import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Inject, Optional, NgModule, assertInInjectionContext, inject, Injector, forwardRef, Directive, Input, HostListener, EventEmitter, Component, ChangeDetectionStrategy, Output, Pipe, HostBinding, ViewEncapsulation, ViewContainerRef, ViewChild, Renderer2, ElementRef, signal, computed, effect, untracked, ContentChildren, DestroyRef, ContentChild, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { TRANSLOCO_LANG, TRANSLOCO_SCOPE, TranslocoModule } from '@ngneat/transloco';
import * as i3 from 'rxjs';
import { BehaviorSubject, of, EMPTY, from, forkJoin, throwError, switchMap as switchMap$1, map as map$1, Subject, Observable, pipe, combineLatest, takeUntil as takeUntil$1, distinctUntilChanged as distinctUntilChanged$1, catchError as catchError$1, filter as filter$1, zip, tap as tap$1, startWith as startWith$1, take as take$1, fromEvent, timer, merge, mergeMap as mergeMap$1, iif, finalize as finalize$1 } from 'rxjs';
import { map, tap, catchError, switchMap, takeUntil, finalize, distinctUntilChanged, take, filter, startWith, mapTo, mergeMap, debounceTime } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpClient, HttpEventType } from '@angular/common/http';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { cloneDeep, isPlainObject, omit, isArray, isEqual, isEqualWith, keyBy, pick, flatten, groupBy, isEmpty, sortBy } from 'lodash-es';
import { isValidDate } from 'rxjs/internal/util/isDate';
import * as i1$4 from '@fundingasiagroup/toolkit-ui';
import { FSWDynamicBuilderControlTypes, FSW_ALERT_SERVICE_TOKEN, FSWTabsModule, FSWIconModule, FSWButtonModule, FSWFieldModule, FSWInputModule, FSW_APPLICATION_SERVICE_TOKEN, FSWApplicationServiceModule, FSWSelectModule, FSWTagsModule, getControlFromGroup, FSWDynamicBuilder, FSWDynamicBuilderFormTypes, FSWDynamicBuilderModule, FSWPanelModule, FSWTranslateModule, FSWAlertModule, fswTranslateScope, FSWDateTimePickerModule, FSWDropdownModule, FSWTooltipModule, FSWModalSizes, FSWModalModule as FSWModalModule$1, FSWCheckboxModule, FSWCheckboxDirections, getDynamicBuilderHiddenControls, FSWTranslatePipe, FSWPaginationModule as FSWPaginationModule$1, FSW_TRANSLATE_SERVICE_TOKEN, followDestroy, autoDestroy, FSWRadioModule, FSWSwitchModule, getDynamicBuilderSetReadonly, getDynamicBuilderReadonly, FSWValueChangesPipeModule, ForceControlPipeModule, FSW_TRANSLATE_SCOPE_TOKEN, FSWDynamicBuilderContainerComponent, ForceGroupPipeModule, FSWTabsSizes, FSWTabsStatuses, NumberRunningModule as NumberRunningModule$1, FSWSwitchComponent, FSWControlBase, getControlFromGroupByGroupPath, FSWAlertHorizontalPositions, FSWAccordionModule } from '@fundingasiagroup/toolkit-ui';
import * as i1$1 from '@angular/common';
import { DatePipe, CommonModule, CurrencyPipe, DOCUMENT, NgIf, NgClass, NgFor, DecimalPipe, NgForOf, AsyncPipe, NgTemplateOutlet, NgSwitch, NgSwitchCase, NgSwitchDefault, TitleCasePipe, JsonPipe } from '@angular/common';
import { toSignal, takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { DataSource } from '@angular/cdk/collections';
import * as i2 from '@angular/forms';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormsModule, ReactiveFormsModule, FormControl, UntypedFormControl, Validators, UntypedFormGroup, UntypedFormArray, FormBuilder, FormGroup, ControlContainer, FormArray } from '@angular/forms';
import { ComponentStore, tapResponse } from '@ngrx/component-store';
import * as i1$2 from '@angular/cdk/clipboard';
import * as i1$3 from '@angular/platform-browser';
import { DomSanitizer } from '@angular/platform-browser';
import { v4 } from 'uuid';
import * as i3$1 from '@ngrx/component';
import { LetDirective } from '@ngrx/component';
import * as i1$5 from 'ag-grid-angular';
import { AgGridModule } from 'ag-grid-angular';
import * as i1$6 from 'ng2-pdf-viewer';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { __decorate, __param, __metadata } from 'tslib';
import * as i6 from '@angular/cdk/menu';
import { CdkMenuTrigger, CdkMenuModule } from '@angular/cdk/menu';
import * as i1$7 from '@angular/cdk/dialog';
import { DialogRef, Dialog, DialogModule, DIALOG_DATA } from '@angular/cdk/dialog';
import * as i7 from '@ng-select/ng-select';
import { NgSelectModule } from '@ng-select/ng-select';
import * as i5 from '@angular/material/table';
import { MatTableModule } from '@angular/material/table';
import * as i6$1 from '@angular/cdk/table';
import { CdkTableModule } from '@angular/cdk/table';
import { sumBy } from 'lodash';
import 'ag-grid-enterprise';
import * as i6$2 from '@ctrl/ngx-codemirror';
import { CodemirrorModule } from '@ctrl/ngx-codemirror';
import { differenceInDays, format } from 'date-fns';
import * as i5$1 from 'ngx-mask';
import { provideNgxMask, NgxMaskDirective } from 'ngx-mask';

const APPLICATION_SERVICE_TOKEN = new InjectionToken('APPLICATION_SERVICE_TOKEN');

const TRANSITION$1 = `{{duration}}ms ease-in-out`;
const DURATION = { params: { duration: 300 } };
const fadeIn = trigger(`fadeIn`, [
    transition(`:enter`, [
        style({ transform: `translateY(-10px)`, opacity: 0 }),
        animate(TRANSITION$1, style({ transform: `translateY(0)`, opacity: 1 })),
    ], DURATION),
    transition(`:leave`, [
        style({ transform: `translateY(0)`, opacity: 1 }),
        animate(TRANSITION$1, style({ transform: `translateY(-10px)`, opacity: 0 })),
    ], DURATION),
]);

const TRANSITION = `{{duration}}ms ease-in-out`;
const slideIn = trigger(`slideIn`, [
    transition(`:enter`, [
        style({ transform: `translate3d(0,{{start}},0)` }),
        animate(TRANSITION, style({ transform: `translate3d(0,{{end}},0)` })),
    ], { params: { end: 0, start: `100%`, duration: 300 } }),
    transition(`:leave`, [
        style({ transform: `translate3d(0,{{end}},0)` }),
        animate(TRANSITION, style({ transform: `translate3d(0,{{start}},0)` })),
    ], { params: { end: 0, start: `100%`, duration: 300 } }),
]);

const UPLOAD_ALLOWED_FILE_TYPES = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'image/png',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/pdf',
    'image/jpeg',
];

const TENOR_TYPES = [1, 7, 14, 30];
const TENOR_TYPE_MAP = {
    days: '1',
    weeks: '7',
    fortnights: '14',
    months: '30',
    years: '360',
    day: '1',
    week: '7',
    fortnight: '14',
    month: '30',
    year: '360',
};

var FSWApplicationExportJobStatuses;
(function (FSWApplicationExportJobStatuses) {
    FSWApplicationExportJobStatuses["IN_PROGRESS"] = "IN_PROGRESS";
    FSWApplicationExportJobStatuses["FAILURE"] = "FAILURE";
    FSWApplicationExportJobStatuses["SUCCESS"] = "SUCCESS";
})(FSWApplicationExportJobStatuses || (FSWApplicationExportJobStatuses = {}));

var ApplicationMemberType;
(function (ApplicationMemberType) {
    ApplicationMemberType["MAIN"] = "MAIN";
    ApplicationMemberType["AFFILIATE"] = "AFFILIATE";
})(ApplicationMemberType || (ApplicationMemberType = {}));

const INIT_STATUS = 'INIT';
// list of bank codes not supported by perfios
const BANK_CODES_NOT_SUPPORTED_BY_PERFIOS = [
    'HSBC',
    'Land and Houses Bank',
    'Mizuho Bank',
    'TD Bank, N.A.',
    'BMO Bank, N.A.',
    'Cathay Bank',
    'JPMorgan Chase Bank',
];

var BankAccountStatusType;
(function (BankAccountStatusType) {
    BankAccountStatusType["PROCESSING"] = "PROCESSING";
    BankAccountStatusType["SUCCESS"] = "SUCCESS";
    BankAccountStatusType["FAILURE"] = "FAILURE";
})(BankAccountStatusType || (BankAccountStatusType = {}));

var FSWCBSRating;
(function (FSWCBSRating) {
    FSWCBSRating["NIL"] = "NIL";
    FSWCBSRating["AA"] = "AA";
    FSWCBSRating["BB"] = "BB";
    FSWCBSRating["CC"] = "CC";
    FSWCBSRating["DD"] = "DD";
    FSWCBSRating["EE"] = "EE";
    FSWCBSRating["FF"] = "FF";
    FSWCBSRating["GG"] = "GG";
    FSWCBSRating["HH"] = "HH";
    FSWCBSRating["HX"] = "HX";
    FSWCBSRating["HZ"] = "HZ";
    FSWCBSRating["GX"] = "GX";
    FSWCBSRating["BX"] = "BX";
    FSWCBSRating["CX"] = "CX";
})(FSWCBSRating || (FSWCBSRating = {}));
const FSWCBSRatingArray = Object.values(FSWCBSRating).map((value) => ({
    value,
    text: value,
}));

var FSWCBSProbabilityOfDefault;
(function (FSWCBSProbabilityOfDefault) {
    FSWCBSProbabilityOfDefault["AA"] = "<=0.27%";
    FSWCBSProbabilityOfDefault["BB"] = "0.27% to 0.67%";
    FSWCBSProbabilityOfDefault["CC"] = "0.67% to 0.88%";
    FSWCBSProbabilityOfDefault["DD"] = "0.88% to 1.03%";
    FSWCBSProbabilityOfDefault["EE"] = "1.03% to 1.58%";
    FSWCBSProbabilityOfDefault["FF"] = "1.58% to 2.28%";
    FSWCBSProbabilityOfDefault["GG"] = "2.28% to 3.48%";
    FSWCBSProbabilityOfDefault["HH"] = ">=3.48%";
    FSWCBSProbabilityOfDefault["HX"] = "N.A";
    FSWCBSProbabilityOfDefault["HZ"] = "N.A";
    FSWCBSProbabilityOfDefault["GX"] = "N.A";
    FSWCBSProbabilityOfDefault["BX"] = "N.A";
    FSWCBSProbabilityOfDefault["CX"] = "N.A";
    FSWCBSProbabilityOfDefault["NIL"] = "N.A";
})(FSWCBSProbabilityOfDefault || (FSWCBSProbabilityOfDefault = {}));

var FSW_DOC_UPLOAD;
(function (FSW_DOC_UPLOAD) {
    FSW_DOC_UPLOAD[FSW_DOC_UPLOAD["MAXIMUM_UPLOAD_SIZE"] = 31457280] = "MAXIMUM_UPLOAD_SIZE";
})(FSW_DOC_UPLOAD || (FSW_DOC_UPLOAD = {}));

var FSWExperianPaymentGrade;
(function (FSWExperianPaymentGrade) {
    FSWExperianPaymentGrade["NA"] = "N.A";
    FSWExperianPaymentGrade["POOR"] = "POOR";
    FSWExperianPaymentGrade["WEAK"] = "WEAK";
    FSWExperianPaymentGrade["MARGINAL"] = "MARGINAL";
    FSWExperianPaymentGrade["FAIR"] = "FAIR";
    FSWExperianPaymentGrade["GOOD"] = "GOOD";
    FSWExperianPaymentGrade["STRONG"] = "STRONG";
})(FSWExperianPaymentGrade || (FSWExperianPaymentGrade = {}));
const FSWExperianPaymentGradeArray = Object.values(FSWExperianPaymentGrade).map((item) => ({
    value: item,
    text: item,
}));

var FSWMaritalStatuses;
(function (FSWMaritalStatuses) {
    FSWMaritalStatuses[FSWMaritalStatuses["SIN"] = 2] = "SIN";
    FSWMaritalStatuses[FSWMaritalStatuses["MRD"] = 5] = "MRD";
    FSWMaritalStatuses[FSWMaritalStatuses["DIV"] = 11] = "DIV";
    FSWMaritalStatuses[FSWMaritalStatuses["WID"] = 8] = "WID";
    FSWMaritalStatuses[FSWMaritalStatuses["WIR"] = 25] = "WIR";
    FSWMaritalStatuses[FSWMaritalStatuses["SEP"] = 27] = "SEP";
})(FSWMaritalStatuses || (FSWMaritalStatuses = {}));

var CurrencyCode;
(function (CurrencyCode) {
    CurrencyCode["SGD"] = "SGD";
    CurrencyCode["MYR"] = "MYR";
    CurrencyCode["IDR"] = "IDR";
    CurrencyCode["VND"] = "VND";
    CurrencyCode["THB"] = "THB";
    CurrencyCode["USD"] = "USD";
})(CurrencyCode || (CurrencyCode = {}));
var CurrencySymbol;
(function (CurrencySymbol) {
    CurrencySymbol["SGD"] = "S$";
    CurrencySymbol["MYR"] = "RM";
    CurrencySymbol["IDR"] = "Rp";
    CurrencySymbol["VND"] = "\u20AB";
    CurrencySymbol["THB"] = "\u0E3F";
    CurrencySymbol["USD"] = "$";
})(CurrencySymbol || (CurrencySymbol = {}));

var CountryCode;
(function (CountryCode) {
    CountryCode["SG"] = "SG";
    CountryCode["MY"] = "MY";
    CountryCode["ID"] = "ID";
    CountryCode["VU"] = "VU";
    CountryCode["VN"] = "VN";
    CountryCode["TH"] = "TH";
    CountryCode["ZI"] = "ZI";
    CountryCode["ZU"] = "ZU";
    CountryCode["ZV"] = "ZV";
})(CountryCode || (CountryCode = {}));
var CountryName;
(function (CountryName) {
    CountryName["SG"] = "Singapore";
    CountryName["MY"] = "Malaysia";
    CountryName["ID"] = "Indonesia";
    CountryName["VU"] = "Vietnam";
    CountryName["TH"] = "Thailand";
})(CountryName || (CountryName = {}));
var CountryPhoneCode;
(function (CountryPhoneCode) {
    CountryPhoneCode["SG"] = "+65";
    CountryPhoneCode["MY"] = "+60";
    CountryPhoneCode["ID"] = "+62";
    CountryPhoneCode["VU"] = "+84";
    CountryPhoneCode["TH"] = "+66";
})(CountryPhoneCode || (CountryPhoneCode = {}));
var CountryTimezone;
(function (CountryTimezone) {
    CountryTimezone["SG"] = "Asia/Singapore";
    CountryTimezone["MY"] = "Asia/Kuala_Lumpur";
    CountryTimezone["ID"] = "Asia/Jakarta";
    CountryTimezone["VU"] = "Asia/Ho_Chi_Minh";
    CountryTimezone["TH"] = "Asia/Bangkok";
})(CountryTimezone || (CountryTimezone = {}));

const COUNTRY_CONFIG = {
    [CountryCode.SG]: {
        countryName: CountryName.SG,
        currencyCode: CurrencyCode.SGD,
        currencySymbol: CurrencySymbol.SGD,
        phone: {
            code: CountryPhoneCode.SG,
        },
        number_format: {
            align: 'left',
            allowNegative: false,
            decimal: '.',
            precision: 2,
            prefix: 'S$',
            suffix: '',
            thousands: ',',
            locale: 'en',
        },
        timezone: CountryTimezone.SG,
    },
    [CountryCode.MY]: {
        countryName: CountryName.MY,
        currencyCode: CurrencyCode.MYR,
        currencySymbol: CurrencySymbol.MYR,
        phone: {
            code: CountryPhoneCode.MY,
        },
        number_format: {
            align: 'left',
            allowNegative: false,
            decimal: '.',
            precision: 2,
            prefix: 'RM',
            suffix: '',
            thousands: ',',
            locale: 'en',
        },
        timezone: CountryTimezone.MY,
        product_upi: 'MY-BMY',
    },
    [CountryCode.ID]: {
        countryName: CountryName.ID,
        currencyCode: CurrencyCode.IDR,
        currencySymbol: CurrencySymbol.IDR,
        phone: {
            code: CountryPhoneCode.ID,
        },
        number_format: {
            align: 'left',
            allowNegative: false,
            decimal: '.',
            precision: 2,
            prefix: 'Rp',
            suffix: '',
            thousands: ',',
            locale: 'id',
        },
        timezone: CountryTimezone.ID,
    },
    [CountryCode.VU]: {
        countryName: CountryName.VU,
        currencyCode: CurrencyCode.USD,
        currencySymbol: CurrencySymbol.USD,
        phone: {
            code: CountryPhoneCode.VU,
        },
        number_format: {
            align: 'left',
            allowNegative: false,
            decimal: '.',
            precision: 2,
            prefix: '$',
            suffix: '',
            thousands: ',',
            locale: 'en',
        },
        timezone: CountryTimezone.VU,
    },
    [CountryCode.VN]: {
        countryName: CountryName.VU,
        currencyCode: CurrencyCode.VND,
        currencySymbol: CurrencySymbol.VND,
        phone: {
            code: CountryPhoneCode.VU,
        },
        number_format: {
            align: 'left',
            allowNegative: false,
            decimal: '.',
            precision: 2,
            prefix: '$',
            suffix: '',
            thousands: ',',
            locale: 'en',
        },
        timezone: CountryTimezone.VU,
    },
    [CountryCode.TH]: {
        countryName: CountryName.TH,
        currencyCode: CurrencyCode.THB,
        currencySymbol: CurrencySymbol.THB,
        phone: {
            code: CountryPhoneCode.TH,
        },
        number_format: {
            align: 'left',
            allowNegative: false,
            decimal: '.',
            precision: 2,
            prefix: '฿',
            suffix: '',
            thousands: ',',
            locale: 'en',
        },
        timezone: CountryTimezone.TH,
        product_upi: 'TH_TF',
    },
    [CountryCode.ZI]: {
        countryName: CountryName.ID,
        currencyCode: CurrencyCode.IDR,
        currencySymbol: CurrencySymbol.IDR,
        phone: {
            code: CountryPhoneCode.ID,
        },
        number_format: {
            align: 'left',
            allowNegative: false,
            decimal: '.',
            precision: 2,
            prefix: 'Rp',
            suffix: '',
            thousands: ',',
            locale: 'id',
        },
        timezone: CountryTimezone.ID,
    },
    [CountryCode.ZU]: {
        countryName: CountryName.ID,
        currencyCode: CurrencyCode.USD,
        currencySymbol: CurrencySymbol.USD,
        phone: {
            code: CountryPhoneCode.ID,
        },
        number_format: {
            align: 'left',
            allowNegative: false,
            decimal: '.',
            precision: 2,
            prefix: '$',
            suffix: '',
            thousands: ',',
            locale: 'id',
        },
        timezone: CountryTimezone.ID,
    },
    [CountryCode.ZV]: {
        countryName: CountryName.VU,
        currencyCode: CurrencyCode.VND,
        currencySymbol: CurrencySymbol.VND,
        phone: {
            code: CountryPhoneCode.VU,
        },
        number_format: {
            align: 'left',
            allowNegative: false,
            decimal: '.',
            precision: 2,
            prefix: '₫',
            suffix: '',
            thousands: ',',
            locale: 'en',
        },
        timezone: CountryTimezone.VU,
    },
};

const getCountryCodeFromStorage = () => localStorage.getItem('countryId');
const getCurrentCountryConfig = () => COUNTRY_CONFIG[getCountryCodeFromStorage()];

var CreditAgingReportTypes;
(function (CreditAgingReportTypes) {
    CreditAgingReportTypes["AP"] = "AP";
    CreditAgingReportTypes["AR"] = "AR";
})(CreditAgingReportTypes || (CreditAgingReportTypes = {}));

var DigitalScorecardFormFields$1;
(function (DigitalScorecardFormFields) {
    DigitalScorecardFormFields["SCORE_CARD_DECISION"] = "score_card_decision";
    DigitalScorecardFormFields["LOAN_GRADE"] = "loan_grade";
    DigitalScorecardFormFields["DEFAULT_PROFITABILITY"] = "default_profitability";
    DigitalScorecardFormFields["EXPECTED_LOSS"] = "expected_loss";
    DigitalScorecardFormFields["LOAN_QUANTUM"] = "loan_quantum";
    DigitalScorecardFormFields["LOAN_TENURE"] = "loan_tenure";
    DigitalScorecardFormFields["LOAN_QUANTUM_WITHOUT_CAPING"] = "credit_quantum_without_cap";
    DigitalScorecardFormFields["MONTHLY_INTEREST_RATE"] = "monthly_interest_rate";
    DigitalScorecardFormFields["REJECTION_REASON"] = "rejection_reason";
    DigitalScorecardFormFields["ERROR_MESSAGE"] = "error_message";
})(DigitalScorecardFormFields$1 || (DigitalScorecardFormFields$1 = {}));

var CreditScreeningResultStageNames;
(function (CreditScreeningResultStageNames) {
    CreditScreeningResultStageNames["BORROWER"] = "borrower";
    CreditScreeningResultStageNames["CTOS"] = "ctos";
    CreditScreeningResultStageNames["BANK"] = "bank";
    CreditScreeningResultStageNames["FINANCE"] = "finance";
})(CreditScreeningResultStageNames || (CreditScreeningResultStageNames = {}));

var FSWCreditPreScreeningStages;
(function (FSWCreditPreScreeningStages) {
    FSWCreditPreScreeningStages["CTOS"] = "CTOS";
    FSWCreditPreScreeningStages["BANK"] = "BANK";
    FSWCreditPreScreeningStages["CBS"] = "CBS";
    FSWCreditPreScreeningStages["MY_DF_CTOS"] = "MY_DF_CTOS";
    FSWCreditPreScreeningStages["BASIC_PRESCREENING"] = "BASIC_PRESCREENING";
    //
    /* Add more stages here for SG Prescreening Details */
    FSWCreditPreScreeningStages["SG_BOLT_SG_MB_BASIC_DETAILS"] = "BASIC";
    FSWCreditPreScreeningStages["SG_BOLT_SG_MB_BRC"] = "BRC";
    FSWCreditPreScreeningStages["SG_BOLT_SG_MB_BRI"] = "BRI";
    FSWCreditPreScreeningStages["SG_BOLT_SG_MB_CBS"] = "SG_CBS";
    FSWCreditPreScreeningStages["SG_BOLT_SG_MB_BANK_STATEMENT"] = "SG_BANK_STATEMENT";
})(FSWCreditPreScreeningStages || (FSWCreditPreScreeningStages = {}));
const STAGES_DATA = {
    'SG-MB': {
        [FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BASIC_DETAILS]: {
            name: 'SG BTL BOLT Pre Screening Basic',
        },
        [FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BRC]: {
            name: 'SG BTL BOLT Pre Screening BRC',
        },
        [FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BRI]: {
            name: 'SG BTL BOLT Pre Screening BRI',
        },
        [FSWCreditPreScreeningStages.SG_BOLT_SG_MB_CBS]: {
            name: 'SG BTL BOLT Pre Screening CBS',
        },
        [FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BANK_STATEMENT]: {
            name: 'SG BTL BOLT Pre Screening Bank Statement',
        },
    },
};

var FSWCreditPreScreeningNames;
(function (FSWCreditPreScreeningNames) {
    FSWCreditPreScreeningNames["CTOS"] = "Pre Screening CTOS Manual Flow";
    FSWCreditPreScreeningNames["CTOS_TOP_UP"] = "Pre Screening CTOS Topup";
    FSWCreditPreScreeningNames["BANK"] = "Pre Screening Bank Statements Manual Flow";
    FSWCreditPreScreeningNames["CBS"] = "Pre Screening CBS Fraud Analysis";
    FSWCreditPreScreeningNames["MY_DF_CTOS"] = "MY DF Renewal Facility Prescreening CTOS";
    FSWCreditPreScreeningNames["BASIC_PRESCREENING"] = "Basic prescreening";
})(FSWCreditPreScreeningNames || (FSWCreditPreScreeningNames = {}));
var FSWCreditPreScreeningAutoNames;
(function (FSWCreditPreScreeningAutoNames) {
    FSWCreditPreScreeningAutoNames["CTOS"] = "Pre Screening CTOS Auto Flow";
    FSWCreditPreScreeningAutoNames["BANK"] = "Pre Screening Bank Statements Auto Flow";
})(FSWCreditPreScreeningAutoNames || (FSWCreditPreScreeningAutoNames = {}));

var FSWCreditPreScreeningIdentifiers;
(function (FSWCreditPreScreeningIdentifiers) {
    FSWCreditPreScreeningIdentifiers["CTOS"] = "pre_screening_ctos_manual_flow";
    FSWCreditPreScreeningIdentifiers["CTOS_TOP_UP"] = "pre_screening_ctos_topup";
    FSWCreditPreScreeningIdentifiers["BANK"] = "pre_screening_bank_statement_manual_flow";
    FSWCreditPreScreeningIdentifiers["CBS"] = "sg-cbs-fraud-analysis";
    FSWCreditPreScreeningIdentifiers["MY_DF_CTOS"] = "my-df-renewal-facility-pre-screening-ctos";
    FSWCreditPreScreeningIdentifiers["BASIC_PRESCREENING"] = "basic_pre_screening";
})(FSWCreditPreScreeningIdentifiers || (FSWCreditPreScreeningIdentifiers = {}));
var FSWCreditPreScreeningAutoIdentifiers;
(function (FSWCreditPreScreeningAutoIdentifiers) {
    FSWCreditPreScreeningAutoIdentifiers["CTOS"] = "pre_screening_ctos_auto_flow";
    FSWCreditPreScreeningAutoIdentifiers["BANK"] = "pre_screening_bank_statement_auto_flow";
})(FSWCreditPreScreeningAutoIdentifiers || (FSWCreditPreScreeningAutoIdentifiers = {}));

var FSWCreditPreScreeningRuleSetIdentifier;
(function (FSWCreditPreScreeningRuleSetIdentifier) {
    FSWCreditPreScreeningRuleSetIdentifier["CTOS"] = "my-bolt-pre-screening-ctos-and-borrower-profile-manual-flow";
    FSWCreditPreScreeningRuleSetIdentifier["CTOS_TOP_UP"] = "my-bolt-pre-screening-ctos-top-up";
    FSWCreditPreScreeningRuleSetIdentifier["BANK"] = "my-bolt-pre-screening-bank-statement-manual-flow";
    FSWCreditPreScreeningRuleSetIdentifier["CBS"] = "sg-cbs-fraud-analysis";
    FSWCreditPreScreeningRuleSetIdentifier["MY_DF_CTOS"] = "my-df-renewal-facility-pre-screening-ctos";
    FSWCreditPreScreeningRuleSetIdentifier["MY_DF_BASIC"] = "my-df-renewal-facility-pre-screening";
})(FSWCreditPreScreeningRuleSetIdentifier || (FSWCreditPreScreeningRuleSetIdentifier = {}));
var FSWCreditPreScreeningAutoRuleSetIdentifier;
(function (FSWCreditPreScreeningAutoRuleSetIdentifier) {
    FSWCreditPreScreeningAutoRuleSetIdentifier["CTOS"] = "my-bolt-pre-screening-ctos-and-borrower-profile-auto-flow";
    FSWCreditPreScreeningAutoRuleSetIdentifier["BANK"] = "my-bolt-pre-screening-bank-statement-auto-flow";
})(FSWCreditPreScreeningAutoRuleSetIdentifier || (FSWCreditPreScreeningAutoRuleSetIdentifier = {}));

var FSWCTOSEntityTypes;
(function (FSWCTOSEntityTypes) {
    FSWCTOSEntityTypes["B"] = "B";
    FSWCTOSEntityTypes["I"] = "I";
    FSWCTOSEntityTypes["C"] = "C";
    FSWCTOSEntityTypes["L"] = "L";
    FSWCTOSEntityTypes["O"] = "O";
})(FSWCTOSEntityTypes || (FSWCTOSEntityTypes = {}));

var FSWCTOSGrade;
(function (FSWCTOSGrade) {
    FSWCTOSGrade["NA"] = "NA";
    FSWCTOSGrade["Poor"] = "Poor";
    FSWCTOSGrade["Low"] = "Low";
    FSWCTOSGrade["Fair"] = "Fair";
    FSWCTOSGrade["Good"] = "Good";
    FSWCTOSGrade["VeryGood"] = "Very Good";
    FSWCTOSGrade["Excellent"] = "Excellent";
    FSWCTOSGrade["LowRisk"] = "Low Risk";
    FSWCTOSGrade["MediumRisk"] = " Medium Risk";
    FSWCTOSGrade["HighRisk"] = "High Risk";
})(FSWCTOSGrade || (FSWCTOSGrade = {}));

const fswCTOSGrades = [
    FSWCTOSGrade.NA,
    FSWCTOSGrade.Poor,
    FSWCTOSGrade.Low,
    FSWCTOSGrade.Fair,
    FSWCTOSGrade.Good,
    FSWCTOSGrade.VeryGood,
    FSWCTOSGrade.Excellent,
    FSWCTOSGrade.LowRisk,
    FSWCTOSGrade.MediumRisk,
    FSWCTOSGrade.HighRisk,
];

function parseCtosEntity(ctosEntity) {
    if (!ctosEntity) {
        return {};
    }
    const ctosEntityData = ctosEntity.split(';');
    const entityType = ctosEntityData[0];
    const entityNo = ctosEntityData[1];
    const entityKey = ctosEntityData[2];
    return { entityType, entityNo, entityKey };
}
function getEntityInfoAuto(member, previousPullID) {
    const { companyCtosEntity, companyName, id, companyRegistrationNumber } = member;
    if (!companyCtosEntity) {
        return {
            entityName: companyName,
            memberID: +id,
            entityNo: companyRegistrationNumber,
            entityType: FSWCTOSEntityTypes.C,
        };
    }
    const ctosEntity = parseCtosEntity(companyCtosEntity);
    const { entityType, entityNo, entityKey } = ctosEntity;
    const entity = {
        entityName: companyName,
        entityType,
        entityKey,
        entityNo,
        memberID: +id,
    };
    if (previousPullID) {
        entity.previousPullID = previousPullID;
    }
    return entity;
}
function getEntityNoFallBackToUEN(ctosEntity, companyRegistrationNumber) {
    const parsedCtosEntity = parseCtosEntity(ctosEntity);
    return parsedCtosEntity.entityNo || companyRegistrationNumber;
}

var FSWCTOSPullStatuses;
(function (FSWCTOSPullStatuses) {
    FSWCTOSPullStatuses["FAILED"] = "FAILED";
    FSWCTOSPullStatuses["SUCCESS"] = "SUCCESS";
    FSWCTOSPullStatuses["IN_PROGRESS"] = "IN-PROGRESS";
})(FSWCTOSPullStatuses || (FSWCTOSPullStatuses = {}));

const YES_NO_OPTIONS = [
    {
        value: true,
        label: 'Yes',
    },
    {
        value: false,
        label: 'No',
    },
];
const MEMBER_ENTITY_TYPE_ID_OPTIONS = [
    {
        value: '1',
        label: 'Individual',
    },
    {
        value: '3',
        label: 'Company',
    },
];
const RECOURSE_TYPE_OPTIONS = [
    {
        value: 'PG',
        label: 'PG',
    },
    {
        value: 'CG',
        label: 'CG',
    },
    {
        value: 'None',
        label: 'None',
    },
];

var MemberCode;
(function (MemberCode) {
    MemberCode["BORROWER"] = "BRW";
    MemberCode["INVESTOR"] = "INV";
    MemberCode["PARTNER"] = "PRT";
    MemberCode["COLLECTOR"] = "COL";
    MemberCode["SURVEYOR"] = "SVY";
    MemberCode["FINANCIAL_ADVISOR"] = "FA";
    MemberCode["ALL"] = "ALL";
})(MemberCode || (MemberCode = {}));
var MemberEntityCode;
(function (MemberEntityCode) {
    MemberEntityCode["ACCREDITED"] = "ACCREDITED";
    MemberEntityCode["CORPORATE"] = "CORPORATE";
    MemberEntityCode["ESCROW"] = "ESCROW";
    MemberEntityCode["INSTITUTION"] = "INSTITUTION";
    MemberEntityCode["RETAIL"] = "RETAIL";
})(MemberEntityCode || (MemberEntityCode = {}));
var MemberTypeId;
(function (MemberTypeId) {
    MemberTypeId["INDIVIDUAL"] = "1";
    MemberTypeId["COMPANY"] = "3";
})(MemberTypeId || (MemberTypeId = {}));

const getCustomProviders = (providersMap, defaultProviders, countryCode) => {
    const providers = countryCode && providersMap[countryCode] ? providersMap[countryCode] : defaultProviders;
    if (providers)
        return providers;
    throw new Error(`Providers not found for country code: ${countryCode}`);
};

var FSWRecourseTypes;
(function (FSWRecourseTypes) {
    FSWRecourseTypes["PG"] = "PG";
    FSWRecourseTypes["CG"] = "CG";
    FSWRecourseTypes["BRW"] = "BRW";
    FSWRecourseTypes["OTHER"] = "OTHER";
})(FSWRecourseTypes || (FSWRecourseTypes = {}));

const INTALLMENT_TYPES = [
    'Daily',
    'Weekly',
    'Fortnightly',
    'Monthly',
    'Two Monthly',
    'Three Monthly',
    'Customized',
    'Bullet',
];

var SalesCalculationKeys;
(function (SalesCalculationKeys) {
    SalesCalculationKeys["SALES"] = "sales";
    SalesCalculationKeys["COGS"] = "cogs";
    SalesCalculationKeys["ARDOH"] = "ardoh";
    SalesCalculationKeys["INVDOH"] = "invdoh";
    SalesCalculationKeys["APDOH"] = "apdoh";
    SalesCalculationKeys["WCR"] = "wcr";
    SalesCalculationKeys["ST_LIMIT"] = "st_limit";
    SalesCalculationKeys["SURPLUS"] = "surplus";
})(SalesCalculationKeys || (SalesCalculationKeys = {}));

var EBALoanDetail;
(function (EBALoanDetail) {
    EBALoanDetail["Leasing"] = "LEASING";
    EBALoanDetail["TermLoan"] = "TERM_LOAN";
    EBALoanDetail["Guarantee"] = "GUARANTEE";
    EBALoanDetail["VehicleLeasing"] = "VEHICLE_LEASING";
    EBALoanDetail["Overdraft"] = "OVERDRAFT";
    EBALoanDetail["CreditCard"] = "CREDIT_CARD";
    EBALoanDetail["OthersLeasing"] = "OTHERS_LEASING";
    EBALoanDetail["PN"] = "PN";
    EBALoanDetail["Factoring"] = "FACTORING";
    EBALoanDetail["TR"] = "TR";
})(EBALoanDetail || (EBALoanDetail = {}));
var EBALoanType;
(function (EBALoanType) {
    EBALoanType["LongTerm"] = "LOAN_TERM";
    EBALoanType["ShortTerm"] = "SHORT_TERM";
    EBALoanType["Guarantee"] = "GUARANTEE";
})(EBALoanType || (EBALoanType = {}));
var EBALoanStatus;
(function (EBALoanStatus) {
    EBALoanStatus["Normal"] = "NORMAL";
    EBALoanStatus["Closed"] = "CLOSED";
})(EBALoanStatus || (EBALoanStatus = {}));

const EBALoanStatuses = [
    {
        value: EBALoanStatus.Normal,
        text: 'Normal',
    },
    {
        value: EBALoanStatus.Closed,
        text: 'Closed',
    },
];
const EBALoanTypes = [
    {
        value: EBALoanType.Guarantee,
        text: 'Guarantee',
    },
    {
        value: EBALoanType.LongTerm,
        text: 'Long Term',
    },
    {
        value: EBALoanType.ShortTerm,
        text: 'Short Term',
    },
];
const EBALoanDetailsLongTerm = [
    {
        value: EBALoanDetail.TermLoan,
        text: 'Term Loan',
    },
    {
        value: EBALoanDetail.Leasing,
        text: 'Leasing',
    },
    {
        value: EBALoanDetail.VehicleLeasing,
        text: 'Vehicle Leasing',
    },
    {
        value: EBALoanDetail.OthersLeasing,
        text: 'Others Leasing',
    },
];
const EBALoanDetailsShortTerm = [
    {
        value: EBALoanDetail.Overdraft,
        text: 'Overdraft',
    },
    {
        value: EBALoanDetail.CreditCard,
        text: 'Credit Card',
    },
    {
        value: EBALoanDetail.PN,
        text: 'PN',
    },
    {
        value: EBALoanDetail.Factoring,
        text: 'Factoring',
    },
    {
        value: EBALoanDetail.TR,
        text: 'TR',
    },
];
const EBALoanDetailsGuarantee = [
    {
        value: EBALoanDetail.Guarantee,
        text: 'Guarantee',
    },
];

class FSWFrankensteinModel {
    static transformIndividualToExpand(data = {}) {
        return {
            id: data.uuid,
            idNumber: data.individualIdentities?.[0]?.identificationNumber,
            addressLine1: data.citizenshipAddress?.line1,
            addressLine2: data.citizenshipAddress?.line2,
            isPrimaryBorrower: false,
            isRecourseParty: true,
            name: data.fullname,
            recourseType: 'PG',
            birth_date: data.birthDate,
            designation: data.relation?.join(', '),
            ownership: (data.shares || []).reduce((acc, cur) => acc + cur.amount, 0).toFixed(2),
        };
    }
    static transformCompanyToExpand(data = {}) {
        return {
            id: data.uuid,
            idNumber: data.companyIdentities?.[0]?.identificationNumber,
            addressLine1: data.address?.line1,
            addressLine2: data.address?.line2,
            isPrimaryBorrower: true,
            isRecourseParty: true,
            name: data.name,
            recourseType: 'CG',
            company_birth_date: data.registrationDate,
            designation: data.relation?.join(', '),
            ownership: (data.shares || []).reduce((acc, cur) => acc + cur.amount, 0).toFixed(2),
        };
    }
    static transformExpand(data) {
        if (data.reference_to === 'COMPANY') {
            return {
                ...data,
                expand: FSWFrankensteinModel.transformCompanyToExpand(data.expand),
            };
        }
        if (data.reference_to === 'INDIVIDUAL') {
            return {
                ...data,
                expand: FSWFrankensteinModel.transformIndividualToExpand(data.expand),
            };
        }
        return data;
    }
}

// standardized select list for MY-DF Renewal
const commonFeePeriodList = [
    {
        value: 'PER_ANNUM',
        text: 'Per Annum',
    },
    {
        value: 'FLAT',
        text: 'Flat',
    },
    {
        value: 'PER_MONTH',
        text: 'Per Month',
    },
];
const lateInterestFeePeriodList = [
    {
        value: '0',
        text: 'One Time',
    },
    {
        value: '1',
        text: 'Daily',
    },
    {
        value: '7',
        text: 'Weekly',
    },
    {
        value: '30',
        text: 'Monthly',
    },
    {
        value: '360',
        text: 'Yearly',
    },
];
const discountingFeePeriodList = [
    {
        value: 'PER_ANNUM',
        text: 'Per Annum',
    },
    {
        value: 'FLAT',
        text: 'Flat',
    },
];
// would be deprecated once all the select list are standardized
const periodTypes = [
    {
        value: 'PER_ANNUM',
        text: 'Annum',
    },
    {
        value: 'FLAT',
        text: 'Flat',
    },
];
const adminPeriodTypes = [
    {
        value: 'PER_ANNUM',
        text: 'Annum',
    },
    {
        value: 'PER_MONTH',
        text: 'Month',
    },
    {
        value: 'FLAT',
        text: 'Flat',
    },
];
const interestTerms = [
    {
        value: 'PER_ANNUM',
        text: 'Annum',
    },
    {
        value: 'PER_MONTH',
        text: 'Month',
    },
    {
        value: 'PER_WEEK',
        text: 'Week',
    },
    {
        value: 'PER_DAY',
        text: 'Day',
    },
];
const termTypes = [
    {
        value: 'day',
        text: 'Day',
    },
    {
        value: 'week',
        text: 'Week',
    },
    {
        value: 'month',
        text: 'Month',
    },
    {
        value: 'year',
        text: 'Year',
    },
];
const tenorTypes = [
    { value: 1, text: 'Day' },
    { value: 7, text: 'Week' },
    { value: 14, text: 'Fortnight' },
    { value: 30, text: 'Month' },
];
const interestTypes = [
    { value: 360, text: 'Per Annum (P.A)' },
    { value: 30, text: 'Per Month (P.M)' },
    { value: 7, text: 'Per Week (P.W)' },
    { value: 1, text: 'Per Day (P.D)' },
    { value: 100, text: 'Per Amount (P.Amt)' },
    { value: 0, text: 'One Time' },
];
const sourceOfFunds = [
    {
        value: 'BALANCE SHEET',
        text: 'Balance Sheet',
    },
    {
        value: 'CF',
        text: 'CF',
    },
];
const installmentTypes = [
    { value: 1, text: 'Daily' },
    { value: 7, text: 'Weekly' },
    { value: 14, text: 'Fortnightly' },
    { value: 30, text: 'Monthly' },
    { value: 60, text: '2-Monthly' },
    { value: 90, text: '3-Monthly' },
    { value: 100, text: 'Bullet' },
    { value: 360, text: 'Yearly' },
];
const latePeriods = [
    {
        value: 'PER_ANNUM',
        text: 'Daily',
    },
    {
        value: 'FLAT',
        text: 'Flat',
    },
];
const collaterals = [
    { value: 'Property', label: 'Property' },
    { value: 'Others', label: 'Others' },
    { value: 'Landed Residential', label: 'Landed Residential' },
    {
        value: 'Non landed Residential',
        label: 'Non landed Residential',
    },
    { value: 'Landed Commercial', label: "'Landed Commercial" },
    {
        value: 'Non Landed Commercial',
        label: 'Non Landed Commercial',
    },
    { value: 'Factory/Industrial', label: 'Factory/Industrial' },
    { value: 'Receivables', label: 'Receivables' },
    { value: 'Others', label: 'Others' },
    { value: 'Not Applicable', label: 'Not Applicable' },
];
const tradeRefereeCategories = [
    { value: 'utility_telco', text: 'Utility & Telco Company' },
    { value: 'credit_leasing', text: 'FI, Credit & Leasing Companies, Money Lender' },
    { value: 'other', text: 'Others' },
];
const controls = [
    {
        value: '1st Party First Charge',
        label: '1st Party First Charge',
    },
    {
        value: '3rd Party First Charge',
        label: '3rd Party First Charge',
    },
    {
        value: '1st Party Second Charge',
        label: '1st Party Second Charge',
    },
    {
        value: '3rd Party Second Charge',
        label: '3rd Party Second Charge',
    },
    {
        value: 'Control Account - Notified',
        label: 'Control Account - Notified',
    },
    {
        value: 'Control Account - Confidential',
        label: 'Control Account - Confidential',
    },
    {
        value: 'Cross Collateral',
        label: 'Cross Collateral',
    },
    {
        value: 'Not Available',
        label: 'Not Available',
    },
];
const paymentBehaviors = {
    // [CountryCode.SG]: ['A', 'N', 'B', 'C', 'X'].map((item) => ({ value: item, text: item })),
    [CountryCode.SG]: [
        { value: 'A', text: 'Majority paid within term' },
        { value: 'N', text: 'Majority payment received within current the month' },
        { value: 'B', text: 'Majority paid after terms' },
        { value: 'C', text: 'Majority No payment' },
        { value: 'X', text: 'No Information' },
    ],
    [CountryCode.MY]: ['Good', 'Prompt', 'Satisfactory', 'Adverse', 'N/A'].map((item) => ({
        value: item,
        text: item,
    })),
};
const paymentGrades = [
    'NA',
    'Poor',
    'Low',
    'Fair',
    'Good',
    'Very Good',
    'Excellent',
    'Low Risk',
    'Medium Risk',
    'High Risk',
].map((item) => ({ value: item, text: item }));
function selectListToBeString(selectList) {
    return selectList.map((m) => ({ text: m.text.toString(), value: m.value.toString() }));
}
function selectListToBeRecord(selectList) {
    return selectList.reduce((acc, cur) => {
        return {
            ...acc,
            [`${cur.value}`]: cur.text.toString(),
        };
    }, {});
}
function getTextFromSelectList(selectList, value, suffix = '') {
    const item = selectList.find((m) => m.value == value);
    return `${item?.text.toString() ?? ''}${suffix}`;
}

function modelTransformer(data, transformers) {
    if (!data || typeof data !== 'object' || !transformers.length) {
        return data;
    }
    const cloneData = cloneDeep(data);
    transformers.forEach(({ keys, cb }) => keys.forEach((key) => {
        cloneData[key] = cb(cloneData[key]);
    }));
    return cloneData;
}

const INTEREST_TYPES = [360, 30, 7, 1, 100];

function showBlankHTML(html) {
    const blob = new Blob([html], { type: 'text/html' });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.target = '_blank';
    anchor.click();
    anchor.remove();
}

function removeBadFalsyValueForObject(data, options) {
    const badFalsyValues = ['undefined', 'null', NaN, 'NaN'].concat(options?.notCatchingEmptyString ? [] : ['']);
    return Object.keys(data).reduce((acc, key) => {
        const indexingValue = data[key];
        if (Array.isArray(indexingValue)) {
            return {
                ...acc,
                [key]: removeBadFalsyValueForArray(indexingValue),
            };
        }
        if (isPlainObject(indexingValue)) {
            return {
                ...acc,
                [key]: removeBadFalsyValueForObject(indexingValue, options),
            };
        }
        if (!badFalsyValues.includes(indexingValue)) {
            acc[key] = indexingValue;
        }
        else {
            options?.replaceWithNull && (acc[key] = null);
        }
        return acc;
    }, {});
}
function removeBadFalsyValueForArray(data, options) {
    return data.map((item) => removeBadFalsyValueForObject(item, options));
}

function getTimezoneHourOffset(date = new Date()) {
    const offsetInMinutes = date.getTimezoneOffset();
    return -offsetInMinutes / 60;
}
function toTimezoneHourOffset(value, direction = 'up') {
    if (value == null) {
        return null;
    }
    try {
        const date = new Date(value);
        if (!isValidDate(date)) {
            return null;
        }
        const hours = (direction === 'up' ? 1 : -1) * getTimezoneHourOffset(date);
        date.setTime(date.getTime() + hours * 60 * 60 * 1000);
        return date;
    }
    catch {
        return null;
    }
}

const dynamicForm = {
    select: (key, context = {}, { element, control } = {}) => ({
        key,
        type: FSWDynamicBuilderControlTypes.SELECT,
        ...element,
        ...control,
        context: {
            fullWidth: true,
            maxHeight: '400px',
            ...context,
            ...control?.context,
        },
    }),
    text: (key, context = {}, { element, control } = {}) => ({
        key,
        type: FSWDynamicBuilderControlTypes.INPUT,
        ...element,
        ...control,
        context: {
            fullWidth: true,
            readonlyTemplate: (value) => value ?? 'N/A',
            ...context,
            ...control?.context,
        },
    }),
    checkbox: (key, context = {}, { element, control } = {}) => ({
        key,
        type: FSWDynamicBuilderControlTypes.CHECKBOX,
        ...element,
        ...control,
        context: {
            readonlyTemplate: (value) => (value ? 'Yes' : 'No'),
            ...context,
            ...control?.context,
        },
    }),
    switch: (key, context = {}, { element, control } = {}) => ({
        key,
        type: FSWDynamicBuilderControlTypes.SWITCH,
        ...element,
        ...control,
        context: {
            readonlyTemplate: (value) => (value ? 'Yes' : 'No'),
            ...context,
            ...control?.context,
        },
    }),
    checkboxGroup: (key, context = {}, { element, control } = {}) => ({
        key,
        type: FSWDynamicBuilderControlTypes.CHECKBOX_GROUP,
        ...element,
        ...control,
        context: {
            ...context,
            ...control?.context,
        },
    }),
    radioGroup: (key, context = {}, { element, control } = {}) => ({
        key,
        type: FSWDynamicBuilderControlTypes.RADIO_GROUP,
        ...element,
        ...control,
        context: {
            ...context,
            ...control?.context,
        },
    }),
    number: (key, context = {}, { element, control } = {}) => ({
        key,
        type: FSWDynamicBuilderControlTypes.INPUT,
        ...element,
        ...control,
        context: {
            inputType: 'number',
            fullWidth: true,
            readonlyTemplate: (value) => value ?? 'N/A',
            ...context,
            ...control?.context,
        },
    }),
    date: (key, context = {}, { element, control } = {}) => ({
        key,
        type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
        ...element,
        ...control,
        context: {
            fullWidth: true,
            closeOnSelected: true,
            placeHolder: 'DD/MM/YYYY',
            readonlyTemplate: (value) => value ? new DatePipe('en-US').transform(value, 'dd/MM/yyyy') || '--' : '--',
            ...context,
            ...control?.context,
        },
    }),
    template: (key, context = {}, { element, control } = {}) => ({
        key,
        type: FSWDynamicBuilderControlTypes.TEMPLATE,
        ...element,
        ...control,
        context: {
            ...context,
            ...control?.context,
        },
    }),
    maskNumber: (key, context = {}, { element, control } = {}) => ({
        key,
        type: FSWDynamicBuilderControlTypes.INPUT,
        ...element,
        ...control,
        context: {
            mask: {
                expression: 'separator.0',
                config: {
                    thousandSeparator: '',
                },
            },
            fullWidth: true,
            readonlyTemplate: (value) => value ?? 'N/A',
            ...context,
            ...control?.context,
        },
    }),
    maskInt: (key, context = {}, { element, control } = {}) => ({
        key,
        type: FSWDynamicBuilderControlTypes.INPUT,
        ...element,
        ...control,
        context: {
            mask: {
                expression: 'separator.0',
                config: {
                    thousandSeparator: ',',
                },
            },
            fullWidth: true,
            readonlyTemplate: (value) => value ?? 'N/A',
            ...context,
            ...control?.context,
        },
    }),
    maskFloat: (key, context = {}, { element, control } = {}) => ({
        key,
        type: FSWDynamicBuilderControlTypes.INPUT,
        ...element,
        ...control,
        context: {
            mask: {
                expression: 'separator.2',
                config: {
                    thousandSeparator: ',',
                },
            },
            fullWidth: true,
            readonlyTemplate: (value) => value ?? 'N/A',
            ...context,
            ...control?.context,
        },
    }),
};

var FSWCountryCode;
(function (FSWCountryCode) {
    FSWCountryCode["EMPTY"] = "";
    FSWCountryCode["SG"] = "SG";
    FSWCountryCode["MY"] = "MY";
    FSWCountryCode["ID"] = "ID";
    FSWCountryCode["ZI"] = "ZI";
    FSWCountryCode["VU"] = "VU";
    FSWCountryCode["TH"] = "TH";
})(FSWCountryCode || (FSWCountryCode = {}));

var Methods;
(function (Methods) {
    Methods["POST"] = "post";
    Methods["PUT"] = "put";
    Methods["DELETE"] = "delete";
    Methods["GET"] = "get";
})(Methods || (Methods = {}));

var FSWFlow;
(function (FSWFlow) {
    FSWFlow["INSTANT"] = "INSTANT";
    FSWFlow["MANUAL"] = "MANUAL";
    FSWFlow["INSTANT_MANUAL"] = "INSTANT_MANUAL";
})(FSWFlow || (FSWFlow = {}));

var FSWEntityTypes;
(function (FSWEntityTypes) {
    FSWEntityTypes["LOAN"] = "loan";
    FSWEntityTypes["APPLICATION"] = "application";
})(FSWEntityTypes || (FSWEntityTypes = {}));

var CreditBureauTypes;
(function (CreditBureauTypes) {
    CreditBureauTypes["CTOS"] = "CTOS";
    CreditBureauTypes["QUESTNET"] = "QUESTNET";
    CreditBureauTypes["PEFINDO"] = "PEFINDO";
})(CreditBureauTypes || (CreditBureauTypes = {}));

var FSWProductCodes;
(function (FSWProductCodes) {
    FSWProductCodes["BRC"] = "BRC";
    FSWProductCodes["BRIG"] = "BRIG";
})(FSWProductCodes || (FSWProductCodes = {}));

const WIDGETS_CONFIG_TOKEN = new InjectionToken('WIDGETS_CONFIG_TOKEN');

/**
 * Validates UEN of businesses in Singapore
 * https://www.uen.gov.sg/ueninternet/faces/pages/admin/aboutUEN.jspx
 */
function isSGUEN(uen) {
    const isUENBusinessRegisteredWithACRA = () => {
        // 8 numbers and 1 uppercase alpahbet
        // Match to '12345678A'
        return RegExp('^[0-9]{8}[A-Z]$').test(uen);
    };
    const isUENLocalCompanyRegisteredWithACRA = () => {
        // 9 numbers and 1 uppercase alpahbet
        // Match to '123456789A'
        return RegExp('^[0-9]{9}[A-Z]$').test(uen);
    };
    const isUENNewEntity = () => {
        const centuryIndicator = ['T', 'S', 'R'];
        // prettier-ignore
        const entityTypeIndicator = [
            'LP', 'LL', 'FC', 'PF', 'RF', 'MQ', 'MM', 'NB', 'CC', 'CS', 'MB', 'FM', 'GS', 'GA',
            'GB', 'DP', 'CP', 'NR', 'CM', 'CD', 'MD', 'HS', 'VH', 'CH', 'MH', 'CL', 'XL', 'CX',
            'RP', 'TU', 'TC', 'FB', 'FN', 'PA', 'PB', 'SS', 'MC', 'SM'
        ];
        // Either T, S, R
        // 2 numbers
        // Static entity type indicators (2 uppercase alphabets)
        // 4 numbers
        // 1 uppercase alphabet
        // Match to 'T12LP1234A'
        return RegExp(`^[${centuryIndicator.join()}][0-9]{2}(?:${entityTypeIndicator.join('|')})[0-9]{4}[A-Z]$`).test(uen);
    };
    return (isUENBusinessRegisteredWithACRA() || isUENLocalCompanyRegisteredWithACRA() || isUENNewEntity());
}
function isSGIC(ic) {
    const typeIndicator = ['S', 'T', 'F', 'G'];
    // Either S, T, F, G
    // 7 numbers
    // 1 uppercase alphabet
    // Match to 'S1234567A'
    return RegExp(`^[${typeIndicator.join()}][0-9]{7}[A-Z]$`).test(ic);
}

function setRequestOptions(allowJson = true) {
    let httpHeaders = new HttpHeaders();
    allowJson && (httpHeaders = httpHeaders.append('Accept', 'application/json'));
    allowJson && (httpHeaders = httpHeaders.append('Content-Type', 'application/json'));
    httpHeaders = httpHeaders.append('username', `${localStorage.getItem('username')}`);
    httpHeaders = httpHeaders.append('Authorization', `Bearer ${localStorage.getItem('oauthToken')}`);
    return httpHeaders;
}
function setRequestOptionsMock(allowJson = true) {
    let httpHeaders = new HttpHeaders();
    httpHeaders = httpHeaders.append('Accept', 'application/json');
    allowJson && (httpHeaders = httpHeaders.append('Content-Type', 'application/json'));
    httpHeaders = httpHeaders.append('username', `${localStorage.getItem('username')}`);
    httpHeaders = httpHeaders.append('Authorization', `Bearer ${localStorage.getItem('oauthToken')}`);
    httpHeaders = httpHeaders.append('is-mock', 'true');
    // httpHeaders = httpHeaders.append('mock-run-id', '1150f534-2304-4df3-bd22-7c1d20a205bc');
    return httpHeaders;
}
function buildFieldOptions(list, valueProperty = 'value', labelProperty = 'label') {
    return list.map((item) => {
        if (typeof item === 'object') {
            return {
                value: item[valueProperty],
                label: item[labelProperty],
            };
        }
        return {
            value: item,
            label: item,
        };
    });
}
function isObjectValid(obj) {
    if (obj === null ||
        obj === undefined ||
        (typeof obj === 'string' && obj === 'null') ||
        (typeof obj === 'string' && obj === 'undefined') ||
        JSON.stringify(obj) === '{}')
        return false;
    return true;
}
function isStringValid(str) {
    if (str === null || str === undefined || str === 'null' || str === 'undefined')
        return false;
    if (typeof str === 'string' && str.trim().length === 0)
        return false;
    return true;
}
function downloadFileToLocal(src, fileName) {
    const downloadLink = document.createElement('a');
    downloadLink.href = src;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
}
function addDotDelimiter(num) {
    const str = num.toString().split('.');
    if (str[0].length >= 4) {
        str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1.');
    }
    if (str[1] && str[1].length >= 4) {
        str[1] = str[1].replace(/(\d{3})/g, '$1 ');
    }
    return str.join('.');
}
const getNoRowsTemplate = (noRowDataStr) => `
	<div>
		<div>
				<svg width="92" height="93" viewBox="0 0 92 93" fill="none" xmlns="http://www.w3.org/2000/svg">
				<rect width="92" height="92.514" fill="white" />
				<path
					d="M67.7222 33.4082C67.7222 32.9351 68.1036 32.5516 68.574 32.5516H71.9814C72.4519 32.5516 72.8333 32.9351 72.8333 33.4082C72.8333 33.8813 72.4519 34.2648 71.9814 34.2648H68.574C68.1036 34.2648 67.7222 33.8813 67.7222 33.4082Z"
					fill="#F1F1F2"
				/>
				<path
					d="M70.2778 30.8384C70.7483 30.8384 71.1297 31.2219 71.1297 31.695V35.1214C71.1297 35.5945 70.7483 35.978 70.2778 35.978C69.8074 35.978 69.426 35.5945 69.426 35.1214V31.695C69.426 31.2219 69.8074 30.8384 70.2778 30.8384Z"
					fill="#F1F1F2"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M51.963 29.1203C51.963 28.6498 51.5816 28.2684 51.1111 28.2684C50.6406 28.2684 50.2592 28.6498 50.2592 29.1203V29.9814H49.412C48.9389 29.9814 48.5554 30.3649 48.5554 30.838C48.5554 31.3111 48.9389 31.6946 49.412 31.6946H50.2592V32.5562C50.2592 33.0267 50.6406 33.4081 51.1111 33.4081C51.5816 33.4081 51.963 33.0267 51.963 32.5562V31.6946H52.8099C53.283 31.6946 53.6665 31.3111 53.6665 30.838C53.6665 30.3649 53.283 29.9814 52.8099 29.9814H51.963V29.1203Z"
					fill="#F1F1F2"
				/>
				<path
					d="M40.8888 10.2796C40.8888 9.56997 41.4609 8.99469 42.1666 8.99469H47.2777C47.9834 8.99469 48.5555 9.56997 48.5555 10.2796C48.5555 10.9892 47.9834 11.5645 47.2777 11.5645H42.1666C41.4609 11.5645 40.8888 10.9892 40.8888 10.2796Z"
					fill="#F1F1F2"
				/>
				<path
					d="M44.7221 6.42486C45.4278 6.42486 45.9999 7.00013 45.9999 7.70977V12.8494C45.9999 13.5591 45.4278 14.1344 44.7221 14.1344C44.0164 14.1344 43.4443 13.5591 43.4443 12.8494V7.70977C43.4443 7.00013 44.0164 6.42486 44.7221 6.42486Z"
					fill="#F1F1F2"
				/>
				<path
					d="M21.7222 80.9501C21.7222 80.2404 22.2942 79.6652 22.9999 79.6652H28.1111C28.8168 79.6652 29.3888 80.2404 29.3888 80.9501C29.3888 81.6597 28.8168 82.235 28.1111 82.235H22.9999C22.2942 82.235 21.7222 81.6597 21.7222 80.9501Z"
					fill="#F1F1F2"
				/>
				<path
					d="M25.5555 77.0953C26.2612 77.0953 26.8333 77.6706 26.8333 78.3803V83.5199C26.8333 84.2296 26.2612 84.8048 25.5555 84.8048C24.8498 84.8048 24.2777 84.2296 24.2777 83.5199V78.3803C24.2777 77.6706 24.8498 77.0953 25.5555 77.0953Z"
					fill="#F1F1F2"
				/>
				<path
					d="M71.5554 64.246C71.5554 63.7729 71.9368 63.3894 72.4073 63.3894H75.8147C76.2851 63.3894 76.6665 63.7729 76.6665 64.246C76.6665 64.7191 76.2851 65.1026 75.8147 65.1026H72.4073C71.9368 65.1026 71.5554 64.7191 71.5554 64.246Z"
					fill="#F1F1F2"
				/>
				<path
					d="M74.1111 61.6762C74.5815 61.6762 74.9629 62.0597 74.9629 62.5328V65.9592C74.9629 66.4323 74.5815 66.8158 74.1111 66.8158C73.6406 66.8158 73.2592 66.4323 73.2592 65.9592V62.5328C73.2592 62.0597 73.6406 61.6762 74.1111 61.6762Z"
					fill="#F1F1F2"
				/>
				<path
					d="M15.3333 19.274C15.3333 18.8009 15.7146 18.4174 16.1851 18.4174H19.5925C20.063 18.4174 20.4444 18.8009 20.4444 19.274C20.4444 19.7471 20.063 20.1306 19.5925 20.1306H16.1851C15.7146 20.1306 15.3333 19.7471 15.3333 19.274Z"
					fill="#F1F1F2"
				/>
				<path
					d="M17.8889 16.7042C18.3594 16.7042 18.7408 17.0877 18.7408 17.5608V20.9872C18.7408 21.4603 18.3594 21.8438 17.8889 21.8438C17.4184 21.8438 17.0371 21.4603 17.0371 20.9872V17.5608C17.0371 17.0877 17.4184 16.7042 17.8889 16.7042Z"
					fill="#F1F1F2"
				/>
				<path
					d="M33.2222 78.3802C33.2222 77.9071 33.6036 77.5236 34.074 77.5236H37.4814C37.9519 77.5236 38.3333 77.9071 38.3333 78.3802C38.3333 78.8533 37.9519 79.2368 37.4814 79.2368H34.074C33.6036 79.2368 33.2222 78.8533 33.2222 78.3802Z"
					fill="#F1F1F2"
				/>
				<path
					d="M35.7778 75.8104C36.2483 75.8104 36.6297 76.1939 36.6297 76.667V80.0934C36.6297 80.5665 36.2483 80.95 35.7778 80.95C35.3074 80.95 34.926 80.5665 34.926 80.0934V76.667C34.926 76.1939 35.3074 75.8104 35.7778 75.8104Z"
					fill="#F1F1F2"
				/>
				<path
					d="M61.3333 23.1285V74.5252H30.6667C26.4325 74.5252 23 71.0735 23 66.8157V23.1285L61.3333 23.1285Z"
					fill="#F1F1F2"
				/>
				<rect x="30.6667" y="30.1957" width="23" height="0.642458" fill="#E0E0E0" />
				<rect x="30.6667" y="35.3354" width="23" height="0.642458" fill="#E0E0E0" />
				<rect x="30.6667" y="40.4748" width="23" height="0.642458" fill="#E0E0E0" />
				<rect x="30.6667" y="45.6147" width="23" height="0.642458" fill="#E0E0E0" />
				<rect x="30.6667" y="50.754" width="23" height="0.642458" fill="#E0E0E0" />
				<rect x="30.6667" y="55.8939" width="23" height="0.642458" fill="#E0E0E0" />
				<rect x="30.6667" y="61.0333" width="23" height="0.642458" fill="#E0E0E0" />
				<path
					d="M69.0001 68.1449V66.8157H34.5001V68.1006C34.5001 71.2296 32.2756 73.8362 29.3301 74.4084C29.7642 74.4851 30.2108 74.5252 30.6668 74.5252H62.6553C66.1594 74.5252 69.0001 71.6686 69.0001 68.1449Z"
					fill="#CCCCCC"
				/>
			</svg>
		</div>
		<div style="color: #757575; padding-top: 10px;">${noRowDataStr}</div>
	</div>
`;
function getOptionLabel(value, options) {
    const selectedOption = options.find((o) => o.value === value);
    return selectedOption ? selectedOption.label : '';
}
function calculateTotalPrincipalAmount(list) {
    return list.reduce((total, plan) => {
        const principalAmount = plan.get('principal_amount')?.value || 0;
        return total + (principalAmount ? parseFloat(principalAmount) : 0);
    }, 0);
}
function sliceDate(value) {
    const date = typeof value !== 'string' ? value : new Date(value);
    const timezoneOffset = date.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
    const adjustedDate = new Date(date.getTime() - timezoneOffset);
    return adjustedDate.toISOString().slice(0, 10);
}
function convertToYearMonth(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = `${(date.getMonth() + 1).toString().padStart(2, '0')}`;
    return `${year}-${month}`;
}
function isValidJSON(jsonStr) {
    try {
        JSON.parse(jsonStr);
        return true;
    }
    catch (error) {
        return false;
    }
}
const lastTenYearsOptions = () => {
    const arrayOfYear = [];
    const currentYear = new Date().getFullYear();
    const pastYear = currentYear - 10;
    for (let i = currentYear; i > pastYear; i--) {
        arrayOfYear.push(i);
    }
    return arrayOfYear;
};
const lastTenYearsSelectOptions = () => lastTenYearsOptions().map((year) => ({
    text: year.toString(),
    value: year,
}));
const getNextMonths = (inputMonths) => {
    if (!inputMonths?.length)
        return [];
    const dateObjects = inputMonths.map((monthStr) => new Date(monthStr + '-01'));
    // Calculate the next months, max upto 5 months
    const nextMonths = [];
    for (let i = 0; i < 6 - inputMonths.length; i++) {
        const nextMonth = new Date(dateObjects[dateObjects.length - 1]);
        nextMonth.setMonth(nextMonth.getMonth() + i + 1);
        nextMonths.push(nextMonth.toLocaleString('default', { month: 'short' }) + '-' + nextMonth.getFullYear());
    }
    return nextMonths;
};
const getLoanData = (resObj, productGroups) => {
    // check recommendation, then propose, then default
    return {
        tenor: (resObj?.data?.recommendation?.tenor && String(resObj.data.recommendation.tenor)) ||
            resObj?.data?.propose?.tenor ||
            (productGroups?.length && productGroups[0]?.settings?.defaults?.loan_draft?.tenor) ||
            '',
        tenor_type: TENOR_TYPE_MAP[resObj?.data?.recommendation?.type] ||
            resObj?.data?.propose?.tenor_type ||
            (productGroups?.length && productGroups[0]?.settings?.defaults?.loan_draft?.tenor_type) ||
            '',
        interest_rate: (resObj?.data?.recommendation?.interest_rate &&
            String(resObj.data.recommendation.interest_rate) !== '0' &&
            String(resObj.data.recommendation.interest_rate)) ||
            (resObj?.data?.propose?.interest_rate &&
                String(resObj.data.propose.interest_rate) !== '0' &&
                String(resObj.data.propose.interest_rate)) ||
            (productGroups.length && productGroups[0]?.settings?.defaults?.loan_draft?.interest_rate) ||
            '',
        interest_type: (resObj?.data?.recommendation?.interest_type &&
            String(resObj.data.recommendation.interest_type) !== '0' &&
            String(resObj.data.recommendation.interest_type)) ||
            (resObj?.data?.propose?.interest_type &&
                String(resObj.data.propose.interest_type) !== '0' &&
                String(resObj.data.propose.interest_type)) ||
            (productGroups.length && productGroups[0]?.settings?.defaults?.loan_draft?.interest_type) ||
            '',
        // default not applicable for loan_amount
        loan_amount: (resObj?.data?.recommendation?.loan_amount &&
            String(resObj.data.recommendation.loan_amount) !== '0' &&
            String(resObj.data.recommendation.loan_amount)) ||
            resObj?.data?.propose?.loan_amount?.toString() ||
            '',
    };
};
const getScoringResult = (state, resObj) => {
    return {
        scorecard_grade: state.scorecardContent?.score?.grade || '',
        amount: +resObj?.data?.recommendation?.loan_amount || resObj?.data?.propose?.loan_amount || 0,
        disbursement_amount: +resObj?.data?.recommendation?.disbursement_amount ||
            resObj?.data?.propose?.disbursement_amount ||
            0,
        origination_fee: +resObj?.data?.recommendation?.origination_fee || resObj?.data?.propose?.origination_fee || 0,
        interest_rate_str: state.scorecardContent?.score?.interest?.toString(),
        tenor_length: +resObj?.data?.recommendation?.tenor || +resObj?.data?.propose?.tenor || 0,
        tenor_type: Number(resObj?.data?.recommendation?.tenor_type) || resObj?.data?.propose?.tenor_type || 1,
        interest_rate: +resObj?.data?.recommendation?.interest_rate || resObj?.data?.propose?.interest_rate || 0,
        interest_type: +resObj?.data?.recommendation?.interest_type || resObj?.data?.propose?.interest_type,
    };
};
const convertToReadableDate = (date) => {
    const inputDate = new Date(date);
    const year = inputDate.getFullYear();
    const month = String(inputDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so add 1
    const day = String(inputDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
const getProductCodeFromIdNumber = (idNumber) => {
    if (isSGUEN(idNumber)) {
        return FSWProductCodes.BRC;
    }
    return FSWProductCodes.BRIG;
};
const isNumericSearch = (search) => {
    if (!search)
        return false;
    return /^\d+$/.test(search.trim());
};
const formatBankRecord = (record) => {
    if (!record)
        return '';
    const parts = [record.account_number, record.currency, record.parser];
    const baseText = parts.filter(Boolean).join(' - ');
    return record?.primary ? `${baseText} - Primary` : baseText;
};
const sortBankAccounts = (accounts) => {
    if (!accounts || !accounts.length)
        return [];
    return [...accounts].sort((a, b) => {
        // First sort by primary status (primary accounts first)
        if (a.primary && !b.primary)
            return -1;
        if (!a.primary && b.primary)
            return 1;
        // Secondary sort by account number if both have same primary status
        return (a.account_number || '').localeCompare(b.account_number || '');
    });
};

function calculateTotalAmount(amount, rate, rateType, tenor, tenorType) {
    if (rateType === 100) {
        return amount + (amount * rate) / 100;
    }
    const tenorInDays = tenor * tenorType;
    return Number((amount + (amount * (tenorInDays / rateType) * rate) / 100).toFixed(2));
}
function calculateTenorInMonth(tenor, tenorType) {
    tenor = Number(tenor);
    tenorType = Number(tenorType);
    switch (tenorType) {
        case 1:
            return Math.round(tenor / 30);
        case 7:
            return Math.round(tenor / 4);
        case 14:
            return Math.round(tenor / 2);
        case 30:
            return tenor;
        default:
            return null;
    }
}
function calculateEffectiveInterestRate(eir, tenor, tenorType) {
    const tenorInMonth = calculateTenorInMonth(tenor, tenorType);
    return Math.round(tenorInMonth * eir * 100) / 100;
}
function calculateSimpleInterestRate(interestRate, interestType) {
    interestType = Number(interestType);
    switch (interestType) {
        case 360:
            return interestRate;
        case 30:
            return (interestRate * 360) / 30;
        case 7:
            return (interestRate * 360) / 7;
        case 1:
            return interestRate * 360;
        case 100:
            return (interestRate * 360) / 100;
        default:
            return null;
    }
}

function toRxSignal(generator, injector, initialValue) {
    return toSignal(generator(new BehaviorSubject(initialValue || null)), {
        injector,
        initialValue,
    });
}

function toSignalValue(source) {
    return source();
}

function validApplicationId(control) {
    // Replace this regex with the actual pattern of your application IDs
    const validIdPattern = /^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89aAbB][a-f0-9]{3}-[a-f0-9]{12}$/;
    if (!control.value || !validIdPattern.test(control.value)) {
        return { invalidApplicationId: true };
    }
    return null;
}

const UTILS_SERVICE_TOKEN = new InjectionToken('UTILS_SERVICE_TOKEN');

class UtilsService {
    constructor(_widgetsConfig) {
        this._widgetsConfig = _widgetsConfig;
    }
    getKongUrl() {
        if (isObjectValid(this._widgetsConfig))
            return this._widgetsConfig.baseUrls.kongUrl;
        return null;
    }
    isEnvProduction() {
        return this._widgetsConfig?.isProd || false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UtilsService, deps: [{ token: WIDGETS_CONFIG_TOKEN, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UtilsService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UtilsService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [WIDGETS_CONFIG_TOKEN]
                }, {
                    type: Optional
                }] }]; } });

function provideUtilsService() {
    return {
        provide: UTILS_SERVICE_TOKEN,
        useClass: UtilsService,
    };
}

class UtilsServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UtilsServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: UtilsServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UtilsServiceModule, providers: [provideUtilsService()] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UtilsServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [provideUtilsService()],
                }]
        }] });

function injectUtilsService(injector) {
    !injector && assertInInjectionContext(injectUtilsService);
    const assertedInjector = injector ?? inject(Injector);
    return assertedInjector.get(UTILS_SERVICE_TOKEN);
}

class ApplicationService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._cache = {};
        this._cacheOther = {
            dsModel: null,
            ratioAnalysisId: null,
            decisions: [],
        };
        this._appSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/applications`;
        this._appIntSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/int/applications`;
    }
    getApplication(applicationId) {
        if (this._cache[applicationId]) {
            return of(this._cache[applicationId]);
        }
        const url = `${this._appSvcUrl}/${applicationId}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => {
            this._cache[applicationId] = data;
            return data;
        }));
    }
    getApplicationExportJobs(applicationId) {
        const url = `${this._appSvcUrl}/${applicationId}/export_jobs`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.export_application_jobs || []));
    }
    exportApplicationJobs(application_exports) {
        const url = `${this._appSvcUrl}/export`;
        return this._httpClient
            .post(url, { application_exports }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.export_application_jobs || []));
    }
    getOfferData(applicationId) {
        const url = `${this._appSvcUrl}/${applicationId}/ext/offer`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    updateOfferData(applicationId, payload) {
        const url = `${this._appSvcUrl}/${applicationId}/ext/offer`;
        return this._httpClient
            .patch(url, payload, {
            headers: setRequestOptions(),
        })
            .pipe(tap(() => {
            delete this._cache[applicationId];
        }), map(({ data }) => data));
    }
    updateApplication(applicationId, payload) {
        const url = `${this._appSvcUrl}/${applicationId}`;
        return this._httpClient
            .put(url, payload, {
            headers: setRequestOptions(),
        })
            .pipe(tap(() => {
            delete this._cache[applicationId];
        }), map(({ data }) => data));
    }
    prepareDSModel(applicationId) {
        const url = `${this._appSvcUrl}/${applicationId}/ds_model/data_collection`;
        return this._httpClient
            .post(url, {}, {
            headers: setRequestOptions(),
        })
            .pipe(tap(() => {
            this._cacheOther.dsModel = null;
        }), map(({ data }) => {
            this._cacheOther.dsModel = data;
            return data;
        }), catchError((err) => {
            console.error(`[POST] ds_model`, err);
            return EMPTY;
        }));
    }
    // ratio analysis
    // GET ratio analysis id
    getRatioAnalysisId(applicationId) {
        const url = `${this._appSvcUrl}/${applicationId}/ratio_analysis`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => {
            if (!res?.data?.category_ratio_analysis?.length ||
                !res?.data?.category_ratio_analysis[0]?.category_ratio_analysis_id) {
                return '';
            }
            const ratioAnalysisId = res.data.category_ratio_analysis[0].category_ratio_analysis_id;
            this._cacheOther.ratioAnalysisId = ratioAnalysisId;
            return ratioAnalysisId;
        }));
    }
    linkRatioAnalysisToApp(applicationId, ratioAnalysisId) {
        const url = `${this._appSvcUrl}/${applicationId}/ratio_analysis`;
        return this._httpClient
            .post(url, {
            category: 'BANK_STATEMENTS',
            category_ratio_analysis_id: ratioAnalysisId,
        }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => {
            return res?.data;
        }));
    }
    // application decision
    // GET decisions
    getApplicationDecisions(applicationId) {
        const url = `${this._appSvcUrl}/${applicationId}/decisions`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => {
            if (!res?.data?.decisions?.length)
                return [];
            const mappedDecisions = res.data.decisions
                .sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())
                .map((d) => ({
                ...d,
                comment: d?.data?.comment || 'N/A',
                created_at: this._formatDate(d.created_at),
            }));
            this._cacheOther.decisions = mappedDecisions;
            return mappedDecisions;
        }));
    }
    getApplicationTradeRefs(applicationId) {
        const url = `${this._appSvcUrl}/${applicationId}/ext/ctos/trade_refs`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data || []));
    }
    // POST
    createApplicationDecisions(applicationId, payload) {
        const url = `${this._appSvcUrl}/${applicationId}/decisions`;
        return this._httpClient
            .post(url, payload, {
            headers: setRequestOptions(),
        })
            .pipe(tap(() => {
            this._cacheOther.decisions = [];
        }), map(({ data }) => data));
    }
    searchApplications(params) {
        const url = `${this._appIntSvcUrl}`;
        return this._httpClient
            .get(url, {
            params,
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    importApplication(params) {
        const url = `${this._appSvcUrl}/imports`;
        return this._httpClient.post(url, params, {
            headers: setRequestOptions(),
            reportProgress: true,
            observe: 'events',
        });
    }
    clearCache() {
        this._cache = {};
        this._cacheOther = {
            dsModel: null,
            ratioAnalysisId: null,
            decisions: [],
        };
    }
    _formatDate(isoDateString) {
        const date = new Date(isoDateString);
        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'short' });
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class ApplicationServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ApplicationServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationServiceModule, providers: [
            {
                provide: APPLICATION_SERVICE_TOKEN,
                useClass: ApplicationService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: APPLICATION_SERVICE_TOKEN,
                            useClass: ApplicationService,
                        },
                    ],
                }]
        }] });

const injectApplicationService = () => inject(APPLICATION_SERVICE_TOKEN);

const provideApplicationService = () => {
    return {
        provide: APPLICATION_SERVICE_TOKEN,
        useClass: ApplicationService,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
};

const APPLICATION_INTERNAL_SERVICE_TOKEN = new InjectionToken('APPLICATION_INTERNAL_SERVICE_TOKEN');

class ApplicationInternalService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._appSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/int/applications`;
    }
    getApplication(applicationId) {
        const url = `${this._appSvcUrl}/${applicationId}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => {
            return data;
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationInternalService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationInternalService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationInternalService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class ApplicationInternalServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationInternalServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ApplicationInternalServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationInternalServiceModule, providers: [
            {
                provide: APPLICATION_INTERNAL_SERVICE_TOKEN,
                useClass: ApplicationInternalService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationInternalServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: APPLICATION_INTERNAL_SERVICE_TOKEN,
                            useClass: ApplicationInternalService,
                        },
                    ],
                }]
        }] });

const APPLICATION_GUARANTOR_SERVICE_TOKEN = new InjectionToken('APPLICATION_GUARANTOR_SERVICE_TOKEN');

class ApplicationGuarantorService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._appIntSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/applications`;
    }
    getSummaries(applicationId) {
        const url = `${this._appIntSvcUrl}/${applicationId}/member_bip_guarantor_summaries`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.data || []));
    }
    addSummaries(applicationId, data) {
        const url = `${this._appIntSvcUrl}/${applicationId}/member_bip_guarantor_summaries`;
        return this._httpClient
            .post(url, {
            data,
        }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.data || []));
    }
    deleteSummary(applicationId, id) {
        const url = `${this._appIntSvcUrl}/${applicationId}/member_bip_guarantor_summaries/${id}`;
        return this._httpClient.delete(url, {
            headers: setRequestOptions(),
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationGuarantorService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationGuarantorService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationGuarantorService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class ApplicationGuarantorServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationGuarantorServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ApplicationGuarantorServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationGuarantorServiceModule, providers: [
            {
                provide: APPLICATION_GUARANTOR_SERVICE_TOKEN,
                useClass: ApplicationGuarantorService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationGuarantorServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: APPLICATION_GUARANTOR_SERVICE_TOKEN,
                            useClass: ApplicationGuarantorService,
                        },
                    ],
                }]
        }] });

const provideApplicationGuarantorService = () => {
    return {
        provide: APPLICATION_GUARANTOR_SERVICE_TOKEN,
        useClass: ApplicationGuarantorService,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
};

const injectApplicationGuarantorService = () => inject(APPLICATION_GUARANTOR_SERVICE_TOKEN);

const APPLICATION_MEMBER_SERVICE_TOKEN = new InjectionToken('APPLICATION_MEMBER_SERVICE_TOKEN');

class ApplicationMemberService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._appSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/applications`;
        this._memberSvcUrl = `${this._utilsService.getKongUrl()}/v2/members`;
    }
    getApplicationMembers(applicationId, params = {}) {
        return this._httpClient
            .get(`${this._appSvcUrl}/${applicationId}/members`, {
            params,
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.members || []));
    }
    getApplicationMembersInformation(applicationId, applicationParams, memberParams) {
        return this.getApplicationMembers(applicationId, applicationParams).pipe(switchMap((applicationMembers) => {
            if (!applicationMembers?.length)
                return from(Promise.resolve([]));
            return forkJoin(applicationMembers.map((applicationInformation) => this._httpClient
                .get(`${this._memberSvcUrl}/${applicationInformation.member_id}`, {
                params: { ...memberParams },
                headers: setRequestOptions(),
            })
                .pipe(map((res) => res?.data))));
        }));
    }
    getApplicationMainBorrower(applicationId) {
        return this.getApplicationMembersInformation(applicationId, { type: ApplicationMemberType.MAIN }, {
            country_code: getCountryCodeFromStorage(),
            member_type_code: MemberCode.BORROWER,
        }).pipe(map((members) => (members ? members[0] : null)));
    }
    removeMember(applicationId, memberUUID) {
        return this._httpClient.delete(`${this._appSvcUrl}/${applicationId}/members/${memberUUID}`, {
            headers: setRequestOptions(),
        });
    }
    linkMember(applicationId, memberData) {
        return this._httpClient.post(`${this._appSvcUrl}/${applicationId}/members`, memberData, {
            headers: setRequestOptions(),
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationMemberService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationMemberService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationMemberService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class ApplicationMemberServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationMemberServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ApplicationMemberServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationMemberServiceModule, providers: [
            {
                provide: APPLICATION_MEMBER_SERVICE_TOKEN,
                useClass: ApplicationMemberService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationMemberServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: APPLICATION_MEMBER_SERVICE_TOKEN,
                            useClass: ApplicationMemberService,
                        },
                    ],
                }]
        }] });

const provideApplicationMemberService = () => {
    return {
        provide: APPLICATION_MEMBER_SERVICE_TOKEN,
        useClass: ApplicationMemberService,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
};

const injectApplicationMemberService = () => inject(APPLICATION_MEMBER_SERVICE_TOKEN);

const APPLICATION_FACILITY_TERMS_SERVICE_TOKEN = new InjectionToken('APPLICATION_FACILITY_TERMS_SERVICE_TOKEN');

class ApplicationFacilityTermsService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._appIntSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/applications`;
    }
    getFacilityTerms(applicationId) {
        const url = `${this._appIntSvcUrl}/${applicationId}/loan_facility_terms`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.loan_facility_terms_id));
    }
    addFacilityTerm(applicationId, loan_facility_terms_id) {
        const url = `${this._appIntSvcUrl}/${applicationId}/loan_facility_terms`;
        return this._httpClient
            .post(url, { loan_facility_terms_id }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.loan_facility_terms_id));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationFacilityTermsService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationFacilityTermsService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationFacilityTermsService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class ApplicationFacilityTermsServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationFacilityTermsServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ApplicationFacilityTermsServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationFacilityTermsServiceModule, providers: [
            {
                provide: APPLICATION_FACILITY_TERMS_SERVICE_TOKEN,
                useClass: ApplicationFacilityTermsService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationFacilityTermsServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: APPLICATION_FACILITY_TERMS_SERVICE_TOKEN,
                            useClass: ApplicationFacilityTermsService,
                        },
                    ],
                }]
        }] });

const injectApplicationFacilityTermsService = () => inject(APPLICATION_FACILITY_TERMS_SERVICE_TOKEN);

const provideApplicationFacilityTermsService = () => {
    return {
        provide: APPLICATION_FACILITY_TERMS_SERVICE_TOKEN,
        useClass: ApplicationFacilityTermsService,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
};

const APPLICATION_PRE_SCREENING_SERVICE_TOKEN = new InjectionToken('APPLICATION_PRE_SCREENING_SERVICE_TOKEN');

class ApplicationPreScreeningService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._appSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/applications`;
    }
    getPreScreeningId(applicationId) {
        const url = `${this._appSvcUrl}/${applicationId}/pre_screenings`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => (res?.data || []).map((item) => item.pre_screening_id)));
    }
    addPreScreeningId(applicationId, pre_screening_id) {
        const url = `${this._appSvcUrl}/${applicationId}/pre_screenings`;
        return this._httpClient
            .post(url, { pre_screening_id }, { headers: setRequestOptions() })
            .pipe(map((res) => res?.data?.pre_screening_id));
    }
    deletePreScreeningId(applicationId, id) {
        const url = `${this._appSvcUrl}/${applicationId}/pre_screenings/${id}`;
        return this._httpClient.delete(url, { headers: setRequestOptions() });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationPreScreeningService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationPreScreeningService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationPreScreeningService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class ApplicationPreScreeningServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationPreScreeningServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ApplicationPreScreeningServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationPreScreeningServiceModule, providers: [
            {
                provide: APPLICATION_PRE_SCREENING_SERVICE_TOKEN,
                useClass: ApplicationPreScreeningService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationPreScreeningServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: APPLICATION_PRE_SCREENING_SERVICE_TOKEN,
                            useClass: ApplicationPreScreeningService,
                        },
                    ],
                }]
        }] });

const injectApplicationPreScreeningService = () => inject(APPLICATION_PRE_SCREENING_SERVICE_TOKEN);

const provideApplicationPreScreeningService = () => {
    return {
        provide: APPLICATION_PRE_SCREENING_SERVICE_TOKEN,
        useClass: ApplicationPreScreeningService,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
};

const APPLICATION_MEMBER_BIP_SERVICE_TOKEN = new InjectionToken('APPLICATION_MEMBER_BIP_SERVICE_TOKEN');

class ApplicationMemberBIPService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._appSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/applications`;
        this._appIntSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/int/applications`;
        this._bipSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/bips`;
    }
    getApplicationMemberBIPs(applicationId, memberId, params) {
        if (!applicationId || !memberId)
            return of([]);
        return this._httpClient
            .get(`${this._appSvcUrl}/${applicationId}/members/${memberId}/bips`, {
            params: { ...params },
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => data.bips || []));
    }
    searchMemberBIPs(params) {
        return this._httpClient
            .get(`${this._bipSvcUrl}`, {
            params,
            headers: setRequestOptions(),
        })
            .pipe(map((res) => ({
            data: (res?.data?.bips || []).map(({ id, data }) => ({
                id,
                expand: data,
                reference_id: id,
                reference_to: 'APPLICATION_BIP',
            })),
            total: res?.data?._metadata?.total || 0,
        })));
    }
    linkMemberBips(applicationId, params) {
        return this._httpClient.post(`${this._appSvcUrl}/${applicationId}/members/${params.memberId}/bips`, omit(params, 'memberId'), {
            headers: setRequestOptions(),
        });
    }
    addMemberBip(applicationId, memberId, payload, isInternal) {
        return this._httpClient
            .post(`${isInternal ? this._appIntSvcUrl : this._appSvcUrl}/${applicationId}/members/${memberId}/bips`, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    updateMemberBip(id, payload) {
        return this._httpClient
            .put(`${this._bipSvcUrl}/${id}`, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    deleteMemberBip(applicationId, memberId, id) {
        return this._httpClient.delete(`${this._appSvcUrl}/${applicationId}/members/${memberId}/bips/${id}`, {
            headers: setRequestOptions(),
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationMemberBIPService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationMemberBIPService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationMemberBIPService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class MemberBIPServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberBIPServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: MemberBIPServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberBIPServiceModule, providers: [
            {
                provide: APPLICATION_MEMBER_BIP_SERVICE_TOKEN,
                useClass: ApplicationMemberBIPService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberBIPServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: APPLICATION_MEMBER_BIP_SERVICE_TOKEN,
                            useClass: ApplicationMemberBIPService,
                        },
                    ],
                }]
        }] });

const injectApplicationMemberBIPService = () => inject(APPLICATION_MEMBER_BIP_SERVICE_TOKEN);

const provideApplicationMemberBIPService = () => {
    return {
        provide: APPLICATION_MEMBER_BIP_SERVICE_TOKEN,
        useClass: ApplicationMemberBIPService,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
};

const APPLICATION_PROJECT_LISTING_SERVICE_TOKEN = new InjectionToken('APPLICATION_PROJECT_LISTING_SERVICE_TOKEN');

class ApplicationProjectListingService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._appSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/applications`;
    }
    getList(applicationId) {
        const url = `${this._appSvcUrl}/${applicationId}/project_listings`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.project_listing_ids || []));
    }
    createList(applicationId, ids) {
        const url = `${this._appSvcUrl}/${applicationId}/project_listings`;
        return this._httpClient.post(url, { project_listing_ids: ids }, { headers: setRequestOptions() });
    }
    delete(applicationId, id) {
        const url = `${this._appSvcUrl}/${applicationId}/project_listings/${id}`;
        return this._httpClient.delete(url, { headers: setRequestOptions() });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationProjectListingService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationProjectListingService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationProjectListingService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class ApplicationProjectListingServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationProjectListingServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ApplicationProjectListingServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationProjectListingServiceModule, providers: [
            {
                provide: APPLICATION_PROJECT_LISTING_SERVICE_TOKEN,
                useClass: ApplicationProjectListingService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationProjectListingServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: APPLICATION_PROJECT_LISTING_SERVICE_TOKEN,
                            useClass: ApplicationProjectListingService,
                        },
                    ],
                }]
        }] });

const APPLICATION_PROPOSAL_SERVICE_TOKEN = new InjectionToken('APPLICATION_PROPOSAL_SERVICE_TOKEN');

class ApplicationProposalService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._proposalSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/proposals`;
        this._appIntSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/int/applications`;
        this._appSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/applications`;
    }
    getProposals(applicationId, params = {}) {
        const url = `${this._appIntSvcUrl}/${applicationId}/proposals`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
            params,
        })
            .pipe(map((res) => res?.data?.proposals || []));
    }
    getProposal(id) {
        const url = `${this._proposalSvcUrl}/${id}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    deleteProposal(applicationId, memberUUID, id) {
        const url = `${this._appSvcUrl}/${applicationId}/members/${memberUUID}/proposals/${id}`;
        return this._httpClient.delete(url, {
            headers: setRequestOptions(),
        });
    }
    assignTestBucket(id, test_bucket) {
        const url = `${this._proposalSvcUrl}/${id}/test_bucket`;
        return this._httpClient.put(url, {
            test_bucket,
        }, {
            headers: setRequestOptions(),
        });
    }
    updateProposal(id, proposal_type, data) {
        const url = `${this._proposalSvcUrl}/${id}`;
        return this._httpClient.put(url, { id, proposal_type, data }, { headers: setRequestOptions() });
    }
    addProposal(applicationId, memberUUID, proposal_type, data) {
        const url = `${this._appIntSvcUrl}/${applicationId}/members/${memberUUID}/proposals`;
        return this._httpClient.post(url, { proposal_type, data }, { headers: setRequestOptions() });
    }
    updateProposalRecommendations(proposalId, payload) {
        const url = `${this._proposalSvcUrl}/${proposalId}/recommendations`;
        return this._httpClient
            .put(url, {
            ...payload,
        }, { headers: setRequestOptions() })
            .pipe(map((res) => res.data));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationProposalService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationProposalService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationProposalService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class ApplicationProposalServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationProposalServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ApplicationProposalServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationProposalServiceModule, providers: [
            {
                provide: APPLICATION_PROPOSAL_SERVICE_TOKEN,
                useClass: ApplicationProposalService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationProposalServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: APPLICATION_PROPOSAL_SERVICE_TOKEN,
                            useClass: ApplicationProposalService,
                        },
                    ],
                }]
        }] });

const injectApplicationProposalService = () => inject(APPLICATION_PROPOSAL_SERVICE_TOKEN);

const provideApplicationProposalService = () => {
    return {
        provide: APPLICATION_PROPOSAL_SERVICE_TOKEN,
        useClass: ApplicationProposalService,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
};

const APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN = new InjectionToken('APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN');

class ApplicationRepaymentScheduleService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._appSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/proposals`;
    }
    getData(id) {
        const url = `${this._appSvcUrl}/${id}/repayment_schedule`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data.repayment_schedule_id));
    }
    addData(id, repayment_schedule_id) {
        const url = `${this._appSvcUrl}/${id}/repayment_schedule`;
        return this._httpClient
            .post(url, { repayment_schedule_id }, { headers: setRequestOptions() })
            .pipe(map((res) => res?.data.repayment_schedule_id));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationRepaymentScheduleService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationRepaymentScheduleService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationRepaymentScheduleService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class ApplicationRepaymentScheduleServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationRepaymentScheduleServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ApplicationRepaymentScheduleServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationRepaymentScheduleServiceModule, providers: [
            {
                provide: APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN,
                useClass: ApplicationRepaymentScheduleService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationRepaymentScheduleServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN,
                            useClass: ApplicationRepaymentScheduleService,
                        },
                    ],
                }]
        }] });

const injectApplicationRepaymentScheduleService = () => inject(APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN);

const provideApplicationRepaymentScheduleService = () => {
    return {
        provide: APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN,
        useClass: ApplicationRepaymentScheduleService,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
};

const APPLICATION_SCORECARD_SERVICE_TOKEN = new InjectionToken('APPLICATION_SCORECARD_SERVICE_TOKEN');

class ApplicationScorecardService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._cache = {
            scorecardId: null,
        };
        this._appSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/applications`;
    }
    // POST /applications/{applicationId}/scorecard
    linkScorecardIdToApplication(applicationId, scorecard_id) {
        const url = `${this._appSvcUrl}/${applicationId}/scorecard`;
        return this._httpClient
            .post(url, { scorecard_id }, { headers: setRequestOptions() })
            .pipe(map((res) => res?.data?.scorecard_id), catchError((err) => {
            console.error(`[linkScorecardIdToApplication]`, err);
            return throwError(() => `Error: [linkScorecardIdToApplication] link scorecard id to application`);
        }));
    }
    // GET /applications/{applicationId}/scorecard
    getScorecardId(applicationId, updateCache = false) {
        if (this._cache.scorecardId && !updateCache)
            return of(this._cache.scorecardId);
        const url = `${this._appSvcUrl}/${applicationId}/scorecard`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => {
            if (!res?.data?.scorecard_id)
                return '';
            this._cache.scorecardId = res.data.scorecard_id;
            return res.data.scorecard_id;
        }), catchError((err) => {
            console.error(`[getScorecardId]`, err);
            return EMPTY;
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationScorecardService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationScorecardService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationScorecardService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class ApplicationScorecardServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationScorecardServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ApplicationScorecardServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationScorecardServiceModule, providers: [
            {
                provide: APPLICATION_SCORECARD_SERVICE_TOKEN,
                useClass: ApplicationScorecardService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationScorecardServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: APPLICATION_SCORECARD_SERVICE_TOKEN,
                            useClass: ApplicationScorecardService,
                        },
                    ],
                }]
        }] });

const APPLICATION_EXPOSURE_SERVICE_TOKEN = new InjectionToken('APPLICATION_EXPOSURE_SERVICE_TOKEN');

class ApplicationExposureService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._appSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/applications`;
    }
    getExposure(applicationId) {
        const url = `${this._appSvcUrl}/${applicationId}/exposure`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.exposure_id));
    }
    addExposure(applicationId, exposure_id) {
        const url = `${this._appSvcUrl}/${applicationId}/exposure`;
        return this._httpClient.post(url, { exposure_id }, {
            headers: setRequestOptions(),
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationExposureService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationExposureService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationExposureService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class ApplicationExposureServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationExposureServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ApplicationExposureServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationExposureServiceModule, providers: [
            {
                provide: APPLICATION_EXPOSURE_SERVICE_TOKEN,
                useClass: ApplicationExposureService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationExposureServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: APPLICATION_EXPOSURE_SERVICE_TOKEN,
                            useClass: ApplicationExposureService,
                        },
                    ],
                }]
        }] });

const KYC_SERVICE_TOKEN = new InjectionToken('KYC_SERVICE_TOKEN');

class KYCService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._cache = {};
        this._appSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/applications`;
    }
    getKYC(applicationId) {
        if (this._cache[applicationId]) {
            return of(this._cache[applicationId]);
        }
        const url = `${this._appSvcUrl}/${applicationId}/kyc`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => {
            this._cache[applicationId] = data;
            return data;
        }));
    }
    updateKYC(applicationId, payload) {
        const url = `${this._appSvcUrl}/${applicationId}`;
        return this._httpClient
            .put(url, payload, {
            headers: setRequestOptions(),
        })
            .pipe(tap(() => {
            delete this._cache[applicationId];
        }), map(({ data }) => data));
    }
    clearCache() {
        this._cache = {};
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: KYCService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: KYCService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: KYCService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class KYCServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: KYCServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: KYCServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: KYCServiceModule, providers: [
            {
                provide: KYC_SERVICE_TOKEN,
                useClass: KYCService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: KYCServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: KYC_SERVICE_TOKEN,
                            useClass: KYCService,
                        },
                    ],
                }]
        }] });

class OutstandingLoansService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._cache = {
            outstandingLoanIds: [],
        };
        this._appSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/applications`;
    }
    // GET
    getOutstandingLoanIds(applicationId, updateCache = false) {
        if (this._cache.outstandingLoanIds?.length && !updateCache) {
            return of(this._cache.outstandingLoanIds);
        }
        const url = `${this._appSvcUrl}/${applicationId}/outstanding_loans`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => {
            if (!res?.data?.outstanding_loan_ids)
                return [];
            this._cache.outstandingLoanIds = res.data.outstanding_loan_ids;
            return res.data.outstanding_loan_ids;
        }), catchError((err) => {
            console.error(`[getOutstandingLoanIds]`, err);
            return EMPTY;
        }));
    }
    addOutstandingLoanIds(applicationId, outstanding_loan_ids, updateCache = false) {
        if (this._cache.outstandingLoanIds?.length && !updateCache) {
            return of(this._cache.outstandingLoanIds);
        }
        const url = `${this._appSvcUrl}/${applicationId}/outstanding_loans`;
        return this._httpClient
            .post(url, {
            outstanding_loan_ids,
        }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => {
            if (!res?.data?.outstanding_loan_ids)
                return [];
            this._cache.outstandingLoanIds = res.data.outstanding_loan_ids;
            return res.data.outstanding_loan_ids;
        }), catchError((err) => {
            console.error(`[getOutstandingLoanIds]`, err);
            return EMPTY;
        }));
    }
    removeOutstandingLoansId(applicationId, id) {
        const url = `${this._appSvcUrl}/${applicationId}/outstanding_loans/${id}`;
        return this._httpClient
            .delete(url, {
            headers: setRequestOptions(),
        })
            .pipe(catchError((err) => {
            console.error(`[removeOutstandingLoansId]`, err);
            return EMPTY;
        }));
    }
    clearCache() {
        this._cache = {
            outstandingLoanIds: [],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OutstandingLoansService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OutstandingLoansService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OutstandingLoansService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

const OUTSTANDING_LOAN_SERVICE_TOKEN = new InjectionToken('OUTSTANDING_LOAN_SERVICE_TOKEN');

class OutstandingLoansServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OutstandingLoansServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: OutstandingLoansServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OutstandingLoansServiceModule, providers: [
            {
                provide: OUTSTANDING_LOAN_SERVICE_TOKEN,
                useClass: OutstandingLoansService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OutstandingLoansServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: OUTSTANDING_LOAN_SERVICE_TOKEN,
                            useClass: OutstandingLoansService,
                        },
                    ],
                }]
        }] });

const APPLICATION_SALES_SUMMARY_SERVICE_TOKEN = new InjectionToken('APPLICATION_SALES_SUMMARY_SERVICE_TOKEN');

class ApplicationSalesSummaryService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._applicationSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/applications`;
    }
    getById(id) {
        return this._httpClient
            .get(`${this._applicationSvcUrl}/${id}/sales_summary`, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.sales_summary_id));
    }
    create(id, sales_summary_id) {
        return this._httpClient
            .post(`${this._applicationSvcUrl}/${id}/sales_summary`, {
            sales_summary_id,
        }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.sales_summary_id));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationSalesSummaryService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationSalesSummaryService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationSalesSummaryService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class ApplicationSalesSummaryServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationSalesSummaryServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ApplicationSalesSummaryServiceModule, imports: [UtilsServiceModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationSalesSummaryServiceModule, providers: [
            {
                provide: APPLICATION_SALES_SUMMARY_SERVICE_TOKEN,
                useClass: ApplicationSalesSummaryService,
            },
        ], imports: [UtilsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationSalesSummaryServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: APPLICATION_SALES_SUMMARY_SERVICE_TOKEN,
                            useClass: ApplicationSalesSummaryService,
                        },
                    ],
                    imports: [UtilsServiceModule],
                }]
        }] });

const APPLICATION_POLICY_CHECKLIST_SERVICE_TOKEN = new InjectionToken('APPLICATION_POLICY_CHECKLIST_SERVICE_TOKEN');

class ApplicationPolicyChecklistService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._applicationSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/applications`;
    }
    addPolicyCheckList(applicationId, policy_checklist_id) {
        return this._httpClient
            .post(`${this._applicationSvcUrl}/${applicationId}/policy_checklist`, { policy_checklist_id }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.policy_checklist_id));
    }
    getPolicyCheckList(applicationId) {
        return this._httpClient
            .get(`${this._applicationSvcUrl}/${applicationId}/policy_checklist`, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.policy_checklist_id));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationPolicyChecklistService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationPolicyChecklistService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationPolicyChecklistService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class ApplicationPolicyChecklistServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationPolicyChecklistServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ApplicationPolicyChecklistServiceModule, imports: [UtilsServiceModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationPolicyChecklistServiceModule, providers: [
            {
                provide: APPLICATION_POLICY_CHECKLIST_SERVICE_TOKEN,
                useClass: ApplicationPolicyChecklistService,
            },
        ], imports: [UtilsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationPolicyChecklistServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: APPLICATION_POLICY_CHECKLIST_SERVICE_TOKEN,
                            useClass: ApplicationPolicyChecklistService,
                        },
                    ],
                    imports: [UtilsServiceModule],
                }]
        }] });

function injectApplicationPolicyChecklistService(injector) {
    !injector && assertInInjectionContext(injectApplicationPolicyChecklistService);
    const assertedInjector = injector ?? inject(Injector);
    return assertedInjector.get(APPLICATION_POLICY_CHECKLIST_SERVICE_TOKEN);
}

function provideApplicationPolicyChecklistService() {
    return {
        provide: APPLICATION_POLICY_CHECKLIST_SERVICE_TOKEN,
        useClass: ApplicationPolicyChecklistService,
    };
}

const APPLICATION_RELATIONSHIP_SERVICE_TOKEN = new InjectionToken('APPLICATION_RELATIONSHIP_SERVICE_TOKEN');

class ApplicationRelationshipService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._applicationSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/applications`;
    }
    addAsync(applicationId, relationshipIdentifier, relationshipId) {
        const url = `${this._applicationSvcUrl}/${applicationId}/relationships/${relationshipIdentifier}/${relationshipId}`;
        return this._httpClient.post(url, {}, {
            headers: setRequestOptions(),
        });
    }
    deleteAsync(applicationId, relationshipIdentifier, relationshipId) {
        const url = `${this._applicationSvcUrl}/${applicationId}/relationships/${relationshipIdentifier}/${relationshipId}`;
        return this._httpClient.delete(url, {
            headers: setRequestOptions(),
        });
    }
    getAsync(applicationId, relationshipIdentifier) {
        const url = `${this._applicationSvcUrl}/${applicationId}/relationships/${relationshipIdentifier}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.map((item) => item.relationship_id) || []));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationRelationshipService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationRelationshipService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationRelationshipService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

function injectApplicationRelationshipService(injector) {
    !injector && assertInInjectionContext(injectApplicationRelationshipService);
    const assertedInjector = injector ?? inject(Injector);
    return assertedInjector.get(APPLICATION_RELATIONSHIP_SERVICE_TOKEN);
}

function provideApplicationRelationshipService() {
    return {
        provide: APPLICATION_RELATIONSHIP_SERVICE_TOKEN,
        useClass: ApplicationRelationshipService,
    };
}

class ApplicationBorrowerSummaryService {
    constructor() {
        this._httpClient = inject(HttpClient);
        this._utilsService = injectUtilsService();
        this._appSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/applications`;
    }
    /**
     * Re Generate Borrower Summary
     * @param applicationId {string}
     * @returns Observable<{
     *   application_id: string;
     *   borrower_summary_id: string;
     * } | null>
     * @memberof ApplicationBorrowerSummaryService
     * @description Re Generate Borrower CTOS
     * @example regenerate('1234')
     */
    regenerate(applicationId) {
        const url = `${this._appSvcUrl}/${applicationId}/borrower_summary/generate`;
        return this._httpClient
            .post(url, {}, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationBorrowerSummaryService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationBorrowerSummaryService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationBorrowerSummaryService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

const APPLICATION_BORROWER_SUMMARY_SERVICE_TOKEN = new InjectionToken('APPLICATION_BORROWER_SUMMARY_SERVICE_TOKEN');

const provideApplicationBorrowerSummaryService = () => {
    return {
        provide: APPLICATION_BORROWER_SUMMARY_SERVICE_TOKEN,
        useClass: ApplicationBorrowerSummaryService,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
};

const injectApplicationBorrowerSummaryService = () => inject(APPLICATION_BORROWER_SUMMARY_SERVICE_TOKEN);

const BANK_ACCOUNTS_AND_STATEMENTS_SERVICE_TOKEN = new InjectionToken('BANK_ACCOUNTS_AND_STATEMENTS_SERVICE_TOKEN');

const MEMBER_SERVICE_TOKEN = new InjectionToken('MEMBER_SERVICE_TOKEN');

class MemberService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._cache = {};
        this._memberSvcUrl = `${this._utilsService.getKongUrl()}/v2/members`;
        this._faSvcUrl = `${this._utilsService.getKongUrl()}/v2/fa`;
        this._memberMsSvcUrl = `${this._utilsService.getKongUrl()}/ms/members`;
        this._memberDocSvcUrl = `${this._utilsService.getKongUrl()}/docs_management/v2/member`;
        this._appSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/applications`;
    }
    searchMembers(params) {
        return this._httpClient.get(`${this._memberSvcUrl}`, {
            params,
            headers: setRequestOptions(),
        });
    }
    getBips(companyId) {
        return this._httpClient
            .get(`${this._faSvcUrl}/bips`, {
            params: { companyId },
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data || []));
    }
    updateBips(companyId, bips) {
        return this._httpClient
            .put(`${this._faSvcUrl}/bips`, { companyId, bips }, {
            params: { companyId },
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data || []));
    }
    getMergeBipNames(applicationId, memberId, params, companyId) {
        return forkJoin([
            this.getBips(companyId).pipe(catchError(() => from(Promise.resolve([])))),
            this.__getApplicationMemberBIPs(applicationId, memberId, params).pipe(catchError(() => from(Promise.resolve([])))),
        ]).pipe(map(([bips, applicationBips]) => {
            const map = new Map();
            applicationBips?.forEach((bip) => {
                if (bip.reference_id && !map.get(bip.reference_id)) {
                    map.set(bip.reference_id, bip?.expand?.member_entity_type_id == 3
                        ? bip?.expand?.company_name || bip?.expand?.name || bip?.expand?.fullname
                        : bip?.expand?.fullname || bip?.expand?.name || bip?.expand?.company_name);
                }
                if (bip.expand?.idNumber && !map.get(bip.expand.idNumber)) {
                    map.set(bip.expand?.idNumber, bip?.expand?.name);
                }
                if (bip?.expand?.individualIdentities?.length &&
                    bip?.expand?.individualIdentities[0]?.identificationNumber) {
                    map.set(bip?.expand?.individualIdentities[0]?.identificationNumber, bip?.expand?.fullname);
                }
            });
            bips?.forEach((bip) => {
                if (bip.id && !map.get(bip.id)) {
                    map.set(bip.id, bip.name);
                }
                if (bip.idNumber && !map.get(bip.idNumber)) {
                    map.set(bip.idNumber, bip.name);
                }
            });
            return Array.from(map.keys()).map((id) => ({
                id,
                name: map.get(id),
            }));
        }), catchError(() => {
            return from(Promise.resolve([]));
        }));
    }
    getMember(memberId, params) {
        return this._httpClient
            .get(`${this._memberSvcUrl}/${memberId}`, {
            params: { ...params },
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => {
            this._cache[memberId] = data;
            return data;
        }));
    }
    getSingleMember(memberId) {
        if (!memberId) {
            console.error('memberId is required');
            return EMPTY;
        }
        return this._httpClient
            .get(`${this._memberMsSvcUrl}/any/single/${memberId}`, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    updateMember(memberId, payload) {
        const url = `${this._memberSvcUrl}/${memberId}`;
        return this._httpClient
            .put(url, payload, {
            headers: setRequestOptions(),
        })
            .pipe(tap(() => {
            delete this._cache[memberId];
        }), map((res) => res?.data));
    }
    addMember(payload) {
        const url = `${this._memberSvcUrl}`;
        return this._httpClient
            .post(url, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    getDocs(memberIdInt, params = {}) {
        const url = `${this._memberDocSvcUrl}/${memberIdInt}/docs`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
            params,
        })
            .pipe(map((res) => res?.results || []));
    }
    clearCache() {
        this._cache = {};
    }
    __getApplicationMemberBIPs(applicationId, memberId, params) {
        return this._httpClient
            .get(`${this._appSvcUrl}/${applicationId}/members/${memberId}/bips`, {
            params: { ...params },
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => data.bips));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class MemberServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: MemberServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberServiceModule, providers: [
            {
                provide: MEMBER_SERVICE_TOKEN,
                useClass: MemberService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: MEMBER_SERVICE_TOKEN,
                            useClass: MemberService,
                        },
                    ],
                }]
        }] });

const provideMemberService = () => {
    return {
        provide: MEMBER_SERVICE_TOKEN,
        useClass: MemberService,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
};

const injectMemberService = () => inject(MEMBER_SERVICE_TOKEN);

const FSW_MEMBER_SERVICE_V3_TOKEN = new InjectionToken('MEMBER_SERVICE_V3');
const provideFSWMemberServiceV3 = () => {
    return {
        provide: FSW_MEMBER_SERVICE_V3_TOKEN,
        useClass: FSWMemberServiceV3,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
};
const injectFSWMemberServiceV3 = () => inject(FSW_MEMBER_SERVICE_V3_TOKEN);
class FSWMemberServiceV3 {
    constructor() {
        this._httpClient = inject(HttpClient);
        this._utilsService = inject(UTILS_SERVICE_TOKEN);
        this._svcUrl = `${this._utilsService.getKongUrl()}/v3/members`;
    }
    getIndividualLinks(companyUuid) {
        const url = `${this._svcUrl}/company_individual_links`;
        return this._httpClient.get(url, {
            params: {
                companyUuid,
            },
            headers: setRequestOptions(),
        });
    }
    getCompanyLinks(companyUuid) {
        const url = `${this._svcUrl}/company_company_links`;
        return this._httpClient.get(url, {
            params: {
                companyUuid,
            },
            headers: setRequestOptions(),
        });
    }
    getLinks(memberUuid) {
        const url = `${this._svcUrl}/${memberUuid}/company_individual_links`;
        return this._httpClient.get(url, {
            headers: setRequestOptions(),
        });
    }
}

class BankAccountsAndStatementsService {
    constructor(_httpClient, _utilsService, _applicationMemberService, _memberService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._applicationMemberService = _applicationMemberService;
        this._memberService = _memberService;
        this._cache = {
            bankAccountsWithStatements: [],
        };
        this._appSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/applications`;
    }
    // PUT
    addBankAccountWithStatements(applicationId, payload) {
        const url = `${this._appSvcUrl}/${applicationId}/bank_statements/link`;
        return this._httpClient
            .put(url, {
            bank_accounts: [payload],
        }, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => data.bank_accounts), catchError((err) => {
            console.error(`[addBankAccountWithStatements]`, err);
            return EMPTY;
        }));
    }
    // PATCH
    updateBankAccount(applicationId, bankAccountId, payload) {
        const url = `${this._appSvcUrl}/${applicationId}/bank_accounts/${bankAccountId}`;
        return this._httpClient
            .patch(url, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => data), catchError((err) => {
            console.error(`[updateBankAccount]`, err);
            return EMPTY;
        }));
    }
    // POST
    cloneBankAccount(applicationId, bankAccountId, payload, useMock) {
        let url = `${this._appSvcUrl}/${applicationId}/bank_accounts/${bankAccountId}/clone`;
        if (useMock) {
            url = `${this._appSvcUrl}/${applicationId}/bank_accounts/${bankAccountId}/clone?is_mock=${useMock}`;
        }
        return this._httpClient
            .post(url, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => data), catchError((err) => {
            console.error(`[cloneBankAccount]`, err);
            return EMPTY;
        }));
    }
    // PATCH
    setPrimaryBankAccount(applicationId, bankAccountId) {
        const url = `${this._appSvcUrl}/${applicationId}/bank_accounts/${bankAccountId}/primary`;
        return this._httpClient
            .patch(url, {}, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => data), catchError((err) => {
            console.error(`[setPrimaryBankAccount]`, err);
            return EMPTY;
        }));
    }
    // PUT
    deleteBankAccount(applicationId, bankAccountId, payload) {
        const url = `${this._appSvcUrl}/${applicationId}/perfios_bank_accounts/${bankAccountId}/delete`;
        return this._httpClient
            .put(url, payload || {}, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => !!res), catchError((err) => {
            console.error(`[deleteBankAccount]`, err);
            return EMPTY;
        }));
    }
    // POST
    uploadDocToV3(file) {
        const url = `${this._utilsService.getKongUrl()}/docs_management/v3/document/upload/single`;
        const headers = setRequestOptions(false);
        const formData = new FormData();
        formData.append('file', file);
        formData.append('doc_type', 'BANK_STATEMENT');
        return this._httpClient
            .post(url, formData, {
            headers,
        })
            .pipe(map((res) => ({
            file,
            doc_id: res?.uuid,
        })), catchError((err) => {
            console.error(`[uploadDocToV3]`, err);
            // Create an error observable using throwError and a factory function
            // that creates an error object with a custom message
            return EMPTY;
        }));
    }
    // POST
    uploadBankStatements(applicationId, bankAccountId, payload) {
        const url = `${this._appSvcUrl}/${applicationId}/bank_accounts/${bankAccountId}/bank_statements`;
        return this._httpClient
            .post(url, {
            statements: payload,
        }, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => data), catchError((err) => {
            console.error(`[uploadBankStatements]`, err);
            return EMPTY;
        }));
    }
    // DELETE
    deleteBankStatement(applicationId, bankAccountId, bankStatementId) {
        const url = `${this._appSvcUrl}/${applicationId}/bank_accounts/${bankAccountId}/bank_statements/${bankStatementId}`;
        return this._httpClient
            .delete(url, {
            headers: setRequestOptions(),
        })
            .pipe(catchError((err) => {
            console.error(`[deleteBankStatement]`, err);
            return EMPTY;
        }));
    }
    // PUT
    sendToPerfios(applicationId, bankAccountId, useMock) {
        let url = `${this._appSvcUrl}/${applicationId}/bank_statements/parse`;
        if (useMock) {
            url = `${this._appSvcUrl}/${applicationId}/bank_statements/parse?is_mock=${useMock}`;
        }
        return this._httpClient
            .put(url, {
            bank_account_ids: [bankAccountId],
        }, { headers: setRequestOptions() })
            .pipe(catchError((err) => {
            console.error(`[sendToPerfios]`, err);
            return EMPTY;
        }));
    }
    // GET
    getBankAccountParseStatus(applicationId, updateCache = false) {
        if (this._cache?.bankAccountsWithStatements?.length && !updateCache) {
            return of(this._cache.bankAccountsWithStatements);
        }
        const url = `${this._appSvcUrl}/${applicationId}/bank_accounts/analyzable`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => {
            this._cache.bankAccountsWithStatements = res?.data?.bank_accounts || [];
            return this._cache.bankAccountsWithStatements;
        }), catchError((err) => {
            // return of(MOCK_BANK_ACCOUNTS);
            console.error(`[getBankAccountParseStatus]`, err);
            return EMPTY;
        }));
    }
    getDocs(applicationId) {
        return this._applicationMemberService
            .getApplicationMembers(applicationId, {
            type: 'MAIN',
        })
            .pipe(map((members) => members[0]), switchMap((member) => this._memberService.getDocs(member.member_id_int)));
    }
    // POST
    processBankReports(applicationId) {
        const url = `${this._appSvcUrl}/${applicationId}/bank_statements/reports`;
        return this._httpClient.post(url, {}, { headers: setRequestOptions() }).pipe(catchError((err) => {
            console.error(`[processBankReports]`, err);
            return EMPTY;
        }));
    }
    // DELETE Bank Statement Reports
    deleteBankStatementReports(applicationId) {
        const url = `${this._appSvcUrl}/${applicationId}/bank_statements/reports`;
        return this._httpClient.delete(url, { headers: setRequestOptions() }).pipe(catchError((err) => {
            console.error(`[deleteBankStatementReports]`, err);
            return EMPTY;
        }));
    }
    // PUT
    changeParseStatus(applicationId, bankAccountId, payload) {
        const url = `${this._appSvcUrl}/${applicationId}/bank_accounts/${bankAccountId}/status`;
        return this._httpClient
            .put(url, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.success), catchError((err) => {
            console.error(`[changeParseStatus]`, err);
            return EMPTY;
        }));
    }
    // DELETE
    deleteBankReports(applicationId, bankAccountId) {
        const url = `${this._appSvcUrl}/${applicationId}/bank_accounts/${bankAccountId}/reports`;
        return this._httpClient
            .delete(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((_) => true), catchError((err) => {
            console.error(`[deleteBankReports]`, err);
            return EMPTY;
        }));
    }
    clearCache() {
        this._cache = {
            bankAccountsWithStatements: [],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BankAccountsAndStatementsService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }, { token: APPLICATION_MEMBER_SERVICE_TOKEN }, { token: MEMBER_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BankAccountsAndStatementsService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BankAccountsAndStatementsService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MEMBER_SERVICE_TOKEN]
                }] }]; } });

class BankAccountsAndStatementsServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BankAccountsAndStatementsServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: BankAccountsAndStatementsServiceModule, imports: [ApplicationMemberServiceModule, MemberServiceModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BankAccountsAndStatementsServiceModule, providers: [
            {
                provide: BANK_ACCOUNTS_AND_STATEMENTS_SERVICE_TOKEN,
                useClass: BankAccountsAndStatementsService,
            },
        ], imports: [ApplicationMemberServiceModule, MemberServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BankAccountsAndStatementsServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: BANK_ACCOUNTS_AND_STATEMENTS_SERVICE_TOKEN,
                            useClass: BankAccountsAndStatementsService,
                        },
                    ],
                    imports: [ApplicationMemberServiceModule, MemberServiceModule],
                }]
        }] });

const BANK_TABULATIONS_SERVICE_TOKEN = new InjectionToken('BANK_TABULATIONS_SERVICE_TOKEN');

class BankTabulationsService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._cache = {
            bankAnalysisReports: [],
        };
        this._appSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/applications`;
    }
    // GET
    getBankAnalyzableAnalysisReports(applicationId, updateCache = false) {
        if (this._cache.bankAnalysisReports?.length && !updateCache) {
            return of(this._cache.bankAnalysisReports);
        }
        const url = `${this._appSvcUrl}/${applicationId}/bank_accounts/analyzable/analysis_reports`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => {
            const modBankAnalysisReports = (res?.data?.bank_accounts || []).map((acc) => {
                const modMonthlyAnalysis = this._sortBankAnalysisReports(acc?.analysis_report?.monthly_analysis);
                return {
                    ...acc,
                    analysis_report: {
                        ...acc?.analysis_report,
                        monthly_analysis: modMonthlyAnalysis,
                    },
                };
            });
            this._cache.bankAnalysisReports = modBankAnalysisReports;
            return modBankAnalysisReports;
        }), catchError((err) => {
            // return of(MOCK_BANK_TABULATIONS);
            console.error(`[getBankAnalyzableAnalysisReports] Error GET Analysis Reports: ${err}`);
            return EMPTY;
        }));
    }
    // GET
    getBankAnalysisReports(applicationId, updateCache = false) {
        if (this._cache.bankAnalysisReports?.length && !updateCache) {
            return of(this._cache.bankAnalysisReports);
        }
        const url = `${this._appSvcUrl}/${applicationId}/bank_statements/analysis_reports`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => {
            const modBankAnalysisReports = (res?.data?.bank_accounts || []).map((acc) => {
                const modMonthlyAnalysis = this._sortBankAnalysisReports(acc?.analysis_report?.monthly_analysis);
                return {
                    ...acc,
                    analysis_report: {
                        ...acc?.analysis_report,
                        monthly_analysis: modMonthlyAnalysis,
                    },
                };
            });
            this._cache.bankAnalysisReports = modBankAnalysisReports;
            return modBankAnalysisReports;
        }), catchError((err) => {
            // return of(MOCK_BANK_TABULATIONS);
            console.error(`[getBankAnalysisReports] Error GET Analysis Reports: ${err}`);
            return EMPTY;
        }));
    }
    // PUT
    updateBankAnalysisReport(applicationId, bankAccountId, payload) {
        const url = `${this._appSvcUrl}/${applicationId}/bank_accounts/${bankAccountId}/bank_statements/analysis_reports`;
        return this._httpClient
            .put(url, {
            ...payload,
        }, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => data.bank_accounts), catchError((err) => {
            console.error(`[updateBankAnalysisReport] Error PUT Analysis Reports: ${err}`);
            return EMPTY;
        }));
    }
    clearCache() {
        this._cache = {
            bankAnalysisReports: [],
        };
    }
    _sortBankAnalysisReports(data) {
        if (!data)
            return data;
        const monthNames = Object.keys(data);
        monthNames.sort((a, b) => {
            const [aMonth, aYear] = a.split('-');
            const [bMonth, bYear] = b.split('-');
            const aDate = new Date(`${aYear}-${aMonth}`);
            const bDate = new Date(`${bYear}-${bMonth}`);
            return aDate.getTime() - bDate.getTime();
        });
        const sortedData = {};
        monthNames.forEach((monthName) => {
            sortedData[monthName] = data[monthName];
        });
        return sortedData;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BankTabulationsService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BankTabulationsService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BankTabulationsService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class BankTabulationsServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BankTabulationsServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: BankTabulationsServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BankTabulationsServiceModule, providers: [
            {
                provide: BANK_TABULATIONS_SERVICE_TOKEN,
                useClass: BankTabulationsService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BankTabulationsServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: BANK_TABULATIONS_SERVICE_TOKEN,
                            useClass: BankTabulationsService,
                        },
                    ],
                }]
        }] });

const NON_TRADE_TRANSACTIONS_SERVICE_TOKEN = new InjectionToken('NON_TRADE_TRANSACTIONS_SERVICE_TOKEN');

class NonTradeTransactionsService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._cache = {
            nonTradeReports: [],
        };
        this._appSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/applications`;
    }
    // GET
    getNonTradeReports(applicationId, updateCache = false) {
        if (this._cache.nonTradeReports?.length && !updateCache) {
            return of(this._cache.nonTradeReports);
        }
        const url = `${this._appSvcUrl}/${applicationId}/bank_accounts/analyzable/nt_reports`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => {
            this._cache.nonTradeReports = res?.data?.bank_accounts || [];
            return this._cache.nonTradeReports;
        }), catchError((err) => {
            // return of(MOCK_NON_TRADE_TRANSACTIONS);
            console.error(`[getNonTradeReports] Error fetching non-trade reports: ${err}`);
            return EMPTY;
        }));
    }
    // PUT
    updateNonTradeReport(applicationId, bankAccountId, payload) {
        const url = `${this._appSvcUrl}/${applicationId}/bank_accounts/${bankAccountId}/bank_statements/nt_reports`;
        return this._httpClient
            .put(url, {
            ...payload,
        }, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => data.bank_accounts), catchError((err) => {
            console.error(`[updateNonTradeReport] Error updating non-trade reports: ${err}`);
            return EMPTY;
        }));
    }
    clearCache() {
        this._cache = {
            nonTradeReports: [],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NonTradeTransactionsService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NonTradeTransactionsService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NonTradeTransactionsService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class NonTradeTransactionsServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NonTradeTransactionsServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: NonTradeTransactionsServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NonTradeTransactionsServiceModule, providers: [
            {
                provide: NON_TRADE_TRANSACTIONS_SERVICE_TOKEN,
                useClass: NonTradeTransactionsService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NonTradeTransactionsServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: NON_TRADE_TRANSACTIONS_SERVICE_TOKEN,
                            useClass: NonTradeTransactionsService,
                        },
                    ],
                }]
        }] });

class FSWBlobService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._kongUrl = this._utilsService.getKongUrl();
    }
    downloadBlob(id) {
        const url = `${this._kongUrl}/docs_management/v3/document/download`;
        return this._httpClient.get(url, {
            responseType: 'blob',
            params: {
                id,
            },
            headers: setRequestOptions(),
        });
    }
    downloadFileByDmsId(id) {
        const url = `${this._kongUrl}/docs_management/v3/document/download`;
        return this._httpClient.get(url, {
            responseType: 'blob',
            observe: 'response',
            params: {
                id,
            },
            headers: setRequestOptions(),
        });
    }
    downloadFileByDmsUUID(uuid) {
        const url = `${this._kongUrl}/docs_management/v3/document/download/${uuid}`;
        return this._httpClient.get(url, {
            responseType: 'blob',
            observe: 'response',
            headers: setRequestOptions(),
        });
    }
    downloadV3Blob(uuid) {
        const url = `${this._kongUrl}/docs_management/v3/document/download/${uuid}`;
        return this._httpClient.get(url, {
            responseType: 'blob',
            headers: setRequestOptions(),
        });
    }
    deleteSingleDocV3(dmsId) {
        const url = `${this._kongUrl}/docs_management/v3/document/${dmsId}`;
        return this._httpClient
            .delete(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((response) => response));
    }
    getMemberDoc(memberId) {
        const url = `${this._kongUrl}/docs_management/v3/document/member/${memberId}/docs`;
        return this._httpClient
            .get(url, { headers: setRequestOptions() })
            .pipe(map(({ results }) => results));
    }
    getApplicationMemberDoc(applicationId, types = []) {
        const url = `${this._kongUrl}/aps/v1/applications/${applicationId}/members/docs`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => (res?.data?.docs || []).filter((doc) => types.length ? types.includes(doc.doc_type) : true)), map((docs) => docs.map((doc) => doc.dms_id)), switchMap$1((ids) => (ids?.length ? this.getDocsByDMSIds(ids) : of([]))));
    }
    getDocsByDMSIds(ids) {
        const url = `${this._kongUrl}/docs_management/v3/document`;
        return this._httpClient
            .get(url, { headers: setRequestOptions(), params: { ids } })
            .pipe(map(({ results }) => results));
    }
    uploadMemberDoc(payload) {
        const url = `${this._kongUrl}/docs_management/v3/document/upload/single`;
        const formData = new FormData();
        formData.append('file', payload.file);
        formData.append('doc_type', payload.doc_type);
        formData.append('borrower_id', payload.borrower_id.toString());
        return this._httpClient.post(url, formData, { headers: setRequestOptions(false) });
    }
    downloadFile(response, fallbackFilename) {
        const contentDisposition = response.headers.get('Content-Disposition');
        const filename = fallbackFilename || `${Date.now()}`; // Fallback filename
        let ext = 'zip';
        if (contentDisposition) {
            const matches = /filename="([^"]*)"/.exec(contentDisposition);
            if (matches != null && matches[1]) {
                ext = matches[1];
            }
        }
        else {
            const contentType = response.headers.get('Content-Type');
            if (contentType) {
                const matches = contentType.split('/');
                if (matches.length > 1) {
                    ext = matches[1];
                }
            }
        }
        const blob = new Blob([response.body], { type: response.body?.type });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${filename}.${ext}`; // Use the extracted filename
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBlobService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBlobService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBlobService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

const BLOB_SERVICE_TOKEN = new InjectionToken('BLOB_SERVICE_TOKEN');

class FSWBlobServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBlobServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWBlobServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBlobServiceModule, providers: [
            {
                provide: BLOB_SERVICE_TOKEN,
                useClass: FSWBlobService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBlobServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: BLOB_SERVICE_TOKEN,
                            useClass: FSWBlobService,
                        },
                    ],
                }]
        }] });

const provideBlobService = () => {
    return {
        provide: BLOB_SERVICE_TOKEN,
        useClass: FSWBlobService,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
};

const injectBlobService = () => inject(BLOB_SERVICE_TOKEN);

const CREDIT_SERVICE_TOKEN = new InjectionToken('CREDIT_SERVICE_TOKEN');

class FSWCreditService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._cache = {
            creditModel: null,
            ratioAnalysisDetail: null,
        };
        this._creditV2SvcUrl = `${this._utilsService.getKongUrl()}/credit/v2`;
    }
    createCreditModel(payload) {
        const countryCode = getCountryCodeFromStorage()?.toLocaleLowerCase();
        const finalEndpoint = countryCode === 'sg' ? 'digital_scorecard' : 'credit_model';
        const url = `${this._creditV2SvcUrl}/${getCountryCodeFromStorage()?.toLocaleLowerCase()}/ds_integration/${finalEndpoint}`;
        return this._httpClient
            .post(url, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => {
            this._cache.creditModel = data;
            return data;
        }), catchError((err) => {
            console.error(`[createCreditModel]`, err);
            return of(null);
        }));
    }
    getCreditModel(id) {
        const countryCode = getCountryCodeFromStorage()?.toLocaleLowerCase();
        const finalEndpoint = countryCode === 'sg' ? 'digital_scorecard' : 'credit_model';
        const url = `${this._creditV2SvcUrl}/${getCountryCodeFromStorage()?.toLocaleLowerCase()}/ds_integration/${finalEndpoint}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
            params: {
                id,
            },
        })
            .pipe(map((res) => res?.data), catchError((err) => {
            console.error(`[getCreditModel]`, err);
            return throwError(() => `Error: [POST] get credit_model | ${err?.error?.error_description || err?.message}`);
        }));
    }
    // ratio analysis
    // GET ratio analysis detail
    getRatioAnalysis(ratioAnalysisId) {
        return this._httpClient
            .get(`${this._creditV2SvcUrl}/${getCountryCodeFromStorage()?.toLocaleLowerCase() || 'my'}/bank_statements/ratio_analysis/${ratioAnalysisId}`, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => {
            this._cache.ratioAnalysisDetail = data;
            return data;
        }));
    }
    // POST ratio analysis detail
    createRatioAnalysis(payload) {
        return this._httpClient
            .post(`${this._creditV2SvcUrl}/${getCountryCodeFromStorage()?.toLocaleLowerCase() || 'my'}/bank_statements/ratio_analysis`, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => {
            this._cache.ratioAnalysisDetail = data;
            return data;
        }));
    }
    // PUT ratio analysis detail
    updateRatioAnalysis(payload) {
        return this._httpClient
            .put(`${this._creditV2SvcUrl}/${getCountryCodeFromStorage()?.toLocaleLowerCase() || 'my'}/bank_statements/ratio_analysis`, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => {
            this._cache.ratioAnalysisDetail = data;
            return data;
        }));
    }
    // clear cache
    clearCache() {
        this._cache = {
            creditModel: null,
            ratioAnalysisDetail: null,
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCreditService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCreditService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCreditService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class FSWCreditServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCreditServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWCreditServiceModule, imports: [UtilsServiceModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCreditServiceModule, providers: [
            {
                provide: CREDIT_SERVICE_TOKEN,
                useClass: FSWCreditService,
            },
        ], imports: [UtilsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCreditServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: CREDIT_SERVICE_TOKEN,
                            useClass: FSWCreditService,
                        },
                    ],
                    imports: [UtilsServiceModule],
                }]
        }] });

const CREDIT_AGING_REPORT_SERVICE_TOKEN = new InjectionToken('CREDIT_AGING_REPORT_SERVICE_TOKEN');

class CreditAgingReportService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._creditSvcUrl = `${this._utilsService.getKongUrl()}/credit/v2`;
    }
    getReportsByLoanId(loanId, isAP) {
        const url = `${this._creditSvcUrl}/credit_memo/cat/aging_report/loan/${loanId}${isAP ? '/AP' : ''}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.content || []));
    }
    getReportsByMemberId(memberId) {
        const url = `${this._creditSvcUrl}/credit_memo/cat/aging_report/member/${memberId}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.content || []));
    }
    createReportsByLoanId(loanId, data, isAP) {
        const url = `${this._creditSvcUrl}/credit_memo/cat/aging_report/loan/${loanId}${isAP ? '/AP' : ''}`;
        return this._httpClient
            .post(url, data, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.content));
    }
    updateReportsByLoanId(loanId, data, isAP) {
        const url = `${this._creditSvcUrl}/credit_memo/cat/aging_report/loan/${loanId}${isAP ? '/AP' : ''}`;
        return this._httpClient
            .put(url, data, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.content));
    }
    deleteLoanReport(id) {
        const url = `${this._creditSvcUrl}/credit_memo/cat/aging_report/${id}/loan`;
        return this._httpClient
            .delete(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.content));
    }
    createReports(aging_report) {
        const url = `${this._creditSvcUrl}/aging_report`;
        return this._httpClient
            .post(url, {
            aging_report: this.transformCreditToApplication(aging_report),
        }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => this.transformApplicationToCredit(res?.data?.aging_report || [])));
    }
    updateReports(aging_report) {
        const url = `${this._creditSvcUrl}/aging_report`;
        return this._httpClient
            .put(url, {
            aging_report: this.transformCreditToApplication(aging_report),
        }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.content));
    }
    getReportsByIds(ids) {
        const url = `${this._creditSvcUrl}/aging_report`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
            params: {
                ids,
            },
        })
            .pipe(map((res) => this.transformApplicationToCredit(res?.data?.aging_report || [])));
    }
    transformApplicationToCredit(data) {
        return data.map((item) => {
            const value = {
                atDate: item.at_date,
                counterParty: item.counter_party,
                concentration: item.concentration,
                current: Number.parseFloat(item.current?.toString() || '0'),
                days30: Number.parseFloat(item.days30?.toString() || '0'),
                days60: Number.parseFloat(item.days60?.toString() || '0'),
                days90: Number.parseFloat(item.days90?.toString() || '0'),
                greaterThan90: Number.parseFloat(item.greater_than90?.toString() || '0'),
                reliabilityScore: Number.parseFloat(item.reliability_score?.toString() || '0'),
                totalValue: Number.parseFloat(item.total_value?.toString() || '0'),
                yearOfRelationship: Number.parseInt(item.year_of_relationship?.toString() || '0'),
                reportType: item.aging_report_type,
            };
            if (item.id) {
                value.id = item.id;
            }
            return value;
        });
    }
    transformCreditToApplication(data) {
        return data.map((item) => {
            const value = {
                at_date: item.atDate,
                counter_party: item.counterParty,
                concentration: item.concentration,
                current: Number.parseFloat(item.current?.toString() || '0'),
                days30: Number.parseFloat(item.days30?.toString() || '0'),
                days60: Number.parseFloat(item.days60?.toString() || '0'),
                days90: Number.parseFloat(item.days90?.toString() || '0'),
                greater_than90: Number.parseFloat(item.greaterThan90?.toString() || '0'),
                reliability_score: Number.parseFloat(item.reliabilityScore?.toString() || '0'),
                total_value: Number.parseFloat(item.totalValue?.toString() || '0'),
                year_of_relationship: Number.parseInt(item.yearOfRelationship?.toString() || '0'),
                aging_report_type: item.reportType,
            };
            if (item.id) {
                value.id = item.id;
            }
            return value;
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditAgingReportService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditAgingReportService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditAgingReportService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class CreditAgingReportServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditAgingReportServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CreditAgingReportServiceModule, imports: [UtilsServiceModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditAgingReportServiceModule, providers: [
            {
                provide: CREDIT_AGING_REPORT_SERVICE_TOKEN,
                useClass: CreditAgingReportService,
            },
        ], imports: [UtilsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditAgingReportServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: CREDIT_AGING_REPORT_SERVICE_TOKEN,
                            useClass: CreditAgingReportService,
                        },
                    ],
                    imports: [UtilsServiceModule],
                }]
        }] });

const injectCreditAgingReportService = () => inject(CREDIT_AGING_REPORT_SERVICE_TOKEN);

const provideCreditAgingReportService = () => {
    return {
        provide: CREDIT_AGING_REPORT_SERVICE_TOKEN,
        useClass: CreditAgingReportService,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
};

const CREDIT_GUARANTOR_SERVICE_TOKEN = new InjectionToken('CREDIT_GUARANTOR_SERVICE_TOKEN');

class CreditGuarantorService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._creditSvcUrl = `${this._utilsService.getKongUrl()}/credit/v2`;
    }
    ctosExtract(member_id) {
        return this._httpClient
            .post(`${this._creditSvcUrl}/my/guarantor_summary/ctos_extract`, { member_id }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.guarantor_summaries || []), map((guarantor_summaries) => {
            guarantor_summaries.forEach((guarantor_summary) => {
                if (!guarantor_summary.summary) {
                    return;
                }
                const { IndividualSummary, Company } = guarantor_summary.summary;
                guarantor_summary.summary.IndividualSummary =
                    transformPersonalGuarantor(IndividualSummary);
                guarantor_summary.summary.Company = transformCompanyGuarantor({
                    company: Company,
                }).company;
            });
            return guarantor_summaries;
        }));
    }
    extract(payload) {
        return this._httpClient
            .post(`${this._creditSvcUrl}/pg_summary/extraction`, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.summaries || []), map((summaries) => summaries.map((item) => ({
            ...item,
            summary: transformPersonalGuarantor(item.summary),
        }))));
    }
    getPersonalSummaries(ids) {
        return this._httpClient
            .get(`${this._creditSvcUrl}/pg_summary`, {
            headers: setRequestOptions(),
            params: {
                ids,
            },
        })
            .pipe(map((res) => res?.data?.personal_guarantor_summary || []));
    }
    updatePersonalSummaries(personal_guarantor_summary) {
        return this._httpClient.put(`${this._creditSvcUrl}/pg_summary`, {
            personal_guarantor_summary,
        }, {
            headers: setRequestOptions(),
        });
    }
    addPersonalSummaries(personal_guarantor_summary) {
        return this._httpClient
            .post(`${this._creditSvcUrl}/pg_summary`, {
            personal_guarantor_summary,
        }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.personal_guarantor_summary || []));
    }
    getCorporateSummaries(ids) {
        return this._httpClient
            .get(`${this._creditSvcUrl}/cg_summary`, {
            headers: setRequestOptions(),
            params: {
                ids,
            },
        })
            .pipe(map((res) => res?.data?.corporate_guarantor_summary || []));
    }
    updateCorporateSummaries(corporate_guarantor_summary) {
        return this._httpClient.put(`${this._creditSvcUrl}/cg_summary`, {
            corporate_guarantor_summary,
        }, {
            headers: setRequestOptions(),
        });
    }
    addCorporateSummaries(corporate_guarantor_summary) {
        return this._httpClient
            .post(`${this._creditSvcUrl}/cg_summary`, {
            corporate_guarantor_summary,
        }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.corporate_guarantor_summary || []));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditGuarantorService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditGuarantorService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditGuarantorService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class CreditGuarantorServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditGuarantorServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CreditGuarantorServiceModule, imports: [UtilsServiceModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditGuarantorServiceModule, providers: [
            {
                provide: CREDIT_GUARANTOR_SERVICE_TOKEN,
                useClass: CreditGuarantorService,
            },
        ], imports: [UtilsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditGuarantorServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: CREDIT_GUARANTOR_SERVICE_TOKEN,
                            useClass: CreditGuarantorService,
                        },
                    ],
                    imports: [UtilsServiceModule],
                }]
        }] });

const provideCreditGuarantorService = () => {
    return {
        provide: CREDIT_GUARANTOR_SERVICE_TOKEN,
        useClass: CreditGuarantorService,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
};

const injectCreditGuarantorService = () => inject(CREDIT_GUARANTOR_SERVICE_TOKEN);

const CREDIT_FACILITY_TERMS_SERVICE_TOKEN = new InjectionToken('CREDIT_FACILITY_TERMS_SERVICE_TOKEN');

class CreditFacilityTermsService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._creditSvcUrl = `${this._utilsService.getKongUrl()}/credit/v2/loan_facility_terms`;
    }
    getFacilityTermsById(id) {
        return this._httpClient
            .get(`${this._creditSvcUrl}/${id}`, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.loan_facility_terms));
    }
    updateFacilityTerms(id, loan_facility_terms) {
        return this._httpClient
            .put(`${this._creditSvcUrl}/${id}`, {
            loan_facility_terms,
        }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.loan_facility_terms));
    }
    addFacilityTerms(loan_facility_terms) {
        return this._httpClient
            .post(`${this._creditSvcUrl}`, {
            loan_facility_terms,
        }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.loan_facility_terms));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditFacilityTermsService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditFacilityTermsService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditFacilityTermsService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class CreditFacilityTermsServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditFacilityTermsServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CreditFacilityTermsServiceModule, imports: [UtilsServiceModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditFacilityTermsServiceModule, providers: [
            {
                provide: CREDIT_FACILITY_TERMS_SERVICE_TOKEN,
                useClass: CreditFacilityTermsService,
            },
        ], imports: [UtilsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditFacilityTermsServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: CREDIT_FACILITY_TERMS_SERVICE_TOKEN,
                            useClass: CreditFacilityTermsService,
                        },
                    ],
                    imports: [UtilsServiceModule],
                }]
        }] });

const injectCreditFacilityTermsService = () => inject(CREDIT_FACILITY_TERMS_SERVICE_TOKEN);

const provideCreditFacilityTermsService = () => {
    return {
        provide: CREDIT_FACILITY_TERMS_SERVICE_TOKEN,
        useClass: CreditFacilityTermsService,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
};

const CREDIT_PROJECT_LISTING_SERVICE_TOKEN = new InjectionToken('CREDIT_PROJECT_LISTING_SERVICE_TOKEN');

class CreditProjectListingService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._creditSvcUrl = `${this._utilsService.getKongUrl()}/credit/v2`;
    }
    getList(ids) {
        const url = `${this._creditSvcUrl}/project_listing`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
            params: {
                ids,
            },
        })
            .pipe(map((res) => res?.data?.project_listing.map((item) => this.convertSnakeCaseToCamelCase(item))));
    }
    createList(data) {
        const url = `${this._creditSvcUrl}/project_listing`;
        return this._httpClient
            .post(url, {
            project_listing: data.map((item) => this.convertCamelCaseToSnakeCase(item)),
        }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.project_listing.map((item) => this.convertSnakeCaseToCamelCase(item))));
    }
    updateList(data) {
        const url = `${this._creditSvcUrl}/project_listing`;
        return this._httpClient
            .put(url, {
            project_listing: data.map((item) => this.convertCamelCaseToSnakeCase(item)),
        }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.project_listing.map((item) => this.convertSnakeCaseToCamelCase(item))));
    }
    getListByLoan(loanId) {
        const url = `${this._creditSvcUrl}/credit_memo/cat/project_listing/loan${loanId}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.content));
    }
    createListByLoan(loanId, data) {
        const url = `${this._creditSvcUrl}/credit_memo/cat/project_listing/loan${loanId}`;
        return this._httpClient
            .post(url, data, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.content));
    }
    updateListByLoan(loanId, data) {
        const url = `${this._creditSvcUrl}/credit_memo/cat/project_listing/loan${loanId}`;
        return this._httpClient
            .put(url, data, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.content));
    }
    delete(id) {
        const url = `${this._creditSvcUrl}/credit_memo/cat/project_listing/${id}/loan}`;
        return this._httpClient.delete(url, {
            headers: setRequestOptions(),
        });
    }
    convertSnakeCaseToCamelCase(data) {
        return {
            id: data.id,
            projectName: data.project_name,
            projectDescription: data.project_description,
            counterParty: data.counter_party,
            startAt: data.start_at,
            endAt: data.end_at,
            isProjectCompleted: data.is_project_completed,
            completePercentage: data.complete_percentage,
            contractAmount: data.contract_amount,
            outstandingAmount: data.outstanding_amount,
            reliabilityScore: data.reliability_score,
            remark: data.remark,
        };
    }
    convertCamelCaseToSnakeCase(data) {
        return {
            id: data.id,
            project_name: data.projectName,
            project_description: data.projectDescription,
            counter_party: data.counterParty,
            start_at: data.startAt,
            end_at: data.endAt,
            is_project_completed: data.isProjectCompleted,
            complete_percentage: data.completePercentage,
            contract_amount: data.contractAmount,
            outstanding_amount: data.outstandingAmount,
            reliability_score: data.reliabilityScore,
            remark: data.remark,
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditProjectListingService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditProjectListingService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditProjectListingService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class CreditProjectListingServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditProjectListingServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CreditProjectListingServiceModule, imports: [UtilsServiceModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditProjectListingServiceModule, providers: [
            {
                provide: CREDIT_PROJECT_LISTING_SERVICE_TOKEN,
                useClass: CreditProjectListingService,
            },
        ], imports: [UtilsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditProjectListingServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: CREDIT_PROJECT_LISTING_SERVICE_TOKEN,
                            useClass: CreditProjectListingService,
                        },
                    ],
                    imports: [UtilsServiceModule],
                }]
        }] });

const CREDIT_REPAYMENT_SCHEDULE_SERVICE_TOKEN = new InjectionToken('CREDIT_REPAYMENT_SCHEDULE_SERVICE_TOKEN');

class CreditRepaymentScheduleService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._creditSvcUrl = `${this._utilsService.getKongUrl()}/credit/v2/repayment_schedule`;
    }
    getById(id) {
        const url = `${this._creditSvcUrl}/${id}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.repayment_schedule));
    }
    update(id, repayment_schedule) {
        const url = `${this._creditSvcUrl}/${id}`;
        return this._httpClient
            .put(url, {
            repayment_schedule,
        }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.repayment_schedule));
    }
    create(repayment_schedule) {
        const url = `${this._creditSvcUrl}`;
        return this._httpClient
            .post(url, {
            repayment_schedule,
        }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.repayment_schedule));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditRepaymentScheduleService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditRepaymentScheduleService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditRepaymentScheduleService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class CreditRepaymentScheduleServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditRepaymentScheduleServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CreditRepaymentScheduleServiceModule, imports: [UtilsServiceModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditRepaymentScheduleServiceModule, providers: [
            {
                provide: CREDIT_REPAYMENT_SCHEDULE_SERVICE_TOKEN,
                useClass: CreditRepaymentScheduleService,
            },
        ], imports: [UtilsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditRepaymentScheduleServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: CREDIT_REPAYMENT_SCHEDULE_SERVICE_TOKEN,
                            useClass: CreditRepaymentScheduleService,
                        },
                    ],
                    imports: [UtilsServiceModule],
                }]
        }] });

const injectCreditRepaymentScheduleService = () => inject(CREDIT_REPAYMENT_SCHEDULE_SERVICE_TOKEN);

const provideCreditRepaymentScheduleService = () => {
    return {
        provide: CREDIT_REPAYMENT_SCHEDULE_SERVICE_TOKEN,
        useClass: CreditRepaymentScheduleService,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
};

const CREDIT_SCORING_SERVICE_TOKEN = new InjectionToken('CREDIT_SCORING_SERVICE_TOKEN');

class CreditScoringService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._creditSvcUrl = `${this._utilsService.getKongUrl()}/credit/v2/credit_scoring`;
    }
    getLatestRuleBasedByApplication(applicationId) {
        throw new Error('this API call function does not implement yet');
    }
    getAssessments(loanId) {
        return this._httpClient
            .get(`${this._creditSvcUrl}/assessment_factors/loan/${loanId}`, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.content || []));
    }
    reloadAssessments(loanId) {
        return this._httpClient.post(`${this._creditSvcUrl}/assessment_factors/reload/my`, {
            loanId,
        }, {
            headers: setRequestOptions(),
        });
    }
    saveAssessments(loanId, data) {
        return this._httpClient.put(`${this._creditSvcUrl}/assessment_factors/loan/${loanId}`, data, {
            headers: setRequestOptions(),
        });
    }
    getLatestRuleBasedByLoan(loanId) {
        return this._httpClient
            .get(`${this._creditSvcUrl}/rule_based/loan/${loanId}/task/latest`, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ content }) => content));
    }
    submitTaskRuleBasedByApplication(applicationId, factors) {
        throw new Error('this API call function does not implement yet');
    }
    submitTaskRuleBasedByLoan(loanId, factors) {
        return this._httpClient
            .post(`${this._creditSvcUrl}/rule_based/task`, {
            loanId,
            factors,
        }, { headers: setRequestOptions() })
            .pipe(map(({ content }) => content));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditScoringService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditScoringService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditScoringService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class CreditScoringServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditScoringServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CreditScoringServiceModule, imports: [UtilsServiceModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditScoringServiceModule, providers: [
            {
                provide: CREDIT_SCORING_SERVICE_TOKEN,
                useClass: CreditScoringService,
            },
        ], imports: [UtilsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditScoringServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: CREDIT_SCORING_SERVICE_TOKEN,
                            useClass: CreditScoringService,
                        },
                    ],
                    imports: [UtilsServiceModule],
                }]
        }] });

const CREDIT_MODEL_SERVICE_TOKEN = new InjectionToken('CREDIT_MODEL_SERVICE_TOKEN');

class CreditModelService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this.kongUrl = this._utilsService.getKongUrl();
    }
    getCreditModelByLoan(loanId) {
        return this._httpClient.get(`${this.kongUrl}/credit/v2/ds_integration/my/credit_model/loan/${loanId}`, {
            headers: setRequestOptions(),
        });
    }
    getCreditModelByApplication(applicationId) {
        throw new Error('This API call function not implemented yet.');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditModelService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditModelService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditModelService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class CreditModelServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditModelServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CreditModelServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditModelServiceModule, providers: [
            {
                provide: CREDIT_MODEL_SERVICE_TOKEN,
                useClass: CreditModelService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditModelServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: CREDIT_MODEL_SERVICE_TOKEN,
                            useClass: CreditModelService,
                        },
                    ],
                }]
        }] });

const provideCreditModelService = () => {
    return {
        provide: CREDIT_MODEL_SERVICE_TOKEN,
        useClass: CreditModelService,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
};

const injectCreditModelService = () => inject(CREDIT_MODEL_SERVICE_TOKEN);

const CREDIT_TEST_BUCKET_SERVICE_TOKEN = new InjectionToken('CREDIT_TEST_BUCKET_SERVICE_TOKEN');

class CreditTestBucketService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._creditSvcUrl = `${this._utilsService.getKongUrl()}/credit/v2/test_bucket`;
    }
    getTestBuckets() {
        return this._httpClient
            .get(`${this._creditSvcUrl}`, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.content || []));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditTestBucketService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditTestBucketService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditTestBucketService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class CreditTestBucketServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditTestBucketServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CreditTestBucketServiceModule, imports: [UtilsServiceModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditTestBucketServiceModule, providers: [
            {
                provide: CREDIT_TEST_BUCKET_SERVICE_TOKEN,
                useClass: CreditTestBucketService,
            },
        ], imports: [UtilsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditTestBucketServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: CREDIT_TEST_BUCKET_SERVICE_TOKEN,
                            useClass: CreditTestBucketService,
                        },
                    ],
                    imports: [UtilsServiceModule],
                }]
        }] });

const injectCreditTestBucketService = () => inject(CREDIT_TEST_BUCKET_SERVICE_TOKEN);

const provideCreditTestBucketService = () => {
    return {
        provide: CREDIT_TEST_BUCKET_SERVICE_TOKEN,
        useClass: CreditTestBucketService,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
};

const CREDIT_EXPOSURE_SERVICE_TOKEN = new InjectionToken('CREDIT_EXPOSURE_SERVICE_TOKEN');

class CreditExposureService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._creditSvcUrl = `${this._utilsService.getKongUrl()}/credit/v2/exposure`;
        this._creditV2SvcUrl = `${this._utilsService.getKongUrl()}/credit/v2/v2/exposure`;
    }
    getExposure(id) {
        return this._httpClient
            .get(`${this._creditSvcUrl}/${id}`, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    getExposureV2(id) {
        return this._httpClient
            .get(`${this._creditV2SvcUrl}/${id}`, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    calculateExposure(data) {
        return this._httpClient
            .post(`${this._creditSvcUrl}`, data, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    calculateExposureV2(data) {
        return this._httpClient
            .post(`${this._creditV2SvcUrl}`, data, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    refreshExposure(data) {
        return this._httpClient
            .put(`${this._creditSvcUrl}`, data, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    updateExposureRemark(data) {
        return this._httpClient
            .put(`${this._creditSvcUrl}/${data.id}/remarks`, data, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditExposureService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditExposureService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditExposureService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class CreditExposureServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditExposureServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CreditExposureServiceModule, imports: [UtilsServiceModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditExposureServiceModule, providers: [
            {
                provide: CREDIT_EXPOSURE_SERVICE_TOKEN,
                useClass: CreditExposureService,
            },
        ], imports: [UtilsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditExposureServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: CREDIT_EXPOSURE_SERVICE_TOKEN,
                            useClass: CreditExposureService,
                        },
                    ],
                    imports: [UtilsServiceModule],
                }]
        }] });

const injectCreditExposureService = () => inject(CREDIT_EXPOSURE_SERVICE_TOKEN);

const provideCreditExposureService = () => {
    return {
        provide: CREDIT_EXPOSURE_SERVICE_TOKEN,
        useClass: CreditExposureService,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
};

const CREDIT_OUTSTANDING_LOANS_SERVICE_TOKEN = new InjectionToken('CREDIT_OUTSTANDING_LOANS_SERVICE_TOKEN');

class CreditOutstandingLoansService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._creditSvcUrl = `${this._utilsService.getKongUrl()}/credit/v2/outstanding_loan`;
    }
    getOutstandingLoans(ids) {
        return this._httpClient
            .get(`${this._creditSvcUrl}`, {
            headers: setRequestOptions(),
            params: {
                ids,
            },
        })
            .pipe(map((res) => res?.data?.outstanding_loan || []));
    }
    addOutstandingLoans(outstanding_loan) {
        return this._httpClient
            .post(`${this._creditSvcUrl}`, {
            outstanding_loan,
        }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.outstanding_loan || []));
    }
    updateOutstandingLoans(outstanding_loan) {
        return this._httpClient
            .put(`${this._creditSvcUrl}`, {
            outstanding_loan,
        }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.outstanding_loan || []));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditOutstandingLoansService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditOutstandingLoansService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditOutstandingLoansService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class CreditOutstandingLoansServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditOutstandingLoansServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CreditOutstandingLoansServiceModule, imports: [UtilsServiceModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditOutstandingLoansServiceModule, providers: [
            {
                provide: CREDIT_OUTSTANDING_LOANS_SERVICE_TOKEN,
                useClass: CreditOutstandingLoansService,
            },
        ], imports: [UtilsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditOutstandingLoansServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: CREDIT_OUTSTANDING_LOANS_SERVICE_TOKEN,
                            useClass: CreditOutstandingLoansService,
                        },
                    ],
                    imports: [UtilsServiceModule],
                }]
        }] });

const CREDIT_SCREENING_RESULT_SERVICE_TOKEN = new InjectionToken('CREDIT_SCREENING_RESULT_SERVICE_TOKEN');

class CreditScreeningResultService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._creditSvcUrl = `${this._utilsService.getKongUrl()}/credit/v2/screening`;
    }
    upsert(payload) {
        return this._httpClient
            .post(`${this._creditSvcUrl}`, payload)
            .pipe(map((res) => res?.content ?? []));
    }
    updateJustification(payload) {
        return this._httpClient.post(`${this._creditSvcUrl}`, payload);
    }
    getByLoan(payload) {
        return this._httpClient
            .get(`${this._creditSvcUrl}/loan/${payload.loanId}`, {
            params: {
                stageName: payload.stageName,
            },
        })
            .pipe(map((res) => res?.content ?? []));
    }
    getByApplication(payload) {
        return this._httpClient
            .get(`${this._creditSvcUrl}/application/${payload.applicationId}`, {
            params: {
                stageName: payload.stageName,
            },
        })
            .pipe(map((res) => res?.content ?? []));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditScreeningResultService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditScreeningResultService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditScreeningResultService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class CreditScreeningResultServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditScreeningResultServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CreditScreeningResultServiceModule, imports: [UtilsServiceModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditScreeningResultServiceModule, providers: [
            {
                provide: CREDIT_SCREENING_RESULT_SERVICE_TOKEN,
                useClass: CreditScreeningResultService,
            },
        ], imports: [UtilsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditScreeningResultServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: CREDIT_SCREENING_RESULT_SERVICE_TOKEN,
                            useClass: CreditScreeningResultService,
                        },
                    ],
                    imports: [UtilsServiceModule],
                }]
        }] });

const SCORECARD_SERVICE_TOKEN = new InjectionToken('SCORECARD_SERVICE_TOKEN');

class ScorecardService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._cache = {
            scorecardContent: null,
        };
        this._creditSvcUrl = `${this._utilsService.getKongUrl()}/credit/v2`;
    }
    // PUT
    updateScorecardContent(payload) {
        const url = `${this._creditSvcUrl}/scorecard/task`;
        return this._httpClient
            .put(url, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data), catchError((err) => {
            console.error(`[createScorecardContent]`, err);
            return EMPTY;
        }));
    }
    // POST
    createScorecardContent(payload) {
        const url = `${this._creditSvcUrl}/scorecard/task`;
        return this._httpClient
            .post(url, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data), catchError((err) => {
            console.error(`[createScorecardContent]`, err);
            return EMPTY;
        }));
    }
    // GET
    getScorecardContent(scorecard_id, updateCache = false) {
        if (this._cache.scorecardContent && !updateCache) {
            return of(this._cache.scorecardContent);
        }
        const url = `${this._creditSvcUrl}/scorecard/task?ids=${scorecard_id}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => {
            if (!res?.data?.rule_based_credit_scoring?.length)
                return {};
            const scorecardContent = res.data.rule_based_credit_scoring[0];
            this._cache.scorecardContent = scorecardContent;
            return scorecardContent;
        }), catchError((err) => {
            console.error(`[getScorecardContent]`, err);
            return EMPTY;
        }));
    }
    getScorecardFactors(identifiers) {
        const url = `${this._creditSvcUrl}/manual_scorecard/master/factors`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
            params: {
                identifiers: identifiers.join(','),
            },
        })
            .pipe(map((res) => res?.data?.factors || []), catchError((err) => {
            console.error(`[getScorecardFactors]`, err);
            return EMPTY;
        }));
    }
    getScorecardDetail(scorecard_id) {
        const url = `${this._creditSvcUrl}/manual_scorecard/${scorecard_id}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data), catchError((err) => {
            console.error(`[getScorecardDetail]`, err);
            return EMPTY;
        }));
    }
    createScorecard(payload) {
        const url = `${this._creditSvcUrl}/manual_scorecard`;
        return this._httpClient
            .post(url, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data), catchError((err) => {
            console.error(`[createScorecard]`, err);
            return EMPTY;
        }));
    }
    generateBNPLScorecard(payload) {
        const url = `${this._creditSvcUrl}/scorecard/b2b`;
        return this._httpClient
            .post(url, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data), catchError((err) => {
            console.error(`[generateBNPLScorecard]`, err);
            return EMPTY;
        }));
    }
    getBNPLScorecard(scorecard_id) {
        const url = `${this._creditSvcUrl}/scorecard/b2b/${scorecard_id}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data), catchError((err) => {
            console.error(`[getBNPLScorecard]`, err);
            return EMPTY;
        }));
    }
    clearCache() {
        this._cache = {
            scorecardContent: null,
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ScorecardService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ScorecardService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ScorecardService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class ScorecardServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ScorecardServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ScorecardServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ScorecardServiceModule, providers: [
            {
                provide: SCORECARD_SERVICE_TOKEN,
                useClass: ScorecardService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ScorecardServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: SCORECARD_SERVICE_TOKEN,
                            useClass: ScorecardService,
                        },
                    ],
                }]
        }] });

const CREDIT_COMMENT_SERVICE_TOKEN = new InjectionToken('CREDIT_COMMENT_SERVICE_TOKEN');

class CreditCommentService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._creditSvcUrl = `${this._utilsService.getKongUrl()}/credit/v2/comments`;
    }
    getComments(ids, modules) {
        return this._httpClient
            .get(`${this._creditSvcUrl}`, {
            headers: setRequestOptions(),
            params: {
                ids,
                modules,
            },
        })
            .pipe(map((res) => res?.data?.comments || []));
    }
    addComments(comments) {
        return this._httpClient
            .post(`${this._creditSvcUrl}`, {
            comments,
        }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.comments || []));
    }
    updateComments(comments) {
        return this._httpClient
            .put(`${this._creditSvcUrl}`, {
            comments,
        }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.comments || []));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditCommentService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditCommentService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditCommentService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class CreditCommentServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditCommentServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CreditCommentServiceModule, imports: [UtilsServiceModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditCommentServiceModule, providers: [
            {
                provide: CREDIT_COMMENT_SERVICE_TOKEN,
                useClass: CreditCommentService,
            },
        ], imports: [UtilsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditCommentServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: CREDIT_COMMENT_SERVICE_TOKEN,
                            useClass: CreditCommentService,
                        },
                    ],
                    imports: [UtilsServiceModule],
                }]
        }] });

const injectCreditCommentService = () => inject(CREDIT_COMMENT_SERVICE_TOKEN);

const provideCreditCommentService = () => {
    return {
        provide: CREDIT_COMMENT_SERVICE_TOKEN,
        useClass: CreditCommentService,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
};

const CREDIT_PRE_SCREENING_SERVICE_TOKEN = new InjectionToken('CREDIT_PRE_SCREENING_SERVICE_TOKEN');

class CreditPreScreeningService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._creditSvcUrl = `${this._utilsService.getKongUrl()}/credit/v2/pre_screenings/rulify`;
    }
    getById(id) {
        const url = `${this._creditSvcUrl}/${id}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    updateJustifications(id, data) {
        const url = `${this._creditSvcUrl}/${id}/justifications`;
        return this._httpClient
            .put(url, data, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    triggerRulify(data) {
        const url = `${this._creditSvcUrl}`;
        return this._httpClient
            .post(url, data, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditPreScreeningService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditPreScreeningService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditPreScreeningService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class CreditPreScreeningServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditPreScreeningServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CreditPreScreeningServiceModule, imports: [UtilsServiceModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditPreScreeningServiceModule, providers: [
            {
                provide: CREDIT_PRE_SCREENING_SERVICE_TOKEN,
                useClass: CreditPreScreeningService,
            },
        ], imports: [UtilsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditPreScreeningServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: CREDIT_PRE_SCREENING_SERVICE_TOKEN,
                            useClass: CreditPreScreeningService,
                        },
                    ],
                    imports: [UtilsServiceModule],
                }]
        }] });

const injectCreditPreScreeningService = () => inject(CREDIT_PRE_SCREENING_SERVICE_TOKEN);

const provideCreditPreScreeningService = () => {
    return {
        provide: CREDIT_PRE_SCREENING_SERVICE_TOKEN,
        useClass: CreditPreScreeningService,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
};

const CREDIT_SALES_SUMMARY_SERVICE_TOKEN = new InjectionToken('CREDIT_SALES_SUMMARY_SERVICE_TOKEN');

class CreditSalesSummaryService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._creditSvcUrl = `${this._utilsService.getKongUrl()}/credit/v2/sales_summary`;
    }
    getById(id, include = 'ACCOUNTS,PORS') {
        return this._httpClient
            .get(`${this._creditSvcUrl}/${id}`, {
            headers: setRequestOptions(),
            params: {
                include,
            },
        })
            .pipe(map((res) => res?.data));
    }
    create(payload) {
        return this._httpClient
            .post(`${this._creditSvcUrl}`, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    update(id, payload) {
        return this._httpClient
            .put(`${this._creditSvcUrl}/${id}`, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    updateAccount(id, payload) {
        return this._httpClient
            .put(`${this._creditSvcUrl}/${id}/accounts/${payload.id}`, omit(payload, 'id'), {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    deleteAccount(id, accountId) {
        return this._httpClient.delete(`${this._creditSvcUrl}/${id}/accounts/${accountId}`, {
            headers: setRequestOptions(),
        });
    }
    createAccount(id, payload) {
        return this._httpClient
            .post(`${this._creditSvcUrl}/${id}/accounts`, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    updatePor(id, payload) {
        return this._httpClient
            .put(`${this._creditSvcUrl}/${id}/pors/${payload.year}`, omit(payload, 'year'), {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    updateWorkingCapital(id, payload) {
        return this._httpClient
            .put(`${this._creditSvcUrl}/${id}/working_capital/${payload.year}`, omit(payload, 'year'), {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditSalesSummaryService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditSalesSummaryService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditSalesSummaryService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class CreditSalesSummaryServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditSalesSummaryServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CreditSalesSummaryServiceModule, imports: [UtilsServiceModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditSalesSummaryServiceModule, providers: [
            {
                provide: CREDIT_SALES_SUMMARY_SERVICE_TOKEN,
                useClass: CreditSalesSummaryService,
            },
        ], imports: [UtilsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditSalesSummaryServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: CREDIT_SALES_SUMMARY_SERVICE_TOKEN,
                            useClass: CreditSalesSummaryService,
                        },
                    ],
                    imports: [UtilsServiceModule],
                }]
        }] });

const CREDIT_POLICY_CHECKLIST_SERVICE_TOKEN = new InjectionToken('CREDIT_POLICY_CHECKLIST_SERVICE_TOKEN');

class CreditPolicyChecklistService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._creditSvcUrl = `${this._utilsService.getKongUrl()}/credit/v2`;
    }
    addPolicyCheckList(data) {
        return this._httpClient
            .post(`${this._creditSvcUrl}/policy_checklist`, { data }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    updatePolicyCheckList(id, data) {
        return this._httpClient
            .put(`${this._creditSvcUrl}/policy_checklist/${id}`, { data }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    getPolicyCheckList(id) {
        return this._httpClient
            .get(`${this._creditSvcUrl}/policy_checklist/${id}`, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    getListPolicies() {
        return this._httpClient
            .get(`${this._creditSvcUrl}/policy_checklist/master_policies`, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.policies || []));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditPolicyChecklistService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditPolicyChecklistService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditPolicyChecklistService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class CreditPolicyChecklistServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditPolicyChecklistServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CreditPolicyChecklistServiceModule, imports: [UtilsServiceModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditPolicyChecklistServiceModule, providers: [
            {
                provide: CREDIT_POLICY_CHECKLIST_SERVICE_TOKEN,
                useClass: CreditPolicyChecklistService,
            },
        ], imports: [UtilsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditPolicyChecklistServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: CREDIT_POLICY_CHECKLIST_SERVICE_TOKEN,
                            useClass: CreditPolicyChecklistService,
                        },
                    ],
                    imports: [UtilsServiceModule],
                }]
        }] });

function injectCreditPolicyChecklistService(injector) {
    !injector && assertInInjectionContext(injectCreditPolicyChecklistService);
    const assertedInjector = injector ?? inject(Injector);
    return assertedInjector.get(CREDIT_POLICY_CHECKLIST_SERVICE_TOKEN);
}

function provideCreditPolicyChecklistService() {
    return {
        provide: CREDIT_POLICY_CHECKLIST_SERVICE_TOKEN,
        useClass: CreditPolicyChecklistService,
    };
}

class CreditBorrowerSummaryService {
    constructor() {
        this._httpClient = inject(HttpClient);
        this._utilsService = injectUtilsService();
        this._creditV2Url = `${this._utilsService.getKongUrl()}/credit/v2`;
    }
    /**
     * Get Borrower Summary
     * @param id {string}
     * @returns Observable<IFSWCreditCompanyGuarantor>
     * @memberof CreditBorrowerSummaryService
     * @description Get Borrower Summary data by id
     * @example getById('1234')
     */
    getById(id) {
        const url = `${this._creditV2Url}/borrower_summary/${id}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => transformCompanyGuarantor(res?.data)));
    }
    /**
     * Create Borrower Summary
     * @param company {IFSWCreditCompanyGuarantorCompany}
     * @returns Observable<IFSWCreditCompanyGuarantor>
     * @memberof CreditBorrowerSummaryService
     * @description Create Borrower Summary
     * @example create({ ...borrowerCTOS })
     */
    create(company) {
        const url = `${this._creditV2Url}/borrower_summary`;
        return this._httpClient
            .post(url, { company }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    /**
     * Update Borrower Summary
     * @param id {string}
     * @param company {IFSWCreditCompanyGuarantorCompany}
     * @returns Observable<IFSWCreditCompanyGuarantor>
     * @memberof CreditBorrowerSummaryService
     * @description Update Borrower Summary
     * @example update('1234', { ...borrowerCTOS })
     */
    update(id, company) {
        const url = `${this._creditV2Url}/borrower_summary/${id}`;
        return this._httpClient
            .put(url, { company }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    /**
     * POST CTOS Extract
     * @param member_id {number}
     * @returns Observable<IFSWCreditCompanyGuarantorCompany>
     * @memberof CreditBorrowerSummaryService
     * @description Extract CTOS
     * @example extractCtos(1234)
     */
    // BE team wanted this to be a POST request
    extractCtos(member_id) {
        const url = `${this._creditV2Url}/my/borrower_summary/ctos_extract`;
        return this._httpClient
            .post(url, { member_id }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => transformCompanyGuarantor(res?.data)?.company));
    }
    /**
     * POST Questnet Extract
     * @param payload {IFSWCreditCompanyGuarantorSummaryExtraction}
     * @returns Observable<IFSWCreditCompanyGuarantorCompany>
     * @memberof CreditBorrowerSummaryService
     * @description Extract CTOS/Questnet
     * @example extract({ ...payload })
     */
    // BE team wanted this to be a POST request
    extract(payload) {
        const url = `${this._creditV2Url}/borrower_summary/extraction`;
        return this._httpClient
            .post(url, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => transformCompanyGuarantor(res?.data)?.company));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditBorrowerSummaryService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditBorrowerSummaryService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditBorrowerSummaryService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

const CREDIT_BORROWER_SUMMARY_SERVICE_TOKEN = new InjectionToken('CREDIT_BORROWER_SUMMARY_SERVICE_TOKEN');

const provideCreditBorrowerSummaryService = () => {
    return {
        provide: CREDIT_BORROWER_SUMMARY_SERVICE_TOKEN,
        useClass: CreditBorrowerSummaryService,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
};

const injectCreditBorrowerSummaryService = () => inject(CREDIT_BORROWER_SUMMARY_SERVICE_TOKEN);

const REFERENCE_SERVICE_TOKEN = new InjectionToken('REFERENCE_SERVICE_TOKEN');

class ReferenceService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._industrySvcUrl = `${this._utilsService.getKongUrl()}/v2/sub_industries/industry`;
        this._memberReferenceSvcUrl = `${this._utilsService.getKongUrl()}/ms/members`;
    }
    getSubIndustries(id) {
        return this._httpClient
            .get(`${this._industrySvcUrl}/${id}`, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    getReference(code) {
        return this._httpClient
            .get(`${this._memberReferenceSvcUrl}/${code}/references`, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ReferenceService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ReferenceService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ReferenceService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class ReferenceServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ReferenceServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ReferenceServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ReferenceServiceModule, providers: [
            {
                provide: REFERENCE_SERVICE_TOKEN,
                useClass: ReferenceService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ReferenceServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: REFERENCE_SERVICE_TOKEN,
                            useClass: ReferenceService,
                        },
                    ],
                }]
        }] });

const FSW_PRODUCT_SERVICE_TOKEN = new InjectionToken('FSW_PRODUCT_SERVICE_TOKEN');

class FSWProductService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._productSvcUrl = `${this._utilsService.getKongUrl()}/ln/v2/products`;
    }
    getProducts(params = {}) {
        const url = `${this._productSvcUrl}`;
        return this._httpClient
            .get(url, {
            params,
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data || []));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class FSWProductServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWProductServiceModule, imports: [UtilsServiceModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductServiceModule, providers: [
            {
                provide: FSW_PRODUCT_SERVICE_TOKEN,
                useClass: FSWProductService,
            },
        ], imports: [UtilsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: FSW_PRODUCT_SERVICE_TOKEN,
                            useClass: FSWProductService,
                        },
                    ],
                    imports: [UtilsServiceModule],
                }]
        }] });

const RATIO_ANALYSIS_SERVICE_TOKEN = new InjectionToken('RATIO_ANALYSIS_SERVICE_TOKEN');

class RatioAnalysisService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._cache = {
            ratioAnalysis: [],
        };
        this._creditSvcUrl = `${this._utilsService.getKongUrl()}/credit/v2`;
    }
    // PUT
    updateRatioAnalysis(financialStatementId, payload) {
        const url = `${this._creditSvcUrl}/${getCountryCodeFromStorage()?.toLocaleLowerCase() || 'my'}/financial_statements/${financialStatementId}/ratio_analysis`;
        return this._httpClient.put(url, payload, { headers: setRequestOptions() }).pipe(catchError((err) => {
            console.error(`[updateRatioAnalysis]`, err);
            return EMPTY;
        }));
    }
    // POST
    createRatioAnalysis(financialStatementId, payload) {
        const url = `${this._creditSvcUrl}/${getCountryCodeFromStorage()?.toLocaleLowerCase() || 'my'}/financial_statements/${financialStatementId}/ratio_analysis`;
        return this._httpClient.post(url, payload, { headers: setRequestOptions() }).pipe(catchError((err) => {
            console.error(`[createRatioAnalysis]`, err);
            return EMPTY;
        }));
    }
    // GET
    getRatioAnalysis(financialStatementId, updateCache = false) {
        if (this._cache.ratioAnalysis?.length && !updateCache) {
            return of(this._cache.ratioAnalysis);
        }
        const url = `${this._creditSvcUrl}/${getCountryCodeFromStorage()?.toLocaleLowerCase() || 'my'}/financial_statements/${financialStatementId}/ratio_analysis`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => {
            if (!res?.data?.ratio_analysis)
                return [];
            this._cache.ratioAnalysis = res.data.ratio_analysis;
            return res.data.ratio_analysis;
        }), catchError((err) => {
            console.error(`[getRatioAnalysis]`, err);
            return EMPTY;
        }));
    }
    clearCache() {
        this._cache = {
            ratioAnalysis: [],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RatioAnalysisService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RatioAnalysisService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RatioAnalysisService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class RatioAnalysisServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RatioAnalysisServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: RatioAnalysisServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RatioAnalysisServiceModule, providers: [
            {
                provide: RATIO_ANALYSIS_SERVICE_TOKEN,
                useClass: RatioAnalysisService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RatioAnalysisServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: RATIO_ANALYSIS_SERVICE_TOKEN,
                            useClass: RatioAnalysisService,
                        },
                    ],
                }]
        }] });

const FINANCIAL_STATEMENT_SERVICE_TOKEN = new InjectionToken('FINANCIAL_STATEMENT_SERVICE_TOKEN');

class FinancialStatementService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._cache = {
            fsMetadata: null,
            fsId: null,
        };
        this._creditSvcUrl = `${this._utilsService.getKongUrl()}/credit/v2`;
        this._appSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/applications`;
    }
    // GET
    getFinancialStatementMetadata(financialStatementId, updateCache = false) {
        if (this._cache.fsMetadata && !updateCache) {
            return of(this._cache.fsMetadata);
        }
        const url = `${this._creditSvcUrl}/${getCountryCodeFromStorage()?.toLocaleLowerCase() || 'my'}/financial_statements/${financialStatementId}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => {
            this._cache.fsMetadata = res?.data;
            return res?.data;
        }), catchError((err) => {
            console.error(`[getFinancialStatementMetadata]`, err);
            return throwError(() => `Error: [getFinancialStatementMetadata] financial statement metadata`);
        }));
    }
    // GET
    getFinancialStatementId(applicationId, updateCache = false) {
        if (this._cache.fsMetadata && !updateCache) {
            return of(this._cache.fsId);
        }
        const url = `${this._appSvcUrl}/${applicationId}/financial_statements`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => {
            if (!res?.data?.financial_statement_id)
                return '';
            this._cache.fsId = res.data.financial_statement_id;
            return res.data.financial_statement_id;
        }), catchError((err) => {
            console.error(`[getFinancialStatementId]`, err);
            return EMPTY;
        }));
    }
    clearCache() {
        this._cache = {
            fsMetadata: null,
            fsId: null,
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FinancialStatementService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FinancialStatementService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FinancialStatementService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class FinancialStatementServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FinancialStatementServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FinancialStatementServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FinancialStatementServiceModule, providers: [
            {
                provide: FINANCIAL_STATEMENT_SERVICE_TOKEN,
                useClass: FinancialStatementService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FinancialStatementServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: FINANCIAL_STATEMENT_SERVICE_TOKEN,
                            useClass: FinancialStatementService,
                        },
                    ],
                }]
        }] });

const HTTP_CLIENT_BASE_SERVICE_TOKEN = new InjectionToken('HTTP_CLIENT_BASE_SERVICE_TOKEN');

class HttpClientBaseService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * Perform a HTTP GET request
     * @param url - The endpoint URL to fetch data from
     * @returns Observable<T>
     * @memberof HttpClientBaseService
     * @description Fetches data by making an HTTP GET request.
     * @example httpGet('https://api.example.com/data')
     */
    httpGet(url) {
        return this.httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res), catchError((error) => {
            console.error(error);
            return throwError(error);
        }));
    }
    /**
     * Perform a HTTP GET request
     * @param url - The endpoint URL to fetch data from
     * @returns Observable<T>
     * @memberof HttpClientBaseService
     * @description Fetches data by making an HTTP GET request.
     * @example httpGetData('https://api.example.com/data')
     */
    httpGetData(url) {
        return this.httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data), catchError((error) => {
            console.error(error);
            return throwError(error);
        }));
    }
    /**
     * Perform a HTTP POST request
     * @param url - The endpoint URL to send data to
     * @param body - The data to be sent in the request body
     * @returns Observable<T>
     * @memberof HttpClientBaseService
     * @description Sends data by making an HTTP POST request.
     * @example httpPost('https://api.example.com/data', { key: 'value' })
     */
    httpPost(url, body) {
        return this.httpClient
            .post(url, body, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => data), catchError((error) => {
            console.error(error);
            return throwError(error);
        }));
    }
    /**
     * Perform a HTTP PUT request
     * @param url - The endpoint URL to update data at
     * @param body - The data to be updated in the request body
     * @returns Observable<T>
     * @memberof HttpClientBaseService
     * @description Updates data by making an HTTP PUT request.
     * @example httpPut('https://api.example.com/data', { key: 'new-value' })
     */
    httpPut(url, body) {
        return this.httpClient
            .put(url, body, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => data), catchError((error) => {
            console.error(error);
            return throwError(error);
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: HttpClientBaseService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: HttpClientBaseService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: HttpClientBaseService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class HttpClientBaseServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: HttpClientBaseServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: HttpClientBaseServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: HttpClientBaseServiceModule, providers: [
            {
                provide: HTTP_CLIENT_BASE_SERVICE_TOKEN,
                useClass: HttpClientBaseService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: HttpClientBaseServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: HTTP_CLIENT_BASE_SERVICE_TOKEN,
                            useClass: HttpClientBaseService,
                        },
                    ],
                }]
        }] });

const MASTER_DATA_SERVICE_TOKEN = new InjectionToken('MASTER_DATA_SERVICE_TOKEN');

class MasterDataService {
    constructor() {
        this._countryCode = getCountryCodeFromStorage();
        this._cache = {
            genders: [],
            identity_card_types: [],
            provinces: [],
            marital_statuses: [],
            countries: [],
            company_entity_types: [],
            industries: [],
            religions: [],
            currencies: [],
            banks: [],
            memberBrwReferences: null,
        };
        this._httpClient = inject(HttpClient);
        this._utilsService = injectUtilsService();
        this._masterSvcUrl = `${this._utilsService.getKongUrl()}/v2/master_data`;
        this._memberMasterSvcUrl = `${this._utilsService.getKongUrl()}/v2/members/master_data`;
        this._memberReferenceSvcUrl = `${this._utilsService.getKongUrl()}/ms/members/BRW/references`;
        this._creditV2SvcUrl = `${this._utilsService.getKongUrl()}/credit/v2`;
    }
    getGenders() {
        if (this._cache.genders?.length) {
            return of(this._cache.genders);
        }
        return this._httpClient
            .get(`${this._masterSvcUrl}/genders/${this._countryCode}`, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => {
            this._cache.genders = data;
            return data;
        }));
    }
    getIdentityCardTypes() {
        if (this._cache.identity_card_types?.length) {
            return of(this._cache.identity_card_types);
        }
        return this._httpClient
            .get(`${this._masterSvcUrl}/identity_card_types/${this._countryCode}`, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => {
            this._cache.identity_card_types = data;
            return data;
        }));
    }
    getProvinces(countryId = this._countryCode) {
        return this._httpClient
            .get(`${this._masterSvcUrl}/provinces/${countryId}`, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data || []));
    }
    getCities(provinceId, countryId = this._countryCode) {
        return this._httpClient
            .get(`${this._masterSvcUrl}/cities/${countryId}?parent_id=${provinceId}`, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data || []));
    }
    getDistricts(cityId, countryId = this._countryCode) {
        return this._httpClient
            .get(`${this._masterSvcUrl}/districts/${countryId}?parent_id=${cityId}`, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data || []));
    }
    getAreas(districtId, countryId = this._countryCode) {
        return this._httpClient
            .get(`${this._masterSvcUrl}/areas/${countryId}?parent_id=${districtId}`, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data || []));
    }
    getCountries() {
        if (this._cache.countries?.length) {
            return of(this._cache.countries);
        }
        return this._httpClient
            .get(`${this._masterSvcUrl}/countries/all`, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => {
            this._cache.countries = data;
            return data;
        }));
    }
    getMaritalStatuses() {
        if (this._cache.marital_statuses?.length) {
            return of(this._cache.marital_statuses);
        }
        return this._httpClient
            .get(`${this._masterSvcUrl}/marital_statuses/${this._countryCode}`, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => {
            this._cache.marital_statuses = data;
            return data;
        }));
    }
    getCompanyEntityTypes() {
        if (this._cache.company_entity_types?.length) {
            return of(this._cache.company_entity_types);
        }
        return this._httpClient
            .get(`${this._masterSvcUrl}/company_entity_types/${this._countryCode}`, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => {
            this._cache.company_entity_types = data;
            return data;
        }));
    }
    getIndustries() {
        if (this._cache.industries?.length) {
            return of(this._cache.industries);
        }
        return this._httpClient
            .get(`${this._masterSvcUrl}/industries/${this._countryCode}`, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => {
            this._cache.industries = data;
            return data;
        }));
    }
    getReligions() {
        if (this._cache.religions?.length) {
            return of(this._cache.religions);
        }
        return this._httpClient
            .get(`${this._masterSvcUrl}/religions/${this._countryCode}`, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => {
            this._cache.religions = data;
            return data;
        }));
    }
    getCurrencies() {
        if (this._cache.currencies?.length) {
            return of(this._cache.currencies);
        }
        return this._httpClient
            .get(`${this._masterSvcUrl}/currencies/all`, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => {
            this._cache.currencies = data;
            return data;
        }));
    }
    getBanks() {
        if (this._cache.banks?.length) {
            return of(this._cache.banks);
        }
        return this._httpClient
            .get(`${this._masterSvcUrl}/banks/${this._countryCode}`, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => {
            this._cache.banks = data;
            return data;
        }));
    }
    getMemberBrwReferences() {
        if (this._cache.memberBrwReferences) {
            return of(this._cache.memberBrwReferences);
        }
        return this._httpClient
            .get(`${this._memberReferenceSvcUrl}?country_id=${this._countryCode}`, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => {
            this._cache.memberBrwReferences = data;
            return data;
        }));
    }
    getMemberMasterData(member_type_code) {
        return this._httpClient
            .get(`${this._memberMasterSvcUrl}`, {
            headers: setRequestOptions(),
            params: {
                member_type_code,
                country_code: getCountryCodeFromStorage(),
            },
        })
            .pipe(map(({ data }) => {
            return data;
        }));
    }
    getExchangeRates(baseCurrency) {
        const base = baseCurrency ||
            COUNTRY_CONFIG[getCountryCodeFromStorage()]?.currencyCode ||
            COUNTRY_CONFIG['SG'].currencyCode;
        return this._httpClient
            .get(`${this._creditV2SvcUrl}/exchange_rate/latest`, {
            headers: setRequestOptions(),
            params: {
                base,
            },
        })
            .pipe(map((res) => res?.content));
    }
    getCache() {
        return this._cache;
    }
    clearCache() {
        this._cache = {
            genders: [],
            identity_card_types: [],
            provinces: [],
            marital_statuses: [],
            countries: [],
            company_entity_types: [],
            industries: [],
            religions: [],
            currencies: [],
            banks: [],
            memberBrwReferences: null,
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MasterDataService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MasterDataService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MasterDataService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

class MasterDataServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MasterDataServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: MasterDataServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MasterDataServiceModule, providers: [
            {
                provide: MASTER_DATA_SERVICE_TOKEN,
                useClass: MasterDataService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MasterDataServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: MASTER_DATA_SERVICE_TOKEN,
                            useClass: MasterDataService,
                        },
                    ],
                }]
        }] });

const provideMasterDataService = () => {
    return {
        provide: MASTER_DATA_SERVICE_TOKEN,
        useClass: MasterDataService,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
};

const injectMasterDataService = () => inject(MASTER_DATA_SERVICE_TOKEN);

const FACILITY_SERVICE_TOKEN = new InjectionToken('FACILITY_SERVICE_TOKEN');

class FacilityService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._facilitySvcUrl = `${this._utilsService.getKongUrl()}/facility/v2`;
    }
    getPreApprovedFacilities(borrowerIds, country_code) {
        return this._httpClient
            .get(`${this._facilitySvcUrl}/pre-approved-facilities`, {
            params: {
                borrowerIds,
                country_code,
            },
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data || []));
    }
    getFacilitiesByCode(code) {
        return this._httpClient
            .get(`${this._facilitySvcUrl}/facilities/code/${code}`, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.rows || []));
    }
    getPreApprovedFacilitiesByCode(code) {
        return this._httpClient
            .get(`${this._facilitySvcUrl}/pre-approved-facilities/code/${code}`, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data || []));
    }
    getTypes(country_code) {
        return this._httpClient
            .get(`${this._facilitySvcUrl}/facility_types`, {
            params: {
                country_code,
            },
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data || []));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FacilityService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FacilityService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FacilityService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class FacilityServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FacilityServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FacilityServiceModule, imports: [UtilsServiceModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FacilityServiceModule, providers: [
            {
                provide: FACILITY_SERVICE_TOKEN,
                useClass: FacilityService,
            },
        ], imports: [UtilsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FacilityServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: FACILITY_SERVICE_TOKEN,
                            useClass: FacilityService,
                        },
                    ],
                    imports: [UtilsServiceModule],
                }]
        }] });

const PRODUCT_GROUP_SERVICE_TOKEN = new InjectionToken('PRODUCT_GROUP_SERVICE_TOKEN');

class ProductGroupService extends HttpClientBaseService {
    constructor(httpClient, utilsService) {
        super(httpClient);
        this.httpClient = httpClient;
        this.utilsService = utilsService;
    }
    /**
     * Get all product groups
     * @returns Observable<IProductGroup[]>
     * @description Retrieves all product groups either from cache or by making an HTTP GET request.
     * @example getProductGroups()
     */
    getProductGroups() {
        const url = `${this._getProductSvcUrl()}`;
        return this.httpGetData(url).pipe(map(({ settings }) => {
            return settings;
        }));
    }
    /**
     * Create a new product group
     * @param productIdentifier - The identifier of the product group to create
     * @returns Observable<IProductGroup>
     * @memberof ProductGroupService
     * @description Creates a new product group by making an HTTP POST request.
     * @example createProductGroup('BTF')
     */
    createProductGroup(productIdentifier) {
        const url = `${this._getProductSvcUrl()}`;
        return this.httpPost(url, {
            identifier: productIdentifier,
        }).pipe(map((data) => {
            return data;
        }));
    }
    /**
     * Create a product group setting
     * @param productIdentifier - The identifier of the product group to create
     * @param payload - The payload to create the product group setting
     * @returns Observable<IProductGroup>
     * @memberof ProductGroupService
     * @description Creates a product group setting by making an HTTP PUT request.
     * API team decided to use PUT instead of POST for this endpoint.
     * @example createProductGroup('BTF')
     */
    createProductGroupSetting(productIdentifier, payload) {
        const url = `${this._getProductSvcUrl()}/${productIdentifier}`;
        return this.httpPut(url, payload).pipe(map((data) => {
            return data;
        }));
    }
    /**
     * Get a specific product group
     * @param productIdentifier - The identifier of the product group to retrieve
     * @returns Observable<IProductGroup>
     * @memberof ProductGroupService
     * @description Retrieves a specific product group by making an HTTP GET request.
     * @example getProductGroup('BTF')
     */
    getProductGroup(productIdentifier) {
        const url = `${this._getProductSvcUrl()}/${productIdentifier}`;
        return this.httpGetData(url).pipe(map(({ data }) => {
            return data;
        }));
    }
    /**
     * Update a product group
     * @param productIdentifier - The identifier of the product group to create
     * @param payload - The payload to update the product group with
     * @returns Observable<IProductGroup>
     * @memberof ProductGroupService
     * @description Updates a product group by making an HTTP PUT request.
     * @example createProductGroup('BTF')
     */
    updateProductGroup(productIdentifier, payload) {
        const url = `${this._getProductSvcUrl()}/${productIdentifier}`;
        return this.httpPut(url, payload).pipe(map((data) => data));
    }
    // product group versions
    /**
     * Get the versions of a product group
     * @param productIdentifier - The identifier of the product group to retrieve the versions for
     * @returns Observable<IProductGroupVersion[]>
     * @memberof ProductGroupService
     * @description Retrieves the versions of a product group by making an HTTP GET request.
     * @example getProductGroupVersions('BTF')
     */
    getProductGroupVersions(productIdentifier) {
        const url = `${this._getProductSvcUrl()}/${productIdentifier}/versions`;
        return this.httpGetData(url).pipe(map(({ versions }) => versions.map((v) => ({ ...v, settingsJson: 'Click to view settings JSON' }))));
    }
    /**
     * Get a specific product group version
     * @param productIdentifier - The identifier of the product group to retrieve the version for
     * @param version - The version number of the product group to retrieve
     * @param key - The key attribute present inside settings object
     * @returns Observable<IProductGroupVersion>
     * @memberof ProductGroupService
     * @description Retrieves a specific product group version by making an HTTP GET request.
     * @example getProductGroupVersion('BTF', 1, 'abc')
     */
    getProductGroupVersion(productIdentifier, version, key) {
        const url = `${this._getProductSvcUrl()}/${productIdentifier}/versions/${version}/${key}`;
        return this.httpGetData(url).pipe(map(({ data }) => {
            return data;
        }));
    }
    // product group common setting
    /**
     * Get the common setting for the product group
     * @returns Observable<IProductGroupCommonSetting>
     * @memberof ProductGroupService
     * @description Retrieves the common setting for the product group by making an HTTP GET request.
     * @example getProductGroupCommonSetting()
     */
    getProductGroupCommonSetting() {
        const url = `${this._getProductCommonSettingSvcUrl()}/common/setting`;
        return this.httpGetData(url).pipe(map((data) => data));
    }
    /**
     * Update the common setting for the product group
     * @param payload - The payload containing the updated common setting
     * @returns Observable<IProductGroupCommonSetting>
     * @memberof ProductGroupService
     * @description Updates the common setting for the product group by making an HTTP PUT request.
     * @example updateProductGroupCommonSetting(payload)
     */
    updateProductGroupCommonSetting(payload) {
        const url = `${this._getProductCommonSettingSvcUrl()}/common/setting`;
        return this.httpPut(url, payload.setting).pipe(map((data) => data));
    }
    // product group common setting versions
    /**
     * Get a list of versions of the common setting for the product group
     * @returns Observable<IProductGroupCommonSettingVersion[]>
     * @memberof ProductGroupService
     * @description Retrieves the version history of the common setting for the product group by making an HTTP GET request.
     * @example getProductGroupCommonSettingVersions()
     */
    getProductGroupCommonSettingVersions() {
        const url = `${this._getProductCommonSettingSvcUrl()}/common/setting/versions`;
        return this.httpGetData(url).pipe(map((data) => (data?.common_settings || []).map((v) => ({
            ...v,
            settingsJson: 'Click to view settings JSON',
        }))));
    }
    /**
     * Get a specific version of the common setting for the product group
     * @param version The version number of the common setting to retrieve
     * @returns Observable<IProductGroupCommonSettingVersion>
     * @memberof ProductGroupService
     * @description Retrieves a specific version of the common setting for the product group by making an HTTP GET request.
     * @example getProductGroupCommonSettingVersion(1)
     */
    getProductGroupCommonSettingVersion(version) {
        const url = `${this._getProductSvcUrl()}/common/setting/versions/${version}`;
        return this.httpGetData(url).pipe(map(({ data }) => {
            return data;
        }));
    }
    _getProductSvcUrl() {
        return `${this.utilsService.getKongUrl()}/aps/v1/product_groups/${getCountryCodeFromStorage() || CountryCode.MY}`;
    }
    _getProductCommonSettingSvcUrl() {
        return `${this.utilsService.getKongUrl()}/aps/v1/product_groups`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductGroupService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductGroupService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductGroupService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class ProductGroupServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductGroupServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ProductGroupServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductGroupServiceModule, providers: [
            {
                provide: PRODUCT_GROUP_SERVICE_TOKEN,
                useClass: ProductGroupService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductGroupServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: PRODUCT_GROUP_SERVICE_TOKEN,
                            useClass: ProductGroupService,
                        },
                    ],
                }]
        }] });

const REPAYMENT_SCHEDULE_PLAN_SERVICE_TOKEN = new InjectionToken('REPAYMENT_SCHEDULE_PLAN_SERVICE_TOKEN');

class RepaymentSchedulePlanService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._cache = {};
        this._appSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/applications`;
    }
    getRepaymentSchedulePlan(applicationId) {
        if (this._cache[applicationId]) {
            return of(this._cache[applicationId]);
        }
        const url = `${this._appSvcUrl}/${applicationId}/repayment_schedule_plans`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => {
            const updatedData = {
                ...data,
                repayment_schedule_plans_details: data.repayment_schedule_plans_details.sort((a, b) => {
                    const dateA = new Date(a.schedule_date);
                    const dateB = new Date(b.schedule_date);
                    return dateA.getTime() - dateB.getTime();
                }),
            };
            this._cache[applicationId] = updatedData;
            return updatedData;
        }));
    }
    updateRepaymentSchedulePlan(applicationId, planId, payload) {
        const url = `${this._appSvcUrl}/${applicationId}/repayment_schedule_plans/${planId}`;
        return this._httpClient
            .put(url, payload, {
            headers: setRequestOptions(),
        })
            .pipe(tap(() => {
            delete this._cache[applicationId];
        }), map(({ data }) => data));
    }
    createRepaymentSchedulePlan(applicationId, payload) {
        const url = `${this._appSvcUrl}/${applicationId}/repayment_schedule_plans`;
        return this._httpClient
            .post(url, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => data));
    }
    clearCache() {
        this._cache = {};
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RepaymentSchedulePlanService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RepaymentSchedulePlanService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RepaymentSchedulePlanService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class RepaymentSchedulePlanServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RepaymentSchedulePlanServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: RepaymentSchedulePlanServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RepaymentSchedulePlanServiceModule, providers: [
            {
                provide: REPAYMENT_SCHEDULE_PLAN_SERVICE_TOKEN,
                useClass: RepaymentSchedulePlanService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RepaymentSchedulePlanServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: REPAYMENT_SCHEDULE_PLAN_SERVICE_TOKEN,
                            useClass: RepaymentSchedulePlanService,
                        },
                    ],
                }]
        }] });

const SETTINGS_SERVICE_TOKEN = new InjectionToken('SETTINGS_SERVICE_TOKEN');

class SettingsService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._cache = {};
    }
    getSettings() {
        const cacheKey = 'settings';
        if (this._cache[cacheKey]) {
            return of(this._cache[cacheKey]);
        }
        const baseUrl = `${this._utilsService.getKongUrl()}/aps/v1/settings`;
        const url = getCountryCodeFromStorage() === FSWCountryCode.VU ? `${baseUrl}/VU_TF` : baseUrl;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => {
            this._cache[cacheKey] = data;
            return data;
        }));
    }
    getSettingsByKey(key) {
        return this._httpClient
            .get(`${this._utilsService.getKongUrl()}/aps/v1/settings/${key}`, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    getProductGroup() {
        return this._httpClient
            .get(`${this._utilsService.getKongUrl()}/aps/v1/product_groups/common/setting`, {
            headers: setRequestOptions(),
        })
            .pipe(switchMap((res) => {
            const settings = res?.data?.latest_setting?.constant[getCountryCodeFromStorage().toString()] ||
                res?.data?.latest_setting?.variable;
            if (settings?.['position']) {
                return of(settings['position']);
            }
            return this._httpClient
                .get(`${this._utilsService.getKongUrl()}/aps/v1/product_groups/${getCountryCodeFromStorage() || CountryCode.MY}`, {
                headers: setRequestOptions(),
            })
                .pipe(switchMap(({ data }) => {
                const position = data?.settings?.[0]?.settings[getCountryCodeFromStorage()]?.position ||
                    data?.settings?.[0]?.settings?.position;
                if (position?.length) {
                    return of(position);
                }
                return this.getSettings().pipe(map((settings) => settings['position']));
            }));
        }));
    }
    getCache() {
        return this._cache['settings'];
    }
    clearCache() {
        this._cache = {};
    }
    updateCache(settings) {
        const cacheKey = 'settings';
        this._cache[cacheKey] = settings;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SettingsService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SettingsService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SettingsService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class SettingsServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SettingsServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: SettingsServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SettingsServiceModule, providers: [
            {
                provide: SETTINGS_SERVICE_TOKEN,
                useClass: SettingsService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SettingsServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: SETTINGS_SERVICE_TOKEN,
                            useClass: SettingsService,
                        },
                    ],
                }]
        }] });

const FSW_LOAN_SERVICE_TOKEN = new InjectionToken('FSW_LOAN_SERVICE_TOKEN');

class FSWLoanService {
    constructor() {
        this._httpClient = inject(HttpClient);
        this._utilsService = injectUtilsService();
        this._loanSvcUrl = `${this._utilsService.getKongUrl()}/ln/v2`;
    }
    getRecourseById(id) {
        const url = `${this._loanSvcUrl}/recourses/${id}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    getProducts(country_code) {
        const url = `${this._loanSvcUrl}/products`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
            params: {
                country_code,
            },
        })
            .pipe(map((res) => res?.data));
    }
    getPurposes(country_code) {
        const url = `${this._loanSvcUrl}/purposes`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
            params: {
                country_code,
            },
        })
            .pipe(map((res) => res?.data));
    }
    getDesignations() {
        const url = `${this._loanSvcUrl}/designations`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    updateLoan(id, data, country_code) {
        const url = `${this._loanSvcUrl}/loans/${id}`;
        return this._httpClient
            .put(url, { ...data, country_code }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    getLoanById(id) {
        const url = `${this._loanSvcUrl}/loans/${id}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    getRecourses(id) {
        const url = `${this._loanSvcUrl}/loans/${id}/recourses`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    getLoanScheduleByLoanId(id) {
        const url = `${this._loanSvcUrl}/loans/${id}/schedule`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    saveLoanScheduleByLoanId(id, data) {
        const url = `${this._loanSvcUrl}/loans/${id}/schedule`;
        return this._httpClient
            .put(url, data, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    getCalculationEffectiveInterestRate(params) {
        const url = `${this._loanSvcUrl}/calculators/effective_interest_rate`;
        return this._httpClient
            .get(url, {
            params,
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    getFormula(name, params, rounding_strategy) {
        const url = `${this._loanSvcUrl}/master/formulas/${name}/installments`;
        return this._httpClient
            .get(url, {
            params: {
                ...params,
                ...(rounding_strategy ? { rounding_strategy } : {}),
            },
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    parseCBS(doc_ids, allow_re_parse = false) {
        const url = `${this._utilsService.getKongUrl()}/ldd/cbs/parse`;
        return this._httpClient
            .post(url, {
            doc_ids,
            allow_re_parse,
        }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data ?? {}));
    }
    getParsedCBS(doc_ids, allow_re_parse = false) {
        const url = `${this._utilsService.getKongUrl()}/ldd/cbs/parse`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
            params: {
                doc_ids,
                allow_re_parse,
            },
        })
            .pipe(map((res) => res?.data ?? []));
    }
    getLDDPreScreeningDocs(doc_id) {
        const url = `${this._utilsService.getKongUrl()}/ldd/pre_screenings`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
            params: {
                doc_id,
            },
        })
            .pipe(map((res) => res?.data ?? []));
    }
    postLDDPreScreeningDocs(payload) {
        const url = `${this._utilsService.getKongUrl()}/ldd/pre_screenings`;
        return this._httpClient
            .post(url, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    getRecourseTypes() {
        return this._httpClient
            .get(`${this._loanSvcUrl}/master/enums/recourse_type`, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => (res?.data || []).map((item) => item.enum)));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWLoanService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWLoanService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWLoanService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

class FSWLoanServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWLoanServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWLoanServiceModule, imports: [UtilsServiceModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWLoanServiceModule, providers: [
            {
                provide: FSW_LOAN_SERVICE_TOKEN,
                useClass: FSWLoanService,
            },
        ], imports: [UtilsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWLoanServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: FSW_LOAN_SERVICE_TOKEN,
                            useClass: FSWLoanService,
                        },
                    ],
                    imports: [UtilsServiceModule],
                }]
        }] });

const provideLoanService = () => {
    return {
        provide: FSW_LOAN_SERVICE_TOKEN,
        useClass: FSWLoanService,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
};

const injectLoanService = () => inject(FSW_LOAN_SERVICE_TOKEN);

const FSW_CTOS_SERVICE_TOKEN = new InjectionToken('FSW_CTOS_SERVICE_TOKEN');

class FSWCtosService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._ctosSvcUrl = `${this._utilsService.getKongUrl()}/ext/ctos`;
    }
    pull(params) {
        const url = `${this._ctosSvcUrl}/v2/pull`;
        return this._httpClient.post(url, params, {
            headers: setRequestOptions(),
        });
    }
    pullMany(params) {
        const url = `${this._ctosSvcUrl}/v2/pull_many`;
        return this._httpClient.post(url, params, {
            headers: setRequestOptions(),
        });
    }
    pullBips(params) {
        const url = `${this._ctosSvcUrl}/pull_bips`;
        return this._httpClient
            .post(url, params, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.bips || []));
    }
    fetchReport(reportId, contentType = 'text/html') {
        const url = `${this._ctosSvcUrl}/fetch/${reportId}`;
        let headers = setRequestOptions(false);
        headers = headers.append('Content-Type', contentType);
        headers = headers.append('accept', contentType);
        return this._httpClient.get(url, {
            headers,
            responseType: 'text',
        });
    }
    history(params) {
        const url = `${this._ctosSvcUrl}/v2/log/history`;
        return this._httpClient
            .post(url, params, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.history || []));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class FSWCtosServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosServiceModule, imports: [UtilsServiceModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosServiceModule, providers: [
            {
                provide: FSW_CTOS_SERVICE_TOKEN,
                useClass: FSWCtosService,
            },
        ], imports: [UtilsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: FSW_CTOS_SERVICE_TOKEN,
                            useClass: FSWCtosService,
                        },
                    ],
                    imports: [UtilsServiceModule],
                }]
        }] });

function provideCtosService() {
    return [
        {
            provide: FSW_CTOS_SERVICE_TOKEN,
            useClass: FSWCtosService,
            deps: [HttpClient, UTILS_SERVICE_TOKEN],
        },
    ];
}

const injectCtosService = () => inject(FSW_CTOS_SERVICE_TOKEN);

const FINANCE_SERVICE_TOKEN = new InjectionToken('FINANCE_SERVICE_TOKEN');

class FinanceService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._financeSvcUrl = `${this._utilsService.getKongUrl()}/fs/v2`;
    }
    getDisburses(loanIds) {
        return this._httpClient
            .get(`${this._financeSvcUrl}/disbursals`, {
            params: {
                'loan_ids[]': loanIds,
            },
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data || []));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FinanceService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FinanceService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FinanceService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class FinanceServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FinanceServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FinanceServiceModule, imports: [UtilsServiceModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FinanceServiceModule, providers: [
            {
                provide: FINANCE_SERVICE_TOKEN,
                useClass: FinanceService,
            },
        ], imports: [UtilsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FinanceServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: FINANCE_SERVICE_TOKEN,
                            useClass: FinanceService,
                        },
                    ],
                    imports: [UtilsServiceModule],
                }]
        }] });

const EXTENSION_SERVICE_TOKEN = new InjectionToken('EXTENSION_SERVICE_TOKEN');

class ExtensionService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this.svcUrl = `${this._utilsService.getKongUrl()}/ext`;
    }
    searchPefindo(params) {
        return this._httpClient
            .get(`${this.svcUrl}/pefindo/search`, {
            headers: setRequestOptions(),
            params: {
                ...params,
            },
        })
            .pipe(map((response) => response.searchResults || []));
    }
    pullPefindo(params) {
        return this._httpClient.post(`${this.svcUrl}/pefindo/pull`, params, {
            headers: setRequestOptions(),
        });
    }
    historyPefindo(pefindoId) {
        return this._httpClient
            .post(`${this.svcUrl}/pefindo/history`, {
            pefindoId,
        }, {
            headers: setRequestOptions(),
        })
            .pipe(map((response) => response.history || []));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ExtensionService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ExtensionService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ExtensionService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class ExtensionServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ExtensionServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ExtensionServiceModule, imports: [UtilsServiceModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ExtensionServiceModule, providers: [
            {
                provide: EXTENSION_SERVICE_TOKEN,
                useClass: ExtensionService,
            },
        ], imports: [UtilsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ExtensionServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [UtilsServiceModule],
                    providers: [
                        {
                            provide: EXTENSION_SERVICE_TOKEN,
                            useClass: ExtensionService,
                        },
                    ],
                }]
        }] });

class RefreshService {
    constructor() {
        this._refreshMap = new Map();
    }
    register(key) {
        const existed = this._refreshMap.get(key);
        if (existed) {
            return existed.asObservable();
        }
        this._refreshMap.set(key, new BehaviorSubject(new Date()));
        return this.register(key);
    }
    refresh(key) {
        const existed = this._refreshMap.get(key);
        if (!existed) {
            return;
        }
        existed.next(new Date());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RefreshService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RefreshService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RefreshService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class EBATHService {
    constructor() {
        this._httpClient = inject(HttpClient);
        this._utilsService = inject(UTILS_SERVICE_TOKEN);
        this._svcUrl = `${this._utilsService.getKongUrl()}/credit/v2/existing_banking_arrangements`;
        this._appSvcUrl = `${this._utilsService.getKongUrl()}/aps/v1/applications`;
    }
    createOne(payload) {
        const url = `${this._svcUrl}`;
        return this._httpClient
            .post(url, payload, { headers: setRequestOptions() })
            .pipe(map$1((res) => res?.data));
    }
    updateOne(id, payload) {
        const url = `${this._svcUrl}/${id}`;
        return this._httpClient
            .put(url, payload, { headers: setRequestOptions() })
            .pipe(map$1((res) => res?.data));
    }
    deleteOne(id) {
        const url = `${this._svcUrl}/${id}`;
        return this._httpClient.get(url, {
            headers: setRequestOptions(),
        });
    }
    getOne(id) {
        const url = `${this._svcUrl}/${id}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map$1((res) => res?.data));
    }
    postToApplication(applicationId, id) {
        const url = `${this._appSvcUrl}/${applicationId}/existing_banking_arrangements`;
        return this._httpClient
            .post(url, { existing_banking_arrangement_ids: [id] }, { headers: setRequestOptions() })
            .pipe(map$1((res) => res?.data));
    }
    getAllFromApplication(applicationId) {
        const url = `${this._appSvcUrl}/${applicationId}/existing_banking_arrangements`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map$1((res) => res?.data?.existing_banking_arrangement_ids || []));
    }
    removeFromApplication(applicationId, id) {
        const url = `${this._appSvcUrl}/${applicationId}/existing_banking_arrangements/${id}`;
        return this._httpClient.delete(url, {
            headers: setRequestOptions(),
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBATHService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBATHService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBATHService, decorators: [{
            type: Injectable
        }] });

const EBATH_SERVICE_TOKEN = new InjectionToken('EBATH_SERVICE_TOKEN');

function provideEBATHService() {
    return [
        provideUtilsService(),
        {
            provide: EBATH_SERVICE_TOKEN,
            useClass: EBATHService,
            deps: [HttpClient, UTILS_SERVICE_TOKEN],
        },
    ];
}

function injectEBATHService(injector) {
    !injector && assertInInjectionContext(injectEBATHService);
    const assertedInjector = injector ?? inject(Injector);
    return assertedInjector.get(EBATH_SERVICE_TOKEN);
}

class QuestnetService {
    constructor() {
        this._httpClient = inject(HttpClient);
        this._utilsService = inject(UTILS_SERVICE_TOKEN);
        this._svcUrl = `${this._utilsService.getKongUrl()}/ext/questnet`;
    }
    fetchHistory(params) {
        const url = `${this._svcUrl}/history`;
        return this._httpClient
            .post(url, params, {
            headers: setRequestOptions(),
        })
            .pipe(map$1((res) => res?.history || []));
    }
    fetchReport(reportId) {
        const url = `${this._svcUrl}/fetch/${reportId}`;
        return this._httpClient.get(url, {
            headers: setRequestOptions(),
        });
    }
    downloadReport(reportId) {
        const url = `${this._svcUrl}/fetch/${reportId}`;
        let headers = setRequestOptions(false);
        headers = headers.append('Content-Type', 'application/pdf');
        headers = headers.append('Accept', 'application/pdf');
        return this._httpClient.get(url, {
            headers,
            responseType: 'blob',
        });
    }
    pull(params) {
        const url = `${this._svcUrl}/pull`;
        return this._httpClient
            .post(url, params, {
            headers: setRequestOptions(),
        })
            .pipe(map$1((res) => res?.report));
    }
    pullMany(params) {
        const url = `${this._svcUrl}/pull_many`;
        return this._httpClient
            .post(url, params, {
            headers: setRequestOptions(),
        })
            .pipe(map$1((res) => (res?.reports || []).map((r) => r.report)));
    }
    getBips(reportId) {
        const url = `${this._svcUrl}/bips/${reportId}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map$1((res) => res?.bips || []));
    }
    buildParams(params) {
        return {
            ...params,
            ...(params.entityNo ? { productCode: getProductCodeFromIdNumber(params.entityNo) } : {}),
            ...(params.entityNo ? { entityName: 'UNUSED' } : {}),
        };
    }
    transformReportToBip(report) {
        const dats = report?.Dats || [];
        if (!dats.length) {
            return { shares: '0' };
        }
        let searchInfo = {};
        let addressInfo = {};
        const firstDat = dats[0];
        const { SrhRec: { NamInfs, AddInfs }, } = firstDat;
        if (NamInfs.length > 0) {
            const info = NamInfs[0];
            searchInfo = {
                name: info['Nam'],
            };
        }
        if (AddInfs.length > 0) {
            const address = AddInfs[0];
            addressInfo = {
                addressLine1: address.Add1 || address.FulAdd,
                addressLine2: address.Add2 || '',
                addressLine3: '',
                postcode: address.PosCod,
            };
        }
        return {
            ...searchInfo,
            ...addressInfo,
            shares: '0',
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: QuestnetService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: QuestnetService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: QuestnetService, decorators: [{
            type: Injectable
        }] });

const QUESTNET_SERVICE_TOKEN = new InjectionToken('QUESTNET_SERVICE_TOKEN');

function provideQuestnetService() {
    return [
        provideUtilsService(),
        {
            provide: QUESTNET_SERVICE_TOKEN,
            useClass: QuestnetService,
            deps: [HttpClient, UTILS_SERVICE_TOKEN],
        },
    ];
}

function injectQuestnetService(injector) {
    !injector && assertInInjectionContext(injectQuestnetService);
    const assertedInjector = injector ?? inject(Injector);
    return assertedInjector.get(QUESTNET_SERVICE_TOKEN);
}

class FSWAppLoanDraftService {
    constructor() {
        this._httpClient = inject(HttpClient);
        this._utilsService = inject(UTILS_SERVICE_TOKEN);
        this._svcUrl = `${this._utilsService.getKongUrl()}/aps/v1/bbs/loan_draft`; // misnamed - using BBS in the URL
    }
    /**
     *
     * @param loan_draft_id
     * @param product_group_identifier_id
     * @returns Observable<never>
     * @description Delete application by loan draft id
     * @url /v1/bbs/loan_draft/:loan_draft_id?product_group_identifier=:product_group_identifier_id
     * @method DELETE
     */
    deleteApplicationByLoanDraftId(loan_draft_id, product_group_identifier_id) {
        const url = `${this._svcUrl}/${loan_draft_id}?product_group_identifier=${product_group_identifier_id}`;
        return this._httpClient.delete(url, {
            headers: setRequestOptions(),
        });
    }
}
function provideFSWAppLoanDraftService() {
    return {
        provide: FSWAppLoanDraftService,
        useClass: FSWAppLoanDraftService,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
}
function injectFSWAppLoanDraftService() {
    return inject(FSWAppLoanDraftService);
}

class FSWBBSLoanDraftService {
    constructor() {
        this._httpClient = inject(HttpClient);
        this._utilsService = inject(UTILS_SERVICE_TOKEN);
        this._intSvcUrl = `${this._utilsService.getKongUrl()}/bbs/int/loan-draft`;
    }
    /**
     *
     * @param loan_draft_id
     * @param member_uuid
     * @returns application_uuid
     * @description Invoke after submit loan draft
     * @url /int/loan-draft/:loan_draft_id/after-submit
     * @method POST
     */
    invokeAfterSubmitLoanDraft(loan_draft_id, member_uuid) {
        const url = `${this._intSvcUrl}/${loan_draft_id}/after-submit`;
        return this._httpClient
            .post(url, { operations: ['CreateApplicationOperation'] }, {
            headers: setRequestOptions(),
        })
            .pipe(map$1((res) => res?.CreateApplicationOperation?.application?.applicationId));
    }
}
function provideFSWBBSLoanDraftService() {
    return {
        provide: FSWBBSLoanDraftService,
        useClass: FSWBBSLoanDraftService,
        deps: [HttpClient, UTILS_SERVICE_TOKEN],
    };
}
function injectFSWBBSLoanDraftService() {
    return inject(FSWBBSLoanDraftService);
}

// API Response

var BuyerStatus;
(function (BuyerStatus) {
    BuyerStatus["NORMAL"] = "NORMAL";
    BuyerStatus["TOP"] = "TOP";
})(BuyerStatus || (BuyerStatus = {}));
var BuyerTransactionPaymentMethod;
(function (BuyerTransactionPaymentMethod) {
    BuyerTransactionPaymentMethod["BankTransfer"] = "Bank Transfer";
    BuyerTransactionPaymentMethod["TT"] = "TT";
    BuyerTransactionPaymentMethod["Cheque"] = "Cheque";
    BuyerTransactionPaymentMethod["Cash"] = "Cash";
    BuyerTransactionPaymentMethod["Others"] = "Others";
})(BuyerTransactionPaymentMethod || (BuyerTransactionPaymentMethod = {}));
var BuyerSalesOrCredit;
(function (BuyerSalesOrCredit) {
    BuyerSalesOrCredit["SALES"] = "SALES";
    BuyerSalesOrCredit["CREDIT"] = "CREDIT";
})(BuyerSalesOrCredit || (BuyerSalesOrCredit = {}));
const BUYER_PAYMENT_METHODS = ['Bank Transfer', 'TT', 'Cheque', 'Cash', 'Others'];

const BUYER_SERVICE_TOKEN = new InjectionToken('BUYER_SERVICE_TOKEN');

class BuyerService {
    constructor() {
        this._httpClient = inject(HttpClient);
        this._utilsService = injectUtilsService();
        this._applicationRelationshipService = injectApplicationRelationshipService();
        this._svcUrl = `${this._utilsService.getKongUrl()}/credit/v2`;
    }
    /* Buyer Link with Application */
    linkBuyerIdToApplication(applicationId, buyer_id) {
        return this._applicationRelationshipService.addAsync(applicationId, 'buyers', buyer_id);
    }
    getAllBuyerIdsFromApplication(applicationId) {
        return this._applicationRelationshipService.getAsync(applicationId, 'buyers');
    }
    unlinkBuyerIdFromApplication(applicationId, buyer_id) {
        return this._applicationRelationshipService.deleteAsync(applicationId, 'buyers', buyer_id);
    }
    /* Buyer Information */
    addBuyer(payload) {
        return this._httpClient
            .post(`${this._svcUrl}/buyer`, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data), catchError((err) => {
            console.error(`[addBuyer]`, err);
            return EMPTY;
        }));
    }
    getAllBuyers(buyer_ids) {
        const queryParams = (buyer_ids || []).map((id) => `ids=${id}`).join('&&');
        let url = `${this._svcUrl}/buyers?${queryParams}`;
        if (!buyer_ids?.length) {
            url = `${this._svcUrl}/buyers`;
        }
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.buyers || []), catchError((err) => {
            console.error(`[getAllBuyers]`, err);
            return EMPTY;
        }));
    }
    getBuyer(buyer_id) {
        const url = `${this._svcUrl}/buyer/${buyer_id}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data), catchError((err) => {
            console.error(`[getBuyer]`, err);
            return EMPTY;
        }));
    }
    updateBuyerSales(buyer_id, payload) {
        const url = `${this._svcUrl}/buyer/${buyer_id}`;
        return this._httpClient
            .put(url, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data), catchError((err) => {
            console.error(`[updateBuyerSales]`, err);
            return EMPTY;
        }));
    }
    updateBuyerCredit(buyer_id, payload) {
        const url = `${this._svcUrl}/buyer/${buyer_id}`;
        return this._httpClient
            .put(url, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data), catchError((err) => {
            console.error(`[updateBuyerCredit]`, err);
            return EMPTY;
        }));
    }
    updateBuyerStatus(buyer_id, status) {
        const url = `${this._svcUrl}/buyer/${buyer_id}/status`;
        return this._httpClient
            .patch(url, { status }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data), catchError((err) => {
            console.error(`[updateBuyerStatus]`, err);
            return EMPTY;
        }));
    }
    deleteBuyer(buyer_id) {
        const url = `${this._svcUrl}/buyer/${buyer_id}`;
        return this._httpClient
            .delete(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.success), catchError((err) => {
            console.error(`[deleteBuyer]`, err);
            return EMPTY;
        }));
    }
    /* Buyer Transaction */
    addTransaction(buyer_id, payload) {
        const url = `${this._svcUrl}/buyer/${buyer_id}/payment_proofing`;
        return this._httpClient
            .post(url, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data), catchError((err) => {
            console.error(`[addTransaction]`, err);
            return EMPTY;
        }));
    }
    addEachBuyerTransactions(buyer_id, buyer_payment_proofing) {
        const url = `${this._svcUrl}/buyer/${buyer_id}/payment_proofings`;
        return this._httpClient
            .post(url, { buyer_payment_proofing }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.buyer_payment_proofing), catchError((err) => {
            console.error(`[addMultipleTransactions]`, err);
            return EMPTY;
        }));
    }
    updateEachBuyerTransactions(buyer_id, buyer_payment_proofing) {
        const url = `${this._svcUrl}/buyer/${buyer_id}/payment_proofings`;
        return this._httpClient
            .put(url, { buyer_payment_proofing }, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.buyer_payment_proofing), catchError((err) => {
            console.error(`[updateMultipleTransactions]`, err);
            return EMPTY;
        }));
    }
    getEachBuyerTransactions(buyer_id) {
        const url = `${this._svcUrl}/buyer/${buyer_id}/payment_proofings`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.buyer_payment_proofing || []), catchError((err) => {
            console.error(`[getAllTransactions]`, err);
            return EMPTY;
        }));
    }
    getTransaction(buyer_id, payment_proofing_id) {
        const url = `${this._svcUrl}/buyer/${buyer_id}/payment_proofing/${payment_proofing_id}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data), catchError((err) => {
            console.error(`[getTransaction]`, err);
            return EMPTY;
        }));
    }
    updateTransaction(buyer_id, payment_proofing_id, payload) {
        const url = `${this._svcUrl}/buyer/${buyer_id}/payment_proofing/${payment_proofing_id}`;
        return this._httpClient
            .put(url, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data), catchError((err) => {
            console.error(`[updateTransaction]`, err);
            return EMPTY;
        }));
    }
    deleteEachBuyerTransactions(buyer_id) {
        const url = `${this._svcUrl}/buyer/${buyer_id}/payment_proofings`;
        return this._httpClient
            .delete(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.success || false), catchError((err) => {
            console.error(`[deleteAllTransactions]`, err);
            return EMPTY;
        }));
    }
    deleteTransaction(buyer_id, payment_proofing_id) {
        const url = `${this._svcUrl}/buyer/${buyer_id}/payment_proofing/${payment_proofing_id}`;
        return this._httpClient
            .delete(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.success || false), catchError((err) => {
            console.error(`[deleteTransaction]`, err);
            return EMPTY;
        }));
    }
    addPaymentProofingAnalysis(buyer_id) {
        const url = `${this._svcUrl}/buyer/${buyer_id}/payment_proofing_analysis`;
        return this._httpClient
            .post(url, {}, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data), catchError((err) => {
            console.error(`[addPaymentProofingAnalysis]`, err);
            return EMPTY;
        }));
    }
    updatePaymentProofingAnalysis(buyer_id) {
        const url = `${this._svcUrl}/buyer/${buyer_id}/payment_proofing_analysis`;
        return this._httpClient
            .put(url, {}, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data), catchError((err) => {
            console.error(`[updatePaymentProofingAnalysis]`, err);
            return EMPTY;
        }));
    }
    getPaymentProofingAnalysis(buyer_id) {
        if (!buyer_id) {
            throw new Error('Buyer ID is not valid');
        }
        const url = `${this._svcUrl}/buyer/${buyer_id}/payment_proofing_analysis`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data), catchError((err) => {
            console.error(`[getPaymentProofingAnalysis]`, err);
            return EMPTY;
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BuyerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BuyerService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BuyerService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

class BuyerServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BuyerServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: BuyerServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BuyerServiceModule, providers: [
            provideApplicationRelationshipService(),
            {
                provide: BUYER_SERVICE_TOKEN,
                useClass: BuyerService,
                deps: [HttpClient, UTILS_SERVICE_TOKEN, APPLICATION_RELATIONSHIP_SERVICE_TOKEN],
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BuyerServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        provideApplicationRelationshipService(),
                        {
                            provide: BUYER_SERVICE_TOKEN,
                            useClass: BuyerService,
                            deps: [HttpClient, UTILS_SERVICE_TOKEN, APPLICATION_RELATIONSHIP_SERVICE_TOKEN],
                        },
                    ],
                }]
        }] });

class CreditSupplierService {
    constructor() {
        this._httpClient = inject(HttpClient);
        this._utilsService = inject(UTILS_SERVICE_TOKEN);
        this._svcUrl = `${this._utilsService.getKongUrl()}/credit/v2/suppliers`;
    }
    createOne(payload) {
        const url = `${this._svcUrl}`;
        return this._httpClient
            .post(url, payload, { headers: setRequestOptions() })
            .pipe(map((res) => res?.data));
    }
    getAll(ids) {
        const url = `${this._svcUrl}`;
        return this._httpClient
            .get(url, {
            params: { ids },
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.suppliers || []));
    }
    getOne(id) {
        const url = `${this._svcUrl}/${id}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    updateOne(id, payload) {
        const url = `${this._svcUrl}/${id}`;
        return this._httpClient
            .put(url, payload, { headers: setRequestOptions() })
            .pipe(map((res) => res?.data));
    }
    patchStatus(id, status) {
        const url = `${this._svcUrl}/${id}/status`;
        return this._httpClient
            .patch(url, { status }, { headers: setRequestOptions() })
            .pipe(map((res) => res?.data));
    }
    deleteOne(id) {
        const url = `${this._svcUrl}/${id}`;
        return this._httpClient.get(url, {
            headers: setRequestOptions(),
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditSupplierService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditSupplierService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditSupplierService, decorators: [{
            type: Injectable
        }] });

const CREDIT_SUPPLIER_SERVICE_TOKEN = new InjectionToken('CREDIT_SUPPLIER_SERVICE_TOKEN');

function provideCreditSupplierService() {
    return [
        provideUtilsService(),
        {
            provide: CREDIT_SUPPLIER_SERVICE_TOKEN,
            useClass: CreditSupplierService,
            deps: [HttpClient, UTILS_SERVICE_TOKEN],
        },
    ];
}

function injectCreditSupplierService(injector) {
    !injector && assertInInjectionContext(injectCreditSupplierService);
    const assertedInjector = injector ?? inject(Injector);
    return assertedInjector.get(CREDIT_SUPPLIER_SERVICE_TOKEN);
}

class ApplicationSupplierService {
    constructor() {
        this._httpClient = inject(HttpClient);
        this._utilsService = inject(UTILS_SERVICE_TOKEN);
        this._svcUrl = `${this._utilsService.getKongUrl()}/aps/v1/applications`;
    }
    createOne(id, supplier_id) {
        const url = `${this._svcUrl}/${id}/suppliers`;
        return this._httpClient
            .post(url, { supplier_id }, { headers: setRequestOptions() })
            .pipe(map((res) => res?.data?.supplier_id));
    }
    getAll(id) {
        const url = `${this._svcUrl}/${id}/suppliers`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data?.supplier_ids || []));
    }
    deleteOne(id, supplier_id) {
        const url = `${this._svcUrl}/${id}/suppliers/${supplier_id}`;
        return this._httpClient.delete(url, {
            headers: setRequestOptions(),
        });
    }
    deleteAll(id) {
        const url = `${this._svcUrl}/${id}/suppliers`;
        return this._httpClient.delete(url, {
            headers: setRequestOptions(),
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationSupplierService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationSupplierService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationSupplierService, decorators: [{
            type: Injectable
        }] });

const APPLICATION_SUPPLIER_SERVICE_TOKEN = new InjectionToken('APPLICATION_SUPPLIER_SERVICE_TOKEN');

function provideApplicationSupplierService() {
    return [
        provideUtilsService(),
        {
            provide: APPLICATION_SUPPLIER_SERVICE_TOKEN,
            useClass: ApplicationSupplierService,
            deps: [HttpClient, UTILS_SERVICE_TOKEN],
        },
    ];
}

function injectApplicationSupplierService(injector) {
    !injector && assertInInjectionContext(injectApplicationSupplierService);
    const assertedInjector = injector ?? inject(Injector);
    return assertedInjector.get(APPLICATION_SUPPLIER_SERVICE_TOKEN);
}

class FSWWorldCheckLinkService {
    constructor() {
        this._httpClient = inject(HttpClient);
        this._utilsService = inject(UTILS_SERVICE_TOKEN);
        this._svcUrl = `${this._utilsService.getKongUrl()}/ext/api/world_check/link`;
    }
    queryAsync(entity, key, { with_detail, with_snapshot }, no_cache = false, no_lock = false) {
        const url = `${this._svcUrl}/${entity}/${key}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
            params: {
                with_detail,
                with_snapshot,
                ...(no_cache ? { no_cache } : {}),
                ...(no_lock ? { no_lock } : {}),
            },
        })
            .pipe(map$1((res) => res?.data || []));
    }
    insertAsync(entity, key, caseId) {
        const url = `${this._svcUrl}/${entity}/${key}/${caseId}`;
        return this._httpClient.post(url, { caseId }, {
            headers: setRequestOptions(),
        });
    }
    deleteAsync(entity, key, caseId) {
        const url = `${this._svcUrl}/${entity}/${key}/${caseId}`;
        return this._httpClient.delete(url, {
            headers: setRequestOptions(),
        });
    }
}
function provideFSWWorldCheckLinkService() {
    return [
        provideUtilsService(),
        {
            provide: FSWWorldCheckLinkService,
            useClass: FSWWorldCheckLinkService,
            deps: [HttpClient, UTILS_SERVICE_TOKEN],
        },
    ];
}
function injectFSWWorldCheckLinkService() {
    return inject(FSWWorldCheckLinkService);
}

class FSWWorldCheckSnapshotService {
    constructor() {
        this._httpClient = inject(HttpClient);
        this._utilsService = inject(UTILS_SERVICE_TOKEN);
        this._svcUrl = `${this._utilsService.getKongUrl()}/ext/api/world_check/snapshot`;
    }
    queryAsync({ queryId, queryCaseId, queryLinkId, } = {
        queryId: {},
        queryCaseId: {},
    }, no_cache = false, no_lock = false) {
        const url = `${this._svcUrl}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
            params: {
                ...queryId,
                ...queryCaseId,
                ...queryLinkId,
                ...(no_cache ? { no_cache } : {}),
                ...(no_lock ? { no_lock } : {}),
                omitData: true,
            },
        })
            .pipe(map$1((res) => res?.data || []));
    }
    triggerAsync(caseId, linkId) {
        const url = `${this._svcUrl}`;
        return this._httpClient
            .post(url, {}, {
            headers: setRequestOptions(),
            params: { caseId, ...(linkId ? { linkId } : {}) },
        })
            .pipe(map$1((res) => res?.data));
    }
    reTriggerAsync(snapshotId, caseId, linkId) {
        const url = `${this._svcUrl}/${snapshotId}`;
        return this._httpClient.put(url, {}, {
            headers: setRequestOptions(),
            params: {
                caseId,
                ...(linkId ? { linkId } : {}),
                ...(snapshotId ? { snapshotId } : {}),
            },
        });
    }
    deleteAsync(snapshotId, caseId, linkId) {
        const url = `${this._svcUrl}/${snapshotId}`;
        return this._httpClient.delete(url, {
            headers: setRequestOptions(),
            params: {
                caseId,
                ...(linkId ? { linkId } : {}),
                ...(snapshotId ? { snapshotId } : {}),
            },
        });
    }
}
function provideFSWWorldCheckSnapshotService() {
    return [
        provideUtilsService(),
        {
            provide: FSWWorldCheckSnapshotService,
            useClass: FSWWorldCheckSnapshotService,
            deps: [HttpClient, UTILS_SERVICE_TOKEN],
        },
    ];
}
function injectFSWWorldCheckSnapshotService() {
    return inject(FSWWorldCheckSnapshotService);
}

class FSWWorldCheckActivityService {
    constructor() {
        this._httpClient = inject(HttpClient);
        this._utilsService = inject(UTILS_SERVICE_TOKEN);
        this._svcUrl = `${this._utilsService.getKongUrl()}/ext/api/world_check/activity`;
    }
    queryAsync(params, no_cache = false, no_lock = false) {
        const url = `${this._svcUrl}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
            params: {
                ...params,
                ...(no_cache ? { no_cache } : {}),
                ...(no_lock ? { no_lock } : {}),
            },
        })
            .pipe(map$1((res) => res?.data || []));
    }
}
function provideFSWWorldCheckActivityService() {
    return [
        provideUtilsService(),
        {
            provide: FSWWorldCheckActivityService,
            useClass: FSWWorldCheckActivityService,
            deps: [HttpClient, UTILS_SERVICE_TOKEN],
        },
    ];
}
function injectFSWWorldCheckActivityService() {
    return inject(FSWWorldCheckActivityService);
}

class FSWWorldCheckSupplementService {
    constructor() {
        this._httpClient = inject(HttpClient);
        this._utilsService = inject(UTILS_SERVICE_TOKEN);
        this._svcUrl = `${this._utilsService.getKongUrl()}/ext/api/world_check/supplement`;
    }
    patchAsync(caseId, edd, linkId, snapshotId) {
        const url = `${this._svcUrl}/cases/${caseId}/edd`;
        return this._httpClient.patch(url, { edd }, {
            headers: setRequestOptions(),
            params: {
                caseId,
                ...(linkId ? { linkId } : {}),
                ...(snapshotId ? { snapshotId } : {}),
            },
        });
    }
}
function provideFSWWorldCheckSupplementService() {
    return [
        provideUtilsService(),
        {
            provide: FSWWorldCheckSupplementService,
            useClass: FSWWorldCheckSupplementService,
            deps: [HttpClient, UTILS_SERVICE_TOKEN],
        },
    ];
}
function injectFSWWorldCheckSupplementService() {
    return inject(FSWWorldCheckSupplementService);
}

class FSWWorldCheckAdapterMasterService {
    constructor() {
        this._httpClient = inject(HttpClient);
        this._utilsService = inject(UTILS_SERVICE_TOKEN);
        this._svcUrl = `${this._utilsService.getKongUrl()}/ext/api/world_check/adapter/master`;
    }
    getAsync(query, no_cache = false, no_lock = false) {
        const url = `${this._svcUrl}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
            params: { ...query, ...(no_cache ? { no_cache } : {}), ...(no_lock ? { no_lock } : {}) },
        })
            .pipe(map((res) => (res?.data ?? {})));
    }
    getBySectionAsync(section, query, no_cache = false, no_lock = false) {
        const url = `${this._svcUrl}/${section}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
            params: { ...query, ...(no_cache ? { no_cache } : {}), ...(no_lock ? { no_lock } : {}) },
        })
            .pipe(map((res) => (res?.data ?? [])));
    }
}
function provideFSWWorldCheckAdapterMasterService() {
    return [
        provideUtilsService(),
        {
            provide: FSWWorldCheckAdapterMasterService,
            useClass: FSWWorldCheckAdapterMasterService,
            deps: [HttpClient, UTILS_SERVICE_TOKEN],
        },
    ];
}
function injectFSWWorldCheckAdapterMasterService() {
    return inject(FSWWorldCheckAdapterMasterService);
}

class FSWWorldCheckAdapterCaseService {
    constructor() {
        this._httpClient = inject(HttpClient);
        this._utilsService = inject(UTILS_SERVICE_TOKEN);
        this._svcUrl = `${this._utilsService.getKongUrl()}/ext/api/world_check/adapter/cases`;
    }
    getByIdAsync(caseId, withSupplement = false, linkId, snapshotId, no_cache = false, no_lock = false) {
        const url = `${this._svcUrl}/${caseId}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
            params: {
                withSupplement,
                caseId,
                ...(snapshotId ? { snapshotId } : {}),
                ...(linkId ? { linkId } : {}),
                ...(no_cache ? { no_cache } : {}),
                ...(no_lock ? { no_lock } : {}),
            },
        })
            .pipe(map((res) => (res?.data ?? {})));
    }
    getResultsByIdAsync(caseId, linkId, snapshotId, no_cache = false, no_lock = false) {
        const url = `${this._svcUrl}/${caseId}/results`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
            params: {
                caseId,
                ...(linkId ? { linkId } : {}),
                ...(snapshotId ? { snapshotId } : {}),
                ...(no_cache ? { no_cache } : {}),
                ...(no_lock ? { no_lock } : {}),
            },
        })
            .pipe(map((res) => res?.data || []));
    }
    getResultRecordAsync(caseId, resultId, linkId, snapshotId, no_cache = false, no_lock = false) {
        const url = `${this._svcUrl}/${caseId}/results/${resultId}/record`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
            params: {
                caseId,
                resultId,
                ...(linkId ? { linkId } : {}),
                ...(snapshotId ? { snapshotId } : {}),
                ...(no_cache ? { no_cache } : {}),
                ...(no_lock ? { no_lock } : {}),
            },
        })
            .pipe(map((res) => (res?.data || {})));
    }
    archiveAsync(caseId, linkId, snapshotId) {
        const url = `${this._svcUrl}/${caseId}/archive`;
        return this._httpClient.put(url, {}, {
            headers: setRequestOptions(),
            params: {
                caseId,
                ...(linkId ? { linkId } : {}),
                ...(snapshotId ? { snapshotId } : {}),
            },
        });
    }
    unArchiveAsync(caseId, linkId, snapshotId) {
        const url = `${this._svcUrl}/${caseId}/archive`;
        return this._httpClient.delete(url, {
            headers: setRequestOptions(),
            params: {
                caseId,
                ...(linkId ? { linkId } : {}),
                ...(snapshotId ? { snapshotId } : {}),
            },
        });
    }
    assignAsync(caseId, payload, linkId, snapshotId) {
        const url = `${this._svcUrl}/${caseId}/assignee`;
        return this._httpClient.put(url, payload, {
            headers: setRequestOptions(),
            params: {
                caseId,
                ...(linkId ? { linkId } : {}),
                ...(snapshotId ? { snapshotId } : {}),
            },
        });
    }
    unAssignAsync(caseId, linkId, snapshotId) {
        const url = `${this._svcUrl}/${caseId}/assignee`;
        return this._httpClient.delete(url, {
            headers: setRequestOptions(),
            params: {
                caseId,
                ...(linkId ? { linkId } : {}),
                ...(snapshotId ? { snapshotId } : {}),
            },
        });
    }
    reScreenAsync(caseId, payload, linkId, snapshotId) {
        const url = `${this._svcUrl}/${caseId}/re_screen`;
        return this._httpClient
            .post(url, payload, {
            headers: setRequestOptions(),
            params: {
                caseId,
                ...(linkId ? { linkId } : {}),
                ...(snapshotId ? { snapshotId } : {}),
            },
        })
            .pipe(map((res) => res?.data));
    }
    resolutionAsync(caseId, payload, linkId, snapshotId) {
        const url = `${this._svcUrl}/${caseId}/results/resolution`;
        return this._httpClient.put(url, payload, {
            headers: setRequestOptions(),
            params: {
                caseId,
                ...(linkId ? { linkId } : {}),
                ...(snapshotId ? { snapshotId } : {}),
            },
        });
    }
    reviewAsync(caseId, payload, linkId, snapshotId) {
        const url = `${this._svcUrl}/${caseId}/results/review`;
        return this._httpClient.put(url, payload, {
            headers: setRequestOptions(),
            params: {
                caseId,
                ...(linkId ? { linkId } : {}),
                ...(snapshotId ? { snapshotId } : {}),
            },
        });
    }
    createAsync(payload) {
        const url = `${this._svcUrl}`;
        return this._httpClient
            .post(url, payload, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    updateAsync(caseId, payload, snapshotId, linkId) {
        const url = `${this._svcUrl}/${caseId}`;
        return this._httpClient
            .put(url, payload, {
            headers: setRequestOptions(),
            params: {
                caseId,
                ...(snapshotId ? { snapshotId } : {}),
                ...(linkId ? { linkId } : {}),
            },
        })
            .pipe(map((res) => res?.data));
    }
    searchAsync(params, no_cache = false, no_lock = false) {
        const url = `${this._svcUrl}/search`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
            params: {
                ...params,
                ...(no_cache ? { no_cache } : {}),
                ...(no_lock ? { no_lock } : {}),
            },
        })
            .pipe(map((res) => res?.data));
    }
}
function provideFSWWorldCheckAdapterCaseService() {
    return [
        provideUtilsService(),
        {
            provide: FSWWorldCheckAdapterCaseService,
            useClass: FSWWorldCheckAdapterCaseService,
            deps: [HttpClient, UTILS_SERVICE_TOKEN],
        },
    ];
}
function injectFSWWorldCheckAdapterCaseService() {
    return inject(FSWWorldCheckAdapterCaseService);
}

var FSWWorldCheckCaseRating;
(function (FSWWorldCheckCaseRating) {
    FSWWorldCheckCaseRating["HIGH"] = "HIGH";
    FSWWorldCheckCaseRating["MEDIUM"] = "MEDIUM";
    FSWWorldCheckCaseRating["LOW"] = "LOW";
    FSWWorldCheckCaseRating["NOT_RATED"] = "NOT_RATED";
    FSWWorldCheckCaseRating["NO_RISK"] = "NO_RISK";
    FSWWorldCheckCaseRating["UNKNOWN"] = "UNKNOWN";
})(FSWWorldCheckCaseRating || (FSWWorldCheckCaseRating = {}));

var FSWWorldCheckDetailLevels;
(function (FSWWorldCheckDetailLevels) {
    FSWWorldCheckDetailLevels["CASE"] = "CASE";
    FSWWorldCheckDetailLevels["CASE_AND_RESULTS"] = "CASE_AND_RESULTS";
    FSWWorldCheckDetailLevels["CASE_AND_AGGREGATED_RESULTS"] = "CASE_AND_AGGREGATED_RESULTS";
    FSWWorldCheckDetailLevels["CASE_AND_RESULTS_AND_AGGREGATED_RESULTS"] = "CASE_AND_RESULTS_AND_AGGREGATED_RESULTS";
})(FSWWorldCheckDetailLevels || (FSWWorldCheckDetailLevels = {}));

var FSWWorldCheckEntityTypes;
(function (FSWWorldCheckEntityTypes) {
    FSWWorldCheckEntityTypes["ORGANISATION"] = "ORGANISATION";
    FSWWorldCheckEntityTypes["INDIVIDUAL"] = "INDIVIDUAL";
    FSWWorldCheckEntityTypes["VESSEL"] = "VESSEL";
    FSWWorldCheckEntityTypes["UNSPECIFIED"] = "UNSPECIFIED";
})(FSWWorldCheckEntityTypes || (FSWWorldCheckEntityTypes = {}));

var FSWWorldCheckGenders;
(function (FSWWorldCheckGenders) {
    FSWWorldCheckGenders["UNSPECIFIED"] = "UNSPECIFIED";
    FSWWorldCheckGenders["MALE"] = "MALE";
    FSWWorldCheckGenders["FEMALE"] = "FEMALE";
})(FSWWorldCheckGenders || (FSWWorldCheckGenders = {}));

var FSWWorldCheckLifecycleStates;
(function (FSWWorldCheckLifecycleStates) {
    FSWWorldCheckLifecycleStates["ARCHIVED"] = "ARCHIVED";
    FSWWorldCheckLifecycleStates["UNARCHIVED"] = "UNARCHIVED";
})(FSWWorldCheckLifecycleStates || (FSWWorldCheckLifecycleStates = {}));

var FSWWorldCheckMandatoryActions;
(function (FSWWorldCheckMandatoryActions) {
    FSWWorldCheckMandatoryActions["REVIEW_REQUIRED"] = "REVIEW_REQUIRED";
    FSWWorldCheckMandatoryActions["UNRESOLVED_MATCHES"] = "UNRESOLVED_MATCHES";
})(FSWWorldCheckMandatoryActions || (FSWWorldCheckMandatoryActions = {}));

var FSWWorldCheckProviderTypes;
(function (FSWWorldCheckProviderTypes) {
    FSWWorldCheckProviderTypes["WATCHLIST"] = "WATCHLIST";
    FSWWorldCheckProviderTypes["PASSPORT_CHECK"] = "PASSPORT_CHECK";
    FSWWorldCheckProviderTypes["CLIENT_WATCHLIST"] = "CLIENT_WATCHLIST";
    FSWWorldCheckProviderTypes["MEDIA_CHECK"] = "MEDIA_CHECK";
})(FSWWorldCheckProviderTypes || (FSWWorldCheckProviderTypes = {}));

var FSWWorldCheckQueryBy;
(function (FSWWorldCheckQueryBy) {
    FSWWorldCheckQueryBy["PRIMARY_NAME"] = "PRIMARY_NAME";
    FSWWorldCheckQueryBy["CASE_ID"] = "CASE_ID";
    FSWWorldCheckQueryBy["ID_NUMBERS_VALUE"] = "ID_NUMBERS_VALUE";
})(FSWWorldCheckQueryBy || (FSWWorldCheckQueryBy = {}));

var FSWWorldCheckReportFilters;
(function (FSWWorldCheckReportFilters) {
    FSWWorldCheckReportFilters["includeUnresolvedMatches"] = "includeUnresolvedMatches";
    FSWWorldCheckReportFilters["includePositiveMatches"] = "includePositiveMatches";
    FSWWorldCheckReportFilters["includePossibleMatches"] = "includePossibleMatches";
    FSWWorldCheckReportFilters["includeFalseMatches"] = "includeFalseMatches";
    FSWWorldCheckReportFilters["includeUnspecifiedMatches"] = "includeUnspecifiedMatches";
    FSWWorldCheckReportFilters["includeAudit"] = "includeAudit";
    FSWWorldCheckReportFilters["includePassportCheck"] = "includePassportCheck";
    FSWWorldCheckReportFilters["includeMediaCheckFullArticles"] = "includeMediaCheckFullArticles";
    FSWWorldCheckReportFilters["includeMediaCheckHeadlines"] = "includeMediaCheckHeadlines";
})(FSWWorldCheckReportFilters || (FSWWorldCheckReportFilters = {}));

var FSWWorldCheckScreeningModes;
(function (FSWWorldCheckScreeningModes) {
    FSWWorldCheckScreeningModes["FULL_SYNC"] = "FULL_SYNC";
    FSWWorldCheckScreeningModes["FULL_ASYNC"] = "FULL_ASYNC";
    FSWWorldCheckScreeningModes["DELTA_SYNC"] = "DELTA_SYNC";
    FSWWorldCheckScreeningModes["DELTA_ASYNC"] = "DELTA_ASYNC";
})(FSWWorldCheckScreeningModes || (FSWWorldCheckScreeningModes = {}));

var FSWWorldCheckWatchlistCaseScreeningStates;
(function (FSWWorldCheckWatchlistCaseScreeningStates) {
    FSWWorldCheckWatchlistCaseScreeningStates["ONGOING"] = "ONGOING";
    FSWWorldCheckWatchlistCaseScreeningStates["INITIAL"] = "INITIAL";
})(FSWWorldCheckWatchlistCaseScreeningStates || (FSWWorldCheckWatchlistCaseScreeningStates = {}));

var FSWWorldCheckWatchlistResolvedByCategory;
(function (FSWWorldCheckWatchlistResolvedByCategory) {
    FSWWorldCheckWatchlistResolvedByCategory["LAW_ENFORCEMENT"] = "Law Enforcement";
    FSWWorldCheckWatchlistResolvedByCategory["OTHER_BODIES"] = "Other Bodies";
    FSWWorldCheckWatchlistResolvedByCategory["REGULATORY_ENFORCEMENT"] = "Regulatory Enforcement";
    FSWWorldCheckWatchlistResolvedByCategory["SANCTIONS"] = "Sanctions";
    FSWWorldCheckWatchlistResolvedByCategory["PEP"] = "PEP";
    FSWWorldCheckWatchlistResolvedByCategory["SIC"] = "Special Interest Categories";
})(FSWWorldCheckWatchlistResolvedByCategory || (FSWWorldCheckWatchlistResolvedByCategory = {}));
var FSWWorldCheckWatchlistResolvedByResolutionStatus;
(function (FSWWorldCheckWatchlistResolvedByResolutionStatus) {
    FSWWorldCheckWatchlistResolvedByResolutionStatus["UNRESOLVED"] = "UNRESOLVED";
    FSWWorldCheckWatchlistResolvedByResolutionStatus["POSITIVE"] = "POSITIVE";
    FSWWorldCheckWatchlistResolvedByResolutionStatus["POSSIBLE"] = "POSSIBLE";
    FSWWorldCheckWatchlistResolvedByResolutionStatus["UNSPECIFIED"] = "UNSPECIFIED";
    FSWWorldCheckWatchlistResolvedByResolutionStatus["FALSE"] = "FALSE";
})(FSWWorldCheckWatchlistResolvedByResolutionStatus || (FSWWorldCheckWatchlistResolvedByResolutionStatus = {}));
var FSWWorldCheckWatchlistResolvedByRiskLevel;
(function (FSWWorldCheckWatchlistResolvedByRiskLevel) {
    FSWWorldCheckWatchlistResolvedByRiskLevel["HIGH"] = "HIGH";
    FSWWorldCheckWatchlistResolvedByRiskLevel["MEDIUM"] = "MEDIUM";
    FSWWorldCheckWatchlistResolvedByRiskLevel["LOW"] = "LOW";
    FSWWorldCheckWatchlistResolvedByRiskLevel["NOT_RATED"] = "NOT_RATED";
    FSWWorldCheckWatchlistResolvedByRiskLevel["NO_RISK"] = "NO_RISK";
    FSWWorldCheckWatchlistResolvedByRiskLevel["UNKNOWN"] = "UNKNOWN";
})(FSWWorldCheckWatchlistResolvedByRiskLevel || (FSWWorldCheckWatchlistResolvedByRiskLevel = {}));

var FSWWorldCheckWatchlistReviewRequired;
(function (FSWWorldCheckWatchlistReviewRequired) {
    FSWWorldCheckWatchlistReviewRequired["LAW_ENFORCEMENT"] = "LAW_ENFORCEMENT";
    FSWWorldCheckWatchlistReviewRequired["OTHER_BODIES"] = "OTHER_BODIES";
    FSWWorldCheckWatchlistReviewRequired["REGULATORY_ENFORCEMENT"] = "REGULATORY_ENFORCEMENT";
    FSWWorldCheckWatchlistReviewRequired["SANCTIONS"] = "SANCTIONS";
    FSWWorldCheckWatchlistReviewRequired["PEP"] = "PEP";
    FSWWorldCheckWatchlistReviewRequired["SIC"] = "SIC";
})(FSWWorldCheckWatchlistReviewRequired || (FSWWorldCheckWatchlistReviewRequired = {}));

var FSWWorldCheckWatchlistUnresolved;
(function (FSWWorldCheckWatchlistUnresolved) {
    FSWWorldCheckWatchlistUnresolved["LAW_ENFORCEMENT"] = "LAW_ENFORCEMENT";
    FSWWorldCheckWatchlistUnresolved["OTHER_BODIES"] = "OTHER_BODIES";
    FSWWorldCheckWatchlistUnresolved["REGULATORY_ENFORCEMENT"] = "REGULATORY_ENFORCEMENT";
    FSWWorldCheckWatchlistUnresolved["SANCTIONS"] = "SANCTIONS";
    FSWWorldCheckWatchlistUnresolved["PEP"] = "PEP";
    FSWWorldCheckWatchlistUnresolved["SIC"] = "SIC";
})(FSWWorldCheckWatchlistUnresolved || (FSWWorldCheckWatchlistUnresolved = {}));

function getListByEnum(obj) {
    return Object.values(obj).map((value) => ({
        value,
        text: value,
    }));
}
const { fswWorldCheckCaseRating, fswWorldCheckGenders, fswWorldCheckDetailLevels, fswWorldCheckEntityTypes, fswWorldCheckLifecycleStates, fswWorldCheckMandatoryActions, fswWorldCheckProviderTypes, fswWorldCheckQueryBy, fswWorldCheckReportFilters, fswWorldCheckScreeningModes, fswWorldCheckWatchlistCaseScreeningStates, fswWorldCheckWatchlistResolvedByCategory, fswWorldCheckWatchlistResolvedByResolutionStatus, fswWorldCheckWatchlistResolvedByRiskLevel, fswWorldCheckWatchlistReviewRequired, fswWorldCheckWatchlistUnresolved, fswWorldCheckPassportDocumentType, } = {
    fswWorldCheckPassportDocumentType: [
        {
            value: 'PASSPORT',
            text: 'Passport',
        },
        {
            value: 'ID1',
            text: 'ID-Card Type 1 (3 lines)',
        },
        {
            value: 'ID2',
            text: 'ID-Card Type 2 (2 lines)',
        },
    ],
    fswWorldCheckCaseRating: getListByEnum(FSWWorldCheckCaseRating),
    fswWorldCheckGenders: getListByEnum(FSWWorldCheckGenders),
    fswWorldCheckDetailLevels: [
        {
            value: FSWWorldCheckDetailLevels.CASE,
            text: 'Case',
        },
        {
            value: FSWWorldCheckDetailLevels.CASE_AND_AGGREGATED_RESULTS,
            text: 'Case and Aggregated Results',
        },
        {
            value: FSWWorldCheckDetailLevels.CASE_AND_RESULTS,
            text: 'Case and Results',
        },
        {
            value: FSWWorldCheckDetailLevels.CASE_AND_RESULTS_AND_AGGREGATED_RESULTS,
            text: 'Case and Results and Aggregated Results',
        },
    ],
    fswWorldCheckEntityTypes: getListByEnum(FSWWorldCheckEntityTypes),
    fswWorldCheckLifecycleStates: getListByEnum(FSWWorldCheckLifecycleStates),
    fswWorldCheckMandatoryActions: getListByEnum(FSWWorldCheckMandatoryActions),
    fswWorldCheckProviderTypes: getListByEnum(FSWWorldCheckProviderTypes),
    fswWorldCheckQueryBy: [
        {
            value: FSWWorldCheckQueryBy.PRIMARY_NAME,
            text: 'Primary Name',
        },
        {
            value: FSWWorldCheckQueryBy.CASE_ID,
            text: 'Case ID',
        },
        {
            value: FSWWorldCheckQueryBy.ID_NUMBERS_VALUE,
            text: 'ID Numbers Value',
        },
    ],
    fswWorldCheckReportFilters: getListByEnum(FSWWorldCheckReportFilters),
    fswWorldCheckScreeningModes: getListByEnum(FSWWorldCheckScreeningModes),
    fswWorldCheckWatchlistCaseScreeningStates: getListByEnum(FSWWorldCheckWatchlistCaseScreeningStates),
    fswWorldCheckWatchlistResolvedByCategory: getListByEnum(FSWWorldCheckWatchlistResolvedByCategory),
    fswWorldCheckWatchlistResolvedByResolutionStatus: getListByEnum(FSWWorldCheckWatchlistResolvedByResolutionStatus),
    fswWorldCheckWatchlistResolvedByRiskLevel: getListByEnum(FSWWorldCheckWatchlistResolvedByRiskLevel),
    fswWorldCheckWatchlistReviewRequired: getListByEnum(FSWWorldCheckWatchlistReviewRequired),
    fswWorldCheckWatchlistUnresolved: getListByEnum(FSWWorldCheckWatchlistUnresolved),
};

function resolveError(exception, alertService, defaultErrorTitle, defaultErrorMessage) {
    const { error } = exception;
    if (!error) {
        alertService.error(defaultErrorTitle, exception?.message || defaultErrorMessage, {
            duration: 3000,
        });
        return;
    }
    if (isArray(error)) {
        error.forEach(({ cause, error }) => {
            alertService.error(cause ? error : defaultErrorTitle, cause ? cause : error ?? defaultErrorMessage, {
                duration: 3000,
            });
        });
    }
    else {
        alertService.error(error.cause ? error.error : defaultErrorTitle, error.cause ? error.cause : error.error ?? defaultErrorMessage, {
            duration: 3000,
        });
    }
}

const personalGuarantorForm = {
    id: (config) => dynamicForm.template('id', { isHidden: true }, config),
    id_number: (config) => dynamicForm.template('id_number', { isHidden: true }, config),
    age: (config) => dynamicForm.number('age', {
        min: 0,
    }, config),
    name: (config) => dynamicForm.text('name', {}, config),
    gender: (config, items = (config?.pickList?.genders || []).map((gender) => ({
        value: gender.code,
        text: gender.name,
    }))) => dynamicForm.select('gender', {
        items,
        readonlyTemplate: (value) => items.find((item) => item.value === value)?.text ?? 'N/A',
    }, config),
    nationality: (config) => dynamicForm.text('nationality', {}, config),
    race: (config, items = config?.pickList?.races || []) => dynamicForm.select('race', {
        items,
        readonlyTemplate: (value) => items.find((item) => item.value === value)?.text ?? 'N/A',
    }, config),
    role: (config, items = (config?.pickList?.designations || []).map((item) => ({
        text: item.name,
        value: item.name,
    }))) => dynamicForm.select('role', {
        items,
        readonlyTemplate: (value) => items.find((item) => item.value === value)?.text ?? 'N/A',
    }, config),
    shareholder_percentage: (config) => dynamicForm.maskFloat('shareholder_percentage', {
        min: 0,
        max: 100,
        suffix: '%',
    }, config),
    negative_and_black_list: (config) => dynamicForm.text('negative_and_black_list', {}, config),
    num_of_borrowing: (config) => dynamicForm.maskInt('num_of_borrowing', {}, config),
    noa_year1: (config, items = lastTenYearsSelectOptions()) => dynamicForm.select('noa_year1', {
        items,
        readonlyTemplate: (value) => items.find((item) => item.value === value)?.text ?? 'N/A',
    }, config),
    noa_year1_total_income: (config) => dynamicForm.maskFloat('noa_year1_total_income', {}, config),
    noa_year2: (config, items = lastTenYearsSelectOptions()) => dynamicForm.select('noa_year2', {
        items,
        readonlyTemplate: (value) => items.find((item) => item.value === value)?.text ?? 'N/A',
    }, config),
    noa_year2_total_income: (config) => dynamicForm.maskFloat('noa_year2_total_income', {}, config),
    total_borrowing_limit: (config) => dynamicForm.maskFloat('total_borrowing_limit', {}, config),
    total_borrowing_outstanding: (config) => dynamicForm.maskFloat('total_borrowing_outstanding', {}, config),
    date_of_birth: (config) => dynamicForm.date('date_of_birth', {}, config),
    litigation: (config) => dynamicForm.text('litigation', {
        inputType: 'area',
    }, config),
    background_and_experience: (config) => dynamicForm.text('background_and_experience', {
        inputType: 'area',
    }, config),
    month_of_experience: (config) => dynamicForm.maskInt('month_of_experience', {}, config),
    // MY fields
    total_monthly_commitment_non_bank_lender: (config) => dynamicForm.maskFloat('total_monthly_commitment_non_bank_lender', {}, config),
    num_of_recent_credit_applications: (config) => dynamicForm.maskInt('num_of_recent_credit_applications', {}, config),
    total_outstanding_amount_trade_reference: (config) => dynamicForm.maskFloat('total_outstanding_amount_trade_reference', {}, config),
    does_own_property_in_my: (config) => dynamicForm.checkbox('does_own_property_in_my', {}, config),
    desktop_valuation_of_my_owned_property: (config) => dynamicForm.maskFloat('desktop_valuation_of_my_owned_property', {}, config),
    total_monthly_commitment: (config) => dynamicForm.maskFloat('total_monthly_commitment', {}, config),
    credit_application_commitment: (config) => dynamicForm.maskFloat('credit_application_commitment', {}, config),
    payment_behavior: (config, items = paymentBehaviors[getCountryCodeFromStorage()] || []) => dynamicForm.select('payment_behavior', {
        items,
        readonlyTemplate: (value) => items.find((item) => item.value === value)?.text ?? 'N/A',
    }, config),
    // SG fields
    experian_expected_default: (config) => dynamicForm.text('experian_expected_default', {}, config),
    experian_payment_grade: (config, items = FSWExperianPaymentGradeArray) => dynamicForm.select('experian_payment_grade', {
        items,
        readonlyTemplate: (value) => items.find((item) => item.value === value)?.text ?? 'N/A',
    }, config),
    cbs_rating: (config, items = FSWCBSRatingArray) => dynamicForm.select('cbs_rating', {
        items,
        readonlyTemplate: (value) => items.find((item) => item.value === value)?.text ?? 'N/A',
    }, config),
    cbs_total_unsecured_limit: (config) => dynamicForm.maskFloat('cbs_total_unsecured_limit', {
        prefix: getCurrentCountryConfig().currencySymbol,
    }, config),
    cbs_total_secured_limit: (config) => dynamicForm.maskFloat('cbs_total_secured_limit', {
        prefix: getCurrentCountryConfig().currencySymbol,
    }, config),
    cbs_bankruptcy_proceeding_count: (config) => dynamicForm.maskInt('cbs_bankruptcy_proceeding_count', {}, config),
    cbs_probability_of_default: (config) => dynamicForm.text('cbs_probability_of_default', {}, config),
    cbs_default_count: (config) => dynamicForm.maskFloat('cbs_default_count', {}, config),
    cbs_total_unsecured_balances_interest_bearing: (config) => dynamicForm.maskFloat('cbs_total_unsecured_balances_interest_bearing', {}, config),
    cbs_total_unsecured_balances_non_interest_bearing: (config) => dynamicForm.maskFloat('cbs_total_unsecured_balances_non_interest_bearing', {}, config),
    cbs_total_secured_balances: (config) => dynamicForm.maskFloat('cbs_total_secured_balances', {}, config),
    cbs_total_overdue_balances: (config) => dynamicForm.maskFloat('cbs_total_overdue_balances', {}, config),
    cbs_total_unsecured_outstanding_amount: (config) => dynamicForm.maskFloat('cbs_total_unsecured_outstanding_amount', {}, config),
    does_own_property_in_sg: (config) => dynamicForm.checkbox('does_own_property_in_sg', {}, config),
    child_relief: (config) => dynamicForm.text('child_relief', {}, config),
    country_where_main_operations_based_in: (config, items = (config?.pickList?.countries || []).map((country) => ({
        value: country.code,
        text: country.name,
    }))) => dynamicForm.select('country_where_main_operations_based_in', {
        items,
        readonlyTemplate: (value) => items.find((item) => item.value === value)?.text ?? 'N/A',
    }, config),
    desktop_valuation_of_sg_owned_property: (config) => dynamicForm.maskFloat('desktop_valuation_of_sg_owned_property', {}, config),
    num_of_pending_litigation: (config) => dynamicForm.maskInt('num_of_pending_litigation', {}, config),
    num_of_bankruptcy: (config) => dynamicForm.maskInt('num_of_bankruptcy', {}, config),
    num_of_ongoing_moneylender_loans: (config) => dynamicForm.maskInt('num_of_ongoing_moneylender_loans', {}, config),
};

const companyGuarantorForm = {
    name: (config) => dynamicForm.text('name', {}, config),
    registration_no: (config) => dynamicForm.text('registration_no', {}, config),
    incorporation_date: (config) => dynamicForm.date('incorporation_date', {}, config),
    paid_up_capital: (config) => dynamicForm.maskFloat('paid_up_capital', {
        readonlyTemplate: (value) => value
            ? new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)
            : '',
    }, config),
    paid_up_capital_currency: (config, items = (config?.pickList?.currencies || []).map((currency) => ({
        value: currency.code,
        text: `${currency.code} (${currency.symbol})`,
    }))) => dynamicForm.select('paid_up_capital_currency', {
        items,
        readonlyTemplate: (value) => items.find((item) => item.value === value)?.text ?? 'N/A',
    }, config),
    num_of_employee: (config) => dynamicForm.maskInt('num_of_employee', {}, config),
    num_of_customers: (config) => dynamicForm.maskInt('num_of_customers', {}, config),
    avg_num_of_days_to_pay_creditors: (config) => dynamicForm.maskInt('avg_num_of_days_to_pay_creditors', {}, config),
    industry_avg_num_of_days_to_pay_creditors: (config) => dynamicForm.maskInt('industry_avg_num_of_days_to_pay_creditors', {}, config),
    total_charges: (config) => dynamicForm.maskFloat('total_charges', {}, config),
    total_charges_currency: (config, items = (config?.pickList?.currencies || []).map((currency) => ({
        value: currency.code,
        text: currency.name,
    }))) => dynamicForm.select('total_charges_currency', {
        items,
        readonlyTemplate: (value) => items.find((item) => item.value === value)?.text ?? 'N/A',
    }, config),
    details_of_charges: (config) => dynamicForm.text('details_of_charges', {}, config),
    num_of_searches: (config) => dynamicForm.maskInt('num_of_searches', {}, config),
    negative_blacklist: (config) => dynamicForm.text('negative_blacklist', {}, config),
    litigation: (config) => dynamicForm.text('litigation', {
        inputType: 'area',
    }, config),
    experian_payment_grade: (config, items = FSWExperianPaymentGradeArray) => dynamicForm.select('experian_payment_grade', {
        items,
        readonlyTemplate: (value) => items.find((item) => item.value === value)?.text ?? 'N/A',
    }, config),
    experian_expected_default: (config) => dynamicForm.text('experian_expected_default', {}, config),
    total_num_of_legal_cases: (config) => dynamicForm.maskInt('total_num_of_legal_cases', {}, config),
    total_value_of_legal_cases: (config) => dynamicForm.maskFloat('total_value_of_legal_cases', {}, config),
    payment_behavior: (config, items = paymentBehaviors[getCountryCodeFromStorage()] || []) => dynamicForm.select('payment_behavior', {
        items,
        readonlyTemplate: (value) => items.find((item) => item.value === value)?.text ?? 'N/A',
    }, config),
    trade_reference: (config) => dynamicForm.text('trade_reference', {
        inputType: 'area',
    }, config),
    credit_bureau_probability_of_default: (config) => dynamicForm.text('credit_bureau_probability_of_default', {
        inputType: 'area',
    }, config),
    credit_bureau_rating: (config) => dynamicForm.text('credit_bureau_rating', {
        inputType: 'area',
    }, config),
    num_of_litigation_cases: (config) => dynamicForm.maskInt('num_of_litigation_cases', {}, config),
    business_nature: (config) => dynamicForm.text('business_nature', {
        inputType: 'area',
    }, config),
    value_of_litigation_cases: (config) => dynamicForm.maskFloat('value_of_litigation_cases', {}, config),
    outstanding_trade_amount: (config) => dynamicForm.maskFloat('outstanding_trade_amount', {}, config),
    status: (config) => dynamicForm.text('status', {}, config),
    has_dishonored_cheques_under_entity: (config) => dynamicForm.checkbox('has_dishonored_cheques_under_entity', {}, config),
    has_dishonored_cheques_under_related_parties: (config) => dynamicForm.checkbox('has_dishonored_cheques_under_related_parties', {}, config),
    has_legal_case_subject_as_defendant: (config) => dynamicForm.checkbox('has_legal_case_subject_as_defendant', {}, config),
    has_legal_case_subject_as_plaintiff: (config) => dynamicForm.checkbox('has_legal_case_subject_as_plaintiff', {}, config),
    has_anti_money_laundering_act_info: (config) => dynamicForm.checkbox('has_anti_money_laundering_act_info', {}, config),
    num_of_borrowing: (config) => dynamicForm.maskInt('num_of_borrowing', {}, config),
    total_borrowing_limit: (config) => dynamicForm.maskFloat('total_borrowing_limit', {}, config),
    total_borrowing_outstanding: (config) => dynamicForm.maskFloat('total_borrowing_outstanding', {}, config),
    ctos_grade: (config, items = paymentGrades) => dynamicForm.select('ctos_grade', {
        items,
        readonlyTemplate: (value) => items.find((item) => item.value === value)?.text ?? 'N/A',
    }, config),
    ctos_sme_score: (config) => dynamicForm.maskFloat('ctos_sme_score', {}, config),
    existing_working_capital_line: (config) => dynamicForm.maskFloat('existing_working_capital_line', {}, config),
    working_capital_line: (config) => dynamicForm.maskFloat('working_capital_line', {}, config),
    previous_loan_code: (config) => dynamicForm.text('previous_loan_code', {}, config),
    total_monthly_commitment: (config) => dynamicForm.maskFloat('total_monthly_commitment', {}, config),
    total_monthly_commitment_non_bank_lender: (config) => dynamicForm.maskFloat('total_monthly_commitment_non_bank_lender', {}, config),
    num_of_recent_credit_applications: (config) => dynamicForm.maskInt('num_of_recent_credit_applications', {}, config),
    credit_application_commitment: (config) => dynamicForm.maskFloat('credit_application_commitment', {}, config),
    id: (config) => dynamicForm.template('id', {}, config),
    partner_id: (config) => dynamicForm.maskNumber('partner_id', {}, config),
    company_industry: (config, items = (config?.pickList?.industries || []).map((item) => ({
        value: +item.id,
        text: item.name,
    }))) => dynamicForm.select('company_industry', {
        items,
        readonlyTemplate: (value) => items.find((item) => item.value === value)?.text ?? 'N/A',
    }, config),
    ssic_code: (config) => dynamicForm.text('ssic_code', {}, config),
    num_of_ongoing_moneylender_loans: (config) => dynamicForm.maskInt('num_of_ongoing_moneylender_loans', {}, config),
    trade_referee: (config) => dynamicForm.text('trade_referee', {}, config),
    category_for_trade_referee: (config) => dynamicForm.text('category_for_trade_referee', {}, config),
    msic_code: (config) => dynamicForm.text('msic_code', {}, config),
    entity_code: (config) => dynamicForm.text('entity_code', {}, config),
    has_bumiputera_shareholding: (config, items = [
        { value: true, text: 'Yes' },
        { value: false, text: 'No' },
    ]) => dynamicForm.select('has_bumiputera_shareholding', {
        items,
        readonlyTemplate: (value) => items.find((item) => item.value === value)?.text ?? 'N/A',
    }, config),
    bumiputera_shareholding_percentage: (config) => dynamicForm.maskFloat('bumiputera_shareholding_percentage', {}, config),
};

function transformCompanyGuarantor(data) {
    if (!data?.company) {
        return data;
    }
    const numberKeys = [
        'num_of_employee',
        'num_of_customers',
        'num_of_searches',
        'avg_num_of_days_to_pay_creditors',
        'total_charges',
        'total_num_of_legal_cases',
        'total_value_of_legal_cases',
        'industry_avg_num_of_days_to_pay_creditors',
        'num_of_litigation_cases',
        'value_of_litigation_cases',
        'outstanding_trade_amount',
        'num_of_borrowing',
        'total_borrowing_limit',
        'total_borrowing_outstanding',
        'total_monthly_commitment',
        'num_of_recent_credit_applications',
        'num_of_ongoing_moneylender_loans',
        // MY fields
        'ctos_sme_score',
        'total_monthly_commitment_non_bank_lender',
        'credit_application_commitment',
        // SG fields
    ];
    const numberCanNullKeys = [
        'paid_up_capital',
        'partner_id',
        'company_industry',
        'existing_working_capital_line',
        'working_capital_line',
        // MY fields
        'bumiputera_shareholding_percentage',
        // SG fields
    ];
    const stringKeys = [
        'id',
        'name',
        'registration_no',
        'paid_up_capital_currency',
        'total_charges_currency',
        'negative_blacklist',
        'payment_behavior',
        'trade_reference',
        'credit_bureau_probability_of_default',
        'credit_bureau_rating',
        'business_nature',
        'details_of_charges',
        'litigation',
        'experian_payment_grade',
        'status',
        'ssic_code',
        'entity_code',
        'financing_records',
        'trade_referee',
        'category_for_trade_referee',
        'msic_code',
        'previous_loan_code',
        // MY fields
        'ctos_grade',
        // SG fields
        'experian_expected_default',
    ];
    const booleanKeys = [
        'has_dishonored_cheques_under_entity',
        'has_dishonored_cheques_under_related_parties',
        'has_legal_case_subject_as_defendant',
        'has_legal_case_subject_as_plaintiff',
        'has_anti_money_laundering_act_info',
        // MY fields
        'has_bumiputera_shareholding',
    ];
    const defaultKeys = ['incorporation_date'];
    const combineKeys = [
        ...numberKeys,
        ...numberCanNullKeys,
        ...stringKeys,
        ...booleanKeys,
        ...defaultKeys,
    ];
    const cloneData = {};
    Object.keys(data.company).forEach((key) => {
        if (combineKeys.includes(key)) {
            cloneData[key] = data.company[key];
        }
    });
    return {
        ...data,
        company: {
            ...modelTransformer(cloneData, [
                {
                    keys: numberKeys,
                    cb: (value) => (isObjectValid(value) ? +value : 0),
                },
                {
                    keys: numberCanNullKeys,
                    cb: (value) => (isObjectValid(value) ? +value : null),
                },
                {
                    keys: stringKeys,
                    cb: (value) => (isObjectValid(value) ? `${value}` : null),
                },
                {
                    keys: booleanKeys,
                    cb: (value) => (isObjectValid(value) ? `${value}` === 'true' : null),
                },
                {
                    keys: defaultKeys,
                    cb: (value) => (isObjectValid(value) ? value : null),
                },
            ]),
        },
    };
}

function transformPersonalGuarantor(data) {
    if (!data) {
        return data;
    }
    const numberKeys = [
        'num_of_borrowing',
        'total_borrowing_limit',
        'shareholder_percentage',
        'total_borrowing_outstanding',
        'outstanding_trade_amount',
        'month_of_experience',
        // MY fields
        'total_monthly_commitment_non_bank_lender',
        'num_of_recent_credit_applications',
        'total_outstanding_amount_trade_reference',
        'total_monthly_commitment',
        'credit_application_commitment',
        // SG fields
        'cbs_total_unsecured_limit',
        'cbs_total_secured_limit',
        'cbs_bankruptcy_proceeding_count',
        'cbs_probability_of_default',
        'cbs_default_count',
        'cbs_total_unsecured_balances_interest_bearing',
        'cbs_total_unsecured_balances_non_interest_bearing',
        'cbs_total_secured_balances',
        'cbs_total_overdue_balances',
        'cbs_total_unsecured_outstanding_amount',
        'num_of_pending_litigation',
        'num_of_bankruptcy',
        'num_of_ongoing_moneylender_loans',
    ];
    const numberCanNullKeys = [
        'age',
        'noa_year1',
        'noa_year1_total_income',
        'noa_year2',
        'noa_year2_total_income',
        'desktop_valuation_of_my_owned_property',
        'desktop_valuation_of_sg_owned_property',
    ];
    const stringKeys = [
        'id',
        'name',
        'gender',
        'nationality',
        'race',
        'role',
        'negative_and_black_list',
        'litigation',
        'background_and_experience',
        'id_number',
        // MY fields
        'payment_behavior',
        // SG fields
        'experian_expected_default',
        'experian_payment_grade',
        'cbs_rating',
        'child_relief',
        'country_where_main_operations_based_in',
    ];
    const booleanKeys = [
        // MY fields
        'does_own_property_in_my',
        // SG fields
        'does_own_property_in_sg',
    ];
    const defaultKeys = ['date_of_birth'];
    const combineKeys = [
        ...numberKeys,
        ...numberCanNullKeys,
        ...stringKeys,
        ...booleanKeys,
        ...defaultKeys,
    ];
    const cloneData = {};
    Object.keys(data).forEach((key) => {
        if (combineKeys.includes(key)) {
            cloneData[key] = data[key];
        }
    });
    return modelTransformer(cloneData, [
        {
            keys: numberKeys,
            cb: (value) => (isObjectValid(value) ? +value : 0),
        },
        {
            keys: numberCanNullKeys,
            cb: (value) => (isObjectValid(value) ? +value : null),
        },
        {
            keys: stringKeys,
            cb: (value) => (isObjectValid(value) ? `${value}` : null),
        },
        {
            keys: booleanKeys,
            cb: (value) => (isObjectValid(value) ? `${value}` === 'true' : null),
        },
        {
            keys: defaultKeys,
            cb: (value) => (isObjectValid(value) ? value : null),
        },
    ]);
}

class GenericTableDataSource extends DataSource {
    constructor(_dataService, _extraQueryParams) {
        super();
        this._dataService = _dataService;
        this._extraQueryParams = _extraQueryParams;
        this._destroy$ = new Subject();
        this._dataListSubject = new BehaviorSubject([]);
        this._loadingSubject = new BehaviorSubject(false);
        this._totalCountSubject = new BehaviorSubject(0);
        this.loading$ = this._loadingSubject.asObservable();
        this.count$ = this._totalCountSubject.asObservable();
        // private readonly _toastrService = inject(ToastrService);
        // private readonly _mixPanelService = inject(MixpanelService);
        // private readonly _authService = inject(Auth0Service);
        this._alertService = inject(FSW_ALERT_SERVICE_TOKEN);
        this._setupSubscriptions();
    }
    connect() {
        return this._dataListSubject.asObservable();
    }
    disconnect() {
        this._cleanup();
    }
    loadData(filter = '', pageIndex, pageSize, status, startDate, endDate, sort, sort_type, facility_code) {
        this._loadingSubject.next(true);
        const params = {
            // ...(status && { status }),
            // limit: pageSize,
            // page: pageIndex + 1,
            // ...(filter && { search: filter }),
            // ...(startDate && { start_date: startDate }),
            // ...(endDate && { end_date: endDate }),
            // ...(sort && { sort }),
            // ...(sort_type && { sort_type }),
            // ...(facility_code && { facility_code }),
            ...this._extraQueryParams,
        };
        this._dataService
            .getData(params)
            .pipe(takeUntil(this._destroy$), finalize(() => this._loadingSubject.next(false)))
            .subscribe({
            next: (response) => {
                if (response?.data) {
                    this._dataListSubject.next(response.data);
                    this._totalCountSubject.next(response.total);
                }
            },
            error: (error) => {
                // this._toastrService.error(parseErrorMessage(error));
                this._alertService.error('[Error] Failed to load', null, {
                    duration: 3000,
                });
                // Reset data on error
                this._dataListSubject.next([]);
                this._totalCountSubject.next(0);
            },
        });
    }
    setPaginatorAndSort(paginator, sort) {
        this.paginator = paginator;
        this.sort = sort;
        this._setupSubscriptions();
    }
    selectRow(item) {
        const currentData = this._dataListSubject.value;
        currentData.forEach((dataItem) => (dataItem.selected = false));
        const selectedItem = currentData.find((dataItem) => dataItem === item);
        if (selectedItem) {
            selectedItem.selected = true;
        }
        this._dataListSubject.next(currentData);
    }
    _setupSubscriptions() {
        if (this.paginator) {
            this.paginator.page.pipe(takeUntil(this._destroy$)).subscribe(() => {
                this.loadData('', this.paginator.pageIndex, this.paginator.pageSize);
            });
        }
        if (this.sort) {
            this.sort.sortChange.pipe(takeUntil(this._destroy$)).subscribe(() => {
                if (this.paginator) {
                    this.paginator.pageIndex = 0;
                }
                this.loadData('', this.paginator?.pageIndex || 0, this.paginator?.pageSize || 10);
            });
        }
    }
    _cleanup() {
        this._destroy$.next();
        this._destroy$.complete();
        this._dataListSubject.complete();
        this._loadingSubject.complete();
        this._totalCountSubject.complete();
    }
}
// factory function to instantiate the data source
function createGenericTableDataSource(dataService, defaultQueryParams) {
    return new GenericTableDataSource(dataService, defaultQueryParams);
}

const CURRENCY_MASK_CONFIG = new InjectionToken('currency.mask.config');

class InputManager {
    constructor(htmlInputElement) {
        this.htmlInputElement = htmlInputElement;
    }
    setCursorAt(position) {
        if (this.htmlInputElement.setSelectionRange) {
            this.htmlInputElement.focus();
            this.htmlInputElement.setSelectionRange(position, position);
        }
        else if (this.htmlInputElement.createTextRange) {
            const textRange = this.htmlInputElement.createTextRange();
            textRange.collapse(true);
            textRange.moveEnd('character', position);
            textRange.moveStart('character', position);
            textRange.select();
        }
    }
    updateValueAndCursor(newRawValue, oldLength, selectionStart) {
        this.rawValue = newRawValue;
        const newLength = newRawValue.length;
        selectionStart = selectionStart - (oldLength - newLength);
        this.setCursorAt(selectionStart);
    }
    get canInputMoreNumbers() {
        const haventReachedMaxLength = !(this.rawValue.length >= this.htmlInputElement.maxLength &&
            this.htmlInputElement.maxLength >= 0);
        const selectionStart = this.inputSelection.selectionStart;
        const selectionEnd = this.inputSelection.selectionEnd;
        const haveNumberSelected = selectionStart != selectionEnd &&
            this.htmlInputElement.value.substring(selectionStart, selectionEnd).match(/\d/)
            ? true
            : false;
        const startWithZero = this.htmlInputElement.value.substring(0, 1) == '0';
        return haventReachedMaxLength || haveNumberSelected || startWithZero;
    }
    get inputSelection() {
        let selectionStart = 0;
        let selectionEnd = 0;
        if (typeof this.htmlInputElement.selectionStart == 'number' &&
            typeof this.htmlInputElement.selectionEnd == 'number') {
            selectionStart = this.htmlInputElement.selectionStart;
            selectionEnd = this.htmlInputElement.selectionEnd;
        }
        else {
            const range = document.getSelection().baseNode;
            if (range && range.firstChild == this.htmlInputElement) {
                const lenght = this.htmlInputElement.value.length;
                const normalizedValue = this.htmlInputElement.value.replace(/\r\n/g, '\n');
                const startRange = this.htmlInputElement.createTextRange();
                const endRange = this.htmlInputElement.createTextRange();
                endRange.collapse(false);
                if (startRange.compareEndPoints('StartToEnd', endRange) > -1) {
                    selectionStart = selectionEnd = lenght;
                }
                else {
                    selectionStart = -startRange.moveStart('character', -lenght);
                    selectionStart += normalizedValue.slice(0, selectionStart).split('\n').length - 1;
                    if (startRange.compareEndPoints('EndToEnd', endRange) > -1) {
                        selectionEnd = lenght;
                    }
                    else {
                        selectionEnd = -startRange.moveEnd('character', -lenght);
                        selectionEnd += normalizedValue.slice(0, selectionEnd).split('\n').length - 1;
                    }
                }
            }
        }
        return {
            selectionStart: selectionStart,
            selectionEnd: selectionEnd,
        };
    }
    get rawValue() {
        return this.htmlInputElement && this.htmlInputElement.value;
    }
    set rawValue(value) {
        this._storedRawValue = value;
        if (this.htmlInputElement) {
            this.htmlInputElement.value = value;
        }
    }
    get storedRawValue() {
        return this._storedRawValue;
    }
}

class InputService {
    constructor(htmlInputElement, options) {
        this.htmlInputElement = htmlInputElement;
        this.options = options;
        this.inputManager = new InputManager(this.htmlInputElement);
    }
    addNumber(keyCode) {
        if (!this.rawValue) {
            this.rawValue = this.applyMask(false, '0');
        }
        const keyChar = String.fromCharCode(keyCode);
        const selectionStart = this.inputSelection.selectionStart;
        const selectionEnd = this.inputSelection.selectionEnd;
        this.rawValue =
            this.rawValue.substring(0, selectionStart) +
                keyChar +
                this.rawValue.substring(selectionEnd, this.rawValue.length);
        this.updateFieldValue(selectionStart + 1);
    }
    applyMask(isNumber, rawValue) {
        const { allowNegative, decimal, precision, prefix, suffix, thousands } = this.options;
        rawValue = isNumber ? new Number(rawValue).toFixed(precision) : rawValue;
        const onlyNumbers = rawValue.replace(/[^0-9]/g, '');
        if (!onlyNumbers) {
            return '';
        }
        let integerPart = onlyNumbers
            .slice(0, onlyNumbers.length - precision)
            .replace(/^0*/g, '')
            .replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        if (integerPart == '') {
            integerPart = '0';
        }
        let newRawValue = integerPart;
        let decimalPart = onlyNumbers.slice(onlyNumbers.length - precision);
        if (precision > 0) {
            decimalPart = '0'.repeat(precision - decimalPart.length) + decimalPart;
            newRawValue += decimal + decimalPart;
        }
        const isZero = parseInt(integerPart) == 0 && (parseInt(decimalPart) == 0 || decimalPart == '');
        const operator = rawValue.indexOf('-') > -1 && allowNegative && !isZero ? '-' : '';
        return operator + prefix + newRawValue + suffix;
    }
    clearMask(rawValue) {
        if (rawValue == null || rawValue == '') {
            return 0;
        }
        let value = rawValue.replace(this.options.prefix, '').replace(this.options.suffix, '');
        if (this.options.thousands) {
            value = value.replace(new RegExp('\\' + this.options.thousands, 'g'), '');
        }
        if (this.options.decimal) {
            value = value.replace(this.options.decimal, '.');
        }
        return parseFloat(value);
    }
    changeToNegative() {
        if (this.options.allowNegative &&
            this.rawValue != '' &&
            this.rawValue.charAt(0) != '-' &&
            this.value != 0) {
            const selectionStart = this.inputSelection.selectionStart;
            this.rawValue = '-' + this.rawValue;
            this.updateFieldValue(selectionStart + 1);
        }
    }
    changeToPositive() {
        const selectionStart = this.inputSelection.selectionStart;
        this.rawValue = this.rawValue.replace('-', '');
        this.updateFieldValue(selectionStart - 1);
    }
    fixCursorPosition(forceToEndPosition) {
        const currentCursorPosition = this.inputSelection.selectionStart;
        //if the current cursor position is after the number end position, it is moved to the end of the number, ignoring the prefix or suffix. this behavior can be forced with forceToEndPosition flag
        if (currentCursorPosition > this.getRawValueWithoutSuffixEndPosition() || forceToEndPosition) {
            this.inputManager.setCursorAt(this.getRawValueWithoutSuffixEndPosition());
            //if the current cursor position is before the number start position, it is moved to the start of the number, ignoring the prefix or suffix
        }
        else if (currentCursorPosition < this.getRawValueWithoutPrefixStartPosition()) {
            this.inputManager.setCursorAt(this.getRawValueWithoutPrefixStartPosition());
        }
    }
    getRawValueWithoutSuffixEndPosition() {
        return this.rawValue.length - this.options.suffix.length;
    }
    getRawValueWithoutPrefixStartPosition() {
        return this.value != null && this.value < 0
            ? this.options.prefix.length + 1
            : this.options.prefix.length;
    }
    removeNumber(keyCode) {
        const { decimal, thousands } = this.options;
        let selectionEnd = this.inputSelection.selectionEnd;
        let selectionStart = this.inputSelection.selectionStart;
        if (selectionStart > this.rawValue.length - this.options.suffix.length) {
            selectionEnd = this.rawValue.length - this.options.suffix.length;
            selectionStart = this.rawValue.length - this.options.suffix.length;
        }
        //there is no selection
        if (selectionEnd == selectionStart) {
            //delete key and the target digit is a number
            if ((keyCode == 46 || keyCode == 63272) &&
                /^\d+$/.test(this.rawValue.substring(selectionStart, selectionEnd + 1))) {
                selectionEnd = selectionEnd + 1;
            }
            //delete key and the target digit is the decimal or thousands divider
            if ((keyCode == 46 || keyCode == 63272) &&
                (this.rawValue.substring(selectionStart, selectionEnd + 1) == decimal ||
                    this.rawValue.substring(selectionStart, selectionEnd + 1) == thousands)) {
                selectionEnd = selectionEnd + 2;
                selectionStart = selectionStart + 1;
            }
            //backspace key and the target digit is a number
            if (keyCode == 8 && /^\d+$/.test(this.rawValue.substring(selectionStart - 1, selectionEnd))) {
                selectionStart = selectionStart - 1;
            }
            //backspace key and the target digit is the decimal or thousands divider
            if (keyCode == 8 &&
                (this.rawValue.substring(selectionStart - 1, selectionEnd) == decimal ||
                    this.rawValue.substring(selectionStart - 1, selectionEnd) == thousands)) {
                selectionStart = selectionStart - 2;
                selectionEnd = selectionEnd - 1;
            }
        }
        this.rawValue =
            this.rawValue.substring(0, selectionStart) +
                this.rawValue.substring(selectionEnd, this.rawValue.length);
        this.updateFieldValue(selectionStart);
    }
    updateFieldValue(selectionStart) {
        const newRawValue = this.applyMask(false, this.rawValue || '');
        selectionStart = selectionStart == undefined ? this.rawValue.length : selectionStart;
        this.inputManager.updateValueAndCursor(newRawValue, this.rawValue.length, selectionStart);
    }
    updateOptions(options) {
        const value = this.value;
        this.options = options;
        this.value = value;
    }
    get canInputMoreNumbers() {
        return this.inputManager.canInputMoreNumbers;
    }
    get inputSelection() {
        return this.inputManager.inputSelection;
    }
    get rawValue() {
        return this.inputManager.rawValue;
    }
    set rawValue(value) {
        this.inputManager.rawValue = value;
    }
    get storedRawValue() {
        return this.inputManager.storedRawValue;
    }
    get value() {
        return this.clearMask(this.rawValue);
    }
    set value(value) {
        this.rawValue = this.applyMask(true, '' + value);
    }
}

class InputHandler {
    constructor(htmlInputElement, options) {
        this.inputService = new InputService(htmlInputElement, options);
        this.htmlInputElement = htmlInputElement;
    }
    handleClick(event, chromeAndroid) {
        const selectionRangeLength = Math.abs(this.inputService.inputSelection.selectionEnd -
            this.inputService.inputSelection.selectionStart);
        // if there is no selection and the value is not null,
        // the cursor position will be fixed. if the browser is chrome on android, the cursor will go to the end of the number.
        if (selectionRangeLength == 0 && !isNaN(this.inputService.value)) {
            this.inputService.fixCursorPosition(chromeAndroid);
        }
    }
    handleCut(event) {
        if (this.isReadOnly()) {
            return;
        }
        setTimeout(() => {
            this.inputService.updateFieldValue();
            this.setValue(this.inputService.value);
            this.onModelChange(this.inputService.value);
        }, 0);
    }
    handleInput(event) {
        if (this.isReadOnly()) {
            return;
        }
        const keyCode = this.getNewKeyCode(this.inputService.storedRawValue, this.inputService.rawValue);
        const rawValueLength = this.inputService.rawValue.length;
        const rawValueSelectionEnd = this.inputService.inputSelection.selectionEnd;
        const rawValueWithoutSuffixEndPosition = this.inputService.getRawValueWithoutSuffixEndPosition();
        const storedRawValueLength = this.inputService.storedRawValue.length;
        this.inputService.rawValue = this.inputService.storedRawValue;
        if ((rawValueSelectionEnd != rawValueWithoutSuffixEndPosition ||
            Math.abs(rawValueLength - storedRawValueLength) != 1) &&
            storedRawValueLength != 0) {
            this.setCursorPosition(event);
            return;
        }
        if (rawValueLength < storedRawValueLength) {
            if (this.inputService.value != 0) {
                this.inputService.removeNumber(8);
            }
            else {
                this.setValue(0);
            }
        }
        if (rawValueLength > storedRawValueLength) {
            switch (keyCode) {
                case 43:
                    this.inputService.changeToPositive();
                    break;
                case 45:
                    this.inputService.changeToNegative();
                    break;
                default:
                    if (!this.inputService.canInputMoreNumbers ||
                        (isNaN(this.inputService.value) && String.fromCharCode(keyCode).match(/\d/) == null)) {
                        return;
                    }
                    this.inputService.addNumber(keyCode);
            }
        }
        this.setCursorPosition(event);
        this.onModelChange(this.inputService.value);
    }
    handleKeydown(event) {
        if (this.isReadOnly()) {
            return;
        }
        const keyCode = event.which || event.charCode || event.keyCode;
        if (keyCode == 8 || keyCode == 46 || keyCode == 63272) {
            event.preventDefault();
            const selectionRangeLength = Math.abs(this.inputService.inputSelection.selectionEnd -
                this.inputService.inputSelection.selectionStart);
            if (selectionRangeLength == this.inputService.rawValue.length ||
                this.inputService.value == 0) {
                this.setValue(0);
                this.onModelChange(this.inputService.value);
            }
            if (selectionRangeLength == 0 && !isNaN(this.inputService.value)) {
                this.inputService.removeNumber(keyCode);
                this.onModelChange(this.inputService.value);
            }
            if ((keyCode === 8 || keyCode === 46) &&
                selectionRangeLength != 0 &&
                !isNaN(this.inputService.value)) {
                this.inputService.removeNumber(keyCode);
                this.onModelChange(this.inputService.value);
            }
        }
    }
    handleKeypress(event) {
        if (this.isReadOnly()) {
            return;
        }
        const keyCode = event.which || event.charCode || event.keyCode;
        if (keyCode == undefined ||
            [9, 13].indexOf(keyCode) != -1 ||
            this.isArrowEndHomeKeyInFirefox(event)) {
            return;
        }
        switch (keyCode) {
            case 43:
                this.inputService.changeToPositive();
                break;
            case 45:
                this.inputService.changeToNegative();
                break;
            default:
                if (this.inputService.canInputMoreNumbers &&
                    (!isNaN(this.inputService.value) || String.fromCharCode(keyCode).match(/\d/) != null)) {
                    this.inputService.addNumber(keyCode);
                }
        }
        event.preventDefault();
        this.onModelChange(this.inputService.value);
    }
    handleKeyup(event) {
        this.inputService.fixCursorPosition();
    }
    handlePaste(event) {
        if (this.isReadOnly()) {
            return;
        }
        setTimeout(() => {
            this.inputService.updateFieldValue();
            this.setValue(this.inputService.value);
            this.onModelChange(this.inputService.value);
        }, 1);
    }
    updateOptions(options) {
        this.inputService.updateOptions(options);
    }
    getOnModelChange() {
        return this.onModelChange;
    }
    setOnModelChange(callbackFunction) {
        this.onModelChange = callbackFunction;
    }
    getOnModelTouched() {
        return this.onModelTouched;
    }
    setOnModelTouched(callbackFunction) {
        this.onModelTouched = callbackFunction;
    }
    setValue(value) {
        this.inputService.value = value;
    }
    getNewKeyCode(oldString, newString) {
        if (oldString.length > newString.length) {
            return 0;
        }
        for (let x = 0; x < newString.length; x++) {
            if (oldString.length == x || oldString[x] != newString[x]) {
                return newString.charCodeAt(x);
            }
        }
        return 0;
    }
    isArrowEndHomeKeyInFirefox(event) {
        if ([35, 36, 37, 38, 39, 40].indexOf(event.keyCode) != -1 &&
            (event.charCode == undefined || event.charCode == 0)) {
            return true;
        }
        return false;
    }
    isReadOnly() {
        return this.htmlInputElement && this.htmlInputElement.readOnly;
    }
    setCursorPosition(event) {
        const rawValueWithoutSuffixEndPosition = this.inputService.getRawValueWithoutSuffixEndPosition();
        setTimeout(function () {
            event.target.setSelectionRange(rawValueWithoutSuffixEndPosition, rawValueWithoutSuffixEndPosition);
        }, 0);
    }
}

const CURRENCYMASKDIRECTIVE_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CurrencyMaskDirective),
    multi: true,
};
class CurrencyMaskDirective {
    constructor(currencyMaskConfig, elementRef, keyValueDiffers) {
        this.currencyMaskConfig = currencyMaskConfig;
        this.elementRef = elementRef;
        this.keyValueDiffers = keyValueDiffers;
        this.options = {};
        this.optionsTemplate =
            COUNTRY_CONFIG[getCountryCodeFromStorage()]?.number_format ||
                COUNTRY_CONFIG['MY'].number_format;
        if (this.currencyMaskConfig) {
            this.optionsTemplate = this.currencyMaskConfig;
        }
        this.keyValueDiffer = this.keyValueDiffers.find({}).create();
    }
    ngAfterViewInit() {
        this.elementRef.nativeElement.style.textAlign = this.options.align
            ? this.options.align
            : this.optionsTemplate.align;
    }
    ngDoCheck() {
        if (this.keyValueDiffer.diff(this.options)) {
            this.elementRef.nativeElement.style.textAlign = this.options.align
                ? this.options.align
                : this.optionsTemplate.align;
            this.inputHandler.updateOptions(Object.assign({}, this.optionsTemplate, this.options));
        }
    }
    ngOnInit() {
        this.inputHandler = new InputHandler(this.elementRef.nativeElement, Object.assign({}, this.optionsTemplate, this.options));
    }
    handleBlur(event) {
        this.inputHandler.getOnModelTouched().apply(event);
    }
    handleClick(event) {
        this.inputHandler.handleClick(event, this.isChromeAndroid());
    }
    handleCut(event) {
        if (!this.isChromeAndroid()) {
            this.inputHandler.handleCut(event);
        }
    }
    handleInput(event) {
        if (this.isChromeAndroid()) {
            this.inputHandler.handleInput(event);
        }
    }
    handleKeydown(event) {
        if (!this.isChromeAndroid()) {
            this.inputHandler.handleKeydown(event);
        }
    }
    handleKeypress(event) {
        if (!this.isChromeAndroid()) {
            this.inputHandler.handleKeypress(event);
        }
    }
    handleKeyup(event) {
        if (!this.isChromeAndroid()) {
            this.inputHandler.handleKeyup(event);
        }
    }
    handlePaste(event) {
        if (!this.isChromeAndroid()) {
            this.inputHandler.handlePaste(event);
        }
    }
    isChromeAndroid() {
        return /chrome/i.test(navigator.userAgent) && /android/i.test(navigator.userAgent);
    }
    registerOnChange(callbackFunction) {
        this.inputHandler.setOnModelChange(callbackFunction);
    }
    registerOnTouched(callbackFunction) {
        this.inputHandler.setOnModelTouched(callbackFunction);
    }
    setDisabledState(value) {
        this.elementRef.nativeElement.disabled = value;
    }
    validate(abstractControl) {
        const result = {};
        if (abstractControl.value > this.max) {
            result.max = true;
        }
        if (abstractControl.value < this.min) {
            result.min = true;
        }
        return Object.keys(result).length > 0 ? result : null;
    }
    writeValue(value) {
        this.inputHandler.setValue(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CurrencyMaskDirective, deps: [{ token: CURRENCY_MASK_CONFIG, optional: true }, { token: i0.ElementRef }, { token: i0.KeyValueDiffers }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: CurrencyMaskDirective, selector: "[fswCurrencyMask]", inputs: { max: "max", min: "min", options: "options" }, host: { listeners: { "blur": "handleBlur($event)", "click": "handleClick($event)", "cut": "handleCut($event)", "input": "handleInput($event)", "keydown": "handleKeydown($event)", "keypress": "handleKeypress($event)", "keyup": "handleKeyup($event)", "paste": "handlePaste($event)" } }, providers: [
            CURRENCYMASKDIRECTIVE_VALUE_ACCESSOR,
            { provide: NG_VALIDATORS, useExisting: CurrencyMaskDirective, multi: true },
        ], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CurrencyMaskDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswCurrencyMask]',
                    providers: [
                        CURRENCYMASKDIRECTIVE_VALUE_ACCESSOR,
                        { provide: NG_VALIDATORS, useExisting: CurrencyMaskDirective, multi: true },
                    ],
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [CURRENCY_MASK_CONFIG]
                }] }, { type: i0.ElementRef }, { type: i0.KeyValueDiffers }]; }, propDecorators: { max: [{
                type: Input
            }], min: [{
                type: Input
            }], options: [{
                type: Input
            }], handleBlur: [{
                type: HostListener,
                args: ['blur', ['$event']]
            }], handleClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }], handleCut: [{
                type: HostListener,
                args: ['cut', ['$event']]
            }], handleInput: [{
                type: HostListener,
                args: ['input', ['$event']]
            }], handleKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], handleKeypress: [{
                type: HostListener,
                args: ['keypress', ['$event']]
            }], handleKeyup: [{
                type: HostListener,
                args: ['keyup', ['$event']]
            }], handlePaste: [{
                type: HostListener,
                args: ['paste', ['$event']]
            }] } });

class FSWCurrencyMaskModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCurrencyMaskModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWCurrencyMaskModule, declarations: [CurrencyMaskDirective], imports: [CommonModule, FormsModule], exports: [CurrencyMaskDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCurrencyMaskModule, imports: [CommonModule, FormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCurrencyMaskModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule],
                    declarations: [CurrencyMaskDirective],
                    exports: [CurrencyMaskDirective],
                }]
        }] });

class ApplicationMemberInformationStore extends ComponentStore {
    constructor(_entity, _initialState) {
        super({
            member: null,
            members: [],
            ..._initialState,
        });
        this._entity = _entity;
        this._initialState = _initialState;
    }
    setupInformation(entity) {
        return this._entity
            .getApplicationMembersInformation(entity, { type: ApplicationMemberType.MAIN }, {
            country_code: getCountryCodeFromStorage(),
            member_type_code: MemberCode.BORROWER,
        })
            .pipe(map((members) => (members ? members[0] : null)), tap((member) => {
            this.patchState({
                member,
            });
        }));
    }
    setupListOfInformation(entity) {
        return this._entity
            .getApplicationMembersInformation(entity, { type: ApplicationMemberType.MAIN }, {
            country_code: getCountryCodeFromStorage(),
            member_type_code: MemberCode.BORROWER,
        })
            .pipe(map((members) => members || []), tap((members) => {
            this.patchState({
                members,
            });
        }));
    }
}

class FSWUploadComponent {
    constructor() {
        this.fileSelect = new EventEmitter();
        this.buttonUploadLabel = '';
        this.isPrimaryButton = false;
        this.hasError = false;
    }
    selectFile(event) {
        const { files } = event.target;
        if (!files)
            return;
        this.hasError = !!Array.from(files).filter((f) => !UPLOAD_ALLOWED_FILE_TYPES.includes(f.type))
            .length;
        if (this.hasError)
            return;
        this.fileSelect.emit(files);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWUploadComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWUploadComponent, selector: "fsw-upload", inputs: { buttonUploadLabel: "buttonUploadLabel", isPrimaryButton: "isPrimaryButton" }, outputs: { fileSelect: "fileSelect" }, ngImport: i0, template: `
		<input hidden multiple type="file" #selectedFile (input)="selectFile($event)" />
		<button
			class="btn"
			[ngClass]="{
				'btn--primary': isPrimaryButton,
				'btn--secondary': !isPrimaryButton
			}"
			(click)="selectedFile.click()"
		>
			{{ buttonUploadLabel }}
		</button>
	`, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWUploadComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-upload',
                    template: `
		<input hidden multiple type="file" #selectedFile (input)="selectFile($event)" />
		<button
			class="btn"
			[ngClass]="{
				'btn--primary': isPrimaryButton,
				'btn--secondary': !isPrimaryButton
			}"
			(click)="selectedFile.click()"
		>
			{{ buttonUploadLabel }}
		</button>
	`,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { fileSelect: [{
                type: Output
            }], buttonUploadLabel: [{
                type: Input
            }], isPrimaryButton: [{
                type: Input
            }] } });

class FSWUploadModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWUploadModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWUploadModule, declarations: [FSWUploadComponent], imports: [CommonModule], exports: [FSWUploadComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWUploadModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWUploadModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FSWUploadComponent],
                    imports: [CommonModule],
                    exports: [FSWUploadComponent],
                }]
        }] });

class FSWClipboardComponent {
    set content(value) {
        this._content = value;
    }
    get content() {
        return this._content;
    }
    constructor(_clipboard, _cdr) {
        this._clipboard = _clipboard;
        this._cdr = _cdr;
        this._content = null;
        this.isCopied = false;
    }
    copyToClipboard() {
        if (this.content) {
            this._clipboard.copy(this.content);
            this.isCopied = true;
            // Clear any existing timeout
            if (this.copyTimeout) {
                clearTimeout(this.copyTimeout);
            }
            // Reset the copy icon after 2 seconds
            this.copyTimeout = setTimeout(() => {
                this.isCopied = false;
                this._cdr.markForCheck();
            }, 2000);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWClipboardComponent, deps: [{ token: i1$2.Clipboard }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWClipboardComponent, selector: "fsw-clipboard", inputs: { content: "content" }, ngImport: i0, template: "<ng-container *ngIf=\"content\">\n  <button\n    class=\"copy-button\"\n    (click)=\"copyToClipboard()\"\n    [title]=\"isCopied ? 'Copied!' : 'Copy content'\"\n  >\n    <i class=\"icon\" [ngClass]=\"isCopied ? 'icon-check' : 'icon-copy'\"></i>\n  </button>\n</ng-container>\n", styles: [".copy-button{background:none;border:none;cursor:pointer;padding:4px;display:flex;align-items:center;justify-content:center;transition:all .2s ease}.copy-button:hover{background-color:#0000000d;border-radius:4px}.copy-button:focus{outline:none;box-shadow:0 0 0 2px #007bff40}.icon{width:16px;height:16px;background-position:center;background-repeat:no-repeat;background-size:contain}.icon-copy{background-image:url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"9\" y=\"9\" width=\"13\" height=\"13\" rx=\"2\" ry=\"2\"></rect><path d=\"M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1\"></path></svg>')}.icon-check{background-image:url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"green\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><polyline points=\"20 6 9 17 4 12\"></polyline></svg>')}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWClipboardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-clipboard', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"content\">\n  <button\n    class=\"copy-button\"\n    (click)=\"copyToClipboard()\"\n    [title]=\"isCopied ? 'Copied!' : 'Copy content'\"\n  >\n    <i class=\"icon\" [ngClass]=\"isCopied ? 'icon-check' : 'icon-copy'\"></i>\n  </button>\n</ng-container>\n", styles: [".copy-button{background:none;border:none;cursor:pointer;padding:4px;display:flex;align-items:center;justify-content:center;transition:all .2s ease}.copy-button:hover{background-color:#0000000d;border-radius:4px}.copy-button:focus{outline:none;box-shadow:0 0 0 2px #007bff40}.icon{width:16px;height:16px;background-position:center;background-repeat:no-repeat;background-size:contain}.icon-copy{background-image:url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"9\" y=\"9\" width=\"13\" height=\"13\" rx=\"2\" ry=\"2\"></rect><path d=\"M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1\"></path></svg>')}.icon-check{background-image:url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"green\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><polyline points=\"20 6 9 17 4 12\"></polyline></svg>')}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.Clipboard }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { content: [{
                type: Input,
                args: [{ required: true }]
            }] } });

class DOMSanitizePipe {
    constructor(_sanitizer) {
        this._sanitizer = _sanitizer;
    }
    transform(value, type) {
        switch (type) {
            case 'html':
                return this._sanitizer.bypassSecurityTrustHtml(value);
            case 'style':
                return this._sanitizer.bypassSecurityTrustStyle(value);
            case 'script':
                return this._sanitizer.bypassSecurityTrustScript(value);
            case 'url':
                return this._sanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl':
                return this._sanitizer.bypassSecurityTrustResourceUrl(value);
            default:
                return this._sanitizer.bypassSecurityTrustHtml(value);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DOMSanitizePipe, deps: [{ token: i1$3.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DOMSanitizePipe, name: "domSanitize" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DOMSanitizePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'domSanitize',
                }]
        }], ctorParameters: function () { return [{ type: i1$3.DomSanitizer }]; } });

class DOMSanitizeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DOMSanitizeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DOMSanitizeModule, declarations: [DOMSanitizePipe], exports: [DOMSanitizePipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DOMSanitizeModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DOMSanitizeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DOMSanitizePipe],
                    exports: [DOMSanitizePipe],
                }]
        }] });

class CountryFilterPipe {
    transform(value, countryCode) {
        if (value && value.length) {
            return value.filter((o) => o.countryId === countryCode);
        }
        return [];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CountryFilterPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CountryFilterPipe, name: "CountryFilter" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CountryFilterPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'CountryFilter',
                }]
        }] });

class CountryFilterModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CountryFilterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CountryFilterModule, declarations: [CountryFilterPipe], exports: [CountryFilterPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CountryFilterModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CountryFilterModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CountryFilterPipe],
                    exports: [CountryFilterPipe],
                }]
        }] });

class CurrencyFormatPipe {
    constructor(currencyPipe) {
        this.currencyPipe = currencyPipe;
    }
    transform(value, countryCode = '', precision = '1.2-2') {
        value = Number(value);
        let currency = '';
        if (!Number.isFinite(value)) {
            value = 0;
        }
        const keys = Object.keys(COUNTRY_CONFIG);
        const COUNTRIES = keys.map((key) => ({
            countryCode: key,
            ...COUNTRY_CONFIG[key],
        }));
        if (countryCode) {
            currency = COUNTRIES.find((o) => o.countryCode === countryCode)?.currencySymbol;
        }
        else {
            currency = COUNTRIES.find((o) => o.countryCode === getCountryCodeFromStorage())?.currencySymbol;
        }
        return this.currencyPipe.transform(value, currency, 'code', precision);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CurrencyFormatPipe, deps: [{ token: i1$1.CurrencyPipe }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CurrencyFormatPipe, name: "currencyMaskPipe" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CurrencyFormatPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'currencyMaskPipe' }]
        }], ctorParameters: function () { return [{ type: i1$1.CurrencyPipe }]; } });

class CurrencyFormatModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CurrencyFormatModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CurrencyFormatModule, declarations: [CurrencyFormatPipe], exports: [CurrencyFormatPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CurrencyFormatModule, providers: [CurrencyPipe] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CurrencyFormatModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CurrencyFormatPipe],
                    exports: [CurrencyFormatPipe],
                    providers: [CurrencyPipe],
                }]
        }] });

class NumericFormatPipe {
    transform(num) {
        return new Intl.NumberFormat().format(num);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NumericFormatPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: NumericFormatPipe, name: "numericFormat" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NumericFormatPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'numericFormat',
                }]
        }] });

class NumericFormatModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NumericFormatModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: NumericFormatModule, declarations: [NumericFormatPipe], exports: [NumericFormatPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NumericFormatModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NumericFormatModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [NumericFormatPipe],
                    exports: [NumericFormatPipe],
                }]
        }] });

class PrettifyDataSource {
    transform(value) {
        if (!value)
            return '';
        return value
            .split(/\./g)
            .map((part) => {
            return part
                .replace(/([A-Z])/g, ' $1')
                .replace(/_([a-z])/g, (match) => ` ${match[1].toUpperCase()}`)
                .replace(/^[a-z]/g, (letter) => letter.toUpperCase());
        })
            .join(' / ');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PrettifyDataSource, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: PrettifyDataSource, name: "PrettifyDataSource" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PrettifyDataSource, decorators: [{
            type: Pipe,
            args: [{
                    name: 'PrettifyDataSource',
                }]
        }] });

class PrettifyDataSourceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PrettifyDataSourceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: PrettifyDataSourceModule, declarations: [PrettifyDataSource], exports: [PrettifyDataSource] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PrettifyDataSourceModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PrettifyDataSourceModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [PrettifyDataSource],
                    exports: [PrettifyDataSource],
                }]
        }] });

class RemoveCurrencySymbolPipe {
    transform(value) {
        let val = '';
        if (typeof value === 'number') {
            val = value.toString();
        }
        return val.replace(/[^0-9.-]/g, '');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RemoveCurrencySymbolPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: RemoveCurrencySymbolPipe, name: "removeCurrencySymbol" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RemoveCurrencySymbolPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'removeCurrencySymbol',
                }]
        }] });

class RemoveCurrencySymbolModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RemoveCurrencySymbolModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: RemoveCurrencySymbolModule, declarations: [RemoveCurrencySymbolPipe], exports: [RemoveCurrencySymbolPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RemoveCurrencySymbolModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RemoveCurrencySymbolModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [RemoveCurrencySymbolPipe],
                    exports: [RemoveCurrencySymbolPipe],
                }]
        }] });

class FSWClipboardModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWClipboardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWClipboardModule, declarations: [FSWClipboardComponent], imports: [CommonModule, DOMSanitizeModule, FSWBlobServiceModule], exports: [FSWClipboardComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWClipboardModule, imports: [CommonModule, DOMSanitizeModule, FSWBlobServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWClipboardModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FSWClipboardComponent],
                    imports: [CommonModule, DOMSanitizeModule, FSWBlobServiceModule],
                    exports: [FSWClipboardComponent],
                }]
        }] });

const MODAL_HOST_ID = new InjectionToken('MODAL_HOST_ID');

const MODAL_HOST_SERVICE = new InjectionToken('MODAL_HOST_SERVICE');

const MODAL_SERVICE = new InjectionToken('MODAL_SERVICE');

const MODAL_ARRAY = new InjectionToken('MODAL_ARRAY');

const MODAL_CONTEXT = new InjectionToken('MODAL_CONTEXT');

const MODAL_ITEM = new InjectionToken('MODAL_ITEM');

const MODAL_BACKDROP_CLICK = new InjectionToken('MODAL_BACKDROP_CLICK');

var ModalSizes;
(function (ModalSizes) {
    ModalSizes["S"] = "s";
    ModalSizes["M"] = "m";
    ModalSizes["L"] = "l";
})(ModalSizes || (ModalSizes = {}));

var ModalAnimations;
(function (ModalAnimations) {
    ModalAnimations["SLIDE_IN"] = "slide-in";
    ModalAnimations["FADE_IN"] = "fade-in";
})(ModalAnimations || (ModalAnimations = {}));

var ModalStyles;
(function (ModalStyles) {
    ModalStyles[ModalStyles["INITIAL"] = 0] = "INITIAL";
    ModalStyles[ModalStyles["CUSTOM"] = 1] = "CUSTOM";
})(ModalStyles || (ModalStyles = {}));

class ModalService {
    constructor(_hostService) {
        this._hostService = _hostService;
    }
    open(content, options = {}) {
        return new Observable((observer) => {
            const defaultOptions = {
                style: ModalStyles.INITIAL,
                size: ModalSizes.M,
                closeable: true,
            };
            this._hostService.createHost();
            const id = v4();
            const zIndex = this._hostService.getNextIndex();
            const context = {
                ...defaultOptions,
                ...options,
                zIndex,
                completeWith: (output) => {
                    this._hostService.remove(id);
                    observer.next(output);
                    observer.complete();
                },
            };
            const item = {
                id,
                context,
                content,
            };
            this._hostService.push(item);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalService, deps: [{ token: MODAL_HOST_SERVICE }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_HOST_SERVICE]
                }] }]; } });

class ModalItemDirective {
    constructor(_injector, _viewContainerRef, _resolver) {
        this._injector = _injector;
        this._viewContainerRef = _viewContainerRef;
        this._resolver = _resolver;
        this.context = null;
        this.content = null;
    }
    ngOnInit() {
        if (!this.content)
            return;
        const factoryResolver = this._resolver.resolveComponentFactory(this.content);
        const injector = Injector.create({
            parent: this._injector,
            providers: [
                {
                    provide: MODAL_CONTEXT,
                    useValue: this.context,
                },
            ],
        });
        this._viewContainerRef.createComponent(factoryResolver, 0, injector);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalItemDirective, deps: [{ token: i0.Injector }, { token: i0.ViewContainerRef }, { token: i0.ComponentFactoryResolver }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: ModalItemDirective, selector: "ng-container[fswModalItem]", inputs: { context: "context", content: "content" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-container[fswModalItem]',
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }, { type: i0.ViewContainerRef }, { type: i0.ComponentFactoryResolver }]; }, propDecorators: { context: [{
                type: Input
            }], content: [{
                type: Input
            }] } });

class ModalComponent {
    get slideInTop() {
        return {
            value: ``,
            params: {
                start: `40px`,
                duration: 300,
            },
        };
    }
    constructor(item, backdropClick$) {
        this.item = item;
        this.backdropClick$ = backdropClick$;
        this.ModalStyles = ModalStyles;
        if (item.context.closeable) {
            this.backdropClick$.pipe(tap(() => this.close())).subscribe();
        }
    }
    close() {
        this.item.context.completeWith(undefined);
    }
    setLabel(label) {
        this.item.context.label = label;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalComponent, deps: [{ token: MODAL_ITEM }, { token: MODAL_BACKDROP_CLICK }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ModalComponent, selector: "fsw-modal", host: { properties: { "@slideIn": "this.slideInTop", "@fadeIn": "this.slideInTop" } }, ngImport: i0, template: "<div\n\tclass=\"wrapper-modal wrapper-modal--size-{{ item.context.size }}\"\n\t[style.zIndex]=\"item.context.zIndex\"\n>\n\t<div class=\"wrapper-modal__header\" *ngIf=\"item.context.style === ModalStyles.INITIAL\">\n\t\t<h5>{{ item.context.label }}</h5>\n\t\t<i class=\"fa fa-times\" (click)=\"close()\"></i>\n\t</div>\n\t<ng-container fswModalItem [context]=\"item.context\" [content]=\"item.content\"></ng-container>\n</div>\n", styles: [":host .wrapper-modal{position:relative;display:flex;flex-direction:column;overflow:hidden;background:#ffffff;border-radius:12px}:host .wrapper-modal--size-s{width:464px}:host .wrapper-modal--size-m{width:640px}:host .wrapper-modal--size-l{width:960px}:host .wrapper-modal__header{width:100%;display:flex;align-items:flex-end;padding:32px 32px 0}:host .wrapper-modal__header i{position:absolute;top:24px;right:24px;cursor:pointer}:host .wrapper-modal__header h5{height:34px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ModalItemDirective, selector: "ng-container[fswModalItem]", inputs: ["context", "content"] }], animations: [slideIn, fadeIn], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-modal', changeDetection: ChangeDetectionStrategy.OnPush, animations: [slideIn, fadeIn], template: "<div\n\tclass=\"wrapper-modal wrapper-modal--size-{{ item.context.size }}\"\n\t[style.zIndex]=\"item.context.zIndex\"\n>\n\t<div class=\"wrapper-modal__header\" *ngIf=\"item.context.style === ModalStyles.INITIAL\">\n\t\t<h5>{{ item.context.label }}</h5>\n\t\t<i class=\"fa fa-times\" (click)=\"close()\"></i>\n\t</div>\n\t<ng-container fswModalItem [context]=\"item.context\" [content]=\"item.content\"></ng-container>\n</div>\n", styles: [":host .wrapper-modal{position:relative;display:flex;flex-direction:column;overflow:hidden;background:#ffffff;border-radius:12px}:host .wrapper-modal--size-s{width:464px}:host .wrapper-modal--size-m{width:640px}:host .wrapper-modal--size-l{width:960px}:host .wrapper-modal__header{width:100%;display:flex;align-items:flex-end;padding:32px 32px 0}:host .wrapper-modal__header i{position:absolute;top:24px;right:24px;cursor:pointer}:host .wrapper-modal__header h5{height:34px}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_ITEM]
                }] }, { type: i3.Subject, decorators: [{
                    type: Inject,
                    args: [MODAL_BACKDROP_CLICK]
                }] }]; }, propDecorators: { slideInTop: [{
                type: HostBinding,
                args: [`@slideIn`]
            }, {
                type: HostBinding,
                args: [`@fadeIn`]
            }] } });

class ModalHostItemDirective {
    constructor(_injector, _viewContainerRef, _resolver) {
        this._injector = _injector;
        this._viewContainerRef = _viewContainerRef;
        this._resolver = _resolver;
        this.item = null;
        this.backDropClick$ = new Subject();
    }
    ngOnInit() {
        if (!this.item)
            return;
        const factoryResolver = this._resolver.resolveComponentFactory(ModalComponent);
        const injector = Injector.create({
            parent: this.item.context.injector || this._injector,
            providers: [
                {
                    provide: MODAL_ITEM,
                    useValue: this.item,
                },
                {
                    provide: MODAL_BACKDROP_CLICK,
                    useValue: this.backDropClick$,
                },
            ],
        });
        this._viewContainerRef.createComponent(factoryResolver, 0, injector);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalHostItemDirective, deps: [{ token: i0.Injector }, { token: i0.ViewContainerRef }, { token: i0.ComponentFactoryResolver }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: ModalHostItemDirective, selector: "ng-container[fswModalHostItem]", inputs: { item: "item", backDropClick$: "backDropClick$" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalHostItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-container[fswModalHostItem]',
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }, { type: i0.ViewContainerRef }, { type: i0.ComponentFactoryResolver }]; }, propDecorators: { item: [{
                type: Input
            }], backDropClick$: [{
                type: Input
            }] } });

class ModalHostComponent {
    constructor() {
        this.array$ = inject(MODAL_ARRAY, { optional: true });
        this.arrayListen$ = this.array$ ? this.array$.asObservable() : of([]);
        this.backDropClick$ = new Subject();
    }
    clickBackDrop() {
        this.backDropClick$.next(undefined);
        this.backDropClick$.complete();
        this.backDropClick$ = new Subject();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalHostComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ModalHostComponent, selector: "fsw-modal-host", ngImport: i0, template: "<ng-container *ngIf=\"arrayListen$ | async as array\">\n\t<div class=\"wrapper-modal-host\" [class.none]=\"!array.length\">\n\t\t<div class=\"wrapper-modal-host__backdrop\" (click)=\"clickBackDrop()\"></div>\n\t\t<ng-container *ngFor=\"let item of array\">\n\t\t\t<ng-container fswModalHostItem [backDropClick$]=\"backDropClick$\" [item]=\"item\"></ng-container>\n\t\t</ng-container>\n\t</div>\n</ng-container>\n", styles: [":host .wrapper-modal-host{position:fixed;top:0;left:0;width:100vw;height:100vh;display:flex;z-index:999;justify-content:center;align-items:center;transition-property:bottom,width,height}:host .wrapper-modal-host.none{transition-delay:.5s;bottom:0;width:0;height:0}:host .wrapper-modal-host__backdrop{position:absolute;top:0;left:0;background:#e5e5e5;width:100%;height:100%;opacity:.7}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ModalHostItemDirective, selector: "ng-container[fswModalHostItem]", inputs: ["item", "backDropClick$"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalHostComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-modal-host', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"arrayListen$ | async as array\">\n\t<div class=\"wrapper-modal-host\" [class.none]=\"!array.length\">\n\t\t<div class=\"wrapper-modal-host__backdrop\" (click)=\"clickBackDrop()\"></div>\n\t\t<ng-container *ngFor=\"let item of array\">\n\t\t\t<ng-container fswModalHostItem [backDropClick$]=\"backDropClick$\" [item]=\"item\"></ng-container>\n\t\t</ng-container>\n\t</div>\n</ng-container>\n", styles: [":host .wrapper-modal-host{position:fixed;top:0;left:0;width:100vw;height:100vh;display:flex;z-index:999;justify-content:center;align-items:center;transition-property:bottom,width,height}:host .wrapper-modal-host.none{transition-delay:.5s;bottom:0;width:0;height:0}:host .wrapper-modal-host__backdrop{position:absolute;top:0;left:0;background:#e5e5e5;width:100%;height:100%;opacity:.7}\n"] }]
        }] });

class ModalHostService {
    get host() {
        return this._host;
    }
    get isHostExisted() {
        return !!this.host;
    }
    constructor(_dom, _hostId, _array$, _injector, _appRef, _resolver) {
        this._dom = _dom;
        this._hostId = _hostId;
        this._array$ = _array$;
        this._injector = _injector;
        this._appRef = _appRef;
        this._resolver = _resolver;
        this._host = null;
        this._body = this._dom.body;
        this._initialHost();
        this._item$ = this._array$ ? this._array$ : new BehaviorSubject([]);
    }
    createHost() {
        if (this.isHostExisted)
            return;
        const injector = Injector.create({
            parent: this._injector,
            providers: [
                {
                    provide: MODAL_ARRAY,
                    useValue: this._item$,
                },
            ],
        });
        const componentRef = this.createComponentRef(ModalHostComponent, injector);
        const element = this.getHostViewElement(componentRef.hostView);
        element.id = this._hostId;
        this.appendTo(element);
        this._host = element;
    }
    createComponentRef(component, injector) {
        const factoryResolver = this._resolver.resolveComponentFactory(component);
        const componentRef = factoryResolver.create(injector);
        this.attachHostView(componentRef.hostView);
        return componentRef;
    }
    push(item) {
        const { value } = this._item$;
        value.push(item);
        this._item$.next(value);
    }
    remove(id) {
        this._item$.next(this._item$.value.filter((e) => e.id !== id));
    }
    getNextIndex() {
        const zIndex = 1000;
        if (!this.isHostExisted)
            return zIndex;
        const length = this.host.childNodes.length;
        return zIndex + length;
    }
    appendTo(element, parent = this._body) {
        parent.appendChild(element);
    }
    attachHostView(hostView) {
        this._appRef.attachView(hostView);
    }
    getHostViewElement(hostView) {
        const embeddedViewRef = hostView;
        return embeddedViewRef.rootNodes[0];
    }
    _initialHost() {
        const existHost = this._dom.getElementById(this._hostId);
        if (!existHost)
            return;
        this._host = existHost;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalHostService, deps: [{ token: DOCUMENT }, { token: MODAL_HOST_ID }, { token: MODAL_ARRAY, optional: true }, { token: i0.Injector }, { token: i0.ApplicationRef }, { token: i0.ComponentFactoryResolver }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalHostService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalHostService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_HOST_ID]
                }] }, { type: i3.BehaviorSubject, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [MODAL_ARRAY]
                }] }, { type: i0.Injector }, { type: i0.ApplicationRef }, { type: i0.ComponentFactoryResolver }]; } });

class FSWModalModule {
    static custom(custom) {
        const providers = [];
        const { service, hostService } = custom;
        if (hostService) {
            providers.push({
                provide: MODAL_HOST_SERVICE,
                useClass: hostService,
            });
        }
        if (service) {
            providers.push({
                provide: MODAL_SERVICE,
                useClass: service,
            });
        }
        return {
            ngModule: FSWModalModule,
            providers,
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWModalModule, declarations: [ModalHostComponent, ModalComponent, ModalItemDirective, ModalHostItemDirective], imports: [CommonModule, LetDirective], exports: [ModalComponent, ModalHostComponent, ModalItemDirective, ModalHostItemDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWModalModule, providers: [
            {
                provide: MODAL_HOST_ID,
                useValue: 'fsw-modal-host',
            },
            {
                provide: MODAL_HOST_SERVICE,
                useClass: ModalHostService,
            },
            {
                provide: MODAL_SERVICE,
                useClass: ModalService,
            },
        ], imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWModalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, LetDirective],
                    declarations: [ModalHostComponent, ModalComponent, ModalItemDirective, ModalHostItemDirective],
                    exports: [ModalComponent, ModalHostComponent, ModalItemDirective, ModalHostItemDirective],
                    providers: [
                        {
                            provide: MODAL_HOST_ID,
                            useValue: 'fsw-modal-host',
                        },
                        {
                            provide: MODAL_HOST_SERVICE,
                            useClass: ModalHostService,
                        },
                        {
                            provide: MODAL_SERVICE,
                            useClass: ModalService,
                        },
                    ],
                }]
        }] });

class FSWRemoveDialogComponent {
    constructor() {
        this.remove = new EventEmitter();
        this.cancel = new EventEmitter();
        this.description = '';
        this.buttonDeleteLabel = '';
        this.buttonCancelLabel = '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRemoveDialogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWRemoveDialogComponent, selector: "fsw-remove-dialog", inputs: { description: "description", buttonDeleteLabel: "buttonDeleteLabel", buttonCancelLabel: "buttonCancelLabel" }, outputs: { remove: "remove", cancel: "cancel" }, ngImport: i0, template: "<div class=\"remove-dialog\">\n\t<p>{{ description }}</p>\n\t<div class=\"remove-dialog__footer\">\n\t\t<button class=\"btn btn--secondary\" (click)=\"cancel.emit()\">{{ buttonCancelLabel }}</button>\n\t\t<button class=\"btn btn--primary\" (click)=\"remove.emit()\">{{ buttonDeleteLabel }}</button>\n\t</div>\n</div>\n", styles: [":host .remove-dialog{width:100%;padding:16px 32px 32px;display:flex;flex-direction:column;gap:16px}:host .remove-dialog p{margin:0;font-size:14px}:host .remove-dialog__footer{width:100%;display:flex;align-items:center;justify-content:space-between}:host .remove-dialog__footer button{width:calc(50% - 8px)}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRemoveDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-remove-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"remove-dialog\">\n\t<p>{{ description }}</p>\n\t<div class=\"remove-dialog__footer\">\n\t\t<button class=\"btn btn--secondary\" (click)=\"cancel.emit()\">{{ buttonCancelLabel }}</button>\n\t\t<button class=\"btn btn--primary\" (click)=\"remove.emit()\">{{ buttonDeleteLabel }}</button>\n\t</div>\n</div>\n", styles: [":host .remove-dialog{width:100%;padding:16px 32px 32px;display:flex;flex-direction:column;gap:16px}:host .remove-dialog p{margin:0;font-size:14px}:host .remove-dialog__footer{width:100%;display:flex;align-items:center;justify-content:space-between}:host .remove-dialog__footer button{width:calc(50% - 8px)}\n"] }]
        }], propDecorators: { remove: [{
                type: Output
            }], cancel: [{
                type: Output
            }], description: [{
                type: Input
            }], buttonDeleteLabel: [{
                type: Input
            }], buttonCancelLabel: [{
                type: Input
            }] } });

class FSWConfirmDialogComponent {
    constructor(context, _modalComponent) {
        this.context = context;
        this._modalComponent = _modalComponent;
        this.configuration();
    }
    cancel() {
        this.context.completeWith(false);
    }
    remove() {
        this.context.completeWith(true);
    }
    configuration() {
        this._modalComponent.setLabel(this.context.data['title']);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWConfirmDialogComponent, deps: [{ token: MODAL_CONTEXT }, { token: ModalComponent }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWConfirmDialogComponent, selector: "fsw-confirm-dialog", ngImport: i0, template: "<fsw-remove-dialog\n\t[buttonCancelLabel]=\"context.data['cancel']\"\n\t[buttonDeleteLabel]=\"context.data['delete']\"\n\t[description]=\"context.data['description']\"\n\t(cancel)=\"cancel()\"\n\t(remove)=\"remove()\"\n></fsw-remove-dialog>\n", dependencies: [{ kind: "component", type: FSWRemoveDialogComponent, selector: "fsw-remove-dialog", inputs: ["description", "buttonDeleteLabel", "buttonCancelLabel"], outputs: ["remove", "cancel"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWConfirmDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-confirm-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-remove-dialog\n\t[buttonCancelLabel]=\"context.data['cancel']\"\n\t[buttonDeleteLabel]=\"context.data['delete']\"\n\t[description]=\"context.data['description']\"\n\t(cancel)=\"cancel()\"\n\t(remove)=\"remove()\"\n></fsw-remove-dialog>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_CONTEXT]
                }] }, { type: ModalComponent }]; } });

class FSWRemoveDialogModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRemoveDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWRemoveDialogModule, declarations: [FSWRemoveDialogComponent], imports: [CommonModule], exports: [FSWRemoveDialogComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRemoveDialogModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRemoveDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [FSWRemoveDialogComponent],
                    exports: [FSWRemoveDialogComponent],
                }]
        }] });

class FSWConfirmDialogModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWConfirmDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWConfirmDialogModule, declarations: [FSWConfirmDialogComponent], imports: [CommonModule, FSWRemoveDialogModule], exports: [FSWConfirmDialogComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWConfirmDialogModule, imports: [CommonModule, FSWRemoveDialogModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWConfirmDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FSWConfirmDialogComponent],
                    imports: [CommonModule, FSWRemoveDialogModule],
                    exports: [FSWConfirmDialogComponent],
                }]
        }] });

/**
 * Defines the base class which is passed in to { MixinControl }.
 */
class ControlBase {
    getControlErrorMsgs(control, label) {
        switch (true) {
            case control?.errors?.['required']:
                return `${label} is a required field`;
            case control?.errors?.['textLengthError']:
                return `The text should be between 3 and 7 chars`;
            default:
                return ``;
        }
    }
}
/**
 * Defines the mixin which adds functionality to { ControlBase } class.
 */
function MixinControl(Base) {
    return class extends Base {
        get control() {
            return this.formFieldControl?.control;
        }
        set control(control) {
            if (!this.formFieldControl) {
                return;
            }
            this.formFieldControl.control = control;
        }
        get key() {
            return this.formFieldControl?.key;
        }
        get id() {
            return this.formFieldControl?.id;
        }
        get label() {
            return this.formFieldControl?.label;
        }
        get type() {
            return this.formFieldControl?.type;
        }
        get param() {
            return this.formFieldControl?.param;
        }
        get options() {
            return this.formFieldControl?.options;
        }
        get context() {
            return this.formFieldControl?.context;
        }
        get validator() {
            const validator = this.control.validator
                ? this.control.validator({})
                : null;
            return validator;
        }
    };
}
const ControlMixin = MixinControl(ControlBase);

var CoreFieldType;
(function (CoreFieldType) {
    CoreFieldType["STRING"] = "STRING";
    CoreFieldType["DATE"] = "DATE";
    CoreFieldType["SELECT"] = "SELECT";
    CoreFieldType["RADIO"] = "RADIO";
    CoreFieldType["CHECKBOX"] = "CHECKBOX";
    CoreFieldType["ARRAY"] = "ARRAY";
    CoreFieldType["NUMBER"] = "NUMBER";
    CoreFieldType["MULTI_SELECT"] = "MULTI_SELECT";
    // STRING_SELECT = 'STRING_SELECT',
    // NUMBER = 'NUMBER',
    // BOOLEAN = 'BOOLEAN',
})(CoreFieldType || (CoreFieldType = {}));
const FIELD_TYPE = {
    ...CoreFieldType,
};

const getErrorMessages = () => ({
    NO_FORM_CONFIG: `Please create the formConfig with formFields, formData and formFieldConfig`,
    NO_FORM_FIELDS: `Please add the formFields before creating the formConfig for formGroup`,
    NO_FORM_GROUP: `Please create the formGroup first`,
});
const getContextMsg = (fieldLabel) => ({
    PLACEHOLDER: `Please enter ${fieldLabel}`,
});

/**
 * Defines the base class which is passed in to { MixinForm }.
 */
class FormBase {
    constructor(fb) {
        this.fb = fb;
        this.formFieldControls$ = new BehaviorSubject([]);
        this.formFieldControls = [];
    }
}
/**
 * Defines the mixin which adds functionality to { FormBase } class.
 */
function MixinForm(Base) {
    return class extends Base {
        constructor() {
            super(...arguments);
            this.loading = false;
        }
        /**
         * Sets a single formGroup based on formFieldControl
         */
        buildFormGroup(formFields) {
            this.formGroup = this._createFormGroup(formFields);
        }
        /**
         * Clear a single formGroup based on formFieldControl
         */
        clearFormGroup() {
            if (!this.formGroup)
                return;
            Object.keys(this.formGroup.controls).forEach((key) => this.formGroup.removeControl(key));
        }
        /**
         * Sets the formFieldControls
         */
        buildFormFieldControls() {
            this.formFieldControls = this._createFormFieldControls();
            this.formFieldControls$.next([...this.formFieldControls]);
        }
        /**
         * clear the formFieldControls
         */
        clearFormFieldControls() {
            this.formFieldControls = [];
            this.formFieldControls$.next([...this.formFieldControls]);
        }
        /**
         * Sets a single formGroup based on formFieldControl
         */
        buildFormArray(formFieldKey) {
            if (!this.formGroup)
                this.buildFormGroup();
            this.formGroup.addControl(formFieldKey, this.fb.array([]));
        }
        /**
         * Initializes configs, sets formData & readonly property
         */
        initWidget(loading = false) {
            this.loading = loading;
            this.clearFormFieldControls();
            this.clearFormGroup();
            this.buildFormGroup();
            this.buildFormFieldControls();
            this.formGroup.patchValue({ ...this.formConfig?.formData });
            if (this.formConfig?.formFieldConfig?.isReadonly)
                this.setAllControlsReadOnly();
            return this.formGroup;
        }
        /**
         * Removes readonly property, present inside context, to true
         */
        removeReadOnly() {
            this.formFieldControls.forEach((config) => {
                config.context = config.context || {};
                delete config.context.isReadonly;
            });
            this.formFieldControls$.next([...this.formFieldControls]);
        }
        /**
         * Sets readonly property, present inside context, to true
         */
        setAllControlsReadOnly() {
            this.formFieldControls.forEach((i) => {
                i.context = i.context || {};
                i.context.isReadonly = true;
            });
            this.formFieldControls$.next([...this.formFieldControls]);
        }
        /**
         * Creates the formFieldControls list based on the `formConfig.formFields`
         */
        _createFormFieldControls() {
            if (!this.formConfig)
                throw new Error(getErrorMessages().NO_FORM_CONFIG);
            if (!this.formConfig?.formFields?.length)
                throw new Error(getErrorMessages().NO_FORM_FIELDS);
            if (!this.formGroup)
                throw new Error(getErrorMessages().NO_FORM_GROUP);
            return this.formConfig.formFields.map((i) => ({
                ...i,
                control: this.formGroup.get(i?.key),
                validator: null,
                context: {
                    ...i?.context,
                    placeholder: i?.context?.placeholder || getContextMsg(i?.label).PLACEHOLDER,
                    loading: this.loading,
                },
            }));
        }
        /**
         * Creates the formGroup based on the `formConfig.formFields` received from consumer component
         */
        _createFormGroup(formFields) {
            const formFieldsList = formFields || this.formConfig?.formFields;
            if (!formFieldsList?.length)
                throw new Error(getErrorMessages().NO_FORM_FIELDS);
            return this.fb.group(formFieldsList
                .filter((i) => !this.formGroup || !this.formGroup.contains(i?.key))
                .reduce((acc, i) => {
                const { param, key, type } = i;
                if (type === FIELD_TYPE.ARRAY)
                    acc[key] = this.fb.array.apply([], [[]]);
                else
                    acc[key] = this.fb.control.apply(this, param);
                return acc;
            }, {}), { validators: this.formValidators });
        }
    };
}
const FormMixin = MixinForm(FormBase);

const BASE_CTRL_TEMPLATE = `
  <div class="form-control" [ngClass]="{
    'has-error': control?.touched && !control?.valid && !control.disabled
  }">
    <label [attr.for]="key + '-' + id" class="form-label">
      {{ label }}
      <span style="color: #cc1830;" *ngIf="validator?.required"> * </span>
    </label>
    <ng-container *ngIf="!context?.loading; else skeletonTemplate">
      <ng-container *ngIf="!context?.isReadonly">
        <ng-container *ngTemplateOutlet="activeCtrlTemplate"></ng-container>
      </ng-container>
      <ng-container *ngIf="context?.isReadonly">
        <div>
          <ng-container *ngIf="(control?.valueChanges | async) as value; else defaultValueTemplate">
              <ng-container *ngTemplateOutlet="valueTemplate; context: {$implicit: value}"></ng-container>
          </ng-container>
          <ng-template #defaultValueTemplate>
              <ng-container *ngTemplateOutlet="valueTemplate; context: {$implicit: control?.value}"></ng-container>
          </ng-template>
          <ng-template #valueTemplate let-value>
              <ng-container *ngIf="context?.template as temp; else templateDefault">
                {{ temp(value) }}
              </ng-container>

              <ng-template #templateDefault>
                <div>{{ value }}</div>
              </ng-template>
          </ng-template>
          <span
            *ngIf="context?.suffix"
            [ngClass]="{
              'input-group__suffix': !context?.isReadonly,
              'input-group__suffix-readonly': context?.isReadonly
            }"
          >{{ context?.suffix }}</span>
        </div>
      </ng-container>
      <span class="form-control__help" *ngIf="context?.helperText">
        {{ context?.helperText }}
      </span>
      <span class="form-control__error" *ngIf="control?.touched && !control?.valid && control?.errors">
        {{ getControlErrorMsgs(control, label) }}
      </span>
    </ng-container>
    <ng-template #skeletonTemplate>
      <div class="text-loading text-loading__box"></div>
    </ng-template>
  </div>
`;

const CHECKBOX_CTRL_TEMPLATE = BASE_CTRL_TEMPLATE +
    `
		<ng-template #activeCtrlTemplate>
			<fieldset class="form-control" [ngClass]="{ 'has-error': !control?.valid }">
				<div class="form-choice">
					<input type="checkbox" [id]="key + '-' + id" [formControl]="control" />
					<label [attr.for]="key + '-' + id" class="form-choice__label form-choice__label--checkbox">
					</label>
				</div>
			</fieldset>
		</ng-template>
	`;
class CheckboxControlComponent extends ControlMixin {
    constructor() {
        super(...arguments);
        this.inputType = CoreFieldType.CHECKBOX;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CheckboxControlComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CheckboxControlComponent, selector: "ng-component", usesInheritance: true, ngImport: i0, template: "\n  <div class=\"form-control\" [ngClass]=\"{\n    'has-error': control?.touched && !control?.valid && !control.disabled\n  }\">\n    <label [attr.for]=\"key + '-' + id\" class=\"form-label\">\n      {{ label }}\n      <span style=\"color: #cc1830;\" *ngIf=\"validator?.required\"> * </span>\n    </label>\n    <ng-container *ngIf=\"!context?.loading; else skeletonTemplate\">\n      <ng-container *ngIf=\"!context?.isReadonly\">\n        <ng-container *ngTemplateOutlet=\"activeCtrlTemplate\"></ng-container>\n      </ng-container>\n      <ng-container *ngIf=\"context?.isReadonly\">\n        <div>\n          <ng-container *ngIf=\"(control?.valueChanges | async) as value; else defaultValueTemplate\">\n              <ng-container *ngTemplateOutlet=\"valueTemplate; context: {$implicit: value}\"></ng-container>\n          </ng-container>\n          <ng-template #defaultValueTemplate>\n              <ng-container *ngTemplateOutlet=\"valueTemplate; context: {$implicit: control?.value}\"></ng-container>\n          </ng-template>\n          <ng-template #valueTemplate let-value>\n              <ng-container *ngIf=\"context?.template as temp; else templateDefault\">\n                {{ temp(value) }}\n              </ng-container>\n\n              <ng-template #templateDefault>\n                <div>{{ value }}</div>\n              </ng-template>\n          </ng-template>\n          <span\n            *ngIf=\"context?.suffix\"\n            [ngClass]=\"{\n              'input-group__suffix': !context?.isReadonly,\n              'input-group__suffix-readonly': context?.isReadonly\n            }\"\n          >{{ context?.suffix }}</span>\n        </div>\n      </ng-container>\n      <span class=\"form-control__help\" *ngIf=\"context?.helperText\">\n        {{ context?.helperText }}\n      </span>\n      <span class=\"form-control__error\" *ngIf=\"control?.touched && !control?.valid && control?.errors\">\n        {{ getControlErrorMsgs(control, label) }}\n      </span>\n    </ng-container>\n    <ng-template #skeletonTemplate>\n      <div class=\"text-loading text-loading__box\"></div>\n    </ng-template>\n  </div>\n\n\t\t<ng-template #activeCtrlTemplate>\n\t\t\t<fieldset class=\"form-control\" [ngClass]=\"{ 'has-error': !control?.valid }\">\n\t\t\t\t<div class=\"form-choice\">\n\t\t\t\t\t<input type=\"checkbox\" [id]=\"key + '-' + id\" [formControl]=\"control\" />\n\t\t\t\t\t<label [attr.for]=\"key + '-' + id\" class=\"form-choice__label form-choice__label--checkbox\">\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t</fieldset>\n\t\t</ng-template>\n\t", isInline: true, styles: [".form-control{position:relative}.form-choice{position:absolute}\n", ".text-loading{display:inline-block;height:1em;position:relative;overflow:hidden;background-color:#dddbdd}.text-loading__box{width:100%;height:24px}.text-loading:after{position:absolute;inset:0;transform:translate(-100%);background-image:linear-gradient(90deg,rgba(255,255,255,0) 0,rgba(255,255,255,.2) 20%,rgba(255,255,255,.5) 60%,rgba(255,255,255,0));animation:shimmer 1s infinite;content:\"\"}@keyframes shimmer{to{transform:translate(100%)}}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CheckboxControlComponent, decorators: [{
            type: Component,
            args: [{ template: CHECKBOX_CTRL_TEMPLATE, styles: [".form-control{position:relative}.form-choice{position:absolute}\n", ".text-loading{display:inline-block;height:1em;position:relative;overflow:hidden;background-color:#dddbdd}.text-loading__box{width:100%;height:24px}.text-loading:after{position:absolute;inset:0;transform:translate(-100%);background-image:linear-gradient(90deg,rgba(255,255,255,0) 0,rgba(255,255,255,.2) 20%,rgba(255,255,255,.5) 60%,rgba(255,255,255,0));animation:shimmer 1s infinite;content:\"\"}@keyframes shimmer{to{transform:translate(100%)}}\n"] }]
        }] });

const DATE_CTRL_TEMPLATE = BASE_CTRL_TEMPLATE +
    `
    <ng-template #activeCtrlTemplate>
      <input
        class="form-input"
        type="date"
        [id]="key + '-' + id"
        [formControl]="control"
        [max]="context?.maxDate"
        [min]="context?.minDate"
      />
    </ng-template>
  `;
class DateControlComponent extends ControlMixin {
    constructor(_datePipe) {
        super();
        this._datePipe = _datePipe;
        this.inputType = CoreFieldType.DATE;
    }
    ngOnInit() {
        const value = this.control.value;
        if (value && typeof value === 'object' && value.constructor === Object) {
            if (!value.value)
                return;
            // convert object to Date
            const year = value.year;
            const month = value.month - 1; // months are zero-indexed
            const day = value.day;
            const date = new Date(year, month, day);
            this.control.setValue(this._datePipe.transform(date, 'yyyy-MM-dd'));
        }
        else {
            this.control.setValue(this._datePipe.transform(value, 'yyyy-MM-dd'));
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DateControlComponent, deps: [{ token: i1$1.DatePipe }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DateControlComponent, selector: "ng-component", usesInheritance: true, ngImport: i0, template: "\n  <div class=\"form-control\" [ngClass]=\"{\n    'has-error': control?.touched && !control?.valid && !control.disabled\n  }\">\n    <label [attr.for]=\"key + '-' + id\" class=\"form-label\">\n      {{ label }}\n      <span style=\"color: #cc1830;\" *ngIf=\"validator?.required\"> * </span>\n    </label>\n    <ng-container *ngIf=\"!context?.loading; else skeletonTemplate\">\n      <ng-container *ngIf=\"!context?.isReadonly\">\n        <ng-container *ngTemplateOutlet=\"activeCtrlTemplate\"></ng-container>\n      </ng-container>\n      <ng-container *ngIf=\"context?.isReadonly\">\n        <div>\n          <ng-container *ngIf=\"(control?.valueChanges | async) as value; else defaultValueTemplate\">\n              <ng-container *ngTemplateOutlet=\"valueTemplate; context: {$implicit: value}\"></ng-container>\n          </ng-container>\n          <ng-template #defaultValueTemplate>\n              <ng-container *ngTemplateOutlet=\"valueTemplate; context: {$implicit: control?.value}\"></ng-container>\n          </ng-template>\n          <ng-template #valueTemplate let-value>\n              <ng-container *ngIf=\"context?.template as temp; else templateDefault\">\n                {{ temp(value) }}\n              </ng-container>\n\n              <ng-template #templateDefault>\n                <div>{{ value }}</div>\n              </ng-template>\n          </ng-template>\n          <span\n            *ngIf=\"context?.suffix\"\n            [ngClass]=\"{\n              'input-group__suffix': !context?.isReadonly,\n              'input-group__suffix-readonly': context?.isReadonly\n            }\"\n          >{{ context?.suffix }}</span>\n        </div>\n      </ng-container>\n      <span class=\"form-control__help\" *ngIf=\"context?.helperText\">\n        {{ context?.helperText }}\n      </span>\n      <span class=\"form-control__error\" *ngIf=\"control?.touched && !control?.valid && control?.errors\">\n        {{ getControlErrorMsgs(control, label) }}\n      </span>\n    </ng-container>\n    <ng-template #skeletonTemplate>\n      <div class=\"text-loading text-loading__box\"></div>\n    </ng-template>\n  </div>\n\n    <ng-template #activeCtrlTemplate>\n      <input\n        class=\"form-input\"\n        type=\"date\"\n        [id]=\"key + '-' + id\"\n        [formControl]=\"control\"\n        [max]=\"context?.maxDate\"\n        [min]=\"context?.minDate\"\n      />\n    </ng-template>\n  ", isInline: true, styles: [".form-input{line-height:1.37}\n", ".text-loading{display:inline-block;height:1em;position:relative;overflow:hidden;background-color:#dddbdd}.text-loading__box{width:100%;height:24px}.text-loading:after{position:absolute;inset:0;transform:translate(-100%);background-image:linear-gradient(90deg,rgba(255,255,255,0) 0,rgba(255,255,255,.2) 20%,rgba(255,255,255,.5) 60%,rgba(255,255,255,0));animation:shimmer 1s infinite;content:\"\"}@keyframes shimmer{to{transform:translate(100%)}}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DateControlComponent, decorators: [{
            type: Component,
            args: [{ template: DATE_CTRL_TEMPLATE, styles: [".form-input{line-height:1.37}\n", ".text-loading{display:inline-block;height:1em;position:relative;overflow:hidden;background-color:#dddbdd}.text-loading__box{width:100%;height:24px}.text-loading:after{position:absolute;inset:0;transform:translate(-100%);background-image:linear-gradient(90deg,rgba(255,255,255,0) 0,rgba(255,255,255,.2) 20%,rgba(255,255,255,.5) 60%,rgba(255,255,255,0));animation:shimmer 1s infinite;content:\"\"}@keyframes shimmer{to{transform:translate(100%)}}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.DatePipe }]; } });

const NUMBER_CTRL_TEMPLATE = BASE_CTRL_TEMPLATE +
    `
    <ng-template #activeCtrlTemplate>
      <input
        class="form-input"
        type="number"
        [id]="key + '-' + id"
        [formControl]="control"
        [placeholder]="context?.placeholder"
      />
    </ng-template>
  `;
class NumberControlComponent extends ControlMixin {
    constructor() {
        super(...arguments);
        this.inputType = CoreFieldType.NUMBER;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NumberControlComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: NumberControlComponent, selector: "ng-component", usesInheritance: true, ngImport: i0, template: "\n  <div class=\"form-control\" [ngClass]=\"{\n    'has-error': control?.touched && !control?.valid && !control.disabled\n  }\">\n    <label [attr.for]=\"key + '-' + id\" class=\"form-label\">\n      {{ label }}\n      <span style=\"color: #cc1830;\" *ngIf=\"validator?.required\"> * </span>\n    </label>\n    <ng-container *ngIf=\"!context?.loading; else skeletonTemplate\">\n      <ng-container *ngIf=\"!context?.isReadonly\">\n        <ng-container *ngTemplateOutlet=\"activeCtrlTemplate\"></ng-container>\n      </ng-container>\n      <ng-container *ngIf=\"context?.isReadonly\">\n        <div>\n          <ng-container *ngIf=\"(control?.valueChanges | async) as value; else defaultValueTemplate\">\n              <ng-container *ngTemplateOutlet=\"valueTemplate; context: {$implicit: value}\"></ng-container>\n          </ng-container>\n          <ng-template #defaultValueTemplate>\n              <ng-container *ngTemplateOutlet=\"valueTemplate; context: {$implicit: control?.value}\"></ng-container>\n          </ng-template>\n          <ng-template #valueTemplate let-value>\n              <ng-container *ngIf=\"context?.template as temp; else templateDefault\">\n                {{ temp(value) }}\n              </ng-container>\n\n              <ng-template #templateDefault>\n                <div>{{ value }}</div>\n              </ng-template>\n          </ng-template>\n          <span\n            *ngIf=\"context?.suffix\"\n            [ngClass]=\"{\n              'input-group__suffix': !context?.isReadonly,\n              'input-group__suffix-readonly': context?.isReadonly\n            }\"\n          >{{ context?.suffix }}</span>\n        </div>\n      </ng-container>\n      <span class=\"form-control__help\" *ngIf=\"context?.helperText\">\n        {{ context?.helperText }}\n      </span>\n      <span class=\"form-control__error\" *ngIf=\"control?.touched && !control?.valid && control?.errors\">\n        {{ getControlErrorMsgs(control, label) }}\n      </span>\n    </ng-container>\n    <ng-template #skeletonTemplate>\n      <div class=\"text-loading text-loading__box\"></div>\n    </ng-template>\n  </div>\n\n    <ng-template #activeCtrlTemplate>\n      <input\n        class=\"form-input\"\n        type=\"number\"\n        [id]=\"key + '-' + id\"\n        [formControl]=\"control\"\n        [placeholder]=\"context?.placeholder\"\n      />\n    </ng-template>\n  ", isInline: true, styles: [".text-loading{display:inline-block;height:1em;position:relative;overflow:hidden;background-color:#dddbdd}.text-loading__box{width:100%;height:24px}.text-loading:after{position:absolute;inset:0;transform:translate(-100%);background-image:linear-gradient(90deg,rgba(255,255,255,0) 0,rgba(255,255,255,.2) 20%,rgba(255,255,255,.5) 60%,rgba(255,255,255,0));animation:shimmer 1s infinite;content:\"\"}@keyframes shimmer{to{transform:translate(100%)}}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NumberControlComponent, decorators: [{
            type: Component,
            args: [{ template: NUMBER_CTRL_TEMPLATE, styles: [".text-loading{display:inline-block;height:1em;position:relative;overflow:hidden;background-color:#dddbdd}.text-loading__box{width:100%;height:24px}.text-loading:after{position:absolute;inset:0;transform:translate(-100%);background-image:linear-gradient(90deg,rgba(255,255,255,0) 0,rgba(255,255,255,.2) 20%,rgba(255,255,255,.5) 60%,rgba(255,255,255,0));animation:shimmer 1s infinite;content:\"\"}@keyframes shimmer{to{transform:translate(100%)}}\n"] }]
        }] });

const SELECT_CTRL_TEMPLATE = BASE_CTRL_TEMPLATE +
    `
    <ng-template #activeCtrlTemplate>
      <div [class.form-select]="true" [class.form-select--disabled]="control?.disabled">
        <select [formControl]="control">
          <option *ngFor="let option of options" [value]="option?.value">
            {{ option?.label }}
          </option>
        </select>
      </div>
    </ng-template>
  `;
class SelectControlComponent extends ControlMixin {
    constructor() {
        super(...arguments);
        this.inputType = CoreFieldType.SELECT;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SelectControlComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: SelectControlComponent, selector: "ng-component", usesInheritance: true, ngImport: i0, template: "\n  <div class=\"form-control\" [ngClass]=\"{\n    'has-error': control?.touched && !control?.valid && !control.disabled\n  }\">\n    <label [attr.for]=\"key + '-' + id\" class=\"form-label\">\n      {{ label }}\n      <span style=\"color: #cc1830;\" *ngIf=\"validator?.required\"> * </span>\n    </label>\n    <ng-container *ngIf=\"!context?.loading; else skeletonTemplate\">\n      <ng-container *ngIf=\"!context?.isReadonly\">\n        <ng-container *ngTemplateOutlet=\"activeCtrlTemplate\"></ng-container>\n      </ng-container>\n      <ng-container *ngIf=\"context?.isReadonly\">\n        <div>\n          <ng-container *ngIf=\"(control?.valueChanges | async) as value; else defaultValueTemplate\">\n              <ng-container *ngTemplateOutlet=\"valueTemplate; context: {$implicit: value}\"></ng-container>\n          </ng-container>\n          <ng-template #defaultValueTemplate>\n              <ng-container *ngTemplateOutlet=\"valueTemplate; context: {$implicit: control?.value}\"></ng-container>\n          </ng-template>\n          <ng-template #valueTemplate let-value>\n              <ng-container *ngIf=\"context?.template as temp; else templateDefault\">\n                {{ temp(value) }}\n              </ng-container>\n\n              <ng-template #templateDefault>\n                <div>{{ value }}</div>\n              </ng-template>\n          </ng-template>\n          <span\n            *ngIf=\"context?.suffix\"\n            [ngClass]=\"{\n              'input-group__suffix': !context?.isReadonly,\n              'input-group__suffix-readonly': context?.isReadonly\n            }\"\n          >{{ context?.suffix }}</span>\n        </div>\n      </ng-container>\n      <span class=\"form-control__help\" *ngIf=\"context?.helperText\">\n        {{ context?.helperText }}\n      </span>\n      <span class=\"form-control__error\" *ngIf=\"control?.touched && !control?.valid && control?.errors\">\n        {{ getControlErrorMsgs(control, label) }}\n      </span>\n    </ng-container>\n    <ng-template #skeletonTemplate>\n      <div class=\"text-loading text-loading__box\"></div>\n    </ng-template>\n  </div>\n\n    <ng-template #activeCtrlTemplate>\n      <div [class.form-select]=\"true\" [class.form-select--disabled]=\"control?.disabled\">\n        <select [formControl]=\"control\">\n          <option *ngFor=\"let option of options\" [value]=\"option?.value\">\n            {{ option?.label }}\n          </option>\n        </select>\n      </div>\n    </ng-template>\n  ", isInline: true, styles: [".text-loading{display:inline-block;height:1em;position:relative;overflow:hidden;background-color:#dddbdd}.text-loading__box{width:100%;height:24px}.text-loading:after{position:absolute;inset:0;transform:translate(-100%);background-image:linear-gradient(90deg,rgba(255,255,255,0) 0,rgba(255,255,255,.2) 20%,rgba(255,255,255,.5) 60%,rgba(255,255,255,0));animation:shimmer 1s infinite;content:\"\"}@keyframes shimmer{to{transform:translate(100%)}}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i2.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i2.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SelectControlComponent, decorators: [{
            type: Component,
            args: [{ template: SELECT_CTRL_TEMPLATE, styles: [".text-loading{display:inline-block;height:1em;position:relative;overflow:hidden;background-color:#dddbdd}.text-loading__box{width:100%;height:24px}.text-loading:after{position:absolute;inset:0;transform:translate(-100%);background-image:linear-gradient(90deg,rgba(255,255,255,0) 0,rgba(255,255,255,.2) 20%,rgba(255,255,255,.5) 60%,rgba(255,255,255,0));animation:shimmer 1s infinite;content:\"\"}@keyframes shimmer{to{transform:translate(100%)}}\n"] }]
        }] });

const STRING_CTRL_TEMPLATE = BASE_CTRL_TEMPLATE +
    `
    <ng-template #activeCtrlTemplate>
      <ng-container *ngIf="context?.isMultiline; else default">
        <textarea
          class="form-input"
          type="text"
          [id]="key + '-' + id"
          [rows]="context?.numberOfRows"
          [formControl]="control"
          [placeholder]="context?.placeholder"
        ></textarea>
      </ng-container>
      <ng-template #default>
        <input
          class="form-input"
          type="text"
          [id]="key"
          [formControl]="control"
          [placeholder]="context?.placeholder"
        />
      </ng-template>
    </ng-template>
  `;
class StringControlComponent extends ControlMixin {
    constructor() {
        super(...arguments);
        this.inputType = CoreFieldType.STRING;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StringControlComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: StringControlComponent, selector: "ng-component", usesInheritance: true, ngImport: i0, template: "\n  <div class=\"form-control\" [ngClass]=\"{\n    'has-error': control?.touched && !control?.valid && !control.disabled\n  }\">\n    <label [attr.for]=\"key + '-' + id\" class=\"form-label\">\n      {{ label }}\n      <span style=\"color: #cc1830;\" *ngIf=\"validator?.required\"> * </span>\n    </label>\n    <ng-container *ngIf=\"!context?.loading; else skeletonTemplate\">\n      <ng-container *ngIf=\"!context?.isReadonly\">\n        <ng-container *ngTemplateOutlet=\"activeCtrlTemplate\"></ng-container>\n      </ng-container>\n      <ng-container *ngIf=\"context?.isReadonly\">\n        <div>\n          <ng-container *ngIf=\"(control?.valueChanges | async) as value; else defaultValueTemplate\">\n              <ng-container *ngTemplateOutlet=\"valueTemplate; context: {$implicit: value}\"></ng-container>\n          </ng-container>\n          <ng-template #defaultValueTemplate>\n              <ng-container *ngTemplateOutlet=\"valueTemplate; context: {$implicit: control?.value}\"></ng-container>\n          </ng-template>\n          <ng-template #valueTemplate let-value>\n              <ng-container *ngIf=\"context?.template as temp; else templateDefault\">\n                {{ temp(value) }}\n              </ng-container>\n\n              <ng-template #templateDefault>\n                <div>{{ value }}</div>\n              </ng-template>\n          </ng-template>\n          <span\n            *ngIf=\"context?.suffix\"\n            [ngClass]=\"{\n              'input-group__suffix': !context?.isReadonly,\n              'input-group__suffix-readonly': context?.isReadonly\n            }\"\n          >{{ context?.suffix }}</span>\n        </div>\n      </ng-container>\n      <span class=\"form-control__help\" *ngIf=\"context?.helperText\">\n        {{ context?.helperText }}\n      </span>\n      <span class=\"form-control__error\" *ngIf=\"control?.touched && !control?.valid && control?.errors\">\n        {{ getControlErrorMsgs(control, label) }}\n      </span>\n    </ng-container>\n    <ng-template #skeletonTemplate>\n      <div class=\"text-loading text-loading__box\"></div>\n    </ng-template>\n  </div>\n\n    <ng-template #activeCtrlTemplate>\n      <ng-container *ngIf=\"context?.isMultiline; else default\">\n        <textarea\n          class=\"form-input\"\n          type=\"text\"\n          [id]=\"key + '-' + id\"\n          [rows]=\"context?.numberOfRows\"\n          [formControl]=\"control\"\n          [placeholder]=\"context?.placeholder\"\n        ></textarea>\n      </ng-container>\n      <ng-template #default>\n        <input\n          class=\"form-input\"\n          type=\"text\"\n          [id]=\"key\"\n          [formControl]=\"control\"\n          [placeholder]=\"context?.placeholder\"\n        />\n      </ng-template>\n    </ng-template>\n  ", isInline: true, styles: [".text-loading{display:inline-block;height:1em;position:relative;overflow:hidden;background-color:#dddbdd}.text-loading__box{width:100%;height:24px}.text-loading:after{position:absolute;inset:0;transform:translate(-100%);background-image:linear-gradient(90deg,rgba(255,255,255,0) 0,rgba(255,255,255,.2) 20%,rgba(255,255,255,.5) 60%,rgba(255,255,255,0));animation:shimmer 1s infinite;content:\"\"}@keyframes shimmer{to{transform:translate(100%)}}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StringControlComponent, decorators: [{
            type: Component,
            args: [{ template: STRING_CTRL_TEMPLATE, styles: [".text-loading{display:inline-block;height:1em;position:relative;overflow:hidden;background-color:#dddbdd}.text-loading__box{width:100%;height:24px}.text-loading:after{position:absolute;inset:0;transform:translate(-100%);background-image:linear-gradient(90deg,rgba(255,255,255,0) 0,rgba(255,255,255,.2) 20%,rgba(255,255,255,.5) 60%,rgba(255,255,255,0));animation:shimmer 1s infinite;content:\"\"}@keyframes shimmer{to{transform:translate(100%)}}\n"] }]
        }] });

const RADIO_CTRL_TEMPLATE = BASE_CTRL_TEMPLATE +
    `
    <ng-template #activeCtrlTemplate>
      <div class="form-choice"
        *ngFor="let option of options; let i = index"
        [class.form-choice--inline]="context?.inline"
      >
        <input
          type="radio"
          [id]="key + '-' + id + '-' + i"
          [formControl]="control"
          [name]="key + '-' + id"
          [value]="option?.value"
        />
        <label [for]="key + '-' + id + '-' + i" class="form-choice__label form-choice__label--radio">
         {{ option?.label }}
        </label>
      </div>
    </ng-template>
  `;
class RadioControlComponent extends ControlMixin {
    constructor() {
        super(...arguments);
        this.inputType = CoreFieldType.RADIO;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RadioControlComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: RadioControlComponent, selector: "ng-component", usesInheritance: true, ngImport: i0, template: "\n  <div class=\"form-control\" [ngClass]=\"{\n    'has-error': control?.touched && !control?.valid && !control.disabled\n  }\">\n    <label [attr.for]=\"key + '-' + id\" class=\"form-label\">\n      {{ label }}\n      <span style=\"color: #cc1830;\" *ngIf=\"validator?.required\"> * </span>\n    </label>\n    <ng-container *ngIf=\"!context?.loading; else skeletonTemplate\">\n      <ng-container *ngIf=\"!context?.isReadonly\">\n        <ng-container *ngTemplateOutlet=\"activeCtrlTemplate\"></ng-container>\n      </ng-container>\n      <ng-container *ngIf=\"context?.isReadonly\">\n        <div>\n          <ng-container *ngIf=\"(control?.valueChanges | async) as value; else defaultValueTemplate\">\n              <ng-container *ngTemplateOutlet=\"valueTemplate; context: {$implicit: value}\"></ng-container>\n          </ng-container>\n          <ng-template #defaultValueTemplate>\n              <ng-container *ngTemplateOutlet=\"valueTemplate; context: {$implicit: control?.value}\"></ng-container>\n          </ng-template>\n          <ng-template #valueTemplate let-value>\n              <ng-container *ngIf=\"context?.template as temp; else templateDefault\">\n                {{ temp(value) }}\n              </ng-container>\n\n              <ng-template #templateDefault>\n                <div>{{ value }}</div>\n              </ng-template>\n          </ng-template>\n          <span\n            *ngIf=\"context?.suffix\"\n            [ngClass]=\"{\n              'input-group__suffix': !context?.isReadonly,\n              'input-group__suffix-readonly': context?.isReadonly\n            }\"\n          >{{ context?.suffix }}</span>\n        </div>\n      </ng-container>\n      <span class=\"form-control__help\" *ngIf=\"context?.helperText\">\n        {{ context?.helperText }}\n      </span>\n      <span class=\"form-control__error\" *ngIf=\"control?.touched && !control?.valid && control?.errors\">\n        {{ getControlErrorMsgs(control, label) }}\n      </span>\n    </ng-container>\n    <ng-template #skeletonTemplate>\n      <div class=\"text-loading text-loading__box\"></div>\n    </ng-template>\n  </div>\n\n    <ng-template #activeCtrlTemplate>\n      <div class=\"form-choice\"\n        *ngFor=\"let option of options; let i = index\"\n        [class.form-choice--inline]=\"context?.inline\"\n      >\n        <input\n          type=\"radio\"\n          [id]=\"key + '-' + id + '-' + i\"\n          [formControl]=\"control\"\n          [name]=\"key + '-' + id\"\n          [value]=\"option?.value\"\n        />\n        <label [for]=\"key + '-' + id + '-' + i\" class=\"form-choice__label form-choice__label--radio\">\n         {{ option?.label }}\n        </label>\n      </div>\n    </ng-template>\n  ", isInline: true, styles: [".text-loading{display:inline-block;height:1em;position:relative;overflow:hidden;background-color:#dddbdd}.text-loading__box{width:100%;height:24px}.text-loading:after{position:absolute;inset:0;transform:translate(-100%);background-image:linear-gradient(90deg,rgba(255,255,255,0) 0,rgba(255,255,255,.2) 20%,rgba(255,255,255,.5) 60%,rgba(255,255,255,0));animation:shimmer 1s infinite;content:\"\"}@keyframes shimmer{to{transform:translate(100%)}}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.RadioControlValueAccessor, selector: "input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]", inputs: ["name", "formControlName", "value"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RadioControlComponent, decorators: [{
            type: Component,
            args: [{ template: RADIO_CTRL_TEMPLATE, styles: [".text-loading{display:inline-block;height:1em;position:relative;overflow:hidden;background-color:#dddbdd}.text-loading__box{width:100%;height:24px}.text-loading:after{position:absolute;inset:0;transform:translate(-100%);background-image:linear-gradient(90deg,rgba(255,255,255,0) 0,rgba(255,255,255,.2) 20%,rgba(255,255,255,.5) 60%,rgba(255,255,255,0));animation:shimmer 1s infinite;content:\"\"}@keyframes shimmer{to{transform:translate(100%)}}\n"] }]
        }] });

class ControlsWidgetModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ControlsWidgetModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ControlsWidgetModule, declarations: [StringControlComponent,
            NumberControlComponent,
            DateControlComponent,
            SelectControlComponent,
            CheckboxControlComponent,
            RadioControlComponent], imports: [CommonModule, ReactiveFormsModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ControlsWidgetModule, providers: [DatePipe], imports: [CommonModule, ReactiveFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ControlsWidgetModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, ReactiveFormsModule],
                    declarations: [
                        StringControlComponent,
                        NumberControlComponent,
                        DateControlComponent,
                        SelectControlComponent,
                        CheckboxControlComponent,
                        RadioControlComponent,
                    ],
                    providers: [DatePipe],
                }]
        }] });

const CORE_CONTROLS = [
    {
        type: FIELD_TYPE.STRING,
        component: StringControlComponent,
    },
    {
        type: FIELD_TYPE.RADIO,
        component: RadioControlComponent,
    },
    {
        type: FIELD_TYPE.NUMBER,
        component: NumberControlComponent,
    },
    {
        type: FIELD_TYPE.DATE,
        component: DateControlComponent,
    },
    {
        type: FIELD_TYPE.SELECT,
        component: SelectControlComponent,
    },
    {
        type: FIELD_TYPE.CHECKBOX,
        component: CheckboxControlComponent,
    },
];
const CORE_MANIFEST = [...CORE_CONTROLS];

class DynamicCompLoaderDirective {
    constructor(_viewContainerRef, _formDirective, _componentFactoryResolver, _fb) {
        this._viewContainerRef = _viewContainerRef;
        this._formDirective = _formDirective;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._fb = _fb;
        this._destroySubject = new Subject();
        this._latestState = '';
        this._componentRef = null;
        this._control = new FormControl();
    }
    ngOnInit() {
        this.loadComponent();
    }
    ngOnDestroy() {
        this._destroySubject.next(0);
        this._destroySubject.complete();
    }
    loadComponent() {
        if (!this.formFieldControl) {
            this._clearView();
            return;
        }
        const componentInstance = this._getComponent(this.formFieldControl.type);
        if (!componentInstance) {
            this._clearView();
            return;
        }
        const formGroup = this._formDirective.control;
        const customRender = this.formFieldControl.context?.customRender;
        this.formFieldControl.id = this.formFieldControl.id || v4();
        if (customRender?.length) {
            formGroup.valueChanges
                .pipe(distinctUntilChanged(), tap((value) => {
                customRender.forEach(({ fields, cb }) => {
                    const controls = fields.filter((field) => !!formGroup.get(field.key));
                    const finalCondition = controls
                        .map(({ key, correctWhenValueIs }) => {
                        return correctWhenValueIs(value[key], this.formFieldControl);
                    })
                        .every((condition) => condition);
                    cb({
                        formGroup,
                        clearView: () => this._clearView(),
                        renderView: () => this._renderView(componentInstance),
                        formFieldControl: this.formFieldControl,
                    }, finalCondition);
                });
            }), takeUntil(this._destroySubject))
                .subscribe();
            formGroup.patchValue({ ...formGroup.value });
        }
        else {
            this._renderView(componentInstance);
        }
    }
    _getComponent(type) {
        return CORE_MANIFEST?.find((manifest) => manifest.type === type)?.component;
    }
    _clearView(clearControl = true) {
        if (this._latestState === 'clear') {
            return;
        }
        this._latestState = 'clear';
        this._viewContainerRef.clear();
        this._viewContainerRef.element.nativeElement.parentElement?.classList.add('hidden');
        if (clearControl && this.formFieldControl.control) {
            this._control = this._fb.control.apply(this, this.formFieldControl.param);
            this._control.setValue(this.formFieldControl.control.value);
            this.formFieldControl.control = this._control;
            this._formDirective.control.removeControl(this.formFieldControl.key);
            this._formDirective.control.updateValueAndValidity();
        }
    }
    _renderView(componentInstance) {
        if (this._latestState === 'render') {
            return this._componentRef;
        }
        const componentFactory = this._componentFactoryResolver.resolveComponentFactory(componentInstance);
        this._latestState = 'render';
        this._clearView(false);
        this._latestState = 'render';
        const existed = this._formDirective.control.get(this.formFieldControl.key);
        if (!existed && this._control) {
            const control = this._fb.control.apply(this, this.formFieldControl.param);
            control.setValue(this._control.value);
            this._formDirective.control.addControl(this.formFieldControl.key, control);
            this.formFieldControl.control = control;
            this._formDirective.control.updateValueAndValidity();
        }
        const componentRef = this._viewContainerRef.createComponent(componentFactory);
        componentRef.instance.formFieldControl = this.formFieldControl;
        componentRef.changeDetectorRef.detectChanges();
        this._viewContainerRef.element.nativeElement.parentElement?.classList.remove('hidden');
        this._componentRef = componentRef;
        return componentRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DynamicCompLoaderDirective, deps: [{ token: i0.ViewContainerRef }, { token: i2.FormGroupDirective }, { token: i0.ComponentFactoryResolver }, { token: i2.FormBuilder }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: DynamicCompLoaderDirective, selector: "[fswDynamicCompHost]", inputs: { formFieldControl: "formFieldControl" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DynamicCompLoaderDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswDynamicCompHost]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }, { type: i2.FormGroupDirective }, { type: i0.ComponentFactoryResolver }, { type: i2.FormBuilder }]; }, propDecorators: { formFieldControl: [{
                type: Input
            }] } });

class FormWidgetComponent extends FormMixin {
    constructor(fb, cdr) {
        super(fb);
        this.fb = fb;
        this.cdr = cdr;
        this.formConfig = null;
        this.loading = false;
        this.isReadonly = false;
        this.initializeWidget = new EventEmitter();
        this.closeForm = new EventEmitter();
        this.submitForm = new EventEmitter();
    }
    ngOnChanges(changes) {
        const { formConfig, loading } = changes;
        if (formConfig?.currentValue || loading?.currentValue != null) {
            this.panelColumn = this.formConfig?.formFieldConfig?.column || 6;
            this.initializeWidget.emit(this.initWidget(this.loading));
            this.formFieldControls$.next([...this.formFieldControls]);
        }
        if (this.isReadonly) {
            this.setAllControlsReadOnly();
            this.markForCheck();
        }
    }
    markForCheck() {
        this.cdr.markForCheck();
    }
    detectChanges() {
        this.cdr.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormWidgetComponent, deps: [{ token: i2.FormBuilder }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FormWidgetComponent, selector: "fsw-form-widget", inputs: { formConfig: "formConfig", loading: "loading", isReadonly: "isReadonly" }, outputs: { initializeWidget: "initializeWidget", closeForm: "closeForm", submitForm: "submitForm" }, usesInheritance: true, usesOnChanges: true, ngImport: i0, template: `
    <ng-container *ngIf="formFieldControls$ | async as controls">
      <form [formGroup]="formGroup" *ngIf="controls?.length">
        <div class="fsw-panel--form">
          <ng-container *ngFor="let formFieldControl of controls">
            <div
              [class]="
                'col col--' +
                (formFieldControl.numberOfColumns
                  ? formFieldControl.numberOfColumns
                  : panelColumn) +
                '/12-medium'
              "
            >
              <ng-container fswDynamicCompHost [formFieldControl]="formFieldControl"></ng-container>
            </div>
          </ng-container>
          <ng-content></ng-content>
        </div>
        <div class="text-right" *ngIf="!formConfig?.formFieldConfig?.hideAllCTAs">
          <button class="btn btn--secondary" (click)="closeForm.emit(formGroup)">
            {{ formConfig?.formFieldConfig?.secondaryBtnLabel || 'Close' }}
          </button>
          <button class="btn btn--primary" (click)="submitForm.emit(formGroup)">
            {{ formConfig?.formFieldConfig?.primaryBtnLabel || 'Save Changes' }}
          </button>
        </div>
      </form>
    </ng-container>
  `, isInline: true, styles: [".fsw-panel{margin-bottom:32px;border:1px solid #cccccc;border-radius:2px;padding:24px 16px}.fsw-panel--form{display:flex;flex-wrap:wrap;overflow-y:auto}.fsw-panel--form>div.col{padding:0 12px 0 0}.fsw-panel--form .form-label{color:#757575}.fsw-panel .col{margin:0;padding:0 12px 0 0}.fsw-panel:after{content:\" \";display:table;clear:both}.fsw-panel--50{width:50%}.fsw-panel--header{display:block;font-size:20px;font-weight:500;line-height:1.5;color:#222;margin-bottom:24px}.fsw-panel--content{display:block}.fsw-panel--content+.fsw-panel--header,.fsw-panel--content+.fsw-panel--content{border-top:1px solid #cccccc;margin-top:24px;padding-top:24px}.fsw-panel--item{margin-top:8px;margin-bottom:8px}.fsw-panel--highlight{display:block;background-color:#f3f5fd;padding:16px 24px;border-radius:2px}.fsw-panel--highlight .fsw-panel--header{font-size:20px;color:#222}.hidden{display:none}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: DynamicCompLoaderDirective, selector: "[fswDynamicCompHost]", inputs: ["formFieldControl"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormWidgetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-form-widget', template: `
    <ng-container *ngIf="formFieldControls$ | async as controls">
      <form [formGroup]="formGroup" *ngIf="controls?.length">
        <div class="fsw-panel--form">
          <ng-container *ngFor="let formFieldControl of controls">
            <div
              [class]="
                'col col--' +
                (formFieldControl.numberOfColumns
                  ? formFieldControl.numberOfColumns
                  : panelColumn) +
                '/12-medium'
              "
            >
              <ng-container fswDynamicCompHost [formFieldControl]="formFieldControl"></ng-container>
            </div>
          </ng-container>
          <ng-content></ng-content>
        </div>
        <div class="text-right" *ngIf="!formConfig?.formFieldConfig?.hideAllCTAs">
          <button class="btn btn--secondary" (click)="closeForm.emit(formGroup)">
            {{ formConfig?.formFieldConfig?.secondaryBtnLabel || 'Close' }}
          </button>
          <button class="btn btn--primary" (click)="submitForm.emit(formGroup)">
            {{ formConfig?.formFieldConfig?.primaryBtnLabel || 'Save Changes' }}
          </button>
        </div>
      </form>
    </ng-container>
  `, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, styles: [".fsw-panel{margin-bottom:32px;border:1px solid #cccccc;border-radius:2px;padding:24px 16px}.fsw-panel--form{display:flex;flex-wrap:wrap;overflow-y:auto}.fsw-panel--form>div.col{padding:0 12px 0 0}.fsw-panel--form .form-label{color:#757575}.fsw-panel .col{margin:0;padding:0 12px 0 0}.fsw-panel:after{content:\" \";display:table;clear:both}.fsw-panel--50{width:50%}.fsw-panel--header{display:block;font-size:20px;font-weight:500;line-height:1.5;color:#222;margin-bottom:24px}.fsw-panel--content{display:block}.fsw-panel--content+.fsw-panel--header,.fsw-panel--content+.fsw-panel--content{border-top:1px solid #cccccc;margin-top:24px;padding-top:24px}.fsw-panel--item{margin-top:8px;margin-bottom:8px}.fsw-panel--highlight{display:block;background-color:#f3f5fd;padding:16px 24px;border-radius:2px}.fsw-panel--highlight .fsw-panel--header{font-size:20px;color:#222}.hidden{display:none}\n"] }]
        }], ctorParameters: function () { return [{ type: i2.FormBuilder }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { formConfig: [{
                type: Input
            }], loading: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], initializeWidget: [{
                type: Output
            }], closeForm: [{
                type: Output
            }], submitForm: [{
                type: Output
            }] } });

class DynamicCompLoaderModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DynamicCompLoaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DynamicCompLoaderModule, declarations: [DynamicCompLoaderDirective], imports: [CommonModule, ReactiveFormsModule], exports: [DynamicCompLoaderDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DynamicCompLoaderModule, imports: [CommonModule, ReactiveFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DynamicCompLoaderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, ReactiveFormsModule],
                    declarations: [DynamicCompLoaderDirective],
                    exports: [DynamicCompLoaderDirective],
                }]
        }] });

class FormWidgetModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormWidgetModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FormWidgetModule, declarations: [FormWidgetComponent], imports: [CommonModule, ReactiveFormsModule, DynamicCompLoaderModule, ControlsWidgetModule], exports: [FormWidgetComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormWidgetModule, imports: [CommonModule, ReactiveFormsModule, DynamicCompLoaderModule, ControlsWidgetModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormWidgetModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FormWidgetComponent],
                    imports: [CommonModule, ReactiveFormsModule, DynamicCompLoaderModule, ControlsWidgetModule],
                    exports: [FormWidgetComponent],
                }]
        }] });

class PanelWidgetComponent {
    ngOnChanges(changes) {
        const { panelConfig } = changes;
        if (panelConfig && panelConfig.previousValue !== panelConfig.currentValue)
            this.panelConfig = panelConfig.currentValue;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PanelWidgetComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PanelWidgetComponent, selector: "fsw-panel-widget", inputs: { panelConfig: "panelConfig" }, usesOnChanges: true, ngImport: i0, template: `
		<div class="fsw-panel">
			<div>
				<div class="fsw-panel--header" *ngIf="panelConfig?.headerLabel">
					{{ panelConfig.headerLabel }}
				</div>
				<ng-content></ng-content>
			</div>
		</div>
	`, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PanelWidgetComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-panel-widget',
                    template: `
		<div class="fsw-panel">
			<div>
				<div class="fsw-panel--header" *ngIf="panelConfig?.headerLabel">
					{{ panelConfig.headerLabel }}
				</div>
				<ng-content></ng-content>
			</div>
		</div>
	`,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { panelConfig: [{
                type: Input
            }] } });

class PanelWidgetModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PanelWidgetModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: PanelWidgetModule, declarations: [PanelWidgetComponent], imports: [CommonModule, ReactiveFormsModule, DynamicCompLoaderModule, ControlsWidgetModule], exports: [PanelWidgetComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PanelWidgetModule, imports: [CommonModule, ReactiveFormsModule, DynamicCompLoaderModule, ControlsWidgetModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PanelWidgetModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [PanelWidgetComponent],
                    imports: [CommonModule, ReactiveFormsModule, DynamicCompLoaderModule, ControlsWidgetModule],
                    exports: [PanelWidgetComponent],
                }]
        }] });

class FSWSaveDialogComponent {
    constructor() {
        this.remove = new EventEmitter();
        this.cancel = new EventEmitter();
        this.save = new EventEmitter();
        this.listen = new EventEmitter();
        this.methodChange = new EventEmitter();
        this.method = Methods.GET;
        this.config = null;
        this.buttonDeleteLabel = '';
        this.buttonCancelLabel = '';
        this.buttonBackLabel = '';
        this.buttonEditLabel = '';
        this.buttonSaveLabel = '';
        this.isReadonly = false;
        this.Methods = Methods;
    }
    get showDeleteButton() {
        return this.method === Methods.PUT || this.method === Methods.GET;
    }
    turnOnEditMode() {
        this.method = Methods.PUT;
        this.methodChange.emit(this.method);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSaveDialogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWSaveDialogComponent, selector: "fsw-save-dialog", inputs: { method: "method", config: "config", buttonDeleteLabel: "buttonDeleteLabel", buttonCancelLabel: "buttonCancelLabel", buttonBackLabel: "buttonBackLabel", buttonEditLabel: "buttonEditLabel", buttonSaveLabel: "buttonSaveLabel", isReadonly: "isReadonly" }, outputs: { remove: "remove", cancel: "cancel", save: "save", listen: "listen", methodChange: "methodChange" }, ngImport: i0, template: "<div class=\"save-dialog\">\n\t<div class=\"save-dialog__body\">\n\t\t<fsw-panel-widget *ngIf=\"config\">\n\t\t\t<fsw-form-widget\n\t\t\t\t[formConfig]=\"config\"\n\t\t\t\t[isReadonly]=\"isReadonly\"\n\t\t\t\t(initializeWidget)=\"listen.emit($event)\"\n\t\t\t></fsw-form-widget>\n\t\t</fsw-panel-widget>\n\t</div>\n\t<div class=\"save-dialog__footer\">\n\t\t<div class=\"save-dialog__remove\">\n\t\t\t<button\n\t\t\t\t*ngIf=\"showDeleteButton && buttonDeleteLabel !== ''\"\n\t\t\t\t(click)=\"remove.emit()\"\n\t\t\t\tclass=\"btn btn--secondary\"\n\t\t\t>\n\t\t\t\t{{ buttonDeleteLabel }}\n\t\t\t</button>\n\t\t</div>\n\t\t<div class=\"save-dialog__buttons\">\n\t\t\t<ng-container *ngIf=\"isReadonly; else notReadonly\">\n\t\t\t\t<button class=\"btn btn--secondary\" (click)=\"cancel.emit()\">{{ buttonBackLabel }}</button>\n\t\t\t</ng-container>\n\t\t\t<ng-template #notReadonly>\n\t\t\t\t<ng-container *ngIf=\"method === Methods.GET; else defaultButtons\">\n\t\t\t\t\t<button class=\"btn btn--secondary\" (click)=\"cancel.emit()\">{{ buttonBackLabel }}</button>\n\t\t\t\t\t<button class=\"btn btn--primary\" (click)=\"turnOnEditMode()\">\n\t\t\t\t\t\t{{ buttonEditLabel }}\n\t\t\t\t\t</button>\n\t\t\t\t</ng-container>\n\t\t\t\t<ng-template #defaultButtons>\n\t\t\t\t\t<button class=\"btn btn--secondary\" (click)=\"cancel.emit()\">\n\t\t\t\t\t\t{{ buttonCancelLabel }}\n\t\t\t\t\t</button>\n\t\t\t\t\t<button class=\"btn btn--primary\" (click)=\"save.emit()\">\n\t\t\t\t\t\t{{ buttonSaveLabel }}\n\t\t\t\t\t</button>\n\t\t\t\t</ng-template>\n\t\t\t</ng-template>\n\t\t</div>\n\t</div>\n</div>\n", styles: [":host .save-dialog{width:100%}:host .save-dialog__body{width:100%;padding:24px 32px;max-height:500px;overflow-y:scroll}:host .save-dialog__body ::ng-deep fsw-panel-widget>.fsw-panel{margin-bottom:0;border:0;padding:0}:host .save-dialog__remove>button{color:#cc1830}:host .save-dialog__footer{width:100%;height:72px;display:flex;align-items:center;justify-content:space-between;gap:16px;padding:0 32px}:host .save-dialog__buttons{display:flex;gap:16px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: PanelWidgetComponent, selector: "fsw-panel-widget", inputs: ["panelConfig"] }, { kind: "component", type: FormWidgetComponent, selector: "fsw-form-widget", inputs: ["formConfig", "loading", "isReadonly"], outputs: ["initializeWidget", "closeForm", "submitForm"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSaveDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-save-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"save-dialog\">\n\t<div class=\"save-dialog__body\">\n\t\t<fsw-panel-widget *ngIf=\"config\">\n\t\t\t<fsw-form-widget\n\t\t\t\t[formConfig]=\"config\"\n\t\t\t\t[isReadonly]=\"isReadonly\"\n\t\t\t\t(initializeWidget)=\"listen.emit($event)\"\n\t\t\t></fsw-form-widget>\n\t\t</fsw-panel-widget>\n\t</div>\n\t<div class=\"save-dialog__footer\">\n\t\t<div class=\"save-dialog__remove\">\n\t\t\t<button\n\t\t\t\t*ngIf=\"showDeleteButton && buttonDeleteLabel !== ''\"\n\t\t\t\t(click)=\"remove.emit()\"\n\t\t\t\tclass=\"btn btn--secondary\"\n\t\t\t>\n\t\t\t\t{{ buttonDeleteLabel }}\n\t\t\t</button>\n\t\t</div>\n\t\t<div class=\"save-dialog__buttons\">\n\t\t\t<ng-container *ngIf=\"isReadonly; else notReadonly\">\n\t\t\t\t<button class=\"btn btn--secondary\" (click)=\"cancel.emit()\">{{ buttonBackLabel }}</button>\n\t\t\t</ng-container>\n\t\t\t<ng-template #notReadonly>\n\t\t\t\t<ng-container *ngIf=\"method === Methods.GET; else defaultButtons\">\n\t\t\t\t\t<button class=\"btn btn--secondary\" (click)=\"cancel.emit()\">{{ buttonBackLabel }}</button>\n\t\t\t\t\t<button class=\"btn btn--primary\" (click)=\"turnOnEditMode()\">\n\t\t\t\t\t\t{{ buttonEditLabel }}\n\t\t\t\t\t</button>\n\t\t\t\t</ng-container>\n\t\t\t\t<ng-template #defaultButtons>\n\t\t\t\t\t<button class=\"btn btn--secondary\" (click)=\"cancel.emit()\">\n\t\t\t\t\t\t{{ buttonCancelLabel }}\n\t\t\t\t\t</button>\n\t\t\t\t\t<button class=\"btn btn--primary\" (click)=\"save.emit()\">\n\t\t\t\t\t\t{{ buttonSaveLabel }}\n\t\t\t\t\t</button>\n\t\t\t\t</ng-template>\n\t\t\t</ng-template>\n\t\t</div>\n\t</div>\n</div>\n", styles: [":host .save-dialog{width:100%}:host .save-dialog__body{width:100%;padding:24px 32px;max-height:500px;overflow-y:scroll}:host .save-dialog__body ::ng-deep fsw-panel-widget>.fsw-panel{margin-bottom:0;border:0;padding:0}:host .save-dialog__remove>button{color:#cc1830}:host .save-dialog__footer{width:100%;height:72px;display:flex;align-items:center;justify-content:space-between;gap:16px;padding:0 32px}:host .save-dialog__buttons{display:flex;gap:16px}\n"] }]
        }], propDecorators: { remove: [{
                type: Output
            }], cancel: [{
                type: Output
            }], save: [{
                type: Output
            }], listen: [{
                type: Output
            }], methodChange: [{
                type: Output
            }], method: [{
                type: Input
            }], config: [{
                type: Input
            }], buttonDeleteLabel: [{
                type: Input
            }], buttonCancelLabel: [{
                type: Input
            }], buttonBackLabel: [{
                type: Input
            }], buttonEditLabel: [{
                type: Input
            }], buttonSaveLabel: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class FSWSaveDialogModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSaveDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWSaveDialogModule, declarations: [FSWSaveDialogComponent], imports: [CommonModule, PanelWidgetModule, FormWidgetModule], exports: [FSWSaveDialogComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSaveDialogModule, imports: [CommonModule, PanelWidgetModule, FormWidgetModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSaveDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, PanelWidgetModule, FormWidgetModule],
                    declarations: [FSWSaveDialogComponent],
                    exports: [FSWSaveDialogComponent],
                }]
        }] });

class DynamicTabsComponent {
    constructor(_injector) {
        this._injector = _injector;
        this.tabContentClass = null;
        this._destroySubject = new Subject();
    }
    ngOnDestroy() {
        this._destroySubject.next();
        this._destroySubject.complete();
    }
    selectTab({ tabInfo, compInfo }) {
        this.tabConfigs.forEach(({ tabInfo }) => (tabInfo.isTabActive = false));
        tabInfo.isTabActive = true;
        this.tabContent.clear();
        let customProviders = [];
        if (compInfo.getComponentProviders) {
            customProviders = compInfo.getComponentProviders();
        }
        const providers = [...customProviders];
        const injector = Injector.create({ providers, parent: this._injector });
        const componentRef = this.tabContent.createComponent(compInfo.component, {
            injector,
        });
        if (compInfo.componentInputs) {
            for (const key in compInfo.componentInputs) {
                if (Object.prototype.hasOwnProperty.call(compInfo.componentInputs, key)) {
                    const value = compInfo.componentInputs[key];
                    componentRef.instance[key] = value;
                }
            }
        }
        componentRef.changeDetectorRef.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DynamicTabsComponent, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DynamicTabsComponent, selector: "fsw-dynamic-tabs", inputs: { tabConfigs: "tabConfigs", tabContentClass: "tabContentClass" }, viewQueries: [{ propertyName: "tabContent", first: true, predicate: ["tabContent"], descendants: true, read: ViewContainerRef, static: true }], ngImport: i0, template: `
    <fsw-tabs-group [customRowGap]="'24px'" [customColumnGap]="'24px'">
      <ng-container *ngFor="let tab of tabConfigs">
        <ng-template
          fswTabs
          [size]="'s'"
          [key]="tab.tabInfo.tabName"
          [maxTextWidth]="'unset'"
          [label]="tab.tabInfo.tabName"
          [icon]="!tab?.compInfo?.componentInputs?.isReadonly ? 'common-edit' : ''"
          (selectTab)="selectTab(tab)"
        >
        </ng-template>
      </ng-container>
    </fsw-tabs-group>
    <div [class]="tabContentClass">
      <ng-container #tabContent></ng-container>
    </div>
  `, isInline: true, styles: [".error__message{color:#cc1830;font-size:14px}:host .cbs-form{display:flex;flex-direction:column;gap:16px;width:100%}:host .cbs-form__tabs{width:100%;gap:4px;display:flex}:host .cbs-form__tab{border-radius:2px;padding:12px 16px}:host .cbs-form__tab span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-weight:500;font-size:14px;line-height:24px;color:#4a4a4a}:host .cbs-form__tab:hover{cursor:pointer}:host .cbs-form__tab:hover span{padding:12px 0;color:#2c50ff;border-bottom:1px solid #2c50ff}:host .cbs-form__tab.active span{padding:12px 0;color:#2c50ff;border-bottom:1px solid #2c50ff}:host .cbs-form__container{padding:16px;width:100%;display:flex;flex-direction:column;gap:16px;border-radius:4px;border:1px solid #e0e0e0}:host .cbs-form__container header{display:flex;width:100%;justify-content:space-between;align-items:center}:host .cbs-form__container header :first-child{display:flex;flex-direction:column}:host .cbs-form__container header :first-child h6{color:#222}:host .cbs-form__container header :first-child span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-weight:400;line-height:1.5;font-size:12px;color:#757575}:host .cbs-form__container header :last-child{display:flex;align-items:center;gap:16px}:host .cbs-form__container main{width:100%}:host .cbs-form__container footer{width:100%;display:flex;flex-direction:row-reverse;gap:16px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i1$4.FSWTabsGroupComponent, selector: "fsw-tabs-group" }, { kind: "directive", type: i1$4.FSWTabsDirective, selector: "ng-template[fswTabs]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DynamicTabsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-dynamic-tabs', template: `
    <fsw-tabs-group [customRowGap]="'24px'" [customColumnGap]="'24px'">
      <ng-container *ngFor="let tab of tabConfigs">
        <ng-template
          fswTabs
          [size]="'s'"
          [key]="tab.tabInfo.tabName"
          [maxTextWidth]="'unset'"
          [label]="tab.tabInfo.tabName"
          [icon]="!tab?.compInfo?.componentInputs?.isReadonly ? 'common-edit' : ''"
          (selectTab)="selectTab(tab)"
        >
        </ng-template>
      </ng-container>
    </fsw-tabs-group>
    <div [class]="tabContentClass">
      <ng-container #tabContent></ng-container>
    </div>
  `, styles: [".error__message{color:#cc1830;font-size:14px}:host .cbs-form{display:flex;flex-direction:column;gap:16px;width:100%}:host .cbs-form__tabs{width:100%;gap:4px;display:flex}:host .cbs-form__tab{border-radius:2px;padding:12px 16px}:host .cbs-form__tab span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-weight:500;font-size:14px;line-height:24px;color:#4a4a4a}:host .cbs-form__tab:hover{cursor:pointer}:host .cbs-form__tab:hover span{padding:12px 0;color:#2c50ff;border-bottom:1px solid #2c50ff}:host .cbs-form__tab.active span{padding:12px 0;color:#2c50ff;border-bottom:1px solid #2c50ff}:host .cbs-form__container{padding:16px;width:100%;display:flex;flex-direction:column;gap:16px;border-radius:4px;border:1px solid #e0e0e0}:host .cbs-form__container header{display:flex;width:100%;justify-content:space-between;align-items:center}:host .cbs-form__container header :first-child{display:flex;flex-direction:column}:host .cbs-form__container header :first-child h6{color:#222}:host .cbs-form__container header :first-child span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-weight:400;line-height:1.5;font-size:12px;color:#757575}:host .cbs-form__container header :last-child{display:flex;align-items:center;gap:16px}:host .cbs-form__container main{width:100%}:host .cbs-form__container footer{width:100%;display:flex;flex-direction:row-reverse;gap:16px}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Injector }]; }, propDecorators: { tabConfigs: [{
                type: Input
            }], tabContentClass: [{
                type: Input
            }], tabContent: [{
                type: ViewChild,
                args: ['tabContent', { read: ViewContainerRef, static: true }]
            }] } });

class DynamicTabsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DynamicTabsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DynamicTabsModule, declarations: [DynamicTabsComponent], imports: [CommonModule, FSWTabsModule], exports: [DynamicTabsComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DynamicTabsModule, imports: [CommonModule, FSWTabsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DynamicTabsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FSWTabsModule],
                    declarations: [DynamicTabsComponent],
                    exports: [DynamicTabsComponent],
                }]
        }] });

class ActionIconsCellComponent {
    agInit(params) {
        this.params = params;
    }
    refresh(params) {
        this.params = params;
        return true;
    }
    onUploadStatement() {
        this.params.context.componentParent.onActionUploadStatement(this.params);
    }
    onViewStatement() {
        this.params.context.componentParent.onActionIconView(this.params);
    }
    onEditStatement() {
        if (this.params.data.disableEditStatementIcon)
            return;
        this.params.context.componentParent.onActionIconEdit(this.params);
    }
    onLinkStatement() {
        this.params.context.componentParent.onActionIconLink(this.params);
    }
    onUnlinkStatement() {
        this.params.context.componentParent.onActionIconUnlink(this.params);
    }
    onUnlinkAllStatements() {
        this.params.context.componentParent.onActionUnlinkAllStatements(this.params);
    }
    onDelete() {
        this.params.context.componentParent.onActionIconDelete(this.params);
    }
    // onDeleteBank(): void {
    //   this.params.context.componentParent.onActionDeleteBank(this.params);
    // }
    onDownloadIcon() {
        this.params.context.componentParent.onActionIconDownload(this.params);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ActionIconsCellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ActionIconsCellComponent, isStandalone: true, selector: "ng-component", ngImport: i0, template: `
    <div class="action-icons">
      <div *ngIf="params.showAddStatementIcon">
        <span><i (click)="onUploadStatement()" class="fa fa-plus"></i></span>
      </div>
      <div *ngIf="params.showUnlinkAllStatementsIcon">
        <span (click)="onUnlinkAllStatements()"><i class="fa fa-unlink"></i></span>
      </div>
      <div *ngIf="params.showDeleteIcon" class="primary">
        <span (click)="onDelete()"><i class="fa fa-trash"></i></span>
      </div>
      <div *ngIf="params.showExternalLinkIcon">
        <span (click)="onViewStatement()"><i class="fa fa-external-link-alt"></i></span>
      </div>
      <div
        *ngIf="params.showEditStatementIcon"
        [ngClass]="{ 'is-disabled': params.data['disableEditStatementIcon'] }"
      >
        <span (click)="onEditStatement()"><i class="fa fa-pen"></i></span>
      </div>
      <div *ngIf="params.showLinkStatementIcon">
        <span (click)="onLinkStatement()"><i class="fa fa-link"></i></span>
      </div>
      <div *ngIf="params.showUnlinkStatementIcon">
        <span (click)="onUnlinkStatement()"><i class="fa fa-unlink"></i></span>
      </div>
      <div *ngIf="params.showDownloadIcon">
        <span (click)="onDownloadIcon()"><i class="fa fa-download"></i></span>
      </div>
    </div>
  `, isInline: true, styles: [".action-icons{display:flex;color:#757575}.action-icons div{margin-right:15px;cursor:pointer}.is-disabled{opacity:.5;cursor:not-allowed}div.is-disabled pantry-icon:hover{cursor:not-allowed}div.primary pantry-icon{color:#2c50ff;vertical-align:text-bottom}\n"], dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ActionIconsCellComponent, decorators: [{
            type: Component,
            args: [{ template: `
    <div class="action-icons">
      <div *ngIf="params.showAddStatementIcon">
        <span><i (click)="onUploadStatement()" class="fa fa-plus"></i></span>
      </div>
      <div *ngIf="params.showUnlinkAllStatementsIcon">
        <span (click)="onUnlinkAllStatements()"><i class="fa fa-unlink"></i></span>
      </div>
      <div *ngIf="params.showDeleteIcon" class="primary">
        <span (click)="onDelete()"><i class="fa fa-trash"></i></span>
      </div>
      <div *ngIf="params.showExternalLinkIcon">
        <span (click)="onViewStatement()"><i class="fa fa-external-link-alt"></i></span>
      </div>
      <div
        *ngIf="params.showEditStatementIcon"
        [ngClass]="{ 'is-disabled': params.data['disableEditStatementIcon'] }"
      >
        <span (click)="onEditStatement()"><i class="fa fa-pen"></i></span>
      </div>
      <div *ngIf="params.showLinkStatementIcon">
        <span (click)="onLinkStatement()"><i class="fa fa-link"></i></span>
      </div>
      <div *ngIf="params.showUnlinkStatementIcon">
        <span (click)="onUnlinkStatement()"><i class="fa fa-unlink"></i></span>
      </div>
      <div *ngIf="params.showDownloadIcon">
        <span (click)="onDownloadIcon()"><i class="fa fa-download"></i></span>
      </div>
    </div>
  `, standalone: true, imports: [NgIf, NgClass], styles: [".action-icons{display:flex;color:#757575}.action-icons div{margin-right:15px;cursor:pointer}.is-disabled{opacity:.5;cursor:not-allowed}div.is-disabled pantry-icon:hover{cursor:not-allowed}div.primary pantry-icon{color:#2c50ff;vertical-align:text-bottom}\n"] }]
        }] });

class FSWGridActionMethodsCellComponent {
    constructor() {
        this.params = {};
    }
    agInit(params) {
        this.params = params;
    }
    refresh(params) {
        this.params = params;
        return true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWGridActionMethodsCellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWGridActionMethodsCellComponent, isStandalone: true, selector: "fsw-action-methods-cell", ngImport: i0, template: `
    <div class="action-methods-cell">
      <i *ngIf="params.onEdit" class="fa fa-pen" (click)="params?.onEdit(params)"></i>
      <i *ngIf="params.onDelete" class="fa fa-trash" (click)="params?.onDelete(params)"></i>
    </div>
  `, isInline: true, styles: [":host .action-methods-cell{display:flex;align-items:center;gap:24px}:host .action-methods-cell i{cursor:pointer}:host .action-methods-cell i:hover{color:#2c50ff}\n"], dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWGridActionMethodsCellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-action-methods-cell', template: `
    <div class="action-methods-cell">
      <i *ngIf="params.onEdit" class="fa fa-pen" (click)="params?.onEdit(params)"></i>
      <i *ngIf="params.onDelete" class="fa fa-trash" (click)="params?.onDelete(params)"></i>
    </div>
  `, standalone: true, imports: [NgIf], styles: [":host .action-methods-cell{display:flex;align-items:center;gap:24px}:host .action-methods-cell i{cursor:pointer}:host .action-methods-cell i:hover{color:#2c50ff}\n"] }]
        }] });

class AffiliateBorrowerReportCellComponent {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    agInit(params) {
        this.params = params;
    }
    refresh(params) {
        this.params = params;
        return true;
    }
    onRepull() {
        this.params.context.componentParent.onActionRepullReport(this.params);
    }
    onView() {
        this.params.context.componentParent.onActionViewReport(this.params);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AffiliateBorrowerReportCellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AffiliateBorrowerReportCellComponent, isStandalone: true, selector: "ng-component", ngImport: i0, template: `
    <div *ngIf="params?.showSIK || params?.showPefindo" class="affBorrowerReport">
      <span class="sik-perindo-btns mr-4" (click)="onRepull()">
        <span><i class="fa fa-external-link-alt"></i></span> Repull
      </span>
      <span class="sik-perindo-btns" (click)="onView()">
        <span><i class="fa fa-eye"></i></span> View
      </span>
      <div></div>
    </div>
  `, isInline: true, styles: [".affBorrowerReport .sik-perindo-btns{padding:2px;cursor:pointer}.affBorrowerReport .sik-perindo-btns:hover{background:#f6f6f6}\n"], dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AffiliateBorrowerReportCellComponent, decorators: [{
            type: Component,
            args: [{ template: `
    <div *ngIf="params?.showSIK || params?.showPefindo" class="affBorrowerReport">
      <span class="sik-perindo-btns mr-4" (click)="onRepull()">
        <span><i class="fa fa-external-link-alt"></i></span> Repull
      </span>
      <span class="sik-perindo-btns" (click)="onView()">
        <span><i class="fa fa-eye"></i></span> View
      </span>
      <div></div>
    </div>
  `, standalone: true, imports: [NgIf], styles: [".affBorrowerReport .sik-perindo-btns{padding:2px;cursor:pointer}.affBorrowerReport .sik-perindo-btns:hover{background:#f6f6f6}\n"] }]
        }] });

class CurrencyCellComponent {
    constructor() {
        this.inputCtrl = new UntypedFormControl();
    }
    agInit(params) {
        this.params = params;
        const commaValue = new Intl.NumberFormat().format(params.data.amount);
        this.inputCtrl.setValue(commaValue);
        this.inputCtrl.disable();
    }
    refresh(params) {
        this.params = params;
        return true;
    }
    handleChange(event) {
        const val = event.target.value;
        this.inputCtrl.setValue(new Intl.NumberFormat().format(+val));
        // this.params.node.setDataValue('amount', +value)
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CurrencyCellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CurrencyCellComponent, isStandalone: true, selector: "ng-component", ngImport: i0, template: ` <input [formControl]="inputCtrl" (change)="handleChange($event)" />`, isInline: true, dependencies: [{ kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CurrencyCellComponent, decorators: [{
            type: Component,
            args: [{ template: ` <input [formControl]="inputCtrl" (change)="handleChange($event)" />`, standalone: true, imports: [ReactiveFormsModule] }]
        }] });

class CustomHeaderCellComponent {
    constructor() {
        this.descSort = 'inactive';
    }
    agInit(params) {
        this.params = params;
        if (this.params &&
            (this.params.displayName === 'Date' || this.params.displayName === 'Facility Name'))
            this.descSort = 'active';
    }
    onSortRequested(order) {
        const headerName = this.params && this.params.displayName;
        const sortUpList = document.querySelectorAll('div.custom-sort-up-label');
        const sortDownList = document.querySelectorAll('div.custom-sort-down-label');
        sortUpList &&
            sortUpList.forEach((item) => {
                const textContent = item &&
                    item.parentElement &&
                    item.parentElement.parentElement &&
                    item.parentElement.parentElement.textContent;
                if (item.classList.contains('active'))
                    item.classList.remove('active');
                if (order === 'ASC' && !item.classList.contains('active') && textContent === headerName)
                    item.classList.add('active');
            });
        sortDownList &&
            sortDownList.forEach((item) => {
                const textContent = item &&
                    item.parentElement &&
                    item.parentElement.parentElement &&
                    item.parentElement.parentElement.textContent;
                if (item.classList.contains('active'))
                    item.classList.remove('active');
                if (order === 'DESC' && !item.classList.contains('active') && textContent === headerName)
                    item.classList.add('active');
            });
        this.params.context.componentParent.onSortChanged(this.params && this.params.column && this.params.column.getColId(), order);
    }
    refresh(params) {
        this.params = params;
        return false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CustomHeaderCellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CustomHeaderCellComponent, isStandalone: true, selector: "ng-component", ngImport: i0, template: `
    <div class="header-container">
      <div class="custom-header-label">{{ params.displayName }}</div>
      <div class="label-container" *ngIf="params.displayName && params.enableSorting">
        <div (click)="onSortRequested('ASC')" class="custom-sort-up-label">
          <i class="fa fa-long-arrow-alt-up"></i>
        </div>

        <div (click)="onSortRequested('DESC')" [ngClass]="descSort" class="custom-sort-down-label">
          <i class="fa fa-long-arrow-alt-down"></i>
        </div>
      </div>
    </div>
  `, isInline: true, styles: [".header-container{display:flex;align-items:center}.label-container{margin-left:2px}.custom-header-label,.custom-sort-down-label,.custom-sort-up-label{float:left;color:#757575;font-weight:500;transition:all .3s ease-in-out}.custom-sort-up-label,.custom-sort-down-label{margin-left:3px;opacity:0}.custom-sort-down-label{margin-top:1px}.label-container:hover .custom-sort-up-label,.label-container:hover .custom-sort-down-label{opacity:1}.active{color:#2c50ff;opacity:1}\n"], dependencies: [{ kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CustomHeaderCellComponent, decorators: [{
            type: Component,
            args: [{ template: `
    <div class="header-container">
      <div class="custom-header-label">{{ params.displayName }}</div>
      <div class="label-container" *ngIf="params.displayName && params.enableSorting">
        <div (click)="onSortRequested('ASC')" class="custom-sort-up-label">
          <i class="fa fa-long-arrow-alt-up"></i>
        </div>

        <div (click)="onSortRequested('DESC')" [ngClass]="descSort" class="custom-sort-down-label">
          <i class="fa fa-long-arrow-alt-down"></i>
        </div>
      </div>
    </div>
  `, standalone: true, imports: [NgClass, NgIf], styles: [".header-container{display:flex;align-items:center}.label-container{margin-left:2px}.custom-header-label,.custom-sort-down-label,.custom-sort-up-label{float:left;color:#757575;font-weight:500;transition:all .3s ease-in-out}.custom-sort-up-label,.custom-sort-down-label{margin-left:3px;opacity:0}.custom-sort-down-label{margin-top:1px}.label-container:hover .custom-sort-up-label,.label-container:hover .custom-sort-down-label{opacity:1}.active{color:#2c50ff;opacity:1}\n"] }]
        }] });

class CustomNoRowsOverlayComponent {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    agInit(params) {
        this.params = params;
    }
    refresh(params) {
        this.params = params;
        return true;
    }
    onBtnClick() {
        this.params.context.componentParent.onNoRowBtnClicked(this.params);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CustomNoRowsOverlayComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CustomNoRowsOverlayComponent, isStandalone: true, selector: "ng-component", ngImport: i0, template: `
    <div style="pointer-events: auto;">
      <div class="mt-6 mb-4">
        {{ params.noRowMsg }}
      </div>
      <span class="wf-link" (click)="onBtnClick()" *ngIf="params?.isNoRowBtn">
        {{ params.noRowBtnLabel }}
      </span>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CustomNoRowsOverlayComponent, decorators: [{
            type: Component,
            args: [{
                    template: `
    <div style="pointer-events: auto;">
      <div class="mt-6 mb-4">
        {{ params.noRowMsg }}
      </div>
      <span class="wf-link" (click)="onBtnClick()" *ngIf="params?.isNoRowBtn">
        {{ params.noRowBtnLabel }}
      </span>
    </div>
  `,
                    standalone: true,
                    imports: [NgIf],
                }]
        }] });

class CustomPinnedRowComponent {
    constructor() {
        this.selectCtrl = new UntypedFormControl();
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    agInit(params) {
        this.params = params;
    }
    refresh() {
        return false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CustomPinnedRowComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CustomPinnedRowComponent, isStandalone: true, selector: "ng-component", ngImport: i0, template: `
    <div class="input-group input-type-text is-disabled">
      <input type="text" class="form-input" [value]="selectCtrl.value" disabled="true" />
    </div>
  `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CustomPinnedRowComponent, decorators: [{
            type: Component,
            args: [{
                    template: `
    <div class="input-group input-type-text is-disabled">
      <input type="text" class="form-input" [value]="selectCtrl.value" disabled="true" />
    </div>
  `,
                    standalone: true,
                }]
        }] });

class CustomTooltipComponent {
    agInit(params) {
        this.params = params;
        this.color = this.params.color || '#4A4A4A';
    }
    getGui() {
        return this.eGui;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CustomTooltipComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CustomTooltipComponent, isStandalone: true, selector: "ng-component", ngImport: i0, template: `
    <div class="custom-tooltip" [style.background-color]="color">
      <p>{{ params.value }}</p>
    </div>
  `, isInline: true, styles: [".custom-tooltip{overflow:hidden;padding:4px}.custom-tooltip p{margin:5px;white-space:nowrap;font-size:12px;color:#fff}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CustomTooltipComponent, decorators: [{
            type: Component,
            args: [{ template: `
    <div class="custom-tooltip" [style.background-color]="color">
      <p>{{ params.value }}</p>
    </div>
  `, standalone: true, styles: [".custom-tooltip{overflow:hidden;padding:4px}.custom-tooltip p{margin:5px;white-space:nowrap;font-size:12px;color:#fff}\n"] }]
        }] });

class FileCellComponent {
    agInit(params) {
        this.params = params;
    }
    refresh(params) {
        this.params = params;
        return true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FileCellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FileCellComponent, isStandalone: true, selector: "ng-component", ngImport: i0, template: `
    <div *ngIf="params?.data?.fileName || params?.data?.file_name" class="file-container">
      <span>{{ params.data?.fileName || params.data?.file_name }}</span>
    </div>
  `, isInline: true, styles: [".file-container{padding:8px;background-color:#f3f5fd;color:#2c50ff;text-align:left;margin:2px 0;height:auto;display:flex;align-items:center;border-radius:2px}.file-container span{line-height:24px}.file-container span:hover{cursor:pointer}\n"], dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FileCellComponent, decorators: [{
            type: Component,
            args: [{ template: `
    <div *ngIf="params?.data?.fileName || params?.data?.file_name" class="file-container">
      <span>{{ params.data?.fileName || params.data?.file_name }}</span>
    </div>
  `, standalone: true, imports: [NgIf], styles: [".file-container{padding:8px;background-color:#f3f5fd;color:#2c50ff;text-align:left;margin:2px 0;height:auto;display:flex;align-items:center;border-radius:2px}.file-container span{line-height:24px}.file-container span:hover{cursor:pointer}\n"] }]
        }] });

class RadioCellComponent {
    agInit(params) {
        this.params = params;
    }
    refresh(params) {
        this.params = params;
        return true;
    }
    handleChange() {
        this.params.node.setSelected(!this.params.node.selected);
        this.params.context.componentParent.onRadioCellRendererChange(this.params);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RadioCellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: RadioCellComponent, isStandalone: true, selector: "ng-component", ngImport: i0, template: `
    <div class="radio-container">
      <input type="radio" [(checked)]="params.node.selected" (change)="handleChange()" />
    </div>
  `, isInline: true, styles: [".radio-container{display:flex;align-items:center}input[type=radio]{opacity:1}input[type=radio]:hover{cursor:pointer}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RadioCellComponent, decorators: [{
            type: Component,
            args: [{ template: `
    <div class="radio-container">
      <input type="radio" [(checked)]="params.node.selected" (change)="handleChange()" />
    </div>
  `, standalone: true, styles: [".radio-container{display:flex;align-items:center}input[type=radio]{opacity:1}input[type=radio]:hover{cursor:pointer}\n"] }]
        }] });

class ScreeningResultCellComponent {
    agInit(params) {
        this.params = params;
    }
    refresh(params) {
        this.params = params;
        return true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ScreeningResultCellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ScreeningResultCellComponent, isStandalone: true, selector: "ng-component", ngImport: i0, template: `
    <span
      class="ag-label"
      [ngClass]="{
        'ag-label--green': params.value === 'pass',
        'ag-label--yellow': params.value === 'fail'
      }"
    >
      {{ params.value }}
    </span>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ScreeningResultCellComponent, decorators: [{
            type: Component,
            args: [{
                    template: `
    <span
      class="ag-label"
      [ngClass]="{
        'ag-label--green': params.value === 'pass',
        'ag-label--yellow': params.value === 'fail'
      }"
    >
      {{ params.value }}
    </span>
  `,
                    standalone: true,
                    imports: [NgClass],
                }]
        }] });

class SelectCellComponent {
    constructor() {
        this.selectCtrl = new UntypedFormControl();
        this.disabled = false;
        this.placeHolder = 'Select';
    }
    agInit(params) {
        this.params = params;
        if (params?.data?.decision == '') {
            this.placeHolder = 'Decision';
        }
        else if (params?.data?.picklist_value == '') {
            this.placeHolder = 'Choose Picklist';
        }
        this.selectCtrl.setValue((params && params.data && params.data.picklist_value) ||
            (params && params.data && params.data.answer) ||
            (params && params.data && params.data.decision) ||
            ' ');
    }
    refresh(params) {
        this.params = params;
        params.api.redrawRows();
        return true;
    }
    handleChange(value) {
        this.params.context.componentParent.onSelectRendererChange(this.params, value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SelectCellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: SelectCellComponent, isStandalone: true, selector: "ng-component", ngImport: i0, template: `
    <div class="select-cell">
      <div
        *ngIf="!params?.data?.isReadonly"
        [class.form-select]="true"
        [class.form-select--disabled]="disabled"
      >
        <select
          #selectCell
          [formControl]="selectCtrl"
          (change)="handleChange(selectCell.value)"
          [ngClass]="{
            'error-border': params?.data?.picklist_value === ''
          }"
        >
          <option [value]="' '">{{ placeHolder }}</option>
          <option *ngFor="let option of params?.value" [value]="option?.key">
            {{ option?.value }}
          </option>
        </select>
      </div>
      <div *ngIf="params?.data?.isReadonly">
        <div
          *ngIf="params?.data?.answer"
          class="label"
          [ngClass]="{
            'ag-label--green': params.data.answer === 'yes',
            'ag-label--yellow': params.data.answer === 'no',
            'ag-label--gray': params.data.answer === 'na'
          }"
        >
          {{ params?.data?.answer }}
        </div>
      </div>
    </div>
  `, isInline: true, styles: [".select-cell{min-height:100px;display:flex;align-items:center;justify-content:flex-start}.error-border{border:1px solid #ff2945}\n"], dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i2.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i2.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SelectCellComponent, decorators: [{
            type: Component,
            args: [{ template: `
    <div class="select-cell">
      <div
        *ngIf="!params?.data?.isReadonly"
        [class.form-select]="true"
        [class.form-select--disabled]="disabled"
      >
        <select
          #selectCell
          [formControl]="selectCtrl"
          (change)="handleChange(selectCell.value)"
          [ngClass]="{
            'error-border': params?.data?.picklist_value === ''
          }"
        >
          <option [value]="' '">{{ placeHolder }}</option>
          <option *ngFor="let option of params?.value" [value]="option?.key">
            {{ option?.value }}
          </option>
        </select>
      </div>
      <div *ngIf="params?.data?.isReadonly">
        <div
          *ngIf="params?.data?.answer"
          class="label"
          [ngClass]="{
            'ag-label--green': params.data.answer === 'yes',
            'ag-label--yellow': params.data.answer === 'no',
            'ag-label--gray': params.data.answer === 'na'
          }"
        >
          {{ params?.data?.answer }}
        </div>
      </div>
    </div>
  `, standalone: true, imports: [NgIf, NgClass, ReactiveFormsModule], styles: [".select-cell{min-height:100px;display:flex;align-items:center;justify-content:flex-start}.error-border{border:1px solid #ff2945}\n"] }]
        }] });

class SimpleContainerCellComponent {
    constructor() {
        this.isParamsArray = false;
        this.isStringArray = false;
    }
    agInit(params) {
        this.params = params;
        this.isParamsArray = Array.isArray(params?.value);
        this.isStringArray =
            Array.isArray(params?.value) && params?.value.every((i) => typeof i === 'string');
    }
    refresh(params) {
        this.params = params;
        return true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SimpleContainerCellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: SimpleContainerCellComponent, isStandalone: true, selector: "ng-component", ngImport: i0, template: `
    <ng-container *ngIf="isStringArray">
      <div class="mb-2">{{ params?.data?.item }}</div>
      <ng-container *ngFor="let item of params?.value">
        <div class="hint">{{ item }}</div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="isParamsArray && !isStringArray">
      <ng-container *ngFor="let item of params?.value">
        <div>{{ item?.message }}</div>
        <div class="timestamp">{{ item?.time | date : 'MMMM d, y, h:mm:ss a z' }}</div>
        <div *ngIf="params?.value?.length > 1">&nbsp;</div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="!isParamsArray">
      <div class="timestamp">{{ params?.value | date : 'MMMM d, y, h:mm:ss a z' }}</div>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "pipe", type: DatePipe, name: "date" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SimpleContainerCellComponent, decorators: [{
            type: Component,
            args: [{
                    template: `
    <ng-container *ngIf="isStringArray">
      <div class="mb-2">{{ params?.data?.item }}</div>
      <ng-container *ngFor="let item of params?.value">
        <div class="hint">{{ item }}</div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="isParamsArray && !isStringArray">
      <ng-container *ngFor="let item of params?.value">
        <div>{{ item?.message }}</div>
        <div class="timestamp">{{ item?.time | date : 'MMMM d, y, h:mm:ss a z' }}</div>
        <div *ngIf="params?.value?.length > 1">&nbsp;</div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="!isParamsArray">
      <div class="timestamp">{{ params?.value | date : 'MMMM d, y, h:mm:ss a z' }}</div>
    </ng-container>
  `,
                    standalone: true,
                    imports: [NgIf, NgFor, DatePipe],
                }]
        }] });

class StatusCellComponent {
    agInit(params) {
        this.params = params;
    }
    refresh(params) {
        this.params = params;
        return true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StatusCellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: StatusCellComponent, isStandalone: true, selector: "ng-component", ngImport: i0, template: `
    <span
      *ngIf="params?.value"
      class="label"
      [ngClass]="{
        'ag-label--green': params.value === 'COMPLETED',
        'ag-label--gray': params.value === 'PARSING',
        'ag-label--yellow': params.value === 'FAILED'
      }"
    >
      {{ params.value }}
    </span>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StatusCellComponent, decorators: [{
            type: Component,
            args: [{
                    template: `
    <span
      *ngIf="params?.value"
      class="label"
      [ngClass]="{
        'ag-label--green': params.value === 'COMPLETED',
        'ag-label--gray': params.value === 'PARSING',
        'ag-label--yellow': params.value === 'FAILED'
      }"
    >
      {{ params.value }}
    </span>
  `,
                    standalone: true,
                    imports: [NgIf, NgClass],
                }]
        }] });

class TextAreaCellComponent {
    constructor() {
        this.textAreaCtrl = new UntypedFormControl();
    }
    agInit(params) {
        if (!params || !params.data)
            return;
        this.params = params;
        this.textAreaCtrl.setValue(params.value);
        const { answer, optionsRequireRemarks } = params.data;
        if (!this.params.context || !this.params.context.form || !this.params.context.form.controls)
            return;
        const ctrl = this.params.context.form.controls[params.node.rowIndex || 0];
        if (optionsRequireRemarks &&
            optionsRequireRemarks.indexOf(answer) > -1 &&
            !this.textAreaCtrl.value) {
            this.textAreaCtrl.setValidators([Validators.required]);
            ctrl && ctrl.setErrors({ required: true });
        }
        else {
            ctrl && ctrl.setErrors(null);
        }
    }
    refresh(params) {
        this.params = params;
        return true;
    }
    handleChange(event) {
        const val = event.target.value;
        this.params.context.componentParent.onTextAreaRendererChange(this.params, val);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TextAreaCellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: TextAreaCellComponent, isStandalone: true, selector: "ng-component", ngImport: i0, template: `
    <div>
      <textarea
        [ngClass]="{ 'has-error': textAreaCtrl.hasError('required') }"
        *ngIf="!params?.data?.isReadonly"
        pantryInput
        cols="60"
        rows="3"
        [formControl]="textAreaCtrl"
        (change)="handleChange($event)"
      >
      </textarea>
      <div *ngIf="params?.data?.isReadonly" class="rowDefaultHeight">
        <span>{{ params?.value }}</span>
      </div>
    </div>
  `, isInline: true, styles: [".form-input{border-radius:5px;margin:5px 0;width:100%;display:block;border:1px solid #cccccc;line-height:1.5;padding:8px 16px;box-shadow:0 1px 4px #0003;color:#4a4a4a}.rowDefaultHeight{min-height:100px}\n"], dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: PanelWidgetModule }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TextAreaCellComponent, decorators: [{
            type: Component,
            args: [{ template: `
    <div>
      <textarea
        [ngClass]="{ 'has-error': textAreaCtrl.hasError('required') }"
        *ngIf="!params?.data?.isReadonly"
        pantryInput
        cols="60"
        rows="3"
        [formControl]="textAreaCtrl"
        (change)="handleChange($event)"
      >
      </textarea>
      <div *ngIf="params?.data?.isReadonly" class="rowDefaultHeight">
        <span>{{ params?.value }}</span>
      </div>
    </div>
  `, standalone: true, imports: [NgIf, NgClass, ReactiveFormsModule, PanelWidgetModule], styles: [".form-input{border-radius:5px;margin:5px 0;width:100%;display:block;border:1px solid #cccccc;line-height:1.5;padding:8px 16px;box-shadow:0 1px 4px #0003;color:#4a4a4a}.rowDefaultHeight{min-height:100px}\n"] }]
        }] });

class UtilityCellComponent {
    constructor() {
        this.status = '';
    }
    agInit(params) {
        this.status = params?.data?.status;
        this.params = params;
    }
    refresh(params) {
        this.status = params?.data?.status;
        this.params = params;
        return true;
    }
    onUploadDoc() {
        if (this.params?.isReadonly || this.status === 'PROCESSING' || this.status === 'SUCCESS')
            return;
        this.params.context.componentParent.onUtilityCellUpload(this.params);
    }
    onDownload() {
        if (!this.params.context.componentParent.onUtilityCellDownload)
            return;
        this.params.context.componentParent.onUtilityCellDownload(this.params, this.params.downloadType);
    }
    onEditDoc() {
        if (this.params?.isReadonly || this.status === 'PROCESSING' || this.status === 'SUCCESS')
            return;
        this.params.context.componentParent.onUtilityCellEdit(this.params);
    }
    onSendToPerfios() {
        if (this.params?.isReadonly || this.status === 'PROCESSING')
            return;
        if (this.status === 'SUCCESS') {
            this.params.context.componentParent.openResendToPerfios(this.params);
            return;
        }
        this.params.context.componentParent.onUtilityCellSendToPerfios(this.params);
    }
    onViewError() {
        this.params.context.componentParent.onUtilityCellError(this.params);
    }
    onDeleteDoc() {
        if (this.params?.isReadonly || this.status === 'PROCESSING' || this.status === 'SUCCESS')
            return;
        this.params.context.componentParent.onDetailRowDeleteDocument(this.params);
    }
    onDeleteAccount() {
        if (this.params?.isReadonly)
            return;
        this.params.context.componentParent.onDeleteAccount(this.params);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UtilityCellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: UtilityCellComponent, isStandalone: true, selector: "ng-component", ngImport: i0, template: `
    <div class="fsw-utility-cell">
      <div (click)="onEditDoc()" *ngIf="params?.canEdit">
        <i
          [fontSize]="'16px'"
          [fswIcon]="'common-edit'"
          [class.opacity-25]="params?.isReadonly || status === 'PROCESSING' || status === 'SUCCESS'"
          [class.cursor-not-allowed]="
            params?.isReadonly || status === 'PROCESSING' || status === 'SUCCESS'
          "
        ></i>
      </div>
      <div (click)="onUploadDoc()" *ngIf="params?.canUpload">
        <i
          [fontSize]="'16px'"
          [fswIcon]="'common-add'"
          [class.opacity-25]="params?.isReadonly || status === 'PROCESSING' || status === 'SUCCESS'"
          [class.cursor-not-allowed]="
            params?.isReadonly || status === 'PROCESSING' || status === 'SUCCESS'
          "
        ></i>
      </div>
      <div (click)="onDownload()" *ngIf="params?.canDownload">
        <i [fontSize]="'16px'" [fswIcon]="'common-download'"></i>
      </div>
      <div (click)="onDeleteAccount()" *ngIf="params?.canDeleteAccount">
        <i
          [fontSize]="'16px'"
          [fswIcon]="'common-delete'"
          [class.opacity-25]="params?.isReadonly"
          [class.cursor-not-allowed]="params?.isReadonly"
        ></i>
      </div>
      <div *ngIf="params?.canParse">
        <button
          (click)="onSendToPerfios()"
          [disabled]="params?.isReadonly || status === 'PROCESSING'"
          fswButton
          appearance="secondary"
        >
          <div class="text-[10px]">
            <div>{{ status === 'SUCCESS' ? 'Resend to' : 'Send to' }}</div>
            <div>{{ 'Perfios' }}</div>
          </div>
        </button>
      </div>
      <div *ngIf="params?.showStatus">
        <div class="text-[11px]">{{ status }}</div>
      </div>
      <div
        (click)="onViewError()"
        *ngIf="params?.showError && params?.data?.message"
        class="bg-red-100 text-red-500 p-1"
      >
        <div class="text-[12px] text-center p-1">
          {{ 'View Error' }}
        </div>
      </div>

      <div
        (click)="onDeleteDoc()"
        [class.opacity-25]="params?.isReadonly || status === 'PROCESSING' || status === 'SUCCESS'"
        [class.cursor-not-allowed]="
          params?.isReadonly || status === 'PROCESSING' || status === 'SUCCESS'
        "
        *ngIf="params?.canDelete"
      >
        <i [fontSize]="'16px'" [fswIcon]="'common-delete'"></i>
      </div>
    </div>
  `, isInline: true, styles: [".fsw-utility-cell{display:flex;align-items:center;gap:8px}\n"], dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UtilityCellComponent, decorators: [{
            type: Component,
            args: [{ template: `
    <div class="fsw-utility-cell">
      <div (click)="onEditDoc()" *ngIf="params?.canEdit">
        <i
          [fontSize]="'16px'"
          [fswIcon]="'common-edit'"
          [class.opacity-25]="params?.isReadonly || status === 'PROCESSING' || status === 'SUCCESS'"
          [class.cursor-not-allowed]="
            params?.isReadonly || status === 'PROCESSING' || status === 'SUCCESS'
          "
        ></i>
      </div>
      <div (click)="onUploadDoc()" *ngIf="params?.canUpload">
        <i
          [fontSize]="'16px'"
          [fswIcon]="'common-add'"
          [class.opacity-25]="params?.isReadonly || status === 'PROCESSING' || status === 'SUCCESS'"
          [class.cursor-not-allowed]="
            params?.isReadonly || status === 'PROCESSING' || status === 'SUCCESS'
          "
        ></i>
      </div>
      <div (click)="onDownload()" *ngIf="params?.canDownload">
        <i [fontSize]="'16px'" [fswIcon]="'common-download'"></i>
      </div>
      <div (click)="onDeleteAccount()" *ngIf="params?.canDeleteAccount">
        <i
          [fontSize]="'16px'"
          [fswIcon]="'common-delete'"
          [class.opacity-25]="params?.isReadonly"
          [class.cursor-not-allowed]="params?.isReadonly"
        ></i>
      </div>
      <div *ngIf="params?.canParse">
        <button
          (click)="onSendToPerfios()"
          [disabled]="params?.isReadonly || status === 'PROCESSING'"
          fswButton
          appearance="secondary"
        >
          <div class="text-[10px]">
            <div>{{ status === 'SUCCESS' ? 'Resend to' : 'Send to' }}</div>
            <div>{{ 'Perfios' }}</div>
          </div>
        </button>
      </div>
      <div *ngIf="params?.showStatus">
        <div class="text-[11px]">{{ status }}</div>
      </div>
      <div
        (click)="onViewError()"
        *ngIf="params?.showError && params?.data?.message"
        class="bg-red-100 text-red-500 p-1"
      >
        <div class="text-[12px] text-center p-1">
          {{ 'View Error' }}
        </div>
      </div>

      <div
        (click)="onDeleteDoc()"
        [class.opacity-25]="params?.isReadonly || status === 'PROCESSING' || status === 'SUCCESS'"
        [class.cursor-not-allowed]="
          params?.isReadonly || status === 'PROCESSING' || status === 'SUCCESS'
        "
        *ngIf="params?.canDelete"
      >
        <i [fontSize]="'16px'" [fswIcon]="'common-delete'"></i>
      </div>
    </div>
  `, standalone: true, imports: [NgIf, NgClass, FSWIconModule, FSWButtonModule], styles: [".fsw-utility-cell{display:flex;align-items:center;gap:8px}\n"] }]
        }] });

class DeleteDocumentCellComponent {
    agInit(params) {
        this.params = params;
    }
    refresh(params) {
        this.params = params;
        return true;
    }
    onDeleteDoc() {
        this.params.context.componentParent.onDetailRowDeleteDocument(this.params);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DeleteDocumentCellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DeleteDocumentCellComponent, isStandalone: true, selector: "ng-component", ngImport: i0, template: `
    <div (click)="onDeleteDoc()" *ngIf="params?.canDelete">
      <i [fontSize]="'16px'" [fswIcon]="'common-delete'"></i>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DeleteDocumentCellComponent, decorators: [{
            type: Component,
            args: [{
                    template: `
    <div (click)="onDeleteDoc()" *ngIf="params?.canDelete">
      <i [fontSize]="'16px'" [fswIcon]="'common-delete'"></i>
    </div>
  `,
                    standalone: true,
                    imports: [NgIf, FSWIconModule],
                }]
        }] });

class ParseAccountCellComponent {
    constructor() {
        this.status = '';
    }
    agInit(params) {
        this.status = params?.data?.status;
        this.params = params;
    }
    refresh(params) {
        this.status = params?.data?.status;
        this.params = params;
        return true;
    }
    onParse() {
        this.params.context.componentParent.onDetailRowParse(this.params);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ParseAccountCellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ParseAccountCellComponent, isStandalone: true, selector: "ng-component", ngImport: i0, template: `
    <ng-container *ngIf="status === 'FAILURE'; else otherTemp">
      <button (click)="onParse()" fswButton appearance="secondary">
        <div class="text-[12px]">
          <div>{{ 'Parse' }}</div>
        </div>
      </button>
    </ng-container>

    <ng-template #otherTemp>
      <div class="text-[12px]">{{ status }}</div>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ParseAccountCellComponent, decorators: [{
            type: Component,
            args: [{
                    template: `
    <ng-container *ngIf="status === 'FAILURE'; else otherTemp">
      <button (click)="onParse()" fswButton appearance="secondary">
        <div class="text-[12px]">
          <div>{{ 'Parse' }}</div>
        </div>
      </button>
    </ng-container>

    <ng-template #otherTemp>
      <div class="text-[12px]">{{ status }}</div>
    </ng-template>
  `,
                    standalone: true,
                    imports: [NgIf, FSWButtonModule],
                }]
        }] });

var CommonGridFields;
(function (CommonGridFields) {
    CommonGridFields["ACTIONS"] = "actions";
})(CommonGridFields || (CommonGridFields = {}));

class FSWGridComponent {
    constructor(_elementRef) {
        this._elementRef = _elementRef;
        this.rowClicked = new EventEmitter();
        this.gridOptions = {};
        this.actionClickedCheck = true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.rowData = [];
        this.gridContainerHeight = 520;
        this.gridOptionsDefault = {
            defaultColDef: {
                sortable: false,
                filter: false,
                resizable: false,
                autoHeight: true,
                wrapText: true,
                suppressMenu: true,
            },
            rowSelection: 'multiple',
            animateRows: true,
            components: {
                action: ActionIconsCellComponent,
                actionMethods: FSWGridActionMethodsCellComponent,
            },
            suppressDragLeaveHidesColumns: true,
            suppressRowClickSelection: true,
            suppressColumnMoveAnimation: true,
            suppressMovableColumns: true,
            suppressContextMenu: true,
            suppressAggFilteredOnly: true,
            pagination: true,
            paginationPageSize: 10,
            onGridReady: (event) => event.api.autoSizeAllColumns(),
            onRowClicked: (e) => {
                const notEmit = this._checkActionMethodsClick(e);
                if (notEmit && this.actionClickedCheck)
                    return;
                this.rowClicked.emit({
                    data: e.data,
                    index: e.rowIndex,
                });
            },
        };
        this._checkActionMethodsClick = (e) => {
            const actions = this._elementRef.nativeElement.querySelectorAll('fsw-action-methods-cell');
            const { event, rowIndex } = e;
            const { target } = event;
            return (rowIndex != null &&
                !!actions.item(rowIndex) &&
                !!actions.item(rowIndex).contains(target));
        };
    }
    ngOnChanges(changes) {
        const { gridOptions } = changes;
        if (gridOptions && gridOptions.previousValue !== gridOptions.currentValue) {
            this.gridOptions = gridOptions.currentValue;
            if (!this.gridOptions) {
                return;
            }
            const defaultColDef = {
                ...this.gridOptionsDefault.defaultColDef,
                ...this.gridOptions.defaultColDef,
            };
            this.gridOptionsDefault = {
                ...this.gridOptionsDefault,
                ...this.gridOptions,
                defaultColDef,
            };
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWGridComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWGridComponent, isStandalone: true, selector: "fsw-grid", inputs: { gridOptions: "gridOptions", actionClickedCheck: "actionClickedCheck", rowData: "rowData", gridContainerHeight: "gridContainerHeight" }, outputs: { rowClicked: "rowClicked" }, usesOnChanges: true, ngImport: i0, template: `
    <div [style.height.px]="gridContainerHeight" *ngIf="gridOptionsDefault?.columnDefs?.length">
      <ag-grid-angular
        class="ag-theme-alpine"
        *ngIf="rowData && rowData.length"
        [gridOptions]="gridOptionsDefault"
        [rowData]="rowData"
      >
      </ag-grid-angular>
      <ag-grid-angular
        class="ag-theme-alpine"
        *ngIf="!rowData || !rowData.length"
        [gridOptions]="gridOptionsDefault"
      >
      </ag-grid-angular>
    </div>
  `, isInline: true, styles: [":host ag-grid-angular{height:100%}:host ::ng-deep .ag-row-hover{background-color:#f1f1f2!important;cursor:pointer!important}\n"], dependencies: [{ kind: "ngmodule", type: AgGridModule }, { kind: "component", type: i1$5.AgGridAngular, selector: "ag-grid-angular", inputs: ["gridOptions", "modules", "statusBar", "sideBar", "suppressContextMenu", "preventDefaultOnContextMenu", "allowContextMenuWithControlKey", "columnMenu", "suppressMenuHide", "enableBrowserTooltips", "tooltipTrigger", "tooltipShowDelay", "tooltipHideDelay", "tooltipMouseTrack", "tooltipShowMode", "tooltipInteraction", "popupParent", "copyHeadersToClipboard", "copyGroupHeadersToClipboard", "clipboardDelimiter", "suppressCopyRowsToClipboard", "suppressCopySingleCellRanges", "suppressLastEmptyLineOnPaste", "suppressClipboardPaste", "suppressClipboardApi", "suppressCutToClipboard", "columnDefs", "defaultColDef", "defaultColGroupDef", "columnTypes", "dataTypeDefinitions", "maintainColumnOrder", "suppressFieldDotNotation", "headerHeight", "groupHeaderHeight", "floatingFiltersHeight", "pivotHeaderHeight", "pivotGroupHeaderHeight", "allowDragFromColumnsToolPanel", "suppressMovableColumns", "suppressColumnMoveAnimation", "suppressDragLeaveHidesColumns", "suppressRowGroupHidesColumns", "colResizeDefault", "suppressAutoSize", "autoSizePadding", "skipHeaderOnAutoSize", "autoSizeStrategy", "components", "editType", "singleClickEdit", "suppressClickEdit", "readOnlyEdit", "stopEditingWhenCellsLoseFocus", "enterNavigatesVertically", "enterNavigatesVerticallyAfterEdit", "enableCellEditingOnBackspace", "undoRedoCellEditing", "undoRedoCellEditingLimit", "defaultCsvExportParams", "suppressCsvExport", "defaultExcelExportParams", "suppressExcelExport", "excelStyles", "quickFilterText", "cacheQuickFilter", "includeHiddenColumnsInQuickFilter", "quickFilterParser", "quickFilterMatcher", "applyQuickFilterBeforePivotOrAgg", "excludeChildrenWhenTreeDataFiltering", "enableAdvancedFilter", "advancedFilterModel", "includeHiddenColumnsInAdvancedFilter", "advancedFilterParent", "advancedFilterBuilderParams", "suppressAdvancedFilterEval", "enableCharts", "chartThemes", "customChartThemes", "chartThemeOverrides", "chartToolPanelsDef", "chartMenuItems", "loadingCellRenderer", "loadingCellRendererParams", "loadingCellRendererSelector", "localeText", "masterDetail", "keepDetailRows", "keepDetailRowsCount", "detailCellRenderer", "detailCellRendererParams", "detailRowHeight", "detailRowAutoHeight", "context", "alignedGrids", "tabIndex", "rowBuffer", "valueCache", "valueCacheNeverExpires", "enableCellExpressions", "suppressTouch", "suppressFocusAfterRefresh", "suppressAsyncEvents", "suppressBrowserResizeObserver", "suppressPropertyNamesCheck", "suppressChangeDetection", "debug", "loading", "overlayLoadingTemplate", "loadingOverlayComponent", "loadingOverlayComponentParams", "suppressLoadingOverlay", "overlayNoRowsTemplate", "noRowsOverlayComponent", "noRowsOverlayComponentParams", "suppressNoRowsOverlay", "pagination", "paginationPageSize", "paginationPageSizeSelector", "paginationAutoPageSize", "paginateChildRows", "suppressPaginationPanel", "pivotMode", "pivotPanelShow", "pivotMaxGeneratedColumns", "pivotDefaultExpanded", "pivotColumnGroupTotals", "pivotRowTotals", "pivotSuppressAutoColumn", "suppressExpandablePivotGroups", "functionsReadOnly", "aggFuncs", "suppressAggFuncInHeader", "alwaysAggregateAtRootLevel", "aggregateOnlyChangedColumns", "suppressAggFilteredOnly", "removePivotHeaderRowWhenSingleValueColumn", "animateRows", "enableCellChangeFlash", "cellFlashDuration", "cellFlashDelay", "cellFadeDuration", "cellFadeDelay", "allowShowChangeAfterFilter", "domLayout", "ensureDomOrder", "enableRtl", "suppressColumnVirtualisation", "suppressMaxRenderedRowRestriction", "suppressRowVirtualisation", "rowDragManaged", "suppressRowDrag", "suppressMoveWhenRowDragging", "rowDragEntireRow", "rowDragMultiRow", "rowDragText", "fullWidthCellRenderer", "fullWidthCellRendererParams", "embedFullWidthRows", "suppressGroupMaintainValueType", "groupDisplayType", "groupDefaultExpanded", "autoGroupColumnDef", "groupMaintainOrder", "groupSelectsChildren", "groupLockGroupColumns", "groupAggFiltering", "groupIncludeFooter", "groupIncludeTotalFooter", "groupTotalRow", "grandTotalRow", "suppressStickyTotalRow", "groupSuppressBlankHeader", "groupSelectsFiltered", "showOpenedGroup", "groupRemoveSingleChildren", "groupRemoveLowestSingleChildren", "groupHideOpenParents", "groupAllowUnbalanced", "rowGroupPanelShow", "groupRowRenderer", "groupRowRendererParams", "suppressMakeColumnVisibleAfterUnGroup", "treeData", "rowGroupPanelSuppressSort", "suppressGroupRowsSticky", "pinnedTopRowData", "pinnedBottomRowData", "rowModelType", "rowData", "asyncTransactionWaitMillis", "suppressModelUpdateAfterUpdateTransaction", "datasource", "cacheOverflowSize", "infiniteInitialRowCount", "serverSideInitialRowCount", "suppressServerSideInfiniteScroll", "suppressServerSideFullWidthLoadingRow", "cacheBlockSize", "maxBlocksInCache", "maxConcurrentDatasourceRequests", "blockLoadDebounceMillis", "purgeClosedRowNodes", "serverSideDatasource", "serverSideSortAllLevels", "serverSideEnableClientSideSort", "serverSideOnlyRefreshFilteredGroups", "serverSideSortOnServer", "serverSideFilterOnServer", "serverSidePivotResultFieldSeparator", "viewportDatasource", "viewportRowModelPageSize", "viewportRowModelBufferSize", "alwaysShowHorizontalScroll", "alwaysShowVerticalScroll", "debounceVerticalScrollbar", "suppressHorizontalScroll", "suppressScrollOnNewData", "suppressScrollWhenPopupsAreOpen", "suppressAnimationFrame", "suppressMiddleClickScrolls", "suppressPreventDefaultOnMouseWheel", "scrollbarWidth", "rowSelection", "rowMultiSelectWithClick", "suppressRowDeselection", "suppressRowClickSelection", "suppressCellFocus", "suppressHeaderFocus", "suppressMultiRangeSelection", "enableCellTextSelection", "enableRangeSelection", "enableRangeHandle", "enableFillHandle", "fillHandleDirection", "suppressClearOnFillReduction", "sortingOrder", "accentedSort", "unSortIcon", "suppressMultiSort", "alwaysMultiSort", "multiSortKey", "suppressMaintainUnsortedOrder", "icons", "rowHeight", "rowStyle", "rowClass", "rowClassRules", "suppressRowHoverHighlight", "suppressRowTransform", "columnHoverHighlight", "gridId", "deltaSort", "treeDataDisplayType", "enableGroupEdit", "initialState", "getContextMenuItems", "getMainMenuItems", "postProcessPopup", "processUnpinnedColumns", "processCellForClipboard", "processHeaderForClipboard", "processGroupHeaderForClipboard", "processCellFromClipboard", "sendToClipboard", "processDataFromClipboard", "isExternalFilterPresent", "doesExternalFilterPass", "getChartToolbarItems", "createChartContainer", "focusGridInnerElement", "navigateToNextHeader", "tabToNextHeader", "navigateToNextCell", "tabToNextCell", "getLocaleText", "getDocument", "paginationNumberFormatter", "getGroupRowAgg", "isGroupOpenByDefault", "initialGroupOrderComparator", "processPivotResultColDef", "processPivotResultColGroupDef", "getDataPath", "getChildCount", "getServerSideGroupLevelParams", "isServerSideGroupOpenByDefault", "isApplyServerSideTransaction", "isServerSideGroup", "getServerSideGroupKey", "getBusinessKeyForNode", "getRowId", "resetRowDataOnUpdate", "processRowPostCreate", "isRowSelectable", "isRowMaster", "fillOperation", "postSortRows", "getRowStyle", "getRowClass", "getRowHeight", "isFullWidthRow"], outputs: ["toolPanelVisibleChanged", "toolPanelSizeChanged", "columnMenuVisibleChanged", "contextMenuVisibleChanged", "cutStart", "cutEnd", "pasteStart", "pasteEnd", "columnVisible", "columnPinned", "columnResized", "columnMoved", "columnValueChanged", "columnPivotModeChanged", "columnPivotChanged", "columnGroupOpened", "newColumnsLoaded", "gridColumnsChanged", "displayedColumnsChanged", "virtualColumnsChanged", "columnEverythingChanged", "columnHeaderMouseOver", "columnHeaderMouseLeave", "columnHeaderClicked", "columnHeaderContextMenu", "componentStateChanged", "cellValueChanged", "cellEditRequest", "rowValueChanged", "cellEditingStarted", "cellEditingStopped", "rowEditingStarted", "rowEditingStopped", "undoStarted", "undoEnded", "redoStarted", "redoEnded", "rangeDeleteStart", "rangeDeleteEnd", "fillStart", "fillEnd", "filterOpened", "filterChanged", "filterModified", "advancedFilterBuilderVisibleChanged", "chartCreated", "chartRangeSelectionChanged", "chartOptionsChanged", "chartDestroyed", "cellKeyDown", "gridReady", "firstDataRendered", "gridSizeChanged", "modelUpdated", "virtualRowRemoved", "viewportChanged", "bodyScroll", "bodyScrollEnd", "dragStarted", "dragStopped", "stateUpdated", "paginationChanged", "rowDragEnter", "rowDragMove", "rowDragLeave", "rowDragEnd", "columnRowGroupChanged", "rowGroupOpened", "expandOrCollapseAll", "pivotMaxColumnsExceeded", "pinnedRowDataChanged", "rowDataUpdated", "asyncTransactionsFlushed", "storeRefreshed", "headerFocused", "cellClicked", "cellDoubleClicked", "cellFocused", "cellMouseOver", "cellMouseOut", "cellMouseDown", "rowClicked", "rowDoubleClicked", "rowSelected", "selectionChanged", "cellContextMenu", "rangeSelectionChanged", "tooltipShow", "tooltipHide", "sortChanged"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWGridComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-grid', template: `
    <div [style.height.px]="gridContainerHeight" *ngIf="gridOptionsDefault?.columnDefs?.length">
      <ag-grid-angular
        class="ag-theme-alpine"
        *ngIf="rowData && rowData.length"
        [gridOptions]="gridOptionsDefault"
        [rowData]="rowData"
      >
      </ag-grid-angular>
      <ag-grid-angular
        class="ag-theme-alpine"
        *ngIf="!rowData || !rowData.length"
        [gridOptions]="gridOptionsDefault"
      >
      </ag-grid-angular>
    </div>
  `, standalone: true, imports: [AgGridModule, NgIf], styles: [":host ag-grid-angular{height:100%}:host ::ng-deep .ag-row-hover{background-color:#f1f1f2!important;cursor:pointer!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { rowClicked: [{
                type: Output
            }], gridOptions: [{
                type: Input
            }], actionClickedCheck: [{
                type: Input
            }], rowData: [{
                type: Input
            }], gridContainerHeight: [{
                type: Input
            }] } });

class FSWGridModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWGridModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWGridModule, imports: [FSWGridComponent], exports: [FSWGridComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWGridModule, imports: [FSWGridComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWGridModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [FSWGridComponent],
                    exports: [FSWGridComponent],
                }]
        }] });

class FSWImageViewerComponent {
    set id(value) {
        this._id = value;
        this.load();
    }
    constructor(_blobService, _cdr) {
        this._blobService = _blobService;
        this._cdr = _cdr;
        this._id = null;
        this.height = '400px';
        this.src = null;
    }
    load() {
        if (!this._id)
            return;
        this._blobService
            .downloadBlob(this._id)
            .pipe(tap((e) => {
            this.src = URL.createObjectURL(e);
            this._cdr.markForCheck();
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWImageViewerComponent, deps: [{ token: BLOB_SERVICE_TOKEN }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWImageViewerComponent, selector: "fsw-image-viewer", inputs: { id: "id", height: "height" }, ngImport: i0, template: "<ng-container *ngIf=\"src\">\n\t<iframe [src]=\"src | domSanitize : 'resourceUrl'\" width=\"100%\" [height]=\"height\"></iframe>\n</ng-container>\n", styles: ["iframe{border:none}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: DOMSanitizePipe, name: "domSanitize" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWImageViewerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-image-viewer', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"src\">\n\t<iframe [src]=\"src | domSanitize : 'resourceUrl'\" width=\"100%\" [height]=\"height\"></iframe>\n</ng-container>\n", styles: ["iframe{border:none}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [BLOB_SERVICE_TOKEN]
                }] }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { id: [{
                type: Input
            }], height: [{
                type: Input
            }] } });

class FSWImageViewerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWImageViewerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWImageViewerModule, declarations: [FSWImageViewerComponent], imports: [CommonModule, DOMSanitizeModule, FSWBlobServiceModule], exports: [FSWImageViewerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWImageViewerModule, imports: [CommonModule, DOMSanitizeModule, FSWBlobServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWImageViewerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FSWImageViewerComponent],
                    imports: [CommonModule, DOMSanitizeModule, FSWBlobServiceModule],
                    exports: [FSWImageViewerComponent],
                }]
        }] });

class NumberRunningDirective {
    constructor(_elementRef, _ngZone) {
        this._elementRef = _elementRef;
        this._ngZone = _ngZone;
        this.value = 0;
        this._startTimestamp = null;
        this._decimalPipe = new DecimalPipe('en-IN');
        this.step = (timestamp) => {
            if (!this._startTimestamp)
                this._startTimestamp = timestamp;
            const progress = Math.min((timestamp - this._startTimestamp) / 1500, 1);
            this._elementRef.nativeElement.innerHTML = this._decimalPipe.transform(Number(progress * (this.value - 0) + 0), '.2');
            if (progress < 1) {
                window.requestAnimationFrame(this.step);
            }
        };
    }
    ngOnChanges() {
        this._ngZone.runOutsideAngular(() => {
            this.animate();
        });
    }
    animate() {
        window.requestAnimationFrame(this.step);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NumberRunningDirective, deps: [{ token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: NumberRunningDirective, selector: "[fswNumberRunning]", inputs: { value: ["fswNumberRunning", "value"] }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NumberRunningDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswNumberRunning]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.NgZone }]; }, propDecorators: { value: [{
                type: Input,
                args: ['fswNumberRunning']
            }] } });

class NumberRunningModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NumberRunningModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: NumberRunningModule, declarations: [NumberRunningDirective], exports: [NumberRunningDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NumberRunningModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NumberRunningModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [NumberRunningDirective],
                    exports: [NumberRunningDirective],
                }]
        }] });

class FSWPaginationComponent {
    constructor() {
        this.maxPage = 0;
        this.page = 1;
        this.pageChange = new EventEmitter();
    }
    get pages() {
        return Array.from({ length: this.maxPage }).map((e, i) => i);
    }
    change(value) {
        this.page = value;
        this.pageChange.emit(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPaginationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWPaginationComponent, selector: "fsw-pagination", inputs: { maxPage: "maxPage", page: "page" }, outputs: { pageChange: "pageChange" }, ngImport: i0, template: "<div class=\"pagination\">\n\t<div\n\t\tclass=\"pagination__control\"\n\t\t[class.disabled]=\"page === 0\"\n\t\t(click)=\"page > 1 && change(page - 1)\"\n\t>\n\t\t<i class=\"fa fa-angle-left\"></i>\n\t\t<span>Prev</span>\n\t</div>\n\t<ng-container *ngFor=\"let p of pages\">\n\t\t<div class=\"pagination__page\" (click)=\"change(p + 1)\" [class.active]=\"p + 1 === page\">\n\t\t\t<span>{{ p + 1 }}</span>\n\t\t</div>\n\t</ng-container>\n\t<div\n\t\tclass=\"pagination__control\"\n\t\t[class.disabled]=\"page === maxPage + 1\"\n\t\t(click)=\"page < maxPage + 1 && change(page + 1)\"\n\t>\n\t\t<span>Next</span>\n\t\t<i class=\"fa fa-angle-right\"></i>\n\t</div>\n</div>\n", styles: [":host .pagination{display:flex;justify-content:center;align-items:center;gap:12px}:host .pagination__control{padding:4px;cursor:pointer;gap:4px;display:flex;align-items:center;color:#adadad;border:1px solid #adadad;border-radius:2px}:host .pagination__control span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;line-height:24px;font-size:14px;font-weight:500}:host .pagination__control.disabled{color:#e0e0e0}:host .pagination__page{padding:4px;cursor:pointer}:host .pagination__page span{color:#222;font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;line-height:24px;font-size:14px;font-weight:500}:host .pagination__page.active span{text-decoration:underline}:host .pagination__page:hover span{text-decoration:underline}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPaginationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-pagination', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"pagination\">\n\t<div\n\t\tclass=\"pagination__control\"\n\t\t[class.disabled]=\"page === 0\"\n\t\t(click)=\"page > 1 && change(page - 1)\"\n\t>\n\t\t<i class=\"fa fa-angle-left\"></i>\n\t\t<span>Prev</span>\n\t</div>\n\t<ng-container *ngFor=\"let p of pages\">\n\t\t<div class=\"pagination__page\" (click)=\"change(p + 1)\" [class.active]=\"p + 1 === page\">\n\t\t\t<span>{{ p + 1 }}</span>\n\t\t</div>\n\t</ng-container>\n\t<div\n\t\tclass=\"pagination__control\"\n\t\t[class.disabled]=\"page === maxPage + 1\"\n\t\t(click)=\"page < maxPage + 1 && change(page + 1)\"\n\t>\n\t\t<span>Next</span>\n\t\t<i class=\"fa fa-angle-right\"></i>\n\t</div>\n</div>\n", styles: [":host .pagination{display:flex;justify-content:center;align-items:center;gap:12px}:host .pagination__control{padding:4px;cursor:pointer;gap:4px;display:flex;align-items:center;color:#adadad;border:1px solid #adadad;border-radius:2px}:host .pagination__control span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;line-height:24px;font-size:14px;font-weight:500}:host .pagination__control.disabled{color:#e0e0e0}:host .pagination__page{padding:4px;cursor:pointer}:host .pagination__page span{color:#222;font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;line-height:24px;font-size:14px;font-weight:500}:host .pagination__page.active span{text-decoration:underline}:host .pagination__page:hover span{text-decoration:underline}\n"] }]
        }], propDecorators: { maxPage: [{
                type: Input
            }], page: [{
                type: Input
            }], pageChange: [{
                type: Output
            }] } });

class FSWPaginationModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPaginationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWPaginationModule, declarations: [FSWPaginationComponent], imports: [CommonModule], exports: [FSWPaginationComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPaginationModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPaginationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [FSWPaginationComponent],
                    exports: [FSWPaginationComponent],
                }]
        }] });

class FSWPdfService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._kongUrl = this._utilsService.getKongUrl();
    }
    getReport(id) {
        const url = `${this._kongUrl}/docs_management/v2/download`;
        return this._httpClient.get(url, {
            responseType: 'blob',
            params: {
                id,
            },
            headers: setRequestOptions(),
        });
    }
    getReportUrl(id) {
        const url = `${this._kongUrl}/docs_management/v2/download`;
        return url;
    }
    getReportDetail(id) {
        const url = `${this._kongUrl}/docs_management/v2/docs`;
        return this._httpClient
            .get(url, {
            params: {
                ids: id,
            },
            headers: setRequestOptions(),
        })
            .pipe(map((e) => e.results && e.results[0]));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPdfService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPdfService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPdfService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

const PDF_SERVICE_TOKEN = new InjectionToken('PDF_SERVICE_TOKEN');

class FSWPdfDialogComponent {
    constructor(context) {
        this.context = context;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPdfDialogComponent, deps: [{ token: MODAL_CONTEXT }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWPdfDialogComponent, selector: "fsw-pdf-dialog", ngImport: i0, template: "<div class=\"pdf-dialog\">\n\t<pdf-viewer [src]=\"context.data\"></pdf-viewer>\n\t<footer>\n\t\t<button class=\"btn btn--secondary\" (click)=\"context.completeWith(false)\">Cancel</button>\n\t</footer>\n</div>\n", styles: [":host .pdf-dialog{width:100%;display:flex;flex-direction:column;background:#4a4a4a}:host .pdf-dialog pdf-viewer{height:60vh}:host .pdf-dialog footer{padding:16px;display:flex;flex-direction:row-reverse;background:white;height:72px}\n"], dependencies: [{ kind: "component", type: i1$6.PdfViewerComponent, selector: "pdf-viewer", inputs: ["src", "c-maps-url", "page", "render-text", "render-text-mode", "original-size", "show-all", "stick-to-page", "zoom", "zoom-scale", "rotation", "external-link-target", "autoresize", "fit-to-page", "show-borders"], outputs: ["after-load-complete", "page-rendered", "pages-initialized", "text-layer-rendered", "error", "on-progress", "pageChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPdfDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-pdf-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"pdf-dialog\">\n\t<pdf-viewer [src]=\"context.data\"></pdf-viewer>\n\t<footer>\n\t\t<button class=\"btn btn--secondary\" (click)=\"context.completeWith(false)\">Cancel</button>\n\t</footer>\n</div>\n", styles: [":host .pdf-dialog{width:100%;display:flex;flex-direction:column;background:#4a4a4a}:host .pdf-dialog pdf-viewer{height:60vh}:host .pdf-dialog footer{padding:16px;display:flex;flex-direction:row-reverse;background:white;height:72px}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_CONTEXT]
                }] }]; } });

class FSWPdfDialogModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPdfDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWPdfDialogModule, declarations: [FSWPdfDialogComponent], imports: [CommonModule, PdfViewerModule], exports: [FSWPdfDialogComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPdfDialogModule, imports: [CommonModule, PdfViewerModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPdfDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, PdfViewerModule],
                    declarations: [FSWPdfDialogComponent],
                    exports: [FSWPdfDialogComponent],
                }]
        }] });

class FSWPdfComponent {
    set id(value) {
        this._id = value;
        this.load();
    }
    constructor(_blobService, _cdr, _modalService) {
        this._blobService = _blobService;
        this._cdr = _cdr;
        this._modalService = _modalService;
        this.src = null;
        this.showPagination = false;
        this.height = '0px';
        this.maxPage = 0;
        this.page = 1;
        this._id = null;
    }
    load() {
        if (!this._id)
            return;
        this._blobService
            .downloadBlob(this._id)
            .pipe(tap((e) => {
            this.src = URL.createObjectURL(e);
            this._cdr.markForCheck();
        }))
            .subscribe();
    }
    pdfLoaded(pdf) {
        this.maxPage = pdf.numPages;
        this._cdr.markForCheck();
    }
    expand(src) {
        this._modalService
            .open(FSWPdfDialogComponent, {
            size: ModalSizes.L,
            data: src,
        })
            .pipe(take(1))
            .subscribe();
    }
    download(src) {
        downloadFileToLocal(src, `credit-bureau-${this._id}.pdf`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPdfComponent, deps: [{ token: BLOB_SERVICE_TOKEN }, { token: i0.ChangeDetectorRef }, { token: MODAL_SERVICE }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWPdfComponent, selector: "fsw-pdf", inputs: { id: "id", showPagination: "showPagination", height: "height" }, ngImport: i0, template: "<ng-container *ngIf=\"src\">\n\t<div class=\"pdf\">\n\t\t<pdf-viewer\n\t\t\t[style.--height]=\"height\"\n\t\t\t[(page)]=\"page\"\n\t\t\t[src]=\"src\"\n\t\t\t(after-load-complete)=\"pdfLoaded($event)\"\n\t\t></pdf-viewer>\n\t\t<fsw-pagination *ngIf=\"showPagination\" [maxPage]=\"maxPage\" [(page)]=\"page\"></fsw-pagination>\n\t\t<div class=\"pdf__control\">\n\t\t\t<i class=\"fa fa-download\" (click)=\"download(src)\"></i>\n\t\t\t<i class=\"fa fa-expand\" (click)=\"expand(src)\"></i>\n\t\t</div>\n\t</div>\n</ng-container>\n", styles: [":host .pdf{display:flex;position:relative;width:100%;flex-direction:column;gap:16px}:host .pdf pdf-viewer{--height: 0px;height:calc(90vh - 48px - var(--height))}:host .pdf:hover .pdf__control{display:flex}:host .pdf__control{position:absolute;bottom:48px;left:50%;display:none;transform:translate(-50%);padding:12px;gap:12px;background:rgba(34,34,34,.6);border-radius:8px}:host .pdf__control i{color:#fff}:host .pdf__control i:hover{color:#2c50ff;cursor:pointer}\n"], dependencies: [{ kind: "component", type: i1$6.PdfViewerComponent, selector: "pdf-viewer", inputs: ["src", "c-maps-url", "page", "render-text", "render-text-mode", "original-size", "show-all", "stick-to-page", "zoom", "zoom-scale", "rotation", "external-link-target", "autoresize", "fit-to-page", "show-borders"], outputs: ["after-load-complete", "page-rendered", "pages-initialized", "text-layer-rendered", "error", "on-progress", "pageChange"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FSWPaginationComponent, selector: "fsw-pagination", inputs: ["maxPage", "page"], outputs: ["pageChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPdfComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-pdf', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"src\">\n\t<div class=\"pdf\">\n\t\t<pdf-viewer\n\t\t\t[style.--height]=\"height\"\n\t\t\t[(page)]=\"page\"\n\t\t\t[src]=\"src\"\n\t\t\t(after-load-complete)=\"pdfLoaded($event)\"\n\t\t></pdf-viewer>\n\t\t<fsw-pagination *ngIf=\"showPagination\" [maxPage]=\"maxPage\" [(page)]=\"page\"></fsw-pagination>\n\t\t<div class=\"pdf__control\">\n\t\t\t<i class=\"fa fa-download\" (click)=\"download(src)\"></i>\n\t\t\t<i class=\"fa fa-expand\" (click)=\"expand(src)\"></i>\n\t\t</div>\n\t</div>\n</ng-container>\n", styles: [":host .pdf{display:flex;position:relative;width:100%;flex-direction:column;gap:16px}:host .pdf pdf-viewer{--height: 0px;height:calc(90vh - 48px - var(--height))}:host .pdf:hover .pdf__control{display:flex}:host .pdf__control{position:absolute;bottom:48px;left:50%;display:none;transform:translate(-50%);padding:12px;gap:12px;background:rgba(34,34,34,.6);border-radius:8px}:host .pdf__control i{color:#fff}:host .pdf__control i:hover{color:#2c50ff;cursor:pointer}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [BLOB_SERVICE_TOKEN]
                }] }, { type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_SERVICE]
                }] }]; }, propDecorators: { id: [{
                type: Input
            }], showPagination: [{
                type: Input
            }], height: [{
                type: Input
            }] } });

class FSWPdfModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPdfModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWPdfModule, declarations: [FSWPdfComponent], imports: [PdfViewerModule,
            CommonModule,
            FSWPaginationModule,
            FSWModalModule,
            FSWPdfDialogModule,
            FSWBlobServiceModule], exports: [FSWPdfComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPdfModule, providers: [
            {
                provide: PDF_SERVICE_TOKEN,
                useClass: FSWPdfService,
            },
        ], imports: [PdfViewerModule,
            CommonModule,
            FSWPaginationModule,
            FSWModalModule,
            FSWPdfDialogModule,
            FSWBlobServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPdfModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FSWPdfComponent],
                    imports: [
                        PdfViewerModule,
                        CommonModule,
                        FSWPaginationModule,
                        FSWModalModule,
                        FSWPdfDialogModule,
                        FSWBlobServiceModule,
                    ],
                    providers: [
                        {
                            provide: PDF_SERVICE_TOKEN,
                            useClass: FSWPdfService,
                        },
                    ],
                    exports: [FSWPdfComponent],
                }]
        }] });

class FSWCommentBoxThumbnailComponent {
    constructor() {
        this.thumbnail = null;
        this.type = null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCommentBoxThumbnailComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCommentBoxThumbnailComponent, selector: "fsw-comment-box-thumbnail", inputs: { thumbnail: "thumbnail", type: "type" }, ngImport: i0, template: "<figure class=\"comment-box-thumbnail\">\n  <ng-container *ngIf=\"thumbnail\">\n    <ng-container *ngIf=\"type === 'thumbnail'; else notThumbnailTemplate\">\n      <img [src]=\"thumbnail\" [alt]=\"thumbnail\" />\n    </ng-container>\n    <ng-template #notThumbnailTemplate>\n      <span>{{ thumbnail.charAt(0).toUpperCase() }}</span>\n    </ng-template>\n  </ng-container>\n</figure>\n", styles: [":host .comment-box-thumbnail{width:40px;height:40px;border-radius:100%;background-color:#79c0ff;display:flex;align-items:center;justify-content:center;overflow:hidden}:host .comment-box-thumbnail>span{color:#fff;font-weight:600;font-size:16px;line-height:1.5;font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif}:host .comment-box-thumbnail>span:lang(th){font-weight:600;font-size:16px;line-height:1.5;font-family:Inter,Prompt,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCommentBoxThumbnailComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-comment-box-thumbnail', changeDetection: ChangeDetectionStrategy.OnPush, template: "<figure class=\"comment-box-thumbnail\">\n  <ng-container *ngIf=\"thumbnail\">\n    <ng-container *ngIf=\"type === 'thumbnail'; else notThumbnailTemplate\">\n      <img [src]=\"thumbnail\" [alt]=\"thumbnail\" />\n    </ng-container>\n    <ng-template #notThumbnailTemplate>\n      <span>{{ thumbnail.charAt(0).toUpperCase() }}</span>\n    </ng-template>\n  </ng-container>\n</figure>\n", styles: [":host .comment-box-thumbnail{width:40px;height:40px;border-radius:100%;background-color:#79c0ff;display:flex;align-items:center;justify-content:center;overflow:hidden}:host .comment-box-thumbnail>span{color:#fff;font-weight:600;font-size:16px;line-height:1.5;font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif}:host .comment-box-thumbnail>span:lang(th){font-weight:600;font-size:16px;line-height:1.5;font-family:Inter,Prompt,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif}\n"] }]
        }], propDecorators: { thumbnail: [{
                type: Input
            }], type: [{
                type: Input
            }] } });

class FSWCommentBoxInformationComponent {
    get dateFormat() {
        if (!this.updatedAt) {
            return '';
        }
        const current = new Date();
        const commentDate = new Date(this.updatedAt);
        if (current.getFullYear() === commentDate.getFullYear() &&
            current.getMonth() === commentDate.getMonth() &&
            current.getDate() === commentDate.getDate()) {
            return `Today`;
        }
        return this._datePipe.transform(`dd/MM/YYYY`) || '';
    }
    constructor(_datePipe) {
        this._datePipe = _datePipe;
        this.createdBy = null;
        this.updatedAt = null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCommentBoxInformationComponent, deps: [{ token: i1$1.DatePipe }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCommentBoxInformationComponent, selector: "fsw-comment-box-information", inputs: { createdBy: "createdBy", updatedAt: "updatedAt" }, providers: [DatePipe], ngImport: i0, template: "<div class=\"comment-box-information\">\n  <strong *ngIf=\"createdBy\">{{ createdBy }}</strong>\n  <span *ngIf=\"updatedAt\">{{ (updatedAt | date : 'hh:mm aa ') + dateFormat }}</span>\n</div>\n", styles: [":host .comment-box-information{display:flex;flex-direction:column}:host .comment-box-information>strong{font-weight:600;font-size:14px;line-height:1.5;font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;color:#222}:host .comment-box-information>strong:lang(th){font-weight:600;font-size:14px;line-height:1.5;font-family:Inter,Prompt,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif}:host .comment-box-information>span{font-weight:500;font-size:12px;line-height:1.5;font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;color:#adadad}:host .comment-box-information>span:lang(th){font-weight:500;font-size:12px;line-height:1.5;font-family:Inter,Prompt,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1$1.DatePipe, name: "date" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCommentBoxInformationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-comment-box-information', changeDetection: ChangeDetectionStrategy.OnPush, providers: [DatePipe], template: "<div class=\"comment-box-information\">\n  <strong *ngIf=\"createdBy\">{{ createdBy }}</strong>\n  <span *ngIf=\"updatedAt\">{{ (updatedAt | date : 'hh:mm aa ') + dateFormat }}</span>\n</div>\n", styles: [":host .comment-box-information{display:flex;flex-direction:column}:host .comment-box-information>strong{font-weight:600;font-size:14px;line-height:1.5;font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;color:#222}:host .comment-box-information>strong:lang(th){font-weight:600;font-size:14px;line-height:1.5;font-family:Inter,Prompt,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif}:host .comment-box-information>span{font-weight:500;font-size:12px;line-height:1.5;font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;color:#adadad}:host .comment-box-information>span:lang(th){font-weight:500;font-size:12px;line-height:1.5;font-family:Inter,Prompt,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.DatePipe }]; }, propDecorators: { createdBy: [{
                type: Input
            }], updatedAt: [{
                type: Input
            }] } });

class FSWCommentBoxActionsComponent {
    constructor() {
        this.editEvent = new EventEmitter();
        this.removeEvent = new EventEmitter();
        this.saveEvent = new EventEmitter();
        this.canEdit = true;
        this.canSave = true;
        this.canRemove = true;
        this.editButtonText = null;
        this.saveButtonText = null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCommentBoxActionsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCommentBoxActionsComponent, selector: "fsw-comment-box-actions", inputs: { canEdit: "canEdit", canSave: "canSave", canRemove: "canRemove", editButtonText: "editButtonText", saveButtonText: "saveButtonText" }, outputs: { editEvent: "editEvent", removeEvent: "removeEvent", saveEvent: "saveEvent" }, ngImport: i0, template: "<div class=\"comment-box-actions\">\n  <button\n    *ngIf=\"canRemove\"\n    class=\"comment-box-actions__remove\"\n    fswButton\n    [appearance]=\"'icon-with-bg'\"\n    [size]=\"'s'\"\n    (click)=\"removeEvent.emit()\"\n  >\n    <i [fswIcon]=\"'common-delete-alternative'\"></i>\n  </button>\n  <button *ngIf=\"canSave\" fswButton [size]=\"'s'\" (click)=\"saveEvent.emit()\">\n    {{ saveButtonText || 'Save' }}\n  </button>\n  <button\n    *ngIf=\"canEdit\"\n    fswButton\n    [appearance]=\"'secondary'\"\n    [size]=\"'s'\"\n    (click)=\"editEvent.emit()\"\n  >\n    {{ editButtonText || 'Edit' }}\n  </button>\n</div>\n", styles: [":host .comment-box-actions{display:flex;align-items:center;justify-content:space-between}:host .comment-box-actions__remove{--fsw-button-color: #ff2945;--fsw-button-hover-color: #ff2945;--fsw-button-active-color: #ff2945;--fsw-button-disabled-color: #ff2945;--fsw-button-background: #fae6e6;--fsw-button-active-background: #f5d7d7;--fsw-button-disabled-background: #fae6e6}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCommentBoxActionsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-comment-box-actions', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"comment-box-actions\">\n  <button\n    *ngIf=\"canRemove\"\n    class=\"comment-box-actions__remove\"\n    fswButton\n    [appearance]=\"'icon-with-bg'\"\n    [size]=\"'s'\"\n    (click)=\"removeEvent.emit()\"\n  >\n    <i [fswIcon]=\"'common-delete-alternative'\"></i>\n  </button>\n  <button *ngIf=\"canSave\" fswButton [size]=\"'s'\" (click)=\"saveEvent.emit()\">\n    {{ saveButtonText || 'Save' }}\n  </button>\n  <button\n    *ngIf=\"canEdit\"\n    fswButton\n    [appearance]=\"'secondary'\"\n    [size]=\"'s'\"\n    (click)=\"editEvent.emit()\"\n  >\n    {{ editButtonText || 'Edit' }}\n  </button>\n</div>\n", styles: [":host .comment-box-actions{display:flex;align-items:center;justify-content:space-between}:host .comment-box-actions__remove{--fsw-button-color: #ff2945;--fsw-button-hover-color: #ff2945;--fsw-button-active-color: #ff2945;--fsw-button-disabled-color: #ff2945;--fsw-button-background: #fae6e6;--fsw-button-active-background: #f5d7d7;--fsw-button-disabled-background: #fae6e6}\n"] }]
        }], propDecorators: { editEvent: [{
                type: Output
            }], removeEvent: [{
                type: Output
            }], saveEvent: [{
                type: Output
            }], canEdit: [{
                type: Input
            }], canSave: [{
                type: Input
            }], canRemove: [{
                type: Input
            }], editButtonText: [{
                type: Input
            }], saveButtonText: [{
                type: Input
            }] } });

const FSW_COMMENT_BOX_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    multi: true,
    useExisting: forwardRef(() => FSWCommentBoxComponent),
};
class FSWCommentBoxComponent {
    get canSave() {
        return !!this.formControl.value?.length && this.editable && !this.readOnly;
    }
    get canEdit() {
        return this.type === 'updating' && !this.editable && !this.readOnly;
    }
    get canRemove() {
        return this.type === 'updating' && !this.readOnly;
    }
    //#endregion Control Setup
    get typeOfThumbnail() {
        return this.config?.thumbnail ? 'thumbnail' : 'not-thumbnail';
    }
    constructor(_cdr) {
        this._cdr = _cdr;
        this.editableChange = new EventEmitter();
        this.editEvent = new EventEmitter();
        this.removeEvent = new EventEmitter();
        this.saveEvent = new EventEmitter();
        this.config = null;
        this.type = 'creating';
        this.editable = true;
        this.readOnly = false;
        this.showError = false;
        this.hasError = false;
        this.autoUpdateEditableWhenSave = false;
        this.errorText = null;
        this.editButtonText = null;
        this.saveButtonText = null;
        this.placeHolder = 'Please give your comment';
        this.formControl = new FormControl('');
        //#region Control Setup
        this._onTouched = () => {
            // Initial
        };
        this._onChange = () => {
            // Initial
        };
    }
    //#region Control Methods
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    writeValue(value) {
        if (!isEqual(value, this.formControl.value)) {
            this.formControl.setValue(value);
        }
        this._onChange(value);
        this._onTouched();
        this._cdr.markForCheck();
    }
    //#endregion Control Methods
    save() {
        if (this.autoUpdateEditableWhenSave) {
            this.updateEditable(false);
        }
        this.writeValue(this.formControl.value);
        this.saveEvent.emit(this.formControl.value);
        this._cdr.markForCheck();
    }
    edit() {
        this.updateEditable(true);
        this.editEvent.emit();
        this._cdr.markForCheck();
    }
    remove() {
        this.removeEvent.emit();
    }
    updateEditable(value) {
        this.editable = value;
        this.editableChange.emit(this.editable);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCommentBoxComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCommentBoxComponent, selector: "fsw-comment-box", inputs: { config: "config", type: "type", editable: "editable", readOnly: "readOnly", showError: "showError", hasError: "hasError", autoUpdateEditableWhenSave: "autoUpdateEditableWhenSave", errorText: "errorText", editButtonText: "editButtonText", saveButtonText: "saveButtonText", placeHolder: "placeHolder" }, outputs: { editableChange: "editableChange", editEvent: "editEvent", removeEvent: "removeEvent", saveEvent: "saveEvent" }, providers: [FSW_COMMENT_BOX_ACCESSOR], ngImport: i0, template: "<article class=\"comment-box\">\n  <header *ngIf=\"config\">\n    <fsw-comment-box-thumbnail\n      [thumbnail]=\"config?.thumbnail || config?.createdBy || null\"\n      [type]=\"typeOfThumbnail\"\n    ></fsw-comment-box-thumbnail>\n    <div class=\"comment-box__control\">\n      <fsw-comment-box-information\n        [createdBy]=\"config?.createdBy || null\"\n        [updatedAt]=\"config?.updatedAt || null\"\n      ></fsw-comment-box-information>\n    </div>\n  </header>\n  <main>\n    <fsw-field\n      [readOnly]=\"!editable || readOnly\"\n      [showError]=\"showError\"\n      [errorText]=\"errorText || ''\"\n      [fullWidth]=\"true\"\n    >\n      <ng-template fswFieldReadonly>\n        <p>{{ formControl.value }}</p>\n      </ng-template>\n      <textarea\n        fswInput\n        [hasError]=\"hasError\"\n        [placeholder]=\"placeHolder\"\n        [formControl]=\"formControl\"\n        rows=\"1\"\n      ></textarea>\n    </fsw-field>\n  </main>\n  <footer>\n    <fsw-comment-box-actions\n      *ngIf=\"!readOnly\"\n      [canEdit]=\"canEdit\"\n      [canRemove]=\"canRemove\"\n      [canSave]=\"canSave\"\n      (saveEvent)=\"save()\"\n      (editEvent)=\"edit()\"\n      (removeEvent)=\"remove()\"\n    ></fsw-comment-box-actions>\n  </footer>\n</article>\n", styles: [":host .comment-box{display:flex;flex-direction:column;gap:16px;padding:16px;background:#ffffff;box-shadow:0 2px 4px #0000001f;border-radius:8px;width:360px}:host .comment-box>header{display:flex;width:100%;align-items:center;gap:8px}:host .comment-box>main{min-height:36px;width:100%}:host .comment-box>main p{font-weight:500;font-size:16px;line-height:1.5;font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;color:#222;word-break:break-word}:host .comment-box>main p:lang(th){font-weight:500;font-size:16px;line-height:1.5;font-family:Inter,Prompt,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif}:host .comment-box>footer{width:100%}:host .comment-box__control{display:flex;align-items:center;justify-content:space-between;flex:1 1 0}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$4.FSWFieldReadonlyDirective, selector: "ng-template[fswFieldReadonly]" }, { kind: "directive", type: i1$4.FSWInputDirective, selector: "input[fswInput], textarea[fswInput]" }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: FSWCommentBoxThumbnailComponent, selector: "fsw-comment-box-thumbnail", inputs: ["thumbnail", "type"] }, { kind: "component", type: FSWCommentBoxInformationComponent, selector: "fsw-comment-box-information", inputs: ["createdBy", "updatedAt"] }, { kind: "component", type: FSWCommentBoxActionsComponent, selector: "fsw-comment-box-actions", inputs: ["canEdit", "canSave", "canRemove", "editButtonText", "saveButtonText"], outputs: ["editEvent", "removeEvent", "saveEvent"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCommentBoxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-comment-box', changeDetection: ChangeDetectionStrategy.OnPush, providers: [FSW_COMMENT_BOX_ACCESSOR], template: "<article class=\"comment-box\">\n  <header *ngIf=\"config\">\n    <fsw-comment-box-thumbnail\n      [thumbnail]=\"config?.thumbnail || config?.createdBy || null\"\n      [type]=\"typeOfThumbnail\"\n    ></fsw-comment-box-thumbnail>\n    <div class=\"comment-box__control\">\n      <fsw-comment-box-information\n        [createdBy]=\"config?.createdBy || null\"\n        [updatedAt]=\"config?.updatedAt || null\"\n      ></fsw-comment-box-information>\n    </div>\n  </header>\n  <main>\n    <fsw-field\n      [readOnly]=\"!editable || readOnly\"\n      [showError]=\"showError\"\n      [errorText]=\"errorText || ''\"\n      [fullWidth]=\"true\"\n    >\n      <ng-template fswFieldReadonly>\n        <p>{{ formControl.value }}</p>\n      </ng-template>\n      <textarea\n        fswInput\n        [hasError]=\"hasError\"\n        [placeholder]=\"placeHolder\"\n        [formControl]=\"formControl\"\n        rows=\"1\"\n      ></textarea>\n    </fsw-field>\n  </main>\n  <footer>\n    <fsw-comment-box-actions\n      *ngIf=\"!readOnly\"\n      [canEdit]=\"canEdit\"\n      [canRemove]=\"canRemove\"\n      [canSave]=\"canSave\"\n      (saveEvent)=\"save()\"\n      (editEvent)=\"edit()\"\n      (removeEvent)=\"remove()\"\n    ></fsw-comment-box-actions>\n  </footer>\n</article>\n", styles: [":host .comment-box{display:flex;flex-direction:column;gap:16px;padding:16px;background:#ffffff;box-shadow:0 2px 4px #0000001f;border-radius:8px;width:360px}:host .comment-box>header{display:flex;width:100%;align-items:center;gap:8px}:host .comment-box>main{min-height:36px;width:100%}:host .comment-box>main p{font-weight:500;font-size:16px;line-height:1.5;font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;color:#222;word-break:break-word}:host .comment-box>main p:lang(th){font-weight:500;font-size:16px;line-height:1.5;font-family:Inter,Prompt,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif}:host .comment-box>footer{width:100%}:host .comment-box__control{display:flex;align-items:center;justify-content:space-between;flex:1 1 0}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { editableChange: [{
                type: Output
            }], editEvent: [{
                type: Output
            }], removeEvent: [{
                type: Output
            }], saveEvent: [{
                type: Output
            }], config: [{
                type: Input
            }], type: [{
                type: Input
            }], editable: [{
                type: Input
            }], readOnly: [{
                type: Input
            }], showError: [{
                type: Input
            }], hasError: [{
                type: Input
            }], autoUpdateEditableWhenSave: [{
                type: Input
            }], errorText: [{
                type: Input
            }], editButtonText: [{
                type: Input
            }], saveButtonText: [{
                type: Input
            }], placeHolder: [{
                type: Input
            }] } });

const UI = [
    FSWCommentBoxThumbnailComponent,
    FSWCommentBoxInformationComponent,
    FSWCommentBoxActionsComponent,
];
class FSWCommentBoxModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCommentBoxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWCommentBoxModule, declarations: [FSWCommentBoxComponent, FSWCommentBoxThumbnailComponent,
            FSWCommentBoxInformationComponent,
            FSWCommentBoxActionsComponent], imports: [NgIf,
            DatePipe,
            FSWFieldModule,
            FSWInputModule,
            ReactiveFormsModule,
            FormsModule,
            FSWIconModule,
            FSWButtonModule], exports: [FSWCommentBoxComponent, FSWCommentBoxThumbnailComponent,
            FSWCommentBoxInformationComponent,
            FSWCommentBoxActionsComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCommentBoxModule, imports: [FSWFieldModule,
            FSWInputModule,
            ReactiveFormsModule,
            FormsModule,
            FSWIconModule,
            FSWButtonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCommentBoxModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FSWCommentBoxComponent, UI],
                    imports: [
                        NgIf,
                        DatePipe,
                        FSWFieldModule,
                        FSWInputModule,
                        ReactiveFormsModule,
                        FormsModule,
                        FSWIconModule,
                        FSWButtonModule,
                    ],
                    exports: [FSWCommentBoxComponent, UI],
                }]
        }] });

const DRAWER_HOST_ID = new InjectionToken('DRAWER_HOST_ID');

const DRAWER_HOST_SERVICE = new InjectionToken('DRAWER_HOST_SERVICE');

const DRAWER_SERVICE = new InjectionToken('DRAWER_SERVICE');

const DRAWER_ARRAY = new InjectionToken('DRAWER_ARRAY');

const DRAWER_CONTEXT = new InjectionToken('DRAWER_CONTEXT');

const DRAWER_ITEM = new InjectionToken('DRAWER_ITEM');

const DRAWER_BACKDROP_CLICK = new InjectionToken('DRAWER_BACKDROP_CLICK');

var DrawerSizes;
(function (DrawerSizes) {
    DrawerSizes["S"] = "s";
    DrawerSizes["M"] = "m";
    DrawerSizes["L"] = "l";
    DrawerSizes["CUSTOM"] = "custom";
})(DrawerSizes || (DrawerSizes = {}));

var DrawerPositions;
(function (DrawerPositions) {
    DrawerPositions["TOP"] = "top";
    DrawerPositions["RIGHT"] = "right";
    DrawerPositions["BOTTOM"] = "bottom";
    DrawerPositions["LEFT"] = "left";
})(DrawerPositions || (DrawerPositions = {}));

var DrawerStyles;
(function (DrawerStyles) {
    DrawerStyles[DrawerStyles["INITIAL"] = 0] = "INITIAL";
    DrawerStyles[DrawerStyles["CUSTOM"] = 1] = "CUSTOM";
})(DrawerStyles || (DrawerStyles = {}));

class DrawerService {
    constructor(_hostService) {
        this._hostService = _hostService;
    }
    open(content, options = {}) {
        return new Observable((observer) => {
            const defaultOptions = {
                style: DrawerStyles.INITIAL,
                size: DrawerSizes.M,
                position: DrawerPositions.RIGHT,
                closeable: true,
            };
            this._hostService.createHost();
            const id = v4();
            const zIndex = this._hostService.getNextIndex();
            const context = {
                ...defaultOptions,
                ...options,
                zIndex,
                completeWith: (output) => {
                    this._hostService.remove(id);
                    observer.next(output);
                    observer.complete();
                },
            };
            const item = {
                id,
                context,
                content,
            };
            this._hostService.push(item);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DrawerService, deps: [{ token: DRAWER_HOST_SERVICE }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DrawerService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DrawerService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DRAWER_HOST_SERVICE]
                }] }]; } });

class DrawerItemDirective {
    constructor(_injector, _viewContainerRef, _resolver) {
        this._injector = _injector;
        this._viewContainerRef = _viewContainerRef;
        this._resolver = _resolver;
        this.context = null;
        this.content = null;
    }
    ngOnInit() {
        if (!this.content)
            return;
        const factoryResolver = this._resolver.resolveComponentFactory(this.content);
        const injector = Injector.create({
            parent: this._injector,
            providers: [
                {
                    provide: DRAWER_CONTEXT,
                    useValue: this.context,
                },
            ],
        });
        this._viewContainerRef.createComponent(factoryResolver, 0, injector);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DrawerItemDirective, deps: [{ token: i0.Injector }, { token: i0.ViewContainerRef }, { token: i0.ComponentFactoryResolver }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: DrawerItemDirective, selector: "ng-container[fswDrawerItem]", inputs: { context: "context", content: "content" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DrawerItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-container[fswDrawerItem]',
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }, { type: i0.ViewContainerRef }, { type: i0.ComponentFactoryResolver }]; }, propDecorators: { context: [{
                type: Input
            }], content: [{
                type: Input
            }] } });

class DrawerComponent {
    constructor(item, backdropClick$, cdr) {
        this.item = item;
        this.backdropClick$ = backdropClick$;
        this.cdr = cdr;
        this.DrawerStyles = DrawerStyles;
        this.endAnimation = false;
        if (item.context.closeable) {
            this.backdropClick$.pipe(tap(() => this.close())).subscribe();
        }
    }
    close() {
        this.complete(undefined);
    }
    complete(data) {
        this.endAnimation = true;
        this.cdr.markForCheck();
        setTimeout(() => {
            this.item.context.completeWith(data);
        }, 300);
    }
    setLabel(label) {
        this.item.context.label = label;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DrawerComponent, deps: [{ token: DRAWER_ITEM }, { token: DRAWER_BACKDROP_CLICK }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DrawerComponent, selector: "fsw-drawer", ngImport: i0, template: "<div\n\tclass=\"wrapper-drawer wrapper-drawer--size-{{ item.context.size }} wrapper-drawer--position-{{\n\t\titem.context.position\n\t}}\"\n\t[style.zIndex]=\"item.context.zIndex\"\n\t[class.end-animation]=\"endAnimation\"\n\t[style.--fsw-drawer-size]=\"item.context.customSize\"\n>\n\t<header *ngIf=\"item.context.style === DrawerStyles.INITIAL\">\n\t\t<h5>{{ item.context.label }}</h5>\n\t\t<i class=\"fa fa-times\" (click)=\"close()\"></i>\n\t</header>\n\t<main>\n\t\t<ng-container fswDrawerItem [context]=\"item.context\" [content]=\"item.content\"></ng-container>\n\t</main>\n</div>\n", styles: [":host .wrapper-drawer{position:absolute;display:flex;flex-direction:column;overflow:hidden;background:#ffffff;box-shadow:0 8px 16px #00000014;--fsw-drawer-size: 0px;--fsw-drawer-top-with: 0px;--fsw-drawer-bottom-with: 1px}:host .wrapper-drawer--size-s{--fsw-drawer-size: 464px}:host .wrapper-drawer--size-m{--fsw-drawer-size: 640px}:host .wrapper-drawer--size-l{--fsw-drawer-size: 960px}:host .wrapper-drawer--position-top{top:0;left:0;flex-direction:column-reverse;height:var(--fsw-drawer-size);--fsw-drawer-top-with: 1px;--fsw-drawer-bottom-with: 0px;width:100vw;animation-name:to-top;animation-duration:.3s}:host .wrapper-drawer--position-top.end-animation{animation-name:from-top}:host .wrapper-drawer--position-top i{bottom:24px}:host .wrapper-drawer--position-right{top:0;right:0;height:100vh;width:var(--fsw-drawer-size);animation-name:to-right;animation-duration:.3s}:host .wrapper-drawer--position-right.end-animation{animation-name:from-right}:host .wrapper-drawer--position-right i{top:24px}:host .wrapper-drawer--position-left{top:0;left:0;height:100vh;width:var(--fsw-drawer-size);animation-name:to-left;animation-duration:.3s}:host .wrapper-drawer--position-left.end-animation{animation-name:from-left}:host .wrapper-drawer--position-left i{top:24px}:host .wrapper-drawer--position-bottom{bottom:0;left:0;height:var(--fsw-drawer-size);width:100vw;animation-name:to-bottom;animation-duration:.3s}:host .wrapper-drawer--position-bottom.end-animation{animation-name:from-bottom}:host .wrapper-drawer>header{width:100%;display:flex;align-items:flex-end;padding:16px;border-bottom:var(--fsw-drawer-bottom-with) solid #e0e0e0;border-top:var(--fsw-drawer-top-with) solid #e0e0e0}:host .wrapper-drawer>header i{position:absolute;right:24px;cursor:pointer;font-size:24px}:host .wrapper-drawer>header h5{height:34px}:host .wrapper-drawer>main{padding:16px}@keyframes to-left{0%{transform:translate(-100%)}to{transform:translateY(0)}}@keyframes to-bottom{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes to-right{0%{transform:translate(100%)}to{transform:translateY(0)}}@keyframes to-top{0%{transform:translateY(-100%)}to{transform:translateY(0)}}@keyframes from-left{to{transform:translate(-100%)}0%{transform:translateY(0)}}@keyframes from-bottom{to{transform:translateY(100%)}0%{transform:translateY(0)}}@keyframes from-right{to{transform:translate(100%)}0%{transform:translateY(0)}}@keyframes from-top{to{transform:translateY(-100%)}0%{transform:translateY(0)}}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: DrawerItemDirective, selector: "ng-container[fswDrawerItem]", inputs: ["context", "content"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DrawerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-drawer', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n\tclass=\"wrapper-drawer wrapper-drawer--size-{{ item.context.size }} wrapper-drawer--position-{{\n\t\titem.context.position\n\t}}\"\n\t[style.zIndex]=\"item.context.zIndex\"\n\t[class.end-animation]=\"endAnimation\"\n\t[style.--fsw-drawer-size]=\"item.context.customSize\"\n>\n\t<header *ngIf=\"item.context.style === DrawerStyles.INITIAL\">\n\t\t<h5>{{ item.context.label }}</h5>\n\t\t<i class=\"fa fa-times\" (click)=\"close()\"></i>\n\t</header>\n\t<main>\n\t\t<ng-container fswDrawerItem [context]=\"item.context\" [content]=\"item.content\"></ng-container>\n\t</main>\n</div>\n", styles: [":host .wrapper-drawer{position:absolute;display:flex;flex-direction:column;overflow:hidden;background:#ffffff;box-shadow:0 8px 16px #00000014;--fsw-drawer-size: 0px;--fsw-drawer-top-with: 0px;--fsw-drawer-bottom-with: 1px}:host .wrapper-drawer--size-s{--fsw-drawer-size: 464px}:host .wrapper-drawer--size-m{--fsw-drawer-size: 640px}:host .wrapper-drawer--size-l{--fsw-drawer-size: 960px}:host .wrapper-drawer--position-top{top:0;left:0;flex-direction:column-reverse;height:var(--fsw-drawer-size);--fsw-drawer-top-with: 1px;--fsw-drawer-bottom-with: 0px;width:100vw;animation-name:to-top;animation-duration:.3s}:host .wrapper-drawer--position-top.end-animation{animation-name:from-top}:host .wrapper-drawer--position-top i{bottom:24px}:host .wrapper-drawer--position-right{top:0;right:0;height:100vh;width:var(--fsw-drawer-size);animation-name:to-right;animation-duration:.3s}:host .wrapper-drawer--position-right.end-animation{animation-name:from-right}:host .wrapper-drawer--position-right i{top:24px}:host .wrapper-drawer--position-left{top:0;left:0;height:100vh;width:var(--fsw-drawer-size);animation-name:to-left;animation-duration:.3s}:host .wrapper-drawer--position-left.end-animation{animation-name:from-left}:host .wrapper-drawer--position-left i{top:24px}:host .wrapper-drawer--position-bottom{bottom:0;left:0;height:var(--fsw-drawer-size);width:100vw;animation-name:to-bottom;animation-duration:.3s}:host .wrapper-drawer--position-bottom.end-animation{animation-name:from-bottom}:host .wrapper-drawer>header{width:100%;display:flex;align-items:flex-end;padding:16px;border-bottom:var(--fsw-drawer-bottom-with) solid #e0e0e0;border-top:var(--fsw-drawer-top-with) solid #e0e0e0}:host .wrapper-drawer>header i{position:absolute;right:24px;cursor:pointer;font-size:24px}:host .wrapper-drawer>header h5{height:34px}:host .wrapper-drawer>main{padding:16px}@keyframes to-left{0%{transform:translate(-100%)}to{transform:translateY(0)}}@keyframes to-bottom{0%{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes to-right{0%{transform:translate(100%)}to{transform:translateY(0)}}@keyframes to-top{0%{transform:translateY(-100%)}to{transform:translateY(0)}}@keyframes from-left{to{transform:translate(-100%)}0%{transform:translateY(0)}}@keyframes from-bottom{to{transform:translateY(100%)}0%{transform:translateY(0)}}@keyframes from-right{to{transform:translate(100%)}0%{transform:translateY(0)}}@keyframes from-top{to{transform:translateY(-100%)}0%{transform:translateY(0)}}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DRAWER_ITEM]
                }] }, { type: i3.Subject, decorators: [{
                    type: Inject,
                    args: [DRAWER_BACKDROP_CLICK]
                }] }, { type: i0.ChangeDetectorRef }]; } });

class DrawerHostItemDirective {
    constructor(_injector, _viewContainerRef, _resolver) {
        this._injector = _injector;
        this._viewContainerRef = _viewContainerRef;
        this._resolver = _resolver;
        this.item = null;
        this.backDropClick$ = new Subject();
    }
    ngOnInit() {
        if (!this.item)
            return;
        const factoryResolver = this._resolver.resolveComponentFactory(DrawerComponent);
        const injector = Injector.create({
            parent: this.item.context.injector || this._injector,
            providers: [
                {
                    provide: DRAWER_ITEM,
                    useValue: this.item,
                },
                {
                    provide: DRAWER_BACKDROP_CLICK,
                    useValue: this.backDropClick$,
                },
            ],
        });
        this._viewContainerRef.createComponent(factoryResolver, 0, injector);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DrawerHostItemDirective, deps: [{ token: i0.Injector }, { token: i0.ViewContainerRef }, { token: i0.ComponentFactoryResolver }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: DrawerHostItemDirective, selector: "ng-container[fswDrawerHostItem]", inputs: { item: "item", backDropClick$: "backDropClick$" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DrawerHostItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-container[fswDrawerHostItem]',
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }, { type: i0.ViewContainerRef }, { type: i0.ComponentFactoryResolver }]; }, propDecorators: { item: [{
                type: Input
            }], backDropClick$: [{
                type: Input
            }] } });

class DrawerHostComponent {
    constructor() {
        this.array$ = inject(DRAWER_ARRAY, { optional: true });
        this.arrayListen$ = this.array$ ? this.array$.asObservable() : of([]);
        this.backDropClick$ = new Subject();
    }
    clickBackDrop() {
        this.backDropClick$.next(undefined);
        this.backDropClick$.complete();
        this.backDropClick$ = new Subject();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DrawerHostComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DrawerHostComponent, selector: "fsw-drawer-host", ngImport: i0, template: "<ng-container *ngIf=\"arrayListen$ | async as array\">\n\t<div class=\"wrapper-drawer-host\" [class.none]=\"!array.length\">\n\t\t<div class=\"wrapper-drawer-host__backdrop\" (click)=\"clickBackDrop()\"></div>\n\t\t<ng-container *ngFor=\"let item of array\">\n\t\t\t<ng-container\n\t\t\t\tfswDrawerHostItem\n\t\t\t\t[backDropClick$]=\"backDropClick$\"\n\t\t\t\t[item]=\"item\"\n\t\t\t></ng-container>\n\t\t</ng-container>\n\t</div>\n</ng-container>\n", styles: [":host .wrapper-drawer-host{position:fixed;top:0;left:0;width:100vw;height:100vh;transition-property:bottom,width,height}:host .wrapper-drawer-host.none{transition-delay:.5s;bottom:0;width:0;height:0}:host .wrapper-drawer-host__backdrop{position:absolute;top:0;left:0;background:#e5e5e5;width:100%;height:100%;z-index:999;opacity:.7}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: DrawerHostItemDirective, selector: "ng-container[fswDrawerHostItem]", inputs: ["item", "backDropClick$"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DrawerHostComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-drawer-host', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"arrayListen$ | async as array\">\n\t<div class=\"wrapper-drawer-host\" [class.none]=\"!array.length\">\n\t\t<div class=\"wrapper-drawer-host__backdrop\" (click)=\"clickBackDrop()\"></div>\n\t\t<ng-container *ngFor=\"let item of array\">\n\t\t\t<ng-container\n\t\t\t\tfswDrawerHostItem\n\t\t\t\t[backDropClick$]=\"backDropClick$\"\n\t\t\t\t[item]=\"item\"\n\t\t\t></ng-container>\n\t\t</ng-container>\n\t</div>\n</ng-container>\n", styles: [":host .wrapper-drawer-host{position:fixed;top:0;left:0;width:100vw;height:100vh;transition-property:bottom,width,height}:host .wrapper-drawer-host.none{transition-delay:.5s;bottom:0;width:0;height:0}:host .wrapper-drawer-host__backdrop{position:absolute;top:0;left:0;background:#e5e5e5;width:100%;height:100%;z-index:999;opacity:.7}\n"] }]
        }] });

class DrawerHostService {
    get host() {
        return this._host;
    }
    get isHostExisted() {
        return !!this.host;
    }
    constructor(_dom, _hostId, _array$, _injector, _appRef, _resolver) {
        this._dom = _dom;
        this._hostId = _hostId;
        this._array$ = _array$;
        this._injector = _injector;
        this._appRef = _appRef;
        this._resolver = _resolver;
        this._host = null;
        this._body = this._dom.body;
        this._initialHost();
        this._item$ = this._array$ ? this._array$ : new BehaviorSubject([]);
    }
    createHost() {
        if (this.isHostExisted)
            return;
        const injector = Injector.create({
            parent: this._injector,
            providers: [
                {
                    provide: DRAWER_ARRAY,
                    useValue: this._item$,
                },
            ],
        });
        const componentRef = this.createComponentRef(DrawerHostComponent, injector);
        const element = this.getHostViewElement(componentRef.hostView);
        element.id = this._hostId;
        this.appendTo(element);
        this._host = element;
    }
    createComponentRef(component, injector) {
        const factoryResolver = this._resolver.resolveComponentFactory(component);
        const componentRef = factoryResolver.create(injector);
        this.attachHostView(componentRef.hostView);
        return componentRef;
    }
    push(item) {
        const { value } = this._item$;
        value.push(item);
        this._item$.next(value);
    }
    remove(id) {
        this._item$.next(this._item$.value.filter((e) => e.id !== id));
    }
    getNextIndex() {
        const zIndex = 1000;
        if (!this.isHostExisted)
            return zIndex;
        const length = this.host.childNodes.length;
        return zIndex + length;
    }
    appendTo(element, parent = this._body) {
        parent.appendChild(element);
    }
    attachHostView(hostView) {
        this._appRef.attachView(hostView);
    }
    getHostViewElement(hostView) {
        const embeddedViewRef = hostView;
        return embeddedViewRef.rootNodes[0];
    }
    _initialHost() {
        const existHost = this._dom.getElementById(this._hostId);
        if (!existHost)
            return;
        this._host = existHost;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DrawerHostService, deps: [{ token: DOCUMENT }, { token: DRAWER_HOST_ID }, { token: DRAWER_ARRAY, optional: true }, { token: i0.Injector }, { token: i0.ApplicationRef }, { token: i0.ComponentFactoryResolver }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DrawerHostService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DrawerHostService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DRAWER_HOST_ID]
                }] }, { type: i3.BehaviorSubject, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [DRAWER_ARRAY]
                }] }, { type: i0.Injector }, { type: i0.ApplicationRef }, { type: i0.ComponentFactoryResolver }]; } });

class FSWDrawerModule {
    static custom(custom) {
        const providers = [];
        const { service, hostService } = custom;
        if (hostService) {
            providers.push({
                provide: DRAWER_HOST_SERVICE,
                useClass: hostService,
            });
        }
        if (service) {
            providers.push({
                provide: DRAWER_SERVICE,
                useClass: service,
            });
        }
        return {
            ngModule: FSWDrawerModule,
            providers,
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDrawerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWDrawerModule, declarations: [DrawerHostComponent,
            DrawerComponent,
            DrawerItemDirective,
            DrawerHostItemDirective], imports: [CommonModule, LetDirective], exports: [DrawerComponent, DrawerHostComponent, DrawerItemDirective, DrawerHostItemDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDrawerModule, providers: [
            {
                provide: DRAWER_HOST_ID,
                useValue: 'fsw-drawer-host',
            },
            {
                provide: DRAWER_HOST_SERVICE,
                useClass: DrawerHostService,
            },
            {
                provide: DRAWER_SERVICE,
                useClass: DrawerService,
            },
        ], imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDrawerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, LetDirective],
                    declarations: [
                        DrawerHostComponent,
                        DrawerComponent,
                        DrawerItemDirective,
                        DrawerHostItemDirective,
                    ],
                    exports: [DrawerComponent, DrawerHostComponent, DrawerItemDirective, DrawerHostItemDirective],
                    providers: [
                        {
                            provide: DRAWER_HOST_ID,
                            useValue: 'fsw-drawer-host',
                        },
                        {
                            provide: DRAWER_HOST_SERVICE,
                            useClass: DrawerHostService,
                        },
                        {
                            provide: DRAWER_SERVICE,
                            useClass: DrawerService,
                        },
                    ],
                }]
        }] });

class FSWMeetCountryDirective {
    set countryCode(value) {
        if (!value) {
            this.showView();
            return;
        }
        if (value === getCountryCodeFromStorage()) {
            this.showView();
        }
        else {
            this.hideView();
        }
    }
    constructor(_templateRef, _viewContainer) {
        this._templateRef = _templateRef;
        this._viewContainer = _viewContainer;
        this._hasView = false;
    }
    showView() {
        if (!this._hasView) {
            this._hasView = true;
            this._viewContainer.createEmbeddedView(this._templateRef);
        }
    }
    hideView() {
        if (this._hasView) {
            this._hasView = false;
            this._viewContainer.clear();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWMeetCountryDirective, deps: [{ token: i0.TemplateRef }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWMeetCountryDirective, isStandalone: true, selector: "[fswMeetCountry]", inputs: { countryCode: ["fswMeetCountry", "countryCode"] }, exportAs: ["meetCountry"], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWMeetCountryDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswMeetCountry]',
                    exportAs: 'meetCountry',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }, { type: i0.ViewContainerRef }]; }, propDecorators: { countryCode: [{
                type: Input,
                args: ['fswMeetCountry']
            }] } });

var FSWViewerPosition;
(function (FSWViewerPosition) {
    FSWViewerPosition["TOP"] = "top";
    FSWViewerPosition["BOTTOM"] = "bottom";
    FSWViewerPosition["LEFT"] = "left";
    FSWViewerPosition["RIGHT"] = "right";
})(FSWViewerPosition || (FSWViewerPosition = {}));

class FSWViewerDirective {
    constructor() {
        this.position = FSWViewerPosition.RIGHT;
        this.size = '600px';
        this.renderer = inject(Renderer2);
        this.elementRef = inject(ElementRef);
        this.dom = inject(DOCUMENT);
        this.refresher$ = new Subject();
        this.startSize = 0;
        this.startPosition = 0;
        this.startResizing = false;
    }
    get isHorizontal() {
        return this.position === FSWViewerPosition.LEFT || this.position === FSWViewerPosition.RIGHT;
    }
    get isVertical() {
        return this.position === FSWViewerPosition.TOP || this.position === FSWViewerPosition.BOTTOM;
    }
    ngOnChanges() {
        this.updateSize(this.size);
        this.mouseup();
    }
    updateSize(px) {
        this.renderer.setProperty(this.target, 'style', `--fsw-viewer-size : ${px}`);
    }
    mousedown(event) {
        const { clientX, clientY } = event;
        this.renderer.addClass(this.elementRef.nativeElement, 'resizing');
        this.startSize = this.isHorizontal ? this.target.offsetWidth : this.target.offsetHeight;
        this.startPosition = this.isHorizontal ? clientX : clientY;
        this.startResizing = true;
        this.dom.addEventListener('mouseup', () => this.mouseup());
        this.dom.addEventListener('mouseleave', () => this.mouseup());
        this.dom.addEventListener('mousemove', (event) => this.mousemove(event));
    }
    mouseup() {
        if (!this.startResizing)
            return;
        if (this.elementRef.nativeElement.classList.contains('resizing')) {
            this.renderer.removeClass(this.elementRef.nativeElement, 'resizing');
        }
        this.startResizing = false;
        this.startSize = 0;
        this.startPosition = 0;
        this.refresher$.next(new Date());
        this.dom.removeEventListener('mouseup', () => this.mouseup());
        this.dom.removeEventListener('mouseleave', () => this.mouseup());
        this.dom.removeEventListener('mousemove', (event) => this.mousemove(event));
    }
    mousemove(event) {
        if (!this.startResizing)
            return;
        const { clientX, clientY } = event;
        switch (this.position) {
            case FSWViewerPosition.TOP:
                this.updateSize(`${this.startSize + (clientY - this.startPosition)}px`);
                break;
            case FSWViewerPosition.BOTTOM:
                this.updateSize(`${this.startSize + (this.startPosition - clientY)}px`);
                break;
            case FSWViewerPosition.LEFT:
                this.updateSize(`${this.startSize + (clientX - this.startPosition)}px`);
                break;
            case FSWViewerPosition.RIGHT:
                this.updateSize(`${this.startSize + (this.startPosition - clientX)}px`);
                break;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWViewerDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWViewerDirective, selector: "[fswViewer]", inputs: { position: "position", size: "size", target: ["fswViewer", "target"] }, host: { listeners: { "mousedown": "mousedown($event)" } }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWViewerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswViewer]',
                }]
        }], propDecorators: { position: [{
                type: Input
            }], size: [{
                type: Input
            }], target: [{
                type: Input,
                args: ['fswViewer']
            }], mousedown: [{
                type: HostListener,
                args: ['mousedown', ['$event']]
            }] } });

class FSWViewerComponent {
    constructor() {
        this.sizeSignal = signal('');
        this.positionSignal = signal(FSWViewerPosition.BOTTOM);
    }
    updatePosition(position) {
        this.positionSignal.set(position);
    }
    updateSize(size) {
        this.sizeSignal.set(size);
    }
    close() {
        // will be overriden by the service
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWViewerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWViewerComponent, selector: "fsw-viewer", ngImport: i0, template: `
    <section class="fsw-viewer fsw-viewer--{{ positionSignal() }}" #target>
      <div
        class="fsw-viewer-handler fsw-viewer-handler--{{ positionSignal() }}"
        [fswViewer]="target"
        [position]="positionSignal()"
        [size]="sizeSignal()"
      ></div>
    </section>
  `, isInline: true, styles: [":host{display:contents}:host .fsw-viewer{--fsw-viewer-size: 600px;position:fixed;z-index:999;overflow:auto;background-color:rgba(var(--fsw-color-white-00-rgba-r),var(--fsw-color-white-00-rgba-g),var(--fsw-color-white-00-rgba-b),var(--fsw-color-white-00-rgba-a))}:host .fsw-viewer--top{top:0;left:0;width:100vw;height:var(--fsw-viewer-size)}:host .fsw-viewer--bottom{left:0;bottom:0;width:100vw;height:var(--fsw-viewer-size)}:host .fsw-viewer--left{left:0;top:0;height:100vh;width:var(--fsw-viewer-size)}:host .fsw-viewer--right{right:0;top:0;height:100vh;width:var(--fsw-viewer-size)}:host .fsw-viewer-handler{position:absolute;--tw-bg-opacity: 1;background-color:rgba(var(--fsw-color-gray-100-rgba-r),var(--fsw-color-gray-100-rgba-g),var(--fsw-color-gray-100-rgba-b),var(--tw-bg-opacity));transition-duration:.1s;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-property:background}:host .fsw-viewer-handler--top{bottom:0;left:0;height:.25rem;width:100%}:host .fsw-viewer-handler--top:hover{cursor:row-resize}:host .fsw-viewer-handler--bottom{top:0;left:0;height:.25rem;width:100%}:host .fsw-viewer-handler--bottom:hover{cursor:row-resize}:host .fsw-viewer-handler--left{top:0;right:0;height:100%;width:.25rem}:host .fsw-viewer-handler--left:hover{cursor:col-resize}:host .fsw-viewer-handler--right{top:0;left:0;height:100%;width:.25rem}:host .fsw-viewer-handler--right:hover{cursor:col-resize}:host .fsw-viewer-handler.resizing{--tw-bg-opacity: 1;background-color:rgba(var(--fsw-color-blue-300-rgba-r),var(--fsw-color-blue-300-rgba-g),var(--fsw-color-blue-300-rgba-b),var(--tw-bg-opacity))}\n"], dependencies: [{ kind: "directive", type: FSWViewerDirective, selector: "[fswViewer]", inputs: ["position", "size", "fswViewer"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWViewerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-viewer', template: `
    <section class="fsw-viewer fsw-viewer--{{ positionSignal() }}" #target>
      <div
        class="fsw-viewer-handler fsw-viewer-handler--{{ positionSignal() }}"
        [fswViewer]="target"
        [position]="positionSignal()"
        [size]="sizeSignal()"
      ></div>
    </section>
  `, changeDetection: ChangeDetectionStrategy.OnPush, styles: [":host{display:contents}:host .fsw-viewer{--fsw-viewer-size: 600px;position:fixed;z-index:999;overflow:auto;background-color:rgba(var(--fsw-color-white-00-rgba-r),var(--fsw-color-white-00-rgba-g),var(--fsw-color-white-00-rgba-b),var(--fsw-color-white-00-rgba-a))}:host .fsw-viewer--top{top:0;left:0;width:100vw;height:var(--fsw-viewer-size)}:host .fsw-viewer--bottom{left:0;bottom:0;width:100vw;height:var(--fsw-viewer-size)}:host .fsw-viewer--left{left:0;top:0;height:100vh;width:var(--fsw-viewer-size)}:host .fsw-viewer--right{right:0;top:0;height:100vh;width:var(--fsw-viewer-size)}:host .fsw-viewer-handler{position:absolute;--tw-bg-opacity: 1;background-color:rgba(var(--fsw-color-gray-100-rgba-r),var(--fsw-color-gray-100-rgba-g),var(--fsw-color-gray-100-rgba-b),var(--tw-bg-opacity));transition-duration:.1s;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-property:background}:host .fsw-viewer-handler--top{bottom:0;left:0;height:.25rem;width:100%}:host .fsw-viewer-handler--top:hover{cursor:row-resize}:host .fsw-viewer-handler--bottom{top:0;left:0;height:.25rem;width:100%}:host .fsw-viewer-handler--bottom:hover{cursor:row-resize}:host .fsw-viewer-handler--left{top:0;right:0;height:100%;width:.25rem}:host .fsw-viewer-handler--left:hover{cursor:col-resize}:host .fsw-viewer-handler--right{top:0;left:0;height:100%;width:.25rem}:host .fsw-viewer-handler--right:hover{cursor:col-resize}:host .fsw-viewer-handler.resizing{--tw-bg-opacity: 1;background-color:rgba(var(--fsw-color-blue-300-rgba-r),var(--fsw-color-blue-300-rgba-g),var(--fsw-color-blue-300-rgba-b),var(--tw-bg-opacity))}\n"] }]
        }] });

class FSWViewerService {
    constructor() {
        this.dom = inject(DOCUMENT);
        this.applicationService = inject(FSW_APPLICATION_SERVICE_TOKEN);
    }
    static { this.ID = 'fsw-viewer'; }
    open(component, metadata, config = {}) {
        const { container, parent } = this._createHost(config);
        const injector = this.applicationService.createInjector([
            {
                provide: FSWViewerComponent,
                useValue: parent,
            },
        ]);
        const ref = this.applicationService.createComponentRef(component, injector);
        const instance = ref.instance;
        instance.metadata = metadata;
        const element = this.applicationService.getHostViewElement(ref.hostView);
        this.applicationService.appendTo(element, container);
        ref.changeDetectorRef.detectChanges();
    }
    _createHost(config = {}) {
        const existed = this.dom.getElementById(FSWViewerService.ID);
        if (existed) {
            this.applicationService.removeFrom(existed, this.dom.body);
        }
        const { position, size, destroyWhen$ } = this._parseConfig(config);
        const ref = this.applicationService.createComponentRef(FSWViewerComponent);
        const element = this.applicationService.getHostViewElement(ref.hostView);
        ref.instance.close = () => {
            this.applicationService.detachHostView(ref.hostView);
            this.applicationService.removeFrom(element, this.dom.body);
        };
        ref.instance.updatePosition(position);
        ref.instance.updateSize(size);
        if (destroyWhen$) {
            destroyWhen$
                .pipe(take(1), tap(() => {
                ref.instance.close();
            }))
                .subscribe();
        }
        element.id = FSWViewerService.ID;
        this.applicationService.appendTo(element, this.dom.body);
        ref.changeDetectorRef.detectChanges();
        return {
            container: element.querySelector('.fsw-viewer'),
            parent: ref.instance,
        };
    }
    _parseConfig(config) {
        return {
            ...config,
            position: config?.position ?? FSWViewerPosition.RIGHT,
            size: config?.size ?? '600px',
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWViewerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWViewerService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWViewerService, decorators: [{
            type: Injectable
        }] });

const DECLARATIONS$1 = [FSWViewerComponent, FSWViewerDirective];
class FSWViewerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWViewerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWViewerModule, declarations: [FSWViewerComponent, FSWViewerDirective], imports: [FSWApplicationServiceModule], exports: [FSWViewerComponent, FSWViewerDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWViewerModule, providers: [FSWViewerService], imports: [FSWApplicationServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWViewerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DECLARATIONS$1],
                    exports: [DECLARATIONS$1],
                    providers: [FSWViewerService],
                    imports: [FSWApplicationServiceModule],
                }]
        }] });

const injectViewerService = () => inject(FSWViewerService);
const injectViewerComponent = () => inject(FSWViewerComponent);

class FSWDocViewerItemComponent {
    constructor() {
        this.type = 'NA';
        this.position = FSWViewerPosition.RIGHT;
        this.items = [];
        this.selectedSignal = signal(null);
        this.selectedItemSignal = computed(() => this.items.find((item) => item.id === this.selectedSignal()));
    }
    ngOnChanges() {
        this.selectedSignal.set(this.items?.[0]?.id);
    }
    setSelected(id) {
        this.selectedSignal.set(id ?? this.items?.[0]?.id);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDocViewerItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDocViewerItemComponent, selector: "fsw-doc-viewer-item", inputs: { type: "type", position: "position", items: "items" }, usesOnChanges: true, ngImport: i0, template: `
    <section class="fsw-doc-viewer-item fsw-doc-viewer-item--{{ position }}">
      <aside>
        <fsw-field [fullWidth]="true">
          <fsw-select
            [closeOnSelected]="true"
            [ngModel]="selectedSignal()"
            (ngModelChange)="setSelected($event)"
          >
            <ng-container *ngFor="let item of items">
              <ng-template
                fswSelectItem
                textSize="s"
                [value]="item.id"
                [text]="item.name"
              ></ng-template>
            </ng-container>
          </fsw-select>
        </fsw-field>
      </aside>
      <main *ngIf="selectedItemSignal() as selectedItem">
        <iframe
          width="100%"
          height="100%"
          [title]="selectedItem.name"
          [src]="selectedItem.src"
        ></iframe>
      </main>
    </section>
  `, isInline: true, styles: [":host{display:contents}:host .fsw-doc-viewer-item{display:flex;width:100%;gap:12px;height:calc(100% - 76px)}:host .fsw-doc-viewer-item>aside{width:100%;max-width:348px;padding-left:12px;padding-right:12px}:host .fsw-doc-viewer-item>main{width:100%;height:calc(100% - 52px)}:host .fsw-doc-viewer-item--top{flex-direction:column-reverse}:host .fsw-doc-viewer-item--bottom{flex-direction:column}:host .fsw-doc-viewer-item--left{flex-direction:column}:host .fsw-doc-viewer-item--right{flex-direction:column}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDocViewerItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-doc-viewer-item', template: `
    <section class="fsw-doc-viewer-item fsw-doc-viewer-item--{{ position }}">
      <aside>
        <fsw-field [fullWidth]="true">
          <fsw-select
            [closeOnSelected]="true"
            [ngModel]="selectedSignal()"
            (ngModelChange)="setSelected($event)"
          >
            <ng-container *ngFor="let item of items">
              <ng-template
                fswSelectItem
                textSize="s"
                [value]="item.id"
                [text]="item.name"
              ></ng-template>
            </ng-container>
          </fsw-select>
        </fsw-field>
      </aside>
      <main *ngIf="selectedItemSignal() as selectedItem">
        <iframe
          width="100%"
          height="100%"
          [title]="selectedItem.name"
          [src]="selectedItem.src"
        ></iframe>
      </main>
    </section>
  `, changeDetection: ChangeDetectionStrategy.OnPush, styles: [":host{display:contents}:host .fsw-doc-viewer-item{display:flex;width:100%;gap:12px;height:calc(100% - 76px)}:host .fsw-doc-viewer-item>aside{width:100%;max-width:348px;padding-left:12px;padding-right:12px}:host .fsw-doc-viewer-item>main{width:100%;height:calc(100% - 52px)}:host .fsw-doc-viewer-item--top{flex-direction:column-reverse}:host .fsw-doc-viewer-item--bottom{flex-direction:column}:host .fsw-doc-viewer-item--left{flex-direction:column}:host .fsw-doc-viewer-item--right{flex-direction:column}\n"] }]
        }], propDecorators: { type: [{
                type: Input
            }], position: [{
                type: Input
            }], items: [{
                type: Input
            }] } });

class FSWDocViewerGroupComponent {
    set metadata(value) {
        if ('groups' in value) {
            this.resolveFilter(value.groups);
        }
        else {
            this.resolveWithoutFilter(value.items);
        }
    }
    constructor() {
        this.viewerComponent = injectViewerComponent();
        this.groupsSignal = signal([]);
        this.selectedGroupSignal = signal(null);
        this.selectedPositionSignal = signal(FSWViewerPosition.RIGHT);
        this.showFilterSignal = signal(false);
        this.FSWViewerPosition = FSWViewerPosition;
        this.positions = [
            {
                value: FSWViewerPosition.TOP,
                label: 'Top',
            },
            {
                value: FSWViewerPosition.BOTTOM,
                label: 'Bottom',
            },
            {
                value: FSWViewerPosition.LEFT,
                label: 'Left',
            },
            {
                value: FSWViewerPosition.RIGHT,
                label: 'Right',
            },
        ];
        effect(() => {
            this.viewerComponent.updatePosition(this.selectedPositionSignal());
        }, { allowSignalWrites: true });
    }
    resolveFilter(groups) {
        this.showFilterSignal.set(true);
        this.groupsSignal.set(groups);
        this.selectedGroupSignal.set(groups?.[0]);
    }
    resolveWithoutFilter(items) {
        const group = {
            type: 'All',
            items,
        };
        this.showFilterSignal.set(false);
        this.groupsSignal.set([group]);
        this.selectedGroupSignal.set(group);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDocViewerGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDocViewerGroupComponent, selector: "fsw-doc-viewer-group", ngImport: i0, template: `
    <ng-container *ngIf="groupsSignal()?.length">
      <section class="fsw-doc-viewer-group fsw-doc-viewer-group--{{ selectedPositionSignal() }}">
        <header>
          <main>
            <ng-container *ngIf="showFilterSignal()">
              <ng-container *ngFor="let group of groupsSignal()">
                <fsw-tags
                  [hiddenCloseButton]="true"
                  [color]="selectedGroupSignal()?.type === group.type ? 'blue' : 'gray'"
                  (click)="selectedGroupSignal.set(group)"
                  >{{ group.type }}
                </fsw-tags>
              </ng-container>
            </ng-container>
          </main>
          <aside>
            <div>
              <fsw-field [fullWidth]="true">
                <fsw-select
                  [closeOnSelected]="true"
                  [ngModel]="selectedPositionSignal()"
                  (ngModelChange)="selectedPositionSignal.set($event ?? FSWViewerPosition.RIGHT)"
                >
                  <ng-container *ngFor="let position of positions">
                    <ng-template
                      fswSelectItem
                      textSize="s"
                      [value]="position.value"
                      [text]="position.label"
                    ></ng-template>
                  </ng-container>
                </fsw-select>
              </fsw-field>
            </div>
            <button fswButton [appearance]="'icon-no-bg'">
              <i fswIcon="common-close" (click)="viewerComponent.close()"></i>
            </button>
          </aside>
        </header>
        <ng-container *ngIf="selectedGroupSignal() as selectedGroup">
          <fsw-doc-viewer-item
            [type]="selectedGroup.type"
            [items]="selectedGroup.items"
            [position]="selectedPositionSignal()"
          />
        </ng-container>
      </section>
    </ng-container>
  `, isInline: true, styles: [":host{display:contents}:host .fsw-doc-viewer-group{display:flex;height:100%;width:100%;gap:12px;overflow-y:auto}:host .fsw-doc-viewer-group>header{display:flex;width:100%;align-items:center;justify-content:space-between;gap:8px;padding:12px}:host .fsw-doc-viewer-group>header>main{display:flex;width:100%;flex-wrap:wrap;align-items:center;gap:8px}:host .fsw-doc-viewer-group>header>aside{display:flex;align-items:center;gap:8px}:host .fsw-doc-viewer-group>header>aside>div{max-width:276px;flex:1 1 0%}:host .fsw-doc-viewer-group--top{flex-direction:column-reverse}:host .fsw-doc-viewer-group--top>header{flex-direction:row}:host .fsw-doc-viewer-group--top>header>aside{width:400px;flex-direction:row}:host .fsw-doc-viewer-group--bottom{flex-direction:column}:host .fsw-doc-viewer-group--bottom>header{flex-direction:row}:host .fsw-doc-viewer-group--bottom>header>aside{width:400px;flex-direction:row}:host .fsw-doc-viewer-group--left{flex-direction:column}:host .fsw-doc-viewer-group--left>header{flex-direction:column-reverse}:host .fsw-doc-viewer-group--left>header>aside{width:100%;flex-direction:row;justify-content:space-between}:host .fsw-doc-viewer-group--right{flex-direction:column}:host .fsw-doc-viewer-group--right>header{flex-direction:column-reverse}:host .fsw-doc-viewer-group--right>header>aside{width:100%;flex-direction:row-reverse;justify-content:space-between}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i1$4.FSWTagsComponent, selector: "fsw-tags" }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "component", type: FSWDocViewerItemComponent, selector: "fsw-doc-viewer-item", inputs: ["type", "position", "items"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDocViewerGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-doc-viewer-group', template: `
    <ng-container *ngIf="groupsSignal()?.length">
      <section class="fsw-doc-viewer-group fsw-doc-viewer-group--{{ selectedPositionSignal() }}">
        <header>
          <main>
            <ng-container *ngIf="showFilterSignal()">
              <ng-container *ngFor="let group of groupsSignal()">
                <fsw-tags
                  [hiddenCloseButton]="true"
                  [color]="selectedGroupSignal()?.type === group.type ? 'blue' : 'gray'"
                  (click)="selectedGroupSignal.set(group)"
                  >{{ group.type }}
                </fsw-tags>
              </ng-container>
            </ng-container>
          </main>
          <aside>
            <div>
              <fsw-field [fullWidth]="true">
                <fsw-select
                  [closeOnSelected]="true"
                  [ngModel]="selectedPositionSignal()"
                  (ngModelChange)="selectedPositionSignal.set($event ?? FSWViewerPosition.RIGHT)"
                >
                  <ng-container *ngFor="let position of positions">
                    <ng-template
                      fswSelectItem
                      textSize="s"
                      [value]="position.value"
                      [text]="position.label"
                    ></ng-template>
                  </ng-container>
                </fsw-select>
              </fsw-field>
            </div>
            <button fswButton [appearance]="'icon-no-bg'">
              <i fswIcon="common-close" (click)="viewerComponent.close()"></i>
            </button>
          </aside>
        </header>
        <ng-container *ngIf="selectedGroupSignal() as selectedGroup">
          <fsw-doc-viewer-item
            [type]="selectedGroup.type"
            [items]="selectedGroup.items"
            [position]="selectedPositionSignal()"
          />
        </ng-container>
      </section>
    </ng-container>
  `, changeDetection: ChangeDetectionStrategy.OnPush, styles: [":host{display:contents}:host .fsw-doc-viewer-group{display:flex;height:100%;width:100%;gap:12px;overflow-y:auto}:host .fsw-doc-viewer-group>header{display:flex;width:100%;align-items:center;justify-content:space-between;gap:8px;padding:12px}:host .fsw-doc-viewer-group>header>main{display:flex;width:100%;flex-wrap:wrap;align-items:center;gap:8px}:host .fsw-doc-viewer-group>header>aside{display:flex;align-items:center;gap:8px}:host .fsw-doc-viewer-group>header>aside>div{max-width:276px;flex:1 1 0%}:host .fsw-doc-viewer-group--top{flex-direction:column-reverse}:host .fsw-doc-viewer-group--top>header{flex-direction:row}:host .fsw-doc-viewer-group--top>header>aside{width:400px;flex-direction:row}:host .fsw-doc-viewer-group--bottom{flex-direction:column}:host .fsw-doc-viewer-group--bottom>header{flex-direction:row}:host .fsw-doc-viewer-group--bottom>header>aside{width:400px;flex-direction:row}:host .fsw-doc-viewer-group--left{flex-direction:column}:host .fsw-doc-viewer-group--left>header{flex-direction:column-reverse}:host .fsw-doc-viewer-group--left>header>aside{width:100%;flex-direction:row;justify-content:space-between}:host .fsw-doc-viewer-group--right{flex-direction:column}:host .fsw-doc-viewer-group--right>header{flex-direction:column-reverse}:host .fsw-doc-viewer-group--right>header>aside{width:100%;flex-direction:row-reverse;justify-content:space-between}\n"] }]
        }], ctorParameters: function () { return []; } });

class FSWDocViewerSingleComponent {
    set metadata(value) {
        this.singleSignal.set(value);
    }
    constructor() {
        this.viewerComponent = injectViewerComponent();
        this.singleSignal = signal(null);
        this.selectedPositionSignal = signal(FSWViewerPosition.RIGHT);
        this.FSWViewerPosition = FSWViewerPosition;
        this.positions = [
            {
                value: FSWViewerPosition.TOP,
                label: 'Top',
            },
            {
                value: FSWViewerPosition.BOTTOM,
                label: 'Bottom',
            },
            {
                value: FSWViewerPosition.LEFT,
                label: 'Left',
            },
            {
                value: FSWViewerPosition.RIGHT,
                label: 'Right',
            },
        ];
        effect(() => {
            this.viewerComponent.updatePosition(this.selectedPositionSignal());
        }, { allowSignalWrites: true });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDocViewerSingleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDocViewerSingleComponent, selector: "fsw-doc-viewer-single", ngImport: i0, template: `
    <ng-container *ngIf="singleSignal() as single">
      <section class="fsw-doc-viewer-single fsw-doc-viewer-single--{{ selectedPositionSignal() }}">
        <header>
          <aside>
            <fsw-field [fullWidth]="true">
              <fsw-select
                [closeOnSelected]="true"
                [ngModel]="selectedPositionSignal()"
                (ngModelChange)="selectedPositionSignal.set($event ?? FSWViewerPosition.RIGHT)"
              >
                <ng-container *ngFor="let position of positions">
                  <ng-template
                    fswSelectItem
                    textSize="s"
                    [value]="position.value"
                    [text]="position.label"
                  ></ng-template>
                </ng-container>
              </fsw-select>
            </fsw-field>
          </aside>
          <button fswButton [appearance]="'icon-no-bg'">
            <i fswIcon="common-close" (click)="viewerComponent.close()"></i>
          </button>
        </header>
        <main>
          <iframe width="100%" height="100%" [title]="single.name" [src]="single.src"></iframe>
        </main>
      </section>
    </ng-container>
  `, isInline: true, styles: [":host{display:contents}:host .fsw-doc-viewer-single{display:flex;height:100%;width:100%;gap:12px;overflow-y:auto}:host .fsw-doc-viewer-single>header{display:flex;align-items:center;justify-content:flex-end;gap:8px;padding:12px}:host .fsw-doc-viewer-single>header>aside{max-width:276px;flex:1 1 0%}:host .fsw-doc-viewer-single>main{width:100%;height:calc(100% - 52px)}:host .fsw-doc-viewer-single--top{flex-direction:column-reverse}:host .fsw-doc-viewer-single--top>header{width:400px;flex-direction:row}:host .fsw-doc-viewer-single--bottom{flex-direction:column}:host .fsw-doc-viewer-single--bottom>header{width:400px;flex-direction:row}:host .fsw-doc-viewer-single--left{flex-direction:column}:host .fsw-doc-viewer-single--left>header{width:100%;flex-direction:row;justify-content:space-between}:host .fsw-doc-viewer-single--right{flex-direction:column}:host .fsw-doc-viewer-single--right>header{width:100%;flex-direction:row-reverse;justify-content:space-between}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDocViewerSingleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-doc-viewer-single', template: `
    <ng-container *ngIf="singleSignal() as single">
      <section class="fsw-doc-viewer-single fsw-doc-viewer-single--{{ selectedPositionSignal() }}">
        <header>
          <aside>
            <fsw-field [fullWidth]="true">
              <fsw-select
                [closeOnSelected]="true"
                [ngModel]="selectedPositionSignal()"
                (ngModelChange)="selectedPositionSignal.set($event ?? FSWViewerPosition.RIGHT)"
              >
                <ng-container *ngFor="let position of positions">
                  <ng-template
                    fswSelectItem
                    textSize="s"
                    [value]="position.value"
                    [text]="position.label"
                  ></ng-template>
                </ng-container>
              </fsw-select>
            </fsw-field>
          </aside>
          <button fswButton [appearance]="'icon-no-bg'">
            <i fswIcon="common-close" (click)="viewerComponent.close()"></i>
          </button>
        </header>
        <main>
          <iframe width="100%" height="100%" [title]="single.name" [src]="single.src"></iframe>
        </main>
      </section>
    </ng-container>
  `, changeDetection: ChangeDetectionStrategy.OnPush, styles: [":host{display:contents}:host .fsw-doc-viewer-single{display:flex;height:100%;width:100%;gap:12px;overflow-y:auto}:host .fsw-doc-viewer-single>header{display:flex;align-items:center;justify-content:flex-end;gap:8px;padding:12px}:host .fsw-doc-viewer-single>header>aside{max-width:276px;flex:1 1 0%}:host .fsw-doc-viewer-single>main{width:100%;height:calc(100% - 52px)}:host .fsw-doc-viewer-single--top{flex-direction:column-reverse}:host .fsw-doc-viewer-single--top>header{width:400px;flex-direction:row}:host .fsw-doc-viewer-single--bottom{flex-direction:column}:host .fsw-doc-viewer-single--bottom>header{width:400px;flex-direction:row}:host .fsw-doc-viewer-single--left{flex-direction:column}:host .fsw-doc-viewer-single--left>header{width:100%;flex-direction:row;justify-content:space-between}:host .fsw-doc-viewer-single--right{flex-direction:column}:host .fsw-doc-viewer-single--right>header{width:100%;flex-direction:row-reverse;justify-content:space-between}\n"] }]
        }], ctorParameters: function () { return []; } });

class FSWDocViewerService {
    constructor() {
        this.viewerService = injectViewerService();
    }
    open(metadata, destroyWhen$) {
        this.viewerService.open(FSWDocViewerGroupComponent, metadata, {
            destroyWhen$,
        });
    }
    openSingle(metadata, destroyWhen$) {
        this.viewerService.open(FSWDocViewerSingleComponent, metadata, {
            destroyWhen$,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDocViewerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDocViewerService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDocViewerService, decorators: [{
            type: Injectable
        }] });

const DECLARATIONS = [
    FSWDocViewerItemComponent,
    FSWDocViewerGroupComponent,
    FSWDocViewerSingleComponent,
];
class FSWDocViewerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDocViewerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWDocViewerModule, declarations: [FSWDocViewerItemComponent,
            FSWDocViewerGroupComponent,
            FSWDocViewerSingleComponent], imports: [NgIf,
            FSWSelectModule,
            FSWFieldModule,
            NgForOf,
            FormsModule,
            FSWViewerModule,
            FSWTagsModule,
            FSWIconModule,
            FSWButtonModule], exports: [FSWDocViewerItemComponent,
            FSWDocViewerGroupComponent,
            FSWDocViewerSingleComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDocViewerModule, providers: [FSWDocViewerService], imports: [FSWSelectModule,
            FSWFieldModule,
            FormsModule,
            FSWViewerModule,
            FSWTagsModule,
            FSWIconModule,
            FSWButtonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDocViewerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DECLARATIONS],
                    exports: [DECLARATIONS],
                    imports: [
                        NgIf,
                        FSWSelectModule,
                        FSWFieldModule,
                        NgForOf,
                        FormsModule,
                        FSWViewerModule,
                        FSWTagsModule,
                        FSWIconModule,
                        FSWButtonModule,
                    ],
                    providers: [FSWDocViewerService],
                }]
        }] });

const injectFSWDocViewerService = () => inject(FSWDocViewerService);

const DIRECTORY_TOKEN = new InjectionToken('DIRECTORY_TOKEN');

class TranslocoRootHttpLoader {
    constructor(_httpClient, _directory) {
        this._httpClient = _httpClient;
        this._directory = _directory;
    }
    getTranslation(lang) {
        return this._httpClient.get(`${this._directory}/${lang}.json`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TranslocoRootHttpLoader, deps: [{ token: i1.HttpClient }, { token: DIRECTORY_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TranslocoRootHttpLoader }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TranslocoRootHttpLoader, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DIRECTORY_TOKEN]
                }] }]; } });

class TranslocoFeatureHttpLoader {
    constructor(defaultLang) {
        this.defaultLang = defaultLang;
        this.lang$ = new BehaviorSubject(defaultLang);
    }
    selectFeatureTranslate(scope, key, lang = this.defaultLang) {
        this.lang$.next(lang);
        const { loader } = scope;
        if (!loader)
            return of({});
        return this.lang$.asObservable().pipe(switchMap((lang) => {
            const pathLoader = loader[lang] || loader['default'];
            return from(pathLoader()).pipe(filter((translation) => !!translation), map((translation) => translation), map((translation) => translation[key]));
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TranslocoFeatureHttpLoader, deps: [{ token: TRANSLOCO_LANG }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TranslocoFeatureHttpLoader }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TranslocoFeatureHttpLoader, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_LANG]
                }] }]; } });

var header$m = {
	title_1: "eKYC",
	title_2: "eKYB",
	title_3: "Applicant Details",
	subTitle: "Please check the applicant's data and then submit the application"
};
var sg$f = {
	header: header$m
};

var sg$g = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: sg$f,
    header: header$m
});

var header$l = {
	title_1: "eKYC",
	title_2: "eKYB",
	title_3: "Applicant Details",
	subTitle: "Silakan periksa data pelamar dan kemudian kirimkan aplikasinya."
};
var id$j = {
	header: header$l
};

var id$k = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: id$j,
    header: header$l
});

const TRANSLATION_LOADER$9 = {
    default: () => Promise.resolve(sg$g),
    [CountryCode.SG]: () => Promise.resolve(sg$g),
    [CountryCode.ID]: () => Promise.resolve(id$k),
};

let KYCStore = class KYCStore extends ComponentStore {
    constructor(_kycService, _stateOverride = {}) {
        super({
            countryCode: null,
            applicationId: null,
            memberId: null,
            kyc: null,
            errors: [],
            // isFormSaved: false,
            ..._stateOverride,
        });
        this._kycService = _kycService;
        this._stateOverride = _stateOverride;
        this.setApplicationId = this.updater((state, applicationId) => {
            return { ...state, applicationId };
        });
        this.setMemberId = this.updater((state, memberId) => {
            return { ...state, memberId };
        });
        this.setKYC = this.updater((state, kyc) => {
            return { ...state, kyc: kyc };
        });
        this.setErrors = this.updater((state, errors) => {
            return { ...state, errors };
        });
        this.getKYC = this.effect(pipe(switchMap(() => this._getKYCAsync())));
        this.updateKYC = this.effect(pipe(switchMap(({ kyc }) => this._updateKYCAsync(kyc))));
        this.saveChanges = this.effect(pipe(tap(({ kyc }) => {
            if (this.get().applicationId) {
                this.updateKYC({ kyc });
            }
            else {
                throw new Error('No applicationId exists');
            }
        })));
    }
    _getKYCAsync() {
        if (!isStringValid(this.state().applicationId))
            return EMPTY;
        // if (this.state().kyc) of(this.state().kyc);
        return this._kycService.getKYC(this.state().applicationId).pipe(tap((kyc) => this.setKYC(kyc)), catchError((err) => {
            console.error(err);
            this.setErrors([
                ...this.state().errors,
                `Error: [GET]: /aps/v1/applications/${this.state().applicationId}/kyc`,
            ]);
            return EMPTY;
        }));
    }
    _updateKYCAsync(payload) {
        if (!isStringValid(this.state().applicationId))
            return EMPTY;
        // if (this.state().kyc) of(this.state().kyc);
        return this._kycService.updateKYC(this.state().applicationId, payload).pipe(switchMap(() => this._getKYCAsync()), catchError((err) => {
            console.error(err);
            this.setErrors([
                ...this.state().errors,
                `Error: [updateKYC] [PUT]: /aps/v1/applications/${payload}`,
            ]);
            return EMPTY;
        }));
    }
};
KYCStore = __decorate([
    __param(0, Inject(KYC_SERVICE_TOKEN)),
    __metadata("design:paramtypes", [Object, Object])
], KYCStore);

class IDKYCStore extends KYCStore {
    constructor(_kycService) {
        super(_kycService, { countryCode: CountryCode.SG });
        this._kycService = _kycService;
    }
    init() {
        this.getKYC();
        // this.getReferenceData();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDKYCStore, deps: [{ token: KYC_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDKYCStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDKYCStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KYC_SERVICE_TOKEN]
                }] }]; } });

class SGKYCStore extends KYCStore {
    constructor(_kycService) {
        super(_kycService, { countryCode: CountryCode.SG });
        this._kycService = _kycService;
    }
    init() {
        this.getKYC();
        // this.getReferenceData();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SGKYCStore, deps: [{ token: KYC_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SGKYCStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SGKYCStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KYC_SERVICE_TOKEN]
                }] }]; } });

const STORE_TOKEN$9 = new InjectionToken('STORE_TOKEN');

const ID_PROVIDERS$c = [
    {
        provide: STORE_TOKEN$9,
        useClass: IDKYCStore,
        deps: [KYC_SERVICE_TOKEN],
    },
];

const SG_PROVIDERS$7 = [
    {
        provide: STORE_TOKEN$9,
        useClass: SGKYCStore,
        deps: [KYC_SERVICE_TOKEN],
    },
];

const PROVIDERS_MAP$c = {
    default: SG_PROVIDERS$7,
    [CountryCode.SG]: SG_PROVIDERS$7,
    [CountryCode.ID]: ID_PROVIDERS$c,
};
const kycLoadProviders = (countryCode) => [
    ...getCustomProviders(PROVIDERS_MAP$c, SG_PROVIDERS$7, countryCode),
];

var FormKeys$5;
(function (FormKeys) {
    FormKeys["FULL_NAME"] = "full_name";
    FormKeys["GENDER"] = "gender";
    FormKeys["IDENTITY_CARD_NUMBER"] = "identity_card_number";
    FormKeys["HOME_ADDRESS"] = "home_address";
    FormKeys["HOME_POSTAL_CODE"] = "home_postal_code";
    FormKeys["DOB"] = "dob";
    FormKeys["MARITAL_STATUS"] = "marital_status";
    FormKeys["NATIONALITY"] = "nationality";
    FormKeys["MOBILE_NUMBER"] = "mobile_number";
    FormKeys["EMAIL"] = "email";
    FormKeys["ANNUAL_INCOME"] = "annual_income";
    FormKeys["NOA"] = "noa";
})(FormKeys$5 || (FormKeys$5 = {}));

const ID_FORM_CONFIG$5 = {
    setup(translate, formData) {
        return {
            formFields: [
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$5.FULL_NAME,
                    label: translate[FormKeys$5.FULL_NAME],
                    param: [{ value: formData && formData[FormKeys$5.FULL_NAME], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$5.GENDER,
                    label: translate[FormKeys$5.GENDER],
                    param: [{ value: formData && formData[FormKeys$5.GENDER], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$5.IDENTITY_CARD_NUMBER,
                    label: translate[FormKeys$5.IDENTITY_CARD_NUMBER],
                    param: [{ value: formData && formData[FormKeys$5.IDENTITY_CARD_NUMBER], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$5.HOME_ADDRESS,
                    label: translate[FormKeys$5.HOME_ADDRESS],
                    param: [{ value: formData && formData[FormKeys$5.HOME_ADDRESS], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$5.HOME_POSTAL_CODE,
                    label: translate[FormKeys$5.HOME_POSTAL_CODE],
                    param: [{ value: formData && formData[FormKeys$5.HOME_POSTAL_CODE], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$5.DOB,
                    label: translate[FormKeys$5.DOB],
                    param: [{ value: formData && formData[FormKeys$5.DOB], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$5.MARITAL_STATUS,
                    label: translate[FormKeys$5.MARITAL_STATUS],
                    param: [{ value: formData && formData[FormKeys$5.MARITAL_STATUS], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$5.NATIONALITY,
                    label: translate[FormKeys$5.NATIONALITY],
                    param: [{ value: formData && formData[FormKeys$5.NATIONALITY], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$5.MOBILE_NUMBER,
                    label: translate[FormKeys$5.MOBILE_NUMBER],
                    param: [{ value: formData && formData[FormKeys$5.MOBILE_NUMBER], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$5.EMAIL,
                    label: translate[FormKeys$5.EMAIL],
                    param: [{ value: formData && formData[FormKeys$5.EMAIL], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$5.ANNUAL_INCOME,
                    label: translate[FormKeys$5.ANNUAL_INCOME],
                    param: [{ value: formData && formData[FormKeys$5.ANNUAL_INCOME], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$5.NOA,
                    label: translate[FormKeys$5.NOA],
                    param: [{ value: formData && formData[FormKeys$5.NOA], disabled: false }],
                },
            ],
            formData,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        };
    },
    reset(oldConfig) {
        return {
            ...oldConfig,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        };
    },
    getValue(form, formData) {
        return {
            ...formData,
            ...form.value,
        };
    },
};

const SG_FORM_CONFIG$5 = {
    setup(translate, formData) {
        return {
            formFields: [
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$5.FULL_NAME,
                    label: translate[FormKeys$5.FULL_NAME],
                    param: [{ value: formData && formData[FormKeys$5.FULL_NAME], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$5.GENDER,
                    label: translate[FormKeys$5.GENDER],
                    param: [{ value: formData && formData[FormKeys$5.GENDER], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$5.IDENTITY_CARD_NUMBER,
                    label: translate[FormKeys$5.IDENTITY_CARD_NUMBER],
                    param: [{ value: formData && formData[FormKeys$5.IDENTITY_CARD_NUMBER], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$5.HOME_ADDRESS,
                    label: translate[FormKeys$5.HOME_ADDRESS],
                    param: [{ value: formData && formData[FormKeys$5.HOME_ADDRESS], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$5.HOME_POSTAL_CODE,
                    label: translate[FormKeys$5.HOME_POSTAL_CODE],
                    param: [{ value: formData && formData[FormKeys$5.HOME_POSTAL_CODE], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$5.DOB,
                    label: translate[FormKeys$5.DOB],
                    param: [{ value: formData && formData[FormKeys$5.DOB], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$5.MARITAL_STATUS,
                    label: translate[FormKeys$5.MARITAL_STATUS],
                    param: [{ value: formData && formData[FormKeys$5.MARITAL_STATUS], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$5.NATIONALITY,
                    label: translate[FormKeys$5.NATIONALITY],
                    param: [{ value: formData && formData[FormKeys$5.NATIONALITY], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$5.MOBILE_NUMBER,
                    label: translate[FormKeys$5.MOBILE_NUMBER],
                    param: [{ value: formData && formData[FormKeys$5.MOBILE_NUMBER], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$5.EMAIL,
                    label: translate[FormKeys$5.EMAIL],
                    param: [{ value: formData && formData[FormKeys$5.EMAIL], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$5.ANNUAL_INCOME,
                    label: translate[FormKeys$5.ANNUAL_INCOME],
                    param: [{ value: formData && formData[FormKeys$5.ANNUAL_INCOME], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$5.NOA,
                    label: translate[FormKeys$5.NOA],
                    param: [{ value: formData && formData[FormKeys$5.NOA], disabled: false }],
                },
            ],
            formData,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        };
    },
    reset(oldConfig) {
        return {
            ...oldConfig,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        };
    },
    getValue(form, formData) {
        return {
            ...formData,
            ...form.value,
        };
    },
};

const FORM_CONFIG_TOKEN$5 = new InjectionToken('FORM_CONFIG_TOKEN');

var header$k = {
	title: "Customer Details"
};
var form_fields$c = {
	full_name: "Full Name",
	gender: "Gender",
	identity_card_number: "Identity Card Number",
	home_address: "Home Address",
	home_postal_code: "Home Postal Code",
	dob: "Date of Birth",
	marital_status: "Marital Status",
	nationality: "Nationality",
	mobile_number: "Mobile Number",
	email: "Email",
	annual_income: "Annual Income",
	noa: "NOA"
};
var buttons$19 = {
	cancel: "Cancel",
	save_changes: "Save Changes"
};
var sg$d = {
	header: header$k,
	form_fields: form_fields$c,
	buttons: buttons$19
};

var sg$e = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$19,
    default: sg$d,
    form_fields: form_fields$c,
    header: header$k
});

var header$j = {
	title: "Customer Details"
};
var form_fields$b = {
	full_name: "Full Name",
	gender: "Gender",
	identity_card_number: "Identity Card Number",
	home_address: "Home Address",
	home_postal_code: "Home Postal Code",
	dob: "Date of Birth",
	marital_status: "Marital Status",
	nationality: "Nationality",
	mobile_number: "Mobile Number",
	email: "Email",
	annual_income: "Annual Income",
	noa: "NOA"
};
var buttons$18 = {
	cancel: "Cancel",
	save_changes: "Save Changes"
};
var id$h = {
	header: header$j,
	form_fields: form_fields$b,
	buttons: buttons$18
};

var id$i = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$18,
    default: id$h,
    form_fields: form_fields$b,
    header: header$j
});

const TRANSLATION_LOADER$8 = {
    default: () => Promise.resolve(sg$e),
    [CountryCode.SG]: () => Promise.resolve(sg$e),
    [CountryCode.ID]: () => Promise.resolve(id$i),
};

class CustomerDetailComponent {
    set customer(value) {
        this._customerSubject.next(value);
    }
    constructor(_formConfig, _scope, _translateService, _cdr) {
        this._formConfig = _formConfig;
        this._scope = _scope;
        this._translateService = _translateService;
        this._cdr = _cdr;
        this._customerSubject = new BehaviorSubject(null);
        this.isReadonly = false;
        this._changeTabStatusSub = new Subject();
        this.changeTabStatus$ = this._changeTabStatusSub.asObservable();
        this.config = null;
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'header'),
            this._translateService.selectFeatureTranslate(this._scope, 'form_fields'),
        ]).pipe(map(([header, form_fields]) => ({
            header,
            form_fields,
        })));
        this.vm$ = combineLatest([this._customerSubject.asObservable(), this.translate$]).pipe(map(([customer, translate]) => ({
            customer,
            translate,
        })), tap(({ customer, translate }) => {
            this.config = this._formConfig.setup(translate.form_fields, customer);
            this._cdr.markForCheck();
        }));
    }
    onSubmit(evt) {
        if (!evt.valid)
            return;
        // this._store.saveChanges({
        // 	application: {
        // 		...this._store.state.customer,
        // 		name: evt?.value.name,
        // 	} as ICustomer,
        // });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CustomerDetailComponent, deps: [{ token: FORM_CONFIG_TOKEN$5 }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CustomerDetailComponent, selector: "fsw-customer-detail", inputs: { customer: "customer", isReadonly: "isReadonly" }, providers: [
            {
                provide: TRANSLOCO_SCOPE,
                useValue: {
                    scope: 'customer-detail',
                    loader: TRANSLATION_LOADER$8,
                },
            },
        ], ngImport: i0, template: `
    <ng-container *ngIf="vm$ | async as vm">
      <header>
        <span>{{ vm.translate.header.title }}</span>
      </header>
      <fsw-form-widget
        #widget
        *ngIf="config"
        [isReadonly]="isReadonly"
        [formConfig]="config"
        (submitForm)="onSubmit($event)"
      ></fsw-form-widget>
    </ng-container>
  `, isInline: true, styles: [".error__message{color:#cc1830;font-size:14px}:host header span{font-weight:600;font-size:18px;line-height:140%;color:#757575}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FormWidgetComponent, selector: "fsw-form-widget", inputs: ["formConfig", "loading", "isReadonly"], outputs: ["initializeWidget", "closeForm", "submitForm"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CustomerDetailComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-customer-detail', template: `
    <ng-container *ngIf="vm$ | async as vm">
      <header>
        <span>{{ vm.translate.header.title }}</span>
      </header>
      <fsw-form-widget
        #widget
        *ngIf="config"
        [isReadonly]="isReadonly"
        [formConfig]="config"
        (submitForm)="onSubmit($event)"
      ></fsw-form-widget>
    </ng-container>
  `, changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        {
                            provide: TRANSLOCO_SCOPE,
                            useValue: {
                                scope: 'customer-detail',
                                loader: TRANSLATION_LOADER$8,
                            },
                        },
                    ], styles: [".error__message{color:#cc1830;font-size:14px}:host header span{font-weight:600;font-size:18px;line-height:140%;color:#757575}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FORM_CONFIG_TOKEN$5]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { customer: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

var FormKeys$4;
(function (FormKeys) {
    FormKeys["COMPANY_NAME"] = "company_name";
    FormKeys["COMPANY_EMAIL"] = "company_email";
    FormKeys["COMPANY_REGISTRATION_NUMBER"] = "company_registration_number";
    FormKeys["COMPANY_ADDRESS"] = "company_address";
    FormKeys["COMPANY_POSTAL_CODE"] = "company_postal_code";
    FormKeys["COMPANY_ESTABLISHMENT_DATE"] = "company_establishment_date";
    FormKeys["COMPANY_ENTITY_TYPE"] = "company_entity_type";
    FormKeys["INDUSTRY"] = "industry";
    FormKeys["COMPANY_INDUSTRY_OTHER"] = "company_industry_other";
})(FormKeys$4 || (FormKeys$4 = {}));

const ID_FORM_CONFIG$4 = {
    setup(translate, formData) {
        return {
            formFields: [
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$4.COMPANY_NAME,
                    label: translate[FormKeys$4.COMPANY_NAME],
                    param: [{ value: formData && formData[FormKeys$4.COMPANY_NAME], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$4.COMPANY_EMAIL,
                    label: translate[FormKeys$4.COMPANY_EMAIL],
                    param: [{ value: formData && formData[FormKeys$4.COMPANY_EMAIL], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$4.COMPANY_REGISTRATION_NUMBER,
                    label: translate[FormKeys$4.COMPANY_REGISTRATION_NUMBER],
                    param: [
                        { value: formData && formData[FormKeys$4.COMPANY_REGISTRATION_NUMBER], disabled: false },
                    ],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$4.COMPANY_ADDRESS,
                    label: translate[FormKeys$4.COMPANY_ADDRESS],
                    param: [{ value: formData && formData[FormKeys$4.COMPANY_ADDRESS], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$4.COMPANY_POSTAL_CODE,
                    label: translate[FormKeys$4.COMPANY_POSTAL_CODE],
                    param: [{ value: formData && formData[FormKeys$4.COMPANY_POSTAL_CODE], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$4.COMPANY_ESTABLISHMENT_DATE,
                    label: translate[FormKeys$4.COMPANY_ESTABLISHMENT_DATE],
                    param: [
                        { value: formData && formData[FormKeys$4.COMPANY_ESTABLISHMENT_DATE], disabled: false },
                    ],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$4.COMPANY_ENTITY_TYPE,
                    label: translate[FormKeys$4.COMPANY_ENTITY_TYPE],
                    param: [{ value: formData && formData[FormKeys$4.COMPANY_ENTITY_TYPE], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$4.INDUSTRY,
                    label: translate[FormKeys$4.INDUSTRY],
                    param: [{ value: formData && formData[FormKeys$4.INDUSTRY], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$4.COMPANY_INDUSTRY_OTHER,
                    label: translate[FormKeys$4.COMPANY_INDUSTRY_OTHER],
                    param: [
                        { value: formData && formData[FormKeys$4.COMPANY_INDUSTRY_OTHER], disabled: false },
                    ],
                },
            ],
            formData,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        };
    },
    reset(oldConfig) {
        return {
            ...oldConfig,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        };
    },
    getValue(form, formData) {
        return {
            ...formData,
            ...form.value,
        };
    },
};

const SG_FORM_CONFIG$4 = {
    setup(translate, formData) {
        return {
            formFields: [
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$4.COMPANY_NAME,
                    label: translate[FormKeys$4.COMPANY_NAME],
                    param: [{ value: formData && formData[FormKeys$4.COMPANY_NAME], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$4.COMPANY_EMAIL,
                    label: translate[FormKeys$4.COMPANY_EMAIL],
                    param: [{ value: formData && formData[FormKeys$4.COMPANY_EMAIL], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$4.COMPANY_REGISTRATION_NUMBER,
                    label: translate[FormKeys$4.COMPANY_REGISTRATION_NUMBER],
                    param: [
                        { value: formData && formData[FormKeys$4.COMPANY_REGISTRATION_NUMBER], disabled: false },
                    ],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$4.COMPANY_ADDRESS,
                    label: translate[FormKeys$4.COMPANY_ADDRESS],
                    param: [{ value: formData && formData[FormKeys$4.COMPANY_ADDRESS], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$4.COMPANY_POSTAL_CODE,
                    label: translate[FormKeys$4.COMPANY_POSTAL_CODE],
                    param: [{ value: formData && formData[FormKeys$4.COMPANY_POSTAL_CODE], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$4.COMPANY_ESTABLISHMENT_DATE,
                    label: translate[FormKeys$4.COMPANY_ESTABLISHMENT_DATE],
                    param: [
                        { value: formData && formData[FormKeys$4.COMPANY_ESTABLISHMENT_DATE], disabled: false },
                    ],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$4.COMPANY_ENTITY_TYPE,
                    label: translate[FormKeys$4.COMPANY_ENTITY_TYPE],
                    param: [{ value: formData && formData[FormKeys$4.COMPANY_ENTITY_TYPE], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$4.INDUSTRY,
                    label: translate[FormKeys$4.INDUSTRY],
                    param: [{ value: formData && formData[FormKeys$4.INDUSTRY], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$4.COMPANY_INDUSTRY_OTHER,
                    label: translate[FormKeys$4.COMPANY_INDUSTRY_OTHER],
                    param: [
                        { value: formData && formData[FormKeys$4.COMPANY_INDUSTRY_OTHER], disabled: false },
                    ],
                },
            ],
            formData,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        };
    },
    reset(oldConfig) {
        return {
            ...oldConfig,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        };
    },
    getValue(form, formData) {
        return {
            ...formData,
            ...form.value,
        };
    },
};

const FORM_CONFIG_TOKEN$4 = new InjectionToken('FORM_CONFIG_TOKEN');

var header$i = {
	title: "Company Details"
};
var form_fields$a = {
	company_name: "Company Name",
	company_email: "Company Email",
	company_registration_number: "Company Registration Number",
	company_address: "Company Address",
	company_postal_code: "Company Postal Code",
	company_establishment_date: "Company Establishment Date",
	company_entity_type: "Company Entity Type",
	industry: "Industry",
	company_industry_other: "Company Industry Other"
};
var buttons$17 = {
	cancel: "Cancel",
	save_changes: "Save Changes"
};
var sg$b = {
	header: header$i,
	form_fields: form_fields$a,
	buttons: buttons$17
};

var sg$c = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$17,
    default: sg$b,
    form_fields: form_fields$a,
    header: header$i
});

var header$h = {
	title: "Company Details"
};
var form_fields$9 = {
	company_name: "Company Name",
	company_email: "Company Email",
	company_registration_number: "Company Registration Number",
	company_address: "Company Address",
	company_postal_code: "Company Postal Code",
	company_establishment_date: "Company Establishment Date",
	company_entity_type: "Company Entity Type",
	industry: "Industry",
	company_industry_other: "Company Industry Other"
};
var buttons$16 = {
	cancel: "Cancel",
	save_changes: "Save Changes"
};
var id$f = {
	header: header$h,
	form_fields: form_fields$9,
	buttons: buttons$16
};

var id$g = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$16,
    default: id$f,
    form_fields: form_fields$9,
    header: header$h
});

const TRANSLATION_LOADER$7 = {
    default: () => Promise.resolve(sg$c),
    [CountryCode.SG]: () => Promise.resolve(sg$c),
    [CountryCode.ID]: () => Promise.resolve(id$g),
};

class CompanyDetailComponent {
    set company(value) {
        this._companySubject.next(value);
    }
    constructor(_formConfig, _scope, _translateService, _cdr) {
        this._formConfig = _formConfig;
        this._scope = _scope;
        this._translateService = _translateService;
        this._cdr = _cdr;
        this._companySubject = new BehaviorSubject(null);
        this.isReadonly = false;
        this._changeTabStatusSub = new Subject();
        this.changeTabStatus$ = this._changeTabStatusSub.asObservable();
        this.config = null;
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'header'),
            this._translateService.selectFeatureTranslate(this._scope, 'form_fields'),
        ]).pipe(map(([header, form_fields]) => ({
            header,
            form_fields,
        })));
        this.vm$ = combineLatest([this._companySubject.asObservable(), this.translate$]).pipe(map(([company, translate]) => ({
            company,
            translate,
        })), tap(({ company, translate }) => {
            this.config = this._formConfig.setup(translate.form_fields, company);
            this._cdr.markForCheck();
        }));
    }
    onSubmit(evt) {
        if (!evt.valid)
            return;
        // this._store.saveChanges({
        // 	application: {
        // 		...this._store.state.customer,
        // 		name: evt?.value.name,
        // 	} as ICompany,
        // });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyDetailComponent, deps: [{ token: FORM_CONFIG_TOKEN$4 }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CompanyDetailComponent, selector: "fsw-company-detail", inputs: { company: "company", isReadonly: "isReadonly" }, providers: [
            {
                provide: TRANSLOCO_SCOPE,
                useValue: {
                    scope: 'company-detail',
                    loader: TRANSLATION_LOADER$7,
                },
            },
        ], ngImport: i0, template: `
    <ng-container *ngIf="vm$ | async as vm">
      <header>
        <span>{{ vm.translate.header.title }}</span>
      </header>
      <fsw-form-widget
        #widget
        *ngIf="config"
        [isReadonly]="isReadonly"
        [formConfig]="config"
        (submitForm)="onSubmit($event)"
      ></fsw-form-widget>
    </ng-container>
  `, isInline: true, styles: [".error__message{color:#cc1830;font-size:14px}:host header span{font-weight:600;font-size:18px;line-height:140%;color:#757575}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FormWidgetComponent, selector: "fsw-form-widget", inputs: ["formConfig", "loading", "isReadonly"], outputs: ["initializeWidget", "closeForm", "submitForm"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyDetailComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-company-detail', template: `
    <ng-container *ngIf="vm$ | async as vm">
      <header>
        <span>{{ vm.translate.header.title }}</span>
      </header>
      <fsw-form-widget
        #widget
        *ngIf="config"
        [isReadonly]="isReadonly"
        [formConfig]="config"
        (submitForm)="onSubmit($event)"
      ></fsw-form-widget>
    </ng-container>
  `, changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        {
                            provide: TRANSLOCO_SCOPE,
                            useValue: {
                                scope: 'company-detail',
                                loader: TRANSLATION_LOADER$7,
                            },
                        },
                    ], styles: [".error__message{color:#cc1830;font-size:14px}:host header span{font-weight:600;font-size:18px;line-height:140%;color:#757575}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FORM_CONFIG_TOKEN$4]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { company: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

var FormKeys$3;
(function (FormKeys) {
    FormKeys["NAME"] = "name";
    FormKeys["UNIQUE_IDENTIFICATION_NUMBER"] = "unique_identification_number";
    FormKeys["POSITION"] = "position";
    FormKeys["EMAIL"] = "email";
})(FormKeys$3 || (FormKeys$3 = {}));

const ID_FORM_CONFIG$3 = {
    setup(translate, formData, isReadonly = false) {
        return {
            formFields: [
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$3.NAME,
                    label: translate[FormKeys$3.NAME],
                    param: [{ value: formData && formData[FormKeys$3.NAME], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$3.UNIQUE_IDENTIFICATION_NUMBER,
                    label: translate[FormKeys$3.UNIQUE_IDENTIFICATION_NUMBER],
                    param: [
                        { value: formData && formData[FormKeys$3.UNIQUE_IDENTIFICATION_NUMBER], disabled: false },
                    ],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$3.POSITION,
                    label: translate[FormKeys$3.POSITION],
                    param: [{ value: formData && formData[FormKeys$3.POSITION], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$3.EMAIL,
                    label: translate[FormKeys$3.EMAIL],
                    param: [
                        { value: formData && formData[FormKeys$3.EMAIL], disabled: false },
                        [Validators.required],
                    ],
                },
            ],
            formData,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        };
    },
    getValue(form, formData) {
        return {
            ...formData,
            ...form.value,
        };
    },
};

const SG_FORM_CONFIG$3 = {
    setup(translate, formData, isReadonly = false) {
        return {
            formFields: [
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$3.NAME,
                    label: translate[FormKeys$3.NAME],
                    param: [{ value: formData && formData[FormKeys$3.NAME], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$3.UNIQUE_IDENTIFICATION_NUMBER,
                    label: translate[FormKeys$3.UNIQUE_IDENTIFICATION_NUMBER],
                    param: [
                        { value: formData && formData[FormKeys$3.UNIQUE_IDENTIFICATION_NUMBER], disabled: false },
                    ],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$3.POSITION,
                    label: translate[FormKeys$3.POSITION],
                    param: [{ value: formData && formData[FormKeys$3.POSITION], disabled: false }],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$3.EMAIL,
                    label: translate[FormKeys$3.EMAIL],
                    param: [
                        { value: formData && formData[FormKeys$3.EMAIL], disabled: false },
                        [Validators.required],
                    ],
                },
            ],
            formData,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        };
    },
    getValue(form, formData) {
        return {
            ...formData,
            ...form.value,
        };
    },
};

const FORM_CONFIG_TOKEN$3 = new InjectionToken('FORM_CONFIG_TOKEN');

var GridFields$1;
(function (GridFields) {
    GridFields["ID"] = "id";
    GridFields["NAME"] = "name";
    GridFields["UNIQUE_IDENTIFICATION_NUMBER"] = "unique_identification_number";
    GridFields["POSITION"] = "position";
    GridFields["EMAIL"] = "email";
})(GridFields$1 || (GridFields$1 = {}));

const ID_GRID_CONFIG$1 = {
    setup(defaultGridOptions, translate, rowData, action) {
        return {
            ...defaultGridOptions,
            rowData,
            columnDefs: [
                {
                    field: GridFields$1.NAME,
                    headerName: translate[GridFields$1.NAME],
                    width: 200,
                },
                {
                    field: GridFields$1.UNIQUE_IDENTIFICATION_NUMBER,
                    headerName: translate[GridFields$1.UNIQUE_IDENTIFICATION_NUMBER],
                    width: 250,
                },
                {
                    field: GridFields$1.POSITION,
                    headerName: translate[GridFields$1.POSITION],
                    width: 180,
                },
                {
                    field: GridFields$1.EMAIL,
                    headerName: translate[GridFields$1.EMAIL],
                    width: 180,
                },
                // {
                // 	field: CommonGridFields.ACTIONS,
                // 	headerName: '',
                // 	width: 60,
                // 	pinned: 'right',
                // 	cellRendererSelector: (params: ICellRendererParams) => ({
                // 		component: 'actionMethods',
                // 		params: {
                // 			...params,
                // 			onEdit: (params: ICellRendererParams) => action(params.data, Methods.PUT),
                // 			onDelete: (params: ICellRendererParams) => action(params.data, Methods.DELETE),
                // 		},
                // 	}),
                // },
            ],
        };
    },
};

const SG_GRID_CONFIG$1 = {
    setup(defaultGridOptions, translate, rowData, action) {
        return {
            ...defaultGridOptions,
            rowData,
            columnDefs: [
                {
                    field: GridFields$1.NAME,
                    headerName: translate[GridFields$1.NAME],
                    width: 200,
                },
                {
                    field: GridFields$1.UNIQUE_IDENTIFICATION_NUMBER,
                    headerName: translate[GridFields$1.UNIQUE_IDENTIFICATION_NUMBER],
                    width: 250,
                },
                {
                    field: GridFields$1.POSITION,
                    headerName: translate[GridFields$1.POSITION],
                    width: 180,
                },
                {
                    field: GridFields$1.EMAIL,
                    headerName: translate[GridFields$1.EMAIL],
                    width: 180,
                },
                // {
                // 	field: CommonGridFields.ACTIONS,
                // 	headerName: '',
                // 	width: 60,
                // 	pinned: 'right',
                // 	cellRendererSelector: (params: ICellRendererParams) => ({
                // 		component: 'actionMethods',
                // 		params: {
                // 			...params,
                // 			onEdit: (params: ICellRendererParams) => action(params.data, Methods.PUT),
                // 			onDelete: (params: ICellRendererParams) => action(params.data, Methods.DELETE),
                // 		},
                // 	}),
                // },
            ],
        };
    },
};

const GRID_CONFIG_TOKEN$1 = new InjectionToken('GRID_CONFIG_TOKEN');

var header$g = {
	title: "Company Directors"
};
var fields$v = {
	name: "Name",
	unique_identification_number: "Unique Identification Number",
	position: "Position",
	email: "Email"
};
var titles$b = {
	post: "Add New Company Director",
	put: "Edit Company Director",
	get: "View Company Director",
	confirm: "Are you sure you want to delete?"
};
var buttons$15 = {
	cancel: "Cancel",
	save_changes: "Save Changes",
	edit: "Edit",
	back: "Back"
};
var sg$9 = {
	header: header$g,
	fields: fields$v,
	titles: titles$b,
	buttons: buttons$15
};

var sg$a = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$15,
    default: sg$9,
    fields: fields$v,
    header: header$g,
    titles: titles$b
});

var header$f = {
	title: "Company Directors"
};
var fields$u = {
	name: "Name",
	unique_identification_number: "Unique Identification Number",
	position: "Position",
	email: "Email"
};
var titles$a = {
	post: "Add New Company Director",
	put: "Edit Company Director",
	get: "View Company Director",
	confirm: "Are you sure you want to delete?"
};
var buttons$14 = {
	cancel: "Cancel",
	save_changes: "Save Changes",
	edit: "Edit",
	back: "Back"
};
var id$d = {
	header: header$f,
	fields: fields$u,
	titles: titles$a,
	buttons: buttons$14
};

var id$e = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$14,
    default: id$d,
    fields: fields$u,
    header: header$f,
    titles: titles$a
});

const TRANSLATION_LOADER$6 = {
    default: () => Promise.resolve(sg$a),
    [CountryCode.SG]: () => Promise.resolve(sg$a),
    [CountryCode.ID]: () => Promise.resolve(id$e),
};

let CompanyDirectorStore$1 = class CompanyDirectorStore extends ComponentStore {
    constructor(_memberBIPService, _stateOverride = {}) {
        super({
            countryCode: null,
            applicationId: null,
            memberId: null,
            selectedMemberBIP: null,
            errors: [],
            ..._stateOverride,
        });
        this._memberBIPService = _memberBIPService;
        this._stateOverride = _stateOverride;
        this.setApplicationId = this.updater((state, applicationId) => {
            return { ...state, applicationId };
        });
        this.setMemberId = this.updater((state, memberId) => {
            return { ...state, memberId };
        });
        this.setSelectedMemberBIP = this.updater((state, selectedMemberBIP) => {
            return { ...state, selectedMemberBIP };
        });
        this.setErrors = this.updater((state, errors) => {
            return { ...state, errors };
        });
        this.updateMemberBIP = this.effect(pipe(switchMap(({ memberBIP }) => this._updateMemberBIPAsync(memberBIP))));
        this.saveChanges = this.effect(pipe(tap(({ memberBIP }) => {
            if (this.get().memberId) {
                this.updateMemberBIP({ memberBIP });
            }
            else {
                throw new Error('No memberId exists');
            }
        })));
    }
    _updateMemberBIPAsync(payload) {
        if (!isStringValid(this.state().applicationId))
            return EMPTY;
        // if (this.state().application) of(this.state().application);
        // return this._memberBIPService
        // 	.updateMemberBIP(this.state().applicationId as string, payload)
        // 	.pipe(
        // 		switchMap(() => this._getApplicationAsync()),
        // 		catchError((err) => {
        // 			console.error(err);
        // 			this.setErrors([
        // 				...this.state().errors,
        // 				`Error: [PUT]: /aps/v1/applications/${payload?.id}`,
        // 			]);
        // 			return EMPTY;
        // 		})
        // 	);
        return EMPTY;
    }
};
CompanyDirectorStore$1 = __decorate([
    __param(0, Inject(APPLICATION_MEMBER_BIP_SERVICE_TOKEN)),
    __metadata("design:paramtypes", [Object, Object])
], CompanyDirectorStore$1);

let IDCompanyDirectorStore$1 = class IDCompanyDirectorStore extends CompanyDirectorStore$1 {
    constructor(_memberBIPService) {
        super(_memberBIPService, { countryCode: CountryCode.ID });
        this._memberBIPService = _memberBIPService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDCompanyDirectorStore, deps: [{ token: APPLICATION_MEMBER_BIP_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDCompanyDirectorStore }); }
};
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDCompanyDirectorStore$1, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_BIP_SERVICE_TOKEN]
                }] }]; } });

let SGCompanyDirectorStore$1 = class SGCompanyDirectorStore extends CompanyDirectorStore$1 {
    constructor(_memberBIPService) {
        super(_memberBIPService, { countryCode: CountryCode.SG });
        this._memberBIPService = _memberBIPService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SGCompanyDirectorStore, deps: [{ token: APPLICATION_MEMBER_BIP_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SGCompanyDirectorStore }); }
};
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SGCompanyDirectorStore$1, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_BIP_SERVICE_TOKEN]
                }] }]; } });

const STORE_TOKEN$8 = new InjectionToken('STORE_TOKEN');

class CompanyDirectorEntryDialogComponent {
    // public formSubscription: Subscription | null = null;
    constructor(context, _scope, _translateService, _cdr, _modalComponent) {
        this.context = context;
        this._scope = _scope;
        this._translateService = _translateService;
        this._cdr = _cdr;
        this._modalComponent = _modalComponent;
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'fields'),
            this._translateService.selectFeatureTranslate(this._scope, 'titles'),
            this._translateService.selectFeatureTranslate(this._scope, 'buttons'),
        ]).pipe(map(([fields, titles, buttons]) => ({ fields, titles, buttons })));
        this.config = null;
        this.form = null;
        this.configuration((fields) => this.setupForm(fields));
    }
    submit() {
        if (!this.form) {
            return this.cancel();
        }
        if (this.form.invalid)
            return;
        const data = this.context.data.config.getValue(this.form, this.context.data.selectedItem);
        const checkEqual = isEqualWith(data, this.context.data.selectedItem);
        if (checkEqual) {
            return this.cancel();
        }
        this.context.completeWith({
            method: this.context.data.method,
            data,
        });
    }
    cancel() {
        this.context.completeWith(null);
    }
    remove() {
        this.context.completeWith({
            method: Methods.DELETE,
            data: null,
        });
    }
    listen(form) {
        this.form = form;
        // this.formSubscription = this.context.data.config.listenChange(form, () => {
        // 	this._cdr.markForCheck();
        // });
    }
    configuration(cb) {
        this.translate$
            .pipe(take(1), tap(({ fields, titles }) => {
            this._modalComponent.setLabel(titles[this.context.data.method]);
            cb(fields, titles);
            this._cdr.markForCheck();
        }))
            .subscribe();
    }
    changeMode() {
        this.configuration(() => {
            if (!this.config)
                return;
            // this.config = this.context.data.config.reset(this.config);
            this.config.formFieldConfig.isReadonly = false;
        });
    }
    setupForm(fields) {
        this.config = this.context.data.config.setup(fields, this.context.data.selectedItem || {}, this.context.data.isReadonly);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyDirectorEntryDialogComponent, deps: [{ token: MODAL_CONTEXT }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: i0.ChangeDetectorRef }, { token: ModalComponent }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CompanyDirectorEntryDialogComponent, selector: "fsw-company-director-save-dialog", ngImport: i0, template: `
		<ng-container *ngIf="translate$ | async as translate">
			<fsw-save-dialog
				[config]="config"
				[(method)]="context.data.method"
				[buttonSaveLabel]="translate.buttons['save']"
				[buttonCancelLabel]="translate.buttons['cancel']"
				[buttonEditLabel]="translate.buttons['edit']"
				[buttonBackLabel]="translate.buttons['back']"
				[isReadonly]="context.data.isReadonly"
				(methodChange)="changeMode()"
				(listen)="listen($event)"
				(remove)="remove()"
				(cancel)="cancel()"
				(save)="submit()"
			>
			</fsw-save-dialog>
		</ng-container>
	`, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FSWSaveDialogComponent, selector: "fsw-save-dialog", inputs: ["method", "config", "buttonDeleteLabel", "buttonCancelLabel", "buttonBackLabel", "buttonEditLabel", "buttonSaveLabel", "isReadonly"], outputs: ["remove", "cancel", "save", "listen", "methodChange"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyDirectorEntryDialogComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-company-director-save-dialog',
                    template: `
		<ng-container *ngIf="translate$ | async as translate">
			<fsw-save-dialog
				[config]="config"
				[(method)]="context.data.method"
				[buttonSaveLabel]="translate.buttons['save']"
				[buttonCancelLabel]="translate.buttons['cancel']"
				[buttonEditLabel]="translate.buttons['edit']"
				[buttonBackLabel]="translate.buttons['back']"
				[isReadonly]="context.data.isReadonly"
				(methodChange)="changeMode()"
				(listen)="listen($event)"
				(remove)="remove()"
				(cancel)="cancel()"
				(save)="submit()"
			>
			</fsw-save-dialog>
		</ng-container>
	`,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_CONTEXT]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: i0.ChangeDetectorRef }, { type: ModalComponent }]; } });

class CompanyDirectorEntryDialogModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyDirectorEntryDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CompanyDirectorEntryDialogModule, declarations: [CompanyDirectorEntryDialogComponent], imports: [CommonModule, FSWSaveDialogModule, TranslocoModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyDirectorEntryDialogModule, imports: [CommonModule, FSWSaveDialogModule, TranslocoModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyDirectorEntryDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FSWSaveDialogModule, TranslocoModule],
                    declarations: [CompanyDirectorEntryDialogComponent],
                }]
        }] });

class CompanyDirectorGridComponent {
    constructor(_memberBIPService, gridConfig, _scope, _translateService) {
        this._memberBIPService = _memberBIPService;
        this.gridConfig = gridConfig;
        this._scope = _scope;
        this._translateService = _translateService;
        this.isReadonly = false;
        this.action = new EventEmitter();
        this._getRowSubject = new Subject();
        this._destroySubject = new Subject();
        this.gridOptions = {
            rowSelection: 'multiple',
            headerHeight: 36,
            rowHeight: 36,
            pagination: true,
            paginationPageSize: 10,
            cacheBlockSize: 10,
            rowModelType: 'serverSide',
            serverSideStoreType: 'partial',
            overlayNoRowsTemplate: `
			<div>
				<div style="color: #757575; padding-top: 40px;">No Directors data is available</div>
			</div>
		`,
            getRowId: (params) => params.data.id,
            onGridReady: (event) => {
                event.api.setGridOption('serverSideDatasource', {
                    getRows: (params) => this._getRowSubject.next(params),
                });
            },
        };
        this.gridOptions$ = this._translateService
            .selectFeatureTranslate(this._scope, 'fields')
            .pipe(map((translate) => this._setupGridOptions(translate)));
    }
    ngOnInit() {
        this._getRowSubject
            .asObservable()
            .pipe(takeUntil(this._destroySubject), switchMap((serverSideParams) => {
            // if (this._productIdsCache !== product_ids || this._keySearchCache !== keySearch) {
            // 	serverSideParams.api.refreshServerSideStore();
            // 	serverSideParams.api.paginationGoToFirstPage();
            // }
            if (!this.applicationId || !this.memberId) {
                throw new Error(`Either applicationId: ${this.applicationId} or memberId ${this.memberId} is not present`);
            }
            return this._memberBIPService
                .getApplicationMemberBIPs(this.applicationId, this.memberId, {
                expand: true,
                page: serverSideParams.request.endRow ? serverSideParams.request.endRow / 10 : 1,
                limit: 10,
            })
                .pipe(map((res) => {
                const data = res.map((r) => ({
                    id: r.id,
                    name: r.expand.fullname,
                    unique_identification_number: r.expand.ic_number,
                    position: r.expand.entity_type,
                    email: r.expand.company_email,
                }));
                return [{ data, total: res?.length }, serverSideParams];
            }));
        }))
            .subscribe(([res, serverSideParams]) => {
            const lbLastRowOnPageEl = document.querySelector(`[ref="lbLastRowOnPage"]`);
            const timeout = setTimeout(() => {
                if (lbLastRowOnPageEl) {
                    lbLastRowOnPageEl.innerHTML = serverSideParams.request.endRow
                        ? serverSideParams.request.endRow.toString()
                        : serverSideParams.api.paginationGetPageSize().toString();
                }
                clearTimeout(timeout);
            }, 300);
            serverSideParams.success({
                rowData: res.data || [],
                rowCount: !res.data.length ? 0 : res.total,
            });
            if (!res.data.length) {
                serverSideParams.api.showNoRowsOverlay();
            }
            else {
                serverSideParams.api.hideOverlay();
            }
        }, (err) => console.error(err));
    }
    ngOnDestroy() {
        this._destroySubject.next(0);
        this._destroySubject.complete();
    }
    rowClicked({ data, index }) {
        this.action.emit({
            res: data,
            method: Methods.GET,
        });
    }
    _setupGridOptions(translate) {
        return this.gridConfig.setup(this.gridOptions, translate, [], (res, method) => this.action.emit({ res, method }), this.isReadonly);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyDirectorGridComponent, deps: [{ token: APPLICATION_MEMBER_BIP_SERVICE_TOKEN }, { token: GRID_CONFIG_TOKEN$1 }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CompanyDirectorGridComponent, selector: "fsw-company-director-grid", inputs: { applicationId: "applicationId", memberId: "memberId", isReadonly: "isReadonly" }, outputs: { action: "action" }, ngImport: i0, template: `
		<fsw-grid
			[gridOptions]="(gridOptions$ | async) || {}"
			[gridContainerHeight]="400"
			(rowClicked)="rowClicked($event)"
		></fsw-grid>
	`, isInline: true, dependencies: [{ kind: "component", type: FSWGridComponent, selector: "fsw-grid", inputs: ["gridOptions", "actionClickedCheck", "rowData", "gridContainerHeight"], outputs: ["rowClicked"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyDirectorGridComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-company-director-grid',
                    template: `
		<fsw-grid
			[gridOptions]="(gridOptions$ | async) || {}"
			[gridContainerHeight]="400"
			(rowClicked)="rowClicked($event)"
		></fsw-grid>
	`,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_BIP_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [GRID_CONFIG_TOKEN$1]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }]; }, propDecorators: { applicationId: [{
                type: Input
            }], memberId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], action: [{
                type: Output
            }] } });

class CompanyDirectorGridModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyDirectorGridModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CompanyDirectorGridModule, declarations: [CompanyDirectorGridComponent], imports: [CommonModule, TranslocoModule, FSWGridModule], exports: [CompanyDirectorGridComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyDirectorGridModule, imports: [CommonModule, TranslocoModule, FSWGridModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyDirectorGridModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, TranslocoModule, FSWGridModule],
                    declarations: [CompanyDirectorGridComponent],
                    exports: [CompanyDirectorGridComponent],
                }]
        }] });

class CompanyDirectorComponent {
    set applicationId(value) {
        this._store.setApplicationId(value);
    }
    set memberId(value) {
        this._store.setMemberId(value);
    }
    constructor(_formConfig, gridConfig, _store, _scope, _translateService, _modalService, _injector) {
        this._formConfig = _formConfig;
        this.gridConfig = gridConfig;
        this._store = _store;
        this._scope = _scope;
        this._translateService = _translateService;
        this._modalService = _modalService;
        this._injector = _injector;
        this.isReadonly = false;
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'header'),
            this._translateService.selectFeatureTranslate(this._scope, 'fields'),
        ]).pipe(map(([header, fields]) => ({
            header,
            fields,
        })));
        this.vm$ = combineLatest([this._store.state$, this.translate$]).pipe(map(([state, translate]) => ({
            state,
            translate,
        })));
        this.Methods = Methods;
    }
    open(method, selectedItem) {
        const data = {
            selectedItem,
            method,
            config: this._formConfig,
            isReadonly: this.isReadonly,
        };
        this._modalService
            .open(CompanyDirectorEntryDialogComponent, {
            data,
            size: ModalSizes.L,
            injector: this._injector,
        })
            .pipe(take(1), tap((res) => {
            if (!res)
                return;
            // const { method, data } = res;
            // if (method === Methods.PUT) {
            // 	this._store.put({
            // 		...selectedItem,
            // 		...(data as ICompanyDirector),
            // 	});
            // } else if (method === Methods.DELETE) {
            // 	selectedItem && this.remove(selectedItem);
            // }
        }))
            .subscribe();
    }
    action(res, method) {
        if (method === Methods.PUT || method === Methods.GET) {
            this.open(method, res);
        }
        else if (method === Methods.DELETE) {
            // this.remove(res);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyDirectorComponent, deps: [{ token: FORM_CONFIG_TOKEN$3 }, { token: GRID_CONFIG_TOKEN$1 }, { token: STORE_TOKEN$8 }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: MODAL_SERVICE }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CompanyDirectorComponent, selector: "fsw-company-director", inputs: { applicationId: "applicationId", memberId: "memberId", isReadonly: "isReadonly" }, providers: [
            {
                provide: TRANSLOCO_SCOPE,
                useValue: {
                    scope: 'company-director',
                    loader: TRANSLATION_LOADER$6,
                },
            },
        ], ngImport: i0, template: `
    <ng-container *ngIf="vm$ | async as vm">
      <header class="mt-4 mb-4">
        <h6>{{ vm.translate.header.title }}</h6>
      </header>
      <fsw-company-director-grid
        [applicationId]="vm.state.applicationId"
        [memberId]="vm.state.memberId"
        [isReadonly]="isReadonly"
        (action)="action($event.res, $event.method)"
      ></fsw-company-director-grid>
    </ng-container>
  `, isInline: true, styles: [".mt-4{margin-top:16px}.mb-4{margin-bottom:16px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CompanyDirectorGridComponent, selector: "fsw-company-director-grid", inputs: ["applicationId", "memberId", "isReadonly"], outputs: ["action"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyDirectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-company-director', template: `
    <ng-container *ngIf="vm$ | async as vm">
      <header class="mt-4 mb-4">
        <h6>{{ vm.translate.header.title }}</h6>
      </header>
      <fsw-company-director-grid
        [applicationId]="vm.state.applicationId"
        [memberId]="vm.state.memberId"
        [isReadonly]="isReadonly"
        (action)="action($event.res, $event.method)"
      ></fsw-company-director-grid>
    </ng-container>
  `, changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        {
                            provide: TRANSLOCO_SCOPE,
                            useValue: {
                                scope: 'company-director',
                                loader: TRANSLATION_LOADER$6,
                            },
                        },
                    ], styles: [".mt-4{margin-top:16px}.mb-4{margin-bottom:16px}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FORM_CONFIG_TOKEN$3]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [GRID_CONFIG_TOKEN$1]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [STORE_TOKEN$8]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_SERVICE]
                }] }, { type: i0.Injector }]; }, propDecorators: { applicationId: [{
                type: Input
            }], memberId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class KYCContainerComponent {
    set applicationId(value) {
        this._store.setApplicationId(value);
    }
    set memberId(value) {
        this._store.setMemberId(value);
    }
    constructor(_store, _scope, _translateService) {
        this._store = _store;
        this._scope = _scope;
        this._translateService = _translateService;
        this.isReadonly = false;
        this._changeTabStatusSub = new Subject();
        this.changeTabStatus$ = this._changeTabStatusSub.asObservable();
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'header'),
        ]).pipe(map(([header]) => ({
            header,
        })));
        this.vm$ = combineLatest([this._store.state$, this.translate$]).pipe(map(([state, translate]) => ({
            state,
            translate,
        }))
        // tap((data) => console.log('data', data))
        );
    }
    ngOnInit() {
        this._store.init();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: KYCContainerComponent, deps: [{ token: STORE_TOKEN$9 }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: KYCContainerComponent, selector: "fsw-kyc-container", inputs: { applicationId: "applicationId", memberId: "memberId", isReadonly: "isReadonly" }, providers: [
            {
                provide: TRANSLOCO_SCOPE,
                useValue: {
                    scope: 'ekyc-container',
                    loader: TRANSLATION_LOADER$9,
                },
            },
            {
                provide: TRANSLOCO_LANG,
                useValue: getCountryCodeFromStorage(),
            },
            {
                provide: TranslocoFeatureHttpLoader,
                useClass: TranslocoFeatureHttpLoader,
            },
            ...kycLoadProviders(getCountryCodeFromStorage()),
        ], ngImport: i0, template: `
    <div class="kyc-container" *ngIf="vm$ | async as vm">
      <header>
        <div>
          <h6>{{ vm.translate.header.title_1 }}</h6>
          /
          <h6>{{ vm.translate.header.title_2 }}</h6>
        </div>
        <div class="sub">{{ vm.translate.header.subTitle }}</div>
      </header>
      <div>
        <ng-container *ngIf="vm.state?.errors as errorList">
          <div class="error__message" *ngFor="let errStr of errorList">{{ errStr }}</div>
        </ng-container>
      </div>
      <main class="mt-4 mb-4 cbs-form__container">
        <h6>{{ vm.translate.header.title_3 }}</h6>
        <fsw-customer-detail
          [isReadonly]="isReadonly"
          [customer]="vm.state.kyc && vm.state.kyc && vm.state.kyc.customer_data"
        ></fsw-customer-detail>
        <div class="cb-separator"></div>
        <fsw-company-detail
          [isReadonly]="isReadonly"
          [company]="vm.state.kyc && vm.state.kyc && vm.state.kyc.company_data"
        ></fsw-company-detail>
      </main>
      <div class="mt-4">
        <fsw-company-director
          [applicationId]="vm.state.applicationId"
          [memberId]="vm.state.memberId"
          [isReadonly]="isReadonly"
        ></fsw-company-director>
      </div>
    </div>
  `, isInline: true, styles: ["header>div:first-child{display:flex;margin-bottom:4px}.error__message{color:#cc1830;font-size:14px}.sub{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:12px;line-height:1.5;color:#757575}:host .cbs-form__container{padding:16px;width:50%;display:flex;flex-direction:column;gap:16px;border-radius:4px;border:1px solid #e0e0e0}.mt-4{margin-top:16px}.mb-4{margin-bottom:16px}::ng-deep .cb-separator{width:100%;height:0;border:1px solid #e0e0e0}.kyc-container{padding:0 16px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CustomerDetailComponent, selector: "fsw-customer-detail", inputs: ["customer", "isReadonly"] }, { kind: "component", type: CompanyDetailComponent, selector: "fsw-company-detail", inputs: ["company", "isReadonly"] }, { kind: "component", type: CompanyDirectorComponent, selector: "fsw-company-director", inputs: ["applicationId", "memberId", "isReadonly"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: KYCContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-kyc-container', template: `
    <div class="kyc-container" *ngIf="vm$ | async as vm">
      <header>
        <div>
          <h6>{{ vm.translate.header.title_1 }}</h6>
          /
          <h6>{{ vm.translate.header.title_2 }}</h6>
        </div>
        <div class="sub">{{ vm.translate.header.subTitle }}</div>
      </header>
      <div>
        <ng-container *ngIf="vm.state?.errors as errorList">
          <div class="error__message" *ngFor="let errStr of errorList">{{ errStr }}</div>
        </ng-container>
      </div>
      <main class="mt-4 mb-4 cbs-form__container">
        <h6>{{ vm.translate.header.title_3 }}</h6>
        <fsw-customer-detail
          [isReadonly]="isReadonly"
          [customer]="vm.state.kyc && vm.state.kyc && vm.state.kyc.customer_data"
        ></fsw-customer-detail>
        <div class="cb-separator"></div>
        <fsw-company-detail
          [isReadonly]="isReadonly"
          [company]="vm.state.kyc && vm.state.kyc && vm.state.kyc.company_data"
        ></fsw-company-detail>
      </main>
      <div class="mt-4">
        <fsw-company-director
          [applicationId]="vm.state.applicationId"
          [memberId]="vm.state.memberId"
          [isReadonly]="isReadonly"
        ></fsw-company-director>
      </div>
    </div>
  `, changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        {
                            provide: TRANSLOCO_SCOPE,
                            useValue: {
                                scope: 'ekyc-container',
                                loader: TRANSLATION_LOADER$9,
                            },
                        },
                        {
                            provide: TRANSLOCO_LANG,
                            useValue: getCountryCodeFromStorage(),
                        },
                        {
                            provide: TranslocoFeatureHttpLoader,
                            useClass: TranslocoFeatureHttpLoader,
                        },
                        ...kycLoadProviders(getCountryCodeFromStorage()),
                    ], styles: ["header>div:first-child{display:flex;margin-bottom:4px}.error__message{color:#cc1830;font-size:14px}.sub{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:12px;line-height:1.5;color:#757575}:host .cbs-form__container{padding:16px;width:50%;display:flex;flex-direction:column;gap:16px;border-radius:4px;border:1px solid #e0e0e0}.mt-4{margin-top:16px}.mb-4{margin-bottom:16px}::ng-deep .cb-separator{width:100%;height:0;border:1px solid #e0e0e0}.kyc-container{padding:0 16px}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [STORE_TOKEN$9]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }]; }, propDecorators: { applicationId: [{
                type: Input
            }], memberId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

var title$H = "Aging Report";
var empty$m = "Aging Report has no data";
var tabs$7 = {
	ap: "AP Aging Report",
	ar: "AR Aging Report"
};
var columns$c = {
	counter_party: "Counter Party",
	concentration: "Concentration (%)",
	total_value: "Total Value",
	current: "Current",
	one_month: "30 Days",
	two_month: "60 Days",
	three_month: "90 Days",
	more_than_three_month: "> 90 Days",
	reliability_score: "Reliability Score (0-1)",
	year_of_relationship: "Year of Relationship",
	total: "Total",
	total_outstanding: "% Total Outstanding",
	total_counter_party: " counter parties"
};
var fields$t = {
	date: "Dated as of"
};
var messages$3 = {
	counter_party: {
		one: "Please provide the top 3 debtor based on value in the<br/>first 3 rows on this table",
		two: "Provide others debtor on the subsequent rows or put it<br/>together as “Others” in the 4th row",
		three: "For the scoring, first top 3 debtor will be used"
	}
};
var modal$8 = {
	title: "Delete Confirmation",
	description: "Are you sure you want to remove this item?"
};
var buttons$13 = {
	save: "Save Changes",
	add: "Add Counter Party",
	cancel: "Cancel",
	"delete": "Delete"
};
var comment$9 = {
	title: "Aging Report Comments",
	credit: "Credit Comments"
};
var agingReportAll = {
	title: title$H,
	empty: empty$m,
	tabs: tabs$7,
	columns: columns$c,
	fields: fields$t,
	messages: messages$3,
	modal: modal$8,
	buttons: buttons$13,
	comment: comment$9
};

var ALL$b = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$13,
    columns: columns$c,
    comment: comment$9,
    default: agingReportAll,
    empty: empty$m,
    fields: fields$t,
    messages: messages$3,
    modal: modal$8,
    tabs: tabs$7,
    title: title$H
});

const AGING_REPORT_ALL_TRANSLATION = ALL$b;

function injectAgingReportEffects(config) {
    switch (getCountryCodeFromStorage()) {
        default:
            return injectAgingReportALLEffects(config);
    }
}
function injectAgingReportForm(isReadonly) {
    switch (getCountryCodeFromStorage()) {
        default:
            return injectAgingReportFormALL(isReadonly);
    }
}

function injectAgingReportALLEffects({ applicationIdSignal, activeTabSignal, isReadonlySignal, }) {
    const creditService = injectCreditAgingReportService();
    const applicationService = injectApplicationRelationshipService();
    const alertService = inject(FSW_ALERT_SERVICE_TOKEN);
    const apBuilder = injectAgingReportForm(isReadonlySignal());
    const arBuilder = injectAgingReportForm(isReadonlySignal());
    const atDateSignal = signal(null);
    const loadReports = () => {
        atDateSignal.set(null);
        const applicationId = applicationIdSignal();
        const activeTab = activeTabSignal();
        if (!applicationId) {
            return;
        }
        applicationService
            .getAsync(applicationId, 'aging_report')
            .pipe(switchMap$1((ids) => {
            if (!ids.length) {
                return of([]);
            }
            return creditService
                .getReportsByIds(ids)
                .pipe(map((reports) => reports.filter((report) => report.reportType === activeTab)));
        }), tap((reports) => {
            apBuilder.groupConfig.form.reset([]);
            arBuilder.groupConfig.form.reset([]);
            const formArray = getControlFromGroup((activeTab === CreditAgingReportTypes.AP ? apBuilder : arBuilder).groupConfig.form, 'agingReport');
            formArray.patchValue(reports);
            atDateSignal.set(reports[0]?.atDate);
        }))
            .subscribe();
    };
    const createReportsAsync = (applicationId, payload) => {
        return creditService.createReports(payload).pipe(map((reports) => reports.map((report) => report.id)), switchMap$1((reports) => forkJoin(reports.map((id) => applicationService.addAsync(applicationId, 'aging_report', id)))), tap(() => {
            alertService.success('Success', 'Aging Report successfully created!', {
                duration: 3000,
            });
        }));
    };
    const updateReportsAsync = (payload) => {
        return creditService.updateReports(payload).pipe(tap(() => {
            alertService.success('Success', 'Aging Report successfully updated!', {
                duration: 3000,
            });
        }));
    };
    return {
        init: () => {
            effect(() => loadReports(), { allowSignalWrites: true });
        },
        save: (payload) => {
            const applicationId = applicationIdSignal();
            const activeTab = activeTabSignal();
            const { postReports, putReports } = payload.reduce((acc, report) => {
                if (report.id) {
                    acc.putReports.push(report);
                }
                else {
                    report.reportType = activeTab;
                    report.aging_report_type = activeTab;
                    acc.postReports.push(omit(report, ['id']));
                }
                return acc;
            }, {
                postReports: [],
                putReports: [],
            });
            const requests = [];
            if (postReports.length) {
                requests.push(createReportsAsync(applicationId, postReports));
            }
            if (putReports.length) {
                requests.push(updateReportsAsync(putReports));
            }
            forkJoin(requests)
                .pipe(tap(() => loadReports()))
                .subscribe();
        },
        remove(id, cb) {
            const applicationId = applicationIdSignal();
            applicationService
                .deleteAsync(applicationId, 'aging_report', id)
                .pipe(tap(() => {
                cb();
                loadReports();
            }))
                .subscribe();
        },
        apBuilder,
        arBuilder,
        atDateSignal: atDateSignal.asReadonly(),
    };
}

const injectAgingReportFormALL = (isReadonly) => {
    const translation = AGING_REPORT_ALL_TRANSLATION;
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.TABLE,
        customClasses: 'fsw-table w-max',
        readonlyWhen$: of(isReadonly),
        header: [
            {
                columns: [
                    {
                        label: '',
                        width: 20,
                    },
                    {
                        columnType: 'template',
                        template: 'counter_party_header',
                        width: 100,
                    },
                    {
                        label: translation.columns.concentration,
                        width: 100,
                    },
                    {
                        label: translation.columns.total_value,
                        width: 100,
                    },
                    {
                        label: translation.columns.current,
                        width: 100,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.one_month,
                        width: 100,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.two_month,
                        width: 100,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.three_month,
                        width: 100,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.more_than_three_month,
                        width: 100,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.reliability_score,
                        width: 100,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.year_of_relationship,
                        width: 100,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: '',
                        width: 20,
                    },
                ],
            },
        ],
        items: [
            {
                body: {
                    isLoop: true,
                    key: 'agingReport',
                    data: {
                        columns: [
                            {
                                columnType: 'control',
                                customClasses: 'text-center',
                                fields: [
                                    {
                                        key: 'id',
                                        type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                        context: {
                                            templateKey: 'no',
                                        },
                                    },
                                    {
                                        key: 'reportType',
                                        type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                        context: {
                                            isHidden: true,
                                        },
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1 w-[100px]',
                                        fields: [
                                            {
                                                key: 'counterParty',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    defaultValue: '',
                                                    fullWidth: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => value ?? 'N/A',
                                                },
                                                validations: [Validators.required],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1 w-[100px]',
                                        fields: [
                                            {
                                                key: 'concentration',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    // inputType: 'number',
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    fullWidth: true,
                                                    isDisabled: true,
                                                    afterCreated: (control, group) => {
                                                        const totalGroup = (group.parent?.parent).get('total');
                                                        if (!totalGroup) {
                                                            return;
                                                        }
                                                        const totalValueControl = totalGroup.get('totalValue');
                                                        totalValueControl?.valueChanges
                                                            .pipe(startWith(Number.parseFloat(totalValueControl.value || '0')), map((value) => Number.parseFloat(value || '0')), tap((total) => {
                                                            const totalValue = group.get('totalValue')?.value;
                                                            control.setValue((total > 0 ? (totalValue / total) * 100 : 0).toFixed(2), {
                                                                emitEvent: false,
                                                            });
                                                        }))
                                                            .subscribe();
                                                    },
                                                    readonlyTemplate: (value) => value ?? '0',
                                                },
                                                validations: [Validators.required],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1 w-[100px]',
                                        fields: [
                                            {
                                                key: 'totalValue',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    // inputType: 'number',
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    fullWidth: true,
                                                    isDisabled: true,
                                                    afterCreated: (control, group) => {
                                                        combineLatest([
                                                            group.controls['current'].valueChanges.pipe(startWith(group.value['current'] || 0), map((value) => Number.parseFloat(value || '0'))),
                                                            group.controls['days30'].valueChanges.pipe(startWith(group.value['days30'] || 0), map((value) => Number.parseFloat(value || '0'))),
                                                            group.controls['days60'].valueChanges.pipe(startWith(group.value['days60'] || 0), map((value) => Number.parseFloat(value || '0'))),
                                                            group.controls['days90'].valueChanges.pipe(startWith(group.value['days90'] || 0), map((value) => Number.parseFloat(value || '0'))),
                                                            group.controls['greaterThan90'].valueChanges.pipe(startWith(group.value['greaterThan90'] || 0), map((value) => Number.parseFloat(value || '0'))),
                                                        ])
                                                            .pipe(tap((values) => {
                                                            control.setValue(values.reduce((acc, cur) => acc + cur, 0));
                                                        }))
                                                            .subscribe();
                                                    },
                                                    readonlyTemplate: (value) => value ?? '0',
                                                },
                                                validations: [Validators.required],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1 w-[100px]',
                                        fields: [
                                            {
                                                key: 'current',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    // inputType: 'number',
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    fullWidth: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => value ?? '0',
                                                },
                                                validations: [Validators.required],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1 w-[100px]',
                                        fields: [
                                            {
                                                key: 'days30',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    inputType: 'number',
                                                    fullWidth: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => value ?? '0',
                                                },
                                                validations: [Validators.required],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1 w-[100px]',
                                        fields: [
                                            {
                                                key: 'days60',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    inputType: 'number',
                                                    fullWidth: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => value ?? '0',
                                                },
                                                validations: [Validators.required],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1 w-[100px]',
                                        fields: [
                                            {
                                                key: 'days90',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    inputType: 'number',
                                                    fullWidth: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => value ?? '0',
                                                },
                                                validations: [Validators.required],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1 w-[100px]',
                                        fields: [
                                            {
                                                key: 'greaterThan90',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    // inputType: 'number',
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    fullWidth: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => value ?? '0',
                                                },
                                                validations: [Validators.required],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1 w-[100px]',
                                        fields: [
                                            {
                                                key: 'reliabilityScore',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    // inputType: 'number',
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    fullWidth: true,
                                                    min: 0,
                                                    max: 1,
                                                    showError: true,
                                                    readonlyTemplate: (value) => value ?? '0',
                                                },
                                                validations: [Validators.min(0), Validators.max(1), Validators.required],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1 w-[100px]',
                                        fields: [
                                            {
                                                key: 'yearOfRelationship',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    // inputType: 'number',
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    fullWidth: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => value ?? '0',
                                                },
                                                validations: [Validators.required],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'template',
                                template: 'delete',
                            },
                        ],
                    },
                    empty: {
                        emptyTemplateKey: 'empty_list',
                        emptyTemplateColSpan: 12,
                    },
                },
            },
        ],
        footer: [
            {
                columns: [
                    {
                        colSpan: 12,
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                name: 'add_aging_report',
                                fields: [],
                            },
                        ],
                    },
                ],
            },
            {
                key: 'total',
                columns: [
                    {
                        colSpan: 2,
                        columnType: 'template',
                        template: 'total_content',
                    },
                    {
                        label: '',
                    },
                    {
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                customClasses: 'pr-1 w-[100px]',
                                fields: [
                                    {
                                        key: 'totalValue',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            // inputType: 'number',
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            isDisabled: true,
                                            afterCreated: (control, group) => {
                                                const agingReport = group.parent.get('agingReport');
                                                if (!agingReport) {
                                                    return;
                                                }
                                                agingReport.valueChanges
                                                    .pipe(map((items) => items.map((item) => Number.parseFloat(item.current || '0') +
                                                    Number.parseFloat(item.days30 || '0') +
                                                    Number.parseFloat(item.days60 || '0') +
                                                    Number.parseFloat(item.days90 || '0') +
                                                    Number.parseFloat(item.greaterThan90 || '0'))), tap((value) => {
                                                    control.setValue(value.reduce((acc, cur) => acc + cur, 0));
                                                }))
                                                    .subscribe();
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                customClasses: 'pr-1 w-[100px]',
                                fields: [
                                    {
                                        key: 'current',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            // inputType: 'number',
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            isDisabled: true,
                                            afterCreated: (control, group) => {
                                                const agingReport = group.parent.get('agingReport');
                                                if (!agingReport) {
                                                    return;
                                                }
                                                agingReport.valueChanges
                                                    .pipe(map((items) => items.map((item) => Number.parseFloat(item.current || '0'))), tap((value) => {
                                                    control.setValue(value.reduce((acc, cur) => acc + cur, 0));
                                                }))
                                                    .subscribe();
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                customClasses: 'pr-1 w-[100px]',
                                fields: [
                                    {
                                        key: 'days30',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            inputType: 'number',
                                            fullWidth: true,
                                            isDisabled: true,
                                            afterCreated: (control, group) => {
                                                const agingReport = group.parent.get('agingReport');
                                                if (!agingReport) {
                                                    return;
                                                }
                                                agingReport.valueChanges
                                                    .pipe(map((items) => items.map((item) => Number.parseFloat(item.days30 || '0'))), tap((value) => {
                                                    control.setValue(value.reduce((acc, cur) => acc + cur, 0));
                                                }))
                                                    .subscribe();
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                customClasses: 'pr-1 w-[100px]',
                                fields: [
                                    {
                                        key: 'days60',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            inputType: 'number',
                                            fullWidth: true,
                                            isDisabled: true,
                                            afterCreated: (control, group) => {
                                                const agingReport = group.parent.get('agingReport');
                                                if (!agingReport) {
                                                    return;
                                                }
                                                agingReport.valueChanges
                                                    .pipe(map((items) => items.map((item) => Number.parseFloat(item.days60 || '0'))), tap((value) => {
                                                    control.setValue(value.reduce((acc, cur) => acc + cur, 0));
                                                }))
                                                    .subscribe();
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                customClasses: 'pr-1 w-[100px]',
                                fields: [
                                    {
                                        key: 'days90',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            inputType: 'number',
                                            fullWidth: true,
                                            isDisabled: true,
                                            afterCreated: (control, group) => {
                                                const agingReport = group.parent.get('agingReport');
                                                if (!agingReport) {
                                                    return;
                                                }
                                                agingReport.valueChanges
                                                    .pipe(map((items) => items.map((item) => Number.parseFloat(item.days90 || '0'))), tap((value) => {
                                                    control.setValue(value.reduce((acc, cur) => acc + cur, 0));
                                                }))
                                                    .subscribe();
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                customClasses: 'pr-1 w-[100px]',
                                fields: [
                                    {
                                        key: 'greaterThan90',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            // inputType: 'number',
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            isDisabled: true,
                                            afterCreated: (control, group) => {
                                                const agingReport = group.parent.get('agingReport');
                                                if (!agingReport) {
                                                    return;
                                                }
                                                agingReport.valueChanges
                                                    .pipe(map((items) => items.map((item) => Number.parseFloat(item.greaterThan90 || '0'))), tap((value) => {
                                                    control.setValue(value.reduce((acc, cur) => acc + cur, 0));
                                                }))
                                                    .subscribe();
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                key: 'total_outstanding',
                columns: [
                    {
                        colSpan: 2,
                        label: translation.columns.total_outstanding,
                    },
                    {
                        label: '',
                    },
                    {
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                customClasses: 'pr-1 w-[100px]',
                                fields: [
                                    {
                                        key: 'totalValue',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            // inputType: 'number',
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            isDisabled: true,
                                            afterCreated: (control, group) => {
                                                const total = group.parent.get('total');
                                                if (!total) {
                                                    return;
                                                }
                                                total.valueChanges
                                                    .pipe(tap((value) => {
                                                    control.setValue((value['totalValue'] > 0
                                                        ? (value['totalValue'] / value['totalValue']) * 100
                                                        : 0).toFixed(2));
                                                }))
                                                    .subscribe();
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                customClasses: 'pr-1 w-[100px]',
                                fields: [
                                    {
                                        key: 'current',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            // inputType: 'number',
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            isDisabled: true,
                                            afterCreated: (control, group) => {
                                                const total = group.parent.get('total');
                                                if (!total) {
                                                    return;
                                                }
                                                total.valueChanges
                                                    .pipe(tap((value) => {
                                                    control.setValue((value['totalValue'] > 0
                                                        ? (value['current'] / value['totalValue']) * 100
                                                        : 0).toFixed(2));
                                                }))
                                                    .subscribe();
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                customClasses: 'pr-1 w-[100px]',
                                fields: [
                                    {
                                        key: 'days30',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            inputType: 'number',
                                            fullWidth: true,
                                            isDisabled: true,
                                            afterCreated: (control, group) => {
                                                const total = group.parent.get('total');
                                                if (!total) {
                                                    return;
                                                }
                                                total.valueChanges
                                                    .pipe(tap((value) => {
                                                    control.setValue((value['totalValue'] > 0
                                                        ? (value['days30'] / value['totalValue']) * 100
                                                        : 0).toFixed(2));
                                                }))
                                                    .subscribe();
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                customClasses: 'pr-1 w-[100px]',
                                fields: [
                                    {
                                        key: 'days60',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            inputType: 'number',
                                            fullWidth: true,
                                            isDisabled: true,
                                            afterCreated: (control, group) => {
                                                const total = group.parent.get('total');
                                                if (!total) {
                                                    return;
                                                }
                                                total.valueChanges
                                                    .pipe(tap((value) => {
                                                    control.setValue((value['totalValue'] > 0
                                                        ? (value['days60'] / value['totalValue']) * 100
                                                        : 0).toFixed(2));
                                                }))
                                                    .subscribe();
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                customClasses: 'pr-1 w-[100px]',
                                fields: [
                                    {
                                        key: 'days90',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            inputType: 'number',
                                            fullWidth: true,
                                            isDisabled: true,
                                            afterCreated: (control, group) => {
                                                const total = group.parent.get('total');
                                                if (!total) {
                                                    return;
                                                }
                                                total.valueChanges
                                                    .pipe(tap((value) => {
                                                    control.setValue((value['totalValue'] > 0
                                                        ? (value['days90'] / value['totalValue']) * 100
                                                        : 9).toFixed(2));
                                                }))
                                                    .subscribe();
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                customClasses: 'pr-1 w-[100px]',
                                fields: [
                                    {
                                        key: 'greaterThan90',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            // inputType: 'number',
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            isDisabled: true,
                                            afterCreated: (control, group) => {
                                                const total = group.parent.get('total');
                                                if (!total) {
                                                    return;
                                                }
                                                total.valueChanges
                                                    .pipe(tap((value) => {
                                                    control.setValue((value['totalValue'] > 0
                                                        ? (value['greaterThan90'] / value['totalValue']) * 100
                                                        : 0).toFixed(2));
                                                }))
                                                    .subscribe();
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
        form: new UntypedFormGroup({}),
    });
};

const injectCommentsFormALL = ({ form, pairs, customClasses, isReadonly, rows, }) => {
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'w-full',
        form,
        readonlyWhen$: of(isReadonly),
        fields: [
            {
                key: 'id',
                type: FSWDynamicBuilderControlTypes.TEMPLATE,
                context: {
                    isHidden: true,
                },
            },
            {
                key: 'module',
                type: FSWDynamicBuilderControlTypes.TEMPLATE,
                context: {
                    isHidden: true,
                },
            },
            {
                key: 'category',
                type: FSWDynamicBuilderControlTypes.TEMPLATE,
                context: {
                    isHidden: true,
                },
            },
            {
                key: 'identifier',
                type: FSWDynamicBuilderControlTypes.TEMPLATE,
                context: {
                    isHidden: true,
                },
            },
            {
                key: 'comments',
                formType: FSWDynamicBuilderFormTypes.GROUP,
                customClasses: customClasses || 'w-full flex',
                fields: Object.keys(pairs).map((key) => ({
                    key,
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-full',
                    context: {
                        inputType: 'area',
                        label: pairs[key],
                        rows: rows || 5,
                        readonlyTemplate: 'comment-readonly',
                        showError: true,
                        fullWidth: true,
                    },
                    validations: [Validators.required],
                })),
            },
        ],
    });
};

function injectCommentsALLEffects({ pairsSignal, entityIdSignal, identifierSignal, moduleSignal, categorySignal, isReadonlySignal, rowsSignal, customClassesSignal, builderSignal, form, }) {
    const applicationRelationshipService = injectApplicationRelationshipService();
    const creditCommentService = injectCreditCommentService();
    const alertService = inject(FSW_ALERT_SERVICE_TOKEN);
    const updateComments = (comments) => {
        creditCommentService
            .updateComments(comments)
            .pipe(tapResponse(() => {
            alertService.success('Notification', 'Updated Comment Successfully!', {
                duration: 1000,
            });
        }, (error) => {
            alertService.error('Error', error.message, {
                duration: 1000,
            });
        }))
            .subscribe();
    };
    const addComments = (comments) => {
        creditCommentService
            .addComments(comments)
            .pipe(map((comments) => comments.map((comment) => comment.id)), switchMap((ids) => forkJoin(ids.map((id) => applicationRelationshipService.addAsync(entityIdSignal(), 'comments', id)))), tapResponse(() => {
            alertService.success('Notification', 'Added Comment Successfully!', {
                duration: 1000,
            });
            loadComments();
        }, (error) => {
            alertService.error('Error', error.message, {
                duration: 1000,
            });
        }))
            .subscribe();
    };
    const loadComments = () => {
        applicationRelationshipService
            .getAsync(entityIdSignal(), 'comments')
            .pipe(switchMap((ids) => {
            if (!ids?.length) {
                return of([]);
            }
            return creditCommentService.getComments(ids, [moduleSignal()]);
        }), map((comments) => comments.filter((comment) => !!comment &&
            comment.category === categorySignal() &&
            comment.identifier === identifierSignal() &&
            comment.module === moduleSignal())), map((comments) => comments.shift()), tap((comment) => form.patchValue({
            module: moduleSignal(),
            category: categorySignal(),
            identifier: identifierSignal(),
            comments: {},
            ...(comment || {}),
        })))
            .subscribe();
    };
    const updateBuilder = () => {
        const builder = injectCommentsFormALL({
            form,
            rows: rowsSignal(),
            pairs: pairsSignal(),
            isReadonly: isReadonlySignal(),
            customClasses: customClassesSignal(),
        });
        builderSignal.set(builder);
    };
    return {
        init: () => {
            effect(() => {
                const pairs = pairsSignal();
                const keys = Object.keys(pairs);
                if (!keys.length) {
                    return;
                }
                untracked(() => {
                    updateBuilder();
                    loadComments();
                });
            }, { allowSignalWrites: true });
        },
        save: () => {
            const data = form.value;
            if (data.id) {
                updateComments([data]);
            }
            else {
                addComments([omit(data, 'id')]);
            }
        },
    };
}

class FSWCommentsItemDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
        this.label = null;
        this.key = null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCommentsItemDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWCommentsItemDirective, isStandalone: true, selector: "ng-template[fswCommentsItem]", inputs: { label: "label", key: "key" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCommentsItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswCommentsItem]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; }, propDecorators: { label: [{
                type: Input
            }], key: [{
                type: Input
            }] } });

function injectCommentsEffects(config) {
    switch (getCountryCodeFromStorage()) {
        default:
            return injectCommentsALLEffects(config);
    }
}

class FSWCommentsComponent {
    set list(list) {
        this.pairsSignal.set(Array.from(list).reduce((acc, item) => ({
            ...acc,
            [item.key]: item.label,
        }), {}));
    }
    set title(title) {
        this.titleSignal.set(title);
    }
    set entityId(entityId) {
        this.entityIdSignal.set(entityId);
    }
    set identifier(identifier) {
        this.identifierSignal.set(identifier);
    }
    set module(module) {
        this.moduleSignal.set(module);
    }
    set category(category) {
        this.categorySignal.set(category);
    }
    set isReadonly(isReadonly) {
        this.isReadonlySignal.set(isReadonly);
    }
    set rows(rows) {
        this.rowsSignal.set(rows);
    }
    set customClasses(customClasses) {
        this.customClassesSignal.set(customClasses);
    }
    set enableSaveButton(enableSaveButton) {
        this.enableSaveButtonSignal.set(enableSaveButton);
    }
    get invalid() {
        const comments = getControlFromGroup(this.form, 'comments');
        if (!comments) {
            return true;
        }
        return Object.keys(comments.controls).every((key) => getControlFromGroup(comments, key).invalid);
    }
    constructor() {
        this.translateScope = 'comments';
        this.pairsSignal = signal({});
        this.titleSignal = signal('');
        this.entityIdSignal = signal(null);
        this.identifierSignal = signal(null);
        this.moduleSignal = signal(null);
        this.categorySignal = signal(null);
        this.isReadonlySignal = signal(false);
        this.rowsSignal = signal(null);
        this.customClassesSignal = signal(null);
        this.enableSaveButtonSignal = signal(true);
        this.builderSignal = signal(null);
        this.form = new UntypedFormGroup({});
        this.effects = injectCommentsEffects({
            form: this.form,
            pairsSignal: this.pairsSignal,
            entityIdSignal: this.entityIdSignal,
            identifierSignal: this.identifierSignal,
            moduleSignal: this.moduleSignal,
            categorySignal: this.categorySignal,
            isReadonlySignal: this.isReadonlySignal,
            rowsSignal: this.rowsSignal,
            customClassesSignal: this.customClassesSignal,
            builderSignal: this.builderSignal,
        });
        this.effects.init();
    }
    format(value) {
        if (!value) {
            return '';
        }
        return value.split('\\"').join('"').split('\t').join(' ').split('\n').join('<br>');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCommentsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCommentsComponent, isStandalone: true, selector: "fsw-comments", inputs: { title: "title", entityId: "entityId", identifier: "identifier", module: "module", category: "category", isReadonly: "isReadonly", rows: "rows", customClasses: "customClasses", enableSaveButton: "enableSaveButton", translateScope: "translateScope" }, providers: [
            provideUtilsService(),
            provideApplicationRelationshipService(),
            provideCreditCommentService(),
        ], queries: [{ propertyName: "list", predicate: FSWCommentsItemDirective }], ngImport: i0, template: "<fsw-panel [title]=\"titleSignal()\">\n  <ng-template fswPanelHeaderSuffix>\n    <ng-container *ngIf=\"enableSaveButtonSignal() && !isReadonlySignal()\">\n      <button [disabled]=\"invalid\" fswButton (click)=\"effects.save()\">\n        {{ 'Save Changes' | fswTranslate : { scope: translateScope } }}\n      </button>\n    </ng-container>\n  </ng-template>\n  <form [formGroup]=\"form\" *ngIf=\"builderSignal() as builder\">\n    <fsw-dynamic-builder [builder]=\"builder\">\n      <ng-template fswDynamicBuilderTemplate key=\"comment-readonly\" let-value>\n        <p [innerHTML]=\"format(value)\" class=\"break-words overflow-x-scroll\"></p>\n      </ng-template>\n    </fsw-dynamic-builder>\n  </form>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: FSWDynamicBuilderModule }, { kind: "directive", type: i1$4.FSWDynamicBuilderTemplateDirective, selector: "[fswDynamicBuilderTemplate]", inputs: ["key"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: FSWAlertModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCommentsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-comments', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, standalone: true, imports: [
                        AsyncPipe,
                        FSWButtonModule,
                        FSWDynamicBuilderModule,
                        FSWPanelModule,
                        FSWTranslateModule,
                        NgIf,
                        ReactiveFormsModule,
                        FSWAlertModule,
                    ], providers: [
                        provideUtilsService(),
                        provideApplicationRelationshipService(),
                        provideCreditCommentService(),
                    ], template: "<fsw-panel [title]=\"titleSignal()\">\n  <ng-template fswPanelHeaderSuffix>\n    <ng-container *ngIf=\"enableSaveButtonSignal() && !isReadonlySignal()\">\n      <button [disabled]=\"invalid\" fswButton (click)=\"effects.save()\">\n        {{ 'Save Changes' | fswTranslate : { scope: translateScope } }}\n      </button>\n    </ng-container>\n  </ng-template>\n  <form [formGroup]=\"form\" *ngIf=\"builderSignal() as builder\">\n    <fsw-dynamic-builder [builder]=\"builder\">\n      <ng-template fswDynamicBuilderTemplate key=\"comment-readonly\" let-value>\n        <p [innerHTML]=\"format(value)\" class=\"break-words overflow-x-scroll\"></p>\n      </ng-template>\n    </fsw-dynamic-builder>\n  </form>\n</fsw-panel>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { list: [{
                type: ContentChildren,
                args: [FSWCommentsItemDirective]
            }], title: [{
                type: Input
            }], entityId: [{
                type: Input
            }], identifier: [{
                type: Input
            }], module: [{
                type: Input
            }], category: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], rows: [{
                type: Input
            }], customClasses: [{
                type: Input
            }], enableSaveButton: [{
                type: Input
            }], translateScope: [{
                type: Input
            }] } });

class FSWCommentsSectionComponent {
    constructor() {
        this.data = [];
        this.customClasses = '';
        this.translateScope = 'comments';
        this.isReadonly = false;
        this.enableSaveButton = true;
    }
    get filteredSections() {
        return this.data?.filter((section) => section.items?.length) ?? [];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCommentsSectionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCommentsSectionComponent, isStandalone: true, selector: "fsw-comments-section", inputs: { data: "data", customClasses: "customClasses", translateScope: "translateScope", isReadonly: "isReadonly", enableSaveButton: "enableSaveButton" }, ngImport: i0, template: "<section [class]=\"customClasses || 'w-full flex flex-col gap-4'\" *ngIf=\"filteredSections.length\">\n  <ng-container *ngFor=\"let section of filteredSections || []\">\n    <fsw-panel [title]=\"section.title | fswTranslate : { scope: translateScope }\">\n      <section [class]=\"section.customClasses || 'w-full flex flex-col gap-4'\">\n        <ng-container *ngFor=\"let item of section.items\">\n          <fsw-comments\n            [category]=\"item.category\"\n            [title]=\"item.title | fswTranslate : { scope: translateScope }\"\n            [module]=\"item.module\"\n            [identifier]=\"item.identifier\"\n            [entityId]=\"item.entityId\"\n            [customClasses]=\"item.customClasses || ''\"\n            [enableSaveButton]=\"enableSaveButton\"\n            [isReadonly]=\"isReadonly\"\n            [translateScope]=\"translateScope\"\n          >\n            <ng-container *ngFor=\"let field of item.fields\">\n              <ng-template\n                fswCommentsItem\n                [key]=\"field.key\"\n                [label]=\"field.label | fswTranslate : { scope: translateScope }\"\n              ></ng-template>\n            </ng-container>\n          </fsw-comments>\n        </ng-container>\n      </section>\n    </fsw-panel>\n  </ng-container>\n</section>\n", dependencies: [{ kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: FSWCommentsItemDirective, selector: "ng-template[fswCommentsItem]", inputs: ["label", "key"] }, { kind: "component", type: FSWCommentsComponent, selector: "fsw-comments", inputs: ["title", "entityId", "identifier", "module", "category", "isReadonly", "rows", "customClasses", "enableSaveButton", "translateScope"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCommentsSectionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-comments-section', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [
                        FSWPanelModule,
                        NgForOf,
                        FSWTranslateModule,
                        FSWCommentsItemDirective,
                        FSWCommentsComponent,
                        NgIf,
                    ], template: "<section [class]=\"customClasses || 'w-full flex flex-col gap-4'\" *ngIf=\"filteredSections.length\">\n  <ng-container *ngFor=\"let section of filteredSections || []\">\n    <fsw-panel [title]=\"section.title | fswTranslate : { scope: translateScope }\">\n      <section [class]=\"section.customClasses || 'w-full flex flex-col gap-4'\">\n        <ng-container *ngFor=\"let item of section.items\">\n          <fsw-comments\n            [category]=\"item.category\"\n            [title]=\"item.title | fswTranslate : { scope: translateScope }\"\n            [module]=\"item.module\"\n            [identifier]=\"item.identifier\"\n            [entityId]=\"item.entityId\"\n            [customClasses]=\"item.customClasses || ''\"\n            [enableSaveButton]=\"enableSaveButton\"\n            [isReadonly]=\"isReadonly\"\n            [translateScope]=\"translateScope\"\n          >\n            <ng-container *ngFor=\"let field of item.fields\">\n              <ng-template\n                fswCommentsItem\n                [key]=\"field.key\"\n                [label]=\"field.label | fswTranslate : { scope: translateScope }\"\n              ></ng-template>\n            </ng-container>\n          </fsw-comments>\n        </ng-container>\n      </section>\n    </fsw-panel>\n  </ng-container>\n</section>\n" }]
        }], propDecorators: { data: [{
                type: Input
            }], customClasses: [{
                type: Input
            }], translateScope: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], enableSaveButton: [{
                type: Input
            }] } });

function agingReportTranslation(scope = 'aging_report') {
    return [
        ...(FSWTranslateModule.forFeature({
            scope,
            defaultKey: getCountryCodeFromStorage(),
            data: {
                [CountryCode.MY]: AGING_REPORT_ALL_TRANSLATION,
                [CountryCode.SG]: AGING_REPORT_ALL_TRANSLATION,
                [CountryCode.TH]: AGING_REPORT_ALL_TRANSLATION,
                [CountryCode.VU]: AGING_REPORT_ALL_TRANSLATION,
                [CountryCode.ID]: AGING_REPORT_ALL_TRANSLATION,
            },
        }).providers || []),
        fswTranslateScope(scope),
    ];
}

class FSWAgingReportGridComponent {
    constructor() {
        this.saveChangeEvent = new EventEmitter();
        this.removeEvent = new EventEmitter();
        this.title = null;
        this.builder = null;
        this.form = new UntypedFormGroup({});
        this.isReadonly = false;
        this.formControl = new UntypedFormControl(null, [Validators.required]);
        this.countSignal = signal(0);
    }
    set atDate(atDate) {
        this.formControl.setValue(atDate);
    }
    get array() {
        return getControlFromGroup(this.form, 'agingReport') ?? new UntypedFormArray([]);
    }
    ngOnChanges() {
        this.countSignal.set(this.array.length);
    }
    addCounterParty() {
        this.array.patchValue([...this.array.value, {}]);
        this.countSignal.set(this.array.length);
    }
    delete(index) {
        this.removeEvent.emit({
            index,
            array: this.array,
            cb: () => this.countSignal.set(this.array.length),
        });
    }
    submit() {
        if (this.form.invalid || !this.array.length) {
            return;
        }
        this.saveChangeEvent.emit({
            array: this.array,
            date: this.formControl.value,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAgingReportGridComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWAgingReportGridComponent, isStandalone: true, selector: "fsw-aging-report-grid", inputs: { title: "title", builder: "builder", form: "form", isReadonly: "isReadonly", atDate: "atDate" }, outputs: { saveChangeEvent: "saveChangeEvent", removeEvent: "removeEvent" }, providers: [agingReportTranslation('aging_report_grid')], viewQueries: [{ propertyName: "commentsComponent", first: true, predicate: FSWCommentsComponent, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<section class=\"w-full flex flex-col gap-[8px]\">\n  <header class=\"w-full flex justify-between items-center\">\n    <div class=\"flex items-center gap-[32px] h-fit\">\n      <h6 class=\"text-body-small-600 text-gray-800\">{{ title }}</h6>\n      <div>\n        <fsw-field [readOnly]=\"isReadonly\">\n          <fsw-date-picker\n            [placeHolder]=\"'fields.date' | fswTranslate : { scope: 'aging_report_grid' }\"\n            [formControl]=\"formControl\"\n            [closeOnSelected]=\"true\"\n          ></fsw-date-picker>\n          <ng-template fswFieldReadonly>\n            <span>{{ formControl.value | date : 'dd/MM/yyyy' }}</span>\n          </ng-template>\n        </fsw-field>\n      </div>\n    </div>\n    <button\n      *ngIf=\"!isReadonly\"\n      [disabled]=\"form.invalid || countSignal() === 0\"\n      fswButton\n      (click)=\"submit()\"\n    >\n      {{ 'buttons.save' | fswTranslate : { scope: 'aging_report_grid' } }}\n    </button>\n  </header>\n  <main class=\"w-full overflow-auto\">\n    <ng-container *ngIf=\"builder\">\n      <form [formGroup]=\"form\">\n        <fsw-dynamic-builder [builder]=\"builder\">\n          <ng-template fswDynamicBuilderTemplate key=\"empty_list\">\n            <p class=\"w-full text-center text-yellow-500 font-bold p-[16px]\">\n              {{ 'empty' | fswTranslate : { scope: 'aging_report_grid' } }}\n            </p>\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"counter_party_header\">\n            <span class=\"flex items-center gap-1\">\n              <span class=\"body-small-500\">{{\n                'columns.counter_party' | fswTranslate : { scope: 'aging_report_grid' }\n              }}</span>\n              <i\n                [fswIcon]=\"'common-question-circle-filled'\"\n                class=\"hover:text-primary-500\"\n                fswDropdown\n                [cdkMenuTriggerFor]=\"tooltip\"\n              ></i>\n              <ng-template #tooltip>\n                <fsw-tooltip>\n                  <p\n                    [innerHTML]=\"\n                      'messages.counter_party.one' | fswTranslate : { scope: 'aging_report_grid' }\n                    \"\n                  ></p>\n                  <p\n                    [innerHTML]=\"\n                      'messages.counter_party.two' | fswTranslate : { scope: 'aging_report_grid' }\n                    \"\n                  ></p>\n                  <p\n                    [innerHTML]=\"\n                      'messages.counter_party.three' | fswTranslate : { scope: 'aging_report_grid' }\n                    \"\n                  ></p>\n                </fsw-tooltip>\n              </ng-template>\n            </span>\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"add_aging_report\">\n            <button *ngIf=\"!isReadonly\" fswButton (click)=\"addCounterParty()\" class=\"float-left\">\n              {{ 'buttons.add' | fswTranslate : { scope: 'aging_report_grid' } }}\n            </button>\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"no\" let-index=\"index\">\n            {{ index + 1 }}\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"total_content\">\n            <div class=\"flex justify-between items-center\">\n              <span *ngIf=\"countSignal()\">\n                {{ countSignal() }}\n                {{ 'columns.total_counter_party' | fswTranslate : { scope: 'aging_report_grid' } }}\n              </span>\n              <span>{{ 'columns.total' | fswTranslate : { scope: 'aging_report_grid' } }}</span>\n            </div>\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"delete\" let-index=\"index\">\n            <button\n              *ngIf=\"!isReadonly\"\n              fswButton\n              [appearance]=\"'icon-with-bg'\"\n              [size]=\"'m'\"\n              (click)=\"delete(index)\"\n            >\n              <i [fswIcon]=\"'common-delete-alternative'\"></i>\n            </button>\n          </ng-template>\n        </fsw-dynamic-builder>\n      </form>\n    </ng-container>\n  </main>\n</section>\n", dependencies: [{ kind: "ngmodule", type: FSWFieldModule }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$4.FSWFieldReadonlyDirective, selector: "ng-template[fswFieldReadonly]" }, { kind: "ngmodule", type: FSWDateTimePickerModule }, { kind: "component", type: i1$4.FSWDatePickerComponent, selector: "fsw-date-picker" }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "pipe", type: DatePipe, name: "date" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: FSWDynamicBuilderModule }, { kind: "directive", type: i1$4.FSWDynamicBuilderTemplateDirective, selector: "[fswDynamicBuilderTemplate]", inputs: ["key"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "ngmodule", type: FSWDropdownModule }, { kind: "directive", type: i1$4.FSWDropdownDirective, selector: "[cdkMenuTriggerFor][fswDropdown]", inputs: ["fixedWidth", "allowBackDropClick", "offsetY", "offsetX", "event", "conditional"], exportAs: ["fswDropdown"] }, { kind: "directive", type: CdkMenuTrigger, selector: "[cdkMenuTriggerFor]", inputs: ["cdkMenuTriggerFor", "cdkMenuPosition", "cdkMenuTriggerData"], outputs: ["cdkMenuOpened", "cdkMenuClosed"], exportAs: ["cdkMenuTriggerFor"] }, { kind: "ngmodule", type: FSWTooltipModule }, { kind: "component", type: i1$4.FSWTooltipComponent, selector: "fsw-tooltip" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAgingReportGridComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-aging-report-grid', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [
                        FSWFieldModule,
                        FSWDateTimePickerModule,
                        ReactiveFormsModule,
                        DatePipe,
                        FSWTranslateModule,
                        NgIf,
                        FSWButtonModule,
                        FSWDynamicBuilderModule,
                        FSWIconModule,
                        FSWDropdownModule,
                        CdkMenuTrigger,
                        FSWTooltipModule,
                        NgTemplateOutlet,
                    ], providers: [agingReportTranslation('aging_report_grid')], template: "<section class=\"w-full flex flex-col gap-[8px]\">\n  <header class=\"w-full flex justify-between items-center\">\n    <div class=\"flex items-center gap-[32px] h-fit\">\n      <h6 class=\"text-body-small-600 text-gray-800\">{{ title }}</h6>\n      <div>\n        <fsw-field [readOnly]=\"isReadonly\">\n          <fsw-date-picker\n            [placeHolder]=\"'fields.date' | fswTranslate : { scope: 'aging_report_grid' }\"\n            [formControl]=\"formControl\"\n            [closeOnSelected]=\"true\"\n          ></fsw-date-picker>\n          <ng-template fswFieldReadonly>\n            <span>{{ formControl.value | date : 'dd/MM/yyyy' }}</span>\n          </ng-template>\n        </fsw-field>\n      </div>\n    </div>\n    <button\n      *ngIf=\"!isReadonly\"\n      [disabled]=\"form.invalid || countSignal() === 0\"\n      fswButton\n      (click)=\"submit()\"\n    >\n      {{ 'buttons.save' | fswTranslate : { scope: 'aging_report_grid' } }}\n    </button>\n  </header>\n  <main class=\"w-full overflow-auto\">\n    <ng-container *ngIf=\"builder\">\n      <form [formGroup]=\"form\">\n        <fsw-dynamic-builder [builder]=\"builder\">\n          <ng-template fswDynamicBuilderTemplate key=\"empty_list\">\n            <p class=\"w-full text-center text-yellow-500 font-bold p-[16px]\">\n              {{ 'empty' | fswTranslate : { scope: 'aging_report_grid' } }}\n            </p>\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"counter_party_header\">\n            <span class=\"flex items-center gap-1\">\n              <span class=\"body-small-500\">{{\n                'columns.counter_party' | fswTranslate : { scope: 'aging_report_grid' }\n              }}</span>\n              <i\n                [fswIcon]=\"'common-question-circle-filled'\"\n                class=\"hover:text-primary-500\"\n                fswDropdown\n                [cdkMenuTriggerFor]=\"tooltip\"\n              ></i>\n              <ng-template #tooltip>\n                <fsw-tooltip>\n                  <p\n                    [innerHTML]=\"\n                      'messages.counter_party.one' | fswTranslate : { scope: 'aging_report_grid' }\n                    \"\n                  ></p>\n                  <p\n                    [innerHTML]=\"\n                      'messages.counter_party.two' | fswTranslate : { scope: 'aging_report_grid' }\n                    \"\n                  ></p>\n                  <p\n                    [innerHTML]=\"\n                      'messages.counter_party.three' | fswTranslate : { scope: 'aging_report_grid' }\n                    \"\n                  ></p>\n                </fsw-tooltip>\n              </ng-template>\n            </span>\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"add_aging_report\">\n            <button *ngIf=\"!isReadonly\" fswButton (click)=\"addCounterParty()\" class=\"float-left\">\n              {{ 'buttons.add' | fswTranslate : { scope: 'aging_report_grid' } }}\n            </button>\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"no\" let-index=\"index\">\n            {{ index + 1 }}\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"total_content\">\n            <div class=\"flex justify-between items-center\">\n              <span *ngIf=\"countSignal()\">\n                {{ countSignal() }}\n                {{ 'columns.total_counter_party' | fswTranslate : { scope: 'aging_report_grid' } }}\n              </span>\n              <span>{{ 'columns.total' | fswTranslate : { scope: 'aging_report_grid' } }}</span>\n            </div>\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"delete\" let-index=\"index\">\n            <button\n              *ngIf=\"!isReadonly\"\n              fswButton\n              [appearance]=\"'icon-with-bg'\"\n              [size]=\"'m'\"\n              (click)=\"delete(index)\"\n            >\n              <i [fswIcon]=\"'common-delete-alternative'\"></i>\n            </button>\n          </ng-template>\n        </fsw-dynamic-builder>\n      </form>\n    </ng-container>\n  </main>\n</section>\n" }]
        }], propDecorators: { commentsComponent: [{
                type: ViewChild,
                args: [FSWCommentsComponent]
            }], saveChangeEvent: [{
                type: Output
            }], removeEvent: [{
                type: Output
            }], title: [{
                type: Input
            }], builder: [{
                type: Input
            }], form: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], atDate: [{
                type: Input
            }] } });

class FSWAgingReportConfirmComponent {
    constructor() {
        this.dialogRef = inject((DialogRef));
        this.FSWModalSizes = FSWModalSizes;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAgingReportConfirmComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWAgingReportConfirmComponent, isStandalone: true, selector: "fsw-aging-report-confirm", providers: [agingReportTranslation('aging_report_confirm')], ngImport: i0, template: "<fsw-modal\n  [title]=\"'modal.title' | fswTranslate : { scope: 'aging_report_confirm' }\"\n  (cancelEvent)=\"dialogRef.close(false)\"\n  (confirmEvent)=\"dialogRef.close(true)\"\n  [confirmButton]=\"'buttons.delete' | fswTranslate : { scope: 'aging_report_confirm' }\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate : { scope: 'aging_report_confirm' }\"\n  [hiddenCloseButton]=\"true\"\n  [size]=\"FSWModalSizes.S\"\n>\n  <ng-template fswModalBody>\n    <p>{{ 'modal.description' | fswTranslate : { scope: 'aging_report_confirm' } }}</p>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "ngmodule", type: FSWModalModule$1 }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAgingReportConfirmComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-aging-report-confirm', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [FSWModalModule$1, FSWTranslateModule], providers: [agingReportTranslation('aging_report_confirm')], template: "<fsw-modal\n  [title]=\"'modal.title' | fswTranslate : { scope: 'aging_report_confirm' }\"\n  (cancelEvent)=\"dialogRef.close(false)\"\n  (confirmEvent)=\"dialogRef.close(true)\"\n  [confirmButton]=\"'buttons.delete' | fswTranslate : { scope: 'aging_report_confirm' }\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate : { scope: 'aging_report_confirm' }\"\n  [hiddenCloseButton]=\"true\"\n  [size]=\"FSWModalSizes.S\"\n>\n  <ng-template fswModalBody>\n    <p>{{ 'modal.description' | fswTranslate : { scope: 'aging_report_confirm' } }}</p>\n  </ng-template>\n</fsw-modal>\n" }]
        }] });

class FSWAgingReportComponent {
    constructor() {
        this.applicationIdSignal = signal('');
        this.isReadonlySignal = signal(false);
        this.activeTabSignal = signal(CreditAgingReportTypes.AP);
        this.dialog = inject(Dialog);
        this.injector = inject(Injector);
        this.effects = injectAgingReportEffects({
            applicationIdSignal: this.applicationIdSignal,
            isReadonlySignal: this.isReadonlySignal,
            activeTabSignal: this.activeTabSignal,
        });
        this.apBuilder = this.effects.apBuilder;
        this.arBuilder = this.effects.arBuilder;
        this.atDateSignal = this.effects.atDateSignal;
        this.CreditAgingReportTypes = CreditAgingReportTypes;
        this.effects.init();
    }
    changeTab(tab) {
        this.activeTabSignal.set(tab);
    }
    save(data) {
        const { array, date } = data;
        const value = array.value.map((item) => {
            return {
                ...item,
                atDate: date,
            };
        });
        this.effects.save(value);
    }
    remove(data) {
        const { index, array } = data;
        const value = array.value[index];
        if (!value.id) {
            array.removeAt(index);
            data.cb();
            return;
        }
        this.dialog
            .open(FSWAgingReportConfirmComponent, {
            injector: this.injector,
        })
            .closed.pipe(take(1), tap((check) => {
            if (!check) {
                return;
            }
            this.effects.remove(value.id, () => {
                array.removeAt(index);
                data.cb();
            });
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAgingReportComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWAgingReportComponent, isStandalone: true, selector: "fsw-aging-report", providers: [
            agingReportTranslation(),
            provideUtilsService(),
            provideApplicationRelationshipService(),
            provideCreditAgingReportService(),
        ], ngImport: i0, template: "<fsw-panel [title]=\"'title' | fswTranslate : { scope: 'aging_report' }\">\n  <section class=\"w-full flex flex-col gap-[16px]\">\n    <fsw-tabs-group\n      [customRowGap]=\"'24px'\"\n      [customColumnGap]=\"'24px'\"\n      (activeKeyChange)=\"changeTab($event || CreditAgingReportTypes.AP)\"\n    >\n      <ng-template\n        fswTabs\n        [key]=\"CreditAgingReportTypes.AP\"\n        [maxTextWidth]=\"'unset'\"\n        [label]=\"'tabs.ap' | fswTranslate : { scope: 'aging_report' }\"\n      >\n        <fsw-aging-report-grid\n          [title]=\"'tabs.ap' | fswTranslate : { scope: 'aging_report_grid' }\"\n          [builder]=\"apBuilder\"\n          [form]=\"apBuilder.groupConfig.form\"\n          [isReadonly]=\"isReadonlySignal()\"\n          [atDate]=\"atDateSignal()\"\n          (removeEvent)=\"remove($event)\"\n          (saveChangeEvent)=\"save($event)\"\n        ></fsw-aging-report-grid>\n      </ng-template>\n      <ng-template\n        fswTabs\n        [key]=\"CreditAgingReportTypes.AR\"\n        [maxTextWidth]=\"'unset'\"\n        [label]=\"'tabs.ar' | fswTranslate : { scope: 'aging_report' }\"\n      >\n        <fsw-aging-report-grid\n          [title]=\"'tabs.ar' | fswTranslate : { scope: 'aging_report_grid' }\"\n          [builder]=\"arBuilder\"\n          [form]=\"arBuilder.groupConfig.form\"\n          [isReadonly]=\"isReadonlySignal()\"\n          [atDate]=\"atDateSignal()\"\n          (removeEvent)=\"remove($event)\"\n          (saveChangeEvent)=\"save($event)\"\n        ></fsw-aging-report-grid>\n      </ng-template>\n    </fsw-tabs-group>\n    <fsw-comments\n      [category]=\"'CREDIT'\"\n      [title]=\"'comment.title' | fswTranslate : { scope: 'aging_report' }\"\n      [module]=\"'AGING_REPORT'\"\n      [identifier]=\"'AGING_REPORT'\"\n      [entityId]=\"applicationIdSignal()\"\n      [enableSaveButton]=\"true\"\n      [isReadonly]=\"isReadonlySignal()\"\n      [translateScope]=\"'aging_report'\"\n    >\n      <ng-template\n        fswCommentsItem\n        [key]=\"'main_comment'\"\n        [label]=\"'comment.credit' | fswTranslate : { scope: 'aging_report' }\"\n      ></ng-template>\n    </fsw-comments>\n  </section>\n</fsw-panel>\n", styles: ["fsw-aging-report .fsw-table tbody tr:hover{background-color:transparent}\n"], dependencies: [{ kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "ngmodule", type: FSWTabsModule }, { kind: "component", type: i1$4.FSWTabsGroupComponent, selector: "fsw-tabs-group" }, { kind: "directive", type: i1$4.FSWTabsDirective, selector: "ng-template[fswTabs]" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "component", type: FSWCommentsComponent, selector: "fsw-comments", inputs: ["title", "entityId", "identifier", "module", "category", "isReadonly", "rows", "customClasses", "enableSaveButton", "translateScope"] }, { kind: "component", type: FSWAgingReportGridComponent, selector: "fsw-aging-report-grid", inputs: ["title", "builder", "form", "isReadonly", "atDate"], outputs: ["saveChangeEvent", "removeEvent"] }, { kind: "ngmodule", type: FSWAlertModule }, { kind: "directive", type: FSWCommentsItemDirective, selector: "ng-template[fswCommentsItem]", inputs: ["label", "key"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAgingReportComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-aging-report', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, standalone: true, imports: [
                        FSWPanelModule,
                        FSWTabsModule,
                        FSWTranslateModule,
                        FSWCommentsComponent,
                        FSWAgingReportConfirmComponent,
                        FSWAgingReportGridComponent,
                        FSWAlertModule,
                        FSWCommentsItemDirective,
                    ], providers: [
                        agingReportTranslation(),
                        provideUtilsService(),
                        provideApplicationRelationshipService(),
                        provideCreditAgingReportService(),
                    ], template: "<fsw-panel [title]=\"'title' | fswTranslate : { scope: 'aging_report' }\">\n  <section class=\"w-full flex flex-col gap-[16px]\">\n    <fsw-tabs-group\n      [customRowGap]=\"'24px'\"\n      [customColumnGap]=\"'24px'\"\n      (activeKeyChange)=\"changeTab($event || CreditAgingReportTypes.AP)\"\n    >\n      <ng-template\n        fswTabs\n        [key]=\"CreditAgingReportTypes.AP\"\n        [maxTextWidth]=\"'unset'\"\n        [label]=\"'tabs.ap' | fswTranslate : { scope: 'aging_report' }\"\n      >\n        <fsw-aging-report-grid\n          [title]=\"'tabs.ap' | fswTranslate : { scope: 'aging_report_grid' }\"\n          [builder]=\"apBuilder\"\n          [form]=\"apBuilder.groupConfig.form\"\n          [isReadonly]=\"isReadonlySignal()\"\n          [atDate]=\"atDateSignal()\"\n          (removeEvent)=\"remove($event)\"\n          (saveChangeEvent)=\"save($event)\"\n        ></fsw-aging-report-grid>\n      </ng-template>\n      <ng-template\n        fswTabs\n        [key]=\"CreditAgingReportTypes.AR\"\n        [maxTextWidth]=\"'unset'\"\n        [label]=\"'tabs.ar' | fswTranslate : { scope: 'aging_report' }\"\n      >\n        <fsw-aging-report-grid\n          [title]=\"'tabs.ar' | fswTranslate : { scope: 'aging_report_grid' }\"\n          [builder]=\"arBuilder\"\n          [form]=\"arBuilder.groupConfig.form\"\n          [isReadonly]=\"isReadonlySignal()\"\n          [atDate]=\"atDateSignal()\"\n          (removeEvent)=\"remove($event)\"\n          (saveChangeEvent)=\"save($event)\"\n        ></fsw-aging-report-grid>\n      </ng-template>\n    </fsw-tabs-group>\n    <fsw-comments\n      [category]=\"'CREDIT'\"\n      [title]=\"'comment.title' | fswTranslate : { scope: 'aging_report' }\"\n      [module]=\"'AGING_REPORT'\"\n      [identifier]=\"'AGING_REPORT'\"\n      [entityId]=\"applicationIdSignal()\"\n      [enableSaveButton]=\"true\"\n      [isReadonly]=\"isReadonlySignal()\"\n      [translateScope]=\"'aging_report'\"\n    >\n      <ng-template\n        fswCommentsItem\n        [key]=\"'main_comment'\"\n        [label]=\"'comment.credit' | fswTranslate : { scope: 'aging_report' }\"\n      ></ng-template>\n    </fsw-comments>\n  </section>\n</fsw-panel>\n", styles: ["fsw-aging-report .fsw-table tbody tr:hover{background-color:transparent}\n"] }]
        }], ctorParameters: function () { return []; } });

class FSWAgingReportDirective {
    constructor() {
        this.applicationId = null;
        this.isReadonly = false;
        this.viewContainerRef = inject(ViewContainerRef);
    }
    ngOnChanges() {
        this.render();
    }
    ngOnDestroy() {
        this.viewContainerRef.clear();
    }
    render() {
        this.viewContainerRef.clear();
        if (!this.applicationId) {
            return;
        }
        const ref = this.viewContainerRef.createComponent(FSWAgingReportComponent);
        const instance = ref.instance;
        instance.applicationIdSignal.set(this.applicationId);
        instance.isReadonlySignal.set(this.isReadonly);
        ref.changeDetectorRef.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAgingReportDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWAgingReportDirective, isStandalone: true, selector: "[fswAgingReport]", inputs: { applicationId: "applicationId", isReadonly: "isReadonly" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAgingReportDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswAgingReport]',
                    standalone: true,
                }]
        }], propDecorators: { applicationId: [{
                type: Input,
                args: [{ required: true }]
            }], isReadonly: [{
                type: Input
            }] } });

var FormKeys$2;
(function (FormKeys) {
    FormKeys["NAME"] = "name";
    FormKeys["DATE"] = "date";
    FormKeys["NUMBER"] = "number";
    FormKeys["TYPE"] = "type";
    FormKeys["LEAD_SOURCE"] = "lead_source";
    FormKeys["IS_STARTUP"] = "is_startup";
    FormKeys["STATUS"] = "status";
})(FormKeys$2 || (FormKeys$2 = {}));

const ID_FORM_CONFIG$2 = {
    setup(translate, formData, referenceData, isReadonly = false) {
        return {
            formFields: [
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$2.NAME,
                    label: translate[FormKeys$2.NAME],
                    param: [
                        { value: formData && formData[FormKeys$2.NAME], disabled: false },
                        Validators.required,
                    ],
                },
                {
                    type: FIELD_TYPE.DATE,
                    key: FormKeys$2.DATE,
                    label: translate[FormKeys$2.DATE],
                    param: [
                        { value: formData && formData[FormKeys$2.DATE], disabled: false },
                        Validators.required,
                    ],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$2.NUMBER,
                    label: translate[FormKeys$2.NUMBER],
                    param: [
                        { value: formData && formData[FormKeys$2.NUMBER], disabled: true },
                        Validators.required,
                    ],
                    context: {
                        isReadonly: true,
                    },
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: FormKeys$2.TYPE,
                    label: translate[FormKeys$2.TYPE],
                    param: [
                        { value: formData && formData[FormKeys$2.TYPE], disabled: false },
                        Validators.required,
                    ],
                    options: referenceData?.applicationTypes?.map((i) => ({ value: i, label: i })) || [],
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: FormKeys$2.LEAD_SOURCE,
                    label: translate[FormKeys$2.LEAD_SOURCE],
                    param: [
                        { value: formData && formData[FormKeys$2.LEAD_SOURCE], disabled: false },
                        Validators.required,
                    ],
                    options: referenceData?.leadSources?.map((i) => ({ value: i, label: i })) || [],
                },
                {
                    type: FIELD_TYPE.RADIO,
                    key: FormKeys$2.IS_STARTUP,
                    label: translate[FormKeys$2.IS_STARTUP],
                    param: [
                        {
                            value: formData && formData.additional_data[FormKeys$2.IS_STARTUP],
                            disabled: false,
                        },
                        Validators.required,
                    ],
                    options: YES_NO_OPTIONS,
                    context: {
                        inline: true,
                        template: (value) => getOptionLabel(value, YES_NO_OPTIONS),
                    },
                },
            ],
            formData,
            formFieldConfig: {
                hideAllCTAs: isReadonly,
            },
        };
    },
    reset(oldConfig) {
        return {
            ...oldConfig,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        };
    },
    getValue(form, formData) {
        return {
            ...formData,
            ...form.value,
        };
    },
};

const SG_FORM_CONFIG$2 = {
    setup(translate, formData, referenceData, isReadonly = false) {
        return {
            formFields: [
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$2.NAME,
                    label: translate[FormKeys$2.NAME],
                    param: [
                        { value: formData && formData[FormKeys$2.NAME], disabled: false },
                        Validators.required,
                    ],
                },
                {
                    type: FIELD_TYPE.DATE,
                    key: FormKeys$2.DATE,
                    label: translate[FormKeys$2.DATE],
                    param: [
                        { value: formData && formData[FormKeys$2.DATE], disabled: false },
                        Validators.required,
                    ],
                    context: {
                        isReadonly: true,
                    },
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$2.NUMBER,
                    label: translate[FormKeys$2.NUMBER],
                    param: [
                        { value: formData && formData[FormKeys$2.NUMBER], disabled: true },
                        Validators.required,
                    ],
                    context: {
                        isReadonly: true,
                    },
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: FormKeys$2.TYPE,
                    label: translate[FormKeys$2.TYPE],
                    param: [
                        { value: formData && formData[FormKeys$2.TYPE], disabled: false },
                        Validators.required,
                    ],
                    options: referenceData?.applicationTypes?.map((i) => ({ value: i, label: i })) || [],
                    context: {
                        isReadonly: true,
                    },
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: FormKeys$2.STATUS,
                    label: translate[FormKeys$2.STATUS],
                    param: [
                        { value: formData && formData[FormKeys$2.STATUS], disabled: false },
                        Validators.required,
                    ],
                    context: {
                        isReadonly: true,
                    },
                },
            ],
            formData,
            formFieldConfig: {
                hideAllCTAs: isReadonly,
            },
        };
    },
    reset(oldConfig) {
        return {
            ...oldConfig,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        };
    },
    getValue(form, formData) {
        return {
            ...formData,
            ...form.value,
        };
    },
};

const FORM_CONFIG_TOKEN$2 = new InjectionToken('FORM_CONFIG_TOKEN');

var header$e = {
	title: "Application Details"
};
var form_fields$8 = {
	name: "Application Name",
	date: "Application Date",
	number: "Application Number",
	type: "Application Type",
	status: "Application Status"
};
var buttons$12 = {
	cancel: "Cancel",
	save_changes: "Save Changes"
};
var sg$7 = {
	header: header$e,
	form_fields: form_fields$8,
	buttons: buttons$12
};

var sg$8 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$12,
    default: sg$7,
    form_fields: form_fields$8,
    header: header$e
});

var header$d = {
	title: "Application Details"
};
var form_fields$7 = {
	name: "Application Name",
	date: "Application Date",
	number: "Application Number",
	type: "Application Type",
	lead_source: "Lead Source",
	is_startup: "Is Startup?"
};
var buttons$11 = {
	cancel: "Cancel",
	save_changes: "Save Changes"
};
var id$b = {
	header: header$d,
	form_fields: form_fields$7,
	buttons: buttons$11
};

var id$c = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$11,
    default: id$b,
    form_fields: form_fields$7,
    header: header$d
});

const TRANSLATION_LOADER$5 = {
    default: () => Promise.resolve(sg$8),
    [CountryCode.SG]: () => Promise.resolve(sg$8),
    [CountryCode.ID]: () => Promise.resolve(id$c),
};

let ApplicationDetailStore = class ApplicationDetailStore extends ComponentStore {
    constructor(_applicationService, _settingsService, _stateOverride = {}) {
        super({
            countryCode: null,
            applicationId: null,
            application: null,
            referenceData: {
                applicationTypes: [],
                leadSources: [],
            },
            errors: [],
            // isFormSaved: false,
            ..._stateOverride,
        });
        this._applicationService = _applicationService;
        this._settingsService = _settingsService;
        this._stateOverride = _stateOverride;
        this.setApplicationId = this.updater((state, applicationId) => {
            return { ...state, applicationId };
        });
        this.setApplication = this.updater((state, application) => {
            return { ...state, application };
        });
        this.setReferenceData = this.updater((state, referenceData) => {
            return { ...state, referenceData };
        });
        this.setErrors = this.updater((state, errors) => {
            return { ...state, errors };
        });
        this.getApplication = this.effect(pipe(switchMap(() => this._getApplicationAsync())));
        this.updateApplication = this.effect(pipe(switchMap(({ application }) => this._updateApplicationAsync(application))));
        this.getReferenceData = this.effect(pipe(switchMap(() => this._getReferenceDataAsync())));
        this.saveChanges = this.effect(pipe(tap(({ application }) => {
            if (this.get().applicationId) {
                this.updateApplication({ application });
            }
            else {
                throw new Error('No applicationId exists');
            }
        })));
    }
    _getApplicationAsync() {
        if (!isStringValid(this.state().applicationId))
            return EMPTY;
        return this._applicationService.getApplication(this.state().applicationId).pipe(tap((application) => this.setApplication(application)), catchError((err) => {
            console.error(err);
            this.setErrors([
                ...this.state().errors,
                `Error: [GET]: /aps/v1/applications/${this.state().applicationId}`,
            ]);
            return EMPTY;
        }));
    }
    _updateApplicationAsync(payload) {
        if (!isStringValid(this.state().applicationId))
            return EMPTY;
        return this._applicationService
            .updateApplication(this.state().applicationId, payload)
            .pipe(switchMap(() => this._getApplicationAsync()), catchError((err) => {
            console.error(err);
            this.setErrors([
                ...this.state().errors,
                `Error: [PUT]: /aps/v1/applications/${payload?.id}`,
            ]);
            return EMPTY;
        }));
    }
    _getReferenceDataAsync() {
        return this._settingsService.getSettings().pipe(tap(({ application_type, lead_source }) => {
            this.setReferenceData({
                applicationTypes: application_type || [],
                leadSources: lead_source || [],
            });
        }), catchError((err) => {
            console.error(err);
            this.setErrors([...this.state().errors, `Error: [GET]: /aps/v1/settings`]);
            return EMPTY;
        }));
    }
};
ApplicationDetailStore = __decorate([
    __param(0, Inject(APPLICATION_SERVICE_TOKEN)),
    __param(1, Inject(SETTINGS_SERVICE_TOKEN)),
    __metadata("design:paramtypes", [Object, Object, Object])
], ApplicationDetailStore);

class IDApplicationDetailStore extends ApplicationDetailStore {
    constructor(_applicationService, _settingsService) {
        super(_applicationService, _settingsService, { countryCode: CountryCode.ID });
        this._applicationService = _applicationService;
        this._settingsService = _settingsService;
    }
    init() {
        this.getApplication();
        this.getReferenceData();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDApplicationDetailStore, deps: [{ token: APPLICATION_SERVICE_TOKEN }, { token: SETTINGS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDApplicationDetailStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDApplicationDetailStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SETTINGS_SERVICE_TOKEN]
                }] }]; } });

class SGApplicationDetailStore extends ApplicationDetailStore {
    constructor(_applicationService, _settingsService) {
        super(_applicationService, _settingsService, { countryCode: CountryCode.SG });
        this._applicationService = _applicationService;
        this._settingsService = _settingsService;
    }
    init() {
        this.getApplication();
        this.getReferenceData();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SGApplicationDetailStore, deps: [{ token: APPLICATION_SERVICE_TOKEN }, { token: SETTINGS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SGApplicationDetailStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SGApplicationDetailStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SETTINGS_SERVICE_TOKEN]
                }] }]; } });

const STORE_TOKEN$7 = new InjectionToken('STORE_TOKEN');

class ApplicationDetailComponent {
    set applicationId(value) {
        this._store.setApplicationId(value);
    }
    constructor(_formConfig, _store, _scope, _translateService) {
        this._formConfig = _formConfig;
        this._store = _store;
        this._scope = _scope;
        this._translateService = _translateService;
        this.isReadonly = false;
        this._changeTabStatusSub = new Subject();
        this.changeTabStatus$ = this._changeTabStatusSub.asObservable();
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'header'),
            this._translateService.selectFeatureTranslate(this._scope, 'form_fields'),
        ]).pipe(map(([header, form_fields]) => ({
            header,
            form_fields,
        })));
        this.vm$ = combineLatest([this._store.state$, this.translate$]).pipe(map(([state, translate]) => ({
            state,
            translate,
        })), tap(({ state, translate }) => {
            if (state.application &&
                state.referenceData.applicationTypes &&
                state.referenceData.leadSources)
                this.config = this._formConfig.setup(translate.form_fields, state.application, {
                    applicationTypes: state.referenceData.applicationTypes,
                    leadSources: state.referenceData.leadSources,
                }, this.isReadonly);
        }));
    }
    ngOnInit() {
        this._store.init();
    }
    onSubmit(evt) {
        if (!evt.valid)
            return;
        this._store.saveChanges(this._store.state().countryCode === CountryCode.SG
            ? {
                application: {
                    ...this._store.state().application,
                    name: evt?.value.name,
                },
            }
            : {
                application: {
                    ...this._store.state().application,
                    ...evt?.value,
                    additional_data: {
                        ...this._store.state().application?.additional_data,
                        is_startup: evt?.value.is_startup,
                    },
                },
            });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationDetailComponent, deps: [{ token: FORM_CONFIG_TOKEN$2 }, { token: STORE_TOKEN$7 }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ApplicationDetailComponent, selector: "ng-component", inputs: { applicationId: "applicationId", isReadonly: "isReadonly" }, providers: [
            {
                provide: TRANSLOCO_SCOPE,
                useValue: {
                    scope: 'application-detail',
                    loader: TRANSLATION_LOADER$5,
                },
            },
        ], ngImport: i0, template: `
    <div class="cbs-form__container" *ngIf="vm$ | async as vm">
      <header>
        <h6>{{ vm.translate.header.title }}</h6>
      </header>
      <div>
        <ng-container *ngIf="vm.state?.errors as errorList">
          <div class="error__message" *ngFor="let errStr of errorList">{{ errStr }}</div>
        </ng-container>
      </div>
      <fsw-form-widget
        #widget
        *ngIf="config"
        [isReadonly]="isReadonly"
        [formConfig]="config"
        (submitForm)="onSubmit($event)"
      ></fsw-form-widget>
    </div>
  `, isInline: true, styles: [".error__message{color:#cc1830;font-size:14px}:host .cbs-form__container{padding:16px;width:50%;display:flex;flex-direction:column;gap:16px;border-radius:4px;border:1px solid #e0e0e0}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FormWidgetComponent, selector: "fsw-form-widget", inputs: ["formConfig", "loading", "isReadonly"], outputs: ["initializeWidget", "closeForm", "submitForm"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationDetailComponent, decorators: [{
            type: Component,
            args: [{ template: `
    <div class="cbs-form__container" *ngIf="vm$ | async as vm">
      <header>
        <h6>{{ vm.translate.header.title }}</h6>
      </header>
      <div>
        <ng-container *ngIf="vm.state?.errors as errorList">
          <div class="error__message" *ngFor="let errStr of errorList">{{ errStr }}</div>
        </ng-container>
      </div>
      <fsw-form-widget
        #widget
        *ngIf="config"
        [isReadonly]="isReadonly"
        [formConfig]="config"
        (submitForm)="onSubmit($event)"
      ></fsw-form-widget>
    </div>
  `, changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        {
                            provide: TRANSLOCO_SCOPE,
                            useValue: {
                                scope: 'application-detail',
                                loader: TRANSLATION_LOADER$5,
                            },
                        },
                    ], styles: [".error__message{color:#cc1830;font-size:14px}:host .cbs-form__container{padding:16px;width:50%;display:flex;flex-direction:column;gap:16px;border-radius:4px;border:1px solid #e0e0e0}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FORM_CONFIG_TOKEN$2]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [STORE_TOKEN$7]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }]; }, propDecorators: { applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

const ID_PROVIDERS$b = [
    {
        provide: FORM_CONFIG_TOKEN$2,
        useValue: ID_FORM_CONFIG$2,
    },
    {
        provide: STORE_TOKEN$7,
        useClass: IDApplicationDetailStore,
        deps: [APPLICATION_SERVICE_TOKEN, SETTINGS_SERVICE_TOKEN],
    },
];

const SG_PROVIDERS$6 = [
    {
        provide: FORM_CONFIG_TOKEN$2,
        useValue: SG_FORM_CONFIG$2,
    },
    {
        provide: STORE_TOKEN$7,
        useClass: SGApplicationDetailStore,
        deps: [APPLICATION_SERVICE_TOKEN, SETTINGS_SERVICE_TOKEN],
    },
];

const PROVIDERS_MAP$b = {
    default: SG_PROVIDERS$6,
    [CountryCode.SG]: SG_PROVIDERS$6,
    [CountryCode.ID]: ID_PROVIDERS$b,
};
const applicationDetailLoadProviders = (countryCode) => [
    ...getCustomProviders(PROVIDERS_MAP$b, SG_PROVIDERS$6, countryCode),
];

class ApplicationDetailModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationDetailModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ApplicationDetailModule, declarations: [ApplicationDetailComponent], imports: [CommonModule,
            LetDirective,
            FormWidgetModule,
            UtilsServiceModule,
            SettingsServiceModule,
            ApplicationServiceModule], exports: [ApplicationDetailComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationDetailModule, imports: [CommonModule,
            FormWidgetModule,
            UtilsServiceModule,
            SettingsServiceModule,
            ApplicationServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationDetailModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        LetDirective,
                        FormWidgetModule,
                        UtilsServiceModule,
                        SettingsServiceModule,
                        ApplicationServiceModule,
                    ],
                    declarations: [ApplicationDetailComponent],
                    exports: [ApplicationDetailComponent],
                }]
        }] });

var header$c = {
	accounts_and_statements: "Bank Accounts & Statements",
	analysis_reports: "Bank Tabulations",
	non_trade_reports: "Non-Trade Transactions"
};
var bank_accounts_and_statements$2 = {
	title: "Bank Accounts & Statements",
	sub_title: "Uploaded Bank Statements",
	notes: {
		note_1: "Maximum 6 Bank statements can be uploaded at a time.",
		note_2: "Only PDF files are allowed to be uploaded."
	},
	form_fields: {
		bank_name: "Bank Name",
		account_name: "Account Name",
		account_number: "Account Number",
		account_type: "Account Type",
		currency: "Currency",
		parser: "Parser",
		from_date: "From Date",
		to_date: "To Date"
	},
	grid_fields: {
		bank_name: "Bank Name",
		account_number: "Account Number",
		account_name: "Account Name",
		account_type: "Account Type",
		currency: "Currency",
		parsing_status: "Parsing Status",
		message: "Error",
		period: "Period",
		from_date: "From",
		to_date: "To",
		file_name: "File Name",
		bank_statements: "Bank Statements"
	},
	buttons: {
		add_bank_account: "Add Bank Account",
		upload_statements: "Upload Bank Statements",
		check_parsing_status: "Check Parsing Status"
	}
};
var bank_tabulations$2 = {
	title_1: "Bank Tabulation",
	title_2: "Summary of Bank Tabulations",
	form_fields_1: {
		bank_name: "Bank Name",
		account_number: "Account Number",
		currency: "Currency",
		overdraft_limit: "Overdraft Limit"
	},
	grid_fields_1: {
		month: "Month",
		perc_change: "% Change",
		bank_deposit: "Bank Deposit",
		bank_withdrawal: "Bank Withdrawal",
		closing_balance: "Closing Balance",
		average_daily_closing_balance: "Average Daily Closing Balance",
		non_business_income: "Non-Business Income",
		adjusted_deposits: "Adjusted Deposits",
		total: "Total",
		average: "Average"
	},
	form_fields_2: {
		from: "From",
		to: "To",
		no_of_months: "No. of Months"
	},
	grid_fields_2: {
		bank_name: "Bank Name",
		account_number: "Account Number",
		currency: "Currency",
		rate: "Rate",
		average_deposit: "Average Deposit",
		average_withdrawal: "Average Withdrawal",
		average_closing_balance: "Average Closing Balance",
		average_daily_running_balance: "Average Daily Running Balance",
		latest_closing_balance: "Latest Closing Balance",
		summary: "Summary"
	},
	buttons: {
		add_bank_tabulation: "Add Bank Tabulation",
		delete_bank_tabulation: "Delete Bank Tabulation"
	},
	modals: {
		delete_bank_tabulation: {
			title: "Delete Bank Tabulation",
			message: "Are you sure you want to delete this bank tabulation?",
			sub_title: "Once you remove this bank tabulation, you will no longer have access anymore"
		}
	}
};
var non_trade_transactions$2 = {
	title_1: "Non-Trade Transaction",
	title_2: "Manual Override Justification",
	buttons: {
		edit_entires: "Edit Entries",
		add_entry: "Add Entry"
	}
};
var buttons$10 = {
	cancel: "Cancel",
	save: "Save",
	confirm: "Confirm"
};
var comment$8 = {
	factsheet: "Factsheet Comments",
	credit: "Credit Comments"
};
var my$k = {
	header: header$c,
	bank_accounts_and_statements: bank_accounts_and_statements$2,
	bank_tabulations: bank_tabulations$2,
	non_trade_transactions: non_trade_transactions$2,
	buttons: buttons$10,
	comment: comment$8
};

var my$l = /*#__PURE__*/Object.freeze({
    __proto__: null,
    bank_accounts_and_statements: bank_accounts_and_statements$2,
    bank_tabulations: bank_tabulations$2,
    buttons: buttons$10,
    comment: comment$8,
    default: my$k,
    header: header$c,
    non_trade_transactions: non_trade_transactions$2
});

var header$b = {
	accounts_and_statements: "Bank Accounts & Statements",
	analysis_reports: "Bank Tabulations",
	non_trade_reports: "Non-Trade Transactions"
};
var bank_accounts_and_statements$1 = {
	title: "Bank Accounts & Statements",
	sub_title: "Uploaded Bank Statements",
	notes: {
		note_1: "Maximum 6 Bank statements can be uploaded at a time.",
		note_2: "Only PDF files are allowed to be uploaded."
	},
	form_fields: {
		bank_name: "Bank Name",
		account_name: "Account Name",
		account_number: "Account Number",
		account_type: "Account Type",
		currency: "Currency",
		parser: "Parser",
		from_date: "From Date",
		to_date: "To Date"
	},
	grid_fields: {
		bank_name: "Bank Name",
		account_number: "Account Number",
		account_name: "Account Name",
		account_type: "Account Type",
		currency: "Currency",
		parsing_status: "Parsing Status",
		message: "Error",
		period: "Period",
		from_date: "From",
		to_date: "To",
		file_name: "File Name",
		bank_statements: "Bank Statements"
	},
	buttons: {
		add_bank_account: "Add Bank Account",
		upload_statements: "Upload Bank Statements",
		check_parsing_status: "Check Parsing Status"
	}
};
var bank_tabulations$1 = {
	title_1: "Bank Tabulation",
	title_2: "Summary of Bank Tabulations",
	form_fields_1: {
		bank_name: "Bank Name",
		account_number: "Account Number",
		currency: "Currency",
		overdraft_limit: "Overdraft Limit"
	},
	grid_fields_1: {
		month: "Month",
		perc_change: "% Change",
		bank_deposit: "Bank Deposit",
		bank_withdrawal: "Bank Withdrawal",
		closing_balance: "Closing Balance",
		average_daily_closing_balance: "Average Daily Closing Balance",
		non_business_income: "Non-Business Income",
		adjusted_deposits: "Adjusted Deposits",
		total: "Total",
		average: "Average"
	},
	form_fields_2: {
		from: "From",
		to: "To",
		no_of_months: "No. of Months"
	},
	grid_fields_2: {
		bank_name: "Bank Name",
		account_number: "Account Number",
		currency: "Currency",
		rate: "Rate",
		average_deposit: "Average Deposit",
		average_withdrawal: "Average Withdrawal",
		average_closing_balance: "Average Closing Balance",
		average_daily_running_balance: "Average Daily Running Balance",
		latest_closing_balance: "Latest Closing Balance",
		summary: "Summary"
	},
	buttons: {
		add_bank_tabulation: "Add Bank Tabulation",
		delete_bank_tabulation: "Delete Bank Tabulation"
	},
	modals: {
		delete_bank_tabulation: {
			title: "Delete Bank Tabulation",
			message: "Are you sure you want to delete this bank tabulation?",
			sub_title: "Once you remove this bank tabulation, you will no longer have access anymore"
		}
	}
};
var non_trade_transactions$1 = {
	title_1: "Non-Trade Transaction",
	title_2: "Manual Override Justification",
	buttons: {
		edit_entires: "Edit Entries",
		add_entry: "Add Entry"
	}
};
var buttons$$ = {
	cancel: "Cancel",
	save: "Save",
	confirm: "Confirm"
};
var comment$7 = {
	factsheet: "Factsheet Comments",
	credit: "Credit Comments"
};
var vu$4 = {
	header: header$b,
	bank_accounts_and_statements: bank_accounts_and_statements$1,
	bank_tabulations: bank_tabulations$1,
	non_trade_transactions: non_trade_transactions$1,
	buttons: buttons$$,
	comment: comment$7
};

var vu$5 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    bank_accounts_and_statements: bank_accounts_and_statements$1,
    bank_tabulations: bank_tabulations$1,
    buttons: buttons$$,
    comment: comment$7,
    default: vu$4,
    header: header$b,
    non_trade_transactions: non_trade_transactions$1
});

var header$a = {
	accounts_and_statements: "Bank Accounts & Statements",
	analysis_reports: "Bank Tabulations",
	non_trade_reports: "Non-Trade Transactions"
};
var bank_accounts_and_statements = {
	title: "Bank Accounts & Statements",
	sub_title: "Uploaded Bank Statements",
	notes: {
		note_1: "Maximum 6 Bank statements can be uploaded at a time.",
		note_2: "Only PDF files are allowed to be uploaded."
	},
	form_fields: {
		bank_name: "Bank Name",
		account_name: "Account Name",
		account_number: "Account Number",
		account_type: "Account Type",
		currency: "Currency",
		parser: "Parser",
		from_date: "From Date",
		to_date: "To Date"
	},
	grid_fields: {
		bank_name: "Bank Name",
		account_number: "Account Number",
		account_name: "Account Name",
		account_type: "Account Type",
		currency: "Currency",
		parsing_status: "Parsing Status",
		message: "Error",
		period: "Period",
		from_date: "From",
		to_date: "To",
		file_name: "File Name",
		bank_statements: "Bank Statements"
	},
	buttons: {
		add_bank_account: "Add Bank Account",
		upload_statements: "Upload Bank Statements",
		check_parsing_status: "Check Parsing Status"
	}
};
var bank_tabulations = {
	title_1: "Bank Tabulation",
	title_2: "Summary of Bank Tabulations",
	form_fields_1: {
		bank_name: "Bank Name",
		account_number: "Account Number",
		currency: "Currency",
		overdraft_limit: "Overdraft Limit"
	},
	grid_fields_1: {
		month: "Month",
		perc_change: "% Change",
		bank_deposit: "Bank Deposit",
		bank_withdrawal: "Bank Withdrawal",
		closing_balance: "Closing Balance",
		average_daily_closing_balance: "Average Daily Closing Balance",
		non_business_income: "Non-Business Income",
		adjusted_deposits: "Adjusted Deposits",
		total: "Total",
		average: "Average"
	},
	form_fields_2: {
		from: "From",
		to: "To",
		no_of_months: "No. of Months"
	},
	grid_fields_2: {
		bank_name: "Bank Name",
		account_number: "Account Number",
		currency: "Currency",
		rate: "Rate",
		average_deposit: "Average Deposit",
		average_withdrawal: "Average Withdrawal",
		average_closing_balance: "Average Closing Balance",
		average_daily_running_balance: "Average Daily Running Balance",
		latest_closing_balance: "Latest Closing Balance",
		summary: "Summary"
	},
	buttons: {
		add_bank_tabulation: "Add Bank Tabulation",
		delete_bank_tabulation: "Delete Bank Tabulation"
	},
	modals: {
		delete_bank_tabulation: {
			title: "Delete Bank Tabulation",
			message: "Are you sure you want to delete this bank tabulation?",
			sub_title: "Once you remove this bank tabulation, you will no longer have access anymore"
		}
	}
};
var non_trade_transactions = {
	title_1: "Non-Trade Transaction",
	title_2: "Manual Override Justification",
	buttons: {
		edit_entires: "Edit Entries",
		add_entry: "Add Entry"
	}
};
var buttons$_ = {
	cancel: "Cancel",
	save: "Save",
	confirm: "Confirm"
};
var comment$6 = {
	factsheet: "Factsheet Comments",
	credit: "Credit Comments"
};
var id$9 = {
	header: header$a,
	bank_accounts_and_statements: bank_accounts_and_statements,
	bank_tabulations: bank_tabulations,
	non_trade_transactions: non_trade_transactions,
	buttons: buttons$_,
	comment: comment$6
};

var id$a = /*#__PURE__*/Object.freeze({
    __proto__: null,
    bank_accounts_and_statements: bank_accounts_and_statements,
    bank_tabulations: bank_tabulations,
    buttons: buttons$_,
    comment: comment$6,
    default: id$9,
    header: header$a,
    non_trade_transactions: non_trade_transactions
});

const TRANSLATION_LOADER$4 = {
    default: () => Promise.resolve(my$l),
    [CountryCode.MY]: () => Promise.resolve(my$l),
    [CountryCode.VU]: () => Promise.resolve(vu$5),
    [CountryCode.ID]: () => Promise.resolve(id$a),
};
const BANK_STATEMENT_ANALYSIS_TRANSLATION = {
    [CountryCode.MY]: my$l,
    [CountryCode.VU]: vu$5,
    [CountryCode.ID]: id$a,
};

const REF_DATA_CATEGORIES = [
    'LOAN DISBURSED',
    'TRANSFER FROM SELF',
    'TRANSFER FROM RELATED PARTIES',
    'OTHERS',
];
const createNonTradeBankUIMap = (nonTradeBankReports) => {
    const map = {};
    if (!nonTradeBankReports?.length) {
        throw new Error(`[getNonTradeTransactions] No bank_accounts found`);
    }
    nonTradeBankReports.forEach((bankAccount) => {
        let { non_trade_categorization } = bankAccount;
        const { account_id, account_name, account_number, bank_name, currency, monthly_totals, override_metadata, } = bankAccount;
        const dataSource = [];
        let nonTradeColumns = [];
        const allDates = [];
        const monthlyTotalRow = {
            transferFrom: 'Monthly Total',
            transferCategory: 'Monthly Total',
            total_myr: null,
        };
        if (!non_trade_categorization?.length) {
            console.error(`No non_trade_categorization found for account: ${account_id}`);
            non_trade_categorization = [
                {
                    category: 'Others',
                    sub_categories: [
                        {
                            name: 'other',
                            data: monthly_totals?.data || [],
                            total_amount: 10,
                        },
                    ],
                },
            ];
            // return;
        }
        non_trade_categorization.forEach((report) => {
            const subCategoryDataLen = report.sub_categories && report.sub_categories[0]?.data?.length;
            if (!subCategoryDataLen) {
                console.error(`No sub category data found for ${report.category}`);
            }
            const dataSourceObj = Array(subCategoryDataLen)
                .fill(null)
                .reduce((acc, curr, index) => {
                acc.a[`month_${index + 1}`] = null;
                acc.b.push(`month_${index + 1}`);
                return acc;
            }, {
                a: {
                    transferFrom: report.category,
                    transferCategory: report.category,
                    isCategory: true,
                    total_myr: null,
                },
                b: ['transferFrom', 'total_myr'],
            });
            dataSource.push(dataSourceObj.a);
            nonTradeColumns = [...dataSourceObj.b];
            report.sub_categories.forEach((subCategoryItem, i) => {
                const dataSourceObjTemp = subCategoryItem.data.reduce((acc, curr, index) => {
                    allDates.push(subCategoryItem.data[index].date);
                    acc[`month_${index + 1}`] = curr?.value || 0;
                    monthlyTotalRow[`month_${index + 1}`] =
                        (monthlyTotalRow[`month_${index + 1}`] || 0) + curr?.value || 0;
                    acc.total_myr += curr?.value || 0;
                    monthlyTotalRow.total_myr += curr?.value || 0;
                    return acc;
                }, {
                    transferFrom: subCategoryItem?.name,
                    transferCategory: report?.category,
                    isCategory: false,
                    total_myr: 0,
                });
                dataSource.push(dataSourceObjTemp);
            });
        });
        dataSource.push(monthlyTotalRow);
        const tempArr = Array.from(new Set(allDates));
        const nonTradeDisplayedColumns = ['Transfer from', ...tempArr, 'Total Amount (MYR)'];
        const nonTradeColumnMappings = {
            'Transfer from': 'transferFrom',
            ...nonTradeDisplayedColumns.slice(1, -1).reduce((acc, month, index) => {
                acc[month] = `month_${index + 1}`;
                return acc;
            }, {}),
            'Total Amount (MYR)': 'total_myr',
        };
        map[account_id] = {
            account_id,
            account_name,
            account_number,
            bank_name,
            currency,
            uiModel: {
                dataSource,
                nonTradeColumns,
                nonTradeDisplayedColumns,
                nonTradeColumnMappings,
                refData: {
                    categories: [
                        'Loan Disbursed',
                        'Transfer from Self',
                        'Transfer from Related Parties',
                        'Others',
                    ],
                    overrideReasons: [
                        'Incorrect Transfer from Self',
                        'Incorrect Transfer from Related Parties',
                        'Incorrect Loan Disburse Details',
                        'Incorrect Other Details',
                    ],
                },
            },
            override_metadata,
            monthly_totals,
        };
    });
    return map;
};

const INITIAL_STATE$5 = {
    countryCode: null,
    applicationId: null,
    username: null,
    bankAccounts: [],
    bankAccountsWithStatementsMap: null,
    bankAnalysisReportMap: null,
    nonTradeBankReports: [],
    nonTradeBankUIMap: null,
    referenceData: {
        currencies: [],
        banks: [],
        bankAccountTypes: [],
        banksMap: {},
        exchangeRatesContent: null,
    },
    uiAsyncStatus: {
        bankAccountWithStatementsAdded: '',
        nonTradeNewEntryAdded: '',
    },
    isBankAnalysisReportsUpdated: false,
    isNonTradeReportsUpdated: false,
    errors: [],
    useMock: false,
    hiddenComments: [],
    comments: [],
    selectedBankAccountRow: null,
    isResendToPerfiosComplete: false,
};
let BankStatementAnalysisStore = class BankStatementAnalysisStore extends ComponentStore {
    // constructor
    constructor(bankAccountsAndStatementsService, bankTabulationsService, nonTradeTransactionsService, masterDataService, blobService, _stateOverride = {}) {
        super({
            ...INITIAL_STATE$5,
            ..._stateOverride,
        });
        this.bankAccountsAndStatementsService = bankAccountsAndStatementsService;
        this.bankTabulationsService = bankTabulationsService;
        this.nonTradeTransactionsService = nonTradeTransactionsService;
        this.masterDataService = masterDataService;
        this.blobService = blobService;
        this._stateOverride = _stateOverride;
        this.domSanitizer = inject(DomSanitizer);
        // GET Calls
        this.getReferenceData = this.effect(pipe(switchMap(() => this._getReferenceDataAsync())));
        this.getBankAccountParseStatus = this.effect(pipe(switchMap(() => this._getBankAccountParseStatusAsync())));
        this.getBankAccountParseStatusWithCallBack = this.effect(pipe(switchMap((cb) => this._getBankAccountParseStatusAsync().pipe(tap(() => cb())))));
        this.refreshBankAccountParseStatus = this.effect(pipe(switchMap((updateCache) => this._getBankAccountParseStatusAsync(updateCache))));
        this.getBankAnalyzableAnalysisReports = this.effect(pipe(switchMap(() => this._getBankAnalyzableAnalysisReportsAsync())));
        this.getNonTradeReports = this.effect(pipe(switchMap(() => this._getNonTradeReportsAsync())));
        // actions
        // Tab - 1
        // 1. POST: add bank account with statements
        // 2. POST: send bank account to perfios
        // 3. GET: parse bank statements
        this.addBankAccountWithStatements = this.effect(pipe(switchMap((payload) => this._addBankAccountWithStatementsAsync(payload).pipe(catchError((err) => {
            console.error(`[_addBankAccountWithStatementsAsync]`, err);
            this.updateState({
                errors: [...this.state().errors, err],
            });
            return of([]);
        }))), 
        // send to perfios after adding bank account with statements
        switchMap((res) => {
            if (!res?.length) {
                return of(null);
            }
            let bankAccountId = '';
            if (!this.state().bankAccounts?.length) {
                bankAccountId = res[0].account_id;
            }
            const existingBankAccountsMap = this.state().bankAccounts.reduce((acc, bankAccount) => {
                acc[bankAccount.account_id] = bankAccount;
                return acc;
            }, {});
            // because response of adding a single bank account is an array of bank accounts
            // we need to find the bank account that is not in the existing bank accounts
            // and send it to perfios
            bankAccountId =
                res.find((acc) => !existingBankAccountsMap[acc.account_id])?.account_id || '';
            return this._sendBankAccountToPerfiosAsync(bankAccountId).pipe(catchError((err) => {
                console.error(`[_sendBankAccountToPerfiosAsync]`, err);
                this.updateState({
                    errors: [...this.state().errors, err],
                });
                return of(null);
            }));
        }), 
        // update cache after adding bank account with statements
        switchMap(() => this._getBankAccountParseStatusAsync(true).pipe(catchError((err) => {
            console.error(`[_getBankAccountParseStatusAsync]`, err);
            this.updateState({
                errors: [...this.state().errors, err],
            });
            return of(null);
        }))), 
        // update uiAsyncStatus - bankAccountWithStatementsAdded
        tap(() => {
            if (this.state().errors.length)
                return;
            this.updateState({
                uiAsyncStatus: {
                    ...this.state().uiAsyncStatus,
                    bankAccountWithStatementsAdded: 'success',
                },
            });
        })));
        // 1. PUT: update bank account
        // 2. GET: parse bank statements
        this.updateBankAccount = this.effect(pipe(switchMap(({ bankAccountId, payload }) => this._updateBankAccountAsync(bankAccountId, payload)), 
        // update cache after updating bank account
        switchMap(() => this._getBankAccountParseStatusAsync(true))));
        this.cloneBankAccount = this.effect(pipe(switchMap(({ bankAccountId, payload }) => this._cloneBankAccountAsync(bankAccountId, payload)), 
        // update cache after updating bank account
        switchMap(() => this._getBankAccountParseStatusAsync(true))));
        this.setPrimaryBankAccount = this.effect(pipe(switchMap(({ bankAccountId }) => this._setPrimaryBankAccountAsync(bankAccountId)), 
        // update cache after setting primary bank account
        switchMap(() => this._getBankAccountParseStatusAsync(true))));
        this.deleteBankAccount = this.effect(pipe(switchMap(({ bankAccountId, payload }) => this._deleteBankAccountAsync(bankAccountId, payload)), 
        // update cache after deleting bank account
        switchMap(() => this._getBankAccountParseStatusAsync(true))));
        // 1. POST: parse bank statements
        // 2. GET: parse bank statements
        this.sendBankAccountToPerfios = this.effect(pipe(switchMap(({ bankAccountId }) => this._sendBankAccountToPerfiosAsync(bankAccountId)), 
        // update cache after sending bank account to perfios
        switchMap(() => this._getBankAccountParseStatusAsync(true))));
        // 1. POST: process bank reports
        // 2. GET: bank analysis reports
        // 3. GET: non-trade reports
        this.processBankReports = this.effect(pipe(switchMap(() => this._processBankReportsAsync()), switchMap(() => this._getBankAnalyzableAnalysisReportsAsync(true)), switchMap(() => this._getNonTradeReportsAsync(true))));
        // 1. POST upload bank statements
        // 2. GET: parse bank statements
        this.uploadBankStatements = this.effect(pipe(switchMap(({ bankAccountId, payload }) => this._uploadBankStatementsAsync(bankAccountId, payload)), 
        // update cache after uploading bank statements
        switchMap(() => this._getBankAccountParseStatusAsync(true))));
        // 1. DELETE: delete bank statement
        // 2. GET: parse bank statements
        this.deleteBankStatement = this.effect(pipe(switchMap(({ bankAccountId, bankStatementId }) => this._deleteBankStatementAsync(bankAccountId, bankStatementId)), 
        // update cache after deleting bank statement
        switchMap(() => this._getBankAccountParseStatusAsync(true))));
        // 1. PUT: change parse status
        // 2. DELETE: bank reports
        // 3. GET: parse bank statements
        // 4. GET: non-trade reports
        // 5. GET: bank analysis reports
        this.resendToPerfios = this.effect(pipe(switchMap(({ payload }) => this._changeParseStatusAsync(this.state().selectedBankAccountRow?.account_id, payload)), switchMap(() => this._deleteBankReportsAsync(this.state().selectedBankAccountRow?.account_id).pipe(tap(() => {
            this.updateState({
                isResendToPerfiosComplete: true,
            });
        }))), switchMap(() => this._getBankAccountParseStatusAsync(true)), switchMap(() => this._getNonTradeReportsAsync(true)), switchMap(() => this._getBankAnalyzableAnalysisReportsAsync(true))));
        // Tab - 2
        // 1. PUT: update bank analysis report
        // 2. GET: bank analysis reports
        this.updateBankAnalysisReport = this.effect(pipe(switchMap(({ bankAccountId, payload }) => this._updateBankAnalysisReportAsync(bankAccountId, payload)), 
        // update cache after updating bank analysis report
        switchMap(() => this._getBankAnalyzableAnalysisReportsAsync(true))
        // update bankAnalysisReportsUpdated - true
        ));
        // Tab - 3
        // 1. PUT: update non-trade report
        // 2. GET: non-trade reports
        this.updateNonTradeReport = this.effect(pipe(switchMap(({ bankAccountId, payload }) => this._updateNonTradeReportAsync(bankAccountId, payload)), 
        // update the cache after updating non-trade report
        switchMap(() => this._getNonTradeReportsAsync(true)), switchMap(() => this._getBankAnalyzableAnalysisReportsAsync(true))));
        this.download = this.effect(pipe(switchMap((data) => {
            return this.blobService
                .downloadV3Blob(data.id)
                .pipe(tap((e) => downloadFileToLocal(URL.createObjectURL(e), data.name)));
        })));
        // all setters to state are handled with this
        this.updateState = (value) => this.patchState({
            ...value,
        });
    }
    loadComments(translation) {
        this.patchState({
            comments: [
                {
                    title: '',
                    customClasses: 'w-full flex flex-col gap-4',
                    items: [
                        {
                            category: 'FACTSHEET',
                            title: translation['factsheet'],
                            module: 'BANK_STMT_ANALYSIS',
                            identifier: 'BANK_STMT_ANALYSIS',
                            entityId: this.get().applicationId,
                            fields: [
                                {
                                    key: 'main_comment',
                                    label: translation['factsheet'],
                                },
                            ],
                        },
                        {
                            category: 'CREDIT',
                            title: translation['credit'],
                            module: 'BANK_STMT_ANALYSIS',
                            identifier: 'BANK_STMT_ANALYSIS',
                            entityId: this.get().applicationId,
                            fields: [
                                {
                                    key: 'main_comment',
                                    label: translation['credit'],
                                },
                            ],
                        },
                    ].filter((item) => !this.get().hiddenComments?.includes(item.category)),
                },
            ],
        });
    }
    // directly called from component
    // 1. POST: upload doc to V3
    uploadDocToV3Async(file) {
        return this.bankAccountsAndStatementsService.uploadDocToV3(file).pipe(catchError((err) => {
            console.error(`[uploadDocToV3Async]`, err);
            return EMPTY;
        }));
    }
    // private async calls
    // GET Calls
    _getReferenceDataAsync() {
        return forkJoin([
            this.masterDataService.getCurrencies().pipe(catchError((err) => {
                console.error('Error: [GET]: /aps/v1/currencies', err);
                return EMPTY;
            })),
            this.masterDataService.getBanks().pipe(catchError((err) => {
                console.error('Error: [GET]: /aps/v1/banks', err);
                return EMPTY;
            })),
            this.masterDataService.getMemberBrwReferences().pipe(catchError((err) => {
                console.error('Error: [GET]: /aps/v1/member_brw_references', err);
                return EMPTY;
            })),
            this.masterDataService.getExchangeRates().pipe(catchError((err) => {
                console.error('Error: [GET]: /aps/v1/exchange_rates', err);
                return EMPTY;
            })),
        ]).pipe(tap(([currencies, banks, { bankAccountTypes }, exchangeRatesContent]) => {
            let sortedBanks = banks.sort((a, b) => a.name.toUpperCase() < b.name.toUpperCase()
                ? -1
                : a.name.toUpperCase() > b.name.toUpperCase()
                    ? 1
                    : 0);
            sortedBanks = sortedBanks.filter((bank) => bank?.country_code !== CountryCode.TH ||
                !BANK_CODES_NOT_SUPPORTED_BY_PERFIOS.includes(bank?.code));
            this.updateState({
                referenceData: {
                    currencies,
                    banks: sortedBanks,
                    bankAccountTypes: (bankAccountTypes || []).filter((t) => t.countryId === CountryCode.MY),
                    banksMap: sortedBanks.reduce((acc, bank) => {
                        acc[bank.code] = bank;
                        return acc;
                    }, {}),
                    exchangeRatesContent,
                },
            });
        }), catchError((err) => {
            console.error(`[_getReferenceDataAsync]`, err);
            return EMPTY;
        }));
    }
    _getBankAccountParseStatusAsync(updateCache = false) {
        if (!isStringValid(this.state().applicationId)) {
            throw new Error('Application ID is not valid');
        }
        return this.bankAccountsAndStatementsService
            .getBankAccountParseStatus(this.state().applicationId, updateCache)
            .pipe(tap((bankAccounts) => {
            this.updateState({
                bankAccounts,
            });
        }), switchMap((bankAccounts) => {
            const enhancedBankAccounts = bankAccounts.map((bankAccount) => {
                const statementBlobObservables = bankAccount.statements.map((statement) => this.blobService.downloadV3Blob(statement.doc_id).pipe(map((data) => ({
                    ...statement,
                    blob: this.domSanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(data)),
                }))));
                return forkJoin(statementBlobObservables).pipe(map((downloadedStatements) => ({
                    ...bankAccount,
                    statements: downloadedStatements,
                })));
            });
            return forkJoin(enhancedBankAccounts).pipe(tap((processedBankAccounts) => {
                const bankAccountsWithStatementsMap = processedBankAccounts.reduce((acc, bankAccount) => {
                    acc[bankAccount.account_id] = bankAccount;
                    return acc;
                }, {});
                this.updateState({
                    bankAccountsWithStatementsMap,
                });
            }));
        }), catchError((err) => {
            console.error('_getBankAccountParseStatusAsync', err);
            return EMPTY;
        }));
    }
    _getBankAnalyzableAnalysisReportsAsync(updateCache = false) {
        if (!isStringValid(this.state().applicationId)) {
            throw new Error('Application ID is not valid');
        }
        return this.bankTabulationsService
            .getBankAnalyzableAnalysisReports(this.state().applicationId, updateCache)
            .pipe(tap((bankAnalysisReports) => {
            const bankAnalysisReportMap = bankAnalysisReports.reduce((acc, report) => {
                acc[report.account_id] = report;
                return acc;
            }, {});
            this.updateState({
                bankAnalysisReportMap,
            });
        }), catchError((err) => {
            console.error('_getBankAnalyzableAnalysisReportsAsync', err);
            return EMPTY;
        }));
    }
    _getNonTradeReportsAsync(updateCache = false) {
        if (!isStringValid(this.state().applicationId)) {
            throw new Error('Application ID is not valid');
        }
        return this.nonTradeTransactionsService
            .getNonTradeReports(this.state().applicationId, updateCache)
            .pipe(map((nonTradeReports) => {
            const nonTradeBankUIMap = createNonTradeBankUIMap(nonTradeReports);
            this.updateState({
                nonTradeBankUIMap: { ...nonTradeBankUIMap },
                nonTradeBankReports: nonTradeReports,
            });
            return nonTradeBankUIMap;
        }), catchError((err) => {
            console.error('_getNonTradeReportsAsync', err);
            return EMPTY;
        }));
    }
    // end of GET calls
    // POST/PUT/PATCH calls
    _addBankAccountWithStatementsAsync(payload) {
        if (!isStringValid(this.state().applicationId)) {
            throw new Error('Application ID is not valid');
        }
        return this.bankAccountsAndStatementsService
            .addBankAccountWithStatements(this.state().applicationId, payload)
            .pipe(catchError((err) => {
            console.error(`[_addBankAccountWithStatementsAsync]`, err);
            return EMPTY;
        }));
    }
    _updateBankAccountAsync(bankAccountId, payload) {
        if (!isStringValid(this.state().applicationId)) {
            throw new Error('Application ID is not valid');
        }
        return this.bankAccountsAndStatementsService
            .updateBankAccount(this.state().applicationId, bankAccountId, payload)
            .pipe(catchError((err) => {
            const errMsg = `Error: [_updateBankAccountAsync] update bank account | ${err}`;
            console.error(errMsg);
            this.updateState({
                errors: [
                    ...this.state().errors,
                    `Error: [_updateBankAccountAsync] update bank account`,
                ],
            });
            return EMPTY;
        }));
    }
    _cloneBankAccountAsync(bankAccountId, payload) {
        if (!isStringValid(this.state().applicationId)) {
            throw new Error('Application ID is not valid');
        }
        return this.bankAccountsAndStatementsService
            .cloneBankAccount(this.state().applicationId, bankAccountId, payload, this.state().useMock)
            .pipe(catchError((err) => {
            const errMsg = `Error: [_cloneBankAccountAsync] update bank account | ${err}`;
            console.error(errMsg);
            this.updateState({
                errors: [...this.state().errors, `Error: [_cloneBankAccountAsync] update bank account`],
            });
            return EMPTY;
        }));
    }
    _setPrimaryBankAccountAsync(bankAccountId) {
        if (!isStringValid(this.state().applicationId)) {
            throw new Error('Application ID is not valid');
        }
        return this.bankAccountsAndStatementsService
            .setPrimaryBankAccount(this.state().applicationId, bankAccountId)
            .pipe(catchError((err) => {
            console.error(`[_setPrimaryBankAccountAsync]`, err);
            return EMPTY;
        }));
    }
    _deleteBankAccountAsync(bankAccountId, payload) {
        if (!isStringValid(this.state().applicationId)) {
            throw new Error('Application ID is not valid');
        }
        return this.bankAccountsAndStatementsService
            .deleteBankAccount(this.state().applicationId, bankAccountId, payload)
            .pipe(catchError((err) => {
            console.error(`[_deleteBankAccountAsync]`, err);
            return EMPTY;
        }));
    }
    _uploadBankStatementsAsync(bankAccountId, payload) {
        if (!isStringValid(this.state().applicationId)) {
            throw new Error('Application ID is not valid');
        }
        return this.bankAccountsAndStatementsService
            .uploadBankStatements(this.state().applicationId, bankAccountId, payload)
            .pipe(catchError((err) => {
            console.error('_uploadBankStatementsAsync', err);
            return EMPTY;
        }));
    }
    _deleteBankStatementAsync(bankAccountId, bankStatementId) {
        if (!isStringValid(this.state().applicationId)) {
            throw new Error('Application ID is not valid');
        }
        return this.bankAccountsAndStatementsService
            .deleteBankStatement(this.state().applicationId, bankAccountId, bankStatementId)
            .pipe(catchError((err) => {
            console.error('_deleteBankStatementAsync', err);
            return EMPTY;
        }));
    }
    _sendBankAccountToPerfiosAsync(bankAccountId) {
        if (!isStringValid(bankAccountId)) {
            throw new Error(`bankAccountId is not valid`);
        }
        if (!isStringValid(this.state().applicationId)) {
            throw new Error(`${this.state().applicationId} is not valid`);
        }
        return this.bankAccountsAndStatementsService
            .sendToPerfios(this.state().applicationId, bankAccountId, this.state().useMock)
            .pipe(catchError((err) => {
            console.error('_sendBankAccountToPerfiosAsync', err);
            return EMPTY;
        }));
    }
    _processBankReportsAsync() {
        if (!isStringValid(this.state().applicationId)) {
            throw new Error('Application ID is not valid');
        }
        return this.bankAccountsAndStatementsService
            .deleteBankStatementReports(this.state().applicationId)
            .pipe(switchMap(() => this.bankAccountsAndStatementsService.processBankReports(this.state().applicationId)), catchError((err) => {
            console.error('_processBankReportsAsync', err);
            return EMPTY;
        }));
    }
    _changeParseStatusAsync(bankAccountId, payload) {
        if (!isStringValid(this.state().applicationId)) {
            throw new Error('Application ID is not valid');
        }
        return this.bankAccountsAndStatementsService
            .changeParseStatus(this.state().applicationId, bankAccountId, payload)
            .pipe(catchError((err) => {
            console.error(`[_resendToPerfiosAsync]`, err);
            return EMPTY;
        }));
    }
    _deleteBankReportsAsync(bankAccountId) {
        if (!isStringValid(this.state().applicationId)) {
            throw new Error('Application ID is not valid');
        }
        return this.bankAccountsAndStatementsService
            .deleteBankReports(this.state().applicationId, bankAccountId)
            .pipe(catchError((err) => {
            console.error(`[_deleteBankReportsAsync]`, err);
            return EMPTY;
        }));
    }
    // Tab - 2
    _updateBankAnalysisReportAsync(bankAccountId, payload) {
        if (!isStringValid(this.state().applicationId)) {
            throw new Error('Application ID is not valid');
        }
        return this.bankTabulationsService
            .updateBankAnalysisReport(this.state().applicationId, bankAccountId, payload)
            .pipe(tap(() => {
            this.updateState({
                isBankAnalysisReportsUpdated: true,
            });
        }), catchError((err) => {
            console.error('_updateBankAnalysisReportAsync', err);
            return EMPTY;
        }));
    }
    // Tab - 3
    _updateNonTradeReportAsync(bankAccountId, payload) {
        if (!isStringValid(this.state().applicationId)) {
            throw new Error('Application ID is not valid');
        }
        return this.nonTradeTransactionsService
            .updateNonTradeReport(this.state().applicationId, bankAccountId, payload)
            .pipe(tap(() => {
            this.updateState({
                isNonTradeReportsUpdated: true,
            });
        }), catchError((err) => {
            console.error('_updateNonTradeReportAsync', err);
            return EMPTY;
        }));
    }
    // end of POST/PUT/PATCH/DELETE calls
    // end of private async calls
    clearCache() {
        this.bankAccountsAndStatementsService.clearCache();
        this.bankTabulationsService.clearCache();
        this.nonTradeTransactionsService.clearCache();
        this.updateState({
            bankAccounts: [],
            bankAnalysisReportMap: null,
            nonTradeBankReports: [],
            nonTradeBankUIMap: null,
            isBankAnalysisReportsUpdated: false,
            isNonTradeReportsUpdated: false,
            isResendToPerfiosComplete: false,
            errors: [],
            uiAsyncStatus: {
                bankAccountWithStatementsAdded: '',
                nonTradeNewEntryAdded: '',
            },
            selectedBankAccountRow: null,
        });
    }
};
BankStatementAnalysisStore = __decorate([
    __param(0, Inject(BANK_ACCOUNTS_AND_STATEMENTS_SERVICE_TOKEN)),
    __param(1, Inject(BANK_TABULATIONS_SERVICE_TOKEN)),
    __param(2, Inject(NON_TRADE_TRANSACTIONS_SERVICE_TOKEN)),
    __param(3, Inject(MASTER_DATA_SERVICE_TOKEN)),
    __param(4, Inject(BLOB_SERVICE_TOKEN)),
    __metadata("design:paramtypes", [Object, Object, Object, Object, Object, Object])
], BankStatementAnalysisStore);

class IDBankStatementAnalysisStore extends BankStatementAnalysisStore {
    constructor(bankAccountsAndStatementsService, bankTabulationsService, nonTradeTransactionsService, masterDataService, blobService) {
        // Call the parent constructor with the injected service and country code
        super(bankAccountsAndStatementsService, bankTabulationsService, nonTradeTransactionsService, masterDataService, blobService, {
            countryCode: CountryCode.ID,
        });
        this.bankAccountsAndStatementsService = bankAccountsAndStatementsService;
        this.bankTabulationsService = bankTabulationsService;
        this.nonTradeTransactionsService = nonTradeTransactionsService;
        this.masterDataService = masterDataService;
        this.blobService = blobService;
    }
    init() {
        this.getReferenceData();
        this.state$.pipe(take(3)).subscribe((state) => {
            if (state.applicationId) {
                this.getBankAccountParseStatus();
                this.getBankAnalyzableAnalysisReports();
                this.getNonTradeReports();
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDBankStatementAnalysisStore, deps: [{ token: BANK_ACCOUNTS_AND_STATEMENTS_SERVICE_TOKEN }, { token: BANK_TABULATIONS_SERVICE_TOKEN }, { token: NON_TRADE_TRANSACTIONS_SERVICE_TOKEN }, { token: MASTER_DATA_SERVICE_TOKEN }, { token: BLOB_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDBankStatementAnalysisStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDBankStatementAnalysisStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [BANK_ACCOUNTS_AND_STATEMENTS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [BANK_TABULATIONS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [NON_TRADE_TRANSACTIONS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MASTER_DATA_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [BLOB_SERVICE_TOKEN]
                }] }]; } });

class VUBankStatementAnalysisStore extends BankStatementAnalysisStore {
    constructor(bankAccountsAndStatementsService, bankTabulationsService, nonTradeTransactionsService, masterDataService, blobService) {
        // Call the parent constructor with the injected service and country code
        super(bankAccountsAndStatementsService, bankTabulationsService, nonTradeTransactionsService, masterDataService, blobService, {
            countryCode: CountryCode.VU,
        });
        this.bankAccountsAndStatementsService = bankAccountsAndStatementsService;
        this.bankTabulationsService = bankTabulationsService;
        this.nonTradeTransactionsService = nonTradeTransactionsService;
        this.masterDataService = masterDataService;
        this.blobService = blobService;
    }
    init() {
        this.getReferenceData();
        this.state$.pipe(take(3)).subscribe((state) => {
            if (state.applicationId) {
                this.getBankAccountParseStatus();
                this.getBankAnalyzableAnalysisReports();
                this.getNonTradeReports();
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: VUBankStatementAnalysisStore, deps: [{ token: BANK_ACCOUNTS_AND_STATEMENTS_SERVICE_TOKEN }, { token: BANK_TABULATIONS_SERVICE_TOKEN }, { token: NON_TRADE_TRANSACTIONS_SERVICE_TOKEN }, { token: MASTER_DATA_SERVICE_TOKEN }, { token: BLOB_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: VUBankStatementAnalysisStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: VUBankStatementAnalysisStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [BANK_ACCOUNTS_AND_STATEMENTS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [BANK_TABULATIONS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [NON_TRADE_TRANSACTIONS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MASTER_DATA_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [BLOB_SERVICE_TOKEN]
                }] }]; } });

class MYBankStatementAnalysisStore extends BankStatementAnalysisStore {
    constructor(bankAccountsAndStatementsService, bankTabulationsService, nonTradeTransactionsService, masterDataService, blobService) {
        // Call the parent constructor with the injected service and country code
        super(bankAccountsAndStatementsService, bankTabulationsService, nonTradeTransactionsService, masterDataService, blobService, {
            countryCode: CountryCode.MY,
        });
        this.bankAccountsAndStatementsService = bankAccountsAndStatementsService;
        this.bankTabulationsService = bankTabulationsService;
        this.nonTradeTransactionsService = nonTradeTransactionsService;
        this.masterDataService = masterDataService;
        this.blobService = blobService;
        this._setApplicationId$ = new Subject();
    }
    init() {
        this.getReferenceData();
        this.state$.pipe(takeUntil(this._setApplicationId$)).subscribe((state) => {
            if (!state.applicationId)
                return;
            this._setApplicationId$.next(state.applicationId);
            if (state.applicationId) {
                this.getBankAccountParseStatus();
                this.getBankAnalyzableAnalysisReports();
                this.getNonTradeReports();
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MYBankStatementAnalysisStore, deps: [{ token: BANK_ACCOUNTS_AND_STATEMENTS_SERVICE_TOKEN }, { token: BANK_TABULATIONS_SERVICE_TOKEN }, { token: NON_TRADE_TRANSACTIONS_SERVICE_TOKEN }, { token: MASTER_DATA_SERVICE_TOKEN }, { token: BLOB_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MYBankStatementAnalysisStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MYBankStatementAnalysisStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [BANK_ACCOUNTS_AND_STATEMENTS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [BANK_TABULATIONS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [NON_TRADE_TRANSACTIONS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MASTER_DATA_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [BLOB_SERVICE_TOKEN]
                }] }]; } });

const STORE_TOKEN$6 = new InjectionToken('STORE_TOKEN');

const ID_PROVIDERS$a = [
    {
        provide: STORE_TOKEN$6,
        useClass: IDBankStatementAnalysisStore,
        deps: [
            BANK_ACCOUNTS_AND_STATEMENTS_SERVICE_TOKEN,
            BANK_TABULATIONS_SERVICE_TOKEN,
            NON_TRADE_TRANSACTIONS_SERVICE_TOKEN,
            MASTER_DATA_SERVICE_TOKEN,
            BLOB_SERVICE_TOKEN,
        ],
    },
];

const MY_PROVIDERS$4 = [
    {
        provide: STORE_TOKEN$6,
        useClass: MYBankStatementAnalysisStore,
        deps: [
            BANK_ACCOUNTS_AND_STATEMENTS_SERVICE_TOKEN,
            BANK_TABULATIONS_SERVICE_TOKEN,
            NON_TRADE_TRANSACTIONS_SERVICE_TOKEN,
            MASTER_DATA_SERVICE_TOKEN,
            BLOB_SERVICE_TOKEN,
        ],
    },
];

const VU_PROVIDERS$5 = [
    {
        provide: STORE_TOKEN$6,
        useClass: VUBankStatementAnalysisStore,
        deps: [
            BANK_ACCOUNTS_AND_STATEMENTS_SERVICE_TOKEN,
            BANK_TABULATIONS_SERVICE_TOKEN,
            NON_TRADE_TRANSACTIONS_SERVICE_TOKEN,
            MASTER_DATA_SERVICE_TOKEN,
            BLOB_SERVICE_TOKEN,
        ],
    },
];

class THBankStatementAnalysisStore extends BankStatementAnalysisStore {
    constructor(bankAccountsAndStatementsService, bankTabulationsService, nonTradeTransactionsService, masterDataService, blobService) {
        // Call the parent constructor with the injected service and country code
        super(bankAccountsAndStatementsService, bankTabulationsService, nonTradeTransactionsService, masterDataService, blobService, {
            countryCode: CountryCode.TH,
        });
        this.bankAccountsAndStatementsService = bankAccountsAndStatementsService;
        this.bankTabulationsService = bankTabulationsService;
        this.nonTradeTransactionsService = nonTradeTransactionsService;
        this.masterDataService = masterDataService;
        this.blobService = blobService;
    }
    init() {
        this.getReferenceData();
        this.select((state) => state.applicationId)
            .pipe(take(3), filter((applicationId) => applicationId != null), tap(() => {
            this.getBankAccountParseStatusWithCallBack(() => {
                if (this.state().bankAccounts?.length) {
                    this.getBankAnalyzableAnalysisReports();
                    this.getNonTradeReports();
                }
            });
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: THBankStatementAnalysisStore, deps: [{ token: BANK_ACCOUNTS_AND_STATEMENTS_SERVICE_TOKEN }, { token: BANK_TABULATIONS_SERVICE_TOKEN }, { token: NON_TRADE_TRANSACTIONS_SERVICE_TOKEN }, { token: MASTER_DATA_SERVICE_TOKEN }, { token: BLOB_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: THBankStatementAnalysisStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: THBankStatementAnalysisStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [BANK_ACCOUNTS_AND_STATEMENTS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [BANK_TABULATIONS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [NON_TRADE_TRANSACTIONS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MASTER_DATA_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [BLOB_SERVICE_TOKEN]
                }] }]; } });

const TH_PROVIDERS$1 = [
    {
        provide: STORE_TOKEN$6,
        useClass: THBankStatementAnalysisStore,
        deps: [
            BANK_ACCOUNTS_AND_STATEMENTS_SERVICE_TOKEN,
            BANK_TABULATIONS_SERVICE_TOKEN,
            NON_TRADE_TRANSACTIONS_SERVICE_TOKEN,
            MASTER_DATA_SERVICE_TOKEN,
            BLOB_SERVICE_TOKEN,
        ],
    },
];

const PROVIDERS_MAP$a = {
    default: MY_PROVIDERS$4,
    [CountryCode.MY]: MY_PROVIDERS$4,
    [CountryCode.VU]: VU_PROVIDERS$5,
    [CountryCode.ID]: ID_PROVIDERS$a,
    [CountryCode.TH]: TH_PROVIDERS$1,
};
const bankStatementAnalysisProviders = (countryCode) => [
    ...getCustomProviders(PROVIDERS_MAP$a, MY_PROVIDERS$4, countryCode),
];

function bankStatementAnalysisTranslation(scope = 'bank_statement_analysis') {
    return [
        ...(FSWTranslateModule.forFeature({
            scope,
            defaultKey: getCountryCodeFromStorage(),
            data: BANK_STATEMENT_ANALYSIS_TRANSLATION,
        }).providers || []),
        fswTranslateScope(scope),
    ];
}

const mapBankAccount = (bankAccounts) => {
    return (bankAccounts || []).map((bankAccount) => {
        return {
            ...bankAccount,
            from_date: formatDateToMMMYY(bankAccount.from_date),
            to_date: formatDateToMMMYY(bankAccount.to_date),
            statements: (bankAccount?.statements || []).map((bankStatement) => {
                return {
                    ...bankStatement,
                    bank_account_id: bankAccount.account_id,
                };
            }),
        };
    });
};
const formatDateToMMMYY = (dateString) => {
    // Split the input into month and year parts
    const [monthPart, yearPart] = dateString.split('-');
    // Convert the month part to a Date object (subtract 1 since JavaScript months are zero-based)
    const date = new Date(`${yearPart}-${monthPart}-01`);
    // Format the month as "MMM" (short month name)
    const formattedMonth = date.toLocaleDateString('en-US', { month: 'short' });
    // Combine the formatted month and year
    return `${formattedMonth}-${yearPart}`;
};

const initFG$5 = (_fb) => {
    const currency = COUNTRY_CONFIG[getCountryCodeFromStorage()]?.currencyCode || COUNTRY_CONFIG['MY'].currencyCode;
    return _fb.group({
        bank_code: ['', [Validators.required]],
        account_name: ['', [Validators.required]],
        account_number: ['', [Validators.required]],
        account_type: ['', [Validators.required]],
        currency: [currency, [Validators.required]],
        parser: [{ value: 'PERFIOS', disabled: true }, [Validators.required]],
        from_date: ['', [Validators.required]],
        to_date: ['', [Validators.required]],
        is_scanned: false,
    });
};
const createBankAccountWithStatementsPayload = (res, addBankAccountFG, referenceData) => {
    const bankStatements = [];
    const fileAnddocIds = (res || []).map((r) => ({
        file_name: r.file.name,
        doc_id: r.doc_id,
    }));
    const { bank_code, account_name, account_number, account_type, currency, from_date, to_date, is_scanned, parser, } = addBankAccountFG.getRawValue();
    fileAnddocIds.forEach((fileAnddocId) => {
        const { file_name, doc_id } = fileAnddocId;
        bankStatements.push({
            file_name,
            doc_id,
        });
    });
    return {
        account_name,
        account_number,
        bank_code,
        bank_name: referenceData.banksMap[bank_code].name,
        account_type,
        currency,
        parser,
        from_date: formatDate(from_date),
        to_date: formatDate(to_date),
        is_scanned,
        statements: bankStatements,
    };
};
const formatDate = (inputDate) => {
    const date = new Date(inputDate);
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Adding 1 because months are zero-based
    const year = date.getFullYear();
    return `${month}-${year}`;
};

var BankAccountsAndStatementsGridFields;
(function (BankAccountsAndStatementsGridFields) {
    BankAccountsAndStatementsGridFields["BANK_NAME"] = "bank_name";
    BankAccountsAndStatementsGridFields["ACCOUNT_NUMBER"] = "account_number";
    BankAccountsAndStatementsGridFields["ACCOUNT_NAME"] = "account_name";
    BankAccountsAndStatementsGridFields["ACCOUNT_TYPE"] = "account_type";
    BankAccountsAndStatementsGridFields["CURRENCY"] = "currency";
    BankAccountsAndStatementsGridFields["BANK_STATEMENTS"] = "bank_statements";
    BankAccountsAndStatementsGridFields["DOWNLOAD"] = "download";
    BankAccountsAndStatementsGridFields["DELETE_ACCOUNT"] = "delete_account";
    BankAccountsAndStatementsGridFields["PARSING_STATUS"] = "status";
    BankAccountsAndStatementsGridFields["MESSAGE"] = "message";
    BankAccountsAndStatementsGridFields["PERIOD"] = "period";
    BankAccountsAndStatementsGridFields["FROM_DATE"] = "from_date";
    BankAccountsAndStatementsGridFields["TO_DATE"] = "to_date";
    BankAccountsAndStatementsGridFields["FILE_NAME"] = "file_name";
})(BankAccountsAndStatementsGridFields || (BankAccountsAndStatementsGridFields = {}));
const BankAccountsAndStatementsColumnNames = {
    arrow: '',
    bank_name: 'Name',
    account_number: 'Number',
    account_name: 'Name',
    account_type: 'Type',
    currency: 'Currency',
    primary: 'Primary',
    from_date: 'From',
    to_date: 'To',
    status: 'Status',
    parser: 'Parser',
    parent_action: 'Action',
};
const BankAccountsAndStatementsChildColumnNames = {
    file_name: 'File Name',
    child_action: 'Action',
};
const FULL_PARSER_OPTIONS = ['PERFIOS', 'FINANCE_AI', 'AUTO'];

class FSWAddBankAccountModalComponent {
    get isButtonDisable() {
        return this.addBankAccountFG.invalid || !this.files.length;
    }
    constructor(_componentStore, _scope, _translateService, _dialogRef, _fb) {
        this._componentStore = _componentStore;
        this._scope = _scope;
        this._translateService = _translateService;
        this._dialogRef = _dialogRef;
        this._fb = _fb;
        this._destroy$ = new Subject();
        this.modalSize = FSWModalSizes.L;
        this.errors = [];
        this.referenceData = {
            banks: [],
            bankAccountTypes: [],
            currencies: [],
            banksMap: {},
            exchangeRatesContent: null,
        };
        this.files = [];
        this.parserOptions = FULL_PARSER_OPTIONS;
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'bank_accounts_and_statements'),
            this._translateService.selectFeatureTranslate(this._scope, 'buttons'),
        ]).pipe(map(([bankAccountStmt, buttons]) => ({
            bankAccountStmt,
            buttons,
        })));
        this._componentStore.state$
            .pipe(takeUntil(this._destroy$), map((state) => state.referenceData), tap((referenceData) => {
            if (!referenceData)
                return;
            this.referenceData = referenceData;
            if (this.referenceData?.banks?.length) {
                this.errors = this.errors.filter((err) => err !== 'Error in getting dropdown data from server');
            }
        }))
            .subscribe();
        this._componentStore.state$
            .pipe(takeUntil(this._destroy$), map((state) => state.errors), tap((errors) => {
            if (!errors?.length)
                return;
            const errList = [...this.errors, ...errors];
            this.errors = [...new Set(errList)];
        }))
            .subscribe();
        this.addBankAccountFG = initFG$5(this._fb);
        this.addBankAccountFG.get('to_date')?.valueChanges.subscribe((toDate) => {
            const fromDate = this.addBankAccountFG.get('from_date')?.value;
            if (!fromDate)
                return;
            // compare from date and to date months and year not the day
            const fromDateMonthYear = new Date(fromDate).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'numeric',
            });
            const toDateMonthYear = new Date(toDate).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'numeric',
            });
            if (toDateMonthYear === fromDateMonthYear || toDate < fromDate) {
                this.addBankAccountFG.get('to_date')?.setErrors({ invalidToDate: true });
                this.errors = [...this.errors, 'To date cannot be less than or equal to from date'];
            }
            else {
                this.addBankAccountFG.get('to_date')?.setErrors(null);
                this.errors = this.errors.filter((err) => err !== 'To date cannot be less than or equal to from date');
            }
        });
        if (!this.referenceData ||
            !this.referenceData?.banks?.length ||
            !this.referenceData?.bankAccountTypes?.length ||
            !this.referenceData?.currencies?.length) {
            this.errors = [...this.errors, 'Error in getting dropdown data from server'];
            return;
        }
        // wait for uiAsyncStatus to be updated
        this._componentStore.state$
            .pipe(takeUntil(this._destroy$), map((state) => state.uiAsyncStatus), tap((uiAsyncStatus) => {
            if (uiAsyncStatus.bankAccountWithStatementsAdded === 'success') {
                this._dialogRef.close();
                this._componentStore.updateState({
                    uiAsyncStatus: {
                        ...this._componentStore.state().uiAsyncStatus,
                        bankAccountWithStatementsAdded: '',
                    },
                });
            }
        }))
            .subscribe();
        if (this._componentStore.state().username === 'tengbin.koay@fundingsocieties.com') {
            this.parserOptions = FULL_PARSER_OPTIONS;
        }
    }
    ngOnDestroy() {
        if (this._destroy$) {
            this._destroy$.next();
            this._destroy$.complete();
        }
    }
    uploadFile(data) {
        const errorMsg = 'Maximum 6 Bank statements can be uploaded at a time.';
        const errorMsgPdf = 'Only PDF files are allowed to be uploaded.';
        this.files = [...Array.from(data)];
        if (!this.files.length)
            return;
        const hasError = !!this.files.filter((f) => !['application/pdf'].includes(f.type)).length;
        if (hasError) {
            this.errors = [...this.errors, errorMsgPdf];
            this.files = [];
            return;
        }
        else {
            this.errors = this.errors.filter((err) => err !== errorMsgPdf);
        }
        if (this.files.length > 6) {
            this.errors = [...this.errors, errorMsg];
            this.files = [];
            return;
        }
        else {
            this.errors = this.errors.filter((err) => err !== errorMsg);
        }
    }
    onConfirm() {
        const obs = [];
        this.files.forEach((file) => {
            obs.push(this._componentStore.uploadDocToV3Async(file));
        });
        forkJoin([...obs])
            .pipe(takeUntil(this._destroy$), tap((data) => {
            const withoutDocId = data.filter((d) => !d.doc_id);
            if (withoutDocId.length) {
                throw new Error(`Error: [onConfirm] Missing doc id`);
            }
            this._componentStore.addBankAccountWithStatements(createBankAccountWithStatementsPayload(data, this.addBankAccountFG, this._componentStore.state().referenceData));
        }), catchError((err) => {
            console.error(`[onConfirm]`, err);
            const errorMsg = `Error: [onConfirm] Add Bank Account failed | ${err}`;
            this.errors = [...this.errors, errorMsg];
            throw new Error(errorMsg);
        }))
            .subscribe();
    }
    onClose() {
        this._dialogRef.close();
    }
    getRangeDate(value, args) {
        if (!value) {
            return null;
        }
        try {
            const rangeDate = new Date(value);
            rangeDate.setMonth(rangeDate.getMonth() + args);
            rangeDate.setDate(1);
            return rangeDate;
        }
        catch {
            return null;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAddBankAccountModalComponent, deps: [{ token: STORE_TOKEN$6 }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: i1$7.DialogRef }, { token: i2.FormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWAddBankAccountModalComponent, selector: "fsw-add-bank-account", ngImport: i0, template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <fsw-modal\n    [title]=\"'Add Bank Account & Send to Parser'\"\n    [confirmButton]=\"'Add & Send to Parser'\"\n    [cancelButton]=\"translate.buttons.cancel\"\n    [size]=\"modalSize\"\n    [confirmButtonDisabled]=\"isButtonDisable\"\n    (closeEvent)=\"onClose()\"\n    (cancelEvent)=\"onClose()\"\n    (confirmEvent)=\"onConfirm()\"\n  >\n    <ng-template fswModalBody>\n      <ng-container [formGroup]=\"addBankAccountFG\">\n        <section *ngIf=\"errors?.length\" class=\"bg-red-100 text-red-500 p-2 h-auto\">\n          <div class=\"text-[12px] p-1\" *ngFor=\"let err of errors\">\n            {{ err }}\n          </div>\n        </section>\n\n        <main class=\"flex justify-between w-full mt-2\">\n          <section class=\"w-1/2\">\n            <div class=\"mb-4 max-w-[328px]\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.bank_name }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n              </fsw-field>\n              <ng-select\n                class=\"custom\"\n                [items]=\"referenceData.banks\"\n                bindLabel=\"name\"\n                bindValue=\"code\"\n                [multiple]=\"false\"\n                [closeOnSelect]=\"true\"\n                formControlName=\"bank_code\"\n              >\n                <ng-template ng-option-tmp let-item=\"item\" let-item$=\"item$\" let-index=\"index\">\n                  <span class=\"select-option\">\n                    {{ item?.name }}\n                  </span>\n                </ng-template>\n              </ng-select>\n            </div>\n\n            <div class=\"w-[328px] mb-4\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.account_name }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <input\n                  type=\"text\"\n                  class=\"form-input\"\n                  formControlName=\"account_name\"\n                  [placeholder]=\"'Please enter Account Name'\"\n                />\n              </fsw-field>\n            </div>\n\n            <div class=\"w-[328px] mb-4\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.account_number }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <input\n                  type=\"text\"\n                  class=\"form-input\"\n                  formControlName=\"account_number\"\n                  [placeholder]=\"'Please enter Account Number'\"\n                />\n              </fsw-field>\n            </div>\n\n            <div class=\"mb-4 max-w-[328px]\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.account_type }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <fsw-select\n                  [maxHeight]=\"'200px'\"\n                  [placeHolder]=\"'Please select Account Types'\"\n                  formControlName=\"account_type\"\n                >\n                  <ng-container *ngFor=\"let bankAccType of referenceData.bankAccountTypes\">\n                    <ng-template\n                      fswSelectItem\n                      let-selected\n                      [text]=\"bankAccType.name\"\n                      [value]=\"bankAccType.code\"\n                    ></ng-template>\n                  </ng-container>\n                </fsw-select>\n              </fsw-field>\n            </div>\n\n            <div class=\"max-w-[328px]\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.currency }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <fsw-select\n                  [maxHeight]=\"'200px'\"\n                  [placeHolder]=\"'Please select currency'\"\n                  formControlName=\"currency\"\n                >\n                  <ng-container *ngFor=\"let curr of referenceData.currencies\">\n                    <ng-template\n                      fswSelectItem\n                      let-selected\n                      [text]=\"curr.name\"\n                      [value]=\"curr.code\"\n                    ></ng-template>\n                  </ng-container>\n                </fsw-select>\n              </fsw-field>\n            </div>\n\n            <div class=\"max-w-[328px]\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.parser }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <fsw-select\n                  [maxHeight]=\"'200px'\"\n                  [placeHolder]=\"'Please select parser'\"\n                  formControlName=\"parser\"\n                >\n                  <ng-container *ngFor=\"let val of parserOptions\">\n                    <ng-template\n                      fswSelectItem\n                      let-selected\n                      [text]=\"val\"\n                      [value]=\"val\"\n                    ></ng-template>\n                  </ng-container>\n                </fsw-select>\n              </fsw-field>\n            </div>\n          </section>\n\n          <section class=\"w-1/2\">\n            <div class=\"flex justify-between gap-[8px] mb-4\">\n              <div class=\"w-1/2\">\n                <fsw-field size=\"s\" [fullWidth]=\"true\">\n                  <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                    <label>\n                      {{ translate.bankAccountStmt.form_fields.from_date }}\n                      <span class=\"text-red-500\">*</span>\n                    </label>\n                  </ng-template>\n                  <fsw-date-picker\n                    formControlName=\"from_date\"\n                    [closeOnSelected]=\"true\"\n                    format=\"MMM-yyyy\"\n                  >\n                  </fsw-date-picker>\n                </fsw-field>\n              </div>\n              <div class=\"w-1/2\">\n                <fsw-field size=\"s\" [fullWidth]=\"true\">\n                  <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                    <label>\n                      {{ translate.bankAccountStmt.form_fields.to_date }}\n                      <span class=\"text-red-500\">*</span>\n                    </label>\n                  </ng-template>\n                  <fsw-date-picker\n                    formControlName=\"to_date\"\n                    [closeOnSelected]=\"true\"\n                    format=\"MMM-YYYY\"\n                    [min]=\"getRangeDate(addBankAccountFG.get('from_date')?.value, 1)\"\n                  >\n                  </fsw-date-picker>\n                </fsw-field>\n              </div>\n            </div>\n\n            <div class=\"flex justify-between items-center gap-[4px]\">\n              <fsw-upload\n                [buttonUploadLabel]=\"translate.bankAccountStmt.buttons.upload_statements\"\n                (fileSelect)=\"uploadFile($event)\"\n              ></fsw-upload>\n              <div *ngIf=\"files?.length\">\n                <fsw-checkbox formControlName=\"is_scanned\" [label]=\"'Is Scanned ?'\"></fsw-checkbox>\n              </div>\n            </div>\n\n            <div class=\"bg-gray-100 text-gray-700 text-[12px] p-2 mt-4\">\n              <div>{{ translate.bankAccountStmt.notes.note_1 }}</div>\n              <div>{{ translate.bankAccountStmt.notes.note_2 }}</div>\n            </div>\n\n            <div class=\"py-2 max-h-[190px] h-auto overflow-y-scroll\" *ngIf=\"files?.length\">\n              <div\n                class=\"bg-blue-100 text-[12px] text-blue-500 p-2 my-1\"\n                *ngFor=\"let file of files\"\n              >\n                <span>{{ file?.name }}</span>\n              </div>\n            </div>\n          </section>\n        </main>\n      </ng-container>\n    </ng-template>\n  </fsw-modal>\n</ng-container>\n", styles: [".ng-select.ng-select-opened>.ng-select-container{background:#fff;border-color:#b3b3b3 #ccc #d9d9d9}.ng-select.ng-select-opened>.ng-select-container:hover{box-shadow:none}.ng-select.ng-select-opened>.ng-select-container .ng-arrow{top:-2px;border-color:transparent transparent #999;border-width:0 5px 5px}.ng-select.ng-select-opened>.ng-select-container .ng-arrow:hover{border-color:transparent transparent #333}.ng-select.ng-select-opened.ng-select-top>.ng-select-container{border-top-right-radius:0;border-top-left-radius:0}.ng-select.ng-select-opened.ng-select-right>.ng-select-container{border-top-right-radius:0;border-bottom-right-radius:0}.ng-select.ng-select-opened.ng-select-bottom>.ng-select-container{border-bottom-right-radius:0;border-bottom-left-radius:0}.ng-select.ng-select-opened.ng-select-left>.ng-select-container{border-top-left-radius:0;border-bottom-left-radius:0}.ng-select.ng-select-focused:not(.ng-select-opened)>.ng-select-container{border-color:#007eff;box-shadow:inset 0 1px 1px #00000013,0 0 0 3px #007eff1a}.ng-select.ng-select-disabled>.ng-select-container{background-color:#f9f9f9}.ng-select .ng-has-value .ng-placeholder{display:none}.ng-select .ng-select-container{color:#333;background-color:#fff;border-radius:4px;border:1px solid #ccc;min-height:36px;align-items:center}.ng-select .ng-select-container:hover{box-shadow:0 1px #0000000f}.ng-select .ng-select-container .ng-value-container{align-items:center;padding-left:10px}[dir=rtl] .ng-select .ng-select-container .ng-value-container{padding-right:10px;padding-left:0}.ng-select .ng-select-container .ng-value-container .ng-placeholder{color:#999}.ng-select.ng-select-single .ng-select-container{height:36px}.ng-select.ng-select-single .ng-select-container .ng-value-container .ng-input{top:5px;left:0;padding-left:10px;padding-right:50px}[dir=rtl] .ng-select.ng-select-single .ng-select-container .ng-value-container .ng-input{padding-right:10px;padding-left:50px}.ng-select.ng-select-multiple.ng-select-disabled>.ng-select-container .ng-value-container .ng-value{background-color:#f9f9f9;border:1px solid #e6e6e6}.ng-select.ng-select-multiple.ng-select-disabled>.ng-select-container .ng-value-container .ng-value .ng-value-label{padding:0 5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container{padding-top:5px;padding-left:7px}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container{padding-right:7px;padding-left:0}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value{font-size:.9em;margin-bottom:5px;color:#333;background-color:#ebf5ff;border-radius:2px;margin-right:5px}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value{margin-right:0;margin-left:5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-value-disabled{background-color:#f9f9f9}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-value-disabled .ng-value-label{padding-left:5px}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-value-disabled .ng-value-label{padding-left:0;padding-right:5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-label,.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon{display:inline-block;padding:1px 5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon:hover{background-color:#d1e8ff}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.left{border-right:1px solid #b8dbff}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.left{border-left:1px solid #b8dbff;border-right:none}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.right{border-left:1px solid #b8dbff}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.right{border-left:0;border-right:1px solid #b8dbff}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-input{padding:0 0 3px 3px}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-input{padding:0 3px 3px 0}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-input>input{color:#000}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-placeholder{top:5px;padding-bottom:5px;padding-left:3px}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-placeholder{padding-right:3px;padding-left:0}.ng-select .ng-clear-wrapper{color:#999}.ng-select .ng-clear-wrapper:hover .ng-clear{color:#d0021b}.ng-select .ng-clear-wrapper:focus .ng-clear{color:#d0021b}.ng-select .ng-clear-wrapper:focus{outline:none}.ng-select .ng-spinner-zone{padding:5px 5px 0 0}[dir=rtl] .ng-select .ng-spinner-zone{padding:5px 0 0 5px}.ng-select .ng-arrow-wrapper{width:25px;padding-right:5px}[dir=rtl] .ng-select .ng-arrow-wrapper{padding-left:5px;padding-right:0}.ng-select .ng-arrow-wrapper:hover .ng-arrow{border-top-color:#666}.ng-select .ng-arrow-wrapper .ng-arrow{border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 2.5px}.ng-dropdown-panel{background-color:#fff;border:1px solid #ccc;box-shadow:0 1px #0000000f;left:0}.ng-dropdown-panel.ng-select-top{bottom:100%;border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-color:#e6e6e6;margin-bottom:-1px}.ng-dropdown-panel.ng-select-top .ng-dropdown-panel-items .ng-option:first-child{border-top-right-radius:4px;border-top-left-radius:4px}.ng-dropdown-panel.ng-select-right{left:100%;top:0;border-top-right-radius:4px;border-bottom-right-radius:4px;border-bottom-left-radius:4px;border-bottom-color:#e6e6e6;margin-bottom:-1px}.ng-dropdown-panel.ng-select-right .ng-dropdown-panel-items .ng-option:first-child{border-top-right-radius:4px}.ng-dropdown-panel.ng-select-bottom{top:100%;border-bottom-right-radius:4px;border-bottom-left-radius:4px;border-top-color:#e6e6e6;margin-top:-1px}.ng-dropdown-panel.ng-select-bottom .ng-dropdown-panel-items .ng-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.ng-dropdown-panel.ng-select-left{left:-100%;top:0;border-top-left-radius:4px;border-bottom-right-radius:4px;border-bottom-left-radius:4px;border-bottom-color:#e6e6e6;margin-bottom:-1px}.ng-dropdown-panel.ng-select-left .ng-dropdown-panel-items .ng-option:first-child{border-top-left-radius:4px}.ng-dropdown-panel .ng-dropdown-header{border-bottom:1px solid #ccc;padding:5px 7px}.ng-dropdown-panel .ng-dropdown-footer{border-top:1px solid #ccc;padding:5px 7px}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup{-webkit-user-select:none;user-select:none;padding:8px 10px;font-weight:500;color:#0000008a;cursor:pointer}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-disabled{cursor:default}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-marked{background-color:#f5faff}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-selected,.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-selected.ng-option-marked{color:#0000008a;background-color:#ebf5ff;font-weight:600}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option{background-color:#fff;color:#000000de;padding:8px 10px}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected,.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected.ng-option-marked{color:#333;background-color:#ebf5ff}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected .ng-option-label,.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected.ng-option-marked .ng-option-label{font-weight:600}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-marked{background-color:#f5faff;color:#333}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-disabled{color:#ccc}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-child{padding-left:22px}[dir=rtl] .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-child{padding-right:22px;padding-left:0}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option .ng-tag-label{font-size:80%;font-weight:400;padding-right:5px}[dir=rtl] .ng-dropdown-panel .ng-dropdown-panel-items .ng-option .ng-tag-label{padding-left:5px;padding-right:0}[dir=rtl] .ng-dropdown-panel{direction:rtl;text-align:right}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$4.FSWFieldHeaderPrefixDirective, selector: "ng-template[fswFieldHeaderPrefix]", inputs: ["kind", "label", "required"] }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "component", type: FSWUploadComponent, selector: "fsw-upload", inputs: ["buttonUploadLabel", "isPrimaryButton"], outputs: ["fileSelect"] }, { kind: "component", type: i1$4.FSWDatePickerComponent, selector: "fsw-date-picker" }, { kind: "component", type: i1$4.FSWCheckboxComponent, selector: "fsw-checkbox" }, { kind: "component", type: i7.NgSelectComponent, selector: "ng-select", inputs: ["bindLabel", "bindValue", "markFirst", "placeholder", "notFoundText", "typeToSearchText", "addTagText", "loadingText", "clearAllText", "appearance", "dropdownPosition", "appendTo", "loading", "closeOnSelect", "hideSelected", "selectOnTab", "openOnEnter", "maxSelectedItems", "groupBy", "groupValue", "bufferAmount", "virtualScroll", "selectableGroup", "selectableGroupAsModel", "searchFn", "trackByFn", "clearOnBackspace", "labelForId", "inputAttrs", "tabIndex", "readonly", "searchWhileComposing", "minTermLength", "editableSearchTerm", "keyDownFn", "typeahead", "multiple", "addTag", "searchable", "clearable", "isOpen", "items", "compareWith", "clearSearchOnAdd", "deselectOnClick"], outputs: ["blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"] }, { kind: "directive", type: i7.NgOptionTemplateDirective, selector: "[ng-option-tmp]" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAddBankAccountModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-add-bank-account', template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <fsw-modal\n    [title]=\"'Add Bank Account & Send to Parser'\"\n    [confirmButton]=\"'Add & Send to Parser'\"\n    [cancelButton]=\"translate.buttons.cancel\"\n    [size]=\"modalSize\"\n    [confirmButtonDisabled]=\"isButtonDisable\"\n    (closeEvent)=\"onClose()\"\n    (cancelEvent)=\"onClose()\"\n    (confirmEvent)=\"onConfirm()\"\n  >\n    <ng-template fswModalBody>\n      <ng-container [formGroup]=\"addBankAccountFG\">\n        <section *ngIf=\"errors?.length\" class=\"bg-red-100 text-red-500 p-2 h-auto\">\n          <div class=\"text-[12px] p-1\" *ngFor=\"let err of errors\">\n            {{ err }}\n          </div>\n        </section>\n\n        <main class=\"flex justify-between w-full mt-2\">\n          <section class=\"w-1/2\">\n            <div class=\"mb-4 max-w-[328px]\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.bank_name }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n              </fsw-field>\n              <ng-select\n                class=\"custom\"\n                [items]=\"referenceData.banks\"\n                bindLabel=\"name\"\n                bindValue=\"code\"\n                [multiple]=\"false\"\n                [closeOnSelect]=\"true\"\n                formControlName=\"bank_code\"\n              >\n                <ng-template ng-option-tmp let-item=\"item\" let-item$=\"item$\" let-index=\"index\">\n                  <span class=\"select-option\">\n                    {{ item?.name }}\n                  </span>\n                </ng-template>\n              </ng-select>\n            </div>\n\n            <div class=\"w-[328px] mb-4\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.account_name }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <input\n                  type=\"text\"\n                  class=\"form-input\"\n                  formControlName=\"account_name\"\n                  [placeholder]=\"'Please enter Account Name'\"\n                />\n              </fsw-field>\n            </div>\n\n            <div class=\"w-[328px] mb-4\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.account_number }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <input\n                  type=\"text\"\n                  class=\"form-input\"\n                  formControlName=\"account_number\"\n                  [placeholder]=\"'Please enter Account Number'\"\n                />\n              </fsw-field>\n            </div>\n\n            <div class=\"mb-4 max-w-[328px]\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.account_type }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <fsw-select\n                  [maxHeight]=\"'200px'\"\n                  [placeHolder]=\"'Please select Account Types'\"\n                  formControlName=\"account_type\"\n                >\n                  <ng-container *ngFor=\"let bankAccType of referenceData.bankAccountTypes\">\n                    <ng-template\n                      fswSelectItem\n                      let-selected\n                      [text]=\"bankAccType.name\"\n                      [value]=\"bankAccType.code\"\n                    ></ng-template>\n                  </ng-container>\n                </fsw-select>\n              </fsw-field>\n            </div>\n\n            <div class=\"max-w-[328px]\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.currency }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <fsw-select\n                  [maxHeight]=\"'200px'\"\n                  [placeHolder]=\"'Please select currency'\"\n                  formControlName=\"currency\"\n                >\n                  <ng-container *ngFor=\"let curr of referenceData.currencies\">\n                    <ng-template\n                      fswSelectItem\n                      let-selected\n                      [text]=\"curr.name\"\n                      [value]=\"curr.code\"\n                    ></ng-template>\n                  </ng-container>\n                </fsw-select>\n              </fsw-field>\n            </div>\n\n            <div class=\"max-w-[328px]\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.parser }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <fsw-select\n                  [maxHeight]=\"'200px'\"\n                  [placeHolder]=\"'Please select parser'\"\n                  formControlName=\"parser\"\n                >\n                  <ng-container *ngFor=\"let val of parserOptions\">\n                    <ng-template\n                      fswSelectItem\n                      let-selected\n                      [text]=\"val\"\n                      [value]=\"val\"\n                    ></ng-template>\n                  </ng-container>\n                </fsw-select>\n              </fsw-field>\n            </div>\n          </section>\n\n          <section class=\"w-1/2\">\n            <div class=\"flex justify-between gap-[8px] mb-4\">\n              <div class=\"w-1/2\">\n                <fsw-field size=\"s\" [fullWidth]=\"true\">\n                  <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                    <label>\n                      {{ translate.bankAccountStmt.form_fields.from_date }}\n                      <span class=\"text-red-500\">*</span>\n                    </label>\n                  </ng-template>\n                  <fsw-date-picker\n                    formControlName=\"from_date\"\n                    [closeOnSelected]=\"true\"\n                    format=\"MMM-yyyy\"\n                  >\n                  </fsw-date-picker>\n                </fsw-field>\n              </div>\n              <div class=\"w-1/2\">\n                <fsw-field size=\"s\" [fullWidth]=\"true\">\n                  <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                    <label>\n                      {{ translate.bankAccountStmt.form_fields.to_date }}\n                      <span class=\"text-red-500\">*</span>\n                    </label>\n                  </ng-template>\n                  <fsw-date-picker\n                    formControlName=\"to_date\"\n                    [closeOnSelected]=\"true\"\n                    format=\"MMM-YYYY\"\n                    [min]=\"getRangeDate(addBankAccountFG.get('from_date')?.value, 1)\"\n                  >\n                  </fsw-date-picker>\n                </fsw-field>\n              </div>\n            </div>\n\n            <div class=\"flex justify-between items-center gap-[4px]\">\n              <fsw-upload\n                [buttonUploadLabel]=\"translate.bankAccountStmt.buttons.upload_statements\"\n                (fileSelect)=\"uploadFile($event)\"\n              ></fsw-upload>\n              <div *ngIf=\"files?.length\">\n                <fsw-checkbox formControlName=\"is_scanned\" [label]=\"'Is Scanned ?'\"></fsw-checkbox>\n              </div>\n            </div>\n\n            <div class=\"bg-gray-100 text-gray-700 text-[12px] p-2 mt-4\">\n              <div>{{ translate.bankAccountStmt.notes.note_1 }}</div>\n              <div>{{ translate.bankAccountStmt.notes.note_2 }}</div>\n            </div>\n\n            <div class=\"py-2 max-h-[190px] h-auto overflow-y-scroll\" *ngIf=\"files?.length\">\n              <div\n                class=\"bg-blue-100 text-[12px] text-blue-500 p-2 my-1\"\n                *ngFor=\"let file of files\"\n              >\n                <span>{{ file?.name }}</span>\n              </div>\n            </div>\n          </section>\n        </main>\n      </ng-container>\n    </ng-template>\n  </fsw-modal>\n</ng-container>\n", styles: [".ng-select.ng-select-opened>.ng-select-container{background:#fff;border-color:#b3b3b3 #ccc #d9d9d9}.ng-select.ng-select-opened>.ng-select-container:hover{box-shadow:none}.ng-select.ng-select-opened>.ng-select-container .ng-arrow{top:-2px;border-color:transparent transparent #999;border-width:0 5px 5px}.ng-select.ng-select-opened>.ng-select-container .ng-arrow:hover{border-color:transparent transparent #333}.ng-select.ng-select-opened.ng-select-top>.ng-select-container{border-top-right-radius:0;border-top-left-radius:0}.ng-select.ng-select-opened.ng-select-right>.ng-select-container{border-top-right-radius:0;border-bottom-right-radius:0}.ng-select.ng-select-opened.ng-select-bottom>.ng-select-container{border-bottom-right-radius:0;border-bottom-left-radius:0}.ng-select.ng-select-opened.ng-select-left>.ng-select-container{border-top-left-radius:0;border-bottom-left-radius:0}.ng-select.ng-select-focused:not(.ng-select-opened)>.ng-select-container{border-color:#007eff;box-shadow:inset 0 1px 1px #00000013,0 0 0 3px #007eff1a}.ng-select.ng-select-disabled>.ng-select-container{background-color:#f9f9f9}.ng-select .ng-has-value .ng-placeholder{display:none}.ng-select .ng-select-container{color:#333;background-color:#fff;border-radius:4px;border:1px solid #ccc;min-height:36px;align-items:center}.ng-select .ng-select-container:hover{box-shadow:0 1px #0000000f}.ng-select .ng-select-container .ng-value-container{align-items:center;padding-left:10px}[dir=rtl] .ng-select .ng-select-container .ng-value-container{padding-right:10px;padding-left:0}.ng-select .ng-select-container .ng-value-container .ng-placeholder{color:#999}.ng-select.ng-select-single .ng-select-container{height:36px}.ng-select.ng-select-single .ng-select-container .ng-value-container .ng-input{top:5px;left:0;padding-left:10px;padding-right:50px}[dir=rtl] .ng-select.ng-select-single .ng-select-container .ng-value-container .ng-input{padding-right:10px;padding-left:50px}.ng-select.ng-select-multiple.ng-select-disabled>.ng-select-container .ng-value-container .ng-value{background-color:#f9f9f9;border:1px solid #e6e6e6}.ng-select.ng-select-multiple.ng-select-disabled>.ng-select-container .ng-value-container .ng-value .ng-value-label{padding:0 5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container{padding-top:5px;padding-left:7px}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container{padding-right:7px;padding-left:0}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value{font-size:.9em;margin-bottom:5px;color:#333;background-color:#ebf5ff;border-radius:2px;margin-right:5px}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value{margin-right:0;margin-left:5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-value-disabled{background-color:#f9f9f9}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-value-disabled .ng-value-label{padding-left:5px}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-value-disabled .ng-value-label{padding-left:0;padding-right:5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-label,.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon{display:inline-block;padding:1px 5px}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon:hover{background-color:#d1e8ff}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.left{border-right:1px solid #b8dbff}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.left{border-left:1px solid #b8dbff;border-right:none}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.right{border-left:1px solid #b8dbff}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.right{border-left:0;border-right:1px solid #b8dbff}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-input{padding:0 0 3px 3px}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-input{padding:0 3px 3px 0}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-input>input{color:#000}.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-placeholder{top:5px;padding-bottom:5px;padding-left:3px}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-placeholder{padding-right:3px;padding-left:0}.ng-select .ng-clear-wrapper{color:#999}.ng-select .ng-clear-wrapper:hover .ng-clear{color:#d0021b}.ng-select .ng-clear-wrapper:focus .ng-clear{color:#d0021b}.ng-select .ng-clear-wrapper:focus{outline:none}.ng-select .ng-spinner-zone{padding:5px 5px 0 0}[dir=rtl] .ng-select .ng-spinner-zone{padding:5px 0 0 5px}.ng-select .ng-arrow-wrapper{width:25px;padding-right:5px}[dir=rtl] .ng-select .ng-arrow-wrapper{padding-left:5px;padding-right:0}.ng-select .ng-arrow-wrapper:hover .ng-arrow{border-top-color:#666}.ng-select .ng-arrow-wrapper .ng-arrow{border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 2.5px}.ng-dropdown-panel{background-color:#fff;border:1px solid #ccc;box-shadow:0 1px #0000000f;left:0}.ng-dropdown-panel.ng-select-top{bottom:100%;border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-color:#e6e6e6;margin-bottom:-1px}.ng-dropdown-panel.ng-select-top .ng-dropdown-panel-items .ng-option:first-child{border-top-right-radius:4px;border-top-left-radius:4px}.ng-dropdown-panel.ng-select-right{left:100%;top:0;border-top-right-radius:4px;border-bottom-right-radius:4px;border-bottom-left-radius:4px;border-bottom-color:#e6e6e6;margin-bottom:-1px}.ng-dropdown-panel.ng-select-right .ng-dropdown-panel-items .ng-option:first-child{border-top-right-radius:4px}.ng-dropdown-panel.ng-select-bottom{top:100%;border-bottom-right-radius:4px;border-bottom-left-radius:4px;border-top-color:#e6e6e6;margin-top:-1px}.ng-dropdown-panel.ng-select-bottom .ng-dropdown-panel-items .ng-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.ng-dropdown-panel.ng-select-left{left:-100%;top:0;border-top-left-radius:4px;border-bottom-right-radius:4px;border-bottom-left-radius:4px;border-bottom-color:#e6e6e6;margin-bottom:-1px}.ng-dropdown-panel.ng-select-left .ng-dropdown-panel-items .ng-option:first-child{border-top-left-radius:4px}.ng-dropdown-panel .ng-dropdown-header{border-bottom:1px solid #ccc;padding:5px 7px}.ng-dropdown-panel .ng-dropdown-footer{border-top:1px solid #ccc;padding:5px 7px}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup{-webkit-user-select:none;user-select:none;padding:8px 10px;font-weight:500;color:#0000008a;cursor:pointer}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-disabled{cursor:default}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-marked{background-color:#f5faff}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-selected,.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-selected.ng-option-marked{color:#0000008a;background-color:#ebf5ff;font-weight:600}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option{background-color:#fff;color:#000000de;padding:8px 10px}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected,.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected.ng-option-marked{color:#333;background-color:#ebf5ff}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected .ng-option-label,.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected.ng-option-marked .ng-option-label{font-weight:600}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-marked{background-color:#f5faff;color:#333}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-disabled{color:#ccc}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-child{padding-left:22px}[dir=rtl] .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-child{padding-right:22px;padding-left:0}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option .ng-tag-label{font-size:80%;font-weight:400;padding-right:5px}[dir=rtl] .ng-dropdown-panel .ng-dropdown-panel-items .ng-option .ng-tag-label{padding-left:5px;padding-right:0}[dir=rtl] .ng-dropdown-panel{direction:rtl;text-align:right}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [STORE_TOKEN$6]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: i1$7.DialogRef }, { type: i2.FormBuilder }]; } });

const DECLARATIONS_EXPORTS$k = [FSWAddBankAccountModalComponent];
class FSWAddBankAccountModalModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAddBankAccountModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWAddBankAccountModalModule, declarations: [FSWAddBankAccountModalComponent], imports: [CommonModule,
            ReactiveFormsModule,
            LetDirective,
            FSWFieldModule,
            FSWSelectModule,
            TranslocoModule,
            FSWModalModule$1,
            DialogModule,
            FSWUploadModule,
            FSWDateTimePickerModule,
            FSWCheckboxModule,
            NgSelectModule], exports: [FSWAddBankAccountModalComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAddBankAccountModalModule, imports: [CommonModule,
            ReactiveFormsModule,
            FSWFieldModule,
            FSWSelectModule,
            TranslocoModule,
            FSWModalModule$1,
            DialogModule,
            FSWUploadModule,
            FSWDateTimePickerModule,
            FSWCheckboxModule,
            NgSelectModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAddBankAccountModalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        LetDirective,
                        FSWFieldModule,
                        FSWSelectModule,
                        TranslocoModule,
                        FSWModalModule$1,
                        DialogModule,
                        FSWUploadModule,
                        FSWDateTimePickerModule,
                        FSWCheckboxModule,
                        NgSelectModule,
                    ],
                    declarations: DECLARATIONS_EXPORTS$k,
                    exports: DECLARATIONS_EXPORTS$k,
                }]
        }] });

const initFG$4 = (_fb) => {
    const currency = COUNTRY_CONFIG[getCountryCodeFromStorage()]?.currencyCode || COUNTRY_CONFIG['MY'].currencyCode;
    return _fb.group({
        bank_code: ['', [Validators.required]],
        account_name: ['', [Validators.required]],
        account_number: ['', [Validators.required]],
        account_type: ['', [Validators.required]],
        currency: [currency, [Validators.required]],
        parser: ['', [Validators.required]],
        from_date: ['', [Validators.required]],
        to_date: ['', [Validators.required]],
        is_scanned: false,
    });
};
function convertDate$1(dateString) {
    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${month}-${year}`;
}
function isMMMYYYYFormat$1(dateString) {
    return /^[A-Za-z]{3}-\d{4}$/.test(dateString);
}
function isISOStringFormat$1(dateString) {
    return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(dateString);
}
function isOtherDateFormat$1(dateString) {
    return isNaN(Date.parse(dateString)) === false;
}
const convertDatesInUpdatePayload$1 = (inputObject) => {
    // Check if 'from_date' property exists and has the format 'MMM-YYYY' or ISO string
    if (inputObject.from_date) {
        if (isMMMYYYYFormat$1(inputObject.from_date)) {
            const [month, year] = inputObject.from_date.split('-');
            const monthNames = [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec',
            ];
            const monthIndex = monthNames.indexOf(month);
            if (monthIndex >= 0) {
                inputObject.from_date = `${(monthIndex + 1).toString().padStart(2, '0')}-${year}`;
            }
        }
        else if (isISOStringFormat$1(inputObject.from_date)) {
            inputObject.from_date = convertDate$1(inputObject.from_date);
        }
        else if (isOtherDateFormat$1(inputObject.from_date)) {
            inputObject.from_date = convertDate$1(inputObject.from_date);
        }
    }
    // Check if 'to_date' property exists and has the format 'MMM-YYYY' or ISO string
    if (inputObject.to_date) {
        if (isMMMYYYYFormat$1(inputObject.to_date)) {
            const [month, year] = inputObject.to_date.split('-');
            const monthNames = [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec',
            ];
            const monthIndex = monthNames.indexOf(month);
            if (monthIndex >= 0) {
                inputObject.to_date = `${(monthIndex + 1).toString().padStart(2, '0')}-${year}`;
            }
        }
        else if (isISOStringFormat$1(inputObject.to_date)) {
            inputObject.to_date = convertDate$1(inputObject.to_date);
        }
        else if (isOtherDateFormat$1(inputObject.to_date)) {
            inputObject.to_date = convertDate$1(inputObject.to_date);
        }
    }
    return inputObject;
};

class FSWCloneBankAccountModalComponent {
    get isButtonDisable() {
        return this.cloneBankAccountFG.invalid;
    }
    constructor(data, _componentStore, _scope, _translateService, _dialogRef, _fb) {
        this.data = data;
        this._componentStore = _componentStore;
        this._scope = _scope;
        this._translateService = _translateService;
        this._dialogRef = _dialogRef;
        this._fb = _fb;
        this._destroy$ = new Subject();
        this.modalSize = FSWModalSizes.S;
        this.errors = [];
        this.referenceData = {
            banks: [],
            bankAccountTypes: [],
            currencies: [],
            banksMap: {},
            exchangeRatesContent: null,
        };
        this.parserOptions = FULL_PARSER_OPTIONS;
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'bank_accounts_and_statements'),
            this._translateService.selectFeatureTranslate(this._scope, 'buttons'),
        ]).pipe(map(([bankAccountStmt, buttons]) => ({
            bankAccountStmt,
            buttons,
        })));
        this._componentStore.state$
            .pipe(takeUntil(this._destroy$), map((state) => state.referenceData), tap((referenceData) => {
            if (!referenceData)
                return;
            this.referenceData = referenceData;
            if (this.referenceData?.banks?.length) {
                this.errors = this.errors.filter((err) => err !== 'Error in getting dropdown data from server');
            }
        }))
            .subscribe();
        if (this.data?.singleRowData?.available_parsers) {
            this.parserOptions = this.data.singleRowData.available_parsers;
        }
        this.cloneBankAccountFG = initFG$4(this._fb);
        this.cloneBankAccountFG.patchValue({ ...this.data.singleRowData });
        if (!this.referenceData ||
            !this.referenceData?.banks?.length ||
            !this.referenceData?.bankAccountTypes?.length ||
            !this.referenceData?.currencies?.length) {
            this.errors = [...this.errors, 'Error in getting dropdown data from server'];
            return;
        }
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    onConfirm() {
        this._componentStore.cloneBankAccount({
            bankAccountId: this.data?.singleRowData?.account_id || '',
            payload: {
                parser: this.cloneBankAccountFG.value?.parser,
                run_parse: true,
            },
        });
        this._dialogRef.close();
    }
    onClose() {
        this._dialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCloneBankAccountModalComponent, deps: [{ token: DIALOG_DATA }, { token: STORE_TOKEN$6 }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: i1$7.DialogRef }, { token: i2.FormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCloneBankAccountModalComponent, selector: "fsw-clone-bank-account", ngImport: i0, template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <fsw-modal\n    [title]=\"'Select the parser'\"\n    [confirmButton]=\"'Parse'\"\n    [cancelButton]=\"translate.buttons.cancel\"\n    [size]=\"modalSize\"\n    [confirmButtonDisabled]=\"isButtonDisable\"\n    (closeEvent)=\"onClose()\"\n    (cancelEvent)=\"onClose()\"\n    (confirmEvent)=\"onConfirm()\"\n  >\n    <ng-template fswModalBody>\n      <ng-container [formGroup]=\"cloneBankAccountFG\">\n        <main class=\"flex justify-between w-full mt-2\">\n          <section class=\"w-full\">\n            <div class=\"max-w-[328px]\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.parser }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <fsw-select\n                  [maxHeight]=\"'200px'\"\n                  [placeHolder]=\"'Please select parser'\"\n                  formControlName=\"parser\"\n                >\n                  <ng-container *ngFor=\"let val of parserOptions\">\n                    <ng-template\n                      fswSelectItem\n                      let-selected\n                      [text]=\"val\"\n                      [value]=\"val\"\n                    ></ng-template>\n                  </ng-container>\n                </fsw-select>\n              </fsw-field>\n            </div>\n          </section>\n        </main>\n      </ng-container>\n    </ng-template>\n  </fsw-modal>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$4.FSWFieldHeaderPrefixDirective, selector: "ng-template[fswFieldHeaderPrefix]", inputs: ["kind", "label", "required"] }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCloneBankAccountModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-clone-bank-account', template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <fsw-modal\n    [title]=\"'Select the parser'\"\n    [confirmButton]=\"'Parse'\"\n    [cancelButton]=\"translate.buttons.cancel\"\n    [size]=\"modalSize\"\n    [confirmButtonDisabled]=\"isButtonDisable\"\n    (closeEvent)=\"onClose()\"\n    (cancelEvent)=\"onClose()\"\n    (confirmEvent)=\"onConfirm()\"\n  >\n    <ng-template fswModalBody>\n      <ng-container [formGroup]=\"cloneBankAccountFG\">\n        <main class=\"flex justify-between w-full mt-2\">\n          <section class=\"w-full\">\n            <div class=\"max-w-[328px]\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.parser }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <fsw-select\n                  [maxHeight]=\"'200px'\"\n                  [placeHolder]=\"'Please select parser'\"\n                  formControlName=\"parser\"\n                >\n                  <ng-container *ngFor=\"let val of parserOptions\">\n                    <ng-template\n                      fswSelectItem\n                      let-selected\n                      [text]=\"val\"\n                      [value]=\"val\"\n                    ></ng-template>\n                  </ng-container>\n                </fsw-select>\n              </fsw-field>\n            </div>\n          </section>\n        </main>\n      </ng-container>\n    </ng-template>\n  </fsw-modal>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DIALOG_DATA]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [STORE_TOKEN$6]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: i1$7.DialogRef }, { type: i2.FormBuilder }]; } });

const DECLARATIONS_EXPORTS$j = [FSWCloneBankAccountModalComponent];
class FSWCloneBankAccountModalModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCloneBankAccountModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWCloneBankAccountModalModule, declarations: [FSWCloneBankAccountModalComponent], imports: [CommonModule,
            ReactiveFormsModule,
            LetDirective,
            FSWFieldModule,
            FSWSelectModule,
            TranslocoModule,
            FSWModalModule$1,
            DialogModule,
            FSWUploadModule,
            FSWDateTimePickerModule,
            FSWCheckboxModule,
            NgSelectModule], exports: [FSWCloneBankAccountModalComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCloneBankAccountModalModule, imports: [CommonModule,
            ReactiveFormsModule,
            FSWFieldModule,
            FSWSelectModule,
            TranslocoModule,
            FSWModalModule$1,
            DialogModule,
            FSWUploadModule,
            FSWDateTimePickerModule,
            FSWCheckboxModule,
            NgSelectModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCloneBankAccountModalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        LetDirective,
                        FSWFieldModule,
                        FSWSelectModule,
                        TranslocoModule,
                        FSWModalModule$1,
                        DialogModule,
                        FSWUploadModule,
                        FSWDateTimePickerModule,
                        FSWCheckboxModule,
                        NgSelectModule,
                    ],
                    declarations: DECLARATIONS_EXPORTS$j,
                    exports: DECLARATIONS_EXPORTS$j,
                }]
        }] });

class FSWConfirmBankAccountModalComponent {
    get isButtonDisable() {
        return !this.files.length;
    }
    constructor(data, _componentStore, _scope, _translateService, _dialogRef) {
        this.data = data;
        this._componentStore = _componentStore;
        this._scope = _scope;
        this._translateService = _translateService;
        this._dialogRef = _dialogRef;
        this._destroy$ = new Subject();
        this.modalSize = FSWModalSizes.S;
        this.errors = [];
        this.files = [];
        this.confirmMessage = 'Are you sure you want to set this bank account as primary ?';
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'bank_accounts_and_statements'),
            this._translateService.selectFeatureTranslate(this._scope, 'buttons'),
        ]).pipe(map(([bankAccountStmt, buttons]) => ({
            bankAccountStmt,
            buttons,
        })));
    }
    ngOnDestroy() {
        if (this._destroy$) {
            this._destroy$.next();
            this._destroy$.complete();
        }
    }
    onConfirm() {
        this._componentStore.setPrimaryBankAccount({
            bankAccountId: this.data?.singleRowData?.account_id || '',
        });
        this._dialogRef.close();
    }
    onClose() {
        this._dialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWConfirmBankAccountModalComponent, deps: [{ token: DIALOG_DATA }, { token: STORE_TOKEN$6 }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: i1$7.DialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWConfirmBankAccountModalComponent, selector: "fsw-confirm-bank-account", ngImport: i0, template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <fsw-modal\n    [title]=\"'Set as Primary Account'\"\n    [confirmButton]=\"translate.buttons.confirm\"\n    [cancelButton]=\"translate.buttons.cancel\"\n    [size]=\"modalSize\"\n    (closeEvent)=\"onClose()\"\n    (cancelEvent)=\"onClose()\"\n    (confirmEvent)=\"onConfirm()\"\n  >\n    <ng-template fswModalBody>\n      <ng-container>\n        <!-- *ngIf=\"data?.singleRowData?.message as confirmMessage\" -->\n        <section class=\"p-2\">\n          <div class=\"text-[16px] p-1 break-words\">\n            {{ confirmMessage }}\n          </div>\n        </section>\n      </ng-container>\n    </ng-template>\n  </fsw-modal>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWConfirmBankAccountModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-confirm-bank-account', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <fsw-modal\n    [title]=\"'Set as Primary Account'\"\n    [confirmButton]=\"translate.buttons.confirm\"\n    [cancelButton]=\"translate.buttons.cancel\"\n    [size]=\"modalSize\"\n    (closeEvent)=\"onClose()\"\n    (cancelEvent)=\"onClose()\"\n    (confirmEvent)=\"onConfirm()\"\n  >\n    <ng-template fswModalBody>\n      <ng-container>\n        <!-- *ngIf=\"data?.singleRowData?.message as confirmMessage\" -->\n        <section class=\"p-2\">\n          <div class=\"text-[16px] p-1 break-words\">\n            {{ confirmMessage }}\n          </div>\n        </section>\n      </ng-container>\n    </ng-template>\n  </fsw-modal>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DIALOG_DATA]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [STORE_TOKEN$6]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: i1$7.DialogRef }]; } });

const DECLARATIONS_EXPORTS$i = [FSWConfirmBankAccountModalComponent];
class FSWConfirmBankAccountModalModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWConfirmBankAccountModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWConfirmBankAccountModalModule, declarations: [FSWConfirmBankAccountModalComponent], imports: [CommonModule, TranslocoModule, FSWModalModule$1, DialogModule], exports: [FSWConfirmBankAccountModalComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWConfirmBankAccountModalModule, imports: [CommonModule, TranslocoModule, FSWModalModule$1, DialogModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWConfirmBankAccountModalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, TranslocoModule, FSWModalModule$1, DialogModule],
                    declarations: DECLARATIONS_EXPORTS$i,
                    exports: DECLARATIONS_EXPORTS$i,
                }]
        }] });

class FSWDeleteBankAccountModalComponent {
    get isButtonDisable() {
        return !this.deleteBankAccountFG.valid;
    }
    constructor(data, _componentStore, _scope, _translateService, _dialogRef, _fb) {
        this.data = data;
        this._componentStore = _componentStore;
        this._scope = _scope;
        this._translateService = _translateService;
        this._dialogRef = _dialogRef;
        this._fb = _fb;
        this._destroy$ = new Subject();
        this.modalSize = FSWModalSizes.S;
        this.errors = [];
        this.files = [];
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'bank_accounts_and_statements'),
            this._translateService.selectFeatureTranslate(this._scope, 'buttons'),
        ]).pipe(map(([bankAccountStmt, buttons]) => ({
            bankAccountStmt,
            buttons,
        })));
        this.deleteBankAccountFG = this._fb.group({
            reason: ['', [Validators.required]],
        });
    }
    ngOnDestroy() {
        if (this._destroy$) {
            this._destroy$.next();
            this._destroy$.complete();
        }
    }
    onConfirm() {
        this._componentStore.deleteBankAccount({
            bankAccountId: this.data?.singleRowData?.account_id || '',
            payload: {
                reason: this.deleteBankAccountFG.value.reason,
            },
        });
        this._dialogRef.close();
    }
    onClose() {
        this._dialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDeleteBankAccountModalComponent, deps: [{ token: DIALOG_DATA }, { token: STORE_TOKEN$6 }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: i1$7.DialogRef }, { token: i2.FormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDeleteBankAccountModalComponent, selector: "fsw-delete-bank-account", ngImport: i0, template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <fsw-modal\n    [title]=\"'Enter Delete Reason'\"\n    [confirmButton]=\"'Delete'\"\n    [cancelButton]=\"translate.buttons.cancel\"\n    [size]=\"modalSize\"\n    [confirmButtonDisabled]=\"isButtonDisable\"\n    (closeEvent)=\"onClose()\"\n    (cancelEvent)=\"onClose()\"\n    (confirmEvent)=\"onConfirm()\"\n  >\n    <ng-template fswModalBody>\n      <ng-container [formGroup]=\"deleteBankAccountFG\">\n        <section *ngIf=\"errors?.length\" class=\"bg-red-100 text-red-500 p-2 h-auto\">\n          <div class=\"text-[12px] p-1\" *ngFor=\"let err of errors\">\n            {{ err }}\n          </div>\n        </section>\n\n        <main class=\"flex justify-between w-full mt-8\">\n          <section lass=\"max-w-[500px] m-auto\">\n            <div class=\"flex justify-between items-center gap-[4px]\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ 'Delete Reason' }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <textarea\n                  rows=\"3\"\n                  cols=\"50\"\n                  class=\"form-textarea\"\n                  [placeholder]=\"'Please enter delete reason'\"\n                  formControlName=\"reason\"\n                ></textarea>\n              </fsw-field>\n            </div>\n          </section>\n        </main>\n      </ng-container>\n    </ng-template>\n  </fsw-modal>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$4.FSWFieldHeaderPrefixDirective, selector: "ng-template[fswFieldHeaderPrefix]", inputs: ["kind", "label", "required"] }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDeleteBankAccountModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-delete-bank-account', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <fsw-modal\n    [title]=\"'Enter Delete Reason'\"\n    [confirmButton]=\"'Delete'\"\n    [cancelButton]=\"translate.buttons.cancel\"\n    [size]=\"modalSize\"\n    [confirmButtonDisabled]=\"isButtonDisable\"\n    (closeEvent)=\"onClose()\"\n    (cancelEvent)=\"onClose()\"\n    (confirmEvent)=\"onConfirm()\"\n  >\n    <ng-template fswModalBody>\n      <ng-container [formGroup]=\"deleteBankAccountFG\">\n        <section *ngIf=\"errors?.length\" class=\"bg-red-100 text-red-500 p-2 h-auto\">\n          <div class=\"text-[12px] p-1\" *ngFor=\"let err of errors\">\n            {{ err }}\n          </div>\n        </section>\n\n        <main class=\"flex justify-between w-full mt-8\">\n          <section lass=\"max-w-[500px] m-auto\">\n            <div class=\"flex justify-between items-center gap-[4px]\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ 'Delete Reason' }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <textarea\n                  rows=\"3\"\n                  cols=\"50\"\n                  class=\"form-textarea\"\n                  [placeholder]=\"'Please enter delete reason'\"\n                  formControlName=\"reason\"\n                ></textarea>\n              </fsw-field>\n            </div>\n          </section>\n        </main>\n      </ng-container>\n    </ng-template>\n  </fsw-modal>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DIALOG_DATA]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [STORE_TOKEN$6]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: i1$7.DialogRef }, { type: i2.FormBuilder }]; } });

const DECLARATIONS_EXPORTS$h = [FSWDeleteBankAccountModalComponent];
class FSWDeleteBankAccountModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDeleteBankAccountModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWDeleteBankAccountModule, declarations: [FSWDeleteBankAccountModalComponent], imports: [CommonModule,
            ReactiveFormsModule,
            LetDirective,
            FSWFieldModule,
            FSWSelectModule,
            TranslocoModule,
            FSWModalModule$1,
            DialogModule], exports: [FSWDeleteBankAccountModalComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDeleteBankAccountModule, imports: [CommonModule,
            ReactiveFormsModule,
            FSWFieldModule,
            FSWSelectModule,
            TranslocoModule,
            FSWModalModule$1,
            DialogModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDeleteBankAccountModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        LetDirective,
                        FSWFieldModule,
                        FSWSelectModule,
                        TranslocoModule,
                        FSWModalModule$1,
                        DialogModule,
                    ],
                    declarations: DECLARATIONS_EXPORTS$h,
                    exports: DECLARATIONS_EXPORTS$h,
                }]
        }] });

const initFG$3 = (_fb) => {
    const currency = COUNTRY_CONFIG[getCountryCodeFromStorage()]?.currencyCode || COUNTRY_CONFIG['MY'].currencyCode;
    return _fb.group({
        bank_code: ['', [Validators.required]],
        account_name: ['', [Validators.required]],
        account_number: ['', [Validators.required]],
        account_type: ['', [Validators.required]],
        currency: [currency, [Validators.required]],
        parser: [{ value: '', disabled: true }, [Validators.required]],
        from_date: ['', [Validators.required]],
        to_date: ['', [Validators.required]],
        is_scanned: false,
    });
};
function convertDate(dateString) {
    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${month}-${year}`;
}
function isMMMYYYYFormat(dateString) {
    return /^[A-Za-z]{3}-\d{4}$/.test(dateString);
}
function isISOStringFormat(dateString) {
    return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(dateString);
}
function isOtherDateFormat(dateString) {
    return isNaN(Date.parse(dateString)) === false;
}
const convertDatesInUpdatePayload = (inputObject) => {
    // Check if 'from_date' property exists and has the format 'MMM-YYYY' or ISO string
    if (inputObject.from_date) {
        if (isMMMYYYYFormat(inputObject.from_date)) {
            const [month, year] = inputObject.from_date.split('-');
            const monthNames = [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec',
            ];
            const monthIndex = monthNames.indexOf(month);
            if (monthIndex >= 0) {
                inputObject.from_date = `${(monthIndex + 1).toString().padStart(2, '0')}-${year}`;
            }
        }
        else if (isISOStringFormat(inputObject.from_date)) {
            inputObject.from_date = convertDate(inputObject.from_date);
        }
        else if (isOtherDateFormat(inputObject.from_date)) {
            inputObject.from_date = convertDate(inputObject.from_date);
        }
    }
    // Check if 'to_date' property exists and has the format 'MMM-YYYY' or ISO string
    if (inputObject.to_date) {
        if (isMMMYYYYFormat(inputObject.to_date)) {
            const [month, year] = inputObject.to_date.split('-');
            const monthNames = [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec',
            ];
            const monthIndex = monthNames.indexOf(month);
            if (monthIndex >= 0) {
                inputObject.to_date = `${(monthIndex + 1).toString().padStart(2, '0')}-${year}`;
            }
        }
        else if (isISOStringFormat(inputObject.to_date)) {
            inputObject.to_date = convertDate(inputObject.to_date);
        }
        else if (isOtherDateFormat(inputObject.to_date)) {
            inputObject.to_date = convertDate(inputObject.to_date);
        }
    }
    return inputObject;
};

class FSWEditBankAccountModalComponent {
    get isButtonDisable() {
        return this.editBankAccountFG.invalid;
    }
    constructor(data, _componentStore, _scope, _translateService, _dialogRef, _fb) {
        this.data = data;
        this._componentStore = _componentStore;
        this._scope = _scope;
        this._translateService = _translateService;
        this._dialogRef = _dialogRef;
        this._fb = _fb;
        this._destroy$ = new Subject();
        this.modalSize = FSWModalSizes.L;
        this.errors = [];
        this.referenceData = {
            banks: [],
            bankAccountTypes: [],
            currencies: [],
            banksMap: {},
            exchangeRatesContent: null,
        };
        this.parserOptions = FULL_PARSER_OPTIONS;
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'bank_accounts_and_statements'),
            this._translateService.selectFeatureTranslate(this._scope, 'buttons'),
        ]).pipe(map(([bankAccountStmt, buttons]) => ({
            bankAccountStmt,
            buttons,
        })));
        this._componentStore.state$
            .pipe(takeUntil(this._destroy$), map((state) => state.referenceData), tap((referenceData) => {
            if (!referenceData)
                return;
            this.referenceData = referenceData;
            if (this.referenceData?.banks?.length) {
                this.errors = this.errors.filter((err) => err !== 'Error in getting dropdown data from server');
            }
        }))
            .subscribe();
        this.editBankAccountFG = initFG$3(this._fb);
        this.editBankAccountFG.patchValue({ ...this.data.singleRowData });
        if (!this.referenceData ||
            !this.referenceData?.banks?.length ||
            !this.referenceData?.bankAccountTypes?.length ||
            !this.referenceData?.currencies?.length) {
            this.errors = [...this.errors, 'Error in getting dropdown data from server'];
            return;
        }
        if (this._componentStore.state().username === 'tengbin.koay@fundingsocieties.com') {
            this.parserOptions = FULL_PARSER_OPTIONS;
        }
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    onConfirm() {
        const payload = {
            ...this.editBankAccountFG.value,
            bank_name: this.editBankAccountFG.value?.bank_code || '',
        };
        this._componentStore.updateBankAccount({
            bankAccountId: this.data?.singleRowData?.account_id || '',
            payload: convertDatesInUpdatePayload(payload),
        });
        this._dialogRef.close();
    }
    onClose() {
        this._dialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWEditBankAccountModalComponent, deps: [{ token: DIALOG_DATA }, { token: STORE_TOKEN$6 }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: i1$7.DialogRef }, { token: i2.FormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWEditBankAccountModalComponent, selector: "fsw-edit-bank-account", ngImport: i0, template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <fsw-modal\n    [title]=\"'Edit Bank Account'\"\n    [confirmButton]=\"'Save Changes'\"\n    [cancelButton]=\"translate.buttons.cancel\"\n    [size]=\"modalSize\"\n    [confirmButtonDisabled]=\"isButtonDisable\"\n    (closeEvent)=\"onClose()\"\n    (cancelEvent)=\"onClose()\"\n    (confirmEvent)=\"onConfirm()\"\n  >\n    <ng-template fswModalBody>\n      <ng-container [formGroup]=\"editBankAccountFG\">\n        <main class=\"flex justify-between w-full mt-2\">\n          <section class=\"w-1/2\">\n            <div class=\"mb-4 max-w-[328px]\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.bank_name }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n              </fsw-field>\n              <ng-select\n                class=\"custom\"\n                [items]=\"referenceData.banks\"\n                bindLabel=\"name\"\n                bindValue=\"code\"\n                [multiple]=\"false\"\n                [closeOnSelect]=\"true\"\n                formControlName=\"bank_code\"\n              >\n                <ng-template ng-option-tmp let-item=\"item\" let-item$=\"item$\" let-index=\"index\">\n                  <span class=\"select-option\">\n                    {{ item?.name }}\n                  </span>\n                </ng-template>\n              </ng-select>\n            </div>\n\n            <div class=\"w-[328px] mb-4\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.account_name }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <input\n                  type=\"text\"\n                  class=\"form-input\"\n                  formControlName=\"account_name\"\n                  [placeholder]=\"'Please enter Account Name'\"\n                />\n              </fsw-field>\n            </div>\n\n            <div class=\"w-[328px] mb-4\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.account_number }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <input\n                  type=\"text\"\n                  class=\"form-input\"\n                  formControlName=\"account_number\"\n                  [placeholder]=\"'Please enter Account Number'\"\n                />\n              </fsw-field>\n            </div>\n\n            <div class=\"mb-4 max-w-[328px]\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.account_type }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <fsw-select\n                  [maxHeight]=\"'200px'\"\n                  [placeHolder]=\"'Please select Account Types'\"\n                  formControlName=\"account_type\"\n                >\n                  <ng-container *ngFor=\"let bankAccType of referenceData.bankAccountTypes\">\n                    <ng-template\n                      fswSelectItem\n                      let-selected\n                      [text]=\"bankAccType.name\"\n                      [value]=\"bankAccType.code\"\n                    ></ng-template>\n                  </ng-container>\n                </fsw-select>\n              </fsw-field>\n            </div>\n\n            <div class=\"max-w-[328px]\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.currency }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <fsw-select\n                  [maxHeight]=\"'200px'\"\n                  [placeHolder]=\"'Please select currency'\"\n                  formControlName=\"currency\"\n                >\n                  <ng-container *ngFor=\"let curr of referenceData.currencies\">\n                    <ng-template\n                      fswSelectItem\n                      let-selected\n                      [text]=\"curr.name\"\n                      [value]=\"curr.code\"\n                    ></ng-template>\n                  </ng-container>\n                </fsw-select>\n              </fsw-field>\n            </div>\n\n            <div class=\"max-w-[328px]\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.parser }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <fsw-select\n                  [maxHeight]=\"'200px'\"\n                  [placeHolder]=\"'Please select parser'\"\n                  formControlName=\"parser\"\n                >\n                  <ng-container *ngFor=\"let val of parserOptions\">\n                    <ng-template\n                      fswSelectItem\n                      let-selected\n                      [text]=\"val\"\n                      [value]=\"val\"\n                    ></ng-template>\n                  </ng-container>\n                </fsw-select>\n              </fsw-field>\n            </div>\n          </section>\n\n          <section class=\"w-1/2\">\n            <div class=\"flex justify-between gap-[8px] mb-4\">\n              <div class=\"w-1/2\">\n                <fsw-field size=\"s\" [fullWidth]=\"true\">\n                  <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                    <label>\n                      {{ translate.bankAccountStmt.form_fields.from_date }}\n                      <span class=\"text-red-500\">*</span>\n                    </label>\n                  </ng-template>\n                  <fsw-date-picker\n                    formControlName=\"from_date\"\n                    [closeOnSelected]=\"true\"\n                    format=\"MMM-yyyy\"\n                  >\n                  </fsw-date-picker>\n                </fsw-field>\n              </div>\n              <div class=\"w-1/2\">\n                <fsw-field size=\"s\" [fullWidth]=\"true\">\n                  <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                    <label>\n                      {{ translate.bankAccountStmt.form_fields.to_date }}\n                      <span class=\"text-red-500\">*</span>\n                    </label>\n                  </ng-template>\n                  <fsw-date-picker\n                    formControlName=\"to_date\"\n                    [closeOnSelected]=\"true\"\n                    format=\"MMM-yyyy\"\n                  >\n                  </fsw-date-picker>\n                </fsw-field>\n              </div>\n            </div>\n\n            <div>\n              <fsw-checkbox formControlName=\"is_scanned\" [label]=\"'Is Scanned ?'\"></fsw-checkbox>\n            </div>\n          </section>\n        </main>\n      </ng-container>\n    </ng-template>\n  </fsw-modal>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$4.FSWFieldHeaderPrefixDirective, selector: "ng-template[fswFieldHeaderPrefix]", inputs: ["kind", "label", "required"] }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "component", type: i1$4.FSWDatePickerComponent, selector: "fsw-date-picker" }, { kind: "component", type: i1$4.FSWCheckboxComponent, selector: "fsw-checkbox" }, { kind: "component", type: i7.NgSelectComponent, selector: "ng-select", inputs: ["bindLabel", "bindValue", "markFirst", "placeholder", "notFoundText", "typeToSearchText", "addTagText", "loadingText", "clearAllText", "appearance", "dropdownPosition", "appendTo", "loading", "closeOnSelect", "hideSelected", "selectOnTab", "openOnEnter", "maxSelectedItems", "groupBy", "groupValue", "bufferAmount", "virtualScroll", "selectableGroup", "selectableGroupAsModel", "searchFn", "trackByFn", "clearOnBackspace", "labelForId", "inputAttrs", "tabIndex", "readonly", "searchWhileComposing", "minTermLength", "editableSearchTerm", "keyDownFn", "typeahead", "multiple", "addTag", "searchable", "clearable", "isOpen", "items", "compareWith", "clearSearchOnAdd", "deselectOnClick"], outputs: ["blur", "focus", "change", "open", "close", "search", "clear", "add", "remove", "scroll", "scrollToEnd"] }, { kind: "directive", type: i7.NgOptionTemplateDirective, selector: "[ng-option-tmp]" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWEditBankAccountModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-edit-bank-account', template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <fsw-modal\n    [title]=\"'Edit Bank Account'\"\n    [confirmButton]=\"'Save Changes'\"\n    [cancelButton]=\"translate.buttons.cancel\"\n    [size]=\"modalSize\"\n    [confirmButtonDisabled]=\"isButtonDisable\"\n    (closeEvent)=\"onClose()\"\n    (cancelEvent)=\"onClose()\"\n    (confirmEvent)=\"onConfirm()\"\n  >\n    <ng-template fswModalBody>\n      <ng-container [formGroup]=\"editBankAccountFG\">\n        <main class=\"flex justify-between w-full mt-2\">\n          <section class=\"w-1/2\">\n            <div class=\"mb-4 max-w-[328px]\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.bank_name }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n              </fsw-field>\n              <ng-select\n                class=\"custom\"\n                [items]=\"referenceData.banks\"\n                bindLabel=\"name\"\n                bindValue=\"code\"\n                [multiple]=\"false\"\n                [closeOnSelect]=\"true\"\n                formControlName=\"bank_code\"\n              >\n                <ng-template ng-option-tmp let-item=\"item\" let-item$=\"item$\" let-index=\"index\">\n                  <span class=\"select-option\">\n                    {{ item?.name }}\n                  </span>\n                </ng-template>\n              </ng-select>\n            </div>\n\n            <div class=\"w-[328px] mb-4\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.account_name }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <input\n                  type=\"text\"\n                  class=\"form-input\"\n                  formControlName=\"account_name\"\n                  [placeholder]=\"'Please enter Account Name'\"\n                />\n              </fsw-field>\n            </div>\n\n            <div class=\"w-[328px] mb-4\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.account_number }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <input\n                  type=\"text\"\n                  class=\"form-input\"\n                  formControlName=\"account_number\"\n                  [placeholder]=\"'Please enter Account Number'\"\n                />\n              </fsw-field>\n            </div>\n\n            <div class=\"mb-4 max-w-[328px]\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.account_type }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <fsw-select\n                  [maxHeight]=\"'200px'\"\n                  [placeHolder]=\"'Please select Account Types'\"\n                  formControlName=\"account_type\"\n                >\n                  <ng-container *ngFor=\"let bankAccType of referenceData.bankAccountTypes\">\n                    <ng-template\n                      fswSelectItem\n                      let-selected\n                      [text]=\"bankAccType.name\"\n                      [value]=\"bankAccType.code\"\n                    ></ng-template>\n                  </ng-container>\n                </fsw-select>\n              </fsw-field>\n            </div>\n\n            <div class=\"max-w-[328px]\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.currency }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <fsw-select\n                  [maxHeight]=\"'200px'\"\n                  [placeHolder]=\"'Please select currency'\"\n                  formControlName=\"currency\"\n                >\n                  <ng-container *ngFor=\"let curr of referenceData.currencies\">\n                    <ng-template\n                      fswSelectItem\n                      let-selected\n                      [text]=\"curr.name\"\n                      [value]=\"curr.code\"\n                    ></ng-template>\n                  </ng-container>\n                </fsw-select>\n              </fsw-field>\n            </div>\n\n            <div class=\"max-w-[328px]\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.bankAccountStmt.form_fields.parser }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <fsw-select\n                  [maxHeight]=\"'200px'\"\n                  [placeHolder]=\"'Please select parser'\"\n                  formControlName=\"parser\"\n                >\n                  <ng-container *ngFor=\"let val of parserOptions\">\n                    <ng-template\n                      fswSelectItem\n                      let-selected\n                      [text]=\"val\"\n                      [value]=\"val\"\n                    ></ng-template>\n                  </ng-container>\n                </fsw-select>\n              </fsw-field>\n            </div>\n          </section>\n\n          <section class=\"w-1/2\">\n            <div class=\"flex justify-between gap-[8px] mb-4\">\n              <div class=\"w-1/2\">\n                <fsw-field size=\"s\" [fullWidth]=\"true\">\n                  <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                    <label>\n                      {{ translate.bankAccountStmt.form_fields.from_date }}\n                      <span class=\"text-red-500\">*</span>\n                    </label>\n                  </ng-template>\n                  <fsw-date-picker\n                    formControlName=\"from_date\"\n                    [closeOnSelected]=\"true\"\n                    format=\"MMM-yyyy\"\n                  >\n                  </fsw-date-picker>\n                </fsw-field>\n              </div>\n              <div class=\"w-1/2\">\n                <fsw-field size=\"s\" [fullWidth]=\"true\">\n                  <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                    <label>\n                      {{ translate.bankAccountStmt.form_fields.to_date }}\n                      <span class=\"text-red-500\">*</span>\n                    </label>\n                  </ng-template>\n                  <fsw-date-picker\n                    formControlName=\"to_date\"\n                    [closeOnSelected]=\"true\"\n                    format=\"MMM-yyyy\"\n                  >\n                  </fsw-date-picker>\n                </fsw-field>\n              </div>\n            </div>\n\n            <div>\n              <fsw-checkbox formControlName=\"is_scanned\" [label]=\"'Is Scanned ?'\"></fsw-checkbox>\n            </div>\n          </section>\n        </main>\n      </ng-container>\n    </ng-template>\n  </fsw-modal>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DIALOG_DATA]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [STORE_TOKEN$6]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: i1$7.DialogRef }, { type: i2.FormBuilder }]; } });

const DECLARATIONS_EXPORTS$g = [FSWEditBankAccountModalComponent];
class FSWEditBankAccountModalModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWEditBankAccountModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWEditBankAccountModalModule, declarations: [FSWEditBankAccountModalComponent], imports: [CommonModule,
            ReactiveFormsModule,
            LetDirective,
            FSWFieldModule,
            FSWSelectModule,
            TranslocoModule,
            FSWModalModule$1,
            DialogModule,
            FSWUploadModule,
            FSWDateTimePickerModule,
            FSWCheckboxModule,
            NgSelectModule], exports: [FSWEditBankAccountModalComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWEditBankAccountModalModule, imports: [CommonModule,
            ReactiveFormsModule,
            FSWFieldModule,
            FSWSelectModule,
            TranslocoModule,
            FSWModalModule$1,
            DialogModule,
            FSWUploadModule,
            FSWDateTimePickerModule,
            FSWCheckboxModule,
            NgSelectModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWEditBankAccountModalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        LetDirective,
                        FSWFieldModule,
                        FSWSelectModule,
                        TranslocoModule,
                        FSWModalModule$1,
                        DialogModule,
                        FSWUploadModule,
                        FSWDateTimePickerModule,
                        FSWCheckboxModule,
                        NgSelectModule,
                    ],
                    declarations: DECLARATIONS_EXPORTS$g,
                    exports: DECLARATIONS_EXPORTS$g,
                }]
        }] });

const initFG$2 = (_fb) => {
    return _fb.group({
        reason: ['', [Validators.required]],
    });
};

class FSWResendToPerfiosModalComponent {
    get isButtonDisable() {
        return this.resendToPerfiosFG.invalid;
    }
    constructor(data, _componentStore, _scope, _translateService, _dialogRef, _fb) {
        this.data = data;
        this._componentStore = _componentStore;
        this._scope = _scope;
        this._translateService = _translateService;
        this._dialogRef = _dialogRef;
        this._fb = _fb;
        this._destroy$ = new Subject();
        this.modalSize = FSWModalSizes.M;
        this.errors = [];
        this.referenceData = {
            banks: [],
            bankAccountTypes: [],
            currencies: [],
            banksMap: {},
            exchangeRatesContent: null,
        };
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'bank_accounts_and_statements'),
            this._translateService.selectFeatureTranslate(this._scope, 'buttons'),
        ]).pipe(map$1(([bankAccountStmt, buttons]) => ({
            bankAccountStmt,
            buttons,
        })));
        this.resendToPerfiosFG = initFG$2(this._fb);
        this._componentStore.updateState({
            selectedBankAccountRow: this.data.singleRowData,
        });
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    onConfirm() {
        const payload = {
            reason: this.resendToPerfiosFG.value?.reason,
            status: INIT_STATUS,
        };
        this._componentStore.resendToPerfios({
            payload,
        });
        this._componentStore.state$
            .pipe(takeUntil$1(this._destroy$), map$1((state) => state.isResendToPerfiosComplete))
            .subscribe((isResendToPerfiosComplete) => {
            if (isResendToPerfiosComplete)
                this._dialogRef.close();
        });
    }
    onClose() {
        this._dialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWResendToPerfiosModalComponent, deps: [{ token: DIALOG_DATA }, { token: STORE_TOKEN$6 }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: i1$7.DialogRef }, { token: i2.FormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWResendToPerfiosModalComponent, selector: "fsw-resend-to-perfios", ngImport: i0, template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <fsw-modal\n    [title]=\"'Resend To Parser'\"\n    [confirmButton]=\"'Save'\"\n    [cancelButton]=\"translate.buttons.cancel\"\n    [size]=\"modalSize\"\n    [confirmButtonDisabled]=\"isButtonDisable\"\n    (closeEvent)=\"onClose()\"\n    (cancelEvent)=\"onClose()\"\n    (confirmEvent)=\"onConfirm()\"\n  >\n    <ng-template fswModalBody>\n      <ng-container [formGroup]=\"resendToPerfiosFG\">\n        <main class=\"w-full mt-2\">\n          <section>\n            <div class=\"mb-4\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template\n                  fswFieldHeaderPrefix\n                  [kind]=\"'default'\"\n                  [label]=\"'Reason*'\"\n                ></ng-template>\n                <textarea\n                  class=\"form-input\"\n                  fswInput\n                  formControlName=\"reason\"\n                  [placeholder]=\"'Please enter reason for resending to parser'\"\n                ></textarea>\n              </fsw-field>\n            </div>\n          </section>\n        </main>\n      </ng-container>\n    </ng-template>\n  </fsw-modal>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$4.FSWFieldHeaderPrefixDirective, selector: "ng-template[fswFieldHeaderPrefix]", inputs: ["kind", "label", "required"] }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWResendToPerfiosModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-resend-to-perfios', template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <fsw-modal\n    [title]=\"'Resend To Parser'\"\n    [confirmButton]=\"'Save'\"\n    [cancelButton]=\"translate.buttons.cancel\"\n    [size]=\"modalSize\"\n    [confirmButtonDisabled]=\"isButtonDisable\"\n    (closeEvent)=\"onClose()\"\n    (cancelEvent)=\"onClose()\"\n    (confirmEvent)=\"onConfirm()\"\n  >\n    <ng-template fswModalBody>\n      <ng-container [formGroup]=\"resendToPerfiosFG\">\n        <main class=\"w-full mt-2\">\n          <section>\n            <div class=\"mb-4\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template\n                  fswFieldHeaderPrefix\n                  [kind]=\"'default'\"\n                  [label]=\"'Reason*'\"\n                ></ng-template>\n                <textarea\n                  class=\"form-input\"\n                  fswInput\n                  formControlName=\"reason\"\n                  [placeholder]=\"'Please enter reason for resending to parser'\"\n                ></textarea>\n              </fsw-field>\n            </div>\n          </section>\n        </main>\n      </ng-container>\n    </ng-template>\n  </fsw-modal>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DIALOG_DATA]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [STORE_TOKEN$6]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: i1$7.DialogRef }, { type: i2.FormBuilder }]; } });

const DECLARATIONS_EXPORTS$f = [FSWResendToPerfiosModalComponent];
class FSWResendToPerfiosModalModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWResendToPerfiosModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWResendToPerfiosModalModule, declarations: [FSWResendToPerfiosModalComponent], imports: [CommonModule,
            ReactiveFormsModule,
            LetDirective,
            FSWFieldModule,
            FSWSelectModule,
            TranslocoModule,
            FSWModalModule$1,
            DialogModule,
            FSWUploadModule,
            FSWDateTimePickerModule,
            FSWCheckboxModule,
            NgSelectModule], exports: [FSWResendToPerfiosModalComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWResendToPerfiosModalModule, imports: [CommonModule,
            ReactiveFormsModule,
            FSWFieldModule,
            FSWSelectModule,
            TranslocoModule,
            FSWModalModule$1,
            DialogModule,
            FSWUploadModule,
            FSWDateTimePickerModule,
            FSWCheckboxModule,
            NgSelectModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWResendToPerfiosModalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        LetDirective,
                        FSWFieldModule,
                        FSWSelectModule,
                        TranslocoModule,
                        FSWModalModule$1,
                        DialogModule,
                        FSWUploadModule,
                        FSWDateTimePickerModule,
                        FSWCheckboxModule,
                        NgSelectModule,
                    ],
                    declarations: DECLARATIONS_EXPORTS$f,
                    exports: DECLARATIONS_EXPORTS$f,
                }]
        }] });

const createBankStatementPayload = (res) => {
    const bankStatements = [];
    const fileAnddocIds = res.map((r) => ({
        file_name: r.file.name,
        doc_id: r.doc_id,
    }));
    fileAnddocIds.forEach((fileAnddocId) => {
        const { file_name, doc_id } = fileAnddocId;
        bankStatements.push({
            file_name,
            doc_id,
        });
    });
    return bankStatements;
};

class FSWUploadBankStatementModalComponent {
    get isButtonDisable() {
        return !this.files.length;
    }
    constructor(data, _componentStore, _scope, _translateService, _dialogRef) {
        this.data = data;
        this._componentStore = _componentStore;
        this._scope = _scope;
        this._translateService = _translateService;
        this._dialogRef = _dialogRef;
        this._destroy$ = new Subject();
        this.modalSize = FSWModalSizes.S;
        this.errors = [];
        this.files = [];
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'bank_accounts_and_statements'),
            this._translateService.selectFeatureTranslate(this._scope, 'buttons'),
        ]).pipe(map(([bankAccountStmt, buttons]) => ({
            bankAccountStmt,
            buttons,
        })));
    }
    ngOnDestroy() {
        if (this._destroy$) {
            this._destroy$.next();
            this._destroy$.complete();
        }
    }
    uploadFile(data) {
        const errorMsg = 'Maximum 6 Bank statements can be uploaded for each bank account.';
        const errorMsgPdf = 'Only PDF files are allowed to be uploaded.';
        this.files = [...Array.from(data)];
        if (!this.files.length)
            return;
        const hasError = !!this.files.filter((f) => !['application/pdf'].includes(f.type)).length;
        if (hasError) {
            this.errors = [...this.errors, errorMsgPdf];
            this.files = [];
            return;
        }
        else {
            this.errors = this.errors.filter((err) => err !== errorMsgPdf);
        }
        if (this.files.length > 6) {
            this.errors = [...this.errors, errorMsg];
            this.files = [];
            return;
        }
        else {
            this.errors = this.errors.filter((err) => err !== errorMsg);
        }
    }
    onConfirm() {
        const obs = [];
        this.files.forEach((file) => {
            obs.push(this._componentStore.uploadDocToV3Async(file));
        });
        forkJoin([...obs])
            .pipe(takeUntil(this._destroy$))
            .subscribe((data) => {
            this._componentStore.uploadBankStatements({
                bankAccountId: this.data?.singleRowData?.account_id || '',
                payload: createBankStatementPayload(data),
            });
            this._dialogRef.close();
        });
    }
    onClose() {
        this._dialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWUploadBankStatementModalComponent, deps: [{ token: DIALOG_DATA }, { token: STORE_TOKEN$6 }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: i1$7.DialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWUploadBankStatementModalComponent, selector: "fsw-upload-bank-statement", ngImport: i0, template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <fsw-modal\n    [title]=\"translate.bankAccountStmt.buttons.upload_statements\"\n    [confirmButton]=\"translate.bankAccountStmt.buttons.upload_statements\"\n    [cancelButton]=\"translate.buttons.cancel\"\n    [size]=\"modalSize\"\n    [confirmButtonDisabled]=\"isButtonDisable\"\n    (closeEvent)=\"onClose()\"\n    (cancelEvent)=\"onClose()\"\n    (confirmEvent)=\"onConfirm()\"\n  >\n    <ng-template fswModalBody>\n      <ng-container>\n        <section *ngIf=\"errors?.length\" class=\"bg-red-100 text-red-500 p-2 h-auto\">\n          <div class=\"text-[12px] p-1\" *ngFor=\"let err of errors\">\n            {{ err }}\n          </div>\n        </section>\n\n        <main class=\"flex justify-between w-full mt-8\">\n          <section lass=\"max-w-[500px] m-auto\">\n            <div class=\"flex justify-between items-center gap-[4px]\">\n              <fsw-upload\n                [buttonUploadLabel]=\"translate.bankAccountStmt.buttons.upload_statements\"\n                (fileSelect)=\"uploadFile($event)\"\n              ></fsw-upload>\n            </div>\n\n            <div class=\"bg-gray-100 text-gray-700 text-[12px] p-2 mt-4\">\n              <div>{{ translate.bankAccountStmt.notes.note_1 }}</div>\n              <div>{{ translate.bankAccountStmt.notes.note_2 }}</div>\n            </div>\n\n            <div class=\"py-2 max-h-[190px] h-auto overflow-y-scroll\" *ngIf=\"files?.length\">\n              <div\n                class=\"bg-blue-100 text-[12px] text-blue-500 p-2 my-1\"\n                *ngFor=\"let file of files\"\n              >\n                <span>{{ file?.name }}</span>\n              </div>\n            </div>\n          </section>\n        </main>\n      </ng-container>\n    </ng-template>\n  </fsw-modal>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "component", type: FSWUploadComponent, selector: "fsw-upload", inputs: ["buttonUploadLabel", "isPrimaryButton"], outputs: ["fileSelect"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWUploadBankStatementModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-upload-bank-statement', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <fsw-modal\n    [title]=\"translate.bankAccountStmt.buttons.upload_statements\"\n    [confirmButton]=\"translate.bankAccountStmt.buttons.upload_statements\"\n    [cancelButton]=\"translate.buttons.cancel\"\n    [size]=\"modalSize\"\n    [confirmButtonDisabled]=\"isButtonDisable\"\n    (closeEvent)=\"onClose()\"\n    (cancelEvent)=\"onClose()\"\n    (confirmEvent)=\"onConfirm()\"\n  >\n    <ng-template fswModalBody>\n      <ng-container>\n        <section *ngIf=\"errors?.length\" class=\"bg-red-100 text-red-500 p-2 h-auto\">\n          <div class=\"text-[12px] p-1\" *ngFor=\"let err of errors\">\n            {{ err }}\n          </div>\n        </section>\n\n        <main class=\"flex justify-between w-full mt-8\">\n          <section lass=\"max-w-[500px] m-auto\">\n            <div class=\"flex justify-between items-center gap-[4px]\">\n              <fsw-upload\n                [buttonUploadLabel]=\"translate.bankAccountStmt.buttons.upload_statements\"\n                (fileSelect)=\"uploadFile($event)\"\n              ></fsw-upload>\n            </div>\n\n            <div class=\"bg-gray-100 text-gray-700 text-[12px] p-2 mt-4\">\n              <div>{{ translate.bankAccountStmt.notes.note_1 }}</div>\n              <div>{{ translate.bankAccountStmt.notes.note_2 }}</div>\n            </div>\n\n            <div class=\"py-2 max-h-[190px] h-auto overflow-y-scroll\" *ngIf=\"files?.length\">\n              <div\n                class=\"bg-blue-100 text-[12px] text-blue-500 p-2 my-1\"\n                *ngFor=\"let file of files\"\n              >\n                <span>{{ file?.name }}</span>\n              </div>\n            </div>\n          </section>\n        </main>\n      </ng-container>\n    </ng-template>\n  </fsw-modal>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DIALOG_DATA]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [STORE_TOKEN$6]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: i1$7.DialogRef }]; } });

const DECLARATIONS_EXPORTS$e = [FSWUploadBankStatementModalComponent];
class FSWUploadBankStatementModalModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWUploadBankStatementModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWUploadBankStatementModalModule, declarations: [FSWUploadBankStatementModalComponent], imports: [CommonModule,
            ReactiveFormsModule,
            LetDirective,
            FSWFieldModule,
            FSWSelectModule,
            TranslocoModule,
            FSWModalModule$1,
            DialogModule,
            FSWUploadModule,
            FSWDateTimePickerModule,
            FSWCheckboxModule], exports: [FSWUploadBankStatementModalComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWUploadBankStatementModalModule, imports: [CommonModule,
            ReactiveFormsModule,
            FSWFieldModule,
            FSWSelectModule,
            TranslocoModule,
            FSWModalModule$1,
            DialogModule,
            FSWUploadModule,
            FSWDateTimePickerModule,
            FSWCheckboxModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWUploadBankStatementModalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        LetDirective,
                        FSWFieldModule,
                        FSWSelectModule,
                        TranslocoModule,
                        FSWModalModule$1,
                        DialogModule,
                        FSWUploadModule,
                        FSWDateTimePickerModule,
                        FSWCheckboxModule,
                    ],
                    declarations: DECLARATIONS_EXPORTS$e,
                    exports: DECLARATIONS_EXPORTS$e,
                }]
        }] });

class FSWViewErrorBankAccountModalComponent {
    get isButtonDisable() {
        return !this.files.length;
    }
    constructor(data, _scope, _translateService, _dialogRef) {
        this.data = data;
        this._scope = _scope;
        this._translateService = _translateService;
        this._dialogRef = _dialogRef;
        this._destroy$ = new Subject();
        this.modalSize = FSWModalSizes.S;
        this.errors = [];
        this.files = [];
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'bank_accounts_and_statements'),
            this._translateService.selectFeatureTranslate(this._scope, 'buttons'),
        ]).pipe(map(([bankAccountStmt, buttons]) => ({
            bankAccountStmt,
            buttons,
        })));
    }
    ngOnDestroy() {
        if (this._destroy$) {
            this._destroy$.next();
            this._destroy$.complete();
        }
    }
    onConfirm() {
        this._dialogRef.close();
    }
    onClose() {
        this._dialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWViewErrorBankAccountModalComponent, deps: [{ token: DIALOG_DATA }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: i1$7.DialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWViewErrorBankAccountModalComponent, selector: "fsw-view-error-bank-account", ngImport: i0, template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <fsw-modal\n    [title]=\"'Error Message from parser'\"\n    [cancelButton]=\"translate.buttons.cancel\"\n    [size]=\"modalSize\"\n    [confirmButtonDisabled]=\"isButtonDisable\"\n    (closeEvent)=\"onClose()\"\n    (cancelEvent)=\"onClose()\"\n    (confirmEvent)=\"onConfirm()\"\n  >\n    <ng-template fswModalBody>\n      <ng-container>\n        <section\n          *ngIf=\"data?.singleRowData?.message as errorMessage\"\n          class=\"bg-red-100 text-red-500 p-2\"\n        >\n          <div class=\"text-[12px] p-1 break-words\">\n            {{ errorMessage }}\n          </div>\n        </section>\n      </ng-container>\n    </ng-template>\n  </fsw-modal>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWViewErrorBankAccountModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-view-error-bank-account', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <fsw-modal\n    [title]=\"'Error Message from parser'\"\n    [cancelButton]=\"translate.buttons.cancel\"\n    [size]=\"modalSize\"\n    [confirmButtonDisabled]=\"isButtonDisable\"\n    (closeEvent)=\"onClose()\"\n    (cancelEvent)=\"onClose()\"\n    (confirmEvent)=\"onConfirm()\"\n  >\n    <ng-template fswModalBody>\n      <ng-container>\n        <section\n          *ngIf=\"data?.singleRowData?.message as errorMessage\"\n          class=\"bg-red-100 text-red-500 p-2\"\n        >\n          <div class=\"text-[12px] p-1 break-words\">\n            {{ errorMessage }}\n          </div>\n        </section>\n      </ng-container>\n    </ng-template>\n  </fsw-modal>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DIALOG_DATA]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: i1$7.DialogRef }]; } });

const DECLARATIONS_EXPORTS$d = [FSWViewErrorBankAccountModalComponent];
class FSWViewErrorBankAccountModalModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWViewErrorBankAccountModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWViewErrorBankAccountModalModule, declarations: [FSWViewErrorBankAccountModalComponent], imports: [CommonModule, TranslocoModule, FSWModalModule$1, DialogModule], exports: [FSWViewErrorBankAccountModalComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWViewErrorBankAccountModalModule, imports: [CommonModule, TranslocoModule, FSWModalModule$1, DialogModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWViewErrorBankAccountModalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, TranslocoModule, FSWModalModule$1, DialogModule],
                    declarations: DECLARATIONS_EXPORTS$d,
                    exports: DECLARATIONS_EXPORTS$d,
                }]
        }] });

// @angular
class FSWBankAccountsAndStatementsComponent {
    set isReadonly(value) {
        this._isReadonly = value;
    }
    get isReadonly() {
        return this._isReadonly;
    }
    constructor(_componentStore, _translateService, _scope, _cdr, _cdkDialog, _injector) {
        this._componentStore = _componentStore;
        this._translateService = _translateService;
        this._scope = _scope;
        this._cdr = _cdr;
        this._cdkDialog = _cdkDialog;
        this._injector = _injector;
        this._isReadonly = true;
        this._destroySubject = new Subject();
        this.translate$ = this._translateService.selectFeatureTranslate(this._scope, 'bank_accounts_and_statements');
        this.dataSource = [];
        this.columnsToDisplay = [...Object.keys(BankAccountsAndStatementsColumnNames)];
        this.childColumnsToDisplay = [...Object.keys(BankAccountsAndStatementsChildColumnNames)];
        this.columnNames = BankAccountsAndStatementsColumnNames;
        this.childColumnNames = BankAccountsAndStatementsChildColumnNames;
        this.expandedStates = {};
        this.expandedElement = null;
        this.isLoading = true;
    }
    ngOnInit() {
        combineLatest([
            this.translate$,
            this._componentStore.state$.pipe(map((state) => state.bankAccounts), tap((_) => this._cdr.detectChanges()), catchError((err) => {
                console.error(err);
                throw new Error(err);
            })),
        ])
            .pipe(takeUntil(this._destroySubject), tap((_) => {
            const rowData = mapBankAccount(this._componentStore.state().bankAccounts || []);
            this.dataSource = rowData;
            this.isLoading = false;
            this._cdr.detectChanges();
        }))
            .subscribe();
    }
    ngOnDestroy() {
        if (this._destroySubject) {
            this._destroySubject.next();
            this._destroySubject.complete();
        }
    }
    openAddBankAccountModal() {
        this._cdkDialog
            .open(FSWAddBankAccountModalComponent, {
            // data,
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((res) => {
            if (!res)
                return;
        }))
            .subscribe();
    }
    openEditBankStatementModal(singleRowData) {
        const data = {
            singleRowData,
        };
        this._cdkDialog
            .open(FSWEditBankAccountModalComponent, {
            data,
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((res) => {
            if (!res)
                return;
        }))
            .subscribe();
    }
    openCloneBankStatementModal(singleRowData) {
        const data = {
            singleRowData,
        };
        this._cdkDialog
            .open(FSWCloneBankAccountModalComponent, {
            data,
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((res) => {
            if (!res)
                return;
        }))
            .subscribe();
    }
    openUploadBankStatementModal(singleRowData) {
        const data = {
            singleRowData,
        };
        this._cdkDialog
            .open(FSWUploadBankStatementModalComponent, {
            data,
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((res) => {
            if (!res)
                return;
        }))
            .subscribe();
    }
    openViewErrorModal(singleRowData) {
        const data = {
            singleRowData,
        };
        this._cdkDialog
            .open(FSWViewErrorBankAccountModalComponent, {
            data,
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((res) => {
            if (!res)
                return;
        }))
            .subscribe();
    }
    openConfirmModal(singleRowData) {
        const data = {
            singleRowData,
        };
        this._cdkDialog
            .open(FSWConfirmBankAccountModalComponent, {
            data,
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((res) => {
            if (!res)
                return;
        }))
            .subscribe();
    }
    openDeleteAccountModal(singleRowData) {
        const data = {
            singleRowData,
        };
        this._cdkDialog
            .open(FSWDeleteBankAccountModalComponent, {
            data,
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((res) => {
            if (!res)
                return;
        }))
            .subscribe();
    }
    openResendToPerfios(params) {
        // TODO
        const data = {
            singleRowData: params.data,
        };
        this._cdkDialog
            .open(FSWResendToPerfiosModalComponent, {
            data,
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((res) => {
            if (!res)
                return;
        }))
            .subscribe((_) => {
            this._componentStore.updateState({
                selectedBankAccountRow: null,
            });
        });
    }
    onUtilityCellDownload(params, downloadType) {
        // TODO
        if (downloadType === 'statement') {
            const { doc_id, file_name } = params.data;
            this._componentStore.download({
                id: doc_id,
                name: file_name,
            });
        }
        else {
            const { xlsx_report_doc_id, account_number, bank_name } = params.data;
            this._componentStore.download({
                id: xlsx_report_doc_id,
                name: `${account_number}-${bank_name}-${Date.now()}.xlsx`,
            });
        }
    }
    onUtilityCellSendToPerfios(params) {
        // TODO
        if (!params || !params.data)
            return;
        this._componentStore.sendBankAccountToPerfios({
            bankAccountId: params.data.account_id,
        });
    }
    onDetailRowDeleteDocument(params) {
        // TODO
        if (!params || !params?.data)
            return;
        this._componentStore.deleteBankStatement({
            bankAccountId: params?.data?.bank_account_id,
            bankStatementId: params?.data?.statement_id,
        });
    }
    onDeleteAccount(params) {
        // TODO
        if (!params || !params.data)
            return;
        this.openDeleteAccountModal(params?.data);
    }
    generateReport() {
        this._componentStore.processBankReports();
    }
    refreshStatus() {
        this._componentStore.refreshBankAccountParseStatus(true);
    }
    // Action Handlers
    onSendToPerfios(element) {
        if (this.isReadonly || element?.status === 'PROCESSING')
            return;
        if (element?.status === 'SUCCESS') {
            this.openResendToPerfios({
                data: element,
            }); // TODO
            return;
        }
        this.onUtilityCellSendToPerfios({
            data: element,
        }); // TODO
    }
    onViewError(element) {
        this.openViewErrorModal(element);
    }
    toggleExpandedState(rowId) {
        if (!rowId)
            return;
        // Reset all other expanded states when opening a new row
        if (!this.expandedStates[rowId]) {
            Object.keys(this.expandedStates).forEach((key) => {
                this.expandedStates[key] = false;
            });
        }
        this.expandedStates[rowId] = !this.expandedStates[rowId];
        this.expandedElement = this.expandedStates[rowId] ? rowId : null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBankAccountsAndStatementsComponent, deps: [{ token: STORE_TOKEN$6 }, { token: TranslocoFeatureHttpLoader }, { token: TRANSLOCO_SCOPE }, { token: i0.ChangeDetectorRef }, { token: i1$7.Dialog }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWBankAccountsAndStatementsComponent, selector: "fsw-bank-accounts-and-statements", inputs: { isReadonly: "isReadonly" }, ngImport: i0, template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <section class=\"flex justify-between m-5\">\n    <div></div>\n    <div class=\"flex items-center w-[480px] justify-between\">\n      <button\n        fswButton\n        appearance=\"secondary\"\n        class=\"cm-btn\"\n        [disabled]=\"isReadonly\"\n        [size]=\"'s'\"\n        (click)=\"refreshStatus()\"\n      >\n        <span>{{ 'Refresh' }}</span>\n      </button>\n      <button\n        fswButton\n        appearance=\"secondary\"\n        class=\"cm-btn\"\n        [disabled]=\"isReadonly\"\n        [size]=\"'s'\"\n        (click)=\"generateReport()\"\n      >\n        <span>{{ 'Generate Reports' }}</span>\n      </button>\n      <button\n        fswButton\n        appearance=\"secondary\"\n        class=\"cm-btn cm-btn--secondary\"\n        [disabled]=\"isReadonly\"\n        [size]=\"'s'\"\n        (click)=\"openAddBankAccountModal()\"\n      >\n        <i [fswIcon]=\"'common-add'\"></i>\n        <span>{{ translate?.buttons?.add_bank_account }}</span>\n      </button>\n    </div>\n  </section>\n</ng-container>\n\n<div class=\"m-5 cm-table animate-slide-up\">\n  <div class=\"mat-table-container\">\n    <div class=\"loading-container\" *ngIf=\"isLoading\">\n      <div class=\"spinner-container\">\n        <div class=\"spinner\"></div>\n      </div>\n    </div>\n\n    <table mat-table [dataSource]=\"dataSource\" multiTemplateDataRows>\n      <ng-container matColumnDef=\"{{ column }}\" *ngFor=\"let column of columnsToDisplay\">\n        <th mat-header-cell *matHeaderCellDef>{{ columnNames[column] }}</th>\n        <td mat-cell *matCellDef=\"let element\">\n          <ng-container [ngSwitch]=\"column\">\n            <ng-container *ngSwitchCase=\"'arrow'\">\n              <div class=\"w-12\">\n                <button\n                  fswButton\n                  [appearance]=\"'icon-no-bg'\"\n                  (click)=\"toggleExpandedState(element.account_id)\"\n                >\n                  <i\n                    [fswIcon]=\"'common-arrow-right'\"\n                    [class.rotate-90]=\"expandedStates[element?.account_id]\"\n                    class=\"transform duration-300\"\n                  ></i>\n                </button>\n              </div>\n            </ng-container>\n\n            <ng-container *ngSwitchCase=\"'status'\">\n              <span\n                class=\"p-3 text-[12px] font-semibold rounded\"\n                [ngClass]=\"{\n                  'bg-red-100 text-red-800': element['status'] === 'FAILURE',\n                  'bg-green-100 text-green-800': element['status'] === 'SUCCESS',\n                  'bg-yellow-100 text-yellow-800': element['status'] === 'PROCESSING',\n                  'bg-blue-100 text-blue-800': element['status'] === 'INIT'\n                }\"\n                >{{ element['status'] }}</span\n              >\n            </ng-container>\n            <ng-container *ngSwitchCase=\"'primary'\">\n              <div>\n                <div\n                  *ngIf=\"element?.primary\"\n                  class=\"p-3 text-[12px] font-semibold rounded flex items-center\"\n                  [ngClass]=\"{\n                  'bg-green-100 text-green-800': element['primary'],\n                }\"\n                >\n                  <span class=\"mr-2\">{{ 'Primary' }}</span>\n                  <span>\n                    <i\n                      [fswIcon]=\"'common-question-circle-outline'\"\n                      class=\"hover:cursor-pointer hover:text-blue-300\"\n                      [fontSize]=\"'12px'\"\n                      [cdkMenuTriggerFor]=\"tooltipTemplate\"\n                      #cdkMenuTrigger=\"cdkMenuTriggerFor\"\n                      (mouseenter)=\"cdkMenuTrigger.open()\"\n                      (mouseleave)=\"cdkMenuTrigger.close()\"\n                    ></i>\n                    <ng-template #tooltipTemplate>\n                      <span\n                        fswTooltip\n                        class=\"!text-red-900 w-[300px] !rounded-lg !bg-white shadow-small\"\n                        >{{\n                          'The primary bank account is determined based on a combination of account number, currency, and parser. This version will be included in subsequent processes like pre-screening, credit modeling, and risk assessment.'\n                        }}</span\n                      >\n                    </ng-template>\n                  </span>\n                </div>\n                <button\n                  *ngIf=\"!element?.primary\"\n                  fswButton\n                  [appearance]=\"'secondary'\"\n                  (click)=\"openConfirmModal(element)\"\n                >\n                  Set primary\n                </button>\n              </div>\n            </ng-container>\n            <ng-container *ngSwitchCase=\"'parent_action'\">\n              <div class=\"flex gap-4\">\n                <button\n                  fswButton\n                  [disabled]=\"!element?.can_reparse\"\n                  [appearance]=\"'secondary'\"\n                  (click)=\"onSendToPerfios(element)\"\n                >\n                  {{ element['status'] === 'SUCCESS' ? 'Resend' : 'Send' }}\n                </button>\n\n                <button\n                  *ngIf=\"element?.message\"\n                  fswButton\n                  [appearance]=\"'secondary'\"\n                  (click)=\"openViewErrorModal(element)\"\n                >\n                  View Error\n                </button>\n\n                <button\n                  fswButton\n                  [appearance]=\"'secondary'\"\n                  (click)=\"openCloneBankStatementModal(element)\"\n                >\n                  Select parser\n                </button>\n\n                <button\n                  fswButton\n                  [disabled]=\"isReadonly\"\n                  [appearance]=\"'icon-with-bg'\"\n                  [size]=\"'s'\"\n                  (click)=\"onDeleteAccount({ data: element })\"\n                >\n                  <i fswIcon=\"common-delete\" [fontSize]=\"'14px'\"></i>\n                </button>\n\n                <button\n                  fswButton\n                  [disabled]=\"\n                    isReadonly ||\n                    element['status'] === 'PROCESSING' ||\n                    element['status'] === 'SUCCESS'\n                  \"\n                  [appearance]=\"'icon-with-bg'\"\n                  (click)=\"openEditBankStatementModal(element)\"\n                >\n                  <i\n                    fswIcon=\"common-edit\"\n                    [fontSize]=\"'14px'\"\n                    [class.opacity-25]=\"\n                      isReadonly ||\n                      element['status'] === 'PROCESSING' ||\n                      element['status'] === 'SUCCESS'\n                    \"\n                    [class.cursor-not-allowed]=\"\n                      isReadonly ||\n                      element['status'] === 'PROCESSING' ||\n                      element['status'] === 'SUCCESS'\n                    \"\n                  ></i>\n                </button>\n\n                <button\n                  fswButton\n                  [disabled]=\"\n                    isReadonly ||\n                    element['status'] === 'PROCESSING' ||\n                    element['status'] === 'SUCCESS'\n                  \"\n                  [size]=\"'s'\"\n                  [appearance]=\"'icon-with-bg'\"\n                  (click)=\"openUploadBankStatementModal(element)\"\n                >\n                  <i\n                    fswIcon=\"common-upload\"\n                    [fontSize]=\"'14px'\"\n                    [class.opacity-25]=\"\n                      isReadonly ||\n                      element['status'] === 'PROCESSING' ||\n                      element['status'] === 'SUCCESS'\n                    \"\n                    [class.cursor-not-allowed]=\"\n                      isReadonly ||\n                      element['status'] === 'PROCESSING' ||\n                      element['status'] === 'SUCCESS'\n                    \"\n                  ></i>\n                </button>\n\n                <button\n                  fswButton\n                  [appearance]=\"'icon-with-bg'\"\n                  [size]=\"'s'\"\n                  (click)=\"onUtilityCellDownload({ data: element }, 'account')\"\n                >\n                  <i fswIcon=\"common-download\" [fontSize]=\"'14px'\"></i>\n                </button>\n\n                <div class=\"flex items-center\">\n                  <span class=\"px-2 py-1 bg-blue-100 text-blue-500 rounded text-sm\">\n                    {{ element.token_id.substring(0, 6) }}...\n                  </span>\n                  <fsw-clipboard [content]=\"element.token_id\"></fsw-clipboard>\n                </div>\n              </div>\n            </ng-container>\n            <ng-container *ngSwitchDefault>\n              <div class=\"p-2\">{{ element[column] }}</div>\n            </ng-container>\n          </ng-container>\n        </td>\n      </ng-container>\n\n      <tr mat-header-row *matHeaderRowDef=\"columnsToDisplay\"></tr>\n      <tr\n        mat-row\n        *matRowDef=\"let element; columns: columnsToDisplay\"\n        class=\"example-element-row\"\n        [class.example-expanded-row]=\"expandedElement === element?.account_id\"\n      ></tr>\n      <tr mat-row *matRowDef=\"let row; columns: ['expandedDetail']\" class=\"example-detail-row\"></tr>\n\n      <tr class=\"mat-row\" *matNoDataRow>\n        <td class=\"mat-cell\" [attr.colspan]=\"columnsToDisplay.length\">\n          <div class=\"empty-state\" *ngIf=\"!isLoading && dataSource.length === 0\">\n            <p>No bank accounts to display</p>\n          </div>\n        </td>\n      </tr>\n\n      <!-- Nested table -->\n      <ng-container matColumnDef=\"expandedDetail\">\n        <td mat-cell *matCellDef=\"let element\" [attr.colspan]=\"columnsToDisplay.length\">\n          <div\n            class=\"example-element-detail\"\n            [@detailExpand]=\"expandedElement === element?.account_id ? 'expanded' : 'collapsed'\"\n          >\n            <div class=\"nested-mat-table-container w-[600px]\">\n              <table mat-table [dataSource]=\"element?.statements\" class=\"mat-elevation-z8\">\n                <ng-container\n                  matColumnDef=\"{{ childColumn }}\"\n                  *ngFor=\"let childColumn of childColumnsToDisplay\"\n                >\n                  <th mat-header-cell *matHeaderCellDef>{{ childColumnNames[childColumn] }}</th>\n                  <td mat-cell *matCellDef=\"let childElement\">\n                    <ng-container [ngSwitch]=\"childColumn\">\n                      <ng-container *ngSwitchCase=\"'file_name'\">\n                        <div\n                          class=\"break-words text-sm px-2 py-1 bg-blue-100 text-blue-500 rounded\"\n                        >\n                          {{ childElement.file_name }}\n                        </div>\n                      </ng-container>\n                      <ng-container *ngSwitchCase=\"'child_action'\">\n                        <div class=\"flex gap-4\">\n                          <button\n                            fswButton\n                            [disabled]=\"isReadonly\"\n                            [appearance]=\"'icon-with-bg'\"\n                            [size]=\"'s'\"\n                            (click)=\"onDetailRowDeleteDocument({ data: childElement })\"\n                          >\n                            <i [fswIcon]=\"'common-delete'\" [fontSize]=\"'14px'\"></i>\n                          </button>\n                          <button\n                            fswButton\n                            [appearance]=\"'icon-with-bg'\"\n                            [size]=\"'s'\"\n                            (click)=\"onUtilityCellDownload({ data: childElement }, 'statement')\"\n                          >\n                            <i [fswIcon]=\"'common-download'\" [fontSize]=\"'14px'\"></i>\n                          </button>\n                        </div>\n                      </ng-container>\n                      <ng-container *ngSwitchDefault>\n                        {{ childElement[childColumn] }}\n                      </ng-container>\n                    </ng-container>\n                  </td>\n                </ng-container>\n\n                <tr mat-header-row *matHeaderRowDef=\"childColumnsToDisplay\"></tr>\n                <tr mat-row *matRowDef=\"let row; columns: childColumnsToDisplay\"></tr>\n              </table>\n            </div>\n          </div>\n        </td>\n      </ng-container>\n    </table>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "component", type: i5.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { kind: "directive", type: i5.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { kind: "directive", type: i5.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { kind: "directive", type: i5.MatColumnDef, selector: "[matColumnDef]", inputs: ["sticky", "matColumnDef"] }, { kind: "directive", type: i5.MatCellDef, selector: "[matCellDef]" }, { kind: "directive", type: i5.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }, { kind: "directive", type: i5.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { kind: "directive", type: i5.MatCell, selector: "mat-cell, td[mat-cell]" }, { kind: "component", type: i5.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { kind: "component", type: i5.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }, { kind: "directive", type: i5.MatNoDataRow, selector: "ng-template[matNoDataRow]" }, { kind: "directive", type: i1$4.FSWTooltipDirective, selector: "[fswTooltip]" }, { kind: "directive", type: i6.CdkMenuTrigger, selector: "[cdkMenuTriggerFor]", inputs: ["cdkMenuTriggerFor", "cdkMenuPosition", "cdkMenuTriggerData"], outputs: ["cdkMenuOpened", "cdkMenuClosed"], exportAs: ["cdkMenuTriggerFor"] }, { kind: "component", type: FSWClipboardComponent, selector: "fsw-clipboard", inputs: ["content"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], animations: [
            trigger('detailExpand', [
                state('collapsed', style({ height: '0px', minHeight: '0' })),
                state('expanded', style({ height: '*' })),
                transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
            ]),
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBankAccountsAndStatementsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-bank-accounts-and-statements', animations: [
                        trigger('detailExpand', [
                            state('collapsed', style({ height: '0px', minHeight: '0' })),
                            state('expanded', style({ height: '*' })),
                            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
                        ]),
                    ], template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <section class=\"flex justify-between m-5\">\n    <div></div>\n    <div class=\"flex items-center w-[480px] justify-between\">\n      <button\n        fswButton\n        appearance=\"secondary\"\n        class=\"cm-btn\"\n        [disabled]=\"isReadonly\"\n        [size]=\"'s'\"\n        (click)=\"refreshStatus()\"\n      >\n        <span>{{ 'Refresh' }}</span>\n      </button>\n      <button\n        fswButton\n        appearance=\"secondary\"\n        class=\"cm-btn\"\n        [disabled]=\"isReadonly\"\n        [size]=\"'s'\"\n        (click)=\"generateReport()\"\n      >\n        <span>{{ 'Generate Reports' }}</span>\n      </button>\n      <button\n        fswButton\n        appearance=\"secondary\"\n        class=\"cm-btn cm-btn--secondary\"\n        [disabled]=\"isReadonly\"\n        [size]=\"'s'\"\n        (click)=\"openAddBankAccountModal()\"\n      >\n        <i [fswIcon]=\"'common-add'\"></i>\n        <span>{{ translate?.buttons?.add_bank_account }}</span>\n      </button>\n    </div>\n  </section>\n</ng-container>\n\n<div class=\"m-5 cm-table animate-slide-up\">\n  <div class=\"mat-table-container\">\n    <div class=\"loading-container\" *ngIf=\"isLoading\">\n      <div class=\"spinner-container\">\n        <div class=\"spinner\"></div>\n      </div>\n    </div>\n\n    <table mat-table [dataSource]=\"dataSource\" multiTemplateDataRows>\n      <ng-container matColumnDef=\"{{ column }}\" *ngFor=\"let column of columnsToDisplay\">\n        <th mat-header-cell *matHeaderCellDef>{{ columnNames[column] }}</th>\n        <td mat-cell *matCellDef=\"let element\">\n          <ng-container [ngSwitch]=\"column\">\n            <ng-container *ngSwitchCase=\"'arrow'\">\n              <div class=\"w-12\">\n                <button\n                  fswButton\n                  [appearance]=\"'icon-no-bg'\"\n                  (click)=\"toggleExpandedState(element.account_id)\"\n                >\n                  <i\n                    [fswIcon]=\"'common-arrow-right'\"\n                    [class.rotate-90]=\"expandedStates[element?.account_id]\"\n                    class=\"transform duration-300\"\n                  ></i>\n                </button>\n              </div>\n            </ng-container>\n\n            <ng-container *ngSwitchCase=\"'status'\">\n              <span\n                class=\"p-3 text-[12px] font-semibold rounded\"\n                [ngClass]=\"{\n                  'bg-red-100 text-red-800': element['status'] === 'FAILURE',\n                  'bg-green-100 text-green-800': element['status'] === 'SUCCESS',\n                  'bg-yellow-100 text-yellow-800': element['status'] === 'PROCESSING',\n                  'bg-blue-100 text-blue-800': element['status'] === 'INIT'\n                }\"\n                >{{ element['status'] }}</span\n              >\n            </ng-container>\n            <ng-container *ngSwitchCase=\"'primary'\">\n              <div>\n                <div\n                  *ngIf=\"element?.primary\"\n                  class=\"p-3 text-[12px] font-semibold rounded flex items-center\"\n                  [ngClass]=\"{\n                  'bg-green-100 text-green-800': element['primary'],\n                }\"\n                >\n                  <span class=\"mr-2\">{{ 'Primary' }}</span>\n                  <span>\n                    <i\n                      [fswIcon]=\"'common-question-circle-outline'\"\n                      class=\"hover:cursor-pointer hover:text-blue-300\"\n                      [fontSize]=\"'12px'\"\n                      [cdkMenuTriggerFor]=\"tooltipTemplate\"\n                      #cdkMenuTrigger=\"cdkMenuTriggerFor\"\n                      (mouseenter)=\"cdkMenuTrigger.open()\"\n                      (mouseleave)=\"cdkMenuTrigger.close()\"\n                    ></i>\n                    <ng-template #tooltipTemplate>\n                      <span\n                        fswTooltip\n                        class=\"!text-red-900 w-[300px] !rounded-lg !bg-white shadow-small\"\n                        >{{\n                          'The primary bank account is determined based on a combination of account number, currency, and parser. This version will be included in subsequent processes like pre-screening, credit modeling, and risk assessment.'\n                        }}</span\n                      >\n                    </ng-template>\n                  </span>\n                </div>\n                <button\n                  *ngIf=\"!element?.primary\"\n                  fswButton\n                  [appearance]=\"'secondary'\"\n                  (click)=\"openConfirmModal(element)\"\n                >\n                  Set primary\n                </button>\n              </div>\n            </ng-container>\n            <ng-container *ngSwitchCase=\"'parent_action'\">\n              <div class=\"flex gap-4\">\n                <button\n                  fswButton\n                  [disabled]=\"!element?.can_reparse\"\n                  [appearance]=\"'secondary'\"\n                  (click)=\"onSendToPerfios(element)\"\n                >\n                  {{ element['status'] === 'SUCCESS' ? 'Resend' : 'Send' }}\n                </button>\n\n                <button\n                  *ngIf=\"element?.message\"\n                  fswButton\n                  [appearance]=\"'secondary'\"\n                  (click)=\"openViewErrorModal(element)\"\n                >\n                  View Error\n                </button>\n\n                <button\n                  fswButton\n                  [appearance]=\"'secondary'\"\n                  (click)=\"openCloneBankStatementModal(element)\"\n                >\n                  Select parser\n                </button>\n\n                <button\n                  fswButton\n                  [disabled]=\"isReadonly\"\n                  [appearance]=\"'icon-with-bg'\"\n                  [size]=\"'s'\"\n                  (click)=\"onDeleteAccount({ data: element })\"\n                >\n                  <i fswIcon=\"common-delete\" [fontSize]=\"'14px'\"></i>\n                </button>\n\n                <button\n                  fswButton\n                  [disabled]=\"\n                    isReadonly ||\n                    element['status'] === 'PROCESSING' ||\n                    element['status'] === 'SUCCESS'\n                  \"\n                  [appearance]=\"'icon-with-bg'\"\n                  (click)=\"openEditBankStatementModal(element)\"\n                >\n                  <i\n                    fswIcon=\"common-edit\"\n                    [fontSize]=\"'14px'\"\n                    [class.opacity-25]=\"\n                      isReadonly ||\n                      element['status'] === 'PROCESSING' ||\n                      element['status'] === 'SUCCESS'\n                    \"\n                    [class.cursor-not-allowed]=\"\n                      isReadonly ||\n                      element['status'] === 'PROCESSING' ||\n                      element['status'] === 'SUCCESS'\n                    \"\n                  ></i>\n                </button>\n\n                <button\n                  fswButton\n                  [disabled]=\"\n                    isReadonly ||\n                    element['status'] === 'PROCESSING' ||\n                    element['status'] === 'SUCCESS'\n                  \"\n                  [size]=\"'s'\"\n                  [appearance]=\"'icon-with-bg'\"\n                  (click)=\"openUploadBankStatementModal(element)\"\n                >\n                  <i\n                    fswIcon=\"common-upload\"\n                    [fontSize]=\"'14px'\"\n                    [class.opacity-25]=\"\n                      isReadonly ||\n                      element['status'] === 'PROCESSING' ||\n                      element['status'] === 'SUCCESS'\n                    \"\n                    [class.cursor-not-allowed]=\"\n                      isReadonly ||\n                      element['status'] === 'PROCESSING' ||\n                      element['status'] === 'SUCCESS'\n                    \"\n                  ></i>\n                </button>\n\n                <button\n                  fswButton\n                  [appearance]=\"'icon-with-bg'\"\n                  [size]=\"'s'\"\n                  (click)=\"onUtilityCellDownload({ data: element }, 'account')\"\n                >\n                  <i fswIcon=\"common-download\" [fontSize]=\"'14px'\"></i>\n                </button>\n\n                <div class=\"flex items-center\">\n                  <span class=\"px-2 py-1 bg-blue-100 text-blue-500 rounded text-sm\">\n                    {{ element.token_id.substring(0, 6) }}...\n                  </span>\n                  <fsw-clipboard [content]=\"element.token_id\"></fsw-clipboard>\n                </div>\n              </div>\n            </ng-container>\n            <ng-container *ngSwitchDefault>\n              <div class=\"p-2\">{{ element[column] }}</div>\n            </ng-container>\n          </ng-container>\n        </td>\n      </ng-container>\n\n      <tr mat-header-row *matHeaderRowDef=\"columnsToDisplay\"></tr>\n      <tr\n        mat-row\n        *matRowDef=\"let element; columns: columnsToDisplay\"\n        class=\"example-element-row\"\n        [class.example-expanded-row]=\"expandedElement === element?.account_id\"\n      ></tr>\n      <tr mat-row *matRowDef=\"let row; columns: ['expandedDetail']\" class=\"example-detail-row\"></tr>\n\n      <tr class=\"mat-row\" *matNoDataRow>\n        <td class=\"mat-cell\" [attr.colspan]=\"columnsToDisplay.length\">\n          <div class=\"empty-state\" *ngIf=\"!isLoading && dataSource.length === 0\">\n            <p>No bank accounts to display</p>\n          </div>\n        </td>\n      </tr>\n\n      <!-- Nested table -->\n      <ng-container matColumnDef=\"expandedDetail\">\n        <td mat-cell *matCellDef=\"let element\" [attr.colspan]=\"columnsToDisplay.length\">\n          <div\n            class=\"example-element-detail\"\n            [@detailExpand]=\"expandedElement === element?.account_id ? 'expanded' : 'collapsed'\"\n          >\n            <div class=\"nested-mat-table-container w-[600px]\">\n              <table mat-table [dataSource]=\"element?.statements\" class=\"mat-elevation-z8\">\n                <ng-container\n                  matColumnDef=\"{{ childColumn }}\"\n                  *ngFor=\"let childColumn of childColumnsToDisplay\"\n                >\n                  <th mat-header-cell *matHeaderCellDef>{{ childColumnNames[childColumn] }}</th>\n                  <td mat-cell *matCellDef=\"let childElement\">\n                    <ng-container [ngSwitch]=\"childColumn\">\n                      <ng-container *ngSwitchCase=\"'file_name'\">\n                        <div\n                          class=\"break-words text-sm px-2 py-1 bg-blue-100 text-blue-500 rounded\"\n                        >\n                          {{ childElement.file_name }}\n                        </div>\n                      </ng-container>\n                      <ng-container *ngSwitchCase=\"'child_action'\">\n                        <div class=\"flex gap-4\">\n                          <button\n                            fswButton\n                            [disabled]=\"isReadonly\"\n                            [appearance]=\"'icon-with-bg'\"\n                            [size]=\"'s'\"\n                            (click)=\"onDetailRowDeleteDocument({ data: childElement })\"\n                          >\n                            <i [fswIcon]=\"'common-delete'\" [fontSize]=\"'14px'\"></i>\n                          </button>\n                          <button\n                            fswButton\n                            [appearance]=\"'icon-with-bg'\"\n                            [size]=\"'s'\"\n                            (click)=\"onUtilityCellDownload({ data: childElement }, 'statement')\"\n                          >\n                            <i [fswIcon]=\"'common-download'\" [fontSize]=\"'14px'\"></i>\n                          </button>\n                        </div>\n                      </ng-container>\n                      <ng-container *ngSwitchDefault>\n                        {{ childElement[childColumn] }}\n                      </ng-container>\n                    </ng-container>\n                  </td>\n                </ng-container>\n\n                <tr mat-header-row *matHeaderRowDef=\"childColumnsToDisplay\"></tr>\n                <tr mat-row *matRowDef=\"let row; columns: childColumnsToDisplay\"></tr>\n              </table>\n            </div>\n          </div>\n        </td>\n      </ng-container>\n    </table>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [STORE_TOKEN$6]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: i0.ChangeDetectorRef }, { type: i1$7.Dialog }, { type: i0.Injector }]; }, propDecorators: { isReadonly: [{
                type: Input
            }] } });

const initFG$1 = (_fb) => {
    return _fb.group({
        account_number: [''],
        overdraft_limit: [''],
        is_included: [false],
    });
};
const formatDateToMMYY = (input) => {
    // Split the input string into parts
    const [month, year] = input.split('-');
    // Create an array of month names
    const monthNames = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ];
    // Get the abbreviated month name based on the month part
    const abbreviatedMonth = monthNames[parseInt(month, 10) - 1];
    // Get the last two digits of the year part
    const abbreviatedYear = year.slice(-2);
    // Create the formatted date string
    const formattedDate = `${abbreviatedMonth}-${abbreviatedYear}`;
    return formattedDate;
};
const parseDateString = (dateString) => {
    // Split the input string into parts
    const [monthAbbrev, yearStr] = dateString.split('-');
    const monthAbbreviations = {
        Jan: 1,
        Feb: 2,
        Mar: 3,
        Apr: 4,
        May: 5,
        Jun: 6,
        Jul: 7,
        Aug: 8,
        Sep: 9,
        Oct: 10,
        Nov: 11,
        Dec: 12,
    };
    // Use the mapping to get the numeric month value
    const month = monthAbbreviations[monthAbbrev];
    // Parse the year as an integer
    let year = parseInt(yearStr, 10);
    const currentYear = new Date().getFullYear();
    if (year < 100) {
        if (year <= currentYear % 100) {
            year += Math.floor(currentYear / 100) * 100;
        }
        else {
            year += (Math.floor(currentYear / 100) - 1) * 100;
        }
    }
    // Create an object with the month and year attributes
    const parsedDate = {
        month,
        year, // Parse the year as an integer
    };
    return parsedDate;
};
const createPayload = (event, currentBankAnalysisReportData, tabulationDetailFG, isOverdraftLimitDisabled) => {
    const formData = event
        .filter((res) => res.month !== 'Total' && res.month !== 'Average')
        .map((res) => ({
        monthYr: res.month,
        month: parseDateString(res.month).month,
        year: parseDateString(res.month).year,
        open_balance: currentBankAnalysisReportData?.analysis_report?.monthly_analysis[res?.month].open_balance,
        closing_balance: res.closing_balance,
        total_credit: res.total_credit,
        cheque_deposit: currentBankAnalysisReportData?.analysis_report?.monthly_analysis[res?.month].cheque_deposit,
        cash_deposit: currentBankAnalysisReportData?.analysis_report?.monthly_analysis[res?.month].cash_deposit,
        card_deposit: currentBankAnalysisReportData?.analysis_report?.monthly_analysis[res?.month].card_deposit,
        total_debit: res.total_debit,
        cheque_issue: currentBankAnalysisReportData?.analysis_report?.monthly_analysis[res?.month].cheque_issue,
        cash_withdrawal: currentBankAnalysisReportData?.analysis_report?.monthly_analysis[res?.month]
            .cash_withdrawal,
        card_debit: currentBankAnalysisReportData?.analysis_report?.monthly_analysis[res?.month].card_debit,
        no_credit_transaction: currentBankAnalysisReportData?.analysis_report?.monthly_analysis[res?.month]
            .no_credit_transaction,
        percent_swing_of_mom_deposit: currentBankAnalysisReportData?.analysis_report?.monthly_analysis[res?.month]
            .percent_swing_of_mom_deposit,
        average_eod_balance: res.average_eod_balance,
        non_biz_income: res.non_biz_income,
    }));
    const formDataMap = formData.reduce((acc, curr) => {
        acc[curr.monthYr] = curr;
        delete acc[curr.monthYr].monthYr;
        return acc;
    }, {});
    if (isOverdraftLimitDisabled) {
        return {
            is_included: tabulationDetailFG.get('is_included')?.value,
            analysis_report: {
                monthly_analysis: formDataMap,
            },
        };
    }
    return {
        overdraft_limit: tabulationDetailFG.get('overdraft_limit')?.value,
        is_included: tabulationDetailFG.get('is_included')?.value,
        analysis_report: {
            monthly_analysis: formDataMap,
        },
    };
};
const createAnalysisReportsPayload = (inputData) => {
    // Create the analysis report payload
    const analysisReport = {
        monthly_analysis: {},
    };
    // Helper function to parse month and year from string
    const parseMonthYear = (monthStr) => {
        if (monthStr === 'Total' || monthStr === 'Average') {
            return { month: 0, year: 0 };
        }
        const [monthAbbr, yearStr] = monthStr.split('-');
        // Map month abbreviations
        const monthMap = {
            Jan: 1,
            Feb: 2,
            Mar: 3,
            Apr: 4,
            May: 5,
            Jun: 6,
            Jul: 7,
            Aug: 8,
            Sep: 9,
            Oct: 10,
            Nov: 11,
            Dec: 12,
        };
        return {
            month: monthMap[monthAbbr],
            year: 2000 + parseInt(yearStr),
        };
    };
    // Process each input data entry
    inputData.forEach((entry) => {
        // Skip 'Total' and 'Average' entries for monthly analysis
        if (entry.month === 'Total' || entry.month === 'Average') {
            return;
        }
        const { month, year } = parseMonthYear(entry.month);
        // Create monthly analysis entry
        const monthlyAnalysis = {
            month,
            year,
            open_balance: 0,
            closing_balance: entry.closing_balance,
            total_credit: entry.adjusted_deposits,
            cheque_deposit: 0,
            cash_deposit: 0,
            card_deposit: 0,
            total_debit: entry.total_debit,
            cheque_issue: 0,
            cash_withdrawal: 0,
            card_debit: 0,
            no_credit_transaction: 0,
            percent_swing_of_mom_deposit: 0,
            average_eod_balance: entry.average_eod_balance,
            non_biz_income: entry.non_biz_income,
        };
        // Add to monthly analysis
        analysisReport.monthly_analysis[entry.month] = monthlyAnalysis;
    });
    return { analysis_report: analysisReport };
};

const initTableCreation = (value, bankTabulationFormArray, dataSource$, _fb, _destroy$, additionalDataSource) => {
    const dataSource = [];
    if (!value.monthly_analysis)
        return;
    if (value?.monthly_analysis) {
        populateDataSource(value, dataSource, additionalDataSource);
        dataSource$.next([...dataSource]);
    }
    initDataSource(dataSource$, _fb, bankTabulationFormArray, _destroy$);
};
const initDataSource = (dataSource$, _fb, bankTabulationFormArray, _destroy$) => {
    const totalRow = initTotalRow();
    calcDataSource(dataSource$, totalRow, _fb, bankTabulationFormArray, _destroy$);
    addAvgRowToDataSource(bankTabulationFormArray, totalRow, dataSource$);
};
const populateDataSource = (value, dataSource, additionalDataSource) => {
    if (!value?.monthly_analysis)
        return;
    const sortedData = (Object.values(value.monthly_analysis) || []).sort((a, b) => {
        if (a.year !== b.year) {
            return a.year - b.year; // Sort by year first, in asc order
        }
        else {
            return a.month - b.month; // If years are the same, sort by month, in asc order
        }
    });
    sortedData?.forEach((val) => {
        dataSource.push({
            month: formatDateToMMYY(`${val.month}-${val.year}`),
            perc_change: null,
            total_credit: val.total_credit,
            total_debit: val.total_debit,
            closing_balance: val.closing_balance,
            average_eod_balance: val.average_eod_balance,
            non_biz_income: val.non_biz_income,
            adjusted_deposits: 0,
        });
    });
    dataSource.push(...additionalDataSource);
};
const initTotalRow = () => ({
    month: 'Total',
    perc_change: null,
    total_credit: 0,
    total_debit: 0,
    closing_balance: 0,
    average_eod_balance: 0,
    non_biz_income: 0,
    adjusted_deposits: 0,
});
const initModData = (val, prevVal) => ({
    month: val.month,
    perc_change: prevVal && prevVal.total_credit > 0
        ? +(((val.total_credit - prevVal.total_credit) / prevVal.total_credit) * 100).toFixed(2)
        : null,
    total_credit: val.total_credit,
    total_debit: val.total_debit,
    closing_balance: val.closing_balance,
    average_eod_balance: val.average_eod_balance,
    non_biz_income: val.non_biz_income,
    adjusted_deposits: val.total_credit - val.non_biz_income,
});
const initTotalFG = (_fb, totalRow) => {
    return _fb.group({
        month: [totalRow.month],
        perc_change: null,
        total_credit: [totalRow.total_credit],
        total_debit: [totalRow.total_debit],
        closing_balance: [totalRow.closing_balance],
        average_eod_balance: [totalRow.average_eod_balance],
        non_biz_income: [totalRow.non_biz_income],
        adjusted_deposits: [totalRow.adjusted_deposits],
    });
};
const initAverageFG = (_fb) => {
    return _fb.group({
        month: 'Average',
        perc_change: null,
        total_credit: null,
        total_debit: null,
        closing_balance: null,
        average_eod_balance: null,
        non_biz_income: null,
        adjusted_deposits: null,
    });
};
const initModDataFG = (_fb, totalRow, modData) => {
    totalRow.total_credit += modData.total_credit;
    totalRow.total_debit += modData.total_debit;
    totalRow.closing_balance += modData.closing_balance;
    totalRow.average_eod_balance += modData.average_eod_balance;
    totalRow.non_biz_income += modData.non_biz_income;
    totalRow.adjusted_deposits += modData.adjusted_deposits;
    return _fb.group({
        month: [modData.month],
        perc_change: [modData.perc_change],
        total_credit: [modData.total_credit],
        total_debit: [modData.total_debit],
        closing_balance: [modData.closing_balance],
        average_eod_balance: [modData.average_eod_balance],
        non_biz_income: [modData.non_biz_income],
        adjusted_deposits: [modData.adjusted_deposits],
    });
};
const onFormValueChange = (value, bankTabulationFormArray, dataSource$) => {
    const currentCtrl = bankTabulationFormArray.controls.find((control) => control.value.month === value.month);
    const currentCtrlIndex = bankTabulationFormArray.controls.findIndex((control) => control.value.month === value.month);
    const prevCtrl = currentCtrlIndex > 0
        ? bankTabulationFormArray.controls[currentCtrlIndex - 1]
        : null;
    const nextCtrl = bankTabulationFormArray.controls[currentCtrlIndex + 1];
    let modValue = {
        month: value.month,
        perc_change: nextCtrl.value.total_credit > 0 &&
            value.total_credit !== null &&
            value.total_credit !== undefined
            ? +(((nextCtrl?.value.total_credit - value.total_credit) / value.total_credit) *
                100).toFixed(2)
            : null,
        total_credit: value?.total_credit,
        total_debit: value?.total_debit,
        closing_balance: value?.closing_balance,
        average_eod_balance: value?.average_eod_balance,
        non_biz_income: value?.non_biz_income,
        adjusted_deposits: value.total_credit !== null &&
            value.non_biz_income !== null &&
            value.total_credit !== undefined &&
            value.non_biz_income !== undefined
            ? value.total_credit - value.non_biz_income
            : null,
    };
    if (currentCtrlIndex === 0) {
        modValue = { ...modValue, perc_change: null };
    }
    if (currentCtrlIndex > 0) {
        modValue = {
            ...modValue,
            perc_change: prevCtrl?.value?.total_credit > 0
                ? +(((currentCtrl?.value?.total_credit - prevCtrl?.value?.total_credit) /
                    prevCtrl?.value?.total_credit) *
                    100).toFixed(2)
                : null,
        };
    }
    nextCtrl?.patchValue({
        perc_change: currentCtrl?.value?.total_credit > 0
            ? +(((nextCtrl?.value?.total_credit - currentCtrl?.value?.total_credit) /
                currentCtrl?.value?.total_credit) *
                100).toFixed(2)
            : null,
    }, { emitEvent: false });
    currentCtrl?.patchValue(modValue, { emitEvent: false });
    const totalCtrl = bankTabulationFormArray.controls.find((control) => control?.value?.month === 'Total');
    const newTotalRow = {
        month: 'Total',
        perc_change: null,
        total_credit: 0,
        total_debit: 0,
        closing_balance: 0,
        average_eod_balance: 0,
        non_biz_income: 0,
        adjusted_deposits: 0,
    };
    let tempData = bankTabulationFormArray.value;
    tempData = tempData.filter((item) => item?.month !== value?.month && item?.month !== 'Total' && item?.month !== 'Average');
    tempData = [...tempData, value];
    for (const row of tempData) {
        if (row.month !== 'Total' && row.month !== 'Average') {
            newTotalRow.total_credit += row?.total_credit;
            newTotalRow.total_debit += row?.total_debit;
            newTotalRow.closing_balance += row?.closing_balance;
            newTotalRow.average_eod_balance += row?.average_eod_balance;
            newTotalRow.non_biz_income += row?.non_biz_income;
            newTotalRow.adjusted_deposits += row?.adjusted_deposits;
        }
    }
    const newAvgRow = calcAverageRow(newTotalRow, dataSource$);
    totalCtrl.patchValue(newTotalRow, { emitEvent: false });
    const averageCtrl = bankTabulationFormArray.controls.find((control) => control.value.month === 'Average');
    averageCtrl?.patchValue(newAvgRow, { emitEvent: false });
    return {
        dataSource$,
        bankTabulationFormArray,
    };
};
const calcDataSource = (dataSource$, totalRow, _fb, bankTabulationFormArray, _destroy$) => {
    dataSource$.value.forEach((val) => {
        const nextIndex = dataSource$.value.findIndex((item) => item.month === val.month) + 1;
        const prevVal = dataSource$.value[nextIndex - 2];
        let modData = initModData(val, prevVal);
        if (nextIndex === 1) {
            modData = { ...modData, perc_change: null };
        }
        if (modData.month === 'Total') {
            bankTabulationFormArray.push(initTotalFG(_fb, totalRow));
        }
        else if (modData.month === 'Average') {
            bankTabulationFormArray.push(initAverageFG(_fb));
        }
        else {
            const formGroup = initModDataFG(_fb, totalRow, modData);
            bankTabulationFormArray.push(formGroup);
            formGroup.valueChanges.pipe(takeUntil(_destroy$)).subscribe((value) => {
                const data = onFormValueChange(value, bankTabulationFormArray, dataSource$);
                dataSource$ = data.dataSource$;
                bankTabulationFormArray = data.bankTabulationFormArray;
            });
        }
    });
};
const addAvgRowToDataSource = (bankTabulationFormArray, totalRow, dataSource$) => {
    const averageCtrl = bankTabulationFormArray.controls.find((control) => control.value.month === 'Average');
    const avgRow = calcAverageRow(totalRow, dataSource$);
    averageCtrl?.patchValue(avgRow, { emitEvent: false });
    dataSource$.next([...bankTabulationFormArray.value]);
};
const calcAverageRow = (newTotalRow, dataSource$) => ({
    month: 'Average',
    perc_change: null,
    total_credit: +(newTotalRow?.total_credit / (dataSource$.value.length - 2)).toFixed(2),
    total_debit: +(newTotalRow?.total_debit / (dataSource$.value.length - 2)).toFixed(2),
    closing_balance: +(newTotalRow?.closing_balance / (dataSource$.value.length - 2)).toFixed(2),
    average_eod_balance: +(newTotalRow?.average_eod_balance / (dataSource$.value.length - 2)).toFixed(2),
    non_biz_income: +(newTotalRow?.non_biz_income / (dataSource$.value.length - 2)).toFixed(2),
    adjusted_deposits: +(newTotalRow?.adjusted_deposits / (dataSource$.value.length - 2)).toFixed(2),
});

const tabulationDetailAdditionalDS = [
    {
        month: 'Total',
        perc_change: null,
        total_credit: 0,
        total_debit: 0,
        closing_balance: 0,
        average_eod_balance: 0,
        non_biz_income: 0,
        adjusted_deposits: 0,
    },
    {
        month: 'Average',
        perc_change: null,
        total_credit: 0,
        total_debit: 0,
        closing_balance: 0,
        average_eod_balance: 0,
        non_biz_income: 0,
        adjusted_deposits: 0,
    },
];
const BANK_TABULATIONS_COLUMNS = [
    'month',
    'perc_change',
    'total_credit',
    'total_debit',
    'closing_balance',
    'average_eod_balance',
    'non_biz_income',
    'adjusted_deposits',
];
const BANK_TABULATIONS_DISPLAYED_COLUMNS = [
    'Month',
    'B.D % change',
    'Bank Deposit',
    'Bank Withdrawal',
    'Closing Balance',
    'Average Daily Closing',
    'Non-Business Income',
    'Adjusted Deposits',
];
const BANK_TABULATIONS_COLUMNS_MAPPPING = {
    Month: 'month',
    'B.D % change': 'perc_change',
    'Bank Deposit': 'total_credit',
    'Bank Withdrawal': 'total_debit',
    'Closing Balance': 'closing_balance',
    'Average Daily Closing': 'average_eod_balance',
    'Non-Business Income': 'non_biz_income',
    'Adjusted Deposits': 'adjusted_deposits',
};

class FSWBankTabulationDetailComponent {
    set isReadonly(value) {
        this._isReadonly = value;
    }
    get isReadonly() {
        return this._isReadonly;
    }
    set analysisReport(value) {
        if (!value) {
            throw new Error('Analysis Report is missing for this Bank Account');
        }
        this._analysisReport = value;
        this.bankTabulationFormArray = this._fb.array([]);
        initTableCreation(value, this.bankTabulationFormArray, this.dataSource$, this._fb, this._destroy$, tabulationDetailAdditionalDS);
    }
    get analysisReport() {
        return this._analysisReport || null;
    }
    get showEditMode() {
        return this.showEditModeFlag;
    }
    constructor(_fb) {
        this._fb = _fb;
        this._isReadonly = true;
        this.saveChanges = new EventEmitter();
        this._destroy$ = new Subject();
        this.showEditModeFlag = false;
        this.showManualOverride = true;
        this.columns = BANK_TABULATIONS_COLUMNS;
        this.displayedColumns = BANK_TABULATIONS_DISPLAYED_COLUMNS;
        this.columnMappings = BANK_TABULATIONS_COLUMNS_MAPPPING;
        this.dataSource$ = new BehaviorSubject([]);
        this.countryCode = getCountryCodeFromStorage();
    }
    onSaveChanges(event) {
        event.preventDefault();
        this.saveChanges.emit(this.bankTabulationFormArray.value);
    }
    isNumericValue(value) {
        return !isNaN(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBankTabulationDetailComponent, deps: [{ token: i2.FormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWBankTabulationDetailComponent, selector: "fsw-bank-tabulation-detail", inputs: { isReadonly: "isReadonly", analysisReport: "analysisReport" }, outputs: { saveChanges: "saveChanges" }, ngImport: i0, template: "<ng-container>\n  <div *ngIf=\"!analysisReport\" class=\"bg-blue-100 text-blue-400 p-2 ml-1 mt-4 mb-4\">\n    <span class=\"text-center text-[14px]\"\n      >Please select an Account Number to view the Analysis Report</span\n    >\n  </div>\n  <ng-container *ngIf=\"analysisReport?.monthly_analysis\">\n    <div style=\"position: relative\">\n      <ng-container *ngIf=\"!showEditModeFlag && countryCode === 'SG'\">\n        <button\n          class=\"edit-entry\"\n          fswButton\n          appearance=\"secondary\"\n          [disabled]=\"isReadonly\"\n          [size]=\"'s'\"\n          (click)=\"showEditModeFlag = !showEditModeFlag\"\n        >\n          {{ 'Edit Entries' }}\n        </button>\n      </ng-container>\n    </div>\n    <form class=\"ml-1 mt-2 flex flex-col gap-[16px]\">\n      <main class=\"flex flex-col gap-[16px] w-full\">\n        <section>\n          <table\n            *ngIf=\"!showEditMode\"\n            cdk-table\n            [dataSource]=\"(dataSource$ | async) || []\"\n            class=\"summary-table\"\n            role=\"grid\"\n          >\n            <caption></caption>\n            <ng-container *ngFor=\"let column of displayedColumns\" [cdkColumnDef]=\"column\">\n              <th cdk-header-cell *cdkHeaderCellDef class=\"column-header\">{{ column }}</th>\n              <td\n                cdk-cell\n                *cdkCellDef=\"let row\"\n                class=\"column-cell\"\n                [class.numeric-value]=\"isNumericValue(row[columnMappings[column]])\"\n              >\n                <span *ngIf=\"isNumericValue(row[columnMappings[column]])\">\n                  {{\n                    row[columnMappings[column]] > 0\n                      ? (row[columnMappings[column]] | currency : 'USD' | slice : 1)\n                      : (row[columnMappings[column]] | removeCurrencySymbol | number : '1.2-2')\n                  }}\n                </span>\n                <span *ngIf=\"!isNumericValue(row[columnMappings[column]])\">\n                  {{ row[columnMappings[column]] }}\n                </span>\n              </td>\n            </ng-container>\n\n            <tr cdk-header-row *cdkHeaderRowDef=\"displayedColumns\"></tr>\n            <tr\n              cdk-row\n              *cdkRowDef=\"let row; columns: displayedColumns\"\n              [class.total]=\"row?.month === 'Total' || row?.month === 'Average'\"\n            >\n              {{\n                row\n              }}\n            </tr>\n          </table>\n\n          <table\n            *ngIf=\"showEditMode\"\n            cdk-table\n            [dataSource]=\"bankTabulationFormArray.controls\"\n            class=\"summary-table\"\n            role=\"grid\"\n          >\n            <caption></caption>\n            <ng-container\n              *ngFor=\"let column of displayedColumns; let i = index\"\n              [cdkColumnDef]=\"column\"\n            >\n              <th cdk-header-cell *cdkHeaderCellDef class=\"column-header\">{{ column }}</th>\n              <td\n                cdk-cell\n                *cdkCellDef=\"let row\"\n                class=\"column-cell\"\n                [class.numeric-value]=\"isNumericValue(row.get(columnMappings[column]).value)\"\n              >\n                <ng-container\n                  *ngIf=\"\n                    i === 0 ||\n                    i === 1 ||\n                    i === displayedColumns.length - 1 ||\n                    row.get(columnMappings[column]) === null ||\n                    row.get('month').value === 'Total' ||\n                    row.get('month').value === 'Average'\n                  \"\n                >\n                  <span *ngIf=\"isNumericValue(row.get(columnMappings[column]).value)\">\n                    {{\n                      row.get(columnMappings[column]).value > 0\n                        ? (row.get(columnMappings[column]).value | currency : 'USD' | slice : 1)\n                        : (row.get(columnMappings[column]).value\n                          | removeCurrencySymbol\n                          | number : '1.2-2')\n                    }}\n                  </span>\n                  <span *ngIf=\"!isNumericValue(row.get(columnMappings[column]).value)\">\n                    {{ row.get(columnMappings[column]).value }}\n                  </span>\n                </ng-container>\n\n                <ng-container\n                  *ngIf=\"\n                    i !== 0 &&\n                    i !== 1 &&\n                    i !== displayedColumns.length - 1 &&\n                    row.get(columnMappings[column]) !== null &&\n                    row.get(columnMappings[column]).value !== null &&\n                    row.get('month').value !== 'Total' &&\n                    row.get('month').value !== 'Average'\n                  \"\n                >\n                  <input\n                    *ngIf=\"!isNumericValue(row.get(columnMappings[column]).value)\"\n                    type=\"text\"\n                    [formControl]=\"row.get(columnMappings[column])\"\n                  />\n                  <input\n                    *ngIf=\"isNumericValue(row.get(columnMappings[column]).value)\"\n                    fswCurrencyMask\n                    [options]=\"{ prefix: '', allowNegative: false, align: 'right' }\"\n                    type=\"text\"\n                    [formControl]=\"row.get(columnMappings[column])\"\n                  />\n                </ng-container>\n              </td>\n            </ng-container>\n\n            <tr cdk-header-row *cdkHeaderRowDef=\"displayedColumns\"></tr>\n            <tr\n              cdk-row\n              *cdkRowDef=\"let row; columns: displayedColumns\"\n              [class.total]=\"\n                row?.get('month').value === 'Total' || row?.get('month').value === 'Average'\n              \"\n            ></tr>\n          </table>\n        </section>\n\n        <section class=\"flex justify-between\">\n          <div></div>\n          <div>\n            <button\n              *ngIf=\"showEditModeFlag && countryCode === 'SG'\"\n              [disabled]=\"isReadonly\"\n              fswButton\n              (click)=\"onSaveChanges($event)\"\n            >\n              {{ 'Save' }}\n            </button>\n          </div>\n        </section>\n      </main>\n    </form>\n  </ng-container>\n</ng-container>\n", styles: ["table{width:100%;border-collapse:collapse}table th,table td{padding:10px;text-align:left;border-bottom:1px solid #ddd;border-top:1px solid #ddd;font-size:90%}table th:first-child,table td:first-child{border-left:1px solid #ddd}table th:last-child,table td:last-child{border-right:1px solid #ddd}table th.numeric-value,table td.numeric-value{text-align:right}table th input[type=text],table td input[type=text]{border:1px solid #ddd;border-radius:5px;padding:5px;width:100%;font-size:90%}table th{font-weight:700;font-weight:500}table td{font-size:80%}.summary-table .cdk-header-cell{width:4%}.summary-table tr.sub-header{background-color:#f9f9f9}.summary-table tr:hover{background-color:#e6e6e6}.summary-table .column-header:not(:first-child){text-align:right}.summary-table tr.total{background-color:#f3f5fd}.edit-entry{position:absolute;top:-50px;right:0}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: CurrencyMaskDirective, selector: "[fswCurrencyMask]", inputs: ["max", "min", "options"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "component", type: i6$1.CdkTable, selector: "cdk-table, table[cdk-table]", inputs: ["trackBy", "dataSource", "multiTemplateDataRows", "fixedLayout"], outputs: ["contentChanged"], exportAs: ["cdkTable"] }, { kind: "directive", type: i6$1.CdkRowDef, selector: "[cdkRowDef]", inputs: ["cdkRowDefColumns", "cdkRowDefWhen"] }, { kind: "directive", type: i6$1.CdkCellDef, selector: "[cdkCellDef]" }, { kind: "directive", type: i6$1.CdkHeaderCellDef, selector: "[cdkHeaderCellDef]" }, { kind: "directive", type: i6$1.CdkColumnDef, selector: "[cdkColumnDef]", inputs: ["sticky", "cdkColumnDef", "stickyEnd"] }, { kind: "directive", type: i6$1.CdkCell, selector: "cdk-cell, td[cdk-cell]" }, { kind: "component", type: i6$1.CdkRow, selector: "cdk-row, tr[cdk-row]" }, { kind: "directive", type: i6$1.CdkHeaderCell, selector: "cdk-header-cell, th[cdk-header-cell]" }, { kind: "component", type: i6$1.CdkHeaderRow, selector: "cdk-header-row, tr[cdk-header-row]" }, { kind: "directive", type: i6$1.CdkHeaderRowDef, selector: "[cdkHeaderRowDef]", inputs: ["cdkHeaderRowDef", "cdkHeaderRowDefSticky"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i1$1.SlicePipe, name: "slice" }, { kind: "pipe", type: i1$1.DecimalPipe, name: "number" }, { kind: "pipe", type: i1$1.CurrencyPipe, name: "currency" }, { kind: "pipe", type: RemoveCurrencySymbolPipe, name: "removeCurrencySymbol" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBankTabulationDetailComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-bank-tabulation-detail', template: "<ng-container>\n  <div *ngIf=\"!analysisReport\" class=\"bg-blue-100 text-blue-400 p-2 ml-1 mt-4 mb-4\">\n    <span class=\"text-center text-[14px]\"\n      >Please select an Account Number to view the Analysis Report</span\n    >\n  </div>\n  <ng-container *ngIf=\"analysisReport?.monthly_analysis\">\n    <div style=\"position: relative\">\n      <ng-container *ngIf=\"!showEditModeFlag && countryCode === 'SG'\">\n        <button\n          class=\"edit-entry\"\n          fswButton\n          appearance=\"secondary\"\n          [disabled]=\"isReadonly\"\n          [size]=\"'s'\"\n          (click)=\"showEditModeFlag = !showEditModeFlag\"\n        >\n          {{ 'Edit Entries' }}\n        </button>\n      </ng-container>\n    </div>\n    <form class=\"ml-1 mt-2 flex flex-col gap-[16px]\">\n      <main class=\"flex flex-col gap-[16px] w-full\">\n        <section>\n          <table\n            *ngIf=\"!showEditMode\"\n            cdk-table\n            [dataSource]=\"(dataSource$ | async) || []\"\n            class=\"summary-table\"\n            role=\"grid\"\n          >\n            <caption></caption>\n            <ng-container *ngFor=\"let column of displayedColumns\" [cdkColumnDef]=\"column\">\n              <th cdk-header-cell *cdkHeaderCellDef class=\"column-header\">{{ column }}</th>\n              <td\n                cdk-cell\n                *cdkCellDef=\"let row\"\n                class=\"column-cell\"\n                [class.numeric-value]=\"isNumericValue(row[columnMappings[column]])\"\n              >\n                <span *ngIf=\"isNumericValue(row[columnMappings[column]])\">\n                  {{\n                    row[columnMappings[column]] > 0\n                      ? (row[columnMappings[column]] | currency : 'USD' | slice : 1)\n                      : (row[columnMappings[column]] | removeCurrencySymbol | number : '1.2-2')\n                  }}\n                </span>\n                <span *ngIf=\"!isNumericValue(row[columnMappings[column]])\">\n                  {{ row[columnMappings[column]] }}\n                </span>\n              </td>\n            </ng-container>\n\n            <tr cdk-header-row *cdkHeaderRowDef=\"displayedColumns\"></tr>\n            <tr\n              cdk-row\n              *cdkRowDef=\"let row; columns: displayedColumns\"\n              [class.total]=\"row?.month === 'Total' || row?.month === 'Average'\"\n            >\n              {{\n                row\n              }}\n            </tr>\n          </table>\n\n          <table\n            *ngIf=\"showEditMode\"\n            cdk-table\n            [dataSource]=\"bankTabulationFormArray.controls\"\n            class=\"summary-table\"\n            role=\"grid\"\n          >\n            <caption></caption>\n            <ng-container\n              *ngFor=\"let column of displayedColumns; let i = index\"\n              [cdkColumnDef]=\"column\"\n            >\n              <th cdk-header-cell *cdkHeaderCellDef class=\"column-header\">{{ column }}</th>\n              <td\n                cdk-cell\n                *cdkCellDef=\"let row\"\n                class=\"column-cell\"\n                [class.numeric-value]=\"isNumericValue(row.get(columnMappings[column]).value)\"\n              >\n                <ng-container\n                  *ngIf=\"\n                    i === 0 ||\n                    i === 1 ||\n                    i === displayedColumns.length - 1 ||\n                    row.get(columnMappings[column]) === null ||\n                    row.get('month').value === 'Total' ||\n                    row.get('month').value === 'Average'\n                  \"\n                >\n                  <span *ngIf=\"isNumericValue(row.get(columnMappings[column]).value)\">\n                    {{\n                      row.get(columnMappings[column]).value > 0\n                        ? (row.get(columnMappings[column]).value | currency : 'USD' | slice : 1)\n                        : (row.get(columnMappings[column]).value\n                          | removeCurrencySymbol\n                          | number : '1.2-2')\n                    }}\n                  </span>\n                  <span *ngIf=\"!isNumericValue(row.get(columnMappings[column]).value)\">\n                    {{ row.get(columnMappings[column]).value }}\n                  </span>\n                </ng-container>\n\n                <ng-container\n                  *ngIf=\"\n                    i !== 0 &&\n                    i !== 1 &&\n                    i !== displayedColumns.length - 1 &&\n                    row.get(columnMappings[column]) !== null &&\n                    row.get(columnMappings[column]).value !== null &&\n                    row.get('month').value !== 'Total' &&\n                    row.get('month').value !== 'Average'\n                  \"\n                >\n                  <input\n                    *ngIf=\"!isNumericValue(row.get(columnMappings[column]).value)\"\n                    type=\"text\"\n                    [formControl]=\"row.get(columnMappings[column])\"\n                  />\n                  <input\n                    *ngIf=\"isNumericValue(row.get(columnMappings[column]).value)\"\n                    fswCurrencyMask\n                    [options]=\"{ prefix: '', allowNegative: false, align: 'right' }\"\n                    type=\"text\"\n                    [formControl]=\"row.get(columnMappings[column])\"\n                  />\n                </ng-container>\n              </td>\n            </ng-container>\n\n            <tr cdk-header-row *cdkHeaderRowDef=\"displayedColumns\"></tr>\n            <tr\n              cdk-row\n              *cdkRowDef=\"let row; columns: displayedColumns\"\n              [class.total]=\"\n                row?.get('month').value === 'Total' || row?.get('month').value === 'Average'\n              \"\n            ></tr>\n          </table>\n        </section>\n\n        <section class=\"flex justify-between\">\n          <div></div>\n          <div>\n            <button\n              *ngIf=\"showEditModeFlag && countryCode === 'SG'\"\n              [disabled]=\"isReadonly\"\n              fswButton\n              (click)=\"onSaveChanges($event)\"\n            >\n              {{ 'Save' }}\n            </button>\n          </div>\n        </section>\n      </main>\n    </form>\n  </ng-container>\n</ng-container>\n", styles: ["table{width:100%;border-collapse:collapse}table th,table td{padding:10px;text-align:left;border-bottom:1px solid #ddd;border-top:1px solid #ddd;font-size:90%}table th:first-child,table td:first-child{border-left:1px solid #ddd}table th:last-child,table td:last-child{border-right:1px solid #ddd}table th.numeric-value,table td.numeric-value{text-align:right}table th input[type=text],table td input[type=text]{border:1px solid #ddd;border-radius:5px;padding:5px;width:100%;font-size:90%}table th{font-weight:700;font-weight:500}table td{font-size:80%}.summary-table .cdk-header-cell{width:4%}.summary-table tr.sub-header{background-color:#f9f9f9}.summary-table tr:hover{background-color:#e6e6e6}.summary-table .column-header:not(:first-child){text-align:right}.summary-table tr.total{background-color:#f3f5fd}.edit-entry{position:absolute;top:-50px;right:0}\n"] }]
        }], ctorParameters: function () { return [{ type: i2.FormBuilder }]; }, propDecorators: { isReadonly: [{
                type: Input
            }], analysisReport: [{
                type: Input
            }], saveChanges: [{
                type: Output
            }] } });

const DECLARATIONS_EXPORTS$c = [FSWBankTabulationDetailComponent];
class FSWBankTabulationDetailModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBankTabulationDetailModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWBankTabulationDetailModule, declarations: [FSWBankTabulationDetailComponent], imports: [CommonModule,
            ReactiveFormsModule,
            LetDirective,
            FormWidgetModule,
            // services
            UtilsServiceModule,
            BankTabulationsServiceModule,
            //
            FSWCurrencyMaskModule,
            FSWInputModule,
            FSWButtonModule,
            FSWDateTimePickerModule,
            FSWPanelModule,
            FSWIconModule,
            CdkTableModule,
            FSWModalModule$1,
            DialogModule,
            RemoveCurrencySymbolModule], exports: [FSWBankTabulationDetailComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBankTabulationDetailModule, providers: [CurrencyPipe], imports: [CommonModule,
            ReactiveFormsModule,
            FormWidgetModule,
            // services
            UtilsServiceModule,
            BankTabulationsServiceModule,
            //
            FSWCurrencyMaskModule,
            FSWInputModule,
            FSWButtonModule,
            FSWDateTimePickerModule,
            FSWPanelModule,
            FSWIconModule,
            CdkTableModule,
            FSWModalModule$1,
            DialogModule,
            RemoveCurrencySymbolModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBankTabulationDetailModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        LetDirective,
                        FormWidgetModule,
                        // services
                        UtilsServiceModule,
                        BankTabulationsServiceModule,
                        //
                        FSWCurrencyMaskModule,
                        FSWInputModule,
                        FSWButtonModule,
                        FSWDateTimePickerModule,
                        FSWPanelModule,
                        FSWIconModule,
                        CdkTableModule,
                        FSWModalModule$1,
                        DialogModule,
                        RemoveCurrencySymbolModule,
                    ],
                    declarations: DECLARATIONS_EXPORTS$c,
                    exports: DECLARATIONS_EXPORTS$c,
                    providers: [CurrencyPipe],
                }]
        }] });

const summaryTabulationAdditionalDS = [
    {
        bank_name: 'Summary',
        account_number: null,
        currency: null,
        rate: null,
        average_deposit: 0,
        average_deposit_rate: 0,
        average_withdrawal: 0,
        average_withdrawal_rate: 0,
        average_closing_balance: 0,
        average_closing_balance_rate: 0,
        average_daily_running_balance: 0,
        average_daily_running_balance_rate: 0,
        latest_closing_balance: 0,
        latest_closing_balance_rate: 0,
    },
];
const SUMMARY_TABULATIONS_COLUMNS = [
    'bank_name',
    'account_number',
    'currency',
    'rate',
    'average_deposit',
    'average_withdrawal',
    'average_closing_balance',
    'average_daily_running_balance',
    'latest_closing_balance',
];
const SUMMARY_TABULATIONS_DISPLAYED_COLUMNS = [
    'Bank Name',
    'Account Number',
    'Currency',
    'Rate',
    'Average Deposit',
    'Average Withdrawal',
    'Average Closing Balance',
    'Average Daily Running Balance',
    'Latest Closing Balance',
];
const SUMMARY_TABULATIONS_COLUMNS_MAPPPING = {
    'Bank Name': 'bank_name',
    'Account Number': 'account_number',
    Currency: 'currency',
    Rate: 'rate',
    'Average Deposit': 'average_deposit',
    'Average Withdrawal': 'average_withdrawal',
    'Average Closing Balance': 'average_closing_balance',
    'Average Daily Running Balance': 'average_daily_running_balance',
    'Latest Closing Balance': 'latest_closing_balance',
};

class FSWSummaryBankTabulationComponent {
    set isReadonly(value) {
        this._isReadonly = value;
    }
    get isReadonly() {
        return this._isReadonly;
    }
    set bankAccountAnalysisReports(values) {
        const includedReports = values.filter((r) => r.is_included);
        if (!includedReports?.length) {
            console.error('No Analysis Reports are included in summary');
            this._bankAccountAnalysisReports = [];
            return;
        }
        this._bankAccountAnalysisReports = [...includedReports];
        this._updateSummaryDataSource(this._bankAccountAnalysisReports);
    }
    get bankAccountAnalysisReports() {
        return this._bankAccountAnalysisReports;
    }
    constructor(_componentStore, masterDataService, _fb) {
        this._componentStore = _componentStore;
        this.masterDataService = masterDataService;
        this._fb = _fb;
        this.summaryColumns = SUMMARY_TABULATIONS_COLUMNS;
        this.summaryDisplayedColumns = SUMMARY_TABULATIONS_DISPLAYED_COLUMNS;
        this.summaryColumnMappings = SUMMARY_TABULATIONS_COLUMNS_MAPPPING;
        this.summaryDataSource$ = new BehaviorSubject([]);
        this.dataSource$ = new BehaviorSubject([]);
        this.exchangeRates = [];
        this.summaryForm = this._fb.group({});
        this._destroy$ = new Subject();
        // Input properties
        this._isReadonly = true;
        this.saveChanges = new EventEmitter();
        this._initializeForms();
    }
    ngOnInit() {
        this._setupSubscriptions();
        this._updateSummaryRowAsPerExchangeRate();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    onSaveChanges(event) {
        event.preventDefault();
        this.saveChanges.emit(this.bankTabulationFormArray.value);
    }
    isNumericValue(value) {
        if (typeof value === 'number') {
            return !isNaN(value);
        }
        return false;
    }
    _initializeForms() {
        const currency = COUNTRY_CONFIG[getCountryCodeFromStorage()]?.currencyCode ||
            COUNTRY_CONFIG['SG'].currencyCode;
        this.summaryForm = this._fb.group({
            selectedCurrency: [currency],
            exchangeRates: [{}],
        });
    }
    _setupSubscriptions() {
        // Subscribe to currency changes
        this.summaryForm
            .get('selectedCurrency')
            ?.valueChanges.pipe(takeUntil$1(this._destroy$), distinctUntilChanged$1())
            .subscribe((res) => {
            this.masterDataService
                .getExchangeRates(res)
                .pipe(takeUntil$1(this._destroy$))
                .subscribe((res) => {
                this.summaryForm.patchValue({
                    exchangeRates: res.rates,
                });
                this._updateSummaryRowAsPerExchangeRate();
            });
        });
        // Subscribe to store for exchange rates
        this._componentStore.state$
            .pipe(takeUntil$1(this._destroy$))
            .subscribe((state) => {
            this.exchangeRates = Object.keys(state?.referenceData?.exchangeRatesContent?.rates ?? {});
            this.summaryForm.patchValue({
                exchangeRates: state?.referenceData?.exchangeRatesContent?.rates ?? {},
            });
        });
    }
    _createTempDataSource(includedReports) {
        const temp = [];
        const exchangeRates = this.summaryForm.get('exchangeRates')?.value;
        for (const value of includedReports) {
            this.bankTabulationFormArray = this._fb.array([]);
            initTableCreation(value.analysis_report, this.bankTabulationFormArray, this.dataSource$, this._fb, this._destroy$, tabulationDetailAdditionalDS);
            const averageRow = this.bankTabulationFormArray.value.find((r) => r?.month === 'Average');
            const thirdLastRow = this.bankTabulationFormArray.value[this.bankTabulationFormArray.length - 3];
            temp.push({
                bank_name: value.bank_name,
                account_number: value.account_number,
                currency: value.currency,
                rate: exchangeRates[value.currency] || 1,
                average_deposit: averageRow?.adjusted_deposits || 0,
                average_deposit_rate: 0,
                average_withdrawal: averageRow?.total_debit || 0,
                average_withdrawal_rate: 0,
                average_closing_balance: averageRow?.closing_balance || 0,
                average_closing_balance_rate: 0,
                average_daily_running_balance: averageRow?.average_eod_balance || 0,
                average_daily_running_balance_rate: 0,
                latest_closing_balance: thirdLastRow?.closing_balance || 0,
                latest_closing_balance_rate: 0,
            });
        }
        return temp;
    }
    _createSummaryRow(data, isRate) {
        const summaryRow = {
            bank_name: 'Summary',
            account_number: null,
            currency: null,
            rate: null,
            average_deposit: 0,
            average_deposit_rate: 0,
            average_withdrawal: 0,
            average_withdrawal_rate: 0,
            average_closing_balance: 0,
            average_closing_balance_rate: 0,
            average_daily_running_balance: 0,
            average_daily_running_balance_rate: 0,
            latest_closing_balance: 0,
            latest_closing_balance_rate: 0,
        };
        for (const row of data) {
            if (row.bank_name !== 'Summary' && !isRate) {
                summaryRow.average_deposit += row.average_deposit;
                summaryRow.average_withdrawal += row.average_withdrawal;
                summaryRow.average_closing_balance += row.average_closing_balance;
                summaryRow.average_daily_running_balance += row.average_daily_running_balance;
                summaryRow.latest_closing_balance += row.latest_closing_balance;
            }
            else if (row.bank_name !== 'Summary' && isRate) {
                summaryRow.average_deposit_rate += row.average_deposit_rate;
                summaryRow.average_withdrawal_rate += row.average_withdrawal_rate;
                summaryRow.average_closing_balance_rate += row.average_closing_balance_rate;
                summaryRow.average_daily_running_balance_rate += row.average_daily_running_balance_rate;
                summaryRow.latest_closing_balance_rate += row.latest_closing_balance_rate;
            }
        }
        return summaryRow;
    }
    _updateSummaryDataSource(includedReports) {
        const temp = this._createTempDataSource(includedReports);
        const summaryRow = this._createSummaryRow(temp);
        temp.push(summaryRow);
        this.summaryDataSource$.next([...temp]);
    }
    _updateSummaryRowAsPerExchangeRate() {
        const exchangeRates = this.summaryForm.get('exchangeRates')?.value;
        this.summaryDataSource$.value.forEach((row) => {
            const derivedRate = exchangeRates[row.currency] || 1;
            row.rate = derivedRate;
            row.average_deposit_rate = row.average_deposit / derivedRate;
            row.average_withdrawal_rate = row.average_withdrawal / derivedRate;
            row.average_closing_balance_rate = row.average_closing_balance / derivedRate;
            row.average_daily_running_balance_rate = row.average_daily_running_balance / derivedRate;
            row.latest_closing_balance_rate = row.latest_closing_balance / derivedRate;
        });
        const temp = this.summaryDataSource$.value.filter((r) => r.bank_name !== 'Summary');
        const summaryRow = this._createSummaryRow(temp, true);
        temp.push(summaryRow);
        this.summaryDataSource$.next([...temp]);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSummaryBankTabulationComponent, deps: [{ token: STORE_TOKEN$6 }, { token: MASTER_DATA_SERVICE_TOKEN }, { token: i2.FormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWSummaryBankTabulationComponent, selector: "fsw-summary-bank-tabulation", inputs: { isReadonly: "isReadonly", bankAccountAnalysisReports: "bankAccountAnalysisReports" }, outputs: { saveChanges: "saveChanges" }, ngImport: i0, template: "<div class=\"bank-tabulation-container\">\n  <header>\n    <h6>Summary of Bank Tabulations</h6>\n  </header>\n\n  <!-- Empty State -->\n  <div *ngIf=\"!bankAccountAnalysisReports?.length\" class=\"empty-state\">\n    <p>Either no Bank Accounts are added to the summary or no Analysis Reports are available.</p>\n    <p>\n      If Analysis Reports are available, please check \"Add to Summary\" and click on \"Save\" to add it\n      here.\n    </p>\n  </div>\n\n  <!-- Main Content -->\n  <ng-container *ngIf=\"bankAccountAnalysisReports?.length\">\n    <form [formGroup]=\"summaryForm\">\n      <!-- Currency Selector -->\n      <div class=\"currency-selector\">\n        <div class=\"flex items-center gap-4 max-w-xs\">\n          <label class=\"text-sm font-medium whitespace-nowrap\">Base Currency:</label>\n          <div class=\"flex-1\">\n            <fsw-select\n              formControlName=\"selectedCurrency\"\n              [maxHeight]=\"'200px'\"\n              [placeHolder]=\"'Select Currency'\"\n            >\n              <ng-container *ngFor=\"let rate of exchangeRates\">\n                <ng-template fswSelectItem let-selected [text]=\"rate\" [value]=\"rate\"></ng-template>\n              </ng-container>\n            </fsw-select>\n          </div>\n        </div>\n      </div>\n\n      <!-- Table Section -->\n      <div class=\"summary-table-wrapper\">\n        <table cdk-table [dataSource]=\"(summaryDataSource$ | async) || []\" class=\"summary-table\">\n          <ng-container *ngFor=\"let column of summaryDisplayedColumns\" [cdkColumnDef]=\"column\">\n            <!-- Header Cell -->\n            <th\n              cdk-header-cell\n              *cdkHeaderCellDef\n              [class.numeric]=\"\n                column !== 'Bank Name' && column !== 'Account Number' && column !== 'Currency'\n              \"\n            >\n              {{ column }}\n            </th>\n\n            <!-- Data Cell -->\n            <td\n              cdk-cell\n              *cdkCellDef=\"let row\"\n              [class.numeric-value]=\"isNumericValue(row[summaryColumnMappings[column]])\"\n            >\n              <!-- Numeric Values -->\n              <ng-container *ngIf=\"isNumericValue(row[summaryColumnMappings[column]])\">\n                <!-- Rate Display -->\n                <ng-container *ngIf=\"column === 'Rate'\">\n                  {{ row[summaryColumnMappings[column]] | number : '1.9-9' }}\n                </ng-container>\n\n                <!-- Other Numeric Values -->\n                <ng-container *ngIf=\"column !== 'Rate'\">\n                  <!-- Main Value -->\n                  <div class=\"main-value\" *ngIf=\"row[summaryColumnMappings[column]] !== 0\">\n                    {{\n                      row[summaryColumnMappings[column]] > 0\n                        ? (row[summaryColumnMappings[column]] | currency : 'USD' | slice : 1)\n                        : (row[summaryColumnMappings[column]] | number : '1.2-2')\n                    }}\n                  </div>\n\n                  <!-- Conversion Rate -->\n                  <div\n                    *ngIf=\"row[summaryColumnMappings[column] + '_rate'] > 0\"\n                    class=\"conversion-rate\"\n                  >\n                    {{\n                      row[summaryColumnMappings[column] + '_rate'] | currency : 'USD' | slice : 1\n                    }}\n                  </div>\n                </ng-container>\n              </ng-container>\n\n              <!-- Text Values -->\n              <span *ngIf=\"!isNumericValue(row[summaryColumnMappings[column]])\">\n                {{ row[summaryColumnMappings[column]] }}\n              </span>\n            </td>\n          </ng-container>\n\n          <!-- Row Templates -->\n          <tr cdk-header-row *cdkHeaderRowDef=\"summaryDisplayedColumns\"></tr>\n          <tr\n            cdk-row\n            *cdkRowDef=\"let row; columns: summaryDisplayedColumns\"\n            [class.summary]=\"row?.bank_name === 'Summary'\"\n          ></tr>\n        </table>\n      </div>\n    </form>\n  </ng-container>\n</div>\n", styles: [".bank-tabulation-container{padding:1.5rem}.bank-tabulation-container header{margin-bottom:1.5rem}.bank-tabulation-container header h6{font-size:1.8rem;font-weight:600;color:#1e293b}.currency-selector{margin-bottom:1.5rem}.currency-selector label{color:#1e293b;font-weight:500}.summary-table-wrapper{overflow-x:auto;margin:0 -1.5rem;padding:0 1.5rem}.summary-table-wrapper .summary-table{width:100%;min-width:1200px;border-collapse:separate;border-spacing:0;border:1px solid #e2e8f0;border-radius:.5rem}.summary-table-wrapper .summary-table th,.summary-table-wrapper .summary-table td{padding:1rem;border-bottom:1px solid #e2e8f0}.summary-table-wrapper .summary-table th:not(:last-child),.summary-table-wrapper .summary-table td:not(:last-child){border-right:1px solid #e2e8f0}.summary-table-wrapper .summary-table th{color:#1e293be6;font-weight:500;font-size:1.4rem;text-align:center;white-space:normal;word-wrap:break-word;min-width:120px;max-width:200px}.summary-table-wrapper .summary-table td{font-size:1.4rem;vertical-align:middle;text-align:center}.summary-table-wrapper .summary-table td.numeric-value{text-align:right}.summary-table-wrapper .summary-table td.numeric-value .conversion-rate{margin-top:.5rem;padding:.25rem .5rem;background-color:#64748b1a;border-radius:.25rem;font-size:1.4rem}.summary-table-wrapper .summary-table td.numeric-value .main-value{padding:.25rem .5rem}.summary-table-wrapper .summary-table tr:hover:not(.summary){background-color:#f1f5f9}.summary-table-wrapper .summary-table tr.summary{background-color:#f3f5fd;font-weight:600}.summary-table-wrapper .summary-table tr.summary td{color:#1e293b}@media (max-width: 1024px){.summary-table-wrapper{margin:0 -1rem;padding:0 1rem}}.empty-state{background-color:#dbeafe;color:#1e40af;padding:1rem;border-radius:.5rem;margin:1rem 0}.empty-state p{margin:.5rem 0;font-size:1.2rem}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i6$1.CdkTable, selector: "cdk-table, table[cdk-table]", inputs: ["trackBy", "dataSource", "multiTemplateDataRows", "fixedLayout"], outputs: ["contentChanged"], exportAs: ["cdkTable"] }, { kind: "directive", type: i6$1.CdkRowDef, selector: "[cdkRowDef]", inputs: ["cdkRowDefColumns", "cdkRowDefWhen"] }, { kind: "directive", type: i6$1.CdkCellDef, selector: "[cdkCellDef]" }, { kind: "directive", type: i6$1.CdkHeaderCellDef, selector: "[cdkHeaderCellDef]" }, { kind: "directive", type: i6$1.CdkColumnDef, selector: "[cdkColumnDef]", inputs: ["sticky", "cdkColumnDef", "stickyEnd"] }, { kind: "directive", type: i6$1.CdkCell, selector: "cdk-cell, td[cdk-cell]" }, { kind: "component", type: i6$1.CdkRow, selector: "cdk-row, tr[cdk-row]" }, { kind: "directive", type: i6$1.CdkHeaderCell, selector: "cdk-header-cell, th[cdk-header-cell]" }, { kind: "component", type: i6$1.CdkHeaderRow, selector: "cdk-header-row, tr[cdk-header-row]" }, { kind: "directive", type: i6$1.CdkHeaderRowDef, selector: "[cdkHeaderRowDef]", inputs: ["cdkHeaderRowDef", "cdkHeaderRowDefSticky"] }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i1$1.SlicePipe, name: "slice" }, { kind: "pipe", type: i1$1.DecimalPipe, name: "number" }, { kind: "pipe", type: i1$1.CurrencyPipe, name: "currency" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSummaryBankTabulationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-summary-bank-tabulation', template: "<div class=\"bank-tabulation-container\">\n  <header>\n    <h6>Summary of Bank Tabulations</h6>\n  </header>\n\n  <!-- Empty State -->\n  <div *ngIf=\"!bankAccountAnalysisReports?.length\" class=\"empty-state\">\n    <p>Either no Bank Accounts are added to the summary or no Analysis Reports are available.</p>\n    <p>\n      If Analysis Reports are available, please check \"Add to Summary\" and click on \"Save\" to add it\n      here.\n    </p>\n  </div>\n\n  <!-- Main Content -->\n  <ng-container *ngIf=\"bankAccountAnalysisReports?.length\">\n    <form [formGroup]=\"summaryForm\">\n      <!-- Currency Selector -->\n      <div class=\"currency-selector\">\n        <div class=\"flex items-center gap-4 max-w-xs\">\n          <label class=\"text-sm font-medium whitespace-nowrap\">Base Currency:</label>\n          <div class=\"flex-1\">\n            <fsw-select\n              formControlName=\"selectedCurrency\"\n              [maxHeight]=\"'200px'\"\n              [placeHolder]=\"'Select Currency'\"\n            >\n              <ng-container *ngFor=\"let rate of exchangeRates\">\n                <ng-template fswSelectItem let-selected [text]=\"rate\" [value]=\"rate\"></ng-template>\n              </ng-container>\n            </fsw-select>\n          </div>\n        </div>\n      </div>\n\n      <!-- Table Section -->\n      <div class=\"summary-table-wrapper\">\n        <table cdk-table [dataSource]=\"(summaryDataSource$ | async) || []\" class=\"summary-table\">\n          <ng-container *ngFor=\"let column of summaryDisplayedColumns\" [cdkColumnDef]=\"column\">\n            <!-- Header Cell -->\n            <th\n              cdk-header-cell\n              *cdkHeaderCellDef\n              [class.numeric]=\"\n                column !== 'Bank Name' && column !== 'Account Number' && column !== 'Currency'\n              \"\n            >\n              {{ column }}\n            </th>\n\n            <!-- Data Cell -->\n            <td\n              cdk-cell\n              *cdkCellDef=\"let row\"\n              [class.numeric-value]=\"isNumericValue(row[summaryColumnMappings[column]])\"\n            >\n              <!-- Numeric Values -->\n              <ng-container *ngIf=\"isNumericValue(row[summaryColumnMappings[column]])\">\n                <!-- Rate Display -->\n                <ng-container *ngIf=\"column === 'Rate'\">\n                  {{ row[summaryColumnMappings[column]] | number : '1.9-9' }}\n                </ng-container>\n\n                <!-- Other Numeric Values -->\n                <ng-container *ngIf=\"column !== 'Rate'\">\n                  <!-- Main Value -->\n                  <div class=\"main-value\" *ngIf=\"row[summaryColumnMappings[column]] !== 0\">\n                    {{\n                      row[summaryColumnMappings[column]] > 0\n                        ? (row[summaryColumnMappings[column]] | currency : 'USD' | slice : 1)\n                        : (row[summaryColumnMappings[column]] | number : '1.2-2')\n                    }}\n                  </div>\n\n                  <!-- Conversion Rate -->\n                  <div\n                    *ngIf=\"row[summaryColumnMappings[column] + '_rate'] > 0\"\n                    class=\"conversion-rate\"\n                  >\n                    {{\n                      row[summaryColumnMappings[column] + '_rate'] | currency : 'USD' | slice : 1\n                    }}\n                  </div>\n                </ng-container>\n              </ng-container>\n\n              <!-- Text Values -->\n              <span *ngIf=\"!isNumericValue(row[summaryColumnMappings[column]])\">\n                {{ row[summaryColumnMappings[column]] }}\n              </span>\n            </td>\n          </ng-container>\n\n          <!-- Row Templates -->\n          <tr cdk-header-row *cdkHeaderRowDef=\"summaryDisplayedColumns\"></tr>\n          <tr\n            cdk-row\n            *cdkRowDef=\"let row; columns: summaryDisplayedColumns\"\n            [class.summary]=\"row?.bank_name === 'Summary'\"\n          ></tr>\n        </table>\n      </div>\n    </form>\n  </ng-container>\n</div>\n", styles: [".bank-tabulation-container{padding:1.5rem}.bank-tabulation-container header{margin-bottom:1.5rem}.bank-tabulation-container header h6{font-size:1.8rem;font-weight:600;color:#1e293b}.currency-selector{margin-bottom:1.5rem}.currency-selector label{color:#1e293b;font-weight:500}.summary-table-wrapper{overflow-x:auto;margin:0 -1.5rem;padding:0 1.5rem}.summary-table-wrapper .summary-table{width:100%;min-width:1200px;border-collapse:separate;border-spacing:0;border:1px solid #e2e8f0;border-radius:.5rem}.summary-table-wrapper .summary-table th,.summary-table-wrapper .summary-table td{padding:1rem;border-bottom:1px solid #e2e8f0}.summary-table-wrapper .summary-table th:not(:last-child),.summary-table-wrapper .summary-table td:not(:last-child){border-right:1px solid #e2e8f0}.summary-table-wrapper .summary-table th{color:#1e293be6;font-weight:500;font-size:1.4rem;text-align:center;white-space:normal;word-wrap:break-word;min-width:120px;max-width:200px}.summary-table-wrapper .summary-table td{font-size:1.4rem;vertical-align:middle;text-align:center}.summary-table-wrapper .summary-table td.numeric-value{text-align:right}.summary-table-wrapper .summary-table td.numeric-value .conversion-rate{margin-top:.5rem;padding:.25rem .5rem;background-color:#64748b1a;border-radius:.25rem;font-size:1.4rem}.summary-table-wrapper .summary-table td.numeric-value .main-value{padding:.25rem .5rem}.summary-table-wrapper .summary-table tr:hover:not(.summary){background-color:#f1f5f9}.summary-table-wrapper .summary-table tr.summary{background-color:#f3f5fd;font-weight:600}.summary-table-wrapper .summary-table tr.summary td{color:#1e293b}@media (max-width: 1024px){.summary-table-wrapper{margin:0 -1rem;padding:0 1rem}}.empty-state{background-color:#dbeafe;color:#1e40af;padding:1rem;border-radius:.5rem;margin:1rem 0}.empty-state p{margin:.5rem 0;font-size:1.2rem}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [STORE_TOKEN$6]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MASTER_DATA_SERVICE_TOKEN]
                }] }, { type: i2.FormBuilder }]; }, propDecorators: { isReadonly: [{
                type: Input
            }], bankAccountAnalysisReports: [{
                type: Input
            }], saveChanges: [{
                type: Output
            }] } });

// Create the injection token with factory implementation
const GST_SERVICE = new InjectionToken('GST_SERVICE');
// helper function to inject the GST service
const injectGSTService = () => inject(GST_SERVICE);
const provideGSTService = () => ({
    provide: GST_SERVICE,
    useFactory: () => {
        const httpClient = inject(HttpClient);
        const utilsService = inject(UTILS_SERVICE_TOKEN);
        // Base URL for GST endpoints
        const url = () => `${utilsService.getKongUrl()}`;
        // Error handler implementation
        const errorHandler = (error) => {
            console.error('GST Service Error:', error);
            return of({
                id: '',
                period_type: 'CUSTOM',
                details: [
                    {
                        gst_revenue: 0,
                        standard_rated: 0,
                        zero_rated: 0,
                        start_at: '',
                        end_at: '',
                    },
                ],
            });
            // return throwError(() => error?.error?.message || 'An error occurred');
        };
        // Response handler
        const responseHandler = (response) => {
            if (response?.error) {
                throw new Error(response.error);
            }
            return response?.data || response;
        };
        return {
            getGstIdFromApplication: (applicationId) => httpClient
                .get(`${url()}/aps/v1/applications/${applicationId}/relationships/gst`, { headers: setRequestOptions() })
                .pipe(map((response) => responseHandler(response?.data[0]?.relationship_id)), catchError(errorHandler)),
            linkGstToApplication: (applicationId, gstId) => httpClient
                .post(`${url()}/aps/v1/applications/${applicationId}/relationships/gst/${gstId}`, null, {
                headers: setRequestOptions(),
            })
                .pipe(map(responseHandler), catchError(errorHandler)),
            getGSTById: (gstId) => httpClient
                .get(`${url()}/credit/v2/gst/${gstId}`, 
            // `${url()}/credit/v2/gst/${gstId}`, // TODO: 'ed87af15-e2fe-4bd3-8028-11d88f1a35af'
            {
                headers: setRequestOptions(),
            })
                .pipe(map((response) => responseHandler(response || {
                id: '',
                period_type: 'CUSTOM',
                details: [
                    {
                        gst_revenue: 0,
                        standard_rated: 0,
                        zero_rated: 0,
                        start_at: '2024-01',
                        end_at: '2024-01',
                    },
                ],
            })), catchError(errorHandler)),
            createGstAsync: (payload) => httpClient
                .post(`${url()}/credit/v2/gst`, payload, { headers: setRequestOptions() })
                .pipe(map(responseHandler), catchError(errorHandler)),
            updateGstAsync: (gstId, payload) => httpClient
                .put(`${url()}/credit/v2/gst/${gstId}`, payload, { headers: setRequestOptions() })
                .pipe(map(responseHandler), catchError(errorHandler)),
        };
    },
    deps: [HttpClient, UTILS_SERVICE_TOKEN],
});

const GST_STORE = new InjectionToken('GST_STORE');
// Helper function to inject the GST store
const injectGSTStore = () => inject(GST_STORE);
const provideGSTStore = () => ({
    provide: GST_STORE,
    useFactory: () => {
        const gstService = injectGSTService();
        const alertService = inject(FSW_ALERT_SERVICE_TOKEN);
        const destroyRef = inject(DestroyRef);
        // Private signals
        const periodicalSignal = signal('MONTHLY');
        const currentPeriodicalSignal = signal('MONTHLY');
        const gstIdSignal = signal(null);
        const gstRevenueMapSignal = signal(new Map());
        const itemsSignal = signal([]);
        const currentItemsSignal = signal([]);
        const monthsSignal = signal({
            gst_revenue: 0,
            standard_rated: 0,
            zero_rated: 0,
        });
        const loadingSignal = signal(false);
        const errorSignal = signal(null);
        const applicationIdSignal = signal(null);
        // Helper function to handle observables with proper takeUntilDestroyed
        function handleApiCall(observable) {
            return observable
                .pipe(catchError$1((error) => {
                errorSignal.set(error.message);
                return EMPTY;
            }), takeUntilDestroyed(destroyRef))
                .toPromise();
        }
        // Computed signals
        const totalsSignal = computed(() => ({
            gst_revenue: sumBy(currentItemsSignal(), 'gst_revenue'),
            standard_rated: sumBy(currentItemsSignal(), 'standard_rated'),
            zero_rated: sumBy(currentItemsSignal(), 'zero_rated'),
        }));
        const averageMonthlySignal = computed(() => {
            const currentTotals = totalsSignal();
            const months = monthsSignal();
            return {
                gst_revenue: months.gst_revenue ? currentTotals.gst_revenue / months.gst_revenue : 0,
                standard_rated: months.standard_rated
                    ? currentTotals.standard_rated / months.standard_rated
                    : 0,
                zero_rated: months.zero_rated ? currentTotals.zero_rated / months.zero_rated : 0,
            };
        });
        // Setup error handling effect
        effect(() => {
            const error = errorSignal();
            if (error) {
                alertService.error(error);
            }
        });
        // Helper functions
        function createEmptyGSTItem() {
            return {
                start_at: '',
                end_at: '',
                gst_revenue: 0,
                standard_rated: 0,
                zero_rated: 0,
            };
        }
        function formatMonthYear(date) {
            const d = new Date(date);
            return `${String(d.getMonth() + 1).padStart(2, '0')}-${d.getFullYear()}`;
        }
        function addMonths(date, months) {
            const newDate = new Date(date);
            newDate.setMonth(date.getMonth() + months);
            return newDate;
        }
        return {
            getPeriodicalSignal: () => periodicalSignal.asReadonly(),
            getCurrentPeriodicalSignal: () => currentPeriodicalSignal.asReadonly(),
            updateCurrentPeriodicalSignal: (type) => currentPeriodicalSignal.set(type),
            getGstIdSignal: () => gstIdSignal.asReadonly(),
            getGstRevenueMapSignal: () => gstRevenueMapSignal,
            getItemsSignal: () => itemsSignal.asReadonly(),
            getCurrentItemsSignal: () => currentItemsSignal.asReadonly(),
            updateCurrentItemsSignal: (items) => currentItemsSignal.set(items),
            getLoadingSignal: () => loadingSignal.asReadonly(),
            getApplicationIdSignal: () => applicationIdSignal.asReadonly(),
            getTotalsSignal: () => totalsSignal,
            getMonthsSignal: () => monthsSignal.asReadonly(),
            getAverageMonthlySignal: () => averageMonthlySignal,
            async loadGSTId(applicationId) {
                applicationIdSignal.set(applicationId);
                loadingSignal.set(true);
                errorSignal.set(null);
                try {
                    const gstId = await handleApiCall(gstService.getGstIdFromApplication(applicationId));
                    if (gstId) {
                        await this.loadGSTData(gstId);
                        gstIdSignal.set(gstId);
                    }
                    else {
                        itemsSignal.set([
                            {
                                start_at: '',
                                end_at: '',
                                gst_revenue: 0,
                                standard_rated: 0,
                                zero_rated: 0,
                            },
                        ]);
                        periodicalSignal.set('CUSTOM');
                    }
                }
                finally {
                    loadingSignal.set(false);
                }
            },
            async loadGSTData(gstId) {
                loadingSignal.set(true);
                errorSignal.set(null);
                try {
                    const data = await handleApiCall(gstService.getGSTById(gstId));
                    if (data) {
                        // if (gstIdSignal() !== data.id) {
                        // }
                        if (periodicalSignal() !== data.period_type) {
                            periodicalSignal.set(data.period_type);
                            currentPeriodicalSignal.set(data.period_type);
                        }
                        itemsSignal.set(data.details);
                        currentItemsSignal.set(data.details);
                        // this.calculateMonths();
                    }
                }
                finally {
                    loadingSignal.set(false);
                    // refreshSignal.set(true);
                }
            },
            // updateCurrentPeriodicalSignal(type: periodicalTypes): void {
            //   // periodicalSignal.set(type);
            //   // const newItems: GSTItem[] = [];
            //   // const count = type === 'QUARTER' ? 4 : type === 'MONTHLY' ? 12 : 1;
            //   // for (let i = 0; i < count; i++) {
            //   //   newItems.push(createEmptyGSTItem());
            //   // }
            //   // itemsSignal.set(newItems);
            // },
            addItem() {
                currentItemsSignal.update((items) => [...items, createEmptyGSTItem()]);
            },
            removeItem(index) {
                currentItemsSignal.update((items) => items.filter((_, i) => i !== index));
            },
            updateItem(index, item) {
                currentItemsSignal.update((items) => {
                    const newItems = [...items];
                    newItems[index] = { ...item };
                    return newItems;
                });
            },
            calculateMonths() {
                const items = currentItemsSignal();
                const monthSet = new Set();
                items.forEach((item) => {
                    if (currentPeriodicalSignal() === 'MONTHLY' &&
                        item.start_at &&
                        item.start_at !== '1-01') {
                        monthSet.add(formatMonthYear(item.start_at));
                    }
                    else if (item.start_at && item.end_at && item.start_at !== '1-01') {
                        let current = new Date(item.start_at);
                        const end = new Date(item.end_at);
                        while (current <= end) {
                            monthSet.add(formatMonthYear(current.toISOString()));
                            current = addMonths(current, 1);
                        }
                    }
                });
                const monthCount = monthSet.size;
                monthsSignal.set({
                    gst_revenue: monthCount,
                    standard_rated: monthCount,
                    zero_rated: monthCount,
                });
            },
            async saveGST(payload, gstId) {
                loadingSignal.set(true);
                errorSignal.set(null);
                try {
                    if (gstId) {
                        await handleApiCall(gstService.updateGstAsync(gstId, payload));
                        await this.loadGSTData(gstId);
                    }
                    else {
                        const data = (await handleApiCall(gstService.createGstAsync(payload)));
                        if (!data?.id) {
                            throw new Error('Failed to create GST ID');
                        }
                        const applicationId = applicationIdSignal();
                        if (!applicationId) {
                            throw new Error('Application ID is missing');
                        }
                        if (applicationId && data?.id) {
                            await handleApiCall(gstService.linkGstToApplication(applicationId, data.id));
                            // gstIdSignal.set(gstId);
                        }
                        // TODO: Link the new GST ID to the application
                        // await this.loadGSTId('applicationId');
                    }
                }
                finally {
                    loadingSignal.set(false);
                }
            },
        };
    },
    deps: [GST_SERVICE, FSW_ALERT_SERVICE_TOKEN, DestroyRef],
});

class FSWGstComponent {
    constructor() {
        this.applicationId = '';
        this.isReadonly = false;
        // @Output() deleteGST = new EventEmitter<number>();
        // Inject the GST store
        this.store = injectGSTStore();
        this.periodCtrl = new FormControl();
        // Access store signals
        this.items = this.store.getItemsSignal();
        this.currentItems = this.store.getCurrentItemsSignal();
        this.gstIdSignal = this.store.getGstIdSignal();
        this.totals = this.store.getTotalsSignal();
        this.months = this.store.getMonthsSignal();
        this.averageMonthly = this.store.getAverageMonthlySignal();
        this.periodSignal = this.store.getPeriodicalSignal();
        this._fb = inject(FormBuilder);
        this._alertService = inject(FSW_ALERT_SERVICE_TOKEN);
        // Component state
        this.periodicals = ['MONTHLY', 'QUARTER', 'CUSTOM'];
        this.hoveredIndex = null;
        this.parentFG = this._fb.group({
            MONTHLY: this._fb.group({
                periodical: ['MONTHLY'],
                items: this._fb.array([]),
            }),
            QUARTER: this._fb.group({
                periodical: ['QUARTER'],
                items: this._fb.array([]),
            }),
            CUSTOM: this._fb.group({
                periodical: ['CUSTOM'],
                items: this._fb.array([]),
            }),
        });
        this.form = this._fb.group({
            periodical: [],
            items: this._fb.array([]),
        });
        this.destroy$ = new Subject();
    }
    get itemsFormArray() {
        return this.form.get('items');
    }
    ngOnInit() {
        this._initData();
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    _initData() {
        if (this.applicationId) {
            this.store.loadGSTId(this.applicationId).then(() => {
                this._setupFormWithResponseData();
                this._listenToPeriodicalChanges();
            });
        }
    }
    _setupFormWithResponseData() {
        const items = [...this.items()];
        const period = this.periodSignal();
        this.parentFG.get(period)?.get('periodical')?.setValue(period, { emitEvent: false });
        const itemsFormArray = this.parentFG.get(period)?.get('items');
        items.forEach((item) => {
            itemsFormArray.push(this._fb.group({
                start_at: [this._reFormatDate(item.start_at)],
                end_at: [this._reFormatDate(item.end_at)],
                gst_revenue: [item.gst_revenue],
                standard_rated: [item.standard_rated],
                zero_rated: [item.zero_rated],
            }));
        });
        this._patchFormValues(period);
    }
    _patchFormValues(period) {
        const newFormValues = this.parentFG.get(period)?.value;
        this.form.reset();
        this.form.patchValue({
            periodical: newFormValues?.periodical,
        }, { emitEvent: false });
        this.periodCtrl.setValue(newFormValues?.periodical, { emitEvent: false });
        const formItemsFormArray = this.form.get('items');
        (newFormValues?.items).forEach((item) => {
            formItemsFormArray.push(this._fb.group({
                start_at: [item.start_at],
                end_at: [item.end_at],
                gst_revenue: [item.gst_revenue],
                standard_rated: [item.standard_rated],
                zero_rated: [item.zero_rated],
            }));
        });
        this.store.updateCurrentItemsSignal(this.form.value.items);
        this.store.calculateMonths();
    }
    _listenToPeriodicalChanges() {
        this.periodCtrl?.valueChanges
            .pipe(takeUntil$1(this.destroy$))
            .subscribe((period) => {
            if (!period) {
                throw new Error('Periodical is required');
            }
            this.store.updateCurrentPeriodicalSignal(period);
            this.form.get('periodical')?.setValue(period, { emitEvent: false });
            if (period !== this.periodSignal()) {
                this.onPeriodicalChange(period);
            }
            else {
                const items = this.items();
                const itemsFormArray = this.form.get('items');
                itemsFormArray.clear();
                (items || []).forEach((item) => {
                    itemsFormArray.push(this._fb.group({
                        start_at: [this._reFormatDate(item.start_at)],
                        end_at: [this._reFormatDate(item.end_at)],
                        gst_revenue: [item.gst_revenue],
                        standard_rated: [item.standard_rated],
                        zero_rated: [item.zero_rated],
                    }));
                });
                this.store.updateCurrentItemsSignal(this.form.value.items);
                this.store.calculateMonths();
            }
        });
        this.form
            ?.get('items')
            ?.valueChanges.pipe(takeUntil$1(this.destroy$))
            .subscribe((currentItems) => {
            this.store.updateCurrentItemsSignal(currentItems);
        });
    }
    createItemFormGroup(item) {
        return this._fb.group({
            start_at: [this._reFormatDate(item?.start_at)],
            end_at: [this._reFormatDate(item?.end_at)],
            gst_revenue: [item?.gst_revenue],
            standard_rated: [item?.standard_rated],
            zero_rated: [item?.zero_rated],
        });
    }
    onPeriodicalChange(period) {
        let newItemsCount;
        switch (period) {
            case 'QUARTER':
                newItemsCount = 4;
                break;
            case 'CUSTOM':
                newItemsCount = 1; // Math.max(currentItems.length, 1);
                break;
            default: // MONTHLY
                newItemsCount = 12;
                break;
        }
        // Clear existing items and create new ones
        const itemsFormArrayParent = this.parentFG.get(period)?.get('items');
        const itemsFormArray = this.form.get('items');
        itemsFormArray.clear();
        for (let i = 0; i < newItemsCount; i++) {
            const emptyItem = {
                start_at: '',
                end_at: '',
                gst_revenue: 0,
                standard_rated: 0,
                zero_rated: 0,
            };
            itemsFormArray.push(this.createItemFormGroup(emptyItem));
            itemsFormArrayParent.push(this.createItemFormGroup(emptyItem));
        }
        this.parentFG.get(period)?.get('periodical')?.setValue(period, { emitEvent: false });
        this.store.updateCurrentItemsSignal(this.form.value.items);
        this.store.calculateMonths();
        // this.store.setPeriodical(period);
    }
    onChangeDate(index) {
        const formGroup = this.itemsFormArray.at(index);
        const item = formGroup.value;
        this.store.updateItem(index, item);
        this.store.updateCurrentItemsSignal(this.form.value.items);
        this.store.calculateMonths();
    }
    onClickAddGSTPeriod() {
        const emptyItem = {
            start_at: '',
            end_at: '',
            gst_revenue: 0,
            standard_rated: 0,
            zero_rated: 0,
        };
        if (this.itemsFormArray.length < 12) {
            this.itemsFormArray.push(this.createItemFormGroup(emptyItem));
            this.store.updateCurrentItemsSignal([...this.form.value.items, emptyItem]);
            this.store.calculateMonths();
        }
        else {
            const errMsg = 'Cannot add more than 12 items';
            this._alertService.error('Error', errMsg, {
                duration: 2000,
            });
        }
    }
    onDeleteGst(index) {
        // const item = this.items()[index];
        // if (item.id) {
        //   this.deleteGST.emit(item.id);
        // }
        this.itemsFormArray.removeAt(index);
        this.store.removeItem(index);
        this.store.updateCurrentItemsSignal(this.form.value.items);
        this.store.calculateMonths();
        // this.store.deleteGST(gstId).then(() => {
        //   // Handle success - maybe refresh the list or show a success message
        //   this.store.loadGSTData(gstId);
        // });
    }
    async onSave() {
        if (this.form.value.periodical === 'CUSTOM' && !this.form?.value?.items?.length) {
            this._alertService.error('Error', 'Please add at least one item', {
                duration: 2000,
            });
            return;
        }
        if (this.form.valid) {
            // Check date validations
            if (this.form.get('periodical')?.value !== 'MONTHLY') {
                const hasInvalidDates = (this.itemsFormArray?.value || []).some((item) => {
                    if (!item.start_at || !item.end_at)
                        return false;
                    const startDate = new Date(this._formatDate(item.start_at, 'start'));
                    const endDate = new Date(this._formatDate(item.end_at, 'end'));
                    return startDate > endDate;
                });
                if (hasInvalidDates) {
                    this._alertService.error('Error', 'Start date cannot be greater than end date', {
                        duration: 2000,
                    });
                    return;
                }
            }
            const payload = {
                period_type: this.form.get('periodical')?.value,
                details: (this.itemsFormArray?.value || []).map((item) => ({
                    ...item,
                    start_at: this._formatDate(item?.start_at, 'start'),
                    end_at: this._formatDate(item?.end_at, 'end'),
                })),
            };
            await this.store.saveGST(payload, this.gstIdSignal());
        }
    }
    _formatDate(date, type) {
        if (!date || date === '1-01')
            return '0001-01-01T00:00:00Z';
        const d = new Date(date);
        if (type === 'start') {
            return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-01T00:00:00Z`;
        }
        else {
            const lastDay = new Date(d.getUTCFullYear(), d.getUTCMonth() + 1, 0).getDate();
            return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${lastDay}T23:59:59Z`;
        }
    }
    _reFormatDate(date) {
        if (!date)
            return '';
        const d = new Date(date);
        return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWGstComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWGstComponent, isStandalone: true, selector: "fsw-gst", inputs: { applicationId: "applicationId", isReadonly: "isReadonly" }, providers: [provideGSTService(), provideGSTStore()], ngImport: i0, template: "<!-- GST Component -->\n<div class=\"gst-container max-w-4xl\">\n  <div class=\"header\">\n    <h6>GST Revenue</h6>\n    <button\n      class=\"px-3 py-1\"\n      fswButton\n      appearance=\"secondary\"\n      [size]=\"'s'\"\n      (click)=\"onSave()\"\n      [disabled]=\"form.invalid || isReadonly\"\n    >\n      Save Changes\n    </button>\n  </div>\n\n  <div class=\"content\">\n    <div class=\"w-[150px] flex-1\">\n      <fsw-select [formControl]=\"periodCtrl\" [maxHeight]=\"'200px'\">\n        <ng-container *ngFor=\"let period of periodicals\">\n          <ng-template\n            fswSelectItem\n            let-selected\n            [text]=\"period | titlecase\"\n            [value]=\"period\"\n          ></ng-template>\n        </ng-container>\n      </fsw-select>\n    </div>\n    <form [formGroup]=\"form\" class=\"w-full\">\n      <div class=\"overflow-x-auto\">\n        <table class=\"w-full\">\n          <thead>\n            <tr>\n              <th class=\"w-[150px]\">\n                {{ form.get('periodical')?.value | titlecase }}\n              </th>\n              <th class=\"w-[22%]\">GST Revenue</th>\n              <th class=\"w-[22%]\">Standard Rated</th>\n              <th class=\"w-[22%]\">Zero Rated</th>\n              <th class=\"w-[40px]\"></th>\n            </tr>\n          </thead>\n\n          <tbody formArrayName=\"items\">\n            <ng-container *ngFor=\"let item of itemsFormArray.controls; let i = index\">\n              <tr\n                [formGroupName]=\"i\"\n                class=\"hover:bg-gray-50\"\n                (mouseenter)=\"hoveredIndex = i\"\n                (mouseleave)=\"hoveredIndex = null\"\n                (click)=\"hoveredIndex = null\"\n              >\n                <!-- Date Input Column -->\n                <td>\n                  <ng-container [ngSwitch]=\"form.get('periodical')?.value\">\n                    <!-- Monthly View -->\n                    <ng-container *ngSwitchCase=\"'MONTHLY'\">\n                      <div class=\"form-group\">\n                        <input\n                          type=\"month\"\n                          class=\"w-full\"\n                          formControlName=\"start_at\"\n                          (change)=\"onChangeDate(i)\"\n                        />\n                      </div>\n                    </ng-container>\n\n                    <!-- Other Views (Quarter/Custom) -->\n                    <ng-container *ngSwitchDefault>\n                      <div\n                        class=\"form-group flex flex-col gap-1\"\n                        [class.error]=\"\n                          item.get('start_at')?.invalid &&\n                          item.get('start_at')?.touched &&\n                          item.get('end_at')?.touched\n                        \"\n                      >\n                        <input\n                          type=\"month\"\n                          class=\"w-full\"\n                          formControlName=\"start_at\"\n                          (change)=\"onChangeDate(i)\"\n                        />\n                        <input\n                          type=\"month\"\n                          class=\"w-full\"\n                          formControlName=\"end_at\"\n                          (change)=\"onChangeDate(i)\"\n                        />\n                      </div>\n                    </ng-container>\n                  </ng-container>\n                </td>\n\n                <!-- GST Revenue Input -->\n                <td>\n                  <div class=\"form-group\">\n                    <input\n                      type=\"number\"\n                      class=\"w-full text-right\"\n                      fswCurrencyMask\n                      [options]=\"{ prefix: '', allowNegative: false, align: 'right' }\"\n                      type=\"text\"\n                      formControlName=\"gst_revenue\"\n                    />\n                  </div>\n                </td>\n\n                <!-- Standard Rated Input -->\n                <td>\n                  <div class=\"form-group\">\n                    <input\n                      type=\"number\"\n                      class=\"w-full text-right\"\n                      fswCurrencyMask\n                      [options]=\"{ prefix: '', allowNegative: false, align: 'right' }\"\n                      type=\"text\"\n                      formControlName=\"standard_rated\"\n                    />\n                  </div>\n                </td>\n\n                <!-- Zero Rated Input -->\n                <td>\n                  <div class=\"form-group\">\n                    <input\n                      type=\"number\"\n                      class=\"w-full text-right\"\n                      fswCurrencyMask\n                      [options]=\"{ prefix: '', allowNegative: false, align: 'right' }\"\n                      type=\"text\"\n                      formControlName=\"zero_rated\"\n                    />\n                  </div>\n                </td>\n\n                <!-- Delete Button -->\n                <td class=\"text-center\">\n                  <div\n                    *ngIf=\"hoveredIndex === i && form.get('periodical')?.value === 'CUSTOM'\"\n                    (click)=\"onDeleteGst(i)\"\n                    class=\"hover:cursor-pointer delete-button\"\n                  >\n                    <i [fontSize]=\"'14px'\" [fswIcon]=\"'common-delete'\"></i>\n                  </div>\n                </td>\n              </tr>\n            </ng-container>\n\n            <!-- Add GST Period button for CUSTOM periodical -->\n            <tr *ngIf=\"form.get('periodical')?.value === 'CUSTOM'\">\n              <td colspan=\"5\" class=\"py-1\">\n                <button\n                  type=\"button\"\n                  class=\"px-3 py-1\"\n                  fswButton\n                  appearance=\"secondary\"\n                  [size]=\"'s'\"\n                  (click)=\"onClickAddGSTPeriod()\"\n                >\n                  Add GST Revenue Period\n                </button>\n              </td>\n            </tr>\n\n            <!-- Summary Rows -->\n            <tr class=\"summary-row\">\n              <td>Total</td>\n              <td>{{ totals()?.gst_revenue | number : '1.2-2' }}</td>\n              <td>{{ totals()?.standard_rated | number : '1.2-2' }}</td>\n              <td>{{ totals()?.zero_rated | number : '1.2-2' }}</td>\n              <td></td>\n            </tr>\n\n            <tr class=\"summary-row\">\n              <td>Months</td>\n              <td>{{ months()?.gst_revenue }}</td>\n              <td>{{ months()?.standard_rated }}</td>\n              <td>{{ months()?.zero_rated }}</td>\n              <td></td>\n            </tr>\n\n            <tr class=\"summary-row\">\n              <td>Average Monthly</td>\n              <td>{{ averageMonthly()?.gst_revenue | number : '1.2-2' }}</td>\n              <td>{{ averageMonthly()?.standard_rated | number : '1.2-2' }}</td>\n              <td>{{ averageMonthly()?.zero_rated | number : '1.2-2' }}</td>\n              <td></td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n    </form>\n  </div>\n</div>\n", styles: [".gst-container table,.bank-tabulation-container .summary-table-wrapper .summary-table{width:100%;border-collapse:separate;border-spacing:0;border:1px solid #e5e7eb;border-radius:.5rem;overflow:hidden}.gst-container table th,.bank-tabulation-container .summary-table-wrapper .summary-table th,.gst-container table td,.bank-tabulation-container .summary-table-wrapper .summary-table td{padding:1rem;vertical-align:middle;border-bottom:1px solid #e5e7eb}.gst-container table th:not(:last-child),.bank-tabulation-container .summary-table-wrapper .summary-table th:not(:last-child),.gst-container table td:not(:last-child),.bank-tabulation-container .summary-table-wrapper .summary-table td:not(:last-child){border-right:1px solid #e5e7eb}.bank-tabulation-container{padding:1.5rem;background-color:#fff;border-radius:.75rem;box-shadow:0 1px 3px #0000001a}.bank-tabulation-container header{margin-bottom:2rem}.bank-tabulation-container header h6{font-size:1.8rem;font-weight:600;color:#1f2937;margin:0}.bank-tabulation-container .currency-selector{margin-bottom:1.5rem}.bank-tabulation-container .currency-selector label{color:#1f2937;font-weight:500}.bank-tabulation-container .summary-table-wrapper{overflow-x:auto;margin:0 -1.5rem;padding:0 1.5rem}.bank-tabulation-container .summary-table-wrapper .summary-table{min-width:1200px}.bank-tabulation-container .summary-table-wrapper .summary-table th{background-color:#f8fafc;font-weight:600;color:#1f2937;white-space:nowrap;position:sticky;top:0;z-index:10}.bank-tabulation-container .summary-table-wrapper .summary-table th.numeric{text-align:right}.bank-tabulation-container .summary-table-wrapper .summary-table td{color:#4b5563;font-size:.875rem}.bank-tabulation-container .summary-table-wrapper .summary-table td.numeric-value{text-align:right;white-space:nowrap}.bank-tabulation-container .summary-table-wrapper .summary-table td.numeric-value .main-value{font-weight:500}.bank-tabulation-container .summary-table-wrapper .summary-table td.numeric-value .conversion-rate{margin-top:.25rem;font-size:.75rem;color:#4b5563;background-color:#f3f4f6;padding:.125rem .375rem;border-radius:.25rem;display:inline-block}.bank-tabulation-container .summary-table-wrapper .summary-table tr:hover:not(.summary){background-color:#f3f4f6}.bank-tabulation-container .summary-table-wrapper .summary-table tr.summary{background-color:#eff6ff;font-weight:600}.bank-tabulation-container .summary-table-wrapper .summary-table tr.summary td{color:#1f2937}.gst-container{background-color:#fff;border-radius:.75rem;box-shadow:0 1px 3px #0000001a;width:70%;min-width:700px}.gst-container .header{padding:1rem 1.5rem;border-bottom:1px solid #e5e7eb;display:flex;justify-content:space-between;align-items:center}.gst-container .header h5{font-size:1.125rem;font-weight:600;color:#1f2937;margin:0}.gst-container .content{padding:1.5rem}.gst-container table th{background-color:#f8fafc;font-weight:600;font-size:1.4rem;color:#1f2937;white-space:nowrap;padding:.75rem 1rem}.gst-container table th:first-child{border-top-left-radius:.5rem}.gst-container table th:last-child{border-top-right-radius:.5rem}.gst-container table td{padding:.75rem 1rem}.gst-container table td .form-group input{width:100%;padding:.5rem .75rem;border:1px solid #d1d5db;border-radius:.375rem;font-size:1.4rem;transition:border-color .15s ease-in-out}.gst-container table td .form-group input:focus{outline:none;border-color:#60a5fa;box-shadow:0 0 0 2px #60a5fa1a}.gst-container table td .form-group input[type=month]{color:#1f2937}.gst-container table td .form-group input[type=text]{text-align:right}.gst-container table td .form-group.error input{border-color:#ef4444}.gst-container table tr.totals-row,.gst-container table tr.months-row{background-color:#f9fafb}.gst-container table tr.totals-row td,.gst-container table tr.months-row td{font-weight:500;text-align:right}.gst-container table tr.totals-row td:first-child,.gst-container table tr.months-row td:first-child{text-align:left}.gst-container table tr.average-monthly-row{background-color:#eff6ff}.gst-container table tr.average-monthly-row td{font-weight:600;text-align:right;color:#1e40af}.gst-container table tr.average-monthly-row td:first-child{text-align:left}.gst-container table tr:hover:not(.totals-row):not(.months-row):not(.average-monthly-row){background-color:#f3f4f6}.gst-container table tr:hover:not(.totals-row):not(.months-row):not(.average-monthly-row) .delete-button{opacity:1}.gst-container table .delete-button{opacity:0;transition:opacity .2s ease-in-out;color:#ef4444}.gst-container table .delete-button:hover{color:#dc2626}.gst-container .add-period-button{margin-top:1rem;padding:.5rem 1rem;color:#1e40af;border:1px solid currentColor;border-radius:.375rem;font-size:.875rem;font-weight:500;transition:all .2s ease-in-out}.gst-container .add-period-button:hover{background-color:#1e40af0d}@media (max-width: 1024px){.bank-tabulation-container,.gst-container,.bank-tabulation-container .header,.gst-container .header,.bank-tabulation-container .content,.gst-container .content{padding:1rem}table{font-size:.875rem}table th,table td{padding:.75rem}}.empty-state{background-color:#dbeafe;border-radius:.5rem;padding:1.5rem;text-align:center}.empty-state p{color:#1e40af;margin:.5rem 0;font-size:.875rem;line-height:1.5}.summary-row{background-color:#f3f5fd}.summary-row td{text-align:right}.summary-row td:first-child{text-align:left}\n"], dependencies: [{ kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: i2.FormGroupName, selector: "[formGroupName]", inputs: ["formGroupName"] }, { kind: "directive", type: i2.FormArrayName, selector: "[formArrayName]", inputs: ["formArrayName"] }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "pipe", type: DecimalPipe, name: "number" }, { kind: "pipe", type: TitleCasePipe, name: "titlecase" }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "ngmodule", type: FSWCurrencyMaskModule }, { kind: "directive", type: CurrencyMaskDirective, selector: "[fswCurrencyMask]", inputs: ["max", "min", "options"] }, { kind: "ngmodule", type: FSWSelectModule }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: UtilsServiceModule }, { kind: "ngmodule", type: FSWAlertModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWGstComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-gst', standalone: true, changeDetection: ChangeDetectionStrategy.OnPush, providers: [provideGSTService(), provideGSTStore()], imports: [
                        ReactiveFormsModule,
                        NgForOf,
                        NgIf,
                        NgSwitch,
                        NgSwitchCase,
                        NgSwitchDefault,
                        DecimalPipe,
                        TitleCasePipe,
                        FSWIconModule,
                        FSWCurrencyMaskModule,
                        FSWSelectModule,
                        FSWButtonModule,
                        UtilsServiceModule,
                        FSWAlertModule,
                    ], template: "<!-- GST Component -->\n<div class=\"gst-container max-w-4xl\">\n  <div class=\"header\">\n    <h6>GST Revenue</h6>\n    <button\n      class=\"px-3 py-1\"\n      fswButton\n      appearance=\"secondary\"\n      [size]=\"'s'\"\n      (click)=\"onSave()\"\n      [disabled]=\"form.invalid || isReadonly\"\n    >\n      Save Changes\n    </button>\n  </div>\n\n  <div class=\"content\">\n    <div class=\"w-[150px] flex-1\">\n      <fsw-select [formControl]=\"periodCtrl\" [maxHeight]=\"'200px'\">\n        <ng-container *ngFor=\"let period of periodicals\">\n          <ng-template\n            fswSelectItem\n            let-selected\n            [text]=\"period | titlecase\"\n            [value]=\"period\"\n          ></ng-template>\n        </ng-container>\n      </fsw-select>\n    </div>\n    <form [formGroup]=\"form\" class=\"w-full\">\n      <div class=\"overflow-x-auto\">\n        <table class=\"w-full\">\n          <thead>\n            <tr>\n              <th class=\"w-[150px]\">\n                {{ form.get('periodical')?.value | titlecase }}\n              </th>\n              <th class=\"w-[22%]\">GST Revenue</th>\n              <th class=\"w-[22%]\">Standard Rated</th>\n              <th class=\"w-[22%]\">Zero Rated</th>\n              <th class=\"w-[40px]\"></th>\n            </tr>\n          </thead>\n\n          <tbody formArrayName=\"items\">\n            <ng-container *ngFor=\"let item of itemsFormArray.controls; let i = index\">\n              <tr\n                [formGroupName]=\"i\"\n                class=\"hover:bg-gray-50\"\n                (mouseenter)=\"hoveredIndex = i\"\n                (mouseleave)=\"hoveredIndex = null\"\n                (click)=\"hoveredIndex = null\"\n              >\n                <!-- Date Input Column -->\n                <td>\n                  <ng-container [ngSwitch]=\"form.get('periodical')?.value\">\n                    <!-- Monthly View -->\n                    <ng-container *ngSwitchCase=\"'MONTHLY'\">\n                      <div class=\"form-group\">\n                        <input\n                          type=\"month\"\n                          class=\"w-full\"\n                          formControlName=\"start_at\"\n                          (change)=\"onChangeDate(i)\"\n                        />\n                      </div>\n                    </ng-container>\n\n                    <!-- Other Views (Quarter/Custom) -->\n                    <ng-container *ngSwitchDefault>\n                      <div\n                        class=\"form-group flex flex-col gap-1\"\n                        [class.error]=\"\n                          item.get('start_at')?.invalid &&\n                          item.get('start_at')?.touched &&\n                          item.get('end_at')?.touched\n                        \"\n                      >\n                        <input\n                          type=\"month\"\n                          class=\"w-full\"\n                          formControlName=\"start_at\"\n                          (change)=\"onChangeDate(i)\"\n                        />\n                        <input\n                          type=\"month\"\n                          class=\"w-full\"\n                          formControlName=\"end_at\"\n                          (change)=\"onChangeDate(i)\"\n                        />\n                      </div>\n                    </ng-container>\n                  </ng-container>\n                </td>\n\n                <!-- GST Revenue Input -->\n                <td>\n                  <div class=\"form-group\">\n                    <input\n                      type=\"number\"\n                      class=\"w-full text-right\"\n                      fswCurrencyMask\n                      [options]=\"{ prefix: '', allowNegative: false, align: 'right' }\"\n                      type=\"text\"\n                      formControlName=\"gst_revenue\"\n                    />\n                  </div>\n                </td>\n\n                <!-- Standard Rated Input -->\n                <td>\n                  <div class=\"form-group\">\n                    <input\n                      type=\"number\"\n                      class=\"w-full text-right\"\n                      fswCurrencyMask\n                      [options]=\"{ prefix: '', allowNegative: false, align: 'right' }\"\n                      type=\"text\"\n                      formControlName=\"standard_rated\"\n                    />\n                  </div>\n                </td>\n\n                <!-- Zero Rated Input -->\n                <td>\n                  <div class=\"form-group\">\n                    <input\n                      type=\"number\"\n                      class=\"w-full text-right\"\n                      fswCurrencyMask\n                      [options]=\"{ prefix: '', allowNegative: false, align: 'right' }\"\n                      type=\"text\"\n                      formControlName=\"zero_rated\"\n                    />\n                  </div>\n                </td>\n\n                <!-- Delete Button -->\n                <td class=\"text-center\">\n                  <div\n                    *ngIf=\"hoveredIndex === i && form.get('periodical')?.value === 'CUSTOM'\"\n                    (click)=\"onDeleteGst(i)\"\n                    class=\"hover:cursor-pointer delete-button\"\n                  >\n                    <i [fontSize]=\"'14px'\" [fswIcon]=\"'common-delete'\"></i>\n                  </div>\n                </td>\n              </tr>\n            </ng-container>\n\n            <!-- Add GST Period button for CUSTOM periodical -->\n            <tr *ngIf=\"form.get('periodical')?.value === 'CUSTOM'\">\n              <td colspan=\"5\" class=\"py-1\">\n                <button\n                  type=\"button\"\n                  class=\"px-3 py-1\"\n                  fswButton\n                  appearance=\"secondary\"\n                  [size]=\"'s'\"\n                  (click)=\"onClickAddGSTPeriod()\"\n                >\n                  Add GST Revenue Period\n                </button>\n              </td>\n            </tr>\n\n            <!-- Summary Rows -->\n            <tr class=\"summary-row\">\n              <td>Total</td>\n              <td>{{ totals()?.gst_revenue | number : '1.2-2' }}</td>\n              <td>{{ totals()?.standard_rated | number : '1.2-2' }}</td>\n              <td>{{ totals()?.zero_rated | number : '1.2-2' }}</td>\n              <td></td>\n            </tr>\n\n            <tr class=\"summary-row\">\n              <td>Months</td>\n              <td>{{ months()?.gst_revenue }}</td>\n              <td>{{ months()?.standard_rated }}</td>\n              <td>{{ months()?.zero_rated }}</td>\n              <td></td>\n            </tr>\n\n            <tr class=\"summary-row\">\n              <td>Average Monthly</td>\n              <td>{{ averageMonthly()?.gst_revenue | number : '1.2-2' }}</td>\n              <td>{{ averageMonthly()?.standard_rated | number : '1.2-2' }}</td>\n              <td>{{ averageMonthly()?.zero_rated | number : '1.2-2' }}</td>\n              <td></td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n    </form>\n  </div>\n</div>\n", styles: [".gst-container table,.bank-tabulation-container .summary-table-wrapper .summary-table{width:100%;border-collapse:separate;border-spacing:0;border:1px solid #e5e7eb;border-radius:.5rem;overflow:hidden}.gst-container table th,.bank-tabulation-container .summary-table-wrapper .summary-table th,.gst-container table td,.bank-tabulation-container .summary-table-wrapper .summary-table td{padding:1rem;vertical-align:middle;border-bottom:1px solid #e5e7eb}.gst-container table th:not(:last-child),.bank-tabulation-container .summary-table-wrapper .summary-table th:not(:last-child),.gst-container table td:not(:last-child),.bank-tabulation-container .summary-table-wrapper .summary-table td:not(:last-child){border-right:1px solid #e5e7eb}.bank-tabulation-container{padding:1.5rem;background-color:#fff;border-radius:.75rem;box-shadow:0 1px 3px #0000001a}.bank-tabulation-container header{margin-bottom:2rem}.bank-tabulation-container header h6{font-size:1.8rem;font-weight:600;color:#1f2937;margin:0}.bank-tabulation-container .currency-selector{margin-bottom:1.5rem}.bank-tabulation-container .currency-selector label{color:#1f2937;font-weight:500}.bank-tabulation-container .summary-table-wrapper{overflow-x:auto;margin:0 -1.5rem;padding:0 1.5rem}.bank-tabulation-container .summary-table-wrapper .summary-table{min-width:1200px}.bank-tabulation-container .summary-table-wrapper .summary-table th{background-color:#f8fafc;font-weight:600;color:#1f2937;white-space:nowrap;position:sticky;top:0;z-index:10}.bank-tabulation-container .summary-table-wrapper .summary-table th.numeric{text-align:right}.bank-tabulation-container .summary-table-wrapper .summary-table td{color:#4b5563;font-size:.875rem}.bank-tabulation-container .summary-table-wrapper .summary-table td.numeric-value{text-align:right;white-space:nowrap}.bank-tabulation-container .summary-table-wrapper .summary-table td.numeric-value .main-value{font-weight:500}.bank-tabulation-container .summary-table-wrapper .summary-table td.numeric-value .conversion-rate{margin-top:.25rem;font-size:.75rem;color:#4b5563;background-color:#f3f4f6;padding:.125rem .375rem;border-radius:.25rem;display:inline-block}.bank-tabulation-container .summary-table-wrapper .summary-table tr:hover:not(.summary){background-color:#f3f4f6}.bank-tabulation-container .summary-table-wrapper .summary-table tr.summary{background-color:#eff6ff;font-weight:600}.bank-tabulation-container .summary-table-wrapper .summary-table tr.summary td{color:#1f2937}.gst-container{background-color:#fff;border-radius:.75rem;box-shadow:0 1px 3px #0000001a;width:70%;min-width:700px}.gst-container .header{padding:1rem 1.5rem;border-bottom:1px solid #e5e7eb;display:flex;justify-content:space-between;align-items:center}.gst-container .header h5{font-size:1.125rem;font-weight:600;color:#1f2937;margin:0}.gst-container .content{padding:1.5rem}.gst-container table th{background-color:#f8fafc;font-weight:600;font-size:1.4rem;color:#1f2937;white-space:nowrap;padding:.75rem 1rem}.gst-container table th:first-child{border-top-left-radius:.5rem}.gst-container table th:last-child{border-top-right-radius:.5rem}.gst-container table td{padding:.75rem 1rem}.gst-container table td .form-group input{width:100%;padding:.5rem .75rem;border:1px solid #d1d5db;border-radius:.375rem;font-size:1.4rem;transition:border-color .15s ease-in-out}.gst-container table td .form-group input:focus{outline:none;border-color:#60a5fa;box-shadow:0 0 0 2px #60a5fa1a}.gst-container table td .form-group input[type=month]{color:#1f2937}.gst-container table td .form-group input[type=text]{text-align:right}.gst-container table td .form-group.error input{border-color:#ef4444}.gst-container table tr.totals-row,.gst-container table tr.months-row{background-color:#f9fafb}.gst-container table tr.totals-row td,.gst-container table tr.months-row td{font-weight:500;text-align:right}.gst-container table tr.totals-row td:first-child,.gst-container table tr.months-row td:first-child{text-align:left}.gst-container table tr.average-monthly-row{background-color:#eff6ff}.gst-container table tr.average-monthly-row td{font-weight:600;text-align:right;color:#1e40af}.gst-container table tr.average-monthly-row td:first-child{text-align:left}.gst-container table tr:hover:not(.totals-row):not(.months-row):not(.average-monthly-row){background-color:#f3f4f6}.gst-container table tr:hover:not(.totals-row):not(.months-row):not(.average-monthly-row) .delete-button{opacity:1}.gst-container table .delete-button{opacity:0;transition:opacity .2s ease-in-out;color:#ef4444}.gst-container table .delete-button:hover{color:#dc2626}.gst-container .add-period-button{margin-top:1rem;padding:.5rem 1rem;color:#1e40af;border:1px solid currentColor;border-radius:.375rem;font-size:.875rem;font-weight:500;transition:all .2s ease-in-out}.gst-container .add-period-button:hover{background-color:#1e40af0d}@media (max-width: 1024px){.bank-tabulation-container,.gst-container,.bank-tabulation-container .header,.gst-container .header,.bank-tabulation-container .content,.gst-container .content{padding:1rem}table{font-size:.875rem}table th,table td{padding:.75rem}}.empty-state{background-color:#dbeafe;border-radius:.5rem;padding:1.5rem;text-align:center}.empty-state p{color:#1e40af;margin:.5rem 0;font-size:.875rem;line-height:1.5}.summary-row{background-color:#f3f5fd}.summary-row td{text-align:right}.summary-row td:first-child{text-align:left}\n"] }]
        }], propDecorators: { applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

// @angular
class FSWBankTabulationsComponent {
    get applicationId() {
        return this._componentStore.state().applicationId || '';
    }
    set isReadonly(value) {
        this._isReadonly = value;
    }
    get isReadonly() {
        return this._isReadonly;
    }
    set showGST(value) {
        this._showGST = value;
    }
    get showGST() {
        return this._showGST;
    }
    set viewDocs(value) {
        this._viewDocs = value;
    }
    get viewDocs() {
        return this._viewDocs;
    }
    constructor(_componentStore, _translateService, _scope, _cdr, _fb) {
        this._componentStore = _componentStore;
        this._translateService = _translateService;
        this._scope = _scope;
        this._cdr = _cdr;
        this._fb = _fb;
        this._isReadonly = true;
        this._showGST = false;
        this._viewDocs = false;
        this._destroySubject = new Subject();
        this.bankAccountsWithStatementsMap = {};
        this.selectedBankAccountStatements = [];
        this.bankAnalysisReportMap = {};
        this.bankAccountAnalysisReports = [];
        this.selectedBankAnalysisReport = null;
        this.translate$ = this._translateService.selectFeatureTranslate(this._scope, 'bank_tabulations');
        this.isOverdraftLimitDisabled = true;
        this.countryCode = getCountryCodeFromStorage();
        this.destroyWhen$ = new Subject();
        this.docViewerService = injectFSWDocViewerService();
        this._componentStore.state$.subscribe((state) => {
            this.bankAccountsWithStatementsMap = { ...state.bankAccountsWithStatementsMap };
            this.bankAnalysisReportMap = { ...state.bankAnalysisReportMap };
            this.bankAccountAnalysisReports = sortBankAccounts(Object.values(this.bankAnalysisReportMap));
            const acc = this.tabulationDetailFG?.value?.account_number;
            this.selectedBankAnalysisReport = {
                ...this.bankAnalysisReportMap[acc],
            };
            if (state.isBankAnalysisReportsUpdated) {
                this.bankTabulationDetailComp.showEditModeFlag = false;
                this.isOverdraftLimitDisabled = true;
            }
        });
        this.tabulationDetailFG = initFG$1(this._fb);
        if (this.isOverdraftLimitDisabled) {
            this.tabulationDetailFG.get('overdraft_limit')?.disable();
        }
        this._componentStore.state$
            .pipe(map((state) => state.bankAnalysisReportMap), takeUntil(this._destroySubject))
            .subscribe((res) => {
            if (!res)
                return;
            this.bankAnalysisReportMap = { ...res };
            this.bankAccountAnalysisReports = Object.values(this.bankAnalysisReportMap);
        });
        this.tabulationDetailFG
            .get('account_number')
            ?.valueChanges.pipe(takeUntil(this._destroySubject))
            .subscribe((res) => {
            this.selectedBankAccountStatements =
                this.bankAccountsWithStatementsMap[res]?.statements || [];
            this.tabulationDetailFG
                .get('overdraft_limit')
                ?.patchValue(this.bankAnalysisReportMap[res]?.overdraft_limit, { emitEvent: false });
            this.tabulationDetailFG
                .get('is_included')
                ?.patchValue(this.bankAnalysisReportMap[res]?.is_included, { emitEvent: false });
            this.selectedBankAnalysisReport = { ...this.bankAnalysisReportMap[res] };
            this._cdr.detectChanges();
        });
    }
    ngOnDestroy() {
        this._destroySubject.next();
        this._destroySubject.complete();
    }
    onSaveOverdraft() {
        const payload = {
            overdraft_limit: Number(this.tabulationDetailFG.get('overdraft_limit')?.value),
        };
        this._componentStore.updateBankAnalysisReport({
            bankAccountId: this.selectedBankAnalysisReport?.account_id,
            payload,
        });
    }
    addToSummary() {
        const val = this.tabulationDetailFG.get('is_included')?.value;
        this._componentStore.updateBankAnalysisReport({
            bankAccountId: this.selectedBankAnalysisReport?.account_id,
            payload: {
                is_included: !val,
            },
        });
        this.tabulationDetailFG.get('is_included')?.patchValue(!val, { emitEvent: false });
    }
    openDocs() {
        this.docViewerService.open({
            items: this.selectedBankAccountStatements.map((item) => ({
                id: item.doc_id,
                name: item.file_name,
                src: item.blob,
            })),
        }, this.destroyWhen$);
    }
    onSaveAnalysisReports(event) {
        this._componentStore.updateState({
            isBankAnalysisReportsUpdated: false,
        });
        const payload = createAnalysisReportsPayload(event);
        this._componentStore.updateBankAnalysisReport({
            bankAccountId: this.selectedBankAnalysisReport?.account_id,
            payload,
        });
    }
    formatBankRecordTabulation(record) {
        return formatBankRecord(record);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBankTabulationsComponent, deps: [{ token: STORE_TOKEN$6 }, { token: TranslocoFeatureHttpLoader }, { token: TRANSLOCO_SCOPE }, { token: i0.ChangeDetectorRef }, { token: i2.FormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWBankTabulationsComponent, selector: "fsw-bank-tabulations", inputs: { isReadonly: "isReadonly", showGST: "showGST", viewDocs: "viewDocs" }, viewQueries: [{ propertyName: "bankTabulationDetailComp", first: true, predicate: FSWBankTabulationDetailComponent, descendants: true }], ngImport: i0, template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <main>\n    <section>\n      <fsw-summary-bank-tabulation\n        [isReadonly]=\"isReadonly\"\n        [bankAccountAnalysisReports]=\"bankAccountAnalysisReports\"\n      ></fsw-summary-bank-tabulation>\n    </section>\n    <section class=\"border-[1px] p-4 mt-10\">\n      <header>\n        <h6>{{ 'Bank Tabulation Details' }}</h6>\n      </header>\n      <ng-container [formGroup]=\"tabulationDetailFG\">\n        <main>\n          <section class=\"flex w-full\">\n            <div class=\"m-2 max-w-[400px] w-[400px]\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.form_fields_1.account_number }}\n                  </label>\n                </ng-template>\n                <fsw-select\n                  [maxHeight]=\"'200px'\"\n                  [placeHolder]=\"'Select Account Number'\"\n                  formControlName=\"account_number\"\n                >\n                  <ng-container *ngFor=\"let record of bankAccountAnalysisReports\">\n                    <ng-template\n                      fswSelectItem\n                      let-selected\n                      [text]=\"formatBankRecordTabulation(record)\"\n                      [value]=\"record.account_id\"\n                    ></ng-template>\n                  </ng-container>\n                </fsw-select>\n              </fsw-field>\n            </div>\n\n            <div class=\"w-[200px] m-2\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label> {{ translate.form_fields_1.overdraft_limit }} ($) </label>\n                </ng-template>\n                <input\n                  class=\"form-input h-[38px]\"\n                  fswCurrencyMask\n                  [options]=\"{ prefix: '', allowNegative: false, align: 'right' }\"\n                  type=\"text\"\n                  formControlName=\"overdraft_limit\"\n                  [placeholder]=\"'Please enter Overdraft Limit'\"\n                  [attr.disabled]=\"isReadonly || isOverdraftLimitDisabled ? true : null\"\n                />\n              </fsw-field>\n\n              <div class=\"flex justify-between items-center\">\n                <button\n                  *ngIf=\"\n                    !isReadonly &&\n                    tabulationDetailFG?.get('account_number')?.value &&\n                    isOverdraftLimitDisabled\n                  \"\n                  class=\"edit-entry mt-2\"\n                  fswButton\n                  appearance=\"secondary\"\n                  [size]=\"'s'\"\n                  (click)=\"isOverdraftLimitDisabled = !isOverdraftLimitDisabled\"\n                >\n                  {{ isOverdraftLimitDisabled ? 'Edit' : '' }}\n                </button>\n                <button\n                  *ngIf=\"!isOverdraftLimitDisabled\"\n                  class=\"edit-entry mt-2\"\n                  fswButton\n                  appearance=\"secondary\"\n                  [size]=\"'s'\"\n                  (click)=\"onSaveOverdraft()\"\n                >\n                  {{ 'Save Overdraft' }}\n                </button>\n              </div>\n            </div>\n\n            <div class=\"w-[250px] max-w-[300px] ml-10\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.form_fields_1.bank_name }}\n                  </label>\n                </ng-template>\n                <div>\n                  {{ this.selectedBankAnalysisReport?.bank_name }}\n                </div>\n              </fsw-field>\n            </div>\n\n            <div class=\"w-[200px] ml-6\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.form_fields_1.currency }}\n                  </label>\n                </ng-template>\n                <div>\n                  {{ this.selectedBankAnalysisReport?.currency }}\n                </div>\n              </fsw-field>\n            </div>\n\n            <div class=\"flex items-center\">\n              <button\n                *ngIf=\"!isReadonly && tabulationDetailFG?.get('account_number')?.value\"\n                class=\"edit-entry mt-2\"\n                fswButton\n                appearance=\"secondary\"\n                [size]=\"'s'\"\n                (click)=\"addToSummary()\"\n              >\n                {{\n                  tabulationDetailFG?.get('is_included')?.value\n                    ? 'Remove from Summary'\n                    : 'Add to Summary'\n                }}\n              </button>\n            </div>\n\n            <div class=\"pl-2 flex items-center\" *ngIf=\"viewDocs\">\n              <button\n                class=\"edit-entry mt-2\"\n                fswButton\n                appearance=\"secondary\"\n                [size]=\"'s'\"\n                [disabled]=\"!this.selectedBankAccountStatements?.length\"\n                (click)=\"openDocs()\"\n              >\n                {{ 'View Docs' }}\n              </button>\n            </div>\n          </section>\n        </main>\n      </ng-container>\n      <fsw-bank-tabulation-detail\n        *ngIf=\"this.selectedBankAnalysisReport?.analysis_report\"\n        [isReadonly]=\"isReadonly\"\n        [analysisReport]=\"this.selectedBankAnalysisReport?.analysis_report || null\"\n        (saveChanges)=\"onSaveAnalysisReports($event)\"\n      ></fsw-bank-tabulation-detail>\n    </section>\n  </main>\n  <div>\n    <fsw-gst *ngIf=\"showGST\" [applicationId]=\"applicationId\" [isReadonly]=\"isReadonly\"></fsw-gst>\n  </div>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$4.FSWFieldHeaderPrefixDirective, selector: "ng-template[fswFieldHeaderPrefix]", inputs: ["kind", "label", "required"] }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "directive", type: CurrencyMaskDirective, selector: "[fswCurrencyMask]", inputs: ["max", "min", "options"] }, { kind: "component", type: FSWBankTabulationDetailComponent, selector: "fsw-bank-tabulation-detail", inputs: ["isReadonly", "analysisReport"], outputs: ["saveChanges"] }, { kind: "component", type: FSWSummaryBankTabulationComponent, selector: "fsw-summary-bank-tabulation", inputs: ["isReadonly", "bankAccountAnalysisReports"], outputs: ["saveChanges"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "component", type: FSWGstComponent, selector: "fsw-gst", inputs: ["applicationId", "isReadonly"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBankTabulationsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-bank-tabulations', template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <main>\n    <section>\n      <fsw-summary-bank-tabulation\n        [isReadonly]=\"isReadonly\"\n        [bankAccountAnalysisReports]=\"bankAccountAnalysisReports\"\n      ></fsw-summary-bank-tabulation>\n    </section>\n    <section class=\"border-[1px] p-4 mt-10\">\n      <header>\n        <h6>{{ 'Bank Tabulation Details' }}</h6>\n      </header>\n      <ng-container [formGroup]=\"tabulationDetailFG\">\n        <main>\n          <section class=\"flex w-full\">\n            <div class=\"m-2 max-w-[400px] w-[400px]\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.form_fields_1.account_number }}\n                  </label>\n                </ng-template>\n                <fsw-select\n                  [maxHeight]=\"'200px'\"\n                  [placeHolder]=\"'Select Account Number'\"\n                  formControlName=\"account_number\"\n                >\n                  <ng-container *ngFor=\"let record of bankAccountAnalysisReports\">\n                    <ng-template\n                      fswSelectItem\n                      let-selected\n                      [text]=\"formatBankRecordTabulation(record)\"\n                      [value]=\"record.account_id\"\n                    ></ng-template>\n                  </ng-container>\n                </fsw-select>\n              </fsw-field>\n            </div>\n\n            <div class=\"w-[200px] m-2\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label> {{ translate.form_fields_1.overdraft_limit }} ($) </label>\n                </ng-template>\n                <input\n                  class=\"form-input h-[38px]\"\n                  fswCurrencyMask\n                  [options]=\"{ prefix: '', allowNegative: false, align: 'right' }\"\n                  type=\"text\"\n                  formControlName=\"overdraft_limit\"\n                  [placeholder]=\"'Please enter Overdraft Limit'\"\n                  [attr.disabled]=\"isReadonly || isOverdraftLimitDisabled ? true : null\"\n                />\n              </fsw-field>\n\n              <div class=\"flex justify-between items-center\">\n                <button\n                  *ngIf=\"\n                    !isReadonly &&\n                    tabulationDetailFG?.get('account_number')?.value &&\n                    isOverdraftLimitDisabled\n                  \"\n                  class=\"edit-entry mt-2\"\n                  fswButton\n                  appearance=\"secondary\"\n                  [size]=\"'s'\"\n                  (click)=\"isOverdraftLimitDisabled = !isOverdraftLimitDisabled\"\n                >\n                  {{ isOverdraftLimitDisabled ? 'Edit' : '' }}\n                </button>\n                <button\n                  *ngIf=\"!isOverdraftLimitDisabled\"\n                  class=\"edit-entry mt-2\"\n                  fswButton\n                  appearance=\"secondary\"\n                  [size]=\"'s'\"\n                  (click)=\"onSaveOverdraft()\"\n                >\n                  {{ 'Save Overdraft' }}\n                </button>\n              </div>\n            </div>\n\n            <div class=\"w-[250px] max-w-[300px] ml-10\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.form_fields_1.bank_name }}\n                  </label>\n                </ng-template>\n                <div>\n                  {{ this.selectedBankAnalysisReport?.bank_name }}\n                </div>\n              </fsw-field>\n            </div>\n\n            <div class=\"w-[200px] ml-6\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ translate.form_fields_1.currency }}\n                  </label>\n                </ng-template>\n                <div>\n                  {{ this.selectedBankAnalysisReport?.currency }}\n                </div>\n              </fsw-field>\n            </div>\n\n            <div class=\"flex items-center\">\n              <button\n                *ngIf=\"!isReadonly && tabulationDetailFG?.get('account_number')?.value\"\n                class=\"edit-entry mt-2\"\n                fswButton\n                appearance=\"secondary\"\n                [size]=\"'s'\"\n                (click)=\"addToSummary()\"\n              >\n                {{\n                  tabulationDetailFG?.get('is_included')?.value\n                    ? 'Remove from Summary'\n                    : 'Add to Summary'\n                }}\n              </button>\n            </div>\n\n            <div class=\"pl-2 flex items-center\" *ngIf=\"viewDocs\">\n              <button\n                class=\"edit-entry mt-2\"\n                fswButton\n                appearance=\"secondary\"\n                [size]=\"'s'\"\n                [disabled]=\"!this.selectedBankAccountStatements?.length\"\n                (click)=\"openDocs()\"\n              >\n                {{ 'View Docs' }}\n              </button>\n            </div>\n          </section>\n        </main>\n      </ng-container>\n      <fsw-bank-tabulation-detail\n        *ngIf=\"this.selectedBankAnalysisReport?.analysis_report\"\n        [isReadonly]=\"isReadonly\"\n        [analysisReport]=\"this.selectedBankAnalysisReport?.analysis_report || null\"\n        (saveChanges)=\"onSaveAnalysisReports($event)\"\n      ></fsw-bank-tabulation-detail>\n    </section>\n  </main>\n  <div>\n    <fsw-gst *ngIf=\"showGST\" [applicationId]=\"applicationId\" [isReadonly]=\"isReadonly\"></fsw-gst>\n  </div>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [STORE_TOKEN$6]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: i0.ChangeDetectorRef }, { type: i2.FormBuilder }]; }, propDecorators: { bankTabulationDetailComp: [{
                type: ViewChild,
                args: [FSWBankTabulationDetailComponent]
            }], isReadonly: [{
                type: Input
            }], showGST: [{
                type: Input
            }], viewDocs: [{
                type: Input
            }] } });

class FSWManualOverrideComponent {
    constructor(data, _scope, _translateService, _dialogRef, _fb) {
        this.data = data;
        this._scope = _scope;
        this._translateService = _translateService;
        this._dialogRef = _dialogRef;
        this._fb = _fb;
        this.modalSize = FSWModalSizes.S;
        this.overrideOptions = [];
        this._destroy$ = new Subject();
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'modals'),
            this._translateService.selectFeatureTranslate(this._scope, 'dialogs'),
        ]).pipe(map(([modals, dialogs]) => ({
            modals,
            dialogs,
        })));
        this.overrideOptions = data?.overrideReasons || [];
        this.manualOverrideFG = this._fb.group({
            overrideReason: ['', [Validators.required]],
        });
    }
    ngOnDestroy() {
        if (this._destroy$) {
            this._destroy$.next();
            this._destroy$.complete();
        }
    }
    onConfirm() {
        this._dialogRef.close({
            data: this.manualOverrideFG.value,
        });
    }
    onClose() {
        this._dialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWManualOverrideComponent, deps: [{ token: DIALOG_DATA }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: i1$7.DialogRef }, { token: i2.FormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWManualOverrideComponent, selector: "fsw-manual-override", ngImport: i0, template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <fsw-modal\n    [title]=\"'Manual Override Justification'\"\n    [confirmButton]=\"'Override'\"\n    [cancelButton]=\"'Cancel'\"\n    [confirmButtonDisabled]=\"!manualOverrideFG.valid\"\n    [size]=\"modalSize\"\n    (closeEvent)=\"onClose()\"\n    (cancelEvent)=\"onClose()\"\n    (confirmEvent)=\"onConfirm()\"\n  >\n    <ng-template fswModalBody>\n      <caption class=\"mb-2.5 text-gray-700\">\n        {{\n          'Please select justification for the manual override.'\n        }}\n      </caption>\n      <ng-container [formGroup]=\"manualOverrideFG\">\n        <section class=\"flex align-middle w-full\">\n          <fsw-field>\n            <fsw-select\n              [maxHeight]=\"'200px'\"\n              [placeHolder]=\"'Please Select Override Reason'\"\n              formControlName=\"overrideReason\"\n            >\n              <ng-container *ngFor=\"let str of overrideOptions\">\n                <ng-template fswSelectItem let-selected [text]=\"str\" [value]=\"str\"></ng-template>\n              </ng-container>\n            </fsw-select>\n          </fsw-field>\n        </section>\n      </ng-container>\n    </ng-template>\n  </fsw-modal>\n</ng-container>\n", styles: ["table{width:100%;border-collapse:collapse}table .cdk-column-Transfer-from{width:80px;max-width:250px;overflow:scroll}table th,table td{padding:10px;text-align:left;border-bottom:1px solid #ddd;border-top:1px solid #ddd;font-size:90%;text-align:right}table th:first-child,table td:first-child{border-left:1px solid #ddd}table th:last-child,table td:last-child{border-right:1px solid #ddd}table th input[type=text],table td input[type=text]{border:1px solid #ddd;border-radius:5px;padding:5px;width:100%;font-size:90%}table th{font-weight:700;font-weight:500}table td{font-size:80%}table tr.sub-header{background-color:#f9f9f9}table tr:hover{background-color:#e6e6e6}table .column-header{text-align:right}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWManualOverrideComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-manual-override', template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <fsw-modal\n    [title]=\"'Manual Override Justification'\"\n    [confirmButton]=\"'Override'\"\n    [cancelButton]=\"'Cancel'\"\n    [confirmButtonDisabled]=\"!manualOverrideFG.valid\"\n    [size]=\"modalSize\"\n    (closeEvent)=\"onClose()\"\n    (cancelEvent)=\"onClose()\"\n    (confirmEvent)=\"onConfirm()\"\n  >\n    <ng-template fswModalBody>\n      <caption class=\"mb-2.5 text-gray-700\">\n        {{\n          'Please select justification for the manual override.'\n        }}\n      </caption>\n      <ng-container [formGroup]=\"manualOverrideFG\">\n        <section class=\"flex align-middle w-full\">\n          <fsw-field>\n            <fsw-select\n              [maxHeight]=\"'200px'\"\n              [placeHolder]=\"'Please Select Override Reason'\"\n              formControlName=\"overrideReason\"\n            >\n              <ng-container *ngFor=\"let str of overrideOptions\">\n                <ng-template fswSelectItem let-selected [text]=\"str\" [value]=\"str\"></ng-template>\n              </ng-container>\n            </fsw-select>\n          </fsw-field>\n        </section>\n      </ng-container>\n    </ng-template>\n  </fsw-modal>\n</ng-container>\n", styles: ["table{width:100%;border-collapse:collapse}table .cdk-column-Transfer-from{width:80px;max-width:250px;overflow:scroll}table th,table td{padding:10px;text-align:left;border-bottom:1px solid #ddd;border-top:1px solid #ddd;font-size:90%;text-align:right}table th:first-child,table td:first-child{border-left:1px solid #ddd}table th:last-child,table td:last-child{border-right:1px solid #ddd}table th input[type=text],table td input[type=text]{border:1px solid #ddd;border-radius:5px;padding:5px;width:100%;font-size:90%}table th{font-weight:700;font-weight:500}table td{font-size:80%}table tr.sub-header{background-color:#f9f9f9}table tr:hover{background-color:#e6e6e6}table .column-header{text-align:right}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DIALOG_DATA]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: i1$7.DialogRef }, { type: i2.FormBuilder }]; } });

class FSWManualOverrideModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWManualOverrideModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWManualOverrideModule, declarations: [FSWManualOverrideComponent], imports: [CommonModule,
            ReactiveFormsModule,
            LetDirective,
            FSWFieldModule,
            FSWSelectModule,
            TranslocoModule,
            FSWModalModule$1,
            DialogModule,
            CdkTableModule,
            FSWCurrencyMaskModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWManualOverrideModule, imports: [CommonModule,
            ReactiveFormsModule,
            FSWFieldModule,
            FSWSelectModule,
            TranslocoModule,
            FSWModalModule$1,
            DialogModule,
            CdkTableModule,
            FSWCurrencyMaskModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWManualOverrideModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        LetDirective,
                        FSWFieldModule,
                        FSWSelectModule,
                        TranslocoModule,
                        FSWModalModule$1,
                        DialogModule,
                        CdkTableModule,
                        FSWCurrencyMaskModule,
                    ],
                    declarations: [FSWManualOverrideComponent],
                }]
        }] });

const initFG = (_fb) => {
    return _fb.group({
        account_number: [''],
    });
};
const createNonTradeCategorizations = (data, monthMapping, alertService) => {
    const non_trade_categorization = [];
    data.forEach((item) => {
        let category = non_trade_categorization.find((cat) => cat.category === item.transferCategory);
        if (!category) {
            category = {
                category: item.transferCategory,
                sub_categories: [],
            };
            non_trade_categorization.push(category);
        }
        const sub_category = {
            data: [],
            name: item.transferFrom,
            total_amount: +item.total_myr.toFixed(2),
        };
        for (const date in monthMapping) {
            const monthKey = monthMapping[date];
            if (item[monthKey] !== null &&
                typeof item[monthKey] === 'number' &&
                monthKey !== 'total_myr') {
                sub_category.data.push({
                    date,
                    value: +item[monthKey].toFixed(2),
                });
            }
        }
        category.sub_categories.push(sub_category);
    });
    const monthlyTotalItem = non_trade_categorization.find((cat) => cat.category === 'Monthly Total');
    return {
        non_trade_categorization: non_trade_categorization.filter((cat) => cat.category !== 'Monthly Total'),
        monthly_totals: {
            data: (monthlyTotalItem?.sub_categories[0]?.data || []).map((d) => ({
                date: d.date,
                total: d.value,
            })),
        },
    };
};

const nonTradeAddEntryDateFormatter = (inputDate) => {
    const date = inputDate ? new Date(inputDate) : new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

class FSWNonTradeAddEntryComponent {
    constructor(data, componentStore, _scope, _translateService, _dialogRef, _fb, _alertService) {
        this.data = data;
        this.componentStore = componentStore;
        this._scope = _scope;
        this._translateService = _translateService;
        this._dialogRef = _dialogRef;
        this._fb = _fb;
        this._alertService = _alertService;
        this.modalSize = FSWModalSizes.L;
        this.errors = [];
        this.columns = [];
        this.displayedColumns = [];
        this.columnMappings = {};
        this.refData = {
            categories: [],
            overrideReasons: [],
        };
        this.form = null;
        this._destroy$ = new Subject();
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'modals'),
            this._translateService.selectFeatureTranslate(this._scope, 'dialogs'),
        ]).pipe(map(([modals, dialogs]) => ({
            modals,
            dialogs,
        })));
        this.overrideOptions = [];
        this.nonTradeAddEntryFG = this._fb.group({
            nonTradeTransactionCategory: ['', [Validators.required]],
            nonTradeTransactionName: ['', [Validators.required]],
        });
        this.manualOverrideFG = this._fb.group({
            overrideReason: ['', [Validators.required]],
        });
        this.overrideOptions = data?.nonTradeModel.refData.overrideReasons || [];
        const containerUIModel = JSON.parse(JSON.stringify(data.nonTradeModel));
        delete containerUIModel.dataSource[0].transferFrom;
        delete containerUIModel.dataSource[0].transferCategory;
        const dataSourceItem = containerUIModel.dataSource[0];
        for (const key in dataSourceItem) {
            if (dataSourceItem[key] === null) {
                dataSourceItem[key] = 0;
            }
        }
        delete containerUIModel.nonTradeColumnMappings['Transfer from'];
        this.columns = containerUIModel.nonTradeColumns.filter((c) => c !== 'transferFrom');
        this.displayedColumns = containerUIModel.nonTradeDisplayedColumns.filter((c) => c !== 'Transfer from');
        this.columnMappings = containerUIModel.nonTradeColumnMappings;
        this.refData = {
            categories: containerUIModel.refData.categories,
            overrideReasons: containerUIModel.refData.overrideReasons,
        };
        const fg = this._fb.group({
            ...dataSourceItem,
        });
        this.nonTradeTransactionFormArray = this._fb.array([fg]);
        fg.valueChanges.subscribe((val) => {
            let total_myr = 0;
            for (const key in val) {
                if (key.startsWith('month_')) {
                    total_myr += val[key] || 0;
                }
            }
            val.total_myr = total_myr;
            fg.patchValue(val, { emitEvent: false });
        });
        // wait for uiAsyncStatus to be updated
        this.componentStore.state$
            .pipe(takeUntil(this._destroy$), map((state) => state.uiAsyncStatus), tap((uiAsyncStatus) => {
            if (uiAsyncStatus.nonTradeNewEntryAdded === 'success') {
                this._dialogRef.close();
                this.componentStore.updateState({
                    uiAsyncStatus: {
                        ...uiAsyncStatus,
                        nonTradeNewEntryAdded: '',
                    },
                });
            }
        }))
            .subscribe();
    }
    ngOnDestroy() {
        if (this._destroy$) {
            this._destroy$.next();
            this._destroy$.complete();
        }
    }
    get isButtonDisable() {
        if (this.data.override_metadata) {
            return this.nonTradeAddEntryFG.invalid;
        }
        return this.nonTradeAddEntryFG.invalid || this.manualOverrideFG.invalid;
    }
    onConfirm() {
        const entryPayload = {
            transferFrom: this.nonTradeAddEntryFG.value.nonTradeTransactionName,
            transferCategory: this.nonTradeAddEntryFG.value.nonTradeTransactionCategory,
            ...this.nonTradeTransactionFormArray.at(0).value,
        };
        const categoryOrder = this.refData.categories;
        const monthlyTotalRow = this.data.nonTradeModel.dataSource.find((entry) => entry.transferFrom === 'Monthly Total');
        for (const key in entryPayload) {
            if (key.startsWith('month_') || key === 'total_myr') {
                monthlyTotalRow[key] = (entryPayload[key] || 0) + (monthlyTotalRow[key] || 0);
            }
        }
        const sortedData = [...this.data.nonTradeModel.dataSource, entryPayload].sort((a, b) => {
            const categoryA = a.transferCategory;
            const categoryB = b.transferCategory;
            if (categoryA === 'Monthly Total') {
                return 1; // Ensure "Monthly Total" is always the last object
            }
            else if (categoryB === 'Monthly Total') {
                return -1;
            }
            const indexA = categoryOrder.indexOf(categoryA);
            const indexB = categoryOrder.indexOf(categoryB);
            return indexA - indexB;
        });
        const filteredData = [...sortedData].filter((r) => r.total_myr !== null);
        const { non_trade_categorization, monthly_totals } = createNonTradeCategorizations(filteredData, this.data.nonTradeModel.nonTradeColumnMappings);
        const { account_id, account_name, account_number, bank_name, currency } = this.data.otherDetails;
        const payload = {
            account_id,
            account_name,
            account_number,
            bank_name,
            currency,
            non_trade_categorization,
            monthly_totals: this.data.monthly_totals || monthly_totals,
            override_metadata: this.data.override_metadata ||
                {
                    date: nonTradeAddEntryDateFormatter(),
                    username: this.data.username,
                    justification: this.manualOverrideFG.value.overrideReason,
                },
        };
        this.componentStore.updateNonTradeReport({
            bankAccountId: account_id,
            payload,
        });
        this.componentStore.state$
            .pipe(takeUntil(this._destroy$), map((state) => state.isNonTradeReportsUpdated))
            .subscribe((isNonTradeReportsUpdated) => {
            if (isNonTradeReportsUpdated) {
                this.componentStore.updateState({
                    uiAsyncStatus: {
                        ...this.componentStore.state().uiAsyncStatus,
                        nonTradeNewEntryAdded: 'success',
                    },
                });
            }
        });
    }
    onClose() {
        this._dialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWNonTradeAddEntryComponent, deps: [{ token: DIALOG_DATA }, { token: STORE_TOKEN$6 }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: i1$7.DialogRef }, { token: i2.FormBuilder }, { token: FSW_ALERT_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWNonTradeAddEntryComponent, selector: "fsw-non-trade-add-entry", ngImport: i0, template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <fsw-modal\n    [title]=\"'Add Entry'\"\n    [confirmButton]=\"'Add Entry'\"\n    [cancelButton]=\"'Cancel'\"\n    [confirmButtonDisabled]=\"isButtonDisable\"\n    [size]=\"modalSize\"\n    (closeEvent)=\"onClose()\"\n    (cancelEvent)=\"onClose()\"\n    (confirmEvent)=\"onConfirm()\"\n  >\n    <ng-template fswModalBody>\n      <ng-container [formGroup]=\"nonTradeAddEntryFG\">\n        <section class=\"flex justify-between w-full\">\n          <fsw-field>\n            <fsw-select\n              [maxHeight]=\"'200px'\"\n              [placeHolder]=\"'Select transaction category (mandatory)'\"\n              formControlName=\"nonTradeTransactionCategory\"\n            >\n              <ng-container *ngFor=\"let str of refData.categories\">\n                <ng-template fswSelectItem let-selected [text]=\"str\" [value]=\"str\"></ng-template>\n              </ng-container>\n            </fsw-select>\n          </fsw-field>\n\n          <div class=\"w-1/2\">\n            <div class=\"form-control\">\n              <input\n                type=\"text\"\n                class=\"form-input\"\n                formControlName=\"nonTradeTransactionName\"\n                [placeholder]=\"'Please Enter Transaction Name (mandatory)'\"\n              />\n            </div>\n          </div>\n        </section>\n\n        <section>\n          <table\n            cdk-table\n            [dataSource]=\"nonTradeTransactionFormArray.controls\"\n            class=\"example-table\"\n            role=\"grid\"\n          >\n            <ng-container\n              *ngFor=\"let column of displayedColumns; let i = index\"\n              [cdkColumnDef]=\"column\"\n            >\n              <th cdk-header-cell *cdkHeaderCellDef class=\"column-header\">{{ column }}</th>\n              <td cdk-cell *cdkCellDef=\"let row\" class=\"column-cell\">\n                <ng-container\n                  *ngIf=\"\n                    i === displayedColumns.length - 1 || row.get(columnMappings[column]) === null\n                  \"\n                >\n                  {{ row.get(columnMappings[column]).value | currency : 'USD' | slice : 1 }}\n                </ng-container>\n                <ng-container\n                  *ngIf=\"\n                    i !== displayedColumns.length - 1 &&\n                    row.get(columnMappings[column]) !== null &&\n                    row.get(columnMappings[column]).value !== null\n                  \"\n                >\n                  <input\n                    fswCurrencyMask\n                    [options]=\"{ prefix: '', allowNegative: false, align: 'right' }\"\n                    type=\"text\"\n                    [formControl]=\"row.get(columnMappings[column])\"\n                  />\n                </ng-container>\n              </td>\n            </ng-container>\n\n            <tr cdk-header-row *cdkHeaderRowDef=\"displayedColumns\"></tr>\n            <tr cdk-row *cdkRowDef=\"let row; columns: displayedColumns\"></tr>\n          </table>\n        </section>\n      </ng-container>\n\n      <ng-container *ngIf=\"!data.override_metadata\" [formGroup]=\"manualOverrideFG\">\n        <header class=\"mt-6 mb-4\">\n          <h6>{{ 'Manual Override Justification' }}</h6>\n        </header>\n\n        <section class=\"flex align-middle w-full\">\n          <fsw-field>\n            <fsw-select\n              [maxHeight]=\"'200px'\"\n              [placeHolder]=\"'Please Select Override Reason'\"\n              formControlName=\"overrideReason\"\n            >\n              <ng-container *ngFor=\"let str of overrideOptions\">\n                <ng-template fswSelectItem let-selected [text]=\"str\" [value]=\"str\"></ng-template>\n              </ng-container>\n            </fsw-select>\n          </fsw-field>\n        </section>\n      </ng-container>\n    </ng-template>\n  </fsw-modal>\n</ng-container>\n", styles: ["table{width:100%;border-collapse:collapse}table .cdk-column-Transfer-from{width:80px;max-width:250px;overflow:scroll}table th,table td{padding:10px;text-align:left;border-bottom:1px solid #ddd;border-top:1px solid #ddd;font-size:90%;text-align:right}table th:first-child,table td:first-child{border-left:1px solid #ddd}table th:last-child,table td:last-child{border-right:1px solid #ddd}table th input[type=text],table td input[type=text]{border:1px solid #ddd;border-radius:5px;padding:5px;width:100%;font-size:90%}table th{font-weight:700;font-weight:500}table td{font-size:80%}table tr.sub-header{background-color:#f9f9f9}table tr:hover{background-color:#e6e6e6}table .column-header{text-align:right}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "component", type: i6$1.CdkTable, selector: "cdk-table, table[cdk-table]", inputs: ["trackBy", "dataSource", "multiTemplateDataRows", "fixedLayout"], outputs: ["contentChanged"], exportAs: ["cdkTable"] }, { kind: "directive", type: i6$1.CdkRowDef, selector: "[cdkRowDef]", inputs: ["cdkRowDefColumns", "cdkRowDefWhen"] }, { kind: "directive", type: i6$1.CdkCellDef, selector: "[cdkCellDef]" }, { kind: "directive", type: i6$1.CdkHeaderCellDef, selector: "[cdkHeaderCellDef]" }, { kind: "directive", type: i6$1.CdkColumnDef, selector: "[cdkColumnDef]", inputs: ["sticky", "cdkColumnDef", "stickyEnd"] }, { kind: "directive", type: i6$1.CdkCell, selector: "cdk-cell, td[cdk-cell]" }, { kind: "component", type: i6$1.CdkRow, selector: "cdk-row, tr[cdk-row]" }, { kind: "directive", type: i6$1.CdkHeaderCell, selector: "cdk-header-cell, th[cdk-header-cell]" }, { kind: "component", type: i6$1.CdkHeaderRow, selector: "cdk-header-row, tr[cdk-header-row]" }, { kind: "directive", type: i6$1.CdkHeaderRowDef, selector: "[cdkHeaderRowDef]", inputs: ["cdkHeaderRowDef", "cdkHeaderRowDefSticky"] }, { kind: "directive", type: CurrencyMaskDirective, selector: "[fswCurrencyMask]", inputs: ["max", "min", "options"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i1$1.SlicePipe, name: "slice" }, { kind: "pipe", type: i1$1.CurrencyPipe, name: "currency" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWNonTradeAddEntryComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-non-trade-add-entry', template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <fsw-modal\n    [title]=\"'Add Entry'\"\n    [confirmButton]=\"'Add Entry'\"\n    [cancelButton]=\"'Cancel'\"\n    [confirmButtonDisabled]=\"isButtonDisable\"\n    [size]=\"modalSize\"\n    (closeEvent)=\"onClose()\"\n    (cancelEvent)=\"onClose()\"\n    (confirmEvent)=\"onConfirm()\"\n  >\n    <ng-template fswModalBody>\n      <ng-container [formGroup]=\"nonTradeAddEntryFG\">\n        <section class=\"flex justify-between w-full\">\n          <fsw-field>\n            <fsw-select\n              [maxHeight]=\"'200px'\"\n              [placeHolder]=\"'Select transaction category (mandatory)'\"\n              formControlName=\"nonTradeTransactionCategory\"\n            >\n              <ng-container *ngFor=\"let str of refData.categories\">\n                <ng-template fswSelectItem let-selected [text]=\"str\" [value]=\"str\"></ng-template>\n              </ng-container>\n            </fsw-select>\n          </fsw-field>\n\n          <div class=\"w-1/2\">\n            <div class=\"form-control\">\n              <input\n                type=\"text\"\n                class=\"form-input\"\n                formControlName=\"nonTradeTransactionName\"\n                [placeholder]=\"'Please Enter Transaction Name (mandatory)'\"\n              />\n            </div>\n          </div>\n        </section>\n\n        <section>\n          <table\n            cdk-table\n            [dataSource]=\"nonTradeTransactionFormArray.controls\"\n            class=\"example-table\"\n            role=\"grid\"\n          >\n            <ng-container\n              *ngFor=\"let column of displayedColumns; let i = index\"\n              [cdkColumnDef]=\"column\"\n            >\n              <th cdk-header-cell *cdkHeaderCellDef class=\"column-header\">{{ column }}</th>\n              <td cdk-cell *cdkCellDef=\"let row\" class=\"column-cell\">\n                <ng-container\n                  *ngIf=\"\n                    i === displayedColumns.length - 1 || row.get(columnMappings[column]) === null\n                  \"\n                >\n                  {{ row.get(columnMappings[column]).value | currency : 'USD' | slice : 1 }}\n                </ng-container>\n                <ng-container\n                  *ngIf=\"\n                    i !== displayedColumns.length - 1 &&\n                    row.get(columnMappings[column]) !== null &&\n                    row.get(columnMappings[column]).value !== null\n                  \"\n                >\n                  <input\n                    fswCurrencyMask\n                    [options]=\"{ prefix: '', allowNegative: false, align: 'right' }\"\n                    type=\"text\"\n                    [formControl]=\"row.get(columnMappings[column])\"\n                  />\n                </ng-container>\n              </td>\n            </ng-container>\n\n            <tr cdk-header-row *cdkHeaderRowDef=\"displayedColumns\"></tr>\n            <tr cdk-row *cdkRowDef=\"let row; columns: displayedColumns\"></tr>\n          </table>\n        </section>\n      </ng-container>\n\n      <ng-container *ngIf=\"!data.override_metadata\" [formGroup]=\"manualOverrideFG\">\n        <header class=\"mt-6 mb-4\">\n          <h6>{{ 'Manual Override Justification' }}</h6>\n        </header>\n\n        <section class=\"flex align-middle w-full\">\n          <fsw-field>\n            <fsw-select\n              [maxHeight]=\"'200px'\"\n              [placeHolder]=\"'Please Select Override Reason'\"\n              formControlName=\"overrideReason\"\n            >\n              <ng-container *ngFor=\"let str of overrideOptions\">\n                <ng-template fswSelectItem let-selected [text]=\"str\" [value]=\"str\"></ng-template>\n              </ng-container>\n            </fsw-select>\n          </fsw-field>\n        </section>\n      </ng-container>\n    </ng-template>\n  </fsw-modal>\n</ng-container>\n", styles: ["table{width:100%;border-collapse:collapse}table .cdk-column-Transfer-from{width:80px;max-width:250px;overflow:scroll}table th,table td{padding:10px;text-align:left;border-bottom:1px solid #ddd;border-top:1px solid #ddd;font-size:90%;text-align:right}table th:first-child,table td:first-child{border-left:1px solid #ddd}table th:last-child,table td:last-child{border-right:1px solid #ddd}table th input[type=text],table td input[type=text]{border:1px solid #ddd;border-radius:5px;padding:5px;width:100%;font-size:90%}table th{font-weight:700;font-weight:500}table td{font-size:80%}table tr.sub-header{background-color:#f9f9f9}table tr:hover{background-color:#e6e6e6}table .column-header{text-align:right}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DIALOG_DATA]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [STORE_TOKEN$6]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: i1$7.DialogRef }, { type: i2.FormBuilder }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }]; } });

const DECLARATIONS_EXPORTS$b = [FSWNonTradeAddEntryComponent];
class FSWNonTradeAddEntryModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWNonTradeAddEntryModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWNonTradeAddEntryModule, declarations: [FSWNonTradeAddEntryComponent], imports: [CommonModule,
            ReactiveFormsModule,
            LetDirective,
            FSWFieldModule,
            FSWSelectModule,
            TranslocoModule,
            FSWModalModule$1,
            DialogModule,
            CdkTableModule,
            FSWCurrencyMaskModule], exports: [FSWNonTradeAddEntryComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWNonTradeAddEntryModule, imports: [CommonModule,
            ReactiveFormsModule,
            FSWFieldModule,
            FSWSelectModule,
            TranslocoModule,
            FSWModalModule$1,
            DialogModule,
            CdkTableModule,
            FSWCurrencyMaskModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWNonTradeAddEntryModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        LetDirective,
                        FSWFieldModule,
                        FSWSelectModule,
                        TranslocoModule,
                        FSWModalModule$1,
                        DialogModule,
                        CdkTableModule,
                        FSWCurrencyMaskModule,
                    ],
                    declarations: DECLARATIONS_EXPORTS$b,
                    exports: DECLARATIONS_EXPORTS$b,
                }]
        }] });

class FSWViewPerfiosMetadataModalComponent {
    get isButtonDisable() {
        return !this.files.length;
    }
    constructor(data, _scope, _translateService, _dialogRef) {
        this.data = data;
        this._scope = _scope;
        this._translateService = _translateService;
        this._dialogRef = _dialogRef;
        this._destroy$ = new Subject();
        this.modalSize = FSWModalSizes.S;
        this.errors = [];
        this.files = [];
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'view_perfios_metadata'),
            this._translateService.selectFeatureTranslate(this._scope, 'buttons'),
        ]).pipe(map(([bankAccountStmt, buttons]) => ({
            bankAccountStmt,
            buttons,
        })));
    }
    ngOnDestroy() {
        if (this._destroy$) {
            this._destroy$.next();
            this._destroy$.complete();
        }
    }
    onConfirm() {
        this._dialogRef.close();
    }
    onClose() {
        this._dialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWViewPerfiosMetadataModalComponent, deps: [{ token: DIALOG_DATA }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: i1$7.DialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWViewPerfiosMetadataModalComponent, selector: "fsw-view-perfios-metadata", ngImport: i0, template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <fsw-modal\n    [title]=\"'Company Details'\"\n    [cancelButton]=\"translate.buttons.cancel\"\n    [size]=\"modalSize\"\n    [confirmButtonDisabled]=\"isButtonDisable\"\n    (closeEvent)=\"onClose()\"\n    (cancelEvent)=\"onClose()\"\n    (confirmEvent)=\"onConfirm()\"\n  >\n    <ng-template fswModalBody>\n      <ng-container>\n        <section *ngIf=\"data?.message as errorMessage\" class=\"p-2 mb-2\">\n          <label class=\"font-medium\">Error Message: </label>\n          <div class=\"text-[12px] p-1 bg-red-100 text-red-500\">\n            {{ errorMessage }}\n          </div>\n        </section>\n\n        <ng-container *ngIf=\"data?.company_name as companyNames\">\n          <section class=\"p-2 mt-2 mb-2\">\n            <div>\n              <label class=\"font-medium\">Company Names: </label>\n            </div>\n\n            <div\n              class=\"text-[12px] p-1 bg-blue-100 text-blue-500\"\n              *ngFor=\"let company of companyNames\"\n            >\n              {{ company }}\n            </div>\n          </section>\n        </ng-container>\n\n        <ng-container *ngIf=\"data?.sister_company_name as sisterCompanyNames\">\n          <section class=\"p-2 mt-2 mb-2\">\n            <div>\n              <label class=\"font-medium\">Sister Company Names: </label>\n            </div>\n\n            <div\n              class=\"text-[12px] p-1 bg-blue-100 text-blue-500\"\n              *ngFor=\"let company of sisterCompanyNames\"\n            >\n              {{ company }}\n            </div>\n          </section>\n        </ng-container>\n      </ng-container>\n    </ng-template>\n  </fsw-modal>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWViewPerfiosMetadataModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-view-perfios-metadata', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"translate$ | async as translate\">\n  <fsw-modal\n    [title]=\"'Company Details'\"\n    [cancelButton]=\"translate.buttons.cancel\"\n    [size]=\"modalSize\"\n    [confirmButtonDisabled]=\"isButtonDisable\"\n    (closeEvent)=\"onClose()\"\n    (cancelEvent)=\"onClose()\"\n    (confirmEvent)=\"onConfirm()\"\n  >\n    <ng-template fswModalBody>\n      <ng-container>\n        <section *ngIf=\"data?.message as errorMessage\" class=\"p-2 mb-2\">\n          <label class=\"font-medium\">Error Message: </label>\n          <div class=\"text-[12px] p-1 bg-red-100 text-red-500\">\n            {{ errorMessage }}\n          </div>\n        </section>\n\n        <ng-container *ngIf=\"data?.company_name as companyNames\">\n          <section class=\"p-2 mt-2 mb-2\">\n            <div>\n              <label class=\"font-medium\">Company Names: </label>\n            </div>\n\n            <div\n              class=\"text-[12px] p-1 bg-blue-100 text-blue-500\"\n              *ngFor=\"let company of companyNames\"\n            >\n              {{ company }}\n            </div>\n          </section>\n        </ng-container>\n\n        <ng-container *ngIf=\"data?.sister_company_name as sisterCompanyNames\">\n          <section class=\"p-2 mt-2 mb-2\">\n            <div>\n              <label class=\"font-medium\">Sister Company Names: </label>\n            </div>\n\n            <div\n              class=\"text-[12px] p-1 bg-blue-100 text-blue-500\"\n              *ngFor=\"let company of sisterCompanyNames\"\n            >\n              {{ company }}\n            </div>\n          </section>\n        </ng-container>\n      </ng-container>\n    </ng-template>\n  </fsw-modal>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DIALOG_DATA]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: i1$7.DialogRef }]; } });

const DECLARATIONS_EXPORTS$a = [FSWViewPerfiosMetadataModalComponent];
class FSWViewPerfiosMetadataModalModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWViewPerfiosMetadataModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWViewPerfiosMetadataModalModule, declarations: [FSWViewPerfiosMetadataModalComponent], imports: [CommonModule, TranslocoModule, FSWModalModule$1, DialogModule], exports: [FSWViewPerfiosMetadataModalComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWViewPerfiosMetadataModalModule, imports: [CommonModule, TranslocoModule, FSWModalModule$1, DialogModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWViewPerfiosMetadataModalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, TranslocoModule, FSWModalModule$1, DialogModule],
                    declarations: DECLARATIONS_EXPORTS$a,
                    exports: DECLARATIONS_EXPORTS$a,
                }]
        }] });

class FSWNonTradeTransactionsComponent {
    set isReadonly(value) {
        this._isReadonly = value;
    }
    get isReadonly() {
        return this._isReadonly;
    }
    constructor(componentStore, _fb, _cdkDialog, _injector, _alertService) {
        this.componentStore = componentStore;
        this._fb = _fb;
        this._cdkDialog = _cdkDialog;
        this._injector = _injector;
        this._alertService = _alertService;
        this._isReadonly = true;
        this.saveChanges = new EventEmitter();
        this._destroy$ = new Subject();
        this.selectedAccountRefData = {
            categories: [],
            overrideReasons: [],
        };
        this.selectedAccountMonthlyTotalsDataLen = 0;
        this.showEditMode = false;
        this.showManualOverride = true;
        this.errors = [];
        this.columns = [];
        this.displayedColumns = [];
        this.columnMappings = {};
        this.dataSource$ = new BehaviorSubject([]);
        this._bankAccountsMap = {};
        // override columns
        this.overrideColumns = ['date', 'username', 'justification'];
        this.overrideDisplayedColumns = ['Date', 'Credit Manager', 'Justification'];
        this.overrideColumnMappings = {
            Date: 'date',
            'Credit Manager': 'username',
            Justification: 'justification',
        };
        this.overrideDataSource$ = new BehaviorSubject([]);
        // subscribe to nonTradeBankUIMap from store
        this.componentStore.state$
            .pipe(takeUntil(this._destroy$), distinctUntilChanged(), map((state) => state.nonTradeBankUIMap))
            .subscribe((res) => {
            if (!res)
                return;
            this.nonTradeBankUIMap = res;
            this.selectedAccountUIModel =
                this.nonTradeBankUIMap[this.nonTradeFG?.value?.account_number]?.uiModel;
            const selectedAccId = this.nonTradeFG?.get('account_number')?.value;
            this.selectedAccountOverrideMetadata =
                this.nonTradeBankUIMap[selectedAccId]?.override_metadata;
            this.selectedAccountUIModel?.dataSource &&
                this.dataSource$.next([...this.selectedAccountUIModel.dataSource]);
            this._calcTotalMyr();
        });
        // init form group
        this.nonTradeFG = initFG(this._fb);
        // on account number change
        this._onAccountNumberChange();
        // after non-trade report is updated
        this.componentStore.state$
            .pipe(takeUntil(this._destroy$), map((state) => state.isNonTradeReportsUpdated))
            .subscribe((isNonTradeReportsUpdated) => {
            if (isNonTradeReportsUpdated) {
                this.showEditMode = false;
                // this._cdr.detectChanges();
            }
        });
        this._bankAccountsMap = keyBy(this.componentStore.state().bankAccounts, 'account_id');
    }
    isNumericValue(value) {
        if (value || value === 0)
            return !isNaN(value);
        else
            return false;
    }
    calcMonthlyTotal(monthlyTotalsDataLength, data) {
        const monthTotals = Array.from({ length: monthlyTotalsDataLength }).fill(0);
        for (const entry of data) {
            if (entry.transferFrom !== 'Monthly Total') {
                for (let i = 1; i <= monthlyTotalsDataLength; i++) {
                    const monthValue = entry[`month_${i}`] || 0;
                    monthTotals[i - 1] += monthValue;
                }
            }
        }
        const monthlyTotalRow = data.find((entry) => entry.transferFrom === 'Monthly Total');
        if (monthlyTotalRow) {
            for (let i = 1; i <= monthlyTotalsDataLength; i++) {
                monthlyTotalRow[`month_${i}`] = monthTotals[i - 1];
            }
        }
        const monthKeys = Object.keys(monthlyTotalRow).filter((key) => key.startsWith('month_'));
        const totalValue = monthKeys.reduce((sum, key) => sum + (monthlyTotalRow[key] || 0), 0);
        monthlyTotalRow['total_myr'] = totalValue;
        return monthlyTotalRow;
    }
    openAddEntryModal() {
        if (!this.selectedAccountMonthlyTotalsDataLen) {
            return;
        }
        this._cdkDialog
            .open(FSWNonTradeAddEntryComponent, {
            data: {
                nonTradeModel: this.selectedAccountUIModel,
                otherDetails: this.selectedAccountOtherDetails,
                monthly_totals: this.selectedAccountMonthlyTotals,
                override_metadata: this.selectedAccountOverrideMetadata,
                username: this.componentStore.state().username,
            },
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((res) => {
            if (!res)
                return;
        }))
            .subscribe();
    }
    _openOverrideModal() {
        // open modal
        this._cdkDialog
            .open(FSWManualOverrideComponent, {
            data: {
                overrideReasons: this.selectedAccountRefData?.overrideReasons || [],
            },
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((res) => {
            if (!res) {
                this.selectedAccountOverrideMetadata = null;
                return;
            }
            const override_metadata = {
                date: nonTradeAddEntryDateFormatter(),
                username: this.componentStore.state().username,
                justification: res?.data?.overrideReason,
            };
            this._createFinalPayload(override_metadata);
            this.selectedAccountOverrideMetadata = override_metadata;
        }))
            .subscribe((res) => {
            if (!res) {
                this.selectedAccountOverrideMetadata = null;
                return;
            }
            this._setupOverrideCDKTable();
        });
    }
    onSaveChanges(event) {
        event.preventDefault();
        if (!this.selectedAccountOverrideMetadata) {
            this._openOverrideModal();
            return;
        }
        this._createFinalPayload(this.selectedAccountOverrideMetadata);
    }
    openViewPerfiosMetadataModal() {
        const data = {
            ...this._selectedAccPerfiosMetadata,
        };
        this._cdkDialog
            .open(FSWViewPerfiosMetadataModalComponent, {
            data,
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((res) => {
            if (!res)
                return;
        }))
            .subscribe();
    }
    formatBankRecordNonTrade(record) {
        return formatBankRecord(record);
    }
    _createFinalPayload(override_metadata) {
        const filteredData = [...this.nonTradeReportFormArray.value].filter((r) => r.total_myr !== null);
        const { non_trade_categorization, monthly_totals } = createNonTradeCategorizations(filteredData, this.selectedAccountUIModel.nonTradeColumnMappings, this._alertService);
        this.selectedAccountMonthlyTotals = monthly_totals;
        const { account_id, account_name, account_number, bank_name, currency } = this.selectedAccountOtherDetails;
        const payload = {
            account_id,
            account_name,
            account_number,
            bank_name,
            currency,
            non_trade_categorization,
            monthly_totals,
            override_metadata: {
                ...override_metadata,
                date: nonTradeAddEntryDateFormatter(),
            },
        };
        this.componentStore.updateNonTradeReport({
            bankAccountId: account_id,
            payload,
        });
    }
    _setSelectedAccountDetails(accNumber) {
        const selectedAccount = this.nonTradeBankUIMap[accNumber];
        if (!selectedAccount) {
            console.error(`No selected account found : ${accNumber}`);
            return;
        }
        const { account_id, account_name, account_number, bank_name, currency, monthly_totals, override_metadata, uiModel, } = selectedAccount;
        this.selectedAccountUIModel = uiModel;
        this.selectedAccountOtherDetails = {
            account_id,
            account_name,
            account_number,
            bank_name,
            currency,
        };
        this.selectedAccountMonthlyTotals = monthly_totals;
        this.selectedAccountOverrideMetadata = isObjectValid(override_metadata)
            ? override_metadata
            : null;
        this.selectedAccountRefData.categories = this.selectedAccountUIModel.refData.categories;
        this.selectedAccountRefData.overrideReasons =
            this.selectedAccountUIModel.refData.overrideReasons;
        this.selectedAccountMonthlyTotalsDataLen = selectedAccount.monthly_totals?.data?.length;
    }
    _setupOverrideCDKTable() {
        if (this.selectedAccountOverrideMetadata) {
            this.overrideDataSource$.next([this.selectedAccountOverrideMetadata]);
            // this._cdr.detectChanges();
        }
    }
    _setupCDKTable() {
        if (!this.selectedAccountMonthlyTotalsDataLen) {
            return;
        }
        // set up table
        this.columns = this.selectedAccountUIModel.nonTradeColumns;
        this.displayedColumns = this.selectedAccountUIModel.nonTradeDisplayedColumns;
        this.columnMappings = this.selectedAccountUIModel.nonTradeColumnMappings;
        this.dataSource$.next([...this.selectedAccountUIModel.dataSource]);
        const data = [...this.selectedAccountUIModel.dataSource];
        // add monthly total row
        const monthlyTotalRow = this.calcMonthlyTotal(this.selectedAccountMonthlyTotalsDataLen, data);
        const filteredDataSource = data.filter((entry) => entry.transferFrom !== 'Monthly Total');
        this.dataSource$.next([...filteredDataSource, monthlyTotalRow]);
    }
    _calcTotalMyr() {
        this.nonTradeReportFormArray = this._fb.array([]);
        this.dataSource$.value.forEach((item) => {
            const fg = this._fb.group(item);
            this.nonTradeReportFormArray.push(fg);
            fg.valueChanges.pipe(takeUntil(this._destroy$)).subscribe((res) => {
                let newTotal = 0;
                for (const key in res) {
                    if (Object.prototype.hasOwnProperty.call(res, key)) {
                        const element = res[key];
                        if (this.isNumericValue(element) &&
                            key !== 'transferFrom' &&
                            key !== 'transferCategory' &&
                            key !== 'total_myr') {
                            newTotal += element;
                        }
                        fg.patchValue({ total_myr: newTotal }, { emitEvent: false });
                    }
                }
            });
        });
    }
    _calcMonthlyTotal() {
        if (!this.selectedAccountMonthlyTotalsDataLen) {
            const errMsg = 'Non Trade Report [monthlyTotalsDataLength] is null or undefined';
            this.errors = [...this.errors, errMsg];
            // this._cdr.detectChanges();
            console.error(errMsg);
            return;
        }
        else {
            this.errors = [];
        }
        this.nonTradeReportFormArray.valueChanges.pipe(takeUntil(this._destroy$)).subscribe(() => {
            const data = [...this.nonTradeReportFormArray.value];
            const monthlyTotalRow = this.calcMonthlyTotal(this.selectedAccountMonthlyTotalsDataLen, data);
            const monthlyTotalCtrl = this.nonTradeReportFormArray.controls.find((ctrl) => ctrl.value.transferFrom === 'Monthly Total');
            monthlyTotalCtrl?.patchValue(monthlyTotalRow, { emitEvent: false });
        });
    }
    _onAccountNumberChange() {
        this.nonTradeFG
            .get('account_number')
            ?.valueChanges.pipe(takeUntil(this._destroy$))
            .subscribe((accNumber) => {
            this._selectedAccPerfiosMetadata =
                (this._bankAccountsMap[accNumber] &&
                    this._bankAccountsMap[accNumber]?.perfios_metadata) ||
                    null;
            if (!this.nonTradeBankUIMap || !(accNumber in this.nonTradeBankUIMap)) {
                const errMsg = 'Non Trade Report is missing for selected Bank Account';
                this.errors = [...this.errors, errMsg];
                // this._cdr.detectChanges();
                throw new Error(errMsg);
            }
            this._setSelectedAccountDetails(accNumber);
            this._setupOverrideCDKTable();
            this._setupCDKTable();
            this._calcTotalMyr();
            this._calcMonthlyTotal();
            // this._cdr.detectChanges();
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWNonTradeTransactionsComponent, deps: [{ token: STORE_TOKEN$6 }, { token: i2.FormBuilder }, { token: i1$7.Dialog }, { token: i0.Injector }, { token: FSW_ALERT_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWNonTradeTransactionsComponent, selector: "fsw-non-trade-transactions", inputs: { isReadonly: "isReadonly" }, outputs: { saveChanges: "saveChanges" }, ngImport: i0, template: "<ng-container>\n  <section *ngIf=\"errors?.length\" class=\"bg-red-100 text-red-500 p-2 h-auto\">\n    <div class=\"text-[12px] p-1\" *ngFor=\"let err of errors\">\n      {{ err }}\n    </div>\n  </section>\n  <section [formGroup]=\"nonTradeFG\" class=\"flex justify-between w-[425px] items-end\">\n    <div class=\"m-2 max-w-[450px] w-[450px]\">\n      <fsw-field [fullWidth]=\"true\">\n        <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n          <label>\n            {{ 'Account Number' }}\n          </label>\n        </ng-template>\n        <fsw-select\n          [maxHeight]=\"'200px'\"\n          [placeHolder]=\"'Select Account Number'\"\n          formControlName=\"account_number\"\n        >\n          <ng-container *ngFor=\"let bankReport of componentStore.state().nonTradeBankReports\">\n            <ng-template\n              fswSelectItem\n              let-selected\n              [text]=\"formatBankRecordNonTrade(bankReport)\"\n              [value]=\"bankReport.account_id\"\n            ></ng-template>\n          </ng-container>\n        </fsw-select>\n      </fsw-field>\n    </div>\n    <div\n      *ngIf=\"selectedAccountUIModel\"\n      class=\"text-blue-400 cursor-pointer flex justify-between w-[100px]\"\n      (click)=\"openViewPerfiosMetadataModal()\"\n    >\n      <span>Company</span>\n      <span><i [fswIcon]=\"'common-information-circle'\"></i></span>\n    </div>\n  </section>\n  <div *ngIf=\"!selectedAccountUIModel\" class=\"bg-blue-100 text-blue-400 p-2 ml-1 mt-4 mb-4\">\n    <span class=\"text-center text-[14px]\"\n      >Please select an Account Number to view the Non-Trade Report</span\n    >\n  </div>\n  <ng-container>\n    <section *ngIf=\"selectedAccountUIModel\" class=\"flex justify-between mt-6\">\n      <header>\n        <h6>{{ 'Non-Trade Transaction Details' }}</h6>\n      </header>\n      <div class=\"flex justify-between gap-5\">\n        <ng-container *ngIf=\"!showEditMode\">\n          <button\n            fswButton\n            appearance=\"secondary\"\n            [disabled]=\"isReadonly\"\n            [size]=\"'s'\"\n            (click)=\"showEditMode = !showEditMode\"\n          >\n            {{ 'Edit Entries' }}\n          </button>\n        </ng-container>\n        <button\n          *ngIf=\"!showEditMode\"\n          fswButton\n          [disabled]=\"isReadonly\"\n          appearance=\"secondary\"\n          [size]=\"'s'\"\n          (click)=\"openAddEntryModal()\"\n        >\n          <i [fswIcon]=\"'common-add'\"></i>\n          {{ 'Add Entry' }}\n        </button>\n      </div>\n    </section>\n    <form class=\"ml-1 mt-2 flex flex-col gap-[16px]\">\n      <main class=\"flex flex-col gap-[16px] w-full\">\n        <section>\n          <table\n            *ngIf=\"!showEditMode\"\n            cdk-table\n            [dataSource]=\"(dataSource$ | async) || []\"\n            class=\"summary-table\"\n            role=\"grid\"\n          >\n            <caption></caption>\n            <ng-container *ngFor=\"let column of displayedColumns\" [cdkColumnDef]=\"column\">\n              <th cdk-header-cell *cdkHeaderCellDef class=\"column-header\">{{ column }}</th>\n              <td\n                cdk-cell\n                *cdkCellDef=\"let row\"\n                class=\"column-cell\"\n                [class.numeric-value]=\"isNumericValue(row[columnMappings[column]])\"\n              >\n                <span *ngIf=\"isNumericValue(row[columnMappings[column]])\">\n                  {{\n                    row[columnMappings[column]] > 0\n                      ? (row[columnMappings[column]] | currency : 'USD' | slice : 1)\n                      : (row[columnMappings[column]] | removeCurrencySymbol | number : '1.2-2')\n                  }}\n                </span>\n                <span\n                  *ngIf=\"\n                    row[columnMappings[column]] && !isNumericValue(row[columnMappings[column]])\n                  \"\n                >\n                  {{\n                    selectedAccountRefData.categories.includes(row['transferFrom']) &&\n                    row['isCategory'] === true\n                      ? row[columnMappings[column]].toString().toUpperCase()\n                      : row[columnMappings[column]]\n                  }}\n                </span>\n              </td>\n            </ng-container>\n\n            <tr cdk-header-row *cdkHeaderRowDef=\"displayedColumns\"></tr>\n            <tr\n              cdk-row\n              *cdkRowDef=\"let row; columns: displayedColumns\"\n              [class]=\"row.total_myr === null ? 'sub-header' : null\"\n              [class.total]=\"row?.transferFrom === 'Monthly Total'\"\n            >\n              {{\n                row\n              }}\n            </tr>\n          </table>\n\n          <table\n            *ngIf=\"showEditMode\"\n            cdk-table\n            [dataSource]=\"nonTradeReportFormArray.controls\"\n            class=\"summary-table\"\n            role=\"grid\"\n          >\n            <caption></caption>\n            <ng-container\n              *ngFor=\"let column of displayedColumns; let i = index\"\n              [cdkColumnDef]=\"column\"\n            >\n              <th cdk-header-cell *cdkHeaderCellDef class=\"column-header\">{{ column }}</th>\n              <td\n                cdk-cell\n                *cdkCellDef=\"let row\"\n                class=\"column-cell\"\n                [class.numeric-value]=\"isNumericValue(row.get(columnMappings[column]).value)\"\n              >\n                <ng-container\n                  *ngIf=\"\n                    i === displayedColumns.length - 1 ||\n                    row.get(columnMappings[column]) === null ||\n                    row.get('transferFrom').value === 'Monthly Total' ||\n                    (selectedAccountRefData.categories?.includes(row.get('transferFrom').value) &&\n                      row.get('isCategory').value === true)\n                  \"\n                >\n                  <span *ngIf=\"isNumericValue(row.get(columnMappings[column]).value)\">\n                    {{\n                      row.get(columnMappings[column]).value > 0\n                        ? (row.get(columnMappings[column]).value | currency : 'USD' | slice : 1)\n                        : (row.get(columnMappings[column]).value\n                          | removeCurrencySymbol\n                          | number : '1.2-2')\n                    }}\n                  </span>\n                  <span\n                    *ngIf=\"\n                      row.get(columnMappings[column]) &&\n                      row.get(columnMappings[column]).value &&\n                      !isNumericValue(row.get(columnMappings[column]).value)\n                    \"\n                  >\n                    <b>{{ row.get(columnMappings[column]).value.toString().toUpperCase() }}</b>\n                  </span>\n                </ng-container>\n\n                <ng-container\n                  *ngIf=\"\n                    i !== displayedColumns.length - 1 &&\n                    row.get(columnMappings[column]) !== null &&\n                    row.get(columnMappings[column]).value !== null &&\n                    row.get('transferFrom').value !== 'Monthly Total' &&\n                    row.get('isCategory').value === false\n                  \"\n                >\n                  <input\n                    *ngIf=\"!isNumericValue(row.get(columnMappings[column]).value)\"\n                    type=\"text\"\n                    [formControl]=\"row.get(columnMappings[column])\"\n                  />\n                  <input\n                    *ngIf=\"isNumericValue(row.get(columnMappings[column]).value)\"\n                    fswCurrencyMask\n                    [options]=\"{ prefix: '', allowNegative: false, align: 'right' }\"\n                    type=\"text\"\n                    [formControl]=\"row.get(columnMappings[column])\"\n                  />\n                </ng-container>\n              </td>\n            </ng-container>\n\n            <tr cdk-header-row *cdkHeaderRowDef=\"displayedColumns\"></tr>\n            <tr cdk-row *cdkRowDef=\"let row; columns: displayedColumns\"></tr>\n          </table>\n        </section>\n\n        <section class=\"flex justify-between\">\n          <div></div>\n          <div>\n            <button\n              *ngIf=\"selectedAccountUIModel && showEditMode\"\n              fswButton\n              [disabled]=\"isReadonly\"\n              (click)=\"onSaveChanges($event)\"\n            >\n              {{ 'Save' }}\n            </button>\n          </div>\n        </section>\n      </main>\n    </form>\n  </ng-container>\n\n  <section *ngIf=\"selectedAccountOverrideMetadata\">\n    <header>\n      <h6>{{ 'Manual Override Justification' }}</h6>\n    </header>\n\n    <table\n      cdk-table\n      [dataSource]=\"(overrideDataSource$ | async) || []\"\n      class=\"override-table mt-2\"\n      role=\"grid\"\n    >\n      <ng-container *ngFor=\"let column of overrideDisplayedColumns\" [cdkColumnDef]=\"column\">\n        <th cdk-header-cell *cdkHeaderCellDef class=\"column-header\">{{ column }}</th>\n        <td cdk-cell *cdkCellDef=\"let row\" class=\"column-cell\">\n          <span>\n            {{ row[overrideColumnMappings[column]] }}\n          </span>\n        </td>\n      </ng-container>\n\n      <tr cdk-header-row *cdkHeaderRowDef=\"overrideDisplayedColumns\"></tr>\n      <tr cdk-row *cdkRowDef=\"let row; columns: overrideDisplayedColumns\"></tr>\n    </table>\n  </section>\n</ng-container>\n", styles: ["table{width:100%;border-collapse:collapse}table th,table td{padding:10px;text-align:left;border-bottom:1px solid #ddd;border-top:1px solid #ddd;font-size:90%}table th:first-child,table td:first-child{border-left:1px solid #ddd}table th:last-child,table td:last-child{border-right:1px solid #ddd}table th.numeric-value,table td.numeric-value{text-align:right}table th input[type=text],table td input[type=text]{border:1px solid #ddd;border-radius:5px;padding:5px;width:100%;font-size:90%}table th{font-weight:700;font-weight:500}table td{font-size:80%}.summary-table .cdk-header-cell{width:4%}.summary-table tr.sub-header{background-color:#f9f9f9;font-weight:500}.summary-table tr:hover{background-color:#e6e6e6}.summary-table .column-header:not(:first-child){text-align:right}.summary-table tr.total{background-color:#f3f5fd}.override-table th.cdk-column-Date,.override-table td.cdk-column-Date,.override-table th.cdk-column-Credit-Manager,.override-table td.cdk-column-Credit-Manager{width:15%}.override-table th.cdk-column-Justification,.override-table td.cdk-column-Justification{width:70%}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: CurrencyMaskDirective, selector: "[fswCurrencyMask]", inputs: ["max", "min", "options"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "component", type: i6$1.CdkTable, selector: "cdk-table, table[cdk-table]", inputs: ["trackBy", "dataSource", "multiTemplateDataRows", "fixedLayout"], outputs: ["contentChanged"], exportAs: ["cdkTable"] }, { kind: "directive", type: i6$1.CdkRowDef, selector: "[cdkRowDef]", inputs: ["cdkRowDefColumns", "cdkRowDefWhen"] }, { kind: "directive", type: i6$1.CdkCellDef, selector: "[cdkCellDef]" }, { kind: "directive", type: i6$1.CdkHeaderCellDef, selector: "[cdkHeaderCellDef]" }, { kind: "directive", type: i6$1.CdkColumnDef, selector: "[cdkColumnDef]", inputs: ["sticky", "cdkColumnDef", "stickyEnd"] }, { kind: "directive", type: i6$1.CdkCell, selector: "cdk-cell, td[cdk-cell]" }, { kind: "component", type: i6$1.CdkRow, selector: "cdk-row, tr[cdk-row]" }, { kind: "directive", type: i6$1.CdkHeaderCell, selector: "cdk-header-cell, th[cdk-header-cell]" }, { kind: "component", type: i6$1.CdkHeaderRow, selector: "cdk-header-row, tr[cdk-header-row]" }, { kind: "directive", type: i6$1.CdkHeaderRowDef, selector: "[cdkHeaderRowDef]", inputs: ["cdkHeaderRowDef", "cdkHeaderRowDefSticky"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$4.FSWFieldHeaderPrefixDirective, selector: "ng-template[fswFieldHeaderPrefix]", inputs: ["kind", "label", "required"] }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i1$1.SlicePipe, name: "slice" }, { kind: "pipe", type: i1$1.DecimalPipe, name: "number" }, { kind: "pipe", type: i1$1.CurrencyPipe, name: "currency" }, { kind: "pipe", type: RemoveCurrencySymbolPipe, name: "removeCurrencySymbol" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWNonTradeTransactionsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-non-trade-transactions', template: "<ng-container>\n  <section *ngIf=\"errors?.length\" class=\"bg-red-100 text-red-500 p-2 h-auto\">\n    <div class=\"text-[12px] p-1\" *ngFor=\"let err of errors\">\n      {{ err }}\n    </div>\n  </section>\n  <section [formGroup]=\"nonTradeFG\" class=\"flex justify-between w-[425px] items-end\">\n    <div class=\"m-2 max-w-[450px] w-[450px]\">\n      <fsw-field [fullWidth]=\"true\">\n        <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n          <label>\n            {{ 'Account Number' }}\n          </label>\n        </ng-template>\n        <fsw-select\n          [maxHeight]=\"'200px'\"\n          [placeHolder]=\"'Select Account Number'\"\n          formControlName=\"account_number\"\n        >\n          <ng-container *ngFor=\"let bankReport of componentStore.state().nonTradeBankReports\">\n            <ng-template\n              fswSelectItem\n              let-selected\n              [text]=\"formatBankRecordNonTrade(bankReport)\"\n              [value]=\"bankReport.account_id\"\n            ></ng-template>\n          </ng-container>\n        </fsw-select>\n      </fsw-field>\n    </div>\n    <div\n      *ngIf=\"selectedAccountUIModel\"\n      class=\"text-blue-400 cursor-pointer flex justify-between w-[100px]\"\n      (click)=\"openViewPerfiosMetadataModal()\"\n    >\n      <span>Company</span>\n      <span><i [fswIcon]=\"'common-information-circle'\"></i></span>\n    </div>\n  </section>\n  <div *ngIf=\"!selectedAccountUIModel\" class=\"bg-blue-100 text-blue-400 p-2 ml-1 mt-4 mb-4\">\n    <span class=\"text-center text-[14px]\"\n      >Please select an Account Number to view the Non-Trade Report</span\n    >\n  </div>\n  <ng-container>\n    <section *ngIf=\"selectedAccountUIModel\" class=\"flex justify-between mt-6\">\n      <header>\n        <h6>{{ 'Non-Trade Transaction Details' }}</h6>\n      </header>\n      <div class=\"flex justify-between gap-5\">\n        <ng-container *ngIf=\"!showEditMode\">\n          <button\n            fswButton\n            appearance=\"secondary\"\n            [disabled]=\"isReadonly\"\n            [size]=\"'s'\"\n            (click)=\"showEditMode = !showEditMode\"\n          >\n            {{ 'Edit Entries' }}\n          </button>\n        </ng-container>\n        <button\n          *ngIf=\"!showEditMode\"\n          fswButton\n          [disabled]=\"isReadonly\"\n          appearance=\"secondary\"\n          [size]=\"'s'\"\n          (click)=\"openAddEntryModal()\"\n        >\n          <i [fswIcon]=\"'common-add'\"></i>\n          {{ 'Add Entry' }}\n        </button>\n      </div>\n    </section>\n    <form class=\"ml-1 mt-2 flex flex-col gap-[16px]\">\n      <main class=\"flex flex-col gap-[16px] w-full\">\n        <section>\n          <table\n            *ngIf=\"!showEditMode\"\n            cdk-table\n            [dataSource]=\"(dataSource$ | async) || []\"\n            class=\"summary-table\"\n            role=\"grid\"\n          >\n            <caption></caption>\n            <ng-container *ngFor=\"let column of displayedColumns\" [cdkColumnDef]=\"column\">\n              <th cdk-header-cell *cdkHeaderCellDef class=\"column-header\">{{ column }}</th>\n              <td\n                cdk-cell\n                *cdkCellDef=\"let row\"\n                class=\"column-cell\"\n                [class.numeric-value]=\"isNumericValue(row[columnMappings[column]])\"\n              >\n                <span *ngIf=\"isNumericValue(row[columnMappings[column]])\">\n                  {{\n                    row[columnMappings[column]] > 0\n                      ? (row[columnMappings[column]] | currency : 'USD' | slice : 1)\n                      : (row[columnMappings[column]] | removeCurrencySymbol | number : '1.2-2')\n                  }}\n                </span>\n                <span\n                  *ngIf=\"\n                    row[columnMappings[column]] && !isNumericValue(row[columnMappings[column]])\n                  \"\n                >\n                  {{\n                    selectedAccountRefData.categories.includes(row['transferFrom']) &&\n                    row['isCategory'] === true\n                      ? row[columnMappings[column]].toString().toUpperCase()\n                      : row[columnMappings[column]]\n                  }}\n                </span>\n              </td>\n            </ng-container>\n\n            <tr cdk-header-row *cdkHeaderRowDef=\"displayedColumns\"></tr>\n            <tr\n              cdk-row\n              *cdkRowDef=\"let row; columns: displayedColumns\"\n              [class]=\"row.total_myr === null ? 'sub-header' : null\"\n              [class.total]=\"row?.transferFrom === 'Monthly Total'\"\n            >\n              {{\n                row\n              }}\n            </tr>\n          </table>\n\n          <table\n            *ngIf=\"showEditMode\"\n            cdk-table\n            [dataSource]=\"nonTradeReportFormArray.controls\"\n            class=\"summary-table\"\n            role=\"grid\"\n          >\n            <caption></caption>\n            <ng-container\n              *ngFor=\"let column of displayedColumns; let i = index\"\n              [cdkColumnDef]=\"column\"\n            >\n              <th cdk-header-cell *cdkHeaderCellDef class=\"column-header\">{{ column }}</th>\n              <td\n                cdk-cell\n                *cdkCellDef=\"let row\"\n                class=\"column-cell\"\n                [class.numeric-value]=\"isNumericValue(row.get(columnMappings[column]).value)\"\n              >\n                <ng-container\n                  *ngIf=\"\n                    i === displayedColumns.length - 1 ||\n                    row.get(columnMappings[column]) === null ||\n                    row.get('transferFrom').value === 'Monthly Total' ||\n                    (selectedAccountRefData.categories?.includes(row.get('transferFrom').value) &&\n                      row.get('isCategory').value === true)\n                  \"\n                >\n                  <span *ngIf=\"isNumericValue(row.get(columnMappings[column]).value)\">\n                    {{\n                      row.get(columnMappings[column]).value > 0\n                        ? (row.get(columnMappings[column]).value | currency : 'USD' | slice : 1)\n                        : (row.get(columnMappings[column]).value\n                          | removeCurrencySymbol\n                          | number : '1.2-2')\n                    }}\n                  </span>\n                  <span\n                    *ngIf=\"\n                      row.get(columnMappings[column]) &&\n                      row.get(columnMappings[column]).value &&\n                      !isNumericValue(row.get(columnMappings[column]).value)\n                    \"\n                  >\n                    <b>{{ row.get(columnMappings[column]).value.toString().toUpperCase() }}</b>\n                  </span>\n                </ng-container>\n\n                <ng-container\n                  *ngIf=\"\n                    i !== displayedColumns.length - 1 &&\n                    row.get(columnMappings[column]) !== null &&\n                    row.get(columnMappings[column]).value !== null &&\n                    row.get('transferFrom').value !== 'Monthly Total' &&\n                    row.get('isCategory').value === false\n                  \"\n                >\n                  <input\n                    *ngIf=\"!isNumericValue(row.get(columnMappings[column]).value)\"\n                    type=\"text\"\n                    [formControl]=\"row.get(columnMappings[column])\"\n                  />\n                  <input\n                    *ngIf=\"isNumericValue(row.get(columnMappings[column]).value)\"\n                    fswCurrencyMask\n                    [options]=\"{ prefix: '', allowNegative: false, align: 'right' }\"\n                    type=\"text\"\n                    [formControl]=\"row.get(columnMappings[column])\"\n                  />\n                </ng-container>\n              </td>\n            </ng-container>\n\n            <tr cdk-header-row *cdkHeaderRowDef=\"displayedColumns\"></tr>\n            <tr cdk-row *cdkRowDef=\"let row; columns: displayedColumns\"></tr>\n          </table>\n        </section>\n\n        <section class=\"flex justify-between\">\n          <div></div>\n          <div>\n            <button\n              *ngIf=\"selectedAccountUIModel && showEditMode\"\n              fswButton\n              [disabled]=\"isReadonly\"\n              (click)=\"onSaveChanges($event)\"\n            >\n              {{ 'Save' }}\n            </button>\n          </div>\n        </section>\n      </main>\n    </form>\n  </ng-container>\n\n  <section *ngIf=\"selectedAccountOverrideMetadata\">\n    <header>\n      <h6>{{ 'Manual Override Justification' }}</h6>\n    </header>\n\n    <table\n      cdk-table\n      [dataSource]=\"(overrideDataSource$ | async) || []\"\n      class=\"override-table mt-2\"\n      role=\"grid\"\n    >\n      <ng-container *ngFor=\"let column of overrideDisplayedColumns\" [cdkColumnDef]=\"column\">\n        <th cdk-header-cell *cdkHeaderCellDef class=\"column-header\">{{ column }}</th>\n        <td cdk-cell *cdkCellDef=\"let row\" class=\"column-cell\">\n          <span>\n            {{ row[overrideColumnMappings[column]] }}\n          </span>\n        </td>\n      </ng-container>\n\n      <tr cdk-header-row *cdkHeaderRowDef=\"overrideDisplayedColumns\"></tr>\n      <tr cdk-row *cdkRowDef=\"let row; columns: overrideDisplayedColumns\"></tr>\n    </table>\n  </section>\n</ng-container>\n", styles: ["table{width:100%;border-collapse:collapse}table th,table td{padding:10px;text-align:left;border-bottom:1px solid #ddd;border-top:1px solid #ddd;font-size:90%}table th:first-child,table td:first-child{border-left:1px solid #ddd}table th:last-child,table td:last-child{border-right:1px solid #ddd}table th.numeric-value,table td.numeric-value{text-align:right}table th input[type=text],table td input[type=text]{border:1px solid #ddd;border-radius:5px;padding:5px;width:100%;font-size:90%}table th{font-weight:700;font-weight:500}table td{font-size:80%}.summary-table .cdk-header-cell{width:4%}.summary-table tr.sub-header{background-color:#f9f9f9;font-weight:500}.summary-table tr:hover{background-color:#e6e6e6}.summary-table .column-header:not(:first-child){text-align:right}.summary-table tr.total{background-color:#f3f5fd}.override-table th.cdk-column-Date,.override-table td.cdk-column-Date,.override-table th.cdk-column-Credit-Manager,.override-table td.cdk-column-Credit-Manager{width:15%}.override-table th.cdk-column-Justification,.override-table td.cdk-column-Justification{width:70%}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [STORE_TOKEN$6]
                }] }, { type: i2.FormBuilder }, { type: i1$7.Dialog }, { type: i0.Injector }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }]; }, propDecorators: { isReadonly: [{
                type: Input
            }], saveChanges: [{
                type: Output
            }] } });

// @angular
class FSWBankStatementAnalysisComponent {
    set applicationId(value) {
        this._componentStore.updateState({
            applicationId: value,
        });
        // this._cdr.detectChanges();
    }
    set username(value) {
        this._componentStore.updateState({
            username: value,
        });
        // this._cdr.detectChanges();
    }
    set hiddenComments(value) {
        this._componentStore.updateState({
            hiddenComments: value,
        });
        // this._cdr.detectChanges();
    }
    set useMock(value) {
        this._componentStore.updateState({
            useMock: value,
        });
        // this._cdr.detectChanges();
    }
    set isReadonly(value) {
        this._isReadonly = value;
    }
    get isReadonly() {
        return this._isReadonly;
    }
    set showGST(value) {
        this._showGST = value;
    }
    get showGST() {
        return this._showGST;
    }
    set viewDocs(value) {
        this._viewDocs = value;
    }
    get viewDocs() {
        return this._viewDocs;
    }
    constructor(_componentStore, _scope, _translateService) {
        this._componentStore = _componentStore;
        this._scope = _scope;
        this._translateService = _translateService;
        this._isReadonly = false;
        this._showGST = false;
        this._viewDocs = false;
        this.displayTabsConfig = {
            accounts_and_statements: true,
            analysis_reports: true,
            non_trade_reports: true,
        };
        this._destroySubject = new Subject();
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'header'),
            this._translateService.selectFeatureTranslate(this._scope, 'comment'),
        ]).pipe(map(([header, comment]) => ({
            header,
            comment,
        })));
        this.state$ = this._componentStore.state$;
        this._componentStore.init();
        this.loadComments();
    }
    ngOnDestroy() {
        if (this._destroySubject) {
            this._destroySubject.next(0);
            this._destroySubject.complete();
        }
        this._componentStore.clearCache();
    }
    loadComments() {
        this._translateService
            .selectFeatureTranslate(this._scope, 'comment')
            .pipe(tap((comment) => {
            this._componentStore.loadComments(comment);
        }), takeUntil(this._destroySubject))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBankStatementAnalysisComponent, deps: [{ token: STORE_TOKEN$6 }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWBankStatementAnalysisComponent, selector: "fsw-bank-statement-analysis", inputs: { applicationId: "applicationId", username: "username", hiddenComments: "hiddenComments", useMock: "useMock", isReadonly: "isReadonly", showGST: "showGST", viewDocs: "viewDocs", displayTabsConfig: "displayTabsConfig" }, providers: [
            {
                provide: TRANSLOCO_SCOPE,
                useValue: {
                    scope: 'bank-statement-analysis',
                    loader: TRANSLATION_LOADER$4,
                },
            },
            {
                provide: TRANSLOCO_LANG,
                useValue: getCountryCodeFromStorage(),
            },
            {
                provide: TranslocoFeatureHttpLoader,
                useClass: TranslocoFeatureHttpLoader,
            },
            ...bankStatementAnalysisProviders(getCountryCodeFromStorage()),
            bankStatementAnalysisTranslation(),
        ], ngImport: i0, template: `
    <div class="w-100" *ngIf="state$ | async as state">
      <section *ngIf="translate$ | async as translate">
        <fsw-tabs-group [customRowGap]="'24px'" [customColumnGap]="'24px'">
          <ng-template
            fswTabs
            *ngIf="displayTabsConfig?.accounts_and_statements"
            [key]="'accounts_and_statements'"
            [maxTextWidth]="'unset'"
            [label]="translate.header.accounts_and_statements"
          >
            <fsw-bank-accounts-and-statements
              [isReadonly]="isReadonly"
            ></fsw-bank-accounts-and-statements>
          </ng-template>
          <ng-template
            fswTabs
            *ngIf="displayTabsConfig?.analysis_reports"
            [key]="'analysis_reports'"
            [maxTextWidth]="'unset'"
            [label]="translate.header.analysis_reports"
          >
            <fsw-bank-tabulations
              [showGST]="showGST"
              [viewDocs]="viewDocs"
              [isReadonly]="isReadonly"
            ></fsw-bank-tabulations>
          </ng-template>
          <ng-template
            fswTabs
            *ngIf="displayTabsConfig?.non_trade_reports"
            [key]="'non_trade_reports'"
            [maxTextWidth]="'unset'"
            [label]="translate.header.non_trade_reports"
          >
            <fsw-non-trade-transactions [isReadonly]="isReadonly"></fsw-non-trade-transactions>
          </ng-template>
        </fsw-tabs-group>
        <fsw-comments-section
          [data]="state.comments"
          [enableSaveButton]="true"
          [isReadonly]="isReadonly"
          [translateScope]="'bank_statement_analysis'"
        ></fsw-comments-section>
      </section>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$4.FSWTabsGroupComponent, selector: "fsw-tabs-group" }, { kind: "directive", type: i1$4.FSWTabsDirective, selector: "ng-template[fswTabs]" }, { kind: "component", type: FSWBankAccountsAndStatementsComponent, selector: "fsw-bank-accounts-and-statements", inputs: ["isReadonly"] }, { kind: "component", type: FSWBankTabulationsComponent, selector: "fsw-bank-tabulations", inputs: ["isReadonly", "showGST", "viewDocs"] }, { kind: "component", type: FSWNonTradeTransactionsComponent, selector: "fsw-non-trade-transactions", inputs: ["isReadonly"], outputs: ["saveChanges"] }, { kind: "component", type: FSWCommentsSectionComponent, selector: "fsw-comments-section", inputs: ["data", "customClasses", "translateScope", "isReadonly", "enableSaveButton"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBankStatementAnalysisComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-bank-statement-analysis',
                    template: `
    <div class="w-100" *ngIf="state$ | async as state">
      <section *ngIf="translate$ | async as translate">
        <fsw-tabs-group [customRowGap]="'24px'" [customColumnGap]="'24px'">
          <ng-template
            fswTabs
            *ngIf="displayTabsConfig?.accounts_and_statements"
            [key]="'accounts_and_statements'"
            [maxTextWidth]="'unset'"
            [label]="translate.header.accounts_and_statements"
          >
            <fsw-bank-accounts-and-statements
              [isReadonly]="isReadonly"
            ></fsw-bank-accounts-and-statements>
          </ng-template>
          <ng-template
            fswTabs
            *ngIf="displayTabsConfig?.analysis_reports"
            [key]="'analysis_reports'"
            [maxTextWidth]="'unset'"
            [label]="translate.header.analysis_reports"
          >
            <fsw-bank-tabulations
              [showGST]="showGST"
              [viewDocs]="viewDocs"
              [isReadonly]="isReadonly"
            ></fsw-bank-tabulations>
          </ng-template>
          <ng-template
            fswTabs
            *ngIf="displayTabsConfig?.non_trade_reports"
            [key]="'non_trade_reports'"
            [maxTextWidth]="'unset'"
            [label]="translate.header.non_trade_reports"
          >
            <fsw-non-trade-transactions [isReadonly]="isReadonly"></fsw-non-trade-transactions>
          </ng-template>
        </fsw-tabs-group>
        <fsw-comments-section
          [data]="state.comments"
          [enableSaveButton]="true"
          [isReadonly]="isReadonly"
          [translateScope]="'bank_statement_analysis'"
        ></fsw-comments-section>
      </section>
    </div>
  `,
                    // changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [
                        {
                            provide: TRANSLOCO_SCOPE,
                            useValue: {
                                scope: 'bank-statement-analysis',
                                loader: TRANSLATION_LOADER$4,
                            },
                        },
                        {
                            provide: TRANSLOCO_LANG,
                            useValue: getCountryCodeFromStorage(),
                        },
                        {
                            provide: TranslocoFeatureHttpLoader,
                            useClass: TranslocoFeatureHttpLoader,
                        },
                        ...bankStatementAnalysisProviders(getCountryCodeFromStorage()),
                        bankStatementAnalysisTranslation(),
                    ],
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [STORE_TOKEN$6]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }]; }, propDecorators: { applicationId: [{
                type: Input
            }], username: [{
                type: Input
            }], hiddenComments: [{
                type: Input
            }], useMock: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], showGST: [{
                type: Input
            }], viewDocs: [{
                type: Input
            }], displayTabsConfig: [{
                type: Input
            }] } });

const DECLARATIONS_EXPORTS$9 = [FSWBankAccountsAndStatementsComponent];
class FSWBankAccountsAndStatementsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBankAccountsAndStatementsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWBankAccountsAndStatementsModule, declarations: [FSWBankAccountsAndStatementsComponent], imports: [CommonModule,
            // ngrx
            LetDirective,
            // translate
            TranslocoModule,
            FSWButtonModule,
            FSWIconModule,
            // modals
            FSWAddBankAccountModalModule,
            FSWUploadBankStatementModalModule,
            FSWDeleteBankAccountModule,
            FSWEditBankAccountModalModule,
            FSWCloneBankAccountModalModule,
            FSWViewErrorBankAccountModalModule,
            FSWResendToPerfiosModalModule,
            FSWConfirmBankAccountModalModule,
            MatTableModule,
            FSWTooltipModule,
            CdkMenuModule,
            FSWClipboardModule], exports: [FSWBankAccountsAndStatementsComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBankAccountsAndStatementsModule, imports: [CommonModule,
            // translate
            TranslocoModule,
            FSWButtonModule,
            FSWIconModule,
            // modals
            FSWAddBankAccountModalModule,
            FSWUploadBankStatementModalModule,
            FSWDeleteBankAccountModule,
            FSWEditBankAccountModalModule,
            FSWCloneBankAccountModalModule,
            FSWViewErrorBankAccountModalModule,
            FSWResendToPerfiosModalModule,
            FSWConfirmBankAccountModalModule,
            MatTableModule,
            FSWTooltipModule,
            CdkMenuModule,
            FSWClipboardModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBankAccountsAndStatementsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        // ngrx
                        LetDirective,
                        // translate
                        TranslocoModule,
                        FSWButtonModule,
                        FSWIconModule,
                        // modals
                        FSWAddBankAccountModalModule,
                        FSWUploadBankStatementModalModule,
                        FSWDeleteBankAccountModule,
                        FSWEditBankAccountModalModule,
                        FSWCloneBankAccountModalModule,
                        FSWViewErrorBankAccountModalModule,
                        FSWResendToPerfiosModalModule,
                        FSWConfirmBankAccountModalModule,
                        MatTableModule,
                        FSWTooltipModule,
                        CdkMenuModule,
                        FSWClipboardModule,
                    ],
                    declarations: DECLARATIONS_EXPORTS$9,
                    exports: DECLARATIONS_EXPORTS$9,
                }]
        }] });

const DECLARATIONS_EXPORTS$8 = [FSWSummaryBankTabulationComponent];
class FSWSummaryBankTabulationModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSummaryBankTabulationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWSummaryBankTabulationModule, declarations: [FSWSummaryBankTabulationComponent], imports: [CommonModule,
            ReactiveFormsModule,
            LetDirective,
            FormWidgetModule,
            // services
            UtilsServiceModule,
            BankTabulationsServiceModule,
            //
            FSWCurrencyMaskModule,
            FSWInputModule,
            FSWButtonModule,
            FSWDateTimePickerModule,
            FSWPanelModule,
            FSWIconModule,
            CdkTableModule,
            FSWModalModule$1,
            DialogModule,
            RemoveCurrencySymbolModule,
            FSWSelectModule,
            FSWGstComponent], exports: [FSWSummaryBankTabulationComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSummaryBankTabulationModule, providers: [CurrencyPipe], imports: [CommonModule,
            ReactiveFormsModule,
            FormWidgetModule,
            // services
            UtilsServiceModule,
            BankTabulationsServiceModule,
            //
            FSWCurrencyMaskModule,
            FSWInputModule,
            FSWButtonModule,
            FSWDateTimePickerModule,
            FSWPanelModule,
            FSWIconModule,
            CdkTableModule,
            FSWModalModule$1,
            DialogModule,
            RemoveCurrencySymbolModule,
            FSWSelectModule,
            FSWGstComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSummaryBankTabulationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        LetDirective,
                        FormWidgetModule,
                        // services
                        UtilsServiceModule,
                        BankTabulationsServiceModule,
                        //
                        FSWCurrencyMaskModule,
                        FSWInputModule,
                        FSWButtonModule,
                        FSWDateTimePickerModule,
                        FSWPanelModule,
                        FSWIconModule,
                        CdkTableModule,
                        FSWModalModule$1,
                        DialogModule,
                        RemoveCurrencySymbolModule,
                        FSWSelectModule,
                        FSWGstComponent,
                    ],
                    declarations: DECLARATIONS_EXPORTS$8,
                    exports: DECLARATIONS_EXPORTS$8,
                    providers: [CurrencyPipe],
                }]
        }] });

const DECLARATIONS_EXPORTS$7 = [FSWBankTabulationsComponent];
class FSWBankTabulationsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBankTabulationsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWBankTabulationsModule, declarations: [FSWBankTabulationsComponent], imports: [CommonModule,
            ReactiveFormsModule,
            LetDirective,
            FSWFieldModule,
            FSWSelectModule,
            TranslocoModule,
            FSWDateTimePickerModule,
            FSWCheckboxModule,
            FSWCurrencyMaskModule,
            // cdk tables
            FSWBankTabulationDetailModule,
            FSWSummaryBankTabulationModule,
            FSWButtonModule,
            FSWGstComponent,
            FSWDocViewerModule], exports: [FSWBankTabulationsComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBankTabulationsModule, providers: [CurrencyPipe], imports: [CommonModule,
            ReactiveFormsModule,
            FSWFieldModule,
            FSWSelectModule,
            TranslocoModule,
            FSWDateTimePickerModule,
            FSWCheckboxModule,
            FSWCurrencyMaskModule,
            // cdk tables
            FSWBankTabulationDetailModule,
            FSWSummaryBankTabulationModule,
            FSWButtonModule,
            FSWGstComponent,
            FSWDocViewerModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBankTabulationsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        LetDirective,
                        FSWFieldModule,
                        FSWSelectModule,
                        TranslocoModule,
                        FSWDateTimePickerModule,
                        FSWCheckboxModule,
                        FSWCurrencyMaskModule,
                        // cdk tables
                        FSWBankTabulationDetailModule,
                        FSWSummaryBankTabulationModule,
                        FSWButtonModule,
                        FSWGstComponent,
                        FSWDocViewerModule,
                    ],
                    declarations: DECLARATIONS_EXPORTS$7,
                    exports: DECLARATIONS_EXPORTS$7,
                    providers: [CurrencyPipe],
                }]
        }] });

const DECLARATIONS_EXPORTS$6 = [FSWNonTradeTransactionsComponent];
class FSWNonTradeTransactionsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWNonTradeTransactionsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWNonTradeTransactionsModule, declarations: [FSWNonTradeTransactionsComponent], imports: [CommonModule,
            ReactiveFormsModule,
            LetDirective,
            FormWidgetModule,
            // services
            UtilsServiceModule,
            BankTabulationsServiceModule,
            //
            FSWCurrencyMaskModule,
            FSWInputModule,
            FSWButtonModule,
            FSWDateTimePickerModule,
            FSWPanelModule,
            FSWIconModule,
            CdkTableModule,
            FSWModalModule$1,
            DialogModule,
            RemoveCurrencySymbolModule,
            //
            FSWFieldModule,
            FSWSelectModule,
            TranslocoModule,
            FSWCheckboxModule,
            //
            FSWNonTradeAddEntryModule,
            FSWManualOverrideModule,
            FSWViewPerfiosMetadataModalModule], exports: [FSWNonTradeTransactionsComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWNonTradeTransactionsModule, providers: [CurrencyPipe], imports: [CommonModule,
            ReactiveFormsModule,
            FormWidgetModule,
            // services
            UtilsServiceModule,
            BankTabulationsServiceModule,
            //
            FSWCurrencyMaskModule,
            FSWInputModule,
            FSWButtonModule,
            FSWDateTimePickerModule,
            FSWPanelModule,
            FSWIconModule,
            CdkTableModule,
            FSWModalModule$1,
            DialogModule,
            RemoveCurrencySymbolModule,
            //
            FSWFieldModule,
            FSWSelectModule,
            TranslocoModule,
            FSWCheckboxModule,
            //
            FSWNonTradeAddEntryModule,
            FSWManualOverrideModule,
            FSWViewPerfiosMetadataModalModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWNonTradeTransactionsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        LetDirective,
                        FormWidgetModule,
                        // services
                        UtilsServiceModule,
                        BankTabulationsServiceModule,
                        //
                        FSWCurrencyMaskModule,
                        FSWInputModule,
                        FSWButtonModule,
                        FSWDateTimePickerModule,
                        FSWPanelModule,
                        FSWIconModule,
                        CdkTableModule,
                        FSWModalModule$1,
                        DialogModule,
                        RemoveCurrencySymbolModule,
                        //
                        FSWFieldModule,
                        FSWSelectModule,
                        TranslocoModule,
                        FSWCheckboxModule,
                        //
                        FSWNonTradeAddEntryModule,
                        FSWManualOverrideModule,
                        FSWViewPerfiosMetadataModalModule,
                    ],
                    declarations: DECLARATIONS_EXPORTS$6,
                    exports: DECLARATIONS_EXPORTS$6,
                    providers: [CurrencyPipe],
                }]
        }] });

// @angular
const DECLARATIONS_EXPORTS$5 = [FSWBankStatementAnalysisComponent];
class FSWBankStatementAnalysisModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBankStatementAnalysisModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWBankStatementAnalysisModule, declarations: [FSWBankStatementAnalysisComponent], imports: [CommonModule,
            LetDirective,
            FormWidgetModule,
            // toolkit-ui
            FSWTabsModule,
            // services modules
            UtilsServiceModule,
            MasterDataServiceModule,
            MemberServiceModule,
            FSWBlobServiceModule,
            BankAccountsAndStatementsServiceModule,
            BankTabulationsServiceModule,
            NonTradeTransactionsServiceModule,
            // custom modules
            FSWBankAccountsAndStatementsModule,
            FSWBankTabulationsModule,
            FSWNonTradeTransactionsModule,
            FSWCommentsSectionComponent,
            FSWTranslateModule,
            FSWTranslateModule], exports: [FSWBankStatementAnalysisComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBankStatementAnalysisModule, imports: [CommonModule,
            FormWidgetModule,
            // toolkit-ui
            FSWTabsModule,
            // services modules
            UtilsServiceModule,
            MasterDataServiceModule,
            MemberServiceModule,
            FSWBlobServiceModule,
            BankAccountsAndStatementsServiceModule,
            BankTabulationsServiceModule,
            NonTradeTransactionsServiceModule,
            // custom modules
            FSWBankAccountsAndStatementsModule,
            FSWBankTabulationsModule,
            FSWNonTradeTransactionsModule,
            FSWCommentsSectionComponent,
            FSWTranslateModule,
            FSWTranslateModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBankStatementAnalysisModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        LetDirective,
                        FormWidgetModule,
                        // toolkit-ui
                        FSWTabsModule,
                        // services modules
                        UtilsServiceModule,
                        MasterDataServiceModule,
                        MemberServiceModule,
                        FSWBlobServiceModule,
                        BankAccountsAndStatementsServiceModule,
                        BankTabulationsServiceModule,
                        NonTradeTransactionsServiceModule,
                        // custom modules
                        FSWBankAccountsAndStatementsModule,
                        FSWBankTabulationsModule,
                        FSWNonTradeTransactionsModule,
                        FSWCommentsSectionComponent,
                        FSWTranslateModule,
                        FSWTranslateModule,
                    ],
                    declarations: DECLARATIONS_EXPORTS$5,
                    exports: DECLARATIONS_EXPORTS$5,
                }]
        }] });

var title$G = "Application - Business Interest Parties";
var description$1 = "- This section shows the BIP used by current application for prescreening. Please ensure that all BIP required in the application are available and shown in this table";
var buttons$Z = {
	add_bip: "Add BIP",
	cancel: "Cancel",
	search: "Search",
	add_new_bip: "Add New BIP",
	delete_bip: "Delete BIP",
	edit_bip: "Edit BIP",
	save_changes: "Save Changes"
};
var tabs$6 = {
	application: "Application",
	command_center: "Command Center"
};
var table$4 = {
	name: "Name",
	full_name: "Full Name",
	designation: "Designation",
	ownership: "Ownership (%)",
	date_of_birth: "Date of Birth (Age)",
	recourse_type: "Recourse Type",
	company_name: "Company Name",
	email_address: "Email Address",
	pefindo: "PEFINDO Report",
	ic_number: "IC / Passport Number",
	recourse_identifier: "Recourse Identifier",
	action: ""
};
var forms$a = {
	individual: {
		name: "Name",
		email: "Email",
		gender: "Gender",
		mobile_phone: "Mobile Phone",
		id_card_number: "ID Card Number",
		passport_number: "Passport Number",
		date_of_birth: "Date of Birth",
		place_of_birth: "Place of Birth",
		years_of_business_experience: "Years of Business Experience (years)",
		designation: "Designation"
	},
	company: {
		name: "Company Name",
		type: "Company Type",
		username: "Username",
		registration_number: "Registration Number"
	},
	shared: {
		member_entity_type: {
			id: "BIP Type",
			individual: "Individual",
			company: "Company"
		},
		tax_number: "Tax Number",
		address_line_1: "Address Line 1",
		address_line_2: "Address Line 2",
		country: "Country",
		state_province: "State/Province",
		district: "District",
		postal_code: "Postal Code",
		net_worth: "Net Worth",
		area: "Area",
		recourse_type: "Recourse Type",
		ownership: "Ownership (%)"
	}
};
var modal$7 = {
	titles: {
		add: "Add BIP",
		edit: "Edit BIP",
		view: "View BIP"
	},
	search: "Search company or individual name",
	confirm_cancel: {
		title: "Are you sure you want to cancel the editing information?",
		description: "You will lose all the information that you are editing about the BIP",
		no: "No, continue edit",
		yes: "Yes, cancel"
	},
	confirm_save: {
		title: "Are you sure you want to save BIP information?",
		description: "You will replace all the current information that you updated about the BIP",
		no: "No, don't change",
		yes: "Yes, save BIP"
	},
	confirm_add: {
		title: "Are you sure you want to add a new BIP?",
		description: "You will lose all the information that you added about the BIP",
		no: "No, don't change",
		yes: "Yes, add new BIP"
	},
	confirm_remove: {
		title: "Are you sure you want to remove bip?",
		description: "You will lose all the information that you added about the BIP",
		no: "No, don't remove",
		yes: "Yes, remove"
	}
};
var th$d = {
	title: title$G,
	description: description$1,
	buttons: buttons$Z,
	tabs: tabs$6,
	table: table$4,
	forms: forms$a,
	modal: modal$7
};

var TH$9 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$Z,
    default: th$d,
    description: description$1,
    forms: forms$a,
    modal: modal$7,
    table: table$4,
    tabs: tabs$6,
    title: title$G
});

var title$F = "Application - Business Interest Parties";
var description = "- This section shows the BIP used by current application for prescreening. Please ensure that all BIP required in the application are available and shown in this table";
var buttons$Y = {
	add_bip: "Add BIP",
	cancel: "Cancel",
	search: "Search",
	add_new_bip: "Add New BIP",
	delete_bip: "Delete BIP",
	edit_bip: "Edit BIP",
	save_changes: "Save Changes",
	pull: "Pull",
	view: "View"
};
var tabs$5 = {
	application: "Application",
	command_center: "Command Center"
};
var table$3 = {
	name: "Name",
	full_name: "Full Name",
	designation: "Designation",
	ownership: "Ownership (%)",
	date_of_birth: "Date of Birth (Age)",
	recourse_type: "Recourse Type",
	company_name: "Company Name",
	email_address: "Email Address",
	pefindo: "PEFINDO Report",
	ic_number: "IC / Passport Number",
	recourse_identifier: "Recourse Identifier",
	action: "",
	id_number: "ID Number",
	tax_number: "Tax Number",
	address: "Address",
	pefindo_id: "Pefindo ID"
};
var forms$9 = {
	individual: {
		spouse: "Spouse",
		name: "Name",
		email: "Email",
		gender: "Gender",
		mobile_phone: "Mobile Phone",
		id_number: "ID Number",
		id_card_number: "ID Card Number",
		id_card_type: "ID Card Type",
		passport_number: "Passport Number",
		marital_status_id: "Marital Status",
		date_of_birth: "Date of Birth",
		place_of_birth: "Place of Birth",
		years_of_business_experience: "Years of Business Experience (years)",
		designation: "Designation"
	},
	company: {
		name: "Company Name",
		type: "Company Type",
		username: "Username",
		tax_number: "Company Tax Number",
		registration_number: "Registration Number",
		phone_number: "Office Phone Number",
		deed_certificate_number: "Deed Certificate Number",
		date_of_birth: "Establishment Date",
		date_of_certificate: "Date of Certificate / Deed",
		address_type: "Address Type",
		industry: "Industry"
	},
	shared: {
		member_entity_type: {
			id: "BIP Type",
			individual: "Individual",
			company: "Company"
		},
		tax_number: "Tax Number",
		address_line_1: "Address Line 1",
		address_line_2: "Address Line 2",
		country: "Country",
		state_province: "State/Province",
		district: "District",
		postal_code: "Postal Code",
		net_worth: "Net Worth",
		area: "Area",
		recourse_type: "Recourse Type",
		ownership: "Ownership (%)"
	}
};
var modal$6 = {
	titles: {
		add: "Add BIP",
		edit: "Edit BIP",
		view: "View BIP",
		pefindo: "Search Report"
	},
	search: "Search company or individual name",
	confirm_cancel: {
		title: "Are you sure you want to cancel the editing information?",
		description: "You will lose all the information that you are editing about the BIP",
		no: "No, continue edit",
		yes: "Yes, cancel"
	},
	confirm_save: {
		title: "Are you sure you want to save BIP information?",
		description: "You will replace all the current information that you updated about the BIP",
		no: "No, don't change",
		yes: "Yes, save BIP"
	},
	confirm_add: {
		title: "Are you sure you want to add a new BIP?",
		description: "Please confirm that you want to add this BIP",
		no: "No, don't change",
		yes: "Yes, add new BIP"
	},
	confirm_remove: {
		title: "Are you sure you want to remove bip?",
		description: "You will lose all the information that you added about the BIP",
		no: "No, don't remove",
		yes: "Yes, remove"
	}
};
var id$8 = {
	title: title$F,
	description: description,
	buttons: buttons$Y,
	tabs: tabs$5,
	table: table$3,
	forms: forms$9,
	modal: modal$6
};

var ID = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$Y,
    default: id$8,
    description: description,
    forms: forms$9,
    modal: modal$6,
    table: table$3,
    tabs: tabs$5,
    title: title$F
});

const FSW_BIPS_TRANSLATION_LOADER = {
    [CountryCode.TH]: TH$9,
    [CountryCode.ID]: ID,
    [CountryCode.ZI]: ID,
};

const FSW_BIPS_STORE_TOKEN = new InjectionToken('FSW_BIPS_STORE_TOKEN');

const FSW_BIPS_FORM_TOKEN = new InjectionToken('FSW_BIPS_FORM_TOKEN');

const FSW_BIPS_HELPER_TOKEN = new InjectionToken('FSW_BIPS_HELPER_TOKEN');

const fswBIPsInitialState = {
    applicationId: null,
    bips: [],
    genders: [],
    industries: [],
    subIndustries: [],
    companyEntityTypes: [],
    countries: [],
    provinces: [],
    districts: [],
    designations: [],
    identityCardTypes: [],
    maritalStatuses: [],
    addressTypes: [],
    cities: [],
    areas: [],
    isReadonly: false,
    page: 1,
    limit: 10,
};
class FSWBIPsStore extends ApplicationMemberInformationStore {
    constructor(_applicationMemberService, _masterDataService, _referenceService, _memberService, _applicationMemberBIPService, _settingsService, _alertService, _form, _initialOptionalState) {
        super(_applicationMemberService, Object.assign(fswBIPsInitialState, _initialOptionalState || {}));
        this._applicationMemberService = _applicationMemberService;
        this._masterDataService = _masterDataService;
        this._referenceService = _referenceService;
        this._memberService = _memberService;
        this._applicationMemberBIPService = _applicationMemberBIPService;
        this._settingsService = _settingsService;
        this._alertService = _alertService;
        this._form = _form;
        this._initialOptionalState = _initialOptionalState;
        this.formGroup = new UntypedFormGroup({});
        this.countryControl = new UntypedFormControl(getCountryCodeFromStorage());
        this.provinceControl = new UntypedFormControl(null);
        this.industryControl = new UntypedFormControl(null);
        this.cityControl = new UntypedFormControl(null);
        this.districtControl = new UntypedFormControl(null);
        this.maritalStatusControl = new UntypedFormControl(null);
        this.areaControl = new UntypedFormControl(null);
        this._referenceSaveMapping = new Map();
        this._reload$ = new BehaviorSubject(new Date());
        this.init = this.effect(pipe(switchMap(() => this.loadAssets()), tap(() => {
            this.initTable();
            this.listenControlChange();
        }), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        this.initTable = this.effect(pipe(switchMap(() => this._reload$.pipe(tap(() => {
            this.updateState({
                page: 1,
                limit: 10,
            });
        }), switchMap(() => combineLatest([
            this.select((state) => state.page),
            this.select((state) => state.limit),
        ]).pipe(switchMap(([page, limit]) => this._applicationMemberBIPService
            .getApplicationMemberBIPs(this.state().applicationId, this.state().member?.uuid, {
            page,
            limit,
            expand: true,
        })
            .pipe(tap((bips) => this.updateState({ bips })))), catchError(() => EMPTY)))))));
        this.save = this.effect(pipe(switchMap((id) => id
            ? this._applicationMemberBIPService.updateMemberBip(id, this.resolveDataBasedOnCountry(this._resolveMemberData(this.formGroup.getRawValue())))
            : this._applicationMemberBIPService.addMemberBip(this.state().applicationId, this.state().member?.uuid, this.resolveDataBasedOnCountry(this._resolveMemberDataBeforeAdd(this.formGroup.getRawValue())), true)), tap(() => {
            this._alertService.success('Notification', 'Saved BIP successfully!', {
                duration: 3000,
            });
            this.reloadTable();
        }), catchError((err) => {
            console.error(err);
            this._alertService.error('Something went wrong', 'Fail to save BIP information! Please try again', {
                duration: 3000,
            });
            return EMPTY;
        })));
        this.link = this.effect(pipe(switchMap(({ reference_id, reference_to }) => this._applicationMemberBIPService
            .linkMemberBips(this.state().applicationId, {
            memberId: this.state().member?.uuid,
            reference_id,
            reference_to,
        })
            .pipe(tap(() => {
            this._alertService.success('Notification', 'Added BIP successfully!', {
                duration: 3000,
            });
            this.reloadTable();
        }), catchError((err) => {
            console.error(err);
            this._alertService.error('Something went wrong', 'Fail to add BIP information! Please try again', {
                duration: 3000,
            });
            return EMPTY;
        })))));
        this.remove = this.effect(pipe(switchMap((bip) => this._applicationMemberBIPService
            .deleteMemberBip(this.state().applicationId, this.state().member?.uuid, bip.id)
            .pipe(tap(() => {
            this._alertService.success('Notification', `Removed BIP (${bip.expand.member_entity_type_id?.toString() === MemberTypeId.INDIVIDUAL
                ? bip.expand.fullname
                : bip.expand.company_name || bip.expand.fullname}) successfully!`, {
                duration: 3000,
            });
            this.reloadTable();
        }), catchError((err) => {
            console.error(err);
            this._alertService.error('Something went wrong', 'Fail to remove BIP! Please try again', {
                duration: 3000,
            });
            return EMPTY;
        })))));
        this.listenCountryChange = this.effect(pipe(switchMap(() => this.countryControl.valueChanges.pipe(startWith(this.countryControl.value), tap(() => {
            this.updateState({ provinces: [] });
            this._updateFormToMapping('citizenship_state_id');
            this._updateFormToMapping('company_state_id');
            this.formGroup.patchValue({
                citizenship_state_id: null,
                company_state_id: null,
            });
        }), filter((countryId) => !!countryId), switchMap(() => this._masterDataService.getProvinces(this._getCountryCode()).pipe(tap((provinces) => {
            this.updateState({ provinces });
            this._updateMappingToForm('citizenship_state_id', (value) => provinces.some((province) => province.id == value));
            this._updateMappingToForm('company_state_id', (value) => provinces.some((province) => province.id == value));
        }), catchError(() => EMPTY)))))));
        this.listenIndustryChange = this.effect(pipe(switchMap(() => this.industryControl.valueChanges.pipe(startWith(this.industryControl.value), tap(() => this.updateState({ subIndustries: [] })), filter((industryId) => !!industryId), switchMap((industryId) => this._referenceService.getSubIndustries(industryId).pipe(tap((subIndustries) => this.updateState({ subIndustries })), catchError(() => EMPTY)))))));
        this.listenProvinceChange = this.effect(pipe(switchMap(() => this.provinceControl.valueChanges.pipe(startWith(this.provinceControl.value), tap(() => {
            this.updateState({ cities: [] });
            this._updateFormToMapping('citizenship_city_id');
            this._updateFormToMapping('company_city_id');
            this.formGroup.patchValue({
                citizenship_city_id: null,
                company_city_id: null,
            });
        }), filter((provinceId) => !!provinceId), switchMap((provinceId) => this._masterDataService.getCities(provinceId, this._getCountryCode()).pipe(tap((cities) => {
            this.updateState({ cities });
            this._updateMappingToForm('citizenship_city_id', (value) => cities.some((city) => city.id == value));
            this._updateMappingToForm('company_city_id', (value) => cities.some((city) => city.id == value));
        }), catchError(() => EMPTY)))))));
        this.listenCityChange = this.effect(pipe(switchMap(() => this.cityControl.valueChanges.pipe(startWith(this.cityControl.value), tap(() => {
            this.updateState({ districts: [] });
            this._updateFormToMapping('citizenship_district');
            this._updateFormToMapping('company_district');
            this.formGroup.patchValue({
                citizenship_district: null,
                company_district: null,
            });
        }), filter((cityId) => !!cityId), switchMap((cityId) => this._masterDataService.getDistricts(cityId, this._getCountryCode()).pipe(tap((districts) => {
            this.updateState({ districts });
            this._updateMappingToForm('citizenship_district', (value) => districts.some((district) => district.id == value));
            this._updateMappingToForm('company_district', (value) => districts.some((district) => district.id == value));
        }), catchError(() => EMPTY)))))));
        this.listenDistrictChange = this.effect(pipe(switchMap(() => this.districtControl.valueChanges.pipe(startWith(this.districtControl.value), tap(() => {
            this.updateState({ areas: [] });
            this._updateFormToMapping('citizenship_area');
            this._updateFormToMapping('citizenship_area_input');
            this._updateFormToMapping('company_area');
            this._updateFormToMapping('company_area_input');
            this.formGroup.patchValue({
                citizenship_area: null,
                citizenship_area_input: null,
                company_area: null,
                company_area_input: null,
            });
        }), filter((districtId) => !!districtId), switchMap((districtId) => this._masterDataService.getAreas(districtId, this._getCountryCode()).pipe(tap((areas) => {
            this.updateState({ areas });
            this._updateMappingToForm('citizenship_area', (value) => areas.some((area) => area.id == value));
            this._updateMappingToForm('company_area', (value) => areas.some((area) => area.id == value));
        }), catchError(() => EMPTY)))))));
        this.listenMaritalStatusChange = this.effect(pipe(switchMap(() => this.maritalStatusControl.valueChanges.pipe(startWith(this.maritalStatusControl.value), tap((status) => {
            if (status == FSWMaritalStatuses.MRD) {
                this._updateMappingToForm('spouse_fullname', () => this._referenceSaveMapping.has('spouse_fullname'));
                this._updateMappingToForm('spouse_birth_place', () => this._referenceSaveMapping.has('spouse_birth_place'));
                this._updateMappingToForm('spouse_id_card_type', () => this._referenceSaveMapping.has('spouse_id_card_type'));
                this._updateMappingToForm('spouse_mobile_phone_number', () => this._referenceSaveMapping.has('spouse_mobile_phone_number'));
                this._updateMappingToForm('spouse_ic_number', () => this._referenceSaveMapping.has('spouse_ic_number'));
                this._updateMappingToForm('spouse_birth_date', () => this._referenceSaveMapping.has('spouse_birth_date'));
            }
            else {
                this._updateFormToMapping('spouse_fullname');
                this._updateFormToMapping('spouse_birth_place');
                this._updateFormToMapping('spouse_id_card_type');
                this._updateFormToMapping('spouse_mobile_phone_number');
                this._updateFormToMapping('spouse_ic_number');
                this._updateFormToMapping('spouse_birth_date');
                this.formGroup.patchValue({
                    spouse_fullname: null,
                    spouse_birth_place: null,
                    spouse_id_card_type: null,
                    spouse_mobile_phone_number: null,
                    spouse_ic_number: null,
                    spouse_birth_date: null,
                });
            }
        }), catchError(() => EMPTY)))));
        this.updateState = (value) => this.patchState({
            ...value,
        });
    }
    getApplicationMembersInformation(entityId, applicationParams, memberParams) {
        return this._applicationMemberService.getApplicationMembersInformation(entityId, applicationParams, memberParams);
    }
    loadAssets() {
        return forkJoin([
            this.setupInformation(this.state().applicationId),
            this._masterDataService.getCountries().pipe(tap((countries) => this.patchState({
                countries,
            }))),
            this._masterDataService
                .getGenders()
                .pipe(tap((genders) => this.patchState({ genders }))),
            this._masterDataService
                .getIndustries()
                .pipe(tap((industries) => this.patchState({ industries }))),
            this._masterDataService
                .getCompanyEntityTypes()
                .pipe(tap((companyEntityTypes) => this.patchState({ companyEntityTypes }))),
            this._settingsService
                .getProductGroup()
                .pipe(tap((designations) => this.patchState({ designations }))),
            this._masterDataService
                .getIdentityCardTypes()
                .pipe(tap((identityCardTypes) => this.patchState({ identityCardTypes }))),
            this._masterDataService
                .getMaritalStatuses()
                .pipe(tap((maritalStatuses) => this.patchState({ maritalStatuses }))),
            this._settingsService
                .getSettings()
                .pipe(tap(({ address_type: addressTypes }) => this.patchState({ addressTypes }))),
        ]);
    }
    listenControlChange() {
        this.listenCountryChange();
        this.listenIndustryChange();
        this.listenProvinceChange();
        this.listenCityChange();
        this.listenDistrictChange();
        this.listenMaritalStatusChange();
    }
    patchMemberToBuilder(member) {
        this._referenceSaveMapping.clear();
        this.formGroup.patchValue({
            ...(member || {}),
            ...(member
                ? {
                    company_username: member.username,
                    company_tax_card_number: member.tax_card_number,
                    company_ownership: member.ownership,
                    company_net_worth: member.net_worth,
                    company_area_input: member.company_area,
                    citizenship_area_input: member.citizenship_area,
                    ...(member.member_entity_type_id
                        ? {
                            member_entity_code: member.member_entity_type_id == MemberTypeId.INDIVIDUAL
                                ? MemberEntityCode.RETAIL
                                : MemberEntityCode.CORPORATE,
                        }
                        : {
                            member_entity_type_id: member.member_entity_code == MemberEntityCode.RETAIL ||
                                member.recourse_type == 'Individual'
                                ? Number(MemberTypeId.INDIVIDUAL)
                                : Number(MemberTypeId.COMPANY),
                        }),
                }
                : {}),
            company_country_code: member?.company_country_code || getCountryCodeFromStorage(),
            citizenship_country_code: member?.citizenship_country_code || getCountryCodeFromStorage(),
        });
    }
    createBuilder(isReadonly$) {
        return this._form(this.formGroup, isReadonly$, {
            countryControl: this.countryControl,
            industryControl: this.industryControl,
            provinceControl: this.provinceControl,
            cityControl: this.cityControl,
            districtControl: this.districtControl,
            maritalStatusControl: this.maritalStatusControl,
            areaControl: this.areaControl,
            countries$: this.select((state) => state.countries),
            genders$: this.select((state) => state.genders),
            industries$: this.select((state) => state.industries),
            designations$: this.select((state) => state.designations),
            companyEntityTypes$: this.select((state) => state.companyEntityTypes),
            identityCardTypes$: this.select((state) => state.identityCardTypes),
            maritalStatuses$: this.select((state) => state.maritalStatuses),
            subIndustries$: this.select((state) => state.subIndustries),
            provinces$: this.select((state) => state.provinces),
            districts$: this.select((state) => state.districts),
            addressTypes$: this.select((state) => state.addressTypes),
            cities$: this.select((state) => state.cities),
            areas$: this.select((state) => state.areas),
        });
    }
    reloadTable() {
        this._reload$.next(new Date());
    }
    resolveDataBasedOnCountry(data) {
        return {
            ...data,
        };
    }
    _updateFormToMapping(key) {
        const value = this._referenceSaveMapping.get(key) || null;
        this._referenceSaveMapping.set(key, this.formGroup.getRawValue()[key] || value);
    }
    _updateMappingToForm(key, conditional) {
        const value = this._referenceSaveMapping.get(key) || null;
        if (conditional(value)) {
            this.formGroup.patchValue({
                [key]: value,
            });
        }
    }
    _getCountryCode() {
        return this.countryControl.value === 'VN' ? FSWCountryCode.VU : this.countryControl.value;
    }
    _resolveMemberDataBeforeAdd(data) {
        return {
            ...this._resolveMemberData(data),
            country_code: getCountryCodeFromStorage(),
        };
    }
    _resolveMemberData(data) {
        return omit({
            ...data,
            username: data['company_username'] || data['username'],
            tax_card_number: data['company_tax_card_number'] || data['tax_card_number'],
            ownership: data['company_ownership'] || data['ownership'],
            net_worth: data['company_net_worth'] || data['net_worth'],
            citizenship_area: data['citizenship_area'] || data['citizenship_area_input'],
            company_area: data['company_area'] || data['company_area_input'],
        }, [
            'company_username',
            'company_tax_card_number',
            'company_ownership',
            'company_net_worth',
            'citizenship_area_input',
            'company_area_input',
        ]);
    }
}

class FSWBIPsStoreID extends FSWBIPsStore {
    constructor(_applicationMemberService, _masterDataService, _referenceService, _memberService, _applicationMemberBIPService, _settingsService, _alertService, _form) {
        super(_applicationMemberService, _masterDataService, _referenceService, _memberService, _applicationMemberBIPService, _settingsService, _alertService, _form);
        this._applicationMemberService = _applicationMemberService;
        this._masterDataService = _masterDataService;
        this._referenceService = _referenceService;
        this._memberService = _memberService;
        this._applicationMemberBIPService = _applicationMemberBIPService;
        this._settingsService = _settingsService;
        this._alertService = _alertService;
        this._form = _form;
    }
    resolveDataBasedOnCountry(data) {
        if (data.ownership != null) {
            data.ownership = data.ownership.toString();
        }
        return data;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsStoreID, deps: [{ token: APPLICATION_MEMBER_SERVICE_TOKEN }, { token: MASTER_DATA_SERVICE_TOKEN }, { token: REFERENCE_SERVICE_TOKEN }, { token: MEMBER_SERVICE_TOKEN }, { token: APPLICATION_MEMBER_BIP_SERVICE_TOKEN }, { token: SETTINGS_SERVICE_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }, { token: FSW_BIPS_FORM_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsStoreID }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsStoreID, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MASTER_DATA_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [REFERENCE_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_BIP_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SETTINGS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_BIPS_FORM_TOKEN]
                }] }]; } });

const FSWBIPsFormID = (form, isReadonly$, config) => {
    const translation = FSW_BIPS_TRANSLATION_LOADER[CountryCode.ID];
    const { provinces$, countryControl, provinceControl, districtControl, maritalStatusControl, cityControl, areaControl, countries$, companyEntityTypes$, genders$, districts$, cities$, areas$, designations$, identityCardTypes$, maritalStatuses$, industries$, industryControl, addressTypes$, } = config;
    const leftIndividualFields = [
        {
            key: 'username',
            type: FSWDynamicBuilderControlTypes.INPUT,
            customClasses: 'contents',
            context: {
                inputType: 'email',
                label: translation.forms.individual.email,
                placeHolder: translation.forms.individual.email,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required, Validators.email],
        },
        {
            key: 'ic_type_id',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.individual.id_card_type,
                placeHolder: translation.forms.individual.id_card_type,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => identityCardTypes$.pipe(map((identityCardTypes) => identityCardTypes.map((identityCardType) => ({
                    value: Number(identityCardType.id),
                    text: identityCardType.name,
                })))),
                readonlyTemplate: (value) => value || 'None',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'birth_date',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
            context: {
                label: translation.forms.individual.date_of_birth,
                placeHolder: 'DD/MM/YYYY',
                isRequired: true,
                fullWidth: true,
                closeOnSelected: true,
                readonlyTemplate: 'date',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'tax_card_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.tax_number,
                placeHolder: translation.forms.shared.tax_number,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'designation',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.individual.designation,
                placeHolder: translation.forms.individual.designation,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => designations$.pipe(map((designations) => designations.map((designation) => ({
                    value: designation,
                    text: designation,
                })))),
                readonlyTemplate: (value) => value || 'None',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_address_1',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.address_line_1,
                placeHolder: translation.forms.shared.address_line_1,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_state_id',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.state_province,
                placeHolder: translation.forms.shared.state_province,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => provinces$.pipe(map((provinces) => provinces.map((province) => ({
                    value: Number(province.id),
                    text: province.name,
                })))),
                afterCreated: (control) => {
                    provinceControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((provinceCode) => provinceCode !== provinceControl.value && provinceControl.setValue(provinceCode)))
                        .subscribe();
                },
                readonlyTemplate: 'province',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_area',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.area,
                placeHolder: translation.forms.shared.area,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => areas$.pipe(map((areas) => areas.map((area) => ({
                    value: area.id,
                    text: area.name,
                })))),
                afterCreated: (control) => {
                    areaControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((areaCode) => areaCode !== areaControl.value && areaControl.setValue(areaCode)))
                        .subscribe();
                },
                readonlyTemplate: 'area',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'marital_status_id',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.individual.marital_status_id,
                placeHolder: translation.forms.individual.marital_status_id,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => maritalStatuses$.pipe(map((maritalStatuses) => maritalStatuses.map((maritalStatus) => ({
                    value: Number(maritalStatus.id),
                    text: maritalStatus.name,
                })))),
                afterCreated: (control) => {
                    maritalStatusControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((maritalStatus) => maritalStatus !== maritalStatusControl.value &&
                        maritalStatusControl.setValue(maritalStatus)))
                        .subscribe();
                },
                readonlyTemplate: (value) => value || 'None',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'spouse_birth_date',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
            context: {
                label: `${translation.forms.individual.spouse} ${translation.forms.individual.date_of_birth}`,
                placeHolder: 'DD/MM/YYYY',
                isRequired: true,
                fullWidth: true,
                closeOnSelected: true,
                readonlyTemplate: 'date',
                customRender: getFSWBIPsFormCustomRenderListenToMaritalStatusChangeID(MemberTypeId.INDIVIDUAL, FSWMaritalStatuses.MRD),
            },
            validations: [Validators.required],
        },
        {
            key: 'spouse_id_card_type',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: `${translation.forms.individual.spouse} ${translation.forms.individual.id_card_type}`,
                placeHolder: `${translation.forms.individual.spouse} ${translation.forms.individual.id_card_type}`,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => identityCardTypes$.pipe(map((identityCardTypes) => identityCardTypes.map((identityCardType) => ({
                    value: identityCardType.id,
                    text: identityCardType.name,
                })))),
                readonlyTemplate: (value) => value || 'None',
                customRender: getFSWBIPsFormCustomRenderListenToMaritalStatusChangeID(MemberTypeId.INDIVIDUAL, FSWMaritalStatuses.MRD),
            },
            validations: [Validators.required],
        },
        {
            key: 'spouse_mobile_phone_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: `${translation.forms.individual.spouse} ${translation.forms.individual.mobile_phone}`,
                placeHolder: `${translation.forms.individual.spouse} ${translation.forms.individual.mobile_phone}`,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMaritalStatusChangeID(MemberTypeId.INDIVIDUAL, FSWMaritalStatuses.MRD),
            },
            validations: [Validators.required],
        },
    ];
    const leftCompanyFields = [
        {
            key: 'company_name',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.company.name,
                placeHolder: translation.forms.company.name,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_tax_card_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.tax_number,
                placeHolder: translation.forms.shared.tax_number,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'address_type',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.company.address_type,
                placeHolder: translation.forms.company.address_type,
                maxHeight: '300px',
                fullWidth: true,
                readonlyTemplate: 'basic',
                loadItemsAsync: () => addressTypes$.pipe(map((addressTypes) => addressTypes.map((addressType) => ({
                    value: addressType,
                    text: addressType,
                })))),
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.COMPANY),
            },
        },
        {
            key: 'company_phone_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.company.phone_number,
                placeHolder: translation.forms.company.phone_number,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.COMPANY),
            },
        },
        {
            key: 'deed_certificate_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.company.deed_certificate_number,
                placeHolder: translation.forms.company.deed_certificate_number,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.COMPANY),
            },
        },
        {
            key: 'company_ownership',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                // inputType: 'number',
                mask: {
                    expression: 'separator.2',
                    config: {
                        thousandSeparator: ',',
                    },
                },
                label: translation.forms.shared.ownership,
                placeHolder: translation.forms.shared.ownership,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: (value) => `${value || '0'}%`,
                suffix: '%',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_address_1',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.address_line_1,
                placeHolder: translation.forms.shared.address_line_1,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_state_id',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.state_province,
                placeHolder: translation.forms.shared.state_province,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                afterCreated: (control) => {
                    provinceControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((provinceCode) => provinceCode !== provinceControl.value && provinceControl.setValue(provinceCode)))
                        .subscribe();
                },
                loadItemsAsync: () => provinces$.pipe(map((provinces) => provinces.map((province) => ({
                    value: Number(province.id),
                    text: province.name,
                })))),
                readonlyTemplate: 'province',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_area',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.area,
                placeHolder: translation.forms.shared.area,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => areas$.pipe(map((areas) => areas.map((area) => ({
                    value: area.id,
                    text: area.name,
                })))),
                afterCreated: (control) => {
                    areaControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((areaCode) => areaCode !== areaControl.value && areaControl.setValue(areaCode)))
                        .subscribe();
                },
                readonlyTemplate: 'area',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
    ];
    const rightIndividualFields = [
        {
            key: 'fullname',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.individual.name,
                placeHolder: translation.forms.individual.name,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'gender_id',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.individual.gender,
                placeHolder: translation.forms.individual.gender,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'gender',
                loadItemsAsync: () => genders$.pipe(map((genders) => genders.map((gender) => ({
                    value: Number(gender.id),
                    text: gender.name,
                })))),
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'mobile_phone_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.individual.mobile_phone,
                placeHolder: translation.forms.individual.mobile_phone,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'ic_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.individual.id_card_number,
                placeHolder: translation.forms.individual.id_card_number,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'birth_place',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.individual.place_of_birth,
                placeHolder: translation.forms.individual.place_of_birth,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'ownership',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                // inputType: 'number',
                mask: {
                    expression: 'separator.2',
                    config: {
                        thousandSeparator: ',',
                    },
                },
                label: translation.forms.shared.ownership,
                placeHolder: translation.forms.shared.ownership,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: (value) => `${value || '0'}%`,
                suffix: '%',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_country_code',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.country,
                placeHolder: translation.forms.shared.country,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                defaultValue: getCountryCodeFromStorage() === FSWCountryCode.VU ? 'VN' : getCountryCodeFromStorage(),
                loadItemsAsync: () => countries$.pipe(map((countries) => countries.map((country) => ({
                    value: country.code,
                    text: country.name,
                })))),
                afterCreated: (control) => {
                    countryControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((countryCode) => countryCode !== countryControl.value && countryControl.setValue(countryCode)))
                        .subscribe();
                },
                readonlyTemplate: 'country',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_address_2',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.address_line_2,
                placeHolder: translation.forms.shared.address_line_2,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_district',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.district,
                placeHolder: translation.forms.shared.district,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => districts$.pipe(map((districts) => districts.map((district) => ({
                    value: district.id,
                    text: district.name,
                })))),
                afterCreated: (control) => {
                    districtControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((districtCode) => districtCode !== districtControl.value && districtControl.setValue(districtCode)))
                        .subscribe();
                },
                readonlyTemplate: 'district',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_zip_code',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.postal_code,
                placeHolder: translation.forms.shared.postal_code,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                afterCreated: (control) => {
                    let controlValue = control.value;
                    combineLatest([areas$, areaControl.valueChanges.pipe(startWith(areaControl.value))])
                        .pipe(tap(([areas, areaValue]) => {
                        const value = (areas.find((area) => area.id == areaValue) || areas[0])?.zip_code;
                        control.setValue(value || controlValue || control.value);
                        if (value) {
                            controlValue = value;
                            control.disable();
                        }
                        else {
                            controlValue = control.value;
                            control.enable();
                        }
                    }))
                        .subscribe();
                },
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'spouse_fullname',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: `${translation.forms.individual.spouse} ${translation.forms.individual.name}`,
                placeHolder: `${translation.forms.individual.spouse} ${translation.forms.individual.name}`,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMaritalStatusChangeID(MemberTypeId.INDIVIDUAL, FSWMaritalStatuses.MRD),
            },
            validations: [Validators.required],
        },
        {
            key: 'spouse_birth_place',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: `${translation.forms.individual.spouse} ${translation.forms.individual.place_of_birth}`,
                placeHolder: `${translation.forms.individual.spouse} ${translation.forms.individual.place_of_birth}`,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMaritalStatusChangeID(MemberTypeId.INDIVIDUAL, FSWMaritalStatuses.MRD),
            },
            validations: [Validators.required],
        },
        {
            key: 'spouse_ic_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: `${translation.forms.individual.spouse} ${translation.forms.individual.id_card_number}`,
                placeHolder: `${translation.forms.individual.spouse} ${translation.forms.individual.id_card_number}`,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMaritalStatusChangeID(MemberTypeId.INDIVIDUAL, FSWMaritalStatuses.MRD),
            },
            validations: [Validators.required],
        },
    ];
    const rightCompanyFields = [
        {
            key: 'company_entity_type_id',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.company.type,
                placeHolder: translation.forms.company.type,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => companyEntityTypes$.pipe(map((entityTypes) => entityTypes.map((entityType) => ({
                    value: Number(entityType.id),
                    text: entityType.name,
                })))),
                readonlyTemplate: 'company_entity_id',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_registration_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.company.registration_number,
                placeHolder: translation.forms.company.registration_number,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_username',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                inputType: 'email',
                label: translation.forms.company.username,
                placeHolder: translation.forms.company.username,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.COMPANY),
            },
            validations: [Validators.required, Validators.email],
        },
        {
            key: 'company_tax_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.company.tax_number,
                placeHolder: translation.forms.company.tax_number,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.COMPANY),
            },
        },
        {
            key: 'company_industry_id',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.company.industry,
                placeHolder: translation.forms.company.industry,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                afterCreated: (control) => {
                    industryControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((industryCode) => industryCode !== industryControl.value && industryControl.setValue(industryCode)))
                        .subscribe();
                },
                loadItemsAsync: () => industries$.pipe(map((industries) => industries.map((industry) => ({
                    value: Number(industry.id),
                    text: industry.name,
                })))),
                readonlyTemplate: 'industry',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_birth_date',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
            context: {
                label: translation.forms.company.date_of_birth,
                placeHolder: 'DD/MM/YYYY',
                isRequired: true,
                fullWidth: true,
                closeOnSelected: true,
                readonlyTemplate: 'date',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'date_of_certificate',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
            context: {
                label: translation.forms.company.date_of_certificate,
                placeHolder: 'DD/MM/YYYY',
                fullWidth: true,
                closeOnSelected: true,
                readonlyTemplate: 'date',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.COMPANY),
            },
        },
        {
            key: 'company_country_code',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.country,
                placeHolder: translation.forms.shared.country,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                isDisabled: true,
                defaultValue: getCountryCodeFromStorage() === FSWCountryCode.VU ? 'VN' : getCountryCodeFromStorage(),
                loadItemsAsync: () => countries$.pipe(map((countries) => countries.map((country) => ({
                    value: country.code,
                    text: country.name,
                })))),
                afterCreated: (control) => {
                    control.valueChanges
                        .pipe(tap((countryCode) => countryCode !== countryControl.value && countryControl.setValue(countryCode)))
                        .subscribe();
                    countryControl.setValue(control.value);
                },
                readonlyTemplate: 'country',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_address_2',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.address_line_2,
                placeHolder: translation.forms.shared.address_line_2,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_district',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.district,
                placeHolder: translation.forms.shared.district,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => districts$.pipe(map((districts) => districts.map((district) => ({
                    value: district.id,
                    text: district.name,
                })))),
                afterCreated: (control) => {
                    districtControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((districtCode) => districtCode !== districtControl.value && districtControl.setValue(districtCode)))
                        .subscribe();
                },
                readonlyTemplate: 'district',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_zip_code',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.postal_code,
                placeHolder: translation.forms.shared.postal_code,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                afterCreated: (control) => {
                    let controlValue = control.value;
                    areas$
                        .pipe(tap((areas) => {
                        const value = areas[0]?.zip_code;
                        control.setValue(value || controlValue || control.value);
                        if (value) {
                            controlValue = value;
                            control.disable();
                        }
                        else {
                            controlValue = control.value;
                            control.enable();
                        }
                    }))
                        .subscribe();
                },
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
    ];
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'w-full flex gap-[16px]',
        readonlyWhen$: isReadonly$,
        renderBy: 'container',
        containers: [
            {
                customClasses: 'flex gap-[16px] flex-col w-[calc(50%-8px)]',
                fields: [
                    {
                        key: 'member_entity_type_id',
                        type: FSWDynamicBuilderControlTypes.RADIO_GROUP,
                        customClasses: 'h-[69px] flex items-center',
                        context: {
                            label: translation.forms.shared.member_entity_type.id,
                            defaultValue: Number(MemberTypeId.INDIVIDUAL),
                            direction: FSWCheckboxDirections.ROW,
                            gap: '12px',
                            items: [
                                {
                                    value: Number(MemberTypeId.INDIVIDUAL),
                                    renderTemplate: {
                                        label: translation.forms.shared.member_entity_type.individual,
                                    },
                                },
                                {
                                    value: Number(MemberTypeId.COMPANY),
                                    renderTemplate: {
                                        label: translation.forms.shared.member_entity_type.company,
                                    },
                                },
                            ],
                            fullWidth: true,
                            readonlyTemplate: (value) => {
                                if (value == MemberTypeId.INDIVIDUAL) {
                                    return translation.forms.shared.member_entity_type.individual;
                                }
                                else {
                                    return translation.forms.shared.member_entity_type.company;
                                }
                            },
                        },
                    },
                    {
                        key: 'recourse_type',
                        type: FSWDynamicBuilderControlTypes.RADIO_GROUP,
                        customClasses: 'h-[69px] flex items-center',
                        context: {
                            label: translation.forms.shared.recourse_type,
                            defaultValue: 'None',
                            direction: FSWCheckboxDirections.ROW,
                            gap: '12px',
                            loadItemsAsync: (form) => {
                                const entityTypeControl = getControlFromGroup(form, 'member_entity_type_id');
                                return entityTypeControl.valueChanges.pipe(startWith(entityTypeControl.value), map((value) => {
                                    if (value == MemberTypeId.INDIVIDUAL) {
                                        return [
                                            {
                                                value: FSWRecourseTypes.PG,
                                                renderTemplate: {
                                                    label: FSWRecourseTypes.PG,
                                                },
                                            },
                                            {
                                                value: 'None',
                                                renderTemplate: {
                                                    label: 'None',
                                                },
                                            },
                                        ];
                                    }
                                    return [
                                        {
                                            value: FSWRecourseTypes.CG,
                                            renderTemplate: {
                                                label: FSWRecourseTypes.CG,
                                            },
                                        },
                                        {
                                            value: 'None',
                                            renderTemplate: {
                                                label: 'None',
                                            },
                                        },
                                    ];
                                }));
                            },
                            fullWidth: true,
                            readonlyTemplate: (value) => value || 'NONE',
                        },
                    },
                    ...leftIndividualFields,
                    ...leftCompanyFields,
                ],
            },
            {
                customClasses: 'flex gap-[16px] flex-col w-[calc(50%-8px)]',
                fields: [...rightIndividualFields, ...rightCompanyFields],
            },
            {
                customClasses: 'hidden',
                fields: [
                    {
                        key: 'citizenship_city_id',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            isDisabled: true,
                            afterCreated: (control) => {
                                cities$
                                    .pipe(tap((cities) => {
                                    const value = cities[0]?.id ? Number(cities[0]?.id) : null;
                                    control.setValue(value, { emitEvent: false });
                                    cityControl.setValue(value);
                                }))
                                    .subscribe();
                            },
                            customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.INDIVIDUAL),
                        },
                    },
                    {
                        key: 'company_city_id',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            isDisabled: true,
                            afterCreated: (control) => {
                                cities$
                                    .pipe(tap((cities) => {
                                    const value = cities[0]?.id ? Number(cities[0]?.id) : null;
                                    control.setValue(value, { emitEvent: false });
                                    cityControl.setValue(value);
                                }))
                                    .subscribe();
                            },
                            customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeID(MemberTypeId.COMPANY),
                        },
                    },
                    {
                        key: 'member_entity_code',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            isDisabled: true,
                            afterCreated: (control, group) => {
                                group.valueChanges
                                    .pipe(startWith(group.value))
                                    .subscribe(({ member_entity_type_id }) => control.setValue(member_entity_type_id == MemberTypeId.INDIVIDUAL
                                    ? MemberEntityCode.RETAIL
                                    : MemberEntityCode.CORPORATE, { emitEvent: false }));
                            },
                        },
                    },
                ],
            },
        ],
        form,
    });
};
const getFSWBIPsFormCustomRenderListenToMemberEntityChangeID = (entityId) => [
    {
        fields: [
            {
                key: 'member_entity_type_id',
                correctWhenValueIs: (value) => value == entityId,
            },
        ],
        checkingConditionCallback: (params, condition) => {
            if (condition) {
                params.renderView();
            }
            else {
                params.clearView();
            }
        },
    },
];
const getFSWBIPsFormCustomRenderListenToMaritalStatusChangeID = (entityId, status) => [
    {
        fields: [
            {
                key: 'marital_status_id',
                correctWhenValueIs: (value) => value == status,
            },
            {
                key: 'member_entity_type_id',
                correctWhenValueIs: (value) => value == entityId,
            },
        ],
        checkingConditionCallback: (params, condition) => {
            if (condition) {
                params.renderView();
            }
            else {
                params.clearView();
            }
        },
    },
];

class FSWBIPsHelperID {
    getExtraColumns() {
        return ['pefindo'];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsHelperID, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsHelperID }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsHelperID, decorators: [{
            type: Injectable
        }] });

const FSW_BIPS_ID_PROVIDERS = [
    {
        provide: FSW_BIPS_STORE_TOKEN,
        useClass: FSWBIPsStoreID,
        deps: [
            APPLICATION_MEMBER_SERVICE_TOKEN,
            MASTER_DATA_SERVICE_TOKEN,
            REFERENCE_SERVICE_TOKEN,
            MEMBER_SERVICE_TOKEN,
            APPLICATION_MEMBER_BIP_SERVICE_TOKEN,
            SETTINGS_SERVICE_TOKEN,
            FSW_ALERT_SERVICE_TOKEN,
            FSW_BIPS_FORM_TOKEN,
        ],
    },
    {
        provide: FSW_BIPS_FORM_TOKEN,
        useValue: FSWBIPsFormID,
        deps: [],
    },
    {
        provide: FSW_BIPS_HELPER_TOKEN,
        useClass: FSWBIPsHelperID,
        deps: [],
    },
];

class FSWBIPsStoreTH extends FSWBIPsStore {
    constructor(_applicationMemberService, _masterDataService, _referenceService, _memberService, _applicationMemberBIPService, _settingsService, _alertService, _form) {
        super(_applicationMemberService, _masterDataService, _referenceService, _memberService, _applicationMemberBIPService, _settingsService, _alertService, _form);
        this._applicationMemberService = _applicationMemberService;
        this._masterDataService = _masterDataService;
        this._referenceService = _referenceService;
        this._memberService = _memberService;
        this._applicationMemberBIPService = _applicationMemberBIPService;
        this._settingsService = _settingsService;
        this._alertService = _alertService;
        this._form = _form;
    }
    resolveDataBasedOnCountry(data) {
        if (data.tax_card_number != null) {
            data.tax_card_number = data.tax_card_number.toString();
        }
        if (data.ownership != null) {
            data.ownership = data.ownership.toString();
        }
        return data;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsStoreTH, deps: [{ token: APPLICATION_MEMBER_SERVICE_TOKEN }, { token: MASTER_DATA_SERVICE_TOKEN }, { token: REFERENCE_SERVICE_TOKEN }, { token: MEMBER_SERVICE_TOKEN }, { token: APPLICATION_MEMBER_BIP_SERVICE_TOKEN }, { token: SETTINGS_SERVICE_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }, { token: FSW_BIPS_FORM_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsStoreTH }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsStoreTH, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MASTER_DATA_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [REFERENCE_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_BIP_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SETTINGS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_BIPS_FORM_TOKEN]
                }] }]; } });

const FSWBIPsFormTH = (form, isReadonly$, config) => {
    const translation = FSW_BIPS_TRANSLATION_LOADER[CountryCode.TH];
    const { provinces$, countryControl, provinceControl, districtControl, cityControl, areaControl, countries$, companyEntityTypes$, genders$, districts$, cities$, areas$, designations$, } = config;
    const leftIndividualFields = [
        {
            key: 'username',
            type: FSWDynamicBuilderControlTypes.INPUT,
            customClasses: 'contents',
            context: {
                inputType: 'email',
                label: translation.forms.individual.email,
                placeHolder: translation.forms.individual.email,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required, Validators.email],
        },
        {
            key: 'ic_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.individual.id_card_number,
                placeHolder: translation.forms.individual.id_card_number,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'birth_date',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
            context: {
                label: translation.forms.individual.date_of_birth,
                placeHolder: 'DD/MM/YYYY',
                isRequired: true,
                fullWidth: true,
                closeOnSelected: true,
                readonlyTemplate: 'date',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'tax_card_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                inputType: 'number',
                label: translation.forms.shared.tax_number,
                placeHolder: translation.forms.shared.tax_number,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'net_worth',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                // inputType: 'number',
                mask: {
                    expression: 'separator.2',
                    config: {
                        thousandSeparator: ',',
                    },
                },
                label: translation.forms.shared.net_worth,
                placeHolder: translation.forms.shared.net_worth,
                isRequired: true,
                fullWidth: true,
                prefix: getCurrentCountryConfig().currencyCode,
                readonlyTemplate: (value) => `${value || '0'} ${getCurrentCountryConfig().currencyCode}`,
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'designation',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.individual.designation,
                placeHolder: translation.forms.individual.designation,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => designations$.pipe(map((designations) => designations.map((designation) => ({
                    value: designation,
                    text: designation,
                })))),
                readonlyTemplate: (value) => value || 'None',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_address_1',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.address_line_1,
                placeHolder: translation.forms.shared.address_line_1,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_state_id',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.state_province,
                placeHolder: translation.forms.shared.state_province,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => provinces$.pipe(map((provinces) => provinces.map((province) => ({
                    value: Number(province.id),
                    text: province.name,
                })))),
                afterCreated: (control) => {
                    provinceControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((provinceCode) => provinceCode !== provinceControl.value && provinceControl.setValue(provinceCode)))
                        .subscribe();
                },
                readonlyTemplate: 'province',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_area',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.area,
                placeHolder: translation.forms.shared.area,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => areas$.pipe(map((areas) => areas.map((area) => ({
                    value: area.id,
                    text: area.name,
                })))),
                afterCreated: (control) => {
                    areaControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((areaCode) => areaCode !== areaControl.value && areaControl.setValue(areaCode)))
                        .subscribe();
                },
                readonlyTemplate: 'area',
                customRender: getFSWBIPsFormCustomRenderAreaListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL, areas$),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_area_input',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.area,
                placeHolder: translation.forms.shared.area,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderAreaListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL, areas$),
            },
            validations: [Validators.required],
        },
    ];
    const leftCompanyFields = [
        {
            key: 'company_name',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.company.name,
                placeHolder: translation.forms.company.name,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_tax_card_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                inputType: 'number',
                label: translation.forms.shared.tax_number,
                placeHolder: translation.forms.shared.tax_number,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_net_worth',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                // inputType: 'number',
                mask: {
                    expression: 'separator.2',
                    config: {
                        thousandSeparator: ',',
                    },
                },
                label: translation.forms.shared.net_worth,
                placeHolder: translation.forms.shared.net_worth,
                isRequired: true,
                fullWidth: true,
                prefix: getCurrentCountryConfig().currencyCode,
                readonlyTemplate: (value) => `${value || '0'} ${getCurrentCountryConfig().currencyCode}`,
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_address_1',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.address_line_1,
                placeHolder: translation.forms.shared.address_line_1,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_state_id',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.state_province,
                placeHolder: translation.forms.shared.state_province,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                afterCreated: (control) => {
                    provinceControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((provinceCode) => provinceCode !== provinceControl.value && provinceControl.setValue(provinceCode)))
                        .subscribe();
                },
                loadItemsAsync: () => provinces$.pipe(map((provinces) => provinces.map((province) => ({
                    value: Number(province.id),
                    text: province.name,
                })))),
                readonlyTemplate: 'province',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_area',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.area,
                placeHolder: translation.forms.shared.area,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => areas$.pipe(map((areas) => areas.map((area) => ({
                    value: area.id,
                    text: area.name,
                })))),
                afterCreated: (control) => {
                    areaControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((areaCode) => areaCode !== areaControl.value && areaControl.setValue(areaCode)))
                        .subscribe();
                },
                readonlyTemplate: 'area',
                customRender: getFSWBIPsFormCustomRenderAreaListenToMemberEntityChangeTH(MemberTypeId.COMPANY, areas$),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_area_input',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.area,
                placeHolder: translation.forms.shared.area,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderAreaListenToMemberEntityChangeTH(MemberTypeId.COMPANY, areas$),
            },
            validations: [Validators.required],
        },
    ];
    const rightIndividualFields = [
        {
            key: 'fullname',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.individual.name,
                placeHolder: translation.forms.individual.name,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'gender_id',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.individual.gender,
                placeHolder: translation.forms.individual.gender,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'gender',
                loadItemsAsync: () => genders$.pipe(map((genders) => genders.map((gender) => ({
                    value: Number(gender.id),
                    text: gender.name,
                })))),
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'mobile_phone_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.individual.mobile_phone,
                placeHolder: translation.forms.individual.mobile_phone,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'passport_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.individual.passport_number,
                placeHolder: translation.forms.individual.passport_number,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
        },
        {
            key: 'birth_place',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.individual.place_of_birth,
                placeHolder: translation.forms.individual.place_of_birth,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'ownership',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                // inputType: 'number',
                mask: {
                    expression: 'separator.2',
                    config: {
                        thousandSeparator: ',',
                    },
                },
                label: translation.forms.shared.ownership,
                placeHolder: translation.forms.shared.ownership,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: (value) => `${value || '0'}%`,
                suffix: '%',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'years_of_exp',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                // inputType: 'number',
                mask: {
                    expression: 'separator.2',
                    config: {
                        thousandSeparator: ',',
                    },
                },
                label: translation.forms.individual.years_of_business_experience,
                placeHolder: translation.forms.individual.years_of_business_experience,
                isRequired: true,
                fullWidth: true,
                suffix: 'years',
                readonlyTemplate: (value) => `${value || '0'} years`,
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_country_code',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.country,
                placeHolder: translation.forms.shared.country,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                defaultValue: getCountryCodeFromStorage() === FSWCountryCode.VU ? 'VN' : getCountryCodeFromStorage(),
                loadItemsAsync: () => countries$.pipe(map((countries) => countries.map((country) => ({
                    value: country.code,
                    text: country.name,
                })))),
                afterCreated: (control) => {
                    countryControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((countryCode) => countryCode !== countryControl.value && countryControl.setValue(countryCode)))
                        .subscribe();
                },
                readonlyTemplate: 'country',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_address_2',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.address_line_2,
                placeHolder: translation.forms.shared.address_line_2,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_district',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.district,
                placeHolder: translation.forms.shared.district,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => districts$.pipe(map((districts) => districts.map((district) => ({
                    value: district.id,
                    text: district.name,
                })))),
                afterCreated: (control) => {
                    districtControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((districtCode) => districtCode !== districtControl.value && districtControl.setValue(districtCode)))
                        .subscribe();
                },
                readonlyTemplate: 'district',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_zip_code',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.postal_code,
                placeHolder: translation.forms.shared.postal_code,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                afterCreated: (control) => {
                    let controlValue = control.value;
                    combineLatest([areas$, areaControl.valueChanges.pipe(startWith(areaControl.value))])
                        .pipe(tap(([areas, areaValue]) => {
                        const value = (areas.find((area) => area.id == areaValue) || areas[0])?.zip_code;
                        control.setValue(value || controlValue || control.value);
                        if (value) {
                            controlValue = value;
                            control.disable();
                        }
                        else {
                            controlValue = control.value;
                            control.enable();
                        }
                    }))
                        .subscribe();
                },
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
    ];
    const rightCompanyFields = [
        {
            key: 'company_entity_type_id',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.company.type,
                placeHolder: translation.forms.company.type,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => companyEntityTypes$.pipe(map((entityTypes) => entityTypes.map((entityType) => ({
                    value: Number(entityType.id),
                    text: entityType.name,
                })))),
                readonlyTemplate: 'company_entity_id',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_registration_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.company.registration_number,
                placeHolder: translation.forms.company.registration_number,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_username',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                inputType: 'email',
                label: translation.forms.company.username,
                placeHolder: translation.forms.company.username,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required, Validators.email],
        },
        {
            key: 'company_ownership',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                // inputType: 'number',
                mask: {
                    expression: 'separator.2',
                    config: {
                        thousandSeparator: ',',
                    },
                },
                label: translation.forms.shared.ownership,
                placeHolder: translation.forms.shared.ownership,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: (value) => `${value || '0'}%`,
                suffix: '%',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_country_code',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.country,
                placeHolder: translation.forms.shared.country,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                isDisabled: true,
                defaultValue: getCountryCodeFromStorage() === FSWCountryCode.VU ? 'VN' : getCountryCodeFromStorage(),
                loadItemsAsync: () => countries$.pipe(map((countries) => countries.map((country) => ({
                    value: country.code,
                    text: country.name,
                })))),
                afterCreated: (control) => {
                    control.valueChanges
                        .pipe(tap((countryCode) => countryCode !== countryControl.value && countryControl.setValue(countryCode)))
                        .subscribe();
                    countryControl.setValue(control.value);
                },
                readonlyTemplate: 'country',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_address_2',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.address_line_2,
                placeHolder: translation.forms.shared.address_line_2,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_district',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.district,
                placeHolder: translation.forms.shared.district,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => districts$.pipe(map((districts) => districts.map((district) => ({
                    value: district.id,
                    text: district.name,
                })))),
                afterCreated: (control) => {
                    districtControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((districtCode) => districtCode !== districtControl.value && districtControl.setValue(districtCode)))
                        .subscribe();
                },
                readonlyTemplate: 'district',
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_zip_code',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.postal_code,
                placeHolder: translation.forms.shared.postal_code,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                afterCreated: (control) => {
                    let controlValue = control.value;
                    areas$
                        .pipe(tap((areas) => {
                        const value = areas[0]?.zip_code;
                        control.setValue(value || controlValue || control.value);
                        if (value) {
                            controlValue = value;
                            control.disable();
                        }
                        else {
                            controlValue = control.value;
                            control.enable();
                        }
                    }))
                        .subscribe();
                },
                customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
    ];
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'w-full flex gap-[16px]',
        readonlyWhen$: isReadonly$,
        renderBy: 'container',
        containers: [
            {
                customClasses: 'w-full flex gap-[16px] flex-col w-[calc(50%-8px)]',
                fields: [
                    {
                        key: 'member_entity_type_id',
                        type: FSWDynamicBuilderControlTypes.RADIO_GROUP,
                        customClasses: 'h-[69px] flex items-center',
                        context: {
                            label: translation.forms.shared.member_entity_type.id,
                            defaultValue: Number(MemberTypeId.INDIVIDUAL),
                            direction: FSWCheckboxDirections.ROW,
                            gap: '12px',
                            items: [
                                {
                                    value: Number(MemberTypeId.INDIVIDUAL),
                                    renderTemplate: {
                                        label: translation.forms.shared.member_entity_type.individual,
                                    },
                                },
                                {
                                    value: Number(MemberTypeId.COMPANY),
                                    renderTemplate: {
                                        label: translation.forms.shared.member_entity_type.company,
                                    },
                                },
                            ],
                            fullWidth: true,
                            readonlyTemplate: (value) => {
                                if (value == MemberTypeId.INDIVIDUAL) {
                                    return translation.forms.shared.member_entity_type.individual;
                                }
                                else {
                                    return translation.forms.shared.member_entity_type.company;
                                }
                            },
                        },
                    },
                    {
                        key: 'recourse_type',
                        type: FSWDynamicBuilderControlTypes.RADIO_GROUP,
                        customClasses: 'h-[69px] flex items-center',
                        context: {
                            label: translation.forms.shared.recourse_type,
                            defaultValue: 'None',
                            direction: FSWCheckboxDirections.ROW,
                            gap: '12px',
                            loadItemsAsync: (form) => {
                                const entityTypeControl = getControlFromGroup(form, 'member_entity_type_id');
                                return entityTypeControl.valueChanges.pipe(startWith(entityTypeControl.value), map((value) => {
                                    if (value == MemberTypeId.INDIVIDUAL) {
                                        return [
                                            {
                                                value: FSWRecourseTypes.PG,
                                                renderTemplate: {
                                                    label: FSWRecourseTypes.PG,
                                                },
                                            },
                                            {
                                                value: 'None',
                                                renderTemplate: {
                                                    label: 'None',
                                                },
                                            },
                                        ];
                                    }
                                    return [
                                        {
                                            value: FSWRecourseTypes.CG,
                                            renderTemplate: {
                                                label: FSWRecourseTypes.CG,
                                            },
                                        },
                                        {
                                            value: 'None',
                                            renderTemplate: {
                                                label: 'None',
                                            },
                                        },
                                    ];
                                }));
                            },
                            fullWidth: true,
                            readonlyTemplate: (value) => value || 'NONE',
                        },
                    },
                    ...leftIndividualFields,
                    ...leftCompanyFields,
                ],
            },
            {
                customClasses: 'w-full flex gap-[16px] flex-col w-[calc(50%-8px)]',
                fields: [...rightIndividualFields, ...rightCompanyFields],
            },
            {
                customClasses: 'hidden',
                fields: [
                    {
                        key: 'citizenship_city_id',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            isDisabled: true,
                            afterCreated: (control) => {
                                cities$
                                    .pipe(tap((cities) => {
                                    const value = cities[0]?.id ? Number(cities[0]?.id) : cities[0]?.id;
                                    control.setValue(value, { emitEvent: false });
                                    cityControl.setValue(value);
                                }))
                                    .subscribe();
                            },
                            customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
                        },
                    },
                    {
                        key: 'company_city_id',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            isDisabled: true,
                            afterCreated: (control) => {
                                cities$
                                    .pipe(tap((cities) => {
                                    const value = cities[0]?.id ? Number(cities[0]?.id) : cities[0]?.id;
                                    control.setValue(value, { emitEvent: false });
                                    cityControl.setValue(value);
                                }))
                                    .subscribe();
                            },
                            customRender: getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
                        },
                    },
                    {
                        key: 'member_entity_code',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            isDisabled: true,
                            afterCreated: (control, group) => {
                                group.valueChanges
                                    .pipe(startWith(group.value))
                                    .subscribe(({ member_entity_type_id }) => control.setValue(member_entity_type_id === MemberTypeId.INDIVIDUAL
                                    ? MemberEntityCode.RETAIL
                                    : MemberEntityCode.CORPORATE, { emitEvent: false }));
                            },
                        },
                    },
                ],
            },
        ],
        form,
    });
};
const getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH = (entityId) => [
    {
        fields: [
            {
                key: 'member_entity_type_id',
                correctWhenValueIs: (value) => value == entityId,
            },
        ],
        checkingConditionCallback: (params, condition) => {
            if (condition) {
                params.renderView();
            }
            else {
                params.clearView();
            }
        },
    },
];
const getFSWBIPsFormCustomRenderAreaListenToMemberEntityChangeTH = (entityId, areas$) => [
    {
        fields: [
            {
                key: 'member_entity_type_id',
                correctWhenValueIs: (value) => value == entityId,
            },
            {
                key: entityId == MemberTypeId.INDIVIDUAL ? 'citizenship_district' : 'company_district',
                correctWhenValueIs: () => true,
            },
        ],
        checkingConditionCallback: (params, condition) => {
            if (!condition) {
                params.clearView();
                return;
            }
            const districtControl = getControlFromGroup(params.formGroup, entityId == MemberTypeId.INDIVIDUAL ? 'citizenship_district' : 'company_district');
            let entityControl = getControlFromGroup(params.formGroup, 'member_entity_type_id');
            if (!entityControl) {
                params.clearView();
                return;
            }
            if (!districtControl?.valid) {
                if (params.controlConfig.key.includes('_input')) {
                    params.clearView();
                    return;
                }
                params.renderView();
                const control = getDynamicBuilderHiddenControls(params.formGroup)[params.controlConfig.key];
                control.disable({ emitEvent: true });
                return;
            }
            areas$
                .pipe(takeUntil(entityControl.valueChanges), takeUntil(districtControl.valueChanges), tap((value) => {
                entityControl = getControlFromGroup(params.formGroup, 'member_entity_type_id');
                const canRender = params.controlConfig.key.includes('_input')
                    ? !value?.length
                    : !!value?.length;
                if (!canRender || entityControl.value != entityId) {
                    params.clearView();
                    return;
                }
                params.renderView();
                const control = getDynamicBuilderHiddenControls(params.formGroup)[params.controlConfig.key];
                if (!params.controlConfig.context.isDisabled) {
                    control.enable();
                }
            }))
                .subscribe();
        },
    },
];

class FSWBIPsHelperTH {
    getExtraColumns() {
        return [];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsHelperTH, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsHelperTH }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsHelperTH, decorators: [{
            type: Injectable
        }] });

const FSW_BIPS_TH_PROVIDERS = [
    {
        provide: FSW_BIPS_STORE_TOKEN,
        useClass: FSWBIPsStoreTH,
        deps: [
            APPLICATION_MEMBER_SERVICE_TOKEN,
            MASTER_DATA_SERVICE_TOKEN,
            REFERENCE_SERVICE_TOKEN,
            MEMBER_SERVICE_TOKEN,
            APPLICATION_MEMBER_BIP_SERVICE_TOKEN,
            SETTINGS_SERVICE_TOKEN,
            FSW_ALERT_SERVICE_TOKEN,
            FSW_BIPS_FORM_TOKEN,
        ],
    },
    {
        provide: FSW_BIPS_FORM_TOKEN,
        useValue: FSWBIPsFormTH,
        deps: [],
    },
    {
        provide: FSW_BIPS_HELPER_TOKEN,
        useClass: FSWBIPsHelperTH,
        deps: [],
    },
];

const FSW_BIPS_PROVIDERS = {
    default: FSW_BIPS_TH_PROVIDERS,
    [CountryCode.TH]: FSW_BIPS_TH_PROVIDERS,
    [CountryCode.ID]: FSW_BIPS_ID_PROVIDERS,
    [CountryCode.ZI]: FSW_BIPS_ID_PROVIDERS,
};
const bipsLoadProviders = (countryCode) => [
    fswTranslateScope('bips'),
    ...getCustomProviders(FSW_BIPS_PROVIDERS, FSW_BIPS_TH_PROVIDERS, countryCode),
];

class FSWBIPsTemplatePipe {
    constructor(componentStore) {
        this.componentStore = componentStore;
        this.latestValue = '';
    }
    transform(value, config, defaultNullValue = 'N/A') {
        const { stateKey, labelKey, compareKey } = config;
        this.componentStore
            .select((state) => state[stateKey])
            .pipe(map((data) => {
            const item = data.find((item) => item[compareKey] == value);
            this.latestValue = item ? `${item[labelKey]}` : defaultNullValue;
        }))
            .subscribe();
        return this.latestValue;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsTemplatePipe, deps: [{ token: FSW_BIPS_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsTemplatePipe, name: "fswBIPsTemplate", pure: false }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsTemplatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fswBIPsTemplate',
                    pure: false,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_BIPS_STORE_TOKEN]
                }] }]; } });

class FSWBIPsGridItemDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsGridItemDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWBIPsGridItemDirective, selector: "ng-template[fswBIPsGridItem]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsGridItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswBIPsGridItem]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

class FSWBIPsGridComponent {
    constructor() {
        this.itemDirective = null;
        this.rowClick = new EventEmitter();
        this.currentPageChange = new EventEmitter();
        this.itemsPerPageChange = new EventEmitter();
        this.columns = {};
        this.rows = [];
        this.emptyMessage = 'No data available.';
        this.itemsPerPage = 10;
        this.currentPage = 1;
    }
    get columnKeys() {
        return Object.keys(this.columns);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsGridComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWBIPsGridComponent, selector: "fsw-bips-grid", inputs: { columns: "columns", rows: "rows", emptyMessage: "emptyMessage", itemsPerPage: "itemsPerPage", currentPage: "currentPage" }, outputs: { rowClick: "rowClick", currentPageChange: "currentPageChange", itemsPerPageChange: "itemsPerPageChange" }, queries: [{ propertyName: "itemDirective", first: true, predicate: FSWBIPsGridItemDirective, descendants: true }], ngImport: i0, template: "<table class=\"fsw-table w-full\">\n  <thead>\n    <tr>\n      <ng-container *ngFor=\"let key of columnKeys\">\n        <th>{{ columns[key] | fswTranslate }}</th>\n      </ng-container>\n    </tr>\n  </thead>\n  <tbody>\n    <tr *ngFor=\"let row of rows\" (click)=\"rowClick.emit(row)\">\n      <ng-container *ngIf=\"!itemDirective; else existedTemplate\">\n        <ng-container *ngFor=\"let key of columnKeys\">\n          <td>{{ row[key] }}</td>\n        </ng-container>\n      </ng-container>\n      <ng-template #existedTemplate>\n        <ng-container\n          *ngTemplateOutlet=\"$any(itemDirective?.templateRef); context: { $implicit: row }\"\n        ></ng-container>\n      </ng-template>\n    </tr>\n  </tbody>\n  <tfoot>\n    <tr *ngIf=\"rows?.length\">\n      <td [colSpan]=\"columnKeys.length\">\n        <div class=\"flex justify-start\">\n          <fsw-pagination\n            [total]=\"rows.length\"\n            [(itemsPerPage)]=\"itemsPerPage\"\n            (itemsPerPageChange)=\"itemsPerPageChange.emit($event)\"\n            [(currentPage)]=\"currentPage\"\n            (currentPageChange)=\"currentPageChange.emit($event)\"\n          ></fsw-pagination>\n        </div>\n      </td>\n    </tr>\n    <tr *ngIf=\"!rows?.length\">\n      <td [colSpan]=\"columnKeys.length\">\n        <div class=\"w-full py-[80px] flex items-center justify-center\">\n          <p class=\"text-center\">{{ emptyMessage }}</p>\n        </div>\n      </td>\n    </tr>\n  </tfoot>\n</table>\n", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i1$4.FSWPaginationComponent, selector: "fsw-pagination", inputs: ["total", "itemsPerPage", "currentPage", "itemsPerPageOptions", "showSelectOptions", "showViewTotalText", "showNavigationText", "totalTextInside"], outputs: ["currentPageChange", "itemsPerPageChange"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsGridComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-bips-grid', changeDetection: ChangeDetectionStrategy.OnPush, template: "<table class=\"fsw-table w-full\">\n  <thead>\n    <tr>\n      <ng-container *ngFor=\"let key of columnKeys\">\n        <th>{{ columns[key] | fswTranslate }}</th>\n      </ng-container>\n    </tr>\n  </thead>\n  <tbody>\n    <tr *ngFor=\"let row of rows\" (click)=\"rowClick.emit(row)\">\n      <ng-container *ngIf=\"!itemDirective; else existedTemplate\">\n        <ng-container *ngFor=\"let key of columnKeys\">\n          <td>{{ row[key] }}</td>\n        </ng-container>\n      </ng-container>\n      <ng-template #existedTemplate>\n        <ng-container\n          *ngTemplateOutlet=\"$any(itemDirective?.templateRef); context: { $implicit: row }\"\n        ></ng-container>\n      </ng-template>\n    </tr>\n  </tbody>\n  <tfoot>\n    <tr *ngIf=\"rows?.length\">\n      <td [colSpan]=\"columnKeys.length\">\n        <div class=\"flex justify-start\">\n          <fsw-pagination\n            [total]=\"rows.length\"\n            [(itemsPerPage)]=\"itemsPerPage\"\n            (itemsPerPageChange)=\"itemsPerPageChange.emit($event)\"\n            [(currentPage)]=\"currentPage\"\n            (currentPageChange)=\"currentPageChange.emit($event)\"\n          ></fsw-pagination>\n        </div>\n      </td>\n    </tr>\n    <tr *ngIf=\"!rows?.length\">\n      <td [colSpan]=\"columnKeys.length\">\n        <div class=\"w-full py-[80px] flex items-center justify-center\">\n          <p class=\"text-center\">{{ emptyMessage }}</p>\n        </div>\n      </td>\n    </tr>\n  </tfoot>\n</table>\n" }]
        }], propDecorators: { itemDirective: [{
                type: ContentChild,
                args: [FSWBIPsGridItemDirective]
            }], rowClick: [{
                type: Output
            }], currentPageChange: [{
                type: Output
            }], itemsPerPageChange: [{
                type: Output
            }], columns: [{
                type: Input
            }], rows: [{
                type: Input
            }], emptyMessage: [{
                type: Input
            }], itemsPerPage: [{
                type: Input
            }], currentPage: [{
                type: Input
            }] } });

class FSWBIPsConfirmComponent {
    constructor(dialogRef) {
        this.dialogRef = dialogRef;
    }
    close(haveData = false) {
        this.dialogRef.close(haveData);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsConfirmComponent, deps: [{ token: i1$7.DialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWBIPsConfirmComponent, selector: "fsw-bips-confirm", providers: [FSWTranslatePipe], ngImport: i0, template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"dialogRef.config.data['yesButtonText'] | fswTranslate\"\n  [cancelButton]=\"dialogRef.config.data['noButtonText'] | fswTranslate\"\n  (confirmEvent)=\"close(true)\"\n  (cancelEvent)=\"close(false)\"\n  (closeEvent)=\"close(false)\"\n>\n  <ng-template fswModalBody>\n    <p\n      [innerHTML]=\"\n        dialogRef.config.data['description']\n          | fswTranslate : { data: dialogRef.config.data['descriptionParams'] }\n      \"\n    ></p>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsConfirmComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-bips-confirm', changeDetection: ChangeDetectionStrategy.OnPush, providers: [FSWTranslatePipe], template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"dialogRef.config.data['yesButtonText'] | fswTranslate\"\n  [cancelButton]=\"dialogRef.config.data['noButtonText'] | fswTranslate\"\n  (confirmEvent)=\"close(true)\"\n  (cancelEvent)=\"close(false)\"\n  (closeEvent)=\"close(false)\"\n>\n  <ng-template fswModalBody>\n    <p\n      [innerHTML]=\"\n        dialogRef.config.data['description']\n          | fswTranslate : { data: dialogRef.config.data['descriptionParams'] }\n      \"\n    ></p>\n  </ng-template>\n</fsw-modal>\n" }]
        }], ctorParameters: function () { return [{ type: i1$7.DialogRef }]; } });

class FSWBIPsAddComponent {
    constructor(componentStore, dialogRef, _memberService, _applicationMemberBIPService, _alertService, _dialog, _injector) {
        this.componentStore = componentStore;
        this.dialogRef = dialogRef;
        this._memberService = _memberService;
        this._applicationMemberBIPService = _applicationMemberBIPService;
        this._alertService = _alertService;
        this._dialog = _dialog;
        this._injector = _injector;
        this.type$ = new BehaviorSubject('link');
        this.keySearch$ = new Subject();
        this.page$ = new BehaviorSubject(1);
        this.bipPage$ = new BehaviorSubject(1);
        this.size$ = new BehaviorSubject(10);
        this.bipSize$ = new BehaviorSubject(10);
        this.selected$ = new BehaviorSubject(null);
        this.searchControl = new UntypedFormControl('');
        this.searchedMembers$ = this.keySearch$.pipe(filter((value) => this.type$.value === 'link' && !!value), tap(() => {
            this.page$.next(1);
            this.size$.next(10);
            this.selected$.next(null);
        }), switchMap((search) => combineLatest([this.page$, this.size$]).pipe(switchMap(([page, size]) => this._memberService
            .searchMembers({
            country_code: getCountryCodeFromStorage(),
            member_type_code: 'BRW',
            attributes: [
                'company_name',
                'fullname',
                'uuid',
                'id',
                'member_entity_code',
                'member_entity_type_id',
                'username',
                'member_type_id',
            ],
            memberActivationStatusIds: [1],
            memberStatusIds: [1, 3],
            search,
            page,
            size,
        })
            .pipe(map((res) => ({
            total: res.total,
            data: res.data.map((item) => ({
                expand: item,
                id: item.id,
                reference_id: item.uuid,
                reference_to: 'MEMBER',
            })),
        })))))));
        this.searchedBIPs$ = this.keySearch$.pipe(filter((value) => this.type$.value === 'link' && !!value), tap(() => {
            this.bipPage$.next(1);
            this.bipSize$.next(10);
            this.selected$.next(null);
        }), switchMap((search) => combineLatest([this.bipPage$, this.bipSize$]).pipe(switchMap(([page, limit]) => this._applicationMemberBIPService.searchMemberBIPs({
            search,
            page,
            limit,
            expand: true,
        })))));
        this.builder = this.componentStore.createBuilder(of(false));
    }
    close(action) {
        this.dialogRef.close(action);
    }
    link() {
        const valid = this._validateBeforeLink();
        if (!valid) {
            this._alertService.warning('Invalid Information', this.type$.value === 'link'
                ? 'Please select BIP to link'
                : 'Please make sure all mandatory fields are filled', {
                duration: 3000,
            });
            return;
        }
        this._dialog
            .open(FSWBIPsConfirmComponent, {
            data: {
                ...this.dialogRef.config.data,
                descriptionParams: {
                    ...this.dialogRef.config.data.descriptionParams,
                    name: this._getLinkName(),
                },
            },
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((result) => {
            if (result) {
                this.close({
                    type: this.type$.value,
                    data: this.type$.value === 'link'
                        ? this.selected$.value
                        : this.builder.groupConfig.form.getRawValue(),
                });
            }
        }))
            .subscribe();
    }
    changeToAddType() {
        this._resetBuilder();
        this.type$.next('add');
    }
    search() {
        this.type$.next('link');
        this.keySearch$.next('');
        this.selected$.next(null);
        setTimeout(() => {
            this.keySearch$.next(this.searchControl.value);
        }, 50);
    }
    _validateBeforeLink() {
        if (this.type$.value === 'link') {
            return !!this.selected$.value;
        }
        else {
            return this.builder.groupConfig.form.valid;
        }
    }
    _getLinkName() {
        return this.type$.value === 'link' ? this._getSelectedLinkName() : this._getFilledLinkName();
    }
    _getFilledLinkName() {
        const value = this.builder.groupConfig.form.value;
        if (value) {
            return value.member_entity_type_id.toString() === MemberTypeId.INDIVIDUAL
                ? value.fullname
                : value.company_name;
        }
        return '';
    }
    _getSelectedLinkName() {
        const value = this.selected$.value;
        if (value) {
            return value.expand.member_entity_type_id?.toString() === MemberTypeId.INDIVIDUAL
                ? value.expand.fullname
                : value.expand.company_name;
        }
        return '';
    }
    _resetBuilder() {
        const raw = this.builder.groupConfig.form.getRawValue();
        this.builder = this.componentStore.createBuilder(of(false));
        this.builder.groupConfig.form.patchValue(raw);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsAddComponent, deps: [{ token: FSW_BIPS_STORE_TOKEN }, { token: i1$7.DialogRef }, { token: MEMBER_SERVICE_TOKEN }, { token: APPLICATION_MEMBER_BIP_SERVICE_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }, { token: i1$7.Dialog }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWBIPsAddComponent, selector: "fsw-bips-add", ngImport: i0, template: "<fsw-modal\n  [size]=\"'l'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"dialogRef.config.data['confirmButtonText'] | fswTranslate\"\n  [cancelButton]=\"dialogRef.config.data['cancelButtonText'] | fswTranslate\"\n  [bodyCustomClasses]=\"'max-h-[calc(90vh-138px)] overflow-y-auto'\"\n  (confirmEvent)=\"link()\"\n  (cancelEvent)=\"close()\"\n  (closeEvent)=\"close()\"\n>\n  <ng-template fswModalBody>\n    <section class=\"flex flex-col gap-[16px]\">\n      <header class=\"flex flex-col items-end\">\n        <fsw-field [fullWidth]=\"true\">\n          <input\n            fswInput\n            [placeholder]=\"'modal.search' | fswTranslate\"\n            [formControl]=\"searchControl\"\n            (keyup.enter)=\"search()\"\n          />\n          <ng-template fswFieldInputSuffix>\n            <button fswButton [appearance]=\"'link'\" (click)=\"search()\">\n              <span>Search</span>\n              <i [fswIcon]=\"'common-search'\"></i>\n            </button>\n          </ng-template>\n        </fsw-field>\n        <button fswButton [appearance]=\"'link'\" (click)=\"changeToAddType()\">\n          {{ 'buttons.add_bip' | fswTranslate }}\n        </button>\n      </header>\n      <main class=\"w-full overflow-x-auto\">\n        <ng-container [ngSwitch]=\"type$ | async\">\n          <ng-container *ngSwitchCase=\"'add'\">\n            <form [formGroup]=\"builder.groupConfig.form\">\n              <fsw-dynamic-builder [builder]=\"builder\">\n                <ng-template fswDynamicBuilderTemplate key=\"district\" let-value>\n                  {{\n                    value\n                      | fswBIPsTemplate\n                        : { stateKey: 'districts', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"province\" let-value>\n                  {{\n                    value\n                      | fswBIPsTemplate\n                        : { stateKey: 'provinces', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"industry\" let-value>\n                  {{\n                    value\n                      | fswBIPsTemplate\n                        : { stateKey: 'industries', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"sub_industry\" let-value>\n                  {{\n                    value\n                      | fswBIPsTemplate\n                        : { stateKey: 'subIndustries', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"gender\" let-value>\n                  {{\n                    value\n                      | fswBIPsTemplate\n                        : { stateKey: 'genders', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"city\" let-value>\n                  {{\n                    value\n                      | fswBIPsTemplate : { stateKey: 'cities', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"country\" let-value>\n                  {{\n                    value\n                      | fswBIPsTemplate\n                        : { stateKey: 'countries', labelKey: 'name', compareKey: 'code' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"area\" let-value>\n                  {{\n                    value\n                      | fswBIPsTemplate : { stateKey: 'areas', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"company_entity_id\" let-value>\n                  {{\n                    value\n                      | fswBIPsTemplate\n                        : { stateKey: 'companyEntityTypes', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"basic\" let-value>\n                  {{ value ?? 'N/A' }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"date\" let-value>\n                  {{ value ? (value | date : 'dd/MM/yyyy') : 'N/A' }}\n                </ng-template>\n              </fsw-dynamic-builder>\n            </form>\n          </ng-container>\n          <ng-container *ngSwitchDefault>\n            <fsw-tabs-group\n              [customRowGap]=\"'24px'\"\n              [customColumnGap]=\"'24px'\"\n              (activeKeyChange)=\"search()\"\n            >\n              <ng-template\n                fswTabs\n                [key]=\"'application'\"\n                [maxTextWidth]=\"'unset'\"\n                [label]=\"'tabs.application' | fswTranslate\"\n              >\n                <ng-container *ngIf=\"searchedBIPs$ | async as searchedBIPs\">\n                  <table class=\"fsw-table w-full\">\n                    <caption class=\"hidden\">\n                      Select BIP from Application\n                    </caption>\n                    <thead>\n                      <tr>\n                        <th>{{ 'table.full_name' | fswTranslate }}</th>\n                        <th>{{ 'table.company_name' | fswTranslate }}</th>\n                        <th>{{ 'table.email_address' | fswTranslate }}</th>\n                      </tr>\n                    </thead>\n                    <tbody>\n                      <ng-container *ngFor=\"let bip of searchedBIPs.data || []\">\n                        <tr>\n                          <td>\n                            <fsw-radio\n                              (click)=\"selected$.next(bip)\"\n                              [id]=\"bip.reference_id\"\n                              [name]=\"'fsw-bips-add-application-radio'\"\n                              [label]=\"bip.expand.fullname\"\n                              [value]=\"bip.reference_id\"\n                              [groupValue]=\"(selected$ | async)?.reference_id || null\"\n                            ></fsw-radio>\n                          </td>\n                          <td>{{ bip.expand.company_name }}</td>\n                          <td>{{ bip.expand.username }}</td>\n                        </tr>\n                      </ng-container>\n                    </tbody>\n                    <tfoot *ngIf=\"searchedBIPs.total\">\n                      <tr>\n                        <td [colSpan]=\"4\">\n                          <div class=\"flex justify-start\">\n                            <fsw-pagination\n                              [total]=\"searchedBIPs.total\"\n                              [itemsPerPage]=\"bipSize$.value\"\n                              [currentPage]=\"bipPage$.value\"\n                              (itemsPerPageChange)=\"bipSize$.next($event)\"\n                              (currentPageChange)=\"bipPage$.next($event)\"\n                            ></fsw-pagination>\n                          </div>\n                        </td>\n                      </tr>\n                    </tfoot>\n                  </table>\n                </ng-container>\n              </ng-template>\n              <ng-template\n                fswTabs\n                [key]=\"'command_center'\"\n                [maxTextWidth]=\"'unset'\"\n                [label]=\"'tabs.command_center' | fswTranslate\"\n              >\n                <ng-container *ngIf=\"searchedMembers$ | async as searchedMembers\">\n                  <table class=\"fsw-table w-full\">\n                    <caption class=\"hidden\">\n                      Select BIP from Command Center\n                    </caption>\n                    <thead>\n                      <tr>\n                        <th>{{ 'table.full_name' | fswTranslate }}</th>\n                        <th>{{ 'table.company_name' | fswTranslate }}</th>\n                        <th>{{ 'table.email_address' | fswTranslate }}</th>\n                      </tr>\n                    </thead>\n                    <tbody>\n                      <ng-container *ngFor=\"let member of searchedMembers.data || []\">\n                        <tr>\n                          <td>\n                            <fsw-radio\n                              (click)=\"selected$.next(member)\"\n                              [id]=\"member.reference_id\"\n                              [name]=\"'fsw-bips-add-cc-radio'\"\n                              [label]=\"member.expand.fullname\"\n                              [value]=\"member.reference_id\"\n                              [groupValue]=\"(selected$ | async)?.reference_id || null\"\n                            ></fsw-radio>\n                          </td>\n                          <td>{{ member.expand.company_name }}</td>\n                          <td>{{ member.expand.username }}</td>\n                        </tr>\n                      </ng-container>\n                    </tbody>\n                    <tfoot *ngIf=\"searchedMembers.total\">\n                      <tr>\n                        <td [colSpan]=\"4\">\n                          <div class=\"flex justify-start\">\n                            <fsw-pagination\n                              [total]=\"searchedMembers.total\"\n                              [itemsPerPage]=\"size$.value\"\n                              [currentPage]=\"page$.value\"\n                              (itemsPerPageChange)=\"size$.next($event)\"\n                              (currentPageChange)=\"page$.next($event)\"\n                            ></fsw-pagination>\n                          </div>\n                        </td>\n                      </tr>\n                    </tfoot>\n                  </table>\n                </ng-container>\n              </ng-template>\n            </fsw-tabs-group>\n          </ng-container>\n        </ng-container>\n      </main>\n    </section>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "directive", type: i1$4.FSWDynamicBuilderTemplateDirective, selector: "[fswDynamicBuilderTemplate]", inputs: ["key"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$4.FSWFieldInputSuffixDirective, selector: "ng-template[fswFieldInputSuffix]" }, { kind: "directive", type: i1$4.FSWInputDirective, selector: "input[fswInput], textarea[fswInput]" }, { kind: "component", type: i1$4.FSWPaginationComponent, selector: "fsw-pagination", inputs: ["total", "itemsPerPage", "currentPage", "itemsPerPageOptions", "showSelectOptions", "showViewTotalText", "showNavigationText", "totalTextInside"], outputs: ["currentPageChange", "itemsPerPageChange"] }, { kind: "component", type: i1$4.FSWTabsGroupComponent, selector: "fsw-tabs-group" }, { kind: "directive", type: i1$4.FSWTabsDirective, selector: "ng-template[fswTabs]" }, { kind: "component", type: i1$4.FSWRadioComponent, selector: "fsw-radio" }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i1$1.DatePipe, name: "date" }, { kind: "pipe", type: FSWBIPsTemplatePipe, name: "fswBIPsTemplate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsAddComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-bips-add', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal\n  [size]=\"'l'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"dialogRef.config.data['confirmButtonText'] | fswTranslate\"\n  [cancelButton]=\"dialogRef.config.data['cancelButtonText'] | fswTranslate\"\n  [bodyCustomClasses]=\"'max-h-[calc(90vh-138px)] overflow-y-auto'\"\n  (confirmEvent)=\"link()\"\n  (cancelEvent)=\"close()\"\n  (closeEvent)=\"close()\"\n>\n  <ng-template fswModalBody>\n    <section class=\"flex flex-col gap-[16px]\">\n      <header class=\"flex flex-col items-end\">\n        <fsw-field [fullWidth]=\"true\">\n          <input\n            fswInput\n            [placeholder]=\"'modal.search' | fswTranslate\"\n            [formControl]=\"searchControl\"\n            (keyup.enter)=\"search()\"\n          />\n          <ng-template fswFieldInputSuffix>\n            <button fswButton [appearance]=\"'link'\" (click)=\"search()\">\n              <span>Search</span>\n              <i [fswIcon]=\"'common-search'\"></i>\n            </button>\n          </ng-template>\n        </fsw-field>\n        <button fswButton [appearance]=\"'link'\" (click)=\"changeToAddType()\">\n          {{ 'buttons.add_bip' | fswTranslate }}\n        </button>\n      </header>\n      <main class=\"w-full overflow-x-auto\">\n        <ng-container [ngSwitch]=\"type$ | async\">\n          <ng-container *ngSwitchCase=\"'add'\">\n            <form [formGroup]=\"builder.groupConfig.form\">\n              <fsw-dynamic-builder [builder]=\"builder\">\n                <ng-template fswDynamicBuilderTemplate key=\"district\" let-value>\n                  {{\n                    value\n                      | fswBIPsTemplate\n                        : { stateKey: 'districts', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"province\" let-value>\n                  {{\n                    value\n                      | fswBIPsTemplate\n                        : { stateKey: 'provinces', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"industry\" let-value>\n                  {{\n                    value\n                      | fswBIPsTemplate\n                        : { stateKey: 'industries', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"sub_industry\" let-value>\n                  {{\n                    value\n                      | fswBIPsTemplate\n                        : { stateKey: 'subIndustries', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"gender\" let-value>\n                  {{\n                    value\n                      | fswBIPsTemplate\n                        : { stateKey: 'genders', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"city\" let-value>\n                  {{\n                    value\n                      | fswBIPsTemplate : { stateKey: 'cities', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"country\" let-value>\n                  {{\n                    value\n                      | fswBIPsTemplate\n                        : { stateKey: 'countries', labelKey: 'name', compareKey: 'code' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"area\" let-value>\n                  {{\n                    value\n                      | fswBIPsTemplate : { stateKey: 'areas', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"company_entity_id\" let-value>\n                  {{\n                    value\n                      | fswBIPsTemplate\n                        : { stateKey: 'companyEntityTypes', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"basic\" let-value>\n                  {{ value ?? 'N/A' }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"date\" let-value>\n                  {{ value ? (value | date : 'dd/MM/yyyy') : 'N/A' }}\n                </ng-template>\n              </fsw-dynamic-builder>\n            </form>\n          </ng-container>\n          <ng-container *ngSwitchDefault>\n            <fsw-tabs-group\n              [customRowGap]=\"'24px'\"\n              [customColumnGap]=\"'24px'\"\n              (activeKeyChange)=\"search()\"\n            >\n              <ng-template\n                fswTabs\n                [key]=\"'application'\"\n                [maxTextWidth]=\"'unset'\"\n                [label]=\"'tabs.application' | fswTranslate\"\n              >\n                <ng-container *ngIf=\"searchedBIPs$ | async as searchedBIPs\">\n                  <table class=\"fsw-table w-full\">\n                    <caption class=\"hidden\">\n                      Select BIP from Application\n                    </caption>\n                    <thead>\n                      <tr>\n                        <th>{{ 'table.full_name' | fswTranslate }}</th>\n                        <th>{{ 'table.company_name' | fswTranslate }}</th>\n                        <th>{{ 'table.email_address' | fswTranslate }}</th>\n                      </tr>\n                    </thead>\n                    <tbody>\n                      <ng-container *ngFor=\"let bip of searchedBIPs.data || []\">\n                        <tr>\n                          <td>\n                            <fsw-radio\n                              (click)=\"selected$.next(bip)\"\n                              [id]=\"bip.reference_id\"\n                              [name]=\"'fsw-bips-add-application-radio'\"\n                              [label]=\"bip.expand.fullname\"\n                              [value]=\"bip.reference_id\"\n                              [groupValue]=\"(selected$ | async)?.reference_id || null\"\n                            ></fsw-radio>\n                          </td>\n                          <td>{{ bip.expand.company_name }}</td>\n                          <td>{{ bip.expand.username }}</td>\n                        </tr>\n                      </ng-container>\n                    </tbody>\n                    <tfoot *ngIf=\"searchedBIPs.total\">\n                      <tr>\n                        <td [colSpan]=\"4\">\n                          <div class=\"flex justify-start\">\n                            <fsw-pagination\n                              [total]=\"searchedBIPs.total\"\n                              [itemsPerPage]=\"bipSize$.value\"\n                              [currentPage]=\"bipPage$.value\"\n                              (itemsPerPageChange)=\"bipSize$.next($event)\"\n                              (currentPageChange)=\"bipPage$.next($event)\"\n                            ></fsw-pagination>\n                          </div>\n                        </td>\n                      </tr>\n                    </tfoot>\n                  </table>\n                </ng-container>\n              </ng-template>\n              <ng-template\n                fswTabs\n                [key]=\"'command_center'\"\n                [maxTextWidth]=\"'unset'\"\n                [label]=\"'tabs.command_center' | fswTranslate\"\n              >\n                <ng-container *ngIf=\"searchedMembers$ | async as searchedMembers\">\n                  <table class=\"fsw-table w-full\">\n                    <caption class=\"hidden\">\n                      Select BIP from Command Center\n                    </caption>\n                    <thead>\n                      <tr>\n                        <th>{{ 'table.full_name' | fswTranslate }}</th>\n                        <th>{{ 'table.company_name' | fswTranslate }}</th>\n                        <th>{{ 'table.email_address' | fswTranslate }}</th>\n                      </tr>\n                    </thead>\n                    <tbody>\n                      <ng-container *ngFor=\"let member of searchedMembers.data || []\">\n                        <tr>\n                          <td>\n                            <fsw-radio\n                              (click)=\"selected$.next(member)\"\n                              [id]=\"member.reference_id\"\n                              [name]=\"'fsw-bips-add-cc-radio'\"\n                              [label]=\"member.expand.fullname\"\n                              [value]=\"member.reference_id\"\n                              [groupValue]=\"(selected$ | async)?.reference_id || null\"\n                            ></fsw-radio>\n                          </td>\n                          <td>{{ member.expand.company_name }}</td>\n                          <td>{{ member.expand.username }}</td>\n                        </tr>\n                      </ng-container>\n                    </tbody>\n                    <tfoot *ngIf=\"searchedMembers.total\">\n                      <tr>\n                        <td [colSpan]=\"4\">\n                          <div class=\"flex justify-start\">\n                            <fsw-pagination\n                              [total]=\"searchedMembers.total\"\n                              [itemsPerPage]=\"size$.value\"\n                              [currentPage]=\"page$.value\"\n                              (itemsPerPageChange)=\"size$.next($event)\"\n                              (currentPageChange)=\"page$.next($event)\"\n                            ></fsw-pagination>\n                          </div>\n                        </td>\n                      </tr>\n                    </tfoot>\n                  </table>\n                </ng-container>\n              </ng-template>\n            </fsw-tabs-group>\n          </ng-container>\n        </ng-container>\n      </main>\n    </section>\n  </ng-template>\n</fsw-modal>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_BIPS_STORE_TOKEN]
                }] }, { type: i1$7.DialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_BIP_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: i1$7.Dialog }, { type: i0.Injector }]; } });

var title$E = "Main Borrower Details";
var forms$8 = {
	individual: {
		name: "Name",
		email: "Email",
		gender: "Gender",
		mobile_phone: "Mobile Phone",
		id_card_number: "ID Card Number",
		passport_number: "Passport Number",
		date_of_birth: "Date of Birth",
		place_of_birth: "Place of Birth"
	},
	company: {
		name: "Company Name",
		type: "Company Type",
		username: "Username",
		industry: "Industry",
		registration_number: "Registration Number",
		establishment_date: "Establishment Date"
	},
	shared: {
		member_entity_type: {
			id: "Entity Type",
			individual: "Individual",
			company: "Company"
		},
		tax_number: "Tax Number",
		address_line_1: "Address Line 1",
		address_line_2: "Address Line 2",
		country: "Country",
		state_province: "State/Province",
		district: "District",
		postal_code: "Postal Code"
	}
};
var buttons$X = {
	cancel: "Cancel",
	save_changes: "Save Changes",
	replace: "Replace",
	edit: "Edit",
	search: "Search",
	add_borrower: "Add New Borrower",
	replace_borrower: "Replace Borrower"
};
var modal$5 = {
	title: "Replace Main Borrower",
	search: "Search company or individual name",
	confirm_cancel: {
		title: "Are you sure you want to cancel the editing information?",
		description: "You will lose all the information that you are editing about the main borrower",
		no: "No, continue edit",
		yes: "Yes, cancel"
	},
	confirm_save: {
		title: "Are you sure you want to save borrower information?",
		description: "You will replace all the current information that you updated about the main borrower",
		no: "No, don't change",
		yes: "Yes, save borrower"
	},
	confirm_add: {
		title: "Are you sure you want to add a new borrower?",
		description: "You will lose all the information that you added about the main borrower",
		no: "No, don't change",
		yes: "Yes, add new borrower"
	},
	confirm_replace: {
		title: "Are you sure you want to replace borrower?",
		description: "You will lose all the information that you added. Would you like to replace with your new borrower <b class='text-blue-500 font-bold'>{{name}}?</b>",
		no: "No, don't change",
		yes: "Yes, replace"
	}
};
var table$2 = {
	full_name: "Full Name",
	entity_type: "Entity Type",
	company_name: "Company Name",
	email_address: "Email Address"
};
var th$c = {
	title: title$E,
	forms: forms$8,
	buttons: buttons$X,
	modal: modal$5,
	table: table$2
};

var TH$8 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$X,
    default: th$c,
    forms: forms$8,
    modal: modal$5,
    table: table$2,
    title: title$E
});

const FSW_MAIN_BORROWER_TRANSLATION_LOADER = {
    [CountryCode.TH]: TH$8,
};

const FSW_MAIN_BORROWER_STORE_TOKEN = new InjectionToken('FSW_MAIN_BORROWER_STORE_TOKEN');

const FSW_MAIN_BORROWER_FORM_TOKEN = new InjectionToken('FSW_MAIN_BORROWER_FORM_TOKEN');

const fswMainBorrowerInitialState = {
    applicationId: null,
    genders: [],
    industries: [],
    subIndustries: [],
    companyEntityTypes: [],
    countries: [],
    provinces: [],
    districts: [],
    cities: [],
    areas: [],
    isReadonly: false,
    isEditable: false,
};
class FSWMainBorrowerStore extends ApplicationMemberInformationStore {
    constructor(_applicationMemberService, _masterDataService, _referenceService, _memberService, _alertService, _form, _initialOptionalState) {
        super(_applicationMemberService, Object.assign(fswMainBorrowerInitialState, _initialOptionalState || {}));
        this._applicationMemberService = _applicationMemberService;
        this._masterDataService = _masterDataService;
        this._referenceService = _referenceService;
        this._memberService = _memberService;
        this._alertService = _alertService;
        this._form = _form;
        this._initialOptionalState = _initialOptionalState;
        this.countryControl = new UntypedFormControl(getCountryCodeFromStorage());
        this.provinceControl = new UntypedFormControl(null);
        this.industryControl = new UntypedFormControl(null);
        this.cityControl = new UntypedFormControl(null);
        this.districtControl = new UntypedFormControl(null);
        this._referenceSaveMapping = new Map();
        this.builder = this.createBuilder();
        this.init = this.effect(pipe(switchMap(() => this.loadAssets()), tap(() => {
            this.listenControlChange();
            this.patchMemberToBuilder();
        }), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        this.save = this.effect(pipe(switchMap(() => this._memberService
            .updateMember(this.state().member?.uuid, this._resolveMemberData(this.builder.groupConfig.form.getRawValue()))
            .pipe(tap(() => {
            this._alertService.success('Notification', 'Saved member successfully!', {
                duration: 3000,
            });
        }), switchMap(() => this.setupInformation(this.state().applicationId)), catchError((err) => {
            console.error(err);
            this._alertService.error('Something went wrong', 'Fail to save member information! Please try again', {
                duration: 3000,
            });
            return EMPTY;
        })))));
        this.replace = this.effect(pipe(switchMap(({ data, type }) => {
            const removeObs$ = this.state().member
                ? this._applicationMemberService.removeMember(this.state().applicationId, this.state().member?.uuid)
                : from(Promise.resolve('Member does not exist in current application'));
            return removeObs$.pipe(switchMap(() => {
                const obs$ = type === 'replace'
                    ? this._applicationMemberService.linkMember(this.state().applicationId, {
                        type: 'MAIN',
                        additional_data: {},
                        member_id: data,
                    })
                    : this._memberService.addMember(this._resolveMemberDataBeforeAdd(data)).pipe(switchMap((member) => this._applicationMemberService.linkMember(this.state().applicationId, {
                        type: 'MAIN',
                        additional_data: this._resolveMemberDataBeforeAdd(data),
                        member_id: member.uuid,
                    })));
                return obs$.pipe(tap(() => {
                    this._alertService.success('Notification', 'Saved member successfully!', {
                        duration: 3000,
                    });
                }), switchMap(() => this.setupInformation(this.state().applicationId).pipe(tap(() => {
                    this.patchMemberToBuilder();
                }))));
            }), catchError((err) => {
                console.error(err);
                this._alertService.error('Something went wrong', 'Fail to save member information! Please try again', {
                    duration: 3000,
                });
                return EMPTY;
            }));
        })));
        this.listenCountryChange = this.effect(pipe(switchMap(() => this.countryControl.valueChanges.pipe(startWith(this.countryControl.value), tap(() => {
            this.updateState({ provinces: [] });
            this._updateFormToMapping('citizenship_state_id');
            this._updateFormToMapping('company_state_id');
            this.builder.groupConfig.form.patchValue({
                citizenship_state_id: null,
                company_state_id: null,
            });
        }), filter((countryId) => !!countryId), switchMap(() => this._masterDataService.getProvinces(this._getCountryCode()).pipe(tap((provinces) => {
            this.updateState({ provinces });
            this._updateMappingToForm('citizenship_state_id', (value) => provinces.some((province) => province.id == value));
            this._updateMappingToForm('company_state_id', (value) => provinces.some((province) => province.id == value));
        })))))));
        this.listenIndustryChange = this.effect(pipe(switchMap(() => this.industryControl.valueChanges.pipe(startWith(this.industryControl.value), tap(() => this.updateState({ subIndustries: [] })), filter((industryId) => !!industryId), switchMap((industryId) => this._referenceService
            .getSubIndustries(industryId)
            .pipe(tap((subIndustries) => this.updateState({ subIndustries }))))))));
        this.listenProvinceChange = this.effect(pipe(switchMap(() => this.provinceControl.valueChanges.pipe(startWith(this.provinceControl.value), tap(() => {
            this.updateState({ cities: [] });
            this._updateFormToMapping('citizenship_city_id');
            this._updateFormToMapping('company_city_id');
            this.builder.groupConfig.form.patchValue({
                citizenship_city_id: null,
                company_city_id: null,
            });
        }), filter((provinceId) => !!provinceId), switchMap((provinceId) => this._masterDataService.getCities(provinceId, this._getCountryCode()).pipe(tap((cities) => {
            this.updateState({ cities });
            this._updateMappingToForm('citizenship_city_id', (value) => cities.some((city) => city.id == value));
            this._updateMappingToForm('company_city_id', (value) => cities.some((city) => city.id == value));
        })))))));
        this.listenCityChange = this.effect(pipe(switchMap(() => this.cityControl.valueChanges.pipe(startWith(this.cityControl.value), tap(() => {
            this.updateState({ districts: [] });
            this._updateFormToMapping('citizenship_district');
            this._updateFormToMapping('company_district');
            this.builder.groupConfig.form.patchValue({
                citizenship_district: null,
                company_district: null,
            });
        }), filter((cityId) => !!cityId), switchMap((cityId) => this._masterDataService.getDistricts(cityId, this._getCountryCode()).pipe(tap((districts) => {
            this.updateState({ districts });
            this._updateMappingToForm('citizenship_district', (value) => districts.some((district) => district.id == value));
            this._updateMappingToForm('company_district', (value) => districts.some((district) => district.id == value));
        })))))));
        this.listenDistrictChange = this.effect(pipe(switchMap(() => this.districtControl.valueChanges.pipe(startWith(this.districtControl.value), tap(() => {
            this.updateState({ areas: [] });
        }), filter((districtId) => !!districtId), switchMap((districtId) => this._masterDataService
            .getAreas(districtId, this._getCountryCode())
            .pipe(tap((areas) => this.updateState({ areas }))))))));
        this.updateState = (value) => this.patchState({
            ...value,
        });
    }
    getApplicationMembersInformation(entityId, applicationParams, memberParams) {
        return this._applicationMemberService.getApplicationMembersInformation(entityId, applicationParams, memberParams);
    }
    loadAssets() {
        return forkJoin([
            this.setupInformation(this.state().applicationId),
            this._masterDataService.getCountries().pipe(tap((countries) => this.patchState({
                countries,
            }))),
            this._masterDataService
                .getGenders()
                .pipe(tap((genders) => this.patchState({ genders }))),
            this._masterDataService
                .getIndustries()
                .pipe(tap((industries) => this.patchState({ industries }))),
            this._masterDataService
                .getCompanyEntityTypes()
                .pipe(tap((companyEntityTypes) => this.patchState({ companyEntityTypes }))),
        ]);
    }
    listenControlChange() {
        this.listenCountryChange();
        this.listenIndustryChange();
        this.listenProvinceChange();
        this.listenCityChange();
        this.listenDistrictChange();
    }
    patchMemberToBuilder() {
        this._referenceSaveMapping.clear();
        const member = this.state().member;
        this.builder.groupConfig.form.patchValue({
            ...(member || {}),
            ...(member
                ? {
                    company_username: member.username,
                    company_tax_card_number: member.tax_card_number,
                }
                : {}),
        });
    }
    createBuilder(notAllowEditableChange = false) {
        return this._form(new UntypedFormGroup({}), notAllowEditableChange ? of(false) : this.select((state) => !state.isEditable), {
            countryControl: this.countryControl,
            industryControl: this.industryControl,
            provinceControl: this.provinceControl,
            cityControl: this.cityControl,
            districtControl: this.districtControl,
            countries$: this.select((state) => state.countries),
            genders$: this.select((state) => state.genders),
            industries$: this.select((state) => state.industries),
            companyEntityTypes$: this.select((state) => state.companyEntityTypes),
            subIndustries$: this.select((state) => state.subIndustries),
            provinces$: this.select((state) => state.provinces),
            districts$: this.select((state) => state.districts),
            cities$: this.select((state) => state.cities),
            areas$: this.select((state) => state.areas),
        });
    }
    _updateFormToMapping(key) {
        const value = this._referenceSaveMapping.get(key) || null;
        this._referenceSaveMapping.set(key, this.builder.groupConfig.form.getRawValue()[key] || value);
    }
    _updateMappingToForm(key, conditional) {
        const value = this._referenceSaveMapping.get(key) || null;
        if (conditional(value)) {
            this.builder.groupConfig.form.patchValue({
                [key]: value,
            });
        }
    }
    _getCountryCode() {
        return this.countryControl.value === 'VN' ? FSWCountryCode.VU : this.countryControl.value;
    }
    _resolveMemberDataBeforeAdd(data) {
        return {
            ...this._resolveMemberData(data),
            country_code: getCountryCodeFromStorage(),
            member_type_id: '2',
            member_status_id: '1',
            member_activation_status_id: '1',
        };
    }
    _resolveMemberData(data) {
        return {
            ...data,
            username: data['company_username'] || data['username'],
            tax_card_number: data['company_tax_card_number'] || data['tax_card_number'],
        };
    }
}

class FSWMainBorrowerStoreTH extends FSWMainBorrowerStore {
    constructor(_applicationMemberService, _masterDataService, _referenceService, _memberService, _alertService, _form) {
        super(_applicationMemberService, _masterDataService, _referenceService, _memberService, _alertService, _form);
        this._applicationMemberService = _applicationMemberService;
        this._masterDataService = _masterDataService;
        this._referenceService = _referenceService;
        this._memberService = _memberService;
        this._alertService = _alertService;
        this._form = _form;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWMainBorrowerStoreTH, deps: [{ token: APPLICATION_MEMBER_SERVICE_TOKEN }, { token: MASTER_DATA_SERVICE_TOKEN }, { token: REFERENCE_SERVICE_TOKEN }, { token: MEMBER_SERVICE_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }, { token: FSW_MAIN_BORROWER_FORM_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWMainBorrowerStoreTH }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWMainBorrowerStoreTH, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MASTER_DATA_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [REFERENCE_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_MAIN_BORROWER_FORM_TOKEN]
                }] }]; } });

const FSWMainBorrowerFormTH = (form, isReadonly$, config) => {
    const translation = FSW_MAIN_BORROWER_TRANSLATION_LOADER[CountryCode.TH];
    const { provinces$, countryControl, provinceControl, districtControl, cityControl, countries$, industryControl, industries$, companyEntityTypes$, genders$, districts$, cities$, areas$, } = config;
    const leftIndividualFields = [
        {
            key: 'username',
            type: FSWDynamicBuilderControlTypes.INPUT,
            customClasses: 'contents',
            context: {
                inputType: 'email',
                label: translation.forms.individual.email,
                placeHolder: translation.forms.individual.email,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required, Validators.email],
        },
        {
            key: 'mobile_phone_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.individual.mobile_phone,
                placeHolder: translation.forms.individual.mobile_phone,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'passport_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.individual.passport_number,
                placeHolder: translation.forms.individual.passport_number,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
        },
        {
            key: 'birth_date',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
            context: {
                label: translation.forms.individual.date_of_birth,
                placeHolder: 'DD/MM/YYYY',
                isRequired: true,
                fullWidth: true,
                closeOnSelected: true,
                readonlyTemplate: 'date',
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_address_1',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.address_line_1,
                placeHolder: translation.forms.shared.address_line_1,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_country_code',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.country,
                placeHolder: translation.forms.shared.country,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                defaultValue: getCountryCodeFromStorage() === FSWCountryCode.VU ? 'VN' : getCountryCodeFromStorage(),
                loadItemsAsync: () => countries$.pipe(map((countries) => countries.map((country) => ({
                    value: country.code,
                    text: country.name,
                })))),
                afterCreated: (control) => {
                    countryControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((countryCode) => countryCode !== countryControl.value && countryControl.setValue(countryCode)))
                        .subscribe();
                },
                readonlyTemplate: 'country',
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_district',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.district,
                placeHolder: translation.forms.shared.district,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => districts$.pipe(map((districts) => districts.map((district) => ({
                    value: district.id,
                    text: district.name,
                })))),
                afterCreated: (control) => {
                    districtControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((districtCode) => districtCode !== districtControl.value && districtControl.setValue(districtCode)))
                        .subscribe();
                },
                readonlyTemplate: 'district',
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
    ];
    const leftCompanyFields = [
        {
            key: 'company_entity_type_id',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.company.type,
                placeHolder: translation.forms.company.type,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => companyEntityTypes$.pipe(map((entityTypes) => entityTypes.map((entityType) => ({
                    value: entityType.id,
                    text: entityType.name,
                })))),
                readonlyTemplate: 'company_entity_id',
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_industry_id',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.company.industry,
                placeHolder: translation.forms.company.industry,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => industries$.pipe(map((industries) => industries.map((industry) => ({
                    value: industry.id,
                    text: industry.name,
                })))),
                readonlyTemplate: 'industry',
                afterCreated: (control) => {
                    countryControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((industry) => industry !== industryControl.value && industryControl.setValue(industry)))
                        .subscribe();
                },
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_tax_card_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                inputType: 'number',
                label: translation.forms.shared.tax_number,
                placeHolder: translation.forms.shared.tax_number,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_address_1',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.address_line_1,
                placeHolder: translation.forms.shared.address_line_1,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_country_code',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.country,
                placeHolder: translation.forms.shared.country,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                defaultValue: getCountryCodeFromStorage() === FSWCountryCode.VU ? 'VN' : getCountryCodeFromStorage(),
                isDisabled: true,
                loadItemsAsync: () => countries$.pipe(map((countries) => countries.map((country) => ({
                    value: country.code,
                    text: country.name,
                })))),
                afterCreated: (control) => {
                    control.valueChanges
                        .pipe(tap((countryCode) => countryCode !== countryControl.value && countryControl.setValue(countryCode)))
                        .subscribe();
                    countryControl.setValue(control.value);
                },
                readonlyTemplate: 'country',
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_district',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.district,
                placeHolder: translation.forms.shared.district,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => districts$.pipe(map((districts) => districts.map((district) => ({
                    value: district.id,
                    text: district.name,
                })))),
                afterCreated: (control) => {
                    districtControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((districtCode) => districtCode !== districtControl.value && districtControl.setValue(districtCode)))
                        .subscribe();
                },
                readonlyTemplate: 'district',
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
    ];
    const rightIndividualFields = [
        {
            key: 'fullname',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.individual.name,
                placeHolder: translation.forms.individual.name,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'gender_id',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.individual.gender,
                placeHolder: translation.forms.individual.gender,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'gender',
                loadItemsAsync: () => genders$.pipe(map((genders) => genders.map((gender) => ({
                    value: gender.id,
                    text: gender.name,
                })))),
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'ic_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.individual.id_card_number,
                placeHolder: translation.forms.individual.id_card_number,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'tax_card_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                inputType: 'number',
                label: translation.forms.shared.tax_number,
                placeHolder: translation.forms.shared.tax_number,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'birth_place',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.individual.place_of_birth,
                placeHolder: translation.forms.individual.place_of_birth,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_address_2',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.address_line_2,
                placeHolder: translation.forms.shared.address_line_2,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_state_id',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.state_province,
                placeHolder: translation.forms.shared.state_province,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => provinces$.pipe(map((provinces) => provinces.map((province) => ({
                    value: province.id,
                    text: province.name,
                })))),
                afterCreated: (control) => {
                    provinceControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((provinceCode) => provinceCode !== provinceControl.value && provinceControl.setValue(provinceCode)))
                        .subscribe();
                },
                readonlyTemplate: 'province',
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_zip_code',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.postal_code,
                placeHolder: translation.forms.shared.postal_code,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                afterCreated: (control) => {
                    let controlValue = control.value;
                    areas$
                        .pipe(tap((areas) => {
                        const value = areas[0]?.zip_code;
                        control.setValue(value || controlValue || control.value);
                        if (value) {
                            controlValue = value;
                            control.disable();
                        }
                        else {
                            controlValue = control.value;
                            control.enable();
                        }
                    }))
                        .subscribe();
                },
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
    ];
    const rightCompanyFields = [
        {
            key: 'company_name',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.company.name,
                placeHolder: translation.forms.company.name,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_username',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                inputType: 'email',
                label: translation.forms.company.username,
                placeHolder: translation.forms.company.username,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required, Validators.email],
        },
        {
            key: 'company_registration_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                inputType: 'number',
                label: translation.forms.company.registration_number,
                placeHolder: translation.forms.company.registration_number,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_birth_date',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
            context: {
                label: translation.forms.company.establishment_date,
                placeHolder: 'DD/MM/YYYY',
                isRequired: true,
                fullWidth: true,
                closeOnSelected: true,
                readonlyTemplate: 'date',
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_address_2',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.address_line_2,
                placeHolder: translation.forms.shared.address_line_2,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_state_id',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.state_province,
                placeHolder: translation.forms.shared.state_province,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                afterCreated: (control) => {
                    provinceControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((provinceCode) => provinceCode !== provinceControl.value && provinceControl.setValue(provinceCode)))
                        .subscribe();
                },
                loadItemsAsync: () => provinces$.pipe(map((provinces) => provinces.map((province) => ({
                    value: province.id,
                    text: province.name,
                })))),
                readonlyTemplate: 'province',
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_zip_code',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.postal_code,
                placeHolder: translation.forms.shared.postal_code,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                afterCreated: (control) => {
                    let controlValue = control.value;
                    areas$
                        .pipe(tap((areas) => {
                        const value = areas[0]?.zip_code;
                        control.setValue(value || controlValue || control.value);
                        if (value) {
                            controlValue = value;
                            control.disable();
                        }
                        else {
                            controlValue = control.value;
                            control.enable();
                        }
                    }))
                        .subscribe();
                },
                customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
    ];
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'w-full flex gap-[16px]',
        readonlyWhen$: isReadonly$,
        renderBy: 'container',
        containers: [
            {
                customClasses: 'w-full flex gap-[16px] flex-col w-[calc(50%-8px)]',
                fields: [
                    {
                        key: 'member_entity_type_id',
                        type: FSWDynamicBuilderControlTypes.RADIO_GROUP,
                        customClasses: 'h-[69px] flex items-center',
                        context: {
                            label: translation.forms.shared.member_entity_type.id,
                            defaultValue: MemberTypeId.INDIVIDUAL,
                            direction: FSWCheckboxDirections.ROW,
                            gap: '12px',
                            items: [
                                {
                                    value: MemberTypeId.INDIVIDUAL,
                                    renderTemplate: {
                                        label: translation.forms.shared.member_entity_type.individual,
                                    },
                                },
                                {
                                    value: MemberTypeId.COMPANY,
                                    renderTemplate: {
                                        label: translation.forms.shared.member_entity_type.company,
                                    },
                                },
                            ],
                            fullWidth: true,
                            readonlyTemplate: (value) => {
                                if (value === MemberTypeId.INDIVIDUAL) {
                                    return translation.forms.shared.member_entity_type.individual;
                                }
                                else {
                                    return translation.forms.shared.member_entity_type.company;
                                }
                            },
                        },
                    },
                    ...leftIndividualFields,
                    ...leftCompanyFields,
                ],
            },
            {
                customClasses: 'w-full flex gap-[16px] flex-col w-[calc(50%-8px)]',
                fields: [...rightIndividualFields, ...rightCompanyFields],
            },
            {
                customClasses: 'hidden',
                fields: [
                    {
                        key: 'citizenship_city_id',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            isDisabled: true,
                            afterCreated: (control) => {
                                cities$
                                    .pipe(tap((cities) => {
                                    control.setValue(cities[0]?.id, { emitEvent: false });
                                    cityControl.setValue(cities[0]?.id);
                                }))
                                    .subscribe();
                            },
                            customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
                        },
                    },
                    {
                        key: 'company_city_id',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            isDisabled: true,
                            afterCreated: (control) => {
                                cities$
                                    .pipe(tap((cities) => {
                                    control.setValue(cities[0]?.id, { emitEvent: false });
                                    cityControl.setValue(cities[0]?.id);
                                }))
                                    .subscribe();
                            },
                            customRender: getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
                        },
                    },
                    {
                        key: 'member_entity_code',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            isDisabled: true,
                            afterCreated: (control, group) => {
                                group.valueChanges
                                    .pipe(startWith(group.value))
                                    .subscribe(({ member_entity_type_id }) => control.setValue(member_entity_type_id === MemberTypeId.INDIVIDUAL
                                    ? MemberEntityCode.RETAIL
                                    : MemberEntityCode.CORPORATE, { emitEvent: false }));
                            },
                        },
                    },
                ],
            },
        ],
        form,
    });
};
const getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH = (entityId) => [
    {
        fields: [
            {
                key: 'member_entity_type_id',
                correctWhenValueIs: (value) => value == entityId,
            },
        ],
        checkingConditionCallback: (params, condition) => {
            if (condition) {
                params.renderView();
            }
            else {
                params.clearView();
            }
        },
    },
];

const FSW_MAIN_BORROWER_TH_PROVIDERS = [
    {
        provide: FSW_MAIN_BORROWER_STORE_TOKEN,
        useClass: FSWMainBorrowerStoreTH,
        deps: [
            APPLICATION_MEMBER_SERVICE_TOKEN,
            MASTER_DATA_SERVICE_TOKEN,
            REFERENCE_SERVICE_TOKEN,
            MEMBER_SERVICE_TOKEN,
            FSW_ALERT_SERVICE_TOKEN,
            FSW_MAIN_BORROWER_FORM_TOKEN,
        ],
    },
    {
        provide: FSW_MAIN_BORROWER_FORM_TOKEN,
        useValue: FSWMainBorrowerFormTH,
        deps: [],
    },
];

const FSW_MAIN_BORROWER_PROVIDERS = {
    default: FSW_MAIN_BORROWER_TH_PROVIDERS,
    [CountryCode.TH]: FSW_MAIN_BORROWER_TH_PROVIDERS,
};
const mainBorrowerLoadProviders = (countryCode) => [
    fswTranslateScope('main-borrower'),
    ...getCustomProviders(FSW_MAIN_BORROWER_PROVIDERS, FSW_MAIN_BORROWER_TH_PROVIDERS, countryCode),
];

class FSWMainBorrowerTemplatePipe {
    constructor(componentStore) {
        this.componentStore = componentStore;
        this.latestValue = '';
    }
    transform(value, config, defaultNullValue = 'N/A') {
        const { stateKey, labelKey, compareKey } = config;
        this.componentStore
            .select((state) => state[stateKey])
            .pipe(map((data) => {
            const item = data.find((item) => item[compareKey] == value);
            this.latestValue = item ? `${item[labelKey]}` : defaultNullValue;
        }))
            .subscribe();
        return this.latestValue;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWMainBorrowerTemplatePipe, deps: [{ token: FSW_MAIN_BORROWER_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWMainBorrowerTemplatePipe, name: "fswMainBorrowerTemplate", pure: false }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWMainBorrowerTemplatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fswMainBorrowerTemplate',
                    pure: false,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_MAIN_BORROWER_STORE_TOKEN]
                }] }]; } });

class FSWMainBorrowerConfirmComponent {
    constructor(dialogRef) {
        this.dialogRef = dialogRef;
    }
    close(haveData = false) {
        this.dialogRef.close(haveData);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWMainBorrowerConfirmComponent, deps: [{ token: i1$7.DialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWMainBorrowerConfirmComponent, selector: "fsw-main-borrower-confirm", ngImport: i0, template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"dialogRef.config.data['yesButtonText'] | fswTranslate\"\n  [cancelButton]=\"dialogRef.config.data['noButtonText'] | fswTranslate\"\n  (confirmEvent)=\"close(true)\"\n  (cancelEvent)=\"close(false)\"\n  (closeEvent)=\"close(false)\"\n>\n  <ng-template fswModalBody>\n    <p\n      [innerHTML]=\"\n        dialogRef.config.data['description']\n          | fswTranslate : { data: dialogRef.config.data['descriptionParams'] }\n      \"\n    ></p>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWMainBorrowerConfirmComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-main-borrower-confirm', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"dialogRef.config.data['yesButtonText'] | fswTranslate\"\n  [cancelButton]=\"dialogRef.config.data['noButtonText'] | fswTranslate\"\n  (confirmEvent)=\"close(true)\"\n  (cancelEvent)=\"close(false)\"\n  (closeEvent)=\"close(false)\"\n>\n  <ng-template fswModalBody>\n    <p\n      [innerHTML]=\"\n        dialogRef.config.data['description']\n          | fswTranslate : { data: dialogRef.config.data['descriptionParams'] }\n      \"\n    ></p>\n  </ng-template>\n</fsw-modal>\n" }]
        }], ctorParameters: function () { return [{ type: i1$7.DialogRef }]; } });

class FSWMainBorrowerReplaceComponent {
    constructor(componentStore, dialogRef, _memberService, _alertService, _dialog, _injector) {
        this.componentStore = componentStore;
        this.dialogRef = dialogRef;
        this._memberService = _memberService;
        this._alertService = _alertService;
        this._dialog = _dialog;
        this._injector = _injector;
        this.builder = this.componentStore.createBuilder(true);
        this.type$ = new BehaviorSubject('replace');
        this.keySearch$ = new Subject();
        this.page$ = new BehaviorSubject(1);
        this.size$ = new BehaviorSubject(10);
        this.selected$ = new BehaviorSubject(null);
        this.searchControl = new UntypedFormControl('');
        this.searchedMembers$ = this.keySearch$.pipe(filter(() => this.type$.value === 'replace'), tap(() => {
            this.page$.next(1);
            this.size$.next(10);
            this.selected$.next(null);
        }), switchMap((search) => combineLatest([this.page$, this.size$]).pipe(switchMap(([page, size]) => this._memberService.searchMembers({
            country_code: getCountryCodeFromStorage(),
            member_type_code: 'BRW',
            attributes: [
                'company_name',
                'fullname',
                'uuid',
                'id',
                'member_entity_code',
                'member_entity_type_id',
                'username',
                'member_type_id',
            ],
            memberActivationStatusIds: [1],
            memberStatusIds: [1, 3],
            search,
            page,
            size,
        })))));
    }
    close(action) {
        this.dialogRef.close(action);
    }
    replace() {
        const valid = this._validateBeforeReplace();
        if (!valid) {
            this._alertService.warning('Invalid Information', this.type$.value === 'replace'
                ? 'Please select member to replace'
                : 'Please make sure all mandatory fields are filled', {
                duration: 3000,
            });
            return;
        }
        this._dialog
            .open(FSWMainBorrowerConfirmComponent, {
            data: {
                ...this.dialogRef.config.data,
                descriptionParams: {
                    ...this.dialogRef.config.data.descriptionParams,
                    name: this._getReplaceName(),
                },
            },
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((result) => {
            if (result) {
                this.close({
                    type: this.type$.value,
                    data: this.type$.value === 'replace'
                        ? this.selected$.value?.uuid
                        : this.builder.groupConfig.form.getRawValue(),
                });
            }
        }))
            .subscribe();
    }
    changeToAddType() {
        this.type$.next('add');
    }
    search() {
        this.type$.next('replace');
        this.keySearch$.next(this.searchControl.value);
    }
    _validateBeforeReplace() {
        if (this.type$.value === 'replace') {
            return !!this.selected$.value;
        }
        else {
            return this.builder.groupConfig.form.valid;
        }
    }
    _getReplaceName() {
        return this.type$.value === 'replace'
            ? this._getSelectedReplaceName()
            : this._getFilledReplaceName();
    }
    _getFilledReplaceName() {
        const value = this.builder.groupConfig.form.value;
        if (value) {
            return value.member_entity_code === MemberEntityCode.RETAIL
                ? value.fullname
                : value.company_name;
        }
        return '';
    }
    _getSelectedReplaceName() {
        const value = this.selected$.value;
        if (value) {
            return value.member_entity_code === MemberEntityCode.RETAIL
                ? value.fullname
                : value.company_name;
        }
        return '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWMainBorrowerReplaceComponent, deps: [{ token: FSW_MAIN_BORROWER_STORE_TOKEN }, { token: i1$7.DialogRef }, { token: MEMBER_SERVICE_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }, { token: i1$7.Dialog }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWMainBorrowerReplaceComponent, selector: "fsw-main-borrower-replace", ngImport: i0, template: "<fsw-modal\n  [size]=\"'l'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"dialogRef.config.data['confirmButtonText'] | fswTranslate\"\n  [cancelButton]=\"dialogRef.config.data['cancelButtonText'] | fswTranslate\"\n  [bodyCustomClasses]=\"'max-h-[calc(90vh-138px)] overflow-y-auto'\"\n  (confirmEvent)=\"replace()\"\n  (cancelEvent)=\"close()\"\n  (closeEvent)=\"close()\"\n>\n  <ng-template fswModalBody>\n    <section class=\"flex flex-col gap-[16px]\">\n      <header class=\"flex items-center gap-[8px]\">\n        <fsw-field [flexWidth]=\"true\">\n          <input\n            fswInput\n            [placeholder]=\"'modal.search' | fswTranslate\"\n            [formControl]=\"searchControl\"\n            (keyup.enter)=\"search()\"\n          />\n          <ng-template fswFieldInputSuffix>\n            <button fswButton [appearance]=\"'link'\" (click)=\"search()\">\n              <span>Search</span>\n              <i [fswIcon]=\"'common-search'\"></i>\n            </button>\n          </ng-template>\n        </fsw-field>\n        <button fswButton [appearance]=\"'secondary'\" (click)=\"changeToAddType()\">\n          {{ 'buttons.add_borrower' | fswTranslate }}\n        </button>\n      </header>\n      <main class=\"w-full overflow-x-auto\">\n        <ng-container [ngSwitch]=\"type$ | async\">\n          <ng-container *ngSwitchCase=\"'add'\">\n            <form [formGroup]=\"builder.groupConfig.form\">\n              <fsw-dynamic-builder [builder]=\"builder\">\n                <ng-template fswDynamicBuilderTemplate key=\"district\" let-value>\n                  {{\n                    value\n                      | fswMainBorrowerTemplate\n                        : { stateKey: 'districts', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"province\" let-value>\n                  {{\n                    value\n                      | fswMainBorrowerTemplate\n                        : { stateKey: 'provinces', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"industry\" let-value>\n                  {{\n                    value\n                      | fswMainBorrowerTemplate\n                        : { stateKey: 'industries', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"sub_industry\" let-value>\n                  {{\n                    value\n                      | fswMainBorrowerTemplate\n                        : { stateKey: 'subIndustries', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"gender\" let-value>\n                  {{\n                    value\n                      | fswMainBorrowerTemplate\n                        : { stateKey: 'genders', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"city\" let-value>\n                  {{\n                    value\n                      | fswMainBorrowerTemplate\n                        : { stateKey: 'cities', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"country\" let-value>\n                  {{\n                    value\n                      | fswMainBorrowerTemplate\n                        : { stateKey: 'countries', labelKey: 'name', compareKey: 'code' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"company_entity_id\" let-value>\n                  {{\n                    value\n                      | fswMainBorrowerTemplate\n                        : { stateKey: 'companyEntityTypes', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"basic\" let-value>\n                  {{ value ?? 'N/A' }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"date\" let-value>\n                  {{ value ? (value | date : 'dd/MM/yyyy') : 'N/A' }}\n                </ng-template>\n              </fsw-dynamic-builder>\n            </form>\n          </ng-container>\n          <ng-container *ngSwitchDefault>\n            <ng-container *ngIf=\"searchedMembers$ | async as searchedMembers\">\n              <table class=\"fsw-table w-full\">\n                <thead>\n                  <tr>\n                    <th>{{ 'table.full_name' | fswTranslate }}</th>\n                    <th>{{ 'table.entity_type' | fswTranslate }}</th>\n                    <th>{{ 'table.company_name' | fswTranslate }}</th>\n                    <th>{{ 'table.email_address' | fswTranslate }}</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <ng-container *ngFor=\"let member of searchedMembers.data || []\">\n                    <tr\n                      class=\"cursor-pointer\"\n                      [class.bg-green-200]=\"member.uuid === (selected$ | async)?.uuid\"\n                      (click)=\"selected$.next(member)\"\n                    >\n                      <td>{{ member.fullname }}</td>\n                      <td>{{ member.member_entity_code }}</td>\n                      <td>{{ member.company_name }}</td>\n                      <td>{{ member.username }}</td>\n                    </tr>\n                  </ng-container>\n                </tbody>\n                <tfoot *ngIf=\"searchedMembers.total\">\n                  <tr>\n                    <td [colSpan]=\"4\">\n                      <div class=\"flex justify-start\">\n                        <fsw-pagination\n                          [total]=\"searchedMembers.total\"\n                          [itemsPerPage]=\"size$.value\"\n                          [currentPage]=\"page$.value\"\n                          (itemsPerPageChange)=\"size$.next($event)\"\n                          (currentPageChange)=\"page$.next($event)\"\n                        ></fsw-pagination>\n                      </div>\n                    </td>\n                  </tr>\n                </tfoot>\n              </table>\n            </ng-container>\n          </ng-container>\n        </ng-container>\n      </main>\n    </section>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "directive", type: i1$4.FSWDynamicBuilderTemplateDirective, selector: "[fswDynamicBuilderTemplate]", inputs: ["key"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$4.FSWFieldInputSuffixDirective, selector: "ng-template[fswFieldInputSuffix]" }, { kind: "directive", type: i1$4.FSWInputDirective, selector: "input[fswInput], textarea[fswInput]" }, { kind: "component", type: i1$4.FSWPaginationComponent, selector: "fsw-pagination", inputs: ["total", "itemsPerPage", "currentPage", "itemsPerPageOptions", "showSelectOptions", "showViewTotalText", "showNavigationText", "totalTextInside"], outputs: ["currentPageChange", "itemsPerPageChange"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i1$1.DatePipe, name: "date" }, { kind: "pipe", type: FSWMainBorrowerTemplatePipe, name: "fswMainBorrowerTemplate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWMainBorrowerReplaceComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-main-borrower-replace', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal\n  [size]=\"'l'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"dialogRef.config.data['confirmButtonText'] | fswTranslate\"\n  [cancelButton]=\"dialogRef.config.data['cancelButtonText'] | fswTranslate\"\n  [bodyCustomClasses]=\"'max-h-[calc(90vh-138px)] overflow-y-auto'\"\n  (confirmEvent)=\"replace()\"\n  (cancelEvent)=\"close()\"\n  (closeEvent)=\"close()\"\n>\n  <ng-template fswModalBody>\n    <section class=\"flex flex-col gap-[16px]\">\n      <header class=\"flex items-center gap-[8px]\">\n        <fsw-field [flexWidth]=\"true\">\n          <input\n            fswInput\n            [placeholder]=\"'modal.search' | fswTranslate\"\n            [formControl]=\"searchControl\"\n            (keyup.enter)=\"search()\"\n          />\n          <ng-template fswFieldInputSuffix>\n            <button fswButton [appearance]=\"'link'\" (click)=\"search()\">\n              <span>Search</span>\n              <i [fswIcon]=\"'common-search'\"></i>\n            </button>\n          </ng-template>\n        </fsw-field>\n        <button fswButton [appearance]=\"'secondary'\" (click)=\"changeToAddType()\">\n          {{ 'buttons.add_borrower' | fswTranslate }}\n        </button>\n      </header>\n      <main class=\"w-full overflow-x-auto\">\n        <ng-container [ngSwitch]=\"type$ | async\">\n          <ng-container *ngSwitchCase=\"'add'\">\n            <form [formGroup]=\"builder.groupConfig.form\">\n              <fsw-dynamic-builder [builder]=\"builder\">\n                <ng-template fswDynamicBuilderTemplate key=\"district\" let-value>\n                  {{\n                    value\n                      | fswMainBorrowerTemplate\n                        : { stateKey: 'districts', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"province\" let-value>\n                  {{\n                    value\n                      | fswMainBorrowerTemplate\n                        : { stateKey: 'provinces', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"industry\" let-value>\n                  {{\n                    value\n                      | fswMainBorrowerTemplate\n                        : { stateKey: 'industries', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"sub_industry\" let-value>\n                  {{\n                    value\n                      | fswMainBorrowerTemplate\n                        : { stateKey: 'subIndustries', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"gender\" let-value>\n                  {{\n                    value\n                      | fswMainBorrowerTemplate\n                        : { stateKey: 'genders', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"city\" let-value>\n                  {{\n                    value\n                      | fswMainBorrowerTemplate\n                        : { stateKey: 'cities', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"country\" let-value>\n                  {{\n                    value\n                      | fswMainBorrowerTemplate\n                        : { stateKey: 'countries', labelKey: 'name', compareKey: 'code' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"company_entity_id\" let-value>\n                  {{\n                    value\n                      | fswMainBorrowerTemplate\n                        : { stateKey: 'companyEntityTypes', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"basic\" let-value>\n                  {{ value ?? 'N/A' }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"date\" let-value>\n                  {{ value ? (value | date : 'dd/MM/yyyy') : 'N/A' }}\n                </ng-template>\n              </fsw-dynamic-builder>\n            </form>\n          </ng-container>\n          <ng-container *ngSwitchDefault>\n            <ng-container *ngIf=\"searchedMembers$ | async as searchedMembers\">\n              <table class=\"fsw-table w-full\">\n                <thead>\n                  <tr>\n                    <th>{{ 'table.full_name' | fswTranslate }}</th>\n                    <th>{{ 'table.entity_type' | fswTranslate }}</th>\n                    <th>{{ 'table.company_name' | fswTranslate }}</th>\n                    <th>{{ 'table.email_address' | fswTranslate }}</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <ng-container *ngFor=\"let member of searchedMembers.data || []\">\n                    <tr\n                      class=\"cursor-pointer\"\n                      [class.bg-green-200]=\"member.uuid === (selected$ | async)?.uuid\"\n                      (click)=\"selected$.next(member)\"\n                    >\n                      <td>{{ member.fullname }}</td>\n                      <td>{{ member.member_entity_code }}</td>\n                      <td>{{ member.company_name }}</td>\n                      <td>{{ member.username }}</td>\n                    </tr>\n                  </ng-container>\n                </tbody>\n                <tfoot *ngIf=\"searchedMembers.total\">\n                  <tr>\n                    <td [colSpan]=\"4\">\n                      <div class=\"flex justify-start\">\n                        <fsw-pagination\n                          [total]=\"searchedMembers.total\"\n                          [itemsPerPage]=\"size$.value\"\n                          [currentPage]=\"page$.value\"\n                          (itemsPerPageChange)=\"size$.next($event)\"\n                          (currentPageChange)=\"page$.next($event)\"\n                        ></fsw-pagination>\n                      </div>\n                    </td>\n                  </tr>\n                </tfoot>\n              </table>\n            </ng-container>\n          </ng-container>\n        </ng-container>\n      </main>\n    </section>\n  </ng-template>\n</fsw-modal>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_MAIN_BORROWER_STORE_TOKEN]
                }] }, { type: i1$7.DialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: i1$7.Dialog }, { type: i0.Injector }]; } });

class FSWMainBorrowerComponent {
    set applicationId(applicationId) {
        this.componentStore.updateState({
            applicationId,
        });
    }
    set isReadonly(isReadonly) {
        this.componentStore.updateState({
            isReadonly,
        });
    }
    constructor(componentStore, _alertService, _dialog, _injector) {
        this.componentStore = componentStore;
        this._alertService = _alertService;
        this._dialog = _dialog;
        this._injector = _injector;
        this.builder = this.componentStore.builder;
        this.state$ = this.componentStore.state$;
    }
    ngOnInit() {
        this.componentStore.init();
    }
    submit() {
        if (this.builder.groupConfig.form.invalid) {
            this._alertService.warning('Invalid Information', 'Please make sure all mandatory fields are filled', {
                duration: 3000,
            });
            return;
        }
        this._dialog
            .open(FSWMainBorrowerConfirmComponent, {
            data: {
                title: 'modal.confirm_save.title',
                titleParams: {},
                description: 'modal.confirm_save.description',
                descriptionParams: {},
                yesButtonText: 'modal.confirm_save.yes',
                noButtonText: 'modal.confirm_save.no',
            },
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((result) => {
            if (result) {
                this.componentStore.save();
            }
        }))
            .subscribe();
    }
    cancel() {
        this._dialog
            .open(FSWMainBorrowerConfirmComponent, {
            data: {
                title: 'modal.confirm_cancel.title',
                titleParams: {},
                description: 'modal.confirm_cancel.description',
                descriptionParams: {},
                yesButtonText: 'modal.confirm_cancel.yes',
                noButtonText: 'modal.confirm_cancel.no',
            },
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((result) => {
            if (result) {
                this.componentStore.patchMemberToBuilder();
                this.componentStore.updateState({ isEditable: false });
            }
        }))
            .subscribe();
    }
    replace(type) {
        this._dialog
            .open(FSWMainBorrowerReplaceComponent, {
            data: {
                title: `modal.title`,
                titleParams: {},
                description: `modal.confirm_${type}.description`,
                descriptionParams: {},
                yesButtonText: `modal.confirm_${type}.yes`,
                noButtonText: `modal.confirm_${type}.no`,
                confirmButtonText: `buttons.${type}_borrower`,
                cancelButtonText: `buttons.cancel`,
            },
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((action) => {
            if (action) {
                this.componentStore.replace(action);
            }
            else {
                this.componentStore.patchMemberToBuilder();
            }
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWMainBorrowerComponent, deps: [{ token: FSW_MAIN_BORROWER_STORE_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }, { token: i1$7.Dialog }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWMainBorrowerComponent, selector: "fsw-main-borrower", inputs: { applicationId: "applicationId", isReadonly: "isReadonly" }, ngImport: i0, template: "<fsw-panel [title]=\"'title' | fswTranslate\" *ngIf=\"state$ | async as state\">\n  <ng-template fswPanelHeaderSuffix>\n    <nav class=\"flex items-center gap-[16px]\" *ngIf=\"!state.isEditable && state.member\">\n      <a\n        fswButton\n        [appearance]=\"'link'\"\n        [disabled]=\"state.isReadonly\"\n        (click)=\"!state.isReadonly && replace('replace')\"\n        >{{ 'buttons.replace' | fswTranslate }}</a\n      >\n      <a\n        fswButton\n        [appearance]=\"'link'\"\n        [disabled]=\"state.isReadonly\"\n        (click)=\"!state.isReadonly && componentStore.updateState({ isEditable: true })\"\n        >{{ 'buttons.edit' | fswTranslate }}</a\n      >\n    </nav>\n  </ng-template>\n  <section class=\"flex flex-col gap-[24px]\">\n    <ng-container *ngIf=\"state.member; else emptyMemberTemplate\">\n      <form [formGroup]=\"builder.groupConfig.form\">\n        <fsw-dynamic-builder [builder]=\"builder\">\n          <ng-template fswDynamicBuilderTemplate key=\"district\" let-value>\n            {{\n              value\n                | fswMainBorrowerTemplate\n                  : { stateKey: 'districts', labelKey: 'name', compareKey: 'id' }\n            }}\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"province\" let-value>\n            {{\n              value\n                | fswMainBorrowerTemplate\n                  : { stateKey: 'provinces', labelKey: 'name', compareKey: 'id' }\n            }}\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"industry\" let-value>\n            {{\n              value\n                | fswMainBorrowerTemplate\n                  : { stateKey: 'industries', labelKey: 'name', compareKey: 'id' }\n            }}\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"sub_industry\" let-value>\n            {{\n              value\n                | fswMainBorrowerTemplate\n                  : { stateKey: 'subIndustries', labelKey: 'name', compareKey: 'id' }\n            }}\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"gender\" let-value>\n            {{\n              value\n                | fswMainBorrowerTemplate\n                  : { stateKey: 'genders', labelKey: 'name', compareKey: 'id' }\n            }}\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"city\" let-value>\n            {{\n              value\n                | fswMainBorrowerTemplate\n                  : { stateKey: 'cities', labelKey: 'name', compareKey: 'id' }\n            }}\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"country\" let-value>\n            {{\n              value\n                | fswMainBorrowerTemplate\n                  : { stateKey: 'countries', labelKey: 'name', compareKey: 'code' }\n            }}\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"company_entity_id\" let-value>\n            {{\n              value\n                | fswMainBorrowerTemplate\n                  : { stateKey: 'companyEntityTypes', labelKey: 'name', compareKey: 'id' }\n            }}\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"basic\" let-value>\n            {{ value ?? 'N/A' }}\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"date\" let-value>\n            {{ value ? (value | date : 'dd/MM/yyyy') : 'N/A' }}\n          </ng-template>\n        </fsw-dynamic-builder>\n      </form>\n      <footer class=\"flex items-center justify-end gap-[16px]\" *ngIf=\"state.isEditable\">\n        <button fswButton [appearance]=\"'secondary'\" (click)=\"cancel()\">\n          {{ 'buttons.cancel' | fswTranslate }}\n        </button>\n        <button fswButton (click)=\"submit()\">{{ 'buttons.save_changes' | fswTranslate }}</button>\n      </footer>\n    </ng-container>\n    <ng-template #emptyMemberTemplate>\n      <button [disabled]=\"state.isReadonly\" fswButton (click)=\"!state.isReadonly && replace('add')\">\n        {{ 'buttons.add_borrower' | fswTranslate }}\n      </button>\n    </ng-template>\n  </section>\n</fsw-panel>\n", dependencies: [{ kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "directive", type: i1$4.FSWDynamicBuilderTemplateDirective, selector: "[fswDynamicBuilderTemplate]", inputs: ["key"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i1$1.DatePipe, name: "date" }, { kind: "pipe", type: FSWMainBorrowerTemplatePipe, name: "fswMainBorrowerTemplate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWMainBorrowerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-main-borrower', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-panel [title]=\"'title' | fswTranslate\" *ngIf=\"state$ | async as state\">\n  <ng-template fswPanelHeaderSuffix>\n    <nav class=\"flex items-center gap-[16px]\" *ngIf=\"!state.isEditable && state.member\">\n      <a\n        fswButton\n        [appearance]=\"'link'\"\n        [disabled]=\"state.isReadonly\"\n        (click)=\"!state.isReadonly && replace('replace')\"\n        >{{ 'buttons.replace' | fswTranslate }}</a\n      >\n      <a\n        fswButton\n        [appearance]=\"'link'\"\n        [disabled]=\"state.isReadonly\"\n        (click)=\"!state.isReadonly && componentStore.updateState({ isEditable: true })\"\n        >{{ 'buttons.edit' | fswTranslate }}</a\n      >\n    </nav>\n  </ng-template>\n  <section class=\"flex flex-col gap-[24px]\">\n    <ng-container *ngIf=\"state.member; else emptyMemberTemplate\">\n      <form [formGroup]=\"builder.groupConfig.form\">\n        <fsw-dynamic-builder [builder]=\"builder\">\n          <ng-template fswDynamicBuilderTemplate key=\"district\" let-value>\n            {{\n              value\n                | fswMainBorrowerTemplate\n                  : { stateKey: 'districts', labelKey: 'name', compareKey: 'id' }\n            }}\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"province\" let-value>\n            {{\n              value\n                | fswMainBorrowerTemplate\n                  : { stateKey: 'provinces', labelKey: 'name', compareKey: 'id' }\n            }}\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"industry\" let-value>\n            {{\n              value\n                | fswMainBorrowerTemplate\n                  : { stateKey: 'industries', labelKey: 'name', compareKey: 'id' }\n            }}\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"sub_industry\" let-value>\n            {{\n              value\n                | fswMainBorrowerTemplate\n                  : { stateKey: 'subIndustries', labelKey: 'name', compareKey: 'id' }\n            }}\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"gender\" let-value>\n            {{\n              value\n                | fswMainBorrowerTemplate\n                  : { stateKey: 'genders', labelKey: 'name', compareKey: 'id' }\n            }}\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"city\" let-value>\n            {{\n              value\n                | fswMainBorrowerTemplate\n                  : { stateKey: 'cities', labelKey: 'name', compareKey: 'id' }\n            }}\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"country\" let-value>\n            {{\n              value\n                | fswMainBorrowerTemplate\n                  : { stateKey: 'countries', labelKey: 'name', compareKey: 'code' }\n            }}\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"company_entity_id\" let-value>\n            {{\n              value\n                | fswMainBorrowerTemplate\n                  : { stateKey: 'companyEntityTypes', labelKey: 'name', compareKey: 'id' }\n            }}\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"basic\" let-value>\n            {{ value ?? 'N/A' }}\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"date\" let-value>\n            {{ value ? (value | date : 'dd/MM/yyyy') : 'N/A' }}\n          </ng-template>\n        </fsw-dynamic-builder>\n      </form>\n      <footer class=\"flex items-center justify-end gap-[16px]\" *ngIf=\"state.isEditable\">\n        <button fswButton [appearance]=\"'secondary'\" (click)=\"cancel()\">\n          {{ 'buttons.cancel' | fswTranslate }}\n        </button>\n        <button fswButton (click)=\"submit()\">{{ 'buttons.save_changes' | fswTranslate }}</button>\n      </footer>\n    </ng-container>\n    <ng-template #emptyMemberTemplate>\n      <button [disabled]=\"state.isReadonly\" fswButton (click)=\"!state.isReadonly && replace('add')\">\n        {{ 'buttons.add_borrower' | fswTranslate }}\n      </button>\n    </ng-template>\n  </section>\n</fsw-panel>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_MAIN_BORROWER_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: i1$7.Dialog }, { type: i0.Injector }]; }, propDecorators: { applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class FSwMainBorrowerDirective {
    constructor(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
        this.applicationId = null;
        this.isReadonly = false;
    }
    ngOnChanges() {
        this._viewContainerRef.clear();
        const ref = this._viewContainerRef.createComponent(FSWMainBorrowerComponent, {
            injector: Injector.create({
                parent: this._viewContainerRef.injector,
                providers: [...mainBorrowerLoadProviders(getCountryCodeFromStorage())],
            }),
        });
        const instance = ref.instance;
        instance.applicationId = this.applicationId;
        instance.isReadonly = this.isReadonly;
        ref.changeDetectorRef.detectChanges();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSwMainBorrowerDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSwMainBorrowerDirective, selector: "[fswMainBorrower]", inputs: { applicationId: "applicationId", isReadonly: "isReadonly" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSwMainBorrowerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswMainBorrower]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; }, propDecorators: { applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class FSWMainBorrowerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWMainBorrowerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWMainBorrowerModule, declarations: [FSWMainBorrowerComponent,
            FSwMainBorrowerDirective,
            FSWMainBorrowerTemplatePipe,
            FSWMainBorrowerConfirmComponent,
            FSWMainBorrowerReplaceComponent], imports: [i1$4.FSWTranslateModule, ApplicationMemberServiceModule,
            MemberServiceModule,
            MasterDataServiceModule,
            ReferenceServiceModule,
            FSWPanelModule,
            FSWDynamicBuilderModule,
            ReactiveFormsModule,
            FSWButtonModule,
            FSWModalModule$1,
            AsyncPipe,
            NgIf,
            DatePipe,
            NgSwitch,
            NgSwitchCase,
            NgSwitchDefault,
            NgForOf,
            FSWIconModule,
            FSWFieldModule,
            FSWInputModule,
            FSWPaginationModule$1], exports: [FSWMainBorrowerComponent,
            FSwMainBorrowerDirective,
            FSWMainBorrowerTemplatePipe,
            FSWMainBorrowerConfirmComponent,
            FSWMainBorrowerReplaceComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWMainBorrowerModule, imports: [FSWTranslateModule.forFeature({
                scope: 'main-borrower',
                defaultKey: CountryCode.TH,
                data: FSW_MAIN_BORROWER_TRANSLATION_LOADER,
            }),
            ApplicationMemberServiceModule,
            MemberServiceModule,
            MasterDataServiceModule,
            ReferenceServiceModule,
            FSWPanelModule,
            FSWDynamicBuilderModule,
            ReactiveFormsModule,
            FSWButtonModule,
            FSWModalModule$1,
            FSWIconModule,
            FSWFieldModule,
            FSWInputModule,
            FSWPaginationModule$1] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWMainBorrowerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FSWMainBorrowerComponent,
                        FSwMainBorrowerDirective,
                        FSWMainBorrowerTemplatePipe,
                        FSWMainBorrowerConfirmComponent,
                        FSWMainBorrowerReplaceComponent,
                    ],
                    exports: [
                        FSWMainBorrowerComponent,
                        FSwMainBorrowerDirective,
                        FSWMainBorrowerTemplatePipe,
                        FSWMainBorrowerConfirmComponent,
                        FSWMainBorrowerReplaceComponent,
                    ],
                    imports: [
                        FSWTranslateModule.forFeature({
                            scope: 'main-borrower',
                            defaultKey: CountryCode.TH,
                            data: FSW_MAIN_BORROWER_TRANSLATION_LOADER,
                        }),
                        ApplicationMemberServiceModule,
                        MemberServiceModule,
                        MasterDataServiceModule,
                        ReferenceServiceModule,
                        FSWPanelModule,
                        FSWDynamicBuilderModule,
                        ReactiveFormsModule,
                        FSWButtonModule,
                        FSWModalModule$1,
                        AsyncPipe,
                        NgIf,
                        DatePipe,
                        NgSwitch,
                        NgSwitchCase,
                        NgSwitchDefault,
                        NgForOf,
                        FSWIconModule,
                        FSWFieldModule,
                        FSWInputModule,
                        FSWPaginationModule$1,
                    ],
                }]
        }] });

class FSWBIPsEditComponent {
    constructor(componentStore, dialogRef, _alertService, _dialog, _injector) {
        this.componentStore = componentStore;
        this.dialogRef = dialogRef;
        this._alertService = _alertService;
        this._dialog = _dialog;
        this._injector = _injector;
        this.isReadonly$ = new BehaviorSubject(this.componentStore.state().isReadonly);
        this.builder = this.componentStore.createBuilder(this.isReadonly$.asObservable());
        this.formGroup = this.componentStore.formGroup;
    }
    ngOnInit() {
        this.componentStore.patchMemberToBuilder(this.dialogRef.config.data.row.expand);
    }
    close(haveData = false) {
        this.dialogRef.close(haveData);
    }
    submit() {
        this._dialog
            .open(FSWMainBorrowerConfirmComponent, {
            data: {
                title: 'modal.confirm_save.title',
                titleParams: {},
                description: 'modal.confirm_save.description',
                descriptionParams: {},
                yesButtonText: 'modal.confirm_save.yes',
                noButtonText: 'modal.confirm_save.no',
            },
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((result) => {
            if (result) {
                this.componentStore.save(this.dialogRef.config.data.row.reference_id);
                this.close(false);
            }
        }))
            .subscribe();
    }
    delete() {
        this.dialogRef.config.data.delete(() => {
            this.close(true);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsEditComponent, deps: [{ token: FSW_BIPS_STORE_TOKEN }, { token: i1$7.DialogRef }, { token: FSW_ALERT_SERVICE_TOKEN }, { token: i1$7.Dialog }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWBIPsEditComponent, selector: "fsw-bips-edit", ngImport: i0, template: "<fsw-modal\n  [size]=\"'l'\"\n  [title]=\"((isReadonly$ | async) ? 'modal.titles.view' : 'modal.titles.edit') | fswTranslate\"\n  [bodyCustomClasses]=\"'max-h-[calc(90vh-138px)] overflow-y-auto'\"\n  [hiddenFooter]=\"componentStore.state().isReadonly\"\n  (closeEvent)=\"close(false)\"\n>\n  <ng-template fswModalBody>\n    <form [formGroup]=\"formGroup\">\n      <fsw-dynamic-builder [builder]=\"builder\">\n        <ng-template fswDynamicBuilderTemplate key=\"district\" let-value>\n          {{\n            value | fswBIPsTemplate : { stateKey: 'districts', labelKey: 'name', compareKey: 'id' }\n          }}\n        </ng-template>\n        <ng-template fswDynamicBuilderTemplate key=\"province\" let-value>\n          {{\n            value | fswBIPsTemplate : { stateKey: 'provinces', labelKey: 'name', compareKey: 'id' }\n          }}\n        </ng-template>\n        <ng-template fswDynamicBuilderTemplate key=\"industry\" let-value>\n          {{\n            value | fswBIPsTemplate : { stateKey: 'industries', labelKey: 'name', compareKey: 'id' }\n          }}\n        </ng-template>\n        <ng-template fswDynamicBuilderTemplate key=\"sub_industry\" let-value>\n          {{\n            value\n              | fswBIPsTemplate : { stateKey: 'subIndustries', labelKey: 'name', compareKey: 'id' }\n          }}\n        </ng-template>\n        <ng-template fswDynamicBuilderTemplate key=\"gender\" let-value>\n          {{\n            value | fswBIPsTemplate : { stateKey: 'genders', labelKey: 'name', compareKey: 'id' }\n          }}\n        </ng-template>\n        <ng-template fswDynamicBuilderTemplate key=\"city\" let-value>\n          {{ value | fswBIPsTemplate : { stateKey: 'cities', labelKey: 'name', compareKey: 'id' } }}\n        </ng-template>\n        <ng-template fswDynamicBuilderTemplate key=\"country\" let-value>\n          {{\n            value\n              | fswBIPsTemplate : { stateKey: 'countries', labelKey: 'name', compareKey: 'code' }\n          }}\n        </ng-template>\n\n        <ng-template fswDynamicBuilderTemplate key=\"area\" let-value>\n          {{ value | fswBIPsTemplate : { stateKey: 'areas', labelKey: 'name', compareKey: 'id' } }}\n        </ng-template>\n        <ng-template fswDynamicBuilderTemplate key=\"company_entity_id\" let-value>\n          {{\n            value\n              | fswBIPsTemplate\n                : { stateKey: 'companyEntityTypes', labelKey: 'name', compareKey: 'id' }\n          }}\n        </ng-template>\n        <ng-template fswDynamicBuilderTemplate key=\"basic\" let-value>\n          {{ value ?? 'N/A' }}\n        </ng-template>\n        <ng-template fswDynamicBuilderTemplate key=\"date\" let-value>\n          {{ value ? (value | date : 'dd/MM/yyyy') : 'N/A' }}\n        </ng-template>\n      </fsw-dynamic-builder>\n    </form>\n  </ng-template>\n  <ng-template fswModalFooter>\n    <section class=\"flex justify-between w-full items-center\">\n      <aside>\n        <button fswButton class=\"!text-red-500\" [appearance]=\"'secondary'\" (click)=\"delete()\">\n          {{ 'buttons.delete_bip' | fswTranslate }}\n        </button>\n      </aside>\n      <main class=\"flex gap-[16px] items-center\">\n        <button fswButton [appearance]=\"'secondary'\" (click)=\"close()\">\n          {{ 'buttons.cancel' | fswTranslate }}\n        </button>\n        <button\n          (click)=\"isReadonly$.next(false)\"\n          fswButton\n          *ngIf=\"isReadonly$ | async; else saveChangesTemplate\"\n        >\n          {{ 'buttons.edit_bip' | fswTranslate }}\n        </button>\n        <ng-template #saveChangesTemplate>\n          <button fswButton (click)=\"submit()\">{{ 'buttons.save_changes' | fswTranslate }}</button>\n        </ng-template>\n      </main>\n    </section>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "directive", type: i1$4.FSWDynamicBuilderTemplateDirective, selector: "[fswDynamicBuilderTemplate]", inputs: ["key"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "directive", type: i1$4.FSWModalFooterDirective, selector: "ng-template[fswModalFooter]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i1$1.DatePipe, name: "date" }, { kind: "pipe", type: FSWBIPsTemplatePipe, name: "fswBIPsTemplate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsEditComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-bips-edit', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal\n  [size]=\"'l'\"\n  [title]=\"((isReadonly$ | async) ? 'modal.titles.view' : 'modal.titles.edit') | fswTranslate\"\n  [bodyCustomClasses]=\"'max-h-[calc(90vh-138px)] overflow-y-auto'\"\n  [hiddenFooter]=\"componentStore.state().isReadonly\"\n  (closeEvent)=\"close(false)\"\n>\n  <ng-template fswModalBody>\n    <form [formGroup]=\"formGroup\">\n      <fsw-dynamic-builder [builder]=\"builder\">\n        <ng-template fswDynamicBuilderTemplate key=\"district\" let-value>\n          {{\n            value | fswBIPsTemplate : { stateKey: 'districts', labelKey: 'name', compareKey: 'id' }\n          }}\n        </ng-template>\n        <ng-template fswDynamicBuilderTemplate key=\"province\" let-value>\n          {{\n            value | fswBIPsTemplate : { stateKey: 'provinces', labelKey: 'name', compareKey: 'id' }\n          }}\n        </ng-template>\n        <ng-template fswDynamicBuilderTemplate key=\"industry\" let-value>\n          {{\n            value | fswBIPsTemplate : { stateKey: 'industries', labelKey: 'name', compareKey: 'id' }\n          }}\n        </ng-template>\n        <ng-template fswDynamicBuilderTemplate key=\"sub_industry\" let-value>\n          {{\n            value\n              | fswBIPsTemplate : { stateKey: 'subIndustries', labelKey: 'name', compareKey: 'id' }\n          }}\n        </ng-template>\n        <ng-template fswDynamicBuilderTemplate key=\"gender\" let-value>\n          {{\n            value | fswBIPsTemplate : { stateKey: 'genders', labelKey: 'name', compareKey: 'id' }\n          }}\n        </ng-template>\n        <ng-template fswDynamicBuilderTemplate key=\"city\" let-value>\n          {{ value | fswBIPsTemplate : { stateKey: 'cities', labelKey: 'name', compareKey: 'id' } }}\n        </ng-template>\n        <ng-template fswDynamicBuilderTemplate key=\"country\" let-value>\n          {{\n            value\n              | fswBIPsTemplate : { stateKey: 'countries', labelKey: 'name', compareKey: 'code' }\n          }}\n        </ng-template>\n\n        <ng-template fswDynamicBuilderTemplate key=\"area\" let-value>\n          {{ value | fswBIPsTemplate : { stateKey: 'areas', labelKey: 'name', compareKey: 'id' } }}\n        </ng-template>\n        <ng-template fswDynamicBuilderTemplate key=\"company_entity_id\" let-value>\n          {{\n            value\n              | fswBIPsTemplate\n                : { stateKey: 'companyEntityTypes', labelKey: 'name', compareKey: 'id' }\n          }}\n        </ng-template>\n        <ng-template fswDynamicBuilderTemplate key=\"basic\" let-value>\n          {{ value ?? 'N/A' }}\n        </ng-template>\n        <ng-template fswDynamicBuilderTemplate key=\"date\" let-value>\n          {{ value ? (value | date : 'dd/MM/yyyy') : 'N/A' }}\n        </ng-template>\n      </fsw-dynamic-builder>\n    </form>\n  </ng-template>\n  <ng-template fswModalFooter>\n    <section class=\"flex justify-between w-full items-center\">\n      <aside>\n        <button fswButton class=\"!text-red-500\" [appearance]=\"'secondary'\" (click)=\"delete()\">\n          {{ 'buttons.delete_bip' | fswTranslate }}\n        </button>\n      </aside>\n      <main class=\"flex gap-[16px] items-center\">\n        <button fswButton [appearance]=\"'secondary'\" (click)=\"close()\">\n          {{ 'buttons.cancel' | fswTranslate }}\n        </button>\n        <button\n          (click)=\"isReadonly$.next(false)\"\n          fswButton\n          *ngIf=\"isReadonly$ | async; else saveChangesTemplate\"\n        >\n          {{ 'buttons.edit_bip' | fswTranslate }}\n        </button>\n        <ng-template #saveChangesTemplate>\n          <button fswButton (click)=\"submit()\">{{ 'buttons.save_changes' | fswTranslate }}</button>\n        </ng-template>\n      </main>\n    </section>\n  </ng-template>\n</fsw-modal>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_BIPS_STORE_TOKEN]
                }] }, { type: i1$7.DialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: i1$7.Dialog }, { type: i0.Injector }]; } });

class FSWBIPsPefindoComponent {
    constructor(dialogRef, _translateService, _alertService, _extensionService, _memberService, _applicationMemberBIPService) {
        this.dialogRef = dialogRef;
        this._translateService = _translateService;
        this._alertService = _alertService;
        this._extensionService = _extensionService;
        this._memberService = _memberService;
        this._applicationMemberBIPService = _applicationMemberBIPService;
        this.formGroup = new UntypedFormGroup({});
        this.selected$ = new BehaviorSubject(null);
        this.searching$ = new BehaviorSubject(false);
        this.invalid$ = this.searching$.pipe(switchMap$1((searching) => searching
            ? this.selected$.pipe(map((selected) => !selected))
            : this.formGroup.statusChanges.pipe(startWith(this.formGroup.status), map((status) => status === 'INVALID'))));
        this.rows$ = this.searching$.pipe(filter$1((searching) => searching), switchMap$1(() => this._extensionService.searchPefindo(this.formGroup.getRawValue())));
        this.columns = {};
        const { fullname, ic_number, birth_date, company_name, tax_card_number } = this.dialogRef.config
            .data.expand;
        const isIndividual = this.isIndividual();
        this.builder = new FSWDynamicBuilder({
            formType: FSWDynamicBuilderFormTypes.GROUP,
            form: this.formGroup,
            customClasses: 'flex flex-col gap-[12px]',
            fields: [
                {
                    key: 'entityName',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    context: {
                        fullWidth: true,
                        isRequired: true,
                        label: this._translateService.select(`forms.${isIndividual ? 'individual' : 'company'}.name`, 'bips'),
                    },
                    validations: [Validators.required],
                },
                {
                    key: 'entityNo',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    context: {
                        fullWidth: true,
                        isRequired: true,
                        label: this._translateService.select(`forms.${isIndividual ? 'individual.id_number' : 'company.tax_number'}`, 'bips'),
                    },
                    validations: [Validators.required],
                },
                ...(isIndividual
                    ? [
                        {
                            key: 'dateOfBirth',
                            type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                            context: {
                                fullWidth: true,
                                isRequired: true,
                                label: this._translateService.select('forms.individual.date_of_birth', 'bips'),
                                closeOnSelected: true,
                            },
                            validations: [Validators.required],
                        },
                    ]
                    : []),
                {
                    key: 'entityNoType',
                    type: FSWDynamicBuilderControlTypes.TEMPLATE,
                    context: {
                        isHidden: true,
                    },
                },
            ],
        });
        this.formGroup.patchValue({
            entityName: isIndividual ? fullname : company_name,
            entityNo: isIndividual ? ic_number : tax_card_number,
            dateOfBirth: birth_date,
            entityNoType: isIndividual ? 'KTP' : 'NPWP',
        });
        this.setColumns();
    }
    close(haveData = false) {
        this.dialogRef.close(haveData);
    }
    search() {
        if (this.formGroup.invalid) {
            this._alertService.error('Search Error', 'The Search form is invalid', {
                duration: 5000,
            });
            return;
        }
        this.searching$.next(true);
    }
    submit() {
        if (!this.selected$.value) {
            this._alertService.error('Search Error', 'Need to select one Pefindo to process', {
                duration: 5000,
            });
        }
        this._extensionService
            .pullPefindo({
            pefindoId: this.selected$.value,
            isIndividual: this.isIndividual(),
            reportDate: new Date().toISOString(),
        })
            .pipe(switchMap$1(() => {
            this._alertService.success('Pefindo Report Pulled', 'Pefindo Report Pulled Successfully', {
                duration: 5000,
            });
            const { reference_id, reference_to, expand } = this.dialogRef.config
                .data;
            return reference_to === 'MEMBER'
                ? this._memberService.updateMember(reference_id, {
                    pefindo_id: this.selected$.value,
                })
                : this._applicationMemberBIPService.updateMemberBip(reference_id, {
                    ...omit(expand, ['id', 'uuid']),
                    pefindo_id: this.selected$.value,
                });
        }), tap(() => this.close(true)), catchError((error) => {
            this._alertService.error('Pefindo Report Pull Error', 'Failed to pull pefindo', {
                duration: 5000,
            });
            return throwError(() => error);
        }))
            .subscribe();
    }
    confirm() {
        if (!this.searching$.value) {
            this.search();
        }
        else {
            this.submit();
        }
    }
    cancel() {
        if (!this.searching$.value) {
            this.close();
        }
        else {
            this.searching$.next(false);
        }
    }
    isIndividual() {
        const { member_entity_type_id, ic_number } = this.dialogRef.config.data
            .expand;
        if (member_entity_type_id) {
            return member_entity_type_id.toString() === MemberTypeId.INDIVIDUAL;
        }
        return !!ic_number;
    }
    setColumns() {
        const isIndividual = this.isIndividual();
        if (isIndividual) {
            this.columns = {
                no: '',
                name: 'table.name',
                entityNo: 'table.id_number',
                dateOfBirth: 'table.date_of_birth',
                address: 'table.address',
                pefindoId: 'table.pefindo_id',
            };
        }
        else {
            this.columns = {
                no: '',
                name: 'table.name',
                entityNo: 'table.tax_number',
                address: 'table.address',
                pefindoId: 'table.pefindo_id',
            };
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsPefindoComponent, deps: [{ token: i1$7.DialogRef }, { token: FSW_TRANSLATE_SERVICE_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }, { token: EXTENSION_SERVICE_TOKEN }, { token: MEMBER_SERVICE_TOKEN }, { token: APPLICATION_MEMBER_BIP_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWBIPsPefindoComponent, selector: "fsw-bips-pefindo", ngImport: i0, template: "<fsw-modal\n  [size]=\"!!(searching$ | async) ? 'l' : 's'\"\n  [title]=\"'modal.titles.pefindo' | fswTranslate\"\n  [confirmButton]=\"(!!(searching$ | async) ? 'buttons.pull' : 'buttons.search') | fswTranslate\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate\"\n  (confirmEvent)=\"confirm()\"\n  (cancelEvent)=\"cancel()\"\n  (closeEvent)=\"close(false)\"\n  [confirmButtonDisabled]=\"!!(invalid$ | async)\"\n>\n  <ng-template fswModalBody>\n    <ng-container *ngIf=\"!!(searching$ | async); else searchForm\">\n      <ng-container *ngIf=\"rows$ | async as rows\">\n        <fsw-bips-grid [columns]=\"columns\" [rows]=\"$any(rows)\" [itemsPerPage]=\"rows.length\">\n          <ng-template fswBIPsGridItem let-row>\n            <td>\n              <fsw-radio\n                (click)=\"selected$.next(row['pefindoId'])\"\n                [name]=\"'fsw-bips-pefindo-radio'\"\n                [id]=\"row['pefindoId']\"\n                [value]=\"row['pefindoId']\"\n                [groupValue]=\"selected$ | async\"\n              ></fsw-radio>\n            </td>\n            <td>{{ row['name'] }}</td>\n            <td>{{ row['entityNo'] }}</td>\n            <td *ngIf=\"isIndividual()\">{{ row['dateOfBirth'] | date : 'dd/MM/yyyy' }}</td>\n            <td>{{ row['address'] }}</td>\n            <td>{{ row['pefindoId'] }}</td>\n          </ng-template>\n        </fsw-bips-grid>\n      </ng-container>\n    </ng-container>\n    <ng-template #searchForm>\n      <form [formGroup]=\"formGroup\">\n        <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n      </form>\n    </ng-template>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$4.FSWRadioComponent, selector: "fsw-radio" }, { kind: "component", type: FSWBIPsGridComponent, selector: "fsw-bips-grid", inputs: ["columns", "rows", "emptyMessage", "itemsPerPage", "currentPage"], outputs: ["rowClick", "currentPageChange", "itemsPerPageChange"] }, { kind: "directive", type: FSWBIPsGridItemDirective, selector: "ng-template[fswBIPsGridItem]" }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i1$1.DatePipe, name: "date" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsPefindoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-bips-pefindo', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal\n  [size]=\"!!(searching$ | async) ? 'l' : 's'\"\n  [title]=\"'modal.titles.pefindo' | fswTranslate\"\n  [confirmButton]=\"(!!(searching$ | async) ? 'buttons.pull' : 'buttons.search') | fswTranslate\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate\"\n  (confirmEvent)=\"confirm()\"\n  (cancelEvent)=\"cancel()\"\n  (closeEvent)=\"close(false)\"\n  [confirmButtonDisabled]=\"!!(invalid$ | async)\"\n>\n  <ng-template fswModalBody>\n    <ng-container *ngIf=\"!!(searching$ | async); else searchForm\">\n      <ng-container *ngIf=\"rows$ | async as rows\">\n        <fsw-bips-grid [columns]=\"columns\" [rows]=\"$any(rows)\" [itemsPerPage]=\"rows.length\">\n          <ng-template fswBIPsGridItem let-row>\n            <td>\n              <fsw-radio\n                (click)=\"selected$.next(row['pefindoId'])\"\n                [name]=\"'fsw-bips-pefindo-radio'\"\n                [id]=\"row['pefindoId']\"\n                [value]=\"row['pefindoId']\"\n                [groupValue]=\"selected$ | async\"\n              ></fsw-radio>\n            </td>\n            <td>{{ row['name'] }}</td>\n            <td>{{ row['entityNo'] }}</td>\n            <td *ngIf=\"isIndividual()\">{{ row['dateOfBirth'] | date : 'dd/MM/yyyy' }}</td>\n            <td>{{ row['address'] }}</td>\n            <td>{{ row['pefindoId'] }}</td>\n          </ng-template>\n        </fsw-bips-grid>\n      </ng-container>\n    </ng-container>\n    <ng-template #searchForm>\n      <form [formGroup]=\"formGroup\">\n        <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n      </form>\n    </ng-template>\n  </ng-template>\n</fsw-modal>\n" }]
        }], ctorParameters: function () { return [{ type: i1$7.DialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_TRANSLATE_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [EXTENSION_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_BIP_SERVICE_TOKEN]
                }] }]; } });

class FSWBIPsComponent {
    set applicationId(applicationId) {
        this.componentStore.updateState({
            applicationId,
        });
    }
    set isReadonly(isReadonly) {
        this.componentStore.updateState({
            isReadonly,
        });
    }
    constructor(componentStore, _alertService, _extensionService, _helper, _dialog, _injector) {
        this.componentStore = componentStore;
        this._alertService = _alertService;
        this._extensionService = _extensionService;
        this._helper = _helper;
        this._dialog = _dialog;
        this._injector = _injector;
        this.state$ = this.componentStore.state$;
        this.columns = this.getColumns().reduce((acc, key) => ({
            ...acc,
            [key]: `table.${key}`,
        }), {});
        this.MemberTypeId = MemberTypeId;
        this.MemberEntityCode = MemberEntityCode;
    }
    ngOnInit() {
        this.componentStore.init();
    }
    pullPefindo(row) {
        if (this.componentStore.state().isReadonly) {
            this._alertService.warning('Readonly Warning', 'The current step is readonly state, you can not pull', {
                duration: 3000,
            });
            return;
        }
        this._dialog
            .open(FSWBIPsPefindoComponent, {
            data: row,
            injector: this._injector,
        })
            .closed.pipe(take(1), filter((result) => !!result), tap(() => this.componentStore.reloadTable()));
    }
    viewPefindo(row) {
        this._extensionService
            .historyPefindo(row.expand['pefindo_id'])
            .pipe(tap((histories) => {
            if (!histories.length) {
                this._alertService.warning('Warning', 'Pefindo report not existed', {
                    duration: 2000,
                });
            }
        }), filter((histories) => !!histories.length), map((histories) => histories.sort((a, b) => b.id - a.id).shift()), catchError(() => {
            this._alertService.error('Error', 'Failed to get pefindo history', {
                duration: 2000,
            });
            return EMPTY;
        }))
            .subscribe();
    }
    add() {
        this._dialog
            .open(FSWBIPsAddComponent, {
            data: {
                title: `modal.titles.add`,
                titleParams: {},
                description: `modal.confirm_add.description`,
                descriptionParams: {},
                yesButtonText: `modal.confirm_add.yes`,
                noButtonText: `modal.confirm_add.no`,
                confirmButtonText: `buttons.add_bip`,
                cancelButtonText: `buttons.cancel`,
            },
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((action) => {
            if (action) {
                if (action.type === 'link') {
                    this.componentStore.link(action.data);
                }
                else {
                    this.componentStore.save();
                }
            }
        }))
            .subscribe();
    }
    rowClicked(row) {
        if (row.reference_to === 'MEMBER') {
            this._alertService.warning('Warning', "Can't edit bip that is a member", {
                duration: 3000,
            });
            return;
        }
        this._dialog
            .open(FSWBIPsEditComponent, {
            data: {
                row,
                delete: (cb) => this.delete(row, cb),
            },
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((result) => {
            if (result) {
                this.componentStore.reloadTable();
            }
        }))
            .subscribe();
    }
    delete(row, cb) {
        this._dialog
            .open(FSWBIPsConfirmComponent, {
            data: {
                title: 'modal.confirm_remove.title',
                titleParams: {},
                description: 'modal.confirm_remove.description',
                descriptionParams: {},
                yesButtonText: 'modal.confirm_remove.yes',
                noButtonText: 'modal.confirm_remove.no',
            },
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((result) => {
            if (result) {
                this.componentStore.remove(row);
                cb && cb();
            }
        }))
            .subscribe();
    }
    getFormattedDate(value) {
        if (value) {
            const diff = Date.now() - new Date(value).getTime();
            const date = new Date(value).toDateString();
            const ageDate = new Date(diff);
            const age = Math.abs(ageDate.getFullYear() - 1970);
            return `${date} (${age})`;
        }
        return '';
    }
    getColumns() {
        return [
            'name',
            'designation',
            'ownership',
            'date_of_birth',
            'recourse_type',
            ...this._helper.getExtraColumns(),
            'action',
        ];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsComponent, deps: [{ token: FSW_BIPS_STORE_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }, { token: EXTENSION_SERVICE_TOKEN }, { token: FSW_BIPS_HELPER_TOKEN }, { token: i1$7.Dialog }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWBIPsComponent, selector: "fsw-bips", inputs: { applicationId: "applicationId", isReadonly: "isReadonly" }, ngImport: i0, template: "<fsw-panel\n  [title]=\"'title' | fswTranslate\"\n  *ngIf=\"state$ | async as state\"\n  [headerClasses]=\"'flex-col gap-[8px] !items-start'\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <nav class=\"flex items-center justify-between gap-[16px]\">\n      <p class=\"flex-1\">{{ 'description' | fswTranslate }}</p>\n      <a *ngIf=\"!state.isReadonly\" fswButton [appearance]=\"'secondary'\" (click)=\"add()\">{{\n        'buttons.add_bip' | fswTranslate\n      }}</a>\n    </nav>\n  </ng-template>\n  <section class=\"w-full overflow-auto\">\n    <fsw-bips-grid\n      [columns]=\"columns\"\n      [rows]=\"$any(state.bips)\"\n      [itemsPerPage]=\"state.limit\"\n      [currentPage]=\"state.page\"\n      (itemsPerPageChange)=\"componentStore.updateState({ limit: $event })\"\n      (currentPageChange)=\"componentStore.updateState({ page: $event })\"\n    >\n      <ng-template fswBIPsGridItem let-row>\n        <td (click)=\"rowClicked(row)\" class=\"hover:bg-green-100 hover:cursor-pointer\">\n          {{\n            row.expand['member_entity_type_id']?.toString() === MemberTypeId.INDIVIDUAL ||\n            row.expand['member_entity_code'] === MemberEntityCode.RETAIL ||\n            row.expand['recourse_type'] === 'Individual'\n              ? row.expand['fullname']\n              : row.expand['company_name'] || row.expand['fullname']\n          }}\n        </td>\n        <td>{{ row.expand['designation'] }}</td>\n        <td>{{ row.expand['ownership'] }}</td>\n        <td>\n          {{\n            getFormattedDate(\n              row.expand['member_entity_type_id']?.toString() === MemberTypeId.INDIVIDUAL\n                ? row.expand['birth_date']\n                : row.expand['company_birth_date'] || row.expand['birth_date']\n            )\n          }}\n        </td>\n        <td>{{ row.expand['recourse_type'] }}</td>\n        <ng-container *fswMeetCountry=\"'MY'\">\n          <td>{{ row.expand['ic_number'] }}</td>\n          <td>{{ row.expand['recourse_identifier'] }}</td>\n        </ng-container>\n        <ng-container *fswMeetCountry=\"'ID'\">\n          <td>\n            <button\n              fswButton\n              appearance=\"link\"\n              [disabled]=\"state.isReadonly\"\n              (click)=\"row.expand['pefindo_id'] ? viewPefindo(row) : pullPefindo(row)\"\n            >\n              <i\n                [fswIcon]=\"\n                  row.expand['pefindo_id']\n                    ? 'common-password-show-alternative'\n                    : 'common-external-link'\n                \"\n              ></i>\n              <span>{{\n                (row.expand['pefindo_id'] ? 'buttons.view' : 'buttons.pull') | fswTranslate\n              }}</span>\n            </button>\n          </td>\n        </ng-container>\n        <td>\n          <i\n            *ngIf=\"!state.isReadonly\"\n            (click)=\"delete(row)\"\n            [fswIcon]=\"'common-delete-alternative'\"\n            class=\"text-blue-500 hover:text-red-500 hover:cursor-pointer\"\n          ></i>\n        </td>\n      </ng-template>\n    </fsw-bips-grid>\n  </section>\n</fsw-panel>\n", dependencies: [{ kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "directive", type: FSWMeetCountryDirective, selector: "[fswMeetCountry]", inputs: ["fswMeetCountry"], exportAs: ["meetCountry"] }, { kind: "component", type: FSWBIPsGridComponent, selector: "fsw-bips-grid", inputs: ["columns", "rows", "emptyMessage", "itemsPerPage", "currentPage"], outputs: ["rowClick", "currentPageChange", "itemsPerPageChange"] }, { kind: "directive", type: FSWBIPsGridItemDirective, selector: "ng-template[fswBIPsGridItem]" }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-bips', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-panel\n  [title]=\"'title' | fswTranslate\"\n  *ngIf=\"state$ | async as state\"\n  [headerClasses]=\"'flex-col gap-[8px] !items-start'\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <nav class=\"flex items-center justify-between gap-[16px]\">\n      <p class=\"flex-1\">{{ 'description' | fswTranslate }}</p>\n      <a *ngIf=\"!state.isReadonly\" fswButton [appearance]=\"'secondary'\" (click)=\"add()\">{{\n        'buttons.add_bip' | fswTranslate\n      }}</a>\n    </nav>\n  </ng-template>\n  <section class=\"w-full overflow-auto\">\n    <fsw-bips-grid\n      [columns]=\"columns\"\n      [rows]=\"$any(state.bips)\"\n      [itemsPerPage]=\"state.limit\"\n      [currentPage]=\"state.page\"\n      (itemsPerPageChange)=\"componentStore.updateState({ limit: $event })\"\n      (currentPageChange)=\"componentStore.updateState({ page: $event })\"\n    >\n      <ng-template fswBIPsGridItem let-row>\n        <td (click)=\"rowClicked(row)\" class=\"hover:bg-green-100 hover:cursor-pointer\">\n          {{\n            row.expand['member_entity_type_id']?.toString() === MemberTypeId.INDIVIDUAL ||\n            row.expand['member_entity_code'] === MemberEntityCode.RETAIL ||\n            row.expand['recourse_type'] === 'Individual'\n              ? row.expand['fullname']\n              : row.expand['company_name'] || row.expand['fullname']\n          }}\n        </td>\n        <td>{{ row.expand['designation'] }}</td>\n        <td>{{ row.expand['ownership'] }}</td>\n        <td>\n          {{\n            getFormattedDate(\n              row.expand['member_entity_type_id']?.toString() === MemberTypeId.INDIVIDUAL\n                ? row.expand['birth_date']\n                : row.expand['company_birth_date'] || row.expand['birth_date']\n            )\n          }}\n        </td>\n        <td>{{ row.expand['recourse_type'] }}</td>\n        <ng-container *fswMeetCountry=\"'MY'\">\n          <td>{{ row.expand['ic_number'] }}</td>\n          <td>{{ row.expand['recourse_identifier'] }}</td>\n        </ng-container>\n        <ng-container *fswMeetCountry=\"'ID'\">\n          <td>\n            <button\n              fswButton\n              appearance=\"link\"\n              [disabled]=\"state.isReadonly\"\n              (click)=\"row.expand['pefindo_id'] ? viewPefindo(row) : pullPefindo(row)\"\n            >\n              <i\n                [fswIcon]=\"\n                  row.expand['pefindo_id']\n                    ? 'common-password-show-alternative'\n                    : 'common-external-link'\n                \"\n              ></i>\n              <span>{{\n                (row.expand['pefindo_id'] ? 'buttons.view' : 'buttons.pull') | fswTranslate\n              }}</span>\n            </button>\n          </td>\n        </ng-container>\n        <td>\n          <i\n            *ngIf=\"!state.isReadonly\"\n            (click)=\"delete(row)\"\n            [fswIcon]=\"'common-delete-alternative'\"\n            class=\"text-blue-500 hover:text-red-500 hover:cursor-pointer\"\n          ></i>\n        </td>\n      </ng-template>\n    </fsw-bips-grid>\n  </section>\n</fsw-panel>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_BIPS_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [EXTENSION_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_BIPS_HELPER_TOKEN]
                }] }, { type: i1$7.Dialog }, { type: i0.Injector }]; }, propDecorators: { applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

var FSwBIPsDirective_1;
let FSwBIPsDirective = class FSwBIPsDirective {
    static { FSwBIPsDirective_1 = this; }
    static { this.REFRESH_KEY = 'fs-widgets-feature-bips'; }
    constructor(_refreshService, _viewContainerRef, _translateService) {
        this._refreshService = _refreshService;
        this._viewContainerRef = _viewContainerRef;
        this._translateService = _translateService;
        this.applicationId = null;
        this.isReadonly = false;
        this._translateService.switchTranslateKey(getCountryCodeFromStorage());
    }
    ngOnInit() {
        this._refreshService
            .register(FSwBIPsDirective_1.REFRESH_KEY)
            .pipe(followDestroy(this), tap(() => this.refresh()))
            .subscribe();
    }
    ngOnChanges() {
        this.refresh();
    }
    refresh() {
        this._viewContainerRef.clear();
        const ref = this._viewContainerRef.createComponent(FSWBIPsComponent, {
            injector: Injector.create({
                parent: this._viewContainerRef.injector,
                providers: [...bipsLoadProviders(getCountryCodeFromStorage())],
            }),
        });
        const instance = ref.instance;
        instance.applicationId = this.applicationId;
        instance.isReadonly = this.isReadonly;
        ref.changeDetectorRef.detectChanges();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSwBIPsDirective, deps: [{ token: RefreshService }, { token: i0.ViewContainerRef }, { token: FSW_TRANSLATE_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSwBIPsDirective, selector: "[fswBIPs]", inputs: { applicationId: "applicationId", isReadonly: "isReadonly" }, usesOnChanges: true, ngImport: i0 }); }
};
FSwBIPsDirective = FSwBIPsDirective_1 = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [RefreshService,
        ViewContainerRef, Object])
], FSwBIPsDirective);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSwBIPsDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswBIPs]',
                }]
        }], ctorParameters: function () { return [{ type: RefreshService }, { type: i0.ViewContainerRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_TRANSLATE_SERVICE_TOKEN]
                }] }]; }, propDecorators: { applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class FSWBIPsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsModule, declarations: [FSWBIPsComponent,
            FSwBIPsDirective,
            FSWBIPsTemplatePipe,
            FSWBIPsConfirmComponent,
            FSWBIPsAddComponent,
            FSWBIPsGridComponent,
            FSWBIPsEditComponent,
            FSWBIPsGridItemDirective,
            FSWBIPsPefindoComponent], imports: [i1$4.FSWTranslateModule, ApplicationMemberServiceModule,
            MemberBIPServiceModule,
            MemberServiceModule,
            MasterDataServiceModule,
            ReferenceServiceModule,
            MemberBIPServiceModule,
            SettingsServiceModule,
            ExtensionServiceModule,
            FSWPanelModule,
            FSWDynamicBuilderModule,
            ReactiveFormsModule,
            FSWButtonModule,
            FSWModalModule$1,
            AsyncPipe,
            NgIf,
            DatePipe,
            NgSwitch,
            NgSwitchCase,
            NgSwitchDefault,
            NgForOf,
            FSWIconModule,
            FSWFieldModule,
            FSWInputModule,
            FSWPaginationModule$1,
            NgTemplateOutlet,
            FSWTabsModule,
            FSWMeetCountryDirective,
            FSWRadioModule], exports: [FSWBIPsComponent,
            FSwBIPsDirective,
            FSWBIPsTemplatePipe,
            FSWBIPsConfirmComponent,
            FSWBIPsAddComponent,
            FSWBIPsGridComponent,
            FSWBIPsEditComponent,
            FSWBIPsGridItemDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsModule, imports: [FSWTranslateModule.forFeature({
                scope: 'bips',
                defaultKey: CountryCode.TH,
                data: FSW_BIPS_TRANSLATION_LOADER,
            }),
            ApplicationMemberServiceModule,
            MemberBIPServiceModule,
            MemberServiceModule,
            MasterDataServiceModule,
            ReferenceServiceModule,
            MemberBIPServiceModule,
            SettingsServiceModule,
            ExtensionServiceModule,
            FSWPanelModule,
            FSWDynamicBuilderModule,
            ReactiveFormsModule,
            FSWButtonModule,
            FSWModalModule$1,
            FSWIconModule,
            FSWFieldModule,
            FSWInputModule,
            FSWPaginationModule$1,
            FSWTabsModule,
            FSWRadioModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBIPsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FSWBIPsComponent,
                        FSwBIPsDirective,
                        FSWBIPsTemplatePipe,
                        FSWBIPsConfirmComponent,
                        FSWBIPsAddComponent,
                        FSWBIPsGridComponent,
                        FSWBIPsEditComponent,
                        FSWBIPsGridItemDirective,
                        FSWBIPsPefindoComponent,
                    ],
                    exports: [
                        FSWBIPsComponent,
                        FSwBIPsDirective,
                        FSWBIPsTemplatePipe,
                        FSWBIPsConfirmComponent,
                        FSWBIPsAddComponent,
                        FSWBIPsGridComponent,
                        FSWBIPsEditComponent,
                        FSWBIPsGridItemDirective,
                    ],
                    imports: [
                        FSWTranslateModule.forFeature({
                            scope: 'bips',
                            defaultKey: CountryCode.TH,
                            data: FSW_BIPS_TRANSLATION_LOADER,
                        }),
                        ApplicationMemberServiceModule,
                        MemberBIPServiceModule,
                        MemberServiceModule,
                        MasterDataServiceModule,
                        ReferenceServiceModule,
                        MemberBIPServiceModule,
                        SettingsServiceModule,
                        ExtensionServiceModule,
                        FSWPanelModule,
                        FSWDynamicBuilderModule,
                        ReactiveFormsModule,
                        FSWButtonModule,
                        FSWModalModule$1,
                        AsyncPipe,
                        NgIf,
                        DatePipe,
                        NgSwitch,
                        NgSwitchCase,
                        NgSwitchDefault,
                        NgForOf,
                        FSWIconModule,
                        FSWFieldModule,
                        FSWInputModule,
                        FSWPaginationModule$1,
                        NgTemplateOutlet,
                        FSWTabsModule,
                        FSWMeetCountryDirective,
                        FSWRadioModule,
                    ],
                }]
        }] });

var title$D = "Borrower Summary";
var empty$l = "Borrower Summary is empty";
var fields$s = {
	name: "Company Name",
	registration_no: "UEN",
	incorporation_date: "Incorporation Date",
	avg_num_of_days_to_pay_creditors: "Average number of days to pay creditors",
	negative_blacklist: "Negative / Black List",
	paid_up_capital_currency: "Paid-Up Capital",
	litigation: "Litigation",
	payment_behavior: "Conduct of account",
	num_of_employee: "Number of Employees",
	num_of_customers: "Number of Customers",
	business_nature: "Business Nature",
	partner_id: "Partner ID",
	ctos_grade: "CTOS Grade",
	ctos_sme_score: "CTOS SME Score",
	num_of_borrowing: "No. of Borrowings",
	existing_working_capital_line: "Existing Working Capital Line",
	working_capital_line: "Working Capital line",
	num_of_searches: "Number of Searches",
	total_borrowing_limit: "Total borrowing limit",
	total_borrowing_outstanding: "Total borrowing outstanding",
	total_monthly_commitment: "Total monthly commitment (CCRIS only)",
	credit_application_commitment: "Recent Credit Application Commitment",
	outstanding_trade_amount: "Total outstanding amount (Trade Reference)",
	total_monthly_commitment_non_bank_lender: "Total Monthly Commitment (Non Bank Lender)",
	total_charges: "Total Charges",
	msic_code: "MSIC Code",
	previous_loan_code: "Previous Loan Code",
	has_bumiputera_shareholding: "Has Bumiputera Shareholding",
	bumiputera_shareholding_percentage: "Bumiputera shareholding (%)"
};
var comments$6 = {
	factsheet: {
		title: "Factsheet Comments",
		general_overview: "General Overview",
		strength: "Strength",
		other_stakeholder_summary: "Other Stakeholder's Summary",
		weakness: "Weakness",
		industry: "Industry",
		business_risk: "Business Risk"
	},
	credit: "Credit Comments",
	bd: "BD Rationale"
};
var tabs$4 = {
	summary: "Summary",
	profit_and_loss: "CG Profit & Loss",
	balance_sheet: "CG Balance Sheet",
	bank_statement: "CG Bank Statement"
};
var buttons$W = {
	save: "Save Changes",
	view_docs: "View Docs"
};
var borrowerSummaryMy = {
	title: title$D,
	empty: empty$l,
	fields: fields$s,
	comments: comments$6,
	tabs: tabs$4,
	buttons: buttons$W
};

var MY$l = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$W,
    comments: comments$6,
    default: borrowerSummaryMy,
    empty: empty$l,
    fields: fields$s,
    tabs: tabs$4,
    title: title$D
});

const BORROWER_SUMMARY_MY_TRANSLATION = MY$l;

function injectBorrowerSummaryMYForm({ isReadonly, currencies, }) {
    const form = new UntypedFormGroup({});
    const translation = BORROWER_SUMMARY_MY_TRANSLATION;
    const builder = new FSWDynamicBuilder({
        form,
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'flex flex-col gap-[16px]',
        readonlyWhen$: of(isReadonly),
        fields: [
            companyGuarantorForm.id({
                control: {
                    context: {
                        isHidden: true,
                    },
                },
            }),
            {
                key: 'company',
                formType: FSWDynamicBuilderFormTypes.GROUP,
                renderBy: 'container',
                customClasses: 'w-full flex flex-wrap gap-[16px]',
                containers: [
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.name({
                                control: {
                                    context: {
                                        label: translation.fields.name,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.registration_no({
                                control: {
                                    context: {
                                        label: translation.fields.registration_no,
                                        isDisabled: true,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-[calc(50%-8px)]',
                        fields: [
                            companyGuarantorForm.incorporation_date({
                                control: {
                                    context: {
                                        label: translation.fields.incorporation_date,
                                    },
                                },
                                element: {
                                    customClasses: 'w-full',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-[calc(50%-8px)] flex gap-[4px] items-end',
                        fields: [
                            companyGuarantorForm.paid_up_capital_currency({
                                control: {
                                    context: {
                                        label: translation.fields.paid_up_capital_currency,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[150px]',
                                },
                                pickList: {
                                    currencies,
                                },
                            }),
                            companyGuarantorForm.paid_up_capital({
                                control: {
                                    context: {},
                                },
                                element: {
                                    customClasses: 'w-[calc(100%-154px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.num_of_employee({
                                control: {
                                    context: {
                                        label: translation.fields.num_of_employee,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.num_of_customers({
                                control: {
                                    context: {
                                        label: translation.fields.num_of_customers,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.litigation({
                                control: {
                                    context: {
                                        label: translation.fields.litigation,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.business_nature({
                                control: {
                                    context: {
                                        label: translation.fields.business_nature,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.negative_blacklist({
                                control: {
                                    context: {
                                        label: translation.fields.negative_blacklist,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.payment_behavior({
                                control: {
                                    context: {
                                        label: translation.fields.payment_behavior,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.ctos_grade({
                                control: {
                                    context: {
                                        label: translation.fields.ctos_grade,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.ctos_sme_score({
                                control: {
                                    context: {
                                        label: translation.fields.ctos_sme_score,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.num_of_borrowing({
                                control: {
                                    context: {
                                        label: translation.fields.num_of_borrowing,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.total_borrowing_limit({
                                control: {
                                    context: {
                                        label: translation.fields.total_borrowing_limit,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.total_borrowing_outstanding({
                                control: {
                                    context: {
                                        label: translation.fields.total_borrowing_outstanding,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.total_monthly_commitment({
                                control: {
                                    context: {
                                        label: translation.fields.total_monthly_commitment,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.existing_working_capital_line({
                                control: {
                                    context: {
                                        label: translation.fields.existing_working_capital_line,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.working_capital_line({
                                control: {
                                    context: {
                                        label: translation.fields.working_capital_line,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.num_of_searches({
                                control: {
                                    context: {
                                        label: translation.fields.num_of_searches,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.credit_application_commitment({
                                control: {
                                    context: {
                                        label: translation.fields.credit_application_commitment,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.avg_num_of_days_to_pay_creditors({
                                control: {
                                    context: {
                                        label: translation.fields.avg_num_of_days_to_pay_creditors,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.total_monthly_commitment_non_bank_lender({
                                control: {
                                    context: {
                                        label: translation.fields.total_monthly_commitment_non_bank_lender,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.total_charges({
                                control: {
                                    context: {
                                        label: translation.fields.total_charges,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.outstanding_trade_amount({
                                control: {
                                    context: {
                                        label: translation.fields.outstanding_trade_amount,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.msic_code({
                                control: {
                                    context: {
                                        label: translation.fields.msic_code,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.previous_loan_code({
                                control: {
                                    context: {
                                        label: translation.fields.previous_loan_code,
                                        defaultValue: null,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.has_bumiputera_shareholding({
                                control: {
                                    context: {
                                        label: translation.fields.has_bumiputera_shareholding,
                                        isDisabled: true,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.partner_id({
                                control: {
                                    context: {
                                        label: translation.fields.partner_id,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.bumiputera_shareholding_percentage({
                                control: {
                                    validations: [Validators.max(100), Validators.min(0)],
                                    context: {
                                        label: translation.fields.bumiputera_shareholding_percentage,
                                        isDisabled: true,
                                        max: 100,
                                        min: 0,
                                        suffix: '%',
                                        customRender: [
                                            {
                                                fields: [
                                                    {
                                                        key: 'has_bumiputera_shareholding',
                                                        correctWhenValueIs: (value) => `${value}` === 'true',
                                                    },
                                                ],
                                                checkingConditionCallback: (params, condition) => {
                                                    if (condition) {
                                                        params.renderView();
                                                    }
                                                    else {
                                                        params.clearView();
                                                    }
                                                },
                                            },
                                        ],
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.id({
                                control: {
                                    context: {
                                        isHidden: true,
                                    },
                                },
                            }),
                        ],
                    },
                ],
            },
        ],
    });
    return { builder, form };
}

function injectBorrowerSummaryMYEffects({ applicationIdSignal, isReadonlySignal, hiddenCommentsSignal, summarySignal, commentsSignal, memberSignal, currenciesSignal, industriesSignal, }) {
    const alertService = inject(FSW_ALERT_SERVICE_TOKEN);
    const applicationRelationshipService = injectApplicationRelationshipService();
    const creditBorrowerSummaryService = injectCreditBorrowerSummaryService();
    const applicationMemberService = injectApplicationMemberService();
    const memberService = injectMemberService();
    const createSummary = (applicationId, company) => creditBorrowerSummaryService
        .create(company)
        .pipe(switchMap((borrowerSummary) => applicationRelationshipService
        .addAsync(applicationId, 'borrower_summary', borrowerSummary.id.toString())
        .pipe(switchMap(() => creditBorrowerSummaryService.getById(borrowerSummary.id)))));
    const loadMember = (applicationId) => applicationMemberService
        .getApplicationMainBorrower(applicationId)
        .pipe(tap((data) => memberSignal.set(data)), catchError(() => {
        alertService.error('Failed to load member', null, {
            duration: 3000,
        });
        memberSignal.set(null);
        return of(null);
    }))
        .subscribe();
    const loadSummary = (applicationId, member) => applicationRelationshipService
        .getAsync(applicationId, 'borrower_summary')
        .pipe(switchMap((ids) => {
        if (ids?.length) {
            return creditBorrowerSummaryService.getById(ids[0]);
        }
        if (isReadonlySignal() || !member.company_ctos_entity) {
            return of(null);
        }
        return creditBorrowerSummaryService
            .extractCtos(+member.id)
            .pipe(switchMap((company) => createSummary(applicationId, company)));
    }), switchMap((summary) => memberService.getSingleMember(+member.id).pipe(map((details) => summary
        ? {
            ...summary,
            company: {
                ...summary.company,
                has_bumiputera_shareholding: details?.additionalData?.['hasBumiputraShareholding'] === 'Yes',
                bumiputera_shareholding_percentage: details?.additionalData?.['bumiputraShareholdingPercentage'],
            },
        }
        : null))), tap((summary) => summarySignal.set(summary)))
        .subscribe();
    const refreshMember = () => {
        const applicationId = applicationIdSignal();
        if (!applicationId) {
            return;
        }
        commentsSignal.set(buildComments());
        loadMember(applicationId);
    };
    const refreshSummary = () => {
        const applicationId = applicationIdSignal();
        const member = memberSignal();
        if (!applicationId || !member) {
            return;
        }
        loadSummary(applicationId, member);
    };
    const buildComments = () => {
        return [
            {
                title: '',
                customClasses: 'flex flex-col gap-[16px] mt-[12px]',
                items: [
                    {
                        category: 'BD_RATIONALE',
                        title: 'comments.bd',
                        module: 'BORROWER_SUMMARY',
                        identifier: 'BORROWER_SUMMARY',
                        entityId: applicationIdSignal(),
                        fields: [
                            {
                                key: 'main_comment',
                                label: 'comments.bd',
                            },
                        ],
                    },
                    {
                        category: 'FACTSHEET',
                        title: 'comments.factsheet.title',
                        module: 'BORROWER_SUMMARY',
                        identifier: 'BORROWER_SUMMARY',
                        entityId: applicationIdSignal(),
                        customClasses: 'flex flex-wrap gap-[16px]',
                        fields: [
                            {
                                key: 'general_overview',
                                label: 'comments.factsheet.general_overview',
                            },
                            {
                                key: 'strength',
                                label: 'comments.factsheet.strength',
                            },
                            {
                                key: 'other_stakeholders_summary',
                                label: 'comments.factsheet.other_stakeholder_summary',
                            },
                            {
                                key: 'weakness',
                                label: 'comments.factsheet.weakness',
                            },
                            {
                                key: 'industry',
                                label: 'comments.factsheet.industry',
                            },
                            {
                                key: 'business_risk',
                                label: 'comments.factsheet.business_risk',
                            },
                        ],
                    },
                    {
                        category: 'CREDIT',
                        title: 'comments.credit',
                        module: 'BORROWER_SUMMARY',
                        identifier: 'BORROWER_SUMMARY',
                        entityId: applicationIdSignal(),
                        fields: [
                            {
                                key: 'main_comment',
                                label: 'comments.credit',
                            },
                        ],
                    },
                ].filter((item) => !hiddenCommentsSignal().includes(item.category)),
            },
        ];
    };
    return {
        buildForm: () => injectBorrowerSummaryMYForm({
            isReadonly: isReadonlySignal(),
            currencies: currenciesSignal(),
            industries: industriesSignal(),
        }),
        init: () => {
            effect(() => refreshMember(), { allowSignalWrites: true });
            effect(() => refreshSummary(), { allowSignalWrites: true });
        },
        save: (form) => {
            if (form.invalid) {
                return;
            }
            const payload = form.getRawValue();
            const { id, company } = payload;
            if (!id) {
                createSummary(applicationIdSignal(), company)
                    .pipe(tapResponse((borrowerSummary) => {
                    alertService.success('Success', 'Borrower summary successfully saved!', {
                        duration: 3000,
                    });
                    summarySignal.set(borrowerSummary);
                }, () => {
                    alertService.error('Error', 'Failed to save borrower summary', {
                        duration: 3000,
                    });
                }))
                    .subscribe();
                return;
            }
            creditBorrowerSummaryService
                .update(id, company)
                .pipe(tapResponse(() => {
                alertService.success('Success', 'Borrower summary successfully saved!', {
                    duration: 3000,
                });
            }, () => {
                alertService.error('Error', 'Failed to save borrower summary', {
                    duration: 3000,
                });
            }))
                .subscribe();
        },
    };
}

var title$C = "Borrower Summary";
var empty$k = "Borrower Summary is empty";
var fields$r = {
	name: "Company Name",
	registration_no: "UEN",
	incorporation_date: "Incorporation Date",
	avg_num_of_days_to_pay_creditors: "Average number of days to pay creditors",
	number_of_searches: "Number of searches",
	negative_blacklist: "Negative / Black List",
	paid_up_capital_currency: "Paid-Up Capital",
	litigation: "Litigation",
	payment_behavior: "Payment Behavior",
	num_of_employee: "Number of Employees",
	num_of_customers: "Number of Customers",
	business_nature: "Business Nature",
	partner_id: "Partner ID",
	num_of_searches: "Number of Searches",
	details_of_charges: "Details of Charges",
	entity_code: "Entity Code",
	ssic_code: "SSIC Code",
	experian_payment_grade: "Experian Payment Grade",
	experian_expected_default: "Experian Default Probability",
	num_of_ongoing_moneylender_loans: "No. of ongoing moneylender loans",
	company_industry: "Company Industry",
	factsheet_comments: "Factsheet Comments",
	credit_comments: "Credit Comments"
};
var comments$5 = {
	factsheet: {
		title: "Factsheet Comments",
		general_overview: "General Overview",
		strength: "Strength",
		other_stakeholder_summary: "Other Stakeholder's Summary",
		weakness: "Weakness",
		industry: "Industry",
		business_risk: "Business Risk"
	},
	credit: "Credit Comments",
	bd: "BD Rationale"
};
var tabs$3 = {
	summary: "Summary",
	profit_and_loss: "CG Profit & Loss",
	balance_sheet: "CG Balance Sheet",
	bank_statement: "CG Bank Statement"
};
var buttons$V = {
	save: "Save Changes",
	view_docs: "View Docs"
};
var borrowerSummarySg = {
	title: title$C,
	empty: empty$k,
	fields: fields$r,
	comments: comments$5,
	tabs: tabs$3,
	buttons: buttons$V
};

var SG$a = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$V,
    comments: comments$5,
    default: borrowerSummarySg,
    empty: empty$k,
    fields: fields$r,
    tabs: tabs$3,
    title: title$C
});

const BORROWER_SUMMARY_SG_TRANSLATION = SG$a;

function injectBorrowerSummarySGForm({ isReadonly, currencies, industries, }) {
    const form = new UntypedFormGroup({});
    const translation = BORROWER_SUMMARY_SG_TRANSLATION;
    const builder = new FSWDynamicBuilder({
        form,
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'flex flex-col gap-[16px]',
        readonlyWhen$: of(isReadonly),
        fields: [
            companyGuarantorForm.id({
                control: {
                    context: {
                        isHidden: true,
                    },
                },
            }),
            {
                key: 'company',
                formType: FSWDynamicBuilderFormTypes.GROUP,
                renderBy: 'container',
                customClasses: 'w-full flex flex-wrap gap-[16px]',
                containers: [
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.name({
                                control: {
                                    context: {
                                        label: translation.fields.name,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.registration_no({
                                control: {
                                    context: {
                                        label: translation.fields.registration_no,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.partner_id({
                                control: {
                                    context: {
                                        label: translation.fields.partner_id,
                                        isDisabled: true,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.company_industry({
                                control: {
                                    context: {
                                        label: translation.fields.company_industry,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                                pickList: {
                                    industries,
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-[calc(50%-8px)]',
                        fields: [
                            companyGuarantorForm.incorporation_date({
                                control: {
                                    context: {
                                        label: translation.fields.incorporation_date,
                                    },
                                },
                                element: {
                                    customClasses: 'w-full',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-[calc(50%-8px)] flex gap-[4px] items-end',
                        fields: [
                            companyGuarantorForm.paid_up_capital_currency({
                                control: {
                                    context: {
                                        label: translation.fields.paid_up_capital_currency,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[150px]',
                                },
                                pickList: {
                                    currencies,
                                },
                            }),
                            companyGuarantorForm.paid_up_capital({
                                element: {
                                    customClasses: 'w-[calc(100%-154px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.num_of_employee({
                                control: {
                                    context: {
                                        label: translation.fields.num_of_employee,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.num_of_customers({
                                control: {
                                    context: {
                                        label: translation.fields.num_of_customers,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.experian_payment_grade({
                                control: {
                                    context: {
                                        label: translation.fields.experian_payment_grade,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.experian_expected_default({
                                control: {
                                    context: {
                                        label: translation.fields.experian_expected_default,
                                        isDisabled: true,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.litigation({
                                control: {
                                    context: {
                                        label: translation.fields.litigation,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.business_nature({
                                control: {
                                    context: {
                                        label: translation.fields.business_nature,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.negative_blacklist({
                                control: {
                                    context: {
                                        label: translation.fields.negative_blacklist,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.payment_behavior({
                                control: {
                                    context: {
                                        label: translation.fields.payment_behavior,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.num_of_searches({
                                control: {
                                    context: {
                                        label: translation.fields.num_of_searches,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.avg_num_of_days_to_pay_creditors({
                                control: {
                                    context: {
                                        label: translation.fields.avg_num_of_days_to_pay_creditors,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.details_of_charges({
                                control: {
                                    context: {
                                        label: translation.fields.details_of_charges,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.num_of_ongoing_moneylender_loans({
                                control: {
                                    context: {
                                        label: translation.fields.num_of_ongoing_moneylender_loans,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.entity_code({
                                control: {
                                    context: {
                                        label: translation.fields.entity_code,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.ssic_code({
                                control: {
                                    context: {
                                        label: translation.fields.ssic_code,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.id({
                                control: {
                                    context: {
                                        isHidden: true,
                                    },
                                },
                            }),
                        ],
                    },
                ],
            },
        ],
    });
    return { builder, form };
}

function injectBorrowerSummarySGEffects({ applicationIdSignal, isReadonlySignal, hiddenCommentsSignal, summarySignal, commentsSignal, memberSignal, currenciesSignal, industriesSignal, viewerDocsSignal, }) {
    const alertService = inject(FSW_ALERT_SERVICE_TOKEN);
    const service = {
        applicationRelationship: injectApplicationRelationshipService(),
        creditBorrowerSummary: injectCreditBorrowerSummaryService(),
        applicationMember: injectApplicationMemberService(),
        blob: injectBlobService(),
    };
    const domSanitizer = inject(DomSanitizer);
    const createSummary = (applicationId, company) => service.creditBorrowerSummary
        .create(company)
        .pipe(switchMap((borrowerSummary) => service.applicationRelationship
        .addAsync(applicationId, 'borrower_summary', borrowerSummary.id.toString())
        .pipe(switchMap(() => service.creditBorrowerSummary.getById(borrowerSummary.id)))));
    const loadMember = (applicationId) => service.applicationMember
        .getApplicationMainBorrower(applicationId)
        .pipe(tap((data) => memberSignal.set(data)), catchError(() => {
        alertService.error('Failed to load member', null, {
            duration: 3000,
        });
        memberSignal.set(null);
        return of(null);
    }))
        .subscribe();
    const loadSummary = (applicationId, member) => service.applicationRelationship
        .getAsync(applicationId, 'borrower_summary')
        .pipe(switchMap((ids) => {
        if (ids?.length) {
            return service.creditBorrowerSummary.getById(ids[0]);
        }
        if (isReadonlySignal() || !member) {
            return of(null);
        }
        return service.creditBorrowerSummary
            .extract({
            source: 'questnet',
            member_uuid: member.uuid,
        })
            .pipe(switchMap((company) => createSummary(applicationId, company)));
    }), tap((summary) => summarySignal.set(summary)))
        .subscribe();
    const loadViewerDocs = (applicationId) => service.blob
        .getApplicationMemberDoc(applicationId, ['BRC'])
        .pipe(filter((docs) => !!docs?.length), switchMap((docs) => forkJoin(docs.map((doc) => service.blob.downloadV3Blob(doc.uuid).pipe(map((blob) => domSanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob))), map((src) => src
        ? {
            id: doc.uuid,
            name: doc.name,
            type: doc.docType,
            src,
        }
        : null)))).pipe(map((docs) => docs.filter((doc) => !!doc)), map((docs) => docs.reduce((acc, doc) => {
        const index = acc.findIndex((item) => item.type === doc.type);
        const viewerDoc = omit(doc, 'type');
        if (index === -1) {
            acc.push({
                type: doc.type,
                items: [viewerDoc],
            });
        }
        else {
            acc[index].items.push(viewerDoc);
        }
        return acc;
    }, [])), tapResponse((docs) => viewerDocsSignal.set(docs), () => {
        viewerDocsSignal.set([]);
        alertService.error('Error', 'Failed to load documents', {
            duration: 3000,
        });
    }))))
        .subscribe();
    const refreshMember = () => {
        const applicationId = applicationIdSignal();
        if (!applicationId) {
            return;
        }
        commentsSignal.set(buildComments());
        loadMember(applicationId);
    };
    const refreshSummary = () => {
        const applicationId = applicationIdSignal();
        const member = memberSignal();
        if (!applicationId || !member) {
            return;
        }
        loadSummary(applicationId, member);
    };
    const refreshViewerDocs = () => {
        const applicationId = applicationIdSignal();
        const summary = summarySignal();
        if (!applicationId || !summary) {
            return;
        }
        loadViewerDocs(applicationId);
    };
    const buildComments = () => {
        return [
            {
                title: '',
                customClasses: 'flex flex-col gap-[16px] mt-[12px]',
                items: [
                    {
                        category: 'FACTSHEET',
                        title: 'comments.factsheet.title',
                        module: 'BORROWER_SUMMARY',
                        identifier: 'BORROWER_SUMMARY',
                        entityId: applicationIdSignal(),
                        customClasses: 'flex flex-wrap gap-[16px]',
                        fields: [
                            {
                                key: 'general_overview',
                                label: 'comments.factsheet.general_overview',
                            },
                            {
                                key: 'strength',
                                label: 'comments.factsheet.strength',
                            },
                            {
                                key: 'other_stakeholders_summary',
                                label: 'comments.factsheet.other_stakeholder_summary',
                            },
                            {
                                key: 'weakness',
                                label: 'comments.factsheet.weakness',
                            },
                        ],
                    },
                    {
                        category: 'CREDIT',
                        title: 'comments.credit',
                        module: 'BORROWER_SUMMARY',
                        identifier: 'BORROWER_SUMMARY',
                        entityId: applicationIdSignal(),
                        fields: [
                            {
                                key: 'main_comment',
                                label: 'comments.credit',
                            },
                        ],
                    },
                ].filter((item) => !hiddenCommentsSignal().includes(item.category)),
            },
        ];
    };
    return {
        buildForm: () => injectBorrowerSummarySGForm({
            isReadonly: isReadonlySignal(),
            currencies: currenciesSignal(),
            industries: industriesSignal(),
        }),
        init: () => {
            effect(() => refreshMember(), { allowSignalWrites: true });
            effect(() => refreshSummary(), { allowSignalWrites: true });
            effect(() => refreshViewerDocs(), { allowSignalWrites: true });
        },
        save: (form) => {
            if (form.invalid) {
                return;
            }
            const payload = form.getRawValue();
            const { id, company } = payload;
            if (!id) {
                createSummary(applicationIdSignal(), company)
                    .pipe(tapResponse((borrowerSummary) => {
                    alertService.success('Success', 'Borrower summary successfully saved!', {
                        duration: 3000,
                    });
                    summarySignal.set(borrowerSummary);
                }, () => {
                    alertService.error('Error', 'Failed to save borrower summary', {
                        duration: 3000,
                    });
                }))
                    .subscribe();
                return;
            }
            service.creditBorrowerSummary
                .update(id, company)
                .pipe(tapResponse(() => {
                alertService.success('Success', 'Borrower summary successfully saved!', {
                    duration: 3000,
                });
            }, () => {
                alertService.error('Error', 'Failed to save borrower summary', {
                    duration: 3000,
                });
            }))
                .subscribe();
        },
    };
}

function injectBorrowerSummaryEffects(config) {
    switch (getCountryCodeFromStorage()) {
        case CountryCode.SG:
            return injectBorrowerSummarySGEffects(config);
        default:
            return injectBorrowerSummaryMYEffects(config);
    }
}

function provideBorrowerSummaryTranslation(scope = 'borrower_summary') {
    return [
        ...(FSWTranslateModule.forFeature({
            scope,
            defaultKey: getCountryCodeFromStorage() ?? CountryCode.MY,
            data: {
                [CountryCode.MY]: BORROWER_SUMMARY_MY_TRANSLATION,
                [CountryCode.SG]: BORROWER_SUMMARY_SG_TRANSLATION,
            },
        }).providers || []),
        fswTranslateScope(scope),
    ];
}

class FSWBorrowerSummaryComponent {
    constructor() {
        this.applicationIdSignal = signal('');
        this.isReadonlySignal = signal(false);
        this.hiddenCommentsSignal = signal([]);
        this.commentsSignal = signal([]);
        this.currenciesSignal = signal([]);
        this.memberSignal = signal(null);
        this.summarySignal = signal(null);
        this.industriesSignal = signal([]);
        this.viewerDocsSignal = signal([]);
        this.destroyDocViewerWhen$ = new Subject();
        this.injector = inject(Injector);
        this.docViewerService = injectFSWDocViewerService();
        this.effects = injectBorrowerSummaryEffects({
            applicationIdSignal: this.applicationIdSignal,
            isReadonlySignal: this.isReadonlySignal,
            hiddenCommentsSignal: this.hiddenCommentsSignal,
            memberSignal: this.memberSignal,
            summarySignal: this.summarySignal,
            commentsSignal: this.commentsSignal,
            currenciesSignal: this.currenciesSignal,
            industriesSignal: this.industriesSignal,
            viewerDocsSignal: this.viewerDocsSignal,
            injector: this.injector,
        });
        this.validViewerDocsSignal = computed(() => {
            const docs = this.viewerDocsSignal();
            return (docs || []).filter((doc) => doc.items.filter((item) => item.src && item.id && item.name).length > 0);
        });
        this.cdr = inject(ChangeDetectorRef);
        this.formBuilder = null;
        this.effects.init();
        effect(() => {
            const summary = this.summarySignal();
            this.formBuilder?.form.patchValue(summary || {});
            this.cdr.detectChanges();
        }, { allowSignalWrites: true });
    }
    ngOnInit() {
        this.formBuilder = this.effects.buildForm();
        this.formBuilder?.form.patchValue(this.summarySignal() || {});
        this.cdr.detectChanges();
    }
    ngOnDestroy() {
        this.destroyDocViewerWhen$.next(new Date());
        this.destroyDocViewerWhen$.complete();
    }
    save() {
        if (!this.formBuilder) {
            return;
        }
        this.effects.save(this.formBuilder.form);
    }
    showDocViewer() {
        if (!this.validViewerDocsSignal().length)
            return;
        this.docViewerService.open({
            groups: this.validViewerDocsSignal(),
        }, this.destroyDocViewerWhen$);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBorrowerSummaryComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWBorrowerSummaryComponent, isStandalone: true, selector: "fsw-borrower-summary", providers: [
            provideBorrowerSummaryTranslation(),
            provideUtilsService(),
            provideApplicationMemberService(),
            provideApplicationRelationshipService(),
            provideCreditBorrowerSummaryService(),
            provideMemberService(),
            provideBlobService(),
        ], ngImport: i0, template: "<fsw-panel [title]=\"'title' | fswTranslate\" [customClasses]=\"'flex w-[900px]'\" *ngIf=\"formBuilder\">\n  <ng-template fswPanelHeaderSuffix>\n    <aside class=\"flex items-center gap-[12px]\">\n      <button\n        fswButton\n        [appearance]=\"'secondary-elevate'\"\n        (click)=\"showDocViewer()\"\n        *ngIf=\"validViewerDocsSignal().length\"\n      >\n        {{ 'buttons.view_docs' | fswTranslate }}\n      </button>\n      <button\n        fswButton\n        *ngIf=\"!isReadonlySignal()\"\n        [disabled]=\"formBuilder.form.invalid\"\n        (click)=\"save()\"\n      >\n        {{ 'buttons.save' | fswTranslate }}\n      </button>\n    </aside>\n  </ng-template>\n  <section class=\"w-full flex flex-col gap-[16px]\">\n    <form [formGroup]=\"formBuilder.form\">\n      <fsw-dynamic-builder [builder]=\"formBuilder.builder\"></fsw-dynamic-builder>\n    </form>\n    <ng-container *ngIf=\"formBuilder.form.value.id\">\n      <fsw-comments-section\n        [enableSaveButton]=\"true\"\n        [isReadonly]=\"isReadonlySignal()\"\n        [translateScope]=\"'borrower_summary'\"\n        [data]=\"commentsSignal()\"\n      ></fsw-comments-section>\n    </ng-container>\n  </section>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWAlertModule }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: FSWDynamicBuilderModule }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "component", type: FSWCommentsSectionComponent, selector: "fsw-comments-section", inputs: ["data", "customClasses", "translateScope", "isReadonly", "enableSaveButton"] }, { kind: "ngmodule", type: FSWDocViewerModule }, { kind: "ngmodule", type: FSWIconModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBorrowerSummaryComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-borrower-summary', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [
                        FSWAlertModule,
                        FSWPanelModule,
                        FSWTranslateModule,
                        FSWButtonModule,
                        NgIf,
                        NgForOf,
                        ReactiveFormsModule,
                        FSWDynamicBuilderModule,
                        FSWCommentsSectionComponent,
                        FSWDocViewerModule,
                        FSWIconModule,
                    ], providers: [
                        provideBorrowerSummaryTranslation(),
                        provideUtilsService(),
                        provideApplicationMemberService(),
                        provideApplicationRelationshipService(),
                        provideCreditBorrowerSummaryService(),
                        provideMemberService(),
                        provideBlobService(),
                    ], template: "<fsw-panel [title]=\"'title' | fswTranslate\" [customClasses]=\"'flex w-[900px]'\" *ngIf=\"formBuilder\">\n  <ng-template fswPanelHeaderSuffix>\n    <aside class=\"flex items-center gap-[12px]\">\n      <button\n        fswButton\n        [appearance]=\"'secondary-elevate'\"\n        (click)=\"showDocViewer()\"\n        *ngIf=\"validViewerDocsSignal().length\"\n      >\n        {{ 'buttons.view_docs' | fswTranslate }}\n      </button>\n      <button\n        fswButton\n        *ngIf=\"!isReadonlySignal()\"\n        [disabled]=\"formBuilder.form.invalid\"\n        (click)=\"save()\"\n      >\n        {{ 'buttons.save' | fswTranslate }}\n      </button>\n    </aside>\n  </ng-template>\n  <section class=\"w-full flex flex-col gap-[16px]\">\n    <form [formGroup]=\"formBuilder.form\">\n      <fsw-dynamic-builder [builder]=\"formBuilder.builder\"></fsw-dynamic-builder>\n    </form>\n    <ng-container *ngIf=\"formBuilder.form.value.id\">\n      <fsw-comments-section\n        [enableSaveButton]=\"true\"\n        [isReadonly]=\"isReadonlySignal()\"\n        [translateScope]=\"'borrower_summary'\"\n        [data]=\"commentsSignal()\"\n      ></fsw-comments-section>\n    </ng-container>\n  </section>\n</fsw-panel>\n" }]
        }], ctorParameters: function () { return []; } });

class FSWBorrowerSummaryDirective {
    constructor() {
        this.applicationId = null;
        this.isReadonly = false;
        this.hiddenComments = [];
        this.viewContainerRef = inject(ViewContainerRef);
        this.masterDataService = injectMasterDataService();
        this.industriesSignal = signal([]);
        this.currenciesSignal = signal([]);
        this.firstLoad = false;
    }
    ngOnInit() {
        forkJoin([this.masterDataService.getIndustries(), this.masterDataService.getCurrencies()])
            .pipe(tap(([industries, currencies]) => {
            this.industriesSignal.set(industries);
            this.currenciesSignal.set(currencies);
            this.firstLoad = true;
            this.render();
        }))
            .subscribe();
    }
    ngOnChanges() {
        this.render();
    }
    ngOnDestroy() {
        this.viewContainerRef.clear();
    }
    render() {
        this.viewContainerRef.clear();
        if (!this.applicationId || !this.firstLoad) {
            return;
        }
        const ref = this.viewContainerRef.createComponent(FSWBorrowerSummaryComponent);
        const instance = ref.instance;
        instance.applicationIdSignal.set(this.applicationId);
        instance.isReadonlySignal.set(this.isReadonly);
        instance.currenciesSignal.set(this.currenciesSignal() || []);
        instance.industriesSignal.set(this.industriesSignal() || []);
        instance.hiddenCommentsSignal.set(this.hiddenComments);
        ref.changeDetectorRef.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBorrowerSummaryDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWBorrowerSummaryDirective, isStandalone: true, selector: "[fswBorrowerSummary]", inputs: { applicationId: "applicationId", isReadonly: "isReadonly", hiddenComments: "hiddenComments" }, providers: [provideUtilsService(), provideMasterDataService()], usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBorrowerSummaryDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswBorrowerSummary]',
                    standalone: true,
                    providers: [provideUtilsService(), provideMasterDataService()],
                }]
        }], propDecorators: { applicationId: [{
                type: Input,
                args: [{ required: true }]
            }], isReadonly: [{
                type: Input
            }], hiddenComments: [{
                type: Input
            }] } });

var tables$7 = {
	buyerInfo: {
		columns: {
			name: "Buyer name",
			credit_term: "Credit term",
			sales_thb_month: "Sales THB/month",
			method_of_payment: "Method of payment",
			include_in_financing: "Include in financing",
			trading_history: "Trading history",
			remark: "Remark",
			status: "Status",
			action: "Action",
			incorporation: "Incorporation",
			supplier_payment_days: "Supplier payment days",
			reported_year: "Reported year",
			revenue: "Revenue",
			profit: "Profit",
			total_net_worth: "Total networth",
			d_e_ratio: "D/E ratio",
			current_ratio: "Current ratio",
			credit_exposure: "Our credit exposure to the buyer revenue",
			reputation_check: "Reputation check",
			verification_with_buyer: "Verification with buyer",
			note: "Note"
		}
	}
};
var empty$j = {
	buyers: "No buyers are found"
};
var buttons$U = {
	cancel: "Cancel",
	refresh: "Refresh",
	save_changes: "Save Changes",
	add_buyer: "Add Buyer",
	delete_buyer: "Delete Buyer",
	edit_details: "Edit Details",
	back: "Back",
	"import": "Import",
	no: "No",
	yes: "Yes",
	change_status: "Change Status"
};
var forms$7 = {
	buyer: {
		name: "Buyer name",
		credit_term: "Credit term",
		sales_thb_month: "Sales THB/month",
		method_of_payment: "Method of payment",
		include_in_financing: "Include in financing",
		trading_history: "Trading history",
		remark: "Remarks",
		status: "Status",
		action: "Action",
		incorporation: "Incorporation",
		supplier_payment_days: "Supplier payment days",
		reported_year: "Reported year",
		revenue: "Revenue",
		profit: "Profit",
		total_net_worth: "Total networth",
		d_e_ratio: "D/E ratio",
		current_ratio: "Current ratio",
		credit_exposure: "Our credit exposure to the buyer revenue",
		reputation_check: "Reputation check",
		verification_with_buyer: "Verification with buyer",
		note: "Note"
	}
};
var modals$a = {
	buyer: {
		edit: "Edit Buyer",
		"new": "New Buyer",
		confirm_add: "Are you sure you want to add this Buyer ?",
		confirm_add_title: "Confirm Add Buyer",
		confirm_edit: "Are you sure you want to update this Buyer ?",
		confirm_edit_title: "Confirm Edit Buyer",
		confirm_delete: "You will lose all the information, Are you sure you want to delete this Buyer ?",
		confirm_delete_title: "Confirm Delete Buyer"
	}
};
var th$a = {
	tables: tables$7,
	empty: empty$j,
	buttons: buttons$U,
	forms: forms$7,
	modals: modals$a
};

var th$b = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$U,
    default: th$a,
    empty: empty$j,
    forms: forms$7,
    modals: modals$a,
    tables: tables$7
});

const BUYER_INFORMATION_TRANSLATION_LOADER = {
    [CountryCode.TH]: th$b,
};

const THBuyerInformationForm = (form, type, method, state, isReadonly$) => {
    const translation = BUYER_INFORMATION_TRANSLATION_LOADER[CountryCode.TH];
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'w-full',
        readonlyWhen$: isReadonly$,
        renderBy: 'container',
        containers: getContainers$4(type, method, translation, state),
        form,
    });
};
function getContainers$4(type, method, translation, state) {
    switch (type) {
        case BuyerSalesOrCredit.SALES:
            return getBuyerContainersSales$1(method, translation);
        case BuyerSalesOrCredit.CREDIT:
        default:
            return getBuyerContainersCredit$1(method, translation);
    }
}
function getBuyerContainersSales$1(method, translation) {
    let hiddenObj = {};
    if (method === 'POST') {
        hiddenObj = {
            buyer_name: '',
            incorporation: '',
            avg_days_suppliers: 0,
            revenue: 0,
            profit: 0,
            total_net_worth: 0,
            de_ratio: 0,
            current_ratio: 0,
            credit_exposure: '',
            reputation_check: '',
            verification_with_buyer: '',
            note: '',
        };
    }
    else {
        hiddenObj['id'] = '';
    }
    const keys = Object.keys(hiddenObj);
    const containers = keys.length
        ? [
            {
                customClasses: 'hidden',
                fields: keys.map((key) => ({
                    key,
                    type: FSWDynamicBuilderControlTypes.TEMPLATE,
                    context: {
                        defaultValue: hiddenObj[key],
                        isHidden: true,
                    },
                })),
            },
        ]
        : [];
    return [
        {
            customClasses: 'flex justify-between gap-[16px]',
            containers: [
                {
                    customClasses: 'flex-1 flex flex-col gap-[16px] w-[calc(50%-8px)]',
                    fields: [
                        {
                            key: 'name',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                label: translation.forms.buyer.name,
                                fullWidth: true,
                                isRequired: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'credit_term',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number',
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.buyer.credit_term,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'sales_thb_month',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number',
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                defaultValue: 0,
                                label: translation.forms.buyer.sales_thb_month,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'method_of_payment',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                label: translation.forms.buyer.method_of_payment,
                                items: BUYER_PAYMENT_METHODS.map((item) => ({
                                    text: item,
                                    value: item,
                                })),
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => {
                                    const text = BUYER_PAYMENT_METHODS.find((item) => item === value);
                                    return text ?? 'N/A';
                                },
                            },
                            validations: [Validators.required],
                        },
                    ],
                },
                {
                    customClasses: 'flex-1 flex flex-col gap-[16px] w-[calc(50%-8px)]',
                    fields: [
                        {
                            key: 'include_in_financing',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                defaultValue: 'Yes',
                                label: translation.forms.buyer.include_in_financing,
                                items: ['Yes', 'No'].map((item) => ({
                                    text: item,
                                    value: item,
                                })),
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => {
                                    const text = ['Yes', 'No'].find((item) => item === value);
                                    return text ?? 'N/A';
                                },
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'trading_history',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                label: translation.forms.buyer.trading_history,
                                fullWidth: true,
                                isRequired: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'remark',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                inputType: 'area',
                                placeHolder: 'Please enter remarks',
                                defaultValue: null,
                                label: translation.forms.buyer.remark,
                                isRequired: true,
                                fullWidth: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'status',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                label: translation.forms.buyer.status,
                                defaultValue: 'NORMAL',
                                fullWidth: true,
                                isRequired: true,
                                isDisabled: true,
                            },
                            validations: [Validators.required],
                        },
                    ],
                },
            ],
        },
        ...containers,
    ];
}
function getBuyerContainersCredit$1(method, translation) {
    const years = Array.from({ length: 4 }, (_, i) => new Date().getFullYear() - i);
    let hiddenObj = {};
    if (method === 'POST') {
        hiddenObj = {
            buyer_name: '',
            incorporation: '',
            avg_days_suppliers: 0,
            revenue: 0,
            profit: 0,
            total_net_worth: 0,
            de_ratio: 0,
            current_ratio: 0,
            credit_exposure: '',
            reputation_check: '',
            verification_with_buyer: '',
            note: '',
        };
    }
    else {
        hiddenObj['id'] = '';
    }
    const keys = Object.keys(hiddenObj);
    const containers = keys.length
        ? [
            {
                customClasses: 'hidden',
                fields: keys.map((key) => ({
                    key,
                    type: FSWDynamicBuilderControlTypes.TEMPLATE,
                    context: {
                        defaultValue: hiddenObj[key],
                        isHidden: true,
                    },
                })),
            },
        ]
        : [];
    return [
        {
            customClasses: 'flex justify-between gap-[16px]',
            containers: [
                {
                    customClasses: 'flex-1 flex flex-col gap-[16px] w-[calc(50%-8px)]',
                    fields: [
                        {
                            key: 'name',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                label: translation.forms.buyer.name,
                                fullWidth: true,
                                isRequired: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'credit_term',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number',
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.buyer.credit_term,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'sales_thb_month',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number',
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.buyer.sales_thb_month,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'method_of_payment',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                label: translation.forms.buyer.method_of_payment,
                                items: BUYER_PAYMENT_METHODS.map((item) => ({
                                    text: item,
                                    value: item,
                                })),
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => {
                                    const text = BUYER_PAYMENT_METHODS.find((item) => item === value);
                                    return text ?? 'N/A';
                                },
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'include_in_financing',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                defaultValue: 'Yes',
                                label: translation.forms.buyer.include_in_financing,
                                items: ['Yes', 'No'].map((item) => ({
                                    text: item,
                                    value: item,
                                })),
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => {
                                    const text = ['Yes', 'No'].find((item) => item === value);
                                    return text ?? 'N/A';
                                },
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'trading_history',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                label: translation.forms.buyer.trading_history,
                                fullWidth: true,
                                isRequired: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'remark',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                inputType: 'area',
                                placeHolder: 'Please enter remarks',
                                defaultValue: null,
                                label: translation.forms.buyer.remark,
                                isRequired: true,
                                fullWidth: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'incorporation',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number',
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.buyer.incorporation,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'supplier_payment_days',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number',
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.buyer.supplier_payment_days,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'reported_year',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                // defaultValue: new Date().getFullYear() as any,
                                label: translation.forms.buyer.reported_year,
                                items: years.map((item) => ({
                                    text: `${item}`,
                                    value: item,
                                })),
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => {
                                    const text = years.find((item) => item === value);
                                    return text?.toString() || 'N/A';
                                },
                            },
                            validations: [Validators.required],
                        },
                    ],
                },
                {
                    customClasses: 'flex-1 flex flex-col gap-[16px] w-[calc(50%-8px)]',
                    fields: [
                        {
                            key: 'revenue',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number',
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.buyer.revenue,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'profit',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number',
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.buyer.profit,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'total_net_worth',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                label: translation.forms.buyer.total_net_worth,
                                fullWidth: true,
                                isRequired: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'd_e_ratio',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number',
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.buyer.d_e_ratio,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'current_ratio',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number',
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.buyer.current_ratio,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'credit_exposure',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                label: translation.forms.buyer.credit_exposure,
                                fullWidth: true,
                                isRequired: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'reputation_check',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                defaultValue: 'Yes',
                                label: translation.forms.buyer.reputation_check,
                                items: ['Yes', 'No'].map((item) => ({
                                    text: item,
                                    value: item,
                                })),
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => {
                                    const text = ['Yes', 'No'].find((item) => item === value);
                                    return text ?? 'N/A';
                                },
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'verification_with_buyer',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                defaultValue: 'Yes',
                                label: translation.forms.buyer.verification_with_buyer,
                                items: ['Yes', 'No'].map((item) => ({
                                    text: item,
                                    value: item,
                                })),
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => {
                                    const text = ['Yes', 'No'].find((item) => item === value);
                                    return text ?? 'N/A';
                                },
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'note',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                inputType: 'area',
                                placeHolder: 'Please enter note',
                                defaultValue: null,
                                label: translation.forms.buyer.note,
                                isRequired: true,
                                fullWidth: true,
                            },
                            validations: [Validators.required],
                        },
                    ],
                },
            ],
        },
        ...containers,
    ];
}

const BUYER_INFORMATION_FORM_TOKEN = new InjectionToken('BUYER_INFORMATION_FORM_TOKEN');

class FSWBuyerInformationConfirmComponent {
    constructor(dialogRef) {
        this.dialogRef = dialogRef;
    }
    close(haveData = false) {
        this.dialogRef.close(haveData);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerInformationConfirmComponent, deps: [{ token: i1$7.DialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWBuyerInformationConfirmComponent, selector: "fsw-buyer-information-confirm", ngImport: i0, template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"'buttons.yes' | fswTranslate\"\n  [cancelButton]=\"'buttons.no' | fswTranslate\"\n  (confirmEvent)=\"close(true)\"\n  (cancelEvent)=\"close(false)\"\n  (closeEvent)=\"close(false)\"\n>\n  <ng-template fswModalBody>\n    <p>\n      {{\n        dialogRef.config.data['description']\n          | fswTranslate : { data: dialogRef.config.data['descriptionParams'] }\n      }}\n    </p>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerInformationConfirmComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-buyer-information-confirm', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"'buttons.yes' | fswTranslate\"\n  [cancelButton]=\"'buttons.no' | fswTranslate\"\n  (confirmEvent)=\"close(true)\"\n  (cancelEvent)=\"close(false)\"\n  (closeEvent)=\"close(false)\"\n>\n  <ng-template fswModalBody>\n    <p>\n      {{\n        dialogRef.config.data['description']\n          | fswTranslate : { data: dialogRef.config.data['descriptionParams'] }\n      }}\n    </p>\n  </ng-template>\n</fsw-modal>\n" }]
        }], ctorParameters: function () { return [{ type: i1$7.DialogRef }]; } });

const BUYER_INFORMATION_STORE_TOKEN = new InjectionToken('BUYER_INFORMATION_STORE_TOKEN');

const BUYER_HELPER_SERVICE_TOKEN = new InjectionToken('BUYER_HELPER_SERVICE_TOKEN');
class BuyerHelperService {
    constructor() {
        this.topBuyersSubject$ = new BehaviorSubject([]);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BuyerHelperService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BuyerHelperService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BuyerHelperService, decorators: [{
            type: Injectable
        }] });

const INITIAL_STATE$4 = {
    countryCode: getCountryCodeFromStorage(),
    applicationId: null,
    salesOrCredit: BuyerSalesOrCredit.SALES,
    isReadonly: false,
    buyerIds: [],
    buyers: [],
    selectedBuyer: null,
    selectedBuyerId: null,
    filteredBuyerStatus: 'ALL',
    errors: [],
};
class BuyerInformationStore extends ComponentStore {
    // constructor
    constructor() {
        super({
            ...INITIAL_STATE$4,
        });
        // inject services
        this._buyerService = inject(BUYER_SERVICE_TOKEN);
        this._buyerHelperService = inject(BUYER_HELPER_SERVICE_TOKEN);
        this._alertService = inject(FSW_ALERT_SERVICE_TOKEN);
        // all setters to state are handled with this
        this.updateState = (value) => this.patchState({
            ...value,
        });
        // GET Calls
        this.getBuyerIds = this.effect(pipe(switchMap(() => this._getBuyerIdsAsync())));
        this.getBuyers = this.effect(pipe(switchMap(() => this._getBuyersAsync())));
        // actions
        this.addBuyer = this.effect(pipe(switchMap((payload) => this._addBuyerAsync(payload)), switchMap((buyer) => this._linkBuyerToApplication(buyer.id)), switchMap(() => this._getBuyerIdsAsync()), tap(() => {
            this._alertService.success('Buyer added successfully', '', {
                duration: 2000,
            });
        })));
        this.updateBuyerSales = this.effect(pipe(switchMap(({ buyer_id, payload }) => this._updateBuyerSalesAsync(buyer_id, payload)), switchMap(() => this._getBuyersAsync()), tap(() => {
            this._alertService.success('Buyer sales updated successfully', '', {
                duration: 2000,
            });
        })));
        this.updateBuyerCredit = this.effect(pipe(switchMap(({ buyer_id, payload }) => this._updateBuyerCreditAsync(buyer_id, payload)), switchMap(() => this._getBuyersAsync()), tap(() => {
            this._alertService.success('Buyer credit updated successfully', '', {
                duration: 2000,
            });
        })));
        this.updateBuyerStatus = this.effect(pipe(switchMap(({ buyer_id, status }) => this._updateBuyerStatusAsync(buyer_id, status)), switchMap(() => this._getBuyersAsync()), tap(() => {
            this._alertService.success('Buyer status updated successfully', '', {
                duration: 2000,
            });
        })));
        this.deleteBuyer = this.effect(pipe(switchMap(({ buyer_id }) => this._deleteBuyerAsync(buyer_id)), switchMap(() => this._unlinkBuyerFromApplicationAsync()), switchMap(() => this._getBuyerIdsAsync()), tap(() => {
            this._alertService.success('Buyer deleted successfully', '', {
                duration: 2000,
            });
            this.updateState({
                selectedBuyerId: null,
                selectedBuyer: null,
            });
        })));
    }
    // private async calls
    // GET Calls
    _getBuyerIdsAsync() {
        if (!isStringValid(this.state().applicationId)) {
            throw new Error('[_getBuyerIdsAsync] Application ID is not valid');
        }
        return this._buyerService
            .getAllBuyerIdsFromApplication(this.state().applicationId)
            .pipe(tap((buyerIds) => {
            if (!buyerIds) {
                this.updateState({
                    buyerIds: [],
                });
                return;
            }
            this.updateState({
                buyerIds,
            });
        }), catchError((err) => {
            console.error('_getBuyerIdsAsync', err);
            return EMPTY;
        }));
    }
    _getBuyersAsync() {
        if (!isStringValid(this.state().applicationId)) {
            throw new Error('[_getBuyersAsync] Application ID is not valid');
        }
        return this._buyerService.getAllBuyers(this.state().buyerIds).pipe(tap((buyers) => {
            this.updateState({
                buyers,
            });
            this._buyerHelperService.topBuyersSubject$.next(buyers.filter((buyer) => buyer.status === BuyerStatus.TOP));
        }), catchError((err) => {
            console.error('_getBuyersAsync', err);
            return EMPTY;
        }));
    }
    // POST/PUT/PATCH calls
    _addBuyerAsync(payload) {
        if (!isObjectValid(payload)) {
            throw new Error('[_addBuyerAsync] Payload is not valid');
        }
        return this._buyerService.addBuyer(payload).pipe(catchError((err) => {
            console.error(`[_addBuyerAsync]`, err);
            return EMPTY;
        }));
    }
    _linkBuyerToApplication(buyer_id) {
        if (!isStringValid(buyer_id)) {
            throw new Error('[_linkBuyerToApplication] Buyer ID is not valid');
        }
        if (!isStringValid(this.state().applicationId)) {
            throw new Error('[_linkBuyerToApplication] Application ID is not valid');
        }
        return this._buyerService
            .linkBuyerIdToApplication(this.state().applicationId, buyer_id)
            .pipe(catchError((err) => {
            console.error(`[_linkBuyerToApplication]`, err);
            return EMPTY;
        }));
    }
    _updateBuyerSalesAsync(buyer_id, payload) {
        if (!isStringValid(buyer_id)) {
            throw new Error('[_updateBuyerSalesAsync] Buyer ID is not valid');
        }
        if (!isObjectValid(payload)) {
            throw new Error('[_updateBuyerSalesAsync] Payload is not valid');
        }
        return this._buyerService.updateBuyerSales(buyer_id, payload).pipe(catchError((err) => {
            console.error(`[_updateBuyerSalesAsync]`, err);
            return EMPTY;
        }));
    }
    _updateBuyerCreditAsync(buyer_id, payload) {
        if (!isStringValid(buyer_id)) {
            throw new Error('[_updateBuyerCreditAsync] Buyer ID is not valid');
        }
        if (!isObjectValid(payload)) {
            throw new Error('[_updateBuyerCreditAsync] Payload is not valid');
        }
        return this._buyerService.updateBuyerCredit(buyer_id, payload).pipe(catchError((err) => {
            console.error(`[_updateBuyerCreditAsync]`, err);
            return EMPTY;
        }));
    }
    _updateBuyerStatusAsync(buyer_id, status) {
        if (!isStringValid(buyer_id)) {
            throw new Error('[_updateBuyerStatusAsync] Buyer ID is not valid');
        }
        return this._buyerService.updateBuyerStatus(buyer_id, status).pipe(catchError((err) => {
            console.error(`[_updateBuyerStatusAsync]`, err);
            return EMPTY;
        }));
    }
    _deleteBuyerAsync(buyer_id) {
        if (!isStringValid(buyer_id)) {
            throw new Error('[_deleteBuyerAsync] Buyer ID is not valid');
        }
        return this._buyerService.deleteBuyer(buyer_id).pipe(catchError((err) => {
            console.error(`[_deleteBuyerAsync]`, err);
            return EMPTY;
        }));
    }
    _unlinkBuyerFromApplicationAsync() {
        const buyer_id = this.state().selectedBuyerId;
        if (!isStringValid(buyer_id)) {
            throw new Error('[_unlinkBuyerFromApplicationAsync] Buyer ID is not valid');
        }
        if (!isStringValid(this.state().applicationId)) {
            throw new Error('[_unlinkBuyerFromApplicationAsync] Application ID is not valid');
        }
        return this._buyerService
            .unlinkBuyerIdFromApplication(this.state().applicationId, buyer_id)
            .pipe(catchError((err) => {
            console.error(`[_unlinkBuyerFromApplicationAsync]`, err);
            return EMPTY;
        }));
    }
    clearCache() {
        this.updateState({
            ...INITIAL_STATE$4,
        });
    }
}

class FSWBuyerInformationSaveComponent {
    constructor() {
        this._alertService = inject(FSW_ALERT_SERVICE_TOKEN);
        this._dialog = inject(Dialog);
        this._injector = inject(Injector);
        this._componentStore = inject(BUYER_INFORMATION_STORE_TOKEN);
        this.salesOrCredit$ = this._componentStore.select((state) => state.salesOrCredit);
        this.dialogRef = inject(DialogRef);
    }
    get data() {
        return this.dialogRef.config.data;
    }
    get translationPrefix() {
        // const { type } = this.data;
        return `modals.buyer`;
    }
    get translationTitle() {
        const { method } = this.data;
        return `${this.translationPrefix}.${method === 'POST' ? 'new' : 'edit'}`;
    }
    get translationDelete() {
        // const { type } = this.data;
        return `buttons.delete_buyer`;
    }
    close(haveData = false) {
        this.dialogRef.close(haveData);
    }
    submit() {
        const { builder, method } = this.data;
        const form = builder.groupConfig.form;
        if (form.invalid) {
            form.markAllAsTouched();
            this._alertService.warning('Invalid Information', 'Please fill in all mandatory fields.', {
                duration: 3000,
            });
            return;
        }
        this._dialog
            .open(FSWBuyerInformationConfirmComponent, {
            data: {
                title: `${this.translationPrefix}.confirm_${method === 'POST' ? 'add' : 'edit'}_title`,
                titleParams: {},
                description: `${this.translationPrefix}.confirm_${method === 'POST' ? 'add' : 'edit'}`,
                descriptionParams: {},
            },
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((accept) => {
            if (accept) {
                const payload = form.getRawValue();
                delete payload.status;
                if (method === 'POST') {
                    this._componentStore.addBuyer({
                        name: payload.name,
                        credit_term: payload.credit_term,
                        sales_thb_month: payload.sales_thb_month,
                        method_of_payment: payload.method_of_payment,
                        include_in_financing: payload.include_in_financing,
                        trading_history: payload.trading_history,
                        remark: payload.remark,
                    });
                    this.close(true);
                    return;
                }
                else if (method === 'PUT') {
                    this._componentStore.state().salesOrCredit === 'SALES'
                        ? this._componentStore.updateBuyerSales({
                            buyer_id: form.getRawValue().id,
                            payload,
                        })
                        : this._componentStore.updateBuyerCredit({
                            buyer_id: form.getRawValue().id,
                            payload,
                        });
                    this.close(true);
                    return;
                }
            }
        }))
            .subscribe();
    }
    edit() {
        this.data.isReadonly$.next(false);
    }
    delete() {
        this.data.delete(this.data.builder.groupConfig.form.getRawValue().id, this.data.type, () => {
            this.close();
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerInformationSaveComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWBuyerInformationSaveComponent, selector: "fsw-buyer-information-save", ngImport: i0, template: "<fsw-modal\n  [size]=\"'l'\"\n  [title]=\"translationTitle | fswTranslate\"\n  [bodyCustomClasses]=\"'max-h-[calc(90vh-138px)] overflow-y-auto'\"\n  (closeEvent)=\"close()\"\n>\n  <ng-template fswModalBody>\n    <form [formGroup]=\"data.builder.groupConfig.form\">\n      <fsw-dynamic-builder [builder]=\"data.builder\"></fsw-dynamic-builder>\n    </form>\n  </ng-template>\n  <ng-template fswModalFooter>\n    <section class=\"flex justify-between w-full items-center\">\n      <aside>\n        <button\n          *ngIf=\"data.method === 'PUT' && (salesOrCredit$ | async) === 'SALES'\"\n          fswButton\n          class=\"!text-red-500\"\n          [appearance]=\"'secondary'\"\n          (click)=\"delete()\"\n        >\n          {{ translationDelete | fswTranslate }}\n        </button>\n      </aside>\n      <main class=\"flex gap-[16px] items-center\">\n        <button fswButton [appearance]=\"'secondary'\" (click)=\"close()\">\n          {{ 'buttons.cancel' | fswTranslate }}\n        </button>\n        <ng-container *ngIf=\"!data?.isReadonly\">\n          <button\n            (click)=\"edit()\"\n            fswButton\n            *ngIf=\"data.isReadonly$ | async; else saveChangesTemplate\"\n          >\n            {{ 'buttons.edit_details' | fswTranslate }}\n          </button>\n          <ng-template #saveChangesTemplate>\n            <button fswButton (click)=\"submit()\">\n              {{ 'buttons.save_changes' | fswTranslate }}\n            </button>\n          </ng-template>\n        </ng-container>\n      </main>\n    </section>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "directive", type: i1$4.FSWModalFooterDirective, selector: "ng-template[fswModalFooter]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerInformationSaveComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-buyer-information-save', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal\n  [size]=\"'l'\"\n  [title]=\"translationTitle | fswTranslate\"\n  [bodyCustomClasses]=\"'max-h-[calc(90vh-138px)] overflow-y-auto'\"\n  (closeEvent)=\"close()\"\n>\n  <ng-template fswModalBody>\n    <form [formGroup]=\"data.builder.groupConfig.form\">\n      <fsw-dynamic-builder [builder]=\"data.builder\"></fsw-dynamic-builder>\n    </form>\n  </ng-template>\n  <ng-template fswModalFooter>\n    <section class=\"flex justify-between w-full items-center\">\n      <aside>\n        <button\n          *ngIf=\"data.method === 'PUT' && (salesOrCredit$ | async) === 'SALES'\"\n          fswButton\n          class=\"!text-red-500\"\n          [appearance]=\"'secondary'\"\n          (click)=\"delete()\"\n        >\n          {{ translationDelete | fswTranslate }}\n        </button>\n      </aside>\n      <main class=\"flex gap-[16px] items-center\">\n        <button fswButton [appearance]=\"'secondary'\" (click)=\"close()\">\n          {{ 'buttons.cancel' | fswTranslate }}\n        </button>\n        <ng-container *ngIf=\"!data?.isReadonly\">\n          <button\n            (click)=\"edit()\"\n            fswButton\n            *ngIf=\"data.isReadonly$ | async; else saveChangesTemplate\"\n          >\n            {{ 'buttons.edit_details' | fswTranslate }}\n          </button>\n          <ng-template #saveChangesTemplate>\n            <button fswButton (click)=\"submit()\">\n              {{ 'buttons.save_changes' | fswTranslate }}\n            </button>\n          </ng-template>\n        </ng-container>\n      </main>\n    </section>\n  </ng-template>\n</fsw-modal>\n" }]
        }] });

class FSWBuyerInfoGridItemDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerInfoGridItemDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWBuyerInfoGridItemDirective, selector: "ng-template[fswBuyerInfoGridItem]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerInfoGridItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswBuyerInfoGridItem]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

class FSWBuyerInfoGridComponent {
    constructor() {
        this.itemDirective = null;
        this.rowClick = new EventEmitter();
        this.addBuyerClick = new EventEmitter();
        this.isReadonly = false;
        this.rows = [];
        this.itemsPerPage = 10;
        this.currentPage = 1;
    }
    get columnKeys() {
        return Object.keys(this.columns);
    }
    get rowsToDisplay() {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.rows.slice(start, end);
    }
    transformToHeaderClasses(width) {
        return width ? `whitespace-normal w-[${width}] block` : '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerInfoGridComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWBuyerInfoGridComponent, selector: "fsw-buyer-info-grid", inputs: { columns: "columns", isReadonly: "isReadonly", rows: "rows" }, outputs: { rowClick: "rowClick", addBuyerClick: "addBuyerClick" }, queries: [{ propertyName: "itemDirective", first: true, predicate: FSWBuyerInfoGridItemDirective, descendants: true }], ngImport: i0, template: "<table class=\"fsw-table w-full !table-auto\">\n  <thead>\n    <tr>\n      <ng-container *ngFor=\"let key of columnKeys\">\n        <th [class]=\"transformToHeaderClasses(columns[key][1])\">\n          {{ columns && columns[key] && columns[key][0] | fswTranslate }}\n        </th>\n      </ng-container>\n    </tr>\n  </thead>\n  <tbody>\n    <ng-container *ngIf=\"rowsToDisplay?.length; else noData\">\n      <tr *ngFor=\"let row of rowsToDisplay\" (click)=\"rowClick.emit(row)\">\n        <ng-container *ngIf=\"!itemDirective; else existedTemplate\">\n          <ng-container *ngFor=\"let key of columnKeys\">\n            <td>{{ row[key] }}</td>\n          </ng-container>\n        </ng-container>\n        <ng-template #existedTemplate>\n          <ng-container\n            *ngTemplateOutlet=\"$any(itemDirective?.templateRef); context: { $implicit: row }\"\n          ></ng-container>\n        </ng-template>\n      </tr>\n    </ng-container>\n    <ng-template #noData>\n      <tr>\n        <td [colSpan]=\"10\">\n          <main class=\"w-full h-full flex flex-col items-center justify-center gap-6 py-10\">\n            <p>{{ 'empty.buyers' | fswTranslate }}</p>\n            <button\n              fswButton\n              *ngIf=\"!isReadonly\"\n              [appearance]=\"'secondary-elevate'\"\n              [size]=\"'s'\"\n              (click)=\"addBuyerClick.emit()\"\n            >\n              {{ 'buttons.add_buyer' | fswTranslate }}\n            </button>\n          </main>\n        </td>\n      </tr>\n    </ng-template>\n  </tbody>\n  <tfoot></tfoot>\n</table>\n", dependencies: [{ kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerInfoGridComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-buyer-info-grid', changeDetection: ChangeDetectionStrategy.OnPush, template: "<table class=\"fsw-table w-full !table-auto\">\n  <thead>\n    <tr>\n      <ng-container *ngFor=\"let key of columnKeys\">\n        <th [class]=\"transformToHeaderClasses(columns[key][1])\">\n          {{ columns && columns[key] && columns[key][0] | fswTranslate }}\n        </th>\n      </ng-container>\n    </tr>\n  </thead>\n  <tbody>\n    <ng-container *ngIf=\"rowsToDisplay?.length; else noData\">\n      <tr *ngFor=\"let row of rowsToDisplay\" (click)=\"rowClick.emit(row)\">\n        <ng-container *ngIf=\"!itemDirective; else existedTemplate\">\n          <ng-container *ngFor=\"let key of columnKeys\">\n            <td>{{ row[key] }}</td>\n          </ng-container>\n        </ng-container>\n        <ng-template #existedTemplate>\n          <ng-container\n            *ngTemplateOutlet=\"$any(itemDirective?.templateRef); context: { $implicit: row }\"\n          ></ng-container>\n        </ng-template>\n      </tr>\n    </ng-container>\n    <ng-template #noData>\n      <tr>\n        <td [colSpan]=\"10\">\n          <main class=\"w-full h-full flex flex-col items-center justify-center gap-6 py-10\">\n            <p>{{ 'empty.buyers' | fswTranslate }}</p>\n            <button\n              fswButton\n              *ngIf=\"!isReadonly\"\n              [appearance]=\"'secondary-elevate'\"\n              [size]=\"'s'\"\n              (click)=\"addBuyerClick.emit()\"\n            >\n              {{ 'buttons.add_buyer' | fswTranslate }}\n            </button>\n          </main>\n        </td>\n      </tr>\n    </ng-template>\n  </tbody>\n  <tfoot></tfoot>\n</table>\n" }]
        }], propDecorators: { itemDirective: [{
                type: ContentChild,
                args: [FSWBuyerInfoGridItemDirective]
            }], rowClick: [{
                type: Output
            }], addBuyerClick: [{
                type: Output
            }], columns: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], rows: [{
                type: Input
            }] } });

class FSWBuyerInfoHeaderComponent {
    constructor() {
        this.buyerStatusClick = new EventEmitter();
        this.addBuyerButtonClick = new EventEmitter();
        this.disableAddBuyerButton = false;
        this.isReadonly = false;
        this.radioControl = new UntypedFormControl('ALL');
    }
    set salesOrCredit(salesOrCredit) {
        this.disableAddBuyerButton = salesOrCredit === BuyerSalesOrCredit.CREDIT;
    }
    ngOnInit() {
        this.radioControl.valueChanges.subscribe((value) => {
            this.buyerStatusClick.emit(value);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerInfoHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWBuyerInfoHeaderComponent, selector: "fsw-buyer-info-header", inputs: { salesOrCredit: "salesOrCredit", isReadonly: "isReadonly" }, outputs: { buyerStatusClick: "buyerStatusClick", addBuyerButtonClick: "addBuyerButtonClick" }, ngImport: i0, template: "<header class=\"buyer-info-header\">\n  <aside>\n    <h6>Buyer Information</h6>\n  </aside>\n  <main>\n    <fsw-radio-group [formControl]=\"radioControl\" [direction]=\"'row'\" [gap]=\"'12px'\">\n      <fsw-radio [label]=\"'All'\" [value]=\"'ALL'\"></fsw-radio>\n      <fsw-radio [label]=\"'Top'\" [value]=\"'TOP'\"></fsw-radio>\n      <fsw-radio [label]=\"'Normal'\" [value]=\"'NORMAL'\"></fsw-radio>\n    </fsw-radio-group>\n    <button\n      *ngIf=\"!isReadonly\"\n      [disabled]=\"disableAddBuyerButton\"\n      (click)=\"!disableAddBuyerButton && addBuyerButtonClick.emit($event)\"\n      fswButton\n      appearance=\"secondary\"\n    >\n      {{ 'buttons.add_buyer' | fswTranslate }}\n    </button>\n  </main>\n</header>\n", styles: [":host{display:contents}:host .buyer-info-header{display:flex;width:100%;align-items:center;justify-content:space-between}:host .buyer-info-header>main{display:flex;align-items:center;gap:1.25rem}\n"], dependencies: [{ kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i1$4.FSWRadioComponent, selector: "fsw-radio" }, { kind: "component", type: i1$4.FSWRadioGroupComponent, selector: "fsw-radio-group" }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerInfoHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-buyer-info-header', changeDetection: ChangeDetectionStrategy.OnPush, template: "<header class=\"buyer-info-header\">\n  <aside>\n    <h6>Buyer Information</h6>\n  </aside>\n  <main>\n    <fsw-radio-group [formControl]=\"radioControl\" [direction]=\"'row'\" [gap]=\"'12px'\">\n      <fsw-radio [label]=\"'All'\" [value]=\"'ALL'\"></fsw-radio>\n      <fsw-radio [label]=\"'Top'\" [value]=\"'TOP'\"></fsw-radio>\n      <fsw-radio [label]=\"'Normal'\" [value]=\"'NORMAL'\"></fsw-radio>\n    </fsw-radio-group>\n    <button\n      *ngIf=\"!isReadonly\"\n      [disabled]=\"disableAddBuyerButton\"\n      (click)=\"!disableAddBuyerButton && addBuyerButtonClick.emit($event)\"\n      fswButton\n      appearance=\"secondary\"\n    >\n      {{ 'buttons.add_buyer' | fswTranslate }}\n    </button>\n  </main>\n</header>\n", styles: [":host{display:contents}:host .buyer-info-header{display:flex;width:100%;align-items:center;justify-content:space-between}:host .buyer-info-header>main{display:flex;align-items:center;gap:1.25rem}\n"] }]
        }], propDecorators: { buyerStatusClick: [{
                type: Output
            }], addBuyerButtonClick: [{
                type: Output
            }], salesOrCredit: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class FSWBuyerInfoGridPipe {
    transform(value) {
        const { id, name, credit_term, sales_thb_month, method_of_payment, include_in_financing, trading_history, remark, status, incorporation, supplier_payment_days, reported_year, revenue, profit, total_net_worth, d_e_ratio, current_ratio, credit_exposure, reputation_check, verification_with_buyer, note, } = value;
        return {
            id,
            name,
            credit_term,
            sales_thb_month,
            method_of_payment,
            include_in_financing,
            trading_history,
            remark,
            status,
            incorporation,
            supplier_payment_days,
            reported_year,
            revenue,
            profit,
            total_net_worth,
            d_e_ratio,
            current_ratio,
            credit_exposure,
            reputation_check,
            verification_with_buyer,
            note,
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerInfoGridPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerInfoGridPipe, name: "fswBuyerInfoGrid" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerInfoGridPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fswBuyerInfoGrid',
                }]
        }] });

class FSWBuyerInformationComponent {
    constructor() {
        this._destroySubject$ = new Subject();
        this._componentStore = inject(BUYER_INFORMATION_STORE_TOKEN);
        this._form = inject(BUYER_INFORMATION_FORM_TOKEN);
        this._dialog = inject(Dialog);
        this._injector = inject(Injector);
        this.salesOrCredit$ = this._componentStore.select((state) => state.salesOrCredit);
        this.buyers$ = this._componentStore.select((state) => state.buyers);
        this.selectedBuyer$ = this._componentStore.select((state) => state.selectedBuyer);
        this.columns$ = this._componentStore.select((state) => {
            return state.salesOrCredit === BuyerSalesOrCredit.SALES
                ? this.columnsSales
                : this.columnsCredit;
        });
        this.isReadonly$ = this._componentStore.select((state) => state.isReadonly);
        this.filteredBuyers$ = new BehaviorSubject([]);
        this.columnsSales = [
            ['name', '100px'],
            ['credit_term', ''],
            ['sales_thb_month', '50px'],
            ['method_of_payment', ''],
            ['include_in_financing', ''],
            ['trading_history', ''],
            ['remark', ''],
            ['status', ''],
        ].reduce((acc, [key, classes]) => ({
            ...acc,
            [key]: [`tables.buyerInfo.columns.${key}`, classes],
        }), {});
        this.columnsCredit = [
            ['name', '100px'],
            ['credit_term', ''],
            ['sales_thb_month', '50px'],
            ['method_of_payment', ''],
            ['include_in_financing', ''],
            ['trading_history', ''],
            ['remark', ''],
            ['status', ''],
            ['action', ''],
            ['incorporation', ''],
            ['supplier_payment_days', ''],
            ['reported_year', ''],
            ['revenue', ''],
            ['profit', ''],
            ['total_net_worth', ''],
            ['d_e_ratio', ''],
            ['current_ratio', ''],
            ['credit_exposure', ''],
            ['reputation_check', ''],
            ['verification_with_buyer', ''],
            ['note', '100px'],
        ].reduce((acc, [key, classes]) => ({
            ...acc,
            [key]: [`tables.buyerInfo.columns.${key}`, classes],
        }), {});
    }
    set applicationId(applicationId) {
        this._componentStore.updateState({
            applicationId,
        });
    }
    set salesOrCredit(salesOrCredit) {
        this._componentStore.updateState({
            salesOrCredit,
        });
    }
    set isReadonly(isReadonly) {
        this._componentStore.updateState({
            isReadonly,
        });
    }
    ngOnInit() {
        this._componentStore.init();
        this.buyers$.pipe(takeUntil(this._destroySubject$)).subscribe((buyers) => {
            if (this._componentStore.state().filteredBuyerStatus === 'ALL') {
                this.filteredBuyers$.next(buyers);
                return;
            }
            this.filteredBuyers$.next(buyers.filter((buyer) => buyer.status === this._componentStore.state().filteredBuyerStatus));
        });
    }
    ngOnDestroy() {
        this._destroySubject$.next();
        this._destroySubject$.complete();
    }
    addBuyer(item) {
        const type = this._componentStore.state().salesOrCredit;
        const isReadonly$ = new BehaviorSubject(!!item);
        const builder = this._form(new UntypedFormGroup({}), type, item ? 'PUT' : 'POST', this._componentStore.state(), isReadonly$);
        if (item) {
            builder.groupConfig.form.patchValue({
                ...(item || {}),
            });
        }
        this._dialog
            .open(FSWBuyerInformationSaveComponent, {
            data: {
                builder,
                isReadonly$,
                type,
                method: item ? 'PUT' : 'POST',
                isReadonly: this._componentStore.state().isReadonly,
                delete: (id, type, cb) => this.delete(id, type, cb),
            },
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((haveData) => {
            if (!haveData) {
                return;
            }
        }))
            .subscribe();
    }
    delete(buyer_id, type, cb) {
        const translationPrefix = `modals.buyer`;
        this._dialog
            .open(FSWBuyerInformationConfirmComponent, {
            data: {
                title: `${translationPrefix}.confirm_delete_title`,
                titleParams: {},
                description: `${translationPrefix}.confirm_delete`,
                descriptionParams: {},
            },
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((accept) => {
            if (accept) {
                this._componentStore.updateState({
                    selectedBuyerId: buyer_id,
                });
                this._componentStore.deleteBuyer({ buyer_id });
                if (cb) {
                    cb();
                }
            }
        }))
            .subscribe();
    }
    select(item) {
        this.addBuyer(item);
    }
    changeStatus(item) {
        this._componentStore.updateBuyerStatus({
            buyer_id: item.id,
            status: item.status === BuyerStatus.NORMAL ? 'TOP' : 'NORMAL',
        });
    }
    filterBuyersByStatus(status) {
        this._componentStore.updateState({
            filteredBuyerStatus: status,
        });
        if (this._componentStore.state().filteredBuyerStatus === 'ALL') {
            this.filteredBuyers$.next(this._componentStore.state().buyers);
            return;
        }
        this.filteredBuyers$.next(this._componentStore.state().buyers.filter((buyer) => buyer.status === status));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerInformationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWBuyerInformationComponent, selector: "fsw-buyer-information", inputs: { applicationId: "applicationId", salesOrCredit: "salesOrCredit", isReadonly: "isReadonly" }, ngImport: i0, template: "<section class=\"flex flex-col gap-[8px] w-full\">\n  <fsw-buyer-info-header\n    [salesOrCredit]=\"salesOrCredit$ | async\"\n    [isReadonly]=\"(isReadonly$ | async) || false\"\n    (addBuyerButtonClick)=\"addBuyer()\"\n    (buyerStatusClick)=\"filterBuyersByStatus($event)\"\n  ></fsw-buyer-info-header>\n\n  <ng-container>\n    <fsw-buyer-info-grid\n      [columns]=\"columns$ | async\"\n      [rows]=\"$any(filteredBuyers$ | async)\"\n      [isReadonly]=\"(isReadonly$ | async) || false\"\n      (addBuyerClick)=\"addBuyer()\"\n      class=\"overflow-x-auto\"\n    >\n      <ng-template fswBuyerInfoGridItem let-row>\n        <ng-container *ngIf=\"row | fswBuyerInfoGrid as item\">\n          <td class=\"hover:bg-blue-100 hover:cursor-pointer\" (click)=\"select(row)\">\n            <p class=\"whitespace-normal\">{{ item.name }}</p>\n          </td>\n          <td>{{ item.credit_term }}</td>\n          <td>{{ item.sales_thb_month }}</td>\n          <td>{{ item.method_of_payment }}</td>\n          <td>{{ item.include_in_financing }}</td>\n          <td>{{ item.trading_history }}</td>\n          <td>{{ item.remark }}</td>\n          <td [ngClass]=\"{ 'bg-green-100': item.status === 'TOP' }\">{{ item.status }}</td>\n          <ng-container *ngIf=\"(salesOrCredit$ | async) === 'CREDIT'\">\n            <td *ngIf=\"!(isReadonly$ | async)\">\n              <button (click)=\"changeStatus(item)\" fswButton appearance=\"secondary\">\n                {{ 'buttons.change_status' | fswTranslate }}\n              </button>\n            </td>\n            <td>{{ item.incorporation }}</td>\n            <td>{{ item.supplier_payment_days }}</td>\n            <td>{{ item.reported_year }}</td>\n            <td>{{ item.revenue }}</td>\n            <td>{{ item.profit }}</td>\n            <td>{{ item.total_net_worth }}</td>\n            <td>{{ item.d_e_ratio }}</td>\n            <td>{{ item.current_ratio }}</td>\n            <td>{{ item.credit_exposure }}</td>\n            <td>{{ item.reputation_check }}</td>\n            <td>{{ item.verification_with_buyer }}</td>\n            <td>\n              <p class=\"whitespace-normal\">{{ item.note }}</p>\n            </td>\n          </ng-container>\n        </ng-container>\n      </ng-template>\n    </fsw-buyer-info-grid>\n  </ng-container>\n</section>\n", dependencies: [{ kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: FSWBuyerInfoGridComponent, selector: "fsw-buyer-info-grid", inputs: ["columns", "isReadonly", "rows"], outputs: ["rowClick", "addBuyerClick"] }, { kind: "component", type: FSWBuyerInfoHeaderComponent, selector: "fsw-buyer-info-header", inputs: ["salesOrCredit", "isReadonly"], outputs: ["buyerStatusClick", "addBuyerButtonClick"] }, { kind: "directive", type: FSWBuyerInfoGridItemDirective, selector: "ng-template[fswBuyerInfoGridItem]" }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "pipe", type: FSWBuyerInfoGridPipe, name: "fswBuyerInfoGrid" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerInformationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-buyer-information', changeDetection: ChangeDetectionStrategy.OnPush, template: "<section class=\"flex flex-col gap-[8px] w-full\">\n  <fsw-buyer-info-header\n    [salesOrCredit]=\"salesOrCredit$ | async\"\n    [isReadonly]=\"(isReadonly$ | async) || false\"\n    (addBuyerButtonClick)=\"addBuyer()\"\n    (buyerStatusClick)=\"filterBuyersByStatus($event)\"\n  ></fsw-buyer-info-header>\n\n  <ng-container>\n    <fsw-buyer-info-grid\n      [columns]=\"columns$ | async\"\n      [rows]=\"$any(filteredBuyers$ | async)\"\n      [isReadonly]=\"(isReadonly$ | async) || false\"\n      (addBuyerClick)=\"addBuyer()\"\n      class=\"overflow-x-auto\"\n    >\n      <ng-template fswBuyerInfoGridItem let-row>\n        <ng-container *ngIf=\"row | fswBuyerInfoGrid as item\">\n          <td class=\"hover:bg-blue-100 hover:cursor-pointer\" (click)=\"select(row)\">\n            <p class=\"whitespace-normal\">{{ item.name }}</p>\n          </td>\n          <td>{{ item.credit_term }}</td>\n          <td>{{ item.sales_thb_month }}</td>\n          <td>{{ item.method_of_payment }}</td>\n          <td>{{ item.include_in_financing }}</td>\n          <td>{{ item.trading_history }}</td>\n          <td>{{ item.remark }}</td>\n          <td [ngClass]=\"{ 'bg-green-100': item.status === 'TOP' }\">{{ item.status }}</td>\n          <ng-container *ngIf=\"(salesOrCredit$ | async) === 'CREDIT'\">\n            <td *ngIf=\"!(isReadonly$ | async)\">\n              <button (click)=\"changeStatus(item)\" fswButton appearance=\"secondary\">\n                {{ 'buttons.change_status' | fswTranslate }}\n              </button>\n            </td>\n            <td>{{ item.incorporation }}</td>\n            <td>{{ item.supplier_payment_days }}</td>\n            <td>{{ item.reported_year }}</td>\n            <td>{{ item.revenue }}</td>\n            <td>{{ item.profit }}</td>\n            <td>{{ item.total_net_worth }}</td>\n            <td>{{ item.d_e_ratio }}</td>\n            <td>{{ item.current_ratio }}</td>\n            <td>{{ item.credit_exposure }}</td>\n            <td>{{ item.reputation_check }}</td>\n            <td>{{ item.verification_with_buyer }}</td>\n            <td>\n              <p class=\"whitespace-normal\">{{ item.note }}</p>\n            </td>\n          </ng-container>\n        </ng-container>\n      </ng-template>\n    </fsw-buyer-info-grid>\n  </ng-container>\n</section>\n" }]
        }], propDecorators: { applicationId: [{
                type: Input
            }], salesOrCredit: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class THBuyerInformationStore extends BuyerInformationStore {
    constructor() {
        super();
    }
    init() {
        this.select((state) => state.applicationId)
            .pipe(filter((applicationId) => applicationId !== null), tap(() => {
            this.getBuyerIds();
        }), take(1))
            .subscribe();
        this.select((state) => state.buyerIds)
            .pipe(tap((buyerIds) => {
            if (buyerIds?.length > 0) {
                this.getBuyers();
            }
            else {
                this.updateState({
                    buyers: [],
                });
            }
        })
        // take(1)
        )
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: THBuyerInformationStore, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: THBuyerInformationStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: THBuyerInformationStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

const BUYER_INFORMATION_TH_PROVIDERS = [
    {
        provide: BUYER_INFORMATION_FORM_TOKEN,
        useValue: THBuyerInformationForm,
    },
    {
        provide: BUYER_INFORMATION_STORE_TOKEN,
        useClass: THBuyerInformationStore,
        deps: [BUYER_SERVICE_TOKEN, BUYER_HELPER_SERVICE_TOKEN, FSW_ALERT_SERVICE_TOKEN],
    },
];

const BUYER_INFORMATION_PROVIDERS = {
    default: BUYER_INFORMATION_TH_PROVIDERS,
    [CountryCode.TH]: BUYER_INFORMATION_TH_PROVIDERS,
};
const buyerInformationLoadProviders = (countryCode) => [
    fswTranslateScope('buyer-information'),
    ...getCustomProviders(BUYER_INFORMATION_PROVIDERS, BUYER_INFORMATION_TH_PROVIDERS, countryCode),
];

class FSWBuyerInformationDirective {
    constructor(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
        this.applicationId = null;
        this.salesOrCredit = BuyerSalesOrCredit.SALES;
        this.isReadonly = false;
    }
    ngOnChanges() {
        this._viewContainerRef.clear();
        const ref = this._viewContainerRef.createComponent(FSWBuyerInformationComponent, {
            injector: Injector.create({
                parent: this._viewContainerRef.injector,
                providers: [...buyerInformationLoadProviders(getCountryCodeFromStorage())],
            }),
        });
        const instance = ref.instance;
        instance.applicationId = this.applicationId;
        instance.salesOrCredit = this.salesOrCredit;
        instance.isReadonly = this.isReadonly;
        ref.changeDetectorRef.detectChanges();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerInformationDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWBuyerInformationDirective, selector: "[fswBuyerInformation]", inputs: { applicationId: "applicationId", salesOrCredit: "salesOrCredit", isReadonly: "isReadonly" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerInformationDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswBuyerInformation]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; }, propDecorators: { applicationId: [{
                type: Input
            }], salesOrCredit: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class FSWBuyerInformationModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerInformationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerInformationModule, declarations: [FSWBuyerInformationDirective,
            FSWBuyerInformationComponent,
            FSWBuyerInfoGridComponent,
            FSWBuyerInfoHeaderComponent,
            FSWBuyerInformationSaveComponent,
            FSWBuyerInformationConfirmComponent,
            FSWBuyerInfoGridPipe,
            FSWBuyerInfoGridItemDirective], imports: [JsonPipe, i1$4.FSWTranslateModule, FSWButtonModule,
            NgIf,
            NgClass,
            FSWSwitchModule,
            FormsModule,
            FSWAlertModule,
            FSWModalModule$1,
            NgSwitch,
            AsyncPipe,
            NgSwitchCase,
            NgSwitchDefault,
            FSWDynamicBuilderModule,
            ReactiveFormsModule,
            FSWIconModule,
            FSWFieldModule,
            FSWSelectModule,
            NgForOf,
            NgTemplateOutlet,
            FSWPaginationModule$1,
            BuyerServiceModule,
            FSWRadioModule], exports: [FSWBuyerInformationDirective,
            FSWBuyerInformationComponent,
            FSWBuyerInfoGridComponent,
            FSWBuyerInfoHeaderComponent,
            FSWBuyerInformationSaveComponent,
            FSWBuyerInformationConfirmComponent,
            FSWBuyerInfoGridPipe,
            FSWBuyerInfoGridItemDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerInformationModule, imports: [FSWTranslateModule.forFeature({
                scope: 'buyer-information',
                defaultKey: CountryCode.TH,
                data: BUYER_INFORMATION_TRANSLATION_LOADER,
            }),
            FSWButtonModule,
            FSWSwitchModule,
            FormsModule,
            FSWAlertModule,
            FSWModalModule$1,
            FSWDynamicBuilderModule,
            ReactiveFormsModule,
            FSWIconModule,
            FSWFieldModule,
            FSWSelectModule,
            FSWPaginationModule$1,
            BuyerServiceModule,
            FSWRadioModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerInformationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FSWBuyerInformationDirective,
                        FSWBuyerInformationComponent,
                        FSWBuyerInfoGridComponent,
                        FSWBuyerInfoHeaderComponent,
                        FSWBuyerInformationSaveComponent,
                        FSWBuyerInformationConfirmComponent,
                        FSWBuyerInfoGridPipe,
                        FSWBuyerInfoGridItemDirective,
                    ],
                    exports: [
                        FSWBuyerInformationDirective,
                        FSWBuyerInformationComponent,
                        FSWBuyerInfoGridComponent,
                        FSWBuyerInfoHeaderComponent,
                        FSWBuyerInformationSaveComponent,
                        FSWBuyerInformationConfirmComponent,
                        FSWBuyerInfoGridPipe,
                        FSWBuyerInfoGridItemDirective,
                    ],
                    imports: [
                        JsonPipe,
                        FSWTranslateModule.forFeature({
                            scope: 'buyer-information',
                            defaultKey: CountryCode.TH,
                            data: BUYER_INFORMATION_TRANSLATION_LOADER,
                        }),
                        FSWButtonModule,
                        NgIf,
                        NgClass,
                        FSWSwitchModule,
                        FormsModule,
                        FSWAlertModule,
                        FSWModalModule$1,
                        NgSwitch,
                        AsyncPipe,
                        NgSwitchCase,
                        NgSwitchDefault,
                        FSWDynamicBuilderModule,
                        ReactiveFormsModule,
                        FSWIconModule,
                        FSWFieldModule,
                        FSWSelectModule,
                        NgForOf,
                        NgTemplateOutlet,
                        FSWPaginationModule$1,
                        BuyerServiceModule,
                        FSWRadioModule,
                    ],
                }]
        }] });

// for loading form's config after selecting item in table and show in modal
var FSWBuyerInformationFormTypes;
(function (FSWBuyerInformationFormTypes) {
    FSWBuyerInformationFormTypes[FSWBuyerInformationFormTypes["ADD_BUYER"] = 0] = "ADD_BUYER";
    FSWBuyerInformationFormTypes[FSWBuyerInformationFormTypes["FACILITY"] = 1] = "FACILITY";
    FSWBuyerInformationFormTypes[FSWBuyerInformationFormTypes["FACILITY_IMPORT"] = 2] = "FACILITY_IMPORT";
    FSWBuyerInformationFormTypes[FSWBuyerInformationFormTypes["FACILITY_AFTER_IMPORT"] = 3] = "FACILITY_AFTER_IMPORT";
})(FSWBuyerInformationFormTypes || (FSWBuyerInformationFormTypes = {}));

class FSWBuyerTransactionConfirmComponent {
    constructor(dialogRef) {
        this.dialogRef = dialogRef;
    }
    close(haveData = false) {
        this.dialogRef.close(haveData);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerTransactionConfirmComponent, deps: [{ token: i1$7.DialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWBuyerTransactionConfirmComponent, selector: "fsw-buyer-transaction-confirm", ngImport: i0, template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"'buttons.yes' | fswTranslate\"\n  [cancelButton]=\"'buttons.no' | fswTranslate\"\n  (confirmEvent)=\"close(true)\"\n  (cancelEvent)=\"close(false)\"\n  (closeEvent)=\"close(false)\"\n>\n  <ng-template fswModalBody>\n    <p>\n      {{\n        dialogRef.config.data['description']\n          | fswTranslate : { data: dialogRef.config.data['descriptionParams'] }\n      }}\n    </p>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerTransactionConfirmComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-buyer-transaction-confirm', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"'buttons.yes' | fswTranslate\"\n  [cancelButton]=\"'buttons.no' | fswTranslate\"\n  (confirmEvent)=\"close(true)\"\n  (cancelEvent)=\"close(false)\"\n  (closeEvent)=\"close(false)\"\n>\n  <ng-template fswModalBody>\n    <p>\n      {{\n        dialogRef.config.data['description']\n          | fswTranslate : { data: dialogRef.config.data['descriptionParams'] }\n      }}\n    </p>\n  </ng-template>\n</fsw-modal>\n" }]
        }], ctorParameters: function () { return [{ type: i1$7.DialogRef }]; } });

const BUYER_TRANSACTION_STORE_TOKEN = new InjectionToken('BUYER_TRANSACTION_STORE_TOKEN');

const INITIAL_STATE$3 = {
    countryCode: getCountryCodeFromStorage(),
    applicationId: null,
    salesOrCredit: BuyerSalesOrCredit.SALES,
    isReadonly: false,
    topBuyers: [],
    selectedBuyerId: null,
    allBuyerTransactions: [],
    isFormGroupSetToReadonly: false,
    errors: [],
};
class BuyerTransactionStore extends ComponentStore {
    // constructor
    constructor() {
        super({
            ...INITIAL_STATE$3,
        });
        // inject services
        this._buyerService = inject(BUYER_SERVICE_TOKEN);
        this._alertService = inject(FSW_ALERT_SERVICE_TOKEN);
        // all setters to state are handled with this
        this.updateState = (value) => this.patchState({
            ...value,
        });
        // GET Calls
        this.getBuyersWithTransactions = this.effect(pipe(switchMap(() => this._getAllBuyerTransactionsAsync()), tap((allBuyerTransactions) => {
            this.updateState({
                allBuyerTransactions,
            });
        }), switchMap(() => this._generateAllBuyersPaymentProofingAnalysis()), tap((allBuyerTransactions) => {
            this.updateState({
                allBuyerTransactions,
            });
        })));
        // actions
        this.addEachBuyerTransactions = this.effect(pipe(switchMap(({ buyer_id, payload }) => this._addEachBuyerTransactionsAsync(buyer_id, payload)), switchMap(() => this._getAllBuyerTransactionsAsync()), tap((allBuyerTransactions) => {
            this.updateState({
                allBuyerTransactions,
            });
        }), switchMap(() => this._generateEachBuyerPaymentProofingAnalysis()), tap(() => {
            this._alertService.success('Transaction added successfully', '', {
                duration: 2000,
            });
            this.updateState({
                isFormGroupSetToReadonly: true,
            });
        })));
        this.updateEachBuyerTransactions = this.effect(pipe(switchMap(({ buyer_id, payload }) => this._updateEachBuyerTransactionsAsync(buyer_id, payload)), switchMap(() => this._getAllBuyerTransactionsAsync()), tap((allBuyerTransactions) => {
            this.updateState({
                allBuyerTransactions,
            });
        }), switchMap(() => this._generateEachBuyerPaymentProofingAnalysis()), tap(() => {
            this._alertService.success('Transaction updated successfully', '', {
                duration: 2000,
            });
            this.updateState({
                isFormGroupSetToReadonly: true,
            });
        })));
        this.deleteTransaction = this.effect(pipe(switchMap(({ buyer_id, payment_proofing_id }) => this._deleteTransactionAsync(buyer_id, payment_proofing_id)), switchMap(() => this._getAllBuyerTransactionsAsync()), tap((allBuyerTransactions) => {
            this.updateState({
                allBuyerTransactions,
            });
        }), switchMap(() => this._generateAllBuyersPaymentProofingAnalysis()), tap((allBuyerTransactions) => {
            this.updateState({
                allBuyerTransactions,
            });
            this._alertService.success('Transaction deleted successfully', '', {
                duration: 2000,
            });
        })));
    }
    // private async calls
    // GET Calls
    _getAllBuyerTransactionsAsync() {
        const allBuyerTransAndProofing = this.state().allBuyerTransactions;
        if (!Array.isArray(allBuyerTransAndProofing)) {
            throw new Error('[_getAllBuyerTransactionsAsync] All Buyer Transactions is not valid');
        }
        const obs$ = (allBuyerTransAndProofing || []).map((item) => {
            return this._buyerService.getEachBuyerTransactions(item.id).pipe(map((transactions) => ({
                ...item,
                transactions,
            })));
        });
        return zip(obs$).pipe(catchError((err) => {
            console.error('_getAllBuyerTransactionsAsync', err);
            return EMPTY;
        }));
    }
    // POST, PUT Calls
    _generateAllBuyersPaymentProofingAnalysis() {
        const allBuyerTransAndProofing = this.state().allBuyerTransactions;
        if (!Array.isArray(allBuyerTransAndProofing)) {
            throw new Error('[_generateAllBuyersPaymentProofingAnalysis] All Buyer Transactions is not valid');
        }
        const obs$ = (allBuyerTransAndProofing || []).map((item) => {
            if (!item?.transactions?.length) {
                return of(item);
            }
            return this._buyerService.updatePaymentProofingAnalysis(item.id).pipe(map((analysis) => {
                // console.log('analysis generateAllBuyers ', analysis);
                return {
                    ...item,
                    paymentProofingAnalysis: analysis,
                };
            }));
        });
        return zip(obs$).pipe(catchError((err) => {
            console.error('_generateAllBuyersPaymentProofingAnalysis', err);
            return of([]);
        }));
    }
    _addEachBuyerTransactionsAsync(buyer_id, payload) {
        if (!isStringValid(buyer_id)) {
            throw new Error('[_addEachBuyerTransactionsAsync] Buyer ID is not valid');
        }
        if (!isObjectValid(payload)) {
            throw new Error('[_addEachBuyerTransactionsAsync] Payload is not valid');
        }
        return this._buyerService.addEachBuyerTransactions(buyer_id, payload).pipe(tap(() => {
            this.updateState({
                selectedBuyerId: buyer_id,
            });
        }), catchError((err) => {
            console.error(`[_addEachBuyerTransactionsAsync]`, err);
            this._alertService.error('Transaction add failed', '', {
                duration: 2000,
            });
            return EMPTY;
        }));
    }
    _updateEachBuyerTransactionsAsync(buyer_id, payload) {
        if (!isStringValid(buyer_id)) {
            throw new Error('[_updateEachBuyerTransactionsAsync] Buyer ID is not valid');
        }
        if (!isObjectValid(payload)) {
            throw new Error('[_updateEachBuyerTransactionsAsync] Payload is not valid');
        }
        return this._buyerService.updateEachBuyerTransactions(buyer_id, payload).pipe(tap(() => {
            this.updateState({
                selectedBuyerId: buyer_id,
            });
        }), catchError((err) => {
            console.error(`[_updateEachBuyerTransactionsAsync]`, err);
            this._alertService.error('Transaction update failed', '', {
                duration: 2000,
            });
            return EMPTY;
        }));
    }
    _generateEachBuyerPaymentProofingAnalysis() {
        const buyer_id = this.state().selectedBuyerId;
        if (!isStringValid(buyer_id)) {
            throw new Error('[_generateBuyerPaymentProofingAnalysis] Buyer ID is not valid');
        }
        return this._buyerService.updatePaymentProofingAnalysis(buyer_id).pipe(tap((analysis) => {
            // console.log('analysis generateEachBuyer == ', analysis);
            const allBuyerTransAndProofing = this.state().allBuyerTransactions;
            const obj = allBuyerTransAndProofing.find((item) => item.id === buyer_id);
            if (!obj)
                return;
            obj.paymentProofingAnalysis = analysis;
            this.updateState({
                allBuyerTransactions: [...allBuyerTransAndProofing],
            });
        }), catchError((err) => {
            console.error(`[_generateBuyerPaymentProofingAnalysis]`, err);
            this._alertService.error('Payment Proofing Analysis failed', '', {
                duration: 2000,
            });
            return EMPTY;
        }));
    }
    _deleteTransactionAsync(buyer_id, payment_proofing_id) {
        if (!isStringValid(buyer_id)) {
            throw new Error('[_deleteTransactionAsync] Buyer ID is not valid');
        }
        if (!isStringValid(payment_proofing_id)) {
            throw new Error('[_deleteTransactionAsync] Payment Proofing ID is not valid');
        }
        return this._buyerService.deleteTransaction(buyer_id, payment_proofing_id).pipe(catchError((err) => {
            console.error(`[_deleteTransactionAsync]`, err);
            this._alertService.error('Transaction delete failed', '', {
                duration: 2000,
            });
            return EMPTY;
        }));
    }
    clearCache() {
        this.updateState({
            ...INITIAL_STATE$3,
        });
    }
}

class FSWBuyerTransactionSaveComponent {
    constructor() {
        this._alertService = inject(FSW_ALERT_SERVICE_TOKEN);
        this._dialog = inject(Dialog);
        this._injector = inject(Injector);
        this._componentStore = inject(BUYER_TRANSACTION_STORE_TOKEN);
        this.salesOrCredit$ = this._componentStore.select((state) => state.salesOrCredit);
        this.dialogRef = inject(DialogRef);
    }
    get data() {
        return this.dialogRef.config.data;
    }
    get translationPrefix() {
        // const { type } = this.data;
        return `modals.buyer`;
    }
    get translationTitle() {
        const { method } = this.data;
        return `${this.translationPrefix}.${method === 'POST' ? 'new' : 'edit'}`;
    }
    get translationDelete() {
        // const { type } = this.data;
        return `buttons.delete_buyer`;
    }
    close(haveData = false) {
        this.dialogRef.close(haveData);
    }
    submit() {
        const { builder, method } = this.data;
        const form = builder.groupConfig.form;
        if (form.invalid) {
            form.markAllAsTouched();
            this._alertService.warning('Invalid Information', 'Please fill in all mandatory fields.', {
                duration: 3000,
            });
            return;
        }
        this._dialog
            .open(FSWBuyerTransactionConfirmComponent, {
            data: {
                title: `${this.translationPrefix}.confirm_${method === 'POST' ? 'add' : 'edit'}_title`,
                titleParams: {},
                description: `${this.translationPrefix}.confirm_${method === 'POST' ? 'add' : 'edit'}`,
                descriptionParams: {},
            },
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((accept) => {
            if (accept) {
                const payload = form.getRawValue();
                delete payload.status;
                // if (method === 'POST') {
                //   this._componentStore.addBuyer({
                //     name: payload.name,
                //     credit_term: payload.credit_term,
                //     sales_thb_month: payload.sales_thb_month,
                //     method_of_payment: payload.method_of_payment,
                //     include_in_financing: payload.include_in_financing,
                //     trading_history: payload.trading_history,
                //     remark: payload.remark,
                //   });
                //   this.close(true);
                //   return;
                // } else if (method === 'PUT') {
                //   this._componentStore.state().salesOrCredit === 'SALES'
                //     ? this._componentStore.updateBuyerSales({
                //         buyer_id: form.getRawValue().id,
                //         payload,
                //       })
                //     : this._componentStore.updateBuyerCredit({
                //         buyer_id: form.getRawValue().id,
                //         payload,
                //       });
                //   this.close(true);
                //   return;
                // }
            }
        }))
            .subscribe();
    }
    edit() {
        this.data.isReadonly$.next(false);
    }
    delete() {
        this.data.delete(this.data.builder.groupConfig.form.getRawValue().id, this.data.type, () => {
            this.close();
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerTransactionSaveComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWBuyerTransactionSaveComponent, selector: "fsw-buyer-transaction-save", ngImport: i0, template: "<fsw-modal\n  [size]=\"'l'\"\n  [title]=\"translationTitle | fswTranslate\"\n  [bodyCustomClasses]=\"'max-h-[calc(90vh-138px)] overflow-y-auto'\"\n  [hiddenFooter]=\"data.isReadonly\"\n  (closeEvent)=\"close()\"\n>\n  <ng-template fswModalBody>\n    <form [formGroup]=\"data.builder.groupConfig.form\">\n      <fsw-dynamic-builder [builder]=\"data.builder\"></fsw-dynamic-builder>\n    </form>\n  </ng-template>\n  <ng-template fswModalFooter>\n    <section class=\"flex justify-between w-full items-center\">\n      <aside>\n        <button\n          *ngIf=\"data.method === 'PUT' && (salesOrCredit$ | async) === 'SALES'\"\n          fswButton\n          class=\"!text-red-500\"\n          [appearance]=\"'secondary'\"\n          (click)=\"delete()\"\n        >\n          {{ translationDelete | fswTranslate }}\n        </button>\n      </aside>\n      <main class=\"flex gap-[16px] items-center\">\n        <button fswButton [appearance]=\"'secondary'\" (click)=\"close()\">\n          {{ 'buttons.cancel' | fswTranslate }}\n        </button>\n        <button\n          (click)=\"edit()\"\n          fswButton\n          *ngIf=\"data.isReadonly$ | async; else saveChangesTemplate\"\n        >\n          {{ 'buttons.edit_details' | fswTranslate }}\n        </button>\n        <ng-template #saveChangesTemplate>\n          <button fswButton (click)=\"submit()\">{{ 'buttons.save_changes' | fswTranslate }}</button>\n        </ng-template>\n      </main>\n    </section>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "directive", type: i1$4.FSWModalFooterDirective, selector: "ng-template[fswModalFooter]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerTransactionSaveComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-buyer-transaction-save', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal\n  [size]=\"'l'\"\n  [title]=\"translationTitle | fswTranslate\"\n  [bodyCustomClasses]=\"'max-h-[calc(90vh-138px)] overflow-y-auto'\"\n  [hiddenFooter]=\"data.isReadonly\"\n  (closeEvent)=\"close()\"\n>\n  <ng-template fswModalBody>\n    <form [formGroup]=\"data.builder.groupConfig.form\">\n      <fsw-dynamic-builder [builder]=\"data.builder\"></fsw-dynamic-builder>\n    </form>\n  </ng-template>\n  <ng-template fswModalFooter>\n    <section class=\"flex justify-between w-full items-center\">\n      <aside>\n        <button\n          *ngIf=\"data.method === 'PUT' && (salesOrCredit$ | async) === 'SALES'\"\n          fswButton\n          class=\"!text-red-500\"\n          [appearance]=\"'secondary'\"\n          (click)=\"delete()\"\n        >\n          {{ translationDelete | fswTranslate }}\n        </button>\n      </aside>\n      <main class=\"flex gap-[16px] items-center\">\n        <button fswButton [appearance]=\"'secondary'\" (click)=\"close()\">\n          {{ 'buttons.cancel' | fswTranslate }}\n        </button>\n        <button\n          (click)=\"edit()\"\n          fswButton\n          *ngIf=\"data.isReadonly$ | async; else saveChangesTemplate\"\n        >\n          {{ 'buttons.edit_details' | fswTranslate }}\n        </button>\n        <ng-template #saveChangesTemplate>\n          <button fswButton (click)=\"submit()\">{{ 'buttons.save_changes' | fswTranslate }}</button>\n        </ng-template>\n      </main>\n    </section>\n  </ng-template>\n</fsw-modal>\n" }]
        }] });

class FSWBuyerTransactionComponent {
    constructor() {
        this._destroySubject = new Subject();
        this._componentStore = inject(BUYER_TRANSACTION_STORE_TOKEN);
        this._buyerHelperService = inject(BUYER_HELPER_SERVICE_TOKEN);
        this._dialog = inject(Dialog);
        this._injector = inject(Injector);
        this.salesOrCredit$ = this._componentStore.select((state) => state.salesOrCredit);
        this.buyers$ = this._componentStore.select((state) => state.topBuyers);
        this.isReadonly$ = this._componentStore.select((state) => state.isReadonly);
        this.formGroup = new UntypedFormGroup({});
        this.buyerControl = new UntypedFormControl([]);
        this.builder = this.generateBuilder();
        this.cdr = inject(ChangeDetectorRef);
        this._alertService = inject(FSW_ALERT_SERVICE_TOKEN);
    }
    set applicationId(applicationId) {
        this._componentStore.updateState({
            applicationId,
        });
    }
    set salesOrCredit(salesOrCredit) {
        this._componentStore.updateState({
            salesOrCredit,
        });
    }
    set isReadonly(isReadonly) {
        this._componentStore.updateState({
            isReadonly,
        });
    }
    ngOnInit() {
        this.refresh();
        // this._componentStore.init();
        this._buyerHelperService.topBuyersSubject$
            .pipe(tap$1((topBuyers) => {
            const allBuyerTransactions = topBuyers.map((buyer) => ({
                id: buyer.id,
                name: buyer.name,
                transactions: [],
                paymentProofingAnalysis: null,
            }));
            this._componentStore.updateState({
                topBuyers,
                allBuyerTransactions,
            });
            this._componentStore.getBuyersWithTransactions();
        }), takeUntil$1(this._destroySubject))
            .subscribe();
        this._componentStore
            .select((state) => state.allBuyerTransactions)
            .pipe(tap$1((allBuyerTransactions) => {
            // console.log('allBuyerTransactions state subs ', allBuyerTransactions);
            // this.builder = this.generateBuilder();
            this.formGroup.patchValue(allBuyerTransactions.reduce((acc, buyer) => ({
                ...acc,
                [buyer.id]: {
                    information: {
                        name: buyer.name,
                        id: buyer.id,
                    },
                    transactions: buyer.transactions,
                    average_contract_amount: {
                        value: buyer.paymentProofingAnalysis?.average_contract_amount ?? 0,
                    },
                    total_contract_amount: {
                        value: buyer.paymentProofingAnalysis?.total_contract_amount ?? 0,
                    },
                    average_received_amount: {
                        value: buyer.paymentProofingAnalysis?.average_received_amount ?? 0,
                    },
                    total_received_amount: {
                        value: buyer.paymentProofingAnalysis?.total_received_amount ?? 0,
                    },
                    max_days_after_invoice: {
                        value: buyer.paymentProofingAnalysis?.max_days_after_invoice ?? 0,
                    },
                },
            }), {}));
            // console.log('formGroup ', this.formGroup.getRawValue());
            this.setReadonly(this.formGroup, true);
            this.cdr.markForCheck();
        }), takeUntil$1(this._destroySubject))
            .subscribe();
        this._componentStore
            .select((state) => state.isFormGroupSetToReadonly)
            .pipe(tap$1((isFormGroupSetToReadonly) => {
            if (isFormGroupSetToReadonly) {
                this.setReadonly(this.formGroup, true);
            }
        }), takeUntil$1(this._destroySubject))
            .subscribe();
    }
    ngOnDestroy() {
        this._destroySubject.next();
        this._destroySubject.complete();
    }
    refresh() {
        zip([this.buyers$])
            .pipe(tap$1(([buyers]) => {
            this.buyerControl.patchValue(buyers.map((buyer) => buyer.id));
        }))
            .pipe(takeUntil$1(this._destroySubject))
            .subscribe();
        combineLatest([
            this.buyerControl.valueChanges.pipe(startWith$1(this.buyerControl.value)),
            this.buyers$,
        ])
            .pipe(tap$1(([value, buyers]) => {
            const selectedBuyers = buyers.filter((buyer) => value.includes(buyer.id));
            this.builder = this.generateBuilder(selectedBuyers);
            this.formGroup.patchValue(selectedBuyers.reduce((acc, buyer) => ({
                ...acc,
                [buyer.id]: {
                    information: {
                        name: buyer.name,
                        id: buyer.id,
                    },
                    transactions: [],
                },
            }), {}));
            this.setReadonly(this.formGroup, true);
            this.cdr.markForCheck();
        }), takeUntil$1(this._destroySubject))
            .subscribe();
    }
    generateBuilder(buyers = [], proofing = {
        total_contract_amount: 0,
        average_contract_amount: 0,
        total_received_amount: 0,
        average_received_amount: 0,
        max_days_after_invoice: 0,
    }) {
        return new FSWDynamicBuilder({
            form: this.formGroup,
            formType: FSWDynamicBuilderFormTypes.TABLE,
            customClasses: 'fsw-table fsw-table--bordered w-full table-fixed',
            header: [
                {
                    columns: [
                        {
                            label: 'Project',
                            colSpan: 4,
                            customClasses: 'text-center min-w-[200px] align-middle bg-[#deeaf6] !font-bold',
                        },
                        {
                            label: 'Payment Proof',
                            colSpan: 5,
                            customClasses: 'text-center min-w-[200px] align-middle bg-[#fef3cb] !font-bold',
                        },
                        {
                            label: 'Project description',
                            colSpan: 2,
                            rowSpan: 2,
                            customClasses: 'text-center min-w-[200px] align-middle !font-bold whitespace-normal',
                        },
                    ],
                },
                {
                    columns: [
                        {
                            label: 'Invoice Date',
                            customClasses: 'text-center min-w-[200px] align-middle bg-[#deeaf6] !font-bold whitespace-normal',
                        },
                        {
                            label: 'Contract No.',
                            customClasses: 'text-center min-w-[200px] align-middle bg-[#deeaf6] !font-bold whitespace-normal',
                        },
                        {
                            label: 'Contract Amount',
                            customClasses: 'text-center min-w-[200px] align-middle bg-[#deeaf6] !font-bold whitespace-normal',
                        },
                        {
                            label: 'Due Date',
                            customClasses: 'text-center min-w-[200px] align-middle bg-[#deeaf6] !font-bold whitespace-normal',
                        },
                        {
                            label: 'Date of Receipt of Cash',
                            customClasses: 'text-center min-w-[200px] align-middle bg-[#fef3cb] !font-bold whitespace-normal',
                        },
                        {
                            label: 'Received Amt',
                            customClasses: 'text-center min-w-[200px] align-middle bg-[#fef3cb] !font-bold whitespace-normal',
                        },
                        {
                            label: 'Difference',
                            customClasses: 'text-center min-w-[200px] align-middle bg-[#fef3cb] !font-bold whitespace-normal',
                        },
                        {
                            label: 'Days After Invoice',
                            customClasses: 'text-center min-w-[200px] align-middle bg-[#fef3cb] !font-bold whitespace-normal',
                        },
                        {
                            label: 'Payment Method',
                            customClasses: 'text-center min-w-[200px] align-middle bg-[#fef3cb] !font-bold whitespace-normal',
                        },
                    ],
                },
            ],
            items: buyers.map((buyer, index) => ({
                key: buyer.id,
                header: [
                    {
                        customClasses: 'bg-gray-200',
                        key: 'information',
                        columns: [
                            {
                                label: `Buyer ${index + 1}:`,
                            },
                            {
                                columnType: 'control',
                                colSpan: 9,
                                fields: [
                                    {
                                        key: 'name',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            placeHolder: 'Buyer Name',
                                            fullWidth: true,
                                            isReadonly: true,
                                        },
                                    },
                                ],
                            },
                            {
                                label: '',
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'id',
                                        type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                        context: {
                                            templateKey: 'transaction-add',
                                        },
                                    },
                                ],
                                colSpan: 1,
                                customClasses: 'text-right',
                            },
                        ],
                    },
                ],
                body: {
                    key: 'transactions',
                    isLoop: true,
                    data: {
                        columns: [
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'invoice_date',
                                        type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                                        context: {
                                            showError: true,
                                            fullWidth: true,
                                            closeOnSelected: true,
                                            placeHolder: 'DD/MM/YYYY',
                                            readonlyTemplate: (value) => value ? new DatePipe('en-US').transform(value, 'dd/MM/yyyy') || '--' : '--',
                                        },
                                        validations: [Validators.required],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'contract_no',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            showError: true,
                                            placeHolder: 'Contract No',
                                            fullWidth: true,
                                        },
                                        validations: [Validators.required],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'contract_amount',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            showError: true,
                                            // inputType: 'number',
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            placeHolder: 'Contract Amount',
                                            readonlyTemplate: (value) => value ? new Intl.NumberFormat().format(value) : '--',
                                        },
                                        validations: [Validators.required],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'due_date',
                                        type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                                        context: {
                                            showError: true,
                                            fullWidth: true,
                                            closeOnSelected: true,
                                            placeHolder: 'DD/MM/YYYY',
                                            readonlyTemplate: (value) => value ? new DatePipe('en-US').transform(value, 'dd/MM/yyyy') || '--' : '--',
                                        },
                                        validations: [Validators.required],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'date_of_receipt_of_cash',
                                        type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                                        context: {
                                            showError: true,
                                            fullWidth: true,
                                            closeOnSelected: true,
                                            placeHolder: 'DD/MM/YYYY',
                                            readonlyTemplate: (value) => value ? new DatePipe('en-US').transform(value, 'dd/MM/yyyy') || '--' : '--',
                                        },
                                        validations: [Validators.required],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'received_amt',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            showError: true,
                                            // inputType: 'number',
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            placeHolder: 'Received Amount',
                                            readonlyTemplate: (value) => value ? new Intl.NumberFormat().format(value) : '--',
                                        },
                                        validations: [Validators.required],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'difference',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            showError: true,
                                            // inputType: 'number',
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            isReadonly: true,
                                            placeHolder: 'Difference',
                                            isDisabled: true,
                                            readonlyTemplate: (value) => value != null ? new Intl.NumberFormat().format(value) : '--',
                                            afterCreated: (control, formGroup) => {
                                                const receivedAmt = formGroup.get('received_amt');
                                                const contractAmount = formGroup.get('contract_amount');
                                                if (receivedAmt && contractAmount) {
                                                    combineLatest([
                                                        receivedAmt.valueChanges.pipe(startWith$1(receivedAmt.value)),
                                                        contractAmount.valueChanges.pipe(startWith$1(contractAmount.value)),
                                                    ]).subscribe(([receivedAmtValue, contractAmountValue]) => {
                                                        const diff = Number(receivedAmtValue) - Number(contractAmountValue);
                                                        control.setValue(Number(diff.toFixed(2)));
                                                    });
                                                }
                                            },
                                        },
                                        validations: [Validators.required],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'days_after_invoice',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            showError: true,
                                            // inputType: 'number',
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            isReadonly: true,
                                            placeHolder: 'Days After Invoice',
                                            isDisabled: true,
                                            readonlyTemplate: (value) => value ?? '--',
                                            afterCreated: (control, formGroup) => {
                                                const invoiceDate = formGroup.get('invoice_date');
                                                const dateOfReceiptOfCash = formGroup.get('date_of_receipt_of_cash');
                                                if (invoiceDate && dateOfReceiptOfCash) {
                                                    combineLatest([
                                                        invoiceDate.valueChanges.pipe(startWith$1(invoiceDate.value)),
                                                        dateOfReceiptOfCash.valueChanges.pipe(startWith$1(dateOfReceiptOfCash.value)),
                                                    ]).subscribe(([invoiceDateValue, dateOfReceiptOfCashValue]) => {
                                                        if (!invoiceDateValue || !dateOfReceiptOfCashValue) {
                                                            control.setValue(null);
                                                            return;
                                                        }
                                                        const diff = Math.ceil((new Date(`${dateOfReceiptOfCashValue}`).getTime() -
                                                            new Date(`${invoiceDateValue}`).getTime()) /
                                                            (1000 * 60 * 60 * 24));
                                                        control.setValue(Number(diff.toFixed(0)));
                                                    });
                                                }
                                            },
                                        },
                                        validations: [Validators.required],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'payment_method',
                                        type: FSWDynamicBuilderControlTypes.SELECT,
                                        context: {
                                            showError: true,
                                            closeOnSelected: true,
                                            fullWidth: true,
                                            placeHolder: 'Payment Method',
                                            items: BUYER_PAYMENT_METHODS.map((item) => ({
                                                text: item,
                                                value: item,
                                            })),
                                        },
                                        validations: [Validators.required],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'project_description',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            showError: true,
                                            inputType: 'area',
                                            fullWidth: true,
                                            placeHolder: 'Project Description',
                                            rows: 1,
                                        },
                                        validations: [Validators.required],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'id',
                                        type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                        context: {
                                            templateKey: 'transaction-action',
                                            isReadonly: true,
                                        },
                                    },
                                ],
                                customClasses: 'text-right',
                            },
                        ],
                    },
                },
                footer: [
                    {
                        key: 'total_contract_amount',
                        columns: [
                            {
                                label: 'Total Contract Amount',
                                colSpan: 2,
                                customClasses: 'text-left !font-bold',
                            },
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'value',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            fullWidth: true,
                                            defaultValue: proofing.total_contract_amount,
                                            placeHolder: 'Total Contract Amount',
                                            isReadonly: true,
                                            readonlyTemplate: (value) => value ? new Intl.NumberFormat().format(value) : '--',
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        key: 'average_contract_amount',
                        columns: [
                            {
                                label: 'Average Contract Amount',
                                colSpan: 2,
                                customClasses: 'text-left !font-bold',
                            },
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'value',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            fullWidth: true,
                                            defaultValue: proofing.average_contract_amount,
                                            placeHolder: 'Average Contract Amount',
                                            isReadonly: true,
                                            readonlyTemplate: (value) => value ? new Intl.NumberFormat().format(value) : '--',
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        key: 'total_received_amount',
                        columns: [
                            {
                                label: 'Total Received Amount',
                                colSpan: 2,
                                customClasses: 'text-left !font-bold',
                            },
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'value',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            fullWidth: true,
                                            defaultValue: proofing.total_received_amount,
                                            placeHolder: 'Total Received Amount',
                                            isReadonly: true,
                                            readonlyTemplate: (value) => value ? new Intl.NumberFormat().format(value) : '--',
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        key: 'average_received_amount',
                        columns: [
                            {
                                label: 'Average Received Amount',
                                colSpan: 2,
                                customClasses: 'text-left !font-bold',
                            },
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'value',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            fullWidth: true,
                                            defaultValue: proofing.average_received_amount,
                                            placeHolder: 'Average Received Amount',
                                            isReadonly: true,
                                            readonlyTemplate: (value) => value ? new Intl.NumberFormat().format(value) : '--',
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        key: 'max_days_after_invoice',
                        columns: [
                            {
                                label: 'Max Days After Invoice',
                                colSpan: 2,
                                customClasses: 'text-left !font-bold',
                            },
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'value',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            fullWidth: true,
                                            defaultValue: proofing.max_days_after_invoice,
                                            placeHolder: 'Max Days After Invoice',
                                            isReadonly: true,
                                            readonlyTemplate: (value) => value ? new Intl.NumberFormat().format(value) : '--',
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                ],
            })),
            footer: [],
        });
    }
    edit(formGroup) {
        this.setReadonly(formGroup, false);
    }
    cancel(formGroup) {
        this.setReadonly(formGroup, true);
    }
    setReadonly(formGroup, value) {
        getDynamicBuilderSetReadonly(formGroup)(value);
    }
    getReadonly(formGroup) {
        return getDynamicBuilderReadonly(formGroup)
            .asObservable()
            .pipe(map$1((value) => (value ? 'readonly' : 'editable')));
    }
    saveAllTransactions(formGroup) {
        if (formGroup.invalid) {
            formGroup.markAllAsTouched();
            this._alertService.error('Please fill in all required fields', '', {
                duration: 2000,
            });
            return;
        }
        const obj = this._componentStore
            .state()
            .allBuyerTransactions.find((buyer) => buyer.id === formGroup.value.information.id);
        const isTransPresent = !!obj?.transactions?.length;
        if (isTransPresent) {
            // PUT
            this._componentStore.updateEachBuyerTransactions({
                buyer_id: formGroup.value.information.id,
                payload: (formGroup.getRawValue().transactions || []).map((item) => {
                    if (item.id === null) {
                        const { id, ...rest } = item;
                        return rest;
                    }
                    return item;
                }),
            });
        }
        else {
            // POST
            const payload = formGroup.getRawValue().transactions.map((transaction) => {
                delete transaction.id;
                return transaction;
            });
            this._componentStore.addEachBuyerTransactions({
                buyer_id: formGroup.value.information.id,
                payload,
            });
        }
    }
    addTransaction(formGroup) {
        const array = getControlFromGroup(formGroup, 'transactions');
        const saveReadonly = array.controls.map((control) => ({
            value: getDynamicBuilderReadonly(control).value,
            id: control.value.id,
        }));
        array.patchValue([{}, ...array.value]);
        array.controls.forEach((control, index) => this.setReadonly(control, saveReadonly.find((item) => item.id === control.value.id)?.value ?? false));
    }
    viewTransaction(transactionsArray, rowGroup, index) {
        if (rowGroup.value.id) {
            return;
        }
        transactionsArray.removeAt(transactionsArray.controls.indexOf(rowGroup));
    }
    deleteTransaction(transactionsArray, rowGroup, parentForm, index) {
        if (!rowGroup?.value?.id) {
            transactionsArray.removeAt(transactionsArray.controls.indexOf(rowGroup));
            return;
        }
        const translationPrefix = `modals.buyer`;
        this._dialog
            .open(FSWBuyerTransactionConfirmComponent, {
            data: {
                title: `${translationPrefix}.confirm_delete_title`,
                titleParams: {},
                description: `${translationPrefix}.confirm_delete`,
                descriptionParams: {},
            },
            injector: this._injector,
        })
            .closed.pipe(take$1(1), tap$1((accept) => {
            if (accept) {
                this._componentStore.deleteTransaction({
                    buyer_id: parentForm.value.information.id,
                    payment_proofing_id: rowGroup.value.id,
                });
            }
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerTransactionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWBuyerTransactionComponent, selector: "fsw-buyer-transaction", inputs: { applicationId: "applicationId", salesOrCredit: "salesOrCredit", isReadonly: "isReadonly" }, ngImport: i0, template: "<section>\n  <aside>\n    <h6>Buyer Transactions</h6>\n  </aside>\n  <main>\n    <section class=\"flex flex-col gap-3\">\n      <header class=\"w-[328px]\">\n        <fsw-field [fullWidth]=\"true\">\n          <fsw-select\n            [formControl]=\"buyerControl\"\n            [placeHolder]=\"'Select Buyer'\"\n            [isMultiple]=\"true\"\n          >\n            <ng-container *ngFor=\"let buyer of buyers$ | async\">\n              <ng-template\n                fswSelectItem\n                textSize=\"s\"\n                [value]=\"buyer.id\"\n                [text]=\"buyer.name\"\n                [showCheckIcon]=\"true\"\n                let-selected\n              ></ng-template>\n            </ng-container>\n          </fsw-select>\n        </fsw-field>\n      </header>\n      <form [formGroup]=\"formGroup\">\n        <fsw-dynamic-builder [builder]=\"builder\">\n          <ng-template\n            fswDynamicBuilderTemplate\n            key=\"transaction-action\"\n            let-control=\"control\"\n            let-index=\"index\"\n          >\n            <!-- <ng-container *ngIf=\"getReadonly(control.parent.parent) | async as mode\">\n              <button\n                fswButton\n                *ngIf=\"mode === 'editable'\"\n                appearance=\"icon-with-bg\"\n                [size]=\"'s'\"\n                (click)=\"viewTransaction(control.parent.parent, control.parent, index)\"\n              >\n                <i fswIcon=\"common-password-show\"></i>\n              </button>\n            </ng-container> -->\n\n            <ng-container *ngIf=\"getReadonly(control.parent.parent) | async as mode\">\n              <button\n                *ngIf=\"!(isReadonly$ | async) || (!(isReadonly$ | async) && mode === 'readonly')\"\n                fswButton\n                appearance=\"icon-with-bg\"\n                [size]=\"'s'\"\n                (click)=\"\n                  deleteTransaction(\n                    control.parent.parent,\n                    control.parent,\n                    control.parent.parent.parent,\n                    index\n                  )\n                \"\n              >\n                <i fswIcon=\"common-delete-alternative\"></i>\n              </button>\n            </ng-container>\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"transaction-add\" let-control=\"control\">\n            <div\n              class=\"flex gap-1 w-full justify-end\"\n              *ngIf=\"getReadonly(control.parent.parent) | async as mode\"\n            >\n              <ng-container [ngSwitch]=\"mode\">\n                <ng-container *ngSwitchCase=\"'readonly'\">\n                  <button\n                    *ngIf=\"!(isReadonly$ | async)\"\n                    fswButton\n                    appearance=\"icon-with-bg\"\n                    [size]=\"'s'\"\n                    (click)=\"setReadonly(control.parent.parent, false)\"\n                  >\n                    <i fswIcon=\"common-edit\"></i>\n                  </button>\n                </ng-container>\n\n                <ng-container *ngSwitchCase=\"'editable'\">\n                  <button\n                    fswButton\n                    appearance=\"icon-with-bg\"\n                    [size]=\"'s'\"\n                    (click)=\"addTransaction(control.parent.parent)\"\n                  >\n                    <i fswIcon=\"common-add\"></i>\n                  </button>\n                  <button\n                    fswButton\n                    appearance=\"icon-with-bg\"\n                    [size]=\"'s'\"\n                    (click)=\"saveAllTransactions(control.parent.parent)\"\n                  >\n                    <i fswIcon=\"common-document\"></i>\n                  </button>\n                  <button\n                    fswButton\n                    appearance=\"icon-with-bg\"\n                    [size]=\"'s'\"\n                    (click)=\"setReadonly(control.parent.parent, true)\"\n                  >\n                    <i fswIcon=\"common-close\"></i>\n                  </button>\n                </ng-container>\n              </ng-container>\n            </div>\n          </ng-template>\n        </fsw-dynamic-builder>\n      </form>\n    </section>\n  </main>\n</section>\n", styles: ["::ng-deep .fsw-table *{font-size:12px!important;--fsw-button-height: 28px}\n"], dependencies: [{ kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$4.FSWDynamicBuilderTemplateDirective, selector: "[fswDynamicBuilderTemplate]", inputs: ["key"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerTransactionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-buyer-transaction', changeDetection: ChangeDetectionStrategy.OnPush, template: "<section>\n  <aside>\n    <h6>Buyer Transactions</h6>\n  </aside>\n  <main>\n    <section class=\"flex flex-col gap-3\">\n      <header class=\"w-[328px]\">\n        <fsw-field [fullWidth]=\"true\">\n          <fsw-select\n            [formControl]=\"buyerControl\"\n            [placeHolder]=\"'Select Buyer'\"\n            [isMultiple]=\"true\"\n          >\n            <ng-container *ngFor=\"let buyer of buyers$ | async\">\n              <ng-template\n                fswSelectItem\n                textSize=\"s\"\n                [value]=\"buyer.id\"\n                [text]=\"buyer.name\"\n                [showCheckIcon]=\"true\"\n                let-selected\n              ></ng-template>\n            </ng-container>\n          </fsw-select>\n        </fsw-field>\n      </header>\n      <form [formGroup]=\"formGroup\">\n        <fsw-dynamic-builder [builder]=\"builder\">\n          <ng-template\n            fswDynamicBuilderTemplate\n            key=\"transaction-action\"\n            let-control=\"control\"\n            let-index=\"index\"\n          >\n            <!-- <ng-container *ngIf=\"getReadonly(control.parent.parent) | async as mode\">\n              <button\n                fswButton\n                *ngIf=\"mode === 'editable'\"\n                appearance=\"icon-with-bg\"\n                [size]=\"'s'\"\n                (click)=\"viewTransaction(control.parent.parent, control.parent, index)\"\n              >\n                <i fswIcon=\"common-password-show\"></i>\n              </button>\n            </ng-container> -->\n\n            <ng-container *ngIf=\"getReadonly(control.parent.parent) | async as mode\">\n              <button\n                *ngIf=\"!(isReadonly$ | async) || (!(isReadonly$ | async) && mode === 'readonly')\"\n                fswButton\n                appearance=\"icon-with-bg\"\n                [size]=\"'s'\"\n                (click)=\"\n                  deleteTransaction(\n                    control.parent.parent,\n                    control.parent,\n                    control.parent.parent.parent,\n                    index\n                  )\n                \"\n              >\n                <i fswIcon=\"common-delete-alternative\"></i>\n              </button>\n            </ng-container>\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"transaction-add\" let-control=\"control\">\n            <div\n              class=\"flex gap-1 w-full justify-end\"\n              *ngIf=\"getReadonly(control.parent.parent) | async as mode\"\n            >\n              <ng-container [ngSwitch]=\"mode\">\n                <ng-container *ngSwitchCase=\"'readonly'\">\n                  <button\n                    *ngIf=\"!(isReadonly$ | async)\"\n                    fswButton\n                    appearance=\"icon-with-bg\"\n                    [size]=\"'s'\"\n                    (click)=\"setReadonly(control.parent.parent, false)\"\n                  >\n                    <i fswIcon=\"common-edit\"></i>\n                  </button>\n                </ng-container>\n\n                <ng-container *ngSwitchCase=\"'editable'\">\n                  <button\n                    fswButton\n                    appearance=\"icon-with-bg\"\n                    [size]=\"'s'\"\n                    (click)=\"addTransaction(control.parent.parent)\"\n                  >\n                    <i fswIcon=\"common-add\"></i>\n                  </button>\n                  <button\n                    fswButton\n                    appearance=\"icon-with-bg\"\n                    [size]=\"'s'\"\n                    (click)=\"saveAllTransactions(control.parent.parent)\"\n                  >\n                    <i fswIcon=\"common-document\"></i>\n                  </button>\n                  <button\n                    fswButton\n                    appearance=\"icon-with-bg\"\n                    [size]=\"'s'\"\n                    (click)=\"setReadonly(control.parent.parent, true)\"\n                  >\n                    <i fswIcon=\"common-close\"></i>\n                  </button>\n                </ng-container>\n              </ng-container>\n            </div>\n          </ng-template>\n        </fsw-dynamic-builder>\n      </form>\n    </section>\n  </main>\n</section>\n", styles: ["::ng-deep .fsw-table *{font-size:12px!important;--fsw-button-height: 28px}\n"] }]
        }], propDecorators: { applicationId: [{
                type: Input
            }], salesOrCredit: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

var tables$6 = {
	buyerInfo: {
		columns: {
			invoice_date: "Invoice Date",
			contract_no: "Contract No.",
			contract_amount: "Contract Amount",
			due_date: "Due Date",
			date_of_receipt_of_cash: "Date of Receipt of Cash",
			received_amt: "Received Amt",
			difference: "Difference",
			days_after_invoice: "Days After Invoice",
			payment_method: "Payment Method",
			project_description: "Project Description"
		}
	}
};
var empty$i = {
	buyers: "No Transactions are found"
};
var buttons$T = {
	cancel: "Cancel",
	refresh: "Refresh",
	save_changes: "Save Changes",
	add_buyer: "Add Transaction",
	delete_buyer: "Delete Transaction",
	edit_details: "Edit Transaction",
	back: "Back",
	"import": "Import",
	no: "No",
	yes: "Yes",
	change_status: "Change Status"
};
var forms$6 = {
	buyer: {
		invoice_date: "Invoice Date",
		contract_no: "Contract No.",
		contract_amount: "Contract Amount",
		due_date: "Due Date",
		date_of_receipt_of_cash: "Date of Receipt of Cash",
		received_amt: "Received Amt",
		difference: "Difference",
		days_after_invoice: "Days After Invoice",
		payment_method: "Payment Method",
		project_description: "Project Description"
	}
};
var modals$9 = {
	buyer: {
		edit: "Edit Transaction",
		"new": "New Transaction",
		confirm_add: "Are you sure you want to add this Transaction ?",
		confirm_add_title: "Confirm Add Transaction",
		confirm_edit: "Are you sure you want to update this Transaction ?",
		confirm_edit_title: "Confirm Edit Transaction",
		confirm_delete: "You will lose all the information, Are you sure you want to delete this Transaction ?",
		confirm_delete_title: "Confirm Delete Transaction"
	}
};
var th$8 = {
	tables: tables$6,
	empty: empty$i,
	buttons: buttons$T,
	forms: forms$6,
	modals: modals$9
};

var th$9 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$T,
    default: th$8,
    empty: empty$i,
    forms: forms$6,
    modals: modals$9,
    tables: tables$6
});

const BUYER_TRANSACTION_TRANSLATION_LOADER = {
    [CountryCode.TH]: th$9,
};

const THBuyerTransactionForm = (form, type, method, state, isReadonly$) => {
    const translation = BUYER_TRANSACTION_TRANSLATION_LOADER[CountryCode.TH];
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'w-full',
        readonlyWhen$: isReadonly$,
        renderBy: 'container',
        containers: getContainers$3(type, method, translation, state),
        form,
    });
};
function getContainers$3(type, method, translation, state) {
    switch (type) {
        case BuyerSalesOrCredit.SALES:
            return getBuyerContainersSales(method, translation, state);
        case BuyerSalesOrCredit.CREDIT:
        default:
            return getBuyerContainersCredit(method, translation, state);
    }
}
function getBuyerContainersSales(method, translation, state) {
    let hiddenObj = {};
    if (method === 'POST') {
        hiddenObj = {
            buyer_name: '',
            incorporation: '',
            avg_days_suppliers: 0,
            revenue: 0,
            profit: 0,
            total_net_worth: 0,
            de_ratio: 0,
            current_ratio: 0,
            credit_exposure: '',
            reputation_check: '',
            verification_with_buyer: '',
            note: '',
        };
    }
    else {
        hiddenObj['id'] = '';
    }
    const keys = Object.keys(hiddenObj);
    const containers = keys.length
        ? [
            {
                customClasses: 'hidden',
                fields: keys.map((key) => ({
                    key,
                    type: FSWDynamicBuilderControlTypes.TEMPLATE,
                    context: {
                        defaultValue: hiddenObj[key],
                        isHidden: true,
                    },
                })),
            },
        ]
        : [];
    return [
        {
            customClasses: 'flex justify-between gap-[16px]',
            containers: [
                {
                    customClasses: 'flex-1 flex flex-col gap-[16px] w-[calc(50%-8px)]',
                    fields: [
                        {
                            key: 'name',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                label: translation.forms.buyer.name,
                                fullWidth: true,
                                isRequired: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'credit_term',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number',
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                defaultValue: 0,
                                label: translation.forms.buyer.credit_term,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'sales_thb_month',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number',
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                defaultValue: 0,
                                label: translation.forms.buyer.sales_thb_month,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'method_of_payment',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                label: translation.forms.buyer.method_of_payment,
                                items: BUYER_PAYMENT_METHODS.map((item) => ({
                                    text: item,
                                    value: item,
                                })),
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => {
                                    const text = BUYER_PAYMENT_METHODS.find((item) => item === value);
                                    return text ?? 'N/A';
                                },
                            },
                            validations: [Validators.required],
                        },
                    ],
                },
                {
                    customClasses: 'flex-1 flex flex-col gap-[16px] w-[calc(50%-8px)]',
                    fields: [
                        {
                            key: 'include_in_financing',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                defaultValue: 'Yes',
                                label: translation.forms.buyer.include_in_financing,
                                items: ['Yes', 'No'].map((item) => ({
                                    text: item,
                                    value: item,
                                })),
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => {
                                    const text = ['Yes', 'No'].find((item) => item === value);
                                    return text ?? 'N/A';
                                },
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'trading_history',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                label: translation.forms.buyer.trading_history,
                                fullWidth: true,
                                isRequired: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'remark',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                inputType: 'area',
                                placeHolder: 'Please enter remarks',
                                defaultValue: null,
                                label: translation.forms.buyer.remark,
                                isRequired: true,
                                fullWidth: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'status',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                label: translation.forms.buyer.status,
                                defaultValue: 'NORMAL',
                                fullWidth: true,
                                isRequired: true,
                                isDisabled: true,
                            },
                            validations: [Validators.required],
                        },
                    ],
                },
            ],
        },
        ...containers,
    ];
}
function getBuyerContainersCredit(method, translation, state) {
    let hiddenObj = {};
    if (method === 'POST') {
        hiddenObj = {
            buyer_name: '',
            incorporation: '',
            avg_days_suppliers: 0,
            revenue: 0,
            profit: 0,
            total_net_worth: 0,
            de_ratio: 0,
            current_ratio: 0,
            credit_exposure: '',
            reputation_check: '',
            verification_with_buyer: '',
            note: '',
        };
    }
    else {
        hiddenObj['id'] = '';
    }
    const keys = Object.keys(hiddenObj);
    const containers = keys.length
        ? [
            {
                customClasses: 'hidden',
                fields: keys.map((key) => ({
                    key,
                    type: FSWDynamicBuilderControlTypes.TEMPLATE,
                    context: {
                        defaultValue: hiddenObj[key],
                        isHidden: true,
                    },
                })),
            },
        ]
        : [];
    return [
        {
            customClasses: 'flex justify-between gap-[16px]',
            containers: [
                {
                    customClasses: 'flex-1 flex flex-col gap-[16px] w-[calc(50%-8px)]',
                    fields: [
                        {
                            key: 'name',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                label: translation.forms.buyer.name,
                                fullWidth: true,
                                isRequired: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'credit_term',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number',
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.buyer.credit_term,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'sales_thb_month',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number',
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                defaultValue: 0,
                                label: translation.forms.buyer.sales_thb_month,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'method_of_payment',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                label: translation.forms.buyer.method_of_payment,
                                items: BUYER_PAYMENT_METHODS.map((item) => ({
                                    text: item,
                                    value: item,
                                })),
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => {
                                    const text = BUYER_PAYMENT_METHODS.find((item) => item === value);
                                    return text ?? 'N/A';
                                },
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'include_in_financing',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                defaultValue: 'Yes',
                                label: translation.forms.buyer.include_in_financing,
                                items: ['Yes', 'No'].map((item) => ({
                                    text: item,
                                    value: item,
                                })),
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => {
                                    const text = ['Yes', 'No'].find((item) => item === value);
                                    return text ?? 'N/A';
                                },
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'trading_history',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                label: translation.forms.buyer.trading_history,
                                fullWidth: true,
                                isRequired: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'remark',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                inputType: 'area',
                                placeHolder: 'Please enter remarks',
                                defaultValue: null,
                                label: translation.forms.buyer.remark,
                                isRequired: true,
                                fullWidth: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'incorporation',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number',
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.buyer.incorporation,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'supplier_payment_days',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number',
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.buyer.supplier_payment_days,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'reported_year',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                defaultValue: new Date().getFullYear(),
                                label: translation.forms.buyer.reported_year,
                                items: Array.from({ length: 4 }, (_, i) => new Date().getFullYear() - i).map((item) => ({
                                    text: item,
                                    value: item,
                                })),
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => {
                                    const text = Array.from({ length: 4 }, (_, i) => new Date().getFullYear() - i).find((item) => item === value);
                                    return text;
                                },
                            },
                            validations: [Validators.required],
                        },
                    ],
                },
                {
                    customClasses: 'flex-1 flex flex-col gap-[16px] w-[calc(50%-8px)]',
                    fields: [
                        {
                            key: 'revenue',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number',
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.buyer.revenue,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'profit',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number',
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.buyer.profit,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'total_net_worth',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                label: translation.forms.buyer.total_net_worth,
                                fullWidth: true,
                                isRequired: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'd_e_ratio',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number',
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.buyer.d_e_ratio,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'current_ratio',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number',
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.buyer.current_ratio,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'credit_exposure',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                label: translation.forms.buyer.credit_exposure,
                                fullWidth: true,
                                isRequired: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'reputation_check',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                defaultValue: 'Yes',
                                label: translation.forms.buyer.reputation_check,
                                items: ['Yes', 'No'].map((item) => ({
                                    text: item,
                                    value: item,
                                })),
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => {
                                    const text = ['Yes', 'No'].find((item) => item === value);
                                    return text ?? 'N/A';
                                },
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'verification_with_buyer',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                defaultValue: 'Yes',
                                label: translation.forms.buyer.verification_with_buyer,
                                items: ['Yes', 'No'].map((item) => ({
                                    text: item,
                                    value: item,
                                })),
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => {
                                    const text = ['Yes', 'No'].find((item) => item === value);
                                    return text ?? 'N/A';
                                },
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'note',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                inputType: 'area',
                                placeHolder: 'Please enter remarks',
                                defaultValue: null,
                                label: translation.forms.buyer.note,
                                isRequired: true,
                                fullWidth: true,
                            },
                            validations: [Validators.required],
                        },
                    ],
                },
            ],
        },
        ...containers,
    ];
}

const BUYER_TRANSACTION_FORM_TOKEN = new InjectionToken('BUYER_TRANSACTION_FORM_TOKEN');

class THBuyerTransactionStore extends BuyerTransactionStore {
    init() {
        // TODO: Implement this method if needed
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: THBuyerTransactionStore, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: THBuyerTransactionStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: THBuyerTransactionStore, decorators: [{
            type: Injectable
        }] });

const BUYER_TRANSACTION_TH_PROVIDERS = [
    {
        provide: BUYER_TRANSACTION_FORM_TOKEN,
        useValue: THBuyerTransactionForm,
    },
    {
        provide: BUYER_TRANSACTION_STORE_TOKEN,
        useClass: THBuyerTransactionStore,
        deps: [BUYER_SERVICE_TOKEN, FSW_ALERT_SERVICE_TOKEN],
    },
];

const BUYER_TRANSACTION_PROVIDERS = {
    default: BUYER_TRANSACTION_TH_PROVIDERS,
    [CountryCode.TH]: BUYER_TRANSACTION_TH_PROVIDERS,
};
const buyerTransactionLoadProviders = (countryCode) => [
    fswTranslateScope('buyer-transaction'),
    ...getCustomProviders(BUYER_TRANSACTION_PROVIDERS, BUYER_TRANSACTION_TH_PROVIDERS, countryCode),
];

class FSWBuyerTransactionDirective {
    constructor(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
        this.applicationId = null;
        this.salesOrCredit = BuyerSalesOrCredit.SALES;
        this.isReadonly = false;
    }
    ngOnChanges() {
        this._viewContainerRef.clear();
        const ref = this._viewContainerRef.createComponent(FSWBuyerTransactionComponent, {
            injector: Injector.create({
                parent: this._viewContainerRef.injector,
                providers: [...buyerTransactionLoadProviders(getCountryCodeFromStorage())],
            }),
        });
        const instance = ref.instance;
        instance.applicationId = this.applicationId;
        instance.salesOrCredit = this.salesOrCredit;
        instance.isReadonly = this.isReadonly;
        ref.changeDetectorRef.detectChanges();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerTransactionDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWBuyerTransactionDirective, selector: "[fswBuyerTransaction]", inputs: { applicationId: "applicationId", salesOrCredit: "salesOrCredit", isReadonly: "isReadonly" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerTransactionDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswBuyerTransaction]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; }, propDecorators: { applicationId: [{
                type: Input
            }], salesOrCredit: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

// import { FSWBuyerInfoGridItemDirective } from './components/buyer-info-grid/buyer-info-grid-item.directive';
// import { FSWBuyerInfoGridPipe } from './components/buyer-info-grid/buyer-info-grid.pipe';
class FSWBuyerTransactionModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerTransactionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerTransactionModule, declarations: [FSWBuyerTransactionDirective,
            FSWBuyerTransactionComponent,
            // FSWBuyerInfoGridComponent,
            // FSWBuyerInfoHeaderComponent,
            FSWBuyerTransactionSaveComponent,
            FSWBuyerTransactionConfirmComponent], imports: [JsonPipe, i1$4.FSWTranslateModule, FSWButtonModule,
            NgIf,
            FSWSwitchModule,
            FormsModule,
            FSWAlertModule,
            FSWModalModule$1,
            NgSwitch,
            AsyncPipe,
            NgSwitchCase,
            NgSwitchDefault,
            FSWDynamicBuilderModule,
            ReactiveFormsModule,
            FSWIconModule,
            FSWFieldModule,
            FSWSelectModule,
            NgForOf,
            NgTemplateOutlet,
            FSWPaginationModule$1,
            BuyerServiceModule], exports: [FSWBuyerTransactionDirective,
            FSWBuyerTransactionComponent,
            // FSWBuyerInfoGridComponent,
            // FSWBuyerInfoHeaderComponent,
            FSWBuyerTransactionSaveComponent,
            FSWBuyerTransactionConfirmComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerTransactionModule, imports: [FSWTranslateModule.forFeature({
                scope: 'buyer-transaction',
                defaultKey: CountryCode.TH,
                data: BUYER_TRANSACTION_TRANSLATION_LOADER,
            }),
            FSWButtonModule,
            FSWSwitchModule,
            FormsModule,
            FSWAlertModule,
            FSWModalModule$1,
            FSWDynamicBuilderModule,
            ReactiveFormsModule,
            FSWIconModule,
            FSWFieldModule,
            FSWSelectModule,
            FSWPaginationModule$1,
            BuyerServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerTransactionModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FSWBuyerTransactionDirective,
                        FSWBuyerTransactionComponent,
                        // FSWBuyerInfoGridComponent,
                        // FSWBuyerInfoHeaderComponent,
                        FSWBuyerTransactionSaveComponent,
                        FSWBuyerTransactionConfirmComponent,
                        // FSWBuyerInfoGridPipe,
                        // FSWBuyerInfoGridItemDirective,
                    ],
                    exports: [
                        FSWBuyerTransactionDirective,
                        FSWBuyerTransactionComponent,
                        // FSWBuyerInfoGridComponent,
                        // FSWBuyerInfoHeaderComponent,
                        FSWBuyerTransactionSaveComponent,
                        FSWBuyerTransactionConfirmComponent,
                        // FSWBuyerInfoGridPipe,
                        // FSWBuyerInfoGridItemDirective,
                    ],
                    imports: [
                        JsonPipe,
                        FSWTranslateModule.forFeature({
                            scope: 'buyer-transaction',
                            defaultKey: CountryCode.TH,
                            data: BUYER_TRANSACTION_TRANSLATION_LOADER,
                        }),
                        FSWButtonModule,
                        NgIf,
                        FSWSwitchModule,
                        FormsModule,
                        FSWAlertModule,
                        FSWModalModule$1,
                        NgSwitch,
                        AsyncPipe,
                        NgSwitchCase,
                        NgSwitchDefault,
                        FSWDynamicBuilderModule,
                        ReactiveFormsModule,
                        FSWIconModule,
                        FSWFieldModule,
                        FSWSelectModule,
                        NgForOf,
                        NgTemplateOutlet,
                        FSWPaginationModule$1,
                        BuyerServiceModule,
                    ],
                }]
        }] });

// for loading form's config after selecting item in table and show in modal
var FSWBuyerTransactionFormTypes;
(function (FSWBuyerTransactionFormTypes) {
    FSWBuyerTransactionFormTypes[FSWBuyerTransactionFormTypes["ADD_BUYER"] = 0] = "ADD_BUYER";
    FSWBuyerTransactionFormTypes[FSWBuyerTransactionFormTypes["FACILITY"] = 1] = "FACILITY";
    FSWBuyerTransactionFormTypes[FSWBuyerTransactionFormTypes["FACILITY_IMPORT"] = 2] = "FACILITY_IMPORT";
    FSWBuyerTransactionFormTypes[FSWBuyerTransactionFormTypes["FACILITY_AFTER_IMPORT"] = 3] = "FACILITY_AFTER_IMPORT";
})(FSWBuyerTransactionFormTypes || (FSWBuyerTransactionFormTypes = {}));

// @angular
class FSWBuyerComponent {
    constructor() {
        this._applicationId = '';
        this._salesOrCredit = BuyerSalesOrCredit.SALES;
        this._isReadonly = false;
        this.comments = [];
        this._destroySubject = new Subject();
    }
    set applicationId(value) {
        this._applicationId = value;
    }
    get applicationId() {
        return this._applicationId;
    }
    set salesOrCredit(value) {
        this._salesOrCredit = value;
    }
    get salesOrCredit() {
        return this._salesOrCredit;
    }
    set isReadonly(value) {
        this._isReadonly = value;
    }
    get isReadonly() {
        return this._isReadonly;
    }
    ngOnDestroy() {
        if (this._destroySubject) {
            this._destroySubject.next(0);
            this._destroySubject.complete();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWBuyerComponent, selector: "fsw-buyer", inputs: { applicationId: "applicationId", salesOrCredit: "salesOrCredit", isReadonly: "isReadonly" }, ngImport: i0, template: `
    <div class="w-100">
      <section class="flex flex-col gap-12">
        <ng-container
          [applicationId]="applicationId"
          [salesOrCredit]="salesOrCredit"
          [isReadonly]="isReadonly"
          fswBuyerInformation
        ></ng-container>

        <ng-container
          *ngIf="salesOrCredit === 'CREDIT'"
          [applicationId]="applicationId"
          [salesOrCredit]="salesOrCredit"
          [isReadonly]="isReadonly"
          fswBuyerTransaction
        ></ng-container>
      </section>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: FSWBuyerInformationDirective, selector: "[fswBuyerInformation]", inputs: ["applicationId", "salesOrCredit", "isReadonly"] }, { kind: "directive", type: FSWBuyerTransactionDirective, selector: "[fswBuyerTransaction]", inputs: ["applicationId", "salesOrCredit", "isReadonly"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-buyer',
                    template: `
    <div class="w-100">
      <section class="flex flex-col gap-12">
        <ng-container
          [applicationId]="applicationId"
          [salesOrCredit]="salesOrCredit"
          [isReadonly]="isReadonly"
          fswBuyerInformation
        ></ng-container>

        <ng-container
          *ngIf="salesOrCredit === 'CREDIT'"
          [applicationId]="applicationId"
          [salesOrCredit]="salesOrCredit"
          [isReadonly]="isReadonly"
          fswBuyerTransaction
        ></ng-container>
      </section>
    </div>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { applicationId: [{
                type: Input
            }], salesOrCredit: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

const DECLARATIONS_EXPORTS$4 = [FSWBuyerComponent];
class FSWBuyerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerModule, declarations: [FSWBuyerComponent], imports: [CommonModule,
            LetDirective,
            FormWidgetModule,
            NgForOf,
            AsyncPipe,
            CurrencyFormatModule,
            NgIf,
            ReactiveFormsModule,
            // toolkit-ui
            FSWButtonModule,
            FSWDynamicBuilderModule,
            FSWFieldModule,
            FSWInputModule,
            FSWModalModule$1,
            FSWPanelModule,
            FSWSelectModule,
            FSWTabsModule,
            FSWValueChangesPipeModule,
            FSWAlertModule,
            DialogModule,
            // services modules
            UtilsServiceModule,
            BuyerServiceModule,
            // custom modules
            FSWBuyerInformationModule,
            FSWBuyerTransactionModule], exports: [FSWBuyerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerModule, providers: [
            {
                provide: BUYER_HELPER_SERVICE_TOKEN,
                useClass: BuyerHelperService,
            },
        ], imports: [CommonModule,
            FormWidgetModule,
            CurrencyFormatModule,
            ReactiveFormsModule,
            // toolkit-ui
            FSWButtonModule,
            FSWDynamicBuilderModule,
            FSWFieldModule,
            FSWInputModule,
            FSWModalModule$1,
            FSWPanelModule,
            FSWSelectModule,
            FSWTabsModule,
            FSWValueChangesPipeModule,
            FSWAlertModule,
            DialogModule,
            // services modules
            UtilsServiceModule,
            BuyerServiceModule,
            // custom modules
            FSWBuyerInformationModule,
            FSWBuyerTransactionModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBuyerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        LetDirective,
                        FormWidgetModule,
                        NgForOf,
                        AsyncPipe,
                        CurrencyFormatModule,
                        NgIf,
                        ReactiveFormsModule,
                        // toolkit-ui
                        FSWButtonModule,
                        FSWDynamicBuilderModule,
                        FSWFieldModule,
                        FSWInputModule,
                        FSWModalModule$1,
                        FSWPanelModule,
                        FSWSelectModule,
                        FSWTabsModule,
                        FSWValueChangesPipeModule,
                        FSWAlertModule,
                        DialogModule,
                        // services modules
                        UtilsServiceModule,
                        BuyerServiceModule,
                        // custom modules
                        FSWBuyerInformationModule,
                        FSWBuyerTransactionModule,
                    ],
                    declarations: DECLARATIONS_EXPORTS$4,
                    exports: DECLARATIONS_EXPORTS$4,
                    providers: [
                        {
                            provide: BUYER_HELPER_SERVICE_TOKEN,
                            useClass: BuyerHelperService,
                        },
                    ],
                }]
        }] });

var title$B = "CBS Screening";
var sub_title$1 = "CBS Documents";
var pdf_title = "CBS PDF Viewer";
var error_title = "CBS Error Viewer";
var empty$h = "Empty CBS Documents";
var buttons$S = {
	upload_new: "Upload new CBS",
	parse: "Parse",
	re_parse: "Re-parse",
	view_error: "View error",
	cancel: "Cancel",
	upload: "Upload",
	yes: "Yes",
	no: "No"
};
var columns$b = {
	name: "Name",
	uploaded_date: "Uploaded date",
	parsing_status: "Parsing status",
	action: "Action",
	last_parsed: "Last parsed"
};
var confirmation$2 = {
	parse: {
		title: "Confirm Parse Document",
		description: "Are you sure you want to parse this Document {{name}} ?"
	},
	"delete": {
		title: "Confirm Delete Document",
		description: "You will lose all the information, Are you sure you want to delete this Document {{name}} ?"
	}
};
var modals$8 = {
	upload: {
		title: "Upload CBS Document",
		description: "Upload a new CBS Document"
	}
};
var cbsSummarySg = {
	title: title$B,
	sub_title: sub_title$1,
	pdf_title: pdf_title,
	error_title: error_title,
	empty: empty$h,
	buttons: buttons$S,
	columns: columns$b,
	confirmation: confirmation$2,
	modals: modals$8
};

var SG$9 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$S,
    columns: columns$b,
    confirmation: confirmation$2,
    default: cbsSummarySg,
    empty: empty$h,
    error_title: error_title,
    modals: modals$8,
    pdf_title: pdf_title,
    sub_title: sub_title$1,
    title: title$B
});

const SG_CBS_SUMMARY_TRANSLATION = SG$9;

function injectCbsSummarySGEffects(refreshedAt, docs, selectedDoc, injector) {
    const blobService = inject(BLOB_SERVICE_TOKEN);
    const loanService = inject(FSW_LOAN_SERVICE_TOKEN);
    const alertService = inject(FSW_ALERT_SERVICE_TOKEN);
    return {
        refreshDocs: (memberId) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => blobService.getMemberDoc(memberId).pipe(map((docs) => (docs || []).filter((doc) => doc.docType === 'CBS')), switchMap$1((docs) => {
            if (!docs.length) {
                return of([]);
            }
            return loanService
                .getParsedCBS(docs.map((doc) => doc.uuid), false)
                .pipe(map((parsedDocs) => docs.map((doc) => ({
                info: doc,
                cbs: parsedDocs.find((parsedDoc) => parsedDoc.doc_id === doc.uuid),
            }))));
        }))), tap((data) => {
            docs.set(data);
            if (docs()?.length) {
                const existed = docs().find((doc) => doc.info.id === selectedDoc()?.info?.id);
                selectedDoc.set(existed ?? docs()[docs().length - 1]);
            }
            else {
                selectedDoc.set(null);
            }
        }), catchError(() => {
            alertService.error('Failed to load member documents', null, {
                duration: 3000,
            });
            docs.set([]);
            selectedDoc.set(null);
            return of([]);
        })), injector, []))),
        deleteDoc: (doc) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => blobService.deleteSingleDocV3(doc.info.id)), tap(() => refreshedAt.set(new Date())), tap(() => alertService.success('Delete document successfully!', null, {
            duration: 3000,
        })), catchError(() => {
            alertService.error('Failed to delete document', null, {
                duration: 3000,
            });
            return of(null);
        })), injector))),
        parseDoc: (doc) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => loanService.parseCBS([doc.info.uuid], true)), tap(() => refreshedAt.set(new Date())), tap(() => alertService.success('Parse document successfully!', null, {
            duration: 3000,
        })), catchError(() => {
            alertService.error('Failed to parse document', null, {
                duration: 3000,
            });
            return of(null);
        })), injector))),
        uploadDoc: (doc) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => blobService.uploadMemberDoc(doc)), tap(() => refreshedAt.set(new Date())), tap(() => alertService.success('Upload document successfully!', null, {
            duration: 3000,
        })), catchError(() => {
            alertService.error('Failed to upload document', null, {
                duration: 3000,
            });
            return of(null);
        })), injector))),
    };
}

function injectCbsSummaryEffects(refreshedAt, docs, selectedDoc, injector) {
    switch (getCountryCodeFromStorage()) {
        case CountryCode.SG:
            return injectCbsSummarySGEffects(refreshedAt, docs, selectedDoc, injector);
        default:
            return injectCbsSummarySGEffects(refreshedAt, docs, selectedDoc, injector);
    }
}

function provideCbsSummaryTranslation() {
    return [
        ...(FSWTranslateModule.forFeature({
            scope: 'cbs_summary',
            defaultKey: CountryCode.SG,
            data: {
                [CountryCode.SG]: SG_CBS_SUMMARY_TRANSLATION,
            },
        }).providers || []),
        fswTranslateScope('cbs_summary'),
    ];
}

class FSWCbsSummaryUploadComponent {
    constructor() {
        this.dialogRef = inject(DialogRef);
        this.cdr = inject(ChangeDetectorRef);
        this.selectedFile = undefined;
        this.error = undefined;
        this.message = 'File size exceeds maximum limit 30 MB.';
    }
    close(file) {
        this.dialogRef.close(file);
    }
    selectFile(event) {
        const target = event.target;
        const pickedFile = target.files[0];
        if (pickedFile.size > FSW_DOC_UPLOAD.MAXIMUM_UPLOAD_SIZE) {
            this.error = this.message;
            target.value = '';
            this.cdr.markForCheck();
            return;
        }
        this.error = undefined;
        this.selectedFile = pickedFile;
        this.cdr.markForCheck();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCbsSummaryUploadComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCbsSummaryUploadComponent, isStandalone: true, selector: "fsw-cbs-summary-upload", providers: [provideCbsSummaryTranslation()], ngImport: i0, template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"'modals.upload.title' | fswTranslate\"\n  [confirmButton]=\"'buttons.upload' | fswTranslate\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate\"\n  (confirmEvent)=\"close(selectedFile)\"\n  (cancelEvent)=\"close(undefined)\"\n  (closeEvent)=\"close(undefined)\"\n>\n  <ng-template fswModalBody>\n    <section\n      class=\"w-full px-4 py-20 flex items-center justify-center relative bg-white hover:cursor-pointer hover:shadow-lightest shadow-small rounded-xl\"\n      (click)=\"file.click()\"\n    >\n      <p\n        [class.text-red-500]=\"error\"\n        class=\"font-inter text-center font-semibold text-body-default-500 break-words\"\n      >\n        {{\n          selectedFile\n            ? selectedFile.name\n            : error\n            ? error\n            : ('modals.upload.description' | fswTranslate)\n        }}\n      </p>\n      <span\n        class=\"font-inter text-body-caption-500 text-gray-400 absolute bottom-[8px] left-[8px]\"\n        >{{ message }}</span\n      >\n    </section>\n    <input #file class=\"hidden\" type=\"file\" (change)=\"selectFile($event)\" />\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "ngmodule", type: FSWModalModule$1 }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCbsSummaryUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cbs-summary-upload', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [FSWModalModule$1, FSWTranslateModule], providers: [provideCbsSummaryTranslation()], template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"'modals.upload.title' | fswTranslate\"\n  [confirmButton]=\"'buttons.upload' | fswTranslate\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate\"\n  (confirmEvent)=\"close(selectedFile)\"\n  (cancelEvent)=\"close(undefined)\"\n  (closeEvent)=\"close(undefined)\"\n>\n  <ng-template fswModalBody>\n    <section\n      class=\"w-full px-4 py-20 flex items-center justify-center relative bg-white hover:cursor-pointer hover:shadow-lightest shadow-small rounded-xl\"\n      (click)=\"file.click()\"\n    >\n      <p\n        [class.text-red-500]=\"error\"\n        class=\"font-inter text-center font-semibold text-body-default-500 break-words\"\n      >\n        {{\n          selectedFile\n            ? selectedFile.name\n            : error\n            ? error\n            : ('modals.upload.description' | fswTranslate)\n        }}\n      </p>\n      <span\n        class=\"font-inter text-body-caption-500 text-gray-400 absolute bottom-[8px] left-[8px]\"\n        >{{ message }}</span\n      >\n    </section>\n    <input #file class=\"hidden\" type=\"file\" (change)=\"selectFile($event)\" />\n  </ng-template>\n</fsw-modal>\n" }]
        }] });

class FSWCbsSummaryConfirmComponent {
    constructor() {
        this.dialogRef = inject(DialogRef);
    }
    close(haveData = false) {
        this.dialogRef.close(haveData);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCbsSummaryConfirmComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCbsSummaryConfirmComponent, isStandalone: true, selector: "fsw-cbs-summary-confirm", providers: [provideCbsSummaryTranslation()], ngImport: i0, template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"'buttons.yes' | fswTranslate\"\n  [cancelButton]=\"'buttons.no' | fswTranslate\"\n  (confirmEvent)=\"close(true)\"\n  (cancelEvent)=\"close(false)\"\n  (closeEvent)=\"close(false)\"\n>\n  <ng-template fswModalBody>\n    <p>\n      {{\n        dialogRef.config.data['description']\n          | fswTranslate : { data: dialogRef.config.data['descriptionParams'] }\n      }}\n    </p>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "ngmodule", type: FSWModalModule$1 }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCbsSummaryConfirmComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cbs-summary-confirm', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [FSWModalModule$1, FSWTranslateModule], providers: [provideCbsSummaryTranslation()], template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"'buttons.yes' | fswTranslate\"\n  [cancelButton]=\"'buttons.no' | fswTranslate\"\n  (confirmEvent)=\"close(true)\"\n  (cancelEvent)=\"close(false)\"\n  (closeEvent)=\"close(false)\"\n>\n  <ng-template fswModalBody>\n    <p>\n      {{\n        dialogRef.config.data['description']\n          | fswTranslate : { data: dialogRef.config.data['descriptionParams'] }\n      }}\n    </p>\n  </ng-template>\n</fsw-modal>\n" }]
        }] });

function injectCbsPdfViewerSGEffects(src, injector) {
    const blobService = inject(BLOB_SERVICE_TOKEN);
    const alertService = inject(FSW_ALERT_SERVICE_TOKEN);
    const domSanitizer = inject(DomSanitizer);
    return {
        loadDoc: (doc) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => blobService
            .downloadV3Blob(doc.info.uuid)
            .pipe(map((data) => data
            ? domSanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(data))
            : null))), tap((data) => src.set(data)), catchError(() => {
            alertService.error('Failed to load document file', null, {
                duration: 3000,
            });
            src.set(null);
            return of([]);
        })), injector, null))),
    };
}

function injectCbsPdfViewerEffects(src, injector) {
    switch (getCountryCodeFromStorage()) {
        case CountryCode.SG:
            return injectCbsPdfViewerSGEffects(src, injector);
        default:
            return injectCbsPdfViewerSGEffects(src, injector);
    }
}

class CbsPdfViewerComponent {
    constructor() {
        this.updated = new EventEmitter();
        this.selectedDoc = signal({});
        this.src = signal(null);
        this.injector = inject(Injector);
        this.effects = injectCbsPdfViewerEffects(this.src, this.injector);
        effect(() => {
            if (!untracked(() => this.src())) {
                this.effects.loadDoc(this.selectedDoc());
            }
        }, { allowSignalWrites: true });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsPdfViewerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CbsPdfViewerComponent, isStandalone: true, selector: "fsw-cbs-pdf-viewer", ngImport: i0, template: "<ng-container *ngIf=\"src() as src\">\n  <section class=\"w-full h-[80vh]\">\n    <iframe width=\"100%\" height=\"100%\" [title]=\"selectedDoc().info.name\" [src]=\"src\"></iframe>\n  </section>\n</ng-container>\n", dependencies: [{ kind: "ngmodule", type: FSWBlobServiceModule }, { kind: "ngmodule", type: FSWAlertModule }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsPdfViewerComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'fsw-cbs-pdf-viewer', imports: [FSWBlobServiceModule, FSWAlertModule, NgIf], template: "<ng-container *ngIf=\"src() as src\">\n  <section class=\"w-full h-[80vh]\">\n    <iframe width=\"100%\" height=\"100%\" [title]=\"selectedDoc().info.name\" [src]=\"src\"></iframe>\n  </section>\n</ng-container>\n" }]
        }], ctorParameters: function () { return []; } });

var CBSPermissionEnum;
(function (CBSPermissionEnum) {
    CBSPermissionEnum["SUMMARY_SECTION"] = "SUMMARY_SECTION";
    CBSPermissionEnum["FRAUD_SCREENING_SECTION"] = "FRAUD_SCREENING_SECTION";
    CBSPermissionEnum["PARSE_RESULT_SECTION"] = "PARSE_RESULT_SECTION";
    CBSPermissionEnum["PDF_VIEWER_SECTION"] = "PDF_VIEWER_SECTION";
    CBSPermissionEnum["SUMMARY_UPLOAD"] = "SUMMARY_UPLOAD";
    CBSPermissionEnum["SUMMARY_PARSE"] = "SUMMARY_PARSE";
    CBSPermissionEnum["SUMMARY_DELETE"] = "SUMMARY_DELETE";
    CBSPermissionEnum["FRAUD_SCREENING_REFRESH"] = "FRAUD_SCREENING_REFRESH";
    CBSPermissionEnum["FRAUD_SCREENING_UPDATE_JUSTIFICATION"] = "FRAUD_SCREENING_UPDATE_JUSTIFICATION";
})(CBSPermissionEnum || (CBSPermissionEnum = {}));

var CbsPdfViewerDirective_1;
let CbsPdfViewerDirective = class CbsPdfViewerDirective {
    static { CbsPdfViewerDirective_1 = this; }
    static { this.REFRESH_KEY = 'fs-widgets-feature-cbs-pdf-viewer'; }
    constructor(_refreshService, _viewContainerRef) {
        this._refreshService = _refreshService;
        this._viewContainerRef = _viewContainerRef;
        this.updated = new EventEmitter();
        this.expanded = new EventEmitter();
        this.selectedDoc = null;
        this.avoidPermissions = [];
    }
    ngOnInit() {
        this._refreshService
            .register(CbsPdfViewerDirective_1.REFRESH_KEY)
            .pipe(followDestroy(this), tap(() => this.refresh()))
            .subscribe();
    }
    ngOnChanges() {
        this.refresh();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    refresh() {
        this._viewContainerRef.clear();
        if (!this.selectedDoc || this.avoidPermissions.includes(CBSPermissionEnum.PDF_VIEWER_SECTION)) {
            return;
        }
        const ref = this._viewContainerRef.createComponent(CbsPdfViewerComponent);
        const instance = ref.instance;
        instance.selectedDoc.set(this.selectedDoc);
        instance.updated
            .asObservable()
            .pipe(followDestroy(this), tap((selectedDoc) => this.updated.emit(selectedDoc)))
            .subscribe();
        ref.changeDetectorRef.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsPdfViewerDirective, deps: [{ token: RefreshService }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: CbsPdfViewerDirective, isStandalone: true, selector: "[fswCbsPdfViewer]", inputs: { selectedDoc: "selectedDoc", avoidPermissions: "avoidPermissions" }, outputs: { updated: "updated", expanded: "expanded" }, usesOnChanges: true, ngImport: i0 }); }
};
CbsPdfViewerDirective = CbsPdfViewerDirective_1 = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [RefreshService,
        ViewContainerRef])
], CbsPdfViewerDirective);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsPdfViewerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswCbsPdfViewer]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: RefreshService }, { type: i0.ViewContainerRef }]; }, propDecorators: { updated: [{
                type: Output
            }], expanded: [{
                type: Output
            }], selectedDoc: [{
                type: Input,
                args: [{ required: true }]
            }], avoidPermissions: [{
                type: Input
            }] } });

class FSWCbsSummaryPdfComponent {
    constructor() {
        this.dialogRef = inject(DialogRef);
    }
    close() {
        this.dialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCbsSummaryPdfComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCbsSummaryPdfComponent, isStandalone: true, selector: "fsw-cbs-summary-pdf", providers: [provideCbsSummaryTranslation()], ngImport: i0, template: "<fsw-modal [size]=\"'l'\" [title]=\"'pdf_title' | fswTranslate\" (closeEvent)=\"close()\">\n  <ng-template fswModalBody>\n    <ng-container fswCbsPdfViewer [selectedDoc]=\"dialogRef.config.data\" />\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "ngmodule", type: FSWModalModule$1 }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: CbsPdfViewerDirective, selector: "[fswCbsPdfViewer]", inputs: ["selectedDoc", "avoidPermissions"], outputs: ["updated", "expanded"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCbsSummaryPdfComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cbs-summary-pdf', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [FSWModalModule$1, FSWTranslateModule, CbsPdfViewerDirective], providers: [provideCbsSummaryTranslation()], template: "<fsw-modal [size]=\"'l'\" [title]=\"'pdf_title' | fswTranslate\" (closeEvent)=\"close()\">\n  <ng-template fswModalBody>\n    <ng-container fswCbsPdfViewer [selectedDoc]=\"dialogRef.config.data\" />\n  </ng-template>\n</fsw-modal>\n" }]
        }] });

class FSWCbsSummaryErrorComponent {
    constructor() {
        this.dialogRef = inject(DialogRef);
    }
    close() {
        this.dialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCbsSummaryErrorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCbsSummaryErrorComponent, isStandalone: true, selector: "fsw-cbs-summary-error", providers: [provideCbsSummaryTranslation()], ngImport: i0, template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"('error_title' | fswTranslate) + ' ' + dialogRef.config.data.info.name\"\n  (closeEvent)=\"close()\"\n>\n  <ng-template fswModalBody>\n    <section\n      class=\"w-full px-4 py-20 flex items-center justify-center relative bg-white hover:cursor-pointer hover:shadow-lightest shadow-small rounded-xl\"\n    >\n      <p\n        class=\"font-inter text-center text-red-500 font-semibold text-body-default-500 break-words\"\n      >\n        {{ dialogRef.config.data.cbs.error_message }}\n      </p>\n    </section>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "ngmodule", type: FSWModalModule$1 }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCbsSummaryErrorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cbs-summary-error', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [FSWModalModule$1, FSWTranslateModule], providers: [provideCbsSummaryTranslation()], template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"('error_title' | fswTranslate) + ' ' + dialogRef.config.data.info.name\"\n  (closeEvent)=\"close()\"\n>\n  <ng-template fswModalBody>\n    <section\n      class=\"w-full px-4 py-20 flex items-center justify-center relative bg-white hover:cursor-pointer hover:shadow-lightest shadow-small rounded-xl\"\n    >\n      <p\n        class=\"font-inter text-center text-red-500 font-semibold text-body-default-500 break-words\"\n      >\n        {{ dialogRef.config.data.cbs.error_message }}\n      </p>\n    </section>\n  </ng-template>\n</fsw-modal>\n" }]
        }] });

var title$A = "CBS Parsed Result";
var empty$g = "CBS Document didn't parse";
var buttons$R = {
	parse: "Parse"
};
var sections = {
	enquiry: "Enquiry Date",
	date_provided: {
		title: "Data Provided",
		empty: "Empty Data Provided",
		columns: {
			name: "Name",
			id_number: "ID Number",
			date_of_birth: "Date of Birth",
			postal_code: "Postal Code"
		}
	},
	summary: {
		title: "Summary",
		empty: "Empty Summary",
		columns: {
			date_of_earliest_known_credit_account_date: "Date of Earliest Known Credit Account Date",
			previous_enquiries: "Previous Enquiries",
			accounts: "Accounts",
			defaults: "Defaults",
			bankruptcy_proceedings: "Bankruptcy Proceedings",
			secured_credit_limit: "Secured Credit Limit",
			unsecured_credit_limit: "Unsecured Credit Limit",
			exempted_credit_limit: "Exempted Credit Limit"
		}
	},
	personal_details: {
		title: "Personal Details",
		empty: "Empty Personal Details",
		columns: {
			gender: "Gender",
			nationality: "Nationality",
			marital_status: "Marital Status"
		}
	},
	bureau_score: {
		title: "Bureau Score",
		empty: "Empty Bureau Score",
		columns: {
			score: "Score",
			risk_grade: "Risk Grade",
			probability_of_default: "Probability of Default"
		}
	},
	bankruptcy_proceedings: {
		title: "Bankruptcy Proceedings",
		empty: "Empty Bankruptcy Proceedings",
		columns: {
			bankruptcy_number: "Bankruptcy Number",
			order_date: "Order Date",
			petition_date: "Petition Date"
		}
	},
	account_status_history: {
		title: "Account Status History",
		empty: "Empty Account Status History",
		columns: {
			product_type: "Product Type",
			grantor_bank: "Grantor Bank",
			account_type: "Account Type",
			date_opened_vs_closed: "Date Opened / Closed",
			overdue_balance: "Overdue Balance",
			last_12_cycles_vs_cash_advance_vs_full_payment: "Last 12 Cycles / Cash Advance / Full Payment"
		}
	},
	default_records: {
		title: "Default Records",
		empty: "Empty Default Records",
		columns: {
			product: "Product",
			client: "Client",
			date_loaded: "Date Loaded",
			original_amount: "Original Amount",
			balance: "Balance",
			status: "Status",
			status_date: "Status Date"
		}
	},
	aggregate_monthly_balances: {
		title: "Aggregate Outstanding Balances",
		empty: "Empty Aggregate Outstanding Balances",
		sub_title: "Aggregated Outstanding Balances for Preceding {{month}} Months",
		columns: {
			month: "Month",
			product_type: "Product Type",
			grantor_bank: "Grantor Bank",
			secured_balances: "Secured Balances",
			unsecured_balances_interest_bearing: "Unsecured Balances Interest Bearing",
			unsecured_balances_non_interest_bearing: "Unsecured Balances Non-Interest Bearing",
			exempted_unsecured_balances: "Exempted Unsecured Balances"
		}
	},
	aggregate_month_installment: {
		title: "Aggregate Monthly Installment",
		empty: "Empty Aggregate Monthly Installment",
		sub_title: "Aggregated Monthly Instalments for Preceding {{month}} Months",
		columns: {
			month: "Month",
			product_type: "Product Type",
			grantor_bank: "Grantor Bank",
			account_type: "Account Type",
			property: "Property",
			non_property: "Non-Property",
			unsecured: "Unsecured",
			exempted_unsecured: "Exempted Unsecured"
		}
	},
	previous_enquiries: {
		title: "Previous Enquiries",
		empty: "Empty Previous Enquiries",
		columns: {
			date: "Date",
			name_of_bank: "Name of Bank",
			enquiry_type: "Enquiry Type",
			product_type: "Product Type",
			account_type: "Account Type"
		}
	},
	metadata: {
		title: "Metadata",
		empty: "Empty Metadata",
		columns: {
			created_at: "Created at",
			modified_at: "Modified at",
			author: "Author",
			producer: "Producer",
			version: "Version",
			fonts: "Fonts"
		}
	}
};
var cbsParsedResultSg = {
	title: title$A,
	empty: empty$g,
	buttons: buttons$R,
	sections: sections
};

var SG$8 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$R,
    default: cbsParsedResultSg,
    empty: empty$g,
    sections: sections,
    title: title$A
});

const SG_CBS_PARSED_RESULT_TRANSLATION = SG$8;

function injectCbsParsedResultSGEffects(refreshedAt, selectedDoc, injector) {
    const loanService = inject(FSW_LOAN_SERVICE_TOKEN);
    const alertService = inject(FSW_ALERT_SERVICE_TOKEN);
    return {
        parseDoc: () => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => loanService.parseCBS([selectedDoc().info.uuid], true)), tap(() => refreshedAt.set(new Date())), tap(() => alertService.success('Parse document successfully!', null, {
            duration: 3000,
        })), catchError(() => {
            alertService.error('Failed to parse document', null, {
                duration: 3000,
            });
            return of(null);
        })), injector))),
    };
}

function provideCbsParsedResultTranslation() {
    return [
        ...(FSWTranslateModule.forFeature({
            scope: 'cbs_parsed_result',
            defaultKey: CountryCode.SG,
            data: {
                [CountryCode.SG]: SG_CBS_PARSED_RESULT_TRANSLATION,
            },
        }).providers || []),
        fswTranslateScope('cbs_parsed_result'),
    ];
}

function injectCbsParsedResultEffects(refreshedAt, selectedDoc, injector) {
    switch (getCountryCodeFromStorage()) {
        case CountryCode.SG:
            return injectCbsParsedResultSGEffects(refreshedAt, selectedDoc, injector);
        default:
            return injectCbsParsedResultSGEffects(refreshedAt, selectedDoc, injector);
    }
}

class CbsEnquiryDatePipe {
    transform(enquiryDate, showTime) {
        if (!enquiryDate) {
            return '--';
        }
        return `${enquiryDate.day_of_month}/${enquiryDate.month_value}/${enquiryDate.year}${showTime
            ? enquiryDate.hour
                ? ` ${enquiryDate.hour}:${enquiryDate.minute || '00'}:${enquiryDate.second || '00'}`
                : ''
            : ''}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsEnquiryDatePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CbsEnquiryDatePipe, isStandalone: true, name: "toCbsEnquiryDate" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsEnquiryDatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'toCbsEnquiryDate',
                    standalone: true,
                }]
        }] });

class CbsParsedResultAccountStatusHistoryComponent {
    constructor() {
        this.data = null;
        this.isExpanded = signal(true);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultAccountStatusHistoryComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CbsParsedResultAccountStatusHistoryComponent, isStandalone: true, selector: "fsw-cbs-parsed-result-account-status-history", inputs: { data: "data" }, providers: [provideCbsParsedResultTranslation()], ngImport: i0, template: "<fsw-panel\n  [title]=\"'sections.account_status_history.title' | fswTranslate : { scope: 'cbs_parsed_result' }\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <button fswButton [appearance]=\"'icon-no-bg'\" (click)=\"isExpanded.set(!isExpanded())\">\n      <i\n        [fswIcon]=\"'common-arrow-dropdown'\"\n        [class.rotate-90]=\"!isExpanded()\"\n        class=\"transform duration-300\"\n      ></i>\n    </button>\n  </ng-template>\n  <table class=\"fsw-table fsw-table--bordered w-full table-fixed\" *ngIf=\"isExpanded()\">\n    <thead>\n      <tr>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.account_status_history.columns.product_type'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.account_status_history.columns.grantor_bank'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.account_status_history.columns.account_type'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.account_status_history.columns.date_opened_vs_closed'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.account_status_history.columns.overdue_balance'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.account_status_history.columns.last_12_cycles_vs_cash_advance_vs_full_payment'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      <ng-container *ngIf=\"!data?.length; else defaultTemplate\">\n        <tr>\n          <td class=\"align-middle\" colspan=\"6\">\n            <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n              <svg\n                class=\"text-yellow-600\"\n                fill=\"currentColor\"\n                version=\"1.1\"\n                id=\"Capa_1\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n                width=\"100px\"\n                height=\"100px\"\n                viewBox=\"0 0 462.035 462.035\"\n                xml:space=\"preserve\"\n              >\n                <g>\n                  <path\n                    d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n                  />\n                </g>\n              </svg>\n              <p class=\"text-center font-semibold text-body-small-600\">\n                {{\n                  'sections.account_status_history.empty'\n                    | fswTranslate : { scope: 'cbs_parsed_result' }\n                }}\n              </p>\n            </section>\n          </td>\n        </tr>\n      </ng-container>\n      <ng-template #defaultTemplate>\n        <tr *ngFor=\"let item of data!\">\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.product_type }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.grantor_bank }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.account_type }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.date_opened | toCbsEnquiryDate }} / {{ item.date_closed | toCbsEnquiryDate }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.overdue_balance }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.last12_cycles }}\n          </td>\n        </tr>\n      </ng-template>\n    </tbody>\n  </table>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "pipe", type: CbsEnquiryDatePipe, name: "toCbsEnquiryDate" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultAccountStatusHistoryComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'fsw-cbs-parsed-result-account-status-history', imports: [
                        FSWPanelModule,
                        FSWTranslateModule,
                        NgIf,
                        NgForOf,
                        CbsEnquiryDatePipe,
                        FSWButtonModule,
                        FSWIconModule,
                    ], providers: [provideCbsParsedResultTranslation()], template: "<fsw-panel\n  [title]=\"'sections.account_status_history.title' | fswTranslate : { scope: 'cbs_parsed_result' }\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <button fswButton [appearance]=\"'icon-no-bg'\" (click)=\"isExpanded.set(!isExpanded())\">\n      <i\n        [fswIcon]=\"'common-arrow-dropdown'\"\n        [class.rotate-90]=\"!isExpanded()\"\n        class=\"transform duration-300\"\n      ></i>\n    </button>\n  </ng-template>\n  <table class=\"fsw-table fsw-table--bordered w-full table-fixed\" *ngIf=\"isExpanded()\">\n    <thead>\n      <tr>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.account_status_history.columns.product_type'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.account_status_history.columns.grantor_bank'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.account_status_history.columns.account_type'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.account_status_history.columns.date_opened_vs_closed'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.account_status_history.columns.overdue_balance'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.account_status_history.columns.last_12_cycles_vs_cash_advance_vs_full_payment'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      <ng-container *ngIf=\"!data?.length; else defaultTemplate\">\n        <tr>\n          <td class=\"align-middle\" colspan=\"6\">\n            <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n              <svg\n                class=\"text-yellow-600\"\n                fill=\"currentColor\"\n                version=\"1.1\"\n                id=\"Capa_1\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n                width=\"100px\"\n                height=\"100px\"\n                viewBox=\"0 0 462.035 462.035\"\n                xml:space=\"preserve\"\n              >\n                <g>\n                  <path\n                    d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n                  />\n                </g>\n              </svg>\n              <p class=\"text-center font-semibold text-body-small-600\">\n                {{\n                  'sections.account_status_history.empty'\n                    | fswTranslate : { scope: 'cbs_parsed_result' }\n                }}\n              </p>\n            </section>\n          </td>\n        </tr>\n      </ng-container>\n      <ng-template #defaultTemplate>\n        <tr *ngFor=\"let item of data!\">\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.product_type }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.grantor_bank }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.account_type }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.date_opened | toCbsEnquiryDate }} / {{ item.date_closed | toCbsEnquiryDate }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.overdue_balance }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.last12_cycles }}\n          </td>\n        </tr>\n      </ng-template>\n    </tbody>\n  </table>\n</fsw-panel>\n" }]
        }], propDecorators: { data: [{
                type: Input
            }] } });

class CbsParsedResultAggregateMonthlyBalancesComponent {
    constructor() {
        this.data = null;
        this.isExpanded = signal(true);
    }
    get breakdownTables() {
        if (!this.data?.length) {
            return [[], []];
        }
        const totalIndex = this.data.findIndex((item) => item.product_type?.toLowerCase() === 'total');
        return [this.data.slice(0, totalIndex + 1), this.data.slice(totalIndex + 1, this.data.length)];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultAggregateMonthlyBalancesComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CbsParsedResultAggregateMonthlyBalancesComponent, isStandalone: true, selector: "fsw-cbs-parsed-result-aggregate-monthly-balances", inputs: { data: "data" }, providers: [provideCbsParsedResultTranslation()], ngImport: i0, template: "<fsw-panel\n  [title]=\"\n    'sections.aggregate_monthly_balances.title' | fswTranslate : { scope: 'cbs_parsed_result' }\n  \"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <button fswButton [appearance]=\"'icon-no-bg'\" (click)=\"isExpanded.set(!isExpanded())\">\n      <i\n        [fswIcon]=\"'common-arrow-dropdown'\"\n        [class.rotate-90]=\"!isExpanded()\"\n        class=\"transform duration-300\"\n      ></i>\n    </button>\n  </ng-template>\n  <table class=\"fsw-table fsw-table--bordered w-full table-fixed\" *ngIf=\"isExpanded()\">\n    <thead>\n      <tr>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_monthly_balances.columns.month'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_monthly_balances.columns.product_type'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_monthly_balances.columns.grantor_bank'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_monthly_balances.columns.secured_balances'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_monthly_balances.columns.unsecured_balances_interest_bearing'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_monthly_balances.columns.unsecured_balances_non_interest_bearing'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_monthly_balances.columns.exempted_unsecured_balances'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      <ng-container *ngIf=\"!data?.length; else defaultTemplate\">\n        <tr>\n          <td class=\"align-middle\" colspan=\"7\">\n            <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n              <svg\n                class=\"text-yellow-600\"\n                fill=\"currentColor\"\n                version=\"1.1\"\n                id=\"Capa_1\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n                width=\"100px\"\n                height=\"100px\"\n                viewBox=\"0 0 462.035 462.035\"\n                xml:space=\"preserve\"\n              >\n                <g>\n                  <path\n                    d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n                  />\n                </g>\n              </svg>\n              <p class=\"text-center font-semibold text-body-small-600\">\n                {{\n                  'sections.aggregate_monthly_balances.empty'\n                    | fswTranslate : { scope: 'cbs_parsed_result' }\n                }}\n              </p>\n            </section>\n          </td>\n        </tr>\n      </ng-container>\n      <ng-template #defaultTemplate>\n        <tr *ngFor=\"let item of breakdownTables[0]\">\n          <td\n            class=\"whitespace-normal align-middle break-words capitalize\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{\n              item.product_type?.toLowerCase() === 'total'\n                ? 'Total'\n                : item.year_month\n                ? item.year_month.month.toLowerCase() + ' ' + item.year_month.year\n                : '--'\n            }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.product_type?.toLowerCase() === 'total' ? '' : item.product_type }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.product_type?.toLowerCase() === 'total' ? '' : item.grantor_bank }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.secured_balances | number : '1.2-2' }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.unsecured_balances_interest_bearing | number : '1.2-2' }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.unsecured_balances_non_interest_bearing | number : '1.2-2' }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.exempted_unsecured_balances | number : '1.2-2' }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"align-middle bg-blue-100 !font-semibold\" colspan=\"8\">\n            {{\n              'sections.aggregate_monthly_balances.sub_title'\n                | fswTranslate : { data: { month: breakdownTables[1].length.toString() } }\n            }}\n          </td>\n        </tr>\n        <tr *ngFor=\"let item of breakdownTables[1]\">\n          <td class=\"whitespace-normal align-middle break-words capitalize\">\n            {{\n              item.year_month\n                ? item.year_month.month.toLowerCase() + ' ' + item.year_month.year\n                : '--'\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.product_type?.toLowerCase() === 'total' ? '' : item.product_type }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.product_type?.toLowerCase() === 'total' ? '' : item.grantor_bank }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.secured_balances | number : '1.2-2' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.unsecured_balances_interest_bearing | number : '1.2-2' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.unsecured_balances_non_interest_bearing | number : '1.2-2' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.exempted_unsecured_balances | number : '1.2-2' }}\n          </td>\n        </tr>\n      </ng-template>\n    </tbody>\n  </table>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "pipe", type: DecimalPipe, name: "number" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultAggregateMonthlyBalancesComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'fsw-cbs-parsed-result-aggregate-monthly-balances', imports: [
                        CbsEnquiryDatePipe,
                        FSWPanelModule,
                        FSWTranslateModule,
                        NgForOf,
                        NgIf,
                        FSWButtonModule,
                        FSWIconModule,
                        DecimalPipe,
                    ], providers: [provideCbsParsedResultTranslation()], template: "<fsw-panel\n  [title]=\"\n    'sections.aggregate_monthly_balances.title' | fswTranslate : { scope: 'cbs_parsed_result' }\n  \"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <button fswButton [appearance]=\"'icon-no-bg'\" (click)=\"isExpanded.set(!isExpanded())\">\n      <i\n        [fswIcon]=\"'common-arrow-dropdown'\"\n        [class.rotate-90]=\"!isExpanded()\"\n        class=\"transform duration-300\"\n      ></i>\n    </button>\n  </ng-template>\n  <table class=\"fsw-table fsw-table--bordered w-full table-fixed\" *ngIf=\"isExpanded()\">\n    <thead>\n      <tr>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_monthly_balances.columns.month'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_monthly_balances.columns.product_type'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_monthly_balances.columns.grantor_bank'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_monthly_balances.columns.secured_balances'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_monthly_balances.columns.unsecured_balances_interest_bearing'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_monthly_balances.columns.unsecured_balances_non_interest_bearing'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_monthly_balances.columns.exempted_unsecured_balances'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      <ng-container *ngIf=\"!data?.length; else defaultTemplate\">\n        <tr>\n          <td class=\"align-middle\" colspan=\"7\">\n            <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n              <svg\n                class=\"text-yellow-600\"\n                fill=\"currentColor\"\n                version=\"1.1\"\n                id=\"Capa_1\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n                width=\"100px\"\n                height=\"100px\"\n                viewBox=\"0 0 462.035 462.035\"\n                xml:space=\"preserve\"\n              >\n                <g>\n                  <path\n                    d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n                  />\n                </g>\n              </svg>\n              <p class=\"text-center font-semibold text-body-small-600\">\n                {{\n                  'sections.aggregate_monthly_balances.empty'\n                    | fswTranslate : { scope: 'cbs_parsed_result' }\n                }}\n              </p>\n            </section>\n          </td>\n        </tr>\n      </ng-container>\n      <ng-template #defaultTemplate>\n        <tr *ngFor=\"let item of breakdownTables[0]\">\n          <td\n            class=\"whitespace-normal align-middle break-words capitalize\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{\n              item.product_type?.toLowerCase() === 'total'\n                ? 'Total'\n                : item.year_month\n                ? item.year_month.month.toLowerCase() + ' ' + item.year_month.year\n                : '--'\n            }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.product_type?.toLowerCase() === 'total' ? '' : item.product_type }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.product_type?.toLowerCase() === 'total' ? '' : item.grantor_bank }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.secured_balances | number : '1.2-2' }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.unsecured_balances_interest_bearing | number : '1.2-2' }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.unsecured_balances_non_interest_bearing | number : '1.2-2' }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.exempted_unsecured_balances | number : '1.2-2' }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"align-middle bg-blue-100 !font-semibold\" colspan=\"8\">\n            {{\n              'sections.aggregate_monthly_balances.sub_title'\n                | fswTranslate : { data: { month: breakdownTables[1].length.toString() } }\n            }}\n          </td>\n        </tr>\n        <tr *ngFor=\"let item of breakdownTables[1]\">\n          <td class=\"whitespace-normal align-middle break-words capitalize\">\n            {{\n              item.year_month\n                ? item.year_month.month.toLowerCase() + ' ' + item.year_month.year\n                : '--'\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.product_type?.toLowerCase() === 'total' ? '' : item.product_type }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.product_type?.toLowerCase() === 'total' ? '' : item.grantor_bank }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.secured_balances | number : '1.2-2' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.unsecured_balances_interest_bearing | number : '1.2-2' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.unsecured_balances_non_interest_bearing | number : '1.2-2' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.exempted_unsecured_balances | number : '1.2-2' }}\n          </td>\n        </tr>\n      </ng-template>\n    </tbody>\n  </table>\n</fsw-panel>\n" }]
        }], propDecorators: { data: [{
                type: Input
            }] } });

class CbsParsedResultAggregateMonthlyInstallmentComponent {
    constructor() {
        this.data = null;
        this.isExpanded = signal(true);
    }
    get breakdownTables() {
        if (!this.data?.length) {
            return [[], []];
        }
        const totalIndex = this.data.findIndex((item) => item.product_type?.toLowerCase() === 'total');
        return [this.data.slice(0, totalIndex + 1), this.data.slice(totalIndex + 1, this.data.length)];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultAggregateMonthlyInstallmentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CbsParsedResultAggregateMonthlyInstallmentComponent, isStandalone: true, selector: "fsw-cbs-parsed-result-aggregate-monthly-installment", inputs: { data: "data" }, providers: [provideCbsParsedResultTranslation()], ngImport: i0, template: "<fsw-panel\n  [title]=\"\n    'sections.aggregate_month_installment.title' | fswTranslate : { scope: 'cbs_parsed_result' }\n  \"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <button fswButton [appearance]=\"'icon-no-bg'\" (click)=\"isExpanded.set(!isExpanded())\">\n      <i\n        [fswIcon]=\"'common-arrow-dropdown'\"\n        [class.rotate-90]=\"!isExpanded()\"\n        class=\"transform duration-300\"\n      ></i>\n    </button>\n  </ng-template>\n  <table class=\"fsw-table fsw-table--bordered w-full table-fixed\" *ngIf=\"isExpanded()\">\n    <thead>\n      <tr>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_month_installment.columns.month'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_month_installment.columns.product_type'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_month_installment.columns.grantor_bank'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_month_installment.columns.account_type'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_month_installment.columns.property'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_month_installment.columns.non_property'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_month_installment.columns.unsecured'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_month_installment.columns.exempted_unsecured'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      <ng-container *ngIf=\"!data?.length; else defaultTemplate\">\n        <tr>\n          <td class=\"align-middle\" colspan=\"8\">\n            <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n              <svg\n                class=\"text-yellow-600\"\n                fill=\"currentColor\"\n                version=\"1.1\"\n                id=\"Capa_1\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n                width=\"100px\"\n                height=\"100px\"\n                viewBox=\"0 0 462.035 462.035\"\n                xml:space=\"preserve\"\n              >\n                <g>\n                  <path\n                    d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n                  />\n                </g>\n              </svg>\n              <p class=\"text-center font-semibold text-body-small-600\">\n                {{\n                  'sections.aggregate_month_installment.empty'\n                    | fswTranslate : { scope: 'cbs_parsed_result' }\n                }}\n              </p>\n            </section>\n          </td>\n        </tr>\n      </ng-container>\n      <ng-template #defaultTemplate>\n        <tr *ngFor=\"let item of breakdownTables[0]\">\n          <td\n            class=\"whitespace-normal align-middle break-words capitalize\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{\n              item.product_type?.toLowerCase() === 'total'\n                ? 'Total'\n                : item.year_month\n                ? item.year_month.month.toLowerCase() + ' ' + item.year_month.year\n                : '--'\n            }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.product_type?.toLowerCase() === 'total' ? '' : item.product_type }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.product_type?.toLowerCase() === 'total' ? '' : item.grantor_bank }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.product_type?.toLowerCase() === 'total' ? '' : item.account_type }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.property | number : '1.2-2' }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.non_property | number : '1.2-2' }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.unsecured | number : '1.2-2' }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.exempted_unsecured | number : '1.2-2' }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"align-middle bg-blue-100 !font-semibold\" colspan=\"8\">\n            {{\n              'sections.aggregate_month_installment.sub_title'\n                | fswTranslate : { data: { month: breakdownTables[1].length.toString() } }\n            }}\n          </td>\n        </tr>\n        <tr *ngFor=\"let item of breakdownTables[1]\">\n          <td class=\"whitespace-normal align-middle break-words capitalize\">\n            {{\n              item.year_month\n                ? item.year_month.month.toLowerCase() + ' ' + item.year_month.year\n                : '--'\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.product_type }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.grantor_bank }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.account_type }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.property | number : '1.2-2' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.non_property | number : '1.2-2' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.unsecured | number : '1.2-2' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.exempted_unsecured | number : '1.2-2' }}\n          </td>\n        </tr>\n      </ng-template>\n    </tbody>\n  </table>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "pipe", type: DecimalPipe, name: "number" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultAggregateMonthlyInstallmentComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'fsw-cbs-parsed-result-aggregate-monthly-installment', imports: [
                        FSWPanelModule,
                        FSWTranslateModule,
                        NgIf,
                        NgForOf,
                        FSWButtonModule,
                        FSWIconModule,
                        DecimalPipe,
                    ], providers: [provideCbsParsedResultTranslation()], template: "<fsw-panel\n  [title]=\"\n    'sections.aggregate_month_installment.title' | fswTranslate : { scope: 'cbs_parsed_result' }\n  \"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <button fswButton [appearance]=\"'icon-no-bg'\" (click)=\"isExpanded.set(!isExpanded())\">\n      <i\n        [fswIcon]=\"'common-arrow-dropdown'\"\n        [class.rotate-90]=\"!isExpanded()\"\n        class=\"transform duration-300\"\n      ></i>\n    </button>\n  </ng-template>\n  <table class=\"fsw-table fsw-table--bordered w-full table-fixed\" *ngIf=\"isExpanded()\">\n    <thead>\n      <tr>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_month_installment.columns.month'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_month_installment.columns.product_type'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_month_installment.columns.grantor_bank'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_month_installment.columns.account_type'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_month_installment.columns.property'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_month_installment.columns.non_property'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_month_installment.columns.unsecured'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.aggregate_month_installment.columns.exempted_unsecured'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      <ng-container *ngIf=\"!data?.length; else defaultTemplate\">\n        <tr>\n          <td class=\"align-middle\" colspan=\"8\">\n            <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n              <svg\n                class=\"text-yellow-600\"\n                fill=\"currentColor\"\n                version=\"1.1\"\n                id=\"Capa_1\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n                width=\"100px\"\n                height=\"100px\"\n                viewBox=\"0 0 462.035 462.035\"\n                xml:space=\"preserve\"\n              >\n                <g>\n                  <path\n                    d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n                  />\n                </g>\n              </svg>\n              <p class=\"text-center font-semibold text-body-small-600\">\n                {{\n                  'sections.aggregate_month_installment.empty'\n                    | fswTranslate : { scope: 'cbs_parsed_result' }\n                }}\n              </p>\n            </section>\n          </td>\n        </tr>\n      </ng-container>\n      <ng-template #defaultTemplate>\n        <tr *ngFor=\"let item of breakdownTables[0]\">\n          <td\n            class=\"whitespace-normal align-middle break-words capitalize\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{\n              item.product_type?.toLowerCase() === 'total'\n                ? 'Total'\n                : item.year_month\n                ? item.year_month.month.toLowerCase() + ' ' + item.year_month.year\n                : '--'\n            }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.product_type?.toLowerCase() === 'total' ? '' : item.product_type }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.product_type?.toLowerCase() === 'total' ? '' : item.grantor_bank }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.product_type?.toLowerCase() === 'total' ? '' : item.account_type }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.property | number : '1.2-2' }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.non_property | number : '1.2-2' }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.unsecured | number : '1.2-2' }}\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!font-semibold]=\"item.product_type?.toLowerCase() === 'total'\"\n          >\n            {{ item.exempted_unsecured | number : '1.2-2' }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"align-middle bg-blue-100 !font-semibold\" colspan=\"8\">\n            {{\n              'sections.aggregate_month_installment.sub_title'\n                | fswTranslate : { data: { month: breakdownTables[1].length.toString() } }\n            }}\n          </td>\n        </tr>\n        <tr *ngFor=\"let item of breakdownTables[1]\">\n          <td class=\"whitespace-normal align-middle break-words capitalize\">\n            {{\n              item.year_month\n                ? item.year_month.month.toLowerCase() + ' ' + item.year_month.year\n                : '--'\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.product_type }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.grantor_bank }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.account_type }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.property | number : '1.2-2' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.non_property | number : '1.2-2' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.unsecured | number : '1.2-2' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.exempted_unsecured | number : '1.2-2' }}\n          </td>\n        </tr>\n      </ng-template>\n    </tbody>\n  </table>\n</fsw-panel>\n" }]
        }], propDecorators: { data: [{
                type: Input
            }] } });

class CbsParsedResultBankruptcyProceedingsComponent {
    constructor() {
        this.data = null;
        this.isExpanded = signal(true);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultBankruptcyProceedingsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CbsParsedResultBankruptcyProceedingsComponent, isStandalone: true, selector: "fsw-cbs-parsed-result-bankruptcy-proceedings", inputs: { data: "data" }, providers: [provideCbsParsedResultTranslation()], ngImport: i0, template: "<fsw-panel\n  [title]=\"'sections.bankruptcy_proceedings.title' | fswTranslate : { scope: 'cbs_parsed_result' }\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <button fswButton [appearance]=\"'icon-no-bg'\" (click)=\"isExpanded.set(!isExpanded())\">\n      <i\n        [fswIcon]=\"'common-arrow-dropdown'\"\n        [class.rotate-90]=\"!isExpanded()\"\n        class=\"transform duration-300\"\n      ></i>\n    </button>\n  </ng-template>\n  <table class=\"fsw-table fsw-table--bordered w-full table-fixed\" *ngIf=\"isExpanded()\">\n    <thead>\n      <tr>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.bankruptcy_proceedings.columns.bankruptcy_number'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.bankruptcy_proceedings.columns.order_date'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.bankruptcy_proceedings.columns.petition_date'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      <ng-container *ngIf=\"!data?.length; else defaultTemplate\">\n        <tr>\n          <td class=\"align-middle\" colspan=\"3\">\n            <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n              <svg\n                class=\"text-yellow-600\"\n                fill=\"currentColor\"\n                version=\"1.1\"\n                id=\"Capa_1\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n                width=\"100px\"\n                height=\"100px\"\n                viewBox=\"0 0 462.035 462.035\"\n                xml:space=\"preserve\"\n              >\n                <g>\n                  <path\n                    d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n                  />\n                </g>\n              </svg>\n              <p class=\"text-center font-semibold text-body-small-600\">\n                {{\n                  'sections.bankruptcy_proceedings.empty'\n                    | fswTranslate : { scope: 'cbs_parsed_result' }\n                }}\n              </p>\n            </section>\n          </td>\n        </tr>\n      </ng-container>\n      <ng-template #defaultTemplate>\n        <tr *ngFor=\"let item of data!\">\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.bankruptcy_number }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.order_date | date : 'dd/MM/yyyy' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.petition_date | date : 'dd/MM/yyyy' }}\n          </td>\n        </tr>\n      </ng-template>\n    </tbody>\n  </table>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "pipe", type: DatePipe, name: "date" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultBankruptcyProceedingsComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'fsw-cbs-parsed-result-bankruptcy-proceedings', imports: [
                        FSWPanelModule,
                        FSWTranslateModule,
                        NgIf,
                        NgForOf,
                        DatePipe,
                        FSWButtonModule,
                        FSWIconModule,
                    ], providers: [provideCbsParsedResultTranslation()], template: "<fsw-panel\n  [title]=\"'sections.bankruptcy_proceedings.title' | fswTranslate : { scope: 'cbs_parsed_result' }\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <button fswButton [appearance]=\"'icon-no-bg'\" (click)=\"isExpanded.set(!isExpanded())\">\n      <i\n        [fswIcon]=\"'common-arrow-dropdown'\"\n        [class.rotate-90]=\"!isExpanded()\"\n        class=\"transform duration-300\"\n      ></i>\n    </button>\n  </ng-template>\n  <table class=\"fsw-table fsw-table--bordered w-full table-fixed\" *ngIf=\"isExpanded()\">\n    <thead>\n      <tr>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.bankruptcy_proceedings.columns.bankruptcy_number'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.bankruptcy_proceedings.columns.order_date'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.bankruptcy_proceedings.columns.petition_date'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      <ng-container *ngIf=\"!data?.length; else defaultTemplate\">\n        <tr>\n          <td class=\"align-middle\" colspan=\"3\">\n            <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n              <svg\n                class=\"text-yellow-600\"\n                fill=\"currentColor\"\n                version=\"1.1\"\n                id=\"Capa_1\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n                width=\"100px\"\n                height=\"100px\"\n                viewBox=\"0 0 462.035 462.035\"\n                xml:space=\"preserve\"\n              >\n                <g>\n                  <path\n                    d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n                  />\n                </g>\n              </svg>\n              <p class=\"text-center font-semibold text-body-small-600\">\n                {{\n                  'sections.bankruptcy_proceedings.empty'\n                    | fswTranslate : { scope: 'cbs_parsed_result' }\n                }}\n              </p>\n            </section>\n          </td>\n        </tr>\n      </ng-container>\n      <ng-template #defaultTemplate>\n        <tr *ngFor=\"let item of data!\">\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.bankruptcy_number }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.order_date | date : 'dd/MM/yyyy' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.petition_date | date : 'dd/MM/yyyy' }}\n          </td>\n        </tr>\n      </ng-template>\n    </tbody>\n  </table>\n</fsw-panel>\n" }]
        }], propDecorators: { data: [{
                type: Input
            }] } });

class CbsParsedResultBureauScoreComponent {
    constructor() {
        this.data = null;
        this.isExpanded = signal(true);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultBureauScoreComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CbsParsedResultBureauScoreComponent, isStandalone: true, selector: "fsw-cbs-parsed-result-bureau-score", inputs: { data: "data" }, providers: [provideCbsParsedResultTranslation()], ngImport: i0, template: "<fsw-panel [title]=\"'sections.bureau_score.title' | fswTranslate : { scope: 'cbs_parsed_result' }\">\n  <ng-template fswPanelHeaderSuffix>\n    <button fswButton [appearance]=\"'icon-no-bg'\" (click)=\"isExpanded.set(!isExpanded())\">\n      <i\n        [fswIcon]=\"'common-arrow-dropdown'\"\n        [class.rotate-90]=\"!isExpanded()\"\n        class=\"transform duration-300\"\n      ></i>\n    </button>\n  </ng-template>\n  <table class=\"fsw-table fsw-table--bordered w-full table-fixed\" *ngIf=\"isExpanded()\">\n    <tbody>\n      <ng-container *ngIf=\"!data; else defaultTemplate\">\n        <tr>\n          <td class=\"align-middle\">\n            <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n              <svg\n                class=\"text-yellow-600\"\n                fill=\"currentColor\"\n                version=\"1.1\"\n                id=\"Capa_1\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                width=\"100px\"\n                height=\"100px\"\n                viewBox=\"0 0 462.035 462.035\"\n                xml:space=\"preserve\"\n              >\n                <g>\n                  <path\n                    d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n                  />\n                </g>\n              </svg>\n              <p class=\"text-center font-semibold text-body-small-600\">\n                {{ 'sections.bureau_score.empty' | fswTranslate : { scope: 'cbs_parsed_result' } }}\n              </p>\n            </section>\n          </td>\n        </tr>\n      </ng-container>\n      <ng-template #defaultTemplate>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.bureau_score.columns.score' | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.score }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.bureau_score.columns.risk_grade'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.risk_grade }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.bureau_score.columns.probability_of_default'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.probability_of_default }}\n          </td>\n        </tr>\n      </ng-template>\n    </tbody>\n  </table>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultBureauScoreComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'fsw-cbs-parsed-result-bureau-score', imports: [FSWPanelModule, FSWTranslateModule, NgIf, FSWButtonModule, FSWIconModule], providers: [provideCbsParsedResultTranslation()], template: "<fsw-panel [title]=\"'sections.bureau_score.title' | fswTranslate : { scope: 'cbs_parsed_result' }\">\n  <ng-template fswPanelHeaderSuffix>\n    <button fswButton [appearance]=\"'icon-no-bg'\" (click)=\"isExpanded.set(!isExpanded())\">\n      <i\n        [fswIcon]=\"'common-arrow-dropdown'\"\n        [class.rotate-90]=\"!isExpanded()\"\n        class=\"transform duration-300\"\n      ></i>\n    </button>\n  </ng-template>\n  <table class=\"fsw-table fsw-table--bordered w-full table-fixed\" *ngIf=\"isExpanded()\">\n    <tbody>\n      <ng-container *ngIf=\"!data; else defaultTemplate\">\n        <tr>\n          <td class=\"align-middle\">\n            <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n              <svg\n                class=\"text-yellow-600\"\n                fill=\"currentColor\"\n                version=\"1.1\"\n                id=\"Capa_1\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                width=\"100px\"\n                height=\"100px\"\n                viewBox=\"0 0 462.035 462.035\"\n                xml:space=\"preserve\"\n              >\n                <g>\n                  <path\n                    d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n                  />\n                </g>\n              </svg>\n              <p class=\"text-center font-semibold text-body-small-600\">\n                {{ 'sections.bureau_score.empty' | fswTranslate : { scope: 'cbs_parsed_result' } }}\n              </p>\n            </section>\n          </td>\n        </tr>\n      </ng-container>\n      <ng-template #defaultTemplate>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.bureau_score.columns.score' | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.score }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.bureau_score.columns.risk_grade'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.risk_grade }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.bureau_score.columns.probability_of_default'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.probability_of_default }}\n          </td>\n        </tr>\n      </ng-template>\n    </tbody>\n  </table>\n</fsw-panel>\n" }]
        }], propDecorators: { data: [{
                type: Input
            }] } });

class CbsParsedResultDataProvidedComponent {
    constructor() {
        this.data = null;
        this.isExpanded = signal(true);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultDataProvidedComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CbsParsedResultDataProvidedComponent, isStandalone: true, selector: "fsw-cbs-parsed-result-data-provided", inputs: { data: "data" }, providers: [provideCbsParsedResultTranslation()], ngImport: i0, template: "<fsw-panel [title]=\"'sections.date_provided.title' | fswTranslate : { scope: 'cbs_parsed_result' }\">\n  <ng-template fswPanelHeaderSuffix>\n    <button fswButton [appearance]=\"'icon-no-bg'\" (click)=\"isExpanded.set(!isExpanded())\">\n      <i\n        [fswIcon]=\"'common-arrow-dropdown'\"\n        [class.rotate-90]=\"!isExpanded()\"\n        class=\"transform duration-300\"\n      ></i>\n    </button>\n  </ng-template>\n  <table class=\"fsw-table fsw-table--bordered w-full table-fixed\" *ngIf=\"isExpanded()\">\n    <tbody>\n      <ng-container *ngIf=\"!data; else defaultTemplate\">\n        <tr>\n          <td class=\"align-middle\">\n            <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n              <svg\n                class=\"text-yellow-600\"\n                fill=\"currentColor\"\n                version=\"1.1\"\n                id=\"Capa_1\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                width=\"100px\"\n                height=\"100px\"\n                viewBox=\"0 0 462.035 462.035\"\n                xml:space=\"preserve\"\n              >\n                <g>\n                  <path\n                    d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n                  />\n                </g>\n              </svg>\n              <p class=\"text-center font-semibold text-body-small-600\">\n                {{ 'sections.date_provided.empty' | fswTranslate : { scope: 'cbs_parsed_result' } }}\n              </p>\n            </section>\n          </td>\n        </tr>\n      </ng-container>\n      <ng-template #defaultTemplate>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.date_provided.columns.name' | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.name }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.date_provided.columns.id_number'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.id_number }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.date_provided.columns.date_of_birth'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.date_of_birth | toCbsEnquiryDate }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.date_provided.columns.postal_code'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{ data!.postal_code }}\n          </td>\n        </tr>\n      </ng-template>\n    </tbody>\n  </table>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: CbsEnquiryDatePipe, name: "toCbsEnquiryDate" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultDataProvidedComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'fsw-cbs-parsed-result-data-provided', imports: [
                        FSWPanelModule,
                        NgIf,
                        FSWTranslateModule,
                        CbsEnquiryDatePipe,
                        FSWButtonModule,
                        FSWIconModule,
                    ], providers: [provideCbsParsedResultTranslation()], template: "<fsw-panel [title]=\"'sections.date_provided.title' | fswTranslate : { scope: 'cbs_parsed_result' }\">\n  <ng-template fswPanelHeaderSuffix>\n    <button fswButton [appearance]=\"'icon-no-bg'\" (click)=\"isExpanded.set(!isExpanded())\">\n      <i\n        [fswIcon]=\"'common-arrow-dropdown'\"\n        [class.rotate-90]=\"!isExpanded()\"\n        class=\"transform duration-300\"\n      ></i>\n    </button>\n  </ng-template>\n  <table class=\"fsw-table fsw-table--bordered w-full table-fixed\" *ngIf=\"isExpanded()\">\n    <tbody>\n      <ng-container *ngIf=\"!data; else defaultTemplate\">\n        <tr>\n          <td class=\"align-middle\">\n            <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n              <svg\n                class=\"text-yellow-600\"\n                fill=\"currentColor\"\n                version=\"1.1\"\n                id=\"Capa_1\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                width=\"100px\"\n                height=\"100px\"\n                viewBox=\"0 0 462.035 462.035\"\n                xml:space=\"preserve\"\n              >\n                <g>\n                  <path\n                    d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n                  />\n                </g>\n              </svg>\n              <p class=\"text-center font-semibold text-body-small-600\">\n                {{ 'sections.date_provided.empty' | fswTranslate : { scope: 'cbs_parsed_result' } }}\n              </p>\n            </section>\n          </td>\n        </tr>\n      </ng-container>\n      <ng-template #defaultTemplate>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.date_provided.columns.name' | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.name }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.date_provided.columns.id_number'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.id_number }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.date_provided.columns.date_of_birth'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.date_of_birth | toCbsEnquiryDate }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.date_provided.columns.postal_code'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{ data!.postal_code }}\n          </td>\n        </tr>\n      </ng-template>\n    </tbody>\n  </table>\n</fsw-panel>\n" }]
        }], propDecorators: { data: [{
                type: Input
            }] } });

class CbsParsedResultDefaultRecordsComponent {
    constructor() {
        this.data = null;
        this.isExpanded = signal(true);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultDefaultRecordsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CbsParsedResultDefaultRecordsComponent, isStandalone: true, selector: "fsw-cbs-parsed-result-default-records", inputs: { data: "data" }, providers: [provideCbsParsedResultTranslation()], ngImport: i0, template: "<fsw-panel\n  [title]=\"'sections.default_records.title' | fswTranslate : { scope: 'cbs_parsed_result' }\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <button fswButton [appearance]=\"'icon-no-bg'\" (click)=\"isExpanded.set(!isExpanded())\">\n      <i\n        [fswIcon]=\"'common-arrow-dropdown'\"\n        [class.rotate-90]=\"!isExpanded()\"\n        class=\"transform duration-300\"\n      ></i>\n    </button>\n  </ng-template>\n  <table class=\"fsw-table fsw-table--bordered w-full table-fixed\" *ngIf=\"isExpanded()\">\n    <thead>\n      <tr>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.default_records.columns.product'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.default_records.columns.client'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.default_records.columns.date_loaded'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.default_records.columns.original_amount'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.default_records.columns.balance'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.default_records.columns.status'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.default_records.columns.status_date'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      <ng-container *ngIf=\"!data?.length; else defaultTemplate\">\n        <tr>\n          <td class=\"align-middle\" colspan=\"7\">\n            <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n              <svg\n                class=\"text-yellow-600\"\n                fill=\"currentColor\"\n                version=\"1.1\"\n                id=\"Capa_1\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n                width=\"100px\"\n                height=\"100px\"\n                viewBox=\"0 0 462.035 462.035\"\n                xml:space=\"preserve\"\n              >\n                <g>\n                  <path\n                    d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n                  />\n                </g>\n              </svg>\n              <p class=\"text-center font-semibold text-body-small-600\">\n                {{\n                  'sections.default_records.empty' | fswTranslate : { scope: 'cbs_parsed_result' }\n                }}\n              </p>\n            </section>\n          </td>\n        </tr>\n      </ng-container>\n      <ng-template #defaultTemplate>\n        <tr *ngFor=\"let item of data!\">\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.product }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.client }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.date_loaded | date : 'dd/MM/yyyy' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.original_amount }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.balance }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.status }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.status_date | date : 'dd/MM/yyyy' }}\n          </td>\n        </tr>\n      </ng-template>\n    </tbody>\n  </table>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: DatePipe, name: "date" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultDefaultRecordsComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'fsw-cbs-parsed-result-default-records', imports: [
                        CbsEnquiryDatePipe,
                        FSWPanelModule,
                        FSWTranslateModule,
                        NgForOf,
                        NgIf,
                        DatePipe,
                        FSWButtonModule,
                        FSWIconModule,
                    ], providers: [provideCbsParsedResultTranslation()], template: "<fsw-panel\n  [title]=\"'sections.default_records.title' | fswTranslate : { scope: 'cbs_parsed_result' }\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <button fswButton [appearance]=\"'icon-no-bg'\" (click)=\"isExpanded.set(!isExpanded())\">\n      <i\n        [fswIcon]=\"'common-arrow-dropdown'\"\n        [class.rotate-90]=\"!isExpanded()\"\n        class=\"transform duration-300\"\n      ></i>\n    </button>\n  </ng-template>\n  <table class=\"fsw-table fsw-table--bordered w-full table-fixed\" *ngIf=\"isExpanded()\">\n    <thead>\n      <tr>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.default_records.columns.product'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.default_records.columns.client'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.default_records.columns.date_loaded'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.default_records.columns.original_amount'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.default_records.columns.balance'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.default_records.columns.status'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.default_records.columns.status_date'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      <ng-container *ngIf=\"!data?.length; else defaultTemplate\">\n        <tr>\n          <td class=\"align-middle\" colspan=\"7\">\n            <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n              <svg\n                class=\"text-yellow-600\"\n                fill=\"currentColor\"\n                version=\"1.1\"\n                id=\"Capa_1\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n                width=\"100px\"\n                height=\"100px\"\n                viewBox=\"0 0 462.035 462.035\"\n                xml:space=\"preserve\"\n              >\n                <g>\n                  <path\n                    d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n                  />\n                </g>\n              </svg>\n              <p class=\"text-center font-semibold text-body-small-600\">\n                {{\n                  'sections.default_records.empty' | fswTranslate : { scope: 'cbs_parsed_result' }\n                }}\n              </p>\n            </section>\n          </td>\n        </tr>\n      </ng-container>\n      <ng-template #defaultTemplate>\n        <tr *ngFor=\"let item of data!\">\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.product }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.client }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.date_loaded | date : 'dd/MM/yyyy' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.original_amount }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.balance }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.status }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.status_date | date : 'dd/MM/yyyy' }}\n          </td>\n        </tr>\n      </ng-template>\n    </tbody>\n  </table>\n</fsw-panel>\n" }]
        }], propDecorators: { data: [{
                type: Input
            }] } });

class CbsParsedResultPersonalDetailsComponent {
    constructor() {
        this.data = null;
        this.isExpanded = signal(true);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultPersonalDetailsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CbsParsedResultPersonalDetailsComponent, isStandalone: true, selector: "fsw-cbs-parsed-result-personal-details", inputs: { data: "data" }, providers: [provideCbsParsedResultTranslation()], ngImport: i0, template: "<fsw-panel\n  [title]=\"'sections.personal_details.title' | fswTranslate : { scope: 'cbs_parsed_result' }\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <button fswButton [appearance]=\"'icon-no-bg'\" (click)=\"isExpanded.set(!isExpanded())\">\n      <i\n        [fswIcon]=\"'common-arrow-dropdown'\"\n        [class.rotate-90]=\"!isExpanded()\"\n        class=\"transform duration-300\"\n      ></i>\n    </button>\n  </ng-template>\n  <table class=\"fsw-table fsw-table--bordered w-full table-fixed\" *ngIf=\"isExpanded()\">\n    <tbody>\n      <ng-container *ngIf=\"!data; else defaultTemplate\">\n        <tr>\n          <td class=\"align-middle\">\n            <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n              <svg\n                class=\"text-yellow-600\"\n                fill=\"currentColor\"\n                version=\"1.1\"\n                id=\"Capa_1\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                width=\"100px\"\n                height=\"100px\"\n                viewBox=\"0 0 462.035 462.035\"\n                xml:space=\"preserve\"\n              >\n                <g>\n                  <path\n                    d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n                  />\n                </g>\n              </svg>\n              <p class=\"text-center font-semibold text-body-small-600\">\n                {{\n                  'sections.personal_details.empty' | fswTranslate : { scope: 'cbs_parsed_result' }\n                }}\n              </p>\n            </section>\n          </td>\n        </tr>\n      </ng-container>\n      <ng-template #defaultTemplate>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.personal_details.columns.gender'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.gender }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.personal_details.columns.nationality'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.nationality }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.personal_details.columns.marital_status'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.marital_status }}\n          </td>\n        </tr>\n      </ng-template>\n    </tbody>\n  </table>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultPersonalDetailsComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'fsw-cbs-parsed-result-personal-details', imports: [FSWPanelModule, FSWTranslateModule, NgIf, FSWButtonModule, FSWIconModule], providers: [provideCbsParsedResultTranslation()], template: "<fsw-panel\n  [title]=\"'sections.personal_details.title' | fswTranslate : { scope: 'cbs_parsed_result' }\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <button fswButton [appearance]=\"'icon-no-bg'\" (click)=\"isExpanded.set(!isExpanded())\">\n      <i\n        [fswIcon]=\"'common-arrow-dropdown'\"\n        [class.rotate-90]=\"!isExpanded()\"\n        class=\"transform duration-300\"\n      ></i>\n    </button>\n  </ng-template>\n  <table class=\"fsw-table fsw-table--bordered w-full table-fixed\" *ngIf=\"isExpanded()\">\n    <tbody>\n      <ng-container *ngIf=\"!data; else defaultTemplate\">\n        <tr>\n          <td class=\"align-middle\">\n            <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n              <svg\n                class=\"text-yellow-600\"\n                fill=\"currentColor\"\n                version=\"1.1\"\n                id=\"Capa_1\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                width=\"100px\"\n                height=\"100px\"\n                viewBox=\"0 0 462.035 462.035\"\n                xml:space=\"preserve\"\n              >\n                <g>\n                  <path\n                    d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n                  />\n                </g>\n              </svg>\n              <p class=\"text-center font-semibold text-body-small-600\">\n                {{\n                  'sections.personal_details.empty' | fswTranslate : { scope: 'cbs_parsed_result' }\n                }}\n              </p>\n            </section>\n          </td>\n        </tr>\n      </ng-container>\n      <ng-template #defaultTemplate>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.personal_details.columns.gender'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.gender }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.personal_details.columns.nationality'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.nationality }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.personal_details.columns.marital_status'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.marital_status }}\n          </td>\n        </tr>\n      </ng-template>\n    </tbody>\n  </table>\n</fsw-panel>\n" }]
        }], propDecorators: { data: [{
                type: Input
            }] } });

class CbsParsedResultPreviousEnquiriesComponent {
    constructor() {
        this.data = null;
        this.isExpanded = signal(true);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultPreviousEnquiriesComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CbsParsedResultPreviousEnquiriesComponent, isStandalone: true, selector: "fsw-cbs-parsed-result-previous-enquiries", inputs: { data: "data" }, providers: [provideCbsParsedResultTranslation()], ngImport: i0, template: "<fsw-panel\n  [title]=\"'sections.previous_enquiries.title' | fswTranslate : { scope: 'cbs_parsed_result' }\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <button fswButton [appearance]=\"'icon-no-bg'\" (click)=\"isExpanded.set(!isExpanded())\">\n      <i\n        [fswIcon]=\"'common-arrow-dropdown'\"\n        [class.rotate-90]=\"!isExpanded()\"\n        class=\"transform duration-300\"\n      ></i>\n    </button>\n  </ng-template>\n  <table class=\"fsw-table fsw-table--bordered w-full table-fixed\" *ngIf=\"isExpanded()\">\n    <thead>\n      <tr>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.previous_enquiries.columns.date'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.previous_enquiries.columns.name_of_bank'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.previous_enquiries.columns.enquiry_type'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.previous_enquiries.columns.product_type'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.previous_enquiries.columns.account_type'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      <ng-container *ngIf=\"!data?.length; else defaultTemplate\">\n        <tr>\n          <td class=\"align-middle\" colspan=\"5\">\n            <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n              <svg\n                class=\"text-yellow-600\"\n                fill=\"currentColor\"\n                version=\"1.1\"\n                id=\"Capa_1\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n                width=\"100px\"\n                height=\"100px\"\n                viewBox=\"0 0 462.035 462.035\"\n                xml:space=\"preserve\"\n              >\n                <g>\n                  <path\n                    d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n                  />\n                </g>\n              </svg>\n              <p class=\"text-center font-semibold text-body-small-600\">\n                {{\n                  'sections.previous_enquiries.empty'\n                    | fswTranslate : { scope: 'cbs_parsed_result' }\n                }}\n              </p>\n            </section>\n          </td>\n        </tr>\n      </ng-container>\n      <ng-template #defaultTemplate>\n        <tr *ngFor=\"let item of data!\">\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.date | toCbsEnquiryDate }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.bank_name }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.enquiry_type }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.product_type }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.account_type }}\n          </td>\n        </tr>\n      </ng-template>\n    </tbody>\n  </table>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: CbsEnquiryDatePipe, name: "toCbsEnquiryDate" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultPreviousEnquiriesComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'fsw-cbs-parsed-result-previous-enquiries', imports: [
                        DatePipe,
                        FSWPanelModule,
                        FSWTranslateModule,
                        NgForOf,
                        NgIf,
                        CbsEnquiryDatePipe,
                        FSWButtonModule,
                        FSWIconModule,
                    ], providers: [provideCbsParsedResultTranslation()], template: "<fsw-panel\n  [title]=\"'sections.previous_enquiries.title' | fswTranslate : { scope: 'cbs_parsed_result' }\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <button fswButton [appearance]=\"'icon-no-bg'\" (click)=\"isExpanded.set(!isExpanded())\">\n      <i\n        [fswIcon]=\"'common-arrow-dropdown'\"\n        [class.rotate-90]=\"!isExpanded()\"\n        class=\"transform duration-300\"\n      ></i>\n    </button>\n  </ng-template>\n  <table class=\"fsw-table fsw-table--bordered w-full table-fixed\" *ngIf=\"isExpanded()\">\n    <thead>\n      <tr>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.previous_enquiries.columns.date'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.previous_enquiries.columns.name_of_bank'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.previous_enquiries.columns.enquiry_type'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.previous_enquiries.columns.product_type'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'sections.previous_enquiries.columns.account_type'\n              | fswTranslate : { scope: 'cbs_parsed_result' }\n          }}\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      <ng-container *ngIf=\"!data?.length; else defaultTemplate\">\n        <tr>\n          <td class=\"align-middle\" colspan=\"5\">\n            <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n              <svg\n                class=\"text-yellow-600\"\n                fill=\"currentColor\"\n                version=\"1.1\"\n                id=\"Capa_1\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n                width=\"100px\"\n                height=\"100px\"\n                viewBox=\"0 0 462.035 462.035\"\n                xml:space=\"preserve\"\n              >\n                <g>\n                  <path\n                    d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n                  />\n                </g>\n              </svg>\n              <p class=\"text-center font-semibold text-body-small-600\">\n                {{\n                  'sections.previous_enquiries.empty'\n                    | fswTranslate : { scope: 'cbs_parsed_result' }\n                }}\n              </p>\n            </section>\n          </td>\n        </tr>\n      </ng-container>\n      <ng-template #defaultTemplate>\n        <tr *ngFor=\"let item of data!\">\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.date | toCbsEnquiryDate }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.bank_name }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.enquiry_type }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.product_type }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.account_type }}\n          </td>\n        </tr>\n      </ng-template>\n    </tbody>\n  </table>\n</fsw-panel>\n" }]
        }], propDecorators: { data: [{
                type: Input
            }] } });

class CbsParsedResultSummaryComponent {
    constructor() {
        this.data = null;
        this.isExpanded = signal(true);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultSummaryComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CbsParsedResultSummaryComponent, isStandalone: true, selector: "fsw-cbs-parsed-result-summary", inputs: { data: "data" }, providers: [provideCbsParsedResultTranslation()], ngImport: i0, template: "<fsw-panel [title]=\"'sections.summary.title' | fswTranslate : { scope: 'cbs_parsed_result' }\">\n  <ng-template fswPanelHeaderSuffix>\n    <button fswButton [appearance]=\"'icon-no-bg'\" (click)=\"isExpanded.set(!isExpanded())\">\n      <i\n        [fswIcon]=\"'common-arrow-dropdown'\"\n        [class.rotate-90]=\"!isExpanded()\"\n        class=\"transform duration-300\"\n      ></i>\n    </button>\n  </ng-template>\n  <table class=\"fsw-table fsw-table--bordered w-full table-fixed\" *ngIf=\"isExpanded()\">\n    <tbody>\n      <ng-container *ngIf=\"!data; else defaultTemplate\">\n        <tr>\n          <td class=\"align-middle\">\n            <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n              <svg\n                class=\"text-yellow-600\"\n                fill=\"currentColor\"\n                version=\"1.1\"\n                id=\"Capa_1\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                width=\"100px\"\n                height=\"100px\"\n                viewBox=\"0 0 462.035 462.035\"\n                xml:space=\"preserve\"\n              >\n                <g>\n                  <path\n                    d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n                  />\n                </g>\n              </svg>\n              <p class=\"text-center font-semibold text-body-small-600\">\n                {{ 'sections.summary.empty' | fswTranslate : { scope: 'cbs_parsed_result' } }}\n              </p>\n            </section>\n          </td>\n        </tr>\n      </ng-container>\n      <ng-template #defaultTemplate>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.summary.columns.date_of_earliest_known_credit_account_date'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.earliest_known_credit_account_date | toCbsEnquiryDate }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.summary.columns.previous_enquiries'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.previous_enquiry_count }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.summary.columns.accounts' | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.account_count }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.summary.columns.defaults' | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.default_count }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.summary.columns.bankruptcy_proceedings'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.bankruptcy_proceeding_count }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.summary.columns.secured_credit_limit'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.secured_credit_limit | number : '1.2-2' }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.summary.columns.unsecured_credit_limit'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.unsecured_credit_limit | number : '1.2-2' }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.summary.columns.exempted_credit_limit'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.exempted_credit_limit | number : '1.2-2' }}\n          </td>\n        </tr>\n      </ng-template>\n    </tbody>\n  </table>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: CbsEnquiryDatePipe, name: "toCbsEnquiryDate" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "pipe", type: DecimalPipe, name: "number" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultSummaryComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'fsw-cbs-parsed-result-summary', imports: [
                        FSWPanelModule,
                        FSWTranslateModule,
                        NgIf,
                        CbsEnquiryDatePipe,
                        FSWButtonModule,
                        FSWIconModule,
                        DecimalPipe,
                    ], providers: [provideCbsParsedResultTranslation()], template: "<fsw-panel [title]=\"'sections.summary.title' | fswTranslate : { scope: 'cbs_parsed_result' }\">\n  <ng-template fswPanelHeaderSuffix>\n    <button fswButton [appearance]=\"'icon-no-bg'\" (click)=\"isExpanded.set(!isExpanded())\">\n      <i\n        [fswIcon]=\"'common-arrow-dropdown'\"\n        [class.rotate-90]=\"!isExpanded()\"\n        class=\"transform duration-300\"\n      ></i>\n    </button>\n  </ng-template>\n  <table class=\"fsw-table fsw-table--bordered w-full table-fixed\" *ngIf=\"isExpanded()\">\n    <tbody>\n      <ng-container *ngIf=\"!data; else defaultTemplate\">\n        <tr>\n          <td class=\"align-middle\">\n            <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n              <svg\n                class=\"text-yellow-600\"\n                fill=\"currentColor\"\n                version=\"1.1\"\n                id=\"Capa_1\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                width=\"100px\"\n                height=\"100px\"\n                viewBox=\"0 0 462.035 462.035\"\n                xml:space=\"preserve\"\n              >\n                <g>\n                  <path\n                    d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n                  />\n                </g>\n              </svg>\n              <p class=\"text-center font-semibold text-body-small-600\">\n                {{ 'sections.summary.empty' | fswTranslate : { scope: 'cbs_parsed_result' } }}\n              </p>\n            </section>\n          </td>\n        </tr>\n      </ng-container>\n      <ng-template #defaultTemplate>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.summary.columns.date_of_earliest_known_credit_account_date'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.earliest_known_credit_account_date | toCbsEnquiryDate }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.summary.columns.previous_enquiries'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.previous_enquiry_count }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.summary.columns.accounts' | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.account_count }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.summary.columns.defaults' | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.default_count }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.summary.columns.bankruptcy_proceedings'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.bankruptcy_proceeding_count }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.summary.columns.secured_credit_limit'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.secured_credit_limit | number : '1.2-2' }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.summary.columns.unsecured_credit_limit'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.unsecured_credit_limit | number : '1.2-2' }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.summary.columns.exempted_credit_limit'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.exempted_credit_limit | number : '1.2-2' }}\n          </td>\n        </tr>\n      </ng-template>\n    </tbody>\n  </table>\n</fsw-panel>\n" }]
        }], propDecorators: { data: [{
                type: Input
            }] } });

class CbsParsedResultMetadataComponent {
    constructor() {
        this.data = null;
        this.isExpanded = signal(true);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultMetadataComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CbsParsedResultMetadataComponent, isStandalone: true, selector: "fsw-cbs-parsed-result-metadata", inputs: { data: "data" }, providers: [provideCbsParsedResultTranslation()], ngImport: i0, template: "<fsw-panel [title]=\"'sections.metadata.title' | fswTranslate : { scope: 'cbs_parsed_result' }\">\n  <ng-template fswPanelHeaderSuffix>\n    <button fswButton [appearance]=\"'icon-no-bg'\" (click)=\"isExpanded.set(!isExpanded())\">\n      <i\n        [fswIcon]=\"'common-arrow-dropdown'\"\n        [class.rotate-90]=\"!isExpanded()\"\n        class=\"transform duration-300\"\n      ></i>\n    </button>\n  </ng-template>\n  <table class=\"fsw-table fsw-table--bordered w-full table-fixed\" *ngIf=\"isExpanded()\">\n    <tbody>\n      <ng-container *ngIf=\"!data; else defaultTemplate\">\n        <tr>\n          <td class=\"align-middle\">\n            <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n              <svg\n                class=\"text-yellow-600\"\n                fill=\"currentColor\"\n                version=\"1.1\"\n                id=\"Capa_1\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                width=\"100px\"\n                height=\"100px\"\n                viewBox=\"0 0 462.035 462.035\"\n                xml:space=\"preserve\"\n              >\n                <g>\n                  <path\n                    d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n                  />\n                </g>\n              </svg>\n              <p class=\"text-center font-semibold text-body-small-600\">\n                {{ 'sections.metadata.empty' | fswTranslate : { scope: 'cbs_parsed_result' } }}\n              </p>\n            </section>\n          </td>\n        </tr>\n      </ng-container>\n      <ng-template #defaultTemplate>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.metadata.columns.created_at' | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.created_date_time | toCbsEnquiryDate : true }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.metadata.columns.modified_at'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.modified_date_time | toCbsEnquiryDate : true }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{ 'sections.metadata.columns.author' | fswTranslate : { scope: 'cbs_parsed_result' } }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.author }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.metadata.columns.producer' | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.producer }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.metadata.columns.version' | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.version }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{ 'sections.metadata.columns.fonts' | fswTranslate : { scope: 'cbs_parsed_result' } }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.fonts?.join(', ') }}\n          </td>\n        </tr>\n      </ng-template>\n    </tbody>\n  </table>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: CbsEnquiryDatePipe, name: "toCbsEnquiryDate" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultMetadataComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'fsw-cbs-parsed-result-metadata', imports: [
                        FSWPanelModule,
                        FSWTranslateModule,
                        NgIf,
                        CbsEnquiryDatePipe,
                        FSWButtonModule,
                        FSWIconModule,
                    ], providers: [provideCbsParsedResultTranslation()], template: "<fsw-panel [title]=\"'sections.metadata.title' | fswTranslate : { scope: 'cbs_parsed_result' }\">\n  <ng-template fswPanelHeaderSuffix>\n    <button fswButton [appearance]=\"'icon-no-bg'\" (click)=\"isExpanded.set(!isExpanded())\">\n      <i\n        [fswIcon]=\"'common-arrow-dropdown'\"\n        [class.rotate-90]=\"!isExpanded()\"\n        class=\"transform duration-300\"\n      ></i>\n    </button>\n  </ng-template>\n  <table class=\"fsw-table fsw-table--bordered w-full table-fixed\" *ngIf=\"isExpanded()\">\n    <tbody>\n      <ng-container *ngIf=\"!data; else defaultTemplate\">\n        <tr>\n          <td class=\"align-middle\">\n            <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n              <svg\n                class=\"text-yellow-600\"\n                fill=\"currentColor\"\n                version=\"1.1\"\n                id=\"Capa_1\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                width=\"100px\"\n                height=\"100px\"\n                viewBox=\"0 0 462.035 462.035\"\n                xml:space=\"preserve\"\n              >\n                <g>\n                  <path\n                    d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n                  />\n                </g>\n              </svg>\n              <p class=\"text-center font-semibold text-body-small-600\">\n                {{ 'sections.metadata.empty' | fswTranslate : { scope: 'cbs_parsed_result' } }}\n              </p>\n            </section>\n          </td>\n        </tr>\n      </ng-container>\n      <ng-template #defaultTemplate>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.metadata.columns.created_at' | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.created_date_time | toCbsEnquiryDate : true }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.metadata.columns.modified_at'\n                | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.modified_date_time | toCbsEnquiryDate : true }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{ 'sections.metadata.columns.author' | fswTranslate : { scope: 'cbs_parsed_result' } }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.author }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.metadata.columns.producer' | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.producer }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{\n              'sections.metadata.columns.version' | fswTranslate : { scope: 'cbs_parsed_result' }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.version }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words font-bold\">\n            {{ 'sections.metadata.columns.fonts' | fswTranslate : { scope: 'cbs_parsed_result' } }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ data!.fonts?.join(', ') }}\n          </td>\n        </tr>\n      </ng-template>\n    </tbody>\n  </table>\n</fsw-panel>\n" }]
        }], propDecorators: { data: [{
                type: Input
            }] } });

class CbsParsedResultComponent {
    constructor() {
        this.updated = new EventEmitter();
        this.refreshedAt = signal(null);
        this.selectedDoc = signal({});
        this.isReadonly = signal(false);
        this.injector = inject(Injector);
        this.effects = injectCbsParsedResultEffects(this.refreshedAt, this.selectedDoc, this.injector);
        effect(() => {
            const refreshedAt = this.refreshedAt();
            if (refreshedAt) {
                this.updated.emit(this.selectedDoc());
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CbsParsedResultComponent, isStandalone: true, selector: "fsw-cbs-parsed-result", providers: [provideCbsParsedResultTranslation()], ngImport: i0, template: "<fsw-panel\n  [title]=\"'title' | fswTranslate\"\n  [headerClasses]=\"'!justify-start items-center gap-[8px]'\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <label>\n      <span class=\"text-body-caption-400 font-semibold text-gray-500 self-start\">\n        ({{ selectedDoc().info.name }})\n      </span>\n    </label>\n  </ng-template>\n  <ng-container\n    *ngIf=\"\n      !selectedDoc().cbs?.parsed_data && !selectedDoc().cbs?.error_message;\n      else parsedTemplate\n    \"\n  >\n    <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n      <svg\n        class=\"text-yellow-600\"\n        fill=\"currentColor\"\n        version=\"1.1\"\n        id=\"Capa_1\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n        width=\"100px\"\n        height=\"100px\"\n        viewBox=\"0 0 462.035 462.035\"\n        xml:space=\"preserve\"\n      >\n        <g>\n          <path\n            d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n          />\n        </g>\n      </svg>\n      <p class=\"text-center font-semibold text-body-small-600\">\n        {{ 'empty' | fswTranslate }}\n      </p>\n      <button\n        *ngIf=\"!isReadonly()\"\n        fswButton\n        [appearance]=\"'secondary'\"\n        [size]=\"'m'\"\n        (click)=\"effects.parseDoc()\"\n        [attr.data-test-id]=\"'cbs-parsed-result-parse-button'\"\n      >\n        {{ 'buttons.parse' | fswTranslate }}\n      </button>\n    </section>\n  </ng-container>\n  <ng-template #parsedTemplate>\n    <ng-container\n      *ngIf=\"selectedDoc().cbs.error_message as error_message; else parsedSuccessTemplate\"\n    >\n      <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n        <svg\n          class=\"text-red-500\"\n          width=\"80px\"\n          height=\"80px\"\n          viewBox=\"0 0 512 512\"\n          xmlns=\"http://www.w3.org/2000/svg\"\n        >\n          <defs>\n            <style>\n              .cls-1 {\n                fill: none;\n                stroke: #000000;\n                stroke-linecap: round;\n                stroke-linejoin: round;\n                stroke-width: 20px;\n              }\n            </style>\n          </defs>\n\n          <g data-name=\"Layer 2\" id=\"Layer_2\">\n            <g\n              data-name=\"E410, Error, Media, media player, multimedia\"\n              id=\"E410_Error_Media_media_player_multimedia\"\n            >\n              <circle class=\"cls-1 !stroke-red-500\" cx=\"256\" cy=\"256\" r=\"246\" />\n\n              <line class=\"cls-1 !stroke-red-500\" x1=\"371.47\" x2=\"140.53\" y1=\"140.53\" y2=\"371.47\" />\n\n              <line class=\"cls-1 !stroke-red-500\" x1=\"371.47\" x2=\"140.53\" y1=\"371.47\" y2=\"140.53\" />\n            </g>\n          </g>\n        </svg>\n        <p class=\"text-center font-semibold text-body-small-600 text-red-500\">\n          {{ error_message }}\n        </p>\n      </section>\n    </ng-container>\n    <ng-template #parsedSuccessTemplate>\n      <section class=\"flex flex-col gap-[32px] w-full\">\n        <header>\n          <strong\n            >{{ 'sections.enquiry' | fswTranslate }}:\n            {{ selectedDoc().cbs.parsed_data.enquiry_date | toCbsEnquiryDate }}</strong\n          >\n        </header>\n        <section class=\"flex gap-[16px] w-full\">\n          <section class=\"flex flex-col gap-[32px] w-[calc(50%-8px)]\">\n            <fsw-cbs-parsed-result-data-provided\n              [data]=\"selectedDoc().cbs.parsed_data.personal_details\"\n            ></fsw-cbs-parsed-result-data-provided>\n            <fsw-cbs-parsed-result-personal-details\n              [data]=\"selectedDoc().cbs.parsed_data.personal_details\"\n            ></fsw-cbs-parsed-result-personal-details>\n            <fsw-cbs-parsed-result-bureau-score\n              [data]=\"selectedDoc().cbs.parsed_data.bureau_score\"\n            ></fsw-cbs-parsed-result-bureau-score>\n          </section>\n          <section class=\"flex flex-col gap-[32px] w-[calc(50%-8px)]\">\n            <fsw-cbs-parsed-result-summary\n              [data]=\"selectedDoc().cbs.parsed_data.summary\"\n            ></fsw-cbs-parsed-result-summary>\n            <fsw-cbs-parsed-result-metadata\n              [data]=\"selectedDoc().cbs.parsed_data.metadata\"\n            ></fsw-cbs-parsed-result-metadata>\n            <fsw-cbs-parsed-result-bankruptcy-proceedings\n              [data]=\"selectedDoc().cbs.parsed_data.bankruptcy_proceedings\"\n            ></fsw-cbs-parsed-result-bankruptcy-proceedings>\n          </section>\n        </section>\n        <section class=\"flex flex-col gap-[32px] w-full\">\n          <fsw-cbs-parsed-result-account-status-history\n            [data]=\"selectedDoc().cbs.parsed_data.account_statuses\"\n          ></fsw-cbs-parsed-result-account-status-history>\n          <fsw-cbs-parsed-result-default-records\n            [data]=\"selectedDoc().cbs.parsed_data.default_records\"\n          ></fsw-cbs-parsed-result-default-records>\n          <fsw-cbs-parsed-result-aggregate-monthly-balances\n            [data]=\"selectedDoc().cbs.parsed_data.aggregated_monthly_balances\"\n          ></fsw-cbs-parsed-result-aggregate-monthly-balances>\n          <fsw-cbs-parsed-result-aggregate-monthly-installment\n            [data]=\"selectedDoc().cbs.parsed_data.aggregated_monthly_installments\"\n          ></fsw-cbs-parsed-result-aggregate-monthly-installment>\n          <fsw-cbs-parsed-result-previous-enquiries\n            [data]=\"selectedDoc().cbs.parsed_data.previous_enquiries\"\n          ></fsw-cbs-parsed-result-previous-enquiries>\n        </section>\n      </section>\n    </ng-template>\n  </ng-template>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: FSWLoanServiceModule }, { kind: "ngmodule", type: FSWAlertModule }, { kind: "component", type: CbsParsedResultAccountStatusHistoryComponent, selector: "fsw-cbs-parsed-result-account-status-history", inputs: ["data"] }, { kind: "component", type: CbsParsedResultAggregateMonthlyInstallmentComponent, selector: "fsw-cbs-parsed-result-aggregate-monthly-installment", inputs: ["data"] }, { kind: "component", type: CbsParsedResultAggregateMonthlyBalancesComponent, selector: "fsw-cbs-parsed-result-aggregate-monthly-balances", inputs: ["data"] }, { kind: "component", type: CbsParsedResultBankruptcyProceedingsComponent, selector: "fsw-cbs-parsed-result-bankruptcy-proceedings", inputs: ["data"] }, { kind: "component", type: CbsParsedResultBureauScoreComponent, selector: "fsw-cbs-parsed-result-bureau-score", inputs: ["data"] }, { kind: "component", type: CbsParsedResultDataProvidedComponent, selector: "fsw-cbs-parsed-result-data-provided", inputs: ["data"] }, { kind: "component", type: CbsParsedResultDefaultRecordsComponent, selector: "fsw-cbs-parsed-result-default-records", inputs: ["data"] }, { kind: "component", type: CbsParsedResultPersonalDetailsComponent, selector: "fsw-cbs-parsed-result-personal-details", inputs: ["data"] }, { kind: "component", type: CbsParsedResultPreviousEnquiriesComponent, selector: "fsw-cbs-parsed-result-previous-enquiries", inputs: ["data"] }, { kind: "component", type: CbsParsedResultSummaryComponent, selector: "fsw-cbs-parsed-result-summary", inputs: ["data"] }, { kind: "pipe", type: CbsEnquiryDatePipe, name: "toCbsEnquiryDate" }, { kind: "component", type: CbsParsedResultMetadataComponent, selector: "fsw-cbs-parsed-result-metadata", inputs: ["data"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'fsw-cbs-parsed-result', imports: [
                        FSWPanelModule,
                        FSWTranslateModule,
                        NgIf,
                        FSWButtonModule,
                        FSWLoanServiceModule,
                        FSWAlertModule,
                        CbsParsedResultAccountStatusHistoryComponent,
                        CbsParsedResultAggregateMonthlyInstallmentComponent,
                        CbsParsedResultAggregateMonthlyBalancesComponent,
                        CbsParsedResultBankruptcyProceedingsComponent,
                        CbsParsedResultBureauScoreComponent,
                        CbsParsedResultDataProvidedComponent,
                        CbsParsedResultDefaultRecordsComponent,
                        CbsParsedResultPersonalDetailsComponent,
                        CbsParsedResultPreviousEnquiriesComponent,
                        CbsParsedResultSummaryComponent,
                        CbsEnquiryDatePipe,
                        CbsParsedResultMetadataComponent,
                    ], providers: [provideCbsParsedResultTranslation()], template: "<fsw-panel\n  [title]=\"'title' | fswTranslate\"\n  [headerClasses]=\"'!justify-start items-center gap-[8px]'\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <label>\n      <span class=\"text-body-caption-400 font-semibold text-gray-500 self-start\">\n        ({{ selectedDoc().info.name }})\n      </span>\n    </label>\n  </ng-template>\n  <ng-container\n    *ngIf=\"\n      !selectedDoc().cbs?.parsed_data && !selectedDoc().cbs?.error_message;\n      else parsedTemplate\n    \"\n  >\n    <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n      <svg\n        class=\"text-yellow-600\"\n        fill=\"currentColor\"\n        version=\"1.1\"\n        id=\"Capa_1\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n        width=\"100px\"\n        height=\"100px\"\n        viewBox=\"0 0 462.035 462.035\"\n        xml:space=\"preserve\"\n      >\n        <g>\n          <path\n            d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n          />\n        </g>\n      </svg>\n      <p class=\"text-center font-semibold text-body-small-600\">\n        {{ 'empty' | fswTranslate }}\n      </p>\n      <button\n        *ngIf=\"!isReadonly()\"\n        fswButton\n        [appearance]=\"'secondary'\"\n        [size]=\"'m'\"\n        (click)=\"effects.parseDoc()\"\n        [attr.data-test-id]=\"'cbs-parsed-result-parse-button'\"\n      >\n        {{ 'buttons.parse' | fswTranslate }}\n      </button>\n    </section>\n  </ng-container>\n  <ng-template #parsedTemplate>\n    <ng-container\n      *ngIf=\"selectedDoc().cbs.error_message as error_message; else parsedSuccessTemplate\"\n    >\n      <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n        <svg\n          class=\"text-red-500\"\n          width=\"80px\"\n          height=\"80px\"\n          viewBox=\"0 0 512 512\"\n          xmlns=\"http://www.w3.org/2000/svg\"\n        >\n          <defs>\n            <style>\n              .cls-1 {\n                fill: none;\n                stroke: #000000;\n                stroke-linecap: round;\n                stroke-linejoin: round;\n                stroke-width: 20px;\n              }\n            </style>\n          </defs>\n\n          <g data-name=\"Layer 2\" id=\"Layer_2\">\n            <g\n              data-name=\"E410, Error, Media, media player, multimedia\"\n              id=\"E410_Error_Media_media_player_multimedia\"\n            >\n              <circle class=\"cls-1 !stroke-red-500\" cx=\"256\" cy=\"256\" r=\"246\" />\n\n              <line class=\"cls-1 !stroke-red-500\" x1=\"371.47\" x2=\"140.53\" y1=\"140.53\" y2=\"371.47\" />\n\n              <line class=\"cls-1 !stroke-red-500\" x1=\"371.47\" x2=\"140.53\" y1=\"371.47\" y2=\"140.53\" />\n            </g>\n          </g>\n        </svg>\n        <p class=\"text-center font-semibold text-body-small-600 text-red-500\">\n          {{ error_message }}\n        </p>\n      </section>\n    </ng-container>\n    <ng-template #parsedSuccessTemplate>\n      <section class=\"flex flex-col gap-[32px] w-full\">\n        <header>\n          <strong\n            >{{ 'sections.enquiry' | fswTranslate }}:\n            {{ selectedDoc().cbs.parsed_data.enquiry_date | toCbsEnquiryDate }}</strong\n          >\n        </header>\n        <section class=\"flex gap-[16px] w-full\">\n          <section class=\"flex flex-col gap-[32px] w-[calc(50%-8px)]\">\n            <fsw-cbs-parsed-result-data-provided\n              [data]=\"selectedDoc().cbs.parsed_data.personal_details\"\n            ></fsw-cbs-parsed-result-data-provided>\n            <fsw-cbs-parsed-result-personal-details\n              [data]=\"selectedDoc().cbs.parsed_data.personal_details\"\n            ></fsw-cbs-parsed-result-personal-details>\n            <fsw-cbs-parsed-result-bureau-score\n              [data]=\"selectedDoc().cbs.parsed_data.bureau_score\"\n            ></fsw-cbs-parsed-result-bureau-score>\n          </section>\n          <section class=\"flex flex-col gap-[32px] w-[calc(50%-8px)]\">\n            <fsw-cbs-parsed-result-summary\n              [data]=\"selectedDoc().cbs.parsed_data.summary\"\n            ></fsw-cbs-parsed-result-summary>\n            <fsw-cbs-parsed-result-metadata\n              [data]=\"selectedDoc().cbs.parsed_data.metadata\"\n            ></fsw-cbs-parsed-result-metadata>\n            <fsw-cbs-parsed-result-bankruptcy-proceedings\n              [data]=\"selectedDoc().cbs.parsed_data.bankruptcy_proceedings\"\n            ></fsw-cbs-parsed-result-bankruptcy-proceedings>\n          </section>\n        </section>\n        <section class=\"flex flex-col gap-[32px] w-full\">\n          <fsw-cbs-parsed-result-account-status-history\n            [data]=\"selectedDoc().cbs.parsed_data.account_statuses\"\n          ></fsw-cbs-parsed-result-account-status-history>\n          <fsw-cbs-parsed-result-default-records\n            [data]=\"selectedDoc().cbs.parsed_data.default_records\"\n          ></fsw-cbs-parsed-result-default-records>\n          <fsw-cbs-parsed-result-aggregate-monthly-balances\n            [data]=\"selectedDoc().cbs.parsed_data.aggregated_monthly_balances\"\n          ></fsw-cbs-parsed-result-aggregate-monthly-balances>\n          <fsw-cbs-parsed-result-aggregate-monthly-installment\n            [data]=\"selectedDoc().cbs.parsed_data.aggregated_monthly_installments\"\n          ></fsw-cbs-parsed-result-aggregate-monthly-installment>\n          <fsw-cbs-parsed-result-previous-enquiries\n            [data]=\"selectedDoc().cbs.parsed_data.previous_enquiries\"\n          ></fsw-cbs-parsed-result-previous-enquiries>\n        </section>\n      </section>\n    </ng-template>\n  </ng-template>\n</fsw-panel>\n" }]
        }], ctorParameters: function () { return []; } });

var CbsParsedResultDirective_1;
let CbsParsedResultDirective = class CbsParsedResultDirective {
    static { CbsParsedResultDirective_1 = this; }
    static { this.REFRESH_KEY = 'fs-widgets-feature-cbs-parsed-result'; }
    constructor(_refreshService, _viewContainerRef) {
        this._refreshService = _refreshService;
        this._viewContainerRef = _viewContainerRef;
        this.updated = new EventEmitter();
        this.selectedDoc = null;
        this.isReadonly = false;
        this.avoidPermissions = [];
    }
    ngOnInit() {
        this._refreshService
            .register(CbsParsedResultDirective_1.REFRESH_KEY)
            .pipe(followDestroy(this), tap(() => this.refresh()))
            .subscribe();
    }
    ngOnChanges() {
        this.refresh();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    refresh() {
        this._viewContainerRef.clear();
        if (!this.selectedDoc ||
            this.avoidPermissions.includes(CBSPermissionEnum.PARSE_RESULT_SECTION)) {
            return;
        }
        const ref = this._viewContainerRef.createComponent(CbsParsedResultComponent);
        const instance = ref.instance;
        instance.selectedDoc.set(this.selectedDoc);
        instance.isReadonly.set(this.isReadonly);
        instance.updated
            .asObservable()
            .pipe(followDestroy(this), tap((selectedDoc) => this.updated.emit(selectedDoc)))
            .subscribe();
        ref.changeDetectorRef.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultDirective, deps: [{ token: RefreshService }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: CbsParsedResultDirective, isStandalone: true, selector: "[fswCbsParsedResult]", inputs: { selectedDoc: "selectedDoc", isReadonly: "isReadonly", avoidPermissions: "avoidPermissions" }, outputs: { updated: "updated" }, usesOnChanges: true, ngImport: i0 }); }
};
CbsParsedResultDirective = CbsParsedResultDirective_1 = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [RefreshService,
        ViewContainerRef])
], CbsParsedResultDirective);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsParsedResultDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswCbsParsedResult]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: RefreshService }, { type: i0.ViewContainerRef }]; }, propDecorators: { updated: [{
                type: Output
            }], selectedDoc: [{
                type: Input,
                args: [{ required: true }]
            }], isReadonly: [{
                type: Input
            }], avoidPermissions: [{
                type: Input
            }] } });

var title$z = "CBS Fraud Screening";
var empty$f = "No fraud screening results found.";
var columns$a = {
	rule: "Rule",
	screening_result: "Screening Result",
	remarks: "Remarks",
	justification: "Justification"
};
var buttons$Q = {
	refresh: "Refresh",
	update_justification: "Update Justification"
};
var cbsFraudScreeningSg = {
	title: title$z,
	empty: empty$f,
	columns: columns$a,
	buttons: buttons$Q
};

var SG$7 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$Q,
    columns: columns$a,
    default: cbsFraudScreeningSg,
    empty: empty$f,
    title: title$z
});

const SG_CBS_FRAUD_SCREENING_TRANSLATION = SG$7;

function injectCbsFraudScreeningSGEffects(preScreening, injector) {
    const loanService = inject(FSW_LOAN_SERVICE_TOKEN);
    const creditPreScreeningService = inject(CREDIT_PRE_SCREENING_SERVICE_TOKEN);
    const alertService = inject(FSW_ALERT_SERVICE_TOKEN);
    return {
        refresh: (doc) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => {
            return loanService.getLDDPreScreeningDocs([doc.info.uuid]).pipe(switchMap$1((docs) => {
                if (!docs?.length) {
                    return of(null);
                }
                return creditPreScreeningService.getById(docs.pop().pre_screening_id);
            }));
        }), tap((data) => preScreening.set(data)), catchError(() => {
            alertService.error('Failed to load pre screening of doc', null, {
                duration: 3000,
            });
            preScreening.set(null);
            return of(null);
        })), injector, null))),
        rulify: (doc, member_uuid, loan_id) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => {
            return creditPreScreeningService
                .triggerRulify({
                stage: FSWCreditPreScreeningStages.CBS,
                name: FSWCreditPreScreeningNames.CBS,
                identifier: FSWCreditPreScreeningIdentifiers.CBS,
                rulify: {
                    rule_set_identifier: FSWCreditPreScreeningRuleSetIdentifier.CBS,
                    extraction_mode: 'DB',
                    extraction_params: {
                        min_fs_commitment: 3000,
                        max_fs_commitment: 100000,
                        member_uuid,
                        country_code: getCountryCodeFromStorage(),
                    },
                    extraction_flags: {
                        no_cache: true,
                    },
                    data: {
                        parsed_data: {
                            document: doc.cbs.parsed_data,
                        },
                    },
                },
                metadata: {
                    ...(loan_id ? { loan_id } : {}),
                },
                ...(preScreening()?.id ? { latest_pre_screening_id: preScreening()?.id } : {}),
            })
                .pipe(switchMap$1((criteria) => {
                if (!criteria) {
                    return of(null);
                }
                return loanService
                    .postLDDPreScreeningDocs({
                    doc_id: doc.info.uuid,
                    pre_screening_id: criteria.id,
                    doc_type: 'CBS',
                })
                    .pipe(map(() => criteria));
            }));
        }), tap((data) => preScreening.set(data)), catchError((err) => {
            console.log(err);
            alertService.error('Failed to refresh pre screening of doc', null, {
                duration: 3000,
            });
            preScreening.set(null);
            return of(null);
        })), injector, null))),
        updateJustification: (criteria, cb) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => {
            return creditPreScreeningService.updateJustifications(preScreening().id, criteria);
        }), tap(() => {
            alertService.success('Update justifications successfully!', null, {
                duration: 3000,
            });
            cb?.();
        }), catchError((err) => {
            console.log(err);
            alertService.error('Failed to update justifications', null, {
                duration: 3000,
            });
            return of(null);
        })), injector, null))),
    };
}

function injectCbsFraudScreeningEffects(preScreening, injector) {
    switch (getCountryCodeFromStorage()) {
        case CountryCode.SG:
            return injectCbsFraudScreeningSGEffects(preScreening, injector);
        default:
            return injectCbsFraudScreeningSGEffects(preScreening, injector);
    }
}

function provideCbsFraudScreeningTranslation() {
    return [
        ...(FSWTranslateModule.forFeature({
            scope: 'cbs_fraud_screening',
            defaultKey: CountryCode.SG,
            data: {
                [CountryCode.SG]: SG_CBS_FRAUD_SCREENING_TRANSLATION,
            },
        }).providers || []),
        fswTranslateScope('cbs_fraud_screening'),
    ];
}

class CbsFraudScreeningComponent {
    get disabledUpdateJustification() {
        return isEqual(this.formGroup.value, Array.from(this.defaultValueMap.keys()).reduce((acc, key) => ({ ...acc, [key]: this.defaultValueMap.get(key) }), {}));
    }
    constructor() {
        this.updated = new EventEmitter();
        this.selectedDoc = signal({});
        this.loanId = signal(null);
        this.avoidPermissions = signal([]);
        this.memberUUID = signal('');
        this.preScreening = signal(null);
        this.isReadonly = signal(false);
        this.injector = inject(Injector);
        this.effects = injectCbsFraudScreeningEffects(this.preScreening, this.injector);
        this.CBSPermissionEnum = CBSPermissionEnum;
        this.formGroup = new UntypedFormGroup({});
        this.defaultValueMap = new Map();
        effect(() => {
            this.effects.refresh(this.selectedDoc());
        });
        effect(() => {
            this.defaultValueMap.clear();
            Object.keys(this.formGroup.controls).forEach((key) => this.formGroup.removeControl(key));
            this.formGroup.updateValueAndValidity();
            const preScreening = this.preScreening();
            if (!preScreening) {
                untracked(() => this.refresh());
                return;
            }
            preScreening.criteria.forEach((criteria) => {
                this.formGroup.addControl(criteria.id, new UntypedFormControl(criteria.justification));
                this.defaultValueMap.set(criteria.id, criteria.justification);
            });
        }, { allowSignalWrites: true });
    }
    refresh() {
        this.effects.rulify(this.selectedDoc(), this.memberUUID(), this.loanId());
    }
    updateJustification() {
        const payload = Object.keys(this.formGroup.value).map((id) => ({
            id,
            justification: this.formGroup.value[id],
        }));
        this.effects.updateJustification(payload, () => {
            this.defaultValueMap.clear();
            payload.forEach((item) => this.defaultValueMap.set(item.id, item.justification));
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsFraudScreeningComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CbsFraudScreeningComponent, isStandalone: true, selector: "fsw-cbs-fraud-screening", providers: [provideCbsFraudScreeningTranslation()], ngImport: i0, template: "<fsw-panel\n  [title]=\"'title' | fswTranslate\"\n  [headerClasses]=\"'!justify-start items-center gap-[8px]'\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <section class=\"flex flex-1 items-center justify-between\">\n      <label>\n        <span class=\"text-body-caption-400 font-semibold text-gray-500 self-start\">\n          ({{ selectedDoc().info.name }})\n        </span>\n      </label>\n      <aside class=\"flex items-center gap-[12px]\">\n        <button\n          *ngIf=\"\n            !isReadonly() &&\n            preScreening()?.criteria?.length &&\n            !avoidPermissions().includes(CBSPermissionEnum.FRAUD_SCREENING_REFRESH)\n          \"\n          fswButton\n          [appearance]=\"'secondary'\"\n          [size]=\"'m'\"\n          [attr.data-test-id]=\"'cbs-fraud-screening-refresh-button'\"\n          (click)=\"refresh()\"\n        >\n          {{ 'buttons.refresh' | fswTranslate }}\n        </button>\n        <button\n          *ngIf=\"\n            !isReadonly() &&\n            preScreening()?.criteria?.length &&\n            !avoidPermissions().includes(CBSPermissionEnum.FRAUD_SCREENING_UPDATE_JUSTIFICATION)\n          \"\n          fswButton\n          [appearance]=\"'secondary'\"\n          [size]=\"'m'\"\n          [attr.data-test-id]=\"'cbs-fraud-screening-update-justification-button'\"\n          [disabled]=\"disabledUpdateJustification\"\n          (click)=\"!disabledUpdateJustification && updateJustification()\"\n        >\n          {{ 'buttons.update_justification' | fswTranslate }}\n        </button>\n      </aside>\n    </section>\n  </ng-template>\n  <ng-container *ngIf=\"!preScreening()?.criteria?.length; else defaultTemplate\">\n    <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n      <svg\n        class=\"text-yellow-600\"\n        fill=\"currentColor\"\n        version=\"1.1\"\n        id=\"Capa_1\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n        width=\"100px\"\n        height=\"100px\"\n        viewBox=\"0 0 462.035 462.035\"\n        xml:space=\"preserve\"\n      >\n        <g>\n          <path\n            d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n          />\n        </g>\n      </svg>\n      <p class=\"text-center font-semibold text-body-small-600\">\n        {{ 'empty' | fswTranslate }}\n      </p>\n      <button\n        *ngIf=\"\n          !isReadonly() && !avoidPermissions().includes(CBSPermissionEnum.FRAUD_SCREENING_REFRESH)\n        \"\n        fswButton\n        [appearance]=\"'secondary'\"\n        [size]=\"'m'\"\n        [attr.data-test-id]=\"'cbs-fraud-screening-refresh-alternative-button'\"\n        (click)=\"refresh()\"\n      >\n        {{ 'buttons.refresh' | fswTranslate }}\n      </button>\n    </section>\n  </ng-container>\n  <ng-template #defaultTemplate>\n    <table class=\"fsw-table fsw-table--bordered w-full table-fixed\">\n      <thead>\n        <tr>\n          <th class=\"whitespace-normal align-middle break-words\">\n            {{ 'columns.rule' | fswTranslate }}\n          </th>\n          <th width=\"130px\" class=\"whitespace-normal align-middle break-words\">\n            {{ 'columns.screening_result' | fswTranslate }}\n          </th>\n          <th class=\"whitespace-normal align-middle break-words\">\n            {{ 'columns.remarks' | fswTranslate }}\n          </th>\n          <th class=\"whitespace-normal align-middle break-words\">\n            {{ 'columns.justification' | fswTranslate }}\n          </th>\n        </tr>\n      </thead>\n      <tbody>\n        <ng-container *ngFor=\"let item of preScreening()!.criteria\">\n          <tr>\n            <td class=\"whitespace-normal align-middle break-words\">{{ item.name }}</td>\n            <td\n              class=\"whitespace-normal align-middle break-words !text-white\"\n              [class.bg-red-500]=\"item.result === 'FAIL'\"\n              [class.bg-green-500]=\"item.result === 'PASS'\"\n            >\n              {{ item.result }}\n            </td>\n            <td class=\"whitespace-normal align-middle break-words\">{{ item.remark }}</td>\n            <td class=\"whitespace-normal align-middle break-words\">\n              <fsw-field [fullWidth]=\"true\" [readOnly]=\"isReadonly()\">\n                <textarea\n                  fswInput\n                  [formControl]=\"formGroup.controls[item.id] | fswForceControl\"\n                  [rows]=\"5\"\n                ></textarea>\n              </fsw-field>\n            </td>\n          </tr>\n        </ng-container>\n      </tbody>\n    </table>\n  </ng-template>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWLoanServiceModule }, { kind: "ngmodule", type: FSWAlertModule }, { kind: "ngmodule", type: CreditPreScreeningServiceModule }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "ngmodule", type: FSWFieldModule }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "ngmodule", type: FSWInputModule }, { kind: "directive", type: i1$4.FSWInputDirective, selector: "input[fswInput], textarea[fswInput]" }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: ForceControlPipeModule }, { kind: "pipe", type: i1$4.FSWForceControlPipe, name: "fswForceControl" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsFraudScreeningComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'fsw-cbs-fraud-screening', imports: [
                        FSWLoanServiceModule,
                        FSWAlertModule,
                        CreditPreScreeningServiceModule,
                        FSWPanelModule,
                        FSWTranslateModule,
                        NgIf,
                        FSWButtonModule,
                        NgForOf,
                        FSWFieldModule,
                        FSWInputModule,
                        FormsModule,
                        ReactiveFormsModule,
                        ForceControlPipeModule,
                    ], providers: [provideCbsFraudScreeningTranslation()], template: "<fsw-panel\n  [title]=\"'title' | fswTranslate\"\n  [headerClasses]=\"'!justify-start items-center gap-[8px]'\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <section class=\"flex flex-1 items-center justify-between\">\n      <label>\n        <span class=\"text-body-caption-400 font-semibold text-gray-500 self-start\">\n          ({{ selectedDoc().info.name }})\n        </span>\n      </label>\n      <aside class=\"flex items-center gap-[12px]\">\n        <button\n          *ngIf=\"\n            !isReadonly() &&\n            preScreening()?.criteria?.length &&\n            !avoidPermissions().includes(CBSPermissionEnum.FRAUD_SCREENING_REFRESH)\n          \"\n          fswButton\n          [appearance]=\"'secondary'\"\n          [size]=\"'m'\"\n          [attr.data-test-id]=\"'cbs-fraud-screening-refresh-button'\"\n          (click)=\"refresh()\"\n        >\n          {{ 'buttons.refresh' | fswTranslate }}\n        </button>\n        <button\n          *ngIf=\"\n            !isReadonly() &&\n            preScreening()?.criteria?.length &&\n            !avoidPermissions().includes(CBSPermissionEnum.FRAUD_SCREENING_UPDATE_JUSTIFICATION)\n          \"\n          fswButton\n          [appearance]=\"'secondary'\"\n          [size]=\"'m'\"\n          [attr.data-test-id]=\"'cbs-fraud-screening-update-justification-button'\"\n          [disabled]=\"disabledUpdateJustification\"\n          (click)=\"!disabledUpdateJustification && updateJustification()\"\n        >\n          {{ 'buttons.update_justification' | fswTranslate }}\n        </button>\n      </aside>\n    </section>\n  </ng-template>\n  <ng-container *ngIf=\"!preScreening()?.criteria?.length; else defaultTemplate\">\n    <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n      <svg\n        class=\"text-yellow-600\"\n        fill=\"currentColor\"\n        version=\"1.1\"\n        id=\"Capa_1\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n        width=\"100px\"\n        height=\"100px\"\n        viewBox=\"0 0 462.035 462.035\"\n        xml:space=\"preserve\"\n      >\n        <g>\n          <path\n            d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n          />\n        </g>\n      </svg>\n      <p class=\"text-center font-semibold text-body-small-600\">\n        {{ 'empty' | fswTranslate }}\n      </p>\n      <button\n        *ngIf=\"\n          !isReadonly() && !avoidPermissions().includes(CBSPermissionEnum.FRAUD_SCREENING_REFRESH)\n        \"\n        fswButton\n        [appearance]=\"'secondary'\"\n        [size]=\"'m'\"\n        [attr.data-test-id]=\"'cbs-fraud-screening-refresh-alternative-button'\"\n        (click)=\"refresh()\"\n      >\n        {{ 'buttons.refresh' | fswTranslate }}\n      </button>\n    </section>\n  </ng-container>\n  <ng-template #defaultTemplate>\n    <table class=\"fsw-table fsw-table--bordered w-full table-fixed\">\n      <thead>\n        <tr>\n          <th class=\"whitespace-normal align-middle break-words\">\n            {{ 'columns.rule' | fswTranslate }}\n          </th>\n          <th width=\"130px\" class=\"whitespace-normal align-middle break-words\">\n            {{ 'columns.screening_result' | fswTranslate }}\n          </th>\n          <th class=\"whitespace-normal align-middle break-words\">\n            {{ 'columns.remarks' | fswTranslate }}\n          </th>\n          <th class=\"whitespace-normal align-middle break-words\">\n            {{ 'columns.justification' | fswTranslate }}\n          </th>\n        </tr>\n      </thead>\n      <tbody>\n        <ng-container *ngFor=\"let item of preScreening()!.criteria\">\n          <tr>\n            <td class=\"whitespace-normal align-middle break-words\">{{ item.name }}</td>\n            <td\n              class=\"whitespace-normal align-middle break-words !text-white\"\n              [class.bg-red-500]=\"item.result === 'FAIL'\"\n              [class.bg-green-500]=\"item.result === 'PASS'\"\n            >\n              {{ item.result }}\n            </td>\n            <td class=\"whitespace-normal align-middle break-words\">{{ item.remark }}</td>\n            <td class=\"whitespace-normal align-middle break-words\">\n              <fsw-field [fullWidth]=\"true\" [readOnly]=\"isReadonly()\">\n                <textarea\n                  fswInput\n                  [formControl]=\"formGroup.controls[item.id] | fswForceControl\"\n                  [rows]=\"5\"\n                ></textarea>\n              </fsw-field>\n            </td>\n          </tr>\n        </ng-container>\n      </tbody>\n    </table>\n  </ng-template>\n</fsw-panel>\n" }]
        }], ctorParameters: function () { return []; } });

var CbsFraudScreeningDirective_1;
let CbsFraudScreeningDirective = class CbsFraudScreeningDirective {
    static { CbsFraudScreeningDirective_1 = this; }
    static { this.REFRESH_KEY = 'fs-widgets-feature-cbs-fraud-screening'; }
    constructor(_refreshService, _viewContainerRef) {
        this._refreshService = _refreshService;
        this._viewContainerRef = _viewContainerRef;
        this.updated = new EventEmitter();
        this.selectedDoc = null;
        this.memberUUID = null;
        this.loanId = null;
        this.isReadonly = false;
        this.avoidPermissions = [];
    }
    ngOnInit() {
        this._refreshService
            .register(CbsFraudScreeningDirective_1.REFRESH_KEY)
            .pipe(followDestroy(this), tap(() => this.refresh()))
            .subscribe();
    }
    ngOnChanges() {
        this.refresh();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    refresh() {
        this._viewContainerRef.clear();
        if (!this.selectedDoc ||
            !this.memberUUID ||
            this.avoidPermissions.includes(CBSPermissionEnum.FRAUD_SCREENING_SECTION)) {
            return;
        }
        const ref = this._viewContainerRef.createComponent(CbsFraudScreeningComponent);
        const instance = ref.instance;
        instance.selectedDoc.set(this.selectedDoc);
        instance.avoidPermissions.set(this.avoidPermissions);
        instance.memberUUID.set(this.memberUUID);
        instance.loanId.set(this.loanId);
        instance.isReadonly.set(this.isReadonly);
        instance.updated
            .asObservable()
            .pipe(followDestroy(this), tap((selectedDoc) => this.updated.emit(selectedDoc)))
            .subscribe();
        ref.changeDetectorRef.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsFraudScreeningDirective, deps: [{ token: RefreshService }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: CbsFraudScreeningDirective, isStandalone: true, selector: "[fswCbsFraudScreening]", inputs: { selectedDoc: "selectedDoc", memberUUID: "memberUUID", loanId: "loanId", isReadonly: "isReadonly", avoidPermissions: "avoidPermissions" }, outputs: { updated: "updated" }, usesOnChanges: true, ngImport: i0 }); }
};
CbsFraudScreeningDirective = CbsFraudScreeningDirective_1 = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [RefreshService,
        ViewContainerRef])
], CbsFraudScreeningDirective);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsFraudScreeningDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswCbsFraudScreening]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: RefreshService }, { type: i0.ViewContainerRef }]; }, propDecorators: { updated: [{
                type: Output
            }], selectedDoc: [{
                type: Input,
                args: [{ required: true }]
            }], memberUUID: [{
                type: Input,
                args: [{ required: true }]
            }], loanId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], avoidPermissions: [{
                type: Input
            }] } });

class CbsSummaryComponent {
    constructor() {
        this.updated = new EventEmitter();
        this.refreshedAt = signal(new Date());
        this.isReadonly = signal(false);
        this.docs = signal([]);
        this.loanId = signal(null);
        this.memberUUID = signal('');
        this.memberIdInt = signal(0);
        this.avoidPermissions = signal([]);
        this.sortDirection = signal('desc');
        this.selectedDoc = signal(null);
        this.sortedDocs = computed(() => this.docs().sort((a, b) => this.sortDirection() === 'asc'
            ? new Date(a.info.version).getTime() - new Date(b.info.version).getTime()
            : new Date(b.info.version).getTime() - new Date(a.info.version).getTime()));
        this.injector = inject(Injector);
        this.effects = injectCbsSummaryEffects(this.refreshedAt, this.docs, this.selectedDoc, this.injector);
        this.dialog = inject(Dialog);
        this.CBSPermissionEnum = CBSPermissionEnum;
        effect(() => {
            const memberIdInt = this.memberIdInt();
            const refreshedAt = this.refreshedAt();
            if (refreshedAt) {
                this.effects.refreshDocs(memberIdInt);
            }
        }, { allowSignalWrites: true });
        effect(() => {
            const docs = this.docs();
            this.updated.emit(docs);
        }, { allowSignalWrites: true });
    }
    deleteDoc(doc, cb) {
        this.dialog
            .open(FSWCbsSummaryConfirmComponent, {
            data: {
                title: `confirmation.delete.title`,
                titleParams: {},
                description: `confirmation.delete.description`,
                descriptionParams: {
                    name: doc.info.name,
                },
            },
            injector: this.injector,
        })
            .closed.pipe(take(1), tap((accept) => {
            if (accept) {
                this.effects.deleteDoc(doc);
                cb && cb();
            }
        }))
            .subscribe();
    }
    parseDoc(doc, cb) {
        this.dialog
            .open(FSWCbsSummaryConfirmComponent, {
            data: {
                title: `confirmation.parse.title`,
                titleParams: {},
                description: `confirmation.parse.description`,
                descriptionParams: {
                    name: doc.info.name,
                },
            },
            injector: this.injector,
        })
            .closed.pipe(take(1), tap((accept) => {
            if (accept) {
                this.effects.parseDoc(doc);
                cb && cb();
            }
        }))
            .subscribe();
    }
    uploadDoc(cb) {
        this.dialog
            .open(FSWCbsSummaryUploadComponent, {
            injector: this.injector,
        })
            .closed.pipe(take(1), tap((file) => {
            if (file) {
                this.effects.uploadDoc({
                    file,
                    doc_type: 'CBS',
                    borrower_id: untracked(() => this.memberIdInt()),
                });
                cb && cb();
            }
        }))
            .subscribe();
    }
    pdfViewer(selectedDoc) {
        this.dialog.open(FSWCbsSummaryPdfComponent, {
            data: selectedDoc,
            injector: this.injector,
        });
    }
    errorViewer(selectedDoc) {
        this.dialog.open(FSWCbsSummaryErrorComponent, {
            data: selectedDoc,
            injector: this.injector,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsSummaryComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CbsSummaryComponent, isStandalone: true, selector: "fsw-cbs-summary", providers: [provideCbsSummaryTranslation()], ngImport: i0, template: "<fsw-panel [title]=\"'title' | fswTranslate\">\n  <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\n</fsw-panel>\n<ng-template #contentTemplate>\n  <section class=\"w-full flex flex-col gap-[16px]\">\n    <fsw-panel [title]=\"'sub_title' | fswTranslate\">\n      <ng-template fswPanelHeaderSuffix>\n        <button\n          *ngIf=\"\n            !isReadonly() &&\n            docs()?.length &&\n            !avoidPermissions().includes(CBSPermissionEnum.SUMMARY_UPLOAD)\n          \"\n          fswButton\n          [appearance]=\"'secondary'\"\n          [size]=\"'m'\"\n          [attr.data-test-id]=\"'cbs-summary-upload-new-button'\"\n          (click)=\"uploadDoc()\"\n        >\n          {{ 'buttons.upload_new' | fswTranslate }}\n        </button>\n      </ng-template>\n      <table\n        *ngIf=\"docs()?.length; else emptyTemplate\"\n        class=\"fsw-table fsw-table--bordered w-full table-fixed\"\n      >\n        <thead>\n          <tr>\n            <th>{{ 'columns.name' | fswTranslate }}</th>\n            <th>\n              <label class=\"inline-flex w-full items-center gap-[12px]\">\n                <span>\n                  {{ 'columns.uploaded_date' | fswTranslate }}\n                </span>\n                <i\n                  (click)=\"sortDirection.set(sortDirection() === 'desc' ? 'asc' : 'desc')\"\n                  [fswIcon]=\"sortDirection() === 'desc' ? 'common-sort-down' : 'common-sort-up'\"\n                  [fontSize]=\"'16px'\"\n                  class=\"hover:cursor-pointer hover:text-green-500\"\n                  [attr.data-test-id]=\"'cbs-summary-table-sort-button'\"\n                ></i>\n              </label>\n            </th>\n            <th>{{ 'columns.parsing_status' | fswTranslate }}</th>\n            <th>{{ 'columns.action' | fswTranslate }}</th>\n          </tr>\n        </thead>\n        <tbody>\n          <ng-container *ngFor=\"let doc of sortedDocs()\">\n            <tr [class.bg-green-200]=\"doc.info.id === selectedDoc()?.info?.id\">\n              <td\n                class=\"whitespace-normal align-middle break-words\"\n                (click)=\"doc.info.id !== selectedDoc()?.info?.id && selectedDoc.set(doc)\"\n              >\n                {{ doc.info.name }}\n              </td>\n              <td\n                class=\"whitespace-normal align-middle\"\n                (click)=\"doc.info.id !== selectedDoc()?.info?.id && selectedDoc.set(doc)\"\n              >\n                {{ doc.info.version | date : 'dd/MM/yyyy hh:mm:ss' }}\n              </td>\n              <td class=\"whitespace-normal align-middle\">\n                <ng-container *ngIf=\"doc.cbs?.created_at\">\n                  <span class=\"inline-flex flex-wrap items-center gap-2\">\n                    <span class=\"text-body-small-500 text-gray-900\"\n                      >{{ 'columns.last_parsed' | fswTranslate }}:\n                      {{ doc.cbs.created_at | date : 'dd/MM/yyyy hh:mm:ss' }}</span\n                    >\n                    <button\n                      *ngIf=\"doc.cbs.error_message\"\n                      fswButton\n                      [appearance]=\"'secondary-elevate'\"\n                      [size]=\"'m'\"\n                      (click)=\"errorViewer(doc)\"\n                      class=\"min-w-max !text-red-500\"\n                    >\n                      {{ 'buttons.view_error' | fswTranslate }}\n                    </button>\n                  </span>\n                </ng-container>\n              </td>\n              <td class=\"align-middle\">\n                <section class=\"flex items-center gap-[12px]\">\n                  <button\n                    *ngIf=\"\n                      !isReadonly() && !avoidPermissions().includes(CBSPermissionEnum.SUMMARY_PARSE)\n                    \"\n                    fswButton\n                    [appearance]=\"'primary'\"\n                    [size]=\"'m'\"\n                    (click)=\"parseDoc(doc)\"\n                  >\n                    {{ (doc.cbs ? 'buttons.re_parse' : 'buttons.parse') | fswTranslate }}\n                  </button>\n                  <button\n                    *ngIf=\"\n                      !isReadonly() &&\n                      !avoidPermissions().includes(CBSPermissionEnum.SUMMARY_DELETE)\n                    \"\n                    (click)=\"deleteDoc(doc)\"\n                    fswButton\n                    [appearance]=\"'icon-with-bg'\"\n                  >\n                    <i\n                      class=\"hover:cursor-pointer text-red-500\"\n                      [fswIcon]=\"'common-delete-alternative'\"\n                      [fontSize]=\"'24px'\"\n                    ></i>\n                  </button>\n                </section>\n              </td>\n            </tr>\n          </ng-container>\n        </tbody>\n      </table>\n      <ng-template #emptyTemplate>\n        <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n          <svg\n            class=\"text-yellow-600\"\n            fill=\"currentColor\"\n            version=\"1.1\"\n            id=\"Capa_1\"\n            xmlns=\"http://www.w3.org/2000/svg\"\n            xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n            width=\"100px\"\n            height=\"100px\"\n            viewBox=\"0 0 462.035 462.035\"\n            xml:space=\"preserve\"\n          >\n            <g>\n              <path\n                d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n              />\n            </g>\n          </svg>\n          <p class=\"text-center font-semibold text-body-small-600\">\n            {{ 'empty' | fswTranslate }}\n          </p>\n          <button\n            *ngIf=\"!isReadonly() && !avoidPermissions().includes(CBSPermissionEnum.SUMMARY_UPLOAD)\"\n            fswButton\n            [appearance]=\"'secondary'\"\n            [size]=\"'m'\"\n            (click)=\"uploadDoc()\"\n            [attr.data-test-id]=\"'cbs-summary-upload-new-alternative-button'\"\n          >\n            {{ 'buttons.upload_new' | fswTranslate }}\n          </button>\n        </section>\n      </ng-template>\n    </fsw-panel>\n    <ng-container *ngIf=\"selectedDoc() as selectedDoc\">\n      <ng-container\n        *ngIf=\"\n          !avoidPermissions().includes(CBSPermissionEnum.FRAUD_SCREENING_SECTION) &&\n          selectedDoc.cbs?.parsed_data\n        \"\n        fswCbsFraudScreening\n        [loanId]=\"loanId()\"\n        [avoidPermissions]=\"avoidPermissions()\"\n        [memberUUID]=\"memberUUID()\"\n        [selectedDoc]=\"selectedDoc\"\n        [isReadonly]=\"isReadonly()\"\n      />\n      <fsw-panel\n        [title]=\"'pdf_title' | fswTranslate\"\n        *ngIf=\"!avoidPermissions().includes(CBSPermissionEnum.PDF_VIEWER_SECTION)\"\n        [headerClasses]=\"'!justify-start items-center gap-[8px]'\"\n      >\n        <ng-template fswPanelHeaderSuffix>\n          <label>\n            <span class=\"text-body-caption-400 font-semibold text-gray-500 self-start\">\n              ({{ selectedDoc.info.name }})\n            </span>\n          </label>\n        </ng-template>\n        <ng-container fswCbsPdfViewer [selectedDoc]=\"selectedDoc\" />\n      </fsw-panel>\n      <ng-container\n        *ngIf=\"!avoidPermissions().includes(CBSPermissionEnum.PARSE_RESULT_SECTION)\"\n        fswCbsParsedResult\n        [selectedDoc]=\"selectedDoc\"\n        [isReadonly]=\"isReadonly()\"\n        (updated)=\"effects.refreshDocs(memberIdInt())\"\n      />\n    </ng-container>\n  </section>\n</ng-template>\n", dependencies: [{ kind: "ngmodule", type: FSWBlobServiceModule }, { kind: "ngmodule", type: FSWLoanServiceModule }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: CbsParsedResultDirective, selector: "[fswCbsParsedResult]", inputs: ["selectedDoc", "isReadonly", "avoidPermissions"], outputs: ["updated"] }, { kind: "directive", type: CbsFraudScreeningDirective, selector: "[fswCbsFraudScreening]", inputs: ["selectedDoc", "memberUUID", "loanId", "isReadonly", "avoidPermissions"], outputs: ["updated"] }, { kind: "directive", type: CbsPdfViewerDirective, selector: "[fswCbsPdfViewer]", inputs: ["selectedDoc", "avoidPermissions"], outputs: ["updated", "expanded"] }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "pipe", type: DatePipe, name: "date" }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "ngmodule", type: FSWAlertModule }, { kind: "directive", type: NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "ngmodule", type: DialogModule }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsSummaryComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'fsw-cbs-summary', imports: [
                        FSWBlobServiceModule,
                        FSWLoanServiceModule,
                        FSWCbsSummaryConfirmComponent,
                        FSWCbsSummaryUploadComponent,
                        FSWCbsSummaryErrorComponent,
                        FSWCbsSummaryPdfComponent,
                        FSWPanelModule,
                        FSWTranslateModule,
                        NgIf,
                        CbsParsedResultDirective,
                        CbsFraudScreeningDirective,
                        CbsPdfViewerDirective,
                        FSWButtonModule,
                        NgForOf,
                        DatePipe,
                        FSWIconModule,
                        FSWAlertModule,
                        NgTemplateOutlet,
                        DialogModule,
                    ], providers: [provideCbsSummaryTranslation()], template: "<fsw-panel [title]=\"'title' | fswTranslate\">\n  <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\n</fsw-panel>\n<ng-template #contentTemplate>\n  <section class=\"w-full flex flex-col gap-[16px]\">\n    <fsw-panel [title]=\"'sub_title' | fswTranslate\">\n      <ng-template fswPanelHeaderSuffix>\n        <button\n          *ngIf=\"\n            !isReadonly() &&\n            docs()?.length &&\n            !avoidPermissions().includes(CBSPermissionEnum.SUMMARY_UPLOAD)\n          \"\n          fswButton\n          [appearance]=\"'secondary'\"\n          [size]=\"'m'\"\n          [attr.data-test-id]=\"'cbs-summary-upload-new-button'\"\n          (click)=\"uploadDoc()\"\n        >\n          {{ 'buttons.upload_new' | fswTranslate }}\n        </button>\n      </ng-template>\n      <table\n        *ngIf=\"docs()?.length; else emptyTemplate\"\n        class=\"fsw-table fsw-table--bordered w-full table-fixed\"\n      >\n        <thead>\n          <tr>\n            <th>{{ 'columns.name' | fswTranslate }}</th>\n            <th>\n              <label class=\"inline-flex w-full items-center gap-[12px]\">\n                <span>\n                  {{ 'columns.uploaded_date' | fswTranslate }}\n                </span>\n                <i\n                  (click)=\"sortDirection.set(sortDirection() === 'desc' ? 'asc' : 'desc')\"\n                  [fswIcon]=\"sortDirection() === 'desc' ? 'common-sort-down' : 'common-sort-up'\"\n                  [fontSize]=\"'16px'\"\n                  class=\"hover:cursor-pointer hover:text-green-500\"\n                  [attr.data-test-id]=\"'cbs-summary-table-sort-button'\"\n                ></i>\n              </label>\n            </th>\n            <th>{{ 'columns.parsing_status' | fswTranslate }}</th>\n            <th>{{ 'columns.action' | fswTranslate }}</th>\n          </tr>\n        </thead>\n        <tbody>\n          <ng-container *ngFor=\"let doc of sortedDocs()\">\n            <tr [class.bg-green-200]=\"doc.info.id === selectedDoc()?.info?.id\">\n              <td\n                class=\"whitespace-normal align-middle break-words\"\n                (click)=\"doc.info.id !== selectedDoc()?.info?.id && selectedDoc.set(doc)\"\n              >\n                {{ doc.info.name }}\n              </td>\n              <td\n                class=\"whitespace-normal align-middle\"\n                (click)=\"doc.info.id !== selectedDoc()?.info?.id && selectedDoc.set(doc)\"\n              >\n                {{ doc.info.version | date : 'dd/MM/yyyy hh:mm:ss' }}\n              </td>\n              <td class=\"whitespace-normal align-middle\">\n                <ng-container *ngIf=\"doc.cbs?.created_at\">\n                  <span class=\"inline-flex flex-wrap items-center gap-2\">\n                    <span class=\"text-body-small-500 text-gray-900\"\n                      >{{ 'columns.last_parsed' | fswTranslate }}:\n                      {{ doc.cbs.created_at | date : 'dd/MM/yyyy hh:mm:ss' }}</span\n                    >\n                    <button\n                      *ngIf=\"doc.cbs.error_message\"\n                      fswButton\n                      [appearance]=\"'secondary-elevate'\"\n                      [size]=\"'m'\"\n                      (click)=\"errorViewer(doc)\"\n                      class=\"min-w-max !text-red-500\"\n                    >\n                      {{ 'buttons.view_error' | fswTranslate }}\n                    </button>\n                  </span>\n                </ng-container>\n              </td>\n              <td class=\"align-middle\">\n                <section class=\"flex items-center gap-[12px]\">\n                  <button\n                    *ngIf=\"\n                      !isReadonly() && !avoidPermissions().includes(CBSPermissionEnum.SUMMARY_PARSE)\n                    \"\n                    fswButton\n                    [appearance]=\"'primary'\"\n                    [size]=\"'m'\"\n                    (click)=\"parseDoc(doc)\"\n                  >\n                    {{ (doc.cbs ? 'buttons.re_parse' : 'buttons.parse') | fswTranslate }}\n                  </button>\n                  <button\n                    *ngIf=\"\n                      !isReadonly() &&\n                      !avoidPermissions().includes(CBSPermissionEnum.SUMMARY_DELETE)\n                    \"\n                    (click)=\"deleteDoc(doc)\"\n                    fswButton\n                    [appearance]=\"'icon-with-bg'\"\n                  >\n                    <i\n                      class=\"hover:cursor-pointer text-red-500\"\n                      [fswIcon]=\"'common-delete-alternative'\"\n                      [fontSize]=\"'24px'\"\n                    ></i>\n                  </button>\n                </section>\n              </td>\n            </tr>\n          </ng-container>\n        </tbody>\n      </table>\n      <ng-template #emptyTemplate>\n        <section class=\"w-full py-10 flex flex-col gap-[16px] items-center\">\n          <svg\n            class=\"text-yellow-600\"\n            fill=\"currentColor\"\n            version=\"1.1\"\n            id=\"Capa_1\"\n            xmlns=\"http://www.w3.org/2000/svg\"\n            xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n            width=\"100px\"\n            height=\"100px\"\n            viewBox=\"0 0 462.035 462.035\"\n            xml:space=\"preserve\"\n          >\n            <g>\n              <path\n                d=\"M457.83,158.441c-0.021-0.028-0.033-0.058-0.057-0.087l-50.184-62.48c-0.564-0.701-1.201-1.305-1.879-1.845\n\t\tc-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615,0-6.804,1.661-8.965,4.225c-0.678,0.54-1.316,1.138-1.885,1.845l-50.178,62.48\n\t\tc-0.023,0.029-0.034,0.059-0.057,0.087C1.655,160.602,0,163.787,0,167.39v193.07c0,6.5,5.27,11.771,11.77,11.771h438.496\n\t\tc6.5,0,11.77-5.271,11.77-11.771V167.39C462.037,163.787,460.381,160.602,457.83,158.441z M408.516,134.615l16.873,21.005h-16.873\n\t\tV134.615z M384.975,113.345v42.274H296.84c-2.514,0-4.955,0.805-6.979,2.293l-58.837,43.299l-58.849-43.305\n\t\tc-2.023-1.482-4.466-2.287-6.978-2.287H77.061v-42.274H384.975z M53.523,155.62H36.65l16.873-21.005V155.62z M438.498,348.69H23.54\n\t\tV179.16h137.796l62.711,46.148c4.15,3.046,9.805,3.052,13.954-0.005l62.698-46.144h137.799V348.69L438.498,348.69z\"\n              />\n            </g>\n          </svg>\n          <p class=\"text-center font-semibold text-body-small-600\">\n            {{ 'empty' | fswTranslate }}\n          </p>\n          <button\n            *ngIf=\"!isReadonly() && !avoidPermissions().includes(CBSPermissionEnum.SUMMARY_UPLOAD)\"\n            fswButton\n            [appearance]=\"'secondary'\"\n            [size]=\"'m'\"\n            (click)=\"uploadDoc()\"\n            [attr.data-test-id]=\"'cbs-summary-upload-new-alternative-button'\"\n          >\n            {{ 'buttons.upload_new' | fswTranslate }}\n          </button>\n        </section>\n      </ng-template>\n    </fsw-panel>\n    <ng-container *ngIf=\"selectedDoc() as selectedDoc\">\n      <ng-container\n        *ngIf=\"\n          !avoidPermissions().includes(CBSPermissionEnum.FRAUD_SCREENING_SECTION) &&\n          selectedDoc.cbs?.parsed_data\n        \"\n        fswCbsFraudScreening\n        [loanId]=\"loanId()\"\n        [avoidPermissions]=\"avoidPermissions()\"\n        [memberUUID]=\"memberUUID()\"\n        [selectedDoc]=\"selectedDoc\"\n        [isReadonly]=\"isReadonly()\"\n      />\n      <fsw-panel\n        [title]=\"'pdf_title' | fswTranslate\"\n        *ngIf=\"!avoidPermissions().includes(CBSPermissionEnum.PDF_VIEWER_SECTION)\"\n        [headerClasses]=\"'!justify-start items-center gap-[8px]'\"\n      >\n        <ng-template fswPanelHeaderSuffix>\n          <label>\n            <span class=\"text-body-caption-400 font-semibold text-gray-500 self-start\">\n              ({{ selectedDoc.info.name }})\n            </span>\n          </label>\n        </ng-template>\n        <ng-container fswCbsPdfViewer [selectedDoc]=\"selectedDoc\" />\n      </fsw-panel>\n      <ng-container\n        *ngIf=\"!avoidPermissions().includes(CBSPermissionEnum.PARSE_RESULT_SECTION)\"\n        fswCbsParsedResult\n        [selectedDoc]=\"selectedDoc\"\n        [isReadonly]=\"isReadonly()\"\n        (updated)=\"effects.refreshDocs(memberIdInt())\"\n      />\n    </ng-container>\n  </section>\n</ng-template>\n" }]
        }], ctorParameters: function () { return []; } });

var CbsSummaryDirective_1;
let CbsSummaryDirective = class CbsSummaryDirective {
    static { CbsSummaryDirective_1 = this; }
    static { this.REFRESH_KEY = 'fs-widgets-feature-cbs-summary'; }
    constructor(_refreshService, _viewContainerRef) {
        this._refreshService = _refreshService;
        this._viewContainerRef = _viewContainerRef;
        this.updated = new EventEmitter();
        this.memberIdInt = null;
        this.memberUUID = null;
        this.loanId = null;
        this.isReadonly = false;
        this.avoidPermissions = [];
    }
    ngOnInit() {
        this._refreshService
            .register(CbsSummaryDirective_1.REFRESH_KEY)
            .pipe(followDestroy(this), tap(() => this.refresh()))
            .subscribe();
    }
    ngOnChanges() {
        this.refresh();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    refresh() {
        this._viewContainerRef.clear();
        if (!this.memberIdInt ||
            !this.memberUUID ||
            this.avoidPermissions.includes(CBSPermissionEnum.SUMMARY_SECTION)) {
            return;
        }
        const ref = this._viewContainerRef.createComponent(CbsSummaryComponent);
        const instance = ref.instance;
        instance.memberIdInt.set(this.memberIdInt);
        instance.loanId.set(this.loanId);
        instance.memberUUID.set(this.memberUUID);
        instance.avoidPermissions.set(this.avoidPermissions);
        instance.isReadonly.set(this.isReadonly);
        instance.updated
            .asObservable()
            .pipe(followDestroy(this), tap((docs) => this.updated.emit(docs)))
            .subscribe();
        ref.changeDetectorRef.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsSummaryDirective, deps: [{ token: RefreshService }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: CbsSummaryDirective, isStandalone: true, selector: "[fswCbsSummary]", inputs: { memberIdInt: "memberIdInt", memberUUID: "memberUUID", loanId: "loanId", isReadonly: "isReadonly", avoidPermissions: "avoidPermissions" }, outputs: { updated: "updated" }, usesOnChanges: true, ngImport: i0 }); }
};
CbsSummaryDirective = CbsSummaryDirective_1 = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [RefreshService,
        ViewContainerRef])
], CbsSummaryDirective);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsSummaryDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswCbsSummary]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: RefreshService }, { type: i0.ViewContainerRef }]; }, propDecorators: { updated: [{
                type: Output
            }], memberIdInt: [{
                type: Input,
                args: [{ required: true }]
            }], memberUUID: [{
                type: Input,
                args: [{ required: true }]
            }], loanId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], avoidPermissions: [{
                type: Input
            }] } });

let CbsPullComponent = class CbsPullComponent {
    constructor() {
        this.successPulled = new EventEmitter();
        this.errorPulled = new EventEmitter();
        this.memberIdInt = null;
        this.isReadonly = false;
        this.blobService = inject(BLOB_SERVICE_TOKEN);
        this.loanService = inject(FSW_LOAN_SERVICE_TOKEN);
        this.elementRef = inject(ElementRef);
    }
    ngOnInit() {
        fromEvent(this.elementRef.nativeElement, 'click')
            .pipe(filter$1(() => this.memberIdInt != null && !this.isReadonly), switchMap$1(() => this.blobService.getMemberDoc(this.memberIdInt).pipe(map((docs) => (docs || []).filter((doc) => doc.docType === 'CBS')), switchMap$1((docs) => {
            if (!docs.length) {
                return of([]);
            }
            return this.loanService
                .getParsedCBS(docs.map((doc) => doc.uuid), false)
                .pipe(map((parsedDocs) => docs.map((doc) => ({
                info: doc,
                cbs: parsedDocs.find((parsedDoc) => parsedDoc.doc_id === doc.uuid),
            }))), tap((data) => this.successPulled.emit(data)));
        }), catchError(() => {
            this.errorPulled.emit();
            return EMPTY;
        }))))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsPullComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CbsPullComponent, isStandalone: true, selector: "[fsw-cbs-pull]", inputs: { memberIdInt: "memberIdInt", isReadonly: "isReadonly" }, outputs: { successPulled: "successPulled", errorPulled: "errorPulled" }, ngImport: i0, template: `<ng-content></ng-content>`, isInline: true, dependencies: [{ kind: "ngmodule", type: FSWBlobServiceModule }, { kind: "ngmodule", type: FSWLoanServiceModule }] }); }
};
CbsPullComponent = __decorate([
    autoDestroy()
], CbsPullComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CbsPullComponent, decorators: [{
            type: Component,
            args: [{
                    // eslint-disable-next-line @angular-eslint/component-selector
                    selector: '[fsw-cbs-pull]',
                    standalone: true,
                    template: `<ng-content></ng-content>`,
                    imports: [FSWBlobServiceModule, FSWLoanServiceModule],
                }]
        }], propDecorators: { successPulled: [{
                type: Output
            }], errorPulled: [{
                type: Output
            }], memberIdInt: [{
                type: Input,
                args: [{ required: true }]
            }], isReadonly: [{
                type: Input
            }] } });

const SG_PROVIDERS$5 = [
    {
        provide: FORM_CONFIG_TOKEN$4,
        useValue: SG_FORM_CONFIG$4,
    },
];

const ID_PROVIDERS$9 = [
    {
        provide: FORM_CONFIG_TOKEN$4,
        useValue: ID_FORM_CONFIG$4,
    },
];

const PROVIDERS_MAP$9 = {
    default: SG_PROVIDERS$5,
    [CountryCode.SG]: SG_PROVIDERS$5,
    [CountryCode.ID]: ID_PROVIDERS$9,
};
const companyDetailLoadProviders = (countryCode) => [
    ...getCustomProviders(PROVIDERS_MAP$9, SG_PROVIDERS$5, countryCode),
];

class CompanyDetailModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyDetailModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CompanyDetailModule, declarations: [CompanyDetailComponent], imports: [CommonModule, LetDirective, FormWidgetModule], exports: [CompanyDetailComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyDetailModule, providers: [...companyDetailLoadProviders(getCountryCodeFromStorage())], imports: [CommonModule, FormWidgetModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyDetailModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, LetDirective, FormWidgetModule],
                    declarations: [CompanyDetailComponent],
                    exports: [CompanyDetailComponent],
                    providers: [...companyDetailLoadProviders(getCountryCodeFromStorage())],
                }]
        }] });

const SG_PROVIDERS$4 = [
    {
        provide: FORM_CONFIG_TOKEN$3,
        useValue: SG_FORM_CONFIG$3,
    },
    {
        provide: GRID_CONFIG_TOKEN$1,
        useValue: SG_GRID_CONFIG$1,
    },
    {
        provide: STORE_TOKEN$8,
        useClass: SGCompanyDirectorStore$1,
        deps: [APPLICATION_MEMBER_BIP_SERVICE_TOKEN],
    },
];

const ID_PROVIDERS$8 = [
    {
        provide: FORM_CONFIG_TOKEN$3,
        useValue: ID_FORM_CONFIG$3,
    },
    {
        provide: GRID_CONFIG_TOKEN$1,
        useValue: ID_GRID_CONFIG$1,
    },
    {
        provide: STORE_TOKEN$8,
        useClass: IDCompanyDirectorStore$1,
        deps: [APPLICATION_MEMBER_BIP_SERVICE_TOKEN],
    },
];

const PROVIDERS_MAP$8 = {
    default: SG_PROVIDERS$4,
    [CountryCode.SG]: SG_PROVIDERS$4,
    [CountryCode.ID]: ID_PROVIDERS$8,
};
const companyDirectorLoadProviders = (countryCode) => [
    ...getCustomProviders(PROVIDERS_MAP$8, SG_PROVIDERS$4, countryCode),
];

class CompanyDirectorModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyDirectorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CompanyDirectorModule, declarations: [CompanyDirectorComponent], imports: [CommonModule,
            FSWGridModule,
            LetDirective,
            FSWModalModule,
            UtilsServiceModule,
            MemberBIPServiceModule,
            CompanyDirectorGridModule,
            CompanyDirectorEntryDialogModule], exports: [CompanyDirectorComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyDirectorModule, providers: [...companyDirectorLoadProviders(getCountryCodeFromStorage())], imports: [CommonModule,
            FSWGridModule,
            FSWModalModule,
            UtilsServiceModule,
            MemberBIPServiceModule,
            CompanyDirectorGridModule,
            CompanyDirectorEntryDialogModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyDirectorModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FSWGridModule,
                        LetDirective,
                        FSWModalModule,
                        UtilsServiceModule,
                        MemberBIPServiceModule,
                        CompanyDirectorGridModule,
                        CompanyDirectorEntryDialogModule,
                    ],
                    declarations: [CompanyDirectorComponent],
                    exports: [CompanyDirectorComponent],
                    providers: [...companyDirectorLoadProviders(getCountryCodeFromStorage())],
                }]
        }] });

var CPCommentTypes;
(function (CPCommentTypes) {
    CPCommentTypes["COMPANY_PROFILE"] = "company_profile";
    CPCommentTypes["RISK_PROFILE"] = "risk_profile";
    CPCommentTypes["RISK_ANALYSIS"] = "risk_analysis";
})(CPCommentTypes || (CPCommentTypes = {}));

const COMPANY_PROFILE_SERVICE_TOKEN = new InjectionToken('CompanyProfile_SERVICE_TOKEN');

class CompanyProfileService {
    constructor() {
        this._httpClient = inject(HttpClient);
        this._utilsService = injectUtilsService();
        this._applicationRelationshipService = injectApplicationRelationshipService();
        this._kongUrl = this._utilsService.getKongUrl();
    }
    //#region Application
    getAllByApplication(applicationId) {
        return this._applicationRelationshipService.getAsync(applicationId, 'company_profile');
    }
    postByApplication(applicationId, company_profile_ids) {
        return forkJoin(company_profile_ids.map((id) => this._applicationRelationshipService.addAsync(applicationId, 'company_profile', id)));
    }
    removeByApplication(applicationId, id) {
        return this._applicationRelationshipService.deleteAsync(applicationId, 'company_profile', id);
    }
    // TODO: change it when 'https://fundingasiagroup.atlassian.net/browse/ITS-3789' done
    getSettings() {
        return of({
            company_establishment_history_options: [
                'Self Established by Owner',
                'Acquired by Past Owner',
            ],
            main_market_segment_options: ['Domestic', 'Export', 'Domestic & Export'],
            source_of_products_options: ['Domestic', 'Export', 'Domestic & Export'],
            concentration_of_competition_options: ['High', 'Medium', 'Low'],
            type_of_payment_by_buyers_customers_options: ['Cash', 'Online', 'Cheque', 'Online & Cash'],
            dependency_on_technology_options: ['High', 'Medium', 'Low'],
            obsolescence_risk_options: ['High', 'Medium', 'Low'],
            loan_use_purpose_options: [
                'Working Capital',
                'Bridge Loan',
                'Investment (Vehicles)',
                'Investment (Machinery/Equipment)',
                'Investment (Project)',
                'Other Investment',
                'Supply Chain Financing',
                'Share Purchase Agreement (SPA)',
                'Others',
            ],
            bargaining_power_of_supplier_options: [
                'Scarcity of Raw Material',
                'High Dependency on Supplier',
                'Low Dependency on Supplier',
                'Secured Supply of Raw Material',
            ],
            bargaining_power_of_buyer_options: ['High Dependency on Buyer', 'Low Dependency on Buyer'],
            threat_of_new_entrant_options: ['High Barrier of Entry', 'Low Barrier of Entry'],
            threat_of_substitution_options: ['High', 'Medium', 'Low'],
            industry_rivalry_options: ['High', 'Medium', 'Low'],
            business_risk_options: ['High', 'Medium', 'Low'],
            liquidity_risk_options: ['High', 'Medium', 'Low'],
            repayment_risk_options: ['High', 'Medium', 'Low'],
            other_risk_options: ['High', 'Medium', 'Low'],
        });
    }
    //#endregion Application
    //#region Profile
    getAll(ids, countryCode) {
        return ids.length > 0 ? forkJoin([...ids.map((id) => this.getById(id, countryCode))]) : of([]);
    }
    getById(id, countryCode) {
        let url = `${this._kongUrl}/credit/v2/${countryCode.toLowerCase()}/company_profiles/${id}`;
        if (getCountryCodeFromStorage() === FSWCountryCode.TH) {
            url = `${this._kongUrl}/credit/v2/company_profiles/${id}`;
        }
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => {
            if (getCountryCodeFromStorage() === FSWCountryCode.TH) {
                return res.data;
            }
            const { data, id } = res.data;
            return {
                ...data,
                id,
            };
        }));
    }
    put(data, countryCode) {
        let url = `${this._kongUrl}/credit/v2/${countryCode.toLowerCase()}/company_profiles/${data.id}`;
        const isThailand = getCountryCodeFromStorage() === FSWCountryCode.TH;
        if (isThailand) {
            data = this.createTHPayload(data);
            url = `${this._kongUrl}/credit/v2/company_profiles/${data.id}`;
        }
        return this._httpClient
            .put(url, isThailand ? data : { data }, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => ({
            ...data.data,
            id: data.id,
        })));
    }
    post(data, countryCode, applicationId) {
        let url = `${this._kongUrl}/credit/v2/${countryCode.toLowerCase()}/company_profiles`;
        const isThailand = getCountryCodeFromStorage() === FSWCountryCode.TH;
        if (isThailand) {
            data = this.createTHPayload(data);
            url = `${this._kongUrl}/credit/v2/company_profiles`;
        }
        return this._httpClient
            .post(url, isThailand ? data : { data }, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => ({
            ...data.data,
            id: data.id,
        })), switchMap((e) => this.postByApplication(applicationId, [e.id]).pipe(mapTo(e))));
    }
    remove(id, countryCode) {
        let url = `${this._kongUrl}/credit/v2/${countryCode.toLowerCase()}/company_profiles/${id}`;
        if (getCountryCodeFromStorage() === FSWCountryCode.TH) {
            url = `${this._kongUrl}/credit/v2/company_profiles/${id}`;
        }
        return this._httpClient.delete(url, {
            headers: setRequestOptions(),
        });
    }
    //#endregion Profile
    //#region Customer
    getAllCustomer(cpId, countryCode) {
        let url = `${this._kongUrl}/credit/v2/${countryCode.toLowerCase()}/company_profiles/${cpId}/customers`;
        if (getCountryCodeFromStorage() === FSWCountryCode.TH) {
            url = `${this._kongUrl}/credit/v2/company_profiles/${cpId}/customers`;
        }
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => (res ? res : { data: [] })), map(({ data }) => data.map((e) => ({
            ...e.data,
            id: e.id,
        }))));
    }
    putCustomer(cpId, data, countryCode) {
        let url = `${this._kongUrl}/credit/v2/${countryCode.toLowerCase()}/company_profiles/${cpId}/customers/${data.id}`;
        if (getCountryCodeFromStorage() === FSWCountryCode.TH) {
            url = `${this._kongUrl}/credit/v2/company_profiles/${cpId}/customers/${data.id}`;
        }
        return this._httpClient
            .put(url, { data }, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => ({
            ...data.data,
            id: data.id,
        })));
    }
    postCustomer(cpId, data, countryCode) {
        let url = `${this._kongUrl}/credit/v2/${countryCode.toLowerCase()}/company_profiles/${cpId}/customers`;
        if (getCountryCodeFromStorage() === FSWCountryCode.TH) {
            url = `${this._kongUrl}/credit/v2/company_profiles/${cpId}/customers`;
        }
        return this._httpClient
            .post(url, { data }, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => ({
            ...data.data,
            id: data.id,
        })));
    }
    removeCustomer(cpId, id, countryCode) {
        let url = `${this._kongUrl}/credit/v2/${countryCode.toLowerCase()}/company_profiles/${cpId}/customers/${id}`;
        if (getCountryCodeFromStorage() === FSWCountryCode.TH) {
            url = `${this._kongUrl}/credit/v2/company_profiles/${cpId}/customers/${id}`;
        }
        return this._httpClient.delete(url, {
            headers: setRequestOptions(),
        });
    }
    //#endregion Customer
    //#region Supplier
    getAllSupplier(cpId, countryCode) {
        let url = `${this._kongUrl}/credit/v2/${countryCode.toLowerCase()}/company_profiles/${cpId}/suppliers`;
        if (getCountryCodeFromStorage() === FSWCountryCode.TH) {
            url = `${this._kongUrl}/credit/v2/company_profiles/${cpId}/suppliers`;
        }
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => (res ? res : { data: [] })), map(({ data }) => data.map((e) => ({
            ...e.data,
            id: e.id,
        }))));
    }
    putSupplier(cpId, data, countryCode) {
        let url = `${this._kongUrl}/credit/v2/${countryCode.toLowerCase()}/company_profiles/${cpId}/suppliers/${data.id}`;
        if (getCountryCodeFromStorage() === FSWCountryCode.TH) {
            url = `${this._kongUrl}/credit/v2/company_profiles/${cpId}/suppliers/${data.id}`;
        }
        return this._httpClient
            .put(url, { data }, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => ({
            ...data.data,
            id: data.id,
        })));
    }
    postSupplier(cpId, data, countryCode) {
        let url = `${this._kongUrl}/credit/v2/${countryCode.toLowerCase()}/company_profiles/${cpId}/suppliers`;
        if (getCountryCodeFromStorage() === FSWCountryCode.TH) {
            url = `${this._kongUrl}/credit/v2/company_profiles/${cpId}/suppliers`;
        }
        return this._httpClient
            .post(url, { data }, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => ({
            ...data.data,
            id: data.id,
        })));
    }
    removeSupplier(cpId, id, countryCode) {
        let url = `${this._kongUrl}/credit/v2/${countryCode.toLowerCase()}/company_profiles/${cpId}/suppliers/${id}`;
        if (getCountryCodeFromStorage() === FSWCountryCode.TH) {
            url = `${this._kongUrl}/credit/v2/company_profiles/${cpId}/suppliers/${id}`;
        }
        return this._httpClient.delete(url, {
            headers: setRequestOptions(),
        });
    }
    //#endregion Supplier
    //#region Comment
    getAllComments(cpId, countryCode) {
        let url = `${this._kongUrl}/credit/v2/${countryCode.toLowerCase()}/company_profiles/${cpId}/comments`;
        if (getCountryCodeFromStorage() === FSWCountryCode.TH) {
            url = `${this._kongUrl}/credit/v2/company_profiles/${cpId}/comments`;
        }
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => (res ? res : { data: [] })), map(({ data }) => data.map((e) => ({
            ...e.company_profile_comment,
            id: e.id,
            company_profile_id: e.company_profile_id,
        }))));
    }
    postComments(cpId, data, countryCode) {
        let url = `${this._kongUrl}/credit/v2/${countryCode.toLowerCase()}/company_profiles/${cpId}/comments`;
        if (getCountryCodeFromStorage() === FSWCountryCode.TH) {
            url = `${this._kongUrl}/credit/v2/company_profiles/${cpId}/comments`;
        }
        const request = (data) => this._httpClient.post(url, { data }, {
            headers: setRequestOptions(),
        });
        return forkJoin(data.map((e) => request(e)));
    }
    putComments(cpId, data, countryCode) {
        let url = `${this._kongUrl}/credit/v2/${countryCode.toLowerCase()}/company_profiles/${cpId}/comments`;
        if (getCountryCodeFromStorage() === FSWCountryCode.TH) {
            url = `${this._kongUrl}/credit/v2/company_profiles/${cpId}/comments`;
        }
        const request = (data) => this._httpClient.put(`${url}/${data.id}`, { data }, {
            headers: setRequestOptions(),
        });
        return forkJoin(data.map((e) => request(e)));
    }
    //#endregion Comment
    createTHPayload(data) {
        const { business_risk, business_risk_comment, liquidity_risk, liquidity_risk_comment, repayment_risk, repayment_risk_comment, other_risk, other_risk_comment, } = data.risk_analysis;
        return {
            ...data,
            risk_analysis: {
                business_risk: {
                    detail: business_risk,
                    mitigation_plan: business_risk_comment,
                },
                liquidity_risk: {
                    detail: liquidity_risk,
                    mitigation_plan: liquidity_risk_comment,
                },
                repayment_risk: {
                    detail: repayment_risk,
                    mitigation_plan: repayment_risk_comment,
                },
                other_risk: {
                    detail: other_risk,
                    mitigation_plan: other_risk_comment,
                },
            },
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyProfileService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyProfileService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyProfileService, decorators: [{
            type: Injectable
        }] });

class CompanyProfileServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyProfileServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CompanyProfileServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyProfileServiceModule, providers: [
            provideApplicationRelationshipService(),
            {
                provide: COMPANY_PROFILE_SERVICE_TOKEN,
                useClass: CompanyProfileService,
                deps: [HttpClient, UTILS_SERVICE_TOKEN, APPLICATION_RELATIONSHIP_SERVICE_TOKEN],
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyProfileServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        provideApplicationRelationshipService(),
                        {
                            provide: COMPANY_PROFILE_SERVICE_TOKEN,
                            useClass: CompanyProfileService,
                            deps: [HttpClient, UTILS_SERVICE_TOKEN, APPLICATION_RELATIONSHIP_SERVICE_TOKEN],
                        },
                    ],
                }]
        }] });

const CP_MAIN_FORM_CONFIG_TOKEN = new InjectionToken('CP_MAIN_FORM_CONFIG_TOKEN');

const CP_CUSTOMER_FORM_CONFIG_TOKEN = new InjectionToken('CP_CUSTOMER_FORM_CONFIG_TOKEN');

const CP_SUPPLIER_FORM_CONFIG_TOKEN = new InjectionToken('CP_SUPPLIER_FORM_CONFIG_TOKEN');

const CP_RISK_ANALYSIS_FORM_CONFIG_TOKEN = new InjectionToken('CP_RISK_ANALYSIS_FORM_CONFIG_TOKEN');

const CP_RISK_PROFILE_FORM_CONFIG_TOKEN = new InjectionToken('CP_RISK_PROFILE_FORM_CONFIG_TOKEN');

const CP_SUPPLIER_GRID_CONFIG_TOKEN = new InjectionToken('CP_SUPPLIER_GRID_CONFIG_TOKEN');

const CP_CUSTOMER_GRID_CONFIG_TOKEN = new InjectionToken('CP_CUSTOMER_GRID_CONFIG_TOKEN');

const CP_COMPONENT_STORE_TOKEN = new InjectionToken('CP_COMPONENT_STORE_TOKEN');

let CPComponentStore = class CPComponentStore extends ComponentStore {
    constructor(_config = {}, _service) {
        super({
            applicationId: null,
            data: null,
            customers: [],
            suppliers: [],
            countryId: null,
            settings: {},
            id: null,
            comments: [],
            isReadonly: false,
            ..._config,
        });
        this._config = _config;
        this._service = _service;
        this.save = this.effect(pipe(tap(({ profile, comments }) => {
            if (this.get().id) {
                this.updateProfile({ profile, comments });
            }
            else {
                this.createProfile({ profile, comments });
            }
        })));
        this.updateProfile = this.effect(pipe(switchMap(({ profile, comments }) => {
            return this._service.put(profile, this.get().countryId).pipe(switchMap(() => this.loadDataAsync()), filter$1(() => !!comments?.length), tap(() => {
                const [commentsForUpdating, commentsForCreating] = comments.reduce((data, comment) => {
                    if (comment.id) {
                        data[0].push(comment);
                    }
                    else {
                        data[1].push(comment);
                    }
                    return data;
                }, [[], []]);
                this.putComments(commentsForUpdating);
                this.postComments(commentsForCreating);
            }));
        })));
        this.createProfile = this.effect(pipe(switchMap(({ profile, comments }) => {
            return this._service
                .post(profile, this.get().countryId, this.get().applicationId)
                .pipe(tap((e) => this.setId(e.id)), switchMap(() => this.loadDataAsync()), filter$1(() => !!comments?.length), tap(() => this.postComments(comments)));
        })));
        //#region Effects
        this.loadData = this.effect(pipe(switchMap(() => this.loadDataAsync()), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        this.loadSettings = this.effect(pipe(switchMap((id) => this.loadSettingsAsync()), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        this.loadCustomers = this.effect(pipe(switchMap((id) => this.loadCustomersAsync()), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        this.loadSuppliers = this.effect(pipe(switchMap((id) => this.loadSuppliersAsync()), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        this.loadComments = this.effect(pipe(switchMap((id) => this.loadCommentsAsync()), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
    }
    //#endregion Effects
    //#region Setup
    setApplicationId(data) {
        const updater = this.updater((state, applicationId) => ({
            ...state,
            applicationId,
        }));
        updater(data);
    }
    setIsReadonly(data) {
        const updater = this.updater((state, isReadonly) => ({
            ...state,
            isReadonly,
        }));
        updater(data);
    }
    setId(data) {
        const updater = this.updater((state, id) => ({
            ...state,
            id,
        }));
        updater(data);
    }
    //#endregion Setup
    //#region Data
    setData(data) {
        const updater = this.updater((state, data) => ({
            ...state,
            data,
        }));
        updater(data);
    }
    loadDataAsync() {
        return this._service
            .getById(this.get().id, this.get().countryId)
            .pipe(tap((data) => this.setData(data)));
    }
    //#endregion Data
    //#region Settings
    setSettings(data) {
        const updater = this.updater((state, settings) => ({
            ...state,
            settings,
        }));
        updater(data);
    }
    loadSettingsAsync() {
        return this._service.getSettings().pipe(tap((settings) => this.setSettings(settings)));
    }
    //#endregion Settings
    //#region Customer
    setCustomers(data) {
        const updater = this.updater((state, customers) => ({
            ...state,
            customers,
        }));
        updater(data);
    }
    loadCustomersAsync() {
        return this._service
            .getAllCustomer(this.get().id, this.get().countryId)
            .pipe(tap((customers) => this.setCustomers(customers)));
    }
    postCustomer(data) {
        const effect = this.effect(pipe(switchMap((data) => this._service.postCustomer(this.get().id, data, this.get().countryId)), tap(() => this.loadCustomers()), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        effect(data);
    }
    putCustomer(data) {
        const effect = this.effect(pipe(switchMap((data) => this._service.putCustomer(this.get().id, data, this.get().countryId)), tap(() => this.loadCustomers()), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        effect(data);
    }
    removeCustomer(id) {
        const effect = this.effect(pipe(switchMap((id) => this._service.removeCustomer(this.get().id, id, this.get().countryId)), tap(() => this.loadCustomers()), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        effect(id);
    }
    //#endregion Customer
    //#region Supplier
    setSuppliers(data) {
        const updater = this.updater((state, suppliers) => ({
            ...state,
            suppliers,
        }));
        updater(data);
    }
    loadSuppliersAsync() {
        return this._service
            .getAllSupplier(this.get().id, this.get().countryId)
            .pipe(tap((suppliers) => this.setSuppliers(suppliers)));
    }
    postSupplier(data) {
        const effect = this.effect(pipe(switchMap((data) => this._service.postSupplier(this.get().id, data, this.get().countryId)), tap(() => this.loadSuppliers()), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        effect(data);
    }
    putSupplier(data) {
        const effect = this.effect(pipe(switchMap((data) => this._service.putSupplier(this.get().id, data, this.get().countryId)), tap(() => this.loadSuppliers()), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        effect(data);
    }
    removeSupplier(id) {
        const effect = this.effect(pipe(switchMap((id) => this._service.removeSupplier(this.get().id, id, this.get().countryId)), tap(() => this.loadSuppliers()), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        effect(id);
    }
    //#endregion Supplier
    //#region Comment
    setComments(data) {
        const updater = this.updater((state, comments) => ({
            ...state,
            comments,
        }));
        updater(data);
    }
    postComments(data) {
        const effect = this.effect(pipe(switchMap((data) => this._service.postComments(this.get().id, data, this.get().countryId)), tap(() => this.loadComments()), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        effect(data);
    }
    putComments(data) {
        const effect = this.effect(pipe(switchMap((data) => this._service.putComments(this.get().id, data, this.get().countryId)), tap(() => this.loadComments()), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        effect(data);
    }
    loadCommentsAsync() {
        return this._service
            .getAllComments(this.get().id, this.get().countryId)
            .pipe(tap((comments) => this.setComments(comments)));
    }
};
CPComponentStore = __decorate([
    __param(1, Inject(COMPANY_PROFILE_SERVICE_TOKEN)),
    __metadata("design:paramtypes", [Object, Object])
], CPComponentStore);

class CPCommentBlockComponent {
    set comments(comments) {
        this.formArray.clear();
        comments.forEach((comment) => {
            this.add(comment);
        });
        if (!comments.length) {
            this.add();
        }
    }
    get controls() {
        return this.formArray.controls;
    }
    constructor(_scope, _translateService) {
        this._scope = _scope;
        this._translateService = _translateService;
        this.listen = new EventEmitter();
        this.type = CPCommentTypes.COMPANY_PROFILE;
        this.isReadonly = false;
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'placeholders'),
            this._translateService.selectFeatureTranslate(this._scope, 'others'),
        ]).pipe(map(([placeholders, others]) => ({ placeholders, others })));
        this.formArray = new UntypedFormArray([]);
        this.expanded = false;
    }
    ngOnInit() {
        this.listen.emit(this.formArray);
    }
    add(comment) {
        const group = new UntypedFormGroup({
            comment_type: new UntypedFormControl(comment?.comment_type || this.type, [
                Validators.required,
            ]),
            comment: new UntypedFormControl(comment?.comment, [Validators.required]),
            subject: new UntypedFormControl(comment?.subject),
            topic: new UntypedFormControl(comment?.topic),
        });
        if (comment) {
            group.addControl('id', new UntypedFormControl(comment.id));
            group.addControl('company_profile_id', new UntypedFormControl(comment.company_profile_id));
        }
        this.formArray.push(group);
    }
    remove(index) {
        this.formArray.removeAt(index);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPCommentBlockComponent, deps: [{ token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CPCommentBlockComponent, selector: "fsw-cp-comment-block", inputs: { comments: "comments", type: "type", isReadonly: "isReadonly" }, outputs: { listen: "listen" }, ngImport: i0, template: "<ng-container *ngrxLet=\"translate$; let translate\">\n  <div class=\"cp-comment-block\">\n    <a class=\"btn--link btn\" (click)=\"expanded = !expanded\">\n      <i class=\"fa {{ !expanded ? 'fa-chevron-down' : 'fa-chevron-up' }}\"></i>\n      {{ translate.others.comments }}\n    </a>\n    <div class=\"cp-comment-block__controls\" [class.show]=\"expanded\">\n      <ng-container *ngFor=\"let group of controls; let i = index\">\n        <form [formGroup]=\"group\">\n          <textarea\n            rows=\"3\"\n            class=\"form-textarea\"\n            [readOnly]=\"isReadonly\"\n            [placeholder]=\"translate.placeholders.comments\"\n            formControlName=\"comment\"\n          ></textarea>\n        </form>\n      </ng-container>\n    </div>\n  </div>\n</ng-container>\n", styles: [":host .cp-comment-block{display:flex;flex-direction:column;width:100%}:host .cp-comment-block a i{margin-right:8px}:host .cp-comment-block__controls{display:flex;flex-direction:column;width:100%;gap:8px;height:0;overflow:hidden;padding:0 12px}:host .cp-comment-block__controls.show{height:auto}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3$1.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPCommentBlockComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cp-comment-block', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngrxLet=\"translate$; let translate\">\n  <div class=\"cp-comment-block\">\n    <a class=\"btn--link btn\" (click)=\"expanded = !expanded\">\n      <i class=\"fa {{ !expanded ? 'fa-chevron-down' : 'fa-chevron-up' }}\"></i>\n      {{ translate.others.comments }}\n    </a>\n    <div class=\"cp-comment-block__controls\" [class.show]=\"expanded\">\n      <ng-container *ngFor=\"let group of controls; let i = index\">\n        <form [formGroup]=\"group\">\n          <textarea\n            rows=\"3\"\n            class=\"form-textarea\"\n            [readOnly]=\"isReadonly\"\n            [placeholder]=\"translate.placeholders.comments\"\n            formControlName=\"comment\"\n          ></textarea>\n        </form>\n      </ng-container>\n    </div>\n  </div>\n</ng-container>\n", styles: [":host .cp-comment-block{display:flex;flex-direction:column;width:100%}:host .cp-comment-block a i{margin-right:8px}:host .cp-comment-block__controls{display:flex;flex-direction:column;width:100%;gap:8px;height:0;overflow:hidden;padding:0 12px}:host .cp-comment-block__controls.show{height:auto}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }]; }, propDecorators: { listen: [{
                type: Output
            }], comments: [{
                type: Input
            }], type: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class CPRiskAnalysisBlockComponent {
    constructor(formConfig) {
        this.formConfig = formConfig;
        this.listen = new EventEmitter();
        this.listenArray = new EventEmitter();
        this.data = null;
        this.comments = [];
        this.label = '';
        this.translate = {};
        this.settings = {};
        this.isReadonly = false;
        this.hiddenComments = false;
        this.CPCommentTypes = CPCommentTypes;
        this.config = null;
    }
    ngOnChanges() {
        this.config = this.formConfig.setup(this.translate, this.data || {}, this.settings, this.isReadonly);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPRiskAnalysisBlockComponent, deps: [{ token: CP_RISK_ANALYSIS_FORM_CONFIG_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CPRiskAnalysisBlockComponent, selector: "fsw-cp-risk-analysis-block", inputs: { data: "data", comments: "comments", label: "label", translate: "translate", settings: "settings", isReadonly: "isReadonly", hiddenComments: "hiddenComments" }, outputs: { listen: "listen", listenArray: "listenArray" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"risk-analysis-block\">\n  <h6>{{ label }}</h6>\n\n  <fsw-form-widget\n    *ngIf=\"config\"\n    [formConfig]=\"config\"\n    [isReadonly]=\"isReadonly\"\n    (initializeWidget)=\"listen.emit($event)\"\n  ></fsw-form-widget>\n\n  <fsw-cp-comment-block\n    *ngIf=\"!hiddenComments\"\n    [type]=\"CPCommentTypes.RISK_ANALYSIS\"\n    [comments]=\"comments\"\n    [isReadonly]=\"isReadonly\"\n    (listen)=\"listenArray.emit($event)\"\n  ></fsw-cp-comment-block>\n</div>\n", styles: [":host .risk-analysis-block{display:flex;flex-direction:column;gap:16px}:host .risk-analysis-block h6{font-family:Poppins,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:20px;line-height:1.4;color:#222}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FormWidgetComponent, selector: "fsw-form-widget", inputs: ["formConfig", "loading", "isReadonly"], outputs: ["initializeWidget", "closeForm", "submitForm"] }, { kind: "component", type: CPCommentBlockComponent, selector: "fsw-cp-comment-block", inputs: ["comments", "type", "isReadonly"], outputs: ["listen"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPRiskAnalysisBlockComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cp-risk-analysis-block', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"risk-analysis-block\">\n  <h6>{{ label }}</h6>\n\n  <fsw-form-widget\n    *ngIf=\"config\"\n    [formConfig]=\"config\"\n    [isReadonly]=\"isReadonly\"\n    (initializeWidget)=\"listen.emit($event)\"\n  ></fsw-form-widget>\n\n  <fsw-cp-comment-block\n    *ngIf=\"!hiddenComments\"\n    [type]=\"CPCommentTypes.RISK_ANALYSIS\"\n    [comments]=\"comments\"\n    [isReadonly]=\"isReadonly\"\n    (listen)=\"listenArray.emit($event)\"\n  ></fsw-cp-comment-block>\n</div>\n", styles: [":host .risk-analysis-block{display:flex;flex-direction:column;gap:16px}:host .risk-analysis-block h6{font-family:Poppins,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:20px;line-height:1.4;color:#222}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CP_RISK_ANALYSIS_FORM_CONFIG_TOKEN]
                }] }]; }, propDecorators: { listen: [{
                type: Output
            }], listenArray: [{
                type: Output
            }], data: [{
                type: Input
            }], comments: [{
                type: Input
            }], label: [{
                type: Input
            }], translate: [{
                type: Input
            }], settings: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], hiddenComments: [{
                type: Input
            }] } });

class CPRiskProfileBlockComponent {
    constructor(formConfig) {
        this.formConfig = formConfig;
        this.listen = new EventEmitter();
        this.listenArray = new EventEmitter();
        this.data = null;
        this.label = '';
        this.comments = [];
        this.translate = {};
        this.settings = {};
        this.isReadonly = false;
        this.hiddenComments = false;
        this.CPCommentTypes = CPCommentTypes;
        this.config = null;
    }
    ngOnChanges() {
        this.config = this.formConfig.setup(this.translate, this.data || {}, this.settings, this.isReadonly);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPRiskProfileBlockComponent, deps: [{ token: CP_RISK_PROFILE_FORM_CONFIG_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CPRiskProfileBlockComponent, selector: "fsw-cp-risk-profile-block", inputs: { data: "data", label: "label", comments: "comments", translate: "translate", settings: "settings", isReadonly: "isReadonly", hiddenComments: "hiddenComments" }, outputs: { listen: "listen", listenArray: "listenArray" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"risk-profile-block\">\n  <h6>{{ label }}</h6>\n\n  <fsw-form-widget\n    *ngIf=\"config\"\n    [formConfig]=\"config\"\n    [isReadonly]=\"isReadonly\"\n    (initializeWidget)=\"listen.emit($event)\"\n  ></fsw-form-widget>\n\n  <fsw-cp-comment-block\n    *ngIf=\"!hiddenComments\"\n    [type]=\"CPCommentTypes.RISK_PROFILE\"\n    [comments]=\"comments\"\n    [isReadonly]=\"isReadonly\"\n    (listen)=\"listenArray.emit($event)\"\n  ></fsw-cp-comment-block>\n</div>\n", styles: [":host .risk-profile-block{display:flex;flex-direction:column;gap:16px}:host .risk-profile-block h6{font-family:Poppins,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:20px;line-height:1.4;color:#222}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FormWidgetComponent, selector: "fsw-form-widget", inputs: ["formConfig", "loading", "isReadonly"], outputs: ["initializeWidget", "closeForm", "submitForm"] }, { kind: "component", type: CPCommentBlockComponent, selector: "fsw-cp-comment-block", inputs: ["comments", "type", "isReadonly"], outputs: ["listen"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPRiskProfileBlockComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cp-risk-profile-block', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"risk-profile-block\">\n  <h6>{{ label }}</h6>\n\n  <fsw-form-widget\n    *ngIf=\"config\"\n    [formConfig]=\"config\"\n    [isReadonly]=\"isReadonly\"\n    (initializeWidget)=\"listen.emit($event)\"\n  ></fsw-form-widget>\n\n  <fsw-cp-comment-block\n    *ngIf=\"!hiddenComments\"\n    [type]=\"CPCommentTypes.RISK_PROFILE\"\n    [comments]=\"comments\"\n    [isReadonly]=\"isReadonly\"\n    (listen)=\"listenArray.emit($event)\"\n  ></fsw-cp-comment-block>\n</div>\n", styles: [":host .risk-profile-block{display:flex;flex-direction:column;gap:16px}:host .risk-profile-block h6{font-family:Poppins,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:20px;line-height:1.4;color:#222}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CP_RISK_PROFILE_FORM_CONFIG_TOKEN]
                }] }]; }, propDecorators: { listen: [{
                type: Output
            }], listenArray: [{
                type: Output
            }], data: [{
                type: Input
            }], label: [{
                type: Input
            }], comments: [{
                type: Input
            }], translate: [{
                type: Input
            }], settings: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], hiddenComments: [{
                type: Input
            }] } });

class CPMainBlockComponent {
    set data(data) {
        this.data$.next(data);
    }
    set settings(settings) {
        this.settings$.next(settings);
    }
    set comments(comments) {
        const initialValue = {
            cp: [],
            ra: [],
            rp: [],
        };
        const group = comments.reduce((group, current) => {
            switch (current.comment_type) {
                case CPCommentTypes.COMPANY_PROFILE:
                    group.cp.push(current);
                    break;
                case CPCommentTypes.RISK_ANALYSIS:
                    group.ra.push(current);
                    break;
                case CPCommentTypes.RISK_PROFILE:
                    group.rp.push(current);
                    break;
                default:
                    break;
            }
            return {
                ...group,
            };
        }, initialValue);
        this.commentGroup$.next(group);
    }
    constructor(formConfig, _scope, _translateService) {
        this.formConfig = formConfig;
        this._scope = _scope;
        this._translateService = _translateService;
        this.save = new EventEmitter();
        this.displaySettings = {
            comment: true,
            profile: true,
            analysis: true,
            grid: true,
            bolt_comment: false,
        };
        this.isReadonly = false;
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'buttons'),
            this._translateService.selectFeatureTranslate(this._scope, 'titles'),
            this._translateService.selectFeatureTranslate(this._scope, 'risk_titles'),
            this._translateService.selectFeatureTranslate(this._scope, 'main_fields'),
            this._translateService.selectFeatureTranslate(this._scope, 'risk_analysis_fields'),
            this._translateService.selectFeatureTranslate(this._scope, 'risk_profile_fields'),
        ]).pipe(map(([buttons, titles, risk_titles, main_fields, risk_analysis_fields, risk_profile_fields]) => ({
            buttons,
            titles,
            risk_titles,
            main_fields,
            risk_analysis_fields,
            risk_profile_fields,
        })));
        this.data$ = new BehaviorSubject(null);
        this.settings$ = new BehaviorSubject({});
        this.commentGroup$ = new BehaviorSubject({
            cp: [],
            ra: [],
            rp: [],
        });
        this.state$ = combineLatest([this.translate$, this.data$, this.settings$]).pipe(map(([translate, data, settings]) => ({ translate, data, settings })));
        this.form = null;
        this.formArray = null;
        this.config = null;
        this.formRP = null;
        this.formArrayRP = null;
        this.formRA = null;
        this.formArrayRA = null;
        this.CPCommentTypes = CPCommentTypes;
    }
    ngOnInit() {
        this.state$
            .pipe(tap(({ translate, data, settings }) => {
            this.config = this.formConfig.setup(translate.main_fields, data || {}, settings, this.isReadonly);
        }))
            .subscribe();
    }
    submit() {
        combineLatest([this.data$, this.commentGroup$])
            .pipe(take(1), tap(([data, group]) => {
            const profile = {
                ...(data || {}),
                ...this.form.value,
                ...(this.displaySettings.analysis
                    ? {
                        risk_analysis: {
                            ...(data || {}).risk_analysis,
                            ...this.formRA.value,
                        },
                    }
                    : {}),
                ...(this.displaySettings.profile
                    ? {
                        risk_profile: {
                            ...(data || {}).risk_profile,
                            ...this.formRP.value,
                        },
                    }
                    : {}),
            };
            this.save.emit({
                profile,
                comments: [
                    ...(this.displaySettings.comment ? this.formArray?.value || group.cp : []),
                    ...(this.displaySettings.comment && this.displaySettings.analysis
                        ? this.formArrayRA?.value || group.ra
                        : []),
                    ...(this.displaySettings.comment && this.displaySettings.profile
                        ? this.formArrayRP?.value || group.rp
                        : []),
                ],
            });
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPMainBlockComponent, deps: [{ token: CP_MAIN_FORM_CONFIG_TOKEN }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CPMainBlockComponent, selector: "fsw-cp-main-block", inputs: { data: "data", settings: "settings", comments: "comments", displaySettings: "displaySettings", isReadonly: "isReadonly" }, outputs: { save: "save" }, ngImport: i0, template: "<ng-container *ngrxLet=\"state$; let state\">\n  <div class=\"cp-main-block\">\n    <h6>{{ state.translate.titles.main }}</h6>\n    <fsw-form-widget\n      *ngIf=\"config\"\n      [formConfig]=\"config\"\n      [isReadonly]=\"isReadonly\"\n      (initializeWidget)=\"form = $event\"\n    ></fsw-form-widget>\n    <fsw-cp-comment-block\n      *ngIf=\"displaySettings.comment\"\n      [type]=\"CPCommentTypes.COMPANY_PROFILE\"\n      [comments]=\"(commentGroup$ | async)?.cp || []\"\n      [isReadonly]=\"isReadonly\"\n      (listen)=\"formArray = $event\"\n    ></fsw-cp-comment-block>\n    <div class=\"cp-main-block__separator\"></div>\n    <fsw-cp-risk-profile-block\n      *ngIf=\"displaySettings.profile\"\n      [label]=\"state.translate.risk_titles.profile\"\n      [data]=\"state.data?.risk_profile || null\"\n      (listen)=\"formRP = $event\"\n      (listenArray)=\"formArrayRP = $event\"\n      [translate]=\"state.translate.risk_profile_fields\"\n      [settings]=\"state.settings\"\n      [comments]=\"(commentGroup$ | async)?.rp || []\"\n      [hiddenComments]=\"!displaySettings.comment\"\n      [isReadonly]=\"isReadonly\"\n    ></fsw-cp-risk-profile-block>\n    <div class=\"cp-main-block__separator\"></div>\n    <fsw-cp-risk-analysis-block\n      *ngIf=\"displaySettings.analysis\"\n      [label]=\"state.translate.risk_titles.analysis\"\n      [data]=\"state.data?.risk_analysis || null\"\n      (listen)=\"formRA = $event\"\n      (listenArray)=\"formArrayRA = $event\"\n      [translate]=\"state.translate.risk_analysis_fields\"\n      [settings]=\"state.settings\"\n      [comments]=\"(commentGroup$ | async)?.ra || []\"\n      [isReadonly]=\"isReadonly\"\n      [hiddenComments]=\"!displaySettings.comment\"\n    ></fsw-cp-risk-analysis-block>\n    <button\n      class=\"btn btn--primary\"\n      *ngIf=\"!isReadonly\"\n      [disabled]=\"\n        !form?.valid ||\n        (displaySettings.analysis ? !formRA?.valid : false) ||\n        (displaySettings.profile ? !formRP?.valid : false)\n      \"\n      (click)=\"submit()\"\n    >\n      {{ state.translate.buttons.save }}\n    </button>\n  </div>\n</ng-container>\n", styles: [":host .cp-main-block{display:flex;max-width:736px;flex-direction:column;gap:24px;padding:16px;border:1px solid #e0e0e0;border-radius:4px}:host .cp-main-block h6{font-family:Poppins,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:20px;line-height:1.4;color:#222}:host .cp-main-block button{align-self:flex-end}:host .cp-main-block__separator{width:100%;height:1px;background-color:#e0e0e0}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CPRiskAnalysisBlockComponent, selector: "fsw-cp-risk-analysis-block", inputs: ["data", "comments", "label", "translate", "settings", "isReadonly", "hiddenComments"], outputs: ["listen", "listenArray"] }, { kind: "component", type: CPRiskProfileBlockComponent, selector: "fsw-cp-risk-profile-block", inputs: ["data", "label", "comments", "translate", "settings", "isReadonly", "hiddenComments"], outputs: ["listen", "listenArray"] }, { kind: "directive", type: i3$1.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: FormWidgetComponent, selector: "fsw-form-widget", inputs: ["formConfig", "loading", "isReadonly"], outputs: ["initializeWidget", "closeForm", "submitForm"] }, { kind: "component", type: CPCommentBlockComponent, selector: "fsw-cp-comment-block", inputs: ["comments", "type", "isReadonly"], outputs: ["listen"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPMainBlockComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cp-main-block', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngrxLet=\"state$; let state\">\n  <div class=\"cp-main-block\">\n    <h6>{{ state.translate.titles.main }}</h6>\n    <fsw-form-widget\n      *ngIf=\"config\"\n      [formConfig]=\"config\"\n      [isReadonly]=\"isReadonly\"\n      (initializeWidget)=\"form = $event\"\n    ></fsw-form-widget>\n    <fsw-cp-comment-block\n      *ngIf=\"displaySettings.comment\"\n      [type]=\"CPCommentTypes.COMPANY_PROFILE\"\n      [comments]=\"(commentGroup$ | async)?.cp || []\"\n      [isReadonly]=\"isReadonly\"\n      (listen)=\"formArray = $event\"\n    ></fsw-cp-comment-block>\n    <div class=\"cp-main-block__separator\"></div>\n    <fsw-cp-risk-profile-block\n      *ngIf=\"displaySettings.profile\"\n      [label]=\"state.translate.risk_titles.profile\"\n      [data]=\"state.data?.risk_profile || null\"\n      (listen)=\"formRP = $event\"\n      (listenArray)=\"formArrayRP = $event\"\n      [translate]=\"state.translate.risk_profile_fields\"\n      [settings]=\"state.settings\"\n      [comments]=\"(commentGroup$ | async)?.rp || []\"\n      [hiddenComments]=\"!displaySettings.comment\"\n      [isReadonly]=\"isReadonly\"\n    ></fsw-cp-risk-profile-block>\n    <div class=\"cp-main-block__separator\"></div>\n    <fsw-cp-risk-analysis-block\n      *ngIf=\"displaySettings.analysis\"\n      [label]=\"state.translate.risk_titles.analysis\"\n      [data]=\"state.data?.risk_analysis || null\"\n      (listen)=\"formRA = $event\"\n      (listenArray)=\"formArrayRA = $event\"\n      [translate]=\"state.translate.risk_analysis_fields\"\n      [settings]=\"state.settings\"\n      [comments]=\"(commentGroup$ | async)?.ra || []\"\n      [isReadonly]=\"isReadonly\"\n      [hiddenComments]=\"!displaySettings.comment\"\n    ></fsw-cp-risk-analysis-block>\n    <button\n      class=\"btn btn--primary\"\n      *ngIf=\"!isReadonly\"\n      [disabled]=\"\n        !form?.valid ||\n        (displaySettings.analysis ? !formRA?.valid : false) ||\n        (displaySettings.profile ? !formRP?.valid : false)\n      \"\n      (click)=\"submit()\"\n    >\n      {{ state.translate.buttons.save }}\n    </button>\n  </div>\n</ng-container>\n", styles: [":host .cp-main-block{display:flex;max-width:736px;flex-direction:column;gap:24px;padding:16px;border:1px solid #e0e0e0;border-radius:4px}:host .cp-main-block h6{font-family:Poppins,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:20px;line-height:1.4;color:#222}:host .cp-main-block button{align-self:flex-end}:host .cp-main-block__separator{width:100%;height:1px;background-color:#e0e0e0}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CP_MAIN_FORM_CONFIG_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }]; }, propDecorators: { save: [{
                type: Output
            }], data: [{
                type: Input
            }], settings: [{
                type: Input
            }], comments: [{
                type: Input
            }], displaySettings: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class CPCommentBlockModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPCommentBlockModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CPCommentBlockModule, declarations: [CPCommentBlockComponent], imports: [CommonModule, LetDirective, ReactiveFormsModule], exports: [CPCommentBlockComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPCommentBlockModule, imports: [CommonModule, ReactiveFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPCommentBlockModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, LetDirective, ReactiveFormsModule],
                    declarations: [CPCommentBlockComponent],
                    exports: [CPCommentBlockComponent],
                }]
        }] });

class CPRiskAnalysisBlockModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPRiskAnalysisBlockModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CPRiskAnalysisBlockModule, declarations: [CPRiskAnalysisBlockComponent], imports: [CommonModule, PanelWidgetModule, FormWidgetModule, CPCommentBlockModule], exports: [CPRiskAnalysisBlockComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPRiskAnalysisBlockModule, imports: [CommonModule, PanelWidgetModule, FormWidgetModule, CPCommentBlockModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPRiskAnalysisBlockModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, PanelWidgetModule, FormWidgetModule, CPCommentBlockModule],
                    declarations: [CPRiskAnalysisBlockComponent],
                    exports: [CPRiskAnalysisBlockComponent],
                }]
        }] });

class CPRiskProfileBlockModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPRiskProfileBlockModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CPRiskProfileBlockModule, declarations: [CPRiskProfileBlockComponent], imports: [CommonModule, PanelWidgetModule, FormWidgetModule, CPCommentBlockModule], exports: [CPRiskProfileBlockComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPRiskProfileBlockModule, imports: [CommonModule, PanelWidgetModule, FormWidgetModule, CPCommentBlockModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPRiskProfileBlockModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, PanelWidgetModule, FormWidgetModule, CPCommentBlockModule],
                    declarations: [CPRiskProfileBlockComponent],
                    exports: [CPRiskProfileBlockComponent],
                }]
        }] });

class CPMainBlockModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPMainBlockModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CPMainBlockModule, declarations: [CPMainBlockComponent], imports: [CommonModule,
            CPRiskAnalysisBlockModule,
            CPRiskProfileBlockModule,
            LetDirective,
            PanelWidgetModule,
            FormWidgetModule,
            CPCommentBlockModule], exports: [CPMainBlockComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPMainBlockModule, imports: [CommonModule,
            CPRiskAnalysisBlockModule,
            CPRiskProfileBlockModule,
            PanelWidgetModule,
            FormWidgetModule,
            CPCommentBlockModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPMainBlockModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        CPRiskAnalysisBlockModule,
                        CPRiskProfileBlockModule,
                        LetDirective,
                        PanelWidgetModule,
                        FormWidgetModule,
                        CPCommentBlockModule,
                    ],
                    declarations: [CPMainBlockComponent],
                    exports: [CPMainBlockComponent],
                }]
        }] });

class CPSaveDialogComponent {
    constructor(context, _cdr, _modalComponent) {
        this.context = context;
        this._cdr = _cdr;
        this._modalComponent = _modalComponent;
        this.config = null;
        this.form = null;
        this.Methods = Methods;
        this.configuration((fields) => this.setupForm(fields));
    }
    submit() {
        if (!this.form) {
            return this.cancel();
        }
        if (this.form.invalid)
            return;
        const data = this.context.data.config.getValue(this.form, this.context.data.selectedItem);
        const checkEqual = isEqualWith(data, this.context.data.selectedItem);
        if (checkEqual) {
            return this.cancel();
        }
        this.context.completeWith({
            method: this.context.data.method,
            data,
        });
    }
    cancel() {
        this.context.completeWith(null);
    }
    remove() {
        this.context.completeWith({
            method: Methods.DELETE,
            data: null,
        });
    }
    listen(form) {
        this.form = form;
    }
    configuration(cb) {
        this._modalComponent.setLabel(this.context.data.translate[this.context.data.method]);
        cb(this.context.data.fields);
        this._cdr.markForCheck();
    }
    changeMode() {
        this.configuration(() => {
            if (!this.config)
                return;
            this.config = this.context.data.config.reset(this.config);
            this.config.formFieldConfig.isReadonly = false;
        });
    }
    setupForm(fields) {
        this.config = this.context.data.config.setup(fields, this.context.data.selectedItem || {});
        this.config.formFieldConfig.isReadonly = this.context.data.method === Methods.GET;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPSaveDialogComponent, deps: [{ token: MODAL_CONTEXT }, { token: i0.ChangeDetectorRef }, { token: ModalComponent }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CPSaveDialogComponent, selector: "fsw-cp-save-dialog", ngImport: i0, template: "<fsw-save-dialog\n\t[config]=\"config\"\n\t[(method)]=\"context.data.method\"\n\t[buttonDeleteLabel]=\"context.data.translate[Methods.DELETE]\"\n\t[buttonSaveLabel]=\"\n\t\tcontext.data.method === Methods.POST\n\t\t\t? context.data.translate[Methods.POST]\n\t\t\t: context.data.translate['save']\n\t\"\n\t[buttonCancelLabel]=\"context.data.translate['cancel']\"\n\t[buttonEditLabel]=\"context.data.translate['edit']\"\n\t[buttonBackLabel]=\"context.data.translate['back']\"\n\t(methodChange)=\"changeMode()\"\n\t(listen)=\"listen($event)\"\n\t(remove)=\"remove()\"\n\t(cancel)=\"cancel()\"\n\t(save)=\"submit()\"\n>\n</fsw-save-dialog>\n", dependencies: [{ kind: "component", type: FSWSaveDialogComponent, selector: "fsw-save-dialog", inputs: ["method", "config", "buttonDeleteLabel", "buttonCancelLabel", "buttonBackLabel", "buttonEditLabel", "buttonSaveLabel", "isReadonly"], outputs: ["remove", "cancel", "save", "listen", "methodChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPSaveDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cp-save-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-save-dialog\n\t[config]=\"config\"\n\t[(method)]=\"context.data.method\"\n\t[buttonDeleteLabel]=\"context.data.translate[Methods.DELETE]\"\n\t[buttonSaveLabel]=\"\n\t\tcontext.data.method === Methods.POST\n\t\t\t? context.data.translate[Methods.POST]\n\t\t\t: context.data.translate['save']\n\t\"\n\t[buttonCancelLabel]=\"context.data.translate['cancel']\"\n\t[buttonEditLabel]=\"context.data.translate['edit']\"\n\t[buttonBackLabel]=\"context.data.translate['back']\"\n\t(methodChange)=\"changeMode()\"\n\t(listen)=\"listen($event)\"\n\t(remove)=\"remove()\"\n\t(cancel)=\"cancel()\"\n\t(save)=\"submit()\"\n>\n</fsw-save-dialog>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_CONTEXT]
                }] }, { type: i0.ChangeDetectorRef }, { type: ModalComponent }]; } });

class CPSaveDialogModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPSaveDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CPSaveDialogModule, declarations: [CPSaveDialogComponent], imports: [CommonModule, FSWSaveDialogModule], exports: [CPSaveDialogComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPSaveDialogModule, imports: [CommonModule, FSWSaveDialogModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPSaveDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FSWSaveDialogModule],
                    declarations: [CPSaveDialogComponent],
                    exports: [CPSaveDialogComponent],
                }]
        }] });

class CPRemoveDialogComponent {
    constructor(context, _modalComponent) {
        this.context = context;
        this._modalComponent = _modalComponent;
        this.configuration();
    }
    cancel() {
        this.context.completeWith(false);
    }
    remove() {
        this.context.completeWith(true);
    }
    configuration() {
        this._modalComponent.setLabel(this.context.data['title']);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPRemoveDialogComponent, deps: [{ token: MODAL_CONTEXT }, { token: ModalComponent }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CPRemoveDialogComponent, selector: "fsw-cp-remove-dialog", ngImport: i0, template: "<fsw-remove-dialog\n\t[buttonCancelLabel]=\"context.data['cancel']\"\n\t[buttonDeleteLabel]=\"context.data['delete']\"\n\t[description]=\"context.data['description']\"\n\t(cancel)=\"cancel()\"\n\t(remove)=\"remove()\"\n></fsw-remove-dialog>\n", dependencies: [{ kind: "component", type: FSWRemoveDialogComponent, selector: "fsw-remove-dialog", inputs: ["description", "buttonDeleteLabel", "buttonCancelLabel"], outputs: ["remove", "cancel"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPRemoveDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cp-remove-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-remove-dialog\n\t[buttonCancelLabel]=\"context.data['cancel']\"\n\t[buttonDeleteLabel]=\"context.data['delete']\"\n\t[description]=\"context.data['description']\"\n\t(cancel)=\"cancel()\"\n\t(remove)=\"remove()\"\n></fsw-remove-dialog>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_CONTEXT]
                }] }, { type: ModalComponent }]; } });

class CPRemoveDialogModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPRemoveDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CPRemoveDialogModule, declarations: [CPRemoveDialogComponent], imports: [CommonModule, FSWRemoveDialogModule], exports: [CPRemoveDialogComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPRemoveDialogModule, imports: [CommonModule, FSWRemoveDialogModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPRemoveDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FSWRemoveDialogModule],
                    declarations: [CPRemoveDialogComponent],
                    exports: [CPRemoveDialogComponent],
                }]
        }] });

class CPGridEmptyComponent {
    agInit(params) {
        this.params = params;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPGridEmptyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CPGridEmptyComponent, selector: "fsw-cp-grid-empty", ngImport: i0, template: "<div class=\"cp-grid-empty\">\n\t<svg width=\"92\" height=\"93\" viewBox=\"0 0 92 93\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<rect width=\"92\" height=\"92.514\" fill=\"white\" />\n\t\t<path\n\t\t\td=\"M67.7222 33.4082C67.7222 32.9351 68.1036 32.5516 68.574 32.5516H71.9814C72.4519 32.5516 72.8333 32.9351 72.8333 33.4082C72.8333 33.8813 72.4519 34.2648 71.9814 34.2648H68.574C68.1036 34.2648 67.7222 33.8813 67.7222 33.4082Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M70.2778 30.8384C70.7483 30.8384 71.1297 31.2219 71.1297 31.695V35.1214C71.1297 35.5945 70.7483 35.978 70.2778 35.978C69.8074 35.978 69.426 35.5945 69.426 35.1214V31.695C69.426 31.2219 69.8074 30.8384 70.2778 30.8384Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\tfill-rule=\"evenodd\"\n\t\t\tclip-rule=\"evenodd\"\n\t\t\td=\"M51.963 29.1203C51.963 28.6498 51.5816 28.2684 51.1111 28.2684C50.6406 28.2684 50.2592 28.6498 50.2592 29.1203V29.9814H49.412C48.9389 29.9814 48.5554 30.3649 48.5554 30.838C48.5554 31.3111 48.9389 31.6946 49.412 31.6946H50.2592V32.5562C50.2592 33.0267 50.6406 33.4081 51.1111 33.4081C51.5816 33.4081 51.963 33.0267 51.963 32.5562V31.6946H52.8099C53.283 31.6946 53.6665 31.3111 53.6665 30.838C53.6665 30.3649 53.283 29.9814 52.8099 29.9814H51.963V29.1203Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M40.8888 10.2796C40.8888 9.56997 41.4609 8.99469 42.1666 8.99469H47.2777C47.9834 8.99469 48.5555 9.56997 48.5555 10.2796C48.5555 10.9892 47.9834 11.5645 47.2777 11.5645H42.1666C41.4609 11.5645 40.8888 10.9892 40.8888 10.2796Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M44.7221 6.42486C45.4278 6.42486 45.9999 7.00013 45.9999 7.70977V12.8494C45.9999 13.5591 45.4278 14.1344 44.7221 14.1344C44.0164 14.1344 43.4443 13.5591 43.4443 12.8494V7.70977C43.4443 7.00013 44.0164 6.42486 44.7221 6.42486Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M21.7222 80.9501C21.7222 80.2404 22.2942 79.6652 22.9999 79.6652H28.1111C28.8168 79.6652 29.3888 80.2404 29.3888 80.9501C29.3888 81.6597 28.8168 82.235 28.1111 82.235H22.9999C22.2942 82.235 21.7222 81.6597 21.7222 80.9501Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M25.5555 77.0953C26.2612 77.0953 26.8333 77.6706 26.8333 78.3803V83.5199C26.8333 84.2296 26.2612 84.8048 25.5555 84.8048C24.8498 84.8048 24.2777 84.2296 24.2777 83.5199V78.3803C24.2777 77.6706 24.8498 77.0953 25.5555 77.0953Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M71.5554 64.246C71.5554 63.7729 71.9368 63.3894 72.4073 63.3894H75.8147C76.2851 63.3894 76.6665 63.7729 76.6665 64.246C76.6665 64.7191 76.2851 65.1026 75.8147 65.1026H72.4073C71.9368 65.1026 71.5554 64.7191 71.5554 64.246Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M74.1111 61.6762C74.5815 61.6762 74.9629 62.0597 74.9629 62.5328V65.9592C74.9629 66.4323 74.5815 66.8158 74.1111 66.8158C73.6406 66.8158 73.2592 66.4323 73.2592 65.9592V62.5328C73.2592 62.0597 73.6406 61.6762 74.1111 61.6762Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M15.3333 19.274C15.3333 18.8009 15.7146 18.4174 16.1851 18.4174H19.5925C20.063 18.4174 20.4444 18.8009 20.4444 19.274C20.4444 19.7471 20.063 20.1306 19.5925 20.1306H16.1851C15.7146 20.1306 15.3333 19.7471 15.3333 19.274Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M17.8889 16.7042C18.3594 16.7042 18.7408 17.0877 18.7408 17.5608V20.9872C18.7408 21.4603 18.3594 21.8438 17.8889 21.8438C17.4184 21.8438 17.0371 21.4603 17.0371 20.9872V17.5608C17.0371 17.0877 17.4184 16.7042 17.8889 16.7042Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M33.2222 78.3802C33.2222 77.9071 33.6036 77.5236 34.074 77.5236H37.4814C37.9519 77.5236 38.3333 77.9071 38.3333 78.3802C38.3333 78.8533 37.9519 79.2368 37.4814 79.2368H34.074C33.6036 79.2368 33.2222 78.8533 33.2222 78.3802Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M35.7778 75.8104C36.2483 75.8104 36.6297 76.1939 36.6297 76.667V80.0934C36.6297 80.5665 36.2483 80.95 35.7778 80.95C35.3074 80.95 34.926 80.5665 34.926 80.0934V76.667C34.926 76.1939 35.3074 75.8104 35.7778 75.8104Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M61.3333 23.1285V74.5252H30.6667C26.4325 74.5252 23 71.0735 23 66.8157V23.1285L61.3333 23.1285Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<rect x=\"30.6667\" y=\"30.1957\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t<rect x=\"30.6667\" y=\"35.3354\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t<rect x=\"30.6667\" y=\"40.4748\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t<rect x=\"30.6667\" y=\"45.6147\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t<rect x=\"30.6667\" y=\"50.754\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t<rect x=\"30.6667\" y=\"55.8939\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t<rect x=\"30.6667\" y=\"61.0333\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t<path\n\t\t\td=\"M69.0001 68.1449V66.8157H34.5001V68.1006C34.5001 71.2296 32.2756 73.8362 29.3301 74.4084C29.7642 74.4851 30.2108 74.5252 30.6668 74.5252H62.6553C66.1594 74.5252 69.0001 71.6686 69.0001 68.1449Z\"\n\t\t\tfill=\"#CCCCCC\"\n\t\t/>\n\t</svg>\n\t<span>{{ params.translate.message }}</span>\n\t<a (click)=\"params.cb()\">{{ params.translate.add }}</a>\n</div>\n", styles: [":host .cp-grid-empty{display:flex;align-items:center;flex-direction:column}:host .cp-grid-empty a,:host .cp-grid-empty span{font-size:14px;line-height:1.5}:host .cp-grid-empty a{color:#2c50ff}:host .cp-grid-empty a:hover{text-decoration:underline}:host .cp-grid-empty span{color:#757575}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPGridEmptyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cp-grid-empty', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"cp-grid-empty\">\n\t<svg width=\"92\" height=\"93\" viewBox=\"0 0 92 93\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<rect width=\"92\" height=\"92.514\" fill=\"white\" />\n\t\t<path\n\t\t\td=\"M67.7222 33.4082C67.7222 32.9351 68.1036 32.5516 68.574 32.5516H71.9814C72.4519 32.5516 72.8333 32.9351 72.8333 33.4082C72.8333 33.8813 72.4519 34.2648 71.9814 34.2648H68.574C68.1036 34.2648 67.7222 33.8813 67.7222 33.4082Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M70.2778 30.8384C70.7483 30.8384 71.1297 31.2219 71.1297 31.695V35.1214C71.1297 35.5945 70.7483 35.978 70.2778 35.978C69.8074 35.978 69.426 35.5945 69.426 35.1214V31.695C69.426 31.2219 69.8074 30.8384 70.2778 30.8384Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\tfill-rule=\"evenodd\"\n\t\t\tclip-rule=\"evenodd\"\n\t\t\td=\"M51.963 29.1203C51.963 28.6498 51.5816 28.2684 51.1111 28.2684C50.6406 28.2684 50.2592 28.6498 50.2592 29.1203V29.9814H49.412C48.9389 29.9814 48.5554 30.3649 48.5554 30.838C48.5554 31.3111 48.9389 31.6946 49.412 31.6946H50.2592V32.5562C50.2592 33.0267 50.6406 33.4081 51.1111 33.4081C51.5816 33.4081 51.963 33.0267 51.963 32.5562V31.6946H52.8099C53.283 31.6946 53.6665 31.3111 53.6665 30.838C53.6665 30.3649 53.283 29.9814 52.8099 29.9814H51.963V29.1203Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M40.8888 10.2796C40.8888 9.56997 41.4609 8.99469 42.1666 8.99469H47.2777C47.9834 8.99469 48.5555 9.56997 48.5555 10.2796C48.5555 10.9892 47.9834 11.5645 47.2777 11.5645H42.1666C41.4609 11.5645 40.8888 10.9892 40.8888 10.2796Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M44.7221 6.42486C45.4278 6.42486 45.9999 7.00013 45.9999 7.70977V12.8494C45.9999 13.5591 45.4278 14.1344 44.7221 14.1344C44.0164 14.1344 43.4443 13.5591 43.4443 12.8494V7.70977C43.4443 7.00013 44.0164 6.42486 44.7221 6.42486Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M21.7222 80.9501C21.7222 80.2404 22.2942 79.6652 22.9999 79.6652H28.1111C28.8168 79.6652 29.3888 80.2404 29.3888 80.9501C29.3888 81.6597 28.8168 82.235 28.1111 82.235H22.9999C22.2942 82.235 21.7222 81.6597 21.7222 80.9501Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M25.5555 77.0953C26.2612 77.0953 26.8333 77.6706 26.8333 78.3803V83.5199C26.8333 84.2296 26.2612 84.8048 25.5555 84.8048C24.8498 84.8048 24.2777 84.2296 24.2777 83.5199V78.3803C24.2777 77.6706 24.8498 77.0953 25.5555 77.0953Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M71.5554 64.246C71.5554 63.7729 71.9368 63.3894 72.4073 63.3894H75.8147C76.2851 63.3894 76.6665 63.7729 76.6665 64.246C76.6665 64.7191 76.2851 65.1026 75.8147 65.1026H72.4073C71.9368 65.1026 71.5554 64.7191 71.5554 64.246Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M74.1111 61.6762C74.5815 61.6762 74.9629 62.0597 74.9629 62.5328V65.9592C74.9629 66.4323 74.5815 66.8158 74.1111 66.8158C73.6406 66.8158 73.2592 66.4323 73.2592 65.9592V62.5328C73.2592 62.0597 73.6406 61.6762 74.1111 61.6762Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M15.3333 19.274C15.3333 18.8009 15.7146 18.4174 16.1851 18.4174H19.5925C20.063 18.4174 20.4444 18.8009 20.4444 19.274C20.4444 19.7471 20.063 20.1306 19.5925 20.1306H16.1851C15.7146 20.1306 15.3333 19.7471 15.3333 19.274Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M17.8889 16.7042C18.3594 16.7042 18.7408 17.0877 18.7408 17.5608V20.9872C18.7408 21.4603 18.3594 21.8438 17.8889 21.8438C17.4184 21.8438 17.0371 21.4603 17.0371 20.9872V17.5608C17.0371 17.0877 17.4184 16.7042 17.8889 16.7042Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M33.2222 78.3802C33.2222 77.9071 33.6036 77.5236 34.074 77.5236H37.4814C37.9519 77.5236 38.3333 77.9071 38.3333 78.3802C38.3333 78.8533 37.9519 79.2368 37.4814 79.2368H34.074C33.6036 79.2368 33.2222 78.8533 33.2222 78.3802Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M35.7778 75.8104C36.2483 75.8104 36.6297 76.1939 36.6297 76.667V80.0934C36.6297 80.5665 36.2483 80.95 35.7778 80.95C35.3074 80.95 34.926 80.5665 34.926 80.0934V76.667C34.926 76.1939 35.3074 75.8104 35.7778 75.8104Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M61.3333 23.1285V74.5252H30.6667C26.4325 74.5252 23 71.0735 23 66.8157V23.1285L61.3333 23.1285Z\"\n\t\t\tfill=\"#F1F1F2\"\n\t\t/>\n\t\t<rect x=\"30.6667\" y=\"30.1957\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t<rect x=\"30.6667\" y=\"35.3354\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t<rect x=\"30.6667\" y=\"40.4748\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t<rect x=\"30.6667\" y=\"45.6147\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t<rect x=\"30.6667\" y=\"50.754\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t<rect x=\"30.6667\" y=\"55.8939\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t<rect x=\"30.6667\" y=\"61.0333\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t<path\n\t\t\td=\"M69.0001 68.1449V66.8157H34.5001V68.1006C34.5001 71.2296 32.2756 73.8362 29.3301 74.4084C29.7642 74.4851 30.2108 74.5252 30.6668 74.5252H62.6553C66.1594 74.5252 69.0001 71.6686 69.0001 68.1449Z\"\n\t\t\tfill=\"#CCCCCC\"\n\t\t/>\n\t</svg>\n\t<span>{{ params.translate.message }}</span>\n\t<a (click)=\"params.cb()\">{{ params.translate.add }}</a>\n</div>\n", styles: [":host .cp-grid-empty{display:flex;align-items:center;flex-direction:column}:host .cp-grid-empty a,:host .cp-grid-empty span{font-size:14px;line-height:1.5}:host .cp-grid-empty a{color:#2c50ff}:host .cp-grid-empty a:hover{text-decoration:underline}:host .cp-grid-empty span{color:#757575}\n"] }]
        }] });

class CPGridEmptyModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPGridEmptyModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CPGridEmptyModule, declarations: [CPGridEmptyComponent], exports: [CPGridEmptyComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPGridEmptyModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPGridEmptyModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CPGridEmptyComponent],
                    exports: [CPGridEmptyComponent],
                }]
        }] });

class CPGridControlComponent {
    constructor() {
        this.add = new EventEmitter();
        this.translate = {};
        this.isReadonly = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPGridControlComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CPGridControlComponent, selector: "fsw-cp-grid-control", inputs: { translate: "translate", isReadonly: "isReadonly" }, outputs: { add: "add" }, ngImport: i0, template: "<div class=\"cp-grid-control\">\n  <div class=\"cp-grid-information\">\n    <h6>{{ translate['top'] }}</h6>\n    <span>{{ translate['optional'] }}</span>\n  </div>\n  <a class=\"btn btn--link\" (click)=\"add.emit()\" *ngIf=\"!isReadonly\">{{ translate['add'] }}</a>\n</div>\n", styles: [":host .cp-grid-control{display:flex;justify-content:space-between}:host .cp-grid-control__information{display:flex;flex-direction:column}:host .cp-grid-control__information h6{font-family:Poppins,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:20px;line-height:1.4;color:#222}:host .cp-grid-control__information span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:12px;line-height:1.5;color:#757575}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPGridControlComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cp-grid-control', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"cp-grid-control\">\n  <div class=\"cp-grid-information\">\n    <h6>{{ translate['top'] }}</h6>\n    <span>{{ translate['optional'] }}</span>\n  </div>\n  <a class=\"btn btn--link\" (click)=\"add.emit()\" *ngIf=\"!isReadonly\">{{ translate['add'] }}</a>\n</div>\n", styles: [":host .cp-grid-control{display:flex;justify-content:space-between}:host .cp-grid-control__information{display:flex;flex-direction:column}:host .cp-grid-control__information h6{font-family:Poppins,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:20px;line-height:1.4;color:#222}:host .cp-grid-control__information span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:12px;line-height:1.5;color:#757575}\n"] }]
        }], propDecorators: { add: [{
                type: Output
            }], translate: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class CPGridComponent {
    constructor() {
        this.action = new EventEmitter();
        this.type = undefined;
        this.data = [];
        this.config = null;
        this.translate = {};
        this.isReadonly = false;
        this.defaultGridOptions = {
            rowSelection: 'multiple',
            headerHeight: 36,
            rowHeight: 36,
            pagination: false,
            noRowsOverlayComponent: CPGridEmptyComponent,
            noRowsOverlayComponentParams: {
                cb: () => {
                    this.add();
                },
            },
        };
    }
    ngOnChanges() {
        this.defaultGridOptions = {
            ...this.defaultGridOptions,
            noRowsOverlayComponentParams: {
                ...this.defaultGridOptions.noRowsOverlayComponentParams,
                translate: {
                    ...this.translate.empty,
                },
            },
        };
        if (!this.config)
            return;
        this.defaultGridOptions = this.config.setup(this.defaultGridOptions, this.translate.columns, this.data, (res, method) => this.action.emit({ res, method }), this.isReadonly);
    }
    add() {
        this.action.emit({ method: Methods.POST, res: undefined });
    }
    rowClicked({ data, index }) {
        this.action.emit({
            res: data,
            method: Methods.GET,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPGridComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CPGridComponent, selector: "fsw-cp-grid", inputs: { type: "type", data: "data", config: "config", translate: "translate", isReadonly: "isReadonly" }, outputs: { action: "action" }, usesOnChanges: true, ngImport: i0, template: "<fsw-cp-grid-control\n  (add)=\"add()\"\n  [translate]=\"translate.control\"\n  [isReadonly]=\"isReadonly\"\n></fsw-cp-grid-control>\n<fsw-grid\n  (rowClicked)=\"rowClicked($event)\"\n  [gridOptions]=\"defaultGridOptions\"\n  [rowData]=\"data\"\n></fsw-grid>\n", styles: [":host{width:100%;display:flex;flex-direction:column;gap:16px}\n"], dependencies: [{ kind: "component", type: FSWGridComponent, selector: "fsw-grid", inputs: ["gridOptions", "actionClickedCheck", "rowData", "gridContainerHeight"], outputs: ["rowClicked"] }, { kind: "component", type: CPGridControlComponent, selector: "fsw-cp-grid-control", inputs: ["translate", "isReadonly"], outputs: ["add"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPGridComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cp-grid', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-cp-grid-control\n  (add)=\"add()\"\n  [translate]=\"translate.control\"\n  [isReadonly]=\"isReadonly\"\n></fsw-cp-grid-control>\n<fsw-grid\n  (rowClicked)=\"rowClicked($event)\"\n  [gridOptions]=\"defaultGridOptions\"\n  [rowData]=\"data\"\n></fsw-grid>\n", styles: [":host{width:100%;display:flex;flex-direction:column;gap:16px}\n"] }]
        }], propDecorators: { action: [{
                type: Output
            }], type: [{
                type: Input
            }], data: [{
                type: Input
            }], config: [{
                type: Input
            }], translate: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class CPGridControlModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPGridControlModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CPGridControlModule, declarations: [CPGridControlComponent], imports: [NgIf], exports: [CPGridControlComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPGridControlModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPGridControlModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CPGridControlComponent],
                    exports: [CPGridControlComponent],
                    imports: [NgIf],
                }]
        }] });

class CPGridModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPGridModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CPGridModule, declarations: [CPGridComponent], imports: [CommonModule, FSWGridModule, CPGridEmptyModule, CPGridControlModule], exports: [CPGridComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPGridModule, imports: [CommonModule, FSWGridModule, CPGridEmptyModule, CPGridControlModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPGridModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FSWGridModule, CPGridEmptyModule, CPGridControlModule],
                    declarations: [CPGridComponent],
                    exports: [CPGridComponent],
                }]
        }] });

var titles$9 = {
	main: "Company Profile",
	confirmation: "Are you sure you want to delete?"
};
var risk_titles$1 = {
	profile: "Risk Profile",
	analysis: "Risk Analysis"
};
var supplier_titles$1 = {
	top_suppliers: "Top Suppliers",
	add_suppliers: "Add Suppliers",
	edit_supplier: "Edit Supplier",
	view_supplier: "View Supplier"
};
var customer_titles$1 = {
	edit_customer: "Edit Customer",
	view_customer: "View Customer",
	top_customers: "Top Customers",
	add_customers: "Add Customers"
};
var others$6 = {
	optional: "Optional",
	warning: "You will lose all the information that you added.",
	comments: "Comments"
};
var buttons$P = {
	cancel: "Cancel",
	put: "Save Changes",
	back: "Back",
	edit: "Edit Details",
	save: "Save"
};
var customer_buttons$1 = {
	"delete": "Delete Customer",
	post: "Add Customers"
};
var supplier_buttons$1 = {
	"delete": "Delete Supplier",
	post: "Add Suppliers"
};
var main_fields$1 = {
	company_establishment_history: "Company Establishment History",
	number_of_employee: "Number of Employees",
	main_market_segment: "Main Market Segment",
	source_of_products: "Source of Products",
	concentration_of_competition: "Concentration of Competition",
	type_of_payment_by_buyers_customers: "Type of Payment by Buyers/Customers",
	dependency_on_technology: "Dependency on Technology",
	obsolescence_risk: "Obsolescence Risk",
	value_added_info: "Value added info",
	list_of_previous_current_potential_contract_projects: "List of previous, current & potential contract/projects",
	source_of_repayment: "Source of Repayment",
	loan_use_purpose: "Loan Use Purpose"
};
var risk_profile_fields$1 = {
	bargaining_power_of_supplier: "Bargaining Power of Supplier",
	bargaining_power_of_buyer: "Bargaining Power of Buyer",
	threat_of_new_entrant: "Threat of New Entrant",
	threat_of_substitution: "Threat of Substitution",
	industry_rivalry: "Industry Rivalry"
};
var risk_analysis_fields$1 = {
	business_risk: "Business Risk",
	business_risk_comment: "Business Risk Comment",
	liquidity_risk: "Liquidity Risk",
	liquidity_risk_comment: "Liquidity Risk Comment",
	repayment_risk: "Repayment Risk",
	repayment_risk_comment: "Repayment Risk Comment",
	other_risk: "Other Risk",
	other_risk_comment: "Other Risk Comment"
};
var placeholders$4 = {
	comments: "Add comments"
};
var supplier_columns$1 = {
	supplier_name: "Supplier Name",
	term_of_payment: "Term of Payment/ToP",
	cogs: "COGS",
	cogs_percentage: "COGS (%)",
	trading_history: "Trading History"
};
var supplier_empty$1 = {
	message: "No top suppliers yet.",
	add: "Add new Top Suppliers"
};
var customer_columns$1 = {
	customer_name: "Customer Name",
	term_of_payment: "Term of Payment/ToP",
	revenue: "Revenue",
	revenue_percentage: "Revenue (%)",
	trading_history: "Trading History"
};
var customer_empty$1 = {
	message: "No top customers yet.",
	add: "Add new Top Customers"
};
var _default$4 = {
	titles: titles$9,
	risk_titles: risk_titles$1,
	supplier_titles: supplier_titles$1,
	customer_titles: customer_titles$1,
	others: others$6,
	buttons: buttons$P,
	customer_buttons: customer_buttons$1,
	supplier_buttons: supplier_buttons$1,
	main_fields: main_fields$1,
	risk_profile_fields: risk_profile_fields$1,
	risk_analysis_fields: risk_analysis_fields$1,
	placeholders: placeholders$4,
	supplier_columns: supplier_columns$1,
	supplier_empty: supplier_empty$1,
	customer_columns: customer_columns$1,
	customer_empty: customer_empty$1
};

var de$3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$P,
    customer_buttons: customer_buttons$1,
    customer_columns: customer_columns$1,
    customer_empty: customer_empty$1,
    customer_titles: customer_titles$1,
    default: _default$4,
    main_fields: main_fields$1,
    others: others$6,
    placeholders: placeholders$4,
    risk_analysis_fields: risk_analysis_fields$1,
    risk_profile_fields: risk_profile_fields$1,
    risk_titles: risk_titles$1,
    supplier_buttons: supplier_buttons$1,
    supplier_columns: supplier_columns$1,
    supplier_empty: supplier_empty$1,
    supplier_titles: supplier_titles$1,
    titles: titles$9
});

var titles$8 = {
	main: "Company Profile",
	confirmation: "Are you sure you want to delete?"
};
var risk_titles = {
	profile: "Risk Profile",
	analysis: "Risk Analysis"
};
var supplier_titles = {
	top_suppliers: "Top Suppliers",
	add_suppliers: "Add Suppliers",
	edit_supplier: "Edit Supplier",
	view_supplier: "View Supplier"
};
var customer_titles = {
	edit_customer: "Edit Customer",
	view_customer: "View Customer",
	top_customers: "Top Customers",
	add_customers: "Add Customers"
};
var others$5 = {
	optional: "Optional",
	warning: "You will lose all the information that you added.",
	comments: "Comments"
};
var buttons$O = {
	cancel: "Cancel",
	put: "Save Changes",
	back: "Back",
	edit: "Edit Details",
	save: "Save"
};
var customer_buttons = {
	"delete": "Delete Customer",
	post: "Add Customers"
};
var supplier_buttons = {
	"delete": "Delete Supplier",
	post: "Add Suppliers"
};
var main_fields = {
	company_establishment_history: "Company Establishment History",
	number_of_employee: "Number of Employees",
	company_background: "Company Background",
	buyer_supplier_information: "Buyer/Supplier information",
	main_market_segment: "Main Market Segment",
	source_of_products: "Source of Products",
	concentration_of_competition: "Concentration of Competition",
	type_of_payment_by_buyers_customers: "Type of Payment by Buyers/Customers",
	dependency_on_technology: "Dependency on Technology",
	obsolescence_risk: "Obsolescence Risk",
	competitive_advantage: "Competitive Advantage",
	date_of_incorporation: "Date of Incorporation",
	ncb_loan_history: "NCB/ Loan history (Please list any delay/restructure or abnormal loan history in detail)",
	value_added_info: "Value added info (If any, please provide supporting docs)",
	list_of_previous_current_potential_contract_projects: "List of previous, current & potential contract/projects (If any)",
	source_of_repayment: "Source of Repayment",
	loan_use_purpose: "Loan Use Purpose"
};
var risk_profile_fields = {
	bargaining_power_of_supplier: "Bargaining Power of Supplier",
	bargaining_power_of_buyer: "Bargaining Power of Buyer",
	threat_of_new_entrant: "Threat of New Entrant",
	threat_of_substitution: "Threat of Substitution",
	industry_rivalry: "Industry Rivalry"
};
var risk_analysis_fields = {
	business_risk: "Business Risk",
	business_risk_comment: "Business Risk Comment",
	liquidity_risk: "Liquidity Risk",
	liquidity_risk_comment: "Liquidity Risk Comment",
	repayment_risk: "Repayment Risk",
	repayment_risk_comment: "Repayment Risk Comment",
	other_risk: "Other Risk",
	other_risk_comment: "Other Risk Comment"
};
var placeholders$3 = {
	comments: "Add comments"
};
var supplier_columns = {
	supplier_name: "Supplier Name",
	term_of_payment: "Term of Payment/ToP",
	cogs: "COGS",
	cogs_percentage: "COGS (%)",
	trading_history: "Trading History"
};
var supplier_empty = {
	message: "No top suppliers yet.",
	add: "Add new Top Suppliers"
};
var customer_columns = {
	customer_name: "Customer Name",
	term_of_payment: "Term of Payment/ToP",
	revenue: "Revenue",
	revenue_percentage: "Revenue (%)",
	trading_history: "Trading History"
};
var customer_empty = {
	message: "No top customers yet.",
	add: "Add new Top Customers"
};
var th$6 = {
	titles: titles$8,
	risk_titles: risk_titles,
	supplier_titles: supplier_titles,
	customer_titles: customer_titles,
	others: others$5,
	buttons: buttons$O,
	customer_buttons: customer_buttons,
	supplier_buttons: supplier_buttons,
	main_fields: main_fields,
	risk_profile_fields: risk_profile_fields,
	risk_analysis_fields: risk_analysis_fields,
	placeholders: placeholders$3,
	supplier_columns: supplier_columns,
	supplier_empty: supplier_empty,
	customer_columns: customer_columns,
	customer_empty: customer_empty
};

var th$7 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$O,
    customer_buttons: customer_buttons,
    customer_columns: customer_columns,
    customer_empty: customer_empty,
    customer_titles: customer_titles,
    default: th$6,
    main_fields: main_fields,
    others: others$5,
    placeholders: placeholders$3,
    risk_analysis_fields: risk_analysis_fields,
    risk_profile_fields: risk_profile_fields,
    risk_titles: risk_titles,
    supplier_buttons: supplier_buttons,
    supplier_columns: supplier_columns,
    supplier_empty: supplier_empty,
    supplier_titles: supplier_titles,
    titles: titles$8
});

const companyProfileLoader = {
    default: () => Promise.resolve(de$3),
    id: () => Promise.resolve(de$3),
    vu: () => Promise.resolve(de$3),
    th: () => Promise.resolve(th$7),
};
const COMPANY_PROFILE_TRANSLATION = {
    [CountryCode.MY]: de$3,
    [CountryCode.SG]: de$3,
    [CountryCode.ID]: de$3,
    [CountryCode.VU]: de$3,
    [CountryCode.TH]: th$7,
};

function companyProfileTranslation(scope = 'company_profile') {
    return [
        ...(FSWTranslateModule.forFeature({
            scope,
            defaultKey: getCountryCodeFromStorage(),
            data: COMPANY_PROFILE_TRANSLATION,
        }).providers || []),
        fswTranslateScope(scope),
    ];
}

class CompanyProfileComponent {
    set id(value) {
        this._componentStore.setId(value);
    }
    set applicationId(value) {
        this._componentStore.setApplicationId(value);
    }
    set isReadonly(value) {
        this._componentStore.setIsReadonly(value);
    }
    constructor(customerGridConfig, supplierGridConfig, _componentStore, _customerFormConfig, _supplierFormConfig, _scope, _translateService, _modalService, _injector) {
        this.customerGridConfig = customerGridConfig;
        this.supplierGridConfig = supplierGridConfig;
        this._componentStore = _componentStore;
        this._customerFormConfig = _customerFormConfig;
        this._supplierFormConfig = _supplierFormConfig;
        this._scope = _scope;
        this._translateService = _translateService;
        this._modalService = _modalService;
        this._injector = _injector;
        this.displaySettings = {
            comment: true,
            profile: true,
            analysis: true,
            grid: true,
            bolt_comment: false,
        };
        this.state$ = this._componentStore.state$;
        this.Methods = Methods;
        this.supplierGridState$ = combineLatest([
            combineLatest([
                this._translateService.selectFeatureTranslate(this._scope, 'supplier_columns'),
                this._translateService.selectFeatureTranslate(this._scope, 'supplier_empty'),
                this._translateService.selectFeatureTranslate(this._scope, 'supplier_titles'),
                this._translateService.selectFeatureTranslate(this._scope, 'supplier_buttons'),
                this._translateService.selectFeatureTranslate(this._scope, 'others'),
            ]).pipe(map(([columns, empty, titles, buttons, others]) => ({
                columns,
                empty,
                control: {
                    top: titles['top_suppliers'],
                    optional: others['optional'],
                    add: buttons['post'],
                },
            }))),
            this._componentStore.state$.pipe(map((e) => e.suppliers)),
        ]).pipe(map(([translate, data]) => ({
            translate,
            data,
        })));
        this.customerGridState$ = combineLatest([
            combineLatest([
                this._translateService.selectFeatureTranslate(this._scope, 'customer_columns'),
                this._translateService.selectFeatureTranslate(this._scope, 'customer_empty'),
                this._translateService.selectFeatureTranslate(this._scope, 'customer_titles'),
                this._translateService.selectFeatureTranslate(this._scope, 'customer_buttons'),
                this._translateService.selectFeatureTranslate(this._scope, 'others'),
            ]).pipe(map(([columns, empty, titles, buttons, others]) => ({
                columns,
                empty,
                control: {
                    top: titles['top_customers'],
                    optional: others['optional'],
                    add: buttons['post'],
                },
            }))),
            this._componentStore.state$.pipe(map((e) => e.customers)),
        ]).pipe(map(([translate, data]) => ({
            translate,
            data,
        })));
    }
    ngOnInit() {
        this._componentStore.init();
    }
    save(data) {
        this._componentStore.save(data);
    }
    //#region Customer
    openCustomer(method, selectedItem) {
        combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'customer_columns'),
            this._translateService.selectFeatureTranslate(this._scope, 'customer_titles'),
            this._translateService.selectFeatureTranslate(this._scope, 'customer_buttons'),
            this._translateService.selectFeatureTranslate(this._scope, 'buttons'),
        ])
            .pipe(take(1), map(([fields, customer_titles, customer_buttons, buttons]) => ({
            translate: {
                [Methods.GET]: customer_titles['view_customer'],
                [Methods.PUT]: customer_titles['edit_customer'],
                [Methods.POST]: customer_titles['add_customers'],
                [Methods.DELETE]: customer_buttons[Methods.DELETE],
                cancel: buttons['cancel'],
                back: buttons['back'],
                edit: buttons['edit'],
                save: buttons['put'],
            },
            fields,
        })), switchMap(({ translate, fields }) => {
            const data = {
                selectedItem,
                settings: this._componentStore.state().settings,
                method,
                config: this._customerFormConfig,
                translate,
                fields,
            };
            return this.open$(data).pipe(tap((res) => {
                if (!res)
                    return;
                const { method, data } = res;
                if (method === Methods.POST) {
                    this._componentStore.postCustomer(data);
                }
                else if (method === Methods.PUT) {
                    this._componentStore.putCustomer({
                        ...selectedItem,
                        ...data,
                    });
                }
                else if (method === Methods.DELETE) {
                    selectedItem && this.removeCustomer(selectedItem);
                }
            }));
        }))
            .subscribe();
    }
    removeCustomer(selectedItem) {
        combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'others'),
            this._translateService.selectFeatureTranslate(this._scope, 'titles'),
            this._translateService.selectFeatureTranslate(this._scope, 'customer_buttons'),
            this._translateService.selectFeatureTranslate(this._scope, 'buttons'),
        ])
            .pipe(take(1), map(([others, titles, customer_buttons, buttons]) => ({
            title: titles['confirmation'],
            delete: customer_buttons['delete'],
            cancel: buttons['cancel'],
            description: others['warning'],
        })), switchMap((data) => this.remove$(data).pipe(tap((res) => {
            if (!res)
                return;
            this._componentStore.removeCustomer(selectedItem.id);
        }))))
            .subscribe();
    }
    actionCustomer(res, method) {
        if (method === Methods.DELETE) {
            this.removeCustomer(res);
        }
        else {
            this.openCustomer(method, res);
        }
    }
    //#endregion Customer
    //#region Supplier
    openSupplier(method, selectedItem) {
        combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'supplier_columns'),
            this._translateService.selectFeatureTranslate(this._scope, 'supplier_titles'),
            this._translateService.selectFeatureTranslate(this._scope, 'supplier_buttons'),
            this._translateService.selectFeatureTranslate(this._scope, 'buttons'),
        ])
            .pipe(take(1), map(([fields, supplier_titles, supplier_buttons, buttons]) => ({
            translate: {
                [Methods.GET]: supplier_titles['view_supplier'],
                [Methods.PUT]: supplier_titles['edit_supplier'],
                [Methods.POST]: supplier_titles['add_suppliers'],
                [Methods.DELETE]: supplier_buttons[Methods.DELETE],
                cancel: buttons['cancel'],
                back: buttons['back'],
                edit: buttons['edit'],
                save: buttons['put'],
            },
            fields,
        })), switchMap(({ translate, fields }) => {
            const data = {
                selectedItem,
                settings: this._componentStore.state().settings,
                method,
                config: this._supplierFormConfig,
                translate,
                fields,
            };
            return this.open$(data).pipe(tap((res) => {
                if (!res)
                    return;
                const { method, data } = res;
                if (method === Methods.POST) {
                    this._componentStore.postSupplier(data);
                }
                else if (method === Methods.PUT) {
                    this._componentStore.putSupplier({
                        ...selectedItem,
                        ...data,
                    });
                }
                else if (method === Methods.DELETE) {
                    selectedItem && this.removeSupplier(selectedItem);
                }
            }));
        }))
            .subscribe();
    }
    removeSupplier(selectedItem) {
        combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'others'),
            this._translateService.selectFeatureTranslate(this._scope, 'titles'),
            this._translateService.selectFeatureTranslate(this._scope, 'supplier_buttons'),
            this._translateService.selectFeatureTranslate(this._scope, 'buttons'),
        ])
            .pipe(take(1), map(([others, titles, supplier_buttons, buttons]) => ({
            title: titles['confirmation'],
            delete: supplier_buttons['delete'],
            cancel: buttons['cancel'],
            description: others['warning'],
        })), switchMap((data) => this.remove$(data).pipe(tap((res) => {
            if (!res)
                return;
            this._componentStore.removeSupplier(selectedItem.id);
        }))))
            .subscribe();
    }
    actionSupplier(res, method) {
        if (method === Methods.DELETE) {
            this.removeSupplier(res);
        }
        else {
            this.openSupplier(method, res);
        }
    }
    //#endregion Supplier
    //#region Dialog
    open$(data) {
        return this._modalService
            .open(CPSaveDialogComponent, {
            data,
            size: ModalSizes.L,
            injector: this._injector,
        })
            .pipe(take(1));
    }
    remove$(data) {
        return this._modalService
            .open(CPRemoveDialogComponent, {
            size: ModalSizes.S,
            injector: this._injector,
            data,
        })
            .pipe(take(1));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyProfileComponent, deps: [{ token: CP_CUSTOMER_GRID_CONFIG_TOKEN }, { token: CP_SUPPLIER_GRID_CONFIG_TOKEN }, { token: CP_COMPONENT_STORE_TOKEN }, { token: CP_CUSTOMER_FORM_CONFIG_TOKEN }, { token: CP_SUPPLIER_FORM_CONFIG_TOKEN }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: MODAL_SERVICE }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CompanyProfileComponent, selector: "fsw-company-profile", inputs: { id: "id", applicationId: "applicationId", isReadonly: "isReadonly", displaySettings: "displaySettings" }, providers: [companyProfileTranslation()], ngImport: i0, template: "<ng-container *ngrxLet=\"state$; let state\">\n  <div class=\"company-profile\">\n    <fsw-cp-main-block\n      [data]=\"state.data\"\n      [settings]=\"state.settings\"\n      [comments]=\"state.comments\"\n      [displaySettings]=\"displaySettings\"\n      [isReadonly]=\"state.isReadonly\"\n      (save)=\"save($event)\"\n    ></fsw-cp-main-block>\n    <fsw-comments\n      *ngIf=\"state.id && displaySettings.bolt_comment\"\n      [title]=\"'Comments'\"\n      [entityId]=\"state.applicationId\"\n      [identifier]=\"state.id\"\n      [module]=\"'COMPANY_PROFILE'\"\n      [category]=\"'CREDIT'\"\n      [isReadonly]=\"state.isReadonly\"\n      [enableSaveButton]=\"true\"\n      [translateScope]=\"'company_profile'\"\n    >\n      <ng-template fswCommentsItem [key]=\"'main_comment'\" [label]=\"'Credit Comments'\"></ng-template>\n    </fsw-comments>\n    <ng-container *ngIf=\"state.data && displaySettings.grid\">\n      <ng-container *ngrxLet=\"supplierGridState$; let supplierGridState\">\n        <fsw-cp-grid\n          (action)=\"actionSupplier($event.res, $event.method)\"\n          [type]=\"supplierGridState.data[0] || undefined\"\n          [config]=\"supplierGridConfig\"\n          [translate]=\"supplierGridState.translate\"\n          [data]=\"supplierGridState.data\"\n          [isReadonly]=\"state.isReadonly\"\n        ></fsw-cp-grid>\n      </ng-container>\n      <ng-container *ngrxLet=\"customerGridState$; let customerGridState\">\n        <fsw-cp-grid\n          (action)=\"actionCustomer($event.res, $event.method)\"\n          [type]=\"customerGridState.data[0] || undefined\"\n          [config]=\"customerGridConfig\"\n          [translate]=\"customerGridState.translate\"\n          [data]=\"customerGridState.data\"\n          [isReadonly]=\"state.isReadonly\"\n        ></fsw-cp-grid>\n      </ng-container>\n    </ng-container>\n  </div>\n</ng-container>\n", styles: [":host .company-profile{display:flex;flex-direction:column;gap:24px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$1.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: CPMainBlockComponent, selector: "fsw-cp-main-block", inputs: ["data", "settings", "comments", "displaySettings", "isReadonly"], outputs: ["save"] }, { kind: "component", type: CPGridComponent, selector: "fsw-cp-grid", inputs: ["type", "data", "config", "translate", "isReadonly"], outputs: ["action"] }, { kind: "component", type: FSWCommentsComponent, selector: "fsw-comments", inputs: ["title", "entityId", "identifier", "module", "category", "isReadonly", "rows", "customClasses", "enableSaveButton", "translateScope"] }, { kind: "directive", type: FSWCommentsItemDirective, selector: "ng-template[fswCommentsItem]", inputs: ["label", "key"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyProfileComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-company-profile', changeDetection: ChangeDetectionStrategy.OnPush, providers: [companyProfileTranslation()], template: "<ng-container *ngrxLet=\"state$; let state\">\n  <div class=\"company-profile\">\n    <fsw-cp-main-block\n      [data]=\"state.data\"\n      [settings]=\"state.settings\"\n      [comments]=\"state.comments\"\n      [displaySettings]=\"displaySettings\"\n      [isReadonly]=\"state.isReadonly\"\n      (save)=\"save($event)\"\n    ></fsw-cp-main-block>\n    <fsw-comments\n      *ngIf=\"state.id && displaySettings.bolt_comment\"\n      [title]=\"'Comments'\"\n      [entityId]=\"state.applicationId\"\n      [identifier]=\"state.id\"\n      [module]=\"'COMPANY_PROFILE'\"\n      [category]=\"'CREDIT'\"\n      [isReadonly]=\"state.isReadonly\"\n      [enableSaveButton]=\"true\"\n      [translateScope]=\"'company_profile'\"\n    >\n      <ng-template fswCommentsItem [key]=\"'main_comment'\" [label]=\"'Credit Comments'\"></ng-template>\n    </fsw-comments>\n    <ng-container *ngIf=\"state.data && displaySettings.grid\">\n      <ng-container *ngrxLet=\"supplierGridState$; let supplierGridState\">\n        <fsw-cp-grid\n          (action)=\"actionSupplier($event.res, $event.method)\"\n          [type]=\"supplierGridState.data[0] || undefined\"\n          [config]=\"supplierGridConfig\"\n          [translate]=\"supplierGridState.translate\"\n          [data]=\"supplierGridState.data\"\n          [isReadonly]=\"state.isReadonly\"\n        ></fsw-cp-grid>\n      </ng-container>\n      <ng-container *ngrxLet=\"customerGridState$; let customerGridState\">\n        <fsw-cp-grid\n          (action)=\"actionCustomer($event.res, $event.method)\"\n          [type]=\"customerGridState.data[0] || undefined\"\n          [config]=\"customerGridConfig\"\n          [translate]=\"customerGridState.translate\"\n          [data]=\"customerGridState.data\"\n          [isReadonly]=\"state.isReadonly\"\n        ></fsw-cp-grid>\n      </ng-container>\n    </ng-container>\n  </div>\n</ng-container>\n", styles: [":host .company-profile{display:flex;flex-direction:column;gap:24px}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CP_CUSTOMER_GRID_CONFIG_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CP_SUPPLIER_GRID_CONFIG_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CP_COMPONENT_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CP_CUSTOMER_FORM_CONFIG_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CP_SUPPLIER_FORM_CONFIG_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_SERVICE]
                }] }, { type: i0.Injector }]; }, propDecorators: { id: [{
                type: Input
            }], applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], displaySettings: [{
                type: Input
            }] } });

const cpDefaultSupplierFormConfig = {
    setup(translate, data) {
        return {
            formFields: [
                {
                    type: FIELD_TYPE.STRING,
                    key: 'supplier_name',
                    label: translate['supplier_name'],
                    param: [{ value: data.supplier_name, disabled: false }, [Validators.required]],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: 'term_of_payment',
                    label: translate['term_of_payment'],
                    param: [{ value: data.term_of_payment, disabled: false }, [Validators.required]],
                },
                {
                    type: FIELD_TYPE.NUMBER,
                    key: 'cogs',
                    label: translate['cogs'],
                    param: [{ value: data.cogs, disabled: false }, [Validators.required]],
                    context: {
                        prefix: getCurrentCountryConfig().currencyCode,
                    },
                },
                {
                    type: FIELD_TYPE.NUMBER,
                    key: 'cogs_percentage',
                    label: translate['cogs_percentage'],
                    param: [{ value: data.cogs_percentage, disabled: false }, [Validators.required]],
                    context: {
                        suffix: '%',
                    },
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: 'trading_history',
                    label: translate['trading_history'],
                    param: [{ value: data.trading_history, disabled: false }, [Validators.required]],
                    context: {
                        isMultiline: true,
                        numberOfRows: 3,
                    },
                },
            ],
            formData: data,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        };
    },
    reset(oldConfig) {
        return {
            ...oldConfig,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        };
    },
    getValue(form, data) {
        return {
            ...data,
            ...form.value,
        };
    },
};

const cpDefaultCustomerFormConfig = {
    setup(translate, data) {
        return {
            formFields: [
                {
                    type: FIELD_TYPE.STRING,
                    key: 'customer_name',
                    label: translate['customer_name'],
                    param: [{ value: data.customer_name, disabled: false }, [Validators.required]],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: 'term_of_payment',
                    label: translate['term_of_payment'],
                    param: [{ value: data.term_of_payment, disabled: false }, [Validators.required]],
                },
                {
                    type: FIELD_TYPE.NUMBER,
                    key: 'revenue',
                    label: translate['revenue'],
                    param: [{ value: data.revenue, disabled: false }, [Validators.required]],
                    context: {
                        prefix: getCurrentCountryConfig().currencyCode,
                    },
                },
                {
                    type: FIELD_TYPE.NUMBER,
                    key: 'revenue_percentage',
                    label: translate['revenue_percentage'],
                    param: [{ value: data.revenue_percentage, disabled: false }, [Validators.required]],
                    context: {
                        suffix: '%',
                    },
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: 'trading_history',
                    label: translate['trading_history'],
                    param: [{ value: data.trading_history, disabled: false }, [Validators.required]],
                    context: {
                        isMultiline: true,
                        numberOfRows: 3,
                    },
                },
            ],
            formData: data,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        };
    },
    reset(oldConfig) {
        return {
            ...oldConfig,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        };
    },
    getValue(form, data) {
        return {
            ...data,
            ...form.value,
        };
    },
};

const cpDefaultMainFormConfig = {
    setup(translate, data, settings) {
        return {
            formFields: [
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'company_establishment_history',
                    label: translate['company_establishment_history'],
                    param: [
                        { value: data.company_establishment_history, disabled: false },
                        [Validators.required],
                    ],
                    options: buildFieldOptions(settings.company_establishment_history_options),
                },
                {
                    type: FIELD_TYPE.NUMBER,
                    key: 'number_of_employee',
                    label: translate['number_of_employee'],
                    param: [{ value: data.number_of_employee, disabled: false }, [Validators.required]],
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'main_market_segment',
                    label: translate['main_market_segment'],
                    param: [{ value: data.main_market_segment, disabled: false }, [Validators.required]],
                    options: buildFieldOptions(settings.main_market_segment_options),
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'source_of_products',
                    label: translate['source_of_products'],
                    param: [{ value: data.source_of_products, disabled: false }, [Validators.required]],
                    options: buildFieldOptions(settings.source_of_products_options),
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'concentration_of_competition',
                    label: translate['concentration_of_competition'],
                    param: [
                        { value: data.concentration_of_competition, disabled: false },
                        [Validators.required],
                    ],
                    options: buildFieldOptions(settings.concentration_of_competition_options),
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'type_of_payment_by_buyers_customers',
                    label: translate['type_of_payment_by_buyers_customers'],
                    param: [
                        { value: data.type_of_payment_by_buyers_customers, disabled: false },
                        [Validators.required],
                    ],
                    options: buildFieldOptions(settings.type_of_payment_by_buyers_customers_options),
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'dependency_on_technology',
                    label: translate['dependency_on_technology'],
                    param: [{ value: data.dependency_on_technology, disabled: false }, [Validators.required]],
                    options: buildFieldOptions(settings.dependency_on_technology_options),
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'obsolescence_risk',
                    label: translate['obsolescence_risk'],
                    param: [{ value: data.obsolescence_risk, disabled: false }, [Validators.required]],
                    options: buildFieldOptions(settings.obsolescence_risk_options),
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: 'source_of_repayment',
                    label: translate['source_of_repayment'],
                    param: [{ value: data.source_of_repayment, disabled: false }, [Validators.required]],
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'loan_use_purpose',
                    label: translate['loan_use_purpose'],
                    param: [{ value: data.loan_use_purpose, disabled: false }, [Validators.required]],
                    options: buildFieldOptions(settings.loan_use_purpose_options),
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: 'list_of_previous_current_potential_contract_projects',
                    label: translate['list_of_previous_current_potential_contract_projects'],
                    param: [
                        { value: data.list_of_previous_current_potential_contract_projects, disabled: false },
                        [Validators.required],
                    ],
                    context: {
                        isMultiline: true,
                        numberOfRows: 3,
                    },
                    numberOfColumns: 12,
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: 'value_added_info',
                    label: translate['value_added_info'],
                    param: [{ value: data.value_added_info, disabled: false }, [Validators.required]],
                    context: {
                        isMultiline: true,
                        numberOfRows: 3,
                    },
                    numberOfColumns: 12,
                },
            ],
            formData: data,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        };
    },
    getValue(form, data) {
        return {
            ...data,
            ...form.value,
        };
    },
};

const cpDefaultRiskAnalysisFormConfig = {
    setup(translate, data, settings) {
        return {
            formFields: [
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'business_risk',
                    label: translate['business_risk'],
                    param: [{ value: data.business_risk, disabled: false }, [Validators.required]],
                    options: buildFieldOptions(settings.business_risk_options),
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'liquidity_risk',
                    label: translate['liquidity_risk'],
                    param: [{ value: data.liquidity_risk, disabled: false }, [Validators.required]],
                    options: buildFieldOptions(settings.liquidity_risk_options),
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'repayment_risk',
                    label: translate['repayment_risk'],
                    param: [{ value: data.repayment_risk, disabled: false }, [Validators.required]],
                    options: buildFieldOptions(settings.repayment_risk_options),
                },
            ],
            formData: data,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        };
    },
    getValue(form, data) {
        return {
            ...data,
            ...form.value,
        };
    },
};

const cpDefaultRiskProfileFormConfig = {
    setup(translate, data, settings) {
        return {
            formFields: [
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'bargaining_power_of_supplier',
                    label: translate['bargaining_power_of_supplier'],
                    param: [
                        { value: data.bargaining_power_of_supplier, disabled: false },
                        [Validators.required],
                    ],
                    options: buildFieldOptions(settings.bargaining_power_of_supplier_options),
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'bargaining_power_of_buyer',
                    label: translate['bargaining_power_of_buyer'],
                    param: [
                        { value: data.bargaining_power_of_buyer, disabled: false },
                        [Validators.required],
                    ],
                    options: buildFieldOptions(settings.bargaining_power_of_buyer_options),
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'threat_of_new_entrant',
                    label: translate['threat_of_new_entrant'],
                    param: [{ value: data.threat_of_new_entrant, disabled: false }, [Validators.required]],
                    options: buildFieldOptions(settings.threat_of_new_entrant_options),
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'threat_of_substitution',
                    label: translate['threat_of_substitution'],
                    param: [{ value: data.threat_of_substitution, disabled: false }, [Validators.required]],
                    options: buildFieldOptions(settings.threat_of_substitution_options),
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'industry_rivalry',
                    label: translate['industry_rivalry'],
                    param: [{ value: data.industry_rivalry, disabled: false }, [Validators.required]],
                    options: buildFieldOptions(settings.industry_rivalry_options),
                },
            ],
            formData: data,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        };
    },
    getValue(form, data) {
        return {
            ...data,
            ...form.value,
        };
    },
};

const cpDefaultSupplierGridConfig = {
    setup(defaultOptions, translate, data, action, isReadonly) {
        const decimalPipe = new DecimalPipe('en-IN');
        return {
            ...defaultOptions,
            rowData: data,
            columnDefs: [
                {
                    field: 'supplier_name',
                    headerName: translate['supplier_name'],
                    width: 240,
                },
                {
                    field: 'term_of_payment',
                    headerName: translate['term_of_payment'],
                    width: 200,
                },
                {
                    field: 'cogs',
                    headerName: translate['cogs'],
                    width: 160,
                    cellRenderer: (params) => {
                        const formattedValue = decimalPipe.transform(params.value, '.2');
                        return `${getCurrentCountryConfig().currencyCode} ${formattedValue}`;
                    },
                },
                {
                    field: 'cogs_percentage',
                    headerName: translate['cogs_percentage'],
                    width: 120,
                },
                {
                    field: 'trading_history',
                    headerName: translate['trading_history'],
                    width: 328,
                },
                ...(!isReadonly
                    ? [
                        {
                            field: 'actions',
                            headerName: '',
                            width: 56,
                            pinned: 'right',
                            cellRendererSelector: (params) => ({
                                component: 'actionMethods',
                                params: {
                                    ...params,
                                    onEdit: (params) => action(params.data, Methods.PUT),
                                    onDelete: (params) => action(params.data, Methods.DELETE),
                                },
                            }),
                        },
                    ]
                    : []),
            ],
        };
    },
};

const cpDefaultCustomerGridConfig = {
    setup(defaultOptions, translate, data, action, isReadonly) {
        const decimalPipe = new DecimalPipe('en-IN');
        return {
            ...defaultOptions,
            rowData: data,
            columnDefs: [
                {
                    field: 'customer_name',
                    headerName: translate['customer_name'],
                    width: 240,
                },
                {
                    field: 'term_of_payment',
                    headerName: translate['term_of_payment'],
                    width: 200,
                },
                {
                    field: 'revenue',
                    headerName: translate['revenue'],
                    width: 160,
                    cellRenderer: (params) => {
                        const formattedValue = decimalPipe.transform(params.value, '.2');
                        return `${getCurrentCountryConfig().currencyCode} ${formattedValue}`;
                    },
                },
                {
                    field: 'revenue_percentage',
                    headerName: translate['revenue_percentage'],
                    width: 120,
                },
                {
                    field: 'trading_history',
                    headerName: translate['trading_history'],
                    width: 328,
                },
                ...(!isReadonly
                    ? [
                        {
                            field: 'actions',
                            headerName: '',
                            width: 56,
                            pinned: 'right',
                            cellRendererSelector: (params) => ({
                                component: 'actionMethods',
                                params: {
                                    ...params,
                                    onEdit: (params) => action(params.data, Methods.PUT),
                                    onDelete: (params) => action(params.data, Methods.DELETE),
                                },
                            }),
                        },
                    ]
                    : []),
            ],
        };
    },
};

class CPDefaultComponentStore extends CPComponentStore {
    constructor(cpService) {
        super({
            countryId: getCountryCodeFromStorage(),
        }, cpService);
        this.cpService = cpService;
    }
    init() {
        this.loadSettings();
        if (this.get().id) {
            this.loadData();
            this.loadComments();
            this.loadSuppliers();
            this.loadCustomers();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPDefaultComponentStore, deps: [{ token: COMPANY_PROFILE_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPDefaultComponentStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPDefaultComponentStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [COMPANY_PROFILE_SERVICE_TOKEN]
                }] }]; } });

const cpDefaultProviders = [
    {
        provide: CP_MAIN_FORM_CONFIG_TOKEN,
        useValue: cpDefaultMainFormConfig,
    },
    {
        provide: CP_CUSTOMER_FORM_CONFIG_TOKEN,
        useValue: cpDefaultCustomerFormConfig,
    },
    {
        provide: CP_SUPPLIER_FORM_CONFIG_TOKEN,
        useValue: cpDefaultSupplierFormConfig,
    },
    {
        provide: CP_RISK_ANALYSIS_FORM_CONFIG_TOKEN,
        useValue: cpDefaultRiskAnalysisFormConfig,
    },
    {
        provide: CP_RISK_PROFILE_FORM_CONFIG_TOKEN,
        useValue: cpDefaultRiskProfileFormConfig,
    },
    {
        provide: CP_CUSTOMER_GRID_CONFIG_TOKEN,
        useValue: cpDefaultCustomerGridConfig,
    },
    {
        provide: CP_SUPPLIER_GRID_CONFIG_TOKEN,
        useValue: cpDefaultSupplierGridConfig,
    },
    {
        provide: CP_COMPONENT_STORE_TOKEN,
        useClass: CPDefaultComponentStore,
        deps: [COMPANY_PROFILE_SERVICE_TOKEN],
    },
];

class CPTHComponentStore extends CPComponentStore {
    constructor(cpService) {
        super({
            countryId: getCountryCodeFromStorage(),
        }, cpService);
        this.cpService = cpService;
    }
    init() {
        this.loadSettings();
        if (this.get().id) {
            this.loadData();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPTHComponentStore, deps: [{ token: COMPANY_PROFILE_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPTHComponentStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CPTHComponentStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [COMPANY_PROFILE_SERVICE_TOKEN]
                }] }]; } });

const cpTHMainFormConfig = {
    setup(translate, data, settings) {
        return {
            formFields: [
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'company_establishment_history',
                    label: translate['company_establishment_history'],
                    param: [
                        { value: data.company_establishment_history, disabled: false },
                        [Validators.required],
                    ],
                    options: buildFieldOptions(settings.company_establishment_history_options),
                },
                {
                    type: FIELD_TYPE.NUMBER,
                    key: 'number_of_employee',
                    label: translate['number_of_employee'],
                    param: [{ value: data.number_of_employee, disabled: false }, [Validators.required]],
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: 'company_background',
                    label: translate['company_background'],
                    param: [{ value: data.company_background, disabled: false }, [Validators.required]],
                    context: {
                        isMultiline: true,
                        numberOfRows: 3,
                    },
                    numberOfColumns: 12,
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'main_market_segment',
                    label: translate['main_market_segment'],
                    param: [{ value: data.main_market_segment, disabled: false }, [Validators.required]],
                    options: buildFieldOptions(settings.main_market_segment_options),
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'source_of_products',
                    label: translate['source_of_products'],
                    param: [{ value: data.source_of_products, disabled: false }, [Validators.required]],
                    options: buildFieldOptions(settings.source_of_products_options),
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'concentration_of_competition',
                    label: translate['concentration_of_competition'],
                    param: [
                        { value: data.concentration_of_competition, disabled: false },
                        [Validators.required],
                    ],
                    options: buildFieldOptions(settings.concentration_of_competition_options),
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: 'buyer_supplier_information',
                    label: translate['buyer_supplier_information'],
                    param: [
                        { value: data.buyer_supplier_information, disabled: false },
                        [Validators.required],
                    ],
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'type_of_payment_by_buyers_customers',
                    label: translate['type_of_payment_by_buyers_customers'],
                    param: [
                        { value: data.type_of_payment_by_buyers_customers, disabled: false },
                        [Validators.required],
                    ],
                    options: buildFieldOptions(settings.type_of_payment_by_buyers_customers_options),
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'dependency_on_technology',
                    label: translate['dependency_on_technology'],
                    param: [{ value: data.dependency_on_technology, disabled: false }, [Validators.required]],
                    options: buildFieldOptions(settings.dependency_on_technology_options),
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'obsolescence_risk',
                    label: translate['obsolescence_risk'],
                    param: [{ value: data.obsolescence_risk, disabled: false }, [Validators.required]],
                    options: buildFieldOptions(settings.obsolescence_risk_options),
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: 'source_of_repayment',
                    label: translate['source_of_repayment'],
                    param: [{ value: data.source_of_repayment, disabled: false }, [Validators.required]],
                },
                {
                    type: FIELD_TYPE.DATE,
                    key: 'date_of_incorporation',
                    label: translate['date_of_incorporation'],
                    param: [{ value: data.date_of_incorporation, disabled: false }, [Validators.required]],
                    options: buildFieldOptions(settings.loan_use_purpose_options),
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'loan_use_purpose',
                    label: translate['loan_use_purpose'],
                    param: [{ value: data.loan_use_purpose, disabled: false }, [Validators.required]],
                    options: buildFieldOptions(settings.loan_use_purpose_options),
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: 'list_of_previous_current_potential_contract_projects',
                    label: translate['list_of_previous_current_potential_contract_projects'],
                    param: [
                        { value: data.list_of_previous_current_potential_contract_projects, disabled: false },
                        [Validators.required],
                    ],
                    context: {
                        isMultiline: true,
                        numberOfRows: 3,
                    },
                    numberOfColumns: 12,
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: 'value_added_info',
                    label: translate['value_added_info'],
                    param: [{ value: data.value_added_info, disabled: false }, [Validators.required]],
                    context: {
                        isMultiline: true,
                        numberOfRows: 3,
                    },
                    numberOfColumns: 12,
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: 'ncb_loan_history',
                    label: translate['ncb_loan_history'],
                    param: [{ value: data.ncb_loan_history, disabled: false }, [Validators.required]],
                    context: {
                        isMultiline: true,
                        numberOfRows: 3,
                    },
                    numberOfColumns: 12,
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: 'competitive_advantage',
                    label: translate['competitive_advantage'],
                    param: [{ value: data.competitive_advantage, disabled: false }, [Validators.required]],
                    context: {
                        isMultiline: true,
                        numberOfRows: 3,
                    },
                    numberOfColumns: 12,
                },
            ],
            formData: data,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        };
    },
    getValue(form, data) {
        return {
            ...data,
            ...form.value,
        };
    },
};

const cpTHRiskAnalysisFormConfig = {
    setup(translate, data, settings) {
        return {
            formFields: [
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'business_risk',
                    label: translate['business_risk'],
                    param: [
                        {
                            value: data?.business_risk?.detail,
                            disabled: false,
                        },
                    ],
                    options: buildFieldOptions(settings.business_risk_options),
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: 'business_risk_comment',
                    label: translate['business_risk_comment'],
                    param: [
                        {
                            value: data?.business_risk?.mitigation_plan,
                            disabled: false,
                        },
                    ],
                    context: {
                        isMultiline: true,
                        numberOfRows: 3,
                    },
                    numberOfColumns: 6,
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'liquidity_risk',
                    label: translate['liquidity_risk'],
                    param: [
                        {
                            value: data?.liquidity_risk?.detail,
                            disabled: false,
                        },
                    ],
                    options: buildFieldOptions(settings.liquidity_risk_options),
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: 'liquidity_risk_comment',
                    label: translate['liquidity_risk_comment'],
                    param: [
                        {
                            value: data?.liquidity_risk?.mitigation_plan,
                            disabled: false,
                        },
                    ],
                    context: {
                        isMultiline: true,
                        numberOfRows: 3,
                    },
                    numberOfColumns: 6,
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'repayment_risk',
                    label: translate['repayment_risk'],
                    param: [
                        {
                            value: data?.repayment_risk?.detail,
                            disabled: false,
                        },
                    ],
                    options: buildFieldOptions(settings.repayment_risk_options),
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: 'repayment_risk_comment',
                    label: translate['repayment_risk_comment'],
                    param: [
                        {
                            value: data?.repayment_risk?.mitigation_plan,
                            disabled: false,
                        },
                    ],
                    context: {
                        isMultiline: true,
                        numberOfRows: 3,
                    },
                    numberOfColumns: 6,
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'other_risk',
                    label: translate['other_risk'],
                    param: [
                        {
                            value: data?.other_risk?.detail,
                            disabled: false,
                        },
                    ],
                    options: buildFieldOptions(settings.other_risk_options),
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: 'other_risk_comment',
                    label: translate['other_risk_comment'],
                    param: [
                        {
                            value: data?.other_risk?.mitigation_plan,
                            disabled: false,
                        },
                    ],
                    context: {
                        isMultiline: true,
                        numberOfRows: 3,
                    },
                    numberOfColumns: 6,
                },
            ],
            formData: {},
            formFieldConfig: {
                hideAllCTAs: true,
            },
        };
    },
    getValue(form, data) {
        return {
            ...data,
            ...form.value,
        };
    },
};

const cpTHRiskProfileFormConfig = {
    setup(translate, data, settings) {
        return {
            formFields: [
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'bargaining_power_of_supplier',
                    label: translate['bargaining_power_of_supplier'],
                    param: [{ value: data.bargaining_power_of_supplier, disabled: false }],
                    options: buildFieldOptions(settings.bargaining_power_of_supplier_options),
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'bargaining_power_of_buyer',
                    label: translate['bargaining_power_of_buyer'],
                    param: [{ value: data.bargaining_power_of_buyer, disabled: false }],
                    options: buildFieldOptions(settings.bargaining_power_of_buyer_options),
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'threat_of_new_entrant',
                    label: translate['threat_of_new_entrant'],
                    param: [{ value: data.threat_of_new_entrant, disabled: false }],
                    options: buildFieldOptions(settings.threat_of_new_entrant_options),
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'threat_of_substitution',
                    label: translate['threat_of_substitution'],
                    param: [{ value: data.threat_of_substitution, disabled: false }],
                    options: buildFieldOptions(settings.threat_of_substitution_options),
                },
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'industry_rivalry',
                    label: translate['industry_rivalry'],
                    param: [{ value: data.industry_rivalry, disabled: false }],
                    options: buildFieldOptions(settings.industry_rivalry_options),
                },
            ],
            formData: data,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        };
    },
    getValue(form, data) {
        return {
            ...data,
            ...form.value,
        };
    },
};

const cpTHProviders = [
    {
        provide: CP_MAIN_FORM_CONFIG_TOKEN,
        useValue: cpTHMainFormConfig,
    },
    {
        provide: CP_CUSTOMER_FORM_CONFIG_TOKEN,
        useValue: cpDefaultCustomerFormConfig,
    },
    {
        provide: CP_SUPPLIER_FORM_CONFIG_TOKEN,
        useValue: cpDefaultSupplierFormConfig,
    },
    {
        provide: CP_RISK_ANALYSIS_FORM_CONFIG_TOKEN,
        useValue: cpTHRiskAnalysisFormConfig,
    },
    {
        provide: CP_RISK_PROFILE_FORM_CONFIG_TOKEN,
        useValue: cpTHRiskProfileFormConfig,
    },
    {
        provide: CP_CUSTOMER_GRID_CONFIG_TOKEN,
        useValue: cpDefaultCustomerGridConfig,
    },
    {
        provide: CP_SUPPLIER_GRID_CONFIG_TOKEN,
        useValue: cpDefaultSupplierGridConfig,
    },
    {
        provide: CP_COMPONENT_STORE_TOKEN,
        useClass: CPTHComponentStore,
        deps: [COMPANY_PROFILE_SERVICE_TOKEN],
    },
];

class CompanyProfileDirective {
    constructor(_injector, _viewContainerRef) {
        this._injector = _injector;
        this._viewContainerRef = _viewContainerRef;
        this.id = null;
        this.countryId = null;
        this.applicationId = null;
        this.isReadonly = false;
        this.displaySettings = {
            comment: true,
            profile: true,
            analysis: true,
            grid: true,
            bolt_comment: false,
        };
        this._internationalMapping = {
            [FSWCountryCode.VU]: cpDefaultProviders,
            [FSWCountryCode.TH]: cpTHProviders,
        };
        this._default = cpDefaultProviders;
    }
    ngOnChanges() {
        this._viewContainerRef.clear();
        const providers = this._internationalMapping[this.countryId] || this._default;
        const injector = Injector.create({
            parent: this._injector,
            providers: [
                ...providers,
                {
                    provide: TRANSLOCO_SCOPE,
                    useValue: {
                        scope: 'company-profile',
                        loader: companyProfileLoader,
                    },
                },
                {
                    provide: TRANSLOCO_LANG,
                    useValue: this.countryId?.toLowerCase() || 'default',
                },
                {
                    provide: TranslocoFeatureHttpLoader,
                    useClass: TranslocoFeatureHttpLoader,
                },
            ],
        });
        const ref = this._viewContainerRef.createComponent(CompanyProfileComponent, {
            injector,
        });
        ref.instance.id = this.id;
        ref.instance.applicationId = this.applicationId;
        ref.instance.isReadonly = this.isReadonly;
        ref.instance.displaySettings = this.displaySettings;
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyProfileDirective, deps: [{ token: i0.Injector }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: CompanyProfileDirective, selector: "[fswCompanyProfile]", inputs: { id: "id", countryId: "countryId", applicationId: "applicationId", isReadonly: "isReadonly", displaySettings: "displaySettings" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyProfileDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswCompanyProfile]',
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }, { type: i0.ViewContainerRef }]; }, propDecorators: { id: [{
                type: Input
            }], countryId: [{
                type: Input
            }], applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], displaySettings: [{
                type: Input
            }] } });

const INTERNAL_UI_MODULES$1 = [
    CPMainBlockModule,
    CPRemoveDialogModule,
    CPSaveDialogModule,
    CPGridModule,
];
class CompanyProfileModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyProfileModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CompanyProfileModule, declarations: [CompanyProfileDirective, CompanyProfileComponent], imports: [CommonModule,
            FSWGridModule,
            LetDirective,
            FSWModalModule, CPMainBlockModule,
            CPRemoveDialogModule,
            CPSaveDialogModule,
            CPGridModule, CompanyProfileServiceModule,
            UtilsServiceModule,
            FSWCommentsComponent,
            FSWCommentsItemDirective], exports: [CompanyProfileDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyProfileModule, imports: [CommonModule,
            FSWGridModule,
            FSWModalModule,
            INTERNAL_UI_MODULES$1,
            CompanyProfileServiceModule,
            UtilsServiceModule,
            FSWCommentsComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CompanyProfileModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FSWGridModule,
                        LetDirective,
                        FSWModalModule,
                        INTERNAL_UI_MODULES$1,
                        CompanyProfileServiceModule,
                        UtilsServiceModule,
                        FSWCommentsComponent,
                        FSWCommentsItemDirective,
                    ],
                    declarations: [CompanyProfileDirective, CompanyProfileComponent],
                    exports: [CompanyProfileDirective],
                }]
        }] });

var title$y = "Corporate Guarantor Details";
var empty$e = "Corporate Guarantor Details is empty";
var item$3 = "CG {{index}}";
var fields$q = {
	name: "Company Name",
	registration_no: "UEN",
	incorporation_date: "Incorporation Date",
	negative_blacklist: "Negative / Black List",
	paid_up_capital_currency: "Paid-Up Capital",
	litigation: "Litigation",
	payment_behavior: "Conduct of account",
	num_of_employee: "Number of Employees",
	num_of_customers: "Number of Customers",
	business_nature: "Business Nature",
	ctos_grade: "CTOS Grade",
	ctos_sme_score: "CTOS SME Score",
	num_of_borrowing: "No. of Borrowings",
	total_borrowing_limit: "Total borrowing limit",
	total_borrowing_outstanding: "Total borrowing outstanding",
	total_monthly_commitment: "Total monthly commitment (CCRIS only)",
	num_of_recent_credit_applications: "No. of recent credit applications",
	credit_application_commitment: "Recent Credit Application Commitment",
	outstanding_trade_amount: "Total outstanding amount (Trade Reference)"
};
var comments$4 = {
	factsheet: "Factsheet Comments",
	credit: "Credit Comments"
};
var tabs$2 = {
	summary: "Summary",
	profit_and_loss: "CG Profit & Loss",
	balance_sheet: "CG Balance Sheet",
	bank_statement: "CG Bank Statement"
};
var buttons$N = {
	save: "Save Changes",
	view_docs: "View Docs"
};
var corporateGuarantorMy = {
	title: title$y,
	empty: empty$e,
	item: item$3,
	fields: fields$q,
	comments: comments$4,
	tabs: tabs$2,
	buttons: buttons$N
};

var MY$k = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$N,
    comments: comments$4,
    default: corporateGuarantorMy,
    empty: empty$e,
    fields: fields$q,
    item: item$3,
    tabs: tabs$2,
    title: title$y
});

const CORPORATE_GUARANTOR_MY_TRANSLATION = MY$k;

function injectCorporateGuarantorMYForm({ currencies, isReadonly, }) {
    const form = new UntypedFormGroup({});
    const translation = CORPORATE_GUARANTOR_MY_TRANSLATION;
    const builder = new FSWDynamicBuilder({
        form,
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'flex flex-col gap-[16px]',
        readonlyWhen$: of(isReadonly),
        fields: [
            {
                key: 'id',
                type: FSWDynamicBuilderControlTypes.TEMPLATE,
                customClasses: 'hidden',
                context: {
                    isHidden: true,
                },
            },
            {
                key: 'company',
                formType: FSWDynamicBuilderFormTypes.GROUP,
                renderBy: 'container',
                customClasses: 'w-full flex flex-wrap gap-[16px]',
                containers: [
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.name({
                                control: {
                                    context: {
                                        label: translation.fields.name,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.registration_no({
                                control: {
                                    context: {
                                        label: translation.fields.registration_no,
                                        isDisabled: true,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-[calc(50%-8px)]',
                        fields: [
                            companyGuarantorForm.incorporation_date({
                                control: {
                                    context: {
                                        label: translation.fields.incorporation_date,
                                    },
                                },
                                element: {
                                    customClasses: 'w-full',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-[calc(50%-8px)] flex gap-[4px] items-end',
                        fields: [
                            companyGuarantorForm.paid_up_capital_currency({
                                control: {
                                    context: {
                                        label: translation.fields.paid_up_capital_currency,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[120px]',
                                },
                                pickList: {
                                    currencies,
                                },
                            }),
                            companyGuarantorForm.paid_up_capital({
                                element: {
                                    customClasses: 'w-[calc(100%-124px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.num_of_employee({
                                control: {
                                    context: {
                                        label: translation.fields.num_of_employee,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.num_of_customers({
                                control: {
                                    context: {
                                        label: translation.fields.num_of_customers,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.litigation({
                                control: {
                                    context: {
                                        label: translation.fields.litigation,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.business_nature({
                                control: {
                                    context: {
                                        label: translation.fields.business_nature,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.negative_blacklist({
                                control: {
                                    context: {
                                        label: translation.fields.negative_blacklist,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.payment_behavior({
                                control: {
                                    context: {
                                        label: translation.fields.payment_behavior,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.ctos_grade({
                                control: {
                                    context: {
                                        label: translation.fields.ctos_grade,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.ctos_sme_score({
                                control: {
                                    context: {
                                        label: translation.fields.ctos_sme_score,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.num_of_borrowing({
                                control: {
                                    context: {
                                        label: translation.fields.num_of_borrowing,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.total_borrowing_limit({
                                control: {
                                    context: {
                                        label: translation.fields.total_borrowing_limit,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.total_borrowing_outstanding({
                                control: {
                                    context: {
                                        label: translation.fields.total_borrowing_outstanding,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.total_monthly_commitment({
                                control: {
                                    context: {
                                        label: translation.fields.total_monthly_commitment,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.num_of_recent_credit_applications({
                                control: {
                                    context: {
                                        label: translation.fields.num_of_recent_credit_applications,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.credit_application_commitment({
                                control: {
                                    context: {
                                        label: translation.fields.credit_application_commitment,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.outstanding_trade_amount({
                                control: {
                                    context: {
                                        label: translation.fields.outstanding_trade_amount,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.id({
                                control: {
                                    context: {
                                        isHidden: true,
                                    },
                                },
                            }),
                        ],
                    },
                ],
            },
        ],
    });
    return { builder, form };
}

function injectCorporateGuarantorMYEffects({ applicationIdSignal, isReadonlySignal, hiddenCommentsSignal, memberSignal, itemsSignal, summariesSignal, currenciesSignal, formArray, }) {
    const alertService = inject(FSW_ALERT_SERVICE_TOKEN);
    const application = {
        guarantorService: injectApplicationGuarantorService(),
        memberService: injectApplicationMemberService(),
    };
    const credit = {
        guarantorService: injectCreditGuarantorService(),
    };
    const memberService = injectMemberService();
    const loadMember = (applicationId) => application.memberService
        .getApplicationMainBorrower(applicationId)
        .pipe(tap((data) => memberSignal.set(data)), catchError(() => {
        alertService.error('Failed to load member', null, {
            duration: 3000,
        });
        memberSignal.set(null);
        return of(null);
    }))
        .subscribe();
    const loadSummaries = (applicationId, member) => application.guarantorService
        .getSummaries(applicationId)
        .pipe(map((summaries) => summaries
        ? summaries
            .filter((summary) => summary.guarantor_summary_type === FSWRecourseTypes.CG)
            .map((item) => item.guarantor_summary_id)
        : []), switchMap$1((ids) => {
        if (ids.length) {
            return credit.guarantorService.getCorporateSummaries(ids);
        }
        return of([]);
    }), tap((data) => summariesSignal.set(data)), catchError(() => {
        alertService.error('Failed to load summaries', null, {
            duration: 3000,
        });
        summariesSignal.set([]);
        return of([]);
    }))
        .subscribe();
    const refreshMember = () => {
        const applicationId = applicationIdSignal();
        if (!applicationId) {
            return;
        }
        loadMember(applicationId);
    };
    const refreshSummaries = () => {
        const applicationId = applicationIdSignal();
        const member = memberSignal();
        if (!applicationId || !member) {
            return;
        }
        loadSummaries(applicationId, member);
    };
    const buildComments = () => {
        return [
            {
                title: '',
                customClasses: 'w-full flex flex-col gap-4',
                items: [
                    {
                        category: 'FACTSHEET',
                        title: 'comments.factsheet',
                        module: 'CG_SUMMARY',
                        identifier: 'CG_SUMMARY',
                        entityId: applicationIdSignal(),
                        fields: [
                            {
                                key: 'main_comment',
                                label: 'comments.factsheet',
                            },
                        ],
                    },
                    {
                        category: 'CREDIT',
                        title: 'comments.credit',
                        module: 'CG_SUMMARY',
                        identifier: 'CG_SUMMARY',
                        entityId: applicationIdSignal(),
                        fields: [
                            {
                                key: 'main_comment',
                                label: 'comments.credit',
                            },
                        ],
                    },
                ].filter((item) => !hiddenCommentsSignal().includes(item.category)),
            },
        ];
    };
    return {
        init: () => {
            effect(() => refreshMember(), { allowSignalWrites: true });
            effect(() => refreshSummaries(), { allowSignalWrites: true });
            effect(() => {
                const summaries = summariesSignal();
                formArray.clear();
                itemsSignal.set(summaries.map((item) => {
                    const { builder, form } = injectCorporateGuarantorMYForm({
                        isReadonly: isReadonlySignal(),
                        currencies: currenciesSignal(),
                    });
                    form.patchValue(item);
                    formArray.push(form);
                    return { builder, comments: buildComments() };
                }));
            }, { allowSignalWrites: true });
        },
        save: () => {
            if (formArray.invalid || formArray.getRawValue().length === 0) {
                return;
            }
            const payload = formArray.getRawValue();
            const { putList, postList } = payload.reduce((acc, item) => {
                if (item.id) {
                    acc.putList.push(transformCompanyGuarantor(item));
                }
                else {
                    acc.postList.push(transformCompanyGuarantor(item));
                }
                return acc;
            }, {
                putList: [],
                postList: [],
            });
            const member = memberSignal();
            forkJoin([
                ...(putList.length ? [credit.guarantorService.updateCorporateSummaries(putList)] : []),
                ...(postList.length
                    ? [
                        memberService
                            .getBips(getEntityNoFallBackToUEN(member.company_ctos_entity, member.company_registration_number))
                            .pipe(switchMap$1((bips) => zip(...postList.map((item) => credit.guarantorService
                            .addCorporateSummaries([{ company: item }])
                            .pipe(map((data) => ({
                            guarantor_summary_id: data[0].id,
                            guarantor_summary_type: FSWRecourseTypes.CG,
                            business_interest_party_id: bips.find((bip) => bip.idNumber ===
                                item.company
                                    .registration_no)?.id,
                        })))))), switchMap$1((data) => application.guarantorService.addSummaries(applicationIdSignal(), data))),
                    ]
                    : []),
            ])
                .pipe(tapResponse(() => {
                alertService.success('Success', 'Corporate Guarantor successfully saved!', {
                    duration: 3000,
                });
                loadSummaries(applicationIdSignal(), memberSignal());
            }, () => {
                alertService.error('Error', 'Failed to save corporate guarantor', {
                    duration: 3000,
                });
            }))
                .subscribe();
        },
    };
}

var title$x = "Corporate Guarantor Details";
var empty$d = "Corporate Guarantor Details is empty";
var item$2 = "CG {{index}}";
var fields$p = {
	name: "Company Name",
	registration_no: "UEN",
	incorporation_date: "Incorporation Date",
	negative_blacklist: "Negative / Black List",
	paid_up_capital_currency: "Paid-Up Capital",
	litigation: "Litigation",
	payment_behavior: "Payment Behavior",
	num_of_employee: "Number of Employees",
	business_nature: "Business Nature",
	details_of_charges: "Details of Charges",
	experian_payment_grade: "Experian Payment Grade",
	experian_expected_default: "Experian Default Probability",
	num_of_searches: "Number of Searches",
	avg_num_of_days_to_pay_creditors: "Average Number of Days to Pay Creditors"
};
var comments$3 = {
	factsheet: "Factsheet Comments",
	credit: "Credit Comments"
};
var tabs$1 = {
	summary: "Summary",
	profit_and_loss: "CG Profit & Loss",
	balance_sheet: "CG Balance Sheet",
	bank_statement: "CG Bank Statement"
};
var buttons$M = {
	save: "Save Changes",
	view_docs: "View Docs"
};
var corporateGuarantorSg = {
	title: title$x,
	empty: empty$d,
	item: item$2,
	fields: fields$p,
	comments: comments$3,
	tabs: tabs$1,
	buttons: buttons$M
};

var SG$6 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$M,
    comments: comments$3,
    default: corporateGuarantorSg,
    empty: empty$d,
    fields: fields$p,
    item: item$2,
    tabs: tabs$1,
    title: title$x
});

const CORPORATE_GUARANTOR_SG_TRANSLATION = SG$6;

function injectCorporateGuarantorSGForm({ currencies, isReadonly, }) {
    const form = new UntypedFormGroup({});
    const translation = CORPORATE_GUARANTOR_SG_TRANSLATION;
    const builder = new FSWDynamicBuilder({
        form,
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'flex flex-col gap-[16px]',
        readonlyWhen$: of(isReadonly),
        fields: [
            {
                key: 'id',
                type: FSWDynamicBuilderControlTypes.TEMPLATE,
                customClasses: 'hidden',
                context: {
                    isHidden: true,
                },
            },
            {
                key: 'company',
                formType: FSWDynamicBuilderFormTypes.GROUP,
                renderBy: 'container',
                customClasses: 'w-full flex flex-wrap gap-[16px]',
                containers: [
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.name({
                                control: {
                                    context: {
                                        label: translation.fields.name,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.registration_no({
                                control: {
                                    context: {
                                        label: translation.fields.registration_no,
                                        isDisabled: true,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-[calc(50%-8px)]',
                        fields: [
                            companyGuarantorForm.incorporation_date({
                                control: {
                                    context: {
                                        label: translation.fields.incorporation_date,
                                    },
                                },
                                element: {
                                    customClasses: 'w-full',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-[calc(50%-8px)] flex gap-[4px] items-end',
                        fields: [
                            companyGuarantorForm.paid_up_capital_currency({
                                control: {
                                    context: {
                                        label: translation.fields.paid_up_capital_currency,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[120px]',
                                },
                                pickList: {
                                    currencies,
                                },
                            }),
                            companyGuarantorForm.paid_up_capital({
                                element: {
                                    customClasses: 'w-[calc(100%-124px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.num_of_employee({
                                control: {
                                    context: {
                                        label: translation.fields.num_of_employee,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.details_of_charges({
                                control: {
                                    context: {
                                        label: translation.fields.details_of_charges,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.litigation({
                                control: {
                                    context: {
                                        label: translation.fields.litigation,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.business_nature({
                                control: {
                                    context: {
                                        label: translation.fields.business_nature,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.negative_blacklist({
                                control: {
                                    context: {
                                        label: translation.fields.negative_blacklist,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.payment_behavior({
                                control: {
                                    context: {
                                        label: translation.fields.payment_behavior,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.experian_payment_grade({
                                control: {
                                    context: {
                                        label: translation.fields.experian_payment_grade,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.experian_expected_default({
                                control: {
                                    context: {
                                        label: translation.fields.experian_expected_default,
                                        isDisabled: true,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.num_of_searches({
                                control: {
                                    context: {
                                        label: translation.fields.num_of_searches,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                            companyGuarantorForm.avg_num_of_days_to_pay_creditors({
                                control: {
                                    context: {
                                        label: translation.fields.avg_num_of_days_to_pay_creditors,
                                    },
                                },
                                element: {
                                    customClasses: 'w-[calc(50%-8px)]',
                                },
                            }),
                        ],
                    },
                    {
                        customClasses: 'w-full flex gap-[16px]',
                        fields: [
                            companyGuarantorForm.id({
                                control: {
                                    context: {
                                        isHidden: true,
                                    },
                                },
                            }),
                        ],
                    },
                ],
            },
        ],
    });
    return { builder, form };
}

function injectCorporateGuarantorSGEffects({ applicationIdSignal, isReadonlySignal, hiddenCommentsSignal, memberSignal, itemsSignal, summariesSignal, currenciesSignal, viewerDocsSignal, formArray, }) {
    const alertService = inject(FSW_ALERT_SERVICE_TOKEN);
    const blobService = injectBlobService();
    const domSanitizer = inject(DomSanitizer);
    const application = {
        guarantorService: injectApplicationGuarantorService(),
        memberService: injectApplicationMemberService(),
    };
    const credit = {
        guarantorService: injectCreditGuarantorService(),
        borrowerSummaryService: injectCreditBorrowerSummaryService(),
    };
    const memberService = injectMemberService();
    const loadMember = (applicationId) => application.memberService
        .getApplicationMainBorrower(applicationId)
        .pipe(tap((data) => memberSignal.set(data)), catchError(() => {
        alertService.error('Failed to load member', null, {
            duration: 3000,
        });
        memberSignal.set(null);
        return of(null);
    }))
        .subscribe();
    const loadSummaries = (applicationId) => application.guarantorService
        .getSummaries(applicationId)
        .pipe(map((summaries) => summaries
        ? summaries
            .filter((summary) => summary.guarantor_summary_type === FSWRecourseTypes.CG)
            .map((item) => item.guarantor_summary_id)
        : []), switchMap$1((ids) => {
        if (ids.length) {
            return credit.guarantorService.getCorporateSummaries(ids);
        }
        return of([]);
    }), tap((data) => summariesSignal.set(data)), catchError(() => {
        alertService.error('Failed to load summaries', null, {
            duration: 3000,
        });
        summariesSignal.set([]);
        return of([]);
    }))
        .subscribe();
    const loadViewerDocs = (applicationId) => blobService
        .getApplicationMemberDoc(applicationId, ['BRC'])
        .pipe(filter((docs) => !!docs?.length), switchMap$1((docs) => forkJoin(docs.map((doc) => blobService.downloadV3Blob(doc.uuid).pipe(map((blob) => domSanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob))), map((src) => src
        ? {
            id: doc.uuid,
            name: doc.name,
            type: doc.docType,
            src,
        }
        : null)))).pipe(map((docs) => docs.filter((doc) => !!doc)), map((docs) => docs.reduce((acc, doc) => {
        const index = acc.findIndex((item) => item.type === doc.type);
        const viewerDoc = omit(doc, 'type');
        if (index === -1) {
            acc.push({
                type: doc.type,
                items: [viewerDoc],
            });
        }
        else {
            acc[index].items.push(viewerDoc);
        }
        return acc;
    }, [])), tapResponse((docs) => viewerDocsSignal.set(docs), () => {
        viewerDocsSignal.set([]);
        alertService.error('Error', 'Failed to load documents', {
            duration: 3000,
        });
    }))))
        .subscribe();
    const refreshMember = () => {
        const applicationId = applicationIdSignal();
        if (!applicationId) {
            return;
        }
        loadMember(applicationId);
    };
    const refreshSummaries = () => {
        const applicationId = applicationIdSignal();
        if (!applicationId) {
            return;
        }
        loadSummaries(applicationId);
    };
    const refreshViewerDocs = () => {
        const applicationId = applicationIdSignal();
        const summaries = summariesSignal();
        if (!applicationId || !summaries?.length) {
            return;
        }
        loadViewerDocs(applicationId);
    };
    const buildComments = () => {
        return [
            {
                title: '',
                customClasses: 'w-full flex flex-col gap-4',
                items: [
                    {
                        category: 'FACTSHEET',
                        title: 'comments.factsheet',
                        module: 'CG_SUMMARY',
                        identifier: 'CG_SUMMARY',
                        entityId: applicationIdSignal(),
                        fields: [
                            {
                                key: 'main_comment',
                                label: 'comments.factsheet',
                            },
                        ],
                    },
                    {
                        category: 'CREDIT',
                        title: 'comments.credit',
                        module: 'CG_SUMMARY',
                        identifier: 'CG_SUMMARY',
                        entityId: applicationIdSignal(),
                        fields: [
                            {
                                key: 'main_comment',
                                label: 'comments.credit',
                            },
                        ],
                    },
                ].filter((item) => !hiddenCommentsSignal().includes(item.category)),
            },
        ];
    };
    return {
        init: () => {
            effect(() => refreshMember(), { allowSignalWrites: true });
            effect(() => refreshSummaries(), { allowSignalWrites: true });
            effect(() => refreshViewerDocs(), { allowSignalWrites: true });
            effect(() => {
                const summaries = summariesSignal();
                formArray.clear();
                itemsSignal.set(summaries.map((item) => {
                    const { builder, form } = injectCorporateGuarantorSGForm({
                        isReadonly: isReadonlySignal(),
                        currencies: currenciesSignal(),
                    });
                    form.patchValue(item);
                    formArray.push(form);
                    return { builder, comments: buildComments() };
                }));
            }, { allowSignalWrites: true });
        },
        save: () => {
            if (formArray.invalid || formArray.getRawValue().length === 0) {
                return;
            }
            const payload = formArray.getRawValue();
            const { putList, postList } = payload.reduce((acc, item) => {
                if (item.id) {
                    acc.putList.push(transformCompanyGuarantor(item));
                }
                else {
                    acc.postList.push(transformCompanyGuarantor(item));
                }
                return acc;
            }, {
                putList: [],
                postList: [],
            });
            forkJoin([
                ...(putList.length ? [credit.guarantorService.updateCorporateSummaries(putList)] : []),
                ...(postList.length
                    ? [
                        memberService.getBips(memberSignal().company_registration_number).pipe(switchMap$1((bips) => zip(...postList.map((item) => credit.guarantorService.addCorporateSummaries([item]).pipe(map((data) => ({
                            guarantor_summary_id: data[0].id,
                            guarantor_summary_type: FSWRecourseTypes.CG,
                            business_interest_party_id: bips.find((bip) => bip.idNumber ===
                                item.company
                                    .registration_no)?.id,
                        })))))), switchMap$1((data) => application.guarantorService.addSummaries(applicationIdSignal(), data))),
                    ]
                    : []),
            ])
                .pipe(tapResponse(() => {
                alertService.success('Success', 'Corporate Guarantor successfully saved!', {
                    duration: 3000,
                });
                loadSummaries(applicationIdSignal());
            }, () => {
                alertService.error('Error', 'Failed to save corporate guarantor', {
                    duration: 3000,
                });
            }))
                .subscribe();
        },
    };
}

function injectCorporateGuarantorEffects(config) {
    switch (getCountryCodeFromStorage()) {
        case CountryCode.SG:
            return injectCorporateGuarantorSGEffects(config);
        default:
            return injectCorporateGuarantorMYEffects(config);
    }
}

function provideCorporateGuarantorTranslation(scope = 'corporate_guarantor') {
    return [
        ...(FSWTranslateModule.forFeature({
            scope,
            defaultKey: getCountryCodeFromStorage() ?? CountryCode.MY,
            data: {
                [CountryCode.MY]: CORPORATE_GUARANTOR_MY_TRANSLATION,
                [CountryCode.SG]: CORPORATE_GUARANTOR_SG_TRANSLATION,
            },
        }).providers || []),
        fswTranslateScope(scope),
    ];
}

class FSWCorporateGuarantorComponent {
    constructor() {
        this.applicationIdSignal = signal('');
        this.currenciesSignal = signal([]);
        this.isReadonlySignal = signal(false);
        this.hiddenCommentsSignal = signal([]);
        this.memberSignal = signal(null);
        this.itemsSignal = signal([]);
        this.summariesSignal = signal([]);
        this.viewerDocsSignal = signal([]);
        this.toggleSignal = signal({});
        this.destroyDocViewerWhen$ = new Subject();
        this.formArray = new UntypedFormArray([]);
        this.injector = inject(Injector);
        this.docViewerService = injectFSWDocViewerService();
        this.effects = injectCorporateGuarantorEffects({
            applicationIdSignal: this.applicationIdSignal,
            currenciesSignal: this.currenciesSignal,
            isReadonlySignal: this.isReadonlySignal,
            hiddenCommentsSignal: this.hiddenCommentsSignal,
            memberSignal: this.memberSignal,
            itemsSignal: this.itemsSignal,
            summariesSignal: this.summariesSignal,
            viewerDocsSignal: this.viewerDocsSignal,
            formArray: this.formArray,
            injector: this.injector,
        });
        this.arrayValueChanges$ = this.formArray.valueChanges.pipe(startWith(this.formArray.value));
        this.arrayValueChangeSignal = toSignal(this.arrayValueChanges$);
        this.arrayInvalidSignal = computed(() => this.arrayValueChangeSignal() && this.formArray.controls.some((control) => control.invalid));
        this.validViewerDocsSignal = computed(() => {
            const docs = this.viewerDocsSignal();
            return (docs || []).filter((doc) => doc.items.filter((item) => item.src && item.id && item.name).length > 0);
        });
        this.effects.init();
    }
    ngOnDestroy() {
        this.destroyDocViewerWhen$.next(new Date());
        this.destroyDocViewerWhen$.complete();
    }
    save() {
        this.effects.save();
    }
    toggle(index) {
        this.toggleSignal.set({
            ...this.toggleSignal(),
            [index]: !this.toggleSignal()[index],
        });
    }
    showDocViewer() {
        if (!this.validViewerDocsSignal().length)
            return;
        this.docViewerService.open({
            groups: this.validViewerDocsSignal(),
        }, this.destroyDocViewerWhen$);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCorporateGuarantorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCorporateGuarantorComponent, isStandalone: true, selector: "fsw-corporate-guarantor", providers: [
            provideCorporateGuarantorTranslation(),
            provideUtilsService(),
            provideApplicationGuarantorService(),
            provideCreditGuarantorService(),
            provideApplicationMemberService(),
            provideCreditBorrowerSummaryService(),
            provideMemberService(),
            provideBlobService(),
        ], ngImport: i0, template: "<fsw-panel [title]=\"'title' | fswTranslate\" [customClasses]=\"'flex w-[900px]'\">\n  <ng-template fswPanelHeaderSuffix>\n    <aside class=\"flex items-center gap-[12px]\">\n      <button\n        fswButton\n        [appearance]=\"'secondary-elevate'\"\n        (click)=\"showDocViewer()\"\n        *ngIf=\"validViewerDocsSignal().length\"\n      >\n        {{ 'buttons.view_docs' | fswTranslate }}\n      </button>\n      <button\n        fswButton\n        *ngIf=\"!isReadonlySignal() && itemsSignal().length\"\n        [disabled]=\"arrayInvalidSignal()\"\n        (click)=\"save()\"\n      >\n        {{ 'buttons.save' | fswTranslate }}\n      </button>\n    </aside>\n  </ng-template>\n  <section class=\"w-full flex flex-col gap-[16px]\">\n    <ng-container *ngFor=\"let item of itemsSignal(); let i = index\">\n      <fsw-panel\n        [title]=\"\n          item.builder.groupConfig.form.getRawValue()['company'].name ??\n          ('item' | fswTranslate : { data: { index: (i + 1).toString() } })\n        \"\n        customClasses=\"flex w-full\"\n      >\n        <ng-template fswPanelHeaderSuffix>\n          <i\n            fswIcon=\"common-arrow-down\"\n            [class.rotate-180]=\"!toggleSignal()[i]\"\n            class=\"text-[#2c50ff] duration-150\"\n            (click)=\"toggle(i)\"\n          ></i>\n        </ng-template>\n        <section class=\"w-full flex flex-col gap-[16px]\" [class.!hidden]=\"toggleSignal()[i]\">\n          <form [formGroup]=\"item.builder.groupConfig.form\">\n            <fsw-dynamic-builder [builder]=\"item.builder\"></fsw-dynamic-builder>\n          </form>\n          <ng-container *ngIf=\"item.builder.groupConfig.form.value.id\">\n            <fsw-comments-section\n              [enableSaveButton]=\"true\"\n              [isReadonly]=\"isReadonlySignal()\"\n              [translateScope]=\"'corporate_guarantor'\"\n              [data]=\"item.comments\"\n            ></fsw-comments-section>\n          </ng-container>\n        </section>\n      </fsw-panel>\n    </ng-container>\n    <ng-container *ngIf=\"!itemsSignal().length\">\n      <section class=\"w-full h-[200px] flex items-center justify-center px-16\">\n        <p class=\"text-center text-body-small-600 font-bold text-yellow-500\">\n          {{ 'empty' | fswTranslate }}\n        </p>\n      </section>\n    </ng-container>\n  </section>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWAlertModule }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: FSWDynamicBuilderModule }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "component", type: FSWCommentsSectionComponent, selector: "fsw-comments-section", inputs: ["data", "customClasses", "translateScope", "isReadonly", "enableSaveButton"] }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "ngmodule", type: FSWDocViewerModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCorporateGuarantorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-corporate-guarantor', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [
                        FSWAlertModule,
                        FSWPanelModule,
                        FSWTranslateModule,
                        FSWButtonModule,
                        NgIf,
                        NgForOf,
                        ReactiveFormsModule,
                        FSWDynamicBuilderModule,
                        FSWCommentsSectionComponent,
                        FSWIconModule,
                        FSWDocViewerModule,
                    ], providers: [
                        provideCorporateGuarantorTranslation(),
                        provideUtilsService(),
                        provideApplicationGuarantorService(),
                        provideCreditGuarantorService(),
                        provideApplicationMemberService(),
                        provideCreditBorrowerSummaryService(),
                        provideMemberService(),
                        provideBlobService(),
                    ], template: "<fsw-panel [title]=\"'title' | fswTranslate\" [customClasses]=\"'flex w-[900px]'\">\n  <ng-template fswPanelHeaderSuffix>\n    <aside class=\"flex items-center gap-[12px]\">\n      <button\n        fswButton\n        [appearance]=\"'secondary-elevate'\"\n        (click)=\"showDocViewer()\"\n        *ngIf=\"validViewerDocsSignal().length\"\n      >\n        {{ 'buttons.view_docs' | fswTranslate }}\n      </button>\n      <button\n        fswButton\n        *ngIf=\"!isReadonlySignal() && itemsSignal().length\"\n        [disabled]=\"arrayInvalidSignal()\"\n        (click)=\"save()\"\n      >\n        {{ 'buttons.save' | fswTranslate }}\n      </button>\n    </aside>\n  </ng-template>\n  <section class=\"w-full flex flex-col gap-[16px]\">\n    <ng-container *ngFor=\"let item of itemsSignal(); let i = index\">\n      <fsw-panel\n        [title]=\"\n          item.builder.groupConfig.form.getRawValue()['company'].name ??\n          ('item' | fswTranslate : { data: { index: (i + 1).toString() } })\n        \"\n        customClasses=\"flex w-full\"\n      >\n        <ng-template fswPanelHeaderSuffix>\n          <i\n            fswIcon=\"common-arrow-down\"\n            [class.rotate-180]=\"!toggleSignal()[i]\"\n            class=\"text-[#2c50ff] duration-150\"\n            (click)=\"toggle(i)\"\n          ></i>\n        </ng-template>\n        <section class=\"w-full flex flex-col gap-[16px]\" [class.!hidden]=\"toggleSignal()[i]\">\n          <form [formGroup]=\"item.builder.groupConfig.form\">\n            <fsw-dynamic-builder [builder]=\"item.builder\"></fsw-dynamic-builder>\n          </form>\n          <ng-container *ngIf=\"item.builder.groupConfig.form.value.id\">\n            <fsw-comments-section\n              [enableSaveButton]=\"true\"\n              [isReadonly]=\"isReadonlySignal()\"\n              [translateScope]=\"'corporate_guarantor'\"\n              [data]=\"item.comments\"\n            ></fsw-comments-section>\n          </ng-container>\n        </section>\n      </fsw-panel>\n    </ng-container>\n    <ng-container *ngIf=\"!itemsSignal().length\">\n      <section class=\"w-full h-[200px] flex items-center justify-center px-16\">\n        <p class=\"text-center text-body-small-600 font-bold text-yellow-500\">\n          {{ 'empty' | fswTranslate }}\n        </p>\n      </section>\n    </ng-container>\n  </section>\n</fsw-panel>\n" }]
        }], ctorParameters: function () { return []; } });

class FSWCorporateGuarantorDirective {
    constructor() {
        this.applicationId = null;
        this.isReadonly = false;
        this.hiddenComments = [];
        this.viewContainerRef = inject(ViewContainerRef);
        this.masterDataService = injectMasterDataService();
        this.currenciesSignal = signal([]);
        this.firstLoad = false;
    }
    ngOnInit() {
        this.masterDataService
            .getCurrencies()
            .pipe(tap((currencies) => {
            this.currenciesSignal.set(currencies);
            this.firstLoad = true;
            this.render();
        }))
            .subscribe();
    }
    ngOnChanges() {
        this.render();
    }
    ngOnDestroy() {
        this.viewContainerRef.clear();
    }
    render() {
        this.viewContainerRef.clear();
        if (!this.applicationId || !this.firstLoad) {
            return;
        }
        const ref = this.viewContainerRef.createComponent(FSWCorporateGuarantorComponent);
        const instance = ref.instance;
        instance.applicationIdSignal.set(this.applicationId);
        instance.isReadonlySignal.set(this.isReadonly);
        instance.currenciesSignal.set(this.currenciesSignal() || []);
        instance.hiddenCommentsSignal.set(this.hiddenComments);
        ref.changeDetectorRef.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCorporateGuarantorDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWCorporateGuarantorDirective, isStandalone: true, selector: "[fswCorporateGuarantor]", inputs: { applicationId: "applicationId", isReadonly: "isReadonly", hiddenComments: "hiddenComments" }, providers: [provideUtilsService(), provideMasterDataService()], usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCorporateGuarantorDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswCorporateGuarantor]',
                    standalone: true,
                    providers: [provideUtilsService(), provideMasterDataService()],
                }]
        }], propDecorators: { applicationId: [{
                type: Input,
                args: [{ required: true }]
            }], isReadonly: [{
                type: Input
            }], hiddenComments: [{
                type: Input
            }] } });

class FSWCreditApproversCandidateComponent {
    constructor(_cdr) {
        this._cdr = _cdr;
        this.selection = new EventEmitter();
        this.data = null;
        this.isReadonly = false;
        this.candidate = null;
        this.validation = 'valid';
        this.control = new FormControl([]);
        this.checkChange();
        this.control.valueChanges.pipe(tap(() => this.checkChange())).subscribe();
    }
    ngOnChanges() {
        if (!this.data) {
            this.candidate = null;
            this.checkChange();
            this._cdr.markForCheck();
            return;
        }
        this.candidate = {
            selection: this.data.selection,
            label: this.data.label,
            candidates: this.data.candidates.split(','),
        };
        this.checkChange();
        this._cdr.markForCheck();
    }
    checkChange() {
        this.validation = 'valid';
        this.selection.emit(this.control.value || []);
        if (!this.control.value || !this.candidate) {
            this._cdr.markForCheck();
            return;
        }
        if (this.control.value.length < this.candidate.selection) {
            this.validation = 'min';
        }
        if (this.control.value.length > this.candidate.selection) {
            this.validation = 'max';
        }
        this._cdr.markForCheck();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCreditApproversCandidateComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCreditApproversCandidateComponent, selector: "fsw-credit-approvers-candidate", inputs: { data: "data", isReadonly: "isReadonly" }, outputs: { selection: "selection" }, usesOnChanges: true, ngImport: i0, template: "<section class=\"credit-approvers-candidate\">\n  <header>\n    <h6 class=\"h6\">{{ candidate?.label }}</h6>\n  </header>\n  <main>\n    <fsw-checkbox-group [formControl]=\"control\">\n      <ng-container *ngFor=\"let candidate of candidate?.candidates || []\">\n        <fsw-checkbox [label]=\"candidate\" [data]=\"candidate\"></fsw-checkbox>\n      </ng-container>\n    </fsw-checkbox-group>\n  </main>\n  <footer *ngIf=\"validation !== 'valid'\">\n    <span class=\"b-default-600\">{{\n      validation | fswTranslate : { data: { count: (candidate?.selection || 0).toString() } }\n    }}</span>\n  </footer>\n</section>\n", styles: [":host .credit-approvers-candidate{display:flex;flex-direction:column;gap:8px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$4.FSWCheckboxGroupComponent, selector: "fsw-checkbox-group" }, { kind: "component", type: i1$4.FSWCheckboxComponent, selector: "fsw-checkbox" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCreditApproversCandidateComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-credit-approvers-candidate', changeDetection: ChangeDetectionStrategy.OnPush, template: "<section class=\"credit-approvers-candidate\">\n  <header>\n    <h6 class=\"h6\">{{ candidate?.label }}</h6>\n  </header>\n  <main>\n    <fsw-checkbox-group [formControl]=\"control\">\n      <ng-container *ngFor=\"let candidate of candidate?.candidates || []\">\n        <fsw-checkbox [label]=\"candidate\" [data]=\"candidate\"></fsw-checkbox>\n      </ng-container>\n    </fsw-checkbox-group>\n  </main>\n  <footer *ngIf=\"validation !== 'valid'\">\n    <span class=\"b-default-600\">{{\n      validation | fswTranslate : { data: { count: (candidate?.selection || 0).toString() } }\n    }}</span>\n  </footer>\n</section>\n", styles: [":host .credit-approvers-candidate{display:flex;flex-direction:column;gap:8px}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { selection: [{
                type: Output
            }], data: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

let FSWApproversSelectionMyDfComponent = class FSWApproversSelectionMyDfComponent {
    set data(value) {
        this._data = value;
    }
    get data() {
        return this._data || [];
    }
    get selectedItems() {
        return Object.keys(this.selectedItemMap).reduce((acc, cur) => acc.concat(this.selectedItemMap[cur]), []);
    }
    constructor(_cdr) {
        this._cdr = _cdr;
        this.selected = new EventEmitter();
        this._data = null;
        this.isReadonly = false;
        this.control = new FormControl(null);
        this.options = [];
        this.selectedItemMap = {};
        this._destroy$ = new Subject();
    }
    ngOnInit() {
        this.control.valueChanges
            .pipe(followDestroy(this), tap(() => {
            this.selectedItemMap = {};
            this._cdr.markForCheck();
            this.selected.emit(this.selectedItemMap);
        }))
            .subscribe();
    }
    ngOnChanges() {
        if (!this.data) {
            this.options = [];
            this.control.reset();
            this._cdr.markForCheck();
            return;
        }
        this.options = this.data.map((item) => ({
            value: item.values,
            text: item.name,
        }));
        this._cdr.markForCheck();
    }
    select(name, values) {
        this.selectedItemMap[name] = values;
        this.selected.emit(this.selectedItemMap);
        this._cdr.markForCheck();
    }
    ngOnDestroy() {
        if (this._destroy$) {
            this._destroy$.next();
            this._destroy$.complete();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWApproversSelectionMyDfComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWApproversSelectionMyDfComponent, selector: "fsw-approvers-selection-my-df", inputs: { data: "data", isReadonly: "isReadonly" }, outputs: { selected: "selected" }, providers: [fswTranslateScope('approvers-selection-my-df')], usesOnChanges: true, ngImport: i0, template: `
    <section class="credit-approvers" style="width: 750px">
      <div class="credit-approvers__selection">
        <fsw-field>
          <ng-template fswFieldHeaderPrefix [label]="'title' | fswTranslate"></ng-template>
          <fsw-select
            [formControl]="control"
            [placeHolder]="'title' | fswTranslate"
            [disabled]="isReadonly"
          >
            <ng-container *ngFor="let option of options">
              <ng-template
                fswSelectItem
                [text]="option.text || 'N/A'"
                [value]="option.value"
              ></ng-template>
            </ng-container>
          </fsw-select>
        </fsw-field>
        <p class="b-default-500">
          <ng-container *ngFor="let item of selectedItems">
            <span>{{ item }}</span>
            <br />
          </ng-container>
        </p>
      </div>
      <ng-container *ngIf="control.value as candidates">
        <div class="credit-approvers__candidates">
          <ng-container *ngFor="let candidate of candidates">
            <fsw-credit-approvers-candidate
              [data]="candidate"
              [isReadonly]="isReadonly"
              (selection)="select(candidate.label, $event)"
            ></fsw-credit-approvers-candidate>
          </ng-container>
        </div>
      </ng-container>
    </section>
  `, isInline: true, styles: [":host .credit-approvers{padding:16px;display:flex;flex-wrap:wrap;justify-content:space-between;gap:16px}:host .credit-approvers__selection{display:flex;flex-direction:column;gap:8px}:host .credit-approvers__candidates{padding:16px;border-radius:8px;box-shadow:var(--fsw-shadow-small);display:flex;flex-direction:column;gap:8px}table{width:100%;border-collapse:collapse}table th,table td{padding:10px;text-align:left;border-bottom:1px solid #ddd;border-top:1px solid #ddd;font-size:90%}table th:first-child,table td:first-child{border-left:1px solid #ddd}table th:last-child,table td:last-child{border-right:1px solid #ddd}table th.numeric-value,table td.numeric-value{text-align:right}table th input[type=text],table td input[type=text]{border:1px solid #ddd;border-radius:5px;padding:5px;width:100%;font-size:90%}table th{font-weight:700;font-weight:500}table td{font-size:80%}.summary-table .cdk-header-cell{width:4%}.summary-table tr.sub-header{background-color:#f9f9f9;font-weight:500}.summary-table tr:hover{background-color:#e6e6e6}.summary-table .column-header:not(:first-child){text-align:right}.summary-table tr.total{background-color:#f3f5fd}.override-table th.cdk-column-Date,.override-table td.cdk-column-Date,.override-table th.cdk-column-Credit-Manager,.override-table td.cdk-column-Credit-Manager{width:15%}.override-table th.cdk-column-Justification,.override-table td.cdk-column-Justification{width:70%}.cdk-column-Credit-Approver,.cdk-column-Decision,.cdk-column-Date{width:20%}.cdk-column-Comments{white-space:normal}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$4.FSWFieldHeaderPrefixDirective, selector: "ng-template[fswFieldHeaderPrefix]", inputs: ["kind", "label", "required"] }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "component", type: FSWCreditApproversCandidateComponent, selector: "fsw-credit-approvers-candidate", inputs: ["data", "isReadonly"], outputs: ["selection"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }] }); }
};
FSWApproversSelectionMyDfComponent = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [ChangeDetectorRef])
], FSWApproversSelectionMyDfComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWApproversSelectionMyDfComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-approvers-selection-my-df', template: `
    <section class="credit-approvers" style="width: 750px">
      <div class="credit-approvers__selection">
        <fsw-field>
          <ng-template fswFieldHeaderPrefix [label]="'title' | fswTranslate"></ng-template>
          <fsw-select
            [formControl]="control"
            [placeHolder]="'title' | fswTranslate"
            [disabled]="isReadonly"
          >
            <ng-container *ngFor="let option of options">
              <ng-template
                fswSelectItem
                [text]="option.text || 'N/A'"
                [value]="option.value"
              ></ng-template>
            </ng-container>
          </fsw-select>
        </fsw-field>
        <p class="b-default-500">
          <ng-container *ngFor="let item of selectedItems">
            <span>{{ item }}</span>
            <br />
          </ng-container>
        </p>
      </div>
      <ng-container *ngIf="control.value as candidates">
        <div class="credit-approvers__candidates">
          <ng-container *ngFor="let candidate of candidates">
            <fsw-credit-approvers-candidate
              [data]="candidate"
              [isReadonly]="isReadonly"
              (selection)="select(candidate.label, $event)"
            ></fsw-credit-approvers-candidate>
          </ng-container>
        </div>
      </ng-container>
    </section>
  `, providers: [fswTranslateScope('approvers-selection-my-df')], styles: [":host .credit-approvers{padding:16px;display:flex;flex-wrap:wrap;justify-content:space-between;gap:16px}:host .credit-approvers__selection{display:flex;flex-direction:column;gap:8px}:host .credit-approvers__candidates{padding:16px;border-radius:8px;box-shadow:var(--fsw-shadow-small);display:flex;flex-direction:column;gap:8px}table{width:100%;border-collapse:collapse}table th,table td{padding:10px;text-align:left;border-bottom:1px solid #ddd;border-top:1px solid #ddd;font-size:90%}table th:first-child,table td:first-child{border-left:1px solid #ddd}table th:last-child,table td:last-child{border-right:1px solid #ddd}table th.numeric-value,table td.numeric-value{text-align:right}table th input[type=text],table td input[type=text]{border:1px solid #ddd;border-radius:5px;padding:5px;width:100%;font-size:90%}table th{font-weight:700;font-weight:500}table td{font-size:80%}.summary-table .cdk-header-cell{width:4%}.summary-table tr.sub-header{background-color:#f9f9f9;font-weight:500}.summary-table tr:hover{background-color:#e6e6e6}.summary-table .column-header:not(:first-child){text-align:right}.summary-table tr.total{background-color:#f3f5fd}.override-table th.cdk-column-Date,.override-table td.cdk-column-Date,.override-table th.cdk-column-Credit-Manager,.override-table td.cdk-column-Credit-Manager{width:15%}.override-table th.cdk-column-Justification,.override-table td.cdk-column-Justification{width:70%}.cdk-column-Credit-Approver,.cdk-column-Decision,.cdk-column-Date{width:20%}.cdk-column-Comments{white-space:normal}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { selected: [{
                type: Output
            }], data: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

var title$w = "Credit Approvers";
var min = "Minimum {{count}} item(s) must be selected";
var max = "Maximum {{count}} item(s) can be selected";
var my$j = {
	title: title$w,
	min: min,
	max: max
};

var MY$j = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: my$j,
    max: max,
    min: min,
    title: title$w
});

const FSW_CREDIT_APPROVERS_TRANSLATION_LOADER = {
    [CountryCode.MY]: MY$j,
};

const initCreditDecisionFG = (_fb) => {
    return _fb.group({
        decision: ['', [Validators.required]],
        comment: ['', [Validators.required]],
        category: ['APPROVER_REVIEW'],
    });
};
const initFinalReviewerDecisionFG = (_fb) => {
    return _fb.group({
        decision: ['', [Validators.required]],
        selected_approvers: ['', [Validators.email]],
        decision_summaries: ['', [Validators.required]],
        category: ['APPROVAL_SUMMARY'],
    });
};

let FSWCreditApproversComponent = class FSWCreditApproversComponent {
    set data(value) {
        this._data = value;
    }
    get data() {
        return this._data || [];
    }
    // application id
    set applicationId(value) {
        this._applicationId = value;
    }
    get applicationId() {
        return this._applicationId;
    }
    set formKey(value) {
        this._formKey = value;
    }
    get formKey() {
        return this._formKey;
    }
    get selectedItems() {
        return Object.keys(this.selectedItemMap).reduce((acc, cur) => acc.concat(this.selectedItemMap[cur]), []);
    }
    constructor(_cdr, _fb, _applicationService) {
        this._cdr = _cdr;
        this._fb = _fb;
        this._applicationService = _applicationService;
        this.saveApproverReview = new EventEmitter();
        this.saveFinalReviewer = new EventEmitter();
        this.tableData = new EventEmitter();
        this.selected = new EventEmitter();
        // credit-approvers selection
        this.showCreditApprovers = false;
        this._data = null;
        this.showDecisions = true;
        // form-key
        this._formKey = 'my:bolt:approver-review';
        this.isReadonly = false;
        this.creditDecisionOptions = [
            { value: 'APPROVE', label: 'Approve' },
            { value: 'REJECT', label: 'Reject' },
            { value: 'CLARIFICATIONS', label: 'Clarifications' },
        ];
        this.finalReviewerDecisionOptions = [
            { value: 'APPROVE', label: 'Approve' },
            { value: 'REJECT', label: 'Reject' },
            { value: 'RE-APPROVAL', label: 'Send for re approval' },
            { value: 'RETURN_ANALYSE_CREDIT_MEMO', label: 'Send back to Analyse credit memo' },
        ];
        // decision columns
        this.decisionColumns = ['by', 'decision', 'created_at', 'comment'];
        this.decisionDisplayedColumns = ['Credit Approver', 'Decision', 'Date', 'Comments'];
        this.decisionColumnMappings = {
            'Credit Approver': 'by',
            Decision: 'decision',
            Date: 'created_at',
            Comments: 'comment',
        };
        this.approverReviewDecisionDataSource$ = new BehaviorSubject([]);
        this.approverSummaryDecisionDataSource$ = new BehaviorSubject([]);
        this.control = new FormControl(null);
        this.options = [];
        this.selectedItemMap = {};
        this._destroy$ = new Subject();
    }
    ngOnInit() {
        this.control.valueChanges
            .pipe(followDestroy(this), tap(() => {
            this.selectedItemMap = {};
            this._cdr.markForCheck();
            this.selected.emit(this.selectedItemMap);
        }))
            .subscribe();
        this.creditDecisionFG = initCreditDecisionFG(this._fb);
        this.finalReviewerDecisionFG = initFinalReviewerDecisionFG(this._fb);
        if (this.applicationId) {
            this._applicationService
                .getApplicationDecisions(this.applicationId)
                .pipe(takeUntil(this._destroy$))
                .subscribe((res) => {
                if (!res?.length) {
                    return;
                }
                const reviewerData = res.filter((r) => r.category === 'APPROVER_REVIEW');
                if (!reviewerData.length) {
                    this.approverReviewDecisionDataSource$.next([]);
                }
                else {
                    this.approverReviewDecisionDataSource$.next(reviewerData);
                    this.tableData.emit(reviewerData);
                }
                const summaryData = res.filter((r) => r.category === 'APPROVAL_SUMMARY');
                if (!summaryData.length) {
                    this.approverSummaryDecisionDataSource$.next([]);
                }
                else {
                    this.approverSummaryDecisionDataSource$.next(summaryData);
                    this.tableData.emit(summaryData);
                }
            }, (err) => {
                console.error(err);
            });
        }
        this.creditDecisionFG.get('decision')?.valueChanges.subscribe((val) => {
            if (!val)
                return;
            this.creditDecisionFG.get('category')?.setValue('APPROVER_REVIEW');
        });
        this.finalReviewerDecisionFG.get('decision')?.valueChanges.subscribe((val) => {
            if (!val)
                return;
            this.finalReviewerDecisionFG.get('category')?.setValue('APPROVAL_SUMMARY');
            const selectedApprovers = this.finalReviewerDecisionFG.get('selected_approvers');
            if (selectedApprovers) {
                if (val === 'RE-APPROVAL') {
                    selectedApprovers.setValidators([Validators.required, Validators.email]);
                }
                else {
                    selectedApprovers.setValidators(null);
                }
                selectedApprovers.updateValueAndValidity({ emitEvent: false });
            }
        });
    }
    ngOnChanges() {
        if (!this.data) {
            this.options = [];
            this.control.reset();
            this._cdr.markForCheck();
            return;
        }
        this.options = this.data.map((item) => ({
            value: item.values,
            text: item.name,
        }));
        this._cdr.markForCheck();
    }
    select(name, values) {
        this.selectedItemMap[name] = values;
        this.selected.emit(this.selectedItemMap);
        this._cdr.markForCheck();
    }
    ngOnDestroy() {
        if (this._destroy$) {
            this._destroy$.next();
            this._destroy$.complete();
        }
    }
    onSaveCreditDecision() {
        if (!this.applicationId) {
            throw new Error(`Missing Application Id`);
        }
        const formVal = this.creditDecisionFG.value;
        this._applicationService
            .createApplicationDecisions(this.applicationId, {
            decision: formVal.decision,
            category: formVal.category,
            data: {
                comment: formVal.comment,
            },
        })
            .pipe(takeUntil(this._destroy$), switchMap(() => this._applicationService.getApplicationDecisions(this.applicationId)))
            .subscribe((res) => {
            if (!res?.length) {
                return;
            }
            const approverData = res.filter((r) => r.category === 'APPROVER_REVIEW');
            this.approverReviewDecisionDataSource$.next(approverData);
            const summaryData = res.filter((r) => r.category === 'APPROVAL_SUMMARY');
            this.approverSummaryDecisionDataSource$.next(summaryData);
            this.saveApproverReview.emit(this.creditDecisionFG.value);
            this.creditDecisionFG.reset();
        }, (err) => {
            this.saveApproverReview.emit(null);
        });
    }
    onSaveFinalReviewerDecision() {
        if (!this.applicationId) {
            throw new Error(`Missing Application Id`);
        }
        if (!this.finalReviewerDecisionFG.valid) {
            throw new Error(`Invalid Final Reviewer Decision Form`);
        }
        const formVal = this.finalReviewerDecisionFG.value;
        this._applicationService
            .createApplicationDecisions(this.applicationId, {
            decision: formVal.decision,
            category: formVal.category,
            data: {
                comment: formVal.decision_summaries,
            },
        })
            .pipe(takeUntil(this._destroy$), switchMap(() => this._applicationService.getApplicationDecisions(this.applicationId)))
            .subscribe((res) => {
            if (!res?.length) {
                return;
            }
            const approverData = res.filter((r) => r.category === 'APPROVER_REVIEW');
            this.approverReviewDecisionDataSource$.next(approverData);
            const summaryData = res.filter((r) => r.category === 'APPROVAL_SUMMARY');
            this.approverSummaryDecisionDataSource$.next(summaryData);
            this.saveFinalReviewer.emit(this.finalReviewerDecisionFG.value);
            this.finalReviewerDecisionFG.reset();
        }, (err) => {
            this.saveFinalReviewer.emit(null);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCreditApproversComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i2.FormBuilder }, { token: APPLICATION_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCreditApproversComponent, selector: "fsw-credit-approvers", inputs: { showCreditApprovers: "showCreditApprovers", data: "data", applicationId: "applicationId", showDecisions: "showDecisions", formKey: "formKey", isReadonly: "isReadonly", creditDecisionOptions: "creditDecisionOptions", finalReviewerDecisionOptions: "finalReviewerDecisionOptions" }, outputs: { saveApproverReview: "saveApproverReview", saveFinalReviewer: "saveFinalReviewer", tableData: "tableData", selected: "selected" }, providers: [fswTranslateScope('credit-approvers')], usesOnChanges: true, ngImport: i0, template: "<section class=\"credit-approvers\" *ngIf=\"showCreditApprovers\">\n  <div class=\"credit-approvers__selection\">\n    <fsw-field>\n      <ng-template fswFieldHeaderPrefix [label]=\"'title' | fswTranslate\"></ng-template>\n      <fsw-select\n        [formControl]=\"control\"\n        [placeHolder]=\"'title' | fswTranslate\"\n        [disabled]=\"isReadonly\"\n      >\n        <ng-container *ngFor=\"let option of options\">\n          <ng-template\n            fswSelectItem\n            [text]=\"option.text || 'N/A'\"\n            [value]=\"option.value\"\n          ></ng-template>\n        </ng-container>\n      </fsw-select>\n    </fsw-field>\n    <p class=\"b-default-500\">\n      <ng-container *ngFor=\"let item of selectedItems\">\n        <span>{{ item }}</span>\n        <br />\n      </ng-container>\n    </p>\n  </div>\n  <ng-container *ngIf=\"control.value as candidates\">\n    <div class=\"credit-approvers__candidates\">\n      <ng-container *ngFor=\"let candidate of candidates\">\n        <fsw-credit-approvers-candidate\n          [data]=\"candidate\"\n          [isReadonly]=\"isReadonly\"\n          (selection)=\"select(candidate.label, $event)\"\n        ></fsw-credit-approvers-candidate>\n      </ng-container>\n    </div>\n  </ng-container>\n</section>\n\n<ng-container *ngIf=\"showDecisions\">\n  <ng-container *ngIf=\"formKey === 'my:bolt:approver-review'\">\n    <ng-container *ngIf=\"approverReviewDecisionDataSource$ | async as reviewDecisions\">\n      <section class=\"mt-2 mb-2\">\n        <ng-container *ngIf=\"reviewDecisions?.length\">\n          <header>\n            <h6>{{ 'Approver(s) Decisions' }}</h6>\n          </header>\n\n          <table\n            cdk-table\n            [dataSource]=\"reviewDecisions || []\"\n            class=\"override-table mt-2\"\n            role=\"grid\"\n          >\n            <ng-container *ngFor=\"let column of decisionDisplayedColumns\" [cdkColumnDef]=\"column\">\n              <th cdk-header-cell *cdkHeaderCellDef class=\"column-header\">{{ column }}</th>\n              <td cdk-cell *cdkCellDef=\"let row\" class=\"column-cell\">\n                <span>\n                  {{ row[decisionColumnMappings[column]] }}\n                </span>\n              </td>\n            </ng-container>\n\n            <tr cdk-header-row *cdkHeaderRowDef=\"decisionDisplayedColumns\"></tr>\n            <tr cdk-row *cdkRowDef=\"let row; columns: decisionDisplayedColumns\"></tr>\n          </table>\n        </ng-container>\n      </section>\n\n      <section class=\"mt-6 mb-2 w-1/2\">\n        <header>\n          <h6>{{ 'Credit Decision' }}</h6>\n        </header>\n        <ng-container [formGroup]=\"creditDecisionFG\">\n          <section>\n            <main class=\"flex justify-between w-full mt-2 gap-4\">\n              <div class=\"mb-4 w-[328px]\">\n                <fsw-field [fullWidth]=\"true\">\n                  <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                    <label>\n                      {{ 'Select Credit Decision' }}\n                      <span class=\"text-red-500\">*</span>\n                    </label>\n                  </ng-template>\n                  <fsw-select\n                    [maxHeight]=\"'200px'\"\n                    [placeHolder]=\"'Please select Credit Decision'\"\n                    [disabled]=\"isReadonly\"\n                    formControlName=\"decision\"\n                  >\n                    <ng-container *ngFor=\"let option of creditDecisionOptions\">\n                      <ng-template\n                        fswSelectItem\n                        let-selected\n                        [text]=\"option.label\"\n                        [value]=\"option.value\"\n                      ></ng-template>\n                    </ng-container>\n                  </fsw-select>\n                </fsw-field>\n              </div>\n\n              <div class=\"w-[328px] mb-4\">\n                <fsw-field [fullWidth]=\"true\">\n                  <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                    <label>\n                      {{ 'Comments' }}\n                      <span class=\"text-red-500\">*</span>\n                    </label>\n                  </ng-template>\n\n                  <textarea\n                    rows=\"3\"\n                    class=\"form-textarea\"\n                    [placeholder]=\"'Please enter comment'\"\n                    [attr.disabled]=\"isReadonly ? true : null\"\n                    formControlName=\"comment\"\n                  ></textarea>\n                </fsw-field>\n              </div>\n            </main>\n\n            <footer class=\"mt-2 flex justify-end\">\n              <button\n                fswButton\n                appearance=\"secondary\"\n                [size]=\"'s'\"\n                [disabled]=\"isReadonly || !creditDecisionFG?.valid\"\n                (click)=\"onSaveCreditDecision()\"\n              >\n                {{ 'Save' }}\n              </button>\n            </footer>\n          </section>\n        </ng-container>\n      </section>\n    </ng-container>\n\n    <section\n      class=\"mt-2 mb-6\"\n      *ngIf=\"approverSummaryDecisionDataSource$ | async as summaryDecisions\"\n    >\n      <ng-container *ngIf=\"summaryDecisions?.length\">\n        <header>\n          <h6>{{ 'Credit Final Reviewer Comments' }}</h6>\n        </header>\n\n        <table\n          cdk-table\n          [dataSource]=\"summaryDecisions || []\"\n          class=\"override-table mt-2\"\n          role=\"grid\"\n        >\n          <ng-container *ngFor=\"let column of decisionDisplayedColumns\" [cdkColumnDef]=\"column\">\n            <th cdk-header-cell *cdkHeaderCellDef class=\"column-header\">{{ column }}</th>\n            <td cdk-cell *cdkCellDef=\"let row\" class=\"column-cell\">\n              <span>\n                {{ row[decisionColumnMappings[column]] }}\n              </span>\n            </td>\n          </ng-container>\n\n          <tr cdk-header-row *cdkHeaderRowDef=\"decisionDisplayedColumns\"></tr>\n          <tr cdk-row *cdkRowDef=\"let row; columns: decisionDisplayedColumns\"></tr>\n        </table>\n      </ng-container>\n    </section>\n  </ng-container>\n\n  <ng-container *ngIf=\"formKey !== 'my:bolt:approver-review'\">\n    <section class=\"mt-2 mb-2\" *ngIf=\"approverReviewDecisionDataSource$ | async as reviewDecisions\">\n      <ng-container *ngIf=\"reviewDecisions?.length\">\n        <header>\n          <h6>{{ 'Approver(s) Decisions' }}</h6>\n        </header>\n\n        <table\n          cdk-table\n          [dataSource]=\"reviewDecisions || []\"\n          class=\"override-table mt-2\"\n          role=\"grid\"\n        >\n          <ng-container *ngFor=\"let column of decisionDisplayedColumns\" [cdkColumnDef]=\"column\">\n            <th cdk-header-cell *cdkHeaderCellDef class=\"column-header\">{{ column }}</th>\n            <td cdk-cell *cdkCellDef=\"let row\" class=\"column-cell\">\n              <span>\n                {{ row[decisionColumnMappings[column]] }}\n              </span>\n            </td>\n          </ng-container>\n\n          <tr cdk-header-row *cdkHeaderRowDef=\"decisionDisplayedColumns\"></tr>\n          <tr cdk-row *cdkRowDef=\"let row; columns: decisionDisplayedColumns\"></tr>\n        </table>\n      </ng-container>\n    </section>\n\n    <section\n      class=\"mt-2 mb-2\"\n      *ngIf=\"approverSummaryDecisionDataSource$ | async as summaryDecisions\"\n    >\n      <ng-container *ngIf=\"summaryDecisions?.length\">\n        <header>\n          <h6>{{ 'Credit Final Reviewer comments' }}</h6>\n        </header>\n\n        <table\n          cdk-table\n          [dataSource]=\"summaryDecisions || []\"\n          class=\"override-table mt-2\"\n          role=\"grid\"\n        >\n          <ng-container *ngFor=\"let column of decisionDisplayedColumns\" [cdkColumnDef]=\"column\">\n            <th cdk-header-cell *cdkHeaderCellDef class=\"column-header\">{{ column }}</th>\n            <td cdk-cell *cdkCellDef=\"let row\" class=\"column-cell\">\n              <span>\n                {{ row[decisionColumnMappings[column]] }}\n              </span>\n            </td>\n          </ng-container>\n\n          <tr cdk-header-row *cdkHeaderRowDef=\"decisionDisplayedColumns\"></tr>\n          <tr cdk-row *cdkRowDef=\"let row; columns: decisionDisplayedColumns\"></tr>\n        </table>\n      </ng-container>\n    </section>\n\n    <section class=\"mt-6 mb-2 w-2/3\">\n      <header>\n        <h6>{{ 'Credit Final Reviewer Decision' }}</h6>\n      </header>\n      <ng-container [formGroup]=\"finalReviewerDecisionFG\">\n        <section>\n          <main class=\"flex justify-between w-full mt-2 gap-4\">\n            <div class=\"w-[328px] mb-4\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ 'Select Final Reviewer Decision' }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <fsw-select\n                  [maxHeight]=\"'200px'\"\n                  [placeHolder]=\"'Please select Final Reviewer Decision'\"\n                  [disabled]=\"isReadonly\"\n                  formControlName=\"decision\"\n                >\n                  <ng-container *ngFor=\"let option of finalReviewerDecisionOptions\">\n                    <ng-template\n                      fswSelectItem\n                      let-selected\n                      [text]=\"option.label\"\n                      [value]=\"option.value\"\n                    ></ng-template>\n                  </ng-container>\n                </fsw-select>\n              </fsw-field>\n            </div>\n\n            <div class=\"w-[328px] mb-4\">\n              <fsw-field\n                [fullWidth]=\"true\"\n                [showError]=\"true\"\n                [errorText]=\"'Please enter valid email format'\"\n              >\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label *ngIf=\"!(finalReviewerDecisionFG?.value?.decision === 'RE-APPROVAL')\">\n                    {{ 'Reassign Approver(s) (optional)' }}\n                  </label>\n                  <label *ngIf=\"finalReviewerDecisionFG?.value?.decision === 'RE-APPROVAL'\">\n                    {{ 'Reassign Approver(s)' }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <input\n                  fswInput\n                  type=\"email\"\n                  formControlName=\"selected_approvers\"\n                  [placeholder]=\"'Please enter Reassign Approver(s)'\"\n                  [attr.disabled]=\"isReadonly ? true : null\"\n                  [hasError]=\"!finalReviewerDecisionFG?.controls?.selected_approvers?.valid\"\n                />\n              </fsw-field>\n            </div>\n\n            <div class=\"w-[328px] mb-4\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ 'Decision Summaries' }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n\n                <textarea\n                  rows=\"3\"\n                  class=\"form-textarea\"\n                  [placeholder]=\"'Please enter Decision Summaries'\"\n                  [attr.disabled]=\"isReadonly ? true : null\"\n                  formControlName=\"decision_summaries\"\n                ></textarea>\n              </fsw-field>\n            </div>\n          </main>\n\n          <footer class=\"mt-2 flex justify-end\">\n            <button\n              fswButton\n              appearance=\"secondary\"\n              [size]=\"'s'\"\n              [disabled]=\"isReadonly || !finalReviewerDecisionFG?.valid\"\n              (click)=\"onSaveFinalReviewerDecision()\"\n            >\n              {{ 'Save' }}\n            </button>\n          </footer>\n        </section>\n      </ng-container>\n    </section>\n  </ng-container>\n</ng-container>\n", styles: [":host .credit-approvers{padding:16px;display:flex;flex-wrap:wrap;justify-content:space-between;gap:16px}:host .credit-approvers__selection{display:flex;flex-direction:column;gap:8px}:host .credit-approvers__candidates{padding:16px;border-radius:8px;box-shadow:var(--fsw-shadow-small);display:flex;flex-direction:column;gap:8px}table{width:100%;border-collapse:collapse}table th,table td{padding:10px;text-align:left;border-bottom:1px solid #ddd;border-top:1px solid #ddd;font-size:90%}table th:first-child,table td:first-child{border-left:1px solid #ddd}table th:last-child,table td:last-child{border-right:1px solid #ddd}table th.numeric-value,table td.numeric-value{text-align:right}table th input[type=text],table td input[type=text]{border:1px solid #ddd;border-radius:5px;padding:5px;width:100%;font-size:90%}table th{font-weight:700;font-weight:500}table td{font-size:80%}.summary-table .cdk-header-cell{width:4%}.summary-table tr.sub-header{background-color:#f9f9f9;font-weight:500}.summary-table tr:hover{background-color:#e6e6e6}.summary-table .column-header:not(:first-child){text-align:right}.summary-table tr.total{background-color:#f3f5fd}.override-table th.cdk-column-Date,.override-table td.cdk-column-Date,.override-table th.cdk-column-Credit-Manager,.override-table td.cdk-column-Credit-Manager{width:15%}.override-table th.cdk-column-Justification,.override-table td.cdk-column-Justification{width:70%}.cdk-column-Credit-Approver,.cdk-column-Decision,.cdk-column-Date{width:20%}.cdk-column-Comments{white-space:normal}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6$1.CdkTable, selector: "cdk-table, table[cdk-table]", inputs: ["trackBy", "dataSource", "multiTemplateDataRows", "fixedLayout"], outputs: ["contentChanged"], exportAs: ["cdkTable"] }, { kind: "directive", type: i6$1.CdkRowDef, selector: "[cdkRowDef]", inputs: ["cdkRowDefColumns", "cdkRowDefWhen"] }, { kind: "directive", type: i6$1.CdkCellDef, selector: "[cdkCellDef]" }, { kind: "directive", type: i6$1.CdkHeaderCellDef, selector: "[cdkHeaderCellDef]" }, { kind: "directive", type: i6$1.CdkColumnDef, selector: "[cdkColumnDef]", inputs: ["sticky", "cdkColumnDef", "stickyEnd"] }, { kind: "directive", type: i6$1.CdkCell, selector: "cdk-cell, td[cdk-cell]" }, { kind: "component", type: i6$1.CdkRow, selector: "cdk-row, tr[cdk-row]" }, { kind: "directive", type: i6$1.CdkHeaderCell, selector: "cdk-header-cell, th[cdk-header-cell]" }, { kind: "component", type: i6$1.CdkHeaderRow, selector: "cdk-header-row, tr[cdk-header-row]" }, { kind: "directive", type: i6$1.CdkHeaderRowDef, selector: "[cdkHeaderRowDef]", inputs: ["cdkHeaderRowDef", "cdkHeaderRowDefSticky"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$4.FSWFieldHeaderPrefixDirective, selector: "ng-template[fswFieldHeaderPrefix]", inputs: ["kind", "label", "required"] }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$4.FSWInputDirective, selector: "input[fswInput], textarea[fswInput]" }, { kind: "component", type: FSWCreditApproversCandidateComponent, selector: "fsw-credit-approvers-candidate", inputs: ["data", "isReadonly"], outputs: ["selection"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }] }); }
};
FSWCreditApproversComponent = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [ChangeDetectorRef,
        FormBuilder, Object])
], FSWCreditApproversComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCreditApproversComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-credit-approvers', providers: [fswTranslateScope('credit-approvers')], template: "<section class=\"credit-approvers\" *ngIf=\"showCreditApprovers\">\n  <div class=\"credit-approvers__selection\">\n    <fsw-field>\n      <ng-template fswFieldHeaderPrefix [label]=\"'title' | fswTranslate\"></ng-template>\n      <fsw-select\n        [formControl]=\"control\"\n        [placeHolder]=\"'title' | fswTranslate\"\n        [disabled]=\"isReadonly\"\n      >\n        <ng-container *ngFor=\"let option of options\">\n          <ng-template\n            fswSelectItem\n            [text]=\"option.text || 'N/A'\"\n            [value]=\"option.value\"\n          ></ng-template>\n        </ng-container>\n      </fsw-select>\n    </fsw-field>\n    <p class=\"b-default-500\">\n      <ng-container *ngFor=\"let item of selectedItems\">\n        <span>{{ item }}</span>\n        <br />\n      </ng-container>\n    </p>\n  </div>\n  <ng-container *ngIf=\"control.value as candidates\">\n    <div class=\"credit-approvers__candidates\">\n      <ng-container *ngFor=\"let candidate of candidates\">\n        <fsw-credit-approvers-candidate\n          [data]=\"candidate\"\n          [isReadonly]=\"isReadonly\"\n          (selection)=\"select(candidate.label, $event)\"\n        ></fsw-credit-approvers-candidate>\n      </ng-container>\n    </div>\n  </ng-container>\n</section>\n\n<ng-container *ngIf=\"showDecisions\">\n  <ng-container *ngIf=\"formKey === 'my:bolt:approver-review'\">\n    <ng-container *ngIf=\"approverReviewDecisionDataSource$ | async as reviewDecisions\">\n      <section class=\"mt-2 mb-2\">\n        <ng-container *ngIf=\"reviewDecisions?.length\">\n          <header>\n            <h6>{{ 'Approver(s) Decisions' }}</h6>\n          </header>\n\n          <table\n            cdk-table\n            [dataSource]=\"reviewDecisions || []\"\n            class=\"override-table mt-2\"\n            role=\"grid\"\n          >\n            <ng-container *ngFor=\"let column of decisionDisplayedColumns\" [cdkColumnDef]=\"column\">\n              <th cdk-header-cell *cdkHeaderCellDef class=\"column-header\">{{ column }}</th>\n              <td cdk-cell *cdkCellDef=\"let row\" class=\"column-cell\">\n                <span>\n                  {{ row[decisionColumnMappings[column]] }}\n                </span>\n              </td>\n            </ng-container>\n\n            <tr cdk-header-row *cdkHeaderRowDef=\"decisionDisplayedColumns\"></tr>\n            <tr cdk-row *cdkRowDef=\"let row; columns: decisionDisplayedColumns\"></tr>\n          </table>\n        </ng-container>\n      </section>\n\n      <section class=\"mt-6 mb-2 w-1/2\">\n        <header>\n          <h6>{{ 'Credit Decision' }}</h6>\n        </header>\n        <ng-container [formGroup]=\"creditDecisionFG\">\n          <section>\n            <main class=\"flex justify-between w-full mt-2 gap-4\">\n              <div class=\"mb-4 w-[328px]\">\n                <fsw-field [fullWidth]=\"true\">\n                  <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                    <label>\n                      {{ 'Select Credit Decision' }}\n                      <span class=\"text-red-500\">*</span>\n                    </label>\n                  </ng-template>\n                  <fsw-select\n                    [maxHeight]=\"'200px'\"\n                    [placeHolder]=\"'Please select Credit Decision'\"\n                    [disabled]=\"isReadonly\"\n                    formControlName=\"decision\"\n                  >\n                    <ng-container *ngFor=\"let option of creditDecisionOptions\">\n                      <ng-template\n                        fswSelectItem\n                        let-selected\n                        [text]=\"option.label\"\n                        [value]=\"option.value\"\n                      ></ng-template>\n                    </ng-container>\n                  </fsw-select>\n                </fsw-field>\n              </div>\n\n              <div class=\"w-[328px] mb-4\">\n                <fsw-field [fullWidth]=\"true\">\n                  <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                    <label>\n                      {{ 'Comments' }}\n                      <span class=\"text-red-500\">*</span>\n                    </label>\n                  </ng-template>\n\n                  <textarea\n                    rows=\"3\"\n                    class=\"form-textarea\"\n                    [placeholder]=\"'Please enter comment'\"\n                    [attr.disabled]=\"isReadonly ? true : null\"\n                    formControlName=\"comment\"\n                  ></textarea>\n                </fsw-field>\n              </div>\n            </main>\n\n            <footer class=\"mt-2 flex justify-end\">\n              <button\n                fswButton\n                appearance=\"secondary\"\n                [size]=\"'s'\"\n                [disabled]=\"isReadonly || !creditDecisionFG?.valid\"\n                (click)=\"onSaveCreditDecision()\"\n              >\n                {{ 'Save' }}\n              </button>\n            </footer>\n          </section>\n        </ng-container>\n      </section>\n    </ng-container>\n\n    <section\n      class=\"mt-2 mb-6\"\n      *ngIf=\"approverSummaryDecisionDataSource$ | async as summaryDecisions\"\n    >\n      <ng-container *ngIf=\"summaryDecisions?.length\">\n        <header>\n          <h6>{{ 'Credit Final Reviewer Comments' }}</h6>\n        </header>\n\n        <table\n          cdk-table\n          [dataSource]=\"summaryDecisions || []\"\n          class=\"override-table mt-2\"\n          role=\"grid\"\n        >\n          <ng-container *ngFor=\"let column of decisionDisplayedColumns\" [cdkColumnDef]=\"column\">\n            <th cdk-header-cell *cdkHeaderCellDef class=\"column-header\">{{ column }}</th>\n            <td cdk-cell *cdkCellDef=\"let row\" class=\"column-cell\">\n              <span>\n                {{ row[decisionColumnMappings[column]] }}\n              </span>\n            </td>\n          </ng-container>\n\n          <tr cdk-header-row *cdkHeaderRowDef=\"decisionDisplayedColumns\"></tr>\n          <tr cdk-row *cdkRowDef=\"let row; columns: decisionDisplayedColumns\"></tr>\n        </table>\n      </ng-container>\n    </section>\n  </ng-container>\n\n  <ng-container *ngIf=\"formKey !== 'my:bolt:approver-review'\">\n    <section class=\"mt-2 mb-2\" *ngIf=\"approverReviewDecisionDataSource$ | async as reviewDecisions\">\n      <ng-container *ngIf=\"reviewDecisions?.length\">\n        <header>\n          <h6>{{ 'Approver(s) Decisions' }}</h6>\n        </header>\n\n        <table\n          cdk-table\n          [dataSource]=\"reviewDecisions || []\"\n          class=\"override-table mt-2\"\n          role=\"grid\"\n        >\n          <ng-container *ngFor=\"let column of decisionDisplayedColumns\" [cdkColumnDef]=\"column\">\n            <th cdk-header-cell *cdkHeaderCellDef class=\"column-header\">{{ column }}</th>\n            <td cdk-cell *cdkCellDef=\"let row\" class=\"column-cell\">\n              <span>\n                {{ row[decisionColumnMappings[column]] }}\n              </span>\n            </td>\n          </ng-container>\n\n          <tr cdk-header-row *cdkHeaderRowDef=\"decisionDisplayedColumns\"></tr>\n          <tr cdk-row *cdkRowDef=\"let row; columns: decisionDisplayedColumns\"></tr>\n        </table>\n      </ng-container>\n    </section>\n\n    <section\n      class=\"mt-2 mb-2\"\n      *ngIf=\"approverSummaryDecisionDataSource$ | async as summaryDecisions\"\n    >\n      <ng-container *ngIf=\"summaryDecisions?.length\">\n        <header>\n          <h6>{{ 'Credit Final Reviewer comments' }}</h6>\n        </header>\n\n        <table\n          cdk-table\n          [dataSource]=\"summaryDecisions || []\"\n          class=\"override-table mt-2\"\n          role=\"grid\"\n        >\n          <ng-container *ngFor=\"let column of decisionDisplayedColumns\" [cdkColumnDef]=\"column\">\n            <th cdk-header-cell *cdkHeaderCellDef class=\"column-header\">{{ column }}</th>\n            <td cdk-cell *cdkCellDef=\"let row\" class=\"column-cell\">\n              <span>\n                {{ row[decisionColumnMappings[column]] }}\n              </span>\n            </td>\n          </ng-container>\n\n          <tr cdk-header-row *cdkHeaderRowDef=\"decisionDisplayedColumns\"></tr>\n          <tr cdk-row *cdkRowDef=\"let row; columns: decisionDisplayedColumns\"></tr>\n        </table>\n      </ng-container>\n    </section>\n\n    <section class=\"mt-6 mb-2 w-2/3\">\n      <header>\n        <h6>{{ 'Credit Final Reviewer Decision' }}</h6>\n      </header>\n      <ng-container [formGroup]=\"finalReviewerDecisionFG\">\n        <section>\n          <main class=\"flex justify-between w-full mt-2 gap-4\">\n            <div class=\"w-[328px] mb-4\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ 'Select Final Reviewer Decision' }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <fsw-select\n                  [maxHeight]=\"'200px'\"\n                  [placeHolder]=\"'Please select Final Reviewer Decision'\"\n                  [disabled]=\"isReadonly\"\n                  formControlName=\"decision\"\n                >\n                  <ng-container *ngFor=\"let option of finalReviewerDecisionOptions\">\n                    <ng-template\n                      fswSelectItem\n                      let-selected\n                      [text]=\"option.label\"\n                      [value]=\"option.value\"\n                    ></ng-template>\n                  </ng-container>\n                </fsw-select>\n              </fsw-field>\n            </div>\n\n            <div class=\"w-[328px] mb-4\">\n              <fsw-field\n                [fullWidth]=\"true\"\n                [showError]=\"true\"\n                [errorText]=\"'Please enter valid email format'\"\n              >\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label *ngIf=\"!(finalReviewerDecisionFG?.value?.decision === 'RE-APPROVAL')\">\n                    {{ 'Reassign Approver(s) (optional)' }}\n                  </label>\n                  <label *ngIf=\"finalReviewerDecisionFG?.value?.decision === 'RE-APPROVAL'\">\n                    {{ 'Reassign Approver(s)' }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n                <input\n                  fswInput\n                  type=\"email\"\n                  formControlName=\"selected_approvers\"\n                  [placeholder]=\"'Please enter Reassign Approver(s)'\"\n                  [attr.disabled]=\"isReadonly ? true : null\"\n                  [hasError]=\"!finalReviewerDecisionFG?.controls?.selected_approvers?.valid\"\n                />\n              </fsw-field>\n            </div>\n\n            <div class=\"w-[328px] mb-4\">\n              <fsw-field [fullWidth]=\"true\">\n                <ng-template fswFieldHeaderPrefix [kind]=\"'custom'\">\n                  <label>\n                    {{ 'Decision Summaries' }}\n                    <span class=\"text-red-500\">*</span>\n                  </label>\n                </ng-template>\n\n                <textarea\n                  rows=\"3\"\n                  class=\"form-textarea\"\n                  [placeholder]=\"'Please enter Decision Summaries'\"\n                  [attr.disabled]=\"isReadonly ? true : null\"\n                  formControlName=\"decision_summaries\"\n                ></textarea>\n              </fsw-field>\n            </div>\n          </main>\n\n          <footer class=\"mt-2 flex justify-end\">\n            <button\n              fswButton\n              appearance=\"secondary\"\n              [size]=\"'s'\"\n              [disabled]=\"isReadonly || !finalReviewerDecisionFG?.valid\"\n              (click)=\"onSaveFinalReviewerDecision()\"\n            >\n              {{ 'Save' }}\n            </button>\n          </footer>\n        </section>\n      </ng-container>\n    </section>\n  </ng-container>\n</ng-container>\n", styles: [":host .credit-approvers{padding:16px;display:flex;flex-wrap:wrap;justify-content:space-between;gap:16px}:host .credit-approvers__selection{display:flex;flex-direction:column;gap:8px}:host .credit-approvers__candidates{padding:16px;border-radius:8px;box-shadow:var(--fsw-shadow-small);display:flex;flex-direction:column;gap:8px}table{width:100%;border-collapse:collapse}table th,table td{padding:10px;text-align:left;border-bottom:1px solid #ddd;border-top:1px solid #ddd;font-size:90%}table th:first-child,table td:first-child{border-left:1px solid #ddd}table th:last-child,table td:last-child{border-right:1px solid #ddd}table th.numeric-value,table td.numeric-value{text-align:right}table th input[type=text],table td input[type=text]{border:1px solid #ddd;border-radius:5px;padding:5px;width:100%;font-size:90%}table th{font-weight:700;font-weight:500}table td{font-size:80%}.summary-table .cdk-header-cell{width:4%}.summary-table tr.sub-header{background-color:#f9f9f9;font-weight:500}.summary-table tr:hover{background-color:#e6e6e6}.summary-table .column-header:not(:first-child){text-align:right}.summary-table tr.total{background-color:#f3f5fd}.override-table th.cdk-column-Date,.override-table td.cdk-column-Date,.override-table th.cdk-column-Credit-Manager,.override-table td.cdk-column-Credit-Manager{width:15%}.override-table th.cdk-column-Justification,.override-table td.cdk-column-Justification{width:70%}.cdk-column-Credit-Approver,.cdk-column-Decision,.cdk-column-Date{width:20%}.cdk-column-Comments{white-space:normal}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i2.FormBuilder }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_SERVICE_TOKEN]
                }] }]; }, propDecorators: { saveApproverReview: [{
                type: Output
            }], saveFinalReviewer: [{
                type: Output
            }], tableData: [{
                type: Output
            }], selected: [{
                type: Output
            }], showCreditApprovers: [{
                type: Input
            }], data: [{
                type: Input
            }], applicationId: [{
                type: Input
            }], showDecisions: [{
                type: Input
            }], formKey: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], creditDecisionOptions: [{
                type: Input
            }], finalReviewerDecisionOptions: [{
                type: Input
            }] } });

class FSWCreditApproversModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCreditApproversModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWCreditApproversModule, declarations: [FSWCreditApproversComponent, FSWCreditApproversCandidateComponent], imports: [i1$4.FSWTranslateModule, NgForOf,
            NgIf,
            AsyncPipe,
            JsonPipe,
            FSWCheckboxModule,
            CdkTableModule,
            ReactiveFormsModule,
            LetDirective,
            FSWFieldModule,
            FSWSelectModule,
            ApplicationServiceModule,
            FSWButtonModule,
            FSWInputModule], exports: [FSWCreditApproversComponent, FSWCreditApproversCandidateComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCreditApproversModule, imports: [FSWTranslateModule.forFeature({
                scope: 'credit-approvers',
                defaultKey: CountryCode.MY,
                data: FSW_CREDIT_APPROVERS_TRANSLATION_LOADER,
            }),
            FSWCheckboxModule,
            CdkTableModule,
            ReactiveFormsModule,
            FSWFieldModule,
            FSWSelectModule,
            ApplicationServiceModule,
            FSWButtonModule,
            FSWInputModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCreditApproversModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FSWCreditApproversComponent, FSWCreditApproversCandidateComponent],
                    imports: [
                        FSWTranslateModule.forFeature({
                            scope: 'credit-approvers',
                            defaultKey: CountryCode.MY,
                            data: FSW_CREDIT_APPROVERS_TRANSLATION_LOADER,
                        }),
                        NgForOf,
                        NgIf,
                        AsyncPipe,
                        JsonPipe,
                        FSWCheckboxModule,
                        CdkTableModule,
                        ReactiveFormsModule,
                        LetDirective,
                        FSWFieldModule,
                        FSWSelectModule,
                        ApplicationServiceModule,
                        FSWButtonModule,
                        FSWInputModule,
                    ],
                    exports: [FSWCreditApproversComponent, FSWCreditApproversCandidateComponent],
                }]
        }] });

class FSWApproversSelectionMyDfModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWApproversSelectionMyDfModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWApproversSelectionMyDfModule, declarations: [FSWApproversSelectionMyDfComponent], imports: [i1$4.FSWTranslateModule, NgForOf,
            NgIf,
            AsyncPipe,
            JsonPipe,
            FSWCheckboxModule,
            CdkTableModule,
            ReactiveFormsModule,
            LetDirective,
            FSWFieldModule,
            FSWSelectModule,
            ApplicationServiceModule,
            FSWButtonModule,
            FSWInputModule,
            FSWCreditApproversModule], exports: [FSWApproversSelectionMyDfComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWApproversSelectionMyDfModule, imports: [FSWTranslateModule.forFeature({
                scope: 'approvers-selection-my-df',
                defaultKey: CountryCode.MY,
                data: FSW_CREDIT_APPROVERS_TRANSLATION_LOADER,
            }),
            FSWCheckboxModule,
            CdkTableModule,
            ReactiveFormsModule,
            FSWFieldModule,
            FSWSelectModule,
            ApplicationServiceModule,
            FSWButtonModule,
            FSWInputModule,
            FSWCreditApproversModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWApproversSelectionMyDfModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FSWApproversSelectionMyDfComponent],
                    imports: [
                        FSWTranslateModule.forFeature({
                            scope: 'approvers-selection-my-df',
                            defaultKey: CountryCode.MY,
                            data: FSW_CREDIT_APPROVERS_TRANSLATION_LOADER,
                        }),
                        NgForOf,
                        NgIf,
                        AsyncPipe,
                        JsonPipe,
                        FSWCheckboxModule,
                        CdkTableModule,
                        ReactiveFormsModule,
                        LetDirective,
                        FSWFieldModule,
                        FSWSelectModule,
                        ApplicationServiceModule,
                        FSWButtonModule,
                        FSWInputModule,
                        FSWCreditApproversModule,
                    ],
                    exports: [FSWApproversSelectionMyDfComponent],
                }]
        }] });

var title$v = "Scoring Result";
var currency = "MYR";
var error = "Please valid all information before submit!";
var fields$o = {
	grade: "Grade",
	interest_rate: "Interest Rate (Type)",
	override_loan_amount: "Override Loan Amount",
	disbursement_amount: "Disbursement Amount",
	origination_fee: "Origination Fee",
	override_tenor: "Override Tenor",
	override_interest_rate: "Override Interest Rate"
};
var tenor_types = {
	"1": "Day",
	"7": "Week",
	"14": "Fortnight",
	"30": "Month"
};
var interest_types = {
	"1": "Per Day (P.D)",
	"7": "Per Week (P.W)",
	"30": "Per Month (P.M)",
	"100": "Per Amount (P.Amt)",
	"360": "Per Annum (P.A)"
};
var modal$4 = {
	title: "Recalculate Score Card",
	description: "Recalculation of Score Card is recommended after change of QTI"
};
var buttons$L = {
	override_score: "Override Score",
	yes: "Yes",
	no: "No, only update"
};
var my$i = {
	title: title$v,
	currency: currency,
	error: error,
	fields: fields$o,
	tenor_types: tenor_types,
	interest_types: interest_types,
	modal: modal$4,
	buttons: buttons$L
};

var MY$i = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$L,
    currency: currency,
    default: my$i,
    error: error,
    fields: fields$o,
    interest_types: interest_types,
    modal: modal$4,
    tenor_types: tenor_types,
    title: title$v
});

const FSW_SCORING_RESULT_TRANSLATION_LOADER = {
    [CountryCode.MY]: MY$i,
};

const scoringResultLoadProviders = () => [
    fswTranslateScope('scoring_result'),
];

class FSWScoringResultConfirmComponent {
    constructor(ref) {
        this.ref = ref;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWScoringResultConfirmComponent, deps: [{ token: i1$7.DialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWScoringResultConfirmComponent, selector: "fsw-scoring-result-confirm", ngImport: i0, template: "<fsw-modal\n  [title]=\"'modal.title' | fswTranslate\"\n  [confirmButton]=\"'buttons.yes' | fswTranslate\"\n  [cancelButton]=\"'buttons.no' | fswTranslate\"\n  (confirmEvent)=\"ref.close(true)\"\n  (cancelEvent)=\"ref.close(false)\"\n  (closeEvent)=\"ref.close(false)\"\n>\n  <ng-template fswModalBody>\n    <p>{{ 'modal.description' | fswTranslate }}</p>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWScoringResultConfirmComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-scoring-result-confirm', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal\n  [title]=\"'modal.title' | fswTranslate\"\n  [confirmButton]=\"'buttons.yes' | fswTranslate\"\n  [cancelButton]=\"'buttons.no' | fswTranslate\"\n  (confirmEvent)=\"ref.close(true)\"\n  (cancelEvent)=\"ref.close(false)\"\n  (closeEvent)=\"ref.close(false)\"\n>\n  <ng-template fswModalBody>\n    <p>{{ 'modal.description' | fswTranslate }}</p>\n  </ng-template>\n</fsw-modal>\n" }]
        }], ctorParameters: function () { return [{ type: i1$7.DialogRef }]; } });

class FSWScoringResultComponent {
    constructor(_alertService, dialog, _translateService, _translateScope, _injector) {
        this._alertService = _alertService;
        this.dialog = dialog;
        this._translateService = _translateService;
        this._translateScope = _translateScope;
        this._injector = _injector;
        this.calculate = new EventEmitter();
        this.update = new EventEmitter();
        this.data = null;
        this.isReadonly = false;
        this.formGroup = new FormGroup({});
        this.builder = this.generateBuilder();
    }
    ngOnInit() {
        this.builder = this.generateBuilder();
        if (!this.data) {
            return;
        }
        this.formGroup.patchValue({
            readonly: {
                scorecard_grade: this.data.scorecard_grade,
                interest_rate_str: this.data.interest_rate_str,
            },
            override: {
                amount: Number(this.data.amount || null),
                disbursement_amount: Number(this.data.disbursement_amount || null),
                origination_fee: Number(this.data.origination_fee || null),
                tenor_length: Number(this.data.tenor_length || '0'),
                tenor_type: Number(this.data.tenor_type || '0'),
                interest_rate: Number(this.data.interest_rate || '0'),
                interest_type: Number(this.data.interest_type || '0'),
            },
        });
    }
    submit() {
        if (this.formGroup.invalid) {
            this._alertService.error(this._translateService.select('error', this._translateScope));
            return;
        }
        this.dialog
            .open(FSWScoringResultConfirmComponent, {
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((value) => {
            const { readonly, override } = this.formGroup.getRawValue();
            if (!value) {
                this.update.emit({
                    ...readonly,
                    ...override,
                });
                return;
            }
            this.calculate.emit({
                ...readonly,
                ...override,
            });
        }))
            .subscribe();
    }
    generateBuilder() {
        const tenorItems = TENOR_TYPES.map((type) => ({
            value: type,
            text: this._translateService.select(`tenor_types.${type}`, this._translateScope),
        }));
        const interestItems = INTEREST_TYPES.map((type) => ({
            value: type,
            text: this._translateService.select(`interest_types.${type}`, this._translateScope),
        }));
        return new FSWDynamicBuilder({
            formType: FSWDynamicBuilderFormTypes.GROUP,
            form: this.formGroup,
            customClasses: 'flex gap-[16px]',
            fields: [
                {
                    key: 'readonly',
                    formType: FSWDynamicBuilderFormTypes.GROUP,
                    fields: [
                        {
                            key: 'scorecard_grade',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                inputType: 'text',
                                isDisabled: true,
                                label: this._translateService.select('fields.grade', this._translateScope),
                                defaultValue: 'N.A.',
                                fullWidth: true,
                                readonlyTemplate: (value) => value || 'N.A.',
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'interest_rate_str',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                inputType: 'text',
                                label: this._translateService.select('fields.interest_rate', this._translateScope),
                                defaultValue: 'N.A.',
                                fullWidth: true,
                                isDisabled: true,
                                readonlyTemplate: (value) => value || 'N.A.',
                            },
                            validations: [Validators.required],
                        },
                    ],
                    customClasses: 'w-[calc(50%-8px)] flex flex-col gap-[16px]',
                },
                {
                    key: 'override',
                    formType: FSWDynamicBuilderFormTypes.GROUP,
                    renderBy: 'container',
                    customClasses: 'w-[calc(50%-8px)] flex flex-col gap-[16px]',
                    containers: [
                        {
                            fields: [
                                {
                                    key: 'amount',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        // inputType: 'number',
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: this._translateService.select('fields.override_loan_amount', this._translateScope),
                                        defaultValue: 0,
                                        prefix: getCurrentCountryConfig().currencyCode,
                                        showError: true,
                                        fullWidth: true,
                                        isDisabled: true,
                                        afterCreated: (control, formGroup) => {
                                            const disbursementAmountControl = formGroup.get('disbursement_amount');
                                            const originationFeeControl = formGroup.get('origination_fee');
                                            if (disbursementAmountControl && originationFeeControl) {
                                                combineLatest([
                                                    disbursementAmountControl.valueChanges.pipe(startWith(disbursementAmountControl.value)),
                                                    originationFeeControl.valueChanges.pipe(startWith(originationFeeControl.value)),
                                                ]).subscribe(([disbursementAmount, originationFee]) => {
                                                    const amount = Number(disbursementAmount) + Number(originationFee);
                                                    control.setValue(+amount.toFixed(2));
                                                });
                                            }
                                        },
                                    },
                                },
                            ],
                        },
                        {
                            fields: [
                                {
                                    key: 'disbursement_amount',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        // inputType: 'number',
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: this._translateService.select('fields.disbursement_amount', this._translateScope),
                                        defaultValue: 0,
                                        prefix: getCurrentCountryConfig().currencyCode,
                                        showError: true,
                                        fullWidth: true,
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            fields: [
                                {
                                    key: 'origination_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        // inputType: 'number',
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: this._translateService.select('fields.origination_fee', this._translateScope),
                                        defaultValue: 0,
                                        prefix: getCurrentCountryConfig().currencyCode,
                                        showError: true,
                                        fullWidth: true,
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex items-end gap-[8px]',
                            fields: [
                                {
                                    key: 'tenor_length',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'w-[calc(50%-4px)]',
                                    context: {
                                        // inputType: 'number',
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: this._translateService.select('fields.override_tenor', this._translateScope),
                                        defaultValue: 0,
                                        fullWidth: true,
                                        showError: true,
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'tenor_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'w-[calc(50%-4px)]',
                                    context: {
                                        defaultValue: '',
                                        items: tenorItems,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => tenorItems.find((item) => item.value == value)?.text || '',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex items-end gap-[8px]',
                            fields: [
                                {
                                    key: 'interest_rate',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'w-[calc(50%-4px)]',
                                    context: {
                                        // inputType: 'number',
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: this._translateService.select('fields.override_interest_rate', this._translateScope),
                                        defaultValue: 0,
                                        fullWidth: true,
                                        showError: true,
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'interest_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'w-[calc(50%-4px)]',
                                    context: {
                                        defaultValue: '',
                                        items: interestItems,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => interestItems.find((item) => item.value == value)?.text || '',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                    ],
                },
            ],
            readonlyWhen$: of(this.isReadonly),
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWScoringResultComponent, deps: [{ token: FSW_ALERT_SERVICE_TOKEN }, { token: i1$7.Dialog }, { token: FSW_TRANSLATE_SERVICE_TOKEN }, { token: FSW_TRANSLATE_SCOPE_TOKEN }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWScoringResultComponent, selector: "fsw-scoring-result", inputs: { data: "data", isReadonly: "isReadonly" }, outputs: { calculate: "calculate", update: "update" }, ngImport: i0, template: "<section class=\"flex flex-col gap-[24px] p-[24px] border border-solid border-gray-200 rounded\">\n  <header>\n    <h6 class=\"h6 text-gray-900\">{{ 'title' | fswTranslate }}</h6>\n  </header>\n  <main>\n    <form [formGroup]=\"formGroup\">\n      <fsw-dynamic-builder [builder]=\"builder\" />\n    </form>\n  </main>\n  <footer class=\"flex justify-end\" *ngIf=\"!isReadonly\">\n    <button fswButton [appearance]=\"'secondary'\" [disabled]=\"formGroup.invalid\" (click)=\"submit()\">\n      {{ 'buttons.override_score' | fswTranslate }}\n    </button>\n  </footer>\n</section>\n", dependencies: [{ kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWScoringResultComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-scoring-result', changeDetection: ChangeDetectionStrategy.OnPush, template: "<section class=\"flex flex-col gap-[24px] p-[24px] border border-solid border-gray-200 rounded\">\n  <header>\n    <h6 class=\"h6 text-gray-900\">{{ 'title' | fswTranslate }}</h6>\n  </header>\n  <main>\n    <form [formGroup]=\"formGroup\">\n      <fsw-dynamic-builder [builder]=\"builder\" />\n    </form>\n  </main>\n  <footer class=\"flex justify-end\" *ngIf=\"!isReadonly\">\n    <button fswButton [appearance]=\"'secondary'\" [disabled]=\"formGroup.invalid\" (click)=\"submit()\">\n      {{ 'buttons.override_score' | fswTranslate }}\n    </button>\n  </footer>\n</section>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: i1$7.Dialog }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_TRANSLATE_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_TRANSLATE_SCOPE_TOKEN]
                }] }, { type: i0.Injector }]; }, propDecorators: { calculate: [{
                type: Output
            }], update: [{
                type: Output
            }], data: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

let FSwScoringResultDirective = class FSwScoringResultDirective {
    constructor(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
        this.calculate = new EventEmitter();
        this.update = new EventEmitter();
        this.data = null;
        this.isReadonly = false;
    }
    ngOnChanges() {
        this._viewContainerRef.clear();
        const ref = this._viewContainerRef.createComponent(FSWScoringResultComponent, {
            injector: Injector.create({
                parent: this._viewContainerRef.injector,
                providers: scoringResultLoadProviders(),
            }),
        });
        const instance = ref.instance;
        instance.data = this.data;
        instance.isReadonly = this.isReadonly;
        instance.update
            .pipe(tap((value) => this.update.emit(value)), followDestroy(this))
            .subscribe();
        instance.calculate
            .pipe(tap((value) => this.calculate.emit(value)), followDestroy(this))
            .subscribe();
        ref.changeDetectorRef.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSwScoringResultDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSwScoringResultDirective, selector: "[fswScoringResult]", inputs: { data: "data", isReadonly: "isReadonly" }, outputs: { calculate: "calculate", update: "update" }, usesOnChanges: true, ngImport: i0 }); }
};
FSwScoringResultDirective = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [ViewContainerRef])
], FSwScoringResultDirective);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSwScoringResultDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswScoringResult]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; }, propDecorators: { calculate: [{
                type: Output
            }], update: [{
                type: Output
            }], data: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class FSWScoringResultModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWScoringResultModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWScoringResultModule, declarations: [FSwScoringResultDirective,
            FSWScoringResultComponent,
            FSWScoringResultConfirmComponent], imports: [i1$4.FSWTranslateModule, FSWAlertModule,
            ReactiveFormsModule,
            FSWDynamicBuilderModule,
            FSWButtonModule,
            DialogModule,
            FSWModalModule$1,
            NgIf], exports: [FSwScoringResultDirective, FSWScoringResultComponent, FSWScoringResultConfirmComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWScoringResultModule, imports: [FSWTranslateModule.forFeature({
                scope: 'scoring_result',
                defaultKey: CountryCode.MY,
                data: FSW_SCORING_RESULT_TRANSLATION_LOADER,
            }),
            FSWAlertModule,
            ReactiveFormsModule,
            FSWDynamicBuilderModule,
            FSWButtonModule,
            DialogModule,
            FSWModalModule$1] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWScoringResultModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FSwScoringResultDirective,
                        FSWScoringResultComponent,
                        FSWScoringResultConfirmComponent,
                    ],
                    exports: [FSwScoringResultDirective, FSWScoringResultComponent, FSWScoringResultConfirmComponent],
                    imports: [
                        FSWTranslateModule.forFeature({
                            scope: 'scoring_result',
                            defaultKey: CountryCode.MY,
                            data: FSW_SCORING_RESULT_TRANSLATION_LOADER,
                        }),
                        FSWAlertModule,
                        ReactiveFormsModule,
                        FSWDynamicBuilderModule,
                        FSWButtonModule,
                        DialogModule,
                        FSWModalModule$1,
                        NgIf,
                    ],
                }]
        }] });

const INITIAL_STATE$2 = {
    countryCode: null,
    applicationId: null,
    ratioAnalysisId: null,
    ratioAnalysisDetail: null,
    ratioAnalysisPayload: null,
    ratioAnalysisUpdatePayload: null,
    isPayloadCreated: false,
    isUpdatePayloadCreated: false,
    errors: [],
    proposalType: 'LOAN',
};
let RatioAnalysisStore = class RatioAnalysisStore extends ComponentStore {
    // constructor
    constructor(applicationService, creditService, bankTabulationsService, financialStatementService, ratioAnalysisService, appRepaymentScheduleService, applicationProposalService, applicationRelationshipService, applicationMemberService, applicationGuarantorService, outstandingLoansService, productGroupService, _stateOverride = {}) {
        super({
            ...INITIAL_STATE$2,
            ..._stateOverride,
        });
        this.applicationService = applicationService;
        this.creditService = creditService;
        this.bankTabulationsService = bankTabulationsService;
        this.financialStatementService = financialStatementService;
        this.ratioAnalysisService = ratioAnalysisService;
        this.appRepaymentScheduleService = appRepaymentScheduleService;
        this.applicationProposalService = applicationProposalService;
        this.applicationRelationshipService = applicationRelationshipService;
        this.applicationMemberService = applicationMemberService;
        this.applicationGuarantorService = applicationGuarantorService;
        this.outstandingLoansService = outstandingLoansService;
        this.productGroupService = productGroupService;
        this._stateOverride = _stateOverride;
        // actions
        // 1. GET - ratioAnalysisId & ratioAnalysisDetail
        this.getRatioAnalysisDetail = this.effect(pipe(switchMap(() => this._getRatioAnalysisIdAsync().pipe(catchError((err) => {
            console.error(`[_getRatioAnalysisIdAsync]`, err);
            this.updateState({
                errors: [...this.state().errors, err],
            });
            return EMPTY;
        }))), switchMap(() => this._getRatioAnalysisDetailAsync().pipe(catchError((err) => {
            console.error(`[_getRatioAnalysisDetailAsync]`, err);
            this.updateState({
                errors: [...this.state().errors, err],
            });
            return EMPTY;
        })))));
        // ratio analysis
        // 1. GET - repayment_schedule_id & application_id,
        // 2. GET - borrower_summary_id,
        // 3. GET - member_id,
        // 4. GET - outstanding_loan_ids,
        // 5. GET - member_bip_guarantor_summaries: pg_ids, cg_ids,
        // 6. GET - bank_accounts, update ratioAnalysisPayload & isPayloadCreated
        this.createRatioAnalysisPayload = this.effect(pipe(switchMap(() => this.applicationProposalService
            .getProposals(this.state().applicationId)
            .pipe(map((data) => data.filter((item) => item.proposal_type === this.get().proposalType)), map((data) => data.shift()?.id || null), switchMap((id) => this.appRepaymentScheduleService.getData(id)))
            .pipe(tap((repayment_schedule_id) => {
            if (!isStringValid(repayment_schedule_id)) {
                const errMsg = `[GET] repayment_schedule_id | No repayment schedule found`;
                console.error(errMsg);
                // repayment_schedule_id must be uuid format or ignore it if empty
                this.updateState({
                    errors: [...this.state().errors, errMsg],
                });
                return;
            }
            if (repayment_schedule_id) {
                const ratioAnalysisPayload = {
                    ...this.state().ratioAnalysisPayload,
                    application_id: this.state().applicationId,
                    repayment_schedule_id,
                };
                this.updateState({
                    ratioAnalysisPayload,
                });
            }
        }), catchError((err) => {
            console.error(`[GET] repayment_schedule_id`, err);
            this.updateState({
                errors: [...this.state().errors, err],
            });
            return EMPTY;
        }))), switchMap(() => this.applicationRelationshipService
            .getAsync(this.state().applicationId, 'borrower_summary')
            .pipe(map((ids) => ids?.shift()), tap((borrower_summary_id) => {
            if (!isStringValid(borrower_summary_id)) {
                const errMsg = `[GET] borrower_summary_id | No borrower summary found`;
                console.error(errMsg);
                this.updateState({
                    ratioAnalysisPayload: {
                        ...this.state().ratioAnalysisPayload,
                        borrower_summary_id,
                    },
                    errors: [...this.state().errors, errMsg],
                });
                return;
            }
            if (borrower_summary_id) {
                const ratioAnalysisPayload = {
                    ...this.state().ratioAnalysisPayload,
                    borrower_summary_id,
                };
                this.updateState({
                    ratioAnalysisPayload,
                });
            }
        }), catchError((err) => {
            console.error(`[GET] borrower_summary_id`, err);
            this.updateState({
                errors: [...this.state().errors, err],
            });
            return EMPTY;
        }))), switchMap(() => this.applicationMemberService
            .getApplicationMembers(this.state().applicationId, { type: 'MAIN' })
            .pipe(tap((members) => {
            if (!members.length) {
                const errMsg = `[GET] member_id | No members found`;
                console.error(errMsg);
                this.updateState({
                    errors: [...this.state().errors, errMsg],
                });
                return;
            }
            if (members[0]?.member_id_int) {
                const ratioAnalysisPayload = {
                    ...this.state().ratioAnalysisPayload,
                    member_id: members[0].member_id_int,
                };
                this.updateState({
                    ratioAnalysisPayload,
                });
            }
        }), catchError((err) => {
            console.error(`[GET] member_id`, err);
            this.updateState({
                errors: [...this.state().errors, err],
            });
            return EMPTY;
        }))), switchMap(() => this.outstandingLoansService
            .getOutstandingLoanIds(this.state().applicationId)
            .pipe(tap((outstanding_loan_ids) => {
            if (!outstanding_loan_ids.length) {
                const errMsg = `[GET] outstanding_loan_ids | No outstanding loans found`;
                console.error(errMsg);
                this.updateState({
                    ratioAnalysisPayload: {
                        ...this.state().ratioAnalysisPayload,
                        outstanding_loan_ids: [],
                    },
                    errors: [...this.state().errors, errMsg],
                });
                return;
            }
            const ratioAnalysisPayload = {
                ...this.state().ratioAnalysisPayload,
                outstanding_loan_ids: outstanding_loan_ids || [],
            };
            this.updateState({
                ratioAnalysisPayload,
            });
        }), catchError((err) => {
            console.error(`[GET] outstanding_loan_ids`, err);
            this.updateState({
                errors: [...this.state().errors, err],
            });
            return EMPTY;
        }))), switchMap(() => this.applicationGuarantorService.getSummaries(this.state().applicationId).pipe(tap((summaries) => {
            if (!summaries.length) {
                const errMsg = `[GET] member_bip_guarantor_summaries | No guarantor summaries found`;
                console.error(errMsg);
                this.updateState({
                    ratioAnalysisPayload: {
                        ...this.state().ratioAnalysisPayload,
                        pg_ids: [],
                        cg_ids: [],
                    },
                    errors: [...this.state().errors, errMsg],
                });
                return;
            }
            const { pg_ids, cg_ids } = summaries.reduce((acc, curr) => {
                if (curr.guarantor_summary_type === 'PG') {
                    acc.pg_ids.push(curr.guarantor_summary_id);
                }
                else {
                    acc.cg_ids.push(curr.guarantor_summary_id);
                }
                return acc;
            }, {
                pg_ids: [],
                cg_ids: [],
            });
            const ratioAnalysisPayload = {
                ...this.state().ratioAnalysisPayload,
                pg_ids: pg_ids || [],
                cg_ids: cg_ids || [],
            };
            this.updateState({
                ratioAnalysisPayload,
            });
        }), catchError((err) => {
            console.error(`[GET] member_bip_guarantor_summaries`, err);
            this.updateState({
                errors: [...this.state().errors, err],
            });
            return EMPTY;
        }))), switchMap(() => this.bankTabulationsService
            .getBankAnalysisReports(this.state().applicationId, true)
            .pipe(tap((bank_accounts) => {
            if (!bank_accounts?.length) {
                const errMsg = `[GET] bank_accounts | No bank accounts found`;
                console.error(errMsg);
                this.updateState({
                    ratioAnalysisPayload: {
                        ...this.state().ratioAnalysisPayload,
                        bank_accounts: [],
                    },
                    errors: [...this.state().errors, errMsg],
                });
                return;
            }
            const ratioAnalysisPayload = {
                ...this.state().ratioAnalysisPayload,
                bank_accounts: bank_accounts || [],
            };
            this.updateState({
                ratioAnalysisPayload,
            });
        }), catchError((err) => {
            console.error(`[GET] outstanding_loan_ids`, err);
            this.updateState({
                isPayloadCreated: true,
                errors: [...this.state().errors, err],
            });
            return EMPTY;
        }))), switchMap(() => zip(this.applicationProposalService
            .getProposals(this.state().applicationId, {
            sort: 'fullname,DESC',
        })
            .pipe(map((proposals) => proposals)), this.productGroupService.getProductGroups()).pipe(tap(([proposalsData, productGroups]) => {
            if (!proposalsData.length) {
                const errMsg = `[GET] proposals | No proposals found`;
                console.error(errMsg);
                this.updateState({
                    errors: [...this.state().errors, errMsg],
                });
                return;
            }
            const resObj = proposalsData.filter((p) => p?.proposal_type === this.get().proposalType)[0];
            const ratioAnalysisPayload = {
                ...this.state().ratioAnalysisPayload,
                loan_data: getLoanData(resObj, productGroups),
            };
            this.updateState({
                ratioAnalysisPayload,
                isPayloadCreated: true,
            });
        }), catchError((err) => {
            console.error(`[GET] proposals`, err);
            this.updateState({
                errors: [...this.state().errors, `[GET] proposals | No proposals found`],
            });
            return EMPTY;
        })))));
        // 1. POST - create ratio analysis with new payload
        // 2. POST - link ratio analysis to application
        this.createRatioAnalysis = this.effect(pipe(switchMap(() => this.creditService
            .createRatioAnalysis(this.state().ratioAnalysisPayload)
            .pipe(tap((res) => {
            if (!res) {
                const errMsg = `Not able to create ratio analysis`;
                console.error(errMsg);
                this.updateState({
                    errors: [...this.state().errors, errMsg],
                });
                return;
            }
            this.updateState({
                ratioAnalysisId: res.id,
            });
        }), catchError((err) => {
            console.error(`[createRatioAnalysis]`, err);
            this.updateState({
                errors: [...this.state().errors, err],
            });
            return EMPTY;
        }))), switchMap(() => this._linkRatioAnalysisToAppAsync()), switchMap(() => this._getRatioAnalysisDetailAsync().pipe(catchError((err) => {
            console.error(`[_getRatioAnalysisDetailAsync]`, err);
            this.updateState({
                errors: [...this.state().errors, err],
            });
            return EMPTY;
        })))));
        // 1. PUT - update ratio analysis with new payload
        this.updateRatioAnalysis = this.effect(pipe(switchMap(() => this.creditService
            .updateRatioAnalysis(this.state().ratioAnalysisUpdatePayload)
            .pipe(catchError((err) => {
            console.error(`[updateRatioAnalysis]`, err);
            this.updateState({
                errors: [...this.state().errors, err],
            });
            return EMPTY;
        }))), switchMap(() => this._getRatioAnalysisDetailAsync().pipe(catchError((err) => {
            console.error(`[_getRatioAnalysisDetailAsync]`, err);
            this.updateState({
                errors: [...this.state().errors, err],
            });
            return EMPTY;
        })))));
        // all setters to state are handled with this
        this.updateState = (value) => this.patchState({
            ...value,
        });
    }
    // private async calls
    // ratio analysis
    clearCache() {
        this.creditService.clearCache();
        this.applicationService.clearCache();
        this.bankTabulationsService.clearCache();
        this.financialStatementService.clearCache();
        this.ratioAnalysisService.clearCache();
        this.outstandingLoansService.clearCache();
    }
    _linkRatioAnalysisToAppAsync() {
        if (!isStringValid(this.state().ratioAnalysisId)) {
            throw new Error('[_linkRatioAnalysisToAppAsync]: Ratio Analysis Id is not valid');
        }
        return this.applicationService
            .linkRatioAnalysisToApp(this.state().applicationId, this.state().ratioAnalysisId)
            .pipe(tap((res) => {
            if (!res) {
                const errMsg = `Not able to link ratio analysis to application`;
                console.error(errMsg);
                this.updateState({
                    errors: [...this.state().errors, errMsg],
                });
                return;
            }
        }), catchError((err) => {
            console.error('_linkRatioAnalysisToAppAsync', err);
            return throwError(() => `Error: [_linkRatioAnalysisToAppAsync] Not able to link ratio analysis to application`);
        }));
    }
    // 1. GET - ratio analysis detail
    _getRatioAnalysisDetailAsync() {
        if (!isStringValid(this.state().ratioAnalysisId)) {
            throw new Error('[_getRatioAnalysisDetailAsync]: Ratio Analysis Id is not valid');
        }
        return this.creditService.getRatioAnalysis(this.state().ratioAnalysisId).pipe(tap((ratioAnalysisDetail) => {
            if (!ratioAnalysisDetail) {
                const errMsg = `No Ratio Analysis Detail found`;
                console.error(errMsg);
                this.updateState({
                    errors: [...this.state().errors, errMsg],
                });
                return;
            }
            this.updateState({
                ratioAnalysisDetail,
            });
        }), catchError((err) => {
            console.error('_getRatioAnalysisDetailAsync', err);
            return throwError(() => `Error: [_getRatioAnalysisDetailAsync] No Ratio Analysis Detail found`);
        }));
    }
    // 1. GET - ratio analysis id
    _getRatioAnalysisIdAsync() {
        if (!isStringValid(this.state().applicationId)) {
            throw new Error('[_getRatioAnalysisIdAsync]: Application Id is not valid');
        }
        return this.applicationService.getRatioAnalysisId(this.state().applicationId).pipe(tap((ratioAnalysisId) => {
            if (!isStringValid(ratioAnalysisId)) {
                const errMsg = `204 | No ratio analysis id found`;
                console.error(errMsg);
                this.updateState({
                    errors: [...this.state().errors, errMsg],
                });
                return;
            }
            this.updateState({
                ratioAnalysisId,
                errors: [],
            });
        }), catchError((err) => {
            console.error('_getRatioAnalysisIdAsync', err);
            return throwError(() => `Error: [_getRatioAnalysisIdAsync] 204 | No ratio analysis id found`);
        }));
    }
};
RatioAnalysisStore = __decorate([
    __param(0, Inject(APPLICATION_SERVICE_TOKEN)),
    __param(1, Inject(CREDIT_SERVICE_TOKEN)),
    __param(2, Inject(BANK_TABULATIONS_SERVICE_TOKEN)),
    __param(3, Inject(FINANCIAL_STATEMENT_SERVICE_TOKEN)),
    __param(4, Inject(RATIO_ANALYSIS_SERVICE_TOKEN)),
    __param(5, Inject(APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN)),
    __param(6, Inject(APPLICATION_PROPOSAL_SERVICE_TOKEN)),
    __param(7, Inject(APPLICATION_RELATIONSHIP_SERVICE_TOKEN)),
    __param(8, Inject(APPLICATION_MEMBER_SERVICE_TOKEN)),
    __param(9, Inject(APPLICATION_GUARANTOR_SERVICE_TOKEN)),
    __param(10, Inject(OUTSTANDING_LOAN_SERVICE_TOKEN)),
    __param(11, Inject(PRODUCT_GROUP_SERVICE_TOKEN)),
    __metadata("design:paramtypes", [Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object])
], RatioAnalysisStore);

class IDRatioAnalysisStore extends RatioAnalysisStore {
    constructor(applicationService, creditService, bankTabulationsService, financialStatementService, ratioAnalysisService, appRepaymentScheduleService, applicationProposalService, applicationRelationshipService, applicationMemberService, applicationGuarantorService, outstandingLoansService, productGroupService) {
        // Call the parent constructor with the injected service and country code
        super(applicationService, creditService, bankTabulationsService, financialStatementService, ratioAnalysisService, appRepaymentScheduleService, applicationProposalService, applicationRelationshipService, applicationMemberService, applicationGuarantorService, outstandingLoansService, productGroupService, {
            countryCode: CountryCode.ID,
        });
        this.applicationService = applicationService;
        this.creditService = creditService;
        this.bankTabulationsService = bankTabulationsService;
        this.financialStatementService = financialStatementService;
        this.ratioAnalysisService = ratioAnalysisService;
        this.appRepaymentScheduleService = appRepaymentScheduleService;
        this.applicationProposalService = applicationProposalService;
        this.applicationRelationshipService = applicationRelationshipService;
        this.applicationMemberService = applicationMemberService;
        this.applicationGuarantorService = applicationGuarantorService;
        this.outstandingLoansService = outstandingLoansService;
        this.productGroupService = productGroupService;
        this._destroySubject = new Subject();
        this._setApplicationId$ = new Subject();
        this._setError$ = new Subject();
        this._isRatioAnalysisPayloadCreated = new Subject();
        this._isRatioAnalysisUpdatePayloadCreated = new Subject();
    }
    init() {
        this.state$
            .pipe(takeUntil(this._setApplicationId$), map((state) => state.applicationId))
            .subscribe((applicationId) => {
            if (!applicationId)
                return;
            this._setApplicationId$.next(applicationId);
            this.getRatioAnalysisDetail();
        });
        this.state$
            .pipe(takeUntil(this._setError$), map((state) => state.errors))
            .subscribe((errors) => {
            if (errors.findIndex((err) => err === '204 | No ratio analysis id found') > -1) {
                this._setError$.next(true);
                this.createRatioAnalysisPayload();
            }
        });
        this.state$
            .pipe(takeUntil(this._isRatioAnalysisPayloadCreated), map((state) => state.isPayloadCreated))
            .subscribe((isPayloadCreated) => {
            if (isPayloadCreated && !this.state().ratioAnalysisId) {
                this._isRatioAnalysisPayloadCreated.next(true);
                this.createRatioAnalysis();
            }
            else if (isPayloadCreated && this.state().ratioAnalysisId) {
                this._isRatioAnalysisPayloadCreated.next(true);
                const updatePayload = {
                    ...this.state().ratioAnalysisPayload,
                    id: this.state().ratioAnalysisId,
                };
                this.updateState({
                    ratioAnalysisUpdatePayload: updatePayload,
                    isUpdatePayloadCreated: true,
                });
            }
        });
        this.state$
            .pipe(takeUntil(this._isRatioAnalysisUpdatePayloadCreated), map((state) => state.isUpdatePayloadCreated))
            .subscribe((isUpdatePayloadCreated) => {
            if (isUpdatePayloadCreated) {
                this._isRatioAnalysisUpdatePayloadCreated.next(true);
                this.updateRatioAnalysis();
            }
        });
    }
    ngOnDestroy() {
        this._destroySubject.next();
        this._destroySubject.complete();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDRatioAnalysisStore, deps: [{ token: APPLICATION_SERVICE_TOKEN }, { token: CREDIT_SERVICE_TOKEN }, { token: BANK_TABULATIONS_SERVICE_TOKEN }, { token: FINANCIAL_STATEMENT_SERVICE_TOKEN }, { token: RATIO_ANALYSIS_SERVICE_TOKEN }, { token: APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN }, { token: APPLICATION_PROPOSAL_SERVICE_TOKEN }, { token: APPLICATION_RELATIONSHIP_SERVICE_TOKEN }, { token: APPLICATION_MEMBER_SERVICE_TOKEN }, { token: APPLICATION_GUARANTOR_SERVICE_TOKEN }, { token: OUTSTANDING_LOAN_SERVICE_TOKEN }, { token: PRODUCT_GROUP_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDRatioAnalysisStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDRatioAnalysisStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CREDIT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [BANK_TABULATIONS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FINANCIAL_STATEMENT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [RATIO_ANALYSIS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_PROPOSAL_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_RELATIONSHIP_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_GUARANTOR_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [OUTSTANDING_LOAN_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PRODUCT_GROUP_SERVICE_TOKEN]
                }] }]; } });

class VURatioAnalysisStore extends RatioAnalysisStore {
    constructor(applicationService, creditService, bankTabulationsService, financialStatementService, ratioAnalysisService, appRepaymentScheduleService, applicationProposalService, applicationRelationshipService, applicationMemberService, applicationGuarantorService, outstandingLoansService, productGroupService) {
        // Call the parent constructor with the injected service and country code
        super(applicationService, creditService, bankTabulationsService, financialStatementService, ratioAnalysisService, appRepaymentScheduleService, applicationProposalService, applicationRelationshipService, applicationMemberService, applicationGuarantorService, outstandingLoansService, productGroupService, {
            countryCode: CountryCode.VU,
        });
        this.applicationService = applicationService;
        this.creditService = creditService;
        this.bankTabulationsService = bankTabulationsService;
        this.financialStatementService = financialStatementService;
        this.ratioAnalysisService = ratioAnalysisService;
        this.appRepaymentScheduleService = appRepaymentScheduleService;
        this.applicationProposalService = applicationProposalService;
        this.applicationRelationshipService = applicationRelationshipService;
        this.applicationMemberService = applicationMemberService;
        this.applicationGuarantorService = applicationGuarantorService;
        this.outstandingLoansService = outstandingLoansService;
        this.productGroupService = productGroupService;
        this._destroySubject = new Subject();
        this._setApplicationId$ = new Subject();
        this._setError$ = new Subject();
        this._isRatioAnalysisPayloadCreated = new Subject();
        this._isRatioAnalysisUpdatePayloadCreated = new Subject();
    }
    init() {
        this.state$
            .pipe(takeUntil(this._setApplicationId$), map((state) => state.applicationId))
            .subscribe((applicationId) => {
            if (!applicationId)
                return;
            this._setApplicationId$.next(applicationId);
            this.getRatioAnalysisDetail();
        });
        this.state$
            .pipe(takeUntil(this._setError$), map((state) => state.errors))
            .subscribe((errors) => {
            if (errors.findIndex((err) => err === '204 | No ratio analysis id found') > -1) {
                this._setError$.next(true);
                this.createRatioAnalysisPayload();
            }
        });
        this.state$
            .pipe(takeUntil(this._isRatioAnalysisPayloadCreated), map((state) => state.isPayloadCreated))
            .subscribe((isPayloadCreated) => {
            if (isPayloadCreated && !this.state().ratioAnalysisId) {
                this._isRatioAnalysisPayloadCreated.next(true);
                this.createRatioAnalysis();
            }
            else if (isPayloadCreated && this.state().ratioAnalysisId) {
                this._isRatioAnalysisPayloadCreated.next(true);
                const updatePayload = {
                    ...this.state().ratioAnalysisPayload,
                    id: this.state().ratioAnalysisId,
                };
                this.updateState({
                    ratioAnalysisUpdatePayload: updatePayload,
                    isUpdatePayloadCreated: true,
                });
            }
        });
        this.state$
            .pipe(takeUntil(this._isRatioAnalysisUpdatePayloadCreated), map((state) => state.isUpdatePayloadCreated))
            .subscribe((isUpdatePayloadCreated) => {
            if (isUpdatePayloadCreated) {
                this._isRatioAnalysisUpdatePayloadCreated.next(true);
                this.updateRatioAnalysis();
            }
        });
    }
    ngOnDestroy() {
        this._destroySubject.next();
        this._destroySubject.complete();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: VURatioAnalysisStore, deps: [{ token: APPLICATION_SERVICE_TOKEN }, { token: CREDIT_SERVICE_TOKEN }, { token: BANK_TABULATIONS_SERVICE_TOKEN }, { token: FINANCIAL_STATEMENT_SERVICE_TOKEN }, { token: RATIO_ANALYSIS_SERVICE_TOKEN }, { token: APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN }, { token: APPLICATION_PROPOSAL_SERVICE_TOKEN }, { token: APPLICATION_RELATIONSHIP_SERVICE_TOKEN }, { token: APPLICATION_MEMBER_SERVICE_TOKEN }, { token: APPLICATION_GUARANTOR_SERVICE_TOKEN }, { token: OUTSTANDING_LOAN_SERVICE_TOKEN }, { token: PRODUCT_GROUP_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: VURatioAnalysisStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: VURatioAnalysisStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CREDIT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [BANK_TABULATIONS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FINANCIAL_STATEMENT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [RATIO_ANALYSIS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_PROPOSAL_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_RELATIONSHIP_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_GUARANTOR_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [OUTSTANDING_LOAN_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PRODUCT_GROUP_SERVICE_TOKEN]
                }] }]; } });

class MYRatioAnalysisStore extends RatioAnalysisStore {
    constructor(applicationService, creditService, bankTabulationsService, financialStatementService, ratioAnalysisService, appRepaymentScheduleService, applicationProposalService, applicationRelationshipService, applicationMemberService, applicationGuarantorService, outstandingLoansService, productGroupService) {
        // Call the parent constructor with the injected service and country code
        super(applicationService, creditService, bankTabulationsService, financialStatementService, ratioAnalysisService, appRepaymentScheduleService, applicationProposalService, applicationRelationshipService, applicationMemberService, applicationGuarantorService, outstandingLoansService, productGroupService, {
            countryCode: CountryCode.MY,
        });
        this.applicationService = applicationService;
        this.creditService = creditService;
        this.bankTabulationsService = bankTabulationsService;
        this.financialStatementService = financialStatementService;
        this.ratioAnalysisService = ratioAnalysisService;
        this.appRepaymentScheduleService = appRepaymentScheduleService;
        this.applicationProposalService = applicationProposalService;
        this.applicationRelationshipService = applicationRelationshipService;
        this.applicationMemberService = applicationMemberService;
        this.applicationGuarantorService = applicationGuarantorService;
        this.outstandingLoansService = outstandingLoansService;
        this.productGroupService = productGroupService;
        this._destroySubject = new Subject();
        this._setApplicationId$ = new Subject();
        this._setError$ = new Subject();
    }
    init(isReadonly) {
        this.state$
            .pipe(takeUntil(this._setApplicationId$), map((state) => state.applicationId))
            .subscribe((applicationId) => {
            if (!applicationId)
                return;
            this._setApplicationId$.next(applicationId);
            this.getRatioAnalysisDetail();
        });
        this.state$
            .pipe(takeUntil(this._setError$), map((state) => state.errors))
            .subscribe((errors) => {
            if (errors.findIndex((err) => err === '204 | No ratio analysis id found') > -1) {
                this._setError$.next(true);
                !isReadonly && this.createRatioAnalysisPayload();
            }
        });
        this.select((state) => state.isPayloadCreated)
            .pipe(takeUntil(this._destroySubject), filter((isPayloadCreated) => isPayloadCreated))
            .subscribe((isPayloadCreated) => {
            if (isPayloadCreated && !this.state().ratioAnalysisId) {
                this.createRatioAnalysis();
            }
            else if (isPayloadCreated && this.state().ratioAnalysisId) {
                const updatePayload = {
                    ...this.state().ratioAnalysisPayload,
                    id: this.state().ratioAnalysisId,
                };
                // update the state with the update payload
                this.updateState({
                    ratioAnalysisUpdatePayload: updatePayload,
                    isUpdatePayloadCreated: true,
                });
            }
        });
        this.select((state) => state.isUpdatePayloadCreated)
            .pipe(takeUntil(this._destroySubject), filter((isUpdatePayloadCreated) => isUpdatePayloadCreated))
            .subscribe(() => {
            this.updateRatioAnalysis();
        });
    }
    ngOnDestroy() {
        this._destroySubject.next();
        this._destroySubject.complete();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MYRatioAnalysisStore, deps: [{ token: APPLICATION_SERVICE_TOKEN }, { token: CREDIT_SERVICE_TOKEN }, { token: BANK_TABULATIONS_SERVICE_TOKEN }, { token: FINANCIAL_STATEMENT_SERVICE_TOKEN }, { token: RATIO_ANALYSIS_SERVICE_TOKEN }, { token: APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN }, { token: APPLICATION_PROPOSAL_SERVICE_TOKEN }, { token: APPLICATION_RELATIONSHIP_SERVICE_TOKEN }, { token: APPLICATION_MEMBER_SERVICE_TOKEN }, { token: APPLICATION_GUARANTOR_SERVICE_TOKEN }, { token: OUTSTANDING_LOAN_SERVICE_TOKEN }, { token: PRODUCT_GROUP_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MYRatioAnalysisStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MYRatioAnalysisStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CREDIT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [BANK_TABULATIONS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FINANCIAL_STATEMENT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [RATIO_ANALYSIS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_PROPOSAL_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_RELATIONSHIP_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_GUARANTOR_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [OUTSTANDING_LOAN_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PRODUCT_GROUP_SERVICE_TOKEN]
                }] }]; } });

const STORE_TOKEN$5 = new InjectionToken('STORE_TOKEN');

const ID_PROVIDERS$7 = [
    {
        provide: STORE_TOKEN$5,
        useClass: MYRatioAnalysisStore,
        deps: [
            APPLICATION_SERVICE_TOKEN,
            CREDIT_SERVICE_TOKEN,
            BANK_TABULATIONS_SERVICE_TOKEN,
            FINANCIAL_STATEMENT_SERVICE_TOKEN,
            RATIO_ANALYSIS_SERVICE_TOKEN,
            APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN,
            APPLICATION_PROPOSAL_SERVICE_TOKEN,
            APPLICATION_RELATIONSHIP_SERVICE_TOKEN,
            APPLICATION_MEMBER_SERVICE_TOKEN,
            APPLICATION_GUARANTOR_SERVICE_TOKEN,
            OUTSTANDING_LOAN_SERVICE_TOKEN,
            PRODUCT_GROUP_SERVICE_TOKEN,
        ],
    },
];

const MY_PROVIDERS$3 = [
    {
        provide: STORE_TOKEN$5,
        useClass: MYRatioAnalysisStore,
        deps: [
            APPLICATION_SERVICE_TOKEN,
            CREDIT_SERVICE_TOKEN,
            BANK_TABULATIONS_SERVICE_TOKEN,
            FINANCIAL_STATEMENT_SERVICE_TOKEN,
            RATIO_ANALYSIS_SERVICE_TOKEN,
            APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN,
            APPLICATION_PROPOSAL_SERVICE_TOKEN,
            APPLICATION_RELATIONSHIP_SERVICE_TOKEN,
            APPLICATION_MEMBER_SERVICE_TOKEN,
            APPLICATION_GUARANTOR_SERVICE_TOKEN,
            OUTSTANDING_LOAN_SERVICE_TOKEN,
            PRODUCT_GROUP_SERVICE_TOKEN,
        ],
    },
];

const VU_PROVIDERS$4 = [
    {
        provide: STORE_TOKEN$5,
        useClass: MYRatioAnalysisStore,
        deps: [
            APPLICATION_SERVICE_TOKEN,
            CREDIT_SERVICE_TOKEN,
            BANK_TABULATIONS_SERVICE_TOKEN,
            FINANCIAL_STATEMENT_SERVICE_TOKEN,
            RATIO_ANALYSIS_SERVICE_TOKEN,
            APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN,
            APPLICATION_PROPOSAL_SERVICE_TOKEN,
            APPLICATION_RELATIONSHIP_SERVICE_TOKEN,
            APPLICATION_MEMBER_SERVICE_TOKEN,
            APPLICATION_GUARANTOR_SERVICE_TOKEN,
            OUTSTANDING_LOAN_SERVICE_TOKEN,
            PRODUCT_GROUP_SERVICE_TOKEN,
        ],
    },
];

const PROVIDERS_MAP$7 = {
    default: MY_PROVIDERS$3,
    [CountryCode.MY]: MY_PROVIDERS$3,
    [CountryCode.VU]: VU_PROVIDERS$4,
    [CountryCode.ID]: ID_PROVIDERS$7,
};
const ratioAnalysisProviders = (countryCode) => [
    ...getCustomProviders(PROVIDERS_MAP$7, MY_PROVIDERS$3, countryCode),
];

const COLUMN_MAP = {
    'DSCR by Income Factor': 'dscr_by_income_factor',
    'Bank balance cover (average monthly bal)': 'average_monthly_balance_cover',
    'Bank balance cover (latest monthly bal)': 'latest_monthly_balance_cover',
    'Bank balance cover (average daily running bal)': 'average_daily_running_balance_cover',
    '% no.of days EOD balance > FS monthly commitment': 'no_of_days_eod_balances_greater_than_fs_commit',
    'Industry income factor': 'industry_income_factor',
    'Existing Working Capital Line': 'existing_working_capital_line',
};

// @angular
class FSWRatioAnalysisComponent {
    set applicationId(value) {
        this.componentStore.updateState({
            applicationId: value,
        });
    }
    set isReadonly(value) {
        this._isReadonly = value;
    }
    get isReadonly() {
        return this._isReadonly;
    }
    set proposalType(proposalType) {
        this.componentStore.updateState({
            proposalType,
        });
    }
    constructor(componentStore) {
        this.componentStore = componentStore;
        this._isReadonly = false;
        this.columnNamesList = Object.keys(COLUMN_MAP);
        this.columnValuesList = Object.values(COLUMN_MAP);
    }
    ngOnInit() {
        this.componentStore.init(this.isReadonly);
    }
    ngOnDestroy() {
        this.componentStore.clearCache();
    }
    isValPositive(val) {
        return Number(val) > 0;
    }
    refresh() {
        if (this.componentStore.state().ratioAnalysisPayload) {
            this.componentStore.updateState({
                isPayloadCreated: false,
                isUpdatePayloadCreated: false,
                ratioAnalysisPayload: null,
                ratioAnalysisUpdatePayload: null,
            });
        }
        this.componentStore.createRatioAnalysisPayload();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRatioAnalysisComponent, deps: [{ token: STORE_TOKEN$5 }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWRatioAnalysisComponent, selector: "fsw-ratio-analysis", inputs: { applicationId: "applicationId", isReadonly: "isReadonly", proposalType: "proposalType" }, providers: [...ratioAnalysisProviders(getCountryCodeFromStorage())], ngImport: i0, template: "<ng-container *ngIf=\"componentStore.state$ | async as state\">\n  <section class=\"mb-4 flex justify-between items-center w-[46%]\">\n    <header>\n      <h6>{{ 'Ratio Analysis' }}</h6>\n    </header>\n    <button\n      *ngIf=\"state.ratioAnalysisDetail && !isReadonly\"\n      fswButton\n      appearance=\"secondary\"\n      [size]=\"'s'\"\n      (click)=\"refresh()\"\n    >\n      {{ 'Refresh' }}\n    </button>\n    <!-- [disabled]=\"isReadonly\" -->\n  </section>\n\n  <section *ngIf=\"state?.errors?.length\" class=\"bg-red-100 text-red-500 p-2 h-auto mb-4 w-[46%]\">\n    <div class=\"text-[12px] p-1\" *ngFor=\"let err of state?.errors || []\">\n      {{ err }}\n    </div>\n  </section>\n\n  <ng-container *ngIf=\"componentStore.state().ratioAnalysisDetail\">\n    <main class=\"w-full flex flex-col gap-2\">\n      <section class=\"flex gap-[4px]\">\n        <div class=\"flex flex-col w-[320px] gap-[4px]\">\n          <div class=\"border border-gray-100 p-3\" *ngFor=\"let columnName of columnNamesList\">\n            <span class=\"text-[12px]\">{{ columnName }}</span>\n          </div>\n        </div>\n        <div class=\"flex flex-col w-[320px] gap-[4px]\">\n          <div class=\"border border-gray-100 p-3\" *ngFor=\"let columnValue of columnValuesList\">\n            <span class=\"text-[12px]\">{{\n                 isValPositive(state?.ratioAnalysisDetail?.[columnValue] || 0)\n                  ? ((state?.ratioAnalysisDetail?.[columnValue] || 0) | currency : 'USD' | slice : 1)\n                  : ((state?.ratioAnalysisDetail?.[columnValue] || 0) | removeCurrencySymbol | number : '1.2-2')\n            }}</span>\n          </div>\n        </div>\n      </section>\n    </main>\n  </ng-container>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i1$1.SlicePipe, name: "slice" }, { kind: "pipe", type: i1$1.DecimalPipe, name: "number" }, { kind: "pipe", type: i1$1.CurrencyPipe, name: "currency" }, { kind: "pipe", type: RemoveCurrencySymbolPipe, name: "removeCurrencySymbol" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRatioAnalysisComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-ratio-analysis', changeDetection: ChangeDetectionStrategy.OnPush, providers: [...ratioAnalysisProviders(getCountryCodeFromStorage())], template: "<ng-container *ngIf=\"componentStore.state$ | async as state\">\n  <section class=\"mb-4 flex justify-between items-center w-[46%]\">\n    <header>\n      <h6>{{ 'Ratio Analysis' }}</h6>\n    </header>\n    <button\n      *ngIf=\"state.ratioAnalysisDetail && !isReadonly\"\n      fswButton\n      appearance=\"secondary\"\n      [size]=\"'s'\"\n      (click)=\"refresh()\"\n    >\n      {{ 'Refresh' }}\n    </button>\n    <!-- [disabled]=\"isReadonly\" -->\n  </section>\n\n  <section *ngIf=\"state?.errors?.length\" class=\"bg-red-100 text-red-500 p-2 h-auto mb-4 w-[46%]\">\n    <div class=\"text-[12px] p-1\" *ngFor=\"let err of state?.errors || []\">\n      {{ err }}\n    </div>\n  </section>\n\n  <ng-container *ngIf=\"componentStore.state().ratioAnalysisDetail\">\n    <main class=\"w-full flex flex-col gap-2\">\n      <section class=\"flex gap-[4px]\">\n        <div class=\"flex flex-col w-[320px] gap-[4px]\">\n          <div class=\"border border-gray-100 p-3\" *ngFor=\"let columnName of columnNamesList\">\n            <span class=\"text-[12px]\">{{ columnName }}</span>\n          </div>\n        </div>\n        <div class=\"flex flex-col w-[320px] gap-[4px]\">\n          <div class=\"border border-gray-100 p-3\" *ngFor=\"let columnValue of columnValuesList\">\n            <span class=\"text-[12px]\">{{\n                 isValPositive(state?.ratioAnalysisDetail?.[columnValue] || 0)\n                  ? ((state?.ratioAnalysisDetail?.[columnValue] || 0) | currency : 'USD' | slice : 1)\n                  : ((state?.ratioAnalysisDetail?.[columnValue] || 0) | removeCurrencySymbol | number : '1.2-2')\n            }}</span>\n          </div>\n        </div>\n      </section>\n    </main>\n  </ng-container>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [STORE_TOKEN$5]
                }] }]; }, propDecorators: { applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], proposalType: [{
                type: Input
            }] } });

// @angular
const DECLARATIONS_EXPORTS$3 = [FSWRatioAnalysisComponent];
class FSWRatioAnalysisModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRatioAnalysisModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWRatioAnalysisModule, declarations: [FSWRatioAnalysisComponent], imports: [CommonModule,
            ReactiveFormsModule,
            LetDirective,
            FormWidgetModule,
            // toolkit-ui
            FSWTabsModule,
            // services modules
            UtilsServiceModule,
            ApplicationServiceModule,
            FSWCreditServiceModule,
            BankTabulationsServiceModule,
            FinancialStatementServiceModule,
            RatioAnalysisServiceModule,
            ApplicationRepaymentScheduleServiceModule,
            ApplicationGuarantorServiceModule,
            OutstandingLoansServiceModule,
            ApplicationMemberServiceModule,
            ApplicationProposalServiceModule,
            ProductGroupServiceModule,
            // custom modules
            FSWCurrencyMaskModule,
            FSWButtonModule,
            CdkTableModule,
            RemoveCurrencySymbolModule], exports: [FSWRatioAnalysisComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRatioAnalysisModule, providers: [provideApplicationRelationshipService()], imports: [CommonModule,
            ReactiveFormsModule,
            FormWidgetModule,
            // toolkit-ui
            FSWTabsModule,
            // services modules
            UtilsServiceModule,
            ApplicationServiceModule,
            FSWCreditServiceModule,
            BankTabulationsServiceModule,
            FinancialStatementServiceModule,
            RatioAnalysisServiceModule,
            ApplicationRepaymentScheduleServiceModule,
            ApplicationGuarantorServiceModule,
            OutstandingLoansServiceModule,
            ApplicationMemberServiceModule,
            ApplicationProposalServiceModule,
            ProductGroupServiceModule,
            // custom modules
            FSWCurrencyMaskModule,
            FSWButtonModule,
            CdkTableModule,
            RemoveCurrencySymbolModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRatioAnalysisModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        LetDirective,
                        FormWidgetModule,
                        // toolkit-ui
                        FSWTabsModule,
                        // services modules
                        UtilsServiceModule,
                        ApplicationServiceModule,
                        FSWCreditServiceModule,
                        BankTabulationsServiceModule,
                        FinancialStatementServiceModule,
                        RatioAnalysisServiceModule,
                        ApplicationRepaymentScheduleServiceModule,
                        ApplicationGuarantorServiceModule,
                        OutstandingLoansServiceModule,
                        ApplicationMemberServiceModule,
                        ApplicationProposalServiceModule,
                        ProductGroupServiceModule,
                        // custom modules
                        FSWCurrencyMaskModule,
                        FSWButtonModule,
                        CdkTableModule,
                        RemoveCurrencySymbolModule,
                    ],
                    declarations: DECLARATIONS_EXPORTS$3,
                    exports: DECLARATIONS_EXPORTS$3,
                    providers: [provideApplicationRelationshipService()],
                }]
        }] });

var DigitalScorecardFormFields;
(function (DigitalScorecardFormFields) {
    DigitalScorecardFormFields["SCORECARD_DECISION"] = "score_card_decision";
    DigitalScorecardFormFields["LOAN_GRADE"] = "loan_grade";
    DigitalScorecardFormFields["DEFAULT_PROBABILITY"] = "default_profitability";
    DigitalScorecardFormFields["EXPECTED_LOSS"] = "expected_loss";
    DigitalScorecardFormFields["LOAN_QUANTUM"] = "loan_quantum";
    DigitalScorecardFormFields["LOAN_TENURE"] = "loan_tenure";
    DigitalScorecardFormFields["LOAN_QUANTUM_WITHOUT_CAPING"] = "credit_quantum_without_cap";
    DigitalScorecardFormFields["MONTHLY_INTEREST_RATE"] = "monthly_interest_rate";
    DigitalScorecardFormFields["REJECTION_REASONS"] = "rejection_reason";
    DigitalScorecardFormFields["ERROR_MESSAGE"] = "error_message";
    DigitalScorecardFormFields["EXPERIMENT_FLAG"] = "experiment_flag";
})(DigitalScorecardFormFields || (DigitalScorecardFormFields = {}));

const FSWFormID = (group) => {
    return new FSWDynamicBuilder({
        form: group,
        formType: FSWDynamicBuilderFormTypes.GROUP,
        renderBy: 'container',
        customClasses: 'flex justify-between gap-[16px] w-full',
        readonlyWhen$: of(true),
        containers: [
            {
                customClasses: 'flex flex-col gap-[16px]',
                fields: [
                    {
                        key: DigitalScorecardFormFields.SCORECARD_DECISION,
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            label: 'Scorecard Decision',
                            fullWidth: true,
                        },
                    },
                    {
                        key: DigitalScorecardFormFields.DEFAULT_PROBABILITY,
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            label: 'Default Probability',
                            fullWidth: true,
                            // isDisabled: true,
                        },
                    },
                    {
                        key: DigitalScorecardFormFields.LOAN_QUANTUM,
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            label: 'Loan Quantum',
                            fullWidth: true,
                            // inputType: 'number',
                            mask: {
                                expression: 'separator.2',
                                config: {
                                    thousandSeparator: ',',
                                },
                            },
                        },
                    },
                    {
                        key: DigitalScorecardFormFields.MONTHLY_INTEREST_RATE,
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            label: 'Monthly Interest Rate',
                            fullWidth: true,
                            // inputType: 'number',
                            mask: {
                                expression: 'separator.2',
                                config: {
                                    thousandSeparator: ',',
                                },
                            },
                        },
                    },
                    {
                        key: DigitalScorecardFormFields.ERROR_MESSAGE,
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            label: 'Error Message',
                            fullWidth: true,
                        },
                    },
                ],
            },
            {
                customClasses: 'flex flex-col gap-[16px]',
                fields: [
                    {
                        key: DigitalScorecardFormFields.LOAN_GRADE,
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            label: 'Loan Grade',
                            fullWidth: true,
                        },
                    },
                    {
                        key: DigitalScorecardFormFields.EXPECTED_LOSS,
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            label: 'Expected Loss',
                            fullWidth: true,
                            // inputType: 'number',
                            mask: {
                                expression: 'separator.2',
                                config: {
                                    thousandSeparator: ',',
                                },
                            },
                        },
                    },
                    {
                        key: DigitalScorecardFormFields.LOAN_QUANTUM_WITHOUT_CAPING,
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            label: 'Loan Quantum (Without Caping)',
                            fullWidth: true,
                            // inputType: 'number',
                            mask: {
                                expression: 'separator.2',
                                config: {
                                    thousandSeparator: ',',
                                },
                            },
                        },
                    },
                    {
                        key: DigitalScorecardFormFields.LOAN_TENURE,
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            label: 'Loan Tenure',
                            fullWidth: true,
                            // inputType: 'number',
                            mask: {
                                expression: 'separator.2',
                                config: {
                                    thousandSeparator: ',',
                                },
                            },
                        },
                    },
                    {
                        key: DigitalScorecardFormFields.REJECTION_REASONS,
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            label: 'Rejection Reasons',
                            fullWidth: true,
                        },
                    },
                ],
            },
        ],
    });
};

const FSWFormMY = (group) => {
    return new FSWDynamicBuilder({
        form: group,
        formType: FSWDynamicBuilderFormTypes.GROUP,
        renderBy: 'container',
        customClasses: 'flex justify-between gap-[16px] w-full',
        readonlyWhen$: of(true),
        containers: [
            {
                customClasses: 'flex flex-col gap-[16px] flex-1',
                fields: [
                    {
                        key: DigitalScorecardFormFields.SCORECARD_DECISION,
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            label: 'Scorecard Decision',
                            fullWidth: true,
                        },
                    },
                    {
                        key: DigitalScorecardFormFields.DEFAULT_PROBABILITY,
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            label: 'Default Probability',
                            fullWidth: true,
                            // isDisabled: true,
                        },
                    },
                    {
                        key: DigitalScorecardFormFields.LOAN_QUANTUM,
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            label: 'Loan Quantum',
                            fullWidth: true,
                            // inputType: 'number',
                            mask: {
                                expression: 'separator.2',
                                config: {
                                    thousandSeparator: ',',
                                },
                            },
                        },
                    },
                    {
                        key: DigitalScorecardFormFields.MONTHLY_INTEREST_RATE,
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            label: 'Monthly Interest Rate',
                            fullWidth: true,
                            // inputType: 'number',
                            mask: {
                                expression: 'separator.2',
                                config: {
                                    thousandSeparator: ',',
                                },
                            },
                        },
                    },
                    {
                        key: DigitalScorecardFormFields.ERROR_MESSAGE,
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            label: 'Error Message',
                            fullWidth: true,
                            inputType: 'area',
                        },
                    },
                ],
            },
            {
                customClasses: 'flex flex-col gap-[16px] flex-1',
                fields: [
                    {
                        key: DigitalScorecardFormFields.LOAN_GRADE,
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            label: 'Loan Grade',
                            fullWidth: true,
                        },
                    },
                    {
                        key: DigitalScorecardFormFields.EXPECTED_LOSS,
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            label: 'Expected Loss',
                            fullWidth: true,
                            // inputType: 'number',
                            mask: {
                                expression: 'separator.2',
                                config: {
                                    thousandSeparator: ',',
                                },
                            },
                        },
                    },
                    {
                        key: DigitalScorecardFormFields.LOAN_QUANTUM_WITHOUT_CAPING,
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            label: 'Loan Quantum (Without Caping)',
                            fullWidth: true,
                            // inputType: 'number',
                            mask: {
                                expression: 'separator.2',
                                config: {
                                    thousandSeparator: ',',
                                },
                            },
                        },
                    },
                    {
                        key: DigitalScorecardFormFields.LOAN_TENURE,
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            label: 'Loan Tenure',
                            fullWidth: true,
                            // inputType: 'number',
                            mask: {
                                expression: 'separator.2',
                                config: {
                                    thousandSeparator: ',',
                                },
                            },
                        },
                    },
                    {
                        key: DigitalScorecardFormFields.REJECTION_REASONS,
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            label: 'Rejection Reasons',
                            fullWidth: true,
                        },
                    },
                    {
                        key: DigitalScorecardFormFields.EXPERIMENT_FLAG,
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            inputType: 'area',
                            label: 'Experiment Flag',
                            fullWidth: true,
                            rows: 3,
                            isReadonly: true,
                        },
                    },
                ],
            },
        ],
    });
};

const FSWFormSG = (group, isReadonly) => {
    const modelNameOptions = [
        { value: 'EFS', text: 'Credit model would be triggered with ESG calculation' },
        { value: 'BOLT', text: 'Credit model would be triggered with normal BOLT calculation' },
        // { value: 'N/A', text: 'Credit model wouldn’t be triggered' },
    ];
    return new FSWDynamicBuilder({
        form: group,
        formType: FSWDynamicBuilderFormTypes.GROUP,
        renderBy: 'container',
        customClasses: 'flex flex-col gap-[16px] w-full',
        readonlyWhen$: of(isReadonly),
        containers: [
            {
                customClasses: 'flex gap-[16px] w-full',
                fields: [
                    {
                        key: 'model_name',
                        type: FSWDynamicBuilderControlTypes.SELECT,
                        customClasses: 'w-[calc(50%-4px)]',
                        context: {
                            defaultValue: 'EFS',
                            items: modelNameOptions,
                            label: 'Model Name',
                            fullWidth: true,
                            allowedClear: false,
                            isRequired: true,
                            readonlyTemplate: (value) => modelNameOptions.find((item) => item.value === value)?.text ?? '--',
                        },
                        validations: [Validators.required],
                    },
                    {
                        key: 'rate',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        customClasses: 'w-[calc(50%-4px)]',
                        context: {
                            label: 'Interest Rate',
                            fullWidth: true,
                            isReadonly: true,
                            readonlyTemplate: (value) => value ?? '--',
                        },
                    },
                ],
            },
            {
                customClasses: 'flex gap-[16px] w-full',
                fields: [
                    {
                        key: 'quantum',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        customClasses: 'w-[calc(50%-4px)]',
                        context: {
                            label: 'Quantum',
                            fullWidth: true,
                            isReadonly: true,
                            readonlyTemplate: (value) => value ?? '--',
                        },
                    },
                    {
                        key: 'status',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        customClasses: 'w-[calc(50%-4px)]',
                        context: {
                            label: 'Result status',
                            fullWidth: true,
                            isReadonly: true,
                            readonlyTemplate: (value) => value ?? '--',
                        },
                    },
                ],
            },
            {
                customClasses: 'flex gap-[16px] w-full',
                fields: [
                    {
                        key: 'reason',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        customClasses: 'w-[calc(50%-4px)]',
                        context: {
                            label: 'Reason',
                            fullWidth: true,
                            isReadonly: true,
                            readonlyTemplate: (value) => value ?? '--',
                        },
                    },
                    {
                        key: 'tenor',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        customClasses: 'w-[calc(50%-4px)]',
                        context: {
                            label: 'Tenor',
                            fullWidth: true,
                            isReadonly: true,
                            readonlyTemplate: (value) => value ?? '--',
                        },
                    },
                ],
            },
            {
                customClasses: 'flex justify-end w-full',
                fields: [
                    {
                        key: 'error_message',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        customClasses: 'w-[calc(50%-4px)]',
                        context: {
                            label: 'Error',
                            fullWidth: true,
                            isReadonly: true,
                            readonlyTemplate: (value) => value ?? '--',
                        },
                    },
                ],
            },
        ],
    });
};

const FORM_TOKEN = new InjectionToken('FORM_TOKEN');

const removeNullProperties = (obj) => {
    if (typeof obj === 'object' && obj !== null) {
        if (Array.isArray(obj)) {
            for (let i = 0; i < obj.length; i++) {
                obj[i] = removeNullProperties(obj[i]);
            }
        }
        else {
            for (const prop in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                    if (obj[prop] === null) {
                        delete obj[prop];
                    }
                    else {
                        obj[prop] = removeNullProperties(obj[prop]);
                    }
                }
            }
        }
    }
    return obj;
};

const INITIAL_STATE$1 = {
    countryCode: null,
    applicationId: null,
    digitalScorecardPayload: null,
    creditModel: null,
    errors: [],
    member: null,
    ssic: null,
    cbs_dms_ids: null,
    model_name: null,
};
let DigitalScorecardStore = class DigitalScorecardStore extends ComponentStore {
    // constructor
    constructor(applicationService, creditService, _stateOverride = {}) {
        super({
            ...INITIAL_STATE$1,
            ..._stateOverride,
        });
        this.applicationService = applicationService;
        this.creditService = creditService;
        this._stateOverride = _stateOverride;
        // variables
        this.formGroup = new UntypedFormGroup({});
        // actions
        // 1. GET scorecard content
        this.getCreditModel = this.effect(pipe(switchMap((flag) => this._getCreditModelAsync(flag).pipe(catchError((err) => {
            console.error(`[POST] credit_model`, err);
            this.updateState({
                errors: [...this.state().errors, err],
            });
            return EMPTY;
        })))));
        this.createDigitalScorecardPayload = this.effect(pipe(switchMap((refresh) => this.applicationService.prepareDSModel(this.state().applicationId).pipe(tap((dsModel) => {
            if (!isObjectValid(dsModel)) {
                const errMsg = `[GET] ds_model | No ds model found`;
                console.error(errMsg);
                this.updateState({
                    errors: [...this.state().errors, errMsg],
                });
                return;
            }
            this.updateState({
                digitalScorecardPayload: refresh ? { ...dsModel, refresh } : dsModel,
            });
        }), catchError((err) => {
            console.error(`[GET] ds_model`, err);
            this.updateState({
                errors: [...this.state().errors, err],
            });
            return EMPTY;
        })))));
        // all setters to state are handled with this
        this.updateState = (value) => this.patchState({
            ...value,
        });
    }
    // private async calls
    // POST Call
    _getCreditModelAsync(flag) {
        return this.resolveModelAsync(flag).pipe(tap((creditModel) => {
            if (!creditModel || !isObjectValid(creditModel)) {
                const errMsg = `Error: [POST] credit_model | No credit model found`;
                console.error(errMsg);
                this.updateState({
                    errors: [...this.state().errors, errMsg],
                });
                return;
            }
            this.updateState({
                creditModel,
            });
        }), catchError((err) => {
            console.error(`Error: [POST] credit_model`, err);
            return EMPTY;
        }));
    }
    // end of GET calls
    // end of private async calls
    resolveModelAsync(flag) {
        return this.creditService.createCreditModel(removeNullProperties(this.state().digitalScorecardPayload));
    }
};
DigitalScorecardStore = __decorate([
    __param(0, Inject(APPLICATION_SERVICE_TOKEN)),
    __param(1, Inject(CREDIT_SERVICE_TOKEN)),
    __metadata("design:paramtypes", [Object, Object, Object])
], DigitalScorecardStore);

class IDDigitalScorecardStore extends DigitalScorecardStore {
    constructor(applicationService, creditService) {
        // Call the parent constructor with the injected service and country code
        super(applicationService, creditService, {
            countryCode: CountryCode.ID,
        });
        this.applicationService = applicationService;
        this.creditService = creditService;
        this._destroySubject = new Subject();
        this._setApplicationId$ = new Subject();
        this._setScorecardPayload$ = new Subject();
    }
    init() {
        this.state$
            .pipe(takeUntil(this._setApplicationId$), map((state) => state.applicationId))
            .subscribe((applicationId) => {
            if (!applicationId)
                return;
            this._setApplicationId$.next(applicationId);
            this.createDigitalScorecardPayload(false);
        });
        this.state$
            .pipe(takeUntil(this._setScorecardPayload$), map((state) => state.digitalScorecardPayload))
            .subscribe((payload) => {
            if (!payload)
                return;
            if (payload) {
                this._setScorecardPayload$.next(true);
                this.getCreditModel(true);
            }
        });
    }
    ngOnDestroy() {
        this._destroySubject.next();
        this._destroySubject.complete();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDDigitalScorecardStore, deps: [{ token: APPLICATION_SERVICE_TOKEN }, { token: CREDIT_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDDigitalScorecardStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDDigitalScorecardStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CREDIT_SERVICE_TOKEN]
                }] }]; } });

class VUDigitalScorecardStore extends DigitalScorecardStore {
    constructor(applicationService, creditService) {
        // Call the parent constructor with the injected service and country code
        super(applicationService, creditService, {
            countryCode: CountryCode.VU,
        });
        this.applicationService = applicationService;
        this.creditService = creditService;
        this._destroySubject = new Subject();
        this._setApplicationId$ = new Subject();
        this._setScorecardPayload$ = new Subject();
    }
    init() {
        this.state$
            .pipe(takeUntil(this._setApplicationId$), map((state) => state.applicationId))
            .subscribe((applicationId) => {
            if (!applicationId)
                return;
            this._setApplicationId$.next(applicationId);
            this.createDigitalScorecardPayload(false);
        });
        this.state$
            .pipe(takeUntil(this._setScorecardPayload$), map((state) => state.digitalScorecardPayload))
            .subscribe((payload) => {
            if (!payload)
                return;
            if (payload) {
                this._setScorecardPayload$.next(true);
                this.getCreditModel(true);
            }
        });
    }
    ngOnDestroy() {
        this._destroySubject.next();
        this._destroySubject.complete();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: VUDigitalScorecardStore, deps: [{ token: APPLICATION_SERVICE_TOKEN }, { token: CREDIT_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: VUDigitalScorecardStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: VUDigitalScorecardStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CREDIT_SERVICE_TOKEN]
                }] }]; } });

class MYDigitalScorecardStore extends DigitalScorecardStore {
    constructor(applicationService, creditService) {
        // Call the parent constructor with the injected service and country code
        super(applicationService, creditService, {
            countryCode: CountryCode.MY,
        });
        this.applicationService = applicationService;
        this.creditService = creditService;
        this._destroySubject = new Subject();
        this._setApplicationId$ = new Subject();
        this._setScorecardPayload$ = new Subject();
    }
    init() {
        this.state$
            .pipe(takeUntil(this._setApplicationId$), map((state) => state.applicationId))
            .subscribe((applicationId) => {
            if (!applicationId)
                return;
            this._setApplicationId$.next(applicationId);
            this.createDigitalScorecardPayload(false);
        });
        this.state$
            .pipe(takeUntil(this._setScorecardPayload$), map((state) => state.digitalScorecardPayload))
            .subscribe((payload) => {
            if (!payload)
                return;
            if (payload) {
                this._setScorecardPayload$.next(true);
                this.getCreditModel(true);
            }
        });
    }
    ngOnDestroy() {
        this._destroySubject.next();
        this._destroySubject.complete();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MYDigitalScorecardStore, deps: [{ token: APPLICATION_SERVICE_TOKEN }, { token: CREDIT_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MYDigitalScorecardStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MYDigitalScorecardStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CREDIT_SERVICE_TOKEN]
                }] }]; } });

class SGDigitalScorecardStore extends DigitalScorecardStore {
    constructor(applicationService, creditService, blobService, creditBorrowerSummaryService, applicationMemberService, applicationRelationshipService) {
        // Call the parent constructor with the injected service and country code
        super(applicationService, creditService, {
            countryCode: CountryCode.SG,
        });
        this.applicationService = applicationService;
        this.creditService = creditService;
        this.blobService = blobService;
        this.creditBorrowerSummaryService = creditBorrowerSummaryService;
        this.applicationMemberService = applicationMemberService;
        this.applicationRelationshipService = applicationRelationshipService;
        this._destroySubject = new Subject();
        this._setApplicationId$ = new Subject();
        this._setScorecardPayload$ = new Subject();
    }
    init() {
        this.select((state) => state.applicationId)
            .pipe(distinctUntilChanged(), filter((applicationId) => !!applicationId), switchMap$1((applicationId) => this.applicationMemberService.getApplicationMainBorrower(applicationId).pipe(tap((member) => this.updateState({ member })), filter((member) => !!member), tap(() => {
            this.state$
                .pipe(takeUntil(this._setApplicationId$), map((state) => state.applicationId))
                .subscribe((applicationId) => {
                if (!applicationId)
                    return;
                this._setApplicationId$.next(applicationId);
                this.createDigitalScorecardPayload(false);
            });
            this.state$
                .pipe(takeUntil(this._setScorecardPayload$), map((state) => state.digitalScorecardPayload))
                .subscribe((payload) => {
                if (!payload)
                    return;
                if (payload) {
                    this._setScorecardPayload$.next(true);
                    this.getCreditModel(false);
                }
            });
        }))))
            .subscribe();
    }
    ngOnDestroy() {
        this._destroySubject.next();
        this._destroySubject.complete();
    }
    resolveModelAsync(flag) {
        return this.applicationRelationshipService
            .getAsync(this.state().applicationId, 'digital_scorecard')
            .pipe(switchMap$1((ids) => {
            const id = ids?.[0];
            if (!id || flag) {
                // this.updateState({ existing: false });
                return this.createAsync(true);
            }
            return this.creditService.getCreditModel(id).pipe(switchMap$1((creditModel) => {
                if (!creditModel) {
                    // this.updateState({ existing: false });
                    return this.createAsync(false);
                }
                // this.updateState({ existing: true });
                return of(creditModel);
            }));
        }), map((creditModel) => ({
            ...creditModel,
            model_name: creditModel?.model_name ? creditModel.model_name.toUpperCase() : '',
        })));
    }
    getPayloadAsync() {
        return forkJoin([
            this.blobService
                .getMemberDoc(+this.get().member?.id)
                .pipe(map((docs) => (docs || []).filter((doc) => doc.docType === 'CBS').map((doc) => doc.uuid))),
            this.applicationRelationshipService
                .getAsync(this.state().applicationId, 'borrower_summary')
                .pipe(switchMap$1((ids) => {
                if (!ids?.length) {
                    return from(Promise.resolve([]));
                }
                return forkJoin(ids.map((id) => this.creditBorrowerSummaryService.getById(id))).pipe(map((items) => items.map((item) => item?.company?.ssic_code).filter((item) => !!item)));
            })),
        ]);
    }
    createAsync(flag) {
        if (this.state().model_name) {
            this.formGroup.patchValue({
                model_name: this.state().model_name,
            });
        }
        return this.getPayloadAsync().pipe(switchMap$1(([cbs_dms_ids, ssic]) => this.creditService
            .createCreditModel(removeNullProperties({
            ...this.state().digitalScorecardPayload,
            cbs_dms_ids,
            ssic,
            model_name: this.formGroup.getRawValue().model_name,
        }))
            .pipe(switchMap$1((creditModel) => {
            if (!creditModel?.id) {
                return of((creditModel || {}));
            }
            // if (creditModel.error_message) {
            //   return of(creditModel);
            // }
            if (!flag || creditModel.error_message) {
                return of(creditModel);
            }
            return this.applicationRelationshipService
                .addAsync(this.state().applicationId, 'digital_scorecard', creditModel.id)
                .pipe(
            // tap(() => this.updateState({ existing: true })),
            map(() => creditModel));
        }))));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SGDigitalScorecardStore, deps: [{ token: APPLICATION_SERVICE_TOKEN }, { token: CREDIT_SERVICE_TOKEN }, { token: BLOB_SERVICE_TOKEN }, { token: CREDIT_BORROWER_SUMMARY_SERVICE_TOKEN }, { token: APPLICATION_MEMBER_SERVICE_TOKEN }, { token: APPLICATION_RELATIONSHIP_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SGDigitalScorecardStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SGDigitalScorecardStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CREDIT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [BLOB_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CREDIT_BORROWER_SUMMARY_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_RELATIONSHIP_SERVICE_TOKEN]
                }] }]; } });

const STORE_TOKEN$4 = new InjectionToken('STORE_TOKEN');

const ID_PROVIDERS$6 = [
    {
        provide: FORM_TOKEN,
        useValue: FSWFormID,
    },
    {
        provide: STORE_TOKEN$4,
        useClass: IDDigitalScorecardStore,
        deps: [APPLICATION_SERVICE_TOKEN, CREDIT_SERVICE_TOKEN],
    },
];

const MY_PROVIDERS$2 = [
    {
        provide: FORM_TOKEN,
        useValue: FSWFormMY,
    },
    {
        provide: STORE_TOKEN$4,
        useClass: MYDigitalScorecardStore,
        deps: [APPLICATION_SERVICE_TOKEN, CREDIT_SERVICE_TOKEN],
    },
];

const VU_PROVIDERS$3 = [
    {
        provide: FORM_TOKEN,
        useValue: FSWFormID,
    },
    {
        provide: STORE_TOKEN$4,
        useClass: VUDigitalScorecardStore,
        deps: [APPLICATION_SERVICE_TOKEN, CREDIT_SERVICE_TOKEN],
    },
];

const SG_PROVIDERS$3 = [
    {
        provide: FORM_TOKEN,
        useValue: FSWFormSG,
    },
    {
        provide: STORE_TOKEN$4,
        useClass: SGDigitalScorecardStore,
        deps: [
            APPLICATION_SERVICE_TOKEN,
            CREDIT_SERVICE_TOKEN,
            BLOB_SERVICE_TOKEN,
            CREDIT_BORROWER_SUMMARY_SERVICE_TOKEN,
            APPLICATION_MEMBER_SERVICE_TOKEN,
            APPLICATION_RELATIONSHIP_SERVICE_TOKEN,
        ],
    },
];

const PROVIDERS_MAP$6 = {
    default: MY_PROVIDERS$2,
    [CountryCode.MY]: MY_PROVIDERS$2,
    [CountryCode.ID]: ID_PROVIDERS$6,
    [CountryCode.VU]: VU_PROVIDERS$3,
    [CountryCode.SG]: SG_PROVIDERS$3,
};
const digitalScorecardProviders = (countryCode) => [
    ...getCustomProviders(PROVIDERS_MAP$6, MY_PROVIDERS$2, countryCode),
];

// @angular
class FSWDigitalScorecardComponent {
    set applicationId(value) {
        this.componentStore.updateState({
            applicationId: value,
        });
        this.cdr.detectChanges();
    }
    set isReadonly(value) {
        this._isReadonly = value;
    }
    get isReadonly() {
        return this._isReadonly;
    }
    constructor(componentStore, formConfig, alertService, cdr) {
        this.componentStore = componentStore;
        this.formConfig = formConfig;
        this.alertService = alertService;
        this.cdr = cdr;
        this._isReadonly = false;
        this._destroySubject = new Subject();
        this._isScorecardPayloadSet$ = new Subject();
        this.builder = null;
        this.componentStore.init();
        this.componentStore.state$
            .pipe(tap((state) => {
            if (state.model_name) {
                this.componentStore.formGroup.patchValue({
                    model_name: state.model_name,
                });
            }
            this.builder = this.formConfig(this.componentStore.formGroup, this.isReadonly);
            if (state.creditModel) {
                this.componentStore.formGroup.patchValue({
                    ...state.creditModel,
                }, { emitEvent: false });
                this.cdr.markForCheck();
            }
        }))
            .subscribe();
    }
    ngOnDestroy() {
        this._destroySubject.next(0);
        this._destroySubject.complete();
    }
    refresh() {
        if (this.componentStore.formGroup.invalid) {
            this.alertService.error('Error', 'Please fill in all mandatory fields', {
                duration: 3000,
            });
            return;
        }
        this.componentStore.updateState({
            digitalScorecardPayload: null,
            creditModel: null,
            model_name: this.componentStore.formGroup.value.model_name,
        });
        this.componentStore.createDigitalScorecardPayload(true);
        this.componentStore.state$
            .pipe(takeUntil(this._isScorecardPayloadSet$), map((state) => state.digitalScorecardPayload))
            .subscribe((payload) => {
            if (!payload)
                return;
            if (payload) {
                this._isScorecardPayloadSet$.next(true);
                // POST call to get credit model
                this.componentStore.getCreditModel(true);
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDigitalScorecardComponent, deps: [{ token: STORE_TOKEN$4 }, { token: FORM_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDigitalScorecardComponent, selector: "fsw-digital-scorecard", inputs: { applicationId: "applicationId", isReadonly: "isReadonly" }, providers: [...digitalScorecardProviders(getCountryCodeFromStorage())], ngImport: i0, template: "<ng-container *ngIf=\"componentStore.state$ | async as state\">\n  <div class=\"w-1/2\">\n    <fsw-panel [title]=\"'Digital Scorecard'\">\n      <section class=\"mb-4 flex justify-between items-center\">\n        <div></div>\n        <button\n          *ngIf=\"!isReadonly\"\n          fswButton\n          appearance=\"secondary\"\n          [size]=\"'s'\"\n          (click)=\"refresh()\"\n        >\n          {{ 'Refresh' }}\n        </button>\n      </section>\n\n      <section *ngIf=\"state?.errors?.length\" class=\"bg-red-100 text-red-500 p-2 h-auto mb-4\">\n        <div class=\"text-[12px] p-1\" *ngFor=\"let err of state?.errors\">\n          {{ err }}\n        </div>\n      </section>\n\n      <section>\n        <main>\n          <form [formGroup]=\"componentStore.formGroup\">\n            <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n          </form>\n        </main>\n      </section>\n    </fsw-panel>\n  </div>\n</ng-container>\n", styles: ["::ng-deep form{display:contents}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDigitalScorecardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-digital-scorecard', changeDetection: ChangeDetectionStrategy.OnPush, providers: [...digitalScorecardProviders(getCountryCodeFromStorage())], template: "<ng-container *ngIf=\"componentStore.state$ | async as state\">\n  <div class=\"w-1/2\">\n    <fsw-panel [title]=\"'Digital Scorecard'\">\n      <section class=\"mb-4 flex justify-between items-center\">\n        <div></div>\n        <button\n          *ngIf=\"!isReadonly\"\n          fswButton\n          appearance=\"secondary\"\n          [size]=\"'s'\"\n          (click)=\"refresh()\"\n        >\n          {{ 'Refresh' }}\n        </button>\n      </section>\n\n      <section *ngIf=\"state?.errors?.length\" class=\"bg-red-100 text-red-500 p-2 h-auto mb-4\">\n        <div class=\"text-[12px] p-1\" *ngFor=\"let err of state?.errors\">\n          {{ err }}\n        </div>\n      </section>\n\n      <section>\n        <main>\n          <form [formGroup]=\"componentStore.formGroup\">\n            <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n          </form>\n        </main>\n      </section>\n    </fsw-panel>\n  </div>\n</ng-container>\n", styles: ["::ng-deep form{display:contents}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [STORE_TOKEN$4]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FORM_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

// @angular
const DECLARATIONS_EXPORTS$2 = [FSWDigitalScorecardComponent];
class FSWDigitalScorecardModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDigitalScorecardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWDigitalScorecardModule, declarations: [FSWDigitalScorecardComponent], imports: [CommonModule,
            ReactiveFormsModule,
            LetDirective,
            FSWDynamicBuilderModule,
            FSWPanelModule,
            FormWidgetModule,
            // toolkit-ui
            FSWTabsModule,
            // services modules
            UtilsServiceModule,
            ApplicationServiceModule,
            FSWCreditServiceModule,
            FSWBlobServiceModule,
            ApplicationMemberServiceModule,
            // custom modules
            FSWCurrencyMaskModule,
            FSWButtonModule,
            CdkTableModule,
            RemoveCurrencySymbolModule,
            FSWAlertModule], exports: [FSWDigitalScorecardComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDigitalScorecardModule, providers: [provideCreditBorrowerSummaryService(), provideApplicationRelationshipService()], imports: [CommonModule,
            ReactiveFormsModule,
            FSWDynamicBuilderModule,
            FSWPanelModule,
            FormWidgetModule,
            // toolkit-ui
            FSWTabsModule,
            // services modules
            UtilsServiceModule,
            ApplicationServiceModule,
            FSWCreditServiceModule,
            FSWBlobServiceModule,
            ApplicationMemberServiceModule,
            // custom modules
            FSWCurrencyMaskModule,
            FSWButtonModule,
            CdkTableModule,
            RemoveCurrencySymbolModule,
            FSWAlertModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDigitalScorecardModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        LetDirective,
                        FSWDynamicBuilderModule,
                        FSWPanelModule,
                        FormWidgetModule,
                        // toolkit-ui
                        FSWTabsModule,
                        // services modules
                        UtilsServiceModule,
                        ApplicationServiceModule,
                        FSWCreditServiceModule,
                        FSWBlobServiceModule,
                        ApplicationMemberServiceModule,
                        // custom modules
                        FSWCurrencyMaskModule,
                        FSWButtonModule,
                        CdkTableModule,
                        RemoveCurrencySymbolModule,
                        FSWAlertModule,
                    ],
                    declarations: DECLARATIONS_EXPORTS$2,
                    exports: DECLARATIONS_EXPORTS$2,
                    providers: [provideCreditBorrowerSummaryService(), provideApplicationRelationshipService()],
                }]
        }] });

var title$u = "Digital Scorecard (Non-Credit Model)";
var qualifying_limit_calculation = "Qualifying Limit Calculation";
var fields$n = {
	application_amount: "Application Amount",
	card_facility_qualifying_limit: "Card Facility",
	overdraft_facility_qualifying_limit: "Overdraft Facility",
	qualifying_limit_monthly_installment: "Monthly Installment",
	decision: "Approval Decision",
	total_aptl_exposure: "Current APTL"
};
var buttons$K = {
	refresh: "Refresh"
};
var digitalScorecardNcmMy = {
	title: title$u,
	qualifying_limit_calculation: qualifying_limit_calculation,
	fields: fields$n,
	buttons: buttons$K
};

var MY$h = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$K,
    default: digitalScorecardNcmMy,
    fields: fields$n,
    qualifying_limit_calculation: qualifying_limit_calculation,
    title: title$u
});

const DIGITAL_SCORECARD_NCM_MY_TRANSLATION = MY$h;

const translation$2 = DIGITAL_SCORECARD_NCM_MY_TRANSLATION;
function injectDigitalScorecardNCMMYForm() {
    const form = new UntypedFormGroup({});
    const builder = new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'w-full flex flex-col gap-[16px]',
        readonlyWhen$: of(true),
        form,
        renderBy: 'container',
        containers: [
            {
                customClasses: 'flex flex-col gap-[16px] w-[calc(50%-8px)]',
                fields: [
                    generateFieldNumber$1('application_amount'),
                    generateFieldNumber$1('total_aptl_exposure'),
                ],
            },
            {
                customClasses: 'flex flex-col gap-[16px] w-[calc(50%-8px)]',
                name: 'digital-scorecard-ncm-container',
                customProps: {
                    title: translation$2.qualifying_limit_calculation,
                    customClasses: 'flex flex-col gap-[16px]',
                },
                fields: [
                    generateFieldNumber$1('card_facility_qualifying_limit'),
                    generateFieldNumber$1('overdraft_facility_qualifying_limit'),
                    generateFieldNumber$1('qualifying_limit_monthly_installment'),
                    generateFieldText$1('decision'),
                ],
            },
        ],
    });
    return { form, builder };
}
function generateFieldText$1(key) {
    return {
        key,
        type: FSWDynamicBuilderControlTypes.INPUT,
        context: {
            label: translation$2.fields[key],
            isDisabled: true,
            readonlyTemplate: (value) => value || '--',
        },
    };
}
function generateFieldNumber$1(key) {
    return {
        key,
        type: FSWDynamicBuilderControlTypes.INPUT,
        context: {
            label: translation$2.fields[key],
            // inputType: 'number',
            mask: {
                expression: 'separator.2',
                config: {
                    thousandSeparator: ',',
                },
            },
            isDisabled: true,
            readonlyTemplate: (value) => (value != null ? Intl.NumberFormat().format(+value) : '--'),
        },
    };
}

function injectDigitalScorecardNCMMYEffects({ applicationIdSignal, identifierSignal, targetSignal, memberSignal, }) {
    const scorecardService = inject(SCORECARD_SERVICE_TOKEN);
    const applicationProposalService = inject(APPLICATION_PROPOSAL_SERVICE_TOKEN);
    const applicationMemberBipService = inject(APPLICATION_MEMBER_BIP_SERVICE_TOKEN);
    const applicationMemberService = inject(APPLICATION_MEMBER_SERVICE_TOKEN);
    const applicationRelationshipService = injectApplicationRelationshipService();
    const sourceSignal = signal(null);
    const loadMember = (applicationId) => {
        applicationMemberService
            .getApplicationMembersInformation(applicationId, { type: ApplicationMemberType.MAIN }, {
            country_code: getCountryCodeFromStorage(),
            member_type_code: MemberCode.BORROWER,
        })
            .pipe(map((members) => members?.shift()), tap((member) => memberSignal.set(member)))
            .subscribe();
    };
    const applicationDataSignal = signal(null);
    const getApplicationInput = (applicationId, member) => {
        const applicationData = untracked(() => applicationDataSignal());
        if (applicationData) {
            return from(Promise.resolve(applicationData));
        }
        return forkJoin([
            // get application amount for input
            applicationProposalService.getProposals(applicationId).pipe(map((proposals) => (proposals || []).find((proposal) => proposal.proposal_type === 'LOAN')?.data), map((data) => data?.propose?.loan_amount || data?.recommendation?.loan_amount || 0)),
            // get application member bips for input
            applicationMemberBipService
                .getApplicationMemberBIPs(applicationId, member.uuid, {})
                .pipe(map((bips) => (bips || []).map((bip) => pick(bip, ['id', 'reference_id', 'reference_to'])))),
        ]).pipe(map(([application_amount, application_member_bips]) => [application_amount, application_member_bips, member]), tap((res) => applicationDataSignal.set(res)));
    };
    const createScorecard = (applicationId, member) => {
        return getApplicationInput(applicationId, member).pipe(switchMap(([application_amount, application_member_bips, member]) => scorecardService
            .generateBNPLScorecard({
            identifier: untracked(() => identifierSignal()),
            input: {
                application_amount,
                application_member_bips,
                member_uuid: member.uuid,
                ...untracked(() => targetSignal()),
            },
        })
            .pipe(switchMap((response) => {
            return applicationRelationshipService
                .addAsync(applicationId, identifierSignal(), response.id)
                .pipe(map(() => response));
        }))));
    };
    const getScorecard = (applicationId) => {
        return applicationRelationshipService.getAsync(applicationId, identifierSignal()).pipe(map((relationshipIds) => relationshipIds.shift()), switchMap((relationshipId) => {
            if (!relationshipId) {
                return of(null);
            }
            return scorecardService.getBNPLScorecard(relationshipId).pipe(map((response) => response));
        }));
    };
    return {
        model: () => {
            effect(() => {
                const applicationId = applicationIdSignal();
                if (!applicationId) {
                    return;
                }
                loadMember(applicationId);
            });
            effect(() => {
                const applicationId = applicationIdSignal();
                const member = memberSignal();
                if (!applicationId || !member) {
                    return;
                }
                getScorecard(applicationId)
                    .pipe(switchMap((scorecard) => {
                    if (!scorecard) {
                        return createScorecard(applicationId, member);
                    }
                    return of(scorecard);
                }), catchError((err) => {
                    console.error('[Digital Scorecard NCM] Init Error', err);
                    return of(null);
                }))
                    .subscribe((res) => {
                    sourceSignal.set(res);
                });
            }, { allowSignalWrites: true });
            return sourceSignal;
        },
        refresh: () => {
            const applicationId = applicationIdSignal();
            const member = memberSignal();
            if (!applicationId || !member) {
                return;
            }
            createScorecard(applicationId, member)
                .pipe(catchError((err) => {
                console.error('[Digital Scorecard NCM] Refresh Error', err);
                return of(null);
            }))
                .subscribe((res) => {
                sourceSignal.set(res);
            });
        },
    };
}

function provideDigitalScorecardNCMTranslation(scope = 'digital_scorecard_ncm') {
    return [
        ...(FSWTranslateModule.forFeature({
            scope,
            defaultKey: CountryCode.MY,
            data: {
                [CountryCode.MY]: DIGITAL_SCORECARD_NCM_MY_TRANSLATION,
            },
        }).providers || []),
        fswTranslateScope(scope),
    ];
}

function injectDigitalScorecardNCMEffects(config) {
    switch (getCountryCodeFromStorage()) {
        case CountryCode.MY:
            return injectDigitalScorecardNCMMYEffects(config);
        default:
            return injectDigitalScorecardNCMMYEffects(config);
    }
}
function injectDigitalScorecardNCMForm() {
    switch (getCountryCodeFromStorage()) {
        case CountryCode.MY:
            return injectDigitalScorecardNCMMYForm();
        default:
            return injectDigitalScorecardNCMMYForm();
    }
}

class FSWDigitalScorecardNCMContainerComponent extends FSWDynamicBuilderContainerComponent {
    get title() {
        return this.element?.customProps?.title ?? '';
    }
    get customClasses() {
        return this.element?.customProps?.customClasses ?? '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDigitalScorecardNCMContainerComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDigitalScorecardNCMContainerComponent, isStandalone: true, selector: "fsw-digital-scorecard-ncm-container", usesInheritance: true, ngImport: i0, template: "<section [class]=\"customClasses\">\n  <strong>{{ title }}</strong>\n  <fsw-dynamic-builder-container\n    [element]=\"element\"\n    [dictionaries]=\"dictionaries\"\n    [config]=\"config\"\n    [index]=\"index\"\n  ></fsw-dynamic-builder-container>\n</section>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "ngmodule", type: FSWDynamicBuilderModule }, { kind: "component", type: i1$4.FSWDynamicBuilderContainerComponent, selector: "fsw-dynamic-builder-container" }, { kind: "ngmodule", type: FSWPanelModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDigitalScorecardNCMContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-digital-scorecard-ncm-container', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [FSWDynamicBuilderModule, FSWPanelModule, NgIf, AsyncPipe], template: "<section [class]=\"customClasses\">\n  <strong>{{ title }}</strong>\n  <fsw-dynamic-builder-container\n    [element]=\"element\"\n    [dictionaries]=\"dictionaries\"\n    [config]=\"config\"\n    [index]=\"index\"\n  ></fsw-dynamic-builder-container>\n</section>\n", styles: [":host{display:contents}\n"] }]
        }] });

let FSWDigitalScorecardNCMComponent = class FSWDigitalScorecardNCMComponent {
    set applicationId(value) {
        this.applicationIdSignal.set(value);
    }
    set target(value) {
        this.targetSignal.set(value);
    }
    set identifier(value) {
        this.identifierSignal.set(value);
    }
    set isReadonly(value) {
        this.isReadonlySignal.set(value);
    }
    constructor() {
        this.refreshEvent = new EventEmitter();
        this.applicationIdSignal = signal('');
        this.targetSignal = signal({
            target_approve_amount: 10000,
            target_facility_product_codes: ['APT', 'IAPT'],
            target_loan_product_codes: ['APP', 'IAPP'],
        });
        this.identifierSignal = signal('');
        this.memberSignal = signal(null);
        this.isReadonlySignal = signal(false);
        this.injector = inject(Injector);
        this.effects = injectDigitalScorecardNCMEffects({
            applicationIdSignal: this.applicationIdSignal,
            identifierSignal: this.identifierSignal,
            targetSignal: this.targetSignal,
            memberSignal: this.memberSignal,
        });
        this.model = this.effects.model();
        this.formBuilder = injectDigitalScorecardNCMForm();
        this.dictionaries = [
            {
                name: 'digital-scorecard-ncm-container',
                dictionaryType: FSWDynamicBuilderFormTypes.CONTAINER,
                component: FSWDigitalScorecardNCMContainerComponent,
            },
        ];
        effect(() => {
            this.formBuilder.form.reset();
            const model = this.model();
            this.refreshEvent.emit(model);
            if (model) {
                this.formBuilder.form.patchValue({
                    ...model.output,
                    ...model.input,
                    ...model,
                });
            }
        }, { allowSignalWrites: true });
    }
    refresh() {
        this.effects.refresh();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDigitalScorecardNCMComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDigitalScorecardNCMComponent, isStandalone: true, selector: "fsw-digital-scorecard-ncm", inputs: { applicationId: "applicationId", target: "target", identifier: "identifier", isReadonly: "isReadonly" }, outputs: { refreshEvent: "refreshEvent" }, providers: [
            provideDigitalScorecardNCMTranslation(),
            provideUtilsService(),
            provideApplicationRelationshipService(),
        ], ngImport: i0, template: "<fsw-panel [title]=\"'title' | fswTranslate : { scope: 'digital_scorecard_ncm' }\">\n  <ng-template fswPanelHeaderSuffix>\n    <button *ngIf=\"!isReadonlySignal()\" fswButton (click)=\"refresh()\">\n      {{ 'buttons.refresh' | fswTranslate : { scope: 'digital_scorecard_ncm' } }}\n    </button>\n  </ng-template>\n  <form [formGroup]=\"formBuilder.form\">\n    <fsw-dynamic-builder\n      [builder]=\"formBuilder.builder\"\n      [dictionaries]=\"dictionaries\"\n    ></fsw-dynamic-builder>\n  </form>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: ScorecardServiceModule }, { kind: "ngmodule", type: ApplicationProposalServiceModule }, { kind: "ngmodule", type: MemberBIPServiceModule }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: FSWDynamicBuilderModule }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "ngmodule", type: ApplicationMemberServiceModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
};
FSWDigitalScorecardNCMComponent = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [])
], FSWDigitalScorecardNCMComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDigitalScorecardNCMComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-digital-scorecard-ncm', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [
                        provideDigitalScorecardNCMTranslation(),
                        provideUtilsService(),
                        provideApplicationRelationshipService(),
                    ], imports: [
                        ScorecardServiceModule,
                        ApplicationProposalServiceModule,
                        MemberBIPServiceModule,
                        FSWTranslateModule,
                        FSWPanelModule,
                        FSWButtonModule,
                        NgIf,
                        ReactiveFormsModule,
                        FSWDynamicBuilderModule,
                        ApplicationMemberServiceModule,
                        FSWDigitalScorecardNCMContainerComponent,
                    ], template: "<fsw-panel [title]=\"'title' | fswTranslate : { scope: 'digital_scorecard_ncm' }\">\n  <ng-template fswPanelHeaderSuffix>\n    <button *ngIf=\"!isReadonlySignal()\" fswButton (click)=\"refresh()\">\n      {{ 'buttons.refresh' | fswTranslate : { scope: 'digital_scorecard_ncm' } }}\n    </button>\n  </ng-template>\n  <form [formGroup]=\"formBuilder.form\">\n    <fsw-dynamic-builder\n      [builder]=\"formBuilder.builder\"\n      [dictionaries]=\"dictionaries\"\n    ></fsw-dynamic-builder>\n  </form>\n</fsw-panel>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { refreshEvent: [{
                type: Output
            }], applicationId: [{
                type: Input
            }], target: [{
                type: Input
            }], identifier: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

var title$t = "Digital Scorecard";
var fields$m = {
	score_card_decision: "Scorecard Decision",
	loan_grade: "Loan Grade",
	default_profitability: "Default Probability",
	expected_loss: "Expected Loss",
	loan_quantum: "Loan Quantum",
	loan_tenure: "Loan Tenure",
	credit_quantum_without_cap: "Credit Quantum (Without Cap)",
	monthly_interest_rate: "Monthly Interest Rate",
	rejection_reason: "Rejection Reasons",
	error_message: "Error Message"
};
var buttons$J = {
	refresh: "Refresh"
};
var digitalScorecardBtlMy = {
	title: title$t,
	fields: fields$m,
	buttons: buttons$J
};

var MY$g = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$J,
    default: digitalScorecardBtlMy,
    fields: fields$m,
    title: title$t
});

const DIGITAL_SCORECARD_BTL_MY_TRANSLATION = MY$g;

const translation$1 = DIGITAL_SCORECARD_BTL_MY_TRANSLATION;
function injectDigitalScorecardBTLMYForm() {
    const form = new UntypedFormGroup({});
    const builder = new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'w-full flex gap-[16px]',
        readonlyWhen$: of(true),
        form,
        renderBy: 'container',
        containers: [
            {
                customClasses: 'flex flex-col gap-[16px] w-[calc(50%-8px)]',
                fields: [
                    generateFieldText(DigitalScorecardFormFields$1.SCORE_CARD_DECISION),
                    generateFieldNumber(DigitalScorecardFormFields$1.DEFAULT_PROFITABILITY),
                    generateFieldNumber(DigitalScorecardFormFields$1.EXPECTED_LOSS),
                    generateFieldNumber(DigitalScorecardFormFields$1.MONTHLY_INTEREST_RATE),
                    generateFieldText(DigitalScorecardFormFields$1.REJECTION_REASON),
                ],
            },
            {
                customClasses: 'flex flex-col gap-[16px] w-[calc(50%-8px)]',
                fields: [
                    generateFieldText(DigitalScorecardFormFields$1.LOAN_GRADE),
                    generateFieldNumber(DigitalScorecardFormFields$1.LOAN_QUANTUM),
                    generateFieldNumber(DigitalScorecardFormFields$1.LOAN_TENURE),
                    generateFieldNumber(DigitalScorecardFormFields$1.LOAN_QUANTUM_WITHOUT_CAPING),
                    generateFieldText(DigitalScorecardFormFields$1.ERROR_MESSAGE),
                ],
            },
        ],
    });
    return { form, builder };
}
function generateFieldText(key) {
    return {
        key,
        type: FSWDynamicBuilderControlTypes.INPUT,
        context: {
            label: translation$1.fields[key],
            isDisabled: true,
            readonlyTemplate: (value) => value || '--',
        },
    };
}
function generateFieldNumber(key) {
    return {
        key,
        type: FSWDynamicBuilderControlTypes.INPUT,
        context: {
            label: translation$1.fields[key],
            // inputType: 'number',
            mask: {
                expression: 'separator.2',
                config: {
                    thousandSeparator: ',',
                },
            },
            isDisabled: true,
            readonlyTemplate: (value) => (value != null ? Intl.NumberFormat().format(+value) : '--'),
        },
    };
}

function injectDigitalScorecardBTLMYEffects({ loanIdSignal, refreshedAtSignal, }) {
    const service = injectCreditModelService();
    const sourceSignal = signal(null);
    return {
        model: () => {
            effect(() => {
                const refreshedAt = refreshedAtSignal();
                const loanId = loanIdSignal();
                if (!loanId) {
                    return;
                }
                console.log('[Digital Scorecard BTL] Refreshed At', refreshedAt.toISOString());
                service
                    .getCreditModelByLoan(loanId)
                    .pipe(map((res) => res?.content), catchError((err) => {
                    console.error('[Digital Scorecard BTL] ', err);
                    return of(null);
                }))
                    .subscribe((res) => {
                    sourceSignal.set(res);
                });
            }, { allowSignalWrites: true });
            return sourceSignal;
        },
    };
}

function provideDigitalScorecardBTLTranslation(scope = 'digital_scorecard_btl') {
    return [
        ...(FSWTranslateModule.forFeature({
            scope,
            defaultKey: CountryCode.MY,
            data: {
                [CountryCode.MY]: DIGITAL_SCORECARD_BTL_MY_TRANSLATION,
            },
        }).providers || []),
        fswTranslateScope(scope),
    ];
}

function injectDigitalScorecardBTLEffects(config) {
    switch (getCountryCodeFromStorage()) {
        case CountryCode.MY:
            return injectDigitalScorecardBTLMYEffects(config);
        default:
            return injectDigitalScorecardBTLMYEffects(config);
    }
}
function injectDigitalScorecardBTLForm() {
    switch (getCountryCodeFromStorage()) {
        case CountryCode.MY:
            return injectDigitalScorecardBTLMYForm();
        default:
            return injectDigitalScorecardBTLMYForm();
    }
}

let FSWDigitalScorecardBTLComponent = class FSWDigitalScorecardBTLComponent {
    set loanId(value) {
        this.loanIdSignal.set(value);
    }
    set isReadonly(value) {
        this.isReadonlySignal.set(value);
    }
    constructor() {
        this.loanIdSignal = signal(0);
        this.isReadonlySignal = signal(false);
        this.refreshedAtSignal = signal(new Date());
        this.injector = inject(Injector);
        this.effects = injectDigitalScorecardBTLEffects({
            loanIdSignal: this.loanIdSignal,
            refreshedAtSignal: this.refreshedAtSignal,
        });
        this.model = this.effects.model();
        this.formBuilder = injectDigitalScorecardBTLForm();
        effect(() => {
            this.formBuilder.form.reset();
            const model = this.model();
            if (model) {
                this.formBuilder.form.patchValue(model);
            }
        }, { allowSignalWrites: true });
    }
    refresh() {
        this.refreshedAtSignal.set(new Date());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDigitalScorecardBTLComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDigitalScorecardBTLComponent, isStandalone: true, selector: "fsw-digital-scorecard-btl", inputs: { loanId: "loanId", isReadonly: "isReadonly" }, providers: [
            provideDigitalScorecardBTLTranslation(),
            provideUtilsService(),
            provideCreditModelService(),
        ], ngImport: i0, template: "<fsw-panel [title]=\"'title' | fswTranslate : { scope: 'digital_scorecard_btl' }\">\n  <ng-template fswPanelHeaderSuffix>\n    <button *ngIf=\"!isReadonlySignal()\" fswButton (click)=\"refresh()\">\n      {{ 'buttons.refresh' | fswTranslate : { scope: 'digital_scorecard_btl' } }}\n    </button>\n  </ng-template>\n  <form [formGroup]=\"formBuilder.form\">\n    <fsw-dynamic-builder [builder]=\"formBuilder.builder\"></fsw-dynamic-builder>\n  </form>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: FSWDynamicBuilderModule }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
};
FSWDigitalScorecardBTLComponent = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [])
], FSWDigitalScorecardBTLComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDigitalScorecardBTLComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-digital-scorecard-btl', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [
                        provideDigitalScorecardBTLTranslation(),
                        provideUtilsService(),
                        provideCreditModelService(),
                    ], imports: [
                        FSWTranslateModule,
                        FSWPanelModule,
                        FSWButtonModule,
                        NgIf,
                        ReactiveFormsModule,
                        FSWDynamicBuilderModule,
                    ], template: "<fsw-panel [title]=\"'title' | fswTranslate : { scope: 'digital_scorecard_btl' }\">\n  <ng-template fswPanelHeaderSuffix>\n    <button *ngIf=\"!isReadonlySignal()\" fswButton (click)=\"refresh()\">\n      {{ 'buttons.refresh' | fswTranslate : { scope: 'digital_scorecard_btl' } }}\n    </button>\n  </ng-template>\n  <form [formGroup]=\"formBuilder.form\">\n    <fsw-dynamic-builder [builder]=\"formBuilder.builder\"></fsw-dynamic-builder>\n  </form>\n</fsw-panel>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { loanId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

const COLUMN_NAMES = [
    'DSCR by Income Factor',
    'Bank balance cover (average monthly bal)',
    'Bank balance cover (latest monthly bal)',
    'Bank balance cover (average daily running bal)',
    '% no.of days EOD balance > FS monthly commitment',
    'Industry income factor',
];

// import { MOCK_FACTORS_RESPONSE } from '../mock-data';
const INITIAL_STATE = {
    countryCode: null,
    applicationId: null,
    scorecardId: null,
    scorecardContent: null,
    scorecardPayload: null,
    scorecardSubmitPayload: null,
    builder: null,
    result: null,
    isPayloadCreated: false,
    scoringResultUpdatePayload: null,
    proposalId: null,
    errors: [],
    isReadonly: false,
    proposalType: 'LOAN',
};
let ManualScorecardStore = class ManualScorecardStore extends ComponentStore {
    // constructor
    constructor(applicationScorecardService, scorecardService, applicationProposalService, appRepaymentScheduleService, applicationRelationshipService, applicationMemberService, applicationGuarantorService, outstandingLoansService, bankTabulationsService, productGroupService, _stateOverride = {}) {
        super({
            ...INITIAL_STATE,
            ..._stateOverride,
        });
        this.applicationScorecardService = applicationScorecardService;
        this.scorecardService = scorecardService;
        this.applicationProposalService = applicationProposalService;
        this.appRepaymentScheduleService = appRepaymentScheduleService;
        this.applicationRelationshipService = applicationRelationshipService;
        this.applicationMemberService = applicationMemberService;
        this.applicationGuarantorService = applicationGuarantorService;
        this.outstandingLoansService = outstandingLoansService;
        this.bankTabulationsService = bankTabulationsService;
        this.productGroupService = productGroupService;
        this._stateOverride = _stateOverride;
        // actions
        // 1. GET scorecard liked with application & scorecard content
        this.getScorecardContent = this.effect(pipe(switchMap(() => zip(this.applicationProposalService
            .getProposals(this.state().applicationId, {
            sort: 'fullname,DESC',
        })
            .pipe(map((proposals) => proposals)), this.productGroupService.getProductGroups()).pipe(tap(([proposalsData, productGroups]) => {
            if (!proposalsData.length) {
                const errMsg = `[GET] proposals | No proposals found`;
                console.error(errMsg);
                this.updateState({
                    errors: [...this.state().errors, errMsg],
                });
                return;
            }
            const resObj = proposalsData.filter((p) => p?.proposal_type === this.get().proposalType)[0];
            const proposalId = resObj?.id || '';
            const scorecardPayload = {
                ...this.state().scorecardPayload,
                product_upi: 'MY-BMY',
                partner: '',
                loan_data: getLoanData(resObj, productGroups),
            };
            const result = getScoringResult(this.state(), resObj);
            const scoringResultUpdatePayload = {
                loan_amount: resObj?.data?.recommendation?.loan_amount || resObj?.data?.propose?.loan_amount,
                disbursement_amount: resObj?.data?.recommendation?.disbursement_amount ||
                    resObj?.data?.propose?.disbursement_amount,
                origination_fee: resObj?.data?.recommendation?.origination_fee ||
                    resObj?.data?.propose?.origination_fee,
                interest_rate: +resObj?.data?.recommendation?.interest_rate ||
                    resObj?.data?.propose?.interest_rate,
                installment_types: resObj?.data?.recommendation?.installment_types,
                interest_type: resObj?.data?.recommendation?.interest_type,
                late_interest_fee: resObj?.data?.recommendation?.late_interest_fee, // 5;
            };
            this.updateState({
                scorecardPayload,
                result,
                scoringResultUpdatePayload,
                proposalId,
            });
        }), catchError((err) => {
            console.error(`[GET] proposals`, err);
            this.updateState({
                errors: [...this.state().errors, `[GET] proposals | No proposals found`],
            });
            return EMPTY;
        }))), switchMap(() => this._getApplicationScorecardIdAsync(true).pipe(catchError((err) => {
            console.error(`[_getApplicationScorecardIdAsync]`, err);
            this.updateState({
                errors: [...this.state().errors, err],
            });
            return EMPTY;
        }))), switchMap(() => this._getScorecardContentAsync(true).pipe(catchError((err) => {
            console.error(`[_getScorecardContentAsync]`, err);
            this.updateState({
                errors: [...this.state().errors, err],
            });
            return EMPTY;
        })))));
        // 1. GET - product_upi, partner, loan_data, result
        // 2. GET - borrower_summary_id
        // 3. GET - borrower_id
        // 4. GET - repayment_schedule_id
        // 5. GET - outstanding_loan_ids
        // 6. GET - bip_application_summary_data
        this.createScorecardPayload = this.effect(pipe(switchMap(() => zip(this.applicationProposalService
            .getProposals(this.state().applicationId, {
            sort: 'fullname,DESC',
        })
            .pipe(map((proposals) => proposals)), this.productGroupService.getProductGroups()).pipe(tap(([proposalsData, productGroups]) => {
            if (!proposalsData.length) {
                const errMsg = `[GET] proposals | No proposals found`;
                console.error(errMsg);
                this.updateState({
                    errors: [...this.state().errors, errMsg],
                });
                return;
            }
            const resObj = proposalsData.filter((p) => p?.proposal_type === this.get().proposalType)[0];
            const proposalId = resObj?.id || '';
            const scorecardPayload = {
                ...this.state().scorecardPayload,
                product_upi: 'MY-BMY',
                partner: '',
                loan_data: getLoanData(resObj, productGroups),
            };
            const result = getScoringResult(this.state(), resObj);
            const scoringResultUpdatePayload = {
                loan_amount: resObj?.data?.recommendation?.loan_amount || resObj?.data?.propose?.loan_amount,
                disbursement_amount: resObj?.data?.recommendation?.disbursement_amount ||
                    resObj?.data?.propose?.disbursement_amount,
                origination_fee: resObj?.data?.recommendation?.origination_fee ||
                    resObj?.data?.propose?.origination_fee,
                interest_rate: +resObj?.data?.recommendation?.interest_rate ||
                    resObj?.data?.propose?.interest_rate,
                installment_types: resObj?.data?.recommendation?.installment_types,
                interest_type: resObj?.data?.recommendation?.interest_type,
                late_interest_fee: resObj?.data?.recommendation?.late_interest_fee, // 5;
            };
            this.updateState({
                scorecardPayload,
                result,
                scoringResultUpdatePayload,
                proposalId,
            });
        }), catchError((err) => {
            console.error(`[GET] proposals`, err);
            this.updateState({
                errors: [...this.state().errors, `[GET] proposals | No proposals found`],
            });
            return EMPTY;
        }))), switchMap(() => this.bankTabulationsService
            .getBankAnalysisReports(this.state().applicationId, true)
            .pipe(tap((bankAnalysisReports) => {
            if (!bankAnalysisReports?.length) {
                const errMsg = `[GET] bank_analysis_reports | No bank analysis reports found`;
                console.error(errMsg);
                this.updateState({
                    errors: [...this.state().errors, errMsg],
                });
                return;
            }
            const bank_accounts = (bankAnalysisReports || []).map((bankAccount) => ({
                account_id: bankAccount?.account_id,
                analysis_report: bankAccount?.analysis_report,
            }));
            const scorecardPayload = {
                ...this.state().scorecardPayload,
                bank_accounts,
            };
            this.updateState({
                scorecardPayload,
            });
        }))), switchMap(() => this.applicationRelationshipService
            .getAsync(this.state().applicationId, 'borrower_summary')
            .pipe(map((ids) => ids?.shift()), tap((borrower_summary_id) => {
            if (!isStringValid(borrower_summary_id)) {
                const errMsg = `[GET] borrower_summary_id | No borrower summary found`;
                console.error(errMsg);
                this.updateState({
                    errors: [...this.state().errors, errMsg],
                });
                return;
            }
            if (borrower_summary_id) {
                const scorecardPayload = {
                    ...this.state().scorecardPayload,
                    borrower_summary_id,
                };
                this.updateState({
                    scorecardPayload,
                });
            }
        }), catchError((err) => {
            console.error(`[GET] borrower_summary_id`, err);
            this.updateState({
                errors: [
                    ...this.state().errors,
                    `[GET] borrower_summary_id | No borrower summary found`,
                ],
            });
            return EMPTY;
        }))), switchMap(() => this.applicationMemberService
            .getApplicationMembers(this.state().applicationId, { type: 'MAIN' })
            .pipe(tap((members) => {
            if (!members.length) {
                const errMsg = `[GET] borrower_id | No borrowers found`;
                console.error(errMsg);
                this.updateState({
                    errors: [...this.state().errors, errMsg],
                });
                return;
            }
            if (members?.length && members[0]?.member_id_int) {
                const scorecardPayload = {
                    ...this.state().scorecardPayload,
                    borrower_id: members[0].member_id_int,
                };
                this.updateState({
                    scorecardPayload,
                });
            }
        }), catchError((err) => {
            console.error(`[GET] borrower_id`, err);
            this.updateState({
                errors: [...this.state().errors, `[GET] borrower_id | No borrowers found`],
            });
            return EMPTY;
        }))), switchMap(() => this.applicationProposalService
            .getProposals(this.state().applicationId)
            .pipe(map((data) => data.filter((item) => item.proposal_type === this.get().proposalType)), map((data) => data.shift()?.id || null), switchMap((id) => id ? this.appRepaymentScheduleService.getData(id) : of(null)))
            .pipe(tap((repayment_schedule_id) => {
            if (!isStringValid(repayment_schedule_id)) {
                const errMsg = `[GET] repayment_schedule_id | No repayment schedule found`;
                console.error(errMsg);
                this.updateState({
                    errors: [...this.state().errors, errMsg],
                });
                return;
            }
            if (repayment_schedule_id) {
                const scorecardPayload = {
                    ...this.state().scorecardPayload,
                    application_id: this.state().applicationId,
                    repayment_schedule_id,
                };
                this.updateState({
                    scorecardPayload,
                });
            }
        }), catchError((err) => {
            console.error(`[GET] repayment_schedule_id`, err);
            this.updateState({
                errors: [...this.state().errors, err],
            });
            return EMPTY;
        }))), switchMap(() => this.outstandingLoansService
            .getOutstandingLoanIds(this.state().applicationId)
            .pipe(tap((outstanding_loan_ids) => {
            if (!outstanding_loan_ids?.length) {
                const errMsg = `[GET] outstanding_loan_ids | No outstanding loans found`;
                console.error(errMsg);
                this.updateState({
                    errors: [...this.state().errors, errMsg],
                });
                return;
            }
            const scorecardPayload = {
                ...this.state().scorecardPayload,
                outstanding_loan_ids: outstanding_loan_ids || [],
            };
            this.updateState({
                scorecardPayload,
            });
        }), catchError((err) => {
            console.error(`[GET] outstanding_loan_ids`, err);
            this.updateState({
                errors: [...this.state().errors, err],
            });
            return EMPTY;
        }))), switchMap(() => this.applicationGuarantorService.getSummaries(this.state().applicationId).pipe(tap((summaries) => {
            if (!summaries?.length) {
                const errMsg = `[GET] member_bip_guarantor_summaries | No guarantor summaries found`;
                console.error(errMsg);
                this.updateState({
                    isPayloadCreated: true,
                    errors: [...this.state().errors, errMsg],
                });
                return;
            }
            const scorecardPayload = {
                ...this.state().scorecardPayload,
                bip_application_summary_data: summaries || [],
            };
            this.updateState({
                scorecardPayload,
                isPayloadCreated: true,
            });
        }), catchError((err) => {
            console.error(`[GET] member_bip_guarantor_summaries`, err);
            this.updateState({
                isPayloadCreated: true,
                errors: [
                    ...this.state().errors,
                    `[GET] member_bip_guarantor_summaries | No guarantor summaries found`,
                ],
            });
            return EMPTY;
        })))));
        // 1. POST - ratio analysis
        // 2. GET - ratio analysis
        this.createScorecardContent = this.effect(pipe(switchMap(() => this.scorecardService
            .createScorecardContent(this.state().scorecardPayload)
            .pipe(tap((scorecardContent) => {
            if (!scorecardContent || !isObjectValid(scorecardContent)) {
                const errMsg = `No scorecard content found`;
                console.error(errMsg);
                this.updateState({
                    errors: [...this.state().errors, errMsg],
                });
                return;
            }
            this.updateState({
                scorecardId: scorecardContent?.id || '',
                scorecardContent,
            });
            this.buildDynamicBuilder(scorecardContent);
        }), catchError((err) => {
            console.error(`[createScorecardContent]`, err);
            this.updateState({
                errors: [...this.state().errors, err],
            });
            return EMPTY;
        }))), switchMap(() => this._linkScorecardIdToApplicationAsync()), switchMap(() => this._getApplicationScorecardIdAsync(true))));
        this.updateScorecard = this.effect(pipe(switchMap(() => this.scorecardService
            .updateScorecardContent(this.state().scorecardSubmitPayload)
            .pipe(tap((scorecardContent) => {
            if (!scorecardContent || !isObjectValid(scorecardContent)) {
                const errMsg = `No scorecard content found`;
                console.error(errMsg);
                this.updateState({
                    errors: [...this.state().errors, errMsg],
                });
                return;
            }
            const result = {
                ...this.state().result,
                scorecard_grade: scorecardContent?.score?.grade || '',
                interest_rate_str: scorecardContent?.score?.interest?.toString() || '',
            };
            this.updateState({
                scorecardId: scorecardContent?.id || '',
                scorecardContent,
                result,
            });
            this.buildDynamicBuilder(scorecardContent);
        }), catchError((err) => {
            console.error(`[createScorecardContent]`, err);
            this.updateState({
                errors: [...this.state().errors, err],
            });
            return EMPTY;
        }))), switchMap(() => this._linkScorecardIdToApplicationAsync())));
        this.updateScoringResult = this.effect(pipe(switchMap(() => zip(this.applicationProposalService.updateProposalRecommendations(this.state().proposalId, this.state().scoringResultUpdatePayload), this.productGroupService.getProductGroups()).pipe(tap(([proposalsData, productGroups]) => {
            const proposalId = proposalsData?.id || '';
            const scorecardPayload = {
                ...this.state().scorecardPayload,
                product_upi: 'MY-BMY',
                partner: '',
                loan_data: getLoanData(proposalsData, productGroups),
            };
            const resObj = {
                data: { ...proposalsData },
            };
            const result = getScoringResult(this.state(), resObj);
            const scoringResultUpdatePayload = {
                loan_amount: resObj?.data?.recommendation?.loan_amount || resObj?.data?.propose?.loan_amount,
                disbursement_amount: resObj?.data?.recommendation?.disbursement_amount ||
                    resObj?.data?.propose?.disbursement_amount,
                origination_fee: resObj?.data?.recommendation?.origination_fee ||
                    resObj?.data?.propose?.origination_fee,
                interest_rate: +resObj?.data?.recommendation?.interest_rate ||
                    resObj?.data?.propose?.interest_rate,
                installment_types: resObj?.data?.recommendation?.installment_types,
                interest_type: resObj?.data?.recommendation?.interest_type,
                late_interest_fee: resObj?.data?.recommendation?.late_interest_fee, // 5;
            };
            this.updateState({
                scorecardPayload,
                result,
                scoringResultUpdatePayload,
                proposalId,
            });
        }), catchError((err) => {
            console.error(`[createScorecardContent]`, err);
            this.updateState({
                errors: [...this.state().errors, err],
            });
            return EMPTY;
        })))));
        // all setters to state are handled with this
        this.updateState = (value) => this.patchState({
            ...value,
        });
    }
    // private async calls
    // GET Calls
    _getScorecardContentAsync(updateCache = false) {
        if (!isStringValid(this.state().scorecardId)) {
            console.error('[_getScorecardContentAsync]: Scorecard Id is not valid');
            return EMPTY;
        }
        return this.scorecardService
            .getScorecardContent(this.state().scorecardId, updateCache)
            .pipe(tap((scorecardContent) => {
            if (!scorecardContent || !isObjectValid(scorecardContent)) {
                const errMsg = `No scorecard content found`;
                console.error(errMsg);
                this.updateState({
                    errors: [...this.state().errors, errMsg],
                });
                return;
            }
            this.updateState({
                scorecardContent,
                result: {
                    ...(this.state().result || {}),
                    scorecard_grade: scorecardContent?.score?.grade || '',
                    interest_rate_str: scorecardContent?.score?.interest?.toString(),
                },
            });
            this.buildDynamicBuilder(scorecardContent);
        }), catchError((err) => {
            console.error('_getScorecardContentAsync', err);
            return throwError(() => `Error: [_getScorecardContentAsync] | No scorecard content found`);
        }));
    }
    // Link scorecard id to application
    _linkScorecardIdToApplicationAsync() {
        if (!isStringValid(this.state().applicationId)) {
            throw new Error('[_linkScorecardIdToApplicationAsync] Application Id is not valid');
        }
        if (!isStringValid(this.state().scorecardId)) {
            throw new Error('[_linkScorecardIdToApplicationAsync] Scorecard Id is not valid');
        }
        return this.applicationScorecardService
            .linkScorecardIdToApplication(this.state().applicationId, this.state().scorecardId)
            .pipe(tap((scorecardId) => {
            if (!scorecardId) {
                const errMsg = `204 | No scorecard id found with application`;
                console.error(errMsg);
                this.updateState({
                    errors: [...this.state().errors, errMsg],
                });
                return;
            }
            this.updateState({
                scorecardId,
                errors: [],
            });
        }), catchError((err) => {
            console.error(`[_linkScorecardIdToApplicationAsync]`, err);
            return EMPTY;
        }));
    }
    // GET scorecardId linked with application
    _getApplicationScorecardIdAsync(updateCache = false) {
        if (!isStringValid(this.state().applicationId)) {
            throw new Error('[_getApplicationScorecardIdAsync] Application Id is not valid');
        }
        return this.applicationScorecardService
            .getScorecardId(this.state().applicationId, updateCache)
            .pipe(tap((scorecardId) => {
            if (!scorecardId) {
                const errMsg = `204 | No scorecard id found with application`;
                console.error(errMsg);
                this.updateState({
                    errors: [...this.state().errors, errMsg],
                    // scorecardContent: MOCK_FACTORS_RESPONSE.content as any,
                });
                // this.buildDynamicBuilder(this.state().scorecardContent as IManualScorecardContent);
                return;
            }
            this.updateState({
                scorecardId,
                errors: [],
            });
        }), catchError((err) => {
            console.error(`[_getApplicationScorecardIdAsync]`, err);
            return EMPTY;
        }));
    }
    // end of GET calls
    // end of private async calls
    // form builder
    buildDynamicBuilder(data) {
        const { factors, score } = data;
        const total = score['score'];
        // const translation = this.getTranslation();
        const builder = new FSWDynamicBuilder({
            header: [
                {
                    columns: [
                        {
                            label: 'Factor',
                            customClasses: 'text-left',
                        },
                        {
                            label: 'Weight',
                        },
                        {
                            label: 'Value',
                            customClasses: 'text-left',
                        },
                        {
                            label: 'Score',
                            customClasses: 'text-right',
                        },
                    ],
                },
            ],
            items: [
                {
                    key: 'scorecard',
                    body: {
                        isLoop: false,
                        data: factors.map((factor) => this.transformFactorToRow(factor)),
                    },
                },
            ],
            formType: FSWDynamicBuilderFormTypes.TABLE,
            form: new FormGroup({}),
            customClasses: 'fsw-table w-full',
            footer: [
                {
                    columns: [
                        {
                            label: 'Total',
                            customClasses: 'text-left font-bold',
                        },
                        {
                            label: '',
                        },
                        {
                            label: '',
                            customClasses: 'text-left',
                        },
                        {
                            label: total?.toFixed(2),
                            customClasses: 'text-right font-bold',
                        },
                    ],
                },
            ],
            readonlyWhen$: this.select((state) => state.isReadonly),
        });
        this.updateState({
            builder,
            data,
        });
    }
    transformFactorToRow(factor) {
        const isReadonly = this.get().isReadonly;
        return {
            key: factor.factor,
            columns: [
                {
                    label: factor.form_control_label,
                    customClasses: 'text-left',
                },
                {
                    label: `${factor.weightage}%`,
                },
                {
                    columnType: 'control',
                    fields: [this.transformFactorToField(factor, isReadonly)],
                },
                {
                    label: factor.score
                        ? Number.parseFloat(factor.score.toString()).toFixed(2)
                        : factor.score,
                    customClasses: 'text-right',
                },
            ],
        };
    }
    transformFactorToField(factor, isReadonly) {
        switch (factor.form_control_type) {
            case 'checkbox':
                return {
                    key: 'input',
                    type: FSWDynamicBuilderControlTypes.SELECT,
                    context: {
                        defaultValue: factor.factor_value,
                        items: factor.options.map((option) => ({
                            value: option,
                            text: option,
                        })),
                        fullWidth: true,
                        isReadonly,
                    },
                };
            case 'radio':
                return {
                    key: 'input',
                    type: FSWDynamicBuilderControlTypes.RADIO_GROUP,
                    context: {
                        defaultValue: factor.factor_value,
                        direction: FSWCheckboxDirections.ROW,
                        items: this.transformRadioItems(factor),
                        fullWidth: true,
                        isReadonly,
                    },
                };
            case 'number':
                return {
                    key: 'input',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    context: {
                        // inputType: 'number',
                        mask: {
                            expression: 'separator.2',
                            config: {
                                thousandSeparator: ',',
                            },
                        },
                        defaultValue: Number.parseFloat(factor.factor_value),
                        fullWidth: true,
                        isReadonly,
                    },
                };
            default:
                return {
                    key: 'input',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    context: {
                        defaultValue: factor.factor_value,
                        fullWidth: true,
                        isReadonly,
                    },
                };
        }
    }
    transformRadioItems(factor) {
        switch (factor.type) {
            default:
                return [
                    {
                        value: false,
                        renderTemplate: {
                            label: 'No',
                        },
                    },
                    {
                        value: true,
                        renderTemplate: {
                            label: 'Yes',
                        },
                    },
                ];
        }
    }
    getRepaymentScheduleId(entityId) {
        return this.getProposalId(entityId).pipe(switchMap((id) => {
            return id ? this.appRepaymentScheduleService.getData(id) : of(null);
        }));
    }
    getProposalId(entityId) {
        return this.applicationProposalService.getProposals(entityId).pipe(map((data) => data.filter((item) => item.proposal_type === this.get().proposalType)), map((data) => data.shift()?.id || null));
    }
};
ManualScorecardStore = __decorate([
    __param(0, Inject(APPLICATION_SCORECARD_SERVICE_TOKEN)),
    __param(1, Inject(SCORECARD_SERVICE_TOKEN)),
    __param(2, Inject(APPLICATION_PROPOSAL_SERVICE_TOKEN)),
    __param(3, Inject(APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN)),
    __param(4, Inject(APPLICATION_RELATIONSHIP_SERVICE_TOKEN)),
    __param(5, Inject(APPLICATION_MEMBER_SERVICE_TOKEN)),
    __param(6, Inject(APPLICATION_GUARANTOR_SERVICE_TOKEN)),
    __param(7, Inject(OUTSTANDING_LOAN_SERVICE_TOKEN)),
    __param(8, Inject(BANK_TABULATIONS_SERVICE_TOKEN)),
    __param(9, Inject(PRODUCT_GROUP_SERVICE_TOKEN)),
    __metadata("design:paramtypes", [Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object])
], ManualScorecardStore);

class IDManualScorecardStore extends ManualScorecardStore {
    constructor(applicationScorecardService, scorecardService, applicationProposalService, appRepaymentScheduleService, applicationRelationshipService, applicationMemberService, applicationGuarantorService, outstandingLoansService, bankTabulationsService, productGroupService) {
        // Call the parent constructor with the injected service and country code
        super(applicationScorecardService, scorecardService, applicationProposalService, appRepaymentScheduleService, applicationRelationshipService, applicationMemberService, applicationGuarantorService, outstandingLoansService, bankTabulationsService, productGroupService, {
            countryCode: CountryCode.ID,
        });
        this.applicationScorecardService = applicationScorecardService;
        this.scorecardService = scorecardService;
        this.applicationProposalService = applicationProposalService;
        this.appRepaymentScheduleService = appRepaymentScheduleService;
        this.applicationRelationshipService = applicationRelationshipService;
        this.applicationMemberService = applicationMemberService;
        this.applicationGuarantorService = applicationGuarantorService;
        this.outstandingLoansService = outstandingLoansService;
        this.bankTabulationsService = bankTabulationsService;
        this.productGroupService = productGroupService;
        this._destroySubject = new Subject();
        this._setApplicationId$ = new Subject();
        this._setError$ = new Subject();
        this._isScorecardPayloadCreated$ = new Subject();
    }
    init() {
        this.state$
            .pipe(takeUntil(this._setApplicationId$), map((state) => state.applicationId))
            .subscribe((applicationId) => {
            if (!applicationId)
                return;
            this._setApplicationId$.next(applicationId);
            this.getScorecardContent();
        });
        this.state$
            .pipe(takeUntil(this._setError$), map((state) => state.errors))
            .subscribe((errors) => {
            if (errors.findIndex((err) => err === '204 | No scorecard id found with application') > -1) {
                this._setError$.next(true);
                this.createScorecardPayload();
            }
        });
        this.state$
            .pipe(takeUntil(this._isScorecardPayloadCreated$), map((state) => state.isPayloadCreated))
            .subscribe((isPayloadCreated) => {
            if (isPayloadCreated && !this.state().scorecardId) {
                this._isScorecardPayloadCreated$.next(true);
                this.createScorecardContent();
            }
            else if (isPayloadCreated && this.state().scorecardId) {
                this._isScorecardPayloadCreated$.next(true);
                // update the state with the update payload
            }
        });
    }
    ngOnDestroy() {
        this._destroySubject.next();
        this._destroySubject.complete();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDManualScorecardStore, deps: [{ token: APPLICATION_SCORECARD_SERVICE_TOKEN }, { token: SCORECARD_SERVICE_TOKEN }, { token: APPLICATION_PROPOSAL_SERVICE_TOKEN }, { token: APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN }, { token: APPLICATION_RELATIONSHIP_SERVICE_TOKEN }, { token: APPLICATION_MEMBER_SERVICE_TOKEN }, { token: APPLICATION_GUARANTOR_SERVICE_TOKEN }, { token: OUTSTANDING_LOAN_SERVICE_TOKEN }, { token: BANK_TABULATIONS_SERVICE_TOKEN }, { token: PRODUCT_GROUP_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDManualScorecardStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDManualScorecardStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_SCORECARD_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SCORECARD_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_PROPOSAL_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_RELATIONSHIP_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_GUARANTOR_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [OUTSTANDING_LOAN_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [BANK_TABULATIONS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PRODUCT_GROUP_SERVICE_TOKEN]
                }] }]; } });

class MYManualScorecardStore extends ManualScorecardStore {
    set isScorecardPayloadCreated(value) {
        this._isScorecardPayloadCreatedSub.next(value);
    }
    get isScorecardPayloadCreated$() {
        return this._isScorecardPayloadCreatedSub.asObservable();
    }
    constructor(applicationScorecardService, scorecardService, applicationProposalService, appRepaymentScheduleService, applicationRelationshipService, applicationMemberService, applicationGuarantorService, outstandingLoansService, bankTabulationsService, productGroupService) {
        // Call the parent constructor with the injected service and country code
        super(applicationScorecardService, scorecardService, applicationProposalService, appRepaymentScheduleService, applicationRelationshipService, applicationMemberService, applicationGuarantorService, outstandingLoansService, bankTabulationsService, productGroupService, {
            countryCode: CountryCode.MY,
        });
        this.applicationScorecardService = applicationScorecardService;
        this.scorecardService = scorecardService;
        this.applicationProposalService = applicationProposalService;
        this.appRepaymentScheduleService = appRepaymentScheduleService;
        this.applicationRelationshipService = applicationRelationshipService;
        this.applicationMemberService = applicationMemberService;
        this.applicationGuarantorService = applicationGuarantorService;
        this.outstandingLoansService = outstandingLoansService;
        this.bankTabulationsService = bankTabulationsService;
        this.productGroupService = productGroupService;
        this._destroySubject = new Subject();
        this._setApplicationId$ = new Subject();
        this._setError$ = new Subject();
        this._isScorecardPayloadCreatedSub = new BehaviorSubject(false);
    }
    init(isReadonly) {
        this.state$
            .pipe(takeUntil(this._setApplicationId$), map((state) => state.applicationId))
            .subscribe((applicationId) => {
            if (!applicationId)
                return;
            this._setApplicationId$.next(applicationId);
            this.getScorecardContent();
        });
        this.state$
            .pipe(takeUntil(this._setError$), map((state) => state.errors))
            .subscribe((errors) => {
            if (errors.findIndex((err) => err === '204 | No scorecard id found with application') > -1) {
                this._setError$.next(true);
                !isReadonly && this.createScorecardPayload();
            }
        });
        this.select((state) => state.isPayloadCreated)
            .pipe(takeUntil(this._destroySubject), filter((isPayloadCreated) => isPayloadCreated))
            .subscribe(() => {
            this.createScorecardContent();
        });
    }
    ngOnDestroy() {
        this._destroySubject.next();
        this._destroySubject.complete();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MYManualScorecardStore, deps: [{ token: APPLICATION_SCORECARD_SERVICE_TOKEN }, { token: SCORECARD_SERVICE_TOKEN }, { token: APPLICATION_PROPOSAL_SERVICE_TOKEN }, { token: APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN }, { token: APPLICATION_RELATIONSHIP_SERVICE_TOKEN }, { token: APPLICATION_MEMBER_SERVICE_TOKEN }, { token: APPLICATION_GUARANTOR_SERVICE_TOKEN }, { token: OUTSTANDING_LOAN_SERVICE_TOKEN }, { token: BANK_TABULATIONS_SERVICE_TOKEN }, { token: PRODUCT_GROUP_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MYManualScorecardStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MYManualScorecardStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_SCORECARD_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SCORECARD_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_PROPOSAL_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_RELATIONSHIP_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_GUARANTOR_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [OUTSTANDING_LOAN_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [BANK_TABULATIONS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PRODUCT_GROUP_SERVICE_TOKEN]
                }] }]; } });

class VUManualScorecardStore extends ManualScorecardStore {
    constructor(applicationScorecardService, scorecardService, applicationProposalService, appRepaymentScheduleService, applicationRelationshipService, applicationMemberService, applicationGuarantorService, outstandingLoansService, bankTabulationsService, productGroupService) {
        // Call the parent constructor with the injected service and country code
        super(applicationScorecardService, scorecardService, applicationProposalService, appRepaymentScheduleService, applicationRelationshipService, applicationMemberService, applicationGuarantorService, outstandingLoansService, bankTabulationsService, productGroupService, {
            countryCode: CountryCode.VU,
        });
        this.applicationScorecardService = applicationScorecardService;
        this.scorecardService = scorecardService;
        this.applicationProposalService = applicationProposalService;
        this.appRepaymentScheduleService = appRepaymentScheduleService;
        this.applicationRelationshipService = applicationRelationshipService;
        this.applicationMemberService = applicationMemberService;
        this.applicationGuarantorService = applicationGuarantorService;
        this.outstandingLoansService = outstandingLoansService;
        this.bankTabulationsService = bankTabulationsService;
        this.productGroupService = productGroupService;
        this._destroySubject = new Subject();
        this._setApplicationId$ = new Subject();
        this._setError$ = new Subject();
        this._isScorecardPayloadCreated$ = new Subject();
    }
    init() {
        this.state$
            .pipe(takeUntil(this._setApplicationId$), map((state) => state.applicationId))
            .subscribe((applicationId) => {
            if (!applicationId)
                return;
            this._setApplicationId$.next(applicationId);
            this.getScorecardContent();
        });
        this.state$
            .pipe(takeUntil(this._setError$), map((state) => state.errors))
            .subscribe((errors) => {
            if (errors.findIndex((err) => err === '204 | No scorecard id found with application') > -1) {
                this._setError$.next(true);
                this.createScorecardPayload();
            }
        });
        this.state$
            .pipe(takeUntil(this._isScorecardPayloadCreated$), map((state) => state.isPayloadCreated))
            .subscribe((isPayloadCreated) => {
            if (isPayloadCreated && !this.state().scorecardId) {
                this._isScorecardPayloadCreated$.next(true);
                this.createScorecardContent();
            }
            else if (isPayloadCreated && this.state().scorecardId) {
                this._isScorecardPayloadCreated$.next(true);
                // update the state with the update payload
            }
        });
    }
    ngOnDestroy() {
        this._destroySubject.next();
        this._destroySubject.complete();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: VUManualScorecardStore, deps: [{ token: APPLICATION_SCORECARD_SERVICE_TOKEN }, { token: SCORECARD_SERVICE_TOKEN }, { token: APPLICATION_PROPOSAL_SERVICE_TOKEN }, { token: APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN }, { token: APPLICATION_RELATIONSHIP_SERVICE_TOKEN }, { token: APPLICATION_MEMBER_SERVICE_TOKEN }, { token: APPLICATION_GUARANTOR_SERVICE_TOKEN }, { token: OUTSTANDING_LOAN_SERVICE_TOKEN }, { token: BANK_TABULATIONS_SERVICE_TOKEN }, { token: PRODUCT_GROUP_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: VUManualScorecardStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: VUManualScorecardStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_SCORECARD_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SCORECARD_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_PROPOSAL_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_RELATIONSHIP_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_GUARANTOR_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [OUTSTANDING_LOAN_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [BANK_TABULATIONS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PRODUCT_GROUP_SERVICE_TOKEN]
                }] }]; } });

const STORE_TOKEN$3 = new InjectionToken('STORE_TOKEN');

const ID_PROVIDERS$5 = [
    {
        provide: STORE_TOKEN$3,
        useClass: MYManualScorecardStore,
        deps: [
            APPLICATION_SCORECARD_SERVICE_TOKEN,
            SCORECARD_SERVICE_TOKEN,
            APPLICATION_PROPOSAL_SERVICE_TOKEN,
            APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN,
            APPLICATION_RELATIONSHIP_SERVICE_TOKEN,
            APPLICATION_MEMBER_SERVICE_TOKEN,
            APPLICATION_GUARANTOR_SERVICE_TOKEN,
            OUTSTANDING_LOAN_SERVICE_TOKEN,
            BANK_TABULATIONS_SERVICE_TOKEN,
            PRODUCT_GROUP_SERVICE_TOKEN,
        ],
    },
];

const MY_PROVIDERS$1 = [
    {
        provide: STORE_TOKEN$3,
        useClass: MYManualScorecardStore,
        deps: [
            APPLICATION_SCORECARD_SERVICE_TOKEN,
            SCORECARD_SERVICE_TOKEN,
            APPLICATION_PROPOSAL_SERVICE_TOKEN,
            APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN,
            APPLICATION_RELATIONSHIP_SERVICE_TOKEN,
            APPLICATION_MEMBER_SERVICE_TOKEN,
            APPLICATION_GUARANTOR_SERVICE_TOKEN,
            OUTSTANDING_LOAN_SERVICE_TOKEN,
            BANK_TABULATIONS_SERVICE_TOKEN,
            PRODUCT_GROUP_SERVICE_TOKEN,
        ],
    },
];

const VU_PROVIDERS$2 = [
    {
        provide: STORE_TOKEN$3,
        useClass: MYManualScorecardStore,
        deps: [
            APPLICATION_SCORECARD_SERVICE_TOKEN,
            SCORECARD_SERVICE_TOKEN,
            APPLICATION_PROPOSAL_SERVICE_TOKEN,
            APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN,
            APPLICATION_RELATIONSHIP_SERVICE_TOKEN,
            APPLICATION_MEMBER_SERVICE_TOKEN,
            APPLICATION_GUARANTOR_SERVICE_TOKEN,
            OUTSTANDING_LOAN_SERVICE_TOKEN,
            BANK_TABULATIONS_SERVICE_TOKEN,
            PRODUCT_GROUP_SERVICE_TOKEN,
        ],
    },
];

const PROVIDERS_MAP$5 = {
    default: MY_PROVIDERS$1,
    [CountryCode.MY]: MY_PROVIDERS$1,
    [CountryCode.VU]: VU_PROVIDERS$2,
    [CountryCode.ID]: ID_PROVIDERS$5,
};
const manualScorecardMYProviders = (countryCode) => [
    ...getCustomProviders(PROVIDERS_MAP$5, MY_PROVIDERS$1, countryCode),
];

// @angular
class FSWManualScorecardComponent {
    set applicationId(value) {
        this.componentStore.updateState({
            applicationId: value,
        });
        this._cdr.detectChanges();
    }
    set isReadonly(value) {
        this.componentStore.updateState({ isReadonly: value });
        this._isReadonly = value;
    }
    get isReadonly() {
        return this._isReadonly;
    }
    set proposalType(proposalType) {
        this.componentStore.updateState({
            proposalType,
        });
    }
    constructor(componentStore, _cdr) {
        this.componentStore = componentStore;
        this._cdr = _cdr;
        this.isManualScorecardValid = new EventEmitter(false);
        this._isReadonly = false;
        this._destroySubject = new Subject();
        this.columnNamesList = COLUMN_NAMES;
    }
    ngOnInit() {
        this.componentStore.init(this.isReadonly);
        this.componentStore.state$.pipe(takeUntil(this._destroySubject)).subscribe((state) => {
            if (state?.scorecardContent?.factors?.length) {
                this.isManualScorecardValid.emit(true);
            }
        });
    }
    ngOnDestroy() {
        if (this._destroySubject) {
            this._destroySubject.next(0);
            this._destroySubject.complete();
        }
    }
    refresh() {
        this.componentStore.updateState({
            isPayloadCreated: false,
        });
        this.componentStore.createScorecardPayload();
    }
    submit() {
        const scorecardValue = this.componentStore.state().builder?.config?.form?.value?.scorecard;
        let updatedFactors = (this.componentStore.state().scorecardContent?.factors || []).map((f) => ({
            factor: f.factor,
            factor_value: scorecardValue[f?.factor]?.input != null
                ? scorecardValue[f?.factor]?.input
                : f.factor_value,
        }));
        updatedFactors = [
            ...updatedFactors,
            {
                factor: 'interest',
                factor_value: {
                    Tenor: this.componentStore.state().result?.tenor_length || 0,
                },
            },
        ];
        const scorecardSubmitPayload = {
            product_upi: this.componentStore.state().scorecardPayload?.product_upi,
            loan_data: this.componentStore.state().scorecardPayload?.loan_data,
            factors: updatedFactors,
        };
        this.componentStore.updateState({
            scorecardSubmitPayload,
        });
        this.componentStore.updateScorecard();
    }
    onSubmit(evt) {
        this.onUpdate(evt);
        this.refresh();
    }
    onUpdate(evt) {
        if (!this.componentStore?.state()?.proposalId) {
            console.error(`[POST] proposal | No proposal id found`);
            return;
        }
        const scoringResultUpdatePayload = {
            ...this.componentStore.state().scoringResultUpdatePayload,
            loan_amount: Number(evt.amount),
            disbursement_amount: Number(evt.disbursement_amount),
            origination_fee: Number(evt.origination_fee),
            interest_rate: Number(evt.interest_rate),
            interest_type: String(evt.interest_type),
            installment_types: String(evt.tenor_type),
            tenor: String(evt.tenor_length),
            tenor_type: String(evt.tenor_type),
        };
        this.componentStore.updateState({
            scoringResultUpdatePayload,
        });
        this.componentStore.updateScoringResult();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWManualScorecardComponent, deps: [{ token: STORE_TOKEN$3 }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWManualScorecardComponent, selector: "fsw-manual-scorecard", inputs: { applicationId: "applicationId", isReadonly: "isReadonly", proposalType: "proposalType" }, outputs: { isManualScorecardValid: "isManualScorecardValid" }, providers: [...manualScorecardMYProviders(getCountryCodeFromStorage())], ngImport: i0, template: "<ng-container *ngIf=\"componentStore.state$ | async as state\">\n  <section class=\"mb-4 flex justify-between items-center w-[66%]\">\n    <header>\n      <h6>{{ 'Manual Scorecard' }}</h6>\n    </header>\n    <div></div>\n  </section>\n\n  <section *ngIf=\"state?.errors?.length\" class=\"bg-red-100 text-red-500 p-2 h-auto mb-4 w-[66%]\">\n    <div class=\"text-[12px] p-1\" *ngFor=\"let err of state?.errors\">\n      {{ err }}\n    </div>\n  </section>\n\n  <ng-container *ngIf=\"componentStore.state$ | async as state\">\n    <section class=\"flex flex-col gap-[24px] w-[66%]\">\n      <header class=\"flex justify-end\" *ngIf=\"!isReadonly\">\n        <button fswButton appearance=\"secondary\" [size]=\"'s'\" (click)=\"refresh()\">\n          {{ 'Refresh' }}\n        </button>\n      </header>\n      <main>\n        <ng-container *ngIf=\"state.builder as builder\">\n          <ng-container *ngIf=\"builder.config as config\">\n            <form [formGroup]=\"config.form | fswForceGroup\">\n              <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n            </form>\n          </ng-container>\n        </ng-container>\n      </main>\n      <footer class=\"flex justify-end\" *ngIf=\"!isReadonly\">\n        <button fswButton (click)=\"submit()\" [appearance]=\"'secondary-elevate'\">\n          {{ 'Submit' }}\n        </button>\n      </footer>\n    </section>\n    <br />\n    <br />\n    <div\n      class=\"w-[66%]\"\n      fswScoringResult\n      [data]=\"state.result\"\n      [isReadonly]=\"isReadonly\"\n      (calculate)=\"onSubmit($event)\"\n      (update)=\"onUpdate($event)\"\n    ></div>\n  </ng-container>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: FSwScoringResultDirective, selector: "[fswScoringResult]", inputs: ["data", "isReadonly"], outputs: ["calculate", "update"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i1$4.FSWForceGroupPipe, name: "fswForceGroup" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWManualScorecardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-manual-scorecard', providers: [...manualScorecardMYProviders(getCountryCodeFromStorage())], template: "<ng-container *ngIf=\"componentStore.state$ | async as state\">\n  <section class=\"mb-4 flex justify-between items-center w-[66%]\">\n    <header>\n      <h6>{{ 'Manual Scorecard' }}</h6>\n    </header>\n    <div></div>\n  </section>\n\n  <section *ngIf=\"state?.errors?.length\" class=\"bg-red-100 text-red-500 p-2 h-auto mb-4 w-[66%]\">\n    <div class=\"text-[12px] p-1\" *ngFor=\"let err of state?.errors\">\n      {{ err }}\n    </div>\n  </section>\n\n  <ng-container *ngIf=\"componentStore.state$ | async as state\">\n    <section class=\"flex flex-col gap-[24px] w-[66%]\">\n      <header class=\"flex justify-end\" *ngIf=\"!isReadonly\">\n        <button fswButton appearance=\"secondary\" [size]=\"'s'\" (click)=\"refresh()\">\n          {{ 'Refresh' }}\n        </button>\n      </header>\n      <main>\n        <ng-container *ngIf=\"state.builder as builder\">\n          <ng-container *ngIf=\"builder.config as config\">\n            <form [formGroup]=\"config.form | fswForceGroup\">\n              <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n            </form>\n          </ng-container>\n        </ng-container>\n      </main>\n      <footer class=\"flex justify-end\" *ngIf=\"!isReadonly\">\n        <button fswButton (click)=\"submit()\" [appearance]=\"'secondary-elevate'\">\n          {{ 'Submit' }}\n        </button>\n      </footer>\n    </section>\n    <br />\n    <br />\n    <div\n      class=\"w-[66%]\"\n      fswScoringResult\n      [data]=\"state.result\"\n      [isReadonly]=\"isReadonly\"\n      (calculate)=\"onSubmit($event)\"\n      (update)=\"onUpdate($event)\"\n    ></div>\n  </ng-container>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [STORE_TOKEN$3]
                }] }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { isManualScorecardValid: [{
                type: Output
            }], applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], proposalType: [{
                type: Input
            }] } });

// @angular
const DECLARATIONS_EXPORTS$1 = [FSWManualScorecardComponent];
class FSWManualScorecardModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWManualScorecardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWManualScorecardModule, declarations: [FSWManualScorecardComponent], imports: [CommonModule,
            ReactiveFormsModule,
            LetDirective,
            FormWidgetModule,
            // toolkit-ui
            FSWTabsModule,
            // services modules
            UtilsServiceModule,
            FinancialStatementServiceModule,
            RatioAnalysisServiceModule,
            ApplicationRepaymentScheduleServiceModule,
            ApplicationGuarantorServiceModule,
            OutstandingLoansServiceModule,
            ApplicationMemberServiceModule,
            ApplicationScorecardServiceModule,
            ScorecardServiceModule,
            ApplicationProposalServiceModule,
            ProductGroupServiceModule,
            // custom modules
            FSWCurrencyMaskModule,
            FSWButtonModule,
            CdkTableModule,
            RemoveCurrencySymbolModule,
            ForceGroupPipeModule,
            FSWScoringResultModule,
            FSWButtonModule,
            FSWDynamicBuilderModule], exports: [FSWManualScorecardComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWManualScorecardModule, providers: [provideApplicationRelationshipService()], imports: [CommonModule,
            ReactiveFormsModule,
            FormWidgetModule,
            // toolkit-ui
            FSWTabsModule,
            // services modules
            UtilsServiceModule,
            FinancialStatementServiceModule,
            RatioAnalysisServiceModule,
            ApplicationRepaymentScheduleServiceModule,
            ApplicationGuarantorServiceModule,
            OutstandingLoansServiceModule,
            ApplicationMemberServiceModule,
            ApplicationScorecardServiceModule,
            ScorecardServiceModule,
            ApplicationProposalServiceModule,
            ProductGroupServiceModule,
            // custom modules
            FSWCurrencyMaskModule,
            FSWButtonModule,
            CdkTableModule,
            RemoveCurrencySymbolModule,
            ForceGroupPipeModule,
            FSWScoringResultModule,
            FSWButtonModule,
            FSWDynamicBuilderModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWManualScorecardModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        LetDirective,
                        FormWidgetModule,
                        // toolkit-ui
                        FSWTabsModule,
                        // services modules
                        UtilsServiceModule,
                        FinancialStatementServiceModule,
                        RatioAnalysisServiceModule,
                        ApplicationRepaymentScheduleServiceModule,
                        ApplicationGuarantorServiceModule,
                        OutstandingLoansServiceModule,
                        ApplicationMemberServiceModule,
                        ApplicationScorecardServiceModule,
                        ScorecardServiceModule,
                        ApplicationProposalServiceModule,
                        ProductGroupServiceModule,
                        // custom modules
                        FSWCurrencyMaskModule,
                        FSWButtonModule,
                        CdkTableModule,
                        RemoveCurrencySymbolModule,
                        ForceGroupPipeModule,
                        FSWScoringResultModule,
                        FSWButtonModule,
                        FSWDynamicBuilderModule,
                    ],
                    declarations: DECLARATIONS_EXPORTS$1,
                    exports: DECLARATIONS_EXPORTS$1,
                    providers: [provideApplicationRelationshipService()],
                }]
        }] });

// @angular
// ui
class FSWCreditScoringComponent {
    constructor() {
        this.refreshDigitalScorecardNCMEvent = new EventEmitter();
        this.isManualScorecardValid = new EventEmitter(false);
        this._applicationId = '';
        this._isReadonly = false;
        this._target = {
            target_approve_amount: 10000,
            target_facility_product_codes: ['APT', 'IAPT'],
            target_loan_product_codes: ['APP', 'IAPP'],
        };
        this._identifier = 'my_ap_tf_bnpl';
        this.displayConfig = {
            digital: true,
            manual: true,
            digital_noncredit_model: false,
        };
    }
    set applicationId(value) {
        this._applicationId = value;
    }
    get applicationId() {
        return this._applicationId;
    }
    set isReadonly(value) {
        this._isReadonly = value;
    }
    get isReadonly() {
        return this._isReadonly;
    }
    set target(value) {
        this._target = value;
    }
    get target() {
        return this._target;
    }
    set identifier(value) {
        this._identifier = value;
    }
    get identifier() {
        return this._identifier;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCreditScoringComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCreditScoringComponent, selector: "fsw-credit-scoring", inputs: { applicationId: "applicationId", isReadonly: "isReadonly", target: "target", identifier: "identifier", displayConfig: "displayConfig" }, outputs: { refreshDigitalScorecardNCMEvent: "refreshDigitalScorecardNCMEvent", isManualScorecardValid: "isManualScorecardValid" }, ngImport: i0, template: `
    <div class="w-100">
      <section>
        <fsw-tabs-group [customRowGap]="'24px'" [customColumnGap]="'24px'">
          <ng-template
            *ngIf="displayConfig.digital"
            fswTabs
            [key]="'tab_1_digital'"
            [maxTextWidth]="'unset'"
            [label]="'Digital Scorecard'"
          >
            <fsw-digital-scorecard
              [applicationId]="applicationId"
              [isReadonly]="isReadonly"
            ></fsw-digital-scorecard>
          </ng-template>
          <ng-template
            *ngIf="displayConfig.digital_noncredit_model"
            fswTabs
            [key]="'tab_1_digital'"
            [maxTextWidth]="'unset'"
            [label]="'Digital Scorecard'"
          >
            <fsw-digital-scorecard-ncm
              [applicationId]="applicationId"
              [isReadonly]="isReadonly"
              [identifier]="identifier"
              [target]="target"
              (refreshEvent)="refreshDigitalScorecardNCMEvent.emit($event)"
            ></fsw-digital-scorecard-ncm>
          </ng-template>
          <ng-template
            *ngIf="displayConfig.manual"
            fswTabs
            [key]="'tab_2_manual'"
            [maxTextWidth]="'unset'"
            [label]="'Manual Scorecard'"
          >
            <fsw-manual-scorecard
              [applicationId]="applicationId"
              [isReadonly]="isReadonly"
              (isManualScorecardValid)="isManualScorecardValid.emit($event)"
            ></fsw-manual-scorecard>
          </ng-template>
        </fsw-tabs-group>
      </section>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$4.FSWTabsGroupComponent, selector: "fsw-tabs-group" }, { kind: "directive", type: i1$4.FSWTabsDirective, selector: "ng-template[fswTabs]" }, { kind: "component", type: FSWDigitalScorecardComponent, selector: "fsw-digital-scorecard", inputs: ["applicationId", "isReadonly"] }, { kind: "component", type: FSWManualScorecardComponent, selector: "fsw-manual-scorecard", inputs: ["applicationId", "isReadonly", "proposalType"], outputs: ["isManualScorecardValid"] }, { kind: "component", type: FSWDigitalScorecardNCMComponent, selector: "fsw-digital-scorecard-ncm", inputs: ["applicationId", "target", "identifier", "isReadonly"], outputs: ["refreshEvent"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCreditScoringComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-credit-scoring',
                    template: `
    <div class="w-100">
      <section>
        <fsw-tabs-group [customRowGap]="'24px'" [customColumnGap]="'24px'">
          <ng-template
            *ngIf="displayConfig.digital"
            fswTabs
            [key]="'tab_1_digital'"
            [maxTextWidth]="'unset'"
            [label]="'Digital Scorecard'"
          >
            <fsw-digital-scorecard
              [applicationId]="applicationId"
              [isReadonly]="isReadonly"
            ></fsw-digital-scorecard>
          </ng-template>
          <ng-template
            *ngIf="displayConfig.digital_noncredit_model"
            fswTabs
            [key]="'tab_1_digital'"
            [maxTextWidth]="'unset'"
            [label]="'Digital Scorecard'"
          >
            <fsw-digital-scorecard-ncm
              [applicationId]="applicationId"
              [isReadonly]="isReadonly"
              [identifier]="identifier"
              [target]="target"
              (refreshEvent)="refreshDigitalScorecardNCMEvent.emit($event)"
            ></fsw-digital-scorecard-ncm>
          </ng-template>
          <ng-template
            *ngIf="displayConfig.manual"
            fswTabs
            [key]="'tab_2_manual'"
            [maxTextWidth]="'unset'"
            [label]="'Manual Scorecard'"
          >
            <fsw-manual-scorecard
              [applicationId]="applicationId"
              [isReadonly]="isReadonly"
              (isManualScorecardValid)="isManualScorecardValid.emit($event)"
            ></fsw-manual-scorecard>
          </ng-template>
        </fsw-tabs-group>
      </section>
    </div>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { refreshDigitalScorecardNCMEvent: [{
                type: Output
            }], isManualScorecardValid: [{
                type: Output
            }], applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], target: [{
                type: Input
            }], identifier: [{
                type: Input
            }], displayConfig: [{
                type: Input
            }] } });

// @angular
const DECLARATIONS_EXPORTS = [FSWCreditScoringComponent];
class FSWCreditScoringModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCreditScoringModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWCreditScoringModule, declarations: [FSWCreditScoringComponent], imports: [CommonModule,
            LetDirective,
            FormWidgetModule,
            // toolkit-ui
            FSWTabsModule,
            // services modules
            UtilsServiceModule,
            // custom modules
            FSWDigitalScorecardModule,
            FSWManualScorecardModule,
            FSWDigitalScorecardNCMComponent], exports: [FSWCreditScoringComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCreditScoringModule, imports: [CommonModule,
            FormWidgetModule,
            // toolkit-ui
            FSWTabsModule,
            // services modules
            UtilsServiceModule,
            // custom modules
            FSWDigitalScorecardModule,
            FSWManualScorecardModule,
            FSWDigitalScorecardNCMComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCreditScoringModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        LetDirective,
                        FormWidgetModule,
                        // toolkit-ui
                        FSWTabsModule,
                        // services modules
                        UtilsServiceModule,
                        // custom modules
                        FSWDigitalScorecardModule,
                        FSWManualScorecardModule,
                        FSWDigitalScorecardNCMComponent,
                    ],
                    declarations: DECLARATIONS_EXPORTS,
                    exports: DECLARATIONS_EXPORTS,
                }]
        }] });

var title$s = "Credit Assessment";
var columns$9 = {
	factor: "Factor",
	rating: "Rating",
	"credit-assessment": "Comments"
};
var options$3 = {
	low: "Low",
	low_to_med: "Low to Med",
	med: "Med",
	med_to_high: "Med to High",
	high: "High",
	na: "N/A"
};
var comments$2 = {
	tabs: {
		borrower_summary: "Borrower Summary Comments",
		pg: "PG Summary Comments",
		cg: "CG Summary Comments",
		bank_statement_analysis: "Bank Statement analysis Comments",
		outstanding_loan_facility: "Outstanding Loan/Facility Comments",
		exposure: "Exposure Comments"
	},
	labels: {
		bd_rationale: "BD Rationale Comments",
		factsheet: "Factsheet Comments",
		credit: "Credit Comments",
		general_overview: "General Overview Comments",
		strength: "Strength Comments",
		other_stakeholders_summary: "Other Stakeholder's Summary Comments",
		weakness: "Weakness Comments",
		industry: "Industry Comments",
		business_risk: "Business Risk Comments"
	}
};
var buttons$I = {
	save: "Save"
};
var creditAssessmentAll = {
	title: title$s,
	columns: columns$9,
	options: options$3,
	comments: comments$2,
	buttons: buttons$I
};

var ALL$a = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$I,
    columns: columns$9,
    comments: comments$2,
    default: creditAssessmentAll,
    options: options$3,
    title: title$s
});

const CREDIT_ASSESSMENT_ALL_TRANSLATION = ALL$a;

function injectCreditAssessmentALLEffects({ applicationIdSignal, isReadonlySignal, hiddenCommentsSignal, proposalTypeSignal, sectionsSignal, }) {
    const applicationMemberService = injectApplicationMemberService();
    const applicationGuarantorService = injectApplicationGuarantorService();
    const creditGuarantorService = injectCreditGuarantorService();
    const memberService = injectMemberService();
    const alertService = inject(FSW_ALERT_SERVICE_TOKEN);
    const memberSignal = signal(null);
    const summariesSignal = signal([]);
    const loadMember = (applicationId) => applicationMemberService
        .getApplicationMainBorrower(applicationId)
        .pipe(tap((data) => memberSignal.set(data)), catchError(() => {
        alertService.error('Failed to load member', null, {
            duration: 3000,
        });
        memberSignal.set(null);
        return of(null);
    }))
        .subscribe();
    const loadSummaries = (applicationId, member) => applicationGuarantorService
        .getSummaries(applicationId)
        .pipe(map((summaries) => summaries
        ? summaries
            .filter((summary) => summary.guarantor_summary_type === FSWRecourseTypes.PG)
            .map((item) => [item.guarantor_summary_id, item.business_interest_party_id])
        : []), switchMap$1((ids) => {
        if (ids.length) {
            return creditGuarantorService.getPersonalSummaries(ids.map((id) => id[0])).pipe(map((data) => data.map((item) => {
                const bip = ids.find((id) => id[0] === item.id);
                if (bip?.[1]) {
                    item.id_number = bip[1];
                }
                return item;
            })));
        }
        if (isReadonlySignal()) {
            return of([]);
        }
        return creditGuarantorService.ctosExtract(Number(member.id)).pipe(map((data) => data
            .map((item) => {
            const summary = item.summary?.IndividualSummary;
            if (summary) {
                summary.id_number = item.id_number;
            }
            return summary;
        })
            .filter((item) => !!item)));
    }), switchMap$1((summaries) => memberService
        .getMergeBipNames(applicationIdSignal(), member.uuid, {
        expand: true,
    }, member.company_registration_number)
        .pipe(map((bips) => summaries.map((summary) => {
        const bipSummary = bips?.find((bip) => bip.id == summary.id_number);
        if (bipSummary) {
            summary.name = bipSummary.name;
        }
        return summary;
    })), map((data) => data.map((item) => ({
        ...item,
        date_of_birth: toTimezoneHourOffset(item.date_of_birth, 'down'),
    }))))), tap((data) => summariesSignal.set(data)), catchError(() => {
        alertService.error('Failed to load summaries', null, {
            duration: 3000,
        });
        summariesSignal.set([]);
        return of([]);
    }))
        .subscribe();
    const refreshMember = () => {
        const applicationId = applicationIdSignal();
        if (!applicationId) {
            return;
        }
        loadMember(applicationId);
    };
    const refreshSummaries = () => {
        const applicationId = applicationIdSignal();
        const member = memberSignal();
        if (!applicationId || !member) {
            return;
        }
        loadSummaries(applicationId, member);
    };
    const buildComments = (applicationId, summaries) => {
        const sections = [
            {
                title: 'comments.tabs.borrower_summary',
                customClasses: 'w-full flex flex-col gap-4',
                items: [
                    {
                        category: 'BD_RATIONALE',
                        title: 'comments.labels.bd_rationale',
                        module: 'BORROWER_SUMMARY',
                        identifier: 'BORROWER_SUMMARY',
                        entityId: applicationId,
                        fields: [
                            {
                                key: 'main_comment',
                                label: 'comments.labels.bd_rationale',
                            },
                        ],
                    },
                    {
                        category: 'FACTSHEET',
                        title: 'comments.labels.factsheet',
                        module: 'BORROWER_SUMMARY',
                        identifier: 'BORROWER_SUMMARY',
                        entityId: applicationId,
                        customClasses: 'flex flex-wrap gap-[16px]',
                        fields: [
                            {
                                key: 'general_overview',
                                label: 'comments.labels.general_overview',
                            },
                            {
                                key: 'strength',
                                label: 'comments.labels.strength',
                            },
                            {
                                key: 'other_stakeholders_summary',
                                label: 'comments.labels.other_stakeholders_summary',
                            },
                            {
                                key: 'weakness',
                                label: 'comments.labels.weakness',
                            },
                            {
                                key: 'industry',
                                label: 'comments.labels.industry',
                            },
                            {
                                key: 'business_risk',
                                label: 'comments.labels.business_risk',
                            },
                        ],
                    },
                    {
                        category: 'CREDIT',
                        title: 'comments.labels.credit',
                        module: 'BORROWER_SUMMARY',
                        identifier: 'BORROWER_SUMMARY',
                        entityId: applicationId,
                        fields: [
                            {
                                key: 'main_comment',
                                label: 'comments.labels.credit',
                            },
                        ],
                    },
                ].filter((item) => !hiddenCommentsSignal()['borrower-summary']?.includes(item['category'])),
            },
            ...summaries.map((item, index) => ({
                title: `PG - ${item.name ?? `${index + 1}`}`,
                customClasses: 'w-full flex flex-col gap-4',
                items: [
                    {
                        category: 'FACTSHEET',
                        title: 'comments.labels.factsheet',
                        module: 'PG_SUMMARY',
                        identifier: item.id,
                        entityId: applicationId,
                        fields: [
                            {
                                key: 'main_comment',
                                label: 'comments.labels.factsheet',
                            },
                        ],
                    },
                    {
                        category: 'CREDIT',
                        title: 'comments.labels.credit',
                        module: 'PG_SUMMARY',
                        identifier: item.id,
                        entityId: applicationId,
                        fields: [
                            {
                                key: 'main_comment',
                                label: 'comments.labels.credit',
                            },
                        ],
                    },
                ].filter((item) => !hiddenCommentsSignal()['personal-guarantor']?.includes(item['category'])),
            })),
            {
                title: 'comments.tabs.cg',
                customClasses: 'w-full flex flex-col gap-4',
                items: [
                    {
                        category: 'FACTSHEET',
                        title: 'comments.labels.factsheet',
                        module: 'CG_SUMMARY',
                        identifier: 'CG_SUMMARY',
                        entityId: applicationId,
                        fields: [
                            {
                                key: 'main_comment',
                                label: 'comments.labels.factsheet',
                            },
                        ],
                    },
                    {
                        category: 'CREDIT',
                        title: 'comments.labels.credit',
                        module: 'CG_SUMMARY',
                        identifier: 'CG_SUMMARY',
                        entityId: applicationId,
                        fields: [
                            {
                                key: 'main_comment',
                                label: 'comments.labels.credit',
                            },
                        ],
                    },
                ].filter((item) => !hiddenCommentsSignal()['corporate-guarantor']?.includes(item['category'])),
            },
            ...(proposalTypeSignal() === 'LOAN'
                ? [
                    {
                        title: 'comments.tabs.bank_statement_analysis',
                        customClasses: 'w-full flex flex-col gap-4',
                        items: [
                            {
                                category: 'FACTSHEET',
                                title: 'comments.labels.factsheet',
                                module: 'BANK_STMT_ANALYSIS',
                                identifier: 'BANK_STMT_ANALYSIS',
                                entityId: applicationId,
                                fields: [
                                    {
                                        key: 'main_comment',
                                        label: 'comments.labels.factsheet',
                                    },
                                ],
                            },
                            {
                                category: 'CREDIT',
                                title: 'comments.labels.credit',
                                module: 'BANK_STMT_ANALYSIS',
                                identifier: 'BANK_STMT_ANALYSIS',
                                entityId: applicationId,
                                fields: [
                                    {
                                        key: 'main_comment',
                                        label: 'comments.labels.credit',
                                    },
                                ],
                            },
                        ].filter((item) => !hiddenCommentsSignal()['bank-statement-analysis']?.includes(item['category'])),
                    },
                ]
                : []),
            {
                title: 'comments.tabs.outstanding_loan_facility',
                customClasses: 'w-full flex flex-col gap-4',
                items: [
                    {
                        category: 'FACTSHEET',
                        title: 'comments.labels.factsheet',
                        module: 'OUTSTANDING_LOAN_FACILITY',
                        identifier: 'OUTSTANDING_LOAN_FACILITY',
                        entityId: applicationId,
                        fields: [
                            {
                                key: 'main_comment',
                                label: 'comments.labels.factsheet',
                            },
                        ],
                    },
                    {
                        category: 'CREDIT',
                        title: 'comments.labels.credit',
                        module: 'OUTSTANDING_LOAN_FACILITY',
                        identifier: 'OUTSTANDING_LOAN_FACILITY',
                        entityId: applicationId,
                        fields: [
                            {
                                key: 'main_comment',
                                label: 'comments.labels.credit',
                            },
                        ],
                    },
                ].filter((item) => !hiddenCommentsSignal()['outstanding-loan-facility']?.includes(item['category'])),
            },
            ...(!hiddenCommentsSignal()['exposure']?.some((item) => item === 'FACTSHEET')
                ? [
                    {
                        title: 'comments.tabs.exposure',
                        customClasses: 'w-full flex flex-col gap-4',
                        items: [
                            {
                                category: 'FACTSHEET',
                                title: 'comments.labels.factsheet',
                                module: 'EXPOSURE',
                                identifier: 'EXPOSURE',
                                entityId: applicationId,
                                fields: [
                                    {
                                        key: 'main_comment',
                                        label: 'comments.labels.factsheet',
                                    },
                                ],
                            },
                        ],
                    },
                ]
                : []),
        ];
        sectionsSignal.set(sections);
    };
    return {
        init: () => {
            effect(() => refreshMember(), { allowSignalWrites: true });
            effect(() => refreshSummaries(), { allowSignalWrites: true });
            effect(() => {
                const applicationId = applicationIdSignal();
                const summaries = summariesSignal();
                if (!applicationId) {
                    sectionsSignal.set([]);
                    return;
                }
                buildComments(applicationId, summaries);
            }, { allowSignalWrites: true });
        },
    };
}

function injectCreditAssessmentEffects(config) {
    switch (getCountryCodeFromStorage()) {
        default:
            return injectCreditAssessmentALLEffects(config);
    }
}

function creditAssessmentTranslation(scope = 'credit_assessment') {
    return [
        ...(FSWTranslateModule.forFeature({
            scope,
            defaultKey: getCountryCodeFromStorage(),
            data: {
                [CountryCode.MY]: CREDIT_ASSESSMENT_ALL_TRANSLATION,
                [CountryCode.SG]: CREDIT_ASSESSMENT_ALL_TRANSLATION,
                [CountryCode.TH]: CREDIT_ASSESSMENT_ALL_TRANSLATION,
                [CountryCode.VU]: CREDIT_ASSESSMENT_ALL_TRANSLATION,
                [CountryCode.ID]: CREDIT_ASSESSMENT_ALL_TRANSLATION,
            },
        }).providers || []),
        fswTranslateScope(scope),
    ];
}

class FSWCreditAssessmentComponent {
    set applicationId(applicationId) {
        this.applicationIdSignal.set(applicationId);
    }
    set isReadonly(isReadonly) {
        this.isReadonlySignal.set(isReadonly);
    }
    set hiddenComments(hiddenComments) {
        this.hiddenCommentsSignal.set(hiddenComments);
    }
    set proposalType(proposalType) {
        this.proposalTypeSignal.set(proposalType);
    }
    constructor() {
        this.applicationIdSignal = signal(null);
        this.isReadonlySignal = signal(false);
        this.hiddenCommentsSignal = signal({});
        this.proposalTypeSignal = signal('LOAN');
        this.sectionsSignal = signal([]);
        this.effects = injectCreditAssessmentEffects({
            applicationIdSignal: this.applicationIdSignal,
            isReadonlySignal: this.isReadonlySignal,
            hiddenCommentsSignal: this.hiddenCommentsSignal,
            proposalTypeSignal: this.proposalTypeSignal,
            sectionsSignal: this.sectionsSignal,
        });
        this.effects.init();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCreditAssessmentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCreditAssessmentComponent, isStandalone: true, selector: "fsw-credit-assessment", inputs: { applicationId: "applicationId", isReadonly: "isReadonly", hiddenComments: "hiddenComments", proposalType: "proposalType" }, providers: [
            creditAssessmentTranslation(),
            provideUtilsService(),
            provideApplicationGuarantorService(),
            provideCreditGuarantorService(),
            provideApplicationMemberService(),
            provideMemberService(),
        ], ngImport: i0, template: "<fsw-comments-section\n  [customClasses]=\"'w-full flex flex-col gap-4'\"\n  [data]=\"sectionsSignal()\"\n  [enableSaveButton]=\"true\"\n  [isReadonly]=\"isReadonlySignal()\"\n  [translateScope]=\"'credit_assessment'\"\n></fsw-comments-section>\n", dependencies: [{ kind: "component", type: FSWCommentsSectionComponent, selector: "fsw-comments-section", inputs: ["data", "customClasses", "translateScope", "isReadonly", "enableSaveButton"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCreditAssessmentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-credit-assessment', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [FSWCommentsSectionComponent], providers: [
                        creditAssessmentTranslation(),
                        provideUtilsService(),
                        provideApplicationGuarantorService(),
                        provideCreditGuarantorService(),
                        provideApplicationMemberService(),
                        provideMemberService(),
                    ], template: "<fsw-comments-section\n  [customClasses]=\"'w-full flex flex-col gap-4'\"\n  [data]=\"sectionsSignal()\"\n  [enableSaveButton]=\"true\"\n  [isReadonly]=\"isReadonlySignal()\"\n  [translateScope]=\"'credit_assessment'\"\n></fsw-comments-section>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], hiddenComments: [{
                type: Input
            }], proposalType: [{
                type: Input
            }] } });

var CBEntityTypes;
(function (CBEntityTypes) {
    CBEntityTypes["INDIVIDUAL"] = "KTP";
    CBEntityTypes["CORPORATE"] = "NPWP";
})(CBEntityTypes || (CBEntityTypes = {}));

var CBFormKeys;
(function (CBFormKeys) {
    CBFormKeys["GENERAL"] = "general";
    CBFormKeys["BANK"] = "bank";
    CBFormKeys["ADDITIONAL"] = "additional";
})(CBFormKeys || (CBFormKeys = {}));

var CBMemberTypes;
(function (CBMemberTypes) {
    CBMemberTypes["BRW"] = "BRW";
    CBMemberTypes["BIP"] = "BIP";
})(CBMemberTypes || (CBMemberTypes = {}));

class CBComponentStore extends ComponentStore {
    //#region Getter
    get report() {
        return this.state().report?.credit_bureau_report_detail || null;
    }
    //#endregion Getter
    constructor(_service, _initialState = {}) {
        super({
            applicationId: null,
            id: null,
            data: null,
            countryId: null,
            bips: [],
            report: null,
            available: [],
            selectedMember: null,
            uploadError: false,
            ..._initialState,
        });
        this._service = _service;
        this._initialState = _initialState;
        this.selectedMember$ = this.select((state) => state.selectedMember);
        this.report$ = this.select((state) => state.report?.credit_bureau_report_detail || null);
        this._reloadAvailable$ = new BehaviorSubject(new Date());
        this._reloadReport$ = new BehaviorSubject(new Date());
        //#region Effects
        this.save = this.effect(pipe(switchMap((cb) => {
            const { report } = this.state();
            if (!report)
                return throwError(new Error('Empty Credit Bureau'));
            const value = cb(report.credit_bureau_report_detail);
            return this._service
                .put(value, this.state().countryId)
                .pipe(tap(() => this._reloadReport$.next(new Date())));
        }), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        this.upload = this.effect(pipe(switchMap((file) => this._service
            .upload({
            file,
            doc_type: 'CREDIT_BUREAU_REPORT',
        })
            .pipe(switchMap((doc) => {
            if (!this.state().selectedMember || !this.state().data)
                return throwError(new Error('Can not call this api'));
            return this._service
                .post({
                doc_id: doc.id,
                entity_no: this.state().selectedMember?.erc,
                entity_no_type: this.state().selectedMember?.entity_type,
                member_id: Number.parseInt(this.state().data?.id),
            }, this.state().countryId)
                .pipe(tap(() => {
                this._reloadReport$.next(new Date());
                this._reloadAvailable$.next(new Date());
                this.setUploadError(false);
            }));
        }))), catchError((err) => {
            console.error(err);
            this.setUploadError(true);
            return EMPTY;
        })));
        this.loadData = this.effect(pipe(switchMap(() => this.loadDataAsync()), tap((data) => {
            const ic_number = data.ic_number;
            const company_registration_number = data.company_registration_number;
            const isIndividual = !!ic_number;
            const information = data;
            this.setSelectedMember({
                member_type: CBMemberTypes.BRW,
                entity_type: isIndividual ? CBEntityTypes.INDIVIDUAL : CBEntityTypes.CORPORATE,
                erc: isIndividual ? ic_number : company_registration_number,
                information,
            });
        }), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        this.loadReport = this.effect(pipe(switchMap(() => combineLatest([
            this.select((state) => state.selectedMember).pipe(distinctUntilChanged()),
            this._reloadReport$.asObservable(),
        ]).pipe(switchMap(([data]) => {
            if (!data?.erc)
                return of({});
            return this.loadReportAsync(data.erc);
        }))), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        this.loadBIPs = this.effect(pipe(switchMap(() => this.loadBIPsAsync()), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        this.loadAvailable = this.effect(pipe(switchMap(() => combineLatest([
            this.select((state) => state.data),
            this.select((state) => state.bips),
            this._reloadAvailable$.asObservable(),
        ]).pipe(switchMap(([data, bips]) => {
            if (!data)
                return of({});
            const entityNo = bips.map((e) => e.expand.ic_number || e.expand.company_registration_number);
            entityNo.push(data.ic_number || data.company_registration_number);
            return this.loadAvailableAsync(entityNo);
        }))), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
    }
    //#endregion Effects
    //#region Data
    loadDataAsync() {
        return this._service
            .getMemberDetailById(this.state().id, {
            country_code: this.state().countryId,
            member_type_code: CBMemberTypes.BRW,
        })
            .pipe(tap((data) => this.setData(data)));
    }
    setData(data) {
        const updater = this.updater((state, data) => ({
            ...state,
            data,
        }));
        updater(data);
    }
    //#endregion Data
    //#region Report
    loadReportAsync(id) {
        return this._service
            .getByIds([id], this.state().countryId)
            .pipe(tap((data) => this.setReport(data ? data[0] : null)));
    }
    setReport(data) {
        const updater = this.updater((state, report) => ({
            ...state,
            report,
        }));
        updater(data);
    }
    //#endregion Report
    //#region BIPS
    loadBIPsAsync() {
        return this._service
            .getApplicationBIPByMemberId(this.state().applicationId, this.state().id)
            .pipe(tap((data) => this.setBIPs(data)));
    }
    setBIPs(data) {
        const updater = this.updater((state, bips) => ({
            ...state,
            bips,
        }));
        updater(data);
    }
    //#endregion BIPS
    //#region Available
    loadAvailableAsync(entityNo) {
        return this._service.getByIds(entityNo, this.state().countryId, false).pipe(map((reports) => reports.map((e) => e.entity_no)), tap((e) => this.setAvailable(e)));
    }
    setAvailable(data) {
        const updater = this.updater((state, available) => ({
            ...state,
            available,
        }));
        updater(data);
    }
    //#endregion Available
    //#region Setup
    setApplicationId(data) {
        const updater = this.updater((state, applicationId) => ({
            ...state,
            applicationId,
        }));
        updater(data);
    }
    setId(data) {
        const updater = this.updater((state, id) => ({
            ...state,
            id,
        }));
        updater(data);
    }
    setSelectedMember(data) {
        const updater = this.updater((state, selectedMember) => ({
            ...state,
            selectedMember,
        }));
        updater(data);
        this.setUploadError(false);
    }
    setUploadError(data) {
        const updater = this.updater((state, uploadError) => ({
            ...state,
            uploadError,
        }));
        updater(data);
    }
    //#endregion Setup
    //#region Methods
    init() {
        this.loadData();
        this.loadBIPs();
        this.loadAvailable();
        this.loadReport();
    }
}

class CBBaseComponentStore extends ComponentStore {
    get updated$() {
        return this._updated$.asObservable();
    }
    get editable$() {
        return this.select((state) => state.editable);
    }
    constructor(_initialState, _cbComponentStore) {
        super(_initialState);
        this._initialState = _initialState;
        this._cbComponentStore = _cbComponentStore;
        this.formTrigger$ = new BehaviorSubject(new Date());
        this.edited$ = this.formTrigger$.pipe(map(() => {
            const result = this.editedCheck();
            return result;
        }));
        this._updated$ = new BehaviorSubject(new Date());
        this.init = this.effect(pipe(switchMap(() => combineLatest([this.translate$, this._cbComponentStore.report$]).pipe(tap(([translate, report]) => {
            if (report) {
                this.reset();
                this.clear();
                this.setup(translate);
            }
            this._next();
        })))));
        this.triggerForm = this.effect(pipe(mergeMap((form) => form.valueChanges.pipe(tap(() => this.formTrigger$.next(new Date()))))));
    }
    setEditable(value) {
        const update = this.updater((state, editable) => ({
            ...state,
            editable,
        }));
        update(value);
    }
    _next() {
        this._updated$.next(new Date());
    }
}

class CBAdditionalComponentStore extends CBBaseComponentStore {
    get nplConfigs() {
        return Array.from(this._formNPLConfigMap.keys()).map((id) => ({
            id,
            value: this._formNPLConfigMap.get(id),
        }));
    }
    get offBalanceSheetConfigs() {
        return Array.from(this._formOffBalanceSheetConfigMap.keys()).map((id) => ({
            id,
            value: this._formOffBalanceSheetConfigMap.get(id),
        }));
    }
    get debtConfigs() {
        return Array.from(this._formDebtConfigMap.keys()).map((id) => ({
            id,
            value: this._formDebtConfigMap.get(id),
        }));
    }
    constructor(_scope, _translateService, _cbComponentStore) {
        super({
            editable: false,
        }, _cbComponentStore);
        this._scope = _scope;
        this._translateService = _translateService;
        this._cbComponentStore = _cbComponentStore;
        this.translate$ = this._translateService.selectFeatureTranslate(this._scope, 'additional_summary');
        this._formGroupMap = new Map();
        this._formConfigMap = new Map();
        this._formOffBalanceSheetConfigMap = new Map();
        this._formNPLConfigMap = new Map();
        this._formDebtConfigMap = new Map();
    }
    setupOffBalanceSheetConfig(id, config) {
        this._formOffBalanceSheetConfigMap.set(id, config);
    }
    setupNPLConfig(id, config) {
        this._formNPLConfigMap.set(id, config);
    }
    setupDebtConfig(id, config) {
        this._formDebtConfigMap.set(id, config);
    }
    getOffBalanceSheet(data) {
        if (!data)
            return null;
        return {
            bank_name: data.bank_name,
            branch_name: data.branch_name,
            amount: data.amount,
            debt: data.type,
        };
    }
    getNPL(data) {
        if (!data)
            return null;
        return {
            bank_name: data.bank_name,
            branch_name: data.branch_name,
            amount: data.debt_amount,
            debt: data.debt_type,
        };
    }
    getDebt(data) {
        if (!data)
            return null;
        return {
            total: data.debt_attention_vnd_amount,
            report_date: data.report_date,
            bank_name: data.bank_name,
            branch_name: data.branch_name,
        };
    }
    getCollaterals(data) {
        if (!data)
            return null;
        return {
            secured_loans: data.secured_loan,
            number_banks: data.number_banks,
        };
    }
    getRequested(data) {
        if (!data)
            return null;
        return {
            total_requests: data.total_requests,
        };
    }
    getCredit(data) {
        if (!data)
            return null;
        return data;
    }
    setupConfig(id, config) {
        this._formConfigMap.set(id, config);
    }
    setupFormGroup(id, form) {
        this._formGroupMap.set(id, form);
        this.formTrigger$.next(new Date());
        this.triggerForm(form);
    }
    reset() {
        this._resetItem('collaterals');
        this._resetItem('credit');
        this._resetNPL();
        this._resetOffBalanceSheetNPL();
        this._resetDebtNPL();
    }
    clear() {
        this._formGroupMap.clear();
        this._formConfigMap.clear();
        this._formDebtConfigMap.clear();
        this._formOffBalanceSheetConfigMap.clear();
        this._formNPLConfigMap.clear();
    }
    getValue(id) {
        return this._formGroupMap.get(id)?.value;
    }
    getConfig(id) {
        return this._formConfigMap.get(id) || null;
    }
    editedCheck() {
        return (this._itemCheck('credit') ||
            this._itemCheck('collaterals') ||
            this._itemCheck('requested') ||
            this._nplCheck() ||
            this._offBalanceSheetCheck() ||
            this._debtCheck());
    }
    submit(report) {
        this._submitCredit(report);
        this._submitCollaterals(report);
        this._submitRequested(report);
        this._submitNPL(report);
        this._submitDebt(report);
        this._submitOffBalanceSheet(report);
    }
    _submitCredit(report) {
        const value = this.getValue('credit');
        if (!value)
            return;
        let { credit_card_detail } = report;
        credit_card_detail = credit_card_detail ? credit_card_detail : {};
        credit_card_detail.total_limit = value.total_limit;
        credit_card_detail.total_need_pay = value.total_need_pay;
        credit_card_detail.total_late_pay = value.total_late_pay;
        credit_card_detail.numbers_of_credit_card = value.numbers_of_credit_card;
    }
    _submitCollaterals(report) {
        const value = this.getValue('collaterals');
        if (!value)
            return;
        let { collaterals_detail } = report;
        collaterals_detail = collaterals_detail ? collaterals_detail : {};
        collaterals_detail.secured_loan = value.secured_loans;
        collaterals_detail.number_banks = value.number_banks;
    }
    _submitRequested(report) {
        const value = this.getValue('requested');
        if (!value)
            return;
        let { cb_requested_by_bank_fs_details } = report;
        cb_requested_by_bank_fs_details = cb_requested_by_bank_fs_details
            ? cb_requested_by_bank_fs_details
            : {};
        cb_requested_by_bank_fs_details.total_requests = value.total_requests;
    }
    _submitNPL(report) {
        const configs = this.nplConfigs;
        if (!configs.length)
            return;
        report.npl_details = configs.map((e) => {
            const value = this.getValue(e.id);
            if (!value)
                return e.value.saveValue;
            return {
                ...e.value.saveValue,
                bank_name: value?.bank_name,
                branch_name: value?.branch_name,
                debt_type: value?.debt,
                debt_amount: value?.amount,
            };
        });
    }
    _submitOffBalanceSheet(report) {
        const configs = this.offBalanceSheetConfigs;
        if (!configs.length)
            return;
        report.off_balance_sheet_details = configs.map((e) => {
            const value = this.getValue(e.id);
            if (!value)
                return e.value.saveValue;
            return {
                ...e.value.saveValue,
                bank_name: value?.bank_name,
                branch_name: value?.branch_name,
                debt_classicial: value?.debt,
                amount: value?.amount,
            };
        });
    }
    _submitDebt(report) {
        const configs = this.debtConfigs;
        if (!configs.length)
            return;
        report.debt_need_attentions = configs.map((e) => {
            const value = this.getValue(e.id);
            if (!value)
                return e.value.saveValue;
            return {
                ...e.value.saveValue,
                debt_attention_vnd_amount: value?.total,
                report_date: value?.report_date,
                bank_name: value?.bank_name,
                branch_name: value?.branch_name,
            };
        });
    }
    _resetItem(id) {
        const form = this._formGroupMap.get(id);
        const value = this.getConfig(id)?.defaultValue;
        if (value && form) {
            form.patchValue({
                ...value,
            });
        }
    }
    _resetNPL() {
        this.nplConfigs.forEach((e) => {
            const form = this._formGroupMap.get(e.id);
            const value = e.value.defaultValue;
            if (value && form) {
                form.patchValue({
                    ...value,
                });
            }
        });
    }
    _resetOffBalanceSheetNPL() {
        this.offBalanceSheetConfigs.forEach((e) => {
            const form = this._formGroupMap.get(e.id);
            const value = e.value.defaultValue;
            if (value && form) {
                form.patchValue({
                    ...value,
                });
            }
        });
    }
    _resetDebtNPL() {
        this.debtConfigs.forEach((e) => {
            const form = this._formGroupMap.get(e.id);
            const value = e.value.defaultValue;
            if (value && form) {
                form.patchValue({
                    ...value,
                });
            }
        });
    }
    _nplCheck() {
        const configs = this.nplConfigs;
        return configs.reduce((acc, cur) => acc || this._childCheck(cur), false);
    }
    _offBalanceSheetCheck() {
        const configs = this.offBalanceSheetConfigs;
        return configs.reduce((acc, cur) => acc || this._childCheck(cur), false);
    }
    _debtCheck() {
        const configs = this.debtConfigs;
        return configs.reduce((acc, cur) => acc || this._childCheck(cur), false);
    }
    _itemCheck(id) {
        const config = this._formConfigMap.get(id);
        const form = this._formGroupMap.get(id);
        if (!form || !config)
            return false;
        return !isEqual(config.defaultValue, form.value);
    }
    _childCheck(data) {
        const form = this._formGroupMap.get(data.id);
        if (!form)
            return false;
        return !isEqual(data.value.defaultValue, form.value);
    }
}

class CBBankComponentStore extends CBBaseComponentStore {
    get configs() {
        return Array.from(this._formConfigMap.keys()).map((id) => ({
            id,
            ...this._formConfigMap.get(id),
        }));
    }
    constructor(_scope, _translateService, _cbComponentStore) {
        super({
            editable: false,
        }, _cbComponentStore);
        this._scope = _scope;
        this._translateService = _translateService;
        this._cbComponentStore = _cbComponentStore;
        this.translate$ = this._translateService.selectFeatureTranslate(this._scope, 'bank_summary');
        this._formGroupMap = new Map();
        this._formConfigMap = new Map();
    }
    setupConfig(id, config) {
        const exist = this._formConfigMap.get(id);
        this._formConfigMap.set(id, {
            ...exist,
            ...config,
        });
    }
    setupFormGroup(id, form) {
        this._formGroupMap.set(id, form);
        this.formTrigger$.next(new Date());
        this.triggerForm(form);
    }
    getBankValue() {
        return this._cbComponentStore.report?.aggregated_outstanding_balances || null;
    }
    getListValue() {
        return this.getBankValue()?.outstanding_balance_details || [];
    }
    getBasicValue(id) {
        const item = this._formGroupMap.get(id);
        return item?.value;
    }
    getTermValue(id) {
        const item = this._formGroupMap.get(id);
        return item?.value;
    }
    getDebtValue(id) {
        const item = this._formGroupMap.get(id);
        return item?.value;
    }
    reset() {
        this.configs.forEach((e) => {
            this._resetItem(e);
        });
    }
    clear() {
        this._formGroupMap.clear();
        this._formConfigMap.clear();
    }
    editedCheck() {
        return this.configs.reduce((acc, cur) => acc || this._itemCheck(cur), false);
    }
    submit(report) {
        if (!this.configs.length)
            return;
        const value = this.configs.map((e) => {
            const value = this._submitBasic(e.id, e.basic || null);
            value.loan_terms = e.terms?.map((e) => this._submitTerm(e)) || [];
            return value;
        });
        report.aggregated_outstanding_balances = report.aggregated_outstanding_balances
            ? report.aggregated_outstanding_balances
            : {};
        report.aggregated_outstanding_balances.outstanding_balance_details = value;
        report.aggregated_outstanding_balances.total_amt_vnd = value.reduce((acc, cur) => {
            return (acc +
                cur.loan_terms.reduce((termAcc, termCur) => {
                    return termAcc + termCur.total_vnd;
                }, 0));
        }, 0);
    }
    _submitBasic(id, config) {
        const value = this._formGroupMap.get(id)?.value;
        if (!config || !value)
            return config?.saveValue;
        return {
            branch_name: value.branch_name,
            bank_name: value.bank_name,
            loan_terms: [],
            last_update_date: new Date().toISOString(),
        };
    }
    _submitTerm(config) {
        const value = this._formGroupMap.get(config.id)?.value;
        if (!value)
            return config.data.saveValue;
        const { saveValue } = config.data;
        const debt_details = config.debts.map((e) => this._submitDebt(e));
        const total_vnd = debt_details.reduce((acc, cur) => acc + cur.vnd_amt, 0);
        return {
            ...saveValue,
            type: value.term,
            debt_details,
            total_vnd,
        };
    }
    _submitDebt(config) {
        const value = this._formGroupMap.get(config.id)?.value;
        if (!value)
            return config.data.saveValue;
        const { saveValue } = config.data;
        return {
            ...saveValue,
            type: value.debt,
            vnd_amt: Number.parseInt(value.outstanding_balance),
        };
    }
    _resetItem(config) {
        const basicForm = this._formGroupMap.get(config.id);
        const basicData = config.basic?.formData;
        basicForm?.patchValue(basicData);
        config.terms?.forEach((term) => this._resetTerm(term));
    }
    _resetTerm(term) {
        const form = this._formGroupMap.get(term.id);
        const data = term.data.formData;
        form?.patchValue(data);
        term.debts.forEach((debt) => this._resetDebt(debt));
    }
    _resetDebt(debt) {
        const form = this._formGroupMap.get(debt.id);
        const data = debt.data.formData;
        form?.patchValue(data);
    }
    _itemCheck(data) {
        return (this._basicCheck(data) ||
            !!data.terms?.reduce((acc, cur) => acc || this._termCheck(cur), false));
    }
    _basicCheck(data) {
        const value = this._formGroupMap.get(data.id)?.value;
        const compare = data.basic?.defaultValue;
        if (!value || !compare)
            return false;
        value && delete value.outstanding_balance;
        compare && delete compare.outstanding_balance;
        return !isEqual(compare, value);
    }
    _termCheck(term) {
        const value = this._formGroupMap.get(term.id)?.value;
        if (!value)
            return false;
        const change = !isEqual(term.data.defaultValue, value);
        return change || term.debts.reduce((acc, cur) => acc || this._debtCheck(cur), false);
    }
    _debtCheck(debt) {
        const value = this._formGroupMap.get(debt.id)?.value;
        if (!value)
            return false;
        return !isEqual(debt.data.defaultValue, value);
    }
}

class CBGeneralComponentStore extends CBBaseComponentStore {
    constructor(_scope, _translateService, _cbComponentStore) {
        super({
            editable: false,
        }, _cbComponentStore);
        this._scope = _scope;
        this._translateService = _translateService;
        this._cbComponentStore = _cbComponentStore;
        //#region Getter
        //#endregion Getter
        this.translate$ = this._translateService.selectFeatureTranslate(this._scope, 'general_summary');
        this._formGroupMap = new Map();
        this._formConfigMap = new Map();
    }
    setupConfig(id, config) {
        this._formConfigMap.set(id, config);
    }
    setupFormGroup(id, form) {
        this._formGroupMap.set(id, form);
        this.formTrigger$.next(new Date());
        this.triggerForm(form);
    }
    reset() {
        this._resetItem('basic');
        this._resetItem('credit');
    }
    setEditable(value) {
        const update = this.updater((state, editable) => ({
            ...state,
            editable,
        }));
        update(value);
    }
    getBasic() {
        if (!this._cbComponentStore.report)
            return null;
        if (!this._cbComponentStore.report.customer_detail ||
            !this._cbComponentStore.report.summary_enquiry)
            return null;
        return {
            issued_date: this._cbComponentStore.report.summary_enquiry.issued_date,
            name: this._cbComponentStore.report.customer_detail.name,
            erc: this._cbComponentStore.report.customer_detail.erc,
        };
    }
    getCredit() {
        if (!this._cbComponentStore.report)
            return null;
        return this._cbComponentStore.report.personal_bureau_score;
    }
    getValue(id) {
        return this._formGroupMap.get(id)?.value;
    }
    getConfig(id) {
        return this._formConfigMap.get(id) || null;
    }
    editedCheck() {
        return this._itemCheck('basic') || this._itemCheck('credit');
    }
    submit(report) {
        this._submitBasic(report);
        this._submitCredit(report);
    }
    clear() {
        this._formGroupMap.clear();
        this._formConfigMap.clear();
    }
    _submitBasic(report) {
        const value = this.getValue('basic');
        if (!value)
            return;
        let { customer_detail, summary_enquiry } = report;
        customer_detail = customer_detail ? customer_detail : {};
        summary_enquiry = summary_enquiry ? summary_enquiry : {};
        customer_detail.name = value.name;
        customer_detail.erc = value.erc;
        summary_enquiry.issued_date = value.issued_date;
    }
    _submitCredit(report) {
        const value = this.getValue('credit');
        if (!value)
            return;
        let { personal_bureau_score } = report;
        personal_bureau_score = personal_bureau_score
            ? personal_bureau_score
            : {};
        personal_bureau_score.score = value.score;
        personal_bureau_score.rank = value.rank;
    }
    _resetItem(id) {
        const form = this._formGroupMap.get(id);
        const value = this.getConfig(id)?.defaultValue;
        if (value && form) {
            form.patchValue({
                ...value,
            });
        }
    }
    _itemCheck(id) {
        const config = this._formConfigMap.get(id);
        const form = this._formGroupMap.get(id);
        if (!config || !form)
            return false;
        return !isEqual(config.defaultValue, form.value);
    }
}

const CREDIT_BUREAU_SERVICE_TOKEN = new InjectionToken('CREDIT_BUREAU_SERVICE_TOKEN');

class CreditBureauService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._kongUrl = this._utilsService.getKongUrl();
    }
    //#region Application
    getApplicationMembers(applicationId, params = {
        type: 'MAIN',
    }) {
        const url = `${this._kongUrl}/aps/v1/applications/${applicationId}/members`;
        // const url = 'assets/mocks/cb/members.json';
        return this._httpClient
            .get(url, {
            params,
            headers: setRequestOptions(),
        })
            .pipe(map((res) => (res ? res : { data: { members: [] } })), map(({ data }) => data.members));
    }
    getApplicationBIPByMemberId(applicationId, memberId, params = {
        expand: true,
        page: 1,
        limit: 10,
    }) {
        const url = `${this._kongUrl}/aps/v1/applications/${applicationId}/members/${memberId}/bips`;
        // const url = 'assets/mocks/cb/bips.json';
        return this._httpClient
            .get(url, {
            params,
            headers: setRequestOptions(),
        })
            .pipe(map((res) => (res ? res : { data: { bips: [] } })), map(({ data }) => data.bips || []));
    }
    //#endregion Application
    //#region Main
    post(data, countryId) {
        const url = `${this._kongUrl}/credit/v2/${countryId.toLowerCase()}/credit_bureau`;
        // const url = 'assets/mocks/cb/post-file.json';
        return this._httpClient
            .post(url, data, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => data));
    }
    put(data, countryId) {
        const url = `${this._kongUrl}/credit/v2/${countryId.toLowerCase()}/credit_bureau/${data.report_id}/report_detail/${data.id}`;
        // const url = 'assets/mocks/cb/put.json';
        return this._httpClient
            .put(url, { data }, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => data));
    }
    getByIds(entityNo, countryId, showDetail = true) {
        const url = `${this._kongUrl}/credit/v2/${countryId.toLowerCase()}/credit_bureau`;
        // const url = entityNo.length > 1 ? 'assets/mocks/cb/available.json' : `assets/mocks/cb/report-${entityNo[0]}.json`;
        return this._httpClient
            .get(url, {
            params: {
                entity_no: entityNo.join(','),
                is_show_detail: showDetail,
            },
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data));
    }
    //#endregion Main
    //#region Others
    getMemberDetailById(id, params = {
        country_code: FSWCountryCode.ID,
        member_type_code: CBMemberTypes.BRW,
    }) {
        const url = `${this._kongUrl}/v2/members/${id}`;
        // const url = 'assets/mocks/cb/member-detail.json';
        return this._httpClient
            .get(url, {
            params,
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => data));
    }
    upload(data) {
        const headers = setRequestOptions(false);
        const formData = new FormData();
        formData.append('doc_type', data.doc_type);
        formData.append('file', data.file);
        const url = `${this._kongUrl}/docs_management/v2/docs`;
        // const url = 'assets/mocks/cb/upload-file.json';
        return this._httpClient.post(url, formData, {
            headers,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditBureauService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditBureauService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditBureauService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class CreditBureauServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditBureauServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CreditBureauServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditBureauServiceModule, providers: [
            {
                provide: CREDIT_BUREAU_SERVICE_TOKEN,
                useClass: CreditBureauService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditBureauServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: CREDIT_BUREAU_SERVICE_TOKEN,
                            useClass: CreditBureauService,
                        },
                    ],
                }]
        }] });

const CB_COMPONENT_STORE_TOKEN = new InjectionToken('CB_COMPONENT_STORE_TOKEN');
const CB_GENERAL_COMPONENT_STORE_TOKEN = new InjectionToken('CB_GENERAL_COMPONENT_STORE_TOKEN');
const CB_BANK_COMPONENT_STORE_TOKEN = new InjectionToken('CB_BANK_COMPONENT_STORE_TOKEN');
const CB_ADDITIONAL_COMPONENT_STORE_TOKEN = new InjectionToken('CB_ADDITIONAL_COMPONENT_STORE_TOKEN');

class CBBlock {
    constructor() {
        this.subscriptionMap = new Map();
    }
    listenEditable(widget) {
        this.subscriptionMap.get('editable')?.unsubscribe();
        this.subscriptionMap.delete('editable');
        const subscription = this.editable$
            .pipe(tap((editable) => this.listenEditableCallBack(widget, editable)))
            .subscribe();
        this.subscriptionMap.set('editable', subscription);
    }
    listenEditableCallBack(widget, editable) {
        if (editable) {
            widget.removeReadOnly();
        }
        else {
            widget.setAllControlsReadOnly();
        }
        widget.markForCheck();
    }
}

class CBBankDebtComponent extends CBBlock {
    constructor(_componentStore) {
        super();
        this._componentStore = _componentStore;
        this.listenTotal = new EventEmitter();
        this.config = null;
        this.editable$ = this._componentStore.editable$;
    }
    setupForm(form, widget, id) {
        this._componentStore.setupFormGroup(id, form);
        this.listenTotal.emit(form.get('outstanding_balance')?.value || 0);
        form
            .get('outstanding_balance')
            ?.valueChanges.pipe(tap((e) => {
            this.listenTotal.emit(typeof e === 'string' ? Number.parseInt(e) : e);
        }))
            .subscribe();
        this.listenEditable(widget);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBBankDebtComponent, deps: [{ token: CB_BANK_COMPONENT_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CBBankDebtComponent, selector: "fsw-cb-bank-debt", inputs: { config: "config" }, outputs: { listenTotal: "listenTotal" }, usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"config\">\n\t<ng-container *ngIf=\"config.data\">\n\t\t<fsw-form-widget\n\t\t\t#widget\n\t\t\t[formConfig]=\"config.data\"\n\t\t\t(initializeWidget)=\"setupForm($event, widget, config.id)\"\n\t\t></fsw-form-widget>\n\t</ng-container>\n</ng-container>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FormWidgetComponent, selector: "fsw-form-widget", inputs: ["formConfig", "loading", "isReadonly"], outputs: ["initializeWidget", "closeForm", "submitForm"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBBankDebtComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cb-bank-debt', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"config\">\n\t<ng-container *ngIf=\"config.data\">\n\t\t<fsw-form-widget\n\t\t\t#widget\n\t\t\t[formConfig]=\"config.data\"\n\t\t\t(initializeWidget)=\"setupForm($event, widget, config.id)\"\n\t\t></fsw-form-widget>\n\t</ng-container>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CB_BANK_COMPONENT_STORE_TOKEN]
                }] }]; }, propDecorators: { listenTotal: [{
                type: Output
            }], config: [{
                type: Input
            }] } });

class CBBankTermComponent extends CBBlock {
    constructor(_componentStore) {
        super();
        this._componentStore = _componentStore;
        this.listenTotal = new EventEmitter();
        this.config = null;
        this.editable$ = this._componentStore.editable$;
        this.totals$ = new BehaviorSubject([]);
    }
    setupForm(form, widget, id) {
        this._componentStore.setupFormGroup(id, form);
        this.totals$
            .pipe(tap((totals) => {
            this.listenTotal.emit(totals.reduce((acc, cur) => acc + cur.value, 0));
        }))
            .subscribe();
        this.listenEditable(widget);
    }
    push(debt, value) {
        if (!debt)
            return;
        const totals = this.totals$.value;
        const pos = totals.findIndex((e) => e.id === debt.id);
        if (pos > -1) {
            totals[pos].value = value;
        }
        else {
            totals.push({ id: debt.id, value });
        }
        this.totals$.next([...totals]);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBBankTermComponent, deps: [{ token: CB_BANK_COMPONENT_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CBBankTermComponent, selector: "fsw-cb-bank-term", inputs: { config: "config" }, outputs: { listenTotal: "listenTotal" }, usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"config\">\n\t<ng-container *ngIf=\"config.data\">\n\t\t<fsw-form-widget\n\t\t\t#widget\n\t\t\t[formConfig]=\"config.data\"\n\t\t\t(initializeWidget)=\"setupForm($event, widget, config.id)\"\n\t\t></fsw-form-widget>\n\t</ng-container>\n\t<ng-container *ngIf=\"config.debts.length\">\n\t\t<ng-container *ngFor=\"let debt of config.debts\">\n\t\t\t<fsw-cb-bank-debt (listenTotal)=\"push(debt, $event)\" [config]=\"debt\"></fsw-cb-bank-debt>\n\t\t</ng-container>\n\t</ng-container>\n</ng-container>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FormWidgetComponent, selector: "fsw-form-widget", inputs: ["formConfig", "loading", "isReadonly"], outputs: ["initializeWidget", "closeForm", "submitForm"] }, { kind: "component", type: CBBankDebtComponent, selector: "fsw-cb-bank-debt", inputs: ["config"], outputs: ["listenTotal"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBBankTermComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cb-bank-term', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"config\">\n\t<ng-container *ngIf=\"config.data\">\n\t\t<fsw-form-widget\n\t\t\t#widget\n\t\t\t[formConfig]=\"config.data\"\n\t\t\t(initializeWidget)=\"setupForm($event, widget, config.id)\"\n\t\t></fsw-form-widget>\n\t</ng-container>\n\t<ng-container *ngIf=\"config.debts.length\">\n\t\t<ng-container *ngFor=\"let debt of config.debts\">\n\t\t\t<fsw-cb-bank-debt (listenTotal)=\"push(debt, $event)\" [config]=\"debt\"></fsw-cb-bank-debt>\n\t\t</ng-container>\n\t</ng-container>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CB_BANK_COMPONENT_STORE_TOKEN]
                }] }]; }, propDecorators: { listenTotal: [{
                type: Output
            }], config: [{
                type: Input
            }] } });

class CBBankBlockComponent extends CBBlock {
    constructor(_componentStore) {
        super();
        this._componentStore = _componentStore;
        this.listenTotal = new EventEmitter();
        this.config = null;
        this.editable$ = this._componentStore.editable$;
        this.totals$ = new BehaviorSubject([]);
        this.translate$ = this._componentStore.translate$;
        this.expanded = false;
    }
    ngOnInit() {
        const terms = this.config?.terms;
        if (terms && terms.length < 2) {
            this.expanded = true;
        }
    }
    setupForm(form, widget, id) {
        this._componentStore.setupFormGroup(id, form);
        this.totals$
            .pipe(tap((totals) => {
            const amount = totals.reduce((acc, cur) => acc + cur.value, 0);
            this.listenTotal.emit(amount);
            form.get('outstanding_balance')?.setValue(amount);
            widget.formFieldControls$.next([...widget.formFieldControls]);
            widget.detectChanges();
        }))
            .subscribe();
        this.listenEditable(widget);
    }
    push(term, value) {
        if (!term)
            return;
        const totals = this.totals$.value;
        const pos = totals.findIndex((e) => e.id === term.id);
        if (pos > -1) {
            totals[pos].value = value;
        }
        else {
            totals.push({ id: term.id, value });
        }
        this.totals$.next([...totals]);
    }
    listenEditableCallBack(widget, editable) {
        if (editable) {
            widget.formFieldControls.forEach((config) => {
                if (config.key !== 'outstanding_balance') {
                    config.context = config.context || {};
                    delete config.context.isReadonly;
                }
            });
            widget.formFieldControls$.next(widget.formFieldControls);
        }
        else {
            widget.setAllControlsReadOnly();
        }
        widget.markForCheck();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBBankBlockComponent, deps: [{ token: CB_BANK_COMPONENT_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CBBankBlockComponent, selector: "fsw-cb-bank-block", inputs: { config: "config" }, outputs: { listenTotal: "listenTotal" }, usesInheritance: true, ngImport: i0, template: "<div class=\"cb-bank-block\">\n\t<ng-container *ngIf=\"config\">\n\t\t<ng-container *ngIf=\"config.basic\">\n\t\t\t<fsw-form-widget\n\t\t\t\t#widget\n\t\t\t\t[formConfig]=\"config.basic\"\n\t\t\t\t(initializeWidget)=\"setupForm($event, widget, config.id)\"\n\t\t\t></fsw-form-widget>\n\t\t</ng-container>\n\t\t<ng-container *ngIf=\"config.terms?.length as length\">\n\t\t\t<div class=\"cb-separator\"></div>\n\t\t\t<ng-container *ngIf=\"length > 1\">\n\t\t\t\t<ng-container *ngIf=\"translate$ | async as translate\">\n\t\t\t\t\t<div class=\"cb-bank-block__show\" (click)=\"expanded = !expanded\">\n\t\t\t\t\t\t<i class=\"fa {{ expanded ? 'fa-chevron-down' : 'fa-chevron-up' }}\"></i>\n\t\t\t\t\t\t<span>{{ length }} {{ translate.expand }}</span>\n\t\t\t\t\t</div>\n\t\t\t\t</ng-container>\n\t\t\t</ng-container>\n\t\t\t<ng-container *ngIf=\"expanded\">\n\t\t\t\t<ng-container *ngFor=\"let term of config.terms; let i = index\">\n\t\t\t\t\t<fsw-cb-bank-term (listenTotal)=\"push(term, $event)\" [config]=\"term\"></fsw-cb-bank-term>\n\t\t\t\t\t<ng-container *ngIf=\"i !== length - 1\">\n\t\t\t\t\t\t<div class=\"cb-separator\"></div>\n\t\t\t\t\t</ng-container>\n\t\t\t\t</ng-container>\n\t\t\t</ng-container>\n\t\t</ng-container>\n\t</ng-container>\n</div>\n", styles: [":host .cb-bank-block{display:flex;width:100%;flex-direction:column;gap:24px;padding:16px;border:1px solid #e0e0e0}:host .cb-bank-block__show{padding:8px 0;color:#2c50ff;display:flex;align-items:center;gap:8px;cursor:pointer}:host .cb-bank-block__show span{font-family:Poppins,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;line-height:1.5;font-size:16px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FormWidgetComponent, selector: "fsw-form-widget", inputs: ["formConfig", "loading", "isReadonly"], outputs: ["initializeWidget", "closeForm", "submitForm"] }, { kind: "component", type: CBBankTermComponent, selector: "fsw-cb-bank-term", inputs: ["config"], outputs: ["listenTotal"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBBankBlockComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cb-bank-block', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"cb-bank-block\">\n\t<ng-container *ngIf=\"config\">\n\t\t<ng-container *ngIf=\"config.basic\">\n\t\t\t<fsw-form-widget\n\t\t\t\t#widget\n\t\t\t\t[formConfig]=\"config.basic\"\n\t\t\t\t(initializeWidget)=\"setupForm($event, widget, config.id)\"\n\t\t\t></fsw-form-widget>\n\t\t</ng-container>\n\t\t<ng-container *ngIf=\"config.terms?.length as length\">\n\t\t\t<div class=\"cb-separator\"></div>\n\t\t\t<ng-container *ngIf=\"length > 1\">\n\t\t\t\t<ng-container *ngIf=\"translate$ | async as translate\">\n\t\t\t\t\t<div class=\"cb-bank-block__show\" (click)=\"expanded = !expanded\">\n\t\t\t\t\t\t<i class=\"fa {{ expanded ? 'fa-chevron-down' : 'fa-chevron-up' }}\"></i>\n\t\t\t\t\t\t<span>{{ length }} {{ translate.expand }}</span>\n\t\t\t\t\t</div>\n\t\t\t\t</ng-container>\n\t\t\t</ng-container>\n\t\t\t<ng-container *ngIf=\"expanded\">\n\t\t\t\t<ng-container *ngFor=\"let term of config.terms; let i = index\">\n\t\t\t\t\t<fsw-cb-bank-term (listenTotal)=\"push(term, $event)\" [config]=\"term\"></fsw-cb-bank-term>\n\t\t\t\t\t<ng-container *ngIf=\"i !== length - 1\">\n\t\t\t\t\t\t<div class=\"cb-separator\"></div>\n\t\t\t\t\t</ng-container>\n\t\t\t\t</ng-container>\n\t\t\t</ng-container>\n\t\t</ng-container>\n\t</ng-container>\n</div>\n", styles: [":host .cb-bank-block{display:flex;width:100%;flex-direction:column;gap:24px;padding:16px;border:1px solid #e0e0e0}:host .cb-bank-block__show{padding:8px 0;color:#2c50ff;display:flex;align-items:center;gap:8px;cursor:pointer}:host .cb-bank-block__show span{font-family:Poppins,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;line-height:1.5;font-size:16px}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CB_BANK_COMPONENT_STORE_TOKEN]
                }] }]; }, propDecorators: { listenTotal: [{
                type: Output
            }], config: [{
                type: Input
            }] } });

class CBBankComponent {
    constructor(_componentStore) {
        this._componentStore = _componentStore;
        this.updated$ = this._componentStore.updated$.pipe(tap(() => this.totals$.next([])), tap(() => (this.configs = this._componentStore.configs)));
        this.configs = this._componentStore.configs;
        this.translate$ = this._componentStore.translate$.pipe(map((e) => e.total));
        this.totals$ = new BehaviorSubject([]);
        this.calculate$ = this.totals$.pipe(map((totals) => totals.reduce((acc, cur) => acc + cur.value, 0)), map((totals) => addDotDelimiter(totals)));
    }
    ngOnInit() {
        this._componentStore.init();
    }
    push(item, value) {
        if (!item)
            return;
        const totals = this.totals$.value;
        const pos = totals.findIndex((e) => e.id === item.id);
        if (pos > -1) {
            totals[pos].value = value;
        }
        else {
            totals.push({ id: item.id, value });
        }
        this.totals$.next([...totals]);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBBankComponent, deps: [{ token: CB_BANK_COMPONENT_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CBBankComponent, selector: "fsw-cb-bank", ngImport: i0, template: "<div class=\"cb-bank\">\n\t<ng-container *ngIf=\"updated$ | async\">\n\t\t<ng-container *ngFor=\"let config of configs\">\n\t\t\t<fsw-cb-bank-block [config]=\"config\" (listenTotal)=\"push(config, $event)\"></fsw-cb-bank-block>\n\t\t</ng-container>\n\t\t<div class=\"cb-separator\"></div>\n\t\t<ng-container *ngIf=\"translate$ | async as translate\">\n\t\t\t<div class=\"cb-bank__total\">\n\t\t\t\t<label>{{ translate.label }}</label>\n\t\t\t\t<span>{{ calculate$ | async }} {{ translate.suffix }}</span>\n\t\t\t</div>\n\t\t</ng-container>\n\t</ng-container>\n</div>\n", styles: [":host .cb-bank{display:flex;flex-direction:column;width:100%;gap:24px}:host .cb-bank__total{width:-moz-fit-content;width:fit-content;padding:16px;border:1px solid #e0e0e0;display:flex;flex-direction:column;gap:8px}:host .cb-bank__total label{margin:0;padding:0;font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:14px;line-height:1.5;color:#757575}:host .cb-bank__total span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:16px;line-height:1.5;color:#222}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CBBankBlockComponent, selector: "fsw-cb-bank-block", inputs: ["config"], outputs: ["listenTotal"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBBankComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cb-bank', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"cb-bank\">\n\t<ng-container *ngIf=\"updated$ | async\">\n\t\t<ng-container *ngFor=\"let config of configs\">\n\t\t\t<fsw-cb-bank-block [config]=\"config\" (listenTotal)=\"push(config, $event)\"></fsw-cb-bank-block>\n\t\t</ng-container>\n\t\t<div class=\"cb-separator\"></div>\n\t\t<ng-container *ngIf=\"translate$ | async as translate\">\n\t\t\t<div class=\"cb-bank__total\">\n\t\t\t\t<label>{{ translate.label }}</label>\n\t\t\t\t<span>{{ calculate$ | async }} {{ translate.suffix }}</span>\n\t\t\t</div>\n\t\t</ng-container>\n\t</ng-container>\n</div>\n", styles: [":host .cb-bank{display:flex;flex-direction:column;width:100%;gap:24px}:host .cb-bank__total{width:-moz-fit-content;width:fit-content;padding:16px;border:1px solid #e0e0e0;display:flex;flex-direction:column;gap:8px}:host .cb-bank__total label{margin:0;padding:0;font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:14px;line-height:1.5;color:#757575}:host .cb-bank__total span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:16px;line-height:1.5;color:#222}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CB_BANK_COMPONENT_STORE_TOKEN]
                }] }]; } });

class CBBankDebtModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBBankDebtModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CBBankDebtModule, declarations: [CBBankDebtComponent], imports: [CommonModule, PanelWidgetModule, FormWidgetModule], exports: [CBBankDebtComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBBankDebtModule, imports: [CommonModule, PanelWidgetModule, FormWidgetModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBBankDebtModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, PanelWidgetModule, FormWidgetModule],
                    declarations: [CBBankDebtComponent],
                    exports: [CBBankDebtComponent],
                }]
        }] });

class CBBankTermModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBBankTermModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CBBankTermModule, declarations: [CBBankTermComponent], imports: [CommonModule, PanelWidgetModule, FormWidgetModule, CBBankDebtModule], exports: [CBBankTermComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBBankTermModule, imports: [CommonModule, PanelWidgetModule, FormWidgetModule, CBBankDebtModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBBankTermModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, PanelWidgetModule, FormWidgetModule, CBBankDebtModule],
                    declarations: [CBBankTermComponent],
                    exports: [CBBankTermComponent],
                }]
        }] });

class CBBankBlockModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBBankBlockModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CBBankBlockModule, declarations: [CBBankBlockComponent], imports: [CommonModule, PanelWidgetModule, FormWidgetModule, CBBankTermModule], exports: [CBBankBlockComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBBankBlockModule, imports: [CommonModule, PanelWidgetModule, FormWidgetModule, CBBankTermModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBBankBlockModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, PanelWidgetModule, FormWidgetModule, CBBankTermModule],
                    declarations: [CBBankBlockComponent],
                    exports: [CBBankBlockComponent],
                }]
        }] });

class CBBankModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBBankModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CBBankModule, declarations: [CBBankComponent], imports: [CommonModule, CBBankBlockModule], exports: [CBBankComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBBankModule, imports: [CommonModule, CBBankBlockModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBBankModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CBBankBlockModule],
                    declarations: [CBBankComponent],
                    exports: [CBBankComponent],
                }]
        }] });

class CBGeneralBlockComponent extends CBBlock {
    constructor(_componentStore, _cdr) {
        super();
        this._componentStore = _componentStore;
        this._cdr = _cdr;
        this.id = null;
        this.config = null;
        this.editable$ = this._componentStore.editable$;
    }
    setupForm(form, widget) {
        this._componentStore.setupFormGroup(this.id, form);
        this.listenEditable(widget);
    }
    ngOnInit() {
        this._componentStore.updated$
            .pipe(tap(() => {
            this.config = this._componentStore.getConfig(this.id);
            this._cdr.markForCheck();
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBGeneralBlockComponent, deps: [{ token: CB_GENERAL_COMPONENT_STORE_TOKEN }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CBGeneralBlockComponent, selector: "fsw-cb-general-block", inputs: { id: "id" }, usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"config\">\n\t<fsw-form-widget\n\t\t#widget\n\t\t[formConfig]=\"config\"\n\t\t(initializeWidget)=\"setupForm($event, widget)\"\n\t></fsw-form-widget>\n</ng-container>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FormWidgetComponent, selector: "fsw-form-widget", inputs: ["formConfig", "loading", "isReadonly"], outputs: ["initializeWidget", "closeForm", "submitForm"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBGeneralBlockComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cb-general-block', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"config\">\n\t<fsw-form-widget\n\t\t#widget\n\t\t[formConfig]=\"config\"\n\t\t(initializeWidget)=\"setupForm($event, widget)\"\n\t></fsw-form-widget>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CB_GENERAL_COMPONENT_STORE_TOKEN]
                }] }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { id: [{
                type: Input
            }] } });

class CBGeneralComponent {
    constructor(_componentStore, _cbComponentStore) {
        this._componentStore = _componentStore;
        this._cbComponentStore = _cbComponentStore;
        this.vm$ = this._componentStore.updated$.pipe(map(() => {
            return {
                isIndividual: this._cbComponentStore.state().selectedMember?.entity_type === CBEntityTypes.INDIVIDUAL,
            };
        }));
    }
    ngOnInit() {
        this._componentStore.init();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBGeneralComponent, deps: [{ token: CB_GENERAL_COMPONENT_STORE_TOKEN }, { token: CB_COMPONENT_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CBGeneralComponent, selector: "fsw-cb-general", ngImport: i0, template: "<ng-container *ngIf=\"vm$ | async as vm\">\n\t<div class=\"cb-general\">\n\t\t<fsw-cb-general-block id=\"basic\"></fsw-cb-general-block>\n\t\t<ng-container *ngIf=\"vm.isIndividual\">\n\t\t\t<div class=\"cb-separator\"></div>\n\t\t\t<fsw-cb-general-block id=\"credit\"></fsw-cb-general-block>\n\t\t</ng-container>\n\t</div>\n</ng-container>\n", styles: [":host .cb-general{display:flex;width:100%;flex-direction:column;gap:24px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CBGeneralBlockComponent, selector: "fsw-cb-general-block", inputs: ["id"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBGeneralComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cb-general', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"vm$ | async as vm\">\n\t<div class=\"cb-general\">\n\t\t<fsw-cb-general-block id=\"basic\"></fsw-cb-general-block>\n\t\t<ng-container *ngIf=\"vm.isIndividual\">\n\t\t\t<div class=\"cb-separator\"></div>\n\t\t\t<fsw-cb-general-block id=\"credit\"></fsw-cb-general-block>\n\t\t</ng-container>\n\t</div>\n</ng-container>\n", styles: [":host .cb-general{display:flex;width:100%;flex-direction:column;gap:24px}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CB_GENERAL_COMPONENT_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CB_COMPONENT_STORE_TOKEN]
                }] }]; } });

class CBGeneralBlockModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBGeneralBlockModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CBGeneralBlockModule, declarations: [CBGeneralBlockComponent], imports: [CommonModule, PanelWidgetModule, FormWidgetModule], exports: [CBGeneralBlockComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBGeneralBlockModule, imports: [CommonModule, PanelWidgetModule, FormWidgetModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBGeneralBlockModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, PanelWidgetModule, FormWidgetModule],
                    declarations: [CBGeneralBlockComponent],
                    exports: [CBGeneralBlockComponent],
                }]
        }] });

class CBGeneralModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBGeneralModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CBGeneralModule, declarations: [CBGeneralComponent], imports: [CommonModule, CBGeneralBlockModule], exports: [CBGeneralComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBGeneralModule, imports: [CommonModule, CBGeneralBlockModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBGeneralModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CBGeneralBlockModule],
                    declarations: [CBGeneralComponent],
                    exports: [CBGeneralComponent],
                }]
        }] });

class CBAdditionalItemComponent extends CBBlock {
    constructor(_componentStore) {
        super();
        this._componentStore = _componentStore;
        this.config = null;
        this.editable$ = this._componentStore.editable$;
    }
    setupForm(form, widget, id) {
        this._componentStore.setupFormGroup(id, form);
        this.listenEditable(widget);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalItemComponent, deps: [{ token: CB_ADDITIONAL_COMPONENT_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CBAdditionalItemComponent, selector: "fsw-cb-additional-item", inputs: { config: "config" }, usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"config\">\n\t<fsw-panel-widget>\n\t\t<fsw-form-widget\n\t\t\t#widget\n\t\t\t[formConfig]=\"config.value\"\n\t\t\t(initializeWidget)=\"setupForm($event, widget, config.id)\"\n\t\t></fsw-form-widget>\n\t</fsw-panel-widget>\n</ng-container>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FormWidgetComponent, selector: "fsw-form-widget", inputs: ["formConfig", "loading", "isReadonly"], outputs: ["initializeWidget", "closeForm", "submitForm"] }, { kind: "component", type: PanelWidgetComponent, selector: "fsw-panel-widget", inputs: ["panelConfig"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cb-additional-item', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"config\">\n\t<fsw-panel-widget>\n\t\t<fsw-form-widget\n\t\t\t#widget\n\t\t\t[formConfig]=\"config.value\"\n\t\t\t(initializeWidget)=\"setupForm($event, widget, config.id)\"\n\t\t></fsw-form-widget>\n\t</fsw-panel-widget>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CB_ADDITIONAL_COMPONENT_STORE_TOKEN]
                }] }]; }, propDecorators: { config: [{
                type: Input
            }] } });

class CBAdditionalOffBalanceSheetComponent {
    constructor(_componentStore) {
        this._componentStore = _componentStore;
        this.translate$ = this._componentStore.translate$.pipe(map((e) => e.sub_titles));
        this.updated$ = this._componentStore.updated$.pipe(tap(() => (this.configs = this._componentStore.offBalanceSheetConfigs)));
        this.configs = [];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalOffBalanceSheetComponent, deps: [{ token: CB_ADDITIONAL_COMPONENT_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CBAdditionalOffBalanceSheetComponent, selector: "fsw-cb-additional-off-balance-sheet", ngImport: i0, template: "<div class=\"cb-additional-off-balance-sheet\">\n\t<ng-container *ngIf=\"translate$ | async as translate\">\n\t\t<span>{{ translate.off_balance }}</span>\n\t</ng-container>\n\t<ng-container *ngIf=\"updated$ | async\">\n\t\t<ng-container *ngFor=\"let config of configs\">\n\t\t\t<fsw-cb-additional-item [config]=\"config\"></fsw-cb-additional-item>\n\t\t</ng-container>\n\t</ng-container>\n</div>\n", styles: [":host .cb-additional-off-balance-sheet{display:flex;flex-direction:column;width:100%;gap:24px}:host .cb-additional-off-balance-sheet span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;line-height:1.4;font-size:18px;color:#757575;font-weight:600}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CBAdditionalItemComponent, selector: "fsw-cb-additional-item", inputs: ["config"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalOffBalanceSheetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cb-additional-off-balance-sheet', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"cb-additional-off-balance-sheet\">\n\t<ng-container *ngIf=\"translate$ | async as translate\">\n\t\t<span>{{ translate.off_balance }}</span>\n\t</ng-container>\n\t<ng-container *ngIf=\"updated$ | async\">\n\t\t<ng-container *ngFor=\"let config of configs\">\n\t\t\t<fsw-cb-additional-item [config]=\"config\"></fsw-cb-additional-item>\n\t\t</ng-container>\n\t</ng-container>\n</div>\n", styles: [":host .cb-additional-off-balance-sheet{display:flex;flex-direction:column;width:100%;gap:24px}:host .cb-additional-off-balance-sheet span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;line-height:1.4;font-size:18px;color:#757575;font-weight:600}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CB_ADDITIONAL_COMPONENT_STORE_TOKEN]
                }] }]; } });

class CBAdditionalDebtComponent {
    constructor(_componentStore) {
        this._componentStore = _componentStore;
        this.translate$ = this._componentStore.translate$.pipe(map((e) => ({
            sub_titles: e.sub_titles,
            empty: e.empty,
        })));
        this.updated$ = this._componentStore.updated$.pipe(tap(() => (this.configs = this._componentStore.debtConfigs)));
        this.configs = [];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalDebtComponent, deps: [{ token: CB_ADDITIONAL_COMPONENT_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CBAdditionalDebtComponent, selector: "fsw-cb-additional-debt", ngImport: i0, template: "<div class=\"cb-additional-debt\">\n\t<ng-container *ngIf=\"translate$ | async as translate\">\n\t\t<span>{{ translate.sub_titles.debt }}</span>\n\t\t<ng-container *ngIf=\"updated$ | async\">\n\t\t\t<ng-container *ngFor=\"let config of configs\">\n\t\t\t\t<fsw-cb-additional-item [config]=\"config\"></fsw-cb-additional-item>\n\t\t\t</ng-container>\n\t\t\t<ng-container *ngIf=\"!configs.length\">\n\t\t\t\t<p>{{ translate.empty.debt }}</p>\n\t\t\t</ng-container>\n\t\t</ng-container>\n\t</ng-container>\n</div>\n", styles: [":host .cb-additional-debt{display:flex;flex-direction:column;width:100%;gap:24px}:host .cb-additional-debt span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;line-height:1.4;font-size:18px;color:#757575;font-weight:600}:host .cb-additional-debt p{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;line-height:1.5;font-size:16px;color:#222;font-weight:500;margin:0;padding:0}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CBAdditionalItemComponent, selector: "fsw-cb-additional-item", inputs: ["config"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalDebtComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cb-additional-debt', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"cb-additional-debt\">\n\t<ng-container *ngIf=\"translate$ | async as translate\">\n\t\t<span>{{ translate.sub_titles.debt }}</span>\n\t\t<ng-container *ngIf=\"updated$ | async\">\n\t\t\t<ng-container *ngFor=\"let config of configs\">\n\t\t\t\t<fsw-cb-additional-item [config]=\"config\"></fsw-cb-additional-item>\n\t\t\t</ng-container>\n\t\t\t<ng-container *ngIf=\"!configs.length\">\n\t\t\t\t<p>{{ translate.empty.debt }}</p>\n\t\t\t</ng-container>\n\t\t</ng-container>\n\t</ng-container>\n</div>\n", styles: [":host .cb-additional-debt{display:flex;flex-direction:column;width:100%;gap:24px}:host .cb-additional-debt span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;line-height:1.4;font-size:18px;color:#757575;font-weight:600}:host .cb-additional-debt p{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;line-height:1.5;font-size:16px;color:#222;font-weight:500;margin:0;padding:0}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CB_ADDITIONAL_COMPONENT_STORE_TOKEN]
                }] }]; } });

class CBAdditionalNplComponent {
    constructor(_componentStore) {
        this._componentStore = _componentStore;
        this.translate$ = this._componentStore.translate$.pipe(map((e) => ({
            sub_titles: e.sub_titles,
            empty: e.empty,
        })));
        this.updated$ = this._componentStore.updated$.pipe(tap(() => (this.configs = this._componentStore.nplConfigs)));
        this.configs = [];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalNplComponent, deps: [{ token: CB_ADDITIONAL_COMPONENT_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CBAdditionalNplComponent, selector: "fsw-cb-additional-npl", ngImport: i0, template: "<div class=\"cb-additional-npl\">\n\t<ng-container *ngIf=\"translate$ | async as translate\">\n\t\t<span>{{ translate.sub_titles.npl }}</span>\n\t\t<ng-container *ngIf=\"updated$ | async\">\n\t\t\t<ng-container *ngFor=\"let config of configs\">\n\t\t\t\t<fsw-cb-additional-item [config]=\"config\"></fsw-cb-additional-item>\n\t\t\t</ng-container>\n\t\t\t<ng-container *ngIf=\"!configs.length\">\n\t\t\t\t<p>{{ translate.empty.npl }}</p>\n\t\t\t</ng-container>\n\t\t</ng-container>\n\t</ng-container>\n</div>\n", styles: [":host .cb-additional-npl{display:flex;flex-direction:column;width:100%;gap:24px}:host .cb-additional-npl span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;line-height:1.4;font-size:18px;color:#757575;font-weight:600}:host .cb-additional-npl p{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;line-height:1.5;font-size:16px;color:#222;font-weight:500;margin:0;padding:0}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CBAdditionalItemComponent, selector: "fsw-cb-additional-item", inputs: ["config"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalNplComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cb-additional-npl', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"cb-additional-npl\">\n\t<ng-container *ngIf=\"translate$ | async as translate\">\n\t\t<span>{{ translate.sub_titles.npl }}</span>\n\t\t<ng-container *ngIf=\"updated$ | async\">\n\t\t\t<ng-container *ngFor=\"let config of configs\">\n\t\t\t\t<fsw-cb-additional-item [config]=\"config\"></fsw-cb-additional-item>\n\t\t\t</ng-container>\n\t\t\t<ng-container *ngIf=\"!configs.length\">\n\t\t\t\t<p>{{ translate.empty.npl }}</p>\n\t\t\t</ng-container>\n\t\t</ng-container>\n\t</ng-container>\n</div>\n", styles: [":host .cb-additional-npl{display:flex;flex-direction:column;width:100%;gap:24px}:host .cb-additional-npl span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;line-height:1.4;font-size:18px;color:#757575;font-weight:600}:host .cb-additional-npl p{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;line-height:1.5;font-size:16px;color:#222;font-weight:500;margin:0;padding:0}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CB_ADDITIONAL_COMPONENT_STORE_TOKEN]
                }] }]; } });

class CBAdditionalBlockComponent extends CBBlock {
    constructor(_componentStore, _cdr) {
        super();
        this._componentStore = _componentStore;
        this._cdr = _cdr;
        this.id = null;
        this.config = null;
        this.editable$ = this._componentStore.editable$;
    }
    setupForm(form, widget) {
        this._componentStore.setupFormGroup(this.id, form);
        this.listenEditable(widget);
    }
    ngOnInit() {
        this._componentStore.updated$
            .pipe(tap(() => {
            this.config = this._componentStore.getConfig(this.id);
            this._cdr.markForCheck();
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalBlockComponent, deps: [{ token: CB_ADDITIONAL_COMPONENT_STORE_TOKEN }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CBAdditionalBlockComponent, selector: "fsw-cb-additional-block", inputs: { id: "id" }, usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"config\">\n\t<fsw-form-widget\n\t\t#widget\n\t\t[formConfig]=\"config\"\n\t\t(initializeWidget)=\"setupForm($event, widget)\"\n\t></fsw-form-widget>\n</ng-container>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FormWidgetComponent, selector: "fsw-form-widget", inputs: ["formConfig", "loading", "isReadonly"], outputs: ["initializeWidget", "closeForm", "submitForm"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalBlockComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cb-additional-block', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"config\">\n\t<fsw-form-widget\n\t\t#widget\n\t\t[formConfig]=\"config\"\n\t\t(initializeWidget)=\"setupForm($event, widget)\"\n\t></fsw-form-widget>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CB_ADDITIONAL_COMPONENT_STORE_TOKEN]
                }] }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { id: [{
                type: Input
            }] } });

class CBAdditionalPartComponent {
    constructor(_componentStore) {
        this._componentStore = _componentStore;
        this.id = null;
        this.showTitle = true;
        this.translate$ = this._componentStore.translate$.pipe(map((e) => e.sub_titles));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalPartComponent, deps: [{ token: CB_ADDITIONAL_COMPONENT_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CBAdditionalPartComponent, selector: "fsw-cb-additional-part", inputs: { id: "id", showTitle: "showTitle" }, ngImport: i0, template: "<div class=\"cb-additional-part\">\n\t<ng-container *ngIf=\"showTitle && id\">\n\t\t<ng-container *ngIf=\"translate$ | async as translate\">\n\t\t\t<span>{{ translate[id] }}</span>\n\t\t</ng-container>\n\t</ng-container>\n\t<fsw-cb-additional-block [id]=\"id\"></fsw-cb-additional-block>\n</div>\n", styles: [":host .cb-additional-part{display:flex;flex-direction:column;width:100%;gap:24px}:host .cb-additional-part span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;line-height:1.4;font-size:18px;color:#757575;font-weight:600}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CBAdditionalBlockComponent, selector: "fsw-cb-additional-block", inputs: ["id"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalPartComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cb-additional-part', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"cb-additional-part\">\n\t<ng-container *ngIf=\"showTitle && id\">\n\t\t<ng-container *ngIf=\"translate$ | async as translate\">\n\t\t\t<span>{{ translate[id] }}</span>\n\t\t</ng-container>\n\t</ng-container>\n\t<fsw-cb-additional-block [id]=\"id\"></fsw-cb-additional-block>\n</div>\n", styles: [":host .cb-additional-part{display:flex;flex-direction:column;width:100%;gap:24px}:host .cb-additional-part span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;line-height:1.4;font-size:18px;color:#757575;font-weight:600}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CB_ADDITIONAL_COMPONENT_STORE_TOKEN]
                }] }]; }, propDecorators: { id: [{
                type: Input
            }], showTitle: [{
                type: Input
            }] } });

class CBAdditionalComponent {
    constructor(_componentStore, _cbComponentStore) {
        this._componentStore = _componentStore;
        this._cbComponentStore = _cbComponentStore;
        this.vm$ = this._componentStore.updated$.pipe(map(() => {
            return {
                isIndividual: this._cbComponentStore.state().selectedMember?.entity_type === CBEntityTypes.INDIVIDUAL,
            };
        }));
    }
    ngOnInit() {
        this._componentStore.init();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalComponent, deps: [{ token: CB_ADDITIONAL_COMPONENT_STORE_TOKEN }, { token: CB_COMPONENT_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CBAdditionalComponent, selector: "fsw-cb-additional", ngImport: i0, template: "<div class=\"cb-additional\">\n\t<ng-container *ngIf=\"vm$ | async as vm\">\n\t\t<ng-container *ngIf=\"vm.isIndividual; else offBalanceSheet\">\n\t\t\t<fsw-cb-additional-part id=\"credit\"></fsw-cb-additional-part>\n\t\t</ng-container>\n\t\t<ng-template #offBalanceSheet>\n\t\t\t<fsw-cb-additional-off-balance-sheet></fsw-cb-additional-off-balance-sheet>\n\t\t</ng-template>\n\t\t<div class=\"cb-separator\"></div>\n\t\t<fsw-cb-additional-npl></fsw-cb-additional-npl>\n\t\t<div class=\"cb-separator\"></div>\n\t\t<fsw-cb-additional-debt></fsw-cb-additional-debt>\n\t\t<div class=\"cb-separator\"></div>\n\t\t<ng-container *ngIf=\"!vm.isIndividual\">\n\t\t\t<fsw-cb-additional-part id=\"collaterals\"></fsw-cb-additional-part>\n\t\t</ng-container>\n\t\t<fsw-cb-additional-part id=\"requested\" [showTitle]=\"false\"></fsw-cb-additional-part>\n\t</ng-container>\n</div>\n", styles: [":host .cb-additional{display:flex;flex-direction:column;gap:24px;width:100%}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CBAdditionalOffBalanceSheetComponent, selector: "fsw-cb-additional-off-balance-sheet" }, { kind: "component", type: CBAdditionalDebtComponent, selector: "fsw-cb-additional-debt" }, { kind: "component", type: CBAdditionalNplComponent, selector: "fsw-cb-additional-npl" }, { kind: "component", type: CBAdditionalPartComponent, selector: "fsw-cb-additional-part", inputs: ["id", "showTitle"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cb-additional', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"cb-additional\">\n\t<ng-container *ngIf=\"vm$ | async as vm\">\n\t\t<ng-container *ngIf=\"vm.isIndividual; else offBalanceSheet\">\n\t\t\t<fsw-cb-additional-part id=\"credit\"></fsw-cb-additional-part>\n\t\t</ng-container>\n\t\t<ng-template #offBalanceSheet>\n\t\t\t<fsw-cb-additional-off-balance-sheet></fsw-cb-additional-off-balance-sheet>\n\t\t</ng-template>\n\t\t<div class=\"cb-separator\"></div>\n\t\t<fsw-cb-additional-npl></fsw-cb-additional-npl>\n\t\t<div class=\"cb-separator\"></div>\n\t\t<fsw-cb-additional-debt></fsw-cb-additional-debt>\n\t\t<div class=\"cb-separator\"></div>\n\t\t<ng-container *ngIf=\"!vm.isIndividual\">\n\t\t\t<fsw-cb-additional-part id=\"collaterals\"></fsw-cb-additional-part>\n\t\t</ng-container>\n\t\t<fsw-cb-additional-part id=\"requested\" [showTitle]=\"false\"></fsw-cb-additional-part>\n\t</ng-container>\n</div>\n", styles: [":host .cb-additional{display:flex;flex-direction:column;gap:24px;width:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CB_ADDITIONAL_COMPONENT_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CB_COMPONENT_STORE_TOKEN]
                }] }]; } });

class CBAdditionalItemModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalItemModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalItemModule, declarations: [CBAdditionalItemComponent], imports: [CommonModule, FormWidgetModule, PanelWidgetModule], exports: [CBAdditionalItemComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalItemModule, imports: [CommonModule, FormWidgetModule, PanelWidgetModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalItemModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormWidgetModule, PanelWidgetModule],
                    declarations: [CBAdditionalItemComponent],
                    exports: [CBAdditionalItemComponent],
                }]
        }] });

class CBAdditionalDebtModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalDebtModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalDebtModule, declarations: [CBAdditionalDebtComponent], imports: [CommonModule, CBAdditionalItemModule], exports: [CBAdditionalDebtComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalDebtModule, imports: [CommonModule, CBAdditionalItemModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalDebtModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CBAdditionalItemModule],
                    declarations: [CBAdditionalDebtComponent],
                    exports: [CBAdditionalDebtComponent],
                }]
        }] });

class CBAdditionalNplModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalNplModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalNplModule, declarations: [CBAdditionalNplComponent], imports: [CommonModule, CBAdditionalItemModule], exports: [CBAdditionalNplComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalNplModule, imports: [CommonModule, CBAdditionalItemModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalNplModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CBAdditionalItemModule],
                    declarations: [CBAdditionalNplComponent],
                    exports: [CBAdditionalNplComponent],
                }]
        }] });

class CBAdditionalBlockModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalBlockModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalBlockModule, declarations: [CBAdditionalBlockComponent], imports: [CommonModule, FormWidgetModule], exports: [CBAdditionalBlockComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalBlockModule, imports: [CommonModule, FormWidgetModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalBlockModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormWidgetModule],
                    declarations: [CBAdditionalBlockComponent],
                    exports: [CBAdditionalBlockComponent],
                }]
        }] });

class CBAdditionalPartModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalPartModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalPartModule, declarations: [CBAdditionalPartComponent], imports: [CommonModule, CBAdditionalBlockModule], exports: [CBAdditionalPartComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalPartModule, imports: [CommonModule, CBAdditionalBlockModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalPartModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CBAdditionalBlockModule],
                    declarations: [CBAdditionalPartComponent],
                    exports: [CBAdditionalPartComponent],
                }]
        }] });

class CBAdditionalOffBalanceSheetModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalOffBalanceSheetModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalOffBalanceSheetModule, declarations: [CBAdditionalOffBalanceSheetComponent], imports: [CommonModule, CBAdditionalItemModule], exports: [CBAdditionalOffBalanceSheetComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalOffBalanceSheetModule, imports: [CommonModule, CBAdditionalItemModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalOffBalanceSheetModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CBAdditionalItemModule],
                    declarations: [CBAdditionalOffBalanceSheetComponent],
                    exports: [CBAdditionalOffBalanceSheetComponent],
                }]
        }] });

class CBAdditionalModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalModule, declarations: [CBAdditionalComponent], imports: [CommonModule,
            CBAdditionalOffBalanceSheetModule,
            CBAdditionalDebtModule,
            CBAdditionalNplModule,
            CBAdditionalPartModule], exports: [CBAdditionalComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalModule, imports: [CommonModule,
            CBAdditionalOffBalanceSheetModule,
            CBAdditionalDebtModule,
            CBAdditionalNplModule,
            CBAdditionalPartModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBAdditionalModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CBAdditionalComponent],
                    imports: [
                        CommonModule,
                        CBAdditionalOffBalanceSheetModule,
                        CBAdditionalDebtModule,
                        CBAdditionalNplModule,
                        CBAdditionalPartModule,
                    ],
                    exports: [CBAdditionalComponent],
                }]
        }] });

class CBConfirmDialogComponent {
    constructor(context, _modalComponent) {
        this.context = context;
        this._modalComponent = _modalComponent;
        this.configuration();
    }
    cancel() {
        this.context.completeWith(false);
    }
    remove() {
        this.context.completeWith(true);
    }
    configuration() {
        this._modalComponent.setLabel(this.context.data['title']);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBConfirmDialogComponent, deps: [{ token: MODAL_CONTEXT }, { token: ModalComponent }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CBConfirmDialogComponent, selector: "fsw-cb-confirm-dialog", ngImport: i0, template: "<fsw-remove-dialog\n\t[buttonCancelLabel]=\"context.data['cancel']\"\n\t[buttonDeleteLabel]=\"context.data['delete']\"\n\t[description]=\"context.data['description']\"\n\t(cancel)=\"cancel()\"\n\t(remove)=\"remove()\"\n></fsw-remove-dialog>\n", dependencies: [{ kind: "component", type: FSWRemoveDialogComponent, selector: "fsw-remove-dialog", inputs: ["description", "buttonDeleteLabel", "buttonCancelLabel"], outputs: ["remove", "cancel"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBConfirmDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cb-confirm-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-remove-dialog\n\t[buttonCancelLabel]=\"context.data['cancel']\"\n\t[buttonDeleteLabel]=\"context.data['delete']\"\n\t[description]=\"context.data['description']\"\n\t(cancel)=\"cancel()\"\n\t(remove)=\"remove()\"\n></fsw-remove-dialog>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_CONTEXT]
                }] }, { type: ModalComponent }]; } });

class CBConfirmDialogModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBConfirmDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CBConfirmDialogModule, declarations: [CBConfirmDialogComponent], imports: [CommonModule, FSWRemoveDialogModule], exports: [CBConfirmDialogComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBConfirmDialogModule, imports: [CommonModule, FSWRemoveDialogModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBConfirmDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FSWRemoveDialogModule],
                    declarations: [CBConfirmDialogComponent],
                    exports: [CBConfirmDialogComponent],
                }]
        }] });

class CBReuploadDialogComponent {
    constructor(context, _cdr, _modalComponent, _pdfService) {
        this.context = context;
        this._cdr = _cdr;
        this._modalComponent = _modalComponent;
        this._pdfService = _pdfService;
        this.detail = null;
        this._modalComponent.setLabel(this.context.data.translate['title']);
    }
    ngOnInit() {
        this._pdfService
            .getReportDetail(this.context.data.id)
            .pipe(tap((e) => {
            this.detail = e;
            this._cdr.markForCheck();
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBReuploadDialogComponent, deps: [{ token: MODAL_CONTEXT }, { token: i0.ChangeDetectorRef }, { token: ModalComponent }, { token: PDF_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CBReuploadDialogComponent, selector: "fsw-cb-reupload-dialog", ngImport: i0, template: "<div class=\"cb-reupload-dialog\">\n\t<div class=\"cb-reupload-dialog__control\">\n\t\t<span>{{ context.data.translate.fields['current'] }}</span>\n\t\t<div class=\"cb-reupload-dialog__file\">{{ detail?.name }}</div>\n\t</div>\n\t<div class=\"cb-reupload-dialog__control\">\n\t\t<span>{{ context.data.translate.fields['new'] }}</span>\n\t\t<div class=\"cb-reupload-dialog__file\">{{ context.data.file.name }}</div>\n\t</div>\n\t<p>{{ context.data.translate.warning }}</p>\n\t<div class=\"cb-reupload-dialog__action\">\n\t\t<button class=\"btn btn--secondary\" (click)=\"context.completeWith(false)\">\n\t\t\t{{ context.data.translate.buttons['cancel'] }}\n\t\t</button>\n\t\t<button class=\"btn btn--primary\" (click)=\"context.completeWith(true)\">\n\t\t\t{{ context.data.translate.buttons['upload'] }}\n\t\t</button>\n\t</div>\n</div>\n", styles: [":host .cb-reupload-dialog{display:flex;flex-direction:column;gap:16px;padding:32px}:host .cb-reupload-dialog__control{display:flex;flex-direction:column;width:100%;gap:8px}:host .cb-reupload-dialog__control span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:14px;line-height:1.5;color:#757575;font-weight:500}:host .cb-reupload-dialog__file{width:100%;padding:4px 8px;background:#f3f5fd;border-radius:2px;color:#2c50ff;font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:14px;line-height:1.5}:host .cb-reupload-dialog p{margin:16px 0 0;padding:0;font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:16px;line-height:1.5;color:#4a4a4a}:host .cb-reupload-dialog__action{display:flex;width:100%;justify-content:space-between}:host .cb-reupload-dialog__action button{width:calc(50% - 8px)}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBReuploadDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cb-reupload-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"cb-reupload-dialog\">\n\t<div class=\"cb-reupload-dialog__control\">\n\t\t<span>{{ context.data.translate.fields['current'] }}</span>\n\t\t<div class=\"cb-reupload-dialog__file\">{{ detail?.name }}</div>\n\t</div>\n\t<div class=\"cb-reupload-dialog__control\">\n\t\t<span>{{ context.data.translate.fields['new'] }}</span>\n\t\t<div class=\"cb-reupload-dialog__file\">{{ context.data.file.name }}</div>\n\t</div>\n\t<p>{{ context.data.translate.warning }}</p>\n\t<div class=\"cb-reupload-dialog__action\">\n\t\t<button class=\"btn btn--secondary\" (click)=\"context.completeWith(false)\">\n\t\t\t{{ context.data.translate.buttons['cancel'] }}\n\t\t</button>\n\t\t<button class=\"btn btn--primary\" (click)=\"context.completeWith(true)\">\n\t\t\t{{ context.data.translate.buttons['upload'] }}\n\t\t</button>\n\t</div>\n</div>\n", styles: [":host .cb-reupload-dialog{display:flex;flex-direction:column;gap:16px;padding:32px}:host .cb-reupload-dialog__control{display:flex;flex-direction:column;width:100%;gap:8px}:host .cb-reupload-dialog__control span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:14px;line-height:1.5;color:#757575;font-weight:500}:host .cb-reupload-dialog__file{width:100%;padding:4px 8px;background:#f3f5fd;border-radius:2px;color:#2c50ff;font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:14px;line-height:1.5}:host .cb-reupload-dialog p{margin:16px 0 0;padding:0;font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:16px;line-height:1.5;color:#4a4a4a}:host .cb-reupload-dialog__action{display:flex;width:100%;justify-content:space-between}:host .cb-reupload-dialog__action button{width:calc(50% - 8px)}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_CONTEXT]
                }] }, { type: i0.ChangeDetectorRef }, { type: ModalComponent }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PDF_SERVICE_TOKEN]
                }] }]; } });

class CBReuploadDialogModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBReuploadDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CBReuploadDialogModule, declarations: [CBReuploadDialogComponent], imports: [CommonModule, FSWModalModule, FSWPdfModule], exports: [CBReuploadDialogComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBReuploadDialogModule, imports: [CommonModule, FSWModalModule, FSWPdfModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBReuploadDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FSWModalModule, FSWPdfModule],
                    declarations: [CBReuploadDialogComponent],
                    exports: [CBReuploadDialogComponent],
                }]
        }] });

class CBSummaryFormComponent {
    constructor(_scope, _translateService, _cbGeneralComponentStore, _cbAdditionalComponentStore, _cbBankComponentStore, _cbComponentStore, _modalService) {
        this._scope = _scope;
        this._translateService = _translateService;
        this._cbGeneralComponentStore = _cbGeneralComponentStore;
        this._cbAdditionalComponentStore = _cbAdditionalComponentStore;
        this._cbBankComponentStore = _cbBankComponentStore;
        this._cbComponentStore = _cbComponentStore;
        this._modalService = _modalService;
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'tabs'),
            this._translateService.selectFeatureTranslate(this._scope, 'hints'),
            this._translateService.selectFeatureTranslate(this._scope, 'buttons'),
        ]).pipe(map(([tabs, hints, buttons]) => ({ tabs, hints, buttons })));
        this.type$ = new BehaviorSubject(CBFormKeys.GENERAL);
        this.vm$ = combineLatest([
            this.translate$,
            this.type$.asObservable(),
            combineLatest([this._cbGeneralComponentStore.editable$, this._cbGeneralComponentStore.edited$]),
            combineLatest([this._cbBankComponentStore.editable$, this._cbBankComponentStore.edited$]),
            combineLatest([
                this._cbAdditionalComponentStore.editable$,
                this._cbAdditionalComponentStore.edited$,
            ]),
        ]).pipe(map(([translate, type, general, bank, additional]) => {
            let editable = false;
            let edited = false;
            switch (type) {
                case CBFormKeys.BANK:
                    editable = bank[0];
                    edited = bank[1];
                    break;
                case CBFormKeys.ADDITIONAL:
                    editable = additional[0];
                    edited = additional[1];
                    break;
                case CBFormKeys.GENERAL:
                    editable = general[0];
                    edited = general[1];
                    break;
            }
            return { translate, type, editable, edited };
        }));
        this.CBFormKeys = CBFormKeys;
    }
    edit(type) {
        this._updateEditableStore(true, type);
    }
    cancel(type, edited) {
        if (!edited) {
            this._updateEditableStore(false, type, true);
        }
        else {
            this._modalService
                .open(CBConfirmDialogComponent, {
                size: ModalSizes.S,
                data: {
                    title: 'Confirm',
                    cancel: 'Cancel',
                    delete: 'Accept',
                    description: 'You are changing data, Accept mean your changed data will reset',
                },
            })
                .pipe(take(1), tap((value) => {
                if (value) {
                    this._updateEditableStore(false, type, true);
                }
            }))
                .subscribe();
        }
    }
    save() {
        this._modalService
            .open(CBConfirmDialogComponent, {
            size: ModalSizes.S,
            data: {
                title: 'Confirm',
                cancel: 'Cancel',
                delete: 'Accept',
                description: 'You are changing data, Accept mean your changed data will save in system',
            },
        })
            .pipe(take(1), tap((value) => {
            if (value) {
                this._cbBankComponentStore.setEditable(false);
                this._cbAdditionalComponentStore.setEditable(false);
                this._cbGeneralComponentStore.setEditable(false);
                this._cbComponentStore.save((report) => {
                    this._cbBankComponentStore.submit(report);
                    this._cbAdditionalComponentStore.submit(report);
                    this._cbGeneralComponentStore.submit(report);
                    return report;
                });
            }
        }))
            .subscribe();
    }
    _updateEditableStore(editable, type, reset = false) {
        switch (type) {
            case CBFormKeys.BANK:
                reset && this._cbBankComponentStore.reset();
                this._cbBankComponentStore.setEditable(editable);
                break;
            case CBFormKeys.ADDITIONAL:
                reset && this._cbAdditionalComponentStore.reset();
                this._cbAdditionalComponentStore.setEditable(editable);
                break;
            case CBFormKeys.GENERAL:
                reset && this._cbGeneralComponentStore.reset();
                this._cbGeneralComponentStore.setEditable(editable);
                break;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBSummaryFormComponent, deps: [{ token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: CB_GENERAL_COMPONENT_STORE_TOKEN }, { token: CB_ADDITIONAL_COMPONENT_STORE_TOKEN }, { token: CB_BANK_COMPONENT_STORE_TOKEN }, { token: CB_COMPONENT_STORE_TOKEN }, { token: MODAL_SERVICE }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CBSummaryFormComponent, selector: "fsw-cb-summary-form", ngImport: i0, template: "<ng-container *ngIf=\"vm$ | async as vm\">\n\t<div class=\"cbs-form\">\n\t\t<div class=\"cbs-form__tabs\">\n\t\t\t<div\n\t\t\t\tclass=\"cbs-form__tab\"\n\t\t\t\t[class.active]=\"vm.type === CBFormKeys.GENERAL\"\n\t\t\t\t(click)=\"type$.next(CBFormKeys.GENERAL)\"\n\t\t\t>\n\t\t\t\t<span>{{ vm.translate.tabs.general }}</span>\n\t\t\t</div>\n\t\t\t<div\n\t\t\t\tclass=\"cbs-form__tab\"\n\t\t\t\t[class.active]=\"vm.type === CBFormKeys.BANK\"\n\t\t\t\t(click)=\"type$.next(CBFormKeys.BANK)\"\n\t\t\t>\n\t\t\t\t<span>{{ vm.translate.tabs.bank }}</span>\n\t\t\t</div>\n\t\t\t<div\n\t\t\t\tclass=\"cbs-form__tab\"\n\t\t\t\t[class.active]=\"vm.type === CBFormKeys.ADDITIONAL\"\n\t\t\t\t(click)=\"type$.next(CBFormKeys.ADDITIONAL)\"\n\t\t\t>\n\t\t\t\t<span>{{ vm.translate.tabs.additional }}</span>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"cbs-form__container\">\n\t\t\t<header>\n\t\t\t\t<div>\n\t\t\t\t\t<h6>{{ vm.translate.tabs[vm.type] }}</h6>\n\t\t\t\t\t<span *ngIf=\"vm.edited\">{{ vm.translate.hints['edited'] }}</span>\n\t\t\t\t</div>\n\t\t\t\t<div>\n\t\t\t\t\t<button *ngIf=\"!vm.editable\" class=\"btn btn--secondary\" (click)=\"edit(vm.type)\">\n\t\t\t\t\t\t{{ vm.translate.buttons['edit'] }}\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</header>\n\t\t\t<main>\n\t\t\t\t<ng-container [ngSwitch]=\"vm.type\">\n\t\t\t\t\t<ng-container *ngSwitchCase=\"CBFormKeys.GENERAL\">\n\t\t\t\t\t\t<fsw-cb-general></fsw-cb-general>\n\t\t\t\t\t</ng-container>\n\t\t\t\t\t<ng-container *ngSwitchCase=\"CBFormKeys.BANK\">\n\t\t\t\t\t\t<fsw-cb-bank></fsw-cb-bank>\n\t\t\t\t\t</ng-container>\n\t\t\t\t\t<ng-container *ngSwitchCase=\"CBFormKeys.ADDITIONAL\">\n\t\t\t\t\t\t<fsw-cb-additional></fsw-cb-additional>\n\t\t\t\t\t</ng-container>\n\t\t\t\t</ng-container>\n\t\t\t</main>\n\t\t\t<footer *ngIf=\"vm.editable\">\n\t\t\t\t<button class=\"btn btn--secondary\" (click)=\"cancel(vm.type, vm.edited)\">\n\t\t\t\t\t{{ vm.translate.buttons['cancel'] }}\n\t\t\t\t</button>\n\t\t\t\t<button *ngIf=\"vm.edited\" class=\"btn btn--primary\" (click)=\"save()\">\n\t\t\t\t\t{{ vm.translate.buttons['save'] }}\n\t\t\t\t</button>\n\t\t\t</footer>\n\t\t</div>\n\t</div>\n</ng-container>\n", styles: [":host .cbs-form{display:flex;flex-direction:column;gap:16px;width:100%}:host .cbs-form__tabs{width:100%;gap:4px;display:flex}:host .cbs-form__tab{border-radius:2px;padding:12px 16px}:host .cbs-form__tab span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-weight:500;font-size:14px;line-height:24px;color:#4a4a4a}:host .cbs-form__tab:hover{background-color:#f3f5fd;cursor:pointer}:host .cbs-form__tab:hover span{color:#2c50ff}:host .cbs-form__tab.active{background-color:#f3f5fd}:host .cbs-form__tab.active span{color:#2c50ff}:host .cbs-form__container{padding:16px;width:100%;display:flex;flex-direction:column;gap:16px;border-radius:4px;border:1px solid #e0e0e0}:host .cbs-form__container header{display:flex;width:100%;justify-content:space-between;align-items:center}:host .cbs-form__container header :first-child{display:flex;flex-direction:column}:host .cbs-form__container header :first-child h6{color:#222}:host .cbs-form__container header :first-child span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-weight:400;line-height:1.5;font-size:12px;color:#757575}:host .cbs-form__container header :last-child{display:flex;align-items:center;gap:16px}:host .cbs-form__container main{width:100%}:host .cbs-form__container footer{width:100%;display:flex;flex-direction:row-reverse;gap:16px}::ng-deep .cb-separator{width:100%;height:0;border:1px solid #e0e0e0}::ng-deep .form-control{padding-bottom:0!important}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "component", type: CBGeneralComponent, selector: "fsw-cb-general" }, { kind: "component", type: CBBankComponent, selector: "fsw-cb-bank" }, { kind: "component", type: CBAdditionalComponent, selector: "fsw-cb-additional" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBSummaryFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cb-summary-form', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"vm$ | async as vm\">\n\t<div class=\"cbs-form\">\n\t\t<div class=\"cbs-form__tabs\">\n\t\t\t<div\n\t\t\t\tclass=\"cbs-form__tab\"\n\t\t\t\t[class.active]=\"vm.type === CBFormKeys.GENERAL\"\n\t\t\t\t(click)=\"type$.next(CBFormKeys.GENERAL)\"\n\t\t\t>\n\t\t\t\t<span>{{ vm.translate.tabs.general }}</span>\n\t\t\t</div>\n\t\t\t<div\n\t\t\t\tclass=\"cbs-form__tab\"\n\t\t\t\t[class.active]=\"vm.type === CBFormKeys.BANK\"\n\t\t\t\t(click)=\"type$.next(CBFormKeys.BANK)\"\n\t\t\t>\n\t\t\t\t<span>{{ vm.translate.tabs.bank }}</span>\n\t\t\t</div>\n\t\t\t<div\n\t\t\t\tclass=\"cbs-form__tab\"\n\t\t\t\t[class.active]=\"vm.type === CBFormKeys.ADDITIONAL\"\n\t\t\t\t(click)=\"type$.next(CBFormKeys.ADDITIONAL)\"\n\t\t\t>\n\t\t\t\t<span>{{ vm.translate.tabs.additional }}</span>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"cbs-form__container\">\n\t\t\t<header>\n\t\t\t\t<div>\n\t\t\t\t\t<h6>{{ vm.translate.tabs[vm.type] }}</h6>\n\t\t\t\t\t<span *ngIf=\"vm.edited\">{{ vm.translate.hints['edited'] }}</span>\n\t\t\t\t</div>\n\t\t\t\t<div>\n\t\t\t\t\t<button *ngIf=\"!vm.editable\" class=\"btn btn--secondary\" (click)=\"edit(vm.type)\">\n\t\t\t\t\t\t{{ vm.translate.buttons['edit'] }}\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</header>\n\t\t\t<main>\n\t\t\t\t<ng-container [ngSwitch]=\"vm.type\">\n\t\t\t\t\t<ng-container *ngSwitchCase=\"CBFormKeys.GENERAL\">\n\t\t\t\t\t\t<fsw-cb-general></fsw-cb-general>\n\t\t\t\t\t</ng-container>\n\t\t\t\t\t<ng-container *ngSwitchCase=\"CBFormKeys.BANK\">\n\t\t\t\t\t\t<fsw-cb-bank></fsw-cb-bank>\n\t\t\t\t\t</ng-container>\n\t\t\t\t\t<ng-container *ngSwitchCase=\"CBFormKeys.ADDITIONAL\">\n\t\t\t\t\t\t<fsw-cb-additional></fsw-cb-additional>\n\t\t\t\t\t</ng-container>\n\t\t\t\t</ng-container>\n\t\t\t</main>\n\t\t\t<footer *ngIf=\"vm.editable\">\n\t\t\t\t<button class=\"btn btn--secondary\" (click)=\"cancel(vm.type, vm.edited)\">\n\t\t\t\t\t{{ vm.translate.buttons['cancel'] }}\n\t\t\t\t</button>\n\t\t\t\t<button *ngIf=\"vm.edited\" class=\"btn btn--primary\" (click)=\"save()\">\n\t\t\t\t\t{{ vm.translate.buttons['save'] }}\n\t\t\t\t</button>\n\t\t\t</footer>\n\t\t</div>\n\t</div>\n</ng-container>\n", styles: [":host .cbs-form{display:flex;flex-direction:column;gap:16px;width:100%}:host .cbs-form__tabs{width:100%;gap:4px;display:flex}:host .cbs-form__tab{border-radius:2px;padding:12px 16px}:host .cbs-form__tab span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-weight:500;font-size:14px;line-height:24px;color:#4a4a4a}:host .cbs-form__tab:hover{background-color:#f3f5fd;cursor:pointer}:host .cbs-form__tab:hover span{color:#2c50ff}:host .cbs-form__tab.active{background-color:#f3f5fd}:host .cbs-form__tab.active span{color:#2c50ff}:host .cbs-form__container{padding:16px;width:100%;display:flex;flex-direction:column;gap:16px;border-radius:4px;border:1px solid #e0e0e0}:host .cbs-form__container header{display:flex;width:100%;justify-content:space-between;align-items:center}:host .cbs-form__container header :first-child{display:flex;flex-direction:column}:host .cbs-form__container header :first-child h6{color:#222}:host .cbs-form__container header :first-child span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-weight:400;line-height:1.5;font-size:12px;color:#757575}:host .cbs-form__container header :last-child{display:flex;align-items:center;gap:16px}:host .cbs-form__container main{width:100%}:host .cbs-form__container footer{width:100%;display:flex;flex-direction:row-reverse;gap:16px}::ng-deep .cb-separator{width:100%;height:0;border:1px solid #e0e0e0}::ng-deep .form-control{padding-bottom:0!important}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CB_GENERAL_COMPONENT_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CB_ADDITIONAL_COMPONENT_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CB_BANK_COMPONENT_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CB_COMPONENT_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_SERVICE]
                }] }]; } });

class CBSummaryFormModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBSummaryFormModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CBSummaryFormModule, declarations: [CBSummaryFormComponent], imports: [CommonModule,
            CBGeneralModule,
            CBBankModule,
            CBAdditionalModule,
            CBConfirmDialogModule,
            FSWModalModule], exports: [CBSummaryFormComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBSummaryFormModule, imports: [CommonModule,
            CBGeneralModule,
            CBBankModule,
            CBAdditionalModule,
            CBConfirmDialogModule,
            FSWModalModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBSummaryFormModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CBSummaryFormComponent],
                    imports: [
                        CommonModule,
                        CBGeneralModule,
                        CBBankModule,
                        CBAdditionalModule,
                        CBConfirmDialogModule,
                        FSWModalModule,
                    ],
                    exports: [CBSummaryFormComponent],
                }]
        }] });

class CBUploadComponent {
    get emptyEntityNo() {
        if (!this.selectedMember)
            return false;
        return !this.selectedMember.erc;
    }
    constructor(_scope, _translateService, _cbComponentStore, _modalService) {
        this._scope = _scope;
        this._translateService = _translateService;
        this._cbComponentStore = _cbComponentStore;
        this._modalService = _modalService;
        this.fileSelect = new EventEmitter();
        this.selectedMember = null;
        this.hasError = false;
        this.isButton = false;
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'upload'),
            this._translateService.selectFeatureTranslate(this._scope, 'types'),
            this._translateService.selectFeatureTranslate(this._scope, 'buttons'),
        ]).pipe(map(([upload, types, buttons]) => ({ upload, types, buttons })));
    }
    selectFile(event) {
        const { files } = event.target;
        if (!files)
            return;
        const selectedFile = files[0];
        this.hasError = selectedFile.type !== 'application/pdf';
        if (this.hasError)
            return;
        if (this.isButton) {
            this.reupload(selectedFile);
            return;
        }
        this.fileSelect.emit(selectedFile);
    }
    reupload(file) {
        combineLatest([
            this._cbComponentStore.state$,
            this.translate$,
            this._translateService.selectFeatureTranslate(this._scope, 'reupload_dialog'),
        ])
            .pipe(take(1), switchMap(([state, translate, reuploadTranslate]) => {
            if (state.report?.doc_id) {
                return this._modalService
                    .open(CBReuploadDialogComponent, {
                    size: ModalSizes.S,
                    data: {
                        id: state.report.doc_id,
                        file,
                        translate: {
                            ...reuploadTranslate,
                            buttons: translate.buttons,
                        },
                    },
                })
                    .pipe(take(1), tap((rs) => {
                    if (rs) {
                        this.fileSelect.emit(file);
                    }
                }));
            }
            return EMPTY;
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBUploadComponent, deps: [{ token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: CB_COMPONENT_STORE_TOKEN }, { token: MODAL_SERVICE }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CBUploadComponent, selector: "fsw-cb-upload", inputs: { selectedMember: "selectedMember", hasError: "hasError", isButton: "isButton" }, outputs: { fileSelect: "fileSelect" }, ngImport: i0, template: "<ng-container *ngIf=\"translate$ | async as translate\">\n\t<input hidden type=\"file\" #selectedFile (input)=\"selectFile($event)\" />\n\t<ng-container *ngIf=\"!isButton; else button\">\n\t\t<ng-container *ngIf=\"selectedMember\">\n\t\t\t<div class=\"credit-bureau-upload\">\n\t\t\t\t<h6>\n\t\t\t\t\t{{ translate.upload['title'] }} -\n\t\t\t\t\t{{ translate.types[selectedMember.entity_type.toLowerCase()] }}\n\t\t\t\t</h6>\n\t\t\t\t<ng-container *ngIf=\"hasError || emptyEntityNo\">\n\t\t\t\t\t<div class=\"credit-bureau-upload__error\">\n\t\t\t\t\t\t<svg\n\t\t\t\t\t\t\t*ngIf=\"hasError\"\n\t\t\t\t\t\t\twidth=\"92\"\n\t\t\t\t\t\t\theight=\"93\"\n\t\t\t\t\t\t\tviewBox=\"0 0 92 93\"\n\t\t\t\t\t\t\tfill=\"none\"\n\t\t\t\t\t\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<rect width=\"92\" height=\"92.514\" fill=\"white\" />\n\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\td=\"M61.3333 23.1285V74.5252H30.6667C26.4325 74.5252 23 71.0735 23 66.8157V23.1285L61.3333 23.1285Z\"\n\t\t\t\t\t\t\t\tfill=\"#F1F1F2\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<rect x=\"30.6667\" y=\"30.1957\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t\t\t\t\t\t<rect x=\"30.6667\" y=\"35.3353\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t\t\t\t\t\t<rect x=\"30.6667\" y=\"40.4747\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t\t\t\t\t\t<rect x=\"30.6667\" y=\"45.6146\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t\t\t\t\t\t<rect x=\"30.6667\" y=\"50.754\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t\t\t\t\t\t<rect x=\"30.6667\" y=\"55.8939\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t\t\t\t\t\t<rect x=\"30.6667\" y=\"61.0333\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\td=\"M69.0001 68.1449V66.8157H34.5001V68.1006C34.5001 71.2297 32.2756 73.8362 29.3301 74.4084C29.7642 74.4851 30.2108 74.5252 30.6668 74.5252H62.6553C66.1594 74.5252 69.0001 71.6686 69.0001 68.1449Z\"\n\t\t\t\t\t\t\t\tfill=\"#CCCCCC\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\td=\"M56.0596 35.5789C56.0596 33.2342 56.2706 31.5477 56.6924 30.5195C57.1131 29.4925 58.0061 28.3711 59.3716 27.1553C60.5627 26.1132 61.4703 25.2083 62.0943 24.4406C62.7195 23.6741 63.0321 22.7987 63.0321 21.8145C63.0321 20.6276 62.6329 19.6434 61.8346 18.8618C61.0351 18.0803 59.9235 17.6895 58.5 17.6895C57.0183 17.6895 55.8923 18.1382 55.1218 19.0355C54.3525 19.9329 53.8081 20.8447 53.4885 21.7711L49 19.8605C49.6101 18.0079 50.7286 16.4013 52.3555 15.0408C53.9824 13.6803 56.0306 13 58.5 13C61.5505 13 63.8967 13.847 65.5387 15.541C67.1796 17.2338 68 19.2671 68 21.6408C68 23.0882 67.688 24.3259 67.0639 25.3542C66.4387 26.3812 65.458 27.5461 64.1216 28.8487C62.698 30.2092 61.834 31.2438 61.5295 31.9524C61.2239 32.6622 61.0711 33.8711 61.0711 35.5789H56.0596ZM58.5 46C57.5413 46 56.7209 45.6602 56.0387 44.9805C55.3554 44.2996 55.0138 43.4816 55.0138 42.5263C55.0138 41.5711 55.3554 40.753 56.0387 40.0722C56.7209 39.3925 57.5413 39.0526 58.5 39.0526C59.4587 39.0526 60.2797 39.3925 60.963 40.0722C61.6452 40.753 61.9862 41.5711 61.9862 42.5263C61.9862 43.4816 61.6452 44.2996 60.963 44.9805C60.2797 45.6602 59.4587 46 58.5 46Z\"\n\t\t\t\t\t\t\t\tfill=\"#ADADAD\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t{{\n\t\t\t\t\t\t\t\temptyEntityNo ? translate.upload['data_message'] : translate.upload['empty_message']\n\t\t\t\t\t\t\t}}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</ng-container>\n\t\t\t\t<button\n\t\t\t\t\tclass=\"btn btn--primary\"\n\t\t\t\t\t[disabled]=\"emptyEntityNo\"\n\t\t\t\t\t(click)=\"!emptyEntityNo && selectedFile.click()\"\n\t\t\t\t>\n\t\t\t\t\t<i class=\"fa fa-upload\"></i>\n\t\t\t\t\t{{ hasError ? translate.buttons['reupload'] : translate.buttons['upload'] }}\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</ng-container>\n\t</ng-container>\n\t<ng-template #button>\n\t\t<button class=\"btn btn--secondary\" (click)=\"selectedFile.click()\">\n\t\t\t{{ translate.buttons.reupload_full }}\n\t\t</button>\n\t</ng-template>\n</ng-container>\n", styles: [":host .credit-bureau-upload{max-width:100%;width:532px;border:1px solid #e0e0e0;border-radius:4px;padding:16px;display:flex;flex-direction:column;gap:16px}:host .credit-bureau-upload h6{color:#222}:host .credit-bureau-upload__error{width:100%;padding:16px;display:flex;align-items:center;flex-direction:column;border:1px solid #e0e0e0}:host .credit-bureau-upload__error p{text-align:center}:host .credit-bureau-upload button{width:max-content}:host .credit-bureau-upload button i{margin-right:8px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cb-upload', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"translate$ | async as translate\">\n\t<input hidden type=\"file\" #selectedFile (input)=\"selectFile($event)\" />\n\t<ng-container *ngIf=\"!isButton; else button\">\n\t\t<ng-container *ngIf=\"selectedMember\">\n\t\t\t<div class=\"credit-bureau-upload\">\n\t\t\t\t<h6>\n\t\t\t\t\t{{ translate.upload['title'] }} -\n\t\t\t\t\t{{ translate.types[selectedMember.entity_type.toLowerCase()] }}\n\t\t\t\t</h6>\n\t\t\t\t<ng-container *ngIf=\"hasError || emptyEntityNo\">\n\t\t\t\t\t<div class=\"credit-bureau-upload__error\">\n\t\t\t\t\t\t<svg\n\t\t\t\t\t\t\t*ngIf=\"hasError\"\n\t\t\t\t\t\t\twidth=\"92\"\n\t\t\t\t\t\t\theight=\"93\"\n\t\t\t\t\t\t\tviewBox=\"0 0 92 93\"\n\t\t\t\t\t\t\tfill=\"none\"\n\t\t\t\t\t\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<rect width=\"92\" height=\"92.514\" fill=\"white\" />\n\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\td=\"M61.3333 23.1285V74.5252H30.6667C26.4325 74.5252 23 71.0735 23 66.8157V23.1285L61.3333 23.1285Z\"\n\t\t\t\t\t\t\t\tfill=\"#F1F1F2\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<rect x=\"30.6667\" y=\"30.1957\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t\t\t\t\t\t<rect x=\"30.6667\" y=\"35.3353\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t\t\t\t\t\t<rect x=\"30.6667\" y=\"40.4747\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t\t\t\t\t\t<rect x=\"30.6667\" y=\"45.6146\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t\t\t\t\t\t<rect x=\"30.6667\" y=\"50.754\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t\t\t\t\t\t<rect x=\"30.6667\" y=\"55.8939\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t\t\t\t\t\t<rect x=\"30.6667\" y=\"61.0333\" width=\"23\" height=\"0.642458\" fill=\"#E0E0E0\" />\n\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\td=\"M69.0001 68.1449V66.8157H34.5001V68.1006C34.5001 71.2297 32.2756 73.8362 29.3301 74.4084C29.7642 74.4851 30.2108 74.5252 30.6668 74.5252H62.6553C66.1594 74.5252 69.0001 71.6686 69.0001 68.1449Z\"\n\t\t\t\t\t\t\t\tfill=\"#CCCCCC\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\td=\"M56.0596 35.5789C56.0596 33.2342 56.2706 31.5477 56.6924 30.5195C57.1131 29.4925 58.0061 28.3711 59.3716 27.1553C60.5627 26.1132 61.4703 25.2083 62.0943 24.4406C62.7195 23.6741 63.0321 22.7987 63.0321 21.8145C63.0321 20.6276 62.6329 19.6434 61.8346 18.8618C61.0351 18.0803 59.9235 17.6895 58.5 17.6895C57.0183 17.6895 55.8923 18.1382 55.1218 19.0355C54.3525 19.9329 53.8081 20.8447 53.4885 21.7711L49 19.8605C49.6101 18.0079 50.7286 16.4013 52.3555 15.0408C53.9824 13.6803 56.0306 13 58.5 13C61.5505 13 63.8967 13.847 65.5387 15.541C67.1796 17.2338 68 19.2671 68 21.6408C68 23.0882 67.688 24.3259 67.0639 25.3542C66.4387 26.3812 65.458 27.5461 64.1216 28.8487C62.698 30.2092 61.834 31.2438 61.5295 31.9524C61.2239 32.6622 61.0711 33.8711 61.0711 35.5789H56.0596ZM58.5 46C57.5413 46 56.7209 45.6602 56.0387 44.9805C55.3554 44.2996 55.0138 43.4816 55.0138 42.5263C55.0138 41.5711 55.3554 40.753 56.0387 40.0722C56.7209 39.3925 57.5413 39.0526 58.5 39.0526C59.4587 39.0526 60.2797 39.3925 60.963 40.0722C61.6452 40.753 61.9862 41.5711 61.9862 42.5263C61.9862 43.4816 61.6452 44.2996 60.963 44.9805C60.2797 45.6602 59.4587 46 58.5 46Z\"\n\t\t\t\t\t\t\t\tfill=\"#ADADAD\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t{{\n\t\t\t\t\t\t\t\temptyEntityNo ? translate.upload['data_message'] : translate.upload['empty_message']\n\t\t\t\t\t\t\t}}\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</ng-container>\n\t\t\t\t<button\n\t\t\t\t\tclass=\"btn btn--primary\"\n\t\t\t\t\t[disabled]=\"emptyEntityNo\"\n\t\t\t\t\t(click)=\"!emptyEntityNo && selectedFile.click()\"\n\t\t\t\t>\n\t\t\t\t\t<i class=\"fa fa-upload\"></i>\n\t\t\t\t\t{{ hasError ? translate.buttons['reupload'] : translate.buttons['upload'] }}\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</ng-container>\n\t</ng-container>\n\t<ng-template #button>\n\t\t<button class=\"btn btn--secondary\" (click)=\"selectedFile.click()\">\n\t\t\t{{ translate.buttons.reupload_full }}\n\t\t</button>\n\t</ng-template>\n</ng-container>\n", styles: [":host .credit-bureau-upload{max-width:100%;width:532px;border:1px solid #e0e0e0;border-radius:4px;padding:16px;display:flex;flex-direction:column;gap:16px}:host .credit-bureau-upload h6{color:#222}:host .credit-bureau-upload__error{width:100%;padding:16px;display:flex;align-items:center;flex-direction:column;border:1px solid #e0e0e0}:host .credit-bureau-upload__error p{text-align:center}:host .credit-bureau-upload button{width:max-content}:host .credit-bureau-upload button i{margin-right:8px}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CB_COMPONENT_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_SERVICE]
                }] }]; }, propDecorators: { fileSelect: [{
                type: Output
            }], selectedMember: [{
                type: Input
            }], hasError: [{
                type: Input
            }], isButton: [{
                type: Input
            }] } });

class CBSummaryPdfComponent {
    constructor(_cbComponentStore) {
        this._cbComponentStore = _cbComponentStore;
        this.id$ = this._cbComponentStore.state$.pipe(map((e) => e.report?.doc_id || null));
    }
    uploadFile(file) {
        this._cbComponentStore.upload(file);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBSummaryPdfComponent, deps: [{ token: CB_COMPONENT_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CBSummaryPdfComponent, selector: "fsw-cb-summary-pdf", ngImport: i0, template: "<div class=\"cb-summary-pdf\">\n\t<fsw-pdf [id]=\"id$ | async\" [showPagination]=\"true\" [height]=\"'64px'\"></fsw-pdf>\n\t<fsw-cb-upload (fileSelect)=\"uploadFile($event)\" [isButton]=\"true\"></fsw-cb-upload>\n</div>\n", styles: [":host{width:calc(50% - 8px)}:host .cb-summary-pdf{width:100%;display:flex;flex-direction:column;gap:16px}:host .cb-summary-pdf fsw-cb-upload{margin:auto}\n"], dependencies: [{ kind: "component", type: FSWPdfComponent, selector: "fsw-pdf", inputs: ["id", "showPagination", "height"] }, { kind: "component", type: CBUploadComponent, selector: "fsw-cb-upload", inputs: ["selectedMember", "hasError", "isButton"], outputs: ["fileSelect"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBSummaryPdfComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cb-summary-pdf', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"cb-summary-pdf\">\n\t<fsw-pdf [id]=\"id$ | async\" [showPagination]=\"true\" [height]=\"'64px'\"></fsw-pdf>\n\t<fsw-cb-upload (fileSelect)=\"uploadFile($event)\" [isButton]=\"true\"></fsw-cb-upload>\n</div>\n", styles: [":host{width:calc(50% - 8px)}:host .cb-summary-pdf{width:100%;display:flex;flex-direction:column;gap:16px}:host .cb-summary-pdf fsw-cb-upload{margin:auto}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CB_COMPONENT_STORE_TOKEN]
                }] }]; } });

class CBUploadModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBUploadModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CBUploadModule, declarations: [CBUploadComponent], imports: [CommonModule, CBReuploadDialogModule], exports: [CBUploadComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBUploadModule, imports: [CommonModule, CBReuploadDialogModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBUploadModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CBUploadComponent],
                    imports: [CommonModule, CBReuploadDialogModule],
                    exports: [CBUploadComponent],
                }]
        }] });

class CBSummaryPdfModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBSummaryPdfModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CBSummaryPdfModule, declarations: [CBSummaryPdfComponent], imports: [CommonModule, FSWPdfModule, FSWPdfModule, CBUploadModule], exports: [CBSummaryPdfComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBSummaryPdfModule, imports: [CommonModule, FSWPdfModule, FSWPdfModule, CBUploadModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBSummaryPdfModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CBSummaryPdfComponent],
                    imports: [CommonModule, FSWPdfModule, FSWPdfModule, CBUploadModule],
                    exports: [CBSummaryPdfComponent],
                }]
        }] });

class CBSelectComponent {
    set main(main) {
        if (!main)
            return;
        this._main = main;
        const value = {
            type: CBMemberTypes.BRW,
            data: main,
        };
        this._map.set(main.id, value);
        this.selectMember.emit(value);
    }
    get main() {
        return this._main;
    }
    set bips(bips) {
        this._bips = bips;
        bips.forEach((e) => {
            this._map.set(e.id, {
                type: CBMemberTypes.BIP,
                data: e,
            });
        });
    }
    get bips() {
        return this._bips;
    }
    get notAvailable() {
        return this.bips.length + 1 - this.available.length;
    }
    constructor(_scope, _translateService) {
        this._scope = _scope;
        this._translateService = _translateService;
        this.selectMember = new EventEmitter();
        this.available = [];
        this.translate$ = this._translateService.selectFeatureTranslate(this._scope, 'select_borrower_bip');
        this._main = null;
        this._bips = [];
        this._map = new Map();
    }
    input(event) {
        const { value } = event.target;
        const item = this._map.get(value);
        if (!item)
            return;
        this.selectMember.emit(item);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBSelectComponent, deps: [{ token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CBSelectComponent, selector: "fsw-cb-select", inputs: { main: "main", bips: "bips", available: "available" }, outputs: { selectMember: "selectMember" }, ngImport: i0, template: `
		<ng-container *ngIf="translate$ | async as translate">
			<ng-container *ngIf="main">
				<div class="form-control">
					<label for="select-borrower" class="form-label">
						{{ translate.label }}
					</label>
					<div class="form-select">
						<select id="select-borrower" (input)="input($event)">
							<option [value]="main.id">
								{{
									main.company_registration_number
										? main.company_name || main.fullname
										: main.fullname || main.company_name
								}}
								(Main Borrower)
								{{
									available.includes(main.ic_number || main.company_registration_number)
										? ''
										: '(!)'
								}}
							</option>
							<option *ngFor="let bip of bips" [value]="bip.id">
								{{
									bip.expand.company_registration_number
										? bip.expand.company_name || bip.expand.fullname
										: bip.expand.fullname || bip.expand.company_name
								}}
								{{
									available.includes(bip.expand.ic_number || bip.expand.company_registration_number)
										? ''
										: '(!)'
								}}
							</option>
						</select>
					</div>
				</div>
				<span *ngIf="notAvailable > 0">{{
					translate.warning.replace('number', notAvailable.toString())
				}}</span>
			</ng-container>
		</ng-container>
	`, isInline: true, styles: [":host{display:flex;flex-direction:column;gap:4px}:host span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:12px;line-height:1.5;color:#757575}:host .form-control{width:328px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBSelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-cb-select', template: `
		<ng-container *ngIf="translate$ | async as translate">
			<ng-container *ngIf="main">
				<div class="form-control">
					<label for="select-borrower" class="form-label">
						{{ translate.label }}
					</label>
					<div class="form-select">
						<select id="select-borrower" (input)="input($event)">
							<option [value]="main.id">
								{{
									main.company_registration_number
										? main.company_name || main.fullname
										: main.fullname || main.company_name
								}}
								(Main Borrower)
								{{
									available.includes(main.ic_number || main.company_registration_number)
										? ''
										: '(!)'
								}}
							</option>
							<option *ngFor="let bip of bips" [value]="bip.id">
								{{
									bip.expand.company_registration_number
										? bip.expand.company_name || bip.expand.fullname
										: bip.expand.fullname || bip.expand.company_name
								}}
								{{
									available.includes(bip.expand.ic_number || bip.expand.company_registration_number)
										? ''
										: '(!)'
								}}
							</option>
						</select>
					</div>
				</div>
				<span *ngIf="notAvailable > 0">{{
					translate.warning.replace('number', notAvailable.toString())
				}}</span>
			</ng-container>
		</ng-container>
	`, changeDetection: ChangeDetectionStrategy.OnPush, styles: [":host{display:flex;flex-direction:column;gap:4px}:host span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:12px;line-height:1.5;color:#757575}:host .form-control{width:328px}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }]; }, propDecorators: { selectMember: [{
                type: Output
            }], main: [{
                type: Input
            }], bips: [{
                type: Input
            }], available: [{
                type: Input
            }] } });

class CBSelectModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBSelectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CBSelectModule, declarations: [CBSelectComponent], imports: [CommonModule], exports: [CBSelectComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBSelectModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBSelectModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [CBSelectComponent],
                    exports: [CBSelectComponent],
                }]
        }] });

class CBDefaultComponentStore extends CBComponentStore {
    constructor(_service) {
        super(_service, {
            countryId: FSWCountryCode.VU,
        });
        this._service = _service;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBDefaultComponentStore, deps: [{ token: CREDIT_BUREAU_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBDefaultComponentStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBDefaultComponentStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CREDIT_BUREAU_SERVICE_TOKEN]
                }] }]; } });

class CBDefaultAdditionalComponentStore extends CBAdditionalComponentStore {
    constructor(_scope, _translateService, _cbComponentStore) {
        super(_scope, _translateService, _cbComponentStore);
        this._scope = _scope;
        this._translateService = _translateService;
        this._cbComponentStore = _cbComponentStore;
    }
    setup(translate) {
        const fields = translate['fields'];
        const options = translate['options'];
        this._setupCredit(fields);
        this._setupRequested(fields);
        this._setupCollaterals(fields, options);
        this._setupOffBalanceSheet(fields, options);
        this._setupDebt(fields);
        this._setupNPL(fields, options);
    }
    _setupCredit(fields) {
        const report = this._cbComponentStore.report;
        if (!report)
            return;
        const data = this.getCredit(report.credit_card_detail);
        this.setupConfig('credit', {
            formData: data,
            formFieldConfig: {
                hideAllCTAs: true,
            },
            formFields: [
                {
                    type: FIELD_TYPE.STRING,
                    key: 'total_limit',
                    label: fields['total_limit'],
                    param: [{ value: data?.total_limit, disabled: false }, [Validators.required]],
                    context: {
                        isReadonly: true,
                    },
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: 'total_need_pay',
                    label: fields['total_need_pay'],
                    param: [{ value: data?.total_need_pay, disabled: false }, [Validators.required]],
                    context: {
                        isReadonly: true,
                    },
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: 'total_late_pay',
                    label: fields['total_late_pay'],
                    param: [{ value: data?.total_late_pay, disabled: false }, [Validators.required]],
                    context: {
                        isReadonly: true,
                    },
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: 'numbers_of_credit_card',
                    label: fields['numbers_of_credit_card'],
                    param: [{ value: data?.numbers_of_credit_card, disabled: false }, [Validators.required]],
                    context: {
                        isReadonly: true,
                    },
                },
            ],
            defaultValue: data,
            saveValue: report.credit_card_detail,
        });
    }
    _setupRequested(fields) {
        const report = this._cbComponentStore.report;
        if (!report)
            return;
        const data = this.getRequested(report.cb_requested_by_bank_fs_details);
        this.setupConfig('requested', {
            formData: data,
            formFieldConfig: {
                hideAllCTAs: true,
            },
            formFields: [
                {
                    type: FIELD_TYPE.NUMBER,
                    key: 'total_requests',
                    label: fields['total_requests'],
                    param: [{ value: data?.total_requests, disabled: false }, [Validators.required]],
                    context: {
                        isReadonly: true,
                    },
                },
            ],
            defaultValue: data,
            saveValue: report.cb_requested_by_bank_fs_details,
        });
    }
    _setupCollaterals(fields, options) {
        const report = this._cbComponentStore.report;
        if (!report)
            return;
        const data = this.getCollaterals(report.collaterals_detail);
        this.setupConfig('collaterals', {
            formData: data,
            formFieldConfig: {
                hideAllCTAs: true,
            },
            formFields: [
                {
                    type: FIELD_TYPE.SELECT,
                    key: 'secured_loans',
                    label: fields['secured_loans'],
                    param: [{ value: data?.secured_loans, disabled: false }, [Validators.required]],
                    context: {
                        isReadonly: true,
                    },
                    options: buildFieldOptions(['yes', 'no'].map((e) => ({ value: e, label: options.secured_loans[e] }))),
                },
                {
                    type: FIELD_TYPE.NUMBER,
                    key: 'number_banks',
                    label: fields['number_banks'],
                    param: [{ value: data?.number_banks, disabled: false }, [Validators.required]],
                    context: {
                        isReadonly: true,
                    },
                },
            ],
            defaultValue: data,
            saveValue: report.collaterals_detail,
        });
    }
    _setupNPL(fields, options) {
        const report = this._cbComponentStore.report;
        if (!report)
            return;
        const items = report.npl_details || [];
        items.forEach((detail) => {
            const data = this.getNPL(detail);
            this.setupNPLConfig(v4(), {
                formFieldConfig: {
                    hideAllCTAs: true,
                },
                formData: data,
                formFields: [
                    {
                        type: FIELD_TYPE.STRING,
                        key: 'bank_name',
                        label: fields['bank_name'],
                        param: [{ value: data?.bank_name, disabled: false }, [Validators.required]],
                        context: {
                            isReadonly: true,
                        },
                    },
                    {
                        type: FIELD_TYPE.STRING,
                        key: 'branch_name',
                        label: fields['branch_name'],
                        param: [{ value: data?.branch_name, disabled: false }, [Validators.required]],
                        context: {
                            isReadonly: true,
                        },
                    },
                    {
                        type: FIELD_TYPE.SELECT,
                        key: 'debt',
                        label: fields['debt'],
                        param: [{ value: data?.debt, disabled: false }, [Validators.required]],
                        context: {
                            isReadonly: true,
                        },
                        options: buildFieldOptions(['01', '02', '03', '04', '05', '06'].map((e) => ({
                            value: e,
                            label: options.debt_types[e],
                        }))),
                    },
                    {
                        type: FIELD_TYPE.NUMBER,
                        key: 'amount',
                        label: fields['amount'],
                        param: [{ value: data?.amount, disabled: false }, [Validators.required]],
                        context: {
                            isReadonly: true,
                            suffix: 'M VND',
                            template: (value) => addDotDelimiter(value),
                        },
                    },
                ],
                defaultValue: data,
                saveValue: detail,
            });
        });
    }
    _setupOffBalanceSheet(fields, options) {
        const report = this._cbComponentStore.report;
        if (!report)
            return;
        const items = report.off_balance_sheet_details || [];
        items.forEach((detail) => {
            const data = this.getOffBalanceSheet(detail);
            this.setupOffBalanceSheetConfig(v4(), {
                formFieldConfig: {
                    hideAllCTAs: true,
                },
                formData: data,
                formFields: [
                    {
                        type: FIELD_TYPE.STRING,
                        key: 'bank_name',
                        label: fields['bank_name'],
                        param: [{ value: data?.bank_name, disabled: false }, [Validators.required]],
                        context: {
                            isReadonly: true,
                        },
                    },
                    {
                        type: FIELD_TYPE.STRING,
                        key: 'branch_name',
                        label: fields['branch_name'],
                        param: [{ value: data?.branch_name, disabled: false }, [Validators.required]],
                        context: {
                            isReadonly: true,
                        },
                    },
                    {
                        type: FIELD_TYPE.NUMBER,
                        key: 'amount',
                        label: fields['amount'],
                        param: [{ value: data?.amount, disabled: false }, [Validators.required]],
                        context: {
                            isReadonly: true,
                        },
                    },
                    {
                        type: FIELD_TYPE.SELECT,
                        key: 'debt',
                        label: fields['debt'],
                        param: [{ value: data?.debt, disabled: false }, [Validators.required]],
                        context: {
                            isReadonly: true,
                        },
                        options: buildFieldOptions(['01', '02', '03', '04', '05', '06'].map((e) => ({
                            value: e,
                            label: options.debt_types[e],
                        }))),
                    },
                ],
                defaultValue: data,
                saveValue: detail,
            });
        });
    }
    _setupDebt(fields) {
        const report = this._cbComponentStore.report;
        if (!report)
            return;
        const items = report.debt_need_attentions || [];
        items.forEach((detail) => {
            const data = this.getDebt(detail);
            this.setupDebtConfig(v4(), {
                formData: data,
                formFieldConfig: {
                    hideAllCTAs: true,
                },
                formFields: [
                    {
                        type: FIELD_TYPE.DATE,
                        key: 'report_date',
                        label: fields['month_year'],
                        param: [{ value: data?.report_date, disabled: false }, [Validators.required]],
                        context: {
                            isReadonly: true,
                        },
                    },
                    {
                        type: FIELD_TYPE.STRING,
                        key: 'total',
                        label: fields['total_debt'],
                        param: [{ value: data?.total, disabled: false }, [Validators.required]],
                        context: {
                            isReadonly: true,
                            suffix: 'M VND',
                            template: (value) => addDotDelimiter(value),
                        },
                    },
                    {
                        type: FIELD_TYPE.STRING,
                        key: 'bank_name',
                        label: fields['bank_name'],
                        param: [{ value: data?.bank_name, disabled: false }, [Validators.required]],
                        context: {
                            isReadonly: true,
                        },
                    },
                    {
                        type: FIELD_TYPE.STRING,
                        key: 'branch_name',
                        label: fields['branch_name'],
                        param: [{ value: data?.branch_name, disabled: false }, [Validators.required]],
                        context: {
                            isReadonly: true,
                        },
                    },
                    {
                        type: FIELD_TYPE.DATE,
                        key: 'report_date',
                        label: fields['report_date'],
                        param: [{ value: data?.report_date, disabled: false }, [Validators.required]],
                        context: {
                            isReadonly: true,
                        },
                    },
                ],
                defaultValue: data,
                saveValue: detail,
            });
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBDefaultAdditionalComponentStore, deps: [{ token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: CB_COMPONENT_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBDefaultAdditionalComponentStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBDefaultAdditionalComponentStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CB_COMPONENT_STORE_TOKEN]
                }] }]; } });

class CBDefaultGeneralComponentStore extends CBGeneralComponentStore {
    constructor(_scope, _translateService, _cbComponentStore) {
        super(_scope, _translateService, _cbComponentStore);
        this._scope = _scope;
        this._translateService = _translateService;
        this._cbComponentStore = _cbComponentStore;
    }
    setup(translate) {
        const fields = translate['fields'];
        this._setupBasic(fields);
        this._setupCredit(fields);
    }
    _setupBasic(fields) {
        const basic = this.getBasic();
        const isIndividual = this._cbComponentStore.state().selectedMember?.entity_type === CBEntityTypes.INDIVIDUAL;
        this.setupConfig('basic', {
            formFields: [
                {
                    type: FIELD_TYPE.DATE,
                    key: 'issued_date',
                    label: fields['issued_date'],
                    param: [{ value: basic?.issued_date, disabled: false }, [Validators.required]],
                    context: {
                        isReadonly: true,
                    },
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: 'name',
                    label: isIndividual ? fields['individual_name'] : fields['name'],
                    param: [{ value: basic?.name, disabled: false }, [Validators.required]],
                    context: {
                        isReadonly: true,
                    },
                },
                {
                    type: FIELD_TYPE.STRING,
                    key: 'erc',
                    label: isIndividual ? fields['individual_erc'] : fields['erc'],
                    param: [{ value: basic?.erc, disabled: false }, [Validators.required]],
                    context: {
                        isReadonly: true,
                    },
                },
            ],
            formData: basic,
            saveValue: {
                customer_detail: this._cbComponentStore.report?.customer_detail,
                summary_enquiry: this._cbComponentStore.report?.summary_enquiry,
            },
            defaultValue: basic,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        });
    }
    _setupCredit(fields) {
        const credit = this.getCredit();
        this.setupConfig('credit', {
            formFields: [
                {
                    type: FIELD_TYPE.NUMBER,
                    key: 'score',
                    label: fields['score'],
                    param: [{ value: credit?.score, disabled: false }, [Validators.required]],
                    context: {
                        isReadonly: true,
                    },
                },
                {
                    type: FIELD_TYPE.NUMBER,
                    key: 'rank',
                    label: fields['rank'],
                    param: [{ value: credit?.rank, disabled: false }, [Validators.required]],
                    context: {
                        isReadonly: true,
                    },
                },
            ],
            formData: credit,
            defaultValue: credit,
            saveValue: this._cbComponentStore.report?.personal_bureau_score,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBDefaultGeneralComponentStore, deps: [{ token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: CB_COMPONENT_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBDefaultGeneralComponentStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBDefaultGeneralComponentStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CB_COMPONENT_STORE_TOKEN]
                }] }]; } });

class CBDefaultBankComponentStore extends CBBankComponentStore {
    constructor(_scope, _translateService, _cbComponentStore) {
        super(_scope, _translateService, _cbComponentStore);
        this._scope = _scope;
        this._translateService = _translateService;
        this._cbComponentStore = _cbComponentStore;
    }
    setup(translate) {
        const fields = translate['fields'];
        const options = translate['options'];
        const list = this.getListValue();
        list.forEach((e) => {
            const data = {
                bank_name: e.bank_name,
                branch_name: e.branch_name,
                outstanding_balance: e.loan_terms.reduce((acc, cur) => acc + cur.total_vnd, 0),
            };
            this.setupConfig(v4(), {
                basic: {
                    formData: data,
                    defaultValue: data,
                    saveValue: e,
                    formFieldConfig: {
                        hideAllCTAs: true,
                    },
                    formFields: [
                        {
                            type: FIELD_TYPE.STRING,
                            key: 'bank_name',
                            label: fields['bank_name'],
                            param: [{ value: data.bank_name, disabled: false }, [Validators.required]],
                            context: {
                                isReadonly: true,
                            },
                        },
                        {
                            type: FIELD_TYPE.STRING,
                            key: 'branch_name',
                            label: fields['branch_name'],
                            param: [{ value: data.branch_name, disabled: false }, [Validators.required]],
                            context: {
                                isReadonly: true,
                            },
                        },
                        {
                            type: FIELD_TYPE.STRING,
                            key: 'outstanding_balance',
                            label: fields['outstanding_balance'],
                            param: [{ value: data.outstanding_balance, disabled: false }, [Validators.required]],
                            context: {
                                isReadonly: true,
                                suffix: 'M VND',
                                template: (value) => addDotDelimiter(value),
                            },
                        },
                    ],
                },
                terms: e.loan_terms.map((term) => this._setupTerm(term, options, fields)),
            });
        });
    }
    _setupTerm(term, options, fields) {
        const data = {
            term: term.type,
        };
        return {
            id: v4(),
            data: {
                formData: data,
                defaultValue: data,
                saveValue: term,
                formFieldConfig: {
                    hideAllCTAs: true,
                },
                formFields: [
                    {
                        type: FIELD_TYPE.SELECT,
                        key: 'term',
                        label: fields['term'],
                        param: [{ value: data.term, disabled: false }, [Validators.required]],
                        context: {
                            isReadonly: true,
                        },
                        options: buildFieldOptions(['long', 'short', 'medium'].map((e) => ({ value: e, label: options.term[e] }))),
                    },
                ],
            },
            debts: term.debt_details.map((e) => this._setupDebt(e, options, fields)),
        };
    }
    _setupDebt(debt, options, fields) {
        const data = {
            debt: debt.type.trim().replace('standard', '01'),
            outstanding_balance: debt.vnd_amt,
        };
        return {
            id: v4(),
            data: {
                formFieldConfig: {
                    hideAllCTAs: true,
                },
                formData: data,
                defaultValue: data,
                saveValue: debt,
                formFields: [
                    {
                        type: FIELD_TYPE.SELECT,
                        key: 'debt',
                        label: fields['debt'],
                        param: [{ value: data.debt, disabled: false }, [Validators.required]],
                        context: {
                            isReadonly: true,
                        },
                        options: buildFieldOptions(['01', '02', '03', '04', '05', '06'].map((e) => ({
                            value: e,
                            label: options.debt_types[e],
                        }))),
                    },
                    {
                        type: FIELD_TYPE.STRING,
                        key: 'outstanding_balance',
                        label: fields['outstanding_balance'],
                        param: [{ value: data.outstanding_balance, disabled: false }, [Validators.required]],
                        context: {
                            isReadonly: true,
                            suffix: 'M VND',
                            template: (value) => addDotDelimiter(value),
                        },
                    },
                ],
            },
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBDefaultBankComponentStore, deps: [{ token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: CB_COMPONENT_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBDefaultBankComponentStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBDefaultBankComponentStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CB_COMPONENT_STORE_TOKEN]
                }] }]; } });

const cbDefaultProviders = [
    {
        provide: CB_COMPONENT_STORE_TOKEN,
        useClass: CBDefaultComponentStore,
        deps: [CREDIT_BUREAU_SERVICE_TOKEN],
    },
    {
        provide: CB_ADDITIONAL_COMPONENT_STORE_TOKEN,
        useClass: CBDefaultAdditionalComponentStore,
        deps: [TRANSLOCO_SCOPE, TranslocoFeatureHttpLoader, CB_COMPONENT_STORE_TOKEN],
    },
    {
        provide: CB_BANK_COMPONENT_STORE_TOKEN,
        useClass: CBDefaultBankComponentStore,
        deps: [TRANSLOCO_SCOPE, TranslocoFeatureHttpLoader, CB_COMPONENT_STORE_TOKEN],
    },
    {
        provide: CB_GENERAL_COMPONENT_STORE_TOKEN,
        useClass: CBDefaultGeneralComponentStore,
        deps: [TRANSLOCO_SCOPE, TranslocoFeatureHttpLoader, CB_COMPONENT_STORE_TOKEN],
    },
];

var title$r = "Credit Bureau";
var general_summary = {
	title: "General Summary",
	fields: {
		issued_date: "Issued Date",
		name: "Customer Name",
		individual_name: "Individual Borrower Name",
		individual_erc: "ID Card Number",
		erc: "ERC Code",
		score: "Credit Score",
		rank: "Credit Rating"
	}
};
var bank_summary = {
	title: "Bank Summary",
	fields: {
		bank_name: "Bank Name",
		branch_name: "Branch Name",
		outstanding_balance: "Outstanding Balance",
		term: "Term",
		debt: "Debt Classification"
	},
	options: {
		term: {
			long: "Dư nợ cho vay dài hạn",
			short: "Dư nợ cho vay ngắn hạn",
			medium: "Dư nợ cho vay trung hạn"
		},
		debt_types: {
			"01": "Standard debts",
			"02": "Debts which need attention",
			"03": "Sub-standard debts",
			"04": "Doubtful debts",
			"05": "Potentially irrecoverable",
			"06": "Others non performing debts"
		}
	},
	total: {
		label: "Total Outstanding Balance at All Banks",
		suffix: "M VND"
	},
	expand: "outstanding balance terms"
};
var additional_summary = {
	title: "Additional Summary",
	sub_titles: {
		off_balance: "Information of off-balance sheet commitments",
		collaterals: "Information of collaterals",
		credit: "Detail of credit cards and outstanding balance",
		npl: "History of NPLs within last 5 years",
		debt: "2nd level - Debt Classification within last 12 months"
	},
	fields: {
		bank_name: "Bank Name",
		branch_name: "Branch Name",
		amount: "Amount",
		debt: "Debt Classification",
		secured_loans: "Secured Loans",
		number_banks: "Number of banks with secured loan",
		total_requests: "Number of Banks/FIs requested within 12 months",
		total_limit: "Total of Credit Card’s Limit",
		total_need_pay: "Total Payment Need to Pay",
		total_late_pay: "Total Late Payment Amount",
		total_debt: "Total Debt",
		month_year: "Month/Year",
		report_date: "Reporting Date (dd/mm/yyyy)",
		numbers_of_credit_card: "Number of Credit Cards"
	},
	options: {
		secured_loans: {
			yes: "Yes",
			no: "No"
		},
		debt_types: {
			"01": "Standard debts",
			"02": "Debts which need attention",
			"03": "Sub-standard debts",
			"04": "Doubtful debts",
			"05": "Potentially irrecoverable",
			"06": "Others non performing debts"
		}
	},
	empty: {
		npl: "Khách hàng không có nợ xấu trong 05 năm gần nhất.",
		debt: "Khách hàng không có nợ cần chú ý trong 12 tháng gần nhất"
	}
};
var reupload_dialog = {
	title: "Reupload Credit Bureau",
	fields: {
		current: "Current Credit Bureau",
		"new": "New Credit Bureau"
	},
	warning: "Any edits you’ve made will NOT be saved after you replace the Credit Bureau."
};
var upload = {
	title: "Credit Bureau",
	empty_message: "Please make sure you choose valid CIC pdf file without footer and header to upload",
	data_message: "IC number or Company registration number can not be empty, please update current member information to correct information."
};
var types = {
	ktp: "Individual",
	npwp: "Corporate"
};
var hints = {
	edited: "Edited"
};
var select_borrower_bip = {
	label: "Borrower/BIP",
	warning: "Credit Bureau is still missing for number borrowers/BIPs"
};
var buttons$H = {
	edit: "Edit",
	cancel: "Cancel",
	close: "Close",
	previous: "Prev",
	next: "Next",
	save: "Save Changes",
	reset: "Reset Edits",
	upload: "Upload",
	reupload: "Reupload",
	reupload_full: "Reupload Credit Bureau"
};
var tabs = {
	general: "General Summary",
	additional: "Additional Summary",
	bank: "Bank Summary"
};
var _default$3 = {
	title: title$r,
	general_summary: general_summary,
	bank_summary: bank_summary,
	additional_summary: additional_summary,
	reupload_dialog: reupload_dialog,
	upload: upload,
	types: types,
	hints: hints,
	select_borrower_bip: select_borrower_bip,
	buttons: buttons$H,
	tabs: tabs
};

var de$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    additional_summary: additional_summary,
    bank_summary: bank_summary,
    buttons: buttons$H,
    default: _default$3,
    general_summary: general_summary,
    hints: hints,
    reupload_dialog: reupload_dialog,
    select_borrower_bip: select_borrower_bip,
    tabs: tabs,
    title: title$r,
    types: types,
    upload: upload
});

const cbLoader = {
    default: () => Promise.resolve(de$2),
};

class CBComponent {
    set id(value) {
        this._componentStore.setId(value);
    }
    set applicationId(value) {
        this._componentStore.setApplicationId(value);
    }
    //#endregion Translate
    constructor(_componentStore, _scope, _translateService) {
        this._componentStore = _componentStore;
        this._scope = _scope;
        this._translateService = _translateService;
        this.state$ = this._componentStore.state$;
        //#region Translate
        this.title$ = this._translateService.selectFeatureTranslate(this._scope, 'title');
    }
    ngOnInit() {
        this._componentStore.init();
    }
    uploadFile(file) {
        this._componentStore.upload(file);
    }
    selectMember(selectedMember) {
        const { type, data } = selectedMember;
        const ic_number = type === CBMemberTypes.BRW
            ? data.ic_number
            : data.expand.ic_number;
        const company_registration_number = type === CBMemberTypes.BRW
            ? data.company_registration_number
            : data.expand.company_registration_number;
        const isIndividual = !!ic_number;
        const information = (type === CBMemberTypes.BRW ? data : data.expand);
        this._componentStore.setSelectedMember({
            member_type: type,
            entity_type: isIndividual ? CBEntityTypes.INDIVIDUAL : CBEntityTypes.CORPORATE,
            erc: isIndividual ? ic_number : company_registration_number,
            information,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBComponent, deps: [{ token: CB_COMPONENT_STORE_TOKEN }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: CBComponent, selector: "fsw-credit-bureau", inputs: { id: "id", applicationId: "applicationId" }, ngImport: i0, template: "<h6>{{ title$ | async }}</h6>\n<ng-container *ngrxLet=\"state$; let state\">\n\t<div class=\"credit-bureau\">\n\t\t<div class=\"credit-bureau__information\">\n\t\t\t<fsw-cb-select\n\t\t\t\t[main]=\"state.data\"\n\t\t\t\t[bips]=\"state.bips\"\n\t\t\t\t[available]=\"state.available\"\n\t\t\t\t(selectMember)=\"selectMember($event)\"\n\t\t\t></fsw-cb-select>\n\t\t\t<ng-container *ngIf=\"state.report as report; else notUploadEmpty\">\n\t\t\t\t<fsw-cb-summary-form></fsw-cb-summary-form>\n\t\t\t</ng-container>\n\t\t\t<ng-template #notUploadEmpty>\n\t\t\t\t<fsw-cb-upload\n\t\t\t\t\t[selectedMember]=\"state.selectedMember\"\n\t\t\t\t\t(fileSelect)=\"uploadFile($event)\"\n\t\t\t\t\t[hasError]=\"state.uploadError\"\n\t\t\t\t></fsw-cb-upload>\n\t\t\t</ng-template>\n\t\t</div>\n\t\t<fsw-cb-summary-pdf *ngIf=\"state.report\"></fsw-cb-summary-pdf>\n\t</div>\n</ng-container>\n", styles: [":host h6{color:#222;margin-bottom:4px}:host .credit-bureau{display:flex;width:100%}:host .credit-bureau__information{width:calc(50% - 8px);display:flex;flex-direction:column;gap:24px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$1.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: CBSelectComponent, selector: "fsw-cb-select", inputs: ["main", "bips", "available"], outputs: ["selectMember"] }, { kind: "component", type: CBSummaryFormComponent, selector: "fsw-cb-summary-form" }, { kind: "component", type: CBSummaryPdfComponent, selector: "fsw-cb-summary-pdf" }, { kind: "component", type: CBUploadComponent, selector: "fsw-cb-upload", inputs: ["selectedMember", "hasError", "isButton"], outputs: ["fileSelect"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-credit-bureau', changeDetection: ChangeDetectionStrategy.OnPush, template: "<h6>{{ title$ | async }}</h6>\n<ng-container *ngrxLet=\"state$; let state\">\n\t<div class=\"credit-bureau\">\n\t\t<div class=\"credit-bureau__information\">\n\t\t\t<fsw-cb-select\n\t\t\t\t[main]=\"state.data\"\n\t\t\t\t[bips]=\"state.bips\"\n\t\t\t\t[available]=\"state.available\"\n\t\t\t\t(selectMember)=\"selectMember($event)\"\n\t\t\t></fsw-cb-select>\n\t\t\t<ng-container *ngIf=\"state.report as report; else notUploadEmpty\">\n\t\t\t\t<fsw-cb-summary-form></fsw-cb-summary-form>\n\t\t\t</ng-container>\n\t\t\t<ng-template #notUploadEmpty>\n\t\t\t\t<fsw-cb-upload\n\t\t\t\t\t[selectedMember]=\"state.selectedMember\"\n\t\t\t\t\t(fileSelect)=\"uploadFile($event)\"\n\t\t\t\t\t[hasError]=\"state.uploadError\"\n\t\t\t\t></fsw-cb-upload>\n\t\t\t</ng-template>\n\t\t</div>\n\t\t<fsw-cb-summary-pdf *ngIf=\"state.report\"></fsw-cb-summary-pdf>\n\t</div>\n</ng-container>\n", styles: [":host h6{color:#222;margin-bottom:4px}:host .credit-bureau{display:flex;width:100%}:host .credit-bureau__information{width:calc(50% - 8px);display:flex;flex-direction:column;gap:24px}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CB_COMPONENT_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }]; }, propDecorators: { id: [{
                type: Input
            }], applicationId: [{
                type: Input
            }] } });

class CBDirective {
    constructor(_injector, _viewContainerRef, _resolver) {
        this._injector = _injector;
        this._viewContainerRef = _viewContainerRef;
        this._resolver = _resolver;
        this.id = null;
        this.countryId = null;
        this.applicationId = null;
        this._internationalMapping = {
            [FSWCountryCode.VU]: Promise.resolve(cbDefaultProviders),
            [FSWCountryCode.ID]: Promise.resolve(cbDefaultProviders),
        };
        this._default = Promise.resolve(cbDefaultProviders);
    }
    ngOnChanges() {
        this._viewContainerRef.clear();
        const mapAsync = this._internationalMapping[this.countryId] || this._default;
        from(mapAsync)
            .pipe(tap((providers) => {
            const factoryResolver = this._resolver.resolveComponentFactory(CBComponent);
            const injector = Injector.create({
                parent: this._injector,
                providers: [
                    ...providers,
                    {
                        provide: TRANSLOCO_SCOPE,
                        useValue: {
                            scope: 'credit-bureau',
                            loader: cbLoader,
                        },
                    },
                    {
                        provide: TRANSLOCO_LANG,
                        useValue: this.countryId?.toLowerCase() || 'default',
                    },
                    {
                        provide: TranslocoFeatureHttpLoader,
                        useClass: TranslocoFeatureHttpLoader,
                    },
                ],
            });
            const ref = this._viewContainerRef.createComponent(factoryResolver, 0, injector);
            ref.instance.id = this.id;
            ref.instance.applicationId = this.applicationId;
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBDirective, deps: [{ token: i0.Injector }, { token: i0.ViewContainerRef }, { token: i0.ComponentFactoryResolver }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: CBDirective, selector: "[fswCreditBureau]", inputs: { id: "id", countryId: "countryId", applicationId: "applicationId" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CBDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswCreditBureau]',
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }, { type: i0.ViewContainerRef }, { type: i0.ComponentFactoryResolver }]; }, propDecorators: { id: [{
                type: Input
            }], countryId: [{
                type: Input
            }], applicationId: [{
                type: Input
            }] } });

const INTERNAL_UI_MODULES = [
    CBSelectModule,
    CBSummaryFormModule,
    CBSummaryPdfModule,
    CBUploadModule,
];
class CreditBureauModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditBureauModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CreditBureauModule, declarations: [CBDirective, CBComponent], imports: [CommonModule,
            FSWGridModule,
            LetDirective,
            FSWModalModule,
            UtilsServiceModule,
            CreditBureauServiceModule, CBSelectModule,
            CBSummaryFormModule,
            CBSummaryPdfModule,
            CBUploadModule], exports: [CBDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditBureauModule, imports: [CommonModule,
            FSWGridModule,
            FSWModalModule,
            UtilsServiceModule,
            CreditBureauServiceModule,
            INTERNAL_UI_MODULES] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditBureauModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FSWGridModule,
                        LetDirective,
                        FSWModalModule,
                        UtilsServiceModule,
                        CreditBureauServiceModule,
                        INTERNAL_UI_MODULES,
                    ],
                    declarations: [CBDirective, CBComponent],
                    exports: [CBDirective],
                }]
        }] });

var repayment_schedule$1 = "Repayment Schedule";
var loan_terms$1 = "Facility Terms";
var facility_terms$1 = "Facility Recommendation";
var credit_assessment$1 = "Credit Assessment";
var scorecard$1 = "Scorecard";
var creditMemoAnalysisMy = {
	repayment_schedule: repayment_schedule$1,
	loan_terms: loan_terms$1,
	facility_terms: facility_terms$1,
	credit_assessment: credit_assessment$1,
	scorecard: scorecard$1
};

var MY$f = /*#__PURE__*/Object.freeze({
    __proto__: null,
    credit_assessment: credit_assessment$1,
    default: creditMemoAnalysisMy,
    facility_terms: facility_terms$1,
    loan_terms: loan_terms$1,
    repayment_schedule: repayment_schedule$1,
    scorecard: scorecard$1
});

const CREDIT_MEMO_ANALYSIS_MY_TRANSLATION = MY$f;

var repayment_schedule = "Repayment Schedule";
var loan_terms = "Loan Recommendation";
var facility_terms = "Facility Recommendation";
var credit_assessment = "Credit Assessment";
var scorecard = "Scorecard";
var creditMemoAnalysisSg = {
	repayment_schedule: repayment_schedule,
	loan_terms: loan_terms,
	facility_terms: facility_terms,
	credit_assessment: credit_assessment,
	scorecard: scorecard
};

var SG$5 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    credit_assessment: credit_assessment,
    default: creditMemoAnalysisSg,
    facility_terms: facility_terms,
    loan_terms: loan_terms,
    repayment_schedule: repayment_schedule,
    scorecard: scorecard
});

const CREDIT_MEMO_ANALYSIS_SG_TRANSLATION = SG$5;

function creditMemoAnalysisTranslation(scope = 'credit_memo_analysis') {
    return [
        ...(FSWTranslateModule.forFeature({
            scope,
            defaultKey: getCountryCodeFromStorage(),
            data: {
                [CountryCode.MY]: CREDIT_MEMO_ANALYSIS_MY_TRANSLATION,
                [CountryCode.SG]: CREDIT_MEMO_ANALYSIS_SG_TRANSLATION,
            },
        }).providers || []),
        fswTranslateScope(scope),
    ];
}

var condition = {
	title: "Conditions"
};
var test_bucket = {
	title: "Test Bucket",
	update: "Update",
	current: "Current"
};
var buttons$G = {
	save: "Save",
	add: "Add New Condition",
	assign: "Assign"
};
var entity = {
	terms: {
		title: "Facility Terms",
		fields: {
			principal: "Principal",
			disbursement_amount: "Disbursement Amount",
			settlement_amount: "Settlement Amount",
			origination_fee: "Origination Fee",
			guarantee_fee: "Guarantee Fee",
			collateral: "Collateral",
			tenor: "Tenor",
			period: "Period",
			controls: "Controls",
			installment_type: "Installment Type",
			interest_rate: "Interest Rate %",
			late_interest_fee: "Late Interest Fee (%)",
			late_fee: "Late Fee",
			investor: "Early Repayment Investor",
			company: "Early Repayment Company"
		}
	},
	recommendation: {
		title: "Facility Recommendation",
		fields: {
			start_date: "Facility Start Date",
			end_date: "Facility End Date",
			limit: "Facility Limit",
			max_loan_to_value: "LTV (%)",
			annual_fee: "Annual Fee",
			minimum_day_to_disburse: "Days to Crowdfund",
			maximum_day_to_disburse: "Credit Term (days)",
			admin_fee: "Admin Fee",
			admin_fee_period: "Admin Fee Period",
			facility_fee_value: "Facility Fee",
			facility_fee_period: "Facility Fee Period",
			interest_rate: "Interest Rate",
			interest_rate_type: "Interest Rate Period",
			late_interest_fee: "Late Interest Fee (%)",
			late_interest_fee_type: "Late Interest Fee Period",
			discounting: "Discounting (%)",
			discounting_type: "Discounting Period",
			late_fee: "Late Fee",
			late_fee_type: "Late Fee Period"
		}
	}
};
var facilityAll = {
	condition: condition,
	test_bucket: test_bucket,
	buttons: buttons$G,
	entity: entity
};

var ALL$9 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$G,
    condition: condition,
    default: facilityAll,
    entity: entity,
    test_bucket: test_bucket
});

const FACILITY_ALL_TRANSLATION = ALL$9;

const injectFacilityALLForm = ({ isReadonly, isTopUp, entity, form, }) => {
    const translation = FACILITY_ALL_TRANSLATION;
    return new FSWDynamicBuilder({
        form,
        formType: FSWDynamicBuilderFormTypes.GROUP,
        renderBy: 'container',
        customClasses: 'flex flex-wrap gap-[16px]',
        readonlyWhen$: of(isReadonly || isTopUp),
        containers: entity === 'terms'
            ? getTermsContainers(translation.entity.terms.fields, isTopUp)
            : getRecommendationContainers(translation.entity.recommendation.fields),
    });
};
const getTermsContainers = (translation, isTopUp) => {
    return [
        {
            customClasses: 'flex flex-col gap-[16px] w-[calc(50%-8px)]',
            fields: [
                {
                    key: 'loan_info',
                    formType: FSWDynamicBuilderFormTypes.GROUP,
                    renderBy: 'container',
                    customClasses: 'flex flex-col w-full gap-[16px]',
                    containers: getCountryCodeFromStorage() === CountryCode.SG
                        ? [
                            {
                                customClasses: 'flex w-full gap-[8px]',
                                fields: [
                                    {
                                        key: 'principal',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        customClasses: 'w-full',
                                        context: {
                                            // inputType: 'number',
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            isDisabled: true,
                                            fullWidth: true,
                                            label: translation.principal,
                                            readonlyTemplate: (value) => value ?? 'N/A',
                                        },
                                    },
                                ],
                            },
                            {
                                customClasses: 'flex w-full gap-[8px] items-end',
                                fields: [
                                    {
                                        key: 'tenor',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        customClasses: 'w-[calc(50%-4px)]',
                                        context: {
                                            isDisabled: true,
                                            fullWidth: true,
                                            label: translation.tenor,
                                            readonlyTemplate: (value) => value ?? 'N/A',
                                        },
                                    },
                                    {
                                        key: 'tenor_type',
                                        type: FSWDynamicBuilderControlTypes.SELECT,
                                        customClasses: 'w-[calc(50%-4px)]',
                                        context: {
                                            isDisabled: true,
                                            fullWidth: true,
                                            label: translation.period,
                                            items: selectListToBeString(tenorTypes),
                                            readonlyTemplate: (value) => {
                                                const text = selectListToBeString(tenorTypes).find((item) => item.value === value)?.text;
                                                return text ?? 'N/A';
                                            },
                                        },
                                    },
                                ],
                            },
                            {
                                customClasses: 'flex w-full gap-[8px]',
                                fields: [
                                    {
                                        key: 'installment_type',
                                        type: FSWDynamicBuilderControlTypes.SELECT,
                                        customClasses: 'w-full',
                                        context: {
                                            label: translation.installment_type,
                                            isDisabled: true,
                                            fullWidth: true,
                                            items: selectListToBeString(installmentTypes),
                                            readonlyTemplate: (value) => {
                                                const text = selectListToBeString(installmentTypes).find((item) => item.value === value)?.text;
                                                return text ?? 'N/A';
                                            },
                                        },
                                    },
                                ],
                            },
                            {
                                customClasses: 'flex w-full gap-[8px] items-end',
                                fields: [
                                    {
                                        key: 'interest_rate',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        customClasses: 'w-[calc(50%-4px)]',
                                        context: {
                                            // inputType: 'number',
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            isDisabled: true,
                                            fullWidth: true,
                                            label: translation.interest_rate,
                                            readonlyTemplate: (value) => value ?? 'N/A',
                                        },
                                    },
                                    {
                                        key: 'interest_rate_type',
                                        type: FSWDynamicBuilderControlTypes.SELECT,
                                        customClasses: 'w-[calc(50%-4px)]',
                                        context: {
                                            isDisabled: true,
                                            fullWidth: true,
                                            label: translation.period,
                                            items: selectListToBeString(interestTypes),
                                            readonlyTemplate: (value) => {
                                                const text = selectListToBeString(interestTypes).find((item) => item.value === value)?.text;
                                                return text ?? 'N/A';
                                            },
                                        },
                                    },
                                ],
                            },
                            {
                                customClasses: 'flex w-full gap-[8px] items-end',
                                fields: [
                                    {
                                        key: 'late_interest_fee',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        customClasses: 'w-[calc(50%-4px)]',
                                        context: {
                                            // inputType: 'number',
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            label: translation.late_interest_fee,
                                            readonlyTemplate: (value) => value ?? 'N/A',
                                        },
                                    },
                                    {
                                        key: 'late_interest_fee_type',
                                        type: FSWDynamicBuilderControlTypes.SELECT,
                                        customClasses: 'w-[calc(50%-4px)]',
                                        context: {
                                            fullWidth: true,
                                            label: translation.period,
                                            items: selectListToBeString(interestTypes),
                                            readonlyTemplate: (value) => {
                                                const text = selectListToBeString(interestTypes).find((item) => item.value === value)?.text;
                                                return text ?? 'N/A';
                                            },
                                        },
                                    },
                                ],
                            },
                            {
                                customClasses: 'flex w-full gap-[8px] items-end',
                                fields: [
                                    {
                                        key: 'late_fee',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        customClasses: 'w-[calc(50%-4px)]',
                                        context: {
                                            inputType: 'number',
                                            fullWidth: true,
                                            label: translation.late_fee,
                                            readonlyTemplate: (value) => value ?? 'N/A',
                                        },
                                    },
                                    {
                                        key: 'late_fee_type',
                                        type: FSWDynamicBuilderControlTypes.SELECT,
                                        customClasses: 'w-[calc(50%-4px)]',
                                        context: {
                                            fullWidth: true,
                                            label: translation.period,
                                            items: selectListToBeString(interestTypes),
                                            readonlyTemplate: (value) => {
                                                const text = selectListToBeString(interestTypes).find((item) => item.value === value)?.text;
                                                return text ?? 'N/A';
                                            },
                                        },
                                    },
                                ],
                            },
                            {
                                customClasses: 'flex w-full gap-[8px] items-end',
                                fields: [
                                    {
                                        key: 'early_repayment_investor',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        customClasses: 'w-[calc(50%-4px)]',
                                        context: {
                                            // inputType: 'number',
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            label: translation.investor,
                                            readonlyTemplate: (value) => value ?? 'N/A',
                                        },
                                    },
                                    {
                                        key: 'early_repayment_company',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        customClasses: 'w-[calc(50%-4px)]',
                                        context: {
                                            // inputType: 'number',
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            label: translation.company,
                                            readonlyTemplate: (value) => value ?? 'N/A',
                                        },
                                    },
                                ],
                            },
                        ]
                        : [
                            {
                                customClasses: 'flex w-full gap-[8px]',
                                fields: [
                                    {
                                        key: 'principal',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        customClasses: 'w-full',
                                        context: {
                                            // inputType: 'number',
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            isDisabled: true,
                                            fullWidth: true,
                                            label: translation.principal,
                                            readonlyTemplate: (value) => value ?? 'N/A',
                                        },
                                    },
                                ],
                            },
                            {
                                customClasses: 'flex w-full gap-[8px]',
                                fields: [
                                    {
                                        key: 'disbursement_amount',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        customClasses: 'w-full',
                                        context: {
                                            // inputType: 'number',
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            isDisabled: true,
                                            fullWidth: true,
                                            label: translation.disbursement_amount,
                                            readonlyTemplate: (value) => value ?? 'N/A',
                                        },
                                    },
                                ],
                            },
                            ...(isTopUp
                                ? [
                                    {
                                        customClasses: 'flex w-full gap-[8px]',
                                        fields: [
                                            {
                                                key: 'settlement_amount',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                customClasses: 'w-full',
                                                context: {
                                                    // inputType: 'number',
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    label: translation.settlement_amount,
                                                    fullWidth: true,
                                                    isDisabled: true,
                                                    readonlyTemplate: (value) => {
                                                        return value ?? 'N/A';
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                    {
                                        customClasses: 'flex w-full gap-[8px]',
                                        fields: [
                                            {
                                                key: 'guarantee_fee',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                customClasses: 'w-full',
                                                context: {
                                                    // inputType: 'number',
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    isDisabled: true,
                                                    fullWidth: true,
                                                    label: translation.guarantee_fee,
                                                    readonlyTemplate: (value) => value ?? 'N/A',
                                                },
                                            },
                                        ],
                                    },
                                ]
                                : []),
                            {
                                customClasses: 'flex w-full gap-[8px]',
                                fields: [
                                    {
                                        key: 'origination_fee',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        customClasses: 'w-full',
                                        context: {
                                            // inputType: 'number',
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            isDisabled: true,
                                            fullWidth: true,
                                            label: translation.origination_fee,
                                            readonlyTemplate: (value) => value ?? 'N/A',
                                        },
                                    },
                                ],
                            },
                            {
                                customClasses: 'flex w-full gap-[8px] items-end',
                                fields: [
                                    {
                                        key: 'tenor',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        customClasses: 'w-[calc(50%-4px)]',
                                        context: {
                                            isDisabled: true,
                                            fullWidth: true,
                                            label: translation.tenor,
                                            readonlyTemplate: (value) => value ?? 'N/A',
                                        },
                                    },
                                    {
                                        key: 'tenor_type',
                                        type: FSWDynamicBuilderControlTypes.SELECT,
                                        customClasses: 'w-[calc(50%-4px)]',
                                        context: {
                                            isDisabled: true,
                                            fullWidth: true,
                                            label: translation.period,
                                            items: selectListToBeString(tenorTypes),
                                            readonlyTemplate: (value) => {
                                                const text = selectListToBeString(tenorTypes).find((item) => item.value === value)?.text;
                                                return text ?? 'N/A';
                                            },
                                        },
                                    },
                                ],
                            },
                            {
                                customClasses: 'flex w-full gap-[8px]',
                                fields: [
                                    {
                                        key: 'installment_type',
                                        type: FSWDynamicBuilderControlTypes.SELECT,
                                        customClasses: 'w-full',
                                        context: {
                                            label: translation.installment_type,
                                            isDisabled: true,
                                            fullWidth: true,
                                            items: selectListToBeString(installmentTypes),
                                            readonlyTemplate: (value) => {
                                                const text = selectListToBeString(installmentTypes).find((item) => item.value === value)?.text;
                                                return text ?? 'N/A';
                                            },
                                        },
                                    },
                                ],
                            },
                            {
                                customClasses: 'flex w-full gap-[8px] items-end',
                                fields: [
                                    {
                                        key: 'interest_rate',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        customClasses: 'w-[calc(50%-4px)]',
                                        context: {
                                            // inputType: 'number',
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            isDisabled: true,
                                            fullWidth: true,
                                            label: translation.interest_rate,
                                            readonlyTemplate: (value) => value ?? 'N/A',
                                        },
                                    },
                                    {
                                        key: 'interest_rate_type',
                                        type: FSWDynamicBuilderControlTypes.SELECT,
                                        customClasses: 'w-[calc(50%-4px)]',
                                        context: {
                                            isDisabled: true,
                                            fullWidth: true,
                                            label: translation.period,
                                            items: selectListToBeString(interestTypes),
                                            readonlyTemplate: (value) => {
                                                const text = selectListToBeString(interestTypes).find((item) => item.value === value)?.text;
                                                return text ?? 'N/A';
                                            },
                                        },
                                    },
                                ],
                            },
                            {
                                customClasses: 'flex w-full gap-[8px] items-end',
                                fields: [
                                    {
                                        key: 'late_interest_fee',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        customClasses: 'w-[calc(50%-4px)]',
                                        context: {
                                            // inputType: 'number',
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            label: translation.late_interest_fee,
                                            readonlyTemplate: (value) => value ?? 'N/A',
                                        },
                                    },
                                    {
                                        key: 'late_interest_fee_type',
                                        type: FSWDynamicBuilderControlTypes.SELECT,
                                        customClasses: 'w-[calc(50%-4px)]',
                                        context: {
                                            fullWidth: true,
                                            label: translation.period,
                                            items: selectListToBeString(interestTypes),
                                            readonlyTemplate: (value) => {
                                                const text = selectListToBeString(interestTypes).find((item) => item.value === value)?.text;
                                                return text ?? 'N/A';
                                            },
                                        },
                                    },
                                ],
                            },
                            {
                                customClasses: 'flex w-full gap-[8px] items-end',
                                fields: [
                                    {
                                        key: 'late_fee',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        customClasses: 'w-[calc(50%-4px)]',
                                        context: {
                                            // inputType: 'number',
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            label: translation.late_fee,
                                            readonlyTemplate: (value) => value ?? 'N/A',
                                        },
                                    },
                                    {
                                        key: 'late_fee_type',
                                        type: FSWDynamicBuilderControlTypes.SELECT,
                                        customClasses: 'w-[calc(50%-4px)]',
                                        context: {
                                            fullWidth: true,
                                            label: translation.period,
                                            items: selectListToBeString(interestTypes),
                                            readonlyTemplate: (value) => {
                                                const text = selectListToBeString(interestTypes).find((item) => item.value === value)?.text;
                                                return text ?? 'N/A';
                                            },
                                        },
                                    },
                                ],
                            },
                            {
                                customClasses: 'flex w-full gap-[8px] items-end',
                                fields: [
                                    {
                                        key: 'early_repayment_investor',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        customClasses: 'w-[calc(50%-4px)]',
                                        context: {
                                            // inputType: 'number',
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            label: translation.investor,
                                            readonlyTemplate: (value) => value ?? 'N/A',
                                        },
                                    },
                                    {
                                        key: 'early_repayment_company',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        customClasses: 'w-[calc(50%-4px)]',
                                        context: {
                                            // inputType: 'number',
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            label: translation.company,
                                            readonlyTemplate: (value) => value ?? 'N/A',
                                        },
                                    },
                                ],
                            },
                        ],
                },
            ],
        },
        {
            customClasses: 'flex flex-col gap-[16px] w-[calc(50%-8px)]',
            fields: [
                {
                    key: 'collateral',
                    type: FSWDynamicBuilderControlTypes.SELECT,
                    customClasses: 'w-full',
                    context: {
                        label: translation.collateral,
                        items: collaterals.map((item) => ({
                            value: item.value,
                            text: item.label,
                        })),
                        fullWidth: true,
                        readonlyTemplate: (value) => {
                            const text = collaterals.find((item) => item.value === value)?.label;
                            return text ?? 'N/A';
                        },
                    },
                },
                {
                    key: 'controls',
                    type: FSWDynamicBuilderControlTypes.SELECT,
                    customClasses: 'w-full',
                    context: {
                        label: translation.controls,
                        items: controls.map((item) => ({
                            value: item.value,
                            text: item.label,
                        })),
                        fullWidth: true,
                        readonlyTemplate: (value) => {
                            const text = controls.find((item) => item.value === value)?.label;
                            return text ?? 'N/A';
                        },
                    },
                },
                {
                    key: 'id',
                    type: FSWDynamicBuilderControlTypes.TEMPLATE,
                    context: {
                        isHidden: true,
                    },
                },
            ],
        },
    ];
};
const getRecommendationContainers = (translation) => {
    return [
        {
            customClasses: 'flex w-full',
            fields: [
                {
                    key: 'loan_info',
                    formType: FSWDynamicBuilderFormTypes.GROUP,
                    renderBy: 'container',
                    customClasses: 'flex w-full gap-[16px]',
                    containers: [
                        {
                            customClasses: 'flex flex-col gap-[16px] w-[calc(50%-8px)]',
                            containers: [
                                {
                                    customClasses: 'flex w-full gap-[8px] items-end',
                                    fields: [
                                        {
                                            key: 'start_date',
                                            type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                                            customClasses: 'w-[calc(50%-4px)]',
                                            context: {
                                                label: translation.start_date,
                                                fullWidth: true,
                                                isRequired: true,
                                                closeOnSelected: true,
                                                isDisabled: true,
                                                readonlyTemplate: (value) => value
                                                    ? new DatePipe('en-US').transform(value, 'dd/MM/yyyy') ?? '--'
                                                    : '--',
                                            },
                                            validations: [Validators.required],
                                        },
                                        {
                                            key: 'end_date',
                                            type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                                            customClasses: 'w-[calc(50%-4px)]',
                                            context: {
                                                label: translation.end_date,
                                                fullWidth: true,
                                                isRequired: true,
                                                closeOnSelected: true,
                                                readonlyTemplate: (value) => value
                                                    ? new DatePipe('en-US').transform(value, 'dd/MM/yyyy') ?? '--'
                                                    : '--',
                                            },
                                            validations: [Validators.required],
                                        },
                                    ],
                                },
                                {
                                    customClasses: 'flex w-full gap-[8px]',
                                    fields: [
                                        {
                                            key: 'max_loan_to_value',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            customClasses: 'w-full',
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                fullWidth: true,
                                                isRequired: true,
                                                isDisabled: true,
                                                label: translation.max_loan_to_value,
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                            validations: [Validators.required],
                                        },
                                    ],
                                },
                                {
                                    customClasses: 'flex w-full gap-[8px]',
                                    fields: [
                                        {
                                            key: 'minimum_day_to_disburse',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            customClasses: 'w-full',
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                fullWidth: true,
                                                isRequired: true,
                                                isDisabled: true,
                                                label: translation.minimum_day_to_disburse,
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                            validations: [Validators.required],
                                        },
                                    ],
                                },
                                {
                                    customClasses: 'flex w-full gap-[8px] items-end',
                                    fields: [
                                        {
                                            key: 'admin_fee',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            customClasses: 'w-[calc(50%-4px)]',
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                fullWidth: true,
                                                isRequired: true,
                                                isDisabled: true,
                                                label: translation.admin_fee,
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                            validations: [Validators.required],
                                        },
                                        {
                                            key: 'admin_fee_period',
                                            type: FSWDynamicBuilderControlTypes.SELECT,
                                            customClasses: 'w-[calc(50%-4px)]',
                                            context: {
                                                fullWidth: true,
                                                isRequired: true,
                                                isDisabled: true,
                                                label: translation.admin_fee_period,
                                                items: commonFeePeriodList,
                                                readonlyTemplate: (value) => {
                                                    const text = commonFeePeriodList.find((item) => item.value === value)?.text;
                                                    return text ?? 'N/A';
                                                },
                                            },
                                            validations: [Validators.required],
                                        },
                                    ],
                                },
                                {
                                    customClasses: 'flex w-full gap-[8px] items-end',
                                    fields: [
                                        {
                                            key: 'interest_rate',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            customClasses: 'w-[calc(50%-4px)]',
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                fullWidth: true,
                                                isRequired: true,
                                                label: translation.interest_rate,
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                            validations: [Validators.required],
                                        },
                                        {
                                            key: 'interest_rate_type',
                                            type: FSWDynamicBuilderControlTypes.SELECT,
                                            customClasses: 'w-[calc(50%-4px)]',
                                            context: {
                                                fullWidth: true,
                                                isRequired: true,
                                                label: translation.interest_rate_type,
                                                items: commonFeePeriodList,
                                                readonlyTemplate: (value) => {
                                                    const text = commonFeePeriodList.find((item) => item.value === value)?.text;
                                                    return text ?? 'N/A';
                                                },
                                            },
                                            validations: [Validators.required],
                                        },
                                    ],
                                },
                                {
                                    customClasses: 'flex w-full gap-[8px] items-end',
                                    fields: [
                                        {
                                            key: 'discounting',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            customClasses: 'w-[calc(50%-4px)]',
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                fullWidth: true,
                                                isRequired: true,
                                                isDisabled: true,
                                                label: translation.discounting,
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                            validations: [Validators.required],
                                        },
                                        {
                                            key: 'discounting_type',
                                            type: FSWDynamicBuilderControlTypes.SELECT,
                                            customClasses: 'w-[calc(50%-4px)]',
                                            context: {
                                                fullWidth: true,
                                                isRequired: true,
                                                isDisabled: true,
                                                label: translation.discounting_type,
                                                items: discountingFeePeriodList,
                                                readonlyTemplate: (value) => {
                                                    const text = discountingFeePeriodList.find((item) => item.value === value)?.text;
                                                    return text ?? 'N/A';
                                                },
                                            },
                                            validations: [Validators.required],
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex flex-col gap-[16px] w-[calc(50%-8px)]',
                            containers: [
                                {
                                    customClasses: 'flex w-full gap-[8px]',
                                    fields: [
                                        {
                                            key: 'limit',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            customClasses: 'w-full',
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                fullWidth: true,
                                                isRequired: true,
                                                label: translation.limit,
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                            validations: [Validators.required],
                                        },
                                    ],
                                },
                                {
                                    customClasses: 'flex w-full gap-[8px]',
                                    fields: [
                                        {
                                            key: 'annual_fee',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            customClasses: 'w-full',
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                fullWidth: true,
                                                isRequired: true,
                                                label: translation.annual_fee,
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                            validations: [Validators.required],
                                        },
                                    ],
                                },
                                {
                                    customClasses: 'flex w-full gap-[8px]',
                                    fields: [
                                        {
                                            key: 'maximum_day_to_disburse',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            customClasses: 'w-full',
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                fullWidth: true,
                                                isRequired: true,
                                                label: translation.maximum_day_to_disburse,
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                            validations: [Validators.required],
                                        },
                                    ],
                                },
                                {
                                    customClasses: 'flex w-full gap-[8px] items-end',
                                    fields: [
                                        {
                                            key: 'facility_fee_value',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            customClasses: 'w-[calc(50%-4px)]',
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                fullWidth: true,
                                                isRequired: true,
                                                label: translation.facility_fee_value,
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                            validations: [Validators.required],
                                        },
                                        {
                                            key: 'facility_fee_period',
                                            type: FSWDynamicBuilderControlTypes.SELECT,
                                            customClasses: 'w-[calc(50%-4px)]',
                                            context: {
                                                fullWidth: true,
                                                isRequired: true,
                                                label: translation.facility_fee_period,
                                                items: commonFeePeriodList,
                                                readonlyTemplate: (value) => {
                                                    const text = commonFeePeriodList.find((item) => item.value === value)?.text;
                                                    return text ?? 'N/A';
                                                },
                                            },
                                            validations: [Validators.required],
                                        },
                                    ],
                                },
                                {
                                    customClasses: 'flex w-full gap-[8px] items-end',
                                    fields: [
                                        {
                                            key: 'late_interest_fee',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            customClasses: 'w-[calc(50%-4px)]',
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                fullWidth: true,
                                                isRequired: true,
                                                isDisabled: true,
                                                label: translation.late_interest_fee,
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                            validations: [Validators.required],
                                        },
                                        {
                                            key: 'late_interest_fee_type',
                                            type: FSWDynamicBuilderControlTypes.SELECT,
                                            customClasses: 'w-[calc(50%-4px)]',
                                            context: {
                                                fullWidth: true,
                                                isRequired: true,
                                                isDisabled: true,
                                                label: translation.late_interest_fee_type,
                                                items: lateInterestFeePeriodList,
                                                readonlyTemplate: (value) => {
                                                    const text = lateInterestFeePeriodList.find((item) => item.value === value)?.text;
                                                    return text ?? 'N/A';
                                                },
                                            },
                                            validations: [Validators.required],
                                        },
                                    ],
                                },
                                {
                                    customClasses: 'flex w-full gap-[8px] items-end',
                                    fields: [
                                        {
                                            key: 'late_fee',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            customClasses: 'w-full',
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                fullWidth: true,
                                                isRequired: true,
                                                isDisabled: true,
                                                label: translation.late_fee,
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                            validations: [Validators.required],
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            customClasses: 'flex w-full',
            fields: [
                {
                    key: 'id',
                    type: FSWDynamicBuilderControlTypes.TEMPLATE,
                    context: {
                        isHidden: true,
                    },
                },
            ],
        },
    ];
};

function injectFacilityALLEffects({ applicationIdSignal, builderSignal, isReadonlySignal, isTopUpSignal, settlementAmountSignal, entitySignal, proposalTypeSignal, bucketSignal, bucketsSignal, form, formArray, saveEvent, }) {
    //#region Injected Services
    const applicationMemberService = injectApplicationMemberService();
    const applicationFacilityTermsService = injectApplicationFacilityTermsService();
    const applicationProposalService = injectApplicationProposalService();
    const applicationGuarantorService = injectApplicationGuarantorService();
    const creditFacilityTermsService = injectCreditFacilityTermsService();
    const creditGuarantorService = injectCreditGuarantorService();
    const creditTestBucketService = injectCreditTestBucketService();
    const memberService = injectMemberService();
    const alertService = inject(FSW_ALERT_SERVICE_TOKEN);
    //#endregion Injected Services
    //#region Signals
    const memberSignal = signal(null);
    //#endregion Signals
    //#region Logics Functions
    const loadData = (applicationId, member) => {
        formArray.clear();
        applicationFacilityTermsService
            .getFacilityTerms(applicationId)
            .pipe(switchMap((id) => {
            if (id) {
                return creditFacilityTermsService
                    .getFacilityTermsById(id)
                    .pipe(switchMap((facility) => loadDataWithProposalAsync(applicationId, facility)));
            }
            return loadDataWithProposalAsync(applicationId);
        }), tapResponse(({ data, existed }) => {
            form.patchValue({
                ...data,
                loan_info: {
                    ...data.loan_info,
                    settlement_amount: settlementAmountSignal(),
                },
            });
            (data.conditions || []).forEach((item) => {
                formArray.push(generateConditionGroup(item));
            });
            if (existed) {
                saveEvent.emit();
            }
            if (!formArray.length) {
                setDefaultCondition(applicationId, member);
            }
        }, () => {
            if (!formArray.length) {
                setDefaultCondition(applicationId, member);
            }
        }))
            .subscribe();
    };
    const loadBuckets = () => {
        creditTestBucketService
            .getTestBuckets()
            .pipe(tap((buckets) => bucketsSignal.set(buckets)))
            .subscribe();
    };
    const loadBucket = (applicationId) => {
        getProposalAsync(applicationId)
            .pipe(filter((proposal) => !!proposal), switchMap((proposal) => applicationProposalService.getProposal(proposal.id)), tap((proposal) => bucketSignal.set(proposal.test_bucket)))
            .subscribe();
    };
    const setDefaultCondition = (applicationId, member) => {
        formArray.clear();
        if (proposalTypeSignal() === 'LOAN') {
            formArray.push(generateConditionGroup({
                condition: 'Successful activation of DD for deduction of repayment',
                checked: true,
            }));
        }
        getSummariesAsync(applicationId, member)
            .pipe(tap((data) => {
            const filterData = data.filter((item) => item.name);
            filterData.forEach((item) => {
                formArray.push(generateConditionGroup({
                    condition: `PG from ${item.name}`,
                    checked: true,
                }));
            });
        }))
            .subscribe();
    };
    const updateProposalAsync = (applicationId, payload) => getProposalAsync(applicationId).pipe(filter((proposal) => !!proposal), switchMap((proposal) => {
        return applicationProposalService.updateProposalRecommendations(proposal?.id, removeBadFalsyValueForObject({
            ...omit(payload.loan_info, [
                'principal',
                'early_repayment_fee',
                'early_repayment_fee_type',
            ]),
            loan_amount: payload.loan_info.principal,
        }));
    }), map(() => payload));
    const updateAsync = (applicationId, id, payload) => creditFacilityTermsService.updateFacilityTerms(id, removeBadFalsyValueForObject(payload)).pipe(switchMap((terms) => updateProposalAsync(applicationId, {
        ...terms,
        ...payload,
    })));
    const createAsync = (applicationId, payload) => creditFacilityTermsService.addFacilityTerms(removeBadFalsyValueForObject(payload)).pipe(switchMap((terms) => applicationFacilityTermsService.addFacilityTerm(applicationId, terms.id).pipe(switchMap(() => updateProposalAsync(applicationId, {
        ...terms,
        ...payload,
    })))));
    //#endregion Logics Functions
    //#region External Functions
    const getSummariesAsync = (applicationId, member) => applicationGuarantorService.getSummaries(applicationId).pipe(switchMap((summaries) => {
        const ids = summaries
            ?.filter((e) => e.guarantor_summary_type === FSWRecourseTypes.PG)
            .map((item) => item.guarantor_summary_id);
        if (ids?.length) {
            return creditGuarantorService.getPersonalSummaries(ids).pipe(map((data) => data.map((item) => {
                const bip = summaries.find((summary) => summary.guarantor_summary_id === item.id);
                if (bip?.business_interest_party_id) {
                    item.id_number = bip.business_interest_party_id;
                }
                return item;
            })), switchMap((summaries) => mapWithBips(applicationId, member, summaries)));
        }
        return of([]);
    }));
    const getProposalAsync = (applicationId) => applicationProposalService.getProposals(applicationId).pipe(map((proposals) => proposals.filter((proposal) => proposal.proposal_type === proposalTypeSignal())), map((proposals) => proposals.shift()), tap((proposal) => {
        if (!proposal) {
            alertService.error('Failed to load proposal', null, {
                duration: 3000,
            });
        }
    }));
    const loadDataWithProposalAsync = (applicationId, facility) => getProposalAsync(applicationId).pipe(filter((proposal) => !!proposal), map((proposal) => mapWithProposal(proposal, facility)));
    const loadMember = (applicationId) => applicationMemberService
        .getApplicationMainBorrower(applicationId)
        .pipe(tap((member) => memberSignal.set(member)), filter((member) => !!member), tap((member) => loadData(applicationId, member)), catchError(() => {
        alertService.error('Failed to load member', null, {
            duration: 3000,
        });
        memberSignal.set(null);
        return of(null);
    }))
        .subscribe();
    //#endregion External Functions
    //#region Map Functions
    const mapTerms = (recommendation, propose, facility) => {
        return {
            ...(facility?.loan_info || {}),
            principal: +Number(recommendation.loan_amount ?? propose.loan_amount ?? facility?.loan_info?.principal ?? '0').toFixed(2),
            disbursement_amount: +Number(recommendation.disbursement_amount ??
                propose.disbursement_amount ??
                facility?.loan_info?.disbursement_amount ??
                '0').toFixed(2),
            origination_fee: +Number(recommendation.origination_fee ??
                propose.origination_fee ??
                facility?.loan_info?.origination_fee ??
                '0').toFixed(2),
            guarantee_fee: +Number(recommendation.guarantee_fee ??
                propose.guarantee_fee ??
                facility?.loan_info?.guarantee_fee ??
                '0').toFixed(2),
            tenor: recommendation.tenor ?? propose.tenor ?? facility?.loan_info?.tenor,
            tenor_type: recommendation.tenor_type ?? propose.tenor_type ?? facility?.loan_info?.tenor_type,
            installment_type: recommendation.installment_types?.toString() ??
                propose.installment_types?.toString() ??
                facility?.loan_info?.installment_type,
            interest_rate: +Number(recommendation.interest_rate ??
                propose.interest_rate ??
                facility?.loan_info?.interest_rate ??
                '0').toFixed(2),
            interest_rate_type: recommendation.interest_type?.toString() ??
                propose.interest_type?.toString() ??
                facility?.loan_info?.interest_rate_type,
            late_interest_fee: +Number(recommendation.late_interest_fee ?? propose.late_interest_rate ?? '0').toFixed(2),
            late_interest_fee_type: recommendation.late_interest_fee_type?.toString() ?? propose.late_interest_type?.toString(),
            late_fee: +Number(recommendation.late_fee ?? propose.late_fee ?? '0').toFixed(2),
            late_fee_type: recommendation.late_fee_type?.toString() ?? propose.late_fee_type?.toString(),
        };
    };
    const mapRecommendation = (recommendation, propose, facility) => {
        const usePropose = !recommendation?.start_date ||
            recommendation?.start_date?.toString() === '0001-01-01T00:00:00Z';
        const dataObject = usePropose ? propose : recommendation;
        const facilityFeeValue = usePropose
            ? propose?.facility_fee
            : recommendation?.facility_fee_value;
        const interestRatePeriodValue = usePropose
            ? propose?.interest_term
            : recommendation?.interest_type;
        return {
            start_date: dataObject?.start_date?.toString() ?? facility?.loan_info?.start_date?.toString(),
            end_date: dataObject?.end_date?.toString() ?? facility?.loan_info?.end_date?.toString(),
            limit: +Number(dataObject?.limit ?? facility?.loan_info?.limit ?? '0').toFixed(2),
            max_loan_to_value: +Number(dataObject?.max_loan_to_value ?? facility?.loan_info?.max_loan_to_value ?? '0').toFixed(2),
            annual_fee: +Number(dataObject?.annual_fee ?? facility?.loan_info?.admin_fee ?? '0').toFixed(2),
            minimum_day_to_disburse: +Number(dataObject?.minimum_day_to_disburse ?? facility?.loan_info?.minimum_day_to_disburse ?? '0'),
            maximum_day_to_disburse: +Number(dataObject?.maximum_day_to_disburse ?? facility?.loan_info?.maximum_day_to_disburse ?? '0'),
            admin_fee: +Number(dataObject?.admin_fee ?? facility?.loan_info?.admin_fee ?? '0').toFixed(2),
            admin_fee_period: dataObject?.admin_fee_period?.toString() ??
                facility?.loan_info?.admin_fee_period?.toString(),
            facility_fee_value: +Number(facilityFeeValue ?? facility?.loan_info?.facility_fee_value ?? '0').toFixed(2),
            facility_fee_period: recommendation?.facility_fee_period?.toString() ??
                propose?.facility_fee_period?.toString() ??
                facility?.loan_info?.facility_fee_period?.toString(),
            interest_rate: +Number(dataObject?.interest_rate ?? facility?.loan_info?.interest_rate ?? '0').toFixed(2),
            interest_rate_type: interestRatePeriodValue?.toString() ?? facility?.loan_info?.interest_rate_type,
            late_interest_fee: +Number(dataObject?.late_interest_fee ?? facility?.loan_info?.late_interest_fee ?? '0').toFixed(2),
            late_interest_fee_type: dataObject?.late_interest_fee_type?.toString() ??
                facility?.loan_info?.late_interest_fee_type?.toString(),
            discounting: +Number(dataObject?.discounting ?? facility?.loan_info?.discounting ?? '0').toFixed(2),
            discounting_type: dataObject?.discounting_type?.toString() ??
                facility?.loan_info?.discounting_type?.toString(),
            late_fee: +Number(dataObject?.late_fee ?? facility?.loan_info?.late_fee ?? '0').toFixed(2),
            late_fee_type: dataObject?.late_fee_type?.toString() ?? facility?.loan_info?.late_fee_type?.toString(),
        };
    };
    const mapWithProposal = (proposal, facility) => {
        const proposalData = proposal?.data;
        const [recommendation, propose] = [
            proposalData?.recommendation || {},
            proposalData?.propose || {},
        ];
        const map = entitySignal() === 'terms' ? mapTerms : mapRecommendation;
        return {
            data: {
                ...(facility || {}),
                loan_info: map(recommendation, propose, facility),
                conditions: (facility?.conditions ?? []),
                collateral: facility?.collateral ?? '',
                controls: facility?.controls ?? '',
            },
            existed: !!facility,
        };
    };
    const mapWithBips = (applicationId, member, summaries) => memberService
        .getMergeBipNames(applicationId, member.uuid, {
        expand: true,
    }, member.company_registration_number)
        .pipe(map((bips) => {
        return summaries.map((summary) => {
            const bipSummary = bips?.find((bip) => bip.id == summary.id_number);
            if (bipSummary) {
                summary.name = bipSummary.name;
            }
            return summary;
        });
    }));
    //#endregion Map Functions
    //#region Helper Functions
    const generateConditionGroup = (data) => {
        return new UntypedFormGroup({
            condition: new UntypedFormControl(data.condition),
            checked: new UntypedFormControl(data.checked),
        });
    };
    const refresh = (cb) => {
        const applicationId = applicationIdSignal();
        if (!applicationId) {
            return;
        }
        cb(applicationId);
    };
    //#endregion Helper Functions
    return {
        init: () => {
            builderSignal.set(injectFacilityALLForm({
                isReadonly: isReadonlySignal(),
                isTopUp: isTopUpSignal(),
                entity: entitySignal(),
                form,
            }));
            refresh((applicationId) => {
                loadMember(applicationId);
                if (proposalTypeSignal() === 'LOAN') {
                    loadBuckets();
                    loadBucket(applicationId);
                }
            });
        },
        save: () => {
            const conditions = formArray.value.filter((item) => !!item?.condition?.length);
            const formValue = form.getRawValue();
            if (proposalTypeSignal() === 'FACILITY') {
                formValue.loan_info = {
                    ...formValue.loan_info,
                    interest_type: formValue.loan_info.interest_rate_type,
                };
            }
            const payload = {
                ...formValue,
                conditions,
                collateral: formValue.collateral || '',
                controls: formValue.controls || '',
            };
            const { id, ...facility } = payload;
            refresh((applicationId) => {
                const obs$ = id
                    ? updateAsync(applicationId, id, facility)
                    : createAsync(applicationId, facility);
                obs$
                    .pipe(tapResponse((res) => {
                    saveEvent.emit(res);
                    loadData(applicationId, memberSignal());
                    alertService.success('Notification', 'Facility saved successfully!', {
                        duration: 3000,
                    });
                }, (err) => {
                    console.error(err);
                    alertService.error('Something went wrong', 'Facility failed to save!', {
                        duration: 3000,
                    });
                }))
                    .subscribe();
            });
        },
        assignBucket: (bucket) => {
            if (proposalTypeSignal() !== 'LOAN') {
                return;
            }
            refresh((applicationId) => {
                getProposalAsync(applicationId)
                    .pipe(filter((proposal) => !!proposal), switchMap((proposal) => applicationProposalService.assignTestBucket(proposal.id, bucket)), tap(() => {
                    alertService.success('Success', 'Assigned successfully!', {
                        duration: 3000,
                    });
                    loadBucket(applicationId);
                }))
                    .subscribe();
            });
        },
        addNewCondition: () => {
            formArray.push(generateConditionGroup({
                condition: '',
                checked: true,
            }));
        },
        removeCondition: (index) => {
            formArray.removeAt(index);
        },
    };
}

class FSWFacilityConditionsComponent {
    constructor() {
        this.addEvent = new EventEmitter();
        this.saveEvent = new EventEmitter();
        this.deleteEvent = new EventEmitter();
        this.formArray = new UntypedFormArray([]);
        this.isReadonly = false;
        this.addLabel = '';
        this.saveLabel = '';
        this.showSaveButton = false;
        this.conditionLabel = '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFacilityConditionsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWFacilityConditionsComponent, isStandalone: true, selector: "fsw-facility-conditions", inputs: { formArray: "formArray", isReadonly: "isReadonly", addLabel: "addLabel", saveLabel: "saveLabel", showSaveButton: "showSaveButton", conditionLabel: "conditionLabel" }, outputs: { addEvent: "addEvent", saveEvent: "saveEvent", deleteEvent: "deleteEvent" }, ngImport: i0, template: "<table class=\"fsw-table w-full\" *ngIf=\"formArray.valueChanges | async\">\n  <thead>\n    <tr>\n      <th colspan=\"10\" class=\"p-4\">\n        {{ conditionLabel }}\n      </th>\n    </tr>\n  </thead>\n  <tbody>\n    <ng-container *ngFor=\"let formGroup of formArray.controls; let i = index\">\n      <tr [formGroup]=\"formGroup | fswForceGroup\">\n        <td>\n          {{ i + 1 }}\n        </td>\n        <td colspan=\"8\">\n          <fsw-field [readOnly]=\"isReadonly\" [fullWidth]=\"true\">\n            <input fswInput type=\"text\" formControlName=\"condition\" />\n          </fsw-field>\n        </td>\n        <td [width]=\"56\">\n          <i\n            *ngIf=\"!isReadonly\"\n            (click)=\"deleteEvent.emit(i)\"\n            [fswIcon]=\"'common-delete-alternative'\"\n          ></i>\n        </td>\n      </tr>\n    </ng-container>\n  </tbody>\n  <tfoot>\n    <tr>\n      <td colspan=\"10\" class=\"p-4\">\n        <div class=\"flex justify-between\">\n          <button\n            type=\"button\"\n            [disabled]=\"isReadonly\"\n            fswButton\n            (click)=\"!isReadonly && addEvent.emit()\"\n          >\n            {{ addLabel }}\n          </button>\n\n          <button\n            *ngIf=\"showSaveButton\"\n            type=\"button\"\n            [disabled]=\"isReadonly\"\n            fswButton\n            (click)=\"!isReadonly && saveEvent.emit()\"\n          >\n            {{ saveLabel }}\n          </button>\n        </div>\n      </td>\n    </tr>\n  </tfoot>\n</table>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "ngmodule", type: ForceGroupPipeModule }, { kind: "pipe", type: i1$4.FSWForceGroupPipe, name: "fswForceGroup" }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "ngmodule", type: FSWFieldModule }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "ngmodule", type: FSWInputModule }, { kind: "directive", type: i1$4.FSWInputDirective, selector: "input[fswInput], textarea[fswInput]" }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "pipe", type: AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFacilityConditionsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-facility-conditions', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [
                        NgIf,
                        ReactiveFormsModule,
                        ForceGroupPipeModule,
                        NgForOf,
                        FSWFieldModule,
                        FSWInputModule,
                        FSWIconModule,
                        FSWButtonModule,
                        AsyncPipe,
                    ], template: "<table class=\"fsw-table w-full\" *ngIf=\"formArray.valueChanges | async\">\n  <thead>\n    <tr>\n      <th colspan=\"10\" class=\"p-4\">\n        {{ conditionLabel }}\n      </th>\n    </tr>\n  </thead>\n  <tbody>\n    <ng-container *ngFor=\"let formGroup of formArray.controls; let i = index\">\n      <tr [formGroup]=\"formGroup | fswForceGroup\">\n        <td>\n          {{ i + 1 }}\n        </td>\n        <td colspan=\"8\">\n          <fsw-field [readOnly]=\"isReadonly\" [fullWidth]=\"true\">\n            <input fswInput type=\"text\" formControlName=\"condition\" />\n          </fsw-field>\n        </td>\n        <td [width]=\"56\">\n          <i\n            *ngIf=\"!isReadonly\"\n            (click)=\"deleteEvent.emit(i)\"\n            [fswIcon]=\"'common-delete-alternative'\"\n          ></i>\n        </td>\n      </tr>\n    </ng-container>\n  </tbody>\n  <tfoot>\n    <tr>\n      <td colspan=\"10\" class=\"p-4\">\n        <div class=\"flex justify-between\">\n          <button\n            type=\"button\"\n            [disabled]=\"isReadonly\"\n            fswButton\n            (click)=\"!isReadonly && addEvent.emit()\"\n          >\n            {{ addLabel }}\n          </button>\n\n          <button\n            *ngIf=\"showSaveButton\"\n            type=\"button\"\n            [disabled]=\"isReadonly\"\n            fswButton\n            (click)=\"!isReadonly && saveEvent.emit()\"\n          >\n            {{ saveLabel }}\n          </button>\n        </div>\n      </td>\n    </tr>\n  </tfoot>\n</table>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { addEvent: [{
                type: Output
            }], saveEvent: [{
                type: Output
            }], deleteEvent: [{
                type: Output
            }], formArray: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], addLabel: [{
                type: Input
            }], saveLabel: [{
                type: Input
            }], showSaveButton: [{
                type: Input
            }], conditionLabel: [{
                type: Input
            }] } });

function facilityTranslation(scope = 'facility') {
    return [
        ...(FSWTranslateModule.forFeature({
            scope,
            defaultKey: getCountryCodeFromStorage(),
            data: {
                [CountryCode.MY]: FACILITY_ALL_TRANSLATION,
                [CountryCode.SG]: FACILITY_ALL_TRANSLATION,
                [CountryCode.TH]: FACILITY_ALL_TRANSLATION,
                [CountryCode.VU]: FACILITY_ALL_TRANSLATION,
                [CountryCode.ID]: FACILITY_ALL_TRANSLATION,
            },
        }).providers || []),
        fswTranslateScope(scope),
    ];
}

let FSWFacilityTestBucketComponent = class FSWFacilityTestBucketComponent {
    constructor() {
        this.saveEvent = new EventEmitter();
        this.isReadonly = false;
        this.buckets = [];
        this.formControl = new UntypedFormControl(null);
    }
    set bucket(value) {
        this.formControl.setValue(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFacilityTestBucketComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWFacilityTestBucketComponent, isStandalone: true, selector: "fsw-facility-test-bucket", inputs: { isReadonly: "isReadonly", buckets: "buckets", bucket: "bucket" }, outputs: { saveEvent: "saveEvent" }, providers: [facilityTranslation('facility_test_bucket')], ngImport: i0, template: "<fsw-panel [title]=\"'test_bucket.title' | fswTranslate : { scope: 'facility_test_bucket' }\">\n  <section class=\"flex flex-col gap-4\">\n    <fsw-field [readOnly]=\"isReadonly\">\n      <fsw-select\n        [maxHeight]=\"'200px'\"\n        [placeHolder]=\"'test_bucket.title' | fswTranslate : { scope: 'facility_test_bucket' }\"\n        [formControl]=\"formControl\"\n      >\n        <ng-container *ngFor=\"let bucket of buckets\">\n          <ng-template\n            fswSelectItem\n            [text]=\"bucket.name\"\n            [value]=\"bucket.name\"\n            [icon]=\"'checkbox'\"\n          ></ng-template>\n        </ng-container>\n      </fsw-select>\n    </fsw-field>\n    <button fswButton (click)=\"saveEvent.emit(formControl.value)\" *ngIf=\"!isReadonly\">\n      {{ 'buttons.assign' | fswTranslate : { scope: 'facility_test_bucket' } }}\n    </button>\n  </section>\n</fsw-panel>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "ngmodule", type: FSWFieldModule }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "ngmodule", type: FSWSelectModule }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
};
FSWFacilityTestBucketComponent = __decorate([
    autoDestroy()
], FSWFacilityTestBucketComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFacilityTestBucketComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-facility-test-bucket', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [facilityTranslation('facility_test_bucket')], imports: [
                        FSWPanelModule,
                        FSWFieldModule,
                        FSWSelectModule,
                        ReactiveFormsModule,
                        FSWTranslateModule,
                        NgForOf,
                        FSWButtonModule,
                        NgIf,
                    ], template: "<fsw-panel [title]=\"'test_bucket.title' | fswTranslate : { scope: 'facility_test_bucket' }\">\n  <section class=\"flex flex-col gap-4\">\n    <fsw-field [readOnly]=\"isReadonly\">\n      <fsw-select\n        [maxHeight]=\"'200px'\"\n        [placeHolder]=\"'test_bucket.title' | fswTranslate : { scope: 'facility_test_bucket' }\"\n        [formControl]=\"formControl\"\n      >\n        <ng-container *ngFor=\"let bucket of buckets\">\n          <ng-template\n            fswSelectItem\n            [text]=\"bucket.name\"\n            [value]=\"bucket.name\"\n            [icon]=\"'checkbox'\"\n          ></ng-template>\n        </ng-container>\n      </fsw-select>\n    </fsw-field>\n    <button fswButton (click)=\"saveEvent.emit(formControl.value)\" *ngIf=\"!isReadonly\">\n      {{ 'buttons.assign' | fswTranslate : { scope: 'facility_test_bucket' } }}\n    </button>\n  </section>\n</fsw-panel>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { saveEvent: [{
                type: Output
            }], isReadonly: [{
                type: Input
            }], buckets: [{
                type: Input
            }], bucket: [{
                type: Input
            }] } });

function injectFacilityEffects(config) {
    switch (getCountryCodeFromStorage()) {
        default:
            return injectFacilityALLEffects(config);
    }
}

class FSWFacilityComponent {
    constructor() {
        this.saveEvent = new EventEmitter();
        this.hideLoanInfo = false;
        this.applicationIdSignal = signal(null);
        this.isReadonlySignal = signal(false);
        this.isTopUpSignal = signal(false);
        this.settlementAmountSignal = signal(0);
        this.proposalTypeSignal = signal('LOAN');
        this.entitySignal = computed(() => this.proposalTypeSignal() === 'FACILITY' ? 'recommendation' : 'terms');
        this.bucketSignal = signal(null);
        this.bucketsSignal = signal([]);
        this.builderSignal = signal(null);
        this.titleSignal = computed(() => `entity.${this.entitySignal()}.title`);
        this.form = new UntypedFormGroup({});
        this.formArray = new UntypedFormArray([]);
        this.effects = injectFacilityEffects({
            saveEvent: this.saveEvent,
            form: this.form,
            formArray: this.formArray,
            applicationIdSignal: this.applicationIdSignal,
            isReadonlySignal: this.isReadonlySignal,
            isTopUpSignal: this.isTopUpSignal,
            settlementAmountSignal: this.settlementAmountSignal,
            entitySignal: this.entitySignal,
            proposalTypeSignal: this.proposalTypeSignal,
            bucketSignal: this.bucketSignal,
            bucketsSignal: this.bucketsSignal,
            builderSignal: this.builderSignal,
        });
    }
    set applicationId(applicationId) {
        this.applicationIdSignal.set(applicationId);
    }
    set isReadonly(isReadonly) {
        this.isReadonlySignal.set(isReadonly);
    }
    set isTopUp(isTopUp) {
        this.isTopUpSignal.set(isTopUp);
    }
    set settlementAmount(settlementAmount) {
        this.settlementAmountSignal.set(settlementAmount);
    }
    set proposalType(proposalType) {
        this.proposalTypeSignal.set(proposalType);
    }
    ngOnInit() {
        this.effects.init();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFacilityComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWFacilityComponent, isStandalone: true, selector: "fsw-facility", inputs: { applicationId: "applicationId", isReadonly: "isReadonly", isTopUp: "isTopUp", settlementAmount: "settlementAmount", proposalType: "proposalType", hideLoanInfo: "hideLoanInfo" }, outputs: { saveEvent: "saveEvent" }, providers: [
            facilityTranslation(),
            provideUtilsService(),
            provideApplicationMemberService(),
            provideApplicationFacilityTermsService(),
            provideCreditFacilityTermsService(),
            provideApplicationProposalService(),
            provideCreditTestBucketService(),
            provideApplicationGuarantorService(),
            provideCreditGuarantorService(),
            provideMemberService(),
        ], ngImport: i0, template: "<fsw-panel\n  [title]=\"titleSignal() | fswTranslate : { scope: 'facility' }\"\n  *ngIf=\"!hideLoanInfo; else formTemplate\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <button *ngIf=\"!isReadonlySignal()\" fswButton (click)=\"effects.save()\">\n      {{ 'buttons.save' | fswTranslate : { scope: 'facility' } }}\n    </button>\n  </ng-template>\n\n  <ng-container *ngTemplateOutlet=\"formTemplate\" />\n</fsw-panel>\n\n<ng-template #formTemplate>\n  <form [formGroup]=\"form\">\n    <section class=\"flex flex-col gap-[16px]\">\n      <fsw-dynamic-builder *ngIf=\"!hideLoanInfo\" [builder]=\"builderSignal()\" />\n      <fsw-facility-conditions\n        [formArray]=\"formArray\"\n        [isReadonly]=\"isReadonlySignal()\"\n        [addLabel]=\"'buttons.add' | fswTranslate : { scope: 'facility' }\"\n        [saveLabel]=\"'buttons.save' | fswTranslate : { scope: 'facility' }\"\n        [conditionLabel]=\"'condition.title' | fswTranslate : { scope: 'facility' }\"\n        [showSaveButton]=\"hideLoanInfo\"\n        (addEvent)=\"effects.addNewCondition()\"\n        (saveEvent)=\"effects.save()\"\n        (deleteEvent)=\"effects.removeCondition($event)\"\n      ></fsw-facility-conditions>\n      <fsw-facility-test-bucket\n        *ngIf=\"proposalTypeSignal() === 'LOAN'\"\n        [isReadonly]=\"isReadonlySignal()\"\n        [bucket]=\"bucketSignal()\"\n        [buckets]=\"bucketsSignal()\"\n        (saveEvent)=\"effects.assignBucket($event)\"\n      ></fsw-facility-test-bucket>\n    </section>\n  </form>\n</ng-template>\n", dependencies: [{ kind: "ngmodule", type: FSWAlertModule }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: FSWDynamicBuilderModule }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: FSWFacilityConditionsComponent, selector: "fsw-facility-conditions", inputs: ["formArray", "isReadonly", "addLabel", "saveLabel", "showSaveButton", "conditionLabel"], outputs: ["addEvent", "saveEvent", "deleteEvent"] }, { kind: "component", type: FSWFacilityTestBucketComponent, selector: "fsw-facility-test-bucket", inputs: ["isReadonly", "buckets", "bucket"], outputs: ["saveEvent"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFacilityComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-facility', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [
                        FSWAlertModule,
                        AsyncPipe,
                        FSWButtonModule,
                        FSWDynamicBuilderModule,
                        FSWPanelModule,
                        FSWTranslateModule,
                        NgIf,
                        NgTemplateOutlet,
                        ReactiveFormsModule,
                        FSWFacilityConditionsComponent,
                        FSWFacilityTestBucketComponent,
                    ], providers: [
                        facilityTranslation(),
                        provideUtilsService(),
                        provideApplicationMemberService(),
                        provideApplicationFacilityTermsService(),
                        provideCreditFacilityTermsService(),
                        provideApplicationProposalService(),
                        provideCreditTestBucketService(),
                        provideApplicationGuarantorService(),
                        provideCreditGuarantorService(),
                        provideMemberService(),
                    ], template: "<fsw-panel\n  [title]=\"titleSignal() | fswTranslate : { scope: 'facility' }\"\n  *ngIf=\"!hideLoanInfo; else formTemplate\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <button *ngIf=\"!isReadonlySignal()\" fswButton (click)=\"effects.save()\">\n      {{ 'buttons.save' | fswTranslate : { scope: 'facility' } }}\n    </button>\n  </ng-template>\n\n  <ng-container *ngTemplateOutlet=\"formTemplate\" />\n</fsw-panel>\n\n<ng-template #formTemplate>\n  <form [formGroup]=\"form\">\n    <section class=\"flex flex-col gap-[16px]\">\n      <fsw-dynamic-builder *ngIf=\"!hideLoanInfo\" [builder]=\"builderSignal()\" />\n      <fsw-facility-conditions\n        [formArray]=\"formArray\"\n        [isReadonly]=\"isReadonlySignal()\"\n        [addLabel]=\"'buttons.add' | fswTranslate : { scope: 'facility' }\"\n        [saveLabel]=\"'buttons.save' | fswTranslate : { scope: 'facility' }\"\n        [conditionLabel]=\"'condition.title' | fswTranslate : { scope: 'facility' }\"\n        [showSaveButton]=\"hideLoanInfo\"\n        (addEvent)=\"effects.addNewCondition()\"\n        (saveEvent)=\"effects.save()\"\n        (deleteEvent)=\"effects.removeCondition($event)\"\n      ></fsw-facility-conditions>\n      <fsw-facility-test-bucket\n        *ngIf=\"proposalTypeSignal() === 'LOAN'\"\n        [isReadonly]=\"isReadonlySignal()\"\n        [bucket]=\"bucketSignal()\"\n        [buckets]=\"bucketsSignal()\"\n        (saveEvent)=\"effects.assignBucket($event)\"\n      ></fsw-facility-test-bucket>\n    </section>\n  </form>\n</ng-template>\n" }]
        }], propDecorators: { saveEvent: [{
                type: Output
            }], applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], isTopUp: [{
                type: Input
            }], settlementAmount: [{
                type: Input
            }], proposalType: [{
                type: Input
            }], hideLoanInfo: [{
                type: Input
            }] } });

var title$q = "Repayment Schedule";
var blocks = {
	calculator: {
		title: "Installment Calculator",
		fields: {
			amount: "Principal",
			disbursement_amount: "Disbursement Amount",
			settlement_amount: "Settlement Amount",
			origination_fee: "Origination Fee",
			guarantee_fee: "Guarantee Fee",
			interest_rate: "Interest Rate %",
			interest_type: "Interest Type",
			tenor: "Tenor",
			tenor_type: "Tenor Type",
			installment_type: "Installment Type"
		}
	},
	grid: {
		title: "Repayment Schedule",
		fields: {
			total_amount: "Total Amount",
			eir: "E.I.R.P.A.",
			installment_number: "No.",
			principal: "Principal",
			interest: "Interest",
			total: "Total",
			balance: "Balance"
		}
	}
};
var buttons$F = {
	save: "Save",
	calculate: "Calculate Installments"
};
var repaymentScheduleAll = {
	title: title$q,
	blocks: blocks,
	buttons: buttons$F
};

var ALL$8 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    blocks: blocks,
    buttons: buttons$F,
    default: repaymentScheduleAll,
    title: title$q
});

const REPAYMENT_SCHEDULE_ALL_TRANSLATION = ALL$8;

const injectRepaymentScheduleALLForm = ({ isEditable$, isReadonly$, isTopUp, infoForm, gridForm, calculatorForm, }) => {
    const translation = REPAYMENT_SCHEDULE_ALL_TRANSLATION;
    return {
        gridBuilder: new FSWDynamicBuilder({
            formType: FSWDynamicBuilderFormTypes.TABLE,
            form: gridForm,
            header: [
                {
                    columns: [
                        {
                            label: 'No',
                            customClasses: 'p-4',
                        },
                        {
                            label: translation.blocks.grid.fields.principal,
                            customClasses: 'p-4',
                            width: 100,
                        },
                        {
                            label: translation.blocks.grid.fields.interest,
                            customClasses: 'p-4',
                            width: 100,
                        },
                        {
                            label: translation.blocks.grid.fields.total,
                            customClasses: 'p-4',
                        },
                        {
                            label: translation.blocks.grid.fields.balance,
                            customClasses: 'p-4',
                        },
                    ],
                },
            ],
            items: [
                {
                    body: {
                        key: 'rows',
                        isLoop: true,
                        readonlyWhen$: isReadonly$,
                        data: {
                            columns: [
                                {
                                    columnType: 'control',
                                    customClasses: 'p-4',
                                    fields: [
                                        {
                                            key: 'installment_number',
                                            type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                            context: {
                                                templateKey: 'no',
                                                flexWidth: true,
                                                prefix: 'amount_prefix',
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    customClasses: 'p-4',
                                    fields: [
                                        {
                                            key: 'principal',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            readonlyWhen$: isEditable$.pipe(map((editable) => !editable)),
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                flexWidth: true,
                                                prefix: 'amount_prefix',
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    customClasses: 'p-4',
                                    fields: [
                                        {
                                            key: 'interest',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            readonlyWhen$: isEditable$.pipe(map((editable) => !editable)),
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                flexWidth: true,
                                                prefix: 'amount_prefix',
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    customClasses: 'p-4',
                                    fields: [
                                        {
                                            key: 'total',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                isReadonly: true,
                                                flexWidth: true,
                                                prefix: 'amount_prefix',
                                                readonlyTemplate: (value) => new Intl.NumberFormat('en-US', {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                }).format(value) ?? 'N/A',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    customClasses: 'p-4',
                                    fields: [
                                        {
                                            key: 'balance',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                isReadonly: true,
                                                flexWidth: true,
                                                prefix: 'amount_prefix',
                                                readonlyTemplate: (value) => new Intl.NumberFormat('en-US', {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                }).format(value) ?? 'N/A',
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                },
            ],
            footer: [
                {
                    key: 'total',
                    columns: [
                        {
                            columnType: 'template',
                            template: 'total_label',
                            width: 100,
                            customClasses: 'p-4',
                        },
                        {
                            columnType: 'control',
                            customClasses: 'p-4',
                            fields: [
                                {
                                    key: 'principal',
                                    type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                    context: {
                                        templateKey: 'control_readonly',
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            customClasses: 'p-4',
                            fields: [
                                {
                                    key: 'interest',
                                    type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                    context: {
                                        templateKey: 'control_readonly',
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            customClasses: 'p-4',
                            fields: [
                                {
                                    key: 'total',
                                    type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                    context: {
                                        templateKey: 'control_readonly',
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            customClasses: 'p-4',
                            fields: [
                                {
                                    key: 'balance',
                                    type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                    context: {
                                        templateKey: 'control_readonly',
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
            customClasses: 'w-max fsw-table min-w-full',
        }),
        calculatorBuilder: new FSWDynamicBuilder({
            formType: FSWDynamicBuilderFormTypes.GROUP,
            form: calculatorForm,
            readonlyWhen$: isReadonly$,
            customClasses: 'flex gap-4 flex-wrap',
            fields: [
                {
                    key: 'total_amount',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'flex-1',
                    context: {
                        // inputType: 'number',
                        mask: {
                            expression: 'separator.2',
                            config: {
                                thousandSeparator: ',',
                            },
                        },
                        prefix: 'amount_prefix',
                        label: translation.blocks.grid.fields.total_amount,
                        isDisabled: true,
                        fullWidth: true,
                        readonlyTemplate: (value) => value ?? 'N/A',
                    },
                },
                {
                    key: 'eir',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'flex-1',
                    context: {
                        // inputType: 'number',
                        mask: {
                            expression: 'separator.2',
                            config: {
                                thousandSeparator: ',',
                            },
                        },
                        label: translation.blocks.grid.fields.eir,
                        isDisabled: true,
                        fullWidth: true,
                        readonlyTemplate: (value) => value ?? 'N/A',
                    },
                },
            ],
        }),
        infoBuilder: new FSWDynamicBuilder({
            formType: FSWDynamicBuilderFormTypes.GROUP,
            form: infoForm,
            renderBy: 'container',
            readonlyWhen$: isReadonly$,
            customClasses: 'w-full flex flex-col gap-[16px]',
            containers: [
                {
                    customClasses: 'w-full flex flex-col gap-[16px]',
                    fields: isTopUp
                        ? [
                            {
                                key: 'amount',
                                type: FSWDynamicBuilderControlTypes.INPUT,
                                context: {
                                    // inputType: 'number',
                                    mask: {
                                        expression: 'separator.2',
                                        config: {
                                            thousandSeparator: ',',
                                        },
                                    },
                                    prefix: 'amount_prefix',
                                    label: translation.blocks.calculator.fields.amount,
                                    fullWidth: true,
                                    readonlyTemplate: (value) => {
                                        return value ?? 'N/A';
                                    },
                                    isDisabled: true,
                                },
                            },
                            {
                                key: 'settlement_amount',
                                type: FSWDynamicBuilderControlTypes.INPUT,
                                context: {
                                    // inputType: 'number',
                                    mask: {
                                        expression: 'separator.2',
                                        config: {
                                            thousandSeparator: ',',
                                        },
                                    },
                                    prefix: 'amount_prefix',
                                    label: translation.blocks.calculator.fields.settlement_amount,
                                    fullWidth: true,
                                    isDisabled: true,
                                    readonlyTemplate: (value) => {
                                        return value ?? 'N/A';
                                    },
                                },
                            },
                            {
                                key: 'disbursement_amount',
                                type: FSWDynamicBuilderControlTypes.INPUT,
                                context: {
                                    // inputType: 'number',
                                    mask: {
                                        expression: 'separator.2',
                                        config: {
                                            thousandSeparator: ',',
                                        },
                                    },
                                    prefix: 'amount_prefix',
                                    label: translation.blocks.calculator.fields.disbursement_amount,
                                    fullWidth: true,
                                    readonlyTemplate: (value) => {
                                        return value ?? 'N/A';
                                    },
                                },
                            },
                            {
                                key: 'origination_fee',
                                type: FSWDynamicBuilderControlTypes.INPUT,
                                context: {
                                    // inputType: 'number',
                                    mask: {
                                        expression: 'separator.2',
                                        config: {
                                            thousandSeparator: ',',
                                        },
                                    },
                                    prefix: 'amount_prefix',
                                    label: translation.blocks.calculator.fields.origination_fee,
                                    fullWidth: true,
                                    readonlyTemplate: (value) => {
                                        return value ?? 'N/A';
                                    },
                                },
                            },
                            {
                                key: 'guarantee_fee',
                                type: FSWDynamicBuilderControlTypes.INPUT,
                                context: {
                                    // inputType: 'number',
                                    mask: {
                                        expression: 'separator.2',
                                        config: {
                                            thousandSeparator: ',',
                                        },
                                    },
                                    prefix: 'amount_prefix',
                                    label: translation.blocks.calculator.fields.guarantee_fee,
                                    fullWidth: true,
                                    readonlyTemplate: (value) => {
                                        return value ?? 'N/A';
                                    },
                                },
                            },
                            {
                                key: 'interest_rate',
                                type: FSWDynamicBuilderControlTypes.INPUT,
                                context: {
                                    // inputType: 'number',
                                    mask: {
                                        expression: 'separator.2',
                                        config: {
                                            thousandSeparator: ',',
                                        },
                                    },
                                    suffix: '%',
                                    label: translation.blocks.calculator.fields.interest_rate,
                                    fullWidth: true,
                                    readonlyTemplate: (value) => value ?? 'N/A',
                                },
                            },
                            {
                                key: 'interest_type',
                                type: FSWDynamicBuilderControlTypes.SELECT,
                                context: {
                                    label: translation.blocks.calculator.fields.interest_type,
                                    items: interestTypes,
                                    fullWidth: true,
                                    readonlyTemplate: (value) => {
                                        const text = interestTypes.find((item) => item.value === value)?.text;
                                        return text ?? 'N/A';
                                    },
                                },
                            },
                        ]
                        : getCountryCodeFromStorage() === CountryCode.SG
                            ? [
                                {
                                    key: 'amount',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        // inputType: 'number',
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        prefix: 'amount_prefix',
                                        label: translation.blocks.calculator.fields.amount,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => {
                                            return value ?? 'N/A';
                                        },
                                        isDisabled: false,
                                    },
                                },
                                {
                                    key: 'interest_rate',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        // inputType: 'number',
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        suffix: '%',
                                        label: translation.blocks.calculator.fields.interest_rate,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => value ?? 'N/A',
                                    },
                                },
                                {
                                    key: 'interest_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    context: {
                                        label: translation.blocks.calculator.fields.interest_type,
                                        items: interestTypes,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => {
                                            const text = interestTypes.find((item) => item.value === value)?.text;
                                            return text ?? 'N/A';
                                        },
                                    },
                                },
                            ]
                            : [
                                {
                                    key: 'amount',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        // inputType: 'number',
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        prefix: 'amount_prefix',
                                        label: translation.blocks.calculator.fields.amount,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => {
                                            return value ?? 'N/A';
                                        },
                                        isDisabled: true,
                                        afterCreated: (control, infoFormGroup) => {
                                            const disbursementAmountControl = infoFormGroup.get('disbursement_amount');
                                            const originationFeeControl = infoFormGroup.get('origination_fee');
                                            if (disbursementAmountControl && originationFeeControl) {
                                                combineLatest([
                                                    disbursementAmountControl?.valueChanges.pipe(startWith(disbursementAmountControl.value)),
                                                    originationFeeControl?.valueChanges.pipe(startWith(originationFeeControl.value)),
                                                ]).subscribe(([disbursementAmount, originationFee]) => {
                                                    const amount = Number(disbursementAmount) + Number(originationFee);
                                                    control.setValue(+amount.toFixed(2));
                                                });
                                            }
                                        },
                                    },
                                },
                                {
                                    key: 'disbursement_amount',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        // inputType: 'number',
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        prefix: 'amount_prefix',
                                        label: translation.blocks.calculator.fields.disbursement_amount,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => {
                                            return value ?? 'N/A';
                                        },
                                    },
                                },
                                {
                                    key: 'origination_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        // inputType: 'number',
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        prefix: 'amount_prefix',
                                        label: translation.blocks.calculator.fields.origination_fee,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => {
                                            return value ?? 'N/A';
                                        },
                                    },
                                },
                                {
                                    key: 'interest_rate',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        // inputType: 'number',
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        suffix: '%',
                                        label: translation.blocks.calculator.fields.interest_rate,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => value ?? 'N/A',
                                    },
                                },
                                {
                                    key: 'interest_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    context: {
                                        label: translation.blocks.calculator.fields.interest_type,
                                        items: interestTypes,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => {
                                            const text = interestTypes.find((item) => item.value === value)?.text;
                                            return text ?? 'N/A';
                                        },
                                    },
                                },
                            ],
                },
                {
                    customClasses: 'flex w-full gap-[8px] items-end',
                    fields: [
                        {
                            key: 'tenor',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            customClasses: 'w-[calc(50%-4px)]',
                            context: {
                                // inputType: 'number',
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.blocks.calculator.fields.tenor,
                                fullWidth: true,
                                readonlyTemplate: (value) => value ?? 'N/A',
                            },
                        },
                        {
                            key: 'tenor_type',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            customClasses: 'w-[calc(50%-4px)]',
                            context: {
                                label: translation.blocks.calculator.fields.tenor_type,
                                items: tenorTypes,
                                fullWidth: true,
                                readonlyTemplate: (value) => {
                                    const text = tenorTypes.find((item) => item.value === value)?.text;
                                    return text ?? 'N/A';
                                },
                            },
                        },
                    ],
                },
                {
                    customClasses: 'w-full',
                    fields: [
                        {
                            key: 'installment_type',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                label: translation.blocks.calculator.fields.installment_type,
                                items: installmentTypes,
                                fullWidth: true,
                                readonlyTemplate: (value) => {
                                    const text = installmentTypes.find((item) => item.value === value)?.text;
                                    return text ?? 'N/A';
                                },
                            },
                        },
                    ],
                },
            ],
        }),
    };
};

function calculateTotal(values) {
    return {
        principal: values.reduce((acc, cur) => Number((acc + (Number(cur.principal) || 0)).toFixed(2)), 0),
        interest: values.reduce((acc, cur) => Number((acc + (Number(cur.interest) || 0)).toFixed(2)), 0),
        total: values.reduce((acc, cur) => Number((acc + (Number(cur.total) || 0)).toFixed(2)), 0),
        balance: Number(values[values.length - 1]?.balance) ?? 0,
    };
}

function injectRepaymentScheduleALLEffects({ saveEvent, isEditableSignal, isReadonlySignal, isTopUpSignal, gridBuilderSignal, infoBuilderSignal, calculatorBuilderSignal, applicationIdSignal, proposalTypeSignal, proposalIdSignal, settlementAmountSignal, }) {
    //#region Injected Services
    const loanService = injectLoanService();
    const applicationService = injectApplicationService();
    const applicationProposalService = injectApplicationProposalService();
    const applicationRepaymentScheduleService = injectApplicationRepaymentScheduleService();
    const creditRepaymentScheduleService = injectCreditRepaymentScheduleService();
    const alertService = inject(FSW_ALERT_SERVICE_TOKEN);
    //#endregion Injected Services
    //#region Variables
    const isEditable$ = toObservable(isEditableSignal);
    const isReadonly$ = toObservable(isReadonlySignal);
    const gridForm = new UntypedFormGroup({});
    const calculatorForm = new UntypedFormGroup({});
    const infoForm = new UntypedFormGroup({});
    const controls = {
        get distributionsFormArray() {
            return getControlFromGroup(gridForm, 'rows');
        },
        get distributionsTotalFormGroup() {
            return getControlFromGroup(gridForm, 'total');
        },
    };
    const eirSignal = signal(null);
    const distributionControlsSignal = signal([]);
    //#endregion Variables
    //#region Logics Functions
    const getRepaymentScheduleIdAsync = (applicationId) => getProposalIdAsync(applicationId).pipe(switchMap((id) => {
        return id ? applicationRepaymentScheduleService.getData(id) : of(null);
    }));
    const getScheduleDistributionsAsync = (applicationId) => getRepaymentScheduleIdAsync(applicationId).pipe(switchMap((id) => {
        const existed = !!id;
        return existed
            ? creditRepaymentScheduleService.getById(id).pipe(map((data) => ({
                data: data.details || [],
                existed,
            })))
            : of({
                data: [],
                existed,
            });
    }));
    const updateRecommendationAsync = (applicationId) => {
        const value = infoForm.getRawValue();
        return getProposalIdAsync(applicationId).pipe(switchMap((proposalId) => applicationProposalService.updateProposalRecommendations(proposalId, {
            installment_types: value.installment_type?.toString(),
            interest_rate: value.interest_rate,
            interest_type: value.interest_type?.toString(),
            loan_amount: value.amount,
            disbursement_amount: value.disbursement_amount,
            origination_fee: value.origination_fee,
            guarantee_fee: value.guarantee_fee,
            tenor: value.tenor?.toString(),
            tenor_type: value.tenor_type?.toString(),
        })));
    };
    const updateOfferAsync = (applicationId) => {
        const value = infoForm.getRawValue();
        return applicationService.getOfferData(applicationId).pipe(switchMap((res) => {
            if (isTopUpSignal()) {
                return applicationService.updateOfferData(applicationId, {
                    ...res?.offer,
                    amount: value.amount,
                    settlement_amount: value.settlement_amount,
                    disbursement_amount: value.disbursement_amount,
                    origination_fee: value.origination_fee,
                    guarantee_fee: value.guarantee_fee,
                    interest_rate: value.interest_rate,
                    interest_type: value.interest_type,
                    tenor: value.tenor,
                    tenor_type: value.tenor_type,
                });
            }
            return of(null);
        }));
    };
    const saveDistributionsAsync = (applicationId) => {
        const details = controls.distributionsFormArray.value.map((item) => ({
            installment_number: Number(item.installment_number),
            principal: Number(item.principal?.toFixed(2)),
            interest: Number(item.interest?.toFixed(2)),
            repayment_date: null,
        }));
        return getRepaymentScheduleIdAsync(applicationId).pipe(switchMap((id) => {
            const obs$ = id
                ? creditRepaymentScheduleService.update(id, {
                    effective_interest_rate: Number(eirSignal()),
                    details,
                })
                : creditRepaymentScheduleService
                    .create({
                    effective_interest_rate: Number(eirSignal()),
                    details,
                })
                    .pipe(switchMap((data) => zip(getProposalIdAsync(applicationId), of(data))), switchMap(([proposalId, data]) => {
                    return applicationRepaymentScheduleService
                        .addData(proposalId, data.id)
                        .pipe(map(() => data));
                }));
            return obs$.pipe(map((data) => data.details));
        }));
    };
    const assertTopUpAmount = () => {
        const value = infoForm.getRawValue();
        const calculatedAmount = +(Number(value.settlement_amount || 0) +
            Number(value.disbursement_amount || 0) +
            Number(value.origination_fee || 0) +
            Number(value.guarantee_fee || 0)).toFixed(2);
        return isTopUpSignal() && value.amount !== calculatedAmount;
    };
    const processDistributionsFormArray = (distributions) => {
        let balance = calculatorForm.get('total_amount')?.value || 0;
        const value = (distributions || []).map((distribution) => {
            const total = Number(distribution.principal?.toFixed(2)) + Number(distribution.interest?.toFixed(2));
            balance -= total;
            return {
                installment_number: Number(distribution.installment_number),
                principal: Number(distribution.principal?.toFixed(2)),
                interest: Number(distribution.interest?.toFixed(2)),
                total: Number(total?.toFixed(2)),
                balance: Number(balance?.toFixed(2)),
            };
        });
        controls.distributionsFormArray.patchValue(value);
    };
    const listenToLoanInfoChange = () => {
        infoForm.valueChanges
            .pipe(debounceTime(750), mergeMap(({ amount, tenor, tenor_type, interest_rate, interest_type }) => loanService
            .getCalculationEffectiveInterestRate({
            loan_amount: Number(amount),
            tenor_length_in_month: calculateTenorInMonth(Number(tenor), tenor_type),
            simple_interest_rate: calculateSimpleInterestRate(Number(interest_rate), interest_type),
        })
            .pipe(tap((eir) => {
            eirSignal.set(eir);
            calculatorForm.patchValue({
                eir: calculateEffectiveInterestRate(Number(eir), Number(tenor), tenor_type),
            });
        }))))
            .subscribe();
    };
    const listenToDistributionsChange = () => {
        const listener$ = controls.distributionsFormArray.valueChanges;
        listener$
            .pipe(filter((value) => !isEqual(value, distributionControlsSignal())), tap((value) => {
            distributionControlsSignal.set(value);
            let balance = calculatorForm.get('total_amount')?.value || 0;
            value.forEach((distribution, index) => {
                const control = controls.distributionsFormArray.controls[index];
                const total = (Number(distribution.principal?.toFixed(2)) || 0) +
                    (Number(distribution.interest?.toFixed(2)) || 0);
                balance -= total;
                distribution.total = Number(total?.toFixed(2));
                distribution.balance = Number(balance?.toFixed(2));
                control.patchValue({
                    balance: Number(balance?.toFixed(2)),
                    total: Number(total?.toFixed(2)),
                }, { emitEvent: false });
            });
            controls.distributionsTotalFormGroup.patchValue(calculateTotal(value));
        }))
            .subscribe();
    };
    const loadData = (applicationId) => {
        getProposalAsync(applicationId)
            .pipe(filter((proposal) => !!proposal), map((proposal) => mapFromProposal(proposal)), switchMap((reschedule) => {
            const { amount, disbursement_amount, origination_fee, guarantee_fee, tenor, tenor_type, interest_rate, interest_type, installment_type, } = reschedule;
            return forkJoin([
                getScheduleDistributionsAsync(applicationId).pipe(catchError(() => of([]))),
                loanService
                    .getCalculationEffectiveInterestRate({
                    loan_amount: Number(amount),
                    tenor_length_in_month: calculateTenorInMonth(Number(tenor), tenor_type),
                    simple_interest_rate: calculateSimpleInterestRate(Number(interest_rate), interest_type),
                })
                    .pipe(catchError(() => of(null))),
            ]).pipe(tap(([distributions, eir]) => {
                const { data, existed } = distributions;
                if (existed) {
                    saveEvent.emit();
                }
                eirSignal.set(eir);
                const effectiveInterestRate = calculateEffectiveInterestRate(Number(eir), tenor, tenor_type);
                infoForm.patchValue({
                    amount: Number(amount),
                    disbursement_amount: Number(disbursement_amount),
                    origination_fee: Number(origination_fee),
                    guarantee_fee: Number(guarantee_fee),
                    tenor_type,
                    tenor: Number(tenor),
                    installment_type,
                    interest_rate: Number(interest_rate),
                    interest_type,
                    settlement_amount: settlementAmountSignal(),
                });
                calculatorForm.patchValue({
                    total_amount: calculateTotalAmount(Number(amount), Number(interest_rate), interest_type, Number(tenor), tenor_type),
                    eir: effectiveInterestRate,
                });
                listenToLoanInfoChange();
                listenToDistributionsChange();
                processDistributionsFormArray(data);
            }));
        }))
            .subscribe();
    };
    //#endregion Logics Functions
    //#region External Functions
    const getProposalAsync = (applicationId) => applicationProposalService.getProposals(applicationId, { order_by: 'p.created_at DESC' }).pipe(map((proposals) => proposals.filter((proposal) => proposal.proposal_type === proposalTypeSignal() &&
        (proposalIdSignal() ? proposal.id === proposalIdSignal() : true))), map((proposals) => proposals.shift()), tap((proposal) => {
        if (!proposal) {
            alertService.error('Failed to load proposal', null, {
                duration: 3000,
            });
        }
    }));
    const getProposalIdAsync = (applicationId) => {
        return proposalIdSignal()
            ? of(proposalIdSignal())
            : getProposalAsync(applicationId).pipe(map((proposal) => proposal.id));
    };
    //#endregion External Functions
    //#region Helper Functions
    const refresh = (cb) => {
        const applicationId = applicationIdSignal();
        if (!applicationId) {
            return;
        }
        cb(applicationId);
    };
    //#endregion Helper Functions
    //#region Map Functions
    const mapFromProposal = ({ data }) => ({
        installment_type: Number(data.recommendation.installment_types?.toString() ||
            data.propose.installment_types?.toString() ||
            '0'),
        interest_rate: Number(data.recommendation.interest_rate?.toString() || data.propose.interest_rate?.toString() || '0'),
        interest_type: Number(data.recommendation.interest_type?.toString() || data.propose.interest_type?.toString() || '0'),
        amount: +Number(data.recommendation.loan_amount?.toString() || data.propose.loan_amount?.toString() || '0')?.toFixed(2),
        disbursement_amount: +Number(data.recommendation.disbursement_amount?.toString() ||
            data.propose.disbursement_amount?.toString() ||
            '0')?.toFixed(2),
        origination_fee: +Number(data.recommendation.origination_fee?.toString() ||
            data.propose.origination_fee?.toString() ||
            '0')?.toFixed(2),
        guarantee_fee: +Number(data.recommendation.guarantee_fee?.toString() || data.propose.guarantee_fee?.toString() || '0')?.toFixed(2),
        tenor: Number(data.recommendation.tenor?.toString() || data.propose.tenor?.toString() || '0'),
        tenor_type: Number(data.recommendation.tenor_type?.toString() || data.propose.tenor_type?.toString() || '0'),
    });
    //#endregion Map Functions
    //#region Builders
    const setupBuilders = (isTopUp = false) => {
        const { gridBuilder, calculatorBuilder, infoBuilder } = injectRepaymentScheduleALLForm({
            isEditable$,
            isReadonly$,
            isTopUp,
            gridForm,
            calculatorForm,
            infoForm,
        });
        gridBuilderSignal.set(gridBuilder);
        calculatorBuilderSignal.set(calculatorBuilder);
        infoBuilderSignal.set(infoBuilder);
    };
    effect(() => {
        const isTopUp = isTopUpSignal();
        untracked(() => setupBuilders(isTopUp));
    }, { allowSignalWrites: true });
    //#endregion Builders
    return {
        init: () => {
            refresh((applicationId) => loadData(applicationId));
        },
        toggleEdit: () => {
            isEditableSignal.set(!isEditableSignal());
        },
        calculation: () => {
            const value = infoForm.getRawValue();
            forkJoin([
                loanService
                    .getFormula('flat', {
                    ...value,
                    tenor_length: value.tenor,
                }, 'round')
                    .pipe(catchError(() => of([]))),
                loanService
                    .getCalculationEffectiveInterestRate({
                    loan_amount: Number(value.amount),
                    tenor_length_in_month: calculateTenorInMonth(Number(value.tenor), value.tenor_type),
                    simple_interest_rate: calculateSimpleInterestRate(Number(value.interest_rate), value.interest_type),
                })
                    .pipe(catchError(() => of(null))),
            ])
                .pipe(tap(([distributions, eir]) => {
                const effectiveInterestRate = calculateEffectiveInterestRate(Number(eir), Number(value.tenor), value.tenor_type);
                calculatorForm.patchValue({
                    total_amount: calculateTotalAmount(Number(value.amount), Number(value.interest_rate), value.interest_type, Number(value.tenor), value.tenor_type),
                    eir: effectiveInterestRate,
                }, { emitEvent: false });
                processDistributionsFormArray(distributions);
            }))
                .subscribe();
        },
        save: () => {
            refresh((applicationId) => {
                if (assertTopUpAmount()) {
                    alertService.error('Error', 'Fee(s) amount and Disbursement amount not tallied with Principal amount', {
                        duration: 2000,
                    });
                    return;
                }
                forkJoin([updateRecommendationAsync(applicationId), updateOfferAsync(applicationId)])
                    .pipe(switchMap(() => saveDistributionsAsync(applicationId)), tap(() => {
                    alertService.success('Success', 'Installment Calculator has been updated successfully', {
                        duration: 2000,
                    });
                    saveEvent.emit();
                }))
                    .subscribe();
            });
        },
    };
}

function repaymentScheduleTranslation(scope = 'repayment_schedule') {
    return [
        ...(FSWTranslateModule.forFeature({
            scope,
            defaultKey: getCountryCodeFromStorage(),
            data: {
                [CountryCode.MY]: REPAYMENT_SCHEDULE_ALL_TRANSLATION,
                [CountryCode.SG]: REPAYMENT_SCHEDULE_ALL_TRANSLATION,
                [CountryCode.TH]: REPAYMENT_SCHEDULE_ALL_TRANSLATION,
                [CountryCode.VU]: REPAYMENT_SCHEDULE_ALL_TRANSLATION,
                [CountryCode.ID]: REPAYMENT_SCHEDULE_ALL_TRANSLATION,
            },
        }).providers || []),
        fswTranslateScope(scope),
    ];
}

function injectRepaymentScheduleEffects(config) {
    switch (getCountryCodeFromStorage()) {
        default:
            return injectRepaymentScheduleALLEffects(config);
    }
}

class FSWRepaymentScheduleComponent {
    constructor() {
        this.saveEvent = new EventEmitter();
        this.applicationIdSignal = signal(null);
        this.proposalIdSignal = signal(null);
        this.isReadonlySignal = signal(false);
        this.isEditableSignal = signal(false);
        this.proposalTypeSignal = signal('LOAN');
        this.isTopUpSignal = signal(false);
        this.settlementAmountSignal = signal(0);
        this.infoBuilderSignal = signal(null);
        this.calculatorBuilderSignal = signal(null);
        this.gridBuilderSignal = signal(null);
        this.effects = injectRepaymentScheduleEffects({
            saveEvent: this.saveEvent,
            applicationIdSignal: this.applicationIdSignal,
            proposalIdSignal: this.proposalIdSignal,
            proposalTypeSignal: this.proposalTypeSignal,
            isTopUpSignal: this.isTopUpSignal,
            settlementAmountSignal: this.settlementAmountSignal,
            isReadonlySignal: this.isReadonlySignal,
            isEditableSignal: this.isEditableSignal,
            infoBuilderSignal: this.infoBuilderSignal,
            calculatorBuilderSignal: this.calculatorBuilderSignal,
            gridBuilderSignal: this.gridBuilderSignal,
        });
        this.currencyCode = getCurrentCountryConfig().currencySymbol;
    }
    set applicationId(applicationId) {
        this.applicationIdSignal.set(applicationId);
    }
    set proposalId(proposalId) {
        this.proposalIdSignal.set(proposalId);
    }
    set isReadonly(isReadonly) {
        this.isReadonlySignal.set(isReadonly);
    }
    set proposalType(proposalType) {
        this.proposalTypeSignal.set(proposalType);
    }
    set isTopUp(isTopUp) {
        this.isTopUpSignal.set(isTopUp);
    }
    set settlementAmount(settlementAmount) {
        this.settlementAmountSignal.set(settlementAmount);
    }
    ngOnInit() {
        this.effects.init();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRepaymentScheduleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWRepaymentScheduleComponent, isStandalone: true, selector: "fsw-repayment-schedule", inputs: { applicationId: "applicationId", proposalId: "proposalId", isReadonly: "isReadonly", proposalType: "proposalType", isTopUp: "isTopUp", settlementAmount: "settlementAmount" }, outputs: { saveEvent: "saveEvent" }, providers: [
            repaymentScheduleTranslation(),
            provideUtilsService(),
            provideLoanService(),
            provideApplicationProposalService(),
            provideApplicationRepaymentScheduleService(),
            provideCreditRepaymentScheduleService(),
            provideApplicationService(),
        ], ngImport: i0, template: "<fsw-panel [title]=\"'title' | fswTranslate : { scope: 'repayment_schedule' }\">\n  <ng-template fswPanelHeaderSuffix>\n    <button *ngIf=\"!isReadonlySignal()\" fswButton (click)=\"effects.save()\">\n      {{ 'buttons.save' | fswTranslate : { scope: 'repayment_schedule' } }}\n    </button>\n  </ng-template>\n  <section class=\"flex gap-[16px]\">\n    <fsw-panel\n      [title]=\"'blocks.calculator.title' | fswTranslate : { scope: 'repayment_schedule' }\"\n      class=\"w-[calc(50%-8px)]\"\n    >\n      <section class=\"flex flex-col gap-[16px]\">\n        <form *ngIf=\"infoBuilderSignal() as infoBuilder\" [formGroup]=\"infoBuilder.groupConfig.form\">\n          <fsw-dynamic-builder [builder]=\"infoBuilder\">\n            <ng-template fswDynamicBuilderTemplate key=\"amount_prefix\">\n              {{ currencyCode }}</ng-template\n            >\n          </fsw-dynamic-builder>\n        </form>\n        <footer *ngIf=\"!isReadonlySignal()\" class=\"w-full flex justify-end\">\n          <button fswButton (click)=\"effects.calculation()\">\n            {{ 'buttons.calculate' | fswTranslate : { scope: 'repayment_schedule' } }}\n          </button>\n        </footer>\n      </section>\n    </fsw-panel>\n    <fsw-panel\n      [title]=\"'blocks.grid.title' | fswTranslate : { scope: 'repayment_schedule' }\"\n      class=\"w-[calc(50%-8px)]\"\n    >\n      <ng-template fswPanelHeaderSuffix>\n        <i\n          *ngIf=\"!isReadonlySignal()\"\n          [fswIcon]=\"'common-edit-alternative'\"\n          (click)=\"effects.toggleEdit()\"\n        ></i>\n      </ng-template>\n      <section class=\"flex flex-col gap-[12px]\">\n        <form\n          *ngIf=\"calculatorBuilderSignal() as calculatorBuilder\"\n          [formGroup]=\"calculatorBuilder.groupConfig.form\"\n        >\n          <fsw-dynamic-builder [builder]=\"calculatorBuilder\">\n            <ng-template fswDynamicBuilderTemplate key=\"amount_prefix\">\n              {{ currencyCode }}</ng-template\n            >\n          </fsw-dynamic-builder>\n        </form>\n        <hr />\n        <section class=\"w-full overflow-auto px-[4px] max-h-[500px]\">\n          <form\n            *ngIf=\"gridBuilderSignal() as gridBuilder\"\n            [formGroup]=\"gridBuilder.groupConfig.form\"\n          >\n            <fsw-dynamic-builder [builder]=\"gridBuilder\">\n              <ng-template fswDynamicBuilderTemplate key=\"amount_prefix\">\n                {{ currencyCode }}</ng-template\n              >\n              <ng-template fswDynamicBuilderTemplate key=\"no\" let-index=\"index\">\n                {{ index + 1 }}\n              </ng-template>\n              <ng-template fswDynamicBuilderTemplate key=\"total_label\">\n                <span class=\"text-green-500 font-bold\">{{\n                  'blocks.grid.fields.total' | fswTranslate : { scope: 'repayment_schedule' }\n                }}</span>\n              </ng-template>\n              <ng-template fswDynamicBuilderTemplate key=\"control_readonly\" let-control=\"control\">\n                <span class=\"text-green-500 font-bold\"\n                  >{{ currencyCode }} {{ (control.value | number : '.2') ?? '0' }}</span\n                >\n              </ng-template>\n            </fsw-dynamic-builder>\n          </form>\n        </section>\n      </section>\n    </fsw-panel>\n  </section>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: FSWDynamicBuilderModule }, { kind: "directive", type: i1$4.FSWDynamicBuilderTemplateDirective, selector: "[fswDynamicBuilderTemplate]", inputs: ["key"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "pipe", type: DecimalPipe, name: "number" }, { kind: "ngmodule", type: FSWAlertModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRepaymentScheduleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-repayment-schedule', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [
                        FSWTranslateModule,
                        FSWButtonModule,
                        NgIf,
                        FSWPanelModule,
                        ReactiveFormsModule,
                        FSWDynamicBuilderModule,
                        FSWIconModule,
                        DecimalPipe,
                        FSWAlertModule,
                    ], providers: [
                        repaymentScheduleTranslation(),
                        provideUtilsService(),
                        provideLoanService(),
                        provideApplicationProposalService(),
                        provideApplicationRepaymentScheduleService(),
                        provideCreditRepaymentScheduleService(),
                        provideApplicationService(),
                    ], template: "<fsw-panel [title]=\"'title' | fswTranslate : { scope: 'repayment_schedule' }\">\n  <ng-template fswPanelHeaderSuffix>\n    <button *ngIf=\"!isReadonlySignal()\" fswButton (click)=\"effects.save()\">\n      {{ 'buttons.save' | fswTranslate : { scope: 'repayment_schedule' } }}\n    </button>\n  </ng-template>\n  <section class=\"flex gap-[16px]\">\n    <fsw-panel\n      [title]=\"'blocks.calculator.title' | fswTranslate : { scope: 'repayment_schedule' }\"\n      class=\"w-[calc(50%-8px)]\"\n    >\n      <section class=\"flex flex-col gap-[16px]\">\n        <form *ngIf=\"infoBuilderSignal() as infoBuilder\" [formGroup]=\"infoBuilder.groupConfig.form\">\n          <fsw-dynamic-builder [builder]=\"infoBuilder\">\n            <ng-template fswDynamicBuilderTemplate key=\"amount_prefix\">\n              {{ currencyCode }}</ng-template\n            >\n          </fsw-dynamic-builder>\n        </form>\n        <footer *ngIf=\"!isReadonlySignal()\" class=\"w-full flex justify-end\">\n          <button fswButton (click)=\"effects.calculation()\">\n            {{ 'buttons.calculate' | fswTranslate : { scope: 'repayment_schedule' } }}\n          </button>\n        </footer>\n      </section>\n    </fsw-panel>\n    <fsw-panel\n      [title]=\"'blocks.grid.title' | fswTranslate : { scope: 'repayment_schedule' }\"\n      class=\"w-[calc(50%-8px)]\"\n    >\n      <ng-template fswPanelHeaderSuffix>\n        <i\n          *ngIf=\"!isReadonlySignal()\"\n          [fswIcon]=\"'common-edit-alternative'\"\n          (click)=\"effects.toggleEdit()\"\n        ></i>\n      </ng-template>\n      <section class=\"flex flex-col gap-[12px]\">\n        <form\n          *ngIf=\"calculatorBuilderSignal() as calculatorBuilder\"\n          [formGroup]=\"calculatorBuilder.groupConfig.form\"\n        >\n          <fsw-dynamic-builder [builder]=\"calculatorBuilder\">\n            <ng-template fswDynamicBuilderTemplate key=\"amount_prefix\">\n              {{ currencyCode }}</ng-template\n            >\n          </fsw-dynamic-builder>\n        </form>\n        <hr />\n        <section class=\"w-full overflow-auto px-[4px] max-h-[500px]\">\n          <form\n            *ngIf=\"gridBuilderSignal() as gridBuilder\"\n            [formGroup]=\"gridBuilder.groupConfig.form\"\n          >\n            <fsw-dynamic-builder [builder]=\"gridBuilder\">\n              <ng-template fswDynamicBuilderTemplate key=\"amount_prefix\">\n                {{ currencyCode }}</ng-template\n              >\n              <ng-template fswDynamicBuilderTemplate key=\"no\" let-index=\"index\">\n                {{ index + 1 }}\n              </ng-template>\n              <ng-template fswDynamicBuilderTemplate key=\"total_label\">\n                <span class=\"text-green-500 font-bold\">{{\n                  'blocks.grid.fields.total' | fswTranslate : { scope: 'repayment_schedule' }\n                }}</span>\n              </ng-template>\n              <ng-template fswDynamicBuilderTemplate key=\"control_readonly\" let-control=\"control\">\n                <span class=\"text-green-500 font-bold\"\n                  >{{ currencyCode }} {{ (control.value | number : '.2') ?? '0' }}</span\n                >\n              </ng-template>\n            </fsw-dynamic-builder>\n          </form>\n        </section>\n      </section>\n    </fsw-panel>\n  </section>\n</fsw-panel>\n" }]
        }], propDecorators: { saveEvent: [{
                type: Output
            }], applicationId: [{
                type: Input
            }], proposalId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], proposalType: [{
                type: Input
            }], isTopUp: [{
                type: Input
            }], settlementAmount: [{
                type: Input
            }] } });

class FSWCreditMemoAnalysisComponent {
    constructor() {
        this.validating = new EventEmitter();
        this.facilitySaveEvent = new EventEmitter();
        this.applicationId = null;
        this.isTopUp = false;
        this.settlementAmount = 0;
        this.readonlyConfig = {
            repayment_schedule: false,
            facility_terms: false,
            credit_assessment: false,
            scorecard: false,
        };
        this.displayTabsConfig = {
            repayment_schedule: true,
            facility_terms: true,
            credit_assessment: true,
            scorecard: false,
        };
        this.hiddenRepaymentScheduleComments = {};
        this.proposalType = 'LOAN';
        this.doneMappingSignal = signal({
            repayment_schedule: false,
            facility_terms: false,
        });
        this.FSWTabsSizes = FSWTabsSizes;
        this.FSWTabsStatuses = FSWTabsStatuses;
    }
    markDone(tab) {
        this.doneMappingSignal.set({
            ...this.doneMappingSignal(),
            [tab]: true,
        });
        const mapping = this.doneMappingSignal();
        const valid = Object.keys(mapping)
            .filter((key) => this.displayTabsConfig[key])
            .every((key) => this.doneMappingSignal()[key]);
        this.validating.emit(valid);
    }
    saveFacility(data) {
        if (!data) {
            return;
        }
        this.facilitySaveEvent.emit(data);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCreditMemoAnalysisComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCreditMemoAnalysisComponent, isStandalone: true, selector: "fsw-credit-memo-analysis", inputs: { applicationId: "applicationId", isTopUp: "isTopUp", settlementAmount: "settlementAmount", readonlyConfig: "readonlyConfig", displayTabsConfig: "displayTabsConfig", hiddenRepaymentScheduleComments: "hiddenRepaymentScheduleComments", proposalType: "proposalType" }, outputs: { validating: "validating", facilitySaveEvent: "facilitySaveEvent" }, providers: [creditMemoAnalysisTranslation()], ngImport: i0, template: "<fsw-tabs-group [customRowGap]=\"'24px'\" [customColumnGap]=\"'24px'\">\n  <ng-template\n    fswTabs\n    *ngIf=\"displayTabsConfig.scorecard\"\n    [key]=\"'scorecard'\"\n    [icon]=\"readonlyConfig.scorecard ? null : 'common-edit'\"\n    [iconFontSize]=\"'20px'\"\n    [size]=\"FSWTabsSizes.S\"\n    [maxTextWidth]=\"'unset'\"\n    [label]=\"'scorecard' | fswTranslate\"\n  >\n    <fsw-digital-scorecard\n      [applicationId]=\"applicationId\"\n      [isReadonly]=\"!!readonlyConfig?.scorecard\"\n    />\n  </ng-template>\n  <ng-template\n    fswTabs\n    *ngIf=\"displayTabsConfig.repayment_schedule\"\n    [key]=\"'repayment_schedule'\"\n    [size]=\"FSWTabsSizes.S\"\n    [icon]=\"readonlyConfig.repayment_schedule ? null : 'common-edit'\"\n    [iconFontSize]=\"'20px'\"\n    [maxTextWidth]=\"'unset'\"\n    [label]=\"'repayment_schedule' | fswTranslate : { scope: 'credit_memo_analysis' }\"\n    [status]=\"\n      doneMappingSignal()['repayment_schedule'] ? FSWTabsStatuses.SUCCESS : FSWTabsStatuses.MISSING\n    \"\n  >\n    <fsw-repayment-schedule\n      [applicationId]=\"applicationId\"\n      [isReadonly]=\"!!readonlyConfig?.repayment_schedule\"\n      [isTopUp]=\"isTopUp\"\n      [settlementAmount]=\"settlementAmount\"\n      [proposalType]=\"proposalType\"\n      (saveEvent)=\"markDone('repayment_schedule')\"\n    />\n  </ng-template>\n  <ng-template\n    fswTabs\n    *ngIf=\"displayTabsConfig.facility_terms\"\n    [key]=\"'facility_terms'\"\n    [size]=\"FSWTabsSizes.S\"\n    [icon]=\"readonlyConfig.facility_terms ? null : 'common-edit'\"\n    [iconFontSize]=\"'20px'\"\n    [maxTextWidth]=\"'unset'\"\n    [label]=\"\n      proposalType.toLowerCase() + '_terms' | fswTranslate : { scope: 'credit_memo_analysis' }\n    \"\n    [status]=\"\n      doneMappingSignal()['facility_terms'] ? FSWTabsStatuses.SUCCESS : FSWTabsStatuses.MISSING\n    \"\n  >\n    <fsw-facility\n      [applicationId]=\"applicationId\"\n      [settlementAmount]=\"settlementAmount\"\n      [isTopUp]=\"isTopUp\"\n      [isReadonly]=\"!!readonlyConfig?.facility_terms\"\n      [proposalType]=\"proposalType\"\n      (saveEvent)=\"saveFacility($event); markDone('facility_terms')\"\n    />\n  </ng-template>\n  <ng-template\n    fswTabs\n    *ngIf=\"displayTabsConfig.credit_assessment\"\n    [key]=\"'credit_assessment'\"\n    [icon]=\"readonlyConfig.credit_assessment ? null : 'common-edit'\"\n    [iconFontSize]=\"'20px'\"\n    [size]=\"FSWTabsSizes.S\"\n    [maxTextWidth]=\"'unset'\"\n    [label]=\"'credit_assessment' | fswTranslate : { scope: 'credit_memo_analysis' }\"\n  >\n    <fsw-credit-assessment\n      [applicationId]=\"applicationId\"\n      [isReadonly]=\"!!readonlyConfig?.credit_assessment\"\n      [hiddenComments]=\"hiddenRepaymentScheduleComments\"\n      [proposalType]=\"proposalType\"\n    />\n  </ng-template>\n</fsw-tabs-group>\n", dependencies: [{ kind: "ngmodule", type: FSWTabsModule }, { kind: "component", type: i1$4.FSWTabsGroupComponent, selector: "fsw-tabs-group" }, { kind: "directive", type: i1$4.FSWTabsDirective, selector: "ng-template[fswTabs]" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "component", type: FSWCreditAssessmentComponent, selector: "fsw-credit-assessment", inputs: ["applicationId", "isReadonly", "hiddenComments", "proposalType"] }, { kind: "component", type: FSWFacilityComponent, selector: "fsw-facility", inputs: ["applicationId", "isReadonly", "isTopUp", "settlementAmount", "proposalType", "hideLoanInfo"], outputs: ["saveEvent"] }, { kind: "component", type: FSWRepaymentScheduleComponent, selector: "fsw-repayment-schedule", inputs: ["applicationId", "proposalId", "isReadonly", "proposalType", "isTopUp", "settlementAmount"], outputs: ["saveEvent"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FSWDigitalScorecardModule }, { kind: "component", type: FSWDigitalScorecardComponent, selector: "fsw-digital-scorecard", inputs: ["applicationId", "isReadonly"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCreditMemoAnalysisComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-credit-memo-analysis', changeDetection: ChangeDetectionStrategy.OnPush, providers: [creditMemoAnalysisTranslation()], standalone: true, imports: [
                        FSWTabsModule,
                        FSWTranslateModule,
                        FSWCreditAssessmentComponent,
                        FSWFacilityComponent,
                        FSWRepaymentScheduleComponent,
                        NgIf,
                        FSWFacilityComponent,
                        FSWDigitalScorecardModule,
                    ], template: "<fsw-tabs-group [customRowGap]=\"'24px'\" [customColumnGap]=\"'24px'\">\n  <ng-template\n    fswTabs\n    *ngIf=\"displayTabsConfig.scorecard\"\n    [key]=\"'scorecard'\"\n    [icon]=\"readonlyConfig.scorecard ? null : 'common-edit'\"\n    [iconFontSize]=\"'20px'\"\n    [size]=\"FSWTabsSizes.S\"\n    [maxTextWidth]=\"'unset'\"\n    [label]=\"'scorecard' | fswTranslate\"\n  >\n    <fsw-digital-scorecard\n      [applicationId]=\"applicationId\"\n      [isReadonly]=\"!!readonlyConfig?.scorecard\"\n    />\n  </ng-template>\n  <ng-template\n    fswTabs\n    *ngIf=\"displayTabsConfig.repayment_schedule\"\n    [key]=\"'repayment_schedule'\"\n    [size]=\"FSWTabsSizes.S\"\n    [icon]=\"readonlyConfig.repayment_schedule ? null : 'common-edit'\"\n    [iconFontSize]=\"'20px'\"\n    [maxTextWidth]=\"'unset'\"\n    [label]=\"'repayment_schedule' | fswTranslate : { scope: 'credit_memo_analysis' }\"\n    [status]=\"\n      doneMappingSignal()['repayment_schedule'] ? FSWTabsStatuses.SUCCESS : FSWTabsStatuses.MISSING\n    \"\n  >\n    <fsw-repayment-schedule\n      [applicationId]=\"applicationId\"\n      [isReadonly]=\"!!readonlyConfig?.repayment_schedule\"\n      [isTopUp]=\"isTopUp\"\n      [settlementAmount]=\"settlementAmount\"\n      [proposalType]=\"proposalType\"\n      (saveEvent)=\"markDone('repayment_schedule')\"\n    />\n  </ng-template>\n  <ng-template\n    fswTabs\n    *ngIf=\"displayTabsConfig.facility_terms\"\n    [key]=\"'facility_terms'\"\n    [size]=\"FSWTabsSizes.S\"\n    [icon]=\"readonlyConfig.facility_terms ? null : 'common-edit'\"\n    [iconFontSize]=\"'20px'\"\n    [maxTextWidth]=\"'unset'\"\n    [label]=\"\n      proposalType.toLowerCase() + '_terms' | fswTranslate : { scope: 'credit_memo_analysis' }\n    \"\n    [status]=\"\n      doneMappingSignal()['facility_terms'] ? FSWTabsStatuses.SUCCESS : FSWTabsStatuses.MISSING\n    \"\n  >\n    <fsw-facility\n      [applicationId]=\"applicationId\"\n      [settlementAmount]=\"settlementAmount\"\n      [isTopUp]=\"isTopUp\"\n      [isReadonly]=\"!!readonlyConfig?.facility_terms\"\n      [proposalType]=\"proposalType\"\n      (saveEvent)=\"saveFacility($event); markDone('facility_terms')\"\n    />\n  </ng-template>\n  <ng-template\n    fswTabs\n    *ngIf=\"displayTabsConfig.credit_assessment\"\n    [key]=\"'credit_assessment'\"\n    [icon]=\"readonlyConfig.credit_assessment ? null : 'common-edit'\"\n    [iconFontSize]=\"'20px'\"\n    [size]=\"FSWTabsSizes.S\"\n    [maxTextWidth]=\"'unset'\"\n    [label]=\"'credit_assessment' | fswTranslate : { scope: 'credit_memo_analysis' }\"\n  >\n    <fsw-credit-assessment\n      [applicationId]=\"applicationId\"\n      [isReadonly]=\"!!readonlyConfig?.credit_assessment\"\n      [hiddenComments]=\"hiddenRepaymentScheduleComments\"\n      [proposalType]=\"proposalType\"\n    />\n  </ng-template>\n</fsw-tabs-group>\n" }]
        }], propDecorators: { validating: [{
                type: Output
            }], facilitySaveEvent: [{
                type: Output
            }], applicationId: [{
                type: Input
            }], isTopUp: [{
                type: Input
            }], settlementAmount: [{
                type: Input
            }], readonlyConfig: [{
                type: Input
            }], displayTabsConfig: [{
                type: Input
            }], hiddenRepaymentScheduleComments: [{
                type: Input
            }], proposalType: [{
                type: Input
            }] } });

const FSW_CTOS_PULL_STORE_TOKEN = new InjectionToken('FSW_CTOS_PULL_STORE_TOKEN');

const FSW_CTOS_PULL_INFORMATION_FORM_BUILDER_TOKEN = new InjectionToken('FSW_CTOS_PULL_INFORMATION_FORM_BUILDER_TOKEN');
const FSW_CTOS_PULL_BIP_STATUS_TABLE_BUILDER_TOKEN = new InjectionToken('FSW_CTOS_PULL_BIP_STATUS_TABLE_BUILDER_TOKEN');
const FSW_CTOS_PULL_BIP_DETAIL_TABLE_BUILDER_TOKEN = new InjectionToken('FSW_CTOS_PULL_BIP_DETAIL_TABLE_BUILDER_TOKEN');
const FSW_CTOS_PULL_BIP_SELECTION_TABLE_BUILDER_TOKEN = new InjectionToken('FSW_CTOS_PULL_BIP_SELECTION_TABLE_BUILDER_TOKEN');
const FSW_CTOS_PULL_FORM_BUILDER_TOKEN = new InjectionToken('FSW_CTOS_PULL_FORM_BUILDER_TOKEN');
const FSW_CTOS_PULL_BIP_FORM_BUILDER_TOKEN = new InjectionToken('FSW_CTOS_PULL_BIP_FORM_BUILDER_TOKEN');

class FSWCtosPullViewBipDialogComponent {
    constructor(_componentStore, _builder, dialogRef) {
        this._componentStore = _componentStore;
        this._builder = _builder;
        this.dialogRef = dialogRef;
        this.state$ = this._componentStore.state$.pipe(tap((state) => {
            this.formGroup.patchValue({
                list: state.renderHistories,
            });
        }));
        this.isReadonly$ = this._componentStore.select((state) => state.isReadonly);
        this.existIds = [];
        this.applicationBipIds = [];
        this.formGroup = new UntypedFormGroup({});
        this.builder = this._builder({
            form: this.formGroup,
        });
    }
    ngOnInit() {
        this._componentStore.fetchBIPsByMemberId((bips, applicationBipIds) => this.solveData(bips, applicationBipIds));
    }
    showReport(control) {
        const parent = control.parent?.value;
        if (!parent?.reportID) {
            return;
        }
        this._componentStore.showReport(parent.reportID);
    }
    link(id) {
        this._componentStore.linkToApplication({
            id,
            cb: this.solveData.bind(this),
        });
    }
    conditionChecking(history) {
        const regex = `${history.entityNo}-${history.entityName}`;
        if (!this.existIds.includes(regex)) {
            this.existIds.push(regex);
            return true;
        }
        return false;
    }
    checkEnableSSM(historyItem) {
        return (this._componentStore
            .state()
            .renderHistories.find((b) => b.entityNo === historyItem.entityNo && b.entityName === historyItem.entityName)?.enableSSM || false);
    }
    getReportId(historyItem) {
        return (this._componentStore
            .state()
            .renderHistories.find((b) => b.entityNo === historyItem.entityNo && b.entityName === historyItem.entityName)?.reportID || null);
    }
    solveData(bips, applicationBipIds) {
        this.existIds = [];
        this.applicationBipIds = applicationBipIds;
        this.formGroup.patchValue({
            list: [
                ...bips
                    .map((bip) => ({
                    ...bip,
                    entityName: bip.name,
                    entityNo: bip.idNumber,
                }))
                    .filter((history) => this.conditionChecking(history)),
                ...this._componentStore
                    .state()
                    .renderHistories.filter((history) => history.status === FSWCTOSPullStatuses.SUCCESS)
                    .filter((history) => this.conditionChecking(history)),
            ].map((history) => {
                const cloneHistory = cloneDeep(history);
                return {
                    id: `${cloneHistory.id}`,
                    entityName: cloneHistory.entityName,
                    entityNo: cloneHistory.entityNo,
                    designation: cloneHistory.designation,
                    reportID: this.getReportId(cloneHistory),
                    isSelected: this.checkEnableSSM(cloneHistory),
                    isPrimaryBorrower: cloneHistory.isPrimaryBorrower,
                };
            }),
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullViewBipDialogComponent, deps: [{ token: FSW_CTOS_PULL_STORE_TOKEN }, { token: FSW_CTOS_PULL_BIP_DETAIL_TABLE_BUILDER_TOKEN }, { token: i1$7.DialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCtosPullViewBipDialogComponent, selector: "fsw-ctos-pull-view-bip-dialog", ngImport: i0, template: "<fsw-modal\n  [size]=\"'l'\"\n  [title]=\"'others.bip_title' | fswTranslate\"\n  (closeEvent)=\"dialogRef.close()\"\n>\n  <ng-template fswModalBody>\n    <form [formGroup]=\"formGroup\" class=\"w-full overflow-x-auto\">\n      <fsw-dynamic-builder [builder]=\"builder\">\n        <ng-template fswDynamicBuilderTemplate key=\"name_link\" let-control=\"control\">\n          <a fswButton appearance=\"link\" (click)=\"showReport(control)\">{{ control.value }}</a>\n        </ng-template>\n        <ng-template fswDynamicBuilderTemplate key=\"id_link\" let-control=\"control\">\n          <ng-container *ngIf=\"control.value as value; else historyTemplate\">\n            <ng-container *ngIf=\"!applicationBipIds.includes(value); else alreadyLinkTemplate\">\n              <ng-container *ngIf=\"isReadonly$ | async; else linkTemplate\">\n                <span class=\"font-bold text-yellow-500\">{{\n                  'others.not_yet_linked' | fswTranslate\n                }}</span>\n              </ng-container>\n              <ng-template #linkTemplate>\n                <button fswButton (click)=\"link(value)\">{{ 'buttons.link' | fswTranslate }}</button>\n              </ng-template>\n            </ng-container>\n            <ng-template #alreadyLinkTemplate>\n              <span class=\"font-bold text-green-500\">{{ 'others.linked' | fswTranslate }}</span>\n            </ng-template>\n          </ng-container>\n          <ng-template #historyTemplate>\n            <span class=\"font-bold text-blue-500\">{{ 'others.history' | fswTranslate }}</span>\n          </ng-template>\n        </ng-template>\n      </fsw-dynamic-builder>\n    </form>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FSWDynamicBuilderTemplateDirective, selector: "[fswDynamicBuilderTemplate]", inputs: ["key"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullViewBipDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-ctos-pull-view-bip-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal\n  [size]=\"'l'\"\n  [title]=\"'others.bip_title' | fswTranslate\"\n  (closeEvent)=\"dialogRef.close()\"\n>\n  <ng-template fswModalBody>\n    <form [formGroup]=\"formGroup\" class=\"w-full overflow-x-auto\">\n      <fsw-dynamic-builder [builder]=\"builder\">\n        <ng-template fswDynamicBuilderTemplate key=\"name_link\" let-control=\"control\">\n          <a fswButton appearance=\"link\" (click)=\"showReport(control)\">{{ control.value }}</a>\n        </ng-template>\n        <ng-template fswDynamicBuilderTemplate key=\"id_link\" let-control=\"control\">\n          <ng-container *ngIf=\"control.value as value; else historyTemplate\">\n            <ng-container *ngIf=\"!applicationBipIds.includes(value); else alreadyLinkTemplate\">\n              <ng-container *ngIf=\"isReadonly$ | async; else linkTemplate\">\n                <span class=\"font-bold text-yellow-500\">{{\n                  'others.not_yet_linked' | fswTranslate\n                }}</span>\n              </ng-container>\n              <ng-template #linkTemplate>\n                <button fswButton (click)=\"link(value)\">{{ 'buttons.link' | fswTranslate }}</button>\n              </ng-template>\n            </ng-container>\n            <ng-template #alreadyLinkTemplate>\n              <span class=\"font-bold text-green-500\">{{ 'others.linked' | fswTranslate }}</span>\n            </ng-template>\n          </ng-container>\n          <ng-template #historyTemplate>\n            <span class=\"font-bold text-blue-500\">{{ 'others.history' | fswTranslate }}</span>\n          </ng-template>\n        </ng-template>\n      </fsw-dynamic-builder>\n    </form>\n  </ng-template>\n</fsw-modal>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_CTOS_PULL_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_CTOS_PULL_BIP_DETAIL_TABLE_BUILDER_TOKEN]
                }] }, { type: i1$7.DialogRef }]; } });

class FSWCtosPullBipActionComponent {
    constructor(_componentStore, _dialog, _injector) {
        this._componentStore = _componentStore;
        this._dialog = _dialog;
        this._injector = _injector;
        this.state$ = this._componentStore.state$;
    }
    pull() {
        this._componentStore.fetchBip(() => {
            this._componentStore.showSelectionBip();
        });
    }
    download() {
        const reportID = this._componentStore.state().latestHistory?.reportID;
        reportID && this._componentStore.showReport(reportID);
    }
    view() {
        this._dialog
            .open(FSWCtosPullViewBipDialogComponent, {
            injector: this._injector,
        })
            .closed.pipe(take(1))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullBipActionComponent, deps: [{ token: FSW_CTOS_PULL_STORE_TOKEN }, { token: i1$7.Dialog }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCtosPullBipActionComponent, selector: "fsw-ctos-pull-bip-action", ngImport: i0, template: "<ng-container *ngIf=\"state$ | async as state\">\n  <section class=\"ctos-pull-bip-action\">\n    <main>\n      <span\n        >{{ 'others.latest_request' | fswTranslate }}\n        {{ state.latestHistory?.createdAt || '' | date : 'dd-M-yyyy' }}</span\n      >\n      <a fswButton [appearance]=\"'link'\" (click)=\"view()\">{{\n        'buttons.view_bips' | fswTranslate\n      }}</a>\n    </main>\n    <footer>\n      <button fswButton (click)=\"pull()\" *ngIf=\"!state.isReadonly\">\n        {{ 'buttons.pull_ctos_request' | fswTranslate }}\n      </button>\n      <button fswButton (click)=\"download()\" *ngIf=\"state.latestHistory\">\n        {{ 'buttons.download_ctos_document' | fswTranslate }}\n      </button>\n    </footer>\n  </section>\n</ng-container>\n", styles: [":host .ctos-pull-bip-action{display:flex;flex-direction:column;gap:1rem}:host .ctos-pull-bip-action>main{display:flex;align-items:center;gap:.75rem}:host .ctos-pull-bip-action>footer{display:flex;gap:.75rem}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.DatePipe, name: "date" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullBipActionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-ctos-pull-bip-action', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"state$ | async as state\">\n  <section class=\"ctos-pull-bip-action\">\n    <main>\n      <span\n        >{{ 'others.latest_request' | fswTranslate }}\n        {{ state.latestHistory?.createdAt || '' | date : 'dd-M-yyyy' }}</span\n      >\n      <a fswButton [appearance]=\"'link'\" (click)=\"view()\">{{\n        'buttons.view_bips' | fswTranslate\n      }}</a>\n    </main>\n    <footer>\n      <button fswButton (click)=\"pull()\" *ngIf=\"!state.isReadonly\">\n        {{ 'buttons.pull_ctos_request' | fswTranslate }}\n      </button>\n      <button fswButton (click)=\"download()\" *ngIf=\"state.latestHistory\">\n        {{ 'buttons.download_ctos_document' | fswTranslate }}\n      </button>\n    </footer>\n  </section>\n</ng-container>\n", styles: [":host .ctos-pull-bip-action{display:flex;flex-direction:column;gap:1rem}:host .ctos-pull-bip-action>main{display:flex;align-items:center;gap:.75rem}:host .ctos-pull-bip-action>footer{display:flex;gap:.75rem}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_CTOS_PULL_STORE_TOKEN]
                }] }, { type: i1$7.Dialog }, { type: i0.Injector }]; } });

class FSWCtosPullBipComponent {
    constructor(_componentStore, _builder) {
        this._componentStore = _componentStore;
        this._builder = _builder;
        this.state$ = this._componentStore.state$.pipe(tap((state) => {
            this.formGroup.patchValue({
                list: state.renderHistories,
            });
        }));
        this.FSWCTOSPullStatuses = FSWCTOSPullStatuses;
        this.formGroup = new UntypedFormGroup({});
        this.builder = this._builder({
            form: this.formGroup,
        });
    }
    getError(control) {
        const parent = control.parent?.value;
        return parent.error || '';
    }
    refresh() {
        this._componentStore.fetchBip(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullBipComponent, deps: [{ token: FSW_CTOS_PULL_STORE_TOKEN }, { token: FSW_CTOS_PULL_BIP_STATUS_TABLE_BUILDER_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCtosPullBipComponent, selector: "fsw-ctos-pull-bip", ngImport: i0, template: "<ng-container *ngIf=\"state$ | async as state\">\n  <section class=\"ctos-pull-bip\">\n    <header>\n      <div class=\"flex w-full justify-between items-center\">\n        <h4 class=\"h4\">{{ 'others.bip_title' | fswTranslate }}</h4>\n        <button fswButton (click)=\"refresh()\" *ngIf=\"!state.isReadonly\">\n          {{ 'buttons.refresh' | fswTranslate }}\n        </button>\n      </div>\n      <ol>\n        <li\n          class=\"text-body-default-400\"\n          [innerHTML]=\"'others.bip_description_1' | fswTranslate\"\n        ></li>\n        <li\n          class=\"text-body-default-400\"\n          [innerHTML]=\"'others.bip_description_2' | fswTranslate\"\n        ></li>\n      </ol>\n    </header>\n    <main>\n      <form [formGroup]=\"formGroup\">\n        <fsw-dynamic-builder [builder]=\"builder\">\n          <ng-template fswDynamicBuilderTemplate key=\"status\" let-control=\"control\">\n            <ng-container [ngSwitch]=\"control.value\">\n              <ng-container *ngSwitchCase=\"FSWCTOSPullStatuses.SUCCESS\">\n                <span class=\"font-bold text-green-500\">{{ control.value }}</span>\n              </ng-container>\n              <ng-container *ngSwitchCase=\"FSWCTOSPullStatuses.FAILED\">\n                <label class=\"inline-flex items-center gap-2 text-red-500\">\n                  <span class=\"font-bold\">{{ control.value }}</span>\n                  <i\n                    [fswIcon]=\"'common-close-circle'\"\n                    class=\"hover:cursor-pointer\"\n                    [cdkMenuTriggerFor]=\"tooltipTemplate\"\n                    #cdkMenuTrigger=\"cdkMenuTriggerFor\"\n                    (mouseenter)=\"cdkMenuTrigger.open()\"\n                    (mouseleave)=\"cdkMenuTrigger.close()\"\n                  ></i>\n                  <ng-template #tooltipTemplate>\n                    <span\n                      fswTooltip\n                      class=\"!text-red-500 w-[300px] !rounded-lg !bg-white shadow-small\"\n                      >{{ getError(control) }}</span\n                    >\n                  </ng-template>\n                </label>\n              </ng-container>\n              <ng-container *ngSwitchCase=\"FSWCTOSPullStatuses.IN_PROGRESS\">\n                <span class=\"font-bold text-blue-500\">{{ control.value }}</span>\n              </ng-container>\n            </ng-container>\n          </ng-template>\n        </fsw-dynamic-builder>\n      </form>\n    </main>\n    <footer>\n      <fsw-ctos-pull-bip-action></fsw-ctos-pull-bip-action>\n    </footer>\n  </section>\n</ng-container>\n", styles: [":host .ctos-pull-bip{display:flex;flex-direction:column;gap:.75rem}:host .ctos-pull-bip>main{max-width:100%;overflow-x:auto}:host .ctos-pull-bip>header>ol{list-style-type:\"- \";padding:1rem}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FSWDynamicBuilderTemplateDirective, selector: "[fswDynamicBuilderTemplate]", inputs: ["key"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "directive", type: i6.CdkMenuTrigger, selector: "[cdkMenuTriggerFor]", inputs: ["cdkMenuTriggerFor", "cdkMenuPosition", "cdkMenuTriggerData"], outputs: ["cdkMenuOpened", "cdkMenuClosed"], exportAs: ["cdkMenuTriggerFor"] }, { kind: "directive", type: i1$4.FSWTooltipDirective, selector: "[fswTooltip]" }, { kind: "component", type: FSWCtosPullBipActionComponent, selector: "fsw-ctos-pull-bip-action" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullBipComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-ctos-pull-bip', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"state$ | async as state\">\n  <section class=\"ctos-pull-bip\">\n    <header>\n      <div class=\"flex w-full justify-between items-center\">\n        <h4 class=\"h4\">{{ 'others.bip_title' | fswTranslate }}</h4>\n        <button fswButton (click)=\"refresh()\" *ngIf=\"!state.isReadonly\">\n          {{ 'buttons.refresh' | fswTranslate }}\n        </button>\n      </div>\n      <ol>\n        <li\n          class=\"text-body-default-400\"\n          [innerHTML]=\"'others.bip_description_1' | fswTranslate\"\n        ></li>\n        <li\n          class=\"text-body-default-400\"\n          [innerHTML]=\"'others.bip_description_2' | fswTranslate\"\n        ></li>\n      </ol>\n    </header>\n    <main>\n      <form [formGroup]=\"formGroup\">\n        <fsw-dynamic-builder [builder]=\"builder\">\n          <ng-template fswDynamicBuilderTemplate key=\"status\" let-control=\"control\">\n            <ng-container [ngSwitch]=\"control.value\">\n              <ng-container *ngSwitchCase=\"FSWCTOSPullStatuses.SUCCESS\">\n                <span class=\"font-bold text-green-500\">{{ control.value }}</span>\n              </ng-container>\n              <ng-container *ngSwitchCase=\"FSWCTOSPullStatuses.FAILED\">\n                <label class=\"inline-flex items-center gap-2 text-red-500\">\n                  <span class=\"font-bold\">{{ control.value }}</span>\n                  <i\n                    [fswIcon]=\"'common-close-circle'\"\n                    class=\"hover:cursor-pointer\"\n                    [cdkMenuTriggerFor]=\"tooltipTemplate\"\n                    #cdkMenuTrigger=\"cdkMenuTriggerFor\"\n                    (mouseenter)=\"cdkMenuTrigger.open()\"\n                    (mouseleave)=\"cdkMenuTrigger.close()\"\n                  ></i>\n                  <ng-template #tooltipTemplate>\n                    <span\n                      fswTooltip\n                      class=\"!text-red-500 w-[300px] !rounded-lg !bg-white shadow-small\"\n                      >{{ getError(control) }}</span\n                    >\n                  </ng-template>\n                </label>\n              </ng-container>\n              <ng-container *ngSwitchCase=\"FSWCTOSPullStatuses.IN_PROGRESS\">\n                <span class=\"font-bold text-blue-500\">{{ control.value }}</span>\n              </ng-container>\n            </ng-container>\n          </ng-template>\n        </fsw-dynamic-builder>\n      </form>\n    </main>\n    <footer>\n      <fsw-ctos-pull-bip-action></fsw-ctos-pull-bip-action>\n    </footer>\n  </section>\n</ng-container>\n", styles: [":host .ctos-pull-bip{display:flex;flex-direction:column;gap:.75rem}:host .ctos-pull-bip>main{max-width:100%;overflow-x:auto}:host .ctos-pull-bip>header>ol{list-style-type:\"- \";padding:1rem}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_CTOS_PULL_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_CTOS_PULL_BIP_STATUS_TABLE_BUILDER_TOKEN]
                }] }]; } });

class FSWCtosPullAddBipDialogComponent {
    constructor(dialogRef, _componentStore, _builder) {
        this.dialogRef = dialogRef;
        this._componentStore = _componentStore;
        this._builder = _builder;
        this.formGroup = new UntypedFormGroup({});
        this.builder = this._builder({
            form: this.formGroup,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullAddBipDialogComponent, deps: [{ token: i1$7.DialogRef }, { token: FSW_CTOS_PULL_STORE_TOKEN }, { token: FSW_CTOS_PULL_BIP_FORM_BUILDER_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCtosPullAddBipDialogComponent, selector: "fsw-ctos-pull-add-bip-dialog", ngImport: i0, template: "<fsw-modal\n  [size]=\"'m'\"\n  [title]=\"'others.bip_adding' | fswTranslate\"\n  [hiddenCloseButton]=\"true\"\n  [confirmButton]=\"'buttons.continue' | fswTranslate\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate\"\n  (cancelEvent)=\"dialogRef.close(undefined)\"\n  (confirmEvent)=\"dialogRef.close(formGroup.value)\"\n>\n  <ng-template fswModalBody>\n    <p>{{ 'others.bip_warning' | fswTranslate }}</p>\n    <form [formGroup]=\"formGroup\">\n      <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n    </form>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullAddBipDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-ctos-pull-add-bip-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal\n  [size]=\"'m'\"\n  [title]=\"'others.bip_adding' | fswTranslate\"\n  [hiddenCloseButton]=\"true\"\n  [confirmButton]=\"'buttons.continue' | fswTranslate\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate\"\n  (cancelEvent)=\"dialogRef.close(undefined)\"\n  (confirmEvent)=\"dialogRef.close(formGroup.value)\"\n>\n  <ng-template fswModalBody>\n    <p>{{ 'others.bip_warning' | fswTranslate }}</p>\n    <form [formGroup]=\"formGroup\">\n      <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n    </form>\n  </ng-template>\n</fsw-modal>\n" }]
        }], ctorParameters: function () { return [{ type: i1$7.DialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_CTOS_PULL_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_CTOS_PULL_BIP_FORM_BUILDER_TOKEN]
                }] }]; } });

class FSWCtosPullSelectionBipComponent {
    get formArray() {
        return this.formGroup.get('list');
    }
    get isDisabledPull() {
        return (!this.consentControl.value ||
            !this.formArray.value.some((item) => item.isSelected));
    }
    get selectedBips() {
        return [...this.formArray.value]
            .filter((item) => item.isSelected)
            .map((item) => {
            const cloneItem = cloneDeep(item);
            delete cloneItem.isSelected;
            delete cloneItem.status;
            delete cloneItem.error;
            return {
                ...cloneItem,
                bipData: {
                    sourceCompanyID: cloneItem.sourceCompanyID,
                    shares: cloneItem.shares,
                    designation: cloneItem.designation,
                    isPrimaryBorrower: cloneItem.isPrimaryBorrower,
                },
            };
        });
    }
    get isPulled() {
        return !!this._componentStore.state().renderHistories.length;
    }
    constructor(dialogRef, _componentStore, _builder, _cdr, _dialog, _injector) {
        this.dialogRef = dialogRef;
        this._componentStore = _componentStore;
        this._builder = _builder;
        this._cdr = _cdr;
        this._dialog = _dialog;
        this._injector = _injector;
        this.consentControl = new UntypedFormControl(false);
        this.historyMap = new Map();
        this.showConfirm = false;
        this.FSWCTOSPullStatuses = FSWCTOSPullStatuses;
        this.formGroup = new UntypedFormGroup({});
        this.builder = this._builder({
            form: this.formGroup,
        });
        this.formGroup.patchValue({
            list: [],
        });
    }
    ngOnInit() {
        this._componentStore
            .state()
            .renderHistories.filter((bip) => bip.status === FSWCTOSPullStatuses.SUCCESS)
            .forEach((bip) => this.historyMap.set(`${bip.entityNo}${bip.entityName}`, bip));
        this._componentStore.pullBIPsAndFetchMember((bips, pullBips) => {
            this.resolveArray(bips.map((bip) => ({
                ...bip,
                entityName: bip.name,
                ...parseCtosEntity(bip.ctosEntity),
            })), true);
            this.resolveArray(pullBips.map((bip) => ({
                ...bip,
                entityName: bip.name,
            })));
            this._cdr.markForCheck();
        });
    }
    checkPull() {
        const check = this.formArray.value.some((item) => this.checkWarning(item));
        if (!check) {
            this.pull();
            return;
        }
        this.showConfirm = true;
        this._cdr.markForCheck();
    }
    pull() {
        if (!this.selectedBips.length) {
            this.cancelPull();
            return;
        }
        this.dialogRef.close(this.selectedBips);
    }
    cancelPull() {
        this.showConfirm = false;
        this.consentControl.setValue(false);
        this._cdr.markForCheck();
    }
    checkWarning(bip) {
        return !!(this.historyMap.get(`${bip.entityNo}${bip.entityName}`) && bip.isSelected);
    }
    checkControlWarning(control) {
        const parent = control.parent?.value;
        if (!parent) {
            return false;
        }
        return this.checkWarning(parent);
    }
    resolveArray(data, forceSelected = false) {
        data.forEach((bip) => {
            const existed = this._componentStore
                .state()
                .renderHistories.some((b) => b.entityNo === bip.entityNo && b.entityName === bip.entityName);
            const isSelected = forceSelected ? true : existed;
            const status = this._componentStore
                .state()
                .renderHistories.find((b) => b.entityNo === bip.entityNo && b.entityName === bip.entityName)?.status || '';
            const reportID = forceSelected
                ? bip.sourceReportId
                : this._componentStore
                    .state()
                    .renderHistories.find((b) => b.entityNo === bip.entityNo && b.entityName === bip.entityName)?.reportID || null;
            const group = this.formArray.controls.find((item) => item.value.entityNo === bip.entityNo && item.value.entityName === bip.entityName);
            if (group) {
                group.patchValue({
                    status,
                    reportID,
                    error: bip.error,
                });
                return;
            }
            this.formArray.push(new UntypedFormGroup({
                entityName: new UntypedFormControl(bip.entityName),
                entityNo: new UntypedFormControl(bip.entityNo),
                entityType: new UntypedFormControl(bip.entityType),
                memberID: new UntypedFormControl(Number(this._componentStore.state().member?.id)),
                allowSaveDataAfterPull: new UntypedFormControl(true),
                isSelected: new UntypedFormControl(isSelected),
                status: new UntypedFormControl(status),
                reportID: new UntypedFormControl(reportID),
                error: new UntypedFormControl(bip.error),
                sourceCompanyID: new UntypedFormControl(this._componentStore.state().ctosEntity?.entityNo),
                shares: new UntypedFormControl(bip.shares),
                designation: new UntypedFormControl(bip.designation),
                isPrimaryBorrower: new UntypedFormControl(bip.isPrimaryBorrower),
            }));
        });
    }
    addBip() {
        this._dialog
            .open(FSWCtosPullAddBipDialogComponent, {
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((value) => {
            if (value) {
                this.formArray.push(new UntypedFormGroup({
                    entityName: new UntypedFormControl(value.entityName),
                    entityNo: new UntypedFormControl(value.entityNo),
                    entityType: new UntypedFormControl(value.entityType),
                    memberID: new UntypedFormControl(Number(this._componentStore.state().member?.id)),
                    allowSaveDataAfterPull: new UntypedFormControl(true),
                    isSelected: new UntypedFormControl(false),
                    status: new UntypedFormControl(''),
                    sourceCompanyID: new UntypedFormControl(this._componentStore.state().ctosEntity?.entityNo),
                    shares: new UntypedFormControl(''),
                    designation: new UntypedFormControl(''),
                    isPrimaryBorrower: new UntypedFormControl(false),
                }));
            }
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullSelectionBipComponent, deps: [{ token: i1$7.DialogRef }, { token: FSW_CTOS_PULL_STORE_TOKEN }, { token: FSW_CTOS_PULL_BIP_SELECTION_TABLE_BUILDER_TOKEN }, { token: i0.ChangeDetectorRef }, { token: i1$7.Dialog }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCtosPullSelectionBipComponent, selector: "fsw-ctos-pull-selection-bip", ngImport: i0, template: "<fsw-modal\n  [size]=\"'l'\"\n  [title]=\"'others.bip_title' | fswTranslate\"\n  (closeEvent)=\"dialogRef.close()\"\n>\n  <ng-template fswModalBody>\n    <section class=\"flex flex-col gap-4\">\n      <header class=\"flex justify-between\">\n        <p>\n          <ng-container *ngIf=\"isPulled; else notTemplate\">\n            {{ 'others.pull_success_warning' | fswTranslate }}\n          </ng-container>\n          <ng-template #notTemplate>\n            {{ 'others.reselect_warning' | fswTranslate }}\n          </ng-template>\n        </p>\n        <button fswButton [appearance]=\"'secondary'\" (click)=\"addBip()\">\n          {{ 'buttons.add_bip' | fswTranslate }}\n        </button>\n      </header>\n      <main>\n        <form [formGroup]=\"formGroup\" class=\"w-full overflow-x-auto\">\n          <fsw-dynamic-builder [builder]=\"builder\">\n            <ng-template fswDynamicBuilderTemplate key=\"name_link\" let-control=\"control\">\n              <label\n                class=\"inline-flex items-center gap-2\"\n                [class.text-yellow-500]=\"checkControlWarning(control)\"\n              >\n                <ng-container *ngIf=\"checkControlWarning(control)\">\n                  <i\n                    [fswIcon]=\"'status-warning-circle'\"\n                    class=\"hover:cursor-pointer\"\n                    [cdkMenuTriggerFor]=\"tooltipTemplate\"\n                    #cdkMenuTrigger=\"cdkMenuTriggerFor\"\n                    (mouseenter)=\"cdkMenuTrigger.open()\"\n                    (mouseleave)=\"cdkMenuTrigger.close()\"\n                  ></i>\n                  <ng-template #tooltipTemplate>\n                    <span fswTooltip class=\"!text-yellow-500 !rounded-lg !bg-white shadow-small\">{{\n                      'others.already_pulled' | fswTranslate\n                    }}</span>\n                  </ng-template>\n                </ng-container>\n                <span>{{ control.value }}</span>\n              </label>\n            </ng-template>\n            <ng-template fswDynamicBuilderTemplate key=\"status\" let-control=\"control\">\n              <ng-container [ngSwitch]=\"control.value\">\n                <ng-container *ngSwitchCase=\"FSWCTOSPullStatuses.SUCCESS\">\n                  <span class=\"font-bold text-green-500\">{{ control.value }}</span>\n                </ng-container>\n                <ng-container *ngSwitchCase=\"FSWCTOSPullStatuses.FAILED\">\n                  <span class=\"font-bold text-red-500\">{{ control.value }}</span>\n                </ng-container>\n                <ng-container *ngSwitchCase=\"FSWCTOSPullStatuses.IN_PROGRESS\">\n                  <span class=\"font-bold text-blue-500\">{{ control.value }}</span>\n                </ng-container>\n              </ng-container>\n            </ng-template>\n          </fsw-dynamic-builder>\n        </form>\n      </main>\n    </section>\n  </ng-template>\n  <ng-template fswModalFooter>\n    <footer class=\"flex items-center justify-between w-full\">\n      <ng-container *ngIf=\"showConfirm; else pullTemplate\">\n        <p\n          class=\"text-yellow-500 font-bold\"\n          [innerHTML]=\"'others.pull_selected_warning' | fswTranslate\"\n        ></p>\n        <div class=\"flex gap-3\">\n          <button fswButton appearance=\"secondary\" (click)=\"cancelPull()\">\n            {{ 'buttons.cancel' | fswTranslate }}\n          </button>\n          <button fswButton (click)=\"pull()\">{{ 'buttons.continue' | fswTranslate }}</button>\n        </div>\n      </ng-container>\n      <ng-template #pullTemplate>\n        <fsw-checkbox\n          [formControl]=\"consentControl\"\n          [label]=\"'others.consent' | fswTranslate\"\n        ></fsw-checkbox>\n        <button fswButton [disabled]=\"isDisabledPull\" (click)=\"checkPull()\">\n          {{ 'buttons.pull_ctos_data' | fswTranslate }}\n        </button>\n      </ng-template>\n    </footer>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "directive", type: i1$4.FSWModalFooterDirective, selector: "ng-template[fswModalFooter]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FSWDynamicBuilderTemplateDirective, selector: "[fswDynamicBuilderTemplate]", inputs: ["key"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "component", type: i1$4.FSWCheckboxComponent, selector: "fsw-checkbox" }, { kind: "directive", type: i1$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "directive", type: i6.CdkMenuTrigger, selector: "[cdkMenuTriggerFor]", inputs: ["cdkMenuTriggerFor", "cdkMenuPosition", "cdkMenuTriggerData"], outputs: ["cdkMenuOpened", "cdkMenuClosed"], exportAs: ["cdkMenuTriggerFor"] }, { kind: "directive", type: i1$4.FSWTooltipDirective, selector: "[fswTooltip]" }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullSelectionBipComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-ctos-pull-selection-bip', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal\n  [size]=\"'l'\"\n  [title]=\"'others.bip_title' | fswTranslate\"\n  (closeEvent)=\"dialogRef.close()\"\n>\n  <ng-template fswModalBody>\n    <section class=\"flex flex-col gap-4\">\n      <header class=\"flex justify-between\">\n        <p>\n          <ng-container *ngIf=\"isPulled; else notTemplate\">\n            {{ 'others.pull_success_warning' | fswTranslate }}\n          </ng-container>\n          <ng-template #notTemplate>\n            {{ 'others.reselect_warning' | fswTranslate }}\n          </ng-template>\n        </p>\n        <button fswButton [appearance]=\"'secondary'\" (click)=\"addBip()\">\n          {{ 'buttons.add_bip' | fswTranslate }}\n        </button>\n      </header>\n      <main>\n        <form [formGroup]=\"formGroup\" class=\"w-full overflow-x-auto\">\n          <fsw-dynamic-builder [builder]=\"builder\">\n            <ng-template fswDynamicBuilderTemplate key=\"name_link\" let-control=\"control\">\n              <label\n                class=\"inline-flex items-center gap-2\"\n                [class.text-yellow-500]=\"checkControlWarning(control)\"\n              >\n                <ng-container *ngIf=\"checkControlWarning(control)\">\n                  <i\n                    [fswIcon]=\"'status-warning-circle'\"\n                    class=\"hover:cursor-pointer\"\n                    [cdkMenuTriggerFor]=\"tooltipTemplate\"\n                    #cdkMenuTrigger=\"cdkMenuTriggerFor\"\n                    (mouseenter)=\"cdkMenuTrigger.open()\"\n                    (mouseleave)=\"cdkMenuTrigger.close()\"\n                  ></i>\n                  <ng-template #tooltipTemplate>\n                    <span fswTooltip class=\"!text-yellow-500 !rounded-lg !bg-white shadow-small\">{{\n                      'others.already_pulled' | fswTranslate\n                    }}</span>\n                  </ng-template>\n                </ng-container>\n                <span>{{ control.value }}</span>\n              </label>\n            </ng-template>\n            <ng-template fswDynamicBuilderTemplate key=\"status\" let-control=\"control\">\n              <ng-container [ngSwitch]=\"control.value\">\n                <ng-container *ngSwitchCase=\"FSWCTOSPullStatuses.SUCCESS\">\n                  <span class=\"font-bold text-green-500\">{{ control.value }}</span>\n                </ng-container>\n                <ng-container *ngSwitchCase=\"FSWCTOSPullStatuses.FAILED\">\n                  <span class=\"font-bold text-red-500\">{{ control.value }}</span>\n                </ng-container>\n                <ng-container *ngSwitchCase=\"FSWCTOSPullStatuses.IN_PROGRESS\">\n                  <span class=\"font-bold text-blue-500\">{{ control.value }}</span>\n                </ng-container>\n              </ng-container>\n            </ng-template>\n          </fsw-dynamic-builder>\n        </form>\n      </main>\n    </section>\n  </ng-template>\n  <ng-template fswModalFooter>\n    <footer class=\"flex items-center justify-between w-full\">\n      <ng-container *ngIf=\"showConfirm; else pullTemplate\">\n        <p\n          class=\"text-yellow-500 font-bold\"\n          [innerHTML]=\"'others.pull_selected_warning' | fswTranslate\"\n        ></p>\n        <div class=\"flex gap-3\">\n          <button fswButton appearance=\"secondary\" (click)=\"cancelPull()\">\n            {{ 'buttons.cancel' | fswTranslate }}\n          </button>\n          <button fswButton (click)=\"pull()\">{{ 'buttons.continue' | fswTranslate }}</button>\n        </div>\n      </ng-container>\n      <ng-template #pullTemplate>\n        <fsw-checkbox\n          [formControl]=\"consentControl\"\n          [label]=\"'others.consent' | fswTranslate\"\n        ></fsw-checkbox>\n        <button fswButton [disabled]=\"isDisabledPull\" (click)=\"checkPull()\">\n          {{ 'buttons.pull_ctos_data' | fswTranslate }}\n        </button>\n      </ng-template>\n    </footer>\n  </ng-template>\n</fsw-modal>\n" }]
        }], ctorParameters: function () { return [{ type: i1$7.DialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_CTOS_PULL_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_CTOS_PULL_BIP_SELECTION_TABLE_BUILDER_TOKEN]
                }] }, { type: i0.ChangeDetectorRef }, { type: i1$7.Dialog }, { type: i0.Injector }]; } });

class FSWCtosPullDialogComponent {
    constructor(dialogRef, _componentStore, _builder) {
        this.dialogRef = dialogRef;
        this._componentStore = _componentStore;
        this._builder = _builder;
        this.formGroup = new UntypedFormGroup({});
        this.builder = this._builder({
            form: this.formGroup,
        });
        this.formGroup.patchValue(this._componentStore.state().ctosEntity || {});
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullDialogComponent, deps: [{ token: i1$7.DialogRef }, { token: FSW_CTOS_PULL_STORE_TOKEN }, { token: FSW_CTOS_PULL_FORM_BUILDER_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCtosPullDialogComponent, selector: "fsw-ctos-pull-dialog", ngImport: i0, template: "<fsw-modal\n  [size]=\"'m'\"\n  [title]=\"'others.pull_ctos' | fswTranslate\"\n  [hiddenCloseButton]=\"true\"\n  [confirmButton]=\"'buttons.continue' | fswTranslate\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate\"\n  (cancelEvent)=\"dialogRef.close(undefined)\"\n  (confirmEvent)=\"dialogRef.close(formGroup.value)\"\n>\n  <ng-template fswModalBody>\n    <p>{{ 'others.connect_ctos' | fswTranslate }}</p>\n    <form [formGroup]=\"formGroup\">\n      <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n    </form>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-ctos-pull-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal\n  [size]=\"'m'\"\n  [title]=\"'others.pull_ctos' | fswTranslate\"\n  [hiddenCloseButton]=\"true\"\n  [confirmButton]=\"'buttons.continue' | fswTranslate\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate\"\n  (cancelEvent)=\"dialogRef.close(undefined)\"\n  (confirmEvent)=\"dialogRef.close(formGroup.value)\"\n>\n  <ng-template fswModalBody>\n    <p>{{ 'others.connect_ctos' | fswTranslate }}</p>\n    <form [formGroup]=\"formGroup\">\n      <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n    </form>\n  </ng-template>\n</fsw-modal>\n" }]
        }], ctorParameters: function () { return [{ type: i1$7.DialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_CTOS_PULL_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_CTOS_PULL_FORM_BUILDER_TOKEN]
                }] }]; } });

class FSWCtosPullInformationComponent {
    constructor(_componentStore, _builder, _cdr) {
        this._componentStore = _componentStore;
        this._builder = _builder;
        this._cdr = _cdr;
        this.pullEvent = new EventEmitter();
        this.resetEvent = new EventEmitter();
        this.state$ = this._componentStore.state$.pipe(tap((state) => {
            const { latestHistory, ctosEntity, processing, memberSingle } = state;
            this.builder = this._builder({
                form: this.formGroup,
                isAlreadyPulled: !!latestHistory,
            });
            this.formGroup.patchValue({
                entityName: ctosEntity?.entityName || 'None',
                entityNo: ctosEntity?.entityNo || 'None',
                status: memberSingle?.companyCtosEntity ||
                    processing ||
                    (!memberSingle?.companyCtosEntity && latestHistory?.status.toLowerCase() === 'failed')
                    ? latestHistory?.status
                    : 'None',
                createdBy: latestHistory?.createdBy,
                createdAt: this.formatDate(latestHistory?.createdAt),
                enableSSM: memberSingle?.companyCtosEntity ||
                    processing ||
                    (!memberSingle?.companyCtosEntity && latestHistory?.status.toLowerCase() === 'failed')
                    ? latestHistory?.enableSSM
                    : false,
            });
            this._cdr.markForCheck();
        }));
        this.formGroup = new UntypedFormGroup({});
        this.builder = this._builder({
            form: this.formGroup,
            isAlreadyPulled: !!this._componentStore.state().latestHistory,
        });
    }
    formatDate(value) {
        try {
            return new DatePipe('en-US').transform(value, 'dd-MM-yyyy, hh:mm') || '';
        }
        catch {
            return `${value}`;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullInformationComponent, deps: [{ token: FSW_CTOS_PULL_STORE_TOKEN }, { token: FSW_CTOS_PULL_INFORMATION_FORM_BUILDER_TOKEN }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCtosPullInformationComponent, selector: "fsw-ctos-pull-information", outputs: { pullEvent: "pullEvent", resetEvent: "resetEvent" }, ngImport: i0, template: "<ng-container *ngIf=\"state$ | async as state\">\n  <section class=\"ctos-pull-information\">\n    <form [formGroup]=\"formGroup\">\n      <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n    </form>\n    <button\n      *ngIf=\"!state.isReadonly\"\n      fswButton\n      [appearance]=\"state.memberSingle?.companyCtosEntity ? 'secondary' : 'primary'\"\n      (click)=\"state.memberSingle?.companyCtosEntity ? resetEvent.emit() : pullEvent.emit()\"\n    >\n      <ng-container *ngIf=\"state.processing; else completeTemplate\">\n        {{ 'buttons.refresh' | fswTranslate }}\n      </ng-container>\n      <ng-template #completeTemplate>\n        <ng-container *ngIf=\"state.memberSingle?.companyCtosEntity; else pullTemplate\">\n          {{ 'buttons.reset_company_ctos' | fswTranslate }}\n        </ng-container>\n        <ng-template #pullTemplate>\n          {{ 'buttons.pull_company_ctos' | fswTranslate }}\n        </ng-template>\n      </ng-template>\n    </button>\n  </section>\n</ng-container>\n", styles: [":host .ctos-pull-information{display:flex;flex-direction:column;gap:.75rem}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullInformationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-ctos-pull-information', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"state$ | async as state\">\n  <section class=\"ctos-pull-information\">\n    <form [formGroup]=\"formGroup\">\n      <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n    </form>\n    <button\n      *ngIf=\"!state.isReadonly\"\n      fswButton\n      [appearance]=\"state.memberSingle?.companyCtosEntity ? 'secondary' : 'primary'\"\n      (click)=\"state.memberSingle?.companyCtosEntity ? resetEvent.emit() : pullEvent.emit()\"\n    >\n      <ng-container *ngIf=\"state.processing; else completeTemplate\">\n        {{ 'buttons.refresh' | fswTranslate }}\n      </ng-container>\n      <ng-template #completeTemplate>\n        <ng-container *ngIf=\"state.memberSingle?.companyCtosEntity; else pullTemplate\">\n          {{ 'buttons.reset_company_ctos' | fswTranslate }}\n        </ng-container>\n        <ng-template #pullTemplate>\n          {{ 'buttons.pull_company_ctos' | fswTranslate }}\n        </ng-template>\n      </ng-template>\n    </button>\n  </section>\n</ng-container>\n", styles: [":host .ctos-pull-information{display:flex;flex-direction:column;gap:.75rem}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_CTOS_PULL_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_CTOS_PULL_INFORMATION_FORM_BUILDER_TOKEN]
                }] }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { pullEvent: [{
                type: Output
            }], resetEvent: [{
                type: Output
            }] } });

class FSWCtosPullConfirmationDialogComponent {
    constructor(dialogRef) {
        this.dialogRef = dialogRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullConfirmationDialogComponent, deps: [{ token: i1$7.DialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCtosPullConfirmationDialogComponent, selector: "fsw-ctos-pull-confirmation-dialog", ngImport: i0, template: "<fsw-modal\n  [title]=\"'others.confirmation' | fswTranslate\"\n  [hiddenCloseButton]=\"true\"\n  [confirmButton]=\"'buttons.continue' | fswTranslate\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate\"\n  (cancelEvent)=\"dialogRef.close(false)\"\n  (confirmEvent)=\"dialogRef.close(true)\"\n>\n  <ng-template fswModalBody>\n    <p>{{ 'others.reset_ctos_warning' | fswTranslate }}</p>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullConfirmationDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-ctos-pull-confirmation-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal\n  [title]=\"'others.confirmation' | fswTranslate\"\n  [hiddenCloseButton]=\"true\"\n  [confirmButton]=\"'buttons.continue' | fswTranslate\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate\"\n  (cancelEvent)=\"dialogRef.close(false)\"\n  (confirmEvent)=\"dialogRef.close(true)\"\n>\n  <ng-template fswModalBody>\n    <p>{{ 'others.reset_ctos_warning' | fswTranslate }}</p>\n  </ng-template>\n</fsw-modal>\n" }]
        }], ctorParameters: function () { return [{ type: i1$7.DialogRef }]; } });

var fields$l = {
	company_name: "Company Name",
	brn: "BRN",
	type_of_api: "Type of API",
	latest_status: "Latest Status",
	latest_pull_by: "Latest Pull By",
	latest_pull_at: "Latest Pull At",
	full_brn: "NRIC/Passport/BRN/CRN",
	name: "Name",
	entity_type: "Entity Type"
};
var options$2 = {
	entity_type: {
		individual: "Individual",
		company: "Company",
		business: "Business"
	},
	type_of_api: {
		ctos_ssm: "CTOS + SSM",
		only_ctos: "Only CTOS"
	}
};
var buttons$E = {
	reset_company_ctos: "Reset Company CTOS",
	pull_ctos_request: "Pull CTOS Request",
	pull_company_ctos: "Pull Company CTOS",
	download_ctos_document: "Download CTOS Document",
	view_bips: "View BIPs",
	cancel: "Cancel",
	pull_ctos: "Pull CTOS",
	refresh: "Refresh",
	"continue": "Continue",
	add_bip: "Add BIP",
	pull_ctos_data: "Pull CTOS Data",
	link: "Link to Application"
};
var columns$8 = {
	id_number: "ID Number",
	name: "Name",
	status: "Status",
	date_of_pull: "Date of Pull",
	pulled_by: "Pulled By",
	bip: "BIP",
	designation: "Designation",
	ctos_ccris: "CTOS/CCRIS",
	primary_borrower: "Primary Borrower",
	application_link: "Application Link"
};
var others$4 = {
	reset_ctos_warning: "Are you sure to reset company ctos entity of this borrower?",
	bip_title: "Borrower - Business Interest Parties",
	bip_warning: "Use the individual’s NRIC/Passport or BRN/CRN to connect to CTOS.",
	bip_adding: "Add BIP",
	bip_description_1: "After you <strong>add</strong> and <strong>pull CTOS</strong> report for the BIP, the BIP need to be <strong>linked to the application</strong>. You can link the BIP by <strong>clicking “View BIPs” link</strong> and link the BIP to the application",
	bip_description_2: "Only BIP shown in the Application - BIP section will be used for screening by the system",
	latest_request: "Last CTOS Report request: ",
	connect_ctos: "Use the company’s BRN/CRN to connect to CTOS",
	entity_type: "Entity Type",
	pull_ctos: "Pull CTOS",
	confirmation: "Confirmation",
	already_pulled: "Already Pulled",
	linked: "Linked",
	not_yet_linked: "Not yet Linked",
	history: "History",
	confirmation_warning: "Are you sure to reset company ctos entity of this borrower",
	pull_success_warning: "BRC for the borrower has been successfully pulled",
	reselect_warning: "CTOS has returned multiple records for one or more of the BIPs selected, please re-select BIPs",
	consent: "I’ve got the consent from all people in this list to pull their CTOS data.",
	pull_selected_warning: "You are selecting some BIPs that have already been pulled by CTOs in the past.<br/>Do you want to re-pull them?"
};
var my$h = {
	fields: fields$l,
	options: options$2,
	buttons: buttons$E,
	columns: columns$8,
	others: others$4
};

var MY$e = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$E,
    columns: columns$8,
    default: my$h,
    fields: fields$l,
    options: options$2,
    others: others$4
});

const FSW_CTOS_PULL_TRANSLATION_LOADER = {
    [CountryCode.MY]: MY$e,
};

class FSWCtosPullStore extends ApplicationMemberInformationStore {
    constructor(_ctosService, _memberService, _applicationMemberBipService, _applicationGuarantorService, _creditGuarantorService, _alertService, _applicationServiceService, _initialState) {
        super(_applicationServiceService, _initialState);
        this._ctosService = _ctosService;
        this._memberService = _memberService;
        this._applicationMemberBipService = _applicationMemberBipService;
        this._applicationGuarantorService = _applicationGuarantorService;
        this._creditGuarantorService = _creditGuarantorService;
        this._alertService = _alertService;
        this._applicationServiceService = _applicationServiceService;
        this._initialState = _initialState;
        this.resetFlowEvent = new EventEmitter();
        this.linkEvent = new EventEmitter();
        this.pullEvent = new EventEmitter();
        this.pullManyEvent = new EventEmitter();
        this.resetEvent = new EventEmitter();
        this.autoProcessCtosListenerSubject = new Subject();
        this.stopAutoListenerSubject = new Subject();
        this.showSelectionBip$ = new Subject();
        this.second$ = new BehaviorSubject(0);
        this.historyMap = new Map();
        this.init = this.effect(pipe(mergeMap((cdr) => this.setupInformation(this.get().entityId).pipe(mapTo(cdr))), tap((cdr) => {
            this.autoProcessCtos(cdr);
            this.refresh();
        })));
        this.autoProcessCtos = this.effect(pipe(switchMap((cdr) => this.autoProcessCtosListenerSubject.pipe(tap(() => this.stopAutoListenerSubject.next(new Date())), switchMap(() => timer(0, 1000).pipe(takeUntil(this.stopAutoListenerSubject), take(30), tap((value) => {
            this.second$.next(30 - value);
            cdr.markForCheck();
            if (value === 29) {
                this.pullCtos(this.state().ctosEntity);
                this.stopAutoListenerSubject.next(new Date());
            }
        }))))), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        this.fetchMember = this.effect(pipe(switchMap((cb) => {
            return this._memberService.getSingleMember(Number(this.state().member?.id)).pipe(tap((memberSingle) => {
                this.updateState({
                    memberSingle,
                });
                cb();
            }));
        }), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        this.fetchBip = this.effect(pipe(switchMap((cb) => {
            return this._memberService
                .getBips(this.state().ctosEntity?.entityNo)
                .pipe(switchMap((bips) => {
                if (!bips?.length) {
                    return of([]);
                }
                return forkJoin(bips
                    .filter((bip) => !!bip?.ctosEntity) // filter to make sure only check bip if available ctosEntity
                    .map((bip) => {
                    const { ctosEntity } = bip;
                    const { entityNo, entityKey, entityType } = parseCtosEntity(ctosEntity);
                    return this._ctosService.history({
                        ...(entityType ? { entityType } : {}),
                        ...(entityKey ? { entityKey } : {}),
                        ...(entityNo ? { entityNo } : {}),
                        statuses: [
                            FSWCTOSPullStatuses.SUCCESS,
                            FSWCTOSPullStatuses.IN_PROGRESS,
                            FSWCTOSPullStatuses.FAILED,
                        ],
                    });
                })).pipe(
                // sometime API return null, so need to filter to make sure don't have any null items before flatten array
                map((bipHistories) => bipHistories.filter((bipHistory) => bipHistory?.length)), 
                // before flatten (Array<Array<T>>) -> flatten because only need to get only Array<T>
                map((bipHistories) => flatten(bipHistories)));
            }))
                .pipe(tap((histories) => {
                this.historyMap.clear();
                histories.forEach((history) => {
                    const currentHistory = this.historyMap.get(`${history.entityNo}${history.entityName}`);
                    if (currentHistory) {
                        const currentDate = new Date(currentHistory.createdAt);
                        const newDate = new Date(history.createdAt);
                        if (newDate.getTime() > currentDate.getTime()) {
                            this.historyMap.set(`${history.entityNo}${history.entityName}`, history);
                        }
                    }
                    else {
                        this.historyMap.set(`${history.entityNo}${history.entityName}`, history);
                    }
                });
                this.updateState({
                    histories,
                    renderHistories: Array.from(this.historyMap.values()),
                });
                cb && cb();
            }));
        }), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        this.fetchHistory = this.effect(pipe(switchMap((processing) => {
            const { member, ctosEntity, memberSingle } = this.state();
            return this._ctosService
                .history({
                ...(memberSingle?.companyCtosEntity
                    ? ctosEntity
                    : {
                        memberID: Number(member?.id),
                    }),
                statuses: [
                    FSWCTOSPullStatuses.SUCCESS,
                    FSWCTOSPullStatuses.IN_PROGRESS,
                    FSWCTOSPullStatuses.FAILED,
                ],
            })
                .pipe(map((histories) => this._getHistoryLatestByCheckingCtos(histories)), tap((history) => {
                if (processing && history && history.status === FSWCTOSPullStatuses.SUCCESS) {
                    this.stopAutoListenerSubject.next(new Date());
                    this._alertService.success('Success', 'Borrower successfully pull ctos entity.', {
                        duration: 1000,
                    });
                    this.resetFlowEvent.emit();
                    return;
                }
                this.updateState({
                    latestHistory: history,
                });
                if (memberSingle?.companyCtosEntity && !processing && history) {
                    this.updateState({
                        ctosEntity: {
                            ...(ctosEntity || {}),
                            enableSSM: history?.enableSSM,
                            entityKey: history?.entityKey,
                            entityName: history?.entityName,
                            entityNo: history?.entityNo,
                        },
                    });
                }
                // if (!processing) {
                //   this.updateState({
                //     ctosEntity: {
                //       ...(ctosEntity || {}),
                //       previousReportId: history?.reportID,
                //     }
                //   });
                // }
            }));
        }), catchError((err) => {
            console.error(err);
            this.updateState({
                latestHistory: null,
            });
            return EMPTY;
        })));
        this.reset = this.effect(pipe(switchMap(() => {
            return this._memberService
                .updateMember(this.state().member?.uuid, {
                companyCtosEntity: '',
            })
                .pipe(tap(() => {
                this.resetEvent.emit();
                this.refresh();
                this._alertService.success('Success', 'Borrower successfully updated (reset company ctos entity).', {
                    duration: 2000,
                });
            }));
        }), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        this.showReport = this.effect(pipe(switchMap((reportId) => {
            return this._ctosService.fetchReport(reportId).pipe(tap((report) => {
                showBlankHTML(report);
            }));
        }), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        this.pullCtos = this.effect(pipe(switchMap((data) => {
            const { processing, member, ctosEntity } = this.state();
            const oldProcessing = cloneDeep(processing);
            this.updateState({
                processing: false,
            });
            this.stopAutoListenerSubject.next(new Date());
            const payload = {
                ...data,
                memberID: Number(member?.id),
                entityKey: ctosEntity?.entityKey,
                ...(ctosEntity?.previousReportId
                    ? { previousReportId: ctosEntity.previousReportId }
                    : {}),
                allowSaveDataAfterPull: true,
            };
            return this._ctosService.pull(payload).pipe(tap((res) => {
                this.pullEvent.emit();
                const updatedCtosEntity = cloneDeep(payload);
                this.updateState({
                    ctosEntity: updatedCtosEntity,
                });
                if (res.status === FSWCTOSPullStatuses.IN_PROGRESS) {
                    updatedCtosEntity.previousPullID = res.pullId;
                    delete updatedCtosEntity.previousReportId;
                    this.updateState({
                        ctosEntity: updatedCtosEntity,
                    });
                    this.updateState({
                        processing: true,
                    });
                    this.autoProcessCtosListenerSubject.next(new Date());
                    this.fetchHistory(true);
                    if (!oldProcessing) {
                        this._activePullBipWithTimeout();
                    }
                }
                else if (res.status === FSWCTOSPullStatuses.SUCCESS) {
                    updatedCtosEntity.previousReportId = res.reportId;
                    delete updatedCtosEntity.previousPullID;
                    this.updateState({
                        ctosEntity: updatedCtosEntity,
                    });
                    this.fetchMember(() => {
                        if (!this.state().memberSingle?.companyCtosEntity) {
                            this.pullCtos(updatedCtosEntity);
                            return;
                        }
                        this._alertService.success('Success', 'Borrower successfully pull ctos entity.', {
                            duration: 2000,
                        });
                        this.resetFlowEvent.emit();
                        this.fetchHistory(false);
                        if (!oldProcessing) {
                            this._activePullBipWithTimeout();
                        }
                    });
                }
                else {
                    delete updatedCtosEntity.previousPullID;
                    this.updateState({
                        ctosEntity: updatedCtosEntity,
                    });
                    this._alertService.error('Error', 'Borrower pull ctos entity failed.', {
                        duration: 2000,
                    });
                    this.fetchHistory(false);
                    if (!oldProcessing) {
                        this._activePullBipWithTimeout();
                    }
                }
            }));
        }), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        this.fetchBIPsByMemberId = this.effect(pipe(switchMap((cb) => {
            return forkJoin([
                this._memberService
                    .getBips(this.state().ctosEntity?.entityNo)
                    .pipe(map((bips) => bips || [])),
                this._applicationMemberBipService
                    .getApplicationMemberBIPs(this.state().entityId, this.state().member?.uuid, {
                    expand: true,
                })
                    .pipe(map((res) => (res || [])
                    .filter((item) => item.reference_to.toUpperCase() === 'MEMBER_BIP')
                    .map((item) => item.reference_id))),
            ]).pipe(tap(([bips, applicationBipIds]) => cb(bips, applicationBipIds)));
        }), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        this.linkToApplication = this.effect(pipe(tap(({ id, cb }) => {
            this.fetchBIPsByMemberId((bips, applicationBipIds) => this.generateGuarantor({
                id,
                bips,
                applicationBipIds,
                cb: (cbBips, cbApplicationBipIds) => {
                    this.linkEvent.emit();
                    cb(cbBips, cbApplicationBipIds);
                },
            }));
        }), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        this.generateGuarantor = this.effect(pipe(switchMap(({ id, bips, applicationBipIds, cb }) => {
            const data = bips.find((bip) => bip.id === id);
            const recourseType = data?.recourseType;
            if (recourseType === FSWRecourseTypes.PG || recourseType === FSWRecourseTypes.CG) {
                return this._applicationGuarantorService
                    .getSummaries(this.get().entityId)
                    .pipe(switchMap((summaries) => {
                    const existed = summaries.some((s) => s.business_interest_party_id === id);
                    if (existed) {
                        return this._applicationMemberBipService.linkMemberBips(this.state().entityId, {
                            memberId: this.state().member?.uuid,
                            reference_id: id,
                            reference_to: 'MEMBER_BIP',
                        });
                    }
                    return this._creditGuarantorService
                        .ctosExtract(Number(this.get()?.member?.id))
                        .pipe(switchMap((data) => {
                        const bip = data.find((item) => item.id === id);
                        if (recourseType === FSWRecourseTypes.PG) {
                            return this._creditGuarantorService
                                .addPersonalSummaries([this._generatePGData(bip)])
                                .pipe(map((data) => ({
                                guarantor_summary_id: data[0].id,
                                guarantor_summary_type: recourseType,
                                business_interest_party_id: id,
                            })));
                        }
                        else {
                            return this._creditGuarantorService
                                .addCorporateSummaries([this._generateCGData(bip)])
                                .pipe(map((data) => ({
                                guarantor_summary_id: data[0].id,
                                guarantor_summary_type: recourseType,
                                business_interest_party_id: id,
                            })));
                        }
                    }), switchMap((data) => this._applicationGuarantorService.addSummaries(this.get().entityId, [data])));
                }))
                    .pipe(tap(() => {
                    this.fetchBIPsByMemberId(cb);
                }));
            }
            return this._applicationMemberBipService
                .linkMemberBips(this.state().entityId, {
                memberId: this.state().member?.uuid,
                reference_id: id,
                reference_to: 'MEMBER_BIP',
            })
                .pipe(tap(() => {
                this.fetchBIPsByMemberId(cb);
            }));
        }), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        this.pullMany = this.effect(pipe(switchMap((data) => {
            return this._ctosService.pullMany(data).pipe(tap(() => {
                this.pullManyEvent.emit();
                this.refresh();
                this._alertService.success('Success', 'Pull BIPs successfully!', {
                    duration: 2000,
                });
            }));
        }), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        this.pullBIPsAndFetchMember = this.effect(pipe(switchMap((cb) => {
            return forkJoin([
                this._memberService.getBips(this.state().ctosEntity?.entityNo),
                this._ctosService.pullBips({
                    entityNo: this.state().ctosEntity?.entityNo,
                    entityName: this.state().ctosEntity?.entityName,
                    entityType: this.state().ctosEntity?.entityType,
                }),
            ]).pipe(tap(([bips, pullBips]) => cb(bips, pullBips)));
        }), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        this.updateState = (value) => this.patchState({
            ...this.state(),
            ...value,
        });
    }
    refresh() {
        this.stopAutoListenerSubject.next(new Date());
        this.updateState({
            processing: false,
        });
        this.fetchMember(() => {
            this.fetchEntity();
        });
    }
    fetchEntity() {
        if (!this.state().memberSingle) {
            return;
        }
        this.updateState({
            ctosEntity: getEntityInfoAuto(this.state().memberSingle),
        });
        this.fetchBip(null);
        this.fetchHistory(false);
    }
    showSelectionBip() {
        this.showSelectionBip$.next(new Date());
    }
    _getHistoryLatestByCheckingCtos(histories) {
        const { memberSingle, ctosEntity, member } = this.state();
        if (memberSingle?.companyCtosEntity) {
            histories = histories.filter((history) => history.entityNo === ctosEntity?.entityNo);
        }
        else {
            histories = histories.filter((history) => history.entityNo === member?.company_registration_number ||
                history.entityNo === member?.company_registration_number_new_format);
        }
        const history = histories.shift();
        if (history?.status === FSWCTOSPullStatuses.FAILED &&
            history?.createdBy !== localStorage.getItem('userName') &&
            history?.createdBy !== 'SYSTEM') {
            return null;
        }
        return history || null;
    }
    _activePullBipWithTimeout() {
        const timeout = setTimeout(() => {
            this.showSelectionBip();
            clearTimeout(timeout);
        }, 2000);
    }
    _generatePGData(data) {
        const summary = data?.summary?.IndividualSummary;
        if (summary) {
            return summary;
        }
        return {
            age: 0,
            name: '',
            gender: '',
            nationality: '',
            race: '',
            role: '',
            shareholder_percentage: 0,
            negative_and_black_list: '',
            num_of_borrowing: 0,
            total_monthly_commitment_non_bank_lender: 0,
            num_of_recent_credit_applications: 0,
            total_outstanding_amount_trade_reference: 0,
            noa_year1: 0,
            noa_year1_total_income: 0,
            noa_year2: 0,
            noa_year2_total_income: 0,
            total_borrowing_limit: 0,
            total_borrowing_outstanding: 0,
            does_own_property_in_my: false,
            desktop_valuation_of_my_owned_property: 0,
            total_monthly_commitment: 0,
            credit_application_commitment: 0,
            payment_behavior: '',
            litigation: '',
            background_and_experience: '',
        };
    }
    _generateCGData(data) {
        const summary = data?.summary?.Company;
        if (summary) {
            return {
                company: summary,
            };
        }
        return {
            company: {
                num_of_employee: 0,
                num_of_customers: 0,
                avg_num_of_days_to_pay_creditors: 0,
                num_of_searches: 0,
                negative_blacklist: '',
                total_num_of_legal_cases: 0,
                total_value_of_legal_cases: 0,
                payment_behavior: '',
                business_nature: '',
                litigation: '0;0',
                num_of_litigation_cases: 0,
                value_of_litigation_cases: 0,
                outstanding_trade_amount: 0,
                num_of_borrowing: 0,
                total_borrowing_limit: 0,
                total_borrowing_outstanding: 0,
                ctos_grade: '',
                ctos_sme_score: 0,
                total_monthly_commitment: 0,
                credit_application_commitment: 0,
                num_of_recent_credit_applications: 0,
                num_of_ongoing_moneylender_loans: 0,
                working_capital_line: 0,
                existing_working_capital_line: 0,
                total_monthly_commitment_non_bank_lender: 0,
            },
        };
    }
}

class FSWCtosPullStoreMY extends FSWCtosPullStore {
    constructor(ctosService, memberService, applicationMemberBipService, applicationGuarantorService, creditGuarantorService, alertService, applicationServiceService) {
        super(ctosService, memberService, applicationMemberBipService, applicationGuarantorService, creditGuarantorService, alertService, applicationServiceService, {
            entityId: null,
            member: null,
            memberSingle: null,
            isReadonly: false,
            ctosEntity: null,
            histories: [],
            renderHistories: [],
            latestHistory: null,
            processing: false,
        });
        this.ctosService = ctosService;
        this.memberService = memberService;
        this.applicationMemberBipService = applicationMemberBipService;
        this.applicationGuarantorService = applicationGuarantorService;
        this.creditGuarantorService = creditGuarantorService;
        this.alertService = alertService;
        this.applicationServiceService = applicationServiceService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullStoreMY, deps: [{ token: FSW_CTOS_SERVICE_TOKEN }, { token: MEMBER_SERVICE_TOKEN }, { token: APPLICATION_MEMBER_BIP_SERVICE_TOKEN }, { token: APPLICATION_GUARANTOR_SERVICE_TOKEN }, { token: CREDIT_GUARANTOR_SERVICE_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }, { token: APPLICATION_MEMBER_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullStoreMY }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullStoreMY, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_CTOS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_BIP_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_GUARANTOR_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CREDIT_GUARANTOR_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_SERVICE_TOKEN]
                }] }]; } });

const translation = FSW_CTOS_PULL_TRANSLATION_LOADER[CountryCode.MY];
const FSWCtosPullInformationFormBuilderMY = (config) => {
    const { form, isReadonly, isAlreadyPulled } = config;
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'flex gap-4 w-full',
        form,
        renderBy: 'container',
        readonlyWhen$: of(!!isReadonly),
        containers: [
            {
                customClasses: 'flex flex-col gap-4 w-[calc(50%-1rem)]',
                fields: [
                    {
                        key: 'entityName',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        customClasses: 'w-full',
                        context: {
                            isDisabled: true,
                            label: translation.fields.company_name,
                            fullWidth: true,
                        },
                    },
                    {
                        key: 'entityNo',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        customClasses: 'w-full',
                        context: {
                            isDisabled: true,
                            label: translation.fields.brn,
                            fullWidth: true,
                        },
                    },
                    ...(isAlreadyPulled
                        ? [
                            {
                                key: 'enableSSM',
                                type: FSWDynamicBuilderControlTypes.CHECKBOX,
                                customClasses: 'w-full',
                                context: {
                                    isDisabled: true,
                                    label: translation.fields.type_of_api,
                                    renderTemplate: {
                                        label: translation.options.type_of_api.ctos_ssm,
                                    },
                                    fullWidth: true,
                                },
                            },
                        ]
                        : []),
                ],
            },
            {
                customClasses: 'flex flex-col gap-4 w-[calc(50%-1rem)]',
                fields: [
                    {
                        key: 'status',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        customClasses: 'w-full',
                        context: {
                            isDisabled: true,
                            label: translation.fields.latest_status,
                            fullWidth: true,
                        },
                    },
                    ...(isAlreadyPulled
                        ? [
                            {
                                key: 'createdBy',
                                type: FSWDynamicBuilderControlTypes.INPUT,
                                customClasses: 'w-full',
                                context: {
                                    isDisabled: true,
                                    label: translation.fields.latest_pull_by,
                                    fullWidth: true,
                                },
                            },
                            {
                                key: 'createdAt',
                                type: FSWDynamicBuilderControlTypes.INPUT,
                                customClasses: 'w-full',
                                context: {
                                    isDisabled: true,
                                    label: translation.fields.latest_pull_at,
                                    fullWidth: true,
                                },
                            },
                        ]
                        : [
                            {
                                key: 'enableSSM',
                                type: FSWDynamicBuilderControlTypes.CHECKBOX,
                                customClasses: 'w-full',
                                context: {
                                    isDisabled: true,
                                    label: translation.fields.type_of_api,
                                    renderTemplate: {
                                        label: translation.options.type_of_api.ctos_ssm,
                                    },
                                    fullWidth: true,
                                },
                            },
                        ]),
                ],
            },
        ],
    });
};
const FSWCtosPullFormBuilderMY = (config) => {
    const { form, isReadonly } = config;
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'w-full flex flex-col gap-4',
        form,
        readonlyWhen$: of(!!isReadonly),
        fields: [
            {
                key: 'entityName',
                type: FSWDynamicBuilderControlTypes.INPUT,
                customClasses: 'w-full',
                context: {
                    label: translation.fields.name,
                    isRequired: true,
                    fullWidth: true,
                },
                validations: [Validators.required],
            },
            {
                key: 'entityNo',
                type: FSWDynamicBuilderControlTypes.INPUT,
                customClasses: 'w-full',
                context: {
                    label: translation.fields.full_brn,
                    isRequired: true,
                    fullWidth: true,
                },
                validations: [Validators.required],
            },
            {
                key: 'entityType',
                type: FSWDynamicBuilderControlTypes.RADIO_GROUP,
                customClasses: 'w-full',
                context: {
                    label: translation.fields.entity_type,
                    items: [
                        {
                            value: 'C',
                            renderTemplate: {
                                label: translation.options.entity_type.company,
                            },
                        },
                        {
                            value: 'B',
                            renderTemplate: {
                                label: translation.options.entity_type.business,
                            },
                        },
                    ],
                    defaultValue: 'C',
                    fullWidth: true,
                },
            },
            {
                key: 'enableSSM',
                type: FSWDynamicBuilderControlTypes.RADIO_GROUP,
                customClasses: 'w-full',
                context: {
                    label: translation.fields.type_of_api,
                    items: [
                        {
                            value: false,
                            renderTemplate: {
                                label: translation.options.type_of_api.only_ctos,
                            },
                        },
                        {
                            value: true,
                            renderTemplate: {
                                label: translation.options.type_of_api.ctos_ssm,
                            },
                        },
                    ],
                    defaultValue: false,
                    fullWidth: true,
                },
            },
        ],
    });
};
const FSWCtosPullBipFormBuilderMY = (config) => {
    const { form, isReadonly } = config;
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'w-full flex flex-col gap-3',
        form,
        readonlyWhen$: of(!!isReadonly),
        fields: [
            {
                key: 'entityName',
                type: FSWDynamicBuilderControlTypes.INPUT,
                customClasses: 'w-full',
                context: {
                    label: translation.fields.name,
                    isRequired: true,
                    fullWidth: true,
                },
                validations: [Validators.required],
            },
            {
                key: 'entityNo',
                type: FSWDynamicBuilderControlTypes.INPUT,
                customClasses: 'w-full',
                context: {
                    label: translation.fields.full_brn,
                    isRequired: true,
                    fullWidth: true,
                },
                validations: [Validators.required],
            },
            {
                key: 'entityType',
                type: FSWDynamicBuilderControlTypes.RADIO_GROUP,
                customClasses: 'w-full',
                context: {
                    label: translation.fields.entity_type,
                    items: [
                        {
                            value: 'I',
                            renderTemplate: {
                                label: translation.options.entity_type.individual,
                            },
                        },
                        {
                            value: 'C',
                            renderTemplate: {
                                label: translation.options.entity_type.company,
                            },
                        },
                        {
                            value: 'B',
                            renderTemplate: {
                                label: translation.options.entity_type.business,
                            },
                        },
                    ],
                    defaultValue: 'I',
                    fullWidth: true,
                },
            },
        ],
    });
};
const FSWCtosPullBipStatusTableBuilderMY = (config) => {
    const { form, isReadonly } = config;
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.TABLE,
        customClasses: 'fsw-table w-full table-auto',
        form,
        readonlyWhen$: of(!!isReadonly),
        header: [
            {
                columns: [
                    {
                        label: translation.columns.id_number,
                        customClasses: '!px-4',
                    },
                    {
                        label: translation.columns.name,
                        customClasses: '!px-4',
                    },
                    {
                        label: translation.columns.status,
                        customClasses: '!px-4',
                    },
                    {
                        label: translation.columns.date_of_pull,
                        customClasses: '!px-4',
                    },
                    {
                        label: translation.columns.pulled_by,
                        customClasses: '!px-4',
                    },
                ],
            },
        ],
        items: [
            {
                body: {
                    key: 'list',
                    isLoop: true,
                    data: {
                        columns: [
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'entityNo',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            isReadonly: true,
                                            flexWidth: true,
                                        },
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'entityName',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            isReadonly: true,
                                            flexWidth: true,
                                        },
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'status',
                                        type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                        context: {
                                            templateKey: 'status',
                                            flexWidth: true,
                                        },
                                    },
                                    {
                                        key: 'error',
                                        type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                        context: {
                                            isHidden: true,
                                        },
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'createdAt',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            isReadonly: true,
                                            readonlyTemplate: (value) => {
                                                try {
                                                    return new DatePipe('en-US').transform(value, 'dd-MM-yyyy, hh:mm') || '';
                                                }
                                                catch {
                                                    return `${value}`;
                                                }
                                            },
                                            flexWidth: true,
                                        },
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                customClasses: '!px-4',
                                fields: [
                                    {
                                        key: 'createdBy',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            isReadonly: true,
                                            flexWidth: true,
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                },
            },
        ],
    });
};
const FSWCtosPullBipDetailTableBuilderMY = (config) => {
    const { form, isReadonly } = config;
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.TABLE,
        customClasses: 'fsw-table w-full table-auto',
        form,
        readonlyWhen$: of(!!isReadonly),
        header: [
            {
                columns: [
                    {
                        label: translation.columns.id_number,
                        customClasses: '!px-4',
                    },
                    {
                        label: translation.columns.bip,
                        customClasses: '!px-4',
                    },
                    {
                        label: translation.columns.designation,
                        customClasses: '!px-4 text-center',
                    },
                    {
                        label: translation.columns.ctos_ccris,
                        customClasses: '!px-4 text-center',
                    },
                    {
                        label: translation.columns.primary_borrower,
                        customClasses: '!px-4 text-center',
                    },
                    {
                        label: translation.columns.application_link,
                        customClasses: '!px-4 text-center',
                    },
                ],
            },
        ],
        items: [
            {
                body: {
                    key: 'list',
                    isLoop: true,
                    data: {
                        columns: [
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'entityNo',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            isReadonly: true,
                                            flexWidth: true,
                                        },
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'entityName',
                                        type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                        context: {
                                            templateKey: 'name_link',
                                            flexWidth: true,
                                        },
                                    },
                                    {
                                        key: 'reportID',
                                        type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                        context: {
                                            isHidden: true,
                                        },
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                customClasses: 'text-center',
                                fields: [
                                    {
                                        key: 'designation',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            isReadonly: true,
                                            flexWidth: true,
                                        },
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                customClasses: 'text-center',
                                fields: [
                                    {
                                        key: 'isSelected',
                                        type: FSWDynamicBuilderControlTypes.CHECKBOX,
                                        context: {
                                            isDisabled: true,
                                            flexWidth: true,
                                        },
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                customClasses: 'text-center',
                                fields: [
                                    {
                                        key: 'isPrimaryBorrower',
                                        type: FSWDynamicBuilderControlTypes.CHECKBOX,
                                        context: {
                                            isDisabled: true,
                                            flexWidth: true,
                                        },
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                customClasses: 'text-center',
                                fields: [
                                    {
                                        key: 'id',
                                        type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                        context: {
                                            templateKey: 'id_link',
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                },
            },
        ],
    });
};
const FSWCtosPullBipSelectionTableBuilderMY = (config) => {
    const { form, isReadonly } = config;
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.TABLE,
        customClasses: 'fsw-table w-full table-auto',
        form,
        readonlyWhen$: of(!!isReadonly),
        header: [
            {
                columns: [
                    {
                        label: translation.columns.id_number,
                        customClasses: '!px-4',
                    },
                    {
                        label: translation.columns.bip,
                        customClasses: '!px-4',
                    },
                    {
                        label: translation.columns.designation,
                        customClasses: '!px-4',
                    },
                    {
                        label: translation.columns.ctos_ccris,
                        customClasses: '!px-4',
                    },
                    {
                        label: translation.columns.status,
                        customClasses: '!px-4',
                    },
                ],
            },
        ],
        items: [
            {
                body: {
                    key: 'list',
                    isLoop: true,
                    data: {
                        columns: [
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'entityNo',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            isReadonly: true,
                                            flexWidth: true,
                                        },
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'entityName',
                                        type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                        context: {
                                            templateKey: 'name_link',
                                            flexWidth: true,
                                        },
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'designation',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            isReadonly: true,
                                            flexWidth: true,
                                        },
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'isSelected',
                                        type: FSWDynamicBuilderControlTypes.CHECKBOX,
                                        context: {
                                            flexWidth: true,
                                        },
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'status',
                                        type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                        context: {
                                            templateKey: 'status',
                                            flexWidth: true,
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                },
            },
        ],
    });
};

const FSW_CTOS_PULL_MY_PROVIDERS = [
    {
        provide: FSW_CTOS_PULL_BIP_FORM_BUILDER_TOKEN,
        useValue: FSWCtosPullBipFormBuilderMY,
    },
    {
        provide: FSW_CTOS_PULL_BIP_SELECTION_TABLE_BUILDER_TOKEN,
        useValue: FSWCtosPullBipSelectionTableBuilderMY,
    },
    {
        provide: FSW_CTOS_PULL_BIP_DETAIL_TABLE_BUILDER_TOKEN,
        useValue: FSWCtosPullBipDetailTableBuilderMY,
    },
    {
        provide: FSW_CTOS_PULL_BIP_STATUS_TABLE_BUILDER_TOKEN,
        useValue: FSWCtosPullBipStatusTableBuilderMY,
    },
    {
        provide: FSW_CTOS_PULL_INFORMATION_FORM_BUILDER_TOKEN,
        useValue: FSWCtosPullInformationFormBuilderMY,
    },
    {
        provide: FSW_CTOS_PULL_FORM_BUILDER_TOKEN,
        useValue: FSWCtosPullFormBuilderMY,
    },
    {
        provide: FSW_CTOS_PULL_STORE_TOKEN,
        useClass: FSWCtosPullStoreMY,
        deps: [
            FSW_CTOS_SERVICE_TOKEN,
            MEMBER_SERVICE_TOKEN,
            APPLICATION_MEMBER_BIP_SERVICE_TOKEN,
            APPLICATION_GUARANTOR_SERVICE_TOKEN,
            CREDIT_GUARANTOR_SERVICE_TOKEN,
            FSW_ALERT_SERVICE_TOKEN,
            APPLICATION_MEMBER_SERVICE_TOKEN,
        ],
    },
];

const FSW_CTOS_PULL_PROVIDERS = {
    default: FSW_CTOS_PULL_MY_PROVIDERS,
    [CountryCode.MY]: FSW_CTOS_PULL_MY_PROVIDERS,
};
const ctosPullLoadProviders = (countryCode) => [
    fswTranslateScope('ctos_pull'),
    ...getCustomProviders(FSW_CTOS_PULL_PROVIDERS, FSW_CTOS_PULL_MY_PROVIDERS, countryCode),
];

let FSWCtosPullComponent = class FSWCtosPullComponent {
    set entityId(entityId) {
        this._componentStore.updateState({
            entityId,
        });
    }
    set isReadonly(isReadonly) {
        this._componentStore.updateState({
            isReadonly,
        });
    }
    constructor(_componentStore, _cdr, _dialog, _injector) {
        this._componentStore = _componentStore;
        this._cdr = _cdr;
        this._dialog = _dialog;
        this._injector = _injector;
        this.resetFlowEvent = this._componentStore.resetFlowEvent;
        this.linkEvent = this._componentStore.linkEvent;
        this.pullEvent = this._componentStore.pullEvent;
        this.pullManyEvent = this._componentStore.pullManyEvent;
        this.resetEvent = this._componentStore.resetEvent;
        this.state$ = this._componentStore.state$;
        this.showSelectionBip$ = this._componentStore.showSelectionBip$.pipe(tap(() => this.showSelectionBip()));
    }
    ngOnInit() {
        this.showSelectionBip$.pipe(followDestroy(this)).subscribe();
        this._componentStore.init(this._cdr);
    }
    pull() {
        const { memberSingle, ctosEntity } = this._componentStore.state();
        if (memberSingle?.companyCtosEntity) {
            return;
        }
        if (ctosEntity?.previousPullID) {
            this._componentStore.pullCtos(ctosEntity);
            return;
        }
        this._dialog
            .open(FSWCtosPullDialogComponent, {
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((params) => params && this._componentStore.pullCtos(params)))
            .subscribe();
    }
    reset() {
        const { memberSingle } = this._componentStore.state();
        if (!memberSingle?.companyCtosEntity) {
            return;
        }
        this._dialog
            .open(FSWCtosPullConfirmationDialogComponent, {
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((value) => value && this._componentStore.reset()))
            .subscribe();
    }
    showSelectionBip() {
        this._dialog
            .open(FSWCtosPullSelectionBipComponent, {
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((value) => value && this._componentStore.pullMany(value)))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullComponent, deps: [{ token: FSW_CTOS_PULL_STORE_TOKEN }, { token: i0.ChangeDetectorRef }, { token: i1$7.Dialog }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCtosPullComponent, selector: "fsw-ctos-pull", inputs: { entityId: "entityId", isReadonly: "isReadonly" }, outputs: { resetFlowEvent: "resetFlowEvent", linkEvent: "linkEvent", pullEvent: "pullEvent", pullManyEvent: "pullManyEvent", resetEvent: "resetEvent" }, ngImport: i0, template: "<ng-container *ngIf=\"state$ | async as state\">\n  <fsw-panel *ngIf=\"state.memberSingle as memberSingle\">\n    <section class=\"flex flex-col gap-8 w-full\">\n      <fsw-ctos-pull-information\n        (pullEvent)=\"pull()\"\n        (resetEvent)=\"reset()\"\n      ></fsw-ctos-pull-information>\n      <fsw-ctos-pull-bip *ngIf=\"memberSingle.companyCtosEntity\"></fsw-ctos-pull-bip>\n    </section>\n  </fsw-panel>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "component", type: FSWCtosPullBipComponent, selector: "fsw-ctos-pull-bip" }, { kind: "component", type: FSWCtosPullInformationComponent, selector: "fsw-ctos-pull-information", outputs: ["pullEvent", "resetEvent"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
};
FSWCtosPullComponent = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [Object, ChangeDetectorRef,
        Dialog,
        Injector])
], FSWCtosPullComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-ctos-pull', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"state$ | async as state\">\n  <fsw-panel *ngIf=\"state.memberSingle as memberSingle\">\n    <section class=\"flex flex-col gap-8 w-full\">\n      <fsw-ctos-pull-information\n        (pullEvent)=\"pull()\"\n        (resetEvent)=\"reset()\"\n      ></fsw-ctos-pull-information>\n      <fsw-ctos-pull-bip *ngIf=\"memberSingle.companyCtosEntity\"></fsw-ctos-pull-bip>\n    </section>\n  </fsw-panel>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_CTOS_PULL_STORE_TOKEN]
                }] }, { type: i0.ChangeDetectorRef }, { type: i1$7.Dialog }, { type: i0.Injector }]; }, propDecorators: { resetFlowEvent: [{
                type: Output
            }], linkEvent: [{
                type: Output
            }], pullEvent: [{
                type: Output
            }], pullManyEvent: [{
                type: Output
            }], resetEvent: [{
                type: Output
            }], entityId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

let FSWCtosPullDirective = class FSWCtosPullDirective {
    constructor(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
        this.resetFlowEvent = new EventEmitter();
        this.linkEvent = new EventEmitter();
        this.pullEvent = new EventEmitter();
        this.pullManyEvent = new EventEmitter();
        this.resetEvent = new EventEmitter();
        this.entityId = null;
        this.isReadonly = false;
    }
    ngOnChanges() {
        this._viewContainerRef.clear();
        const ref = this._viewContainerRef.createComponent(FSWCtosPullComponent, {
            injector: Injector.create({
                parent: this._viewContainerRef.injector,
                providers: [...ctosPullLoadProviders(getCountryCodeFromStorage())],
            }),
        });
        const instance = ref.instance;
        instance.entityId = this.entityId;
        instance.isReadonly = this.isReadonly;
        merge(instance.resetFlowEvent.pipe(tap(() => this.resetFlowEvent.emit())), instance.resetEvent.pipe(tap(() => this.resetEvent.emit())), instance.pullEvent.pipe(tap(() => this.pullEvent.emit())), instance.pullManyEvent.pipe(tap(() => this.pullManyEvent.emit())), instance.linkEvent.pipe(tap(() => this.linkEvent.emit())))
            .pipe(followDestroy(this))
            .subscribe();
        ref.changeDetectorRef.detectChanges();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWCtosPullDirective, selector: "[fswCtosPull]", inputs: { entityId: "entityId", isReadonly: "isReadonly" }, outputs: { resetFlowEvent: "resetFlowEvent", linkEvent: "linkEvent", pullEvent: "pullEvent", pullManyEvent: "pullManyEvent", resetEvent: "resetEvent" }, usesOnChanges: true, ngImport: i0 }); }
};
FSWCtosPullDirective = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [ViewContainerRef])
], FSWCtosPullDirective);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswCtosPull]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; }, propDecorators: { resetFlowEvent: [{
                type: Output
            }], linkEvent: [{
                type: Output
            }], pullEvent: [{
                type: Output
            }], pullManyEvent: [{
                type: Output
            }], resetEvent: [{
                type: Output
            }], entityId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class FSWCtosPullModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullModule, declarations: [FSWCtosPullComponent,
            FSWCtosPullDirective,
            FSWCtosPullBipComponent,
            FSWCtosPullDialogComponent,
            FSWCtosPullInformationComponent,
            FSWCtosPullViewBipDialogComponent,
            FSWCtosPullAddBipDialogComponent,
            FSWCtosPullConfirmationDialogComponent,
            FSWCtosPullBipActionComponent,
            FSWCtosPullSelectionBipComponent], imports: [MemberServiceModule,
            ApplicationGuarantorServiceModule,
            ApplicationMemberServiceModule,
            CreditGuarantorServiceModule,
            MemberBIPServiceModule,
            FSWCtosServiceModule,
            DialogModule,
            FSWModalModule$1,
            NgIf,
            AsyncPipe,
            ReactiveFormsModule,
            FSWDynamicBuilderModule,
            FSWTranslateModule,
            FSWButtonModule,
            DatePipe,
            FSWAlertModule,
            FSWCheckboxModule, i1$4.FSWTranslateModule, FSWPanelModule,
            NgSwitch,
            NgSwitchCase,
            FSWIconModule,
            CdkMenuModule,
            FSWTooltipModule], exports: [FSWCtosPullComponent,
            FSWCtosPullDirective,
            FSWCtosPullBipComponent,
            FSWCtosPullDialogComponent,
            FSWCtosPullInformationComponent,
            FSWCtosPullViewBipDialogComponent,
            FSWCtosPullAddBipDialogComponent,
            FSWCtosPullConfirmationDialogComponent,
            FSWCtosPullBipActionComponent,
            FSWCtosPullSelectionBipComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullModule, imports: [MemberServiceModule,
            ApplicationGuarantorServiceModule,
            ApplicationMemberServiceModule,
            CreditGuarantorServiceModule,
            MemberBIPServiceModule,
            FSWCtosServiceModule,
            DialogModule,
            FSWModalModule$1,
            ReactiveFormsModule,
            FSWDynamicBuilderModule,
            FSWTranslateModule,
            FSWButtonModule,
            FSWAlertModule,
            FSWCheckboxModule,
            FSWTranslateModule.forFeature({
                scope: 'ctos_pull',
                defaultKey: CountryCode.MY,
                data: FSW_CTOS_PULL_TRANSLATION_LOADER,
            }),
            FSWPanelModule,
            FSWIconModule,
            CdkMenuModule,
            FSWTooltipModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCtosPullModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FSWCtosPullComponent,
                        FSWCtosPullDirective,
                        FSWCtosPullBipComponent,
                        FSWCtosPullDialogComponent,
                        FSWCtosPullInformationComponent,
                        FSWCtosPullViewBipDialogComponent,
                        FSWCtosPullAddBipDialogComponent,
                        FSWCtosPullConfirmationDialogComponent,
                        FSWCtosPullBipActionComponent,
                        FSWCtosPullSelectionBipComponent,
                    ],
                    exports: [
                        FSWCtosPullComponent,
                        FSWCtosPullDirective,
                        FSWCtosPullBipComponent,
                        FSWCtosPullDialogComponent,
                        FSWCtosPullInformationComponent,
                        FSWCtosPullViewBipDialogComponent,
                        FSWCtosPullAddBipDialogComponent,
                        FSWCtosPullConfirmationDialogComponent,
                        FSWCtosPullBipActionComponent,
                        FSWCtosPullSelectionBipComponent,
                    ],
                    imports: [
                        MemberServiceModule,
                        ApplicationGuarantorServiceModule,
                        ApplicationMemberServiceModule,
                        CreditGuarantorServiceModule,
                        MemberBIPServiceModule,
                        FSWCtosServiceModule,
                        DialogModule,
                        FSWModalModule$1,
                        NgIf,
                        AsyncPipe,
                        ReactiveFormsModule,
                        FSWDynamicBuilderModule,
                        FSWTranslateModule,
                        FSWButtonModule,
                        DatePipe,
                        FSWAlertModule,
                        FSWCheckboxModule,
                        FSWTranslateModule.forFeature({
                            scope: 'ctos_pull',
                            defaultKey: CountryCode.MY,
                            data: FSW_CTOS_PULL_TRANSLATION_LOADER,
                        }),
                        FSWPanelModule,
                        NgSwitch,
                        NgSwitchCase,
                        FSWIconModule,
                        CdkMenuModule,
                        FSWTooltipModule,
                    ],
                }]
        }] });

const SG_PROVIDERS$2 = [
    {
        provide: FORM_CONFIG_TOKEN$5,
        useValue: SG_FORM_CONFIG$5,
    },
];

const ID_PROVIDERS$4 = [
    {
        provide: FORM_CONFIG_TOKEN$5,
        useValue: ID_FORM_CONFIG$5,
    },
];

const PROVIDERS_MAP$4 = {
    default: SG_PROVIDERS$2,
    [CountryCode.SG]: SG_PROVIDERS$2,
    [CountryCode.ID]: ID_PROVIDERS$4,
};
const customerDetailLoadProviders = (countryCode) => [
    ...getCustomProviders(PROVIDERS_MAP$4, SG_PROVIDERS$2, countryCode),
];

class CustomerDetailModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CustomerDetailModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CustomerDetailModule, declarations: [CustomerDetailComponent], imports: [CommonModule, LetDirective, FormWidgetModule], exports: [CustomerDetailComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CustomerDetailModule, providers: [...customerDetailLoadProviders(getCountryCodeFromStorage())], imports: [CommonModule, FormWidgetModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CustomerDetailModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, LetDirective, FormWidgetModule],
                    declarations: [CustomerDetailComponent],
                    exports: [CustomerDetailComponent],
                    providers: [...customerDetailLoadProviders(getCountryCodeFromStorage())],
                }]
        }] });

const FSW_CUSTOMER_ACCEPTANCE_FORM_TOKEN = new InjectionToken('FSW_CUSTOMER_ACCEPTANCE_FORM_TOKEN');

const FSW_CUSTOMER_ACCEPTANCE_ISTOPUP_TOKEN = new InjectionToken('FSW_CUSTOMER_ACCEPTANCE_ISTOPUP_TOKEN');

const FSW_CUSTOMER_ACCEPTANCE_STORE_TOKEN = new InjectionToken('FSW_CUSTOMER_ACCEPTANCE_STORE_TOKEN');

const FSW_CUSTOMER_ACCEPTANCE_TYPE_TOKEN = new InjectionToken('FSW_CUSTOMER_ACCEPTANCE_TYPE_TOKEN');

class FSWCustomerAcceptanceComponent {
    set entityId(entityId) {
        this._componentStore.updateState({
            entityId,
        });
    }
    set proposalType(proposalType) {
        this._componentStore.updateState({
            proposalType,
        });
    }
    constructor(_componentStore) {
        this._componentStore = _componentStore;
        this.form = this._componentStore.group;
        this.builder = this._componentStore.builder;
    }
    ngOnInit() {
        this._componentStore.init();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCustomerAcceptanceComponent, deps: [{ token: FSW_CUSTOMER_ACCEPTANCE_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCustomerAcceptanceComponent, selector: "fsw-customer-acceptance", inputs: { entityId: "entityId", proposalType: "proposalType" }, ngImport: i0, template: "<fsw-panel [title]=\"''\" class=\"w-[700px] flex\">\n  <form [formGroup]=\"form\">\n    <fsw-dynamic-builder [builder]=\"builder\">\n      <ng-template fswDynamicBuilderTemplate key=\"approved_date\" let-value>\n        {{ value | date : 'dd/MM/yyyy' }}\n      </ng-template>\n      <ng-template fswDynamicBuilderTemplate key=\"borrower_rejection_reason\" let-value>\n        <p [innerHTML]=\"value\"></p>\n      </ng-template>\n    </fsw-dynamic-builder>\n  </form>\n</fsw-panel>\n", styles: [":host ::ng-deep form{display:contents}\n"], dependencies: [{ kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWDynamicBuilderTemplateDirective, selector: "[fswDynamicBuilderTemplate]", inputs: ["key"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "pipe", type: i1$1.DatePipe, name: "date" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCustomerAcceptanceComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-customer-acceptance', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-panel [title]=\"''\" class=\"w-[700px] flex\">\n  <form [formGroup]=\"form\">\n    <fsw-dynamic-builder [builder]=\"builder\">\n      <ng-template fswDynamicBuilderTemplate key=\"approved_date\" let-value>\n        {{ value | date : 'dd/MM/yyyy' }}\n      </ng-template>\n      <ng-template fswDynamicBuilderTemplate key=\"borrower_rejection_reason\" let-value>\n        <p [innerHTML]=\"value\"></p>\n      </ng-template>\n    </fsw-dynamic-builder>\n  </form>\n</fsw-panel>\n", styles: [":host ::ng-deep form{display:contents}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_CUSTOMER_ACCEPTANCE_STORE_TOKEN]
                }] }]; }, propDecorators: { entityId: [{
                type: Input
            }], proposalType: [{
                type: Input
            }] } });

var FSWCustomerAcceptanceTypes;
(function (FSWCustomerAcceptanceTypes) {
    FSWCustomerAcceptanceTypes["DEFAULT"] = "my:instantbolt:pending-borrower-approval";
    FSWCustomerAcceptanceTypes["SALE_REVIEW"] = "my:instantbolt:sales-review";
})(FSWCustomerAcceptanceTypes || (FSWCustomerAcceptanceTypes = {}));

var title$p = {
	"default": "Customer Acceptance",
	sale_review: "Sales Review Task"
};
var fields$k = {
	application_number: "Application Number",
	customer_name: "Customer Name",
	approved_date: "Approved Date",
	disbursement_amount: "Disbursement Amount (Rounded Down)",
	total_financing_limit: "Total Financing Limit",
	monthly_repayment_amount: "Monthly Repayment Amount",
	interest_rate: "Monthly interest rate",
	status: "Status of Customer Acceptance",
	borrower_rejection_reason: "Borrower Rejection Reason",
	tenor: "Tenure",
	settlement_amount: "Settlement Amount",
	utilisation_fee: "Utilisation Fee",
	origination_fee: "Origination Fee",
	guarantee_fee: "Guarantee Fee",
	payment_due_date: "Offer Deadline"
};
var my$g = {
	title: title$p,
	fields: fields$k
};

var MY$d = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: my$g,
    fields: fields$k,
    title: title$p
});

const FSW_CUSTOMER_ACCEPTANCE_TRANSLATION_LOADER = {
    [CountryCode.MY]: MY$d,
};

const FSWCustomerAcceptanceFormMY = (group, config, isTopUp = false) => {
    const { type } = config;
    const translation = FSW_CUSTOMER_ACCEPTANCE_TRANSLATION_LOADER[CountryCode.MY];
    return new FSWDynamicBuilder({
        form: group,
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'flex flex-wrap gap-[16px]',
        readonlyWhen$: of(true),
        fields: isTopUp
            ? [
                {
                    key: 'approved_date',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-[calc(50%-8px)]',
                    context: {
                        label: translation.fields.approved_date,
                        fullWidth: true,
                        readonlyTemplate: (value) => value ? new DatePipe('en-US').transform(new Date(value), 'dd/MM/yyyy') : 'N/A',
                    },
                },
                {
                    key: 'total_financing_limit',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-[calc(50%-8px)]',
                    context: {
                        label: translation.fields.total_financing_limit,
                        fullWidth: true,
                        readonlyTemplate: (value) => isNaN(Number(value))
                            ? 'N/A'
                            : new Intl.NumberFormat('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            }).format(value),
                    },
                },
                {
                    key: 'settlement_amount',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-[calc(50%-8px)]',
                    context: {
                        label: translation.fields.settlement_amount,
                        fullWidth: true,
                        readonlyTemplate: (value) => isNaN(Number(value))
                            ? 'N/A'
                            : new Intl.NumberFormat('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            }).format(value),
                    },
                },
                {
                    key: 'origination_fee',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-[calc(50%-8px)]',
                    context: {
                        label: translation.fields.origination_fee,
                        fullWidth: true,
                        readonlyTemplate: (value) => isNaN(Number(value))
                            ? 'N/A'
                            : new Intl.NumberFormat('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            }).format(value),
                    },
                },
                {
                    key: 'guarantee_fee',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-[calc(50%-8px)]',
                    context: {
                        label: translation.fields.guarantee_fee,
                        fullWidth: true,
                        readonlyTemplate: (value) => isNaN(Number(value)) ? 'N/A' : Number(value).toFixed(2).replace('.00', ''),
                    },
                },
                {
                    key: 'payment_due_date',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-[calc(50%-8px)]',
                    context: {
                        label: translation.fields.payment_due_date,
                        fullWidth: true,
                        readonlyTemplate: (value) => value ? new DatePipe('en-US').transform(new Date(value), 'dd/MM/yyyy') : 'N/A',
                    },
                },
                {
                    key: 'disbursement_amount',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-[calc(50%-8px)]',
                    context: {
                        label: translation.fields.disbursement_amount,
                        fullWidth: true,
                        readonlyTemplate: (value) => isNaN(Number(value))
                            ? 'N/A'
                            : new Intl.NumberFormat('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            }).format(value),
                    },
                },
                {
                    key: 'tenor',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-[calc(50%-8px)]',
                    context: {
                        label: translation.fields.tenor,
                        fullWidth: true,
                        readonlyTemplate: (value) => value ?? 'N/A',
                    },
                },
                {
                    key: 'monthly_repayment_amount',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-[calc(50%-8px)]',
                    context: {
                        label: translation.fields.monthly_repayment_amount,
                        fullWidth: true,
                        readonlyTemplate: (value) => isNaN(Number(value))
                            ? 'N/A'
                            : new Intl.NumberFormat('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            }).format(value),
                    },
                },
                {
                    key: 'interest_rate',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-[calc(50%-8px)]',
                    context: {
                        label: translation.fields.interest_rate,
                        fullWidth: true,
                        readonlyTemplate: (value) => isNaN(Number(value))
                            ? 'N/A'
                            : new Intl.NumberFormat('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            }).format(value),
                    },
                },
                {
                    key: 'status',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-[calc(50%-8px)]',
                    context: {
                        label: translation.fields.status,
                        fullWidth: true,
                        readonlyTemplate: (value) => value ?? 'N/A',
                    },
                },
                {
                    key: 'borrower_rejection_reason',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-[calc(50%-8px)]',
                    context: {
                        label: translation.fields.borrower_rejection_reason,
                        fullWidth: true,
                        readonlyTemplate: 'borrower_rejection_reason',
                    },
                },
            ]
            : [
                {
                    key: 'application_number',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-[calc(50%-8px)]',
                    context: {
                        label: translation.fields.application_number,
                        fullWidth: true,
                        readonlyTemplate: (value) => value ?? 'N/A',
                    },
                },
                {
                    key: 'customer_name',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-[calc(50%-8px)]',
                    context: {
                        label: translation.fields.customer_name,
                        fullWidth: true,
                        readonlyTemplate: (value) => value ?? 'N/A',
                    },
                },
                {
                    key: 'approved_date',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-[calc(50%-8px)]',
                    context: {
                        label: translation.fields.approved_date,
                        fullWidth: true,
                        readonlyTemplate: 'approved_date',
                    },
                },
                {
                    key: 'disbursement_amount',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-[calc(50%-8px)]',
                    context: {
                        label: translation.fields.disbursement_amount,
                        fullWidth: true,
                        readonlyTemplate: (value) => isNaN(Number(value))
                            ? 'N/A'
                            : new Intl.NumberFormat('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            }).format(value),
                    },
                },
                {
                    key: 'total_financing_limit',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-[calc(50%-8px)]',
                    context: {
                        label: translation.fields.total_financing_limit,
                        fullWidth: true,
                        readonlyTemplate: (value) => isNaN(Number(value))
                            ? 'N/A'
                            : new Intl.NumberFormat('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            }).format(value),
                    },
                },
                {
                    key: 'monthly_repayment_amount',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-[calc(50%-8px)]',
                    context: {
                        label: translation.fields.monthly_repayment_amount,
                        fullWidth: true,
                        readonlyTemplate: (value) => isNaN(Number(value))
                            ? 'N/A'
                            : new Intl.NumberFormat('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            }).format(value),
                    },
                },
                {
                    key: 'tenor',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-[calc(50%-8px)]',
                    context: {
                        label: translation.fields.tenor,
                        fullWidth: true,
                        readonlyTemplate: (value) => value ?? 'N/A',
                    },
                },
                {
                    key: 'interest_rate',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-[calc(50%-8px)]',
                    context: {
                        label: translation.fields.interest_rate,
                        fullWidth: true,
                        readonlyTemplate: (value) => isNaN(Number(value))
                            ? 'N/A'
                            : new Intl.NumberFormat('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            }).format(value),
                    },
                },
                ...(type === FSWCustomerAcceptanceTypes.DEFAULT
                    ? []
                    : [
                        {
                            key: 'status',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            customClasses: 'w-[calc(50%-8px)]',
                            context: {
                                label: translation.fields.status,
                                fullWidth: true,
                                readonlyTemplate: (value) => value ?? 'N/A',
                            },
                        },
                        {
                            key: 'borrower_rejection_reason',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            customClasses: 'w-[calc(50%-8px)]',
                            context: {
                                label: translation.fields.borrower_rejection_reason,
                                fullWidth: true,
                                readonlyTemplate: 'borrower_rejection_reason',
                            },
                        },
                    ]),
            ],
    });
};

class FSWCustomerAcceptanceStore extends ComponentStore {
    get array() {
        return getControlFromGroup(this.group, 'factors');
    }
    constructor(_initialState, _formConfig, _type, _isTopUp, _applicationService, _applicationInternalService, _applicationProposalService) {
        super(_initialState);
        this._initialState = _initialState;
        this._formConfig = _formConfig;
        this._type = _type;
        this._isTopUp = _isTopUp;
        this._applicationService = _applicationService;
        this._applicationInternalService = _applicationInternalService;
        this._applicationProposalService = _applicationProposalService;
        this.group = new UntypedFormGroup({});
        this.init = this.effect(pipe(switchMap(() => {
            const entityId = this.get().entityId;
            return forkJoin([
                this._applicationService.getOfferData(entityId),
                this._applicationInternalService.getApplication(entityId),
                this._applicationProposalService.getProposals(entityId).pipe(map((proposals) => proposals.find((proposal) => proposal.proposal_type === this.get().proposalType)), map((proposal) => {
                    if (!proposal?.data)
                        return {
                            origination_fee: 0,
                            guarantee_fee: 0,
                        };
                    const { propose, recommendation } = proposal.data;
                    return {
                        ...(propose
                            ? {
                                ...(!Number.isNaN(Number(propose.origination_fee))
                                    ? { origination_fee: propose.origination_fee }
                                    : {}),
                                ...(!Number.isNaN(Number(propose.guarantee_fee))
                                    ? { guarantee_fee: propose.guarantee_fee }
                                    : {}),
                            }
                            : {}),
                        ...(recommendation
                            ? {
                                ...(!Number.isNaN(Number(recommendation.origination_fee))
                                    ? { origination_fee: recommendation.origination_fee }
                                    : {}),
                                ...(!Number.isNaN(Number(recommendation.guarantee_fee))
                                    ? { guarantee_fee: recommendation.guarantee_fee }
                                    : {}),
                            }
                            : {}),
                    };
                })),
            ]).pipe(tap(([offer, application, { origination_fee, guarantee_fee }]) => this.patchForm({
                application_number: application.number || 'N/A',
                customer_name: application.name || 'N/A',
                approved_date: offer?.offer?.approved_date || '',
                disbursement_amount: offer?.offer?.disbursement_amount ?? 'N/A',
                total_financing_limit: offer?.offer?.amount || 'N/A',
                monthly_repayment_amount: offer?.offer?.monthly_repayment_amount ?? offer?.offer?.monthly_payment ?? 'N/A',
                interest_rate: offer?.offer?.interest_rate ?? 'N/A',
                status: offer?.offer_reply?.decision || 'N/A',
                settlement_amount: offer?.offer?.settlement_amount ?? 'N/A',
                utilisation_fee: offer?.offer?.utilisation_fee ?? 'N/A',
                origination_fee: offer?.offer?.origination_fee ?? 'N/A',
                guarantee_fee: offer?.offer?.guarantee_fee ?? 'N/A',
                payment_due_date: offer?.offer?.payment_due_date || '',
                tenor: offer?.offer?.tenor
                    ? `${offer?.offer?.tenor} ${getTextFromSelectList(tenorTypes, offer?.offer?.tenor_type, offer?.offer?.tenor > 1 ? 's' : '')}`
                    : 'N/A',
                borrower_rejection_reason: offer?.offer_reply?.decision
                    ? `<div>
              ${offer?.offer_reply?.decision || ''}
              </div>` +
                        ` <div>
              ${offer?.offer_reply?.reason || ''}
              </div>` +
                        ` <div>
              ${offer?.offer_reply?.comment || ''}
              </div>`
                    : 'N/A',
            })));
        })));
        this.updateState = (value) => this.patchState({
            ...value,
        });
        this.builder = this._formConfig(this.group, { type: _type }, this._isTopUp);
    }
    patchForm(value) {
        this.group.patchValue(value);
    }
}

class FSWCustomerAcceptanceStoreMY extends FSWCustomerAcceptanceStore {
    constructor(formConfig, type, isTopUp, applicationService, applicationInternalService, applicationProposalsService) {
        super({
            entityId: null,
            proposalType: 'LOAN',
        }, formConfig, type, isTopUp, applicationService, applicationInternalService, applicationProposalsService);
        this.formConfig = formConfig;
        this.type = type;
        this.isTopUp = isTopUp;
        this.applicationService = applicationService;
        this.applicationInternalService = applicationInternalService;
        this.applicationProposalsService = applicationProposalsService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCustomerAcceptanceStoreMY, deps: [{ token: FSW_CUSTOMER_ACCEPTANCE_FORM_TOKEN }, { token: FSW_CUSTOMER_ACCEPTANCE_TYPE_TOKEN }, { token: FSW_CUSTOMER_ACCEPTANCE_ISTOPUP_TOKEN }, { token: APPLICATION_SERVICE_TOKEN }, { token: APPLICATION_INTERNAL_SERVICE_TOKEN }, { token: APPLICATION_PROPOSAL_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCustomerAcceptanceStoreMY }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCustomerAcceptanceStoreMY, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_CUSTOMER_ACCEPTANCE_FORM_TOKEN]
                }] }, { type: FSWCustomerAcceptanceTypes, decorators: [{
                    type: Inject,
                    args: [FSW_CUSTOMER_ACCEPTANCE_TYPE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_CUSTOMER_ACCEPTANCE_ISTOPUP_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_INTERNAL_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_PROPOSAL_SERVICE_TOKEN]
                }] }]; } });

const FSW_CUSTOMER_ACCEPTANCE_MY_PROVIDERS = [
    {
        provide: FSW_CUSTOMER_ACCEPTANCE_FORM_TOKEN,
        useValue: FSWCustomerAcceptanceFormMY,
    },
    {
        provide: FSW_CUSTOMER_ACCEPTANCE_STORE_TOKEN,
        useClass: FSWCustomerAcceptanceStoreMY,
        deps: [
            FSW_CUSTOMER_ACCEPTANCE_FORM_TOKEN,
            FSW_CUSTOMER_ACCEPTANCE_TYPE_TOKEN,
            FSW_CUSTOMER_ACCEPTANCE_ISTOPUP_TOKEN,
            APPLICATION_SERVICE_TOKEN,
            APPLICATION_INTERNAL_SERVICE_TOKEN,
            APPLICATION_PROPOSAL_SERVICE_TOKEN,
        ],
    },
];

const FSW_CUSTOMER_ACCEPTANCE_PROVIDERS = {
    default: FSW_CUSTOMER_ACCEPTANCE_MY_PROVIDERS,
    [CountryCode.MY]: FSW_CUSTOMER_ACCEPTANCE_MY_PROVIDERS,
};
const customerAcceptanceLoadProviders = (countryCode) => [
    fswTranslateScope('customer_acceptance'),
    ...getCustomProviders(FSW_CUSTOMER_ACCEPTANCE_PROVIDERS, FSW_CUSTOMER_ACCEPTANCE_MY_PROVIDERS, countryCode),
];

class FSWCustomerAcceptanceDirective {
    constructor(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
        this.entityId = null;
        this.type = FSWCustomerAcceptanceTypes.DEFAULT;
        this.isTopUp = false;
        this.proposalType = 'LOAN';
    }
    ngOnChanges() {
        this._viewContainerRef.clear();
        const ref = this._viewContainerRef.createComponent(FSWCustomerAcceptanceComponent, {
            injector: Injector.create({
                parent: this._viewContainerRef.injector,
                providers: [
                    {
                        provide: FSW_CUSTOMER_ACCEPTANCE_TYPE_TOKEN,
                        useValue: this.type || FSWCustomerAcceptanceTypes.DEFAULT,
                    },
                    {
                        provide: FSW_CUSTOMER_ACCEPTANCE_ISTOPUP_TOKEN,
                        useValue: this.isTopUp,
                    },
                    ...customerAcceptanceLoadProviders(getCountryCodeFromStorage()),
                ],
            }),
        });
        const instance = ref.instance;
        instance.entityId = this.entityId;
        instance.proposalType = this.proposalType;
        ref.changeDetectorRef.detectChanges();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCustomerAcceptanceDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWCustomerAcceptanceDirective, selector: "[fswCustomerAcceptance]", inputs: { entityId: "entityId", type: "type", isTopUp: "isTopUp", proposalType: "proposalType" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCustomerAcceptanceDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswCustomerAcceptance]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; }, propDecorators: { entityId: [{
                type: Input
            }], type: [{
                type: Input
            }], isTopUp: [{
                type: Input
            }], proposalType: [{
                type: Input
            }] } });

class FSWCustomerAcceptanceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCustomerAcceptanceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWCustomerAcceptanceModule, declarations: [FSWCustomerAcceptanceComponent, FSWCustomerAcceptanceDirective], imports: [FSWPanelModule,
            FSWDynamicBuilderModule, i1$4.FSWTranslateModule, ReactiveFormsModule,
            CommonModule,
            ApplicationInternalServiceModule,
            ApplicationServiceModule,
            ApplicationProposalServiceModule], exports: [FSWCustomerAcceptanceComponent, FSWCustomerAcceptanceDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCustomerAcceptanceModule, imports: [FSWPanelModule,
            FSWDynamicBuilderModule,
            FSWTranslateModule.forFeature({
                scope: 'customer_acceptance',
                data: FSW_CUSTOMER_ACCEPTANCE_TRANSLATION_LOADER,
                defaultKey: CountryCode.MY,
            }),
            ReactiveFormsModule,
            CommonModule,
            ApplicationInternalServiceModule,
            ApplicationServiceModule,
            ApplicationProposalServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCustomerAcceptanceModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FSWCustomerAcceptanceComponent, FSWCustomerAcceptanceDirective],
                    imports: [
                        FSWPanelModule,
                        FSWDynamicBuilderModule,
                        FSWTranslateModule.forFeature({
                            scope: 'customer_acceptance',
                            data: FSW_CUSTOMER_ACCEPTANCE_TRANSLATION_LOADER,
                            defaultKey: CountryCode.MY,
                        }),
                        ReactiveFormsModule,
                        CommonModule,
                        ApplicationInternalServiceModule,
                        ApplicationServiceModule,
                        ApplicationProposalServiceModule,
                    ],
                    exports: [FSWCustomerAcceptanceComponent, FSWCustomerAcceptanceDirective],
                }]
        }] });

const DOC_MANAGER_SERVICE_TOKEN = new InjectionToken('DOC_MANAGER_SERVICE_TOKEN');

class DocManagerService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._kongUrl = this._utilsService.getKongUrl();
    }
    deleteSingleDoc(dmsId) {
        const url = `${this._kongUrl}/docs_management/v2/docs/${dmsId}`;
        return this._httpClient
            .delete(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((response) => response));
    }
    downloadSingleDoc(dmsId) {
        const url = `${this._kongUrl}/docs_management/v2/download`;
        return this._httpClient.get(url, {
            responseType: 'blob',
            params: {
                id: dmsId,
            },
            headers: setRequestOptions(),
        });
    }
    getDocs(dmsIds) {
        const url = `${this._kongUrl}/docs_management/v2/docs/`;
        return this._httpClient
            .get(url, {
            params: {
                ids: dmsIds.join(','),
            },
            headers: setRequestOptions(),
        })
            .pipe(map(({ results }) => results));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DocManagerService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DocManagerService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DocManagerService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class DocManagerServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DocManagerServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DocManagerServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DocManagerServiceModule, providers: [
            {
                provide: DOC_MANAGER_SERVICE_TOKEN,
                useClass: DocManagerService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DocManagerServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: DOC_MANAGER_SERVICE_TOKEN,
                            useClass: DocManagerService,
                        },
                    ],
                }]
        }] });

function injectEBATHTHEffects(refreshedAt, ebaths, injector) {
    const service = injectEBATHService();
    const alertService = inject(FSW_ALERT_SERVICE_TOKEN);
    return {
        refresh: (applicationId) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => service.getAllFromApplication(applicationId)), switchMap$1((ids) => {
            if (ids?.length) {
                return forkJoin(ids.map((id) => service.getOne(id)));
            }
            return of([]);
        }), tap((data) => ebaths.set(data)), catchError(() => {
            alertService.error('Failed to load Existing Banking Arrangement data', null, {
                duration: 3000,
            });
            ebaths.set([]);
            return of([]);
        })), injector, []))),
        create: (applicationId, payload, cb) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => service.createOne(payload)), switchMap$1((ebath) => service.postToApplication(applicationId, ebath.id).pipe(map(() => ebath))), tap(() => cb()), tap(() => refreshedAt.set(new Date())), tap(() => alertService.success('create Loan successfully!', null, {
            duration: 3000,
        })), catchError(() => {
            alertService.error('Failed to create Loan', null, {
                duration: 3000,
            });
            return of(null);
        })), injector))),
        update: (payload) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => service.updateOne(payload.id, payload)), tap(() => refreshedAt.set(new Date())), tap(() => alertService.success('Update Loan successfully!', null, {
            duration: 3000,
        })), catchError(() => {
            alertService.error('Failed to update Loan', null, {
                duration: 3000,
            });
            return of(null);
        })), injector))),
        delete: (applicationId, id) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => service.deleteOne(id)), switchMap$1(() => service.removeFromApplication(applicationId, id)), tap(() => refreshedAt.set(new Date())), tap(() => alertService.success('Delete Loan successfully!', null, {
            duration: 3000,
        })), catchError(() => {
            alertService.error('Failed to delete Loan', null, {
                duration: 3000,
            });
            return of(null);
        })), injector))),
    };
}

var title$o = "Existing Banking Arrangement";
var empty$c = "Don't have any Loans available";
var fields$j = {
	bank: "Bank",
	account_no: "Account No.",
	status: "Status",
	account_open_date: "Account Open Date",
	loan_type: "Loan Type",
	loan_detail: "Loan Detail",
	limit: "Limit",
	interest: "Interest",
	outstanding: "Outstanding",
	monthly_repayment: "Monthly Repayment",
	request_month: "Request Month",
	collectability: "Collectability"
};
var buttons$D = {
	"delete": "Delete",
	edit: "Edit",
	save: "Save",
	cancel: "Cancel Edit",
	add: "Add New Entry",
	yes: "Yes",
	no: "No"
};
var confirmation$1 = {
	"delete": "Are you sure you want to delete the loan",
	cancel: {
		title: "Are you sure you want to discard changes",
		message: "All unsaved changes will be lost"
	},
	save: "Are you sure you want to save the loan information"
};
var tiles = {
	all_loans: "Term Loans",
	long_term_loans: "Long Term Loans",
	short_term_loans: "Short Term Loans",
	guarantee_loans: "Guarantee Loans"
};
var attributes = {
	total_limit: "Total Limit",
	total_outstanding: "Total Outstanding",
	total_monthly_repayment: "Total Monthly Repayment"
};
var ebathTh = {
	title: title$o,
	empty: empty$c,
	fields: fields$j,
	buttons: buttons$D,
	confirmation: confirmation$1,
	tiles: tiles,
	attributes: attributes
};

var TH$7 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    attributes: attributes,
    buttons: buttons$D,
    confirmation: confirmation$1,
    default: ebathTh,
    empty: empty$c,
    fields: fields$j,
    tiles: tiles,
    title: title$o
});

const EBA_TH_TRANSLATION = TH$7;

function injectEBATHTHForm(form, { banks$, readonlyWhen$ }) {
    const loanTypeSubject = new BehaviorSubject(EBALoanType.LongTerm);
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'w-full flex flex-col gap-4',
        readonlyWhen$,
        form,
        renderBy: 'container',
        containers: [
            {
                customClasses: 'w-full flex flex-wrap gap-4',
                fields: [
                    {
                        key: 'bank_id',
                        customClasses: 'eba-field',
                        type: FSWDynamicBuilderControlTypes.SELECT,
                        context: {
                            label: EBA_TH_TRANSLATION.fields.bank,
                            fullWidth: true,
                            isRequired: true,
                            closeOnSelected: true,
                            maxHeight: '400px',
                            loadItemsAsync: () => banks$.pipe(map((banks) => banks.map((item) => ({
                                text: item.name,
                                value: +item.id,
                            })))),
                            readonlyTemplate: 'bank',
                        },
                        validations: [Validators.required],
                    },
                    {
                        key: 'account_no',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        customClasses: 'eba-field',
                        context: {
                            label: EBA_TH_TRANSLATION.fields.account_no,
                            fullWidth: true,
                            isRequired: true,
                            readonlyTemplate: (value) => value ?? '--',
                        },
                        validations: [Validators.required],
                    },
                    {
                        key: 'status',
                        type: FSWDynamicBuilderControlTypes.SELECT,
                        customClasses: 'eba-field',
                        context: {
                            label: EBA_TH_TRANSLATION.fields.status,
                            fullWidth: true,
                            isRequired: true,
                            closeOnSelected: true,
                            items: EBALoanStatuses,
                            readonlyTemplate: (value) => EBALoanStatuses.find((item) => item.value === value)?.text ?? '--',
                        },
                        validations: [Validators.required],
                    },
                    {
                        key: 'account_open_date',
                        type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                        customClasses: 'eba-field',
                        context: {
                            label: EBA_TH_TRANSLATION.fields.account_open_date,
                            fullWidth: true,
                            isRequired: true,
                            closeOnSelected: true,
                            readonlyTemplate: (value) => value ? new DatePipe('en-US').transform(value, 'dd/MM/yyyy') ?? '--' : '--',
                        },
                        validations: [Validators.required],
                    },
                    {
                        key: 'loan_type',
                        type: FSWDynamicBuilderControlTypes.SELECT,
                        customClasses: 'eba-field',
                        context: {
                            defaultValue: EBALoanType.LongTerm,
                            label: EBA_TH_TRANSLATION.fields.loan_type,
                            fullWidth: true,
                            isRequired: true,
                            closeOnSelected: true,
                            items: EBALoanTypes,
                            readonlyTemplate: (value) => EBALoanTypes.find((item) => item.value === value)?.text ?? '--',
                            afterCreated: (control) => {
                                loanTypeSubject.next(control.value);
                                control.valueChanges.subscribe((value) => {
                                    loanTypeSubject.next(value);
                                });
                            },
                        },
                        validations: [Validators.required],
                    },
                    {
                        key: 'loan_detail',
                        type: FSWDynamicBuilderControlTypes.SELECT,
                        customClasses: 'eba-field',
                        context: {
                            label: EBA_TH_TRANSLATION.fields.loan_detail,
                            fullWidth: true,
                            isRequired: true,
                            closeOnSelected: true,
                            loadItemsAsync: () => loanTypeSubject.pipe(map((loanType) => {
                                switch (loanType) {
                                    case EBALoanType.LongTerm:
                                        return EBALoanDetailsLongTerm;
                                    case EBALoanType.ShortTerm:
                                        return EBALoanDetailsShortTerm;
                                    case EBALoanType.Guarantee:
                                        return EBALoanDetailsGuarantee;
                                    default:
                                        return [];
                                }
                            })),
                            readonlyTemplate: (value) => {
                                return ([
                                    ...EBALoanDetailsLongTerm,
                                    ...EBALoanDetailsShortTerm,
                                    ...EBALoanDetailsGuarantee,
                                ].find((item) => item.value === value)?.text ?? '--');
                            },
                        },
                    },
                    {
                        key: 'limit',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        customClasses: 'eba-field',
                        context: {
                            label: EBA_TH_TRANSLATION.fields.limit,
                            defaultValue: 0,
                            mask: {
                                expression: 'separator.2',
                                config: {
                                    thousandSeparator: ',',
                                },
                            },
                            fullWidth: true,
                            isRequired: true,
                            readonlyTemplate: (value) => (value ? new Intl.NumberFormat().format(value) : '--'),
                        },
                        validations: [Validators.required],
                    },
                    {
                        key: 'interest',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        customClasses: 'eba-field',
                        context: {
                            label: EBA_TH_TRANSLATION.fields.interest,
                            defaultValue: 0,
                            mask: {
                                expression: 'separator.2',
                                config: {
                                    thousandSeparator: ',',
                                },
                            },
                            fullWidth: true,
                            isRequired: true,
                            readonlyTemplate: (value) => (value ? new Intl.NumberFormat().format(value) : '--'),
                        },
                        validations: [Validators.required],
                    },
                    {
                        key: 'outstanding',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        customClasses: 'eba-field',
                        context: {
                            label: EBA_TH_TRANSLATION.fields.outstanding,
                            defaultValue: 0,
                            mask: {
                                expression: 'separator.2',
                                config: {
                                    thousandSeparator: ',',
                                },
                            },
                            fullWidth: true,
                            isRequired: true,
                            readonlyTemplate: (value) => (value ? new Intl.NumberFormat().format(value) : '--'),
                        },
                        validations: [Validators.required],
                    },
                    {
                        key: 'monthly_repayment',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        customClasses: 'eba-field',
                        context: {
                            label: EBA_TH_TRANSLATION.fields.monthly_repayment,
                            defaultValue: 0,
                            mask: {
                                expression: 'separator.2',
                                config: {
                                    thousandSeparator: ',',
                                },
                            },
                            fullWidth: true,
                            isRequired: true,
                            readonlyTemplate: (value) => (value ? new Intl.NumberFormat().format(value) : '--'),
                        },
                        validations: [Validators.required],
                    },
                    {
                        key: 'requested_month',
                        type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                        customClasses: 'eba-field',
                        context: {
                            label: EBA_TH_TRANSLATION.fields.request_month,
                            fullWidth: true,
                            isRequired: true,
                            closeOnSelected: true,
                            readonlyTemplate: (value) => value ? new DatePipe('en-US').transform(value, 'dd/MM/yyyy') ?? '--' : '--',
                        },
                        validations: [Validators.required],
                    },
                ],
            },
            {
                customClasses: 'w-full overflow-x-auto',
                fields: [
                    {
                        key: 'collectability',
                        formType: FSWDynamicBuilderFormTypes.TABLE,
                        customClasses: 'w-full fsw-table fsw-table--bordered table-fixed',
                        header: [
                            {
                                columns: [
                                    {
                                        label: EBA_TH_TRANSLATION.fields.collectability,
                                        colSpan: 36,
                                        customClasses: '!text-gray-800',
                                    },
                                ],
                            },
                            {
                                columns: Array.from({ length: 36 }, (_, index) => ({
                                    label: `${index + 1}`,
                                    customClasses: 'text-center',
                                })),
                            },
                        ],
                        items: [
                            {
                                body: {
                                    isLoop: false,
                                    data: [
                                        {
                                            key: 'collectability',
                                            columns: Array.from({ length: 36 }, (_, index) => ({
                                                columnType: 'control',
                                                fields: [
                                                    {
                                                        key: `${index + 1}`,
                                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                                        context: {
                                                            defaultValue: 0,
                                                            mask: {
                                                                expression: 'separator.2',
                                                                config: {
                                                                    thousandSeparator: ',',
                                                                },
                                                            },
                                                            fullWidth: true,
                                                            isRequired: true,
                                                            readonlyTemplate: 'collectability',
                                                        },
                                                        validations: [
                                                            Validators.required,
                                                            Validators.min(0),
                                                            Validators.max(999),
                                                        ],
                                                    },
                                                ],
                                            })),
                                        },
                                    ],
                                },
                            },
                        ],
                    },
                ],
            },
            {
                customClasses: 'hidden',
                fields: [
                    {
                        key: 'id',
                        type: FSWDynamicBuilderControlTypes.TEMPLATE,
                        customClasses: 'hidden',
                        context: {
                            isHidden: true,
                        },
                    },
                ],
            },
        ],
    });
}

function provideEBATHTranslation() {
    return [
        ...(FSWTranslateModule.forFeature({
            scope: 'ebath',
            defaultKey: CountryCode.TH,
            data: {
                [CountryCode.TH]: EBA_TH_TRANSLATION,
            },
        }).providers || []),
        fswTranslateScope('ebath'),
    ];
}

function injectEBATHEffects(refreshedAt, ebaths, injector) {
    switch (getCountryCodeFromStorage()) {
        case CountryCode.TH:
            return injectEBATHTHEffects(refreshedAt, ebaths, injector);
        default:
            return injectEBATHTHEffects(refreshedAt, ebaths, injector);
    }
}
function injectEBATHForm(form, config) {
    switch (getCountryCodeFromStorage()) {
        case CountryCode.TH:
            return injectEBATHTHForm(form, config);
        default:
            return injectEBATHTHForm(form, config);
    }
}

class FSWEBATHConfirmComponent {
    constructor() {
        this.dialogRef = inject((DialogRef));
    }
    close(haveData = false) {
        this.dialogRef.close(haveData);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWEBATHConfirmComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWEBATHConfirmComponent, isStandalone: true, selector: "fsw-ebath-confirm", providers: [provideEBATHTranslation()], ngImport: i0, template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"'buttons.yes' | fswTranslate\"\n  [cancelButton]=\"'buttons.no' | fswTranslate\"\n  (confirmEvent)=\"close(true)\"\n  (cancelEvent)=\"close(false)\"\n  (closeEvent)=\"close(false)\"\n>\n  <ng-template fswModalBody>\n    <p>\n      {{\n        dialogRef.config.data['description']\n          | fswTranslate : { data: dialogRef.config.data['descriptionParams'] }\n      }}\n    </p>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "ngmodule", type: FSWModalModule$1 }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWEBATHConfirmComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-ebath-confirm', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [FSWModalModule$1, FSWTranslateModule], providers: [provideEBATHTranslation()], template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"'buttons.yes' | fswTranslate\"\n  [cancelButton]=\"'buttons.no' | fswTranslate\"\n  (confirmEvent)=\"close(true)\"\n  (cancelEvent)=\"close(false)\"\n  (closeEvent)=\"close(false)\"\n>\n  <ng-template fswModalBody>\n    <p>\n      {{\n        dialogRef.config.data['description']\n          | fswTranslate : { data: dialogRef.config.data['descriptionParams'] }\n      }}\n    </p>\n  </ng-template>\n</fsw-modal>\n" }]
        }] });

class FSWEBATHBoxComponent {
    constructor() {
        this.deleted = new EventEmitter();
        this.saved = new EventEmitter();
        this.dialog = inject(Dialog);
        this.injector = inject(Injector);
        this.alertService = inject(FSW_ALERT_SERVICE_TOKEN);
        this.banksSignal = signal([]);
        this.isReadonlySignal = signal(false);
        this.isEditableSignal = signal(true);
        this.isReadonly$ = toObservable(this.isReadonlySignal);
        this.banks$ = toObservable(this.banksSignal);
        this.isEditable$ = toObservable(this.isEditableSignal);
        this.builder = null;
        this.defaultValue = null;
    }
    set formGroup(formGroup) {
        const value = formGroup.getRawValue();
        this.defaultValue = value;
        if (value.id) {
            this.isEditableSignal.set(false);
        }
        if (this.builder) {
            if (!isEqual(this.builder.groupConfig.form.getRawValue(), value)) {
                this.builder.groupConfig.form.patchValue(value);
            }
        }
        else {
            this.builder = injectEBATHForm(formGroup, {
                banks$: this.banks$,
                readonlyWhen$: this.isReadonly$.pipe(switchMap$1((isReadonly) => {
                    if (isReadonly) {
                        return of(isReadonly);
                    }
                    return this.isEditable$.pipe(map((isEditable) => !isEditable));
                })),
            });
            this.builder.groupConfig.form.patchValue(value);
        }
    }
    set banks(banks) {
        this.banksSignal.set(banks);
    }
    set isReadonly(value) {
        this.isReadonlySignal.set(value);
    }
    edit() {
        this.isEditableSignal.set(true);
    }
    delete() {
        this.dialog
            .open(FSWEBATHConfirmComponent, {
            data: {
                title: this.builder.groupConfig.form.getRawValue().account_no,
                description: 'confirmation.delete',
            },
            injector: this.injector,
        })
            .closed.pipe(take(1), tap((result) => result && this.deleted.emit()))
            .subscribe();
    }
    save() {
        if (this.builder.groupConfig.form.invalid) {
            this.alertService.warning('Warning', 'Invalid Form, please fill in all required fields', {
                duration: 3000,
            });
            return;
        }
        // this.isEditableSignal.set(false);
        this.dialog
            .open(FSWEBATHConfirmComponent, {
            data: {
                title: this.builder.groupConfig.form.getRawValue().account_no,
                description: 'confirmation.save',
            },
            injector: this.injector,
        })
            .closed.pipe(take(1), tap((result) => result &&
            this.saved.emit(this.builder.groupConfig.form.getRawValue())))
            .subscribe();
    }
    cancel() {
        if (isEqual(this.builder?.groupConfig.form.getRawValue(), this.defaultValue)) {
            this.cancelEditing();
            return;
        }
        this.dialog
            .open(FSWEBATHConfirmComponent, {
            data: {
                title: 'confirmation.cancel.title',
                description: 'confirmation.cancel.message',
            },
            injector: this.injector,
        })
            .closed.pipe(take(1), tap((result) => result && this.cancelEditing()))
            .subscribe();
    }
    cancelEditing() {
        this.builder?.groupConfig?.form?.patchValue(this.defaultValue || {});
        this.isEditableSignal.set(false);
        if (!this.defaultValue?.id) {
            this.deleted.emit();
        }
    }
    getBankName(id) {
        return this.banksSignal().find((bank) => bank.id == id)?.name || '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWEBATHBoxComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWEBATHBoxComponent, isStandalone: true, selector: "fsw-ebath-box", inputs: { formGroup: "formGroup", banks: "banks", isReadonly: "isReadonly" }, outputs: { deleted: "deleted", saved: "saved" }, providers: [provideEBATHTranslation()], ngImport: i0, template: "<fsw-panel\n  *ngIf=\"builder\"\n  customClasses=\"w-full\"\n  [title]=\"builder.groupConfig.form.getRawValue().id ? 'EBA' : 'Creating EBA'\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <div class=\"flex items-center gap-5\">\n      <button\n        *ngIf=\"!isEditableSignal()\"\n        [disabled]=\"isReadonlySignal()\"\n        (click)=\"!isReadonlySignal() && edit()\"\n        fswButton\n        [appearance]=\"'secondary'\"\n        [size]=\"'s'\"\n      >\n        {{ 'buttons.edit' | fswTranslate }}\n      </button>\n      <button\n        *ngIf=\"isEditableSignal()\"\n        [disabled]=\"isReadonlySignal() || builder.groupConfig.form.invalid\"\n        (click)=\"!isReadonlySignal() && save()\"\n        fswButton\n        [appearance]=\"'secondary'\"\n        [size]=\"'s'\"\n      >\n        {{ 'buttons.save' | fswTranslate }}\n      </button>\n      <button\n        *ngIf=\"isEditableSignal()\"\n        [disabled]=\"isReadonlySignal()\"\n        (click)=\"!isReadonlySignal() && cancel()\"\n        fswButton\n        [appearance]=\"'secondary'\"\n        [size]=\"'s'\"\n      >\n        {{ 'buttons.cancel' | fswTranslate }}\n      </button>\n      <button\n        *ngIf=\"!isEditableSignal() && builder.groupConfig.form.getRawValue().id\"\n        [disabled]=\"isReadonlySignal()\"\n        (click)=\"!isReadonlySignal() && delete()\"\n        fswButton\n        [appearance]=\"'secondary-elevate'\"\n        [size]=\"'s'\"\n      >\n        {{ 'buttons.delete' | fswTranslate }}\n      </button>\n    </div>\n  </ng-template>\n  <form class=\"w-full\" [formGroup]=\"builder.groupConfig.form\">\n    <fsw-dynamic-builder [builder]=\"builder\">\n      <ng-template fswDynamicBuilderTemplate key=\"bank\" let-value>\n        {{ getBankName(value) }}\n      </ng-template>\n      <ng-template fswDynamicBuilderTemplate key=\"collectability\" let-value>\n        <label class=\"py-[8px] text-center w-full\">\n          <span>{{ value || 0 | number : '.0-2' }}</span>\n        </label>\n      </ng-template>\n    </fsw-dynamic-builder>\n  </form>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: FSWDynamicBuilderModule }, { kind: "directive", type: i1$4.FSWDynamicBuilderTemplateDirective, selector: "[fswDynamicBuilderTemplate]", inputs: ["key"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: DialogModule }, { kind: "ngmodule", type: FSWAlertModule }, { kind: "pipe", type: DecimalPipe, name: "number" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWEBATHBoxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-ebath-box', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [
                        FSWTranslateModule,
                        FSWPanelModule,
                        NgIf,
                        ReactiveFormsModule,
                        FSWDynamicBuilderModule,
                        FSWButtonModule,
                        DialogModule,
                        FSWAlertModule,
                        DecimalPipe,
                    ], providers: [provideEBATHTranslation()], template: "<fsw-panel\n  *ngIf=\"builder\"\n  customClasses=\"w-full\"\n  [title]=\"builder.groupConfig.form.getRawValue().id ? 'EBA' : 'Creating EBA'\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <div class=\"flex items-center gap-5\">\n      <button\n        *ngIf=\"!isEditableSignal()\"\n        [disabled]=\"isReadonlySignal()\"\n        (click)=\"!isReadonlySignal() && edit()\"\n        fswButton\n        [appearance]=\"'secondary'\"\n        [size]=\"'s'\"\n      >\n        {{ 'buttons.edit' | fswTranslate }}\n      </button>\n      <button\n        *ngIf=\"isEditableSignal()\"\n        [disabled]=\"isReadonlySignal() || builder.groupConfig.form.invalid\"\n        (click)=\"!isReadonlySignal() && save()\"\n        fswButton\n        [appearance]=\"'secondary'\"\n        [size]=\"'s'\"\n      >\n        {{ 'buttons.save' | fswTranslate }}\n      </button>\n      <button\n        *ngIf=\"isEditableSignal()\"\n        [disabled]=\"isReadonlySignal()\"\n        (click)=\"!isReadonlySignal() && cancel()\"\n        fswButton\n        [appearance]=\"'secondary'\"\n        [size]=\"'s'\"\n      >\n        {{ 'buttons.cancel' | fswTranslate }}\n      </button>\n      <button\n        *ngIf=\"!isEditableSignal() && builder.groupConfig.form.getRawValue().id\"\n        [disabled]=\"isReadonlySignal()\"\n        (click)=\"!isReadonlySignal() && delete()\"\n        fswButton\n        [appearance]=\"'secondary-elevate'\"\n        [size]=\"'s'\"\n      >\n        {{ 'buttons.delete' | fswTranslate }}\n      </button>\n    </div>\n  </ng-template>\n  <form class=\"w-full\" [formGroup]=\"builder.groupConfig.form\">\n    <fsw-dynamic-builder [builder]=\"builder\">\n      <ng-template fswDynamicBuilderTemplate key=\"bank\" let-value>\n        {{ getBankName(value) }}\n      </ng-template>\n      <ng-template fswDynamicBuilderTemplate key=\"collectability\" let-value>\n        <label class=\"py-[8px] text-center w-full\">\n          <span>{{ value || 0 | number : '.0-2' }}</span>\n        </label>\n      </ng-template>\n    </fsw-dynamic-builder>\n  </form>\n</fsw-panel>\n" }]
        }], propDecorators: { deleted: [{
                type: Output
            }], saved: [{
                type: Output
            }], formGroup: [{
                type: Input,
                args: [{ required: true }]
            }], banks: [{
                type: Input,
                args: [{ required: true }]
            }], isReadonly: [{
                type: Input,
                args: [{ required: true }]
            }] } });

class FSWEBATHTileComponent {
    constructor() {
        this.type = 'all';
        this.data = [];
        this.titleMapping = {
            all: 'tiles.all_loans',
            [EBALoanType.LongTerm]: 'tiles.long_term_loans',
            [EBALoanType.ShortTerm]: 'tiles.short_term_loans',
            [EBALoanType.Guarantee]: 'tiles.guarantee_loans',
        };
    }
    calculateTotalByKey(key) {
        return this.data
            .filter((item) => (this.type === 'all'
            ? [EBALoanType.ShortTerm, EBALoanType.LongTerm].includes(item.loan_type)
            : item.loan_type === this.type) && item.status === EBALoanStatus.Normal)
            .reduce((acc, item) => acc + item[key], 0);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWEBATHTileComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWEBATHTileComponent, isStandalone: true, selector: "fsw-ebath-tile", inputs: { type: "type", data: "data" }, providers: [provideEBATHTranslation()], ngImport: i0, template: "<fsw-panel [title]=\"titleMapping[type] | fswTranslate\" headerClasses=\"justify-center\">\n  <ul class=\"w-full flex flex-col gap-4\">\n    <li class=\"flex justify-between items-center w-full\">\n      <span>{{ 'attributes.total_limit' | fswTranslate }}</span>\n      <span [fswNumberRunning]=\"calculateTotalByKey('limit')\"></span>\n    </li>\n    <li class=\"flex justify-between items-center w-full\">\n      <span>{{ 'attributes.total_outstanding' | fswTranslate }}</span>\n      <span [fswNumberRunning]=\"calculateTotalByKey('outstanding')\"></span>\n    </li>\n    <li class=\"flex justify-between items-center w-full\">\n      <span>{{ 'attributes.total_monthly_repayment' | fswTranslate }}</span>\n      <span [fswNumberRunning]=\"calculateTotalByKey('monthly_repayment')\"></span>\n    </li>\n  </ul>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: NumberRunningModule$1 }, { kind: "directive", type: i1$4.NumberRunningDirective, selector: "[fswNumberRunning]", inputs: ["fswNumberRunning"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWEBATHTileComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-ebath-tile', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [NgIf, FSWPanelModule, FSWTranslateModule, NumberRunningModule$1], providers: [provideEBATHTranslation()], template: "<fsw-panel [title]=\"titleMapping[type] | fswTranslate\" headerClasses=\"justify-center\">\n  <ul class=\"w-full flex flex-col gap-4\">\n    <li class=\"flex justify-between items-center w-full\">\n      <span>{{ 'attributes.total_limit' | fswTranslate }}</span>\n      <span [fswNumberRunning]=\"calculateTotalByKey('limit')\"></span>\n    </li>\n    <li class=\"flex justify-between items-center w-full\">\n      <span>{{ 'attributes.total_outstanding' | fswTranslate }}</span>\n      <span [fswNumberRunning]=\"calculateTotalByKey('outstanding')\"></span>\n    </li>\n    <li class=\"flex justify-between items-center w-full\">\n      <span>{{ 'attributes.total_monthly_repayment' | fswTranslate }}</span>\n      <span [fswNumberRunning]=\"calculateTotalByKey('monthly_repayment')\"></span>\n    </li>\n  </ul>\n</fsw-panel>\n" }]
        }], propDecorators: { type: [{
                type: Input,
                args: [{ required: true }]
            }], data: [{
                type: Input,
                args: [{ required: true }]
            }] } });

class FSWEBATHComponent {
    constructor() {
        this.updated = new EventEmitter();
        this.applicationId = signal('');
        this.isReadonly = signal(false);
        this.refreshedAt = signal(new Date());
        this.banks = signal([]);
        this.ebaths = signal([]);
        this.effects = injectEBATHEffects(this.refreshedAt, this.ebaths, inject(Injector));
        this.formArray = new UntypedFormArray([]);
        this.formArrayCreating = new UntypedFormArray([]);
        this.actualLength = toSignal(combineLatest([
            this.formArray.valueChanges.pipe(startWith(this.formArray.getRawValue())),
            this.formArrayCreating.valueChanges.pipe(startWith(this.formArrayCreating.getRawValue())),
        ]).pipe(map(([values, creatingValues]) => values.length + creatingValues.length)));
        this.isEmpty = computed(() => this.actualLength() === 0);
        this.isReadonly$ = toObservable(this.isReadonly);
        this.banks$ = toObservable(this.banks);
        this.masterDataService = inject(MASTER_DATA_SERVICE_TOKEN);
        this.EBALoanType = EBALoanType;
        effect(() => {
            if (this.refreshedAt()) {
                this.effects.refresh(this.applicationId());
            }
        });
        effect(() => {
            this.masterDataService
                .getBanks()
                .pipe(tap((banks) => untracked(() => this.banks.set(banks))))
                .subscribe();
        }, { allowSignalWrites: true });
        effect(() => {
            this.formArray.clear();
            this.ebaths().forEach((ebath) => {
                if (!ebath)
                    return;
                const builder = injectEBATHForm(new UntypedFormGroup({}), {
                    banks$: this.banks$,
                    readonlyWhen$: this.isReadonly$,
                });
                builder.groupConfig.form.patchValue({
                    ...ebath,
                    collectability: {
                        collectability: ebath?.collectability,
                    },
                });
                this.formArray.push(builder.groupConfig.form);
            });
        }, { allowSignalWrites: true });
        this.formArray.valueChanges
            .pipe(startWith(this.formArray.getRawValue()), tap((values) => {
            this.updated.emit(values.map((value) => this._mapFormToUIModel(value)));
        }))
            .subscribe();
    }
    addNew() {
        this.formArrayCreating.insert(0, injectEBATHForm(new UntypedFormGroup({}), {
            banks$: this.banks$,
            readonlyWhen$: this.isReadonly$,
        }).groupConfig.form);
    }
    update(ebath) {
        this.effects.update(this._mapFormToUIModel(ebath));
    }
    create(ebath, index) {
        const { id, ...rest } = this._mapFormToUIModel(ebath);
        this.effects.create(this.applicationId(), rest, () => {
            this.formArrayCreating.removeAt(index);
        });
    }
    cancel(index) {
        this.formArrayCreating.removeAt(index);
    }
    delete(ebath) {
        this.effects.delete(this.applicationId(), ebath.id);
    }
    _mapFormToUIModel(ebath) {
        if (ebath?.collectability
            ?.collectability) {
            ebath.collectability = {
                ...ebath.collectability
                    .collectability,
            };
        }
        return ebath;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWEBATHComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWEBATHComponent, isStandalone: true, selector: "fsw-ebath", outputs: { updated: "updated" }, providers: [provideEBATHService(), provideEBATHTranslation()], ngImport: i0, template: "<fsw-panel>\n  <ng-template fswPanelHeaderSuffix>\n    <button\n      *ngIf=\"!isReadonly()\"\n      (click)=\"addNew()\"\n      fswButton\n      [appearance]=\"'secondary'\"\n      [size]=\"'s'\"\n    >\n      {{ 'buttons.add' | fswTranslate }}\n    </button>\n  </ng-template>\n  <section class=\"w-full flex flex-col gap-6\">\n    <header class=\"w-full flex items-center gap-6\">\n      <fsw-ebath-tile\n        class=\"w-1/4\"\n        [type]=\"'all'\"\n        [data]=\"formArray.getRawValue().concat(formArrayCreating.getRawValue())\"\n      ></fsw-ebath-tile>\n      <fsw-ebath-tile\n        class=\"w-1/4\"\n        [type]=\"EBALoanType.LongTerm\"\n        [data]=\"formArray.getRawValue().concat(formArrayCreating.getRawValue())\"\n      ></fsw-ebath-tile>\n      <fsw-ebath-tile\n        class=\"w-1/4\"\n        [type]=\"EBALoanType.ShortTerm\"\n        [data]=\"formArray.getRawValue().concat(formArrayCreating.getRawValue())\"\n      ></fsw-ebath-tile>\n      <fsw-ebath-tile\n        class=\"w-1/4\"\n        [type]=\"EBALoanType.Guarantee\"\n        [data]=\"formArray.getRawValue().concat(formArrayCreating.getRawValue())\"\n      ></fsw-ebath-tile>\n    </header>\n    <main class=\"w-full flex flex-col gap-6\">\n      <ng-container *ngIf=\"isEmpty()\">\n        <section class=\"flex flex-col gap-4 items-center justify-center w-full p-8\">\n          <p>{{ 'empty' | fswTranslate }}</p>\n        </section>\n      </ng-container>\n      <ng-container *ngFor=\"let formGroup of formArrayCreating.controls; let i = index\">\n        <fsw-ebath-box\n          [formGroup]=\"formGroup | fswForceGroup\"\n          [banks]=\"banks()\"\n          [isReadonly]=\"isReadonly()\"\n          (saved)=\"create(formGroup.getRawValue(), i)\"\n          (deleted)=\"cancel(i)\"\n        ></fsw-ebath-box>\n      </ng-container>\n      <ng-container *ngFor=\"let formGroup of formArray.controls\">\n        <fsw-ebath-box\n          [formGroup]=\"formGroup | fswForceGroup\"\n          [banks]=\"banks()\"\n          [isReadonly]=\"isReadonly()\"\n          (deleted)=\"delete(formGroup.getRawValue())\"\n          (saved)=\"update(formGroup.getRawValue())\"\n        ></fsw-ebath-box>\n      </ng-container>\n    </main>\n  </section>\n</fsw-panel>\n", styles: ["fsw-ebath .eba-field{width:calc(calc(100% - 80px) / 6)}fsw-ebath .fsw-table{--fsw-table-tbody-padding: 0 !important}fsw-ebath .fsw-table .fsw-field>main{border-radius:0!important}fsw-ebath .fsw-table thead tr:not(:first-child) th{padding:var(--fsw-table-thead-padding) 0!important}fsw-ebath .fsw-table tbody tr td:has(input){border:none!important}fsw-ebath .fsw-table tbody tr td:has(input) main{padding:0!important}fsw-ebath .fsw-table tbody tr td:has(input) main input{text-align:center;width:100%}\n"], dependencies: [{ kind: "ngmodule", type: FSWAlertModule }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "ngmodule", type: CurrencyFormatModule }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: MasterDataServiceModule }, { kind: "ngmodule", type: FSWRadioModule }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "ngmodule", type: FSWTagsModule }, { kind: "component", type: FSWEBATHBoxComponent, selector: "fsw-ebath-box", inputs: ["formGroup", "banks", "isReadonly"], outputs: ["deleted", "saved"] }, { kind: "ngmodule", type: ForceGroupPipeModule }, { kind: "pipe", type: i1$4.FSWForceGroupPipe, name: "fswForceGroup" }, { kind: "component", type: FSWEBATHTileComponent, selector: "fsw-ebath-tile", inputs: ["type", "data"] }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWEBATHComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-ebath', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [provideEBATHService(), provideEBATHTranslation()], imports: [
                        FSWAlertModule,
                        FSWTranslateModule,
                        NgForOf,
                        CurrencyFormatModule,
                        FSWButtonModule,
                        FSWIconModule,
                        NgIf,
                        MasterDataServiceModule,
                        FSWRadioModule,
                        FormsModule,
                        FSWTagsModule,
                        FSWEBATHBoxComponent,
                        ForceGroupPipeModule,
                        FSWEBATHTileComponent,
                        FSWPanelModule,
                    ], encapsulation: ViewEncapsulation.None, template: "<fsw-panel>\n  <ng-template fswPanelHeaderSuffix>\n    <button\n      *ngIf=\"!isReadonly()\"\n      (click)=\"addNew()\"\n      fswButton\n      [appearance]=\"'secondary'\"\n      [size]=\"'s'\"\n    >\n      {{ 'buttons.add' | fswTranslate }}\n    </button>\n  </ng-template>\n  <section class=\"w-full flex flex-col gap-6\">\n    <header class=\"w-full flex items-center gap-6\">\n      <fsw-ebath-tile\n        class=\"w-1/4\"\n        [type]=\"'all'\"\n        [data]=\"formArray.getRawValue().concat(formArrayCreating.getRawValue())\"\n      ></fsw-ebath-tile>\n      <fsw-ebath-tile\n        class=\"w-1/4\"\n        [type]=\"EBALoanType.LongTerm\"\n        [data]=\"formArray.getRawValue().concat(formArrayCreating.getRawValue())\"\n      ></fsw-ebath-tile>\n      <fsw-ebath-tile\n        class=\"w-1/4\"\n        [type]=\"EBALoanType.ShortTerm\"\n        [data]=\"formArray.getRawValue().concat(formArrayCreating.getRawValue())\"\n      ></fsw-ebath-tile>\n      <fsw-ebath-tile\n        class=\"w-1/4\"\n        [type]=\"EBALoanType.Guarantee\"\n        [data]=\"formArray.getRawValue().concat(formArrayCreating.getRawValue())\"\n      ></fsw-ebath-tile>\n    </header>\n    <main class=\"w-full flex flex-col gap-6\">\n      <ng-container *ngIf=\"isEmpty()\">\n        <section class=\"flex flex-col gap-4 items-center justify-center w-full p-8\">\n          <p>{{ 'empty' | fswTranslate }}</p>\n        </section>\n      </ng-container>\n      <ng-container *ngFor=\"let formGroup of formArrayCreating.controls; let i = index\">\n        <fsw-ebath-box\n          [formGroup]=\"formGroup | fswForceGroup\"\n          [banks]=\"banks()\"\n          [isReadonly]=\"isReadonly()\"\n          (saved)=\"create(formGroup.getRawValue(), i)\"\n          (deleted)=\"cancel(i)\"\n        ></fsw-ebath-box>\n      </ng-container>\n      <ng-container *ngFor=\"let formGroup of formArray.controls\">\n        <fsw-ebath-box\n          [formGroup]=\"formGroup | fswForceGroup\"\n          [banks]=\"banks()\"\n          [isReadonly]=\"isReadonly()\"\n          (deleted)=\"delete(formGroup.getRawValue())\"\n          (saved)=\"update(formGroup.getRawValue())\"\n        ></fsw-ebath-box>\n      </ng-container>\n    </main>\n  </section>\n</fsw-panel>\n", styles: ["fsw-ebath .eba-field{width:calc(calc(100% - 80px) / 6)}fsw-ebath .fsw-table{--fsw-table-tbody-padding: 0 !important}fsw-ebath .fsw-table .fsw-field>main{border-radius:0!important}fsw-ebath .fsw-table thead tr:not(:first-child) th{padding:var(--fsw-table-thead-padding) 0!important}fsw-ebath .fsw-table tbody tr td:has(input){border:none!important}fsw-ebath .fsw-table tbody tr td:has(input) main{padding:0!important}fsw-ebath .fsw-table tbody tr td:has(input) main input{text-align:center;width:100%}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { updated: [{
                type: Output
            }] } });

var FSWEBATHDirective_1;
let FSWEBATHDirective = class FSWEBATHDirective {
    static { FSWEBATHDirective_1 = this; }
    static { this.REFRESH_KEY = 'fs-widgets-feature-ebath'; }
    constructor(_refreshService, _viewContainerRef) {
        this._refreshService = _refreshService;
        this._viewContainerRef = _viewContainerRef;
        this.updated = new EventEmitter();
        this.applicationId = null;
        this.isReadonly = false;
    }
    ngOnInit() {
        this._refreshService
            .register(FSWEBATHDirective_1.REFRESH_KEY)
            .pipe(followDestroy(this), tap(() => this.refresh()))
            .subscribe();
    }
    ngOnChanges() {
        this.refresh();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    refresh() {
        this._viewContainerRef.clear();
        if (!this.applicationId) {
            return;
        }
        const ref = this._viewContainerRef.createComponent(FSWEBATHComponent);
        const instance = ref.instance;
        instance.applicationId.set(this.applicationId);
        instance.isReadonly.set(this.isReadonly);
        instance.updated
            .asObservable()
            .pipe(followDestroy(this), tap((ebaths) => this.updated.emit(ebaths)))
            .subscribe();
        ref.changeDetectorRef.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWEBATHDirective, deps: [{ token: RefreshService }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWEBATHDirective, isStandalone: true, selector: "[fswEBATH]", inputs: { applicationId: "applicationId", isReadonly: "isReadonly" }, outputs: { updated: "updated" }, usesOnChanges: true, ngImport: i0 }); }
};
FSWEBATHDirective = FSWEBATHDirective_1 = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [RefreshService,
        ViewContainerRef])
], FSWEBATHDirective);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWEBATHDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswEBATH]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: RefreshService }, { type: i0.ViewContainerRef }]; }, propDecorators: { updated: [{
                type: Output
            }], applicationId: [{
                type: Input,
                args: [{ required: true }]
            }], isReadonly: [{
                type: Input
            }] } });

var EBAFields;
(function (EBAFields) {
    EBAFields["TYPE_OF_LOAN"] = "type_of_loan";
    EBAFields["INSTITUTION_NAME"] = "institution_name";
    EBAFields["COLLATERAL"] = "collateral";
    EBAFields["COLLATERAL_VALUE"] = "collateral_value";
    EBAFields["LIMIT"] = "limit";
    EBAFields["INTEREST"] = "interest";
    EBAFields["OUTSTANDING"] = "outstanding";
    EBAFields["MONTHLY_REPAYMENT"] = "monthly_repayment";
})(EBAFields || (EBAFields = {}));

var EBAIdFields;
(function (EBAIdFields) {
    EBAIdFields["ID"] = "id";
    EBAIdFields["BANK_ID"] = "bank_id";
})(EBAIdFields || (EBAIdFields = {}));

var EBACustomFields;
(function (EBACustomFields) {
    EBACustomFields["ACTIONS"] = "actions";
})(EBACustomFields || (EBACustomFields = {}));

const EBA_SERVICE_TOKEN = new InjectionToken('EBA_SERVICE_TOKEN');

class EBAService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._kongUrl = this._utilsService.getKongUrl();
    }
    getBanks(countryCode) {
        const url = `${this._kongUrl}/v2/master_data/banks/${countryCode}`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => (res ? res : { data: [] })), map(({ data }) => data.map((e) => ({ ...e, id: Number.parseInt(e.id.toString()) }))));
    }
    getAll(id, countryCode) {
        const url = `${this._kongUrl}/aps/v1/applications/${id}/relationships/existing_banking_arrangement`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map((res) => res?.data || []), map((data) => data.map((item) => item.relationship_id)), switchMap((ids) => ids.length > 0 ? forkJoin([...ids.map((id) => this.getById(id, countryCode))]) : of([])));
    }
    getById(id, countryCode) {
        let url = `${this._kongUrl}/credit/v2/${countryCode.toLowerCase()}/existing_banking_arrangements/${id}`;
        if (getCountryCodeFromStorage() === FSWCountryCode.TH) {
            url = `${this._kongUrl}/credit/v2/existing_banking_arrangements/${id}`;
        }
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => data));
    }
    post(data, id, countryCode) {
        let url = `${this._kongUrl}/credit/v2/${countryCode.toLowerCase()}/existing_banking_arrangements`;
        if (getCountryCodeFromStorage() === FSWCountryCode.TH) {
            url = `${this._kongUrl}/credit/v2/existing_banking_arrangements`;
        }
        return this._httpClient
            .post(url, data, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => data), switchMap((data) => {
            return this.postToApplication(data[EBAIdFields.ID], id).pipe(mapTo(data));
        }));
    }
    postToApplication(targetId, id) {
        const url = `${this._kongUrl}/aps/v1/applications/${id}/relationships/existing_banking_arrangement`;
        return this._httpClient.post(url, {
            ids: [targetId],
        }, {
            headers: setRequestOptions(),
        });
    }
    put(data, countryCode) {
        let url = `${this._kongUrl}/credit/v2/${countryCode.toLowerCase()}/existing_banking_arrangements/${data.id}`;
        if (getCountryCodeFromStorage() === FSWCountryCode.TH) {
            url = `${this._kongUrl}/credit/v2/existing_banking_arrangements/${data.id}`;
        }
        return this._httpClient
            .put(url, data, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => data));
    }
    remove(targetId, id, countryCode) {
        let url = `${this._kongUrl}/credit/v2/${countryCode.toLowerCase()}/existing_banking_arrangements//${targetId}`;
        if (getCountryCodeFromStorage() === FSWCountryCode.TH) {
            url = `${this._kongUrl}/credit/v2/existing_banking_arrangements/${targetId}`;
        }
        return this.removeFromApplication(targetId, id).pipe(switchMap(() => this._httpClient.delete(url, {
            headers: setRequestOptions(),
        })));
    }
    removeFromApplication(targetId, id) {
        const url = `${this._kongUrl}/aps/v1/applications/${id}/relationships/existing_banking_arrangement/${targetId}`;
        return this._httpClient.delete(url, {
            headers: setRequestOptions(),
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class EBAServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: EBAServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAServiceModule, providers: [
            {
                provide: EBA_SERVICE_TOKEN,
                useClass: EBAService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: EBA_SERVICE_TOKEN,
                            useClass: EBAService,
                        },
                    ],
                }]
        }] });

class EBAComponentStore extends ComponentStore {
    constructor(_custom, _service) {
        super({
            applicationId: null,
            isReadonly: false,
            data: [],
            ..._custom,
        });
        this._custom = _custom;
        this._service = _service;
        this.loadData = this.effect(pipe(switchMap(() => this.loadDataAsync()), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
    }
    post(data) {
        const effect = this.effect(pipe(switchMap((data) => this._service.post(data, this.get().applicationId, this.get().countryId)), switchMap(() => this.loadDataAsync()), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        effect(data);
    }
    put(data) {
        const effect = this.effect(pipe(switchMap((data) => this._service.put(data, this.get().countryId)), switchMap(() => this.loadDataAsync()), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        effect(data);
    }
    remove(id) {
        const effect = this.effect(pipe(switchMap((id) => this._service.remove(id, this.get().applicationId, this.get().countryId)), switchMap(() => this.loadDataAsync()), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        effect(id);
    }
    setApplicationId(data) {
        const updater = this.updater((state, applicationId) => ({
            ...state,
            applicationId,
        }));
        updater(data);
    }
    setIsReadonly(data) {
        const updater = this.updater((state, isReadonly) => ({
            ...state,
            isReadonly,
        }));
        updater(data);
    }
    setData(data) {
        const updater = this.updater((state, data) => ({
            ...state,
            data,
        }));
        updater(data);
    }
    loadDataAsync() {
        return this._service
            .getAll(this.get().applicationId, this.get().countryId)
            .pipe(tap((data) => this.setData(data)));
    }
}

const EBA_TYPE_OF_LOANS = [
    {
        value: 'Short Term',
        label: 'Short Term',
    },
    {
        value: 'Long Term',
        label: 'Long Term',
    },
];

const EBA_COMPONENT_STORE_TOKEN = new InjectionToken('EBA_COMPONENT_STORE_TOKEN');

const EBA_FORM_CONFIG_TOKEN = new InjectionToken('EBA_FORM_CONFIG_TOKEN');

const EBA_GRID_CONFIG_TOKEN = new InjectionToken('EBA_GRID_CONFIG_TOKEN');

const ebaDefaultFormConfig = {
    setup(translate, custom, data, isReadonly) {
        return {
            formFields: [
                {
                    key: EBAIdFields.BANK_ID,
                    label: translate[EBAIdFields.BANK_ID],
                    type: FIELD_TYPE.SELECT,
                    param: [{ value: data[EBAIdFields.BANK_ID], disabled: false }, [Validators.required]],
                    options: buildFieldOptions(custom.banks, 'id', 'code'),
                    context: {
                        isReadonly,
                    },
                },
                {
                    key: EBAFields.INSTITUTION_NAME,
                    label: translate[EBAFields.INSTITUTION_NAME],
                    type: FIELD_TYPE.STRING,
                    param: [{ value: data[EBAFields.INSTITUTION_NAME], disabled: false }, []],
                    context: {
                        isReadonly,
                        customRender: [
                            {
                                fields: [
                                    {
                                        key: EBAIdFields.BANK_ID,
                                        correctWhenValueIs: (value) => value == custom?.banks?.find((i) => i.code === 'Others')?.id,
                                    },
                                ],
                                cb: ({ renderView, clearView }, condition) => {
                                    if (condition) {
                                        renderView();
                                    }
                                    else {
                                        clearView();
                                    }
                                },
                            },
                        ],
                    },
                },
                {
                    key: EBAFields.TYPE_OF_LOAN,
                    label: translate[EBAFields.TYPE_OF_LOAN],
                    type: FIELD_TYPE.SELECT,
                    param: [{ value: data[EBAFields.TYPE_OF_LOAN], disabled: false }, [Validators.required]],
                    options: buildFieldOptions(EBA_TYPE_OF_LOANS),
                    context: {
                        isReadonly,
                    },
                },
                {
                    key: EBAFields.COLLATERAL,
                    label: translate[EBAFields.COLLATERAL],
                    type: FIELD_TYPE.STRING,
                    param: [{ value: data[EBAFields.COLLATERAL], disabled: false }, [Validators.required]],
                    context: {
                        isReadonly,
                    },
                },
                {
                    key: EBAFields.COLLATERAL_VALUE,
                    label: translate[EBAFields.COLLATERAL_VALUE],
                    type: FIELD_TYPE.NUMBER,
                    param: [
                        { value: data[EBAFields.COLLATERAL_VALUE], disabled: false },
                        [Validators.required],
                    ],
                    context: {
                        prefix: getCurrentCountryConfig().currencyCode,
                        isReadonly,
                    },
                },
                {
                    key: EBAFields.LIMIT,
                    label: translate[EBAFields.LIMIT],
                    type: FIELD_TYPE.NUMBER,
                    param: [{ value: data[EBAFields.LIMIT], disabled: false }, [Validators.required]],
                    context: {
                        prefix: getCurrentCountryConfig().currencyCode,
                        isReadonly,
                    },
                },
                {
                    key: EBAFields.INTEREST,
                    label: translate[EBAFields.INTEREST],
                    type: FIELD_TYPE.NUMBER,
                    param: [{ value: data[EBAFields.INTEREST], disabled: false }, [Validators.required]],
                    context: {
                        suffix: '%',
                        isReadonly,
                    },
                },
                {
                    key: EBAFields.OUTSTANDING,
                    label: translate[EBAFields.OUTSTANDING],
                    type: FIELD_TYPE.NUMBER,
                    param: [{ value: data[EBAFields.OUTSTANDING], disabled: false }, [Validators.required]],
                    context: {
                        prefix: getCurrentCountryConfig().currencyCode,
                        isReadonly,
                    },
                },
                {
                    key: EBAFields.MONTHLY_REPAYMENT,
                    label: translate[EBAFields.MONTHLY_REPAYMENT],
                    type: FIELD_TYPE.NUMBER,
                    param: [
                        { value: data[EBAFields.MONTHLY_REPAYMENT], disabled: false },
                        [Validators.required],
                    ],
                    context: {
                        prefix: getCurrentCountryConfig().currencyCode,
                        isReadonly: true,
                    },
                },
            ],
            formData: data,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        };
    },
    reset(oldConfig) {
        return {
            ...oldConfig,
            formFields: oldConfig.formFields.map((e) => ({
                ...e,
                context: {
                    ...(e.context || {}),
                    isReadonly: e.key === EBAFields.MONTHLY_REPAYMENT,
                },
            })),
            formFieldConfig: {
                ...(oldConfig.formFieldConfig || {}),
                isReadonly: false,
            },
        };
    },
    getValue(form, data) {
        return {
            ...form.value,
            [EBAIdFields.BANK_ID]: Number.parseInt(form.value[EBAIdFields.BANK_ID]),
            [EBAIdFields.ID]: data?.id,
        };
    },
    listenChange(form, cb) {
        let oldValue = form.value;
        return form.valueChanges
            .pipe(distinctUntilChanged(), filter((value) => {
            const checkOutstanding = oldValue[EBAFields.OUTSTANDING] !== value[EBAFields.OUTSTANDING];
            const checkInterest = oldValue[EBAFields.INTEREST] !== value[EBAFields.INTEREST];
            return checkOutstanding || checkInterest;
        }), tap((value) => {
            const interest = value[EBAFields.INTEREST] || 0;
            const outstanding = value[EBAFields.OUTSTANDING] || 0;
            const monthlyPaymentValue = (outstanding * (interest / 100)) / 12;
            const formattedValue = Number.parseFloat(monthlyPaymentValue.toFixed(2));
            oldValue = {
                ...value,
                [EBAFields.MONTHLY_REPAYMENT]: formattedValue,
            };
            form.controls[EBAFields.MONTHLY_REPAYMENT].setValue(formattedValue);
            cb();
        }))
            .subscribe();
    },
};

const ebaDefaultGridConfig = {
    setup(defaultOptions, translate, custom, data, action, isReadonly) {
        const decimalPipe = new DecimalPipe('en-IN');
        return {
            ...defaultOptions,
            rowData: data,
            columnDefs: [
                {
                    field: EBAIdFields.ID,
                    headerName: translate[EBAIdFields.ID],
                    width: 36,
                    cellRenderer: (params) => {
                        return params.node.rowIndex || 0 + 1;
                    },
                },
                {
                    field: EBAIdFields.BANK_ID,
                    headerName: translate[EBAIdFields.BANK_ID],
                    width: 94,
                    cellRenderer: (params) => {
                        const data = params.data || null;
                        const bank = data && custom.banks.find((e) => e.id == data[EBAIdFields.BANK_ID]);
                        return bank?.code || '';
                    },
                },
                {
                    field: EBAFields.TYPE_OF_LOAN,
                    headerName: translate[EBAFields.TYPE_OF_LOAN],
                    width: 104,
                },
                {
                    field: EBAFields.COLLATERAL,
                    headerName: translate[EBAFields.COLLATERAL],
                    width: 88,
                },
                {
                    field: EBAFields.COLLATERAL_VALUE,
                    headerName: translate[EBAFields.COLLATERAL_VALUE],
                    width: 136,
                    cellRenderer: (params) => {
                        const formattedValue = decimalPipe.transform(params.value, '.2');
                        return `${getCurrentCountryConfig().currencyCode} ${formattedValue}`;
                    },
                },
                {
                    field: EBAFields.LIMIT,
                    headerName: translate[EBAFields.LIMIT],
                    width: 136,
                    cellRenderer: (params) => {
                        const formattedValue = decimalPipe.transform(params.value, '.2');
                        return `${getCurrentCountryConfig().currencyCode} ${formattedValue}`;
                    },
                },
                {
                    field: EBAFields.INTEREST,
                    headerName: translate[EBAFields.INTEREST],
                    width: 96,
                },
                {
                    field: EBAFields.OUTSTANDING,
                    headerName: translate[EBAFields.OUTSTANDING],
                    width: 152,
                    cellRenderer: (params) => {
                        const formattedValue = decimalPipe.transform(params.value, '.2');
                        return `${getCurrentCountryConfig().currencyCode} ${formattedValue}`;
                    },
                },
                {
                    field: EBAFields.MONTHLY_REPAYMENT,
                    headerName: translate[EBAFields.MONTHLY_REPAYMENT],
                    width: 152,
                    cellRenderer: (params) => {
                        const formattedValue = new DecimalPipe('en-IN').transform(params.value, '.2');
                        return `${getCurrentCountryConfig().currencyCode} ${formattedValue}`;
                    },
                },
                ...(isReadonly
                    ? []
                    : [
                        {
                            field: EBACustomFields.ACTIONS,
                            headerName: '',
                            width: 56,
                            pinned: 'right',
                            cellRendererSelector: (params) => ({
                                component: 'actionMethods',
                                params: {
                                    ...params,
                                    onEdit: (params) => action(params.data, Methods.PUT),
                                    onDelete: (params) => action(params.data, Methods.DELETE),
                                },
                            }),
                        },
                    ]),
            ],
        };
    },
};

class EBADefaultComponentStore extends EBAComponentStore {
    get custom() {
        return {
            banks: this.state().banks,
            countryId: this.state().countryId,
        };
    }
    get custom$() {
        return this.state$.pipe(map((state) => ({
            banks: state.banks,
            countryId: state.countryId,
        })));
    }
    constructor(_ebaService) {
        super({
            banks: [],
            countryId: getCountryCodeFromStorage(),
        }, _ebaService);
        this._ebaService = _ebaService;
        this.loadBanks = this.effect(pipe(switchMap(() => this.loadBanksAsync()), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        this.updateBanks = this.updater((state, banks) => ({
            ...state,
            banks,
        }));
    }
    init() {
        this.loadBanks();
        this.loadData();
    }
    loadBanksAsync() {
        return this._ebaService
            .getBanks(this.get().countryId)
            .pipe(tap((banks) => this.updateBanks(banks)));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBADefaultComponentStore, deps: [{ token: EBA_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBADefaultComponentStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBADefaultComponentStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [EBA_SERVICE_TOKEN]
                }] }]; } });

const providers = [
    {
        provide: EBA_FORM_CONFIG_TOKEN,
        useValue: ebaDefaultFormConfig,
    },
    {
        provide: EBA_GRID_CONFIG_TOKEN,
        useValue: ebaDefaultGridConfig,
    },
    {
        provide: EBA_COMPONENT_STORE_TOKEN,
        useClass: EBADefaultComponentStore,
        deps: [EBA_SERVICE_TOKEN],
    },
];

var ebaDefault_provider = /*#__PURE__*/Object.freeze({
    __proto__: null,
    providers: providers
});

class EBAEntryDialogComponent {
    constructor(context, _translateService, _scope, _cdr, _modalComponent) {
        this.context = context;
        this._translateService = _translateService;
        this._scope = _scope;
        this._cdr = _cdr;
        this._modalComponent = _modalComponent;
        this.fields$ = this._translateService.selectFeatureTranslate(this._scope, 'fields');
        this.titles$ = this._translateService.selectFeatureTranslate(this._scope, 'titles');
        this.buttons$ = this._translateService.selectFeatureTranslate(this._scope, 'buttons');
        this.translate$ = combineLatest([this.titles$, this.buttons$, this.fields$]).pipe(map(([titles, buttons, fields]) => ({ titles, buttons, fields })));
        this.config = null;
        this.form = null;
        this.formSubscription = null;
        this.configuration((fields) => this.setupForm(fields));
    }
    submit() {
        if (!this.form) {
            return this.cancel();
        }
        if (this.form.invalid)
            return;
        const data = this.context.data.config.getValue(this.form, this.context.data.selectedItem);
        const checkEqual = isEqualWith(data, this.context.data.selectedItem);
        if (checkEqual) {
            return this.cancel();
        }
        this.context.completeWith({
            method: this.context.data.method,
            data,
        });
    }
    cancel() {
        this.context.completeWith(null);
    }
    remove() {
        this.context.completeWith({
            method: Methods.DELETE,
            data: null,
        });
    }
    listen(form) {
        this.form = form;
        this.formSubscription = this.context.data.config.listenChange(form, () => {
            this._cdr.markForCheck();
        });
    }
    configuration(cb) {
        this.translate$
            .pipe(take(1), tap(({ fields, titles }) => {
            this._modalComponent.setLabel(titles[this.context.data.method]);
            cb(fields, titles);
            this._cdr.markForCheck();
        }))
            .subscribe();
    }
    changeMode() {
        this.configuration(() => {
            if (!this.config)
                return;
            this.formSubscription?.unsubscribe();
            this.formSubscription = null;
            this.config = this.context.data.config.reset(this.config);
        });
    }
    setupForm(fields) {
        this.config = this.context.data.config.setup(fields, this.context.data.custom, this.context.data.selectedItem || {}, this.context.data.method === Methods.GET);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAEntryDialogComponent, deps: [{ token: MODAL_CONTEXT }, { token: TranslocoFeatureHttpLoader }, { token: TRANSLOCO_SCOPE }, { token: i0.ChangeDetectorRef }, { token: ModalComponent }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: EBAEntryDialogComponent, selector: "fsw-eba-entry-dialog", ngImport: i0, template: "<ng-container *ngIf=\"translate$ | async as translate\">\n\t<fsw-save-dialog\n\t\t[config]=\"config\"\n\t\t[(method)]=\"context.data.method\"\n\t\t[buttonDeleteLabel]=\"translate.buttons['delete']\"\n\t\t[buttonSaveLabel]=\"translate.buttons[context.data.method]\"\n\t\t[buttonCancelLabel]=\"translate.buttons['cancel']\"\n\t\t[buttonEditLabel]=\"translate.buttons['edit']\"\n\t\t[buttonBackLabel]=\"translate.buttons['back']\"\n\t\t(methodChange)=\"changeMode()\"\n\t\t(listen)=\"listen($event)\"\n\t\t(remove)=\"remove()\"\n\t\t(cancel)=\"cancel()\"\n\t\t(save)=\"submit()\"\n\t>\n\t</fsw-save-dialog>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FSWSaveDialogComponent, selector: "fsw-save-dialog", inputs: ["method", "config", "buttonDeleteLabel", "buttonCancelLabel", "buttonBackLabel", "buttonEditLabel", "buttonSaveLabel", "isReadonly"], outputs: ["remove", "cancel", "save", "listen", "methodChange"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAEntryDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-eba-entry-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"translate$ | async as translate\">\n\t<fsw-save-dialog\n\t\t[config]=\"config\"\n\t\t[(method)]=\"context.data.method\"\n\t\t[buttonDeleteLabel]=\"translate.buttons['delete']\"\n\t\t[buttonSaveLabel]=\"translate.buttons[context.data.method]\"\n\t\t[buttonCancelLabel]=\"translate.buttons['cancel']\"\n\t\t[buttonEditLabel]=\"translate.buttons['edit']\"\n\t\t[buttonBackLabel]=\"translate.buttons['back']\"\n\t\t(methodChange)=\"changeMode()\"\n\t\t(listen)=\"listen($event)\"\n\t\t(remove)=\"remove()\"\n\t\t(cancel)=\"cancel()\"\n\t\t(save)=\"submit()\"\n\t>\n\t</fsw-save-dialog>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_CONTEXT]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: i0.ChangeDetectorRef }, { type: ModalComponent }]; } });

class EBAEntryDialogModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAEntryDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: EBAEntryDialogModule, declarations: [EBAEntryDialogComponent], imports: [CommonModule, FSWSaveDialogModule, TranslocoModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAEntryDialogModule, imports: [CommonModule, FSWSaveDialogModule, TranslocoModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAEntryDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FSWSaveDialogModule, TranslocoModule],
                    declarations: [EBAEntryDialogComponent],
                }]
        }] });

class EBAEntryRemoveDialogComponent {
    constructor(context, _translateService, _scope, _cdr, _modalComponent) {
        this.context = context;
        this._translateService = _translateService;
        this._scope = _scope;
        this._cdr = _cdr;
        this._modalComponent = _modalComponent;
        this.others$ = this._translateService.selectFeatureTranslate(this._scope, 'others');
        this.titles$ = this._translateService.selectFeatureTranslate(this._scope, 'titles');
        this.buttons$ = this._translateService.selectFeatureTranslate(this._scope, 'buttons');
        this.translate$ = combineLatest([this.titles$, this.buttons$, this.others$]).pipe(map(([titles, buttons, others]) => ({ titles, buttons, others })));
        this.configuration();
    }
    cancel() {
        this.context.completeWith(false);
    }
    remove() {
        this.context.completeWith(true);
    }
    configuration() {
        this.titles$
            .pipe(tap((titles) => {
            this._modalComponent.setLabel(titles['confirm']);
            this._cdr.markForCheck();
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAEntryRemoveDialogComponent, deps: [{ token: MODAL_CONTEXT }, { token: TranslocoFeatureHttpLoader }, { token: TRANSLOCO_SCOPE }, { token: i0.ChangeDetectorRef }, { token: ModalComponent }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: EBAEntryRemoveDialogComponent, selector: "fsw-eba-entry-remove-dialog", ngImport: i0, template: "<ng-container *ngIf=\"translate$ | async as translate\">\n\t<fsw-remove-dialog\n\t\t[buttonCancelLabel]=\"translate.buttons['cancel']\"\n\t\t[buttonDeleteLabel]=\"translate.buttons['delete']\"\n\t\t[description]=\"translate.others['description']\"\n\t\t(cancel)=\"cancel()\"\n\t\t(remove)=\"remove()\"\n\t></fsw-remove-dialog>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FSWRemoveDialogComponent, selector: "fsw-remove-dialog", inputs: ["description", "buttonDeleteLabel", "buttonCancelLabel"], outputs: ["remove", "cancel"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAEntryRemoveDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-eba-entry-remove-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"translate$ | async as translate\">\n\t<fsw-remove-dialog\n\t\t[buttonCancelLabel]=\"translate.buttons['cancel']\"\n\t\t[buttonDeleteLabel]=\"translate.buttons['delete']\"\n\t\t[description]=\"translate.others['description']\"\n\t\t(cancel)=\"cancel()\"\n\t\t(remove)=\"remove()\"\n\t></fsw-remove-dialog>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_CONTEXT]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: i0.ChangeDetectorRef }, { type: ModalComponent }]; } });

class EBAEntryRemoveDialogModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAEntryRemoveDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: EBAEntryRemoveDialogModule, declarations: [EBAEntryRemoveDialogComponent], imports: [CommonModule, TranslocoModule, FSWRemoveDialogModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAEntryRemoveDialogModule, imports: [CommonModule, TranslocoModule, FSWRemoveDialogModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAEntryRemoveDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, TranslocoModule, FSWRemoveDialogModule],
                    declarations: [EBAEntryRemoveDialogComponent],
                }]
        }] });

class EBAGridComponent {
    set data(data) {
        this.data$.next(data);
    }
    set custom(custom) {
        this.custom$.next(custom);
    }
    constructor(_translateService, _scope) {
        this._translateService = _translateService;
        this._scope = _scope;
        this.action = new EventEmitter();
        this.isReadonly = false;
        this.config = null;
        this.data$ = new BehaviorSubject([]);
        this.custom$ = new BehaviorSubject(null);
        this.state$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'fields'),
            this.data$,
            this.custom$,
        ]).pipe(map(([translate, data, custom]) => this.setupGridOptions(translate, data, custom)));
        this.gridOptions = {
            rowSelection: 'multiple',
            headerHeight: 36,
            rowHeight: 36,
            pagination: false,
        };
    }
    setupGridOptions(translate, data, custom) {
        return this.config && custom
            ? this.config.setup(this.gridOptions, translate, custom, data, (res, method) => this.action.emit({ res, method }), this.isReadonly)
            : undefined;
    }
    rowClicked({ data, index }) {
        this.action.emit({
            res: data,
            method: Methods.GET,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAGridComponent, deps: [{ token: TranslocoFeatureHttpLoader }, { token: TRANSLOCO_SCOPE }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: EBAGridComponent, selector: "fsw-eba-grid", inputs: { data: "data", isReadonly: "isReadonly", config: "config", custom: "custom" }, outputs: { action: "action" }, ngImport: i0, template: "<ng-container *ngIf=\"state$ | async as state\">\n\t<fsw-grid\n\t\t(rowClicked)=\"rowClicked($event)\"\n\t\t[gridOptions]=\"state\"\n\t\t[rowData]=\"state.rowData || []\"\n\t></fsw-grid>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FSWGridComponent, selector: "fsw-grid", inputs: ["gridOptions", "actionClickedCheck", "rowData", "gridContainerHeight"], outputs: ["rowClicked"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAGridComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-eba-grid', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"state$ | async as state\">\n\t<fsw-grid\n\t\t(rowClicked)=\"rowClicked($event)\"\n\t\t[gridOptions]=\"state\"\n\t\t[rowData]=\"state.rowData || []\"\n\t></fsw-grid>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: TranslocoFeatureHttpLoader }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }]; }, propDecorators: { action: [{
                type: Output
            }], data: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], config: [{
                type: Input
            }], custom: [{
                type: Input
            }] } });

class EBAGridModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAGridModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: EBAGridModule, declarations: [EBAGridComponent], imports: [CommonModule, FSWGridModule, TranslocoModule, LetDirective], exports: [EBAGridComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAGridModule, imports: [CommonModule, FSWGridModule, TranslocoModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAGridModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FSWGridModule, TranslocoModule, LetDirective],
                    declarations: [EBAGridComponent],
                    exports: [EBAGridComponent],
                }]
        }] });

class EBAControlComponent {
    set data(items) {
        let limit = 0;
        let outstanding = 0;
        let monthly_repayment = 0;
        items.forEach((item) => {
            limit += item[EBAFields.LIMIT];
            outstanding += item[EBAFields.OUTSTANDING];
            monthly_repayment += item[EBAFields.MONTHLY_REPAYMENT];
        });
        this.limit = limit;
        this.outstanding = outstanding;
        this.monthly_repayment = monthly_repayment;
    }
    constructor(_scope, _translateService) {
        this._scope = _scope;
        this._translateService = _translateService;
        this.add = new EventEmitter();
        this.isReadonly = false;
        this.totals$ = this._translateService.selectFeatureTranslate(this._scope, 'totals');
        this.buttons$ = this._translateService.selectFeatureTranslate(this._scope, 'buttons');
        this.limit = 0;
        this.outstanding = 0;
        this.monthly_repayment = 0;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAControlComponent, deps: [{ token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: EBAControlComponent, selector: "fsw-eba-control", inputs: { data: "data", isReadonly: "isReadonly" }, outputs: { add: "add" }, ngImport: i0, template: "<div class=\"eba-control\">\n  <ng-container *ngIf=\"totals$ | async as totals\">\n    <div class=\"eba-control__fields\">\n      <div class=\"eba-control__total\">\n        <span>{{ totals['limit'] }}</span>\n        <span [fswNumberRunning]=\"limit\"></span>\n      </div>\n      <div class=\"eba-control__total\">\n        <span>{{ totals['outstanding'] }}</span>\n        <span [fswNumberRunning]=\"outstanding\"></span>\n      </div>\n      <div class=\"eba-control__total\">\n        <span>{{ totals['monthly_repayment'] }}</span>\n        <span [fswNumberRunning]=\"monthly_repayment\"></span>\n      </div>\n    </div>\n  </ng-container>\n  <ng-container *ngIf=\"!isReadonly\">\n    <ng-container *ngIf=\"buttons$ | async as buttons\">\n      <button class=\"btn btn--secondary\" (click)=\"add.emit()\">{{ buttons['post'] }}</button>\n    </ng-container>\n  </ng-container>\n</div>\n", styles: [":host .eba-control{width:100%;padding:16px 0;display:flex;align-items:flex-end;justify-content:space-between}:host .eba-control__fields{display:flex;gap:16px}:host .eba-control__total{height:85px;min-width:192px;padding:16px;border-radius:4px;display:flex;flex-direction:column;gap:8px;border:1px solid #e0e0e0}:host .eba-control__total span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:16px;line-height:1.5}:host .eba-control__total span:first-child{font-weight:400;color:#757575}:host .eba-control__total span:nth-child(2){font-weight:500;color:#222}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NumberRunningDirective, selector: "[fswNumberRunning]", inputs: ["fswNumberRunning"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAControlComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-eba-control', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"eba-control\">\n  <ng-container *ngIf=\"totals$ | async as totals\">\n    <div class=\"eba-control__fields\">\n      <div class=\"eba-control__total\">\n        <span>{{ totals['limit'] }}</span>\n        <span [fswNumberRunning]=\"limit\"></span>\n      </div>\n      <div class=\"eba-control__total\">\n        <span>{{ totals['outstanding'] }}</span>\n        <span [fswNumberRunning]=\"outstanding\"></span>\n      </div>\n      <div class=\"eba-control__total\">\n        <span>{{ totals['monthly_repayment'] }}</span>\n        <span [fswNumberRunning]=\"monthly_repayment\"></span>\n      </div>\n    </div>\n  </ng-container>\n  <ng-container *ngIf=\"!isReadonly\">\n    <ng-container *ngIf=\"buttons$ | async as buttons\">\n      <button class=\"btn btn--secondary\" (click)=\"add.emit()\">{{ buttons['post'] }}</button>\n    </ng-container>\n  </ng-container>\n</div>\n", styles: [":host .eba-control{width:100%;padding:16px 0;display:flex;align-items:flex-end;justify-content:space-between}:host .eba-control__fields{display:flex;gap:16px}:host .eba-control__total{height:85px;min-width:192px;padding:16px;border-radius:4px;display:flex;flex-direction:column;gap:8px;border:1px solid #e0e0e0}:host .eba-control__total span{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:16px;line-height:1.5}:host .eba-control__total span:first-child{font-weight:400;color:#757575}:host .eba-control__total span:nth-child(2){font-weight:500;color:#222}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }]; }, propDecorators: { add: [{
                type: Output
            }], data: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class EBAControlModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAControlModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: EBAControlModule, declarations: [EBAControlComponent], imports: [CommonModule, TranslocoModule, NumberRunningModule], exports: [EBAControlComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAControlModule, imports: [CommonModule, TranslocoModule, NumberRunningModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAControlModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, TranslocoModule, NumberRunningModule],
                    declarations: [EBAControlComponent],
                    exports: [EBAControlComponent],
                }]
        }] });

class EBAComponent {
    set applicationId(value) {
        this._componentStore.setApplicationId(value);
    }
    set isReadonly(value) {
        this._componentStore.setIsReadonly(value);
    }
    constructor(_componentStore, _formConfig, gridConfig, _modalService, _injector) {
        this._componentStore = _componentStore;
        this._formConfig = _formConfig;
        this.gridConfig = gridConfig;
        this._modalService = _modalService;
        this._injector = _injector;
        this.state$ = this._componentStore.state$;
        this.custom$ = this._componentStore.custom$;
        this.Methods = Methods;
    }
    ngOnInit() {
        this._componentStore.init();
    }
    open(method, selectedItem) {
        const data = {
            selectedItem,
            custom: this._componentStore.custom,
            method,
            config: this._formConfig,
        };
        this._modalService
            .open(EBAEntryDialogComponent, {
            data,
            size: ModalSizes.M,
            injector: this._injector,
        })
            .pipe(take(1), tap((res) => {
            if (!res)
                return;
            const { method, data } = res;
            if (method === Methods.POST) {
                this._componentStore.post(data);
            }
            else if (method === Methods.PUT) {
                this._componentStore.put({
                    ...selectedItem,
                    ...data,
                });
            }
            else if (method === Methods.DELETE) {
                selectedItem && this.remove(selectedItem);
            }
        }))
            .subscribe();
    }
    remove(selectedItem) {
        this._modalService
            .open(EBAEntryRemoveDialogComponent, {
            size: ModalSizes.S,
            injector: this._injector,
        })
            .pipe(take(1), tap((res) => {
            if (!res)
                return;
            this._componentStore.remove(selectedItem[EBAIdFields.ID]);
        }))
            .subscribe();
    }
    action(res, method) {
        if (method === Methods.PUT || method === Methods.GET) {
            this.open(method, res);
        }
        else if (method === Methods.DELETE) {
            this.remove(res);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAComponent, deps: [{ token: EBA_COMPONENT_STORE_TOKEN }, { token: EBA_FORM_CONFIG_TOKEN }, { token: EBA_GRID_CONFIG_TOKEN }, { token: MODAL_SERVICE }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: EBAComponent, selector: "fsw-eba", inputs: { applicationId: "applicationId", isReadonly: "isReadonly" }, ngImport: i0, template: "<ng-container *ngIf=\"state$ | async as state\">\n  <fsw-eba-control\n    (add)=\"open(Methods.POST)\"\n    [data]=\"state.data\"\n    [isReadonly]=\"state.isReadonly\"\n  ></fsw-eba-control>\n  <fsw-eba-grid\n    [data]=\"state.data\"\n    [config]=\"gridConfig\"\n    [custom]=\"custom$ | async\"\n    [isReadonly]=\"state.isReadonly\"\n    (action)=\"action($event.res, $event.method)\"\n  ></fsw-eba-grid>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: EBAGridComponent, selector: "fsw-eba-grid", inputs: ["data", "isReadonly", "config", "custom"], outputs: ["action"] }, { kind: "component", type: EBAControlComponent, selector: "fsw-eba-control", inputs: ["data", "isReadonly"], outputs: ["add"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-eba', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"state$ | async as state\">\n  <fsw-eba-control\n    (add)=\"open(Methods.POST)\"\n    [data]=\"state.data\"\n    [isReadonly]=\"state.isReadonly\"\n  ></fsw-eba-control>\n  <fsw-eba-grid\n    [data]=\"state.data\"\n    [config]=\"gridConfig\"\n    [custom]=\"custom$ | async\"\n    [isReadonly]=\"state.isReadonly\"\n    (action)=\"action($event.res, $event.method)\"\n  ></fsw-eba-grid>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [EBA_COMPONENT_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [EBA_FORM_CONFIG_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [EBA_GRID_CONFIG_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_SERVICE]
                }] }, { type: i0.Injector }]; }, propDecorators: { applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

var totals = {
	limit: "Limit Total",
	outstanding: "Outstanding Total",
	monthly_repayment: "Monthly Repayment Total"
};
var fields$i = {
	id: "No.",
	bank_id: "Bank Name",
	institution_name: "Institution Name",
	type_of_loan: "Type of Loan",
	collateral: "Collateral",
	collateral_value: "Collateral Value",
	limit: "Limit",
	interest: "Interest (%)",
	outstanding: "Outstanding",
	monthly_repayment: "Monthly Repayment"
};
var titles$7 = {
	post: "Add New Entry",
	put: "Edit Entry",
	get: "View Entry",
	confirm: "Are you sure you want to delete?"
};
var buttons$C = {
	cancel: "Cancel",
	"delete": "Delete Entry",
	put: "Save Changes",
	post: "Add New Entry",
	back: "Back",
	edit: "Edit Details"
};
var others$3 = {
	description: "You will lose all information of the entry."
};
var _default$2 = {
	totals: totals,
	fields: fields$i,
	titles: titles$7,
	buttons: buttons$C,
	others: others$3
};

var de$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$C,
    default: _default$2,
    fields: fields$i,
    others: others$3,
    titles: titles$7,
    totals: totals
});

// import * as id from './i18n/languages/id.json';
// import * as vu from './i18n/languages/vu.json';
// import * as th from './i18n/languages/th.json';
const ebaLoader = {
    default: () => Promise.resolve(de$1),
    id: () => Promise.resolve(de$1),
    vu: () => Promise.resolve(de$1),
    th: () => Promise.resolve(de$1),
};

class EBADirective {
    constructor(_injector, _viewContainerRef, _resolver) {
        this._injector = _injector;
        this._viewContainerRef = _viewContainerRef;
        this._resolver = _resolver;
        this.countryId = null;
        this.applicationId = null;
        this.isReadonly = false;
        this._internationalMapping = {
            [FSWCountryCode.VU]: Promise.resolve().then(function () { return ebaDefault_provider; }).then((m) => m.providers),
            [FSWCountryCode.TH]: Promise.resolve().then(function () { return ebaDefault_provider; }).then((m) => m.providers),
        };
        this._default = Promise.resolve().then(function () { return ebaDefault_provider; }).then((m) => m.providers);
    }
    ngOnChanges() {
        this._viewContainerRef.clear();
        const mapAsync = this._internationalMapping[this.countryId] || this._default;
        from(mapAsync)
            .pipe(tap((providers) => {
            const factoryResolver = this._resolver.resolveComponentFactory(EBAComponent);
            const injector = Injector.create({
                parent: this._injector,
                providers: [
                    ...providers,
                    {
                        provide: TRANSLOCO_SCOPE,
                        useValue: {
                            scope: 'eba',
                            loader: ebaLoader,
                        },
                    },
                    {
                        provide: TRANSLOCO_LANG,
                        useValue: this.countryId?.toLowerCase() || 'default',
                    },
                    {
                        provide: TranslocoFeatureHttpLoader,
                        useClass: TranslocoFeatureHttpLoader,
                    },
                ],
            });
            const ref = this._viewContainerRef.createComponent(factoryResolver, 0, injector);
            ref.instance.applicationId = this.applicationId;
            ref.instance.isReadonly = this.isReadonly;
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBADirective, deps: [{ token: i0.Injector }, { token: i0.ViewContainerRef }, { token: i0.ComponentFactoryResolver }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: EBADirective, selector: "[fswEBA]", inputs: { countryId: "countryId", applicationId: "applicationId", isReadonly: "isReadonly" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBADirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswEBA]',
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }, { type: i0.ViewContainerRef }, { type: i0.ComponentFactoryResolver }]; }, propDecorators: { countryId: [{
                type: Input
            }], applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class EBAModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: EBAModule, declarations: [EBADirective, EBAComponent], imports: [CommonModule,
            FSWGridModule,
            LetDirective,
            FSWModalModule,
            EBAServiceModule,
            EBAEntryDialogModule,
            EBAEntryRemoveDialogModule,
            EBAGridModule,
            EBAControlModule,
            UtilsServiceModule], exports: [EBADirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAModule, imports: [CommonModule,
            FSWGridModule,
            FSWModalModule,
            EBAServiceModule,
            EBAEntryDialogModule,
            EBAEntryRemoveDialogModule,
            EBAGridModule,
            EBAControlModule,
            UtilsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EBAModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FSWGridModule,
                        LetDirective,
                        FSWModalModule,
                        EBAServiceModule,
                        EBAEntryDialogModule,
                        EBAEntryRemoveDialogModule,
                        EBAGridModule,
                        EBAControlModule,
                        UtilsServiceModule,
                    ],
                    declarations: [EBADirective, EBAComponent],
                    exports: [EBADirective],
                }]
        }] });

var title$n = "Borrower Exposure Details";
var comment$5 = "Factsheet Comments (Past & Current Facilites with FS)";
var total$2 = "Total";
var empty$b = "Borrower Exposure Details is empty";
var borrower$4 = {
	tab_name: "Borrower",
	columns: {
		product: "Product",
		product_limit: "Product Limit",
		outstanding_principal: "Outstanding Principal",
		outstanding_interest: "Outstanding Interest",
		pending_approval: "Pending Approval",
		total: "Total",
		number_of_loans: "Number of loans",
		repayments_completed: "Repayments completed",
		remarks: "Remarks"
	}
};
var related_parties$2 = {
	tab_name: "Related Parties",
	columns: {
		parties: "Parties",
		product_limit: "Product Limit",
		outstanding_principal: "Outstanding Principal",
		outstanding_interest: "Outstanding Interest",
		number_of_loans: "Number of loans",
		completed_loans: "Completed Loans",
		ongoing_loans: "Ongoing Loans",
		defaulted_loans: "Defaulted Loans",
		remarks: "Remarks"
	}
};
var buttons$B = {
	save: "Save Changes"
};
var my$f = {
	title: title$n,
	comment: comment$5,
	total: total$2,
	empty: empty$b,
	borrower: borrower$4,
	related_parties: related_parties$2,
	buttons: buttons$B
};

var MY$c = /*#__PURE__*/Object.freeze({
    __proto__: null,
    borrower: borrower$4,
    buttons: buttons$B,
    comment: comment$5,
    default: my$f,
    empty: empty$b,
    related_parties: related_parties$2,
    title: title$n,
    total: total$2
});

var title$m = "Borrower Exposure Details";
var comment$4 = "Factsheet Comments (Past & Current Facilites with FS)";
var total$1 = "Total";
var empty$a = "Borrower Exposure Details is empty";
var borrower$3 = {
	tab_name: "Borrower",
	columns: {
		product: "Product",
		product_limit: "Product Limit",
		outstanding_principal: "Outstanding Principal",
		outstanding_interest: "Outstanding Interest",
		pending_approval: "Pending Approval",
		total: "Total",
		number_of_loans: "Number of loans",
		repayments_completed: "Repayments completed",
		remarks: "Remarks"
	}
};
var related_parties$1 = {
	tab_name: "Related Parties",
	columns: {
		parties: "Parties",
		product_limit: "Product Limit",
		outstanding_principal: "Outstanding Principal",
		outstanding_interest: "Outstanding Interest",
		number_of_loans: "Number of loans",
		completed_loans: "Completed Loans",
		ongoing_loans: "Ongoing Loans",
		defaulted_loans: "Defaulted Loans",
		remarks: "Remarks"
	}
};
var buttons$A = {
	save: "Save Changes"
};
var th$5 = {
	title: title$m,
	comment: comment$4,
	total: total$1,
	empty: empty$a,
	borrower: borrower$3,
	related_parties: related_parties$1,
	buttons: buttons$A
};

var TH$6 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    borrower: borrower$3,
    buttons: buttons$A,
    comment: comment$4,
    default: th$5,
    empty: empty$a,
    related_parties: related_parties$1,
    title: title$m,
    total: total$1
});

var title$l = "Borrower Exposure Details";
var comment$3 = "Factsheet Comments (Past & Current Facilites with FS)";
var total = "Total";
var empty$9 = "Borrower Exposure Details is empty";
var borrower$2 = {
	tab_name: "Borrower",
	columns: {
		product: "Product",
		product_limit: "Product Limit",
		outstanding_principal: "Outstanding Principal",
		outstanding_interest: "Outstanding Interest",
		pending_approval: "Pending Approval",
		total: "Total",
		number_of_loans: "Number of loans",
		repayments_completed: "Repayments completed",
		remarks: "Remarks"
	}
};
var related_parties = {
	tab_name: "Related Parties",
	columns: {
		parties: "Parties",
		product_limit: "Product Limit",
		outstanding_principal: "Outstanding Principal",
		outstanding_interest: "Outstanding Interest",
		number_of_loans: "Number of loans",
		completed_loans: "Completed Loans",
		ongoing_loans: "Ongoing Loans",
		defaulted_loans: "Defaulted Loans",
		remarks: "Remarks"
	}
};
var buttons$z = {
	save: "Save Changes"
};
var sg$6 = {
	title: title$l,
	comment: comment$3,
	total: total,
	empty: empty$9,
	borrower: borrower$2,
	related_parties: related_parties,
	buttons: buttons$z
};

var SG$4 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    borrower: borrower$2,
    buttons: buttons$z,
    comment: comment$3,
    default: sg$6,
    empty: empty$9,
    related_parties: related_parties,
    title: title$l,
    total: total
});

const FSW_EXPOSURE_TRANSLATION_LOADER = {
    [CountryCode.MY]: MY$c,
    [CountryCode.TH]: TH$6,
    [CountryCode.SG]: SG$4,
};

class FSWExposureStore extends ApplicationMemberInformationStore {
    constructor(_alertService, _entity, _builder, _initialState) {
        super(_entity, _initialState);
        this._alertService = _alertService;
        this._entity = _entity;
        this._builder = _builder;
        this._initialState = _initialState;
        this.borrowerGroup = new UntypedFormGroup({});
        this.relatedGroup = new UntypedFormGroup({});
        this.idControl = new UntypedFormControl(null);
        this.refresh = this.effect(pipe(switchMap(() => {
            const { entityId, productUpi, member } = this.get();
            return this._entity
                .getData(entityId, productUpi, member)
                .pipe(tap(({ id, borrower_as_cg_exposure, recourse_exposures, borrower_product_exposures }) => {
                this.idControl.patchValue(id);
                this.borrowerGroup.patchValue({
                    borrower_product_exposures,
                });
                this.relatedGroup.patchValue({
                    borrower_as_cg_exposure,
                    recourse_exposures,
                });
            }));
        })));
        this.listenValueToChangeTotal = this.effect(pipe(switchMap(() => {
            const borrower_product_exposures = getControlFromGroup(this.borrowerGroup, 'borrower_product_exposures');
            const borrower_total = getControlFromGroup(this.borrowerGroup, 'total');
            const recourse_exposures = getControlFromGroup(this.relatedGroup, 'recourse_exposures');
            const borrower_as_cg_exposure = getControlFromGroup(this.relatedGroup, 'borrower_as_cg_exposure');
            const related_total = getControlFromGroup(this.relatedGroup, 'total');
            return combineLatest([
                borrower_product_exposures.valueChanges.pipe(startWith(borrower_product_exposures.value), tap((borrower_product_exposures) => {
                    borrower_total.patchValue({
                        ...borrower_product_exposures.reduce((acc, cur) => {
                            const product_limit = Number(((acc.product_limit || 0) + Number(cur.product_limit || '0')).toFixed(2));
                            const outstanding_principal = Number(((acc.outstanding_principal || 0) + Number(cur.outstanding_principal || '0')).toFixed(2));
                            const outstanding_interest = Number(((acc.outstanding_interest || 0) + Number(cur.outstanding_interest || '0')).toFixed(2));
                            const pending_approval = Number(((acc.pending_approval || 0) + Number(cur.pending_approval || '0')).toFixed(2));
                            return {
                                ...acc,
                                product_limit,
                                outstanding_principal,
                                outstanding_interest,
                                pending_approval,
                                total: Number((product_limit +
                                    outstanding_principal +
                                    outstanding_interest +
                                    pending_approval).toFixed(2)),
                                num_of_loans: Number(((acc.num_of_loans || 0) + Number(cur.num_of_loans || '0')).toFixed(2)),
                                num_of_repayments_completed: Number(((acc.num_of_repayments_completed || 0) +
                                    Number(cur.num_of_repayments_completed || '0')).toFixed(2)),
                            };
                        }, {}),
                    });
                })),
                combineLatest([
                    recourse_exposures.valueChanges.pipe(startWith(recourse_exposures.value)),
                    borrower_as_cg_exposure.valueChanges.pipe(startWith(borrower_as_cg_exposure.value)),
                ]).pipe(tap(([recourse_exposures, borrower_as_cg_exposure]) => {
                    related_total.patchValue({
                        ...[borrower_as_cg_exposure, ...recourse_exposures].reduce((acc, cur) => {
                            return {
                                ...acc,
                                product_limit: Number(((acc.product_limit || 0) + Number(cur.product_limit || '0')).toFixed(2)),
                                outstanding_principal: Number(((acc.outstanding_principal || 0) + Number(cur.outstanding_principal || '0')).toFixed(2)),
                                outstanding_interest: Number(((acc.outstanding_interest || 0) + Number(cur.outstanding_interest || '0')).toFixed(2)),
                                num_of_loans: Number(((acc.num_of_loans || 0) + Number(cur.num_of_loans || '0')).toFixed(2)),
                                num_of_completed_loans: Number(((acc.num_of_completed_loans || 0) +
                                    Number(cur.num_of_completed_loans || '0')).toFixed(2)),
                                num_of_ongoing_loans: Number(((acc.num_of_ongoing_loans || 0) + Number(cur.num_of_ongoing_loans || '0')).toFixed(2)),
                                num_of_default_loans: Number(((acc.num_of_default_loans || 0) + Number(cur.num_of_default_loans || '0')).toFixed(2)),
                            };
                        }, {}),
                    });
                })),
            ]);
        })));
        this.save = this.effect(pipe(switchMap(() => {
            return this._entity.updateMark({
                borrower_product_exposures: getControlFromGroup(this.borrowerGroup, 'borrower_product_exposures').value,
                borrower_as_cg_exposure: getControlFromGroup(this.relatedGroup, 'borrower_as_cg_exposure')
                    .value,
                recourse_exposures: getControlFromGroup(this.relatedGroup, 'recourse_exposures').value,
                id: this.idControl.value,
            });
        })));
        this.init = this.effect(pipe(mergeMap(() => this.setupInformation(this.get().entityId)), tap(() => {
            const { isReadonly } = this.get();
            const { borrowerBuilder, relatedBuilder } = this._builder({
                isReadonly,
                borrowerForm: this.borrowerGroup,
                relatedForm: this.relatedGroup,
            });
            this.updateState({
                borrowerBuilder,
                relatedBuilder,
            });
            this.listenValueToChangeTotal();
            this.refresh();
        })));
        this.updateState = (value) => this.patchState({
            ...value,
        });
    }
}

const FSW_EXPOSURE_STORE_TOKEN = new InjectionToken('FSW_EXPOSURE_STORE_TOKEN');

const FSW_EXPOSURE_FORM_TOKEN = new InjectionToken('FSW_EXPOSURE_FORM_TOKEN');

const FSW_EXPOSURE_ENTITY_TOKEN = new InjectionToken('FSW_EXPOSURE_ENTITY_TOKEN');

class FSWExposureStoreMY extends FSWExposureStore {
    constructor(alertService, entity, builder) {
        super(alertService, entity, builder, {
            entityId: null,
            entityType: FSWEntityTypes.APPLICATION,
            member: null,
            isReadonly: false,
            borrowerBuilder: null,
            relatedBuilder: null,
            productUpi: null,
            hiddenComment: false,
        });
        this.alertService = alertService;
        this.entity = entity;
        this.builder = builder;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWExposureStoreMY, deps: [{ token: FSW_ALERT_SERVICE_TOKEN }, { token: FSW_EXPOSURE_ENTITY_TOKEN }, { token: FSW_EXPOSURE_ENTITY_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWExposureStoreMY }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWExposureStoreMY, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_EXPOSURE_ENTITY_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_EXPOSURE_ENTITY_TOKEN]
                }] }]; } });

const FSWExposureFormMY = (config) => {
    const { borrowerForm, relatedForm, isReadonly } = config;
    const translation = FSW_EXPOSURE_TRANSLATION_LOADER[CountryCode.MY];
    return {
        borrowerBuilder: new FSWDynamicBuilder({
            formType: FSWDynamicBuilderFormTypes.TABLE,
            form: borrowerForm,
            customClasses: 'fsw-table w-max',
            header: [
                {
                    columns: [
                        {
                            label: translation.borrower.columns.product,
                            width: 300,
                        },
                        {
                            label: translation.borrower.columns.product_limit,
                            width: 100,
                        },
                        {
                            label: translation.borrower.columns.outstanding_principal,
                            width: 100,
                        },
                        {
                            label: translation.borrower.columns.outstanding_interest,
                            width: 100,
                        },
                        {
                            label: translation.borrower.columns.pending_approval,
                            width: 100,
                        },
                        {
                            label: translation.borrower.columns.total,
                            width: 100,
                        },
                        {
                            label: translation.borrower.columns.number_of_loans,
                            width: 100,
                        },
                        {
                            label: translation.borrower.columns.repayments_completed,
                            width: 100,
                        },
                        {
                            label: translation.borrower.columns.remarks,
                            width: 300,
                        },
                    ],
                },
            ],
            items: [
                {
                    body: {
                        isLoop: true,
                        key: 'borrower_product_exposures',
                        data: {
                            columns: [
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'render_name',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                isReadonly: true,
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'product_limit',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'outstanding_principal',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'outstanding_interest',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'pending_approval',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'total',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                                afterCreated: (control, group) => {
                                                    group.valueChanges
                                                        .pipe(startWith(group.value), mergeMap(() => {
                                                        return combineLatest([
                                                            getControlFromGroup(group, 'product_limit').valueChanges.pipe(startWith(0)),
                                                            getControlFromGroup(group, 'outstanding_principal').valueChanges.pipe(startWith(0)),
                                                            getControlFromGroup(group, 'outstanding_interest').valueChanges.pipe(startWith(0)),
                                                            getControlFromGroup(group, 'pending_approval').valueChanges.pipe(startWith(0)),
                                                        ]);
                                                    }), tap((values) => {
                                                        control.patchValue(values.reduce((acc, curr) => acc + curr, 0), { emitEvent: false });
                                                    }))
                                                        .subscribe();
                                                },
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_repayments_completed',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'remark',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            readonlyWhen$: of(isReadonly),
                                            context: {
                                                inputType: 'area',
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                        },
                                        {
                                            key: 'borrower_id',
                                            type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                            context: {
                                                isHidden: true,
                                            },
                                        },
                                        {
                                            key: 'product_id',
                                            type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                            context: {
                                                isHidden: true,
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                        empty: {
                            emptyTemplateKey: 'empty_list',
                            emptyTemplateColSpan: 9,
                        },
                    },
                },
            ],
            footer: [
                {
                    key: 'total',
                    columns: [
                        {
                            label: translation.total,
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'product_limit',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'outstanding_principal',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'outstanding_interest',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'pending_approval',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'total',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                        afterCreated: (control, group) => {
                                            group.valueChanges
                                                .pipe(startWith(group.value), mergeMap(() => {
                                                return combineLatest([
                                                    getControlFromGroup(group, 'product_limit').valueChanges.pipe(startWith(0)),
                                                    getControlFromGroup(group, 'outstanding_principal').valueChanges.pipe(startWith(0)),
                                                    getControlFromGroup(group, 'outstanding_interest').valueChanges.pipe(startWith(0)),
                                                    getControlFromGroup(group, 'pending_approval').valueChanges.pipe(startWith(0)),
                                                ]);
                                            }), tap((values) => {
                                                control.patchValue(values.reduce((acc, curr) => acc + curr, 0), { emitEvent: false });
                                            }))
                                                .subscribe();
                                        },
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'num_of_loans',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => value ?? '0',
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'num_of_repayments_completed',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => value ?? '0',
                                    },
                                },
                            ],
                        },
                        {
                            label: '',
                        },
                    ],
                },
            ],
        }),
        relatedBuilder: new FSWDynamicBuilder({
            formType: FSWDynamicBuilderFormTypes.TABLE,
            form: relatedForm,
            customClasses: 'fsw-table w-max',
            header: [
                {
                    columns: [
                        {
                            label: translation.related_parties.columns.parties,
                            width: 300,
                        },
                        {
                            label: translation.related_parties.columns.product_limit,
                            width: 100,
                        },
                        {
                            label: translation.related_parties.columns.outstanding_principal,
                            width: 100,
                        },
                        {
                            label: translation.related_parties.columns.outstanding_interest,
                            width: 100,
                        },
                        {
                            label: translation.related_parties.columns.number_of_loans,
                            width: 100,
                        },
                        {
                            label: translation.related_parties.columns.completed_loans,
                            width: 100,
                        },
                        {
                            label: translation.related_parties.columns.ongoing_loans,
                            width: 100,
                        },
                        {
                            label: translation.related_parties.columns.defaulted_loans,
                            width: 100,
                        },
                        {
                            label: translation.related_parties.columns.remarks,
                            width: 100,
                        },
                    ],
                },
            ],
            items: [
                {
                    header: [
                        {
                            key: 'borrower_as_cg_exposure',
                            columns: [
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'render_name',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                isReadonly: true,
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'product_limit',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'outstanding_principal',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'outstanding_interest',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_completed_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_ongoing_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_default_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'remark',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'area',
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                        },
                                        {
                                            key: 'borrower_id',
                                            type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                            context: {
                                                isHidden: true,
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                    body: {
                        isLoop: true,
                        key: 'recourse_exposures',
                        data: {
                            columns: [
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'render_name',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                isReadonly: true,
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'product_limit',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'outstanding_principal',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'outstanding_interest',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_completed_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_ongoing_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_default_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'remark',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            readonlyWhen$: of(isReadonly),
                                            context: {
                                                inputType: 'area',
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                        },
                                        {
                                            key: 'recourse_id',
                                            type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                            context: {
                                                isHidden: true,
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                        empty: {
                            emptyTemplateKey: 'empty_list',
                            emptyTemplateColSpan: 9,
                        },
                    },
                },
            ],
            footer: [
                {
                    key: 'total',
                    columns: [
                        {
                            label: translation.total,
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'product_limit',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'outstanding_principal',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'outstanding_interest',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'num_of_loans',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => value ?? '0',
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'num_of_completed_loans',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => value ?? '0',
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'num_of_ongoing_loans',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => value ?? '0',
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'num_of_default_loans',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => value ?? '0',
                                    },
                                },
                            ],
                        },
                        {
                            label: '',
                        },
                    ],
                },
            ],
        }),
    };
};

const FSW_EXPOSURE_MY_PROVIDERS = [
    {
        provide: FSW_EXPOSURE_FORM_TOKEN,
        useValue: FSWExposureFormMY,
    },
    {
        provide: FSW_EXPOSURE_STORE_TOKEN,
        useClass: FSWExposureStoreMY,
        deps: [FSW_ALERT_SERVICE_TOKEN, FSW_EXPOSURE_ENTITY_TOKEN, FSW_EXPOSURE_FORM_TOKEN],
    },
];

class FSWExposureStoreSG extends FSWExposureStore {
    constructor(alertService, entity, builder) {
        super(alertService, entity, builder, {
            entityId: null,
            entityType: FSWEntityTypes.APPLICATION,
            member: null,
            isReadonly: false,
            borrowerBuilder: null,
            relatedBuilder: null,
            productUpi: null,
            hiddenComment: false,
        });
        this.alertService = alertService;
        this.entity = entity;
        this.builder = builder;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWExposureStoreSG, deps: [{ token: FSW_ALERT_SERVICE_TOKEN }, { token: FSW_EXPOSURE_ENTITY_TOKEN }, { token: FSW_EXPOSURE_ENTITY_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWExposureStoreSG }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWExposureStoreSG, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_EXPOSURE_ENTITY_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_EXPOSURE_ENTITY_TOKEN]
                }] }]; } });

const FSWExposureFormSG = (config) => {
    const { borrowerForm, relatedForm, isReadonly } = config;
    const translation = FSW_EXPOSURE_TRANSLATION_LOADER[CountryCode.MY];
    return {
        borrowerBuilder: new FSWDynamicBuilder({
            formType: FSWDynamicBuilderFormTypes.TABLE,
            form: borrowerForm,
            customClasses: 'fsw-table w-max',
            header: [
                {
                    columns: [
                        {
                            label: translation.borrower.columns.product,
                            width: 300,
                        },
                        {
                            label: translation.borrower.columns.product_limit,
                            width: 100,
                        },
                        {
                            label: translation.borrower.columns.outstanding_principal,
                            width: 100,
                        },
                        {
                            label: translation.borrower.columns.outstanding_interest,
                            width: 100,
                        },
                        {
                            label: translation.borrower.columns.pending_approval,
                            width: 100,
                        },
                        {
                            label: translation.borrower.columns.total,
                            width: 100,
                        },
                        {
                            label: translation.borrower.columns.number_of_loans,
                            width: 100,
                        },
                        {
                            label: translation.borrower.columns.repayments_completed,
                            width: 100,
                        },
                        {
                            label: translation.borrower.columns.remarks,
                            width: 300,
                        },
                    ],
                },
            ],
            items: [
                {
                    body: {
                        isLoop: true,
                        key: 'borrower_product_exposures',
                        data: {
                            columns: [
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'render_name',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                isReadonly: true,
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'product_limit',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'outstanding_principal',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'outstanding_interest',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'pending_approval',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'total',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                                afterCreated: (control, group) => {
                                                    group.valueChanges
                                                        .pipe(startWith(group.value), mergeMap(() => {
                                                        return combineLatest([
                                                            getControlFromGroup(group, 'product_limit').valueChanges.pipe(startWith(0)),
                                                            getControlFromGroup(group, 'outstanding_principal').valueChanges.pipe(startWith(0)),
                                                            getControlFromGroup(group, 'outstanding_interest').valueChanges.pipe(startWith(0)),
                                                            getControlFromGroup(group, 'pending_approval').valueChanges.pipe(startWith(0)),
                                                        ]);
                                                    }), tap((values) => {
                                                        control.patchValue(values.reduce((acc, curr) => acc + curr, 0), { emitEvent: false });
                                                    }))
                                                        .subscribe();
                                                },
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_repayments_completed',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'remark',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            readonlyWhen$: of(isReadonly),
                                            context: {
                                                inputType: 'area',
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                        },
                                        {
                                            key: 'borrower_id',
                                            type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                            context: {
                                                isHidden: true,
                                            },
                                        },
                                        {
                                            key: 'product_id',
                                            type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                            context: {
                                                isHidden: true,
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                        empty: {
                            emptyTemplateKey: 'empty_list',
                            emptyTemplateColSpan: 9,
                        },
                    },
                },
            ],
            footer: [
                {
                    key: 'total',
                    columns: [
                        {
                            label: translation.total,
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'product_limit',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        // inputType: 'number',
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'outstanding_principal',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        // inputType: 'number',
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'outstanding_interest',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        // inputType: 'number',
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'pending_approval',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        // inputType: 'number',
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'total',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        // inputType: 'number',
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                        afterCreated: (control, group) => {
                                            group.valueChanges
                                                .pipe(startWith(group.value), mergeMap(() => {
                                                return combineLatest([
                                                    getControlFromGroup(group, 'product_limit').valueChanges.pipe(startWith(0)),
                                                    getControlFromGroup(group, 'outstanding_principal').valueChanges.pipe(startWith(0)),
                                                    getControlFromGroup(group, 'outstanding_interest').valueChanges.pipe(startWith(0)),
                                                    getControlFromGroup(group, 'pending_approval').valueChanges.pipe(startWith(0)),
                                                ]);
                                            }), tap((values) => {
                                                control.patchValue(values.reduce((acc, curr) => acc + curr, 0), { emitEvent: false });
                                            }))
                                                .subscribe();
                                        },
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'num_of_loans',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        // inputType: 'number',
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => value ?? '0',
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'num_of_repayments_completed',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        // inputType: 'number',
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => value ?? '0',
                                    },
                                },
                            ],
                        },
                        {
                            label: '',
                        },
                    ],
                },
            ],
        }),
        relatedBuilder: new FSWDynamicBuilder({
            formType: FSWDynamicBuilderFormTypes.TABLE,
            form: relatedForm,
            customClasses: 'fsw-table w-max',
            header: [
                {
                    columns: [
                        {
                            label: translation.related_parties.columns.parties,
                            width: 300,
                        },
                        {
                            label: translation.related_parties.columns.product_limit,
                            width: 100,
                        },
                        {
                            label: translation.related_parties.columns.outstanding_principal,
                            width: 100,
                        },
                        {
                            label: translation.related_parties.columns.outstanding_interest,
                            width: 100,
                        },
                        {
                            label: translation.related_parties.columns.number_of_loans,
                            width: 100,
                        },
                        {
                            label: translation.related_parties.columns.completed_loans,
                            width: 100,
                        },
                        {
                            label: translation.related_parties.columns.ongoing_loans,
                            width: 100,
                        },
                        {
                            label: translation.related_parties.columns.defaulted_loans,
                            width: 100,
                        },
                        {
                            label: translation.related_parties.columns.remarks,
                            width: 100,
                        },
                    ],
                },
            ],
            items: [
                {
                    header: [
                        {
                            key: 'borrower_as_cg_exposure',
                            columns: [
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'render_name',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                isReadonly: true,
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'product_limit',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'outstanding_principal',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'outstanding_interest',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_completed_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_ongoing_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_default_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'remark',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'area',
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                        },
                                        {
                                            key: 'borrower_id',
                                            type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                            context: {
                                                isHidden: true,
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                    body: {
                        isLoop: true,
                        key: 'recourse_exposures',
                        data: {
                            columns: [
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'render_name',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                isReadonly: true,
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'product_limit',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'outstanding_principal',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'outstanding_interest',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_completed_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_ongoing_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_default_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                // inputType: 'number',
                                                mask: {
                                                    expression: 'separator.2',
                                                    config: {
                                                        thousandSeparator: ',',
                                                    },
                                                },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'remark',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            readonlyWhen$: of(isReadonly),
                                            context: {
                                                inputType: 'area',
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                        },
                                        {
                                            key: 'recourse_id',
                                            type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                            context: {
                                                isHidden: true,
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                        empty: {
                            emptyTemplateKey: 'empty_list',
                            emptyTemplateColSpan: 9,
                        },
                    },
                },
            ],
            footer: [
                {
                    key: 'total',
                    columns: [
                        {
                            label: translation.total,
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'product_limit',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        // inputType: 'number',
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'outstanding_principal',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        // inputType: 'number',
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'outstanding_interest',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        // inputType: 'number',
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'num_of_loans',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        // inputType: 'number',
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => value ?? '0',
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'num_of_completed_loans',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        // inputType: 'number',
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => value ?? '0',
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'num_of_ongoing_loans',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        // inputType: 'number',
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => value ?? '0',
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'num_of_default_loans',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        // inputType: 'number',
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => value ?? '0',
                                    },
                                },
                            ],
                        },
                        {
                            label: '',
                        },
                    ],
                },
            ],
        }),
    };
};

const FSW_EXPOSURE_SG_PROVIDERS = [
    {
        provide: FSW_EXPOSURE_FORM_TOKEN,
        useValue: FSWExposureFormSG,
    },
    {
        provide: FSW_EXPOSURE_STORE_TOKEN,
        useClass: FSWExposureStoreSG,
        deps: [FSW_ALERT_SERVICE_TOKEN, FSW_EXPOSURE_ENTITY_TOKEN, FSW_EXPOSURE_FORM_TOKEN],
    },
];

class FSWExposureStoreTH extends FSWExposureStore {
    constructor(alertService, entity, builder) {
        super(alertService, entity, builder, {
            entityId: null,
            entityType: FSWEntityTypes.APPLICATION,
            member: null,
            isReadonly: false,
            borrowerBuilder: null,
            relatedBuilder: null,
            productUpi: null,
            hiddenComment: false,
        });
        this.alertService = alertService;
        this.entity = entity;
        this.builder = builder;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWExposureStoreTH, deps: [{ token: FSW_ALERT_SERVICE_TOKEN }, { token: FSW_EXPOSURE_ENTITY_TOKEN }, { token: FSW_EXPOSURE_ENTITY_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWExposureStoreTH }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWExposureStoreTH, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_EXPOSURE_ENTITY_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_EXPOSURE_ENTITY_TOKEN]
                }] }]; } });

const FSWExposureFormTH = (config) => {
    const { borrowerForm, relatedForm, isReadonly } = config;
    const translation = FSW_EXPOSURE_TRANSLATION_LOADER[CountryCode.TH];
    return {
        borrowerBuilder: new FSWDynamicBuilder({
            formType: FSWDynamicBuilderFormTypes.TABLE,
            form: borrowerForm,
            customClasses: 'fsw-table w-max',
            header: [
                {
                    columns: [
                        {
                            label: translation.borrower.columns.product,
                            width: 300,
                        },
                        {
                            label: translation.borrower.columns.product_limit,
                            width: 100,
                        },
                        {
                            label: translation.borrower.columns.outstanding_principal,
                            width: 100,
                        },
                        {
                            label: translation.borrower.columns.outstanding_interest,
                            width: 100,
                        },
                        {
                            label: translation.borrower.columns.pending_approval,
                            width: 100,
                        },
                        {
                            label: translation.borrower.columns.total,
                            width: 100,
                        },
                        {
                            label: translation.borrower.columns.number_of_loans,
                            width: 100,
                        },
                        {
                            label: translation.borrower.columns.repayments_completed,
                            width: 100,
                        },
                        {
                            label: translation.borrower.columns.remarks,
                            width: 300,
                        },
                    ],
                },
            ],
            items: [
                {
                    body: {
                        isLoop: true,
                        key: 'borrower_product_exposures',
                        data: {
                            columns: [
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'render_name',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                isReadonly: true,
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'product_limit',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'outstanding_principal',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'outstanding_interest',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'pending_approval',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'total',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                                afterCreated: (control, group) => {
                                                    group.valueChanges
                                                        .pipe(startWith(group.value), mergeMap(() => {
                                                        return combineLatest([
                                                            getControlFromGroup(group, 'product_limit').valueChanges.pipe(startWith(0)),
                                                            getControlFromGroup(group, 'outstanding_principal').valueChanges.pipe(startWith(0)),
                                                            getControlFromGroup(group, 'outstanding_interest').valueChanges.pipe(startWith(0)),
                                                            getControlFromGroup(group, 'pending_approval').valueChanges.pipe(startWith(0)),
                                                        ]);
                                                    }), tap((values) => {
                                                        control.patchValue(values.reduce((acc, curr) => acc + curr, 0), { emitEvent: false });
                                                    }))
                                                        .subscribe();
                                                },
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_repayments_completed',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'remark',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            readonlyWhen$: of(isReadonly),
                                            context: {
                                                inputType: 'area',
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                        },
                                        {
                                            key: 'borrower_id',
                                            type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                            context: {
                                                isHidden: true,
                                            },
                                        },
                                        {
                                            key: 'product_id',
                                            type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                            context: {
                                                isHidden: true,
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                        empty: {
                            emptyTemplateKey: 'empty_list',
                            emptyTemplateColSpan: 9,
                        },
                    },
                },
            ],
            footer: [
                {
                    key: 'total',
                    columns: [
                        {
                            label: translation.total,
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'product_limit',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'outstanding_principal',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'outstanding_interest',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'pending_approval',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'total',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                        afterCreated: (control, group) => {
                                            group.valueChanges
                                                .pipe(startWith(group.value), mergeMap(() => {
                                                return combineLatest([
                                                    getControlFromGroup(group, 'product_limit').valueChanges.pipe(startWith(0)),
                                                    getControlFromGroup(group, 'outstanding_principal').valueChanges.pipe(startWith(0)),
                                                    getControlFromGroup(group, 'outstanding_interest').valueChanges.pipe(startWith(0)),
                                                    getControlFromGroup(group, 'pending_approval').valueChanges.pipe(startWith(0)),
                                                ]);
                                            }), tap((values) => {
                                                control.patchValue(values.reduce((acc, curr) => acc + curr, 0), { emitEvent: false });
                                            }))
                                                .subscribe();
                                        },
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'num_of_loans',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => value ?? '0',
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'num_of_repayments_completed',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => value ?? '0',
                                    },
                                },
                            ],
                        },
                        {
                            label: '',
                        },
                    ],
                },
            ],
        }),
        relatedBuilder: new FSWDynamicBuilder({
            formType: FSWDynamicBuilderFormTypes.TABLE,
            form: relatedForm,
            customClasses: 'fsw-table w-max',
            header: [
                {
                    columns: [
                        {
                            label: translation.related_parties.columns.parties,
                            width: 300,
                        },
                        {
                            label: translation.related_parties.columns.product_limit,
                            width: 100,
                        },
                        {
                            label: translation.related_parties.columns.outstanding_principal,
                            width: 100,
                        },
                        {
                            label: translation.related_parties.columns.outstanding_interest,
                            width: 100,
                        },
                        {
                            label: translation.related_parties.columns.number_of_loans,
                            width: 100,
                        },
                        {
                            label: translation.related_parties.columns.completed_loans,
                            width: 100,
                        },
                        {
                            label: translation.related_parties.columns.ongoing_loans,
                            width: 100,
                        },
                        {
                            label: translation.related_parties.columns.defaulted_loans,
                            width: 100,
                        },
                        {
                            label: translation.related_parties.columns.remarks,
                            width: 100,
                        },
                    ],
                },
            ],
            items: [
                {
                    header: [
                        {
                            key: 'borrower_as_cg_exposure',
                            columns: [
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'render_name',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                isReadonly: true,
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'product_limit',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'outstanding_principal',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'outstanding_interest',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_completed_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_ongoing_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_default_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'remark',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'area',
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                        },
                                        {
                                            key: 'borrower_id',
                                            type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                            context: {
                                                isHidden: true,
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                    body: {
                        isLoop: true,
                        key: 'recourse_exposures',
                        data: {
                            columns: [
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'render_name',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                isReadonly: true,
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'product_limit',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'outstanding_principal',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'outstanding_interest',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_completed_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_ongoing_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'num_of_default_loans',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            context: {
                                                inputType: 'number',
                                                // mask: {
                                                //   expression: 'separator.2',
                                                //   config: {
                                                //     thousandSeparator: ',',
                                                //   },
                                                // },
                                                isReadonly: true,
                                                prefix: 'currency',
                                                readonlyTemplate: (value) => value ?? '0',
                                            },
                                        },
                                    ],
                                },
                                {
                                    columnType: 'control',
                                    fields: [
                                        {
                                            key: 'remark',
                                            type: FSWDynamicBuilderControlTypes.INPUT,
                                            readonlyWhen$: of(isReadonly),
                                            context: {
                                                inputType: 'area',
                                                readonlyTemplate: (value) => value ?? 'N/A',
                                            },
                                        },
                                        {
                                            key: 'recourse_id',
                                            type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                            context: {
                                                isHidden: true,
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                        empty: {
                            emptyTemplateKey: 'empty_list',
                            emptyTemplateColSpan: 9,
                        },
                    },
                },
            ],
            footer: [
                {
                    key: 'total',
                    columns: [
                        {
                            label: translation.total,
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'product_limit',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'outstanding_principal',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'outstanding_interest',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => (value ? Number(value).toFixed(2) : '0'),
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'num_of_loans',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => value ?? '0',
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'num_of_completed_loans',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => value ?? '0',
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'num_of_ongoing_loans',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => value ?? '0',
                                    },
                                },
                            ],
                        },
                        {
                            columnType: 'control',
                            fields: [
                                {
                                    key: 'num_of_default_loans',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        inputType: 'number',
                                        // mask: {
                                        //   expression: 'separator.2',
                                        //   config: {
                                        //     thousandSeparator: ',',
                                        //   },
                                        // },
                                        isReadonly: true,
                                        prefix: 'currency',
                                        readonlyTemplate: (value) => value ?? '0',
                                    },
                                },
                            ],
                        },
                        {
                            label: '',
                        },
                    ],
                },
            ],
        }),
    };
};

const FSW_EXPOSURE_TH_PROVIDERS = [
    {
        provide: FSW_EXPOSURE_FORM_TOKEN,
        useValue: FSWExposureFormTH,
    },
    {
        provide: FSW_EXPOSURE_STORE_TOKEN,
        useClass: FSWExposureStoreTH,
        deps: [FSW_ALERT_SERVICE_TOKEN, FSW_EXPOSURE_ENTITY_TOKEN, FSW_EXPOSURE_FORM_TOKEN],
    },
];

class FSWExposureLoanEntity {
    getApplicationMembersInformation(entityId, applicationParams, memberParams) {
        throw new Error('Method not implemented.');
    }
    getData(entityId, product_upi, member) {
        throw new Error('Method not implemented.');
    }
    refresh(entityId, product_upi, member) {
        throw new Error('Method not implemented.');
    }
    updateMark(data) {
        throw new Error('Method not implemented.');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWExposureLoanEntity, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWExposureLoanEntity }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWExposureLoanEntity, decorators: [{
            type: Injectable
        }] });

class FSWExposureApplicationEntity {
    constructor(_applicationExposureService, _applicationGuarantorService, _creditExposureService, _productService, _loanService, _memberService, _applicationServiceService) {
        this._applicationExposureService = _applicationExposureService;
        this._applicationGuarantorService = _applicationGuarantorService;
        this._creditExposureService = _creditExposureService;
        this._productService = _productService;
        this._loanService = _loanService;
        this._memberService = _memberService;
        this._applicationServiceService = _applicationServiceService;
    }
    getApplicationMembersInformation(entityId, applicationParams, memberParams) {
        return this._applicationServiceService.getApplicationMembersInformation(entityId, applicationParams, memberParams);
    }
    getData(entityId, product_upi, member) {
        return this._applicationExposureService.getExposure(entityId).pipe(switchMap((id) => {
            if (!id) {
                return this.getExposureRefreshPayload(entityId, product_upi, member).pipe(switchMap((payload) => this._creditExposureService.calculateExposure(payload).pipe(switchMap((exposure) => {
                    return this._applicationExposureService
                        .addExposure(entityId, exposure.id)
                        .pipe(switchMap(() => this.getExposureWithRenderName(exposure)));
                }))));
            }
            return this._creditExposureService
                .getExposure(id)
                .pipe(switchMap((exposure) => this.getExposureWithRenderName(exposure)));
        }));
    }
    refresh(entityId, product_upi, member) {
        return this.getExposureRefreshPayload(entityId, product_upi, member).pipe(switchMap((payload) => this._creditExposureService.refreshExposure(payload)), switchMap((exposure) => this.getExposureWithRenderName(exposure)));
    }
    updateMark(data) {
        const { borrower_as_cg_exposure, recourse_exposures, borrower_product_exposures } = data;
        return this._creditExposureService
            .updateExposureRemark({
            ...data,
            borrower_as_cg_exposure: omit(borrower_as_cg_exposure, ['render_name', 'total']),
            recourse_exposures: (recourse_exposures || []).map((item) => omit(item, ['render_name', 'total'])),
            borrower_product_exposures: (borrower_product_exposures || []).map((item) => omit(item, ['render_name', 'total'])),
        })
            .pipe(switchMap((exposure) => this.getExposureWithRenderName(exposure)));
    }
    getExposureWithRenderName(exposure) {
        return zip(this._productService.getProducts({
            country_code: getCountryCodeFromStorage(),
        }), this._memberService.getSingleMember(exposure.borrower_as_cg_exposure.borrower_id), ...(exposure.recourse_exposures || []).map((item) => this._loanService.getRecourseById(item.recourse_id).pipe(map((recourse) => ({
            ...item,
            render_name: recourse.name,
        }))))).pipe(map(([products, member, ...recourse_exposures]) => {
            return {
                ...exposure,
                borrower_product_exposures: (exposure.borrower_product_exposures || []).map((item) => {
                    const product = products.find((product) => product.id === item.product_id);
                    return {
                        ...item,
                        render_name: product?.name,
                    };
                }),
                borrower_as_cg_exposure: {
                    ...exposure.borrower_as_cg_exposure,
                    render_name: member.fullname,
                },
                recourse_exposures,
            };
        }));
    }
    getExposureRefreshPayload(entityId, product_upi, member) {
        return this._applicationGuarantorService.getSummaries(entityId).pipe(filter$1((bip_application_summary_data) => !!bip_application_summary_data?.length), map((bip_application_summary_data) => ({
            product_upi,
            borrower_uuid: member.uuid,
            borrower_id: Number(member.id),
            bip_application_summary_data,
        })));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWExposureApplicationEntity, deps: [{ token: APPLICATION_EXPOSURE_SERVICE_TOKEN }, { token: APPLICATION_GUARANTOR_SERVICE_TOKEN }, { token: CREDIT_EXPOSURE_SERVICE_TOKEN }, { token: FSW_PRODUCT_SERVICE_TOKEN }, { token: FSW_LOAN_SERVICE_TOKEN }, { token: MEMBER_SERVICE_TOKEN }, { token: APPLICATION_MEMBER_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWExposureApplicationEntity }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWExposureApplicationEntity, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_EXPOSURE_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_GUARANTOR_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CREDIT_EXPOSURE_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PRODUCT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_LOAN_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_SERVICE_TOKEN]
                }] }]; } });

const FSW_EXPOSURE_PROVIDERS = {
    default: FSW_EXPOSURE_MY_PROVIDERS,
    [CountryCode.MY]: FSW_EXPOSURE_MY_PROVIDERS,
    [CountryCode.TH]: FSW_EXPOSURE_TH_PROVIDERS,
    [CountryCode.SG]: FSW_EXPOSURE_SG_PROVIDERS,
};
const exposureLoadProviders = (countryCode, entityType) => [
    fswTranslateScope('exposure'),
    ...exposureEntityLoadProviders(entityType),
    ...getCustomProviders(FSW_EXPOSURE_PROVIDERS, FSW_EXPOSURE_MY_PROVIDERS, countryCode),
];
const exposureEntityLoadProviders = (entityType) => {
    if (entityType === FSWEntityTypes.LOAN) {
        return [
            {
                provide: FSW_EXPOSURE_ENTITY_TOKEN,
                useClass: FSWExposureLoanEntity,
                deps: [],
            },
        ];
    }
    return [
        {
            provide: FSW_EXPOSURE_ENTITY_TOKEN,
            useClass: FSWExposureApplicationEntity,
            deps: [
                APPLICATION_EXPOSURE_SERVICE_TOKEN,
                APPLICATION_GUARANTOR_SERVICE_TOKEN,
                CREDIT_EXPOSURE_SERVICE_TOKEN,
                FSW_PRODUCT_SERVICE_TOKEN,
                FSW_LOAN_SERVICE_TOKEN,
                MEMBER_SERVICE_TOKEN,
                APPLICATION_MEMBER_SERVICE_TOKEN,
            ],
        },
    ];
};

class ExposureComponent {
    set productUpi(productUpi) {
        this._componentStore.updateState({
            productUpi,
        });
    }
    set entityId(entityId) {
        this._componentStore.updateState({
            entityId,
        });
    }
    set entityType(entityType) {
        this._componentStore.updateState({
            entityType,
        });
    }
    set isReadonly(isReadonly) {
        this._componentStore.updateState({
            isReadonly,
        });
    }
    set hiddenComment(hiddenComment) {
        this._componentStore.updateState({
            hiddenComment,
        });
    }
    constructor(_componentStore) {
        this._componentStore = _componentStore;
        this.state$ = this._componentStore.state$;
        this.borrowerGroup = this._componentStore.borrowerGroup;
        this.relatedGroup = this._componentStore.relatedGroup;
    }
    ngOnInit() {
        this._componentStore.init();
    }
    save() {
        this._componentStore.save();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ExposureComponent, deps: [{ token: FSW_EXPOSURE_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ExposureComponent, selector: "fsw-exposure", inputs: { productUpi: "productUpi", entityId: "entityId", entityType: "entityType", isReadonly: "isReadonly", hiddenComment: "hiddenComment" }, ngImport: i0, template: "<section class=\"flex flex-col gap-[16px]\" *ngIf=\"state$ | async as state\">\n  <fsw-tabs-group [customRowGap]=\"'24px'\">\n    <ng-template\n      fswTabs\n      [key]=\"'borrower'\"\n      [maxTextWidth]=\"'unset'\"\n      [label]=\"'borrower.tab_name' | fswTranslate\"\n    >\n      <fsw-panel [title]=\"'title' | fswTranslate\">\n        <ng-template fswPanelHeaderSuffix>\n          <button\n            *ngIf=\"!state.isReadonly\"\n            [disabled]=\"borrowerGroup.invalid\"\n            fswButton\n            appearance=\"secondary\"\n            (click)=\"save()\"\n          >\n            {{ 'buttons.save' | fswTranslate }}\n          </button>\n        </ng-template>\n        <section class=\"w-full overflow-auto\">\n          <form [formGroup]=\"borrowerGroup\">\n            <fsw-dynamic-builder [builder]=\"state.borrowerBuilder\">\n              <ng-template fswDynamicBuilderTemplate key=\"empty_list\">\n                <p class=\"w-full text-center text-yellow-500 font-bold p-[16px]\">\n                  {{ 'empty' | fswTranslate }}\n                </p>\n              </ng-template>\n              <ng-template fswDynamicBuilderTemplate key=\"currency\">\n                <span>RM</span>\n              </ng-template>\n            </fsw-dynamic-builder>\n          </form>\n        </section>\n      </fsw-panel>\n    </ng-template>\n    <ng-template\n      fswTabs\n      [key]=\"'related_parties'\"\n      [maxTextWidth]=\"'unset'\"\n      [label]=\"'related_parties.tab_name' | fswTranslate\"\n    >\n      <fsw-panel [title]=\"'title' | fswTranslate\">\n        <ng-template fswPanelHeaderSuffix>\n          <button\n            *ngIf=\"!state.isReadonly\"\n            [disabled]=\"relatedGroup.invalid\"\n            fswButton\n            appearance=\"secondary\"\n            (click)=\"save()\"\n          >\n            {{ 'buttons.save' | fswTranslate }}\n          </button>\n        </ng-template>\n        <section class=\"w-full overflow-auto\">\n          <form [formGroup]=\"relatedGroup\">\n            <fsw-dynamic-builder [builder]=\"state.relatedBuilder\">\n              <ng-template fswDynamicBuilderTemplate key=\"empty_list\">\n                <p class=\"w-full text-center text-yellow-500 font-bold p-[16px]\">\n                  {{ 'empty' | fswTranslate }}\n                </p>\n              </ng-template>\n              <ng-template fswDynamicBuilderTemplate key=\"currency\">\n                <span>RM</span>\n              </ng-template>\n            </fsw-dynamic-builder>\n          </form>\n        </section>\n      </fsw-panel>\n    </ng-template>\n  </fsw-tabs-group>\n  <ng-container *ngIf=\"!state.hiddenComment\">\n    <fsw-comments\n      [category]=\"'FACTSHEET'\"\n      [title]=\"'comment' | fswTranslate : { scope: 'exposure' }\"\n      [module]=\"'EXPOSURE'\"\n      [identifier]=\"'EXPOSURE'\"\n      [entityId]=\"state.entityId?.toString() || null\"\n      [enableSaveButton]=\"true\"\n      [isReadonly]=\"state.isReadonly\"\n      [translateScope]=\"'exposure'\"\n    >\n      <ng-template\n        fswCommentsItem\n        [key]=\"'main_comment'\"\n        [label]=\"'comment' | fswTranslate : { scope: 'exposure' }\"\n      ></ng-template>\n    </fsw-comments>\n  </ng-container>\n</section>\n", dependencies: [{ kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i1$4.FSWTabsGroupComponent, selector: "fsw-tabs-group" }, { kind: "directive", type: i1$4.FSWTabsDirective, selector: "ng-template[fswTabs]" }, { kind: "component", type: FSWCommentsComponent, selector: "fsw-comments", inputs: ["title", "entityId", "identifier", "module", "category", "isReadonly", "rows", "customClasses", "enableSaveButton", "translateScope"] }, { kind: "directive", type: FSWCommentsItemDirective, selector: "ng-template[fswCommentsItem]", inputs: ["label", "key"] }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "directive", type: i1$4.FSWDynamicBuilderTemplateDirective, selector: "[fswDynamicBuilderTemplate]", inputs: ["key"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ExposureComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-exposure', changeDetection: ChangeDetectionStrategy.OnPush, template: "<section class=\"flex flex-col gap-[16px]\" *ngIf=\"state$ | async as state\">\n  <fsw-tabs-group [customRowGap]=\"'24px'\">\n    <ng-template\n      fswTabs\n      [key]=\"'borrower'\"\n      [maxTextWidth]=\"'unset'\"\n      [label]=\"'borrower.tab_name' | fswTranslate\"\n    >\n      <fsw-panel [title]=\"'title' | fswTranslate\">\n        <ng-template fswPanelHeaderSuffix>\n          <button\n            *ngIf=\"!state.isReadonly\"\n            [disabled]=\"borrowerGroup.invalid\"\n            fswButton\n            appearance=\"secondary\"\n            (click)=\"save()\"\n          >\n            {{ 'buttons.save' | fswTranslate }}\n          </button>\n        </ng-template>\n        <section class=\"w-full overflow-auto\">\n          <form [formGroup]=\"borrowerGroup\">\n            <fsw-dynamic-builder [builder]=\"state.borrowerBuilder\">\n              <ng-template fswDynamicBuilderTemplate key=\"empty_list\">\n                <p class=\"w-full text-center text-yellow-500 font-bold p-[16px]\">\n                  {{ 'empty' | fswTranslate }}\n                </p>\n              </ng-template>\n              <ng-template fswDynamicBuilderTemplate key=\"currency\">\n                <span>RM</span>\n              </ng-template>\n            </fsw-dynamic-builder>\n          </form>\n        </section>\n      </fsw-panel>\n    </ng-template>\n    <ng-template\n      fswTabs\n      [key]=\"'related_parties'\"\n      [maxTextWidth]=\"'unset'\"\n      [label]=\"'related_parties.tab_name' | fswTranslate\"\n    >\n      <fsw-panel [title]=\"'title' | fswTranslate\">\n        <ng-template fswPanelHeaderSuffix>\n          <button\n            *ngIf=\"!state.isReadonly\"\n            [disabled]=\"relatedGroup.invalid\"\n            fswButton\n            appearance=\"secondary\"\n            (click)=\"save()\"\n          >\n            {{ 'buttons.save' | fswTranslate }}\n          </button>\n        </ng-template>\n        <section class=\"w-full overflow-auto\">\n          <form [formGroup]=\"relatedGroup\">\n            <fsw-dynamic-builder [builder]=\"state.relatedBuilder\">\n              <ng-template fswDynamicBuilderTemplate key=\"empty_list\">\n                <p class=\"w-full text-center text-yellow-500 font-bold p-[16px]\">\n                  {{ 'empty' | fswTranslate }}\n                </p>\n              </ng-template>\n              <ng-template fswDynamicBuilderTemplate key=\"currency\">\n                <span>RM</span>\n              </ng-template>\n            </fsw-dynamic-builder>\n          </form>\n        </section>\n      </fsw-panel>\n    </ng-template>\n  </fsw-tabs-group>\n  <ng-container *ngIf=\"!state.hiddenComment\">\n    <fsw-comments\n      [category]=\"'FACTSHEET'\"\n      [title]=\"'comment' | fswTranslate : { scope: 'exposure' }\"\n      [module]=\"'EXPOSURE'\"\n      [identifier]=\"'EXPOSURE'\"\n      [entityId]=\"state.entityId?.toString() || null\"\n      [enableSaveButton]=\"true\"\n      [isReadonly]=\"state.isReadonly\"\n      [translateScope]=\"'exposure'\"\n    >\n      <ng-template\n        fswCommentsItem\n        [key]=\"'main_comment'\"\n        [label]=\"'comment' | fswTranslate : { scope: 'exposure' }\"\n      ></ng-template>\n    </fsw-comments>\n  </ng-container>\n</section>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_EXPOSURE_STORE_TOKEN]
                }] }]; }, propDecorators: { productUpi: [{
                type: Input
            }], entityId: [{
                type: Input
            }], entityType: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], hiddenComment: [{
                type: Input
            }] } });

class FSwExposureDirective {
    constructor(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
        this.entityId = null;
        this.entityType = FSWEntityTypes.LOAN;
        this.productUpi = null;
        this.isReadonly = false;
        this.hiddenComment = false;
    }
    ngOnChanges() {
        this._viewContainerRef.clear();
        const ref = this._viewContainerRef.createComponent(ExposureComponent, {
            injector: Injector.create({
                parent: this._viewContainerRef.injector,
                providers: exposureLoadProviders(getCountryCodeFromStorage(), this.entityType),
            }),
        });
        const instance = ref.instance;
        instance.entityId = this.entityId;
        instance.entityType = this.entityType;
        instance.productUpi = this.productUpi;
        instance.isReadonly = this.isReadonly;
        instance.hiddenComment = this.hiddenComment;
        ref.changeDetectorRef.detectChanges();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSwExposureDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSwExposureDirective, selector: "[fswExposure]", inputs: { entityId: "entityId", entityType: "entityType", productUpi: "productUpi", isReadonly: "isReadonly", hiddenComment: "hiddenComment" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSwExposureDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswExposure]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; }, propDecorators: { entityId: [{
                type: Input
            }], entityType: [{
                type: Input
            }], productUpi: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], hiddenComment: [{
                type: Input
            }] } });

class FSWExposureModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWExposureModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWExposureModule, declarations: [FSwExposureDirective, ExposureComponent], imports: [i1$4.FSWTranslateModule, FSWButtonModule,
            NgIf,
            ReactiveFormsModule,
            FSWDateTimePickerModule,
            FSWTabsModule,
            NgTemplateOutlet,
            NgForOf,
            FSWCommentsComponent,
            FSWCommentsItemDirective,
            ApplicationExposureServiceModule,
            ApplicationGuarantorServiceModule,
            ApplicationMemberServiceModule,
            CreditExposureServiceModule,
            FSWProductServiceModule,
            FSWLoanServiceModule,
            MemberServiceModule,
            AsyncPipe,
            FSWPanelModule,
            FSWDynamicBuilderModule], exports: [FSwExposureDirective, ExposureComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWExposureModule, imports: [FSWTranslateModule.forFeature({
                scope: 'exposure',
                defaultKey: CountryCode.MY,
                data: FSW_EXPOSURE_TRANSLATION_LOADER,
            }),
            FSWButtonModule,
            ReactiveFormsModule,
            FSWDateTimePickerModule,
            FSWTabsModule,
            FSWCommentsComponent,
            ApplicationExposureServiceModule,
            ApplicationGuarantorServiceModule,
            ApplicationMemberServiceModule,
            CreditExposureServiceModule,
            FSWProductServiceModule,
            FSWLoanServiceModule,
            MemberServiceModule,
            FSWPanelModule,
            FSWDynamicBuilderModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWExposureModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FSwExposureDirective, ExposureComponent],
                    exports: [FSwExposureDirective, ExposureComponent],
                    imports: [
                        FSWTranslateModule.forFeature({
                            scope: 'exposure',
                            defaultKey: CountryCode.MY,
                            data: FSW_EXPOSURE_TRANSLATION_LOADER,
                        }),
                        FSWButtonModule,
                        NgIf,
                        ReactiveFormsModule,
                        FSWDateTimePickerModule,
                        FSWTabsModule,
                        NgTemplateOutlet,
                        NgForOf,
                        FSWCommentsComponent,
                        FSWCommentsItemDirective,
                        ApplicationExposureServiceModule,
                        ApplicationGuarantorServiceModule,
                        ApplicationMemberServiceModule,
                        CreditExposureServiceModule,
                        FSWProductServiceModule,
                        FSWLoanServiceModule,
                        MemberServiceModule,
                        AsyncPipe,
                        FSWPanelModule,
                        FSWDynamicBuilderModule,
                    ],
                }]
        }] });

var title$k = "Exposure";
var comment$2 = "Factsheet Comments (Past & Current Facilities with FS)";
var columns$7 = {
	product: "Product",
	code: "Code",
	product_limit: "Product Limit",
	outstanding_principal: "Outstanding Principal",
	max_dpd: "Max DPD",
	limit_pending_approval: "Limit Pending Approval",
	status: "Status"
};
var products = {
	term: "Term Products",
	line: "Line Products"
};
var buttons$y = {
	save: "Save Changes",
	refresh: "Refresh"
};
var exposureProductsAll = {
	title: title$k,
	comment: comment$2,
	columns: columns$7,
	products: products,
	buttons: buttons$y
};

var ALL$7 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$y,
    columns: columns$7,
    comment: comment$2,
    default: exposureProductsAll,
    products: products,
    title: title$k
});

const FSW_EXPOSURE_PRODUCTS_ALL_TRANSLATION = ALL$7;

const injectExposureProductsAllEffects = ({ signals, }) => {
    const services = {
        creditExposure: injectCreditExposureService(),
        applicationMemberBIP: injectApplicationMemberBIPService(),
        applicationMember: injectApplicationMemberService(),
        applicationRelationship: injectApplicationRelationshipService(),
        loanService: injectLoanService(),
        alert: inject(FSW_ALERT_SERVICE_TOKEN),
    };
    const internalSignals = {
        tabs: signal([]),
        products: signal([]),
        member: signal(null),
        bips: signal(null),
    };
    const asyncFunctions = {
        loadMemberAsync: (applicationId) => {
            const member = internalSignals.member();
            if (member) {
                return of(member);
            }
            return services.applicationMember.getApplicationMainBorrower(applicationId).pipe(map((member) => member), tap((member) => internalSignals.member.set(member)));
        },
        loadBipsAsync: (applicationId, member) => {
            const bips = internalSignals.bips();
            if (bips) {
                return of(bips);
            }
            return services.applicationMemberBIP
                .getApplicationMemberBIPs(applicationId, member.uuid, {
                expand: true,
                limit: 100,
                page: 1,
            })
                .pipe(map((bips) => bips || []), tap((bips) => internalSignals.bips.set(bips)));
        },
        refreshTabsAsync: (applicationId, member, bips) => {
            return services.creditExposure
                .calculateExposureV2({
                borrower_uuid: member.uuid,
                bips,
            })
                .pipe(switchMap((res) => {
                return services.applicationRelationship
                    .addAsync(applicationId, 'exposure', res.id)
                    .pipe(map(() => res));
            }));
        },
        getTabsAsync: (applicationId) => {
            return services.applicationRelationship.getAsync(applicationId, 'exposure').pipe(switchMap((ids) => {
                if (!ids?.length) {
                    return of(null);
                }
                return services.creditExposure.getExposureV2(ids[0]);
            }));
        },
    };
    const internalFunctions = {
        loadingTabs: () => {
            internalSignals.tabs.set([
                {
                    key: 'borrower',
                    label: 'Borrower',
                    term_products: Array.from({ length: 3 }).map((_, i) => ({
                        product_id: i + 1,
                        loans: Array.from({ length: 3 }).map((_, j) => ({
                            code: 'Loading...',
                            product_limit: 10000,
                            outstanding_principal: 10000,
                            max_dpd: '100',
                            limit_pending_approval: 10000,
                            status: 'Loading...',
                            status_id: j + 1,
                            application_id: 'Loading...',
                            loan_id: j + 1,
                        })),
                    })),
                    line_products: Array.from({ length: 3 }).map((_, i) => ({
                        product_id: i + 1,
                        facilities: Array.from({ length: 3 }).map((_, j) => ({
                            code: 'Loading...',
                            product_limit: 10000,
                            outstanding_principal: 10000,
                            max_dpd: '100',
                            limit_pending_approval: 10000,
                            status: 'Loading...',
                            status_id: j + 1,
                            application_id: 'Loading...',
                            facility_id: j + 1,
                        })),
                    })),
                    isLoading: true,
                },
                ...Array.from({ length: 3 }).map((_, i) => ({
                    key: `bip_${i + 1}`,
                    label: `BIP ${i + 1}`,
                    term_products: [],
                    line_products: [],
                    isLoading: true,
                })),
            ]);
        },
        updateTabs: (bips, { bip_exposures, borrower_exposure }) => {
            const frankensteinBips = bips.map((bip) => FSWFrankensteinModel.transformExpand(bip));
            internalSignals.tabs.set([
                {
                    ...borrower_exposure,
                    label: 'Borrower',
                    key: 'borrower',
                },
                ...(bip_exposures || []).map((item) => ({
                    ...item.exposure,
                    label: frankensteinBips.find((bip) => bip.expand?.idNumber === item.bip)?.expand?.name ||
                        'N/A',
                    key: item.bip,
                })),
            ]);
        },
    };
    const functions = {
        loadTabs: (applicationId, hardRefresh = false) => {
            internalFunctions.loadingTabs();
            asyncFunctions
                .loadMemberAsync(applicationId)
                .pipe(filter((member) => !!member), switchMap((member) => asyncFunctions.loadBipsAsync(applicationId, member).pipe(switchMap((bips) => {
                let obs$ = asyncFunctions.getTabsAsync(applicationId).pipe(switchMap((res) => {
                    if (res) {
                        return of(res);
                    }
                    return asyncFunctions.refreshTabsAsync(applicationId, member, bips);
                }));
                if (hardRefresh) {
                    obs$ = asyncFunctions.refreshTabsAsync(applicationId, member, bips);
                }
                return obs$.pipe(tap((res) => internalFunctions.updateTabs(bips, res)));
            }), catchError((err) => {
                services.alert.error('Error', 'Failed to load exposure', {
                    duration: 3000,
                });
                return throwError(() => err);
            }))))
                .subscribe();
        },
        loadProducts: () => {
            services.loanService
                .getProducts(getCountryCodeFromStorage())
                .pipe(tap((products) => internalSignals.products.set(products)))
                .subscribe();
        },
    };
    return {
        signals: {
            tabs: internalSignals.tabs.asReadonly(),
            products: internalSignals.products.asReadonly(),
        },
        actions: {
            init: () => {
                const applicationId = signals.applicationId();
                if (!applicationId) {
                    return;
                }
                functions.loadProducts();
                functions.loadTabs(applicationId);
            },
            refresh: () => {
                const applicationId = signals.applicationId();
                if (!applicationId) {
                    return;
                }
                functions.loadTabs(applicationId, true);
            },
        },
    };
};

function injectExposureProductsEffects(config) {
    switch (getCountryCodeFromStorage()) {
        default:
            return injectExposureProductsAllEffects(config);
    }
}

function exposureProductsTranslation(scope = 'exposure_products') {
    return [
        ...(FSWTranslateModule.forFeature({
            scope,
            defaultKey: getCountryCodeFromStorage() ?? CountryCode.SG,
            data: {
                [CountryCode.MY]: FSW_EXPOSURE_PRODUCTS_ALL_TRANSLATION,
                [CountryCode.SG]: FSW_EXPOSURE_PRODUCTS_ALL_TRANSLATION,
                [CountryCode.ID]: FSW_EXPOSURE_PRODUCTS_ALL_TRANSLATION,
                [CountryCode.VU]: FSW_EXPOSURE_PRODUCTS_ALL_TRANSLATION,
                [CountryCode.TH]: FSW_EXPOSURE_PRODUCTS_ALL_TRANSLATION,
            },
        }).providers || []),
        fswTranslateScope(scope),
    ];
}

class FSWExposureProductsTableComponent {
    transformToRows(product, isFirst) {
        const proposals = (product.loans ||
            product.facilities ||
            []);
        return [
            {
                ...proposals.reduce((acc, cur) => ({
                    product_limit: Number(acc.product_limit ?? 0) + Number(cur.product_limit ?? 0),
                    outstanding_principal: Number(acc.outstanding_principal ?? 0) + Number(cur.outstanding_principal ?? 0),
                    max_dpd: (Number(acc.max_dpd ?? 0) + Number(isNaN(Number(cur.max_dpd)) ? '0' : cur.max_dpd)).toString(),
                    limit_pending_approval: Number(acc.limit_pending_approval ?? 0) + Number(cur.limit_pending_approval ?? 0),
                }), {
                    product_limit: 0,
                    outstanding_principal: 0,
                    max_dpd: '',
                    limit_pending_approval: 0,
                }),
                code: this.products.find((item) => item.id === product.product_id)?.code || 'N/A',
                isGroup: true,
                isFirst,
            },
            ...proposals,
        ].map((item) => ({
            ...item,
            product_limit: this.toFormatedNumber(item.product_limit),
            outstanding_principal: this.toFormatedNumber(item.outstanding_principal),
            max_dpd: this.toFormatedNumber(item.max_dpd),
            limit_pending_approval: this.toFormatedNumber(item.limit_pending_approval),
        }));
    }
    getRowSpan(products) {
        return products.reduce((acc, cur) => {
            const { loans, facilities } = cur;
            return acc + (loans?.length || 0) + (facilities?.length || 0) + 1;
        }, 0);
    }
    toFormatedNumber(value) {
        if (value == null || isNaN(Number(value))) {
            return '--';
        }
        return new Intl.NumberFormat().format(Number(value));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWExposureProductsTableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWExposureProductsTableComponent, isStandalone: true, selector: "fsw-exposure-products-table", inputs: { data: "data", products: "products" }, providers: [exposureProductsTranslation('exposure_products_table')], ngImport: i0, template: `
    <table class="fsw-table !table-auto w-full fsw-table--bordered">
      <thead>
        <tr>
          <th
            class="align-middle"
            *ngFor="
              let column of [
                'columns.product',
                'columns.code',
                'columns.product_limit',
                'columns.outstanding_principal',
                'columns.max_dpd',
                'columns.limit_pending_approval',
                'columns.status'
              ]
            "
          >
            {{ column | fswTranslate : { scope: 'exposure_products_table' } }}
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="data.term_products?.length">
          <ng-container
            *ngTemplateOutlet="
              itemTemplate;
              context: {
                $implicit: data.term_products,
                label: 'products.term' | fswTranslate : { scope: 'exposure_products_table' },
                classes: '!bg-[antiquewhite]',
                isLoading: data.isLoading
              }
            "
          />
        </ng-container>
        <ng-container *ngIf="data.line_products?.length">
          <ng-container
            *ngTemplateOutlet="
              itemTemplate;
              context: {
                $implicit: data.line_products,
                label: 'products.line' | fswTranslate : { scope: 'exposure_products_table' },
                classes: '!bg-[aliceblue]',
                isLoading: data.isLoading
              }
            "
          />
        </ng-container>
      </tbody>
    </table>
    <ng-template
      #itemTemplate
      let-products
      let-label="label"
      let-classes="classes"
      let-isLoading="isLoading"
    >
      <ng-container *ngFor="let product of products; let i = index">
        <ng-container *ngFor="let row of transformToRows(product, i === 0)">
          <tr>
            <td
              *ngIf="row.isFirst"
              [rowSpan]="getRowSpan(products)"
              class="!font-bold !text-body-default-500 {{ classes }}"
            >
              {{ label }}
            </td>
            <td
              class="align-middle !text-body-default-500"
              [ngClass]="{ '!font-bold !bg-gray-100': row.isGroup }"
            >
              {{ isLoading ? 'Loading...' : row.code ?? '--' }}
            </td>
            <td class="align-middle" [ngClass]="{ '!font-bold !bg-gray-100': row.isGroup }">
              {{ isLoading ? 'Loading...' : row.product_limit ?? '--' }}
            </td>
            <td class="align-middle" [ngClass]="{ '!font-bold !bg-gray-100': row.isGroup }">
              {{ isLoading ? 'Loading...' : row.outstanding_principal ?? '--' }}
            </td>
            <td class="align-middle" [ngClass]="{ '!font-bold !bg-gray-100': row.isGroup }">
              {{ isLoading ? 'Loading...' : row.max_dpd ?? '--' }}
            </td>
            <td class="align-middle" [ngClass]="{ '!font-bold !bg-gray-100': row.isGroup }">
              {{ isLoading ? 'Loading...' : row.limit_pending_approval ?? '--' }}
            </td>
            <td class="align-middle" [ngClass]="{ '!font-bold !bg-gray-100': row.isGroup }">
              {{ isLoading ? 'Loading...' : row.status ?? '--' }}
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWExposureProductsTableComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-exposure-products-table',
                    template: `
    <table class="fsw-table !table-auto w-full fsw-table--bordered">
      <thead>
        <tr>
          <th
            class="align-middle"
            *ngFor="
              let column of [
                'columns.product',
                'columns.code',
                'columns.product_limit',
                'columns.outstanding_principal',
                'columns.max_dpd',
                'columns.limit_pending_approval',
                'columns.status'
              ]
            "
          >
            {{ column | fswTranslate : { scope: 'exposure_products_table' } }}
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="data.term_products?.length">
          <ng-container
            *ngTemplateOutlet="
              itemTemplate;
              context: {
                $implicit: data.term_products,
                label: 'products.term' | fswTranslate : { scope: 'exposure_products_table' },
                classes: '!bg-[antiquewhite]',
                isLoading: data.isLoading
              }
            "
          />
        </ng-container>
        <ng-container *ngIf="data.line_products?.length">
          <ng-container
            *ngTemplateOutlet="
              itemTemplate;
              context: {
                $implicit: data.line_products,
                label: 'products.line' | fswTranslate : { scope: 'exposure_products_table' },
                classes: '!bg-[aliceblue]',
                isLoading: data.isLoading
              }
            "
          />
        </ng-container>
      </tbody>
    </table>
    <ng-template
      #itemTemplate
      let-products
      let-label="label"
      let-classes="classes"
      let-isLoading="isLoading"
    >
      <ng-container *ngFor="let product of products; let i = index">
        <ng-container *ngFor="let row of transformToRows(product, i === 0)">
          <tr>
            <td
              *ngIf="row.isFirst"
              [rowSpan]="getRowSpan(products)"
              class="!font-bold !text-body-default-500 {{ classes }}"
            >
              {{ label }}
            </td>
            <td
              class="align-middle !text-body-default-500"
              [ngClass]="{ '!font-bold !bg-gray-100': row.isGroup }"
            >
              {{ isLoading ? 'Loading...' : row.code ?? '--' }}
            </td>
            <td class="align-middle" [ngClass]="{ '!font-bold !bg-gray-100': row.isGroup }">
              {{ isLoading ? 'Loading...' : row.product_limit ?? '--' }}
            </td>
            <td class="align-middle" [ngClass]="{ '!font-bold !bg-gray-100': row.isGroup }">
              {{ isLoading ? 'Loading...' : row.outstanding_principal ?? '--' }}
            </td>
            <td class="align-middle" [ngClass]="{ '!font-bold !bg-gray-100': row.isGroup }">
              {{ isLoading ? 'Loading...' : row.max_dpd ?? '--' }}
            </td>
            <td class="align-middle" [ngClass]="{ '!font-bold !bg-gray-100': row.isGroup }">
              {{ isLoading ? 'Loading...' : row.limit_pending_approval ?? '--' }}
            </td>
            <td class="align-middle" [ngClass]="{ '!font-bold !bg-gray-100': row.isGroup }">
              {{ isLoading ? 'Loading...' : row.status ?? '--' }}
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </ng-template>
  `,
                    standalone: true,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    imports: [FSWTranslateModule, NgForOf, NgIf, NgTemplateOutlet, NgClass],
                    providers: [exposureProductsTranslation('exposure_products_table')],
                    encapsulation: ViewEncapsulation.None,
                }]
        }], propDecorators: { data: [{
                type: Input,
                args: [{ required: true }]
            }], products: [{
                type: Input,
                args: [{ required: true }]
            }] } });

class FSWExposureProductsComponent {
    constructor() {
        this.isReadonly = false;
        this.hiddenComment = false;
        this.signals = {
            applicationId: signal(null),
        };
        this.effects = injectExposureProductsEffects({
            signals: {
                applicationId: this.signals.applicationId,
            },
        });
    }
    set applicationId(value) {
        this.signals.applicationId.set(value);
    }
    ngOnInit() {
        this.effects.actions.init();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWExposureProductsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWExposureProductsComponent, isStandalone: true, selector: "fsw-exposure-products", inputs: { applicationId: "applicationId", isReadonly: "isReadonly", hiddenComment: "hiddenComment" }, providers: [
            exposureProductsTranslation(),
            provideUtilsService(),
            provideApplicationMemberBIPService(),
            provideApplicationMemberService(),
            provideCreditExposureService(),
            provideLoanService(),
            provideApplicationRelationshipService(),
        ], ngImport: i0, template: `
    <fsw-panel [title]="'title' | fswTranslate : { scope: 'exposure_products' }">
      <ng-template fswPanelHeaderSuffix>
        <button fswButton (click)="effects.actions.refresh()" *ngIf="!isReadonly">
          {{ 'buttons.refresh' | fswTranslate : { scope: 'exposure_products' } }}
        </button>
      </ng-template>
      <section class="flex flex-col gap-[16px]">
        <fsw-tabs-group [customRowGap]="'24px'" [customColumnGap]="'24px'">
          <ng-container *ngFor="let tab of effects.signals.tabs()">
            <ng-template fswTabs [key]="tab.key" [maxTextWidth]="'unset'" [label]="tab.label">
              <fsw-exposure-products-table [data]="tab" [products]="effects.signals.products()" />
            </ng-template>
          </ng-container>
        </fsw-tabs-group>
        <ng-container *ngIf="!hiddenComment">
          <fsw-comments
            [category]="'FACTSHEET'"
            [title]="'comment' | fswTranslate : { scope: 'exposure_products' }"
            [module]="'EXPOSURE'"
            [identifier]="'EXPOSURE'"
            [entityId]="signals.applicationId()"
            [enableSaveButton]="true"
            [isReadonly]="isReadonly"
            [translateScope]="'exposure_products'"
          >
            <ng-template
              fswCommentsItem
              [key]="'main_comment'"
              [label]="'comment' | fswTranslate : { scope: 'exposure_products' }"
            ></ng-template>
          </fsw-comments>
        </ng-container>
      </section>
    </fsw-panel>
  `, isInline: true, dependencies: [{ kind: "ngmodule", type: FSWAlertModule }, { kind: "ngmodule", type: FSWTabsModule }, { kind: "component", type: i1$4.FSWTabsGroupComponent, selector: "fsw-tabs-group" }, { kind: "directive", type: i1$4.FSWTabsDirective, selector: "ng-template[fswTabs]" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: FSWExposureProductsTableComponent, selector: "fsw-exposure-products-table", inputs: ["data", "products"] }, { kind: "component", type: FSWCommentsComponent, selector: "fsw-comments", inputs: ["title", "entityId", "identifier", "module", "category", "isReadonly", "rows", "customClasses", "enableSaveButton", "translateScope"] }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: FSWCommentsItemDirective, selector: "ng-template[fswCommentsItem]", inputs: ["label", "key"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWExposureProductsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-exposure-products',
                    template: `
    <fsw-panel [title]="'title' | fswTranslate : { scope: 'exposure_products' }">
      <ng-template fswPanelHeaderSuffix>
        <button fswButton (click)="effects.actions.refresh()" *ngIf="!isReadonly">
          {{ 'buttons.refresh' | fswTranslate : { scope: 'exposure_products' } }}
        </button>
      </ng-template>
      <section class="flex flex-col gap-[16px]">
        <fsw-tabs-group [customRowGap]="'24px'" [customColumnGap]="'24px'">
          <ng-container *ngFor="let tab of effects.signals.tabs()">
            <ng-template fswTabs [key]="tab.key" [maxTextWidth]="'unset'" [label]="tab.label">
              <fsw-exposure-products-table [data]="tab" [products]="effects.signals.products()" />
            </ng-template>
          </ng-container>
        </fsw-tabs-group>
        <ng-container *ngIf="!hiddenComment">
          <fsw-comments
            [category]="'FACTSHEET'"
            [title]="'comment' | fswTranslate : { scope: 'exposure_products' }"
            [module]="'EXPOSURE'"
            [identifier]="'EXPOSURE'"
            [entityId]="signals.applicationId()"
            [enableSaveButton]="true"
            [isReadonly]="isReadonly"
            [translateScope]="'exposure_products'"
          >
            <ng-template
              fswCommentsItem
              [key]="'main_comment'"
              [label]="'comment' | fswTranslate : { scope: 'exposure_products' }"
            ></ng-template>
          </fsw-comments>
        </ng-container>
      </section>
    </fsw-panel>
  `,
                    standalone: true,
                    imports: [
                        FSWAlertModule,
                        FSWTabsModule,
                        NgIf,
                        NgForOf,
                        FSWExposureProductsTableComponent,
                        AsyncPipe,
                        FSWCommentsComponent,
                        FSWTranslateModule,
                        FSWPanelModule,
                        FSWButtonModule,
                        FSWCommentsItemDirective,
                    ],
                    providers: [
                        exposureProductsTranslation(),
                        provideUtilsService(),
                        provideApplicationMemberBIPService(),
                        provideApplicationMemberService(),
                        provideCreditExposureService(),
                        provideLoanService(),
                        provideApplicationRelationshipService(),
                    ],
                }]
        }], propDecorators: { applicationId: [{
                type: Input,
                args: [{ required: true }]
            }], isReadonly: [{
                type: Input
            }], hiddenComment: [{
                type: Input
            }] } });

var LoanListFields;
(function (LoanListFields) {
    LoanListFields["ID"] = "id";
    LoanListFields["LOAN_CODE"] = "loan_code";
    LoanListFields["BORROWER_NAME"] = "borrower_name";
    LoanListFields["BORROWER_EMAIL"] = "user_name";
    LoanListFields["COMPANY_NAME"] = "company_name";
    LoanListFields["CREATED_AT"] = "created_at";
    LoanListFields["STATUS"] = "status";
})(LoanListFields || (LoanListFields = {}));

const PRODUCT_SERVICE_TOKEN = new InjectionToken('PRODUCT_SERVICE_TOKEN');

class ProductService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this.kongUrl = this._utilsService.getKongUrl();
    }
    getProducts(params) {
        return this._httpClient
            .get(`${this.kongUrl}/ln/v2/products`, {
            params: { ...params },
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => data));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class ProductServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ProductServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductServiceModule, providers: [
            {
                provide: PRODUCT_SERVICE_TOKEN,
                useClass: ProductService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: PRODUCT_SERVICE_TOKEN,
                            useClass: ProductService,
                        },
                    ],
                }]
        }] });

const LOAN_PRODUCTS_GROUPBY_COUNTRY_PROD = [
    {
        countryId: CountryCode.MY,
        label: 'Business Term Financing (Bizfund)',
        value: 189,
        productUpi: 'MY-BTB',
    },
    {
        countryId: CountryCode.MY,
        label: 'Business Term Financing',
        value: 6,
        productUpi: 'MY-BT',
    },
    {
        countryId: CountryCode.MY,
        label: 'BOLT-MY',
        value: 25,
        productUpi: 'MY-BMY',
    },
    {
        countryId: CountryCode.MY,
        label: 'Bolt (Islamic Financing)',
        value: 195,
        productUpi: 'MY-IBMY',
    },
    {
        countryId: CountryCode.MY,
        label: 'Business Term Financing (Islamic Financing)',
        value: 203,
        productUpi: 'MY-IBT',
    },
    {
        countryId: CountryCode.MY,
        label: 'Business Term Financing (CGC)',
        value: 175,
        productUpi: 'MY-BTC',
    },
];
const LOAN_PRODUCTS_GROUPBY_COUNTRY_OTHER = [
    {
        countryId: CountryCode.MY,
        label: 'Business Term Financing (Bizfund)',
        value: 176,
        productUpi: 'MY-BTB',
    },
    {
        countryId: CountryCode.MY,
        label: 'Business Term Financing',
        value: 6,
        productUpi: 'MY-BT',
    },
    {
        countryId: CountryCode.MY,
        label: 'BOLT-MY',
        value: 25,
        productUpi: 'MY-BMY',
    },
    {
        countryId: CountryCode.MY,
        label: 'Bolt (Islamic Financing)',
        value: 210,
        productUpi: 'MY-IBMY',
    },
    {
        countryId: CountryCode.MY,
        label: 'Business Term Financing (Islamic Financing)',
        value: 228,
        productUpi: 'MY-IBT',
    },
    {
        countryId: CountryCode.MY,
        label: 'Business Term Financing (CGC)',
        value: 175,
        productUpi: 'MY-BTC',
    },
];

const LOAN_SERVICE_TOKEN = new InjectionToken('LOAN_SERVICE_TOKEN');

class LoanService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this.kongUrl = this._utilsService.getKongUrl();
    }
    getLoans(params) {
        return this._httpClient.get(`${this.kongUrl}/ln/v2/loans`, {
            params: { ...params },
            headers: setRequestOptions(),
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoanService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoanService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoanService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class LoanServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoanServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: LoanServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoanServiceModule, providers: [
            {
                provide: LOAN_SERVICE_TOKEN,
                useClass: LoanService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoanServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: LOAN_SERVICE_TOKEN,
                            useClass: LoanService,
                        },
                    ],
                }]
        }] });

let LoanListStore = class LoanListStore extends ComponentStore {
    constructor(_loanService, _productService, _stateOverride = {}) {
        super({
            countryId: null,
            productIds: '',
            loans: [],
            loanParams: null,
            products: [],
            productParams: null,
            keySearch: '',
            ..._stateOverride,
        });
        this._loanService = _loanService;
        this._productService = _productService;
        this._stateOverride = _stateOverride;
        // effect called from loan-list-default.store.ts
        this.getLoans = this.effect(pipe(
        // switchMap(() => this._getLoansAsync()),
        catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
    }
    // setters
    // setter for productIds
    setProductIds(productIds) {
        const updater = this.updater((state, productIds) => ({
            ...state,
            productIds,
        }));
        updater(productIds);
    }
    setKeySearch(value) {
        const updater = this.updater((state, keySearch) => ({
            ...state,
            keySearch,
        }));
        updater(value);
    }
    // setter for loans
    setLoans(loans) {
        const updater = this.updater((state, loans) => ({
            ...state,
            loans,
        }));
        updater(loans);
    }
};
LoanListStore = __decorate([
    __param(0, Inject(LOAN_SERVICE_TOKEN)),
    __param(1, Inject(PRODUCT_SERVICE_TOKEN)),
    __metadata("design:paramtypes", [Object, Object, Object])
], LoanListStore);

const LOAN_LIST_GRID_CONFIG_TOKEN = new InjectionToken('LOAN_LIST_GRID_CONFIG_TOKEN');

const LOAN_LIST_STORE_TOKEN = new InjectionToken('LOAN_LIST_STORE_TOKEN');

const loanListDefaultGridConfig = {
    setup(defaultGridOptions, translate, rowData) {
        return {
            ...defaultGridOptions,
            rowData,
            columnDefs: [
                {
                    field: LoanListFields.ID,
                    headerName: translate[LoanListFields.ID],
                    width: 100,
                },
                {
                    field: LoanListFields.LOAN_CODE,
                    headerName: translate[LoanListFields.LOAN_CODE],
                    width: 180,
                },
                {
                    field: LoanListFields.BORROWER_NAME,
                    headerName: translate[LoanListFields.BORROWER_NAME],
                    width: 180,
                },
                {
                    field: LoanListFields.BORROWER_EMAIL,
                    headerName: translate[LoanListFields.BORROWER_EMAIL],
                    width: 320,
                },
                {
                    field: LoanListFields.COMPANY_NAME,
                    headerName: translate[LoanListFields.COMPANY_NAME],
                    width: 180,
                },
                {
                    field: LoanListFields.CREATED_AT,
                    headerName: translate[LoanListFields.CREATED_AT],
                    width: 180,
                    cellRenderer: (params) => {
                        const data = params.data;
                        return new DatePipe('en-US').transform(data.created_at, 'MMMM d, y, h:mm:ss a z');
                    },
                },
                {
                    field: LoanListFields.STATUS,
                    headerName: translate[LoanListFields.STATUS],
                    width: 180,
                },
            ],
        };
    },
};

let LoanListDefaultComponentStore = class LoanListDefaultComponentStore extends LoanListStore {
    constructor(_loanService, _productService) {
        super(_loanService, _productService, {
            countryId: FSWCountryCode.MY,
            productParams: {
                page: 1,
                size: 100,
                country_code: FSWCountryCode.MY,
            },
        });
        this._loanService = _loanService;
        this._productService = _productService;
    }
};
LoanListDefaultComponentStore = __decorate([
    __param(0, Inject(LOAN_SERVICE_TOKEN)),
    __param(1, Inject(PRODUCT_SERVICE_TOKEN)),
    __metadata("design:paramtypes", [Object, Object])
], LoanListDefaultComponentStore);

const loanListDefaultProviders = [
    {
        provide: LOAN_LIST_GRID_CONFIG_TOKEN,
        useValue: loanListDefaultGridConfig,
    },
    {
        provide: LOAN_LIST_STORE_TOKEN,
        useClass: LoanListDefaultComponentStore,
        deps: [LOAN_SERVICE_TOKEN, PRODUCT_SERVICE_TOKEN],
    },
];

var loanListDefault_provider = /*#__PURE__*/Object.freeze({
    __proto__: null,
    loanListDefaultProviders: loanListDefaultProviders
});

class LoanListControlComponent {
    set products(products) {
        this.products$.next(products);
    }
    constructor(_scope, _utilsService, _translateService, fb) {
        this._scope = _scope;
        this._utilsService = _utilsService;
        this._translateService = _translateService;
        this.fb = fb;
        this.productSelect = new EventEmitter();
        this.keySearchChange = new EventEmitter();
        this.products$ = new BehaviorSubject([]);
        this.state$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'loan_control'),
            this.products$,
        ]).pipe(map(([translate, products]) => ({ translate, products })));
        this._destroySubject = new Subject();
        this.options = [];
        this.multiSelectOptions = {
            countryId: 'countryId',
            isMultiSelect: true,
            isCloseOnSelect: true,
        };
        this.taskFG = this.fb.group({
            productControl: this.fb.control(null),
            filterControl: this.fb.control('Application Name'),
            searchControl: this.fb.control(''),
        });
    }
    ngOnInit() {
        this.options = this._utilsService.isEnvProduction()
            ? LOAN_PRODUCTS_GROUPBY_COUNTRY_PROD
            : LOAN_PRODUCTS_GROUPBY_COUNTRY_OTHER;
        combineLatest([
            this.taskFG.controls.productControl.valueChanges.pipe(tap((val) => this.productSelect.emit({
                productIds: val.join(),
            }))),
            this.taskFG.controls.searchControl.valueChanges.pipe(debounceTime(500), tap((val) => this.keySearchChange.emit(val))),
        ])
            .pipe(takeUntil(this._destroySubject))
            .subscribe();
    }
    ngOnDestroy() {
        this._destroySubject.next(0);
        this._destroySubject.complete();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoanListControlComponent, deps: [{ token: TRANSLOCO_SCOPE }, { token: UTILS_SERVICE_TOKEN }, { token: TranslocoFeatureHttpLoader }, { token: i2.FormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: LoanListControlComponent, selector: "fsw-loan-list-control", inputs: { products: "products" }, outputs: { productSelect: "productSelect", keySearchChange: "keySearchChange" }, ngImport: i0, template: "<div *ngIf=\"state$ | async as state\" class=\"product-select-container\" [formGroup]=\"taskFG\">\n  <section class=\"flex w-[500px]\">\n    <fsw-field>\n      <fsw-select\n        [maxHeight]=\"'200px'\"\n        [placeHolder]=\"state.translate.product\"\n        [isMultiple]=\"true\"\n        formControlName=\"productControl\"\n      >\n        <ng-container *ngFor=\"let type of options\">\n          <ng-template\n            fswSelectItem\n            let-selected\n            [text]=\"type.label\"\n            [value]=\"type.value\"\n            [icon]=\"'checkbox'\"\n          ></ng-template>\n        </ng-container>\n      </fsw-select>\n    </fsw-field>\n  </section>\n\n  <ng-container *ngIf=\"taskFG?.controls?.productControl?.valueChanges | async as productControl\">\n    <div class=\"form-control\" *ngIf=\"productControl.length\">\n      <input\n        type=\"text\"\n        class=\"form-input\"\n        autocomplete=\"off\"\n        name=\"keyword\"\n        formControlName=\"searchControl\"\n        [placeholder]=\"state.translate.search\"\n      />\n    </div>\n  </ng-container>\n</div>\n", styles: [".product-select-container{width:100%;margin-bottom:40px;display:flex;justify-content:space-between}.product-select-container .form-control{width:450px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoanListControlComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-loan-list-control', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<div *ngIf=\"state$ | async as state\" class=\"product-select-container\" [formGroup]=\"taskFG\">\n  <section class=\"flex w-[500px]\">\n    <fsw-field>\n      <fsw-select\n        [maxHeight]=\"'200px'\"\n        [placeHolder]=\"state.translate.product\"\n        [isMultiple]=\"true\"\n        formControlName=\"productControl\"\n      >\n        <ng-container *ngFor=\"let type of options\">\n          <ng-template\n            fswSelectItem\n            let-selected\n            [text]=\"type.label\"\n            [value]=\"type.value\"\n            [icon]=\"'checkbox'\"\n          ></ng-template>\n        </ng-container>\n      </fsw-select>\n    </fsw-field>\n  </section>\n\n  <ng-container *ngIf=\"taskFG?.controls?.productControl?.valueChanges | async as productControl\">\n    <div class=\"form-control\" *ngIf=\"productControl.length\">\n      <input\n        type=\"text\"\n        class=\"form-input\"\n        autocomplete=\"off\"\n        name=\"keyword\"\n        formControlName=\"searchControl\"\n        [placeholder]=\"state.translate.search\"\n      />\n    </div>\n  </ng-container>\n</div>\n", styles: [".product-select-container{width:100%;margin-bottom:40px;display:flex;justify-content:space-between}.product-select-container .form-control{width:450px}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: i2.FormBuilder }]; }, propDecorators: { productSelect: [{
                type: Output
            }], keySearchChange: [{
                type: Output
            }], products: [{
                type: Input
            }] } });

class LoanListControlModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoanListControlModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: LoanListControlModule, declarations: [LoanListControlComponent], imports: [CommonModule,
            LetDirective,
            ReactiveFormsModule,
            FormWidgetModule,
            FSWFieldModule,
            FSWSelectModule], exports: [LoanListControlComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoanListControlModule, imports: [CommonModule,
            ReactiveFormsModule,
            FormWidgetModule,
            FSWFieldModule,
            FSWSelectModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoanListControlModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        LetDirective,
                        ReactiveFormsModule,
                        FormWidgetModule,
                        FSWFieldModule,
                        FSWSelectModule,
                    ],
                    declarations: [LoanListControlComponent],
                    exports: [LoanListControlComponent],
                }]
        }] });

class LoanListGridComponent {
    set productsIds(value) {
        if (value)
            this._onProductsChangeSubject.next(value);
    }
    set keySearch(value) {
        this._onKeySearchChangeSubject.next(value || '');
    }
    constructor(_translateService, _scope, _loanService, gridConfig) {
        this._translateService = _translateService;
        this._scope = _scope;
        this._loanService = _loanService;
        this.gridConfig = gridConfig;
        this.action = new EventEmitter();
        this._loanParams = {
            page: 1,
            size: 10,
            search: '',
            order_by: 'id,DESC',
            product_ids: '',
            includes: 'members,products',
            excluded_fields: 'groups,stages,statuses,purposes,disbursals,installments',
            country_code: FSWCountryCode.MY,
        };
        this._onProductsChangeSubject = new BehaviorSubject('');
        this._onKeySearchChangeSubject = new BehaviorSubject('');
        this._productIdsCache = '';
        this._keySearchCache = '';
        this._getRowSubject = new Subject();
        this._destroySubject = new Subject();
        this.gridOptions = {
            rowSelection: 'multiple',
            headerHeight: 36,
            rowHeight: 36,
            pagination: true,
            paginationPageSize: 10,
            cacheBlockSize: 10,
            rowModelType: 'serverSide',
            serverSideStoreType: 'partial',
            overlayNoRowsTemplate: `
			<div>
				<div style="color: #757575; padding-top: 40px;">Please select a product to view Loans</div>
			</div>
		`,
            getRowId: (params) => params.data.id,
            onGridReady: (event) => {
                event.api.setGridOption('serverSideDatasource', {
                    getRows: (params) => this._getRowSubject.next(params),
                });
            },
        };
        this.gridOptions$ = this._translateService
            .selectFeatureTranslate(this._scope, 'loan_grid_columns')
            .pipe(map((translate) => this.setupGridOptions(translate)));
    }
    ngOnInit() {
        combineLatest([
            this._onProductsChangeSubject.asObservable(),
            this._onKeySearchChangeSubject.asObservable(),
            this._getRowSubject.asObservable(),
        ])
            .pipe(takeUntil(this._destroySubject), switchMap(([product_ids, keySearch, serverSideParams]) => {
            if (this._productIdsCache !== product_ids || this._keySearchCache !== keySearch) {
                serverSideParams.api.refreshServerSide({ route: [], purge: true });
                serverSideParams.api.paginationGoToFirstPage();
            }
            this._productIdsCache = product_ids;
            this._keySearchCache = keySearch;
            return this._loanService
                .getLoans({
                ...this._loanParams,
                product_ids,
                page: serverSideParams.request.endRow ? serverSideParams.request.endRow / 10 : 0,
                search: keySearch,
            })
                .pipe(takeUntil(this._destroySubject), map((res) => {
                return [res, serverSideParams];
            }));
        }))
            .subscribe(([res, serverSideParams]) => {
            const lbLastRowOnPageEl = document.querySelector(`[ref="lbLastRowOnPage"]`);
            const timeout = setTimeout(() => {
                if (lbLastRowOnPageEl) {
                    lbLastRowOnPageEl.innerHTML = serverSideParams.request.endRow
                        ? serverSideParams.request.endRow.toString()
                        : serverSideParams.api.paginationGetPageSize().toString();
                }
                clearTimeout(timeout);
            }, 300);
            serverSideParams.success({
                rowData: res.data || [],
                rowCount: res?.data?.length < 10 ? undefined : res?.total || 0,
            });
            if (!res.data.length) {
                serverSideParams.api.showNoRowsOverlay();
            }
            else {
                serverSideParams.api.hideOverlay();
            }
        }, (err) => console.error(err));
    }
    ngOnDestroy() {
        this._destroySubject.next(0);
        this._destroySubject.complete();
    }
    setupGridOptions(translate) {
        return this.gridConfig.setup(this.gridOptions, translate, []);
    }
    rowClicked({ data }) {
        this.action.emit({ res: data });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoanListGridComponent, deps: [{ token: TranslocoFeatureHttpLoader }, { token: TRANSLOCO_SCOPE }, { token: LOAN_SERVICE_TOKEN }, { token: LOAN_LIST_GRID_CONFIG_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: LoanListGridComponent, selector: "fsw-loan-list-grid", inputs: { productsIds: "productsIds", keySearch: "keySearch" }, outputs: { action: "action" }, ngImport: i0, template: `
    <fsw-grid
      [gridOptions]="(gridOptions$ | async) || {}"
      (rowClicked)="rowClicked($event)"
    ></fsw-grid>
  `, isInline: true, dependencies: [{ kind: "component", type: FSWGridComponent, selector: "fsw-grid", inputs: ["gridOptions", "actionClickedCheck", "rowData", "gridContainerHeight"], outputs: ["rowClicked"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoanListGridComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-loan-list-grid',
                    template: `
    <fsw-grid
      [gridOptions]="(gridOptions$ | async) || {}"
      (rowClicked)="rowClicked($event)"
    ></fsw-grid>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: TranslocoFeatureHttpLoader }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [LOAN_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [LOAN_LIST_GRID_CONFIG_TOKEN]
                }] }]; }, propDecorators: { action: [{
                type: Output
            }], productsIds: [{
                type: Input
            }], keySearch: [{
                type: Input
            }] } });

class LoanListGridModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoanListGridModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: LoanListGridModule, declarations: [LoanListGridComponent], imports: [CommonModule, FSWGridModule, TranslocoModule, LetDirective], exports: [LoanListGridComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoanListGridModule, imports: [CommonModule, FSWGridModule, TranslocoModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoanListGridModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FSWGridModule, TranslocoModule, LetDirective],
                    declarations: [LoanListGridComponent],
                    exports: [LoanListGridComponent],
                }]
        }] });

class LoanListComponent {
    constructor(_store) {
        this._store = _store;
        this._emitLoanSubject = new Subject();
        this.getSelectedLoan$ = this._emitLoanSubject.asObservable();
        this.productIds$ = this._store.state$.pipe(map((s) => s.productIds));
        this.keySearch$ = this._store.state$.pipe(map((s) => s.keySearch));
    }
    onSelect({ productIds }) {
        this._store.setProductIds(productIds);
    }
    onSearch(value) {
        this._store.setKeySearch(value);
    }
    actionLoan(loan) {
        this._emitLoanSubject.next(loan);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoanListComponent, deps: [{ token: LOAN_LIST_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: LoanListComponent, selector: "fsw-loan-list", ngImport: i0, template: `
    <ng-container>
      <fsw-loan-list-control
        (productSelect)="onSelect($event)"
        (keySearchChange)="onSearch($event)"
      ></fsw-loan-list-control>
      <fsw-loan-list-grid
        [productsIds]="(productIds$ | async) || '0'"
        [keySearch]="(keySearch$ | async) || ''"
        (action)="actionLoan($event.res)"
      ></fsw-loan-list-grid>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "component", type: LoanListControlComponent, selector: "fsw-loan-list-control", inputs: ["products"], outputs: ["productSelect", "keySearchChange"] }, { kind: "component", type: LoanListGridComponent, selector: "fsw-loan-list-grid", inputs: ["productsIds", "keySearch"], outputs: ["action"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoanListComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-loan-list',
                    template: `
    <ng-container>
      <fsw-loan-list-control
        (productSelect)="onSelect($event)"
        (keySearchChange)="onSearch($event)"
      ></fsw-loan-list-control>
      <fsw-loan-list-grid
        [productsIds]="(productIds$ | async) || '0'"
        [keySearch]="(keySearch$ | async) || ''"
        (action)="actionLoan($event.res)"
      ></fsw-loan-list-grid>
    </ng-container>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LOAN_LIST_STORE_TOKEN]
                }] }]; } });

var titles$6 = {
	main: "Loan"
};
var loan_control$1 = {
	product: "Select Product",
	search: "Search by Loan Code, Borrower Name, Company Name"
};
var loan_grid_columns$1 = {
	id: "Loan Id",
	loan_code: "Loan Code",
	borrower_name: "Borrower Name",
	user_name: "Borrower Email",
	company_name: "Company Name",
	created_at: "Created At"
};
var loan_grid_empty$1 = {
	message: "No loans yet",
	add: "Add new Loans"
};
var _default$1 = {
	titles: titles$6,
	loan_control: loan_control$1,
	loan_grid_columns: loan_grid_columns$1,
	loan_grid_empty: loan_grid_empty$1
};

var de = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: _default$1,
    loan_control: loan_control$1,
    loan_grid_columns: loan_grid_columns$1,
    loan_grid_empty: loan_grid_empty$1,
    titles: titles$6
});

var titles$5 = {
	main: "Loan"
};
var loan_control = {
	product: "Select Product",
	search: "Search by Loan Code, Borrower Name, Company Name"
};
var loan_grid_columns = {
	id: "Loan Id",
	loan_code: "Loan Code",
	borrower_name: "Borrower Name",
	user_name: "Borrower Email",
	company_name: "Company Name",
	created_at: "Created At"
};
var loan_grid_empty = {
	message: "No loans yet",
	add: "Add new Loans"
};
var my$d = {
	titles: titles$5,
	loan_control: loan_control,
	loan_grid_columns: loan_grid_columns,
	loan_grid_empty: loan_grid_empty
};

var my$e = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: my$d,
    loan_control: loan_control,
    loan_grid_columns: loan_grid_columns,
    loan_grid_empty: loan_grid_empty,
    titles: titles$5
});

const loanListTranslateLoader = {
    default: () => Promise.resolve(de),
    my: () => Promise.resolve(my$e),
};

class LoanListDirective {
    constructor(_injector, _viewContainerRef, _resolver) {
        this._injector = _injector;
        this._viewContainerRef = _viewContainerRef;
        this._resolver = _resolver;
        this.loanSelect = new EventEmitter();
        this._destroySubject = new Subject();
        this._internationalMapping = {
            [FSWCountryCode.MY]: Promise.resolve().then(function () { return loanListDefault_provider; }).then((m) => m.loanListDefaultProviders),
        };
        this._default = Promise.resolve().then(function () { return loanListDefault_provider; }).then((m) => m.loanListDefaultProviders);
    }
    ngOnInit() {
        const mapAsync = this._internationalMapping[this.countryId] || this._default;
        from(mapAsync)
            .pipe(tap((providers) => {
            const factoryResolver = this._resolver.resolveComponentFactory(LoanListComponent);
            const injector = Injector.create({
                parent: this._injector,
                providers: [
                    ...providers,
                    {
                        provide: TRANSLOCO_SCOPE,
                        useValue: {
                            scope: 'loan-list',
                            loader: loanListTranslateLoader,
                        },
                    },
                    {
                        provide: TRANSLOCO_LANG,
                        useValue: this.countryId?.toLowerCase() || 'default',
                    },
                    {
                        provide: TranslocoFeatureHttpLoader,
                        useClass: TranslocoFeatureHttpLoader,
                    },
                ],
            });
            const ref = this._viewContainerRef.createComponent(factoryResolver, 0, injector);
            ref.instance.getSelectedLoan$.pipe(takeUntil(this._destroySubject)).subscribe((loan) => {
                return this.loanSelect.emit(loan);
            });
        }))
            .subscribe();
    }
    ngOnDestroy() {
        this._destroySubject.next(0);
        this._destroySubject.complete();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoanListDirective, deps: [{ token: i0.Injector }, { token: i0.ViewContainerRef }, { token: i0.ComponentFactoryResolver }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: LoanListDirective, selector: "[fswLoanList]", inputs: { countryId: "countryId" }, outputs: { loanSelect: "loanSelect" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoanListDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswLoanList]',
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }, { type: i0.ViewContainerRef }, { type: i0.ComponentFactoryResolver }]; }, propDecorators: { loanSelect: [{
                type: Output
            }], countryId: [{
                type: Input
            }] } });

class FSWLoanListModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWLoanListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWLoanListModule, declarations: [LoanListDirective, LoanListComponent], imports: [CommonModule,
            FSWGridModule,
            LetDirective,
            FSWModalModule,
            ProductServiceModule,
            LoanServiceModule,
            LoanListControlModule,
            LoanListGridModule,
            UtilsServiceModule], exports: [LoanListDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWLoanListModule, imports: [CommonModule,
            FSWGridModule,
            FSWModalModule,
            ProductServiceModule,
            LoanServiceModule,
            LoanListControlModule,
            LoanListGridModule,
            UtilsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWLoanListModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FSWGridModule,
                        LetDirective,
                        FSWModalModule,
                        ProductServiceModule,
                        LoanServiceModule,
                        LoanListControlModule,
                        LoanListGridModule,
                        UtilsServiceModule,
                    ],
                    declarations: [LoanListDirective, LoanListComponent],
                    exports: [LoanListDirective],
                }]
        }] });

var FormKeys$1;
(function (FormKeys) {
    FormKeys["RECOURSE_TYPE"] = "recourse_type";
    // individual
    FormKeys["DESIGNATION"] = "designation";
    FormKeys["MEMBER_ENTITY_TYPE_ID"] = "member_entity_type_id";
    FormKeys["BIRTH_DATE"] = "birth_date";
    FormKeys["FULL_NAME"] = "fullname";
    FormKeys["BIRTH_PLACE"] = "birth_place";
    FormKeys["USERNAME"] = "username";
    FormKeys["ADDRESS_1"] = "address_1";
    FormKeys["GENDER_ID"] = "gender_id";
    FormKeys["ADDRESS_2"] = "address_2";
    FormKeys["MOBILE_PHONE_NUMBER"] = "mobile_phone_number";
    FormKeys["AREA"] = "area";
    FormKeys["IC_TYPE_ID"] = "ic_type_id";
    FormKeys["DISTRICT"] = "district";
    FormKeys["IC_NUMBER"] = "ic_number";
    FormKeys["STATE_ID"] = "state_id";
    FormKeys["TAX_CARD_NUMBER"] = "tax_card_number";
    FormKeys["ZIP_CODE"] = "zip_code";
    FormKeys["MARITAL_STATUS_ID"] = "marital_status_id";
    FormKeys["COUNTRY_CODE"] = "country_code";
    // spouse
    FormKeys["SPOUSE_FULLNAME"] = "spouse_fullname";
    FormKeys["SPOUSE_BIRTH_PLACE"] = "spouse_birth_place";
    FormKeys["SPOUSE_ID_CARD_TYPE"] = "spouse_id_card_type";
    FormKeys["SPOUSE_MOBILE_PHONE_NUMBER"] = "spouse_mobile_phone_number";
    FormKeys["SPOUSE_IC_NUMBER"] = "spouse_ic_number";
    FormKeys["SPOUSE_BIRTH_DATE"] = "spouse_birth_date";
    // company
    FormKeys["OWNERSHIP"] = "ownership";
    FormKeys["NIB"] = "nib";
    FormKeys["COMPANY_NAME"] = "company_name";
    FormKeys["SKDP"] = "skdp";
    FormKeys["COMPANY_ENTITY_TYPE_ID"] = "company_entity_type_id";
    FormKeys["TDP"] = "tdp";
    FormKeys["ADDRESS_TYPE"] = "address_type";
    FormKeys["COMPANY_INDUSTRY_ID"] = "company_industry_id";
    FormKeys["COMPANY_ADDRESS_1"] = "company_address_1";
    FormKeys["COMPANY_PHONE_NUMBER"] = "company_phone_number";
    FormKeys["COMPANY_ADDRESS_2"] = "company_address_2";
    FormKeys["COMPANY_REGISTRATION_NUMBER"] = "company_registration_number";
    FormKeys["COMPANY_AREA"] = "company_area";
    FormKeys["COMPANY_TAX_NUMBER"] = "company_tax_number";
    FormKeys["DEED_CERTIFICATE_NUMBER"] = "deed_certificate_number";
    FormKeys["COMPANY_DISTRICT"] = "company_district";
    FormKeys["DATE_OF_CERTIFICATE"] = "date_of_certificate";
    FormKeys["COMPANY_STATE_ID"] = "company_state_id";
    FormKeys["COMPANY_BIRTH_DATE"] = "company_birth_date";
    FormKeys["COMPANY_COUNTRY_CODE"] = "company_country_code";
    FormKeys["COMPANY_ZIP_CODE"] = "company_zip_code";
})(FormKeys$1 || (FormKeys$1 = {}));

const renderObjFunc$3 = (renderObj, records) => {
    records = records.filter(({ key }) => !!renderObj[key]);
    if (!records.length)
        return undefined;
    const rec = records.reduce((acc, { key, fields }) => {
        const item = renderObj[key];
        return acc.concat(item(fields));
    }, []);
    return rec;
};
const getIndividualFormFields$3 = (translate, formData, referenceData, context) => [
    {
        type: FIELD_TYPE.RADIO,
        key: FormKeys$1.RECOURSE_TYPE,
        label: translate && translate[FormKeys$1.RECOURSE_TYPE],
        param: [
            { value: formData && formData[FormKeys$1.RECOURSE_TYPE], disabled: false },
            Validators.required,
        ],
        options: RECOURSE_TYPE_OPTIONS,
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, RECOURSE_TYPE_OPTIONS),
        },
    },
    {
        type: FIELD_TYPE.RADIO,
        key: FormKeys$1.MEMBER_ENTITY_TYPE_ID,
        label: translate && translate[FormKeys$1.MEMBER_ENTITY_TYPE_ID],
        param: [
            { value: formData && formData[FormKeys$1.MEMBER_ENTITY_TYPE_ID], disabled: false },
            Validators.required,
        ],
        options: MEMBER_ENTITY_TYPE_ID_OPTIONS,
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, MEMBER_ENTITY_TYPE_ID_OPTIONS),
        },
    },
    {
        type: FIELD_TYPE.DATE,
        key: FormKeys$1.BIRTH_DATE,
        label: translate && translate[FormKeys$1.BIRTH_DATE],
        param: [
            { value: formData && formData[FormKeys$1.BIRTH_DATE], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.FULL_NAME,
        label: translate && translate[FormKeys$1.FULL_NAME],
        param: [
            { value: formData && formData[FormKeys$1.FULL_NAME], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.BIRTH_PLACE,
        label: translate && translate[FormKeys$1.BIRTH_PLACE],
        param: [
            { value: formData && formData[FormKeys$1.BIRTH_PLACE], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.USERNAME,
        label: translate && translate[FormKeys$1.USERNAME],
        param: [
            { value: formData && formData[FormKeys$1.USERNAME], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.ADDRESS_1,
        label: translate && translate[FormKeys$1.ADDRESS_1],
        param: [
            { value: formData && formData[FormKeys$1.ADDRESS_1], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.RADIO,
        key: FormKeys$1.GENDER_ID,
        label: translate && translate[FormKeys$1.GENDER_ID],
        param: [
            { value: formData && formData[FormKeys$1.GENDER_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.genders.map((g) => ({ value: g.id, label: g.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData ? referenceData.genders.map((g) => ({ value: g.id, label: g.name })) : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.ADDRESS_2,
        label: translate && translate[FormKeys$1.ADDRESS_2],
        param: [
            { value: formData && formData[FormKeys$1.ADDRESS_2], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.MOBILE_PHONE_NUMBER,
        label: translate && translate[FormKeys$1.MOBILE_PHONE_NUMBER],
        param: [
            { value: formData && formData[FormKeys$1.MOBILE_PHONE_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.AREA,
        label: translate && translate[FormKeys$1.AREA],
        param: [{ value: formData && formData[FormKeys$1.AREA], disabled: false }, Validators.required],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys$1.IC_TYPE_ID,
        label: translate && translate[FormKeys$1.IC_TYPE_ID],
        param: [
            { value: formData && formData[FormKeys$1.IC_TYPE_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.identityCardTypes.map((i) => ({ value: i.id, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.identityCardTypes.map((i) => ({ value: i.id, label: i.name }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.DISTRICT,
        label: translate && translate[FormKeys$1.DISTRICT],
        param: [
            { value: formData && formData[FormKeys$1.DISTRICT], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.IC_NUMBER,
        label: translate && translate[FormKeys$1.IC_NUMBER],
        param: [
            { value: formData && formData[FormKeys$1.IC_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys$1.STATE_ID,
        label: translate && translate[FormKeys$1.STATE_ID],
        param: [
            { value: formData && formData[FormKeys$1.STATE_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.provinces.map((i) => ({ value: i.id, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData ? referenceData.provinces.map((i) => ({ value: i.id, label: i.name })) : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.TAX_CARD_NUMBER,
        label: translate && translate[FormKeys$1.TAX_CARD_NUMBER],
        param: [
            { value: formData && formData[FormKeys$1.TAX_CARD_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.ZIP_CODE,
        label: translate && translate[FormKeys$1.ZIP_CODE],
        param: [
            { value: formData && formData[FormKeys$1.ZIP_CODE], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys$1.MARITAL_STATUS_ID,
        label: translate && translate[FormKeys$1.MARITAL_STATUS_ID],
        param: [
            { value: formData && formData[FormKeys$1.MARITAL_STATUS_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.maritalStatuses.map((i) => ({ value: i.id, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.maritalStatuses.map((i) => ({ value: i.id, label: i.name }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys$1.COUNTRY_CODE,
        label: translate && translate[FormKeys$1.COUNTRY_CODE],
        param: [
            { value: formData && formData[FormKeys$1.COUNTRY_CODE], disabled: false },
            Validators.required,
        ],
        options: referenceData?.countries.map((i) => ({ value: i.code, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.countries.map((i) => ({ value: i.code, label: i.name }))
                : []),
            ...context,
        },
    },
];
const getCompanyFormFields$3 = (translate, formData, referenceData, context) => [
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.NIB,
        label: translate && translate[FormKeys$1.NIB],
        param: [
            { value: null, disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.COMPANY_NAME,
        label: translate && translate[FormKeys$1.COMPANY_NAME],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_NAME], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.SKDP,
        label: translate && translate[FormKeys$1.SKDP],
        param: [
            { value: null, disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys$1.COMPANY_ENTITY_TYPE_ID,
        label: translate && translate[FormKeys$1.COMPANY_ENTITY_TYPE_ID],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_ENTITY_TYPE_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.companyEntityTypes.map((i) => ({ value: i.id, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.companyEntityTypes.map((i) => ({ value: i.id, label: i.name }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.TDP,
        label: translate && translate[FormKeys$1.TDP],
        param: [
            { value: null, disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.USERNAME,
        label: translate && translate[FormKeys$1.USERNAME],
        param: [
            { value: formData && formData[FormKeys$1.USERNAME], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys$1.ADDRESS_TYPE,
        label: translate && translate[FormKeys$1.ADDRESS_TYPE],
        param: [
            { value: null, disabled: false },
            Validators.required,
        ],
        options: referenceData?.settings?.address_type.map((i) => ({ value: i, label: i })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData && referenceData.settings
                ? referenceData.settings.address_type.map((i) => ({
                    value: i,
                    label: i,
                }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys$1.COMPANY_INDUSTRY_ID,
        label: translate && translate[FormKeys$1.COMPANY_INDUSTRY_ID],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_INDUSTRY_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.industries.map((i) => ({
            value: i.id,
            label: i.name, //  i.id_name || i.en_name ||
        })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.industries.map((i) => ({
                    value: i.id,
                    label: i.name, // i.id_name || i.en_name ||
                }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.COMPANY_ADDRESS_1,
        label: translate && translate[FormKeys$1.COMPANY_ADDRESS_1],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_ADDRESS_1], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.COMPANY_PHONE_NUMBER,
        label: translate && translate[FormKeys$1.COMPANY_PHONE_NUMBER],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_PHONE_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.COMPANY_ADDRESS_2,
        label: translate && translate[FormKeys$1.COMPANY_ADDRESS_2],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_ADDRESS_2], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.COMPANY_REGISTRATION_NUMBER,
        label: translate && translate[FormKeys$1.COMPANY_REGISTRATION_NUMBER],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_REGISTRATION_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.COMPANY_AREA,
        label: translate && translate[FormKeys$1.COMPANY_AREA],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_AREA], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.TAX_CARD_NUMBER,
        label: translate && translate[FormKeys$1.TAX_CARD_NUMBER],
        param: [
            { value: formData && formData[FormKeys$1.TAX_CARD_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    // {
    // 	type: FIELD_TYPE.STRING,
    // 	key: FormKeys.DEED_CERTIFICATE_NUMBER,
    // 	label: translate && translate[FormKeys.DEED_CERTIFICATE_NUMBER],
    // 	param: [
    // 		{ value: formData && formData[FormKeys.DEED_CERTIFICATE_NUMBER], disabled: false },
    // 		Validators.required,
    // 	],
    // 	context,
    // },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.COMPANY_DISTRICT,
        label: translate && translate[FormKeys$1.COMPANY_DISTRICT],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_DISTRICT], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.DATE,
        key: FormKeys$1.DATE_OF_CERTIFICATE,
        label: translate && translate[FormKeys$1.DATE_OF_CERTIFICATE],
        param: [
            { value: null, disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys$1.COMPANY_STATE_ID,
        label: translate && translate[FormKeys$1.COMPANY_STATE_ID],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_STATE_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.provinces.map((i) => ({ value: i.id, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData ? referenceData.provinces.map((i) => ({ value: i.id, label: i.name })) : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.DATE,
        key: FormKeys$1.COMPANY_BIRTH_DATE,
        label: translate && translate[FormKeys$1.COMPANY_BIRTH_DATE],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_BIRTH_DATE], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys$1.COMPANY_COUNTRY_CODE,
        label: translate && translate[FormKeys$1.COMPANY_COUNTRY_CODE],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_COUNTRY_CODE], disabled: false },
            Validators.required,
        ],
        options: referenceData?.countries.map((i) => ({ value: i.code, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.countries.map((i) => ({ value: i.code, label: i.name }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.COMPANY_ZIP_CODE,
        label: translate && translate[FormKeys$1.COMPANY_ZIP_CODE],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_ZIP_CODE], disabled: false },
            Validators.required,
        ],
        context,
    },
];
const getSpouseFormFields$3 = (translate, formData, referenceData, context) => [
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.SPOUSE_FULLNAME,
        label: translate && translate[FormKeys$1.SPOUSE_FULLNAME],
        param: [
            { value: formData && formData[FormKeys$1.SPOUSE_FULLNAME], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.SPOUSE_BIRTH_PLACE,
        label: translate && translate[FormKeys$1.SPOUSE_BIRTH_PLACE],
        param: [
            { value: formData && formData[FormKeys$1.SPOUSE_BIRTH_PLACE], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys$1.SPOUSE_ID_CARD_TYPE,
        label: translate && translate[FormKeys$1.SPOUSE_ID_CARD_TYPE],
        param: [
            { value: null, disabled: false },
            Validators.required,
        ],
        options: referenceData?.identityCardTypes.map((i) => ({ value: i.id, label: i.name })),
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.SPOUSE_IC_NUMBER,
        label: translate && translate[FormKeys$1.SPOUSE_IC_NUMBER],
        param: [
            { value: formData && formData[FormKeys$1.SPOUSE_IC_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.DATE,
        key: FormKeys$1.SPOUSE_BIRTH_DATE,
        label: translate && translate[FormKeys$1.SPOUSE_BIRTH_DATE],
        param: [
            { value: formData && formData[FormKeys$1.SPOUSE_BIRTH_DATE], disabled: false },
            Validators.required,
        ],
        context,
    },
];
const getAllFormFields$3 = (translate, formData, referenceData, renderObj) => [
    ...getIndividualFormFields$3(translate, formData, referenceData, {
        customRender: renderObjFunc$3(renderObj, [{ key: 'bip-individual-entity-change' }]),
    }),
    ...getSpouseFormFields$3(translate, formData, referenceData, {
        customRender: renderObjFunc$3(renderObj, [{ key: 'bip-marital-status-change' }]),
    }),
    ...getCompanyFormFields$3(translate, formData, referenceData, {
        customRender: renderObjFunc$3(renderObj, [{ key: 'bip-company-entity-change' }]),
    }),
];
const ID_FORM_CONFIG$1 = {
    setup(translate, formData, referenceData, isReadonly, renderObj) {
        return {
            formFields: getAllFormFields$3(translate, formData, referenceData, renderObj),
            formData,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        };
    },
    getValue(form, formData) {
        return {
            ...formData,
            ...form.value,
        };
    },
};

const renderObjFunc$2 = (renderObj, records) => {
    records = records.filter(({ key }) => !!renderObj[key]);
    if (!records.length)
        return undefined;
    const rec = records.reduce((acc, { key, fields }) => {
        const item = renderObj[key];
        return acc.concat(item(fields));
    }, []);
    return rec;
};
const getIndividualFormFields$2 = (translate, formData, referenceData, context) => [
    {
        type: FIELD_TYPE.RADIO,
        key: FormKeys$1.RECOURSE_TYPE,
        label: translate && translate[FormKeys$1.RECOURSE_TYPE],
        param: [
            { value: formData && formData[FormKeys$1.RECOURSE_TYPE], disabled: false },
            Validators.required,
        ],
        options: RECOURSE_TYPE_OPTIONS,
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, RECOURSE_TYPE_OPTIONS),
        },
    },
    {
        type: FIELD_TYPE.RADIO,
        key: FormKeys$1.MEMBER_ENTITY_TYPE_ID,
        label: translate && translate[FormKeys$1.MEMBER_ENTITY_TYPE_ID],
        param: [
            { value: formData && formData[FormKeys$1.MEMBER_ENTITY_TYPE_ID], disabled: false },
            Validators.required,
        ],
        options: MEMBER_ENTITY_TYPE_ID_OPTIONS,
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, MEMBER_ENTITY_TYPE_ID_OPTIONS),
        },
    },
    {
        type: FIELD_TYPE.DATE,
        key: FormKeys$1.BIRTH_DATE,
        label: translate && translate[FormKeys$1.BIRTH_DATE],
        param: [
            { value: formData && formData[FormKeys$1.BIRTH_DATE], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.FULL_NAME,
        label: translate && translate[FormKeys$1.FULL_NAME],
        param: [
            { value: formData && formData[FormKeys$1.FULL_NAME], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.BIRTH_PLACE,
        label: translate && translate[FormKeys$1.BIRTH_PLACE],
        param: [
            { value: formData && formData[FormKeys$1.BIRTH_PLACE], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.USERNAME,
        label: translate && translate[FormKeys$1.USERNAME],
        param: [
            { value: formData && formData[FormKeys$1.USERNAME], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.ADDRESS_1,
        label: translate && translate[FormKeys$1.ADDRESS_1],
        param: [
            { value: formData && formData[FormKeys$1.ADDRESS_1], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.RADIO,
        key: FormKeys$1.GENDER_ID,
        label: translate && translate[FormKeys$1.GENDER_ID],
        param: [
            { value: formData && formData[FormKeys$1.GENDER_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.genders.map((g) => ({ value: g.id, label: g.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData ? referenceData.genders.map((g) => ({ value: g.id, label: g.name })) : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.ADDRESS_2,
        label: translate && translate[FormKeys$1.ADDRESS_2],
        param: [
            { value: formData && formData[FormKeys$1.ADDRESS_2], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.MOBILE_PHONE_NUMBER,
        label: translate && translate[FormKeys$1.MOBILE_PHONE_NUMBER],
        param: [
            { value: formData && formData[FormKeys$1.MOBILE_PHONE_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.AREA,
        label: translate && translate[FormKeys$1.AREA],
        param: [{ value: formData && formData[FormKeys$1.AREA], disabled: false }, Validators.required],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys$1.IC_TYPE_ID,
        label: translate && translate[FormKeys$1.IC_TYPE_ID],
        param: [
            { value: formData && formData[FormKeys$1.IC_TYPE_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.identityCardTypes.map((i) => ({ value: i.id, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.identityCardTypes.map((i) => ({ value: i.id, label: i.name }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.DISTRICT,
        label: translate && translate[FormKeys$1.DISTRICT],
        param: [
            { value: formData && formData[FormKeys$1.DISTRICT], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.IC_NUMBER,
        label: translate && translate[FormKeys$1.IC_NUMBER],
        param: [
            { value: formData && formData[FormKeys$1.IC_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys$1.STATE_ID,
        label: translate && translate[FormKeys$1.STATE_ID],
        param: [
            { value: formData && formData[FormKeys$1.STATE_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.provinces.map((i) => ({ value: i.id, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData ? referenceData.provinces.map((i) => ({ value: i.id, label: i.name })) : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.TAX_CARD_NUMBER,
        label: translate && translate[FormKeys$1.TAX_CARD_NUMBER],
        param: [
            { value: formData && formData[FormKeys$1.TAX_CARD_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.ZIP_CODE,
        label: translate && translate[FormKeys$1.ZIP_CODE],
        param: [
            { value: formData && formData[FormKeys$1.ZIP_CODE], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys$1.MARITAL_STATUS_ID,
        label: translate && translate[FormKeys$1.MARITAL_STATUS_ID],
        param: [
            { value: formData && formData[FormKeys$1.MARITAL_STATUS_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.maritalStatuses.map((i) => ({ value: i.id, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.maritalStatuses.map((i) => ({ value: i.id, label: i.name }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys$1.COUNTRY_CODE,
        label: translate && translate[FormKeys$1.COUNTRY_CODE],
        param: [
            { value: formData && formData[FormKeys$1.COUNTRY_CODE], disabled: false },
            Validators.required,
        ],
        options: referenceData?.countries.map((i) => ({ value: i.code, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.countries.map((i) => ({ value: i.code, label: i.name }))
                : []),
            ...context,
        },
    },
];
const getCompanyFormFields$2 = (translate, formData, referenceData, context) => [
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.NIB,
        label: translate && translate[FormKeys$1.NIB],
        param: [
            { value: null, disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.COMPANY_NAME,
        label: translate && translate[FormKeys$1.COMPANY_NAME],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_NAME], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.SKDP,
        label: translate && translate[FormKeys$1.SKDP],
        param: [
            { value: null, disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys$1.COMPANY_ENTITY_TYPE_ID,
        label: translate && translate[FormKeys$1.COMPANY_ENTITY_TYPE_ID],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_ENTITY_TYPE_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.companyEntityTypes.map((i) => ({ value: i.id, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.companyEntityTypes.map((i) => ({ value: i.id, label: i.name }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.TDP,
        label: translate && translate[FormKeys$1.TDP],
        param: [
            { value: null, disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.USERNAME,
        label: translate && translate[FormKeys$1.USERNAME],
        param: [
            { value: formData && formData[FormKeys$1.USERNAME], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys$1.ADDRESS_TYPE,
        label: translate && translate[FormKeys$1.ADDRESS_TYPE],
        param: [
            { value: null, disabled: false },
            Validators.required,
        ],
        options: referenceData?.settings?.address_type.map((i) => ({ value: i, label: i })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData && referenceData.settings
                ? referenceData.settings.address_type.map((i) => ({
                    value: i,
                    label: i,
                }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys$1.COMPANY_INDUSTRY_ID,
        label: translate && translate[FormKeys$1.COMPANY_INDUSTRY_ID],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_INDUSTRY_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.industries.map((i) => ({
            value: i.id,
            label: i.name, //  i.id_name || i.en_name ||
        })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.industries.map((i) => ({
                    value: i.id,
                    label: i.name, // i.id_name || i.en_name ||
                }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.COMPANY_ADDRESS_1,
        label: translate && translate[FormKeys$1.COMPANY_ADDRESS_1],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_ADDRESS_1], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.COMPANY_PHONE_NUMBER,
        label: translate && translate[FormKeys$1.COMPANY_PHONE_NUMBER],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_PHONE_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.COMPANY_ADDRESS_2,
        label: translate && translate[FormKeys$1.COMPANY_ADDRESS_2],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_ADDRESS_2], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.COMPANY_REGISTRATION_NUMBER,
        label: translate && translate[FormKeys$1.COMPANY_REGISTRATION_NUMBER],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_REGISTRATION_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.COMPANY_AREA,
        label: translate && translate[FormKeys$1.COMPANY_AREA],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_AREA], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.TAX_CARD_NUMBER,
        label: translate && translate[FormKeys$1.TAX_CARD_NUMBER],
        param: [
            { value: formData && formData[FormKeys$1.TAX_CARD_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    // {
    // 	type: FIELD_TYPE.STRING,
    // 	key: FormKeys.DEED_CERTIFICATE_NUMBER,
    // 	label: translate && translate[FormKeys.DEED_CERTIFICATE_NUMBER],
    // 	param: [
    // 		{ value: formData && formData[FormKeys.DEED_CERTIFICATE_NUMBER], disabled: false },
    // 		Validators.required,
    // 	],
    // 	context,
    // },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.COMPANY_DISTRICT,
        label: translate && translate[FormKeys$1.COMPANY_DISTRICT],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_DISTRICT], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.DATE,
        key: FormKeys$1.DATE_OF_CERTIFICATE,
        label: translate && translate[FormKeys$1.DATE_OF_CERTIFICATE],
        param: [
            { value: null, disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys$1.COMPANY_STATE_ID,
        label: translate && translate[FormKeys$1.COMPANY_STATE_ID],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_STATE_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.provinces.map((i) => ({ value: i.id, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData ? referenceData.provinces.map((i) => ({ value: i.id, label: i.name })) : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.DATE,
        key: FormKeys$1.COMPANY_BIRTH_DATE,
        label: translate && translate[FormKeys$1.COMPANY_BIRTH_DATE],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_BIRTH_DATE], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys$1.COMPANY_COUNTRY_CODE,
        label: translate && translate[FormKeys$1.COMPANY_COUNTRY_CODE],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_COUNTRY_CODE], disabled: false },
            Validators.required,
        ],
        options: referenceData?.countries.map((i) => ({ value: i.code, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.countries.map((i) => ({ value: i.code, label: i.name }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.COMPANY_ZIP_CODE,
        label: translate && translate[FormKeys$1.COMPANY_ZIP_CODE],
        param: [
            { value: formData && formData[FormKeys$1.COMPANY_ZIP_CODE], disabled: false },
            Validators.required,
        ],
        context,
    },
];
const getSpouseFormFields$2 = (translate, formData, referenceData, context) => [
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.SPOUSE_FULLNAME,
        label: translate && translate[FormKeys$1.SPOUSE_FULLNAME],
        param: [
            { value: formData && formData[FormKeys$1.SPOUSE_FULLNAME], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.SPOUSE_BIRTH_PLACE,
        label: translate && translate[FormKeys$1.SPOUSE_BIRTH_PLACE],
        param: [
            { value: formData && formData[FormKeys$1.SPOUSE_BIRTH_PLACE], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys$1.SPOUSE_ID_CARD_TYPE,
        label: translate && translate[FormKeys$1.SPOUSE_ID_CARD_TYPE],
        param: [
            { value: null, disabled: false },
            Validators.required,
        ],
        options: referenceData?.identityCardTypes.map((i) => ({ value: i.id, label: i.name })),
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys$1.SPOUSE_IC_NUMBER,
        label: translate && translate[FormKeys$1.SPOUSE_IC_NUMBER],
        param: [
            { value: formData && formData[FormKeys$1.SPOUSE_IC_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.DATE,
        key: FormKeys$1.SPOUSE_BIRTH_DATE,
        label: translate && translate[FormKeys$1.SPOUSE_BIRTH_DATE],
        param: [
            { value: formData && formData[FormKeys$1.SPOUSE_BIRTH_DATE], disabled: false },
            Validators.required,
        ],
        context,
    },
];
const getAllFormFields$2 = (translate, formData, referenceData, renderObj) => [
    ...getIndividualFormFields$2(translate, formData, referenceData, {
        customRender: renderObjFunc$2(renderObj, [{ key: 'bip-individual-entity-change' }]),
    }),
    ...getSpouseFormFields$2(translate, formData, referenceData, {
        customRender: renderObjFunc$2(renderObj, [{ key: 'bip-marital-status-change' }]),
    }),
    ...getCompanyFormFields$2(translate, formData, referenceData, {
        customRender: renderObjFunc$2(renderObj, [{ key: 'bip-company-entity-change' }]),
    }),
];
const SG_FORM_CONFIG$1 = {
    setup(translate, formData, referenceData, isReadonly, renderObj) {
        return {
            formFields: getAllFormFields$2(translate, formData, referenceData, renderObj),
            formData,
            formFieldConfig: {
                hideAllCTAs: true,
            },
        };
    },
    getValue(form, formData) {
        return {
            ...formData,
            ...form.value,
        };
    },
};

const FORM_CONFIG_TOKEN$1 = new InjectionToken('FORM_CONFIG_TOKEN');

var GridFields;
(function (GridFields) {
    GridFields["ID"] = "id";
    GridFields["FULLNAME"] = "fullname";
    GridFields["DESIGNATION"] = "designation";
    GridFields["OWNERSHIP"] = "ownership";
    GridFields["BIRTH_DOB"] = "birth_date";
    GridFields["RECOURSE_TYPE"] = "recourse_type";
    GridFields["PEFINDO_REPORT"] = "pefindo_report";
})(GridFields || (GridFields = {}));

const ID_GRID_CONFIG = {
    setup(defaultGridOptions, translate, rowData, action, isReadonly = false) {
        return {
            ...defaultGridOptions,
            rowData,
            columnDefs: [
                {
                    field: GridFields.FULLNAME,
                    headerName: translate && translate[GridFields.FULLNAME],
                    width: 200,
                },
                {
                    field: GridFields.DESIGNATION,
                    headerName: translate && translate[GridFields.DESIGNATION],
                    width: 250,
                },
                {
                    field: GridFields.OWNERSHIP,
                    headerName: translate && translate[GridFields.OWNERSHIP],
                    width: 180,
                },
                {
                    field: GridFields.BIRTH_DOB,
                    headerName: translate && translate[GridFields.BIRTH_DOB],
                    width: 180,
                },
                {
                    field: GridFields.RECOURSE_TYPE,
                    headerName: translate && translate[GridFields.RECOURSE_TYPE],
                    width: 180,
                },
                isReadonly
                    ? {}
                    : {
                        field: CommonGridFields.ACTIONS,
                        headerName: '',
                        width: 60,
                        pinned: 'right',
                        cellRendererSelector: (params) => ({
                            component: 'actionMethods',
                            params: {
                                ...params,
                                onEdit: (params) => action(params.data, Methods.PUT),
                                onDelete: (params) => action(params.data, Methods.DELETE),
                            },
                        }),
                    },
            ],
        };
    },
};

const SG_GRID_CONFIG = {
    setup(defaultGridOptions, translate, rowData, action, isReadonly = false) {
        return {
            ...defaultGridOptions,
            rowData,
            columnDefs: [
                {
                    field: GridFields.FULLNAME,
                    headerName: translate && translate[GridFields.FULLNAME],
                    width: 200,
                },
                {
                    field: GridFields.DESIGNATION,
                    headerName: translate && translate[GridFields.DESIGNATION],
                    width: 250,
                },
                {
                    field: GridFields.OWNERSHIP,
                    headerName: translate && translate[GridFields.OWNERSHIP],
                    width: 180,
                },
                {
                    field: GridFields.BIRTH_DOB,
                    headerName: translate && translate[GridFields.BIRTH_DOB],
                    width: 180,
                },
                {
                    field: GridFields.RECOURSE_TYPE,
                    headerName: translate && translate[GridFields.RECOURSE_TYPE],
                    width: 180,
                },
                isReadonly
                    ? {}
                    : {
                        field: CommonGridFields.ACTIONS,
                        headerName: '',
                        width: 60,
                        pinned: 'right',
                        cellRendererSelector: (params) => ({
                            component: 'actionMethods',
                            params: {
                                ...params,
                                onEdit: (params) => action(params.data, Methods.PUT),
                                onDelete: (params) => action(params.data, Methods.DELETE),
                            },
                        }),
                    },
            ],
        };
    },
};

const GRID_CONFIG_TOKEN = new InjectionToken('GRID_CONFIG_TOKEN');

class MemberBIPSEntryDialogComponent {
    // public formSubscription: Subscription | null = null;
    constructor(context, _scope, _translateService, _masterDataService, _settingsService, _cdr, _modalComponent) {
        this.context = context;
        this._scope = _scope;
        this._translateService = _translateService;
        this._masterDataService = _masterDataService;
        this._settingsService = _settingsService;
        this._cdr = _cdr;
        this._modalComponent = _modalComponent;
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'form_fields'),
            this._translateService.selectFeatureTranslate(this._scope, 'titles'),
            this._translateService.selectFeatureTranslate(this._scope, 'buttons'),
        ]).pipe(map(([fields, titles, buttons]) => ({ fields, titles, buttons })));
        this.config = null;
        this.form = null;
        this.configuration((fields) => this.setupForm(fields));
    }
    submit() {
        if (!this.form) {
            return this.cancel();
        }
        if (this.form.invalid)
            return;
        const data = this.context.data.config.getValue(this.form, this.context.data.selectedItem);
        const checkEqual = isEqualWith(data, this.context.data.selectedItem);
        if (checkEqual) {
            return this.cancel();
        }
        this.context.completeWith({
            method: this.context.data.method,
            data,
        });
    }
    cancel() {
        this.context.completeWith(null);
    }
    remove() {
        this.context.completeWith({
            method: Methods.DELETE,
            data: null,
        });
    }
    listen(form) {
        this.form = form;
        // this.formSubscription = this.context.data.config.listenChange(form, () => {
        // 	this._cdr.markForCheck();
        // });
    }
    configuration(cb) {
        this.translate$
            .pipe(take(1), tap(({ fields, titles }) => {
            this._modalComponent.setLabel(titles[this.context.data.method]);
            cb(fields, titles);
            this._cdr.markForCheck();
        }))
            .subscribe();
    }
    changeMode() {
        this.configuration(() => {
            if (!this.config)
                return;
            // this.config = this.context.data.config.reset(this.config);
            this.config.formFieldConfig.isReadonly = false;
        });
    }
    setupForm(fields) {
        const masterDataCache = this._masterDataService.getCache();
        this.config = this.context.data.config.setup(fields, this.context.data.selectedItem, {
            ...masterDataCache,
            maritalStatuses: masterDataCache.marital_statuses,
            identityCardTypes: masterDataCache.identity_card_types,
            companyEntityTypes: masterDataCache.company_entity_types,
            settings: this._settingsService.getCache(),
        }, this.context.data.isReadonly, {
            'bip-individual-entity-change': (fields) => {
                return [
                    {
                        fields: fields || [
                            {
                                key: FormKeys$1.MEMBER_ENTITY_TYPE_ID,
                                correctWhenValueIs(value
                                // formFieldControl: FormFieldControl
                                ) {
                                    return value.toString() === '1';
                                },
                            },
                        ],
                        cb: (params, condition) => {
                            if (condition) {
                                params.renderView();
                            }
                            else {
                                params.clearView();
                            }
                        },
                    },
                ];
            },
            'bip-company-entity-change': (fields) => {
                return [
                    {
                        fields: fields || [
                            {
                                key: FormKeys$1.MEMBER_ENTITY_TYPE_ID,
                                correctWhenValueIs(value
                                // formFieldControl: FormFieldControl
                                ) {
                                    return value.toString() === '3';
                                },
                            },
                        ],
                        cb: (params, condition) => {
                            if (condition) {
                                params.renderView();
                            }
                            else {
                                params.clearView();
                            }
                        },
                    },
                ];
            },
            'bip-marital-status-change': (fields) => {
                return [
                    {
                        fields: fields || [
                            {
                                key: FormKeys$1.MARITAL_STATUS_ID,
                                correctWhenValueIs(value
                                // formFieldControl: FormFieldControl
                                ) {
                                    return (value.toString() === '5' ||
                                        (getCountryCodeFromStorage() === CountryCode.SG && value === '4'));
                                },
                            },
                            {
                                key: FormKeys$1.MEMBER_ENTITY_TYPE_ID,
                                correctWhenValueIs(value
                                // formFieldControl: FormFieldControl
                                ) {
                                    return value.toString() === '1';
                                },
                            },
                        ],
                        cb: (params, condition) => {
                            if (condition) {
                                params.renderView();
                            }
                            else {
                                params.clearView();
                            }
                        },
                    },
                ];
            },
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberBIPSEntryDialogComponent, deps: [{ token: MODAL_CONTEXT }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: MASTER_DATA_SERVICE_TOKEN }, { token: SETTINGS_SERVICE_TOKEN }, { token: i0.ChangeDetectorRef }, { token: ModalComponent }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: MemberBIPSEntryDialogComponent, selector: "fsw-member-bips-entry-dialog", ngImport: i0, template: `
    <ng-container *ngIf="translate$ | async as translate">
      <fsw-save-dialog
        [config]="config"
        [(method)]="context.data.method"
        [buttonSaveLabel]="translate.buttons['save']"
        [buttonCancelLabel]="translate.buttons['cancel']"
        [buttonEditLabel]="translate.buttons['edit']"
        [buttonBackLabel]="translate.buttons['back']"
        [isReadonly]="context.data.isReadonly"
        (methodChange)="changeMode()"
        (listen)="listen($event)"
        (remove)="remove()"
        (cancel)="cancel()"
        (save)="submit()"
      >
      </fsw-save-dialog>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FSWSaveDialogComponent, selector: "fsw-save-dialog", inputs: ["method", "config", "buttonDeleteLabel", "buttonCancelLabel", "buttonBackLabel", "buttonEditLabel", "buttonSaveLabel", "isReadonly"], outputs: ["remove", "cancel", "save", "listen", "methodChange"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberBIPSEntryDialogComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-member-bips-entry-dialog',
                    template: `
    <ng-container *ngIf="translate$ | async as translate">
      <fsw-save-dialog
        [config]="config"
        [(method)]="context.data.method"
        [buttonSaveLabel]="translate.buttons['save']"
        [buttonCancelLabel]="translate.buttons['cancel']"
        [buttonEditLabel]="translate.buttons['edit']"
        [buttonBackLabel]="translate.buttons['back']"
        [isReadonly]="context.data.isReadonly"
        (methodChange)="changeMode()"
        (listen)="listen($event)"
        (remove)="remove()"
        (cancel)="cancel()"
        (save)="submit()"
      >
      </fsw-save-dialog>
    </ng-container>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_CONTEXT]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MASTER_DATA_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SETTINGS_SERVICE_TOKEN]
                }] }, { type: i0.ChangeDetectorRef }, { type: ModalComponent }]; } });

class MemberBIPSEntryDialogModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberBIPSEntryDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: MemberBIPSEntryDialogModule, declarations: [MemberBIPSEntryDialogComponent], imports: [CommonModule, FSWSaveDialogModule, TranslocoModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberBIPSEntryDialogModule, imports: [CommonModule, FSWSaveDialogModule, TranslocoModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberBIPSEntryDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FSWSaveDialogModule, TranslocoModule],
                    declarations: [MemberBIPSEntryDialogComponent],
                }]
        }] });

class MemberBIPSGridComponent {
    constructor(_memberBIPService, gridConfig, _scope, _translateService) {
        this._memberBIPService = _memberBIPService;
        this.gridConfig = gridConfig;
        this._scope = _scope;
        this._translateService = _translateService;
        this.isReadonly = false;
        this.action = new EventEmitter();
        this._getRowSubject = new Subject();
        this._destroySubject = new Subject();
        this.gridOptions = {
            rowSelection: 'multiple',
            headerHeight: 36,
            rowHeight: 36,
            pagination: true,
            paginationPageSize: 10,
            cacheBlockSize: 10,
            rowModelType: 'serverSide',
            serverSideStoreType: 'partial',
            overlayNoRowsTemplate: `
			<div>
				<div style="color: #757575; padding-top: 40px;">No Directors data is available</div>
			</div>
		`,
            getRowId: (params) => params.data.id,
            onGridReady: (event) => {
                event.api.setGridOption('serverSideDatasource', {
                    getRows: (params) => this._getRowSubject.next(params),
                });
            },
        };
        this.gridOptions$ = this._translateService
            .selectFeatureTranslate(this._scope, 'fields')
            .pipe(map((translate) => this._setupGridOptions(translate)));
    }
    ngOnInit() {
        this._getRowSubject
            .asObservable()
            .pipe(takeUntil(this._destroySubject), switchMap((serverSideParams) => {
            // if (this._productIdsCache !== product_ids || this._keySearchCache !== keySearch) {
            // 	serverSideParams.api.refreshServerSideStore();
            // 	serverSideParams.api.paginationGoToFirstPage();
            // }
            if (!this.applicationId || !this.memberId) {
                throw new Error(`Either applicationId: ${this.applicationId} or memberId ${this.memberId} is not present`);
            }
            return this._memberBIPService
                .getApplicationMemberBIPs(this.applicationId, this.memberId, {
                expand: true,
                page: serverSideParams.request.endRow ? serverSideParams.request.endRow / 10 : 1,
                limit: 10,
            })
                .pipe(map((res) => {
                const data = res.map((r) => ({
                    id: r.id,
                    ...r.expand,
                }));
                return [{ data, total: res?.length }, serverSideParams];
            }));
        }))
            .subscribe(([res, serverSideParams]) => {
            const lbLastRowOnPageEl = document.querySelector(`[ref="lbLastRowOnPage"]`);
            const timeout = setTimeout(() => {
                if (lbLastRowOnPageEl) {
                    lbLastRowOnPageEl.innerHTML = serverSideParams.request.endRow
                        ? serverSideParams.request.endRow.toString()
                        : serverSideParams.api.paginationGetPageSize().toString();
                }
                clearTimeout(timeout);
            }, 300);
            serverSideParams.success({
                rowData: res.data || [],
                rowCount: !res.data.length ? 0 : res.total,
            });
            if (!res.data.length) {
                serverSideParams.api.showNoRowsOverlay();
            }
            else {
                serverSideParams.api.hideOverlay();
            }
        }, (err) => console.error(err));
    }
    ngOnDestroy() {
        this._destroySubject.next(0);
        this._destroySubject.complete();
    }
    rowClicked({ data, index, }) {
        this.action.emit({
            res: data,
            method: Methods.GET,
        });
    }
    _setupGridOptions(translate) {
        return this.gridConfig.setup(this.gridOptions, translate, [], (res, method) => this.action.emit({ res, method }), this.isReadonly);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberBIPSGridComponent, deps: [{ token: APPLICATION_MEMBER_BIP_SERVICE_TOKEN }, { token: GRID_CONFIG_TOKEN }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: MemberBIPSGridComponent, selector: "fsw-member-bips-grid", inputs: { applicationId: "applicationId", memberId: "memberId", isReadonly: "isReadonly" }, outputs: { action: "action" }, ngImport: i0, template: `
		<fsw-grid
			[gridOptions]="(gridOptions$ | async) || {}"
			[gridContainerHeight]="400"
			(rowClicked)="rowClicked($event)"
		></fsw-grid>
	`, isInline: true, dependencies: [{ kind: "component", type: FSWGridComponent, selector: "fsw-grid", inputs: ["gridOptions", "actionClickedCheck", "rowData", "gridContainerHeight"], outputs: ["rowClicked"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberBIPSGridComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-member-bips-grid',
                    template: `
		<fsw-grid
			[gridOptions]="(gridOptions$ | async) || {}"
			[gridContainerHeight]="400"
			(rowClicked)="rowClicked($event)"
		></fsw-grid>
	`,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_BIP_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [GRID_CONFIG_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }]; }, propDecorators: { applicationId: [{
                type: Input
            }], memberId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], action: [{
                type: Output
            }] } });

class MemberBIPSGridModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberBIPSGridModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: MemberBIPSGridModule, declarations: [MemberBIPSGridComponent], imports: [CommonModule, TranslocoModule, FSWGridModule], exports: [MemberBIPSGridComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberBIPSGridModule, imports: [CommonModule, TranslocoModule, FSWGridModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberBIPSGridModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, TranslocoModule, FSWGridModule],
                    declarations: [MemberBIPSGridComponent],
                    exports: [MemberBIPSGridComponent],
                }]
        }] });

var header$9 = {
	title: "Member BIPs"
};
var fields$h = {
	fullname: "Name",
	designation: "Designation",
	ownership: "Ownership",
	birth_date: "Date of Birth (Age)",
	recourse_type: "Recourse Type"
};
var form_fields$6 = {
	member_entity_type_id: "Entity Type",
	birth_date: "Date of Birth",
	fullname: "Name",
	birth_place: "Place of Birth",
	username: "Email",
	address_1: "Address Line 1",
	gender_id: "Gender",
	address_2: "Address Line 2",
	mobile_phone_number: "Mobile Number",
	area: "Area",
	ic_type_id: "ID Card Type",
	district: "District",
	ic_number: "ID Card Number",
	state_id: "State Province",
	tax_card_number: "Tax Number",
	religion_code: "Religion",
	zip_code: "Postal Code",
	marital_status_id: "Marital Status",
	country_code: "Country",
	nib: "NIB",
	company_name: "Company Name",
	skdp: "SKDP",
	company_entity_type_id: "Company Type",
	tdp: "TDP",
	address_type: "Address Type",
	company_industry_id: "Company Industry",
	company_address_1: "Company Address Line 1",
	company_phone_number: "Company Phone Number",
	company_address_2: "Company Address Line 2",
	company_registration_number: "Company Registration Number",
	company_area: "Company Area",
	deed_certificate_number: "Deed Certificate Number",
	company_district: "District",
	date_of_certificate: "Date of Certificate / Deed",
	company_state_id: "State Province",
	company_birth_date: "Establishment Date",
	company_country_code: "Country",
	company_zip_code: "Postal Code",
	spouse_fullname: "Spouse Full Name",
	spouse_birth_place: "Spouse Place of Birth",
	spouse_id_card_type: "Spouse ID Card Type",
	spouse_mobile_phone_number: "Spouse Phone Number",
	spouse_ic_number: "Spouse ID Card Number",
	spouse_birth_date: "Spouse Date of Birth",
	recourse_type: "Recourse Type"
};
var titles$4 = {
	post: "Add New BIP",
	put: "Edit BIP",
	get: "View BIP",
	confirm: "Are you sure you want to delete?"
};
var buttons$x = {
	cancel: "Cancel",
	save_changes: "Save Changes",
	edit: "Edit",
	back: "Back"
};
var sg$4 = {
	header: header$9,
	fields: fields$h,
	form_fields: form_fields$6,
	titles: titles$4,
	buttons: buttons$x
};

var sg$5 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$x,
    default: sg$4,
    fields: fields$h,
    form_fields: form_fields$6,
    header: header$9,
    titles: titles$4
});

var header$8 = {
	title: "Member BIPs"
};
var fields$g = {
	fullname: "Name",
	designation: "Designation",
	ownership: "Ownership",
	birth_date: "Date of Birth (Age)",
	recourse_type: "Recourse Type"
};
var form_fields$5 = {
	member_entity_type_id: "Entity Type",
	birth_date: "Date of Birth",
	fullname: "Name",
	birth_place: "Place of Birth",
	username: "Email",
	address_1: "Address Line 1",
	gender_id: "Gender",
	address_2: "Address Line 2",
	mobile_phone_number: "Mobile Number",
	area: "Area",
	ic_type_id: "ID Card Type",
	district: "District",
	ic_number: "ID Card Number",
	state_id: "State Province",
	tax_card_number: "Tax Number",
	religion_code: "Religion",
	zip_code: "Postal Code",
	marital_status_id: "Marital Status",
	country_code: "Country",
	nib: "NIB",
	company_name: "Company Name",
	skdp: "SKDP",
	company_entity_type_id: "Company Type",
	tdp: "TDP",
	address_type: "Address Type",
	company_industry_id: "Company Industry",
	company_address_1: "Company Address Line 1",
	company_phone_number: "Company Phone Number",
	company_address_2: "Company Address Line 2",
	company_registration_number: "Company Registration Number",
	company_area: "Company Area",
	deed_certificate_number: "Deed Certificate Number",
	company_district: "District",
	date_of_certificate: "Date of Certificate / Deed",
	company_state_id: "State Province",
	company_birth_date: "Establishment Date",
	company_country_code: "Country",
	company_zip_code: "Postal Code",
	spouse_fullname: "Spouse Full Name",
	spouse_birth_place: "Spouse Place of Birth",
	spouse_id_card_type: "Spouse ID Card Type",
	spouse_mobile_phone_number: "Spouse Phone Number",
	spouse_ic_number: "Spouse ID Card Number",
	spouse_birth_date: "Spouse Date of Birth",
	recourse_type: "Recourse Type"
};
var titles$3 = {
	post: "Add New BIP",
	put: "Edit BIP",
	get: "View BIP",
	confirm: "Are you sure you want to delete?"
};
var buttons$w = {
	cancel: "Cancel",
	save_changes: "Save Changes",
	edit: "Edit",
	back: "Back"
};
var id$6 = {
	header: header$8,
	fields: fields$g,
	form_fields: form_fields$5,
	titles: titles$3,
	buttons: buttons$w
};

var id$7 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$w,
    default: id$6,
    fields: fields$g,
    form_fields: form_fields$5,
    header: header$8,
    titles: titles$3
});

const TRANSLATION_LOADER$3 = {
    default: () => Promise.resolve(sg$5),
    [CountryCode.SG]: () => Promise.resolve(sg$5),
    [CountryCode.ID]: () => Promise.resolve(id$7),
};

let CompanyDirectorStore = class CompanyDirectorStore extends ComponentStore {
    constructor(_memberBIPService, _stateOverride = {}) {
        super({
            countryCode: null,
            applicationId: null,
            memberId: null,
            selectedMemberBIP: null,
            errors: [],
            ..._stateOverride,
        });
        this._memberBIPService = _memberBIPService;
        this._stateOverride = _stateOverride;
        this.setApplicationId = this.updater((state, applicationId) => {
            return { ...state, applicationId };
        });
        this.setMemberId = this.updater((state, memberId) => {
            return { ...state, memberId };
        });
        this.setSelectedMemberBIP = this.updater((state, selectedMemberBIP) => {
            return { ...state, selectedMemberBIP };
        });
        this.setErrors = this.updater((state, errors) => {
            return { ...state, errors };
        });
        this.updateMemberBIP = this.effect(pipe(switchMap(({ memberBIP }) => this._updateMemberBIPAsync(memberBIP))));
        this.saveChanges = this.effect(pipe(tap(({ memberBIP }) => {
            if (this.get().memberId) {
                this.updateMemberBIP({ memberBIP });
            }
            else {
                throw new Error('No memberId exists');
            }
        })));
    }
    _updateMemberBIPAsync(payload) {
        if (!isStringValid(this.state().applicationId))
            return EMPTY;
        return EMPTY;
    }
};
CompanyDirectorStore = __decorate([
    __param(0, Inject(APPLICATION_MEMBER_BIP_SERVICE_TOKEN)),
    __metadata("design:paramtypes", [Object, Object])
], CompanyDirectorStore);

class IDCompanyDirectorStore extends CompanyDirectorStore {
    constructor(_memberBIPService) {
        super(_memberBIPService, { countryCode: CountryCode.ID });
        this._memberBIPService = _memberBIPService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDCompanyDirectorStore, deps: [{ token: APPLICATION_MEMBER_BIP_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDCompanyDirectorStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDCompanyDirectorStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_BIP_SERVICE_TOKEN]
                }] }]; } });

class SGCompanyDirectorStore extends CompanyDirectorStore {
    constructor(_memberBIPService) {
        super(_memberBIPService, { countryCode: CountryCode.SG });
        this._memberBIPService = _memberBIPService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SGCompanyDirectorStore, deps: [{ token: APPLICATION_MEMBER_BIP_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SGCompanyDirectorStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SGCompanyDirectorStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_BIP_SERVICE_TOKEN]
                }] }]; } });

const STORE_TOKEN$2 = new InjectionToken('STORE_TOKEN');

class MemberBIPSComponent {
    set applicationId(value) {
        this._store.setApplicationId(value);
    }
    set memberId(value) {
        this._store.setMemberId(value);
    }
    constructor(_formConfig, gridConfig, _store, _scope, _translateService, _modalService, _injector) {
        this._formConfig = _formConfig;
        this.gridConfig = gridConfig;
        this._store = _store;
        this._scope = _scope;
        this._translateService = _translateService;
        this._modalService = _modalService;
        this._injector = _injector;
        this.isReadonly = false;
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'header'),
            this._translateService.selectFeatureTranslate(this._scope, 'form_fields'),
        ]).pipe(map(([header, fields]) => ({
            header,
            fields,
        })));
        this.vm$ = combineLatest([this._store.state$, this.translate$]).pipe(map(([state, translate]) => ({
            state,
            translate,
        })));
        this.Methods = Methods;
    }
    open(method, selectedItem) {
        const data = {
            selectedItem: {
                ...selectedItem,
                member_entity_type_id: selectedItem?.member_entity_type_id?.toString(),
                gender_id: selectedItem?.gender_id?.toString(),
            },
            method,
            config: this._formConfig,
            isReadonly: this.isReadonly,
        };
        this._modalService
            .open(MemberBIPSEntryDialogComponent, {
            data,
            size: ModalSizes.L,
            injector: this._injector,
        })
            .pipe(take(1), tap((res) => {
            if (!res)
                return;
            // const { method, data } = res;
            // if (method === Methods.PUT) {
            // 	this._store.put({
            // 		...selectedItem,
            // 		...(data as ICompanyDirector),
            // 	});
            // } else if (method === Methods.DELETE) {
            // 	selectedItem && this.remove(selectedItem);
            // }
        }))
            .subscribe();
    }
    action(res, method) {
        if (method === Methods.PUT || method === Methods.GET) {
            this.open(method, res);
        }
        else if (method === Methods.DELETE) {
            // this.remove(res);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberBIPSComponent, deps: [{ token: FORM_CONFIG_TOKEN$1 }, { token: GRID_CONFIG_TOKEN }, { token: STORE_TOKEN$2 }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: MODAL_SERVICE }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: MemberBIPSComponent, selector: "fsw-member-bips", inputs: { applicationId: "applicationId", memberId: "memberId", isReadonly: "isReadonly" }, providers: [
            {
                provide: TRANSLOCO_SCOPE,
                useValue: {
                    scope: 'member-bips',
                    loader: TRANSLATION_LOADER$3,
                },
            },
        ], ngImport: i0, template: `
		<ng-container *ngIf="vm$ | async as vm">
			<header class="mt-4 mb-4">
				<h6>{{ vm.translate.header.title }}</h6>
			</header>
			<fsw-member-bips-grid
				[applicationId]="vm.state.applicationId"
				[memberId]="vm.state.memberId"
				[isReadonly]="isReadonly"
				(action)="action($event.res, $event.method)"
			></fsw-member-bips-grid>
		</ng-container>
	`, isInline: true, styles: [".mt-4{margin-top:16px}.mb-4{margin-bottom:16px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: MemberBIPSGridComponent, selector: "fsw-member-bips-grid", inputs: ["applicationId", "memberId", "isReadonly"], outputs: ["action"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberBIPSComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-member-bips', template: `
		<ng-container *ngIf="vm$ | async as vm">
			<header class="mt-4 mb-4">
				<h6>{{ vm.translate.header.title }}</h6>
			</header>
			<fsw-member-bips-grid
				[applicationId]="vm.state.applicationId"
				[memberId]="vm.state.memberId"
				[isReadonly]="isReadonly"
				(action)="action($event.res, $event.method)"
			></fsw-member-bips-grid>
		</ng-container>
	`, changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        {
                            provide: TRANSLOCO_SCOPE,
                            useValue: {
                                scope: 'member-bips',
                                loader: TRANSLATION_LOADER$3,
                            },
                        },
                    ], styles: [".mt-4{margin-top:16px}.mb-4{margin-bottom:16px}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FORM_CONFIG_TOKEN$1]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [GRID_CONFIG_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [STORE_TOKEN$2]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_SERVICE]
                }] }, { type: i0.Injector }]; }, propDecorators: { applicationId: [{
                type: Input
            }], memberId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

const SG_PROVIDERS$1 = [
    {
        provide: FORM_CONFIG_TOKEN$1,
        useValue: SG_FORM_CONFIG$1,
    },
    {
        provide: GRID_CONFIG_TOKEN,
        useValue: SG_GRID_CONFIG,
    },
    {
        provide: STORE_TOKEN$2,
        useClass: SGCompanyDirectorStore,
        deps: [APPLICATION_MEMBER_BIP_SERVICE_TOKEN],
    },
];

const ID_PROVIDERS$3 = [
    {
        provide: FORM_CONFIG_TOKEN$1,
        useValue: ID_FORM_CONFIG$1,
    },
    {
        provide: GRID_CONFIG_TOKEN,
        useValue: ID_GRID_CONFIG,
    },
    {
        provide: STORE_TOKEN$2,
        useClass: IDCompanyDirectorStore,
        deps: [APPLICATION_MEMBER_BIP_SERVICE_TOKEN],
    },
];

const PROVIDERS_MAP$3 = {
    default: SG_PROVIDERS$1,
    [CountryCode.SG]: SG_PROVIDERS$1,
    [CountryCode.ID]: ID_PROVIDERS$3,
};
const memberBIPSLoadProviders = (countryCode) => [
    ...getCustomProviders(PROVIDERS_MAP$3, SG_PROVIDERS$1, countryCode),
];

class MemberBIPSModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberBIPSModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: MemberBIPSModule, declarations: [MemberBIPSComponent], imports: [CommonModule,
            FSWGridModule,
            LetDirective,
            FSWModalModule,
            UtilsServiceModule,
            MemberBIPServiceModule,
            MemberBIPSGridModule,
            MemberBIPSEntryDialogModule], exports: [MemberBIPSComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberBIPSModule, providers: [...memberBIPSLoadProviders(getCountryCodeFromStorage())], imports: [CommonModule,
            FSWGridModule,
            FSWModalModule,
            UtilsServiceModule,
            MemberBIPServiceModule,
            MemberBIPSGridModule,
            MemberBIPSEntryDialogModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberBIPSModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FSWGridModule,
                        LetDirective,
                        FSWModalModule,
                        UtilsServiceModule,
                        MemberBIPServiceModule,
                        MemberBIPSGridModule,
                        MemberBIPSEntryDialogModule,
                    ],
                    declarations: [MemberBIPSComponent],
                    exports: [MemberBIPSComponent],
                    providers: [...memberBIPSLoadProviders(getCountryCodeFromStorage())],
                }]
        }] });

let MemberDetailStore = class MemberDetailStore extends ComponentStore {
    constructor(_memberService, _masterDataService, _settingsService, _stateOverride = {}) {
        super({
            countryCode: null,
            applicationId: null,
            memberId: null,
            member: null,
            referenceData: {
                genders: [],
                identityCardTypes: [],
                provinces: [],
                maritalStatuses: [],
                countries: [],
                companyEntityTypes: [],
                settings: null,
                industries: [],
                religions: [],
            },
            errors: [],
            // isFormSaved: false,
            ..._stateOverride,
        });
        this._memberService = _memberService;
        this._masterDataService = _masterDataService;
        this._settingsService = _settingsService;
        this._stateOverride = _stateOverride;
        this.setApplicationId = this.updater((state, applicationId) => {
            return { ...state, applicationId };
        });
        this.setMemberId = this.updater((state, memberId) => {
            return { ...state, memberId };
        });
        this.setMember = this.updater((state, member) => {
            return { ...state, member };
        });
        this.setReferenceData = this.updater((state, referenceData) => {
            return { ...state, referenceData };
        });
        this.setErrors = this.updater((state, errors) => {
            return { ...state, errors };
        });
        this.getMember = this.effect(pipe(switchMap(() => this._getMemberAsync())));
        this.updateMember = this.effect(pipe(switchMap(({ member }) => this._updateMemberAsync(member))));
        this.getReferenceData = this.effect(pipe(switchMap(() => this._getReferenceDataAsync())));
        this.saveChanges = this.effect(pipe(tap(({ member }) => {
            if (this.get().memberId) {
                this.updateMember({ member });
            }
            else {
                throw new Error('No applicationId exists');
            }
        })));
    }
    _getMemberAsync() {
        if (!isStringValid(this.state().applicationId))
            return EMPTY;
        return this._memberService
            .getMember(this.state().memberId, {
            country_code: this.state().countryCode,
            member_type_code: MemberCode.BORROWER,
        })
            .pipe(tap((member) => this.setMember(member)), catchError((err) => {
            console.error(err);
            this.setErrors([
                ...this.state().errors,
                `Error: [GET]: v2/members/${this.state().memberId}`,
            ]);
            return EMPTY;
        }));
    }
    _updateMemberAsync(payload) {
        if (!isStringValid(this.state().memberId))
            return EMPTY;
        return this._memberService.updateMember(this.state().memberId, payload).pipe(switchMap(() => this._getMemberAsync()), catchError((err) => {
            console.error(err);
            this.setErrors([...this.state().errors, `Error: [PUT]: v2/members/${payload?.id}`]);
            return EMPTY;
        }));
    }
    _getReferenceDataAsync() {
        return forkJoin({
            genders: this._masterDataService.getGenders(),
            identityCardTypes: this._masterDataService.getIdentityCardTypes(),
            provinces: this._masterDataService.getProvinces(),
            maritalStatuses: this._masterDataService.getMaritalStatuses(),
            countries: this._masterDataService.getCountries(),
            companyEntityTypes: this._masterDataService.getCompanyEntityTypes(),
            settings: this._settingsService.getSettings(),
            industries: this._masterDataService.getIndustries(),
            religions: this._masterDataService.getReligions(),
        }).pipe(tap(({ genders, identityCardTypes, provinces, maritalStatuses, countries, companyEntityTypes, settings, industries, religions, }) => {
            this.setReferenceData({
                genders,
                identityCardTypes,
                provinces,
                maritalStatuses,
                countries,
                companyEntityTypes,
                settings,
                industries,
                religions,
            });
        }), catchError((err) => {
            console.error(err);
            this.setErrors([...this.state().errors, `Error: [GET]: /aps/v1/settings`]);
            return EMPTY;
        }));
    }
};
MemberDetailStore = __decorate([
    __param(0, Inject(MEMBER_SERVICE_TOKEN)),
    __param(1, Inject(MASTER_DATA_SERVICE_TOKEN)),
    __param(2, Inject(SETTINGS_SERVICE_TOKEN)),
    __metadata("design:paramtypes", [Object, Object, Object, Object])
], MemberDetailStore);

class IDMemberDetailStore extends MemberDetailStore {
    constructor(_memberService, _masterDataService, _settingsService) {
        super(_memberService, _masterDataService, _settingsService, { countryCode: CountryCode.ID });
        this._memberService = _memberService;
        this._masterDataService = _masterDataService;
        this._settingsService = _settingsService;
    }
    init() {
        this.getMember();
        this.getReferenceData();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDMemberDetailStore, deps: [{ token: MEMBER_SERVICE_TOKEN }, { token: MASTER_DATA_SERVICE_TOKEN }, { token: SETTINGS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDMemberDetailStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDMemberDetailStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MASTER_DATA_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SETTINGS_SERVICE_TOKEN]
                }] }]; } });

class SGMemberDetailStore extends MemberDetailStore {
    constructor(_memberService, _masterDataService, _settingsService) {
        super(_memberService, _masterDataService, _settingsService, { countryCode: CountryCode.SG });
        this._memberService = _memberService;
        this._masterDataService = _masterDataService;
        this._settingsService = _settingsService;
    }
    init() {
        this.getMember();
        this.getReferenceData();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SGMemberDetailStore, deps: [{ token: MEMBER_SERVICE_TOKEN }, { token: MASTER_DATA_SERVICE_TOKEN }, { token: SETTINGS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SGMemberDetailStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SGMemberDetailStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MASTER_DATA_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SETTINGS_SERVICE_TOKEN]
                }] }]; } });

const STORE_TOKEN$1 = new InjectionToken('STORE_TOKEN');

var FormKeys;
(function (FormKeys) {
    // individual
    FormKeys["MEMBER_ENTITY_TYPE_ID"] = "member_entity_type_id";
    FormKeys["BIRTH_DATE"] = "birth_date";
    FormKeys["FULL_NAME"] = "fullname";
    FormKeys["BIRTH_PLACE"] = "birth_place";
    FormKeys["USERNAME"] = "username";
    FormKeys["ADDRESS_1"] = "address_1";
    FormKeys["GENDER_ID"] = "gender_id";
    FormKeys["ADDRESS_2"] = "address_2";
    FormKeys["MOBILE_PHONE_NUMBER"] = "mobile_phone_number";
    FormKeys["AREA"] = "area";
    FormKeys["IC_TYPE_ID"] = "ic_type_id";
    FormKeys["DISTRICT"] = "district";
    FormKeys["IC_NUMBER"] = "ic_number";
    FormKeys["STATE_ID"] = "state_id";
    FormKeys["TAX_CARD_NUMBER"] = "tax_card_number";
    FormKeys["ZIP_CODE"] = "zip_code";
    FormKeys["RELIGION"] = "religion_code";
    FormKeys["MARITAL_STATUS_ID"] = "marital_status_id";
    FormKeys["COUNTRY_CODE"] = "country_code";
    // spouse
    FormKeys["SPOUSE_FULLNAME"] = "spouse_fullname";
    FormKeys["SPOUSE_BIRTH_PLACE"] = "spouse_birth_place";
    FormKeys["SPOUSE_ID_CARD_TYPE"] = "spouse_id_card_type";
    FormKeys["SPOUSE_MOBILE_PHONE_NUMBER"] = "spouse_mobile_phone_number";
    FormKeys["SPOUSE_IC_NUMBER"] = "spouse_ic_number";
    FormKeys["SPOUSE_BIRTH_DATE"] = "spouse_birth_date";
    // company
    FormKeys["NIB"] = "nib";
    FormKeys["COMPANY_NAME"] = "company_name";
    FormKeys["SKDP"] = "skdp";
    FormKeys["COMPANY_ENTITY_TYPE_ID"] = "company_entity_type_id";
    FormKeys["TDP"] = "tdp";
    FormKeys["ADDRESS_TYPE"] = "address_type";
    FormKeys["COMPANY_INDUSTRY_ID"] = "company_industry_id";
    FormKeys["COMPANY_ADDRESS_1"] = "company_address_1";
    FormKeys["COMPANY_PHONE_NUMBER"] = "company_phone_number";
    FormKeys["COMPANY_ADDRESS_2"] = "company_address_2";
    FormKeys["COMPANY_REGISTRATION_NUMBER"] = "company_registration_number";
    FormKeys["COMPANY_AREA"] = "company_area";
    FormKeys["COMPANY_TAX_NUMBER"] = "company_tax_number";
    FormKeys["DEED_CERTIFICATE_NUMBER"] = "deed_certificate_number";
    FormKeys["COMPANY_DISTRICT"] = "company_district";
    FormKeys["DATE_OF_CERTIFICATE"] = "date_of_certificate";
    FormKeys["COMPANY_STATE_ID"] = "company_state_id";
    FormKeys["COMPANY_BIRTH_DATE"] = "company_birth_date";
    FormKeys["COMPANY_COUNTRY_CODE"] = "company_country_code";
    FormKeys["COMPANY_ZIP_CODE"] = "company_zip_code";
})(FormKeys || (FormKeys = {}));

const renderObjFunc$1 = (renderObj, records) => {
    records = records.filter(({ key }) => !!renderObj[key]);
    if (!records.length)
        return undefined;
    const rec = records.reduce((acc, { key, fields }) => {
        const item = renderObj[key];
        return acc.concat(item(fields));
    }, []);
    return rec;
};
const getIndividualFormFields$1 = (translate, formData, referenceData, context) => [
    {
        type: FIELD_TYPE.RADIO,
        key: FormKeys.MEMBER_ENTITY_TYPE_ID,
        label: translate && translate[FormKeys.MEMBER_ENTITY_TYPE_ID],
        param: [
            { value: formData && formData[FormKeys.MEMBER_ENTITY_TYPE_ID], disabled: false },
            Validators.required,
        ],
        options: MEMBER_ENTITY_TYPE_ID_OPTIONS,
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, MEMBER_ENTITY_TYPE_ID_OPTIONS),
        },
    },
    {
        type: FIELD_TYPE.DATE,
        key: FormKeys.BIRTH_DATE,
        label: translate && translate[FormKeys.BIRTH_DATE],
        param: [
            { value: formData && formData[FormKeys.BIRTH_DATE], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.FULL_NAME,
        label: translate && translate[FormKeys.FULL_NAME],
        param: [
            { value: formData && formData[FormKeys.FULL_NAME], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.BIRTH_PLACE,
        label: translate && translate[FormKeys.BIRTH_PLACE],
        param: [
            { value: formData && formData[FormKeys.BIRTH_PLACE], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.USERNAME,
        label: translate && translate[FormKeys.USERNAME],
        param: [
            { value: formData && formData[FormKeys.USERNAME], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.ADDRESS_1,
        label: translate && translate[FormKeys.ADDRESS_1],
        param: [
            { value: formData && formData[FormKeys.ADDRESS_1], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.RADIO,
        key: FormKeys.GENDER_ID,
        label: translate && translate[FormKeys.GENDER_ID],
        param: [
            { value: formData && formData[FormKeys.GENDER_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.genders.map((g) => ({ value: g.id, label: g.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData ? referenceData.genders.map((g) => ({ value: g.id, label: g.name })) : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.ADDRESS_2,
        label: translate && translate[FormKeys.ADDRESS_2],
        param: [
            { value: formData && formData[FormKeys.ADDRESS_2], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.MOBILE_PHONE_NUMBER,
        label: translate && translate[FormKeys.MOBILE_PHONE_NUMBER],
        param: [
            { value: formData && formData[FormKeys.MOBILE_PHONE_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.AREA,
        label: translate && translate[FormKeys.AREA],
        param: [{ value: formData && formData[FormKeys.AREA], disabled: false }, Validators.required],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys.IC_TYPE_ID,
        label: translate && translate[FormKeys.IC_TYPE_ID],
        param: [
            { value: formData && formData[FormKeys.IC_TYPE_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.identityCardTypes.map((i) => ({ value: i.id, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.identityCardTypes.map((i) => ({ value: i.id, label: i.name }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.DISTRICT,
        label: translate && translate[FormKeys.DISTRICT],
        param: [
            { value: formData && formData[FormKeys.DISTRICT], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.IC_NUMBER,
        label: translate && translate[FormKeys.IC_NUMBER],
        param: [
            { value: formData && formData[FormKeys.IC_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys.STATE_ID,
        label: translate && translate[FormKeys.STATE_ID],
        param: [
            { value: formData && formData[FormKeys.STATE_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.provinces.map((i) => ({ value: i.id, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData ? referenceData.provinces.map((i) => ({ value: i.id, label: i.name })) : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.TAX_CARD_NUMBER,
        label: translate && translate[FormKeys.TAX_CARD_NUMBER],
        param: [
            { value: formData && formData[FormKeys.TAX_CARD_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.ZIP_CODE,
        label: translate && translate[FormKeys.ZIP_CODE],
        param: [
            { value: formData && formData[FormKeys.ZIP_CODE], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys.RELIGION,
        label: translate && translate[FormKeys.RELIGION],
        param: [
            { value: formData && formData[FormKeys.RELIGION], disabled: false },
            Validators.required,
        ],
        options: referenceData?.religions?.map((i) => ({ value: i.code, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.religions?.map((i) => ({ value: i.code, label: i.name }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys.MARITAL_STATUS_ID,
        label: translate && translate[FormKeys.MARITAL_STATUS_ID],
        param: [
            { value: formData && formData[FormKeys.MARITAL_STATUS_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.maritalStatuses.map((i) => ({ value: i.id, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.maritalStatuses.map((i) => ({ value: i.id, label: i.name }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys.COUNTRY_CODE,
        label: translate && translate[FormKeys.COUNTRY_CODE],
        param: [
            { value: formData && formData[FormKeys.COUNTRY_CODE], disabled: false },
            Validators.required,
        ],
        options: referenceData?.countries.map((i) => ({ value: i.code, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.countries.map((i) => ({ value: i.code, label: i.name }))
                : []),
            ...context,
        },
    },
];
const getCompanyFormFields$1 = (translate, formData, referenceData, context) => [
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.NIB,
        label: translate && translate[FormKeys.NIB],
        param: [
            { value: null, disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.COMPANY_NAME,
        label: translate && translate[FormKeys.COMPANY_NAME],
        param: [
            { value: formData && formData[FormKeys.COMPANY_NAME], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.SKDP,
        label: translate && translate[FormKeys.SKDP],
        param: [
            { value: null, disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys.COMPANY_ENTITY_TYPE_ID,
        label: translate && translate[FormKeys.COMPANY_ENTITY_TYPE_ID],
        param: [
            { value: formData && formData[FormKeys.COMPANY_ENTITY_TYPE_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.companyEntityTypes.map((i) => ({ value: i.id, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.companyEntityTypes.map((i) => ({ value: i.id, label: i.name }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.TDP,
        label: translate && translate[FormKeys.TDP],
        param: [
            { value: null, disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.USERNAME,
        label: translate && translate[FormKeys.USERNAME],
        param: [
            { value: formData && formData[FormKeys.USERNAME], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys.ADDRESS_TYPE,
        label: translate && translate[FormKeys.ADDRESS_TYPE],
        param: [
            { value: null, disabled: false },
            Validators.required,
        ],
        options: referenceData?.settings?.address_type.map((i) => ({ value: i, label: i })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData && referenceData.settings
                ? referenceData.settings.address_type.map((i) => ({
                    value: i,
                    label: i,
                }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys.COMPANY_INDUSTRY_ID,
        label: translate && translate[FormKeys.COMPANY_INDUSTRY_ID],
        param: [
            { value: formData && formData[FormKeys.COMPANY_INDUSTRY_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.industries.map((i) => ({
            value: i.id,
            label: i.name, //  i.id_name || i.en_name ||
        })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.industries.map((i) => ({
                    value: i.id,
                    label: i.name, // i.id_name || i.en_name ||
                }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.COMPANY_ADDRESS_1,
        label: translate && translate[FormKeys.COMPANY_ADDRESS_1],
        param: [
            { value: formData && formData[FormKeys.COMPANY_ADDRESS_1], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.COMPANY_PHONE_NUMBER,
        label: translate && translate[FormKeys.COMPANY_PHONE_NUMBER],
        param: [
            { value: formData && formData[FormKeys.COMPANY_PHONE_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.COMPANY_ADDRESS_2,
        label: translate && translate[FormKeys.COMPANY_ADDRESS_2],
        param: [
            { value: formData && formData[FormKeys.COMPANY_ADDRESS_2], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.COMPANY_REGISTRATION_NUMBER,
        label: translate && translate[FormKeys.COMPANY_REGISTRATION_NUMBER],
        param: [
            { value: formData && formData[FormKeys.COMPANY_REGISTRATION_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.COMPANY_AREA,
        label: translate && translate[FormKeys.COMPANY_AREA],
        param: [
            { value: formData && formData[FormKeys.COMPANY_AREA], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.TAX_CARD_NUMBER,
        label: translate && translate[FormKeys.TAX_CARD_NUMBER],
        param: [
            { value: formData && formData[FormKeys.TAX_CARD_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.DEED_CERTIFICATE_NUMBER,
        label: translate && translate[FormKeys.DEED_CERTIFICATE_NUMBER],
        param: [
            { value: formData && formData[FormKeys.DEED_CERTIFICATE_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.COMPANY_DISTRICT,
        label: translate && translate[FormKeys.COMPANY_DISTRICT],
        param: [
            { value: formData && formData[FormKeys.COMPANY_DISTRICT], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.DATE,
        key: FormKeys.DATE_OF_CERTIFICATE,
        label: translate && translate[FormKeys.DATE_OF_CERTIFICATE],
        param: [
            { value: null, disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys.COMPANY_STATE_ID,
        label: translate && translate[FormKeys.COMPANY_STATE_ID],
        param: [
            { value: formData && formData[FormKeys.COMPANY_STATE_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.provinces.map((i) => ({ value: i.id, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData ? referenceData.provinces.map((i) => ({ value: i.id, label: i.name })) : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.DATE,
        key: FormKeys.COMPANY_BIRTH_DATE,
        label: translate && translate[FormKeys.COMPANY_BIRTH_DATE],
        param: [
            { value: formData && formData[FormKeys.COMPANY_BIRTH_DATE], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys.COMPANY_COUNTRY_CODE,
        label: translate && translate[FormKeys.COMPANY_COUNTRY_CODE],
        param: [
            { value: formData && formData[FormKeys.COMPANY_COUNTRY_CODE], disabled: false },
            Validators.required,
        ],
        options: referenceData?.countries.map((i) => ({ value: i.code, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.countries.map((i) => ({ value: i.code, label: i.name }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.COMPANY_ZIP_CODE,
        label: translate && translate[FormKeys.COMPANY_ZIP_CODE],
        param: [
            { value: formData && formData[FormKeys.COMPANY_ZIP_CODE], disabled: false },
            Validators.required,
        ],
        context,
    },
];
const getSpouseFormFields$1 = (translate, formData, referenceData, context) => [
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.SPOUSE_FULLNAME,
        label: translate && translate[FormKeys.SPOUSE_FULLNAME],
        param: [
            { value: formData && formData[FormKeys.SPOUSE_FULLNAME], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.SPOUSE_BIRTH_PLACE,
        label: translate && translate[FormKeys.SPOUSE_BIRTH_PLACE],
        param: [
            { value: formData && formData[FormKeys.SPOUSE_BIRTH_PLACE], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys.SPOUSE_ID_CARD_TYPE,
        label: translate && translate[FormKeys.SPOUSE_ID_CARD_TYPE],
        param: [
            { value: null, disabled: false },
            Validators.required,
        ],
        options: referenceData?.identityCardTypes.map((i) => ({ value: i.id, label: i.name })),
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.SPOUSE_IC_NUMBER,
        label: translate && translate[FormKeys.SPOUSE_IC_NUMBER],
        param: [
            { value: formData && formData[FormKeys.SPOUSE_IC_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.DATE,
        key: FormKeys.SPOUSE_BIRTH_DATE,
        label: translate && translate[FormKeys.SPOUSE_BIRTH_DATE],
        param: [
            { value: formData && formData[FormKeys.SPOUSE_BIRTH_DATE], disabled: false },
            Validators.required,
        ],
        context,
    },
];
const getAllFormFields$1 = (translate, formData, referenceData, renderObj) => [
    ...getIndividualFormFields$1(translate, formData, referenceData, {
        customRender: renderObjFunc$1(renderObj, [{ key: 'member-detail-individual-entity-change' }]),
    }),
    ...getSpouseFormFields$1(translate, formData, referenceData, {
        customRender: renderObjFunc$1(renderObj, [{ key: 'member-detail-marital-status-change' }]),
    }),
    ...getCompanyFormFields$1(translate, formData, referenceData, {
        customRender: renderObjFunc$1(renderObj, [{ key: 'member-detail-company-entity-change' }]),
    }),
];
const ID_FORM_CONFIG = {
    setup(translate, formData, referenceData, isReadonly, renderObj) {
        return {
            formFields: getAllFormFields$1(translate, formData, referenceData, renderObj),
            formData,
            formFieldConfig: {
                hideAllCTAs: isReadonly,
            },
        };
    },
    getValue(form, formData) {
        return {
            ...formData,
            ...form.value,
        };
    },
};

const renderObjFunc = (renderObj, records) => {
    records = records.filter(({ key }) => !!renderObj[key]);
    if (!records.length)
        return undefined;
    const rec = records.reduce((acc, { key, fields }) => {
        const item = renderObj[key];
        return acc.concat(item(fields));
    }, []);
    return rec;
};
const getIndividualFormFields = (translate, formData, referenceData, context) => [
    {
        type: FIELD_TYPE.RADIO,
        key: FormKeys.MEMBER_ENTITY_TYPE_ID,
        label: translate && translate[FormKeys.MEMBER_ENTITY_TYPE_ID],
        param: [
            { value: formData && formData[FormKeys.MEMBER_ENTITY_TYPE_ID], disabled: false },
            Validators.required,
        ],
        options: MEMBER_ENTITY_TYPE_ID_OPTIONS,
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, MEMBER_ENTITY_TYPE_ID_OPTIONS),
        },
    },
    {
        type: FIELD_TYPE.DATE,
        key: FormKeys.BIRTH_DATE,
        label: translate && translate[FormKeys.BIRTH_DATE],
        param: [
            { value: formData && formData[FormKeys.BIRTH_DATE], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.FULL_NAME,
        label: translate && translate[FormKeys.FULL_NAME],
        param: [
            { value: formData && formData[FormKeys.FULL_NAME], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.BIRTH_PLACE,
        label: translate && translate[FormKeys.BIRTH_PLACE],
        param: [
            { value: formData && formData[FormKeys.BIRTH_PLACE], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.USERNAME,
        label: translate && translate[FormKeys.USERNAME],
        param: [
            { value: formData && formData[FormKeys.USERNAME], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.ADDRESS_1,
        label: translate && translate[FormKeys.ADDRESS_1],
        param: [
            { value: formData && formData[FormKeys.ADDRESS_1], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.RADIO,
        key: FormKeys.GENDER_ID,
        label: translate && translate[FormKeys.GENDER_ID],
        param: [
            { value: formData && formData[FormKeys.GENDER_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.genders.map((g) => ({ value: g.id, label: g.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData ? referenceData.genders.map((g) => ({ value: g.id, label: g.name })) : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.ADDRESS_2,
        label: translate && translate[FormKeys.ADDRESS_2],
        param: [
            { value: formData && formData[FormKeys.ADDRESS_2], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.MOBILE_PHONE_NUMBER,
        label: translate && translate[FormKeys.MOBILE_PHONE_NUMBER],
        param: [
            { value: formData && formData[FormKeys.MOBILE_PHONE_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.AREA,
        label: translate && translate[FormKeys.AREA],
        param: [{ value: formData && formData[FormKeys.AREA], disabled: false }, Validators.required],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys.IC_TYPE_ID,
        label: translate && translate[FormKeys.IC_TYPE_ID],
        param: [
            { value: formData && formData[FormKeys.IC_TYPE_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.identityCardTypes.map((i) => ({ value: i.id, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.identityCardTypes.map((i) => ({ value: i.id, label: i.name }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.DISTRICT,
        label: translate && translate[FormKeys.DISTRICT],
        param: [
            { value: formData && formData[FormKeys.DISTRICT], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.IC_NUMBER,
        label: translate && translate[FormKeys.IC_NUMBER],
        param: [
            { value: formData && formData[FormKeys.IC_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys.STATE_ID,
        label: translate && translate[FormKeys.STATE_ID],
        param: [
            { value: formData && formData[FormKeys.STATE_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.provinces.map((i) => ({ value: i.id, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData ? referenceData.provinces.map((i) => ({ value: i.id, label: i.name })) : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.TAX_CARD_NUMBER,
        label: translate && translate[FormKeys.TAX_CARD_NUMBER],
        param: [
            { value: formData && formData[FormKeys.TAX_CARD_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.ZIP_CODE,
        label: translate && translate[FormKeys.ZIP_CODE],
        param: [
            { value: formData && formData[FormKeys.ZIP_CODE], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys.RELIGION,
        label: translate && translate[FormKeys.RELIGION],
        param: [
            { value: formData && formData[FormKeys.RELIGION], disabled: false },
            Validators.required,
        ],
        options: referenceData?.religions?.map((i) => ({ value: i.code, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.religions?.map((i) => ({ value: i.code, label: i.name }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys.MARITAL_STATUS_ID,
        label: translate && translate[FormKeys.MARITAL_STATUS_ID],
        param: [
            { value: formData && formData[FormKeys.MARITAL_STATUS_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.maritalStatuses.map((i) => ({ value: i.id, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.maritalStatuses.map((i) => ({ value: i.id, label: i.name }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys.COUNTRY_CODE,
        label: translate && translate[FormKeys.COUNTRY_CODE],
        param: [
            { value: formData && formData[FormKeys.COUNTRY_CODE], disabled: false },
            Validators.required,
        ],
        options: referenceData?.countries.map((i) => ({ value: i.code, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.countries.map((i) => ({ value: i.code, label: i.name }))
                : []),
            ...context,
        },
    },
];
const getCompanyFormFields = (translate, formData, referenceData, context) => [
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.NIB,
        label: translate && translate[FormKeys.NIB],
        param: [
            { value: null, disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.COMPANY_NAME,
        label: translate && translate[FormKeys.COMPANY_NAME],
        param: [
            { value: formData && formData[FormKeys.COMPANY_NAME], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.SKDP,
        label: translate && translate[FormKeys.SKDP],
        param: [
            { value: null, disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys.COMPANY_ENTITY_TYPE_ID,
        label: translate && translate[FormKeys.COMPANY_ENTITY_TYPE_ID],
        param: [
            { value: formData && formData[FormKeys.COMPANY_ENTITY_TYPE_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.companyEntityTypes.map((i) => ({ value: i.id, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.companyEntityTypes.map((i) => ({ value: i.id, label: i.name }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.TDP,
        label: translate && translate[FormKeys.TDP],
        param: [
            { value: null, disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.USERNAME,
        label: translate && translate[FormKeys.USERNAME],
        param: [
            { value: formData && formData[FormKeys.USERNAME], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys.ADDRESS_TYPE,
        label: translate && translate[FormKeys.ADDRESS_TYPE],
        param: [
            { value: null, disabled: false },
            Validators.required,
        ],
        options: referenceData?.settings?.address_type.map((i) => ({ value: i, label: i })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData && referenceData.settings
                ? referenceData.settings.address_type.map((i) => ({
                    value: i,
                    label: i,
                }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys.COMPANY_INDUSTRY_ID,
        label: translate && translate[FormKeys.COMPANY_INDUSTRY_ID],
        param: [
            { value: formData && formData[FormKeys.COMPANY_INDUSTRY_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.industries.map((i) => ({
            value: i.id,
            label: i.name, //  i.id_name || i.en_name ||
        })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.industries.map((i) => ({
                    value: i.id,
                    label: i.name, // i.id_name || i.en_name ||
                }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.COMPANY_ADDRESS_1,
        label: translate && translate[FormKeys.COMPANY_ADDRESS_1],
        param: [
            { value: formData && formData[FormKeys.COMPANY_ADDRESS_1], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.COMPANY_PHONE_NUMBER,
        label: translate && translate[FormKeys.COMPANY_PHONE_NUMBER],
        param: [
            { value: formData && formData[FormKeys.COMPANY_PHONE_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.COMPANY_ADDRESS_2,
        label: translate && translate[FormKeys.COMPANY_ADDRESS_2],
        param: [
            { value: formData && formData[FormKeys.COMPANY_ADDRESS_2], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.COMPANY_REGISTRATION_NUMBER,
        label: translate && translate[FormKeys.COMPANY_REGISTRATION_NUMBER],
        param: [
            { value: formData && formData[FormKeys.COMPANY_REGISTRATION_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.COMPANY_AREA,
        label: translate && translate[FormKeys.COMPANY_AREA],
        param: [
            { value: formData && formData[FormKeys.COMPANY_AREA], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.TAX_CARD_NUMBER,
        label: translate && translate[FormKeys.TAX_CARD_NUMBER],
        param: [
            { value: formData && formData[FormKeys.TAX_CARD_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.DEED_CERTIFICATE_NUMBER,
        label: translate && translate[FormKeys.DEED_CERTIFICATE_NUMBER],
        param: [
            { value: formData && formData[FormKeys.DEED_CERTIFICATE_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.COMPANY_DISTRICT,
        label: translate && translate[FormKeys.COMPANY_DISTRICT],
        param: [
            { value: formData && formData[FormKeys.COMPANY_DISTRICT], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.DATE,
        key: FormKeys.DATE_OF_CERTIFICATE,
        label: translate && translate[FormKeys.DATE_OF_CERTIFICATE],
        param: [
            { value: null, disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys.COMPANY_STATE_ID,
        label: translate && translate[FormKeys.COMPANY_STATE_ID],
        param: [
            { value: formData && formData[FormKeys.COMPANY_STATE_ID], disabled: false },
            Validators.required,
        ],
        options: referenceData?.provinces.map((i) => ({ value: i.id, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData ? referenceData.provinces.map((i) => ({ value: i.id, label: i.name })) : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.DATE,
        key: FormKeys.COMPANY_BIRTH_DATE,
        label: translate && translate[FormKeys.COMPANY_BIRTH_DATE],
        param: [
            { value: formData && formData[FormKeys.COMPANY_BIRTH_DATE], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys.COMPANY_COUNTRY_CODE,
        label: translate && translate[FormKeys.COMPANY_COUNTRY_CODE],
        param: [
            { value: formData && formData[FormKeys.COMPANY_COUNTRY_CODE], disabled: false },
            Validators.required,
        ],
        options: referenceData?.countries.map((i) => ({ value: i.code, label: i.name })),
        context: {
            inline: true,
            template: (value) => getOptionLabel(value, referenceData
                ? referenceData.countries.map((i) => ({ value: i.code, label: i.name }))
                : []),
            ...context,
        },
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.COMPANY_ZIP_CODE,
        label: translate && translate[FormKeys.COMPANY_ZIP_CODE],
        param: [
            { value: formData && formData[FormKeys.COMPANY_ZIP_CODE], disabled: false },
            Validators.required,
        ],
        context,
    },
];
const getSpouseFormFields = (translate, formData, referenceData, context) => [
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.SPOUSE_FULLNAME,
        label: translate && translate[FormKeys.SPOUSE_FULLNAME],
        param: [
            { value: formData && formData[FormKeys.SPOUSE_FULLNAME], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.SPOUSE_BIRTH_PLACE,
        label: translate && translate[FormKeys.SPOUSE_BIRTH_PLACE],
        param: [
            { value: formData && formData[FormKeys.SPOUSE_BIRTH_PLACE], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.SELECT,
        key: FormKeys.SPOUSE_ID_CARD_TYPE,
        label: translate && translate[FormKeys.SPOUSE_ID_CARD_TYPE],
        param: [
            { value: null, disabled: false },
            Validators.required,
        ],
        options: referenceData?.identityCardTypes.map((i) => ({ value: i.id, label: i.name })),
        context,
    },
    {
        type: FIELD_TYPE.STRING,
        key: FormKeys.SPOUSE_IC_NUMBER,
        label: translate && translate[FormKeys.SPOUSE_IC_NUMBER],
        param: [
            { value: formData && formData[FormKeys.SPOUSE_IC_NUMBER], disabled: false },
            Validators.required,
        ],
        context,
    },
    {
        type: FIELD_TYPE.DATE,
        key: FormKeys.SPOUSE_BIRTH_DATE,
        label: translate && translate[FormKeys.SPOUSE_BIRTH_DATE],
        param: [
            { value: formData && formData[FormKeys.SPOUSE_BIRTH_DATE], disabled: false },
            Validators.required,
        ],
        context,
    },
];
const getAllFormFields = (translate, formData, referenceData, renderObj) => [
    ...getIndividualFormFields(translate, formData, referenceData, {
        customRender: renderObjFunc(renderObj, [{ key: 'member-detail-individual-entity-change' }]),
    }),
    ...getSpouseFormFields(translate, formData, referenceData, {
        customRender: renderObjFunc(renderObj, [{ key: 'member-detail-marital-status-change' }]),
    }),
    ...getCompanyFormFields(translate, formData, referenceData, {
        customRender: renderObjFunc(renderObj, [{ key: 'member-detail-company-entity-change' }]),
    }),
];
const SG_FORM_CONFIG = {
    setup(translate, formData, referenceData, isReadonly, renderObj) {
        return {
            formFields: getAllFormFields(translate, formData, referenceData, renderObj),
            formData,
            formFieldConfig: {
                hideAllCTAs: isReadonly,
            },
        };
    },
    getValue(form, formData) {
        return {
            ...formData,
            ...form.value,
        };
    },
};

const FORM_CONFIG_TOKEN = new InjectionToken('FORM_CONFIG_TOKEN');

const ID_PROVIDERS$2 = [
    {
        provide: FORM_CONFIG_TOKEN,
        useValue: ID_FORM_CONFIG,
    },
    {
        provide: STORE_TOKEN$1,
        useClass: IDMemberDetailStore,
        deps: [MEMBER_SERVICE_TOKEN, MASTER_DATA_SERVICE_TOKEN, SETTINGS_SERVICE_TOKEN],
    },
];

const SG_PROVIDERS = [
    {
        provide: FORM_CONFIG_TOKEN,
        useValue: SG_FORM_CONFIG,
    },
    {
        provide: STORE_TOKEN$1,
        useClass: SGMemberDetailStore,
        deps: [MEMBER_SERVICE_TOKEN, MASTER_DATA_SERVICE_TOKEN, SETTINGS_SERVICE_TOKEN],
    },
];

const PROVIDERS_MAP$2 = {
    default: SG_PROVIDERS,
    [CountryCode.SG]: SG_PROVIDERS,
    [CountryCode.ID]: ID_PROVIDERS$2,
};
const memberDetailLoadProviders = (countryCode) => [
    ...getCustomProviders(PROVIDERS_MAP$2, SG_PROVIDERS, countryCode),
];

var header$7 = {
	title: "Member Details"
};
var form_fields$4 = {
	member_entity_type_id: "Entity Type",
	birth_date: "Date of Birth",
	fullname: "Name",
	birth_place: "Place of Birth",
	username: "Email",
	address_1: "Address Line 1",
	gender_id: "Gender",
	address_2: "Address Line 2",
	mobile_phone_number: "Mobile Number",
	area: "Area",
	ic_type_id: "ID Card Type",
	district: "District",
	ic_number: "ID Card Number",
	state_id: "State Province",
	tax_card_number: "Tax Number",
	zip_code: "Postal Code",
	marital_status_id: "Marital Status",
	country_code: "Country",
	nib: "NIB",
	company_name: "Company Name",
	skdp: "SKDP",
	company_entity_type_id: "Company Type",
	tdp: "TDP",
	address_type: "Address Type",
	company_industry_id: "Company Industry",
	company_address_1: "Company Address Line 1",
	company_phone_number: "Company Phone Number",
	company_address_2: "Company Address Line 2",
	company_registration_number: "Company Registration Number",
	company_area: "Company Area",
	deed_certificate_number: "Deed Certificate Number",
	company_district: "District",
	date_of_certificate: "Date of Certificate / Deed",
	company_state_id: "State Province",
	company_birth_date: "Establishment Date",
	company_country_code: "Country",
	company_zip_code: "Postal Code",
	spouse_fullname: "Spouse Full Name",
	spouse_birth_place: "Spouse Place of Birth",
	spouse_id_card_type: "Spouse ID Card Type",
	spouse_mobile_phone_number: "Spouse Phone Number",
	spouse_ic_number: "Spouse ID Card Number",
	spouse_birth_date: "Spouse Date of Birth"
};
var buttons$v = {
	cancel: "Cancel",
	save_changes: "Save Changes"
};
var sg$2 = {
	header: header$7,
	form_fields: form_fields$4,
	buttons: buttons$v
};

var sg$3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$v,
    default: sg$2,
    form_fields: form_fields$4,
    header: header$7
});

var header$6 = {
	title: "Member Details"
};
var form_fields$3 = {
	member_entity_type_id: "Entity Type",
	birth_date: "Date of Birth",
	fullname: "Name",
	birth_place: "Place of Birth",
	username: "Email",
	address_1: "Address Line 1",
	gender_id: "Gender",
	address_2: "Address Line 2",
	mobile_phone_number: "Mobile Number",
	area: "Area",
	ic_type_id: "ID Card Type",
	district: "District",
	ic_number: "ID Card Number",
	state_id: "State Province",
	tax_card_number: "Tax Number",
	religion_code: "Religion",
	zip_code: "Postal Code",
	marital_status_id: "Marital Status",
	country_code: "Country",
	nib: "NIB",
	company_name: "Company Name",
	skdp: "SKDP",
	company_entity_type_id: "Company Type",
	tdp: "TDP",
	address_type: "Address Type",
	company_industry_id: "Company Industry",
	company_address_1: "Company Address Line 1",
	company_phone_number: "Company Phone Number",
	company_address_2: "Company Address Line 2",
	company_registration_number: "Company Registration Number",
	company_area: "Company Area",
	deed_certificate_number: "Deed Certificate Number",
	company_district: "District",
	date_of_certificate: "Date of Certificate / Deed",
	company_state_id: "State Province",
	company_birth_date: "Establishment Date",
	company_country_code: "Country",
	company_zip_code: "Postal Code",
	spouse_fullname: "Spouse Full Name",
	spouse_birth_place: "Spouse Place of Birth",
	spouse_id_card_type: "Spouse ID Card Type",
	spouse_mobile_phone_number: "Spouse Phone Number",
	spouse_ic_number: "Spouse ID Card Number",
	spouse_birth_date: "Spouse Date of Birth"
};
var buttons$u = {
	cancel: "Cancel",
	save_changes: "Save Changes"
};
var id$4 = {
	header: header$6,
	form_fields: form_fields$3,
	buttons: buttons$u
};

var id$5 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$u,
    default: id$4,
    form_fields: form_fields$3,
    header: header$6
});

const TRANSLATION_LOADER$2 = {
    default: () => Promise.resolve(sg$3),
    [CountryCode.SG]: () => Promise.resolve(sg$3),
    [CountryCode.ID]: () => Promise.resolve(id$5),
};

class MemberDetailComponent {
    set applicationId(value) {
        this._store.setApplicationId(value);
    }
    set memberId(value) {
        this._store.setMemberId(value);
    }
    constructor(_formConfig, _store, _scope, _translateService, _cdr) {
        this._formConfig = _formConfig;
        this._store = _store;
        this._scope = _scope;
        this._translateService = _translateService;
        this._cdr = _cdr;
        this.isReadonly = false;
        this._changeTabStatusSub = new Subject();
        this.changeTabStatus$ = this._changeTabStatusSub.asObservable();
        this.config = null;
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'header'),
            this._translateService.selectFeatureTranslate(this._scope, 'form_fields'),
        ]).pipe(map(([header, form_fields]) => ({
            header,
            form_fields,
        })));
        this.destroy$ = new Subject();
        this.vm$ = combineLatest([this._store.state$, this.translate$.pipe(take(1))]).pipe(map(([state, translate]) => ({
            state,
            translate,
        })), tap(({ state, translate }) => {
            if (state.member)
                this.config = this._formConfig.setup(translate.form_fields, state.member, state.referenceData, this.isReadonly, {
                    'member-detail-individual-entity-change': (fields) => {
                        return [
                            {
                                fields: fields || [
                                    {
                                        key: FormKeys.MEMBER_ENTITY_TYPE_ID,
                                        correctWhenValueIs(value
                                        // formFieldControl: FormFieldControl
                                        ) {
                                            return value?.toString() === '1';
                                        },
                                    },
                                ],
                                cb: (params, condition) => {
                                    if (condition) {
                                        params.renderView();
                                    }
                                    else {
                                        params.clearView();
                                    }
                                },
                            },
                        ];
                    },
                    'member-detail-company-entity-change': (fields) => {
                        return [
                            {
                                fields: fields || [
                                    {
                                        key: FormKeys.MEMBER_ENTITY_TYPE_ID,
                                        correctWhenValueIs(value
                                        // formFieldControl: FormFieldControl
                                        ) {
                                            return value?.toString() === '3';
                                        },
                                    },
                                ],
                                cb: (params, condition) => {
                                    if (condition) {
                                        params.renderView();
                                    }
                                    else {
                                        params.clearView();
                                    }
                                },
                            },
                        ];
                    },
                    'member-detail-marital-status-change': (fields) => {
                        return [
                            {
                                fields: fields || [
                                    {
                                        key: FormKeys.MARITAL_STATUS_ID,
                                        correctWhenValueIs(value
                                        // formFieldControl: FormFieldControl
                                        ) {
                                            return (value?.toString() === '5' ||
                                                (getCountryCodeFromStorage() === CountryCode.SG && value === '4'));
                                        },
                                    },
                                    {
                                        key: FormKeys.MEMBER_ENTITY_TYPE_ID,
                                        correctWhenValueIs(value
                                        // formFieldControl: FormFieldControl
                                        ) {
                                            return value === '1';
                                        },
                                    },
                                ],
                                cb: (params, condition) => {
                                    if (condition) {
                                        params.renderView();
                                    }
                                    else {
                                        params.clearView();
                                    }
                                },
                            },
                        ];
                    },
                });
            this._cdr.markForCheck();
        }));
    }
    ngOnInit() {
        this._store.init();
    }
    ngOnDestroy() {
        this.destroy$.next(0);
        this.destroy$.complete();
    }
    onSubmit(evt) {
        if (!evt.valid) {
            evt.markAllAsTouched();
            return;
        }
        this._store.saveChanges({
            member: {
                ...this._store.state().member,
                ...evt.value,
            },
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberDetailComponent, deps: [{ token: FORM_CONFIG_TOKEN }, { token: STORE_TOKEN$1 }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: MemberDetailComponent, selector: "fsw-member-detail", inputs: { applicationId: "applicationId", memberId: "memberId", isReadonly: "isReadonly" }, providers: [
            {
                provide: TRANSLOCO_SCOPE,
                useValue: {
                    scope: 'member-detail',
                    loader: TRANSLATION_LOADER$2,
                },
            },
        ], ngImport: i0, template: `
    <div class="cbs-form__container" *ngIf="vm$ | async as vm">
      <header>
        <h6>{{ vm.translate.header.title }}</h6>
      </header>
      <div>
        <ng-container *ngIf="vm.state?.errors as errorList">
          <div class="error__message" *ngFor="let errStr of errorList">{{ errStr }}</div>
        </ng-container>
      </div>
      <fsw-form-widget
        #widget
        *ngIf="config"
        [isReadonly]="isReadonly"
        [formConfig]="config"
        (submitForm)="onSubmit($event)"
      ></fsw-form-widget>
    </div>
  `, isInline: true, styles: [".error__message{color:#cc1830;font-size:14px}:host .cbs-form__container{padding:16px;width:50%;display:flex;flex-direction:column;gap:16px;border-radius:4px;border:1px solid #e0e0e0}:host .col.col--6\\/12-medium .form-control>div{word-break:break-word}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FormWidgetComponent, selector: "fsw-form-widget", inputs: ["formConfig", "loading", "isReadonly"], outputs: ["initializeWidget", "closeForm", "submitForm"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberDetailComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-member-detail', template: `
    <div class="cbs-form__container" *ngIf="vm$ | async as vm">
      <header>
        <h6>{{ vm.translate.header.title }}</h6>
      </header>
      <div>
        <ng-container *ngIf="vm.state?.errors as errorList">
          <div class="error__message" *ngFor="let errStr of errorList">{{ errStr }}</div>
        </ng-container>
      </div>
      <fsw-form-widget
        #widget
        *ngIf="config"
        [isReadonly]="isReadonly"
        [formConfig]="config"
        (submitForm)="onSubmit($event)"
      ></fsw-form-widget>
    </div>
  `, changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        {
                            provide: TRANSLOCO_SCOPE,
                            useValue: {
                                scope: 'member-detail',
                                loader: TRANSLATION_LOADER$2,
                            },
                        },
                    ], styles: [".error__message{color:#cc1830;font-size:14px}:host .cbs-form__container{padding:16px;width:50%;display:flex;flex-direction:column;gap:16px;border-radius:4px;border:1px solid #e0e0e0}:host .col.col--6\\/12-medium .form-control>div{word-break:break-word}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FORM_CONFIG_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [STORE_TOKEN$1]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { applicationId: [{
                type: Input
            }], memberId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class MemberDetailModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberDetailModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: MemberDetailModule, declarations: [MemberDetailComponent], imports: [CommonModule,
            LetDirective,
            FormWidgetModule,
            UtilsServiceModule,
            MemberServiceModule,
            MasterDataServiceModule,
            SettingsServiceModule], exports: [MemberDetailComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberDetailModule, providers: [...memberDetailLoadProviders(getCountryCodeFromStorage())], imports: [CommonModule,
            FormWidgetModule,
            UtilsServiceModule,
            MemberServiceModule,
            MasterDataServiceModule,
            SettingsServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberDetailModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        LetDirective,
                        FormWidgetModule,
                        UtilsServiceModule,
                        MemberServiceModule,
                        MasterDataServiceModule,
                        SettingsServiceModule,
                    ],
                    declarations: [MemberDetailComponent],
                    exports: [MemberDetailComponent],
                    providers: [...memberDetailLoadProviders(getCountryCodeFromStorage())],
                }]
        }] });

const MEMBER_DOC_SERVICE_TOKEN = new InjectionToken('MEMBER_DOC_SERVICE_TOKEN');

class MemberDocService {
    constructor(_httpClient, _utilsService) {
        this._httpClient = _httpClient;
        this._utilsService = _utilsService;
        this._kongUrl = this._utilsService.getKongUrl();
    }
    deleteMemberDoc(applicationId, docId) {
        const url = `${this._kongUrl}/aps/v1/applications/${applicationId}/members/docs/${docId}`;
        return this._httpClient.delete(url, { headers: setRequestOptions() });
    }
    uploadSingleMemberDoc(applicationId, payload) {
        const { file, doc_type, member_ids } = payload;
        const headers = setRequestOptions(false);
        const formData = new FormData();
        formData.append('file', file);
        formData.append('doc_type', doc_type);
        formData.append('member_ids', member_ids.join(','));
        const url = `${this._kongUrl}/aps/v1/applications/${applicationId}/members/docs`;
        return this._httpClient
            .post(url, formData, {
            headers,
        })
            .pipe(map(({ data }) => data.doc_id));
    }
    getMemberDocs(applicationId) {
        const url = `${this._kongUrl}/aps/v1/applications/${applicationId}/members/docs`;
        return this._httpClient
            .get(url, {
            headers: setRequestOptions(),
        })
            .pipe(map(({ data }) => data?.docs));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberDocService, deps: [{ token: i1.HttpClient }, { token: UTILS_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberDocService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberDocService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [UTILS_SERVICE_TOKEN]
                }] }]; } });

class MemberDocServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberDocServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: MemberDocServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberDocServiceModule, providers: [
            {
                provide: MEMBER_DOC_SERVICE_TOKEN,
                useClass: MemberDocService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberDocServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: MEMBER_DOC_SERVICE_TOKEN,
                            useClass: MemberDocService,
                        },
                    ],
                }]
        }] });

class FSWOutstandingLoanFacilityConfirmComponent {
    constructor(dialogRef) {
        this.dialogRef = dialogRef;
        this.FSWModalSizes = FSWModalSizes;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWOutstandingLoanFacilityConfirmComponent, deps: [{ token: i1$7.DialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWOutstandingLoanFacilityConfirmComponent, selector: "fsw-outstanding-loan-facility-confirm", ngImport: i0, template: "<fsw-modal\n  [title]=\"'modal.title' | fswTranslate\"\n  (cancelEvent)=\"dialogRef.close(false)\"\n  (confirmEvent)=\"dialogRef.close(true)\"\n  [confirmButton]=\"'buttons.delete' | fswTranslate\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate\"\n  [hiddenCloseButton]=\"true\"\n  [size]=\"FSWModalSizes.S\"\n>\n  <ng-template fswModalBody>\n    <p>{{ 'modal.description' | fswTranslate }}</p>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWOutstandingLoanFacilityConfirmComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-outstanding-loan-facility-confirm', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal\n  [title]=\"'modal.title' | fswTranslate\"\n  (cancelEvent)=\"dialogRef.close(false)\"\n  (confirmEvent)=\"dialogRef.close(true)\"\n  [confirmButton]=\"'buttons.delete' | fswTranslate\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate\"\n  [hiddenCloseButton]=\"true\"\n  [size]=\"FSWModalSizes.S\"\n>\n  <ng-template fswModalBody>\n    <p>{{ 'modal.description' | fswTranslate }}</p>\n  </ng-template>\n</fsw-modal>\n" }]
        }], ctorParameters: function () { return [{ type: i1$7.DialogRef }]; } });

var title$j = "Outstanding Loan / Facility";
var empty$8 = "Outstanding Loans Facility has no data";
var columns$6 = {
	bank: "Bank / Financial Institution",
	facility_amount: "Facility Amount",
	monthly_installment: "Monthly Installment",
	outstanding_amount: "Outstanding Amount",
	period: "Period",
	security_amount: "Security Amount",
	source: "Source",
	reliability_score: "Reliability Score (0-1)",
	remarks: "Remarks",
	total: "Total",
	facilities: "facilities"
};
var fields$f = {
	facility_type: "Facility Type",
	security_type: "Security Type",
	source: "Source",
	bank: "Name of Bank / Financial Institution",
	start_at: "Start At",
	end_at: "End At",
	factsheet_comments: "Factsheet Comments",
	credit_comments: "Credit Comments"
};
var modal$3 = {
	title: "Delete Confirmation",
	description: "Are you sure you want to remove this item?"
};
var buttons$t = {
	save: "Save Changes",
	add: "Add New facility",
	cancel: "Cancel",
	"delete": "Delete"
};
var values = {
	facility_types: {
		term_loan: "Term Loan",
		hp: "HP",
		trade: "Trade",
		equity_loan: "Equity Loan",
		if_factoring: "IF / Factoring",
		rcf: "RCF",
		od: "OD",
		property: "Property",
		mml: "MML",
		convertible_loan: "Convertible Loan",
		na: "N/A"
	},
	security_types: {
		property: "Property",
		shares: "Shares",
		charge: "Charge",
		machines: "Machines",
		inventories: "Inventories",
		vehicles: "Vehicles",
		fd: "FD",
		insurance: "Insurance",
		others: "Others"
	},
	sources: {
		bank_statements: "Bank Statements",
		declaration: "Declaration",
		brc: "BRC",
		financials: "Financials",
		others: "Others"
	}
};
var my$c = {
	title: title$j,
	empty: empty$8,
	columns: columns$6,
	fields: fields$f,
	modal: modal$3,
	buttons: buttons$t,
	values: values
};

var MY$b = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$t,
    columns: columns$6,
    default: my$c,
    empty: empty$8,
    fields: fields$f,
    modal: modal$3,
    title: title$j,
    values: values
});

const FSW_OUTSTANDING_LOAN_FACILITY_TRANSLATION_LOADER = {
    [CountryCode.MY]: MY$b,
};

class FSWOutstandingLoanFacilityStore extends ApplicationMemberInformationStore {
    get array() {
        try {
            return getControlFromGroup(this.form, 'outstandingLoanFacility');
        }
        catch (err) {
            return new UntypedFormArray([]);
        }
    }
    constructor(_alertService, _outstandingLoanFacilityEntity, _outstandingLoanFacilityGrid, _initialState) {
        super(_outstandingLoanFacilityEntity, _initialState);
        this._alertService = _alertService;
        this._outstandingLoanFacilityEntity = _outstandingLoanFacilityEntity;
        this._outstandingLoanFacilityGrid = _outstandingLoanFacilityGrid;
        this._initialState = _initialState;
        this.form = new UntypedFormGroup({});
        this.init = this.effect(pipe(mergeMap(() => this.setupInformation(this.get().entityId)), tap(() => {
            const { isReadonly } = this.get();
            this.updateState({
                builder: this._outstandingLoanFacilityGrid(this.form, isReadonly),
            });
            this.refresh();
        })));
        this.save = this.effect(pipe(switchMap(() => {
            const { entityId } = this.get();
            return this._outstandingLoanFacilityEntity
                .saveAsync(entityId, this.array.value)
                .pipe(tap(() => {
                this._alertService.success('Notification', 'Save successfully', {
                    duration: 2000,
                });
                this.refresh();
            }), catchError((err) => {
                console.error(err);
                this._alertService.error('Something went wrong', err.message, {
                    duration: 2000,
                });
                return EMPTY;
            }));
        })));
        this.remove = this.effect(pipe(switchMap((id) => {
            return this._outstandingLoanFacilityEntity
                .removeAsync(this.get().entityId, id)
                .pipe(tap(() => {
                this._alertService.success('Notification', 'Deleted successfully', {
                    duration: 2000,
                });
                this.refresh();
            }), catchError((err) => {
                console.error(err);
                this._alertService.error('Something went wrong', err.message, {
                    duration: 2000,
                });
                return EMPTY;
            }));
        })));
        this.refresh = this.effect(pipe(switchMap(() => {
            const { entityId } = this.get();
            return this._outstandingLoanFacilityEntity.loadAsync(entityId).pipe(tap((data) => {
                this.array.patchValue(data);
            }), catchError((err) => {
                console.error(err);
                this._alertService.error('Something went wrong', err.message, {
                    duration: 2000,
                });
                return EMPTY;
            }));
        })));
        this.updateState = (value) => this.patchState({
            ...value,
        });
        this.updateState({
            builder: this._outstandingLoanFacilityGrid(this.form, this.get().isReadonly),
        });
    }
    addNew() {
        this.array.patchValue([...this.array.value, {}]);
    }
    loadComments() {
        this.updateState({
            comments: [
                {
                    title: '',
                    customClasses: 'w-full flex flex-col gap-4',
                    items: [
                        {
                            category: 'FACTSHEET',
                            title: 'fields.factsheet_comments',
                            module: 'OUTSTANDING_LOAN_FACILITY',
                            identifier: 'OUTSTANDING_LOAN_FACILITY',
                            entityId: this.get().entityId,
                            fields: [
                                {
                                    key: 'main_comment',
                                    label: 'fields.factsheet_comments',
                                },
                            ],
                        },
                        {
                            category: 'CREDIT',
                            title: 'fields.credit_comments',
                            module: 'OUTSTANDING_LOAN_FACILITY',
                            identifier: 'OUTSTANDING_LOAN_FACILITY',
                            entityId: this.get().entityId,
                            fields: [
                                {
                                    key: 'main_comment',
                                    label: 'fields.credit_comments',
                                },
                            ],
                        },
                    ].filter((item) => !this.get().hiddenComments?.includes(item.category)),
                },
            ],
        });
    }
}

var OutstandingLoanFacilityFacilityTypes;
(function (OutstandingLoanFacilityFacilityTypes) {
    OutstandingLoanFacilityFacilityTypes["TERM_LOAN"] = "Term Loan";
    OutstandingLoanFacilityFacilityTypes["HP"] = "HP";
    OutstandingLoanFacilityFacilityTypes["TRADE"] = "Trade";
    OutstandingLoanFacilityFacilityTypes["EQUITY_LOAN"] = "Equity Loan";
    OutstandingLoanFacilityFacilityTypes["IF_FACTORING"] = "IF / Factoring";
    OutstandingLoanFacilityFacilityTypes["RCF"] = "RCF";
    OutstandingLoanFacilityFacilityTypes["OD"] = "OD";
    OutstandingLoanFacilityFacilityTypes["PROPERTY"] = "Property";
    OutstandingLoanFacilityFacilityTypes["MML"] = "MML";
    OutstandingLoanFacilityFacilityTypes["CONVERTIBLE_LOAN"] = "Convertible Loan";
    OutstandingLoanFacilityFacilityTypes["NA"] = "Not Applicable";
})(OutstandingLoanFacilityFacilityTypes || (OutstandingLoanFacilityFacilityTypes = {}));
var OutstandingLoanFacilitySecurityTypes;
(function (OutstandingLoanFacilitySecurityTypes) {
    OutstandingLoanFacilitySecurityTypes["PROPERTY"] = "Property";
    OutstandingLoanFacilitySecurityTypes["SHARES"] = "Shares";
    OutstandingLoanFacilitySecurityTypes["CHARGE"] = "Charge";
    OutstandingLoanFacilitySecurityTypes["MACHINES"] = "Machines";
    OutstandingLoanFacilitySecurityTypes["INVENTORIES"] = "Inventories";
    OutstandingLoanFacilitySecurityTypes["VEHICLES"] = "Vehicles";
    OutstandingLoanFacilitySecurityTypes["FD"] = "FD";
    OutstandingLoanFacilitySecurityTypes["INSURANCE"] = "Insurance";
    OutstandingLoanFacilitySecurityTypes["OTHERS"] = "Others";
})(OutstandingLoanFacilitySecurityTypes || (OutstandingLoanFacilitySecurityTypes = {}));
var OutstandingLoanFacilitySources;
(function (OutstandingLoanFacilitySources) {
    OutstandingLoanFacilitySources["BANK_STATEMENTS"] = "Bank Statements";
    OutstandingLoanFacilitySources["DECLARATION"] = "Declaration";
    OutstandingLoanFacilitySources["BRC"] = "BRC";
    OutstandingLoanFacilitySources["FINANCIALS"] = "Financials";
    OutstandingLoanFacilitySources["OTHERS"] = "Others";
})(OutstandingLoanFacilitySources || (OutstandingLoanFacilitySources = {}));

const tranFormPrefix = 'values';
const outstandingLoanFacilityFacilityTypes = (translation) => {
    return [
        {
            text: translation ? translation.term_loan : `${tranFormPrefix}.facility_types.term_loan`,
            value: OutstandingLoanFacilityFacilityTypes.TERM_LOAN,
        },
        {
            text: translation ? translation.hp : `${tranFormPrefix}.facility_types.hp`,
            value: OutstandingLoanFacilityFacilityTypes.HP,
        },
        {
            text: translation ? translation.trade : `${tranFormPrefix}.facility_types.trade`,
            value: OutstandingLoanFacilityFacilityTypes.TRADE,
        },
        {
            text: translation ? translation.equity_loan : `${tranFormPrefix}.facility_types.equity_loan`,
            value: OutstandingLoanFacilityFacilityTypes.EQUITY_LOAN,
        },
        {
            text: translation
                ? translation.if_factoring
                : `${tranFormPrefix}.facility_types.if_factoring`,
            value: OutstandingLoanFacilityFacilityTypes.IF_FACTORING,
        },
        {
            text: translation ? translation.rcf : `${tranFormPrefix}.facility_types.rcf`,
            value: OutstandingLoanFacilityFacilityTypes.RCF,
        },
        {
            text: translation ? translation.od : `${tranFormPrefix}.facility_types.od`,
            value: OutstandingLoanFacilityFacilityTypes.OD,
        },
        {
            text: translation ? translation.property : `${tranFormPrefix}.facility_types.property`,
            value: OutstandingLoanFacilityFacilityTypes.PROPERTY,
        },
        {
            text: translation ? translation.mml : `${tranFormPrefix}.facility_types.mml`,
            value: OutstandingLoanFacilityFacilityTypes.MML,
        },
        {
            text: translation
                ? translation.convertible_loan
                : `${tranFormPrefix}.facility_types.convertible_loan`,
            value: OutstandingLoanFacilityFacilityTypes.CONVERTIBLE_LOAN,
        },
        {
            text: translation ? translation.na : `${tranFormPrefix}.facility_types.na`,
            value: OutstandingLoanFacilityFacilityTypes.NA,
        },
    ];
};
const outstandingLoanFacilitySecurityTypes = (translation) => {
    return [
        {
            text: translation ? translation.property : `${tranFormPrefix}.security_types.property`,
            value: OutstandingLoanFacilitySecurityTypes.PROPERTY,
        },
        {
            text: translation ? translation.shares : `${tranFormPrefix}.security_types.shares`,
            value: OutstandingLoanFacilitySecurityTypes.SHARES,
        },
        {
            text: translation ? translation.charge : `${tranFormPrefix}.security_types.charge`,
            value: OutstandingLoanFacilitySecurityTypes.CHARGE,
        },
        {
            text: translation ? translation.machines : `${tranFormPrefix}.security_types.machines`,
            value: OutstandingLoanFacilitySecurityTypes.MACHINES,
        },
        {
            text: translation ? translation.inventories : `${tranFormPrefix}.security_types.inventories`,
            value: OutstandingLoanFacilitySecurityTypes.INVENTORIES,
        },
        {
            text: translation ? translation.vehicles : `${tranFormPrefix}.security_types.vehicles`,
            value: OutstandingLoanFacilitySecurityTypes.VEHICLES,
        },
        {
            text: translation ? translation.fd : `${tranFormPrefix}.security_types.fd`,
            value: OutstandingLoanFacilitySecurityTypes.FD,
        },
        {
            text: translation ? translation.insurance : `${tranFormPrefix}.security_types.insurance`,
            value: OutstandingLoanFacilitySecurityTypes.INSURANCE,
        },
        {
            text: translation ? translation.others : `${tranFormPrefix}.security_types.others`,
            value: OutstandingLoanFacilitySecurityTypes.OTHERS,
        },
    ];
};
const outstandingLoanFacilitySources = (translation) => {
    return [
        {
            text: translation ? translation.bank_statements : `${tranFormPrefix}.sources.bank_statements`,
            value: OutstandingLoanFacilitySources.BANK_STATEMENTS,
        },
        {
            text: translation ? translation.declaration : `${tranFormPrefix}.sources.declaration`,
            value: OutstandingLoanFacilitySources.DECLARATION,
        },
        {
            text: translation ? translation.brc : `${tranFormPrefix}.sources.brc`,
            value: OutstandingLoanFacilitySources.BRC,
        },
        {
            text: translation ? translation.financials : `${tranFormPrefix}.sources.financials`,
            value: OutstandingLoanFacilitySources.FINANCIALS,
        },
        {
            text: translation ? translation.others : `${tranFormPrefix}.sources.others`,
            value: OutstandingLoanFacilitySources.OTHERS,
        },
    ];
};

const FSW_OUTSTANDING_LOAN_FACILITY_STORE_TOKEN = new InjectionToken('FSW_OUTSTANDING_LOAN_FACILITY_STORE_TOKEN');

const FSW_OUTSTANDING_LOAN_FACILITY_GRID_TOKEN = new InjectionToken('FSW_OUTSTANDING_LOAN_FACILITY_GRID_TOKEN');

const FSW_OUTSTANDING_LOAN_FACILITY_ENTITY_TOKEN = new InjectionToken('FSW_OUTSTANDING_LOAN_FACILITY_ENTITY_TOKEN');

class FSWOutstandingLoanFacilityStoreMY extends FSWOutstandingLoanFacilityStore {
    constructor(alertService, outstandingLoanFacilityEntity, outstandingLoanFacilityGrid) {
        super(alertService, outstandingLoanFacilityEntity, outstandingLoanFacilityGrid, {
            entityId: null,
            builder: null,
            member: null,
            isReadonly: false,
            entityType: FSWEntityTypes.APPLICATION,
            hiddenComments: [],
            comments: [],
        });
        this.alertService = alertService;
        this.outstandingLoanFacilityEntity = outstandingLoanFacilityEntity;
        this.outstandingLoanFacilityGrid = outstandingLoanFacilityGrid;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWOutstandingLoanFacilityStoreMY, deps: [{ token: FSW_ALERT_SERVICE_TOKEN }, { token: FSW_OUTSTANDING_LOAN_FACILITY_ENTITY_TOKEN }, { token: FSW_OUTSTANDING_LOAN_FACILITY_GRID_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWOutstandingLoanFacilityStoreMY }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWOutstandingLoanFacilityStoreMY, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_OUTSTANDING_LOAN_FACILITY_ENTITY_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_OUTSTANDING_LOAN_FACILITY_GRID_TOKEN]
                }] }]; } });

const FSWOutstandingLoanFacilityGridMY = (form, isReadonly) => {
    const translation = FSW_OUTSTANDING_LOAN_FACILITY_TRANSLATION_LOADER[CountryCode.MY];
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.TABLE,
        customClasses: 'fsw-table w-max',
        readonlyWhen$: of(isReadonly),
        header: [
            {
                columns: [
                    {
                        label: '',
                        width: 20,
                    },
                    {
                        label: translation.columns.bank,
                        width: 200,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.facility_amount,
                        width: 120,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.monthly_installment,
                        width: 120,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.outstanding_amount,
                        width: 120,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.period,
                        width: 150,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.security_amount,
                        width: 120,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.source,
                        width: 150,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.reliability_score,
                        width: 10,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.remarks,
                        width: 180,
                    },
                    {
                        label: '',
                        width: 50,
                    },
                ],
            },
        ],
        items: [
            {
                body: {
                    isLoop: true,
                    key: 'outstandingLoanFacility',
                    data: {
                        columns: [
                            {
                                columnType: 'template',
                                template: 'no',
                                customClasses: 'text-center',
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'flex flex-col gap-2 pr-1',
                                        fields: [
                                            {
                                                key: 'facility_type',
                                                type: FSWDynamicBuilderControlTypes.SELECT,
                                                context: {
                                                    placeHolder: translation.fields.facility_type,
                                                    defaultValue: OutstandingLoanFacilityFacilityTypes.NA,
                                                    fullWidth: true,
                                                    items: outstandingLoanFacilityFacilityTypes(translation.values.facility_types),
                                                    showError: true,
                                                    readonlyTemplate: (value) => {
                                                        const text = outstandingLoanFacilityFacilityTypes(translation.values.facility_types).find((item) => item.value === value)?.text;
                                                        return text ?? 'N/A';
                                                    },
                                                },
                                                validations: [Validators.required],
                                            },
                                            {
                                                key: 'financial_institution_name',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    inputType: 'text',
                                                    placeHolder: translation.fields.bank,
                                                    defaultValue: '',
                                                    fullWidth: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => value ?? 'N/A',
                                                },
                                                validations: [Validators.required],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1',
                                        fields: [
                                            {
                                                key: 'facility_amount',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    // inputType: 'number',
                                                    defaultValue: 0,
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    fullWidth: true,
                                                    readonlyTemplate: (value) => value ?? '0',
                                                    showError: true,
                                                },
                                                validations: [Validators.required],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1',
                                        fields: [
                                            {
                                                key: 'monthly_installment',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    // inputType: 'number',
                                                    defaultValue: 0,
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    fullWidth: true,
                                                    readonlyTemplate: (value) => value ?? '0',
                                                    showError: true,
                                                },
                                                validations: [Validators.required],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1',
                                        fields: [
                                            {
                                                key: 'outstanding_amount',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    // inputType: 'number',
                                                    defaultValue: 0,
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    fullWidth: true,
                                                    readonlyTemplate: (value) => value ?? '0',
                                                    showError: true,
                                                },
                                                validations: [Validators.required],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'flex flex-col gap-2 pr-1',
                                        fields: [
                                            {
                                                key: 'start_at',
                                                type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                                                context: {
                                                    defaultValue: null,
                                                    fullWidth: true,
                                                    placeHolder: translation.fields.start_at,
                                                    closeOnSelected: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => {
                                                        const text = new DatePipe('en-US').transform(value, 'dd/MM/yyyy');
                                                        return text ?? 'N/A';
                                                    },
                                                },
                                                validations: [Validators.required],
                                            },
                                            {
                                                key: 'end_at',
                                                type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                                                context: {
                                                    defaultValue: null,
                                                    fullWidth: true,
                                                    placeHolder: translation.fields.end_at,
                                                    closeOnSelected: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => {
                                                        const text = new DatePipe('en-US').transform(value, 'dd/MM/yyyy');
                                                        return text ?? 'N/A';
                                                    },
                                                },
                                                validations: [Validators.required],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'flex flex-col gap-2 pr-1',
                                        fields: [
                                            {
                                                key: 'security_type',
                                                type: FSWDynamicBuilderControlTypes.SELECT,
                                                context: {
                                                    placeHolder: translation.fields.security_type,
                                                    defaultValue: null,
                                                    fullWidth: true,
                                                    items: outstandingLoanFacilitySecurityTypes(translation.values.security_types),
                                                    showError: true,
                                                    readonlyTemplate: (value) => {
                                                        const text = outstandingLoanFacilitySecurityTypes(translation.values.security_types).find((item) => item.value === value)?.text;
                                                        return text ?? 'N/A';
                                                    },
                                                },
                                                validations: [Validators.required],
                                            },
                                            {
                                                key: 'security_amount',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    // inputType: 'number',
                                                    defaultValue: 0,
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    fullWidth: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => value ?? '0',
                                                },
                                                validations: [Validators.required],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'flex flex-col gap-2 pr-1',
                                        fields: [
                                            {
                                                key: 'source',
                                                type: FSWDynamicBuilderControlTypes.SELECT,
                                                context: {
                                                    placeHolder: translation.fields.source,
                                                    defaultValue: null,
                                                    fullWidth: true,
                                                    items: outstandingLoanFacilitySources(translation.values.sources),
                                                    showError: true,
                                                    readonlyTemplate: (value) => {
                                                        const text = outstandingLoanFacilitySources(translation.values.sources).find((item) => item.value === value)?.text;
                                                        return text ?? 'N/A';
                                                    },
                                                },
                                                validations: [Validators.required],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1',
                                        fields: [
                                            {
                                                key: 'reliability_score',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    // inputType: 'number',
                                                    defaultValue: 0,
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    fullWidth: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => value ?? '0',
                                                },
                                                validations: [Validators.required, Validators.min(0), Validators.max(1)],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1',
                                        fields: [
                                            {
                                                key: 'id',
                                                type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                                context: {
                                                    isHidden: true,
                                                },
                                            },
                                            {
                                                key: 'remark',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    inputType: 'area',
                                                    defaultValue: '',
                                                    fullWidth: true,
                                                    readonlyTemplate: (value) => value ?? 'N/A',
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'template',
                                template: 'delete',
                            },
                        ],
                    },
                    empty: {
                        emptyTemplateKey: 'empty_list',
                        emptyTemplateColSpan: 11,
                    },
                },
            },
        ],
        footer: [
            {
                columns: [
                    {
                        colSpan: 9,
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                name: 'add_outstanding_loan_facility',
                                fields: [],
                            },
                        ],
                    },
                ],
            },
            {
                key: 'total',
                columns: [
                    {
                        columnType: 'template',
                        template: 'total',
                        colSpan: 2,
                    },
                    {
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                customClasses: 'pr-1',
                                fields: [
                                    {
                                        key: 'facility_amount',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            // inputType: 'number',
                                            defaultValue: 0,
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            isDisabled: true,
                                            afterCreated: (control, group) => {
                                                const outstandingLoanFacility = group.parent.get('outstandingLoanFacility');
                                                if (!outstandingLoanFacility) {
                                                    return;
                                                }
                                                outstandingLoanFacility.valueChanges
                                                    .pipe(tap((value) => {
                                                    control.setValue(value.reduce((acc, cur) => acc + Number.parseFloat(cur.facility_amount || '0'), 0));
                                                }))
                                                    .subscribe();
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                        // width: 150,
                    },
                    {
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                customClasses: 'pr-1',
                                fields: [
                                    {
                                        key: 'monthly_installment',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            // inputType: 'number',
                                            defaultValue: 0,
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            isDisabled: true,
                                            afterCreated: (control, group) => {
                                                const outstandingLoanFacility = group.parent.get('outstandingLoanFacility');
                                                if (!outstandingLoanFacility) {
                                                    return;
                                                }
                                                outstandingLoanFacility.valueChanges
                                                    .pipe(tap((value) => {
                                                    control.setValue(value.reduce((acc, cur) => acc + Number.parseFloat(cur.monthly_installment || '0'), 0));
                                                }))
                                                    .subscribe();
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                        // width: 150,
                    },
                    {
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                customClasses: 'pr-1',
                                fields: [
                                    {
                                        key: 'outstanding_amount',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            // inputType: 'number',
                                            defaultValue: 0,
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            isDisabled: true,
                                            afterCreated: (control, group) => {
                                                const outstandingLoanFacility = group.parent.get('outstandingLoanFacility');
                                                if (!outstandingLoanFacility) {
                                                    return;
                                                }
                                                outstandingLoanFacility.valueChanges
                                                    .pipe(tap((value) => {
                                                    control.setValue(value.reduce((acc, cur) => acc + Number.parseFloat(cur.outstanding_amount || '0'), 0));
                                                }))
                                                    .subscribe();
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                        // width: 150,
                    },
                    {
                        label: '',
                        colSpan: 6,
                    },
                ],
            },
        ],
        form,
    });
};

const FSW_OUTSTANDING_LOAN_FACILITY_MY_PROVIDERS = [
    {
        provide: FSW_OUTSTANDING_LOAN_FACILITY_GRID_TOKEN,
        useValue: FSWOutstandingLoanFacilityGridMY,
        deps: [],
    },
    {
        provide: FSW_OUTSTANDING_LOAN_FACILITY_STORE_TOKEN,
        useClass: FSWOutstandingLoanFacilityStoreMY,
        deps: [
            FSW_ALERT_SERVICE_TOKEN,
            FSW_OUTSTANDING_LOAN_FACILITY_ENTITY_TOKEN,
            FSW_OUTSTANDING_LOAN_FACILITY_GRID_TOKEN,
        ],
    },
];

class FSWOutstandingLoanFacilityStoreSG extends FSWOutstandingLoanFacilityStore {
    constructor(alertService, outstandingLoanFacilityEntity, outstandingLoanFacilityGrid) {
        super(alertService, outstandingLoanFacilityEntity, outstandingLoanFacilityGrid, {
            entityId: null,
            builder: null,
            member: null,
            isReadonly: false,
            entityType: FSWEntityTypes.APPLICATION,
            hiddenComments: [],
            comments: [],
        });
        this.alertService = alertService;
        this.outstandingLoanFacilityEntity = outstandingLoanFacilityEntity;
        this.outstandingLoanFacilityGrid = outstandingLoanFacilityGrid;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWOutstandingLoanFacilityStoreSG, deps: [{ token: FSW_ALERT_SERVICE_TOKEN }, { token: FSW_OUTSTANDING_LOAN_FACILITY_ENTITY_TOKEN }, { token: FSW_OUTSTANDING_LOAN_FACILITY_GRID_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWOutstandingLoanFacilityStoreSG }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWOutstandingLoanFacilityStoreSG, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_OUTSTANDING_LOAN_FACILITY_ENTITY_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_OUTSTANDING_LOAN_FACILITY_GRID_TOKEN]
                }] }]; } });

const FSWOutstandingLoanFacilityGridSG = (form, isReadonly) => {
    const translation = FSW_OUTSTANDING_LOAN_FACILITY_TRANSLATION_LOADER[CountryCode.MY];
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.TABLE,
        customClasses: 'fsw-table w-max',
        readonlyWhen$: of(isReadonly),
        header: [
            {
                columns: [
                    {
                        label: '',
                        width: 20,
                    },
                    {
                        label: translation.columns.bank,
                        width: 200,
                    },
                    {
                        label: translation.columns.facility_amount,
                        width: 120,
                    },
                    {
                        label: translation.columns.monthly_installment,
                        width: 120,
                    },
                    {
                        label: translation.columns.outstanding_amount,
                        width: 120,
                    },
                    {
                        label: translation.columns.period,
                        width: 150,
                    },
                    {
                        label: translation.columns.security_amount,
                        width: 120,
                    },
                    {
                        label: translation.columns.source,
                        width: 150,
                    },
                    {
                        label: translation.columns.reliability_score,
                        width: 10,
                    },
                    {
                        label: translation.columns.remarks,
                        width: 180,
                    },
                    {
                        label: '',
                        width: 50,
                    },
                ],
            },
        ],
        items: [
            {
                body: {
                    isLoop: true,
                    key: 'outstandingLoanFacility',
                    data: {
                        columns: [
                            {
                                columnType: 'template',
                                template: 'no',
                                customClasses: 'text-center',
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'flex flex-col gap-2 pr-1',
                                        fields: [
                                            {
                                                key: 'facility_type',
                                                type: FSWDynamicBuilderControlTypes.SELECT,
                                                context: {
                                                    placeHolder: translation.fields.facility_type,
                                                    defaultValue: OutstandingLoanFacilityFacilityTypes.HP,
                                                    fullWidth: true,
                                                    items: outstandingLoanFacilityFacilityTypes(translation.values.facility_types),
                                                    readonlyTemplate: (value) => {
                                                        const text = outstandingLoanFacilityFacilityTypes(translation.values.facility_types).find((item) => item.value === value)?.text;
                                                        return text ?? 'N/A';
                                                    },
                                                },
                                            },
                                            {
                                                key: 'financial_institution_name',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    inputType: 'text',
                                                    placeHolder: translation.fields.bank,
                                                    defaultValue: '',
                                                    fullWidth: true,
                                                    readonlyTemplate: (value) => value ?? 'N/A',
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1',
                                        fields: [
                                            {
                                                key: 'facility_amount',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    // inputType: 'number',
                                                    defaultValue: 0,
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    fullWidth: true,
                                                    readonlyTemplate: (value) => new Intl.NumberFormat('en-US', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    }).format(value) ?? '0',
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1',
                                        fields: [
                                            {
                                                key: 'monthly_installment',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    // inputType: 'number',
                                                    defaultValue: 0,
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    fullWidth: true,
                                                    readonlyTemplate: (value) => new Intl.NumberFormat('en-US', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    }).format(value) ?? '0',
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1',
                                        fields: [
                                            {
                                                key: 'outstanding_amount',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    // inputType: 'number',
                                                    defaultValue: 0,
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    fullWidth: true,
                                                    readonlyTemplate: (value) => new Intl.NumberFormat('en-US', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    }).format(value) ?? '0',
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'flex flex-col gap-2 pr-1',
                                        fields: [
                                            {
                                                key: 'start_at',
                                                type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                                                context: {
                                                    defaultValue: null,
                                                    fullWidth: true,
                                                    placeHolder: translation.fields.start_at,
                                                    closeOnSelected: true,
                                                    readonlyTemplate: (value) => {
                                                        const text = new DatePipe('en-US').transform(value, 'dd/MM/yyyy');
                                                        return text ?? 'N/A';
                                                    },
                                                },
                                            },
                                            {
                                                key: 'end_at',
                                                type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                                                context: {
                                                    defaultValue: null,
                                                    fullWidth: true,
                                                    placeHolder: translation.fields.end_at,
                                                    closeOnSelected: true,
                                                    readonlyTemplate: (value) => {
                                                        const text = new DatePipe('en-US').transform(value, 'dd/MM/yyyy');
                                                        return text ?? 'N/A';
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'flex flex-col gap-2 pr-1',
                                        fields: [
                                            {
                                                key: 'security_type',
                                                type: FSWDynamicBuilderControlTypes.SELECT,
                                                context: {
                                                    placeHolder: translation.fields.security_type,
                                                    defaultValue: null,
                                                    fullWidth: true,
                                                    items: outstandingLoanFacilitySecurityTypes(translation.values.security_types),
                                                    readonlyTemplate: (value) => {
                                                        const text = outstandingLoanFacilitySecurityTypes(translation.values.security_types).find((item) => item.value === value)?.text;
                                                        return text ?? 'N/A';
                                                    },
                                                },
                                            },
                                            {
                                                key: 'security_amount',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    // inputType: 'number',
                                                    defaultValue: 0,
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    fullWidth: true,
                                                    readonlyTemplate: (value) => new Intl.NumberFormat('en-US', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    }).format(value) ?? '0',
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'flex flex-col gap-2 pr-1',
                                        fields: [
                                            {
                                                key: 'source',
                                                type: FSWDynamicBuilderControlTypes.SELECT,
                                                context: {
                                                    placeHolder: translation.fields.source,
                                                    defaultValue: null,
                                                    fullWidth: true,
                                                    items: outstandingLoanFacilitySources(translation.values.sources),
                                                    readonlyTemplate: (value) => {
                                                        const text = outstandingLoanFacilitySources(translation.values.sources).find((item) => item.value === value)?.text;
                                                        return text ?? 'N/A';
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1',
                                        fields: [
                                            {
                                                key: 'reliability_score',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    // inputType: 'number',
                                                    defaultValue: 0,
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    fullWidth: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => value ?? '0',
                                                },
                                                validations: [Validators.min(0), Validators.max(1)],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1',
                                        fields: [
                                            {
                                                key: 'id',
                                                type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                                context: {
                                                    isHidden: true,
                                                },
                                            },
                                            {
                                                key: 'remark',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    inputType: 'area',
                                                    defaultValue: '',
                                                    fullWidth: true,
                                                    readonlyTemplate: (value) => value ?? 'N/A',
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'template',
                                template: 'delete',
                            },
                        ],
                    },
                    empty: {
                        emptyTemplateKey: 'empty_list',
                        emptyTemplateColSpan: 11,
                    },
                },
            },
        ],
        footer: [
            {
                columns: [
                    {
                        colSpan: 9,
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                name: 'add_outstanding_loan_facility',
                                fields: [],
                            },
                        ],
                    },
                ],
            },
            {
                key: 'total',
                columns: [
                    {
                        columnType: 'template',
                        template: 'total',
                        colSpan: 2,
                    },
                    {
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                customClasses: 'pr-1',
                                fields: [
                                    {
                                        key: 'facility_amount',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            // inputType: 'number',
                                            defaultValue: 0,
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            isDisabled: true,
                                            afterCreated: (control, group) => {
                                                const outstandingLoanFacility = group.parent.get('outstandingLoanFacility');
                                                if (!outstandingLoanFacility) {
                                                    return;
                                                }
                                                outstandingLoanFacility.valueChanges
                                                    .pipe(tap((value) => {
                                                    control.setValue(new Intl.NumberFormat('en-US', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    }).format(value.reduce((acc, cur) => acc + Number.parseFloat(cur.facility_amount || '0'), 0)));
                                                }))
                                                    .subscribe();
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                        // width: 150,
                    },
                    {
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                customClasses: 'pr-1',
                                fields: [
                                    {
                                        key: 'monthly_installment',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            // inputType: 'number',
                                            defaultValue: 0,
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            isDisabled: true,
                                            afterCreated: (control, group) => {
                                                const outstandingLoanFacility = group.parent.get('outstandingLoanFacility');
                                                if (!outstandingLoanFacility) {
                                                    return;
                                                }
                                                outstandingLoanFacility.valueChanges
                                                    .pipe(tap((value) => {
                                                    control.setValue(new Intl.NumberFormat('en-US', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    }).format(value.reduce((acc, cur) => acc + Number.parseFloat(cur.monthly_installment || '0'), 0)));
                                                }))
                                                    .subscribe();
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                        // width: 150,
                    },
                    {
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                customClasses: 'pr-1',
                                fields: [
                                    {
                                        key: 'outstanding_amount',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            // inputType: 'number',
                                            defaultValue: 0,
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            isDisabled: true,
                                            afterCreated: (control, group) => {
                                                const outstandingLoanFacility = group.parent.get('outstandingLoanFacility');
                                                if (!outstandingLoanFacility) {
                                                    return;
                                                }
                                                outstandingLoanFacility.valueChanges
                                                    .pipe(tap((value) => {
                                                    control.setValue(new Intl.NumberFormat('en-US', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    }).format(value.reduce((acc, cur) => acc + Number.parseFloat(cur.outstanding_amount || '0'), 0)));
                                                }))
                                                    .subscribe();
                                            },
                                        },
                                    },
                                ],
                            },
                        ],
                        // width: 150,
                    },
                    {
                        label: '',
                        colSpan: 6,
                    },
                ],
            },
        ],
        form,
    });
};

const FSW_OUTSTANDING_LOAN_FACILITY_SG_PROVIDERS = [
    {
        provide: FSW_OUTSTANDING_LOAN_FACILITY_GRID_TOKEN,
        useValue: FSWOutstandingLoanFacilityGridSG,
        deps: [],
    },
    {
        provide: FSW_OUTSTANDING_LOAN_FACILITY_STORE_TOKEN,
        useClass: FSWOutstandingLoanFacilityStoreSG,
        deps: [
            FSW_ALERT_SERVICE_TOKEN,
            FSW_OUTSTANDING_LOAN_FACILITY_ENTITY_TOKEN,
            FSW_OUTSTANDING_LOAN_FACILITY_GRID_TOKEN,
        ],
    },
];

class FSWOutstandingLoanFacilityLoanEntity {
    getApplicationMembersInformation(entityId, applicationParams, memberParams) {
        throw new Error('Method not implemented.');
    }
    addAsync(entityId, data) {
        throw new Error('Did not support this method');
    }
    loadAsync(entityId) {
        throw new Error('Did not support this method');
    }
    saveAsync(entityId, data) {
        throw new Error('Did not support this method');
    }
    updateAsync(entityId, data) {
        throw new Error('Did not support this method');
    }
    removeAsync(entityId, id) {
        throw new Error('Did not support this method');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWOutstandingLoanFacilityLoanEntity, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWOutstandingLoanFacilityLoanEntity }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWOutstandingLoanFacilityLoanEntity, decorators: [{
            type: Injectable
        }] });

class FSWOutstandingLoanFacilityFacilityApplicationEntity {
    constructor(applicationOutstandingLoansService, creditOutstandingLoansService, _applicationServiceService) {
        this.applicationOutstandingLoansService = applicationOutstandingLoansService;
        this.creditOutstandingLoansService = creditOutstandingLoansService;
        this._applicationServiceService = _applicationServiceService;
    }
    getApplicationMembersInformation(entityId, applicationParams, memberParams) {
        return this._applicationServiceService.getApplicationMembersInformation(entityId, applicationParams, memberParams);
    }
    addAsync(entityId, data) {
        return this.creditOutstandingLoansService.addOutstandingLoans(data).pipe(switchMap((loans) => {
            return this.applicationOutstandingLoansService
                .addOutstandingLoanIds(entityId, loans.map((loan) => loan.id), true)
                .pipe(switchMap(() => this.loadAsync(entityId)));
        }));
    }
    loadAsync(entityId) {
        return this.applicationOutstandingLoansService.getOutstandingLoanIds(entityId, true).pipe(switchMap((ids) => {
            if (!ids.length) {
                return of([]);
            }
            return this.creditOutstandingLoansService.getOutstandingLoans(ids);
        }));
    }
    saveAsync(entityId, data) {
        const { putList, postList } = data.reduce((acc, item) => {
            if (item.id) {
                acc.putList.push(item);
            }
            else {
                acc.postList.push(item);
            }
            return acc;
        }, {
            putList: [],
            postList: [],
        });
        return forkJoin([
            ...(postList.length ? [this.addAsync(entityId, postList)] : []),
            ...(putList.length ? [this.updateAsync(entityId, putList)] : []),
        ]).pipe(switchMap(() => this.loadAsync(entityId)));
    }
    updateAsync(entityId, data) {
        return this.creditOutstandingLoansService.updateOutstandingLoans(data);
    }
    removeAsync(entityId, id) {
        return this.applicationOutstandingLoansService.removeOutstandingLoansId(entityId, id);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWOutstandingLoanFacilityFacilityApplicationEntity, deps: [{ token: OUTSTANDING_LOAN_SERVICE_TOKEN }, { token: CREDIT_OUTSTANDING_LOANS_SERVICE_TOKEN }, { token: APPLICATION_MEMBER_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWOutstandingLoanFacilityFacilityApplicationEntity }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWOutstandingLoanFacilityFacilityApplicationEntity, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [OUTSTANDING_LOAN_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CREDIT_OUTSTANDING_LOANS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_SERVICE_TOKEN]
                }] }]; } });

const FSW_OUTSTANDING_LOAN_FACILITY_PROVIDERS = {
    default: FSW_OUTSTANDING_LOAN_FACILITY_MY_PROVIDERS,
    [CountryCode.MY]: FSW_OUTSTANDING_LOAN_FACILITY_MY_PROVIDERS,
    [CountryCode.SG]: FSW_OUTSTANDING_LOAN_FACILITY_SG_PROVIDERS,
};
const outstandingLoanFacilityLoadProviders = (countryCode) => [
    fswTranslateScope('outstanding_loan_facility'),
    ...getCustomProviders(FSW_OUTSTANDING_LOAN_FACILITY_PROVIDERS, FSW_OUTSTANDING_LOAN_FACILITY_MY_PROVIDERS, countryCode),
];
const outstandingLoanFacilityEntityLoadProviders = (entityType) => [
    {
        provide: FSW_OUTSTANDING_LOAN_FACILITY_ENTITY_TOKEN,
        useClass: entityType === FSWEntityTypes.APPLICATION
            ? FSWOutstandingLoanFacilityFacilityApplicationEntity
            : FSWOutstandingLoanFacilityLoanEntity,
        deps: entityType === FSWEntityTypes.APPLICATION
            ? [
                OUTSTANDING_LOAN_SERVICE_TOKEN,
                CREDIT_OUTSTANDING_LOANS_SERVICE_TOKEN,
                APPLICATION_MEMBER_SERVICE_TOKEN,
            ]
            : [],
    },
];

class OutstandingLoanFacilityComponent {
    set entityId(entityId) {
        this._componentStore.updateState({
            entityId,
        });
    }
    set entityType(entityType) {
        this._componentStore.updateState({
            entityType,
        });
    }
    set isReadonly(isReadonly) {
        this._componentStore.updateState({
            isReadonly,
        });
    }
    set hiddenComments(hiddenComments) {
        this._componentStore.updateState({
            hiddenComments,
        });
    }
    get count$() {
        return this._componentStore.array.valueChanges.pipe(startWith(this._componentStore.array.value), map((value) => value.length));
    }
    constructor(_componentStore, _dialog, _injector) {
        this._componentStore = _componentStore;
        this._dialog = _dialog;
        this._injector = _injector;
        this.form = this._componentStore.form;
        this.array = this._componentStore.array;
        this.state$ = this._componentStore.state$;
    }
    ngOnInit() {
        this._componentStore.init();
        this._componentStore.loadComments();
    }
    save() {
        this._componentStore.save();
    }
    addOutstandingLoanFacility() {
        this._componentStore.addNew();
    }
    remove(index) {
        const value = this._componentStore.array.value[index];
        if (!value.id) {
            this._componentStore.array.removeAt(index);
            return;
        }
        this._dialog
            .open(FSWOutstandingLoanFacilityConfirmComponent, {
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((check) => {
            if (check) {
                this._componentStore.remove(value.id);
            }
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OutstandingLoanFacilityComponent, deps: [{ token: FSW_OUTSTANDING_LOAN_FACILITY_STORE_TOKEN }, { token: i1$7.Dialog }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: OutstandingLoanFacilityComponent, selector: "fsw-outstanding-loan-facility", inputs: { entityId: "entityId", entityType: "entityType", isReadonly: "isReadonly", hiddenComments: "hiddenComments" }, ngImport: i0, template: "<fsw-panel [title]=\"'title' | fswTranslate\" *ngIf=\"state$ | async as state\">\n  <ng-template fswPanelHeaderSuffix>\n    <button\n      *ngIf=\"!state.isReadonly\"\n      fswButton\n      [appearance]=\"'secondary'\"\n      [disabled]=\"form.invalid || (count$ | async) === 0\"\n      (click)=\"save()\"\n    >\n      {{ 'buttons.save' | fswTranslate }}\n    </button>\n  </ng-template>\n  <section class=\"flex flex-col gap-[16px]\">\n    <section class=\"w-full overflow-auto\">\n      <form [formGroup]=\"form\">\n        <fsw-dynamic-builder [builder]=\"state.builder\">\n          <ng-template fswDynamicBuilderTemplate key=\"empty_list\">\n            <p class=\"w-full text-center text-yellow-500 font-bold p-[16px]\">\n              {{ 'empty' | fswTranslate }}\n            </p>\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"add_outstanding_loan_facility\">\n            <button\n              *ngIf=\"!state.isReadonly\"\n              fswButton\n              (click)=\"addOutstandingLoanFacility()\"\n              class=\"float-left\"\n            >\n              {{ 'buttons.add' | fswTranslate }}\n            </button>\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"no\" let-index=\"index\">\n            {{ index + 1 }}\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"delete\" let-index=\"index\">\n            <button\n              *ngIf=\"!state.isReadonly\"\n              fswButton\n              [appearance]=\"'icon-with-bg'\"\n              [size]=\"'m'\"\n              (click)=\"remove(index)\"\n            >\n              <i [fswIcon]=\"'common-delete-alternative'\"></i>\n            </button>\n          </ng-template>\n\n          <ng-template fswDynamicBuilderTemplate key=\"total\">\n            <div class=\"flex justify-between items-center\">\n              <ng-container *ngIf=\"array.valueChanges | async; else counting\">\n                <ng-container *ngTemplateOutlet=\"counting\"></ng-container>\n              </ng-container>\n              <ng-template #counting>\n                <span *ngIf=\"array.length\">\n                  {{ array.length }} {{ 'columns.facilities' | fswTranslate }}\n                </span>\n              </ng-template>\n              <span>{{ 'columns.total' | fswTranslate }}</span>\n            </div>\n          </ng-template>\n        </fsw-dynamic-builder>\n      </form>\n    </section>\n    <fsw-comments-section\n      [data]=\"state.comments\"\n      [enableSaveButton]=\"true\"\n      [isReadonly]=\"state.isReadonly\"\n      [translateScope]=\"'outstanding_loan_facility'\"\n    ></fsw-comments-section>\n  </section>\n</fsw-panel>\n", dependencies: [{ kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FSWDynamicBuilderTemplateDirective, selector: "[fswDynamicBuilderTemplate]", inputs: ["key"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "component", type: FSWCommentsSectionComponent, selector: "fsw-comments-section", inputs: ["data", "customClasses", "translateScope", "isReadonly", "enableSaveButton"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OutstandingLoanFacilityComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-outstanding-loan-facility', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-panel [title]=\"'title' | fswTranslate\" *ngIf=\"state$ | async as state\">\n  <ng-template fswPanelHeaderSuffix>\n    <button\n      *ngIf=\"!state.isReadonly\"\n      fswButton\n      [appearance]=\"'secondary'\"\n      [disabled]=\"form.invalid || (count$ | async) === 0\"\n      (click)=\"save()\"\n    >\n      {{ 'buttons.save' | fswTranslate }}\n    </button>\n  </ng-template>\n  <section class=\"flex flex-col gap-[16px]\">\n    <section class=\"w-full overflow-auto\">\n      <form [formGroup]=\"form\">\n        <fsw-dynamic-builder [builder]=\"state.builder\">\n          <ng-template fswDynamicBuilderTemplate key=\"empty_list\">\n            <p class=\"w-full text-center text-yellow-500 font-bold p-[16px]\">\n              {{ 'empty' | fswTranslate }}\n            </p>\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"add_outstanding_loan_facility\">\n            <button\n              *ngIf=\"!state.isReadonly\"\n              fswButton\n              (click)=\"addOutstandingLoanFacility()\"\n              class=\"float-left\"\n            >\n              {{ 'buttons.add' | fswTranslate }}\n            </button>\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"no\" let-index=\"index\">\n            {{ index + 1 }}\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"delete\" let-index=\"index\">\n            <button\n              *ngIf=\"!state.isReadonly\"\n              fswButton\n              [appearance]=\"'icon-with-bg'\"\n              [size]=\"'m'\"\n              (click)=\"remove(index)\"\n            >\n              <i [fswIcon]=\"'common-delete-alternative'\"></i>\n            </button>\n          </ng-template>\n\n          <ng-template fswDynamicBuilderTemplate key=\"total\">\n            <div class=\"flex justify-between items-center\">\n              <ng-container *ngIf=\"array.valueChanges | async; else counting\">\n                <ng-container *ngTemplateOutlet=\"counting\"></ng-container>\n              </ng-container>\n              <ng-template #counting>\n                <span *ngIf=\"array.length\">\n                  {{ array.length }} {{ 'columns.facilities' | fswTranslate }}\n                </span>\n              </ng-template>\n              <span>{{ 'columns.total' | fswTranslate }}</span>\n            </div>\n          </ng-template>\n        </fsw-dynamic-builder>\n      </form>\n    </section>\n    <fsw-comments-section\n      [data]=\"state.comments\"\n      [enableSaveButton]=\"true\"\n      [isReadonly]=\"state.isReadonly\"\n      [translateScope]=\"'outstanding_loan_facility'\"\n    ></fsw-comments-section>\n  </section>\n</fsw-panel>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_OUTSTANDING_LOAN_FACILITY_STORE_TOKEN]
                }] }, { type: i1$7.Dialog }, { type: i0.Injector }]; }, propDecorators: { entityId: [{
                type: Input
            }], entityType: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], hiddenComments: [{
                type: Input
            }] } });

class FSwOutstandingLoanFacilityDirective {
    constructor(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
        this.entityId = null;
        this.entityType = FSWEntityTypes.LOAN;
        this.isReadonly = false;
        this.hiddenComments = [];
    }
    ngOnChanges() {
        this._viewContainerRef.clear();
        const ref = this._viewContainerRef.createComponent(OutstandingLoanFacilityComponent, {
            injector: Injector.create({
                parent: this._viewContainerRef.injector,
                providers: [
                    ...outstandingLoanFacilityEntityLoadProviders(this.entityType),
                    ...outstandingLoanFacilityLoadProviders(getCountryCodeFromStorage()),
                ],
            }),
        });
        const instance = ref.instance;
        instance.entityId = this.entityId;
        instance.entityType = this.entityType;
        instance.isReadonly = this.isReadonly;
        instance.hiddenComments = this.hiddenComments;
        ref.changeDetectorRef.detectChanges();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSwOutstandingLoanFacilityDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSwOutstandingLoanFacilityDirective, selector: "[fswOutstandingLoanFacility]", inputs: { entityId: "entityId", entityType: "entityType", isReadonly: "isReadonly", hiddenComments: "hiddenComments" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSwOutstandingLoanFacilityDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswOutstandingLoanFacility]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; }, propDecorators: { entityId: [{
                type: Input
            }], entityType: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], hiddenComments: [{
                type: Input
            }] } });

class FSWOutstandingLoanFacilityModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWOutstandingLoanFacilityModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWOutstandingLoanFacilityModule, declarations: [FSwOutstandingLoanFacilityDirective,
            OutstandingLoanFacilityComponent,
            FSWOutstandingLoanFacilityConfirmComponent], imports: [i1$4.FSWTranslateModule, FSWButtonModule,
            NgIf,
            ReactiveFormsModule,
            FSWDynamicBuilderModule,
            AsyncPipe,
            NgTemplateOutlet,
            FSWPanelModule,
            OutstandingLoansServiceModule,
            CreditOutstandingLoansServiceModule,
            ApplicationMemberServiceModule,
            FSWIconModule,
            FSWButtonModule,
            FSWCommentsSectionComponent,
            FSWModalModule$1,
            DialogModule], exports: [FSwOutstandingLoanFacilityDirective,
            OutstandingLoanFacilityComponent,
            FSWOutstandingLoanFacilityConfirmComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWOutstandingLoanFacilityModule, imports: [FSWTranslateModule.forFeature({
                scope: 'outstanding_loan_facility',
                defaultKey: CountryCode.MY,
                data: FSW_OUTSTANDING_LOAN_FACILITY_TRANSLATION_LOADER,
            }),
            FSWButtonModule,
            ReactiveFormsModule,
            FSWDynamicBuilderModule,
            FSWPanelModule,
            OutstandingLoansServiceModule,
            CreditOutstandingLoansServiceModule,
            ApplicationMemberServiceModule,
            FSWIconModule,
            FSWButtonModule,
            FSWCommentsSectionComponent,
            FSWModalModule$1,
            DialogModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWOutstandingLoanFacilityModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FSwOutstandingLoanFacilityDirective,
                        OutstandingLoanFacilityComponent,
                        FSWOutstandingLoanFacilityConfirmComponent,
                    ],
                    exports: [
                        FSwOutstandingLoanFacilityDirective,
                        OutstandingLoanFacilityComponent,
                        FSWOutstandingLoanFacilityConfirmComponent,
                    ],
                    imports: [
                        FSWTranslateModule.forFeature({
                            scope: 'outstanding_loan_facility',
                            defaultKey: CountryCode.MY,
                            data: FSW_OUTSTANDING_LOAN_FACILITY_TRANSLATION_LOADER,
                        }),
                        FSWButtonModule,
                        NgIf,
                        ReactiveFormsModule,
                        FSWDynamicBuilderModule,
                        AsyncPipe,
                        NgTemplateOutlet,
                        FSWPanelModule,
                        OutstandingLoansServiceModule,
                        CreditOutstandingLoansServiceModule,
                        ApplicationMemberServiceModule,
                        FSWIconModule,
                        FSWButtonModule,
                        FSWCommentsSectionComponent,
                        FSWModalModule$1,
                        DialogModule,
                    ],
                }]
        }] });

var title$i = "Personal Guarantor Details";
var item$1 = "PG {{index}}";
var empty$7 = "Empty Personal Guarantor in current application";
var fields$e = {
	name: "Personal Guarantor Name",
	age: "Age",
	noa_year: "NOA Year {{index}}",
	noa_year_total_income: "Total Income",
	gender: "Gender",
	total_borrowing_limit: "Total Borrowing Limit",
	total_borrowing_outstanding: "Total Borrowing Outstanding",
	nationality: "Nationality",
	race: "Race",
	role: "Role",
	does_own_property: "Does PG own property in Malaysia?",
	desktop_valuation: "Desktop Valuation of MY owned property",
	shareholder_percentage: "Percentage Shareholder",
	negative_and_black_list: "Negative / Black List",
	num_of_borrowing: "No. of Borrowings",
	total_monthly_commitment: "Total monthly commitment (CCRIS only)",
	payment_behavior: "Conduct of account",
	num_of_recent_credit_applications: "Number of recent credit applications",
	credit_application_commitment: "Recent Credit Application Commitment",
	litigation: "Litigation",
	total_outstanding_amount_trade_reference: "Total outstanding amount (Trade Reference)",
	total_monthly_commitment_non_bank_lender: "Total Commitment (Non Bank Lender)",
	desktop_valuation_of_owned_property: "Desktop Valuation of MY owned property",
	background_and_experience: "Background experience",
	month_of_experience: "Month of Experience",
	date_of_birth: "Date of Birth"
};
var comments$1 = {
	factsheet: "Factsheet Comments",
	credit: "Credit Comments"
};
var options$1 = {
	race: {
		malay: "Malay",
		chinese: "Chinese",
		indian: "Indian",
		others: "Others"
	}
};
var buttons$s = {
	save: "Save Changes",
	view_docs: "View Docs"
};
var personalGuarantorMy = {
	title: title$i,
	item: item$1,
	empty: empty$7,
	fields: fields$e,
	comments: comments$1,
	options: options$1,
	buttons: buttons$s
};

var MY$a = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$s,
    comments: comments$1,
    default: personalGuarantorMy,
    empty: empty$7,
    fields: fields$e,
    item: item$1,
    options: options$1,
    title: title$i
});

const PERSONAL_GUARANTOR_MY_TRANSLATION = MY$a;

function injectPersonalGuarantorMYForm({ designations, genders, isReadonly, }) {
    const form = new UntypedFormGroup({});
    const translation = PERSONAL_GUARANTOR_MY_TRANSLATION;
    const builder = new FSWDynamicBuilder({
        form,
        formType: FSWDynamicBuilderFormTypes.GROUP,
        renderBy: 'container',
        customClasses: 'flex flex-col gap-[16px]',
        readonlyWhen$: of(isReadonly),
        containers: [
            {
                customClasses: 'flex flex-wrap gap-[8px] w-full',
                fields: [
                    personalGuarantorForm.name({
                        control: {
                            validations: [Validators.required],
                            context: {
                                label: translation.fields.name,
                                isDisabled: true,
                                isRequired: true,
                                showError: true,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.age({
                        control: {
                            context: {
                                label: translation.fields.age,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                ],
            },
            {
                customClasses: 'flex flex-wrap gap-[8px] w-full',
                fields: [
                    personalGuarantorForm.gender({
                        control: {
                            context: {
                                label: translation.fields.gender,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                        pickList: {
                            genders,
                        },
                    }),
                    personalGuarantorForm.nationality({
                        control: {
                            context: {
                                label: translation.fields.nationality,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                ],
            },
            {
                customClasses: 'flex flex-wrap gap-[8px] w-full',
                fields: [
                    personalGuarantorForm.race({
                        control: {
                            context: {
                                label: translation.fields.race,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                        pickList: {
                            races: [
                                {
                                    value: translation.options.race.malay,
                                    text: translation.options.race.malay,
                                },
                                {
                                    value: translation.options.race.chinese,
                                    text: translation.options.race.chinese,
                                },
                                {
                                    value: translation.options.race.indian,
                                    text: translation.options.race.indian,
                                },
                                {
                                    value: translation.options.race.others,
                                    text: translation.options.race.others,
                                },
                            ],
                        },
                    }),
                    personalGuarantorForm.role({
                        control: {
                            context: {
                                label: translation.fields.role,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                        pickList: {
                            designations,
                        },
                    }),
                ],
            },
            {
                customClasses: 'flex flex-wrap gap-[8px] w-full',
                fields: [
                    personalGuarantorForm.shareholder_percentage({
                        control: {
                            context: {
                                label: translation.fields.shareholder_percentage,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.negative_and_black_list({
                        control: {
                            context: {
                                label: translation.fields.negative_and_black_list,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                ],
            },
            {
                customClasses: 'flex flex-wrap gap-[8px] w-full items-end',
                fields: [
                    personalGuarantorForm.noa_year1({
                        control: {
                            validations: [Validators.required],
                            context: {
                                label: translation.fields.noa_year.replace('{{index}}', '1'),
                                showError: true,
                                isRequired: true,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.noa_year1_total_income({
                        control: {
                            validations: [Validators.required],
                            context: {
                                label: translation.fields.noa_year_total_income.replace('{{index}}', '1'),
                                showError: true,
                                isRequired: true,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                ],
            },
            {
                customClasses: 'flex flex-wrap gap-[8px] w-full items-end',
                fields: [
                    personalGuarantorForm.noa_year2({
                        control: {
                            validations: [Validators.required],
                            context: {
                                label: translation.fields.noa_year.replace('{{index}}', '2'),
                                showError: true,
                                isRequired: true,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.noa_year2_total_income({
                        control: {
                            validations: [Validators.required],
                            context: {
                                label: translation.fields.noa_year_total_income.replace('{{index}}', '2'),
                                showError: true,
                                isRequired: true,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                ],
            },
            {
                customClasses: 'flex flex-wrap gap-[8px] w-full',
                fields: [
                    personalGuarantorForm.month_of_experience({
                        control: {
                            context: {
                                label: translation.fields.month_of_experience,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.date_of_birth({
                        control: {
                            context: {
                                label: translation.fields.date_of_birth,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                ],
            },
            {
                customClasses: 'flex flex-wrap gap-[8px] w-full',
                fields: [
                    personalGuarantorForm.total_borrowing_limit({
                        control: {
                            context: {
                                label: translation.fields.total_borrowing_limit,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.total_borrowing_outstanding({
                        control: {
                            context: {
                                label: translation.fields.total_borrowing_outstanding,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                ],
            },
            {
                customClasses: 'flex flex-wrap gap-[8px] w-full',
                fields: [
                    personalGuarantorForm.num_of_borrowing({
                        control: {
                            context: {
                                label: translation.fields.num_of_borrowing,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.payment_behavior({
                        control: {
                            context: {
                                label: translation.fields.payment_behavior,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                ],
            },
            {
                customClasses: 'flex flex-wrap gap-[8px] w-full',
                fields: [
                    personalGuarantorForm.litigation({
                        control: {
                            context: {
                                label: translation.fields.litigation,
                            },
                        },
                        element: {
                            customClasses: 'w-full',
                        },
                    }),
                ],
            },
            {
                customClasses: 'flex flex-wrap gap-[8px] w-full',
                fields: [
                    personalGuarantorForm.num_of_recent_credit_applications({
                        control: {
                            context: {
                                label: translation.fields.num_of_recent_credit_applications,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.credit_application_commitment({
                        control: {
                            context: {
                                label: translation.fields.credit_application_commitment,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                ],
            },
            {
                customClasses: 'flex flex-wrap gap-[8px] w-full',
                fields: [
                    personalGuarantorForm.does_own_property_in_my({
                        control: {
                            context: {
                                renderTemplate: {
                                    label: translation.fields.does_own_property,
                                },
                            },
                        },
                    }),
                ],
            },
            {
                customClasses: 'flex flex-wrap gap-[8px] w-full',
                fields: [
                    personalGuarantorForm.total_monthly_commitment_non_bank_lender({
                        control: {
                            context: {
                                label: translation.fields.total_monthly_commitment_non_bank_lender,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.desktop_valuation_of_my_owned_property({
                        control: {
                            context: {
                                label: translation.fields.desktop_valuation_of_owned_property,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                ],
            },
            {
                customClasses: 'flex flex-wrap gap-[8px] w-full',
                fields: [
                    personalGuarantorForm.total_monthly_commitment({
                        control: {
                            context: {
                                label: translation.fields.total_monthly_commitment,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.total_outstanding_amount_trade_reference({
                        control: {
                            context: {
                                label: translation.fields.total_outstanding_amount_trade_reference,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                ],
            },
            {
                customClasses: 'flex flex-wrap gap-[16px] w-full',
                fields: [
                    personalGuarantorForm.background_and_experience({
                        control: {
                            context: {
                                label: translation.fields.background_and_experience,
                            },
                        },
                        element: {
                            customClasses: 'w-full',
                        },
                    }),
                ],
            },
            {
                customClasses: 'hidden',
                fields: [
                    personalGuarantorForm.id({
                        control: {
                            context: {
                                isHidden: true,
                            },
                        },
                    }),
                    personalGuarantorForm.id_number({
                        control: {
                            context: {
                                isHidden: true,
                            },
                        },
                    }),
                ],
            },
        ],
    });
    return { builder, form };
}

function injectPersonalGuarantorMYEffects({ applicationIdSignal, isReadonlySignal, gendersSignal, designationsSignal, hiddenCommentsSignal, memberSignal, itemsSignal, summariesSignal, formArray, }) {
    const alertService = inject(FSW_ALERT_SERVICE_TOKEN);
    const application = {
        guarantorService: injectApplicationGuarantorService(),
        memberService: injectApplicationMemberService(),
    };
    const credit = {
        guarantorService: injectCreditGuarantorService(),
        memberService: injectMemberService(),
    };
    const loadMember = (applicationId) => application.memberService
        .getApplicationMainBorrower(applicationId)
        .pipe(tap((data) => memberSignal.set(data)), catchError(() => {
        alertService.error('Failed to load member', null, {
            duration: 3000,
        });
        memberSignal.set(null);
        return of(null);
    }))
        .subscribe();
    const loadSummaries = (applicationId, member) => application.guarantorService
        .getSummaries(applicationId)
        .pipe(map((summaries) => summaries
        ? summaries
            .filter((summary) => summary.guarantor_summary_type === FSWRecourseTypes.PG)
            .map((item) => [item.guarantor_summary_id, item.business_interest_party_id])
        : []), switchMap$1((ids) => {
        if (ids.length) {
            return credit.guarantorService.getPersonalSummaries(ids.map((id) => id[0])).pipe(map((data) => data.map((item) => {
                const bip = ids.find((id) => id[0] === item.id);
                if (bip?.[1]) {
                    item.id_number = bip[1];
                }
                return item;
            })));
        }
        return of([]);
    }), switchMap$1((summaries) => credit.memberService
        .getMergeBipNames(applicationIdSignal(), member.uuid, {
        expand: true,
    }, getEntityNoFallBackToUEN(member.company_ctos_entity, member.company_registration_number))
        .pipe(map((bips) => summaries.map((summary) => {
        const bipSummary = bips?.find((bip) => bip.id == summary.id_number);
        if (bipSummary) {
            summary.name = bipSummary.name;
        }
        return summary;
    })), map((data) => data.map((item) => ({
        ...item,
        date_of_birth: toTimezoneHourOffset(item.date_of_birth, 'down'),
    }))))), tap((data) => summariesSignal.set(data)), catchError(() => {
        alertService.error('Failed to load summaries', null, {
            duration: 3000,
        });
        summariesSignal.set([]);
        return of([]);
    }))
        .subscribe();
    const refreshMember = () => {
        const applicationId = applicationIdSignal();
        if (!applicationId) {
            return;
        }
        loadMember(applicationId);
    };
    const refreshSummaries = () => {
        const applicationId = applicationIdSignal();
        const member = memberSignal();
        if (!applicationId || !member) {
            return;
        }
        loadSummaries(applicationId, member);
    };
    const buildComments = (item) => {
        return [
            {
                title: '',
                customClasses: 'w-full flex flex-col gap-4',
                items: [
                    {
                        category: 'FACTSHEET',
                        title: 'comments.factsheet',
                        module: 'PG_SUMMARY',
                        identifier: item.id,
                        entityId: applicationIdSignal(),
                        fields: [
                            {
                                key: 'main_comment',
                                label: 'comments.factsheet',
                            },
                        ],
                    },
                    {
                        category: 'CREDIT',
                        title: 'comments.credit',
                        module: 'PG_SUMMARY',
                        identifier: item.id,
                        entityId: applicationIdSignal(),
                        fields: [
                            {
                                key: 'main_comment',
                                label: 'comments.credit',
                            },
                        ],
                    },
                ].filter((item) => !hiddenCommentsSignal().includes(item.category)),
            },
        ];
    };
    return {
        init: () => {
            effect(() => refreshMember(), { allowSignalWrites: true });
            effect(() => refreshSummaries(), { allowSignalWrites: true });
            effect(() => {
                const summaries = summariesSignal();
                formArray.clear();
                itemsSignal.set(summaries.map((item) => {
                    const { builder, form } = injectPersonalGuarantorMYForm({
                        isReadonly: isReadonlySignal(),
                        designations: designationsSignal().filter((designation) => designation.country_code === CountryCode.MY),
                        genders: gendersSignal(),
                    });
                    form.patchValue(item);
                    formArray.push(form);
                    return { builder, comments: buildComments(item) };
                }));
            }, { allowSignalWrites: true });
        },
        save: () => {
            if (formArray.invalid || formArray.getRawValue().length === 0) {
                return;
            }
            const payload = formArray
                .getRawValue()
                .map((item) => ({
                ...item,
                date_of_birth: toTimezoneHourOffset(item.date_of_birth),
            }));
            const { putList, postList } = payload.reduce((acc, item) => {
                if (item.id) {
                    acc.putList.push(transformPersonalGuarantor(item));
                }
                else {
                    acc.postList.push(transformPersonalGuarantor(item));
                }
                return acc;
            }, {
                putList: [],
                postList: [],
            });
            const member = memberSignal();
            forkJoin([
                ...(putList.length ? [credit.guarantorService.updatePersonalSummaries(putList)] : []),
                ...(postList.length
                    ? [
                        credit.memberService
                            .getBips(getEntityNoFallBackToUEN(member.company_ctos_entity, member.company_registration_number))
                            .pipe(switchMap$1((bips) => credit.guarantorService.addPersonalSummaries(postList).pipe(map((data) => data.map((item) => ({
                            guarantor_summary_id: item.id,
                            guarantor_summary_type: FSWRecourseTypes.PG,
                            business_interest_party_id: bips.find((bip) => bip.idNumber === item.id_number)?.id,
                        }))))), switchMap$1((data) => application.guarantorService.addSummaries(applicationIdSignal(), data))),
                    ]
                    : []),
            ])
                .pipe(tapResponse(() => {
                alertService.success('Success', 'Personal Guarantor successfully saved!', {
                    duration: 3000,
                });
                refreshSummaries();
            }, () => {
                alertService.error('Error', 'Failed to save personal guarantor', {
                    duration: 3000,
                });
            }))
                .subscribe();
        },
    };
}

var title$h = "Personal Guarantor Details";
var item = "PG {{index}}";
var empty$6 = "Empty Personal Guarantor in current application";
var fields$d = {
	id_number: "NRIC",
	name: "Personal Guarantor Name",
	age: "Age",
	noa_year: "NOA Year {{index}}",
	noa_year_total_income: "Total Income",
	gender: "Gender",
	total_borrowing_limit: "Total Borrowing Limit",
	total_borrowing_outstanding: "Total Borrowing Outstanding",
	nationality: "Nationality",
	race: "Race",
	role: "Role",
	does_own_property: "Does PG own property in Malaysia?",
	desktop_valuation: "Desktop Valuation of MY owned property",
	shareholder_percentage: "Percentage Shareholder",
	negative_and_black_list: "Negative / Black List",
	num_of_borrowing: "No. of Borrowings",
	total_monthly_commitment: "Total monthly commitment (CCRIS only)",
	payment_behavior: "Conduct of account",
	num_of_recent_credit_applications: "Number of recent credit applications",
	credit_application_commitment: "Recent Credit Application Commitment",
	litigation: "Litigation",
	total_outstanding_amount_trade_reference: "Total outstanding amount (Trade Reference)",
	total_monthly_commitment_non_bank_lender: "Total Commitment (Non Bank Lender)",
	desktop_valuation_of_owned_property: "Desktop Valuation of SG owned property",
	background_and_experience: "Background experience",
	month_of_experience: "Month of Experience",
	date_of_birth: "Date of Birth",
	experian_payment_grade: "Experian Credit Payment Grade",
	experian_expected_default: "Experian Expected Default Probability",
	child_relief: "Child Relief",
	country_where_main_operations_based_in: "Country where main operations of PG based",
	num_of_pending_litigation: "Pending litigations",
	num_of_bankruptcy: "Bankruptcy Last 3 years",
	num_of_ongoing_moneylender_loans: "Ongoing Moneylender Loans",
	cbs_rating: "CBS Rating",
	cbs_probability_of_default: "CBS Probability of Default",
	cbs_total_unsecured_limit: "CBS Total Unsecured Limit",
	cbs_total_secured_limit: "CBS Total Secured Credit Limit",
	cbs_bankruptcy_proceeding_count: "CBS Bankruptcy Proceedings",
	cbs_total_unsecured_balances_interest_bearing: "CBS Total Unsecured Balance Interest Bearing",
	cbs_total_unsecured_balances_non_interest_bearing: "CBS Total Unsecured Balance Non-Interest Bearing",
	cbs_total_secured_balances: "CBS Total Secured Balances",
	cbs_total_overdue_balances: "CBS Total Overdue Balance",
	cbs_default_count: "CBS Outstanding Defaults",
	cbs_total_unsecured_outstanding_amount: "CBS Total Unsecured Outstanding Balances"
};
var comments = {
	factsheet: "Factsheet Comments",
	credit: "Credit Comments"
};
var options = {
	race: {
		malay: "Malay",
		chinese: "Chinese",
		indian: "Indian",
		others: "Others"
	}
};
var buttons$r = {
	save: "Save Changes",
	pull: "Pull CBS",
	view_docs: "View Docs"
};
var personalGuarantorSg = {
	title: title$h,
	item: item,
	empty: empty$6,
	fields: fields$d,
	comments: comments,
	options: options,
	buttons: buttons$r
};

var SG$3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$r,
    comments: comments,
    default: personalGuarantorSg,
    empty: empty$6,
    fields: fields$d,
    item: item,
    options: options,
    title: title$h
});

const PERSONAL_GUARANTOR_SG_TRANSLATION = SG$3;

function injectPersonalGuarantorSGForm({ designations, genders, countries, isReadonly, canPullCBS, memberIdInt, }) {
    const form = new UntypedFormGroup({});
    const translation = PERSONAL_GUARANTOR_SG_TRANSLATION;
    const builder = new FSWDynamicBuilder({
        form,
        formType: FSWDynamicBuilderFormTypes.GROUP,
        renderBy: 'container',
        customClasses: 'flex flex-col gap-[16px]',
        readonlyWhen$: of(isReadonly),
        containers: [
            {
                customClasses: 'flex flex-wrap gap-[8px] w-full',
                fields: [
                    personalGuarantorForm.name({
                        control: {
                            validations: [Validators.required],
                            context: {
                                label: translation.fields.name,
                                isDisabled: true,
                                isRequired: true,
                                showError: true,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    dynamicForm.text('id_number', {}, {
                        control: {
                            validations: [Validators.required],
                            context: {
                                label: translation.fields.id_number,
                                isDisabled: true,
                                isRequired: true,
                                showError: true,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                ],
            },
            {
                customClasses: 'flex flex-wrap gap-[8px] w-full',
                fields: [
                    personalGuarantorForm.age({
                        control: {
                            context: {
                                label: translation.fields.age,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.gender({
                        control: {
                            context: {
                                label: translation.fields.gender,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                        pickList: {
                            genders,
                        },
                    }),
                ],
            },
            {
                customClasses: 'flex flex-wrap gap-[8px] w-full',
                fields: [
                    personalGuarantorForm.nationality({
                        control: {
                            context: {
                                label: translation.fields.nationality,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.does_own_property_in_sg({
                        control: {
                            context: {
                                renderTemplate: {
                                    label: translation.fields.does_own_property,
                                },
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                ],
            },
            {
                customClasses: 'flex flex-wrap gap-[8px] w-full',
                fields: [
                    personalGuarantorForm.race({
                        control: {
                            context: {
                                label: translation.fields.race,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                        pickList: {
                            races: [
                                {
                                    value: translation.options.race.malay,
                                    text: translation.options.race.malay,
                                },
                                {
                                    value: translation.options.race.chinese,
                                    text: translation.options.race.chinese,
                                },
                                {
                                    value: translation.options.race.indian,
                                    text: translation.options.race.indian,
                                },
                                {
                                    value: translation.options.race.others,
                                    text: translation.options.race.others,
                                },
                            ],
                        },
                    }),
                    personalGuarantorForm.role({
                        control: {
                            context: {
                                label: translation.fields.role,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                        pickList: {
                            designations,
                        },
                    }),
                ],
            },
            {
                customClasses: 'flex flex-wrap gap-[8px] w-full',
                fields: [
                    personalGuarantorForm.shareholder_percentage({
                        control: {
                            context: {
                                label: translation.fields.shareholder_percentage,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.negative_and_black_list({
                        control: {
                            context: {
                                label: translation.fields.negative_and_black_list,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                ],
            },
            {
                customClasses: 'flex flex-wrap gap-[8px] w-full',
                fields: [
                    personalGuarantorForm.experian_payment_grade({
                        control: {
                            context: {
                                label: translation.fields.experian_payment_grade,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.experian_expected_default({
                        control: {
                            context: {
                                label: translation.fields.experian_expected_default,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                ],
            },
            {
                customClasses: 'flex flex-wrap gap-[8px] w-full items-end',
                fields: [
                    personalGuarantorForm.noa_year1({
                        control: {
                            // validations: [Validators.required],
                            context: {
                                label: translation.fields.noa_year.replace('{{index}}', '1'),
                                showError: true,
                                // isRequired: true,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.noa_year1_total_income({
                        control: {
                            // validations: [Validators.required],
                            context: {
                                label: translation.fields.noa_year_total_income.replace('{{index}}', '1'),
                                showError: true,
                                // isRequired: true,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                ],
            },
            {
                customClasses: 'flex flex-wrap gap-[8px] w-full items-end',
                fields: [
                    personalGuarantorForm.noa_year2({
                        control: {
                            // validations: [Validators.required],
                            context: {
                                label: translation.fields.noa_year.replace('{{index}}', '2'),
                                showError: true,
                                // isRequired: true,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.noa_year2_total_income({
                        control: {
                            // validations: [Validators.required],
                            context: {
                                label: translation.fields.noa_year_total_income.replace('{{index}}', '2'),
                                showError: true,
                                // isRequired: true,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                ],
            },
            {
                customClasses: 'flex flex-wrap gap-[8px] w-full items-end',
                fields: [
                    personalGuarantorForm.child_relief({
                        control: {
                            context: {
                                label: translation.fields.child_relief,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.num_of_ongoing_moneylender_loans({
                        control: {
                            context: {
                                label: translation.fields.num_of_ongoing_moneylender_loans,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                ],
            },
            {
                customClasses: 'flex flex-wrap gap-[8px] w-full items-end',
                fields: [
                    personalGuarantorForm.num_of_pending_litigation({
                        control: {
                            context: {
                                label: translation.fields.num_of_pending_litigation,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.num_of_bankruptcy({
                        control: {
                            context: {
                                label: translation.fields.num_of_bankruptcy,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                ],
            },
            {
                customClasses: 'flex flex-wrap gap-[8px] w-full items-end',
                fields: [
                    personalGuarantorForm.desktop_valuation_of_sg_owned_property({
                        control: {
                            context: {
                                label: translation.fields.desktop_valuation_of_owned_property,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.country_where_main_operations_based_in({
                        control: {
                            context: {
                                label: translation.fields.country_where_main_operations_based_in,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                        pickList: {
                            countries,
                        },
                    }),
                ],
            },
            {
                name: 'personal-guarantor-container',
                customClasses: 'flex flex-wrap gap-y-[16px] gap-x-[8px] w-full',
                customProps: {
                    title: 'CBS',
                    canPullCBS,
                    memberIdInt,
                },
                fields: [
                    personalGuarantorForm.cbs_rating({
                        control: {
                            validations: [Validators.required],
                            context: {
                                label: translation.fields.cbs_rating,
                                isRequired: true,
                                showError: true,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.cbs_probability_of_default({
                        control: {
                            context: {
                                label: translation.fields.cbs_probability_of_default,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.cbs_total_unsecured_limit({
                        control: {
                            context: {
                                label: translation.fields.cbs_total_unsecured_limit,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.cbs_total_secured_limit({
                        control: {
                            context: {
                                label: translation.fields.cbs_total_secured_limit,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.cbs_bankruptcy_proceeding_count({
                        control: {
                            context: {
                                label: translation.fields.cbs_bankruptcy_proceeding_count,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.cbs_total_unsecured_balances_interest_bearing({
                        control: {
                            context: {
                                label: translation.fields.cbs_total_unsecured_balances_interest_bearing,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.cbs_total_unsecured_balances_non_interest_bearing({
                        control: {
                            context: {
                                label: translation.fields.cbs_total_unsecured_balances_non_interest_bearing,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.cbs_total_secured_balances({
                        control: {
                            context: {
                                label: translation.fields.cbs_total_secured_balances,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.cbs_total_overdue_balances({
                        control: {
                            context: {
                                label: translation.fields.cbs_total_overdue_balances,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.cbs_default_count({
                        control: {
                            context: {
                                label: translation.fields.cbs_default_count,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                    personalGuarantorForm.cbs_total_unsecured_outstanding_amount({
                        control: {
                            context: {
                                label: translation.fields.cbs_total_unsecured_outstanding_amount,
                            },
                        },
                        element: {
                            customClasses: 'w-[calc(50%-4px)]',
                        },
                    }),
                ],
            },
            {
                customClasses: 'hidden',
                fields: [
                    personalGuarantorForm.id({
                        control: {
                            context: {
                                isHidden: true,
                            },
                        },
                    }),
                ],
            },
        ],
    });
    return { builder, form };
}

function injectPersonalGuarantorSGEffects({ applicationIdSignal, isReadonlySignal, gendersSignal, designationsSignal, hiddenCommentsSignal, memberSignal, itemsSignal, countriesSignal, canPullCBSSignal, summariesSignal, viewerDocsSignal, formArray, }) {
    const alertService = inject(FSW_ALERT_SERVICE_TOKEN);
    const blobService = injectBlobService();
    const domSanitizer = inject(DomSanitizer);
    const application = {
        guarantorService: injectApplicationGuarantorService(),
        memberService: injectApplicationMemberService(),
    };
    const credit = {
        guarantorService: injectCreditGuarantorService(),
        memberService: injectMemberService(),
    };
    const loadMember = (applicationId) => application.memberService
        .getApplicationMainBorrower(applicationId)
        .pipe(tap((data) => memberSignal.set(data)), catchError(() => {
        alertService.error('Failed to load member', null, {
            duration: 3000,
        });
        memberSignal.set(null);
        return of(null);
    }))
        .subscribe();
    const loadSummaries = (applicationId, member) => application.guarantorService
        .getSummaries(applicationId)
        .pipe(map((summaries) => summaries
        ? summaries
            .filter((summary) => summary.guarantor_summary_type === FSWRecourseTypes.PG)
            .map((item) => [item.guarantor_summary_id, item.business_interest_party_id])
        : []), switchMap$1((ids) => {
        if (ids.length) {
            return credit.guarantorService.getPersonalSummaries(ids.map((id) => id[0]));
        }
        return of([]);
    }), switchMap$1((summaries) => credit.memberService
        .getMergeBipNames(applicationIdSignal(), member.uuid, {
        expand: true,
    }, member.company_registration_number)
        .pipe(map((bips) => {
        return summaries.map((summary, i) => {
            const bipSummary = bips?.find((bip) => bip.id == summary.id_number);
            if (bipSummary) {
                summary.name = bipSummary.name;
            }
            return summary;
        });
    }), map((data) => data.map((item) => ({
        ...item,
        date_of_birth: toTimezoneHourOffset(item.date_of_birth, 'down'),
    }))))), tap((data) => summariesSignal.set(data)), catchError(() => {
        alertService.error('Failed to load summaries', null, {
            duration: 3000,
        });
        summariesSignal.set([]);
        return of([]);
    }))
        .subscribe();
    const loadViewerDocs = (applicationId) => blobService
        .getApplicationMemberDoc(applicationId, ['CBS', 'BRI', 'NOA'])
        .pipe(filter((docs) => !!docs?.length), switchMap$1((docs) => forkJoin(docs.map((doc) => blobService.downloadV3Blob(doc.uuid).pipe(map((blob) => domSanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob))), map((src) => src
        ? {
            id: doc.uuid,
            name: doc.name,
            type: doc.docType,
            src,
        }
        : null)))).pipe(map((docs) => docs.filter((doc) => !!doc)), map((docs) => docs.reduce((acc, doc) => {
        const index = acc.findIndex((item) => item.type === doc.type);
        const viewerDoc = omit(doc, 'type');
        if (index === -1) {
            acc.push({
                type: doc.type,
                items: [viewerDoc],
            });
        }
        else {
            acc[index].items.push(viewerDoc);
        }
        return acc;
    }, [])), tapResponse((docs) => viewerDocsSignal.set(docs), () => {
        viewerDocsSignal.set([]);
        alertService.error('Error', 'Failed to load documents', {
            duration: 3000,
        });
    }))))
        .subscribe();
    const refreshMember = () => {
        const applicationId = applicationIdSignal();
        if (!applicationId) {
            return;
        }
        loadMember(applicationId);
    };
    const refreshSummaries = () => {
        const applicationId = applicationIdSignal();
        const member = memberSignal();
        if (!applicationId || !member) {
            return;
        }
        loadSummaries(applicationId, member);
    };
    const refreshViewerDocs = () => {
        const applicationId = applicationIdSignal();
        const summaries = summariesSignal();
        if (!applicationId || !summaries?.length) {
            return;
        }
        loadViewerDocs(applicationId);
    };
    const buildComments = (item) => {
        return [
            {
                title: '',
                customClasses: 'w-full flex flex-col gap-4',
                items: [
                    {
                        category: 'FACTSHEET',
                        title: 'comments.factsheet',
                        module: 'PG_SUMMARY',
                        identifier: item.id,
                        entityId: applicationIdSignal(),
                        fields: [
                            {
                                key: 'main_comment',
                                label: 'comments.factsheet',
                            },
                        ],
                    },
                    {
                        category: 'CREDIT',
                        title: 'comments.credit',
                        module: 'PG_SUMMARY',
                        identifier: item.id,
                        entityId: applicationIdSignal(),
                        fields: [
                            {
                                key: 'main_comment',
                                label: 'comments.credit',
                            },
                        ],
                    },
                ].filter((item) => !hiddenCommentsSignal().includes(item.category)),
            },
        ];
    };
    return {
        init: () => {
            effect(() => refreshMember(), { allowSignalWrites: true });
            effect(() => refreshSummaries(), { allowSignalWrites: true });
            effect(() => refreshViewerDocs(), { allowSignalWrites: true });
            effect(() => {
                const summaries = summariesSignal();
                formArray.clear();
                itemsSignal.set(summaries.map((item) => {
                    const { builder, form } = injectPersonalGuarantorSGForm({
                        isReadonly: isReadonlySignal(),
                        designations: designationsSignal().filter((designation) => designation.country_code === CountryCode.MY),
                        genders: gendersSignal(),
                        countries: countriesSignal(),
                        canPullCBS: canPullCBSSignal() && !isReadonlySignal(),
                        memberIdInt: +memberSignal().id,
                    });
                    form.patchValue(item);
                    formArray.push(form);
                    return { builder, comments: buildComments(item) };
                }));
            }, { allowSignalWrites: true });
        },
        save: () => {
            if (formArray.invalid || formArray.getRawValue().length === 0) {
                return;
            }
            const payload = formArray
                .getRawValue()
                .map((item) => ({
                ...item,
                date_of_birth: toTimezoneHourOffset(item.date_of_birth),
            }));
            const { putList, postList } = payload.reduce((acc, item) => {
                if (item.id) {
                    acc.putList.push(transformPersonalGuarantor(item));
                }
                else {
                    acc.postList.push(transformPersonalGuarantor(item));
                }
                return acc;
            }, {
                putList: [],
                postList: [],
            });
            forkJoin([
                ...(putList.length ? [credit.guarantorService.updatePersonalSummaries(putList)] : []),
                ...(postList.length
                    ? [
                        credit.memberService
                            .getBips(memberSignal().company_registration_number)
                            .pipe(switchMap$1((bips) => credit.guarantorService.addPersonalSummaries(postList).pipe(map((data) => data.map((item) => ({
                            guarantor_summary_id: item.id,
                            guarantor_summary_type: FSWRecourseTypes.PG,
                            business_interest_party_id: bips.find((bip) => bip.idNumber === item.id_number)?.id,
                        }))))), switchMap$1((data) => application.guarantorService.addSummaries(applicationIdSignal(), data))),
                    ]
                    : []),
            ])
                .pipe(tapResponse(() => {
                alertService.success('Success', 'Personal Guarantor successfully saved!', {
                    duration: 3000,
                });
                refreshSummaries();
            }, () => {
                alertService.error('Error', 'Failed to save personal guarantor', {
                    duration: 3000,
                });
            }))
                .subscribe();
        },
    };
}

function providePersonalGuarantorTranslation(scope = 'personal_guarantor') {
    return [
        ...(FSWTranslateModule.forFeature({
            scope,
            defaultKey: getCountryCodeFromStorage() ?? CountryCode.MY,
            data: {
                [CountryCode.MY]: PERSONAL_GUARANTOR_MY_TRANSLATION,
                [CountryCode.SG]: PERSONAL_GUARANTOR_SG_TRANSLATION,
            },
        }).providers || []),
        fswTranslateScope(scope),
    ];
}

class FSWPersonalGuarantorContainerComponent extends FSWDynamicBuilderContainerComponent {
    constructor() {
        super(...arguments);
        this.controlContainer = inject(ControlContainer);
        this.alertService = inject(FSW_ALERT_SERVICE_TOKEN);
    }
    get title() {
        return this.element?.customProps?.title ?? '';
    }
    get canPullCBS() {
        return this.element?.customProps?.canPullCBS ?? false;
    }
    get memberIdInt() {
        return this.element?.customProps?.memberIdInt;
    }
    get customClasses() {
        return this.element?.customProps?.customClasses ?? '';
    }
    get formGroup() {
        return this.controlContainer.control;
    }
    pullingCbs(docs) {
        const value = this.formGroup.getRawValue();
        const filteredDocs = docs
            .filter((doc) => doc.cbs?.parsed_data?.personal_details?.id_number
            ? value.id_number === doc.cbs?.parsed_data?.personal_details?.id_number
            : false)
            .sort((a, b) => {
            const enquireCompare = this.transformEnquireDateToDate(b.cbs.parsed_data.enquiry_date).getTime() -
                this.transformEnquireDateToDate(a.cbs.parsed_data.enquiry_date).getTime();
            if (enquireCompare !== 0) {
                return enquireCompare;
            }
            return new Date(b.cbs.created_at).getTime() - new Date(a.cbs.created_at).getTime();
        });
        const selectedDoc = filteredDocs?.[0];
        if (!selectedDoc) {
            this.alertService.error('Error', 'No CBS data found for this PG', {
                duration: 3000,
            });
            return;
        }
        const parsedData = selectedDoc.cbs.parsed_data;
        const patchDataObject = {
            cbs_rating: parsedData.bureau_score.risk_grade,
            cbs_total_unsecured_limit: parsedData.summary.unsecured_credit_limit,
            cbs_total_secured_limit: parsedData.summary.secured_credit_limit,
            cbs_bankruptcy_proceeding_count: parsedData.summary.bankruptcy_proceeding_count,
            cbs_total_unsecured_balances_interest_bearing: parsedData.aggregated_monthly_balances.find((item) => item.product_type?.toLowerCase() === 'total')?.unsecured_balances_interest_bearing,
            cbs_total_unsecured_balances_non_interest_bearing: parsedData.aggregated_monthly_balances.find((item) => item.product_type?.toLowerCase() === 'total')?.unsecured_balances_non_interest_bearing,
            cbs_total_secured_balances: parsedData.aggregated_monthly_balances.find((item) => item.product_type?.toLowerCase() === 'total')?.secured_balances,
            cbs_total_overdue_balances: sumBy(parsedData.account_statuses, 'overdue_balance'),
            cbs_default_count: parsedData.summary.default_count,
        };
        this.formGroup.patchValue(Object.keys(patchDataObject).reduce((acc, key) => {
            if (this.formGroup.get(key)) {
                acc[key] = patchDataObject[key];
            }
            return acc;
        }, {}));
        this.alertService.success('Success', 'Pulled CBS successfully!', {
            duration: 3000,
        });
    }
    pullCBSError() {
        this.alertService.error('Error', 'Failed to load CBS Data', {
            duration: 3000,
        });
    }
    transformEnquireDateToDate(enquiryDate) {
        return new Date(enquiryDate.year, enquiryDate.month_value - 1, enquiryDate.day_of_month);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPersonalGuarantorContainerComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWPersonalGuarantorContainerComponent, isStandalone: true, selector: "fsw-personal-guarantor-container", host: { properties: { "class": "this.customClasses" } }, providers: [providePersonalGuarantorTranslation('personal_guarantor_container')], usesInheritance: true, ngImport: i0, template: "<fsw-panel [title]=\"title\">\n  <ng-template fswPanelHeaderSuffix>\n    <button\n      fswButton\n      *ngIf=\"canPullCBS\"\n      [appearance]=\"'secondary'\"\n      fsw-cbs-pull\n      [memberIdInt]=\"memberIdInt\"\n      (successPulled)=\"pullingCbs($event)\"\n      (errorPulled)=\"pullCBSError()\"\n    >\n      {{ 'buttons.pull' | fswTranslate : { scope: 'personal_guarantor_container' } }}\n    </button>\n  </ng-template>\n  <fsw-dynamic-builder-container\n    [element]=\"element\"\n    [dictionaries]=\"dictionaries\"\n    [config]=\"config\"\n    [index]=\"index\"\n  ></fsw-dynamic-builder-container>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWDynamicBuilderModule }, { kind: "component", type: i1$4.FSWDynamicBuilderContainerComponent, selector: "fsw-dynamic-builder-container" }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "component", type: CbsPullComponent, selector: "[fsw-cbs-pull]", inputs: ["memberIdInt", "isReadonly"], outputs: ["successPulled", "errorPulled"] }, { kind: "ngmodule", type: FSWAlertModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPersonalGuarantorContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-personal-guarantor-container', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [
                        FSWDynamicBuilderModule,
                        FSWPanelModule,
                        NgIf,
                        AsyncPipe,
                        FSWButtonModule,
                        FSWTranslateModule,
                        CbsPullComponent,
                        FSWAlertModule,
                    ], providers: [providePersonalGuarantorTranslation('personal_guarantor_container')], template: "<fsw-panel [title]=\"title\">\n  <ng-template fswPanelHeaderSuffix>\n    <button\n      fswButton\n      *ngIf=\"canPullCBS\"\n      [appearance]=\"'secondary'\"\n      fsw-cbs-pull\n      [memberIdInt]=\"memberIdInt\"\n      (successPulled)=\"pullingCbs($event)\"\n      (errorPulled)=\"pullCBSError()\"\n    >\n      {{ 'buttons.pull' | fswTranslate : { scope: 'personal_guarantor_container' } }}\n    </button>\n  </ng-template>\n  <fsw-dynamic-builder-container\n    [element]=\"element\"\n    [dictionaries]=\"dictionaries\"\n    [config]=\"config\"\n    [index]=\"index\"\n  ></fsw-dynamic-builder-container>\n</fsw-panel>\n" }]
        }], propDecorators: { customClasses: [{
                type: HostBinding,
                args: ['class']
            }] } });

function injectPersonalGuarantorEffects(config) {
    switch (getCountryCodeFromStorage()) {
        case CountryCode.SG:
            return injectPersonalGuarantorSGEffects(config);
        default:
            return injectPersonalGuarantorMYEffects(config);
    }
}

class FSWPersonalGuarantorComponent {
    constructor() {
        this.applicationIdSignal = signal('');
        this.gendersSignal = signal([]);
        this.designationsSignal = signal([]);
        this.countriesSignal = signal([]);
        this.isReadonlySignal = signal(false);
        this.canPullCBSSignal = signal(false);
        this.hiddenCommentsSignal = signal([]);
        this.memberSignal = signal(null);
        this.itemsSignal = signal([]);
        this.summariesSignal = signal([]);
        this.viewerDocsSignal = signal([]);
        this.toggleSignal = signal({});
        this.destroyDocViewerWhen$ = new Subject();
        this.formArray = new UntypedFormArray([]);
        this.injector = inject(Injector);
        this.docViewerService = injectFSWDocViewerService();
        this.effects = injectPersonalGuarantorEffects({
            applicationIdSignal: this.applicationIdSignal,
            gendersSignal: this.gendersSignal,
            designationsSignal: this.designationsSignal,
            countriesSignal: this.countriesSignal,
            isReadonlySignal: this.isReadonlySignal,
            canPullCBSSignal: this.canPullCBSSignal,
            hiddenCommentsSignal: this.hiddenCommentsSignal,
            memberSignal: this.memberSignal,
            itemsSignal: this.itemsSignal,
            summariesSignal: this.summariesSignal,
            viewerDocsSignal: this.viewerDocsSignal,
            formArray: this.formArray,
            injector: this.injector,
        });
        this.arrayValueChanges$ = this.formArray.valueChanges.pipe(startWith(this.formArray.value));
        this.arrayValueChangeSignal = toSignal(this.arrayValueChanges$);
        this.arrayInvalidSignal = computed(() => this.arrayValueChangeSignal() && this.formArray.controls.some((control) => control.invalid));
        this.validViewerDocsSignal = computed(() => {
            const docs = this.viewerDocsSignal();
            return (docs || []).filter((doc) => doc.items.filter((item) => item.src && item.id && item.name).length > 0);
        });
        this.dictionaries = [
            {
                name: 'personal-guarantor-container',
                component: FSWPersonalGuarantorContainerComponent,
                dictionaryType: FSWDynamicBuilderFormTypes.CONTAINER,
            },
        ];
        this.effects.init();
    }
    ngOnDestroy() {
        this.destroyDocViewerWhen$.next(new Date());
        this.destroyDocViewerWhen$.complete();
    }
    save() {
        this.effects.save();
    }
    toggle(index) {
        this.toggleSignal.set({
            ...this.toggleSignal(),
            [index]: !this.toggleSignal()[index],
        });
    }
    showDocViewer() {
        if (!this.validViewerDocsSignal().length)
            return;
        this.docViewerService.open({
            groups: this.validViewerDocsSignal(),
        }, this.destroyDocViewerWhen$);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPersonalGuarantorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWPersonalGuarantorComponent, isStandalone: true, selector: "fsw-personal-guarantor", providers: [
            providePersonalGuarantorTranslation(),
            provideUtilsService(),
            provideApplicationGuarantorService(),
            provideCreditGuarantorService(),
            provideMemberService(),
            provideApplicationMemberService(),
            provideBlobService(),
        ], ngImport: i0, template: "<fsw-panel [title]=\"'title' | fswTranslate\" [customClasses]=\"'flex w-[900px]'\">\n  <ng-template fswPanelHeaderSuffix>\n    <aside class=\"flex items-center gap-[12px]\">\n      <button\n        fswButton\n        [appearance]=\"'secondary-elevate'\"\n        (click)=\"showDocViewer()\"\n        *ngIf=\"validViewerDocsSignal().length\"\n      >\n        {{ 'buttons.view_docs' | fswTranslate }}\n      </button>\n      <button\n        fswButton\n        *ngIf=\"!isReadonlySignal() && itemsSignal().length\"\n        [disabled]=\"arrayInvalidSignal()\"\n        (click)=\"save()\"\n      >\n        {{ 'buttons.save' | fswTranslate }}\n      </button>\n    </aside>\n  </ng-template>\n  <section class=\"w-full flex flex-col gap-[16px]\">\n    <ng-container *ngFor=\"let item of itemsSignal(); let i = index\">\n      <fsw-panel\n        [title]=\"\n          item.builder.groupConfig.form.getRawValue().name ??\n          ('item' | fswTranslate : { data: { index: (i + 1).toString() } })\n        \"\n        customClasses=\"flex w-full\"\n      >\n        <ng-template fswPanelHeaderSuffix>\n          <i\n            fswIcon=\"common-arrow-down\"\n            [class.rotate-180]=\"!toggleSignal()[i]\"\n            class=\"text-[#2c50ff] duration-150\"\n            (click)=\"toggle(i)\"\n          ></i>\n        </ng-template>\n        <section class=\"w-full flex flex-col gap-[16px]\" [class.!hidden]=\"toggleSignal()[i]\">\n          <form [formGroup]=\"item.builder.groupConfig.form\">\n            <fsw-dynamic-builder\n              [builder]=\"item.builder\"\n              [dictionaries]=\"dictionaries\"\n            ></fsw-dynamic-builder>\n          </form>\n          <ng-container *ngIf=\"item.builder.groupConfig.form.value.id\">\n            <fsw-comments-section\n              [enableSaveButton]=\"true\"\n              [isReadonly]=\"isReadonlySignal()\"\n              [translateScope]=\"'personal_guarantor'\"\n              [data]=\"item.comments\"\n            ></fsw-comments-section>\n          </ng-container>\n        </section>\n      </fsw-panel>\n    </ng-container>\n    <ng-container *ngIf=\"!itemsSignal().length\">\n      <section class=\"w-full h-[200px] flex items-center justify-center px-16\">\n        <p class=\"text-center text-body-small-600 font-bold text-yellow-500\">\n          {{ 'empty' | fswTranslate }}\n        </p>\n      </section>\n    </ng-container>\n  </section>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWAlertModule }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: FSWDynamicBuilderModule }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "component", type: FSWCommentsSectionComponent, selector: "fsw-comments-section", inputs: ["data", "customClasses", "translateScope", "isReadonly", "enableSaveButton"] }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "ngmodule", type: FSWDocViewerModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPersonalGuarantorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-personal-guarantor', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [
                        FSWAlertModule,
                        FSWPanelModule,
                        FSWTranslateModule,
                        FSWButtonModule,
                        NgIf,
                        NgForOf,
                        ReactiveFormsModule,
                        FSWDynamicBuilderModule,
                        FSWCommentsSectionComponent,
                        FSWIconModule,
                        FSWDocViewerModule,
                    ], providers: [
                        providePersonalGuarantorTranslation(),
                        provideUtilsService(),
                        provideApplicationGuarantorService(),
                        provideCreditGuarantorService(),
                        provideMemberService(),
                        provideApplicationMemberService(),
                        provideBlobService(),
                    ], template: "<fsw-panel [title]=\"'title' | fswTranslate\" [customClasses]=\"'flex w-[900px]'\">\n  <ng-template fswPanelHeaderSuffix>\n    <aside class=\"flex items-center gap-[12px]\">\n      <button\n        fswButton\n        [appearance]=\"'secondary-elevate'\"\n        (click)=\"showDocViewer()\"\n        *ngIf=\"validViewerDocsSignal().length\"\n      >\n        {{ 'buttons.view_docs' | fswTranslate }}\n      </button>\n      <button\n        fswButton\n        *ngIf=\"!isReadonlySignal() && itemsSignal().length\"\n        [disabled]=\"arrayInvalidSignal()\"\n        (click)=\"save()\"\n      >\n        {{ 'buttons.save' | fswTranslate }}\n      </button>\n    </aside>\n  </ng-template>\n  <section class=\"w-full flex flex-col gap-[16px]\">\n    <ng-container *ngFor=\"let item of itemsSignal(); let i = index\">\n      <fsw-panel\n        [title]=\"\n          item.builder.groupConfig.form.getRawValue().name ??\n          ('item' | fswTranslate : { data: { index: (i + 1).toString() } })\n        \"\n        customClasses=\"flex w-full\"\n      >\n        <ng-template fswPanelHeaderSuffix>\n          <i\n            fswIcon=\"common-arrow-down\"\n            [class.rotate-180]=\"!toggleSignal()[i]\"\n            class=\"text-[#2c50ff] duration-150\"\n            (click)=\"toggle(i)\"\n          ></i>\n        </ng-template>\n        <section class=\"w-full flex flex-col gap-[16px]\" [class.!hidden]=\"toggleSignal()[i]\">\n          <form [formGroup]=\"item.builder.groupConfig.form\">\n            <fsw-dynamic-builder\n              [builder]=\"item.builder\"\n              [dictionaries]=\"dictionaries\"\n            ></fsw-dynamic-builder>\n          </form>\n          <ng-container *ngIf=\"item.builder.groupConfig.form.value.id\">\n            <fsw-comments-section\n              [enableSaveButton]=\"true\"\n              [isReadonly]=\"isReadonlySignal()\"\n              [translateScope]=\"'personal_guarantor'\"\n              [data]=\"item.comments\"\n            ></fsw-comments-section>\n          </ng-container>\n        </section>\n      </fsw-panel>\n    </ng-container>\n    <ng-container *ngIf=\"!itemsSignal().length\">\n      <section class=\"w-full h-[200px] flex items-center justify-center px-16\">\n        <p class=\"text-center text-body-small-600 font-bold text-yellow-500\">\n          {{ 'empty' | fswTranslate }}\n        </p>\n      </section>\n    </ng-container>\n  </section>\n</fsw-panel>\n" }]
        }], ctorParameters: function () { return []; } });

class FSWPersonalGuarantorDirective {
    constructor() {
        this.applicationId = null;
        this.isReadonly = false;
        this.canPullCBS = false;
        this.hiddenComments = [];
        this.viewContainerRef = inject(ViewContainerRef);
        this.loanService = injectLoanService();
        this.masterDataService = injectMasterDataService();
        this.countriesSignal = signal([]);
        this.gendersSignal = signal([]);
        this.designationsSignal = signal([]);
        this.firstLoad = false;
    }
    ngOnInit() {
        forkJoin([
            this.masterDataService.getCountries(),
            this.masterDataService.getGenders(),
            this.loanService.getDesignations(),
        ])
            .pipe(tapResponse(([countries, genders, designations]) => {
            this.countriesSignal.set(countries);
            this.gendersSignal.set(genders);
            this.designationsSignal.set(designations);
            this.firstLoad = true;
            this.render();
        }, () => {
            this.countriesSignal.set([]);
            this.gendersSignal.set([]);
            this.designationsSignal.set([]);
            this.firstLoad = true;
            this.render();
        }))
            .subscribe();
    }
    ngOnChanges() {
        this.render();
    }
    ngOnDestroy() {
        this.viewContainerRef.clear();
    }
    render() {
        this.viewContainerRef.clear();
        if (!this.applicationId || !this.firstLoad) {
            return;
        }
        const ref = this.viewContainerRef.createComponent(FSWPersonalGuarantorComponent);
        const instance = ref.instance;
        instance.applicationIdSignal.set(this.applicationId);
        instance.isReadonlySignal.set(this.isReadonly);
        instance.canPullCBSSignal.set(this.canPullCBS);
        instance.gendersSignal.set(this.gendersSignal() || []);
        instance.countriesSignal.set(this.countriesSignal() || []);
        instance.designationsSignal.set(this.designationsSignal() || []);
        instance.hiddenCommentsSignal.set(this.hiddenComments);
        ref.changeDetectorRef.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPersonalGuarantorDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWPersonalGuarantorDirective, isStandalone: true, selector: "[fswPersonalGuarantor]", inputs: { applicationId: "applicationId", isReadonly: "isReadonly", canPullCBS: "canPullCBS", hiddenComments: "hiddenComments" }, providers: [provideUtilsService(), provideMasterDataService(), provideLoanService()], usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPersonalGuarantorDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswPersonalGuarantor]',
                    standalone: true,
                    providers: [provideUtilsService(), provideMasterDataService(), provideLoanService()],
                }]
        }], propDecorators: { applicationId: [{
                type: Input,
                args: [{ required: true }]
            }], isReadonly: [{
                type: Input
            }], canPullCBS: [{
                type: Input
            }], hiddenComments: [{
                type: Input
            }] } });

var title$g = "Policy Checklist";
var fields$c = {
	exception: "Policy Exception"
};
var buttons$q = {
	save: "Save"
};
var policyChecklistSg = {
	title: title$g,
	fields: fields$c,
	buttons: buttons$q
};

var SG$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$q,
    default: policyChecklistSg,
    fields: fields$c,
    title: title$g
});

const POLICY_CHECKLIST_SG_TRANSLATION = SG$2;

function injectPolicyChecklistSGEffects(refreshedAt, policyCheckList, injector) {
    const creditService = injectCreditPolicyChecklistService();
    const applicationService = injectApplicationPolicyChecklistService();
    const alertService = inject(FSW_ALERT_SERVICE_TOKEN);
    return {
        refresh: (applicationId) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => applicationService
            .getPolicyCheckList(applicationId)
            .pipe(switchMap$1((id) => id ? creditService.getPolicyCheckList(id) : from(Promise.resolve(null))))), tap((data) => policyCheckList.set(data)), catchError((err) => {
            alertService.error('Failed to load Policy Checklist', null, {
                duration: 3000,
            });
            policyCheckList.set(null);
            return throwError(() => err);
        })), injector, null))),
        create: (applicationId, payload) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => creditService
            .addPolicyCheckList(payload)
            .pipe(switchMap$1((data) => applicationService.addPolicyCheckList(applicationId, data.id)))), tap(() => refreshedAt.set(new Date())), tap(() => alertService.success('Create Policy Checklist successfully!', null, {
            duration: 3000,
        })), catchError(() => {
            alertService.error('Failed to create Policy Checklist', null, {
                duration: 3000,
            });
            return of(null);
        })), injector))),
        update: (payload) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => creditService.updatePolicyCheckList(payload.id, payload.data)), tap(() => refreshedAt.set(new Date())), tap(() => alertService.success('Update Policy Checklist successfully!', null, {
            duration: 3000,
        })), catchError(() => {
            alertService.error('Failed to update Policy Checklist', null, {
                duration: 3000,
            });
            return of(null);
        })), injector))),
    };
}

var title$f = "Policy Checklist";
var fields$b = {
	exception: "Policy Exception"
};
var buttons$p = {
	save: "Save"
};
var policyChecklistTh = {
	title: title$f,
	fields: fields$b,
	buttons: buttons$p
};

var TH$5 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$p,
    default: policyChecklistTh,
    fields: fields$b,
    title: title$f
});

const POLICY_CHECKLIST_TH_TRANSLATION = TH$5;

function injectPolicyChecklistTHEffects(refreshedAt, policyCheckList, injector) {
    const creditService = injectCreditPolicyChecklistService();
    const applicationService = injectApplicationPolicyChecklistService();
    const alertService = inject(FSW_ALERT_SERVICE_TOKEN);
    return {
        refresh: (applicationId) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => applicationService
            .getPolicyCheckList(applicationId)
            .pipe(switchMap$1((id) => id ? creditService.getPolicyCheckList(id) : from(Promise.resolve(null))))), tap((data) => policyCheckList.set(data)), catchError((err) => {
            alertService.error('Failed to load Policy Checklist', null, {
                duration: 3000,
            });
            policyCheckList.set(null);
            return throwError(() => err);
        })), injector, null))),
        create: (applicationId, payload) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => creditService
            .addPolicyCheckList(payload)
            .pipe(switchMap$1((data) => applicationService.addPolicyCheckList(applicationId, data.id)))), tap(() => refreshedAt.set(new Date())), tap(() => alertService.success('Create Policy Checklist successfully!', null, {
            duration: 3000,
        })), catchError(() => {
            alertService.error('Failed to create Policy Checklist', null, {
                duration: 3000,
            });
            return of(null);
        })), injector))),
        update: (payload) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => creditService.updatePolicyCheckList(payload.id, payload.data)), tap(() => refreshedAt.set(new Date())), tap(() => alertService.success('Update Policy Checklist successfully!', null, {
            duration: 3000,
        })), catchError(() => {
            alertService.error('Failed to update Policy Checklist', null, {
                duration: 3000,
            });
            return of(null);
        })), injector))),
    };
}

function providePolicyChecklistTranslation() {
    return [
        ...(FSWTranslateModule.forFeature({
            scope: 'policy_checklist',
            defaultKey: CountryCode.TH,
            data: {
                [CountryCode.TH]: POLICY_CHECKLIST_TH_TRANSLATION,
                [CountryCode.SG]: POLICY_CHECKLIST_SG_TRANSLATION,
            },
        }).providers || []),
        fswTranslateScope('policy_checklist'),
    ];
}

function injectPolicyChecklistEffects(refreshedAt, policyChecklists, injector) {
    switch (getCountryCodeFromStorage()) {
        case CountryCode.TH:
            return injectPolicyChecklistTHEffects(refreshedAt, policyChecklists, injector);
        case CountryCode.SG:
            return injectPolicyChecklistSGEffects(refreshedAt, policyChecklists, injector);
        default:
            return injectPolicyChecklistTHEffects(refreshedAt, policyChecklists, injector);
    }
}

class FSWPolicyChecklistComponent {
    constructor() {
        this.updated = new EventEmitter();
        this.applicationId = signal('');
        this.isReadonly = signal(false);
        this.policyChecklist = signal(null);
        this.refreshedAt = signal(new Date());
        this.policies = signal([]);
        this.groupPolicies = signal([]);
        this.selectedPolicies = signal([]);
        this.effects = injectPolicyChecklistEffects(this.refreshedAt, this.policyChecklist, inject(Injector));
        this.creditPolicyChecklistService = injectCreditPolicyChecklistService();
        this.translateService = inject(FSW_TRANSLATE_SERVICE_TOKEN);
        this.exceptionBuilder = new FSWDynamicBuilder({
            formType: FSWDynamicBuilderFormTypes.GROUP,
            form: new UntypedFormGroup({}),
            customClasses: 'w-full flex flex-col gap-4',
            fields: [
                {
                    key: 'exception',
                    type: FSWDynamicBuilderControlTypes.SELECT,
                    customClasses: 'w-full',
                    context: {
                        defaultValue: false,
                        label: this.translateService.select('fields.exception', 'policy_checklist'),
                        fullWidth: true,
                        items: [
                            {
                                text: 'YES',
                                value: true,
                            },
                            {
                                text: 'NO',
                                value: false,
                            },
                        ],
                        readonlyTemplate: (value) => (value ? 'YES' : 'NO'),
                    },
                },
                {
                    key: 'text',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-full',
                    context: {
                        inputType: 'area',
                        rows: 3,
                        fullWidth: true,
                    },
                },
            ],
        });
        effect(() => {
            const isReadonly = this.isReadonly();
            if (isReadonly) {
                this.exceptionBuilder.groupConfig.form.disable();
            }
            else {
                this.exceptionBuilder.groupConfig.form.enable();
            }
        });
        effect(() => {
            const value = this.policyChecklist();
            this.exceptionBuilder.groupConfig.form.patchValue(value?.data?.policy_exceptions[0] || {});
            this.selectedPolicies.set(value?.data?.policy_ids || []);
            if (value) {
                this.updated.emit(value);
            }
        }, { allowSignalWrites: true });
        effect(() => {
            this.creditPolicyChecklistService
                .getListPolicies()
                .pipe(take(1), tap((policies) => this.policies.set(policies)))
                .subscribe();
        }, { allowSignalWrites: true });
        effect(() => {
            const policies = this.policies();
            if (policies?.length) {
                const groupPoliciesDictionary = groupBy(policies, 'domain');
                this.groupPolicies.set(Object.keys(groupPoliciesDictionary).map((domain) => ({
                    domain,
                    policies: groupPoliciesDictionary[domain],
                })));
            }
        }, { allowSignalWrites: true });
        effect(() => {
            if (!this.applicationId()) {
                return;
            }
            if (this.refreshedAt()) {
                this.effects.refresh(this.applicationId());
            }
        });
    }
    togglePolicy(id) {
        if (!this.isReadonly()) {
            if (this.selectedPolicies().includes(id)) {
                this.selectedPolicies.set(this.selectedPolicies().filter((policyId) => policyId !== id));
            }
            else {
                this.selectedPolicies.set([...this.selectedPolicies(), id]);
            }
        }
    }
    submit() {
        if (this.isReadonly()) {
            return;
        }
        const existed = this.policyChecklist();
        if (existed) {
            this.effects.update({
                ...existed,
                data: {
                    policy_ids: this.selectedPolicies(),
                    policy_exceptions: [this.exceptionBuilder.groupConfig.form.value],
                },
            });
        }
        else {
            this.effects.create(this.applicationId(), {
                policy_ids: this.selectedPolicies(),
                policy_exceptions: [this.exceptionBuilder.groupConfig.form.value],
            });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPolicyChecklistComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWPolicyChecklistComponent, isStandalone: true, selector: "fsw-policy-checklist", outputs: { updated: "updated" }, providers: [
            providePolicyChecklistTranslation(),
            provideCreditPolicyChecklistService(),
            provideApplicationPolicyChecklistService(),
        ], ngImport: i0, template: "<fsw-panel [title]=\"'title' | fswTranslate\">\n  <section class=\"w-full flex flex-col gap-6\">\n    <table class=\"fsw-table fsw-table--bordered w-full\">\n      <caption class=\"hidden\">\n        Policy Checklist Table\n      </caption>\n      <thead>\n        <tr>\n          <th class=\"w-10\"></th>\n          <th>{{ 'title' | fswTranslate }}</th>\n          <th class=\"w-[10%]\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <ng-container *ngFor=\"let item of groupPolicies()\">\n          <tr>\n            <td></td>\n            <td class=\"!font-semibold\">{{ item.domain }}</td>\n            <td></td>\n          </tr>\n          <ng-container *ngFor=\"let policy of item.policies; let i = index\">\n            <tr>\n              <td>{{ i + 1 }}</td>\n              <td>{{ policy.policy }}</td>\n              <td>\n                <fsw-checkbox\n                  [forceChecked]=\"selectedPolicies().includes(policy.id.toString())\"\n                  (change)=\"togglePolicy(policy.id.toString())\"\n                  [disabled]=\"isReadonly()\"\n                ></fsw-checkbox>\n              </td>\n            </tr>\n          </ng-container>\n        </ng-container>\n      </tbody>\n    </table>\n    <form class=\"w-full !flex flex-col gap-4\" [formGroup]=\"exceptionBuilder.groupConfig.form\">\n      <fsw-dynamic-builder [builder]=\"exceptionBuilder\"></fsw-dynamic-builder>\n      <button (click)=\"submit()\" fswButton [disabled]=\"isReadonly()\">\n        {{ 'buttons.save' | fswTranslate }}\n      </button>\n    </form>\n  </section>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: FSWDynamicBuilderModule }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "ngmodule", type: FSWCheckboxModule }, { kind: "component", type: i1$4.FSWCheckboxComponent, selector: "fsw-checkbox" }, { kind: "ngmodule", type: FormsModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPolicyChecklistComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-policy-checklist', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [
                        providePolicyChecklistTranslation(),
                        provideCreditPolicyChecklistService(),
                        provideApplicationPolicyChecklistService(),
                    ], imports: [
                        FSWTranslateModule,
                        FSWPanelModule,
                        ReactiveFormsModule,
                        FSWDynamicBuilderModule,
                        FSWButtonModule,
                        NgForOf,
                        FSWCheckboxModule,
                        FormsModule,
                    ], template: "<fsw-panel [title]=\"'title' | fswTranslate\">\n  <section class=\"w-full flex flex-col gap-6\">\n    <table class=\"fsw-table fsw-table--bordered w-full\">\n      <caption class=\"hidden\">\n        Policy Checklist Table\n      </caption>\n      <thead>\n        <tr>\n          <th class=\"w-10\"></th>\n          <th>{{ 'title' | fswTranslate }}</th>\n          <th class=\"w-[10%]\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <ng-container *ngFor=\"let item of groupPolicies()\">\n          <tr>\n            <td></td>\n            <td class=\"!font-semibold\">{{ item.domain }}</td>\n            <td></td>\n          </tr>\n          <ng-container *ngFor=\"let policy of item.policies; let i = index\">\n            <tr>\n              <td>{{ i + 1 }}</td>\n              <td>{{ policy.policy }}</td>\n              <td>\n                <fsw-checkbox\n                  [forceChecked]=\"selectedPolicies().includes(policy.id.toString())\"\n                  (change)=\"togglePolicy(policy.id.toString())\"\n                  [disabled]=\"isReadonly()\"\n                ></fsw-checkbox>\n              </td>\n            </tr>\n          </ng-container>\n        </ng-container>\n      </tbody>\n    </table>\n    <form class=\"w-full !flex flex-col gap-4\" [formGroup]=\"exceptionBuilder.groupConfig.form\">\n      <fsw-dynamic-builder [builder]=\"exceptionBuilder\"></fsw-dynamic-builder>\n      <button (click)=\"submit()\" fswButton [disabled]=\"isReadonly()\">\n        {{ 'buttons.save' | fswTranslate }}\n      </button>\n    </form>\n  </section>\n</fsw-panel>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { updated: [{
                type: Output
            }] } });

var FSWPolicyChecklistDirective_1;
let FSWPolicyChecklistDirective = class FSWPolicyChecklistDirective {
    static { FSWPolicyChecklistDirective_1 = this; }
    static { this.REFRESH_KEY = 'fs-widgets-feature-policy-checklist'; }
    constructor(_refreshService, _viewContainerRef) {
        this._refreshService = _refreshService;
        this._viewContainerRef = _viewContainerRef;
        this.updated = new EventEmitter();
        this.applicationId = null;
        this.isReadonly = false;
    }
    ngOnInit() {
        this._refreshService
            .register(FSWPolicyChecklistDirective_1.REFRESH_KEY)
            .pipe(followDestroy(this), tap(() => this.refresh()))
            .subscribe();
    }
    ngOnChanges() {
        this.refresh();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    refresh() {
        this._viewContainerRef.clear();
        if (!this.applicationId) {
            return;
        }
        const ref = this._viewContainerRef.createComponent(FSWPolicyChecklistComponent);
        const instance = ref.instance;
        instance.applicationId.set(this.applicationId);
        instance.isReadonly.set(this.isReadonly);
        instance.updated
            .asObservable()
            .pipe(followDestroy(this), tap((policyChecklist) => this.updated.emit(policyChecklist)))
            .subscribe();
        ref.changeDetectorRef.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPolicyChecklistDirective, deps: [{ token: RefreshService }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWPolicyChecklistDirective, isStandalone: true, selector: "[fswPolicyChecklist]", inputs: { applicationId: "applicationId", isReadonly: "isReadonly" }, outputs: { updated: "updated" }, usesOnChanges: true, ngImport: i0 }); }
};
FSWPolicyChecklistDirective = FSWPolicyChecklistDirective_1 = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [RefreshService,
        ViewContainerRef])
], FSWPolicyChecklistDirective);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPolicyChecklistDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswPolicyChecklist]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: RefreshService }, { type: i0.ViewContainerRef }]; }, propDecorators: { updated: [{
                type: Output
            }], applicationId: [{
                type: Input,
                args: [{ required: true }]
            }], isReadonly: [{
                type: Input
            }] } });

const FSW_PRE_SCREENING_CRITERIA_STORE_TOKEN = new InjectionToken('FSW_PRE_SCREENING_CRITERIA_STORE_TOKEN');

const FSW_PRE_SCREENING_CRITERIA_BUILDER_TOKEN = new InjectionToken('FSW_PRE_SCREENING_CRITERIA_BUILDER_TOKEN');

const FSW_PRE_SCREENING_CRITERIA_MODAL_BUILDER_TOKEN = new InjectionToken('FSW_PRE_SCREENING_CRITERIA_MODAL_BUILDER_TOKEN');

let FSWPreScreeningCriteriaEditJustificationComponent = class FSWPreScreeningCriteriaEditJustificationComponent {
    get parent() {
        return this.control.parent;
    }
    constructor(control, _builder, dialogRef) {
        this.control = control;
        this._builder = _builder;
        this.dialogRef = dialogRef;
        this.form = new UntypedFormGroup({});
        this.builder = this._builder({
            form: this.form,
        });
        this.form.patchValue(this.parent.value);
        this.form.valueChanges
            .pipe(tap((value) => this.parent.patchValue(value)), followDestroy(this))
            .subscribe();
    }
    close() {
        this.dialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCriteriaEditJustificationComponent, deps: [{ token: DIALOG_DATA }, { token: FSW_PRE_SCREENING_CRITERIA_MODAL_BUILDER_TOKEN }, { token: i1$7.DialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWPreScreeningCriteriaEditJustificationComponent, selector: "fsw-pre-screening-criteria-edit-justification", ngImport: i0, template: "<fsw-modal [title]=\"'buttons.edit' | fswTranslate\" (closeEvent)=\"close()\">\n  <ng-template fswModalBody>\n    <form [formGroup]=\"parent\">\n      <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n    </form>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
};
FSWPreScreeningCriteriaEditJustificationComponent = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [UntypedFormControl, Function, DialogRef])
], FSWPreScreeningCriteriaEditJustificationComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCriteriaEditJustificationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-pre-screening-criteria-edit-justification', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal [title]=\"'buttons.edit' | fswTranslate\" (closeEvent)=\"close()\">\n  <ng-template fswModalBody>\n    <form [formGroup]=\"parent\">\n      <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n    </form>\n  </ng-template>\n</fsw-modal>\n" }]
        }], ctorParameters: function () { return [{ type: i2.UntypedFormControl, decorators: [{
                    type: Inject,
                    args: [DIALOG_DATA]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PRE_SCREENING_CRITERIA_MODAL_BUILDER_TOKEN]
                }] }, { type: i1$7.DialogRef }]; } });

class FSWPreScreeningCriteriaSelectDataComponent {
    constructor(_componentStore, _alertService, stage, dialogRef) {
        this._componentStore = _componentStore;
        this._alertService = _alertService;
        this.stage = stage;
        this.dialogRef = dialogRef;
        this.FSWCreditPreScreeningStages = FSWCreditPreScreeningStages;
        this.tradeRefereeCategories = tradeRefereeCategories;
        this.hasReturnedCheque = this._componentStore.hasReturnedCheque;
        this.noOfDishonouredOrReturnedCheques = this._componentStore.noOfDishonouredOrReturnedCheques;
        this.tradeReferenceCompanyCategories = this._componentStore.tradeReferenceCompanyCategories;
        this.isCtos = this._componentStore.isCtos;
    }
    close(value = false) {
        this.dialogRef.close(value);
    }
    confirm() {
        this.close(true);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCriteriaSelectDataComponent, deps: [{ token: FSW_PRE_SCREENING_CRITERIA_STORE_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }, { token: DIALOG_DATA }, { token: i1$7.DialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWPreScreeningCriteriaSelectDataComponent, selector: "fsw-pre-screening-criteria-select-data", ngImport: i0, template: "<fsw-modal\n  [title]=\"'trigger_title' | fswTranslate\"\n  (closeEvent)=\"close()\"\n  (confirmEvent)=\"confirm()\"\n  [size]=\"isCtos ? 'm' : 's'\"\n  [confirmButton]=\"'buttons.trigger' | fswTranslate\"\n  [cancelButtonDisabled]=\"isCtos ? tradeReferenceCompanyCategories.valid : false\"\n>\n  <ng-template fswModalBody>\n    <ng-container [ngSwitch]=\"stage\">\n      <ng-container *ngSwitchCase=\"FSWCreditPreScreeningStages.BANK\">\n        <fsw-checkbox [formControl]=\"hasReturnedCheque\">\n          <ng-template fswCheckboxLabel>\n            <span>{{ 'fields.has_returned_cheque' | fswTranslate }}</span>\n          </ng-template>\n        </fsw-checkbox>\n        <ng-container *ngIf=\"!!hasReturnedCheque.value\">\n          <fsw-field [fullWidth]=\"true\">\n            <input\n              fswInput\n              type=\"number\"\n              [formControl]=\"noOfDishonouredOrReturnedCheques\"\n              [placeholder]=\"'fields.no_of_dishonoured_or_returned_cheques' | fswTranslate\"\n            />\n            <ng-template\n              fswFieldHeaderPrefix\n              [label]=\"'fields.no_of_dishonoured_or_returned_cheques' | fswTranslate\"\n            ></ng-template>\n          </fsw-field>\n        </ng-container>\n      </ng-container>\n      <ng-container *ngSwitchCase=\"FSWCreditPreScreeningStages.CTOS\">\n        <ng-container *ngTemplateOutlet=\"ctosTemplate\"></ng-container>\n      </ng-container>\n      <ng-container *ngSwitchCase=\"FSWCreditPreScreeningStages.MY_DF_CTOS\">\n        <ng-container *ngTemplateOutlet=\"ctosTemplate\"></ng-container>\n      </ng-container>\n    </ng-container>\n    <ng-template #ctosTemplate>\n      <table class=\"fsw-table w-full\">\n        <caption class=\"hidden\">\n          Trade Reference Selection Table\n        </caption>\n        <thead>\n          <tr>\n            <th [width]=\"150\">{{ 'columns.trade_referee' | fswTranslate }}</th>\n            <th>{{ 'columns.category_for_trade_referee' | fswTranslate }}</th>\n          </tr>\n        </thead>\n        <tbody>\n          <ng-container *ngFor=\"let row of tradeReferenceCompanyCategories.controls\">\n            <tr>\n              <td>{{ row.value.name }}</td>\n              <td>\n                <fsw-field [fullWidth]=\"true\">\n                  <fsw-select\n                    [maxHeight]=\"'300px'\"\n                    [formControl]=\"$any(row.get('category')) | fswForceControl\"\n                    [closeOnSelected]=\"true\"\n                  >\n                    <ng-container *ngFor=\"let category of tradeRefereeCategories; let i = index\">\n                      <ng-template\n                        fswSelectItem\n                        [value]=\"category.value\"\n                        [text]=\"category.text\"\n                        [showCheckIcon]=\"true\"\n                      ></ng-template>\n                    </ng-container>\n                  </fsw-select>\n                </fsw-field>\n              </td>\n            </tr>\n          </ng-container>\n        </tbody>\n      </table>\n    </ng-template>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "directive", type: i1$4.FSWCheckboxLabelDirective, selector: "ng-template[fswCheckboxLabel]" }, { kind: "component", type: i1$4.FSWCheckboxComponent, selector: "fsw-checkbox" }, { kind: "directive", type: i1$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$4.FSWFieldHeaderPrefixDirective, selector: "ng-template[fswFieldHeaderPrefix]", inputs: ["kind", "label", "required"] }, { kind: "directive", type: i1$4.FSWInputDirective, selector: "input[fswInput], textarea[fswInput]" }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$4.FSWForceControlPipe, name: "fswForceControl" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCriteriaSelectDataComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-pre-screening-criteria-select-data', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal\n  [title]=\"'trigger_title' | fswTranslate\"\n  (closeEvent)=\"close()\"\n  (confirmEvent)=\"confirm()\"\n  [size]=\"isCtos ? 'm' : 's'\"\n  [confirmButton]=\"'buttons.trigger' | fswTranslate\"\n  [cancelButtonDisabled]=\"isCtos ? tradeReferenceCompanyCategories.valid : false\"\n>\n  <ng-template fswModalBody>\n    <ng-container [ngSwitch]=\"stage\">\n      <ng-container *ngSwitchCase=\"FSWCreditPreScreeningStages.BANK\">\n        <fsw-checkbox [formControl]=\"hasReturnedCheque\">\n          <ng-template fswCheckboxLabel>\n            <span>{{ 'fields.has_returned_cheque' | fswTranslate }}</span>\n          </ng-template>\n        </fsw-checkbox>\n        <ng-container *ngIf=\"!!hasReturnedCheque.value\">\n          <fsw-field [fullWidth]=\"true\">\n            <input\n              fswInput\n              type=\"number\"\n              [formControl]=\"noOfDishonouredOrReturnedCheques\"\n              [placeholder]=\"'fields.no_of_dishonoured_or_returned_cheques' | fswTranslate\"\n            />\n            <ng-template\n              fswFieldHeaderPrefix\n              [label]=\"'fields.no_of_dishonoured_or_returned_cheques' | fswTranslate\"\n            ></ng-template>\n          </fsw-field>\n        </ng-container>\n      </ng-container>\n      <ng-container *ngSwitchCase=\"FSWCreditPreScreeningStages.CTOS\">\n        <ng-container *ngTemplateOutlet=\"ctosTemplate\"></ng-container>\n      </ng-container>\n      <ng-container *ngSwitchCase=\"FSWCreditPreScreeningStages.MY_DF_CTOS\">\n        <ng-container *ngTemplateOutlet=\"ctosTemplate\"></ng-container>\n      </ng-container>\n    </ng-container>\n    <ng-template #ctosTemplate>\n      <table class=\"fsw-table w-full\">\n        <caption class=\"hidden\">\n          Trade Reference Selection Table\n        </caption>\n        <thead>\n          <tr>\n            <th [width]=\"150\">{{ 'columns.trade_referee' | fswTranslate }}</th>\n            <th>{{ 'columns.category_for_trade_referee' | fswTranslate }}</th>\n          </tr>\n        </thead>\n        <tbody>\n          <ng-container *ngFor=\"let row of tradeReferenceCompanyCategories.controls\">\n            <tr>\n              <td>{{ row.value.name }}</td>\n              <td>\n                <fsw-field [fullWidth]=\"true\">\n                  <fsw-select\n                    [maxHeight]=\"'300px'\"\n                    [formControl]=\"$any(row.get('category')) | fswForceControl\"\n                    [closeOnSelected]=\"true\"\n                  >\n                    <ng-container *ngFor=\"let category of tradeRefereeCategories; let i = index\">\n                      <ng-template\n                        fswSelectItem\n                        [value]=\"category.value\"\n                        [text]=\"category.text\"\n                        [showCheckIcon]=\"true\"\n                      ></ng-template>\n                    </ng-container>\n                  </fsw-select>\n                </fsw-field>\n              </td>\n            </tr>\n          </ng-container>\n        </tbody>\n      </table>\n    </ng-template>\n  </ng-template>\n</fsw-modal>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PRE_SCREENING_CRITERIA_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: FSWCreditPreScreeningStages, decorators: [{
                    type: Inject,
                    args: [DIALOG_DATA]
                }] }, { type: i1$7.DialogRef }]; } });

var title$e = "Pre Screening Criteria";
var trigger_title = "Pre Screening Criteria Trigger";
var columns$5 = {
	name: "Name",
	result: "Screening Result",
	remark: "Remark",
	description: "Description",
	justification: "Justification",
	trade_referee: "Trade Referee",
	category_for_trade_referee: "Category for Trade Reference"
};
var fields$a = {
	has_returned_cheque: "Has Returned Cheque",
	no_of_dishonoured_or_returned_cheques: "No. of dishonoured/returned cheques",
	trade_reference_company_category: "Trade Reference Company Category"
};
var buttons$o = {
	trigger: "Trigger",
	refresh: "Refresh",
	edit: "Edit Justification",
	update: "Update Justification"
};
var my$b = {
	title: title$e,
	trigger_title: trigger_title,
	columns: columns$5,
	fields: fields$a,
	buttons: buttons$o
};

var MY$9 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$o,
    columns: columns$5,
    default: my$b,
    fields: fields$a,
    title: title$e,
    trigger_title: trigger_title
});

const FSW_PRE_SCREENING_CRITERIA_TRANSLATION_LOADER = {
    [CountryCode.MY]: MY$9,
    [CountryCode.SG]: MY$9,
    [CountryCode.ID]: MY$9,
    [CountryCode.VU]: MY$9,
    [CountryCode.TH]: MY$9,
};

class FSWPreScreeningCriteriaDescriptionPipe {
    transform(value) {
        if (!value) {
            return '';
        }
        return value.split('\\"').join('"').split('\t').join(' ').split('\n').join('<br>');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCriteriaDescriptionPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCriteriaDescriptionPipe, name: "fswPreScreeningCriteriaDescription" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCriteriaDescriptionPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fswPreScreeningCriteriaDescription',
                }]
        }] });

function toPreScreeningCriteriaIdentifier({ flow, stage, isTopUp, partnerId, allowedProductUPI, prescreeningIdsData, }) {
    const productUPI = allowedProductUPI || 'SG-MB';
    let stageMapping = {
        [FSWCreditPreScreeningStages.CTOS]: isTopUp
            ? FSWCreditPreScreeningIdentifiers.CTOS_TOP_UP
            : flow === FSWFlow.INSTANT
                ? FSWCreditPreScreeningAutoIdentifiers.CTOS
                : FSWCreditPreScreeningIdentifiers.CTOS,
        [FSWCreditPreScreeningStages.MY_DF_CTOS]: FSWCreditPreScreeningIdentifiers.MY_DF_CTOS,
        [FSWCreditPreScreeningStages.BANK]: flow === FSWFlow.INSTANT
            ? FSWCreditPreScreeningAutoIdentifiers.BANK
            : FSWCreditPreScreeningIdentifiers.BANK,
        [FSWCreditPreScreeningStages.CBS]: FSWCreditPreScreeningIdentifiers.CBS,
        [FSWCreditPreScreeningStages.BASIC_PRESCREENING]: FSWCreditPreScreeningIdentifiers.BASIC_PRESCREENING,
        // Add more stages here for SG Prescreening Details
        [FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BASIC_DETAILS]: prescreeningIdsData && prescreeningIdsData[productUPI].default.BASIC,
        [FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BRC]: prescreeningIdsData && prescreeningIdsData[productUPI].default.BRC,
        [FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BRI]: prescreeningIdsData && prescreeningIdsData[productUPI].default.BRI,
        [FSWCreditPreScreeningStages.SG_BOLT_SG_MB_CBS]: prescreeningIdsData && prescreeningIdsData[productUPI].default.SG_CBS,
        [FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BANK_STATEMENT]: prescreeningIdsData && prescreeningIdsData[productUPI].default.SG_BANK_STATEMENT,
    };
    if (partnerId &&
        prescreeningIdsData &&
        prescreeningIdsData[productUPI] &&
        prescreeningIdsData[productUPI][`${partnerId}`]) {
        stageMapping = {
            ...stageMapping,
            [FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BASIC_DETAILS]: prescreeningIdsData[productUPI][`${partnerId}`].BASIC,
            [FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BRC]: prescreeningIdsData[productUPI][`${partnerId}`].BRC,
            [FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BRI]: prescreeningIdsData[productUPI][`${partnerId}`].BRI,
            [FSWCreditPreScreeningStages.SG_BOLT_SG_MB_CBS]: prescreeningIdsData[productUPI][`${partnerId}`].SG_CBS,
            [FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BANK_STATEMENT]: prescreeningIdsData[productUPI][`${partnerId}`].SG_BANK_STATEMENT,
        };
    }
    return stageMapping[stage];
}

class FSWPreScreeningCriteriaStore extends ComponentStore {
    get array() {
        return getControlFromGroup(this.form, 'criteria');
    }
    get isCtos() {
        return (this.state().stage === FSWCreditPreScreeningStages.CTOS ||
            this.state().stage === FSWCreditPreScreeningStages.MY_DF_CTOS);
    }
    get ignoreSelectDataBeforeTriggering() {
        return ((this.isCtos && !this.state().tradeReferenceNames?.length) ||
            this.state().stage === FSWCreditPreScreeningStages.BASIC_PRESCREENING ||
            this.state().stage === FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BASIC_DETAILS ||
            this.state().stage === FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BRC ||
            this.state().stage === FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BRI ||
            this.state().stage === FSWCreditPreScreeningStages.SG_BOLT_SG_MB_CBS ||
            this.state().stage === FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BANK_STATEMENT);
    }
    constructor(_applicationPreScreeningService, _creditPreScreeningService, _financeService, _facilityService, _alertService, _builder, _initialState) {
        super(_initialState);
        this._applicationPreScreeningService = _applicationPreScreeningService;
        this._creditPreScreeningService = _creditPreScreeningService;
        this._financeService = _financeService;
        this._facilityService = _facilityService;
        this._alertService = _alertService;
        this._builder = _builder;
        this._initialState = _initialState;
        this.validating = new EventEmitter();
        this.tradeReferenceChange = new EventEmitter();
        this.form = new UntypedFormGroup({});
        this.dataForm = new UntypedFormGroup({
            trade_reference_company_categories: new UntypedFormArray([]),
            has_returned_cheque: new UntypedFormControl(false),
            invalid_cheque_count: new UntypedFormControl(0),
        });
        this.hasReturnedCheque = getControlFromGroup(this.dataForm, 'has_returned_cheque');
        this.noOfDishonouredOrReturnedCheques = getControlFromGroup(this.dataForm, 'invalid_cheque_count');
        this.tradeReferenceCompanyCategories = getControlFromGroup(this.dataForm, 'trade_reference_company_categories');
        this.justificationMap = new Map();
        this.updateJustification = this.effect(pipe(switchMap(() => {
            const payload = this.getJustificationPayload();
            if (!payload?.length) {
                this._alertService.warning('Notification', 'Empty Payload', {
                    duration: 1000,
                });
                return of([]);
            }
            return this._creditPreScreeningService
                .updateJustifications(this.get().id, this.getJustificationPayload())
                .pipe(tap(() => {
                this.updateJustificationMap();
                this._alertService.success('Notification', 'Updated Justification successfully!', {
                    duration: 1000,
                });
            }), catchError((err) => {
                this._alertService.error('Error', err.message, {
                    duration: 1000,
                });
                return EMPTY;
            }));
        })));
        this.triggerFlow = this.effect(pipe(tap(() => {
            this.patchState({
                builder: this._builder({
                    form: this.form,
                    isReadonly: this.get().isReadonly ?? this.get().flow === FSWFlow.INSTANT,
                    hiddenJustification: this.get().flow === FSWFlow.INSTANT,
                }),
            });
            this.justificationMap.clear();
        }), switchMap((triggerFirst) => this.getCriteria(triggerFirst).pipe(tap((data) => {
            data?.criteria.sort((a, b) => (a.name > b.name ? 1 : -1));
            this.patchData(data);
        }), catchError((err) => {
            this._alertService.error('Error', err.message, {
                duration: 1000,
            });
            return EMPTY;
        })))));
        this.updateState = (value) => this.patchState({
            ...value,
        });
    }
    init() {
        this.triggerFlow(false);
    }
    trigger() {
        this.triggerFlow(true);
    }
    getCriteria(triggerFirst = false) {
        if (triggerFirst) {
            return this.runTrigger().pipe(switchMap((id) => this._creditPreScreeningService.getById(id)));
        }
        const existingId = this.get().id;
        if (existingId) {
            return this._creditPreScreeningService.getById(existingId);
        }
        return this._applicationPreScreeningService
            .getPreScreeningId(this.get().entityId)
            .pipe(switchMap((ids) => {
            if (!ids.length)
                return of(null);
            const { stage } = this.get();
            return zip(...ids.map((id) => this._creditPreScreeningService.getById(id))).pipe(map((items) => items.filter((item) => item.stage === stage &&
                item.identifier === toPreScreeningCriteriaIdentifier(this.get()) &&
                this.get().customFilterCallback(item))), map((items) => items.sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime())), map((items) => items.pop()));
        }));
    }
    runTrigger() {
        return this.getCheckPointDate().pipe(switchMap((checkpoint_date) => this._creditPreScreeningService.triggerRulify(this.generatePayload(checkpoint_date)).pipe(switchMap(({ id }) => this._applicationPreScreeningService.addPreScreeningId(this.get().entityId, id)), tap(() => {
            this._alertService.success('Notification', 'Trigger successfully!', {
                duration: 1000,
            });
        }))));
    }
    patchData(data) {
        this.validating.emit({
            isScreeningResultPresent: this.get().flow === FSWFlow.INSTANT ? true : !!data,
        });
        this.patchState((state) => ({
            ...state,
            id: data?.id,
        }));
        this.array.patchValue(data?.criteria || []);
        if (!isEmpty(omit(data?.rulify.data || {}, 'application_member_detail'))) {
            this.dataForm.patchValue(omit(data?.rulify.data, ['application_member_detail', 'trade_reference_company_categories']));
            const { trade_reference_company_categories } = data?.rulify
                .data;
            this.updateTradeReferenceCategories((this.state().tradeReferenceNames || []).map((name) => ({
                name,
                category: (trade_reference_company_categories || []).find((item) => item.name === name)
                    ?.category || 'N/A',
            })));
        }
        else {
            this.dataForm.patchValue({
                has_returned_cheque: false,
                invalid_cheque_count: 0,
            });
            this.updateTradeReferenceCategories((this.state().tradeReferenceNames || []).map((name) => ({ name, category: 'N/A' })));
        }
        this.updateJustificationMap();
    }
    updateJustificationMap() {
        this.justificationMap.clear();
        const data = this.array.value;
        data.forEach((item) => this.justificationMap.set(item.id, item.justification));
        this.validating.emit({
            isScreeningResultPresent: !!data.length,
            areAllFailedJustificationPresent: this.get().flow === FSWFlow.INSTANT
                ? true
                : !!data.length &&
                    !data
                        .filter((item) => item.result === 'FAIL')
                        .some((item) => !item.justification?.length),
        });
    }
    updateTradeReferenceCategories(data = []) {
        this.tradeReferenceCompanyCategories.clear();
        data.forEach((item) => {
            this.tradeReferenceCompanyCategories.push(new UntypedFormGroup({
                name: new UntypedFormControl(item.name),
                category: new UntypedFormControl(item.category, [Validators.required]),
            }));
        });
        this.tradeReferenceChange.emit(data);
    }
    getJustificationPayload() {
        const data = this.array.value;
        return data
            .filter((item) => {
            const mapItem = this.justificationMap.get(item.id);
            return !isEqual(mapItem, item.justification);
        })
            .map((item) => ({
            id: item.id,
            justification: item.justification,
        }));
    }
    getCheckPointDate() {
        const { parentLoanId, isTopUp, stage, parentFacilityCode } = this.get();
        const cannotGetDateByStage = stage !== FSWCreditPreScreeningStages.MY_DF_CTOS || !parentFacilityCode;
        if (!cannotGetDateByStage) {
            return forkJoin([
                this._facilityService.getFacilitiesByCode(parentFacilityCode),
                this._facilityService.getPreApprovedFacilitiesByCode(parentFacilityCode),
            ]).pipe(map(([facilities, preApprovedFacilities]) => {
                const latest = facilities.pop();
                if (!latest) {
                    return null;
                }
                const item = preApprovedFacilities?.find((item) => item.code === latest.code && item.version === latest.version);
                return item?.facilityVersionDate || null;
            }));
        }
        const cannotGetDateByTopUp = !parentLoanId || !isTopUp;
        if (!cannotGetDateByTopUp) {
            return this._financeService.getDisburses([parentLoanId]).pipe(map((disburses) => {
                if (!disburses?.length) {
                    return null;
                }
                return disburses[0].disbursal_date;
            }), catchError(() => of(null)));
        }
        return of(null);
    }
    generatePayload(checkpoint_date) {
        const { stage, entityId, entityNumber, isTopUp, partnerId, allowedProductUPI, prescreeningIdsData, customPayloadDataCallback, } = this.get();
        const productUPI = allowedProductUPI || 'SG-MB';
        let stageMapping = {
            [FSWCreditPreScreeningStages.CTOS]: {
                name: isTopUp ? FSWCreditPreScreeningNames.CTOS_TOP_UP : FSWCreditPreScreeningNames.CTOS,
                identifier: isTopUp
                    ? FSWCreditPreScreeningIdentifiers.CTOS_TOP_UP
                    : FSWCreditPreScreeningIdentifiers.CTOS,
                rule_set_identifier: isTopUp
                    ? FSWCreditPreScreeningRuleSetIdentifier.CTOS_TOP_UP
                    : FSWCreditPreScreeningRuleSetIdentifier.CTOS,
                data: {
                    trade_reference_company_categories: this.tradeReferenceCompanyCategories.value,
                },
                extraction_params: {},
            },
            [FSWCreditPreScreeningStages.MY_DF_CTOS]: {
                name: FSWCreditPreScreeningNames.MY_DF_CTOS,
                identifier: FSWCreditPreScreeningIdentifiers.MY_DF_CTOS,
                rule_set_identifier: FSWCreditPreScreeningRuleSetIdentifier.MY_DF_CTOS,
                data: {
                    trade_reference_company_categories: this.tradeReferenceCompanyCategories.value,
                },
                extraction_params: {},
            },
            [FSWCreditPreScreeningStages.BANK]: {
                name: FSWCreditPreScreeningNames.BANK,
                identifier: FSWCreditPreScreeningIdentifiers.BANK,
                rule_set_identifier: FSWCreditPreScreeningRuleSetIdentifier.BANK,
                data: {
                    has_returned_cheque: this.hasReturnedCheque.value,
                    invalid_cheque_count: this.noOfDishonouredOrReturnedCheques.value,
                },
                extraction_params: {},
            },
            [FSWCreditPreScreeningStages.CBS]: {
                name: FSWCreditPreScreeningNames.CBS,
                identifier: FSWCreditPreScreeningIdentifiers.CBS,
                rule_set_identifier: FSWCreditPreScreeningRuleSetIdentifier.CBS,
                data: {},
                extraction_params: {},
            },
            [FSWCreditPreScreeningStages.BASIC_PRESCREENING]: {
                name: FSWCreditPreScreeningNames.BASIC_PRESCREENING,
                identifier: FSWCreditPreScreeningIdentifiers.BASIC_PRESCREENING,
                rule_set_identifier: FSWCreditPreScreeningRuleSetIdentifier.MY_DF_BASIC,
                data: {},
                extraction_params: {},
            },
            // Add more stages here for SG Prescreening Details
            [FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BASIC_DETAILS]: {
                name: STAGES_DATA[productUPI][FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BASIC_DETAILS].name,
                identifier: prescreeningIdsData && prescreeningIdsData[productUPI].default.BASIC,
                rule_set_identifier: prescreeningIdsData && prescreeningIdsData[productUPI].default.BASIC,
                data: {},
                extraction_params: {},
            },
            [FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BRC]: {
                name: STAGES_DATA[productUPI][FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BRC].name,
                identifier: prescreeningIdsData && prescreeningIdsData[productUPI].default.BRC,
                rule_set_identifier: prescreeningIdsData && prescreeningIdsData[productUPI].default.BRC,
                data: {},
                extraction_params: {},
            },
            [FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BRI]: {
                name: STAGES_DATA[productUPI][FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BRI].name,
                identifier: prescreeningIdsData && prescreeningIdsData[productUPI].default.BRI,
                rule_set_identifier: prescreeningIdsData && prescreeningIdsData[productUPI].default.BRI,
                data: {},
                extraction_params: {},
            },
            [FSWCreditPreScreeningStages.SG_BOLT_SG_MB_CBS]: {
                name: STAGES_DATA[productUPI][FSWCreditPreScreeningStages.SG_BOLT_SG_MB_CBS].name,
                identifier: prescreeningIdsData && prescreeningIdsData[productUPI].default.SG_CBS,
                rule_set_identifier: prescreeningIdsData && prescreeningIdsData[productUPI].default.SG_CBS,
                data: {},
                extraction_params: {},
            },
            [FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BANK_STATEMENT]: {
                name: STAGES_DATA[productUPI][FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BANK_STATEMENT]
                    .name,
                identifier: prescreeningIdsData && prescreeningIdsData[productUPI].default.SG_BANK_STATEMENT,
                rule_set_identifier: prescreeningIdsData && prescreeningIdsData[productUPI].default.SG_BANK_STATEMENT,
                data: {},
                extraction_params: {
                    is_ctos_required: false,
                    entity_no: this.get().member?.company_registration_number,
                },
            },
        };
        if (partnerId &&
            prescreeningIdsData &&
            prescreeningIdsData[productUPI] &&
            prescreeningIdsData[productUPI][`${partnerId}`]) {
            stageMapping = {
                ...stageMapping,
                [FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BASIC_DETAILS]: {
                    name: STAGES_DATA[productUPI][FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BASIC_DETAILS]
                        .name,
                    identifier: prescreeningIdsData[productUPI][`${partnerId}`].BASIC,
                    rule_set_identifier: prescreeningIdsData[productUPI][`${partnerId}`].BASIC,
                    data: {},
                    extraction_params: {},
                },
                [FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BRC]: {
                    name: STAGES_DATA[productUPI][FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BRC].name,
                    identifier: prescreeningIdsData[productUPI][`${partnerId}`].BRC,
                    rule_set_identifier: prescreeningIdsData[productUPI][`${partnerId}`].BRC,
                    data: {},
                    extraction_params: {},
                },
                [FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BRI]: {
                    name: STAGES_DATA[productUPI][FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BRI].name,
                    identifier: prescreeningIdsData[productUPI][`${partnerId}`].BRI,
                    rule_set_identifier: prescreeningIdsData[productUPI][`${partnerId}`].BRI,
                    data: {},
                    extraction_params: {},
                },
                [FSWCreditPreScreeningStages.SG_BOLT_SG_MB_CBS]: {
                    name: STAGES_DATA[productUPI][FSWCreditPreScreeningStages.SG_BOLT_SG_MB_CBS].name,
                    identifier: prescreeningIdsData[productUPI][`${partnerId}`].SG_CBS,
                    rule_set_identifier: prescreeningIdsData[productUPI][`${partnerId}`].SG_CBS,
                    data: {},
                    extraction_params: {},
                },
                [FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BANK_STATEMENT]: {
                    name: STAGES_DATA[productUPI][FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BANK_STATEMENT]
                        .name,
                    identifier: prescreeningIdsData[productUPI][`${partnerId}`].SG_BANK_STATEMENT,
                    rule_set_identifier: prescreeningIdsData[productUPI][`${partnerId}`].SG_BANK_STATEMENT,
                    data: {},
                    extraction_params: {
                        is_ctos_required: false,
                        entity_no: this.get().member?.company_registration_number,
                    },
                },
            };
        }
        const foundStage = stageMapping[stage];
        return customPayloadDataCallback({
            stage,
            name: foundStage.name,
            identifier: foundStage.identifier,
            rulify: {
                rule_set_identifier: foundStage.rule_set_identifier,
                extraction_mode: 'DB',
                extraction_params: {
                    application_id: entityId,
                    ...(checkpoint_date ? { checkpoint_date } : {}),
                    min_fs_commitment: 3000,
                    max_fs_commitment: 100000,
                    ...(foundStage.extraction_params || {}),
                },
                extraction_flags: {
                    no_cache: true,
                },
                data: foundStage.data,
            },
            metadata: {
                application_id: entityId,
                application_number: entityNumber,
            },
            ...(this.get()?.id ? { latest_pre_screening_id: this.get()?.id } : {}),
        });
    }
}

class FSWPreScreeningCriteriaStoreMY extends FSWPreScreeningCriteriaStore {
    constructor(_applicationPreScreeningService, _creditPreScreeningService, _financeService, _facilityService, alertService, _builder) {
        super(_applicationPreScreeningService, _creditPreScreeningService, _financeService, _facilityService, alertService, _builder, {
            id: null,
            entityId: null,
            entityNumber: null,
            partnerId: null,
            allowedProductUPI: null,
            prescreeningIdsData: null,
            flow: FSWFlow.INSTANT,
            stage: FSWCreditPreScreeningStages.CTOS,
            member: null,
            tradeReferenceNames: [],
            builder: null,
            isReadonly: false,
            isTopUp: false,
            parentLoanId: null,
            parentFacilityCode: null,
            customPayloadDataCallback: (data) => data,
            customFilterCallback: () => true,
        });
        this._applicationPreScreeningService = _applicationPreScreeningService;
        this._creditPreScreeningService = _creditPreScreeningService;
        this._financeService = _financeService;
        this._facilityService = _facilityService;
        this.alertService = alertService;
        this._builder = _builder;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCriteriaStoreMY, deps: [{ token: APPLICATION_PRE_SCREENING_SERVICE_TOKEN }, { token: CREDIT_PRE_SCREENING_SERVICE_TOKEN }, { token: FINANCE_SERVICE_TOKEN }, { token: FACILITY_SERVICE_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }, { token: FSW_PRE_SCREENING_CRITERIA_BUILDER_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCriteriaStoreMY }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCriteriaStoreMY, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_PRE_SCREENING_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CREDIT_PRE_SCREENING_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FINANCE_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FACILITY_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PRE_SCREENING_CRITERIA_BUILDER_TOKEN]
                }] }]; } });

const FSWWPreScreeningCriteriaBuilderMY = (config) => {
    const { form, hiddenJustification } = config;
    const translation = FSW_PRE_SCREENING_CRITERIA_TRANSLATION_LOADER[CountryCode.MY];
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.TABLE,
        customClasses: 'fsw-table w-max min-w-full',
        form,
        header: [
            {
                columns: [
                    {
                        label: translation.columns.name,
                        customClasses: 'p-4',
                    },
                    {
                        label: translation.columns.result,
                        customClasses: 'p-4',
                    },
                    ...(hiddenJustification
                        ? []
                        : [
                            {
                                label: translation.columns.justification,
                                customClasses: 'p-4',
                            },
                        ]),
                    {
                        label: translation.columns.remark,
                        customClasses: 'p-4',
                    },
                ],
            },
        ],
        items: [
            {
                body: {
                    key: 'criteria',
                    isLoop: true,
                    data: {
                        columns: [
                            {
                                columnType: 'control',
                                customClasses: 'p-4 flex flex-col gap-2',
                                fields: [
                                    {
                                        key: 'name',
                                        type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                        customClasses: 'font-semibold',
                                        context: {
                                            templateKey: 'description',
                                        },
                                    },
                                    {
                                        key: 'description',
                                        type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                        context: {
                                            templateKey: 'description',
                                        },
                                    },
                                    {
                                        key: 'id',
                                        type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                        context: {
                                            isHidden: true,
                                        },
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                customClasses: 'p-4',
                                fields: [
                                    {
                                        key: 'result',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            isReadonly: true,
                                        },
                                    },
                                ],
                            },
                            ...(hiddenJustification
                                ? []
                                : [
                                    {
                                        columnType: 'control',
                                        customClasses: 'p-4',
                                        fields: [
                                            {
                                                key: 'justification',
                                                type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                                context: {
                                                    templateKey: 'justification_button',
                                                },
                                            },
                                        ],
                                    },
                                ]),
                            {
                                columnType: 'control',
                                customClasses: 'p-4',
                                fields: [
                                    {
                                        key: 'remark',
                                        type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                        context: {
                                            templateKey: 'description',
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                },
            },
        ],
    });
};
const FSWWPreScreeningCriteriaModalBuilderMY = (config) => {
    const { form } = config;
    const translation = FSW_PRE_SCREENING_CRITERIA_TRANSLATION_LOADER[CountryCode.MY];
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.GROUP,
        form,
        customClasses: 'w-full flex flex-col gap-[16px]',
        fields: [
            {
                key: 'name',
                type: FSWDynamicBuilderControlTypes.INPUT,
                context: {
                    isReadonly: true,
                    label: translation.columns.name,
                },
            },
            {
                key: 'result',
                type: FSWDynamicBuilderControlTypes.INPUT,
                context: {
                    isReadonly: true,
                    label: translation.columns.result,
                },
            },
            {
                key: 'justification',
                type: FSWDynamicBuilderControlTypes.INPUT,
                context: {
                    inputType: 'area',
                    rows: 6,
                    label: translation.columns.justification,
                    fullWidth: true,
                },
            },
        ],
    });
};

const FSW_PRE_SCREENING_CRITERIA_MY_PROVIDERS = [
    {
        provide: FSW_PRE_SCREENING_CRITERIA_BUILDER_TOKEN,
        useValue: FSWWPreScreeningCriteriaBuilderMY,
    },
    {
        provide: FSW_PRE_SCREENING_CRITERIA_MODAL_BUILDER_TOKEN,
        useValue: FSWWPreScreeningCriteriaModalBuilderMY,
    },
    {
        provide: FSW_PRE_SCREENING_CRITERIA_STORE_TOKEN,
        useClass: FSWPreScreeningCriteriaStoreMY,
        deps: [
            APPLICATION_PRE_SCREENING_SERVICE_TOKEN,
            CREDIT_PRE_SCREENING_SERVICE_TOKEN,
            FINANCE_SERVICE_TOKEN,
            FACILITY_SERVICE_TOKEN,
            FSW_ALERT_SERVICE_TOKEN,
            FSW_PRE_SCREENING_CRITERIA_BUILDER_TOKEN,
        ],
    },
];

const FSW_PRE_SCREENING_CRITERIA_PROVIDERS = {
    default: FSW_PRE_SCREENING_CRITERIA_MY_PROVIDERS,
    [CountryCode.MY]: FSW_PRE_SCREENING_CRITERIA_MY_PROVIDERS,
};
const preScreeningCriteriaLoadProviders = (countryCode) => [
    fswTranslateScope('pre_screening_criteria'),
    ...getCustomProviders(FSW_PRE_SCREENING_CRITERIA_PROVIDERS, FSW_PRE_SCREENING_CRITERIA_MY_PROVIDERS, countryCode),
];

function preScreeningCriteriaTranslation(scope = 'pre_screening_criteria') {
    return [
        ...(FSWTranslateModule.forFeature({
            scope,
            defaultKey: getCountryCodeFromStorage() ?? CountryCode.SG,
            data: FSW_PRE_SCREENING_CRITERIA_TRANSLATION_LOADER,
        }).providers || []),
        fswTranslateScope(scope),
    ];
}

class FSWPreScreeningCriteriaComponent {
    set id(id) {
        this._componentStore.updateState({
            id,
        });
    }
    set entityId(entityId) {
        this._componentStore.updateState({
            entityId,
        });
    }
    set entityNumber(entityNumber) {
        this._componentStore.updateState({
            entityNumber,
        });
    }
    set partnerId(partnerId) {
        this._componentStore.updateState({
            partnerId,
        });
    }
    set allowedProductUPI(allowedProductUPI) {
        this._componentStore.updateState({
            allowedProductUPI,
        });
    }
    set prescreeningIdsData(prescreeningIdsData) {
        this._componentStore.updateState({
            prescreeningIdsData,
        });
    }
    set flow(flow) {
        this._componentStore.updateState({
            flow,
        });
    }
    set stage(stage) {
        this._componentStore.updateState({
            stage,
        });
    }
    set member(member) {
        this._componentStore.updateState({
            member,
        });
    }
    set tradeReferenceNames(tradeReferenceNames) {
        this._componentStore.updateState({
            tradeReferenceNames,
        });
    }
    set isReadonly(isReadonly) {
        this._componentStore.updateState({
            isReadonly,
        });
    }
    set isTopUp(isTopUp) {
        this._componentStore.updateState({
            isTopUp,
        });
    }
    set parentLoanId(parentLoanId) {
        this._componentStore.updateState({
            parentLoanId,
        });
    }
    set parentFacilityCode(parentFacilityCode) {
        this._componentStore.updateState({
            parentFacilityCode,
        });
    }
    set customPayloadDataCallback(customPayloadDataCallback) {
        this._componentStore.updateState({
            customPayloadDataCallback,
        });
    }
    set customFilterCallback(customFilterCallback) {
        this._componentStore.updateState({
            customFilterCallback,
        });
    }
    constructor(_componentStore, _dialog, _injector) {
        this._componentStore = _componentStore;
        this._dialog = _dialog;
        this._injector = _injector;
        this.validating = this._componentStore.validating;
        this.tradeReferenceChange = this._componentStore.tradeReferenceChange;
        this.title = 'Pre Screening Criteria';
        this.form = this._componentStore.form;
        this.state$ = this._componentStore.state$;
        this.FSWFlow = FSWFlow;
        this.FSWCreditPreScreeningStages = FSWCreditPreScreeningStages;
    }
    ngOnInit() {
        this._componentStore.init();
    }
    trigger(data) {
        if (this._componentStore.ignoreSelectDataBeforeTriggering) {
            this._componentStore.trigger();
            return;
        }
        this._dialog
            .open(FSWPreScreeningCriteriaSelectDataComponent, {
            data,
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((value) => {
            if (value) {
                this._componentStore.trigger();
            }
        }))
            .subscribe();
    }
    updateJustification() {
        if (this._componentStore.state().isReadonly)
            return;
        this._componentStore.updateJustification();
    }
    updateJustificationItem(control) {
        this._dialog
            .open(FSWPreScreeningCriteriaEditJustificationComponent, {
            data: control,
            injector: this._injector,
        })
            .closed.pipe(take(1))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCriteriaComponent, deps: [{ token: FSW_PRE_SCREENING_CRITERIA_STORE_TOKEN }, { token: i1$7.Dialog }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWPreScreeningCriteriaComponent, selector: "fsw-pre-screening-criteria", inputs: { title: "title", id: "id", entityId: "entityId", entityNumber: "entityNumber", partnerId: "partnerId", allowedProductUPI: "allowedProductUPI", prescreeningIdsData: "prescreeningIdsData", flow: "flow", stage: "stage", member: "member", tradeReferenceNames: "tradeReferenceNames", isReadonly: "isReadonly", isTopUp: "isTopUp", parentLoanId: "parentLoanId", parentFacilityCode: "parentFacilityCode", customPayloadDataCallback: "customPayloadDataCallback", customFilterCallback: "customFilterCallback" }, outputs: { validating: "validating", tradeReferenceChange: "tradeReferenceChange" }, providers: [preScreeningCriteriaTranslation()], ngImport: i0, template: "<fsw-panel [title]=\"title\" *ngIf=\"state$ | async as state\">\n  <ng-template fswPanelHeaderSuffix>\n    <section class=\"flex items-center gap-[8px]\" *ngIf=\"state.flow === FSWFlow.MANUAL\">\n      <button fswButton (click)=\"trigger(state.stage)\" [disabled]=\"state.isReadonly\">\n        {{ state.id ? ('buttons.refresh' | fswTranslate) : ('buttons.trigger' | fswTranslate) }}\n      </button>\n      <button\n        *ngIf=\"state.id\"\n        fswButton\n        (click)=\"updateJustification()\"\n        [disabled]=\"state.isReadonly\"\n      >\n        {{ 'buttons.update' | fswTranslate }}\n      </button>\n    </section>\n  </ng-template>\n  <section class=\"w-full overflow-auto\" *ngIf=\"state.id\">\n    <form [formGroup]=\"form\">\n      <fsw-dynamic-builder [builder]=\"state.builder\">\n        <ng-template fswDynamicBuilderTemplate key=\"justification_button\" let-control=\"control\">\n          <fsw-field [readOnly]=\"state.isReadonly\">\n            <textarea fswInput [formControl]=\"control\" [rows]=\"5\"></textarea>\n          </fsw-field>\n        </ng-template>\n        <ng-template fswDynamicBuilderTemplate key=\"description\" let-control=\"control\">\n          <p\n            [innerHTML]=\"control.value | fswPreScreeningCriteriaDescription\"\n            class=\"max-w-[300px] whitespace-pre-wrap\"\n          ></p>\n        </ng-template>\n      </fsw-dynamic-builder>\n    </form>\n  </section>\n</fsw-panel>\n", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$4.FSWDynamicBuilderTemplateDirective, selector: "[fswDynamicBuilderTemplate]", inputs: ["key"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$4.FSWInputDirective, selector: "input[fswInput], textarea[fswInput]" }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "pipe", type: FSWPreScreeningCriteriaDescriptionPipe, name: "fswPreScreeningCriteriaDescription" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCriteriaComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-pre-screening-criteria', changeDetection: ChangeDetectionStrategy.OnPush, providers: [preScreeningCriteriaTranslation()], template: "<fsw-panel [title]=\"title\" *ngIf=\"state$ | async as state\">\n  <ng-template fswPanelHeaderSuffix>\n    <section class=\"flex items-center gap-[8px]\" *ngIf=\"state.flow === FSWFlow.MANUAL\">\n      <button fswButton (click)=\"trigger(state.stage)\" [disabled]=\"state.isReadonly\">\n        {{ state.id ? ('buttons.refresh' | fswTranslate) : ('buttons.trigger' | fswTranslate) }}\n      </button>\n      <button\n        *ngIf=\"state.id\"\n        fswButton\n        (click)=\"updateJustification()\"\n        [disabled]=\"state.isReadonly\"\n      >\n        {{ 'buttons.update' | fswTranslate }}\n      </button>\n    </section>\n  </ng-template>\n  <section class=\"w-full overflow-auto\" *ngIf=\"state.id\">\n    <form [formGroup]=\"form\">\n      <fsw-dynamic-builder [builder]=\"state.builder\">\n        <ng-template fswDynamicBuilderTemplate key=\"justification_button\" let-control=\"control\">\n          <fsw-field [readOnly]=\"state.isReadonly\">\n            <textarea fswInput [formControl]=\"control\" [rows]=\"5\"></textarea>\n          </fsw-field>\n        </ng-template>\n        <ng-template fswDynamicBuilderTemplate key=\"description\" let-control=\"control\">\n          <p\n            [innerHTML]=\"control.value | fswPreScreeningCriteriaDescription\"\n            class=\"max-w-[300px] whitespace-pre-wrap\"\n          ></p>\n        </ng-template>\n      </fsw-dynamic-builder>\n    </form>\n  </section>\n</fsw-panel>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PRE_SCREENING_CRITERIA_STORE_TOKEN]
                }] }, { type: i1$7.Dialog }, { type: i0.Injector }]; }, propDecorators: { validating: [{
                type: Output
            }], tradeReferenceChange: [{
                type: Output
            }], title: [{
                type: Input
            }], id: [{
                type: Input
            }], entityId: [{
                type: Input
            }], entityNumber: [{
                type: Input
            }], partnerId: [{
                type: Input
            }], allowedProductUPI: [{
                type: Input
            }], prescreeningIdsData: [{
                type: Input
            }], flow: [{
                type: Input
            }], stage: [{
                type: Input
            }], member: [{
                type: Input
            }], tradeReferenceNames: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], isTopUp: [{
                type: Input
            }], parentLoanId: [{
                type: Input
            }], parentFacilityCode: [{
                type: Input
            }], customPayloadDataCallback: [{
                type: Input
            }], customFilterCallback: [{
                type: Input
            }] } });

class FSWPreScreeningCriteriaDirective {
    constructor(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
        this.validating = new EventEmitter();
        this.tradeReferenceChange = new EventEmitter();
        this.id = null;
        this.title = 'Pre Screening Criteria';
        this.entityId = null;
        this.entityNumber = null;
        this.partnerId = null;
        this.allowedProductUPI = null;
        this.prescreeningIdsData = null;
        this.flow = FSWFlow.INSTANT;
        this.stage = FSWCreditPreScreeningStages.CTOS;
        this.member = null;
        this.tradeReferenceNames = [];
        this.isReadonly = false;
        this.isTopUp = false;
        this.parentLoanId = null;
        this.parentFacilityCode = null;
        this.customPayloadDataCallback = (data) => data;
        this.customFilterCallback = () => true;
    }
    ngOnChanges() {
        this._viewContainerRef.clear();
        const ref = this._viewContainerRef.createComponent(FSWPreScreeningCriteriaComponent, {
            injector: Injector.create({
                parent: this._viewContainerRef.injector,
                providers: [...preScreeningCriteriaLoadProviders(getCountryCodeFromStorage())],
            }),
        });
        const instance = ref.instance;
        instance.title = this.title;
        instance.id = this.id;
        instance.entityId = this.entityId;
        instance.entityNumber = this.entityNumber;
        instance.partnerId = this.partnerId;
        instance.allowedProductUPI = this.allowedProductUPI;
        instance.prescreeningIdsData = this.prescreeningIdsData;
        instance.flow = this.flow;
        instance.stage = this.stage;
        instance.member = this.member;
        instance.tradeReferenceNames = this.tradeReferenceNames;
        instance.isReadonly = this.isReadonly;
        instance.isTopUp = this.isTopUp;
        instance.parentLoanId = this.parentLoanId;
        instance.parentFacilityCode = this.parentFacilityCode;
        instance.customPayloadDataCallback = this.customPayloadDataCallback;
        instance.customFilterCallback = this.customFilterCallback;
        merge(instance.tradeReferenceChange.pipe(tap((value) => this.tradeReferenceChange.emit(value))), instance.validating.pipe(tap((value) => this.validating.emit(value)))).subscribe();
        ref.changeDetectorRef.detectChanges();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCriteriaDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWPreScreeningCriteriaDirective, selector: "[fswPreScreeningCriteria]", inputs: { id: "id", title: "title", entityId: "entityId", entityNumber: "entityNumber", partnerId: "partnerId", allowedProductUPI: "allowedProductUPI", prescreeningIdsData: "prescreeningIdsData", flow: "flow", stage: "stage", member: "member", tradeReferenceNames: "tradeReferenceNames", isReadonly: "isReadonly", isTopUp: "isTopUp", parentLoanId: "parentLoanId", parentFacilityCode: "parentFacilityCode", customPayloadDataCallback: "customPayloadDataCallback", customFilterCallback: "customFilterCallback" }, outputs: { validating: "validating", tradeReferenceChange: "tradeReferenceChange" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCriteriaDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswPreScreeningCriteria]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; }, propDecorators: { validating: [{
                type: Output
            }], tradeReferenceChange: [{
                type: Output
            }], id: [{
                type: Input
            }], title: [{
                type: Input
            }], entityId: [{
                type: Input
            }], entityNumber: [{
                type: Input
            }], partnerId: [{
                type: Input
            }], allowedProductUPI: [{
                type: Input
            }], prescreeningIdsData: [{
                type: Input
            }], flow: [{
                type: Input
            }], stage: [{
                type: Input
            }], member: [{
                type: Input
            }], tradeReferenceNames: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], isTopUp: [{
                type: Input
            }], parentLoanId: [{
                type: Input
            }], parentFacilityCode: [{
                type: Input
            }], customPayloadDataCallback: [{
                type: Input
            }], customFilterCallback: [{
                type: Input
            }] } });

class FSWPreScreeningCriteriaModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCriteriaModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCriteriaModule, declarations: [FSWPreScreeningCriteriaComponent,
            FSWPreScreeningCriteriaDirective,
            FSWPreScreeningCriteriaEditJustificationComponent,
            FSWPreScreeningCriteriaSelectDataComponent,
            FSWPreScreeningCriteriaDescriptionPipe], imports: [FSWTranslateModule,
            NgForOf,
            NgIf,
            ReactiveFormsModule,
            FSWButtonModule,
            FSWDynamicBuilderModule,
            ApplicationPreScreeningServiceModule,
            CreditPreScreeningServiceModule,
            FacilityServiceModule,
            FinanceServiceModule,
            FSWIconModule,
            AsyncPipe,
            FSWButtonModule,
            FSWPanelModule,
            FSWModalModule$1,
            FSWCheckboxModule,
            FSWAlertModule,
            DialogModule,
            NgSwitch,
            NgSwitchCase,
            FSWSelectModule,
            FSWFieldModule,
            FSWInputModule,
            ForceControlPipeModule,
            ForceGroupPipeModule,
            NgTemplateOutlet], exports: [FSWPreScreeningCriteriaComponent,
            FSWPreScreeningCriteriaDirective,
            FSWPreScreeningCriteriaEditJustificationComponent,
            FSWPreScreeningCriteriaSelectDataComponent,
            FSWPreScreeningCriteriaDescriptionPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCriteriaModule, imports: [FSWTranslateModule,
            ReactiveFormsModule,
            FSWButtonModule,
            FSWDynamicBuilderModule,
            ApplicationPreScreeningServiceModule,
            CreditPreScreeningServiceModule,
            FacilityServiceModule,
            FinanceServiceModule,
            FSWIconModule,
            FSWButtonModule,
            FSWPanelModule,
            FSWModalModule$1,
            FSWCheckboxModule,
            FSWAlertModule,
            DialogModule,
            FSWSelectModule,
            FSWFieldModule,
            FSWInputModule,
            ForceControlPipeModule,
            ForceGroupPipeModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCriteriaModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FSWPreScreeningCriteriaComponent,
                        FSWPreScreeningCriteriaDirective,
                        FSWPreScreeningCriteriaEditJustificationComponent,
                        FSWPreScreeningCriteriaSelectDataComponent,
                        FSWPreScreeningCriteriaDescriptionPipe,
                    ],
                    imports: [
                        FSWTranslateModule,
                        NgForOf,
                        NgIf,
                        ReactiveFormsModule,
                        FSWButtonModule,
                        FSWDynamicBuilderModule,
                        ApplicationPreScreeningServiceModule,
                        CreditPreScreeningServiceModule,
                        FacilityServiceModule,
                        FinanceServiceModule,
                        FSWIconModule,
                        AsyncPipe,
                        FSWButtonModule,
                        FSWPanelModule,
                        FSWModalModule$1,
                        FSWCheckboxModule,
                        FSWAlertModule,
                        DialogModule,
                        NgSwitch,
                        NgSwitchCase,
                        FSWSelectModule,
                        FSWFieldModule,
                        FSWInputModule,
                        ForceControlPipeModule,
                        ForceGroupPipeModule,
                        NgTemplateOutlet,
                    ],
                    exports: [
                        FSWPreScreeningCriteriaComponent,
                        FSWPreScreeningCriteriaDirective,
                        FSWPreScreeningCriteriaEditJustificationComponent,
                        FSWPreScreeningCriteriaSelectDataComponent,
                        FSWPreScreeningCriteriaDescriptionPipe,
                    ],
                }]
        }] });

const FSW_PRE_SCREENING_COMPANY_DETAILS_STORE_TOKEN = new InjectionToken('FSW_PRE_SCREENING_COMPANY_DETAILS_STORE_TOKEN');

const FSW_PRE_SCREENING_COMPANY_DETAILS_BUILDER_TOKEN = new InjectionToken('FSW_PRE_SCREENING_COMPANY_DETAILS_BUILDER_TOKEN');

class PreScreeningCompanyDetailsComponent {
    set entityId(entityId) {
        this._componentStore.updateState({
            entityId,
        });
    }
    set flow(flow) {
        this._componentStore.updateState({
            flow,
        });
    }
    set member(member) {
        this._componentStore.updateState({
            member,
        });
    }
    set isReadonly(isReadonly) {
        this._componentStore.updateState({
            isReadonly,
        });
    }
    set isCompanyDetailsReadonly(isCompanyDetailsReadonly) {
        this._componentStore.updateState({
            isCompanyDetailsReadonly,
        });
    }
    constructor(_componentStore) {
        this._componentStore = _componentStore;
        this.state$ = this._componentStore.state$;
        this.form = this._componentStore.form;
        this.FSWFlow = FSWFlow;
    }
    ngOnInit() {
        this._componentStore.init();
    }
    save() {
        this._componentStore.saveChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningCompanyDetailsComponent, deps: [{ token: FSW_PRE_SCREENING_COMPANY_DETAILS_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PreScreeningCompanyDetailsComponent, selector: "fsw-pre-screening-company-details", inputs: { entityId: "entityId", flow: "flow", member: "member", isReadonly: "isReadonly", isCompanyDetailsReadonly: "isCompanyDetailsReadonly" }, ngImport: i0, template: "<fsw-panel\n  [title]=\"'title' | fswTranslate\"\n  *ngIf=\"state$ | async as state\"\n  customClasses=\"w-[800px]\"\n>\n  <form [formGroup]=\"form\">\n    <fsw-dynamic-builder [builder]=\"state.builder\"></fsw-dynamic-builder>\n    <footer *ngIf=\"!state.isReadonly\" class=\"w-full flex justify-end mt-4\">\n      <button fswButton (click)=\"save()\">\n        {{ 'Save' }}\n      </button>\n    </footer>\n  </form>\n</fsw-panel>\n", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningCompanyDetailsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-pre-screening-company-details', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-panel\n  [title]=\"'title' | fswTranslate\"\n  *ngIf=\"state$ | async as state\"\n  customClasses=\"w-[800px]\"\n>\n  <form [formGroup]=\"form\">\n    <fsw-dynamic-builder [builder]=\"state.builder\"></fsw-dynamic-builder>\n    <footer *ngIf=\"!state.isReadonly\" class=\"w-full flex justify-end mt-4\">\n      <button fswButton (click)=\"save()\">\n        {{ 'Save' }}\n      </button>\n    </footer>\n  </form>\n</fsw-panel>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PRE_SCREENING_COMPANY_DETAILS_STORE_TOKEN]
                }] }]; }, propDecorators: { entityId: [{
                type: Input
            }], flow: [{
                type: Input
            }], member: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], isCompanyDetailsReadonly: [{
                type: Input
            }] } });

class FSWPreScreeningCompanyDetailsStore extends ComponentStore {
    constructor(_referenceService, _alertService, _memberService, _builder, _initialState) {
        super(_initialState);
        this._referenceService = _referenceService;
        this._alertService = _alertService;
        this._memberService = _memberService;
        this._builder = _builder;
        this._initialState = _initialState;
        this.form = new UntypedFormGroup({});
        this.saveChanges = this.effect(pipe(tap(() => {
            if (this.get().member?.id) {
                this.updateMember({ member: this.form.value });
            }
            else {
                throw new Error('No memberId exists');
            }
        })));
        this.updateMember = this.effect(pipe(switchMap(({ member }) => this._updateMemberAsync(member))));
        this.init = this.effect(pipe(switchMap(() => this._referenceService.getReference(MemberCode.BORROWER).pipe(tap((reference) => this.updateState({
            industries: reference['industries']?.filter((industry) => industry.countryId === getCountryCodeFromStorage()),
            companyEntityTypes: reference['companyEntityTypes']?.filter((industry) => industry.countryId === getCountryCodeFromStorage()),
        })), tap(() => this.updateBuilder()))), tap(() => {
            const { member } = this.get();
            this.form.patchValue(member
                ? {
                    ...member,
                }
                : {});
        })));
        this.listenIndustryChange = this.effect(pipe(switchMap(() => getControlFromGroup(this.form, 'company_industry_id').valueChanges), filter((id) => !!id), switchMap((id) => this._referenceService.getSubIndustries(id)), tap((subIndustries) => {
            this.updateState({ subIndustries });
            this.updateBuilder();
        })));
        this.updateState = (value) => this.patchState({
            ...value,
        });
    }
    updateBuilder() {
        const { industries, subIndustries, companyEntityTypes } = this.get();
        const oldValue = this.form.value;
        this.patchState((state) => ({
            ...state,
            builder: this._builder({
                form: this.form,
                isReadonly: true,
                isCompanyDetailsReadonly: state.isReadonly,
                industries,
                subIndustries,
                companyEntityTypes,
            }),
        }));
        this.form.patchValue(oldValue, {
            emitEvent: false,
        });
        this.listenIndustryChange();
    }
    _updateMemberAsync(payload) {
        const formattedDate = convertToReadableDate(payload.company_birth_date);
        const updatedPayload = {
            ...payload,
            company_birth_date: formattedDate,
        };
        const { member } = this.get();
        if (!member)
            return EMPTY;
        return this._memberService.updateMember(member?.uuid, updatedPayload).pipe(switchMap(() => this._getMemberAsync()), catchError((err) => {
            console.error(err);
            return EMPTY;
        }));
    }
    _getMemberAsync() {
        const { member, entityId } = this.get();
        if (!isStringValid(entityId))
            return EMPTY;
        return this._memberService
            .getMember(member?.uuid, {
            country_code: getCountryCodeFromStorage(),
            member_type_code: MemberCode.BORROWER,
        })
            .pipe(tap((member) => this.updateState({ member })), catchError((err) => {
            console.error(err);
            return EMPTY;
        }));
    }
}

class FSWPreScreeningCompanyDetailsStoreMY extends FSWPreScreeningCompanyDetailsStore {
    constructor(referenceService, alertService, memberService, _builder) {
        super(referenceService, alertService, memberService, _builder, {
            id: null,
            entityId: null,
            flow: FSWFlow.INSTANT,
            builder: null,
            industries: [],
            companyEntityTypes: [],
            subIndustries: [],
            member: null,
            isReadonly: false,
            isCompanyDetailsReadonly: true, // default is set to true
        });
        this.referenceService = referenceService;
        this.alertService = alertService;
        this.memberService = memberService;
        this._builder = _builder;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCompanyDetailsStoreMY, deps: [{ token: REFERENCE_SERVICE_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }, { token: MEMBER_SERVICE_TOKEN }, { token: FSW_PRE_SCREENING_COMPANY_DETAILS_BUILDER_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCompanyDetailsStoreMY }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCompanyDetailsStoreMY, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [REFERENCE_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PRE_SCREENING_COMPANY_DETAILS_BUILDER_TOKEN]
                }] }]; } });

var title$d = "Company Details";
var fields$9 = {
	name: "Company Name",
	industry: "Industry",
	number: "Business Registration Number",
	sub_industry: "Sub Industry",
	type: "Business Entity Type",
	other_industry: "Other Industry (Optional)",
	revenue: "Annual Revenue",
	date: "Incorporation Date"
};
var my$a = {
	title: title$d,
	fields: fields$9
};

var MY$8 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: my$a,
    fields: fields$9,
    title: title$d
});

const FSW_PRE_SCREENING_COMPANY_DETAILS_TRANSLATION_LOADER = {
    [CountryCode.MY]: MY$8,
};

const FSWWPreScreeningCompanyDetailsBuilderMY = (config) => {
    const { form, isCompanyDetailsReadonly, industries, subIndustries, companyEntityTypes } = config;
    const translation = FSW_PRE_SCREENING_COMPANY_DETAILS_TRANSLATION_LOADER[CountryCode.MY];
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'w-full flex gap-[16px] flex-wrap',
        form,
        readonlyWhen$: of(isCompanyDetailsReadonly),
        fields: [
            {
                key: 'company_name',
                customClasses: 'w-[calc(50%-8px)]',
                type: FSWDynamicBuilderControlTypes.INPUT,
                context: {
                    fullWidth: true,
                    label: translation.fields.name,
                    isReadonly: true,
                },
            },
            {
                key: 'company_industry_id',
                customClasses: 'w-[calc(50%-8px)]',
                type: FSWDynamicBuilderControlTypes.SELECT,
                context: {
                    fullWidth: true,
                    label: translation.fields.industry,
                    items: industries.map((industry) => ({
                        text: industry.name,
                        value: industry.id,
                    })),
                    maxHeight: '300px',
                    readonlyTemplate: (value) => {
                        const industry = industries.find((item) => item.id === value);
                        return industry?.name || '';
                    },
                },
            },
            {
                key: 'company_registration_number',
                customClasses: 'w-[calc(50%-8px)]',
                type: FSWDynamicBuilderControlTypes.INPUT,
                context: {
                    fullWidth: true,
                    label: translation.fields.number,
                    isReadonly: true,
                },
            },
            {
                key: 'company_sub_industry_id',
                customClasses: 'w-[calc(50%-8px)]',
                type: FSWDynamicBuilderControlTypes.SELECT,
                context: {
                    fullWidth: true,
                    label: translation.fields.sub_industry,
                    items: subIndustries.map((industry) => ({
                        text: industry.name,
                        value: +industry.id,
                    })),
                    maxHeight: '300px',
                    readonlyTemplate: (value) => {
                        if (value && subIndustries.length) {
                            const industry = subIndustries.find((item) => item.id == value);
                            return industry?.name || '';
                        }
                        return '';
                    },
                },
            },
            {
                key: 'company_entity_type_id',
                customClasses: 'w-[calc(50%-8px)]',
                type: FSWDynamicBuilderControlTypes.SELECT,
                context: {
                    fullWidth: true,
                    label: translation.fields.type,
                    items: companyEntityTypes.map((item) => ({
                        text: item.name,
                        value: item.id,
                    })),
                    readonlyTemplate: (value) => {
                        const item = companyEntityTypes.find((item) => item.id === value);
                        return item?.name || '';
                    },
                },
            },
            {
                key: 'company_industry_other',
                customClasses: 'w-[calc(50%-8px)]',
                type: FSWDynamicBuilderControlTypes.INPUT,
                context: {
                    fullWidth: true,
                    label: translation.fields.other_industry,
                },
            },
            {
                key: 'company_birth_date',
                customClasses: 'w-[calc(50%-8px)]',
                type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                context: {
                    fullWidth: true,
                    label: translation.fields.date,
                    readonlyTemplate: (value) => new DatePipe('en-US').transform(value, 'dd/MM/yyyy') || '',
                    closeOnSelected: true,
                },
            },
            {
                key: 'company_annual_revenue',
                customClasses: 'w-[calc(50%-8px)]',
                type: FSWDynamicBuilderControlTypes.INPUT,
                context: {
                    fullWidth: true,
                    // inputType: 'number',
                    mask: {
                        expression: 'separator.2',
                        config: {
                            thousandSeparator: ',',
                        },
                    },
                    label: translation.fields.revenue,
                },
            },
        ],
    });
};

const FSW_PRE_SCREENING_COMPANY_DETAILS_MY_PROVIDERS = [
    {
        provide: FSW_PRE_SCREENING_COMPANY_DETAILS_BUILDER_TOKEN,
        useValue: FSWWPreScreeningCompanyDetailsBuilderMY,
    },
    {
        provide: FSW_PRE_SCREENING_COMPANY_DETAILS_STORE_TOKEN,
        useClass: FSWPreScreeningCompanyDetailsStoreMY,
        deps: [
            REFERENCE_SERVICE_TOKEN,
            FSW_ALERT_SERVICE_TOKEN,
            MEMBER_SERVICE_TOKEN,
            FSW_PRE_SCREENING_COMPANY_DETAILS_BUILDER_TOKEN,
        ],
    },
];

const FSW_PRE_SCREENING_COMPANY_DETAILS_PROVIDERS = {
    default: FSW_PRE_SCREENING_COMPANY_DETAILS_MY_PROVIDERS,
    [CountryCode.MY]: FSW_PRE_SCREENING_COMPANY_DETAILS_MY_PROVIDERS,
};
const preScreeningCompanyDetailsLoadProviders = (countryCode) => [
    fswTranslateScope('pre_screening_company_details'),
    ...getCustomProviders(FSW_PRE_SCREENING_COMPANY_DETAILS_PROVIDERS, FSW_PRE_SCREENING_COMPANY_DETAILS_MY_PROVIDERS, countryCode),
];

class PreScreeningCompanyDetailsDirective {
    constructor(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
        this.entityId = null;
        this.flow = FSWFlow.INSTANT;
        this.member = null;
        this.isReadonly = false;
        this.isCompanyDetailsReadonly = true; // default is set to true
    }
    ngOnChanges() {
        this._viewContainerRef.clear();
        const ref = this._viewContainerRef.createComponent(PreScreeningCompanyDetailsComponent, {
            injector: Injector.create({
                parent: this._viewContainerRef.injector,
                providers: [...preScreeningCompanyDetailsLoadProviders(getCountryCodeFromStorage())],
            }),
        });
        const instance = ref.instance;
        instance.entityId = this.entityId;
        instance.flow = this.flow;
        instance.member = this.member;
        instance.isReadonly = this.isReadonly;
        instance.isCompanyDetailsReadonly = this.isCompanyDetailsReadonly;
        ref.changeDetectorRef.detectChanges();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningCompanyDetailsDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: PreScreeningCompanyDetailsDirective, selector: "[fswPreScreeningCompanyDetails]", inputs: { entityId: "entityId", flow: "flow", member: "member", isReadonly: "isReadonly", isCompanyDetailsReadonly: "isCompanyDetailsReadonly" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningCompanyDetailsDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswPreScreeningCompanyDetails]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; }, propDecorators: { entityId: [{
                type: Input
            }], flow: [{
                type: Input
            }], member: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], isCompanyDetailsReadonly: [{
                type: Input
            }] } });

const FSW_PRE_SCREENING_TRADE_REFERENCE_STORE_TOKEN = new InjectionToken('FSW_PRE_SCREENING_TRADE_REFERENCE_STORE_TOKEN');

class PreScreeningTradeReferenceComponent {
    set entityId(entityId) {
        this._componentStore.updateState({
            entityId,
        });
    }
    set flow(flow) {
        this._componentStore.updateState({
            flow,
        });
    }
    set member(member) {
        this._componentStore.updateState({
            member,
        });
    }
    set data(data) {
        this._componentStore.updateState({
            data: data.map((item) => ({
                name: item.name,
                category: tradeRefereeCategories.find((category) => category.value === item.category)?.text ||
                    'N/A',
            })),
        });
    }
    set isReadonly(isReadonly) {
        this._componentStore.updateState({
            isReadonly,
        });
    }
    constructor(_componentStore) {
        this._componentStore = _componentStore;
        this.state$ = this._componentStore.state$;
        this.FSWFlow = FSWFlow;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningTradeReferenceComponent, deps: [{ token: FSW_PRE_SCREENING_TRADE_REFERENCE_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PreScreeningTradeReferenceComponent, selector: "fsw-pre-screening-trade-reference", inputs: { entityId: "entityId", flow: "flow", member: "member", data: "data", isReadonly: "isReadonly" }, ngImport: i0, template: "<fsw-panel\n  *ngIf=\"state$ | async as state\"\n  [title]=\"'title' | fswTranslate\"\n  customClasses=\"w-[800px]\"\n>\n  <table class=\"fsw-table w-full\">\n    <caption class=\"hidden\">\n      Trade Reference Selection Table\n    </caption>\n    <thead>\n      <tr>\n        <th>{{ 'columns.trade_referee' | fswTranslate }}</th>\n        <th>{{ 'columns.category_for_trade_referee' | fswTranslate }}</th>\n      </tr>\n    </thead>\n    <tbody>\n      <ng-container *ngFor=\"let item of state.data\">\n        <tr>\n          <td>{{ item.name }}</td>\n          <td>{{ item.category }}</td>\n        </tr>\n      </ng-container>\n    </tbody>\n  </table>\n</fsw-panel>\n", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningTradeReferenceComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-pre-screening-trade-reference', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-panel\n  *ngIf=\"state$ | async as state\"\n  [title]=\"'title' | fswTranslate\"\n  customClasses=\"w-[800px]\"\n>\n  <table class=\"fsw-table w-full\">\n    <caption class=\"hidden\">\n      Trade Reference Selection Table\n    </caption>\n    <thead>\n      <tr>\n        <th>{{ 'columns.trade_referee' | fswTranslate }}</th>\n        <th>{{ 'columns.category_for_trade_referee' | fswTranslate }}</th>\n      </tr>\n    </thead>\n    <tbody>\n      <ng-container *ngFor=\"let item of state.data\">\n        <tr>\n          <td>{{ item.name }}</td>\n          <td>{{ item.category }}</td>\n        </tr>\n      </ng-container>\n    </tbody>\n  </table>\n</fsw-panel>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PRE_SCREENING_TRADE_REFERENCE_STORE_TOKEN]
                }] }]; }, propDecorators: { entityId: [{
                type: Input
            }], flow: [{
                type: Input
            }], member: [{
                type: Input
            }], data: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class FSWPreScreeningTradeReferenceStore extends ComponentStore {
    constructor(_initialState) {
        super(_initialState);
        this._initialState = _initialState;
        this.updateState = (value) => this.patchState({
            ...value,
        });
    }
}

class FSWPreScreeningTradeReferenceStoreMY extends FSWPreScreeningTradeReferenceStore {
    constructor() {
        super({
            entityId: null,
            flow: FSWFlow.INSTANT,
            member: null,
            data: [],
            isReadonly: false,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningTradeReferenceStoreMY, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningTradeReferenceStoreMY }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningTradeReferenceStoreMY, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

const FSW_PRE_SCREENING_TRADE_REFERENCE_MY_PROVIDERS = [
    {
        provide: FSW_PRE_SCREENING_TRADE_REFERENCE_STORE_TOKEN,
        useClass: FSWPreScreeningTradeReferenceStoreMY,
        deps: [],
    },
];

const FSW_PRE_SCREENING_TRADE_REFERENCE_PROVIDERS = {
    default: FSW_PRE_SCREENING_TRADE_REFERENCE_MY_PROVIDERS,
    [CountryCode.MY]: FSW_PRE_SCREENING_TRADE_REFERENCE_MY_PROVIDERS,
};
const preScreeningTradeReferenceLoadProviders = (countryCode) => [
    fswTranslateScope('pre_screening_trade_reference'),
    ...getCustomProviders(FSW_PRE_SCREENING_TRADE_REFERENCE_PROVIDERS, FSW_PRE_SCREENING_TRADE_REFERENCE_MY_PROVIDERS, countryCode),
];

class PreScreeningTradeReferenceDirective {
    constructor(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
        this.entityId = null;
        this.flow = FSWFlow.INSTANT;
        this.member = null;
        this.data = [];
        this.isReadonly = false;
    }
    ngOnChanges() {
        this._viewContainerRef.clear();
        const ref = this._viewContainerRef.createComponent(PreScreeningTradeReferenceComponent, {
            injector: Injector.create({
                parent: this._viewContainerRef.injector,
                providers: [...preScreeningTradeReferenceLoadProviders(getCountryCodeFromStorage())],
            }),
        });
        const instance = ref.instance;
        instance.entityId = this.entityId;
        instance.flow = this.flow;
        instance.member = this.member;
        instance.data = this.data || [];
        instance.isReadonly = this.isReadonly;
        ref.changeDetectorRef.detectChanges();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningTradeReferenceDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: PreScreeningTradeReferenceDirective, selector: "[fswPreScreeningTradeReference]", inputs: { entityId: "entityId", flow: "flow", member: "member", data: "data", isReadonly: "isReadonly" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningTradeReferenceDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswPreScreeningTradeReference]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; }, propDecorators: { entityId: [{
                type: Input
            }], flow: [{
                type: Input
            }], member: [{
                type: Input
            }], data: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

const FSW_PRE_SCREENING_CCRIS_FINDINGS_STORE_TOKEN = new InjectionToken('FSW_PRE_SCREENING_CCRIS_FINDINGS_STORE_TOKEN');

const FSW_PRE_SCREENING_CCRIS_FINDINGS_BUILDER_TOKEN = new InjectionToken('FSW_PRE_SCREENING_CCRIS_FINDINGS_BUILDER_TOKEN');

const FSW_PRE_SCREENING_CCRIS_FINDINGS_ENTITY_TOKEN = new InjectionToken('FSW_PRE_SCREENING_CCRIS_FINDINGS_ENTITY_TOKEN');

class PreScreeningCcrisFindingsComponent {
    set entityId(entityId) {
        this._componentStore.updateState({
            entityId,
        });
    }
    set flow(flow) {
        this._componentStore.updateState({
            flow,
        });
    }
    set member(member) {
        this._componentStore.updateState({
            member,
        });
    }
    set isReadonly(isReadonly) {
        this._componentStore.updateState({
            isReadonly,
        });
    }
    constructor(_componentStore, _cdr) {
        this._componentStore = _componentStore;
        this._cdr = _cdr;
        this.state$ = this._componentStore.state$;
        this.form = this._componentStore.form;
        this.FSWFlow = FSWFlow;
    }
    ngOnInit() {
        this._componentStore.init();
    }
    regenerateBorrowerSummary() {
        this._componentStore.regenerateBorrowerSummary();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningCcrisFindingsComponent, deps: [{ token: FSW_PRE_SCREENING_CCRIS_FINDINGS_STORE_TOKEN }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PreScreeningCcrisFindingsComponent, selector: "fsw-pre-screening-ccris-findings", inputs: { entityId: "entityId", flow: "flow", member: "member", isReadonly: "isReadonly" }, ngImport: i0, template: "<fsw-panel\n  [title]=\"'title' | fswTranslate\"\n  *ngIf=\"state$ | async as state\"\n  customClasses=\"w-[800px]\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <button *ngIf=\"!state?.isReadonly\" fswButton (click)=\"regenerateBorrowerSummary()\">\n      {{ 'buttons.regenerate' | fswTranslate }}\n    </button>\n  </ng-template>\n\n  <form [formGroup]=\"form\">\n    <fsw-dynamic-builder [builder]=\"state.builder\"></fsw-dynamic-builder>\n  </form>\n</fsw-panel>\n", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningCcrisFindingsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-pre-screening-ccris-findings', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-panel\n  [title]=\"'title' | fswTranslate\"\n  *ngIf=\"state$ | async as state\"\n  customClasses=\"w-[800px]\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <button *ngIf=\"!state?.isReadonly\" fswButton (click)=\"regenerateBorrowerSummary()\">\n      {{ 'buttons.regenerate' | fswTranslate }}\n    </button>\n  </ng-template>\n\n  <form [formGroup]=\"form\">\n    <fsw-dynamic-builder [builder]=\"state.builder\"></fsw-dynamic-builder>\n  </form>\n</fsw-panel>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PRE_SCREENING_CCRIS_FINDINGS_STORE_TOKEN]
                }] }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { entityId: [{
                type: Input
            }], flow: [{
                type: Input
            }], member: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class FSWPreScreeningCcrisFindingsStore extends ComponentStore {
    constructor(_entity, _alertService, _builder, _initialState) {
        super(_initialState);
        this._entity = _entity;
        this._alertService = _alertService;
        this._builder = _builder;
        this._initialState = _initialState;
        this.form = new UntypedFormGroup({});
        this.init = this.effect(pipe(tap$1(() => this.updateBuilder()), switchMap$1(() => this.select((state) => state.entityId).pipe(mergeMap$1((entityId) => this._entity.getData(entityId, this.state().isReadonly)), tap$1((data) => {
            this.form.patchValue(data || {});
        }), catchError$1((err) => {
            console.error(err);
            return EMPTY;
        })))));
        this.regenerateBorrowerSummary = this.effect(pipe(tap$1(() => this.updateBuilder()), switchMap$1(() => this.select((state) => state.entityId).pipe(switchMap$1((entityId) => this._entity.regenerate(entityId)), map$1((data) => {
            if (!data) {
                const errMsg = 'Failed to regenerate borrower summary';
                this._alertService.error(errMsg);
                throw new Error(errMsg);
            }
            return data;
        }), mergeMap$1(({ application_id }) => this._entity.getData(application_id)), tap$1((data) => {
            this.form.patchValue(data || {});
        }), catchError$1((err) => {
            console.error(err);
            return EMPTY;
        })))));
        this.updateState = (value) => this.patchState({
            ...value,
        });
    }
    updateBuilder() {
        this.updateState({
            builder: this._builder({
                form: this.form,
                isReadonly: true,
            }),
        });
    }
}

class FSWPreScreeningCcrisFindingsStoreMY extends FSWPreScreeningCcrisFindingsStore {
    constructor(entity, alertService, _builder) {
        super(entity, alertService, _builder, {
            id: null,
            entityId: null,
            flow: FSWFlow.INSTANT,
            builder: null,
            member: null,
            isReadonly: false,
        });
        this.entity = entity;
        this.alertService = alertService;
        this._builder = _builder;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCcrisFindingsStoreMY, deps: [{ token: FSW_PRE_SCREENING_CCRIS_FINDINGS_ENTITY_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }, { token: FSW_PRE_SCREENING_CCRIS_FINDINGS_BUILDER_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCcrisFindingsStoreMY }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCcrisFindingsStoreMY, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PRE_SCREENING_CCRIS_FINDINGS_ENTITY_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PRE_SCREENING_CCRIS_FINDINGS_BUILDER_TOKEN]
                }] }]; } });

var title$c = "CCRIS Findings";
var fields$8 = {
	num_of_borrowing: "No. of Borrowings",
	num_of_recent_credit_applications: "No. of Recent Credit Application",
	total_borrowing_limit: "Total Borrowings Limit",
	total_monthly_commitment: "Total Monthly Commitment(CCRIS)",
	total_borrowing_outstanding: "Total Borrowings Outstanding"
};
var buttons$n = {
	regenerate: "Regenerate Borrower Summary"
};
var my$9 = {
	title: title$c,
	fields: fields$8,
	buttons: buttons$n
};

var MY$7 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$n,
    default: my$9,
    fields: fields$8,
    title: title$c
});

const FSW_PRE_SCREENING_CCRIS_FINDINGS_TRANSLATION_LOADER = {
    [CountryCode.MY]: MY$7,
};

const FSWWPreScreeningCcrisFindingsBuilderMY = (config) => {
    const { form } = config;
    const translation = FSW_PRE_SCREENING_CCRIS_FINDINGS_TRANSLATION_LOADER[CountryCode.MY];
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'w-full flex flex-wrap gap-[16px]',
        readonlyWhen$: of(true),
        form,
        fields: [
            {
                key: 'num_of_borrowing',
                customClasses: 'w-[calc(50%-8px)]',
                type: FSWDynamicBuilderControlTypes.INPUT,
                context: {
                    // inputType: 'number',
                    mask: {
                        expression: 'separator.2',
                        config: {
                            thousandSeparator: ',',
                        },
                    },
                    fullWidth: true,
                    label: translation.fields.num_of_borrowing,
                },
            },
            {
                key: 'num_of_recent_credit_applications',
                customClasses: 'w-[calc(50%-8px)]',
                type: FSWDynamicBuilderControlTypes.INPUT,
                context: {
                    // inputType: 'number',
                    mask: {
                        expression: 'separator.2',
                        config: {
                            thousandSeparator: ',',
                        },
                    },
                    fullWidth: true,
                    label: translation.fields.num_of_recent_credit_applications,
                },
            },
            {
                key: 'total_borrowing_limit',
                customClasses: 'w-[calc(50%-8px)]',
                type: FSWDynamicBuilderControlTypes.INPUT,
                context: {
                    // inputType: 'number',
                    mask: {
                        expression: 'separator.2',
                        config: {
                            thousandSeparator: ',',
                        },
                    },
                    fullWidth: true,
                    label: translation.fields.total_borrowing_limit,
                },
            },
            {
                key: 'total_borrowing_outstanding',
                customClasses: 'w-[calc(50%-8px)]',
                type: FSWDynamicBuilderControlTypes.INPUT,
                context: {
                    // inputType: 'number',
                    mask: {
                        expression: 'separator.2',
                        config: {
                            thousandSeparator: ',',
                        },
                    },
                    fullWidth: true,
                    label: translation.fields.total_borrowing_outstanding,
                },
            },
            {
                key: 'total_monthly_commitment',
                customClasses: 'w-[calc(50%-8px)]',
                type: FSWDynamicBuilderControlTypes.INPUT,
                context: {
                    // inputType: 'number',
                    mask: {
                        expression: 'separator.2',
                        config: {
                            thousandSeparator: ',',
                        },
                    },
                    fullWidth: true,
                    label: translation.fields.total_monthly_commitment,
                },
            },
        ],
    });
};

const FSW_PRE_SCREENING_CCRIS_FINDINGS_MY_PROVIDERS = [
    {
        provide: FSW_PRE_SCREENING_CCRIS_FINDINGS_BUILDER_TOKEN,
        useValue: FSWWPreScreeningCcrisFindingsBuilderMY,
    },
    {
        provide: FSW_PRE_SCREENING_CCRIS_FINDINGS_STORE_TOKEN,
        useClass: FSWPreScreeningCcrisFindingsStoreMY,
        deps: [
            FSW_PRE_SCREENING_CCRIS_FINDINGS_ENTITY_TOKEN,
            FSW_ALERT_SERVICE_TOKEN,
            FSW_PRE_SCREENING_CCRIS_FINDINGS_BUILDER_TOKEN,
        ],
    },
];

class FSWPreScreeningCcrisFindingsBrwEntity {
    constructor(_applicationRelationshipService, _applicationBorrowerSummaryService, _creditBorrowerSummaryService, _applicationMemberService) {
        this._applicationRelationshipService = _applicationRelationshipService;
        this._applicationBorrowerSummaryService = _applicationBorrowerSummaryService;
        this._creditBorrowerSummaryService = _creditBorrowerSummaryService;
        this._applicationMemberService = _applicationMemberService;
    }
    getData(entityId, isReadonly = false) {
        return this._applicationRelationshipService.getAsync(entityId, 'borrower_summary').pipe(map((ids) => ids?.shift()), switchMap$1((borrower_summary_id) => {
            if (borrower_summary_id) {
                return this._creditBorrowerSummaryService
                    .getById(borrower_summary_id)
                    .pipe(map((data) => transformCompanyGuarantor(data).company));
            }
            if (isReadonly) {
                return of(null);
            }
            return this._applicationMemberService
                .getApplicationMembersInformation(entityId, { type: ApplicationMemberType.MAIN }, {
                country_code: getCountryCodeFromStorage(),
                member_type_code: MemberCode.BORROWER,
            })
                .pipe(map((members) => members?.shift()), switchMap$1((member) => {
                if (!isObjectValid(member?.company_ctos_entity)) {
                    return of(null);
                }
                return this._creditBorrowerSummaryService.extractCtos(+member.id).pipe(switchMap$1((company) => this._creditBorrowerSummaryService.create(company).pipe(switchMap$1((summary) => this._applicationRelationshipService
                    .addAsync(entityId, 'borrower_summary', summary.id)
                    .pipe(switchMap$1(() => this._creditBorrowerSummaryService.getById(summary.id)), map((data) => transformCompanyGuarantor(data).company))))));
            }));
        }));
    }
    regenerate(entityId) {
        return this._applicationBorrowerSummaryService.regenerate(entityId).pipe(map((data) => {
            if (!data)
                return null;
            return {
                application_id: data.application_id,
                borrower_summary_id: data.borrower_summary_id,
            };
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCcrisFindingsBrwEntity, deps: [{ token: APPLICATION_RELATIONSHIP_SERVICE_TOKEN }, { token: APPLICATION_BORROWER_SUMMARY_SERVICE_TOKEN }, { token: CREDIT_BORROWER_SUMMARY_SERVICE_TOKEN }, { token: APPLICATION_MEMBER_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCcrisFindingsBrwEntity }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCcrisFindingsBrwEntity, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_RELATIONSHIP_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_BORROWER_SUMMARY_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CREDIT_BORROWER_SUMMARY_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_SERVICE_TOKEN]
                }] }]; } });

class FSWPreScreeningCcrisFindingsPgEntity {
    constructor(_creditGuarantorService) {
        this._creditGuarantorService = _creditGuarantorService;
    }
    getData(entityId) {
        return this._creditGuarantorService
            .getPersonalSummaries([entityId])
            .pipe(map((list) => (list.shift() ?? null)));
    }
    regenerate() {
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCcrisFindingsPgEntity, deps: [{ token: CREDIT_GUARANTOR_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCcrisFindingsPgEntity }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCcrisFindingsPgEntity, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CREDIT_GUARANTOR_SERVICE_TOKEN]
                }] }]; } });

class FSWPreScreeningCcrisFindingsCgEntity {
    constructor(_creditGuarantorService) {
        this._creditGuarantorService = _creditGuarantorService;
    }
    getData(entityId) {
        return this._creditGuarantorService
            .getCorporateSummaries([entityId])
            .pipe(map((list) => (list.shift()?.company ?? null)));
    }
    regenerate() {
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCcrisFindingsCgEntity, deps: [{ token: CREDIT_GUARANTOR_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCcrisFindingsCgEntity }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCcrisFindingsCgEntity, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CREDIT_GUARANTOR_SERVICE_TOKEN]
                }] }]; } });

class FSWPreScreeningCcrisFindingsOtherEntity {
    getData() {
        return of(null);
    }
    regenerate() {
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCcrisFindingsOtherEntity, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCcrisFindingsOtherEntity }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCcrisFindingsOtherEntity, decorators: [{
            type: Injectable
        }] });

const FSW_PRE_SCREENING_CCRIS_FINDINGS_PROVIDERS = {
    default: FSW_PRE_SCREENING_CCRIS_FINDINGS_MY_PROVIDERS,
    [CountryCode.MY]: FSW_PRE_SCREENING_CCRIS_FINDINGS_MY_PROVIDERS,
};
const preScreeningCcrisFindingsLoadProviders = (countryCode) => [
    fswTranslateScope('pre_screening_ccris_findings'),
    ...getCustomProviders(FSW_PRE_SCREENING_CCRIS_FINDINGS_PROVIDERS, FSW_PRE_SCREENING_CCRIS_FINDINGS_MY_PROVIDERS, countryCode),
];
const preScreeningCcrisFindingsEntityLoadProviders = (entityType) => {
    const classMapping = {
        [FSWRecourseTypes.CG]: FSWPreScreeningCcrisFindingsCgEntity,
        [FSWRecourseTypes.PG]: FSWPreScreeningCcrisFindingsPgEntity,
        [FSWRecourseTypes.BRW]: FSWPreScreeningCcrisFindingsBrwEntity,
        [FSWRecourseTypes.OTHER]: FSWPreScreeningCcrisFindingsOtherEntity,
    };
    const depsMapping = {
        [FSWRecourseTypes.CG]: [CREDIT_GUARANTOR_SERVICE_TOKEN],
        [FSWRecourseTypes.PG]: [CREDIT_GUARANTOR_SERVICE_TOKEN],
        [FSWRecourseTypes.BRW]: [
            APPLICATION_RELATIONSHIP_SERVICE_TOKEN,
            APPLICATION_BORROWER_SUMMARY_SERVICE_TOKEN,
            CREDIT_BORROWER_SUMMARY_SERVICE_TOKEN,
            APPLICATION_MEMBER_SERVICE_TOKEN,
        ],
        [FSWRecourseTypes.OTHER]: [],
    };
    return [
        {
            provide: FSW_PRE_SCREENING_CCRIS_FINDINGS_ENTITY_TOKEN,
            useClass: classMapping[entityType],
            deps: depsMapping[entityType],
        },
    ];
};

class PreScreeningCcrisFindingsDirective {
    constructor(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
        this.entityId = null;
        this.entityType = FSWRecourseTypes.OTHER;
        this.flow = FSWFlow.INSTANT;
        this.member = null;
        this.isReadonly = false;
    }
    ngOnChanges() {
        this._viewContainerRef.clear();
        const ref = this._viewContainerRef.createComponent(PreScreeningCcrisFindingsComponent, {
            injector: Injector.create({
                parent: this._viewContainerRef.injector,
                providers: [
                    ...preScreeningCcrisFindingsLoadProviders(getCountryCodeFromStorage()),
                    ...preScreeningCcrisFindingsEntityLoadProviders(this.entityType),
                ],
            }),
        });
        const instance = ref.instance;
        instance.entityId = this.entityId;
        instance.flow = this.flow;
        instance.member = this.member;
        instance.isReadonly = this.isReadonly;
        ref.changeDetectorRef.detectChanges();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningCcrisFindingsDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: PreScreeningCcrisFindingsDirective, selector: "[fswPreScreeningCcrisFindings]", inputs: { entityId: "entityId", entityType: "entityType", flow: "flow", member: "member", isReadonly: "isReadonly" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningCcrisFindingsDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswPreScreeningCcrisFindings]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; }, propDecorators: { entityId: [{
                type: Input
            }], entityType: [{
                type: Input
            }], flow: [{
                type: Input
            }], member: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

const FSW_PRE_SCREENING_BORROWER_AND_BIPS_STORE_TOKEN = new InjectionToken('FSW_PRE_SCREENING_BORROWER_AND_BIPS_STORE_TOKEN');

class PreScreeningBorrowerAndBipsComponent {
    set entityId(entityId) {
        this._componentStore.updateState({
            entityId,
        });
    }
    set flow(flow) {
        this._componentStore.updateState({
            flow,
        });
    }
    set member(member) {
        this._componentStore.updateState({
            member,
        });
    }
    set bips(bips) {
        this._componentStore.updateState({
            bips,
        });
    }
    set isReadonly(isReadonly) {
        this._componentStore.updateState({
            isReadonly,
        });
    }
    constructor(_componentStore) {
        this._componentStore = _componentStore;
        this.tabChange = new EventEmitter();
        this.state$ = this._componentStore.state$;
        this.tabs$ = this.state$.pipe(map(({ data, entityId, bips }) => !entityId
            ? []
            : [
                {
                    key: 'borrower',
                    label: 'borrower',
                    source: {
                        guarantor_summary_type: FSWRecourseTypes.BRW,
                        guarantor_summary_id: entityId,
                    },
                },
                ...data.map((source) => {
                    const summary = bips?.find((bip) => bip.id === source.business_interest_party_id);
                    return {
                        key: source.guarantor_summary_id,
                        label: summary?.name ?? 'bip',
                        source,
                    };
                }),
            ]));
        this.FSWFlow = FSWFlow;
        this.FSWTabsSizes = FSWTabsSizes;
    }
    ngOnInit() {
        this._componentStore.init();
    }
    selectTab(tab) {
        this.tabChange.emit(tab);
    }
    isTranslateLabel(label) {
        return label === 'borrower' || label === 'bip';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningBorrowerAndBipsComponent, deps: [{ token: FSW_PRE_SCREENING_BORROWER_AND_BIPS_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PreScreeningBorrowerAndBipsComponent, selector: "fsw-pre-screening-borrower-and-bips", inputs: { entityId: "entityId", flow: "flow", member: "member", bips: "bips", isReadonly: "isReadonly" }, outputs: { tabChange: "tabChange" }, ngImport: i0, template: "<ng-container *ngIf=\"state$ | async as state\">\n  <ng-container *ngIf=\"tabs$ | async as tabs\">\n    <fsw-tabs-group [customRowGap]=\"'24px'\" [customColumnGap]=\"'24px'\">\n      <ng-container *ngFor=\"let tab of tabs; let i = index\">\n        <ng-template\n          fswTabs\n          [key]=\"tab.key\"\n          [size]=\"FSWTabsSizes.S\"\n          [maxTextWidth]=\"'unset'\"\n          [label]=\"\n            isTranslateLabel(tab.label)\n              ? (tab.label | fswTranslate : { data: { index: i.toString() } })\n              : tab.label\n          \"\n          (selectTab)=\"selectTab(tab.source)\"\n        >\n          <ng-container *ngIf=\"tab.key === 'borrower'; else bipTemplate\">\n            <!--            <ng-container-->\n            <!--              fswPreScreeningBorrowerDetails-->\n            <!--              [entityId]=\"state.entityId\"-->\n            <!--              [flow]=\"state.flow\"-->\n            <!--              [memberId]=\"state.memberId\"-->\n            <!--              [memberUUID]=\"state.memberUUID\"-->\n            <!--              [memberData]=\"state.memberData\"-->\n            <!--            ></ng-container>-->\n          </ng-container>\n          <ng-template #bipTemplate>\n            <!--            <ng-container-->\n            <!--              fswPreScreeningBips-->\n            <!--              [entityId]=\"tab.key\"-->\n            <!--              [flow]=\"state.flow\"-->\n            <!--              [memberId]=\"state.memberId\"-->\n            <!--              [memberUUID]=\"state.memberUUID\"-->\n            <!--              [memberData]=\"state.memberData\"-->\n            <!--              [entityType]=\"tab.source.guarantor_summary_type\"-->\n            <!--            ></ng-container>-->\n          </ng-template>\n        </ng-template>\n      </ng-container>\n    </fsw-tabs-group>\n  </ng-container>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$4.FSWTabsGroupComponent, selector: "fsw-tabs-group" }, { kind: "directive", type: i1$4.FSWTabsDirective, selector: "ng-template[fswTabs]" }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningBorrowerAndBipsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-pre-screening-borrower-and-bips', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"state$ | async as state\">\n  <ng-container *ngIf=\"tabs$ | async as tabs\">\n    <fsw-tabs-group [customRowGap]=\"'24px'\" [customColumnGap]=\"'24px'\">\n      <ng-container *ngFor=\"let tab of tabs; let i = index\">\n        <ng-template\n          fswTabs\n          [key]=\"tab.key\"\n          [size]=\"FSWTabsSizes.S\"\n          [maxTextWidth]=\"'unset'\"\n          [label]=\"\n            isTranslateLabel(tab.label)\n              ? (tab.label | fswTranslate : { data: { index: i.toString() } })\n              : tab.label\n          \"\n          (selectTab)=\"selectTab(tab.source)\"\n        >\n          <ng-container *ngIf=\"tab.key === 'borrower'; else bipTemplate\">\n            <!--            <ng-container-->\n            <!--              fswPreScreeningBorrowerDetails-->\n            <!--              [entityId]=\"state.entityId\"-->\n            <!--              [flow]=\"state.flow\"-->\n            <!--              [memberId]=\"state.memberId\"-->\n            <!--              [memberUUID]=\"state.memberUUID\"-->\n            <!--              [memberData]=\"state.memberData\"-->\n            <!--            ></ng-container>-->\n          </ng-container>\n          <ng-template #bipTemplate>\n            <!--            <ng-container-->\n            <!--              fswPreScreeningBips-->\n            <!--              [entityId]=\"tab.key\"-->\n            <!--              [flow]=\"state.flow\"-->\n            <!--              [memberId]=\"state.memberId\"-->\n            <!--              [memberUUID]=\"state.memberUUID\"-->\n            <!--              [memberData]=\"state.memberData\"-->\n            <!--              [entityType]=\"tab.source.guarantor_summary_type\"-->\n            <!--            ></ng-container>-->\n          </ng-template>\n        </ng-template>\n      </ng-container>\n    </fsw-tabs-group>\n  </ng-container>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PRE_SCREENING_BORROWER_AND_BIPS_STORE_TOKEN]
                }] }]; }, propDecorators: { tabChange: [{
                type: Output
            }], entityId: [{
                type: Input
            }], flow: [{
                type: Input
            }], member: [{
                type: Input
            }], bips: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class FSWPreScreeningBorrowerAndBipsStore extends ComponentStore {
    constructor(_memberService, _applicationGuarantorService, _creditGuarantorService, _alertService, _initialState) {
        super(_initialState);
        this._memberService = _memberService;
        this._applicationGuarantorService = _applicationGuarantorService;
        this._creditGuarantorService = _creditGuarantorService;
        this._alertService = _alertService;
        this._initialState = _initialState;
        this.init = this.effect(pipe(switchMap(() => forkJoin([
            this._applicationGuarantorService.getSummaries(this.get().entityId),
            this._memberService.getMergeBipNames(this.get().entityId, this.get().member?.uuid, {
                expand: true,
            }, getEntityNoFallBackToUEN(this.get().member?.company_ctos_entity, this.get().member?.company_registration_number)),
        ]).pipe(tap(([data, bips]) => {
            this.updateState({
                data,
                bips,
            });
        }), catchError((err) => {
            console.error(err);
            return EMPTY;
        })))));
        this.updateState = (value) => this.patchState({
            ...value,
        });
    }
    getOrCreateSummaries() {
        return this._applicationGuarantorService.getSummaries(this.get().entityId).pipe(switchMap((summaries) => {
            const existPG = summaries.some((s) => s.guarantor_summary_type === FSWRecourseTypes.PG);
            const existCG = summaries.some((s) => s.guarantor_summary_type === FSWRecourseTypes.CG);
            if (existPG && existCG) {
                return of(summaries);
            }
            return this._creditGuarantorService.ctosExtract(Number(this.get().member?.id)).pipe(switchMap((data) => {
                const PGs = data.filter((item) => item.type === FSWRecourseTypes.PG && item.summary?.IndividualSummary);
                const CGs = data.filter((item) => item.type === FSWRecourseTypes.CG && item.summary?.Company);
                if (!PGs && !CGs) {
                    return of(summaries);
                }
                const obsList = [
                    ...(!existPG && PGs ? this.createPGs(PGs) : []),
                    ...(!existCG && CGs ? this.createCGs(CGs) : []),
                ];
                if (!obsList.length) {
                    return of(summaries);
                }
                return zip(...obsList).pipe(switchMap((data) => this._applicationGuarantorService.addSummaries(this.get().entityId, data)), switchMap(() => this._applicationGuarantorService.getSummaries(this.get().entityId)), catchError((err) => {
                    console.error(err);
                    return of(summaries);
                }));
            }), catchError(() => of(summaries)));
        }));
    }
    createPGs(PGs) {
        const summaries = PGs.filter((pg) => !!pg.summary).map((pg) => {
            const summary = pg.summary.IndividualSummary;
            summary.id_number = pg.id;
            return summary;
        });
        return summaries.map((item) => this._creditGuarantorService.addPersonalSummaries([item]).pipe(map((data) => ({
            guarantor_summary_id: data[0].id,
            guarantor_summary_type: FSWRecourseTypes.PG,
            business_interest_party_id: item.id_number,
        }))));
    }
    createCGs(cgs) {
        const summaries = cgs.filter((cg) => !!cg.summary?.Company).map((cg) => cg.summary.Company);
        return summaries.map((item) => this._creditGuarantorService.addCorporateSummaries([item]).pipe(map((data) => ({
            guarantor_summary_id: data[0].id,
            guarantor_summary_type: FSWRecourseTypes.CG,
            business_interest_party_id: item.registration_no,
        }))));
    }
}

class FSWPreScreeningBorrowerAndBipsStoreMY extends FSWPreScreeningBorrowerAndBipsStore {
    constructor(memberService, applicationGuarantorService, creditGuarantorService, alertService) {
        super(memberService, applicationGuarantorService, creditGuarantorService, alertService, {
            entityId: null,
            flow: FSWFlow.INSTANT,
            data: [],
            member: null,
            bips: null,
            isReadonly: false,
        });
        this.memberService = memberService;
        this.applicationGuarantorService = applicationGuarantorService;
        this.creditGuarantorService = creditGuarantorService;
        this.alertService = alertService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBorrowerAndBipsStoreMY, deps: [{ token: MEMBER_SERVICE_TOKEN }, { token: APPLICATION_GUARANTOR_SERVICE_TOKEN }, { token: CREDIT_GUARANTOR_SERVICE_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBorrowerAndBipsStoreMY }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBorrowerAndBipsStoreMY, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_GUARANTOR_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CREDIT_GUARANTOR_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }]; } });

const FSW_PRE_SCREENING_BORROWER_AND_BIPS_MY_PROVIDERS = [
    {
        provide: FSW_PRE_SCREENING_BORROWER_AND_BIPS_STORE_TOKEN,
        useClass: FSWPreScreeningBorrowerAndBipsStoreMY,
        deps: [
            MEMBER_SERVICE_TOKEN,
            APPLICATION_GUARANTOR_SERVICE_TOKEN,
            CREDIT_GUARANTOR_SERVICE_TOKEN,
            FSW_ALERT_SERVICE_TOKEN,
        ],
    },
];

const FSW_PRE_SCREENING_BORROWER_AND_BIPS_PROVIDERS = {
    default: FSW_PRE_SCREENING_BORROWER_AND_BIPS_MY_PROVIDERS,
    [CountryCode.MY]: FSW_PRE_SCREENING_BORROWER_AND_BIPS_MY_PROVIDERS,
};
const preScreeningBorrowerAndBipsLoadProviders = (countryCode) => [
    fswTranslateScope('pre_screening_borrower_and_bips'),
    ...getCustomProviders(FSW_PRE_SCREENING_BORROWER_AND_BIPS_PROVIDERS, FSW_PRE_SCREENING_BORROWER_AND_BIPS_MY_PROVIDERS, countryCode),
];

class PreScreeningBorrowerAndBipsDirective {
    constructor(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
        this.tabChange = new EventEmitter();
        this.entityId = null;
        this.flow = FSWFlow.INSTANT;
        this.member = null;
        this.bips = null;
        this.isReadonly = false;
    }
    ngOnChanges() {
        this._viewContainerRef.clear();
        const ref = this._viewContainerRef.createComponent(PreScreeningBorrowerAndBipsComponent, {
            injector: Injector.create({
                parent: this._viewContainerRef.injector,
                providers: [...preScreeningBorrowerAndBipsLoadProviders(getCountryCodeFromStorage())],
            }),
        });
        const instance = ref.instance;
        instance.entityId = this.entityId;
        instance.flow = this.flow;
        instance.member = this.member;
        instance.bips = this.bips;
        instance.isReadonly = this.isReadonly;
        instance.tabChange.subscribe((tab) => this.tabChange.emit(tab));
        ref.changeDetectorRef.detectChanges();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningBorrowerAndBipsDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: PreScreeningBorrowerAndBipsDirective, selector: "[fswPreScreeningBorrowerAndBips]", inputs: { entityId: "entityId", flow: "flow", member: "member", bips: "bips", isReadonly: "isReadonly" }, outputs: { tabChange: "tabChange" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningBorrowerAndBipsDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswPreScreeningBorrowerAndBips]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; }, propDecorators: { tabChange: [{
                type: Output
            }], entityId: [{
                type: Input
            }], flow: [{
                type: Input
            }], member: [{
                type: Input
            }], bips: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class PreScreeningCtosComponent {
    constructor(_applicationMemberService, _applicationService, _cdr) {
        this._applicationMemberService = _applicationMemberService;
        this._applicationService = _applicationService;
        this._cdr = _cdr;
        this.validating = new EventEmitter();
        this.entityId = null;
        this.entityNumber = null;
        this.flow = FSWFlow.INSTANT;
        this.tradeReferenceNames = [];
        this.isReadonly = false;
        this.isCompanyDetailsReadonly = true; // default is set to true
        this.isTopUp = false;
        this.parentLoanId = null;
        this.parentFacilityCode = null;
        this.stage = FSWCreditPreScreeningStages.CTOS;
        this.showCcrisFindings = true;
        this.FSWFlow = FSWFlow;
        this.ccrisData$ = new BehaviorSubject(null);
        this.tradeReferenceData$ = new BehaviorSubject([]);
        this.init$ = new BehaviorSubject(false);
        this.member$ = new BehaviorSubject(null);
    }
    ngOnInit() {
        if (!this.entityId) {
            return;
        }
        forkJoin([this.getMember(this.entityId), this.getTradeRefs(this.entityId)])
            .pipe(finalize(() => this.init$.next(true)))
            .subscribe();
    }
    getMember(applicationId) {
        return this._applicationMemberService
            .getApplicationMembersInformation(applicationId, { type: ApplicationMemberType.MAIN }, {
            country_code: getCountryCodeFromStorage(),
            member_type_code: MemberCode.BORROWER,
        })
            .pipe(tap((members) => this.member$.next(members[0])));
    }
    getTradeRefs(applicationId) {
        return this._applicationService.getApplicationTradeRefs(applicationId).pipe(tap((data) => {
            this.tradeReferenceNames =
                data
                    .filter((item) => !isNaN(Number(item.totalOutstanding)) && Number(item.totalOutstanding) > 0)
                    .map((item) => item.name) || this.tradeReferenceNames;
            this._cdr.markForCheck();
        }), catchError(() => of([])));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningCtosComponent, deps: [{ token: APPLICATION_MEMBER_SERVICE_TOKEN }, { token: APPLICATION_SERVICE_TOKEN }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PreScreeningCtosComponent, selector: "fsw-pre-screening-ctos", inputs: { entityId: "entityId", entityNumber: "entityNumber", flow: "flow", tradeReferenceNames: "tradeReferenceNames", isReadonly: "isReadonly", isCompanyDetailsReadonly: "isCompanyDetailsReadonly", isTopUp: "isTopUp", parentLoanId: "parentLoanId", parentFacilityCode: "parentFacilityCode", stage: "stage", showCcrisFindings: "showCcrisFindings" }, outputs: { validating: "validating" }, ngImport: i0, template: "<fsw-tabs-group [customRowGap]=\"'24px'\" [customColumnGap]=\"'24px'\">\n  <ng-container *ngIf=\"flow !== FSWFlow.MANUAL\">\n    <ng-template fswTabs [key]=\"FSWFlow.INSTANT\" [maxTextWidth]=\"'unset'\" [label]=\"'Instant Flow'\">\n      <ng-container\n        *ngTemplateOutlet=\"flowTemplate; context: { $implicit: FSWFlow.INSTANT }\"\n      ></ng-container>\n    </ng-template>\n  </ng-container>\n  <ng-container *ngIf=\"flow !== FSWFlow.INSTANT\">\n    <ng-template fswTabs [key]=\"FSWFlow.MANUAL\" [maxTextWidth]=\"'unset'\" [label]=\"'Manual Flow'\">\n      <ng-container\n        *ngTemplateOutlet=\"flowTemplate; context: { $implicit: FSWFlow.MANUAL }\"\n      ></ng-container>\n    </ng-template>\n  </ng-container>\n</fsw-tabs-group>\n<ng-template #flowTemplate let-flowType>\n  <section class=\"flex flex-col gap-[16px]\" *ngIf=\"init$ | async\">\n    <ng-container\n      fswPreScreeningBorrowerAndBips\n      [entityId]=\"entityId\"\n      [member]=\"member$ | async\"\n      [isReadonly]=\"flowType === FSWFlow.INSTANT ? true : isReadonly\"\n      [flow]=\"flowType\"\n      (tabChange)=\"ccrisData$.next($event)\"\n    ></ng-container>\n    <ng-container\n      fswPreScreeningCompanyDetails\n      [flow]=\"flowType\"\n      [entityId]=\"entityId\"\n      [member]=\"member$ | async\"\n      [isReadonly]=\"flowType === FSWFlow.INSTANT ? true : isReadonly\"\n      [isCompanyDetailsReadonly]=\"isCompanyDetailsReadonly\"\n    ></ng-container>\n    <ng-container *ngIf=\"flowType === FSWFlow.MANUAL && tradeReferenceNames?.length\">\n      <ng-container\n        fswPreScreeningTradeReference\n        [flow]=\"flowType\"\n        [entityId]=\"entityId\"\n        [member]=\"member$ | async\"\n        [data]=\"tradeReferenceData$ | async\"\n        [isReadonly]=\"flowType === FSWFlow.INSTANT ? true : isReadonly\"\n      ></ng-container>\n    </ng-container>\n    <ng-container *ngIf=\"ccrisData$ | async as ccrisData\">\n      <ng-container\n        *ngIf=\"showCcrisFindings\"\n        fswPreScreeningCcrisFindings\n        [flow]=\"flowType\"\n        [entityId]=\"ccrisData.guarantor_summary_id\"\n        [entityType]=\"ccrisData.guarantor_summary_type\"\n        [member]=\"member$ | async\"\n        [isReadonly]=\"flowType === FSWFlow.INSTANT ? true : isReadonly\"\n      ></ng-container>\n    </ng-container>\n    <ng-container\n      fswPreScreeningCriteria\n      [entityId]=\"entityId\"\n      [entityNumber]=\"entityNumber\"\n      [stage]=\"stage\"\n      [flow]=\"flowType\"\n      [member]=\"member$ | async\"\n      [tradeReferenceNames]=\"tradeReferenceNames\"\n      [isReadonly]=\"flowType === FSWFlow.INSTANT ? true : isReadonly\"\n      [isTopUp]=\"isTopUp\"\n      [parentLoanId]=\"parentLoanId\"\n      [parentFacilityCode]=\"parentFacilityCode\"\n      (tradeReferenceChange)=\"tradeReferenceData$.next($event)\"\n      (validating)=\"validating.emit($event)\"\n    ></ng-container>\n  </section>\n</ng-template>\n", dependencies: [{ kind: "component", type: i1$4.FSWTabsGroupComponent, selector: "fsw-tabs-group" }, { kind: "directive", type: i1$4.FSWTabsDirective, selector: "ng-template[fswTabs]" }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: PreScreeningCompanyDetailsDirective, selector: "[fswPreScreeningCompanyDetails]", inputs: ["entityId", "flow", "member", "isReadonly", "isCompanyDetailsReadonly"] }, { kind: "directive", type: PreScreeningTradeReferenceDirective, selector: "[fswPreScreeningTradeReference]", inputs: ["entityId", "flow", "member", "data", "isReadonly"] }, { kind: "directive", type: PreScreeningCcrisFindingsDirective, selector: "[fswPreScreeningCcrisFindings]", inputs: ["entityId", "entityType", "flow", "member", "isReadonly"] }, { kind: "directive", type: FSWPreScreeningCriteriaDirective, selector: "[fswPreScreeningCriteria]", inputs: ["id", "title", "entityId", "entityNumber", "partnerId", "allowedProductUPI", "prescreeningIdsData", "flow", "stage", "member", "tradeReferenceNames", "isReadonly", "isTopUp", "parentLoanId", "parentFacilityCode", "customPayloadDataCallback", "customFilterCallback"], outputs: ["validating", "tradeReferenceChange"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: PreScreeningBorrowerAndBipsDirective, selector: "[fswPreScreeningBorrowerAndBips]", inputs: ["entityId", "flow", "member", "bips", "isReadonly"], outputs: ["tabChange"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningCtosComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-pre-screening-ctos', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-tabs-group [customRowGap]=\"'24px'\" [customColumnGap]=\"'24px'\">\n  <ng-container *ngIf=\"flow !== FSWFlow.MANUAL\">\n    <ng-template fswTabs [key]=\"FSWFlow.INSTANT\" [maxTextWidth]=\"'unset'\" [label]=\"'Instant Flow'\">\n      <ng-container\n        *ngTemplateOutlet=\"flowTemplate; context: { $implicit: FSWFlow.INSTANT }\"\n      ></ng-container>\n    </ng-template>\n  </ng-container>\n  <ng-container *ngIf=\"flow !== FSWFlow.INSTANT\">\n    <ng-template fswTabs [key]=\"FSWFlow.MANUAL\" [maxTextWidth]=\"'unset'\" [label]=\"'Manual Flow'\">\n      <ng-container\n        *ngTemplateOutlet=\"flowTemplate; context: { $implicit: FSWFlow.MANUAL }\"\n      ></ng-container>\n    </ng-template>\n  </ng-container>\n</fsw-tabs-group>\n<ng-template #flowTemplate let-flowType>\n  <section class=\"flex flex-col gap-[16px]\" *ngIf=\"init$ | async\">\n    <ng-container\n      fswPreScreeningBorrowerAndBips\n      [entityId]=\"entityId\"\n      [member]=\"member$ | async\"\n      [isReadonly]=\"flowType === FSWFlow.INSTANT ? true : isReadonly\"\n      [flow]=\"flowType\"\n      (tabChange)=\"ccrisData$.next($event)\"\n    ></ng-container>\n    <ng-container\n      fswPreScreeningCompanyDetails\n      [flow]=\"flowType\"\n      [entityId]=\"entityId\"\n      [member]=\"member$ | async\"\n      [isReadonly]=\"flowType === FSWFlow.INSTANT ? true : isReadonly\"\n      [isCompanyDetailsReadonly]=\"isCompanyDetailsReadonly\"\n    ></ng-container>\n    <ng-container *ngIf=\"flowType === FSWFlow.MANUAL && tradeReferenceNames?.length\">\n      <ng-container\n        fswPreScreeningTradeReference\n        [flow]=\"flowType\"\n        [entityId]=\"entityId\"\n        [member]=\"member$ | async\"\n        [data]=\"tradeReferenceData$ | async\"\n        [isReadonly]=\"flowType === FSWFlow.INSTANT ? true : isReadonly\"\n      ></ng-container>\n    </ng-container>\n    <ng-container *ngIf=\"ccrisData$ | async as ccrisData\">\n      <ng-container\n        *ngIf=\"showCcrisFindings\"\n        fswPreScreeningCcrisFindings\n        [flow]=\"flowType\"\n        [entityId]=\"ccrisData.guarantor_summary_id\"\n        [entityType]=\"ccrisData.guarantor_summary_type\"\n        [member]=\"member$ | async\"\n        [isReadonly]=\"flowType === FSWFlow.INSTANT ? true : isReadonly\"\n      ></ng-container>\n    </ng-container>\n    <ng-container\n      fswPreScreeningCriteria\n      [entityId]=\"entityId\"\n      [entityNumber]=\"entityNumber\"\n      [stage]=\"stage\"\n      [flow]=\"flowType\"\n      [member]=\"member$ | async\"\n      [tradeReferenceNames]=\"tradeReferenceNames\"\n      [isReadonly]=\"flowType === FSWFlow.INSTANT ? true : isReadonly\"\n      [isTopUp]=\"isTopUp\"\n      [parentLoanId]=\"parentLoanId\"\n      [parentFacilityCode]=\"parentFacilityCode\"\n      (tradeReferenceChange)=\"tradeReferenceData$.next($event)\"\n      (validating)=\"validating.emit($event)\"\n    ></ng-container>\n  </section>\n</ng-template>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_SERVICE_TOKEN]
                }] }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { validating: [{
                type: Output
            }], entityId: [{
                type: Input
            }], entityNumber: [{
                type: Input
            }], flow: [{
                type: Input
            }], tradeReferenceNames: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], isCompanyDetailsReadonly: [{
                type: Input
            }], isTopUp: [{
                type: Input
            }], parentLoanId: [{
                type: Input
            }], parentFacilityCode: [{
                type: Input
            }], stage: [{
                type: Input
            }], showCcrisFindings: [{
                type: Input
            }] } });

const FSW_PRE_SCREENING_BORROWER_DETAILS_STORE_TOKEN = new InjectionToken('FSW_PRE_SCREENING_BORROWER_DETAILS_STORE_TOKEN');

const FSW_PRE_SCREENING_BORROWER_DETAILS_BUILDER_TOKEN = new InjectionToken('FSW_PRE_SCREENING_BORROWER_DETAILS_BUILDER_TOKEN');

var title$b = "Borrower Details";
var fields$7 = {
	name: "Name",
	nationality: "Nationality",
	date: "Birth Date",
	number: "IC Number"
};
var my$8 = {
	title: title$b,
	fields: fields$7
};

var MY$6 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: my$8,
    fields: fields$7,
    title: title$b
});

const FSW_PRE_SCREENING_BORROWER_DETAILS_TRANSLATION_LOADER = {
    [CountryCode.MY]: MY$6,
};

class FSWPreScreeningBorrowerDetailsStore extends ComponentStore {
    constructor(_alertService, _builder, _initialState) {
        super(_initialState);
        this._alertService = _alertService;
        this._builder = _builder;
        this._initialState = _initialState;
        this.form = new UntypedFormGroup({});
        this.init = this.effect(pipe(tap(() => {
            const { member } = this.get();
            this.updateBuilder();
            this.form.patchValue(member
                ? {
                    ...member,
                }
                : {});
        })));
        this.updateState = (value) => this.patchState({
            ...value,
        });
    }
    updateBuilder() {
        this.patchState((state) => ({
            ...state,
            builder: this._builder({
                form: this.form,
                isReadonly: true,
            }),
        }));
    }
}

class FSWPreScreeningBorrowerDetailsStoreMY extends FSWPreScreeningBorrowerDetailsStore {
    constructor(alertService, _builder) {
        super(alertService, _builder, {
            id: null,
            entityId: null,
            flow: FSWFlow.INSTANT,
            builder: null,
            member: null,
            isReadonly: false,
        });
        this.alertService = alertService;
        this._builder = _builder;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBorrowerDetailsStoreMY, deps: [{ token: FSW_ALERT_SERVICE_TOKEN }, { token: FSW_PRE_SCREENING_BORROWER_DETAILS_BUILDER_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBorrowerDetailsStoreMY }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBorrowerDetailsStoreMY, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PRE_SCREENING_BORROWER_DETAILS_BUILDER_TOKEN]
                }] }]; } });

const FSWWPreScreeningBorrowerDetailsBuilderMY = (config) => {
    const { form } = config;
    const translation = FSW_PRE_SCREENING_BORROWER_DETAILS_TRANSLATION_LOADER[CountryCode.MY];
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'w-full flex gap-[16px] flex-wrap',
        form,
        readonlyWhen$: of(true),
        fields: [
            {
                key: 'fullname',
                customClasses: 'w-[calc(50%-8px)]',
                type: FSWDynamicBuilderControlTypes.INPUT,
                context: {
                    fullWidth: true,
                    label: translation.fields.name,
                },
            },
            {
                key: 'country_code',
                customClasses: 'w-[calc(50%-8px)]',
                type: FSWDynamicBuilderControlTypes.INPUT,
                context: {
                    fullWidth: true,
                    label: translation.fields.nationality,
                },
            },
            {
                key: 'birth_date',
                customClasses: 'w-[calc(50%-8px)]',
                type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                context: {
                    fullWidth: true,
                    label: translation.fields.date,
                    readonlyTemplate: (value) => new DatePipe('en-US').transform(value, 'dd/MM/yyyy') || '',
                    closeOnSelected: true,
                },
            },
            {
                key: 'ic_number',
                customClasses: 'w-[calc(50%-8px)]',
                type: FSWDynamicBuilderControlTypes.INPUT,
                context: {
                    fullWidth: true,
                    label: translation.fields.number,
                },
            },
        ],
    });
};

const FSW_PRE_SCREENING_BORROWER_DETAILS_MY_PROVIDERS = [
    {
        provide: FSW_PRE_SCREENING_BORROWER_DETAILS_BUILDER_TOKEN,
        useValue: FSWWPreScreeningBorrowerDetailsBuilderMY,
    },
    {
        provide: FSW_PRE_SCREENING_BORROWER_DETAILS_STORE_TOKEN,
        useClass: FSWPreScreeningBorrowerDetailsStoreMY,
        deps: [FSW_ALERT_SERVICE_TOKEN, FSW_PRE_SCREENING_BORROWER_DETAILS_BUILDER_TOKEN],
    },
];

const FSW_PRE_SCREENING_BORROWER_DETAILS_PROVIDERS = {
    default: FSW_PRE_SCREENING_BORROWER_DETAILS_MY_PROVIDERS,
    [CountryCode.MY]: FSW_PRE_SCREENING_BORROWER_DETAILS_MY_PROVIDERS,
};
const preScreeningBorrowerDetailsLoadProviders = (countryCode) => [
    fswTranslateScope('pre_screening_borrower_details'),
    ...getCustomProviders(FSW_PRE_SCREENING_BORROWER_DETAILS_PROVIDERS, FSW_PRE_SCREENING_BORROWER_DETAILS_MY_PROVIDERS, countryCode),
];

class PreScreeningBorrowerDetailsComponent {
    set entityId(entityId) {
        this._componentStore.updateState({
            entityId,
        });
    }
    set flow(flow) {
        this._componentStore.updateState({
            flow,
        });
    }
    set member(member) {
        this._componentStore.updateState({
            member,
        });
    }
    set isReadonly(isReadonly) {
        this._componentStore.updateState({
            isReadonly,
        });
    }
    constructor(_componentStore) {
        this._componentStore = _componentStore;
        this.state$ = this._componentStore.state$;
        this.form = this._componentStore.form;
        this.FSWFlow = FSWFlow;
    }
    ngOnInit() {
        this._componentStore.init();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningBorrowerDetailsComponent, deps: [{ token: FSW_PRE_SCREENING_BORROWER_DETAILS_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PreScreeningBorrowerDetailsComponent, selector: "fsw-pre-screening-borrower-details", inputs: { entityId: "entityId", flow: "flow", member: "member", isReadonly: "isReadonly" }, ngImport: i0, template: "<fsw-panel\n  [title]=\"'title' | fswTranslate\"\n  *ngIf=\"state$ | async as state\"\n  customClasses=\"w-[800px]\"\n>\n  <form [formGroup]=\"form\">\n    <fsw-dynamic-builder [builder]=\"state.builder\"></fsw-dynamic-builder>\n  </form>\n</fsw-panel>\n", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningBorrowerDetailsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-pre-screening-borrower-details', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-panel\n  [title]=\"'title' | fswTranslate\"\n  *ngIf=\"state$ | async as state\"\n  customClasses=\"w-[800px]\"\n>\n  <form [formGroup]=\"form\">\n    <fsw-dynamic-builder [builder]=\"state.builder\"></fsw-dynamic-builder>\n  </form>\n</fsw-panel>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PRE_SCREENING_BORROWER_DETAILS_STORE_TOKEN]
                }] }]; }, propDecorators: { entityId: [{
                type: Input
            }], flow: [{
                type: Input
            }], member: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class PreScreeningBorrowerDetailsDirective {
    constructor(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
        this.entityId = null;
        this.flow = FSWFlow.INSTANT;
        this.member = null;
        this.isReadonly = false;
    }
    ngOnChanges() {
        this._viewContainerRef.clear();
        const ref = this._viewContainerRef.createComponent(PreScreeningBorrowerDetailsComponent, {
            injector: Injector.create({
                parent: this._viewContainerRef.injector,
                providers: [...preScreeningBorrowerDetailsLoadProviders(getCountryCodeFromStorage())],
            }),
        });
        const instance = ref.instance;
        instance.entityId = this.entityId;
        instance.flow = this.flow;
        instance.member = this.member;
        instance.isReadonly = this.isReadonly;
        ref.changeDetectorRef.detectChanges();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningBorrowerDetailsDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: PreScreeningBorrowerDetailsDirective, selector: "[fswPreScreeningBorrowerDetails]", inputs: { entityId: "entityId", flow: "flow", member: "member", isReadonly: "isReadonly" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningBorrowerDetailsDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswPreScreeningBorrowerDetails]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; }, propDecorators: { entityId: [{
                type: Input
            }], flow: [{
                type: Input
            }], member: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class FSWPreScreeningBorrowerDetailsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBorrowerDetailsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBorrowerDetailsModule, declarations: [PreScreeningBorrowerDetailsComponent, PreScreeningBorrowerDetailsDirective], imports: [i1$4.FSWTranslateModule, NgForOf,
            NgIf,
            ReactiveFormsModule,
            FSWButtonModule,
            FSWDynamicBuilderModule,
            ApplicationPreScreeningServiceModule,
            CreditPreScreeningServiceModule,
            FSWIconModule,
            AsyncPipe,
            FSWPanelModule,
            FSWModalModule$1,
            FSWCheckboxModule,
            FSWAlertModule], exports: [PreScreeningBorrowerDetailsComponent, PreScreeningBorrowerDetailsDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBorrowerDetailsModule, imports: [FSWTranslateModule.forFeature({
                scope: 'pre_screening_borrower_details',
                defaultKey: CountryCode.MY,
                data: FSW_PRE_SCREENING_BORROWER_DETAILS_TRANSLATION_LOADER,
            }),
            ReactiveFormsModule,
            FSWButtonModule,
            FSWDynamicBuilderModule,
            ApplicationPreScreeningServiceModule,
            CreditPreScreeningServiceModule,
            FSWIconModule,
            FSWPanelModule,
            FSWModalModule$1,
            FSWCheckboxModule,
            FSWAlertModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBorrowerDetailsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [PreScreeningBorrowerDetailsComponent, PreScreeningBorrowerDetailsDirective],
                    imports: [
                        FSWTranslateModule.forFeature({
                            scope: 'pre_screening_borrower_details',
                            defaultKey: CountryCode.MY,
                            data: FSW_PRE_SCREENING_BORROWER_DETAILS_TRANSLATION_LOADER,
                        }),
                        NgForOf,
                        NgIf,
                        ReactiveFormsModule,
                        FSWButtonModule,
                        FSWDynamicBuilderModule,
                        ApplicationPreScreeningServiceModule,
                        CreditPreScreeningServiceModule,
                        FSWIconModule,
                        AsyncPipe,
                        FSWPanelModule,
                        FSWModalModule$1,
                        FSWCheckboxModule,
                        FSWAlertModule,
                    ],
                    exports: [PreScreeningBorrowerDetailsComponent, PreScreeningBorrowerDetailsDirective],
                }]
        }] });

class FSWPreScreeningCompanyDetailsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCompanyDetailsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCompanyDetailsModule, declarations: [PreScreeningCompanyDetailsComponent, PreScreeningCompanyDetailsDirective], imports: [i1$4.FSWTranslateModule, NgForOf,
            NgIf,
            ReactiveFormsModule,
            FSWButtonModule,
            FSWDynamicBuilderModule,
            ApplicationPreScreeningServiceModule,
            CreditPreScreeningServiceModule,
            FSWIconModule,
            AsyncPipe,
            FSWPanelModule,
            FSWModalModule$1,
            FSWCheckboxModule,
            FSWAlertModule,
            ReferenceServiceModule,
            MemberServiceModule], exports: [PreScreeningCompanyDetailsComponent, PreScreeningCompanyDetailsDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCompanyDetailsModule, imports: [FSWTranslateModule.forFeature({
                scope: 'pre_screening_company_details',
                defaultKey: CountryCode.MY,
                data: FSW_PRE_SCREENING_COMPANY_DETAILS_TRANSLATION_LOADER,
            }),
            ReactiveFormsModule,
            FSWButtonModule,
            FSWDynamicBuilderModule,
            ApplicationPreScreeningServiceModule,
            CreditPreScreeningServiceModule,
            FSWIconModule,
            FSWPanelModule,
            FSWModalModule$1,
            FSWCheckboxModule,
            FSWAlertModule,
            ReferenceServiceModule,
            MemberServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCompanyDetailsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [PreScreeningCompanyDetailsComponent, PreScreeningCompanyDetailsDirective],
                    imports: [
                        FSWTranslateModule.forFeature({
                            scope: 'pre_screening_company_details',
                            defaultKey: CountryCode.MY,
                            data: FSW_PRE_SCREENING_COMPANY_DETAILS_TRANSLATION_LOADER,
                        }),
                        NgForOf,
                        NgIf,
                        ReactiveFormsModule,
                        FSWButtonModule,
                        FSWDynamicBuilderModule,
                        ApplicationPreScreeningServiceModule,
                        CreditPreScreeningServiceModule,
                        FSWIconModule,
                        AsyncPipe,
                        FSWPanelModule,
                        FSWModalModule$1,
                        FSWCheckboxModule,
                        FSWAlertModule,
                        ReferenceServiceModule,
                        MemberServiceModule,
                    ],
                    exports: [PreScreeningCompanyDetailsComponent, PreScreeningCompanyDetailsDirective],
                }]
        }] });

var title$a = "Trade Reference";
var columns$4 = {
	trade_referee: "Trade Referee",
	category_for_trade_referee: "Category for Trade Reference"
};
var my$7 = {
	title: title$a,
	columns: columns$4
};

var MY$5 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    columns: columns$4,
    default: my$7,
    title: title$a
});

const FSW_PRE_SCREENING_TRADE_REFERENCE_TRANSLATION_LOADER = {
    [CountryCode.MY]: MY$5,
};

class FSWPreScreeningTradeReferenceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningTradeReferenceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningTradeReferenceModule, declarations: [PreScreeningTradeReferenceComponent, PreScreeningTradeReferenceDirective], imports: [i1$4.FSWTranslateModule, NgForOf,
            NgIf,
            ReactiveFormsModule,
            FSWButtonModule,
            FSWDynamicBuilderModule,
            ApplicationPreScreeningServiceModule,
            CreditPreScreeningServiceModule,
            FSWIconModule,
            AsyncPipe,
            FSWButtonModule,
            FSWPanelModule,
            FSWModalModule$1,
            FSWCheckboxModule,
            FSWAlertModule], exports: [PreScreeningTradeReferenceComponent, PreScreeningTradeReferenceDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningTradeReferenceModule, imports: [FSWTranslateModule.forFeature({
                scope: 'pre_screening_trade_reference',
                defaultKey: CountryCode.MY,
                data: FSW_PRE_SCREENING_TRADE_REFERENCE_TRANSLATION_LOADER,
            }),
            ReactiveFormsModule,
            FSWButtonModule,
            FSWDynamicBuilderModule,
            ApplicationPreScreeningServiceModule,
            CreditPreScreeningServiceModule,
            FSWIconModule,
            FSWButtonModule,
            FSWPanelModule,
            FSWModalModule$1,
            FSWCheckboxModule,
            FSWAlertModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningTradeReferenceModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [PreScreeningTradeReferenceComponent, PreScreeningTradeReferenceDirective],
                    imports: [
                        FSWTranslateModule.forFeature({
                            scope: 'pre_screening_trade_reference',
                            defaultKey: CountryCode.MY,
                            data: FSW_PRE_SCREENING_TRADE_REFERENCE_TRANSLATION_LOADER,
                        }),
                        NgForOf,
                        NgIf,
                        ReactiveFormsModule,
                        FSWButtonModule,
                        FSWDynamicBuilderModule,
                        ApplicationPreScreeningServiceModule,
                        CreditPreScreeningServiceModule,
                        FSWIconModule,
                        AsyncPipe,
                        FSWButtonModule,
                        FSWPanelModule,
                        FSWModalModule$1,
                        FSWCheckboxModule,
                        FSWAlertModule,
                    ],
                    exports: [PreScreeningTradeReferenceComponent, PreScreeningTradeReferenceDirective],
                }]
        }] });

class FSWPreScreeningCcrisFindingsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCcrisFindingsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCcrisFindingsModule, declarations: [PreScreeningCcrisFindingsComponent, PreScreeningCcrisFindingsDirective], imports: [i1$4.FSWTranslateModule, NgForOf,
            NgIf,
            ReactiveFormsModule,
            FSWButtonModule,
            FSWDynamicBuilderModule,
            ApplicationPreScreeningServiceModule,
            CreditPreScreeningServiceModule,
            FSWIconModule,
            AsyncPipe,
            FSWPanelModule,
            FSWModalModule$1,
            FSWCheckboxModule,
            FSWAlertModule,
            CreditGuarantorServiceModule], exports: [PreScreeningCcrisFindingsComponent, PreScreeningCcrisFindingsDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCcrisFindingsModule, providers: [
            provideApplicationRelationshipService(),
            provideApplicationBorrowerSummaryService(),
            provideCreditBorrowerSummaryService(),
            provideApplicationMemberService(),
        ], imports: [FSWTranslateModule.forFeature({
                scope: 'pre_screening_ccris_findings',
                defaultKey: CountryCode.MY,
                data: FSW_PRE_SCREENING_CCRIS_FINDINGS_TRANSLATION_LOADER,
            }),
            ReactiveFormsModule,
            FSWButtonModule,
            FSWDynamicBuilderModule,
            ApplicationPreScreeningServiceModule,
            CreditPreScreeningServiceModule,
            FSWIconModule,
            FSWPanelModule,
            FSWModalModule$1,
            FSWCheckboxModule,
            FSWAlertModule,
            CreditGuarantorServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCcrisFindingsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [PreScreeningCcrisFindingsComponent, PreScreeningCcrisFindingsDirective],
                    imports: [
                        FSWTranslateModule.forFeature({
                            scope: 'pre_screening_ccris_findings',
                            defaultKey: CountryCode.MY,
                            data: FSW_PRE_SCREENING_CCRIS_FINDINGS_TRANSLATION_LOADER,
                        }),
                        NgForOf,
                        NgIf,
                        ReactiveFormsModule,
                        FSWButtonModule,
                        FSWDynamicBuilderModule,
                        ApplicationPreScreeningServiceModule,
                        CreditPreScreeningServiceModule,
                        FSWIconModule,
                        AsyncPipe,
                        FSWPanelModule,
                        FSWModalModule$1,
                        FSWCheckboxModule,
                        FSWAlertModule,
                        CreditGuarantorServiceModule,
                    ],
                    exports: [PreScreeningCcrisFindingsComponent, PreScreeningCcrisFindingsDirective],
                    providers: [
                        provideApplicationRelationshipService(),
                        provideApplicationBorrowerSummaryService(),
                        provideCreditBorrowerSummaryService(),
                        provideApplicationMemberService(),
                    ],
                }]
        }] });

var borrower$1 = "Borrower";
var bip = "BIP {{index}}";
var my$6 = {
	borrower: borrower$1,
	bip: bip
};

var MY$4 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    bip: bip,
    borrower: borrower$1,
    default: my$6
});

const FSW_PRE_SCREENING_BORROWER_AND_BIPS_TRANSLATION_LOADER = {
    [CountryCode.MY]: MY$4,
};

const FSW_PRE_SCREENING_BIPS_STORE_TOKEN = new InjectionToken('FSW_PRE_SCREENING_BIPS_STORE_TOKEN');

const FSW_PRE_SCREENING_BIPS_BUILDER_TOKEN = new InjectionToken('FSW_PRE_SCREENING_BIPS_BUILDER_TOKEN');

const FSW_PRE_SCREENING_BIPS_ENTITY_TOKEN = new InjectionToken('FSW_PRE_SCREENING_BIPS_ENTITY_TOKEN');

var title$9 = "BIP Details";
var fields$6 = {
	pg: {
		recourse_type: "Recourse Type",
		role: "Role",
		age: "Age",
		nationality: "Nationality",
		shareholder_percentage: "Percentage Shareholder",
		litigation: "Litigation",
		payment_behavior: "Repayment Conduct",
		total_outstanding_amount_trade_reference: "Trade Reference Outstanding"
	},
	cg: {
		number: "Business Registration Number",
		revenue: "Annual Revenue",
		date: "Incorporation Date"
	}
};
var my$5 = {
	title: title$9,
	fields: fields$6
};

var MY$3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: my$5,
    fields: fields$6,
    title: title$9
});

const FSW_PRE_SCREENING_BIPS_TRANSLATION_LOADER = {
    [CountryCode.MY]: MY$3,
};

class FSWPreScreeningBipsStore extends ComponentStore {
    constructor(_entity, _alertService, _builder, _initialState) {
        super(_initialState);
        this._entity = _entity;
        this._alertService = _alertService;
        this._builder = _builder;
        this._initialState = _initialState;
        this.form = new UntypedFormGroup({});
        this.init = this.effect(pipe(tap(() => this.updateBuilder()), switchMap(() => this.select((state) => state.entityId).pipe(mergeMap((entityId) => this._entity.getData(entityId)), tap((data) => {
            this.form.patchValue(data || {});
            this.form.patchValue({
                recourse_type: this.get().entityType,
            });
        })))));
        this.updateState = (value) => this.patchState({
            ...value,
        });
    }
    updateBuilder() {
        this.updateState({
            builder: this._builder({
                form: this.form,
                isReadonly: true,
                entityType: this.get().entityType,
            }),
        });
    }
}

class FSWPreScreeningBipsStoreMY extends FSWPreScreeningBipsStore {
    constructor(entity, alertService, _builder) {
        super(entity, alertService, _builder, {
            entityId: null,
            flow: FSWFlow.INSTANT,
            builder: null,
            entityType: FSWRecourseTypes.OTHER,
            member: null,
            isReadonly: false,
        });
        this.entity = entity;
        this.alertService = alertService;
        this._builder = _builder;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBipsStoreMY, deps: [{ token: FSW_PRE_SCREENING_BIPS_ENTITY_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }, { token: FSW_PRE_SCREENING_BIPS_BUILDER_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBipsStoreMY }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBipsStoreMY, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PRE_SCREENING_BIPS_ENTITY_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PRE_SCREENING_BIPS_BUILDER_TOKEN]
                }] }]; } });

const FSWWPreScreeningBipsBuilderMY = (config) => {
    const { form, isReadonly, entityType } = config;
    const translation = FSW_PRE_SCREENING_BIPS_TRANSLATION_LOADER[CountryCode.MY];
    const builderMapping = {
        [FSWRecourseTypes.PG]: new FSWDynamicBuilder({
            formType: FSWDynamicBuilderFormTypes.GROUP,
            customClasses: 'w-full flex flex-col',
            readonlyWhen$: of(true),
            form,
            renderBy: 'container',
            containers: [
                {
                    customClasses: 'flex gap-[16px] flex-wrap pt-2 pb-4',
                    fields: [
                        {
                            key: 'recourse_type',
                            customClasses: 'w-[calc(50%-8px)]',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                fullWidth: true,
                                isReadonly: true,
                                label: translation.fields.pg.recourse_type,
                            },
                        },
                        {
                            key: 'role',
                            customClasses: 'w-[calc(50%-8px)]',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                fullWidth: true,
                                label: translation.fields.pg.role,
                            },
                        },
                    ],
                },
                {
                    customClasses: 'flex gap-[16px] flex-wrap pt-2 pb-4 border-0 border-t border-solid',
                    fields: [
                        {
                            key: 'age',
                            customClasses: 'w-[calc(50%-8px)]',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                fullWidth: true,
                                label: translation.fields.pg.age,
                            },
                        },
                        {
                            key: 'nationality',
                            customClasses: 'w-[calc(50%-8px)]',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                fullWidth: true,
                                label: translation.fields.pg.nationality,
                            },
                        },
                    ],
                },
                {
                    customClasses: 'flex gap-[16px] flex-wrap pt-2 pb-4 border-0 border-t border-solid',
                    fields: [
                        {
                            key: 'shareholder_percentage',
                            customClasses: 'w-[calc(50%-8px)]',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number',
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                fullWidth: true,
                                label: translation.fields.pg.shareholder_percentage,
                            },
                        },
                        {
                            key: 'litigation',
                            customClasses: 'w-[calc(50%-8px)]',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number',
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                fullWidth: true,
                                label: translation.fields.pg.litigation,
                            },
                        },
                        {
                            key: 'payment_behavior',
                            customClasses: 'w-[calc(50%-8px)]',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                fullWidth: true,
                                label: translation.fields.pg.payment_behavior,
                            },
                        },
                        {
                            key: 'total_outstanding_amount_trade_reference',
                            customClasses: 'w-[calc(50%-8px)]',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number',
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                fullWidth: true,
                                label: translation.fields.pg.total_outstanding_amount_trade_reference,
                            },
                        },
                    ],
                },
            ],
        }),
        [FSWRecourseTypes.CG]: new FSWDynamicBuilder({
            formType: FSWDynamicBuilderFormTypes.GROUP,
            customClasses: 'flex gap-[16px] flex-wrap w-full',
            readonlyWhen$: of(isReadonly),
            form,
            fields: [
                {
                    key: 'registration_no',
                    customClasses: 'w-[calc(50%-8px)]',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    context: {
                        fullWidth: true,
                        label: translation.fields.cg.number,
                    },
                },
                {
                    key: 'revenue',
                    customClasses: 'w-[calc(50%-8px)]',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    context: {
                        // inputType: 'number',
                        mask: {
                            expression: 'separator.2',
                            config: {
                                thousandSeparator: ',',
                            },
                        },
                        fullWidth: true,
                        label: translation.fields.cg.revenue,
                    },
                },
                {
                    key: 'incorporation_date',
                    customClasses: 'w-[calc(50%-8px)]',
                    type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                    context: {
                        fullWidth: true,
                        label: translation.fields.cg.date,
                        readonlyTemplate: (value) => new DatePipe('en-US').transform(value, 'dd/MM/yyyy') || '',
                        closeOnSelected: true,
                    },
                },
            ],
        }),
        [FSWRecourseTypes.OTHER]: new FSWDynamicBuilder({
            formType: FSWDynamicBuilderFormTypes.GROUP,
            customClasses: 'w-full',
            readonlyWhen$: of(isReadonly),
            form,
            fields: [],
        }),
        [FSWRecourseTypes.BRW]: new FSWDynamicBuilder({
            formType: FSWDynamicBuilderFormTypes.GROUP,
            customClasses: 'w-full',
            readonlyWhen$: of(isReadonly),
            form,
            fields: [],
        }),
    };
    return builderMapping[entityType];
};

const FSW_PRE_SCREENING_BIPS_MY_PROVIDERS = [
    {
        provide: FSW_PRE_SCREENING_BIPS_BUILDER_TOKEN,
        useValue: FSWWPreScreeningBipsBuilderMY,
    },
    {
        provide: FSW_PRE_SCREENING_BIPS_STORE_TOKEN,
        useClass: FSWPreScreeningBipsStoreMY,
        deps: [
            FSW_PRE_SCREENING_BIPS_ENTITY_TOKEN,
            FSW_ALERT_SERVICE_TOKEN,
            FSW_PRE_SCREENING_BIPS_BUILDER_TOKEN,
        ],
    },
];

class FSWPreScreeningBipsPgEntity {
    constructor(_creditGuarantorService) {
        this._creditGuarantorService = _creditGuarantorService;
    }
    getData(entityId) {
        return this._creditGuarantorService
            .getPersonalSummaries([entityId])
            .pipe(map((list) => (list.shift() ?? null)));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBipsPgEntity, deps: [{ token: CREDIT_GUARANTOR_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBipsPgEntity }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBipsPgEntity, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CREDIT_GUARANTOR_SERVICE_TOKEN]
                }] }]; } });

class FSWPreScreeningBipsCgEntity {
    constructor(_creditGuarantorService) {
        this._creditGuarantorService = _creditGuarantorService;
    }
    getData(entityId) {
        return this._creditGuarantorService
            .getCorporateSummaries([entityId])
            .pipe(map((list) => (list.shift()?.company ?? null)));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBipsCgEntity, deps: [{ token: CREDIT_GUARANTOR_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBipsCgEntity }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBipsCgEntity, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CREDIT_GUARANTOR_SERVICE_TOKEN]
                }] }]; } });

class FSWPreScreeningBipsOtherEntity {
    getData(entityId) {
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBipsOtherEntity, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBipsOtherEntity }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBipsOtherEntity, decorators: [{
            type: Injectable
        }] });

const FSW_PRE_SCREENING_BIPS_PROVIDERS = {
    default: FSW_PRE_SCREENING_BIPS_MY_PROVIDERS,
    [CountryCode.MY]: FSW_PRE_SCREENING_BIPS_MY_PROVIDERS,
};
const preScreeningBipsLoadProviders = (countryCode) => [
    fswTranslateScope('pre_screening_bips'),
    ...getCustomProviders(FSW_PRE_SCREENING_BIPS_PROVIDERS, FSW_PRE_SCREENING_BIPS_MY_PROVIDERS, countryCode),
];
const preScreeningBipsEntityLoadProviders = (entityType) => {
    const classMapping = {
        [FSWRecourseTypes.CG]: FSWPreScreeningBipsCgEntity,
        [FSWRecourseTypes.PG]: FSWPreScreeningBipsPgEntity,
        [FSWRecourseTypes.OTHER]: FSWPreScreeningBipsOtherEntity,
        [FSWRecourseTypes.BRW]: FSWPreScreeningBipsOtherEntity,
    };
    const depsMapping = {
        [FSWRecourseTypes.CG]: [CREDIT_GUARANTOR_SERVICE_TOKEN],
        [FSWRecourseTypes.PG]: [CREDIT_GUARANTOR_SERVICE_TOKEN],
        [FSWRecourseTypes.OTHER]: [],
        [FSWRecourseTypes.BRW]: [],
    };
    return [
        {
            provide: FSW_PRE_SCREENING_BIPS_ENTITY_TOKEN,
            useClass: classMapping[entityType],
            deps: depsMapping[entityType],
        },
    ];
};

class PreScreeningBipsComponent {
    set entityId(entityId) {
        this._componentStore.updateState({
            entityId,
        });
    }
    set entityType(entityType) {
        this._componentStore.updateState({
            entityType,
        });
    }
    set flow(flow) {
        this._componentStore.updateState({
            flow,
        });
    }
    set member(member) {
        this._componentStore.updateState({
            member,
        });
    }
    set isReadonly(isReadonly) {
        this._componentStore.updateState({
            isReadonly,
        });
    }
    constructor(_componentStore) {
        this._componentStore = _componentStore;
        this.state$ = this._componentStore.state$;
        this.form = this._componentStore.form;
        this.FSWFlow = FSWFlow;
    }
    ngOnInit() {
        this._componentStore.init();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningBipsComponent, deps: [{ token: FSW_PRE_SCREENING_BIPS_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PreScreeningBipsComponent, selector: "fsw-pre-screening-bips", inputs: { entityId: "entityId", entityType: "entityType", flow: "flow", member: "member", isReadonly: "isReadonly" }, ngImport: i0, template: "<fsw-panel\n  [title]=\"form.value.name || ('title' | fswTranslate)\"\n  *ngIf=\"state$ | async as state\"\n  customClasses=\"w-[800px]\"\n>\n  <form [formGroup]=\"form\">\n    <fsw-dynamic-builder [builder]=\"state.builder\"></fsw-dynamic-builder>\n  </form>\n</fsw-panel>\n", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningBipsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-pre-screening-bips', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-panel\n  [title]=\"form.value.name || ('title' | fswTranslate)\"\n  *ngIf=\"state$ | async as state\"\n  customClasses=\"w-[800px]\"\n>\n  <form [formGroup]=\"form\">\n    <fsw-dynamic-builder [builder]=\"state.builder\"></fsw-dynamic-builder>\n  </form>\n</fsw-panel>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PRE_SCREENING_BIPS_STORE_TOKEN]
                }] }]; }, propDecorators: { entityId: [{
                type: Input
            }], entityType: [{
                type: Input
            }], flow: [{
                type: Input
            }], member: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class PreScreeningBipsDirective {
    constructor(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
        this.entityId = null;
        this.entityType = FSWRecourseTypes.OTHER;
        this.flow = FSWFlow.INSTANT;
        this.member = null;
        this.isReadonly = false;
    }
    ngOnChanges() {
        this._viewContainerRef.clear();
        const ref = this._viewContainerRef.createComponent(PreScreeningBipsComponent, {
            injector: Injector.create({
                parent: this._viewContainerRef.injector,
                providers: [
                    ...preScreeningBipsLoadProviders(getCountryCodeFromStorage()),
                    ...preScreeningBipsEntityLoadProviders(this.entityType),
                ],
            }),
        });
        const instance = ref.instance;
        instance.entityId = this.entityId;
        instance.flow = this.flow;
        instance.entityType = this.entityType;
        instance.member = this.member;
        instance.isReadonly = this.isReadonly;
        ref.changeDetectorRef.detectChanges();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningBipsDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: PreScreeningBipsDirective, selector: "[fswPreScreeningBips]", inputs: { entityId: "entityId", entityType: "entityType", flow: "flow", member: "member", isReadonly: "isReadonly" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningBipsDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswPreScreeningBips]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; }, propDecorators: { entityId: [{
                type: Input
            }], entityType: [{
                type: Input
            }], flow: [{
                type: Input
            }], member: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class FSWPreScreeningBipsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBipsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBipsModule, declarations: [PreScreeningBipsComponent, PreScreeningBipsDirective], imports: [i1$4.FSWTranslateModule, NgForOf,
            NgIf,
            ReactiveFormsModule,
            FSWButtonModule,
            FSWDynamicBuilderModule,
            ApplicationPreScreeningServiceModule,
            CreditPreScreeningServiceModule,
            FSWIconModule,
            AsyncPipe,
            FSWPanelModule,
            FSWModalModule$1,
            FSWCheckboxModule,
            FSWAlertModule,
            CreditGuarantorServiceModule], exports: [PreScreeningBipsComponent, PreScreeningBipsDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBipsModule, imports: [FSWTranslateModule.forFeature({
                scope: 'pre_screening_bips',
                defaultKey: CountryCode.MY,
                data: FSW_PRE_SCREENING_BIPS_TRANSLATION_LOADER,
            }),
            ReactiveFormsModule,
            FSWButtonModule,
            FSWDynamicBuilderModule,
            ApplicationPreScreeningServiceModule,
            CreditPreScreeningServiceModule,
            FSWIconModule,
            FSWPanelModule,
            FSWModalModule$1,
            FSWCheckboxModule,
            FSWAlertModule,
            CreditGuarantorServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBipsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [PreScreeningBipsComponent, PreScreeningBipsDirective],
                    imports: [
                        FSWTranslateModule.forFeature({
                            scope: 'pre_screening_bips',
                            defaultKey: CountryCode.MY,
                            data: FSW_PRE_SCREENING_BIPS_TRANSLATION_LOADER,
                        }),
                        NgForOf,
                        NgIf,
                        ReactiveFormsModule,
                        FSWButtonModule,
                        FSWDynamicBuilderModule,
                        ApplicationPreScreeningServiceModule,
                        CreditPreScreeningServiceModule,
                        FSWIconModule,
                        AsyncPipe,
                        FSWPanelModule,
                        FSWModalModule$1,
                        FSWCheckboxModule,
                        FSWAlertModule,
                        CreditGuarantorServiceModule,
                    ],
                    exports: [PreScreeningBipsComponent, PreScreeningBipsDirective],
                }]
        }] });

class FSWPreScreeningBorrowerAndBipsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBorrowerAndBipsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBorrowerAndBipsModule, declarations: [PreScreeningBorrowerAndBipsComponent, PreScreeningBorrowerAndBipsDirective], imports: [i1$4.FSWTranslateModule, NgForOf,
            NgIf,
            ReactiveFormsModule,
            FSWButtonModule,
            FSWTabsModule,
            AsyncPipe,
            FSWAlertModule,
            NgTemplateOutlet,
            FSWPreScreeningBipsModule,
            FSWPreScreeningBorrowerDetailsModule,
            ApplicationGuarantorServiceModule,
            CreditGuarantorServiceModule,
            JsonPipe,
            MemberServiceModule], exports: [PreScreeningBorrowerAndBipsComponent, PreScreeningBorrowerAndBipsDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBorrowerAndBipsModule, imports: [FSWTranslateModule.forFeature({
                scope: 'pre_screening_borrower_and_bips',
                defaultKey: CountryCode.MY,
                data: FSW_PRE_SCREENING_BORROWER_AND_BIPS_TRANSLATION_LOADER,
            }),
            ReactiveFormsModule,
            FSWButtonModule,
            FSWTabsModule,
            FSWAlertModule,
            FSWPreScreeningBipsModule,
            FSWPreScreeningBorrowerDetailsModule,
            ApplicationGuarantorServiceModule,
            CreditGuarantorServiceModule,
            MemberServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBorrowerAndBipsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [PreScreeningBorrowerAndBipsComponent, PreScreeningBorrowerAndBipsDirective],
                    imports: [
                        FSWTranslateModule.forFeature({
                            scope: 'pre_screening_borrower_and_bips',
                            defaultKey: CountryCode.MY,
                            data: FSW_PRE_SCREENING_BORROWER_AND_BIPS_TRANSLATION_LOADER,
                        }),
                        NgForOf,
                        NgIf,
                        ReactiveFormsModule,
                        FSWButtonModule,
                        FSWTabsModule,
                        AsyncPipe,
                        FSWAlertModule,
                        NgTemplateOutlet,
                        FSWPreScreeningBipsModule,
                        FSWPreScreeningBorrowerDetailsModule,
                        ApplicationGuarantorServiceModule,
                        CreditGuarantorServiceModule,
                        JsonPipe,
                        MemberServiceModule,
                    ],
                    exports: [PreScreeningBorrowerAndBipsComponent, PreScreeningBorrowerAndBipsDirective],
                }]
        }] });

class FSWPreScreeningCtosModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCtosModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCtosModule, declarations: [PreScreeningCtosComponent], imports: [FSWTabsModule,
            NgForOf,
            NgIf,
            FSWPreScreeningBorrowerDetailsModule,
            FSWPreScreeningCompanyDetailsModule,
            FSWPreScreeningTradeReferenceModule,
            FSWPreScreeningCcrisFindingsModule,
            FSWPreScreeningCriteriaModule,
            NgTemplateOutlet,
            FSWPreScreeningBorrowerAndBipsModule,
            AsyncPipe,
            JsonPipe,
            ApplicationMemberServiceModule,
            ApplicationServiceModule], exports: [PreScreeningCtosComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCtosModule, imports: [FSWTabsModule,
            FSWPreScreeningBorrowerDetailsModule,
            FSWPreScreeningCompanyDetailsModule,
            FSWPreScreeningTradeReferenceModule,
            FSWPreScreeningCcrisFindingsModule,
            FSWPreScreeningCriteriaModule,
            FSWPreScreeningBorrowerAndBipsModule,
            ApplicationMemberServiceModule,
            ApplicationServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCtosModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [PreScreeningCtosComponent],
                    imports: [
                        FSWTabsModule,
                        NgForOf,
                        NgIf,
                        FSWPreScreeningBorrowerDetailsModule,
                        FSWPreScreeningCompanyDetailsModule,
                        FSWPreScreeningTradeReferenceModule,
                        FSWPreScreeningCcrisFindingsModule,
                        FSWPreScreeningCriteriaModule,
                        NgTemplateOutlet,
                        FSWPreScreeningBorrowerAndBipsModule,
                        AsyncPipe,
                        JsonPipe,
                        ApplicationMemberServiceModule,
                        ApplicationServiceModule,
                    ],
                    exports: [PreScreeningCtosComponent],
                }]
        }] });

class PreScreeningBasicDetailsComponent {
    constructor(_applicationMemberService) {
        this._applicationMemberService = _applicationMemberService;
        this.validating = new EventEmitter();
        this.entityId = null;
        this.entityNumber = null;
        this.flow = FSWFlow.INSTANT;
        this.isReadonly = false;
        this.FSWFlow = FSWFlow;
        this.FSWCreditPreScreeningStages = FSWCreditPreScreeningStages;
        this.init$ = new BehaviorSubject(false);
        this.member$ = new BehaviorSubject(null);
    }
    ngOnInit() {
        if (!this.entityId) {
            return;
        }
        this._applicationMemberService
            .getApplicationMembersInformation(this.entityId, { type: ApplicationMemberType.MAIN }, {
            country_code: getCountryCodeFromStorage(),
            member_type_code: MemberCode.BORROWER,
        })
            .pipe(tap((members) => this.member$.next(members ? members[0] : null)), finalize(() => this.init$.next(true)) // making sure that this get call even the API success or error
        )
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningBasicDetailsComponent, deps: [{ token: APPLICATION_MEMBER_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PreScreeningBasicDetailsComponent, selector: "fsw-pre-screening-basic-details", inputs: { entityId: "entityId", entityNumber: "entityNumber", flow: "flow", isReadonly: "isReadonly" }, outputs: { validating: "validating" }, ngImport: i0, template: "<fsw-tabs-group [customRowGap]=\"'24px'\" [customColumnGap]=\"'24px'\">\n  <ng-container *ngIf=\"flow !== FSWFlow.MANUAL\">\n    <ng-template fswTabs [key]=\"FSWFlow.INSTANT\" [maxTextWidth]=\"'unset'\" [label]=\"'Instant Flow'\">\n      <ng-container\n        *ngTemplateOutlet=\"flowTemplate; context: { $implicit: FSWFlow.INSTANT }\"\n      ></ng-container>\n    </ng-template>\n  </ng-container>\n  <ng-container *ngIf=\"flow !== FSWFlow.INSTANT\">\n    <ng-template fswTabs [key]=\"FSWFlow.MANUAL\" [maxTextWidth]=\"'unset'\" [label]=\"'Manual Flow'\">\n      <ng-container\n        *ngTemplateOutlet=\"flowTemplate; context: { $implicit: FSWFlow.MANUAL }\"\n      ></ng-container>\n    </ng-template>\n  </ng-container>\n</fsw-tabs-group>\n<ng-template #flowTemplate let-flow>\n  <section class=\"flex flex-col gap-[16px]\" *ngIf=\"init$ | async\">\n    <ng-container\n      fswPreScreeningCriteria\n      [entityId]=\"entityId\"\n      [entityNumber]=\"entityNumber\"\n      [stage]=\"FSWCreditPreScreeningStages.BASIC_PRESCREENING\"\n      [flow]=\"flow\"\n      [member]=\"member$ | async\"\n      [isReadonly]=\"isReadonly\"\n      (validating)=\"validating.emit($event)\"\n    ></ng-container>\n  </section>\n</ng-template>\n", dependencies: [{ kind: "component", type: i1$4.FSWTabsGroupComponent, selector: "fsw-tabs-group" }, { kind: "directive", type: i1$4.FSWTabsDirective, selector: "ng-template[fswTabs]" }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: FSWPreScreeningCriteriaDirective, selector: "[fswPreScreeningCriteria]", inputs: ["id", "title", "entityId", "entityNumber", "partnerId", "allowedProductUPI", "prescreeningIdsData", "flow", "stage", "member", "tradeReferenceNames", "isReadonly", "isTopUp", "parentLoanId", "parentFacilityCode", "customPayloadDataCallback", "customFilterCallback"], outputs: ["validating", "tradeReferenceChange"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningBasicDetailsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-pre-screening-basic-details', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-tabs-group [customRowGap]=\"'24px'\" [customColumnGap]=\"'24px'\">\n  <ng-container *ngIf=\"flow !== FSWFlow.MANUAL\">\n    <ng-template fswTabs [key]=\"FSWFlow.INSTANT\" [maxTextWidth]=\"'unset'\" [label]=\"'Instant Flow'\">\n      <ng-container\n        *ngTemplateOutlet=\"flowTemplate; context: { $implicit: FSWFlow.INSTANT }\"\n      ></ng-container>\n    </ng-template>\n  </ng-container>\n  <ng-container *ngIf=\"flow !== FSWFlow.INSTANT\">\n    <ng-template fswTabs [key]=\"FSWFlow.MANUAL\" [maxTextWidth]=\"'unset'\" [label]=\"'Manual Flow'\">\n      <ng-container\n        *ngTemplateOutlet=\"flowTemplate; context: { $implicit: FSWFlow.MANUAL }\"\n      ></ng-container>\n    </ng-template>\n  </ng-container>\n</fsw-tabs-group>\n<ng-template #flowTemplate let-flow>\n  <section class=\"flex flex-col gap-[16px]\" *ngIf=\"init$ | async\">\n    <ng-container\n      fswPreScreeningCriteria\n      [entityId]=\"entityId\"\n      [entityNumber]=\"entityNumber\"\n      [stage]=\"FSWCreditPreScreeningStages.BASIC_PRESCREENING\"\n      [flow]=\"flow\"\n      [member]=\"member$ | async\"\n      [isReadonly]=\"isReadonly\"\n      (validating)=\"validating.emit($event)\"\n    ></ng-container>\n  </section>\n</ng-template>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_SERVICE_TOKEN]
                }] }]; }, propDecorators: { validating: [{
                type: Output
            }], entityId: [{
                type: Input
            }], entityNumber: [{
                type: Input
            }], flow: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class FSWPreScreeningBasicDetailsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBasicDetailsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBasicDetailsModule, declarations: [PreScreeningBasicDetailsComponent], imports: [FSWTabsModule,
            NgForOf,
            NgIf,
            FSWPreScreeningCriteriaModule,
            NgTemplateOutlet,
            ApplicationMemberServiceModule,
            AsyncPipe], exports: [PreScreeningBasicDetailsComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBasicDetailsModule, imports: [FSWTabsModule,
            FSWPreScreeningCriteriaModule,
            ApplicationMemberServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBasicDetailsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [PreScreeningBasicDetailsComponent],
                    imports: [
                        FSWTabsModule,
                        NgForOf,
                        NgIf,
                        FSWPreScreeningCriteriaModule,
                        NgTemplateOutlet,
                        ApplicationMemberServiceModule,
                        AsyncPipe,
                    ],
                    exports: [PreScreeningBasicDetailsComponent],
                }]
        }] });

class PreScreeningBankStatementsComponent {
    constructor(_applicationMemberService) {
        this._applicationMemberService = _applicationMemberService;
        this.validating = new EventEmitter();
        this.entityId = null;
        this.entityNumber = null;
        this.flow = FSWFlow.INSTANT;
        this.isReadonly = false;
        this.FSWFlow = FSWFlow;
        this.FSWCreditPreScreeningStages = FSWCreditPreScreeningStages;
        this.init$ = new BehaviorSubject(false);
        this.member$ = new BehaviorSubject(null);
    }
    ngOnInit() {
        if (!this.entityId) {
            return;
        }
        this._applicationMemberService
            .getApplicationMembersInformation(this.entityId, { type: ApplicationMemberType.MAIN }, {
            country_code: getCountryCodeFromStorage(),
            member_type_code: MemberCode.BORROWER,
        })
            .pipe(tap((members) => this.member$.next(members ? members[0] : null)), finalize(() => this.init$.next(true)) // making sure that this get call even the API success or error
        )
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningBankStatementsComponent, deps: [{ token: APPLICATION_MEMBER_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PreScreeningBankStatementsComponent, selector: "fsw-pre-screening-bank-statements", inputs: { entityId: "entityId", entityNumber: "entityNumber", flow: "flow", isReadonly: "isReadonly" }, outputs: { validating: "validating" }, ngImport: i0, template: "<fsw-tabs-group [customRowGap]=\"'24px'\" [customColumnGap]=\"'24px'\">\n  <ng-container *ngIf=\"flow !== FSWFlow.MANUAL\">\n    <ng-template fswTabs [key]=\"FSWFlow.INSTANT\" [maxTextWidth]=\"'unset'\" [label]=\"'Instant Flow'\">\n      <ng-container\n        *ngTemplateOutlet=\"flowTemplate; context: { $implicit: FSWFlow.INSTANT }\"\n      ></ng-container>\n    </ng-template>\n  </ng-container>\n  <ng-container *ngIf=\"flow !== FSWFlow.INSTANT\">\n    <ng-template fswTabs [key]=\"FSWFlow.MANUAL\" [maxTextWidth]=\"'unset'\" [label]=\"'Manual Flow'\">\n      <ng-container\n        *ngTemplateOutlet=\"flowTemplate; context: { $implicit: FSWFlow.MANUAL }\"\n      ></ng-container>\n    </ng-template>\n  </ng-container>\n</fsw-tabs-group>\n<ng-template #flowTemplate let-flow>\n  <section class=\"flex flex-col gap-[16px]\" *ngIf=\"init$ | async\">\n    <ng-container\n      fswPreScreeningCriteria\n      [entityId]=\"entityId\"\n      [entityNumber]=\"entityNumber\"\n      [stage]=\"FSWCreditPreScreeningStages.BANK\"\n      [flow]=\"flow\"\n      [member]=\"member$ | async\"\n      [isReadonly]=\"isReadonly\"\n      (validating)=\"validating.emit($event)\"\n    ></ng-container>\n  </section>\n</ng-template>\n", dependencies: [{ kind: "component", type: i1$4.FSWTabsGroupComponent, selector: "fsw-tabs-group" }, { kind: "directive", type: i1$4.FSWTabsDirective, selector: "ng-template[fswTabs]" }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: FSWPreScreeningCriteriaDirective, selector: "[fswPreScreeningCriteria]", inputs: ["id", "title", "entityId", "entityNumber", "partnerId", "allowedProductUPI", "prescreeningIdsData", "flow", "stage", "member", "tradeReferenceNames", "isReadonly", "isTopUp", "parentLoanId", "parentFacilityCode", "customPayloadDataCallback", "customFilterCallback"], outputs: ["validating", "tradeReferenceChange"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreScreeningBankStatementsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-pre-screening-bank-statements', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-tabs-group [customRowGap]=\"'24px'\" [customColumnGap]=\"'24px'\">\n  <ng-container *ngIf=\"flow !== FSWFlow.MANUAL\">\n    <ng-template fswTabs [key]=\"FSWFlow.INSTANT\" [maxTextWidth]=\"'unset'\" [label]=\"'Instant Flow'\">\n      <ng-container\n        *ngTemplateOutlet=\"flowTemplate; context: { $implicit: FSWFlow.INSTANT }\"\n      ></ng-container>\n    </ng-template>\n  </ng-container>\n  <ng-container *ngIf=\"flow !== FSWFlow.INSTANT\">\n    <ng-template fswTabs [key]=\"FSWFlow.MANUAL\" [maxTextWidth]=\"'unset'\" [label]=\"'Manual Flow'\">\n      <ng-container\n        *ngTemplateOutlet=\"flowTemplate; context: { $implicit: FSWFlow.MANUAL }\"\n      ></ng-container>\n    </ng-template>\n  </ng-container>\n</fsw-tabs-group>\n<ng-template #flowTemplate let-flow>\n  <section class=\"flex flex-col gap-[16px]\" *ngIf=\"init$ | async\">\n    <ng-container\n      fswPreScreeningCriteria\n      [entityId]=\"entityId\"\n      [entityNumber]=\"entityNumber\"\n      [stage]=\"FSWCreditPreScreeningStages.BANK\"\n      [flow]=\"flow\"\n      [member]=\"member$ | async\"\n      [isReadonly]=\"isReadonly\"\n      (validating)=\"validating.emit($event)\"\n    ></ng-container>\n  </section>\n</ng-template>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_SERVICE_TOKEN]
                }] }]; }, propDecorators: { validating: [{
                type: Output
            }], entityId: [{
                type: Input
            }], entityNumber: [{
                type: Input
            }], flow: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class FSWPreScreeningBankStatementsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBankStatementsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBankStatementsModule, declarations: [PreScreeningBankStatementsComponent], imports: [FSWTabsModule,
            NgForOf,
            NgIf,
            FSWPreScreeningCriteriaModule,
            NgTemplateOutlet,
            ApplicationMemberServiceModule,
            AsyncPipe], exports: [PreScreeningBankStatementsComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBankStatementsModule, imports: [FSWTabsModule,
            FSWPreScreeningCriteriaModule,
            ApplicationMemberServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBankStatementsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [PreScreeningBankStatementsComponent],
                    imports: [
                        FSWTabsModule,
                        NgForOf,
                        NgIf,
                        FSWPreScreeningCriteriaModule,
                        NgTemplateOutlet,
                        ApplicationMemberServiceModule,
                        AsyncPipe,
                    ],
                    exports: [PreScreeningBankStatementsComponent],
                }]
        }] });

class FSWPreScreeningItemDirective {
    constructor() {
        this.entityId = null;
        this.entityNumber = null;
        this.partnerId = null;
        this.allowedProductUPI = null;
        this.prescreeningIdsData = null;
        this.member = null;
        this.isReadonly = false;
        this.isTopUp = false;
        this.parentLoanId = null;
        this.parentFacilityCode = null;
        this.flow = FSWFlow.MANUAL;
        this.stage = FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BRI;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningItemDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWPreScreeningItemDirective, inputs: { entityId: "entityId", entityNumber: "entityNumber", partnerId: "partnerId", allowedProductUPI: "allowedProductUPI", prescreeningIdsData: "prescreeningIdsData", member: "member", isReadonly: "isReadonly", isTopUp: "isTopUp", parentLoanId: "parentLoanId", parentFacilityCode: "parentFacilityCode", flow: "flow", stage: "stage" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningItemDirective, decorators: [{
            type: Directive
        }], propDecorators: { entityId: [{
                type: Input
            }], entityNumber: [{
                type: Input
            }], partnerId: [{
                type: Input
            }], allowedProductUPI: [{
                type: Input
            }], prescreeningIdsData: [{
                type: Input
            }], member: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], isTopUp: [{
                type: Input
            }], parentLoanId: [{
                type: Input
            }], parentFacilityCode: [{
                type: Input
            }], flow: [{
                type: Input
            }], stage: [{
                type: Input
            }] } });

class FSWPreScreeningItemComponent extends FSWPreScreeningItemDirective {
    constructor() {
        super();
        this.validating = new EventEmitter();
        this.items = [];
        console.log('prescreeningIdsData', this.prescreeningIdsData);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWPreScreeningItemComponent, isStandalone: true, selector: "fsw-pre-screening-item", inputs: { items: "items" }, outputs: { validating: "validating" }, usesInheritance: true, ngImport: i0, template: `
    <fsw-tabs-group [customRowGap]="'24px'" [customColumnGap]="'24px'">
      <ng-container *ngFor="let item of items">
        <ng-template
          fswTabs
          [key]="item.value"
          [size]="'s'"
          [icon]="isReadonly ? null : 'common-edit'"
          [iconFontSize]="'20px'"
          [maxTextWidth]="'unset'"
          [label]="item.label"
        >
          <ng-container
            fswPreScreeningCriteria
            [id]="item.id || null"
            [title]="'Pre Screening Criteria for ' + (item.label || item.value)"
            [entityId]="entityId"
            [entityNumber]="entityNumber"
            [partnerId]="partnerId"
            [allowedProductUPI]="allowedProductUPI"
            [prescreeningIdsData]="prescreeningIdsData"
            [stage]="stage"
            [flow]="flow"
            [member]="member"
            [isReadonly]="isReadonly"
            [customFilterCallback]="item.customFilterCallback"
            [customPayloadDataCallback]="item.customPayloadDataCallback"
            (validating)="validating.emit([item, $event])"
          ></ng-container>
        </ng-template>
      </ng-container>
    </fsw-tabs-group>
  `, isInline: true, dependencies: [{ kind: "ngmodule", type: FSWTabsModule }, { kind: "component", type: i1$4.FSWTabsGroupComponent, selector: "fsw-tabs-group" }, { kind: "directive", type: i1$4.FSWTabsDirective, selector: "ng-template[fswTabs]" }, { kind: "ngmodule", type: FSWPreScreeningCriteriaModule }, { kind: "directive", type: FSWPreScreeningCriteriaDirective, selector: "[fswPreScreeningCriteria]", inputs: ["id", "title", "entityId", "entityNumber", "partnerId", "allowedProductUPI", "prescreeningIdsData", "flow", "stage", "member", "tradeReferenceNames", "isReadonly", "isTopUp", "parentLoanId", "parentFacilityCode", "customPayloadDataCallback", "customFilterCallback"], outputs: ["validating", "tradeReferenceChange"] }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningItemComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-pre-screening-item',
                    template: `
    <fsw-tabs-group [customRowGap]="'24px'" [customColumnGap]="'24px'">
      <ng-container *ngFor="let item of items">
        <ng-template
          fswTabs
          [key]="item.value"
          [size]="'s'"
          [icon]="isReadonly ? null : 'common-edit'"
          [iconFontSize]="'20px'"
          [maxTextWidth]="'unset'"
          [label]="item.label"
        >
          <ng-container
            fswPreScreeningCriteria
            [id]="item.id || null"
            [title]="'Pre Screening Criteria for ' + (item.label || item.value)"
            [entityId]="entityId"
            [entityNumber]="entityNumber"
            [partnerId]="partnerId"
            [allowedProductUPI]="allowedProductUPI"
            [prescreeningIdsData]="prescreeningIdsData"
            [stage]="stage"
            [flow]="flow"
            [member]="member"
            [isReadonly]="isReadonly"
            [customFilterCallback]="item.customFilterCallback"
            [customPayloadDataCallback]="item.customPayloadDataCallback"
            (validating)="validating.emit([item, $event])"
          ></ng-container>
        </ng-template>
      </ng-container>
    </fsw-tabs-group>
  `,
                    standalone: true,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    imports: [FSWTabsModule, FSWPreScreeningCriteriaModule, NgForOf],
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { validating: [{
                type: Output
            }], items: [{
                type: Input
            }] } });

class FSWPreScreeningRecourseComponent extends FSWPreScreeningItemDirective {
    constructor() {
        super(...arguments);
        this.validating = new EventEmitter();
        this.type = FSWRecourseTypes.PG;
        this.customItemsCallback = (data) => data;
        this.customPayloadDataCallback = (data) => data;
        this.applicationGuarantorService = injectApplicationGuarantorService();
        this.applicationPreScreeningService = injectApplicationPreScreeningService();
        this.creditGuarantorService = injectCreditGuarantorService();
        this.creditPreScreeningService = injectCreditPreScreeningService();
        this.memberService = injectMemberService();
        this.itemsSignal = signal([]);
        this.initSignal = signal(false);
        this.FSWTabsSizes = FSWTabsSizes;
        this.validationMap = new Map();
    }
    ngOnInit() {
        if (!this.entityId || !this.entityNumber || !this.member) {
            return;
        }
        this.loadRecourses();
    }
    loadRecourses() {
        this.applicationGuarantorService
            .getSummaries(this.entityId)
            .pipe(map((summaries) => summaries
            .filter((summary) => summary.guarantor_summary_type === this.type)
            .map((summary) => summary.guarantor_summary_id)), switchMap$1((ids) => {
            if (!ids?.length) {
                return of([]);
            }
            return iif(() => this.type === FSWRecourseTypes.PG, this.creditGuarantorService.getPersonalSummaries(ids).pipe(switchMap$1((summaries) => this.memberService
                .getMergeBipNames(this.entityId, this.member?.uuid, {
                expand: true,
            }, getEntityNoFallBackToUEN(this.member?.company_ctos_entity, this.member?.company_registration_number))
                .pipe(map((bips) => summaries.map((summary) => {
                const bipSummary = bips?.find((bip) => bip.id == summary.id_number);
                return {
                    label: bipSummary?.name || summary.id_number,
                    value: summary.id_number,
                    customFilterCallback: (item) => item.rulify.data.entity_no === summary.id_number,
                    customPayloadDataCallback: (payload) => this.customPayloadDataCallback({
                        ...payload,
                        rulify: {
                            ...payload.rulify,
                            data: {
                                ...payload.rulify.data,
                                entity_no: summary.id_number,
                            },
                        },
                    }),
                };
            }))))), this.creditGuarantorService.getCorporateSummaries(ids).pipe(map((summaries) => (summaries || []).map((summary) => ({
                value: summary.company.registration_no,
                label: summary.company.name || summary.company.registration_no,
                customFilterCallback: (item) => item.rulify.data.entity_no === summary.company.registration_no,
                customPayloadDataCallback: (payload) => this.customPayloadDataCallback({
                    ...payload,
                    rulify: {
                        ...payload.rulify,
                        data: {
                            ...payload.rulify.data,
                            entity_no: summary.company.registration_no,
                        },
                    },
                }),
            })))));
        }), tap((items) => {
            this.itemsSignal.set(this.customItemsCallback(items));
            this.validationMap.clear();
            this.itemsSignal().forEach((item) => {
                this.validationMap.set(item.value, {});
            });
            this.autoValidation();
        }))
            .subscribe();
    }
    validate(id, validation) {
        if (this.validationMap.has(id)) {
            this.validationMap.set(id, {
                ...this.validationMap.get(id),
                ...validation,
            });
        }
        this.assertValidation();
    }
    autoValidation() {
        const items = this.itemsSignal();
        const values = items.map((item) => item.value);
        this.applicationPreScreeningService
            .getPreScreeningId(this.entityId)
            .pipe(switchMap$1((ids) => forkJoin(ids.map((id) => this.creditPreScreeningService.getById(id))).pipe(map((guarantors) => guarantors.filter((guarantor) => guarantor.stage === this.stage &&
            guarantor.identifier ===
                toPreScreeningCriteriaIdentifier({
                    flow: this.flow,
                    stage: this.stage,
                    isTopUp: this.isTopUp,
                    partnerId: this.partnerId,
                    allowedProductUPI: this.allowedProductUPI,
                    prescreeningIdsData: this.prescreeningIdsData,
                }) &&
            values.includes(guarantor.rulify.data.entity_no))), map((items) => items.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())), map((guarantors) => guarantors.reduce((acc, cur) => {
            if (acc.findIndex((item) => item.rulify.data.entity_no === cur.rulify.data.entity_no) === -1) {
                acc.push(cur);
            }
            return acc;
        }, [])))), tap((preScreenings) => {
            preScreenings.forEach((preScreening) => {
                this.validate(preScreening.rulify.data.entity_no, {
                    isScreeningResultPresent: true,
                    areAllFailedJustificationPresent: preScreening.criteria.filter((cri) => cri.result === 'FAIL' && !cri.remark)
                        .length === 0,
                });
                const index = values.indexOf(preScreening.rulify.data.entity_no);
                if (index > -1) {
                    items[index].id = preScreening.id;
                }
            });
            this.itemsSignal.set(items);
        }), finalize(() => this.initSignal.set(true)))
            .subscribe();
    }
    assertValidation() {
        const items = this.itemsSignal();
        this.validating.emit({
            isScreeningResultPresent: items.every((item) => this.validationMap.get(item.value)?.isScreeningResultPresent ?? false),
            areAllFailedJustificationPresent: items.every((item) => this.validationMap.get(item.value)?.areAllFailedJustificationPresent ?? false),
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningRecourseComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWPreScreeningRecourseComponent, isStandalone: true, selector: "fsw-pre-screening-recourse", inputs: { type: "type", customItemsCallback: "customItemsCallback", customPayloadDataCallback: "customPayloadDataCallback" }, outputs: { validating: "validating" }, providers: [
            provideApplicationGuarantorService(),
            provideCreditGuarantorService(),
            provideMemberService(),
            provideApplicationPreScreeningService(),
            provideCreditPreScreeningService(),
        ], usesInheritance: true, ngImport: i0, template: `
    <fsw-pre-screening-item
      *ngIf="initSignal()"
      [items]="itemsSignal()"
      [entityId]="entityId"
      [entityNumber]="entityNumber"
      [partnerId]="partnerId"
      [allowedProductUPI]="allowedProductUPI"
      [prescreeningIdsData]="prescreeningIdsData"
      [flow]="flow"
      [stage]="stage"
      [member]="member"
      [isReadonly]="isReadonly"
      [isTopUp]="isTopUp"
      [parentLoanId]="parentLoanId"
      [parentFacilityCode]="parentFacilityCode"
      (validating)="validate($event[0].value, $event[1])"
    />
  `, isInline: true, dependencies: [{ kind: "component", type: FSWPreScreeningItemComponent, selector: "fsw-pre-screening-item", inputs: ["items"], outputs: ["validating"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningRecourseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-pre-screening-recourse',
                    template: `
    <fsw-pre-screening-item
      *ngIf="initSignal()"
      [items]="itemsSignal()"
      [entityId]="entityId"
      [entityNumber]="entityNumber"
      [partnerId]="partnerId"
      [allowedProductUPI]="allowedProductUPI"
      [prescreeningIdsData]="prescreeningIdsData"
      [flow]="flow"
      [stage]="stage"
      [member]="member"
      [isReadonly]="isReadonly"
      [isTopUp]="isTopUp"
      [parentLoanId]="parentLoanId"
      [parentFacilityCode]="parentFacilityCode"
      (validating)="validate($event[0].value, $event[1])"
    />
  `,
                    standalone: true,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [
                        provideApplicationGuarantorService(),
                        provideCreditGuarantorService(),
                        provideMemberService(),
                        provideApplicationPreScreeningService(),
                        provideCreditPreScreeningService(),
                    ],
                    imports: [FSWPreScreeningItemComponent, NgIf],
                }]
        }], propDecorators: { validating: [{
                type: Output
            }], type: [{
                type: Input
            }], customItemsCallback: [{
                type: Input
            }], customPayloadDataCallback: [{
                type: Input
            }] } });

class FSWPreScreeningBrcComponent extends FSWPreScreeningItemDirective {
    constructor() {
        super(...arguments);
        this.validating = new EventEmitter();
        this.type = FSWRecourseTypes.CG;
        this.customItemsCallback = (data) => {
            return [
                {
                    label: `${this.member?.company_name} (Borrower)`,
                    value: this.member?.company_registration_number,
                    customFilterCallback: (item) => item.rulify.data.entity_no === this.member?.company_registration_number,
                    customPayloadDataCallback: (payload) => ({
                        ...payload,
                        rulify: {
                            ...payload.rulify,
                            data: {
                                ...payload.rulify.data,
                                entity_no: this.member?.company_registration_number,
                            },
                        },
                    }),
                },
                ...data,
            ];
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBrcComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWPreScreeningBrcComponent, isStandalone: true, selector: "fsw-pre-screening-brc", outputs: { validating: "validating" }, usesInheritance: true, ngImport: i0, template: `
    <fsw-pre-screening-recourse
      [entityId]="entityId"
      [entityNumber]="entityNumber"
      [partnerId]="partnerId"
      [allowedProductUPI]="allowedProductUPI"
      [prescreeningIdsData]="prescreeningIdsData"
      [flow]="flow"
      [stage]="stage"
      [member]="member"
      [isReadonly]="isReadonly"
      [isTopUp]="isTopUp"
      [parentLoanId]="parentLoanId"
      [parentFacilityCode]="parentFacilityCode"
      [type]="type"
      [customItemsCallback]="customItemsCallback"
      (validating)="validating.emit($event)"
    />
  `, isInline: true, dependencies: [{ kind: "component", type: FSWPreScreeningRecourseComponent, selector: "fsw-pre-screening-recourse", inputs: ["type", "customItemsCallback", "customPayloadDataCallback"], outputs: ["validating"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBrcComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-pre-screening-brc',
                    template: `
    <fsw-pre-screening-recourse
      [entityId]="entityId"
      [entityNumber]="entityNumber"
      [partnerId]="partnerId"
      [allowedProductUPI]="allowedProductUPI"
      [prescreeningIdsData]="prescreeningIdsData"
      [flow]="flow"
      [stage]="stage"
      [member]="member"
      [isReadonly]="isReadonly"
      [isTopUp]="isTopUp"
      [parentLoanId]="parentLoanId"
      [parentFacilityCode]="parentFacilityCode"
      [type]="type"
      [customItemsCallback]="customItemsCallback"
      (validating)="validating.emit($event)"
    />
  `,
                    standalone: true,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    imports: [FSWPreScreeningRecourseComponent],
                }]
        }], propDecorators: { validating: [{
                type: Output
            }] } });

class FSWPreScreeningBriComponent extends FSWPreScreeningItemDirective {
    constructor() {
        super(...arguments);
        this.validating = new EventEmitter();
        this.type = FSWRecourseTypes.PG;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBriComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWPreScreeningBriComponent, isStandalone: true, selector: "fsw-pre-screening-bri", outputs: { validating: "validating" }, usesInheritance: true, ngImport: i0, template: `
    <fsw-pre-screening-recourse
      [entityId]="entityId"
      [entityNumber]="entityNumber"
      [partnerId]="partnerId"
      [allowedProductUPI]="allowedProductUPI"
      [prescreeningIdsData]="prescreeningIdsData"
      [flow]="flow"
      [stage]="stage"
      [member]="member"
      [isReadonly]="isReadonly"
      [isTopUp]="isTopUp"
      [parentLoanId]="parentLoanId"
      [parentFacilityCode]="parentFacilityCode"
      [type]="type"
      (validating)="validating.emit($event)"
    />
  `, isInline: true, dependencies: [{ kind: "component", type: FSWPreScreeningRecourseComponent, selector: "fsw-pre-screening-recourse", inputs: ["type", "customItemsCallback", "customPayloadDataCallback"], outputs: ["validating"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningBriComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-pre-screening-bri',
                    template: `
    <fsw-pre-screening-recourse
      [entityId]="entityId"
      [entityNumber]="entityNumber"
      [partnerId]="partnerId"
      [allowedProductUPI]="allowedProductUPI"
      [prescreeningIdsData]="prescreeningIdsData"
      [flow]="flow"
      [stage]="stage"
      [member]="member"
      [isReadonly]="isReadonly"
      [isTopUp]="isTopUp"
      [parentLoanId]="parentLoanId"
      [parentFacilityCode]="parentFacilityCode"
      [type]="type"
      (validating)="validating.emit($event)"
    />
  `,
                    standalone: true,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    imports: [FSWPreScreeningRecourseComponent],
                }]
        }], propDecorators: { validating: [{
                type: Output
            }] } });

class FSWPreScreeningCbsComponent extends FSWPreScreeningItemDirective {
    constructor() {
        super(...arguments);
        this.validating = new EventEmitter();
        this.blobService = injectBlobService();
        this.loanService = injectLoanService();
        this.initSignal = signal(false);
        this.docsSignal = signal([]);
        this.type = FSWRecourseTypes.PG;
        this.customPayloadDataCallback = (data) => {
            const document = this.docsSignal().find((doc) => doc.cbs?.parsed_data?.personal_details?.id_number === data.rulify.data.entity_no)?.cbs?.parsed_data;
            return {
                ...data,
                rulify: {
                    ...data.rulify,
                    data: {
                        ...data.rulify.data,
                        ...(document ? { parsed_data: { document } } : {}),
                    },
                },
            };
        };
    }
    ngOnInit() {
        if (!this.member) {
            return;
        }
        this.blobService
            .getMemberDoc(+this.member.id)
            .pipe(map((docs) => (docs || []).filter((doc) => doc.docType === 'CBS')), switchMap((docs) => {
            if (!docs.length) {
                return of([]);
            }
            return this.loanService
                .getParsedCBS(docs.map((doc) => doc.uuid), false)
                .pipe(map((parsedDocs) => docs
                .map((doc) => ({
                info: doc,
                cbs: parsedDocs.find((parsedDoc) => parsedDoc.doc_id === doc.uuid),
            }))
                .sort((a, b) => new Date(b.info.version).getTime() - new Date(a.info.version).getTime())));
        }), tap((docs) => {
            this.docsSignal.set(docs);
            this.initSignal.set(true);
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCbsComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWPreScreeningCbsComponent, isStandalone: true, selector: "fsw-pre-screening-cbs", outputs: { validating: "validating" }, providers: [provideBlobService(), provideLoanService()], usesInheritance: true, ngImport: i0, template: `
    <fsw-pre-screening-recourse
      *ngIf="initSignal()"
      [entityId]="entityId"
      [entityNumber]="entityNumber"
      [partnerId]="partnerId"
      [allowedProductUPI]="allowedProductUPI"
      [prescreeningIdsData]="prescreeningIdsData"
      [flow]="flow"
      [stage]="stage"
      [member]="member"
      [isReadonly]="isReadonly"
      [isTopUp]="isTopUp"
      [parentLoanId]="parentLoanId"
      [parentFacilityCode]="parentFacilityCode"
      [type]="type"
      [customPayloadDataCallback]="customPayloadDataCallback"
      (validating)="validating.emit($event)"
    />
  `, isInline: true, dependencies: [{ kind: "component", type: FSWPreScreeningRecourseComponent, selector: "fsw-pre-screening-recourse", inputs: ["type", "customItemsCallback", "customPayloadDataCallback"], outputs: ["validating"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPreScreeningCbsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-pre-screening-cbs',
                    template: `
    <fsw-pre-screening-recourse
      *ngIf="initSignal()"
      [entityId]="entityId"
      [entityNumber]="entityNumber"
      [partnerId]="partnerId"
      [allowedProductUPI]="allowedProductUPI"
      [prescreeningIdsData]="prescreeningIdsData"
      [flow]="flow"
      [stage]="stage"
      [member]="member"
      [isReadonly]="isReadonly"
      [isTopUp]="isTopUp"
      [parentLoanId]="parentLoanId"
      [parentFacilityCode]="parentFacilityCode"
      [type]="type"
      [customPayloadDataCallback]="customPayloadDataCallback"
      (validating)="validating.emit($event)"
    />
  `,
                    standalone: true,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    imports: [FSWPreScreeningRecourseComponent, NgIf],
                    providers: [provideBlobService(), provideLoanService()],
                }]
        }], propDecorators: { validating: [{
                type: Output
            }] } });

var basic_details = "Basic Details";
var brc = "BRC";
var bri = "BRI";
var cbs = "CBS";
var bank_statement = "Bank Statement";
var preScreeningDetailsAll = {
	basic_details: basic_details,
	brc: brc,
	bri: bri,
	cbs: cbs,
	bank_statement: bank_statement
};

var ALL$6 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    bank_statement: bank_statement,
    basic_details: basic_details,
    brc: brc,
    bri: bri,
    cbs: cbs,
    default: preScreeningDetailsAll
});

const FSW_PRE_SCREENING_DETAILS_TRANSLATION = ALL$6;

function preScreeningDetailsTranslation(scope = 'pre_screening_details') {
    return [
        ...(FSWTranslateModule.forFeature({
            scope,
            defaultKey: getCountryCodeFromStorage() ?? CountryCode.SG,
            data: {
                [CountryCode.SG]: FSW_PRE_SCREENING_DETAILS_TRANSLATION,
                [CountryCode.MY]: FSW_PRE_SCREENING_DETAILS_TRANSLATION,
                [CountryCode.ID]: FSW_PRE_SCREENING_DETAILS_TRANSLATION,
                [CountryCode.VU]: FSW_PRE_SCREENING_DETAILS_TRANSLATION,
                [CountryCode.TH]: FSW_PRE_SCREENING_DETAILS_TRANSLATION,
            },
        }).providers || []),
        fswTranslateScope(scope),
    ];
}

class FSWPrescreeningDetailsComponent {
    constructor() {
        this.validating = new EventEmitter();
        this.entityId = null;
        this.entityNumber = null;
        this.partnerId = null;
        this.allowedProductUPI = null;
        this.prescreeningIdsData = null;
        this.isReadonly = false;
        this.isTopUp = false;
        this.parentLoanId = null;
        this.parentFacilityCode = null;
        this.readonlyConfig = {
            basic_details: false,
            brc: false,
            bri: false,
            cbs: false,
            bank_statement: false,
        };
        this.displayConfig = {
            basic_details: true,
            brc: true,
            bri: true,
            cbs: true,
            bank_statement: true,
        };
        this.stageConfig = {
            basic_details: FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BASIC_DETAILS,
            brc: FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BRC,
            bri: FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BRI,
            cbs: FSWCreditPreScreeningStages.SG_BOLT_SG_MB_CBS,
            bank_statement: FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BANK_STATEMENT,
        };
        this.titleConfig = {
            basic_details: STAGES_DATA['SG-MB'][FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BASIC_DETAILS].name,
            brc: STAGES_DATA['SG-MB'][FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BRC].name,
            bri: STAGES_DATA['SG-MB'][FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BRI].name,
            cbs: STAGES_DATA['SG-MB'][FSWCreditPreScreeningStages.SG_BOLT_SG_MB_CBS].name,
            bank_statement: STAGES_DATA['SG-MB'][FSWCreditPreScreeningStages.SG_BOLT_SG_MB_BANK_STATEMENT].name,
        };
        this.applicationMemberService = injectApplicationMemberService();
        this.initSignal = signal(false);
        this.memberSignal = signal(null);
        this.FSWTabsSizes = FSWTabsSizes;
        this.flow = FSWFlow.MANUAL;
    }
    ngOnInit() {
        if (!this.entityId) {
            return;
        }
        this.applicationMemberService
            .getApplicationMainBorrower(this.entityId)
            .pipe(tap$1((member) => this.memberSignal.set(member)), finalize$1(() => this.initSignal.set(true)) // making sure that this get call even the API success or error
        )
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPrescreeningDetailsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWPrescreeningDetailsComponent, isStandalone: true, selector: "fsw-pre-screening-details", inputs: { entityId: "entityId", entityNumber: "entityNumber", partnerId: "partnerId", allowedProductUPI: "allowedProductUPI", prescreeningIdsData: "prescreeningIdsData", isReadonly: "isReadonly", isTopUp: "isTopUp", parentLoanId: "parentLoanId", parentFacilityCode: "parentFacilityCode", readonlyConfig: "readonlyConfig", displayConfig: "displayConfig", stageConfig: "stageConfig", titleConfig: "titleConfig" }, outputs: { validating: "validating" }, providers: [preScreeningDetailsTranslation(), provideApplicationMemberService()], ngImport: i0, template: "<fsw-tabs-group [customRowGap]=\"'24px'\" [customColumnGap]=\"'24px'\" *ngIf=\"initSignal()\">\n  <!-- Basic Details -->\n  <ng-template\n    fswTabs\n    *ngIf=\"displayConfig.basic_details\"\n    [key]=\"'basic_details'\"\n    [size]=\"FSWTabsSizes.S\"\n    [icon]=\"readonlyConfig.basic_details ? null : 'common-edit'\"\n    [iconFontSize]=\"'20px'\"\n    [maxTextWidth]=\"'unset'\"\n    [label]=\"'basic_details' | fswTranslate : { scope: 'pre_screening_details' }\"\n  >\n    <ng-container\n      fswPreScreeningCriteria\n      [title]=\"titleConfig.basic_details\"\n      [entityId]=\"entityId\"\n      [entityNumber]=\"entityNumber\"\n      [partnerId]=\"partnerId\"\n      [allowedProductUPI]=\"allowedProductUPI\"\n      [prescreeningIdsData]=\"prescreeningIdsData\"\n      [stage]=\"stageConfig.basic_details\"\n      [flow]=\"flow\"\n      [member]=\"memberSignal()\"\n      [isReadonly]=\"readonlyConfig.basic_details\"\n      (validating)=\"validating.emit(['basic_details', $event])\"\n    />\n  </ng-template>\n  <!-- BRC -->\n  <ng-template\n    fswTabs\n    *ngIf=\"displayConfig.brc\"\n    [key]=\"'brc'\"\n    [size]=\"FSWTabsSizes.S\"\n    [icon]=\"readonlyConfig.brc ? null : 'common-edit'\"\n    [iconFontSize]=\"'20px'\"\n    [maxTextWidth]=\"'unset'\"\n    [label]=\"'brc' | fswTranslate : { scope: 'pre_screening_details' }\"\n  >\n    <fsw-pre-screening-brc\n      [entityId]=\"entityId\"\n      [entityNumber]=\"entityNumber\"\n      [partnerId]=\"partnerId\"\n      [allowedProductUPI]=\"allowedProductUPI\"\n      [prescreeningIdsData]=\"prescreeningIdsData\"\n      [flow]=\"flow\"\n      [stage]=\"stageConfig.brc\"\n      [member]=\"memberSignal()\"\n      [isReadonly]=\"readonlyConfig.brc\"\n      [isTopUp]=\"isTopUp\"\n      [parentLoanId]=\"parentLoanId\"\n      [parentFacilityCode]=\"parentFacilityCode\"\n      (validating)=\"validating.emit(['brc', $event])\"\n    />\n  </ng-template>\n  <!-- BRI -->\n  <ng-template\n    fswTabs\n    *ngIf=\"displayConfig.bri\"\n    [key]=\"'bri'\"\n    [icon]=\"readonlyConfig.bri ? null : 'common-edit'\"\n    [iconFontSize]=\"'20px'\"\n    [size]=\"FSWTabsSizes.S\"\n    [maxTextWidth]=\"'unset'\"\n    [label]=\"'bri' | fswTranslate : { scope: 'pre_screening_details' }\"\n  >\n    <fsw-pre-screening-bri\n      [entityId]=\"entityId\"\n      [entityNumber]=\"entityNumber\"\n      [partnerId]=\"partnerId\"\n      [allowedProductUPI]=\"allowedProductUPI\"\n      [prescreeningIdsData]=\"prescreeningIdsData\"\n      [flow]=\"flow\"\n      [stage]=\"stageConfig.bri\"\n      [member]=\"memberSignal()\"\n      [isReadonly]=\"readonlyConfig.bri\"\n      [isTopUp]=\"isTopUp\"\n      [parentLoanId]=\"parentLoanId\"\n      [parentFacilityCode]=\"parentFacilityCode\"\n      (validating)=\"validating.emit(['bri', $event])\"\n    />\n  </ng-template>\n  <!-- CBS -->\n  <ng-template\n    fswTabs\n    *ngIf=\"displayConfig.cbs\"\n    [key]=\"'cbs'\"\n    [icon]=\"readonlyConfig.cbs ? null : 'common-edit'\"\n    [iconFontSize]=\"'20px'\"\n    [size]=\"FSWTabsSizes.S\"\n    [maxTextWidth]=\"'unset'\"\n    [label]=\"'cbs' | fswTranslate : { scope: 'pre_screening_details' }\"\n  >\n    <fsw-pre-screening-cbs\n      [entityId]=\"entityId\"\n      [entityNumber]=\"entityNumber\"\n      [partnerId]=\"partnerId\"\n      [allowedProductUPI]=\"allowedProductUPI\"\n      [prescreeningIdsData]=\"prescreeningIdsData\"\n      [flow]=\"flow\"\n      [stage]=\"stageConfig.cbs\"\n      [member]=\"memberSignal()\"\n      [isReadonly]=\"readonlyConfig.cbs\"\n      [isTopUp]=\"isTopUp\"\n      [parentLoanId]=\"parentLoanId\"\n      [parentFacilityCode]=\"parentFacilityCode\"\n      (validating)=\"validating.emit(['cbs', $event])\"\n    />\n  </ng-template>\n  <!-- Bank Statement -->\n  <ng-template\n    fswTabs\n    *ngIf=\"displayConfig.bank_statement\"\n    [key]=\"'bank_statement'\"\n    [icon]=\"readonlyConfig.bank_statement ? null : 'common-edit'\"\n    [iconFontSize]=\"'20px'\"\n    [size]=\"FSWTabsSizes.S\"\n    [maxTextWidth]=\"'unset'\"\n    [label]=\"'bank_statement' | fswTranslate : { scope: 'pre_screening_details' }\"\n  >\n    <ng-container\n      fswPreScreeningCriteria\n      [title]=\"titleConfig.bank_statement\"\n      [entityId]=\"entityId\"\n      [entityNumber]=\"entityNumber\"\n      [partnerId]=\"partnerId\"\n      [allowedProductUPI]=\"allowedProductUPI\"\n      [prescreeningIdsData]=\"prescreeningIdsData\"\n      [stage]=\"stageConfig.bank_statement\"\n      [flow]=\"flow\"\n      [member]=\"memberSignal()\"\n      [isReadonly]=\"readonlyConfig.bank_statement\"\n      (validating)=\"validating.emit(['bank_statement', $event])\"\n    />\n  </ng-template>\n</fsw-tabs-group>\n", dependencies: [{ kind: "ngmodule", type: FSWTabsModule }, { kind: "component", type: i1$4.FSWTabsGroupComponent, selector: "fsw-tabs-group" }, { kind: "directive", type: i1$4.FSWTabsDirective, selector: "ng-template[fswTabs]" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FSWPreScreeningCriteriaModule }, { kind: "directive", type: FSWPreScreeningCriteriaDirective, selector: "[fswPreScreeningCriteria]", inputs: ["id", "title", "entityId", "entityNumber", "partnerId", "allowedProductUPI", "prescreeningIdsData", "flow", "stage", "member", "tradeReferenceNames", "isReadonly", "isTopUp", "parentLoanId", "parentFacilityCode", "customPayloadDataCallback", "customFilterCallback"], outputs: ["validating", "tradeReferenceChange"] }, { kind: "component", type: FSWPreScreeningBrcComponent, selector: "fsw-pre-screening-brc", outputs: ["validating"] }, { kind: "component", type: FSWPreScreeningBriComponent, selector: "fsw-pre-screening-bri", outputs: ["validating"] }, { kind: "component", type: FSWPreScreeningCbsComponent, selector: "fsw-pre-screening-cbs", outputs: ["validating"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPrescreeningDetailsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-pre-screening-details', standalone: true, changeDetection: ChangeDetectionStrategy.OnPush, providers: [preScreeningDetailsTranslation(), provideApplicationMemberService()], imports: [
                        FSWTabsModule,
                        FSWTranslateModule,
                        NgIf,
                        FSWPreScreeningCriteriaModule,
                        FSWPreScreeningBrcComponent,
                        FSWPreScreeningRecourseComponent,
                        FSWPreScreeningBriComponent,
                        FSWPreScreeningCbsComponent,
                    ], template: "<fsw-tabs-group [customRowGap]=\"'24px'\" [customColumnGap]=\"'24px'\" *ngIf=\"initSignal()\">\n  <!-- Basic Details -->\n  <ng-template\n    fswTabs\n    *ngIf=\"displayConfig.basic_details\"\n    [key]=\"'basic_details'\"\n    [size]=\"FSWTabsSizes.S\"\n    [icon]=\"readonlyConfig.basic_details ? null : 'common-edit'\"\n    [iconFontSize]=\"'20px'\"\n    [maxTextWidth]=\"'unset'\"\n    [label]=\"'basic_details' | fswTranslate : { scope: 'pre_screening_details' }\"\n  >\n    <ng-container\n      fswPreScreeningCriteria\n      [title]=\"titleConfig.basic_details\"\n      [entityId]=\"entityId\"\n      [entityNumber]=\"entityNumber\"\n      [partnerId]=\"partnerId\"\n      [allowedProductUPI]=\"allowedProductUPI\"\n      [prescreeningIdsData]=\"prescreeningIdsData\"\n      [stage]=\"stageConfig.basic_details\"\n      [flow]=\"flow\"\n      [member]=\"memberSignal()\"\n      [isReadonly]=\"readonlyConfig.basic_details\"\n      (validating)=\"validating.emit(['basic_details', $event])\"\n    />\n  </ng-template>\n  <!-- BRC -->\n  <ng-template\n    fswTabs\n    *ngIf=\"displayConfig.brc\"\n    [key]=\"'brc'\"\n    [size]=\"FSWTabsSizes.S\"\n    [icon]=\"readonlyConfig.brc ? null : 'common-edit'\"\n    [iconFontSize]=\"'20px'\"\n    [maxTextWidth]=\"'unset'\"\n    [label]=\"'brc' | fswTranslate : { scope: 'pre_screening_details' }\"\n  >\n    <fsw-pre-screening-brc\n      [entityId]=\"entityId\"\n      [entityNumber]=\"entityNumber\"\n      [partnerId]=\"partnerId\"\n      [allowedProductUPI]=\"allowedProductUPI\"\n      [prescreeningIdsData]=\"prescreeningIdsData\"\n      [flow]=\"flow\"\n      [stage]=\"stageConfig.brc\"\n      [member]=\"memberSignal()\"\n      [isReadonly]=\"readonlyConfig.brc\"\n      [isTopUp]=\"isTopUp\"\n      [parentLoanId]=\"parentLoanId\"\n      [parentFacilityCode]=\"parentFacilityCode\"\n      (validating)=\"validating.emit(['brc', $event])\"\n    />\n  </ng-template>\n  <!-- BRI -->\n  <ng-template\n    fswTabs\n    *ngIf=\"displayConfig.bri\"\n    [key]=\"'bri'\"\n    [icon]=\"readonlyConfig.bri ? null : 'common-edit'\"\n    [iconFontSize]=\"'20px'\"\n    [size]=\"FSWTabsSizes.S\"\n    [maxTextWidth]=\"'unset'\"\n    [label]=\"'bri' | fswTranslate : { scope: 'pre_screening_details' }\"\n  >\n    <fsw-pre-screening-bri\n      [entityId]=\"entityId\"\n      [entityNumber]=\"entityNumber\"\n      [partnerId]=\"partnerId\"\n      [allowedProductUPI]=\"allowedProductUPI\"\n      [prescreeningIdsData]=\"prescreeningIdsData\"\n      [flow]=\"flow\"\n      [stage]=\"stageConfig.bri\"\n      [member]=\"memberSignal()\"\n      [isReadonly]=\"readonlyConfig.bri\"\n      [isTopUp]=\"isTopUp\"\n      [parentLoanId]=\"parentLoanId\"\n      [parentFacilityCode]=\"parentFacilityCode\"\n      (validating)=\"validating.emit(['bri', $event])\"\n    />\n  </ng-template>\n  <!-- CBS -->\n  <ng-template\n    fswTabs\n    *ngIf=\"displayConfig.cbs\"\n    [key]=\"'cbs'\"\n    [icon]=\"readonlyConfig.cbs ? null : 'common-edit'\"\n    [iconFontSize]=\"'20px'\"\n    [size]=\"FSWTabsSizes.S\"\n    [maxTextWidth]=\"'unset'\"\n    [label]=\"'cbs' | fswTranslate : { scope: 'pre_screening_details' }\"\n  >\n    <fsw-pre-screening-cbs\n      [entityId]=\"entityId\"\n      [entityNumber]=\"entityNumber\"\n      [partnerId]=\"partnerId\"\n      [allowedProductUPI]=\"allowedProductUPI\"\n      [prescreeningIdsData]=\"prescreeningIdsData\"\n      [flow]=\"flow\"\n      [stage]=\"stageConfig.cbs\"\n      [member]=\"memberSignal()\"\n      [isReadonly]=\"readonlyConfig.cbs\"\n      [isTopUp]=\"isTopUp\"\n      [parentLoanId]=\"parentLoanId\"\n      [parentFacilityCode]=\"parentFacilityCode\"\n      (validating)=\"validating.emit(['cbs', $event])\"\n    />\n  </ng-template>\n  <!-- Bank Statement -->\n  <ng-template\n    fswTabs\n    *ngIf=\"displayConfig.bank_statement\"\n    [key]=\"'bank_statement'\"\n    [icon]=\"readonlyConfig.bank_statement ? null : 'common-edit'\"\n    [iconFontSize]=\"'20px'\"\n    [size]=\"FSWTabsSizes.S\"\n    [maxTextWidth]=\"'unset'\"\n    [label]=\"'bank_statement' | fswTranslate : { scope: 'pre_screening_details' }\"\n  >\n    <ng-container\n      fswPreScreeningCriteria\n      [title]=\"titleConfig.bank_statement\"\n      [entityId]=\"entityId\"\n      [entityNumber]=\"entityNumber\"\n      [partnerId]=\"partnerId\"\n      [allowedProductUPI]=\"allowedProductUPI\"\n      [prescreeningIdsData]=\"prescreeningIdsData\"\n      [stage]=\"stageConfig.bank_statement\"\n      [flow]=\"flow\"\n      [member]=\"memberSignal()\"\n      [isReadonly]=\"readonlyConfig.bank_statement\"\n      (validating)=\"validating.emit(['bank_statement', $event])\"\n    />\n  </ng-template>\n</fsw-tabs-group>\n" }]
        }], propDecorators: { validating: [{
                type: Output
            }], entityId: [{
                type: Input
            }], entityNumber: [{
                type: Input
            }], partnerId: [{
                type: Input
            }], allowedProductUPI: [{
                type: Input
            }], prescreeningIdsData: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], isTopUp: [{
                type: Input
            }], parentLoanId: [{
                type: Input
            }], parentFacilityCode: [{
                type: Input
            }], readonlyConfig: [{
                type: Input
            }], displayConfig: [{
                type: Input
            }], stageConfig: [{
                type: Input
            }], titleConfig: [{
                type: Input
            }] } });

var FSWPrescreeningDetailsTabs;
(function (FSWPrescreeningDetailsTabs) {
    FSWPrescreeningDetailsTabs["BASIC_DETAILS"] = "basic_details";
    FSWPrescreeningDetailsTabs["BRC"] = "brc";
    FSWPrescreeningDetailsTabs["BRI"] = "bri";
    FSWPrescreeningDetailsTabs["CBS"] = "cbs";
    FSWPrescreeningDetailsTabs["BANK_STATEMENT"] = "bank_statement";
})(FSWPrescreeningDetailsTabs || (FSWPrescreeningDetailsTabs = {}));

var header$5 = {
	title_1: "Product Group List",
	title_2: "Product Group Detail",
	title_3: "Product group - Common settings"
};
var buttons$m = {
	add_product_group: "Add"
};
var product_group_grid$2 = {
	identifier: "Product Group",
	latest_version_setting: "Latest Version"
};
var product_version_grid$2 = {
	version: "Version",
	settings: "Settings",
	settingsJson: "Settings",
	created_by: "Created By",
	created_at: "Created At"
};
var product_group_detail$2 = {
	identifier: "Product Group Identifier",
	latest_version_setting: "Latest Version",
	tabs: {
		settings: "Settings",
		versions: "Versions"
	},
	buttons: {
		save: "Save",
		edit: "Edit"
	},
	error: "Please enter a valid json format."
};
var modals$7 = {
	add_product_group: {
		title: "Add Product Group",
		fields: {
			identifier: {
				label: "Product Group Identifier",
				placeholder: "Enter Product Group Identifier"
			}
		}
	},
	view_settings: {
		title: "View Settings"
	},
	buttons: {
		add: "Add",
		cancel: "Cancel"
	}
};
var my$3 = {
	header: header$5,
	buttons: buttons$m,
	product_group_grid: product_group_grid$2,
	product_version_grid: product_version_grid$2,
	product_group_detail: product_group_detail$2,
	modals: modals$7
};

var my$4 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$m,
    default: my$3,
    header: header$5,
    modals: modals$7,
    product_group_detail: product_group_detail$2,
    product_group_grid: product_group_grid$2,
    product_version_grid: product_version_grid$2
});

var header$4 = {
	title_1: "Product Group List",
	title_2: "Product Group Detail",
	title_3: "Product group - Common settings"
};
var buttons$l = {
	add_product_group: "Add"
};
var product_group_grid$1 = {
	identifier: "Product Group",
	latest_version_setting: "Latest Version"
};
var product_version_grid$1 = {
	version: "Version",
	settings: "Settings",
	settingsJson: "Settings",
	created_by: "Created By",
	created_at: "Created At"
};
var product_group_detail$1 = {
	identifier: "Product Group Identifier",
	latest_version_setting: "Latest Version",
	tabs: {
		settings: "Settings",
		versions: "Versions"
	},
	buttons: {
		save: "Save",
		edit: "Edit"
	},
	error: "Please enter a valid json format."
};
var modals$6 = {
	add_product_group: {
		title: "Add Product Group",
		fields: {
			identifier: {
				label: "Product Group Identifier",
				placeholder: "Enter Product Group Identifier"
			}
		}
	},
	view_settings: {
		title: "View Settings"
	},
	buttons: {
		add: "Add",
		cancel: "Cancel"
	}
};
var vu$2 = {
	header: header$4,
	buttons: buttons$l,
	product_group_grid: product_group_grid$1,
	product_version_grid: product_version_grid$1,
	product_group_detail: product_group_detail$1,
	modals: modals$6
};

var vu$3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$l,
    default: vu$2,
    header: header$4,
    modals: modals$6,
    product_group_detail: product_group_detail$1,
    product_group_grid: product_group_grid$1,
    product_version_grid: product_version_grid$1
});

var header$3 = {
	title_1: "Product Group List",
	title_2: "Product Group Detail",
	title_3: "Product group - Common settings"
};
var buttons$k = {
	add_product_group: "Add"
};
var product_group_grid = {
	identifier: "Product Group",
	latest_version_setting: "Latest Version"
};
var product_version_grid = {
	version: "Version",
	settings: "Settings",
	settingsJson: "Settings",
	created_by: "Created By",
	created_at: "Created At"
};
var product_group_detail = {
	identifier: "Product Group Identifier",
	latest_version_setting: "Latest Version",
	tabs: {
		settings: "Settings",
		versions: "Versions"
	},
	buttons: {
		save: "Save",
		edit: "Edit"
	},
	error: "Please enter a valid json format."
};
var modals$5 = {
	add_product_group: {
		title: "Add Product Group",
		fields: {
			identifier: {
				label: "Product Group Identifier",
				placeholder: "Enter Product Group Identifier"
			}
		}
	},
	view_settings: {
		title: "View Settings"
	},
	buttons: {
		add: "Add",
		cancel: "Cancel"
	}
};
var id$2 = {
	header: header$3,
	buttons: buttons$k,
	product_group_grid: product_group_grid,
	product_version_grid: product_version_grid,
	product_group_detail: product_group_detail,
	modals: modals$5
};

var id$3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$k,
    default: id$2,
    header: header$3,
    modals: modals$5,
    product_group_detail: product_group_detail,
    product_group_grid: product_group_grid,
    product_version_grid: product_version_grid
});

const TRANSLATION_LOADER$1 = {
    default: () => Promise.resolve(my$4),
    [CountryCode.MY]: () => Promise.resolve(my$4),
    [CountryCode.VU]: () => Promise.resolve(vu$3),
    [CountryCode.ID]: () => Promise.resolve(id$3),
};

class ProductGroupCacheService {
    constructor() {
        // selected product group
        this.selectRowSub = new BehaviorSubject(null);
        // product groups
        this.loadGridDataSub = new Subject();
        this.loadGridDataOnSave = new Subject();
    }
    /**
     * Clear cache
     * @memberof ProductGroupCacheService
     * @description Clear cache
     * @example clearCache()
     * @returns void
     */
    clearCache() {
        this.selectRowSub.next(null);
        this.loadGridDataSub.next(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductGroupCacheService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductGroupCacheService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductGroupCacheService, decorators: [{
            type: Injectable
        }] });

const PRODUCT_VERSION_GRID_CONFIG_TOKEN = new InjectionToken('PRODUCT_VERSION_GRID_CONFIG_TOKEN');

var ProductVersionGridFields;
(function (ProductVersionGridFields) {
    ProductVersionGridFields["VERSION"] = "version";
    ProductVersionGridFields["SETTINGS"] = "settingsJson";
    ProductVersionGridFields["CREATED_BY"] = "created_by";
    ProductVersionGridFields["CREATED_AT"] = "created_at";
})(ProductVersionGridFields || (ProductVersionGridFields = {}));

const productVersionGridConfig = {
    setup(defaultGridOptions, translate, rowData) {
        return {
            ...defaultGridOptions,
            rowData,
            columnDefs: [
                {
                    field: ProductVersionGridFields.VERSION,
                    headerName: translate[ProductVersionGridFields.VERSION],
                    width: 130,
                },
                {
                    field: ProductVersionGridFields.SETTINGS,
                    headerName: translate[ProductVersionGridFields.SETTINGS],
                    width: 230,
                    cellClass: 'highlight-on-hover',
                },
                {
                    field: ProductVersionGridFields.CREATED_BY,
                    headerName: translate[ProductVersionGridFields.CREATED_BY],
                    width: 200,
                },
                {
                    field: ProductVersionGridFields.CREATED_AT,
                    headerName: translate[ProductVersionGridFields.CREATED_AT],
                    width: 200,
                },
            ],
        };
    },
};

// @angular
class FSWAddProductGroupComponent {
    constructor(_scope, _translateService, _dialogRef, _fb) {
        this._scope = _scope;
        this._translateService = _translateService;
        this._dialogRef = _dialogRef;
        this._fb = _fb;
        this.modalSize = FSWModalSizes.S;
        this.form = null;
        this._destroy$ = new Subject();
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'modals'),
        ]).pipe(map(([modals]) => ({
            modals,
        })));
    }
    ngOnInit() {
        this.addProductFG = this._fb.group({
            productGroupIdentifier: ['', [Validators.required]],
        });
    }
    ngOnDestroy() {
        if (this._destroy$) {
            this._destroy$.next();
            this._destroy$.complete();
        }
    }
    onConfirm() {
        this._dialogRef.close({
            data: this.addProductFG.value,
        });
    }
    onClose() {
        this._dialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAddProductGroupComponent, deps: [{ token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: i1$7.DialogRef }, { token: i2.FormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWAddProductGroupComponent, selector: "fsw-add-product-group", ngImport: i0, template: `
    <ng-container *ngIf="translate$ | async as translate">
      <fsw-modal
        [title]="translate.modals.add_product_group.title"
        [confirmButton]="translate.modals.buttons.add"
        [cancelButton]="translate.modals.buttons.cancel"
        [size]="modalSize"
        [confirmButtonDisabled]="!addProductFG?.valid"
        (closeEvent)="onClose()"
        (cancelEvent)="onClose()"
        (confirmEvent)="onConfirm()"
      >
        <ng-template fswModalBody>
          <ng-container [formGroup]="addProductFG">
            <section class="flex align-middle w-full">
              <div class="form-control">
                <div class="mb-2 text-gray-700" for="productGroupIdentifier">
                  <span>{{ translate.modals.add_product_group.fields.identifier.label }} </span>
                  <span class="text-red-700">*</span>
                </div>
                <input
                  id="productGroupIdentifier"
                  type="text"
                  class="form-input"
                  formControlName="productGroupIdentifier"
                  [placeholder]="translate.modals.add_product_group.fields.identifier.placeholder"
                />
              </div>
            </section>
          </ng-container>
        </ng-template>
      </fsw-modal>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAddProductGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-add-product-group',
                    template: `
    <ng-container *ngIf="translate$ | async as translate">
      <fsw-modal
        [title]="translate.modals.add_product_group.title"
        [confirmButton]="translate.modals.buttons.add"
        [cancelButton]="translate.modals.buttons.cancel"
        [size]="modalSize"
        [confirmButtonDisabled]="!addProductFG?.valid"
        (closeEvent)="onClose()"
        (cancelEvent)="onClose()"
        (confirmEvent)="onConfirm()"
      >
        <ng-template fswModalBody>
          <ng-container [formGroup]="addProductFG">
            <section class="flex align-middle w-full">
              <div class="form-control">
                <div class="mb-2 text-gray-700" for="productGroupIdentifier">
                  <span>{{ translate.modals.add_product_group.fields.identifier.label }} </span>
                  <span class="text-red-700">*</span>
                </div>
                <input
                  id="productGroupIdentifier"
                  type="text"
                  class="form-input"
                  formControlName="productGroupIdentifier"
                  [placeholder]="translate.modals.add_product_group.fields.identifier.placeholder"
                />
              </div>
            </section>
          </ng-container>
        </ng-template>
      </fsw-modal>
    </ng-container>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: i1$7.DialogRef }, { type: i2.FormBuilder }]; } });

// @angular
class FSWAddProductGroupModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAddProductGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWAddProductGroupModule, declarations: [FSWAddProductGroupComponent], imports: [
            // @angular
            CommonModule,
            ReactiveFormsModule,
            // translate
            TranslocoModule,
            // ngrx
            LetDirective,
            // cdk
            DialogModule,
            CdkTableModule,
            // toolkit-ui
            FSWFieldModule,
            FSWInputModule,
            FSWModalModule$1] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAddProductGroupModule, imports: [
            // @angular
            CommonModule,
            ReactiveFormsModule,
            // translate
            TranslocoModule,
            // cdk
            DialogModule,
            CdkTableModule,
            // toolkit-ui
            FSWFieldModule,
            FSWInputModule,
            FSWModalModule$1] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAddProductGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        // @angular
                        CommonModule,
                        ReactiveFormsModule,
                        // translate
                        TranslocoModule,
                        // ngrx
                        LetDirective,
                        // cdk
                        DialogModule,
                        CdkTableModule,
                        // toolkit-ui
                        FSWFieldModule,
                        FSWInputModule,
                        FSWModalModule$1,
                    ],
                    declarations: [FSWAddProductGroupComponent],
                }]
        }] });

// @angular
// import { IProductGroupCommonSettingVersion, IProductGroupVersion } from '../../../../../shared';
class FSWProductViewSettingsComponent {
    constructor(data, _scope, _translateService, _dialogRef, _fb) {
        this.data = data;
        this._scope = _scope;
        this._translateService = _translateService;
        this._dialogRef = _dialogRef;
        this._fb = _fb;
        this.modalSize = FSWModalSizes.L;
        this.form = null;
        this.options = {
            lineNumbers: true,
            mode: 'json',
            theme: 'material',
            readOnly: true,
        };
        this._destroy$ = new Subject();
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'modals'),
        ]).pipe(map(([modals]) => ({
            modals,
        })));
    }
    ngOnInit() {
        this.viewSettingsFG = this._fb.group({
            settingsJsonContent: JSON.stringify(this.data.isCommonSetting ? this.data.version.setting : this.data.version.settings || {}, null, 2),
        });
    }
    ngOnDestroy() {
        if (this._destroy$) {
            this._destroy$.next();
            this._destroy$.complete();
        }
    }
    onClose() {
        this.viewSettingsFG.setValue({
            settingsJsonContent: null,
        });
        this._dialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductViewSettingsComponent, deps: [{ token: DIALOG_DATA }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: i1$7.DialogRef }, { token: i2.FormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWProductViewSettingsComponent, selector: "fsw-product-view-settings", ngImport: i0, template: `
    <ng-container [formGroup]="viewSettingsFG" *ngIf="translate$ | async as translate">
      <fsw-modal
        [title]="translate.modals.view_settings.title"
        [cancelButton]="translate.modals.buttons.cancel"
        [size]="modalSize"
        (closeEvent)="onClose()"
        (cancelEvent)="onClose()"
      >
        <ng-template fswModalBody>
          <ngx-codemirror
            formControlName="settingsJsonContent"
            [options]="options"
          ></ngx-codemirror>
        </ng-template>
      </fsw-modal>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "component", type: i6$2.CodemirrorComponent, selector: "ngx-codemirror", inputs: ["className", "name", "autoFocus", "options", "preserveScrollPosition"], outputs: ["cursorActivity", "focusChange", "scroll", "drop"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductViewSettingsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-product-view-settings',
                    template: `
    <ng-container [formGroup]="viewSettingsFG" *ngIf="translate$ | async as translate">
      <fsw-modal
        [title]="translate.modals.view_settings.title"
        [cancelButton]="translate.modals.buttons.cancel"
        [size]="modalSize"
        (closeEvent)="onClose()"
        (cancelEvent)="onClose()"
      >
        <ng-template fswModalBody>
          <ngx-codemirror
            formControlName="settingsJsonContent"
            [options]="options"
          ></ngx-codemirror>
        </ng-template>
      </fsw-modal>
    </ng-container>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DIALOG_DATA]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: i1$7.DialogRef }, { type: i2.FormBuilder }]; } });

// @angular
class FSWProductViewSettingsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductViewSettingsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWProductViewSettingsModule, declarations: [FSWProductViewSettingsComponent], imports: [
            // @angular
            CommonModule,
            ReactiveFormsModule,
            // translate
            TranslocoModule,
            // ngrx
            LetDirective,
            // cdk
            DialogModule,
            CdkTableModule,
            // toolkit-ui
            FSWFieldModule,
            FSWInputModule,
            FSWModalModule$1,
            // json-viewer
            CodemirrorModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductViewSettingsModule, imports: [
            // @angular
            CommonModule,
            ReactiveFormsModule,
            // translate
            TranslocoModule,
            // cdk
            DialogModule,
            CdkTableModule,
            // toolkit-ui
            FSWFieldModule,
            FSWInputModule,
            FSWModalModule$1,
            // json-viewer
            CodemirrorModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductViewSettingsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        // @angular
                        CommonModule,
                        ReactiveFormsModule,
                        // translate
                        TranslocoModule,
                        // ngrx
                        LetDirective,
                        // cdk
                        DialogModule,
                        CdkTableModule,
                        // toolkit-ui
                        FSWFieldModule,
                        FSWInputModule,
                        FSWModalModule$1,
                        // json-viewer
                        CodemirrorModule,
                    ],
                    declarations: [FSWProductViewSettingsComponent],
                }]
        }] });

// @angular
class FSWProductVersionGridComponent {
    constructor(_gridConfig, _translateService, _scope, _productGroupService, _productGroupCacheService, _cdr, _cdkDialog, _injector) {
        this._gridConfig = _gridConfig;
        this._translateService = _translateService;
        this._scope = _scope;
        this._productGroupService = _productGroupService;
        this._productGroupCacheService = _productGroupCacheService;
        this._cdr = _cdr;
        this._cdkDialog = _cdkDialog;
        this._injector = _injector;
        this.isCommonSetting = false;
        this.selectRow = new EventEmitter();
        this._destroySubject = new Subject();
        this._gridOptions = {
            rowSelection: 'single',
            headerHeight: 36,
            rowHeight: 36,
            pagination: true,
            paginationPageSize: 10,
            cacheBlockSize: 10,
            overlayNoRowsTemplate: `
			<div style="color: #757575; padding-top: 40px;">
				<div>No Application Product Groups are available.</div>
			</div>
		`,
            rowData: [],
            onCellClicked: (event) => {
                if (!event || !event.column || !event.column || !event.data) {
                    return;
                }
                const colId = event.column.getColId();
                if (colId === ProductVersionGridFields.SETTINGS) {
                    this.onViewSettings(event.data);
                }
            },
            onGridReady: (event) => {
                this._gridApi = event.api;
            },
        };
    }
    ngOnInit() {
        if (this.isCommonSetting) {
            combineLatest([
                this._translateService.selectFeatureTranslate(this._scope, 'product_version_grid'),
                this._productGroupService.getProductGroupCommonSettingVersions(),
            ])
                .pipe(switchMap(([columns, productGroupVersions]) => this._initGridOptions(columns, productGroupVersions)))
                .subscribe((productGroupVersions) => this._setRowData(productGroupVersions), (err) => console.error(err));
        }
        else {
            this._productGroupCacheService.selectRowSub
                .pipe(takeUntil(this._destroySubject), switchMap((productGroup) => {
                if (!productGroup?.identifier)
                    return of(null);
                return combineLatest([
                    this._translateService.selectFeatureTranslate(this._scope, 'product_version_grid'),
                    this._productGroupService.getProductGroupVersions(productGroup?.identifier).pipe(catchError((err) => {
                        console.error(err);
                        return of([]);
                    })),
                ]).pipe(switchMap(([columns, productGroupVersions]) => this._initGridOptions(columns, productGroupVersions)));
            }))
                .subscribe((productGroupVersions) => this._setRowData(productGroupVersions), (err) => console.error(err));
        }
    }
    ngOnDestroy() {
        this._destroySubject.next(0);
        this._destroySubject.complete();
    }
    onViewSettings(version) {
        this._cdkDialog
            .open(FSWProductViewSettingsComponent, {
            data: {
                version: {
                    ...version,
                },
                isCommonSetting: this.isCommonSetting,
            },
            injector: this._injector,
        })
            .closed.pipe(take(1))
            .subscribe();
    }
    _setupGridOptions(columns, productGroups) {
        return of(this._gridConfig.setup(this._gridOptions, columns, productGroups));
    }
    _initGridOptions(columns, productGroupVersions) {
        this.gridOptions$ = this._setupGridOptions(columns, productGroupVersions.sort((a, b) => b.version - a.version));
        return of(productGroupVersions);
    }
    _setRowData(gridData) {
        if (!gridData?.length)
            return;
        const rowData = gridData
            .map((p) => ({
            ...p,
        }))
            .sort((a, b) => b.version - a.version);
        this._gridApi && this._gridApi.setGridOption('rowData', rowData || []);
        this._cdr.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductVersionGridComponent, deps: [{ token: PRODUCT_VERSION_GRID_CONFIG_TOKEN }, { token: TranslocoFeatureHttpLoader }, { token: TRANSLOCO_SCOPE }, { token: PRODUCT_GROUP_SERVICE_TOKEN }, { token: ProductGroupCacheService }, { token: i0.ChangeDetectorRef }, { token: i1$7.Dialog }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWProductVersionGridComponent, selector: "fsw-product-version-grid", inputs: { isCommonSetting: "isCommonSetting" }, outputs: { selectRow: "selectRow" }, ngImport: i0, template: `
    <ng-container *ngIf="gridOptions$ | async as gridOptions">
      <fsw-grid [gridOptions]="gridOptions" [gridContainerHeight]="300"></fsw-grid>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FSWGridComponent, selector: "fsw-grid", inputs: ["gridOptions", "actionClickedCheck", "rowData", "gridContainerHeight"], outputs: ["rowClicked"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductVersionGridComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-product-version-grid',
                    template: `
    <ng-container *ngIf="gridOptions$ | async as gridOptions">
      <fsw-grid [gridOptions]="gridOptions" [gridContainerHeight]="300"></fsw-grid>
    </ng-container>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [PRODUCT_VERSION_GRID_CONFIG_TOKEN]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PRODUCT_GROUP_SERVICE_TOKEN]
                }] }, { type: ProductGroupCacheService }, { type: i0.ChangeDetectorRef }, { type: i1$7.Dialog }, { type: i0.Injector }]; }, propDecorators: { isCommonSetting: [{
                type: Input
            }], selectRow: [{
                type: Output
            }] } });

// @angular
class FSWProductGroupDetailComponent {
    set isReadonly(value) {
        this._isReadonly = value;
        this._cdr.detectChanges();
    }
    get isReadonly() {
        return this._isReadonly;
    }
    constructor(_scope, _translateService, _productGroupService, productGroupCacheService, _fb, _cdr) {
        this._scope = _scope;
        this._translateService = _translateService;
        this._productGroupService = _productGroupService;
        this.productGroupCacheService = productGroupCacheService;
        this._fb = _fb;
        this._cdr = _cdr;
        this.isCommonSetting = false;
        this._isReadonly = true;
        this._destroyedSubject = new Subject();
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'header'),
            this._translateService.selectFeatureTranslate(this._scope, 'product_group_detail'),
        ]).pipe(map(([header, product_group_detail]) => ({
            header,
            product_group_detail,
        })));
        this.options = {
            lineNumbers: true,
            mode: 'json',
            theme: 'material',
            readOnly: false,
        };
        this.isProductDetailJsonValid = true;
        this.isEditable = false;
        this.productGroupDetailFG = this._fb.group({
            identifier: [''],
            productJsonContent: JSON.stringify({}, null, 2),
        });
    }
    ngOnInit() {
        if (this.isCommonSetting) {
            this._productGroupService
                .getProductGroupCommonSetting()
                .pipe(takeUntil(this._destroyedSubject))
                .subscribe((setting) => {
                this.productCommonSetting = setting;
                this.productGroupDetailFG.patchValue({
                    identifier: setting.id,
                    productJsonContent: JSON.stringify(setting.latest_setting, null, 2),
                });
                this._cdr.detectChanges();
            });
        }
        else {
            this.productGroupCacheService.selectRowSub
                .pipe(takeUntil(this._destroyedSubject))
                .subscribe((res) => {
                if (!res)
                    return;
                this.productGroupDetailFG.patchValue({
                    identifier: res.identifier,
                    productJsonContent: JSON.stringify(res.settings, null, 2),
                });
            });
        }
        this.isProductDetailJsonValid = isValidJSON(this.productGroupDetailFG.value.productJsonContent);
        this.productGroupDetailFG.valueChanges.subscribe((res) => {
            this.isProductDetailJsonValid = isValidJSON(res.productJsonContent);
            this._cdr.detectChanges();
        });
    }
    ngOnDestroy() {
        this._destroyedSubject.next();
        this._destroyedSubject.complete();
    }
    onSave(selectedProductGroup) {
        if (this.isCommonSetting) {
            this._productGroupService
                .updateProductGroupCommonSetting({
                setting: JSON.parse(this.productGroupDetailFG.value.productJsonContent),
            })
                .pipe(takeUntil(this._destroyedSubject), switchMap(() => this._productGroupService.getProductGroupCommonSetting()))
                .subscribe((setting) => {
                this.productCommonSetting = setting;
                this.productGroupDetailFG.patchValue({
                    identifier: setting.id,
                    productJsonContent: JSON.stringify(setting.latest_setting, null, 2),
                });
                this.options = {
                    ...this.options,
                    readOnly: true,
                };
                this.isEditable = true;
                this._cdr.detectChanges();
            }, (err) => console.error(err));
        }
        else {
            this._productGroupService
                .updateProductGroup(this.productGroupDetailFG.value.identifier, {
                setting: JSON.parse(this.productGroupDetailFG.value.productJsonContent),
            })
                .pipe(takeUntil(this._destroyedSubject), tap(() => {
                this.options = {
                    ...this.options,
                    readOnly: true,
                };
                this.isEditable = true;
            }), switchMap(() => this._productGroupService.getProductGroups()))
                .subscribe((res) => {
                if (!res)
                    return;
                this.productGroupCacheService.loadGridDataOnSave.next({
                    productGroups: res,
                    prodIndex: res.findIndex((r) => r.id === selectedProductGroup?.id) || 0,
                });
                this._cdr.detectChanges();
            });
        }
    }
    onEdit() {
        this.isEditable = !this.isEditable;
        this.options = {
            ...this.options,
            readOnly: false,
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductGroupDetailComponent, deps: [{ token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: PRODUCT_GROUP_SERVICE_TOKEN }, { token: ProductGroupCacheService }, { token: i2.FormBuilder }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWProductGroupDetailComponent, selector: "fsw-product-group-detail", inputs: { isCommonSetting: "isCommonSetting", isReadonly: "isReadonly" }, providers: [
            {
                provide: TRANSLOCO_SCOPE,
                useValue: {
                    scope: 'product-group-detail',
                    loader: TRANSLATION_LOADER$1,
                },
            },
            {
                provide: TranslocoFeatureHttpLoader,
                useClass: TranslocoFeatureHttpLoader,
            },
        ], ngImport: i0, template: "<ng-container\n  [formGroup]=\"productGroupDetailFG\"\n  *ngIf=\"\n    !isCommonSetting && (productGroupCacheService.selectRowSub | async) as selectedProductGroup\n  \"\n>\n  <section *ngIf=\"translate$ | async as translate\">\n    <div class=\"flex justify-between mb-4\">\n      <header>\n        <h6>{{ translate.header.title_2 }}</h6>\n      </header>\n    </div>\n    <section>\n      <div>\n        <span>{{ translate.product_group_detail.identifier }} : </span>\n        <span\n          ><b>{{ selectedProductGroup?.identifier }}</b></span\n        >\n      </div>\n      <div>\n        <span>{{ translate.product_group_detail.latest_version_setting }} : </span>\n        <span\n          ><b>{{ selectedProductGroup?.latest_version_setting }}</b></span\n        >\n      </div>\n    </section>\n    <section>\n      <fsw-tabs-group [customRowGap]=\"'24px'\" [customColumnGap]=\"'24px'\">\n        <ng-template\n          fswTabs\n          [key]=\"'ap'\"\n          [maxTextWidth]=\"'unset'\"\n          [label]=\"translate.product_group_detail.tabs.settings\"\n        >\n          <header class=\"flex mt-2 mb-2 justify-between\" *ngIf=\"isEditable\">\n            <div></div>\n            <button *ngIf=\"!isReadonly\" fswButton [size]=\"'s'\" (click)=\"onEdit()\">\n              {{ translate.product_group_detail.buttons.edit }}\n            </button>\n          </header>\n          <ngx-codemirror formControlName=\"productJsonContent\" [options]=\"options\"></ngx-codemirror>\n        </ng-template>\n        <ng-template\n          fswTabs\n          [key]=\"'ar'\"\n          [maxTextWidth]=\"'unset'\"\n          [label]=\"translate.product_group_detail.tabs.versions\"\n        >\n          <div style=\"min-height: 300px\"><fsw-product-version-grid></fsw-product-version-grid></div>\n        </ng-template>\n      </fsw-tabs-group>\n    </section>\n    <footer class=\"flex mt-4 justify-between\">\n      <div *ngIf=\"isProductDetailJsonValid\"></div>\n      <div\n        *ngIf=\"!isProductDetailJsonValid\"\n        class=\"bg-red-100 border border-red-300 text-red-600 px-4 py-3 rounded relative\"\n        role=\"alert\"\n      >\n        <span>{{ isProductDetailJsonValid ? '' : translate.product_group_detail.error }}</span>\n      </div>\n      <button\n        fswButton\n        [size]=\"'s'\"\n        [disabled]=\"!isProductDetailJsonValid\"\n        *ngIf=\"!isEditable && !isReadonly\"\n        (click)=\"onSave(selectedProductGroup)\"\n      >\n        {{ translate.product_group_detail.buttons.save }}\n      </button>\n    </footer>\n  </section>\n</ng-container>\n\n<ng-container [formGroup]=\"productGroupDetailFG\" *ngIf=\"isCommonSetting\">\n  <section *ngIf=\"translate$ | async as translate\">\n    <div class=\"flex justify-between mb-4\">\n      <header>\n        <h6>{{ translate.header.title_3 }}</h6>\n      </header>\n    </div>\n    <section>\n      <div></div>\n      <div>\n        <span>{{ translate.product_group_detail.latest_version_setting }} : </span>\n        <span\n          ><b>{{ productCommonSetting?.latest_version }}</b></span\n        >\n      </div>\n    </section>\n    <section>\n      <fsw-tabs-group [customRowGap]=\"'24px'\" [customColumnGap]=\"'24px'\">\n        <ng-template\n          fswTabs\n          [key]=\"'ap'\"\n          [maxTextWidth]=\"'unset'\"\n          [label]=\"translate.product_group_detail.tabs.settings\"\n        >\n          <header class=\"flex mt-2 mb-2 justify-between\" *ngIf=\"isEditable\">\n            <div></div>\n            <button *ngIf=\"!isReadonly\" fswButton [size]=\"'s'\" (click)=\"onEdit()\">\n              {{ translate.product_group_detail.buttons.edit }}\n            </button>\n          </header>\n          <ngx-codemirror formControlName=\"productJsonContent\" [options]=\"options\"></ngx-codemirror>\n        </ng-template>\n        <ng-template\n          fswTabs\n          [key]=\"'ar'\"\n          [maxTextWidth]=\"'unset'\"\n          [label]=\"translate.product_group_detail.tabs.versions\"\n        >\n          <div style=\"min-height: 300px\">\n            <fsw-product-version-grid [isCommonSetting]=\"true\"></fsw-product-version-grid>\n          </div>\n        </ng-template>\n      </fsw-tabs-group>\n    </section>\n    <footer class=\"flex mt-4 justify-between\">\n      <div *ngIf=\"isProductDetailJsonValid\"></div>\n      <div\n        *ngIf=\"!isProductDetailJsonValid\"\n        class=\"bg-red-100 border border-red-300 text-red-600 px-4 py-3 rounded relative\"\n        role=\"alert\"\n      >\n        <span>{{ isProductDetailJsonValid ? '' : translate.product_group_detail.error }}</span>\n      </div>\n      <button\n        fswButton\n        [size]=\"'s'\"\n        [disabled]=\"!isProductDetailJsonValid\"\n        *ngIf=\"!isEditable && !isReadonly\"\n        (click)=\"onSave()\"\n      >\n        {{ translate.product_group_detail.buttons.save }}\n      </button>\n    </footer>\n  </section>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: FSWProductVersionGridComponent, selector: "fsw-product-version-grid", inputs: ["isCommonSetting"], outputs: ["selectRow"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "component", type: i1$4.FSWTabsGroupComponent, selector: "fsw-tabs-group" }, { kind: "directive", type: i1$4.FSWTabsDirective, selector: "ng-template[fswTabs]" }, { kind: "component", type: i6$2.CodemirrorComponent, selector: "ngx-codemirror", inputs: ["className", "name", "autoFocus", "options", "preserveScrollPosition"], outputs: ["cursorActivity", "focusChange", "scroll", "drop"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductGroupDetailComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-product-group-detail', changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        {
                            provide: TRANSLOCO_SCOPE,
                            useValue: {
                                scope: 'product-group-detail',
                                loader: TRANSLATION_LOADER$1,
                            },
                        },
                        {
                            provide: TranslocoFeatureHttpLoader,
                            useClass: TranslocoFeatureHttpLoader,
                        },
                    ], template: "<ng-container\n  [formGroup]=\"productGroupDetailFG\"\n  *ngIf=\"\n    !isCommonSetting && (productGroupCacheService.selectRowSub | async) as selectedProductGroup\n  \"\n>\n  <section *ngIf=\"translate$ | async as translate\">\n    <div class=\"flex justify-between mb-4\">\n      <header>\n        <h6>{{ translate.header.title_2 }}</h6>\n      </header>\n    </div>\n    <section>\n      <div>\n        <span>{{ translate.product_group_detail.identifier }} : </span>\n        <span\n          ><b>{{ selectedProductGroup?.identifier }}</b></span\n        >\n      </div>\n      <div>\n        <span>{{ translate.product_group_detail.latest_version_setting }} : </span>\n        <span\n          ><b>{{ selectedProductGroup?.latest_version_setting }}</b></span\n        >\n      </div>\n    </section>\n    <section>\n      <fsw-tabs-group [customRowGap]=\"'24px'\" [customColumnGap]=\"'24px'\">\n        <ng-template\n          fswTabs\n          [key]=\"'ap'\"\n          [maxTextWidth]=\"'unset'\"\n          [label]=\"translate.product_group_detail.tabs.settings\"\n        >\n          <header class=\"flex mt-2 mb-2 justify-between\" *ngIf=\"isEditable\">\n            <div></div>\n            <button *ngIf=\"!isReadonly\" fswButton [size]=\"'s'\" (click)=\"onEdit()\">\n              {{ translate.product_group_detail.buttons.edit }}\n            </button>\n          </header>\n          <ngx-codemirror formControlName=\"productJsonContent\" [options]=\"options\"></ngx-codemirror>\n        </ng-template>\n        <ng-template\n          fswTabs\n          [key]=\"'ar'\"\n          [maxTextWidth]=\"'unset'\"\n          [label]=\"translate.product_group_detail.tabs.versions\"\n        >\n          <div style=\"min-height: 300px\"><fsw-product-version-grid></fsw-product-version-grid></div>\n        </ng-template>\n      </fsw-tabs-group>\n    </section>\n    <footer class=\"flex mt-4 justify-between\">\n      <div *ngIf=\"isProductDetailJsonValid\"></div>\n      <div\n        *ngIf=\"!isProductDetailJsonValid\"\n        class=\"bg-red-100 border border-red-300 text-red-600 px-4 py-3 rounded relative\"\n        role=\"alert\"\n      >\n        <span>{{ isProductDetailJsonValid ? '' : translate.product_group_detail.error }}</span>\n      </div>\n      <button\n        fswButton\n        [size]=\"'s'\"\n        [disabled]=\"!isProductDetailJsonValid\"\n        *ngIf=\"!isEditable && !isReadonly\"\n        (click)=\"onSave(selectedProductGroup)\"\n      >\n        {{ translate.product_group_detail.buttons.save }}\n      </button>\n    </footer>\n  </section>\n</ng-container>\n\n<ng-container [formGroup]=\"productGroupDetailFG\" *ngIf=\"isCommonSetting\">\n  <section *ngIf=\"translate$ | async as translate\">\n    <div class=\"flex justify-between mb-4\">\n      <header>\n        <h6>{{ translate.header.title_3 }}</h6>\n      </header>\n    </div>\n    <section>\n      <div></div>\n      <div>\n        <span>{{ translate.product_group_detail.latest_version_setting }} : </span>\n        <span\n          ><b>{{ productCommonSetting?.latest_version }}</b></span\n        >\n      </div>\n    </section>\n    <section>\n      <fsw-tabs-group [customRowGap]=\"'24px'\" [customColumnGap]=\"'24px'\">\n        <ng-template\n          fswTabs\n          [key]=\"'ap'\"\n          [maxTextWidth]=\"'unset'\"\n          [label]=\"translate.product_group_detail.tabs.settings\"\n        >\n          <header class=\"flex mt-2 mb-2 justify-between\" *ngIf=\"isEditable\">\n            <div></div>\n            <button *ngIf=\"!isReadonly\" fswButton [size]=\"'s'\" (click)=\"onEdit()\">\n              {{ translate.product_group_detail.buttons.edit }}\n            </button>\n          </header>\n          <ngx-codemirror formControlName=\"productJsonContent\" [options]=\"options\"></ngx-codemirror>\n        </ng-template>\n        <ng-template\n          fswTabs\n          [key]=\"'ar'\"\n          [maxTextWidth]=\"'unset'\"\n          [label]=\"translate.product_group_detail.tabs.versions\"\n        >\n          <div style=\"min-height: 300px\">\n            <fsw-product-version-grid [isCommonSetting]=\"true\"></fsw-product-version-grid>\n          </div>\n        </ng-template>\n      </fsw-tabs-group>\n    </section>\n    <footer class=\"flex mt-4 justify-between\">\n      <div *ngIf=\"isProductDetailJsonValid\"></div>\n      <div\n        *ngIf=\"!isProductDetailJsonValid\"\n        class=\"bg-red-100 border border-red-300 text-red-600 px-4 py-3 rounded relative\"\n        role=\"alert\"\n      >\n        <span>{{ isProductDetailJsonValid ? '' : translate.product_group_detail.error }}</span>\n      </div>\n      <button\n        fswButton\n        [size]=\"'s'\"\n        [disabled]=\"!isProductDetailJsonValid\"\n        *ngIf=\"!isEditable && !isReadonly\"\n        (click)=\"onSave()\"\n      >\n        {{ translate.product_group_detail.buttons.save }}\n      </button>\n    </footer>\n  </section>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PRODUCT_GROUP_SERVICE_TOKEN]
                }] }, { type: ProductGroupCacheService }, { type: i2.FormBuilder }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { isCommonSetting: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

const PRODUCT_LIST_GRID_CONFIG_TOKEN = new InjectionToken('PRODUCT_LIST_GRID_CONFIG_TOKEN');

var ProductListGridFields;
(function (ProductListGridFields) {
    ProductListGridFields["IDENTIFIER"] = "identifier";
    ProductListGridFields["LATEST_VERSION_SETTING"] = "latest_version_setting";
})(ProductListGridFields || (ProductListGridFields = {}));

const productListGridConfig = {
    setup(defaultGridOptions, translate, rowData) {
        return {
            ...defaultGridOptions,
            rowData,
            columnDefs: [
                {
                    field: ProductListGridFields.IDENTIFIER,
                    headerName: translate[ProductListGridFields.IDENTIFIER],
                    width: 180,
                },
                {
                    field: ProductListGridFields.LATEST_VERSION_SETTING,
                    headerName: translate[ProductListGridFields.LATEST_VERSION_SETTING],
                    width: 180,
                },
            ],
        };
    },
};

// @angular
class FSWProductListGridComponent {
    constructor(_gridConfig, _translateService, _scope, _productGroupService, _productGroupCacheService, _cdr) {
        this._gridConfig = _gridConfig;
        this._translateService = _translateService;
        this._scope = _scope;
        this._productGroupService = _productGroupService;
        this._productGroupCacheService = _productGroupCacheService;
        this._cdr = _cdr;
        this.selectRow = new EventEmitter();
        this._destroySubject = new Subject();
        this._gridOptions = {
            rowSelection: 'single',
            headerHeight: 36,
            rowHeight: 36,
            pagination: true,
            paginationPageSize: 10,
            cacheBlockSize: 10,
            overlayNoRowsTemplate: `
			<div style="color: #757575; padding-top: 40px;">
				<div>No Application Product Groups are available.</div>
			</div>
		`,
            rowData: [],
            onRowClicked: (event) => {
                this.selectRow.emit({ res: event?.data });
                if (event?.node)
                    event.node.setSelected(!event.node.isSelected());
            },
            onGridReady: (event) => {
                this._gridApi = event.api;
                this._gridApi?.forEachNode((node, index) => {
                    if (index === 0) {
                        node.setSelected(true);
                    }
                });
            },
        };
    }
    ngOnInit() {
        this.gridOptions$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'product_group_grid'),
            this._productGroupService.getProductGroups().pipe(catchError((err) => {
                console.error(err);
                return of([]);
            })),
        ]).pipe(takeUntil(this._destroySubject), switchMap(([columns, productGroups]) => {
            this._productGroupCacheService.selectRowSub.next(productGroups[0]);
            return this._setupGridOptions(columns, productGroups);
        }));
        this._productGroupCacheService.loadGridDataSub
            .pipe(takeUntil(this._destroySubject))
            .subscribe((productGroups) => {
            if (productGroups?.length) {
                this._gridApi && this._gridApi.setGridOption('rowData', productGroups || []);
                this._gridApi?.paginationGoToLastPage();
                this._gridApi?.forEachNode((node, index) => {
                    if (index === productGroups.length - 1) {
                        node.setSelected(true);
                    }
                });
                this._productGroupCacheService.selectRowSub.next(productGroups[productGroups.length - 1]);
            }
            else {
                this._gridApi && this._gridApi.setGridOption('rowData', []);
            }
            this._cdr.detectChanges();
        });
        this._productGroupCacheService.loadGridDataOnSave
            .pipe(takeUntil(this._destroySubject))
            .subscribe(({ productGroups, prodIndex }) => {
            if (productGroups?.length) {
                this._gridApi && this._gridApi.setGridOption('rowData', productGroups || []);
                this._gridApi?.forEachNode((node, index) => {
                    if (index === prodIndex) {
                        node.setSelected(true);
                    }
                });
                this._productGroupCacheService.selectRowSub.next(productGroups[prodIndex]);
            }
            else {
                this._gridApi && this._gridApi.setGridOption('rowData', []);
            }
            this._cdr.detectChanges();
        });
    }
    ngOnDestroy() {
        this._destroySubject.next(0);
        this._destroySubject.complete();
    }
    _setupGridOptions(columns, productGroups) {
        return of(this._gridConfig.setup(this._gridOptions, columns, productGroups));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductListGridComponent, deps: [{ token: PRODUCT_LIST_GRID_CONFIG_TOKEN }, { token: TranslocoFeatureHttpLoader }, { token: TRANSLOCO_SCOPE }, { token: PRODUCT_GROUP_SERVICE_TOKEN }, { token: ProductGroupCacheService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWProductListGridComponent, selector: "fsw-product-list-grid", outputs: { selectRow: "selectRow" }, ngImport: i0, template: `
    <ng-container *ngIf="gridOptions$ | async as gridOptions">
      <fsw-grid [gridOptions]="gridOptions" [gridContainerHeight]="450"></fsw-grid>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FSWGridComponent, selector: "fsw-grid", inputs: ["gridOptions", "actionClickedCheck", "rowData", "gridContainerHeight"], outputs: ["rowClicked"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductListGridComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-product-list-grid',
                    template: `
    <ng-container *ngIf="gridOptions$ | async as gridOptions">
      <fsw-grid [gridOptions]="gridOptions" [gridContainerHeight]="450"></fsw-grid>
    </ng-container>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [PRODUCT_LIST_GRID_CONFIG_TOKEN]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PRODUCT_GROUP_SERVICE_TOKEN]
                }] }, { type: ProductGroupCacheService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { selectRow: [{
                type: Output
            }] } });

class FSWProductListGridModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductListGridModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWProductListGridModule, declarations: [FSWProductListGridComponent], imports: [CommonModule,
            // ngrx
            LetDirective,
            // translate
            TranslocoModule,
            // grids
            FSWGridModule,
            HttpClientBaseServiceModule,
            // services
            ProductGroupServiceModule], exports: [FSWProductListGridComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductListGridModule, imports: [CommonModule,
            // translate
            TranslocoModule,
            // grids
            FSWGridModule,
            HttpClientBaseServiceModule,
            // services
            ProductGroupServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductListGridModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        // ngrx
                        LetDirective,
                        // translate
                        TranslocoModule,
                        // grids
                        FSWGridModule,
                        HttpClientBaseServiceModule,
                        // services
                        ProductGroupServiceModule,
                    ],
                    declarations: [FSWProductListGridComponent],
                    exports: [FSWProductListGridComponent],
                }]
        }] });

class FSWProductVersionGridModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductVersionGridModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWProductVersionGridModule, declarations: [FSWProductVersionGridComponent], imports: [CommonModule,
            // ngrx
            LetDirective,
            // translate
            TranslocoModule,
            // grids
            FSWGridModule,
            // services
            HttpClientBaseServiceModule,
            ProductGroupServiceModule,
            // modals
            FSWModalModule$1,
            DialogModule,
            // custom modals
            FSWProductViewSettingsModule], exports: [FSWProductVersionGridComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductVersionGridModule, imports: [CommonModule,
            // translate
            TranslocoModule,
            // grids
            FSWGridModule,
            // services
            HttpClientBaseServiceModule,
            ProductGroupServiceModule,
            // modals
            FSWModalModule$1,
            DialogModule,
            // custom modals
            FSWProductViewSettingsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductVersionGridModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        // ngrx
                        LetDirective,
                        // translate
                        TranslocoModule,
                        // grids
                        FSWGridModule,
                        // services
                        HttpClientBaseServiceModule,
                        ProductGroupServiceModule,
                        // modals
                        FSWModalModule$1,
                        DialogModule,
                        // custom modals
                        FSWProductViewSettingsModule,
                    ],
                    declarations: [FSWProductVersionGridComponent],
                    exports: [FSWProductVersionGridComponent],
                }]
        }] });

const MY_PROVIDERS = [
    {
        provide: TRANSLOCO_LANG,
        useValue: getCountryCodeFromStorage() || 'default',
    },
    {
        provide: PRODUCT_LIST_GRID_CONFIG_TOKEN,
        useValue: productListGridConfig,
    },
    {
        provide: PRODUCT_VERSION_GRID_CONFIG_TOKEN,
        useValue: productVersionGridConfig,
    },
];

const ID_PROVIDERS$1 = [
    {
        provide: TRANSLOCO_LANG,
        useValue: getCountryCodeFromStorage() || 'default',
    },
    {
        provide: PRODUCT_LIST_GRID_CONFIG_TOKEN,
        useValue: productListGridConfig,
    },
    {
        provide: PRODUCT_VERSION_GRID_CONFIG_TOKEN,
        useValue: productVersionGridConfig,
    },
];

const VU_PROVIDERS$1 = [
    {
        provide: TRANSLOCO_LANG,
        useValue: getCountryCodeFromStorage() || 'default',
    },
    {
        provide: PRODUCT_LIST_GRID_CONFIG_TOKEN,
        useValue: productListGridConfig,
    },
    {
        provide: PRODUCT_VERSION_GRID_CONFIG_TOKEN,
        useValue: productVersionGridConfig,
    },
];

const PROVIDERS_MAP$1 = {
    default: MY_PROVIDERS,
    [CountryCode.MY]: MY_PROVIDERS,
    [CountryCode.VU]: VU_PROVIDERS$1,
    [CountryCode.ID]: ID_PROVIDERS$1,
};
const productGroupProviders = (countryCode) => [
    ...getCustomProviders(PROVIDERS_MAP$1, MY_PROVIDERS, countryCode),
];

// @angular
class FSWProductGroupComponent {
    set isReadonly(value) {
        this._isReadonly = value;
        this._cdr.detectChanges();
    }
    get isReadonly() {
        return this._isReadonly;
    }
    constructor(_scope, _translateService, _productGroupService, _productGroupCacheService, _cdr, _cdkDialog, _injector) {
        this._scope = _scope;
        this._translateService = _translateService;
        this._productGroupService = _productGroupService;
        this._productGroupCacheService = _productGroupCacheService;
        this._cdr = _cdr;
        this._cdkDialog = _cdkDialog;
        this._injector = _injector;
        this._isReadonly = true;
        this.productSelect = new EventEmitter();
        this.productAdd = new EventEmitter();
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'header'),
            this._translateService.selectFeatureTranslate(this._scope, 'buttons'),
        ]).pipe(map(([header, buttons]) => ({
            header,
            buttons,
        })));
    }
    ngOnDestroy() {
        this._productGroupCacheService.clearCache();
    }
    onAddProductGroup() {
        this._cdkDialog
            .open(FSWAddProductGroupComponent, {
            data: null,
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((res) => {
            if (!res?.data?.productGroupIdentifier)
                return;
            const identifier = res?.data?.productGroupIdentifier;
            this._productGroupService
                .createProductGroup(identifier)
                .pipe(switchMap((res) => {
                this.productAdd.emit(res);
                return this._productGroupService.createProductGroupSetting(res.identifier, {
                    setting: {
                        ...res.settings,
                    },
                });
            }), switchMap(() => this._productGroupService.getProductGroups()))
                .subscribe((res) => {
                if (!res)
                    return;
                this._productGroupCacheService.loadGridDataSub.next(res);
                this._cdr.detectChanges();
            }, (err) => console.error(err));
        }))
            .subscribe();
    }
    onSelectProductGroup(productGroup) {
        this._productGroupCacheService.selectRowSub.next(productGroup);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductGroupComponent, deps: [{ token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: PRODUCT_GROUP_SERVICE_TOKEN }, { token: ProductGroupCacheService }, { token: i0.ChangeDetectorRef }, { token: i1$7.Dialog }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWProductGroupComponent, selector: "fsw-product-group", inputs: { isReadonly: "isReadonly" }, outputs: { productSelect: "productSelect", productAdd: "productAdd" }, providers: [
            {
                provide: TRANSLOCO_SCOPE,
                useValue: {
                    scope: 'product-group-settings',
                    loader: TRANSLATION_LOADER$1,
                },
            },
            {
                provide: TranslocoFeatureHttpLoader,
                useClass: TranslocoFeatureHttpLoader,
            },
        ], ngImport: i0, template: `
    <div class="flex justify-between w-100">
      <section *ngIf="translate$ | async as translate" style="width: 35%">
        <div class="flex justify-between mb-4">
          <header>
            <h6>{{ translate.header.title_1 }}</h6>
          </header>
          <button
            *ngIf="!isReadonly"
            fswButton
            appearance="secondary"
            [size]="'s'"
            (click)="onAddProductGroup()"
          >
            <i [fswIcon]="'common-add'"></i>
            {{ translate.buttons.add_product_group }}
          </button>
        </div>
        <ng-container>
          <fsw-product-list-grid
            (selectRow)="onSelectProductGroup($event.res)"
          ></fsw-product-list-grid>
        </ng-container>
      </section>
      <div style="width: 62%">
        <fsw-product-group-detail [isReadonly]="isReadonly"></fsw-product-group-detail>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FSWProductListGridComponent, selector: "fsw-product-list-grid", outputs: ["selectRow"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "component", type: FSWProductGroupDetailComponent, selector: "fsw-product-group-detail", inputs: ["isCommonSetting", "isReadonly"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-product-group',
                    template: `
    <div class="flex justify-between w-100">
      <section *ngIf="translate$ | async as translate" style="width: 35%">
        <div class="flex justify-between mb-4">
          <header>
            <h6>{{ translate.header.title_1 }}</h6>
          </header>
          <button
            *ngIf="!isReadonly"
            fswButton
            appearance="secondary"
            [size]="'s'"
            (click)="onAddProductGroup()"
          >
            <i [fswIcon]="'common-add'"></i>
            {{ translate.buttons.add_product_group }}
          </button>
        </div>
        <ng-container>
          <fsw-product-list-grid
            (selectRow)="onSelectProductGroup($event.res)"
          ></fsw-product-list-grid>
        </ng-container>
      </section>
      <div style="width: 62%">
        <fsw-product-group-detail [isReadonly]="isReadonly"></fsw-product-group-detail>
      </div>
    </div>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [
                        {
                            provide: TRANSLOCO_SCOPE,
                            useValue: {
                                scope: 'product-group-settings',
                                loader: TRANSLATION_LOADER$1,
                            },
                        },
                        {
                            provide: TranslocoFeatureHttpLoader,
                            useClass: TranslocoFeatureHttpLoader,
                        },
                    ],
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PRODUCT_GROUP_SERVICE_TOKEN]
                }] }, { type: ProductGroupCacheService }, { type: i0.ChangeDetectorRef }, { type: i1$7.Dialog }, { type: i0.Injector }]; }, propDecorators: { isReadonly: [{
                type: Input
            }], productSelect: [{
                type: Output
            }], productAdd: [{
                type: Output
            }] } });

// @angular
class FSWProductGroupModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWProductGroupModule, declarations: [FSWProductGroupComponent, FSWProductGroupDetailComponent], imports: [CommonModule,
            ReactiveFormsModule,
            LetDirective,
            // grids
            FSWGridModule,
            FSWProductListGridModule,
            FSWProductVersionGridModule,
            // toolkit-ui
            FSWButtonModule,
            FSWIconModule,
            FSWTabsModule,
            // modals
            FSWModalModule$1,
            DialogModule,
            // services
            UtilsServiceModule,
            HttpClientBaseServiceModule,
            ProductGroupServiceModule,
            // custom modals
            FSWAddProductGroupModule,
            FSWProductViewSettingsModule,
            // json-viewer
            CodemirrorModule,
            // translate
            FSWTranslateModule], exports: [FSWProductGroupComponent, FSWProductGroupDetailComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductGroupModule, providers: [...productGroupProviders(getCountryCodeFromStorage()), ProductGroupCacheService], imports: [CommonModule,
            ReactiveFormsModule,
            // grids
            FSWGridModule,
            FSWProductListGridModule,
            FSWProductVersionGridModule,
            // toolkit-ui
            FSWButtonModule,
            FSWIconModule,
            FSWTabsModule,
            // modals
            FSWModalModule$1,
            DialogModule,
            // services
            UtilsServiceModule,
            HttpClientBaseServiceModule,
            ProductGroupServiceModule,
            // custom modals
            FSWAddProductGroupModule,
            FSWProductViewSettingsModule,
            // json-viewer
            CodemirrorModule,
            // translate
            FSWTranslateModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProductGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        LetDirective,
                        // grids
                        FSWGridModule,
                        FSWProductListGridModule,
                        FSWProductVersionGridModule,
                        // toolkit-ui
                        FSWButtonModule,
                        FSWIconModule,
                        FSWTabsModule,
                        // modals
                        FSWModalModule$1,
                        DialogModule,
                        // services
                        UtilsServiceModule,
                        HttpClientBaseServiceModule,
                        ProductGroupServiceModule,
                        // custom modals
                        FSWAddProductGroupModule,
                        FSWProductViewSettingsModule,
                        // json-viewer
                        CodemirrorModule,
                        // translate
                        FSWTranslateModule,
                    ],
                    declarations: [FSWProductGroupComponent, FSWProductGroupDetailComponent],
                    exports: [FSWProductGroupComponent, FSWProductGroupDetailComponent],
                    providers: [...productGroupProviders(getCountryCodeFromStorage()), ProductGroupCacheService],
                }]
        }] });

class FSWProjectListingConfirmComponent {
    constructor(dialogRef) {
        this.dialogRef = dialogRef;
        this.FSWModalSizes = FSWModalSizes;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProjectListingConfirmComponent, deps: [{ token: i1$7.DialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWProjectListingConfirmComponent, selector: "fsw-project-listing-confirm", ngImport: i0, template: "<fsw-modal\n  [title]=\"'modal.title' | fswTranslate\"\n  (cancelEvent)=\"dialogRef.close(false)\"\n  (confirmEvent)=\"dialogRef.close(true)\"\n  [confirmButton]=\"'buttons.delete' | fswTranslate\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate\"\n  [hiddenCloseButton]=\"true\"\n  [size]=\"FSWModalSizes.S\"\n>\n  <ng-template fswModalBody>\n    <p>{{ 'modal.description' | fswTranslate }}</p>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProjectListingConfirmComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-project-listing-confirm', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal\n  [title]=\"'modal.title' | fswTranslate\"\n  (cancelEvent)=\"dialogRef.close(false)\"\n  (confirmEvent)=\"dialogRef.close(true)\"\n  [confirmButton]=\"'buttons.delete' | fswTranslate\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate\"\n  [hiddenCloseButton]=\"true\"\n  [size]=\"FSWModalSizes.S\"\n>\n  <ng-template fswModalBody>\n    <p>{{ 'modal.description' | fswTranslate }}</p>\n  </ng-template>\n</fsw-modal>\n" }]
        }], ctorParameters: function () { return [{ type: i1$7.DialogRef }]; } });

var title$8 = "Project Listing";
var empty$5 = "Project Listing has no data";
var columns$3 = {
	project_name: "Project Name",
	counter_party: "Counter Party",
	date: "Date",
	completed_project: "Completed Project",
	completion: "% Completion",
	contract_amount: "Contract Amount",
	outstanding_amount: "Outstanding Amount",
	reliability_score: "Reliability Score (0-1)",
	remarks: "Remarks",
	total: "Total"
};
var fields$5 = {
	project_name: "Project Name",
	project_description: "Project Description",
	start_at: "Start At",
	end_at: "End At"
};
var modal$2 = {
	title: "Delete Confirmation",
	description: "Are you sure you want to remove this item?"
};
var buttons$j = {
	save: "Save Changes",
	add: "Add Project Listing",
	cancel: "Cancel",
	"delete": "Delete"
};
var comment$1 = {
	title: "Project Listing Comments",
	credit: "Credit Comments"
};
var my$2 = {
	title: title$8,
	empty: empty$5,
	columns: columns$3,
	fields: fields$5,
	modal: modal$2,
	buttons: buttons$j,
	comment: comment$1
};

var MY$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$j,
    columns: columns$3,
    comment: comment$1,
    default: my$2,
    empty: empty$5,
    fields: fields$5,
    modal: modal$2,
    title: title$8
});

var title$7 = "Project Listing";
var empty$4 = "Project Listing has no data";
var columns$2 = {
	project_name: "Project Name",
	counter_party: "Counter Party",
	date: "Date",
	completed_project: "Completed Project",
	completion: "% Completion",
	contract_amount: "Contract Amount",
	outstanding_amount: "Outstanding Amount",
	reliability_score: "Reliability Score (0-1)",
	remarks: "Remarks",
	total: "Total"
};
var fields$4 = {
	project_name: "Project Name",
	project_description: "Project Description",
	start_at: "Start At",
	end_at: "End At"
};
var modal$1 = {
	title: "Delete Confirmation",
	description: "Are you sure you want to remove this item?"
};
var buttons$i = {
	save: "Save Changes",
	add: "Add Project Listing",
	cancel: "Cancel",
	"delete": "Delete"
};
var comment = {
	title: "Project Listing Comments",
	credit: "Credit Comments"
};
var sg$1 = {
	title: title$7,
	empty: empty$4,
	columns: columns$2,
	fields: fields$4,
	modal: modal$1,
	buttons: buttons$i,
	comment: comment
};

var SG$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$i,
    columns: columns$2,
    comment: comment,
    default: sg$1,
    empty: empty$4,
    fields: fields$4,
    modal: modal$1,
    title: title$7
});

const FSW_PROJECT_LISTING_TRANSLATION_LOADER = {
    [CountryCode.MY]: MY$2,
    [CountryCode.SG]: SG$1,
};

class FSWProjectListingStore extends ComponentStore {
    get array() {
        try {
            return getControlFromGroup(this.formGroup, 'projectListing');
        }
        catch (err) {
            return new UntypedFormArray([]);
        }
    }
    get total() {
        return getControlFromGroup(this.formGroup, 'total');
    }
    constructor(_entity, _grid, _initialState) {
        super(_initialState);
        this._entity = _entity;
        this._grid = _grid;
        this._initialState = _initialState;
        this.formGroup = new FormGroup({});
        this.init = this.effect(pipe(switchMap(() => {
            const { entityId, isReadonly } = this.get();
            this.updateState({
                builder: this._grid(this.formGroup, isReadonly),
            });
            this.listenToArrayChange();
            return this._entity.getList(entityId).pipe(tap((value) => {
                this.array.patchValue(value);
            }), catchError((error) => {
                console.error(error);
                return EMPTY;
            }));
        })));
        this.save = this.effect(pipe(switchMap(() => {
            const { entityId } = this.get();
            const data = this.array.value;
            const { postReports, putReports } = data.reduce((acc, report) => {
                if (report.id) {
                    acc.putReports.push(report);
                }
                else {
                    acc.postReports.push(omit(report, ['id']));
                }
                return acc;
            }, {
                postReports: [],
                putReports: [],
            });
            const requests = [];
            if (postReports.length) {
                requests.push(this._entity.createList(entityId, postReports));
            }
            if (putReports.length) {
                requests.push(this._entity.updateList(entityId, putReports));
            }
            return forkJoin(requests).pipe(tap(() => this.init()), catchError(() => {
                return EMPTY;
            }));
        })));
        this.remove = this.effect(pipe(switchMap(({ id, cb }) => {
            const { entityId } = this.get();
            return this._entity.delete(entityId, id).pipe(tap(() => cb()));
        })));
        this.listenToArrayChange = this.effect(pipe(switchMap(() => this.array.valueChanges.pipe(distinctUntilChanged()).pipe(tap((value) => {
            this.total.patchValue({
                ...value.reduce((acc, item) => {
                    acc.contractAmount += Number.parseFloat(item.contractAmount?.toString() || '0');
                    acc.outstandingAmount += Number.parseFloat(item.outstandingAmount?.toString() || '0');
                    return acc;
                }, {
                    contractAmount: 0,
                    outstandingAmount: 0,
                }),
            });
        })))));
        this.updateState = (value) => this.patchState({
            ...value,
        });
    }
    add() {
        this.array.patchValue([...this.array.value, {}], {
            emitEvent: true,
        });
    }
}

const FSW_PROJECT_LISTING_STORE_TOKEN = new InjectionToken('FSW_PROJECT_LISTING_STORE_TOKEN');

const FSW_PROJECT_LISTING_GRID_TOKEN = new InjectionToken('FSW_PROJECT_LISTING_GRID_TOKEN');

const FSW_PROJECT_LISTING_ENTITY_TOKEN = new InjectionToken('FSW_PROJECT_LISTING_ENTITY_TOKEN');

class FSWProjectListingStoreMY extends FSWProjectListingStore {
    constructor(_entity, _grid) {
        super(_entity, _grid, {
            entityId: null,
            entityType: FSWEntityTypes.LOAN,
            isReadonly: false,
            builder: null,
        });
        this._entity = _entity;
        this._grid = _grid;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProjectListingStoreMY, deps: [{ token: FSW_PROJECT_LISTING_ENTITY_TOKEN }, { token: FSW_PROJECT_LISTING_GRID_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProjectListingStoreMY }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProjectListingStoreMY, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PROJECT_LISTING_ENTITY_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PROJECT_LISTING_GRID_TOKEN]
                }] }]; } });

const FSWProjectListingGridMY = (form, isReadonly) => {
    const translation = FSW_PROJECT_LISTING_TRANSLATION_LOADER[CountryCode.MY];
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.TABLE,
        customClasses: 'fsw-table w-max',
        readonlyWhen$: of(isReadonly),
        header: [
            {
                columns: [
                    {
                        label: translation.columns.project_name,
                        width: 200,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.counter_party,
                        width: 50,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.date,
                        width: 150,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.completed_project,
                        width: 120,
                    },
                    {
                        label: translation.columns.completion,
                        width: 90,
                    },
                    {
                        label: translation.columns.contract_amount,
                        width: 120,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.outstanding_amount,
                        width: 120,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.reliability_score,
                        width: 120,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.remarks,
                        width: 150,
                    },
                    {
                        label: '',
                        width: 50,
                    },
                ],
            },
        ],
        items: [
            {
                body: {
                    isLoop: true,
                    key: 'projectListing',
                    data: {
                        columns: [
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'flex flex-col gap-2 pr-1',
                                        fields: [
                                            {
                                                key: 'projectName',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    inputType: 'text',
                                                    placeHolder: translation.fields.project_name,
                                                    defaultValue: '',
                                                    fullWidth: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => value ?? 'N/A',
                                                },
                                                validations: [Validators.required],
                                            },
                                            {
                                                key: 'projectDescription',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    inputType: 'area',
                                                    placeHolder: translation.fields.project_description,
                                                    defaultValue: '',
                                                    fullWidth: true,
                                                    rows: 2,
                                                    readonlyTemplate: (value) => value ?? 'N/A',
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1',
                                        fields: [
                                            {
                                                key: 'counterParty',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    fullWidth: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => value ?? 'N/A',
                                                },
                                                validations: [Validators.required],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'flex flex-col gap-2 pr-1',
                                        fields: [
                                            {
                                                key: 'startAt',
                                                type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                                                context: {
                                                    defaultValue: null,
                                                    fullWidth: true,
                                                    placeHolder: translation.fields.start_at,
                                                    closeOnSelected: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => `Start At: ${new DatePipe('en-US').transform(value, 'dd/MM/yyyy') || 'N/A'}`,
                                                },
                                                validations: [Validators.required],
                                            },
                                            {
                                                key: 'endAt',
                                                type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                                                context: {
                                                    defaultValue: null,
                                                    fullWidth: true,
                                                    placeHolder: translation.fields.end_at,
                                                    closeOnSelected: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => `End At: ${new DatePipe('en-US').transform(value, 'dd/MM/yyyy') || 'N/A'}`,
                                                },
                                                validations: [Validators.required],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1',
                                        fields: [
                                            {
                                                key: 'isProjectCompleted',
                                                type: FSWDynamicBuilderControlTypes.SELECT,
                                                context: {
                                                    defaultValue: false,
                                                    fullWidth: true,
                                                    items: [
                                                        {
                                                            value: false,
                                                            text: 'No',
                                                        },
                                                        {
                                                            value: true,
                                                            text: 'Yes',
                                                        },
                                                    ],
                                                    readonlyTemplate: (value) => (value ? 'Yes' : 'No'),
                                                    isDisabled: true,
                                                    afterCreated: (control, formGroup) => {
                                                        const completePercentage = formGroup.get('completePercentage');
                                                        if (!completePercentage) {
                                                            return;
                                                        }
                                                        completePercentage.valueChanges
                                                            .pipe(startWith(completePercentage.value), tap((value) => {
                                                            control.setValue(value >= 100);
                                                        }))
                                                            .subscribe();
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1',
                                        fields: [
                                            {
                                                key: 'completePercentage',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    // inputType: 'number',
                                                    defaultValue: 0,
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    fullWidth: true,
                                                    min: 0,
                                                    max: 100,
                                                    showError: true,
                                                    readonlyTemplate: (value) => value ?? 'N/A',
                                                },
                                                validations: [Validators.min(0), Validators.max(100)],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1',
                                        fields: [
                                            {
                                                key: 'contractAmount',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    // inputType: 'number',
                                                    defaultValue: 0,
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    fullWidth: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => value ?? 'N/A',
                                                },
                                                validations: [Validators.required],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1',
                                        fields: [
                                            {
                                                key: 'outstandingAmount',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    // inputType: 'number',
                                                    defaultValue: 0,
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    fullWidth: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => value ?? 'N/A',
                                                },
                                                validations: [Validators.required],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1',
                                        fields: [
                                            {
                                                key: 'reliabilityScore',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    // inputType: 'number',
                                                    defaultValue: 0,
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    fullWidth: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => value ?? 'N/A',
                                                },
                                                validations: [Validators.required, Validators.min(0), Validators.max(1)],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1',
                                        fields: [
                                            {
                                                key: 'remark',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    inputType: 'area',
                                                    defaultValue: '',
                                                    fullWidth: true,
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'id',
                                        type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                        context: {
                                            templateKey: 'delete',
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    empty: {
                        emptyTemplateKey: 'empty_list',
                        emptyTemplateColSpan: 10,
                    },
                },
            },
        ],
        footer: [
            {
                columns: [
                    {
                        colSpan: 9,
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                name: 'add_project_listing',
                                fields: [],
                            },
                        ],
                    },
                ],
            },
            {
                key: 'total',
                columns: [
                    {
                        label: 'Total',
                        colSpan: 4,
                        customClasses: 'text-right',
                    },
                    {
                        label: '',
                    },
                    {
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                customClasses: 'pr-1',
                                fields: [
                                    {
                                        key: 'contractAmount',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            // inputType: 'number',
                                            defaultValue: 0,
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            isDisabled: true,
                                        },
                                    },
                                ],
                            },
                        ],
                        // width: 150,
                    },
                    {
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                customClasses: 'pr-1',
                                fields: [
                                    {
                                        key: 'outstandingAmount',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            // inputType: 'number',
                                            defaultValue: 0,
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            isDisabled: true,
                                        },
                                    },
                                ],
                            },
                        ],
                        // width: 150,
                    },
                    {
                        label: '',
                        colSpan: 2,
                    },
                ],
            },
        ],
        form,
    });
};

const FSW_PROJECT_LISTING_MY_PROVIDERS = [
    {
        provide: FSW_PROJECT_LISTING_STORE_TOKEN,
        useClass: FSWProjectListingStoreMY,
        deps: [FSW_PROJECT_LISTING_ENTITY_TOKEN, FSW_PROJECT_LISTING_GRID_TOKEN],
    },
    {
        provide: FSW_PROJECT_LISTING_GRID_TOKEN,
        useValue: FSWProjectListingGridMY,
        deps: [],
    },
];

class FSWProjectListingStoreSG extends FSWProjectListingStore {
    constructor(_entity, _grid) {
        super(_entity, _grid, {
            entityId: null,
            entityType: FSWEntityTypes.APPLICATION,
            isReadonly: false,
            builder: null,
        });
        this._entity = _entity;
        this._grid = _grid;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProjectListingStoreSG, deps: [{ token: FSW_PROJECT_LISTING_ENTITY_TOKEN }, { token: FSW_PROJECT_LISTING_GRID_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProjectListingStoreSG }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProjectListingStoreSG, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PROJECT_LISTING_ENTITY_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PROJECT_LISTING_GRID_TOKEN]
                }] }]; } });

const FSWProjectListingGridSG = (form, isReadonly) => {
    const translation = FSW_PROJECT_LISTING_TRANSLATION_LOADER[CountryCode.SG];
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.TABLE,
        customClasses: 'fsw-table w-max',
        readonlyWhen$: of(isReadonly),
        header: [
            {
                columns: [
                    {
                        label: translation.columns.project_name,
                        width: 200,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.counter_party,
                        width: 50,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.date,
                        width: 150,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.completed_project,
                        width: 120,
                    },
                    {
                        label: translation.columns.completion,
                        width: 90,
                    },
                    {
                        label: translation.columns.contract_amount,
                        width: 120,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.outstanding_amount,
                        width: 120,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.reliability_score,
                        width: 120,
                        requireClasses: 'text-red-500',
                    },
                    {
                        label: translation.columns.remarks,
                        width: 150,
                    },
                    {
                        label: '',
                        width: 50,
                    },
                ],
            },
        ],
        items: [
            {
                body: {
                    isLoop: true,
                    key: 'projectListing',
                    data: {
                        columns: [
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'flex flex-col gap-2 pr-1',
                                        fields: [
                                            {
                                                key: 'projectName',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    inputType: 'text',
                                                    placeHolder: translation.fields.project_name,
                                                    defaultValue: '',
                                                    fullWidth: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => value ?? 'N/A',
                                                },
                                                validations: [Validators.required],
                                            },
                                            {
                                                key: 'projectDescription',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    inputType: 'area',
                                                    placeHolder: translation.fields.project_description,
                                                    defaultValue: '',
                                                    fullWidth: true,
                                                    rows: 2,
                                                    readonlyTemplate: (value) => value ?? 'N/A',
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1',
                                        fields: [
                                            {
                                                key: 'counterParty',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    fullWidth: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => value ?? 'N/A',
                                                },
                                                validations: [Validators.required],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'flex flex-col gap-2 pr-1',
                                        fields: [
                                            {
                                                key: 'startAt',
                                                type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                                                context: {
                                                    defaultValue: null,
                                                    fullWidth: true,
                                                    placeHolder: translation.fields.start_at,
                                                    closeOnSelected: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => `Start At: ${new DatePipe('en-US').transform(value, 'dd/MM/yyyy') || 'N/A'}`,
                                                },
                                                validations: [Validators.required],
                                            },
                                            {
                                                key: 'endAt',
                                                type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                                                context: {
                                                    defaultValue: null,
                                                    fullWidth: true,
                                                    placeHolder: translation.fields.end_at,
                                                    closeOnSelected: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => `End At: ${new DatePipe('en-US').transform(value, 'dd/MM/yyyy') || 'N/A'}`,
                                                },
                                                validations: [Validators.required],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1',
                                        fields: [
                                            {
                                                key: 'isProjectCompleted',
                                                type: FSWDynamicBuilderControlTypes.SELECT,
                                                context: {
                                                    defaultValue: false,
                                                    fullWidth: true,
                                                    items: [
                                                        {
                                                            value: false,
                                                            text: 'No',
                                                        },
                                                        {
                                                            value: true,
                                                            text: 'Yes',
                                                        },
                                                    ],
                                                    readonlyTemplate: (value) => (value ? 'Yes' : 'No'),
                                                    isDisabled: true,
                                                    afterCreated: (control, formGroup) => {
                                                        const completePercentage = formGroup.get('completePercentage');
                                                        if (!completePercentage) {
                                                            return;
                                                        }
                                                        completePercentage.valueChanges
                                                            .pipe(startWith(completePercentage.value), tap((value) => {
                                                            control.setValue(value >= 100);
                                                        }))
                                                            .subscribe();
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1',
                                        fields: [
                                            {
                                                key: 'completePercentage',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    // inputType: 'number',
                                                    defaultValue: 0,
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    fullWidth: true,
                                                    min: 0,
                                                    max: 100,
                                                    showError: true,
                                                    readonlyTemplate: (value) => value ?? 'N/A',
                                                },
                                                validations: [Validators.min(0), Validators.max(100)],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1',
                                        fields: [
                                            {
                                                key: 'contractAmount',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    // inputType: 'number',
                                                    defaultValue: 0,
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    fullWidth: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => value ?? 'N/A',
                                                },
                                                validations: [Validators.required],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1',
                                        fields: [
                                            {
                                                key: 'outstandingAmount',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    // inputType: 'number',
                                                    defaultValue: 0,
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    fullWidth: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => value ?? 'N/A',
                                                },
                                                validations: [Validators.required],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1',
                                        fields: [
                                            {
                                                key: 'reliabilityScore',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    // inputType: 'number',
                                                    defaultValue: 0,
                                                    mask: {
                                                        expression: 'separator.2',
                                                        config: {
                                                            thousandSeparator: ',',
                                                        },
                                                    },
                                                    fullWidth: true,
                                                    showError: true,
                                                    readonlyTemplate: (value) => value ?? 'N/A',
                                                },
                                                validations: [Validators.required, Validators.min(0), Validators.max(1)],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                renderBy: 'container',
                                containers: [
                                    {
                                        customClasses: 'pr-1',
                                        fields: [
                                            {
                                                key: 'remark',
                                                type: FSWDynamicBuilderControlTypes.INPUT,
                                                context: {
                                                    inputType: 'area',
                                                    defaultValue: '',
                                                    fullWidth: true,
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                columnType: 'control',
                                fields: [
                                    {
                                        key: 'id',
                                        type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                        context: {
                                            templateKey: 'delete',
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    empty: {
                        emptyTemplateKey: 'empty_list',
                        emptyTemplateColSpan: 10,
                    },
                },
            },
        ],
        footer: [
            {
                columns: [
                    {
                        colSpan: 9,
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                name: 'add_project_listing',
                                fields: [],
                            },
                        ],
                    },
                ],
            },
            {
                key: 'total',
                columns: [
                    {
                        label: 'Total',
                        colSpan: 4,
                        customClasses: 'text-right',
                    },
                    {
                        label: '',
                    },
                    {
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                customClasses: 'pr-1',
                                fields: [
                                    {
                                        key: 'contractAmount',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            // inputType: 'number',
                                            defaultValue: 0,
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            isDisabled: true,
                                        },
                                    },
                                ],
                            },
                        ],
                        // width: 150,
                    },
                    {
                        columnType: 'control',
                        renderBy: 'container',
                        containers: [
                            {
                                customClasses: 'pr-1',
                                fields: [
                                    {
                                        key: 'outstandingAmount',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            // inputType: 'number',
                                            defaultValue: 0,
                                            mask: {
                                                expression: 'separator.2',
                                                config: {
                                                    thousandSeparator: ',',
                                                },
                                            },
                                            fullWidth: true,
                                            isDisabled: true,
                                        },
                                    },
                                ],
                            },
                        ],
                        // width: 150,
                    },
                    {
                        label: '',
                        colSpan: 2,
                    },
                ],
            },
        ],
        form,
    });
};

const FSW_PROJECT_LISTING_SG_PROVIDERS = [
    {
        provide: FSW_PROJECT_LISTING_STORE_TOKEN,
        useClass: FSWProjectListingStoreSG,
        deps: [FSW_PROJECT_LISTING_ENTITY_TOKEN, FSW_PROJECT_LISTING_GRID_TOKEN],
    },
    {
        provide: FSW_PROJECT_LISTING_GRID_TOKEN,
        useValue: FSWProjectListingGridSG,
        deps: [],
    },
];

class FSWProjectListingLoanEntity {
    constructor(_creditProjectListingService) {
        this._creditProjectListingService = _creditProjectListingService;
    }
    getList(entityId) {
        return this._creditProjectListingService.getListByLoan(entityId);
    }
    createList(entityId, data) {
        return this._creditProjectListingService.createListByLoan(entityId, data);
    }
    updateList(entityId, data) {
        return this._creditProjectListingService.updateListByLoan(entityId, data);
    }
    delete(entityId, id) {
        return this._creditProjectListingService.delete(id);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProjectListingLoanEntity, deps: [{ token: CREDIT_PROJECT_LISTING_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProjectListingLoanEntity }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProjectListingLoanEntity, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CREDIT_PROJECT_LISTING_SERVICE_TOKEN]
                }] }]; } });

class FSWProjectListingApplicationEntity {
    constructor(_creditProjectListingService, _applicationProjectListingService) {
        this._creditProjectListingService = _creditProjectListingService;
        this._applicationProjectListingService = _applicationProjectListingService;
    }
    getList(entityId) {
        return this._applicationProjectListingService.getList(entityId).pipe(switchMap((res) => {
            if (!res?.length) {
                return of([]);
            }
            return this._creditProjectListingService.getList(res);
        }));
    }
    createList(entityId, data) {
        return this._creditProjectListingService.createList(data).pipe(switchMap((res) => this._applicationProjectListingService.createList(entityId, res.map((item) => item.id))));
    }
    updateList(entityId, data) {
        return this._creditProjectListingService.updateList(data);
    }
    delete(entityId, id) {
        return this._applicationProjectListingService.delete(entityId, id);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProjectListingApplicationEntity, deps: [{ token: CREDIT_PROJECT_LISTING_SERVICE_TOKEN }, { token: APPLICATION_PROJECT_LISTING_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProjectListingApplicationEntity }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProjectListingApplicationEntity, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CREDIT_PROJECT_LISTING_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_PROJECT_LISTING_SERVICE_TOKEN]
                }] }]; } });

const FSW_PROJECT_LISTING_PROVIDERS = {
    default: FSW_PROJECT_LISTING_MY_PROVIDERS,
    [CountryCode.MY]: FSW_PROJECT_LISTING_MY_PROVIDERS,
    [CountryCode.SG]: FSW_PROJECT_LISTING_SG_PROVIDERS,
};
const projectListingEntityLoadProviders = (entityType) => {
    if (entityType === FSWEntityTypes.LOAN) {
        return [
            {
                provide: FSW_PROJECT_LISTING_ENTITY_TOKEN,
                useClass: FSWProjectListingLoanEntity,
                deps: [CREDIT_PROJECT_LISTING_SERVICE_TOKEN],
            },
        ];
    }
    return [
        {
            provide: FSW_PROJECT_LISTING_ENTITY_TOKEN,
            useClass: FSWProjectListingApplicationEntity,
            deps: [CREDIT_PROJECT_LISTING_SERVICE_TOKEN, APPLICATION_PROJECT_LISTING_SERVICE_TOKEN],
        },
    ];
};
const projectListingLoadProviders = (countryCode) => [
    fswTranslateScope('project_listing'),
    ...getCustomProviders(FSW_PROJECT_LISTING_PROVIDERS, FSW_PROJECT_LISTING_MY_PROVIDERS, countryCode),
];

class ProjectListingComponent {
    set entityId(entityId) {
        this._componentStore.updateState({
            entityId,
        });
    }
    set entityType(entityType) {
        this._componentStore.updateState({
            entityType,
        });
    }
    set isReadonly(isReadonly) {
        this._componentStore.updateState({
            isReadonly,
        });
    }
    get count$() {
        return this._componentStore.array.valueChanges.pipe(startWith(this._componentStore.array.value), map((value) => value.length));
    }
    constructor(_componentStore, _dialog, _injector) {
        this._componentStore = _componentStore;
        this._dialog = _dialog;
        this._injector = _injector;
        this.state$ = this._componentStore.state$;
        this.formGroup = this._componentStore.formGroup;
        this.array = this._componentStore.array;
    }
    ngOnInit() {
        this._componentStore.init();
    }
    addProjectListing() {
        this._componentStore.add();
    }
    save() {
        this._componentStore.save();
    }
    remove(index) {
        const value = this._componentStore.array.value[index];
        if (!value.id) {
            this._componentStore.array.removeAt(index);
            return;
        }
        this._dialog
            .open(FSWProjectListingConfirmComponent, {
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((check) => {
            if (check) {
                this._componentStore.remove({
                    id: value.id,
                    cb: () => {
                        this._componentStore.array.removeAt(index);
                    },
                });
            }
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProjectListingComponent, deps: [{ token: FSW_PROJECT_LISTING_STORE_TOKEN }, { token: i1$7.Dialog }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ProjectListingComponent, selector: "fsw-project-listing", inputs: { entityId: "entityId", entityType: "entityType", isReadonly: "isReadonly" }, ngImport: i0, template: "<fsw-panel [title]=\"'title' | fswTranslate\" *ngIf=\"state$ | async as state\">\n  <section class=\"w-full flex flex-col gap-[16px]\">\n    <ng-template fswPanelHeaderSuffix>\n      <button\n        *ngIf=\"!state.isReadonly\"\n        fswButton\n        [appearance]=\"'secondary'\"\n        [disabled]=\"formGroup.invalid || (count$ | async) === 0\"\n        (click)=\"save()\"\n      >\n        {{ 'buttons.save' | fswTranslate }}\n      </button>\n    </ng-template>\n    <section class=\"w-full overflow-auto\">\n      <form [formGroup]=\"formGroup\">\n        <fsw-dynamic-builder [builder]=\"state.builder\">\n          <ng-template fswDynamicBuilderTemplate key=\"empty_list\">\n            <p class=\"w-full text-center text-yellow-500 font-bold p-[16px]\">\n              {{ 'empty' | fswTranslate }}\n            </p>\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"add_project_listing\">\n            <button\n              *ngIf=\"!state.isReadonly\"\n              fswButton\n              (click)=\"addProjectListing()\"\n              class=\"float-left\"\n            >\n              {{ 'buttons.add' | fswTranslate }}\n            </button>\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"delete\" let-index=\"index\">\n            <button\n              *ngIf=\"!state.isReadonly\"\n              fswButton\n              [appearance]=\"'icon-with-bg'\"\n              [size]=\"'m'\"\n              (click)=\"remove(index)\"\n            >\n              <i [fswIcon]=\"'common-delete-alternative'\"></i>\n            </button>\n          </ng-template>\n        </fsw-dynamic-builder>\n      </form>\n    </section>\n    <fsw-comments\n      [category]=\"'CREDIT'\"\n      [title]=\"'comment.title' | fswTranslate : { scope: 'project_listing' }\"\n      [module]=\"'PROJECT_LISTING'\"\n      [identifier]=\"'PROJECT_LISTING'\"\n      [entityId]=\"state.entityId?.toString() || null\"\n      [enableSaveButton]=\"true\"\n      [isReadonly]=\"state.isReadonly\"\n      [translateScope]=\"'project_listing'\"\n    >\n      <ng-template\n        fswCommentsItem\n        [key]=\"'main_comment'\"\n        [label]=\"'comment.credit' | fswTranslate : { scope: 'project_listing' }\"\n      ></ng-template>\n    </fsw-comments>\n  </section>\n</fsw-panel>\n", styles: [":is() .fsw-table tbody tr:hover{background-color:transparent}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FSWDynamicBuilderTemplateDirective, selector: "[fswDynamicBuilderTemplate]", inputs: ["key"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "component", type: FSWCommentsComponent, selector: "fsw-comments", inputs: ["title", "entityId", "identifier", "module", "category", "isReadonly", "rows", "customClasses", "enableSaveButton", "translateScope"] }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "directive", type: FSWCommentsItemDirective, selector: "ng-template[fswCommentsItem]", inputs: ["label", "key"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProjectListingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-project-listing', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-panel [title]=\"'title' | fswTranslate\" *ngIf=\"state$ | async as state\">\n  <section class=\"w-full flex flex-col gap-[16px]\">\n    <ng-template fswPanelHeaderSuffix>\n      <button\n        *ngIf=\"!state.isReadonly\"\n        fswButton\n        [appearance]=\"'secondary'\"\n        [disabled]=\"formGroup.invalid || (count$ | async) === 0\"\n        (click)=\"save()\"\n      >\n        {{ 'buttons.save' | fswTranslate }}\n      </button>\n    </ng-template>\n    <section class=\"w-full overflow-auto\">\n      <form [formGroup]=\"formGroup\">\n        <fsw-dynamic-builder [builder]=\"state.builder\">\n          <ng-template fswDynamicBuilderTemplate key=\"empty_list\">\n            <p class=\"w-full text-center text-yellow-500 font-bold p-[16px]\">\n              {{ 'empty' | fswTranslate }}\n            </p>\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"add_project_listing\">\n            <button\n              *ngIf=\"!state.isReadonly\"\n              fswButton\n              (click)=\"addProjectListing()\"\n              class=\"float-left\"\n            >\n              {{ 'buttons.add' | fswTranslate }}\n            </button>\n          </ng-template>\n          <ng-template fswDynamicBuilderTemplate key=\"delete\" let-index=\"index\">\n            <button\n              *ngIf=\"!state.isReadonly\"\n              fswButton\n              [appearance]=\"'icon-with-bg'\"\n              [size]=\"'m'\"\n              (click)=\"remove(index)\"\n            >\n              <i [fswIcon]=\"'common-delete-alternative'\"></i>\n            </button>\n          </ng-template>\n        </fsw-dynamic-builder>\n      </form>\n    </section>\n    <fsw-comments\n      [category]=\"'CREDIT'\"\n      [title]=\"'comment.title' | fswTranslate : { scope: 'project_listing' }\"\n      [module]=\"'PROJECT_LISTING'\"\n      [identifier]=\"'PROJECT_LISTING'\"\n      [entityId]=\"state.entityId?.toString() || null\"\n      [enableSaveButton]=\"true\"\n      [isReadonly]=\"state.isReadonly\"\n      [translateScope]=\"'project_listing'\"\n    >\n      <ng-template\n        fswCommentsItem\n        [key]=\"'main_comment'\"\n        [label]=\"'comment.credit' | fswTranslate : { scope: 'project_listing' }\"\n      ></ng-template>\n    </fsw-comments>\n  </section>\n</fsw-panel>\n", styles: [":is() .fsw-table tbody tr:hover{background-color:transparent}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PROJECT_LISTING_STORE_TOKEN]
                }] }, { type: i1$7.Dialog }, { type: i0.Injector }]; }, propDecorators: { entityId: [{
                type: Input
            }], entityType: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class FSwProjectListingDirective {
    constructor(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
        this.entityId = null;
        this.entityType = FSWEntityTypes.LOAN;
        this.isReadonly = false;
    }
    ngOnChanges() {
        this._viewContainerRef.clear();
        const ref = this._viewContainerRef.createComponent(ProjectListingComponent, {
            injector: Injector.create({
                parent: this._viewContainerRef.injector,
                providers: [
                    ...projectListingLoadProviders(getCountryCodeFromStorage()),
                    ...projectListingEntityLoadProviders(this.entityType || FSWEntityTypes.LOAN),
                ],
            }),
        });
        const instance = ref.instance;
        instance.entityId = this.entityId;
        instance.entityType = this.entityType;
        instance.isReadonly = this.isReadonly;
        ref.changeDetectorRef.detectChanges();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSwProjectListingDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSwProjectListingDirective, selector: "[fswProjectListing]", inputs: { entityId: "entityId", entityType: "entityType", isReadonly: "isReadonly" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSwProjectListingDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswProjectListing]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; }, propDecorators: { entityId: [{
                type: Input
            }], entityType: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class FSWProjectListingModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProjectListingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWProjectListingModule, declarations: [FSwProjectListingDirective,
            ProjectListingComponent,
            FSWProjectListingConfirmComponent], imports: [i1$4.FSWTranslateModule, NgIf,
            FSWFieldModule,
            FSWInputModule,
            ReactiveFormsModule,
            FSWDateTimePickerModule,
            FSWSelectModule,
            FSWDynamicBuilderModule,
            FSWIconModule,
            FSWButtonModule,
            FSWModalModule$1,
            CreditProjectListingServiceModule,
            ApplicationProjectListingServiceModule,
            FSWCommentsComponent,
            AsyncPipe,
            FSWPanelModule,
            DialogModule,
            FSWCommentsItemDirective], exports: [FSwProjectListingDirective, ProjectListingComponent, FSWProjectListingConfirmComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProjectListingModule, imports: [FSWTranslateModule.forFeature({
                scope: 'project_listing',
                defaultKey: CountryCode.MY,
                data: FSW_PROJECT_LISTING_TRANSLATION_LOADER,
            }),
            FSWFieldModule,
            FSWInputModule,
            ReactiveFormsModule,
            FSWDateTimePickerModule,
            FSWSelectModule,
            FSWDynamicBuilderModule,
            FSWIconModule,
            FSWButtonModule,
            FSWModalModule$1,
            CreditProjectListingServiceModule,
            ApplicationProjectListingServiceModule,
            FSWCommentsComponent,
            FSWPanelModule,
            DialogModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProjectListingModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FSwProjectListingDirective,
                        ProjectListingComponent,
                        FSWProjectListingConfirmComponent,
                    ],
                    exports: [FSwProjectListingDirective, ProjectListingComponent, FSWProjectListingConfirmComponent],
                    imports: [
                        FSWTranslateModule.forFeature({
                            scope: 'project_listing',
                            defaultKey: CountryCode.MY,
                            data: FSW_PROJECT_LISTING_TRANSLATION_LOADER,
                        }),
                        NgIf,
                        FSWFieldModule,
                        FSWInputModule,
                        ReactiveFormsModule,
                        FSWDateTimePickerModule,
                        FSWSelectModule,
                        FSWDynamicBuilderModule,
                        FSWIconModule,
                        FSWButtonModule,
                        FSWModalModule$1,
                        CreditProjectListingServiceModule,
                        ApplicationProjectListingServiceModule,
                        FSWCommentsComponent,
                        AsyncPipe,
                        FSWPanelModule,
                        DialogModule,
                        FSWCommentsItemDirective,
                    ],
                }]
        }] });

const FSW_PROPOSALS_STORE_TOKEN = new InjectionToken('FSW_PROPOSALS_STORE_TOKEN');

const FSW_PROPOSALS_FORM_TOKEN = new InjectionToken('FSW_PROPOSALS_FORM_TOKEN');

// for loading form's config after selecting item in table and show in modal
var FSWProposalsFormTypes;
(function (FSWProposalsFormTypes) {
    FSWProposalsFormTypes[FSWProposalsFormTypes["LOAN"] = 0] = "LOAN";
    FSWProposalsFormTypes[FSWProposalsFormTypes["FACILITY"] = 1] = "FACILITY";
    FSWProposalsFormTypes[FSWProposalsFormTypes["FACILITY_IMPORT"] = 2] = "FACILITY_IMPORT";
    FSWProposalsFormTypes[FSWProposalsFormTypes["FACILITY_AFTER_IMPORT"] = 3] = "FACILITY_AFTER_IMPORT";
})(FSWProposalsFormTypes || (FSWProposalsFormTypes = {}));

var FSWProposalsRenderTypes;
(function (FSWProposalsRenderTypes) {
    FSWProposalsRenderTypes["FORM"] = "form";
    FSWProposalsRenderTypes["GRID"] = "grid";
})(FSWProposalsRenderTypes || (FSWProposalsRenderTypes = {}));

class FSWProposalsFormComponent {
    constructor(componentStore, _form) {
        this.componentStore = componentStore;
        this._form = _form;
        this.editEvent = new EventEmitter();
        this.deleteEvent = new EventEmitter();
        this.proposals$ = this.componentStore.select((state) => state.proposals);
        this.isEditable$ = this.componentStore.select((state) => !state.isReadonly);
        this.isReadonly$ = this.componentStore.select((state) => state.isReadonly);
        this.length$ = this.proposals$.pipe(map((proposals) => proposals.length));
        this.options$ = this.length$.pipe(map((length) => Array.from({ length }, (_, i) => i)));
        this.index$ = new BehaviorSubject(0);
        this.selected$ = combineLatest([this.proposals$, this.index$]).pipe(map(([proposals, index]) => proposals[index]));
        this.builder$ = this.selected$.pipe(map((selected) => {
            const builder = this._form(new UntypedFormGroup({}), selected.proposal_type === 'LOAN'
                ? FSWProposalsFormTypes.LOAN
                : FSWProposalsFormTypes.FACILITY, 'PUT', this.componentStore.state(), this.isReadonly$);
            builder.groupConfig.form.patchValue({
                ...(selected.data?.propose || {}),
                member_id: selected.member.uuid,
                id: selected.id,
            });
            return builder;
        }));
    }
    select(index) {
        this.index$.next(index);
    }
    previous() {
        if (this.index$.value === 0) {
            return;
        }
        this.select(this.index$.value - 1);
    }
    next(length) {
        if (this.index$.value === length - 1) {
            return;
        }
        this.select(this.index$.value + 1);
    }
    delete(item) {
        this.deleteEvent.emit({
            id: item.id,
            type: item.proposal_type === 'LOAN' ? FSWProposalsFormTypes.LOAN : FSWProposalsFormTypes.FACILITY,
        });
    }
    edit(item) {
        this.editEvent.emit({
            item,
            type: item.proposal_type === 'LOAN' ? FSWProposalsFormTypes.LOAN : FSWProposalsFormTypes.FACILITY,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsFormComponent, deps: [{ token: FSW_PROPOSALS_STORE_TOKEN }, { token: FSW_PROPOSALS_FORM_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWProposalsFormComponent, selector: "fsw-proposals-form", outputs: { editEvent: "editEvent", deleteEvent: "deleteEvent" }, ngImport: i0, template: "<section class=\"flex flex-col gap-[16px]\" *ngIf=\"length$ | async as length\">\n  <header class=\"flex justify-between items-center w-full\">\n    <button\n      fswButton\n      [appearance]=\"'icon-no-bg'\"\n      [disabled]=\"(index$ | async) === 0\"\n      (click)=\"previous()\"\n    >\n      <i [fswIcon]=\"'common-arrow-left'\" [fontSize]=\"'36px'\"></i>\n    </button>\n    <main class=\"flex items-center gap-[8px]\">\n      <fsw-field [flexWidth]=\"true\">\n        <fsw-select\n          [closeOnSelected]=\"true\"\n          [ngModel]=\"index$.value\"\n          (ngModelChange)=\"index$.next($event)\"\n        >\n          <ng-container *ngFor=\"let option of options$ | async\">\n            <ng-template\n              fswSelectItem\n              [text]=\"(option + 1).toString()\"\n              [value]=\"option\"\n              [icon]=\"'checkbox'\"\n            ></ng-template>\n          </ng-container>\n        </fsw-select>\n      </fsw-field>\n      <strong *ngIf=\"selected$ | async as selected\">\n        ({{ selected.proposal_type }})\n        {{ 'others.form_pagination' | fswTranslate : { data: { length: length.toString() } } }}\n      </strong>\n    </main>\n    <button\n      fswButton\n      [appearance]=\"'icon-no-bg'\"\n      [disabled]=\"(index$ | async) === length - 1\"\n      (click)=\"next(length)\"\n    >\n      <i [fswIcon]=\"'common-arrow-right'\" [fontSize]=\"'36px'\"></i>\n    </button>\n  </header>\n  <ng-container *ngIf=\"selected$ | async as selected\">\n    <main *ngIf=\"builder$ | async as builder\" class=\"px-[24px]\">\n      <form [formGroup]=\"builder.groupConfig.form\">\n        <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n      </form>\n    </main>\n    <footer class=\"flex justify-between items-center\" *ngIf=\"isEditable$ | async\">\n      <button fswButton class=\"!text-red-500\" [appearance]=\"'secondary'\" (click)=\"delete(selected)\">\n        {{\n          selected.proposal_type === 'LOAN'\n            ? ('buttons.delete_loan' | fswTranslate)\n            : ('buttons.delete_facility' | fswTranslate)\n        }}\n      </button>\n      <button fswButton (click)=\"edit(selected)\">\n        {{ 'buttons.edit_details' | fswTranslate }}\n      </button>\n    </footer>\n  </ng-container>\n</section>\n", dependencies: [{ kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-proposals-form', changeDetection: ChangeDetectionStrategy.OnPush, template: "<section class=\"flex flex-col gap-[16px]\" *ngIf=\"length$ | async as length\">\n  <header class=\"flex justify-between items-center w-full\">\n    <button\n      fswButton\n      [appearance]=\"'icon-no-bg'\"\n      [disabled]=\"(index$ | async) === 0\"\n      (click)=\"previous()\"\n    >\n      <i [fswIcon]=\"'common-arrow-left'\" [fontSize]=\"'36px'\"></i>\n    </button>\n    <main class=\"flex items-center gap-[8px]\">\n      <fsw-field [flexWidth]=\"true\">\n        <fsw-select\n          [closeOnSelected]=\"true\"\n          [ngModel]=\"index$.value\"\n          (ngModelChange)=\"index$.next($event)\"\n        >\n          <ng-container *ngFor=\"let option of options$ | async\">\n            <ng-template\n              fswSelectItem\n              [text]=\"(option + 1).toString()\"\n              [value]=\"option\"\n              [icon]=\"'checkbox'\"\n            ></ng-template>\n          </ng-container>\n        </fsw-select>\n      </fsw-field>\n      <strong *ngIf=\"selected$ | async as selected\">\n        ({{ selected.proposal_type }})\n        {{ 'others.form_pagination' | fswTranslate : { data: { length: length.toString() } } }}\n      </strong>\n    </main>\n    <button\n      fswButton\n      [appearance]=\"'icon-no-bg'\"\n      [disabled]=\"(index$ | async) === length - 1\"\n      (click)=\"next(length)\"\n    >\n      <i [fswIcon]=\"'common-arrow-right'\" [fontSize]=\"'36px'\"></i>\n    </button>\n  </header>\n  <ng-container *ngIf=\"selected$ | async as selected\">\n    <main *ngIf=\"builder$ | async as builder\" class=\"px-[24px]\">\n      <form [formGroup]=\"builder.groupConfig.form\">\n        <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n      </form>\n    </main>\n    <footer class=\"flex justify-between items-center\" *ngIf=\"isEditable$ | async\">\n      <button fswButton class=\"!text-red-500\" [appearance]=\"'secondary'\" (click)=\"delete(selected)\">\n        {{\n          selected.proposal_type === 'LOAN'\n            ? ('buttons.delete_loan' | fswTranslate)\n            : ('buttons.delete_facility' | fswTranslate)\n        }}\n      </button>\n      <button fswButton (click)=\"edit(selected)\">\n        {{ 'buttons.edit_details' | fswTranslate }}\n      </button>\n    </footer>\n  </ng-container>\n</section>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PROPOSALS_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PROPOSALS_FORM_TOKEN]
                }] }]; }, propDecorators: { editEvent: [{
                type: Output
            }], deleteEvent: [{
                type: Output
            }] } });

class FSWProposalsGridItemDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsGridItemDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWProposalsGridItemDirective, selector: "ng-template[fswProposalsGridItem]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsGridItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswProposalsGridItem]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

class FSWProposalsGridComponent {
    constructor() {
        this.itemDirective = null;
        this.rowClick = new EventEmitter();
        this.columns = {};
        this.rows = [];
        this.emptyMessage = 'No data available.';
        this.itemsPerPage = 10;
        this.currentPage = 1;
    }
    get columnKeys() {
        return Object.keys(this.columns);
    }
    get rowsToDisplay() {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.rows.slice(start, end);
    }
    getCurrency() {
        return getCurrentCountryConfig().currencyCode;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsGridComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWProposalsGridComponent, selector: "fsw-proposals-grid", inputs: { columns: "columns", rows: "rows", emptyMessage: "emptyMessage" }, outputs: { rowClick: "rowClick" }, queries: [{ propertyName: "itemDirective", first: true, predicate: FSWProposalsGridItemDirective, descendants: true }], ngImport: i0, template: "<table class=\"fsw-table w-full\">\n  <thead>\n    <tr>\n      <ng-container *ngFor=\"let key of columnKeys\">\n        <th>{{ columns[key] | fswTranslate : { data: { currency: getCurrency() } } }}</th>\n      </ng-container>\n    </tr>\n  </thead>\n  <tbody>\n    <tr *ngFor=\"let row of rowsToDisplay\" (click)=\"rowClick.emit(row)\">\n      <ng-container *ngIf=\"!itemDirective; else existedTemplate\">\n        <ng-container *ngFor=\"let key of columnKeys\">\n          <td>{{ row[key] }}</td>\n        </ng-container>\n      </ng-container>\n      <ng-template #existedTemplate>\n        <ng-container\n          *ngTemplateOutlet=\"$any(itemDirective?.templateRef); context: { $implicit: row }\"\n        ></ng-container>\n      </ng-template>\n    </tr>\n  </tbody>\n  <tfoot>\n    <tr *ngIf=\"rows.length\">\n      <td [colSpan]=\"columnKeys.length\">\n        <div class=\"flex justify-start\">\n          <fsw-pagination\n            [total]=\"rows.length\"\n            [(itemsPerPage)]=\"itemsPerPage\"\n            [(currentPage)]=\"currentPage\"\n          ></fsw-pagination>\n        </div>\n      </td>\n    </tr>\n    <tr *ngIf=\"!rows.length\">\n      <td [colSpan]=\"columnKeys.length\">\n        <div class=\"w-full py-[80px] flex items-center justify-center\">\n          <p class=\"text-center\">{{ emptyMessage }}</p>\n        </div>\n      </td>\n    </tr>\n  </tfoot>\n</table>\n", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i1$4.FSWPaginationComponent, selector: "fsw-pagination", inputs: ["total", "itemsPerPage", "currentPage", "itemsPerPageOptions", "showSelectOptions", "showViewTotalText", "showNavigationText", "totalTextInside"], outputs: ["currentPageChange", "itemsPerPageChange"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsGridComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-proposals-grid', changeDetection: ChangeDetectionStrategy.OnPush, template: "<table class=\"fsw-table w-full\">\n  <thead>\n    <tr>\n      <ng-container *ngFor=\"let key of columnKeys\">\n        <th>{{ columns[key] | fswTranslate : { data: { currency: getCurrency() } } }}</th>\n      </ng-container>\n    </tr>\n  </thead>\n  <tbody>\n    <tr *ngFor=\"let row of rowsToDisplay\" (click)=\"rowClick.emit(row)\">\n      <ng-container *ngIf=\"!itemDirective; else existedTemplate\">\n        <ng-container *ngFor=\"let key of columnKeys\">\n          <td>{{ row[key] }}</td>\n        </ng-container>\n      </ng-container>\n      <ng-template #existedTemplate>\n        <ng-container\n          *ngTemplateOutlet=\"$any(itemDirective?.templateRef); context: { $implicit: row }\"\n        ></ng-container>\n      </ng-template>\n    </tr>\n  </tbody>\n  <tfoot>\n    <tr *ngIf=\"rows.length\">\n      <td [colSpan]=\"columnKeys.length\">\n        <div class=\"flex justify-start\">\n          <fsw-pagination\n            [total]=\"rows.length\"\n            [(itemsPerPage)]=\"itemsPerPage\"\n            [(currentPage)]=\"currentPage\"\n          ></fsw-pagination>\n        </div>\n      </td>\n    </tr>\n    <tr *ngIf=\"!rows.length\">\n      <td [colSpan]=\"columnKeys.length\">\n        <div class=\"w-full py-[80px] flex items-center justify-center\">\n          <p class=\"text-center\">{{ emptyMessage }}</p>\n        </div>\n      </td>\n    </tr>\n  </tfoot>\n</table>\n" }]
        }], propDecorators: { itemDirective: [{
                type: ContentChild,
                args: [FSWProposalsGridItemDirective]
            }], rowClick: [{
                type: Output
            }], columns: [{
                type: Input
            }], rows: [{
                type: Input
            }], emptyMessage: [{
                type: Input
            }] } });

class FSWProposalsSwitchComponent extends FSWSwitchComponent {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsSwitchComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWProposalsSwitchComponent, selector: "fsw-proposals-switch", providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => FSWProposalsSwitchComponent),
                multi: true,
            },
            {
                provide: FSWControlBase,
                useExisting: FSWProposalsSwitchComponent,
            },
        ], usesInheritance: true, ngImport: i0, template: "<div\n  class=\"fsw-proposals-switch fsw-proposals-switch--size-{{ size }}\"\n  [class.has-error]=\"hasError\"\n  [class.read-only]=\"isReadonly\"\n  [class.disabled]=\"isDisabled\"\n  (click)=\"listenInputChange()\"\n>\n  <input\n    [id]=\"id\"\n    [disabled]=\"isDisabled\"\n    [readOnly]=\"isReadonly\"\n    [checked]=\"value\"\n    type=\"checkbox\"\n  />\n  <label *ngIf=\"label\" [for]=\"id\">{{ label }}</label>\n</div>\n", styles: [":host{display:contents}:host .fsw-proposals-switch{--fsw-switch-progress-height: 16px;--fsw-switch-height: 24px;--fsw-switch-circle-size: 24px;--fsw-switch-progress-background: #cccccc;--fsw-switch-circle-background: #8f8f8f;--fsw-switch-left: 4px;display:inline-flex;align-items:center;position:relative;gap:4px;width:120px;height:var(--fsw-switch-height)}:host .fsw-proposals-switch--size-l{--fsw-switch-progress-height: 40px;--fsw-switch-height: 32px;--fsw-switch-circle-size: 32px}:host .fsw-proposals-switch--size-l>label{font-weight:500;font-size:16px;line-height:1.5;font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif}:host .fsw-proposals-switch--size-l>label:lang(th){font-weight:500;font-size:16px;line-height:1.5;font-family:Inter,Prompt,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif}:host .fsw-proposals-switch--size-m{--fsw-switch-progress-height: 32px;--fsw-switch-height: 24px;--fsw-switch-circle-size: 24px}:host .fsw-proposals-switch--size-m>label{font-weight:500;font-size:14px;line-height:1.5;font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif}:host .fsw-proposals-switch--size-m>label:lang(th){font-weight:500;font-size:14px;line-height:1.5;font-family:Inter,Prompt,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif}:host .fsw-proposals-switch:before{position:absolute;border-radius:100px;top:50%;left:0;transform:translateY(-50%);content:\"\";width:100%;height:var(--fsw-switch-progress-height);background:var(--fsw-switch-progress-background)}:host .fsw-proposals-switch:after{position:absolute;border-radius:100%;content:\"\";width:var(--fsw-switch-circle-size);height:var(--fsw-switch-circle-size);background:var(--fsw-switch-circle-background);transition-property:background,left;transition-duration:.3s;transform:translateY(-50%);transition-timing-function:cubic-bezier(.4,0,.2,1);top:50%;left:var(--fsw-switch-left)}:host .fsw-proposals-switch>label{color:#4a4a4a;font-weight:600;z-index:1;margin:auto}:host .fsw-proposals-switch>input[type=checkbox]{opacity:0;position:absolute;z-index:2;width:100%;left:0;height:var(--fsw-switch-progress-height)}:host .fsw-proposals-switch:has(input[type=checkbox]:disabled){opacity:.4}:host .fsw-proposals-switch:has(input[type=checkbox]:disabled)>input[type=checkbox]{-webkit-user-select:none;user-select:none}:host .fsw-proposals-switch:has(input[type=checkbox]:not(:disabled))>input[type=checkbox]:hover{cursor:pointer}:host .fsw-proposals-switch:has(input[type=checkbox]:checked){--fsw-switch-progress-background: #79c0ff;--fsw-switch-circle-background: #ffffff;--fsw-switch-left: calc(100% - var(--fsw-switch-circle-size) - 4px)}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsSwitchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-proposals-switch', changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => FSWProposalsSwitchComponent),
                            multi: true,
                        },
                        {
                            provide: FSWControlBase,
                            useExisting: FSWProposalsSwitchComponent,
                        },
                    ], template: "<div\n  class=\"fsw-proposals-switch fsw-proposals-switch--size-{{ size }}\"\n  [class.has-error]=\"hasError\"\n  [class.read-only]=\"isReadonly\"\n  [class.disabled]=\"isDisabled\"\n  (click)=\"listenInputChange()\"\n>\n  <input\n    [id]=\"id\"\n    [disabled]=\"isDisabled\"\n    [readOnly]=\"isReadonly\"\n    [checked]=\"value\"\n    type=\"checkbox\"\n  />\n  <label *ngIf=\"label\" [for]=\"id\">{{ label }}</label>\n</div>\n", styles: [":host{display:contents}:host .fsw-proposals-switch{--fsw-switch-progress-height: 16px;--fsw-switch-height: 24px;--fsw-switch-circle-size: 24px;--fsw-switch-progress-background: #cccccc;--fsw-switch-circle-background: #8f8f8f;--fsw-switch-left: 4px;display:inline-flex;align-items:center;position:relative;gap:4px;width:120px;height:var(--fsw-switch-height)}:host .fsw-proposals-switch--size-l{--fsw-switch-progress-height: 40px;--fsw-switch-height: 32px;--fsw-switch-circle-size: 32px}:host .fsw-proposals-switch--size-l>label{font-weight:500;font-size:16px;line-height:1.5;font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif}:host .fsw-proposals-switch--size-l>label:lang(th){font-weight:500;font-size:16px;line-height:1.5;font-family:Inter,Prompt,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif}:host .fsw-proposals-switch--size-m{--fsw-switch-progress-height: 32px;--fsw-switch-height: 24px;--fsw-switch-circle-size: 24px}:host .fsw-proposals-switch--size-m>label{font-weight:500;font-size:14px;line-height:1.5;font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif}:host .fsw-proposals-switch--size-m>label:lang(th){font-weight:500;font-size:14px;line-height:1.5;font-family:Inter,Prompt,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif}:host .fsw-proposals-switch:before{position:absolute;border-radius:100px;top:50%;left:0;transform:translateY(-50%);content:\"\";width:100%;height:var(--fsw-switch-progress-height);background:var(--fsw-switch-progress-background)}:host .fsw-proposals-switch:after{position:absolute;border-radius:100%;content:\"\";width:var(--fsw-switch-circle-size);height:var(--fsw-switch-circle-size);background:var(--fsw-switch-circle-background);transition-property:background,left;transition-duration:.3s;transform:translateY(-50%);transition-timing-function:cubic-bezier(.4,0,.2,1);top:50%;left:var(--fsw-switch-left)}:host .fsw-proposals-switch>label{color:#4a4a4a;font-weight:600;z-index:1;margin:auto}:host .fsw-proposals-switch>input[type=checkbox]{opacity:0;position:absolute;z-index:2;width:100%;left:0;height:var(--fsw-switch-progress-height)}:host .fsw-proposals-switch:has(input[type=checkbox]:disabled){opacity:.4}:host .fsw-proposals-switch:has(input[type=checkbox]:disabled)>input[type=checkbox]{-webkit-user-select:none;user-select:none}:host .fsw-proposals-switch:has(input[type=checkbox]:not(:disabled))>input[type=checkbox]:hover{cursor:pointer}:host .fsw-proposals-switch:has(input[type=checkbox]:checked){--fsw-switch-progress-background: #79c0ff;--fsw-switch-circle-background: #ffffff;--fsw-switch-left: calc(100% - var(--fsw-switch-circle-size) - 4px)}\n"] }]
        }], ctorParameters: function () { return []; } });

class FSWProposalsHeaderComponent {
    get renderLabel() {
        return `modes.${this.renderType}`;
    }
    constructor(_cdr) {
        this._cdr = _cdr;
        this.renderTypeChange = new EventEmitter();
        this.refreshButtonClick = new EventEmitter();
        this.retrieveButtonClick = new EventEmitter();
        this.newLoanButtonClick = new EventEmitter();
        this.newFacilityButtonClick = new EventEmitter();
        this.renderType = FSWProposalsRenderTypes.GRID;
        this.disabledRefreshButton = false;
        this.hiddenRefreshButton = false;
        this.disabledRetrieveButton = false;
        this.hiddenRetrieveButton = false;
        this.disabledNewLoanButton = false;
        this.hiddenNewLoanButton = false;
        this.disabledNewFacilityButton = false;
        this.hiddenNewFacilityButton = false;
        this.hiddenSwitch = true;
        this.FSWProposalsRenderTypes = FSWProposalsRenderTypes;
    }
    changeRenderType(checked) {
        this.renderType = checked ? FSWProposalsRenderTypes.GRID : FSWProposalsRenderTypes.FORM;
        this.renderTypeChange.emit(this.renderType);
        this._cdr.markForCheck();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsHeaderComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWProposalsHeaderComponent, selector: "fsw-proposals-header", inputs: { renderType: "renderType", disabledRefreshButton: "disabledRefreshButton", hiddenRefreshButton: "hiddenRefreshButton", disabledRetrieveButton: "disabledRetrieveButton", hiddenRetrieveButton: "hiddenRetrieveButton", disabledNewLoanButton: "disabledNewLoanButton", hiddenNewLoanButton: "hiddenNewLoanButton", disabledNewFacilityButton: "disabledNewFacilityButton", hiddenNewFacilityButton: "hiddenNewFacilityButton", hiddenSwitch: "hiddenSwitch" }, outputs: { renderTypeChange: "renderTypeChange", refreshButtonClick: "refreshButtonClick", retrieveButtonClick: "retrieveButtonClick", newLoanButtonClick: "newLoanButtonClick", newFacilityButtonClick: "newFacilityButtonClick" }, ngImport: i0, template: "<header class=\"proposals-header\">\n  <aside>\n    <fsw-proposals-switch\n      *ngIf=\"!hiddenSwitch\"\n      [size]=\"'l'\"\n      [label]=\"\n        renderType === FSWProposalsRenderTypes.GRID\n          ? ('modes.grid' | fswTranslate)\n          : ('modes.form' | fswTranslate)\n      \"\n      [ngModel]=\"renderType === FSWProposalsRenderTypes.GRID\"\n      (ngModelChange)=\"changeRenderType($event)\"\n    ></fsw-proposals-switch>\n  </aside>\n  <main>\n    <button\n      [attr.data-test-id]=\"'proposals-header-refresh-button'\"\n      *ngIf=\"!hiddenRefreshButton\"\n      [disabled]=\"disabledRefreshButton\"\n      (click)=\"!disabledRefreshButton && refreshButtonClick.emit($event)\"\n      fswButton\n      appearance=\"secondary\"\n    >\n      {{ 'buttons.refresh' | fswTranslate }}\n    </button>\n    <button\n      [attr.data-test-id]=\"'proposals-header-retrieve-button'\"\n      *ngIf=\"!hiddenRetrieveButton\"\n      [disabled]=\"disabledRetrieveButton\"\n      (click)=\"!disabledRetrieveButton && retrieveButtonClick.emit($event)\"\n      fswButton\n      appearance=\"secondary\"\n    >\n      {{ 'buttons.retrieve_existing_facility' | fswTranslate }}\n    </button>\n    <button\n      [attr.data-test-id]=\"'proposals-header-new-loan'\"\n      *ngIf=\"!hiddenNewLoanButton\"\n      [disabled]=\"disabledNewLoanButton\"\n      (click)=\"!disabledNewLoanButton && newLoanButtonClick.emit($event)\"\n      fswButton\n      appearance=\"secondary\"\n    >\n      {{ 'buttons.new_loan' | fswTranslate }}\n    </button>\n    <button\n      [attr.data-test-id]=\"'proposals-header-new-facility'\"\n      *ngIf=\"!hiddenNewFacilityButton\"\n      [disabled]=\"disabledNewFacilityButton\"\n      (click)=\"!disabledNewFacilityButton && newFacilityButtonClick.emit($event)\"\n      fswButton\n      appearance=\"secondary\"\n    >\n      {{ 'buttons.new_facility' | fswTranslate }}\n    </button>\n  </main>\n</header>\n", styles: [":host{display:contents}:host .proposals-header{display:flex;width:100%;align-items:center;justify-content:space-between}:host .proposals-header>main{display:flex;align-items:center;gap:1.25rem}\n"], dependencies: [{ kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: FSWProposalsSwitchComponent, selector: "fsw-proposals-switch" }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-proposals-header', changeDetection: ChangeDetectionStrategy.OnPush, template: "<header class=\"proposals-header\">\n  <aside>\n    <fsw-proposals-switch\n      *ngIf=\"!hiddenSwitch\"\n      [size]=\"'l'\"\n      [label]=\"\n        renderType === FSWProposalsRenderTypes.GRID\n          ? ('modes.grid' | fswTranslate)\n          : ('modes.form' | fswTranslate)\n      \"\n      [ngModel]=\"renderType === FSWProposalsRenderTypes.GRID\"\n      (ngModelChange)=\"changeRenderType($event)\"\n    ></fsw-proposals-switch>\n  </aside>\n  <main>\n    <button\n      [attr.data-test-id]=\"'proposals-header-refresh-button'\"\n      *ngIf=\"!hiddenRefreshButton\"\n      [disabled]=\"disabledRefreshButton\"\n      (click)=\"!disabledRefreshButton && refreshButtonClick.emit($event)\"\n      fswButton\n      appearance=\"secondary\"\n    >\n      {{ 'buttons.refresh' | fswTranslate }}\n    </button>\n    <button\n      [attr.data-test-id]=\"'proposals-header-retrieve-button'\"\n      *ngIf=\"!hiddenRetrieveButton\"\n      [disabled]=\"disabledRetrieveButton\"\n      (click)=\"!disabledRetrieveButton && retrieveButtonClick.emit($event)\"\n      fswButton\n      appearance=\"secondary\"\n    >\n      {{ 'buttons.retrieve_existing_facility' | fswTranslate }}\n    </button>\n    <button\n      [attr.data-test-id]=\"'proposals-header-new-loan'\"\n      *ngIf=\"!hiddenNewLoanButton\"\n      [disabled]=\"disabledNewLoanButton\"\n      (click)=\"!disabledNewLoanButton && newLoanButtonClick.emit($event)\"\n      fswButton\n      appearance=\"secondary\"\n    >\n      {{ 'buttons.new_loan' | fswTranslate }}\n    </button>\n    <button\n      [attr.data-test-id]=\"'proposals-header-new-facility'\"\n      *ngIf=\"!hiddenNewFacilityButton\"\n      [disabled]=\"disabledNewFacilityButton\"\n      (click)=\"!disabledNewFacilityButton && newFacilityButtonClick.emit($event)\"\n      fswButton\n      appearance=\"secondary\"\n    >\n      {{ 'buttons.new_facility' | fswTranslate }}\n    </button>\n  </main>\n</header>\n", styles: [":host{display:contents}:host .proposals-header{display:flex;width:100%;align-items:center;justify-content:space-between}:host .proposals-header>main{display:flex;align-items:center;gap:1.25rem}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { renderTypeChange: [{
                type: Output
            }], refreshButtonClick: [{
                type: Output
            }], retrieveButtonClick: [{
                type: Output
            }], newLoanButtonClick: [{
                type: Output
            }], newFacilityButtonClick: [{
                type: Output
            }], renderType: [{
                type: Input
            }], disabledRefreshButton: [{
                type: Input
            }], hiddenRefreshButton: [{
                type: Input
            }], disabledRetrieveButton: [{
                type: Input
            }], hiddenRetrieveButton: [{
                type: Input
            }], disabledNewLoanButton: [{
                type: Input
            }], hiddenNewLoanButton: [{
                type: Input
            }], disabledNewFacilityButton: [{
                type: Input
            }], hiddenNewFacilityButton: [{
                type: Input
            }], hiddenSwitch: [{
                type: Input
            }] } });

class FSWProposalsContainerComponent extends FSWDynamicBuilderContainerComponent {
    get title() {
        return this.element?.customProps?.title ?? '';
    }
    get customClasses() {
        return this.element?.customProps?.customClasses ?? '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsContainerComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWProposalsContainerComponent, selector: "fsw-proposals-container", host: { properties: { "class": "this.customClasses" } }, usesInheritance: true, ngImport: i0, template: "<fsw-panel [title]=\"title\">\n  <fsw-dynamic-builder-container\n    [element]=\"element\"\n    [dictionaries]=\"dictionaries\"\n    [config]=\"config\"\n    [index]=\"index\"\n  ></fsw-dynamic-builder-container>\n</fsw-panel>\n", dependencies: [{ kind: "component", type: i1$4.FSWDynamicBuilderContainerComponent, selector: "fsw-dynamic-builder-container" }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-proposals-container', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-panel [title]=\"title\">\n  <fsw-dynamic-builder-container\n    [element]=\"element\"\n    [dictionaries]=\"dictionaries\"\n    [config]=\"config\"\n    [index]=\"index\"\n  ></fsw-dynamic-builder-container>\n</fsw-panel>\n" }]
        }], propDecorators: { customClasses: [{
                type: HostBinding,
                args: ['class']
            }] } });

var modes$2 = {
	grid: "Grid",
	form: "Form"
};
var tables$5 = {
	proposals: {
		columns: {
			type: "Product / Facility Type",
			borrower: "Borrower",
			code: "Code",
			status: "Status",
			limit: "Limit ({{currency}})",
			action: ""
		}
	},
	facilities: {
		title: "Search Existing Facility",
		columns: {
			borrower: "Borrower",
			name: "Facility Name",
			code: "Facility Code",
			status: "Status",
			limit: "Limit",
			type: "Type",
			interest: "Interest",
			period: "Period"
		}
	}
};
var empty$3 = {
	proposals: "No proposals found",
	facilities: "No facilities found"
};
var buttons$h = {
	cancel: "Cancel",
	refresh: "Refresh",
	save_changes: "Save Changes",
	new_loan: "New Loan",
	new_facility: "New Facility",
	delete_loan: "Delete Loan",
	delete_facility: "Delete Facility",
	edit_details: "Edit Details",
	retrieve_existing_facility: "Retrieve Existing Facility",
	back: "Back",
	"import": "Import",
	no: "No",
	yes: "Yes"
};
var forms$5 = {
	loan: {
		borrower: "Borrower",
		number: "Loan Number",
		product: "Product",
		amount: "Loan Amount ({{currency}})",
		source_of_funds: "Source of Funds",
		purpose: "Loan Purpose",
		installment_types: "Installment Types",
		interest_rate: "Interest Rate",
		late_interest_rate: "Late Interest Rate",
		tenor: "Tenor",
		late_fee: "Late Fee",
		period: "Period"
	},
	facility: {
		borrower: "Borrower",
		status: "Status",
		current_version: "Current Version",
		code: "Facility Code",
		max_loan_to_value: "Max Loan to Value",
		minimum_amount_due: "Minimum Amount Due",
		disbursement_request_period: "Disbursement Request Period",
		version: "Version",
		new_version: "New Version",
		plafond_type: "Plafond Type",
		type: "Facility Type",
		product: "Product",
		origination_fee: "Origination Fee",
		limit: "Limit",
		ltv: "LTV",
		source_of_funds: "Source of Funds",
		days_to_crowdfund: "Days to Crowdfund",
		due_days_per_month: "Due Day per Month (Revolver only)",
		annual_fee: "Annual Fee",
		facility_fee: "Facility Fee",
		interest_rate: "Interest Rate",
		admin_fee: "Admin Fee",
		service_fee: "Service Fee",
		restructure: "Restructure Fee",
		credit_term: "Credit Term",
		discounting: "Discounting",
		tenor: "Tenor",
		late_increment_day: "Late Increment Day",
		late_fee: "Late Fee",
		late_interest_fee: "Late Interest Fee (%)",
		late_interest_fee_type: "Late Interest Fee Type",
		period: "Period",
		start_date: "Start Date",
		end_date: "End Date",
		facility_start_date: "Facility Start Date",
		facility_end_date: "Facility End Date",
		facility_limit: "Facility Limit",
		ltv_percentage: "LTV (%)",
		credit_term_new: "Credit Term (Days)",
		admin_fee_period: "Admin Fee Period",
		facility_fee_period: "Facility Fee Period",
		interest_rate_period: "Interest Rate Period",
		late_interest_fee_period: "Late Interest Fee Period",
		discounting_percentage: "Discounting (%)",
		discounting_period: "Discounting Period",
		late_fee_period: "Late Fee Period"
	}
};
var modals$4 = {
	loan: {
		edit: "Edit Loan",
		view: "View Loan",
		"new": "New Loan",
		confirm_add: "Are you sure you want to add this Loan ?",
		confirm_add_title: "Confirm Add Loan",
		confirm_edit: "Are you sure you want to update this Loan ?",
		confirm_edit_title: "Confirm Edit Loan",
		confirm_delete: "You will lose all the information, Are you sure you want to delete this Loan ?",
		confirm_delete_title: "Confirm Delete Loan"
	},
	facility: {
		edit: "Edit Facility",
		view: "View Facility",
		"new": "New Facility",
		"import": "Import Facility {{code}}",
		confirm_add: "Are you sure you want to add this Facility ?",
		confirm_add_title: "Confirm Add Facility",
		confirm_import: "Are you sure you want to import facility {{code}}?",
		confirm_import_title: "Confirm Import Facility",
		confirm_edit: "Are you sure you want to update this Facility ?",
		confirm_edit_title: "Confirm Edit Facility",
		confirm_delete: "You will lose all the information, Are you sure you want to delete this Facility ?",
		confirm_delete_title: "Confirm Delete Facility"
	}
};
var others$2 = {
	form_pagination: " of {{length}} Proposals"
};
var my$1 = {
	modes: modes$2,
	tables: tables$5,
	empty: empty$3,
	buttons: buttons$h,
	forms: forms$5,
	modals: modals$4,
	others: others$2
};

var MY$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$h,
    default: my$1,
    empty: empty$3,
    forms: forms$5,
    modals: modals$4,
    modes: modes$2,
    others: others$2,
    tables: tables$5
});

var modes$1 = {
	grid: "Grid",
	form: "Form"
};
var tables$4 = {
	proposals: {
		columns: {
			type: "Product / Facility Type",
			borrower: "Borrower",
			code: "Code",
			status: "Status",
			limit: "Limit ({{currency}})",
			action: ""
		}
	},
	facilities: {
		title: "Search Existing Facility",
		columns: {
			borrower: "Borrower",
			name: "Facility Name",
			code: "Facility Code",
			status: "Status",
			limit: "Limit",
			type: "Type",
			interest: "Interest",
			period: "Period"
		}
	}
};
var empty$2 = {
	proposals: "No proposals found",
	facilities: "No facilities found"
};
var buttons$g = {
	cancel: "Cancel",
	refresh: "Refresh",
	save_changes: "Save Changes",
	new_loan: "New Loan",
	new_facility: "New Facility",
	delete_loan: "Delete Loan",
	delete_facility: "Delete Facility",
	edit_details: "Edit Details",
	retrieve_existing_facility: "Retrieve Existing Facility",
	back: "Back",
	"import": "Import",
	no: "No",
	yes: "Yes"
};
var forms$4 = {
	loan: {
		borrower: "Borrower",
		number: "Loan Number",
		product: "Product",
		amount: "Loan Amount ({{currency}})",
		source_of_funds: "Source of Funds",
		purpose: "Loan Purpose",
		installment_types: "Installment Types",
		interest_rate: "Interest Rate",
		late_interest_rate: "Late Interest Rate",
		tenor: "Tenor",
		late_fee: "Late Fee",
		period: "Period"
	},
	facility: {
		borrower: "Borrower",
		status: "Status",
		current_version: "Current Version",
		code: "Facility Code",
		max_loan_to_value: "Max Loan to Value",
		minimum_amount_due: "Minimum Amount Due",
		disbursement_request_period: "Disbursement Request Period",
		version: "Version",
		new_version: "New Version",
		plafond_type: "Plafond Type",
		type: "Facility Type",
		product: "Product",
		origination_fee: "Origination Fee",
		limit: "Limit",
		ltv: "LTV",
		source_of_funds: "Source of Funds",
		days_to_crowdfund: "Days to Crowdfund",
		due_days_per_month: "Due Day per Month (Revolver only)",
		annual_fee: "Annual Fee",
		facility_fee: "Facility Fee",
		interest_rate: "Interest Rate",
		admin_fee: "Admin Fee",
		service_fee: "Service Fee",
		restructure: "Restructure Fee",
		credit_term: "Credit Term",
		discounting: "Discounting",
		tenor: "Tenor",
		late_increment_day: "Late Increment Day",
		late_fee: "Late Fee",
		late_interest_fee: "Late Interest Fee",
		late_interest_fee_type: "Late Interest Fee Type",
		period: "Period",
		start_date: "Start Date",
		end_date: "End Date"
	}
};
var modals$3 = {
	loan: {
		edit: "Edit Loan",
		view: "View Loan",
		"new": "New Loan",
		confirm_add: "Are you sure you want to add this Loan ?",
		confirm_add_title: "Confirm Add Loan",
		confirm_edit: "Are you sure you want to update this Loan ?",
		confirm_edit_title: "Confirm Edit Loan",
		confirm_delete: "You will lose all the information, Are you sure you want to delete this Loan ?",
		confirm_delete_title: "Confirm Delete Loan"
	},
	facility: {
		edit: "Edit Facility",
		view: "View Facility",
		"new": "New Facility",
		"import": "Import Facility {{code}}",
		confirm_add: "Are you sure you want to add this Facility ?",
		confirm_add_title: "Confirm Add Facility",
		confirm_import: "Are you sure you want to import facility {{code}}?",
		confirm_import_title: "Confirm Import Facility",
		confirm_edit: "Are you sure you want to update this Facility ?",
		confirm_edit_title: "Confirm Edit Facility",
		confirm_delete: "You will lose all the information, Are you sure you want to delete this Facility ?",
		confirm_delete_title: "Confirm Delete Facility"
	}
};
var others$1 = {
	form_pagination: " of {{length}} Proposals"
};
var sg = {
	modes: modes$1,
	tables: tables$4,
	empty: empty$2,
	buttons: buttons$g,
	forms: forms$4,
	modals: modals$3,
	others: others$1
};

var SG = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$g,
    default: sg,
    empty: empty$2,
    forms: forms$4,
    modals: modals$3,
    modes: modes$1,
    others: others$1,
    tables: tables$4
});

var modes = {
	grid: "Grid",
	form: "Form"
};
var tables$3 = {
	proposals: {
		columns: {
			type: "Product / Facility Type",
			borrower: "Borrower",
			code: "Code",
			status: "Status",
			limit: "Limit ({{currency}})",
			action: ""
		}
	},
	facilities: {
		title: "Search Existing Facility",
		columns: {
			borrower: "Borrower",
			name: "Facility Name",
			code: "Facility Code",
			status: "Status",
			limit: "Limit",
			type: "Type",
			interest: "Interest",
			period: "Period"
		}
	}
};
var empty$1 = {
	proposals: "No proposals found",
	facilities: "No facilities found"
};
var buttons$f = {
	cancel: "Cancel",
	refresh: "Refresh",
	save_changes: "Save Changes",
	new_loan: "New Loan",
	new_facility: "New Facility",
	delete_loan: "Delete Loan",
	delete_facility: "Delete Facility",
	edit_details: "Edit Details",
	retrieve_existing_facility: "Retrieve Existing Facility",
	back: "Back",
	"import": "Import",
	no: "No",
	yes: "Yes"
};
var forms$3 = {
	loan: {
		borrower: "Borrower",
		number: "Loan Number",
		product: "Product",
		amount: "Loan Amount ({{currency}})",
		source_of_funds: "Source of Funds",
		purpose: "Loan Purpose",
		installment_types: "Installment Types",
		interest_rate: "Interest Rate",
		late_interest_rate: "Late Interest Rate",
		tenor: "Tenor",
		late_fee: "Late Fee",
		period: "Period"
	},
	facility: {
		borrower: "Borrower",
		status: "Status",
		current_version: "Current Version",
		code: "Facility Code",
		max_loan_to_value: "Max Loan to Value",
		minimum_amount_due: "Minimum Amount Due",
		disbursement_request_period: "Disbursement Request Period",
		version: "Version",
		new_version: "New Version",
		plafond_type: "Plafond Type",
		type: "Facility Type",
		product: "Product",
		origination_fee: "Origination Fee",
		limit: "Limit",
		ltv: "LTV",
		source_of_funds: "Source of Funds",
		days_to_crowdfund: "Days to Crowdfund",
		due_days_per_month: "Due Day per Month (Revolver only)",
		annual_fee: "Annual Fee",
		facility_fee: "Facility Fee",
		interest_rate: "Interest Rate",
		admin_fee: "Admin Fee",
		service_fee: "Service Fee",
		restructure: "Restructure Fee",
		credit_term: "Credit Term",
		discounting: "Discounting",
		tenor: "Tenor",
		late_increment_day: "Late Increment Day",
		late_fee: "Late Fee",
		late_interest_fee: "Late Interest Fee",
		late_interest_fee_type: "Late Interest Fee Type",
		period: "Period",
		start_date: "Start Date",
		end_date: "End Date"
	}
};
var modals$2 = {
	loan: {
		edit: "Edit Loan",
		view: "View Loan",
		"new": "New Loan",
		confirm_add: "Are you sure you want to add this Loan ?",
		confirm_add_title: "Confirm Add Loan",
		confirm_edit: "Are you sure you want to update this Loan ?",
		confirm_edit_title: "Confirm Edit Loan",
		confirm_delete: "You will lose all the information, Are you sure you want to delete this Loan ?",
		confirm_delete_title: "Confirm Delete Loan"
	},
	facility: {
		edit: "Edit Facility",
		view: "View Facility",
		"new": "New Facility",
		"import": "Import Facility {{code}}",
		confirm_add: "Are you sure you want to add this Facility ?",
		confirm_add_title: "Confirm Add Facility",
		confirm_import: "Are you sure you want to import facility {{code}}?",
		confirm_import_title: "Confirm Import Facility",
		confirm_edit: "Are you sure you want to update this Facility ?",
		confirm_edit_title: "Confirm Edit Facility",
		confirm_delete: "You will lose all the information, Are you sure you want to delete this Facility ?",
		confirm_delete_title: "Confirm Delete Facility"
	}
};
var others = {
	form_pagination: " of {{length}} Proposals"
};
var th$4 = {
	modes: modes,
	tables: tables$3,
	empty: empty$1,
	buttons: buttons$f,
	forms: forms$3,
	modals: modals$2,
	others: others
};

var TH$4 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$f,
    default: th$4,
    empty: empty$1,
    forms: forms$3,
    modals: modals$2,
    modes: modes,
    others: others,
    tables: tables$3
});

const FSW_PROPOSALS_TRANSLATION_LOADER = {
    [CountryCode.TH]: TH$4,
    [CountryCode.MY]: MY$1,
    [CountryCode.SG]: SG,
};

const fswProposalsInitialState = {
    applicationId: null,
    products: [],
    proposals: [],
    purposes: [],
    settings: null,
    facilities: [],
    facilityTypes: [],
    member: null,
    renderType: FSWProposalsRenderTypes.GRID,
    isReadonly: false,
    allowedProductUPIs: [],
};
class FSWProposalsStore extends ApplicationMemberInformationStore {
    constructor(_applicationMemberService, _applicationProposalService, _facilityService, _settingsService, _loanService, _alertService, _form, _initialOptionalState) {
        super(_applicationMemberService, Object.assign(fswProposalsInitialState, _initialOptionalState || {}));
        this._applicationMemberService = _applicationMemberService;
        this._applicationProposalService = _applicationProposalService;
        this._facilityService = _facilityService;
        this._settingsService = _settingsService;
        this._loanService = _loanService;
        this._alertService = _alertService;
        this._form = _form;
        this._initialOptionalState = _initialOptionalState;
        this.proposalsChange = new EventEmitter();
        this.init = this.effect(pipe(switchMap(() => this.loadAssets()), tap(() => this.loadProposals()), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        this.deleteProposal = this.effect(pipe(switchMap(({ id, cb }) => this._applicationProposalService
            .deleteProposal(this.state().applicationId, this.state().member?.uuid, id)
            .pipe(tap(() => {
            this._alertService.success('Notification', 'Proposal deleted successfully!', {
                duration: 3000,
            });
            this.loadProposals();
            cb && cb();
        }), catchError((err) => {
            this._alertService.error('Something went wrong', 'Fail to delete proposal. Please try again!', {
                duration: 3000,
            });
            console.error(err);
            return EMPTY;
        })))));
        this.loadProposals = this.effect(pipe(switchMap(() => this._applicationProposalService
            .getProposals(this.state().applicationId, {
            sort: 'name,DESC',
            include: 'MEMBER,PRODUCT',
        })
            .pipe(tap((proposals) => {
            this.updateState({ proposals });
            this.proposalsChange.emit(proposals);
        }), catchError((err) => {
            this._alertService.error('Something went wrong', 'Fail to load proposal. Please try again!', {
                duration: 3000,
            });
            console.error(err);
            return EMPTY;
        })))));
        this.loadFacilities = this.effect(pipe(switchMap(() => this._facilityService
            .getPreApprovedFacilities([Number(this.state().member?.id)], getCountryCodeFromStorage())
            .pipe(tap((facilities) => this.updateState({ facilities })), catchError((err) => {
            console.error(err);
            return EMPTY;
        })))));
        this.save = this.effect(pipe(switchMap(({ id, data, proposal_type }) => {
            data = {
                ...data,
                tenor: data.tenor?.toString(),
                tenor_type: data.tenor_type?.toString(),
                loan_type: data.loan_type?.toString(),
                late_interest_type: data.late_interest_type?.toString(),
                late_fee_type: data.late_fee_type?.toString(),
                late_interest_fee_type: data.late_interest_fee_type?.toString(),
            };
            const obs$ = id
                ? this._applicationProposalService.updateProposal(id, proposal_type, data)
                : this._applicationProposalService.addProposal(this.state().applicationId, this.state().member?.uuid, proposal_type, data);
            return obs$.pipe(tap(() => {
                this._alertService.success('Notification', 'Proposal saved successfully!', {
                    duration: 3000,
                });
                this.loadProposals();
            }), catchError((err) => {
                this._alertService.error('Something went wrong', 'Fail to save proposal. Please try again!', {
                    duration: 3000,
                });
                console.error(err);
                return EMPTY;
            }));
        })));
        this.updateState = (value) => this.patchState({
            ...value,
        });
    }
    getApplicationMembersInformation(entityId, applicationParams, memberParams) {
        return this._applicationMemberService.getApplicationMembersInformation(entityId, applicationParams, memberParams);
    }
    loadAssets() {
        return forkJoin([
            this.setupInformation(this.state().applicationId),
            this.setupListOfInformation(this.state().applicationId),
            this._loanService.getProducts(getCountryCodeFromStorage()).pipe(map((products) => {
                const allowedProductUPIs = (this.get().allowedProductUPIs || [])
                    .map((upi) => upi?.split('-')[1]?.toLowerCase())
                    .filter((upi) => !!upi);
                if (!allowedProductUPIs.length) {
                    return products;
                }
                return products.filter((product) => allowedProductUPIs.includes(product.code?.toLowerCase()));
            }), tap((products) => this.updateState({ products }))),
            this._loanService
                .getPurposes(getCountryCodeFromStorage())
                .pipe(tap((purposes) => this.updateState({ purposes }))),
            this._settingsService
                .getSettingsByKey('SME_TF')
                .pipe(tap((settings) => this.updateState({ settings }))),
            this._facilityService
                .getTypes(getCountryCodeFromStorage())
                .pipe(tap((facilityTypes) => this.updateState({ facilityTypes }))),
        ]);
    }
}

class FSWProposalsStoreMY extends FSWProposalsStore {
    constructor(_applicationMemberService, _applicationProposalService, _facilityService, _settingsService, _loanService, _alertService, _form) {
        super(_applicationMemberService, _applicationProposalService, _facilityService, _settingsService, _loanService, _alertService, _form);
        this._applicationMemberService = _applicationMemberService;
        this._applicationProposalService = _applicationProposalService;
        this._facilityService = _facilityService;
        this._settingsService = _settingsService;
        this._loanService = _loanService;
        this._alertService = _alertService;
        this._form = _form;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsStoreMY, deps: [{ token: APPLICATION_MEMBER_SERVICE_TOKEN }, { token: APPLICATION_PROPOSAL_SERVICE_TOKEN }, { token: FACILITY_SERVICE_TOKEN }, { token: SETTINGS_SERVICE_TOKEN }, { token: FSW_LOAN_SERVICE_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }, { token: FSW_PROPOSALS_FORM_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsStoreMY }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsStoreMY, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_PROPOSAL_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FACILITY_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SETTINGS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_LOAN_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PROPOSALS_FORM_TOKEN]
                }] }]; } });

function getProposalsMember(members, ids) {
    return members?.find((member) => member.uuid === ids.uuid || member.id == ids.id) || null;
}
function getProposalsMemberName(member) {
    if (!member) {
        return '-';
    }
    let name = '';
    if (member.member_entity_code === 'INS' || member.member_entity_code === 'CORPORATE') {
        name = member.company_name;
    }
    name = name || member.fullname || member.username || member.company_name || '-';
    return name;
}

const allowedProposalsFacilityStatuses = new Set(['EXPIRED', 'TO-BE-RENEWED', 'LIVE']);

const FSWProposalsFormMY = (form, type, method, state, isReadonly$) => {
    const translation = FSW_PROPOSALS_TRANSLATION_LOADER[CountryCode.MY];
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'w-full',
        readonlyWhen$: isReadonly$,
        renderBy: 'container',
        containers: getContainers$2(type, method, translation, state),
        form,
    });
};
function getContainers$2(type, method, translation, state) {
    switch (type) {
        case FSWProposalsFormTypes.LOAN:
            return getLoanContainers$2(method, translation, state);
        case FSWProposalsFormTypes.FACILITY:
            return getFacilityContainers$2(method, translation, state);
        case FSWProposalsFormTypes.FACILITY_IMPORT:
        case FSWProposalsFormTypes.FACILITY_AFTER_IMPORT:
            return getFacilityImportContainers$2(type, method, translation, state);
    }
}
function getLoanContainers$2(method, translation, state) {
    let hiddenObj = {};
    if (method === 'POST') {
        hiddenObj = {
            product_id: 0,
            instance: '',
            limit: 0,
            term: 0,
            term_type: '',
            ltv: 0,
            installment: 0,
            admin_fee: 0,
            admin_fee_period: '',
            facility_fee: 0,
            facility_fee_period: '',
            origination_fee: 0,
            service_fee: 0,
            service_fee_period: '',
            late_interest_fee: 0,
            crowdfund_day: 0,
            annual_fee: 0,
            discounting: 0,
            discounting_type: '',
            facility_type_id: 0,
            plafond_type: '',
            version: 0,
            code: '',
            status: '',
            start_date: new Date(),
            end_date: new Date(),
            late_interest_fee_type: '',
            disbursement_request_period: '',
            max_loan_to_value: 0,
            minimum_amount_due: 0,
            late_increment_day: 0,
            interest_term: '',
            due_day_per_month: 0,
            restructure_fee: 0,
            restructure_fee_type: '',
        };
    }
    else {
        hiddenObj['id'] = '';
    }
    const keys = Object.keys(hiddenObj);
    const containers = keys.length
        ? [
            {
                customClasses: 'hidden',
                fields: keys.map((key) => ({
                    key,
                    type: FSWDynamicBuilderControlTypes.TEMPLATE,
                    context: {
                        defaultValue: hiddenObj[key],
                        isHidden: true,
                    },
                })),
            },
        ]
        : [];
    return [
        {
            customClasses: 'flex justify-between gap-[16px]',
            containers: [
                {
                    customClasses: 'flex-1 flex flex-col gap-[16px] w-[calc(50%-8px)]',
                    fields: [
                        {
                            key: 'member_id',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                label: translation.forms.loan.borrower,
                                items: state.members?.map((member) => ({
                                    value: member.uuid,
                                    text: getProposalsMemberName(member),
                                })) || [],
                                fullWidth: true,
                                isRequired: true,
                                isDisabled: method === 'PUT',
                                readonlyTemplate: (uuid) => uuid
                                    ? getProposalsMemberName(getProposalsMember(state.members || [], { uuid }))
                                    : 'N/A',
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'loan_code',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                label: translation.forms.loan.number,
                                isDisabled: true,
                                fullWidth: true,
                                isRequired: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'source_of_fund',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                defaultValue: 'CF',
                                label: translation.forms.loan.source_of_funds,
                                items: sourceOfFunds,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => sourceOfFunds.find((item) => item.value == value)?.text || 'N/A',
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'installment_types',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                defaultValue: 1,
                                label: translation.forms.loan.installment_types,
                                items: installmentTypes,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => installmentTypes.find((item) => item.value == value)?.text || 'N/A',
                            },
                            validations: [Validators.required],
                        },
                    ],
                    containers: [
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'late_interest_rate',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number', // Commented out
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.loan.late_interest_rate,
                                        fullWidth: true,
                                        suffix: '%',
                                        isRequired: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required, Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'late_interest_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 360,
                                        label: translation.forms.loan.period,
                                        isRequired: true,
                                        items: interestTypes,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => interestTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'tenor',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number', // Commented out
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.loan.tenor,
                                        fullWidth: true,
                                        isRequired: true,
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'tenor_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 30,
                                        label: translation.forms.loan.period,
                                        isRequired: true,
                                        items: tenorTypes,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => tenorTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                    ],
                },
                {
                    customClasses: 'flex-1 flex flex-col gap-[16px] w-[calc(50%-8px)]',
                    fields: [
                        {
                            key: 'loan_type',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                label: translation.forms.loan.product,
                                items: state.products.map((product) => ({
                                    text: product.name,
                                    value: product.id,
                                })),
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => state.products.find((item) => item.id === value)?.name || 'N/A',
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'loan_amount',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.loan.amount.replace('{{currency}}', getCurrentCountryConfig().currencyCode),
                                // prefix: getCurrentCountryConfig().currencyCode,
                                // inputType: 'number', // Commented out
                                isRequired: true,
                                fullWidth: true,
                                showError: true,
                                errorText: 'Minimum value of 10000 is required',
                                readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                            },
                            validations: [Validators.required, Validators.min(10000)],
                        },
                        {
                            key: 'loan_purpose',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                label: translation.forms.loan.purpose,
                                items: state.purposes.map((purpose) => ({
                                    text: purpose.name_eng,
                                    value: purpose.id,
                                })),
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => state.purposes.find((item) => item.id === value)?.name_eng || 'N/A',
                            },
                            validations: [Validators.required],
                        },
                    ],
                    containers: [
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'interest_rate',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number', // Commented out
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.loan.interest_rate,
                                        fullWidth: true,
                                        suffix: '%',
                                        isRequired: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required, Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'interest_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 360,
                                        label: translation.forms.loan.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: interestTypes,
                                        readonlyTemplate: (value) => interestTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'late_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number', // Commented out
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.loan.late_fee,
                                        prefix: getCurrentCountryConfig().currencyCode,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                                    },
                                },
                                {
                                    key: 'late_fee_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 360,
                                        label: translation.forms.loan.period,
                                        fullWidth: true,
                                        items: interestTypes,
                                        readonlyTemplate: (value) => interestTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        ...containers,
    ];
}
function getFacilityContainers$2(method, translation, state) {
    let hiddenObj = {};
    if (method === 'POST') {
        hiddenObj = {
            instance: '',
            installment: 15,
            version: 0,
            code: '',
            status: '',
            start_date: new Date(),
            end_date: new Date(),
            disbursement_request_period: '',
            max_loan_to_value: 0,
            minimum_amount_due: 0,
            late_increment_day: 0,
            loan_number: '',
            loan_type: 0,
            loan_amount: 0,
            loan_purpose: null,
            installment_types: null,
            interest_type: null,
            late_interest_rate: 0,
            late_interest_type: 0,
            late_fee_type: null,
        };
    }
    else {
        hiddenObj['id'] = '';
    }
    const keys = Object.keys(hiddenObj);
    const containers = keys.length
        ? [
            {
                customClasses: 'hidden',
                fields: keys.map((key) => ({
                    key,
                    type: FSWDynamicBuilderControlTypes.TEMPLATE,
                    context: {
                        defaultValue: hiddenObj[key],
                        isHidden: true,
                    },
                })),
            },
        ]
        : [];
    return [
        {
            customClasses: 'flex justify-between gap-[16px]',
            containers: [
                {
                    customClasses: 'flex-1 flex flex-col gap-[16px] w-[calc(50%-8px)]',
                    fields: [
                        {
                            key: 'member_id',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                label: translation.forms.facility.borrower,
                                items: state.members?.map((member) => ({
                                    value: member.uuid,
                                    text: getProposalsMemberName(member),
                                })) || [],
                                fullWidth: true,
                                isRequired: true,
                                isDisabled: method === 'PUT',
                                readonlyTemplate: (uuid) => uuid
                                    ? getProposalsMemberName(getProposalsMember(state.members || [], { uuid }))
                                    : 'N/A',
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'facility_type_id',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                label: translation.forms.facility.type,
                                items: state.facilityTypes.map((item) => ({
                                    value: item.id,
                                    text: item.description,
                                })) || [],
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => state.facilityTypes.find((item) => item.id === value)?.description || 'N/A',
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'product_id',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                label: translation.forms.facility.product,
                                items: state.products.map((product) => ({
                                    text: product.name,
                                    value: product.id,
                                })),
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => state.products.find((item) => item.id === value)?.name || 'N/A',
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'limit',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.limit,
                                prefix: getCurrentCountryConfig().currencyCode,
                                // inputType: 'number', // Commented out
                                isRequired: true,
                                fullWidth: true,
                                readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'late_fee',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number', // Commented out
                                defaultValue: 1000,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.late_fee,
                                prefix: getCurrentCountryConfig().currencyCode,
                                fullWidth: true,
                                readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                            },
                        },
                        {
                            key: 'late_interest_fee',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0.1,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.late_interest_fee,
                                suffix: '% per day',
                                // inputType: 'number', // Commented out
                                isRequired: true,
                                fullWidth: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'annual_fee',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0,
                                label: translation.forms.facility.annual_fee,
                                prefix: getCurrentCountryConfig().currencyCode,
                                // inputType: 'number', // Commented out
                                fullWidth: true,
                                readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                            },
                        },
                    ],
                    containers: [
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'interest_rate',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number', // Commented out
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.interest_rate,
                                        fullWidth: true,
                                        suffix: '%',
                                        isRequired: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required, Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'interest_term',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: interestTerms,
                                        readonlyTemplate: (value) => interestTerms.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'term',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number', // Commented out
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.credit_term,
                                        fullWidth: true,
                                        isRequired: true,
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'term_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'day',
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: termTypes,
                                        readonlyTemplate: (value) => termTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'discounting',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number', // Commented out
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        suffix: '%',
                                        label: translation.forms.facility.discounting,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'discounting_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        fullWidth: true,
                                        items: periodTypes,
                                        readonlyTemplate: (value) => periodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'tenor',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number', // Commented out
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.tenor,
                                        fullWidth: true,
                                        isRequired: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'tenor_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 30,
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: tenorTypes,
                                        readonlyTemplate: (value) => tenorTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                    ],
                },
                {
                    customClasses: 'flex-1 flex flex-col gap-[16px] w-[calc(50%-8px)]',
                    fields: [
                        {
                            key: 'start_date',
                            type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                            context: {
                                fullWidth: true,
                                isRequired: true,
                                label: translation.forms.facility.start_date,
                                closeOnSelected: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'end_date',
                            type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                            context: {
                                fullWidth: true,
                                isRequired: true,
                                label: translation.forms.facility.end_date,
                                closeOnSelected: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'source_of_fund',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                defaultValue: 'CF',
                                label: translation.forms.loan.source_of_funds,
                                items: sourceOfFunds,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => sourceOfFunds.find((item) => item.value == value)?.text || 'N/A',
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'origination_fee',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.origination_fee,
                                prefix: getCurrentCountryConfig().currencyCode,
                                // inputType: 'number', // Commented out
                                isRequired: true,
                                fullWidth: true,
                                readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'ltv',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.ltv,
                                suffix: '%',
                                // inputType: 'number', // Commented out
                                isRequired: true,
                                fullWidth: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required, Validators.min(0), Validators.max(100)],
                        },
                        {
                            key: 'crowdfund_day',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.days_to_crowdfund,
                                suffix: 'days',
                                // inputType: 'number', // Commented out
                                fullWidth: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                        },
                        {
                            key: 'late_interest_fee_type',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                defaultValue: 'PER_ANNUM',
                                label: translation.forms.facility.late_interest_fee_type,
                                isRequired: true,
                                fullWidth: true,
                                items: latePeriods,
                                readonlyTemplate: (value) => latePeriods.find((item) => item.value == value)?.text || 'N/A',
                            },
                            validations: [Validators.required],
                        },
                    ],
                    containers: [
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'facility_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number', // Commented out
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.facility_fee,
                                        fullWidth: true,
                                        suffix: '%',
                                        isRequired: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required, Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'facility_fee_period',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: periodTypes,
                                        readonlyTemplate: (value) => periodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'admin_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number', // Commented out
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.admin_fee,
                                        fullWidth: true,
                                        suffix: '%',
                                        isRequired: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required, Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'admin_fee_period',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: adminPeriodTypes,
                                        readonlyTemplate: (value) => adminPeriodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'service_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number', // Commented out
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.service_fee,
                                        fullWidth: true,
                                        suffix: '%',
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'service_fee_period',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        fullWidth: true,
                                        items: periodTypes,
                                        readonlyTemplate: (value) => periodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'restructure_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number', // Commented out
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.restructure,
                                        fullWidth: true,
                                        suffix: '%',
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'restructure_fee_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        fullWidth: true,
                                        items: periodTypes,
                                        readonlyTemplate: (value) => periodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        ...containers,
    ];
}
function getFacilityImportContainers$2(type, method, translation, state) {
    let hiddenObj = {};
    if (method === 'POST') {
        hiddenObj = {
            instance: '',
            installment: 0,
            origination_fee: 0,
            service_fee: 0,
            service_fee_period: '',
            plafond_type: '',
            due_day_per_month: 0,
            loan_number: '',
            loan_type: 0,
            loan_amount: 0,
            loan_purpose: null,
            installment_types: null,
            interest_type: null,
            late_interest_rate: 0,
            late_interest_type: 0,
            source_of_fund: '',
        };
    }
    else {
        hiddenObj['id'] = '';
    }
    const keys = Object.keys(hiddenObj);
    const containers = keys.length
        ? [
            {
                customClasses: 'hidden',
                fields: keys.map((key) => ({
                    key,
                    type: FSWDynamicBuilderControlTypes.TEMPLATE,
                    context: {
                        defaultValue: hiddenObj[key],
                        isHidden: true,
                    },
                })),
            },
        ]
        : [];
    if (method === 'PUT') {
        return [
            {
                customClasses: 'flex flex-wrap gap-[16px]',
                containers: [
                    {
                        name: 'proposals-container',
                        customProps: {
                            title: '',
                            customClasses: 'w-full',
                        },
                        containers: [
                            {
                                customClasses: 'flex flex-wrap gap-[8px]',
                                fields: [
                                    {
                                        key: 'member_id',
                                        type: FSWDynamicBuilderControlTypes.SELECT,
                                        customClasses: 'w-[calc(50%-8px)]',
                                        context: {
                                            label: translation.forms.facility.borrower,
                                            items: state.members?.map((member) => ({
                                                value: member.uuid,
                                                text: getProposalsMemberName(member),
                                            })) || [],
                                            fullWidth: true,
                                            isRequired: true,
                                            isDisabled: method === 'PUT',
                                            readonlyTemplate: (uuid) => uuid
                                                ? getProposalsMemberName(getProposalsMember(state.members || [], { uuid }))
                                                : 'N/A',
                                        },
                                        validations: [Validators.required],
                                    },
                                    {
                                        key: 'code',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        customClasses: 'w-[calc(50%-8px)]',
                                        context: {
                                            label: translation.forms.facility.code,
                                            fullWidth: true,
                                            isRequired: true,
                                            isDisabled: true,
                                        },
                                        validations: [Validators.required],
                                    },
                                    {
                                        key: 'status',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        customClasses: 'w-[calc(50%-8px)]',
                                        context: {
                                            label: translation.forms.facility.status,
                                            fullWidth: true,
                                            isRequired: true,
                                            isDisabled: true,
                                        },
                                        validations: [Validators.required],
                                    },
                                    {
                                        key: 'version',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        customClasses: 'w-[calc(50%-8px)]',
                                        context: {
                                            defaultValue: 0,
                                            label: translation.forms.facility.version,
                                            isRequired: true,
                                            fullWidth: true,
                                            isDisabled: true,
                                        },
                                        validations: [Validators.required],
                                    },
                                    {
                                        key: 'facility_type_id',
                                        type: FSWDynamicBuilderControlTypes.SELECT,
                                        customClasses: 'w-[calc(50%-8px)]',
                                        context: {
                                            label: translation.forms.facility.type,
                                            items: state.facilityTypes.map((item) => ({
                                                value: item.id,
                                                text: item.description,
                                            })) || [],
                                            fullWidth: true,
                                            isRequired: true,
                                            isDisabled: true,
                                            readonlyTemplate: (value) => state.facilityTypes.find((item) => item.id === value)?.description || 'N/A',
                                        },
                                        validations: [Validators.required],
                                    },
                                    {
                                        key: 'product_id',
                                        type: FSWDynamicBuilderControlTypes.SELECT,
                                        customClasses: 'w-[calc(50%-8px)]',
                                        context: {
                                            label: translation.forms.facility.product,
                                            items: state.products.map((product) => ({
                                                text: product.name,
                                                value: product.id,
                                            })),
                                            fullWidth: true,
                                            isRequired: true,
                                            isDisabled: true,
                                            readonlyTemplate: (value) => state.products.find((item) => item.id === value)?.name || 'N/A',
                                        },
                                        validations: [Validators.required],
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        name: 'proposals-container',
                        customProps: {
                            title: 'Proposal',
                            customClasses: 'w-[calc(50%-8px)]',
                        },
                        containers: [
                            {
                                customClasses: 'flex flex-wrap gap-[8px]',
                                fields: _getFields$1(true, translation, false),
                            },
                        ],
                    },
                    {
                        name: 'proposals-container',
                        customProps: {
                            title: 'Recommendation',
                            customClasses: 'w-[calc(50%-8px)]',
                        },
                        fields: [
                            {
                                key: 'recommendation',
                                formType: FSWDynamicBuilderFormTypes.GROUP,
                                renderBy: 'container',
                                customClasses: 'w-full',
                                containers: [
                                    {
                                        customClasses: 'flex flex-wrap gap-[8px]',
                                        fields: _getFields$1(false, translation, true),
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            ...containers,
        ];
    }
    return [
        {
            customClasses: 'flex flex-wrap gap-[16px]',
            containers: [
                {
                    name: 'proposals-container',
                    customProps: {
                        title: '',
                        customClasses: 'w-full',
                    },
                    containers: [
                        {
                            customClasses: 'flex flex-wrap gap-[8px]',
                            fields: [
                                {
                                    key: 'member_id',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'w-[calc(50%-8px)]',
                                    context: {
                                        label: translation.forms.facility.borrower,
                                        items: state.members?.map((member) => ({
                                            value: member.uuid,
                                            text: getProposalsMemberName(member),
                                        })) || [],
                                        fullWidth: true,
                                        isRequired: true,
                                        isDisabled: false,
                                        readonlyTemplate: (uuid) => uuid
                                            ? getProposalsMemberName(getProposalsMember(state.members || [], { uuid }))
                                            : 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'code',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'w-[calc(50%-8px)]',
                                    context: {
                                        label: translation.forms.facility.code,
                                        fullWidth: true,
                                        isRequired: true,
                                        isDisabled: true,
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'status',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'w-[calc(50%-8px)]',
                                    context: {
                                        label: translation.forms.facility.status,
                                        fullWidth: true,
                                        isRequired: true,
                                        isDisabled: true,
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'version',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'w-[calc(50%-8px)]',
                                    context: {
                                        defaultValue: 0,
                                        label: translation.forms.facility.version,
                                        isRequired: true,
                                        fullWidth: true,
                                        isDisabled: true,
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'facility_type_id',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'w-[calc(50%-8px)]',
                                    context: {
                                        label: translation.forms.facility.type,
                                        items: state.facilityTypes.map((item) => ({
                                            value: item.id,
                                            text: item.description,
                                        })) || [],
                                        fullWidth: true,
                                        isRequired: true,
                                        isDisabled: true,
                                        readonlyTemplate: (value) => state.facilityTypes.find((item) => item.id === value)?.description || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'product_id',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'w-[calc(50%-8px)]',
                                    context: {
                                        label: translation.forms.facility.product,
                                        items: state.products.map((product) => ({
                                            text: product.name,
                                            value: product.id,
                                        })),
                                        fullWidth: true,
                                        isRequired: true,
                                        isDisabled: true,
                                        readonlyTemplate: (value) => state.products.find((item) => item.id === value)?.name || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                    ],
                },
                {
                    name: 'proposals-container',
                    customProps: {
                        title: 'Proposal',
                        customClasses: 'w-[calc(50%-8px)]',
                    },
                    containers: [
                        {
                            customClasses: 'flex flex-wrap gap-[8px]',
                            fields: _getFields$1(true, translation, false),
                        },
                    ],
                },
                {
                    name: 'proposals-container',
                    customProps: {
                        title: 'Recommendation',
                        customClasses: 'w-[calc(50%-8px)]',
                    },
                    fields: [
                        {
                            key: 'recommendation',
                            formType: FSWDynamicBuilderFormTypes.GROUP,
                            renderBy: 'container',
                            customClasses: 'w-full',
                            containers: [
                                {
                                    customClasses: 'flex flex-wrap gap-[8px]',
                                    fields: _getFields$1(false, translation, true),
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        ...containers,
    ];
}
function _getFields$1(isProposal, translation, isDisabled) {
    return [
        {
            key: 'start_date',
            type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                defaultValue: new Date(),
                label: translation.forms.facility.facility_start_date,
                readonlyTemplate: (value) => new DatePipe('en-US').transform(value, 'dd/MM/yyyy') || '',
                closeOnSelected: true,
                fullWidth: true,
                isDisabled: true,
            },
        },
        {
            key: 'end_date',
            type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                defaultValue: new Date(),
                label: translation.forms.facility.facility_end_date,
                readonlyTemplate: (value) => new DatePipe('en-US').transform(value, 'dd/MM/yyyy') || '',
                closeOnSelected: true,
                fullWidth: true,
                isDisabled,
            },
        },
        {
            key: 'limit',
            type: FSWDynamicBuilderControlTypes.INPUT,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                defaultValue: 0,
                mask: {
                    expression: 'separator.2',
                    config: {
                        thousandSeparator: ',',
                    },
                },
                label: translation.forms.facility.facility_limit,
                prefix: getCurrentCountryConfig().currencyCode,
                // inputType: 'number', // Commented out
                isRequired: true,
                fullWidth: true,
                isDisabled,
                readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
            },
            validations: [Validators.required],
        },
        {
            key: 'max_loan_to_value',
            type: FSWDynamicBuilderControlTypes.INPUT,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                defaultValue: 0,
                mask: {
                    expression: 'separator.2',
                    config: {
                        thousandSeparator: ',',
                    },
                },
                label: translation.forms.facility.ltv_percentage,
                // inputType: 'number',
                isRequired: true,
                fullWidth: true,
                isDisabled: true,
                readonlyTemplate: (value) => (value || 0).toString(),
            },
            validations: [Validators.required, Validators.min(0), Validators.max(100)],
        },
        {
            key: 'annual_fee',
            type: FSWDynamicBuilderControlTypes.INPUT,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                defaultValue: 0,
                mask: {
                    expression: 'separator.2',
                    config: {
                        thousandSeparator: ',',
                    },
                },
                label: translation.forms.facility.annual_fee,
                prefix: getCurrentCountryConfig().currencyCode,
                // inputType: 'number', // Commented out
                fullWidth: true,
                isDisabled,
                readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
            },
        },
        {
            key: 'minimum_day_to_disburse',
            type: FSWDynamicBuilderControlTypes.INPUT,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                defaultValue: 0,
                mask: {
                    expression: 'separator.2',
                    config: {
                        thousandSeparator: ',',
                    },
                },
                label: translation.forms.facility.days_to_crowdfund,
                // inputType: 'number',
                isRequired: true,
                fullWidth: true,
                isDisabled: true,
                readonlyTemplate: (value) => (value || 0).toString(),
            },
            validations: [Validators.required],
        },
        {
            key: 'maximum_day_to_disburse',
            type: FSWDynamicBuilderControlTypes.INPUT,
            customClasses: 'w-full',
            context: {
                defaultValue: 0,
                mask: {
                    expression: 'separator.2',
                    config: {
                        thousandSeparator: ',',
                    },
                },
                label: translation.forms.facility.credit_term_new,
                // inputType: 'number',
                isRequired: true,
                fullWidth: true,
                isDisabled,
                readonlyTemplate: (value) => (value || 0).toString(),
            },
            validations: [Validators.required],
        },
        {
            key: 'admin_fee',
            type: FSWDynamicBuilderControlTypes.INPUT,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                // inputType: 'number',
                defaultValue: 0,
                mask: {
                    expression: 'separator.2',
                    config: {
                        thousandSeparator: ',',
                    },
                },
                label: translation.forms.facility.admin_fee,
                fullWidth: true,
                isRequired: true,
                isDisabled: true,
                readonlyTemplate: (value) => (value || 0).toString(),
            },
            validations: [Validators.required, Validators.min(0), Validators.max(100)],
        },
        {
            key: 'admin_fee_period',
            type: FSWDynamicBuilderControlTypes.SELECT,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                defaultValue: 'PER_ANNUM',
                label: translation.forms.facility.admin_fee_period,
                isRequired: true,
                fullWidth: true,
                isDisabled: true,
                items: commonFeePeriodList,
                readonlyTemplate: (value) => commonFeePeriodList.find((item) => item.value == value)?.text || 'N/A',
            },
            validations: [Validators.required],
        },
        {
            key: isProposal ? 'facility_fee' : 'facility_fee_value',
            type: FSWDynamicBuilderControlTypes.INPUT,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                // inputType: 'number',
                defaultValue: 0,
                mask: {
                    expression: 'separator.2',
                    config: {
                        thousandSeparator: ',',
                    },
                },
                label: translation.forms.facility.facility_fee,
                fullWidth: true,
                isRequired: true,
                isDisabled,
                readonlyTemplate: (value) => (value || 0).toString(),
            },
            validations: [Validators.required, Validators.min(0), Validators.max(100)],
        },
        {
            key: 'facility_fee_period',
            type: FSWDynamicBuilderControlTypes.SELECT,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                defaultValue: 'PER_ANNUM',
                label: translation.forms.facility.facility_fee_period,
                isRequired: true,
                fullWidth: true,
                isDisabled,
                items: commonFeePeriodList,
                readonlyTemplate: (value) => commonFeePeriodList.find((item) => item.value == value)?.text || 'N/A',
            },
            validations: [Validators.required],
        },
        {
            key: 'interest_rate',
            type: FSWDynamicBuilderControlTypes.INPUT,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                // inputType: 'number',
                defaultValue: 0,
                mask: {
                    expression: 'separator.2',
                    config: {
                        thousandSeparator: ',',
                    },
                },
                label: translation.forms.facility.interest_rate,
                fullWidth: true,
                isRequired: true,
                isDisabled,
                readonlyTemplate: (value) => (value || 0).toString(),
            },
            validations: [Validators.required, Validators.min(0), Validators.max(100)],
        },
        {
            key: isProposal ? 'interest_term' : 'interest_type',
            type: FSWDynamicBuilderControlTypes.SELECT,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                defaultValue: 0,
                label: translation.forms.facility.interest_rate_period,
                isRequired: true,
                fullWidth: true,
                isDisabled,
                items: commonFeePeriodList,
                readonlyTemplate: (value) => commonFeePeriodList.find((item) => item.value == value)?.text || 'N/A',
            },
            validations: [Validators.required],
        },
        {
            key: 'late_interest_fee',
            type: FSWDynamicBuilderControlTypes.INPUT,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                defaultValue: 0.1,
                mask: {
                    expression: 'separator.2',
                    config: {
                        thousandSeparator: ',',
                    },
                },
                label: translation.forms.facility.late_interest_fee,
                // inputType: 'number',
                isRequired: true,
                fullWidth: true,
                isDisabled: true,
                readonlyTemplate: (value) => (value || 0).toString(),
            },
            validations: [Validators.required],
        },
        {
            key: 'late_increment_day',
            type: FSWDynamicBuilderControlTypes.INPUT,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                defaultValue: 0,
                mask: {
                    expression: 'separator.2',
                    config: {
                        thousandSeparator: ',',
                    },
                },
                label: translation.forms.facility.late_interest_fee_period,
                isRequired: true,
                fullWidth: true,
                isDisabled: true,
                readonlyTemplate: (value) => lateInterestFeePeriodList.find((item) => item.value == value)?.text || 'N/A',
            },
            validations: [Validators.required],
        },
        {
            key: 'discounting',
            type: FSWDynamicBuilderControlTypes.INPUT,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                // inputType: 'number',
                defaultValue: 0,
                mask: {
                    expression: 'separator.2',
                    config: {
                        thousandSeparator: ',',
                    },
                },
                label: translation.forms.facility.discounting_percentage,
                fullWidth: true,
                isDisabled: true,
                readonlyTemplate: (value) => (value || 0).toString(),
            },
            validations: [Validators.min(0), Validators.max(100)],
        },
        {
            key: 'discounting_type',
            type: FSWDynamicBuilderControlTypes.SELECT,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                defaultValue: 'PER_ANNUM',
                label: translation.forms.facility.discounting_period,
                fullWidth: true,
                isDisabled: true,
                items: discountingFeePeriodList,
                readonlyTemplate: (value) => discountingFeePeriodList.find((item) => item.value == value)?.text || 'N/A',
            },
        },
        {
            key: 'late_fee',
            type: FSWDynamicBuilderControlTypes.INPUT,
            customClasses: 'w-full',
            context: {
                // inputType: 'number',
                defaultValue: 1000,
                mask: {
                    expression: 'separator.2',
                    config: {
                        thousandSeparator: ',',
                    },
                },
                label: translation.forms.facility.late_fee,
                prefix: getCurrentCountryConfig().currencyCode,
                fullWidth: true,
                isDisabled: true,
                readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
            },
        },
    ];
}

const FSW_PROPOSALS_MY_PROVIDERS = [
    {
        provide: FSW_PROPOSALS_STORE_TOKEN,
        useClass: FSWProposalsStoreMY,
        deps: [
            APPLICATION_MEMBER_SERVICE_TOKEN,
            APPLICATION_PROPOSAL_SERVICE_TOKEN,
            FACILITY_SERVICE_TOKEN,
            SETTINGS_SERVICE_TOKEN,
            FSW_LOAN_SERVICE_TOKEN,
            FSW_ALERT_SERVICE_TOKEN,
            FSW_PROPOSALS_FORM_TOKEN,
        ],
    },
    {
        provide: FSW_PROPOSALS_FORM_TOKEN,
        useValue: FSWProposalsFormMY,
        deps: [],
    },
];

class FSWProposalsStoreSG extends FSWProposalsStore {
    constructor(_applicationMemberService, _applicationProposalService, _facilityService, _settingsService, _loanService, _alertService, _form) {
        super(_applicationMemberService, _applicationProposalService, _facilityService, _settingsService, _loanService, _alertService, _form);
        this._applicationMemberService = _applicationMemberService;
        this._applicationProposalService = _applicationProposalService;
        this._facilityService = _facilityService;
        this._settingsService = _settingsService;
        this._loanService = _loanService;
        this._alertService = _alertService;
        this._form = _form;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsStoreSG, deps: [{ token: APPLICATION_MEMBER_SERVICE_TOKEN }, { token: APPLICATION_PROPOSAL_SERVICE_TOKEN }, { token: FACILITY_SERVICE_TOKEN }, { token: SETTINGS_SERVICE_TOKEN }, { token: FSW_LOAN_SERVICE_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }, { token: FSW_PROPOSALS_FORM_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsStoreSG }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsStoreSG, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_PROPOSAL_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FACILITY_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SETTINGS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_LOAN_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PROPOSALS_FORM_TOKEN]
                }] }]; } });

const FSWProposalsFormSG = (form, type, method, state, isReadonly$) => {
    const translation = FSW_PROPOSALS_TRANSLATION_LOADER[CountryCode.SG];
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'w-full',
        readonlyWhen$: isReadonly$,
        renderBy: 'container',
        containers: getContainers$1(type, method, translation, state),
        form,
    });
};
function getContainers$1(type, method, translation, state) {
    switch (type) {
        case FSWProposalsFormTypes.LOAN:
            return getLoanContainers$1(method, translation, state);
        case FSWProposalsFormTypes.FACILITY:
            return getFacilityContainers$1(method, translation, state);
        case FSWProposalsFormTypes.FACILITY_IMPORT:
        case FSWProposalsFormTypes.FACILITY_AFTER_IMPORT:
            return getFacilityImportContainers$1(type, method, translation, state);
    }
}
function getLoanContainers$1(method, translation, state) {
    let hiddenObj = {};
    if (method === 'POST') {
        hiddenObj = {
            product_id: 0,
            instance: '',
            limit: 0,
            term: 0,
            term_type: '',
            ltv: 0,
            installment: 0,
            admin_fee: 0,
            admin_fee_period: '',
            facility_fee: 0,
            facility_fee_period: '',
            origination_fee: 0,
            service_fee: 0,
            service_fee_period: '',
            late_interest_fee: 0,
            crowdfund_day: 0,
            annual_fee: 0,
            discounting: 0,
            discounting_type: '',
            facility_type_id: 0,
            plafond_type: '',
            version: 0,
            code: '',
            status: '',
            start_date: new Date(),
            end_date: new Date(),
            late_interest_fee_type: '',
            disbursement_request_period: '',
            max_loan_to_value: 0,
            minimum_amount_due: 0,
            late_increment_day: 0,
            interest_term: '',
            due_day_per_month: 0,
            restructure_fee: 0,
            restructure_fee_type: '',
        };
    }
    else {
        hiddenObj['id'] = '';
    }
    const keys = Object.keys(hiddenObj);
    const containers = keys.length
        ? [
            {
                customClasses: 'hidden',
                fields: keys.map((key) => ({
                    key,
                    type: FSWDynamicBuilderControlTypes.TEMPLATE,
                    context: {
                        defaultValue: hiddenObj[key],
                        isHidden: true,
                    },
                })),
            },
        ]
        : [];
    return [
        {
            customClasses: 'flex flex-wrap gap-[16px]',
            containers: [
                {
                    name: 'proposals-container',
                    customProps: {
                        title: '',
                        customClasses: 'w-full',
                    },
                    containers: [
                        {
                            customClasses: 'flex flex-wrap gap-[8px]',
                            fields: [
                                {
                                    key: 'member_id',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'w-[calc(50%-8px)]',
                                    context: {
                                        label: translation.forms.loan.borrower,
                                        items: state.members?.map((member) => ({
                                            value: member.uuid,
                                            text: getProposalsMemberName(member),
                                        })) || [],
                                        fullWidth: true,
                                        isRequired: true,
                                        isDisabled: method === 'PUT',
                                        readonlyTemplate: (uuid) => uuid
                                            ? getProposalsMemberName(getProposalsMember(state.members || [], { uuid }))
                                            : 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'loan_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'w-[calc(50%-8px)]',
                                    context: {
                                        defaultValue: 2,
                                        label: translation.forms.loan.product,
                                        items: state.products.map((product) => ({
                                            text: product.name,
                                            value: product.id,
                                        })),
                                        fullWidth: true,
                                        isRequired: true,
                                        afterCreated: (control) => {
                                            const formGroup = control?.parent;
                                            if (!formGroup) {
                                                return;
                                            }
                                            const loanAmountControl = formGroup?.get('loan_amount');
                                            const loanPurposeControl = formGroup?.get('loan_purpose');
                                            const interestRateControl = formGroup?.get('interest_rate');
                                            const interestTypeControl = formGroup?.get('interest_type');
                                            const sourceOfFundControl = formGroup?.get('source_of_fund');
                                            const installmentTypesControl = formGroup?.get('installment_types');
                                            const tenorControl = formGroup?.get('tenor');
                                            const lateFeeControl = formGroup?.get('late_fee');
                                            const lateFeeTypeControl = formGroup?.get('late_fee_type');
                                            control.valueChanges.subscribe((value) => {
                                                if (value === 11) {
                                                    loanAmountControl?.setValue(150000);
                                                    loanPurposeControl?.setValue(3);
                                                    interestRateControl?.setValue(20);
                                                    interestTypeControl?.setValue(30);
                                                    sourceOfFundControl?.setValue('BALANCE SHEET');
                                                    installmentTypesControl?.setValue(30);
                                                    tenorControl?.setValue(18);
                                                    lateFeeControl?.setValue(270);
                                                    lateFeeTypeControl?.setValue(1);
                                                }
                                            });
                                        },
                                        readonlyTemplate: (value) => state.products.find((item) => item.id === value)?.name ||
                                            (state.products?.length && state.products[0].name) ||
                                            'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                    ],
                },
                {
                    name: 'proposals-container',
                    customProps: {
                        title: 'Proposal',
                        customClasses: 'w-[calc(50%-8px)]',
                    },
                    containers: [
                        {
                            customClasses: 'flex flex-wrap gap-[8px]',
                            fields: _getFields(true, translation, false, state),
                        },
                    ],
                },
                {
                    name: 'proposals-container',
                    customProps: {
                        title: 'Recommendation',
                        customClasses: 'w-[calc(50%-8px)]',
                    },
                    fields: [
                        {
                            key: 'recommendation',
                            formType: FSWDynamicBuilderFormTypes.GROUP,
                            renderBy: 'container',
                            customClasses: 'w-full',
                            containers: [
                                {
                                    customClasses: 'flex flex-wrap gap-[8px]',
                                    fields: _getFields(false, translation, true, state),
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        ...containers,
    ];
}
function getFacilityContainers$1(method, translation, state) {
    let hiddenObj = {};
    if (method === 'POST') {
        hiddenObj = {
            instance: '',
            installment: 15,
            version: 0,
            code: '',
            status: '',
            start_date: new Date(),
            end_date: new Date(),
            disbursement_request_period: '',
            max_loan_to_value: 0,
            minimum_amount_due: 0,
            late_increment_day: 0,
            loan_number: '',
            loan_type: 0,
            loan_amount: 0,
            loan_purpose: null,
            installment_types: null,
            interest_type: null,
            late_interest_rate: 0,
            late_interest_type: 0,
            late_fee_type: null,
        };
    }
    else {
        hiddenObj['id'] = '';
    }
    const keys = Object.keys(hiddenObj);
    const containers = keys.length
        ? [
            {
                customClasses: 'hidden',
                fields: keys.map((key) => ({
                    key,
                    type: FSWDynamicBuilderControlTypes.TEMPLATE,
                    context: {
                        defaultValue: hiddenObj[key],
                        isHidden: true,
                    },
                })),
            },
        ]
        : [];
    return [
        {
            customClasses: 'flex justify-between gap-[16px]',
            containers: [
                {
                    customClasses: 'flex-1 flex flex-col gap-[16px] w-[calc(50%-8px)]',
                    fields: [
                        {
                            key: 'member_id',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                label: translation.forms.facility.borrower,
                                items: state.members?.map((member) => ({
                                    value: member.uuid,
                                    text: getProposalsMemberName(member),
                                })) || [],
                                fullWidth: true,
                                isRequired: true,
                                isDisabled: method === 'PUT',
                                readonlyTemplate: (uuid) => uuid
                                    ? getProposalsMemberName(getProposalsMember(state.members || [], { uuid }))
                                    : 'N/A',
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'facility_type_id',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                label: translation.forms.facility.type,
                                items: state.facilityTypes.map((item) => ({
                                    value: item.id,
                                    text: item.description,
                                })) || [],
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => state.facilityTypes.find((item) => item.id === value)?.description || 'N/A',
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'product_id',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                label: translation.forms.facility.product,
                                items: state.products.map((product) => ({
                                    text: product.name,
                                    value: product.id,
                                })),
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => state.products.find((item) => item.id === value)?.name || 'N/A',
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'limit',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.limit,
                                prefix: getCurrentCountryConfig().currencyCode,
                                // inputType: 'number',
                                isRequired: true,
                                fullWidth: true,
                                readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'late_fee',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number',
                                defaultValue: 1000,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.late_fee,
                                prefix: getCurrentCountryConfig().currencyCode,
                                fullWidth: true,
                                readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                            },
                        },
                        {
                            key: 'late_interest_fee',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0.1,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.late_interest_fee,
                                suffix: '% per day',
                                // inputType: 'number',
                                isRequired: true,
                                fullWidth: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'annual_fee',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.annual_fee,
                                prefix: getCurrentCountryConfig().currencyCode,
                                // inputType: 'number',
                                fullWidth: true,
                                readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                            },
                        },
                    ],
                    containers: [
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'interest_rate',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.interest_rate,
                                        fullWidth: true,
                                        suffix: '%',
                                        isRequired: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required, Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'interest_term',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: interestTerms,
                                        readonlyTemplate: (value) => interestTerms.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'term',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.credit_term,
                                        fullWidth: true,
                                        isRequired: true,
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'term_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'day',
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: termTypes,
                                        readonlyTemplate: (value) => termTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'discounting',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        suffix: '%',
                                        label: translation.forms.facility.discounting,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'discounting_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        fullWidth: true,
                                        items: periodTypes,
                                        readonlyTemplate: (value) => periodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'tenor',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.tenor,
                                        fullWidth: true,
                                        isRequired: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'tenor_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 30,
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: tenorTypes,
                                        readonlyTemplate: (value) => tenorTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                    ],
                },
                {
                    customClasses: 'flex-1 flex flex-col gap-[16px] w-[calc(50%-8px)]',
                    fields: [
                        {
                            key: 'start_date',
                            type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                            context: {
                                fullWidth: true,
                                isRequired: true,
                                label: translation.forms.facility.start_date,
                                closeOnSelected: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'end_date',
                            type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                            context: {
                                fullWidth: true,
                                isRequired: true,
                                label: translation.forms.facility.end_date,
                                closeOnSelected: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'source_of_fund',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                defaultValue: 'CF',
                                label: translation.forms.loan.source_of_funds,
                                items: sourceOfFunds,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => sourceOfFunds.find((item) => item.value == value)?.text || 'N/A',
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'origination_fee',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.origination_fee,
                                prefix: getCurrentCountryConfig().currencyCode,
                                // inputType: 'number',
                                isRequired: true,
                                fullWidth: true,
                                readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'ltv',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.ltv,
                                suffix: '%',
                                // inputType: 'number',
                                isRequired: true,
                                fullWidth: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required, Validators.min(0), Validators.max(100)],
                        },
                        {
                            key: 'crowdfund_day',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.days_to_crowdfund,
                                suffix: 'days',
                                // inputType: 'number',
                                fullWidth: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                        },
                        {
                            key: 'late_interest_fee_type',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                defaultValue: 'PER_ANNUM',
                                label: translation.forms.facility.late_interest_fee_type,
                                isRequired: true,
                                fullWidth: true,
                                items: latePeriods,
                                readonlyTemplate: (value) => latePeriods.find((item) => item.value == value)?.text || 'N/A',
                            },
                            validations: [Validators.required],
                        },
                    ],
                    containers: [
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'facility_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.facility_fee,
                                        fullWidth: true,
                                        suffix: '%',
                                        isRequired: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required, Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'facility_fee_period',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: periodTypes,
                                        readonlyTemplate: (value) => periodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'admin_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.admin_fee,
                                        fullWidth: true,
                                        suffix: '%',
                                        isRequired: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required, Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'admin_fee_period',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: adminPeriodTypes,
                                        readonlyTemplate: (value) => adminPeriodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'service_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.service_fee,
                                        fullWidth: true,
                                        suffix: '%',
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'service_fee_period',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        fullWidth: true,
                                        items: periodTypes,
                                        readonlyTemplate: (value) => periodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'restructure_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.restructure,
                                        fullWidth: true,
                                        suffix: '%',
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'restructure_fee_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        fullWidth: true,
                                        items: periodTypes,
                                        readonlyTemplate: (value) => periodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        ...containers,
    ];
}
function getFacilityImportContainers$1(type, method, translation, state) {
    let hiddenObj = {};
    if (method === 'POST') {
        hiddenObj = {
            instance: '',
            installment: 0,
            origination_fee: 0,
            service_fee: 0,
            service_fee_period: '',
            plafond_type: '',
            due_day_per_month: 0,
            loan_number: '',
            loan_type: 0,
            loan_amount: 0,
            loan_purpose: null,
            installment_types: null,
            interest_type: null,
            late_interest_rate: 0,
            late_interest_type: 0,
            source_of_fund: '',
        };
    }
    else {
        hiddenObj['id'] = '';
    }
    const keys = Object.keys(hiddenObj);
    const containers = keys.length
        ? [
            {
                customClasses: 'hidden',
                fields: keys.map((key) => ({
                    key,
                    type: FSWDynamicBuilderControlTypes.TEMPLATE,
                    context: {
                        defaultValue: hiddenObj[key],
                        isHidden: true,
                    },
                })),
            },
        ]
        : [];
    return [
        {
            customClasses: 'flex justify-between gap-[16px]',
            containers: [
                {
                    customClasses: 'flex-1 flex flex-col gap-[16px] w-[calc(50%-8px)]',
                    fields: [
                        {
                            key: 'member_id',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                label: translation.forms.facility.borrower,
                                items: state.members?.map((member) => ({
                                    value: member.uuid,
                                    text: getProposalsMemberName(member),
                                })) || [],
                                fullWidth: true,
                                isRequired: true,
                                isDisabled: true,
                                readonlyTemplate: (uuid) => uuid
                                    ? getProposalsMemberName(getProposalsMember(state.members || [], { uuid }))
                                    : 'N/A',
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'status',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                label: translation.forms.facility.status,
                                fullWidth: true,
                                isRequired: true,
                                isDisabled: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'facility_type_id',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                label: translation.forms.facility.type,
                                items: state.facilityTypes.map((item) => ({
                                    value: item.id,
                                    text: item.description,
                                })) || [],
                                fullWidth: true,
                                isRequired: true,
                                isDisabled: true,
                                readonlyTemplate: (value) => state.facilityTypes.find((item) => item.id === value)?.description || 'N/A',
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'start_date',
                            type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                            context: {
                                defaultValue: new Date(),
                                label: translation.forms.facility.start_date,
                                readonlyTemplate: (value) => new DatePipe('en-US').transform(value, 'dd/MM/yyyy') || '',
                                closeOnSelected: true,
                                fullWidth: true,
                            },
                        },
                        {
                            key: 'limit',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.limit,
                                prefix: getCurrentCountryConfig().currencyCode,
                                // inputType: 'number',
                                isRequired: true,
                                fullWidth: true,
                                readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'minimum_amount_due',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.minimum_amount_due,
                                prefix: getCurrentCountryConfig().currencyCode,
                                // inputType: 'number',
                                isRequired: true,
                                fullWidth: true,
                                readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'ltv',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.ltv,
                                suffix: '%',
                                // inputType: 'number',
                                isRequired: true,
                                fullWidth: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required, Validators.min(0), Validators.max(100)],
                        },
                        {
                            key: 'late_interest_fee',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0.1,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.late_interest_fee,
                                suffix: '% per day',
                                // inputType: 'number',
                                isRequired: true,
                                fullWidth: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'annual_fee',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.annual_fee,
                                prefix: getCurrentCountryConfig().currencyCode,
                                // inputType: 'number',
                                fullWidth: true,
                                readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                            },
                        },
                    ],
                    containers: [
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'facility_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.facility_fee,
                                        fullWidth: true,
                                        suffix: '%',
                                        isRequired: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required, Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'facility_fee_period',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: periodTypes,
                                        readonlyTemplate: (value) => periodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'admin_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.admin_fee,
                                        fullWidth: true,
                                        suffix: '%',
                                        isRequired: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required, Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'admin_fee_period',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: adminPeriodTypes,
                                        readonlyTemplate: (value) => adminPeriodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'discounting',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        suffix: '%',
                                        label: translation.forms.facility.discounting,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'discounting_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        fullWidth: true,
                                        items: periodTypes,
                                        readonlyTemplate: (value) => periodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'tenor',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.tenor,
                                        fullWidth: true,
                                        isRequired: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'tenor_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 30,
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: tenorTypes,
                                        readonlyTemplate: (value) => tenorTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                    ],
                },
                {
                    customClasses: 'flex-1 flex flex-col gap-[16px] w-[calc(50%-8px)]',
                    fields: [
                        {
                            key: 'code',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                label: translation.forms.facility.code,
                                fullWidth: true,
                                isRequired: true,
                                isDisabled: true,
                            },
                            validations: [Validators.required],
                        },
                    ],
                    containers: [
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: type === FSWProposalsFormTypes.FACILITY_IMPORT
                                ? [
                                    {
                                        key: 'original_version',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        customClasses: 'flex-1',
                                        context: {
                                            defaultValue: 0,
                                            label: translation.forms.facility.current_version,
                                            fullWidth: true,
                                            isRequired: true,
                                        },
                                        validations: [Validators.required],
                                    },
                                    {
                                        key: 'version',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        customClasses: 'flex-1',
                                        context: {
                                            defaultValue: 0,
                                            label: translation.forms.facility.new_version,
                                            isRequired: true,
                                            fullWidth: true,
                                        },
                                        validations: [Validators.required],
                                    },
                                ]
                                : [
                                    {
                                        key: 'version',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        customClasses: 'flex-1',
                                        context: {
                                            defaultValue: 0,
                                            label: translation.forms.facility.version,
                                            isRequired: true,
                                            fullWidth: true,
                                        },
                                        validations: [Validators.required],
                                    },
                                ],
                        },
                        {
                            customClasses: 'flex flex-col gap-[16px] justify-between',
                            fields: [
                                {
                                    key: 'product_id',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    context: {
                                        label: translation.forms.facility.product,
                                        items: state.products.map((product) => ({
                                            text: product.name,
                                            value: product.id,
                                        })),
                                        fullWidth: true,
                                        isRequired: true,
                                        isDisabled: true,
                                        readonlyTemplate: (value) => state.products.find((item) => item.id === value)?.name || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'end_date',
                                    type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                                    context: {
                                        defaultValue: new Date(),
                                        label: translation.forms.facility.end_date,
                                        readonlyTemplate: (value) => new DatePipe('en-US').transform(value, 'dd/MM/yyyy') || '',
                                        closeOnSelected: true,
                                        fullWidth: true,
                                    },
                                },
                                {
                                    key: 'max_loan_to_value',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.max_loan_to_value,
                                        prefix: getCurrentCountryConfig().currencyCode,
                                        // inputType: 'number',
                                        isRequired: true,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'disbursement_request_period',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        defaultValue: 0,
                                        label: translation.forms.facility.disbursement_request_period,
                                        isRequired: true,
                                        fullWidth: true,
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'crowdfund_day',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        defaultValue: 0,
                                        label: translation.forms.facility.days_to_crowdfund,
                                        suffix: 'days',
                                        inputType: 'number',
                                        isRequired: true,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'late_increment_day',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.late_increment_day,
                                        suffix: 'days',
                                        // inputType: 'number',
                                        isRequired: true,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'late_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 1000,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.tenor,
                                        prefix: getCurrentCountryConfig().currencyCode,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                                    },
                                },
                                {
                                    key: 'late_fee_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        fullWidth: true,
                                        items: periodTypes,
                                        readonlyTemplate: (value) => periodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'interest_rate',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.interest_rate,
                                        fullWidth: true,
                                        suffix: '%',
                                        isRequired: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required, Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'interest_term',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: interestTerms,
                                        readonlyTemplate: (value) => interestTerms.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'term',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.credit_term,
                                        fullWidth: true,
                                        isRequired: true,
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'term_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'day',
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: termTypes,
                                        readonlyTemplate: (value) => termTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'restructure_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.restructure,
                                        fullWidth: true,
                                        suffix: '%',
                                        isRequired: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required, Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'restructure_fee_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: periodTypes,
                                        readonlyTemplate: (value) => periodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'w-full',
                            fields: [
                                {
                                    key: 'late_interest_fee_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.late_interest_fee_type,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: latePeriods,
                                        readonlyTemplate: (value) => latePeriods.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        ...containers,
    ];
}
function _getFields(isProposal, translation, isDisabled, state) {
    return [
        {
            key: 'loan_code',
            type: FSWDynamicBuilderControlTypes.INPUT,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                label: translation.forms.loan.number,
                fullWidth: true,
                // isRequired: true,
                isDisabled: true,
            },
            // validations: [Validators.required],
        },
        {
            key: 'loan_amount',
            type: FSWDynamicBuilderControlTypes.INPUT,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                defaultValue: 0,
                mask: {
                    expression: 'separator.2',
                    config: {
                        thousandSeparator: ',',
                    },
                },
                label: translation.forms.loan.amount.replace('{{currency}}', getCurrentCountryConfig().currencyCode),
                // prefix: getCurrentCountryConfig().currencyCode,
                // inputType: 'number',
                isRequired: true,
                fullWidth: true,
                showError: true,
                errorText: 'Minimum value of 10000 is required',
                isDisabled,
                readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
            },
            validations: [Validators.required, Validators.min(10000)],
        },
        {
            key: 'source_of_fund',
            type: FSWDynamicBuilderControlTypes.SELECT,
            customClasses: 'w-[calc(100%-8px)]',
            context: {
                defaultValue: 'CF',
                label: translation.forms.loan.source_of_funds,
                items: sourceOfFunds,
                fullWidth: true,
                isRequired: true,
                isDisabled,
                readonlyTemplate: (value) => sourceOfFunds.find((item) => item.value == value)?.text || 'N/A',
            },
            validations: [Validators.required],
        },
        {
            key: 'loan_purpose',
            type: FSWDynamicBuilderControlTypes.SELECT,
            customClasses: 'w-[calc(100%-8px)]',
            context: {
                label: translation.forms.loan.purpose,
                items: state.purposes.map((purpose) => ({
                    text: purpose.name_eng,
                    value: purpose.id,
                })),
                fullWidth: true,
                isRequired: true,
                isDisabled,
                readonlyTemplate: (value) => state.purposes.find((item) => item.id === value)?.name_eng || 'N/A',
            },
            validations: [Validators.required],
        },
        {
            key: 'installment_types',
            type: FSWDynamicBuilderControlTypes.SELECT,
            customClasses: 'w-[calc(100%-8px)]',
            context: {
                defaultValue: 1,
                label: translation.forms.loan.installment_types,
                items: installmentTypes,
                fullWidth: true,
                isRequired: true,
                isDisabled,
                readonlyTemplate: (value) => installmentTypes.find((item) => item.value == value)?.text || 'N/A',
            },
            validations: [Validators.required],
        },
        {
            key: 'interest_rate',
            type: FSWDynamicBuilderControlTypes.INPUT,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                // inputType: 'number',
                defaultValue: 0,
                mask: {
                    expression: 'separator.2',
                    config: {
                        thousandSeparator: ',',
                    },
                },
                label: translation.forms.loan.interest_rate,
                fullWidth: true,
                suffix: '%',
                isRequired: true,
                isDisabled,
                readonlyTemplate: (value) => (value || 0).toString(),
            },
            validations: [Validators.required, Validators.min(0), Validators.max(100)],
        },
        {
            key: 'interest_type',
            type: FSWDynamicBuilderControlTypes.SELECT,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                defaultValue: 360,
                label: translation.forms.loan.period,
                isRequired: true,
                fullWidth: true,
                isDisabled,
                items: interestTypes,
                readonlyTemplate: (value) => interestTypes.find((item) => item.value == value)?.text || 'N/A',
            },
            validations: [Validators.required],
        },
        {
            key: 'late_interest_rate',
            type: FSWDynamicBuilderControlTypes.INPUT,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                // inputType: 'number',
                defaultValue: 0,
                mask: {
                    expression: 'separator.2',
                    config: {
                        thousandSeparator: ',',
                    },
                },
                label: translation.forms.loan.late_interest_rate,
                fullWidth: true,
                suffix: '%',
                isRequired: true,
                isDisabled,
                readonlyTemplate: (value) => (value || 0).toString(),
            },
            validations: [Validators.required, Validators.min(0), Validators.max(100)],
        },
        {
            key: 'late_interest_type',
            type: FSWDynamicBuilderControlTypes.SELECT,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                defaultValue: 360,
                label: translation.forms.loan.period,
                isRequired: true,
                items: interestTypes,
                fullWidth: true,
                isDisabled,
                readonlyTemplate: (value) => interestTypes.find((item) => item.value == value)?.text || 'N/A',
            },
            validations: [Validators.required],
        },
        {
            key: 'late_fee',
            type: FSWDynamicBuilderControlTypes.INPUT,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                // inputType: 'number',
                defaultValue: 0,
                mask: {
                    expression: 'separator.2',
                    config: {
                        thousandSeparator: ',',
                    },
                },
                label: translation.forms.loan.late_fee,
                prefix: getCurrentCountryConfig().currencyCode,
                fullWidth: true,
                isDisabled,
                readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
            },
        },
        {
            key: 'late_fee_type',
            type: FSWDynamicBuilderControlTypes.SELECT,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                defaultValue: 360,
                label: translation.forms.loan.period,
                fullWidth: true,
                items: interestTypes,
                isDisabled,
                readonlyTemplate: (value) => interestTypes.find((item) => item.value == value)?.text || 'N/A',
            },
        },
        {
            key: 'tenor',
            type: FSWDynamicBuilderControlTypes.INPUT,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                // inputType: 'number',
                defaultValue: 0,
                mask: {
                    expression: 'separator.2',
                    config: {
                        thousandSeparator: ',',
                    },
                },
                label: translation.forms.loan.tenor,
                fullWidth: true,
                isRequired: true,
                isDisabled,
            },
            validations: [Validators.required],
        },
        {
            key: 'tenor_type',
            type: FSWDynamicBuilderControlTypes.SELECT,
            customClasses: 'w-[calc(50%-8px)]',
            context: {
                defaultValue: 30,
                label: translation.forms.loan.period,
                isRequired: true,
                items: tenorTypes,
                fullWidth: true,
                isDisabled,
                readonlyTemplate: (value) => tenorTypes.find((item) => item.value == value)?.text || 'N/A',
            },
            validations: [Validators.required],
        },
    ];
}

const FSW_PROPOSALS_SG_PROVIDERS = [
    {
        provide: FSW_PROPOSALS_STORE_TOKEN,
        useClass: FSWProposalsStoreSG,
        deps: [
            APPLICATION_MEMBER_SERVICE_TOKEN,
            APPLICATION_PROPOSAL_SERVICE_TOKEN,
            FACILITY_SERVICE_TOKEN,
            SETTINGS_SERVICE_TOKEN,
            FSW_LOAN_SERVICE_TOKEN,
            FSW_ALERT_SERVICE_TOKEN,
            FSW_PROPOSALS_FORM_TOKEN,
        ],
    },
    {
        provide: FSW_PROPOSALS_FORM_TOKEN,
        useValue: FSWProposalsFormSG,
        deps: [],
    },
];

class FSWProposalsStoreTH extends FSWProposalsStore {
    constructor(_applicationMemberService, _applicationProposalService, _facilityService, _settingsService, _loanService, _alertService, _form) {
        super(_applicationMemberService, _applicationProposalService, _facilityService, _settingsService, _loanService, _alertService, _form);
        this._applicationMemberService = _applicationMemberService;
        this._applicationProposalService = _applicationProposalService;
        this._facilityService = _facilityService;
        this._settingsService = _settingsService;
        this._loanService = _loanService;
        this._alertService = _alertService;
        this._form = _form;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsStoreTH, deps: [{ token: APPLICATION_MEMBER_SERVICE_TOKEN }, { token: APPLICATION_PROPOSAL_SERVICE_TOKEN }, { token: FACILITY_SERVICE_TOKEN }, { token: SETTINGS_SERVICE_TOKEN }, { token: FSW_LOAN_SERVICE_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }, { token: FSW_PROPOSALS_FORM_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsStoreTH }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsStoreTH, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_PROPOSAL_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FACILITY_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SETTINGS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_LOAN_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PROPOSALS_FORM_TOKEN]
                }] }]; } });

const FSWProposalsFormTH = (form, type, method, state, isReadonly$) => {
    const translation = FSW_PROPOSALS_TRANSLATION_LOADER[CountryCode.TH];
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'w-full',
        readonlyWhen$: isReadonly$,
        renderBy: 'container',
        containers: getContainers(type, method, translation, state),
        form,
    });
};
function getContainers(type, method, translation, state) {
    switch (type) {
        case FSWProposalsFormTypes.LOAN:
            return getLoanContainers(method, translation, state);
        case FSWProposalsFormTypes.FACILITY:
            return getFacilityContainers(method, translation, state);
        case FSWProposalsFormTypes.FACILITY_IMPORT:
        case FSWProposalsFormTypes.FACILITY_AFTER_IMPORT:
            return getFacilityImportContainers(type, method, translation, state);
    }
}
function getLoanContainers(method, translation, state) {
    let hiddenObj = {};
    if (method === 'POST') {
        hiddenObj = {
            product_id: 0,
            instance: '',
            limit: 0,
            term: 0,
            term_type: '',
            ltv: 0,
            installment: 0,
            admin_fee: 0,
            admin_fee_period: '',
            facility_fee: 0,
            facility_fee_period: '',
            origination_fee: 0,
            service_fee: 0,
            service_fee_period: '',
            late_interest_fee: 0,
            crowdfund_day: 0,
            annual_fee: 0,
            discounting: 0,
            discounting_type: '',
            facility_type_id: 0,
            plafond_type: '',
            version: 0,
            code: '',
            status: '',
            start_date: new Date(),
            end_date: new Date(),
            late_interest_fee_type: '',
            disbursement_request_period: '',
            max_loan_to_value: 0,
            minimum_amount_due: 0,
            late_increment_day: 0,
            interest_term: '',
            due_day_per_month: 0,
            restructure_fee: 0,
            restructure_fee_type: '',
        };
    }
    else {
        hiddenObj['id'] = '';
    }
    const keys = Object.keys(hiddenObj);
    const containers = keys.length
        ? [
            {
                customClasses: 'hidden',
                fields: keys.map((key) => ({
                    key,
                    type: FSWDynamicBuilderControlTypes.TEMPLATE,
                    context: {
                        defaultValue: hiddenObj[key],
                        isHidden: true,
                    },
                })),
            },
        ]
        : [];
    return [
        {
            customClasses: 'flex justify-between gap-[16px]',
            containers: [
                {
                    customClasses: 'flex-1 flex flex-col gap-[16px] w-[calc(50%-8px)]',
                    fields: [
                        {
                            key: 'member_id',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                label: translation.forms.loan.borrower,
                                items: state.members?.map((member) => ({
                                    value: member.uuid,
                                    text: getProposalsMemberName(member),
                                })) || [],
                                fullWidth: true,
                                isRequired: true,
                                isDisabled: method === 'PUT',
                                readonlyTemplate: (uuid) => uuid
                                    ? getProposalsMemberName(getProposalsMember(state.members || [], { uuid }))
                                    : 'N/A',
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'loan_code',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                label: translation.forms.loan.number,
                                isDisabled: true,
                                fullWidth: true,
                                isRequired: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'source_of_fund',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                defaultValue: 'CF',
                                label: translation.forms.loan.source_of_funds,
                                items: sourceOfFunds,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => sourceOfFunds.find((item) => item.value == value)?.text || 'N/A',
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'installment_types',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                defaultValue: 1,
                                label: translation.forms.loan.installment_types,
                                items: installmentTypes,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => installmentTypes.find((item) => item.value == value)?.text || 'N/A',
                            },
                            validations: [Validators.required],
                        },
                    ],
                    containers: [
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'late_interest_rate',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.loan.late_interest_rate,
                                        fullWidth: true,
                                        suffix: '%',
                                        isRequired: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required, Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'late_interest_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 360,
                                        label: translation.forms.loan.period,
                                        isRequired: true,
                                        items: interestTypes,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => interestTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'tenor',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.loan.tenor,
                                        fullWidth: true,
                                        isRequired: true,
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'tenor_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 30,
                                        label: translation.forms.loan.period,
                                        isRequired: true,
                                        items: tenorTypes,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => tenorTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                    ],
                },
                {
                    customClasses: 'flex-1 flex flex-col gap-[16px] w-[calc(50%-8px)]',
                    fields: [
                        {
                            key: 'loan_type',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                label: translation.forms.loan.product,
                                items: state.products.map((product) => ({
                                    text: product.name,
                                    value: product.id,
                                })),
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => state.products.find((item) => item.id === value)?.name || 'N/A',
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'loan_amount',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.loan.amount.replace('{{currency}}', getCurrentCountryConfig().currencyCode),
                                // prefix: getCurrentCountryConfig().currencyCode,
                                // inputType: 'number',
                                isRequired: true,
                                fullWidth: true,
                                showError: true,
                                errorText: 'Minimum value of 10000 is required',
                                readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                            },
                            validations: [Validators.required, Validators.min(10000)],
                        },
                        {
                            key: 'loan_purpose',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                label: translation.forms.loan.purpose,
                                items: state.purposes.map((purpose) => ({
                                    text: purpose.name_eng,
                                    value: purpose.id,
                                })),
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => state.purposes.find((item) => item.id === value)?.name_eng || 'N/A',
                            },
                            validations: [Validators.required],
                        },
                    ],
                    containers: [
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'interest_rate',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.loan.interest_rate,
                                        fullWidth: true,
                                        suffix: '%',
                                        isRequired: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required, Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'interest_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 360,
                                        label: translation.forms.loan.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: interestTypes,
                                        readonlyTemplate: (value) => interestTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'late_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.loan.late_fee,
                                        prefix: getCurrentCountryConfig().currencyCode,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                                    },
                                },
                                {
                                    key: 'late_fee_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 360,
                                        label: translation.forms.loan.period,
                                        fullWidth: true,
                                        items: interestTypes,
                                        readonlyTemplate: (value) => interestTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        ...containers,
    ];
}
function getFacilityContainers(method, translation, state) {
    let hiddenObj = {};
    if (method === 'POST') {
        hiddenObj = {
            instance: '',
            installment: 15,
            version: 0,
            code: '',
            status: '',
            start_date: new Date(),
            end_date: new Date(),
            disbursement_request_period: '',
            max_loan_to_value: 0,
            minimum_amount_due: 0,
            late_increment_day: 0,
            loan_number: '',
            loan_type: 0,
            loan_amount: 0,
            loan_purpose: null,
            installment_types: null,
            interest_type: null,
            late_interest_rate: 0,
            late_interest_type: 0,
            late_fee_type: null,
        };
    }
    else {
        hiddenObj['id'] = '';
    }
    const keys = Object.keys(hiddenObj);
    const containers = keys.length
        ? [
            {
                customClasses: 'hidden',
                fields: keys.map((key) => ({
                    key,
                    type: FSWDynamicBuilderControlTypes.TEMPLATE,
                    context: {
                        defaultValue: hiddenObj[key],
                        isHidden: true,
                    },
                })),
            },
        ]
        : [];
    return [
        {
            customClasses: 'flex justify-between gap-[16px]',
            containers: [
                {
                    customClasses: 'flex-1 flex flex-col gap-[16px] w-[calc(50%-8px)]',
                    fields: [
                        {
                            key: 'member_id',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                label: translation.forms.facility.borrower,
                                items: state.members?.map((member) => ({
                                    value: member.uuid,
                                    text: getProposalsMemberName(member),
                                })) || [],
                                fullWidth: true,
                                isRequired: true,
                                isDisabled: method === 'PUT',
                                readonlyTemplate: (uuid) => uuid
                                    ? getProposalsMemberName(getProposalsMember(state.members || [], { uuid }))
                                    : 'N/A',
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'facility_type_id',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                label: translation.forms.facility.type,
                                items: state.facilityTypes.map((item) => ({
                                    value: item.id,
                                    text: item.description,
                                })) || [],
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => state.facilityTypes.find((item) => item.id === value)?.description || 'N/A',
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'product_id',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                label: translation.forms.facility.product,
                                items: state.products.map((product) => ({
                                    text: product.name,
                                    value: product.id,
                                })),
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => state.products.find((item) => item.id === value)?.name || 'N/A',
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'limit',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.limit,
                                prefix: getCurrentCountryConfig().currencyCode,
                                // inputType: 'number',
                                isRequired: true,
                                fullWidth: true,
                                readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'late_fee',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                // inputType: 'number',
                                defaultValue: 1000,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.late_fee,
                                prefix: getCurrentCountryConfig().currencyCode,
                                fullWidth: true,
                                readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                            },
                        },
                        {
                            key: 'late_interest_fee',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0.1,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.late_interest_fee,
                                suffix: '% per day',
                                // inputType: 'number',
                                isRequired: true,
                                fullWidth: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'annual_fee',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0,
                                label: translation.forms.facility.annual_fee,
                                prefix: getCurrentCountryConfig().currencyCode,
                                // inputType: 'number',
                                fullWidth: true,
                                readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                            },
                        },
                    ],
                    containers: [
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'interest_rate',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.interest_rate,
                                        fullWidth: true,
                                        suffix: '%',
                                        isRequired: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required, Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'interest_term',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: interestTerms,
                                        readonlyTemplate: (value) => interestTerms.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'term',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.credit_term,
                                        fullWidth: true,
                                        isRequired: true,
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'term_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'day',
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: termTypes,
                                        readonlyTemplate: (value) => termTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'discounting',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        suffix: '%',
                                        label: translation.forms.facility.discounting,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'discounting_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        fullWidth: true,
                                        items: periodTypes,
                                        readonlyTemplate: (value) => periodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'tenor',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.tenor,
                                        fullWidth: true,
                                        isRequired: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'tenor_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 30,
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: tenorTypes,
                                        readonlyTemplate: (value) => tenorTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                    ],
                },
                {
                    customClasses: 'flex-1 flex flex-col gap-[16px] w-[calc(50%-8px)]',
                    fields: [
                        {
                            key: 'start_date',
                            type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                            context: {
                                fullWidth: true,
                                isRequired: true,
                                label: translation.forms.facility.start_date,
                                closeOnSelected: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'end_date',
                            type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                            context: {
                                fullWidth: true,
                                isRequired: true,
                                label: translation.forms.facility.end_date,
                                closeOnSelected: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'source_of_fund',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                defaultValue: 'CF',
                                label: translation.forms.loan.source_of_funds,
                                items: sourceOfFunds,
                                fullWidth: true,
                                isRequired: true,
                                readonlyTemplate: (value) => sourceOfFunds.find((item) => item.value == value)?.text || 'N/A',
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'origination_fee',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.origination_fee,
                                prefix: getCurrentCountryConfig().currencyCode,
                                // inputType: 'number',
                                isRequired: true,
                                fullWidth: true,
                                readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'ltv',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.ltv,
                                suffix: '%',
                                // inputType: 'number',
                                isRequired: true,
                                fullWidth: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required, Validators.min(0), Validators.max(100)],
                        },
                        {
                            key: 'crowdfund_day',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.days_to_crowdfund,
                                suffix: 'days',
                                // inputType: 'number',
                                fullWidth: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                        },
                        {
                            key: 'late_interest_fee_type',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                defaultValue: 'PER_ANNUM',
                                label: translation.forms.facility.late_interest_fee_type,
                                isRequired: true,
                                fullWidth: true,
                                items: latePeriods,
                                readonlyTemplate: (value) => latePeriods.find((item) => item.value == value)?.text || 'N/A',
                            },
                            validations: [Validators.required],
                        },
                    ],
                    containers: [
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'facility_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.facility_fee,
                                        fullWidth: true,
                                        suffix: '%',
                                        isRequired: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required, Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'facility_fee_period',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: periodTypes,
                                        readonlyTemplate: (value) => periodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'admin_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.admin_fee,
                                        fullWidth: true,
                                        suffix: '%',
                                        isRequired: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required, Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'admin_fee_period',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: adminPeriodTypes,
                                        readonlyTemplate: (value) => adminPeriodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'service_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.service_fee,
                                        fullWidth: true,
                                        suffix: '%',
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'service_fee_period',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        fullWidth: true,
                                        items: periodTypes,
                                        readonlyTemplate: (value) => periodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'restructure_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.restructure,
                                        fullWidth: true,
                                        suffix: '%',
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'restructure_fee_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        fullWidth: true,
                                        items: periodTypes,
                                        readonlyTemplate: (value) => periodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        ...containers,
    ];
}
function getFacilityImportContainers(type, method, translation, state) {
    let hiddenObj = {};
    if (method === 'POST') {
        hiddenObj = {
            instance: '',
            installment: 0,
            origination_fee: 0,
            service_fee: 0,
            service_fee_period: '',
            plafond_type: '',
            due_day_per_month: 0,
            loan_number: '',
            loan_type: 0,
            loan_amount: 0,
            loan_purpose: null,
            installment_types: null,
            interest_type: null,
            late_interest_rate: 0,
            late_interest_type: 0,
            source_of_fund: '',
        };
    }
    else {
        hiddenObj['id'] = '';
    }
    const keys = Object.keys(hiddenObj);
    const containers = keys.length
        ? [
            {
                customClasses: 'hidden',
                fields: keys.map((key) => ({
                    key,
                    type: FSWDynamicBuilderControlTypes.TEMPLATE,
                    context: {
                        defaultValue: hiddenObj[key],
                        isHidden: true,
                    },
                })),
            },
        ]
        : [];
    return [
        {
            customClasses: 'flex justify-between gap-[16px]',
            containers: [
                {
                    customClasses: 'flex-1 flex flex-col gap-[16px] w-[calc(50%-8px)]',
                    fields: [
                        {
                            key: 'member_id',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                label: translation.forms.facility.borrower,
                                items: state.members?.map((member) => ({
                                    value: member.uuid,
                                    text: getProposalsMemberName(member),
                                })) || [],
                                fullWidth: true,
                                isRequired: true,
                                isDisabled: true,
                                readonlyTemplate: (uuid) => uuid
                                    ? getProposalsMemberName(getProposalsMember(state.members || [], { uuid }))
                                    : 'N/A',
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'status',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                label: translation.forms.facility.status,
                                fullWidth: true,
                                isRequired: true,
                                isDisabled: true,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'facility_type_id',
                            type: FSWDynamicBuilderControlTypes.SELECT,
                            context: {
                                label: translation.forms.facility.type,
                                items: state.facilityTypes.map((item) => ({
                                    value: item.id,
                                    text: item.description,
                                })) || [],
                                fullWidth: true,
                                isRequired: true,
                                isDisabled: true,
                                readonlyTemplate: (value) => state.facilityTypes.find((item) => item.id === value)?.description || 'N/A',
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'start_date',
                            type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                            context: {
                                defaultValue: new Date(),
                                label: translation.forms.facility.start_date,
                                readonlyTemplate: (value) => new DatePipe('en-US').transform(value, 'dd/MM/yyyy') || '',
                                closeOnSelected: true,
                                fullWidth: true,
                            },
                        },
                        {
                            key: 'limit',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.limit,
                                prefix: getCurrentCountryConfig().currencyCode,
                                // inputType: 'number',
                                isRequired: true,
                                fullWidth: true,
                                readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'minimum_amount_due',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.minimum_amount_due,
                                prefix: getCurrentCountryConfig().currencyCode,
                                // inputType: 'number',
                                isRequired: true,
                                fullWidth: true,
                                readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'ltv',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.ltv,
                                suffix: '%',
                                // inputType: 'number',
                                isRequired: true,
                                fullWidth: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required, Validators.min(0), Validators.max(100)],
                        },
                        {
                            key: 'late_interest_fee',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0.1,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.late_interest_fee,
                                suffix: '% per day',
                                // inputType: 'number',
                                isRequired: true,
                                fullWidth: true,
                                readonlyTemplate: (value) => (value || 0).toString(),
                            },
                            validations: [Validators.required],
                        },
                        {
                            key: 'annual_fee',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                defaultValue: 0,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                label: translation.forms.facility.annual_fee,
                                prefix: getCurrentCountryConfig().currencyCode,
                                // inputType: 'number',
                                fullWidth: true,
                                readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                            },
                        },
                    ],
                    containers: [
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'facility_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.facility_fee,
                                        fullWidth: true,
                                        suffix: '%',
                                        isRequired: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required, Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'facility_fee_period',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: periodTypes,
                                        readonlyTemplate: (value) => periodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'admin_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.admin_fee,
                                        fullWidth: true,
                                        suffix: '%',
                                        isRequired: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required, Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'admin_fee_period',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: adminPeriodTypes,
                                        readonlyTemplate: (value) => adminPeriodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'service_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.service_fee,
                                        fullWidth: true,
                                        suffix: '%',
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'service_fee_period',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        fullWidth: true,
                                        items: periodTypes,
                                        readonlyTemplate: (value) => periodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'restructure_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.restructure,
                                        fullWidth: true,
                                        suffix: '%',
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'restructure_fee_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        fullWidth: true,
                                        items: periodTypes,
                                        readonlyTemplate: (value) => periodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                    ],
                },
                {
                    customClasses: 'flex-1 flex flex-col gap-[16px] w-[calc(50%-8px)]',
                    fields: [
                        {
                            key: 'code',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                label: translation.forms.facility.code,
                                fullWidth: true,
                                isRequired: true,
                                isDisabled: true,
                            },
                            validations: [Validators.required],
                        },
                    ],
                    containers: [
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: type === FSWProposalsFormTypes.FACILITY_IMPORT
                                ? [
                                    {
                                        key: 'original_version',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        customClasses: 'flex-1',
                                        context: {
                                            defaultValue: 0,
                                            label: translation.forms.facility.current_version,
                                            fullWidth: true,
                                            isRequired: true,
                                        },
                                        validations: [Validators.required],
                                    },
                                    {
                                        key: 'version',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        customClasses: 'flex-1',
                                        context: {
                                            defaultValue: 0,
                                            label: translation.forms.facility.new_version,
                                            isRequired: true,
                                            fullWidth: true,
                                        },
                                        validations: [Validators.required],
                                    },
                                ]
                                : [
                                    {
                                        key: 'version',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        customClasses: 'flex-1',
                                        context: {
                                            defaultValue: 0,
                                            label: translation.forms.facility.version,
                                            isRequired: true,
                                            fullWidth: true,
                                        },
                                        validations: [Validators.required],
                                    },
                                ],
                        },
                        {
                            customClasses: 'flex flex-col gap-[16px] justify-between',
                            fields: [
                                {
                                    key: 'product_id',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    context: {
                                        label: translation.forms.facility.product,
                                        items: state.products.map((product) => ({
                                            text: product.name,
                                            value: product.id,
                                        })),
                                        fullWidth: true,
                                        isRequired: true,
                                        isDisabled: true,
                                        readonlyTemplate: (value) => state.products.find((item) => item.id === value)?.name || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'end_date',
                                    type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                                    context: {
                                        defaultValue: new Date(),
                                        label: translation.forms.facility.end_date,
                                        readonlyTemplate: (value) => new DatePipe('en-US').transform(value, 'dd/MM/yyyy') || '',
                                        closeOnSelected: true,
                                        fullWidth: true,
                                    },
                                },
                                {
                                    key: 'max_loan_to_value',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.max_loan_to_value,
                                        prefix: getCurrentCountryConfig().currencyCode,
                                        // inputType: 'number',
                                        isRequired: true,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'disbursement_request_period',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.disbursement_request_period,
                                        isRequired: true,
                                        fullWidth: true,
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'crowdfund_day',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.days_to_crowdfund,
                                        suffix: 'days',
                                        // inputType: 'number',
                                        fullWidth: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'late_increment_day',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    context: {
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.late_increment_day,
                                        suffix: 'days',
                                        // inputType: 'number',
                                        isRequired: true,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'late_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 1000,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.tenor,
                                        prefix: getCurrentCountryConfig().currencyCode,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => `${new Intl.NumberFormat().format(value || 0)}`,
                                    },
                                },
                                {
                                    key: 'late_fee_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        fullWidth: true,
                                        items: periodTypes,
                                        readonlyTemplate: (value) => periodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'interest_rate',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.interest_rate,
                                        fullWidth: true,
                                        suffix: '%',
                                        isRequired: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required, Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'interest_term',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: interestTerms,
                                        readonlyTemplate: (value) => interestTerms.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'term',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.credit_term,
                                        fullWidth: true,
                                        isRequired: true,
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'term_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'day',
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: termTypes,
                                        readonlyTemplate: (value) => termTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'flex gap-[8px] justify-between',
                            fields: [
                                {
                                    key: 'restructure_fee',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        // inputType: 'number',
                                        defaultValue: 0,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        label: translation.forms.facility.restructure,
                                        fullWidth: true,
                                        suffix: '%',
                                        isRequired: true,
                                        readonlyTemplate: (value) => (value || 0).toString(),
                                    },
                                    validations: [Validators.required, Validators.min(0), Validators.max(100)],
                                },
                                {
                                    key: 'restructure_fee_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    customClasses: 'flex-1',
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.period,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: periodTypes,
                                        readonlyTemplate: (value) => periodTypes.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                        {
                            customClasses: 'w-full',
                            fields: [
                                {
                                    key: 'late_interest_fee_type',
                                    type: FSWDynamicBuilderControlTypes.SELECT,
                                    context: {
                                        defaultValue: 'PER_ANNUM',
                                        label: translation.forms.facility.late_interest_fee_type,
                                        isRequired: true,
                                        fullWidth: true,
                                        items: latePeriods,
                                        readonlyTemplate: (value) => latePeriods.find((item) => item.value == value)?.text || 'N/A',
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        ...containers,
    ];
}

const FSW_PROPOSALS_TH_PROVIDERS = [
    {
        provide: FSW_PROPOSALS_STORE_TOKEN,
        useClass: FSWProposalsStoreTH,
        deps: [
            APPLICATION_MEMBER_SERVICE_TOKEN,
            APPLICATION_PROPOSAL_SERVICE_TOKEN,
            FACILITY_SERVICE_TOKEN,
            SETTINGS_SERVICE_TOKEN,
            FSW_LOAN_SERVICE_TOKEN,
            FSW_ALERT_SERVICE_TOKEN,
            FSW_PROPOSALS_FORM_TOKEN,
        ],
    },
    {
        provide: FSW_PROPOSALS_FORM_TOKEN,
        useValue: FSWProposalsFormTH,
        deps: [],
    },
];

const FSW_PROPOSALS_PROVIDERS = {
    default: FSW_PROPOSALS_TH_PROVIDERS,
    [CountryCode.TH]: FSW_PROPOSALS_TH_PROVIDERS,
    [CountryCode.MY]: FSW_PROPOSALS_MY_PROVIDERS,
    [CountryCode.SG]: FSW_PROPOSALS_SG_PROVIDERS,
};
const proposalsLoadProviders = (countryCode) => [
    fswTranslateScope('proposals'),
    ...getCustomProviders(FSW_PROPOSALS_PROVIDERS, FSW_PROPOSALS_TH_PROVIDERS, countryCode),
];

class FSWProposalsConfirmComponent {
    constructor(dialogRef) {
        this.dialogRef = dialogRef;
    }
    close(haveData = false) {
        this.dialogRef.close(haveData);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsConfirmComponent, deps: [{ token: i1$7.DialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWProposalsConfirmComponent, selector: "fsw-proposals-confirm", ngImport: i0, template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"'buttons.yes' | fswTranslate\"\n  [cancelButton]=\"'buttons.no' | fswTranslate\"\n  (confirmEvent)=\"close(true)\"\n  (cancelEvent)=\"close(false)\"\n  (closeEvent)=\"close(false)\"\n>\n  <ng-template fswModalBody>\n    <p>\n      {{\n        dialogRef.config.data['description']\n          | fswTranslate : { data: dialogRef.config.data['descriptionParams'] }\n      }}\n    </p>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsConfirmComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-proposals-confirm', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"'buttons.yes' | fswTranslate\"\n  [cancelButton]=\"'buttons.no' | fswTranslate\"\n  (confirmEvent)=\"close(true)\"\n  (cancelEvent)=\"close(false)\"\n  (closeEvent)=\"close(false)\"\n>\n  <ng-template fswModalBody>\n    <p>\n      {{\n        dialogRef.config.data['description']\n          | fswTranslate : { data: dialogRef.config.data['descriptionParams'] }\n      }}\n    </p>\n  </ng-template>\n</fsw-modal>\n" }]
        }], ctorParameters: function () { return [{ type: i1$7.DialogRef }]; } });

class FSWProposalsRetrieveGridPipe {
    transform(value, state) {
        return {
            borrower: getProposalsMemberName(getProposalsMember(state.members || [], { id: value.memberId })),
            name: value.productName,
            code: value.facilityCode,
            status: value.status,
            limit: new Intl.NumberFormat().format(Number(value.limit || '0')),
            type: value.facilityType,
            interest: `${value.interestRate} ${value.interestRateType}`,
            period: `${differenceInDays(new Date(value.endDate), new Date(value.startDate))} days`,
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsRetrieveGridPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsRetrieveGridPipe, name: "fswProposalsRetrieveGrid" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsRetrieveGridPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fswProposalsRetrieveGrid',
                }]
        }] });

class FSWProposalsRetrieveComponent {
    get builder() {
        return this.dialogRef.config.data;
    }
    constructor(dialogRef, componentStore, _alertService, _cdr, _dialog, _injector) {
        this.dialogRef = dialogRef;
        this.componentStore = componentStore;
        this._alertService = _alertService;
        this._cdr = _cdr;
        this._dialog = _dialog;
        this._injector = _injector;
        this.renderType$ = new BehaviorSubject(FSWProposalsRenderTypes.GRID);
        this.title$ = this.renderType$.asObservable().pipe(map((type) => type === FSWProposalsRenderTypes.GRID
            ? {
                value: 'tables.facilities.title',
                params: {},
            }
            : {
                value: 'modals.facility.import',
                params: {
                    code: this.builder.groupConfig.form.getRawValue().code,
                },
            }));
        this.facilities$ = this.componentStore
            .select((state) => state.facilities)
            .pipe(map((facilities) => facilities?.filter((facility) => allowedProposalsFacilityStatuses.has(facility.status))));
        this.FSWProposalsRenderTypes = FSWProposalsRenderTypes;
        this.columns = [
            'borrower',
            'name',
            'code',
            'status',
            'limit',
            'type',
            'interest',
            'period',
        ].reduce((acc, key) => ({
            ...acc,
            [key]: `tables.facilities.columns.${key}`,
        }), {});
    }
    ngOnInit() {
        this.componentStore.loadFacilities();
    }
    close(haveData = false) {
        this.dialogRef.close(haveData);
    }
    select(item) {
        this.builder.groupConfig.form.patchValue({
            loan_type: 0,
            late_interest_type: 0,
            member_id: getProposalsMember(this.componentStore.state().members || [], {
                id: item.memberId,
            })?.uuid,
            code: item.code,
            status: item.status,
            original_version: item.version,
            version: item.version + 1,
            facility_type_id: item.facilityTypeId,
            product_id: item.productId,
            limit: Number(item.limit),
            max_loan_to_value: Number(item.maxLoanToValue),
            start_date: new Date(item.startDate),
            end_date: new Date(item.endDate),
            interest_rate: Number(item.interestRate),
            interest_term: item.interestRateType,
            admin_fee: Number(item.adminFee),
            admin_fee_period: item.adminFeeType,
            facility_fee: Number(item.facilityFee),
            facility_fee_period: item.facilityFeeType,
            late_fee: Number(item.lateFee),
            late_fee_type: item.lateFeeType,
            late_interest_fee: Number(item.lateInterestFee),
            late_increment_day: item.lateIncrementDay,
            annual_fee: Number(item.admissionFee),
            discounting: Number(item.discountingFee),
            discounting_type: item.discountingFeeType,
            minimum_amount_due: Number(item.minimumAmountDue),
            disbursement_request_period: item.disbursementRequestPeriod,
            ltv: Number(item.ltv),
            crowdfund_day: Number(item.daysToCrowdfund),
            term: Number(item.creditTerm),
        });
        this.renderType$.next(FSWProposalsRenderTypes.FORM);
    }
    submit() {
        const form = this.builder.groupConfig.form;
        if (form.invalid) {
            form.markAllAsTouched();
            this._alertService.warning('Invalid Information', 'Please fill in all mandatory fields.', {
                duration: 3000,
            });
            return;
        }
        this._dialog
            .open(FSWProposalsConfirmComponent, {
            data: {
                title: `modals.facility.confirm_import_title`,
                titleParams: {},
                description: `modals.facility.confirm_import`,
                descriptionParams: {
                    code: form.getRawValue().code,
                },
            },
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((accept) => {
            if (accept) {
                this.close(true);
            }
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsRetrieveComponent, deps: [{ token: i1$7.DialogRef }, { token: FSW_PROPOSALS_STORE_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }, { token: i0.ChangeDetectorRef }, { token: i1$7.Dialog }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWProposalsRetrieveComponent, selector: "fsw-proposals-retrieve", ngImport: i0, template: "<ng-container *ngIf=\"title$ | async as title\">\n  <fsw-modal\n    [size]=\"'l'\"\n    [title]=\"title.value | fswTranslate : { data: title.params }\"\n    [bodyCustomClasses]=\"'max-h-[calc(90vh-138px)] overflow-y-auto'\"\n    (closeEvent)=\"close(false)\"\n  >\n    <ng-template fswModalBody>\n      <ng-container [ngSwitch]=\"renderType$ | async\">\n        <ng-container *ngSwitchCase=\"FSWProposalsRenderTypes.FORM\">\n          <form [formGroup]=\"builder.groupConfig.form\">\n            <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n          </form>\n        </ng-container>\n        <ng-container *ngSwitchDefault>\n          <fsw-proposals-grid\n            [columns]=\"columns\"\n            [rows]=\"$any(facilities$ | async)\"\n            (rowClick)=\"select($any($event))\"\n          >\n            <ng-template fswProposalsGridItem let-row>\n              <ng-container *ngIf=\"row | fswProposalsRetrieveGrid : componentStore.state() as item\">\n                <td>{{ item.borrower }}</td>\n                <td>{{ item.name }}</td>\n                <td>{{ item.code }}</td>\n                <td>{{ item.status }}</td>\n                <td>{{ item.type }}</td>\n                <td>{{ item.limit }}</td>\n                <td>{{ item.interest }}</td>\n                <td>{{ item.period }}</td>\n              </ng-container>\n            </ng-template>\n          </fsw-proposals-grid>\n        </ng-container>\n      </ng-container>\n    </ng-template>\n    <ng-template fswModalFooter>\n      <section class=\"flex justify-between w-full items-center\">\n        <aside>\n          <button\n            [attr.data-test-id]=\"'proposals-retrieve-modal-back'\"\n            fswButton\n            *ngIf=\"(renderType$ | async) === FSWProposalsRenderTypes.FORM\"\n            [appearance]=\"'secondary'\"\n            (click)=\"renderType$.next(FSWProposalsRenderTypes.GRID)\"\n          >\n            {{ 'buttons.back' | fswTranslate }}\n          </button>\n        </aside>\n        <main class=\"flex gap-[16px] items-center\">\n          <button\n            fswButton\n            [appearance]=\"'secondary'\"\n            (click)=\"close()\"\n            [attr.data-test-id]=\"'proposals-retrieve-modal-cancel'\"\n          >\n            {{ 'buttons.cancel' | fswTranslate }}\n          </button>\n          <button\n            [attr.data-test-id]=\"'proposals-retrieve-modal-import'\"\n            fswButton\n            *ngIf=\"(renderType$ | async) === FSWProposalsRenderTypes.FORM\"\n            (click)=\"submit()\"\n          >\n            {{ 'buttons.import' | fswTranslate }}\n          </button>\n        </main>\n      </section>\n    </ng-template>\n  </fsw-modal>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "directive", type: i1$4.FSWModalFooterDirective, selector: "ng-template[fswModalFooter]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "directive", type: i1$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: FSWProposalsGridComponent, selector: "fsw-proposals-grid", inputs: ["columns", "rows", "emptyMessage"], outputs: ["rowClick"] }, { kind: "directive", type: FSWProposalsGridItemDirective, selector: "ng-template[fswProposalsGridItem]" }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "pipe", type: FSWProposalsRetrieveGridPipe, name: "fswProposalsRetrieveGrid" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsRetrieveComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-proposals-retrieve', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"title$ | async as title\">\n  <fsw-modal\n    [size]=\"'l'\"\n    [title]=\"title.value | fswTranslate : { data: title.params }\"\n    [bodyCustomClasses]=\"'max-h-[calc(90vh-138px)] overflow-y-auto'\"\n    (closeEvent)=\"close(false)\"\n  >\n    <ng-template fswModalBody>\n      <ng-container [ngSwitch]=\"renderType$ | async\">\n        <ng-container *ngSwitchCase=\"FSWProposalsRenderTypes.FORM\">\n          <form [formGroup]=\"builder.groupConfig.form\">\n            <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n          </form>\n        </ng-container>\n        <ng-container *ngSwitchDefault>\n          <fsw-proposals-grid\n            [columns]=\"columns\"\n            [rows]=\"$any(facilities$ | async)\"\n            (rowClick)=\"select($any($event))\"\n          >\n            <ng-template fswProposalsGridItem let-row>\n              <ng-container *ngIf=\"row | fswProposalsRetrieveGrid : componentStore.state() as item\">\n                <td>{{ item.borrower }}</td>\n                <td>{{ item.name }}</td>\n                <td>{{ item.code }}</td>\n                <td>{{ item.status }}</td>\n                <td>{{ item.type }}</td>\n                <td>{{ item.limit }}</td>\n                <td>{{ item.interest }}</td>\n                <td>{{ item.period }}</td>\n              </ng-container>\n            </ng-template>\n          </fsw-proposals-grid>\n        </ng-container>\n      </ng-container>\n    </ng-template>\n    <ng-template fswModalFooter>\n      <section class=\"flex justify-between w-full items-center\">\n        <aside>\n          <button\n            [attr.data-test-id]=\"'proposals-retrieve-modal-back'\"\n            fswButton\n            *ngIf=\"(renderType$ | async) === FSWProposalsRenderTypes.FORM\"\n            [appearance]=\"'secondary'\"\n            (click)=\"renderType$.next(FSWProposalsRenderTypes.GRID)\"\n          >\n            {{ 'buttons.back' | fswTranslate }}\n          </button>\n        </aside>\n        <main class=\"flex gap-[16px] items-center\">\n          <button\n            fswButton\n            [appearance]=\"'secondary'\"\n            (click)=\"close()\"\n            [attr.data-test-id]=\"'proposals-retrieve-modal-cancel'\"\n          >\n            {{ 'buttons.cancel' | fswTranslate }}\n          </button>\n          <button\n            [attr.data-test-id]=\"'proposals-retrieve-modal-import'\"\n            fswButton\n            *ngIf=\"(renderType$ | async) === FSWProposalsRenderTypes.FORM\"\n            (click)=\"submit()\"\n          >\n            {{ 'buttons.import' | fswTranslate }}\n          </button>\n        </main>\n      </section>\n    </ng-template>\n  </fsw-modal>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: i1$7.DialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PROPOSALS_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: i0.ChangeDetectorRef }, { type: i1$7.Dialog }, { type: i0.Injector }]; } });

class FSWProposalsSaveComponent {
    get data() {
        return this.dialogRef.config.data;
    }
    get translationPrefix() {
        const { type } = this.data;
        return `modals.${type === FSWProposalsFormTypes.LOAN ? 'loan' : 'facility'}`;
    }
    get translationTitle() {
        const { method } = this.data;
        return `${this.translationPrefix}.${method === 'POST' ? 'new' : this.data.isReadonly$ ? 'view' : 'edit'}`;
    }
    get translationDelete() {
        const { type } = this.data;
        return `buttons.delete_${type === FSWProposalsFormTypes.LOAN ? 'loan' : 'facility'}`;
    }
    constructor(dialogRef, _alertService, _dialog, _injector) {
        this.dialogRef = dialogRef;
        this._alertService = _alertService;
        this._dialog = _dialog;
        this._injector = _injector;
        this.dictionaries = [
            {
                name: 'proposals-container',
                dictionaryType: FSWDynamicBuilderFormTypes.CONTAINER,
                component: FSWProposalsContainerComponent,
            },
        ];
    }
    close(haveData = false) {
        this.dialogRef.close(haveData);
    }
    submit() {
        const { builder, method } = this.data;
        const form = builder.groupConfig.form;
        if (form.invalid) {
            form.markAllAsTouched();
            this._alertService.warning('Invalid Information', 'Please fill in all mandatory fields.', {
                duration: 3000,
            });
            return;
        }
        this._dialog
            .open(FSWProposalsConfirmComponent, {
            data: {
                title: `${this.translationPrefix}.confirm_${method === 'POST' ? 'add' : 'edit'}_title`,
                titleParams: {},
                description: `${this.translationPrefix}.confirm_${method === 'POST' ? 'add' : 'edit'}`,
                descriptionParams: {},
            },
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((accept) => {
            if (accept) {
                this.close(true);
            }
        }))
            .subscribe();
    }
    edit() {
        this.data.isReadonly$.next(false);
    }
    delete() {
        this.data.delete(this.data.builder.groupConfig.form.getRawValue().id, this.data.type, () => {
            this.close();
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsSaveComponent, deps: [{ token: i1$7.DialogRef }, { token: FSW_ALERT_SERVICE_TOKEN }, { token: i1$7.Dialog }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWProposalsSaveComponent, selector: "fsw-proposals-save", ngImport: i0, template: "<fsw-modal\n  [size]=\"'l'\"\n  [title]=\"translationTitle | fswTranslate\"\n  [bodyCustomClasses]=\"'max-h-[calc(90vh-138px)] overflow-y-auto'\"\n  [hiddenFooter]=\"data.isReadonly\"\n  (closeEvent)=\"close()\"\n>\n  <ng-template fswModalBody>\n    <form [formGroup]=\"data.builder.groupConfig.form\">\n      <fsw-dynamic-builder\n        [builder]=\"data.builder\"\n        [dictionaries]=\"dictionaries\"\n      ></fsw-dynamic-builder>\n    </form>\n  </ng-template>\n  <ng-template fswModalFooter>\n    <section class=\"flex justify-between w-full items-center\">\n      <aside>\n        <button\n          [attr.data-test-id]=\"'proposals-save-modal-delete'\"\n          *ngIf=\"data.method === 'PUT'\"\n          fswButton\n          class=\"!text-red-500\"\n          [appearance]=\"'secondary'\"\n          (click)=\"delete()\"\n        >\n          {{ translationDelete | fswTranslate }}\n        </button>\n      </aside>\n      <main class=\"flex gap-[16px] items-center\">\n        <button\n          fswButton\n          [appearance]=\"'secondary'\"\n          (click)=\"close()\"\n          [attr.data-test-id]=\"'proposals-save-modal-cancel'\"\n        >\n          {{ 'buttons.cancel' | fswTranslate }}\n        </button>\n        <button\n          [attr.data-test-id]=\"'proposals-save-modal-edit'\"\n          (click)=\"edit()\"\n          fswButton\n          *ngIf=\"data.isReadonly$ | async; else saveChangesTemplate\"\n        >\n          {{ 'buttons.edit_details' | fswTranslate }}\n        </button>\n        <ng-template #saveChangesTemplate>\n          <button fswButton (click)=\"submit()\" [attr.data-test-id]=\"'proposals-save-modal-save'\">\n            {{ 'buttons.save_changes' | fswTranslate }}\n          </button>\n        </ng-template>\n      </main>\n    </section>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "directive", type: i1$4.FSWModalFooterDirective, selector: "ng-template[fswModalFooter]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsSaveComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-proposals-save', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal\n  [size]=\"'l'\"\n  [title]=\"translationTitle | fswTranslate\"\n  [bodyCustomClasses]=\"'max-h-[calc(90vh-138px)] overflow-y-auto'\"\n  [hiddenFooter]=\"data.isReadonly\"\n  (closeEvent)=\"close()\"\n>\n  <ng-template fswModalBody>\n    <form [formGroup]=\"data.builder.groupConfig.form\">\n      <fsw-dynamic-builder\n        [builder]=\"data.builder\"\n        [dictionaries]=\"dictionaries\"\n      ></fsw-dynamic-builder>\n    </form>\n  </ng-template>\n  <ng-template fswModalFooter>\n    <section class=\"flex justify-between w-full items-center\">\n      <aside>\n        <button\n          [attr.data-test-id]=\"'proposals-save-modal-delete'\"\n          *ngIf=\"data.method === 'PUT'\"\n          fswButton\n          class=\"!text-red-500\"\n          [appearance]=\"'secondary'\"\n          (click)=\"delete()\"\n        >\n          {{ translationDelete | fswTranslate }}\n        </button>\n      </aside>\n      <main class=\"flex gap-[16px] items-center\">\n        <button\n          fswButton\n          [appearance]=\"'secondary'\"\n          (click)=\"close()\"\n          [attr.data-test-id]=\"'proposals-save-modal-cancel'\"\n        >\n          {{ 'buttons.cancel' | fswTranslate }}\n        </button>\n        <button\n          [attr.data-test-id]=\"'proposals-save-modal-edit'\"\n          (click)=\"edit()\"\n          fswButton\n          *ngIf=\"data.isReadonly$ | async; else saveChangesTemplate\"\n        >\n          {{ 'buttons.edit_details' | fswTranslate }}\n        </button>\n        <ng-template #saveChangesTemplate>\n          <button fswButton (click)=\"submit()\" [attr.data-test-id]=\"'proposals-save-modal-save'\">\n            {{ 'buttons.save_changes' | fswTranslate }}\n          </button>\n        </ng-template>\n      </main>\n    </section>\n  </ng-template>\n</fsw-modal>\n" }]
        }], ctorParameters: function () { return [{ type: i1$7.DialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: i1$7.Dialog }, { type: i0.Injector }]; } });

class FSWProposalsGridPipe {
    transform(value) {
        const { proposal_type, product, facility_type, data, member } = value;
        const { propose } = data;
        return {
            id: value.id,
            type: proposal_type === 'LOAN' ? product?.name : facility_type?.name,
            status: propose.status || 'NEW',
            code: propose.code || 'N/A',
            borrower: getProposalsMemberName(member),
            limit: new Intl.NumberFormat().format(proposal_type === 'LOAN' ? propose.loan_amount : propose.limit),
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsGridPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsGridPipe, name: "fswProposalsGrid" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsGridPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fswProposalsGrid',
                }]
        }] });

class FSWProposalsComponent {
    set applicationId(applicationId) {
        this.componentStore.updateState({
            applicationId,
        });
    }
    set isReadonly(isReadonly) {
        this.componentStore.updateState({
            isReadonly,
        });
    }
    set allowedProductUPIs(allowedProductUPIs) {
        this.componentStore.updateState({
            allowedProductUPIs,
        });
    }
    constructor(componentStore, _form, _dialog, _injector) {
        this.componentStore = componentStore;
        this._form = _form;
        this._dialog = _dialog;
        this._injector = _injector;
        this.proposalsChange = this.componentStore.proposalsChange;
        this.disabledNewLoanButton = false;
        this.disabledNewFacilityButton = false;
        this.disabledRetrieveButton = false;
        this.hiddenNewLoanButton = false;
        this.hiddenNewFacilityButton = false;
        this.hiddenRefreshButton = false;
        this.hiddenRetrieveButton = false;
        this.disabledButtonsWhenHaveData = false;
        this.hiddenSwitch = false;
        this.state$ = this.componentStore.state$;
        this.renderType$ = this.componentStore.select((state) => state.renderType);
        this.proposals$ = this.componentStore.select((state) => state.proposals);
        this.isReadonly$ = this.componentStore.select((state) => state.isReadonly);
        this.FSWProposalsRenderTypes = FSWProposalsRenderTypes;
        this.FSWProposalsFormTypes = FSWProposalsFormTypes;
        this.columns = [
            'type',
            'borrower',
            'code',
            'status',
            'limit',
            'action',
        ].reduce((acc, key) => ({
            ...acc,
            [key]: `tables.proposals.columns.${key}`,
        }), {});
    }
    ngOnInit() {
        this.componentStore.init();
    }
    save(type, item) {
        const isReadonly$ = new BehaviorSubject(this.componentStore.state().isReadonly || !!item);
        const builder = this._form(new UntypedFormGroup({}), type, item ? 'PUT' : 'POST', this.componentStore.state(), isReadonly$);
        if (item) {
            builder.groupConfig.form.patchValue({
                ...(item.data?.propose || {}),
                member_id: item.member.uuid,
                id: item.id,
            });
            if (getCountryCodeFromStorage() === CountryCode.MY ||
                getCountryCodeFromStorage() === CountryCode.SG) {
                builder.groupConfig.form.patchValue({
                    ...(item.data?.propose || {}),
                    recommendation: {
                        ...(item.data?.recommendation || {}),
                    },
                    member_id: item.member.uuid,
                    id: item.id,
                });
            }
        }
        this._dialog
            .open(FSWProposalsSaveComponent, {
            data: {
                builder,
                isReadonly$,
                type,
                method: item ? 'PUT' : 'POST',
                isReadonly: this.componentStore.state().isReadonly,
                delete: (id, type, cb) => this.delete(id, type, cb),
            },
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((haveData) => {
            if (!haveData) {
                return;
            }
            const rawValue = builder.groupConfig.form.getRawValue();
            const data = {
                ...rawValue,
                crowdfund_day: rawValue?.crowdfund_day || 0,
                service_fee: rawValue?.service_fee || 0,
                restructure_fee: rawValue?.restructure_fee || 0,
            };
            this.componentStore.save({
                id: item?.id,
                data,
                proposal_type: type === FSWProposalsFormTypes.LOAN ? 'LOAN' : 'FACILITY',
            });
        }))
            .subscribe();
    }
    delete(id, type, cb) {
        const translationPrefix = `modals.${type === FSWProposalsFormTypes.LOAN ? 'loan' : 'facility'}`;
        this._dialog
            .open(FSWProposalsConfirmComponent, {
            data: {
                title: `${translationPrefix}.confirm_delete_title`,
                titleParams: {},
                description: `${translationPrefix}.confirm_delete`,
                descriptionParams: {},
            },
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((accept) => {
            if (accept) {
                this.componentStore.deleteProposal({ id, cb });
            }
        }))
            .subscribe();
    }
    import() {
        if (this.componentStore.state().isReadonly) {
            return;
        }
        const builder = this._form(new UntypedFormGroup({}), FSWProposalsFormTypes.FACILITY_IMPORT, 'POST', this.componentStore.state(), of(false));
        this._dialog
            .open(FSWProposalsRetrieveComponent, {
            data: builder,
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((haveData) => {
            if (!haveData) {
                return;
            }
            this.componentStore.save({
                data: builder.groupConfig.form.getRawValue(),
                proposal_type: 'FACILITY',
            });
        }))
            .subscribe();
    }
    select(item) {
        const { proposal_type, data } = item;
        const { propose } = data;
        const { code, version } = propose;
        this.save(proposal_type === 'LOAN'
            ? FSWProposalsFormTypes.LOAN
            : !!code && version > 0 // if code and version is existed, it's mean this data is imported from retrieve facility
                ? FSWProposalsFormTypes.FACILITY_AFTER_IMPORT
                : FSWProposalsFormTypes.FACILITY, item);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsComponent, deps: [{ token: FSW_PROPOSALS_STORE_TOKEN }, { token: FSW_PROPOSALS_FORM_TOKEN }, { token: i1$7.Dialog }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWProposalsComponent, selector: "fsw-proposals", inputs: { applicationId: "applicationId", isReadonly: "isReadonly", allowedProductUPIs: "allowedProductUPIs", disabledNewLoanButton: "disabledNewLoanButton", disabledNewFacilityButton: "disabledNewFacilityButton", disabledRetrieveButton: "disabledRetrieveButton", hiddenNewLoanButton: "hiddenNewLoanButton", hiddenNewFacilityButton: "hiddenNewFacilityButton", hiddenRefreshButton: "hiddenRefreshButton", hiddenRetrieveButton: "hiddenRetrieveButton", disabledButtonsWhenHaveData: "disabledButtonsWhenHaveData", hiddenSwitch: "hiddenSwitch" }, outputs: { proposalsChange: "proposalsChange" }, ngImport: i0, template: "<section class=\"flex flex-col gap-[32px] w-full\">\n  <fsw-proposals-header\n    [renderType]=\"$any(renderType$ | async)\"\n    (renderTypeChange)=\"componentStore.updateState({ renderType: $event })\"\n    (newLoanButtonClick)=\"save(FSWProposalsFormTypes.LOAN)\"\n    (newFacilityButtonClick)=\"save(FSWProposalsFormTypes.FACILITY)\"\n    (refreshButtonClick)=\"componentStore.loadProposals()\"\n    (retrieveButtonClick)=\"import()\"\n    [disabledNewFacilityButton]=\"\n      disabledButtonsWhenHaveData\n        ? !!(proposals$ | async)?.length\n        : disabledNewFacilityButton || $any(isReadonly$ | async)\n    \"\n    [disabledNewLoanButton]=\"\n      disabledButtonsWhenHaveData\n        ? !!(proposals$ | async)?.length\n        : disabledNewLoanButton || $any(isReadonly$ | async)\n    \"\n    [disabledRetrieveButton]=\"\n      disabledButtonsWhenHaveData\n        ? !!(proposals$ | async)?.length\n        : disabledRetrieveButton || $any(isReadonly$ | async)\n    \"\n    [hiddenRefreshButton]=\"hiddenRefreshButton\"\n    [hiddenNewFacilityButton]=\"hiddenNewFacilityButton\"\n    [hiddenNewLoanButton]=\"hiddenNewLoanButton\"\n    [hiddenRetrieveButton]=\"hiddenRetrieveButton\"\n    [hiddenSwitch]=\"hiddenSwitch\"\n  ></fsw-proposals-header>\n  <ng-container [ngSwitch]=\"renderType$ | async\">\n    <ng-container *ngSwitchCase=\"FSWProposalsRenderTypes.FORM\">\n      <fsw-proposals-form\n        (editEvent)=\"save($event.type, $event.item)\"\n        (deleteEvent)=\"delete($event.id, $event.type)\"\n      ></fsw-proposals-form>\n    </ng-container>\n    <ng-container *ngSwitchDefault>\n      <fsw-proposals-grid [columns]=\"columns\" [rows]=\"$any(proposals$ | async)\">\n        <ng-template fswProposalsGridItem let-row>\n          <ng-container *ngIf=\"row | fswProposalsGrid as item\">\n            <td class=\"hover:bg-blue-100 hover:cursor-pointer\" (click)=\"select(row)\">\n              {{ item.type }}\n            </td>\n            <td>{{ item.borrower }}</td>\n            <td>{{ item.code }}</td>\n            <td>{{ item.status }}</td>\n            <td>{{ item.limit }}</td>\n            <td>\n              <button\n                *ngIf=\"!(isReadonly$ | async)\"\n                fswButton\n                [appearance]=\"'icon-no-bg'\"\n                [size]=\"'s'\"\n                (click)=\"delete(item.id, $any(item.type))\"\n              >\n                <i [fswIcon]=\"'common-delete'\" class=\"text-red-500\"></i>\n              </button>\n            </td>\n          </ng-container>\n        </ng-template>\n      </fsw-proposals-grid>\n    </ng-container>\n  </ng-container>\n</section>\n", dependencies: [{ kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "component", type: FSWProposalsFormComponent, selector: "fsw-proposals-form", outputs: ["editEvent", "deleteEvent"] }, { kind: "component", type: FSWProposalsGridComponent, selector: "fsw-proposals-grid", inputs: ["columns", "rows", "emptyMessage"], outputs: ["rowClick"] }, { kind: "component", type: FSWProposalsHeaderComponent, selector: "fsw-proposals-header", inputs: ["renderType", "disabledRefreshButton", "hiddenRefreshButton", "disabledRetrieveButton", "hiddenRetrieveButton", "disabledNewLoanButton", "hiddenNewLoanButton", "disabledNewFacilityButton", "hiddenNewFacilityButton", "hiddenSwitch"], outputs: ["renderTypeChange", "refreshButtonClick", "retrieveButtonClick", "newLoanButtonClick", "newFacilityButtonClick"] }, { kind: "directive", type: FSWProposalsGridItemDirective, selector: "ng-template[fswProposalsGridItem]" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "pipe", type: FSWProposalsGridPipe, name: "fswProposalsGrid" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-proposals', changeDetection: ChangeDetectionStrategy.OnPush, template: "<section class=\"flex flex-col gap-[32px] w-full\">\n  <fsw-proposals-header\n    [renderType]=\"$any(renderType$ | async)\"\n    (renderTypeChange)=\"componentStore.updateState({ renderType: $event })\"\n    (newLoanButtonClick)=\"save(FSWProposalsFormTypes.LOAN)\"\n    (newFacilityButtonClick)=\"save(FSWProposalsFormTypes.FACILITY)\"\n    (refreshButtonClick)=\"componentStore.loadProposals()\"\n    (retrieveButtonClick)=\"import()\"\n    [disabledNewFacilityButton]=\"\n      disabledButtonsWhenHaveData\n        ? !!(proposals$ | async)?.length\n        : disabledNewFacilityButton || $any(isReadonly$ | async)\n    \"\n    [disabledNewLoanButton]=\"\n      disabledButtonsWhenHaveData\n        ? !!(proposals$ | async)?.length\n        : disabledNewLoanButton || $any(isReadonly$ | async)\n    \"\n    [disabledRetrieveButton]=\"\n      disabledButtonsWhenHaveData\n        ? !!(proposals$ | async)?.length\n        : disabledRetrieveButton || $any(isReadonly$ | async)\n    \"\n    [hiddenRefreshButton]=\"hiddenRefreshButton\"\n    [hiddenNewFacilityButton]=\"hiddenNewFacilityButton\"\n    [hiddenNewLoanButton]=\"hiddenNewLoanButton\"\n    [hiddenRetrieveButton]=\"hiddenRetrieveButton\"\n    [hiddenSwitch]=\"hiddenSwitch\"\n  ></fsw-proposals-header>\n  <ng-container [ngSwitch]=\"renderType$ | async\">\n    <ng-container *ngSwitchCase=\"FSWProposalsRenderTypes.FORM\">\n      <fsw-proposals-form\n        (editEvent)=\"save($event.type, $event.item)\"\n        (deleteEvent)=\"delete($event.id, $event.type)\"\n      ></fsw-proposals-form>\n    </ng-container>\n    <ng-container *ngSwitchDefault>\n      <fsw-proposals-grid [columns]=\"columns\" [rows]=\"$any(proposals$ | async)\">\n        <ng-template fswProposalsGridItem let-row>\n          <ng-container *ngIf=\"row | fswProposalsGrid as item\">\n            <td class=\"hover:bg-blue-100 hover:cursor-pointer\" (click)=\"select(row)\">\n              {{ item.type }}\n            </td>\n            <td>{{ item.borrower }}</td>\n            <td>{{ item.code }}</td>\n            <td>{{ item.status }}</td>\n            <td>{{ item.limit }}</td>\n            <td>\n              <button\n                *ngIf=\"!(isReadonly$ | async)\"\n                fswButton\n                [appearance]=\"'icon-no-bg'\"\n                [size]=\"'s'\"\n                (click)=\"delete(item.id, $any(item.type))\"\n              >\n                <i [fswIcon]=\"'common-delete'\" class=\"text-red-500\"></i>\n              </button>\n            </td>\n          </ng-container>\n        </ng-template>\n      </fsw-proposals-grid>\n    </ng-container>\n  </ng-container>\n</section>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PROPOSALS_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PROPOSALS_FORM_TOKEN]
                }] }, { type: i1$7.Dialog }, { type: i0.Injector }]; }, propDecorators: { proposalsChange: [{
                type: Output
            }], applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], allowedProductUPIs: [{
                type: Input
            }], disabledNewLoanButton: [{
                type: Input
            }], disabledNewFacilityButton: [{
                type: Input
            }], disabledRetrieveButton: [{
                type: Input
            }], hiddenNewLoanButton: [{
                type: Input
            }], hiddenNewFacilityButton: [{
                type: Input
            }], hiddenRefreshButton: [{
                type: Input
            }], hiddenRetrieveButton: [{
                type: Input
            }], disabledButtonsWhenHaveData: [{
                type: Input
            }], hiddenSwitch: [{
                type: Input
            }] } });

var FSwProposalsDirective_1;
let FSwProposalsDirective = class FSwProposalsDirective {
    static { FSwProposalsDirective_1 = this; }
    static { this.REFRESH_KEY = 'fs-widgets-feature-proposals'; }
    constructor(_refreshService, _viewContainerRef) {
        this._refreshService = _refreshService;
        this._viewContainerRef = _viewContainerRef;
        this.proposalsChange = new EventEmitter();
        this.applicationId = null;
        this.isReadonly = false;
        this.hiddenNewLoanButton = false;
        this.hiddenNewFacilityButton = false;
        this.hiddenRefreshButton = false;
        this.hiddenRetrieveButton = false;
        this.disabledNewLoanButton = false;
        this.disabledNewFacilityButton = false;
        this.disabledRetrieveButton = false;
        this.disabledButtonsWhenHaveData = false;
        this.hiddenSwitch = false;
        this.allowedProductUPIs = [];
    }
    ngOnInit() {
        this._refreshService
            .register(FSwProposalsDirective_1.REFRESH_KEY)
            .pipe(followDestroy(this), tap(() => this.refresh()))
            .subscribe();
    }
    ngOnChanges() {
        this.refresh();
    }
    refresh() {
        this._viewContainerRef.clear();
        const ref = this._viewContainerRef.createComponent(FSWProposalsComponent, {
            injector: Injector.create({
                parent: this._viewContainerRef.injector,
                providers: [...proposalsLoadProviders(getCountryCodeFromStorage())],
            }),
        });
        const instance = ref.instance;
        instance.applicationId = this.applicationId;
        instance.isReadonly = this.isReadonly;
        instance.allowedProductUPIs = this.allowedProductUPIs;
        instance.hiddenSwitch = this.hiddenSwitch;
        instance.hiddenNewLoanButton = this.hiddenNewLoanButton;
        instance.hiddenRefreshButton = this.hiddenRefreshButton;
        instance.hiddenNewFacilityButton = this.hiddenNewFacilityButton;
        instance.hiddenRetrieveButton = this.hiddenRetrieveButton;
        instance.disabledNewLoanButton = this.disabledNewLoanButton;
        instance.disabledNewFacilityButton = this.disabledNewFacilityButton;
        instance.disabledRetrieveButton = this.disabledRetrieveButton;
        instance.disabledButtonsWhenHaveData = this.disabledButtonsWhenHaveData;
        instance.proposalsChange
            .pipe(followDestroy(this), tap((proposals) => this.proposalsChange.emit(proposals)))
            .subscribe();
        ref.changeDetectorRef.detectChanges();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSwProposalsDirective, deps: [{ token: RefreshService }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSwProposalsDirective, selector: "[fswProposals]", inputs: { applicationId: "applicationId", isReadonly: "isReadonly", hiddenNewLoanButton: "hiddenNewLoanButton", hiddenNewFacilityButton: "hiddenNewFacilityButton", hiddenRefreshButton: "hiddenRefreshButton", hiddenRetrieveButton: "hiddenRetrieveButton", disabledNewLoanButton: "disabledNewLoanButton", disabledNewFacilityButton: "disabledNewFacilityButton", disabledRetrieveButton: "disabledRetrieveButton", disabledButtonsWhenHaveData: "disabledButtonsWhenHaveData", hiddenSwitch: "hiddenSwitch", allowedProductUPIs: "allowedProductUPIs" }, outputs: { proposalsChange: "proposalsChange" }, usesOnChanges: true, ngImport: i0 }); }
};
FSwProposalsDirective = FSwProposalsDirective_1 = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [RefreshService,
        ViewContainerRef])
], FSwProposalsDirective);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSwProposalsDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswProposals]',
                }]
        }], ctorParameters: function () { return [{ type: RefreshService }, { type: i0.ViewContainerRef }]; }, propDecorators: { proposalsChange: [{
                type: Output
            }], applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], hiddenNewLoanButton: [{
                type: Input
            }], hiddenNewFacilityButton: [{
                type: Input
            }], hiddenRefreshButton: [{
                type: Input
            }], hiddenRetrieveButton: [{
                type: Input
            }], disabledNewLoanButton: [{
                type: Input
            }], disabledNewFacilityButton: [{
                type: Input
            }], disabledRetrieveButton: [{
                type: Input
            }], disabledButtonsWhenHaveData: [{
                type: Input
            }], hiddenSwitch: [{
                type: Input
            }], allowedProductUPIs: [{
                type: Input
            }] } });

class FSWProposalsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsModule, declarations: [FSwProposalsDirective,
            FSWProposalsComponent,
            FSWProposalsFormComponent,
            FSWProposalsGridComponent,
            FSWProposalsSwitchComponent,
            FSWProposalsHeaderComponent,
            FSWProposalsRetrieveComponent,
            FSWProposalsSaveComponent,
            FSWProposalsConfirmComponent,
            FSWProposalsGridPipe,
            FSWProposalsRetrieveGridPipe,
            FSWProposalsGridItemDirective,
            FSWProposalsContainerComponent], imports: [i1$4.FSWTranslateModule, FSWButtonModule,
            NgIf,
            FSWSwitchModule,
            FormsModule,
            ApplicationMemberServiceModule,
            ApplicationProposalServiceModule,
            FacilityServiceModule,
            SettingsServiceModule,
            FSWLoanServiceModule,
            FSWAlertModule,
            FSWModalModule$1,
            NgSwitch,
            AsyncPipe,
            NgSwitchCase,
            NgSwitchDefault,
            FSWDynamicBuilderModule,
            ReactiveFormsModule,
            FSWIconModule,
            FSWFieldModule,
            FSWSelectModule,
            NgForOf,
            NgTemplateOutlet,
            FSWPaginationModule$1,
            DialogModule,
            FSWPanelModule], exports: [FSwProposalsDirective,
            FSWProposalsComponent,
            FSWProposalsFormComponent,
            FSWProposalsGridComponent,
            FSWProposalsHeaderComponent,
            FSWProposalsRetrieveComponent,
            FSWProposalsSaveComponent,
            FSWProposalsConfirmComponent,
            FSWProposalsGridPipe,
            FSWProposalsRetrieveGridPipe,
            FSWProposalsGridItemDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsModule, imports: [FSWTranslateModule.forFeature({
                scope: 'proposals',
                defaultKey: CountryCode.TH,
                data: FSW_PROPOSALS_TRANSLATION_LOADER,
            }),
            FSWButtonModule,
            FSWSwitchModule,
            FormsModule,
            ApplicationMemberServiceModule,
            ApplicationProposalServiceModule,
            FacilityServiceModule,
            SettingsServiceModule,
            FSWLoanServiceModule,
            FSWAlertModule,
            FSWModalModule$1,
            FSWDynamicBuilderModule,
            ReactiveFormsModule,
            FSWIconModule,
            FSWFieldModule,
            FSWSelectModule,
            FSWPaginationModule$1,
            DialogModule,
            FSWPanelModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWProposalsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FSwProposalsDirective,
                        FSWProposalsComponent,
                        FSWProposalsFormComponent,
                        FSWProposalsGridComponent,
                        FSWProposalsSwitchComponent,
                        FSWProposalsHeaderComponent,
                        FSWProposalsRetrieveComponent,
                        FSWProposalsSaveComponent,
                        FSWProposalsConfirmComponent,
                        FSWProposalsGridPipe,
                        FSWProposalsRetrieveGridPipe,
                        FSWProposalsGridItemDirective,
                        FSWProposalsContainerComponent,
                    ],
                    exports: [
                        FSwProposalsDirective,
                        FSWProposalsComponent,
                        FSWProposalsFormComponent,
                        FSWProposalsGridComponent,
                        FSWProposalsHeaderComponent,
                        FSWProposalsRetrieveComponent,
                        FSWProposalsSaveComponent,
                        FSWProposalsConfirmComponent,
                        FSWProposalsGridPipe,
                        FSWProposalsRetrieveGridPipe,
                        FSWProposalsGridItemDirective,
                    ],
                    imports: [
                        FSWTranslateModule.forFeature({
                            scope: 'proposals',
                            defaultKey: CountryCode.TH,
                            data: FSW_PROPOSALS_TRANSLATION_LOADER,
                        }),
                        FSWButtonModule,
                        NgIf,
                        FSWSwitchModule,
                        FormsModule,
                        ApplicationMemberServiceModule,
                        ApplicationProposalServiceModule,
                        FacilityServiceModule,
                        SettingsServiceModule,
                        FSWLoanServiceModule,
                        FSWAlertModule,
                        FSWModalModule$1,
                        NgSwitch,
                        AsyncPipe,
                        NgSwitchCase,
                        NgSwitchDefault,
                        FSWDynamicBuilderModule,
                        ReactiveFormsModule,
                        FSWIconModule,
                        FSWFieldModule,
                        FSWSelectModule,
                        NgForOf,
                        NgTemplateOutlet,
                        FSWPaginationModule$1,
                        DialogModule,
                        FSWPanelModule,
                    ],
                }]
        }] });

var header$2 = {
	title: "Repayment Schedule",
	subTitle: "Schedule"
};
var form_fields$2 = {
	installment_type: "Installment Type",
	start_date: "From",
	end_date: "To"
};
var placeholders$2 = {
	installment_type: "Select Installment Type"
};
var buttons$e = {
	cancel: "Cancel",
	save: "Save Repayment Schedule"
};
var labels$2 = {
	schedule: "Schedule",
	date: "Date (Month-Year)",
	principal: "Principal Amount (USD)",
	total_principal: "Total Principal Amount (USD)"
};
var vu = {
	header: header$2,
	form_fields: form_fields$2,
	placeholders: placeholders$2,
	buttons: buttons$e,
	labels: labels$2
};

var vu$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$e,
    default: vu,
    form_fields: form_fields$2,
    header: header$2,
    labels: labels$2,
    placeholders: placeholders$2
});

var header$1 = {
	title: "Repayment Schedule",
	subTitle: "Schedule"
};
var form_fields$1 = {
	installment_type: "Installment Type",
	start_date: "From",
	end_date: "To"
};
var placeholders$1 = {
	installment_type: "Select Installment Type"
};
var buttons$d = {
	cancel: "Cancel",
	save: "Save Repayment Schedule"
};
var labels$1 = {
	schedule: "Schedule",
	date: "Date (Month-Year)",
	principal: "Principal Amount (USD)",
	total_principal: "Total Principal Amount (USD)"
};
var id = {
	header: header$1,
	form_fields: form_fields$1,
	placeholders: placeholders$1,
	buttons: buttons$d,
	labels: labels$1
};

var id$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$d,
    default: id,
    form_fields: form_fields$1,
    header: header$1,
    labels: labels$1,
    placeholders: placeholders$1
});

var header = {
	title: "Repayment Schedule",
	subTitle: "Schedule"
};
var form_fields = {
	installment_type: "Installment Type",
	start_date: "From",
	end_date: "To"
};
var placeholders = {
	installment_type: "Select Installment Type"
};
var buttons$c = {
	cancel: "Cancel",
	save: "Save Repayment Schedule"
};
var labels = {
	schedule: "Schedule",
	date: "Date (Month-Year)",
	principal: "Principal Amount (USD)",
	total_principal: "Total Principal Amount (USD)"
};
var th$2 = {
	header: header,
	form_fields: form_fields,
	placeholders: placeholders,
	buttons: buttons$c,
	labels: labels
};

var th$3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$c,
    default: th$2,
    form_fields: form_fields,
    header: header,
    labels: labels,
    placeholders: placeholders
});

const TRANSLATION_LOADER = {
    default: () => Promise.resolve(vu$1),
    [CountryCode.VU]: () => Promise.resolve(vu$1),
    [CountryCode.ID]: () => Promise.resolve(id$1),
    [CountryCode.TH]: () => Promise.resolve(th$3),
};

let RepaymentSchedulePlanStore = class RepaymentSchedulePlanStore extends ComponentStore {
    constructor(_repaymentService, _stateOverride = {}) {
        super({
            countryCode: null,
            applicationId: null,
            repaymentSchedulePlan: null,
            errors: [],
            ..._stateOverride,
        });
        this._repaymentService = _repaymentService;
        this._stateOverride = _stateOverride;
        this.setApplicationId = this.updater((state, applicationId) => {
            return { ...state, applicationId };
        });
        this.setRepaymentSchedulePlan = this.updater((state, repaymentSchedulePlan) => {
            return { ...state, repaymentSchedulePlan };
        });
        this.setErrors = this.updater((state, errors) => {
            return { ...state, errors };
        });
        this.getRepaymentSchedulePlan = this.effect(pipe(switchMap(() => this._getRepaymentSchedulePlanAsync())));
        this.createRepaymentSchedulePlan = this.effect(pipe(switchMap(({ repaymentSchedulePlan }) => this._createRepaymentSchedulePlanAsync(repaymentSchedulePlan))));
        this.updateRepaymentSchedulePlan = this.effect(pipe(switchMap(({ repaymentSchedulePlan }) => this._updateRepaymentSchedulePlanAsync(repaymentSchedulePlan))));
    }
    _getRepaymentSchedulePlanAsync() {
        if (!isStringValid(this.state().applicationId))
            return EMPTY;
        return this._repaymentService
            .getRepaymentSchedulePlan(this.state().applicationId)
            .pipe(tap((repaymentSchedulePlan) => this.setRepaymentSchedulePlan(repaymentSchedulePlan)), catchError((err) => {
            console.error(err);
            this.setErrors([
                ...this.state().errors,
                `Error: [GET]: /aps/v1/applications/${this.state().applicationId}/repayment_schedule_plans`,
            ]);
            return EMPTY;
        }));
    }
    _createRepaymentSchedulePlanAsync(payload) {
        if (!isStringValid(this.state().applicationId))
            return EMPTY;
        return this._repaymentService
            .createRepaymentSchedulePlan(this.state().applicationId, payload)
            .pipe(switchMap(() => this._getRepaymentSchedulePlanAsync()), catchError((err) => {
            console.error(err);
            this.setErrors([
                ...this.state().errors,
                `Error: [POST]: /aps/v1/applications/${this.state().applicationId}/repayment_schedule_plans`,
            ]);
            return EMPTY;
        }));
    }
    _updateRepaymentSchedulePlanAsync(payload) {
        if (!isStringValid(this.state().applicationId))
            return EMPTY;
        return this._repaymentService
            .updateRepaymentSchedulePlan(this.state().applicationId, this.state().repaymentSchedulePlan?.id, payload)
            .pipe(switchMap(() => this._getRepaymentSchedulePlanAsync()), catchError((err) => {
            console.error(err);
            this.setErrors([
                ...this.state().errors,
                `Error: [PUT]: /aps/v1/applications/${this.state().applicationId}/repayment_schedule_plans/${this.state().repaymentSchedulePlan?.id}`,
            ]);
            return EMPTY;
        }));
    }
};
RepaymentSchedulePlanStore = __decorate([
    __param(0, Inject(REPAYMENT_SCHEDULE_PLAN_SERVICE_TOKEN)),
    __metadata("design:paramtypes", [Object, Object])
], RepaymentSchedulePlanStore);

class IDRepaymentSchedulePlanStore extends RepaymentSchedulePlanStore {
    constructor(_repaymentService) {
        super(_repaymentService, { countryCode: CountryCode.VU });
        this._repaymentService = _repaymentService;
    }
    init() {
        this.getRepaymentSchedulePlan();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDRepaymentSchedulePlanStore, deps: [{ token: REPAYMENT_SCHEDULE_PLAN_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDRepaymentSchedulePlanStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IDRepaymentSchedulePlanStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [REPAYMENT_SCHEDULE_PLAN_SERVICE_TOKEN]
                }] }]; } });

class VURepaymentSchedulePlanStore extends RepaymentSchedulePlanStore {
    constructor(_repaymentService) {
        super(_repaymentService, { countryCode: CountryCode.VU });
        this._repaymentService = _repaymentService;
    }
    init() {
        this.getRepaymentSchedulePlan();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: VURepaymentSchedulePlanStore, deps: [{ token: REPAYMENT_SCHEDULE_PLAN_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: VURepaymentSchedulePlanStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: VURepaymentSchedulePlanStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [REPAYMENT_SCHEDULE_PLAN_SERVICE_TOKEN]
                }] }]; } });

class THRepaymentSchedulePlanStore extends RepaymentSchedulePlanStore {
    constructor(_repaymentService) {
        super(_repaymentService, { countryCode: CountryCode.TH });
        this._repaymentService = _repaymentService;
    }
    init() {
        this.getRepaymentSchedulePlan();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: THRepaymentSchedulePlanStore, deps: [{ token: REPAYMENT_SCHEDULE_PLAN_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: THRepaymentSchedulePlanStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: THRepaymentSchedulePlanStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [REPAYMENT_SCHEDULE_PLAN_SERVICE_TOKEN]
                }] }]; } });

const STORE_TOKEN = new InjectionToken('STORE_TOKEN');

class RepaymentSchedulePlanComponent {
    set applicationId(value) {
        this.store.setApplicationId(value);
    }
    get repaymentSchedulePlans() {
        return this.repaymentScheduleForm.get('repayment_schedule_plans_details');
    }
    get tableItems() {
        return this.repaymentSchedulePlans.controls;
    }
    constructor(store, scope, translateService, fb, cdr) {
        this.store = store;
        this.scope = scope;
        this.translateService = translateService;
        this.fb = fb;
        this.cdr = cdr;
        this.isReadonly = false;
        this.totalPrincipalAmount = 0;
        this.installmentTypes = INTALLMENT_TYPES.map((i) => ({
            value: i,
            render: i,
        }));
        this.translate$ = combineLatest([
            this.translateService.selectFeatureTranslate(this.scope, 'header'),
            this.translateService.selectFeatureTranslate(this.scope, 'form_fields'),
            this.translateService.selectFeatureTranslate(this.scope, 'placeholders'),
            this.translateService.selectFeatureTranslate(this.scope, 'buttons'),
            this.translateService.selectFeatureTranslate(this.scope, 'labels'),
        ]).pipe(map(([header, form_fields, placeholders, buttons, labels]) => ({
            header,
            form_fields,
            placeholders,
            buttons,
            labels,
        })));
        this.vm$ = combineLatest([this.store.state$, this.translate$]).pipe(map(([state, translate]) => ({
            state,
            translate,
        })), tap(({ state, translate }) => {
            this.repaymentScheduleForm.patchValue({ ...state.repaymentSchedulePlan });
            this.cdr.markForCheck();
        }));
        this.repaymentScheduleForm = this.fb.group({
            installment_type: ['', Validators.required],
            start_date: ['', Validators.required],
            end_date: ['', Validators.required],
            repayment_schedule_plans_details: this.fb.array([]),
        });
    }
    ngOnInit() {
        this.store.init();
        this.repaymentScheduleForm.valueChanges.subscribe(() => {
            this.totalPrincipalAmount = calculateTotalPrincipalAmount(this.repaymentSchedulePlans.controls);
        });
    }
    onSubmit() {
        if (!this.repaymentScheduleForm.valid)
            return;
        const formValue = this.repaymentScheduleForm.value;
        const storeRepaymentList = this.store?.state()?.repaymentSchedulePlan?.repayment_schedule_plans_details;
        const storeRepaymentListMap = {};
        if (storeRepaymentList) {
            for (const item of storeRepaymentList) {
                storeRepaymentListMap[convertToYearMonth(item.schedule_date)] = item;
            }
        }
        const commonPayload = {
            start_date: sliceDate(formValue.start_date),
            end_date: sliceDate(formValue.end_date),
            installment_type: formValue.installment_type,
            currency: 'USD',
        };
        const postPayload = {
            ...commonPayload,
            repayment_schedule_plans_details: formValue.repayment_schedule_plans_details.map((planDetail) => ({
                ...planDetail,
                schedule_date: sliceDate(planDetail.schedule_date),
            })),
        };
        if (!this.store.state().repaymentSchedulePlan) {
            this.store.createRepaymentSchedulePlan({
                repaymentSchedulePlan: { ...postPayload },
            });
        }
        else {
            const putPayload = {
                ...commonPayload,
                repayment_schedule_plans_details: formValue.repayment_schedule_plans_details.map((planDetail) => ({
                    ...planDetail,
                    id: storeRepaymentListMap[convertToYearMonth(planDetail.schedule_date)]
                        ? storeRepaymentListMap[convertToYearMonth(planDetail.schedule_date)]?.id
                        : null,
                    schedule_date: sliceDate(planDetail.schedule_date),
                })),
            };
            this.store.updateRepaymentSchedulePlan({
                repaymentSchedulePlan: { ...putPayload },
            });
        }
    }
    generateRepaymentSchedulePlans() {
        const startDate = new Date(this.repaymentScheduleForm.get('start_date')?.value);
        const endDate = new Date(this.repaymentScheduleForm.get('end_date')?.value);
        const diffInMs = endDate.getTime() - startDate.getTime();
        const diffInYears = diffInMs / 31536000000;
        if (isNaN(startDate.getTime()) ||
            isNaN(endDate.getTime()) ||
            startDate > endDate ||
            diffInYears > 1)
            return;
        const plans = [];
        const currentDate = startDate;
        while (currentDate <= endDate) {
            const tempDate = new Date(currentDate);
            const plan = this.fb.group({
                schedule_date: tempDate,
                principal_amount: [0, Validators.required],
            });
            plans.push(plan);
            currentDate.setMonth(currentDate.getMonth() + 1);
        }
        this.repaymentScheduleForm.setControl('repayment_schedule_plans_details', this.fb.array([...plans]));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RepaymentSchedulePlanComponent, deps: [{ token: STORE_TOKEN }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: i2.FormBuilder }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: RepaymentSchedulePlanComponent, selector: "fsw-repayment-schedule-plan", inputs: { applicationId: "applicationId", isReadonly: "isReadonly" }, providers: [
            {
                provide: TRANSLOCO_SCOPE,
                useValue: {
                    scope: 'repayment-schedule-plan',
                    loader: TRANSLATION_LOADER,
                },
            },
            {
                provide: TranslocoFeatureHttpLoader,
                useClass: TranslocoFeatureHttpLoader,
            },
        ], ngImport: i0, template: "<ng-container *ngIf=\"vm$ | async as vm\">\n  <fsw-panel [title]=\"vm.translate.header.title\" class=\"flex\">\n    <form\n      class=\"flex flex-col gap-[16px]\"\n      [formGroup]=\"repaymentScheduleForm\"\n      (ngSubmit)=\"onSubmit()\"\n    >\n      <main class=\"flex flex-col gap-[16px]\">\n        <section class=\"flex flex-col gap-[16px]\">\n          <fsw-field>\n            <ng-template\n              fswFieldHeaderPrefix\n              [kind]=\"'default'\"\n              [label]=\"vm.translate.form_fields.installment_type\"\n            ></ng-template>\n            <fsw-select\n              [maxHeight]=\"'200px'\"\n              [placeHolder]=\"vm.translate.placeholders.installment_type\"\n              formControlName=\"installment_type\"\n            >\n              <ng-container *ngFor=\"let type of installmentTypes\">\n                <ng-template\n                  fswSelectItem\n                  let-selected\n                  [text]=\"type.render\"\n                  [value]=\"type.value\"\n                ></ng-template>\n              </ng-container>\n            </fsw-select>\n          </fsw-field>\n\n          <section class=\"flex justify-between gap-[16px]\">\n            <fsw-field>\n              <ng-template\n                fswFieldHeaderPrefix\n                [label]=\"vm.translate.form_fields.start_date\"\n              ></ng-template>\n              <fsw-date-picker\n                formControlName=\"start_date\"\n                [closeOnSelected]=\"true\"\n                (ngModelChange)=\"generateRepaymentSchedulePlans()\"\n              >\n              </fsw-date-picker>\n            </fsw-field>\n            <fsw-field>\n              <ng-template\n                fswFieldHeaderPrefix\n                [label]=\"vm.translate.form_fields.end_date\"\n              ></ng-template>\n              <fsw-date-picker\n                formControlName=\"end_date\"\n                [closeOnSelected]=\"true\"\n                (ngModelChange)=\"generateRepaymentSchedulePlans()\"\n              >\n              </fsw-date-picker>\n            </fsw-field>\n          </section>\n        </section>\n\n        <hr class=\"w-full bg-gray-200 h-px\" />\n\n        <section class=\"flex flex-col gap-[8px]\">\n          <header class=\"flex flex-col gap-[4px]\">\n            <span class=\"subtitle text-gray-700\">{{ vm.translate.labels.schedule }}</span>\n            <!-- <caption class=\"b-caption-400 text-gray-700\">\n              Any blanks in the principal amount fields will be saved as 0\n            </caption> -->\n          </header>\n\n          <table cdk-table [dataSource]=\"tableItems\" class=\"fsw-table\">\n            <ng-container cdkColumnDef=\"schedule_date\">\n              <th width=\"280\" cdk-header-cell *cdkHeaderCellDef>{{ vm.translate.labels.date }}</th>\n              <td cdk-cell *cdkCellDef=\"let element\">\n                {{ element.get('schedule_date')?.value | date : 'MMM-yyyy' }}\n              </td>\n            </ng-container>\n            <ng-container cdkColumnDef=\"principal_amount\">\n              <th width=\"392\" cdk-header-cell *cdkHeaderCellDef>\n                {{ vm.translate.labels.principal }}\n              </th>\n              <td cdk-cell *cdkCellDef=\"let element\">\n                <fsw-field size=\"s\" [fullWidth]=\"true\">\n                  <input\n                    fswInput\n                    fswCurrencyMask\n                    [options]=\"{ prefix: '', allowNegative: false, align: 'right' }\"\n                    [formControl]=\"element.get('principal_amount')\"\n                  />\n                </fsw-field>\n              </td>\n            </ng-container>\n            <tr cdk-header-row *cdkHeaderRowDef=\"['schedule_date', 'principal_amount']\"></tr>\n            <tr cdk-row *cdkRowDef=\"let row; columns: ['schedule_date', 'principal_amount']\"></tr>\n          </table>\n        </section>\n      </main>\n\n      <footer class=\"flex flex-col gap-[16px]\">\n        <article\n          class=\"flex flex-col gap-[8px] p-[16px] border border-solid border-gray-200 rounded-[4px] w-max\"\n        >\n          <span class=\"b-small-500 text-gray-700\">Total Principal Amount (USD)</span>\n          <span class=\"b-default-500 text-gray-900\">{{\n            totalPrincipalAmount | currency : 'USD'\n          }}</span>\n        </article>\n        <button type=\"submit\" fswButton>{{ vm.translate.buttons.save }}</button>\n      </footer>\n    </form>\n  </fsw-panel>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: CurrencyMaskDirective, selector: "[fswCurrencyMask]", inputs: ["max", "min", "options"] }, { kind: "directive", type: i1$4.FSWInputDirective, selector: "input[fswInput], textarea[fswInput]" }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$4.FSWFieldHeaderPrefixDirective, selector: "ng-template[fswFieldHeaderPrefix]", inputs: ["kind", "label", "required"] }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "component", type: i1$4.FSWDatePickerComponent, selector: "fsw-date-picker" }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "component", type: i6$1.CdkTable, selector: "cdk-table, table[cdk-table]", inputs: ["trackBy", "dataSource", "multiTemplateDataRows", "fixedLayout"], outputs: ["contentChanged"], exportAs: ["cdkTable"] }, { kind: "directive", type: i6$1.CdkRowDef, selector: "[cdkRowDef]", inputs: ["cdkRowDefColumns", "cdkRowDefWhen"] }, { kind: "directive", type: i6$1.CdkCellDef, selector: "[cdkCellDef]" }, { kind: "directive", type: i6$1.CdkHeaderCellDef, selector: "[cdkHeaderCellDef]" }, { kind: "directive", type: i6$1.CdkColumnDef, selector: "[cdkColumnDef]", inputs: ["sticky", "cdkColumnDef", "stickyEnd"] }, { kind: "directive", type: i6$1.CdkCell, selector: "cdk-cell, td[cdk-cell]" }, { kind: "component", type: i6$1.CdkRow, selector: "cdk-row, tr[cdk-row]" }, { kind: "directive", type: i6$1.CdkHeaderCell, selector: "cdk-header-cell, th[cdk-header-cell]" }, { kind: "component", type: i6$1.CdkHeaderRow, selector: "cdk-header-row, tr[cdk-header-row]" }, { kind: "directive", type: i6$1.CdkHeaderRowDef, selector: "[cdkHeaderRowDef]", inputs: ["cdkHeaderRowDef", "cdkHeaderRowDefSticky"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i1$1.CurrencyPipe, name: "currency" }, { kind: "pipe", type: i1$1.DatePipe, name: "date" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RepaymentSchedulePlanComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-repayment-schedule-plan', changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        {
                            provide: TRANSLOCO_SCOPE,
                            useValue: {
                                scope: 'repayment-schedule-plan',
                                loader: TRANSLATION_LOADER,
                            },
                        },
                        {
                            provide: TranslocoFeatureHttpLoader,
                            useClass: TranslocoFeatureHttpLoader,
                        },
                    ], template: "<ng-container *ngIf=\"vm$ | async as vm\">\n  <fsw-panel [title]=\"vm.translate.header.title\" class=\"flex\">\n    <form\n      class=\"flex flex-col gap-[16px]\"\n      [formGroup]=\"repaymentScheduleForm\"\n      (ngSubmit)=\"onSubmit()\"\n    >\n      <main class=\"flex flex-col gap-[16px]\">\n        <section class=\"flex flex-col gap-[16px]\">\n          <fsw-field>\n            <ng-template\n              fswFieldHeaderPrefix\n              [kind]=\"'default'\"\n              [label]=\"vm.translate.form_fields.installment_type\"\n            ></ng-template>\n            <fsw-select\n              [maxHeight]=\"'200px'\"\n              [placeHolder]=\"vm.translate.placeholders.installment_type\"\n              formControlName=\"installment_type\"\n            >\n              <ng-container *ngFor=\"let type of installmentTypes\">\n                <ng-template\n                  fswSelectItem\n                  let-selected\n                  [text]=\"type.render\"\n                  [value]=\"type.value\"\n                ></ng-template>\n              </ng-container>\n            </fsw-select>\n          </fsw-field>\n\n          <section class=\"flex justify-between gap-[16px]\">\n            <fsw-field>\n              <ng-template\n                fswFieldHeaderPrefix\n                [label]=\"vm.translate.form_fields.start_date\"\n              ></ng-template>\n              <fsw-date-picker\n                formControlName=\"start_date\"\n                [closeOnSelected]=\"true\"\n                (ngModelChange)=\"generateRepaymentSchedulePlans()\"\n              >\n              </fsw-date-picker>\n            </fsw-field>\n            <fsw-field>\n              <ng-template\n                fswFieldHeaderPrefix\n                [label]=\"vm.translate.form_fields.end_date\"\n              ></ng-template>\n              <fsw-date-picker\n                formControlName=\"end_date\"\n                [closeOnSelected]=\"true\"\n                (ngModelChange)=\"generateRepaymentSchedulePlans()\"\n              >\n              </fsw-date-picker>\n            </fsw-field>\n          </section>\n        </section>\n\n        <hr class=\"w-full bg-gray-200 h-px\" />\n\n        <section class=\"flex flex-col gap-[8px]\">\n          <header class=\"flex flex-col gap-[4px]\">\n            <span class=\"subtitle text-gray-700\">{{ vm.translate.labels.schedule }}</span>\n            <!-- <caption class=\"b-caption-400 text-gray-700\">\n              Any blanks in the principal amount fields will be saved as 0\n            </caption> -->\n          </header>\n\n          <table cdk-table [dataSource]=\"tableItems\" class=\"fsw-table\">\n            <ng-container cdkColumnDef=\"schedule_date\">\n              <th width=\"280\" cdk-header-cell *cdkHeaderCellDef>{{ vm.translate.labels.date }}</th>\n              <td cdk-cell *cdkCellDef=\"let element\">\n                {{ element.get('schedule_date')?.value | date : 'MMM-yyyy' }}\n              </td>\n            </ng-container>\n            <ng-container cdkColumnDef=\"principal_amount\">\n              <th width=\"392\" cdk-header-cell *cdkHeaderCellDef>\n                {{ vm.translate.labels.principal }}\n              </th>\n              <td cdk-cell *cdkCellDef=\"let element\">\n                <fsw-field size=\"s\" [fullWidth]=\"true\">\n                  <input\n                    fswInput\n                    fswCurrencyMask\n                    [options]=\"{ prefix: '', allowNegative: false, align: 'right' }\"\n                    [formControl]=\"element.get('principal_amount')\"\n                  />\n                </fsw-field>\n              </td>\n            </ng-container>\n            <tr cdk-header-row *cdkHeaderRowDef=\"['schedule_date', 'principal_amount']\"></tr>\n            <tr cdk-row *cdkRowDef=\"let row; columns: ['schedule_date', 'principal_amount']\"></tr>\n          </table>\n        </section>\n      </main>\n\n      <footer class=\"flex flex-col gap-[16px]\">\n        <article\n          class=\"flex flex-col gap-[8px] p-[16px] border border-solid border-gray-200 rounded-[4px] w-max\"\n        >\n          <span class=\"b-small-500 text-gray-700\">Total Principal Amount (USD)</span>\n          <span class=\"b-default-500 text-gray-900\">{{\n            totalPrincipalAmount | currency : 'USD'\n          }}</span>\n        </article>\n        <button type=\"submit\" fswButton>{{ vm.translate.buttons.save }}</button>\n      </footer>\n    </form>\n  </fsw-panel>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: i2.FormBuilder }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

const ID_PROVIDERS = [
    {
        provide: TRANSLOCO_LANG,
        useValue: getCountryCodeFromStorage() || 'default',
    },
    {
        provide: STORE_TOKEN,
        useClass: VURepaymentSchedulePlanStore,
        deps: [REPAYMENT_SCHEDULE_PLAN_SERVICE_TOKEN],
    },
];

const VU_PROVIDERS = [
    {
        provide: TRANSLOCO_LANG,
        useValue: getCountryCodeFromStorage() || 'default',
    },
    {
        provide: STORE_TOKEN,
        useClass: VURepaymentSchedulePlanStore,
        deps: [REPAYMENT_SCHEDULE_PLAN_SERVICE_TOKEN],
    },
];

const TH_PROVIDERS = [
    {
        provide: TRANSLOCO_LANG,
        useValue: getCountryCodeFromStorage() || 'default',
    },
    {
        provide: STORE_TOKEN,
        useClass: THRepaymentSchedulePlanStore,
        deps: [REPAYMENT_SCHEDULE_PLAN_SERVICE_TOKEN],
    },
];

const PROVIDERS_MAP = {
    default: VU_PROVIDERS,
    [CountryCode.VU]: VU_PROVIDERS,
    [CountryCode.ID]: ID_PROVIDERS,
    [CountryCode.TH]: TH_PROVIDERS,
};
const repaymentSchedulePlanLoadProviders = (countryCode) => [...getCustomProviders(PROVIDERS_MAP, VU_PROVIDERS, countryCode)];

class RepaymentSchedulePlanModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RepaymentSchedulePlanModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: RepaymentSchedulePlanModule, declarations: [RepaymentSchedulePlanComponent], imports: [CommonModule,
            ReactiveFormsModule,
            LetDirective,
            FormWidgetModule,
            RepaymentSchedulePlanServiceModule,
            FSWCurrencyMaskModule,
            UtilsServiceModule,
            FSWInputModule,
            FSWButtonModule,
            FSWFieldModule,
            FSWSelectModule,
            FSWDateTimePickerModule,
            FSWPanelModule,
            CdkTableModule], exports: [RepaymentSchedulePlanComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RepaymentSchedulePlanModule, providers: [CurrencyPipe, ...repaymentSchedulePlanLoadProviders(getCountryCodeFromStorage())], imports: [CommonModule,
            ReactiveFormsModule,
            FormWidgetModule,
            RepaymentSchedulePlanServiceModule,
            FSWCurrencyMaskModule,
            UtilsServiceModule,
            FSWInputModule,
            FSWButtonModule,
            FSWFieldModule,
            FSWSelectModule,
            FSWDateTimePickerModule,
            FSWPanelModule,
            CdkTableModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RepaymentSchedulePlanModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        LetDirective,
                        FormWidgetModule,
                        RepaymentSchedulePlanServiceModule,
                        FSWCurrencyMaskModule,
                        UtilsServiceModule,
                        FSWInputModule,
                        FSWButtonModule,
                        FSWFieldModule,
                        FSWSelectModule,
                        FSWDateTimePickerModule,
                        FSWPanelModule,
                        CdkTableModule,
                    ],
                    declarations: [RepaymentSchedulePlanComponent],
                    exports: [RepaymentSchedulePlanComponent],
                    providers: [CurrencyPipe, ...repaymentSchedulePlanLoadProviders(getCountryCodeFromStorage())],
                }]
        }] });

var title$6 = "Credit Memo Report Generation";
var fields$3 = {
	exported_by: "Exported By",
	timestamp: "Timestamp",
	export_type: "Export Type",
	status: "Status",
	error: "Error",
	report: "Report",
	action: "Action"
};
var empty = "No records found";
var buttons$b = {
	generate: "Generate Credit Memo Report",
	view_error: "View Error",
	cancel: "Cancel"
};
var reportAll = {
	title: title$6,
	fields: fields$3,
	empty: empty,
	buttons: buttons$b
};

var ALL$5 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$b,
    default: reportAll,
    empty: empty,
    fields: fields$3,
    title: title$6
});

const ALL_TRANSLATION = ALL$5;

function provideReportTranslation(scope) {
    return [
        ...(FSWTranslateModule.forFeature({
            scope: scope,
            defaultKey: getCountryCodeFromStorage(),
            data: {
                [CountryCode.TH]: ALL_TRANSLATION,
                [CountryCode.MY]: ALL_TRANSLATION,
                [CountryCode.VU]: ALL_TRANSLATION,
                [CountryCode.ID]: ALL_TRANSLATION,
                [CountryCode.ZI]: ALL_TRANSLATION,
                [CountryCode.SG]: ALL_TRANSLATION,
            },
        }).providers || []),
        fswTranslateScope(scope),
    ];
}

class FSWReportErrorComponent {
    constructor() {
        this.dialogRef = inject(DialogRef);
    }
    close() {
        this.dialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWReportErrorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWReportErrorComponent, isStandalone: true, selector: "fsw-report-error", providers: [provideReportTranslation('fsw_report_error')], ngImport: i0, template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"\n    ('buttons.view_error' | fswTranslate : { scope: 'fsw_report_error' }) +\n    ' ' +\n    dialogRef.config.data.export_type\n  \"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate\"\n  (cancelEvent)=\"close()\"\n  (closeEvent)=\"close()\"\n>\n  <ng-template fswModalBody>\n    <section\n      class=\"w-full px-4 py-20 flex items-center bg-red-100 justify-center relative hover:cursor-pointer hover:shadow-lightest shadow-small rounded-xl\"\n    >\n      <p\n        class=\"font-inter text-center text-red-500 font-semibold text-body-default-500 break-words\"\n      >\n        {{ dialogRef.config.data.error }}\n      </p>\n    </section>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "ngmodule", type: FSWModalModule$1 }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWReportErrorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-report-error', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [FSWModalModule$1, FSWTranslateModule], providers: [provideReportTranslation('fsw_report_error')], template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"\n    ('buttons.view_error' | fswTranslate : { scope: 'fsw_report_error' }) +\n    ' ' +\n    dialogRef.config.data.export_type\n  \"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate\"\n  (cancelEvent)=\"close()\"\n  (closeEvent)=\"close()\"\n>\n  <ng-template fswModalBody>\n    <section\n      class=\"w-full px-4 py-20 flex items-center bg-red-100 justify-center relative hover:cursor-pointer hover:shadow-lightest shadow-small rounded-xl\"\n    >\n      <p\n        class=\"font-inter text-center text-red-500 font-semibold text-body-default-500 break-words\"\n      >\n        {{ dialogRef.config.data.error }}\n      </p>\n    </section>\n  </ng-template>\n</fsw-modal>\n" }]
        }] });

class FSWReportComponent {
    constructor() {
        this.exportTypes = [];
        this.applicationNumber = null;
        this.isReadonly = false;
        this.fileExtension = 'zip';
        this.applicationService = inject(APPLICATION_SERVICE_TOKEN);
        this.blobService = inject(BLOB_SERVICE_TOKEN);
        this.alertService = inject(FSW_ALERT_SERVICE_TOKEN);
        this.dialog = inject(Dialog);
        this.jobsSignal = signal([]);
        this.exportTypeControl = new FormControl(null, [Validators.required]);
        this.FSWApplicationExportJobStatuses = FSWApplicationExportJobStatuses;
    }
    ngOnInit() {
        this.reload();
    }
    reload() {
        this.applicationService
            .getApplicationExportJobs(this.applicationId)
            .pipe(tap((res) => this.jobsSignal.set(res)))
            .subscribe();
    }
    download(id, exportType) {
        this.blobService
            .downloadV3Blob(id)
            .pipe(tap((e) => downloadFileToLocal(URL.createObjectURL(e), `${this.applicationNumber ?? this.applicationId}-${exportType}-${format(new Date(), 'dd-MM-yyyy:HH-mm-ss')}.${this.fileExtension}`)))
            .subscribe();
    }
    generate(exportType) {
        if (this.isReadonly) {
            this.alertService.warning('Readonly Warning', 'The current step is readonly state, you can not export', {
                duration: 3000,
            });
            return;
        }
        if (!exportType) {
            this.alertService.error('Error', 'Please select export type', {
                duration: 3000,
            });
            return;
        }
        this.applicationService
            .exportApplicationJobs([
            {
                application_id: this.applicationId,
                export_type: exportType,
            },
        ])
            .pipe(tap(() => this.reload()))
            .subscribe();
    }
    viewError(data) {
        this.dialog.open(FSWReportErrorComponent, {
            data,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWReportComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWReportComponent, isStandalone: true, selector: "fsw-report", inputs: { exportTypes: "exportTypes", applicationId: "applicationId", applicationNumber: "applicationNumber", isReadonly: "isReadonly", fileExtension: "fileExtension" }, providers: [provideReportTranslation('fsw_report')], ngImport: i0, template: "<fsw-panel [title]=\"'title' | fswTranslate : { scope: 'fsw_report' }\">\n  <section class=\"flex flex-col gap-[16px]\">\n    <header class=\"flex justify-end items-center gap-[16px]\" *ngIf=\"!isReadonly\">\n      <fsw-field>\n        <fsw-select\n          [maxHeight]=\"'300px'\"\n          [placeHolder]=\"'fields.export_type' | fswTranslate : { scope: 'fsw_report' }\"\n          [formControl]=\"exportTypeControl\"\n        >\n          <ng-container *ngFor=\"let type of exportTypes\">\n            <ng-template\n              fswSelectItem\n              textSize=\"s\"\n              [value]=\"type\"\n              [text]=\"type\"\n              [showCheckIcon]=\"true\"\n              let-selected\n            ></ng-template>\n          </ng-container>\n        </fsw-select>\n      </fsw-field>\n      <button\n        fswButton\n        [disabled]=\"exportTypeControl.invalid\"\n        (click)=\"generate(exportTypeControl.value)\"\n      >\n        {{ 'buttons.generate' | fswTranslate : { scope: 'fsw_report' } }}\n      </button>\n    </header>\n    <table class=\"fsw-table fsw-table--bordered w-full table-fixed\">\n      <thead>\n        <tr>\n          <th class=\"text-center !whitespace-normal !break-words\">\n            {{ 'fields.exported_by' | fswTranslate : { scope: 'fsw_report' } }}\n          </th>\n          <th class=\"text-center !whitespace-normal !break-words\">\n            {{ 'fields.timestamp' | fswTranslate : { scope: 'fsw_report' } }}\n          </th>\n          <th class=\"text-center !whitespace-normal !break-words\">\n            {{ 'fields.export_type' | fswTranslate : { scope: 'fsw_report' } }}\n          </th>\n          <th class=\"text-center !whitespace-normal !break-words\">\n            {{ 'fields.status' | fswTranslate : { scope: 'fsw_report' } }}\n          </th>\n          <th class=\"text-center !whitespace-normal !break-words\">\n            {{ 'fields.error' | fswTranslate : { scope: 'fsw_report' } }}\n          </th>\n          <th class=\"text-center !whitespace-normal !break-words\">\n            {{ 'fields.report' | fswTranslate : { scope: 'fsw_report' } }}\n          </th>\n          <th class=\"text-center !whitespace-normal !break-words\">\n            {{ 'fields.action' | fswTranslate : { scope: 'fsw_report' } }}\n          </th>\n        </tr>\n      </thead>\n      <tbody>\n        <ng-container *ngFor=\"let item of jobsSignal()\">\n          <tr>\n            <td class=\"text-center !break-words !whitespace-normal\">{{ item.created_by }}</td>\n            <td class=\"text-center !break-words !whitespace-normal\">\n              {{ item.created_at | date : 'dd/MM/yyyy hh:mm:ss' }}\n            </td>\n            <td class=\"text-center !break-words !whitespace-normal\">{{ item.export_type }}</td>\n            <td\n              class=\"text-center !break-words !whitespace-normal !font-semibold\"\n              [ngClass]=\"{\n                '!text-red-500': item.job_status === FSWApplicationExportJobStatuses.FAILURE,\n                '!text-green-500': item.job_status === FSWApplicationExportJobStatuses.SUCCESS,\n                '!text-blue-500': item.job_status === FSWApplicationExportJobStatuses.IN_PROGRESS\n              }\"\n            >\n              {{ item.job_status }}\n            </td>\n            <td class=\"text-center !break-words !whitespace-normal\">\n              <button\n                *ngIf=\"item.error\"\n                fswButton\n                [appearance]=\"'secondary-elevate'\"\n                [size]=\"'s'\"\n                class=\"!text-red-500 !bg-red-100\"\n                (click)=\"viewError(item)\"\n              >\n                {{ 'buttons.view_error' | fswTranslate : { scope: 'fsw_report' } }}\n              </button>\n            </td>\n            <td class=\"text-center !break-words !whitespace-normal\">\n              <i\n                *ngIf=\"\n                  !item.error && item.job_status !== FSWApplicationExportJobStatuses.IN_PROGRESS\n                \"\n                (click)=\"download(item.doc_uuid, item.export_type)\"\n                [fswIcon]=\"'common-download'\"\n                class=\"hover:cursor-pointer hover:text-green-500\"\n              ></i>\n            </td>\n            <td class=\"text-center !break-words !whitespace-normal\">\n              <button\n                *ngIf=\"item.job_status === FSWApplicationExportJobStatuses.IN_PROGRESS\"\n                fswButton\n                [appearance]=\"'icon-with-bg'\"\n                [size]=\"'s'\"\n                (click)=\"reload()\"\n              >\n                <i [fswIcon]=\"'common-auto-invest'\"></i>\n              </button>\n            </td>\n          </tr>\n        </ng-container>\n\n        <tr *ngIf=\"!jobsSignal().length\">\n          <td colspan=\"7\">\n            <p class=\"w-full text-center\">{{ 'empty' | fswTranslate : { scope: 'fsw_report' } }}</p>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </section>\n</fsw-panel>\n", styles: [":is() .fsw-table :is(th,td){width:100%;white-space:normal;overflow-wrap:break-word;vertical-align:middle}\n"], dependencies: [{ kind: "ngmodule", type: ApplicationServiceModule }, { kind: "ngmodule", type: FSWBlobServiceModule }, { kind: "ngmodule", type: FSWAlertModule }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgFor, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "pipe", type: DatePipe, name: "date" }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "ngmodule", type: DialogModule }, { kind: "ngmodule", type: FSWFieldModule }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "ngmodule", type: FSWSelectModule }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWReportComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-report', standalone: true, changeDetection: ChangeDetectionStrategy.OnPush, providers: [provideReportTranslation('fsw_report')], imports: [
                        ApplicationServiceModule,
                        FSWBlobServiceModule,
                        FSWAlertModule,
                        FSWTranslateModule,
                        FSWIconModule,
                        FSWButtonModule,
                        NgIf,
                        NgFor,
                        DatePipe,
                        FSWPanelModule,
                        DialogModule,
                        FSWFieldModule,
                        FSWSelectModule,
                        ReactiveFormsModule,
                        FSWReportErrorComponent,
                        NgClass,
                    ], template: "<fsw-panel [title]=\"'title' | fswTranslate : { scope: 'fsw_report' }\">\n  <section class=\"flex flex-col gap-[16px]\">\n    <header class=\"flex justify-end items-center gap-[16px]\" *ngIf=\"!isReadonly\">\n      <fsw-field>\n        <fsw-select\n          [maxHeight]=\"'300px'\"\n          [placeHolder]=\"'fields.export_type' | fswTranslate : { scope: 'fsw_report' }\"\n          [formControl]=\"exportTypeControl\"\n        >\n          <ng-container *ngFor=\"let type of exportTypes\">\n            <ng-template\n              fswSelectItem\n              textSize=\"s\"\n              [value]=\"type\"\n              [text]=\"type\"\n              [showCheckIcon]=\"true\"\n              let-selected\n            ></ng-template>\n          </ng-container>\n        </fsw-select>\n      </fsw-field>\n      <button\n        fswButton\n        [disabled]=\"exportTypeControl.invalid\"\n        (click)=\"generate(exportTypeControl.value)\"\n      >\n        {{ 'buttons.generate' | fswTranslate : { scope: 'fsw_report' } }}\n      </button>\n    </header>\n    <table class=\"fsw-table fsw-table--bordered w-full table-fixed\">\n      <thead>\n        <tr>\n          <th class=\"text-center !whitespace-normal !break-words\">\n            {{ 'fields.exported_by' | fswTranslate : { scope: 'fsw_report' } }}\n          </th>\n          <th class=\"text-center !whitespace-normal !break-words\">\n            {{ 'fields.timestamp' | fswTranslate : { scope: 'fsw_report' } }}\n          </th>\n          <th class=\"text-center !whitespace-normal !break-words\">\n            {{ 'fields.export_type' | fswTranslate : { scope: 'fsw_report' } }}\n          </th>\n          <th class=\"text-center !whitespace-normal !break-words\">\n            {{ 'fields.status' | fswTranslate : { scope: 'fsw_report' } }}\n          </th>\n          <th class=\"text-center !whitespace-normal !break-words\">\n            {{ 'fields.error' | fswTranslate : { scope: 'fsw_report' } }}\n          </th>\n          <th class=\"text-center !whitespace-normal !break-words\">\n            {{ 'fields.report' | fswTranslate : { scope: 'fsw_report' } }}\n          </th>\n          <th class=\"text-center !whitespace-normal !break-words\">\n            {{ 'fields.action' | fswTranslate : { scope: 'fsw_report' } }}\n          </th>\n        </tr>\n      </thead>\n      <tbody>\n        <ng-container *ngFor=\"let item of jobsSignal()\">\n          <tr>\n            <td class=\"text-center !break-words !whitespace-normal\">{{ item.created_by }}</td>\n            <td class=\"text-center !break-words !whitespace-normal\">\n              {{ item.created_at | date : 'dd/MM/yyyy hh:mm:ss' }}\n            </td>\n            <td class=\"text-center !break-words !whitespace-normal\">{{ item.export_type }}</td>\n            <td\n              class=\"text-center !break-words !whitespace-normal !font-semibold\"\n              [ngClass]=\"{\n                '!text-red-500': item.job_status === FSWApplicationExportJobStatuses.FAILURE,\n                '!text-green-500': item.job_status === FSWApplicationExportJobStatuses.SUCCESS,\n                '!text-blue-500': item.job_status === FSWApplicationExportJobStatuses.IN_PROGRESS\n              }\"\n            >\n              {{ item.job_status }}\n            </td>\n            <td class=\"text-center !break-words !whitespace-normal\">\n              <button\n                *ngIf=\"item.error\"\n                fswButton\n                [appearance]=\"'secondary-elevate'\"\n                [size]=\"'s'\"\n                class=\"!text-red-500 !bg-red-100\"\n                (click)=\"viewError(item)\"\n              >\n                {{ 'buttons.view_error' | fswTranslate : { scope: 'fsw_report' } }}\n              </button>\n            </td>\n            <td class=\"text-center !break-words !whitespace-normal\">\n              <i\n                *ngIf=\"\n                  !item.error && item.job_status !== FSWApplicationExportJobStatuses.IN_PROGRESS\n                \"\n                (click)=\"download(item.doc_uuid, item.export_type)\"\n                [fswIcon]=\"'common-download'\"\n                class=\"hover:cursor-pointer hover:text-green-500\"\n              ></i>\n            </td>\n            <td class=\"text-center !break-words !whitespace-normal\">\n              <button\n                *ngIf=\"item.job_status === FSWApplicationExportJobStatuses.IN_PROGRESS\"\n                fswButton\n                [appearance]=\"'icon-with-bg'\"\n                [size]=\"'s'\"\n                (click)=\"reload()\"\n              >\n                <i [fswIcon]=\"'common-auto-invest'\"></i>\n              </button>\n            </td>\n          </tr>\n        </ng-container>\n\n        <tr *ngIf=\"!jobsSignal().length\">\n          <td colspan=\"7\">\n            <p class=\"w-full text-center\">{{ 'empty' | fswTranslate : { scope: 'fsw_report' } }}</p>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </section>\n</fsw-panel>\n", styles: [":is() .fsw-table :is(th,td){width:100%;white-space:normal;overflow-wrap:break-word;vertical-align:middle}\n"] }]
        }], propDecorators: { exportTypes: [{
                type: Input,
                args: [{ required: true }]
            }], applicationId: [{
                type: Input,
                args: [{ required: true }]
            }], applicationNumber: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], fileExtension: [{
                type: Input
            }] } });

var title$5 = "Sales Summary";
var tables$2 = {
	accounts: {
		title: "Accounts",
		details: "Details",
		auto: "Selecting an account will automatically fill in the details below",
		account_holder: "Account Holder",
		account_number: "Account Number",
		bank: "Bank",
		average_balance: "Average Balance",
		debit_turnover: "Debit Turnover",
		credit_turnover: "Credit Turnover",
		average_monthly_balance: "Average Monthly Balance",
		frequency: "Frequency",
		average_monthly: "Average Monthly",
		total: "Total",
		monthly_sales_based_on_financial_statement: "Monthly Sales Based on Financial Statement",
		credit_throughput: "Credit Throughput",
		bounced_cheque: "Bounced Cheque",
		reasons: "Reasons"
	},
	por: {
		title: "Sales Summary: From Por por 30 ( Withholding Tax report of land-transportation business)",
		month: "Month ({{year}})",
		sales: "Sales",
		total: "Total -  FY{{year}}",
		average: "Average - FY{{year}}",
		total_trailing: "Total - 6 Months Trailing",
		average_trailing: "Average - 6 Months Trailing",
		volatility: "Volatility last 6 months (for BTL_ex)",
		reported_year: "Reported Year",
		ebitda_margin: "EBITDA Margin",
		annualized_sales: "Annualized {{year}}F Sales",
		projected_ebitda: "Projected EBITDA {{year}}",
		current_year: "Today's year"
	},
	working_capital: {
		title: "Calculation of working capital requirement",
		vat30: "VAT30 {{year}}",
		target_by_the_client: "Target by the Client",
		ratio: "Ratio / DOH",
		sales: "Sales",
		others: "Others",
		cogs: "Cost of good Sold ต้นทุนขาย",
		ardoh: "Account Receivable  ลูกหนี้การค้า",
		apdoh: "Account Payable เจ้าหนี้การค้า",
		invdoh: "Inventory สินค้าคงคลัง",
		wcr: "Working capital requirements เงินทุนที่ต้องการ",
		st_limit: "Total Short Term Limit (NCB) วงเงินระยะสั้น (OD/PN)",
		surplus: "Surplus/ (Shortfall) เงินทุนที่จำเป็น",
		cash_cycle: "Cash Cycle  วงจรเงินสด",
		idb: "Debt/ Revenue Ratio (IBD)",
		lto: "Long Term Loan Outstanding (including Leasing)"
	}
};
var modals$1 = {
	accounts: {
		add: "Add Account",
		edit: "Edit Account",
		"delete": "Delete Account",
		view: "View Account"
	}
};
var messages$2 = {
	accounts: {
		confirm: {
			"delete": "Are you sure you want to delete this account?",
			update: "Are you sure you want to update this account information?",
			add: "Are you sure you want to add this account information?"
		},
		success: {
			update: "Account information updated successfully",
			add: "Account information added successfully",
			"delete": "Account information deleted successfully"
		},
		error: {
			update: "Error updating account information",
			add: "Error adding account information",
			"delete": "Error deleting account information"
		}
	}
};
var buttons$a = {
	save_changes: "Save Changes",
	edit_details: "Edit Details",
	"delete": "Delete",
	cancel: "Cancel",
	add: "Add",
	refresh: "Refresh"
};
var th$1 = {
	title: title$5,
	tables: tables$2,
	modals: modals$1,
	messages: messages$2,
	buttons: buttons$a
};

var TH$3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$a,
    default: th$1,
    messages: messages$2,
    modals: modals$1,
    tables: tables$2,
    title: title$5
});

const FSW_SALES_SUMMARY_TRANSLATION_LOADER = {
    [CountryCode.TH]: TH$3,
};

const fswSalesSummaryInitialState = {
    id: null,
    applicationId: null,
    isReadonly: false,
    data: null,
    bankAccountStatements: [],
};
class FSWSalesSummaryStore extends ComponentStore {
    constructor(_applicationSalesSummaryService, _salesSummaryService, _bankAccountsAdnStatementsService, _alertService, _initialOptionalState) {
        super(Object.assign(fswSalesSummaryInitialState, _initialOptionalState || {}));
        this._applicationSalesSummaryService = _applicationSalesSummaryService;
        this._salesSummaryService = _salesSummaryService;
        this._bankAccountsAdnStatementsService = _bankAccountsAdnStatementsService;
        this._alertService = _alertService;
        this._initialOptionalState = _initialOptionalState;
        this.yearControl = new UntypedFormControl(new Date().getFullYear());
        this.porGroup = new UntypedFormGroup({
            ebitda_margin: new UntypedFormControl(0, [Validators.required]),
            projected_ebitda: new UntypedFormControl(0, [Validators.required]),
            annualized_sales: new UntypedFormControl(0, [Validators.required]),
            note: new UntypedFormControl(''),
            monthly_amounts: new FormArray(Array.from({ length: 12 }, (_, index) => new UntypedFormGroup({
                month: new UntypedFormControl(index),
                amount: new UntypedFormControl(0, [Validators.required]),
            }))),
        });
        this.capitalGroup = new UntypedFormGroup({
            working_capital_requirements: new UntypedFormGroup({
                stlimit: new FormControl(0, [Validators.required]),
                lto: new FormControl(0, [Validators.required]),
            }),
            vat_30: new UntypedFormGroup({
                sales: new FormControl(0, [Validators.required]),
                cogs: new FormControl(0, [Validators.required]),
                ardoh: new FormControl(0, [Validators.required]),
                invdoh: new FormControl(0, [Validators.required]),
                apdoh: new FormControl(0, [Validators.required]),
                wcr: new FormControl(0, [Validators.required]),
            }),
            target_by_clients: new UntypedFormGroup({
                sales: new FormControl(0, [Validators.required]),
                cogs: new FormControl(0, [Validators.required]),
                ardoh: new FormControl(0, [Validators.required]),
                invdoh: new FormControl(0, [Validators.required]),
                apdoh: new FormControl(0, [Validators.required]),
                wcr: new FormControl(0, [Validators.required]),
            }),
        });
        this.yearPors = new BehaviorSubject([]);
        this.init = this.effect(pipe(filter$1(() => !!this.state().applicationId), tap(() => {
            this.loadDetails();
            this.loadBankAccounts();
        })));
        this.loadDetails = this.effect(pipe(switchMap$1(() => this._applicationSalesSummaryService.getById(this.state().applicationId).pipe(switchMap$1((id) => {
            if (!id) {
                return this._salesSummaryService
                    .create({
                    bounced_cheque: '',
                    reason: '',
                    credit_throughput: 0,
                    monthly_sales_financial_statement: 0,
                })
                    .pipe(switchMap$1((data) => this._applicationSalesSummaryService.create(this.state().applicationId, data.id)));
            }
            return of(id);
        }), tap((id) => {
            this.updateState({
                id,
            });
            this.loadData();
        }), catchError((err) => {
            console.error(err);
            return EMPTY;
        })))));
        this.loadBankAccounts = this.effect(pipe(switchMap$1(() => this._bankAccountsAdnStatementsService
            .getBankAccountParseStatus(this.state().applicationId)
            .pipe(tap((bankAccountStatements) => {
            this.updateState({
                bankAccountStatements,
            });
        }), catchError((err) => {
            console.error(err);
            return EMPTY;
        })))));
        this.loadData = this.effect(pipe(filter$1(() => !!this.state().id), switchMap$1(() => this._salesSummaryService.getById(this.state().id).pipe(tap((data) => {
            this.updateState({
                data,
            });
        }), catchError((err) => {
            console.error(err);
            return EMPTY;
        })))));
        this.saveData = this.effect(pipe(switchMap$1((data) => {
            return this._salesSummaryService.update(data.id, data).pipe(tap(() => {
                this._alertService.success('Success', 'Data saved successfully', {
                    duration: 3000,
                });
                this.loadData();
            }), catchError((err) => {
                console.error(err);
                return EMPTY;
            }));
        })));
        this.deleteAccount = this.effect(pipe(switchMap$1(({ id, cb }) => {
            return this._salesSummaryService.deleteAccount(this.state().id, id).pipe(tap(() => {
                this._alertService.success('Success', 'Account deleted successfully', {
                    duration: 3000,
                });
                this.loadData();
                cb();
            }), catchError((err) => {
                console.error(err);
                return EMPTY;
            }));
        })));
        this.saveAccount = this.effect(pipe(switchMap$1(({ payload, cb }) => {
            delete payload['auto'];
            if (payload.id) {
                return this._salesSummaryService.updateAccount(this.state().id, payload).pipe(tap(() => {
                    this._alertService.success('Success', 'Account saved successfully', {
                        duration: 3000,
                    });
                    this.loadData();
                    cb();
                }), catchError((err) => {
                    console.error(err);
                    return EMPTY;
                }));
            }
            const existed = this.state().data?.accounts?.find((item) => item.account_number === payload.account_number)?.id;
            if (existed) {
                payload.id = existed;
                return this._salesSummaryService.updateAccount(this.state().id, payload).pipe(tap(() => {
                    this._alertService.success('Success', 'Account saved successfully', {
                        duration: 3000,
                    });
                    this.loadData();
                    cb();
                }), catchError((err) => {
                    console.error(err);
                    return EMPTY;
                }));
            }
            return this._salesSummaryService.createAccount(this.state().id, payload).pipe(tap(() => {
                this._alertService.success('Success', 'Account saved successfully', {
                    duration: 3000,
                });
                this.loadData();
                cb();
            }), catchError((err) => {
                console.error(err);
                return EMPTY;
            }));
        })));
        this.savePor = this.effect(pipe(switchMap$1((data) => {
            return this._salesSummaryService.updatePor(this.state().id, data).pipe(tap(() => {
                this._alertService.success('Success', 'Por saved successfully', {
                    duration: 3000,
                });
                this.loadData();
            }), catchError((err) => {
                console.error(err);
                return EMPTY;
            }));
        })));
        this.saveWorkingCapital = this.effect(pipe(switchMap$1((data) => {
            return this._salesSummaryService.updateWorkingCapital(this.state().id, data).pipe(tap(() => {
                this._alertService.success('Success', 'Working Capital saved successfully', {
                    duration: 3000,
                });
                this.loadData();
            }), catchError((err) => {
                console.error(err);
                return EMPTY;
            }));
        })));
        this.updateState = (value) => this.patchState({
            ...value,
        });
    }
}

class FSWSalesSummaryStoreTH extends FSWSalesSummaryStore {
    constructor(_applicationSalesSummaryService, _salesSummaryService, _bankAccountsAdnStatementsService, _alertService) {
        super(_applicationSalesSummaryService, _salesSummaryService, _bankAccountsAdnStatementsService, _alertService);
        this._applicationSalesSummaryService = _applicationSalesSummaryService;
        this._salesSummaryService = _salesSummaryService;
        this._bankAccountsAdnStatementsService = _bankAccountsAdnStatementsService;
        this._alertService = _alertService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSalesSummaryStoreTH, deps: [{ token: APPLICATION_SALES_SUMMARY_SERVICE_TOKEN }, { token: CREDIT_SALES_SUMMARY_SERVICE_TOKEN }, { token: BANK_ACCOUNTS_AND_STATEMENTS_SERVICE_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSalesSummaryStoreTH }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSalesSummaryStoreTH, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_SALES_SUMMARY_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CREDIT_SALES_SUMMARY_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [BANK_ACCOUNTS_AND_STATEMENTS_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }]; } });

const FSW_SALES_SUMMARY_STORE_TOKEN = new InjectionToken('FSW_SALES_SUMMARY_STORE_TOKEN');

const FSW_SALES_SUMMARY_TH_PROVIDERS = [
    {
        provide: FSW_SALES_SUMMARY_STORE_TOKEN,
        useClass: FSWSalesSummaryStoreTH,
        deps: [
            APPLICATION_SALES_SUMMARY_SERVICE_TOKEN,
            CREDIT_SALES_SUMMARY_SERVICE_TOKEN,
            BANK_ACCOUNTS_AND_STATEMENTS_SERVICE_TOKEN,
            FSW_ALERT_SERVICE_TOKEN,
        ],
    },
];

const FSW_SALES_SUMMARY_PROVIDERS = {
    default: FSW_SALES_SUMMARY_TH_PROVIDERS,
    [CountryCode.TH]: FSW_SALES_SUMMARY_TH_PROVIDERS,
};
const salesSummaryLoadProviders = (countryCode) => [
    fswTranslateScope('sales_summary'),
    ...getCustomProviders(FSW_SALES_SUMMARY_PROVIDERS, FSW_SALES_SUMMARY_TH_PROVIDERS, countryCode),
];

class FSWSalesSummaryAccountsContainerComponent extends FSWDynamicBuilderContainerComponent {
    get title() {
        return this.element?.customProps?.title ?? '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSalesSummaryAccountsContainerComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWSalesSummaryAccountsContainerComponent, selector: "fsw-sales-summary-accounts-container", usesInheritance: true, ngImport: i0, template: "<fsw-panel [title]=\"title\">\n  <fsw-dynamic-builder-container\n    [element]=\"element\"\n    [dictionaries]=\"dictionaries\"\n    [config]=\"config\"\n    [index]=\"index\"\n  ></fsw-dynamic-builder-container>\n</fsw-panel>\n", dependencies: [{ kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "component", type: i1$4.FSWDynamicBuilderContainerComponent, selector: "fsw-dynamic-builder-container" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSalesSummaryAccountsContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-sales-summary-accounts-container', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-panel [title]=\"title\">\n  <fsw-dynamic-builder-container\n    [element]=\"element\"\n    [dictionaries]=\"dictionaries\"\n    [config]=\"config\"\n    [index]=\"index\"\n  ></fsw-dynamic-builder-container>\n</fsw-panel>\n" }]
        }] });

class FSWSalesSummaryAccountsModalComponent {
    constructor(dialogRef, _translateService, componentStore, _alertService, _dialog, _injector) {
        this.dialogRef = dialogRef;
        this._translateService = _translateService;
        this.componentStore = componentStore;
        this._alertService = _alertService;
        this._dialog = _dialog;
        this._injector = _injector;
        this.mode$ = new BehaviorSubject('view');
        this.readonly$ = this.componentStore.select((state) => state.isReadonly || !state.id);
        this.bankAccounts$ = this.componentStore.select((state) => state.bankAccountStatements);
        this.bankAccountControl = new UntypedFormControl(null);
        this.formGroup = new UntypedFormGroup({});
        this.builder = new FSWDynamicBuilder({
            formType: FSWDynamicBuilderFormTypes.GROUP,
            form: this.formGroup,
            renderBy: 'container',
            customClasses: 'flex flex-col gap-[16px]',
            readonlyWhen$: this.mode$.pipe(map((mode) => mode === 'view')),
            containers: [
                {
                    name: 'sales-summary-container',
                    customProps: {
                        title: this._translateService.select('tables.accounts.details', 'sales_summary'),
                    },
                    containers: [
                        {
                            customClasses: 'flex gap-[12px] flex-wrap',
                            fields: [
                                {
                                    key: 'auto',
                                    type: FSWDynamicBuilderControlTypes.TEMPLATE,
                                    customClasses: 'w-full',
                                    context: {
                                        templateKey: 'auto',
                                        defaultValue: undefined,
                                    },
                                },
                                {
                                    key: 'account_holder',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'w-full',
                                    context: {
                                        isRequired: true,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => value || 'N/A',
                                        label: this._translateService.select('tables.accounts.account_holder', 'sales_summary'),
                                        placeHolder: this._translateService.select('tables.accounts.account_holder', 'sales_summary'),
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'account_number',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        isRequired: true,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => value || 'N/A',
                                        label: this._translateService.select('tables.accounts.account_number', 'sales_summary'),
                                        placeHolder: this._translateService.select('tables.accounts.account_number', 'sales_summary'),
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'bank',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        isRequired: true,
                                        fullWidth: true,
                                        readonlyTemplate: (value) => value || 'N/A',
                                        label: this._translateService.select('tables.accounts.bank', 'sales_summary'),
                                        placeHolder: this._translateService.select('tables.accounts.bank', 'sales_summary'),
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                    ],
                },
                {
                    name: 'sales-summary-container',
                    customProps: {
                        title: this._translateService.select('tables.accounts.debit_turnover', 'sales_summary'),
                    },
                    fields: [
                        {
                            key: 'debit_turnover',
                            formType: FSWDynamicBuilderFormTypes.GROUP,
                            customClasses: 'flex gap-[12px]',
                            fields: [
                                {
                                    key: 'avg_monthly_balance',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        isRequired: true,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        defaultValue: 0,
                                        fullWidth: true,
                                        suffix: getCurrentCountryConfig().currencySymbol,
                                        readonlyTemplate: (value) => Intl.NumberFormat().format(value || 0),
                                        label: this._translateService.select('tables.accounts.average_monthly_balance', 'sales_summary'),
                                        placeHolder: this._translateService.select('tables.accounts.average_monthly_balance', 'sales_summary'),
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'frequency',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        isRequired: true,
                                        fullWidth: true,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        defaultValue: 0,
                                        readonlyTemplate: (value) => Intl.NumberFormat().format(value || 0),
                                        label: this._translateService.select('tables.accounts.frequency', 'sales_summary'),
                                        placeHolder: this._translateService.select('tables.accounts.frequency', 'sales_summary'),
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                    ],
                },
                {
                    name: 'sales-summary-container',
                    customProps: {
                        title: this._translateService.select('tables.accounts.average_balance', 'sales_summary'),
                    },
                    customClasses: 'w-full',
                    fields: [
                        {
                            key: 'average_balance',
                            type: FSWDynamicBuilderControlTypes.INPUT,
                            context: {
                                isRequired: true,
                                mask: {
                                    expression: 'separator.2',
                                    config: {
                                        thousandSeparator: ',',
                                    },
                                },
                                placeHolder: this._translateService.select('tables.accounts.average_balance', 'sales_summary'),
                                defaultValue: 0,
                                fullWidth: true,
                                suffix: getCurrentCountryConfig().currencySymbol,
                                readonlyTemplate: (value) => Intl.NumberFormat().format(value || 0),
                            },
                            validations: [Validators.required],
                        },
                    ],
                },
                {
                    name: 'sales-summary-container',
                    customProps: {
                        title: this._translateService.select('tables.accounts.credit_turnover', 'sales_summary'),
                    },
                    fields: [
                        {
                            key: 'credit_turnover',
                            formType: FSWDynamicBuilderFormTypes.GROUP,
                            customClasses: 'flex gap-[12px]',
                            fields: [
                                {
                                    key: 'avg_monthly_balance',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        isRequired: true,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        defaultValue: 0,
                                        fullWidth: true,
                                        suffix: getCurrentCountryConfig().currencySymbol,
                                        readonlyTemplate: (value) => Intl.NumberFormat().format(value || 0),
                                        label: this._translateService.select('tables.accounts.average_monthly_balance', 'sales_summary'),
                                        placeHolder: this._translateService.select('tables.accounts.average_monthly_balance', 'sales_summary'),
                                    },
                                    validations: [Validators.required],
                                },
                                {
                                    key: 'frequency',
                                    type: FSWDynamicBuilderControlTypes.INPUT,
                                    customClasses: 'flex-1',
                                    context: {
                                        isRequired: true,
                                        fullWidth: true,
                                        mask: {
                                            expression: 'separator.2',
                                            config: {
                                                thousandSeparator: ',',
                                            },
                                        },
                                        defaultValue: 0,
                                        readonlyTemplate: (value) => Intl.NumberFormat().format(value || 0),
                                        label: this._translateService.select('tables.accounts.frequency', 'sales_summary'),
                                        placeHolder: this._translateService.select('tables.accounts.frequency', 'sales_summary'),
                                    },
                                    validations: [Validators.required],
                                },
                            ],
                        },
                    ],
                },
            ],
        });
        this.dictionaries = [
            {
                name: 'sales-summary-container',
                dictionaryType: FSWDynamicBuilderFormTypes.CONTAINER,
                component: FSWSalesSummaryAccountsContainerComponent,
            },
        ];
        this.title$ = this.mode$.asObservable().pipe(map((mode) => `modals.accounts.${mode}`));
        if (dialogRef.config.data) {
            this.formGroup.patchValue(dialogRef.config.data);
        }
        else {
            this.mode$.next('add');
        }
        this.listenToBankAccountChange();
    }
    close(haveData = false) {
        this.dialogRef.close(haveData);
    }
    delete() {
        if (this.componentStore.state().isReadonly || !this.componentStore.state().id) {
            return;
        }
        this.componentStore.deleteAccount({
            id: this.dialogRef.config.data.id,
            cb: () => this.close(true),
        });
    }
    edit() {
        if (this.componentStore.state().isReadonly || !this.componentStore.state().id) {
            return;
        }
        this.mode$.next('edit');
    }
    submit() {
        if (this.componentStore.state().isReadonly || !this.componentStore.state().id) {
            return;
        }
        if (this.formGroup.invalid) {
            this._alertService.warning('Invalid Form', 'Please fill in all mandatory fields', {
                duration: 3000,
            });
            return;
        }
        this.componentStore.saveAccount({
            payload: {
                ...(this.dialogRef.config.data || {}),
                ...this.formGroup.value,
            },
            cb: () => this.close(true),
        });
    }
    toBankAccountText(item) {
        return `${item.account_name} (${item.account_number} - ${item.bank_name})`;
    }
    listenToBankAccountChange() {
        this.bankAccountControl.valueChanges.subscribe((value) => {
            if (!value) {
                return;
            }
            this.formGroup.patchValue({
                account_holder: value.account_name,
                account_number: value.account_number,
                bank: value.bank_name,
            });
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSalesSummaryAccountsModalComponent, deps: [{ token: i1$7.DialogRef }, { token: FSW_TRANSLATE_SERVICE_TOKEN }, { token: FSW_SALES_SUMMARY_STORE_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }, { token: i1$7.Dialog }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWSalesSummaryAccountsModalComponent, selector: "fsw-sales-summary-accounts-modal", ngImport: i0, template: "<fsw-modal\n  [size]=\"'m'\"\n  [title]=\"title$ | async | fswTranslate\"\n  [bodyCustomClasses]=\"'max-h-[calc(90vh-138px)] overflow-y-auto'\"\n  (closeEvent)=\"close(false)\"\n>\n  <ng-template fswModalBody>\n    <form [formGroup]=\"formGroup\">\n      <fsw-dynamic-builder [builder]=\"builder\" [dictionaries]=\"dictionaries\">\n        <ng-template fswDynamicBuilderTemplate key=\"auto\">\n          <ng-container *ngIf=\"bankAccounts$ | async as bankAccountStatements\">\n            <fsw-field [fullWidth]=\"true\" *ngIf=\"bankAccountStatements?.length\">\n              <ng-template\n                fswFieldHeaderPrefix\n                [label]=\"'tables.accounts.auto' | fswTranslate\"\n              ></ng-template>\n              <fsw-select\n                [closeOnSelected]=\"true\"\n                [fixedWidth]=\"true\"\n                [placeHolder]=\"'tables.accounts.auto' | fswTranslate\"\n                [formControl]=\"bankAccountControl\"\n              >\n                <ng-container *ngFor=\"let item of bankAccountStatements\">\n                  <ng-template\n                    fswSelectItem\n                    [value]=\"item\"\n                    [text]=\"toBankAccountText(item)\"\n                    [showCheckIcon]=\"true\"\n                  ></ng-template>\n                </ng-container>\n              </fsw-select>\n            </fsw-field>\n          </ng-container>\n        </ng-template>\n      </fsw-dynamic-builder>\n    </form>\n  </ng-template>\n  <ng-template fswModalFooter>\n    <section class=\"flex justify-between w-full items-center\">\n      <aside>\n        <button\n          *ngIf=\"(mode$ | async) !== 'add'\"\n          fswButton\n          class=\"!text-red-500\"\n          [appearance]=\"'secondary'\"\n          [disabled]=\"(readonly$ | async) ?? false\"\n          (click)=\"delete()\"\n        >\n          {{ 'buttons.delete' | fswTranslate }}\n        </button>\n      </aside>\n      <main class=\"flex gap-[16px] items-center\">\n        <button fswButton [appearance]=\"'secondary'\" (click)=\"close()\">\n          {{ 'buttons.cancel' | fswTranslate }}\n        </button>\n        <button\n          (click)=\"edit()\"\n          fswButton\n          [disabled]=\"(readonly$ | async) ?? false\"\n          *ngIf=\"(mode$ | async) === 'view'; else saveChangesTemplate\"\n        >\n          {{ 'buttons.edit_details' | fswTranslate }}\n        </button>\n        <ng-template #saveChangesTemplate>\n          <button\n            fswButton\n            (click)=\"submit()\"\n            [disabled]=\"(readonly$ | async) ?? formGroup.invalid\"\n          >\n            {{ 'buttons.save_changes' | fswTranslate }}\n          </button>\n        </ng-template>\n      </main>\n    </section>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$4.FSWFieldHeaderPrefixDirective, selector: "ng-template[fswFieldHeaderPrefix]", inputs: ["kind", "label", "required"] }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "directive", type: i1$4.FSWModalFooterDirective, selector: "ng-template[fswModalFooter]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FSWDynamicBuilderTemplateDirective, selector: "[fswDynamicBuilderTemplate]", inputs: ["key"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSalesSummaryAccountsModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-sales-summary-accounts-modal', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal\n  [size]=\"'m'\"\n  [title]=\"title$ | async | fswTranslate\"\n  [bodyCustomClasses]=\"'max-h-[calc(90vh-138px)] overflow-y-auto'\"\n  (closeEvent)=\"close(false)\"\n>\n  <ng-template fswModalBody>\n    <form [formGroup]=\"formGroup\">\n      <fsw-dynamic-builder [builder]=\"builder\" [dictionaries]=\"dictionaries\">\n        <ng-template fswDynamicBuilderTemplate key=\"auto\">\n          <ng-container *ngIf=\"bankAccounts$ | async as bankAccountStatements\">\n            <fsw-field [fullWidth]=\"true\" *ngIf=\"bankAccountStatements?.length\">\n              <ng-template\n                fswFieldHeaderPrefix\n                [label]=\"'tables.accounts.auto' | fswTranslate\"\n              ></ng-template>\n              <fsw-select\n                [closeOnSelected]=\"true\"\n                [fixedWidth]=\"true\"\n                [placeHolder]=\"'tables.accounts.auto' | fswTranslate\"\n                [formControl]=\"bankAccountControl\"\n              >\n                <ng-container *ngFor=\"let item of bankAccountStatements\">\n                  <ng-template\n                    fswSelectItem\n                    [value]=\"item\"\n                    [text]=\"toBankAccountText(item)\"\n                    [showCheckIcon]=\"true\"\n                  ></ng-template>\n                </ng-container>\n              </fsw-select>\n            </fsw-field>\n          </ng-container>\n        </ng-template>\n      </fsw-dynamic-builder>\n    </form>\n  </ng-template>\n  <ng-template fswModalFooter>\n    <section class=\"flex justify-between w-full items-center\">\n      <aside>\n        <button\n          *ngIf=\"(mode$ | async) !== 'add'\"\n          fswButton\n          class=\"!text-red-500\"\n          [appearance]=\"'secondary'\"\n          [disabled]=\"(readonly$ | async) ?? false\"\n          (click)=\"delete()\"\n        >\n          {{ 'buttons.delete' | fswTranslate }}\n        </button>\n      </aside>\n      <main class=\"flex gap-[16px] items-center\">\n        <button fswButton [appearance]=\"'secondary'\" (click)=\"close()\">\n          {{ 'buttons.cancel' | fswTranslate }}\n        </button>\n        <button\n          (click)=\"edit()\"\n          fswButton\n          [disabled]=\"(readonly$ | async) ?? false\"\n          *ngIf=\"(mode$ | async) === 'view'; else saveChangesTemplate\"\n        >\n          {{ 'buttons.edit_details' | fswTranslate }}\n        </button>\n        <ng-template #saveChangesTemplate>\n          <button\n            fswButton\n            (click)=\"submit()\"\n            [disabled]=\"(readonly$ | async) ?? formGroup.invalid\"\n          >\n            {{ 'buttons.save_changes' | fswTranslate }}\n          </button>\n        </ng-template>\n      </main>\n    </section>\n  </ng-template>\n</fsw-modal>\n" }]
        }], ctorParameters: function () { return [{ type: i1$7.DialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_TRANSLATE_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_SALES_SUMMARY_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: i1$7.Dialog }, { type: i0.Injector }]; } });

class FSWSalesSummaryConfirmModalComponent {
    constructor(dialogRef) {
        this.dialogRef = dialogRef;
    }
    close(haveData = false) {
        this.dialogRef.close(haveData);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSalesSummaryConfirmModalComponent, deps: [{ token: i1$7.DialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWSalesSummaryConfirmModalComponent, selector: "fsw-sales-summary-confirm-modal", ngImport: i0, template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"'buttons.yes' | fswTranslate\"\n  [cancelButton]=\"'buttons.no' | fswTranslate\"\n  (confirmEvent)=\"close(true)\"\n  (cancelEvent)=\"close(false)\"\n  (closeEvent)=\"close(false)\"\n>\n  <ng-template fswModalBody>\n    <p>\n      {{\n        dialogRef.config.data['description']\n          | fswTranslate : { data: dialogRef.config.data['descriptionParams'] }\n      }}\n    </p>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSalesSummaryConfirmModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-sales-summary-confirm-modal', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"'buttons.yes' | fswTranslate\"\n  [cancelButton]=\"'buttons.no' | fswTranslate\"\n  (confirmEvent)=\"close(true)\"\n  (cancelEvent)=\"close(false)\"\n  (closeEvent)=\"close(false)\"\n>\n  <ng-template fswModalBody>\n    <p>\n      {{\n        dialogRef.config.data['description']\n          | fswTranslate : { data: dialogRef.config.data['descriptionParams'] }\n      }}\n    </p>\n  </ng-template>\n</fsw-modal>\n" }]
        }], ctorParameters: function () { return [{ type: i1$7.DialogRef }]; } });

class FSWSalesSummaryAccountCalculationPipe {
    constructor(componentStore, _currencyFormatPipe) {
        this.componentStore = componentStore;
        this._currencyFormatPipe = _currencyFormatPipe;
        this._latestValue = '';
    }
    transform(key) {
        combineLatest([
            this.componentStore.select((state) => state.data?.accounts || []),
            this.componentStore.yearPors,
        ])
            .pipe(tap(([accounts, pors]) => {
            switch (key) {
                case 'average_balance':
                    this._latestValue =
                        this._currencyFormatPipe.transform(this.transformValue(Number(accounts.reduce((acc, account) => acc + account.average_balance, 0).toFixed(2)))) || '';
                    break;
                case 'credit':
                    this._latestValue =
                        this._currencyFormatPipe.transform(this.transformValue(Number(accounts
                            .reduce((acc, account) => acc + account.credit_turnover.avg_monthly_balance, 0)
                            .toFixed(2)))) || '';
                    break;
                case 'debit':
                    this._latestValue =
                        this._currencyFormatPipe.transform(this.transformValue(Number(accounts
                            .reduce((acc, account) => acc + account.debit_turnover.avg_monthly_balance, 0)
                            .toFixed(2)))) || '';
                    break;
                case 'monthly':
                    this._latestValue =
                        this._currencyFormatPipe.transform(this.transformValue(Number((pors.reduce((acc, por) => acc + por.amount, 0) / 12).toFixed(2)))) || '';
                    break;
                case 'throughput':
                    this._latestValue =
                        this._currencyFormatPipe.transform(this.transformValue(Number((accounts.reduce((acc, account) => acc + account.credit_turnover.avg_monthly_balance, 0) /
                            (pors.reduce((acc, por) => acc + por.amount, 0) / 12)).toFixed(2)))) || '';
                    break;
                default:
                    this._latestValue = '';
                    break;
            }
        }))
            .subscribe();
        return this._latestValue;
    }
    transformValue(value) {
        return isNaN(value) || value.toString().includes('Infinity') ? 0 : Number(value.toFixed(2));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSalesSummaryAccountCalculationPipe, deps: [{ token: FSW_SALES_SUMMARY_STORE_TOKEN }, { token: CurrencyFormatPipe }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWSalesSummaryAccountCalculationPipe, name: "fswSalesSummaryAccountCalculation", pure: false }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSalesSummaryAccountCalculationPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fswSalesSummaryAccountCalculation',
                    pure: false,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_SALES_SUMMARY_STORE_TOKEN]
                }] }, { type: CurrencyFormatPipe }]; } });

let FSWSalesSummaryAccountsTableComponent = class FSWSalesSummaryAccountsTableComponent {
    constructor(componentStore, _dialog, _injector) {
        this.componentStore = componentStore;
        this._dialog = _dialog;
        this._injector = _injector;
        this.accounts$ = this.componentStore.select((state) => state.data?.accounts || []);
        this.readonly$ = this.componentStore
            .select((state) => state)
            .pipe(map((state) => state.isReadonly || !state.id));
        this.formGroup = new FormGroup({
            id: new UntypedFormControl(null),
            bounced_cheque: new UntypedFormControl(''),
            reason: new UntypedFormControl(''),
            credit_throughput: new UntypedFormControl(0),
            monthly_sales_financial_statement: new UntypedFormControl(0),
        });
    }
    ngOnInit() {
        this.componentStore
            .select((state) => state.data)
            .pipe(followDestroy(this), tap((data) => {
            this.formGroup.patchValue(data ?? {
                id: null,
                bounced_cheque: '',
                reason: '',
                credit_throughput: 0,
                monthly_sales_financial_statement: 0,
            });
        }))
            .subscribe();
        this.readonly$
            .pipe(followDestroy(this), tap((isReadonly) => {
            if (isReadonly) {
                this.formGroup.disable();
            }
            else {
                this.formGroup.enable();
            }
        }))
            .subscribe();
    }
    selectAccount(account) {
        if (!account && (!this.componentStore.state().id || this.componentStore.state().isReadonly)) {
            return;
        }
        this._dialog
            .open(FSWSalesSummaryAccountsModalComponent, {
            data: account,
            injector: this._injector,
        })
            .closed.pipe(take(1))
            .subscribe();
    }
    save() {
        if (this.componentStore.state().isReadonly || !this.componentStore.state().id) {
            return;
        }
        this.componentStore.saveData(this.formGroup.getRawValue());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSalesSummaryAccountsTableComponent, deps: [{ token: FSW_SALES_SUMMARY_STORE_TOKEN }, { token: i1$7.Dialog }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWSalesSummaryAccountsTableComponent, selector: "fsw-sales-summary-accounts-table", providers: [CurrencyFormatPipe], ngImport: i0, template: "<fsw-panel [title]=\"'tables.accounts.title' | fswTranslate\">\n  <ng-template fswPanelHeaderSuffix>\n    <section class=\"flex items-center gap-[12px]\">\n      <button [disabled]=\"(readonly$ | async) ?? false\" fswButton (click)=\"selectAccount()\">\n        {{ 'buttons.add' | fswTranslate }}\n      </button>\n    </section>\n  </ng-template>\n  <table class=\"fsw-table fsw-table--bordered table-fixed w-full\">\n    <caption class=\"hidden\">\n      Sales Summary Accounts Table\n    </caption>\n    <thead class=\"bg-[aliceblue]\">\n      <tr>\n        <th\n          scope=\"colgroup\"\n          colspan=\"3\"\n          class=\"text-center whitespace-normal align-middle !font-bold\"\n        >\n          {{ 'tables.accounts.details' | fswTranslate }}\n        </th>\n        <th\n          scope=\"rowgroup\"\n          rowspan=\"2\"\n          class=\"text-center whitespace-normal align-middle align-middle !font-bold\"\n        >\n          {{ 'tables.accounts.average_balance' | fswTranslate }}\n        </th>\n        <th\n          scope=\"colgroup\"\n          colspan=\"2\"\n          class=\"text-center whitespace-normal align-middle !font-bold\"\n        >\n          {{ 'tables.accounts.debit_turnover' | fswTranslate }}\n        </th>\n        <th\n          scope=\"colgroup\"\n          colspan=\"2\"\n          class=\"text-center whitespace-normal align-middle !font-bold\"\n        >\n          {{ 'tables.accounts.credit_turnover' | fswTranslate }}\n        </th>\n      </tr>\n      <tr>\n        <th scope=\"col\" class=\"text-center whitespace-normal align-middle\">\n          {{ 'tables.accounts.account_holder' | fswTranslate }}\n        </th>\n        <th scope=\"col\" class=\"text-center whitespace-normal align-middle\">\n          {{ 'tables.accounts.account_number' | fswTranslate }}\n        </th>\n        <th scope=\"col\" class=\"text-center whitespace-normal align-middle\">\n          {{ 'tables.accounts.bank' | fswTranslate }}\n        </th>\n        <th scope=\"col\" class=\"text-center whitespace-normal align-middle\">\n          {{ 'tables.accounts.average_monthly_balance' | fswTranslate }}\n        </th>\n        <th scope=\"col\" class=\"text-center whitespace-normal align-middle\">\n          {{ 'tables.accounts.frequency' | fswTranslate }}\n        </th>\n        <th scope=\"col\" class=\"text-center whitespace-normal align-middle\">\n          {{ 'tables.accounts.average_monthly_balance' | fswTranslate }}\n        </th>\n        <th scope=\"col\" class=\"text-center whitespace-normal align-middle\">\n          {{ 'tables.accounts.frequency' | fswTranslate }}\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr *ngFor=\"let account of accounts$ | async\">\n        <td\n          class=\"text-center whitespace-normal align-middle hover:bg-green-200 hover:cursor-pointer\"\n          (click)=\"selectAccount(account)\"\n        >\n          {{ account.account_holder }}\n        </td>\n        <td class=\"text-center whitespace-normal align-middle\">{{ account.account_number }}</td>\n        <td class=\"text-center whitespace-normal align-middle\">{{ account.bank }}</td>\n        <td class=\"text-center whitespace-normal align-middle\">\n          {{ account.average_balance | currencyMaskPipe }}\n        </td>\n        <td class=\"text-center whitespace-normal align-middle\">\n          {{ account.debit_turnover.avg_monthly_balance | currencyMaskPipe }}\n        </td>\n        <td class=\"text-center whitespace-normal align-middle\">\n          {{ account.debit_turnover.frequency }}\n        </td>\n        <td class=\"text-center whitespace-normal align-middle\">\n          {{ account.credit_turnover.avg_monthly_balance | currencyMaskPipe }}\n        </td>\n        <td class=\"text-center whitespace-normal align-middle\">\n          {{ account.credit_turnover.frequency }}\n        </td>\n      </tr>\n    </tbody>\n    <tfoot>\n      <tr>\n        <td colspan=\"3\" class=\"bg-[aliceblue] !font-bold whitespace-normal align-middle\">\n          {{ 'tables.accounts.total' | fswTranslate }}\n        </td>\n        <td class=\"text-center whitespace-normal align-middle\">\n          {{ 'average_balance' | fswSalesSummaryAccountCalculation }}\n        </td>\n        <td colspan=\"4\"></td>\n      </tr>\n      <tr>\n        <td colspan=\"3\" class=\"bg-[aliceblue] !font-bold whitespace-normal align-middle\">\n          {{ 'tables.accounts.monthly_sales_based_on_financial_statement' | fswTranslate }}\n        </td>\n        <td class=\"text-center whitespace-normal align-middle\">\n          {{ 'monthly' | fswSalesSummaryAccountCalculation }}\n        </td>\n        <td colspan=\"4\"></td>\n      </tr>\n      <tr>\n        <td colspan=\"3\" class=\"bg-[aliceblue] !font-bold whitespace-normal align-middle\">\n          {{ 'tables.accounts.credit_throughput' | fswTranslate }}\n        </td>\n        <td class=\"text-center whitespace-normal align-middle\">\n          {{ 'throughput' | fswSalesSummaryAccountCalculation }}\n        </td>\n        <td class=\"text-center whitespace-normal align-middle\" colspan=\"2\">\n          {{ 'debit' | fswSalesSummaryAccountCalculation }}\n        </td>\n        <td class=\"text-center whitespace-normal align-middle\" colspan=\"2\">\n          {{ 'credit' | fswSalesSummaryAccountCalculation }}\n        </td>\n      </tr>\n      <tr>\n        <td class=\"whitespace-normal align-middle\">\n          {{ 'tables.accounts.bounced_cheque' | fswTranslate }}\n        </td>\n        <td colspan=\"3\">\n          <fsw-field [fullWidth]=\"true\">\n            <fsw-select\n              [placeHolder]=\"'tables.accounts.bounced_cheque' | fswTranslate\"\n              [formControl]=\"formGroup.controls.bounced_cheque\"\n            >\n              <ng-template\n                fswSelectItem\n                textSize=\"s\"\n                [value]=\"'YES'\"\n                [text]=\"'Yes'\"\n                [showCheckIcon]=\"true\"\n                let-selected\n              ></ng-template>\n              <ng-template\n                fswSelectItem\n                textSize=\"s\"\n                [value]=\"'NO'\"\n                [text]=\"'No'\"\n                [showCheckIcon]=\"true\"\n                let-selected\n              ></ng-template>\n            </fsw-select>\n          </fsw-field>\n        </td>\n        <td colspan=\"4\"></td>\n      </tr>\n      <tr>\n        <td class=\"whitespace-normal align-middle\">\n          {{ 'tables.accounts.reasons' | fswTranslate }}\n        </td>\n        <td colspan=\"3\">\n          <section class=\"flex flex-col gap-2 w-full\">\n            <fsw-field [fullWidth]=\"true\">\n              <textarea\n                [formControl]=\"formGroup.controls.reason\"\n                fswInput\n                [rows]=\"5\"\n                [placeholder]=\"'tables.accounts.reasons' | fswTranslate\"\n              ></textarea>\n            </fsw-field>\n            <button\n              fswButton\n              [disabled]=\"(readonly$ | async) ?? false\"\n              (click)=\"save()\"\n              class=\"w-full\"\n            >\n              {{ 'buttons.save_changes' | fswTranslate }}\n            </button>\n          </section>\n        </td>\n        <td colspan=\"4\"></td>\n      </tr>\n    </tfoot>\n  </table>\n</fsw-panel>\n", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "directive", type: i1$4.FSWInputDirective, selector: "input[fswInput], textarea[fswInput]" }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "pipe", type: CurrencyFormatPipe, name: "currencyMaskPipe" }, { kind: "pipe", type: FSWSalesSummaryAccountCalculationPipe, name: "fswSalesSummaryAccountCalculation" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
};
FSWSalesSummaryAccountsTableComponent = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [Object, Dialog,
        Injector])
], FSWSalesSummaryAccountsTableComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSalesSummaryAccountsTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-sales-summary-accounts-table', changeDetection: ChangeDetectionStrategy.OnPush, providers: [CurrencyFormatPipe], template: "<fsw-panel [title]=\"'tables.accounts.title' | fswTranslate\">\n  <ng-template fswPanelHeaderSuffix>\n    <section class=\"flex items-center gap-[12px]\">\n      <button [disabled]=\"(readonly$ | async) ?? false\" fswButton (click)=\"selectAccount()\">\n        {{ 'buttons.add' | fswTranslate }}\n      </button>\n    </section>\n  </ng-template>\n  <table class=\"fsw-table fsw-table--bordered table-fixed w-full\">\n    <caption class=\"hidden\">\n      Sales Summary Accounts Table\n    </caption>\n    <thead class=\"bg-[aliceblue]\">\n      <tr>\n        <th\n          scope=\"colgroup\"\n          colspan=\"3\"\n          class=\"text-center whitespace-normal align-middle !font-bold\"\n        >\n          {{ 'tables.accounts.details' | fswTranslate }}\n        </th>\n        <th\n          scope=\"rowgroup\"\n          rowspan=\"2\"\n          class=\"text-center whitespace-normal align-middle align-middle !font-bold\"\n        >\n          {{ 'tables.accounts.average_balance' | fswTranslate }}\n        </th>\n        <th\n          scope=\"colgroup\"\n          colspan=\"2\"\n          class=\"text-center whitespace-normal align-middle !font-bold\"\n        >\n          {{ 'tables.accounts.debit_turnover' | fswTranslate }}\n        </th>\n        <th\n          scope=\"colgroup\"\n          colspan=\"2\"\n          class=\"text-center whitespace-normal align-middle !font-bold\"\n        >\n          {{ 'tables.accounts.credit_turnover' | fswTranslate }}\n        </th>\n      </tr>\n      <tr>\n        <th scope=\"col\" class=\"text-center whitespace-normal align-middle\">\n          {{ 'tables.accounts.account_holder' | fswTranslate }}\n        </th>\n        <th scope=\"col\" class=\"text-center whitespace-normal align-middle\">\n          {{ 'tables.accounts.account_number' | fswTranslate }}\n        </th>\n        <th scope=\"col\" class=\"text-center whitespace-normal align-middle\">\n          {{ 'tables.accounts.bank' | fswTranslate }}\n        </th>\n        <th scope=\"col\" class=\"text-center whitespace-normal align-middle\">\n          {{ 'tables.accounts.average_monthly_balance' | fswTranslate }}\n        </th>\n        <th scope=\"col\" class=\"text-center whitespace-normal align-middle\">\n          {{ 'tables.accounts.frequency' | fswTranslate }}\n        </th>\n        <th scope=\"col\" class=\"text-center whitespace-normal align-middle\">\n          {{ 'tables.accounts.average_monthly_balance' | fswTranslate }}\n        </th>\n        <th scope=\"col\" class=\"text-center whitespace-normal align-middle\">\n          {{ 'tables.accounts.frequency' | fswTranslate }}\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr *ngFor=\"let account of accounts$ | async\">\n        <td\n          class=\"text-center whitespace-normal align-middle hover:bg-green-200 hover:cursor-pointer\"\n          (click)=\"selectAccount(account)\"\n        >\n          {{ account.account_holder }}\n        </td>\n        <td class=\"text-center whitespace-normal align-middle\">{{ account.account_number }}</td>\n        <td class=\"text-center whitespace-normal align-middle\">{{ account.bank }}</td>\n        <td class=\"text-center whitespace-normal align-middle\">\n          {{ account.average_balance | currencyMaskPipe }}\n        </td>\n        <td class=\"text-center whitespace-normal align-middle\">\n          {{ account.debit_turnover.avg_monthly_balance | currencyMaskPipe }}\n        </td>\n        <td class=\"text-center whitespace-normal align-middle\">\n          {{ account.debit_turnover.frequency }}\n        </td>\n        <td class=\"text-center whitespace-normal align-middle\">\n          {{ account.credit_turnover.avg_monthly_balance | currencyMaskPipe }}\n        </td>\n        <td class=\"text-center whitespace-normal align-middle\">\n          {{ account.credit_turnover.frequency }}\n        </td>\n      </tr>\n    </tbody>\n    <tfoot>\n      <tr>\n        <td colspan=\"3\" class=\"bg-[aliceblue] !font-bold whitespace-normal align-middle\">\n          {{ 'tables.accounts.total' | fswTranslate }}\n        </td>\n        <td class=\"text-center whitespace-normal align-middle\">\n          {{ 'average_balance' | fswSalesSummaryAccountCalculation }}\n        </td>\n        <td colspan=\"4\"></td>\n      </tr>\n      <tr>\n        <td colspan=\"3\" class=\"bg-[aliceblue] !font-bold whitespace-normal align-middle\">\n          {{ 'tables.accounts.monthly_sales_based_on_financial_statement' | fswTranslate }}\n        </td>\n        <td class=\"text-center whitespace-normal align-middle\">\n          {{ 'monthly' | fswSalesSummaryAccountCalculation }}\n        </td>\n        <td colspan=\"4\"></td>\n      </tr>\n      <tr>\n        <td colspan=\"3\" class=\"bg-[aliceblue] !font-bold whitespace-normal align-middle\">\n          {{ 'tables.accounts.credit_throughput' | fswTranslate }}\n        </td>\n        <td class=\"text-center whitespace-normal align-middle\">\n          {{ 'throughput' | fswSalesSummaryAccountCalculation }}\n        </td>\n        <td class=\"text-center whitespace-normal align-middle\" colspan=\"2\">\n          {{ 'debit' | fswSalesSummaryAccountCalculation }}\n        </td>\n        <td class=\"text-center whitespace-normal align-middle\" colspan=\"2\">\n          {{ 'credit' | fswSalesSummaryAccountCalculation }}\n        </td>\n      </tr>\n      <tr>\n        <td class=\"whitespace-normal align-middle\">\n          {{ 'tables.accounts.bounced_cheque' | fswTranslate }}\n        </td>\n        <td colspan=\"3\">\n          <fsw-field [fullWidth]=\"true\">\n            <fsw-select\n              [placeHolder]=\"'tables.accounts.bounced_cheque' | fswTranslate\"\n              [formControl]=\"formGroup.controls.bounced_cheque\"\n            >\n              <ng-template\n                fswSelectItem\n                textSize=\"s\"\n                [value]=\"'YES'\"\n                [text]=\"'Yes'\"\n                [showCheckIcon]=\"true\"\n                let-selected\n              ></ng-template>\n              <ng-template\n                fswSelectItem\n                textSize=\"s\"\n                [value]=\"'NO'\"\n                [text]=\"'No'\"\n                [showCheckIcon]=\"true\"\n                let-selected\n              ></ng-template>\n            </fsw-select>\n          </fsw-field>\n        </td>\n        <td colspan=\"4\"></td>\n      </tr>\n      <tr>\n        <td class=\"whitespace-normal align-middle\">\n          {{ 'tables.accounts.reasons' | fswTranslate }}\n        </td>\n        <td colspan=\"3\">\n          <section class=\"flex flex-col gap-2 w-full\">\n            <fsw-field [fullWidth]=\"true\">\n              <textarea\n                [formControl]=\"formGroup.controls.reason\"\n                fswInput\n                [rows]=\"5\"\n                [placeholder]=\"'tables.accounts.reasons' | fswTranslate\"\n              ></textarea>\n            </fsw-field>\n            <button\n              fswButton\n              [disabled]=\"(readonly$ | async) ?? false\"\n              (click)=\"save()\"\n              class=\"w-full\"\n            >\n              {{ 'buttons.save_changes' | fswTranslate }}\n            </button>\n          </section>\n        </td>\n        <td colspan=\"4\"></td>\n      </tr>\n    </tfoot>\n  </table>\n</fsw-panel>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_SALES_SUMMARY_STORE_TOKEN]
                }] }, { type: i1$7.Dialog }, { type: i0.Injector }]; } });

let FSWSalesSummaryWorkingCapitalTableComponent = class FSWSalesSummaryWorkingCapitalTableComponent {
    constructor(componentStore, _translateService, _dialog, _injector) {
        this.componentStore = componentStore;
        this._translateService = _translateService;
        this._dialog = _dialog;
        this._injector = _injector;
        this.yearControl = this.componentStore.yearControl;
        this.formGroup = this.componentStore.capitalGroup;
        this.ratioApdoh$ = combineLatest([
            getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.apdoh').valueChanges.pipe(startWith(getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.apdoh.value'))),
            getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.cogs').valueChanges.pipe(startWith(getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.cogs').value)),
        ]).pipe(map(([targetApdoh, targetCorgs]) => {
            try {
                return (Number(targetApdoh || '0') / Number(targetCorgs || '0')) * 365;
            }
            catch {
                return 0;
            }
        }));
        this.ratioInvdoh$ = combineLatest([
            getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.invdoh').valueChanges.pipe(startWith(getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.invdoh').value)),
            getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.cogs').valueChanges.pipe(startWith(getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.cogs').value)),
        ]).pipe(map(([targetIndoh, targetCorgs]) => {
            try {
                return (Number(targetIndoh || '0') / Number(targetCorgs || '0')) * 365;
            }
            catch {
                return 0;
            }
        }));
        this.ratioArdoh$ = combineLatest([
            getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.ardoh').valueChanges.pipe(startWith(getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.ardoh').value)),
            getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.sales').valueChanges.pipe(startWith(getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.sales').value)),
        ]).pipe(map(([targetArdoh, targetSales]) => {
            try {
                return (Number(targetArdoh || '0') / Number(targetSales || '0')) * 365;
            }
            catch {
                return 0;
            }
        }));
        this.vat30Sales$ = this.componentStore.yearPors.pipe(map((pors) => pors.reduce((acc, { amount }) => acc + amount, 0)));
        this.vat30Cogs$ = combineLatest([
            this.vat30Sales$,
            getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.sales').valueChanges.pipe(startWith(getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.sales').value)),
            getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.cogs').valueChanges.pipe(startWith(getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.cogs').value)),
        ]).pipe(map(([vat30Sales, targetSales, targetCogs]) => {
            try {
                return (Number(targetCogs || '0') / Number(vat30Sales || '0')) * Number(targetSales || '0');
            }
            catch {
                return 0;
            }
        }));
        this.vat30Apdoh$ = combineLatest([this.ratioApdoh$, this.vat30Cogs$]).pipe(map(([ratioApdoh, vat30Corgs]) => {
            try {
                return (Number(ratioApdoh) / 365) * Number(vat30Corgs || '0');
            }
            catch {
                return 0;
            }
        }));
        this.vat30Invdoh$ = combineLatest([this.ratioInvdoh$, this.vat30Cogs$]).pipe(map(([ratioInvdoh, vat30Corgs]) => {
            try {
                return (Number(ratioInvdoh) / 365) * Number(vat30Corgs || '0');
            }
            catch {
                return 0;
            }
        }));
        this.vat30Ardoh$ = combineLatest([this.ratioArdoh$, this.vat30Sales$]).pipe(map(([ratioArdoh, vat30Sales]) => {
            try {
                return (Number(ratioArdoh) / 365) * Number(vat30Sales || '0');
            }
            catch {
                return 0;
            }
        }));
        this.vat30Wcr$ = combineLatest([
            this.vat30Ardoh$,
            this.vat30Invdoh$,
            this.vat30Apdoh$,
        ]).pipe(map(([vat30Ardoh, vat30Indoh, vat30Apdoh]) => {
            try {
                return Number(vat30Ardoh || '0') + Number(vat30Indoh || '0') - Number(vat30Apdoh || '0');
            }
            catch {
                return 0;
            }
        }));
        this.targetWcr$ = combineLatest([
            getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.ardoh').valueChanges.pipe(startWith(getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.ardoh').value)),
            getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.invdoh').valueChanges.pipe(startWith(getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.invdoh').value)),
            getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.apdoh').valueChanges.pipe(startWith(getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.apdoh').value)),
        ]).pipe(map(([targetArdoh, targetIndoh, targetApdoh]) => {
            try {
                return Number(targetArdoh || '0') + Number(targetIndoh || '0') - Number(targetApdoh || '0');
            }
            catch {
                return 0;
            }
        }));
        this.surplus$ = combineLatest([
            getControlFromGroupByGroupPath(this.formGroup, 'working_capital_requirements.stlimit').valueChanges.pipe(startWith(getControlFromGroupByGroupPath(this.formGroup, 'working_capital_requirements.stlimit').value)),
            this.vat30Wcr$,
        ]).pipe(map(([stlimit, vat30Wrc]) => {
            try {
                return Number(stlimit || '0') - Number(vat30Wrc || '0');
            }
            catch {
                return 0;
            }
        }));
        this.idb$ = combineLatest([
            getControlFromGroupByGroupPath(this.formGroup, 'working_capital_requirements.stlimit').valueChanges.pipe(startWith(getControlFromGroupByGroupPath(this.formGroup, 'working_capital_requirements.stlimit').value)),
            this.vat30Sales$,
            getControlFromGroupByGroupPath(this.formGroup, 'working_capital_requirements.lto').valueChanges.pipe(startWith(getControlFromGroupByGroupPath(this.formGroup, 'working_capital_requirements.lto').value)),
        ]).pipe(map(([stlimit, vat30Sales, lto]) => {
            try {
                return ((Number(stlimit || '0') + Number(lto || '0')) / Number(vat30Sales || '0')) * 100;
            }
            catch {
                return 0;
            }
        }));
        this.cashCycle$ = combineLatest([
            this.ratioArdoh$,
            this.ratioApdoh$,
            this.ratioInvdoh$,
        ]).pipe(map(([ratioArdoh, ratioApdoh, ratioInvdoh]) => {
            try {
                return Number(ratioArdoh || '0') + Number(ratioInvdoh || '0') - Number(ratioApdoh || '0');
            }
            catch {
                return 0;
            }
        }));
        this.tableBodyStructureRows = [
            [
                {
                    type: 'label',
                    value: this._translateService.select('tables.working_capital.sales', 'sales_summary'),
                    colSpan: 1,
                },
                {
                    type: 'label',
                    value: '',
                    colSpan: 1,
                },
                {
                    type: 'control',
                    value: getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.sales'),
                    colSpan: 1,
                },
                {
                    type: 'listener',
                    value: this.vat30Sales$.pipe(tap((amount) => getControlFromGroupByGroupPath(this.formGroup, 'vat_30.sales').setValue(amount)), map((value) => this.transformValue(value))),
                    colSpan: 1,
                },
            ],
            [
                {
                    type: 'label',
                    value: this._translateService.select('tables.working_capital.cogs', 'sales_summary'),
                    colSpan: 1,
                },
                {
                    type: 'label',
                    value: '',
                    colSpan: 1,
                },
                {
                    type: 'control',
                    value: getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.cogs'),
                    colSpan: 1,
                },
                {
                    type: 'listener',
                    value: this.vat30Cogs$.pipe(tap((amount) => getControlFromGroupByGroupPath(this.formGroup, 'vat_30.cogs').setValue(amount)), map((value) => this.transformValue(value))),
                    colSpan: 1,
                },
            ],
            [
                {
                    type: 'label',
                    value: '',
                    colSpan: 1,
                },
                {
                    type: 'label',
                    value: this._translateService.select('tables.working_capital.ratio', 'sales_summary'),
                    colSpan: 1,
                },
                {
                    type: 'label',
                    value: '',
                    colSpan: 1,
                },
                {
                    type: 'label',
                    value: '',
                    colSpan: 1,
                },
            ],
            [
                {
                    type: 'label',
                    value: this._translateService.select('tables.working_capital.ardoh', 'sales_summary'),
                    colSpan: 1,
                },
                {
                    type: 'listener',
                    value: this.ratioArdoh$.pipe(map((value) => this.transformValue(value))),
                    colSpan: 1,
                },
                {
                    type: 'control',
                    value: getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.ardoh'),
                    colSpan: 1,
                },
                {
                    type: 'listener',
                    value: this.vat30Ardoh$.pipe(tap((amount) => getControlFromGroupByGroupPath(this.formGroup, 'vat_30.ardoh').setValue(amount)), map((value) => this.transformValue(value))),
                    colSpan: 1,
                },
            ],
            [
                {
                    type: 'label',
                    value: this._translateService.select('tables.working_capital.invdoh', 'sales_summary'),
                    colSpan: 1,
                },
                {
                    type: 'listener',
                    value: this.ratioInvdoh$.pipe(map((value) => this.transformValue(value))),
                    colSpan: 1,
                },
                {
                    type: 'control',
                    value: getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.invdoh'),
                    colSpan: 1,
                },
                {
                    type: 'listener',
                    value: this.vat30Invdoh$.pipe(tap((amount) => getControlFromGroupByGroupPath(this.formGroup, 'vat_30.invdoh').setValue(amount)), map((value) => this.transformValue(value))),
                    colSpan: 1,
                },
            ],
            [
                {
                    type: 'label',
                    value: this._translateService.select('tables.working_capital.apdoh', 'sales_summary'),
                    colSpan: 1,
                },
                {
                    type: 'listener',
                    value: this.ratioApdoh$.pipe(map((value) => this.transformValue(value))),
                    colSpan: 1,
                },
                {
                    type: 'control',
                    value: getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.apdoh'),
                    colSpan: 1,
                },
                {
                    type: 'listener',
                    value: this.vat30Apdoh$.pipe(tap((amount) => getControlFromGroupByGroupPath(this.formGroup, 'vat_30.apdoh').setValue(amount)), map((value) => this.transformValue(value))),
                    colSpan: 1,
                },
            ],
            [
                {
                    type: 'label',
                    value: this._translateService.select('tables.working_capital.wcr', 'sales_summary'),
                    colSpan: 1,
                },
                {
                    type: 'label',
                    value: '',
                    colSpan: 1,
                },
                {
                    type: 'listener',
                    value: this.targetWcr$.pipe(tap((amount) => getControlFromGroupByGroupPath(this.formGroup, 'target_by_clients.wcr').setValue(amount)), map((value) => this.transformValue(value))),
                    colSpan: 1,
                },
                {
                    type: 'listener',
                    value: this.vat30Wcr$.pipe(tap((amount) => getControlFromGroupByGroupPath(this.formGroup, 'vat_30.wcr').setValue(amount)), map((value) => this.transformValue(value))),
                    colSpan: 1,
                },
            ],
            [
                {
                    type: 'label',
                    value: '',
                    colSpan: 1,
                },
                {
                    type: 'label',
                    value: this._translateService.select('tables.working_capital.others', 'sales_summary'),
                    colSpan: 1,
                },
                {
                    type: 'label',
                    value: '',
                    colSpan: 1,
                },
                {
                    type: 'label',
                    value: '',
                    colSpan: 1,
                },
            ],
            [
                {
                    type: 'label',
                    value: this._translateService.select('tables.working_capital.st_limit', 'sales_summary'),
                    colSpan: 1,
                },
                {
                    type: 'control',
                    value: getControlFromGroupByGroupPath(this.formGroup, 'working_capital_requirements.stlimit'),
                    colSpan: 1,
                },
                {
                    type: 'label',
                    value: '',
                    colSpan: 1,
                },
                {
                    type: 'label',
                    value: '',
                    colSpan: 1,
                },
            ],
            [
                {
                    type: 'label',
                    value: this._translateService.select('tables.working_capital.lto', 'sales_summary'),
                    colSpan: 1,
                },
                {
                    type: 'control',
                    value: getControlFromGroupByGroupPath(this.formGroup, 'working_capital_requirements.lto'),
                    colSpan: 1,
                },
                {
                    type: 'label',
                    value: '',
                    colSpan: 1,
                },
                {
                    type: 'label',
                    value: '',
                    colSpan: 1,
                },
            ],
            [
                {
                    type: 'label',
                    value: this._translateService.select('tables.working_capital.idb', 'sales_summary'),
                    colSpan: 1,
                },
                {
                    type: 'listener',
                    value: this.idb$.pipe(map((value) => {
                        const transformedValue = this.transformValue(value, false);
                        return transformedValue === '--' ? transformedValue : `${transformedValue}%`;
                    })),
                    colSpan: 1,
                },
                {
                    type: 'label',
                    value: '',
                    colSpan: 1,
                },
                {
                    type: 'label',
                    value: '',
                    colSpan: 1,
                },
            ],
            [
                {
                    type: 'label',
                    value: this._translateService.select('tables.working_capital.surplus', 'sales_summary'),
                    colSpan: 1,
                },
                {
                    type: 'listener',
                    value: this.surplus$.pipe(map((value) => this.transformValue(value))),
                    colSpan: 1,
                },
                {
                    type: 'label',
                    value: '',
                    colSpan: 1,
                },
                {
                    type: 'label',
                    value: '',
                    colSpan: 1,
                },
            ],
            [
                {
                    type: 'label',
                    value: this._translateService.select('tables.working_capital.cash_cycle', 'sales_summary'),
                    colSpan: 1,
                },
                {
                    type: 'listener',
                    value: this.cashCycle$.pipe(map((value) => this.transformValue(value))),
                    colSpan: 1,
                },
                {
                    type: 'label',
                    value: '',
                    colSpan: 1,
                },
                {
                    type: 'label',
                    value: '',
                    colSpan: 1,
                },
            ],
        ];
        this.readonly$ = this.componentStore
            .select((state) => state)
            .pipe(map((state) => state.isReadonly || !state.id));
    }
    ngOnInit() {
        combineLatest([
            this.componentStore.select((state) => state.data?.sales_summary_working_capitals),
            this.yearControl.valueChanges.pipe(startWith(this.yearControl.getRawValue())),
        ])
            .pipe(map(([capitals, year]) => capitals?.find((por) => por.year === year)), tap((capital) => {
            this.formGroup.patchValue(capital ?? {
                working_capital_requirements: {
                    stlimit: 0,
                    lto: 0,
                },
                vat_30: {
                    sales: 0,
                    cogs: 0,
                    ardoh: 0,
                    invdoh: 0,
                    apdoh: 0,
                    wcr: 0,
                },
                target_by_clients: {
                    sales: 0,
                    cogs: 0,
                    ardoh: 0,
                    invdoh: 0,
                    apdoh: 0,
                    wcr: 0,
                },
            });
        }))
            .subscribe();
        this.readonly$
            .pipe(followDestroy(this), tap((isReadonly) => {
            if (isReadonly) {
                this.formGroup.disable();
            }
            else {
                this.formGroup.enable();
            }
        }))
            .subscribe();
    }
    save() {
        if (!this.componentStore.state().id || this.componentStore.state().isReadonly) {
            return;
        }
        this.componentStore.saveWorkingCapital({
            ...this.formGroup.getRawValue(),
            year: this.yearControl.getRawValue(),
        });
    }
    transformValue(value, isCurrency = true) {
        return isNaN(value) || value.toString().includes('Infinity')
            ? '--'
            : `${isCurrency ? `${this.getCurrency()} ` : ''}${new Intl.NumberFormat('en-US', {
                maximumFractionDigits: 2,
            })
                .format(value)
                .replace('.00', '')}`;
    }
    getCurrency() {
        return getCurrentCountryConfig().currencyCode;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSalesSummaryWorkingCapitalTableComponent, deps: [{ token: FSW_SALES_SUMMARY_STORE_TOKEN }, { token: FSW_TRANSLATE_SERVICE_TOKEN }, { token: i1$7.Dialog }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWSalesSummaryWorkingCapitalTableComponent, selector: "fsw-sales-summary-working-capital-table", providers: [provideNgxMask()], ngImport: i0, template: "<fsw-panel [title]=\"'tables.working_capital.title' | fswTranslate\" [headerClasses]=\"'gap-[12px]'\">\n  <ng-template fswPanelHeaderSuffix>\n    <section class=\"flex items-center gap-[12px]\">\n      <button [disabled]=\"(readonly$ | async) ?? formGroup.invalid\" fswButton (click)=\"save()\">\n        {{ 'buttons.save_changes' | fswTranslate }}\n      </button>\n    </section>\n  </ng-template>\n  <form [formGroup]=\"formGroup\" class=\"w-full overflow-x-auto !flex\">\n    <table class=\"fsw-table fsw-table--bordered table-fixed w-full\">\n      <caption class=\"hidden\">\n        Sales Summary Calculation Table\n      </caption>\n      <thead *ngIf=\"yearControl | fswValueChanges as value\">\n        <tr>\n          <th colspan=\"2\" scope=\"rowgroup\" class=\"!font-bold whitespace-normal\">\n            {{ 'tables.working_capital.title' | fswTranslate }}\n          </th>\n          <th scope=\"col\" class=\"whitespace-normal\">\n            {{ 'tables.working_capital.target_by_the_client' | fswTranslate }}\n          </th>\n          <th scope=\"col\" class=\"whitespace-normal\">\n            {{ 'tables.working_capital.vat30' | fswTranslate : { data: { year: value } } }}\n          </th>\n        </tr>\n        <tr>\n          <th scope=\"col\" colspan=\"2\"></th>\n          <th scope=\"col\">{{ value }}F</th>\n          <th scope=\"col\">{{ value }}F</th>\n        </tr>\n      </thead>\n      <tbody>\n        <ng-container *ngFor=\"let row of tableBodyStructureRows\">\n          <tr>\n            <ng-container *ngFor=\"let col of row\">\n              <td [colSpan]=\"col.colSpan\" class=\"align-middle h-[57px] whitespace-normal\">\n                <ng-container *ngIf=\"col.type === 'control'; else asyncTemplate\">\n                  <fsw-field [fullWidth]=\"true\">\n                    <ng-template fswFieldInputPrefix>\n                      {{ getCurrency() }}\n                    </ng-template>\n                    <input\n                      fswInput\n                      [mask]=\"'separator.2'\"\n                      thousandSeparator=\",\"\n                      [formControl]=\"col.value\"\n                    />\n                  </fsw-field>\n                </ng-container>\n                <ng-template #asyncTemplate>\n                  <ng-container *ngIf=\"col.type === 'listener'; else labelTemplate\">\n                    {{ col.value | async }}\n                  </ng-container>\n                </ng-template>\n                <ng-template #labelTemplate>\n                  {{ col.value }}\n                </ng-template>\n              </td>\n            </ng-container>\n          </tr>\n        </ng-container>\n      </tbody>\n    </table>\n  </form>\n</fsw-panel>\n", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$4.FSWFieldInputPrefixDirective, selector: "ng-template[fswFieldInputPrefix]" }, { kind: "directive", type: i1$4.FSWInputDirective, selector: "input[fswInput], textarea[fswInput]" }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i5$1.NgxMaskDirective, selector: "input[mask], textarea[mask]", inputs: ["mask", "specialCharacters", "patterns", "prefix", "suffix", "thousandSeparator", "decimalMarker", "dropSpecialCharacters", "hiddenInput", "showMaskTyped", "placeHolderCharacter", "shownMaskExpression", "showTemplate", "clearIfNotMatch", "validation", "separatorLimit", "allowNegativeNumbers", "leadZeroDateTime", "leadZero", "triggerOnMaskChange", "apm", "inputTransformFn", "outputTransformFn", "keepCharacterPositions"], outputs: ["maskFilled"], exportAs: ["mask", "ngxMask"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i1$4.FSWValueChangesPipe, name: "fswValueChanges" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
};
FSWSalesSummaryWorkingCapitalTableComponent = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [Object, Object, Dialog,
        Injector])
], FSWSalesSummaryWorkingCapitalTableComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSalesSummaryWorkingCapitalTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-sales-summary-working-capital-table', changeDetection: ChangeDetectionStrategy.OnPush, providers: [provideNgxMask()], template: "<fsw-panel [title]=\"'tables.working_capital.title' | fswTranslate\" [headerClasses]=\"'gap-[12px]'\">\n  <ng-template fswPanelHeaderSuffix>\n    <section class=\"flex items-center gap-[12px]\">\n      <button [disabled]=\"(readonly$ | async) ?? formGroup.invalid\" fswButton (click)=\"save()\">\n        {{ 'buttons.save_changes' | fswTranslate }}\n      </button>\n    </section>\n  </ng-template>\n  <form [formGroup]=\"formGroup\" class=\"w-full overflow-x-auto !flex\">\n    <table class=\"fsw-table fsw-table--bordered table-fixed w-full\">\n      <caption class=\"hidden\">\n        Sales Summary Calculation Table\n      </caption>\n      <thead *ngIf=\"yearControl | fswValueChanges as value\">\n        <tr>\n          <th colspan=\"2\" scope=\"rowgroup\" class=\"!font-bold whitespace-normal\">\n            {{ 'tables.working_capital.title' | fswTranslate }}\n          </th>\n          <th scope=\"col\" class=\"whitespace-normal\">\n            {{ 'tables.working_capital.target_by_the_client' | fswTranslate }}\n          </th>\n          <th scope=\"col\" class=\"whitespace-normal\">\n            {{ 'tables.working_capital.vat30' | fswTranslate : { data: { year: value } } }}\n          </th>\n        </tr>\n        <tr>\n          <th scope=\"col\" colspan=\"2\"></th>\n          <th scope=\"col\">{{ value }}F</th>\n          <th scope=\"col\">{{ value }}F</th>\n        </tr>\n      </thead>\n      <tbody>\n        <ng-container *ngFor=\"let row of tableBodyStructureRows\">\n          <tr>\n            <ng-container *ngFor=\"let col of row\">\n              <td [colSpan]=\"col.colSpan\" class=\"align-middle h-[57px] whitespace-normal\">\n                <ng-container *ngIf=\"col.type === 'control'; else asyncTemplate\">\n                  <fsw-field [fullWidth]=\"true\">\n                    <ng-template fswFieldInputPrefix>\n                      {{ getCurrency() }}\n                    </ng-template>\n                    <input\n                      fswInput\n                      [mask]=\"'separator.2'\"\n                      thousandSeparator=\",\"\n                      [formControl]=\"col.value\"\n                    />\n                  </fsw-field>\n                </ng-container>\n                <ng-template #asyncTemplate>\n                  <ng-container *ngIf=\"col.type === 'listener'; else labelTemplate\">\n                    {{ col.value | async }}\n                  </ng-container>\n                </ng-template>\n                <ng-template #labelTemplate>\n                  {{ col.value }}\n                </ng-template>\n              </td>\n            </ng-container>\n          </tr>\n        </ng-container>\n      </tbody>\n    </table>\n  </form>\n</fsw-panel>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_SALES_SUMMARY_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_TRANSLATE_SERVICE_TOKEN]
                }] }, { type: i1$7.Dialog }, { type: i0.Injector }]; } });

class FswSalesSummaryPorCalculationPipe {
    constructor(componentStore, _currencyFormatPipe) {
        this.componentStore = componentStore;
        this._currencyFormatPipe = _currencyFormatPipe;
        this._latestValue = '';
    }
    transform(formGroup, key) {
        formGroup.valueChanges
            .pipe(startWith(formGroup.value), tap(({ monthly_amounts }) => {
            const total = monthly_amounts.reduce((acc, { amount }) => acc + amount, 0);
            const last6Months = this._getLast6Months(monthly_amounts);
            const totalLast6Months = last6Months.reduce((acc, { amount }) => acc + amount, 0);
            const volatility = Number((Math.min(...last6Months.map((m) => m.amount)) / (totalLast6Months / 6)).toFixed(2)) * 100;
            switch (key) {
                case 'total':
                    this._latestValue =
                        this._currencyFormatPipe.transform(this.transformValue(Number(total.toFixed(2)))) ||
                            '';
                    break;
                case 'average':
                    this._latestValue =
                        this._currencyFormatPipe.transform(this.transformValue(Number((total / monthly_amounts.length).toFixed(2)))) || '';
                    break;
                case 'total-trailing':
                    this._latestValue =
                        this._currencyFormatPipe.transform(this.transformValue(Number(totalLast6Months.toFixed(2)))) || '';
                    break;
                case 'average-trailing':
                    this._latestValue =
                        this._currencyFormatPipe.transform(this.transformValue(Number((totalLast6Months / 6).toFixed(2)))) || '';
                    break;
                case 'volatility':
                    this._latestValue = isNaN(volatility) ? '' : `${this.transformValue(volatility)}%`;
                    break;
                default:
                    this._latestValue = '';
                    break;
            }
        }))
            .subscribe();
        return this._latestValue;
    }
    transformValue(value) {
        return isNaN(value) || value.toString().includes('Infinity') ? 0 : Number(value.toFixed(2));
    }
    _getLast6Months(monthly_amounts) {
        const checkHaveValue = monthly_amounts.some((m) => m.amount > 0);
        if (!checkHaveValue) {
            return monthly_amounts.slice(6, 12);
        }
        const latestIndex = this._getLatestIndex(monthly_amounts);
        return [
            ...this._getPreviousYears(latestIndex),
            ...monthly_amounts.slice(latestIndex - 5 > 0 ? latestIndex - 5 : 0, latestIndex + 1),
        ];
    }
    _getLatestIndex(monthly_amounts) {
        let resolve = false;
        let index = monthly_amounts.length - 1;
        while (!resolve && index >= 0) {
            if (monthly_amounts[index].amount > 0) {
                resolve = true;
            }
            else {
                index--;
            }
        }
        return index;
    }
    _getPreviousYears(latestIndex) {
        const adding = 6 - (latestIndex + 1);
        if (adding <= 0) {
            return [];
        }
        const previousPors = this.componentStore
            .state()
            .data?.sales_summary_pors?.find((por) => por.year === new Date().getFullYear() - 1);
        const monthly_amounts = previousPors?.sales_por_data?.monthly_amounts;
        if (!monthly_amounts?.length) {
            return [];
        }
        return monthly_amounts.slice(monthly_amounts.length - adding, monthly_amounts.length);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FswSalesSummaryPorCalculationPipe, deps: [{ token: FSW_SALES_SUMMARY_STORE_TOKEN }, { token: CurrencyFormatPipe }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FswSalesSummaryPorCalculationPipe, name: "fswSalesSummaryPorCalculation", pure: false }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FswSalesSummaryPorCalculationPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fswSalesSummaryPorCalculation',
                    pure: false,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_SALES_SUMMARY_STORE_TOKEN]
                }] }, { type: CurrencyFormatPipe }]; } });

let FSWSalesSummaryPorTableComponent = class FSWSalesSummaryPorTableComponent {
    get yearOptions() {
        return Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i);
    }
    constructor(componentStore, _dialog, _injector) {
        this.componentStore = componentStore;
        this._dialog = _dialog;
        this._injector = _injector;
        this.yearControl = this.componentStore.yearControl;
        this.pors$ = this.componentStore.select((state) => state.data?.sales_summary_pors);
        this.readonly$ = this.componentStore
            .select((state) => state)
            .pipe(map((state) => state.isReadonly || !state.id));
        this.canNotSelectYear$ = this.componentStore
            .select((state) => state)
            .pipe(map((state) => !state.id));
        this.formGroup = this.componentStore.porGroup;
        this.monthLabels = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ];
    }
    ngOnInit() {
        getControlFromGroup(this.formGroup, 'monthly_amounts')
            .valueChanges.pipe(followDestroy(this), tap((monthlyAmounts) => {
            this.componentStore.yearPors.next(monthlyAmounts);
        }))
            .subscribe();
        combineLatest([
            this.pors$,
            this.yearControl.valueChanges.pipe(startWith(this.yearControl.value)),
        ])
            .pipe(followDestroy(this), map(([pors, year]) => pors?.find((por) => por.year === year)), tap((por) => {
            this.formGroup.patchValue(por?.sales_por_data ?? {
                ebitda_margin: 0,
                projected_ebitda: 0,
                annualized_sales: 0,
                note: '',
                monthly_amounts: Array.from({ length: 12 }, (_, month) => ({
                    month,
                    amount: 0,
                })),
            });
        }))
            .subscribe();
        this.canNotSelectYear$
            .pipe(followDestroy(this), tap((canNotSelectYear) => {
            if (canNotSelectYear) {
                this.yearControl.disable();
            }
            else {
                this.yearControl.enable();
            }
        }))
            .subscribe();
        this.readonly$
            .pipe(followDestroy(this), tap((isReadonly) => {
            if (isReadonly) {
                this.formGroup.disable();
            }
            else {
                this.formGroup.enable();
            }
        }))
            .subscribe();
    }
    save() {
        if (!this.componentStore.state().id || this.componentStore.state().isReadonly) {
            return;
        }
        this.componentStore.savePor({
            year: this.yearControl.getRawValue(),
            sales_por_data: this.formGroup.getRawValue(),
        });
    }
    isTodayYear(year) {
        return year === new Date().getFullYear();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSalesSummaryPorTableComponent, deps: [{ token: FSW_SALES_SUMMARY_STORE_TOKEN }, { token: i1$7.Dialog }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWSalesSummaryPorTableComponent, selector: "fsw-sales-summary-por-table", providers: [CurrencyFormatPipe, provideNgxMask()], ngImport: i0, template: "<fsw-panel [title]=\"'tables.por.title' | fswTranslate\" [headerClasses]=\"'gap-[12px]'\">\n  <ng-template fswPanelHeaderSuffix>\n    <section class=\"flex items-center gap-[12px]\">\n      <button [disabled]=\"(readonly$ | async) ?? formGroup.invalid\" fswButton (click)=\"save()\">\n        {{ 'buttons.save_changes' | fswTranslate }}\n      </button>\n    </section>\n  </ng-template>\n  <form class=\"!flex flex-col gap-[16px] overflow-x-auto\" [formGroup]=\"formGroup\">\n    <header>\n      <fsw-field>\n        <ng-template\n          fswFieldHeaderPrefix\n          [label]=\"'tables.por.reported_year' | fswTranslate\"\n        ></ng-template>\n        <fsw-select\n          [formControl]=\"yearControl\"\n          [closeOnSelected]=\"true\"\n          [placeHolder]=\"'tables.por.reported_year' | fswTranslate\"\n        >\n          <ng-container *ngFor=\"let yearOption of yearOptions\">\n            <ng-template\n              fswSelectItem\n              textSize=\"s\"\n              [value]=\"yearOption\"\n              [text]=\"\n                yearOption.toString() +\n                (isTodayYear(yearOption)\n                  ? ' (' + ('tables.por.current_year' | fswTranslate) + ')'\n                  : '')\n              \"\n              [showCheckIcon]=\"true\"\n              let-selected\n            ></ng-template>\n          </ng-container>\n        </fsw-select>\n      </fsw-field>\n    </header>\n    <table class=\"fsw-table fsw-table--bordered w-full table-fixed\">\n      <caption class=\"hidden\">\n        Sales Summary Monthly Table\n      </caption>\n      <thead>\n        <tr>\n          <th>\n            {{\n              'tables.por.month'\n                | fswTranslate : { data: { year: yearControl.getRawValue().toString() } }\n            }}\n          </th>\n          <th>{{ 'tables.por.sales' | fswTranslate }}</th>\n        </tr>\n      </thead>\n      <tbody formArrayName=\"monthly_amounts\">\n        <ng-container *ngFor=\"let monthLabel of monthLabels; let i = index\">\n          <tr formGroupName=\"{{ i }}\">\n            <td>{{ monthLabel }}</td>\n            <td>\n              <fsw-field [fullWidth]=\"true\">\n                <input\n                  [mask]=\"'separator.2'\"\n                  thousandSeparator=\",\"\n                  fswInput\n                  [placeholder]=\"monthLabel\"\n                  formControlName=\"amount\"\n                />\n              </fsw-field>\n            </td>\n          </tr>\n        </ng-container>\n      </tbody>\n      <tfoot class=\"bg-[aliceblue]\">\n        <tr>\n          <td class=\"whitespace-normal align-middle\">\n            {{\n              'tables.por.total'\n                | fswTranslate : { data: { year: yearControl.getRawValue().toString() } }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle\">\n            {{ formGroup | fswSalesSummaryPorCalculation : 'total' }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle\">\n            {{\n              'tables.por.average'\n                | fswTranslate : { data: { year: yearControl.getRawValue().toString() } }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle\">\n            {{ formGroup | fswSalesSummaryPorCalculation : 'average' }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle\">\n            {{ 'tables.por.total_trailing' | fswTranslate }}\n          </td>\n          <td class=\"whitespace-normal align-middle\">\n            {{ formGroup | fswSalesSummaryPorCalculation : 'total-trailing' }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle\">\n            {{ 'tables.por.average_trailing' | fswTranslate }}\n          </td>\n          <td class=\"whitespace-normal align-middle\">\n            {{ formGroup | fswSalesSummaryPorCalculation : 'average-trailing' }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle\">\n            {{ 'tables.por.volatility' | fswTranslate }}\n          </td>\n          <td class=\"whitespace-normal align-middle\">\n            {{ formGroup | fswSalesSummaryPorCalculation : 'volatility' }}\n          </td>\n        </tr>\n      </tfoot>\n    </table>\n  </form>\n</fsw-panel>\n", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$4.FSWFieldHeaderPrefixDirective, selector: "ng-template[fswFieldHeaderPrefix]", inputs: ["kind", "label", "required"] }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "directive", type: i1$4.FSWInputDirective, selector: "input[fswInput], textarea[fswInput]" }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: i2.FormGroupName, selector: "[formGroupName]", inputs: ["formGroupName"] }, { kind: "directive", type: i2.FormArrayName, selector: "[formArrayName]", inputs: ["formArrayName"] }, { kind: "directive", type: i5$1.NgxMaskDirective, selector: "input[mask], textarea[mask]", inputs: ["mask", "specialCharacters", "patterns", "prefix", "suffix", "thousandSeparator", "decimalMarker", "dropSpecialCharacters", "hiddenInput", "showMaskTyped", "placeHolderCharacter", "shownMaskExpression", "showTemplate", "clearIfNotMatch", "validation", "separatorLimit", "allowNegativeNumbers", "leadZeroDateTime", "leadZero", "triggerOnMaskChange", "apm", "inputTransformFn", "outputTransformFn", "keepCharacterPositions"], outputs: ["maskFilled"], exportAs: ["mask", "ngxMask"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "pipe", type: FswSalesSummaryPorCalculationPipe, name: "fswSalesSummaryPorCalculation" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
};
FSWSalesSummaryPorTableComponent = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [Object, Dialog,
        Injector])
], FSWSalesSummaryPorTableComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSalesSummaryPorTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-sales-summary-por-table', changeDetection: ChangeDetectionStrategy.OnPush, providers: [CurrencyFormatPipe, provideNgxMask()], template: "<fsw-panel [title]=\"'tables.por.title' | fswTranslate\" [headerClasses]=\"'gap-[12px]'\">\n  <ng-template fswPanelHeaderSuffix>\n    <section class=\"flex items-center gap-[12px]\">\n      <button [disabled]=\"(readonly$ | async) ?? formGroup.invalid\" fswButton (click)=\"save()\">\n        {{ 'buttons.save_changes' | fswTranslate }}\n      </button>\n    </section>\n  </ng-template>\n  <form class=\"!flex flex-col gap-[16px] overflow-x-auto\" [formGroup]=\"formGroup\">\n    <header>\n      <fsw-field>\n        <ng-template\n          fswFieldHeaderPrefix\n          [label]=\"'tables.por.reported_year' | fswTranslate\"\n        ></ng-template>\n        <fsw-select\n          [formControl]=\"yearControl\"\n          [closeOnSelected]=\"true\"\n          [placeHolder]=\"'tables.por.reported_year' | fswTranslate\"\n        >\n          <ng-container *ngFor=\"let yearOption of yearOptions\">\n            <ng-template\n              fswSelectItem\n              textSize=\"s\"\n              [value]=\"yearOption\"\n              [text]=\"\n                yearOption.toString() +\n                (isTodayYear(yearOption)\n                  ? ' (' + ('tables.por.current_year' | fswTranslate) + ')'\n                  : '')\n              \"\n              [showCheckIcon]=\"true\"\n              let-selected\n            ></ng-template>\n          </ng-container>\n        </fsw-select>\n      </fsw-field>\n    </header>\n    <table class=\"fsw-table fsw-table--bordered w-full table-fixed\">\n      <caption class=\"hidden\">\n        Sales Summary Monthly Table\n      </caption>\n      <thead>\n        <tr>\n          <th>\n            {{\n              'tables.por.month'\n                | fswTranslate : { data: { year: yearControl.getRawValue().toString() } }\n            }}\n          </th>\n          <th>{{ 'tables.por.sales' | fswTranslate }}</th>\n        </tr>\n      </thead>\n      <tbody formArrayName=\"monthly_amounts\">\n        <ng-container *ngFor=\"let monthLabel of monthLabels; let i = index\">\n          <tr formGroupName=\"{{ i }}\">\n            <td>{{ monthLabel }}</td>\n            <td>\n              <fsw-field [fullWidth]=\"true\">\n                <input\n                  [mask]=\"'separator.2'\"\n                  thousandSeparator=\",\"\n                  fswInput\n                  [placeholder]=\"monthLabel\"\n                  formControlName=\"amount\"\n                />\n              </fsw-field>\n            </td>\n          </tr>\n        </ng-container>\n      </tbody>\n      <tfoot class=\"bg-[aliceblue]\">\n        <tr>\n          <td class=\"whitespace-normal align-middle\">\n            {{\n              'tables.por.total'\n                | fswTranslate : { data: { year: yearControl.getRawValue().toString() } }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle\">\n            {{ formGroup | fswSalesSummaryPorCalculation : 'total' }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle\">\n            {{\n              'tables.por.average'\n                | fswTranslate : { data: { year: yearControl.getRawValue().toString() } }\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle\">\n            {{ formGroup | fswSalesSummaryPorCalculation : 'average' }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle\">\n            {{ 'tables.por.total_trailing' | fswTranslate }}\n          </td>\n          <td class=\"whitespace-normal align-middle\">\n            {{ formGroup | fswSalesSummaryPorCalculation : 'total-trailing' }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle\">\n            {{ 'tables.por.average_trailing' | fswTranslate }}\n          </td>\n          <td class=\"whitespace-normal align-middle\">\n            {{ formGroup | fswSalesSummaryPorCalculation : 'average-trailing' }}\n          </td>\n        </tr>\n        <tr>\n          <td class=\"whitespace-normal align-middle\">\n            {{ 'tables.por.volatility' | fswTranslate }}\n          </td>\n          <td class=\"whitespace-normal align-middle\">\n            {{ formGroup | fswSalesSummaryPorCalculation : 'volatility' }}\n          </td>\n        </tr>\n      </tfoot>\n    </table>\n  </form>\n</fsw-panel>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_SALES_SUMMARY_STORE_TOKEN]
                }] }, { type: i1$7.Dialog }, { type: i0.Injector }]; } });

class FSWSalesSummaryComponent {
    set applicationId(applicationId) {
        this.componentStore.updateState({
            applicationId,
        });
    }
    set isReadonly(isReadonly) {
        this.componentStore.updateState({
            isReadonly,
        });
    }
    constructor(componentStore) {
        this.componentStore = componentStore;
    }
    ngOnInit() {
        this.componentStore.init();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSalesSummaryComponent, deps: [{ token: FSW_SALES_SUMMARY_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWSalesSummaryComponent, selector: "fsw-sales-summary", inputs: { applicationId: "applicationId", isReadonly: "isReadonly" }, ngImport: i0, template: "<fsw-panel [title]=\"'title' | fswTranslate\">\n  <section class=\"flex flex-col gap-[16px]\">\n    <ng-template fswPanelHeaderSuffix>\n      <button fswButton [appearance]=\"'secondary'\" (click)=\"componentStore.loadData()\">\n        {{ 'buttons.refresh' | fswTranslate }}\n      </button>\n    </ng-template>\n    <fsw-sales-summary-accounts-table></fsw-sales-summary-accounts-table>\n    <section class=\"flex gap-[16px]\">\n      <fsw-sales-summary-por-table class=\"w-[calc(50%-8px)]\"></fsw-sales-summary-por-table>\n      <fsw-sales-summary-working-capital-table\n        class=\"w-[calc(50%-8px)]\"\n      ></fsw-sales-summary-working-capital-table>\n    </section>\n  </section>\n</fsw-panel>\n", dependencies: [{ kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "component", type: FSWSalesSummaryAccountsTableComponent, selector: "fsw-sales-summary-accounts-table" }, { kind: "component", type: FSWSalesSummaryWorkingCapitalTableComponent, selector: "fsw-sales-summary-working-capital-table" }, { kind: "component", type: FSWSalesSummaryPorTableComponent, selector: "fsw-sales-summary-por-table" }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSalesSummaryComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-sales-summary', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-panel [title]=\"'title' | fswTranslate\">\n  <section class=\"flex flex-col gap-[16px]\">\n    <ng-template fswPanelHeaderSuffix>\n      <button fswButton [appearance]=\"'secondary'\" (click)=\"componentStore.loadData()\">\n        {{ 'buttons.refresh' | fswTranslate }}\n      </button>\n    </ng-template>\n    <fsw-sales-summary-accounts-table></fsw-sales-summary-accounts-table>\n    <section class=\"flex gap-[16px]\">\n      <fsw-sales-summary-por-table class=\"w-[calc(50%-8px)]\"></fsw-sales-summary-por-table>\n      <fsw-sales-summary-working-capital-table\n        class=\"w-[calc(50%-8px)]\"\n      ></fsw-sales-summary-working-capital-table>\n    </section>\n  </section>\n</fsw-panel>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_SALES_SUMMARY_STORE_TOKEN]
                }] }]; }, propDecorators: { applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class FSwSalesSummaryDirective {
    constructor(_viewContainerRef, _translateService) {
        this._viewContainerRef = _viewContainerRef;
        this._translateService = _translateService;
        this.applicationId = null;
        this.isReadonly = false;
        this._translateService.switchTranslateKey(getCountryCodeFromStorage());
    }
    ngOnChanges() {
        this._viewContainerRef.clear();
        const ref = this._viewContainerRef.createComponent(FSWSalesSummaryComponent, {
            injector: Injector.create({
                parent: this._viewContainerRef.injector,
                providers: [...salesSummaryLoadProviders(getCountryCodeFromStorage())],
            }),
        });
        const instance = ref.instance;
        instance.applicationId = this.applicationId;
        instance.isReadonly = this.isReadonly;
        ref.changeDetectorRef.detectChanges();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSwSalesSummaryDirective, deps: [{ token: i0.ViewContainerRef }, { token: FSW_TRANSLATE_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSwSalesSummaryDirective, selector: "[fswSalesSummary]", inputs: { applicationId: "applicationId", isReadonly: "isReadonly" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSwSalesSummaryDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswSalesSummary]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_TRANSLATE_SERVICE_TOKEN]
                }] }]; }, propDecorators: { applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class FSWSalesSummaryModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSalesSummaryModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWSalesSummaryModule, declarations: [FSwSalesSummaryDirective,
            FSWSalesSummaryComponent,
            FSWSalesSummaryAccountsTableComponent,
            FSWSalesSummaryWorkingCapitalTableComponent,
            FSWSalesSummaryPorTableComponent,
            FSWSalesSummaryAccountsModalComponent,
            FSWSalesSummaryAccountCalculationPipe,
            FswSalesSummaryPorCalculationPipe,
            FSWSalesSummaryConfirmModalComponent,
            FSWSalesSummaryAccountsContainerComponent], imports: [i1$4.FSWTranslateModule, NgForOf,
            FSWFieldModule,
            FSWSelectModule,
            FSWModalModule$1,
            FSWInputModule,
            AsyncPipe,
            CurrencyFormatModule,
            FSWPanelModule,
            FSWTranslateModule,
            NgIf,
            FSWButtonModule,
            ReactiveFormsModule,
            FSWDynamicBuilderModule,
            ApplicationSalesSummaryServiceModule,
            CreditSalesSummaryServiceModule,
            BankAccountsAndStatementsServiceModule,
            FSWValueChangesPipeModule,
            NgxMaskDirective], exports: [FSwSalesSummaryDirective,
            FSWSalesSummaryComponent,
            FSWSalesSummaryAccountsTableComponent,
            FSWSalesSummaryWorkingCapitalTableComponent,
            FSWSalesSummaryPorTableComponent,
            FSWSalesSummaryAccountsModalComponent,
            FSWSalesSummaryAccountCalculationPipe,
            FswSalesSummaryPorCalculationPipe,
            FSWSalesSummaryConfirmModalComponent,
            FSWSalesSummaryAccountsContainerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSalesSummaryModule, imports: [FSWTranslateModule.forFeature({
                scope: 'sales_summary',
                defaultKey: CountryCode.TH,
                data: FSW_SALES_SUMMARY_TRANSLATION_LOADER,
            }),
            FSWFieldModule,
            FSWSelectModule,
            FSWModalModule$1,
            FSWInputModule,
            CurrencyFormatModule,
            FSWPanelModule,
            FSWTranslateModule,
            FSWButtonModule,
            ReactiveFormsModule,
            FSWDynamicBuilderModule,
            ApplicationSalesSummaryServiceModule,
            CreditSalesSummaryServiceModule,
            BankAccountsAndStatementsServiceModule,
            FSWValueChangesPipeModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSalesSummaryModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FSwSalesSummaryDirective,
                        FSWSalesSummaryComponent,
                        FSWSalesSummaryAccountsTableComponent,
                        FSWSalesSummaryWorkingCapitalTableComponent,
                        FSWSalesSummaryPorTableComponent,
                        FSWSalesSummaryAccountsModalComponent,
                        FSWSalesSummaryAccountCalculationPipe,
                        FswSalesSummaryPorCalculationPipe,
                        FSWSalesSummaryConfirmModalComponent,
                        FSWSalesSummaryAccountsContainerComponent,
                    ],
                    exports: [
                        FSwSalesSummaryDirective,
                        FSWSalesSummaryComponent,
                        FSWSalesSummaryAccountsTableComponent,
                        FSWSalesSummaryWorkingCapitalTableComponent,
                        FSWSalesSummaryPorTableComponent,
                        FSWSalesSummaryAccountsModalComponent,
                        FSWSalesSummaryAccountCalculationPipe,
                        FswSalesSummaryPorCalculationPipe,
                        FSWSalesSummaryConfirmModalComponent,
                        FSWSalesSummaryAccountsContainerComponent,
                    ],
                    imports: [
                        FSWTranslateModule.forFeature({
                            scope: 'sales_summary',
                            defaultKey: CountryCode.TH,
                            data: FSW_SALES_SUMMARY_TRANSLATION_LOADER,
                        }),
                        NgForOf,
                        FSWFieldModule,
                        FSWSelectModule,
                        FSWModalModule$1,
                        FSWInputModule,
                        AsyncPipe,
                        CurrencyFormatModule,
                        FSWPanelModule,
                        FSWTranslateModule,
                        NgIf,
                        FSWButtonModule,
                        ReactiveFormsModule,
                        FSWDynamicBuilderModule,
                        ApplicationSalesSummaryServiceModule,
                        CreditSalesSummaryServiceModule,
                        BankAccountsAndStatementsServiceModule,
                        FSWValueChangesPipeModule,
                        NgxMaskDirective,
                    ],
                }]
        }] });

function injectScorecardTHEffects(refreshedAt, scorecard, injector) {
    const creditService = inject(SCORECARD_SERVICE_TOKEN);
    const applicationService = inject(APPLICATION_SCORECARD_SERVICE_TOKEN);
    const alertService = inject(FSW_ALERT_SERVICE_TOKEN);
    return {
        refresh: (applicationId) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => applicationService
            .getScorecardId(applicationId, true)
            .pipe(switchMap$1((id) => id ? creditService.getScorecardDetail(id) : from(Promise.resolve(null))))), tap((data) => scorecard.set(data)), catchError((err) => {
            alertService.error('Failed to load Scorecard', null, {
                duration: 3000,
            });
            scorecard.set(null);
            return throwError(() => err);
        })), injector, null))),
        create: (applicationId, payload) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => creditService
            .createScorecard(payload)
            .pipe(switchMap$1((data) => applicationService.linkScorecardIdToApplication(applicationId, data.score_card_id)))), tap(() => refreshedAt.set(new Date())), tap(() => alertService.success('Create Scorecard successfully!', null, {
            duration: 3000,
        })), catchError(() => {
            alertService.error('Failed to create Scorecard', null, {
                duration: 3000,
            });
            return of(null);
        })), injector))),
    };
}

var title$4 = "Scorecard";
var borrower = {
	title: "Borrower Details",
	fields: {
		borrower_name: "Borrower Name",
		product: "Product",
		rating: "Rating",
		score: "Score",
		interest_range_recommendation: "Adjustment from Min interest"
	}
};
var table$1 = {
	title: "Credit Scoring",
	columns: {
		category: "Category",
		factor: "Factor",
		picklist: "Picklist",
		score: "Score"
	}
};
var score = "Score";
var buttons$9 = {
	save: "Save Scorecard"
};
var scorecardTh = {
	title: title$4,
	borrower: borrower,
	table: table$1,
	score: score,
	buttons: buttons$9
};

var TH$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    borrower: borrower,
    buttons: buttons$9,
    default: scorecardTh,
    score: score,
    table: table$1,
    title: title$4
});

const SCORECARD_TH_TRANSLATION = TH$2;

function provideScorecardTranslation() {
    return [
        ...(FSWTranslateModule.forFeature({
            scope: 'scorecard',
            defaultKey: CountryCode.TH,
            data: {
                [CountryCode.TH]: SCORECARD_TH_TRANSLATION,
            },
        }).providers || []),
        fswTranslateScope('scorecard'),
    ];
}

function injectScorecardEffects(refreshedAt, scorecard, injector) {
    switch (getCountryCodeFromStorage()) {
        case CountryCode.TH:
            return injectScorecardTHEffects(refreshedAt, scorecard, injector);
        default:
            return injectScorecardTHEffects(refreshedAt, scorecard, injector);
    }
}

let FSWScorecardComponent = class FSWScorecardComponent {
    constructor() {
        this.updated = new EventEmitter();
        this.applicationId = signal('');
        this.productUPI = signal(getCurrentCountryConfig().product_upi);
        this.isReadonly = signal(false);
        this.scorecard = signal(null);
        this.refreshedAt = signal(new Date());
        this.products = signal([]);
        this.factors = signal([]);
        this.factorGroups = signal([]);
        this.ratingTypes = signal([]);
        this.selectedProduct = signal(null);
        this.selectedRating = signal(null);
        this.products$ = toObservable(this.products);
        this.ratingTypes$ = toObservable(this.ratingTypes);
        this.effects = injectScorecardEffects(this.refreshedAt, this.scorecard, inject(Injector));
        this.service = inject(SCORECARD_SERVICE_TOKEN);
        this.settingService = inject(SETTINGS_SERVICE_TOKEN);
        this.applicationMemberService = inject(APPLICATION_MEMBER_SERVICE_TOKEN);
        this.translateService = inject(FSW_TRANSLATE_SERVICE_TOKEN);
        this.alertService = inject(FSW_ALERT_SERVICE_TOKEN);
        this.scoringGroup = new UntypedFormGroup({});
        this.scorecardGroup = new UntypedFormGroup({});
        this.scorecardBuilder = new FSWDynamicBuilder({
            formType: FSWDynamicBuilderFormTypes.GROUP,
            form: this.scorecardGroup,
            customClasses: 'w-full flex flex-col gap-[16px]',
            fields: [
                {
                    key: 'borrower_name',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-full',
                    context: {
                        label: this.translateService.select('borrower.fields.borrower_name', 'scorecard'),
                        placeHolder: this.translateService.select('borrower.fields.borrower_name', 'scorecard'),
                        isDisabled: true,
                        fullWidth: true,
                    },
                },
                {
                    key: 'product_type',
                    type: FSWDynamicBuilderControlTypes.SELECT,
                    customClasses: 'w-full',
                    context: {
                        label: this.translateService.select('borrower.fields.product', 'scorecard'),
                        placeHolder: this.translateService.select('borrower.fields.product', 'scorecard'),
                        maxHeight: '300px',
                        closeOnSelected: true,
                        fullWidth: true,
                        isRequired: true,
                        isDisabled: this.isReadonly(),
                        loadItemsAsync: () => this.products$.pipe(map((products) => products.map((product) => ({
                            text: product.name,
                            value: product.name,
                        })))),
                        afterCreated: (control) => {
                            this.selectedProduct.set(control.value);
                            control.valueChanges.subscribe((value) => this.selectedProduct.set(value));
                        },
                    },
                    validations: [Validators.required],
                },
                {
                    key: 'rating_type',
                    type: FSWDynamicBuilderControlTypes.SELECT,
                    customClasses: 'w-full',
                    context: {
                        label: this.translateService.select('borrower.fields.rating', 'scorecard'),
                        placeHolder: this.translateService.select('borrower.fields.rating', 'scorecard'),
                        maxHeight: '300px',
                        closeOnSelected: true,
                        fullWidth: true,
                        isRequired: true,
                        isDisabled: this.isReadonly(),
                        loadItemsAsync: () => this.ratingTypes$.pipe(map((ratingTypes) => ratingTypes.map((ratingType) => ({
                            text: ratingType,
                            value: ratingType,
                        })))),
                        afterCreated: (control) => {
                            this.selectedRating.set(control.value);
                            control.valueChanges.subscribe((value) => this.selectedRating.set(value));
                        },
                    },
                    validations: [Validators.required],
                },
                {
                    key: 'total_score',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-full',
                    context: {
                        // inputType: 'number',
                        defaultValue: 0,
                        mask: {
                            expression: 'separator.2',
                            config: {
                                thousandSeparator: ',',
                            },
                        },
                        label: this.translateService.select('borrower.fields.score', 'scorecard'),
                        placeHolder: this.translateService.select('borrower.fields.score', 'scorecard'),
                        isDisabled: true,
                        fullWidth: true,
                    },
                },
                {
                    key: 'interest_range_recommendation',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-full',
                    context: {
                        defaultValue: '',
                        label: this.translateService.select('borrower.fields.interest_range_recommendation', 'scorecard'),
                        placeHolder: this.translateService.select('borrower.fields.interest_range_recommendation', 'scorecard'),
                        isDisabled: true,
                        fullWidth: true,
                    },
                },
                {
                    key: 'rating',
                    type: FSWDynamicBuilderControlTypes.TEMPLATE,
                    context: {
                        isHidden: true,
                    },
                },
            ],
        });
        effect(() => {
            if (!this.applicationId()) {
                return;
            }
            if (this.refreshedAt()) {
                this.effects.refresh(this.applicationId());
            }
        }, { allowSignalWrites: true });
        effect(() => {
            const scorecard = this.scorecard();
            this.scorecardGroup.reset({
                ...(scorecard || {}),
                borrower_name: this.scorecardGroup.getRawValue().borrower_name,
            });
            this.scoringGroup.reset(scorecard
                ? (scorecard.factors || []).reduce((acc, cur) => ({
                    ...acc,
                    [cur.factor]: cur.value,
                }), {})
                : {});
        }, { allowSignalWrites: true });
        effect(() => {
            this.applicationMemberService
                .getApplicationMembersInformation(this.applicationId(), { type: ApplicationMemberType.MAIN }, {
                country_code: getCountryCodeFromStorage(),
                member_type_code: MemberCode.BORROWER,
            })
                .pipe(take(1), tap((members) => {
                this.scorecardGroup.patchValue({
                    borrower_name: this.__getBorrowerName(members[0]),
                });
            }))
                .subscribe();
        }, { allowSignalWrites: true });
        effect(() => {
            this.settingService
                .getSettingsByKey(this.productUPI() || '')
                .pipe(take(1), tap((settings) => this.products.set(settings?.score_card_products || [])))
                .subscribe();
        }, { allowSignalWrites: true });
        effect(() => {
            const value = this.selectedRating();
            Object.keys(this.scoringGroup.controls).forEach((key) => this.scoringGroup.removeControl(key));
            this.scoringGroup.updateValueAndValidity();
            if (!value) {
                return;
            }
            const product = untracked(() => this.products())?.find((product) => product.name === untracked(() => this.selectedProduct()));
            const rating = product?.factors?.find((factor) => factor.rating === value);
            if (!rating?.identifiers?.length) {
                return;
            }
            this.service
                .getScorecardFactors(rating.identifiers)
                .pipe(take(1), tap((factors) => this.factors.set(factors || [])))
                .subscribe();
        }, { allowSignalWrites: true });
        effect(() => {
            const factors = this.factors();
            const groupOfFactors = groupBy(factors, 'category');
            factors?.forEach((factor) => {
                this.scoringGroup.addControl(factor.identifier, new UntypedFormControl(factor.options[0], [Validators.required]));
            });
            this.factorGroups.set(Object.keys(groupOfFactors).map((category) => ({
                category,
                factors: groupOfFactors[category],
            })));
        }, { allowSignalWrites: true });
        effect(() => {
            const products = this.products();
            this.scorecardGroup.patchValue({
                product_type: products?.[0]?.name || null,
            });
        }, { allowSignalWrites: true });
        effect(() => {
            const selectedProduct = this.selectedProduct();
            const product = untracked(() => this.products())?.find((product) => product.name === selectedProduct);
            this.ratingTypes.set(product?.ratings || []);
        }, { allowSignalWrites: true });
        effect(() => {
            this.scorecardGroup.patchValue({
                rating_type: this.ratingTypes()?.[0],
            });
        }, { allowSignalWrites: true });
    }
    save() {
        if (this.isReadonly()) {
            this.alertService.warning('Warning', 'This action will be prevent because you are in readonly mode', {
                duration: 3000,
            });
            return;
        }
        if (this.scorecardGroup.invalid || this.scoringGroup.invalid) {
            this.alertService.warning('Warning', 'This action will be prevent because still have invalid information', {
                duration: 3000,
            });
            return;
        }
        this.effects.create(this.applicationId(), {
            ...omit(this.scorecardGroup.getRawValue(), ['borrower_name']),
            factors: this.__getFactorRequest(),
        });
    }
    getFactorScore(identifier) {
        return (this.scorecard()
            ?.factors?.find((factor) => factor.factor === identifier)
            ?.score?.toString() || '--');
    }
    getFactorControl(identifier) {
        return this.scoringGroup.get(identifier);
    }
    __getBorrowerName(member) {
        const isCompany = member.member_entity_type_id === MemberTypeId.COMPANY.toString() ||
            member.member_entity_code === MemberEntityCode.CORPORATE;
        const name = isCompany ? member?.company_name || member?.company_email : '';
        return name || member?.fullname || member?.user_name || member?.username || '';
    }
    __getFactorRequest() {
        const factors = this.factors();
        return (factors?.map((factor) => ({
            factor: factor.identifier,
            value: this.scoringGroup.get(factor.identifier)?.value || '',
        })) || []);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWScorecardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWScorecardComponent, isStandalone: true, selector: "fsw-scorecard", outputs: { updated: "updated" }, providers: [provideScorecardTranslation()], ngImport: i0, template: "<fsw-panel customClasses=\"w-full\" [title]=\"'title' | fswTranslate\">\n  <ng-template fswPanelHeaderSuffix>\n    <button\n      fswButton\n      appearance=\"primary\"\n      *ngIf=\"!isReadonly()\"\n      [disabled]=\"scoringGroup.invalid || scorecardGroup.invalid\"\n      (click)=\"save()\"\n    >\n      {{ 'buttons.save' | fswTranslate }}\n    </button>\n  </ng-template>\n  <section class=\"w-full flex flex-col gap-[32px]\">\n    <section class=\"flex gap-[32px] w-full\">\n      <fsw-panel customClasses=\"w-[500px]\" [title]=\"'borrower.title' | fswTranslate\">\n        <form [formGroup]=\"scorecardGroup\">\n          <fsw-dynamic-builder [builder]=\"scorecardBuilder\"></fsw-dynamic-builder>\n        </form>\n      </fsw-panel>\n      <fsw-panel customClasses=\"w-[200px]\" [title]=\"'score' | fswTranslate\">\n        <h1 class=\"h1 font-bold text-gray-900\">\n          {{ scorecardGroup.get('rating')?.value || '-' }}\n        </h1>\n      </fsw-panel>\n    </section>\n    <fsw-panel customClasses=\"w-full scrolling\" [title]=\"'table.title' | fswTranslate\">\n      <table class=\"fsw-table fsw-table--bordered w-full\">\n        <thead>\n          <tr>\n            <th class=\"w-[60%]\">{{ 'table.columns.factor' | fswTranslate }}</th>\n            <th class=\"w-[30%]\">{{ 'table.columns.picklist' | fswTranslate }}</th>\n            <th class=\"w-[10%]\">{{ 'table.columns.score' | fswTranslate }}</th>\n          </tr>\n        </thead>\n        <tbody>\n          <ng-container *ngFor=\"let factorGroup of factorGroups()\">\n            <tr class=\"bg-gray-200\">\n              <td class=\"!font-semibold\">{{ factorGroup.category }}</td>\n              <td></td>\n              <td></td>\n            </tr>\n            <ng-container *ngFor=\"let factor of factorGroup.factors\">\n              <tr>\n                <td class=\"whitespace-normal align-middle\">{{ factor.description }}</td>\n                <td class=\"align-middle\">\n                  <fsw-field\n                    *ngIf=\"getFactorControl(factor.identifier) as control\"\n                    [fullWidth]=\"true\"\n                    [disabled]=\"isReadonly()\"\n                  >\n                    <fsw-select\n                      [maxHeight]=\"'300px'\"\n                      [closeOnSelected]=\"true\"\n                      [formControl]=\"control | fswForceControl\"\n                      [disabled]=\"isReadonly()\"\n                    >\n                      <ng-container *ngFor=\"let option of factor.options\">\n                        <ng-template\n                          fswSelectItem\n                          [text]=\"option\"\n                          [value]=\"option\"\n                          [icon]=\"'checkbox'\"\n                        ></ng-template>\n                      </ng-container>\n                    </fsw-select>\n                  </fsw-field>\n                </td>\n                <td class=\"align-middle\">{{ getFactorScore(factor.identifier) }}</td>\n              </tr>\n            </ng-container>\n          </ng-container>\n        </tbody>\n      </table>\n    </fsw-panel>\n  </section>\n</fsw-panel>\n", styles: [":host{display:contents}:is() .scrolling>main{overflow:auto}\n"], dependencies: [{ kind: "ngmodule", type: ApplicationScorecardServiceModule }, { kind: "ngmodule", type: ScorecardServiceModule }, { kind: "ngmodule", type: SettingsServiceModule }, { kind: "ngmodule", type: ApplicationMemberServiceModule }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: FSWAlertModule }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: FSWDynamicBuilderModule }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "ngmodule", type: FSWFieldModule }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "ngmodule", type: FSWSelectModule }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "ngmodule", type: ForceControlPipeModule }, { kind: "pipe", type: i1$4.FSWForceControlPipe, name: "fswForceControl" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
};
FSWScorecardComponent = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [])
], FSWScorecardComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWScorecardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-scorecard', standalone: true, changeDetection: ChangeDetectionStrategy.OnPush, providers: [provideScorecardTranslation()], imports: [
                        ApplicationScorecardServiceModule,
                        ScorecardServiceModule,
                        SettingsServiceModule,
                        ApplicationMemberServiceModule,
                        FSWTranslateModule,
                        FSWAlertModule,
                        FSWPanelModule,
                        FSWButtonModule,
                        NgIf,
                        ReactiveFormsModule,
                        FSWDynamicBuilderModule,
                        NgForOf,
                        FSWFieldModule,
                        FSWSelectModule,
                        ForceControlPipeModule,
                    ], template: "<fsw-panel customClasses=\"w-full\" [title]=\"'title' | fswTranslate\">\n  <ng-template fswPanelHeaderSuffix>\n    <button\n      fswButton\n      appearance=\"primary\"\n      *ngIf=\"!isReadonly()\"\n      [disabled]=\"scoringGroup.invalid || scorecardGroup.invalid\"\n      (click)=\"save()\"\n    >\n      {{ 'buttons.save' | fswTranslate }}\n    </button>\n  </ng-template>\n  <section class=\"w-full flex flex-col gap-[32px]\">\n    <section class=\"flex gap-[32px] w-full\">\n      <fsw-panel customClasses=\"w-[500px]\" [title]=\"'borrower.title' | fswTranslate\">\n        <form [formGroup]=\"scorecardGroup\">\n          <fsw-dynamic-builder [builder]=\"scorecardBuilder\"></fsw-dynamic-builder>\n        </form>\n      </fsw-panel>\n      <fsw-panel customClasses=\"w-[200px]\" [title]=\"'score' | fswTranslate\">\n        <h1 class=\"h1 font-bold text-gray-900\">\n          {{ scorecardGroup.get('rating')?.value || '-' }}\n        </h1>\n      </fsw-panel>\n    </section>\n    <fsw-panel customClasses=\"w-full scrolling\" [title]=\"'table.title' | fswTranslate\">\n      <table class=\"fsw-table fsw-table--bordered w-full\">\n        <thead>\n          <tr>\n            <th class=\"w-[60%]\">{{ 'table.columns.factor' | fswTranslate }}</th>\n            <th class=\"w-[30%]\">{{ 'table.columns.picklist' | fswTranslate }}</th>\n            <th class=\"w-[10%]\">{{ 'table.columns.score' | fswTranslate }}</th>\n          </tr>\n        </thead>\n        <tbody>\n          <ng-container *ngFor=\"let factorGroup of factorGroups()\">\n            <tr class=\"bg-gray-200\">\n              <td class=\"!font-semibold\">{{ factorGroup.category }}</td>\n              <td></td>\n              <td></td>\n            </tr>\n            <ng-container *ngFor=\"let factor of factorGroup.factors\">\n              <tr>\n                <td class=\"whitespace-normal align-middle\">{{ factor.description }}</td>\n                <td class=\"align-middle\">\n                  <fsw-field\n                    *ngIf=\"getFactorControl(factor.identifier) as control\"\n                    [fullWidth]=\"true\"\n                    [disabled]=\"isReadonly()\"\n                  >\n                    <fsw-select\n                      [maxHeight]=\"'300px'\"\n                      [closeOnSelected]=\"true\"\n                      [formControl]=\"control | fswForceControl\"\n                      [disabled]=\"isReadonly()\"\n                    >\n                      <ng-container *ngFor=\"let option of factor.options\">\n                        <ng-template\n                          fswSelectItem\n                          [text]=\"option\"\n                          [value]=\"option\"\n                          [icon]=\"'checkbox'\"\n                        ></ng-template>\n                      </ng-container>\n                    </fsw-select>\n                  </fsw-field>\n                </td>\n                <td class=\"align-middle\">{{ getFactorScore(factor.identifier) }}</td>\n              </tr>\n            </ng-container>\n          </ng-container>\n        </tbody>\n      </table>\n    </fsw-panel>\n  </section>\n</fsw-panel>\n", styles: [":host{display:contents}:is() .scrolling>main{overflow:auto}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { updated: [{
                type: Output
            }] } });

var FSWScorecardDirective_1;
let FSWScorecardDirective = class FSWScorecardDirective {
    static { FSWScorecardDirective_1 = this; }
    static { this.REFRESH_KEY = 'fs-widgets-feature-scorecard'; }
    constructor(_refreshService, _viewContainerRef) {
        this._refreshService = _refreshService;
        this._viewContainerRef = _viewContainerRef;
        this.updated = new EventEmitter();
        this.applicationId = null;
        this.productUPI = getCurrentCountryConfig().product_upi;
        this.isReadonly = false;
    }
    ngOnInit() {
        this._refreshService
            .register(FSWScorecardDirective_1.REFRESH_KEY)
            .pipe(followDestroy(this), tap(() => this.refresh()))
            .subscribe();
    }
    ngOnChanges() {
        this.refresh();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    refresh() {
        this._viewContainerRef.clear();
        if (!this.applicationId) {
            return;
        }
        const ref = this._viewContainerRef.createComponent(FSWScorecardComponent);
        const instance = ref.instance;
        instance.applicationId.set(this.applicationId);
        instance.isReadonly.set(this.isReadonly);
        instance.productUPI.set(this.productUPI);
        instance.updated
            .asObservable()
            .pipe(followDestroy(this), tap((scorecard) => this.updated.emit(scorecard)))
            .subscribe();
        ref.changeDetectorRef.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWScorecardDirective, deps: [{ token: RefreshService }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWScorecardDirective, isStandalone: true, selector: "[fswScorecard]", inputs: { applicationId: "applicationId", productUPI: "productUPI", isReadonly: "isReadonly" }, outputs: { updated: "updated" }, usesOnChanges: true, ngImport: i0 }); }
};
FSWScorecardDirective = FSWScorecardDirective_1 = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [RefreshService,
        ViewContainerRef])
], FSWScorecardDirective);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWScorecardDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswScorecard]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: RefreshService }, { type: i0.ViewContainerRef }]; }, propDecorators: { updated: [{
                type: Output
            }], applicationId: [{
                type: Input,
                args: [{ required: true }]
            }], productUPI: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

var title$3 = "Pre-screening Results";
var sub_title = "Screening Results";
var columns$1 = {
	item: "Item",
	result: "Result",
	remarks: "Remarks",
	justification: "Justification"
};
var stages = {
	borrower: "Pre-screening 1: Basic Check",
	ctos: "Pre-screening 2: CTOS",
	bank: "Pre-screening 3: Bank Statements",
	finance: "Pre-screening 4: Financial Statements"
};
var buttons$8 = {
	save: "Save",
	edit: "Edit"
};
var my = {
	title: title$3,
	sub_title: sub_title,
	columns: columns$1,
	stages: stages,
	buttons: buttons$8
};

var MY = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$8,
    columns: columns$1,
    default: my,
    stages: stages,
    sub_title: sub_title,
    title: title$3
});

const FSW_SCREENING_RESULT_TRANSLATION_LOADER = {
    [CountryCode.MY]: MY,
};

class FSWScreeningResultStore extends ComponentStore {
    constructor(_initialState, _creditService) {
        super(_initialState);
        this._initialState = _initialState;
        this._creditService = _creditService;
        this.loadAsync = this.effect(switchMap((applicationId) => {
            this.updateState({
                applicationId,
            });
            return forkJoin([
                this._creditService.upsert({
                    applicationId,
                    stageName: CreditScreeningResultStageNames.BORROWER,
                }),
                this._creditService.upsert({
                    applicationId,
                    stageName: CreditScreeningResultStageNames.CTOS,
                }),
                this._creditService.upsert({
                    applicationId,
                    stageName: CreditScreeningResultStageNames.BANK,
                }),
                this._creditService.upsert({
                    applicationId,
                    stageName: CreditScreeningResultStageNames.FINANCE,
                }),
            ]).pipe(tap((data) => this.updateState({
                borrower: this.transformToGridItems(data[0]),
                ctos: this.transformToGridItems(data[1]),
                bank: this.transformToGridItems(data[2]),
                finance: this.transformToGridItems(data[3]),
            })));
        }));
        this.updateJustificationAsync = this.effect(switchMap(({ data, cb }) => {
            return this._creditService.updateJustification(data).pipe(tap(() => cb()));
        }));
        this.updateState = (value) => this.patchState({
            ...value,
        });
    }
    transformToGridItems(data) {
        return data.map((item) => ({
            id: item.id,
            order: item.factorOrder,
            item: item.factorName,
            result: item.result,
            remarks: item.remarks,
            justification: item.justification,
            description: item.factorDescription
                ? item.factorDescription.split('\n')
                : item.factors?.factorDescription
                    ? item.factors?.factorDescription?.split('\n')
                    : [],
        }));
    }
}

const FSW_SCREENING_RESULT_STORE_TOKEN = new InjectionToken('FSW_SCREENING_RESULT_STORE_TOKEN');

class FSWScreeningResultGridComponent {
    constructor(_componentStore, _alertService) {
        this._componentStore = _componentStore;
        this._alertService = _alertService;
        this.editableChange = new EventEmitter();
        this.title = '';
        this.data = [];
        this.editable = false;
    }
    save() {
        if (!this.data) {
            return;
        }
        const failedRow = this.data.filter((item) => item.result === 'fail' && !item.justification);
        if (failedRow.length) {
            this._alertService.error('Notification', 'Please add justification for failed results to complete the task', {
                duration: 2000,
                horizontalPosition: FSWAlertHorizontalPositions.END,
            });
            return;
        }
        const payload = this.data.map((item) => ({
            id: item.id,
            justification: item.justification,
        }));
        this._componentStore.updateJustificationAsync({
            data: payload,
            cb: () => {
                this.updateEditable(false);
                this._alertService.success('Notification', 'Screening Result successfully updated', {
                    duration: 2000,
                    horizontalPosition: FSWAlertHorizontalPositions.END,
                });
            },
        });
    }
    updateEditable(value) {
        this.editable = value;
        this.editableChange.emit(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWScreeningResultGridComponent, deps: [{ token: FSW_SCREENING_RESULT_STORE_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWScreeningResultGridComponent, selector: "fsw-screening-result-grid", inputs: { title: "title", data: "data", editable: "editable" }, outputs: { editableChange: "editableChange" }, ngImport: i0, template: "<section class=\"screening-result-grid\">\n  <header>\n    <h5 class=\"h5\">{{ title }}</h5>\n  </header>\n  <main>\n    <header>\n      <h6 class=\"h6\">{{ 'sub_title' | fswTranslate }}</h6>\n      <ng-container *ngIf=\"editable; else editTemplate\">\n        <button fswButton (click)=\"save()\">{{ 'buttons.save' | fswTranslate }}</button>\n      </ng-container>\n      <ng-template #editTemplate>\n        <button fswButton appearance=\"icon-no-bg\" (click)=\"updateEditable(true)\">\n          <i [fswIcon]=\"'common-edit'\"></i>\n        </button>\n      </ng-template>\n    </header>\n    <table class=\"fsw-table\">\n      <thead>\n        <tr>\n          <th>{{ 'columns.item' | fswTranslate }}</th>\n          <th>{{ 'columns.result' | fswTranslate }}</th>\n          <th>{{ 'columns.remarks' | fswTranslate }}</th>\n          <th>{{ 'columns.justification' | fswTranslate }}</th>\n        </tr>\n      </thead>\n      <tbody>\n        <ng-container *ngFor=\"let item of data\">\n          <tr>\n            <td>\n              <div>\n                <h6 class=\"h6\">{{ item.item }}</h6>\n                <div class=\"screening-result-grid__sentence\">\n                  <ng-container *ngFor=\"let des of item.description\">\n                    <p>{{ des }}</p>\n                  </ng-container>\n                </div>\n              </div>\n            </td>\n            <td>\n              <fsw-tags\n                [hiddenCloseButton]=\"true\"\n                [color]=\"item.result === 'fail' ? 'red' : 'green'\"\n              >\n                {{ item.result.toUpperCase() }}\n              </fsw-tags>\n            </td>\n            <td>{{ item.remarks }}</td>\n            <td>\n              <fsw-field [readOnly]=\"!editable\">\n                <textarea fswInput [(ngModel)]=\"item.justification\" [rows]=\"4\"></textarea>\n              </fsw-field>\n            </td>\n          </tr>\n        </ng-container>\n      </tbody>\n    </table>\n  </main>\n</section>\n", styles: [":host .screening-result-grid{width:100%;display:flex;flex-direction:column;gap:12px}:host .screening-result-grid>main{width:100%;display:flex;flex-direction:column;gap:4px}:host .screening-result-grid>main>header{display:flex;align-items:center;justify-content:space-between;width:100%}:host .screening-result-grid>main>table{width:100%}:host .screening-result-grid__sentence{display:flex;flex-direction:column;gap:2px}:host .screening-result-grid__sentence p{width:300px;word-break:break-word;white-space:break-spaces}\n"], dependencies: [{ kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$4.FSWInputDirective, selector: "input[fswInput], textarea[fswInput]" }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i1$4.FSWTagsComponent, selector: "fsw-tags" }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWScreeningResultGridComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-screening-result-grid', changeDetection: ChangeDetectionStrategy.OnPush, template: "<section class=\"screening-result-grid\">\n  <header>\n    <h5 class=\"h5\">{{ title }}</h5>\n  </header>\n  <main>\n    <header>\n      <h6 class=\"h6\">{{ 'sub_title' | fswTranslate }}</h6>\n      <ng-container *ngIf=\"editable; else editTemplate\">\n        <button fswButton (click)=\"save()\">{{ 'buttons.save' | fswTranslate }}</button>\n      </ng-container>\n      <ng-template #editTemplate>\n        <button fswButton appearance=\"icon-no-bg\" (click)=\"updateEditable(true)\">\n          <i [fswIcon]=\"'common-edit'\"></i>\n        </button>\n      </ng-template>\n    </header>\n    <table class=\"fsw-table\">\n      <thead>\n        <tr>\n          <th>{{ 'columns.item' | fswTranslate }}</th>\n          <th>{{ 'columns.result' | fswTranslate }}</th>\n          <th>{{ 'columns.remarks' | fswTranslate }}</th>\n          <th>{{ 'columns.justification' | fswTranslate }}</th>\n        </tr>\n      </thead>\n      <tbody>\n        <ng-container *ngFor=\"let item of data\">\n          <tr>\n            <td>\n              <div>\n                <h6 class=\"h6\">{{ item.item }}</h6>\n                <div class=\"screening-result-grid__sentence\">\n                  <ng-container *ngFor=\"let des of item.description\">\n                    <p>{{ des }}</p>\n                  </ng-container>\n                </div>\n              </div>\n            </td>\n            <td>\n              <fsw-tags\n                [hiddenCloseButton]=\"true\"\n                [color]=\"item.result === 'fail' ? 'red' : 'green'\"\n              >\n                {{ item.result.toUpperCase() }}\n              </fsw-tags>\n            </td>\n            <td>{{ item.remarks }}</td>\n            <td>\n              <fsw-field [readOnly]=\"!editable\">\n                <textarea fswInput [(ngModel)]=\"item.justification\" [rows]=\"4\"></textarea>\n              </fsw-field>\n            </td>\n          </tr>\n        </ng-container>\n      </tbody>\n    </table>\n  </main>\n</section>\n", styles: [":host .screening-result-grid{width:100%;display:flex;flex-direction:column;gap:12px}:host .screening-result-grid>main{width:100%;display:flex;flex-direction:column;gap:4px}:host .screening-result-grid>main>header{display:flex;align-items:center;justify-content:space-between;width:100%}:host .screening-result-grid>main>table{width:100%}:host .screening-result-grid__sentence{display:flex;flex-direction:column;gap:2px}:host .screening-result-grid__sentence p{width:300px;word-break:break-word;white-space:break-spaces}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_SCREENING_RESULT_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }]; }, propDecorators: { editableChange: [{
                type: Output
            }], title: [{
                type: Input
            }], data: [{
                type: Input
            }], editable: [{
                type: Input
            }] } });

class FSWScreeningResultStoreMY extends FSWScreeningResultStore {
    constructor(creditService) {
        super({
            applicationId: null,
            borrower: [],
            ctos: [],
            finance: [],
            bank: [],
        }, creditService);
        this.creditService = creditService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWScreeningResultStoreMY, deps: [{ token: CREDIT_SCREENING_RESULT_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWScreeningResultStoreMY }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWScreeningResultStoreMY, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CREDIT_SCREENING_RESULT_SERVICE_TOKEN]
                }] }]; } });

const FSW_SCREENING_RESULT_MY_PROVIDERS = [
    {
        provide: FSW_SCREENING_RESULT_STORE_TOKEN,
        useClass: FSWScreeningResultStoreMY,
        deps: [CREDIT_SCREENING_RESULT_SERVICE_TOKEN],
    },
];

const FSW_SCREENING_RESULT_PROVIDERS = {
    default: FSW_SCREENING_RESULT_MY_PROVIDERS,
    [CountryCode.MY]: FSW_SCREENING_RESULT_MY_PROVIDERS,
};
const screeningResultLoadProviders = (countryCode) => [
    fswTranslateScope('screening_result'),
    ...getCustomProviders(FSW_SCREENING_RESULT_PROVIDERS, FSW_SCREENING_RESULT_MY_PROVIDERS, countryCode),
];

class FSWScreeningResultComponent {
    constructor(_componentStore) {
        this._componentStore = _componentStore;
        this.applicationId = null;
        this.state$ = this._componentStore.state$;
    }
    ngOnInit() {
        if (!this.applicationId) {
            return;
        }
        this._componentStore.loadAsync(this.applicationId);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWScreeningResultComponent, deps: [{ token: FSW_SCREENING_RESULT_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWScreeningResultComponent, selector: "fsw-screening-result", inputs: { applicationId: "applicationId" }, ngImport: i0, template: "<section class=\"screening-result\">\n  <header>\n    <h3 class=\"h3\">{{ 'title' | fswTranslate }}</h3>\n  </header>\n  <main *ngIf=\"state$ | async as state\">\n    <fsw-screening-result-grid\n      [data]=\"state.borrower\"\n      [title]=\"'stages.borrower' | fswTranslate\"\n    ></fsw-screening-result-grid>\n    <fsw-screening-result-grid\n      [data]=\"state.ctos\"\n      [title]=\"'stages.ctos' | fswTranslate\"\n    ></fsw-screening-result-grid>\n    <fsw-screening-result-grid\n      [data]=\"state.bank\"\n      [title]=\"'stages.bank' | fswTranslate\"\n    ></fsw-screening-result-grid>\n    <fsw-screening-result-grid\n      [data]=\"state.finance\"\n      [title]=\"'stages.finance' | fswTranslate\"\n    ></fsw-screening-result-grid>\n  </main>\n</section>\n", styles: [":host .screening-result{display:flex;flex-direction:column;gap:8px;width:100%}:host .screening-result>header{display:flex;align-items:center;justify-content:space-between;width:100%}:host .screening-result>main{width:100%;border-radius:4px;border:1px solid #adadad;padding:20px;display:flex;flex-direction:column;gap:20px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FSWScreeningResultGridComponent, selector: "fsw-screening-result-grid", inputs: ["title", "data", "editable"], outputs: ["editableChange"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWScreeningResultComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-screening-result', changeDetection: ChangeDetectionStrategy.OnPush, template: "<section class=\"screening-result\">\n  <header>\n    <h3 class=\"h3\">{{ 'title' | fswTranslate }}</h3>\n  </header>\n  <main *ngIf=\"state$ | async as state\">\n    <fsw-screening-result-grid\n      [data]=\"state.borrower\"\n      [title]=\"'stages.borrower' | fswTranslate\"\n    ></fsw-screening-result-grid>\n    <fsw-screening-result-grid\n      [data]=\"state.ctos\"\n      [title]=\"'stages.ctos' | fswTranslate\"\n    ></fsw-screening-result-grid>\n    <fsw-screening-result-grid\n      [data]=\"state.bank\"\n      [title]=\"'stages.bank' | fswTranslate\"\n    ></fsw-screening-result-grid>\n    <fsw-screening-result-grid\n      [data]=\"state.finance\"\n      [title]=\"'stages.finance' | fswTranslate\"\n    ></fsw-screening-result-grid>\n  </main>\n</section>\n", styles: [":host .screening-result{display:flex;flex-direction:column;gap:8px;width:100%}:host .screening-result>header{display:flex;align-items:center;justify-content:space-between;width:100%}:host .screening-result>main{width:100%;border-radius:4px;border:1px solid #adadad;padding:20px;display:flex;flex-direction:column;gap:20px}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_SCREENING_RESULT_STORE_TOKEN]
                }] }]; }, propDecorators: { applicationId: [{
                type: Input
            }] } });

class FSwScreeningResultDirective {
    constructor(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
        this.applicationId = null;
    }
    ngOnChanges() {
        const ref = this._viewContainerRef.createComponent(FSWScreeningResultComponent, {
            injector: Injector.create({
                parent: this._viewContainerRef.injector,
                providers: screeningResultLoadProviders(getCountryCodeFromStorage()),
            }),
        });
        const instance = ref.instance;
        instance.applicationId = this.applicationId;
        ref.changeDetectorRef.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSwScreeningResultDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSwScreeningResultDirective, selector: "[fswScreeningResult]", inputs: { applicationId: "applicationId" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSwScreeningResultDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswScreeningResult]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; }, propDecorators: { applicationId: [{
                type: Input
            }] } });

class FSWScreeningResultModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWScreeningResultModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWScreeningResultModule, declarations: [FSwScreeningResultDirective,
            FSWScreeningResultComponent,
            FSWScreeningResultGridComponent], imports: [i1$4.FSWTranslateModule, FSWButtonModule,
            NgIf,
            FSWFieldModule,
            FSWInputModule,
            ReactiveFormsModule,
            FSWButtonModule,
            FSWButtonModule,
            AsyncPipe,
            NgForOf,
            FormsModule,
            FSWTagsModule,
            CreditScreeningResultServiceModule,
            FSWIconModule,
            FSWAlertModule], exports: [FSwScreeningResultDirective,
            FSWScreeningResultComponent,
            FSWScreeningResultGridComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWScreeningResultModule, imports: [FSWTranslateModule.forFeature({
                scope: 'screening_result',
                defaultKey: CountryCode.MY,
                data: FSW_SCREENING_RESULT_TRANSLATION_LOADER,
            }),
            FSWButtonModule,
            FSWFieldModule,
            FSWInputModule,
            ReactiveFormsModule,
            FSWButtonModule,
            FSWButtonModule,
            FormsModule,
            FSWTagsModule,
            CreditScreeningResultServiceModule,
            FSWIconModule,
            FSWAlertModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWScreeningResultModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FSwScreeningResultDirective,
                        FSWScreeningResultComponent,
                        FSWScreeningResultGridComponent,
                    ],
                    exports: [
                        FSwScreeningResultDirective,
                        FSWScreeningResultComponent,
                        FSWScreeningResultGridComponent,
                    ],
                    imports: [
                        FSWTranslateModule.forFeature({
                            scope: 'screening_result',
                            defaultKey: CountryCode.MY,
                            data: FSW_SCREENING_RESULT_TRANSLATION_LOADER,
                        }),
                        FSWButtonModule,
                        NgIf,
                        FSWFieldModule,
                        FSWInputModule,
                        ReactiveFormsModule,
                        FSWButtonModule,
                        FSWButtonModule,
                        AsyncPipe,
                        NgForOf,
                        FormsModule,
                        FSWTagsModule,
                        CreditScreeningResultServiceModule,
                        FSWIconModule,
                        FSWAlertModule,
                    ],
                }]
        }] });

const SITE_VISIT_STORE_TOKEN = new InjectionToken('SITE_VISIT_STORE_TOKEN');

var SiteVisitDocTypes;
(function (SiteVisitDocTypes) {
    SiteVisitDocTypes["SV_REPORT"] = "SITE_VISIT_RPT";
    SiteVisitDocTypes["SV_PHOTO"] = "SITE_VISIT_PHOTO";
    SiteVisitDocTypes["SV_OTHERS"] = "OTHERS";
})(SiteVisitDocTypes || (SiteVisitDocTypes = {}));
var SiteVisitMapKey;
(function (SiteVisitMapKey) {
    SiteVisitMapKey["LABEL"] = "label";
})(SiteVisitMapKey || (SiteVisitMapKey = {}));

const SITE_VISIT_DOC_MAP = {
    [`${SiteVisitDocTypes.SV_REPORT}`]: {
        [`${SiteVisitMapKey.LABEL}`]: 'Site Visit Report',
    },
    [`${SiteVisitDocTypes.SV_PHOTO}`]: {
        [`${SiteVisitMapKey.LABEL}`]: 'Site Visit Photo',
    },
    [`${SiteVisitDocTypes.SV_OTHERS}`]: {
        [`${SiteVisitMapKey.LABEL}`]: 'Site Visit Others',
    },
};

const SITE_VISIT_ALLOWED_FILE_EXT = ['pdf', 'jpeg', 'jpg', 'png'];

let SiteVisitStore = class SiteVisitStore extends ComponentStore {
    get allowedDocumentTypes() {
        return Object.values(SiteVisitDocTypes).filter((value) => !this.state().notAllowedDocumentTypes.includes(value));
    }
    constructor(_memberDocService, _docManagerService, _stateOverride = {}) {
        super({
            countryId: null,
            applicationId: null,
            isReadonly: false,
            memberIds: [],
            documentTypes: [],
            memberDocs: [],
            documents: [],
            selectedDocument: null,
            errors: [],
            notAllowedDocumentTypes: [],
            ..._stateOverride,
        });
        this._memberDocService = _memberDocService;
        this._docManagerService = _docManagerService;
        this._stateOverride = _stateOverride;
        // effect called from site-visit-default.store.ts
        this.getSupportedDocTypes = this.effect(pipe(switchMap(() => this._getSupportedDocTypesAsync())));
        // effect called from site-visit-default.store.ts
        this.getAllDocs = this.effect(pipe(switchMap(() => this._getMemberDocsAsync()), map((docs) => (docs || []).map((d) => d.dms_id)), switchMap((dmsIds) => iif(() => !!(dmsIds && dmsIds.length), this._getDocsFromDocManagerAsync(dmsIds), this._setWhenNoDocuments())), tap((docs) => {
            const map = {};
            docs.forEach((doc) => {
                map[doc.id] = { ...doc };
            });
            this.setDocuments(this.state().memberDocs.map((m) => ({ ...m, doc_name: map[m.dms_id].name })));
        })));
        // effect called from site-visit.component.ts
        this.uploadSingleDocument = this.effect(pipe(switchMap((payload) => this._uploadSingleDocumentAsync({ ...payload, member_ids: this.get().memberIds })), tap(() => this.getAllDocs()), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        // effect called from site-visit.component.ts
        this.uploadMultipleDocuments = this.effect(pipe(switchMap((payload) => this._uploadMultipleDocumentsAsync({ ...payload, member_ids: this.get().memberIds })), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        // effect called from site-visit.component.ts
        this.downloadSingleDocument = this.effect(pipe(switchMap((doc) => this._downloadSingleDocumentAsync(doc)), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        // effect called from site-visit.component.ts
        this.deleteSingleDocument = this.effect(pipe(switchMap((doc) => this._deleteSingleDocumentAsync(doc)), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
    }
    // setter for applicationId
    setApplicationId(data) {
        const updater = this.updater((state, applicationId) => ({
            ...state,
            applicationId,
        }));
        updater(data);
    }
    // setter for isReadonly
    setIsReadonly(data) {
        const updater = this.updater((state, isReadonly) => ({
            ...state,
            isReadonly,
        }));
        updater(data);
    }
    // setter for memberIds
    setMemberIds(data) {
        const updater = this.updater((state, member_ids) => ({
            ...state,
            memberIds: member_ids,
        }));
        updater(data);
    }
    // setter for documentTypes
    setDocumentTypes(data) {
        const updater = this.updater((state, documentTypes) => ({
            ...state,
            documentTypes,
        }));
        updater(data);
    }
    // setter for notAllowedDocumentTypes
    setNotAllowedDocumentTypes(data) {
        const updater = this.updater((state, notAllowedDocumentTypes) => ({
            ...state,
            notAllowedDocumentTypes,
        }));
        updater(data);
    }
    // setter for memberDocs
    setMemberDocs(data) {
        const updater = this.updater((state, memberDocs) => ({
            ...state,
            memberDocs,
        }));
        updater(data);
    }
    // setter for documents
    setDocuments(data) {
        const updater = this.updater((state, documents) => ({
            ...state,
            documents,
        }));
        updater(data);
    }
    // setter for selectedDocument
    setSelectedDocument(data) {
        const updater = this.updater((state, selectedDocument) => ({
            ...state,
            selectedDocument,
        }));
        updater(data);
    }
    // setter for errors
    setErrors(data) {
        const updater = this.updater((state, errors) => ({
            ...state,
            errors,
        }));
        updater(data);
    }
    _setWhenNoDocuments() {
        this.setDocuments([]);
        return EMPTY;
    }
    _getSupportedDocTypesAsync() {
        return of(this.allowedDocumentTypes).pipe(tap((data) => this.setDocumentTypes(data)));
    }
    _getMemberDocsAsync() {
        // getMemberDocs called to get the dms_id
        return this._memberDocService.getMemberDocs(this.state().applicationId).pipe(map((docs) => (docs || []).filter((d) => this.allowedDocumentTypes.includes(d.doc_type))), tap((data) => this.setMemberDocs(data)), catchError((err) => {
            console.error(err);
            this.setErrors([...this.state().errors, `[GET]: applications/applicationId/members/docs`]);
            return EMPTY;
        }));
    }
    _getDocsFromDocManagerAsync(dmsIds) {
        return this._docManagerService.getDocs(dmsIds).pipe(catchError((err) => {
            console.error(err);
            this.setErrors([...this.state().errors, `[GET]: /docs_management/v2/docs/`]);
            return EMPTY;
        }));
    }
    _uploadSingleDocumentAsync(payload) {
        const { file, doc_type, member_ids } = payload;
        return this._memberDocService
            .uploadSingleMemberDoc(this.state().applicationId, {
            file,
            doc_type,
            member_ids,
        })
            .pipe(catchError((err) => {
            console.error(err);
            this.setErrors([
                ...this.state().errors,
                `[POST]: applications/applicationId/members/docs`,
            ]);
            return EMPTY;
        }));
    }
    _uploadMultipleDocumentsAsync(payload) {
        const { files, doc_type, member_ids } = payload;
        const arr = Array.from(files).map((file) => {
            return this._memberDocService
                .uploadSingleMemberDoc(this.state().applicationId, {
                file,
                doc_type,
                member_ids,
            })
                .pipe(catchError((err) => {
                console.error(err);
                this.setErrors([
                    ...this.state().errors,
                    `[POST]: applications/applicationId/members/docs`,
                ]);
                return EMPTY;
            }));
        });
        return combineLatest([...arr]).pipe(tap(() => this.getAllDocs()), catchError((err) => {
            console.error(err);
            this.setErrors([...this.state().errors, `[POST]: applications/applicationId/members/docs`]);
            return EMPTY;
        }));
    }
    _downloadSingleDocumentAsync(doc) {
        if (!doc.dms_id)
            return EMPTY;
        return this._docManagerService.downloadSingleDoc(doc.dms_id).pipe(tap(() => this.setSelectedDocument(doc)), catchError((err) => {
            console.error(err);
            this.setErrors([...this.state().errors, `[GET]: /docs_management/v2/download`]);
            return EMPTY;
        }));
    }
    _deleteSingleDocumentAsync(doc) {
        return this._memberDocService
            .deleteMemberDoc(this.state().applicationId, doc.id)
            .pipe(switchMap(() => this._docManagerService.deleteSingleDoc(doc.dms_id).pipe(catchError((err) => {
            console.error(err);
            this.setErrors([...this.state().errors, `[DELETE]: docs_management/v2/docs/dmsId`]);
            return EMPTY;
        }))), tap(() => this.setSelectedDocument(null)), tap(() => this.getAllDocs()), catchError((err) => {
            console.error(err);
            this.setErrors([
                ...this.state().errors,
                `[DELETE]: applications/applicationId/members/docs/docId`,
            ]);
            return EMPTY;
        }));
    }
};
SiteVisitStore = __decorate([
    __param(0, Inject(MEMBER_DOC_SERVICE_TOKEN)),
    __param(1, Inject(DOC_MANAGER_SERVICE_TOKEN)),
    __metadata("design:paramtypes", [Object, Object, Object])
], SiteVisitStore);

class SiteVisitDefaultStore extends SiteVisitStore {
    constructor(_memberDocService, _docManagerService) {
        super(_memberDocService, _docManagerService, { countryId: FSWCountryCode.VU });
        this._memberDocService = _memberDocService;
        this._docManagerService = _docManagerService;
    }
    // called from site-visit.component.ts
    init() {
        // calling getSupportedDocTypes() present in site-visit.store.ts
        this.getSupportedDocTypes();
        // calling getAllDocs() present in site-visit.store.ts
        this.getAllDocs();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SiteVisitDefaultStore, deps: [{ token: MEMBER_DOC_SERVICE_TOKEN }, { token: DOC_MANAGER_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SiteVisitDefaultStore }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SiteVisitDefaultStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MEMBER_DOC_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOC_MANAGER_SERVICE_TOKEN]
                }] }]; } });

const siteVisitDefaultProviders = [
    {
        provide: SITE_VISIT_STORE_TOKEN,
        useClass: SiteVisitDefaultStore,
        deps: [MEMBER_DOC_SERVICE_TOKEN, DOC_MANAGER_SERVICE_TOKEN],
    },
];

class SiteVisitComponent {
    set applicationId(value) {
        this._store.setApplicationId(value);
    }
    set memberIds(value) {
        this._store.setMemberIds(value);
    }
    set isReadonly(value) {
        this._store.setIsReadonly(value);
    }
    set notAllowedDocumentTypes(value) {
        this._store.setNotAllowedDocumentTypes(value);
    }
    constructor(_store, _scope, _translateService, _modalService, _blobService) {
        this._store = _store;
        this._scope = _scope;
        this._translateService = _translateService;
        this._modalService = _modalService;
        this._blobService = _blobService;
        this.SiteVisitDocTypes = SiteVisitDocTypes;
        this.SITE_VISIT_DOC_MAP = SITE_VISIT_DOC_MAP;
        this.allowedFileExtList = SITE_VISIT_ALLOWED_FILE_EXT;
        this.documents$ = this._store.state$.pipe(map((s) => s.documents));
        this.selectedDocument$ = this._store.state$.pipe(map((s) => s.selectedDocument));
        this.documentTypes$ = this._store.state$.pipe(map((s) => s.documentTypes));
        this.translate$ = combineLatest([
            this._translateService.selectFeatureTranslate(this._scope, 'headings'),
            this._translateService.selectFeatureTranslate(this._scope, 'preview'),
            this._translateService.selectFeatureTranslate(this._scope, 'buttons'),
        ]).pipe(map(([headings, preview, buttons]) => ({ headings, preview, buttons })));
        this.vm$ = combineLatest([
            this._store.state$.pipe(map((s) => s.isReadonly)),
            this._store.state$.pipe(map((s) => s.documents)),
            this._store.state$.pipe(map((s) => s.selectedDocument)),
            this._store.state$.pipe(map((s) => s.documentTypes)),
            this.translate$,
        ]).pipe(map(([isReadonly, documents, selectedDocument, documentTypes, translate]) => ({
            isReadonly,
            documents,
            selectedDocument,
            documentTypes,
            translate,
        })));
    }
    ngOnInit() {
        // calling init() present in site-visit-default.store.ts
        this._store.init();
    }
    getSelectedFileExt(doc_name) {
        return doc_name.split('.').pop() || '';
    }
    getDocumentsByDocType(docType) {
        return this.documents$.pipe(map((docs) => docs.filter((d) => d.doc_type === docType)));
    }
    uploadFile(data, doc_type) {
        // calling uploadMultipleDocuments() / uploadSingleDocument() present in site-visit.store.ts
        Array.from(data).length > 1
            ? this._store.uploadMultipleDocuments({
                files: data,
                doc_type,
                member_ids: [],
            })
            : this._store.uploadSingleDocument({
                file: data[0],
                doc_type,
                member_ids: [],
            });
    }
    selectFile(doc) {
        // calling downloadSingleDocument() present in site-visit.store.ts
        this._store.downloadSingleDocument(doc);
    }
    downloadFile(doc) {
        this._blobService
            .downloadBlob(doc?.dms_id)
            .pipe(take(1), tap((e) => downloadFileToLocal(URL.createObjectURL(e), doc?.doc_name)))
            .subscribe();
    }
    deleteFile(doc) {
        this._translateService
            .selectFeatureTranslate(this._scope, 'dialogs')
            .pipe(take(1), switchMap(({ headings, buttons }) => this._modalService
            .open(FSWConfirmDialogComponent, {
            size: ModalSizes.S,
            data: {
                title: headings.title,
                cancel: buttons.cancel,
                delete: buttons.accept,
                description: headings.subTitle,
            },
        })
            .pipe(take(1), tap((value) => {
            if (value) {
                // calling deleteSingleDocument() present in site-visit.store.ts
                this._store.deleteSingleDocument(doc);
            }
        }))))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SiteVisitComponent, deps: [{ token: SITE_VISIT_STORE_TOKEN }, { token: TRANSLOCO_SCOPE }, { token: TranslocoFeatureHttpLoader }, { token: MODAL_SERVICE }, { token: BLOB_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: SiteVisitComponent, selector: "fsw-site-visit", inputs: { applicationId: "applicationId", memberIds: "memberIds", isReadonly: "isReadonly", notAllowedDocumentTypes: "notAllowedDocumentTypes" }, ngImport: i0, template: "<ng-container *ngIf=\"vm$ | async as vm\">\n  <ng-container>\n    <div class=\"site-visit\">\n      <div class=\"site-visit__upload\">\n        <div>\n          <h6>{{ vm.translate.headings.title }}</h6>\n          <span class=\"site-visit__sub\">{{ vm.translate.headings.subTitle }}</span>\n        </div>\n        <ng-container *ngIf=\"vm.documentTypes\">\n          <ng-container *ngFor=\"let docType of vm.documentTypes\">\n            <div class=\"document\">\n              <span class=\"document__label\">{{ SITE_VISIT_DOC_MAP[docType].label }}</span>\n              <ng-container *ngFor=\"let file of getDocumentsByDocType(docType) | async\">\n                <div class=\"document__control\">\n                  <div class=\"document__file\">\n                    <div\n                      class=\"checkmark draw\"\n                      [ngClass]=\"{\n                        checkmark__show: file.id === vm.selectedDocument?.id\n                      }\"\n                    ></div>\n                    <div class=\"document__name\">\n                      <span (click)=\"selectFile(file)\">{{ file?.doc_name }}</span>\n                    </div>\n                  </div>\n                  <div class=\"document__icons\" *ngIf=\"!vm.isReadonly\">\n                    <div (click)=\"downloadFile(file)\">\n                      <svg\n                        width=\"22\"\n                        height=\"22\"\n                        viewBox=\"0 0 22 22\"\n                        fill=\"none\"\n                        xmlns=\"http://www.w3.org/2000/svg\"\n                      >\n                        <path\n                          fill-rule=\"evenodd\"\n                          clip-rule=\"evenodd\"\n                          d=\"M11 0.875C11.6213 0.875 12.125 1.37868 12.125 2V11.7843L15.2048 8.70451C15.6441 8.26517 16.3564 8.26517 16.7957 8.70451C17.2351 9.14385 17.2351 9.85616 16.7957 10.2955L11.7957 15.2955C11.5848 15.5065 11.2986 15.625 11.0002 15.625C10.7019 15.625 10.4157 15.5065 10.2047 15.2955L5.20475 10.2955C4.76541 9.85616 4.76541 9.14385 5.20475 8.70451C5.64409 8.26517 6.3564 8.26517 6.79574 8.70451L9.875 11.7838V2C9.875 1.37868 10.3787 0.875 11 0.875ZM2 12.875C2.62132 12.875 3.125 13.3787 3.125 14V18C3.125 18.2321 3.21719 18.4546 3.38128 18.6187C3.54538 18.7828 3.76794 18.875 4 18.875H18C18.2321 18.875 18.4546 18.7828 18.6187 18.6187C18.7828 18.4546 18.875 18.2321 18.875 18V14C18.875 13.3787 19.3787 12.875 20 12.875C20.6213 12.875 21.125 13.3787 21.125 14V18C21.125 18.8288 20.7958 19.6237 20.2097 20.2097C19.6237 20.7958 18.8288 21.125 18 21.125H4C3.1712 21.125 2.37634 20.7958 1.79029 20.2097C1.20424 19.6237 0.875 18.8288 0.875 18V14C0.875 13.3787 1.37868 12.875 2 12.875Z\"\n                          fill=\"#4A4A4A\"\n                        />\n                      </svg>\n                    </div>\n                    <div (click)=\"deleteFile(file)\">\n                      <svg\n                        width=\"10\"\n                        height=\"12\"\n                        viewBox=\"0 0 10 12\"\n                        fill=\"none\"\n                        xmlns=\"http://www.w3.org/2000/svg\"\n                      >\n                        <path\n                          d=\"M8.31037 3.29129L7.99919 10.7598C7.9931 10.9058 7.86315 11.0302 7.71606 11.0302H2.28577C2.13875 11.0302 2.00872 10.9055 2.00265 10.7598L1.69146 3.29129C1.68171 3.05719 1.48402 2.87532 1.24992 2.88508C1.01582 2.89483 0.833956 3.09251 0.84371 3.32661L1.1549 10.7951C1.17991 11.3954 1.68396 11.8786 2.28577 11.8786H7.71606C8.31752 11.8786 8.82189 11.3961 8.84694 10.7951L9.15812 3.32661C9.16788 3.09251 8.98601 2.89483 8.75191 2.88508C8.51781 2.87532 8.32013 3.05719 8.31037 3.29129Z\"\n                          fill=\"#4A4A4A\"\n                        />\n                        <path\n                          d=\"M4.66094 3.98804V9.75774C4.66094 9.94518 4.81289 10.0971 5.00034 10.0971C5.18778 10.0971 5.33973 9.94518 5.33973 9.75774V3.98804C5.33973 3.8006 5.18778 3.64865 5.00034 3.64865C4.81289 3.64865 4.66094 3.8006 4.66094 3.98804Z\"\n                          fill=\"#4A4A4A\"\n                        />\n                        <path\n                          d=\"M2.7944 3.99802L2.96409 9.76772C2.9696 9.95508 3.12596 10.1025 3.31332 10.097C3.50068 10.0915 3.6481 9.93513 3.64259 9.74776L3.47289 3.97807C3.46738 3.79071 3.31102 3.64329 3.12366 3.6488C2.9363 3.65431 2.78889 3.81066 2.7944 3.99802Z\"\n                          fill=\"#4A4A4A\"\n                        />\n                        <path\n                          d=\"M6.5281 3.97807L6.35841 9.74776C6.3529 9.93513 6.50031 10.0915 6.68768 10.097C6.87504 10.1025 7.03139 9.95508 7.0369 9.76772L7.2066 3.99802C7.21211 3.81066 7.06469 3.65431 6.87733 3.6488C6.68997 3.64329 6.53361 3.79071 6.5281 3.97807Z\"\n                          fill=\"#4A4A4A\"\n                        />\n                        <path\n                          d=\"M0.758227 2.29085H9.24308C9.47738 2.29085 9.66732 2.10091 9.66732 1.86661C9.66732 1.6323 9.47738 1.44236 9.24308 1.44236H0.758227C0.523924 1.44236 0.333984 1.6323 0.333984 1.86661C0.333984 2.10091 0.523924 2.29085 0.758227 2.29085Z\"\n                          fill=\"#4A4A4A\"\n                        />\n                        <path\n                          d=\"M3.71148 1.72867L3.88813 1.11038C3.92597 0.977949 4.09763 0.848485 4.23545 0.848485H5.76561C5.90351 0.848485 6.07505 0.977838 6.11292 1.11038L6.28958 1.72867L7.10542 1.49557L6.92876 0.877278C6.7868 0.380432 6.28229 0 5.76561 0H4.23545C3.71883 0 3.21421 0.380569 3.07229 0.877278L2.89564 1.49557L3.71148 1.72867Z\"\n                          fill=\"#4A4A4A\"\n                        />\n                      </svg>\n                    </div>\n                  </div>\n                </div>\n              </ng-container>\n              <fsw-upload\n                *ngIf=\"!vm.isReadonly\"\n                [buttonUploadLabel]=\"vm.translate.buttons.upload\"\n                (fileSelect)=\"uploadFile($event, docType)\"\n              ></fsw-upload>\n            </div>\n          </ng-container>\n        </ng-container>\n      </div>\n      <div\n        class=\"site-visit__viewers\"\n        [ngClass]=\"{\n          'site-visit__viewers--no-preview':\n            !vm.selectedDocument?.doc_name ||\n            !allowedFileExtList.includes(getSelectedFileExt(vm.selectedDocument?.doc_name || ''))\n        }\"\n      >\n        <ng-container *ngIf=\"!vm.selectedDocument?.doc_name; else afterDocIsSelected\">\n          <div class=\"site-visit__viewers--no-doc\">\n            <div>\n              <svg\n                width=\"60\"\n                height=\"68\"\n                viewBox=\"0 0 60 68\"\n                fill=\"none\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n              >\n                <path\n                  d=\"M50 0.552734V67.5918H10C4.47715 67.5918 0 63.0897 0 57.536L0 0.552734L50 0.552734Z\"\n                  fill=\"#F1F1F2\"\n                />\n                <rect x=\"10.0002\" y=\"9.77075\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <rect x=\"10.0002\" y=\"16.4746\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <rect x=\"10.0002\" y=\"23.1782\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <rect x=\"10.0002\" y=\"29.8826\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <rect x=\"10.0002\" y=\"36.5859\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <rect x=\"10.0002\" y=\"43.2903\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <rect x=\"10.0002\" y=\"49.9937\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <path\n                  d=\"M60.0001 59.2697V57.5359H15.0001V59.2119C15.0001 63.2933 12.0986 66.6931 8.25659 67.4394C8.82279 67.5395 9.4054 67.5918 10.0001 67.5918H51.7243C56.2949 67.5918 60.0001 63.8658 60.0001 59.2697Z\"\n                  fill=\"#CCCCCC\"\n                />\n              </svg>\n            </div>\n            <div>{{ vm.translate.preview.noDocSelected }}</div>\n          </div>\n        </ng-container>\n\n        <ng-template #afterDocIsSelected>\n          <div\n            class=\"site-visit__viewers--no-doc\"\n            *ngIf=\"\n              !allowedFileExtList.includes(getSelectedFileExt(vm.selectedDocument?.doc_name || ''))\n            \"\n          >\n            <div>\n              <svg\n                width=\"74\"\n                height=\"83\"\n                viewBox=\"0 0 74 83\"\n                fill=\"none\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n              >\n                <path\n                  d=\"M50.5 15.6467V82.6858H10.5C4.97715 82.6858 0.5 78.1837 0.5 72.63L0.5 15.6467L50.5 15.6467Z\"\n                  fill=\"#F1F1F2\"\n                />\n                <rect x=\"10.5\" y=\"24.8647\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <rect x=\"10.5\" y=\"31.5686\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <rect x=\"10.5\" y=\"38.2722\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <rect x=\"10.5\" y=\"44.9763\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <rect x=\"10.5\" y=\"51.6799\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <rect x=\"10.5\" y=\"58.3843\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <rect x=\"10.5\" y=\"65.0876\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <path\n                  d=\"M60.5001 74.3637V72.6299H15.5001V74.3059C15.5001 78.3872 12.5986 81.7871 8.75659 82.5334C9.32279 82.6335 9.9054 82.6857 10.5001 82.6857H52.2243C56.7949 82.6857 60.5001 78.9598 60.5001 74.3637Z\"\n                  fill=\"#CCCCCC\"\n                />\n                <path\n                  d=\"M34.7974 15.2142C30.9059 18.4392 28.5 21.6642 28.5 21.6642C28.5 21.6642 38.1256 34.5642 50 34.5642C51.4728 34.5642 52.9111 34.3653 54.3 34.0181M45.7344 9.30171C47.1126 8.95986 48.5402 8.76421 50 8.76421C61.8745 8.76421 71.5 21.6642 71.5 21.6642C71.5 21.6642 69.0931 24.8892 65.2026 28.1142M46.0375 18.0318C45.087 19.0636 44.5775 20.4262 44.6179 21.8286C44.6584 23.2309 45.2455 24.5619 46.254 25.5373C47.2624 26.5126 48.6123 27.055 50.0152 27.0486C51.4181 27.0422 52.763 26.4875 53.7625 25.503M69.35 41.0142L30.65 2.31421\"\n                  stroke=\"#ADADAD\"\n                  stroke-width=\"4\"\n                  stroke-linecap=\"round\"\n                  stroke-linejoin=\"round\"\n                />\n              </svg>\n            </div>\n            <div>{{ vm.translate.preview.noPreview }}</div>\n            <div>\n              {{\n                vm.translate.preview.allowedPreview.replace(\n                  'allowedFileExtList',\n                  allowedFileExtList.join(', ')\n                )\n              }}\n            </div>\n          </div>\n\n          <div\n            *ngIf=\"\n              allowedFileExtList.includes(getSelectedFileExt(vm.selectedDocument?.doc_name || ''))\n            \"\n          >\n            <fsw-pdf\n              *ngIf=\"\n                vm.selectedDocument?.dms_id &&\n                getSelectedFileExt(vm.selectedDocument?.doc_name || '') === 'pdf'\n              \"\n              [id]=\"vm.selectedDocument?.dms_id || null\"\n              [showPagination]=\"true\"\n              [height]=\"'64px'\"\n            ></fsw-pdf>\n            <fsw-image-viewer\n              *ngIf=\"\n                vm.selectedDocument?.dms_id &&\n                getSelectedFileExt(vm.selectedDocument?.doc_name || '') !== 'pdf'\n              \"\n              [id]=\"vm.selectedDocument?.dms_id || null\"\n              [height]=\"'480px'\"\n            ></fsw-image-viewer>\n          </div>\n        </ng-template>\n      </div>\n    </div>\n  </ng-container>\n</ng-container>\n", styles: [".site-visit{display:flex;width:100%;height:90vh;gap:16px}.site-visit__sub{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:12px;line-height:1.5;color:#757575}.site-visit__upload{padding:16px;width:30%;display:flex;flex-direction:column;gap:16px;border-radius:4px;border:1px solid #e0e0e0;overflow-y:scroll}.site-visit__viewers{width:70%;border:1px solid #e0e0e0}.site-visit__viewers--no-preview{display:flex;justify-content:center;align-items:center;min-height:420px}.site-visit__viewers--no-doc{width:25%;font-size:14px;color:#757575;text-align:center;display:flex;flex-direction:column;gap:16px}.site-visit__viewers--no-doc>div{text-align:center;display:flex;justify-content:center}.document{display:flex;flex-direction:column;width:100%;grid-gap:8px;gap:8px}.document__label{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:14px;line-height:1.5;color:#757575;font-weight:500}.document__control{display:flex;justify-content:space-between;align-items:center;width:100%;background-color:#f3f5fd;padding:4px;border-radius:2px;font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:14px;line-height:1.5}.document__file{display:flex;width:88%}.document__name{color:#2c50ff;width:90%;word-wrap:break-word}.document__name span{cursor:pointer}.document__icons{display:flex;justify-content:space-between;align-items:center;width:12%}.document__icons>div svg{width:14px;height:14px;cursor:pointer}.checkmark{display:block;visibility:hidden;position:relative;width:10%}.checkmark__show{visibility:visible}.checkmark.draw:after{animation-duration:.8s;animation-timing-function:ease;animation-name:checkmark;transform:scaleX(-1) rotate(135deg)}.checkmark:after{opacity:1;height:12px;width:6px;transform-origin:left top;border-right:2px solid #08c0a6;border-top:2px solid #08c0a6;content:\"\";left:25%;top:50%;position:absolute}@media (max-width: 801px){.site-visit{flex-direction:column}.site-visit__upload{width:70%;overflow-y:unset}.site-visit__viewers{width:100%}}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FSWUploadComponent, selector: "fsw-upload", inputs: ["buttonUploadLabel", "isPrimaryButton"], outputs: ["fileSelect"] }, { kind: "component", type: FSWPdfComponent, selector: "fsw-pdf", inputs: ["id", "showPagination", "height"] }, { kind: "component", type: FSWImageViewerComponent, selector: "fsw-image-viewer", inputs: ["id", "height"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SiteVisitComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-site-visit', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"vm$ | async as vm\">\n  <ng-container>\n    <div class=\"site-visit\">\n      <div class=\"site-visit__upload\">\n        <div>\n          <h6>{{ vm.translate.headings.title }}</h6>\n          <span class=\"site-visit__sub\">{{ vm.translate.headings.subTitle }}</span>\n        </div>\n        <ng-container *ngIf=\"vm.documentTypes\">\n          <ng-container *ngFor=\"let docType of vm.documentTypes\">\n            <div class=\"document\">\n              <span class=\"document__label\">{{ SITE_VISIT_DOC_MAP[docType].label }}</span>\n              <ng-container *ngFor=\"let file of getDocumentsByDocType(docType) | async\">\n                <div class=\"document__control\">\n                  <div class=\"document__file\">\n                    <div\n                      class=\"checkmark draw\"\n                      [ngClass]=\"{\n                        checkmark__show: file.id === vm.selectedDocument?.id\n                      }\"\n                    ></div>\n                    <div class=\"document__name\">\n                      <span (click)=\"selectFile(file)\">{{ file?.doc_name }}</span>\n                    </div>\n                  </div>\n                  <div class=\"document__icons\" *ngIf=\"!vm.isReadonly\">\n                    <div (click)=\"downloadFile(file)\">\n                      <svg\n                        width=\"22\"\n                        height=\"22\"\n                        viewBox=\"0 0 22 22\"\n                        fill=\"none\"\n                        xmlns=\"http://www.w3.org/2000/svg\"\n                      >\n                        <path\n                          fill-rule=\"evenodd\"\n                          clip-rule=\"evenodd\"\n                          d=\"M11 0.875C11.6213 0.875 12.125 1.37868 12.125 2V11.7843L15.2048 8.70451C15.6441 8.26517 16.3564 8.26517 16.7957 8.70451C17.2351 9.14385 17.2351 9.85616 16.7957 10.2955L11.7957 15.2955C11.5848 15.5065 11.2986 15.625 11.0002 15.625C10.7019 15.625 10.4157 15.5065 10.2047 15.2955L5.20475 10.2955C4.76541 9.85616 4.76541 9.14385 5.20475 8.70451C5.64409 8.26517 6.3564 8.26517 6.79574 8.70451L9.875 11.7838V2C9.875 1.37868 10.3787 0.875 11 0.875ZM2 12.875C2.62132 12.875 3.125 13.3787 3.125 14V18C3.125 18.2321 3.21719 18.4546 3.38128 18.6187C3.54538 18.7828 3.76794 18.875 4 18.875H18C18.2321 18.875 18.4546 18.7828 18.6187 18.6187C18.7828 18.4546 18.875 18.2321 18.875 18V14C18.875 13.3787 19.3787 12.875 20 12.875C20.6213 12.875 21.125 13.3787 21.125 14V18C21.125 18.8288 20.7958 19.6237 20.2097 20.2097C19.6237 20.7958 18.8288 21.125 18 21.125H4C3.1712 21.125 2.37634 20.7958 1.79029 20.2097C1.20424 19.6237 0.875 18.8288 0.875 18V14C0.875 13.3787 1.37868 12.875 2 12.875Z\"\n                          fill=\"#4A4A4A\"\n                        />\n                      </svg>\n                    </div>\n                    <div (click)=\"deleteFile(file)\">\n                      <svg\n                        width=\"10\"\n                        height=\"12\"\n                        viewBox=\"0 0 10 12\"\n                        fill=\"none\"\n                        xmlns=\"http://www.w3.org/2000/svg\"\n                      >\n                        <path\n                          d=\"M8.31037 3.29129L7.99919 10.7598C7.9931 10.9058 7.86315 11.0302 7.71606 11.0302H2.28577C2.13875 11.0302 2.00872 10.9055 2.00265 10.7598L1.69146 3.29129C1.68171 3.05719 1.48402 2.87532 1.24992 2.88508C1.01582 2.89483 0.833956 3.09251 0.84371 3.32661L1.1549 10.7951C1.17991 11.3954 1.68396 11.8786 2.28577 11.8786H7.71606C8.31752 11.8786 8.82189 11.3961 8.84694 10.7951L9.15812 3.32661C9.16788 3.09251 8.98601 2.89483 8.75191 2.88508C8.51781 2.87532 8.32013 3.05719 8.31037 3.29129Z\"\n                          fill=\"#4A4A4A\"\n                        />\n                        <path\n                          d=\"M4.66094 3.98804V9.75774C4.66094 9.94518 4.81289 10.0971 5.00034 10.0971C5.18778 10.0971 5.33973 9.94518 5.33973 9.75774V3.98804C5.33973 3.8006 5.18778 3.64865 5.00034 3.64865C4.81289 3.64865 4.66094 3.8006 4.66094 3.98804Z\"\n                          fill=\"#4A4A4A\"\n                        />\n                        <path\n                          d=\"M2.7944 3.99802L2.96409 9.76772C2.9696 9.95508 3.12596 10.1025 3.31332 10.097C3.50068 10.0915 3.6481 9.93513 3.64259 9.74776L3.47289 3.97807C3.46738 3.79071 3.31102 3.64329 3.12366 3.6488C2.9363 3.65431 2.78889 3.81066 2.7944 3.99802Z\"\n                          fill=\"#4A4A4A\"\n                        />\n                        <path\n                          d=\"M6.5281 3.97807L6.35841 9.74776C6.3529 9.93513 6.50031 10.0915 6.68768 10.097C6.87504 10.1025 7.03139 9.95508 7.0369 9.76772L7.2066 3.99802C7.21211 3.81066 7.06469 3.65431 6.87733 3.6488C6.68997 3.64329 6.53361 3.79071 6.5281 3.97807Z\"\n                          fill=\"#4A4A4A\"\n                        />\n                        <path\n                          d=\"M0.758227 2.29085H9.24308C9.47738 2.29085 9.66732 2.10091 9.66732 1.86661C9.66732 1.6323 9.47738 1.44236 9.24308 1.44236H0.758227C0.523924 1.44236 0.333984 1.6323 0.333984 1.86661C0.333984 2.10091 0.523924 2.29085 0.758227 2.29085Z\"\n                          fill=\"#4A4A4A\"\n                        />\n                        <path\n                          d=\"M3.71148 1.72867L3.88813 1.11038C3.92597 0.977949 4.09763 0.848485 4.23545 0.848485H5.76561C5.90351 0.848485 6.07505 0.977838 6.11292 1.11038L6.28958 1.72867L7.10542 1.49557L6.92876 0.877278C6.7868 0.380432 6.28229 0 5.76561 0H4.23545C3.71883 0 3.21421 0.380569 3.07229 0.877278L2.89564 1.49557L3.71148 1.72867Z\"\n                          fill=\"#4A4A4A\"\n                        />\n                      </svg>\n                    </div>\n                  </div>\n                </div>\n              </ng-container>\n              <fsw-upload\n                *ngIf=\"!vm.isReadonly\"\n                [buttonUploadLabel]=\"vm.translate.buttons.upload\"\n                (fileSelect)=\"uploadFile($event, docType)\"\n              ></fsw-upload>\n            </div>\n          </ng-container>\n        </ng-container>\n      </div>\n      <div\n        class=\"site-visit__viewers\"\n        [ngClass]=\"{\n          'site-visit__viewers--no-preview':\n            !vm.selectedDocument?.doc_name ||\n            !allowedFileExtList.includes(getSelectedFileExt(vm.selectedDocument?.doc_name || ''))\n        }\"\n      >\n        <ng-container *ngIf=\"!vm.selectedDocument?.doc_name; else afterDocIsSelected\">\n          <div class=\"site-visit__viewers--no-doc\">\n            <div>\n              <svg\n                width=\"60\"\n                height=\"68\"\n                viewBox=\"0 0 60 68\"\n                fill=\"none\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n              >\n                <path\n                  d=\"M50 0.552734V67.5918H10C4.47715 67.5918 0 63.0897 0 57.536L0 0.552734L50 0.552734Z\"\n                  fill=\"#F1F1F2\"\n                />\n                <rect x=\"10.0002\" y=\"9.77075\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <rect x=\"10.0002\" y=\"16.4746\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <rect x=\"10.0002\" y=\"23.1782\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <rect x=\"10.0002\" y=\"29.8826\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <rect x=\"10.0002\" y=\"36.5859\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <rect x=\"10.0002\" y=\"43.2903\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <rect x=\"10.0002\" y=\"49.9937\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <path\n                  d=\"M60.0001 59.2697V57.5359H15.0001V59.2119C15.0001 63.2933 12.0986 66.6931 8.25659 67.4394C8.82279 67.5395 9.4054 67.5918 10.0001 67.5918H51.7243C56.2949 67.5918 60.0001 63.8658 60.0001 59.2697Z\"\n                  fill=\"#CCCCCC\"\n                />\n              </svg>\n            </div>\n            <div>{{ vm.translate.preview.noDocSelected }}</div>\n          </div>\n        </ng-container>\n\n        <ng-template #afterDocIsSelected>\n          <div\n            class=\"site-visit__viewers--no-doc\"\n            *ngIf=\"\n              !allowedFileExtList.includes(getSelectedFileExt(vm.selectedDocument?.doc_name || ''))\n            \"\n          >\n            <div>\n              <svg\n                width=\"74\"\n                height=\"83\"\n                viewBox=\"0 0 74 83\"\n                fill=\"none\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n              >\n                <path\n                  d=\"M50.5 15.6467V82.6858H10.5C4.97715 82.6858 0.5 78.1837 0.5 72.63L0.5 15.6467L50.5 15.6467Z\"\n                  fill=\"#F1F1F2\"\n                />\n                <rect x=\"10.5\" y=\"24.8647\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <rect x=\"10.5\" y=\"31.5686\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <rect x=\"10.5\" y=\"38.2722\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <rect x=\"10.5\" y=\"44.9763\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <rect x=\"10.5\" y=\"51.6799\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <rect x=\"10.5\" y=\"58.3843\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <rect x=\"10.5\" y=\"65.0876\" width=\"30\" height=\"0.837989\" fill=\"#E0E0E0\" />\n                <path\n                  d=\"M60.5001 74.3637V72.6299H15.5001V74.3059C15.5001 78.3872 12.5986 81.7871 8.75659 82.5334C9.32279 82.6335 9.9054 82.6857 10.5001 82.6857H52.2243C56.7949 82.6857 60.5001 78.9598 60.5001 74.3637Z\"\n                  fill=\"#CCCCCC\"\n                />\n                <path\n                  d=\"M34.7974 15.2142C30.9059 18.4392 28.5 21.6642 28.5 21.6642C28.5 21.6642 38.1256 34.5642 50 34.5642C51.4728 34.5642 52.9111 34.3653 54.3 34.0181M45.7344 9.30171C47.1126 8.95986 48.5402 8.76421 50 8.76421C61.8745 8.76421 71.5 21.6642 71.5 21.6642C71.5 21.6642 69.0931 24.8892 65.2026 28.1142M46.0375 18.0318C45.087 19.0636 44.5775 20.4262 44.6179 21.8286C44.6584 23.2309 45.2455 24.5619 46.254 25.5373C47.2624 26.5126 48.6123 27.055 50.0152 27.0486C51.4181 27.0422 52.763 26.4875 53.7625 25.503M69.35 41.0142L30.65 2.31421\"\n                  stroke=\"#ADADAD\"\n                  stroke-width=\"4\"\n                  stroke-linecap=\"round\"\n                  stroke-linejoin=\"round\"\n                />\n              </svg>\n            </div>\n            <div>{{ vm.translate.preview.noPreview }}</div>\n            <div>\n              {{\n                vm.translate.preview.allowedPreview.replace(\n                  'allowedFileExtList',\n                  allowedFileExtList.join(', ')\n                )\n              }}\n            </div>\n          </div>\n\n          <div\n            *ngIf=\"\n              allowedFileExtList.includes(getSelectedFileExt(vm.selectedDocument?.doc_name || ''))\n            \"\n          >\n            <fsw-pdf\n              *ngIf=\"\n                vm.selectedDocument?.dms_id &&\n                getSelectedFileExt(vm.selectedDocument?.doc_name || '') === 'pdf'\n              \"\n              [id]=\"vm.selectedDocument?.dms_id || null\"\n              [showPagination]=\"true\"\n              [height]=\"'64px'\"\n            ></fsw-pdf>\n            <fsw-image-viewer\n              *ngIf=\"\n                vm.selectedDocument?.dms_id &&\n                getSelectedFileExt(vm.selectedDocument?.doc_name || '') !== 'pdf'\n              \"\n              [id]=\"vm.selectedDocument?.dms_id || null\"\n              [height]=\"'480px'\"\n            ></fsw-image-viewer>\n          </div>\n        </ng-template>\n      </div>\n    </div>\n  </ng-container>\n</ng-container>\n", styles: [".site-visit{display:flex;width:100%;height:90vh;gap:16px}.site-visit__sub{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:12px;line-height:1.5;color:#757575}.site-visit__upload{padding:16px;width:30%;display:flex;flex-direction:column;gap:16px;border-radius:4px;border:1px solid #e0e0e0;overflow-y:scroll}.site-visit__viewers{width:70%;border:1px solid #e0e0e0}.site-visit__viewers--no-preview{display:flex;justify-content:center;align-items:center;min-height:420px}.site-visit__viewers--no-doc{width:25%;font-size:14px;color:#757575;text-align:center;display:flex;flex-direction:column;gap:16px}.site-visit__viewers--no-doc>div{text-align:center;display:flex;justify-content:center}.document{display:flex;flex-direction:column;width:100%;grid-gap:8px;gap:8px}.document__label{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:14px;line-height:1.5;color:#757575;font-weight:500}.document__control{display:flex;justify-content:space-between;align-items:center;width:100%;background-color:#f3f5fd;padding:4px;border-radius:2px;font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:14px;line-height:1.5}.document__file{display:flex;width:88%}.document__name{color:#2c50ff;width:90%;word-wrap:break-word}.document__name span{cursor:pointer}.document__icons{display:flex;justify-content:space-between;align-items:center;width:12%}.document__icons>div svg{width:14px;height:14px;cursor:pointer}.checkmark{display:block;visibility:hidden;position:relative;width:10%}.checkmark__show{visibility:visible}.checkmark.draw:after{animation-duration:.8s;animation-timing-function:ease;animation-name:checkmark;transform:scaleX(-1) rotate(135deg)}.checkmark:after{opacity:1;height:12px;width:6px;transform-origin:left top;border-right:2px solid #08c0a6;border-top:2px solid #08c0a6;content:\"\";left:25%;top:50%;position:absolute}@media (max-width: 801px){.site-visit{flex-direction:column}.site-visit__upload{width:70%;overflow-y:unset}.site-visit__viewers{width:100%}}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [SITE_VISIT_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLOCO_SCOPE]
                }] }, { type: TranslocoFeatureHttpLoader }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MODAL_SERVICE]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [BLOB_SERVICE_TOKEN]
                }] }]; }, propDecorators: { applicationId: [{
                type: Input
            }], memberIds: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], notAllowedDocumentTypes: [{
                type: Input
            }] } });

var headings = {
	title: "Site Visit",
	subTitle: "Please click on the uploaded files to view in the right panel"
};
var preview = {
	noDocSelected: "No document is selected. Please upload and select a document in the left panel to view it here.",
	noPreview: "No preview is available for selected document.",
	allowedPreview: "Previews are only available for allowedFileExtList file formats."
};
var buttons$7 = {
	upload: "Upload file"
};
var dialogs = {
	headings: {
		title: "Confirm Delete",
		subTitle: "You are deleting data. Accept means your data will be permanently deleted"
	},
	buttons: {
		cancel: "Cancel",
		accept: "Accept"
	}
};
var _default = {
	headings: headings,
	preview: preview,
	buttons: buttons$7,
	dialogs: dialogs
};

var defaultJson = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$7,
    default: _default,
    dialogs: dialogs,
    headings: headings,
    preview: preview
});

const siteVisitTranslateLoader = {
    default: () => Promise.resolve(defaultJson),
    vu: () => Promise.resolve(defaultJson),
    id: () => Promise.resolve(defaultJson),
};

class SiteVisitDirective {
    constructor(_injector, _viewContainerRef) {
        this._injector = _injector;
        this._viewContainerRef = _viewContainerRef;
        this.countryId = null;
        this.isReadonly = false;
        this.memberIds = [];
        this.notAllowedDocumentTypes = [];
        this._defaultProvider = Promise.resolve(siteVisitDefaultProviders);
        this._internationalMapping = {
            [FSWCountryCode.VU]: this._defaultProvider,
            [FSWCountryCode.ID]: this._defaultProvider,
        };
    }
    ngOnInit() {
        const mapAsync = this._internationalMapping[this.countryId] || this._defaultProvider;
        from(mapAsync)
            .pipe(tap((providers) => {
            const ref = this._viewContainerRef.createComponent(SiteVisitComponent, {
                injector: Injector.create({
                    parent: this._injector,
                    providers: [
                        ...providers,
                        {
                            provide: TRANSLOCO_SCOPE,
                            useValue: {
                                scope: 'site-visit',
                                loader: siteVisitTranslateLoader,
                            },
                        },
                        {
                            provide: TRANSLOCO_LANG,
                            useValue: this.countryId?.toLowerCase() || 'default',
                        },
                        {
                            provide: TranslocoFeatureHttpLoader,
                            useClass: TranslocoFeatureHttpLoader,
                        },
                    ],
                }),
            });
            ref.instance.applicationId = this.applicationId;
            ref.instance.isReadonly = this.isReadonly;
            ref.instance.memberIds = this.memberIds;
            ref.instance.notAllowedDocumentTypes = this.notAllowedDocumentTypes;
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SiteVisitDirective, deps: [{ token: i0.Injector }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: SiteVisitDirective, selector: "[fswSiteVisit]", inputs: { countryId: "countryId", applicationId: "applicationId", isReadonly: "isReadonly", memberIds: "memberIds", notAllowedDocumentTypes: "notAllowedDocumentTypes" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SiteVisitDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswSiteVisit]',
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }, { type: i0.ViewContainerRef }]; }, propDecorators: { countryId: [{
                type: Input
            }], applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], memberIds: [{
                type: Input
            }], notAllowedDocumentTypes: [{
                type: Input
            }] } });

class SiteVisitModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SiteVisitModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: SiteVisitModule, declarations: [SiteVisitDirective, SiteVisitComponent], imports: [CommonModule,
            LetDirective,
            FSWModalModule,
            MemberDocServiceModule,
            DocManagerServiceModule,
            FSWUploadModule,
            FSWPdfModule,
            FSWConfirmDialogModule,
            FSWImageViewerModule], exports: [SiteVisitDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SiteVisitModule, imports: [CommonModule,
            FSWModalModule,
            MemberDocServiceModule,
            DocManagerServiceModule,
            FSWUploadModule,
            FSWPdfModule,
            FSWConfirmDialogModule,
            FSWImageViewerModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SiteVisitModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SiteVisitDirective, SiteVisitComponent],
                    imports: [
                        CommonModule,
                        LetDirective,
                        FSWModalModule,
                        MemberDocServiceModule,
                        DocManagerServiceModule,
                        FSWUploadModule,
                        FSWPdfModule,
                        FSWConfirmDialogModule,
                        FSWImageViewerModule,
                    ],
                    exports: [SiteVisitDirective],
                }]
        }] });

// export * from './data-access';
// export * from './i18n';
// // export * from './ui';

var fields$2 = {
	name: "Supplier name",
	credit_term: "Credit term",
	purchase_thb_month: "Purchase THB/Month",
	method_of_payment: "Method of payment",
	include_in_financing: "Include in financing",
	bank_name: "Bank's name",
	status: "Status",
	bank_account_number: "Bank account number",
	remark: "Remarks"
};
var buttons$6 = {
	edit: "Edit Details",
	save: "Save Changes",
	cancel: "Cancel",
	"delete": "Delete",
	delete_all: "Delete All",
	add: "Add Supplier",
	no: "No, please cancel",
	yes: "Yes, please proceed"
};
var titles$2 = {
	create: "Create Supplier",
	view: "View Supplier",
	edit: "Edit Supplier"
};
var confirmation = {
	save: {
		title: "Confirm Save Supplier",
		description: "Are you sure you want to save this Supplier {{name}} ?"
	},
	"delete": {
		title: "Confirm Delete Supplier",
		description: "You will lose all the information, Are you sure you want to delete this Supplier {{name}} ?"
	},
	delete_all: {
		title: "Confirm Delete All Supplier",
		description: "You will lose all the information, Are you sure you want to delete all Supplier ?"
	}
};
var messages$1 = {
	no_supplier: "Empty Supplier Data"
};
var suffix = {
	in_days: "days"
};
var supplierTh = {
	fields: fields$2,
	buttons: buttons$6,
	titles: titles$2,
	confirmation: confirmation,
	messages: messages$1,
	suffix: suffix
};

var TH$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$6,
    confirmation: confirmation,
    default: supplierTh,
    fields: fields$2,
    messages: messages$1,
    suffix: suffix,
    titles: titles$2
});

const TH_TRANSLATION = TH$1;

function injectSupplierTHForm(readonlyWhen$, { banks }) {
    const form = new UntypedFormGroup({});
    const builder = new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'w-full flex flex-wrap gap-4',
        readonlyWhen$,
        form,
        fields: [
            {
                key: 'name',
                customClasses: 'w-[calc(50%-8px)]',
                type: FSWDynamicBuilderControlTypes.INPUT,
                context: {
                    label: TH_TRANSLATION.fields.name,
                    fullWidth: true,
                    isRequired: true,
                },
                validations: [Validators.required],
            },
            {
                key: 'credit_term',
                type: FSWDynamicBuilderControlTypes.INPUT,
                customClasses: 'w-[calc(50%-8px)]',
                context: {
                    // inputType: 'number',
                    defaultValue: 0,
                    mask: {
                        expression: 'separator.2',
                        config: {
                            thousandSeparator: ',',
                        },
                    },
                    suffix: TH_TRANSLATION.suffix.in_days,
                    label: TH_TRANSLATION.fields.credit_term,
                    fullWidth: true,
                    isRequired: true,
                    readonlyTemplate: (value) => (value || 0).toString(),
                },
                validations: [Validators.required],
            },
            {
                key: 'purchase_thb_month',
                type: FSWDynamicBuilderControlTypes.INPUT,
                customClasses: 'w-[calc(50%-8px)]',
                context: {
                    defaultValue: 0,
                    mask: {
                        expression: 'separator.2',
                        config: {
                            thousandSeparator: ',',
                        },
                    },
                    prefix: getCurrentCountryConfig().currencyCode,
                    label: TH_TRANSLATION.fields.purchase_thb_month,
                    fullWidth: true,
                    isRequired: true,
                    readonlyTemplate: (value) => (value || 0).toString(),
                },
                validations: [Validators.required],
            },
            {
                key: 'method_of_payment',
                type: FSWDynamicBuilderControlTypes.SELECT,
                customClasses: 'w-[calc(50%-8px)]',
                context: {
                    label: TH_TRANSLATION.fields.method_of_payment,
                    items: BUYER_PAYMENT_METHODS.map((item) => ({
                        text: item,
                        value: item,
                    })),
                    fullWidth: true,
                    isRequired: true,
                    readonlyTemplate: (value) => {
                        const text = BUYER_PAYMENT_METHODS.find((item) => item === value);
                        return text ?? 'N/A';
                    },
                },
                validations: [Validators.required],
            },
            {
                key: 'bank_name',
                type: FSWDynamicBuilderControlTypes.SELECT,
                customClasses: 'w-[calc(50%-8px)]',
                context: {
                    label: TH_TRANSLATION.fields.bank_name,
                    items: banks.map((item) => ({
                        text: item.name,
                        value: item.id,
                    })),
                    fullWidth: true,
                    isRequired: true,
                    readonlyTemplate: (value) => {
                        const text = banks.find((item) => item.id === value)?.name;
                        return text ?? 'N/A';
                    },
                },
                validations: [Validators.required],
            },
            {
                key: 'bank_account_number',
                type: FSWDynamicBuilderControlTypes.INPUT,
                customClasses: 'w-[calc(50%-8px)]',
                context: {
                    label: TH_TRANSLATION.fields.bank_account_number,
                    fullWidth: true,
                    isRequired: true,
                    readonlyTemplate: (value) => value ?? 'N/A',
                },
                validations: [Validators.required],
            },
            {
                key: 'include_in_financing',
                type: FSWDynamicBuilderControlTypes.SELECT,
                customClasses: 'w-[calc(50%-8px)]',
                context: {
                    defaultValue: 'Yes',
                    label: TH_TRANSLATION.fields.include_in_financing,
                    items: ['Yes', 'No'].map((item) => ({
                        text: item,
                        value: item,
                    })),
                    fullWidth: true,
                    isRequired: true,
                    readonlyTemplate: (value) => {
                        const text = ['Yes', 'No'].find((item) => item === value);
                        return text ?? 'N/A';
                    },
                },
                validations: [Validators.required],
            },
            {
                key: 'status',
                type: FSWDynamicBuilderControlTypes.INPUT,
                customClasses: 'w-[calc(50%-8px)]',
                context: {
                    label: TH_TRANSLATION.fields.status,
                    defaultValue: 'NORMAL',
                    fullWidth: true,
                    isRequired: true,
                    isDisabled: true,
                },
                validations: [Validators.required],
            },
            {
                key: 'remark',
                type: FSWDynamicBuilderControlTypes.INPUT,
                customClasses: 'w-[calc(50%-8px)]',
                context: {
                    inputType: 'area',
                    placeHolder: 'Please enter remarks',
                    defaultValue: '',
                    label: TH_TRANSLATION.fields.remark,
                    fullWidth: true,
                },
            },
        ],
    });
    return { form, builder };
}

function injectSupplierTHEffects(refreshedAt, suppliers, injector) {
    const creditService = injectCreditSupplierService();
    const applicationService = injectApplicationSupplierService();
    const alertService = inject(FSW_ALERT_SERVICE_TOKEN);
    return {
        refresh: (applicationId) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => applicationService.getAll(applicationId)), switchMap$1((ids) => {
            if (ids?.length) {
                return creditService.getAll(ids);
            }
            return of([]);
        }), tap((data) => suppliers.set(data)), catchError(() => {
            alertService.error('Failed to load suppliers', null, {
                duration: 3000,
            });
            suppliers.set([]);
            return of([]);
        })), injector, []))),
        create: (applicationId, payload) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => creditService.createOne(payload)), switchMap$1((supplier) => applicationService.createOne(applicationId, supplier.id).pipe(map(() => supplier))), tap(() => refreshedAt.set(new Date())), tap(() => alertService.success('create supplier successfully!', null, {
            duration: 3000,
        })), catchError(() => {
            alertService.error('Failed to create supplier', null, {
                duration: 3000,
            });
            return of(null);
        })), injector))),
        update: (payload) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => creditService.updateOne(payload.id, payload)), tap(() => refreshedAt.set(new Date())), tap(() => alertService.success('Update supplier successfully!', null, {
            duration: 3000,
        })), catchError(() => {
            alertService.error('Failed to update supplier', null, {
                duration: 3000,
            });
            return of(null);
        })), injector))),
        patchStatus: (id, status) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => creditService.patchStatus(id, status)), tap(() => refreshedAt.set(new Date())), tap(() => alertService.success('Patch supplier status successfully!', null, {
            duration: 3000,
        })), catchError(() => {
            alertService.error('Failed to patch supplier status', null, {
                duration: 3000,
            });
            return of(null);
        })), injector))),
        delete: (applicationId, id) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => creditService.deleteOne(id)), switchMap$1(() => applicationService.deleteOne(applicationId, id)), tap(() => refreshedAt.set(new Date())), tap(() => alertService.success('Delete supplier successfully!', null, {
            duration: 3000,
        })), catchError(() => {
            alertService.error('Failed to delete supplier', null, {
                duration: 3000,
            });
            return of(null);
        })), injector))),
        deleteAll: (applicationId) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => applicationService.deleteAll(applicationId)), tap(() => refreshedAt.set(new Date())), tap(() => alertService.success('Delete all suppliers successfully!', null, {
            duration: 3000,
        })), catchError(() => {
            alertService.error('Failed to delete all suppliers', null, {
                duration: 3000,
            });
            return of(null);
        })), injector))),
    };
}

function injectSupplierEffects(refreshedAt, suppliers, injector) {
    switch (getCountryCodeFromStorage()) {
        case CountryCode.TH:
            return injectSupplierTHEffects(refreshedAt, suppliers, injector);
        default:
            return injectSupplierTHEffects(refreshedAt, suppliers, injector);
    }
}
function injectSupplierForm(readonlyWhen$, config) {
    switch (getCountryCodeFromStorage()) {
        case CountryCode.TH:
            return injectSupplierTHForm(readonlyWhen$, config);
        default:
            return injectSupplierTHForm(readonlyWhen$, config);
    }
}

function provideSupplierTranslation() {
    return [
        ...(FSWTranslateModule.forFeature({
            scope: 'supplier',
            defaultKey: CountryCode.TH,
            data: {
                [CountryCode.TH]: TH_TRANSLATION,
            },
        }).providers || []),
        fswTranslateScope('supplier'),
    ];
}

class FSWSupplierSaveComponent {
    constructor() {
        this.dialogRef = inject(DialogRef);
        this.alertService = inject(FSW_ALERT_SERVICE_TOKEN);
        this.dialogData = this.dialogRef.config.data;
        this.readonlyWhen$ = new BehaviorSubject(!!this.dialogData.supplier);
        this.formConfig = injectSupplierForm(this.readonlyWhen$, {
            banks: this.dialogData.banks || [],
        });
        this.title = signal(this.dialogData.supplier ? 'titles.view' : 'titles.create');
    }
    ngOnInit() {
        this.formConfig.form.patchValue(this.dialogData.supplier || {});
    }
    close(data) {
        this.dialogRef.close(data);
    }
    submit() {
        if (this.formConfig.form.valid) {
            if (this.dialogData.confirm) {
                this.dialogData.confirm(this.formConfig.form.value.name, () => {
                    this.close(this.formConfig.form.value);
                });
            }
            else {
                this.close(this.formConfig.form.value);
            }
        }
        else {
            this.alertService.error('Supplier form is invalid', null, {
                duration: 3000,
            });
        }
    }
    edit() {
        if (this.dialogData.isReadonly) {
            return;
        }
        this.readonlyWhen$.next(false);
        this.title.set('titles.edit');
    }
    delete() {
        if (this.dialogData.isReadonly || !this.dialogData.delete) {
            return;
        }
        this.dialogData.delete(() => this.close());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSupplierSaveComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWSupplierSaveComponent, isStandalone: true, selector: "fsw-supplier-save", providers: [provideSupplierTranslation()], ngImport: i0, template: "<fsw-modal\n  [size]=\"'l'\"\n  [title]=\"title() | fswTranslate\"\n  [bodyCustomClasses]=\"'max-h-[calc(90vh-138px)] overflow-y-auto'\"\n  [hiddenFooter]=\"!!dialogData.isReadonly\"\n  (closeEvent)=\"close()\"\n>\n  <ng-template fswModalBody>\n    <form [formGroup]=\"formConfig.form\">\n      <fsw-dynamic-builder [builder]=\"formConfig.builder\"></fsw-dynamic-builder>\n    </form>\n  </ng-template>\n  <ng-template fswModalFooter>\n    <section class=\"flex justify-between w-full items-center\">\n      <aside>\n        <button\n          [attr.data-test-id]=\"'supplier-save-modal-delete'\"\n          *ngIf=\"!!dialogData.supplier && dialogData.isSales\"\n          fswButton\n          class=\"!text-red-500\"\n          [appearance]=\"'secondary'\"\n          (click)=\"delete()\"\n        >\n          {{ 'buttons.delete' | fswTranslate }}\n        </button>\n      </aside>\n      <main class=\"flex gap-[16px] items-center\">\n        <button\n          fswButton\n          [appearance]=\"'secondary'\"\n          (click)=\"close()\"\n          [attr.data-test-id]=\"'supplier-save-modal-cancel'\"\n        >\n          {{ 'buttons.cancel' | fswTranslate }}\n        </button>\n        <button\n          (click)=\"edit()\"\n          fswButton\n          *ngIf=\"readonlyWhen$ | async; else saveChangesTemplate\"\n          [attr.data-test-id]=\"'supplier-save-modal-edit'\"\n        >\n          {{ 'buttons.edit' | fswTranslate }}\n        </button>\n        <ng-template #saveChangesTemplate>\n          <button fswButton (click)=\"submit()\" [attr.data-test-id]=\"'supplier-save-modal-save'\">\n            {{ 'buttons.save' | fswTranslate }}\n          </button>\n        </ng-template>\n      </main>\n    </section>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "ngmodule", type: FSWModalModule$1 }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "directive", type: i1$4.FSWModalFooterDirective, selector: "ng-template[fswModalFooter]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "ngmodule", type: FSWAlertModule }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: AsyncPipe, name: "async" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: FSWDynamicBuilderModule }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSupplierSaveComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-supplier-save', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [
                        FSWModalModule$1,
                        FSWAlertModule,
                        FSWTranslateModule,
                        AsyncPipe,
                        FSWButtonModule,
                        ReactiveFormsModule,
                        FSWDynamicBuilderModule,
                        NgIf,
                    ], providers: [provideSupplierTranslation()], template: "<fsw-modal\n  [size]=\"'l'\"\n  [title]=\"title() | fswTranslate\"\n  [bodyCustomClasses]=\"'max-h-[calc(90vh-138px)] overflow-y-auto'\"\n  [hiddenFooter]=\"!!dialogData.isReadonly\"\n  (closeEvent)=\"close()\"\n>\n  <ng-template fswModalBody>\n    <form [formGroup]=\"formConfig.form\">\n      <fsw-dynamic-builder [builder]=\"formConfig.builder\"></fsw-dynamic-builder>\n    </form>\n  </ng-template>\n  <ng-template fswModalFooter>\n    <section class=\"flex justify-between w-full items-center\">\n      <aside>\n        <button\n          [attr.data-test-id]=\"'supplier-save-modal-delete'\"\n          *ngIf=\"!!dialogData.supplier && dialogData.isSales\"\n          fswButton\n          class=\"!text-red-500\"\n          [appearance]=\"'secondary'\"\n          (click)=\"delete()\"\n        >\n          {{ 'buttons.delete' | fswTranslate }}\n        </button>\n      </aside>\n      <main class=\"flex gap-[16px] items-center\">\n        <button\n          fswButton\n          [appearance]=\"'secondary'\"\n          (click)=\"close()\"\n          [attr.data-test-id]=\"'supplier-save-modal-cancel'\"\n        >\n          {{ 'buttons.cancel' | fswTranslate }}\n        </button>\n        <button\n          (click)=\"edit()\"\n          fswButton\n          *ngIf=\"readonlyWhen$ | async; else saveChangesTemplate\"\n          [attr.data-test-id]=\"'supplier-save-modal-edit'\"\n        >\n          {{ 'buttons.edit' | fswTranslate }}\n        </button>\n        <ng-template #saveChangesTemplate>\n          <button fswButton (click)=\"submit()\" [attr.data-test-id]=\"'supplier-save-modal-save'\">\n            {{ 'buttons.save' | fswTranslate }}\n          </button>\n        </ng-template>\n      </main>\n    </section>\n  </ng-template>\n</fsw-modal>\n" }]
        }] });

class FSWSupplierConfirmComponent {
    constructor() {
        this.dialogRef = inject(DialogRef);
    }
    close(haveData = false) {
        this.dialogRef.close(haveData);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSupplierConfirmComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWSupplierConfirmComponent, isStandalone: true, selector: "fsw-supplier-confirm", providers: [provideSupplierTranslation()], ngImport: i0, template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"'buttons.yes' | fswTranslate\"\n  [cancelButton]=\"'buttons.no' | fswTranslate\"\n  (confirmEvent)=\"close(true)\"\n  (cancelEvent)=\"close(false)\"\n  (closeEvent)=\"close(false)\"\n>\n  <ng-template fswModalBody>\n    <p>\n      {{\n        dialogRef.config.data['description']\n          | fswTranslate : { data: dialogRef.config.data['descriptionParams'] }\n      }}\n    </p>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "ngmodule", type: FSWModalModule$1 }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSupplierConfirmComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-supplier-confirm', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [FSWModalModule$1, FSWTranslateModule], providers: [provideSupplierTranslation()], template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"'buttons.yes' | fswTranslate\"\n  [cancelButton]=\"'buttons.no' | fswTranslate\"\n  (confirmEvent)=\"close(true)\"\n  (cancelEvent)=\"close(false)\"\n  (closeEvent)=\"close(false)\"\n>\n  <ng-template fswModalBody>\n    <p>\n      {{\n        dialogRef.config.data['description']\n          | fswTranslate : { data: dialogRef.config.data['descriptionParams'] }\n      }}\n    </p>\n  </ng-template>\n</fsw-modal>\n" }]
        }] });

class FSWSupplierComponent {
    constructor() {
        this.updated = new EventEmitter();
        this.applicationId = signal('');
        this.isReadonly = signal(false);
        this.salesOrCredit = signal(BuyerSalesOrCredit.SALES);
        this.isSales = computed(() => this.salesOrCredit() === BuyerSalesOrCredit.SALES);
        this.isCredit = computed(() => this.salesOrCredit() === BuyerSalesOrCredit.CREDIT);
        this.colSpan = computed(() => (this.isReadonly() ? 9 : 9));
        this.refreshedAt = signal(new Date());
        this.banks = signal([]);
        this.suppliers = signal([]);
        this.status = signal('ALL');
        this.effects = injectSupplierEffects(this.refreshedAt, this.suppliers, inject(Injector));
        this.filteredSuppliers = computed(() => this.suppliers().filter((supplier) => this.status() === 'ALL' || supplier.status === this.status()));
        this.dialog = inject(Dialog);
        this.masterDataService = inject(MASTER_DATA_SERVICE_TOKEN);
        this.BuyerSalesOrCredit = BuyerSalesOrCredit;
        this.injector = inject(Injector);
        effect(() => {
            this.updated.emit(this.suppliers());
        });
        effect(() => {
            if (this.refreshedAt()) {
                this.effects.refresh(this.applicationId());
            }
        });
        effect(() => {
            this.masterDataService
                .getBanks()
                .pipe(tap((banks) => untracked(() => this.banks.set(banks))))
                .subscribe();
        }, { allowSignalWrites: true });
    }
    editOrCreate(supplier) {
        this.dialog
            .open(FSWSupplierSaveComponent, {
            data: {
                supplier,
                isReadonly: this.isReadonly(),
                isSales: this.isSales(),
                banks: this.banks(),
                delete: supplier ? (cb) => this.delete(supplier, cb) : undefined,
                confirm: (name, cb) => this.confirm(name, cb),
            },
            injector: this.injector,
        })
            .closed.pipe(take(1), tap((res) => {
            if (!res) {
                return;
            }
            this.upsert(res, supplier?.id);
        }))
            .subscribe();
    }
    upsert(supplier, id) {
        if (id) {
            this.effects.update({
                ...supplier,
                id,
            });
        }
        else {
            this.effects.create(this.applicationId(), supplier);
        }
    }
    confirm(name, cb) {
        this.dialog
            .open(FSWProposalsConfirmComponent, {
            data: {
                title: `confirmation.save.title`,
                titleParams: {},
                description: `confirmation.save.description`,
                descriptionParams: {
                    name,
                },
            },
            injector: this.injector,
        })
            .closed.pipe(take(1), tap((accept) => {
            if (!accept) {
                return;
            }
            cb && cb();
        }))
            .subscribe();
    }
    deleteAll() {
        this.dialog
            .open(FSWProposalsConfirmComponent, {
            data: {
                title: `confirmation.delete_all.title`,
                titleParams: {},
                description: `confirmation.delete_all.description`,
                descriptionParams: {},
            },
            injector: this.injector,
        })
            .closed.pipe(take(1), tap((accept) => {
            if (accept) {
                this.effects.deleteAll(this.applicationId());
            }
        }))
            .subscribe();
    }
    delete(supplier, cb) {
        this.dialog
            .open(FSWProposalsConfirmComponent, {
            data: {
                title: `confirmation.delete.title`,
                titleParams: {},
                description: `confirmation.delete.description`,
                descriptionParams: {
                    name: supplier.name,
                },
            },
            injector: this.injector,
        })
            .closed.pipe(take(1), tap((accept) => {
            if (accept) {
                this.effects.delete(this.applicationId(), supplier.id);
                cb && cb();
            }
        }))
            .subscribe();
    }
    patchStatus(id, status) {
        this.effects.patchStatus(id, status === BuyerStatus.NORMAL ? BuyerStatus.TOP : BuyerStatus.NORMAL);
    }
    getBankName(id) {
        return this.banks().find((bank) => bank.id == id)?.name || '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSupplierComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWSupplierComponent, isStandalone: true, selector: "fsw-supplier", outputs: { updated: "updated" }, providers: [
            provideCreditSupplierService(),
            provideApplicationSupplierService(),
            provideSupplierTranslation(),
        ], ngImport: i0, template: "<table class=\"fsw-table fsw-table--bordered w-full\">\n  <caption class=\"hidden\">\n    Supplier Table\n  </caption>\n  <thead>\n    <tr>\n      <th scope=\"colgroup\" [colSpan]=\"colSpan()\">\n        <main class=\"w-full h-full flex items-center justify-end gap-3\">\n          <fsw-radio-group\n            [ngModel]=\"status()\"\n            (ngModelChange)=\"status.set($event)\"\n            [direction]=\"'row'\"\n            [gap]=\"'12px'\"\n          >\n            <fsw-radio [label]=\"'All'\" [value]=\"'ALL'\"></fsw-radio>\n            <fsw-radio [label]=\"'Top'\" [value]=\"'TOP'\"></fsw-radio>\n            <fsw-radio [label]=\"'Normal'\" [value]=\"'NORMAL'\"></fsw-radio>\n          </fsw-radio-group>\n          <aside\n            class=\"flex items-center gap-3\"\n            *ngIf=\"!isReadonly() && suppliers()?.length && isSales()\"\n          >\n            <!--            <button-->\n            <!--              fswButton-->\n            <!--              [appearance]=\"'secondary-elevate'\"-->\n            <!--              class=\"!text-status-error\"-->\n            <!--              [size]=\"'s'\"-->\n            <!--              (click)=\"deleteAll()\"-->\n            <!--            >-->\n            <!--              {{ 'buttons.delete_all' | fswTranslate }}-->\n            <!--            </button>-->\n            <button fswButton [appearance]=\"'secondary'\" [size]=\"'s'\" (click)=\"editOrCreate()\">\n              {{ 'buttons.add' | fswTranslate }}\n            </button>\n          </aside>\n        </main>\n      </th>\n    </tr>\n    <tr *ngIf=\"suppliers()?.length\">\n      <th class=\"whitespace-normal\" scope=\"col\">{{ 'fields.name' | fswTranslate }}</th>\n      <th class=\"whitespace-normal\" scope=\"col\">{{ 'fields.credit_term' | fswTranslate }}</th>\n      <th class=\"whitespace-normal\" scope=\"col\">\n        {{ 'fields.purchase_thb_month' | fswTranslate }}\n      </th>\n      <th class=\"whitespace-normal\" scope=\"col\">{{ 'fields.method_of_payment' | fswTranslate }}</th>\n      <th class=\"whitespace-normal\" scope=\"col\">\n        {{ 'fields.include_in_financing' | fswTranslate }}\n      </th>\n      <th class=\"whitespace-normal\" scope=\"col\">{{ 'fields.bank_name' | fswTranslate }}</th>\n      <th class=\"whitespace-normal\" scope=\"col\">\n        {{ 'fields.bank_account_number' | fswTranslate }}\n      </th>\n      <th class=\"whitespace-normal\" scope=\"col\">{{ 'fields.status' | fswTranslate }}</th>\n      <th class=\"whitespace-normal\" scope=\"col\">{{ 'fields.remark' | fswTranslate }}</th>\n      <!--      <th scope=\"col\" class=\"min-w-[40px]\" *ngIf=\"!isReadonly() && isSales()\"></th>-->\n    </tr>\n  </thead>\n  <tbody>\n    <ng-container *ngFor=\"let supplier of filteredSuppliers()\">\n      <tr>\n        <td\n          class=\"hover:bg-blue-100 hover:cursor-pointer whitespace-normal\"\n          (click)=\"editOrCreate(supplier)\"\n        >\n          {{ supplier.name }}\n        </td>\n        <td class=\"whitespace-normal\">{{ supplier.credit_term }} days</td>\n        <td class=\"whitespace-normal\">{{ supplier.purchase_thb_month | currencyMaskPipe }}</td>\n        <td class=\"whitespace-normal\">{{ supplier.method_of_payment }}</td>\n        <td class=\"whitespace-normal\">{{ supplier.include_in_financing }}</td>\n        <td class=\"whitespace-normal\">{{ getBankName(supplier.bank_name) }}</td>\n        <td class=\"whitespace-normal\">{{ supplier.bank_account_number }}</td>\n        <td class=\"whitespace-normal\">\n          <fsw-tags\n            [hiddenCloseButton]=\"true\"\n            [disabled]=\"isReadonly()\"\n            [color]=\"supplier.status === 'NORMAL' ? 'gray' : 'green'\"\n            (click)=\"!isReadonly() && isCredit() && patchStatus(supplier.id, supplier.status)\"\n            class=\"cursor-pointer\"\n          >\n            {{ supplier.status }}\n          </fsw-tags>\n        </td>\n        <td class=\"whitespace-normal\">{{ supplier.remark }}</td>\n        <!--        <td *ngIf=\"!isReadonly() && isSales()\">-->\n        <!--          <main class=\"w-full h-full flex items-center justify-center\">-->\n        <!--            <button fswButton [appearance]=\"'icon-with-bg'\" [size]=\"'s'\" (click)=\"delete(supplier)\">-->\n        <!--              <i [fswIcon]=\"'common-delete'\" class=\"!text-status-error\"></i>-->\n        <!--            </button>-->\n        <!--          </main>-->\n        <!--        </td>-->\n      </tr>\n    </ng-container>\n    <ng-container *ngIf=\"!suppliers()?.length\">\n      <tr>\n        <td [colSpan]=\"colSpan()\">\n          <main class=\"w-full h-full flex flex-col items-center justify-center gap-6 py-10\">\n            <p>{{ 'messages.no_supplier' | fswTranslate }}</p>\n            <button\n              *ngIf=\"!isReadonly() && isSales()\"\n              fswButton\n              [appearance]=\"'secondary'\"\n              [size]=\"'s'\"\n              (click)=\"editOrCreate()\"\n            >\n              {{ 'buttons.add' | fswTranslate }}\n            </button>\n          </main>\n        </td>\n      </tr>\n    </ng-container>\n  </tbody>\n</table>\n", dependencies: [{ kind: "ngmodule", type: FSWAlertModule }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "ngmodule", type: CurrencyFormatModule }, { kind: "pipe", type: CurrencyFormatPipe, name: "currencyMaskPipe" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: MasterDataServiceModule }, { kind: "ngmodule", type: FSWRadioModule }, { kind: "component", type: i1$4.FSWRadioComponent, selector: "fsw-radio" }, { kind: "component", type: i1$4.FSWRadioGroupComponent, selector: "fsw-radio-group" }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "ngmodule", type: FSWTagsModule }, { kind: "component", type: i1$4.FSWTagsComponent, selector: "fsw-tags" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSupplierComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-supplier', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [
                        provideCreditSupplierService(),
                        provideApplicationSupplierService(),
                        provideSupplierTranslation(),
                    ], imports: [
                        FSWAlertModule,
                        FSWTranslateModule,
                        NgForOf,
                        CurrencyFormatModule,
                        FSWButtonModule,
                        FSWIconModule,
                        NgIf,
                        MasterDataServiceModule,
                        FSWRadioModule,
                        FormsModule,
                        FSWTagsModule,
                    ], template: "<table class=\"fsw-table fsw-table--bordered w-full\">\n  <caption class=\"hidden\">\n    Supplier Table\n  </caption>\n  <thead>\n    <tr>\n      <th scope=\"colgroup\" [colSpan]=\"colSpan()\">\n        <main class=\"w-full h-full flex items-center justify-end gap-3\">\n          <fsw-radio-group\n            [ngModel]=\"status()\"\n            (ngModelChange)=\"status.set($event)\"\n            [direction]=\"'row'\"\n            [gap]=\"'12px'\"\n          >\n            <fsw-radio [label]=\"'All'\" [value]=\"'ALL'\"></fsw-radio>\n            <fsw-radio [label]=\"'Top'\" [value]=\"'TOP'\"></fsw-radio>\n            <fsw-radio [label]=\"'Normal'\" [value]=\"'NORMAL'\"></fsw-radio>\n          </fsw-radio-group>\n          <aside\n            class=\"flex items-center gap-3\"\n            *ngIf=\"!isReadonly() && suppliers()?.length && isSales()\"\n          >\n            <!--            <button-->\n            <!--              fswButton-->\n            <!--              [appearance]=\"'secondary-elevate'\"-->\n            <!--              class=\"!text-status-error\"-->\n            <!--              [size]=\"'s'\"-->\n            <!--              (click)=\"deleteAll()\"-->\n            <!--            >-->\n            <!--              {{ 'buttons.delete_all' | fswTranslate }}-->\n            <!--            </button>-->\n            <button fswButton [appearance]=\"'secondary'\" [size]=\"'s'\" (click)=\"editOrCreate()\">\n              {{ 'buttons.add' | fswTranslate }}\n            </button>\n          </aside>\n        </main>\n      </th>\n    </tr>\n    <tr *ngIf=\"suppliers()?.length\">\n      <th class=\"whitespace-normal\" scope=\"col\">{{ 'fields.name' | fswTranslate }}</th>\n      <th class=\"whitespace-normal\" scope=\"col\">{{ 'fields.credit_term' | fswTranslate }}</th>\n      <th class=\"whitespace-normal\" scope=\"col\">\n        {{ 'fields.purchase_thb_month' | fswTranslate }}\n      </th>\n      <th class=\"whitespace-normal\" scope=\"col\">{{ 'fields.method_of_payment' | fswTranslate }}</th>\n      <th class=\"whitespace-normal\" scope=\"col\">\n        {{ 'fields.include_in_financing' | fswTranslate }}\n      </th>\n      <th class=\"whitespace-normal\" scope=\"col\">{{ 'fields.bank_name' | fswTranslate }}</th>\n      <th class=\"whitespace-normal\" scope=\"col\">\n        {{ 'fields.bank_account_number' | fswTranslate }}\n      </th>\n      <th class=\"whitespace-normal\" scope=\"col\">{{ 'fields.status' | fswTranslate }}</th>\n      <th class=\"whitespace-normal\" scope=\"col\">{{ 'fields.remark' | fswTranslate }}</th>\n      <!--      <th scope=\"col\" class=\"min-w-[40px]\" *ngIf=\"!isReadonly() && isSales()\"></th>-->\n    </tr>\n  </thead>\n  <tbody>\n    <ng-container *ngFor=\"let supplier of filteredSuppliers()\">\n      <tr>\n        <td\n          class=\"hover:bg-blue-100 hover:cursor-pointer whitespace-normal\"\n          (click)=\"editOrCreate(supplier)\"\n        >\n          {{ supplier.name }}\n        </td>\n        <td class=\"whitespace-normal\">{{ supplier.credit_term }} days</td>\n        <td class=\"whitespace-normal\">{{ supplier.purchase_thb_month | currencyMaskPipe }}</td>\n        <td class=\"whitespace-normal\">{{ supplier.method_of_payment }}</td>\n        <td class=\"whitespace-normal\">{{ supplier.include_in_financing }}</td>\n        <td class=\"whitespace-normal\">{{ getBankName(supplier.bank_name) }}</td>\n        <td class=\"whitespace-normal\">{{ supplier.bank_account_number }}</td>\n        <td class=\"whitespace-normal\">\n          <fsw-tags\n            [hiddenCloseButton]=\"true\"\n            [disabled]=\"isReadonly()\"\n            [color]=\"supplier.status === 'NORMAL' ? 'gray' : 'green'\"\n            (click)=\"!isReadonly() && isCredit() && patchStatus(supplier.id, supplier.status)\"\n            class=\"cursor-pointer\"\n          >\n            {{ supplier.status }}\n          </fsw-tags>\n        </td>\n        <td class=\"whitespace-normal\">{{ supplier.remark }}</td>\n        <!--        <td *ngIf=\"!isReadonly() && isSales()\">-->\n        <!--          <main class=\"w-full h-full flex items-center justify-center\">-->\n        <!--            <button fswButton [appearance]=\"'icon-with-bg'\" [size]=\"'s'\" (click)=\"delete(supplier)\">-->\n        <!--              <i [fswIcon]=\"'common-delete'\" class=\"!text-status-error\"></i>-->\n        <!--            </button>-->\n        <!--          </main>-->\n        <!--        </td>-->\n      </tr>\n    </ng-container>\n    <ng-container *ngIf=\"!suppliers()?.length\">\n      <tr>\n        <td [colSpan]=\"colSpan()\">\n          <main class=\"w-full h-full flex flex-col items-center justify-center gap-6 py-10\">\n            <p>{{ 'messages.no_supplier' | fswTranslate }}</p>\n            <button\n              *ngIf=\"!isReadonly() && isSales()\"\n              fswButton\n              [appearance]=\"'secondary'\"\n              [size]=\"'s'\"\n              (click)=\"editOrCreate()\"\n            >\n              {{ 'buttons.add' | fswTranslate }}\n            </button>\n          </main>\n        </td>\n      </tr>\n    </ng-container>\n  </tbody>\n</table>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { updated: [{
                type: Output
            }] } });

var FSWSupplierDirective_1;
let FSWSupplierDirective = class FSWSupplierDirective {
    static { FSWSupplierDirective_1 = this; }
    static { this.REFRESH_KEY = 'fs-widgets-feature-supplier'; }
    constructor(_refreshService, _viewContainerRef) {
        this._refreshService = _refreshService;
        this._viewContainerRef = _viewContainerRef;
        this.updated = new EventEmitter();
        this.applicationId = null;
        this.salesOrCredit = BuyerSalesOrCredit.SALES;
        this.isReadonly = false;
    }
    ngOnInit() {
        this._refreshService
            .register(FSWSupplierDirective_1.REFRESH_KEY)
            .pipe(followDestroy(this), tap(() => this.refresh()))
            .subscribe();
    }
    ngOnChanges() {
        this.refresh();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    refresh() {
        this._viewContainerRef.clear();
        if (!this.applicationId) {
            return;
        }
        const ref = this._viewContainerRef.createComponent(FSWSupplierComponent);
        const instance = ref.instance;
        instance.applicationId.set(this.applicationId);
        instance.isReadonly.set(this.isReadonly);
        instance.salesOrCredit.set(this.salesOrCredit);
        instance.updated
            .asObservable()
            .pipe(followDestroy(this), tap((suppliers) => this.updated.emit(suppliers)))
            .subscribe();
        ref.changeDetectorRef.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSupplierDirective, deps: [{ token: RefreshService }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWSupplierDirective, isStandalone: true, selector: "[fswSupplier]", inputs: { applicationId: "applicationId", salesOrCredit: "salesOrCredit", isReadonly: "isReadonly" }, outputs: { updated: "updated" }, usesOnChanges: true, ngImport: i0 }); }
};
FSWSupplierDirective = FSWSupplierDirective_1 = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [RefreshService,
        ViewContainerRef])
], FSWSupplierDirective);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSupplierDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswSupplier]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: RefreshService }, { type: i0.ViewContainerRef }]; }, propDecorators: { updated: [{
                type: Output
            }], applicationId: [{
                type: Input,
                args: [{ required: true }]
            }], salesOrCredit: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

var fields$1 = {
	application_uuid: "Application UUID",
	application_number: "Application Number",
	loan_draft_id: "Loan Draft Id",
	created_by: "Created By"
};
var buttons$5 = {
	create: "Create Application"
};
var titles$1 = {
	create: "Create Application from BBS"
};
var messages = {
	create_success: "Application is successfully created"
};
var supportAll = {
	fields: fields$1,
	buttons: buttons$5,
	titles: titles$1,
	messages: messages
};

var ALL$4 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$5,
    default: supportAll,
    fields: fields$1,
    messages: messages,
    titles: titles$1
});

const SUPPORT_ALL_TRANSLATION = ALL$4;

function injectSupportForm(readonlyWhen$) {
    const form = new UntypedFormGroup({});
    const builder = new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'w-full flex flex-wrap gap-4',
        readonlyWhen$,
        form,
        fields: [
            {
                key: 'application_uuid',
                customClasses: 'w-[calc(100%-8px)]',
                type: FSWDynamicBuilderControlTypes.INPUT,
                context: {
                    label: SUPPORT_ALL_TRANSLATION.fields.application_uuid,
                    fullWidth: true,
                    isRequired: true,
                },
                validations: [Validators.required, Validators.minLength(36), validApplicationId],
            },
        ],
    });
    return { form, builder };
}
function injectOtherSupportForm(readonlyWhen$) {
    const form = new UntypedFormGroup({});
    const builder = new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'w-full flex flex-wrap gap-4',
        readonlyWhen$,
        form,
        fields: [
            {
                key: 'application_number',
                customClasses: 'w-[calc(100%-8px)]',
                type: FSWDynamicBuilderControlTypes.INPUT,
                context: {
                    label: SUPPORT_ALL_TRANSLATION.fields.application_number,
                    fullWidth: true,
                },
            },
            {
                key: 'loan_draft_id',
                customClasses: 'w-[calc(100%-8px)]',
                type: FSWDynamicBuilderControlTypes.INPUT,
                context: {
                    label: SUPPORT_ALL_TRANSLATION.fields.loan_draft_id,
                    fullWidth: true,
                },
            },
            {
                key: 'created_by',
                customClasses: 'w-[calc(100%-8px)]',
                type: FSWDynamicBuilderControlTypes.INPUT,
                context: {
                    label: SUPPORT_ALL_TRANSLATION.fields.created_by,
                    fullWidth: true,
                },
            },
        ],
    });
    return { form, builder };
}

function injectSupportEffects(applicationData, injector) {
    const applicationLoanDraftService = injectFSWAppLoanDraftService();
    const bbsLoanDraftService = injectFSWBBSLoanDraftService();
    const alertService = inject(FSW_ALERT_SERVICE_TOKEN);
    const applicationService = inject(APPLICATION_SERVICE_TOKEN);
    return {
        create: (application_uuid) => untracked(() => toSignalValue(toRxSignal(pipe(switchMap$1(() => applicationService.getApplication(application_uuid)), switchMap$1((res) => {
            if (!res?.additional_data?.loan_draft_id || !res?.product_group_identifier) {
                alertService.error('Something went wrong', 'Loan draft ID or product group identifier is missing', {
                    duration: 3000,
                });
                return throwError(() => 'Loan draft ID or product group identifier is missing');
            }
            return applicationLoanDraftService
                .deleteApplicationByLoanDraftId(res?.additional_data?.loan_draft_id, res?.product_group_identifier)
                .pipe(map(() => res));
        }), switchMap$1((res) => {
            if (!res?.additional_data?.loan_draft_id ||
                !res?.additional_data?.loan_draft_snapshot?.member?.uuid) {
                alertService.error('Something went wrong', 'Loan draft ID or member UUID is missing', {
                    duration: 3000,
                });
                return throwError(() => 'Loan draft ID or member UUID is missing');
            }
            return bbsLoanDraftService.invokeAfterSubmitLoanDraft(res?.additional_data?.loan_draft_id, res?.additional_data?.loan_draft_snapshot?.member?.uuid);
        }), switchMap$1((application_uuid) => {
            if (!application_uuid) {
                alertService.error('Something went wrong', 'New Application UUID is missing', {
                    duration: 3000,
                });
                return throwError(() => 'New Application UUID is missing');
            }
            return applicationService.getApplication(application_uuid);
        }), tap((res) => applicationData.set(res)), tap(() => alertService.success('Application is successfully created!', null, {
            duration: 3000,
        }))), injector))),
    };
}

function provideSupportTranslation(scope = 'support') {
    return [
        ...(FSWTranslateModule.forFeature({
            scope,
            defaultKey: getCountryCodeFromStorage() ?? CountryCode.MY,
            data: {
                [CountryCode.MY]: SUPPORT_ALL_TRANSLATION,
                [CountryCode.TH]: SUPPORT_ALL_TRANSLATION,
                [CountryCode.VU]: SUPPORT_ALL_TRANSLATION,
                [CountryCode.ID]: SUPPORT_ALL_TRANSLATION,
                [CountryCode.ZI]: SUPPORT_ALL_TRANSLATION,
                [CountryCode.SG]: SUPPORT_ALL_TRANSLATION,
                [CountryCode.ZU]: SUPPORT_ALL_TRANSLATION,
                [CountryCode.ZV]: SUPPORT_ALL_TRANSLATION,
                [CountryCode.VN]: SUPPORT_ALL_TRANSLATION,
            },
        }).providers || []),
        fswTranslateScope('support'),
    ];
}

class FSWSupportComponent {
    constructor() {
        this.updated = new EventEmitter();
        this.isReadonly = signal(false);
        this.applicationData = signal(null);
        this.refreshedAt = signal(null);
        this.effects = injectSupportEffects(this.applicationData, inject(Injector));
        this.readonlyWhen$ = new BehaviorSubject(false); // later could be based on some condition
        this.formConfig = injectSupportForm(this.readonlyWhen$);
        this.otherFormConfig = injectOtherSupportForm(of(true)); // always readonly
        this.masterDataService = inject(MASTER_DATA_SERVICE_TOKEN);
        this.BuyerSalesOrCredit = BuyerSalesOrCredit;
        this.injector = inject(Injector);
        effect(() => {
            if (this.applicationData()) {
                const application = this.applicationData();
                this.otherFormConfig.form.patchValue({
                    application_number: application?.number,
                    loan_draft_id: application?.additional_data?.loan_draft_id,
                    created_by: application?.created_by,
                });
            }
        }, { allowSignalWrites: true });
    }
    create() {
        if (this.formConfig?.form?.valid) {
            this.effects.create(this.formConfig?.form?.value?.application_uuid);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSupportComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWSupportComponent, isStandalone: true, selector: "fsw-support", outputs: { updated: "updated" }, providers: [
            provideFSWAppLoanDraftService(),
            provideFSWBBSLoanDraftService(),
            provideSupportTranslation(),
        ], ngImport: i0, template: "<section class=\"flex gap-16 p-5\">\n  <fsw-modal\n    [size]=\"'s'\"\n    [title]=\"'titles.create' | fswTranslate\"\n    [bodyCustomClasses]=\"'max-h-[calc(90vh-138px)] overflow-y-auto'\"\n    [hiddenFooter]=\"false\"\n    [hiddenCloseButton]=\"true\"\n  >\n    <ng-template fswModalBody>\n      <form [formGroup]=\"formConfig.form\">\n        <fsw-dynamic-builder [builder]=\"formConfig.builder\"></fsw-dynamic-builder>\n      </form>\n    </ng-template>\n    <ng-template fswModalFooter>\n      <section class=\"flex justify-between w-full items-center\">\n        <aside>\n          <div></div>\n        </aside>\n        <main class=\"flex gap-[16px] items-center\">\n          <button\n            fswButton\n            [appearance]=\"'secondary'\"\n            [attr.data-test-id]=\"'supplier-save-modal-cancel'\"\n            [disabled]=\"formConfig.form.invalid\"\n            (click)=\"create()\"\n          >\n            {{ 'buttons.create' | fswTranslate }}\n          </button>\n        </main>\n      </section>\n    </ng-template>\n  </fsw-modal>\n\n  <div class=\"animate\">\n    <section *ngIf=\"applicationData()\">\n      <main class=\"fsw-modal fsw-modal--size-m h-[285px]\">\n        <div class=\"w-full pt-[32px] pr-[32px] pb-0 pl-[32px] text-green-700\">\n          <h6>{{ 'messages.create_success' | fswTranslate }}</h6>\n        </div>\n\n        <main>\n          <form [formGroup]=\"otherFormConfig.form\">\n            <fsw-dynamic-builder [builder]=\"otherFormConfig.builder\"></fsw-dynamic-builder>\n          </form>\n        </main>\n      </main>\n    </section>\n  </div>\n</section>\n", styles: ["@keyframes slide-in{0%{transform:translate(100%);opacity:0}to{transform:translate(0);opacity:1}}.animate{animation:slide-in 1s ease-out forwards}\n"], dependencies: [{ kind: "ngmodule", type: FSWModalModule$1 }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "directive", type: i1$4.FSWModalFooterDirective, selector: "ng-template[fswModalFooter]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "ngmodule", type: FSWAlertModule }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: FSWDynamicBuilderModule }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: CurrencyFormatModule }, { kind: "ngmodule", type: FSWIconModule }, { kind: "ngmodule", type: MasterDataServiceModule }, { kind: "ngmodule", type: FSWRadioModule }, { kind: "ngmodule", type: FormsModule }, { kind: "ngmodule", type: FSWTagsModule }, { kind: "ngmodule", type: ApplicationServiceModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSupportComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-support', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [
                        provideFSWAppLoanDraftService(),
                        provideFSWBBSLoanDraftService(),
                        provideSupportTranslation(),
                    ], imports: [
                        FSWModalModule$1,
                        FSWAlertModule,
                        FSWTranslateModule,
                        FSWButtonModule,
                        ReactiveFormsModule,
                        FSWDynamicBuilderModule,
                        NgIf,
                        NgForOf,
                        CurrencyFormatModule,
                        FSWIconModule,
                        MasterDataServiceModule,
                        FSWRadioModule,
                        FormsModule,
                        FSWTagsModule,
                        ApplicationServiceModule,
                    ], template: "<section class=\"flex gap-16 p-5\">\n  <fsw-modal\n    [size]=\"'s'\"\n    [title]=\"'titles.create' | fswTranslate\"\n    [bodyCustomClasses]=\"'max-h-[calc(90vh-138px)] overflow-y-auto'\"\n    [hiddenFooter]=\"false\"\n    [hiddenCloseButton]=\"true\"\n  >\n    <ng-template fswModalBody>\n      <form [formGroup]=\"formConfig.form\">\n        <fsw-dynamic-builder [builder]=\"formConfig.builder\"></fsw-dynamic-builder>\n      </form>\n    </ng-template>\n    <ng-template fswModalFooter>\n      <section class=\"flex justify-between w-full items-center\">\n        <aside>\n          <div></div>\n        </aside>\n        <main class=\"flex gap-[16px] items-center\">\n          <button\n            fswButton\n            [appearance]=\"'secondary'\"\n            [attr.data-test-id]=\"'supplier-save-modal-cancel'\"\n            [disabled]=\"formConfig.form.invalid\"\n            (click)=\"create()\"\n          >\n            {{ 'buttons.create' | fswTranslate }}\n          </button>\n        </main>\n      </section>\n    </ng-template>\n  </fsw-modal>\n\n  <div class=\"animate\">\n    <section *ngIf=\"applicationData()\">\n      <main class=\"fsw-modal fsw-modal--size-m h-[285px]\">\n        <div class=\"w-full pt-[32px] pr-[32px] pb-0 pl-[32px] text-green-700\">\n          <h6>{{ 'messages.create_success' | fswTranslate }}</h6>\n        </div>\n\n        <main>\n          <form [formGroup]=\"otherFormConfig.form\">\n            <fsw-dynamic-builder [builder]=\"otherFormConfig.builder\"></fsw-dynamic-builder>\n          </form>\n        </main>\n      </main>\n    </section>\n  </div>\n</section>\n", styles: ["@keyframes slide-in{0%{transform:translate(100%);opacity:0}to{transform:translate(0);opacity:1}}.animate{animation:slide-in 1s ease-out forwards}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { updated: [{
                type: Output
            }] } });

let FSWSupportDirective = class FSWSupportDirective {
    constructor(_refreshService, _viewContainerRef) {
        this._refreshService = _refreshService;
        this._viewContainerRef = _viewContainerRef;
        this.updated = new EventEmitter();
        this.isReadonly = false;
    }
    ngOnInit() {
        this._init();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
    }
    _init() {
        this._viewContainerRef.clear();
        const ref = this._viewContainerRef.createComponent(FSWSupportComponent);
        const instance = ref.instance;
        instance.isReadonly.set(this.isReadonly);
        ref.changeDetectorRef.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSupportDirective, deps: [{ token: RefreshService }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWSupportDirective, isStandalone: true, selector: "[fswSupport]", inputs: { isReadonly: "isReadonly" }, outputs: { updated: "updated" }, ngImport: i0 }); }
};
FSWSupportDirective = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [RefreshService,
        ViewContainerRef])
], FSWSupportDirective);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSupportDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswSupport]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: RefreshService }, { type: i0.ViewContainerRef }]; }, propDecorators: { updated: [{
                type: Output
            }], isReadonly: [{
                type: Input
            }] } });

var titles = {
	main: "World Check",
	case_detail_screen: "Case Detail",
	case_new_screen: "New Case",
	link_detail_screen: "Link Detail",
	result_detail_screen: "Result Detail",
	snapshot_detail_screen: "Snapshot Detail",
	snapshot_information_screen: "Case Detail - Snapshot Mode",
	link_screen: "Links",
	case_screen: "Cases",
	result_screen: "Results",
	activity_screen: "Activity",
	snapshot_screen: "Snapshots",
	group_screen: "Groups",
	user_screen: "Users",
	record_screen: "Records"
};
var forms$2 = {
	supplement: {
		title: "Supplement",
		fields: {
			edd: "EDD"
		}
	},
	"case": {
		title: "Case Information",
		fields: {
			case_id: "Case ID",
			case_system_id: "Case System ID",
			name: "Name",
			group_id: "Group",
			assignee: "Assignee",
			entity_type: "Entity Type",
			provider_type: "Provider Type",
			entity_id: "Entity ID",
			name_transposition: "Name Transposition",
			state: "State",
			country: "Country",
			department: "Department",
			reference: "Reference",
			date_of_birth: "Date of Birth",
			place_of_birth: "Place of Birth",
			gender: "Gender",
			citizenship: "Citizenship",
			identification_country: "Identification Country",
			identification_type: "Identification Type",
			identification_number: "Identification Number",
			passport_given_name: "Passport Given Name",
			passport_last_name: "Passport Last Name",
			passport_issuing_state: "Passport Issuing State",
			passport_nationality: "Passport Nationality",
			passport_document_type: "Passport Document Type",
			passport_id_number: "Passport ID Number",
			passport_date_of_expiry: "Passport Date of Expiry",
			passport_date_of_birth: "Passport Date of Birth",
			passport_gender: "Passport Gender",
			duplicate_check: "Duplicate Check"
		}
	},
	search: {
		title: "Browse Cases",
		fields: {
			case_id: "Case ID",
			primary_name: "Primary Name",
			case_system_id: "Case System ID",
			id_numbers_value: "ID Numbers Value",
			group_id: "Group",
			created_by: "Creator User ID",
			updated_by: "Modifier User ID",
			assigned_to: "Assignee User ID",
			provider_type: "Provider Type",
			entity_type: "Entity Type"
		}
	}
};
var modals = {
	review: {
		title: "Review",
		fields: {
			remark: "Remark"
		}
	},
	resolution: {
		title: "Resolution",
		fields: {
			status: "Status",
			risk: "Risk Level",
			reason: "Reason",
			remark: "Remark"
		}
	},
	re_screening: {
		title: "Re-screening",
		fields: {
			screening_mode: "Screening Mode",
			case_info: "Case Info"
		}
	},
	assign: {
		title: "Assign",
		fields: {
			email: "Email",
			note: "Note"
		}
	},
	un_assign: {
		title: "Un-assign",
		description: "Are you sure to un assign the case ?"
	},
	archive: {
		title: "Archive",
		description: "This will put the case into a state from which it can be either unarchived or deleted. The user must be active and have the archive permission."
	},
	un_archive: {
		title: "Un Archive",
		description: "Are you sure want to un archive this case ?"
	},
	"delete": {
		title: "Delete",
		description: "Are you sure want to delete this record ?",
		warning: "You will lost the information, Are you sure want to delete this record ?"
	},
	update: {
		title: "Update",
		description: "Are you sure want to update this record ?",
		warning: "Previous information will be replaced, Are you sure want to update this record ?"
	},
	link: {
		title: "Link Case",
		description: "Are you sure want to link this case ?"
	}
};
var tables$1 = {
	activity: {
		created_at: "Created At",
		message: "Message"
	},
	"case": {
		case_id: "Case ID",
		name: "Name",
		status: "Status",
		case_system_id: "Case System ID",
		group_id: "Group",
		entity_type: "Entity Type",
		provider_type: "Provider Type",
		id_number: "ID Number",
		last_screen: "Last Screen",
		linked: "Linked",
		available: "Not linked yet",
		unresolved: "Unresolved",
		all: "All"
	},
	link: {
		id: "ID",
		case_id: "Case ID",
		status: "Status",
		created_at: "Created At"
	},
	snapshot: {
		id: "ID",
		case_id: "Case ID",
		report_id: "Report ID",
		status: "Status",
		created_by: "Created By",
		created_at: "Created At",
		updated_at: "Updated At",
		action: "Action",
		error: "Error"
	},
	result: {
		name: "Name",
		match_strength: "Match Strength",
		match_score: "Match Score",
		match_name_type: "Match Name Type",
		registered_country: "Registered Country",
		category: "Category",
		special_interest_categories: "Special Interest Categories",
		resolution: "Resolution",
		result_id: "Result ID",
		reference_id: "Reference ID",
		remark: "Resolution Remark",
		review_remark: "Review Remark",
		date_of_birth: "Date of Birth",
		gender: "Gender",
		citizenship: "Citizenship",
		entered_date: "Entered Date"
	},
	source: {
		date: "Date",
		link: "Link"
	},
	location: {
		street: "Street",
		city: "City",
		region: "Region",
		country: "Country",
		postcode: "Postcode"
	},
	reference: {
		entity_type: "Entity Type",
		actions: "Actions",
		active: "Active",
		addresses: "Addresses",
		associates: "Associates",
		category: "Category",
		comments: "Comments",
		contacts: "Contacts",
		country_links: "Country Links",
		creation_date: "Creation Date",
		deletion_date: "Deletion Date",
		description: "Description",
		details: "Details",
		entity_id: "Entity ID",
		external_import_id: "External Import ID",
		files: "Files",
		identity_documents: "Identity Documents",
		images: "Images",
		last_adjudication_date: "Last Adjudication Date",
		modification_date: "Modification Date",
		names: "Names",
		previous_country_links: "Previous Country Links",
		provider: "Provider",
		source_description: "Source Description",
		source_uris: "Source URIs",
		sources: "Sources",
		sub_category: "Sub Category",
		update_category: "Update Category",
		updated_dates: "Updated Dates",
		weblinks: "Weblinks",
		translated_entity: "Translated Entity",
		age: "Age",
		age_as_of_date: "Age as of Date",
		events: "Events",
		gender: "Gender",
		is_deceased: "Is Deceased",
		roles: "Roles"
	},
	update: {
		categorization: "Categorization",
		entered_date: "Entered Date",
		updated_date: "Updated Date"
	}
};
var containers = {
	summary: {
		title: "Summary",
		fields: {
			match_strength: "Match Strength",
			match_score: "Match Score",
			match_name_type: "Match Name Type",
			resolution: "Resolution",
			remark: "Resolution Remark",
			review_remark: "Review Remark"
		}
	},
	key_data: {
		title: "Key Data",
		fields: {
			name: "Name",
			category: "Category",
			special_interest_categories: "Special Interest Categories",
			gender: "Gender",
			date_of_birth: "Date of Birth",
			citizenship: "Citizenship",
			age: "Age",
			update: "Update",
			location_details: "Location Details"
		}
	},
	information: {
		title: "Information",
		fields: {
			biography: "Biography",
			identification: "Identification",
			reports: "Reports"
		}
	},
	source: {
		title: "Source",
		fields: {
			date: "Date",
			link: "Link"
		}
	},
	warning: {
		title: "World Check Information",
		description: "The current access role has these information:",
		default_group: "The default group is <strong>{{group}}</strong>",
		not_allow_resolution: "Not allow to <strong>resolution</strong>",
		not_allow_screening: "Not allow to <strong>screening</strong>",
		allow_resolution: "Allow to <strong>resolution</strong>",
		allow_screening: "Allow to <strong>screening</strong>"
	}
};
var buttons$4 = {
	refresh: "Refresh",
	back: "Back",
	save: "Save Changes",
	cancel: "Cancel",
	download: "Download",
	resolution: "Resolution",
	update: "Update",
	search: "Search",
	"new": "New Case",
	"delete": "Delete",
	report: "Report",
	review: "Review",
	trigger: "Export Snapshot",
	re_trigger: "Re-trigger",
	archive: "Archive",
	un_archive: "Un-archive",
	assign: "Assign",
	un_assign: "Un-Assign",
	re_screening: "Re-screening",
	view_error: "View Error",
	detail: "Detail",
	pick: "Link existing cases",
	"import": "Import",
	link: "Link",
	un_link: "Un-Link",
	screen: "Screen",
	no_cache: "No Cache",
	no_lock: "No Lock",
	clear: "Clear"
};
var information = {
	no_cache: "Refreshes data without using cached results, ensuring the latest information is retrieved.",
	no_lock: "Allows updates even if a snapshot process is still in progress, unlocking the update operation."
};
var worldCheckAll = {
	titles: titles,
	forms: forms$2,
	modals: modals,
	tables: tables$1,
	containers: containers,
	buttons: buttons$4,
	information: information
};

var ALL$3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$4,
    containers: containers,
    default: worldCheckAll,
    forms: forms$2,
    information: information,
    modals: modals,
    tables: tables$1,
    titles: titles
});

const WORLD_CHECK_ALL_TRANSLATION = ALL$3;

function injectWorldCheckTranslation() {
    return {
        [CountryCode.MY]: WORLD_CHECK_ALL_TRANSLATION,
        [CountryCode.TH]: WORLD_CHECK_ALL_TRANSLATION,
        [CountryCode.VU]: WORLD_CHECK_ALL_TRANSLATION,
        [CountryCode.ID]: WORLD_CHECK_ALL_TRANSLATION,
        [CountryCode.ZI]: WORLD_CHECK_ALL_TRANSLATION,
        [CountryCode.SG]: WORLD_CHECK_ALL_TRANSLATION,
        [CountryCode.ZU]: WORLD_CHECK_ALL_TRANSLATION,
        [CountryCode.ZV]: WORLD_CHECK_ALL_TRANSLATION,
        [CountryCode.VN]: WORLD_CHECK_ALL_TRANSLATION,
    };
}
function injectWorldCheckTranslationByCountryCode() {
    return injectWorldCheckTranslation()[getCountryCodeFromStorage()];
}

function provideWorldCheckTranslation(scope = 'world_check') {
    return [
        ...(FSWTranslateModule.forFeature({
            scope,
            defaultKey: getCountryCodeFromStorage() ?? CountryCode.MY,
            data: injectWorldCheckTranslation(),
        }).providers || []),
        fswTranslateScope(scope),
    ];
}

class FSWWorldCheckLogoComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckLogoComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckLogoComponent, isStandalone: true, selector: "fsw-world-check-logo", ngImport: i0, template: "<label class=\"flex flex-col gap-[8px]\">\n  <svg class=\"h-[20px]\" id=\"logo\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 187.28 16.65\">\n    <defs>\n      <style>\n        .cls-1 {\n          fill: #001eff;\n        }\n\n        .cls-1,\n        .cls-2 {\n          stroke-width: 0px;\n        }\n      </style>\n    </defs>\n    <path\n      class=\"cls-1\"\n      d=\"m0,16.28c.37-.64.62-1.95.62-3.31V4.19C.62,2.83.37,1.52,0,.88v-.12h4.44v.12c-.37.64-.62,1.95-.62,3.31v9.91h1.43c2,0,3.59-.28,4.81-.9h.11v3.2H0v-.12Z\"\n    />\n    <path\n      class=\"cls-1\"\n      d=\"m11.41,15.73v-3.43h.09c1.49,1.36,2.78,1.93,4.44,1.93s2.53-.62,2.53-1.84c0-1.33-1.13-1.72-3.15-2.53-2.21-.85-4.23-1.75-4.23-4.58,0-2.97,2.16-4.78,5.7-4.78,1.29,0,2.55.23,3.56.67v3.17h-.09c-1.17-.97-2.28-1.42-3.56-1.42-1.54,0-2.41.64-2.41,1.86,0,1.33,1.13,1.72,3.15,2.53,2.21.85,4.23,1.75,4.23,4.58s-2.23,4.76-5.84,4.76c-1.54,0-3.17-.34-4.42-.92Z\"\n    />\n    <path\n      class=\"cls-1\"\n      d=\"m23.48,16.28c.37-.64.62-1.95.62-3.31V4.19c0-1.36-.25-2.67-.62-3.31v-.12h9.96v2.97h-.07c-.9-.46-2.35-.67-4.25-.67h-1.82v4.07h1.77c1.68,0,2.58-.12,3.4-.3h.09v3.04h-.09c-.83-.18-1.72-.28-3.4-.28h-1.77v4.51h1.77c2,0,3.63-.28,4.81-.87h.11v3.17h-10.51v-.12Z\"\n    />\n    <path\n      class=\"cls-1\"\n      d=\"m35.79,8.63c0-4.97,3.33-8.12,8.48-8.12,1.56,0,3.15.3,4.14.76v3.2h-.09c-1.01-.92-2.48-1.47-4.09-1.47-3.24,0-5.15,2-5.15,5.52s2.07,5.68,5.66,5.68c.48,0,.97-.05,1.43-.14v-3.86c-1.43,0-2.23.09-2.94.25h-.12v-2.97h.12c.74.14,1.59.25,3.1.25h3.17v.09c-.18.41-.25,1.29-.25,2.23v3.7c0,.97.07,1.63.18,2.05v.09c-1.26.41-3.24.76-4.67.76-5.45,0-8.97-3.17-8.97-8.03Z\"\n    />\n    <path\n      class=\"cls-2\"\n      d=\"m63.59,16.4h-3.84l-2.83-12.72c-.15-.71-.3-1.24-.43-1.6s-.33-.76-.61-1.21v-.11h4.74v.11c-.28.35-.45.79-.52,1.32-.07.53-.03,1.16.13,1.9l1.82,8.58,3.1-11.91h2.99l3.15,11.91,1.79-8.58c.14-.71.18-1.33.11-1.86-.06-.54-.23-.99-.51-1.36v-.11h4.21v.11c-.23.35-.41.71-.55,1.08-.14.37-.29.94-.46,1.73l-2.88,12.72h-3.86l-2.78-10.49-2.78,10.49Z\"\n    />\n    <path\n      class=\"cls-2\"\n      d=\"m88.54,10.97c0,1.69-.54,3.05-1.63,4.11-1.09,1.05-2.51,1.58-4.25,1.58s-3.16-.51-4.23-1.53c-1.07-1.02-1.61-2.35-1.61-3.99s.54-3.06,1.63-4.11c1.09-1.05,2.51-1.58,4.25-1.58s3.16.51,4.23,1.53c1.07,1.02,1.61,2.35,1.61,3.99Zm-8.58,0c0,1.1.24,1.96.72,2.56.48.61,1.15.91,2.01.91s1.52-.29,1.99-.86c.47-.58.7-1.39.7-2.45s-.24-1.94-.72-2.55c-.48-.61-1.15-.92-2.01-.92s-1.52.29-1.99.86c-.47.58-.7,1.39-.7,2.45Z\"\n    />\n    <path\n      class=\"cls-2\"\n      d=\"m90.22,16.4v-.12c.15-.28.27-.64.35-1.09.08-.45.11-.99.11-1.62v-4.05c0-.9-.05-1.58-.15-2.01-.1-.44-.28-.71-.54-.82v-.12l3.47-1.13h.14v1.96c.41-.57.85-.99,1.32-1.28.47-.28.95-.43,1.44-.43.11,0,.22,0,.33.02.11.02.25.05.4.09v2.9h-.09c-.14-.06-.3-.11-.48-.14-.18-.03-.36-.05-.53-.05-.44,0-.85.1-1.21.31s-.71.52-1.05.96v3.81c0,.62.04,1.15.11,1.6s.19.8.35,1.08v.12h-3.98Z\"\n    />\n    <path\n      class=\"cls-2\"\n      d=\"m102.3,16.4h-3.98v-.12c.15-.28.27-.64.34-1.09s.12-.99.12-1.62V3.7c0-.9-.05-1.58-.15-2.01-.1-.44-.28-.71-.54-.82v-.11l3.61-.76h.14v13.57c0,.63.04,1.17.11,1.62s.19.82.35,1.09v.12Z\"\n    />\n    <path\n      class=\"cls-2\"\n      d=\"m112.42,15.07c-.43.49-.9.88-1.43,1.16-.52.28-1.1.43-1.75.43-1.55,0-2.83-.52-3.83-1.56-1-1.04-1.51-2.36-1.51-3.96,0-1.69.5-3.06,1.49-4.11,1-1.05,2.29-1.58,3.89-1.58.57,0,1.1.07,1.61.21.51.14.97.34,1.38.6v-2.55c0-.9-.05-1.58-.15-2.01-.1-.44-.28-.71-.54-.82v-.11l3.61-.76h.14v13.38c0,.55.05,1.06.15,1.53.1.47.24.86.43,1.16v.09l-3.04.23c-.11-.14-.2-.32-.29-.55-.08-.23-.14-.49-.17-.78Zm-2.62-7.29c-.8,0-1.45.3-1.97.9-.51.6-.77,1.36-.77,2.3s.25,1.71.75,2.32c.5.61,1.12.92,1.87.92.6,0,1.12-.14,1.56-.41.44-.28.79-.68,1.03-1.22v-3.86c-.29-.31-.65-.54-1.07-.7-.42-.16-.89-.24-1.41-.24Z\"\n    />\n    <path class=\"cls-2\" d=\"m123.48,11.68h-6.09v-2.67h6.09v2.67Z\" />\n    <path\n      class=\"cls-2\"\n      d=\"m133.3,16.65c-2.42,0-4.38-.74-5.87-2.21s-2.23-3.41-2.23-5.82.74-4.4,2.23-5.89,3.45-2.23,5.89-2.23c.86,0,1.67.08,2.44.25.77.17,1.46.41,2.07.74v3.24h-.11c-.55-.57-1.21-1-1.97-1.3-.76-.3-1.57-.45-2.43-.45-1.5,0-2.69.5-3.55,1.48-.87.99-1.3,2.33-1.3,4.04s.44,3.15,1.31,4.15,2.07,1.51,3.59,1.51c.81,0,1.59-.16,2.35-.48.75-.32,1.42-.78,2-1.38h.11v3.36c-.64.32-1.36.57-2.15.74-.79.17-1.58.25-2.38.25Z\"\n    />\n    <path\n      class=\"cls-2\"\n      d=\"m143.86,16.28v.12h-3.98v-.12c.15-.28.27-.64.34-1.09s.12-.99.12-1.62V3.7c0-.9-.05-1.58-.15-2.01-.1-.44-.28-.71-.54-.82v-.11l3.61-.76h.14v6.74c.66-.44,1.29-.77,1.9-.98.61-.21,1.22-.31,1.85-.31,1.2,0,2.09.34,2.69,1.01.6.67.9,1.68.9,3.01v4.07c0,.64.04,1.18.11,1.64s.19.83.35,1.1v.12h-3.98v-.12c.15-.28.27-.65.34-1.11s.12-1.01.12-1.64v-3.96c0-.58-.12-1-.37-1.26-.25-.26-.63-.4-1.15-.4-.44,0-.89.09-1.32.28s-.92.48-1.44.89v4.45c0,.64.04,1.19.11,1.64s.19.83.35,1.11Z\"\n    />\n    <path\n      class=\"cls-2\"\n      d=\"m158.81,16.65c-1.81,0-3.27-.51-4.39-1.53s-1.68-2.35-1.68-3.99.51-3.07,1.52-4.12c1.01-1.04,2.35-1.56,4.02-1.56,1.53,0,2.76.44,3.68,1.32.92.88,1.38,2.07,1.38,3.55,0,.2-.01.42-.03.66-.02.24-.07.53-.13.88h-7.25c.12.86.48,1.52,1.06,1.99.58.47,1.34.7,2.28.7.61,0,1.21-.12,1.79-.37.58-.25,1.1-.6,1.54-1.06h.12v2.25c-.52.41-1.12.73-1.79.94-.68.21-1.38.32-2.12.32Zm-.58-9.11c-.67,0-1.2.18-1.59.55s-.62.93-.71,1.68h4.25c-.02-.74-.18-1.29-.51-1.67-.32-.38-.81-.56-1.45-.56Z\"\n    />\n    <path\n      class=\"cls-2\"\n      d=\"m170.4,16.65c-1.63,0-2.98-.52-4.06-1.56-1.08-1.04-1.62-2.36-1.62-3.96s.57-3,1.7-4.07,2.55-1.61,4.25-1.61c.55,0,1.12.07,1.71.2.59.13,1.13.3,1.62.52v2.62h-.12c-.48-.4-.96-.69-1.46-.87-.5-.18-1.04-.28-1.62-.28-.89,0-1.6.3-2.14.9-.54.6-.8,1.4-.8,2.42s.29,1.88.89,2.51c.59.63,1.36.94,2.31.94.52,0,1.01-.09,1.46-.28.45-.18.91-.47,1.37-.85h.12v2.3c-.41.34-.95.6-1.6.79-.65.19-1.32.29-2.01.29Z\"\n    />\n    <path\n      class=\"cls-2\"\n      d=\"m175.71,16.4v-.12c.15-.28.27-.64.34-1.09s.12-.99.12-1.62V3.7c0-.9-.05-1.58-.15-2.01-.1-.44-.28-.71-.54-.82v-.11l3.61-.76h.14v9.98l2.07-2.14c.37-.37.64-.72.83-1.07.18-.34.27-.66.25-.95v-.12h4.67v.12c-.34.18-.69.42-1.05.71-.36.29-.8.7-1.32,1.22l-2.74,2.67,3.08,3.7c.41.49.8.91,1.16,1.27.36.35.72.65,1.09.9v.12h-3.75c-.29-.11-.61-.32-.95-.64-.34-.32-.73-.78-1.16-1.38l-2.18-3.01v2.21c0,.63.04,1.17.11,1.62s.19.82.35,1.09v.12h-3.98Z\"\n    />\n  </svg>\n  <span class=\"text-body-small-caption-400 text-gray-700 font-bold\">\n    Powered by LSEG World-Check One\n  </span>\n</label>\n", changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckLogoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-logo', standalone: true, changeDetection: ChangeDetectionStrategy.OnPush, template: "<label class=\"flex flex-col gap-[8px]\">\n  <svg class=\"h-[20px]\" id=\"logo\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 187.28 16.65\">\n    <defs>\n      <style>\n        .cls-1 {\n          fill: #001eff;\n        }\n\n        .cls-1,\n        .cls-2 {\n          stroke-width: 0px;\n        }\n      </style>\n    </defs>\n    <path\n      class=\"cls-1\"\n      d=\"m0,16.28c.37-.64.62-1.95.62-3.31V4.19C.62,2.83.37,1.52,0,.88v-.12h4.44v.12c-.37.64-.62,1.95-.62,3.31v9.91h1.43c2,0,3.59-.28,4.81-.9h.11v3.2H0v-.12Z\"\n    />\n    <path\n      class=\"cls-1\"\n      d=\"m11.41,15.73v-3.43h.09c1.49,1.36,2.78,1.93,4.44,1.93s2.53-.62,2.53-1.84c0-1.33-1.13-1.72-3.15-2.53-2.21-.85-4.23-1.75-4.23-4.58,0-2.97,2.16-4.78,5.7-4.78,1.29,0,2.55.23,3.56.67v3.17h-.09c-1.17-.97-2.28-1.42-3.56-1.42-1.54,0-2.41.64-2.41,1.86,0,1.33,1.13,1.72,3.15,2.53,2.21.85,4.23,1.75,4.23,4.58s-2.23,4.76-5.84,4.76c-1.54,0-3.17-.34-4.42-.92Z\"\n    />\n    <path\n      class=\"cls-1\"\n      d=\"m23.48,16.28c.37-.64.62-1.95.62-3.31V4.19c0-1.36-.25-2.67-.62-3.31v-.12h9.96v2.97h-.07c-.9-.46-2.35-.67-4.25-.67h-1.82v4.07h1.77c1.68,0,2.58-.12,3.4-.3h.09v3.04h-.09c-.83-.18-1.72-.28-3.4-.28h-1.77v4.51h1.77c2,0,3.63-.28,4.81-.87h.11v3.17h-10.51v-.12Z\"\n    />\n    <path\n      class=\"cls-1\"\n      d=\"m35.79,8.63c0-4.97,3.33-8.12,8.48-8.12,1.56,0,3.15.3,4.14.76v3.2h-.09c-1.01-.92-2.48-1.47-4.09-1.47-3.24,0-5.15,2-5.15,5.52s2.07,5.68,5.66,5.68c.48,0,.97-.05,1.43-.14v-3.86c-1.43,0-2.23.09-2.94.25h-.12v-2.97h.12c.74.14,1.59.25,3.1.25h3.17v.09c-.18.41-.25,1.29-.25,2.23v3.7c0,.97.07,1.63.18,2.05v.09c-1.26.41-3.24.76-4.67.76-5.45,0-8.97-3.17-8.97-8.03Z\"\n    />\n    <path\n      class=\"cls-2\"\n      d=\"m63.59,16.4h-3.84l-2.83-12.72c-.15-.71-.3-1.24-.43-1.6s-.33-.76-.61-1.21v-.11h4.74v.11c-.28.35-.45.79-.52,1.32-.07.53-.03,1.16.13,1.9l1.82,8.58,3.1-11.91h2.99l3.15,11.91,1.79-8.58c.14-.71.18-1.33.11-1.86-.06-.54-.23-.99-.51-1.36v-.11h4.21v.11c-.23.35-.41.71-.55,1.08-.14.37-.29.94-.46,1.73l-2.88,12.72h-3.86l-2.78-10.49-2.78,10.49Z\"\n    />\n    <path\n      class=\"cls-2\"\n      d=\"m88.54,10.97c0,1.69-.54,3.05-1.63,4.11-1.09,1.05-2.51,1.58-4.25,1.58s-3.16-.51-4.23-1.53c-1.07-1.02-1.61-2.35-1.61-3.99s.54-3.06,1.63-4.11c1.09-1.05,2.51-1.58,4.25-1.58s3.16.51,4.23,1.53c1.07,1.02,1.61,2.35,1.61,3.99Zm-8.58,0c0,1.1.24,1.96.72,2.56.48.61,1.15.91,2.01.91s1.52-.29,1.99-.86c.47-.58.7-1.39.7-2.45s-.24-1.94-.72-2.55c-.48-.61-1.15-.92-2.01-.92s-1.52.29-1.99.86c-.47.58-.7,1.39-.7,2.45Z\"\n    />\n    <path\n      class=\"cls-2\"\n      d=\"m90.22,16.4v-.12c.15-.28.27-.64.35-1.09.08-.45.11-.99.11-1.62v-4.05c0-.9-.05-1.58-.15-2.01-.1-.44-.28-.71-.54-.82v-.12l3.47-1.13h.14v1.96c.41-.57.85-.99,1.32-1.28.47-.28.95-.43,1.44-.43.11,0,.22,0,.33.02.11.02.25.05.4.09v2.9h-.09c-.14-.06-.3-.11-.48-.14-.18-.03-.36-.05-.53-.05-.44,0-.85.1-1.21.31s-.71.52-1.05.96v3.81c0,.62.04,1.15.11,1.6s.19.8.35,1.08v.12h-3.98Z\"\n    />\n    <path\n      class=\"cls-2\"\n      d=\"m102.3,16.4h-3.98v-.12c.15-.28.27-.64.34-1.09s.12-.99.12-1.62V3.7c0-.9-.05-1.58-.15-2.01-.1-.44-.28-.71-.54-.82v-.11l3.61-.76h.14v13.57c0,.63.04,1.17.11,1.62s.19.82.35,1.09v.12Z\"\n    />\n    <path\n      class=\"cls-2\"\n      d=\"m112.42,15.07c-.43.49-.9.88-1.43,1.16-.52.28-1.1.43-1.75.43-1.55,0-2.83-.52-3.83-1.56-1-1.04-1.51-2.36-1.51-3.96,0-1.69.5-3.06,1.49-4.11,1-1.05,2.29-1.58,3.89-1.58.57,0,1.1.07,1.61.21.51.14.97.34,1.38.6v-2.55c0-.9-.05-1.58-.15-2.01-.1-.44-.28-.71-.54-.82v-.11l3.61-.76h.14v13.38c0,.55.05,1.06.15,1.53.1.47.24.86.43,1.16v.09l-3.04.23c-.11-.14-.2-.32-.29-.55-.08-.23-.14-.49-.17-.78Zm-2.62-7.29c-.8,0-1.45.3-1.97.9-.51.6-.77,1.36-.77,2.3s.25,1.71.75,2.32c.5.61,1.12.92,1.87.92.6,0,1.12-.14,1.56-.41.44-.28.79-.68,1.03-1.22v-3.86c-.29-.31-.65-.54-1.07-.7-.42-.16-.89-.24-1.41-.24Z\"\n    />\n    <path class=\"cls-2\" d=\"m123.48,11.68h-6.09v-2.67h6.09v2.67Z\" />\n    <path\n      class=\"cls-2\"\n      d=\"m133.3,16.65c-2.42,0-4.38-.74-5.87-2.21s-2.23-3.41-2.23-5.82.74-4.4,2.23-5.89,3.45-2.23,5.89-2.23c.86,0,1.67.08,2.44.25.77.17,1.46.41,2.07.74v3.24h-.11c-.55-.57-1.21-1-1.97-1.3-.76-.3-1.57-.45-2.43-.45-1.5,0-2.69.5-3.55,1.48-.87.99-1.3,2.33-1.3,4.04s.44,3.15,1.31,4.15,2.07,1.51,3.59,1.51c.81,0,1.59-.16,2.35-.48.75-.32,1.42-.78,2-1.38h.11v3.36c-.64.32-1.36.57-2.15.74-.79.17-1.58.25-2.38.25Z\"\n    />\n    <path\n      class=\"cls-2\"\n      d=\"m143.86,16.28v.12h-3.98v-.12c.15-.28.27-.64.34-1.09s.12-.99.12-1.62V3.7c0-.9-.05-1.58-.15-2.01-.1-.44-.28-.71-.54-.82v-.11l3.61-.76h.14v6.74c.66-.44,1.29-.77,1.9-.98.61-.21,1.22-.31,1.85-.31,1.2,0,2.09.34,2.69,1.01.6.67.9,1.68.9,3.01v4.07c0,.64.04,1.18.11,1.64s.19.83.35,1.1v.12h-3.98v-.12c.15-.28.27-.65.34-1.11s.12-1.01.12-1.64v-3.96c0-.58-.12-1-.37-1.26-.25-.26-.63-.4-1.15-.4-.44,0-.89.09-1.32.28s-.92.48-1.44.89v4.45c0,.64.04,1.19.11,1.64s.19.83.35,1.11Z\"\n    />\n    <path\n      class=\"cls-2\"\n      d=\"m158.81,16.65c-1.81,0-3.27-.51-4.39-1.53s-1.68-2.35-1.68-3.99.51-3.07,1.52-4.12c1.01-1.04,2.35-1.56,4.02-1.56,1.53,0,2.76.44,3.68,1.32.92.88,1.38,2.07,1.38,3.55,0,.2-.01.42-.03.66-.02.24-.07.53-.13.88h-7.25c.12.86.48,1.52,1.06,1.99.58.47,1.34.7,2.28.7.61,0,1.21-.12,1.79-.37.58-.25,1.1-.6,1.54-1.06h.12v2.25c-.52.41-1.12.73-1.79.94-.68.21-1.38.32-2.12.32Zm-.58-9.11c-.67,0-1.2.18-1.59.55s-.62.93-.71,1.68h4.25c-.02-.74-.18-1.29-.51-1.67-.32-.38-.81-.56-1.45-.56Z\"\n    />\n    <path\n      class=\"cls-2\"\n      d=\"m170.4,16.65c-1.63,0-2.98-.52-4.06-1.56-1.08-1.04-1.62-2.36-1.62-3.96s.57-3,1.7-4.07,2.55-1.61,4.25-1.61c.55,0,1.12.07,1.71.2.59.13,1.13.3,1.62.52v2.62h-.12c-.48-.4-.96-.69-1.46-.87-.5-.18-1.04-.28-1.62-.28-.89,0-1.6.3-2.14.9-.54.6-.8,1.4-.8,2.42s.29,1.88.89,2.51c.59.63,1.36.94,2.31.94.52,0,1.01-.09,1.46-.28.45-.18.91-.47,1.37-.85h.12v2.3c-.41.34-.95.6-1.6.79-.65.19-1.32.29-2.01.29Z\"\n    />\n    <path\n      class=\"cls-2\"\n      d=\"m175.71,16.4v-.12c.15-.28.27-.64.34-1.09s.12-.99.12-1.62V3.7c0-.9-.05-1.58-.15-2.01-.1-.44-.28-.71-.54-.82v-.11l3.61-.76h.14v9.98l2.07-2.14c.37-.37.64-.72.83-1.07.18-.34.27-.66.25-.95v-.12h4.67v.12c-.34.18-.69.42-1.05.71-.36.29-.8.7-1.32,1.22l-2.74,2.67,3.08,3.7c.41.49.8.91,1.16,1.27.36.35.72.65,1.09.9v.12h-3.75c-.29-.11-.61-.32-.95-.64-.34-.32-.73-.78-1.16-1.38l-2.18-3.01v2.21c0,.63.04,1.17.11,1.62s.19.82.35,1.09v.12h-3.98Z\"\n    />\n  </svg>\n  <span class=\"text-body-small-caption-400 text-gray-700 font-bold\">\n    Powered by LSEG World-Check One\n  </span>\n</label>\n" }]
        }] });

class FSWWorldCheckComponent {
    constructor() {
        this.templateRef = null;
        this.adapterMasterService = injectFSWWorldCheckAdapterMasterService();
        this.alertService = inject(FSW_ALERT_SERVICE_TOKEN);
        this.resourceSignal = signal(null);
        this.hasWarningSignal = computed(() => {
            const resources = this.resourceSignal();
            if (!resources) {
                return false;
            }
            return !!resources.permission || !!resources.defaultGroup;
        });
        this.showWarningSignal = signal(true);
        this.noCacheSignal = signal(false);
        this.noLockSignal = signal(false);
        this.menuPositions = [
            {
                originX: 'end',
                originY: 'bottom',
                overlayX: 'end',
                overlayY: 'top',
                offsetY: 8,
            },
            {
                originX: 'end',
                originY: 'top',
                overlayX: 'end',
                overlayY: 'bottom',
            },
        ];
    }
    ngOnInit() {
        this.loadResources();
    }
    loadResources() {
        this.adapterMasterService
            .getAsync({}, this.noCacheSignal(), this.noLockSignal())
            .pipe(tapResponse((resources) => this.resourceSignal.set(resources), (error) => {
            resolveError(error, this.alertService, 'Error', 'Load Master Data failed!');
        }))
            .subscribe();
    }
    updateNoCache(value) {
        if (this.noCacheSignal() === value) {
            return;
        }
        this.noCacheSignal.set(value);
        this.loadResources();
    }
    updateNoLock(value) {
        if (this.noLockSignal() === value) {
            return;
        }
        this.noLockSignal.set(value);
        this.loadResources();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckComponent, isStandalone: true, selector: "fsw-world-check", providers: [provideFSWWorldCheckAdapterMasterService(), provideWorldCheckTranslation()], queries: [{ propertyName: "templateRef", first: true, predicate: TemplateRef, descendants: true }], ngImport: i0, template: "<ng-container *ngIf=\"resourceSignal() as resources\">\n  <header class=\"flex items-center justify-between py-[16px] w-full\">\n    <fsw-world-check-logo></fsw-world-check-logo>\n    <ng-container *ngIf=\"hasWarningSignal()\">\n      <div class=\"flex items-center gap-[8px]\">\n        <div class=\"flex flex-col items-start gap-[8px]\">\n          <span class=\"inline-flex w-full justify-between items-center gap-[8px]\">\n            <fsw-switch\n              [label]=\"'buttons.no_cache' | fswTranslate : { scope: 'world_check' }\"\n              [ngModel]=\"noCacheSignal()\"\n              (ngModelChange)=\"updateNoCache($event)\"\n            ></fsw-switch>\n            <i\n              [fswIcon]=\"'common-question-circle-outline'\"\n              class=\"hover:cursor-pointer hover:text-blue-300\"\n              [fontSize]=\"'20px'\"\n              [cdkMenuTriggerFor]=\"tooltipNoCacheTemplate\"\n              [cdkMenuPosition]=\"menuPositions\"\n              fswDropdown\n            ></i>\n            <ng-template #tooltipNoCacheTemplate>\n              <span\n                class=\"w-[300px] p-[12px] rounded-[8px] bg-gray-100 font-bold text-body-default-500 text-yellow-700 shadow-md\"\n              >\n                {{ 'information.no_cache' | fswTranslate : { scope: 'world_check' } }}\n              </span>\n            </ng-template>\n          </span>\n          <span class=\"inline-flex w-full justify-between items-center gap-[8px]\">\n            <fsw-switch\n              [label]=\"'buttons.no_lock' | fswTranslate : { scope: 'world_check' }\"\n              [ngModel]=\"noLockSignal()\"\n              (ngModelChange)=\"updateNoLock($event)\"\n            ></fsw-switch>\n            <i\n              [fswIcon]=\"'common-question-circle-outline'\"\n              class=\"hover:cursor-pointer hover:text-blue-300\"\n              [fontSize]=\"'20px'\"\n              [cdkMenuTriggerFor]=\"tooltipNoLockTemplate\"\n              [cdkMenuPosition]=\"menuPositions\"\n              fswDropdown\n            ></i>\n            <ng-template #tooltipNoLockTemplate>\n              <span\n                class=\"w-[300px] p-[12px] rounded-[8px] bg-gray-100 font-bold text-body-default-500 text-yellow-700 shadow-md\"\n              >\n                {{ 'information.no_lock' | fswTranslate : { scope: 'world_check' } }}\n              </span>\n            </ng-template>\n          </span>\n        </div>\n        <i\n          fswIcon=\"common-arrow-dropdown transform duration-300\"\n          [class.rotate-90]=\"!showWarningSignal()\"\n          (click)=\"showWarningSignal.set(!showWarningSignal())\"\n        ></i>\n      </div>\n    </ng-container>\n  </header>\n  <ng-container *ngIf=\"hasWarningSignal() && showWarningSignal()\">\n    <fsw-alert\n      [hiddenFooter]=\"true\"\n      [status]=\"'warning'\"\n      [size]=\"'l'\"\n      [title]=\"'containers.warning.description' | fswTranslate : { scope: 'world_check' }\"\n      [hiddenCloseButton]=\"true\"\n    >\n      <ng-template fswAlertBody>\n        <main class=\"flex flex-col gap-[16px]\">\n          <ul class=\"flex flex-col gap-[8px]\" *ngIf=\"resourceSignal()?.permission as permission\">\n            <li\n              *ngIf=\"resourceSignal()?.defaultGroup as defaultGroup\"\n              class=\"flex items-center gap-[8px]\"\n            >\n              <i fswIcon=\"common-information-circle\" class=\"text-blue-500\"></i>\n              <span\n                [innerHTML]=\"\n                  'containers.warning.default_group'\n                    | fswTranslate : { scope: 'world_check', data: { group: defaultGroup.name } }\n                \"\n              ></span>\n            </li>\n            <li class=\"flex items-center gap-[8px]\">\n              <ng-container *ngIf=\"permission.allowScreening; else notAllowScreening\">\n                <i fswIcon=\"common-check-circle\" class=\"text-green-500\"></i>\n                <span\n                  [innerHTML]=\"\n                    'containers.warning.allow_screening' | fswTranslate : { scope: 'world_check' }\n                  \"\n                ></span>\n              </ng-container>\n              <ng-template #notAllowScreening>\n                <i fswIcon=\"common-close-circle\" class=\"text-red-500\"></i>\n                <span\n                  [innerHTML]=\"\n                    'containers.warning.not_allow_screening'\n                      | fswTranslate : { scope: 'world_check' }\n                  \"\n                ></span>\n              </ng-template>\n            </li>\n            <li class=\"flex items-center gap-[8px]\">\n              <ng-container *ngIf=\"permission.allowResolve; else notAllowResolution\">\n                <i fswIcon=\"common-check-circle\" class=\"text-green-500\"></i>\n                <span\n                  [innerHTML]=\"\n                    'containers.warning.allow_resolution' | fswTranslate : { scope: 'world_check' }\n                  \"\n                ></span>\n              </ng-container>\n              <ng-template #notAllowResolution>\n                <i fswIcon=\"common-close-circle\" class=\"text-red-500\"></i>\n                <span\n                  [innerHTML]=\"\n                    'containers.warning.not_allow_resolution'\n                      | fswTranslate : { scope: 'world_check' }\n                  \"\n                ></span>\n              </ng-template>\n            </li>\n          </ul>\n        </main>\n      </ng-template>\n    </fsw-alert>\n  </ng-container>\n  <ng-container *ngIf=\"templateRef\">\n    <ng-container\n      *ngTemplateOutlet=\"\n        templateRef;\n        context: { $implicit: resources, noCache: noCacheSignal(), noLock: noLockSignal() }\n      \"\n    ></ng-container>\n  </ng-container>\n</ng-container>\n", dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "ngmodule", type: FSWAlertModule }, { kind: "component", type: i1$4.FSWAlertComponent, selector: "fsw-alert", inputs: ["title", "confirmButton", "cancelButton", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "status", "size"], outputs: ["closeClick", "confirmClick", "cancelClick", "opened", "closed"] }, { kind: "directive", type: i1$4.FSWAlertBodyDirective, selector: "ng-template[fswAlertBody]" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "component", type: FSWWorldCheckLogoComponent, selector: "fsw-world-check-logo" }, { kind: "ngmodule", type: FSWSwitchModule }, { kind: "component", type: i1$4.FSWSwitchComponent, selector: "fsw-switch" }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "ngmodule", type: FSWDropdownModule }, { kind: "directive", type: i1$4.FSWDropdownDirective, selector: "[cdkMenuTriggerFor][fswDropdown]", inputs: ["fixedWidth", "allowBackDropClick", "offsetY", "offsetX", "event", "conditional"], exportAs: ["fswDropdown"] }, { kind: "directive", type: CdkMenuTrigger, selector: "[cdkMenuTriggerFor]", inputs: ["cdkMenuTriggerFor", "cdkMenuPosition", "cdkMenuTriggerData"], outputs: ["cdkMenuOpened", "cdkMenuClosed"], exportAs: ["cdkMenuTriggerFor"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check', standalone: true, changeDetection: ChangeDetectionStrategy.OnPush, providers: [provideFSWWorldCheckAdapterMasterService(), provideWorldCheckTranslation()], imports: [
                        NgIf,
                        NgTemplateOutlet,
                        FSWAlertModule,
                        FSWTranslateModule,
                        FSWIconModule,
                        FSWWorldCheckLogoComponent,
                        FSWSwitchModule,
                        FormsModule,
                        FSWDropdownModule,
                        CdkMenuTrigger,
                    ], template: "<ng-container *ngIf=\"resourceSignal() as resources\">\n  <header class=\"flex items-center justify-between py-[16px] w-full\">\n    <fsw-world-check-logo></fsw-world-check-logo>\n    <ng-container *ngIf=\"hasWarningSignal()\">\n      <div class=\"flex items-center gap-[8px]\">\n        <div class=\"flex flex-col items-start gap-[8px]\">\n          <span class=\"inline-flex w-full justify-between items-center gap-[8px]\">\n            <fsw-switch\n              [label]=\"'buttons.no_cache' | fswTranslate : { scope: 'world_check' }\"\n              [ngModel]=\"noCacheSignal()\"\n              (ngModelChange)=\"updateNoCache($event)\"\n            ></fsw-switch>\n            <i\n              [fswIcon]=\"'common-question-circle-outline'\"\n              class=\"hover:cursor-pointer hover:text-blue-300\"\n              [fontSize]=\"'20px'\"\n              [cdkMenuTriggerFor]=\"tooltipNoCacheTemplate\"\n              [cdkMenuPosition]=\"menuPositions\"\n              fswDropdown\n            ></i>\n            <ng-template #tooltipNoCacheTemplate>\n              <span\n                class=\"w-[300px] p-[12px] rounded-[8px] bg-gray-100 font-bold text-body-default-500 text-yellow-700 shadow-md\"\n              >\n                {{ 'information.no_cache' | fswTranslate : { scope: 'world_check' } }}\n              </span>\n            </ng-template>\n          </span>\n          <span class=\"inline-flex w-full justify-between items-center gap-[8px]\">\n            <fsw-switch\n              [label]=\"'buttons.no_lock' | fswTranslate : { scope: 'world_check' }\"\n              [ngModel]=\"noLockSignal()\"\n              (ngModelChange)=\"updateNoLock($event)\"\n            ></fsw-switch>\n            <i\n              [fswIcon]=\"'common-question-circle-outline'\"\n              class=\"hover:cursor-pointer hover:text-blue-300\"\n              [fontSize]=\"'20px'\"\n              [cdkMenuTriggerFor]=\"tooltipNoLockTemplate\"\n              [cdkMenuPosition]=\"menuPositions\"\n              fswDropdown\n            ></i>\n            <ng-template #tooltipNoLockTemplate>\n              <span\n                class=\"w-[300px] p-[12px] rounded-[8px] bg-gray-100 font-bold text-body-default-500 text-yellow-700 shadow-md\"\n              >\n                {{ 'information.no_lock' | fswTranslate : { scope: 'world_check' } }}\n              </span>\n            </ng-template>\n          </span>\n        </div>\n        <i\n          fswIcon=\"common-arrow-dropdown transform duration-300\"\n          [class.rotate-90]=\"!showWarningSignal()\"\n          (click)=\"showWarningSignal.set(!showWarningSignal())\"\n        ></i>\n      </div>\n    </ng-container>\n  </header>\n  <ng-container *ngIf=\"hasWarningSignal() && showWarningSignal()\">\n    <fsw-alert\n      [hiddenFooter]=\"true\"\n      [status]=\"'warning'\"\n      [size]=\"'l'\"\n      [title]=\"'containers.warning.description' | fswTranslate : { scope: 'world_check' }\"\n      [hiddenCloseButton]=\"true\"\n    >\n      <ng-template fswAlertBody>\n        <main class=\"flex flex-col gap-[16px]\">\n          <ul class=\"flex flex-col gap-[8px]\" *ngIf=\"resourceSignal()?.permission as permission\">\n            <li\n              *ngIf=\"resourceSignal()?.defaultGroup as defaultGroup\"\n              class=\"flex items-center gap-[8px]\"\n            >\n              <i fswIcon=\"common-information-circle\" class=\"text-blue-500\"></i>\n              <span\n                [innerHTML]=\"\n                  'containers.warning.default_group'\n                    | fswTranslate : { scope: 'world_check', data: { group: defaultGroup.name } }\n                \"\n              ></span>\n            </li>\n            <li class=\"flex items-center gap-[8px]\">\n              <ng-container *ngIf=\"permission.allowScreening; else notAllowScreening\">\n                <i fswIcon=\"common-check-circle\" class=\"text-green-500\"></i>\n                <span\n                  [innerHTML]=\"\n                    'containers.warning.allow_screening' | fswTranslate : { scope: 'world_check' }\n                  \"\n                ></span>\n              </ng-container>\n              <ng-template #notAllowScreening>\n                <i fswIcon=\"common-close-circle\" class=\"text-red-500\"></i>\n                <span\n                  [innerHTML]=\"\n                    'containers.warning.not_allow_screening'\n                      | fswTranslate : { scope: 'world_check' }\n                  \"\n                ></span>\n              </ng-template>\n            </li>\n            <li class=\"flex items-center gap-[8px]\">\n              <ng-container *ngIf=\"permission.allowResolve; else notAllowResolution\">\n                <i fswIcon=\"common-check-circle\" class=\"text-green-500\"></i>\n                <span\n                  [innerHTML]=\"\n                    'containers.warning.allow_resolution' | fswTranslate : { scope: 'world_check' }\n                  \"\n                ></span>\n              </ng-container>\n              <ng-template #notAllowResolution>\n                <i fswIcon=\"common-close-circle\" class=\"text-red-500\"></i>\n                <span\n                  [innerHTML]=\"\n                    'containers.warning.not_allow_resolution'\n                      | fswTranslate : { scope: 'world_check' }\n                  \"\n                ></span>\n              </ng-template>\n            </li>\n          </ul>\n        </main>\n      </ng-template>\n    </fsw-alert>\n  </ng-container>\n  <ng-container *ngIf=\"templateRef\">\n    <ng-container\n      *ngTemplateOutlet=\"\n        templateRef;\n        context: { $implicit: resources, noCache: noCacheSignal(), noLock: noLockSignal() }\n      \"\n    ></ng-container>\n  </ng-container>\n</ng-container>\n" }]
        }], propDecorators: { templateRef: [{
                type: ContentChild,
                args: [TemplateRef]
            }] } });

class FSWWorldCheckInformationContainerComponent {
    transformText(text) {
        return text.replaceAll('\n', '<br/>').replaceAll('. ', '.<br/>');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckInformationContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckInformationContainerComponent, isStandalone: true, selector: "fsw-world-check-information-container", inputs: { data: "data" }, providers: [provideWorldCheckTranslation('world_check_information_container')], ngImport: i0, template: "<section class=\"w-full flex flex-col gap-[16px]\">\n  <fsw-panel\n    [title]=\"\n      'containers.information.fields.biography'\n        | fswTranslate : { scope: 'world_check_information_container' }\n    \"\n  >\n    <p [innerHTML]=\"transformText(data.biography)\"></p>\n  </fsw-panel>\n  <fsw-panel\n    [title]=\"\n      'containers.information.fields.reports'\n        | fswTranslate : { scope: 'world_check_information_container' }\n    \"\n  >\n    <p [innerHTML]=\"transformText(data.reports)\"></p>\n  </fsw-panel>\n  <fsw-panel\n    [title]=\"\n      'containers.information.fields.identification'\n        | fswTranslate : { scope: 'world_check_information_container' }\n    \"\n  >\n    <p [innerHTML]=\"transformText(data.identification)\"></p>\n  </fsw-panel>\n</section>\n", dependencies: [{ kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckInformationContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-information-container', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [provideWorldCheckTranslation('world_check_information_container')], imports: [FSWTranslateModule, FSWPanelModule], template: "<section class=\"w-full flex flex-col gap-[16px]\">\n  <fsw-panel\n    [title]=\"\n      'containers.information.fields.biography'\n        | fswTranslate : { scope: 'world_check_information_container' }\n    \"\n  >\n    <p [innerHTML]=\"transformText(data.biography)\"></p>\n  </fsw-panel>\n  <fsw-panel\n    [title]=\"\n      'containers.information.fields.reports'\n        | fswTranslate : { scope: 'world_check_information_container' }\n    \"\n  >\n    <p [innerHTML]=\"transformText(data.reports)\"></p>\n  </fsw-panel>\n  <fsw-panel\n    [title]=\"\n      'containers.information.fields.identification'\n        | fswTranslate : { scope: 'world_check_information_container' }\n    \"\n  >\n    <p [innerHTML]=\"transformText(data.identification)\"></p>\n  </fsw-panel>\n</section>\n" }]
        }], propDecorators: { data: [{
                type: Input,
                args: [{ required: true }]
            }] } });

let FSWWorldCheckActivityTableComponent = class FSWWorldCheckActivityTableComponent {
    constructor() {
        this.refreshEvent = new EventEmitter();
        this.data = [];
        this.hiddenViewSignal = signal(false);
        this.queryControl = new FormControl('');
        this.filteredSignal = signal([]);
        this.indexSignal = signal(1);
        this.itemsPerPageSignal = signal(50);
        this.transformDataSignal = computed(() => {
            return this.filteredSignal()
                .slice((this.indexSignal() - 1) * (this.itemsPerPageSignal() ?? this.filteredSignal().length), this.indexSignal() * (this.itemsPerPageSignal() ?? this.filteredSignal().length))
                .map((item) => {
                let message = item.message.replaceAll('\n', '<br/>');
                Object.keys(item.context).forEach((key) => {
                    message = message.replaceAll(`${item.context[key]}`, (match) => `<strong>${match}</strong>`);
                });
                return {
                    ...item,
                    message,
                };
            });
        });
    }
    ngOnInit() {
        this.queryControl.valueChanges
            .pipe(startWith(''))
            .pipe(followDestroy(this), tap(() => {
            this.indexSignal.set(1);
            this.runFilter();
        }))
            .subscribe();
    }
    ngOnChanges() {
        this.runFilter();
    }
    runFilter() {
        const query = this.queryControl.value;
        this.filteredSignal.set(this.data?.filter((match) => query ? match.message?.toLowerCase().includes(query.toLowerCase()) : true) ?? []);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckActivityTableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckActivityTableComponent, isStandalone: true, selector: "fsw-world-check-activity-table", inputs: { data: "data" }, outputs: { refreshEvent: "refreshEvent" }, providers: [provideWorldCheckTranslation('world_check_activity_table')], usesOnChanges: true, ngImport: i0, template: "<fsw-panel\n  [title]=\"'titles.activity_screen' | fswTranslate : { scope: 'world_check_activity_table' }\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <section class=\"flex items-center gap-[8px]\">\n      <div class=\"w-[200px]\">\n        <fsw-field [fullWidth]=\"true\">\n          <input fswInput [formControl]=\"queryControl\" placeholder=\"Type to search\" />\n        </fsw-field>\n      </div>\n      <button fswButton (click)=\"refreshEvent.emit()\">\n        {{ 'buttons.refresh' | fswTranslate : { scope: 'world_check_activity_table' } }}\n      </button>\n      <i\n        fswIcon=\"common-arrow-down\"\n        [class.rotate-180]=\"!hiddenViewSignal()\"\n        class=\"text-[#2c50ff] duration-150\"\n        (click)=\"hiddenViewSignal.set(!hiddenViewSignal())\"\n      ></i>\n    </section>\n  </ng-template>\n  <section class=\"w-full flex flex-col gap-[16px]\" *ngIf=\"!hiddenViewSignal()\">\n    <table class=\"fsw-table fsw-table--bordered w-full table-fixed\">\n      <thead>\n        <tr>\n          <th class=\"whitespace-normal align-middle break-words !w-1/5\">\n            {{\n              'tables.activity.created_at' | fswTranslate : { scope: 'world_check_activity_table' }\n            }}\n          </th>\n          <th class=\"whitespace-normal align-middle break-words\">\n            {{ 'tables.activity.message' | fswTranslate : { scope: 'world_check_activity_table' } }}\n          </th>\n        </tr>\n      </thead>\n      <tbody>\n        <ng-container *ngFor=\"let item of transformDataSignal()\">\n          <tr>\n            <td class=\"whitespace-normal align-middle break-words !w-1/5\">\n              {{ item.createdAt ? (item.createdAt | date : 'dd/MM/yyyy HH:mm:ss') : '--' }}\n            </td>\n            <td class=\"whitespace-normal align-middle break-words\">\n              <p [innerHTML]=\"item.message\"></p>\n            </td>\n          </tr>\n        </ng-container>\n      </tbody>\n    </table>\n    <footer class=\"flex justify-end\">\n      <fsw-pagination\n        [total]=\"filteredSignal().length\"\n        [itemsPerPage]=\"itemsPerPageSignal() ?? filteredSignal().length\"\n        [currentPage]=\"indexSignal()\"\n        (currentPageChange)=\"indexSignal.set($event)\"\n        (itemsPerPageChange)=\"itemsPerPageSignal.set($event ?? filteredSignal().length)\"\n      ></fsw-pagination>\n    </footer>\n  </section>\n</fsw-panel>\n", styles: ["fsw-world-check-activity-table .fsw-panel>main:empty{display:none}\n"], dependencies: [{ kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: DatePipe, name: "date" }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FSWFieldModule }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "ngmodule", type: FSWInputModule }, { kind: "directive", type: i1$4.FSWInputDirective, selector: "input[fswInput], textarea[fswInput]" }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "ngmodule", type: FSWPaginationModule$1 }, { kind: "component", type: i1$4.FSWPaginationComponent, selector: "fsw-pagination", inputs: ["total", "itemsPerPage", "currentPage", "itemsPerPageOptions", "showSelectOptions", "showViewTotalText", "showNavigationText", "totalTextInside"], outputs: ["currentPageChange", "itemsPerPageChange"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
};
FSWWorldCheckActivityTableComponent = __decorate([
    autoDestroy()
], FSWWorldCheckActivityTableComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckActivityTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-activity-table', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [provideWorldCheckTranslation('world_check_activity_table')], imports: [
                        FSWTranslateModule,
                        DatePipe,
                        NgForOf,
                        FSWPanelModule,
                        FSWButtonModule,
                        FSWIconModule,
                        NgIf,
                        FSWFieldModule,
                        FSWInputModule,
                        FormsModule,
                        FSWPaginationModule$1,
                        ReactiveFormsModule,
                    ], encapsulation: ViewEncapsulation.None, template: "<fsw-panel\n  [title]=\"'titles.activity_screen' | fswTranslate : { scope: 'world_check_activity_table' }\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <section class=\"flex items-center gap-[8px]\">\n      <div class=\"w-[200px]\">\n        <fsw-field [fullWidth]=\"true\">\n          <input fswInput [formControl]=\"queryControl\" placeholder=\"Type to search\" />\n        </fsw-field>\n      </div>\n      <button fswButton (click)=\"refreshEvent.emit()\">\n        {{ 'buttons.refresh' | fswTranslate : { scope: 'world_check_activity_table' } }}\n      </button>\n      <i\n        fswIcon=\"common-arrow-down\"\n        [class.rotate-180]=\"!hiddenViewSignal()\"\n        class=\"text-[#2c50ff] duration-150\"\n        (click)=\"hiddenViewSignal.set(!hiddenViewSignal())\"\n      ></i>\n    </section>\n  </ng-template>\n  <section class=\"w-full flex flex-col gap-[16px]\" *ngIf=\"!hiddenViewSignal()\">\n    <table class=\"fsw-table fsw-table--bordered w-full table-fixed\">\n      <thead>\n        <tr>\n          <th class=\"whitespace-normal align-middle break-words !w-1/5\">\n            {{\n              'tables.activity.created_at' | fswTranslate : { scope: 'world_check_activity_table' }\n            }}\n          </th>\n          <th class=\"whitespace-normal align-middle break-words\">\n            {{ 'tables.activity.message' | fswTranslate : { scope: 'world_check_activity_table' } }}\n          </th>\n        </tr>\n      </thead>\n      <tbody>\n        <ng-container *ngFor=\"let item of transformDataSignal()\">\n          <tr>\n            <td class=\"whitespace-normal align-middle break-words !w-1/5\">\n              {{ item.createdAt ? (item.createdAt | date : 'dd/MM/yyyy HH:mm:ss') : '--' }}\n            </td>\n            <td class=\"whitespace-normal align-middle break-words\">\n              <p [innerHTML]=\"item.message\"></p>\n            </td>\n          </tr>\n        </ng-container>\n      </tbody>\n    </table>\n    <footer class=\"flex justify-end\">\n      <fsw-pagination\n        [total]=\"filteredSignal().length\"\n        [itemsPerPage]=\"itemsPerPageSignal() ?? filteredSignal().length\"\n        [currentPage]=\"indexSignal()\"\n        (currentPageChange)=\"indexSignal.set($event)\"\n        (itemsPerPageChange)=\"itemsPerPageSignal.set($event ?? filteredSignal().length)\"\n      ></fsw-pagination>\n    </footer>\n  </section>\n</fsw-panel>\n", styles: ["fsw-world-check-activity-table .fsw-panel>main:empty{display:none}\n"] }]
        }], propDecorators: { refreshEvent: [{
                type: Output
            }], data: [{
                type: Input,
                args: [{ required: true }]
            }] } });

let FSWWorldCheckResultTableComponent = class FSWWorldCheckResultTableComponent {
    constructor() {
        this.actionEvent = new EventEmitter();
        this.data = [];
        this.isReadonly = false;
        this.snapshotId = null;
        this.selectedResults = signal([]);
        this.hiddenViewSignal = signal(false);
        this.filteredSignal = signal([]);
        this.sortKeySignal = signal([]);
        this.filterMappingSignal = signal({
            resolution: null,
        });
        this.filterCountSignal = computed(() => {
            const mapping = this.filterMappingSignal();
            return Object.keys(mapping)
                .filter((key) => !!mapping[key]?.length)
                .map((key) => [
                key,
                (this.columns.find((column) => column[0] === key)?.[5])(mapping[key]),
            ]);
        });
        this.optionsMappingSignal = signal({});
        this.indexSignal = signal(1);
        this.itemsPerPageSignal = signal(50);
        this.paginatedSignal = computed(() => {
            return this.filteredSignal().slice((this.indexSignal() - 1) * (this.itemsPerPageSignal() ?? this.filteredSignal().length), this.indexSignal() * (this.itemsPerPageSignal() ?? this.filteredSignal().length));
        });
        this.columns = [
            [
                'name',
                'name',
                'text',
                'w-[300px]',
                (selection, target) => {
                    if (!selection) {
                        return true;
                    }
                    return (target || '').toLowerCase().includes(selection.toLowerCase());
                },
                (selection) => `Name includes ${selection}`,
            ],
            [
                'matchStrength',
                'match_strength',
                'select',
                'w-[200px]',
                (selection, target) => {
                    if (!selection?.length) {
                        return true;
                    }
                    return selection.some((item) => (item === '--' ? !target : item === target));
                },
                (selection) => `Match Strength in [${selection.join(', ')}]`,
            ],
            [
                'matchScore',
                'match_score',
                'number',
                'w-[200px]',
                (selection, target) => {
                    if (!selection?.length) {
                        return true;
                    }
                    if (!target) {
                        return false;
                    }
                    const [start, end] = selection;
                    const startTime = start ? Number(start) : null;
                    const endTime = end ? Number(end) : null;
                    if (startTime && endTime) {
                        return startTime <= Number(target) && endTime >= Number(target);
                    }
                    if (startTime) {
                        return startTime <= Number(target);
                    }
                    if (endTime) {
                        return endTime >= Number(target);
                    }
                    return true;
                },
                (selection) => {
                    const [start, end] = selection;
                    if (start && end) {
                        return `Match Score from ${start} to ${end}`;
                    }
                    if (start) {
                        return `Match Score from ${start}`;
                    }
                    if (end) {
                        return `Match Score to ${end}`;
                    }
                    return `Match Score range is invalid`;
                },
            ],
            [
                'matchNameType',
                'match_name_type',
                'select',
                'w-[200px]',
                (selection, target) => {
                    if (!selection?.length) {
                        return true;
                    }
                    return selection.some((item) => (item === '--' ? !target : item === target));
                },
                (selection) => `Match Name Type in [${selection.join(', ')}]`,
            ],
            [
                'resolution',
                'resolution',
                'tags',
                'w-[200px]',
                (selection, target) => {
                    if (!selection?.length) {
                        return true;
                    }
                    if (selection === FSWWorldCheckWatchlistResolvedByResolutionStatus.UNRESOLVED) {
                        return !target;
                    }
                    return selection === target;
                },
                (selection) => `Resolution is ${selection}`,
            ],
            [
                'resolutionRemark',
                'remark',
                'text',
                'w-[300px]',
                (selection, target) => {
                    if (!selection) {
                        return true;
                    }
                    return (target || '').toLowerCase().includes(selection.toLowerCase());
                },
                (selection) => `Resolution Remark includes ${selection}`,
            ],
            [
                'reviewRemark',
                'review_remark',
                'text',
                'w-[300px]',
                (selection, target) => {
                    if (!selection) {
                        return true;
                    }
                    return (target || '').toLowerCase().includes(selection.toLowerCase());
                },
                (selection) => `Review Remark includes ${selection}`,
            ],
            [
                'registeredCountry',
                'registered_country',
                'select',
                'w-[200px]',
                (selection, target) => {
                    if (!selection?.length) {
                        return true;
                    }
                    return selection.some((item) => (item === '--' ? !target : item === target));
                },
                (selection) => `Registered Country in [${selection.join(', ')}]`,
            ],
            [
                'citizenship',
                'citizenship',
                'select',
                'w-[200px]',
                (selection, target) => {
                    if (!selection?.length) {
                        return true;
                    }
                    return selection.some((item) => (item === '--' ? !target : item === target));
                },
                (selection) => `Citizenship in [${selection.join(', ')}]`,
            ],
            [
                'dateOfBirth',
                'date_of_birth',
                'select',
                'w-[200px]',
                (selection, target) => {
                    if (!selection?.length) {
                        return true;
                    }
                    if (!target) {
                        return selection.includes('--');
                    }
                    const options = this.toFilteredDates(target);
                    return options.some((option) => selection.includes(option));
                },
                (selection) => `Date of Birth in [${selection.join(', ')}]`,
            ],
            [
                'category',
                'category',
                'select',
                'w-[200px]',
                (selection, target) => {
                    if (!selection?.length) {
                        return true;
                    }
                    return selection.some((item) => (item === '--' ? !target : item === target));
                },
                (selection) => `Category in [${selection.join(', ')}]`,
            ],
            [
                'enteredDate',
                'entered_date',
                'select',
                'w-[200px]',
                (selection, target) => {
                    if (!selection?.length) {
                        return true;
                    }
                    if (!target) {
                        return selection.includes('--');
                    }
                    const options = this.toFilteredDates(target);
                    return options.some((option) => selection.includes(option));
                },
                (selection) => `Entered Date in [${selection.join(', ')}]`,
            ],
            [
                'specialInterestCategories',
                'special_interest_categories',
                'select',
                'w-[300px]',
                (selection, target) => {
                    if (!selection?.length) {
                        return true;
                    }
                    return selection.some((item) => item === '--' ? !(target || []).length : (target || []).includes(item));
                },
                (selection) => `Special Interest Categories in [${selection.join(', ')}]`,
            ],
        ];
        this.optionsResolverMapping = {
            matchStrength: this.resolveOptions(),
            matchNameType: this.resolveOptions(),
            resolution: this.resolveOptions(FSWWorldCheckWatchlistResolvedByResolutionStatus.UNRESOLVED),
            registeredCountry: this.resolveOptions(),
            citizenship: this.resolveOptions(),
            category: this.resolveOptions(),
            specialInterestCategories: this.resolveOptions(),
            dateOfBirth: this.resolveDateOptions(),
            enteredDate: this.resolveDateOptions(),
        };
        this.menuPositions = [
            {
                originX: 'end',
                originY: 'bottom',
                overlayX: 'end',
                overlayY: 'top',
                offsetY: 8,
            },
            {
                originX: 'end',
                originY: 'top',
                overlayX: 'end',
                overlayY: 'bottom',
            },
        ];
        this.FSWWorldCheckWatchlistResolvedByResolutionStatus = FSWWorldCheckWatchlistResolvedByResolutionStatus;
    }
    ngOnChanges() {
        this.runFilter();
        this.optionsMappingSignal.set(this.generateOptions(this.data || []));
        console.log(this.optionsMappingSignal());
    }
    action(method) {
        if (!this.selectedResults().length) {
            return;
        }
        this.actionEvent.emit({
            results: this.data
                .filter((r) => this.selectedResults().includes(r.resultId))
                .map((r) => ({
                resultId: r.resultId,
                resolution: r.resolution,
                name: r.name,
                referenceId: r.referenceId,
            })),
            method,
        });
    }
    runFilter(noSort = false) {
        this.selectedResults.set([]);
        this.indexSignal.set(1);
        const data = this.data || [];
        this.filteredSignal.set(this.filterWithOmitColumns(data));
        this.runOptions();
        !noSort && this.runSort();
    }
    runSort() {
        const [key, direction] = this.sortKeySignal();
        if (!key) {
            this.runFilter(true);
            return;
        }
        const filtered = this.filteredSignal();
        const specialKeySortCB = {
            specialInterestCategories: (obj) => obj.specialInterestCategories?.length || 0,
            matchScore: (obj) => +(obj.matchScore || 0),
            dateOfBirth: (obj) => obj.dateOfBirth ? new Date(obj.dateOfBirth).getTime() : 0,
        };
        const sorted = sortBy(filtered, specialKeySortCB[key] || key);
        this.filteredSignal.set(direction === 'up' ? sorted.reverse() : sorted);
    }
    runOptions() {
        const data = this.data || [];
        const options = {};
        Object.keys(this.optionsMappingSignal()).forEach((key) => {
            const rows = this.filterWithOmitColumns(data, [key]);
            const ops = Object.keys(this.optionsMappingSignal()).reduce((acc, key) => ({
                ...acc,
                [key]: this.optionsMappingSignal()[key].map((item) => ({
                    ...item,
                    length: item.value !== null ? 0 : rows.length,
                })),
            }), {});
            const obj = this.generateOptions(rows, ops);
            options[key] = obj[key];
        });
        this.optionsMappingSignal.set(options);
    }
    toggleAll() {
        if (this.selectedResults().length === this.filteredSignal().length) {
            this.selectedResults.set([]);
        }
        else {
            this.selectedResults.set(this.filteredSignal().map((m) => m.resultId));
        }
    }
    toggleMatch(resultId) {
        if (this.selectedResults().includes(resultId)) {
            this.selectedResults.set(this.selectedResults().filter((m) => m !== resultId));
        }
        else {
            this.selectedResults.set([...this.selectedResults(), resultId]);
        }
    }
    updateSort(key) {
        const existing = this.sortKeySignal()[0] === key;
        if (existing) {
            this.sortKeySignal.set([key, this.sortKeySignal()[1] === 'up' ? 'down' : 'up']);
        }
        else {
            this.sortKeySignal.set([key, 'up']);
        }
        this.runSort();
    }
    updateFilter(key, value) {
        if (!this.filterMappingSignal()[key] && !value) {
            return;
        }
        this.filterMappingSignal.set({
            ...this.filterMappingSignal(),
            [key]: value,
        });
        this.runFilter();
    }
    generateOptions(data, options = {
        matchStrength: [],
        matchNameType: [],
        resolution: [
            {
                value: null,
                length: data.length,
            },
            ...(this.resources.resolution
                ? Object.keys(this.resources.resolution)
                : [
                    FSWWorldCheckWatchlistResolvedByResolutionStatus.POSITIVE,
                    FSWWorldCheckWatchlistResolvedByResolutionStatus.POSSIBLE,
                    FSWWorldCheckWatchlistResolvedByResolutionStatus.FALSE,
                    FSWWorldCheckWatchlistResolvedByResolutionStatus.UNSPECIFIED,
                ]).map((item) => ({
                value: item,
                length: 0,
            })),
            {
                value: FSWWorldCheckWatchlistResolvedByResolutionStatus.UNRESOLVED,
                length: 0,
            },
        ],
        registeredCountry: [],
        citizenship: [],
        category: [],
        specialInterestCategories: [],
        dateOfBirth: [],
        enteredDate: [],
    }) {
        data.forEach((item) => {
            Object.keys(options).forEach((key) => this.optionsResolverMapping[key](options[key], item[key]));
        });
        Object.keys(options).forEach((key) => options[key].sort((a, b) => (a.value === '--' ? -1 : b.length - a.length)));
        return options;
    }
    toMiniResult(result) {
        return {
            resultId: result.resultId,
            referenceId: result.referenceId,
            name: result.name,
        };
    }
    toFilteredDates(value) {
        const date = new Date(value);
        const [year, month, day] = [date.getFullYear(), date.getMonth() + 1, date.getDate()];
        const monthString = month.toString().length === 1 ? `0${month}` : month;
        const dayString = day.toString().length === 1 ? `0${day}` : day;
        return [`xx/xx/${year}`, `xx/${monthString}/${year}`, `${dayString}/${monthString}/${year}`];
    }
    resolveOptions(defaultValue = '--') {
        const cb = (items, value) => {
            if (!value) {
                const empty = items.find((item) => item.value === defaultValue);
                if (empty) {
                    empty.length++;
                }
                else {
                    items.push({
                        value: defaultValue,
                        length: 1,
                    });
                }
                return;
            }
            if (isArray(value)) {
                value.forEach((v) => cb(items, v));
                return;
            }
            const index = items.findIndex((item) => item.value === value);
            if (index > -1) {
                items[index].length++;
                return;
            }
            items.unshift({
                value: value,
                length: 1,
            });
        };
        return cb;
    }
    resolveDateOptions(defaultValue = '--') {
        return (items, value) => {
            if (!value) {
                const empty = items.find((item) => item.value === defaultValue);
                if (empty) {
                    empty.length++;
                }
                else {
                    items.push({
                        value: defaultValue,
                        length: 1,
                    });
                }
                return;
            }
            const options = this.toFilteredDates(value);
            options.forEach((option) => {
                const index = items.findIndex((item) => item.value === option);
                if (index > -1) {
                    items[index].length++;
                    return;
                }
                items.unshift({
                    value: option,
                    length: 1,
                });
            });
        };
    }
    filterWithOmitColumns(data, omitColumns = []) {
        const mapping = this.filterMappingSignal();
        return [...data].filter((match) => this.columns
            .filter((column) => !omitColumns.includes(column[0]))
            .every((column) => column[4](mapping[column[0]], match[column[0]])));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckResultTableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckResultTableComponent, isStandalone: true, selector: "fsw-world-check-result-table", inputs: { data: "data", case: "case", resources: "resources", isReadonly: "isReadonly", snapshotId: "snapshotId" }, outputs: { actionEvent: "actionEvent" }, providers: [provideWorldCheckTranslation('world_check_result_table'), provideNgxMask()], usesOnChanges: true, ngImport: i0, template: "<fsw-panel [title]=\"'titles.result_screen' | fswTranslate : { scope: 'world_check_result_table' }\">\n  <ng-template fswPanelHeaderSuffix>\n    <section class=\"flex items-center gap-[8px]\">\n      <ng-container *ngIf=\"!isReadonly\">\n        <button\n          fswButton\n          [appearance]=\"'secondary'\"\n          [disabled]=\"!selectedResults().length || !resources?.permission?.allowResolve\"\n          (click)=\"!!resources?.permission?.allowResolve && action('resolution')\"\n        >\n          {{ 'buttons.resolution' | fswTranslate : { scope: 'world_check_result_table' } }}\n        </button>\n        <button\n          fswButton\n          [appearance]=\"'secondary'\"\n          [disabled]=\"!selectedResults().length\"\n          (click)=\"action('review')\"\n        >\n          {{ 'buttons.review' | fswTranslate : { scope: 'world_check_result_table' } }}\n        </button>\n        <button fswButton (click)=\"actionEvent.emit({ method: 'refresh', results: [] })\">\n          {{ 'buttons.refresh' | fswTranslate : { scope: 'world_check_result_table' } }}\n        </button>\n      </ng-container>\n      <i\n        fswIcon=\"common-arrow-down\"\n        class=\"text-[#2c50ff] duration-150\"\n        [class.rotate-180]=\"!hiddenViewSignal()\"\n        (click)=\"hiddenViewSignal.set(!hiddenViewSignal())\"\n      ></i>\n    </section>\n  </ng-template>\n  <section class=\"w-full flex flex-col gap-[16px]\" *ngIf=\"!hiddenViewSignal()\">\n    <header class=\"w-full flex items-center gap-[8px] justify-between\">\n      <section class=\"w-full flex items-center gap-[8px]\">\n        <ng-container *ngFor=\"let status of optionsMappingSignal()['resolution']\">\n          <fsw-tags\n            [hiddenCloseButton]=\"true\"\n            [color]=\"status.value === filterMappingSignal()['resolution'] ? 'blue' : 'gray'\"\n            (click)=\"updateFilter('resolution', status.value)\"\n          >\n            {{ status.value ?? 'All' }} ({{ status.length }})\n          </fsw-tags>\n        </ng-container>\n      </section>\n      <ng-container *ngIf=\"filterCountSignal().length as length\">\n        <span\n          class=\"text-blue-300 hover:text-blue-500 cursor-pointer text-body-caption-400 font-bold min-w-max\"\n          [cdkMenuTriggerFor]=\"listFiltersTemplate\"\n          [cdkMenuPosition]=\"menuPositions\"\n          fswDropdown\n        >\n          {{ length + ' Filter(s)' }}\n        </span>\n        <ng-template #listFiltersTemplate>\n          <article class=\"p-[12px] rounded-[8px] bg-white shadow-small flex flex-col gap-[8px]\">\n            <label class=\"text-blue-500 text-body-caption-500 font-bold\">\n              {{ length + ' Filter(s)' }}\n            </label>\n            <ng-container *ngFor=\"let item of filterCountSignal()\">\n              <fsw-tags [color]=\"'blue'\" (closeClick)=\"updateFilter(item[0], null)\">\n                {{ item[1] }}\n              </fsw-tags>\n            </ng-container>\n          </article>\n        </ng-template>\n      </ng-container>\n    </header>\n    <main class=\"w-full overflow-x-auto\">\n      <table class=\"fsw-table fsw-table--bordered min-w-full w-max !table-auto\">\n        <thead>\n          <tr>\n            <th\n              *ngIf=\"!isReadonly\"\n              class=\"align-middle text-center\"\n              (click)=\"!!filteredSignal().length && toggleAll()\"\n            >\n              <span [class.opacity-0]=\"isReadonly || !filteredSignal().length\">\n                <fsw-checkbox\n                  [forceChecked]=\"selectedResults().length === filteredSignal().length\"\n                ></fsw-checkbox>\n              </span>\n            </th>\n            <ng-container *ngFor=\"let column of columns\">\n              <th class=\"whitespace-normal align-middle break-words\">\n                <ng-container\n                  *ngTemplateOutlet=\"\n                    sortTemplate;\n                    context: {\n                      $implicit: column,\n                    }\n                  \"\n                />\n              </th>\n            </ng-container>\n          </tr>\n        </thead>\n        <tbody>\n          <ng-container *ngFor=\"let result of paginatedSignal()\">\n            <tr>\n              <td\n                *ngIf=\"!isReadonly\"\n                class=\"align-middle text-center\"\n                (click)=\"toggleMatch(result.resultId)\"\n              >\n                <fsw-checkbox\n                  [forceChecked]=\"selectedResults().includes(result.resultId)\"\n                ></fsw-checkbox>\n              </td>\n              <td\n                class=\"whitespace-normal align-middle break-words !text-blue-300 hover:underline\"\n                (click)=\"actionEvent.emit({ method: 'detail', results: [toMiniResult(result)] })\"\n              >\n                <p class=\"w-[300px]\">{{ result.name || '--' }}</p>\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                <p class=\"w-[200px]\">{{ result.matchStrength || '--' }}</p>\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                <p class=\"w-[200px]\">{{ result.matchScore || '--' }}</p>\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                <p class=\"w-[200px]\">{{ result.matchNameType || '--' }}</p>\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                <p class=\"w-[200px]\">\n                  {{\n                    result.resolution || FSWWorldCheckWatchlistResolvedByResolutionStatus.UNRESOLVED\n                  }}\n                </p>\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                <p class=\"w-[300px]\">{{ result.resolutionRemark || '--' }}</p>\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                <p class=\"w-[300px]\">{{ result.reviewRemark || '--' }}</p>\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                <p class=\"w-[200px]\">{{ result.registeredCountry || '--' }}</p>\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                <p class=\"w-[200px]\">{{ result.citizenship || '--' }}</p>\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                <p class=\"w-[200px]\">\n                  {{ result.dateOfBirth ? (result.dateOfBirth | date : 'dd/MM/yyyy') : '--' }}\n                </p>\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                <p class=\"w-[200px]\">{{ result.category || '--' }}</p>\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                <p class=\"w-[200px]\">\n                  {{ result.enteredDate ? (result.enteredDate | date : 'dd/MM/yyyy') : '--' }}\n                </p>\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                <label\n                  class=\"flex flex-wrap gap-[4px] w-[300px]\"\n                  *ngIf=\"result.specialInterestCategories?.length; else emptyTemplate\"\n                >\n                  <ng-container *ngFor=\"let type of result.specialInterestCategories\">\n                    <fsw-tags [hiddenCloseButton]=\"true\">{{ type }}</fsw-tags>\n                  </ng-container>\n                </label>\n              </td>\n            </tr>\n          </ng-container>\n        </tbody>\n      </table>\n    </main>\n    <footer class=\"flex justify-end w-full\">\n      <fsw-pagination\n        [total]=\"filteredSignal().length\"\n        [itemsPerPage]=\"itemsPerPageSignal() ?? filteredSignal().length\"\n        [currentPage]=\"indexSignal()\"\n        (currentPageChange)=\"indexSignal.set($event)\"\n        (itemsPerPageChange)=\"itemsPerPageSignal.set($event ?? filteredSignal().length)\"\n      ></fsw-pagination>\n    </footer>\n  </section>\n</fsw-panel>\n<ng-template #emptyTemplate>--</ng-template>\n<ng-template #sortTemplate let-column>\n  <label class=\"inline-flex justify-between items-center gap-[16px] {{ column[3] }}\">\n    <span [class.text-blue-300]=\"sortKeySignal()[0] === column[0]\">\n      {{ 'tables.result.' + column[1] | fswTranslate : { scope: 'world_check_result_table' } }}\n    </span>\n    <span class=\"flex items-center gap-[4px]\">\n      <ng-container *ngIf=\"column[0] !== 'resolution'\">\n        <i\n          [fswIcon]=\"'common-filter'\"\n          [fontSize]=\"'16px'\"\n          [ngClass]=\"{\n            'hover:text-blue-300': true,\n            'text-blue-300': !!filterMappingSignal()[column[0]]?.length\n          }\"\n          [cdkMenuTriggerFor]=\"filterTemplate\"\n          [cdkMenuPosition]=\"menuPositions\"\n          fswDropdown\n        ></i>\n        <ng-template #filterTemplate>\n          <article\n            class=\"flex flex-col gap-[8px] w-[300px] p-[12px] rounded-[8px] bg-white shadow-small\"\n          >\n            <ng-container [ngSwitch]=\"column[2]\">\n              <ng-container *ngSwitchCase=\"'select'\">\n                <fsw-field [fullWidth]=\"true\">\n                  <fsw-select\n                    [isMultiple]=\"true\"\n                    [maxHeight]=\"'300px'\"\n                    [placeHolder]=\"\n                      'tables.result.' + column[1]\n                        | fswTranslate : { scope: 'world_check_result_table' }\n                    \"\n                    [searchPlaceHolder]=\"\n                      'tables.result.' + column[1]\n                        | fswTranslate : { scope: 'world_check_result_table' }\n                    \"\n                    [ngModel]=\"filterMappingSignal()[column[0]] || []\"\n                    (ngModelChange)=\"updateFilter(column[0], $event)\"\n                  >\n                    <ng-container *ngFor=\"let item of optionsMappingSignal()[column[0]]\">\n                      <ng-template\n                        fswSelectItem\n                        [text]=\"item.value + ' (' + item.length + ')'\"\n                        [value]=\"item.value\"\n                        [isDisabled]=\"item.length === 0\"\n                      ></ng-template>\n                    </ng-container>\n                  </fsw-select>\n                </fsw-field>\n              </ng-container>\n              <ng-container *ngSwitchCase=\"'date'\">\n                <div class=\"w-full flex items-center gap-[8px]\">\n                  <div class=\"w-[calc(50%-4px)]\">\n                    <fsw-field [fullWidth]=\"true\">\n                      <input\n                        fswInput\n                        [mask]=\"'M0/0000'\"\n                        [specialCharacters]=\"['/']\"\n                        [dropSpecialCharacters]=\"false\"\n                        [ngModel]=\"filterMappingSignal()[column[0]]?.[0] || ''\"\n                        (ngModelChange)=\"\n                          updateFilter(column[0], [$event, $any(filterMappingSignal()[column[0]])?.[1]])\n                        \"\n                        [placeholder]=\"'MM/YYYY'\"\n                      />\n                    </fsw-field>\n                  </div>\n                  <div class=\"w-[calc(50%-4px)]\">\n                    <fsw-field [fullWidth]=\"true\">\n                      <input\n                        fswInput\n                        [mask]=\"'M0/0000'\"\n                        [specialCharacters]=\"['/']\"\n                        [dropSpecialCharacters]=\"false\"\n                        [ngModel]=\"filterMappingSignal()[column[0]]?.[1] || ''\"\n                        (ngModelChange)=\"\n                          updateFilter(column[0], [$any(filterMappingSignal()[column[0]])?.[0], $event])\n                        \"\n                        [placeholder]=\"'MM/YYYY'\"\n                      />\n                    </fsw-field>\n                  </div>\n                </div>\n              </ng-container>\n              <ng-container *ngSwitchCase=\"'number'\">\n                <div class=\"w-full flex items-center gap-[8px]\">\n                  <div class=\"w-[calc(50%-4px)]\">\n                    <fsw-field [fullWidth]=\"true\">\n                      <input\n                        fswInput\n                        [mask]=\"'separator.2'\"\n                        [thousandSeparator]=\"','\"\n                        [ngModel]=\"filterMappingSignal()[column[0]]?.[0] || ''\"\n                        (ngModelChange)=\"\n                          updateFilter(column[0], [$event, $any(filterMappingSignal()[column[0]])?.[1]])\n                        \"\n                        [placeholder]=\"'Min'\"\n                      />\n                    </fsw-field>\n                  </div>\n                  <div class=\"w-[calc(50%-4px)]\">\n                    <fsw-field [fullWidth]=\"true\">\n                      <input\n                        fswInput\n                        [mask]=\"'separator.2'\"\n                        [thousandSeparator]=\"','\"\n                        [ngModel]=\"filterMappingSignal()[column[0]]?.[1] || ''\"\n                        (ngModelChange)=\"\n                          updateFilter(column[0], [$any(filterMappingSignal()[column[0]])?.[0], $event])\n                        \"\n                        [placeholder]=\"'Max'\"\n                      />\n                    </fsw-field>\n                  </div>\n                </div>\n              </ng-container>\n              <ng-container *ngSwitchDefault>\n                <fsw-field [fullWidth]=\"true\">\n                  <input\n                    fswInput\n                    [ngModel]=\"filterMappingSignal()[column[0]] || ''\"\n                    (ngModelChange)=\"updateFilter(column[0], $event)\"\n                    [placeholder]=\"\n                      'tables.result.' + column[1]\n                        | fswTranslate : { scope: 'world_check_result_table' }\n                    \"\n                    type=\"text\"\n                  />\n                </fsw-field>\n              </ng-container>\n            </ng-container>\n            <button\n              fswButton\n              [appearance]=\"'secondary'\"\n              [size]=\"'s'\"\n              [ngClass]=\"{ '!w-full': true }\"\n              (click)=\"updateFilter(column[0], null)\"\n              [disabled]=\"!filterMappingSignal()[column[0]]?.length\"\n            >\n              {{ 'buttons.clear' | fswTranslate : { scope: 'world_check_result_table' } }}\n            </button>\n          </article>\n        </ng-template>\n      </ng-container>\n      <span class=\"flex items-center\" (click)=\"updateSort(column[0])\">\n        <ng-container *ngFor=\"let item of ['up', 'down']\">\n          <i\n            [fswIcon]=\"'common-sort-' + item\"\n            [fontSize]=\"'12px'\"\n            [class.text-gray-300]=\"sortKeySignal()[0] !== column[0] || sortKeySignal()[1] !== item\"\n            [class.text-blue-300]=\"sortKeySignal()[0] === column[0] && sortKeySignal()[1] === item\"\n            [ngClass]=\"{ '-mx-[2px] hover:text-blue-300': true }\"\n          ></i>\n        </ng-container>\n      </span>\n    </span>\n  </label>\n</ng-template>\n", styles: ["fsw-world-check-result-table .fsw-panel>main:empty{display:none}fsw-world-check-result-table .fsw-checkbox>label{visibility:hidden!important}fsw-world-check-result-table .fsw-pagination .fsw-field:not(.full-width):not(.flex-width){min-width:unset!important}\n"], dependencies: [{ kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "ngmodule", type: FSWCheckboxModule }, { kind: "component", type: i1$4.FSWCheckboxComponent, selector: "fsw-checkbox" }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "ngmodule", type: FSWTagsModule }, { kind: "component", type: i1$4.FSWTagsComponent, selector: "fsw-tags" }, { kind: "ngmodule", type: FSWFieldModule }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "ngmodule", type: FSWInputModule }, { kind: "directive", type: i1$4.FSWInputDirective, selector: "input[fswInput], textarea[fswInput]" }, { kind: "ngmodule", type: FSWPaginationModule$1 }, { kind: "component", type: i1$4.FSWPaginationComponent, selector: "fsw-pagination", inputs: ["total", "itemsPerPage", "currentPage", "itemsPerPageOptions", "showSelectOptions", "showViewTotalText", "showNavigationText", "totalTextInside"], outputs: ["currentPageChange", "itemsPerPageChange"] }, { kind: "directive", type: NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: DatePipe, name: "date" }, { kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "ngmodule", type: FSWSelectModule }, { kind: "component", type: i1$4.FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: i1$4.FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "directive", type: NgxMaskDirective, selector: "input[mask], textarea[mask]", inputs: ["mask", "specialCharacters", "patterns", "prefix", "suffix", "thousandSeparator", "decimalMarker", "dropSpecialCharacters", "hiddenInput", "showMaskTyped", "placeHolderCharacter", "shownMaskExpression", "showTemplate", "clearIfNotMatch", "validation", "separatorLimit", "allowNegativeNumbers", "leadZeroDateTime", "leadZero", "triggerOnMaskChange", "apm", "inputTransformFn", "outputTransformFn", "keepCharacterPositions"], outputs: ["maskFilled"], exportAs: ["mask", "ngxMask"] }, { kind: "directive", type: CdkMenuTrigger, selector: "[cdkMenuTriggerFor]", inputs: ["cdkMenuTriggerFor", "cdkMenuPosition", "cdkMenuTriggerData"], outputs: ["cdkMenuOpened", "cdkMenuClosed"], exportAs: ["cdkMenuTriggerFor"] }, { kind: "ngmodule", type: FSWDropdownModule }, { kind: "directive", type: i1$4.FSWDropdownDirective, selector: "[cdkMenuTriggerFor][fswDropdown]", inputs: ["fixedWidth", "allowBackDropClick", "offsetY", "offsetX", "event", "conditional"], exportAs: ["fswDropdown"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
};
FSWWorldCheckResultTableComponent = __decorate([
    autoDestroy()
], FSWWorldCheckResultTableComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckResultTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-result-table', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [provideWorldCheckTranslation('world_check_result_table'), provideNgxMask()], imports: [
                        FSWTranslateModule,
                        FSWPanelModule,
                        NgForOf,
                        FSWCheckboxModule,
                        ReactiveFormsModule,
                        FSWButtonModule,
                        NgIf,
                        FSWIconModule,
                        FSWTagsModule,
                        FSWFieldModule,
                        FSWInputModule,
                        FSWPaginationModule$1,
                        NgTemplateOutlet,
                        DatePipe,
                        NgClass,
                        NgSwitch,
                        NgSwitchDefault,
                        NgSwitchCase,
                        FormsModule,
                        FSWSelectModule,
                        NgxMaskDirective,
                        CdkMenuTrigger,
                        FSWDropdownModule,
                    ], encapsulation: ViewEncapsulation.None, template: "<fsw-panel [title]=\"'titles.result_screen' | fswTranslate : { scope: 'world_check_result_table' }\">\n  <ng-template fswPanelHeaderSuffix>\n    <section class=\"flex items-center gap-[8px]\">\n      <ng-container *ngIf=\"!isReadonly\">\n        <button\n          fswButton\n          [appearance]=\"'secondary'\"\n          [disabled]=\"!selectedResults().length || !resources?.permission?.allowResolve\"\n          (click)=\"!!resources?.permission?.allowResolve && action('resolution')\"\n        >\n          {{ 'buttons.resolution' | fswTranslate : { scope: 'world_check_result_table' } }}\n        </button>\n        <button\n          fswButton\n          [appearance]=\"'secondary'\"\n          [disabled]=\"!selectedResults().length\"\n          (click)=\"action('review')\"\n        >\n          {{ 'buttons.review' | fswTranslate : { scope: 'world_check_result_table' } }}\n        </button>\n        <button fswButton (click)=\"actionEvent.emit({ method: 'refresh', results: [] })\">\n          {{ 'buttons.refresh' | fswTranslate : { scope: 'world_check_result_table' } }}\n        </button>\n      </ng-container>\n      <i\n        fswIcon=\"common-arrow-down\"\n        class=\"text-[#2c50ff] duration-150\"\n        [class.rotate-180]=\"!hiddenViewSignal()\"\n        (click)=\"hiddenViewSignal.set(!hiddenViewSignal())\"\n      ></i>\n    </section>\n  </ng-template>\n  <section class=\"w-full flex flex-col gap-[16px]\" *ngIf=\"!hiddenViewSignal()\">\n    <header class=\"w-full flex items-center gap-[8px] justify-between\">\n      <section class=\"w-full flex items-center gap-[8px]\">\n        <ng-container *ngFor=\"let status of optionsMappingSignal()['resolution']\">\n          <fsw-tags\n            [hiddenCloseButton]=\"true\"\n            [color]=\"status.value === filterMappingSignal()['resolution'] ? 'blue' : 'gray'\"\n            (click)=\"updateFilter('resolution', status.value)\"\n          >\n            {{ status.value ?? 'All' }} ({{ status.length }})\n          </fsw-tags>\n        </ng-container>\n      </section>\n      <ng-container *ngIf=\"filterCountSignal().length as length\">\n        <span\n          class=\"text-blue-300 hover:text-blue-500 cursor-pointer text-body-caption-400 font-bold min-w-max\"\n          [cdkMenuTriggerFor]=\"listFiltersTemplate\"\n          [cdkMenuPosition]=\"menuPositions\"\n          fswDropdown\n        >\n          {{ length + ' Filter(s)' }}\n        </span>\n        <ng-template #listFiltersTemplate>\n          <article class=\"p-[12px] rounded-[8px] bg-white shadow-small flex flex-col gap-[8px]\">\n            <label class=\"text-blue-500 text-body-caption-500 font-bold\">\n              {{ length + ' Filter(s)' }}\n            </label>\n            <ng-container *ngFor=\"let item of filterCountSignal()\">\n              <fsw-tags [color]=\"'blue'\" (closeClick)=\"updateFilter(item[0], null)\">\n                {{ item[1] }}\n              </fsw-tags>\n            </ng-container>\n          </article>\n        </ng-template>\n      </ng-container>\n    </header>\n    <main class=\"w-full overflow-x-auto\">\n      <table class=\"fsw-table fsw-table--bordered min-w-full w-max !table-auto\">\n        <thead>\n          <tr>\n            <th\n              *ngIf=\"!isReadonly\"\n              class=\"align-middle text-center\"\n              (click)=\"!!filteredSignal().length && toggleAll()\"\n            >\n              <span [class.opacity-0]=\"isReadonly || !filteredSignal().length\">\n                <fsw-checkbox\n                  [forceChecked]=\"selectedResults().length === filteredSignal().length\"\n                ></fsw-checkbox>\n              </span>\n            </th>\n            <ng-container *ngFor=\"let column of columns\">\n              <th class=\"whitespace-normal align-middle break-words\">\n                <ng-container\n                  *ngTemplateOutlet=\"\n                    sortTemplate;\n                    context: {\n                      $implicit: column,\n                    }\n                  \"\n                />\n              </th>\n            </ng-container>\n          </tr>\n        </thead>\n        <tbody>\n          <ng-container *ngFor=\"let result of paginatedSignal()\">\n            <tr>\n              <td\n                *ngIf=\"!isReadonly\"\n                class=\"align-middle text-center\"\n                (click)=\"toggleMatch(result.resultId)\"\n              >\n                <fsw-checkbox\n                  [forceChecked]=\"selectedResults().includes(result.resultId)\"\n                ></fsw-checkbox>\n              </td>\n              <td\n                class=\"whitespace-normal align-middle break-words !text-blue-300 hover:underline\"\n                (click)=\"actionEvent.emit({ method: 'detail', results: [toMiniResult(result)] })\"\n              >\n                <p class=\"w-[300px]\">{{ result.name || '--' }}</p>\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                <p class=\"w-[200px]\">{{ result.matchStrength || '--' }}</p>\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                <p class=\"w-[200px]\">{{ result.matchScore || '--' }}</p>\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                <p class=\"w-[200px]\">{{ result.matchNameType || '--' }}</p>\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                <p class=\"w-[200px]\">\n                  {{\n                    result.resolution || FSWWorldCheckWatchlistResolvedByResolutionStatus.UNRESOLVED\n                  }}\n                </p>\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                <p class=\"w-[300px]\">{{ result.resolutionRemark || '--' }}</p>\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                <p class=\"w-[300px]\">{{ result.reviewRemark || '--' }}</p>\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                <p class=\"w-[200px]\">{{ result.registeredCountry || '--' }}</p>\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                <p class=\"w-[200px]\">{{ result.citizenship || '--' }}</p>\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                <p class=\"w-[200px]\">\n                  {{ result.dateOfBirth ? (result.dateOfBirth | date : 'dd/MM/yyyy') : '--' }}\n                </p>\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                <p class=\"w-[200px]\">{{ result.category || '--' }}</p>\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                <p class=\"w-[200px]\">\n                  {{ result.enteredDate ? (result.enteredDate | date : 'dd/MM/yyyy') : '--' }}\n                </p>\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                <label\n                  class=\"flex flex-wrap gap-[4px] w-[300px]\"\n                  *ngIf=\"result.specialInterestCategories?.length; else emptyTemplate\"\n                >\n                  <ng-container *ngFor=\"let type of result.specialInterestCategories\">\n                    <fsw-tags [hiddenCloseButton]=\"true\">{{ type }}</fsw-tags>\n                  </ng-container>\n                </label>\n              </td>\n            </tr>\n          </ng-container>\n        </tbody>\n      </table>\n    </main>\n    <footer class=\"flex justify-end w-full\">\n      <fsw-pagination\n        [total]=\"filteredSignal().length\"\n        [itemsPerPage]=\"itemsPerPageSignal() ?? filteredSignal().length\"\n        [currentPage]=\"indexSignal()\"\n        (currentPageChange)=\"indexSignal.set($event)\"\n        (itemsPerPageChange)=\"itemsPerPageSignal.set($event ?? filteredSignal().length)\"\n      ></fsw-pagination>\n    </footer>\n  </section>\n</fsw-panel>\n<ng-template #emptyTemplate>--</ng-template>\n<ng-template #sortTemplate let-column>\n  <label class=\"inline-flex justify-between items-center gap-[16px] {{ column[3] }}\">\n    <span [class.text-blue-300]=\"sortKeySignal()[0] === column[0]\">\n      {{ 'tables.result.' + column[1] | fswTranslate : { scope: 'world_check_result_table' } }}\n    </span>\n    <span class=\"flex items-center gap-[4px]\">\n      <ng-container *ngIf=\"column[0] !== 'resolution'\">\n        <i\n          [fswIcon]=\"'common-filter'\"\n          [fontSize]=\"'16px'\"\n          [ngClass]=\"{\n            'hover:text-blue-300': true,\n            'text-blue-300': !!filterMappingSignal()[column[0]]?.length\n          }\"\n          [cdkMenuTriggerFor]=\"filterTemplate\"\n          [cdkMenuPosition]=\"menuPositions\"\n          fswDropdown\n        ></i>\n        <ng-template #filterTemplate>\n          <article\n            class=\"flex flex-col gap-[8px] w-[300px] p-[12px] rounded-[8px] bg-white shadow-small\"\n          >\n            <ng-container [ngSwitch]=\"column[2]\">\n              <ng-container *ngSwitchCase=\"'select'\">\n                <fsw-field [fullWidth]=\"true\">\n                  <fsw-select\n                    [isMultiple]=\"true\"\n                    [maxHeight]=\"'300px'\"\n                    [placeHolder]=\"\n                      'tables.result.' + column[1]\n                        | fswTranslate : { scope: 'world_check_result_table' }\n                    \"\n                    [searchPlaceHolder]=\"\n                      'tables.result.' + column[1]\n                        | fswTranslate : { scope: 'world_check_result_table' }\n                    \"\n                    [ngModel]=\"filterMappingSignal()[column[0]] || []\"\n                    (ngModelChange)=\"updateFilter(column[0], $event)\"\n                  >\n                    <ng-container *ngFor=\"let item of optionsMappingSignal()[column[0]]\">\n                      <ng-template\n                        fswSelectItem\n                        [text]=\"item.value + ' (' + item.length + ')'\"\n                        [value]=\"item.value\"\n                        [isDisabled]=\"item.length === 0\"\n                      ></ng-template>\n                    </ng-container>\n                  </fsw-select>\n                </fsw-field>\n              </ng-container>\n              <ng-container *ngSwitchCase=\"'date'\">\n                <div class=\"w-full flex items-center gap-[8px]\">\n                  <div class=\"w-[calc(50%-4px)]\">\n                    <fsw-field [fullWidth]=\"true\">\n                      <input\n                        fswInput\n                        [mask]=\"'M0/0000'\"\n                        [specialCharacters]=\"['/']\"\n                        [dropSpecialCharacters]=\"false\"\n                        [ngModel]=\"filterMappingSignal()[column[0]]?.[0] || ''\"\n                        (ngModelChange)=\"\n                          updateFilter(column[0], [$event, $any(filterMappingSignal()[column[0]])?.[1]])\n                        \"\n                        [placeholder]=\"'MM/YYYY'\"\n                      />\n                    </fsw-field>\n                  </div>\n                  <div class=\"w-[calc(50%-4px)]\">\n                    <fsw-field [fullWidth]=\"true\">\n                      <input\n                        fswInput\n                        [mask]=\"'M0/0000'\"\n                        [specialCharacters]=\"['/']\"\n                        [dropSpecialCharacters]=\"false\"\n                        [ngModel]=\"filterMappingSignal()[column[0]]?.[1] || ''\"\n                        (ngModelChange)=\"\n                          updateFilter(column[0], [$any(filterMappingSignal()[column[0]])?.[0], $event])\n                        \"\n                        [placeholder]=\"'MM/YYYY'\"\n                      />\n                    </fsw-field>\n                  </div>\n                </div>\n              </ng-container>\n              <ng-container *ngSwitchCase=\"'number'\">\n                <div class=\"w-full flex items-center gap-[8px]\">\n                  <div class=\"w-[calc(50%-4px)]\">\n                    <fsw-field [fullWidth]=\"true\">\n                      <input\n                        fswInput\n                        [mask]=\"'separator.2'\"\n                        [thousandSeparator]=\"','\"\n                        [ngModel]=\"filterMappingSignal()[column[0]]?.[0] || ''\"\n                        (ngModelChange)=\"\n                          updateFilter(column[0], [$event, $any(filterMappingSignal()[column[0]])?.[1]])\n                        \"\n                        [placeholder]=\"'Min'\"\n                      />\n                    </fsw-field>\n                  </div>\n                  <div class=\"w-[calc(50%-4px)]\">\n                    <fsw-field [fullWidth]=\"true\">\n                      <input\n                        fswInput\n                        [mask]=\"'separator.2'\"\n                        [thousandSeparator]=\"','\"\n                        [ngModel]=\"filterMappingSignal()[column[0]]?.[1] || ''\"\n                        (ngModelChange)=\"\n                          updateFilter(column[0], [$any(filterMappingSignal()[column[0]])?.[0], $event])\n                        \"\n                        [placeholder]=\"'Max'\"\n                      />\n                    </fsw-field>\n                  </div>\n                </div>\n              </ng-container>\n              <ng-container *ngSwitchDefault>\n                <fsw-field [fullWidth]=\"true\">\n                  <input\n                    fswInput\n                    [ngModel]=\"filterMappingSignal()[column[0]] || ''\"\n                    (ngModelChange)=\"updateFilter(column[0], $event)\"\n                    [placeholder]=\"\n                      'tables.result.' + column[1]\n                        | fswTranslate : { scope: 'world_check_result_table' }\n                    \"\n                    type=\"text\"\n                  />\n                </fsw-field>\n              </ng-container>\n            </ng-container>\n            <button\n              fswButton\n              [appearance]=\"'secondary'\"\n              [size]=\"'s'\"\n              [ngClass]=\"{ '!w-full': true }\"\n              (click)=\"updateFilter(column[0], null)\"\n              [disabled]=\"!filterMappingSignal()[column[0]]?.length\"\n            >\n              {{ 'buttons.clear' | fswTranslate : { scope: 'world_check_result_table' } }}\n            </button>\n          </article>\n        </ng-template>\n      </ng-container>\n      <span class=\"flex items-center\" (click)=\"updateSort(column[0])\">\n        <ng-container *ngFor=\"let item of ['up', 'down']\">\n          <i\n            [fswIcon]=\"'common-sort-' + item\"\n            [fontSize]=\"'12px'\"\n            [class.text-gray-300]=\"sortKeySignal()[0] !== column[0] || sortKeySignal()[1] !== item\"\n            [class.text-blue-300]=\"sortKeySignal()[0] === column[0] && sortKeySignal()[1] === item\"\n            [ngClass]=\"{ '-mx-[2px] hover:text-blue-300': true }\"\n          ></i>\n        </ng-container>\n      </span>\n    </span>\n  </label>\n</ng-template>\n", styles: ["fsw-world-check-result-table .fsw-panel>main:empty{display:none}fsw-world-check-result-table .fsw-checkbox>label{visibility:hidden!important}fsw-world-check-result-table .fsw-pagination .fsw-field:not(.full-width):not(.flex-width){min-width:unset!important}\n"] }]
        }], propDecorators: { actionEvent: [{
                type: Output
            }], data: [{
                type: Input,
                args: [{ required: true }]
            }], case: [{
                type: Input,
                args: [{ required: true }]
            }], resources: [{
                type: Input,
                args: [{ required: true }]
            }], isReadonly: [{
                type: Input
            }], snapshotId: [{
                type: Input
            }] } });

class FSWWorldCheckCaseTableComponent {
    constructor() {
        this.selectedEvent = new EventEmitter();
        this.linkEvent = new EventEmitter();
        this.data = [];
        this.linkedCases = [];
        this.isReadonly = false;
        this.canGoToDetails = true;
        this.FSWWorldCheckLifecycleStates = FSWWorldCheckLifecycleStates;
        this.dataSignal = signal([]);
        this.queryControl = new FormControl('');
        this.querySignal = toSignal(this.queryControl.valueChanges, {
            initialValue: '',
        });
        this.typeSignal = signal(null);
        this.filteredSignal = computed(() => {
            const query = this.querySignal();
            const type = this.typeSignal();
            return this.dataSignal().filter((item) => (query
                ? item.name?.toLowerCase().includes(query.toLowerCase()) ||
                    item.identificationNumber?.toLowerCase().includes(query.toLowerCase()) ||
                    item.entityType?.toLowerCase().includes(query.toLowerCase()) ||
                    item.state?.toLowerCase().includes(query.toLowerCase()) ||
                    item.providerTypes?.some((providerType) => providerType.toLowerCase().includes(query.toLowerCase()))
                : true) &&
                (type
                    ? type === 'linked'
                        ? this.linkedCases?.includes(item.caseId)
                        : !this.linkedCases?.includes(item.caseId)
                    : true));
        });
        this.indexSignal = signal(1);
        this.itemsPerPageSignal = signal(50);
        this.paginatedSignal = computed(() => {
            return this.filteredSignal().slice((this.indexSignal() - 1) * (this.itemsPerPageSignal() ?? this.filteredSignal().length), this.indexSignal() * (this.itemsPerPageSignal() ?? this.filteredSignal().length));
        });
    }
    ngOnChanges() {
        this.dataSignal.set(this.data ?? []);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckCaseTableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckCaseTableComponent, isStandalone: true, selector: "fsw-world-check-case-table", inputs: { data: "data", linkedCases: "linkedCases", isReadonly: "isReadonly", canGoToDetails: "canGoToDetails" }, outputs: { selectedEvent: "selectedEvent", linkEvent: "linkEvent" }, providers: [provideWorldCheckTranslation('world_check_case_table')], usesOnChanges: true, ngImport: i0, template: "<section class=\"w-full flex flex-col gap-[16px]\">\n  <header class=\"flex justify-between items-center\" *ngIf=\"dataSignal()?.length\">\n    <div class=\"flex flex-wrap gap-[8px]\">\n      <fsw-tags\n        [hiddenCloseButton]=\"true\"\n        [color]=\"typeSignal() === null ? 'blue' : 'gray'\"\n        (click)=\"typeSignal.set(null)\"\n      >\n        {{ 'tables.case.all' | fswTranslate : { scope: 'world_check_case_table' } }}\n      </fsw-tags>\n      <fsw-tags\n        [hiddenCloseButton]=\"true\"\n        [color]=\"typeSignal() === 'linked' ? 'blue' : 'gray'\"\n        (click)=\"typeSignal.set('linked')\"\n      >\n        {{ 'tables.case.linked' | fswTranslate : { scope: 'world_check_case_table' } }}\n      </fsw-tags>\n      <fsw-tags\n        [hiddenCloseButton]=\"true\"\n        [color]=\"typeSignal() === 'available' ? 'blue' : 'gray'\"\n        (click)=\"typeSignal.set('available')\"\n      >\n        {{ 'tables.case.available' | fswTranslate : { scope: 'world_check_case_table' } }}\n      </fsw-tags>\n    </div>\n    <div class=\"w-[200px]\">\n      <fsw-field [fullWidth]=\"true\">\n        <input fswInput [formControl]=\"queryControl\" placeholder=\"Type to search...\" />\n      </fsw-field>\n    </div>\n  </header>\n  <main class=\"w-full overflow-x-auto\">\n    <table class=\"table-fixed fsw-table fsw-table--bordered w-full\">\n      <thead>\n        <tr>\n          <th class=\"whitespace-normal align-middle break-words\">\n            {{ 'tables.case.name' | fswTranslate : { scope: 'world_check_case_table' } }}\n          </th>\n          <th class=\"whitespace-normal align-middle break-words\">\n            {{ 'tables.case.id_number' | fswTranslate : { scope: 'world_check_case_table' } }}\n          </th>\n          <th class=\"whitespace-normal align-middle break-words\">\n            {{ 'tables.case.entity_type' | fswTranslate : { scope: 'world_check_case_table' } }}\n          </th>\n          <th class=\"whitespace-normal align-middle break-words\">\n            {{ 'tables.case.status' | fswTranslate : { scope: 'world_check_case_table' } }}\n          </th>\n          <th class=\"whitespace-normal align-middle break-words\">\n            {{ 'tables.case.provider_type' | fswTranslate : { scope: 'world_check_case_table' } }}\n          </th>\n          <th></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr *ngFor=\"let item of paginatedSignal()\">\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!text-blue-300]=\"canGoToDetails\"\n            [class.hover:underline]=\"canGoToDetails\"\n            [class.hover:cursor-pointer]=\"canGoToDetails\"\n            (click)=\"canGoToDetails && selectedEvent.emit(item)\"\n          >\n            {{ item.name || '--' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.identificationNumber || '--' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.entityType || '--' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            <ng-container *ngIf=\"item.state as status; else emptyTemplate\">\n              <fsw-tags\n                [color]=\"status === FSWWorldCheckLifecycleStates.ARCHIVED ? 'yellow' : 'green'\"\n                [hiddenCloseButton]=\"true\"\n                >{{ status }}</fsw-tags\n              >\n            </ng-container>\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            <label\n              class=\"flex flex-wrap gap-[4px]\"\n              *ngIf=\"item.providerTypes?.length; else emptyTemplate\"\n            >\n              <ng-container *ngFor=\"let type of item.providerTypes\">\n                <fsw-tags [hiddenCloseButton]=\"true\">{{ type }}</fsw-tags>\n              </ng-container>\n            </label>\n          </td>\n          <td class=\"align-middle\">\n            <ng-container *ngIf=\"!linkedCases.includes(item.caseId); else linkedTemplate\">\n              <button\n                fswButton\n                (click)=\"linkEvent.emit(item)\"\n                *ngIf=\"!isReadonly; else availableTemplate\"\n              >\n                {{ 'buttons.link' | fswTranslate : { scope: 'world_check_case_table' } }}\n              </button>\n              <ng-template #availableTemplate>\n                <fsw-tags [hiddenCloseButton]=\"true\" [color]=\"'blue'\">\n                  {{ 'tables.case.available' | fswTranslate : { scope: 'world_check_case_table' } }}\n                </fsw-tags>\n              </ng-template>\n            </ng-container>\n\n            <ng-template #linkedTemplate>\n              <fsw-tags [hiddenCloseButton]=\"true\" [color]=\"'green'\">\n                {{ 'tables.case.linked' | fswTranslate : { scope: 'world_check_case_table' } }}\n              </fsw-tags>\n            </ng-template>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </main>\n  <footer class=\"flex justify-end\" *ngIf=\"filteredSignal().length\">\n    <fsw-pagination\n      [total]=\"filteredSignal().length\"\n      [itemsPerPage]=\"itemsPerPageSignal() ?? filteredSignal().length\"\n      [currentPage]=\"indexSignal()\"\n      (currentPageChange)=\"indexSignal.set($event)\"\n      (itemsPerPageChange)=\"itemsPerPageSignal.set($event ?? filteredSignal().length)\"\n    ></fsw-pagination>\n  </footer>\n</section>\n<ng-template #emptyTemplate>--</ng-template>\n", dependencies: [{ kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FSWTagsModule }, { kind: "component", type: i1$4.FSWTagsComponent, selector: "fsw-tags" }, { kind: "ngmodule", type: FSWFieldModule }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "ngmodule", type: FSWInputModule }, { kind: "directive", type: i1$4.FSWInputDirective, selector: "input[fswInput], textarea[fswInput]" }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: FSWPaginationModule$1 }, { kind: "component", type: i1$4.FSWPaginationComponent, selector: "fsw-pagination", inputs: ["total", "itemsPerPage", "currentPage", "itemsPerPageOptions", "showSelectOptions", "showViewTotalText", "showNavigationText", "totalTextInside"], outputs: ["currentPageChange", "itemsPerPageChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckCaseTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-case-table', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [provideWorldCheckTranslation('world_check_case_table')], imports: [
                        FSWTranslateModule,
                        NgForOf,
                        FSWButtonModule,
                        NgIf,
                        FSWTagsModule,
                        FSWFieldModule,
                        FSWInputModule,
                        ReactiveFormsModule,
                        FSWPaginationModule$1,
                    ], template: "<section class=\"w-full flex flex-col gap-[16px]\">\n  <header class=\"flex justify-between items-center\" *ngIf=\"dataSignal()?.length\">\n    <div class=\"flex flex-wrap gap-[8px]\">\n      <fsw-tags\n        [hiddenCloseButton]=\"true\"\n        [color]=\"typeSignal() === null ? 'blue' : 'gray'\"\n        (click)=\"typeSignal.set(null)\"\n      >\n        {{ 'tables.case.all' | fswTranslate : { scope: 'world_check_case_table' } }}\n      </fsw-tags>\n      <fsw-tags\n        [hiddenCloseButton]=\"true\"\n        [color]=\"typeSignal() === 'linked' ? 'blue' : 'gray'\"\n        (click)=\"typeSignal.set('linked')\"\n      >\n        {{ 'tables.case.linked' | fswTranslate : { scope: 'world_check_case_table' } }}\n      </fsw-tags>\n      <fsw-tags\n        [hiddenCloseButton]=\"true\"\n        [color]=\"typeSignal() === 'available' ? 'blue' : 'gray'\"\n        (click)=\"typeSignal.set('available')\"\n      >\n        {{ 'tables.case.available' | fswTranslate : { scope: 'world_check_case_table' } }}\n      </fsw-tags>\n    </div>\n    <div class=\"w-[200px]\">\n      <fsw-field [fullWidth]=\"true\">\n        <input fswInput [formControl]=\"queryControl\" placeholder=\"Type to search...\" />\n      </fsw-field>\n    </div>\n  </header>\n  <main class=\"w-full overflow-x-auto\">\n    <table class=\"table-fixed fsw-table fsw-table--bordered w-full\">\n      <thead>\n        <tr>\n          <th class=\"whitespace-normal align-middle break-words\">\n            {{ 'tables.case.name' | fswTranslate : { scope: 'world_check_case_table' } }}\n          </th>\n          <th class=\"whitespace-normal align-middle break-words\">\n            {{ 'tables.case.id_number' | fswTranslate : { scope: 'world_check_case_table' } }}\n          </th>\n          <th class=\"whitespace-normal align-middle break-words\">\n            {{ 'tables.case.entity_type' | fswTranslate : { scope: 'world_check_case_table' } }}\n          </th>\n          <th class=\"whitespace-normal align-middle break-words\">\n            {{ 'tables.case.status' | fswTranslate : { scope: 'world_check_case_table' } }}\n          </th>\n          <th class=\"whitespace-normal align-middle break-words\">\n            {{ 'tables.case.provider_type' | fswTranslate : { scope: 'world_check_case_table' } }}\n          </th>\n          <th></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr *ngFor=\"let item of paginatedSignal()\">\n          <td\n            class=\"whitespace-normal align-middle break-words\"\n            [class.!text-blue-300]=\"canGoToDetails\"\n            [class.hover:underline]=\"canGoToDetails\"\n            [class.hover:cursor-pointer]=\"canGoToDetails\"\n            (click)=\"canGoToDetails && selectedEvent.emit(item)\"\n          >\n            {{ item.name || '--' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.identificationNumber || '--' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.entityType || '--' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            <ng-container *ngIf=\"item.state as status; else emptyTemplate\">\n              <fsw-tags\n                [color]=\"status === FSWWorldCheckLifecycleStates.ARCHIVED ? 'yellow' : 'green'\"\n                [hiddenCloseButton]=\"true\"\n                >{{ status }}</fsw-tags\n              >\n            </ng-container>\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            <label\n              class=\"flex flex-wrap gap-[4px]\"\n              *ngIf=\"item.providerTypes?.length; else emptyTemplate\"\n            >\n              <ng-container *ngFor=\"let type of item.providerTypes\">\n                <fsw-tags [hiddenCloseButton]=\"true\">{{ type }}</fsw-tags>\n              </ng-container>\n            </label>\n          </td>\n          <td class=\"align-middle\">\n            <ng-container *ngIf=\"!linkedCases.includes(item.caseId); else linkedTemplate\">\n              <button\n                fswButton\n                (click)=\"linkEvent.emit(item)\"\n                *ngIf=\"!isReadonly; else availableTemplate\"\n              >\n                {{ 'buttons.link' | fswTranslate : { scope: 'world_check_case_table' } }}\n              </button>\n              <ng-template #availableTemplate>\n                <fsw-tags [hiddenCloseButton]=\"true\" [color]=\"'blue'\">\n                  {{ 'tables.case.available' | fswTranslate : { scope: 'world_check_case_table' } }}\n                </fsw-tags>\n              </ng-template>\n            </ng-container>\n\n            <ng-template #linkedTemplate>\n              <fsw-tags [hiddenCloseButton]=\"true\" [color]=\"'green'\">\n                {{ 'tables.case.linked' | fswTranslate : { scope: 'world_check_case_table' } }}\n              </fsw-tags>\n            </ng-template>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </main>\n  <footer class=\"flex justify-end\" *ngIf=\"filteredSignal().length\">\n    <fsw-pagination\n      [total]=\"filteredSignal().length\"\n      [itemsPerPage]=\"itemsPerPageSignal() ?? filteredSignal().length\"\n      [currentPage]=\"indexSignal()\"\n      (currentPageChange)=\"indexSignal.set($event)\"\n      (itemsPerPageChange)=\"itemsPerPageSignal.set($event ?? filteredSignal().length)\"\n    ></fsw-pagination>\n  </footer>\n</section>\n<ng-template #emptyTemplate>--</ng-template>\n" }]
        }], propDecorators: { selectedEvent: [{
                type: Output
            }], linkEvent: [{
                type: Output
            }], data: [{
                type: Input,
                args: [{ required: true }]
            }], linkedCases: [{
                type: Input,
                args: [{ required: true }]
            }], isReadonly: [{
                type: Input
            }], canGoToDetails: [{
                type: Input
            }] } });

class FSWWorldCheckLinkTableComponent {
    constructor() {
        this.actionEvent = new EventEmitter();
        this.actionSnapshotEvent = new EventEmitter();
        this.data = [];
        this.isReadonly = false;
        this.resultsMapping = {};
        this.linkOpenSignal = signal({});
        this.positions = [
            {
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top',
                offsetY: 4,
            },
            {
                originX: 'start',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'bottom',
            },
        ];
        this.FSWWorldCheckLifecycleStates = FSWWorldCheckLifecycleStates;
    }
    toGroupName(group) {
        return this.resources.groups.find((g) => g.id === group)?.name || '';
    }
    toActionLabel(item) {
        return [
            're_screening',
            'un_link',
            'trigger',
            ...[item.state === FSWWorldCheckLifecycleStates.ARCHIVED ? 'un_archive' : 'archive'],
        ];
    }
    toSnapshotActionLabel(item, status) {
        return [
            ...(status !== 'Completed' ? ['refresh'] : []),
            ...((item.caseDossierReportDmsId || item.dmsId) && !item.error ? ['download'] : []),
            ...(item.error ? ['re_trigger', 'view_error'] : []),
            'delete',
        ];
    }
    toSnapshotStatusLabel(item) {
        return [
            item.error
                ? 'Error'
                : item.caseDossierReportDmsId || item.dmsId
                    ? 'Completed'
                    : 'In Progress',
            item.error ? 'red' : item.caseDossierReportDmsId || item.dmsId ? 'green' : 'blue',
        ];
    }
    toActionTitle(method) {
        if (['un_link', 'trigger'].includes(method)) {
            return `buttons.${method}`;
        }
        return `modals.${method}.title`;
    }
    toActionSnapshotTitle(method) {
        return `buttons.${method}`;
    }
    toSortedSnapshots(snapshots) {
        return [...(snapshots ?? [])].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
    }
    toUnresolvedResults(link) {
        return this.resultsMapping[`${link.id}${link.caseId}`] || 0;
    }
    action(item, method) {
        this.actionEvent.emit({
            item,
            method,
        });
    }
    actionSnapshot(item, method) {
        this.actionSnapshotEvent.emit({
            item,
            method,
        });
    }
    linkOpen(id) {
        this.linkOpenSignal.set({
            ...this.linkOpenSignal(),
            [id]: !this.linkOpenSignal()[id],
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckLinkTableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckLinkTableComponent, isStandalone: true, selector: "fsw-world-check-link-table", inputs: { data: "data", isReadonly: "isReadonly", resources: "resources", resultsMapping: "resultsMapping" }, outputs: { actionEvent: "actionEvent", actionSnapshotEvent: "actionSnapshotEvent" }, providers: [provideWorldCheckTranslation('world_check_link_table')], ngImport: i0, template: "<section class=\"w-full overflow-x-auto\">\n  <table class=\"!table-auto fsw-table fsw-table--bordered w-max min-w-full\">\n    <thead>\n      <tr>\n        <th class=\"w-[40px]\"></th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{ 'tables.case.name' | fswTranslate : { scope: 'world_check_link_table' } }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{ 'tables.case.id_number' | fswTranslate : { scope: 'world_check_link_table' } }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{ 'tables.case.entity_type' | fswTranslate : { scope: 'world_check_link_table' } }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{ 'tables.case.status' | fswTranslate : { scope: 'world_check_link_table' } }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{ 'tables.case.unresolved' | fswTranslate : { scope: 'world_check_link_table' } }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{ 'tables.case.provider_type' | fswTranslate : { scope: 'world_check_link_table' } }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{ 'tables.case.last_screen' | fswTranslate : { scope: 'world_check_link_table' } }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{ 'tables.case.group_id' | fswTranslate : { scope: 'world_check_link_table' } }}\n        </th>\n        <th *ngIf=\"!isReadonly\"></th>\n      </tr>\n    </thead>\n    <tbody>\n      <ng-container *ngFor=\"let link of data\">\n        <tr>\n          <td class=\"align-middle\">\n            <span\n              class=\"inline-flex\"\n              [class.-rotate-90]=\"!linkOpenSignal()[link.id]\"\n              (click)=\"linkOpen(link.id)\"\n            >\n              <i [fswIcon]=\"'common-arrow-dropdown'\"></i>\n            </span>\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words !text-blue-300 hover:underline hover:cursor-pointer\"\n            (click)=\"action(link, 'detail')\"\n          >\n            {{ link.detail.data.name || '--' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ link.detail.data.identificationNumber || '--' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ link.detail.data.entityType || '--' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            <ng-container *ngIf=\"link.detail.data.state as status; else emptyTemplate\">\n              <fsw-tags\n                [color]=\"status === FSWWorldCheckLifecycleStates.ARCHIVED ? 'yellow' : 'green'\"\n                [hiddenCloseButton]=\"true\"\n                >{{ status }}</fsw-tags\n              >\n            </ng-container>\n          </td>\n          <td class=\"whitespace-normal align-middle break-words text-red-500\">\n            {{ toUnresolvedResults(link) }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            <label\n              class=\"flex flex-wrap gap-[4px]\"\n              *ngIf=\"link.detail.data.providerTypes?.length; else emptyTemplate\"\n            >\n              <ng-container *ngFor=\"let type of link.detail.data.providerTypes\">\n                <fsw-tags [hiddenCloseButton]=\"true\">{{ type }}</fsw-tags>\n              </ng-container>\n            </label>\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{\n              link?.detail?.data?.lastScreenedDate\n                ? (link.detail.data.lastScreenedDate | date : 'dd/MM/yyyy HH:mm:ss')\n                : '--'\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ toGroupName(link.detail.data.groupId) || '--' }}\n          </td>\n          <td class=\"align-middle\" *ngIf=\"!isReadonly\">\n            <button\n              fswButton\n              #dropdown=\"fswDropdown\"\n              [appearance]=\"'icon-with-bg'\"\n              [size]=\"'s'\"\n              fswDropdown\n              [cdkMenuTriggerFor]=\"menuTemplate\"\n              [cdkMenuPosition]=\"positions\"\n            >\n              <i [fswIcon]=\"'common-more'\"></i>\n            </button>\n            <ng-template #menuTemplate>\n              <ol class=\"fsw-select__container !w-[160px]\">\n                <ng-container *ngFor=\"let label of toActionLabel(link.detail.data)\">\n                  <li class=\"fsw-select__item\" (click)=\"dropdown.close(true); action(link, label)\">\n                    <article class=\"fsw-select__item__template !py-[12px]\">\n                      <main>\n                        <span class=\"fsw-select__item__text fsw-select__item__text--m\">\n                          {{\n                            toActionTitle(label)\n                              | fswTranslate : { scope: 'world_check_link_table' }\n                          }}\n                        </span>\n                      </main>\n                    </article>\n                  </li>\n                </ng-container>\n              </ol>\n            </ng-template>\n          </td>\n        </tr>\n        <ng-container *ngIf=\"linkOpenSignal()[link.id]\">\n          <tr *ngIf=\"link.snapshots.records?.length\">\n            <td></td>\n            <td></td>\n            <td></td>\n            <td></td>\n            <td></td>\n            <td class=\"whitespace-normal align-middle break-words\">\n              {{\n                'tables.snapshot.created_at' | fswTranslate : { scope: 'world_check_link_table' }\n              }}\n            </td>\n            <td class=\"whitespace-normal align-middle break-words\">\n              {{\n                'tables.snapshot.created_by' | fswTranslate : { scope: 'world_check_link_table' }\n              }}\n            </td>\n            <td class=\"whitespace-normal align-middle break-words\">\n              {{ 'tables.snapshot.status' | fswTranslate : { scope: 'world_check_link_table' } }}\n            </td>\n            <td></td>\n          </tr>\n          <ng-container *ngFor=\"let snapshot of toSortedSnapshots(link.snapshots.records)\">\n            <tr *ngIf=\"toSnapshotStatusLabel(snapshot) as status\">\n              <td></td>\n              <td></td>\n              <td></td>\n              <td></td>\n              <td></td>\n              <td\n                class=\"whitespace-normal align-middle break-words\"\n                [class.!text-blue-300]=\"snapshot.hasData\"\n                [class.hover:underline]=\"snapshot.hasData\"\n                [class.hover:cursor-pointer]=\"snapshot.hasData\"\n                (click)=\"snapshot.hasData && actionSnapshot({snapshot, link}, 'detail')\"\n              >\n                {{\n                  snapshot.createdAt ? (snapshot.createdAt | date : 'dd/MM/yyyy HH:mm:ss') : '--'\n                }}\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                {{ snapshot.createdBy || '--' }}\n              </td>\n              <td class=\"align-middle\">\n                <fsw-tags [hiddenCloseButton]=\"true\" [color]=\"status[1]\">{{ status[0] }}</fsw-tags>\n              </td>\n              <td class=\"align-middle\" *ngIf=\"!isReadonly\">\n                <button\n                  fswButton\n                  #dropdown=\"fswDropdown\"\n                  [appearance]=\"'icon-with-bg'\"\n                  [size]=\"'s'\"\n                  fswDropdown\n                  [cdkMenuTriggerFor]=\"menuTemplate\"\n                  [cdkMenuPosition]=\"positions\"\n                >\n                  <i [fswIcon]=\"'common-more'\"></i>\n                </button>\n                <ng-template #menuTemplate>\n                  <ol class=\"fsw-select__container !w-[160px]\">\n                    <ng-container *ngFor=\"let label of toSnapshotActionLabel(snapshot, status[0])\">\n                      <li\n                        class=\"fsw-select__item\"\n                        (click)=\"dropdown.close(true); actionSnapshot({snapshot, link}, label)\"\n                      >\n                        <article class=\"fsw-select__item__template !py-[12px]\">\n                          <main>\n                            <span class=\"fsw-select__item__text fsw-select__item__text--m\">\n                              {{\n                                toActionSnapshotTitle(label)\n                                  | fswTranslate : { scope: 'world_check_link_table' }\n                              }}\n                            </span>\n                          </main>\n                        </article>\n                      </li>\n                    </ng-container>\n                  </ol>\n                </ng-template>\n              </td>\n            </tr>\n          </ng-container>\n        </ng-container>\n      </ng-container>\n    </tbody>\n  </table>\n</section>\n<ng-template #emptyTemplate>--</ng-template>\n", dependencies: [{ kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "pipe", type: DatePipe, name: "date" }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FSWDropdownModule }, { kind: "directive", type: i1$4.FSWDropdownDirective, selector: "[cdkMenuTriggerFor][fswDropdown]", inputs: ["fixedWidth", "allowBackDropClick", "offsetY", "offsetX", "event", "conditional"], exportAs: ["fswDropdown"] }, { kind: "directive", type: CdkMenuTrigger, selector: "[cdkMenuTriggerFor]", inputs: ["cdkMenuTriggerFor", "cdkMenuPosition", "cdkMenuTriggerData"], outputs: ["cdkMenuOpened", "cdkMenuClosed"], exportAs: ["cdkMenuTriggerFor"] }, { kind: "ngmodule", type: FSWTagsModule }, { kind: "component", type: i1$4.FSWTagsComponent, selector: "fsw-tags" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckLinkTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-link-table', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [provideWorldCheckTranslation('world_check_link_table')], imports: [
                        FSWTranslateModule,
                        NgForOf,
                        DatePipe,
                        FSWIconModule,
                        FSWButtonModule,
                        NgIf,
                        FSWDropdownModule,
                        CdkMenuTrigger,
                        FSWTagsModule,
                    ], template: "<section class=\"w-full overflow-x-auto\">\n  <table class=\"!table-auto fsw-table fsw-table--bordered w-max min-w-full\">\n    <thead>\n      <tr>\n        <th class=\"w-[40px]\"></th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{ 'tables.case.name' | fswTranslate : { scope: 'world_check_link_table' } }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{ 'tables.case.id_number' | fswTranslate : { scope: 'world_check_link_table' } }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{ 'tables.case.entity_type' | fswTranslate : { scope: 'world_check_link_table' } }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{ 'tables.case.status' | fswTranslate : { scope: 'world_check_link_table' } }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{ 'tables.case.unresolved' | fswTranslate : { scope: 'world_check_link_table' } }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{ 'tables.case.provider_type' | fswTranslate : { scope: 'world_check_link_table' } }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{ 'tables.case.last_screen' | fswTranslate : { scope: 'world_check_link_table' } }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{ 'tables.case.group_id' | fswTranslate : { scope: 'world_check_link_table' } }}\n        </th>\n        <th *ngIf=\"!isReadonly\"></th>\n      </tr>\n    </thead>\n    <tbody>\n      <ng-container *ngFor=\"let link of data\">\n        <tr>\n          <td class=\"align-middle\">\n            <span\n              class=\"inline-flex\"\n              [class.-rotate-90]=\"!linkOpenSignal()[link.id]\"\n              (click)=\"linkOpen(link.id)\"\n            >\n              <i [fswIcon]=\"'common-arrow-dropdown'\"></i>\n            </span>\n          </td>\n          <td\n            class=\"whitespace-normal align-middle break-words !text-blue-300 hover:underline hover:cursor-pointer\"\n            (click)=\"action(link, 'detail')\"\n          >\n            {{ link.detail.data.name || '--' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ link.detail.data.identificationNumber || '--' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ link.detail.data.entityType || '--' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            <ng-container *ngIf=\"link.detail.data.state as status; else emptyTemplate\">\n              <fsw-tags\n                [color]=\"status === FSWWorldCheckLifecycleStates.ARCHIVED ? 'yellow' : 'green'\"\n                [hiddenCloseButton]=\"true\"\n                >{{ status }}</fsw-tags\n              >\n            </ng-container>\n          </td>\n          <td class=\"whitespace-normal align-middle break-words text-red-500\">\n            {{ toUnresolvedResults(link) }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            <label\n              class=\"flex flex-wrap gap-[4px]\"\n              *ngIf=\"link.detail.data.providerTypes?.length; else emptyTemplate\"\n            >\n              <ng-container *ngFor=\"let type of link.detail.data.providerTypes\">\n                <fsw-tags [hiddenCloseButton]=\"true\">{{ type }}</fsw-tags>\n              </ng-container>\n            </label>\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{\n              link?.detail?.data?.lastScreenedDate\n                ? (link.detail.data.lastScreenedDate | date : 'dd/MM/yyyy HH:mm:ss')\n                : '--'\n            }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ toGroupName(link.detail.data.groupId) || '--' }}\n          </td>\n          <td class=\"align-middle\" *ngIf=\"!isReadonly\">\n            <button\n              fswButton\n              #dropdown=\"fswDropdown\"\n              [appearance]=\"'icon-with-bg'\"\n              [size]=\"'s'\"\n              fswDropdown\n              [cdkMenuTriggerFor]=\"menuTemplate\"\n              [cdkMenuPosition]=\"positions\"\n            >\n              <i [fswIcon]=\"'common-more'\"></i>\n            </button>\n            <ng-template #menuTemplate>\n              <ol class=\"fsw-select__container !w-[160px]\">\n                <ng-container *ngFor=\"let label of toActionLabel(link.detail.data)\">\n                  <li class=\"fsw-select__item\" (click)=\"dropdown.close(true); action(link, label)\">\n                    <article class=\"fsw-select__item__template !py-[12px]\">\n                      <main>\n                        <span class=\"fsw-select__item__text fsw-select__item__text--m\">\n                          {{\n                            toActionTitle(label)\n                              | fswTranslate : { scope: 'world_check_link_table' }\n                          }}\n                        </span>\n                      </main>\n                    </article>\n                  </li>\n                </ng-container>\n              </ol>\n            </ng-template>\n          </td>\n        </tr>\n        <ng-container *ngIf=\"linkOpenSignal()[link.id]\">\n          <tr *ngIf=\"link.snapshots.records?.length\">\n            <td></td>\n            <td></td>\n            <td></td>\n            <td></td>\n            <td></td>\n            <td class=\"whitespace-normal align-middle break-words\">\n              {{\n                'tables.snapshot.created_at' | fswTranslate : { scope: 'world_check_link_table' }\n              }}\n            </td>\n            <td class=\"whitespace-normal align-middle break-words\">\n              {{\n                'tables.snapshot.created_by' | fswTranslate : { scope: 'world_check_link_table' }\n              }}\n            </td>\n            <td class=\"whitespace-normal align-middle break-words\">\n              {{ 'tables.snapshot.status' | fswTranslate : { scope: 'world_check_link_table' } }}\n            </td>\n            <td></td>\n          </tr>\n          <ng-container *ngFor=\"let snapshot of toSortedSnapshots(link.snapshots.records)\">\n            <tr *ngIf=\"toSnapshotStatusLabel(snapshot) as status\">\n              <td></td>\n              <td></td>\n              <td></td>\n              <td></td>\n              <td></td>\n              <td\n                class=\"whitespace-normal align-middle break-words\"\n                [class.!text-blue-300]=\"snapshot.hasData\"\n                [class.hover:underline]=\"snapshot.hasData\"\n                [class.hover:cursor-pointer]=\"snapshot.hasData\"\n                (click)=\"snapshot.hasData && actionSnapshot({snapshot, link}, 'detail')\"\n              >\n                {{\n                  snapshot.createdAt ? (snapshot.createdAt | date : 'dd/MM/yyyy HH:mm:ss') : '--'\n                }}\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                {{ snapshot.createdBy || '--' }}\n              </td>\n              <td class=\"align-middle\">\n                <fsw-tags [hiddenCloseButton]=\"true\" [color]=\"status[1]\">{{ status[0] }}</fsw-tags>\n              </td>\n              <td class=\"align-middle\" *ngIf=\"!isReadonly\">\n                <button\n                  fswButton\n                  #dropdown=\"fswDropdown\"\n                  [appearance]=\"'icon-with-bg'\"\n                  [size]=\"'s'\"\n                  fswDropdown\n                  [cdkMenuTriggerFor]=\"menuTemplate\"\n                  [cdkMenuPosition]=\"positions\"\n                >\n                  <i [fswIcon]=\"'common-more'\"></i>\n                </button>\n                <ng-template #menuTemplate>\n                  <ol class=\"fsw-select__container !w-[160px]\">\n                    <ng-container *ngFor=\"let label of toSnapshotActionLabel(snapshot, status[0])\">\n                      <li\n                        class=\"fsw-select__item\"\n                        (click)=\"dropdown.close(true); actionSnapshot({snapshot, link}, label)\"\n                      >\n                        <article class=\"fsw-select__item__template !py-[12px]\">\n                          <main>\n                            <span class=\"fsw-select__item__text fsw-select__item__text--m\">\n                              {{\n                                toActionSnapshotTitle(label)\n                                  | fswTranslate : { scope: 'world_check_link_table' }\n                              }}\n                            </span>\n                          </main>\n                        </article>\n                      </li>\n                    </ng-container>\n                  </ol>\n                </ng-template>\n              </td>\n            </tr>\n          </ng-container>\n        </ng-container>\n      </ng-container>\n    </tbody>\n  </table>\n</section>\n<ng-template #emptyTemplate>--</ng-template>\n" }]
        }], propDecorators: { actionEvent: [{
                type: Output
            }], actionSnapshotEvent: [{
                type: Output
            }], data: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], resources: [{
                type: Input,
                args: [{ required: true }]
            }], resultsMapping: [{
                type: Input,
                args: [{ required: true }]
            }] } });

class FSWWorldCheckLocationTableComponent {
    constructor() {
        this.data = [];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckLocationTableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckLocationTableComponent, isStandalone: true, selector: "fsw-world-check-location-table", inputs: { data: "data" }, providers: [provideWorldCheckTranslation('world_check_location_table')], ngImport: i0, template: "<table class=\"fsw-table fsw-table--bordered w-full table-fixed\">\n  <thead>\n    <tr>\n      <th>\n        {{ 'tables.location.street' | fswTranslate : { scope: 'world_check_location_table' } }}\n      </th>\n      <th>\n        {{ 'tables.location.city' | fswTranslate : { scope: 'world_check_location_table' } }}\n      </th>\n      <th>\n        {{ 'tables.location.region' | fswTranslate : { scope: 'world_check_location_table' } }}\n      </th>\n      <th>\n        {{ 'tables.location.country' | fswTranslate : { scope: 'world_check_location_table' } }}\n      </th>\n      <th>\n        {{ 'tables.location.postcode' | fswTranslate : { scope: 'world_check_location_table' } }}\n      </th>\n    </tr>\n  </thead>\n  <tbody>\n    <ng-container *ngFor=\"let location of data\">\n      <tr>\n        <td class=\"whitespace-normal align-middle break-words\">{{ location.street || '--' }}</td>\n        <td class=\"whitespace-normal align-middle break-words\">{{ location.city || '--' }}</td>\n        <td class=\"whitespace-normal align-middle break-words\">{{ location.region || '--' }}</td>\n        <td class=\"whitespace-normal align-middle break-words\">{{ location.country || '--' }}</td>\n        <td class=\"whitespace-normal align-middle break-words\">{{ location.postCode || '--' }}</td>\n      </tr>\n    </ng-container>\n  </tbody>\n</table>\n", dependencies: [{ kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckLocationTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-location-table', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [provideWorldCheckTranslation('world_check_location_table')], imports: [FSWTranslateModule, NgForOf], template: "<table class=\"fsw-table fsw-table--bordered w-full table-fixed\">\n  <thead>\n    <tr>\n      <th>\n        {{ 'tables.location.street' | fswTranslate : { scope: 'world_check_location_table' } }}\n      </th>\n      <th>\n        {{ 'tables.location.city' | fswTranslate : { scope: 'world_check_location_table' } }}\n      </th>\n      <th>\n        {{ 'tables.location.region' | fswTranslate : { scope: 'world_check_location_table' } }}\n      </th>\n      <th>\n        {{ 'tables.location.country' | fswTranslate : { scope: 'world_check_location_table' } }}\n      </th>\n      <th>\n        {{ 'tables.location.postcode' | fswTranslate : { scope: 'world_check_location_table' } }}\n      </th>\n    </tr>\n  </thead>\n  <tbody>\n    <ng-container *ngFor=\"let location of data\">\n      <tr>\n        <td class=\"whitespace-normal align-middle break-words\">{{ location.street || '--' }}</td>\n        <td class=\"whitespace-normal align-middle break-words\">{{ location.city || '--' }}</td>\n        <td class=\"whitespace-normal align-middle break-words\">{{ location.region || '--' }}</td>\n        <td class=\"whitespace-normal align-middle break-words\">{{ location.country || '--' }}</td>\n        <td class=\"whitespace-normal align-middle break-words\">{{ location.postCode || '--' }}</td>\n      </tr>\n    </ng-container>\n  </tbody>\n</table>\n" }]
        }], propDecorators: { data: [{
                type: Input,
                args: [{ required: true }]
            }] } });

class FSWWorldCheckReferenceTableComponent {
    constructor() {
        this.data = [];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckReferenceTableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckReferenceTableComponent, isStandalone: true, selector: "fsw-world-check-reference-table", inputs: { data: "data" }, providers: [provideWorldCheckTranslation('world_check_reference_table')], ngImport: i0, template: "<fsw-panel\n  [title]=\"'titles.record_screen' | fswTranslate : { scope: 'world_check_reference_table' }\"\n>\n  <table class=\"fsw-table fsw-table--bordered w-full table-fixed\">\n    <thead>\n      <tr>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'tables.reference.category' | fswTranslate : { scope: 'world_check_reference_table' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'tables.reference.entity_type' | fswTranslate : { scope: 'world_check_reference_table' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'tables.reference.entity_id' | fswTranslate : { scope: 'world_check_reference_table' }\n          }}\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      <ng-container *ngFor=\"let item of data\">\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.category || '--' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.entityType || '--' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.entityId || '--' }}\n          </td>\n        </tr>\n      </ng-container>\n    </tbody>\n  </table>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckReferenceTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-reference-table', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [provideWorldCheckTranslation('world_check_reference_table')], imports: [FSWTranslateModule, FSWPanelModule, NgForOf], template: "<fsw-panel\n  [title]=\"'titles.record_screen' | fswTranslate : { scope: 'world_check_reference_table' }\"\n>\n  <table class=\"fsw-table fsw-table--bordered w-full table-fixed\">\n    <thead>\n      <tr>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'tables.reference.category' | fswTranslate : { scope: 'world_check_reference_table' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'tables.reference.entity_type' | fswTranslate : { scope: 'world_check_reference_table' }\n          }}\n        </th>\n        <th class=\"whitespace-normal align-middle break-words\">\n          {{\n            'tables.reference.entity_id' | fswTranslate : { scope: 'world_check_reference_table' }\n          }}\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      <ng-container *ngFor=\"let item of data\">\n        <tr>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.category || '--' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.entityType || '--' }}\n          </td>\n          <td class=\"whitespace-normal align-middle break-words\">\n            {{ item.entityId || '--' }}\n          </td>\n        </tr>\n      </ng-container>\n    </tbody>\n  </table>\n</fsw-panel>\n" }]
        }], propDecorators: { data: [{
                type: Input,
                args: [{ required: true }]
            }] } });

let FSWWorldCheckSnapshotTableComponent = class FSWWorldCheckSnapshotTableComponent {
    constructor() {
        this.actionEvent = new EventEmitter();
        this.data = [];
        this.isReadonly = false;
        this.snapshotId = null;
        this.hiddenViewSignal = signal(false);
        this.queryControl = new FormControl('');
        this.filteredSignal = signal([]);
        this.indexSignal = signal(1);
        this.itemsPerPageSignal = signal(50);
        this.paginatedSignal = computed(() => {
            return this.filteredSignal().slice((this.indexSignal() - 1) * (this.itemsPerPageSignal() ?? this.filteredSignal().length), this.indexSignal() * (this.itemsPerPageSignal() ?? this.filteredSignal().length));
        });
    }
    ngOnInit() {
        this.queryControl.valueChanges
            .pipe(startWith(''))
            .pipe(followDestroy(this), tap(() => {
            this.indexSignal.set(1);
            this.runFilter();
        }))
            .subscribe();
    }
    ngOnChanges() {
        this.runFilter();
    }
    toShort(item) {
        return {
            ...item,
            hasData: !!item.data,
        };
    }
    // public toSnapshotStatusLabel(item: IFSWWorldCheckSnapshotShortVM): [string, string] {
    //   return [
    //     item.error
    //       ? 'Error'
    //       : item.caseDossierReportDmsId || item.dmsId
    //       ? 'Completed'
    //       : 'In Progress',
    //     item.error ? 'red' : item.caseDossierReportDmsId || item.dmsId ? 'green' : 'blue',
    //   ];
    // }
    toSnapshotStatusLabel(item) {
        let statusLabel = 'In Progress';
        let color = 'blue';
        if (item?.error || item?.status === 'FAILED' || item?.status === 'ERROR') {
            statusLabel = 'Error';
            color = 'red';
        }
        else if (item?.status === 'COMPLETED') {
            statusLabel = 'Completed';
            color = 'green';
        }
        else if (item?.status === 'IN PROGRESS') {
            statusLabel = 'In Progress';
            color = 'blue';
        }
        else {
            statusLabel = item.status;
            color = 'blue';
        }
        return [statusLabel, color];
    }
    toSortedSnapshots(snapshots) {
        return [...(snapshots ?? [])].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
    }
    runFilter() {
        const query = this.queryControl.value;
        this.filteredSignal.set(this.toSortedSnapshots(this.data?.filter((match) => query
            ? match.createdBy?.toLowerCase().includes(query.toLowerCase()) ||
                this.toSnapshotStatusLabel(match)[1]?.toLowerCase().includes(query.toLowerCase())
            : true) ?? []));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckSnapshotTableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckSnapshotTableComponent, isStandalone: true, selector: "fsw-world-check-snapshot-table", inputs: { data: "data", isReadonly: "isReadonly", snapshotId: "snapshotId" }, outputs: { actionEvent: "actionEvent" }, providers: [provideWorldCheckTranslation('world_check_snapshot_table')], usesOnChanges: true, ngImport: i0, template: "<fsw-panel\n  *ngIf=\"!snapshotId; else defaultTemplate\"\n  [title]=\"'titles.snapshot_screen' | fswTranslate : { scope: 'world_check_snapshot_table' }\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <section class=\"flex items-center gap-[8px]\">\n      <div class=\"w-[200px]\">\n        <fsw-field [fullWidth]=\"true\">\n          <input fswInput [formControl]=\"queryControl\" placeholder=\"Type to search\" />\n        </fsw-field>\n      </div>\n      <button\n        *ngIf=\"!isReadonly\"\n        fswButton\n        (click)=\"actionEvent.emit({ item: null, method: 'trigger' })\"\n      >\n        {{ 'buttons.trigger' | fswTranslate : { scope: 'world_check_snapshot_table' } }}\n      </button>\n      <button fswButton (click)=\"actionEvent.emit({ item: null, method: 'refresh' })\">\n        {{ 'buttons.refresh' | fswTranslate : { scope: 'world_check_snapshot_table' } }}\n      </button>\n      <i\n        fswIcon=\"common-arrow-down\"\n        [class.rotate-180]=\"!hiddenViewSignal()\"\n        class=\"text-[#2c50ff] duration-150\"\n        (click)=\"hiddenViewSignal.set(!hiddenViewSignal())\"\n      ></i>\n    </section>\n  </ng-template>\n  <ng-container *ngTemplateOutlet=\"defaultTemplate\"></ng-container>\n</fsw-panel>\n<ng-template #defaultTemplate>\n  <section class=\"w-full flex flex-col gap-[16px]\" *ngIf=\"!hiddenViewSignal() || snapshotId\">\n    <section class=\"w-full overflow-x-auto\">\n      <table class=\"fsw-table fsw-table--bordered w-full !table-auto\">\n        <thead>\n          <tr>\n            <th class=\"whitespace-normal align-middle break-words\">\n              {{\n                'tables.snapshot.created_at'\n                  | fswTranslate : { scope: 'world_check_snapshot_table' }\n              }}\n            </th>\n            <th class=\"whitespace-normal align-middle break-words\">\n              {{\n                'tables.snapshot.updated_at'\n                  | fswTranslate : { scope: 'world_check_snapshot_table' }\n              }}\n            </th>\n            <th class=\"whitespace-normal align-middle break-words\">\n              {{\n                'tables.snapshot.created_by'\n                  | fswTranslate : { scope: 'world_check_snapshot_table' }\n              }}\n            </th>\n            <th class=\"whitespace-normal align-middle break-words\">\n              {{\n                'tables.snapshot.status' | fswTranslate : { scope: 'world_check_snapshot_table' }\n              }}\n            </th>\n            <th class=\"whitespace-normal align-middle break-words\" *ngIf=\"!isReadonly\">\n              {{\n                'tables.snapshot.action' | fswTranslate : { scope: 'world_check_snapshot_table' }\n              }}\n            </th>\n          </tr>\n        </thead>\n        <tbody>\n          <ng-container *ngFor=\"let item of paginatedSignal()\">\n            <tr *ngIf=\"toSnapshotStatusLabel(item) as statusLabelAndColor\">\n              <td class=\"whitespace-normal align-middle break-words\">\n                {{ item.createdAt ? (item.createdAt | date : 'dd/MM/yyyy HH:mm:ss') : '--' }}\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                {{ item.updatedAt ? (item.updatedAt | date : 'dd/MM/yyyy HH:mm:ss') : '--' }}\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                {{ item.createdBy || '--' }}\n              </td>\n              <td class=\"align-middle\">\n                <fsw-tags [hiddenCloseButton]=\"true\" [color]=\"statusLabelAndColor[1]\">{{\n                  statusLabelAndColor[0]\n                }}</fsw-tags>\n              </td>\n              <td class=\"align-middle\">\n                <div class=\"flex gap-[8px]\">\n                  <button\n                    *ngIf=\"item.error; else snapshotDownloadTemplate\"\n                    fswButton\n                    class=\"!text-red-500 !bg-red-100\"\n                    (click)=\"actionEvent.emit({ item: toShort(item), method: 'view_error' })\"\n                  >\n                    {{\n                      'buttons.view_error' | fswTranslate : { scope: 'world_check_snapshot_table' }\n                    }}\n                  </button>\n                  <ng-template #snapshotDownloadTemplate>\n                    <button\n                      *ngIf=\"item.caseDossierReportDmsId || item.dmsId\"\n                      fswButton\n                      [appearance]=\"'icon-with-bg'\"\n                      (click)=\"actionEvent.emit({ item: toShort(item), method: 'download' })\"\n                    >\n                      <i fswIcon=\"common-download\"></i>\n                    </button>\n                  </ng-template>\n                  <button\n                    *ngIf=\"!isReadonly && item?.status !== 'COMPLETED'\"\n                    [appearance]=\"'icon-with-bg'\"\n                    fswButton\n                    (click)=\"actionEvent.emit({ item: toShort(item), method: 're_trigger' })\"\n                  >\n                    <i fswIcon=\"status-ongoing\"></i>\n                  </button>\n                  <!-- <button\n                    *ngIf=\"!isReadonly\"\n                    fswButton\n                    (click)=\"actionEvent.emit({ item: toShort(item), method: 'delete' })\"\n                    [appearance]=\"'icon-with-bg'\"\n                    class=\"!text-red-500 !bg-red-100\"\n                  >\n                    <i fswIcon=\"common-delete\"></i>\n                  </button> -->\n                  <button\n                    *ngIf=\"item?.status === 'COMPLETED'\"\n                    fswButton\n                    (click)=\"actionEvent.emit({ item: toShort(item), method: 'detail' })\"\n                    [appearance]=\"'icon-with-bg'\"\n                  >\n                    <i fswIcon=\"common-external-link\"></i>\n                  </button>\n                </div>\n              </td>\n            </tr>\n          </ng-container>\n        </tbody>\n      </table>\n    </section>\n    <footer class=\"flex justify-end\" *ngIf=\"!snapshotId\">\n      <fsw-pagination\n        [total]=\"filteredSignal().length\"\n        [itemsPerPage]=\"itemsPerPageSignal() ?? filteredSignal().length\"\n        [currentPage]=\"indexSignal()\"\n        (currentPageChange)=\"indexSignal.set($event)\"\n        (itemsPerPageChange)=\"itemsPerPageSignal.set($event ?? filteredSignal().length)\"\n      ></fsw-pagination>\n    </footer>\n  </section>\n</ng-template>\n", styles: ["fsw-world-check-snapshot-table .fsw-panel>main:empty{display:none}\n"], dependencies: [{ kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "pipe", type: DatePipe, name: "date" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: FSWTagsModule }, { kind: "component", type: i1$4.FSWTagsComponent, selector: "fsw-tags" }, { kind: "directive", type: NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "ngmodule", type: FSWPaginationModule$1 }, { kind: "component", type: i1$4.FSWPaginationComponent, selector: "fsw-pagination", inputs: ["total", "itemsPerPage", "currentPage", "itemsPerPageOptions", "showSelectOptions", "showViewTotalText", "showNavigationText", "totalTextInside"], outputs: ["currentPageChange", "itemsPerPageChange"] }, { kind: "ngmodule", type: FSWFieldModule }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: FSWInputModule }, { kind: "directive", type: i1$4.FSWInputDirective, selector: "input[fswInput], textarea[fswInput]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
};
FSWWorldCheckSnapshotTableComponent = __decorate([
    autoDestroy()
], FSWWorldCheckSnapshotTableComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckSnapshotTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-snapshot-table', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [provideWorldCheckTranslation('world_check_snapshot_table')], imports: [
                        FSWTranslateModule,
                        NgForOf,
                        DatePipe,
                        FSWButtonModule,
                        FSWIconModule,
                        NgIf,
                        FSWPanelModule,
                        FSWTagsModule,
                        NgTemplateOutlet,
                        FSWPaginationModule$1,
                        FSWFieldModule,
                        ReactiveFormsModule,
                        FSWInputModule,
                    ], encapsulation: ViewEncapsulation.None, template: "<fsw-panel\n  *ngIf=\"!snapshotId; else defaultTemplate\"\n  [title]=\"'titles.snapshot_screen' | fswTranslate : { scope: 'world_check_snapshot_table' }\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <section class=\"flex items-center gap-[8px]\">\n      <div class=\"w-[200px]\">\n        <fsw-field [fullWidth]=\"true\">\n          <input fswInput [formControl]=\"queryControl\" placeholder=\"Type to search\" />\n        </fsw-field>\n      </div>\n      <button\n        *ngIf=\"!isReadonly\"\n        fswButton\n        (click)=\"actionEvent.emit({ item: null, method: 'trigger' })\"\n      >\n        {{ 'buttons.trigger' | fswTranslate : { scope: 'world_check_snapshot_table' } }}\n      </button>\n      <button fswButton (click)=\"actionEvent.emit({ item: null, method: 'refresh' })\">\n        {{ 'buttons.refresh' | fswTranslate : { scope: 'world_check_snapshot_table' } }}\n      </button>\n      <i\n        fswIcon=\"common-arrow-down\"\n        [class.rotate-180]=\"!hiddenViewSignal()\"\n        class=\"text-[#2c50ff] duration-150\"\n        (click)=\"hiddenViewSignal.set(!hiddenViewSignal())\"\n      ></i>\n    </section>\n  </ng-template>\n  <ng-container *ngTemplateOutlet=\"defaultTemplate\"></ng-container>\n</fsw-panel>\n<ng-template #defaultTemplate>\n  <section class=\"w-full flex flex-col gap-[16px]\" *ngIf=\"!hiddenViewSignal() || snapshotId\">\n    <section class=\"w-full overflow-x-auto\">\n      <table class=\"fsw-table fsw-table--bordered w-full !table-auto\">\n        <thead>\n          <tr>\n            <th class=\"whitespace-normal align-middle break-words\">\n              {{\n                'tables.snapshot.created_at'\n                  | fswTranslate : { scope: 'world_check_snapshot_table' }\n              }}\n            </th>\n            <th class=\"whitespace-normal align-middle break-words\">\n              {{\n                'tables.snapshot.updated_at'\n                  | fswTranslate : { scope: 'world_check_snapshot_table' }\n              }}\n            </th>\n            <th class=\"whitespace-normal align-middle break-words\">\n              {{\n                'tables.snapshot.created_by'\n                  | fswTranslate : { scope: 'world_check_snapshot_table' }\n              }}\n            </th>\n            <th class=\"whitespace-normal align-middle break-words\">\n              {{\n                'tables.snapshot.status' | fswTranslate : { scope: 'world_check_snapshot_table' }\n              }}\n            </th>\n            <th class=\"whitespace-normal align-middle break-words\" *ngIf=\"!isReadonly\">\n              {{\n                'tables.snapshot.action' | fswTranslate : { scope: 'world_check_snapshot_table' }\n              }}\n            </th>\n          </tr>\n        </thead>\n        <tbody>\n          <ng-container *ngFor=\"let item of paginatedSignal()\">\n            <tr *ngIf=\"toSnapshotStatusLabel(item) as statusLabelAndColor\">\n              <td class=\"whitespace-normal align-middle break-words\">\n                {{ item.createdAt ? (item.createdAt | date : 'dd/MM/yyyy HH:mm:ss') : '--' }}\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                {{ item.updatedAt ? (item.updatedAt | date : 'dd/MM/yyyy HH:mm:ss') : '--' }}\n              </td>\n              <td class=\"whitespace-normal align-middle break-words\">\n                {{ item.createdBy || '--' }}\n              </td>\n              <td class=\"align-middle\">\n                <fsw-tags [hiddenCloseButton]=\"true\" [color]=\"statusLabelAndColor[1]\">{{\n                  statusLabelAndColor[0]\n                }}</fsw-tags>\n              </td>\n              <td class=\"align-middle\">\n                <div class=\"flex gap-[8px]\">\n                  <button\n                    *ngIf=\"item.error; else snapshotDownloadTemplate\"\n                    fswButton\n                    class=\"!text-red-500 !bg-red-100\"\n                    (click)=\"actionEvent.emit({ item: toShort(item), method: 'view_error' })\"\n                  >\n                    {{\n                      'buttons.view_error' | fswTranslate : { scope: 'world_check_snapshot_table' }\n                    }}\n                  </button>\n                  <ng-template #snapshotDownloadTemplate>\n                    <button\n                      *ngIf=\"item.caseDossierReportDmsId || item.dmsId\"\n                      fswButton\n                      [appearance]=\"'icon-with-bg'\"\n                      (click)=\"actionEvent.emit({ item: toShort(item), method: 'download' })\"\n                    >\n                      <i fswIcon=\"common-download\"></i>\n                    </button>\n                  </ng-template>\n                  <button\n                    *ngIf=\"!isReadonly && item?.status !== 'COMPLETED'\"\n                    [appearance]=\"'icon-with-bg'\"\n                    fswButton\n                    (click)=\"actionEvent.emit({ item: toShort(item), method: 're_trigger' })\"\n                  >\n                    <i fswIcon=\"status-ongoing\"></i>\n                  </button>\n                  <!-- <button\n                    *ngIf=\"!isReadonly\"\n                    fswButton\n                    (click)=\"actionEvent.emit({ item: toShort(item), method: 'delete' })\"\n                    [appearance]=\"'icon-with-bg'\"\n                    class=\"!text-red-500 !bg-red-100\"\n                  >\n                    <i fswIcon=\"common-delete\"></i>\n                  </button> -->\n                  <button\n                    *ngIf=\"item?.status === 'COMPLETED'\"\n                    fswButton\n                    (click)=\"actionEvent.emit({ item: toShort(item), method: 'detail' })\"\n                    [appearance]=\"'icon-with-bg'\"\n                  >\n                    <i fswIcon=\"common-external-link\"></i>\n                  </button>\n                </div>\n              </td>\n            </tr>\n          </ng-container>\n        </tbody>\n      </table>\n    </section>\n    <footer class=\"flex justify-end\" *ngIf=\"!snapshotId\">\n      <fsw-pagination\n        [total]=\"filteredSignal().length\"\n        [itemsPerPage]=\"itemsPerPageSignal() ?? filteredSignal().length\"\n        [currentPage]=\"indexSignal()\"\n        (currentPageChange)=\"indexSignal.set($event)\"\n        (itemsPerPageChange)=\"itemsPerPageSignal.set($event ?? filteredSignal().length)\"\n      ></fsw-pagination>\n    </footer>\n  </section>\n</ng-template>\n", styles: ["fsw-world-check-snapshot-table .fsw-panel>main:empty{display:none}\n"] }]
        }], propDecorators: { actionEvent: [{
                type: Output
            }], data: [{
                type: Input,
                args: [{ required: true }]
            }], isReadonly: [{
                type: Input
            }], snapshotId: [{
                type: Input
            }] } });

class FSWWorldCheckSourceTableComponent {
    constructor() {
        this.data = [];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckSourceTableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckSourceTableComponent, isStandalone: true, selector: "fsw-world-check-source-table", inputs: { data: "data" }, providers: [provideWorldCheckTranslation('world_check_source_table')], ngImport: i0, template: "<table class=\"fsw-table fsw-table--bordered w-full table-fixed\">\n  <thead>\n    <tr>\n      <th class=\"whitespace-normal align-middle break-words\">\n        {{ 'tables.source.date' | fswTranslate : { scope: 'world_check_source_table' } }}\n      </th>\n      <th class=\"whitespace-normal align-middle break-words\">\n        {{ 'tables.source.link' | fswTranslate : { scope: 'world_check_source_table' } }}\n      </th>\n    </tr>\n  </thead>\n  <tbody>\n    <ng-container *ngFor=\"let item of data\">\n      <tr>\n        <td class=\"whitespace-normal align-middle break-words\">\n          {{ item.date ? (item.date | date : 'dd/MM/yyyy HH:mm:ss') : '--' }}\n        </td>\n        <td class=\"whitespace-normal align-middle break-words\">\n          <ng-container *ngIf=\"item.link; else defaultTemplate\">\n            <a [href]=\"item.link\" target=\"_blank\">{{ item.link }}</a>\n          </ng-container>\n          <ng-template #defaultTemplate> -- </ng-template>\n        </td>\n      </tr>\n    </ng-container>\n  </tbody>\n</table>\n", dependencies: [{ kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "pipe", type: DatePipe, name: "date" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckSourceTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-source-table', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [provideWorldCheckTranslation('world_check_source_table')], imports: [FSWTranslateModule, NgForOf, DatePipe, NgIf], template: "<table class=\"fsw-table fsw-table--bordered w-full table-fixed\">\n  <thead>\n    <tr>\n      <th class=\"whitespace-normal align-middle break-words\">\n        {{ 'tables.source.date' | fswTranslate : { scope: 'world_check_source_table' } }}\n      </th>\n      <th class=\"whitespace-normal align-middle break-words\">\n        {{ 'tables.source.link' | fswTranslate : { scope: 'world_check_source_table' } }}\n      </th>\n    </tr>\n  </thead>\n  <tbody>\n    <ng-container *ngFor=\"let item of data\">\n      <tr>\n        <td class=\"whitespace-normal align-middle break-words\">\n          {{ item.date ? (item.date | date : 'dd/MM/yyyy HH:mm:ss') : '--' }}\n        </td>\n        <td class=\"whitespace-normal align-middle break-words\">\n          <ng-container *ngIf=\"item.link; else defaultTemplate\">\n            <a [href]=\"item.link\" target=\"_blank\">{{ item.link }}</a>\n          </ng-container>\n          <ng-template #defaultTemplate> -- </ng-template>\n        </td>\n      </tr>\n    </ng-container>\n  </tbody>\n</table>\n" }]
        }], propDecorators: { data: [{
                type: Input
            }] } });

class FSWWorldCheckUpdateTableComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckUpdateTableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckUpdateTableComponent, isStandalone: true, selector: "fsw-world-check-update-table", inputs: { data: "data" }, providers: [provideWorldCheckTranslation('world_check_update_table')], ngImport: i0, template: "<table class=\"fsw-table fsw-table--bordered fsw-table--cover-content w-full table-fixed\">\n  <tbody>\n    <tr>\n      <td>\n        {{ 'tables.update.categorization' | fswTranslate : { scope: 'world_check_update_table' } }}\n      </td>\n      <td>{{ data.category ?? '--' }}</td>\n    </tr>\n    <tr>\n      <td>\n        {{ 'tables.update.entered_date' | fswTranslate : { scope: 'world_check_update_table' } }}\n      </td>\n      <td>{{ data.enterDate ? (data.enterDate | date : 'dd/MM/yyyy') : '--' }}</td>\n    </tr>\n    <tr>\n      <td>\n        {{ 'tables.update.updated_date' | fswTranslate : { scope: 'world_check_update_table' } }}\n      </td>\n      <td>{{ data.updateDate ? (data.updateDate | date : 'dd/MM/yyyy') : '--' }}</td>\n    </tr>\n  </tbody>\n</table>\n", dependencies: [{ kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: DatePipe, name: "date" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckUpdateTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-update-table', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [provideWorldCheckTranslation('world_check_update_table')], imports: [FSWTranslateModule, NgForOf, DatePipe], template: "<table class=\"fsw-table fsw-table--bordered fsw-table--cover-content w-full table-fixed\">\n  <tbody>\n    <tr>\n      <td>\n        {{ 'tables.update.categorization' | fswTranslate : { scope: 'world_check_update_table' } }}\n      </td>\n      <td>{{ data.category ?? '--' }}</td>\n    </tr>\n    <tr>\n      <td>\n        {{ 'tables.update.entered_date' | fswTranslate : { scope: 'world_check_update_table' } }}\n      </td>\n      <td>{{ data.enterDate ? (data.enterDate | date : 'dd/MM/yyyy') : '--' }}</td>\n    </tr>\n    <tr>\n      <td>\n        {{ 'tables.update.updated_date' | fswTranslate : { scope: 'world_check_update_table' } }}\n      </td>\n      <td>{{ data.updateDate ? (data.updateDate | date : 'dd/MM/yyyy') : '--' }}</td>\n    </tr>\n  </tbody>\n</table>\n" }]
        }], propDecorators: { data: [{
                type: Input,
                args: [{ required: true }]
            }] } });

class FSWWorldCheckKeyDataContainerComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckKeyDataContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckKeyDataContainerComponent, isStandalone: true, selector: "fsw-world-check-key-data-container", inputs: { data: "data" }, providers: [provideWorldCheckTranslation('world_check_key_data_container')], ngImport: i0, template: "<table class=\"fsw-table fsw-table--bordered w-full table-fixed\">\n  <tbody>\n    <tr>\n      <td class=\"whitespace-normal align-middle break-words !w-[200px]\">\n        {{\n          'containers.key_data.fields.name'\n            | fswTranslate : { scope: 'world_check_key_data_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">{{ data.name }}</td>\n    </tr>\n    <tr>\n      <td class=\"whitespace-normal align-middle break-words !w-[200px]\">\n        {{\n          'containers.key_data.fields.update'\n            | fswTranslate : { scope: 'world_check_key_data_container' }\n        }}\n      </td>\n      <td>\n        <fsw-world-check-update-table [data]=\"data.update\"></fsw-world-check-update-table>\n      </td>\n    </tr>\n    <tr>\n      <td class=\"whitespace-normal align-middle break-words !w-[200px]\">\n        {{\n          'containers.key_data.fields.category'\n            | fswTranslate : { scope: 'world_check_key_data_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">{{ data.category }}</td>\n    </tr>\n    <tr>\n      <td class=\"whitespace-normal align-middle break-words !w-[200px]\">\n        {{\n          'containers.key_data.fields.special_interest_categories'\n            | fswTranslate : { scope: 'world_check_key_data_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">\n        {{ data.specialInterestCategories?.join(', ') }}\n      </td>\n    </tr>\n    <tr>\n      <td class=\"whitespace-normal align-middle break-words !w-[200px]\">\n        {{\n          'containers.key_data.fields.gender'\n            | fswTranslate : { scope: 'world_check_key_data_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">{{ data.gender }}</td>\n    </tr>\n    <tr>\n      <td class=\"whitespace-normal align-middle break-words !w-[200px]\">\n        {{\n          'containers.key_data.fields.date_of_birth'\n            | fswTranslate : { scope: 'world_check_key_data_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">{{ data.dateOfBirth | date : 'dd/MM/yyyy' }}</td>\n    </tr>\n    <tr>\n      <td class=\"whitespace-normal align-middle break-words !w-[200px]\">\n        {{\n          'containers.key_data.fields.citizenship'\n            | fswTranslate : { scope: 'world_check_key_data_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">{{ data.registeredCountry }}</td>\n    </tr>\n    <tr>\n      <td class=\"whitespace-normal align-middle break-words !w-[200px]\">\n        {{\n          'containers.key_data.fields.location_details'\n            | fswTranslate : { scope: 'world_check_key_data_container' }\n        }}\n      </td>\n      <td>\n        <fsw-world-check-location-table [data]=\"data.locations\"></fsw-world-check-location-table>\n      </td>\n    </tr>\n    <tr>\n      <td class=\"whitespace-normal align-middle break-words !w-[200px]\">\n        {{\n          'containers.key_data.fields.age'\n            | fswTranslate : { scope: 'world_check_key_data_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">{{ data.age }}</td>\n    </tr>\n  </tbody>\n</table>\n", dependencies: [{ kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: DatePipe, name: "date" }, { kind: "component", type: FSWWorldCheckLocationTableComponent, selector: "fsw-world-check-location-table", inputs: ["data"] }, { kind: "component", type: FSWWorldCheckUpdateTableComponent, selector: "fsw-world-check-update-table", inputs: ["data"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckKeyDataContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-key-data-container', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [provideWorldCheckTranslation('world_check_key_data_container')], imports: [
                        FSWTranslateModule,
                        DatePipe,
                        NgForOf,
                        FSWWorldCheckLocationTableComponent,
                        FSWWorldCheckUpdateTableComponent,
                    ], template: "<table class=\"fsw-table fsw-table--bordered w-full table-fixed\">\n  <tbody>\n    <tr>\n      <td class=\"whitespace-normal align-middle break-words !w-[200px]\">\n        {{\n          'containers.key_data.fields.name'\n            | fswTranslate : { scope: 'world_check_key_data_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">{{ data.name }}</td>\n    </tr>\n    <tr>\n      <td class=\"whitespace-normal align-middle break-words !w-[200px]\">\n        {{\n          'containers.key_data.fields.update'\n            | fswTranslate : { scope: 'world_check_key_data_container' }\n        }}\n      </td>\n      <td>\n        <fsw-world-check-update-table [data]=\"data.update\"></fsw-world-check-update-table>\n      </td>\n    </tr>\n    <tr>\n      <td class=\"whitespace-normal align-middle break-words !w-[200px]\">\n        {{\n          'containers.key_data.fields.category'\n            | fswTranslate : { scope: 'world_check_key_data_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">{{ data.category }}</td>\n    </tr>\n    <tr>\n      <td class=\"whitespace-normal align-middle break-words !w-[200px]\">\n        {{\n          'containers.key_data.fields.special_interest_categories'\n            | fswTranslate : { scope: 'world_check_key_data_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">\n        {{ data.specialInterestCategories?.join(', ') }}\n      </td>\n    </tr>\n    <tr>\n      <td class=\"whitespace-normal align-middle break-words !w-[200px]\">\n        {{\n          'containers.key_data.fields.gender'\n            | fswTranslate : { scope: 'world_check_key_data_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">{{ data.gender }}</td>\n    </tr>\n    <tr>\n      <td class=\"whitespace-normal align-middle break-words !w-[200px]\">\n        {{\n          'containers.key_data.fields.date_of_birth'\n            | fswTranslate : { scope: 'world_check_key_data_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">{{ data.dateOfBirth | date : 'dd/MM/yyyy' }}</td>\n    </tr>\n    <tr>\n      <td class=\"whitespace-normal align-middle break-words !w-[200px]\">\n        {{\n          'containers.key_data.fields.citizenship'\n            | fswTranslate : { scope: 'world_check_key_data_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">{{ data.registeredCountry }}</td>\n    </tr>\n    <tr>\n      <td class=\"whitespace-normal align-middle break-words !w-[200px]\">\n        {{\n          'containers.key_data.fields.location_details'\n            | fswTranslate : { scope: 'world_check_key_data_container' }\n        }}\n      </td>\n      <td>\n        <fsw-world-check-location-table [data]=\"data.locations\"></fsw-world-check-location-table>\n      </td>\n    </tr>\n    <tr>\n      <td class=\"whitespace-normal align-middle break-words !w-[200px]\">\n        {{\n          'containers.key_data.fields.age'\n            | fswTranslate : { scope: 'world_check_key_data_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">{{ data.age }}</td>\n    </tr>\n  </tbody>\n</table>\n" }]
        }], propDecorators: { data: [{
                type: Input,
                args: [{ required: true }]
            }] } });

class FSWWorldCheckSummaryContainerComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckSummaryContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckSummaryContainerComponent, isStandalone: true, selector: "fsw-world-check-summary-container", inputs: { data: "data" }, providers: [provideWorldCheckTranslation('world_check_summary_container')], ngImport: i0, template: "<table class=\"fsw-table fsw-table--bordered w-full table-fixed\">\n  <tbody>\n    <tr>\n      <td>\n        {{\n          'containers.summary.fields.match_strength'\n            | fswTranslate : { scope: 'world_check_summary_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">{{ data.matchStrength }}</td>\n    </tr>\n    <tr>\n      <td>\n        {{\n          'containers.summary.fields.match_name_type'\n            | fswTranslate : { scope: 'world_check_summary_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">{{ data.matchNameType }}</td>\n    </tr>\n    <tr>\n      <td>\n        {{\n          'containers.summary.fields.match_score'\n            | fswTranslate : { scope: 'world_check_summary_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">{{ data.matchScore }}</td>\n    </tr>\n    <tr>\n      <td>\n        {{\n          'containers.summary.fields.resolution'\n            | fswTranslate : { scope: 'world_check_summary_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">{{ data.resolution }}</td>\n    </tr>\n    <tr>\n      <td>\n        {{\n          'containers.summary.fields.remark'\n            | fswTranslate : { scope: 'world_check_summary_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">{{ data.resolutionRemark }}</td>\n    </tr>\n    <tr>\n      <td>\n        {{\n          'containers.summary.fields.review_remark'\n            | fswTranslate : { scope: 'world_check_summary_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">{{ data.reviewRemark }}</td>\n    </tr>\n  </tbody>\n</table>\n", dependencies: [{ kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckSummaryContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-summary-container', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [provideWorldCheckTranslation('world_check_summary_container')], imports: [FSWTranslateModule, DatePipe], template: "<table class=\"fsw-table fsw-table--bordered w-full table-fixed\">\n  <tbody>\n    <tr>\n      <td>\n        {{\n          'containers.summary.fields.match_strength'\n            | fswTranslate : { scope: 'world_check_summary_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">{{ data.matchStrength }}</td>\n    </tr>\n    <tr>\n      <td>\n        {{\n          'containers.summary.fields.match_name_type'\n            | fswTranslate : { scope: 'world_check_summary_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">{{ data.matchNameType }}</td>\n    </tr>\n    <tr>\n      <td>\n        {{\n          'containers.summary.fields.match_score'\n            | fswTranslate : { scope: 'world_check_summary_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">{{ data.matchScore }}</td>\n    </tr>\n    <tr>\n      <td>\n        {{\n          'containers.summary.fields.resolution'\n            | fswTranslate : { scope: 'world_check_summary_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">{{ data.resolution }}</td>\n    </tr>\n    <tr>\n      <td>\n        {{\n          'containers.summary.fields.remark'\n            | fswTranslate : { scope: 'world_check_summary_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">{{ data.resolutionRemark }}</td>\n    </tr>\n    <tr>\n      <td>\n        {{\n          'containers.summary.fields.review_remark'\n            | fswTranslate : { scope: 'world_check_summary_container' }\n        }}\n      </td>\n      <td class=\"!text-gray-700 !font-semibold\">{{ data.reviewRemark }}</td>\n    </tr>\n  </tbody>\n</table>\n" }]
        }], propDecorators: { data: [{
                type: Input,
                args: [{ required: true }]
            }] } });

class FSWWorldCheckContainerComponent extends FSWDynamicBuilderContainerComponent {
    get title() {
        return this.element?.customProps?.title ?? '';
    }
    get showConditional$() {
        return this.element?.customProps?.showConditional$ ?? of(true);
    }
    get customClasses() {
        return this.element?.customProps?.customClasses ?? '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckContainerComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckContainerComponent, isStandalone: true, selector: "fsw-world-check-container", host: { properties: { "class": "this.customClasses" } }, usesInheritance: true, ngImport: i0, template: "<fsw-panel [title]=\"title\" *ngIf=\"showConditional$ | async\">\n  <fsw-dynamic-builder-container\n    [element]=\"element\"\n    [dictionaries]=\"dictionaries\"\n    [config]=\"config\"\n    [index]=\"index\"\n  ></fsw-dynamic-builder-container>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWDynamicBuilderModule }, { kind: "component", type: i1$4.FSWDynamicBuilderContainerComponent, selector: "fsw-dynamic-builder-container" }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-container', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [FSWDynamicBuilderModule, FSWPanelModule, NgIf, AsyncPipe], template: "<fsw-panel [title]=\"title\" *ngIf=\"showConditional$ | async\">\n  <fsw-dynamic-builder-container\n    [element]=\"element\"\n    [dictionaries]=\"dictionaries\"\n    [config]=\"config\"\n    [index]=\"index\"\n  ></fsw-dynamic-builder-container>\n</fsw-panel>\n" }]
        }], propDecorators: { customClasses: [{
                type: HostBinding,
                args: ['class']
            }] } });

let FSWWorldCheckCaseFormComponent = class FSWWorldCheckCaseFormComponent {
    constructor() {
        this.saveEvent = new EventEmitter();
        this.isReadonly = false;
        this.snapshotId = null;
        this.linkId = null;
        this.disableAutoFillFields = false;
        this.automaticFilledCaseFunction = (cb) => {
            cb({});
        };
        this.translations = injectWorldCheckTranslationByCountryCode();
        this.adapterCaseService = injectFSWWorldCheckAdapterCaseService();
        this.alertService = inject(FSW_ALERT_SERVICE_TOKEN);
        this.selectedIDCountryCode$ = new BehaviorSubject(null);
        this.selectedEntityType$ = new BehaviorSubject(null);
        this.selectedProviderTypes$ = new BehaviorSubject([]);
        this.form = new UntypedFormGroup({});
        this.formChangeSubject = new Subject();
        this.dictionaries = [
            {
                name: 'world-check-container',
                component: FSWWorldCheckContainerComponent,
                dictionaryType: FSWDynamicBuilderFormTypes.CONTAINER,
            },
        ];
        this.builderSignal = signal(this.buildBuilder());
        this.hiddenViewSignal = signal(false);
        this.icAvailableSignal = signal(false);
        this.countryMapping = {
            [CountryCode.ID]: 'IDN',
            [CountryCode.SG]: 'SGP',
            [CountryCode.TH]: 'THA',
            [CountryCode.VU]: 'VNM',
            [CountryCode.VN]: 'VNM',
            [CountryCode.MY]: 'MYS',
            [CountryCode.ZI]: 'IDN',
            [CountryCode.ZU]: 'IDN',
            [CountryCode.ZV]: 'VNM',
        };
    }
    ngOnInit() {
        this.updateBuilder();
    }
    ngOnChanges() {
        this.updateBuilder();
    }
    updateBuilder() {
        this.builderSignal.set(this.buildBuilder());
        this.formChangeSubject.next(new Date());
        this.icAvailableSignal.set(false);
        if (!this.isReadonly) {
            this.listenToICNumberChange();
        }
        this.builderSignal().groupConfig.form.patchValue({
            ...this.data,
        });
    }
    buildBuilder() {
        return new FSWDynamicBuilder({
            form: this.form,
            formType: FSWDynamicBuilderFormTypes.GROUP,
            customClasses: 'w-full flex flex-col gap-[16px]',
            renderBy: 'container',
            readonlyWhen$: of(this.isReadonly),
            containers: this.resources
                ? [
                    ...(this.data
                        ? [
                            {
                                name: 'world-check-container',
                                customClasses: 'w-full flex flex-wrap gap-[16px]',
                                fields: [
                                    {
                                        key: 'caseId',
                                        customClasses: 'w-[calc(50%-8px)]',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            label: this.translations.forms.case.fields.case_id,
                                            fullWidth: true,
                                            isDisabled: true,
                                        },
                                    },
                                    {
                                        key: 'caseSystemId',
                                        customClasses: 'w-[calc(50%-8px)]',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            label: this.translations.forms.case.fields.case_system_id,
                                            fullWidth: true,
                                            isDisabled: true,
                                        },
                                    },
                                    {
                                        key: 'groupId',
                                        customClasses: 'w-[calc(50%-8px)]',
                                        type: FSWDynamicBuilderControlTypes.SELECT,
                                        context: {
                                            items: this.resources.groups.map((group) => ({
                                                value: group.id,
                                                text: group.name,
                                            })),
                                            maxHeight: '300px',
                                            label: this.translations.forms.case.fields.group_id,
                                            fullWidth: true,
                                            isRequired: true,
                                            isDisabled: true,
                                        },
                                        validations: [Validators.required],
                                    },
                                    {
                                        key: 'entityType',
                                        customClasses: 'w-[calc(50%-8px)]',
                                        type: FSWDynamicBuilderControlTypes.SELECT,
                                        context: {
                                            items: this.resources?.enums?.entity_types?.map((value) => ({
                                                value,
                                                text: value,
                                            })) ?? fswWorldCheckEntityTypes,
                                            maxHeight: '300px',
                                            label: this.translations.forms.case.fields.entity_type,
                                            fullWidth: true,
                                            isRequired: true,
                                            afterCreated: (control) => {
                                                this.selectedEntityType$.next(control.value);
                                                this.autoFillBaseOnEntityType(control.value);
                                                control.valueChanges
                                                    .pipe(followDestroy(this), tap((type) => {
                                                    this.selectedEntityType$.next(type);
                                                    this.autoFillBaseOnEntityType(type);
                                                }))
                                                    .subscribe();
                                            },
                                            isDisabled: true,
                                        },
                                        validations: [Validators.required],
                                    },
                                    {
                                        key: 'providerTypes',
                                        customClasses: 'w-[calc(50%-8px)]',
                                        type: FSWDynamicBuilderControlTypes.SELECT,
                                        context: {
                                            defaultValue: [FSWWorldCheckProviderTypes.WATCHLIST],
                                            isMultiple: true,
                                            items: this.resources?.enums?.providers?.map((value) => ({
                                                value,
                                                text: value,
                                            })) ?? fswWorldCheckProviderTypes,
                                            maxHeight: '300px',
                                            label: this.translations.forms.case.fields.provider_type,
                                            fullWidth: true,
                                            isRequired: true,
                                            afterCreated: (control) => {
                                                this.selectedProviderTypes$.next(control.value);
                                                control.valueChanges
                                                    .pipe(followDestroy(this), tap((value) => this.selectedProviderTypes$.next(value ?? [])))
                                                    .subscribe();
                                            },
                                            isDisabled: true,
                                        },
                                        validations: [Validators.required],
                                    },
                                    {
                                        key: 'state',
                                        customClasses: 'w-[calc(50%-8px)]',
                                        type: FSWDynamicBuilderControlTypes.SELECT,
                                        context: {
                                            items: fswWorldCheckLifecycleStates,
                                            maxHeight: '300px',
                                            label: this.translations.forms.case.fields.state,
                                            fullWidth: true,
                                            isRequired: true,
                                            isDisabled: true,
                                        },
                                        validations: [Validators.required],
                                    },
                                ],
                            },
                        ]
                        : []),
                    {
                        name: 'world-check-container',
                        customClasses: 'w-full flex flex-wrap gap-[16px]',
                        fields: [
                            ...(!this.data
                                ? [
                                    {
                                        key: 'groupId',
                                        customClasses: 'w-[calc(50%-8px)]',
                                        type: FSWDynamicBuilderControlTypes.SELECT,
                                        context: {
                                            items: this.resources.groups.map((group) => ({
                                                value: group.id,
                                                text: group.name,
                                            })),
                                            maxHeight: '300px',
                                            label: this.translations.forms.case.fields.group_id,
                                            fullWidth: true,
                                            isRequired: true,
                                            defaultValue: this.resources.defaultGroup?.id,
                                            isDisabled: !!this.data || !!this.snapshotId || !!this.resources.defaultGroup?.id,
                                        },
                                        validations: [Validators.required],
                                    },
                                    {
                                        key: 'entityType',
                                        customClasses: 'w-[calc(50%-8px)]',
                                        type: FSWDynamicBuilderControlTypes.SELECT,
                                        context: {
                                            items: this.resources?.enums?.entity_types?.map((value) => ({
                                                value,
                                                text: value,
                                            })) ?? fswWorldCheckEntityTypes,
                                            maxHeight: '300px',
                                            label: this.translations.forms.case.fields.entity_type,
                                            fullWidth: true,
                                            isRequired: true,
                                            afterCreated: (control) => {
                                                this.selectedEntityType$.next(control.value);
                                                this.autoFillBaseOnEntityType(control.value);
                                                control.valueChanges
                                                    .pipe(followDestroy(this), tap((type) => {
                                                    this.selectedEntityType$.next(type);
                                                    this.autoFillBaseOnEntityType(type);
                                                }))
                                                    .subscribe();
                                            },
                                            isDisabled: !!this.data || !!this.snapshotId,
                                        },
                                        validations: [Validators.required],
                                    },
                                    {
                                        key: 'providerTypes',
                                        customClasses: 'w-[calc(50%-8px)]',
                                        type: FSWDynamicBuilderControlTypes.SELECT,
                                        context: {
                                            defaultValue: [FSWWorldCheckProviderTypes.WATCHLIST],
                                            isMultiple: true,
                                            items: this.resources?.enums?.providers?.map((value) => ({
                                                value,
                                                text: value,
                                            })) ?? fswWorldCheckProviderTypes,
                                            maxHeight: '300px',
                                            label: this.translations.forms.case.fields.provider_type,
                                            fullWidth: true,
                                            isRequired: true,
                                            afterCreated: (control) => {
                                                this.selectedProviderTypes$.next(control.value);
                                                control.valueChanges
                                                    .pipe(followDestroy(this), tap((value) => this.selectedProviderTypes$.next(value ?? [])))
                                                    .subscribe();
                                            },
                                        },
                                        validations: [Validators.required],
                                    },
                                ]
                                : []),
                            {
                                key: 'name',
                                customClasses: 'w-[calc(50%-8px)]',
                                type: FSWDynamicBuilderControlTypes.INPUT,
                                context: {
                                    label: this.translations.forms.case.fields.name,
                                    fullWidth: true,
                                    isRequired: true,
                                    isDisabled: !!this.snapshotId || this.disableAutoFillFields,
                                },
                                validations: [Validators.required],
                            },
                            {
                                key: 'country_case',
                                customClasses: 'w-[calc(50%-8px)]',
                                type: FSWDynamicBuilderControlTypes.SELECT,
                                context: {
                                    defaultValue: this.countryMapping[getCountryCodeFromStorage()],
                                    items: Object.keys(this.resources.countries).map((countryCode) => ({
                                        value: countryCode,
                                        text: this.resources.countries[countryCode],
                                    })),
                                    searchPlaceHolder: this.translations.forms.case.fields.country,
                                    maxHeight: '300px',
                                    label: this.translations.forms.case.fields.country,
                                    fullWidth: true,
                                    isRequired: true,
                                    isDisabled: !!this.snapshotId,
                                },
                                validations: [Validators.required],
                            },
                            {
                                key: 'nameTransposition',
                                customClasses: 'w-full',
                                type: FSWDynamicBuilderControlTypes.SWITCH,
                                context: {
                                    label: this.translations.forms.case.fields.name_transposition,
                                    fullWidth: true,
                                    isDisabled: !!this.snapshotId,
                                },
                            },
                            {
                                key: 'department',
                                customClasses: 'w-[calc(50%-8px)]',
                                type: FSWDynamicBuilderControlTypes.INPUT,
                                context: {
                                    label: this.translations.forms.case.fields.department,
                                    fullWidth: true,
                                    isRequired: true,
                                    isDisabled: !!this.snapshotId || this.disableAutoFillFields,
                                },
                                validations: [Validators.required],
                            },
                            {
                                key: 'reference',
                                customClasses: 'w-[calc(50%-8px)]',
                                type: FSWDynamicBuilderControlTypes.INPUT,
                                context: {
                                    defaultValue: this.snapshotId ? 'review' : 'onboarding',
                                    label: this.translations.forms.case.fields.reference,
                                    fullWidth: true,
                                    isRequired: true,
                                    isDisabled: !!this.snapshotId,
                                },
                                validations: [Validators.required],
                            },
                            {
                                key: 'dateOfBirth',
                                customClasses: 'w-[calc(50%-8px)]',
                                type: FSWDynamicBuilderControlTypes.INPUT,
                                context: {
                                    inputType: 'date',
                                    label: this.translations.forms.case.fields.date_of_birth,
                                    fullWidth: true,
                                    isDisabled: !!this.snapshotId || this.disableAutoFillFields,
                                    customRender: [
                                        {
                                            fields: [
                                                {
                                                    key: 'entityType',
                                                    correctWhenValueIs: (value) => value === FSWWorldCheckEntityTypes.INDIVIDUAL,
                                                },
                                            ],
                                            checkingConditionCallback: (params, condition) => {
                                                if (condition) {
                                                    params.renderView();
                                                }
                                                else {
                                                    params.clearView();
                                                }
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                key: 'placeOfBirth',
                                customClasses: 'w-[calc(50%-8px)]',
                                type: FSWDynamicBuilderControlTypes.SELECT,
                                context: {
                                    defaultValue: this.countryMapping[getCountryCodeFromStorage()],
                                    items: Object.keys(this.resources.countries).map((countryCode) => ({
                                        value: countryCode,
                                        text: this.resources.countries[countryCode],
                                    })),
                                    maxHeight: '300px',
                                    label: this.translations.forms.case.fields.place_of_birth,
                                    searchPlaceHolder: this.translations.forms.case.fields.place_of_birth,
                                    fullWidth: true,
                                    isDisabled: !!this.snapshotId,
                                    customRender: [
                                        {
                                            fields: [
                                                {
                                                    key: 'entityType',
                                                    correctWhenValueIs: (value) => value === FSWWorldCheckEntityTypes.INDIVIDUAL,
                                                },
                                            ],
                                            checkingConditionCallback: (params, condition) => {
                                                if (condition) {
                                                    params.renderView();
                                                }
                                                else {
                                                    params.clearView();
                                                }
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                key: 'gender',
                                customClasses: 'w-[calc(50%-8px)]',
                                type: FSWDynamicBuilderControlTypes.SELECT,
                                context: {
                                    items: this.resources?.enums?.genders?.map((value) => ({ value, text: value })) ??
                                        fswWorldCheckGenders,
                                    label: this.translations.forms.case.fields.gender,
                                    fullWidth: true,
                                    maxHeight: '300px',
                                    isDisabled: !!this.snapshotId || this.disableAutoFillFields,
                                    customRender: [
                                        {
                                            fields: [
                                                {
                                                    key: 'entityType',
                                                    correctWhenValueIs: (value) => value === FSWWorldCheckEntityTypes.INDIVIDUAL,
                                                },
                                            ],
                                            checkingConditionCallback: (params, condition) => {
                                                if (condition) {
                                                    params.renderView();
                                                }
                                                else {
                                                    params.clearView();
                                                }
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                key: 'citizenship',
                                customClasses: 'w-[calc(50%-8px)]',
                                type: FSWDynamicBuilderControlTypes.SELECT,
                                context: {
                                    defaultValue: this.countryMapping[getCountryCodeFromStorage()],
                                    items: Object.keys(this.resources.countries).map((countryCode) => ({
                                        value: countryCode,
                                        text: this.resources.countries[countryCode],
                                    })),
                                    maxHeight: '300px',
                                    searchPlaceHolder: this.translations.forms.case.fields.citizenship,
                                    label: this.translations.forms.case.fields.citizenship,
                                    fullWidth: true,
                                    isDisabled: !!this.snapshotId || this.disableAutoFillFields,
                                    customRender: [
                                        {
                                            fields: [
                                                {
                                                    key: 'entityType',
                                                    correctWhenValueIs: (value) => value === FSWWorldCheckEntityTypes.INDIVIDUAL,
                                                },
                                            ],
                                            checkingConditionCallback: (params, condition) => {
                                                if (condition) {
                                                    params.renderView();
                                                }
                                                else {
                                                    params.clearView();
                                                }
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                    },
                    {
                        name: 'world-check-container',
                        customProps: {
                            title: 'Identification Number',
                        },
                        customClasses: 'w-full flex flex-wrap gap-[16px]',
                        fields: [
                            {
                                key: 'identificationCountry',
                                customClasses: 'w-full',
                                type: FSWDynamicBuilderControlTypes.SELECT,
                                context: {
                                    defaultValue: this.countryMapping[getCountryCodeFromStorage()],
                                    items: Object.keys(this.resources.countries).map((countryCode) => ({
                                        value: countryCode,
                                        text: this.resources.countries[countryCode],
                                    })),
                                    maxHeight: '300px',
                                    searchPlaceHolder: this.translations.forms.case.fields.country,
                                    label: this.translations.forms.case.fields.country,
                                    fullWidth: true,
                                    isDisabled: !!this.snapshotId || this.disableAutoFillFields,
                                    afterCreated: (control) => {
                                        this.selectedIDCountryCode$.next(control.value);
                                        control.valueChanges
                                            .pipe(followDestroy(this), tap((countryCode) => this.selectedIDCountryCode$.next(countryCode)))
                                            .subscribe();
                                    },
                                },
                            },
                            {
                                key: 'identificationType',
                                customClasses: 'w-[calc(50%-8px)]',
                                type: FSWDynamicBuilderControlTypes.SELECT,
                                context: {
                                    loadItemsAsync: () => combineLatest([this.selectedIDCountryCode$, this.selectedEntityType$]).pipe(map(([countryCode, entityType]) => {
                                        if (!countryCode)
                                            return [];
                                        return this.resources.identityDocumentLocationTypes
                                            .filter((idType) => idType.country.code === countryCode &&
                                            idType.entityTypes.includes(entityType))
                                            .map((idType) => ({ value: idType.type, text: idType.name }));
                                    })),
                                    maxHeight: '300px',
                                    label: this.translations.forms.case.fields.identification_type,
                                    fullWidth: true,
                                    isDisabled: !!this.snapshotId || this.disableAutoFillFields,
                                },
                            },
                        ],
                        containers: [
                            {
                                customClasses: 'w-[calc(50%-8px)] flex gap-[12px]',
                                fields: [
                                    {
                                        key: 'identificationNumber',
                                        customClasses: 'flex-1',
                                        type: FSWDynamicBuilderControlTypes.INPUT,
                                        context: {
                                            label: this.translations.forms.case.fields.identification_number,
                                            fullWidth: true,
                                            isDisabled: !!this.snapshotId || this.disableAutoFillFields,
                                        },
                                    },
                                    {
                                        key: 'duplicateCheck',
                                        type: FSWDynamicBuilderControlTypes.CHECKBOX,
                                        context: {
                                            flexWidth: true,
                                            defaultValue: false,
                                            label: this.translations.forms.case.fields.duplicate_check,
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    // {
                    //   name: 'world-check-container',
                    //   customProps: {
                    //     title: 'Passport Check',
                    //     showConditional$:
                    //       // combineLatest([
                    //       //   this.selectedProviderTypes$,
                    //       //   this.selectedEntityType$,
                    //       // ])
                    //       of(false).pipe(
                    //         // map(
                    //         //   ([providerTypes, entityType]) =>
                    //         //     providerTypes?.includes(FSWWorldCheckProviderTypes.PASSPORT_CHECK) &&
                    //         //     entityType === FSWWorldCheckEntityTypes.INDIVIDUAL
                    //         // ),
                    //         tap((condition) => {
                    //           const fields = [
                    //             'passportGivenName',
                    //             'passportLastName',
                    //             'passportIssuingState',
                    //             'passportNationality',
                    //             'passportDocumentType',
                    //             'passportIdNumber',
                    //             'passportDateOfExpiry',
                    //             'passportDateOfBirth',
                    //             'passportGender',
                    //           ];
                    //
                    //           fields.forEach((field) => {
                    //             if (condition) {
                    //               this.form.get(field)?.addValidators([Validators.required]);
                    //             } else {
                    //               this.form.get(field)?.removeValidators([Validators.required]);
                    //             }
                    //           });
                    //         })
                    //       ),
                    //   },
                    //   customClasses: 'w-full flex flex-wrap gap-[16px]',
                    //   fields: [
                    //     {
                    //       key: 'passportGivenName',
                    //       customClasses: 'w-[calc(50%-8px)]',
                    //       type: FSWDynamicBuilderControlTypes.INPUT,
                    //       context: {
                    //         label: this.translations.forms.case.fields.passport_given_name,
                    //         fullWidth: true,
                    //         isRequired: true,
                    //       },
                    //     },
                    //     {
                    //       key: 'passportLastName',
                    //       customClasses: 'w-[calc(50%-8px)]',
                    //       type: FSWDynamicBuilderControlTypes.INPUT,
                    //       context: {
                    //         label: this.translations.forms.case.fields.passport_last_name,
                    //         fullWidth: true,
                    //         isRequired: true,
                    //       },
                    //     },
                    //     {
                    //       key: 'passportIssuingState',
                    //       customClasses: 'w-[calc(50%-8px)]',
                    //       type: FSWDynamicBuilderControlTypes.SELECT,
                    //       context: {
                    //         defaultValue: this.countryMapping[getCountryCodeFromStorage()],
                    //         items: Object.keys(this.resources.countries).map((countryCode) => ({
                    //           value: countryCode,
                    //           text: this.resources.countries[countryCode],
                    //         })),
                    //         maxHeight: '300px',
                    //         fullWidth: true,
                    //         searchPlaceHolder: this.translations.forms.case.fields.passport_issuing_state,
                    //         label: this.translations.forms.case.fields.passport_issuing_state,
                    //         isRequired: true,
                    //       },
                    //     },
                    //     {
                    //       key: 'passportNationality',
                    //       customClasses: 'w-[calc(50%-8px)]',
                    //       type: FSWDynamicBuilderControlTypes.SELECT,
                    //       context: {
                    //         defaultValue: this.countryMapping[getCountryCodeFromStorage()],
                    //         items: Object.keys(this.resources.nationalities).map((countryCode) => ({
                    //           value: countryCode,
                    //           text: this.resources.nationalities[countryCode],
                    //         })),
                    //         maxHeight: '300px',
                    //         searchPlaceHolder: this.translations.forms.case.fields.passport_nationality,
                    //         label: this.translations.forms.case.fields.passport_nationality,
                    //         fullWidth: true,
                    //         isRequired: true,
                    //         afterCreated: (control) => {
                    //           this.selectedPPCountryCode$.next(control.value);
                    //           control.valueChanges
                    //             .pipe(
                    //               followDestroy(this),
                    //               tap((countryCode) => this.selectedPPCountryCode$.next(countryCode))
                    //             )
                    //             .subscribe();
                    //         },
                    //       },
                    //     },
                    //     {
                    //       key: 'passportDocumentType',
                    //       customClasses: 'w-[calc(50%-8px)]',
                    //       type: FSWDynamicBuilderControlTypes.SELECT,
                    //       context: {
                    //         items: fswWorldCheckPassportDocumentType,
                    //         maxHeight: '300px',
                    //         label: this.translations.forms.case.fields.passport_document_type,
                    //         fullWidth: true,
                    //       },
                    //     },
                    //     {
                    //       key: 'passportIdNumber',
                    //       customClasses: 'w-[calc(50%-8px)]',
                    //       type: FSWDynamicBuilderControlTypes.INPUT,
                    //       context: {
                    //         label: this.translations.forms.case.fields.passport_id_number,
                    //         fullWidth: true,
                    //         isRequired: true,
                    //       },
                    //     },
                    //     {
                    //       key: 'passportDateOfExpiry',
                    //       customClasses: 'w-[calc(50%-8px)]',
                    //       type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                    //       context: {
                    //         label: this.translations.forms.case.fields.passport_date_of_expiry,
                    //         fullWidth: true,
                    //         isRequired: true,
                    //         closeOnSelected: true,
                    //       },
                    //     },
                    //     {
                    //       key: 'passportDateOfBirth',
                    //       customClasses: 'w-[calc(50%-8px)]',
                    //       type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
                    //       context: {
                    //         label: this.translations.forms.case.fields.date_of_birth,
                    //         fullWidth: true,
                    //         closeOnSelected: true,
                    //         isRequired: true,
                    //       },
                    //     },
                    //     {
                    //       key: 'passportGender',
                    //       customClasses: 'w-[calc(50%-8px)]',
                    //       type: FSWDynamicBuilderControlTypes.SELECT,
                    //       context: {
                    //         items:
                    //           this.resources?.enums?.genders?.map((value) => ({ value, text: value })) ??
                    //           fswWorldCheckGenders,
                    //         label: this.translations.forms.case.fields.gender,
                    //         fullWidth: true,
                    //         maxHeight: '300px',
                    //         isRequired: true,
                    //       },
                    //     },
                    //   ],
                    // },
                ]
                : [],
        });
    }
    save() {
        if (this.form.invalid) {
            this.alertService.warning('Invalid Information', 'Please fill in all mandatory fields.', {
                duration: 3000,
            });
            return;
        }
        const rawValue = this.form.getRawValue();
        rawValue.dateOfBirth = this.toPlainDate(rawValue.dateOfBirth);
        rawValue.passportDateOfBirth = this.toPlainDate(rawValue.passportDateOfBirth);
        rawValue.passportDateOfExpiry = this.toPlainDate(rawValue.passportDateOfExpiry);
        if (!this.data) {
            this.adapterCaseService
                .createAsync({
                ...rawValue,
                links: [
                    {
                        entity: this.entity,
                        key: this.key,
                    },
                ],
            })
                .pipe(tapResponse(() => {
                this.saveEvent.emit();
                this.alertService.success('Success', 'Case successfully created!', {
                    duration: 3000,
                });
            }, (error) => {
                console.error(error);
                resolveError(error, this.alertService, 'Error', 'Create case failed!');
            }))
                .subscribe();
        }
        else {
            this.adapterCaseService
                .updateAsync(this.data.caseId, {
                ...this.data,
                ...rawValue,
            }, this.snapshotId, this.linkId)
                .pipe(tapResponse(() => {
                this.saveEvent.emit();
                this.alertService.success('Success', 'Case successfully updated!', {
                    duration: 3000,
                });
            }, (error) => {
                resolveError(error, this.alertService, 'Error', 'Updated case failed!');
            }))
                .subscribe();
        }
    }
    toPlainDate(date) {
        const timezoneDate = toTimezoneHourOffset(date);
        if (!timezoneDate) {
            return date;
        }
        return timezoneDate.toISOString().split('T')[0];
    }
    import() {
        const entityType = this.form.value.entityType;
        if (!entityType) {
            this.alertService.warning('Warning', 'Please select entity type', {
                duration: 3000,
            });
            return;
        }
        else {
            this.automaticFilledCaseFunction((data) => {
                this.form.patchValue(data);
                this.alertService.success('Success', 'Import successfully!', {
                    duration: 3000,
                });
            }, entityType);
        }
    }
    autoFillBaseOnEntityType(entityType) {
        if (this.data || !entityType)
            return;
        const identificationTypeControl = this.form.get('identificationType');
        if (!identificationTypeControl || identificationTypeControl.value)
            return;
        switch (entityType) {
            case FSWWorldCheckEntityTypes.ORGANISATION:
                identificationTypeControl.patchValue(this.resources.identityDocumentLocationTypes.find((item) => item.country.code === this.countryMapping[getCountryCodeFromStorage()])?.type);
                break;
            default:
                break;
        }
    }
    listenToICNumberChange() {
        const icControl = this.form.get('identificationNumber');
        const duplicateCheckControl = this.form.get('duplicateCheck');
        icControl.valueChanges
            .pipe(takeUntil(this.formChangeSubject), tap((value) => {
            if (!value) {
                this.icAvailableSignal.set(false);
                duplicateCheckControl.setValue(false);
                duplicateCheckControl.disable();
                return;
            }
            if (this.icAvailableSignal()) {
                return;
            }
            this.icAvailableSignal.set(true);
            duplicateCheckControl.setValue(true);
            duplicateCheckControl.enable();
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckCaseFormComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckCaseFormComponent, isStandalone: true, selector: "fsw-world-check-case-form", inputs: { resources: "resources", data: "data", isReadonly: "isReadonly", entity: "entity", key: "key", snapshotId: "snapshotId", linkId: "linkId", disableAutoFillFields: "disableAutoFillFields", automaticFilledCaseFunction: "automaticFilledCaseFunction" }, outputs: { saveEvent: "saveEvent" }, providers: [
            provideWorldCheckTranslation('world_check_case_form'),
            provideFSWWorldCheckAdapterCaseService(),
        ], usesOnChanges: true, ngImport: i0, template: "<section class=\"w-full\" *ngIf=\"data; else defaultTemplate\">\n  <fsw-panel\n    [title]=\"\n      (snapshotId ? 'titles.snapshot_information_screen' : 'forms.case.title')\n        | fswTranslate : { scope: 'world_check_case_form' }\n    \"\n  >\n    <ng-template fswPanelHeaderSuffix>\n      <section class=\"flex items-center gap-[8px]\">\n        <ng-content select=\"[menu]\"></ng-content>\n        <i\n          fswIcon=\"common-arrow-down\"\n          [class.rotate-180]=\"!hiddenViewSignal()\"\n          class=\"text-[#2c50ff] duration-150\"\n          (click)=\"hiddenViewSignal.set(!hiddenViewSignal())\"\n        ></i>\n      </section>\n    </ng-template>\n    <ng-container *ngIf=\"!hiddenViewSignal()\">\n      <ng-container *ngTemplateOutlet=\"defaultTemplate\"></ng-container>\n    </ng-container>\n  </fsw-panel>\n</section>\n\n<ng-template #defaultTemplate>\n  <section class=\"w-full flex flex-col gap-[16px]\">\n    <ng-content select=\"[snapshot]\"></ng-content>\n    <header class=\"flex justify-end\" *ngIf=\"!data && !isReadonly\">\n      <button fswButton (click)=\"import()\">\n        {{ 'buttons.import' | fswTranslate : { scope: 'world_check_case_form' } }}\n      </button>\n    </header>\n    <form [formGroup]=\"form\">\n      <fsw-dynamic-builder\n        [builder]=\"builderSignal()\"\n        [dictionaries]=\"dictionaries\"\n      ></fsw-dynamic-builder>\n    </form>\n\n    <footer class=\"flex justify-end\" *ngIf=\"!isReadonly && !snapshotId\">\n      <button fswButton [appearance]=\"'secondary'\" (click)=\"save()\" [disabled]=\"form.invalid\">\n        {{\n          (data ? 'buttons.save' : 'buttons.screen')\n            | fswTranslate : { scope: 'world_check_case_form' }\n        }}\n      </button>\n    </footer>\n  </section>\n</ng-template>\n", styles: ["fsw-world-check-case-form .fsw-panel>main:empty{display:none}fsw-world-check-case-form .fsw-checkbox>label{visibility:unset!important}\n"], dependencies: [{ kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: FSWDynamicBuilderModule }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
};
FSWWorldCheckCaseFormComponent = __decorate([
    autoDestroy()
], FSWWorldCheckCaseFormComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckCaseFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-case-form', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [
                        provideWorldCheckTranslation('world_check_case_form'),
                        provideFSWWorldCheckAdapterCaseService(),
                    ], imports: [
                        FSWTranslateModule,
                        ReactiveFormsModule,
                        FSWDynamicBuilderModule,
                        FSWButtonModule,
                        NgIf,
                        NgTemplateOutlet,
                        FSWPanelModule,
                        FSWIconModule,
                    ], encapsulation: ViewEncapsulation.None, template: "<section class=\"w-full\" *ngIf=\"data; else defaultTemplate\">\n  <fsw-panel\n    [title]=\"\n      (snapshotId ? 'titles.snapshot_information_screen' : 'forms.case.title')\n        | fswTranslate : { scope: 'world_check_case_form' }\n    \"\n  >\n    <ng-template fswPanelHeaderSuffix>\n      <section class=\"flex items-center gap-[8px]\">\n        <ng-content select=\"[menu]\"></ng-content>\n        <i\n          fswIcon=\"common-arrow-down\"\n          [class.rotate-180]=\"!hiddenViewSignal()\"\n          class=\"text-[#2c50ff] duration-150\"\n          (click)=\"hiddenViewSignal.set(!hiddenViewSignal())\"\n        ></i>\n      </section>\n    </ng-template>\n    <ng-container *ngIf=\"!hiddenViewSignal()\">\n      <ng-container *ngTemplateOutlet=\"defaultTemplate\"></ng-container>\n    </ng-container>\n  </fsw-panel>\n</section>\n\n<ng-template #defaultTemplate>\n  <section class=\"w-full flex flex-col gap-[16px]\">\n    <ng-content select=\"[snapshot]\"></ng-content>\n    <header class=\"flex justify-end\" *ngIf=\"!data && !isReadonly\">\n      <button fswButton (click)=\"import()\">\n        {{ 'buttons.import' | fswTranslate : { scope: 'world_check_case_form' } }}\n      </button>\n    </header>\n    <form [formGroup]=\"form\">\n      <fsw-dynamic-builder\n        [builder]=\"builderSignal()\"\n        [dictionaries]=\"dictionaries\"\n      ></fsw-dynamic-builder>\n    </form>\n\n    <footer class=\"flex justify-end\" *ngIf=\"!isReadonly && !snapshotId\">\n      <button fswButton [appearance]=\"'secondary'\" (click)=\"save()\" [disabled]=\"form.invalid\">\n        {{\n          (data ? 'buttons.save' : 'buttons.screen')\n            | fswTranslate : { scope: 'world_check_case_form' }\n        }}\n      </button>\n    </footer>\n  </section>\n</ng-template>\n", styles: ["fsw-world-check-case-form .fsw-panel>main:empty{display:none}fsw-world-check-case-form .fsw-checkbox>label{visibility:unset!important}\n"] }]
        }], propDecorators: { saveEvent: [{
                type: Output
            }], resources: [{
                type: Input,
                args: [{ required: true }]
            }], data: [{
                type: Input,
                args: [{ required: true }]
            }], isReadonly: [{
                type: Input
            }], entity: [{
                type: Input,
                args: [{ required: true }]
            }], key: [{
                type: Input,
                args: [{ required: true }]
            }], snapshotId: [{
                type: Input
            }], linkId: [{
                type: Input
            }], disableAutoFillFields: [{
                type: Input
            }], automaticFilledCaseFunction: [{
                type: Input
            }] } });

let FSWWorldCheckSearchFormComponent = class FSWWorldCheckSearchFormComponent {
    constructor() {
        this.searchEvent = new EventEmitter();
        this.translations = injectWorldCheckTranslationByCountryCode();
        this.form = new UntypedFormGroup({});
        this.builderSignal = signal(this.buildBuilder());
    }
    ngOnInit() {
        this.builderSignal.set(this.buildBuilder());
        if (this.resources.defaultGroup?.id) {
            this.search();
        }
    }
    buildBuilder() {
        return new FSWDynamicBuilder({
            form: this.form,
            formType: FSWDynamicBuilderFormTypes.GROUP,
            customClasses: 'w-full flex flex-wrap gap-[12px]',
            fields: this.resources
                ? [
                    {
                        key: 'caseId',
                        customClasses: 'w-[calc(calc(100%-24px)/3)]',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            label: this.translations.forms.search.fields.case_id,
                            fullWidth: true,
                        },
                    },
                    {
                        key: 'groupId',
                        customClasses: 'w-[calc(calc(100%-24px)/3)]',
                        type: FSWDynamicBuilderControlTypes.SELECT,
                        context: {
                            items: this.resources.groups.map((group) => ({
                                value: group.id,
                                text: group.name,
                            })),
                            defaultValue: this.resources.defaultGroup?.id,
                            label: this.translations.forms.search.fields.group_id,
                            fullWidth: true,
                            isDisabled: !!this.resources.defaultGroup?.id,
                        },
                    },
                    {
                        key: 'providerType',
                        customClasses: 'w-[calc(calc(100%-24px)/3)]',
                        type: FSWDynamicBuilderControlTypes.SELECT,
                        context: {
                            items: this.resources?.enums?.providers?.map((value) => ({
                                value,
                                text: value,
                            })) ?? fswWorldCheckProviderTypes,
                            label: this.translations.forms.search.fields.provider_type,
                            fullWidth: true,
                        },
                    },
                    {
                        key: 'entityType',
                        customClasses: 'w-[calc(calc(100%-24px)/3)]',
                        type: FSWDynamicBuilderControlTypes.SELECT,
                        context: {
                            items: this.resources?.enums?.entity_types?.map((value) => ({
                                value,
                                text: value,
                            })) ?? fswWorldCheckEntityTypes,
                            label: this.translations.forms.search.fields.entity_type,
                            fullWidth: true,
                        },
                    },
                    {
                        key: 'primaryName',
                        customClasses: 'w-[calc(calc(100%-24px)/3)]',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            label: this.translations.forms.search.fields.primary_name,
                            fullWidth: true,
                        },
                    },
                    {
                        key: 'idNumbers',
                        customClasses: 'w-[calc(calc(100%-24px)/3)]',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            label: this.translations.forms.search.fields.id_numbers_value,
                            fullWidth: true,
                        },
                    },
                ]
                : [],
        });
    }
    search() {
        const value = this.form.getRawValue();
        const search = Object.keys(value)
            .filter((key) => value[key] != null)
            .reduce((acc, key) => ({ ...acc, [key]: value[key] }), {});
        if (Object.keys(search).length === 0) {
            return;
        }
        this.searchEvent.emit(search);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckSearchFormComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckSearchFormComponent, isStandalone: true, selector: "fsw-world-check-search-form", inputs: { resources: "resources" }, outputs: { searchEvent: "searchEvent" }, providers: [provideWorldCheckTranslation('world_check_search_form')], ngImport: i0, template: "<section class=\"w-full\">\n  <fsw-accordion [expanded]=\"true\" [title]=\"translations.forms.search.title\">\n    <section class=\"w-full flex flex-col gap-[16px]\">\n      <form [formGroup]=\"form\">\n        <fsw-dynamic-builder [builder]=\"builderSignal()\"></fsw-dynamic-builder>\n      </form>\n\n      <footer>\n        <button fswButton [appearance]=\"'secondary'\" (click)=\"search()\">\n          {{ translations.buttons.search }}\n        </button>\n      </footer>\n    </section>\n  </fsw-accordion>\n</section>\n", styles: ["fsw-world-check-search-form *,fsw-world-check-search-form *:before,fsw-world-check-search-form *:after{box-sizing:border-box}fsw-world-check-search-form .fsw-accordion[open]{height:100%}\n"], dependencies: [{ kind: "ngmodule", type: FSWTranslateModule }, { kind: "ngmodule", type: FSWDynamicBuilderModule }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: FSWAccordionModule }, { kind: "component", type: i1$4.FSWAccordionComponent, selector: "fsw-accordion", outputs: ["expandedChange"] }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
};
FSWWorldCheckSearchFormComponent = __decorate([
    autoDestroy()
], FSWWorldCheckSearchFormComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckSearchFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-search-form', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [provideWorldCheckTranslation('world_check_search_form')], imports: [
                        FSWTranslateModule,
                        FSWDynamicBuilderModule,
                        ReactiveFormsModule,
                        FSWAccordionModule,
                        FSWButtonModule,
                    ], encapsulation: ViewEncapsulation.None, template: "<section class=\"w-full\">\n  <fsw-accordion [expanded]=\"true\" [title]=\"translations.forms.search.title\">\n    <section class=\"w-full flex flex-col gap-[16px]\">\n      <form [formGroup]=\"form\">\n        <fsw-dynamic-builder [builder]=\"builderSignal()\"></fsw-dynamic-builder>\n      </form>\n\n      <footer>\n        <button fswButton [appearance]=\"'secondary'\" (click)=\"search()\">\n          {{ translations.buttons.search }}\n        </button>\n      </footer>\n    </section>\n  </fsw-accordion>\n</section>\n", styles: ["fsw-world-check-search-form *,fsw-world-check-search-form *:before,fsw-world-check-search-form *:after{box-sizing:border-box}fsw-world-check-search-form .fsw-accordion[open]{height:100%}\n"] }]
        }], propDecorators: { searchEvent: [{
                type: Output
            }], resources: [{
                type: Input,
                args: [{ required: true }]
            }] } });

class FSWWorldCheckSupplementFormComponent {
    constructor() {
        this.saveEvent = new EventEmitter();
        this.isReadonly = false;
        this.linkId = null;
        this.snapshotId = null;
        this.translations = injectWorldCheckTranslationByCountryCode();
        this.supplementService = injectFSWWorldCheckSupplementService();
        this.alertService = inject(FSW_ALERT_SERVICE_TOKEN);
        this.form = new UntypedFormGroup({});
        this.builderSignal = signal(this.buildBuilder());
    }
    ngOnInit() {
        this.builderSignal.set(this.buildBuilder());
    }
    ngOnChanges() {
        this.builderSignal.set(this.buildBuilder());
    }
    buildBuilder() {
        return new FSWDynamicBuilder({
            form: this.form,
            formType: FSWDynamicBuilderFormTypes.GROUP,
            customClasses: 'w-full flex flex-col gap-[16px]',
            readonlyWhen$: of(this.isReadonly),
            fields: [
                {
                    key: 'edd',
                    customClasses: 'w-full',
                    type: FSWDynamicBuilderControlTypes.SWITCH,
                    context: {
                        defaultValue: !!this.data?.supplement?.edd,
                        label: this.translations.forms.supplement.fields.edd,
                        fullWidth: true,
                        isDisabled: !!this.snapshotId,
                    },
                },
            ],
        });
    }
    save() {
        this.supplementService
            .patchAsync(this.data.caseId, this.form.getRawValue().edd, this.linkId, this.snapshotId)
            .pipe(tapResponse(() => {
            this.saveEvent.emit(this.data);
            this.alertService.success('Success', 'Supplement successfully updated!', {
                duration: 3000,
            });
        }, (error) => {
            console.error(error);
            resolveError(error, this.alertService, 'Error', 'Update supplement failed!');
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckSupplementFormComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckSupplementFormComponent, isStandalone: true, selector: "fsw-world-check-supplement-form", inputs: { data: "data", isReadonly: "isReadonly", linkId: "linkId", snapshotId: "snapshotId" }, outputs: { saveEvent: "saveEvent" }, providers: [
            provideWorldCheckTranslation('world_check_supplement_form'),
            provideFSWWorldCheckSupplementService(),
        ], usesOnChanges: true, ngImport: i0, template: "<section class=\"w-full\">\n  <fsw-accordion\n    [expanded]=\"true\"\n    [title]=\"'forms.supplement.title' | fswTranslate : { scope: 'world_check_supplement_form' }\"\n  >\n    <section class=\"w-full flex flex-col gap-[16px]\">\n      <form [formGroup]=\"form\">\n        <fsw-dynamic-builder [builder]=\"builderSignal()\"></fsw-dynamic-builder>\n      </form>\n\n      <footer *ngIf=\"!isReadonly && !snapshotId\">\n        <button fswButton [appearance]=\"'secondary'\" (click)=\"save()\">\n          {{ 'buttons.save' | fswTranslate }}\n        </button>\n      </footer>\n    </section>\n  </fsw-accordion>\n</section>\n", dependencies: [{ kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: FSWAccordionModule }, { kind: "component", type: i1$4.FSWAccordionComponent, selector: "fsw-accordion", outputs: ["expandedChange"] }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: FSWDynamicBuilderModule }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckSupplementFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-supplement-form', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [
                        provideWorldCheckTranslation('world_check_supplement_form'),
                        provideFSWWorldCheckSupplementService(),
                    ], imports: [
                        FSWTranslateModule,
                        FSWAccordionModule,
                        FSWButtonModule,
                        ReactiveFormsModule,
                        FSWDynamicBuilderModule,
                        NgIf,
                    ], template: "<section class=\"w-full\">\n  <fsw-accordion\n    [expanded]=\"true\"\n    [title]=\"'forms.supplement.title' | fswTranslate : { scope: 'world_check_supplement_form' }\"\n  >\n    <section class=\"w-full flex flex-col gap-[16px]\">\n      <form [formGroup]=\"form\">\n        <fsw-dynamic-builder [builder]=\"builderSignal()\"></fsw-dynamic-builder>\n      </form>\n\n      <footer *ngIf=\"!isReadonly && !snapshotId\">\n        <button fswButton [appearance]=\"'secondary'\" (click)=\"save()\">\n          {{ 'buttons.save' | fswTranslate }}\n        </button>\n      </footer>\n    </section>\n  </fsw-accordion>\n</section>\n" }]
        }], propDecorators: { saveEvent: [{
                type: Output
            }], data: [{
                type: Input,
                args: [{ required: true }]
            }], isReadonly: [{
                type: Input
            }], linkId: [{
                type: Input
            }], snapshotId: [{
                type: Input
            }] } });

class FSWWorldCheckReScreeningModalComponent {
    constructor() {
        this.dialogRef = inject((DialogRef));
        this.translations = injectWorldCheckTranslationByCountryCode();
        this.form = new UntypedFormGroup({});
        this.builder = new FSWDynamicBuilder({
            form: this.form,
            formType: FSWDynamicBuilderFormTypes.GROUP,
            customClasses: 'w-full flex flex-col gap-[16px]',
            fields: [
                {
                    key: 'screeningMode',
                    customClasses: 'w-full',
                    type: FSWDynamicBuilderControlTypes.SELECT,
                    context: {
                        label: this.translations.modals.re_screening.fields.screening_mode,
                        items: this.dialogRef.config.data?.map((item) => ({ value: item, text: item })) ??
                            fswWorldCheckScreeningModes,
                        defaultValue: FSWWorldCheckScreeningModes.FULL_ASYNC,
                        closeOnSelected: true,
                        fullWidth: true,
                        isRequired: true,
                    },
                    validations: [Validators.required],
                },
                // {
                //   key: 'caseInfo',
                //   customClasses: 'w-full',
                //   type: FSWDynamicBuilderControlTypes.CHECKBOX,
                //   context: {
                //     renderTemplate: {
                //       label: this.translations.modals.re_screening.fields.case_info,
                //     },
                //     fullWidth: true,
                //   },
                // },
            ],
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckReScreeningModalComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckReScreeningModalComponent, isStandalone: true, selector: "fsw-world-check-re-screening-modal", providers: [provideWorldCheckTranslation('world_check_re_screening_modal')], ngImport: i0, template: "<fsw-modal\n  [title]=\"'modals.re_screening.title' | fswTranslate : { scope: 'world_check_re_screening_modal' }\"\n  [size]=\"'s'\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate : { scope: 'world_check_re_screening_modal' }\"\n  [confirmButton]=\"'buttons.save' | fswTranslate : { scope: 'world_check_re_screening_modal' }\"\n  (closeEvent)=\"dialogRef.close()\"\n  (cancelEvent)=\"dialogRef.close()\"\n  [confirmButtonDisabled]=\"form.invalid\"\n  (confirmEvent)=\"dialogRef.close(form.value)\"\n>\n  <ng-template fswModalBody>\n    <section class=\"w-full max-h-[calc(90vh-200px)] overflow-y-auto\">\n      <form [formGroup]=\"form\">\n        <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n      </form>\n    </section>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "ngmodule", type: FSWModalModule$1 }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: FSWDynamicBuilderModule }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckReScreeningModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-re-screening-modal', standalone: true, changeDetection: ChangeDetectionStrategy.OnPush, providers: [provideWorldCheckTranslation('world_check_re_screening_modal')], imports: [FSWModalModule$1, FSWTranslateModule, ReactiveFormsModule, FSWDynamicBuilderModule], template: "<fsw-modal\n  [title]=\"'modals.re_screening.title' | fswTranslate : { scope: 'world_check_re_screening_modal' }\"\n  [size]=\"'s'\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate : { scope: 'world_check_re_screening_modal' }\"\n  [confirmButton]=\"'buttons.save' | fswTranslate : { scope: 'world_check_re_screening_modal' }\"\n  (closeEvent)=\"dialogRef.close()\"\n  (cancelEvent)=\"dialogRef.close()\"\n  [confirmButtonDisabled]=\"form.invalid\"\n  (confirmEvent)=\"dialogRef.close(form.value)\"\n>\n  <ng-template fswModalBody>\n    <section class=\"w-full max-h-[calc(90vh-200px)] overflow-y-auto\">\n      <form [formGroup]=\"form\">\n        <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n      </form>\n    </section>\n  </ng-template>\n</fsw-modal>\n" }]
        }] });

class FSWWorldCheckResolutionModalComponent {
    constructor() {
        this.dialogRef = inject((DialogRef));
        this.translations = injectWorldCheckTranslationByCountryCode();
        this.status$ = new BehaviorSubject(null);
        this.form = new UntypedFormGroup({});
        this.builder = new FSWDynamicBuilder({
            form: this.form,
            formType: FSWDynamicBuilderFormTypes.GROUP,
            customClasses: 'w-full flex flex-col gap-[16px]',
            fields: [
                {
                    key: 'status',
                    customClasses: 'w-full',
                    type: FSWDynamicBuilderControlTypes.SELECT,
                    context: {
                        label: this.translations.modals.resolution.fields.status,
                        items: Object.keys(this.dialogRef.config.data.resources
                            .resolution).map((value) => ({
                            value,
                            text: value,
                        })),
                        closeOnSelected: true,
                        fullWidth: true,
                        isRequired: true,
                        afterCreated: (control) => {
                            this.status$.next(control.value);
                            control.valueChanges
                                .pipe(tap((status) => {
                                this.status$.next(status);
                            }))
                                .subscribe();
                        },
                    },
                    validations: [Validators.required],
                },
                {
                    key: 'risk',
                    customClasses: 'w-full',
                    type: FSWDynamicBuilderControlTypes.SELECT,
                    context: {
                        label: this.translations.modals.resolution.fields.risk,
                        loadItemsAsync: () => this.status$.pipe(map((status) => status
                            ? this.dialogRef.config.data.resources
                                .resolution[status].risks.map((item) => ({ value: item.label, text: item.label }))
                            : [])),
                        closeOnSelected: true,
                        fullWidth: true,
                        isRequired: true,
                    },
                    validations: [Validators.required],
                },
                {
                    key: 'reason',
                    customClasses: 'w-full',
                    type: FSWDynamicBuilderControlTypes.SELECT,
                    context: {
                        label: this.translations.modals.resolution.fields.reason,
                        loadItemsAsync: () => this.status$.pipe(map((status) => status
                            ? this.dialogRef.config.data.resources
                                .resolution[status].reasons.map((item) => ({ value: item.label, text: item.label }))
                            : [])),
                        closeOnSelected: true,
                        fullWidth: true,
                        isRequired: true,
                    },
                    validations: [Validators.required],
                },
                {
                    key: 'remark',
                    customClasses: 'w-full',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    context: {
                        label: this.translations.modals.resolution.fields.remark,
                        inputType: 'area',
                        rows: 5,
                        fullWidth: true,
                        isRequired: true,
                    },
                    validations: [Validators.required],
                },
            ],
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckResolutionModalComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckResolutionModalComponent, isStandalone: true, selector: "fsw-world-check-resolution-modal", providers: [provideWorldCheckTranslation('world_check_resolution_modal')], ngImport: i0, template: "<fsw-modal\n  [title]=\"'modals.resolution.title' | fswTranslate : { scope: 'world_check_resolution_modal' }\"\n  [size]=\"'s'\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate : { scope: 'world_check_resolution_modal' }\"\n  [confirmButton]=\"'buttons.save' | fswTranslate : { scope: 'world_check_resolution_modal' }\"\n  (closeEvent)=\"dialogRef.close()\"\n  (cancelEvent)=\"dialogRef.close()\"\n  [confirmButtonDisabled]=\"form.invalid\"\n  (confirmEvent)=\"dialogRef.close(form.value)\"\n>\n  <ng-template fswModalBody>\n    <section class=\"w-full max-h-[calc(90vh-200px)] overflow-y-auto flex flex-col gap-[16px]\">\n      <table class=\"fsw-table !table-auto w-full fsw-table--bordered\">\n        <thead>\n          <tr>\n            <th class=\"whitespace-normal align-middle break-words\" colspan=\"2\">Results</th>\n          </tr>\n          <tr>\n            <th class=\"whitespace-normal align-middle break-words\">\n              {{ 'tables.result.name' | fswTranslate : { scope: 'world_check_resolution_modal' } }}\n            </th>\n            <th class=\"whitespace-normal align-middle break-words\">\n              {{\n                'tables.result.reference_id'\n                  | fswTranslate : { scope: 'world_check_resolution_modal' }\n              }}\n            </th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr *ngFor=\"let result of dialogRef.config.data.results\">\n            <td class=\"whitespace-normal align-middle break-words\">\n              {{ result['name'] || '--' }}\n            </td>\n            <td class=\"whitespace-normal align-middle break-words\">\n              {{ result['referenceId'] || '--' }}\n            </td>\n          </tr>\n        </tbody>\n      </table>\n      <form [formGroup]=\"form\">\n        <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n      </form>\n    </section>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "ngmodule", type: FSWModalModule$1 }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: FSWDynamicBuilderModule }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckResolutionModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-resolution-modal', standalone: true, changeDetection: ChangeDetectionStrategy.OnPush, providers: [provideWorldCheckTranslation('world_check_resolution_modal')], imports: [
                        FSWModalModule$1,
                        FSWTranslateModule,
                        ReactiveFormsModule,
                        FSWDynamicBuilderModule,
                        NgForOf,
                    ], template: "<fsw-modal\n  [title]=\"'modals.resolution.title' | fswTranslate : { scope: 'world_check_resolution_modal' }\"\n  [size]=\"'s'\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate : { scope: 'world_check_resolution_modal' }\"\n  [confirmButton]=\"'buttons.save' | fswTranslate : { scope: 'world_check_resolution_modal' }\"\n  (closeEvent)=\"dialogRef.close()\"\n  (cancelEvent)=\"dialogRef.close()\"\n  [confirmButtonDisabled]=\"form.invalid\"\n  (confirmEvent)=\"dialogRef.close(form.value)\"\n>\n  <ng-template fswModalBody>\n    <section class=\"w-full max-h-[calc(90vh-200px)] overflow-y-auto flex flex-col gap-[16px]\">\n      <table class=\"fsw-table !table-auto w-full fsw-table--bordered\">\n        <thead>\n          <tr>\n            <th class=\"whitespace-normal align-middle break-words\" colspan=\"2\">Results</th>\n          </tr>\n          <tr>\n            <th class=\"whitespace-normal align-middle break-words\">\n              {{ 'tables.result.name' | fswTranslate : { scope: 'world_check_resolution_modal' } }}\n            </th>\n            <th class=\"whitespace-normal align-middle break-words\">\n              {{\n                'tables.result.reference_id'\n                  | fswTranslate : { scope: 'world_check_resolution_modal' }\n              }}\n            </th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr *ngFor=\"let result of dialogRef.config.data.results\">\n            <td class=\"whitespace-normal align-middle break-words\">\n              {{ result['name'] || '--' }}\n            </td>\n            <td class=\"whitespace-normal align-middle break-words\">\n              {{ result['referenceId'] || '--' }}\n            </td>\n          </tr>\n        </tbody>\n      </table>\n      <form [formGroup]=\"form\">\n        <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n      </form>\n    </section>\n  </ng-template>\n</fsw-modal>\n" }]
        }] });

class FSWWorldCheckReviewModalComponent {
    constructor() {
        this.dialogRef = inject((DialogRef));
        this.reviewControl = new FormControl('');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckReviewModalComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckReviewModalComponent, isStandalone: true, selector: "fsw-world-check-review-modal", providers: [provideWorldCheckTranslation('world_check_review_modal')], ngImport: i0, template: "<fsw-modal\n  [title]=\"'modals.review.title' | fswTranslate : { scope: 'world_check_review_modal' }\"\n  [size]=\"'s'\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate : { scope: 'world_check_review_modal' }\"\n  [confirmButton]=\"'buttons.save' | fswTranslate : { scope: 'world_check_review_modal' }\"\n  (closeEvent)=\"dialogRef.close()\"\n  (cancelEvent)=\"dialogRef.close()\"\n  (confirmEvent)=\"dialogRef.close(reviewControl.value)\"\n>\n  <ng-template fswModalBody>\n    <section class=\"w-full max-h-[calc(90vh-200px)] overflow-y-auto flex flex-col gap-[16px]\">\n      <table class=\"fsw-table !table-auto w-full fsw-table--bordered\">\n        <thead>\n          <tr>\n            <th class=\"whitespace-normal align-middle break-words\" colspan=\"2\">Results</th>\n          </tr>\n          <tr>\n            <th class=\"whitespace-normal align-middle break-words\">\n              {{ 'tables.result.name' | fswTranslate : { scope: 'world_check_review_modal' } }}\n            </th>\n            <th class=\"whitespace-normal align-middle break-words\">\n              {{\n                'tables.result.reference_id' | fswTranslate : { scope: 'world_check_review_modal' }\n              }}\n            </th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr *ngFor=\"let result of dialogRef.config.data\">\n            <td class=\"whitespace-normal align-middle break-words\">\n              {{ result['name'] || '--' }}\n            </td>\n            <td class=\"whitespace-normal align-middle break-words\">\n              {{ result['referenceId'] || '--' }}\n            </td>\n          </tr>\n        </tbody>\n      </table>\n      <fsw-field [fullWidth]=\"true\">\n        <textarea fswInput [formControl]=\"reviewControl\" rows=\"5\"></textarea>\n      </fsw-field>\n    </section>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "ngmodule", type: FSWCheckboxModule }, { kind: "ngmodule", type: FSWDynamicBuilderModule }, { kind: "ngmodule", type: FSWModalModule$1 }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: FSWFieldModule }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "ngmodule", type: FSWInputModule }, { kind: "directive", type: i1$4.FSWInputDirective, selector: "input[fswInput], textarea[fswInput]" }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckReviewModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-review-modal', standalone: true, changeDetection: ChangeDetectionStrategy.OnPush, providers: [provideWorldCheckTranslation('world_check_review_modal')], imports: [
                        FSWCheckboxModule,
                        FSWDynamicBuilderModule,
                        FSWModalModule$1,
                        FSWTranslateModule,
                        ReactiveFormsModule,
                        FSWFieldModule,
                        FSWInputModule,
                        NgForOf,
                    ], template: "<fsw-modal\n  [title]=\"'modals.review.title' | fswTranslate : { scope: 'world_check_review_modal' }\"\n  [size]=\"'s'\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate : { scope: 'world_check_review_modal' }\"\n  [confirmButton]=\"'buttons.save' | fswTranslate : { scope: 'world_check_review_modal' }\"\n  (closeEvent)=\"dialogRef.close()\"\n  (cancelEvent)=\"dialogRef.close()\"\n  (confirmEvent)=\"dialogRef.close(reviewControl.value)\"\n>\n  <ng-template fswModalBody>\n    <section class=\"w-full max-h-[calc(90vh-200px)] overflow-y-auto flex flex-col gap-[16px]\">\n      <table class=\"fsw-table !table-auto w-full fsw-table--bordered\">\n        <thead>\n          <tr>\n            <th class=\"whitespace-normal align-middle break-words\" colspan=\"2\">Results</th>\n          </tr>\n          <tr>\n            <th class=\"whitespace-normal align-middle break-words\">\n              {{ 'tables.result.name' | fswTranslate : { scope: 'world_check_review_modal' } }}\n            </th>\n            <th class=\"whitespace-normal align-middle break-words\">\n              {{\n                'tables.result.reference_id' | fswTranslate : { scope: 'world_check_review_modal' }\n              }}\n            </th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr *ngFor=\"let result of dialogRef.config.data\">\n            <td class=\"whitespace-normal align-middle break-words\">\n              {{ result['name'] || '--' }}\n            </td>\n            <td class=\"whitespace-normal align-middle break-words\">\n              {{ result['referenceId'] || '--' }}\n            </td>\n          </tr>\n        </tbody>\n      </table>\n      <fsw-field [fullWidth]=\"true\">\n        <textarea fswInput [formControl]=\"reviewControl\" rows=\"5\"></textarea>\n      </fsw-field>\n    </section>\n  </ng-template>\n</fsw-modal>\n" }]
        }] });

class FSWWorldCheckAssignModalComponent {
    constructor() {
        this.dialogRef = inject((DialogRef));
        this.translations = injectWorldCheckTranslationByCountryCode();
        this.form = new UntypedFormGroup({});
        this.builder = new FSWDynamicBuilder({
            formType: FSWDynamicBuilderFormTypes.GROUP,
            form: this.form,
            customClasses: 'w-full flex flex-col gap-[12px] w-full',
            fields: [
                {
                    key: 'email',
                    type: FSWDynamicBuilderControlTypes.SELECT,
                    customClasses: 'w-full',
                    context: {
                        fullWidth: true,
                        label: this.translations.modals.assign.fields.email,
                        maxHeight: '300px',
                        isRequired: true,
                        closeOnSelected: true,
                        items: this.dialogRef.config.data.map((user) => ({
                            value: user.email,
                            text: user.email,
                        })),
                    },
                    validations: [Validators.required],
                },
                {
                    key: 'note',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-full',
                    context: {
                        fullWidth: true,
                        isRequired: true,
                        label: this.translations.modals.assign.fields.note,
                        inputType: 'area',
                        rows: 3,
                    },
                    validations: [Validators.required],
                },
            ],
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckAssignModalComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckAssignModalComponent, isStandalone: true, selector: "fsw-world-check-assign-modal", providers: [provideWorldCheckTranslation('world_check_assign_modal')], ngImport: i0, template: "<fsw-modal\n  [title]=\"'modals.assign.title' | fswTranslate : { scope: 'world_check_assign_modal' }\"\n  [size]=\"'s'\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate : { scope: 'world_check_assign_modal' }\"\n  [confirmButton]=\"'buttons.save' | fswTranslate : { scope: 'world_check_assign_modal' }\"\n  (closeEvent)=\"dialogRef.close()\"\n  (cancelEvent)=\"dialogRef.close()\"\n  [confirmButtonDisabled]=\"form.invalid\"\n  (confirmEvent)=\"dialogRef.close(form.value)\"\n>\n  <ng-template fswModalBody>\n    <section class=\"w-full max-h-[calc(90vh-200px)] overflow-y-auto\">\n      <form [formGroup]=\"form\">\n        <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n      </form>\n    </section>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "ngmodule", type: FSWModalModule$1 }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: FSWDynamicBuilderModule }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckAssignModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-assign-modal', standalone: true, changeDetection: ChangeDetectionStrategy.OnPush, providers: [provideWorldCheckTranslation('world_check_assign_modal')], imports: [FSWModalModule$1, FSWTranslateModule, ReactiveFormsModule, FSWDynamicBuilderModule], template: "<fsw-modal\n  [title]=\"'modals.assign.title' | fswTranslate : { scope: 'world_check_assign_modal' }\"\n  [size]=\"'s'\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate : { scope: 'world_check_assign_modal' }\"\n  [confirmButton]=\"'buttons.save' | fswTranslate : { scope: 'world_check_assign_modal' }\"\n  (closeEvent)=\"dialogRef.close()\"\n  (cancelEvent)=\"dialogRef.close()\"\n  [confirmButtonDisabled]=\"form.invalid\"\n  (confirmEvent)=\"dialogRef.close(form.value)\"\n>\n  <ng-template fswModalBody>\n    <section class=\"w-full max-h-[calc(90vh-200px)] overflow-y-auto\">\n      <form [formGroup]=\"form\">\n        <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n      </form>\n    </section>\n  </ng-template>\n</fsw-modal>\n" }]
        }] });

class FSWWorldCheckConfirmModalComponent {
    constructor() {
        this.dialogRef = inject((DialogRef));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckConfirmModalComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckConfirmModalComponent, isStandalone: true, selector: "fsw-world-check-confirm-modal", providers: [provideWorldCheckTranslation('world_check_confirm_modal')], ngImport: i0, template: "<fsw-modal\n  [title]=\"dialogRef.config.data.title\"\n  [size]=\"'s'\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate : { scope: 'world_check_confirm_modal' }\"\n  [confirmButton]=\"'buttons.save' | fswTranslate : { scope: 'world_check_confirm_modal' }\"\n  [hiddenFooter]=\"dialogRef.config.data.hiddenButtons\"\n  (closeEvent)=\"dialogRef.close()\"\n  (cancelEvent)=\"dialogRef.close()\"\n  (confirmEvent)=\"dialogRef.close(true)\"\n>\n  <ng-template fswModalBody>\n    <section class=\"w-full flex flex-col gap-[16px] max-h-[calc(90vh-200px)] overflow-y-auto\">\n      <p [innerHTML]=\"dialogRef.config.data.description\"></p>\n      <p *ngIf=\"dialogRef.config.data.warning\" [innerHTML]=\"dialogRef.config.data.warning\"></p>\n    </section>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "ngmodule", type: FSWModalModule$1 }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckConfirmModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-confirm-modal', standalone: true, changeDetection: ChangeDetectionStrategy.OnPush, providers: [provideWorldCheckTranslation('world_check_confirm_modal')], imports: [FSWModalModule$1, FSWTranslateModule, NgIf], template: "<fsw-modal\n  [title]=\"dialogRef.config.data.title\"\n  [size]=\"'s'\"\n  [cancelButton]=\"'buttons.cancel' | fswTranslate : { scope: 'world_check_confirm_modal' }\"\n  [confirmButton]=\"'buttons.save' | fswTranslate : { scope: 'world_check_confirm_modal' }\"\n  [hiddenFooter]=\"dialogRef.config.data.hiddenButtons\"\n  (closeEvent)=\"dialogRef.close()\"\n  (cancelEvent)=\"dialogRef.close()\"\n  (confirmEvent)=\"dialogRef.close(true)\"\n>\n  <ng-template fswModalBody>\n    <section class=\"w-full flex flex-col gap-[16px] max-h-[calc(90vh-200px)] overflow-y-auto\">\n      <p [innerHTML]=\"dialogRef.config.data.description\"></p>\n      <p *ngIf=\"dialogRef.config.data.warning\" [innerHTML]=\"dialogRef.config.data.warning\"></p>\n    </section>\n  </ng-template>\n</fsw-modal>\n" }]
        }] });

class FSWWorldCheckErrorModalComponent {
    constructor() {
        this.dialogRef = inject((DialogRef));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckErrorModalComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckErrorModalComponent, isStandalone: true, selector: "fsw-world-check-error-modal", providers: [provideWorldCheckTranslation('world_check_confirm_modal')], ngImport: i0, template: "<fsw-modal\n  [title]=\"dialogRef.config.data.title\"\n  [size]=\"'s'\"\n  [hiddenFooter]=\"dialogRef.config.data.hiddenButtons\"\n  (closeEvent)=\"dialogRef.close()\"\n>\n  <ng-template fswModalBody>\n    <section\n      class=\"w-full flex max-h-[calc(90vh-200px)] overflow-y-auto px-4 py-20 items-center bg-red-100 justify-center\"\n    >\n      <p\n        class=\"font-inter text-center text-red-500 font-semibold text-body-default-500 break-words\"\n        [innerHTML]=\"dialogRef.config.data.description\"\n      ></p>\n    </section>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "ngmodule", type: FSWModalModule$1 }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "ngmodule", type: FSWTranslateModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckErrorModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-error-modal', standalone: true, changeDetection: ChangeDetectionStrategy.OnPush, providers: [provideWorldCheckTranslation('world_check_confirm_modal')], imports: [FSWModalModule$1, FSWTranslateModule, NgIf], template: "<fsw-modal\n  [title]=\"dialogRef.config.data.title\"\n  [size]=\"'s'\"\n  [hiddenFooter]=\"dialogRef.config.data.hiddenButtons\"\n  (closeEvent)=\"dialogRef.close()\"\n>\n  <ng-template fswModalBody>\n    <section\n      class=\"w-full flex max-h-[calc(90vh-200px)] overflow-y-auto px-4 py-20 items-center bg-red-100 justify-center\"\n    >\n      <p\n        class=\"font-inter text-center text-red-500 font-semibold text-body-default-500 break-words\"\n        [innerHTML]=\"dialogRef.config.data.description\"\n      ></p>\n    </section>\n  </ng-template>\n</fsw-modal>\n" }]
        }] });

class FSWWorldCheckCaseModalComponent {
    constructor() {
        this.adapterCaseService = injectFSWWorldCheckAdapterCaseService();
        this.linkService = injectFSWWorldCheckLinkService();
        this.alertService = inject(FSW_ALERT_SERVICE_TOKEN);
        this.translations = injectWorldCheckTranslationByCountryCode();
        this.casesSignal = signal([]);
        this.searchSignal = signal({});
        this.dialog = inject(Dialog);
        this.dialogRef = inject((DialogRef));
        effect(() => {
            this.loadCases();
        }, { allowSignalWrites: true });
    }
    loadCases() {
        const search = this.searchSignal();
        if (Object.keys(search).length === 0) {
            this.casesSignal.set([]);
            return;
        }
        const { noCache, noLock } = this.dialogRef.config.data.information;
        this.adapterCaseService
            .searchAsync(search, noCache, noLock)
            .pipe(tapResponse((cases) => this.casesSignal.set(cases), (error) => {
            resolveError(error, this.alertService, 'Error', 'Search cases failed!');
        }))
            .subscribe();
    }
    link(item) {
        this.dialog
            .open(FSWWorldCheckConfirmModalComponent, {
            data: this.translations.modals['link'],
        })
            .closed.pipe(take(1), filter((accept) => !!accept), switchMap(() => this.linkService
            .insertAsync(this.dialogRef.config.data.information.entity, this.dialogRef.config.data.information.key, item.caseId)
            .pipe(tapResponse(() => {
            this.alertService.success('Success', 'Link successfully!', {
                duration: 3000,
            });
            this.dialogRef.config.data.events.linked();
        }, (error) => {
            resolveError(error, this.alertService, 'Error', 'Link failed!');
        }))))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckCaseModalComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckCaseModalComponent, isStandalone: true, selector: "fsw-world-check-case-modal", providers: [
            provideWorldCheckTranslation('world_check_case_modal'),
            provideFSWWorldCheckAdapterCaseService(),
            provideFSWWorldCheckLinkService(),
        ], ngImport: i0, template: "<fsw-modal\n  [title]=\"'buttons.pick' | fswTranslate : { scope: 'world_check_case_modal' }\"\n  [size]=\"'l'\"\n  [hiddenFooter]=\"dialogRef.config.data.hiddenButtons\"\n  (closeEvent)=\"dialogRef.close()\"\n>\n  <ng-template fswModalBody>\n    <section class=\"flex flex-col gap-[16px] py-[16px] max-h-[calc(90vh-200px)] overflow-y-auto\">\n      <fsw-world-check-search-form\n        [resources]=\"dialogRef.config.data.information.resources\"\n        (searchEvent)=\"searchSignal.set($event)\"\n      ></fsw-world-check-search-form>\n      <section class=\"flex flex-col gap-[16px]\">\n        <fsw-world-check-case-table\n          [data]=\"casesSignal()\"\n          [linkedCases]=\"dialogRef.config.data.information.linkedCases\"\n          [isReadonly]=\"dialogRef.config.data.information.isReadonly\"\n          [canGoToDetails]=\"false\"\n          (selectedEvent)=\"dialogRef.config.data.events.selected($event); dialogRef.close()\"\n          (linkEvent)=\"link($event)\"\n        ></fsw-world-check-case-table>\n      </section>\n    </section>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "component", type: FSWWorldCheckSearchFormComponent, selector: "fsw-world-check-search-form", inputs: ["resources"], outputs: ["searchEvent"] }, { kind: "component", type: FSWWorldCheckCaseTableComponent, selector: "fsw-world-check-case-table", inputs: ["data", "linkedCases", "isReadonly", "canGoToDetails"], outputs: ["selectedEvent", "linkEvent"] }, { kind: "ngmodule", type: FSWAlertModule }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "ngmodule", type: FSWModalModule$1 }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckCaseModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-case-modal', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [
                        provideWorldCheckTranslation('world_check_case_modal'),
                        provideFSWWorldCheckAdapterCaseService(),
                        provideFSWWorldCheckLinkService(),
                    ], imports: [
                        FSWTranslateModule,
                        NgIf,
                        FSWWorldCheckSearchFormComponent,
                        FSWWorldCheckCaseTableComponent,
                        FSWWorldCheckConfirmModalComponent,
                        FSWAlertModule,
                        FSWButtonModule,
                        FSWModalModule$1,
                        FSWModalModule$1,
                    ], template: "<fsw-modal\n  [title]=\"'buttons.pick' | fswTranslate : { scope: 'world_check_case_modal' }\"\n  [size]=\"'l'\"\n  [hiddenFooter]=\"dialogRef.config.data.hiddenButtons\"\n  (closeEvent)=\"dialogRef.close()\"\n>\n  <ng-template fswModalBody>\n    <section class=\"flex flex-col gap-[16px] py-[16px] max-h-[calc(90vh-200px)] overflow-y-auto\">\n      <fsw-world-check-search-form\n        [resources]=\"dialogRef.config.data.information.resources\"\n        (searchEvent)=\"searchSignal.set($event)\"\n      ></fsw-world-check-search-form>\n      <section class=\"flex flex-col gap-[16px]\">\n        <fsw-world-check-case-table\n          [data]=\"casesSignal()\"\n          [linkedCases]=\"dialogRef.config.data.information.linkedCases\"\n          [isReadonly]=\"dialogRef.config.data.information.isReadonly\"\n          [canGoToDetails]=\"false\"\n          (selectedEvent)=\"dialogRef.config.data.events.selected($event); dialogRef.close()\"\n          (linkEvent)=\"link($event)\"\n        ></fsw-world-check-case-table>\n      </section>\n    </section>\n  </ng-template>\n</fsw-modal>\n" }]
        }], ctorParameters: function () { return []; } });

class FSWWorldCheckDashboardScreenComponent {
    constructor() {
        this.newCaseEvent = new EventEmitter();
        this.selectedCaseEvent = new EventEmitter();
        this.selectedLinkEvent = new EventEmitter();
        this.selectedSnapshotEvent = new EventEmitter();
        this.isReadonly = false;
        this.noCache = false;
        this.noLock = false;
        this.linkService = injectFSWWorldCheckLinkService();
        this.adapterCaseService = injectFSWWorldCheckAdapterCaseService();
        this.snapshotService = injectFSWWorldCheckSnapshotService();
        this.alertService = inject(FSW_ALERT_SERVICE_TOKEN);
        this.translations = injectWorldCheckTranslationByCountryCode();
        this.blobService = inject(BLOB_SERVICE_TOKEN);
        this.searchControl = new FormControl('');
        this.dialog = inject(Dialog);
        this.resultsMappingSignal = signal({});
        this.linksSignal = signal([]);
        this.searchSignal = toSignal(this.searchControl.valueChanges, {
            initialValue: '',
        });
        this.indexSignal = signal(1);
        this.itemsPerPageSignal = signal(50);
        this.filteredSignal = computed(() => {
            const query = this.searchSignal();
            if (!query?.length) {
                return this.linksSignal();
            }
            const groups = this.resources?.groups ?? [];
            return this.linksSignal().filter((link) => {
                return ['name', 'identificationNumber', 'groupId', 'entityType', 'providerTypes'].some((field) => {
                    const value = link.detail.data[field];
                    if (field === 'groupId') {
                        return groups.length
                            ? groups.some((group) => group.name.toLowerCase().includes(query.toLowerCase()))
                            : true;
                    }
                    const providerTypes = link.detail.data.providerTypes ?? [];
                    if (field === 'providerTypes') {
                        return providerTypes.length
                            ? link.detail.data.providerTypes.some((providerType) => providerType.toLowerCase().includes(query.toLowerCase()))
                            : true;
                    }
                    return value?.toLowerCase().includes(query.toLowerCase());
                });
            });
        });
        this.paginatedSignal = computed(() => {
            return this.filteredSignal().slice((this.indexSignal() - 1) * (this.itemsPerPageSignal() ?? this.filteredSignal().length), this.indexSignal() * (this.itemsPerPageSignal() ?? this.filteredSignal().length));
        });
    }
    ngOnChanges(changes) {
        if (changes.noCache || this.noCache || changes.noLock || this.noLock) {
            this.loadLinks();
        }
    }
    loadLinks() {
        this.linkService
            .queryAsync(this.entity, this.key, {
            with_detail: true,
            with_snapshot: true,
        }, this.noCache, this.noLock)
            .pipe(tapResponse((links) => {
            this.linksSignal.set(links);
            this.loadResultsMapping();
        }, (error) => {
            console.error(error);
            this.linksSignal.set([]);
            resolveError(error, this.alertService, 'Error', 'Load link data failed!');
        }))
            .subscribe();
    }
    /**
     * @description Getting un-resolved results and add to map with key `${link.id}${link.caseId}`
     */
    loadResultsMapping() {
        forkJoin(this.linksSignal().map((link) => this.adapterCaseService
            .getResultsByIdAsync(link.caseId, link.id, null, this.noCache, this.noLock)
            .pipe(map((results) => [
            `${link.id}${link.caseId}`,
            results.filter((result) => !result.resolution?.length).length,
        ]))))
            .pipe(tapResponse((list) => this.resultsMappingSignal.set(list.reduce((acc, cur) => ({ ...acc, [cur[0]]: cur[1] }), {})), (error) => {
            resolveError(error, this.alertService, 'Error', `Load results failed!`);
        }))
            .subscribe();
    }
    action(item, method) {
        switch (method) {
            case 're_screening':
                this.dialog
                    .open(FSWWorldCheckReScreeningModalComponent, {
                    data: this.resources?.enums?.screening_modes,
                })
                    .closed.pipe(take(1), filter((data) => !!data), switchMap((data) => this.adapterCaseService
                    .reScreenAsync(item.caseId, data, item.id)
                    .pipe(tapResponse(() => {
                    this.alertService.success('Success', 'Re-Screening successfully!', {
                        duration: 3000,
                    });
                    this.loadLinks();
                }, (error) => {
                    console.error(error);
                    resolveError(error, this.alertService, 'Error', 'Re-Screening failed!');
                }))))
                    .subscribe();
                break;
            case 'assign':
                this.dialog
                    .open(FSWWorldCheckAssignModalComponent, {
                    data: this.resources.users,
                })
                    .closed.pipe(take(1), filter((accept) => !!accept), switchMap((data) => this.adapterCaseService
                    .assignAsync(item.caseId, data, item.id)
                    .pipe(tapResponse(() => {
                    this.alertService.success('Success', 'Assign successfully!', {
                        duration: 3000,
                    });
                    this.loadLinks();
                }, (error) => {
                    console.error(error);
                    resolveError(error, this.alertService, 'Error', 'Assign failed!');
                }))))
                    .subscribe();
                break;
            case 'un_assign':
                this.dialog
                    .open(FSWWorldCheckConfirmModalComponent, {
                    data: this.translations.modals['un_assign'],
                })
                    .closed.pipe(take(1), filter((data) => !!data), switchMap(() => this.adapterCaseService.unAssignAsync(item.caseId, item.id).pipe(tapResponse(() => {
                    this.alertService.success('Success', 'Un-Assign successfully!', {
                        duration: 3000,
                    });
                    this.loadLinks();
                }, (error) => {
                    console.error(error);
                    resolveError(error, this.alertService, 'Error', 'Un-Assign failed!');
                }))))
                    .subscribe();
                break;
            case 'archive':
                this.dialog
                    .open(FSWWorldCheckConfirmModalComponent, {
                    data: this.translations.modals['archive'],
                })
                    .closed.pipe(take(1), filter((accept) => !!accept), switchMap(() => this.adapterCaseService.archiveAsync(item.caseId, item.id).pipe(tapResponse(() => {
                    this.alertService.success('Success', 'Archive successfully!', {
                        duration: 3000,
                    });
                    this.loadLinks();
                }, (error) => {
                    console.error(error);
                    resolveError(error, this.alertService, 'Error', 'Archive failed!');
                }))))
                    .subscribe();
                break;
            case 'un_archive':
                this.dialog
                    .open(FSWWorldCheckConfirmModalComponent, {
                    data: this.translations.modals['un_archive'],
                })
                    .closed.pipe(take(1), filter((accept) => !!accept), switchMap(() => this.adapterCaseService.unArchiveAsync(item.caseId, item.id).pipe(tapResponse(() => {
                    this.alertService.success('Success', 'Un-archive successfully!', {
                        duration: 3000,
                    });
                    this.loadLinks();
                }, (error) => {
                    console.error(error);
                    resolveError(error, this.alertService, 'Error', 'Un-archive failed!');
                }))))
                    .subscribe();
                break;
            case 'trigger':
                this.snapshotService
                    .triggerAsync(item.caseId, item.id)
                    .pipe(tapResponse(() => {
                    this.loadLinks();
                    this.alertService.success('Success', 'Trigger snapshot data successfully!', {
                        duration: 3000,
                    });
                }, (error) => {
                    console.error(error);
                    resolveError(error, this.alertService, 'Error', 'Trigger snapshot data failed!');
                }))
                    .subscribe();
                break;
            case 'un_link':
                this.dialog
                    .open(FSWWorldCheckConfirmModalComponent, {
                    data: this.translations.modals.delete,
                })
                    .closed.pipe(take(1), filter((accept) => !!accept), switchMap(() => this.linkService.deleteAsync(item.entity, item.key, item.caseId).pipe(tapResponse(() => {
                    this.loadLinks();
                    this.alertService.success('Success', 'Delete link data successfully!', {
                        duration: 3000,
                    });
                }, (error) => {
                    console.error(error);
                    resolveError(error, this.alertService, 'Error', 'Delete link data failed!');
                }))))
                    .subscribe();
                break;
            case 'detail':
                this.selectedLinkEvent.emit({
                    caseId: item.caseId,
                    linkId: item.id,
                });
                break;
        }
    }
    actionSnapshot({ snapshot, link }, method) {
        switch (method) {
            case 'delete':
                this.dialog
                    .open(FSWWorldCheckConfirmModalComponent, {
                    data: this.translations.modals.delete,
                })
                    .closed.pipe(take(1), filter((accept) => !!accept), switchMap(() => this.snapshotService.deleteAsync(snapshot.id, link.caseId, link.id).pipe(tapResponse(() => {
                    this.loadLinks();
                    this.alertService.success('Success', 'Delete snapshot data successfully!', {
                        duration: 3000,
                    });
                }, (error) => {
                    console.error(error);
                    resolveError(error, this.alertService, 'Error', 'Delete snapshot data failed!');
                }))))
                    .subscribe();
                break;
            case 're_trigger':
                this.snapshotService
                    .reTriggerAsync(snapshot.id, link.caseId, link.id)
                    .pipe(tapResponse(() => {
                    this.loadLinks();
                    this.alertService.success('Success', 'Re-Trigger snapshot data successfully!', {
                        duration: 3000,
                    });
                }, (error) => {
                    console.error(error);
                    resolveError(error, this.alertService, 'Error', 'Re-Trigger snapshot data failed!');
                }))
                    .subscribe();
                break;
            case 'view_error':
                this.dialog.open(FSWWorldCheckErrorModalComponent, {
                    data: {
                        title: `View Error`,
                        description: snapshot.error,
                    },
                });
                break;
            case 'download':
                this.blobService
                    .downloadFileByDmsId(Number(snapshot.caseDossierReportDmsId || snapshot.dmsId))
                    .pipe(tapResponse((response) => this.blobService.downloadFile(response, `case-report-${snapshot.id}`), (error) => {
                    resolveError(error, this.alertService, 'Error', `Download Snapshot ${snapshot.id} failed!`);
                }))
                    .subscribe();
                break;
            case 'detail':
                this.selectedSnapshotEvent.emit({
                    caseId: link.caseId,
                    snapshotId: snapshot.id,
                    linkId: link.id,
                });
                break;
            case 'refresh':
                this.loadLinks();
                break;
        }
    }
    pick() {
        this.dialog.open(FSWWorldCheckCaseModalComponent, {
            data: {
                information: {
                    resources: this.resources,
                    isReadonly: this.isReadonly,
                    entity: this.entity,
                    key: this.key,
                    linkedCases: this.linksSignal()?.map((link) => link.caseId) ?? [],
                    noCache: this.noCache,
                    noLock: this.noLock,
                },
                events: {
                    selected: (item) => this.selectedCaseEvent.emit(item.caseId),
                    linked: () => this.loadLinks(),
                },
            },
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckDashboardScreenComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckDashboardScreenComponent, isStandalone: true, selector: "fsw-world-check-dashboard-screen", inputs: { resources: "resources", entity: "entity", key: "key", isReadonly: "isReadonly", noCache: "noCache", noLock: "noLock" }, outputs: { newCaseEvent: "newCaseEvent", selectedCaseEvent: "selectedCaseEvent", selectedLinkEvent: "selectedLinkEvent", selectedSnapshotEvent: "selectedSnapshotEvent" }, providers: [
            provideWorldCheckTranslation('world_check_dashboard_screen'),
            provideFSWWorldCheckLinkService(),
            provideFSWWorldCheckSnapshotService(),
            provideFSWWorldCheckAdapterCaseService(),
        ], usesOnChanges: true, ngImport: i0, template: "<section class=\"flex flex-col gap-[16px] py-[16px] w-full\">\n  <header class=\"flex items-center gap-[8px] justify-end\" *ngIf=\"!isReadonly\">\n    <div class=\"w-[200px]\">\n      <fsw-field [fullWidth]=\"true\">\n        <input [formControl]=\"searchControl\" fswInput placeholder=\"Type to search...\" />\n      </fsw-field>\n    </div>\n    <button fswButton [appearance]=\"'secondary'\" (click)=\"pick()\">\n      {{ 'buttons.pick' | fswTranslate }}\n    </button>\n    <button\n      [disabled]=\"!resources?.permission?.allowScreening\"\n      fswButton\n      [appearance]=\"'secondary'\"\n      (click)=\"!!resources?.permission?.allowScreening && newCaseEvent.emit()\"\n    >\n      {{ 'buttons.new' | fswTranslate }}\n    </button>\n  </header>\n  <fsw-world-check-link-table\n    [resources]=\"resources\"\n    [resultsMapping]=\"resultsMappingSignal()\"\n    [isReadonly]=\"isReadonly\"\n    [data]=\"paginatedSignal()\"\n    (actionSnapshotEvent)=\"actionSnapshot($event.item, $event.method)\"\n    (actionEvent)=\"action($event.item, $event.method)\"\n  ></fsw-world-check-link-table>\n  <footer class=\"flex justify-end\">\n    <fsw-pagination\n      [total]=\"filteredSignal().length\"\n      [itemsPerPage]=\"itemsPerPageSignal() ?? filteredSignal().length\"\n      [currentPage]=\"indexSignal()\"\n      (currentPageChange)=\"indexSignal.set($event)\"\n      (itemsPerPageChange)=\"itemsPerPageSignal.set($event ?? filteredSignal().length)\"\n    ></fsw-pagination>\n  </footer>\n</section>\n", dependencies: [{ kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: FSWBlobServiceModule }, { kind: "component", type: FSWWorldCheckLinkTableComponent, selector: "fsw-world-check-link-table", inputs: ["data", "isReadonly", "resources", "resultsMapping"], outputs: ["actionEvent", "actionSnapshotEvent"] }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: FSWAlertModule }, { kind: "ngmodule", type: DialogModule }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: FSWFieldModule }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "ngmodule", type: FSWInputModule }, { kind: "directive", type: i1$4.FSWInputDirective, selector: "input[fswInput], textarea[fswInput]" }, { kind: "ngmodule", type: FSWPaginationModule$1 }, { kind: "component", type: i1$4.FSWPaginationComponent, selector: "fsw-pagination", inputs: ["total", "itemsPerPage", "currentPage", "itemsPerPageOptions", "showSelectOptions", "showViewTotalText", "showNavigationText", "totalTextInside"], outputs: ["currentPageChange", "itemsPerPageChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckDashboardScreenComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-dashboard-screen', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [
                        provideWorldCheckTranslation('world_check_dashboard_screen'),
                        provideFSWWorldCheckLinkService(),
                        provideFSWWorldCheckSnapshotService(),
                        provideFSWWorldCheckAdapterCaseService(),
                    ], imports: [
                        FSWTranslateModule,
                        FSWBlobServiceModule,
                        FSWWorldCheckLinkTableComponent,
                        FSWButtonModule,
                        FSWAlertModule,
                        DialogModule,
                        NgIf,
                        ReactiveFormsModule,
                        FSWFieldModule,
                        FSWInputModule,
                        FSWWorldCheckAssignModalComponent,
                        FSWWorldCheckConfirmModalComponent,
                        FSWWorldCheckErrorModalComponent,
                        FSWWorldCheckReScreeningModalComponent,
                        FSWPaginationModule$1,
                    ], template: "<section class=\"flex flex-col gap-[16px] py-[16px] w-full\">\n  <header class=\"flex items-center gap-[8px] justify-end\" *ngIf=\"!isReadonly\">\n    <div class=\"w-[200px]\">\n      <fsw-field [fullWidth]=\"true\">\n        <input [formControl]=\"searchControl\" fswInput placeholder=\"Type to search...\" />\n      </fsw-field>\n    </div>\n    <button fswButton [appearance]=\"'secondary'\" (click)=\"pick()\">\n      {{ 'buttons.pick' | fswTranslate }}\n    </button>\n    <button\n      [disabled]=\"!resources?.permission?.allowScreening\"\n      fswButton\n      [appearance]=\"'secondary'\"\n      (click)=\"!!resources?.permission?.allowScreening && newCaseEvent.emit()\"\n    >\n      {{ 'buttons.new' | fswTranslate }}\n    </button>\n  </header>\n  <fsw-world-check-link-table\n    [resources]=\"resources\"\n    [resultsMapping]=\"resultsMappingSignal()\"\n    [isReadonly]=\"isReadonly\"\n    [data]=\"paginatedSignal()\"\n    (actionSnapshotEvent)=\"actionSnapshot($event.item, $event.method)\"\n    (actionEvent)=\"action($event.item, $event.method)\"\n  ></fsw-world-check-link-table>\n  <footer class=\"flex justify-end\">\n    <fsw-pagination\n      [total]=\"filteredSignal().length\"\n      [itemsPerPage]=\"itemsPerPageSignal() ?? filteredSignal().length\"\n      [currentPage]=\"indexSignal()\"\n      (currentPageChange)=\"indexSignal.set($event)\"\n      (itemsPerPageChange)=\"itemsPerPageSignal.set($event ?? filteredSignal().length)\"\n    ></fsw-pagination>\n  </footer>\n</section>\n" }]
        }], propDecorators: { newCaseEvent: [{
                type: Output
            }], selectedCaseEvent: [{
                type: Output
            }], selectedLinkEvent: [{
                type: Output
            }], selectedSnapshotEvent: [{
                type: Output
            }], resources: [{
                type: Input,
                args: [{ required: true }]
            }], entity: [{
                type: Input,
                args: [{ required: true }]
            }], key: [{
                type: Input,
                args: [{ required: true }]
            }], isReadonly: [{
                type: Input
            }], noCache: [{
                type: Input
            }], noLock: [{
                type: Input
            }] } });

class FSWWorldCheckCaseScreenComponent {
    constructor() {
        this.saveEvent = new EventEmitter();
        this.deleteEvent = new EventEmitter();
        this.selectedSnapshotEvent = new EventEmitter();
        this.selectedResultEvent = new EventEmitter();
        this.caseId = null;
        this.snapshotId = null;
        this.linkId = null;
        this.isReadonly = false;
        this.noCache = false;
        this.noLock = false;
        this.disableAutoFillFields = false;
        this.automaticFilledCaseFunction = (cb) => {
            cb({});
        };
        this.dataSignal = signal(null);
        this.resultsSignal = signal([]);
        this.activitySignal = signal([]);
        this.snapshotSignal = signal([]);
        this.translations = injectWorldCheckTranslationByCountryCode();
        this.adapterCaseService = injectFSWWorldCheckAdapterCaseService();
        this.activityService = injectFSWWorldCheckActivityService();
        this.snapshotService = injectFSWWorldCheckSnapshotService();
        this.linkService = injectFSWWorldCheckLinkService();
        this.blobService = inject(BLOB_SERVICE_TOKEN);
        this.alertService = inject(FSW_ALERT_SERVICE_TOKEN);
        this.dialog = inject(Dialog);
        this.positions = [
            {
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top',
                offsetY: 4,
            },
            {
                originX: 'start',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'bottom',
            },
        ];
    }
    ngOnChanges(changes) {
        if (changes.noCache || this.noCache || changes.noLock || this.noLock || changes.snapshotId) {
            this.loadCase();
        }
    }
    loadCase() {
        if (!this.caseId) {
            return;
        }
        this.adapterCaseService
            .getByIdAsync(this.caseId, true, this.linkId, this.snapshotId, this.noCache, this.noLock)
            .pipe(tapResponse((data) => {
            this.dataSignal.set(data);
            this.loadResults(false);
            this.loadActivity(false);
            this.loadSnapshot(false);
        }, (error) => {
            resolveError(error, this.alertService, 'Error', `Load Details of Case ${this.caseId} failed!`);
        }))
            .subscribe();
    }
    loadResults(refresh = true) {
        if (!this.caseId) {
            return;
        }
        this.adapterCaseService
            .getResultsByIdAsync(this.caseId, this.linkId, this.snapshotId, this.noCache, this.noLock)
            .pipe(tapResponse((results) => {
            this.resultsSignal.set(results);
            refresh &&
                this.alertService.success('Success', 'Results successfully loaded!', {
                    duration: 3000,
                });
        }, (error) => {
            resolveError(error, this.alertService, 'Error', `Load Results of Case ${this.caseId} failed!`);
        }))
            .subscribe();
    }
    loadActivity(refresh = true) {
        if (!this.caseId) {
            return;
        }
        this.activityService
            .queryAsync({
            caseId: this.caseId,
            ...(this.linkId ? { linkId: this.linkId } : {}),
        }, this.noCache, this.noLock)
            .pipe(tapResponse((activity) => {
            this.activitySignal.set(activity);
            refresh &&
                this.alertService.success('Success', 'Activities successfully loaded!', {
                    duration: 3000,
                });
        }, (error) => {
            resolveError(error, this.alertService, 'Error', `Load Activities of Case ${this.caseId} failed!`);
        }))
            .subscribe();
    }
    loadSnapshot(refresh = true) {
        if (!this.caseId) {
            return;
        }
        this.snapshotService
            .queryAsync({
            queryCaseId: {
                caseId: this.caseId,
            },
            queryLinkId: this.linkId ? { linkId: this.linkId } : {},
            queryId: this.snapshotId ? { id: this.snapshotId } : {},
        }, this.noCache, this.noLock)
            .pipe(tapResponse((snapshot) => {
            this.snapshotSignal.set(snapshot);
            refresh &&
                this.alertService.success('Success', 'Snapshots successfully loaded!', {
                    duration: 3000,
                });
        }, (error) => {
            resolveError(error, this.alertService, 'Error', `Load Snapshots of Case ${this.caseId} failed!`);
        }))
            .subscribe();
    }
    actionSnapshot(snapshot, method) {
        switch (method) {
            case 'delete':
                this.dialog
                    .open(FSWWorldCheckConfirmModalComponent, {
                    data: this.translations.modals.delete,
                })
                    .closed.pipe(take(1), filter((accept) => !!accept), switchMap(() => this.snapshotService
                    .deleteAsync(snapshot.id, this.caseId, this.linkId)
                    .pipe(tapResponse(() => {
                    this.alertService.success('Success', 'Delete snapshot data successfully!', {
                        duration: 3000,
                    });
                    if (this.snapshotId === snapshot.id) {
                        this.deleteEvent.emit();
                    }
                    else {
                        this.loadSnapshot();
                    }
                }, (error) => {
                    console.error(error);
                    resolveError(error, this.alertService, 'Error', 'Delete snapshot data failed!');
                }))))
                    .subscribe();
                break;
            case 're_trigger':
                this.snapshotService
                    .reTriggerAsync(snapshot.id, this.caseId, this.linkId)
                    .pipe(tapResponse(() => {
                    this.loadSnapshot();
                    this.alertService.success('Success', 'Re-Trigger snapshot data successfully!', {
                        duration: 3000,
                    });
                }, (error) => {
                    console.error(error);
                    resolveError(error, this.alertService, 'Error', 'Re-Trigger snapshot data failed!');
                }))
                    .subscribe();
                break;
            case 'view_error':
                this.dialog.open(FSWWorldCheckErrorModalComponent, {
                    data: {
                        title: `View Error`,
                        description: snapshot.error,
                    },
                });
                break;
            case 'download':
                this.blobService
                    .downloadFileByDmsId(Number(snapshot.caseDossierReportDmsId ||
                    snapshot.dmsId))
                    .pipe(tapResponse((response) => this.blobService.downloadFile(response, `case-report-${snapshot.id}`), (error) => {
                    resolveError(error, this.alertService, 'Error', `Download Snapshot ${snapshot.id} failed!`);
                }))
                    .subscribe();
                break;
            case 'detail':
                this.selectedSnapshotEvent.emit(snapshot.id);
                break;
            case 'trigger':
                this.snapshotService
                    .triggerAsync(this.caseId, this.linkId)
                    .pipe(tapResponse(() => {
                    this.loadSnapshot();
                    this.alertService.success('Success', 'Trigger snapshot data successfully!', {
                        duration: 3000,
                    });
                }, (error) => {
                    console.error(error);
                    resolveError(error, this.alertService, 'Error', 'Trigger snapshot data failed!');
                }))
                    .subscribe();
                break;
            case 'refresh':
                this.loadSnapshot();
                break;
        }
    }
    actionResult(results, method) {
        switch (method) {
            case 'resolution':
                this.dialog
                    .open(FSWWorldCheckResolutionModalComponent, {
                    data: {
                        resources: this.resources,
                        results,
                    },
                })
                    .closed.pipe(take(1), filter((data) => !!data), switchMap((data) => {
                    return this.adapterCaseService
                        .resolutionAsync(this.caseId, {
                        ...data,
                        results,
                    }, this.linkId, this.snapshotId)
                        .pipe(tapResponse(() => {
                        this.alertService.success('Success', 'Resolution successfully!', {
                            duration: 3000,
                        });
                        this.loadResults();
                    }, (error) => resolveError(error, this.alertService, 'Error', 'Resolution failed!')));
                }))
                    .subscribe();
                break;
            case 'review':
                this.dialog
                    .open(FSWWorldCheckReviewModalComponent, {
                    data: results,
                })
                    .closed.pipe(take(1), filter((data) => !!data), switchMap((remark) => {
                    return this.adapterCaseService
                        .reviewAsync(this.caseId, {
                        remark: remark,
                        results,
                    }, this.linkId, this.snapshotId)
                        .pipe(tapResponse(() => {
                        this.alertService.success('Success', 'Review successfully!', {
                            duration: 3000,
                        });
                        this.loadResults();
                    }, (error) => resolveError(error, this.alertService, 'Error', 'Review failed!')));
                }))
                    .subscribe();
                break;
            case 'refresh':
                this.loadResults();
                break;
            case 'detail':
                this.selectedResultEvent.emit(results[0].resultId);
                break;
        }
    }
    action(item, method) {
        switch (method) {
            case 're_screening':
                this.dialog
                    .open(FSWWorldCheckReScreeningModalComponent, {
                    data: this.resources?.enums?.screening_modes,
                })
                    .closed.pipe(take(1), filter((data) => !!data), switchMap((data) => this.adapterCaseService
                    .reScreenAsync(item.caseId, data, this.linkId, this.snapshotId)
                    .pipe(tapResponse(() => {
                    this.alertService.success('Success', 'Re-Screening successfully!', {
                        duration: 3000,
                    });
                    this.loadCase();
                }, (error) => {
                    console.error(error);
                    resolveError(error, this.alertService, 'Error', 'Re-Screening failed!');
                }))))
                    .subscribe();
                break;
            case 'assign':
                this.dialog
                    .open(FSWWorldCheckAssignModalComponent, {
                    data: this.resources.users,
                })
                    .closed.pipe(take(1), filter((accept) => !!accept), switchMap((data) => this.adapterCaseService
                    .assignAsync(item.caseId, data, this.linkId, this.snapshotId)
                    .pipe(tapResponse(() => {
                    this.alertService.success('Success', 'Assign successfully!', {
                        duration: 3000,
                    });
                    this.loadCase();
                }, (error) => {
                    console.error(error);
                    resolveError(error, this.alertService, 'Error', 'Assign failed!');
                }))))
                    .subscribe();
                break;
            case 'un_assign':
                this.dialog
                    .open(FSWWorldCheckConfirmModalComponent, {
                    data: this.translations.modals['un_assign'],
                })
                    .closed.pipe(take(1), filter((data) => !!data), switchMap(() => this.adapterCaseService.unAssignAsync(item.caseId, this.linkId, this.snapshotId).pipe(tapResponse(() => {
                    this.alertService.success('Success', 'Un-Assign successfully!', {
                        duration: 3000,
                    });
                    this.loadCase();
                }, (error) => {
                    console.error(error);
                    resolveError(error, this.alertService, 'Error', 'Un-Assign failed!');
                }))))
                    .subscribe();
                break;
            case 'archive':
                this.dialog
                    .open(FSWWorldCheckConfirmModalComponent, {
                    data: this.translations.modals['archive'],
                })
                    .closed.pipe(take(1), filter((accept) => !!accept), switchMap(() => this.adapterCaseService.archiveAsync(item.caseId, this.linkId, this.snapshotId).pipe(tapResponse(() => {
                    this.alertService.success('Success', 'Archive successfully!', {
                        duration: 3000,
                    });
                    this.loadCase();
                }, (error) => {
                    console.error(error);
                    resolveError(error, this.alertService, 'Error', 'Archive failed!');
                }))))
                    .subscribe();
                break;
            case 'un_archive':
                this.dialog
                    .open(FSWWorldCheckConfirmModalComponent, {
                    data: this.translations.modals['un_archive'],
                })
                    .closed.pipe(take(1), filter((accept) => !!accept), switchMap(() => this.adapterCaseService
                    .unArchiveAsync(item.caseId, this.linkId, this.snapshotId)
                    .pipe(tapResponse(() => {
                    this.alertService.success('Success', 'Un-archive successfully!', {
                        duration: 3000,
                    });
                    this.loadCase();
                }, (error) => {
                    console.error(error);
                    resolveError(error, this.alertService, 'Error', 'Un-archive failed!');
                }))))
                    .subscribe();
                break;
            case 'trigger':
                this.snapshotService
                    .triggerAsync(item.caseId, this.linkId)
                    .pipe(tapResponse(() => {
                    this.loadCase();
                    this.alertService.success('Success', 'Trigger snapshot data successfully!', {
                        duration: 3000,
                    });
                }, (error) => {
                    console.error(error);
                    resolveError(error, this.alertService, 'Error', 'Trigger snapshot data failed!');
                }))
                    .subscribe();
                break;
            case 'un_link':
                this.dialog
                    .open(FSWWorldCheckConfirmModalComponent, {
                    data: this.translations.modals.delete,
                })
                    .closed.pipe(take(1), filter((accept) => !!accept), switchMap(() => this.linkService.deleteAsync(this.entity, this.key, item.caseId).pipe(tapResponse(() => {
                    this.deleteEvent.emit();
                    this.alertService.success('Success', 'Delete link data successfully!', {
                        duration: 3000,
                    });
                }, (error) => {
                    console.error(error);
                    resolveError(error, this.alertService, 'Error', 'Delete link data failed!');
                }))))
                    .subscribe();
                break;
        }
    }
    toActionLabel(item) {
        return [
            're_screening',
            'un_link',
            ...[item.state === FSWWorldCheckLifecycleStates.ARCHIVED ? 'un_archive' : 'archive'],
        ];
    }
    toActionTitle(method) {
        if (['un_link'].includes(method)) {
            return `buttons.${method}`;
        }
        return `modals.${method}.title`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckCaseScreenComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckCaseScreenComponent, isStandalone: true, selector: "fsw-world-check-case-screen", inputs: { resources: "resources", entity: "entity", key: "key", caseId: "caseId", snapshotId: "snapshotId", linkId: "linkId", isReadonly: "isReadonly", noCache: "noCache", noLock: "noLock", disableAutoFillFields: "disableAutoFillFields", automaticFilledCaseFunction: "automaticFilledCaseFunction" }, outputs: { saveEvent: "saveEvent", deleteEvent: "deleteEvent", selectedSnapshotEvent: "selectedSnapshotEvent", selectedResultEvent: "selectedResultEvent" }, providers: [
            provideWorldCheckTranslation('world_check_case_screen'),
            provideFSWWorldCheckAdapterCaseService(),
            provideFSWWorldCheckActivityService(),
            provideFSWWorldCheckSnapshotService(),
            provideFSWWorldCheckLinkService(),
        ], usesOnChanges: true, ngImport: i0, template: "<section class=\"flex flex-col gap-[16px] py-[16px] w-full\">\n  <fsw-world-check-case-form\n    [resources]=\"resources\"\n    [data]=\"dataSignal()\"\n    [key]=\"key\"\n    [entity]=\"entity\"\n    [isReadonly]=\"isReadonly\"\n    [snapshotId]=\"snapshotId\"\n    [automaticFilledCaseFunction]=\"automaticFilledCaseFunction\"\n    (saveEvent)=\"saveEvent.emit()\"\n    [disableAutoFillFields]=\"disableAutoFillFields\"\n  >\n    <div snapshot *ngIf=\"snapshotId && dataSignal()\">\n      <ng-container *ngTemplateOutlet=\"snapshotsTemplate\"></ng-container>\n    </div>\n    <div menu *ngIf=\"!isReadonly && !snapshotId\">\n      <ng-container *ngTemplateOutlet=\"menuTemplate\"></ng-container>\n    </div>\n  </fsw-world-check-case-form>\n  <ng-container *ngIf=\"dataSignal() as data\">\n    <fsw-world-check-supplement-form\n      [data]=\"data\"\n      [isReadonly]=\"isReadonly\"\n      [linkId]=\"linkId\"\n      [snapshotId]=\"snapshotId\"\n      (saveEvent)=\"saveEvent.emit()\"\n    ></fsw-world-check-supplement-form>\n    <fsw-world-check-result-table\n      [data]=\"resultsSignal()\"\n      [case]=\"data\"\n      [isReadonly]=\"isReadonly || !!snapshotId\"\n      [resources]=\"resources\"\n      [snapshotId]=\"snapshotId\"\n      (actionEvent)=\"actionResult($event.results, $event.method)\"\n    ></fsw-world-check-result-table>\n    <ng-container *ngIf=\"!snapshotId\">\n      <ng-container *ngTemplateOutlet=\"snapshotsTemplate\"></ng-container>\n    </ng-container>\n    <fsw-world-check-activity-table\n      *ngIf=\"!snapshotId\"\n      [data]=\"activitySignal()\"\n      (refreshEvent)=\"loadActivity()\"\n    ></fsw-world-check-activity-table>\n  </ng-container>\n</section>\n\n<ng-template #snapshotsTemplate>\n  <fsw-world-check-snapshot-table\n    [isReadonly]=\"isReadonly\"\n    [snapshotId]=\"snapshotId\"\n    (actionEvent)=\"actionSnapshot($event.item, $event.method)\"\n    [data]=\"snapshotSignal()\"\n  ></fsw-world-check-snapshot-table>\n</ng-template>\n\n<ng-template #menuTemplate>\n  <ng-container *ngIf=\"dataSignal() as data\">\n    <button\n      fswButton\n      #dropdown=\"fswDropdown\"\n      [appearance]=\"'icon-with-bg'\"\n      [size]=\"'s'\"\n      fswDropdown\n      [cdkMenuTriggerFor]=\"menuTemplate\"\n      [cdkMenuPosition]=\"positions\"\n    >\n      <i [fswIcon]=\"'common-more'\"></i>\n    </button>\n    <ng-template #menuTemplate>\n      <ol class=\"fsw-select__container !w-[160px]\">\n        <ng-container *ngFor=\"let label of toActionLabel(data)\">\n          <li class=\"fsw-select__item\" (click)=\"dropdown.close(true); action(data, label)\">\n            <article class=\"fsw-select__item__template !py-[12px]\">\n              <main>\n                <span class=\"fsw-select__item__text fsw-select__item__text--m\">\n                  {{ toActionTitle(label) | fswTranslate : { scope: 'world_check_case_screen' } }}\n                </span>\n              </main>\n            </article>\n          </li>\n        </ng-container>\n      </ol>\n    </ng-template>\n  </ng-container>\n</ng-template>\n", dependencies: [{ kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "component", type: FSWWorldCheckCaseFormComponent, selector: "fsw-world-check-case-form", inputs: ["resources", "data", "isReadonly", "entity", "key", "snapshotId", "linkId", "disableAutoFillFields", "automaticFilledCaseFunction"], outputs: ["saveEvent"] }, { kind: "component", type: FSWWorldCheckSupplementFormComponent, selector: "fsw-world-check-supplement-form", inputs: ["data", "isReadonly", "linkId", "snapshotId"], outputs: ["saveEvent"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FSWWorldCheckResultTableComponent, selector: "fsw-world-check-result-table", inputs: ["data", "case", "resources", "isReadonly", "snapshotId"], outputs: ["actionEvent"] }, { kind: "component", type: FSWWorldCheckActivityTableComponent, selector: "fsw-world-check-activity-table", inputs: ["data"], outputs: ["refreshEvent"] }, { kind: "component", type: FSWWorldCheckSnapshotTableComponent, selector: "fsw-world-check-snapshot-table", inputs: ["data", "isReadonly", "snapshotId"], outputs: ["actionEvent"] }, { kind: "ngmodule", type: FSWAlertModule }, { kind: "ngmodule", type: DialogModule }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: FSWBlobServiceModule }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "ngmodule", type: FSWTagsModule }, { kind: "ngmodule", type: FSWDropdownModule }, { kind: "directive", type: i1$4.FSWDropdownDirective, selector: "[cdkMenuTriggerFor][fswDropdown]", inputs: ["fixedWidth", "allowBackDropClick", "offsetY", "offsetX", "event", "conditional"], exportAs: ["fswDropdown"] }, { kind: "directive", type: CdkMenuTrigger, selector: "[cdkMenuTriggerFor]", inputs: ["cdkMenuTriggerFor", "cdkMenuPosition", "cdkMenuTriggerData"], outputs: ["cdkMenuOpened", "cdkMenuClosed"], exportAs: ["cdkMenuTriggerFor"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckCaseScreenComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-case-screen', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [
                        provideWorldCheckTranslation('world_check_case_screen'),
                        provideFSWWorldCheckAdapterCaseService(),
                        provideFSWWorldCheckActivityService(),
                        provideFSWWorldCheckSnapshotService(),
                        provideFSWWorldCheckLinkService(),
                    ], imports: [
                        FSWTranslateModule,
                        FSWWorldCheckCaseFormComponent,
                        FSWWorldCheckSupplementFormComponent,
                        NgIf,
                        FSWWorldCheckResultTableComponent,
                        FSWWorldCheckActivityTableComponent,
                        FSWWorldCheckSnapshotTableComponent,
                        FSWWorldCheckConfirmModalComponent,
                        FSWWorldCheckErrorModalComponent,
                        FSWWorldCheckResolutionModalComponent,
                        FSWWorldCheckReviewModalComponent,
                        FSWWorldCheckAssignModalComponent,
                        FSWWorldCheckReScreeningModalComponent,
                        FSWAlertModule,
                        DialogModule,
                        FSWButtonModule,
                        FSWBlobServiceModule,
                        FSWIconModule,
                        NgForOf,
                        NgTemplateOutlet,
                        FSWTagsModule,
                        FSWDropdownModule,
                        CdkMenuTrigger,
                    ], template: "<section class=\"flex flex-col gap-[16px] py-[16px] w-full\">\n  <fsw-world-check-case-form\n    [resources]=\"resources\"\n    [data]=\"dataSignal()\"\n    [key]=\"key\"\n    [entity]=\"entity\"\n    [isReadonly]=\"isReadonly\"\n    [snapshotId]=\"snapshotId\"\n    [automaticFilledCaseFunction]=\"automaticFilledCaseFunction\"\n    (saveEvent)=\"saveEvent.emit()\"\n    [disableAutoFillFields]=\"disableAutoFillFields\"\n  >\n    <div snapshot *ngIf=\"snapshotId && dataSignal()\">\n      <ng-container *ngTemplateOutlet=\"snapshotsTemplate\"></ng-container>\n    </div>\n    <div menu *ngIf=\"!isReadonly && !snapshotId\">\n      <ng-container *ngTemplateOutlet=\"menuTemplate\"></ng-container>\n    </div>\n  </fsw-world-check-case-form>\n  <ng-container *ngIf=\"dataSignal() as data\">\n    <fsw-world-check-supplement-form\n      [data]=\"data\"\n      [isReadonly]=\"isReadonly\"\n      [linkId]=\"linkId\"\n      [snapshotId]=\"snapshotId\"\n      (saveEvent)=\"saveEvent.emit()\"\n    ></fsw-world-check-supplement-form>\n    <fsw-world-check-result-table\n      [data]=\"resultsSignal()\"\n      [case]=\"data\"\n      [isReadonly]=\"isReadonly || !!snapshotId\"\n      [resources]=\"resources\"\n      [snapshotId]=\"snapshotId\"\n      (actionEvent)=\"actionResult($event.results, $event.method)\"\n    ></fsw-world-check-result-table>\n    <ng-container *ngIf=\"!snapshotId\">\n      <ng-container *ngTemplateOutlet=\"snapshotsTemplate\"></ng-container>\n    </ng-container>\n    <fsw-world-check-activity-table\n      *ngIf=\"!snapshotId\"\n      [data]=\"activitySignal()\"\n      (refreshEvent)=\"loadActivity()\"\n    ></fsw-world-check-activity-table>\n  </ng-container>\n</section>\n\n<ng-template #snapshotsTemplate>\n  <fsw-world-check-snapshot-table\n    [isReadonly]=\"isReadonly\"\n    [snapshotId]=\"snapshotId\"\n    (actionEvent)=\"actionSnapshot($event.item, $event.method)\"\n    [data]=\"snapshotSignal()\"\n  ></fsw-world-check-snapshot-table>\n</ng-template>\n\n<ng-template #menuTemplate>\n  <ng-container *ngIf=\"dataSignal() as data\">\n    <button\n      fswButton\n      #dropdown=\"fswDropdown\"\n      [appearance]=\"'icon-with-bg'\"\n      [size]=\"'s'\"\n      fswDropdown\n      [cdkMenuTriggerFor]=\"menuTemplate\"\n      [cdkMenuPosition]=\"positions\"\n    >\n      <i [fswIcon]=\"'common-more'\"></i>\n    </button>\n    <ng-template #menuTemplate>\n      <ol class=\"fsw-select__container !w-[160px]\">\n        <ng-container *ngFor=\"let label of toActionLabel(data)\">\n          <li class=\"fsw-select__item\" (click)=\"dropdown.close(true); action(data, label)\">\n            <article class=\"fsw-select__item__template !py-[12px]\">\n              <main>\n                <span class=\"fsw-select__item__text fsw-select__item__text--m\">\n                  {{ toActionTitle(label) | fswTranslate : { scope: 'world_check_case_screen' } }}\n                </span>\n              </main>\n            </article>\n          </li>\n        </ng-container>\n      </ol>\n    </ng-template>\n  </ng-container>\n</ng-template>\n" }]
        }], propDecorators: { saveEvent: [{
                type: Output
            }], deleteEvent: [{
                type: Output
            }], selectedSnapshotEvent: [{
                type: Output
            }], selectedResultEvent: [{
                type: Output
            }], resources: [{
                type: Input,
                args: [{ required: true }]
            }], entity: [{
                type: Input,
                args: [{ required: true }]
            }], key: [{
                type: Input,
                args: [{ required: true }]
            }], caseId: [{
                type: Input
            }], snapshotId: [{
                type: Input
            }], linkId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], noCache: [{
                type: Input
            }], noLock: [{
                type: Input
            }], disableAutoFillFields: [{
                type: Input
            }], automaticFilledCaseFunction: [{
                type: Input
            }] } });

class FSWWorldCheckResultScreenComponent {
    constructor() {
        this.resultId = null;
        this.caseId = null;
        this.linkId = null;
        this.snapshotId = null;
        this.noCache = false;
        this.noLock = false;
        this.resultSignal = signal(null);
        this.translations = injectWorldCheckTranslationByCountryCode();
        this.isReadonly$ = new BehaviorSubject(false);
        this.adapterCaseService = injectFSWWorldCheckAdapterCaseService();
        this.form = new UntypedFormGroup({});
        this.dialog = inject(Dialog);
        this.alertService = inject(FSW_ALERT_SERVICE_TOKEN);
        this.builder = new FSWDynamicBuilder({
            form: this.form,
            formType: FSWDynamicBuilderFormTypes.GROUP,
            customClasses: 'w-full flex gap-[16px]',
            readonlyWhen$: this.isReadonly$,
            fields: [
                {
                    key: 'resultId',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-[calc(50%-8px)]',
                    context: {
                        fullWidth: true,
                        label: this.translations.tables['result'].result_id,
                        isDisabled: true,
                    },
                },
                {
                    key: 'referenceId',
                    type: FSWDynamicBuilderControlTypes.INPUT,
                    customClasses: 'w-[calc(50%-8px)]',
                    context: {
                        fullWidth: true,
                        label: this.translations.tables['result'].reference_id,
                        isDisabled: true,
                    },
                },
            ],
        });
    }
    set isReadonly(value) {
        this.isReadonly$.next(value);
    }
    ngOnChanges(changes) {
        if (changes.noCache || this.noCache || changes.noLock || this.noLock) {
            this.loadResult();
        }
    }
    loadResult() {
        if (!this.resultId || !this.caseId) {
            return;
        }
        this.adapterCaseService
            .getResultRecordAsync(this.caseId, this.resultId, this.linkId, this.snapshotId, this.noCache, this.noLock)
            .pipe(tapResponse((result) => {
            this.form.patchValue({
                resultId: result.resultId,
                referenceId: result.referenceId,
            });
            this.resultSignal.set(result);
        }, (error) => resolveError(error, this.alertService, 'Error', 'Load Result record failed!')))
            .subscribe();
    }
    action(method) {
        const results = [
            {
                resultId: this.resultSignal().resultId,
                name: this.resultSignal().keyData.name,
                resolution: this.resultSignal().summary.resolution,
                referenceId: this.resultSignal().referenceId,
            },
        ];
        switch (method) {
            case 'resolution':
                this.dialog
                    .open(FSWWorldCheckResolutionModalComponent, {
                    data: {
                        resources: this.resources,
                        results,
                    },
                })
                    .closed.pipe(take(1), filter((data) => !!data), switchMap((data) => {
                    return this.adapterCaseService
                        .resolutionAsync(this.caseId, {
                        ...data,
                        results,
                    }, this.linkId, this.snapshotId)
                        .pipe(tapResponse(() => {
                        this.alertService.success('Success', 'Resolution successfully!', {
                            duration: 3000,
                        });
                        this.loadResult();
                    }, (error) => resolveError(error, this.alertService, 'Error', 'Resolution failed!')));
                }))
                    .subscribe();
                break;
            case 'review':
                this.dialog
                    .open(FSWWorldCheckReviewModalComponent, {
                    data: results,
                })
                    .closed.pipe(take(1), filter((data) => !!data), switchMap((remark) => {
                    return this.adapterCaseService
                        .reviewAsync(this.caseId, {
                        remark: remark,
                        results,
                    }, this.linkId, this.snapshotId)
                        .pipe(tapResponse(() => {
                        this.alertService.success('Success', 'Review successfully!', {
                            duration: 3000,
                        });
                        this.loadResult();
                    }, (error) => resolveError(error, this.alertService, 'Error', 'Review failed!')));
                }))
                    .subscribe();
                break;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckResultScreenComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWWorldCheckResultScreenComponent, isStandalone: true, selector: "fsw-world-check-result-screen", inputs: { resources: "resources", resultId: "resultId", caseId: "caseId", linkId: "linkId", snapshotId: "snapshotId", isReadonly: "isReadonly", noCache: "noCache", noLock: "noLock" }, providers: [
            provideWorldCheckTranslation('world_check_result_screen'),
            provideFSWWorldCheckAdapterCaseService(),
        ], usesOnChanges: true, ngImport: i0, template: "<fsw-panel\n  *ngIf=\"resultSignal() as result\"\n  [title]=\"'titles.result_detail_screen' | fswTranslate : { scope: 'world_check_result_screen' }\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <section class=\"flex items-center gap-[8px]\" *ngIf=\"!(isReadonly$ | async) && !snapshotId\">\n      <button\n        [disabled]=\"!resources?.permission?.allowResolve\"\n        fswButton\n        [appearance]=\"'secondary'\"\n        (click)=\"!!resources?.permission?.allowResolve && action('resolution')\"\n      >\n        {{ 'buttons.resolution' | fswTranslate : { scope: 'world_check_result_screen' } }}\n      </button>\n      <button fswButton [appearance]=\"'secondary'\" (click)=\"action('review')\">\n        {{ 'buttons.review' | fswTranslate : { scope: 'world_check_result_screen' } }}\n      </button>\n    </section>\n  </ng-template>\n  <section class=\"w-full flex flex-col gap-[16px]\">\n    <form [formGroup]=\"form\">\n      <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n    </form>\n\n    <section class=\"w-full rounded-[16px] border border-solid border-gray-200 p-4 relative\">\n      <div class=\"absolute w-full left-0 top-[66px] border border-solid border-gray-200\"></div>\n      <fsw-tabs-group [customRowGap]=\"'24px'\">\n        <ng-template\n          fswTabs\n          [key]=\"'summary'\"\n          [maxTextWidth]=\"'unset'\"\n          [label]=\"\n            'containers.summary.title' | fswTranslate : { scope: 'world_check_result_screen' }\n          \"\n        >\n          <fsw-world-check-summary-container\n            class=\"flex pt-[8px]\"\n            *ngIf=\"result.summary as summary\"\n            [data]=\"summary\"\n          ></fsw-world-check-summary-container>\n        </ng-template>\n        <ng-template\n          fswTabs\n          [key]=\"'key_data'\"\n          [maxTextWidth]=\"'unset'\"\n          [label]=\"\n            'containers.key_data.title' | fswTranslate : { scope: 'world_check_result_screen' }\n          \"\n        >\n          <fsw-world-check-key-data-container\n            class=\"flex pt-[8px]\"\n            *ngIf=\"result.keyData as keyData\"\n            [data]=\"keyData\"\n          ></fsw-world-check-key-data-container>\n        </ng-template>\n        <ng-template\n          fswTabs\n          [key]=\"'information'\"\n          [maxTextWidth]=\"'unset'\"\n          [label]=\"\n            'containers.information.title' | fswTranslate : { scope: 'world_check_result_screen' }\n          \"\n        >\n          <fsw-world-check-information-container\n            class=\"flex pt-[8px]\"\n            *ngIf=\"result.information as information\"\n            [data]=\"information\"\n          ></fsw-world-check-information-container>\n        </ng-template>\n        <ng-template\n          fswTabs\n          [key]=\"'source'\"\n          [maxTextWidth]=\"'unset'\"\n          [label]=\"\n            'containers.source.title' | fswTranslate : { scope: 'world_check_result_screen' }\n          \"\n        >\n          <fsw-world-check-source-table\n            class=\"flex pt-[8px]\"\n            *ngIf=\"result.sources as sources\"\n            [data]=\"sources\"\n          ></fsw-world-check-source-table>\n        </ng-template>\n      </fsw-tabs-group>\n    </section>\n  </section>\n</fsw-panel>\n", dependencies: [{ kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FSWDynamicBuilderModule }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: FSWTabsModule }, { kind: "component", type: i1$4.FSWTabsGroupComponent, selector: "fsw-tabs-group" }, { kind: "directive", type: i1$4.FSWTabsDirective, selector: "ng-template[fswTabs]" }, { kind: "component", type: FSWWorldCheckSummaryContainerComponent, selector: "fsw-world-check-summary-container", inputs: ["data"] }, { kind: "component", type: FSWWorldCheckKeyDataContainerComponent, selector: "fsw-world-check-key-data-container", inputs: ["data"] }, { kind: "component", type: FSWWorldCheckInformationContainerComponent, selector: "fsw-world-check-information-container", inputs: ["data"] }, { kind: "component", type: FSWWorldCheckSourceTableComponent, selector: "fsw-world-check-source-table", inputs: ["data"] }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: FSWIconModule }, { kind: "ngmodule", type: FSWAlertModule }, { kind: "ngmodule", type: DialogModule }, { kind: "pipe", type: AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWWorldCheckResultScreenComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-world-check-result-screen', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, providers: [
                        provideWorldCheckTranslation('world_check_result_screen'),
                        provideFSWWorldCheckAdapterCaseService(),
                    ], imports: [
                        FSWTranslateModule,
                        FSWPanelModule,
                        NgIf,
                        FSWDynamicBuilderModule,
                        FormsModule,
                        ReactiveFormsModule,
                        FSWTabsModule,
                        FSWWorldCheckSummaryContainerComponent,
                        FSWWorldCheckKeyDataContainerComponent,
                        FSWWorldCheckInformationContainerComponent,
                        FSWWorldCheckSourceTableComponent,
                        FSWWorldCheckResolutionModalComponent,
                        FSWWorldCheckReviewModalComponent,
                        FSWButtonModule,
                        FSWIconModule,
                        FSWAlertModule,
                        DialogModule,
                        AsyncPipe,
                    ], template: "<fsw-panel\n  *ngIf=\"resultSignal() as result\"\n  [title]=\"'titles.result_detail_screen' | fswTranslate : { scope: 'world_check_result_screen' }\"\n>\n  <ng-template fswPanelHeaderSuffix>\n    <section class=\"flex items-center gap-[8px]\" *ngIf=\"!(isReadonly$ | async) && !snapshotId\">\n      <button\n        [disabled]=\"!resources?.permission?.allowResolve\"\n        fswButton\n        [appearance]=\"'secondary'\"\n        (click)=\"!!resources?.permission?.allowResolve && action('resolution')\"\n      >\n        {{ 'buttons.resolution' | fswTranslate : { scope: 'world_check_result_screen' } }}\n      </button>\n      <button fswButton [appearance]=\"'secondary'\" (click)=\"action('review')\">\n        {{ 'buttons.review' | fswTranslate : { scope: 'world_check_result_screen' } }}\n      </button>\n    </section>\n  </ng-template>\n  <section class=\"w-full flex flex-col gap-[16px]\">\n    <form [formGroup]=\"form\">\n      <fsw-dynamic-builder [builder]=\"builder\"></fsw-dynamic-builder>\n    </form>\n\n    <section class=\"w-full rounded-[16px] border border-solid border-gray-200 p-4 relative\">\n      <div class=\"absolute w-full left-0 top-[66px] border border-solid border-gray-200\"></div>\n      <fsw-tabs-group [customRowGap]=\"'24px'\">\n        <ng-template\n          fswTabs\n          [key]=\"'summary'\"\n          [maxTextWidth]=\"'unset'\"\n          [label]=\"\n            'containers.summary.title' | fswTranslate : { scope: 'world_check_result_screen' }\n          \"\n        >\n          <fsw-world-check-summary-container\n            class=\"flex pt-[8px]\"\n            *ngIf=\"result.summary as summary\"\n            [data]=\"summary\"\n          ></fsw-world-check-summary-container>\n        </ng-template>\n        <ng-template\n          fswTabs\n          [key]=\"'key_data'\"\n          [maxTextWidth]=\"'unset'\"\n          [label]=\"\n            'containers.key_data.title' | fswTranslate : { scope: 'world_check_result_screen' }\n          \"\n        >\n          <fsw-world-check-key-data-container\n            class=\"flex pt-[8px]\"\n            *ngIf=\"result.keyData as keyData\"\n            [data]=\"keyData\"\n          ></fsw-world-check-key-data-container>\n        </ng-template>\n        <ng-template\n          fswTabs\n          [key]=\"'information'\"\n          [maxTextWidth]=\"'unset'\"\n          [label]=\"\n            'containers.information.title' | fswTranslate : { scope: 'world_check_result_screen' }\n          \"\n        >\n          <fsw-world-check-information-container\n            class=\"flex pt-[8px]\"\n            *ngIf=\"result.information as information\"\n            [data]=\"information\"\n          ></fsw-world-check-information-container>\n        </ng-template>\n        <ng-template\n          fswTabs\n          [key]=\"'source'\"\n          [maxTextWidth]=\"'unset'\"\n          [label]=\"\n            'containers.source.title' | fswTranslate : { scope: 'world_check_result_screen' }\n          \"\n        >\n          <fsw-world-check-source-table\n            class=\"flex pt-[8px]\"\n            *ngIf=\"result.sources as sources\"\n            [data]=\"sources\"\n          ></fsw-world-check-source-table>\n        </ng-template>\n      </fsw-tabs-group>\n    </section>\n  </section>\n</fsw-panel>\n" }]
        }], propDecorators: { resources: [{
                type: Input,
                args: [{ required: true }]
            }], resultId: [{
                type: Input,
                args: [{ required: true }]
            }], caseId: [{
                type: Input,
                args: [{ required: true }]
            }], linkId: [{
                type: Input
            }], snapshotId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], noCache: [{
                type: Input
            }], noLock: [{
                type: Input
            }] } });

var texts = {
	history: {
		latest: "Last Questnet Bureau Report request: {{date}}",
		empty: "Generate borrower profile quickly by generating information from Questnet Bureau Reports."
	},
	uen: "Use the UEN or NRIC to connect to Questnet Bureau.",
	bip: "Business Interest Party"
};
var forms$1 = {
	bip: {
		name: "BIP",
		id_number: "ID Number",
		designation: "Designation",
		percentage: "Shareholder Percentage",
		primary_borrower: "Primary Borrower",
		recourse_party: "Recourse Party"
	},
	add: {
		uen: "UEN/NRIC"
	}
};
var buttons$3 = {
	pull: "Pull Questnet",
	pull_many: "Pull Many",
	download: "Download Document",
	view_bips: "View BIPs",
	add_bip: "Add BIP",
	cancel: "Cancel"
};
var questnetPullAll = {
	texts: texts,
	forms: forms$1,
	buttons: buttons$3
};

var ALL$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$3,
    default: questnetPullAll,
    forms: forms$1,
    texts: texts
});

const QUESTNET_PULL_ALL_TRANSLATION = ALL$2;

const injectQuestnetPullAllEffects = ({ signals, events, }) => {
    const applicationMemberService = injectApplicationMemberService();
    const memberService = injectMemberService();
    const questnetService = injectQuestnetService();
    const alertService = inject(FSW_ALERT_SERVICE_TOKEN);
    //#region Variables
    const internalSignals = {
        member: signal(null),
        history: signal(null),
    };
    //#endregion
    //#region Load Functions
    const loadMember = (applicationId, cb) => {
        const member = internalSignals.member();
        if (member) {
            cb?.(member);
            return;
        }
        applicationMemberService
            .getApplicationMainBorrower(applicationId)
            .pipe(tap((member) => {
            if (member) {
                internalSignals.member.set(member);
                cb?.(member);
            }
            else {
                throw new Error('Member is not found');
            }
        }), catchError((err) => {
            alertService.error('Error', 'Failed to load member', {
                duration: 3000,
            });
            return throwError(() => err);
        }))
            .subscribe();
    };
    const loadHistory = () => {
        const member = internalSignals.member();
        if (!member) {
            return;
        }
        questnetService
            .fetchHistory(questnetService.buildParams({
            entityNo: member.company_registration_number,
        }))
            .pipe(tap((histories) => {
            const preparedHistories = (histories || [])
                .filter((history) => !history.deletedAt)
                .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
            internalSignals.history.set(preparedHistories.shift() || null);
        }))
            .subscribe();
    };
    //#endregion
    //#region Logics Functions
    const download = (reportId) => {
        questnetService
            .downloadReport(reportId)
            .pipe(tap((blobParts) => {
            const blob = new Blob([blobParts], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
        }))
            .subscribe();
    };
    const pull = (params, cb) => {
        questnetService
            .pull(questnetService.buildParams(params))
            .pipe(tap((history) => {
            if (!history.reportId) {
                alertService.error('Error', 'Their is no report for this BIP', {
                    duration: 3000,
                });
            }
        }), filter((history) => !!history.reportId), switchMap((history) => questnetService.fetchReport(history.reportId).pipe(map((report) => ({
            idNumber: params.entityNo,
            ...questnetService.transformReportToBip(report),
            fromReportId: history.reportId,
        })), tap((bip) => cb?.(bip)))))
            .subscribe();
    };
    //#endregion
    //#region Request Functions
    const getReportBips = (cb) => {
        const member = internalSignals.member();
        if (!member) {
            return;
        }
        const bipMap = new Map();
        pull({
            entityNo: member.company_registration_number,
            memberUUID: member.uuid,
        }, (history) => {
            forkJoin([
                questnetService.getBips(history.fromReportId),
                memberService.getBips(member.company_registration_number).pipe(switchMap((bips) => {
                    bips.forEach((bip) => bipMap.set(bip.idNumber, bip));
                    const filteredBips = bips.filter((bip) => bip.sourceReportId && bip.sourceReportId !== history.fromReportId);
                    return forkJoin(filteredBips.map((bip) => questnetService.fetchReport(bip.sourceReportId).pipe(map((report) => ({
                        ...bip,
                        ...questnetService.transformReportToBip(report),
                        fromReportId: bip.sourceReportId,
                    })))));
                })),
            ])
                .pipe(tap(([questnetBips, memberBips]) => {
                [...questnetBips, ...memberBips].forEach((bip) => {
                    const existed = bipMap.get(bip.idNumber);
                    bipMap.set(bip.idNumber, {
                        ...bip,
                        ...(existed || {}),
                    });
                });
                cb?.(Array.from(bipMap.values()));
            }))
                .subscribe();
        });
    };
    //#endregion
    effect(() => {
        const applicationId = signals.applicationId();
        if (!applicationId) {
            return;
        }
        untracked(() => loadMember(applicationId));
    }, { allowSignalWrites: true });
    effect(() => loadHistory(), { allowSignalWrites: true });
    return {
        signals: {
            member: internalSignals.member.asReadonly(),
            history: internalSignals.history.asReadonly(),
        },
        requests: {
            download: (reportId) => {
                if (reportId) {
                    download(reportId);
                    return;
                }
                const member = internalSignals.member();
                if (!member) {
                    return;
                }
                pull({
                    entityNo: member.company_registration_number,
                }, (bip) => download(bip.fromReportId));
            },
        },
        actions: {
            pullMany: (params, bips, cb) => {
                questnetService
                    .pullMany(params.map((param) => questnetService.buildParams(param)))
                    .pipe(tap((reports) => {
                    cb?.(reports);
                    events.pullMany.emit();
                }), switchMap(() => memberService.updateBips(internalSignals.member()?.company_registration_number, bips)))
                    .subscribe();
            },
            pull: (cbOrParams, cb) => {
                if (typeof cbOrParams === 'function') {
                    getReportBips(cbOrParams);
                    return;
                }
                pull(cbOrParams, cb);
            },
        },
        transformers: {
            toFormArray: (bips, formArray = new UntypedFormArray([])) => {
                const totalShares = sumBy(bips, (bip) => +bip.shares ?? 0);
                bips.forEach((bip) => {
                    const percentage = bip.shares && totalShares ? (((+bip.shares ?? 0) / totalShares) * 100).toFixed(2) : '0';
                    const existing = formArray.value.findIndex((item) => item['entityNo'] === bip.idNumber);
                    if (existing > -1) {
                        const group = formArray.controls[existing];
                        group.get('percentage')?.setValue(percentage);
                        return;
                    }
                    formArray.push(new UntypedFormGroup({
                        entityName: new UntypedFormControl(bip.name),
                        entityNo: new UntypedFormControl(bip.idNumber),
                        id: new UntypedFormControl(bip.id),
                        designation: new UntypedFormControl(bip.designation),
                        percentage: new UntypedFormControl(percentage),
                        isPrimaryBorrower: new UntypedFormControl(!!bip.isPrimaryBorrower),
                        isRecourseParty: new UntypedFormControl(!!bip.isRecourseParty),
                    }));
                });
                return formArray;
            },
        },
    };
};

function provideExternalPullTranslation(scope = 'questnet_pull') {
    return [
        ...(FSWTranslateModule.forFeature({
            scope,
            defaultKey: getCountryCodeFromStorage() ?? CountryCode.SG,
            data: {
                [CountryCode.MY]: QUESTNET_PULL_ALL_TRANSLATION,
                [CountryCode.SG]: QUESTNET_PULL_ALL_TRANSLATION,
                [CountryCode.VU]: QUESTNET_PULL_ALL_TRANSLATION,
                [CountryCode.ID]: QUESTNET_PULL_ALL_TRANSLATION,
                [CountryCode.TH]: QUESTNET_PULL_ALL_TRANSLATION,
            },
        }).providers || []),
        fswTranslateScope(scope),
    ];
}

const injectQuestnetPullEffects = (config) => {
    switch (getCountryCodeFromStorage()) {
        default:
            return injectQuestnetPullAllEffects(config);
    }
};

class FSWQuestnetPullAddBipDialogComponent {
    constructor() {
        this.dialogRef = inject((DialogRef));
        this.alertService = inject(FSW_ALERT_SERVICE_TOKEN);
        this.data = this.dialogRef.config.data;
        this.formControl = new UntypedFormControl('');
    }
    add() {
        if (!this.formControl.value) {
            return;
        }
        this.data.effects.actions.pull({
            entityNo: this.formControl.value,
        }, (bip) => {
            const existingBip = this.data.bips.find((item) => item.id === bip.id);
            if (existingBip) {
                this.alertService.error('Error', 'Duplicate BIP NRIC or Passport', {
                    duration: 3000,
                });
                return;
            }
            this.dialogRef.close(bip);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWQuestnetPullAddBipDialogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWQuestnetPullAddBipDialogComponent, isStandalone: true, selector: "fsw-questnet-pull-add-bip-dialog", providers: [provideExternalPullTranslation('questnet_pull_add_bip_dialog')], ngImport: i0, template: `
    <fsw-modal
      [size]="'s'"
      [title]="'texts.bip' | fswTranslate : { scope: 'questnet_pull_add_bip_dialog' }"
      [confirmButton]="'buttons.add_bip' | fswTranslate : { scope: 'questnet_pull_add_bip_dialog' }"
      [confirmButtonDisabled]="formControl.invalid"
      [cancelButton]="'buttons.cancel' | fswTranslate : { scope: 'questnet_pull_add_bip_dialog' }"
      (confirmEvent)="add()"
      (cancelEvent)="dialogRef.close()"
      (closeEvent)="dialogRef.close()"
    >
      <ng-template fswModalBody>
        <section>
          <p class="text-body-caption-600 text-gray-700">
            {{ 'texts.uen' | fswTranslate : { scope: 'questnet_pull_add_bip_dialog' } }}
          </p>
          <fsw-field [fullWidth]="true">
            <ng-template
              fswFieldHeaderPrefix
              [label]="'forms.add.uen' | fswTranslate : { scope: 'questnet_pull_add_bip_dialog' }"
            ></ng-template>
            <input fswInput type="text" [formControl]="formControl" />
          </fsw-field>
        </section>
      </ng-template>
    </fsw-modal>
  `, isInline: true, dependencies: [{ kind: "ngmodule", type: FSWModalModule$1 }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: FSWAlertModule }, { kind: "ngmodule", type: FSWFieldModule }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$4.FSWFieldHeaderPrefixDirective, selector: "ng-template[fswFieldHeaderPrefix]", inputs: ["kind", "label", "required"] }, { kind: "ngmodule", type: FSWInputModule }, { kind: "directive", type: i1$4.FSWInputDirective, selector: "input[fswInput], textarea[fswInput]" }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWQuestnetPullAddBipDialogComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-questnet-pull-add-bip-dialog',
                    template: `
    <fsw-modal
      [size]="'s'"
      [title]="'texts.bip' | fswTranslate : { scope: 'questnet_pull_add_bip_dialog' }"
      [confirmButton]="'buttons.add_bip' | fswTranslate : { scope: 'questnet_pull_add_bip_dialog' }"
      [confirmButtonDisabled]="formControl.invalid"
      [cancelButton]="'buttons.cancel' | fswTranslate : { scope: 'questnet_pull_add_bip_dialog' }"
      (confirmEvent)="add()"
      (cancelEvent)="dialogRef.close()"
      (closeEvent)="dialogRef.close()"
    >
      <ng-template fswModalBody>
        <section>
          <p class="text-body-caption-600 text-gray-700">
            {{ 'texts.uen' | fswTranslate : { scope: 'questnet_pull_add_bip_dialog' } }}
          </p>
          <fsw-field [fullWidth]="true">
            <ng-template
              fswFieldHeaderPrefix
              [label]="'forms.add.uen' | fswTranslate : { scope: 'questnet_pull_add_bip_dialog' }"
            ></ng-template>
            <input fswInput type="text" [formControl]="formControl" />
          </fsw-field>
        </section>
      </ng-template>
    </fsw-modal>
  `,
                    standalone: true,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [provideExternalPullTranslation('questnet_pull_add_bip_dialog')],
                    imports: [
                        FSWModalModule$1,
                        FSWTranslateModule,
                        FSWAlertModule,
                        FSWFieldModule,
                        FSWInputModule,
                        ReactiveFormsModule,
                    ],
                }]
        }] });

class FSWQuestnetPullBipsTableComponent {
    constructor() {
        this.controls = [];
        this.primaryBorrowerSignal = signal(null);
    }
    ngOnInit() {
        this.data.formArray.value.forEach((group) => {
            if (group.isPrimaryBorrower) {
                this.primaryBorrowerSignal.set(group.entityNo);
            }
        });
    }
    setPrimaryBorrower(id) {
        if (this.data.signals.isReadonly()) {
            return;
        }
        this.primaryBorrowerSignal.set(id);
        this.data.formArray.controls.forEach((group) => {
            group.patchValue({
                ...group.value,
                isPrimaryBorrower: group.value.entityNo === id,
            });
        });
    }
    setRecourseParty(group) {
        if (this.data.signals.isReadonly()) {
            return;
        }
        group.patchValue({
            ...group.value,
            isRecourseParty: !group.value.isRecourseParty,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWQuestnetPullBipsTableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWQuestnetPullBipsTableComponent, isStandalone: true, selector: "fsw-questnet-pull-bips-table", inputs: { data: "data", controls: "controls" }, providers: [provideExternalPullTranslation('questnet_pull_bips_table')], ngImport: i0, template: `
    <table class="fsw-table !table-auto w-full fsw-table--bordered">
      <thead>
        <tr>
          <th class="align-middle">
            {{ 'forms.bip.name' | fswTranslate : { scope: 'questnet_pull_bips_table' } }}
          </th>
          <th class="align-middle">
            {{ 'forms.bip.id_number' | fswTranslate : { scope: 'questnet_pull_bips_table' } }}
          </th>
          <th class="align-middle">
            {{ 'forms.bip.designation' | fswTranslate : { scope: 'questnet_pull_bips_table' } }}
          </th>
          <th class="align-middle">
            {{ 'forms.bip.percentage' | fswTranslate : { scope: 'questnet_pull_bips_table' } }}
          </th>
          <th class="align-middle">
            {{
              'forms.bip.primary_borrower' | fswTranslate : { scope: 'questnet_pull_bips_table' }
            }}
          </th>
          <th class="align-middle">
            {{ 'forms.bip.recourse_party' | fswTranslate : { scope: 'questnet_pull_bips_table' } }}
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let group of controls">
          <tr *ngIf="group | fswForceGroup as formGroup">
            <td class="align-middle">
              {{ formGroup.value['entityName'] ?? '--' }}
            </td>
            <td class="align-middle">
              {{ formGroup.value['entityNo'] ?? '--' }}
            </td>
            <td class="align-middle">
              {{ formGroup.value['designation'] ?? '--' }}
            </td>
            <td class="align-middle">
              {{ formGroup.value['percentage'] ? formGroup.value['percentage'] + '%' : '--' }}
            </td>
            <td class="align-middle">
              <span (click)="setPrimaryBorrower(formGroup.value['entityNo'])">
                <fsw-radio
                  [groupValue]="primaryBorrowerSignal()"
                  [disabled]="data.signals.isReadonly()"
                  [value]="formGroup.value['entityNo']"
                />
              </span>
            </td>
            <td class="align-middle">
              <span (click)="setRecourseParty(formGroup)">
                <fsw-checkbox
                  [forceChecked]="formGroup.value['isRecourseParty']"
                  [disabled]="data.signals.isReadonly()"
                />
              </span>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  `, isInline: true, styles: ["fsw-questnet-pull-bips-table .fsw-checkbox>label{visibility:hidden}fsw-questnet-pull-bips-table .fsw-radio>label{visibility:hidden}\n"], dependencies: [{ kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "ngmodule", type: ForceGroupPipeModule }, { kind: "pipe", type: i1$4.FSWForceGroupPipe, name: "fswForceGroup" }, { kind: "ngmodule", type: FSWRadioModule }, { kind: "component", type: i1$4.FSWRadioComponent, selector: "fsw-radio" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FSWCheckboxModule }, { kind: "component", type: i1$4.FSWCheckboxComponent, selector: "fsw-checkbox" }, { kind: "ngmodule", type: FSWButtonModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWQuestnetPullBipsTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-questnet-pull-bips-table', template: `
    <table class="fsw-table !table-auto w-full fsw-table--bordered">
      <thead>
        <tr>
          <th class="align-middle">
            {{ 'forms.bip.name' | fswTranslate : { scope: 'questnet_pull_bips_table' } }}
          </th>
          <th class="align-middle">
            {{ 'forms.bip.id_number' | fswTranslate : { scope: 'questnet_pull_bips_table' } }}
          </th>
          <th class="align-middle">
            {{ 'forms.bip.designation' | fswTranslate : { scope: 'questnet_pull_bips_table' } }}
          </th>
          <th class="align-middle">
            {{ 'forms.bip.percentage' | fswTranslate : { scope: 'questnet_pull_bips_table' } }}
          </th>
          <th class="align-middle">
            {{
              'forms.bip.primary_borrower' | fswTranslate : { scope: 'questnet_pull_bips_table' }
            }}
          </th>
          <th class="align-middle">
            {{ 'forms.bip.recourse_party' | fswTranslate : { scope: 'questnet_pull_bips_table' } }}
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let group of controls">
          <tr *ngIf="group | fswForceGroup as formGroup">
            <td class="align-middle">
              {{ formGroup.value['entityName'] ?? '--' }}
            </td>
            <td class="align-middle">
              {{ formGroup.value['entityNo'] ?? '--' }}
            </td>
            <td class="align-middle">
              {{ formGroup.value['designation'] ?? '--' }}
            </td>
            <td class="align-middle">
              {{ formGroup.value['percentage'] ? formGroup.value['percentage'] + '%' : '--' }}
            </td>
            <td class="align-middle">
              <span (click)="setPrimaryBorrower(formGroup.value['entityNo'])">
                <fsw-radio
                  [groupValue]="primaryBorrowerSignal()"
                  [disabled]="data.signals.isReadonly()"
                  [value]="formGroup.value['entityNo']"
                />
              </span>
            </td>
            <td class="align-middle">
              <span (click)="setRecourseParty(formGroup)">
                <fsw-checkbox
                  [forceChecked]="formGroup.value['isRecourseParty']"
                  [disabled]="data.signals.isReadonly()"
                />
              </span>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  `, standalone: true, changeDetection: ChangeDetectionStrategy.OnPush, providers: [provideExternalPullTranslation('questnet_pull_bips_table')], imports: [
                        FSWTranslateModule,
                        NgForOf,
                        ReactiveFormsModule,
                        ForceGroupPipeModule,
                        FSWRadioModule,
                        NgIf,
                        FSWCheckboxModule,
                        FSWButtonModule,
                    ], encapsulation: ViewEncapsulation.None, styles: ["fsw-questnet-pull-bips-table .fsw-checkbox>label{visibility:hidden}fsw-questnet-pull-bips-table .fsw-radio>label{visibility:hidden}\n"] }]
        }], propDecorators: { data: [{
                type: Input
            }], controls: [{
                type: Input
            }] } });

class FSWQuestnetPullBipsDialogComponent {
    constructor() {
        this.dialogRef = inject((DialogRef));
        this.alertService = inject(FSW_ALERT_SERVICE_TOKEN);
        this.dialog = inject(Dialog);
        this.data = this.dialogRef.config.data;
        this.bips = this.data.bips;
        this.controlsSignal = signal(...[this.data.formArray.controls]);
    }
    get invalid() {
        if (this.data.formArray.length === 0) {
            return true;
        }
        return !this.data.formArray.controls.some((control) => control.value['isPrimaryBorrower']);
    }
    pull() {
        if (this.invalid) {
            this.alertService.error('Invalid', 'Please select primary borrower!', {
                duration: 3000,
            });
            return;
        }
        const params = this.data.formArray.value.filter((item) => item.isRecourseParty || item.isPrimaryBorrower);
        const filteredBips = this.bips
            .map((bip) => omit({
            ...bip,
            ...pick(params.find((param) => param.entityNo === bip.idNumber) || {}, ['isPrimaryBorrower', 'isRecourseParty']),
        }, ['sourceCompanyIdNumber']))
            .filter((bip) => bip.isRecourseParty || bip.isPrimaryBorrower);
        this.data.effects.actions.pullMany(params.map((item) => pick(item, ['entityNo', 'entityName'])), filteredBips, () => {
            this.alertService.success('Success', 'Pull BIPs successfully!', {
                duration: 2000,
            });
            this.dialogRef.close();
        });
    }
    add() {
        this.dialog
            .open(FSWQuestnetPullAddBipDialogComponent, {
            data: this.data,
        })
            .closed.pipe(take(1), filter((result) => !!result), tap((bip) => {
            this.bips.push(bip);
            const controls = this.data.effects.transformers.toFormArray(this.bips, this.data.formArray).controls;
            this.controlsSignal.set([...controls]);
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWQuestnetPullBipsDialogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWQuestnetPullBipsDialogComponent, isStandalone: true, selector: "fsw-questnet-pull-bips-dialog", providers: [provideExternalPullTranslation('questnet_pull_bips_dialog')], ngImport: i0, template: `
    <fsw-modal
      [size]="'l'"
      [title]="'texts.bip' | fswTranslate : { scope: 'questnet_pull_bips_dialog' }"
      (closeEvent)="dialogRef.close()"
    >
      <ng-template fswModalBody>
        <section class="flex flex-col w-full gap-[12px] overflow-y-auto max-h-[70vh]">
          <header class="flex w-full justify-end">
            <button fswButton [appearance]="'secondary-elevate'" (click)="add()">
              {{ 'buttons.add_bip' | fswTranslate : { scope: 'questnet_pull_bips_dialog' } }}
            </button>
          </header>
          <main class="w-full overflow-x-auto">
            <fsw-questnet-pull-bips-table [data]="data" [controls]="controlsSignal()" />
          </main>
          <footer class="flex w-full justify-end">
            <button fswButton [disabled]="invalid" (click)="pull()">
              {{ 'buttons.pull' | fswTranslate : { scope: 'questnet_pull_bips_dialog' } }}
            </button>
          </footer>
        </section>
      </ng-template>
    </fsw-modal>
  `, isInline: true, dependencies: [{ kind: "ngmodule", type: FSWModalModule$1 }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: FSWAlertModule }, { kind: "ngmodule", type: DialogModule }, { kind: "component", type: FSWQuestnetPullBipsTableComponent, selector: "fsw-questnet-pull-bips-table", inputs: ["data", "controls"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWQuestnetPullBipsDialogComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-questnet-pull-bips-dialog',
                    template: `
    <fsw-modal
      [size]="'l'"
      [title]="'texts.bip' | fswTranslate : { scope: 'questnet_pull_bips_dialog' }"
      (closeEvent)="dialogRef.close()"
    >
      <ng-template fswModalBody>
        <section class="flex flex-col w-full gap-[12px] overflow-y-auto max-h-[70vh]">
          <header class="flex w-full justify-end">
            <button fswButton [appearance]="'secondary-elevate'" (click)="add()">
              {{ 'buttons.add_bip' | fswTranslate : { scope: 'questnet_pull_bips_dialog' } }}
            </button>
          </header>
          <main class="w-full overflow-x-auto">
            <fsw-questnet-pull-bips-table [data]="data" [controls]="controlsSignal()" />
          </main>
          <footer class="flex w-full justify-end">
            <button fswButton [disabled]="invalid" (click)="pull()">
              {{ 'buttons.pull' | fswTranslate : { scope: 'questnet_pull_bips_dialog' } }}
            </button>
          </footer>
        </section>
      </ng-template>
    </fsw-modal>
  `,
                    standalone: true,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [provideExternalPullTranslation('questnet_pull_bips_dialog')],
                    imports: [
                        FSWModalModule$1,
                        FSWTranslateModule,
                        FSWButtonModule,
                        FSWAlertModule,
                        NgIf,
                        DialogModule,
                        FSWQuestnetPullAddBipDialogComponent,
                        FSWQuestnetPullBipsTableComponent,
                    ],
                }]
        }] });

class FSWQuestnetPullComponent {
    constructor() {
        this.pullEvent = new EventEmitter();
        this.pullManyEvent = new EventEmitter();
        this.stage = 'FULL';
        this.dialog = inject(Dialog);
        this.signals = {
            applicationId: signal(''),
            isReadonly: signal(false),
        };
        this.effects = injectQuestnetPullEffects({
            signals: {
                applicationId: this.signals.applicationId.asReadonly(),
                isReadonly: this.signals.isReadonly.asReadonly(),
            },
            events: {
                pull: this.pullEvent,
                pullMany: this.pullManyEvent,
            },
        });
        this.computedSignals = {
            history: {
                text: computed(() => this.effects.signals.history() ? 'texts.history.latest' : 'texts.history.empty'),
                date: computed(() => this.effects.signals.history()?.createdAt),
            },
        };
    }
    set applicationId(value) {
        this.signals.applicationId.set(value);
    }
    set isReadonly(value) {
        this.signals.isReadonly.set(value);
    }
    pullMany() {
        this.effects.actions.pull((bips) => {
            this.pullEvent.emit();
            this.dialog
                .open(FSWQuestnetPullBipsDialogComponent, {
                data: {
                    effects: this.effects,
                    signals: {
                        applicationId: this.signals.applicationId.asReadonly(),
                        isReadonly: this.signals.isReadonly.asReadonly(),
                    },
                    formArray: this.effects.transformers.toFormArray(bips),
                    bips,
                },
            })
                .closed.pipe(take(1))
                .subscribe();
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWQuestnetPullComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWQuestnetPullComponent, isStandalone: true, selector: "fsw-questnet-pull", inputs: { applicationId: "applicationId", isReadonly: "isReadonly", stage: "stage" }, outputs: { pullEvent: "pullEvent", pullManyEvent: "pullManyEvent" }, providers: [
            provideExternalPullTranslation(),
            provideUtilsService(),
            provideApplicationMemberService(),
            provideMemberService(),
            provideQuestnetService(),
        ], ngImport: i0, template: `
    <ng-container *ngIf="stage === 'FULL'; else manyTemplate">
      <article class="flex flex-col gap-[12px] w-full">
        <main class="flex gap-[12px] w-full items-center">
          <span class="text-body-caption-600 font-bold text-gray-700">
            {{
              computedSignals.history.text()
                | fswTranslate
                  : {
                      scope: 'questnet_pull',
                      data: {
                        date: (computedSignals.history.date() | date : 'dd/MM/yyyy') || '--'
                      }
                    }
            }}
          </span>
        </main>
        <footer class="flex gap-[12px] w-full">
          <button fswButton (click)="pullMany()" *ngIf="!signals.isReadonly()">
            {{ 'buttons.pull' | fswTranslate : { scope: 'questnet_pull' } }}
          </button>
          <button
            *ngIf="!!computedSignals.history.date()"
            fswButton
            (click)="effects.requests.download()"
          >
            {{ 'buttons.download' | fswTranslate : { scope: 'questnet_pull' } }}
          </button>
        </footer>
      </article>
    </ng-container>
    <ng-template #manyTemplate>
      <button fswButton (click)="pullMany()" *ngIf="!signals.isReadonly()">
        {{ 'buttons.pull_many' | fswTranslate : { scope: 'questnet_pull' } }}
      </button>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "ngmodule", type: FSWAlertModule }, { kind: "ngmodule", type: DialogModule }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: DatePipe, name: "date" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWQuestnetPullComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-questnet-pull',
                    template: `
    <ng-container *ngIf="stage === 'FULL'; else manyTemplate">
      <article class="flex flex-col gap-[12px] w-full">
        <main class="flex gap-[12px] w-full items-center">
          <span class="text-body-caption-600 font-bold text-gray-700">
            {{
              computedSignals.history.text()
                | fswTranslate
                  : {
                      scope: 'questnet_pull',
                      data: {
                        date: (computedSignals.history.date() | date : 'dd/MM/yyyy') || '--'
                      }
                    }
            }}
          </span>
        </main>
        <footer class="flex gap-[12px] w-full">
          <button fswButton (click)="pullMany()" *ngIf="!signals.isReadonly()">
            {{ 'buttons.pull' | fswTranslate : { scope: 'questnet_pull' } }}
          </button>
          <button
            *ngIf="!!computedSignals.history.date()"
            fswButton
            (click)="effects.requests.download()"
          >
            {{ 'buttons.download' | fswTranslate : { scope: 'questnet_pull' } }}
          </button>
        </footer>
      </article>
    </ng-container>
    <ng-template #manyTemplate>
      <button fswButton (click)="pullMany()" *ngIf="!signals.isReadonly()">
        {{ 'buttons.pull_many' | fswTranslate : { scope: 'questnet_pull' } }}
      </button>
    </ng-template>
  `,
                    standalone: true,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [
                        provideExternalPullTranslation(),
                        provideUtilsService(),
                        provideApplicationMemberService(),
                        provideMemberService(),
                        provideQuestnetService(),
                    ],
                    imports: [
                        FSWQuestnetPullBipsDialogComponent,
                        FSWAlertModule,
                        DialogModule,
                        FSWTranslateModule,
                        FSWButtonModule,
                        NgIf,
                        DatePipe,
                    ],
                }]
        }], propDecorators: { pullEvent: [{
                type: Output
            }], pullManyEvent: [{
                type: Output
            }], applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], stage: [{
                type: Input
            }] } });

var title$2 = "Import Application";
var buttons$2 = {
	yes: "Yes",
	no: "No",
	validate: "Validate",
	"import": "Import",
	imported: "Imported",
	retry: "Retry",
	confirm: "Confirm"
};
var modules = {
	borrowers: "Borrowers Data",
	borrower_summary: "Borrower Summary",
	borrower_documents: "Borrower Documents",
	proposals: "Loan Proposals",
	bips: "BIPs",
	bip_documents: "BIP Documents",
	pg_cg_summary: "CG & PG Summary"
};
var fields = {
	"import": "Would you like to import data from another application?",
	application_number: "Application Number to import data from",
	name: "Application Name",
	product_group_identifier: "Product Group Identifier",
	member_username: "Borrower Username",
	member_name: "Borrower Name",
	product: "Product",
	created_by: "Created By",
	status: "Status"
};
var warning = {
	title: "Warning",
	description: "Once data is imported, the system cannot revert it. Ensure you are importing the data from correct application"
};
var applicationImportAll = {
	title: title$2,
	buttons: buttons$2,
	modules: modules,
	fields: fields,
	warning: warning
};

var ALL$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$2,
    default: applicationImportAll,
    fields: fields,
    modules: modules,
    title: title$2,
    warning: warning
});

const APPLICATION_IMPORT_ALL_TRANSLATION = ALL$1;

const injectApplicationImportALLEffects = () => {
    const applicationService = injectApplicationService();
    const applicationProposalService = injectApplicationProposalService();
    return {
        searchApplications: (number) => {
            return applicationService
                .searchApplications({
                number,
                include: 'MAIN',
                status: 'IN_PROGRESS',
                limit: 10,
                page: 1,
            })
                .pipe(map((res) => res?.applications?.shift()), switchMap((application) => {
                if (!application) {
                    return of(null);
                }
                return applicationProposalService
                    .getProposals(application.id, {
                    include: 'MEMBER,PRODUCT',
                    sort: 'name,DESC',
                    page: 1,
                    limit: 10,
                })
                    .pipe(map((proposals) => ({
                    ...application,
                    product: proposals?.[0]?.product?.product_upi,
                })));
            }));
        },
        importApplication: (params) => {
            return applicationService.importApplication(params);
        },
    };
};

function provideApplicationImportTranslation(scope = 'application_import') {
    return [
        ...(FSWTranslateModule.forFeature({
            scope,
            defaultKey: getCountryCodeFromStorage() ?? CountryCode.MY,
            data: {
                [CountryCode.MY]: APPLICATION_IMPORT_ALL_TRANSLATION,
                [CountryCode.TH]: APPLICATION_IMPORT_ALL_TRANSLATION,
                [CountryCode.VU]: APPLICATION_IMPORT_ALL_TRANSLATION,
                [CountryCode.ID]: APPLICATION_IMPORT_ALL_TRANSLATION,
                [CountryCode.ZI]: APPLICATION_IMPORT_ALL_TRANSLATION,
                [CountryCode.SG]: APPLICATION_IMPORT_ALL_TRANSLATION,
                [CountryCode.ZU]: APPLICATION_IMPORT_ALL_TRANSLATION,
                [CountryCode.ZV]: APPLICATION_IMPORT_ALL_TRANSLATION,
                [CountryCode.VN]: APPLICATION_IMPORT_ALL_TRANSLATION,
            },
        }).providers || []),
        fswTranslateScope(scope),
    ];
}

const injectApplicationImportEffects = () => {
    switch (getCountryCodeFromStorage()) {
        default:
            return injectApplicationImportALLEffects();
    }
};

class FSWApplicationImportModuleComponent {
    constructor() {
        this.importedEvent = new EventEmitter();
        this.destinationApplicationId = '';
        this.application = {};
        this.module = '';
        this.alertService = inject(FSW_ALERT_SERVICE_TOKEN);
        this.effects = injectApplicationImportEffects();
        this.progressSignal = signal({
            status: 'NOT_STARTED',
        });
        this.menuPositions = [
            {
                originX: 'end',
                originY: 'bottom',
                overlayX: 'end',
                overlayY: 'top',
                offsetY: 8,
            },
            {
                originX: 'end',
                originY: 'top',
                overlayX: 'end',
                overlayY: 'bottom',
            },
        ];
    }
    get translation() {
        return `modules.${this.module}`;
    }
    import() {
        this.effects
            .importApplication({
            destination_application_id: this.destinationApplicationId,
            source_application_id: this.application.id,
            module: this.module,
        })
            .pipe(tapResponse((res) => {
            switch (res.type) {
                case HttpEventType.UploadProgress: {
                    const progress = res.total ? Math.round((100 * res.loaded) / res.total) : 0;
                    this.progressSignal.set({
                        status: 'IN_PROGRESS',
                        data: progress > 99 ? 99 : progress,
                    });
                    break;
                }
                case HttpEventType.Response:
                    this.progressSignal.set({
                        status: 'SUCCESS',
                    });
                    this.importedEvent.emit();
                    break;
                default:
                    this.progressSignal.set({
                        status: 'IN_PROGRESS',
                        data: 0,
                    });
                    break;
            }
        }, (exception) => {
            this.progressSignal.set({
                status: 'NOT_STARTED',
                data: exception.error.errors.map((e) => e.message).join(', '),
            });
        }))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWApplicationImportModuleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWApplicationImportModuleComponent, isStandalone: true, selector: "fsw-application-import-module", inputs: { destinationApplicationId: "destinationApplicationId", application: "application", module: "module" }, outputs: { importedEvent: "importedEvent" }, providers: [
            provideUtilsService(),
            provideApplicationService(),
            provideApplicationImportTranslation('application_import_module'),
        ], ngImport: i0, template: "<div class=\"flex items-center justify-between gap-[8px] w-[400px] h-[40px]\">\n  <span class=\"text-gray-600 font-bold text-body-caption-500\">{{\n    translation | fswTranslate : { scope: 'application_import_module' }\n  }}</span>\n  <ng-container [ngSwitch]=\"progressSignal().status\">\n    <ng-container *ngSwitchCase=\"'IN_PROGRESS'\">\n      <span class=\"text-blue-500 font-bold text-body-caption-600\">\n        {{ progressSignal().data }}%\n      </span>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'SUCCESS'\">\n      <span class=\"text-green-500 font-bold text-body-caption-600\">\n        {{ 'buttons.imported' | fswTranslate : { scope: 'application_import_module' } }}\n      </span>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'ERROR'\">\n      <button fswButton [appearance]=\"'secondary-elevate'\" [size]=\"'s'\" (click)=\"import()\">\n        {{ 'buttons.import' | fswTranslate : { scope: 'application_import_module' } }}\n      </button>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'NOT_STARTED'\">\n      <div class=\"flex items-center gap-[12px]\">\n        <button fswButton [appearance]=\"'secondary-elevate'\" [size]=\"'s'\" (click)=\"import()\">\n          {{\n            (progressSignal().data ? 'buttons.retry' : 'buttons.import')\n              | fswTranslate : { scope: 'application_import_module' }\n          }}\n        </button>\n        <ng-container *ngIf=\"progressSignal().data as error\">\n          <i\n            [cdkMenuTriggerFor]=\"errorTemplate\"\n            [cdkMenuPosition]=\"menuPositions\"\n            fswDropdown\n            fswIcon=\"status-error\"\n            class=\"!text-red-500\"\n            [fontSize]=\"'16px'\"\n          ></i>\n          <ng-template #errorTemplate>\n            <fsw-alert\n              [hiddenFooter]=\"true\"\n              [status]=\"'error'\"\n              [title]=\"'Error'\"\n              [hiddenCloseButton]=\"true\"\n            >\n              <ng-template fswAlertBody>\n                <p>{{ error }}</p>\n              </ng-template>\n            </fsw-alert>\n          </ng-template>\n        </ng-container>\n      </div>\n    </ng-container>\n  </ng-container>\n</div>\n", dependencies: [{ kind: "ngmodule", type: FSWAlertModule }, { kind: "component", type: i1$4.FSWAlertComponent, selector: "fsw-alert", inputs: ["title", "confirmButton", "cancelButton", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "status", "size"], outputs: ["closeClick", "confirmClick", "cancelClick", "opened", "closed"] }, { kind: "directive", type: i1$4.FSWAlertBodyDirective, selector: "ng-template[fswAlertBody]" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: CdkMenuTrigger, selector: "[cdkMenuTriggerFor]", inputs: ["cdkMenuTriggerFor", "cdkMenuPosition", "cdkMenuTriggerData"], outputs: ["cdkMenuOpened", "cdkMenuClosed"], exportAs: ["cdkMenuTriggerFor"] }, { kind: "ngmodule", type: FSWDropdownModule }, { kind: "directive", type: i1$4.FSWDropdownDirective, selector: "[cdkMenuTriggerFor][fswDropdown]", inputs: ["fixedWidth", "allowBackDropClick", "offsetY", "offsetX", "event", "conditional"], exportAs: ["fswDropdown"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWApplicationImportModuleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-application-import-module', standalone: true, imports: [
                        FSWAlertModule,
                        FSWTranslateModule,
                        FSWButtonModule,
                        NgSwitch,
                        NgSwitchCase,
                        FSWIconModule,
                        NgIf,
                        CdkMenuTrigger,
                        FSWDropdownModule,
                    ], providers: [
                        provideUtilsService(),
                        provideApplicationService(),
                        provideApplicationImportTranslation('application_import_module'),
                    ], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"flex items-center justify-between gap-[8px] w-[400px] h-[40px]\">\n  <span class=\"text-gray-600 font-bold text-body-caption-500\">{{\n    translation | fswTranslate : { scope: 'application_import_module' }\n  }}</span>\n  <ng-container [ngSwitch]=\"progressSignal().status\">\n    <ng-container *ngSwitchCase=\"'IN_PROGRESS'\">\n      <span class=\"text-blue-500 font-bold text-body-caption-600\">\n        {{ progressSignal().data }}%\n      </span>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'SUCCESS'\">\n      <span class=\"text-green-500 font-bold text-body-caption-600\">\n        {{ 'buttons.imported' | fswTranslate : { scope: 'application_import_module' } }}\n      </span>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'ERROR'\">\n      <button fswButton [appearance]=\"'secondary-elevate'\" [size]=\"'s'\" (click)=\"import()\">\n        {{ 'buttons.import' | fswTranslate : { scope: 'application_import_module' } }}\n      </button>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'NOT_STARTED'\">\n      <div class=\"flex items-center gap-[12px]\">\n        <button fswButton [appearance]=\"'secondary-elevate'\" [size]=\"'s'\" (click)=\"import()\">\n          {{\n            (progressSignal().data ? 'buttons.retry' : 'buttons.import')\n              | fswTranslate : { scope: 'application_import_module' }\n          }}\n        </button>\n        <ng-container *ngIf=\"progressSignal().data as error\">\n          <i\n            [cdkMenuTriggerFor]=\"errorTemplate\"\n            [cdkMenuPosition]=\"menuPositions\"\n            fswDropdown\n            fswIcon=\"status-error\"\n            class=\"!text-red-500\"\n            [fontSize]=\"'16px'\"\n          ></i>\n          <ng-template #errorTemplate>\n            <fsw-alert\n              [hiddenFooter]=\"true\"\n              [status]=\"'error'\"\n              [title]=\"'Error'\"\n              [hiddenCloseButton]=\"true\"\n            >\n              <ng-template fswAlertBody>\n                <p>{{ error }}</p>\n              </ng-template>\n            </fsw-alert>\n          </ng-template>\n        </ng-container>\n      </div>\n    </ng-container>\n  </ng-container>\n</div>\n" }]
        }], propDecorators: { importedEvent: [{
                type: Output
            }], destinationApplicationId: [{
                type: Input
            }], application: [{
                type: Input
            }], module: [{
                type: Input
            }] } });

class FSWApplicationImportDetailsComponent {
    constructor() {
        this.application = {};
    }
    get fields() {
        return [
            ['fields.name', this.application.name],
            ['fields.product_group_identifier', this.application.product_group_identifier],
            ['fields.member_username', this.application.members?.[0]?.username],
            ['fields.product', this.application.product],
            ['fields.member_name', this.application.members?.[0]?.fullname],
            ['fields.created_by', this.application.created_by],
            ['fields.status', this.application.status],
        ];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWApplicationImportDetailsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWApplicationImportDetailsComponent, isStandalone: true, selector: "fsw-application-import-details", inputs: { application: "application" }, providers: [provideApplicationImportTranslation('application_import_details')], ngImport: i0, template: "<article\n  class=\"w-full flex gap-[8px] flex-wrap p-[8px] rounded-[8px] border border-solid border-gray-600\"\n>\n  <ng-container *ngFor=\"let field of fields\">\n    <label class=\"flex flex-col gap-[4px] w-[calc(50%-4px)]\">\n      <span class=\"text-gray-600 text-body-caption-400 font-bold\">{{\n        field[0] | fswTranslate : { scope: 'application_import_details' }\n      }}</span>\n      <span class=\"text-gray-600 text-body-caption-600\">{{ field[1] || '--' }}</span>\n    </label>\n  </ng-container>\n</article>\n", dependencies: [{ kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWApplicationImportDetailsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-application-import-details', standalone: true, providers: [provideApplicationImportTranslation('application_import_details')], changeDetection: ChangeDetectionStrategy.OnPush, imports: [NgForOf, FSWTranslateModule], template: "<article\n  class=\"w-full flex gap-[8px] flex-wrap p-[8px] rounded-[8px] border border-solid border-gray-600\"\n>\n  <ng-container *ngFor=\"let field of fields\">\n    <label class=\"flex flex-col gap-[4px] w-[calc(50%-4px)]\">\n      <span class=\"text-gray-600 text-body-caption-400 font-bold\">{{\n        field[0] | fswTranslate : { scope: 'application_import_details' }\n      }}</span>\n      <span class=\"text-gray-600 text-body-caption-600\">{{ field[1] || '--' }}</span>\n    </label>\n  </ng-container>\n</article>\n" }]
        }], propDecorators: { application: [{
                type: Input
            }] } });

class FSWApplicationImportComponent {
    constructor() {
        this.dialogRef = inject((DialogRef));
        this.alertService = inject(FSW_ALERT_SERVICE_TOKEN);
        this.allowedToImportSignal = signal(false);
        this.applicationNumberSignal = signal('');
        this.applicationSignal = signal(null);
        this.disabledImportSignal = signal(false);
        this.acceptedSignal = signal(false);
        this.effects = injectApplicationImportEffects();
        this.modules = [
            'borrowers',
            'borrower_summary',
            'bips',
            'pg_cg_summary',
            'proposals',
            'borrower_documents',
            'bip_documents',
        ];
    }
    validate() {
        this.effects
            .searchApplications(this.applicationNumberSignal())
            .pipe(tapResponse((application) => {
            this.applicationSignal.set(application);
            if (!application) {
                this.alertService.error('Error', `Cannot find in_progress application with number: ${this.applicationNumberSignal()}`, {
                    duration: 3000,
                });
            }
        }, (error) => {
            console.error(error);
            this.alertService.error('Error', 'Something went wrong! Please try again.', {
                duration: 3000,
            });
        }))
            .subscribe();
    }
    confirm() {
        if (this.allowedToImportSignal()) {
            this.acceptedSignal.set(true);
            return;
        }
        this.dialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWApplicationImportComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWApplicationImportComponent, isStandalone: true, selector: "fsw-application-import", providers: [
            provideUtilsService(),
            provideApplicationService(),
            provideApplicationImportTranslation(),
            provideApplicationProposalService(),
        ], ngImport: i0, template: "<fsw-modal\n  [title]=\"'title' | fswTranslate : { scope: 'application_import' }\"\n  [size]=\"'l'\"\n  [hiddenFooter]=\"true\"\n  (closeEvent)=\"dialogRef.close()\"\n>\n  <ng-template fswModalBody>\n    <section class=\"flex flex-col gap-[12px] w-full max-h-[70vh] overflow-y-auto p-[4px]\">\n      <header class=\"flex flex-col gap-[8px] w-full\">\n        <ng-container *ngIf=\"!acceptedSignal()\">\n          <fsw-field [fullWidth]=\"true\" [disabled]=\"disabledImportSignal()\">\n            <ng-template\n              fswFieldHeaderPrefix\n              [label]=\"'fields.import' | fswTranslate : { scope: 'application_import' }\"\n            />\n            <fsw-radio-group\n              [ngModel]=\"allowedToImportSignal()\"\n              [disabled]=\"disabledImportSignal()\"\n              [direction]=\"'row'\"\n              (ngModelChange)=\"allowedToImportSignal.set($event)\"\n            >\n              <fsw-radio\n                [label]=\"'buttons.yes' | fswTranslate : { scope: 'application_import' }\"\n                [value]=\"true\"\n                [disabled]=\"disabledImportSignal()\"\n              />\n              <fsw-radio\n                [label]=\"'buttons.no' | fswTranslate : { scope: 'application_import' }\"\n                [value]=\"false\"\n                [disabled]=\"disabledImportSignal()\"\n              />\n            </fsw-radio-group>\n          </fsw-field>\n          <button fswButton (click)=\"confirm()\">\n            {{ 'buttons.confirm' | fswTranslate : { scope: 'application_import' } }}\n          </button>\n        </ng-container>\n        <label class=\"flex items-end gap-[8px] w-full\" *ngIf=\"acceptedSignal()\">\n          <div class=\"w-[300px]\">\n            <fsw-field [fullWidth]=\"true\" [disabled]=\"disabledImportSignal()\">\n              <ng-template\n                fswFieldHeaderPrefix\n                [label]=\"\n                  'fields.application_number' | fswTranslate : { scope: 'application_import' }\n                \"\n              />\n              <input\n                fswInput\n                [disabled]=\"disabledImportSignal()\"\n                [ngModel]=\"applicationNumberSignal()\"\n                (ngModelChange)=\"applicationNumberSignal.set($event)\"\n                [placeholder]=\"\n                  'fields.application_number' | fswTranslate : { scope: 'application_import' }\n                \"\n              />\n            </fsw-field>\n          </div>\n          <button\n            *ngIf=\"applicationNumberSignal() && !disabledImportSignal()\"\n            fswButton\n            [appearance]=\"'secondary-elevate'\"\n            [size]=\"'s'\"\n            (click)=\"validate()\"\n          >\n            {{ 'buttons.validate' | fswTranslate : { scope: 'application_import' } }}\n          </button>\n        </label>\n      </header>\n      <ng-container *ngIf=\"applicationSignal() as application\">\n        <main class=\"flex flex-col gap-[8px] w-full\">\n          <fsw-application-import-details [application]=\"application\" />\n          <fsw-alert\n            [hiddenFooter]=\"true\"\n            [status]=\"'warning'\"\n            [size]=\"'l'\"\n            [title]=\"'warning.title' | fswTranslate : { scope: 'application_import' }\"\n            [hiddenCloseButton]=\"true\"\n          >\n            <ng-template fswAlertBody>\n              <p>{{ 'warning.description' | fswTranslate : { scope: 'application_import' } }}</p>\n            </ng-template>\n          </fsw-alert>\n        </main>\n        <footer class=\"flex flex-col gap-[8px] w-full\">\n          <ng-container *ngFor=\"let module of modules\">\n            <fsw-application-import-module\n              [application]=\"application\"\n              [module]=\"module\"\n              [destinationApplicationId]=\"dialogRef.config.data\"\n              (importedEvent)=\"disabledImportSignal.set(true)\"\n            />\n          </ng-container>\n        </footer>\n      </ng-container>\n    </section>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "ngmodule", type: FSWAlertModule }, { kind: "component", type: i1$4.FSWAlertComponent, selector: "fsw-alert", inputs: ["title", "confirmButton", "cancelButton", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "status", "size"], outputs: ["closeClick", "confirmClick", "cancelClick", "opened", "closed"] }, { kind: "directive", type: i1$4.FSWAlertBodyDirective, selector: "ng-template[fswAlertBody]" }, { kind: "ngmodule", type: FSWModalModule$1 }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FSWFieldModule }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$4.FSWFieldHeaderPrefixDirective, selector: "ng-template[fswFieldHeaderPrefix]", inputs: ["kind", "label", "required"] }, { kind: "ngmodule", type: FSWRadioModule }, { kind: "component", type: i1$4.FSWRadioComponent, selector: "fsw-radio" }, { kind: "component", type: i1$4.FSWRadioGroupComponent, selector: "fsw-radio-group" }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "ngmodule", type: FSWInputModule }, { kind: "directive", type: i1$4.FSWInputDirective, selector: "input[fswInput], textarea[fswInput]" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: FSWApplicationImportModuleComponent, selector: "fsw-application-import-module", inputs: ["destinationApplicationId", "application", "module"], outputs: ["importedEvent"] }, { kind: "component", type: FSWApplicationImportDetailsComponent, selector: "fsw-application-import-details", inputs: ["application"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWApplicationImportComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-application-import', standalone: true, imports: [
                        FSWAlertModule,
                        FSWModalModule$1,
                        FSWTranslateModule,
                        NgIf,
                        FSWFieldModule,
                        FSWRadioModule,
                        FormsModule,
                        FSWInputModule,
                        FSWButtonModule,
                        NgForOf,
                        FSWApplicationImportModuleComponent,
                        FSWApplicationImportDetailsComponent,
                    ], providers: [
                        provideUtilsService(),
                        provideApplicationService(),
                        provideApplicationImportTranslation(),
                        provideApplicationProposalService(),
                    ], changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal\n  [title]=\"'title' | fswTranslate : { scope: 'application_import' }\"\n  [size]=\"'l'\"\n  [hiddenFooter]=\"true\"\n  (closeEvent)=\"dialogRef.close()\"\n>\n  <ng-template fswModalBody>\n    <section class=\"flex flex-col gap-[12px] w-full max-h-[70vh] overflow-y-auto p-[4px]\">\n      <header class=\"flex flex-col gap-[8px] w-full\">\n        <ng-container *ngIf=\"!acceptedSignal()\">\n          <fsw-field [fullWidth]=\"true\" [disabled]=\"disabledImportSignal()\">\n            <ng-template\n              fswFieldHeaderPrefix\n              [label]=\"'fields.import' | fswTranslate : { scope: 'application_import' }\"\n            />\n            <fsw-radio-group\n              [ngModel]=\"allowedToImportSignal()\"\n              [disabled]=\"disabledImportSignal()\"\n              [direction]=\"'row'\"\n              (ngModelChange)=\"allowedToImportSignal.set($event)\"\n            >\n              <fsw-radio\n                [label]=\"'buttons.yes' | fswTranslate : { scope: 'application_import' }\"\n                [value]=\"true\"\n                [disabled]=\"disabledImportSignal()\"\n              />\n              <fsw-radio\n                [label]=\"'buttons.no' | fswTranslate : { scope: 'application_import' }\"\n                [value]=\"false\"\n                [disabled]=\"disabledImportSignal()\"\n              />\n            </fsw-radio-group>\n          </fsw-field>\n          <button fswButton (click)=\"confirm()\">\n            {{ 'buttons.confirm' | fswTranslate : { scope: 'application_import' } }}\n          </button>\n        </ng-container>\n        <label class=\"flex items-end gap-[8px] w-full\" *ngIf=\"acceptedSignal()\">\n          <div class=\"w-[300px]\">\n            <fsw-field [fullWidth]=\"true\" [disabled]=\"disabledImportSignal()\">\n              <ng-template\n                fswFieldHeaderPrefix\n                [label]=\"\n                  'fields.application_number' | fswTranslate : { scope: 'application_import' }\n                \"\n              />\n              <input\n                fswInput\n                [disabled]=\"disabledImportSignal()\"\n                [ngModel]=\"applicationNumberSignal()\"\n                (ngModelChange)=\"applicationNumberSignal.set($event)\"\n                [placeholder]=\"\n                  'fields.application_number' | fswTranslate : { scope: 'application_import' }\n                \"\n              />\n            </fsw-field>\n          </div>\n          <button\n            *ngIf=\"applicationNumberSignal() && !disabledImportSignal()\"\n            fswButton\n            [appearance]=\"'secondary-elevate'\"\n            [size]=\"'s'\"\n            (click)=\"validate()\"\n          >\n            {{ 'buttons.validate' | fswTranslate : { scope: 'application_import' } }}\n          </button>\n        </label>\n      </header>\n      <ng-container *ngIf=\"applicationSignal() as application\">\n        <main class=\"flex flex-col gap-[8px] w-full\">\n          <fsw-application-import-details [application]=\"application\" />\n          <fsw-alert\n            [hiddenFooter]=\"true\"\n            [status]=\"'warning'\"\n            [size]=\"'l'\"\n            [title]=\"'warning.title' | fswTranslate : { scope: 'application_import' }\"\n            [hiddenCloseButton]=\"true\"\n          >\n            <ng-template fswAlertBody>\n              <p>{{ 'warning.description' | fswTranslate : { scope: 'application_import' } }}</p>\n            </ng-template>\n          </fsw-alert>\n        </main>\n        <footer class=\"flex flex-col gap-[8px] w-full\">\n          <ng-container *ngFor=\"let module of modules\">\n            <fsw-application-import-module\n              [application]=\"application\"\n              [module]=\"module\"\n              [destinationApplicationId]=\"dialogRef.config.data\"\n              (importedEvent)=\"disabledImportSignal.set(true)\"\n            />\n          </ng-container>\n        </footer>\n      </ng-container>\n    </section>\n  </ng-template>\n</fsw-modal>\n" }]
        }] });

var title$1 = "Partner Search Details";
var forms = {
	individual: {
		name: "Name",
		email: "Email",
		gender: "Gender",
		mobile_phone: "Mobile Phone",
		id_card_number: "ID Card Number",
		passport_number: "Passport Number",
		date_of_birth: "Date of Birth",
		place_of_birth: "Place of Birth"
	},
	company: {
		name: "Company Name",
		type: "Company Type",
		username: "Username",
		industry: "Industry",
		registration_number: "Registration Number",
		establishment_date: "Establishment Date"
	},
	shared: {
		member_entity_type: {
			id: "Entity Type",
			individual: "Individual",
			company: "Company"
		},
		tax_number: "Tax Number",
		address_line_1: "Address Line 1",
		address_line_2: "Address Line 2",
		country: "Country",
		state_province: "State/Province",
		district: "District",
		postal_code: "Postal Code"
	},
	partner_id: "Partner Id"
};
var buttons$1 = {
	cancel: "Cancel",
	save_changes: "Save Changes",
	replace: "Search",
	edit: "Edit",
	search: "Search",
	add_borrower: "Save",
	replace_borrower: "Add Partner"
};
var modal = {
	title: "Search Partner",
	search: "Search with Partner Id or Name",
	confirm_cancel: {
		title: "Are you sure you want to cancel the editing information?",
		description: "You will lose all the information that you are editing about the partner search",
		no: "No, continue edit",
		yes: "Yes, cancel"
	},
	confirm_save: {
		title: "Are you sure you want to save borrower information?",
		description: "You will replace all the current information that you updated about the partner search",
		no: "No, don't change",
		yes: "Yes, save borrower"
	},
	confirm_add: {
		title: "Are you sure you want to add a new borrower?",
		description: "You will lose all the information that you added about the partner search",
		no: "No, don't change",
		yes: "Yes, add new borrower"
	},
	confirm_replace: {
		title: "Are you sure you want to replace borrower?",
		description: "You will lose all the information that you added. Would you like to replace with your new borrower <b class='text-blue-500 font-bold'>{{name}}?</b>",
		no: "No, don't change",
		yes: "Yes, replace"
	}
};
var table = {
	full_name: "Full Name",
	entity_type: "Entity Type",
	company_name: "Company Name",
	email_address: "Email Address",
	id: "Id"
};
var th = {
	title: title$1,
	forms: forms,
	buttons: buttons$1,
	modal: modal,
	table: table
};

var TH = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons$1,
    default: th,
    forms: forms,
    modal: modal,
    table: table,
    title: title$1
});

const FSW_PARTNER_SEARCH_TRANSLATION_LOADER = {
    [CountryCode.TH]: TH,
};

const FSW_PARTNER_SEARCH_STORE_TOKEN = new InjectionToken('FSW_PARTNER_SEARCH_STORE_TOKEN');

const FSW_PARTNER_SEARCH_FORM_TOKEN = new InjectionToken('FSW_PARTNER_SEARCH_FORM_TOKEN');

const fswPartnerSearchInitialState = {
    applicationId: null,
    genders: [],
    industries: [],
    subIndustries: [],
    companyEntityTypes: [],
    countries: [],
    provinces: [],
    districts: [],
    cities: [],
    areas: [],
    isReadonly: false,
    isEditable: false,
};
class FSWPartnerSearchStore extends ApplicationMemberInformationStore {
    constructor(_applicationMemberService, _masterDataService, _referenceService, _memberService, _alertService, _form, _initialOptionalState) {
        super(_applicationMemberService, Object.assign(fswPartnerSearchInitialState, _initialOptionalState || {}));
        this._applicationMemberService = _applicationMemberService;
        this._masterDataService = _masterDataService;
        this._referenceService = _referenceService;
        this._memberService = _memberService;
        this._alertService = _alertService;
        this._form = _form;
        this._initialOptionalState = _initialOptionalState;
        this.countryControl = new UntypedFormControl(getCountryCodeFromStorage());
        this.provinceControl = new UntypedFormControl(null);
        this.industryControl = new UntypedFormControl(null);
        this.cityControl = new UntypedFormControl(null);
        this.districtControl = new UntypedFormControl(null);
        this._referenceSaveMapping = new Map();
        this.builder = this.createBuilder();
        this.init = this.effect(pipe(switchMap(() => this.loadAssets()), tap(() => {
            this.listenControlChange();
            this.patchMemberToBuilder();
        }), catchError((err) => {
            console.error(err);
            return EMPTY;
        })));
        this.save = this.effect(pipe(switchMap(() => this._memberService
            .updateMember(this.state().member?.uuid, this._resolveMemberData(this.builder.groupConfig.form.getRawValue()))
            .pipe(tap(() => {
            this._alertService.success('Notification', 'Saved member successfully!', {
                duration: 3000,
            });
        }), switchMap(() => this.setupInformation(this.state().applicationId)), catchError((err) => {
            console.error(err);
            this._alertService.error('Something went wrong', 'Fail to save member information! Please try again', {
                duration: 3000,
            });
            return EMPTY;
        })))));
        this.replace = this.effect(pipe(tap(({ data, type }) => {
            const removeObs$ = this.state().member
                ? this._applicationMemberService.removeMember(this.state().applicationId, this.state().member?.uuid)
                : from(Promise.resolve('Member does not exist in current application'));
            return removeObs$.pipe(switchMap(() => {
                const obs$ = type === 'replace'
                    ? this._applicationMemberService.linkMember(this.state().applicationId, {
                        type: 'MAIN',
                        additional_data: {},
                        member_id: data,
                    })
                    : this._memberService.addMember(this._resolveMemberDataBeforeAdd(data)).pipe(switchMap((member) => this._applicationMemberService.linkMember(this.state().applicationId, {
                        type: 'MAIN',
                        additional_data: this._resolveMemberDataBeforeAdd(data),
                        member_id: member.uuid,
                    })));
                return obs$.pipe(tap(() => {
                    this._alertService.success('Notification', 'Saved member successfully!', {
                        duration: 3000,
                    });
                }), switchMap(() => this.setupInformation(this.state().applicationId).pipe(tap(() => {
                    this.patchMemberToBuilder();
                }))));
            }), catchError((err) => {
                console.error(err);
                this._alertService.error('Something went wrong', 'Fail to save member information! Please try again', {
                    duration: 3000,
                });
                return EMPTY;
            }));
        })));
        this.listenCountryChange = this.effect(pipe(switchMap(() => this.countryControl.valueChanges.pipe(startWith(this.countryControl.value), tap(() => {
            this.updateState({ provinces: [] });
            this._updateFormToMapping('citizenship_state_id');
            this._updateFormToMapping('company_state_id');
            this.builder.groupConfig.form.patchValue({
                citizenship_state_id: null,
                company_state_id: null,
            });
        }), filter((countryId) => !!countryId), switchMap(() => this._masterDataService.getProvinces(this._getCountryCode()).pipe(tap((provinces) => {
            this.updateState({ provinces });
            this._updateMappingToForm('citizenship_state_id', (value) => provinces.some((province) => province.id == value));
            this._updateMappingToForm('company_state_id', (value) => provinces.some((province) => province.id == value));
        })))))));
        this.listenIndustryChange = this.effect(pipe(switchMap(() => this.industryControl.valueChanges.pipe(startWith(this.industryControl.value), tap(() => this.updateState({ subIndustries: [] })), filter((industryId) => !!industryId), switchMap((industryId) => this._referenceService
            .getSubIndustries(industryId)
            .pipe(tap((subIndustries) => this.updateState({ subIndustries }))))))));
        this.listenProvinceChange = this.effect(pipe(switchMap(() => this.provinceControl.valueChanges.pipe(startWith(this.provinceControl.value), tap(() => {
            this.updateState({ cities: [] });
            this._updateFormToMapping('citizenship_city_id');
            this._updateFormToMapping('company_city_id');
            this.builder.groupConfig.form.patchValue({
                citizenship_city_id: null,
                company_city_id: null,
            });
        }), filter((provinceId) => !!provinceId), switchMap((provinceId) => this._masterDataService.getCities(provinceId, this._getCountryCode()).pipe(tap((cities) => {
            this.updateState({ cities });
            this._updateMappingToForm('citizenship_city_id', (value) => cities.some((city) => city.id == value));
            this._updateMappingToForm('company_city_id', (value) => cities.some((city) => city.id == value));
        })))))));
        this.listenCityChange = this.effect(pipe(switchMap(() => this.cityControl.valueChanges.pipe(startWith(this.cityControl.value), tap(() => {
            this.updateState({ districts: [] });
            this._updateFormToMapping('citizenship_district');
            this._updateFormToMapping('company_district');
            this.builder.groupConfig.form.patchValue({
                citizenship_district: null,
                company_district: null,
            });
        }), filter((cityId) => !!cityId), switchMap((cityId) => this._masterDataService.getDistricts(cityId, this._getCountryCode()).pipe(tap((districts) => {
            this.updateState({ districts });
            this._updateMappingToForm('citizenship_district', (value) => districts.some((district) => district.id == value));
            this._updateMappingToForm('company_district', (value) => districts.some((district) => district.id == value));
        })))))));
        this.listenDistrictChange = this.effect(pipe(switchMap(() => this.districtControl.valueChanges.pipe(startWith(this.districtControl.value), tap(() => {
            this.updateState({ areas: [] });
        }), filter((districtId) => !!districtId), switchMap((districtId) => this._masterDataService
            .getAreas(districtId, this._getCountryCode())
            .pipe(tap((areas) => this.updateState({ areas }))))))));
        this.updateState = (value) => this.patchState({
            ...value,
        });
    }
    getApplicationMembersInformation(entityId, applicationParams, memberParams) {
        return this._applicationMemberService.getApplicationMembersInformation(entityId, applicationParams, memberParams);
    }
    loadAssets() {
        return forkJoin([
            this.setupInformation(this.state().applicationId),
            this._masterDataService.getCountries().pipe(tap((countries) => this.patchState({
                countries,
            }))),
            this._masterDataService
                .getGenders()
                .pipe(tap((genders) => this.patchState({ genders }))),
            this._masterDataService
                .getIndustries()
                .pipe(tap((industries) => this.patchState({ industries }))),
            this._masterDataService
                .getCompanyEntityTypes()
                .pipe(tap((companyEntityTypes) => this.patchState({ companyEntityTypes }))),
        ]);
    }
    listenControlChange() {
        this.listenCountryChange();
        this.listenIndustryChange();
        this.listenProvinceChange();
        this.listenCityChange();
        this.listenDistrictChange();
    }
    patchMemberToBuilder() {
        this._referenceSaveMapping.clear();
        const member = this.state().member;
        this.builder.groupConfig.form.patchValue({
            ...(member || {}),
            ...(member
                ? {
                    company_username: member.username,
                    company_tax_card_number: member.tax_card_number,
                }
                : {}),
        });
    }
    createBuilder(notAllowEditableChange = false) {
        return this._form(new UntypedFormGroup({}), notAllowEditableChange ? of(false) : this.select((state) => !state.isEditable), {
            countryControl: this.countryControl,
            industryControl: this.industryControl,
            provinceControl: this.provinceControl,
            cityControl: this.cityControl,
            districtControl: this.districtControl,
            countries$: this.select((state) => state.countries),
            genders$: this.select((state) => state.genders),
            industries$: this.select((state) => state.industries),
            companyEntityTypes$: this.select((state) => state.companyEntityTypes),
            subIndustries$: this.select((state) => state.subIndustries),
            provinces$: this.select((state) => state.provinces),
            districts$: this.select((state) => state.districts),
            cities$: this.select((state) => state.cities),
            areas$: this.select((state) => state.areas),
        });
    }
    _updateFormToMapping(key) {
        const value = this._referenceSaveMapping.get(key) || null;
        this._referenceSaveMapping.set(key, this.builder.groupConfig.form.getRawValue()[key] || value);
    }
    _updateMappingToForm(key, conditional) {
        const value = this._referenceSaveMapping.get(key) || null;
        if (conditional(value)) {
            this.builder.groupConfig.form.patchValue({
                [key]: value,
            });
        }
    }
    _getCountryCode() {
        return this.countryControl.value === 'VN' ? FSWCountryCode.VU : this.countryControl.value;
    }
    _resolveMemberDataBeforeAdd(data) {
        return {
            ...this._resolveMemberData(data),
            country_code: getCountryCodeFromStorage(),
            member_type_id: '2',
            member_status_id: '1',
            member_activation_status_id: '1',
        };
    }
    _resolveMemberData(data) {
        return {
            ...data,
            username: data['company_username'] || data['username'],
            tax_card_number: data['company_tax_card_number'] || data['tax_card_number'],
        };
    }
}

class FSWPartnerSearchStoreTH extends FSWPartnerSearchStore {
    constructor(_applicationMemberService, _masterDataService, _referenceService, _memberService, _alertService, _form) {
        super(_applicationMemberService, _masterDataService, _referenceService, _memberService, _alertService, _form);
        this._applicationMemberService = _applicationMemberService;
        this._masterDataService = _masterDataService;
        this._referenceService = _referenceService;
        this._memberService = _memberService;
        this._alertService = _alertService;
        this._form = _form;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPartnerSearchStoreTH, deps: [{ token: APPLICATION_MEMBER_SERVICE_TOKEN }, { token: MASTER_DATA_SERVICE_TOKEN }, { token: REFERENCE_SERVICE_TOKEN }, { token: MEMBER_SERVICE_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }, { token: FSW_PARTNER_SEARCH_FORM_TOKEN }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPartnerSearchStoreTH }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPartnerSearchStoreTH, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APPLICATION_MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MASTER_DATA_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [REFERENCE_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PARTNER_SEARCH_FORM_TOKEN]
                }] }]; } });

const FSWPartnerSearchFormTH = (form, isReadonly$, config) => {
    const translation = FSW_PARTNER_SEARCH_TRANSLATION_LOADER[CountryCode.TH];
    const { provinces$, countryControl, provinceControl, districtControl, cityControl, countries$, industryControl, industries$, companyEntityTypes$, genders$, districts$, cities$, areas$, } = config;
    const leftIndividualFields = [
        {
            key: 'username',
            type: FSWDynamicBuilderControlTypes.INPUT,
            customClasses: 'contents',
            context: {
                inputType: 'email',
                label: translation.forms.individual.email,
                placeHolder: translation.forms.individual.email,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required, Validators.email],
        },
        {
            key: 'mobile_phone_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.individual.mobile_phone,
                placeHolder: translation.forms.individual.mobile_phone,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'passport_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.individual.passport_number,
                placeHolder: translation.forms.individual.passport_number,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
        },
        {
            key: 'birth_date',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
            context: {
                label: translation.forms.individual.date_of_birth,
                placeHolder: 'DD/MM/YYYY',
                isRequired: true,
                fullWidth: true,
                closeOnSelected: true,
                readonlyTemplate: 'date',
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_address_1',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.address_line_1,
                placeHolder: translation.forms.shared.address_line_1,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_country_code',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.country,
                placeHolder: translation.forms.shared.country,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                defaultValue: getCountryCodeFromStorage() === FSWCountryCode.VU ? 'VN' : getCountryCodeFromStorage(),
                loadItemsAsync: () => countries$.pipe(map((countries) => countries.map((country) => ({
                    value: country.code,
                    text: country.name,
                })))),
                afterCreated: (control) => {
                    countryControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((countryCode) => countryCode !== countryControl.value && countryControl.setValue(countryCode)))
                        .subscribe();
                },
                readonlyTemplate: 'country',
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_district',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.district,
                placeHolder: translation.forms.shared.district,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => districts$.pipe(map((districts) => districts.map((district) => ({
                    value: district.id,
                    text: district.name,
                })))),
                afterCreated: (control) => {
                    districtControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((districtCode) => districtCode !== districtControl.value && districtControl.setValue(districtCode)))
                        .subscribe();
                },
                readonlyTemplate: 'district',
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
    ];
    const leftCompanyFields = [
        {
            key: 'company_entity_type_id',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.company.type,
                placeHolder: translation.forms.company.type,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => companyEntityTypes$.pipe(map((entityTypes) => entityTypes.map((entityType) => ({
                    value: entityType.id,
                    text: entityType.name,
                })))),
                readonlyTemplate: 'company_entity_id',
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_industry_id',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.company.industry,
                placeHolder: translation.forms.company.industry,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => industries$.pipe(map((industries) => industries.map((industry) => ({
                    value: industry.id,
                    text: industry.name,
                })))),
                readonlyTemplate: 'industry',
                afterCreated: (control) => {
                    countryControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((industry) => industry !== industryControl.value && industryControl.setValue(industry)))
                        .subscribe();
                },
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_tax_card_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                inputType: 'number',
                label: translation.forms.shared.tax_number,
                placeHolder: translation.forms.shared.tax_number,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_address_1',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.address_line_1,
                placeHolder: translation.forms.shared.address_line_1,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_country_code',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.country,
                placeHolder: translation.forms.shared.country,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                defaultValue: getCountryCodeFromStorage() === FSWCountryCode.VU ? 'VN' : getCountryCodeFromStorage(),
                isDisabled: true,
                loadItemsAsync: () => countries$.pipe(map((countries) => countries.map((country) => ({
                    value: country.code,
                    text: country.name,
                })))),
                afterCreated: (control) => {
                    control.valueChanges
                        .pipe(tap((countryCode) => countryCode !== countryControl.value && countryControl.setValue(countryCode)))
                        .subscribe();
                    countryControl.setValue(control.value);
                },
                readonlyTemplate: 'country',
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_district',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.district,
                placeHolder: translation.forms.shared.district,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => districts$.pipe(map((districts) => districts.map((district) => ({
                    value: district.id,
                    text: district.name,
                })))),
                afterCreated: (control) => {
                    districtControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((districtCode) => districtCode !== districtControl.value && districtControl.setValue(districtCode)))
                        .subscribe();
                },
                readonlyTemplate: 'district',
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
    ];
    const rightIndividualFields = [
        {
            key: 'fullname',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.individual.name,
                placeHolder: translation.forms.individual.name,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'gender_id',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.individual.gender,
                placeHolder: translation.forms.individual.gender,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'gender',
                loadItemsAsync: () => genders$.pipe(map((genders) => genders.map((gender) => ({
                    value: gender.id,
                    text: gender.name,
                })))),
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'ic_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.individual.id_card_number,
                placeHolder: translation.forms.individual.id_card_number,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'tax_card_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                inputType: 'number',
                label: translation.forms.shared.tax_number,
                placeHolder: translation.forms.shared.tax_number,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'birth_place',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.individual.place_of_birth,
                placeHolder: translation.forms.individual.place_of_birth,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_address_2',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.address_line_2,
                placeHolder: translation.forms.shared.address_line_2,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_state_id',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.state_province,
                placeHolder: translation.forms.shared.state_province,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                loadItemsAsync: () => provinces$.pipe(map((provinces) => provinces.map((province) => ({
                    value: province.id,
                    text: province.name,
                })))),
                afterCreated: (control) => {
                    provinceControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((provinceCode) => provinceCode !== provinceControl.value && provinceControl.setValue(provinceCode)))
                        .subscribe();
                },
                readonlyTemplate: 'province',
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
        {
            key: 'citizenship_zip_code',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.postal_code,
                placeHolder: translation.forms.shared.postal_code,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                afterCreated: (control) => {
                    let controlValue = control.value;
                    areas$
                        .pipe(tap((areas) => {
                        const value = areas[0]?.zip_code;
                        control.setValue(value || controlValue || control.value);
                        if (value) {
                            controlValue = value;
                            control.disable();
                        }
                        else {
                            controlValue = control.value;
                            control.enable();
                        }
                    }))
                        .subscribe();
                },
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
            },
            validations: [Validators.required],
        },
    ];
    const rightCompanyFields = [
        {
            key: 'company_name',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.company.name,
                placeHolder: translation.forms.company.name,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_username',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                inputType: 'email',
                label: translation.forms.company.username,
                placeHolder: translation.forms.company.username,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required, Validators.email],
        },
        {
            key: 'company_registration_number',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                inputType: 'number',
                label: translation.forms.company.registration_number,
                placeHolder: translation.forms.company.registration_number,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_birth_date',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.DATE_TIME_PICKER,
            context: {
                label: translation.forms.company.establishment_date,
                placeHolder: 'DD/MM/YYYY',
                isRequired: true,
                fullWidth: true,
                closeOnSelected: true,
                readonlyTemplate: 'date',
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_address_2',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.address_line_2,
                placeHolder: translation.forms.shared.address_line_2,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_state_id',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.SELECT,
            context: {
                label: translation.forms.shared.state_province,
                placeHolder: translation.forms.shared.state_province,
                maxHeight: '300px',
                isRequired: true,
                fullWidth: true,
                afterCreated: (control) => {
                    provinceControl.setValue(control.value);
                    control.valueChanges
                        .pipe(tap((provinceCode) => provinceCode !== provinceControl.value && provinceControl.setValue(provinceCode)))
                        .subscribe();
                },
                loadItemsAsync: () => provinces$.pipe(map((provinces) => provinces.map((province) => ({
                    value: province.id,
                    text: province.name,
                })))),
                readonlyTemplate: 'province',
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
        {
            key: 'company_zip_code',
            customClasses: 'contents',
            type: FSWDynamicBuilderControlTypes.INPUT,
            context: {
                label: translation.forms.shared.postal_code,
                placeHolder: translation.forms.shared.postal_code,
                isRequired: true,
                fullWidth: true,
                readonlyTemplate: 'basic',
                afterCreated: (control) => {
                    let controlValue = control.value;
                    areas$
                        .pipe(tap((areas) => {
                        const value = areas[0]?.zip_code;
                        control.setValue(value || controlValue || control.value);
                        if (value) {
                            controlValue = value;
                            control.disable();
                        }
                        else {
                            controlValue = control.value;
                            control.enable();
                        }
                    }))
                        .subscribe();
                },
                customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
            },
            validations: [Validators.required],
        },
    ];
    return new FSWDynamicBuilder({
        formType: FSWDynamicBuilderFormTypes.GROUP,
        customClasses: 'w-full flex gap-[16px]',
        readonlyWhen$: isReadonly$,
        renderBy: 'container',
        containers: [
            {
                customClasses: 'w-full flex gap-[16px] flex-col w-[calc(50%-8px)]',
                fields: [
                    {
                        key: 'member_entity_type_id',
                        type: FSWDynamicBuilderControlTypes.RADIO_GROUP,
                        customClasses: 'h-[69px] flex items-center',
                        context: {
                            label: translation.forms.shared.member_entity_type.id,
                            defaultValue: MemberTypeId.INDIVIDUAL,
                            direction: FSWCheckboxDirections.ROW,
                            gap: '12px',
                            items: [
                                {
                                    value: MemberTypeId.INDIVIDUAL,
                                    renderTemplate: {
                                        label: translation.forms.shared.member_entity_type.individual,
                                    },
                                },
                                {
                                    value: MemberTypeId.COMPANY,
                                    renderTemplate: {
                                        label: translation.forms.shared.member_entity_type.company,
                                    },
                                },
                            ],
                            fullWidth: true,
                            readonlyTemplate: (value) => {
                                if (value === MemberTypeId.INDIVIDUAL) {
                                    return translation.forms.shared.member_entity_type.individual;
                                }
                                else {
                                    return translation.forms.shared.member_entity_type.company;
                                }
                            },
                        },
                    },
                    ...leftIndividualFields,
                    ...leftCompanyFields,
                ],
            },
            {
                customClasses: 'w-full flex gap-[16px] flex-col w-[calc(50%-8px)]',
                fields: [...rightIndividualFields, ...rightCompanyFields],
            },
            {
                customClasses: 'hidden',
                fields: [
                    {
                        key: 'citizenship_city_id',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            isDisabled: true,
                            afterCreated: (control) => {
                                cities$
                                    .pipe(tap((cities) => {
                                    control.setValue(cities[0]?.id, { emitEvent: false });
                                    cityControl.setValue(cities[0]?.id);
                                }))
                                    .subscribe();
                            },
                            customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.INDIVIDUAL),
                        },
                    },
                    {
                        key: 'company_city_id',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            isDisabled: true,
                            afterCreated: (control) => {
                                cities$
                                    .pipe(tap((cities) => {
                                    control.setValue(cities[0]?.id, { emitEvent: false });
                                    cityControl.setValue(cities[0]?.id);
                                }))
                                    .subscribe();
                            },
                            customRender: getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH(MemberTypeId.COMPANY),
                        },
                    },
                    {
                        key: 'member_entity_code',
                        type: FSWDynamicBuilderControlTypes.INPUT,
                        context: {
                            isDisabled: true,
                            afterCreated: (control, group) => {
                                group.valueChanges
                                    .pipe(startWith(group.value))
                                    .subscribe(({ member_entity_type_id }) => control.setValue(member_entity_type_id === MemberTypeId.INDIVIDUAL
                                    ? MemberEntityCode.RETAIL
                                    : MemberEntityCode.CORPORATE, { emitEvent: false }));
                            },
                        },
                    },
                ],
            },
        ],
        form,
    });
};
const getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH = (entityId) => [
    {
        fields: [
            {
                key: 'member_entity_type_id',
                correctWhenValueIs: (value) => value == entityId,
            },
        ],
        checkingConditionCallback: (params, condition) => {
            if (condition) {
                params.renderView();
            }
            else {
                params.clearView();
            }
        },
    },
];

const FSW_PARTNER_SEARCH_TH_PROVIDERS = [
    {
        provide: FSW_PARTNER_SEARCH_STORE_TOKEN,
        useClass: FSWPartnerSearchStoreTH,
        deps: [
            APPLICATION_MEMBER_SERVICE_TOKEN,
            MASTER_DATA_SERVICE_TOKEN,
            REFERENCE_SERVICE_TOKEN,
            MEMBER_SERVICE_TOKEN,
            FSW_ALERT_SERVICE_TOKEN,
            FSW_PARTNER_SEARCH_FORM_TOKEN,
        ],
    },
    {
        provide: FSW_PARTNER_SEARCH_FORM_TOKEN,
        useValue: FSWPartnerSearchFormTH,
        deps: [],
    },
];

const FSW_PARTNER_SEARCH_PROVIDERS = {
    default: FSW_PARTNER_SEARCH_TH_PROVIDERS,
    [CountryCode.TH]: FSW_PARTNER_SEARCH_TH_PROVIDERS,
};
const partnerSearchLoadProviders = (countryCode) => [
    fswTranslateScope('partner-search'),
    ...getCustomProviders(FSW_PARTNER_SEARCH_PROVIDERS, FSW_PARTNER_SEARCH_TH_PROVIDERS, countryCode),
];

class FSWPartnerSearchTemplatePipe {
    constructor(componentStore) {
        this.componentStore = componentStore;
        this.latestValue = '';
    }
    transform(value, config, defaultNullValue = 'N/A') {
        const { stateKey, labelKey, compareKey } = config;
        this.componentStore
            .select((state) => state[stateKey])
            .pipe(map((data) => {
            const item = data.find((item) => item[compareKey] == value);
            this.latestValue = item ? `${item[labelKey]}` : defaultNullValue;
        }))
            .subscribe();
        return this.latestValue;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPartnerSearchTemplatePipe, deps: [{ token: FSW_PARTNER_SEARCH_STORE_TOKEN }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWPartnerSearchTemplatePipe, name: "fswPartnerSearchTemplate", pure: false }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPartnerSearchTemplatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fswPartnerSearchTemplate',
                    pure: false,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PARTNER_SEARCH_STORE_TOKEN]
                }] }]; } });

class FSWPartnerSearchConfirmComponent {
    constructor(dialogRef) {
        this.dialogRef = dialogRef;
    }
    close(haveData = false) {
        this.dialogRef.close(haveData);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPartnerSearchConfirmComponent, deps: [{ token: i1$7.DialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWPartnerSearchConfirmComponent, selector: "fsw-partner-search-confirm", ngImport: i0, template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"dialogRef.config.data['yesButtonText'] | fswTranslate\"\n  [cancelButton]=\"dialogRef.config.data['noButtonText'] | fswTranslate\"\n  (confirmEvent)=\"close(true)\"\n  (cancelEvent)=\"close(false)\"\n  (closeEvent)=\"close(false)\"\n>\n  <ng-template fswModalBody>\n    <p\n      [innerHTML]=\"\n        dialogRef.config.data['description']\n          | fswTranslate : { data: dialogRef.config.data['descriptionParams'] }\n      \"\n    ></p>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPartnerSearchConfirmComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-partner-search-confirm', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal\n  [size]=\"'s'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"dialogRef.config.data['yesButtonText'] | fswTranslate\"\n  [cancelButton]=\"dialogRef.config.data['noButtonText'] | fswTranslate\"\n  (confirmEvent)=\"close(true)\"\n  (cancelEvent)=\"close(false)\"\n  (closeEvent)=\"close(false)\"\n>\n  <ng-template fswModalBody>\n    <p\n      [innerHTML]=\"\n        dialogRef.config.data['description']\n          | fswTranslate : { data: dialogRef.config.data['descriptionParams'] }\n      \"\n    ></p>\n  </ng-template>\n</fsw-modal>\n" }]
        }], ctorParameters: function () { return [{ type: i1$7.DialogRef }]; } });

class FSWPartnerSearchReplaceComponent {
    constructor(componentStore, dialogRef, _memberService, _alertService, _dialog, _injector) {
        this.componentStore = componentStore;
        this.dialogRef = dialogRef;
        this._memberService = _memberService;
        this._alertService = _alertService;
        this._dialog = _dialog;
        this._injector = _injector;
        this.builder = this.componentStore.createBuilder(true);
        this.type$ = new BehaviorSubject('replace');
        this.keySearch$ = new Subject();
        this.page$ = new BehaviorSubject(1);
        this.size$ = new BehaviorSubject(10);
        this.selected$ = new BehaviorSubject(null);
        this.searchControl = new UntypedFormControl('');
        this.searchedMembers$ = this.keySearch$.pipe(filter(() => this.type$.value === 'replace'), tap(() => {
            this.page$.next(1);
            this.size$.next(10);
            this.selected$.next(null);
        }), switchMap((search) => combineLatest([this.page$, this.size$]).pipe(switchMap(([page, size]) => {
            if (!search)
                return of({ data: [], total: 0 });
            const searchValue = typeof search === 'string' ? search.trim() : search;
            const isNumeric = typeof searchValue === 'number' ||
                (typeof searchValue === 'string' && isNumericSearch(searchValue));
            if (isNumeric) {
                return this._memberService.searchMembers({
                    country_code: getCountryCodeFromStorage(),
                    member_type_code: 'PRT',
                    attributes: [
                        'company_name',
                        'fullname',
                        'uuid',
                        'id',
                        'member_entity_code',
                        'member_entity_type_id',
                        'username',
                        'member_type_id',
                    ],
                    memberActivationStatusIds: [1],
                    memberStatusIds: [1, 3],
                    ids: [parseInt(searchValue, 10)],
                    page,
                    size,
                });
            }
            return this._memberService.searchMembers({
                country_code: getCountryCodeFromStorage(),
                member_type_code: 'PRT',
                attributes: [
                    'company_name',
                    'fullname',
                    'uuid',
                    'id',
                    'member_entity_code',
                    'member_entity_type_id',
                    'username',
                    'member_type_id',
                ],
                memberActivationStatusIds: [1],
                memberStatusIds: [1, 3],
                search,
                page,
                size,
            });
        }))));
    }
    close(action) {
        this.dialogRef.close(action);
    }
    replace() {
        const valid = this._validateBeforeReplace();
        if (!valid) {
            this._alertService.warning('Invalid Information', this.type$.value === 'replace'
                ? 'Please select partner to add'
                : 'Please make sure all mandatory fields are filled', {
                duration: 3000,
            });
            return;
        }
        this.close({
            type: this.type$.value,
            data: this.type$.value === 'replace'
                ? this.selected$.value
                : this.builder.groupConfig.form.getRawValue(),
        });
    }
    changeToAddType() {
        this.type$.next('add');
    }
    search() {
        this.type$.next('replace');
        this.keySearch$.next(this.searchControl.value);
    }
    _validateBeforeReplace() {
        if (this.type$.value === 'replace') {
            return !!this.selected$.value;
        }
        else {
            return this.builder.groupConfig.form.valid;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPartnerSearchReplaceComponent, deps: [{ token: FSW_PARTNER_SEARCH_STORE_TOKEN }, { token: i1$7.DialogRef }, { token: MEMBER_SERVICE_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }, { token: i1$7.Dialog }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWPartnerSearchReplaceComponent, selector: "fsw-partner-search-replace", ngImport: i0, template: "<fsw-modal\n  [size]=\"'l'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"dialogRef.config.data['confirmButtonText'] | fswTranslate\"\n  [cancelButton]=\"dialogRef.config.data['cancelButtonText'] | fswTranslate\"\n  [bodyCustomClasses]=\"'max-h-[calc(90vh-138px)] overflow-y-auto'\"\n  (confirmEvent)=\"replace()\"\n  (cancelEvent)=\"close()\"\n  (closeEvent)=\"close()\"\n>\n  <ng-template fswModalBody>\n    <section class=\"flex flex-col gap-[16px]\">\n      <header class=\"flex items-center gap-[8px]\">\n        <fsw-field [flexWidth]=\"true\">\n          <input\n            fswInput\n            [placeholder]=\"'modal.search' | fswTranslate\"\n            [formControl]=\"searchControl\"\n            (keyup.enter)=\"search()\"\n          />\n          <ng-template fswFieldInputSuffix>\n            <button fswButton [appearance]=\"'link'\" (click)=\"search()\">\n              <span>Search</span>\n              <i [fswIcon]=\"'common-search'\"></i>\n            </button>\n          </ng-template>\n        </fsw-field>\n      </header>\n      <main class=\"w-full overflow-x-auto\">\n        <ng-container [ngSwitch]=\"type$ | async\">\n          <ng-container *ngSwitchCase=\"'add'\">\n            <form [formGroup]=\"builder.groupConfig.form\">\n              <fsw-dynamic-builder [builder]=\"builder\">\n                <ng-template fswDynamicBuilderTemplate key=\"district\" let-value>\n                  {{\n                    value\n                      | fswPartnerSearchTemplate\n                        : { stateKey: 'districts', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"province\" let-value>\n                  {{\n                    value\n                      | fswPartnerSearchTemplate\n                        : { stateKey: 'provinces', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"industry\" let-value>\n                  {{\n                    value\n                      | fswPartnerSearchTemplate\n                        : { stateKey: 'industries', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"sub_industry\" let-value>\n                  {{\n                    value\n                      | fswPartnerSearchTemplate\n                        : { stateKey: 'subIndustries', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"gender\" let-value>\n                  {{\n                    value\n                      | fswPartnerSearchTemplate\n                        : { stateKey: 'genders', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"city\" let-value>\n                  {{\n                    value\n                      | fswPartnerSearchTemplate\n                        : { stateKey: 'cities', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"country\" let-value>\n                  {{\n                    value\n                      | fswPartnerSearchTemplate\n                        : { stateKey: 'countries', labelKey: 'name', compareKey: 'code' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"company_entity_id\" let-value>\n                  {{\n                    value\n                      | fswPartnerSearchTemplate\n                        : { stateKey: 'companyEntityTypes', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"basic\" let-value>\n                  {{ value ?? 'N/A' }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"date\" let-value>\n                  {{ value ? (value | date : 'dd/MM/yyyy') : 'N/A' }}\n                </ng-template>\n              </fsw-dynamic-builder>\n            </form>\n          </ng-container>\n          <ng-container *ngSwitchDefault>\n            <ng-container *ngIf=\"searchedMembers$ | async as searchedMembers\">\n              <table class=\"fsw-table w-full\">\n                <thead>\n                  <tr>\n                    <th>{{ 'table.full_name' | fswTranslate }}</th>\n                    <th>{{ 'table.id' | fswTranslate }}</th>\n                    <th>{{ 'table.entity_type' | fswTranslate }}</th>\n                    <th>{{ 'table.company_name' | fswTranslate }}</th>\n                    <th>{{ 'table.email_address' | fswTranslate }}</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <ng-container *ngFor=\"let member of searchedMembers.data || []\">\n                    <tr\n                      class=\"cursor-pointer\"\n                      [class.bg-green-200]=\"member.uuid === (selected$ | async)?.uuid\"\n                      (click)=\"selected$.next(member)\"\n                    >\n                      <td>{{ member?.fullname }}</td>\n                      <td>{{ member?.id }}</td>\n                      <td>{{ member?.member_entity_code }}</td>\n                      <td>{{ member?.company_name }}</td>\n                      <td>{{ member?.username }}</td>\n                    </tr>\n                  </ng-container>\n                </tbody>\n                <tfoot *ngIf=\"searchedMembers.total\">\n                  <tr>\n                    <td [colSpan]=\"5\">\n                      <div class=\"flex justify-start\">\n                        <fsw-pagination\n                          [total]=\"searchedMembers.total\"\n                          [itemsPerPage]=\"size$.value\"\n                          [currentPage]=\"page$.value\"\n                          (itemsPerPageChange)=\"size$.next($event)\"\n                          (currentPageChange)=\"page$.next($event)\"\n                        ></fsw-pagination>\n                      </div>\n                    </td>\n                  </tr>\n                </tfoot>\n              </table>\n            </ng-container>\n          </ng-container>\n        </ng-container>\n      </main>\n    </section>\n  </ng-template>\n</fsw-modal>\n", dependencies: [{ kind: "directive", type: i1$4.FSWDynamicBuilderTemplateDirective, selector: "[fswDynamicBuilderTemplate]", inputs: ["key"] }, { kind: "component", type: i1$4.FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: ["builder", "dictionaries"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$4.FSWModalBodyDirective, selector: "ng-template[fswModalBody]" }, { kind: "component", type: i1$4.FSWModalComponent, selector: "fsw-modal", inputs: ["title", "confirmButton", "confirmButtonAppearance", "confirmButtonSize", "confirmButtonDisabled", "cancelButton", "cancelButtonAppearance", "cancelButtonSize", "cancelButtonDisabled", "hiddenCloseButton", "hiddenBody", "hiddenFooter", "closeOnConfirm", "closeOnCancel", "size", "buttonStyle", "buttonDirection", "fullBlock", "bodyCustomClasses", "customWidth"], outputs: ["closeEvent", "confirmEvent", "cancelEvent", "afterOpenedEvent", "afterClosedEvent"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$4.FSWFieldInputSuffixDirective, selector: "ng-template[fswFieldInputSuffix]" }, { kind: "directive", type: i1$4.FSWInputDirective, selector: "input[fswInput], textarea[fswInput]" }, { kind: "component", type: i1$4.FSWPaginationComponent, selector: "fsw-pagination", inputs: ["total", "itemsPerPage", "currentPage", "itemsPerPageOptions", "showSelectOptions", "showViewTotalText", "showNavigationText", "totalTextInside"], outputs: ["currentPageChange", "itemsPerPageChange"] }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i1$1.DatePipe, name: "date" }, { kind: "pipe", type: FSWPartnerSearchTemplatePipe, name: "fswPartnerSearchTemplate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPartnerSearchReplaceComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-partner-search-replace', changeDetection: ChangeDetectionStrategy.OnPush, template: "<fsw-modal\n  [size]=\"'l'\"\n  [title]=\"\n    dialogRef.config.data['title'] | fswTranslate : { data: dialogRef.config.data['titleParams'] }\n  \"\n  [confirmButton]=\"dialogRef.config.data['confirmButtonText'] | fswTranslate\"\n  [cancelButton]=\"dialogRef.config.data['cancelButtonText'] | fswTranslate\"\n  [bodyCustomClasses]=\"'max-h-[calc(90vh-138px)] overflow-y-auto'\"\n  (confirmEvent)=\"replace()\"\n  (cancelEvent)=\"close()\"\n  (closeEvent)=\"close()\"\n>\n  <ng-template fswModalBody>\n    <section class=\"flex flex-col gap-[16px]\">\n      <header class=\"flex items-center gap-[8px]\">\n        <fsw-field [flexWidth]=\"true\">\n          <input\n            fswInput\n            [placeholder]=\"'modal.search' | fswTranslate\"\n            [formControl]=\"searchControl\"\n            (keyup.enter)=\"search()\"\n          />\n          <ng-template fswFieldInputSuffix>\n            <button fswButton [appearance]=\"'link'\" (click)=\"search()\">\n              <span>Search</span>\n              <i [fswIcon]=\"'common-search'\"></i>\n            </button>\n          </ng-template>\n        </fsw-field>\n      </header>\n      <main class=\"w-full overflow-x-auto\">\n        <ng-container [ngSwitch]=\"type$ | async\">\n          <ng-container *ngSwitchCase=\"'add'\">\n            <form [formGroup]=\"builder.groupConfig.form\">\n              <fsw-dynamic-builder [builder]=\"builder\">\n                <ng-template fswDynamicBuilderTemplate key=\"district\" let-value>\n                  {{\n                    value\n                      | fswPartnerSearchTemplate\n                        : { stateKey: 'districts', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"province\" let-value>\n                  {{\n                    value\n                      | fswPartnerSearchTemplate\n                        : { stateKey: 'provinces', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"industry\" let-value>\n                  {{\n                    value\n                      | fswPartnerSearchTemplate\n                        : { stateKey: 'industries', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"sub_industry\" let-value>\n                  {{\n                    value\n                      | fswPartnerSearchTemplate\n                        : { stateKey: 'subIndustries', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"gender\" let-value>\n                  {{\n                    value\n                      | fswPartnerSearchTemplate\n                        : { stateKey: 'genders', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"city\" let-value>\n                  {{\n                    value\n                      | fswPartnerSearchTemplate\n                        : { stateKey: 'cities', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"country\" let-value>\n                  {{\n                    value\n                      | fswPartnerSearchTemplate\n                        : { stateKey: 'countries', labelKey: 'name', compareKey: 'code' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"company_entity_id\" let-value>\n                  {{\n                    value\n                      | fswPartnerSearchTemplate\n                        : { stateKey: 'companyEntityTypes', labelKey: 'name', compareKey: 'id' }\n                  }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"basic\" let-value>\n                  {{ value ?? 'N/A' }}\n                </ng-template>\n                <ng-template fswDynamicBuilderTemplate key=\"date\" let-value>\n                  {{ value ? (value | date : 'dd/MM/yyyy') : 'N/A' }}\n                </ng-template>\n              </fsw-dynamic-builder>\n            </form>\n          </ng-container>\n          <ng-container *ngSwitchDefault>\n            <ng-container *ngIf=\"searchedMembers$ | async as searchedMembers\">\n              <table class=\"fsw-table w-full\">\n                <thead>\n                  <tr>\n                    <th>{{ 'table.full_name' | fswTranslate }}</th>\n                    <th>{{ 'table.id' | fswTranslate }}</th>\n                    <th>{{ 'table.entity_type' | fswTranslate }}</th>\n                    <th>{{ 'table.company_name' | fswTranslate }}</th>\n                    <th>{{ 'table.email_address' | fswTranslate }}</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <ng-container *ngFor=\"let member of searchedMembers.data || []\">\n                    <tr\n                      class=\"cursor-pointer\"\n                      [class.bg-green-200]=\"member.uuid === (selected$ | async)?.uuid\"\n                      (click)=\"selected$.next(member)\"\n                    >\n                      <td>{{ member?.fullname }}</td>\n                      <td>{{ member?.id }}</td>\n                      <td>{{ member?.member_entity_code }}</td>\n                      <td>{{ member?.company_name }}</td>\n                      <td>{{ member?.username }}</td>\n                    </tr>\n                  </ng-container>\n                </tbody>\n                <tfoot *ngIf=\"searchedMembers.total\">\n                  <tr>\n                    <td [colSpan]=\"5\">\n                      <div class=\"flex justify-start\">\n                        <fsw-pagination\n                          [total]=\"searchedMembers.total\"\n                          [itemsPerPage]=\"size$.value\"\n                          [currentPage]=\"page$.value\"\n                          (itemsPerPageChange)=\"size$.next($event)\"\n                          (currentPageChange)=\"page$.next($event)\"\n                        ></fsw-pagination>\n                      </div>\n                    </td>\n                  </tr>\n                </tfoot>\n              </table>\n            </ng-container>\n          </ng-container>\n        </ng-container>\n      </main>\n    </section>\n  </ng-template>\n</fsw-modal>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PARTNER_SEARCH_STORE_TOKEN]
                }] }, { type: i1$7.DialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MEMBER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: i1$7.Dialog }, { type: i0.Injector }]; } });

class FSWPartnerSearchComponent {
    set applicationId(applicationId) {
        this.componentStore.updateState({
            applicationId,
        });
    }
    set isReadonly(isReadonly) {
        this.componentStore.updateState({
            isReadonly,
        });
    }
    constructor(componentStore, _alertService, _dialog, _injector) {
        this.componentStore = componentStore;
        this._alertService = _alertService;
        this._dialog = _dialog;
        this._injector = _injector;
        this.actionSelected = new EventEmitter();
        this.actionClear = new EventEmitter();
        this.partnerFullName = '';
        this.builder = this.componentStore.builder;
        this.state$ = this.componentStore.state$;
        this.partnerControl = new UntypedFormControl({
            value: '',
            disabled: true,
        });
    }
    ngOnInit() {
        this.componentStore.init();
        if (this.partnerFullName) {
            this.partnerControl.setValue(this.partnerFullName);
        }
    }
    submit() {
        if (this.builder.groupConfig.form.invalid) {
            this._alertService.warning('Invalid Information', 'Please make sure all mandatory fields are filled', {
                duration: 3000,
            });
            return;
        }
        this._dialog
            .open(FSWPartnerSearchConfirmComponent, {
            data: {
                title: 'modal.confirm_save.title',
                titleParams: {},
                description: 'modal.confirm_save.description',
                descriptionParams: {},
                yesButtonText: 'modal.confirm_save.yes',
                noButtonText: 'modal.confirm_save.no',
            },
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((result) => {
            if (result) {
                this.componentStore.save();
            }
        }))
            .subscribe();
    }
    cancel() {
        this._dialog
            .open(FSWPartnerSearchConfirmComponent, {
            data: {
                title: 'modal.confirm_cancel.title',
                titleParams: {},
                description: 'modal.confirm_cancel.description',
                descriptionParams: {},
                yesButtonText: 'modal.confirm_cancel.yes',
                noButtonText: 'modal.confirm_cancel.no',
            },
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((result) => {
            if (result) {
                this.componentStore.patchMemberToBuilder();
                this.componentStore.updateState({ isEditable: false });
            }
        }))
            .subscribe();
    }
    replace(type) {
        this._dialog
            .open(FSWPartnerSearchReplaceComponent, {
            data: {
                title: `modal.title`,
                titleParams: {},
                description: `modal.confirm_${type}.description`,
                descriptionParams: {},
                yesButtonText: `modal.confirm_${type}.yes`,
                noButtonText: `modal.confirm_${type}.no`,
                confirmButtonText: `buttons.${type}_borrower`,
                cancelButtonText: `buttons.cancel`,
            },
            injector: this._injector,
        })
            .closed.pipe(take(1), tap((action) => {
            if (action) {
                const data = action.data;
                this.partnerControl.setValue(data?.fullname);
                this.actionSelected.emit({
                    data,
                });
            }
        }))
            .subscribe();
    }
    clear() {
        this.partnerControl.setValue('');
        this.actionClear.emit({ data: 'reset' });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPartnerSearchComponent, deps: [{ token: FSW_PARTNER_SEARCH_STORE_TOKEN }, { token: FSW_ALERT_SERVICE_TOKEN }, { token: i1$7.Dialog }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWPartnerSearchComponent, selector: "fsw-partner-search", inputs: { applicationId: "applicationId", isReadonly: "isReadonly", partnerFullName: "partnerFullName" }, outputs: { actionSelected: "actionSelected", actionClear: "actionClear" }, ngImport: i0, template: "<div *ngIf=\"state$ | async as state\">\n  <fsw-field [fullWidth]=\"true\">\n    <ng-template fswFieldHeaderPrefix [label]=\"'forms.partner_id' | fswTranslate\"></ng-template>\n    <input fswInput [placeholder]=\"'modal.search' | fswTranslate\" [formControl]=\"partnerControl\" />\n    <ng-template fswFieldInputSuffix>\n      <span>\n        <a\n          fswButton\n          [appearance]=\"'link'\"\n          [disabled]=\"state.isReadonly\"\n          (click)=\"!state.isReadonly && replace('replace')\"\n          ><span> <i [fswIcon]=\"'common-search'\"></i> </span\n        ></a>\n      </span>\n\n      <span>\n        <a\n          fswButton\n          [appearance]=\"'link'\"\n          [disabled]=\"state.isReadonly\"\n          (click)=\"!state.isReadonly && clear()\"\n          ><span> <i [fswIcon]=\"'common-delete'\"></i> </span\n        ></a>\n      </span>\n    </ng-template>\n  </fsw-field>\n</div>\n", dependencies: [{ kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "component", type: i1$4.FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: i1$4.FSWFieldInputSuffixDirective, selector: "ng-template[fswFieldInputSuffix]" }, { kind: "directive", type: i1$4.FSWFieldHeaderPrefixDirective, selector: "ng-template[fswFieldHeaderPrefix]", inputs: ["kind", "label", "required"] }, { kind: "directive", type: i1$4.FSWInputDirective, selector: "input[fswInput], textarea[fswInput]" }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPartnerSearchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-partner-search', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"state$ | async as state\">\n  <fsw-field [fullWidth]=\"true\">\n    <ng-template fswFieldHeaderPrefix [label]=\"'forms.partner_id' | fswTranslate\"></ng-template>\n    <input fswInput [placeholder]=\"'modal.search' | fswTranslate\" [formControl]=\"partnerControl\" />\n    <ng-template fswFieldInputSuffix>\n      <span>\n        <a\n          fswButton\n          [appearance]=\"'link'\"\n          [disabled]=\"state.isReadonly\"\n          (click)=\"!state.isReadonly && replace('replace')\"\n          ><span> <i [fswIcon]=\"'common-search'\"></i> </span\n        ></a>\n      </span>\n\n      <span>\n        <a\n          fswButton\n          [appearance]=\"'link'\"\n          [disabled]=\"state.isReadonly\"\n          (click)=\"!state.isReadonly && clear()\"\n          ><span> <i [fswIcon]=\"'common-delete'\"></i> </span\n        ></a>\n      </span>\n    </ng-template>\n  </fsw-field>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_PARTNER_SEARCH_STORE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_ALERT_SERVICE_TOKEN]
                }] }, { type: i1$7.Dialog }, { type: i0.Injector }]; }, propDecorators: { actionSelected: [{
                type: Output
            }], actionClear: [{
                type: Output
            }], applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], partnerFullName: [{
                type: Input
            }] } });

class FSWPartnerSearchDirective {
    constructor(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
        this.actionSelected = new EventEmitter();
        this.actionClear = new EventEmitter();
        this.applicationId = null;
        this.isReadonly = false;
        this.partnerFullName = '';
        this._destroyed$ = new EventEmitter();
    }
    ngOnChanges() {
        this._viewContainerRef.clear();
        const ref = this._viewContainerRef.createComponent(FSWPartnerSearchComponent, {
            injector: Injector.create({
                parent: this._viewContainerRef.injector,
                providers: [...partnerSearchLoadProviders(getCountryCodeFromStorage())],
            }),
        });
        const instance = ref.instance;
        instance.applicationId = this.applicationId;
        instance.isReadonly = this.isReadonly;
        instance.partnerFullName = this.partnerFullName;
        instance.actionSelected
            .pipe(takeUntil$1(this._destroyed$))
            .subscribe((res) => this.actionSelected.emit(res));
        instance.actionClear
            .pipe(takeUntil$1(this._destroyed$))
            .subscribe(() => this.actionClear.emit({ data: 'reset' }));
        ref.changeDetectorRef.detectChanges();
    }
    ngOnDestroy() {
        this._viewContainerRef.clear();
        this._destroyed$.complete();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPartnerSearchDirective, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWPartnerSearchDirective, selector: "[fswPartnerSearch]", inputs: { applicationId: "applicationId", isReadonly: "isReadonly", partnerFullName: "partnerFullName" }, outputs: { actionSelected: "actionSelected", actionClear: "actionClear" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPartnerSearchDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswPartnerSearch]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; }, propDecorators: { actionSelected: [{
                type: Output
            }], actionClear: [{
                type: Output
            }], applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], partnerFullName: [{
                type: Input
            }] } });

class FSWPartnerSearchModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPartnerSearchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWPartnerSearchModule, declarations: [FSWPartnerSearchComponent,
            FSWPartnerSearchDirective,
            FSWPartnerSearchTemplatePipe,
            FSWPartnerSearchConfirmComponent,
            FSWPartnerSearchReplaceComponent], imports: [i1$4.FSWTranslateModule, ApplicationMemberServiceModule,
            MemberServiceModule,
            MasterDataServiceModule,
            ReferenceServiceModule,
            FSWPanelModule,
            FSWDynamicBuilderModule,
            ReactiveFormsModule,
            FSWButtonModule,
            FSWModalModule$1,
            AsyncPipe,
            NgIf,
            DatePipe,
            NgSwitch,
            NgSwitchCase,
            NgSwitchDefault,
            NgForOf,
            FSWIconModule,
            FSWFieldModule,
            FSWInputModule,
            FSWPaginationModule$1], exports: [FSWPartnerSearchComponent,
            FSWPartnerSearchDirective,
            FSWPartnerSearchTemplatePipe,
            FSWPartnerSearchConfirmComponent,
            FSWPartnerSearchReplaceComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPartnerSearchModule, imports: [FSWTranslateModule.forFeature({
                scope: 'partner-search',
                defaultKey: CountryCode.TH,
                data: FSW_PARTNER_SEARCH_TRANSLATION_LOADER,
            }),
            ApplicationMemberServiceModule,
            MemberServiceModule,
            MasterDataServiceModule,
            ReferenceServiceModule,
            FSWPanelModule,
            FSWDynamicBuilderModule,
            ReactiveFormsModule,
            FSWButtonModule,
            FSWModalModule$1,
            FSWIconModule,
            FSWFieldModule,
            FSWInputModule,
            FSWPaginationModule$1] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPartnerSearchModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FSWPartnerSearchComponent,
                        FSWPartnerSearchDirective,
                        FSWPartnerSearchTemplatePipe,
                        FSWPartnerSearchConfirmComponent,
                        FSWPartnerSearchReplaceComponent,
                    ],
                    exports: [
                        FSWPartnerSearchComponent,
                        FSWPartnerSearchDirective,
                        FSWPartnerSearchTemplatePipe,
                        FSWPartnerSearchConfirmComponent,
                        FSWPartnerSearchReplaceComponent,
                    ],
                    imports: [
                        FSWTranslateModule.forFeature({
                            scope: 'partner-search',
                            defaultKey: CountryCode.TH,
                            data: FSW_PARTNER_SEARCH_TRANSLATION_LOADER,
                        }),
                        ApplicationMemberServiceModule,
                        MemberServiceModule,
                        MasterDataServiceModule,
                        ReferenceServiceModule,
                        FSWPanelModule,
                        FSWDynamicBuilderModule,
                        ReactiveFormsModule,
                        FSWButtonModule,
                        FSWModalModule$1,
                        AsyncPipe,
                        NgIf,
                        DatePipe,
                        NgSwitch,
                        NgSwitchCase,
                        NgSwitchDefault,
                        NgForOf,
                        FSWIconModule,
                        FSWFieldModule,
                        FSWInputModule,
                        FSWPaginationModule$1,
                    ],
                }]
        }] });

var title = "Business Interest Parties";
var no_data = "No data";
var columns = {
	history: "",
	name: "Name",
	id_number: "ID Number",
	designation: "Designation",
	ownership: "Ownership",
	date_of_birth: "Date of Birth",
	recourse_type: "Recourse Type",
	reference_to: "Reference to",
	link: "Link to Application",
	last_pull: "Last Pull",
	last_pull_by: "Last Pull By",
	report: "Report"
};
var buttons = {
	link: "Link",
	linked: "Linked",
	not_yet_linked: "Not yet linked",
	unlink: "Unlink",
	refresh: "Refresh"
};
var tables = {
	internal: "Member BIPs",
	external: "Frankenstein BIPs"
};
var frankensteinBipsAll = {
	title: title,
	no_data: no_data,
	columns: columns,
	buttons: buttons,
	tables: tables
};

var ALL = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttons: buttons,
    columns: columns,
    default: frankensteinBipsAll,
    no_data: no_data,
    tables: tables,
    title: title
});

const FSW_FRANKENSTEIN_BIPS_ALL_TRANSLATION = ALL;

const injectFrankensteinBipsAllEffects = ({ actions, signals, }) => {
    const services = {
        memberV3: injectFSWMemberServiceV3(),
        member: injectMemberService(),
        applicationMemberBIP: injectApplicationMemberBIPService(),
        applicationMember: injectApplicationMemberService(),
        applicationGuarantor: injectApplicationGuarantorService(),
        creditGuarantor: injectCreditGuarantorService(),
        creditBorrowerSummary: injectCreditBorrowerSummaryService(),
        questnet: injectQuestnetService(),
        alert: inject(FSW_ALERT_SERVICE_TOKEN),
    };
    const internalSignals = {
        items: signal([]),
        applicationMember: signal(null),
        member: signal(null),
        history: signal({}),
    };
    const helperFunctions = {
        generateBorrower: () => {
            const member = internalSignals.member();
            if (!member) {
                return null;
            }
            return {
                reference_to: 'BORROWER',
                reference_id: member.uuid,
                expand: {
                    recourseType: 'Borrower',
                    name: member.companyName,
                    idNumber: member.companyRegistrationNumber,
                    birth_date: member.companyBirthDate,
                    company_birth_date: member.companyBirthDate,
                },
            };
        },
    };
    const asyncFunctions = {
        loadApplicationMemberAsync: () => {
            const member = internalSignals.applicationMember();
            if (member) {
                return of(member);
            }
            return services.applicationMember
                .getApplicationMembers(signals.applicationId())
                .pipe(map((members) => members?.[0]), tap((value) => {
                internalSignals.applicationMember.set(value);
                if (!value) {
                    services.alert.error('Error', '[Frankenstein] Member not found', {
                        duration: 3000,
                    });
                }
            }), filter((value) => !!value));
        },
        loadMemberAsync: () => {
            return asyncFunctions.loadApplicationMemberAsync().pipe(switchMap$1((member) => services.member.getSingleMember(member.member_id_int)), tap((value) => {
                internalSignals.member.set(value);
                if (!value) {
                    services.alert.error('Error', '[Frankenstein] Member not found', {
                        duration: 3000,
                    });
                }
            }), filter((value) => !!value));
        },
        loadApplicationBipsAsync: () => {
            return asyncFunctions.loadApplicationMemberAsync().pipe(switchMap$1((member) => services.applicationMemberBIP
                .getApplicationMemberBIPs(signals.applicationId(), member.member_id, {
                expand: true,
                limit: 100,
                page: 1,
            })
                .pipe(map((bips) => bips || []), map((bips) => ({
                bips,
                ids: bips.map((b) => b.reference_id),
            })))));
        },
        loadFrankensteinBipsAsync: () => {
            return asyncFunctions.loadApplicationMemberAsync().pipe(switchMap$1((member) => forkJoin([
                services.memberV3.getCompanyLinks(member.company?.uuid).pipe(map((links) => (links || []).map((link) => ({
                    reference_to: 'COMPANY',
                    reference_id: link.relatedCompanyUuid,
                    expand: FSWFrankensteinModel.transformCompanyToExpand({
                        ...link.relatedCompany,
                        relation: link.relatedCompany.relation ?? link.relation,
                        shares: link.shares.map((share) => ({
                            ...share,
                            amount: share.amount ?? share.numberOfShares,
                        })),
                    }),
                })))),
                services.memberV3.getIndividualLinks(member.company?.uuid).pipe(map((links) => (links || []).map((link) => ({
                    reference_to: 'INDIVIDUAL',
                    reference_id: link.individualUuid,
                    expand: FSWFrankensteinModel.transformIndividualToExpand({
                        ...link.individual,
                        relation: link.individual.relation ?? link.relation,
                        shares: link.shares.map((share) => ({
                            ...share,
                            amount: share.amount ?? share.numberOfShares,
                        })),
                    }),
                })))),
            ]).pipe(map(([companies, individuals]) => [...companies, ...individuals]))));
        },
        loadBipsAsync: () => {
            return forkJoin([
                asyncFunctions.loadApplicationBipsAsync(),
                asyncFunctions.loadFrankensteinBipsAsync(),
            ]).pipe(tapResponse(([{ bips, ids }, links]) => {
                const mappedLinks = links
                    .filter((item) => item.reference_id)
                    .map((item) => ({
                    id: bips.find((b) => b.reference_id === item.reference_id)?.id,
                    ...item,
                    expand: {
                        ...item.expand,
                        linked: ids.includes(item.reference_id),
                    },
                }));
                const borrower = helperFunctions.generateBorrower();
                internalSignals.items.set([...(borrower ? [borrower] : []), ...mappedLinks]);
            }, (err) => {
                console.error('[Frankenstein]', err);
                services.alert.error('Error', '[Frankenstein] Failed to get bips', {
                    duration: 3000,
                });
            }));
        },
        loadHistoryAsync: (params) => {
            return services.questnet.fetchHistory(services.questnet.buildParams(params)).pipe(map((histories) => (histories || []).sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())), map((histories) => [params.entityNo, histories]));
        },
    };
    const functions = {
        reloadBips: () => {
            asyncFunctions
                .loadApplicationMemberAsync()
                .pipe(switchMap$1((member) => {
                return asyncFunctions.loadMemberAsync().pipe(switchMap$1(() => {
                    if (!member.company?.uuid) {
                        const borrower = helperFunctions.generateBorrower();
                        internalSignals.items.set(borrower ? [borrower] : []);
                        return of([]);
                    }
                    return asyncFunctions.loadBipsAsync();
                }));
            }))
                .subscribe();
        },
        reloadHistories() {
            const items = internalSignals.items();
            if (!items.length) {
                internalSignals.history.set({});
                return;
            }
            forkJoin(items.map((item) => asyncFunctions.loadHistoryAsync({
                entityNo: item.expand.idNumber,
                entityName: item.expand.name,
            })))
                .pipe(tapResponse((histories) => {
                const history = histories.reduce((acc, cur) => {
                    return {
                        ...acc,
                        [cur[0]]: cur[1],
                    };
                }, {});
                internalSignals.history.set(history);
            }, (err) => {
                console.error('[Frankenstein]', err);
                services.alert.error('Error', '[Frankenstein] Failed to get history', {
                    duration: 3000,
                });
            }))
                .subscribe();
        },
        link: (item, member) => {
            let obs$ = services.applicationMemberBIP.linkMemberBips(signals.applicationId(), {
                ...omit(item, 'expand'),
                memberId: member.uuid,
            });
            if (['CG', 'PG'].includes(item.expand.recourseType)) {
                if (item.expand.recourseType === 'PG') {
                    obs$ = services.creditGuarantor
                        .extract({
                        source: 'questnet',
                        member_uuid: member.uuid,
                        identifiers: [item.expand.idNumber],
                    })
                        .pipe(map((guarantors) => guarantors?.shift()), tap((guarantor) => {
                        if (!guarantor?.summary) {
                            throw new Error('BRI report not available. Please pull the questnet report for the BIP before linking to the application');
                        }
                    }), map((guarantor) => transformPersonalGuarantor({
                        ...guarantor.summary,
                        id_number: guarantor.identifier,
                        name: item.expand.name,
                        negative_and_black_list: guarantor.summary.negative_and_black_list ??
                            guarantor.summary['negative_blacklist'],
                        date_of_birth: toTimezoneHourOffset(guarantor.summary.date_of_birth, 'down'),
                    })), switchMap$1((guarantor) => services.creditGuarantor.addPersonalSummaries([guarantor])), map((guarantor) => ({
                        guarantor_summary_id: guarantor[0].id,
                        guarantor_summary_type: FSWRecourseTypes.PG,
                        business_interest_party_id: item.reference_id,
                        ...(item.reference_to !== 'MEMBER_BIP'
                            ? {
                                reference_to: item.reference_to,
                            }
                            : {}),
                    })), switchMap$1((applicationGuarantor) => services.applicationGuarantor.addSummaries(signals.applicationId(), [
                        applicationGuarantor,
                    ])));
                }
                else {
                    obs$ = services.creditBorrowerSummary
                        .extract({
                        source: 'questnet',
                        company_registration_number: item.expand.idNumber, // member.companyRegistrationNumber,
                    })
                        .pipe(tap((company) => {
                        if (!company) {
                            throw new Error('BRC report not available. Please pull the questnet report for the BIP before linking to the application');
                        }
                    }), map((company) => ({ company })), switchMap$1((guarantor) => services.creditGuarantor.addCorporateSummaries([
                        transformCompanyGuarantor(guarantor),
                    ])), map((guarantor) => ({
                        guarantor_summary_id: guarantor[0].id,
                        guarantor_summary_type: FSWRecourseTypes.CG,
                        business_interest_party_id: item.reference_id,
                        ...(item.reference_to !== 'MEMBER_BIP'
                            ? {
                                reference_to: item.reference_to,
                            }
                            : {}),
                    })), switchMap$1((applicationGuarantor) => services.applicationGuarantor.addSummaries(signals.applicationId(), [
                        applicationGuarantor,
                    ])));
                }
            }
            obs$
                .pipe(tapResponse(() => {
                services.alert.success('Success', '[Frankenstein] Success linked', {
                    duration: 3000,
                });
                functions.reloadBips();
                actions.linked();
            }, (err) => {
                console.error('[Frankenstein]', err);
                services.alert.error('Something went wrong', err['message'] || '[Frankenstein] Failed to link', {
                    duration: 3000,
                });
            }))
                .subscribe();
        },
        unlink: (item, member) => {
            if (!item.id) {
                return;
            }
            services.applicationMemberBIP
                .deleteMemberBip(signals.applicationId(), member.uuid, item.id)
                .pipe(tapResponse(() => {
                services.alert.success('Success', '[Frankenstein] Success unlinked', {
                    duration: 3000,
                });
                functions.reloadBips();
                actions.unlinked();
            }, (err) => {
                console.error('[Frankenstein]', err);
                services.alert.error('Error', '[Frankenstein] Failed to unlink', {
                    duration: 3000,
                });
            }))
                .subscribe();
        },
    };
    effect(() => functions.reloadHistories(), { allowSignalWrites: true });
    return {
        signals: {
            items: internalSignals.items.asReadonly(),
            history: internalSignals.history.asReadonly(),
        },
        actions: {
            link: (item) => {
                if (signals.isReadonly()) {
                    return;
                }
                const member = internalSignals.member();
                if (!member) {
                    services.alert.error('Error', '[Frankenstein] Member is required', {
                        duration: 3000,
                    });
                    return;
                }
                functions.link(item, member);
            },
            unlink: (item) => {
                if (signals.isReadonly()) {
                    return;
                }
                const member = internalSignals.member();
                if (!member) {
                    services.alert.error('Error', '[Frankenstein] Member is required', {
                        duration: 3000,
                    });
                    return;
                }
                functions.unlink(item, member);
            },
            reload: () => functions.reloadBips(),
            download: (reportId) => {
                services.questnet
                    .downloadReport(reportId)
                    .pipe(tap((blobParts) => {
                    const blob = new Blob([blobParts], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(blob);
                    window.open(url, '_blank');
                }))
                    .subscribe();
            },
            pull: (item) => {
                const history = internalSignals.history()[item.expand.idNumber];
                services.questnet
                    .pull(services.questnet.buildParams({
                    entityNo: item.expand.idNumber,
                    entityName: item.expand.name,
                    ...(history?.length ? { previousReportId: history[0].id } : {}),
                    ...(item.expand.recourseType === 'Borrower' ? { memberUUID: item.reference_id } : {}),
                }))
                    .pipe(switchMap$1(() => asyncFunctions
                    .loadHistoryAsync({
                    entityNo: item.expand.idNumber,
                    entityName: item.expand.name,
                })
                    .pipe(tapResponse(([key, histories]) => {
                    services.alert.success('Success', '[Frankenstein] Success pulled', {
                        duration: 3000,
                    });
                    actions.pulled();
                    internalSignals.history.set({
                        ...internalSignals.history(),
                        [key]: histories,
                    });
                }, (err) => {
                    console.error('[Frankenstein] pull', err);
                    services.alert.error('Error', '[Frankenstein] Failed to pull', {
                        duration: 3000,
                    });
                }))))
                    .subscribe();
            },
        },
    };
};

function frankensteinLinkTranslation(scope = 'frankenstein_bips') {
    return [
        ...(FSWTranslateModule.forFeature({
            scope,
            defaultKey: getCountryCodeFromStorage() ?? CountryCode.SG,
            data: {
                [CountryCode.MY]: FSW_FRANKENSTEIN_BIPS_ALL_TRANSLATION,
                [CountryCode.SG]: FSW_FRANKENSTEIN_BIPS_ALL_TRANSLATION,
                [CountryCode.ID]: FSW_FRANKENSTEIN_BIPS_ALL_TRANSLATION,
                [CountryCode.VU]: FSW_FRANKENSTEIN_BIPS_ALL_TRANSLATION,
                [CountryCode.TH]: FSW_FRANKENSTEIN_BIPS_ALL_TRANSLATION,
            },
        }).providers || []),
        fswTranslateScope(scope),
    ];
}

class FSWFrankensteinBipsTableComponent {
    constructor() {
        this.linkEvent = new EventEmitter();
        this.unlinkEvent = new EventEmitter();
        this.downloadEvent = new EventEmitter();
        this.pullEvent = new EventEmitter();
        this.data = [];
        this.isReadonly = false;
        this.historySignal = signal({});
        this.expandSignal = signal({});
        this.expandKeys = computed(() => Object.keys(this.expandSignal()));
    }
    set history(value) {
        this.historySignal.set(value || {});
        this.expandSignal.set(Object.keys(this.historySignal()).reduce((acc, key) => {
            if (this.historySignal()[key].length > 1) {
                acc[key] = this.expandSignal()[key];
            }
            return { ...acc };
        }, {}));
    }
    toggleExpand(entity) {
        const expand = this.expandSignal();
        this.expandSignal.set({
            ...expand,
            [entity.expand.idNumber]: !expand[entity.expand.idNumber],
        });
    }
    getHistories(entity, ignoreFirst = false) {
        const histories = [...(this.historySignal()[entity.expand.idNumber] || [])];
        if (ignoreFirst) {
            histories.shift();
        }
        return histories;
    }
    getLastHistory(entity) {
        return this.getHistories(entity)[0] || null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFrankensteinBipsTableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWFrankensteinBipsTableComponent, isStandalone: true, selector: "fsw-frankenstein-bips-table", inputs: { data: "data", isReadonly: "isReadonly", history: "history" }, outputs: { linkEvent: "linkEvent", unlinkEvent: "unlinkEvent", downloadEvent: "downloadEvent", pullEvent: "pullEvent" }, providers: [frankensteinLinkTranslation('frankenstein_bips_table')], ngImport: i0, template: `
    <table class="fsw-table !table-auto w-full fsw-table--bordered">
      <thead>
        <tr>
          <th
            class="align-middle"
            *ngFor="
              let column of [
                'columns.name',
                'columns.id_number',
                'columns.designation',
                'columns.ownership',
                'columns.date_of_birth',
                'columns.recourse_type',
                'columns.reference_to',
                'columns.last_pull',
                'columns.last_pull_by',
                'columns.report'
              ]
            "
          >
            {{ column | fswTranslate : { scope: 'frankenstein_bips_table' } }}
          </th>
          <th [colSpan]="isReadonly ? 1 : 2" class="align-middle">
            {{ 'columns.link' | fswTranslate : { scope: 'frankenstein_bips_table' } }}
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of data">
          <tr>
            <td class="align-middle">
              <label class="inline-flex items-center gap-[8px]">
                <span class="w-[20px] inline-flex items-center">
                  <ng-container *ngIf="item.expand.idNumber as idNumber">
                    <span
                      *ngIf="expandKeys().includes(idNumber)"
                      class="transform inline-flex items-center"
                      [class.-rotate-90]="!expandSignal()[idNumber]"
                      (click)="toggleExpand(item)"
                    >
                      <i
                        [fswIcon]="'common-arrow-dropdown'"
                        [fontSize]="'20px'"
                        class="text-blue-500"
                      ></i>
                    </span>
                  </ng-container>
                </span>
                <span>{{ item.expand.name ?? '--' }}</span>
              </label>
            </td>
            <td class="align-middle">
              {{ item.expand.idNumber ?? '--' }}
            </td>
            <td class="align-middle">
              {{ item.expand.designation ?? '--' }}
            </td>
            <td class="align-middle">
              {{ item.expand.ownership ?? '--' }}
            </td>
            <td class="align-middle">
              {{
                (item.expand.birth_date || item.expand.company_birth_date | date : 'dd/MM/yyyy') ||
                  '--'
              }}
            </td>
            <td class="align-middle">
              {{ item.expand.recourseType ?? '--' }}
            </td>
            <td class="align-middle">
              {{ item.reference_to ?? '--' }}
            </td>
            <td class="align-middle">
              {{
                getLastHistory(item)?.createdAt
                  ? (getLastHistory(item)?.createdAt | date : 'dd/MM/yyyy') || '--'
                  : '--'
              }}
            </td>
            <td class="align-middle">
              {{ getLastHistory(item)?.createdBy || '--' }}
            </td>
            <td class="align-middle">
              <div class="flex gap-[8px] items-center">
                <button
                  *ngIf="getLastHistory(item)?.id as reportId"
                  fswButton
                  [appearance]="'icon-with-bg'"
                  (click)="downloadEvent.emit(reportId)"
                >
                  <i fswIcon="common-download"></i>
                </button>
                <button
                  *ngIf="!isReadonly"
                  fswButton
                  [appearance]="'icon-with-bg'"
                  (click)="pullEvent.emit(item)"
                >
                  <i fswIcon="status-ongoing"></i>
                </button>
              </div>
            </td>
            <ng-container *ngIf="item.expand.recourseType !== 'Borrower'; else borrowerTemplate">
              <td class="align-middle">
                <ng-container *ngIf="item.expand.linked; else notLinkedTemplate">
                  <span class="text-green-500">
                    {{ 'buttons.linked' | fswTranslate : { scope: 'frankenstein_bips_table' } }}
                  </span>
                </ng-container>
                <ng-template #notLinkedTemplate>
                  <span class="text-yellow-500">
                    {{
                      'buttons.not_yet_linked' | fswTranslate : { scope: 'frankenstein_bips_table' }
                    }}
                  </span>
                </ng-template>
              </td>
              <td class="align-middle" *ngIf="!isReadonly">
                <ng-container *ngIf="item.expand.linked; else notLinkedTemplate">
                  <button
                    fswButton
                    class="fsw-button-error"
                    (click)="unlinkEvent.emit(item)"
                    [appearance]="'secondary-elevate'"
                  >
                    {{ 'buttons.unlink' | fswTranslate : { scope: 'frankenstein_bips_table' } }}
                  </button>
                </ng-container>
                <ng-template #notLinkedTemplate>
                  <button fswButton (click)="linkEvent.emit(item)">
                    {{ 'buttons.link' | fswTranslate : { scope: 'frankenstein_bips_table' } }}
                  </button>
                </ng-template>
              </td>
            </ng-container>
            <ng-template #borrowerTemplate>
              <td class="align-middle" colspan="2">
                <span class="text-green-500">
                  {{ 'buttons.linked' | fswTranslate : { scope: 'frankenstein_bips_table' } }}
                </span>
              </td>
            </ng-template>
          </tr>
          <ng-container *ngIf="item.expand.idNumber && expandSignal()[item.expand.idNumber]">
            <ng-container *ngFor="let history of getHistories(item, true)">
              <tr>
                <td colspan="7"></td>
                <td class="align-middle">
                  {{ history.createdAt ? (history.createdAt | date : 'dd/MM/yyyy') || '--' : '--' }}
                </td>
                <td class="align-middle">
                  {{ history.createdBy || '--' }}
                </td>
                <td class="align-middle">
                  <button
                    fswButton
                    [appearance]="'icon-with-bg'"
                    (click)="downloadEvent.emit(history.id)"
                  >
                    <i fswIcon="common-download"></i>
                  </button>
                </td>
                <td class="align-middle" [colSpan]="isReadonly ? 1 : 2"></td>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>
        <tr *ngIf="!data.length">
          <td [colSpan]="isReadonly ? 11 : 12" class="align-middle text-center">
            {{ 'no_data' | fswTranslate : { scope: 'frankenstein_bips_table' } }}
          </td>
        </tr>
      </tbody>
    </table>
  `, isInline: true, styles: [":host .fsw-button-error{--fsw-button-background: var(--fsw-color-red-400-hex);--fsw-button-color: white;--fsw-button-active-background: var(--fsw-color-red-500-hex);--fsw-button-disabled-background: var(--fsw-color-red-400-hex)}\n"], dependencies: [{ kind: "pipe", type: DatePipe, name: "date" }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "directive", type: NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FSWIconModule }, { kind: "directive", type: i1$4.FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFrankensteinBipsTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-frankenstein-bips-table', template: `
    <table class="fsw-table !table-auto w-full fsw-table--bordered">
      <thead>
        <tr>
          <th
            class="align-middle"
            *ngFor="
              let column of [
                'columns.name',
                'columns.id_number',
                'columns.designation',
                'columns.ownership',
                'columns.date_of_birth',
                'columns.recourse_type',
                'columns.reference_to',
                'columns.last_pull',
                'columns.last_pull_by',
                'columns.report'
              ]
            "
          >
            {{ column | fswTranslate : { scope: 'frankenstein_bips_table' } }}
          </th>
          <th [colSpan]="isReadonly ? 1 : 2" class="align-middle">
            {{ 'columns.link' | fswTranslate : { scope: 'frankenstein_bips_table' } }}
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of data">
          <tr>
            <td class="align-middle">
              <label class="inline-flex items-center gap-[8px]">
                <span class="w-[20px] inline-flex items-center">
                  <ng-container *ngIf="item.expand.idNumber as idNumber">
                    <span
                      *ngIf="expandKeys().includes(idNumber)"
                      class="transform inline-flex items-center"
                      [class.-rotate-90]="!expandSignal()[idNumber]"
                      (click)="toggleExpand(item)"
                    >
                      <i
                        [fswIcon]="'common-arrow-dropdown'"
                        [fontSize]="'20px'"
                        class="text-blue-500"
                      ></i>
                    </span>
                  </ng-container>
                </span>
                <span>{{ item.expand.name ?? '--' }}</span>
              </label>
            </td>
            <td class="align-middle">
              {{ item.expand.idNumber ?? '--' }}
            </td>
            <td class="align-middle">
              {{ item.expand.designation ?? '--' }}
            </td>
            <td class="align-middle">
              {{ item.expand.ownership ?? '--' }}
            </td>
            <td class="align-middle">
              {{
                (item.expand.birth_date || item.expand.company_birth_date | date : 'dd/MM/yyyy') ||
                  '--'
              }}
            </td>
            <td class="align-middle">
              {{ item.expand.recourseType ?? '--' }}
            </td>
            <td class="align-middle">
              {{ item.reference_to ?? '--' }}
            </td>
            <td class="align-middle">
              {{
                getLastHistory(item)?.createdAt
                  ? (getLastHistory(item)?.createdAt | date : 'dd/MM/yyyy') || '--'
                  : '--'
              }}
            </td>
            <td class="align-middle">
              {{ getLastHistory(item)?.createdBy || '--' }}
            </td>
            <td class="align-middle">
              <div class="flex gap-[8px] items-center">
                <button
                  *ngIf="getLastHistory(item)?.id as reportId"
                  fswButton
                  [appearance]="'icon-with-bg'"
                  (click)="downloadEvent.emit(reportId)"
                >
                  <i fswIcon="common-download"></i>
                </button>
                <button
                  *ngIf="!isReadonly"
                  fswButton
                  [appearance]="'icon-with-bg'"
                  (click)="pullEvent.emit(item)"
                >
                  <i fswIcon="status-ongoing"></i>
                </button>
              </div>
            </td>
            <ng-container *ngIf="item.expand.recourseType !== 'Borrower'; else borrowerTemplate">
              <td class="align-middle">
                <ng-container *ngIf="item.expand.linked; else notLinkedTemplate">
                  <span class="text-green-500">
                    {{ 'buttons.linked' | fswTranslate : { scope: 'frankenstein_bips_table' } }}
                  </span>
                </ng-container>
                <ng-template #notLinkedTemplate>
                  <span class="text-yellow-500">
                    {{
                      'buttons.not_yet_linked' | fswTranslate : { scope: 'frankenstein_bips_table' }
                    }}
                  </span>
                </ng-template>
              </td>
              <td class="align-middle" *ngIf="!isReadonly">
                <ng-container *ngIf="item.expand.linked; else notLinkedTemplate">
                  <button
                    fswButton
                    class="fsw-button-error"
                    (click)="unlinkEvent.emit(item)"
                    [appearance]="'secondary-elevate'"
                  >
                    {{ 'buttons.unlink' | fswTranslate : { scope: 'frankenstein_bips_table' } }}
                  </button>
                </ng-container>
                <ng-template #notLinkedTemplate>
                  <button fswButton (click)="linkEvent.emit(item)">
                    {{ 'buttons.link' | fswTranslate : { scope: 'frankenstein_bips_table' } }}
                  </button>
                </ng-template>
              </td>
            </ng-container>
            <ng-template #borrowerTemplate>
              <td class="align-middle" colspan="2">
                <span class="text-green-500">
                  {{ 'buttons.linked' | fswTranslate : { scope: 'frankenstein_bips_table' } }}
                </span>
              </td>
            </ng-template>
          </tr>
          <ng-container *ngIf="item.expand.idNumber && expandSignal()[item.expand.idNumber]">
            <ng-container *ngFor="let history of getHistories(item, true)">
              <tr>
                <td colspan="7"></td>
                <td class="align-middle">
                  {{ history.createdAt ? (history.createdAt | date : 'dd/MM/yyyy') || '--' : '--' }}
                </td>
                <td class="align-middle">
                  {{ history.createdBy || '--' }}
                </td>
                <td class="align-middle">
                  <button
                    fswButton
                    [appearance]="'icon-with-bg'"
                    (click)="downloadEvent.emit(history.id)"
                  >
                    <i fswIcon="common-download"></i>
                  </button>
                </td>
                <td class="align-middle" [colSpan]="isReadonly ? 1 : 2"></td>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>
        <tr *ngIf="!data.length">
          <td [colSpan]="isReadonly ? 11 : 12" class="align-middle text-center">
            {{ 'no_data' | fswTranslate : { scope: 'frankenstein_bips_table' } }}
          </td>
        </tr>
      </tbody>
    </table>
  `, standalone: true, changeDetection: ChangeDetectionStrategy.OnPush, imports: [DatePipe, FSWButtonModule, FSWTranslateModule, NgForOf, NgIf, FSWIconModule], providers: [frankensteinLinkTranslation('frankenstein_bips_table')], styles: [":host .fsw-button-error{--fsw-button-background: var(--fsw-color-red-400-hex);--fsw-button-color: white;--fsw-button-active-background: var(--fsw-color-red-500-hex);--fsw-button-disabled-background: var(--fsw-color-red-400-hex)}\n"] }]
        }], propDecorators: { linkEvent: [{
                type: Output
            }], unlinkEvent: [{
                type: Output
            }], downloadEvent: [{
                type: Output
            }], pullEvent: [{
                type: Output
            }], data: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], history: [{
                type: Input
            }] } });

function injectFrankensteinBipsEffects(config) {
    switch (getCountryCodeFromStorage()) {
        default:
            return injectFrankensteinBipsAllEffects(config);
    }
}

class FSWFrankensteinBipsComponent {
    constructor() {
        this.linkEvent = new EventEmitter();
        this.unlinkEvent = new EventEmitter();
        this.pullEvent = new EventEmitter();
        this.pullManyEvent = new EventEmitter();
        this.signals = {
            applicationId: signal(null),
            isReadonly: signal(false),
        };
        this.effects = injectFrankensteinBipsEffects({
            actions: {
                linked: () => this.linkEvent.emit(),
                unlinked: () => this.unlinkEvent.emit(),
                pulled: () => this.pullEvent.emit(),
            },
            signals: {
                applicationId: this.signals.applicationId,
                isReadonly: this.signals.isReadonly,
            },
        });
        this.FSWTabsSizes = FSWTabsSizes;
    }
    set applicationId(value) {
        this.signals.applicationId.set(value);
    }
    set isReadonly(value) {
        this.signals.isReadonly.set(value);
    }
    ngOnInit() {
        if (!this.signals.applicationId()) {
            return;
        }
        this.effects.actions.reload();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFrankensteinBipsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWFrankensteinBipsComponent, isStandalone: true, selector: "fsw-frankenstein-bips", inputs: { applicationId: "applicationId", isReadonly: "isReadonly" }, outputs: { linkEvent: "linkEvent", unlinkEvent: "unlinkEvent", pullEvent: "pullEvent", pullManyEvent: "pullManyEvent" }, providers: [
            frankensteinLinkTranslation(),
            provideUtilsService(),
            provideFSWMemberServiceV3(),
            provideApplicationMemberBIPService(),
            provideApplicationMemberService(),
            provideMemberService(),
            provideApplicationGuarantorService(),
            provideCreditGuarantorService(),
            provideCreditBorrowerSummaryService(),
            provideQuestnetService(),
        ], ngImport: i0, template: `
    <fsw-panel [title]="'title' | fswTranslate : { scope: 'frankenstein_bips' }">
      <ng-template fswPanelHeaderSuffix>
        <div class="flex gap-[12px] items-center" *ngIf="signals.applicationId() as applicationId">
          <fsw-questnet-pull
            [stage]="'MANY'"
            [applicationId]="applicationId"
            [isReadonly]="signals.isReadonly()"
            (pullManyEvent)="effects.actions.reload(); pullManyEvent.emit()"
          />
          <button fswButton (click)="effects.actions.reload()">
            {{ 'buttons.refresh' | fswTranslate : { scope: 'frankenstein_bips' } }}
          </button>
        </div>
      </ng-template>
      <section class="w-full max-h-[70vh] overflow-auto flex flex-col gap-[16px]">
        <fsw-frankenstein-bips-table
          [data]="effects.signals.items()"
          [history]="effects.signals.history()"
          [isReadonly]="signals.isReadonly()"
          (linkEvent)="effects.actions.link($event)"
          (unlinkEvent)="effects.actions.unlink($event)"
          (downloadEvent)="effects.actions.download($event)"
          (pullEvent)="effects.actions.pull($event)"
        />
      </section>
    </fsw-panel>
  `, isInline: true, dependencies: [{ kind: "ngmodule", type: FSWAlertModule }, { kind: "ngmodule", type: FSWTranslateModule }, { kind: "pipe", type: i1$4.FSWTranslatePipe, name: "fswTranslate" }, { kind: "component", type: FSWFrankensteinBipsTableComponent, selector: "fsw-frankenstein-bips-table", inputs: ["data", "isReadonly", "history"], outputs: ["linkEvent", "unlinkEvent", "downloadEvent", "pullEvent"] }, { kind: "ngmodule", type: FSWPanelModule }, { kind: "component", type: i1$4.FSWPanelComponent, selector: "fsw-panel", inputs: ["title", "titleClasses", "headerClasses", "customClasses"] }, { kind: "directive", type: i1$4.FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]" }, { kind: "component", type: FSWQuestnetPullComponent, selector: "fsw-questnet-pull", inputs: ["applicationId", "isReadonly", "stage"], outputs: ["pullEvent", "pullManyEvent"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FSWButtonModule }, { kind: "directive", type: i1$4.FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFrankensteinBipsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fsw-frankenstein-bips',
                    template: `
    <fsw-panel [title]="'title' | fswTranslate : { scope: 'frankenstein_bips' }">
      <ng-template fswPanelHeaderSuffix>
        <div class="flex gap-[12px] items-center" *ngIf="signals.applicationId() as applicationId">
          <fsw-questnet-pull
            [stage]="'MANY'"
            [applicationId]="applicationId"
            [isReadonly]="signals.isReadonly()"
            (pullManyEvent)="effects.actions.reload(); pullManyEvent.emit()"
          />
          <button fswButton (click)="effects.actions.reload()">
            {{ 'buttons.refresh' | fswTranslate : { scope: 'frankenstein_bips' } }}
          </button>
        </div>
      </ng-template>
      <section class="w-full max-h-[70vh] overflow-auto flex flex-col gap-[16px]">
        <fsw-frankenstein-bips-table
          [data]="effects.signals.items()"
          [history]="effects.signals.history()"
          [isReadonly]="signals.isReadonly()"
          (linkEvent)="effects.actions.link($event)"
          (unlinkEvent)="effects.actions.unlink($event)"
          (downloadEvent)="effects.actions.download($event)"
          (pullEvent)="effects.actions.pull($event)"
        />
      </section>
    </fsw-panel>
  `,
                    standalone: true,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    imports: [
                        FSWAlertModule,
                        FSWTranslateModule,
                        FSWFrankensteinBipsTableComponent,
                        FSWPanelModule,
                        FSWQuestnetPullComponent,
                        NgIf,
                        FSWButtonModule,
                    ],
                    providers: [
                        frankensteinLinkTranslation(),
                        provideUtilsService(),
                        provideFSWMemberServiceV3(),
                        provideApplicationMemberBIPService(),
                        provideApplicationMemberService(),
                        provideMemberService(),
                        provideApplicationGuarantorService(),
                        provideCreditGuarantorService(),
                        provideCreditBorrowerSummaryService(),
                        provideQuestnetService(),
                    ],
                }]
        }], propDecorators: { linkEvent: [{
                type: Output
            }], unlinkEvent: [{
                type: Output
            }], pullEvent: [{
                type: Output
            }], pullManyEvent: [{
                type: Output
            }], applicationId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class KYCContainerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: KYCContainerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: KYCContainerModule, declarations: [KYCContainerComponent], imports: [CommonModule,
            LetDirective,
            FormWidgetModule,
            UtilsServiceModule,
            KYCServiceModule,
            CustomerDetailModule,
            CompanyDetailModule,
            CompanyDirectorModule], exports: [KYCContainerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: KYCContainerModule, imports: [CommonModule,
            FormWidgetModule,
            UtilsServiceModule,
            KYCServiceModule,
            CustomerDetailModule,
            CompanyDetailModule,
            CompanyDirectorModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: KYCContainerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        LetDirective,
                        FormWidgetModule,
                        UtilsServiceModule,
                        KYCServiceModule,
                        CustomerDetailModule,
                        CompanyDetailModule,
                        CompanyDirectorModule,
                    ],
                    declarations: [KYCContainerComponent],
                    exports: [KYCContainerComponent],
                }]
        }] });

class MainBorrowerContainerComponent {
    constructor() {
        this.isReadonly = false;
        this._changeTabStatusSub = new Subject();
        this.changeTabStatus$ = this._changeTabStatusSub.asObservable();
    }
    set applicationId(value) {
        this._applicationId = value;
    }
    get applicationId() {
        return this._applicationId;
    }
    set memberId(value) {
        this._memberId = value;
    }
    get memberId() {
        return this._memberId;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MainBorrowerContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: MainBorrowerContainerComponent, selector: "ng-component", inputs: { applicationId: "applicationId", memberId: "memberId", isReadonly: "isReadonly" }, ngImport: i0, template: `
    <main>
      <fsw-member-detail
        *ngIf="applicationId && memberId"
        [applicationId]="applicationId"
        [memberId]="memberId"
        [isReadonly]="isReadonly"
      ></fsw-member-detail>
    </main>
    <div class="mt-4">
      <fsw-member-bips
        [applicationId]="applicationId"
        [memberId]="memberId"
        [isReadonly]="isReadonly"
      ></fsw-member-bips>
    </div>
  `, isInline: true, styles: ["header>div:first-child{display:flex;margin-bottom:4px}.error__message{color:#cc1830;font-size:14px}.sub{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:12px;line-height:1.5;color:#757575}:host .cbs-form__container{padding:16px;width:50%;display:flex;flex-direction:column;gap:16px;border-radius:4px;border:1px solid #e0e0e0}.mt-4{margin-top:16px}.mb-4{margin-bottom:16px}::ng-deep .cb-separator{width:100%;height:0;border:1px solid #e0e0e0}.kyc-container{padding:0 16px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: MemberDetailComponent, selector: "fsw-member-detail", inputs: ["applicationId", "memberId", "isReadonly"] }, { kind: "component", type: MemberBIPSComponent, selector: "fsw-member-bips", inputs: ["applicationId", "memberId", "isReadonly"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MainBorrowerContainerComponent, decorators: [{
            type: Component,
            args: [{ template: `
    <main>
      <fsw-member-detail
        *ngIf="applicationId && memberId"
        [applicationId]="applicationId"
        [memberId]="memberId"
        [isReadonly]="isReadonly"
      ></fsw-member-detail>
    </main>
    <div class="mt-4">
      <fsw-member-bips
        [applicationId]="applicationId"
        [memberId]="memberId"
        [isReadonly]="isReadonly"
      ></fsw-member-bips>
    </div>
  `, changeDetection: ChangeDetectionStrategy.OnPush, styles: ["header>div:first-child{display:flex;margin-bottom:4px}.error__message{color:#cc1830;font-size:14px}.sub{font-family:Inter,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif;font-size:12px;line-height:1.5;color:#757575}:host .cbs-form__container{padding:16px;width:50%;display:flex;flex-direction:column;gap:16px;border-radius:4px;border:1px solid #e0e0e0}.mt-4{margin-top:16px}.mb-4{margin-bottom:16px}::ng-deep .cb-separator{width:100%;height:0;border:1px solid #e0e0e0}.kyc-container{padding:0 16px}\n"] }]
        }], propDecorators: { applicationId: [{
                type: Input
            }], memberId: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }] } });

class MainBorrowerContainerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MainBorrowerContainerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: MainBorrowerContainerModule, declarations: [MainBorrowerContainerComponent], imports: [CommonModule, LetDirective, FormWidgetModule, MemberDetailModule, MemberBIPSModule], exports: [MainBorrowerContainerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MainBorrowerContainerModule, imports: [CommonModule, FormWidgetModule, MemberDetailModule, MemberBIPSModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MainBorrowerContainerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, LetDirective, FormWidgetModule, MemberDetailModule, MemberBIPSModule],
                    declarations: [MainBorrowerContainerComponent],
                    exports: [MainBorrowerContainerComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AGING_REPORT_ALL_TRANSLATION, ALL_TRANSLATION, APPLICATION_BORROWER_SUMMARY_SERVICE_TOKEN, APPLICATION_EXPOSURE_SERVICE_TOKEN, APPLICATION_FACILITY_TERMS_SERVICE_TOKEN, APPLICATION_GUARANTOR_SERVICE_TOKEN, APPLICATION_IMPORT_ALL_TRANSLATION, APPLICATION_INTERNAL_SERVICE_TOKEN, APPLICATION_MEMBER_BIP_SERVICE_TOKEN, APPLICATION_MEMBER_SERVICE_TOKEN, APPLICATION_POLICY_CHECKLIST_SERVICE_TOKEN, APPLICATION_PRE_SCREENING_SERVICE_TOKEN, APPLICATION_PROJECT_LISTING_SERVICE_TOKEN, APPLICATION_PROPOSAL_SERVICE_TOKEN, APPLICATION_RELATIONSHIP_SERVICE_TOKEN, APPLICATION_REPAYMENT_SCHEDULE_SERVICE_TOKEN, APPLICATION_SALES_SUMMARY_SERVICE_TOKEN, APPLICATION_SCORECARD_SERVICE_TOKEN, APPLICATION_SERVICE_TOKEN, APPLICATION_SUPPLIER_SERVICE_TOKEN, ActionIconsCellComponent, AffiliateBorrowerReportCellComponent, ApplicationBorrowerSummaryService, ApplicationDetailComponent, ApplicationDetailModule, ApplicationExposureService, ApplicationExposureServiceModule, ApplicationFacilityTermsService, ApplicationFacilityTermsServiceModule, ApplicationGuarantorService, ApplicationGuarantorServiceModule, ApplicationInternalService, ApplicationInternalServiceModule, ApplicationMemberBIPService, ApplicationMemberInformationStore, ApplicationMemberService, ApplicationMemberServiceModule, ApplicationMemberType, ApplicationPolicyChecklistService, ApplicationPolicyChecklistServiceModule, ApplicationPreScreeningService, ApplicationPreScreeningServiceModule, ApplicationProjectListingService, ApplicationProjectListingServiceModule, ApplicationProposalService, ApplicationProposalServiceModule, ApplicationRelationshipService, ApplicationRepaymentScheduleService, ApplicationRepaymentScheduleServiceModule, ApplicationSalesSummaryService, ApplicationSalesSummaryServiceModule, ApplicationScorecardService, ApplicationScorecardServiceModule, ApplicationService, ApplicationServiceModule, ApplicationSupplierService, BANK_ACCOUNTS_AND_STATEMENTS_SERVICE_TOKEN, BANK_CODES_NOT_SUPPORTED_BY_PERFIOS, BANK_TABULATIONS_SERVICE_TOKEN, BLOB_SERVICE_TOKEN, BORROWER_SUMMARY_MY_TRANSLATION, BORROWER_SUMMARY_SG_TRANSLATION, BUYER_INFORMATION_FORM_TOKEN, BUYER_INFORMATION_PROVIDERS, BUYER_INFORMATION_STORE_TOKEN, BUYER_INFORMATION_TH_PROVIDERS, BUYER_INFORMATION_TRANSLATION_LOADER, BUYER_PAYMENT_METHODS, BUYER_SERVICE_TOKEN, BUYER_TRANSACTION_FORM_TOKEN, BUYER_TRANSACTION_PROVIDERS, BUYER_TRANSACTION_STORE_TOKEN, BUYER_TRANSACTION_TH_PROVIDERS, BUYER_TRANSACTION_TRANSLATION_LOADER, BankAccountStatusType, BankAccountsAndStatementsService, BankAccountsAndStatementsServiceModule, BankTabulationsService, BankTabulationsServiceModule, BuyerInformationStore, BuyerSalesOrCredit, BuyerService, BuyerServiceModule, BuyerStatus, BuyerTransactionPaymentMethod, BuyerTransactionStore, CBAdditionalComponent, CBAdditionalComponentStore, CBAdditionalModule, CBBankComponent, CBBankComponentStore, CBBankModule, CBBlock, CBComponent, CBComponentStore, CBDirective, CBEntityTypes, CBFormKeys, CBGeneralComponent, CBGeneralComponentStore, CBGeneralModule, CBMemberTypes, CBSPermissionEnum, CBSelectComponent, CBSelectModule, CBSummaryFormComponent, CBSummaryFormModule, CBSummaryPdfComponent, CBSummaryPdfModule, CBUploadComponent, CBUploadModule, CB_ADDITIONAL_COMPONENT_STORE_TOKEN, CB_BANK_COMPONENT_STORE_TOKEN, CB_COMPONENT_STORE_TOKEN, CB_GENERAL_COMPONENT_STORE_TOKEN, COMPANY_PROFILE_SERVICE_TOKEN, CORPORATE_GUARANTOR_MY_TRANSLATION, CORPORATE_GUARANTOR_SG_TRANSLATION, COUNTRY_CONFIG, CPCommentTypes, CPComponentStore, CPGridComponent, CPGridControlComponent, CPGridControlModule, CPGridEmptyComponent, CPGridEmptyModule, CPGridModule, CPMainBlockComponent, CPMainBlockModule, CPRemoveDialogComponent, CPRemoveDialogModule, CPRiskAnalysisBlockComponent, CPRiskAnalysisBlockModule, CPRiskProfileBlockComponent, CPRiskProfileBlockModule, CPSaveDialogComponent, CPSaveDialogModule, CP_COMPONENT_STORE_TOKEN, CP_CUSTOMER_FORM_CONFIG_TOKEN, CP_CUSTOMER_GRID_CONFIG_TOKEN, CP_MAIN_FORM_CONFIG_TOKEN, CP_RISK_ANALYSIS_FORM_CONFIG_TOKEN, CP_RISK_PROFILE_FORM_CONFIG_TOKEN, CP_SUPPLIER_FORM_CONFIG_TOKEN, CP_SUPPLIER_GRID_CONFIG_TOKEN, CREDIT_AGING_REPORT_SERVICE_TOKEN, CREDIT_ASSESSMENT_ALL_TRANSLATION, CREDIT_BORROWER_SUMMARY_SERVICE_TOKEN, CREDIT_BUREAU_SERVICE_TOKEN, CREDIT_COMMENT_SERVICE_TOKEN, CREDIT_EXPOSURE_SERVICE_TOKEN, CREDIT_FACILITY_TERMS_SERVICE_TOKEN, CREDIT_GUARANTOR_SERVICE_TOKEN, CREDIT_MEMO_ANALYSIS_MY_TRANSLATION, CREDIT_MEMO_ANALYSIS_SG_TRANSLATION, CREDIT_MODEL_SERVICE_TOKEN, CREDIT_OUTSTANDING_LOANS_SERVICE_TOKEN, CREDIT_POLICY_CHECKLIST_SERVICE_TOKEN, CREDIT_PRE_SCREENING_SERVICE_TOKEN, CREDIT_PROJECT_LISTING_SERVICE_TOKEN, CREDIT_REPAYMENT_SCHEDULE_SERVICE_TOKEN, CREDIT_SALES_SUMMARY_SERVICE_TOKEN, CREDIT_SCORING_SERVICE_TOKEN, CREDIT_SCREENING_RESULT_SERVICE_TOKEN, CREDIT_SERVICE_TOKEN, CREDIT_SUPPLIER_SERVICE_TOKEN, CREDIT_TEST_BUCKET_SERVICE_TOKEN, CURRENCYMASKDIRECTIVE_VALUE_ACCESSOR, CURRENCY_MASK_CONFIG, CbsEnquiryDatePipe, CbsFraudScreeningComponent, CbsFraudScreeningDirective, CbsParsedResultAccountStatusHistoryComponent, CbsParsedResultAggregateMonthlyBalancesComponent, CbsParsedResultAggregateMonthlyInstallmentComponent, CbsParsedResultBankruptcyProceedingsComponent, CbsParsedResultBureauScoreComponent, CbsParsedResultComponent, CbsParsedResultDataProvidedComponent, CbsParsedResultDefaultRecordsComponent, CbsParsedResultDirective, CbsParsedResultMetadataComponent, CbsParsedResultPersonalDetailsComponent, CbsParsedResultPreviousEnquiriesComponent, CbsParsedResultSummaryComponent, CbsPdfViewerComponent, CbsPdfViewerDirective, CbsPullComponent, CbsSummaryComponent, CbsSummaryDirective, CheckboxControlComponent, CommonGridFields, CompanyDetailComponent, CompanyDetailModule, CompanyDirectorComponent, CompanyDirectorEntryDialogComponent, CompanyDirectorEntryDialogModule, CompanyDirectorGridComponent, CompanyDirectorGridModule, CompanyDirectorModule, CompanyProfileComponent, CompanyProfileDirective, CompanyProfileModule, CompanyProfileService, CompanyProfileServiceModule, ControlMixin, ControlsWidgetModule, CoreFieldType, CountryCode, CountryFilterModule, CountryFilterPipe, CountryName, CountryPhoneCode, CountryTimezone, CreditAgingReportService, CreditAgingReportServiceModule, CreditAgingReportTypes, CreditBorrowerSummaryService, CreditBureauModule, CreditBureauService, CreditBureauServiceModule, CreditBureauTypes, CreditCommentService, CreditCommentServiceModule, CreditExposureService, CreditExposureServiceModule, CreditFacilityTermsService, CreditFacilityTermsServiceModule, CreditGuarantorService, CreditGuarantorServiceModule, CreditModelService, CreditModelServiceModule, CreditOutstandingLoansService, CreditOutstandingLoansServiceModule, CreditPolicyChecklistService, CreditPolicyChecklistServiceModule, CreditPreScreeningService, CreditPreScreeningServiceModule, CreditProjectListingService, CreditProjectListingServiceModule, CreditRepaymentScheduleService, CreditRepaymentScheduleServiceModule, CreditSalesSummaryService, CreditSalesSummaryServiceModule, CreditScoringService, CreditScoringServiceModule, CreditScreeningResultService, CreditScreeningResultServiceModule, CreditScreeningResultStageNames, CreditSupplierService, CreditTestBucketService, CreditTestBucketServiceModule, CurrencyCellComponent, CurrencyCode, CurrencyFormatModule, CurrencyFormatPipe, CurrencyMaskDirective, CurrencySymbol, CustomHeaderCellComponent, CustomNoRowsOverlayComponent, CustomPinnedRowComponent, CustomTooltipComponent, CustomerDetailComponent, CustomerDetailModule, DIGITAL_SCORECARD_BTL_MY_TRANSLATION, DIGITAL_SCORECARD_NCM_MY_TRANSLATION, DIRECTORY_TOKEN, DOC_MANAGER_SERVICE_TOKEN, DOMSanitizeModule, DOMSanitizePipe, DRAWER_ARRAY, DRAWER_BACKDROP_CLICK, DRAWER_CONTEXT, DRAWER_HOST_ID, DRAWER_HOST_SERVICE, DRAWER_ITEM, DRAWER_SERVICE, DateControlComponent, DeleteDocumentCellComponent, DigitalScorecardFormFields$1 as DigitalScorecardFormFields, DocManagerService, DocManagerServiceModule, DrawerComponent, DrawerHostComponent, DrawerHostItemDirective, DrawerHostService, DrawerItemDirective, DrawerPositions, DrawerService, DrawerSizes, DrawerStyles, DynamicCompLoaderDirective, DynamicCompLoaderModule, DynamicTabsComponent, DynamicTabsModule, EBADirective, EBALoanDetail, EBALoanDetailsGuarantee, EBALoanDetailsLongTerm, EBALoanDetailsShortTerm, EBALoanStatus, EBALoanStatuses, EBALoanType, EBALoanTypes, EBAModule, EBATHService, EBATH_SERVICE_TOKEN, EBA_TH_TRANSLATION, EXTENSION_SERVICE_TOKEN, ExposureComponent, ExtensionService, ExtensionServiceModule, FACILITY_ALL_TRANSLATION, FACILITY_SERVICE_TOKEN, FIELD_TYPE, FINANCE_SERVICE_TOKEN, FINANCIAL_STATEMENT_SERVICE_TOKEN, FSWAddProductGroupComponent, FSWAddProductGroupModule, FSWAgingReportComponent, FSWAgingReportConfirmComponent, FSWAgingReportDirective, FSWAgingReportGridComponent, FSWApplicationExportJobStatuses, FSWApplicationImportComponent, FSWApplicationImportDetailsComponent, FSWApplicationImportModuleComponent, FSWApproversSelectionMyDfComponent, FSWApproversSelectionMyDfModule, FSWBIPsAddComponent, FSWBIPsComponent, FSWBIPsConfirmComponent, FSWBIPsEditComponent, FSWBIPsFormID, FSWBIPsFormTH, FSWBIPsGridComponent, FSWBIPsGridItemDirective, FSWBIPsHelperID, FSWBIPsHelperTH, FSWBIPsModule, FSWBIPsPefindoComponent, FSWBIPsStore, FSWBIPsStoreID, FSWBIPsStoreTH, FSWBIPsTemplatePipe, FSWBankStatementAnalysisComponent, FSWBankStatementAnalysisModule, FSWBlobService, FSWBlobServiceModule, FSWBorrowerSummaryComponent, FSWBorrowerSummaryDirective, FSWBuyerComponent, FSWBuyerInfoGridComponent, FSWBuyerInfoGridItemDirective, FSWBuyerInfoGridPipe, FSWBuyerInfoHeaderComponent, FSWBuyerInformationComponent, FSWBuyerInformationConfirmComponent, FSWBuyerInformationDirective, FSWBuyerInformationFormTypes, FSWBuyerInformationModule, FSWBuyerInformationSaveComponent, FSWBuyerModule, FSWBuyerTransactionComponent, FSWBuyerTransactionConfirmComponent, FSWBuyerTransactionDirective, FSWBuyerTransactionFormTypes, FSWBuyerTransactionModule, FSWBuyerTransactionSaveComponent, FSWCBSProbabilityOfDefault, FSWCBSRating, FSWCBSRatingArray, FSWCTOSEntityTypes, FSWCTOSGrade, FSWCTOSPullStatuses, FSWCbsSummaryConfirmComponent, FSWCbsSummaryErrorComponent, FSWCbsSummaryPdfComponent, FSWCbsSummaryUploadComponent, FSWClipboardComponent, FSWClipboardModule, FSWCommentBoxActionsComponent, FSWCommentBoxComponent, FSWCommentBoxInformationComponent, FSWCommentBoxModule, FSWCommentBoxThumbnailComponent, FSWCommentsComponent, FSWCommentsItemDirective, FSWCommentsSectionComponent, FSWConfirmDialogComponent, FSWConfirmDialogModule, FSWCorporateGuarantorComponent, FSWCorporateGuarantorDirective, FSWCountryCode, FSWCreditApproversCandidateComponent, FSWCreditApproversComponent, FSWCreditApproversModule, FSWCreditAssessmentComponent, FSWCreditMemoAnalysisComponent, FSWCreditPreScreeningAutoIdentifiers, FSWCreditPreScreeningAutoNames, FSWCreditPreScreeningAutoRuleSetIdentifier, FSWCreditPreScreeningIdentifiers, FSWCreditPreScreeningNames, FSWCreditPreScreeningRuleSetIdentifier, FSWCreditPreScreeningStages, FSWCreditScoringComponent, FSWCreditScoringModule, FSWCreditService, FSWCreditServiceModule, FSWCtosPullAddBipDialogComponent, FSWCtosPullBipActionComponent, FSWCtosPullBipComponent, FSWCtosPullBipDetailTableBuilderMY, FSWCtosPullBipFormBuilderMY, FSWCtosPullBipSelectionTableBuilderMY, FSWCtosPullBipStatusTableBuilderMY, FSWCtosPullComponent, FSWCtosPullConfirmationDialogComponent, FSWCtosPullDialogComponent, FSWCtosPullDirective, FSWCtosPullFormBuilderMY, FSWCtosPullInformationComponent, FSWCtosPullInformationFormBuilderMY, FSWCtosPullModule, FSWCtosPullSelectionBipComponent, FSWCtosPullStore, FSWCtosPullStoreMY, FSWCtosPullViewBipDialogComponent, FSWCtosService, FSWCtosServiceModule, FSWCurrencyMaskModule, FSWCustomerAcceptanceComponent, FSWCustomerAcceptanceDirective, FSWCustomerAcceptanceFormMY, FSWCustomerAcceptanceModule, FSWCustomerAcceptanceStoreMY, FSWCustomerAcceptanceTypes, FSWDigitalScorecardBTLComponent, FSWDigitalScorecardComponent, FSWDigitalScorecardModule, FSWDigitalScorecardNCMComponent, FSWDigitalScorecardNCMContainerComponent, FSWDocViewerGroupComponent, FSWDocViewerItemComponent, FSWDocViewerModule, FSWDocViewerService, FSWDocViewerSingleComponent, FSWDrawerModule, FSWEBATHBoxComponent, FSWEBATHComponent, FSWEBATHConfirmComponent, FSWEBATHDirective, FSWEBATHTileComponent, FSWEntityTypes, FSWExperianPaymentGrade, FSWExperianPaymentGradeArray, FSWExposureApplicationEntity, FSWExposureFormMY, FSWExposureFormSG, FSWExposureFormTH, FSWExposureLoanEntity, FSWExposureModule, FSWExposureProductsComponent, FSWExposureProductsTableComponent, FSWExposureStore, FSWExposureStoreMY, FSWExposureStoreSG, FSWExposureStoreTH, FSWFacilityComponent, FSWFacilityConditionsComponent, FSWFacilityTestBucketComponent, FSWFlow, FSWFrankensteinBipsComponent, FSWFrankensteinBipsTableComponent, FSWFrankensteinModel, FSWGridActionMethodsCellComponent, FSWGridComponent, FSWGridModule, FSWGstComponent, FSWImageViewerComponent, FSWImageViewerModule, FSWLoanListModule, FSWLoanService, FSWLoanServiceModule, FSWMainBorrowerComponent, FSWMainBorrowerConfirmComponent, FSWMainBorrowerFormTH, FSWMainBorrowerModule, FSWMainBorrowerReplaceComponent, FSWMainBorrowerStore, FSWMainBorrowerStoreTH, FSWMainBorrowerTemplatePipe, FSWManualScorecardComponent, FSWManualScorecardModule, FSWMaritalStatuses, FSWMeetCountryDirective, FSWMemberServiceV3, FSWModalModule, FSWOutstandingLoanFacilityConfirmComponent, FSWOutstandingLoanFacilityGridMY, FSWOutstandingLoanFacilityGridSG, FSWOutstandingLoanFacilityModule, FSWOutstandingLoanFacilityStore, FSWOutstandingLoanFacilityStoreMY, FSWOutstandingLoanFacilityStoreSG, FSWPaginationComponent, FSWPaginationModule, FSWPartnerSearchComponent, FSWPartnerSearchConfirmComponent, FSWPartnerSearchDirective, FSWPartnerSearchFormTH, FSWPartnerSearchModule, FSWPartnerSearchReplaceComponent, FSWPartnerSearchStore, FSWPartnerSearchStoreTH, FSWPartnerSearchTemplatePipe, FSWPdfComponent, FSWPdfModule, FSWPdfService, FSWPersonalGuarantorComponent, FSWPersonalGuarantorContainerComponent, FSWPersonalGuarantorDirective, FSWPolicyChecklistComponent, FSWPolicyChecklistDirective, FSWPreScreeningBankStatementsModule, FSWPreScreeningBasicDetailsModule, FSWPreScreeningBipsCgEntity, FSWPreScreeningBipsModule, FSWPreScreeningBipsOtherEntity, FSWPreScreeningBipsPgEntity, FSWPreScreeningBipsStore, FSWPreScreeningBipsStoreMY, FSWPreScreeningBorrowerAndBipsModule, FSWPreScreeningBorrowerAndBipsStore, FSWPreScreeningBorrowerAndBipsStoreMY, FSWPreScreeningBorrowerDetailsModule, FSWPreScreeningBorrowerDetailsStore, FSWPreScreeningBorrowerDetailsStoreMY, FSWPreScreeningBrcComponent, FSWPreScreeningBriComponent, FSWPreScreeningCbsComponent, FSWPreScreeningCcrisFindingsBrwEntity, FSWPreScreeningCcrisFindingsCgEntity, FSWPreScreeningCcrisFindingsModule, FSWPreScreeningCcrisFindingsOtherEntity, FSWPreScreeningCcrisFindingsPgEntity, FSWPreScreeningCcrisFindingsStore, FSWPreScreeningCcrisFindingsStoreMY, FSWPreScreeningCompanyDetailsModule, FSWPreScreeningCompanyDetailsStore, FSWPreScreeningCompanyDetailsStoreMY, FSWPreScreeningCriteriaComponent, FSWPreScreeningCriteriaDescriptionPipe, FSWPreScreeningCriteriaDirective, FSWPreScreeningCriteriaEditJustificationComponent, FSWPreScreeningCriteriaModule, FSWPreScreeningCriteriaSelectDataComponent, FSWPreScreeningCriteriaStore, FSWPreScreeningCriteriaStoreMY, FSWPreScreeningCtosModule, FSWPreScreeningItemComponent, FSWPreScreeningItemDirective, FSWPreScreeningRecourseComponent, FSWPreScreeningTradeReferenceModule, FSWPreScreeningTradeReferenceStore, FSWPreScreeningTradeReferenceStoreMY, FSWPrescreeningDetailsComponent, FSWPrescreeningDetailsTabs, FSWProductCodes, FSWProductGroupComponent, FSWProductGroupDetailComponent, FSWProductGroupModule, FSWProductListGridComponent, FSWProductListGridModule, FSWProductService, FSWProductServiceModule, FSWProductVersionGridComponent, FSWProductVersionGridModule, FSWProductViewSettingsComponent, FSWProductViewSettingsModule, FSWProjectListingConfirmComponent, FSWProjectListingGridMY, FSWProjectListingGridSG, FSWProjectListingModule, FSWProjectListingStore, FSWProjectListingStoreMY, FSWProjectListingStoreSG, FSWProposalsComponent, FSWProposalsConfirmComponent, FSWProposalsContainerComponent, FSWProposalsFormComponent, FSWProposalsFormMY, FSWProposalsFormSG, FSWProposalsFormTH, FSWProposalsFormTypes, FSWProposalsGridComponent, FSWProposalsGridItemDirective, FSWProposalsGridPipe, FSWProposalsHeaderComponent, FSWProposalsModule, FSWProposalsRenderTypes, FSWProposalsRetrieveComponent, FSWProposalsRetrieveGridPipe, FSWProposalsSaveComponent, FSWProposalsStore, FSWProposalsStoreMY, FSWProposalsStoreSG, FSWProposalsStoreTH, FSWProposalsSwitchComponent, FSWQuestnetPullAddBipDialogComponent, FSWQuestnetPullBipsDialogComponent, FSWQuestnetPullBipsTableComponent, FSWQuestnetPullComponent, FSWRatioAnalysisComponent, FSWRatioAnalysisModule, FSWRecourseTypes, FSWRemoveDialogComponent, FSWRemoveDialogModule, FSWRepaymentScheduleComponent, FSWReportComponent, FSWReportErrorComponent, FSWSalesSummaryAccountCalculationPipe, FSWSalesSummaryAccountsContainerComponent, FSWSalesSummaryAccountsModalComponent, FSWSalesSummaryAccountsTableComponent, FSWSalesSummaryComponent, FSWSalesSummaryConfirmModalComponent, FSWSalesSummaryModule, FSWSalesSummaryPorTableComponent, FSWSalesSummaryStore, FSWSalesSummaryStoreTH, FSWSalesSummaryWorkingCapitalTableComponent, FSWSaveDialogComponent, FSWSaveDialogModule, FSWScorecardComponent, FSWScorecardDirective, FSWScoringResultComponent, FSWScoringResultConfirmComponent, FSWScoringResultModule, FSWScreeningResultComponent, FSWScreeningResultGridComponent, FSWScreeningResultModule, FSWScreeningResultStore, FSWScreeningResultStoreMY, FSWSupplierComponent, FSWSupplierConfirmComponent, FSWSupplierDirective, FSWSupplierSaveComponent, FSWSupportComponent, FSWSupportDirective, FSWUploadComponent, FSWUploadModule, FSWViewerComponent, FSWViewerDirective, FSWViewerModule, FSWViewerPosition, FSWViewerService, FSWWPreScreeningBipsBuilderMY, FSWWPreScreeningBorrowerDetailsBuilderMY, FSWWPreScreeningCcrisFindingsBuilderMY, FSWWPreScreeningCompanyDetailsBuilderMY, FSWWPreScreeningCriteriaBuilderMY, FSWWPreScreeningCriteriaModalBuilderMY, FSWWorldCheckActivityService, FSWWorldCheckActivityTableComponent, FSWWorldCheckAdapterCaseService, FSWWorldCheckAdapterMasterService, FSWWorldCheckAssignModalComponent, FSWWorldCheckCaseFormComponent, FSWWorldCheckCaseModalComponent, FSWWorldCheckCaseRating, FSWWorldCheckCaseScreenComponent, FSWWorldCheckCaseTableComponent, FSWWorldCheckComponent, FSWWorldCheckConfirmModalComponent, FSWWorldCheckContainerComponent, FSWWorldCheckDashboardScreenComponent, FSWWorldCheckDetailLevels, FSWWorldCheckEntityTypes, FSWWorldCheckErrorModalComponent, FSWWorldCheckGenders, FSWWorldCheckInformationContainerComponent, FSWWorldCheckKeyDataContainerComponent, FSWWorldCheckLifecycleStates, FSWWorldCheckLinkService, FSWWorldCheckLinkTableComponent, FSWWorldCheckLocationTableComponent, FSWWorldCheckLogoComponent, FSWWorldCheckMandatoryActions, FSWWorldCheckProviderTypes, FSWWorldCheckQueryBy, FSWWorldCheckReScreeningModalComponent, FSWWorldCheckReferenceTableComponent, FSWWorldCheckReportFilters, FSWWorldCheckResolutionModalComponent, FSWWorldCheckResultScreenComponent, FSWWorldCheckResultTableComponent, FSWWorldCheckReviewModalComponent, FSWWorldCheckScreeningModes, FSWWorldCheckSearchFormComponent, FSWWorldCheckSnapshotService, FSWWorldCheckSnapshotTableComponent, FSWWorldCheckSourceTableComponent, FSWWorldCheckSummaryContainerComponent, FSWWorldCheckSupplementFormComponent, FSWWorldCheckSupplementService, FSWWorldCheckUpdateTableComponent, FSWWorldCheckWatchlistCaseScreeningStates, FSWWorldCheckWatchlistResolvedByCategory, FSWWorldCheckWatchlistResolvedByResolutionStatus, FSWWorldCheckWatchlistResolvedByRiskLevel, FSWWorldCheckWatchlistReviewRequired, FSWWorldCheckWatchlistUnresolved, FSW_BIPS_FORM_TOKEN, FSW_BIPS_HELPER_TOKEN, FSW_BIPS_ID_PROVIDERS, FSW_BIPS_PROVIDERS, FSW_BIPS_STORE_TOKEN, FSW_BIPS_TH_PROVIDERS, FSW_BIPS_TRANSLATION_LOADER, FSW_COMMENT_BOX_ACCESSOR, FSW_CREDIT_APPROVERS_TRANSLATION_LOADER, FSW_CTOS_PULL_BIP_DETAIL_TABLE_BUILDER_TOKEN, FSW_CTOS_PULL_BIP_FORM_BUILDER_TOKEN, FSW_CTOS_PULL_BIP_SELECTION_TABLE_BUILDER_TOKEN, FSW_CTOS_PULL_BIP_STATUS_TABLE_BUILDER_TOKEN, FSW_CTOS_PULL_FORM_BUILDER_TOKEN, FSW_CTOS_PULL_INFORMATION_FORM_BUILDER_TOKEN, FSW_CTOS_PULL_MY_PROVIDERS, FSW_CTOS_PULL_PROVIDERS, FSW_CTOS_PULL_STORE_TOKEN, FSW_CTOS_PULL_TRANSLATION_LOADER, FSW_CTOS_SERVICE_TOKEN, FSW_CUSTOMER_ACCEPTANCE_FORM_TOKEN, FSW_CUSTOMER_ACCEPTANCE_ISTOPUP_TOKEN, FSW_CUSTOMER_ACCEPTANCE_MY_PROVIDERS, FSW_CUSTOMER_ACCEPTANCE_PROVIDERS, FSW_CUSTOMER_ACCEPTANCE_STORE_TOKEN, FSW_CUSTOMER_ACCEPTANCE_TYPE_TOKEN, FSW_DOC_UPLOAD, FSW_EXPOSURE_ENTITY_TOKEN, FSW_EXPOSURE_FORM_TOKEN, FSW_EXPOSURE_MY_PROVIDERS, FSW_EXPOSURE_PRODUCTS_ALL_TRANSLATION, FSW_EXPOSURE_PROVIDERS, FSW_EXPOSURE_SG_PROVIDERS, FSW_EXPOSURE_STORE_TOKEN, FSW_EXPOSURE_TH_PROVIDERS, FSW_EXPOSURE_TRANSLATION_LOADER, FSW_FRANKENSTEIN_BIPS_ALL_TRANSLATION, FSW_LOAN_SERVICE_TOKEN, FSW_MAIN_BORROWER_FORM_TOKEN, FSW_MAIN_BORROWER_PROVIDERS, FSW_MAIN_BORROWER_STORE_TOKEN, FSW_MAIN_BORROWER_TH_PROVIDERS, FSW_MAIN_BORROWER_TRANSLATION_LOADER, FSW_MEMBER_SERVICE_V3_TOKEN, FSW_OUTSTANDING_LOAN_FACILITY_ENTITY_TOKEN, FSW_OUTSTANDING_LOAN_FACILITY_GRID_TOKEN, FSW_OUTSTANDING_LOAN_FACILITY_MY_PROVIDERS, FSW_OUTSTANDING_LOAN_FACILITY_PROVIDERS, FSW_OUTSTANDING_LOAN_FACILITY_SG_PROVIDERS, FSW_OUTSTANDING_LOAN_FACILITY_STORE_TOKEN, FSW_OUTSTANDING_LOAN_FACILITY_TRANSLATION_LOADER, FSW_PARTNER_SEARCH_FORM_TOKEN, FSW_PARTNER_SEARCH_PROVIDERS, FSW_PARTNER_SEARCH_STORE_TOKEN, FSW_PARTNER_SEARCH_TH_PROVIDERS, FSW_PARTNER_SEARCH_TRANSLATION_LOADER, FSW_PRE_SCREENING_BIPS_BUILDER_TOKEN, FSW_PRE_SCREENING_BIPS_ENTITY_TOKEN, FSW_PRE_SCREENING_BIPS_MY_PROVIDERS, FSW_PRE_SCREENING_BIPS_PROVIDERS, FSW_PRE_SCREENING_BIPS_STORE_TOKEN, FSW_PRE_SCREENING_BIPS_TRANSLATION_LOADER, FSW_PRE_SCREENING_BORROWER_AND_BIPS_MY_PROVIDERS, FSW_PRE_SCREENING_BORROWER_AND_BIPS_PROVIDERS, FSW_PRE_SCREENING_BORROWER_AND_BIPS_STORE_TOKEN, FSW_PRE_SCREENING_BORROWER_AND_BIPS_TRANSLATION_LOADER, FSW_PRE_SCREENING_BORROWER_DETAILS_BUILDER_TOKEN, FSW_PRE_SCREENING_BORROWER_DETAILS_MY_PROVIDERS, FSW_PRE_SCREENING_BORROWER_DETAILS_PROVIDERS, FSW_PRE_SCREENING_BORROWER_DETAILS_STORE_TOKEN, FSW_PRE_SCREENING_BORROWER_DETAILS_TRANSLATION_LOADER, FSW_PRE_SCREENING_CCRIS_FINDINGS_BUILDER_TOKEN, FSW_PRE_SCREENING_CCRIS_FINDINGS_ENTITY_TOKEN, FSW_PRE_SCREENING_CCRIS_FINDINGS_MY_PROVIDERS, FSW_PRE_SCREENING_CCRIS_FINDINGS_PROVIDERS, FSW_PRE_SCREENING_CCRIS_FINDINGS_STORE_TOKEN, FSW_PRE_SCREENING_CCRIS_FINDINGS_TRANSLATION_LOADER, FSW_PRE_SCREENING_COMPANY_DETAILS_BUILDER_TOKEN, FSW_PRE_SCREENING_COMPANY_DETAILS_MY_PROVIDERS, FSW_PRE_SCREENING_COMPANY_DETAILS_PROVIDERS, FSW_PRE_SCREENING_COMPANY_DETAILS_STORE_TOKEN, FSW_PRE_SCREENING_COMPANY_DETAILS_TRANSLATION_LOADER, FSW_PRE_SCREENING_CRITERIA_BUILDER_TOKEN, FSW_PRE_SCREENING_CRITERIA_MODAL_BUILDER_TOKEN, FSW_PRE_SCREENING_CRITERIA_MY_PROVIDERS, FSW_PRE_SCREENING_CRITERIA_PROVIDERS, FSW_PRE_SCREENING_CRITERIA_STORE_TOKEN, FSW_PRE_SCREENING_CRITERIA_TRANSLATION_LOADER, FSW_PRE_SCREENING_DETAILS_TRANSLATION, FSW_PRE_SCREENING_TRADE_REFERENCE_MY_PROVIDERS, FSW_PRE_SCREENING_TRADE_REFERENCE_PROVIDERS, FSW_PRE_SCREENING_TRADE_REFERENCE_STORE_TOKEN, FSW_PRE_SCREENING_TRADE_REFERENCE_TRANSLATION_LOADER, FSW_PRODUCT_SERVICE_TOKEN, FSW_PROJECT_LISTING_ENTITY_TOKEN, FSW_PROJECT_LISTING_GRID_TOKEN, FSW_PROJECT_LISTING_MY_PROVIDERS, FSW_PROJECT_LISTING_PROVIDERS, FSW_PROJECT_LISTING_SG_PROVIDERS, FSW_PROJECT_LISTING_STORE_TOKEN, FSW_PROJECT_LISTING_TRANSLATION_LOADER, FSW_PROPOSALS_FORM_TOKEN, FSW_PROPOSALS_MY_PROVIDERS, FSW_PROPOSALS_PROVIDERS, FSW_PROPOSALS_SG_PROVIDERS, FSW_PROPOSALS_STORE_TOKEN, FSW_PROPOSALS_TH_PROVIDERS, FSW_PROPOSALS_TRANSLATION_LOADER, FSW_SALES_SUMMARY_PROVIDERS, FSW_SALES_SUMMARY_STORE_TOKEN, FSW_SALES_SUMMARY_TH_PROVIDERS, FSW_SALES_SUMMARY_TRANSLATION_LOADER, FSW_SCORING_RESULT_TRANSLATION_LOADER, FSW_SCREENING_RESULT_MY_PROVIDERS, FSW_SCREENING_RESULT_PROVIDERS, FSW_SCREENING_RESULT_STORE_TOKEN, FSW_SCREENING_RESULT_TRANSLATION_LOADER, FSwBIPsDirective, FSwExposureDirective, FSwMainBorrowerDirective, FSwOutstandingLoanFacilityDirective, FSwProjectListingDirective, FSwProposalsDirective, FSwSalesSummaryDirective, FSwScoringResultDirective, FSwScreeningResultDirective, FacilityService, FacilityServiceModule, FileCellComponent, FinanceService, FinanceServiceModule, FinancialStatementService, FinancialStatementServiceModule, FormMixin, FormWidgetComponent, FormWidgetModule, FswSalesSummaryPorCalculationPipe, GenericTableDataSource, HTTP_CLIENT_BASE_SERVICE_TOKEN, HttpClientBaseService, HttpClientBaseServiceModule, INIT_STATUS, INTALLMENT_TYPES, INTEREST_TYPES, InputHandler, InputManager, InputService, KYCContainerComponent, KYCContainerModule, KYCService, KYCServiceModule, KYC_SERVICE_TOKEN, LOAN_LIST_GRID_CONFIG_TOKEN, LOAN_LIST_STORE_TOKEN, LOAN_PRODUCTS_GROUPBY_COUNTRY_OTHER, LOAN_PRODUCTS_GROUPBY_COUNTRY_PROD, LOAN_SERVICE_TOKEN, LoanListComponent, LoanListControlComponent, LoanListControlModule, LoanListDefaultComponentStore, LoanListDirective, LoanListFields, LoanListGridComponent, LoanListGridModule, LoanListStore, LoanService, LoanServiceModule, MASTER_DATA_SERVICE_TOKEN, MEMBER_DOC_SERVICE_TOKEN, MEMBER_ENTITY_TYPE_ID_OPTIONS, MEMBER_SERVICE_TOKEN, MODAL_ARRAY, MODAL_BACKDROP_CLICK, MODAL_CONTEXT, MODAL_HOST_ID, MODAL_HOST_SERVICE, MODAL_ITEM, MODAL_SERVICE, MainBorrowerContainerComponent, MainBorrowerContainerModule, MasterDataService, MasterDataServiceModule, MemberBIPSComponent, MemberBIPSEntryDialogComponent, MemberBIPSEntryDialogModule, MemberBIPSGridComponent, MemberBIPSGridModule, MemberBIPSModule, MemberBIPServiceModule, MemberCode, MemberDetailComponent, MemberDetailModule, MemberDocService, MemberDocServiceModule, MemberEntityCode, MemberService, MemberServiceModule, MemberTypeId, Methods, ModalAnimations, ModalComponent, ModalHostComponent, ModalHostItemDirective, ModalHostService, ModalItemDirective, ModalService, ModalSizes, ModalStyles, NON_TRADE_TRANSACTIONS_SERVICE_TOKEN, NonTradeTransactionsService, NonTradeTransactionsServiceModule, NumberControlComponent, NumberRunningDirective, NumberRunningModule, NumericFormatModule, NumericFormatPipe, OUTSTANDING_LOAN_SERVICE_TOKEN, OutstandingLoanFacilityComponent, OutstandingLoanFacilityFacilityTypes, OutstandingLoanFacilitySecurityTypes, OutstandingLoanFacilitySources, OutstandingLoansService, OutstandingLoansServiceModule, PDF_SERVICE_TOKEN, PERSONAL_GUARANTOR_MY_TRANSLATION, PERSONAL_GUARANTOR_SG_TRANSLATION, POLICY_CHECKLIST_SG_TRANSLATION, POLICY_CHECKLIST_TH_TRANSLATION, PRODUCT_GROUP_SERVICE_TOKEN, PRODUCT_LIST_GRID_CONFIG_TOKEN, PRODUCT_SERVICE_TOKEN, PRODUCT_VERSION_GRID_CONFIG_TOKEN, PanelWidgetComponent, PanelWidgetModule, ParseAccountCellComponent, PreScreeningBankStatementsComponent, PreScreeningBasicDetailsComponent, PreScreeningBipsComponent, PreScreeningBipsDirective, PreScreeningBorrowerAndBipsComponent, PreScreeningBorrowerAndBipsDirective, PreScreeningBorrowerDetailsComponent, PreScreeningBorrowerDetailsDirective, PreScreeningCcrisFindingsComponent, PreScreeningCcrisFindingsDirective, PreScreeningCompanyDetailsComponent, PreScreeningCompanyDetailsDirective, PreScreeningCtosComponent, PreScreeningTradeReferenceComponent, PreScreeningTradeReferenceDirective, PrettifyDataSource, PrettifyDataSourceModule, ProductGroupService, ProductGroupServiceModule, ProductListGridFields, ProductService, ProductServiceModule, ProductVersionGridFields, ProjectListingComponent, QUESTNET_PULL_ALL_TRANSLATION, QUESTNET_SERVICE_TOKEN, QuestnetService, RATIO_ANALYSIS_SERVICE_TOKEN, RECOURSE_TYPE_OPTIONS, REFERENCE_SERVICE_TOKEN, REPAYMENT_SCHEDULE_ALL_TRANSLATION, REPAYMENT_SCHEDULE_PLAN_SERVICE_TOKEN, RadioCellComponent, RadioControlComponent, RatioAnalysisService, RatioAnalysisServiceModule, ReferenceService, ReferenceServiceModule, RefreshService, RemoveCurrencySymbolModule, RemoveCurrencySymbolPipe, RepaymentSchedulePlanComponent, RepaymentSchedulePlanModule, RepaymentSchedulePlanService, RepaymentSchedulePlanServiceModule, SCORECARD_SERVICE_TOKEN, SCORECARD_TH_TRANSLATION, SETTINGS_SERVICE_TOKEN, SG_CBS_FRAUD_SCREENING_TRANSLATION, SG_CBS_PARSED_RESULT_TRANSLATION, SG_CBS_SUMMARY_TRANSLATION, STAGES_DATA, SUPPORT_ALL_TRANSLATION, SalesCalculationKeys, ScorecardService, ScorecardServiceModule, ScreeningResultCellComponent, SelectCellComponent, SelectControlComponent, SettingsService, SettingsServiceModule, SimpleContainerCellComponent, SiteVisitDirective, SiteVisitModule, StatusCellComponent, StringControlComponent, TENOR_TYPES, TENOR_TYPE_MAP, THBuyerInformationForm, THBuyerTransactionForm, TH_TRANSLATION, TRANSLATION_LOADER$1 as TRANSLATION_LOADER, TextAreaCellComponent, TranslocoFeatureHttpLoader, TranslocoRootHttpLoader, UPLOAD_ALLOWED_FILE_TYPES, UTILS_SERVICE_TOKEN, UtilityCellComponent, UtilsService, UtilsServiceModule, WIDGETS_CONFIG_TOKEN, WORLD_CHECK_ALL_TRANSLATION, YES_NO_OPTIONS, addDotDelimiter, adminPeriodTypes, agingReportTranslation, allowedProposalsFacilityStatuses, applicationDetailLoadProviders, bipsLoadProviders, buildFieldOptions, buyerInformationLoadProviders, buyerTransactionLoadProviders, calculateEffectiveInterestRate, calculateSimpleInterestRate, calculateTenorInMonth, calculateTotalAmount, calculateTotalPrincipalAmount, collaterals, commonFeePeriodList, companyGuarantorForm, controls, convertToReadableDate, convertToYearMonth, cpDefaultProviders, cpTHProviders, createGenericTableDataSource, creditAssessmentTranslation, creditMemoAnalysisTranslation, ctosPullLoadProviders, customerAcceptanceLoadProviders, discountingFeePeriodList, downloadFileToLocal, dynamicForm, exposureEntityLoadProviders, exposureLoadProviders, exposureProductsTranslation, facilityTranslation, fadeIn, formatBankRecord, frankensteinLinkTranslation, fswBIPsInitialState, fswCTOSGrades, fswMainBorrowerInitialState, fswPartnerSearchInitialState, fswProposalsInitialState, fswSalesSummaryInitialState, fswWorldCheckCaseRating, fswWorldCheckDetailLevels, fswWorldCheckEntityTypes, fswWorldCheckGenders, fswWorldCheckLifecycleStates, fswWorldCheckMandatoryActions, fswWorldCheckPassportDocumentType, fswWorldCheckProviderTypes, fswWorldCheckQueryBy, fswWorldCheckReportFilters, fswWorldCheckScreeningModes, fswWorldCheckWatchlistCaseScreeningStates, fswWorldCheckWatchlistResolvedByCategory, fswWorldCheckWatchlistResolvedByResolutionStatus, fswWorldCheckWatchlistResolvedByRiskLevel, fswWorldCheckWatchlistReviewRequired, fswWorldCheckWatchlistUnresolved, getCountryCodeFromStorage, getCurrentCountryConfig, getCustomProviders, getEntityInfoAuto, getEntityNoFallBackToUEN, getFSWBIPsFormCustomRenderAreaListenToMemberEntityChangeTH, getFSWBIPsFormCustomRenderListenToMaritalStatusChangeID, getFSWBIPsFormCustomRenderListenToMemberEntityChangeID, getFSWBIPsFormCustomRenderListenToMemberEntityChangeTH, getFSWMainBorrowerFormCustomRenderListenToMemberEntityChangeTH, getFSWPartnerSearchFormCustomRenderListenToMemberEntityChangeTH, getLoanData, getNextMonths, getNoRowsTemplate, getOptionLabel, getProductCodeFromIdNumber, getProposalsMember, getProposalsMemberName, getRecommendationContainers, getScoringResult, getTermsContainers, getTextFromSelectList, getTimezoneHourOffset, injectAgingReportALLEffects, injectAgingReportEffects, injectAgingReportForm, injectAgingReportFormALL, injectApplicationBorrowerSummaryService, injectApplicationFacilityTermsService, injectApplicationGuarantorService, injectApplicationImportALLEffects, injectApplicationImportEffects, injectApplicationMemberBIPService, injectApplicationMemberService, injectApplicationPolicyChecklistService, injectApplicationPreScreeningService, injectApplicationProposalService, injectApplicationRelationshipService, injectApplicationRepaymentScheduleService, injectApplicationService, injectApplicationSupplierService, injectBlobService, injectBorrowerSummaryEffects, injectBorrowerSummaryMYEffects, injectBorrowerSummaryMYForm, injectBorrowerSummarySGEffects, injectBorrowerSummarySGForm, injectCbsFraudScreeningEffects, injectCbsFraudScreeningSGEffects, injectCbsParsedResultEffects, injectCbsParsedResultSGEffects, injectCbsPdfViewerEffects, injectCbsPdfViewerSGEffects, injectCbsSummaryEffects, injectCbsSummarySGEffects, injectCommentsALLEffects, injectCommentsEffects, injectCommentsFormALL, injectCorporateGuarantorEffects, injectCorporateGuarantorMYEffects, injectCorporateGuarantorMYForm, injectCorporateGuarantorSGEffects, injectCorporateGuarantorSGForm, injectCreditAgingReportService, injectCreditAssessmentALLEffects, injectCreditAssessmentEffects, injectCreditBorrowerSummaryService, injectCreditCommentService, injectCreditExposureService, injectCreditFacilityTermsService, injectCreditGuarantorService, injectCreditModelService, injectCreditPolicyChecklistService, injectCreditPreScreeningService, injectCreditRepaymentScheduleService, injectCreditSupplierService, injectCreditTestBucketService, injectCtosService, injectDigitalScorecardBTLEffects, injectDigitalScorecardBTLForm, injectDigitalScorecardBTLMYEffects, injectDigitalScorecardBTLMYForm, injectDigitalScorecardNCMEffects, injectDigitalScorecardNCMForm, injectDigitalScorecardNCMMYEffects, injectDigitalScorecardNCMMYForm, injectEBATHEffects, injectEBATHForm, injectEBATHService, injectEBATHTHEffects, injectEBATHTHForm, injectExposureProductsAllEffects, injectExposureProductsEffects, injectFSWAppLoanDraftService, injectFSWBBSLoanDraftService, injectFSWDocViewerService, injectFSWMemberServiceV3, injectFSWWorldCheckActivityService, injectFSWWorldCheckAdapterCaseService, injectFSWWorldCheckAdapterMasterService, injectFSWWorldCheckLinkService, injectFSWWorldCheckSnapshotService, injectFSWWorldCheckSupplementService, injectFacilityALLEffects, injectFacilityALLForm, injectFacilityEffects, injectFrankensteinBipsAllEffects, injectFrankensteinBipsEffects, injectLoanService, injectMasterDataService, injectMemberService, injectOtherSupportForm, injectPersonalGuarantorEffects, injectPersonalGuarantorMYEffects, injectPersonalGuarantorMYForm, injectPersonalGuarantorSGEffects, injectPersonalGuarantorSGForm, injectPolicyChecklistEffects, injectPolicyChecklistSGEffects, injectPolicyChecklistTHEffects, injectQuestnetPullAllEffects, injectQuestnetPullEffects, injectQuestnetService, injectRepaymentScheduleALLEffects, injectRepaymentScheduleALLForm, injectRepaymentScheduleEffects, injectScorecardEffects, injectScorecardTHEffects, injectSupplierEffects, injectSupplierForm, injectSupplierTHEffects, injectSupplierTHForm, injectSupportEffects, injectSupportForm, injectUtilsService, injectViewerComponent, injectViewerService, injectWorldCheckTranslation, injectWorldCheckTranslationByCountryCode, installmentTypes, interestTerms, interestTypes, isNumericSearch, isObjectValid, isSGIC, isSGUEN, isStringValid, isValidJSON, kycLoadProviders, lastTenYearsOptions, lastTenYearsSelectOptions, lateInterestFeePeriodList, latePeriods, loanListDefaultGridConfig, loanListDefaultProviders, loanListTranslateLoader, mainBorrowerLoadProviders, memberDetailLoadProviders, modelTransformer, outstandingLoanFacilityEntityLoadProviders, outstandingLoanFacilityFacilityTypes, outstandingLoanFacilityLoadProviders, outstandingLoanFacilitySecurityTypes, outstandingLoanFacilitySources, parseCtosEntity, partnerSearchLoadProviders, paymentBehaviors, paymentGrades, periodTypes, personalGuarantorForm, preScreeningBipsEntityLoadProviders, preScreeningBipsLoadProviders, preScreeningBorrowerAndBipsLoadProviders, preScreeningBorrowerDetailsLoadProviders, preScreeningCcrisFindingsEntityLoadProviders, preScreeningCcrisFindingsLoadProviders, preScreeningCompanyDetailsLoadProviders, preScreeningCriteriaLoadProviders, preScreeningDetailsTranslation, preScreeningTradeReferenceLoadProviders, productGroupProviders, productListGridConfig, productVersionGridConfig, projectListingEntityLoadProviders, projectListingLoadProviders, proposalsLoadProviders, provideApplicationBorrowerSummaryService, provideApplicationFacilityTermsService, provideApplicationGuarantorService, provideApplicationImportTranslation, provideApplicationMemberBIPService, provideApplicationMemberService, provideApplicationPolicyChecklistService, provideApplicationPreScreeningService, provideApplicationProposalService, provideApplicationRelationshipService, provideApplicationRepaymentScheduleService, provideApplicationService, provideApplicationSupplierService, provideBlobService, provideBorrowerSummaryTranslation, provideCbsFraudScreeningTranslation, provideCbsParsedResultTranslation, provideCbsSummaryTranslation, provideCorporateGuarantorTranslation, provideCreditAgingReportService, provideCreditBorrowerSummaryService, provideCreditCommentService, provideCreditExposureService, provideCreditFacilityTermsService, provideCreditGuarantorService, provideCreditModelService, provideCreditPolicyChecklistService, provideCreditPreScreeningService, provideCreditRepaymentScheduleService, provideCreditSupplierService, provideCreditTestBucketService, provideCtosService, provideDigitalScorecardBTLTranslation, provideDigitalScorecardNCMTranslation, provideEBATHService, provideEBATHTranslation, provideExternalPullTranslation, provideFSWAppLoanDraftService, provideFSWBBSLoanDraftService, provideFSWMemberServiceV3, provideFSWWorldCheckActivityService, provideFSWWorldCheckAdapterCaseService, provideFSWWorldCheckAdapterMasterService, provideFSWWorldCheckLinkService, provideFSWWorldCheckSnapshotService, provideFSWWorldCheckSupplementService, provideLoanService, provideMasterDataService, provideMemberService, providePersonalGuarantorTranslation, providePolicyChecklistTranslation, provideQuestnetService, provideReportTranslation, provideScorecardTranslation, provideSupplierTranslation, provideSupportTranslation, provideUtilsService, provideWorldCheckTranslation, providers, removeBadFalsyValueForArray, removeBadFalsyValueForObject, repaymentScheduleTranslation, resolveError, salesSummaryLoadProviders, scoringResultLoadProviders, screeningResultLoadProviders, selectListToBeRecord, selectListToBeString, setRequestOptions, setRequestOptionsMock, showBlankHTML, sliceDate, slideIn, sortBankAccounts, sourceOfFunds, tenorTypes, termTypes, toPreScreeningCriteriaIdentifier, toRxSignal, toSignalValue, toTimezoneHourOffset, tradeRefereeCategories, transformCompanyGuarantor, transformPersonalGuarantor, validApplicationId };
